// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../vendors/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./font-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./dripicons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./cryptofont.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./themify-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./animate.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./flag-icon.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./twemoji.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./material-design-iconic-font.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./remixicon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./material-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./line-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./bootstrap-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./flaticon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./prism.css";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../vendors/simplebar/dist/simplebar.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_16___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../vendors/owl.carousel/dist/assets/owl.carousel.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_17___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../vendors/owl.carousel/dist/assets/owl.theme.default.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/cropper.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 20 20%27 fill=%27none%27 stroke=%27rgba%2847, 52, 58, 0.3%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/loading.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=DM+Sans:400,500,700&display=swap||Material+Icons);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_16___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_17___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*------------------------------------------------------------------
[Master Stylesheet]
Project:	Jampack
++++ Imports ++++
++++ Reset ++++
++++ Basic ++++

	++CSS Basic++
	++Media Object++
	++Gap++
	++Position++
	++Padding++
	++Margin++
	++Background Colors++
	++Text Colors++
	++Border++
	++Colors++
	++Shadow++
	++Font Size++	
	++Font Weight++
	++Text Case++
	++Letter Spacing++
	++Line Height++
	++Width++
	++Width In Percentage++
	++Max Width++
	++Min Width++
	++Height++
	++Height In Percentage++
	++Max Height++
	++Min Height++
	++Hr++
	++opacity++
	++Div Sizes++
	++Z-Index++
	++Loader++
	++Scrollbar++
	++Separator++
	++Typography++
	++Buttons++
	++Wrapper++
	++Gutter++
	++Hk Section++
	++Card++
	++Placehoder++
	++Placehoder++
	++Breadcrumb++
	++Page Header++
	++Page Body++
	++Form++
	++Checkbox++
	++Form Switch++
	++Form Range++
	++Form validation++
    ++Inut group++
    ++Inut search++
    ++Spinner++
    ++Input Spinner++
	++Select2++
	++Tinymce++
	++File Upload++
	++Form-Wizard++
	++Popover++
	++Collapse++
	++Accordion++
	++Table++
	++Data Table++
	++Advance Table++
	++Apex Chart++
	++charts++
	++Nestable++
	++Treeview++	
	++Modals++
	++Close++
	++Sweet-alert++
	++Notification++
	++Toast++
	++Bootstrap Notify++
	++Tooltop++
	++Images++  
	++Icons++
    ++Carousel++
	++Twitter slider++
	++Color Pickr++
	++Range Slider++
	++Daterangepicker++
	++Profile++
	++Activity++
	++Wizards++
	++Pricing Table++
	++Dropdown++
	++Avatar++
	++Pagination++
	++Badge++
	++List Group++
	++Google Map++
	++Vecotor Map++
	++Progressbar++
	++Togglable++
	++Advance List++
	++Light Gallery++
	++Cropperjs++
	++Bootstrap TimeOut++
	++Hopscotch++
	++Rating++
	++Tinyemce++
	++Chips++
	++Playlist widget++
	++Ribbons++
	++Advance Badges++
	++Callout++
	++Toolbar++
	++Filter Component++
	++Content sidebar++
	++Fixed Footer++
	++Dragula++
	++Fixed Footer++
	++Authantication Pages++
	++Fixed Footer++

++++ Componets Import ++++	
-------------------------------------------------------------------*/
/****************************/
/** Imports **/
/****************************/
/*__________________________________________________________________;
[Mixin]
Project:	Jampack
___________________________________________________________________*/
/*Shadow*/
/*Table Variants*/
/*__________________________________________________________________;
[Variables]
Project:	Jampack
___________________________________________________________________*/
:root {
  --bs-body-font-family: 'DM Sans', sans-serif;
  --bs-text-opacity:1;
  --bs-bg-opacity: 1;
}
input::-ms-reveal,
input::-ms-clear {
display: none;
}

/****************************/
/** Reset **/
/****************************/
html, body, div, span, applet, object, iframe, p, pre, a, abbr, acronym, address, big, cite, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, fieldset, form, label, legend, caption, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
}

em, cite {
  font-style: italic;
}

strong {
  font-weight: bold;
}

body {
  color: #6f6f6f;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  height: 100%;
  
}
/****************************/
/** hide scrolbar **/
::-webkit-scrollbar {display:none;}
/****************************/

.main-font, .jq-toast-wrap .jq-toast-single, .jq-toast-wrap .jq-toast-single .jq-toast-heading, .infowindow-wrap .infowindow-header, .infowindow-wrap .infowindow-body {
  font-family: var(--bs-body-font-family);
}

a:hover, a:active {
  outline: 0;
}

ul {
  list-style: none;
}
ul.list-ul {
  list-style: disc;
}
ul.list-ul ul {
  list-style-type: circle;
}
ul.list-icon {
  list-style: none;
  padding-left: 0;
}
ul.list-icon > li {
  padding-left: 1.875rem;
  counter-increment: li;
}
ul.list-icon > li i,
ul.list-icon > li .feather-icon,
ul.list-icon > li .svg-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  text-align: center;
  margin-left: -1.25rem;
  position: relative;
  left: -10px;
  padding: 1px;
  top: -1px;
}
ul.list-icon > li i {
  font-size: 21px;
  top: 5px;
}
ul.hk-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -.68rem;
  padding-left: 0;
}
ul.hk-list li {
  padding: .68rem;
}
ul.hk-list.hk-list-sm {
  margin: 0 -.4rem;
}
ul.hk-list.hk-list-sm li {
  padding: .4rem;
}

a {
  text-decoration: none;
  color: #0a2f4c;
  transition: color 0.2s ease;
}
a:hover {
  text-decoration: none;
  color: #3d9ca5;
}
a:focus {
  text-decoration: none;
  outline: none;
  color: #3d9ca5;
}
a.link-info {
  color: #18DDEF !important;
}
a.link-info:hover, a.link-info:focus {
  color: #4fe5f3 !important;
}
a.link-success {
  color: #00D67F !important;
}
a.link-success:hover, a.link-success:focus {
  color: #3de09e !important;
}
a.link-warning {
  color: #FFC400 !important;
}
a.link-warning:hover, a.link-warning:focus {
  color: #ffd23d !important;
}
a.link-danger {
  color: #FF0000 !important;
}
a.link-danger:hover, a.link-danger:focus {
  color: #ff3d3d !important;
}
a.link-primary {
  color: #0a2f4c !important;
}
a.link-primary:hover, a.link-primary:focus {
  color: #3d9ca5 !important;
}
a.link-muted {
  color: #6f6f6f !important;
}
a.link-muted:hover, a.link-muted:focus {
  color: #b5b5b5 !important;
}
a.link-secondary {
  color: #6f6f6f !important;
}
a.link-secondary:hover, a.link-secondary:focus {
  color: #929292 !important;
}
a.link-dark {
  color: #262a2e !important;
}
a.link-dark:hover, a.link-dark:focus {
  color: #2a2f34 !important;
}
a.link-light {
  color: #9e9e9e !important;
}
a.link-light:hover, a.link-light:focus {
  color: #b5b5b5 !important;
}
a.link-white {
  color: #fff !important;
}
a.link-white:hover, a.link-white:focus {
  color: rgba(255, 255, 255, 0.8);
}
a.link-disabled {
  color: #b5b5b5 !important;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
a.link-disabled:hover, a.link-disabled:focus {
  color: #b5b5b5 !important;
}
a.link-high-em {
  font-weight: 500;
}
a.link-medium-em {
  font-size: .875rem;
}
a.link-low-em {
  font-size: .75rem;
}

h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  color: #262a2e;
}

.heading-wth-icon {
  display: flex;
  align-items: center;
}
.heading-wth-icon .head-icon {
  display: flex;
}
.heading-wth-icon .head-icon i {
  line-height: 0;
}

.h1.heading-wth-icon .head-icon, h1.heading-wth-icon .head-icon {
  margin-right: 1.125rem;
}

@media (max-width: 1199px) {
  .h1.heading-wth-icon .head-icon, h1.heading-wth-icon .head-icon {
    margin-right: 1.125rem;
  }
}
.h2.heading-wth-icon .head-icon, h2.heading-wth-icon .head-icon {
  margin-right: 1rem;
}

@media (max-width: 1199px) {
  .h2.heading-wth-icon .head-icon, h2.heading-wth-icon .head-icon {
    margin-right: 1.125rem;
  }
}
.h3.heading-wth-icon .head-icon, h3.heading-wth-icon .head-icon {
  margin-right: .875rem;
}

@media (max-width: 1199px) {
  .h3.heading-wth-icon .head-icon, h3.heading-wth-icon .head-icon {
    margin-right: 1.125rem;
  }
}
.h4.heading-wth-icon .head-icon, h4.heading-wth-icon .head-icon {
  margin-right: .75rem;
}

.h5.heading-wth-icon .head-icon, h5.heading-wth-icon .head-icon {
  margin-right: .625rem;
}

.h6.heading-wth-icon .head-icon, h6.heading-wth-icon .head-icon {
  margin-right: .5rem;
}

.force-UTF-8 {
  content: "¡";
}

dt {
  font-weight: 600;
}

::-webkit-file-upload-button {
  cursor: pointer;
}

/****************************/
/** Basic **/
/****************************/
/*CSS Basic*/
.overflow-y-scroll {
  overflow-y: scroll;
}

.overflow-x-scroll {
  overflow-x: scroll;
}

.white-space-wrap {
  white-space: initial;
}

.white-space-nowrap {
  white-space: nowrap;
}

.word-break,
a.link-url {
  word-break: break-all;
}

.multine-ellipsis {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.seprator-block {
  margin-bottom: 5rem;
}

.no-transition {
  transition: 0s;
}

.transform-none {
  transform: none !important;
}

.name {
  color: #262a2e !important;
  font-weight: 500;
}

.twa-2x {
  background-size: 1.3em 1.3em;
  height: 1.3em;
  width: 1.3em;
}

.flex-basis-0 {
  flex-basis: 0 !important;
}

.flex-1 {
  flex: 1 1 !important;
}

td.text-truncate, th.text-truncate {
  max-width: 1px;
}

[contenteditable="true"] {
  outline: none;
}

.icon-flip-y {
  transform: rotateY(180deg);
}

.icon-flip-x {
  transform: rotateX(180deg);
}

/*Media Object*/
.media {
  display: flex;
  align-items: flex-start;
}

.media-head {
  display: flex;
}

.media-body {
  flex: 1 1;
}

/*Gap*/
.gap-5 {
  gap: 2rem !important;
}

.gap-6 {
  gap: 2.5rem !important;
}

.gap-7 {
  gap: 3rem !important;
}

/*Position*/
.position-top-start,
.position-top-end,
.position-bottom-start,
.position-bottom-end,
.position-start-center,
.position-end-center,
.position-top-center,
.position-bottom-center,
.position-top-start-overflow,
.position-top-end-overflow,
.position-bottom-start-overflow,
.position-bottom-end-overflow,
.position-start-center-overflow,
.position-end-center-overflow,
.position-top-center-overflow,
.position-bottom-center-overflow {
  position: absolute !important;
  z-index: 2;
}

.position-top-start {
  top: 0 !important;
  left: 0 !important;
}

.position-top-end {
  top: 0 !important;
  right: 0 !important;
}

.position-bottom-start {
  bottom: 0 !important;
  left: 0 !important;
  top: auto !important;
}

.position-bottom-end {
  bottom: 0 !important;
  right: 0 !important;
  top: auto !important;
}

.position-top-center {
  top: 0 !important;
  right: 50% !important;
  transform: translateX(50%) !important;
}

.position-bottom-center {
  bottom: 0 !important;
  right: 50% !important;
  transform: translateX(50%) !important;
}

.position-start-center {
  left: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.position-end-center {
  right: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.position-center {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.position-top-start-overflow {
  top: 0 !important;
  left: 0 !important;
  transform: translate(-50%, -50%) !important;
}

.position-top-end-overflow {
  top: 0 !important;
  right: 0 !important;
  transform: translate(50%, -50%) !important;
}

.position-bottom-start-overflow {
  bottom: 0 !important;
  left: 0 !important;
  top: auto !important;
  transform: translate(-50%, 50%) !important;
}

.position-bottom-end-overflow {
  bottom: 0 !important;
  right: 0 !important;
  top: auto !important;
  transform: translate(50%, 50%) !important;
}

.position-top-center-overflow {
  top: 0 !important;
  right: 50% !important;
  transform: translate(50%, -50%) !important;
}

.position-bottom-center-overflow {
  bottom: 0 !important;
  right: 50% !important;
  transform: translate(50%, 50%) !important;
}

.position-start-center-overflow {
  left: 0 !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.position-end-center-overflow {
  right: 0 !important;
  top: 50% !important;
  transform: translate(50%, -50%) !important;
}

.position-top-start-overflow-1,
.position-top-end-overflow-1,
.position-bottom-start-overflow-1,
.position-bottom-end-overflow-1 {
  position: absolute !important;
  z-index: 2;
}

.position-top-start-overflow-1 {
  top: 12% !important;
  left: 16% !important;
  transform: translate(-50%, -50%) !important;
}

.position-top-end-overflow-1 {
  top: 12% !important;
  right: 16% !important;
  transform: translate(50%, -50%) !important;
}

.position-bottom-start-overflow-1 {
  bottom: 12% !important;
  left: 16% !important;
  top: auto !important;
  transform: translate(-50%, 50%) !important;
}

.position-bottom-end-overflow-1 {
  bottom: 12% !important;
  right: 16% !important;
  top: auto !important;
  transform: translate(50%, 50%) !important;
}

/*Padding*/
.p-0 {
  padding: 0rem !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 2rem !important;
}

.p-6 {
  padding: 2.5rem !important;
}

.p-7 {
  padding: 3rem !important;
}

.p-8 {
  padding: 3.5rem !important;
}

.p-9 {
  padding: 4rem !important;
}

.p-10 {
  padding: 4.5rem !important;
}

.p-11 {
  padding: 5rem !important;
}

.p-12 {
  padding: 5.5rem !important;
}

.p-13 {
  padding: 6rem !important;
}

.p-14 {
  padding: 6.5rem !important;
}

.p-15 {
  padding: 7rem !important;
}

.p-16 {
  padding: 7.5rem !important;
}

.p-17 {
  padding: 8rem !important;
}

.p-18 {
  padding: 8.5rem !important;
}

.p-19 {
  padding: 9rem !important;
}

.p-20 {
  padding: 9.5rem !important;
}

.p-21 {
  padding: 10rem !important;
}

.p-22 {
  padding: 10.5rem !important;
}

.p-23 {
  padding: 11rem !important;
}

.p-24 {
  padding: 11.5rem !important;
}

.p-25 {
  padding: 12rem !important;
}

.p-26 {
  padding: 12.5rem !important;
}

.p-27 {
  padding: 13rem !important;
}

.p-28 {
  padding: 13.5rem !important;
}

.p-29 {
  padding: 14rem !important;
}

.p-30 {
  padding: 14.5rem !important;
}

.p-31 {
  padding: 15rem !important;
}

.p-32 {
  padding: 15.5rem !important;
}

.p-33 {
  padding: 16rem !important;
}

.p-34 {
  padding: 16.5rem !important;
}

.p-35 {
  padding: 17rem !important;
}

.p-36 {
  padding: 17.5rem !important;
}

.p-37 {
  padding: 18rem !important;
}

.p-38 {
  padding: 18.5rem !important;
}

.p-39 {
  padding: 19rem !important;
}

.p-40 {
  padding: 19.5rem !important;
}

.p-41 {
  padding: 20rem !important;
}

.p-42 {
  padding: 20.5rem !important;
}

.p-43 {
  padding: 21rem !important;
}

.p-44 {
  padding: 21.5rem !important;
}

.p-45 {
  padding: 22rem !important;
}

.p-46 {
  padding: 22.5rem !important;
}

.p-47 {
  padding: 23rem !important;
}

.p-48 {
  padding: 23.5rem !important;
}

.p-49 {
  padding: 24rem !important;
}

.p-50 {
  padding: 24.5rem !important;
}

.p-51 {
  padding: 25rem !important;
}

.p-52 {
  padding: 25.5rem !important;
}

.p-53 {
  padding: 26rem !important;
}

.p-54 {
  padding: 26.5rem !important;
}

.p-55 {
  padding: 27rem !important;
}

.p-56 {
  padding: 27.5rem !important;
}

.p-57 {
  padding: 28rem !important;
}

.p-58 {
  padding: 28.5rem !important;
}

.p-59 {
  padding: 29rem !important;
}

.p-60 {
  padding: 29.5rem !important;
}

.p-61 {
  padding: 30rem !important;
}

.p-62 {
  padding: 30.5rem !important;
}

.p-63 {
  padding: 31rem !important;
}

.p-64 {
  padding: 31.5rem !important;
}

.p-65 {
  padding: 32rem !important;
}

.p-66 {
  padding: 32.5rem !important;
}

.p-67 {
  padding: 33rem !important;
}

.p-68 {
  padding: 33.5rem !important;
}

.p-69 {
  padding: 34rem !important;
}

.p-70 {
  padding: 34.5rem !important;
}

.p-71 {
  padding: 35rem !important;
}

.p-72 {
  padding: 35.5rem !important;
}

.p-73 {
  padding: 36rem !important;
}

.p-74 {
  padding: 36.5rem !important;
}

.p-75 {
  padding: 37rem !important;
}

.p-76 {
  padding: 37.5rem !important;
}

.p-77 {
  padding: 38rem !important;
}

.p-78 {
  padding: 38.5rem !important;
}

.p-79 {
  padding: 39rem !important;
}

.p-80 {
  padding: 39.5rem !important;
}

.p-81 {
  padding: 40rem !important;
}

.p-82 {
  padding: 40.5rem !important;
}

.p-83 {
  padding: 41rem !important;
}

.p-84 {
  padding: 41.5rem !important;
}

.p-85 {
  padding: 42rem !important;
}

.p-86 {
  padding: 42.5rem !important;
}

.p-87 {
  padding: 43rem !important;
}

.p-88 {
  padding: 43.5rem !important;
}

.p-89 {
  padding: 44rem !important;
}

.p-90 {
  padding: 44.5rem !important;
}

.p-91 {
  padding: 45rem !important;
}

.p-92 {
  padding: 45.5rem !important;
}

.p-93 {
  padding: 46rem !important;
}

.p-94 {
  padding: 46.5rem !important;
}

.p-95 {
  padding: 47rem !important;
}

.p-96 {
  padding: 47.5rem !important;
}

.p-97 {
  padding: 48rem !important;
}

.p-98 {
  padding: 48.5rem !important;
}

.p-99 {
  padding: 49rem !important;
}

.p-100 {
  padding: 49.5rem !important;
}

.p-101 {
  padding: 50rem !important;
}

.p-102 {
  padding: 50.5rem !important;
}

.p-103 {
  padding: 51rem !important;
}

.p-104 {
  padding: 51.5rem !important;
}

.p-105 {
  padding: 52rem !important;
}

.p-106 {
  padding: 52.5rem !important;
}

.p-107 {
  padding: 53rem !important;
}

.p-108 {
  padding: 53.5rem !important;
}

.p-109 {
  padding: 54rem !important;
}

.p-110 {
  padding: 54.5rem !important;
}

.p-111 {
  padding: 55rem !important;
}

.p-112 {
  padding: 55.5rem !important;
}

.p-113 {
  padding: 56rem !important;
}

.p-114 {
  padding: 56.5rem !important;
}

.p-115 {
  padding: 57rem !important;
}

.p-116 {
  padding: 57.5rem !important;
}

.p-117 {
  padding: 58rem !important;
}

.p-118 {
  padding: 58.5rem !important;
}

.p-119 {
  padding: 59rem !important;
}

.p-120 {
  padding: 59.5rem !important;
}

.p-121 {
  padding: 60rem !important;
}

.p-122 {
  padding: 60.5rem !important;
}

.p-123 {
  padding: 61rem !important;
}

.p-124 {
  padding: 61.5rem !important;
}

.p-125 {
  padding: 62rem !important;
}

.p-126 {
  padding: 62.5rem !important;
}

.p-127 {
  padding: 63rem !important;
}

.p-128 {
  padding: 63.5rem !important;
}

.p-129 {
  padding: 64rem !important;
}

.p-130 {
  padding: 64.5rem !important;
}

.p-131 {
  padding: 65rem !important;
}

.p-132 {
  padding: 65.5rem !important;
}

.p-133 {
  padding: 66rem !important;
}

.p-134 {
  padding: 66.5rem !important;
}

.p-135 {
  padding: 67rem !important;
}

.p-136 {
  padding: 67.5rem !important;
}

.p-137 {
  padding: 68rem !important;
}

.p-138 {
  padding: 68.5rem !important;
}

.p-139 {
  padding: 69rem !important;
}

.p-140 {
  padding: 69.5rem !important;
}

.p-141 {
  padding: 70rem !important;
}

.p-142 {
  padding: 70.5rem !important;
}

.p-143 {
  padding: 71rem !important;
}

.p-144 {
  padding: 71.5rem !important;
}

.p-145 {
  padding: 72rem !important;
}

.p-146 {
  padding: 72.5rem !important;
}

.p-147 {
  padding: 73rem !important;
}

.p-148 {
  padding: 73.5rem !important;
}

.p-149 {
  padding: 74rem !important;
}

.p-150 {
  padding: 74.5rem !important;
}

.p-151 {
  padding: 75rem !important;
}

.p-152 {
  padding: 75.5rem !important;
}

.p-153 {
  padding: 76rem !important;
}

.p-154 {
  padding: 76.5rem !important;
}

.p-155 {
  padding: 77rem !important;
}

.p-156 {
  padding: 77.5rem !important;
}

.p-157 {
  padding: 78rem !important;
}

.p-158 {
  padding: 78.5rem !important;
}

.p-159 {
  padding: 79rem !important;
}

.p-160 {
  padding: 79.5rem !important;
}

.pt-0 {
  padding-top: 0rem !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 2rem !important;
}

.pt-6 {
  padding-top: 2.5rem !important;
}

.pt-7 {
  padding-top: 3rem !important;
}

.pt-8 {
  padding-top: 3.5rem !important;
}

.pt-9 {
  padding-top: 4rem !important;
}

.pt-10 {
  padding-top: 4.5rem !important;
}

.pt-11 {
  padding-top: 5rem !important;
}

.pt-12 {
  padding-top: 5.5rem !important;
}

.pt-13 {
  padding-top: 6rem !important;
}

.pt-14 {
  padding-top: 6.5rem !important;
}

.pt-15 {
  padding-top: 7rem !important;
}

.pt-16 {
  padding-top: 7.5rem !important;
}

.pt-17 {
  padding-top: 8rem !important;
}

.pt-18 {
  padding-top: 8.5rem !important;
}

.pt-19 {
  padding-top: 9rem !important;
}

.pt-20 {
  padding-top: 9.5rem !important;
}

.pt-21 {
  padding-top: 10rem !important;
}

.pt-22 {
  padding-top: 10.5rem !important;
}

.pt-23 {
  padding-top: 11rem !important;
}

.pt-24 {
  padding-top: 11.5rem !important;
}

.pt-25 {
  padding-top: 12rem !important;
}

.pt-26 {
  padding-top: 12.5rem !important;
}

.pt-27 {
  padding-top: 13rem !important;
}

.pt-28 {
  padding-top: 13.5rem !important;
}

.pt-29 {
  padding-top: 14rem !important;
}

.pt-30 {
  padding-top: 14.5rem !important;
}

.pt-31 {
  padding-top: 15rem !important;
}

.pt-32 {
  padding-top: 15.5rem !important;
}

.pt-33 {
  padding-top: 16rem !important;
}

.pt-34 {
  padding-top: 16.5rem !important;
}

.pt-35 {
  padding-top: 17rem !important;
}

.pt-36 {
  padding-top: 17.5rem !important;
}

.pt-37 {
  padding-top: 18rem !important;
}

.pt-38 {
  padding-top: 18.5rem !important;
}

.pt-39 {
  padding-top: 19rem !important;
}

.pt-40 {
  padding-top: 19.5rem !important;
}

.pt-41 {
  padding-top: 20rem !important;
}

.pt-42 {
  padding-top: 20.5rem !important;
}

.pt-43 {
  padding-top: 21rem !important;
}

.pt-44 {
  padding-top: 21.5rem !important;
}

.pt-45 {
  padding-top: 22rem !important;
}

.pt-46 {
  padding-top: 22.5rem !important;
}

.pt-47 {
  padding-top: 23rem !important;
}

.pt-48 {
  padding-top: 23.5rem !important;
}

.pt-49 {
  padding-top: 24rem !important;
}

.pt-50 {
  padding-top: 24.5rem !important;
}

.pt-51 {
  padding-top: 25rem !important;
}

.pt-52 {
  padding-top: 25.5rem !important;
}

.pt-53 {
  padding-top: 26rem !important;
}

.pt-54 {
  padding-top: 26.5rem !important;
}

.pt-55 {
  padding-top: 27rem !important;
}

.pt-56 {
  padding-top: 27.5rem !important;
}

.pt-57 {
  padding-top: 28rem !important;
}

.pt-58 {
  padding-top: 28.5rem !important;
}

.pt-59 {
  padding-top: 29rem !important;
}

.pt-60 {
  padding-top: 29.5rem !important;
}

.pt-61 {
  padding-top: 30rem !important;
}

.pt-62 {
  padding-top: 30.5rem !important;
}

.pt-63 {
  padding-top: 31rem !important;
}

.pt-64 {
  padding-top: 31.5rem !important;
}

.pt-65 {
  padding-top: 32rem !important;
}

.pt-66 {
  padding-top: 32.5rem !important;
}

.pt-67 {
  padding-top: 33rem !important;
}

.pt-68 {
  padding-top: 33.5rem !important;
}

.pt-69 {
  padding-top: 34rem !important;
}

.pt-70 {
  padding-top: 34.5rem !important;
}

.pt-71 {
  padding-top: 35rem !important;
}

.pt-72 {
  padding-top: 35.5rem !important;
}

.pt-73 {
  padding-top: 36rem !important;
}

.pt-74 {
  padding-top: 36.5rem !important;
}

.pt-75 {
  padding-top: 37rem !important;
}

.pt-76 {
  padding-top: 37.5rem !important;
}

.pt-77 {
  padding-top: 38rem !important;
}

.pt-78 {
  padding-top: 38.5rem !important;
}

.pt-79 {
  padding-top: 39rem !important;
}

.pt-80 {
  padding-top: 39.5rem !important;
}

.pt-81 {
  padding-top: 40rem !important;
}

.pt-82 {
  padding-top: 40.5rem !important;
}

.pt-83 {
  padding-top: 41rem !important;
}

.pt-84 {
  padding-top: 41.5rem !important;
}

.pt-85 {
  padding-top: 42rem !important;
}

.pt-86 {
  padding-top: 42.5rem !important;
}

.pt-87 {
  padding-top: 43rem !important;
}

.pt-88 {
  padding-top: 43.5rem !important;
}

.pt-89 {
  padding-top: 44rem !important;
}

.pt-90 {
  padding-top: 44.5rem !important;
}

.pt-91 {
  padding-top: 45rem !important;
}

.pt-92 {
  padding-top: 45.5rem !important;
}

.pt-93 {
  padding-top: 46rem !important;
}

.pt-94 {
  padding-top: 46.5rem !important;
}

.pt-95 {
  padding-top: 47rem !important;
}

.pt-96 {
  padding-top: 47.5rem !important;
}

.pt-97 {
  padding-top: 48rem !important;
}

.pt-98 {
  padding-top: 48.5rem !important;
}

.pt-99 {
  padding-top: 49rem !important;
}

.pt-100 {
  padding-top: 49.5rem !important;
}

.pt-101 {
  padding-top: 50rem !important;
}

.pt-102 {
  padding-top: 50.5rem !important;
}

.pt-103 {
  padding-top: 51rem !important;
}

.pt-104 {
  padding-top: 51.5rem !important;
}

.pt-105 {
  padding-top: 52rem !important;
}

.pt-106 {
  padding-top: 52.5rem !important;
}

.pt-107 {
  padding-top: 53rem !important;
}

.pt-108 {
  padding-top: 53.5rem !important;
}

.pt-109 {
  padding-top: 54rem !important;
}

.pt-110 {
  padding-top: 54.5rem !important;
}

.pt-111 {
  padding-top: 55rem !important;
}

.pt-112 {
  padding-top: 55.5rem !important;
}

.pt-113 {
  padding-top: 56rem !important;
}

.pt-114 {
  padding-top: 56.5rem !important;
}

.pt-115 {
  padding-top: 57rem !important;
}

.pt-116 {
  padding-top: 57.5rem !important;
}

.pt-117 {
  padding-top: 58rem !important;
}

.pt-118 {
  padding-top: 58.5rem !important;
}

.pt-119 {
  padding-top: 59rem !important;
}

.pt-120 {
  padding-top: 59.5rem !important;
}

.pt-121 {
  padding-top: 60rem !important;
}

.pt-122 {
  padding-top: 60.5rem !important;
}

.pt-123 {
  padding-top: 61rem !important;
}

.pt-124 {
  padding-top: 61.5rem !important;
}

.pt-125 {
  padding-top: 62rem !important;
}

.pt-126 {
  padding-top: 62.5rem !important;
}

.pt-127 {
  padding-top: 63rem !important;
}

.pt-128 {
  padding-top: 63.5rem !important;
}

.pt-129 {
  padding-top: 64rem !important;
}

.pt-130 {
  padding-top: 64.5rem !important;
}

.pt-131 {
  padding-top: 65rem !important;
}

.pt-132 {
  padding-top: 65.5rem !important;
}

.pt-133 {
  padding-top: 66rem !important;
}

.pt-134 {
  padding-top: 66.5rem !important;
}

.pt-135 {
  padding-top: 67rem !important;
}

.pt-136 {
  padding-top: 67.5rem !important;
}

.pt-137 {
  padding-top: 68rem !important;
}

.pt-138 {
  padding-top: 68.5rem !important;
}

.pt-139 {
  padding-top: 69rem !important;
}

.pt-140 {
  padding-top: 69.5rem !important;
}

.pt-141 {
  padding-top: 70rem !important;
}

.pt-142 {
  padding-top: 70.5rem !important;
}

.pt-143 {
  padding-top: 71rem !important;
}

.pt-144 {
  padding-top: 71.5rem !important;
}

.pt-145 {
  padding-top: 72rem !important;
}

.pt-146 {
  padding-top: 72.5rem !important;
}

.pt-147 {
  padding-top: 73rem !important;
}

.pt-148 {
  padding-top: 73.5rem !important;
}

.pt-149 {
  padding-top: 74rem !important;
}

.pt-150 {
  padding-top: 74.5rem !important;
}

.pt-151 {
  padding-top: 75rem !important;
}

.pt-152 {
  padding-top: 75.5rem !important;
}

.pt-153 {
  padding-top: 76rem !important;
}

.pt-154 {
  padding-top: 76.5rem !important;
}

.pt-155 {
  padding-top: 77rem !important;
}

.pt-156 {
  padding-top: 77.5rem !important;
}

.pt-157 {
  padding-top: 78rem !important;
}

.pt-158 {
  padding-top: 78.5rem !important;
}

.pt-159 {
  padding-top: 79rem !important;
}

.pt-160 {
  padding-top: 79.5rem !important;
}

.pb-0 {
  padding-bottom: 0rem !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 2rem !important;
}

.pb-6 {
  padding-bottom: 2.5rem !important;
}

.pb-7 {
  padding-bottom: 3rem !important;
}

.pb-8 {
  padding-bottom: 3.5rem !important;
}

.pb-9 {
  padding-bottom: 4rem !important;
}

.pb-10 {
  padding-bottom: 4.5rem !important;
}

.pb-11 {
  padding-bottom: 5rem !important;
}

.pb-12 {
  padding-bottom: 5.5rem !important;
}

.pb-13 {
  padding-bottom: 6rem !important;
}

.pb-14 {
  padding-bottom: 6.5rem !important;
}

.pb-15 {
  padding-bottom: 7rem !important;
}

.pb-16 {
  padding-bottom: 7.5rem !important;
}

.pb-17 {
  padding-bottom: 8rem !important;
}

.pb-18 {
  padding-bottom: 8.5rem !important;
}

.pb-19 {
  padding-bottom: 9rem !important;
}

.pb-20 {
  padding-bottom: 9.5rem !important;
}

.pb-21 {
  padding-bottom: 10rem !important;
}

.pb-22 {
  padding-bottom: 10.5rem !important;
}

.pb-23 {
  padding-bottom: 11rem !important;
}

.pb-24 {
  padding-bottom: 11.5rem !important;
}

.pb-25 {
  padding-bottom: 12rem !important;
}

.pb-26 {
  padding-bottom: 12.5rem !important;
}

.pb-27 {
  padding-bottom: 13rem !important;
}

.pb-28 {
  padding-bottom: 13.5rem !important;
}

.pb-29 {
  padding-bottom: 14rem !important;
}

.pb-30 {
  padding-bottom: 14.5rem !important;
}

.pb-31 {
  padding-bottom: 15rem !important;
}

.pb-32 {
  padding-bottom: 15.5rem !important;
}

.pb-33 {
  padding-bottom: 16rem !important;
}

.pb-34 {
  padding-bottom: 16.5rem !important;
}

.pb-35 {
  padding-bottom: 17rem !important;
}

.pb-36 {
  padding-bottom: 17.5rem !important;
}

.pb-37 {
  padding-bottom: 18rem !important;
}

.pb-38 {
  padding-bottom: 18.5rem !important;
}

.pb-39 {
  padding-bottom: 19rem !important;
}

.pb-40 {
  padding-bottom: 19.5rem !important;
}

.pb-41 {
  padding-bottom: 20rem !important;
}

.pb-42 {
  padding-bottom: 20.5rem !important;
}

.pb-43 {
  padding-bottom: 21rem !important;
}

.pb-44 {
  padding-bottom: 21.5rem !important;
}

.pb-45 {
  padding-bottom: 22rem !important;
}

.pb-46 {
  padding-bottom: 22.5rem !important;
}

.pb-47 {
  padding-bottom: 23rem !important;
}

.pb-48 {
  padding-bottom: 23.5rem !important;
}

.pb-49 {
  padding-bottom: 24rem !important;
}

.pb-50 {
  padding-bottom: 24.5rem !important;
}

.pb-51 {
  padding-bottom: 25rem !important;
}

.pb-52 {
  padding-bottom: 25.5rem !important;
}

.pb-53 {
  padding-bottom: 26rem !important;
}

.pb-54 {
  padding-bottom: 26.5rem !important;
}

.pb-55 {
  padding-bottom: 27rem !important;
}

.pb-56 {
  padding-bottom: 27.5rem !important;
}

.pb-57 {
  padding-bottom: 28rem !important;
}

.pb-58 {
  padding-bottom: 28.5rem !important;
}

.pb-59 {
  padding-bottom: 29rem !important;
}

.pb-60 {
  padding-bottom: 29.5rem !important;
}

.pb-61 {
  padding-bottom: 30rem !important;
}

.pb-62 {
  padding-bottom: 30.5rem !important;
}

.pb-63 {
  padding-bottom: 31rem !important;
}

.pb-64 {
  padding-bottom: 31.5rem !important;
}

.pb-65 {
  padding-bottom: 32rem !important;
}

.pb-66 {
  padding-bottom: 32.5rem !important;
}

.pb-67 {
  padding-bottom: 33rem !important;
}

.pb-68 {
  padding-bottom: 33.5rem !important;
}

.pb-69 {
  padding-bottom: 34rem !important;
}

.pb-70 {
  padding-bottom: 34.5rem !important;
}

.pb-71 {
  padding-bottom: 35rem !important;
}

.pb-72 {
  padding-bottom: 35.5rem !important;
}

.pb-73 {
  padding-bottom: 36rem !important;
}

.pb-74 {
  padding-bottom: 36.5rem !important;
}

.pb-75 {
  padding-bottom: 37rem !important;
}

.pb-76 {
  padding-bottom: 37.5rem !important;
}

.pb-77 {
  padding-bottom: 38rem !important;
}

.pb-78 {
  padding-bottom: 38.5rem !important;
}

.pb-79 {
  padding-bottom: 39rem !important;
}

.pb-80 {
  padding-bottom: 39.5rem !important;
}

.pb-81 {
  padding-bottom: 40rem !important;
}

.pb-82 {
  padding-bottom: 40.5rem !important;
}

.pb-83 {
  padding-bottom: 41rem !important;
}

.pb-84 {
  padding-bottom: 41.5rem !important;
}

.pb-85 {
  padding-bottom: 42rem !important;
}

.pb-86 {
  padding-bottom: 42.5rem !important;
}

.pb-87 {
  padding-bottom: 43rem !important;
}

.pb-88 {
  padding-bottom: 43.5rem !important;
}

.pb-89 {
  padding-bottom: 44rem !important;
}

.pb-90 {
  padding-bottom: 44.5rem !important;
}

.pb-91 {
  padding-bottom: 45rem !important;
}

.pb-92 {
  padding-bottom: 45.5rem !important;
}

.pb-93 {
  padding-bottom: 46rem !important;
}

.pb-94 {
  padding-bottom: 46.5rem !important;
}

.pb-95 {
  padding-bottom: 47rem !important;
}

.pb-96 {
  padding-bottom: 47.5rem !important;
}

.pb-97 {
  padding-bottom: 48rem !important;
}

.pb-98 {
  padding-bottom: 48.5rem !important;
}

.pb-99 {
  padding-bottom: 49rem !important;
}

.pb-100 {
  padding-bottom: 49.5rem !important;
}

.pb-101 {
  padding-bottom: 50rem !important;
}

.pb-102 {
  padding-bottom: 50.5rem !important;
}

.pb-103 {
  padding-bottom: 51rem !important;
}

.pb-104 {
  padding-bottom: 51.5rem !important;
}

.pb-105 {
  padding-bottom: 52rem !important;
}

.pb-106 {
  padding-bottom: 52.5rem !important;
}

.pb-107 {
  padding-bottom: 53rem !important;
}

.pb-108 {
  padding-bottom: 53.5rem !important;
}

.pb-109 {
  padding-bottom: 54rem !important;
}

.pb-110 {
  padding-bottom: 54.5rem !important;
}

.pb-111 {
  padding-bottom: 55rem !important;
}

.pb-112 {
  padding-bottom: 55.5rem !important;
}

.pb-113 {
  padding-bottom: 56rem !important;
}

.pb-114 {
  padding-bottom: 56.5rem !important;
}

.pb-115 {
  padding-bottom: 57rem !important;
}

.pb-116 {
  padding-bottom: 57.5rem !important;
}

.pb-117 {
  padding-bottom: 58rem !important;
}

.pb-118 {
  padding-bottom: 58.5rem !important;
}

.pb-119 {
  padding-bottom: 59rem !important;
}

.pb-120 {
  padding-bottom: 59.5rem !important;
}

.pb-121 {
  padding-bottom: 60rem !important;
}

.pb-122 {
  padding-bottom: 60.5rem !important;
}

.pb-123 {
  padding-bottom: 61rem !important;
}

.pb-124 {
  padding-bottom: 61.5rem !important;
}

.pb-125 {
  padding-bottom: 62rem !important;
}

.pb-126 {
  padding-bottom: 62.5rem !important;
}

.pb-127 {
  padding-bottom: 63rem !important;
}

.pb-128 {
  padding-bottom: 63.5rem !important;
}

.pb-129 {
  padding-bottom: 64rem !important;
}

.pb-130 {
  padding-bottom: 64.5rem !important;
}

.pb-131 {
  padding-bottom: 65rem !important;
}

.pb-132 {
  padding-bottom: 65.5rem !important;
}

.pb-133 {
  padding-bottom: 66rem !important;
}

.pb-134 {
  padding-bottom: 66.5rem !important;
}

.pb-135 {
  padding-bottom: 67rem !important;
}

.pb-136 {
  padding-bottom: 67.5rem !important;
}

.pb-137 {
  padding-bottom: 68rem !important;
}

.pb-138 {
  padding-bottom: 68.5rem !important;
}

.pb-139 {
  padding-bottom: 69rem !important;
}

.pb-140 {
  padding-bottom: 69.5rem !important;
}

.pb-141 {
  padding-bottom: 70rem !important;
}

.pb-142 {
  padding-bottom: 70.5rem !important;
}

.pb-143 {
  padding-bottom: 71rem !important;
}

.pb-144 {
  padding-bottom: 71.5rem !important;
}

.pb-145 {
  padding-bottom: 72rem !important;
}

.pb-146 {
  padding-bottom: 72.5rem !important;
}

.pb-147 {
  padding-bottom: 73rem !important;
}

.pb-148 {
  padding-bottom: 73.5rem !important;
}

.pb-149 {
  padding-bottom: 74rem !important;
}

.pb-150 {
  padding-bottom: 74.5rem !important;
}

.pb-151 {
  padding-bottom: 75rem !important;
}

.pb-152 {
  padding-bottom: 75.5rem !important;
}

.pb-153 {
  padding-bottom: 76rem !important;
}

.pb-154 {
  padding-bottom: 76.5rem !important;
}

.pb-155 {
  padding-bottom: 77rem !important;
}

.pb-156 {
  padding-bottom: 77.5rem !important;
}

.pb-157 {
  padding-bottom: 78rem !important;
}

.pb-158 {
  padding-bottom: 78.5rem !important;
}

.pb-159 {
  padding-bottom: 79rem !important;
}

.pb-160 {
  padding-bottom: 79.5rem !important;
}

.ps-0 {
  padding-left: 0rem !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 2rem !important;
}

.ps-6 {
  padding-left: 2.5rem !important;
}

.ps-7 {
  padding-left: 3rem !important;
}

.ps-8 {
  padding-left: 3.5rem !important;
}

.ps-9 {
  padding-left: 4rem !important;
}

.ps-10 {
  padding-left: 4.5rem !important;
}

.ps-11 {
  padding-left: 5rem !important;
}

.ps-12 {
  padding-left: 5.5rem !important;
}

.ps-13 {
  padding-left: 6rem !important;
}

.ps-14 {
  padding-left: 6.5rem !important;
}

.ps-15 {
  padding-left: 7rem !important;
}

.ps-16 {
  padding-left: 7.5rem !important;
}

.ps-17 {
  padding-left: 8rem !important;
}

.ps-18 {
  padding-left: 8.5rem !important;
}

.ps-19 {
  padding-left: 9rem !important;
}

.ps-20 {
  padding-left: 9.5rem !important;
}

.ps-21 {
  padding-left: 10rem !important;
}

.ps-22 {
  padding-left: 10.5rem !important;
}

.ps-23 {
  padding-left: 11rem !important;
}

.ps-24 {
  padding-left: 11.5rem !important;
}

.ps-25 {
  padding-left: 12rem !important;
}

.ps-26 {
  padding-left: 12.5rem !important;
}

.ps-27 {
  padding-left: 13rem !important;
}

.ps-28 {
  padding-left: 13.5rem !important;
}

.ps-29 {
  padding-left: 14rem !important;
}

.ps-30 {
  padding-left: 14.5rem !important;
}

.ps-31 {
  padding-left: 15rem !important;
}

.ps-32 {
  padding-left: 15.5rem !important;
}

.ps-33 {
  padding-left: 16rem !important;
}

.ps-34 {
  padding-left: 16.5rem !important;
}

.ps-35 {
  padding-left: 17rem !important;
}

.ps-36 {
  padding-left: 17.5rem !important;
}

.ps-37 {
  padding-left: 18rem !important;
}

.ps-38 {
  padding-left: 18.5rem !important;
}

.ps-39 {
  padding-left: 19rem !important;
}

.ps-40 {
  padding-left: 19.5rem !important;
}

.ps-41 {
  padding-left: 20rem !important;
}

.ps-42 {
  padding-left: 20.5rem !important;
}

.ps-43 {
  padding-left: 21rem !important;
}

.ps-44 {
  padding-left: 21.5rem !important;
}

.ps-45 {
  padding-left: 22rem !important;
}

.ps-46 {
  padding-left: 22.5rem !important;
}

.ps-47 {
  padding-left: 23rem !important;
}

.ps-48 {
  padding-left: 23.5rem !important;
}

.ps-49 {
  padding-left: 24rem !important;
}

.ps-50 {
  padding-left: 24.5rem !important;
}

.ps-51 {
  padding-left: 25rem !important;
}

.ps-52 {
  padding-left: 25.5rem !important;
}

.ps-53 {
  padding-left: 26rem !important;
}

.ps-54 {
  padding-left: 26.5rem !important;
}

.ps-55 {
  padding-left: 27rem !important;
}

.ps-56 {
  padding-left: 27.5rem !important;
}

.ps-57 {
  padding-left: 28rem !important;
}

.ps-58 {
  padding-left: 28.5rem !important;
}

.ps-59 {
  padding-left: 29rem !important;
}

.ps-60 {
  padding-left: 29.5rem !important;
}

.ps-61 {
  padding-left: 30rem !important;
}

.ps-62 {
  padding-left: 30.5rem !important;
}

.ps-63 {
  padding-left: 31rem !important;
}

.ps-64 {
  padding-left: 31.5rem !important;
}

.ps-65 {
  padding-left: 32rem !important;
}

.ps-66 {
  padding-left: 32.5rem !important;
}

.ps-67 {
  padding-left: 33rem !important;
}

.ps-68 {
  padding-left: 33.5rem !important;
}

.ps-69 {
  padding-left: 34rem !important;
}

.ps-70 {
  padding-left: 34.5rem !important;
}

.ps-71 {
  padding-left: 35rem !important;
}

.ps-72 {
  padding-left: 35.5rem !important;
}

.ps-73 {
  padding-left: 36rem !important;
}

.ps-74 {
  padding-left: 36.5rem !important;
}

.ps-75 {
  padding-left: 37rem !important;
}

.ps-76 {
  padding-left: 37.5rem !important;
}

.ps-77 {
  padding-left: 38rem !important;
}

.ps-78 {
  padding-left: 38.5rem !important;
}

.ps-79 {
  padding-left: 39rem !important;
}

.ps-80 {
  padding-left: 39.5rem !important;
}

.ps-81 {
  padding-left: 40rem !important;
}

.ps-82 {
  padding-left: 40.5rem !important;
}

.ps-83 {
  padding-left: 41rem !important;
}

.ps-84 {
  padding-left: 41.5rem !important;
}

.ps-85 {
  padding-left: 42rem !important;
}

.ps-86 {
  padding-left: 42.5rem !important;
}

.ps-87 {
  padding-left: 43rem !important;
}

.ps-88 {
  padding-left: 43.5rem !important;
}

.ps-89 {
  padding-left: 44rem !important;
}

.ps-90 {
  padding-left: 44.5rem !important;
}

.ps-91 {
  padding-left: 45rem !important;
}

.ps-92 {
  padding-left: 45.5rem !important;
}

.ps-93 {
  padding-left: 46rem !important;
}

.ps-94 {
  padding-left: 46.5rem !important;
}

.ps-95 {
  padding-left: 47rem !important;
}

.ps-96 {
  padding-left: 47.5rem !important;
}

.ps-97 {
  padding-left: 48rem !important;
}

.ps-98 {
  padding-left: 48.5rem !important;
}

.ps-99 {
  padding-left: 49rem !important;
}

.ps-100 {
  padding-left: 49.5rem !important;
}

.ps-101 {
  padding-left: 50rem !important;
}

.ps-102 {
  padding-left: 50.5rem !important;
}

.ps-103 {
  padding-left: 51rem !important;
}

.ps-104 {
  padding-left: 51.5rem !important;
}

.ps-105 {
  padding-left: 52rem !important;
}

.ps-106 {
  padding-left: 52.5rem !important;
}

.ps-107 {
  padding-left: 53rem !important;
}

.ps-108 {
  padding-left: 53.5rem !important;
}

.ps-109 {
  padding-left: 54rem !important;
}

.ps-110 {
  padding-left: 54.5rem !important;
}

.ps-111 {
  padding-left: 55rem !important;
}

.ps-112 {
  padding-left: 55.5rem !important;
}

.ps-113 {
  padding-left: 56rem !important;
}

.ps-114 {
  padding-left: 56.5rem !important;
}

.ps-115 {
  padding-left: 57rem !important;
}

.ps-116 {
  padding-left: 57.5rem !important;
}

.ps-117 {
  padding-left: 58rem !important;
}

.ps-118 {
  padding-left: 58.5rem !important;
}

.ps-119 {
  padding-left: 59rem !important;
}

.ps-120 {
  padding-left: 59.5rem !important;
}

.ps-121 {
  padding-left: 60rem !important;
}

.ps-122 {
  padding-left: 60.5rem !important;
}

.ps-123 {
  padding-left: 61rem !important;
}

.ps-124 {
  padding-left: 61.5rem !important;
}

.ps-125 {
  padding-left: 62rem !important;
}

.ps-126 {
  padding-left: 62.5rem !important;
}

.ps-127 {
  padding-left: 63rem !important;
}

.ps-128 {
  padding-left: 63.5rem !important;
}

.ps-129 {
  padding-left: 64rem !important;
}

.ps-130 {
  padding-left: 64.5rem !important;
}

.ps-131 {
  padding-left: 65rem !important;
}

.ps-132 {
  padding-left: 65.5rem !important;
}

.ps-133 {
  padding-left: 66rem !important;
}

.ps-134 {
  padding-left: 66.5rem !important;
}

.ps-135 {
  padding-left: 67rem !important;
}

.ps-136 {
  padding-left: 67.5rem !important;
}

.ps-137 {
  padding-left: 68rem !important;
}

.ps-138 {
  padding-left: 68.5rem !important;
}

.ps-139 {
  padding-left: 69rem !important;
}

.ps-140 {
  padding-left: 69.5rem !important;
}

.ps-141 {
  padding-left: 70rem !important;
}

.ps-142 {
  padding-left: 70.5rem !important;
}

.ps-143 {
  padding-left: 71rem !important;
}

.ps-144 {
  padding-left: 71.5rem !important;
}

.ps-145 {
  padding-left: 72rem !important;
}

.ps-146 {
  padding-left: 72.5rem !important;
}

.ps-147 {
  padding-left: 73rem !important;
}

.ps-148 {
  padding-left: 73.5rem !important;
}

.ps-149 {
  padding-left: 74rem !important;
}

.ps-150 {
  padding-left: 74.5rem !important;
}

.ps-151 {
  padding-left: 75rem !important;
}

.ps-152 {
  padding-left: 75.5rem !important;
}

.ps-153 {
  padding-left: 76rem !important;
}

.ps-154 {
  padding-left: 76.5rem !important;
}

.ps-155 {
  padding-left: 77rem !important;
}

.ps-156 {
  padding-left: 77.5rem !important;
}

.ps-157 {
  padding-left: 78rem !important;
}

.ps-158 {
  padding-left: 78.5rem !important;
}

.ps-159 {
  padding-left: 79rem !important;
}

.ps-160 {
  padding-left: 79.5rem !important;
}

.pe-0 {
  padding-right: 0rem !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 2rem !important;
}

.pe-6 {
  padding-right: 2.5rem !important;
}

.pe-7 {
  padding-right: 3rem !important;
}

.pe-8 {
  padding-right: 3.5rem !important;
}

.pe-9 {
  padding-right: 4rem !important;
}

.pe-10 {
  padding-right: 4.5rem !important;
}

.pe-11 {
  padding-right: 5rem !important;
}

.pe-12 {
  padding-right: 5.5rem !important;
}

.pe-13 {
  padding-right: 6rem !important;
}

.pe-14 {
  padding-right: 6.5rem !important;
}

.pe-15 {
  padding-right: 7rem !important;
}

.pe-16 {
  padding-right: 7.5rem !important;
}

.pe-17 {
  padding-right: 8rem !important;
}

.pe-18 {
  padding-right: 8.5rem !important;
}

.pe-19 {
  padding-right: 9rem !important;
}

.pe-20 {
  padding-right: 9.5rem !important;
}

.pe-21 {
  padding-right: 10rem !important;
}

.pe-22 {
  padding-right: 10.5rem !important;
}

.pe-23 {
  padding-right: 11rem !important;
}

.pe-24 {
  padding-right: 11.5rem !important;
}

.pe-25 {
  padding-right: 12rem !important;
}

.pe-26 {
  padding-right: 12.5rem !important;
}

.pe-27 {
  padding-right: 13rem !important;
}

.pe-28 {
  padding-right: 13.5rem !important;
}

.pe-29 {
  padding-right: 14rem !important;
}

.pe-30 {
  padding-right: 14.5rem !important;
}

.pe-31 {
  padding-right: 15rem !important;
}

.pe-32 {
  padding-right: 15.5rem !important;
}

.pe-33 {
  padding-right: 16rem !important;
}

.pe-34 {
  padding-right: 16.5rem !important;
}

.pe-35 {
  padding-right: 17rem !important;
}

.pe-36 {
  padding-right: 17.5rem !important;
}

.pe-37 {
  padding-right: 18rem !important;
}

.pe-38 {
  padding-right: 18.5rem !important;
}

.pe-39 {
  padding-right: 19rem !important;
}

.pe-40 {
  padding-right: 19.5rem !important;
}

.pe-41 {
  padding-right: 20rem !important;
}

.pe-42 {
  padding-right: 20.5rem !important;
}

.pe-43 {
  padding-right: 21rem !important;
}

.pe-44 {
  padding-right: 21.5rem !important;
}

.pe-45 {
  padding-right: 22rem !important;
}

.pe-46 {
  padding-right: 22.5rem !important;
}

.pe-47 {
  padding-right: 23rem !important;
}

.pe-48 {
  padding-right: 23.5rem !important;
}

.pe-49 {
  padding-right: 24rem !important;
}

.pe-50 {
  padding-right: 24.5rem !important;
}

.pe-51 {
  padding-right: 25rem !important;
}

.pe-52 {
  padding-right: 25.5rem !important;
}

.pe-53 {
  padding-right: 26rem !important;
}

.pe-54 {
  padding-right: 26.5rem !important;
}

.pe-55 {
  padding-right: 27rem !important;
}

.pe-56 {
  padding-right: 27.5rem !important;
}

.pe-57 {
  padding-right: 28rem !important;
}

.pe-58 {
  padding-right: 28.5rem !important;
}

.pe-59 {
  padding-right: 29rem !important;
}

.pe-60 {
  padding-right: 29.5rem !important;
}

.pe-61 {
  padding-right: 30rem !important;
}

.pe-62 {
  padding-right: 30.5rem !important;
}

.pe-63 {
  padding-right: 31rem !important;
}

.pe-64 {
  padding-right: 31.5rem !important;
}

.pe-65 {
  padding-right: 32rem !important;
}

.pe-66 {
  padding-right: 32.5rem !important;
}

.pe-67 {
  padding-right: 33rem !important;
}

.pe-68 {
  padding-right: 33.5rem !important;
}

.pe-69 {
  padding-right: 34rem !important;
}

.pe-70 {
  padding-right: 34.5rem !important;
}

.pe-71 {
  padding-right: 35rem !important;
}

.pe-72 {
  padding-right: 35.5rem !important;
}

.pe-73 {
  padding-right: 36rem !important;
}

.pe-74 {
  padding-right: 36.5rem !important;
}

.pe-75 {
  padding-right: 37rem !important;
}

.pe-76 {
  padding-right: 37.5rem !important;
}

.pe-77 {
  padding-right: 38rem !important;
}

.pe-78 {
  padding-right: 38.5rem !important;
}

.pe-79 {
  padding-right: 39rem !important;
}

.pe-80 {
  padding-right: 39.5rem !important;
}

.pe-81 {
  padding-right: 40rem !important;
}

.pe-82 {
  padding-right: 40.5rem !important;
}

.pe-83 {
  padding-right: 41rem !important;
}

.pe-84 {
  padding-right: 41.5rem !important;
}

.pe-85 {
  padding-right: 42rem !important;
}

.pe-86 {
  padding-right: 42.5rem !important;
}

.pe-87 {
  padding-right: 43rem !important;
}

.pe-88 {
  padding-right: 43.5rem !important;
}

.pe-89 {
  padding-right: 44rem !important;
}

.pe-90 {
  padding-right: 44.5rem !important;
}

.pe-91 {
  padding-right: 45rem !important;
}

.pe-92 {
  padding-right: 45.5rem !important;
}

.pe-93 {
  padding-right: 46rem !important;
}

.pe-94 {
  padding-right: 46.5rem !important;
}

.pe-95 {
  padding-right: 47rem !important;
}

.pe-96 {
  padding-right: 47.5rem !important;
}

.pe-97 {
  padding-right: 48rem !important;
}

.pe-98 {
  padding-right: 48.5rem !important;
}

.pe-99 {
  padding-right: 49rem !important;
}

.pe-100 {
  padding-right: 49.5rem !important;
}

.pe-101 {
  padding-right: 50rem !important;
}

.pe-102 {
  padding-right: 50.5rem !important;
}

.pe-103 {
  padding-right: 51rem !important;
}

.pe-104 {
  padding-right: 51.5rem !important;
}

.pe-105 {
  padding-right: 52rem !important;
}

.pe-106 {
  padding-right: 52.5rem !important;
}

.pe-107 {
  padding-right: 53rem !important;
}

.pe-108 {
  padding-right: 53.5rem !important;
}

.pe-109 {
  padding-right: 54rem !important;
}

.pe-110 {
  padding-right: 54.5rem !important;
}

.pe-111 {
  padding-right: 55rem !important;
}

.pe-112 {
  padding-right: 55.5rem !important;
}

.pe-113 {
  padding-right: 56rem !important;
}

.pe-114 {
  padding-right: 56.5rem !important;
}

.pe-115 {
  padding-right: 57rem !important;
}

.pe-116 {
  padding-right: 57.5rem !important;
}

.pe-117 {
  padding-right: 58rem !important;
}

.pe-118 {
  padding-right: 58.5rem !important;
}

.pe-119 {
  padding-right: 59rem !important;
}

.pe-120 {
  padding-right: 59.5rem !important;
}

.pe-121 {
  padding-right: 60rem !important;
}

.pe-122 {
  padding-right: 60.5rem !important;
}

.pe-123 {
  padding-right: 61rem !important;
}

.pe-124 {
  padding-right: 61.5rem !important;
}

.pe-125 {
  padding-right: 62rem !important;
}

.pe-126 {
  padding-right: 62.5rem !important;
}

.pe-127 {
  padding-right: 63rem !important;
}

.pe-128 {
  padding-right: 63.5rem !important;
}

.pe-129 {
  padding-right: 64rem !important;
}

.pe-130 {
  padding-right: 64.5rem !important;
}

.pe-131 {
  padding-right: 65rem !important;
}

.pe-132 {
  padding-right: 65.5rem !important;
}

.pe-133 {
  padding-right: 66rem !important;
}

.pe-134 {
  padding-right: 66.5rem !important;
}

.pe-135 {
  padding-right: 67rem !important;
}

.pe-136 {
  padding-right: 67.5rem !important;
}

.pe-137 {
  padding-right: 68rem !important;
}

.pe-138 {
  padding-right: 68.5rem !important;
}

.pe-139 {
  padding-right: 69rem !important;
}

.pe-140 {
  padding-right: 69.5rem !important;
}

.pe-141 {
  padding-right: 70rem !important;
}

.pe-142 {
  padding-right: 70.5rem !important;
}

.pe-143 {
  padding-right: 71rem !important;
}

.pe-144 {
  padding-right: 71.5rem !important;
}

.pe-145 {
  padding-right: 72rem !important;
}

.pe-146 {
  padding-right: 72.5rem !important;
}

.pe-147 {
  padding-right: 73rem !important;
}

.pe-148 {
  padding-right: 73.5rem !important;
}

.pe-149 {
  padding-right: 74rem !important;
}

.pe-150 {
  padding-right: 74.5rem !important;
}

.pe-151 {
  padding-right: 75rem !important;
}

.pe-152 {
  padding-right: 75.5rem !important;
}

.pe-153 {
  padding-right: 76rem !important;
}

.pe-154 {
  padding-right: 76.5rem !important;
}

.pe-155 {
  padding-right: 77rem !important;
}

.pe-156 {
  padding-right: 77.5rem !important;
}

.pe-157 {
  padding-right: 78rem !important;
}

.pe-158 {
  padding-right: 78.5rem !important;
}

.pe-159 {
  padding-right: 79rem !important;
}

.pe-160 {
  padding-right: 79.5rem !important;
}

.px-0 {
  padding-left: 0rem !important;
  padding-right: 0rem !important;
}

.px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}

.px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.px-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.px-4 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}

.px-5 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}

.px-6 {
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}

.px-7 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.px-8 {
  padding-left: 3.5rem !important;
  padding-right: 3.5rem !important;
}

.px-9 {
  padding-left: 4rem !important;
  padding-right: 4rem !important;
}

.px-10 {
  padding-left: 4.5rem !important;
  padding-right: 4.5rem !important;
}

.px-11 {
  padding-left: 5rem !important;
  padding-right: 5rem !important;
}

.px-12 {
  padding-left: 5.5rem !important;
  padding-right: 5.5rem !important;
}

.px-13 {
  padding-left: 6rem !important;
  padding-right: 6rem !important;
}

.px-14 {
  padding-left: 6.5rem !important;
  padding-right: 6.5rem !important;
}

.px-15 {
  padding-left: 7rem !important;
  padding-right: 7rem !important;
}

.px-16 {
  padding-left: 7.5rem !important;
  padding-right: 7.5rem !important;
}

.px-17 {
  padding-left: 8rem !important;
  padding-right: 8rem !important;
}

.px-18 {
  padding-left: 8.5rem !important;
  padding-right: 8.5rem !important;
}

.px-19 {
  padding-left: 9rem !important;
  padding-right: 9rem !important;
}

.px-20 {
  padding-left: 9.5rem !important;
  padding-right: 9.5rem !important;
}

.px-21 {
  padding-left: 10rem !important;
  padding-right: 10rem !important;
}

.px-22 {
  padding-left: 10.5rem !important;
  padding-right: 10.5rem !important;
}

.px-23 {
  padding-left: 11rem !important;
  padding-right: 11rem !important;
}

.px-24 {
  padding-left: 11.5rem !important;
  padding-right: 11.5rem !important;
}

.px-25 {
  padding-left: 12rem !important;
  padding-right: 12rem !important;
}

.px-26 {
  padding-left: 12.5rem !important;
  padding-right: 12.5rem !important;
}

.px-27 {
  padding-left: 13rem !important;
  padding-right: 13rem !important;
}

.px-28 {
  padding-left: 13.5rem !important;
  padding-right: 13.5rem !important;
}

.px-29 {
  padding-left: 14rem !important;
  padding-right: 14rem !important;
}

.px-30 {
  padding-left: 14.5rem !important;
  padding-right: 14.5rem !important;
}

.px-31 {
  padding-left: 15rem !important;
  padding-right: 15rem !important;
}

.px-32 {
  padding-left: 15.5rem !important;
  padding-right: 15.5rem !important;
}

.px-33 {
  padding-left: 16rem !important;
  padding-right: 16rem !important;
}

.px-34 {
  padding-left: 16.5rem !important;
  padding-right: 16.5rem !important;
}

.px-35 {
  padding-left: 17rem !important;
  padding-right: 17rem !important;
}

.px-36 {
  padding-left: 17.5rem !important;
  padding-right: 17.5rem !important;
}

.px-37 {
  padding-left: 18rem !important;
  padding-right: 18rem !important;
}

.px-38 {
  padding-left: 18.5rem !important;
  padding-right: 18.5rem !important;
}

.px-39 {
  padding-left: 19rem !important;
  padding-right: 19rem !important;
}

.px-40 {
  padding-left: 19.5rem !important;
  padding-right: 19.5rem !important;
}

.px-41 {
  padding-left: 20rem !important;
  padding-right: 20rem !important;
}

.px-42 {
  padding-left: 20.5rem !important;
  padding-right: 20.5rem !important;
}

.px-43 {
  padding-left: 21rem !important;
  padding-right: 21rem !important;
}

.px-44 {
  padding-left: 21.5rem !important;
  padding-right: 21.5rem !important;
}

.px-45 {
  padding-left: 22rem !important;
  padding-right: 22rem !important;
}

.px-46 {
  padding-left: 22.5rem !important;
  padding-right: 22.5rem !important;
}

.px-47 {
  padding-left: 23rem !important;
  padding-right: 23rem !important;
}

.px-48 {
  padding-left: 23.5rem !important;
  padding-right: 23.5rem !important;
}

.px-49 {
  padding-left: 24rem !important;
  padding-right: 24rem !important;
}

.px-50 {
  padding-left: 24.5rem !important;
  padding-right: 24.5rem !important;
}

.px-51 {
  padding-left: 25rem !important;
  padding-right: 25rem !important;
}

.px-52 {
  padding-left: 25.5rem !important;
  padding-right: 25.5rem !important;
}

.px-53 {
  padding-left: 26rem !important;
  padding-right: 26rem !important;
}

.px-54 {
  padding-left: 26.5rem !important;
  padding-right: 26.5rem !important;
}

.px-55 {
  padding-left: 27rem !important;
  padding-right: 27rem !important;
}

.px-56 {
  padding-left: 27.5rem !important;
  padding-right: 27.5rem !important;
}

.px-57 {
  padding-left: 28rem !important;
  padding-right: 28rem !important;
}

.px-58 {
  padding-left: 28.5rem !important;
  padding-right: 28.5rem !important;
}

.px-59 {
  padding-left: 29rem !important;
  padding-right: 29rem !important;
}

.px-60 {
  padding-left: 29.5rem !important;
  padding-right: 29.5rem !important;
}

.px-61 {
  padding-left: 30rem !important;
  padding-right: 30rem !important;
}

.px-62 {
  padding-left: 30.5rem !important;
  padding-right: 30.5rem !important;
}

.px-63 {
  padding-left: 31rem !important;
  padding-right: 31rem !important;
}

.px-64 {
  padding-left: 31.5rem !important;
  padding-right: 31.5rem !important;
}

.px-65 {
  padding-left: 32rem !important;
  padding-right: 32rem !important;
}

.px-66 {
  padding-left: 32.5rem !important;
  padding-right: 32.5rem !important;
}

.px-67 {
  padding-left: 33rem !important;
  padding-right: 33rem !important;
}

.px-68 {
  padding-left: 33.5rem !important;
  padding-right: 33.5rem !important;
}

.px-69 {
  padding-left: 34rem !important;
  padding-right: 34rem !important;
}

.px-70 {
  padding-left: 34.5rem !important;
  padding-right: 34.5rem !important;
}

.px-71 {
  padding-left: 35rem !important;
  padding-right: 35rem !important;
}

.px-72 {
  padding-left: 35.5rem !important;
  padding-right: 35.5rem !important;
}

.px-73 {
  padding-left: 36rem !important;
  padding-right: 36rem !important;
}

.px-74 {
  padding-left: 36.5rem !important;
  padding-right: 36.5rem !important;
}

.px-75 {
  padding-left: 37rem !important;
  padding-right: 37rem !important;
}

.px-76 {
  padding-left: 37.5rem !important;
  padding-right: 37.5rem !important;
}

.px-77 {
  padding-left: 38rem !important;
  padding-right: 38rem !important;
}

.px-78 {
  padding-left: 38.5rem !important;
  padding-right: 38.5rem !important;
}

.px-79 {
  padding-left: 39rem !important;
  padding-right: 39rem !important;
}

.px-80 {
  padding-left: 39.5rem !important;
  padding-right: 39.5rem !important;
}

.px-81 {
  padding-left: 40rem !important;
  padding-right: 40rem !important;
}

.px-82 {
  padding-left: 40.5rem !important;
  padding-right: 40.5rem !important;
}

.px-83 {
  padding-left: 41rem !important;
  padding-right: 41rem !important;
}

.px-84 {
  padding-left: 41.5rem !important;
  padding-right: 41.5rem !important;
}

.px-85 {
  padding-left: 42rem !important;
  padding-right: 42rem !important;
}

.px-86 {
  padding-left: 42.5rem !important;
  padding-right: 42.5rem !important;
}

.px-87 {
  padding-left: 43rem !important;
  padding-right: 43rem !important;
}

.px-88 {
  padding-left: 43.5rem !important;
  padding-right: 43.5rem !important;
}

.px-89 {
  padding-left: 44rem !important;
  padding-right: 44rem !important;
}

.px-90 {
  padding-left: 44.5rem !important;
  padding-right: 44.5rem !important;
}

.px-91 {
  padding-left: 45rem !important;
  padding-right: 45rem !important;
}

.px-92 {
  padding-left: 45.5rem !important;
  padding-right: 45.5rem !important;
}

.px-93 {
  padding-left: 46rem !important;
  padding-right: 46rem !important;
}

.px-94 {
  padding-left: 46.5rem !important;
  padding-right: 46.5rem !important;
}

.px-95 {
  padding-left: 47rem !important;
  padding-right: 47rem !important;
}

.px-96 {
  padding-left: 47.5rem !important;
  padding-right: 47.5rem !important;
}

.px-97 {
  padding-left: 48rem !important;
  padding-right: 48rem !important;
}

.px-98 {
  padding-left: 48.5rem !important;
  padding-right: 48.5rem !important;
}

.px-99 {
  padding-left: 49rem !important;
  padding-right: 49rem !important;
}

.px-100 {
  padding-left: 49.5rem !important;
  padding-right: 49.5rem !important;
}

.px-101 {
  padding-left: 50rem !important;
  padding-right: 50rem !important;
}

.px-102 {
  padding-left: 50.5rem !important;
  padding-right: 50.5rem !important;
}

.px-103 {
  padding-left: 51rem !important;
  padding-right: 51rem !important;
}

.px-104 {
  padding-left: 51.5rem !important;
  padding-right: 51.5rem !important;
}

.px-105 {
  padding-left: 52rem !important;
  padding-right: 52rem !important;
}

.px-106 {
  padding-left: 52.5rem !important;
  padding-right: 52.5rem !important;
}

.px-107 {
  padding-left: 53rem !important;
  padding-right: 53rem !important;
}

.px-108 {
  padding-left: 53.5rem !important;
  padding-right: 53.5rem !important;
}

.px-109 {
  padding-left: 54rem !important;
  padding-right: 54rem !important;
}

.px-110 {
  padding-left: 54.5rem !important;
  padding-right: 54.5rem !important;
}

.px-111 {
  padding-left: 55rem !important;
  padding-right: 55rem !important;
}

.px-112 {
  padding-left: 55.5rem !important;
  padding-right: 55.5rem !important;
}

.px-113 {
  padding-left: 56rem !important;
  padding-right: 56rem !important;
}

.px-114 {
  padding-left: 56.5rem !important;
  padding-right: 56.5rem !important;
}

.px-115 {
  padding-left: 57rem !important;
  padding-right: 57rem !important;
}

.px-116 {
  padding-left: 57.5rem !important;
  padding-right: 57.5rem !important;
}

.px-117 {
  padding-left: 58rem !important;
  padding-right: 58rem !important;
}

.px-118 {
  padding-left: 58.5rem !important;
  padding-right: 58.5rem !important;
}

.px-119 {
  padding-left: 59rem !important;
  padding-right: 59rem !important;
}

.px-120 {
  padding-left: 59.5rem !important;
  padding-right: 59.5rem !important;
}

.px-121 {
  padding-left: 60rem !important;
  padding-right: 60rem !important;
}

.px-122 {
  padding-left: 60.5rem !important;
  padding-right: 60.5rem !important;
}

.px-123 {
  padding-left: 61rem !important;
  padding-right: 61rem !important;
}

.px-124 {
  padding-left: 61.5rem !important;
  padding-right: 61.5rem !important;
}

.px-125 {
  padding-left: 62rem !important;
  padding-right: 62rem !important;
}

.px-126 {
  padding-left: 62.5rem !important;
  padding-right: 62.5rem !important;
}

.px-127 {
  padding-left: 63rem !important;
  padding-right: 63rem !important;
}

.px-128 {
  padding-left: 63.5rem !important;
  padding-right: 63.5rem !important;
}

.px-129 {
  padding-left: 64rem !important;
  padding-right: 64rem !important;
}

.px-130 {
  padding-left: 64.5rem !important;
  padding-right: 64.5rem !important;
}

.px-131 {
  padding-left: 65rem !important;
  padding-right: 65rem !important;
}

.px-132 {
  padding-left: 65.5rem !important;
  padding-right: 65.5rem !important;
}

.px-133 {
  padding-left: 66rem !important;
  padding-right: 66rem !important;
}

.px-134 {
  padding-left: 66.5rem !important;
  padding-right: 66.5rem !important;
}

.px-135 {
  padding-left: 67rem !important;
  padding-right: 67rem !important;
}

.px-136 {
  padding-left: 67.5rem !important;
  padding-right: 67.5rem !important;
}

.px-137 {
  padding-left: 68rem !important;
  padding-right: 68rem !important;
}

.px-138 {
  padding-left: 68.5rem !important;
  padding-right: 68.5rem !important;
}

.px-139 {
  padding-left: 69rem !important;
  padding-right: 69rem !important;
}

.px-140 {
  padding-left: 69.5rem !important;
  padding-right: 69.5rem !important;
}

.px-141 {
  padding-left: 70rem !important;
  padding-right: 70rem !important;
}

.px-142 {
  padding-left: 70.5rem !important;
  padding-right: 70.5rem !important;
}

.px-143 {
  padding-left: 71rem !important;
  padding-right: 71rem !important;
}

.px-144 {
  padding-left: 71.5rem !important;
  padding-right: 71.5rem !important;
}

.px-145 {
  padding-left: 72rem !important;
  padding-right: 72rem !important;
}

.px-146 {
  padding-left: 72.5rem !important;
  padding-right: 72.5rem !important;
}

.px-147 {
  padding-left: 73rem !important;
  padding-right: 73rem !important;
}

.px-148 {
  padding-left: 73.5rem !important;
  padding-right: 73.5rem !important;
}

.px-149 {
  padding-left: 74rem !important;
  padding-right: 74rem !important;
}

.px-150 {
  padding-left: 74.5rem !important;
  padding-right: 74.5rem !important;
}

.px-151 {
  padding-left: 75rem !important;
  padding-right: 75rem !important;
}

.px-152 {
  padding-left: 75.5rem !important;
  padding-right: 75.5rem !important;
}

.px-153 {
  padding-left: 76rem !important;
  padding-right: 76rem !important;
}

.px-154 {
  padding-left: 76.5rem !important;
  padding-right: 76.5rem !important;
}

.px-155 {
  padding-left: 77rem !important;
  padding-right: 77rem !important;
}

.px-156 {
  padding-left: 77.5rem !important;
  padding-right: 77.5rem !important;
}

.px-157 {
  padding-left: 78rem !important;
  padding-right: 78rem !important;
}

.px-158 {
  padding-left: 78.5rem !important;
  padding-right: 78.5rem !important;
}

.px-159 {
  padding-left: 79rem !important;
  padding-right: 79rem !important;
}

.px-160 {
  padding-left: 79.5rem !important;
  padding-right: 79.5rem !important;
}

.py-0 {
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-6 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.py-7 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-8 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-9 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-10 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-11 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.py-12 {
  padding-top: 5.5rem !important;
  padding-bottom: 5.5rem !important;
}

.py-13 {
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}

.py-14 {
  padding-top: 6.5rem !important;
  padding-bottom: 6.5rem !important;
}

.py-15 {
  padding-top: 7rem !important;
  padding-bottom: 7rem !important;
}

.py-16 {
  padding-top: 7.5rem !important;
  padding-bottom: 7.5rem !important;
}

.py-17 {
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
}

.py-18 {
  padding-top: 8.5rem !important;
  padding-bottom: 8.5rem !important;
}

.py-19 {
  padding-top: 9rem !important;
  padding-bottom: 9rem !important;
}

.py-20 {
  padding-top: 9.5rem !important;
  padding-bottom: 9.5rem !important;
}

.py-21 {
  padding-top: 10rem !important;
  padding-bottom: 10rem !important;
}

.py-22 {
  padding-top: 10.5rem !important;
  padding-bottom: 10.5rem !important;
}

.py-23 {
  padding-top: 11rem !important;
  padding-bottom: 11rem !important;
}

.py-24 {
  padding-top: 11.5rem !important;
  padding-bottom: 11.5rem !important;
}

.py-25 {
  padding-top: 12rem !important;
  padding-bottom: 12rem !important;
}

.py-26 {
  padding-top: 12.5rem !important;
  padding-bottom: 12.5rem !important;
}

.py-27 {
  padding-top: 13rem !important;
  padding-bottom: 13rem !important;
}

.py-28 {
  padding-top: 13.5rem !important;
  padding-bottom: 13.5rem !important;
}

.py-29 {
  padding-top: 14rem !important;
  padding-bottom: 14rem !important;
}

.py-30 {
  padding-top: 14.5rem !important;
  padding-bottom: 14.5rem !important;
}

.py-31 {
  padding-top: 15rem !important;
  padding-bottom: 15rem !important;
}

.py-32 {
  padding-top: 15.5rem !important;
  padding-bottom: 15.5rem !important;
}

.py-33 {
  padding-top: 16rem !important;
  padding-bottom: 16rem !important;
}

.py-34 {
  padding-top: 16.5rem !important;
  padding-bottom: 16.5rem !important;
}

.py-35 {
  padding-top: 17rem !important;
  padding-bottom: 17rem !important;
}

.py-36 {
  padding-top: 17.5rem !important;
  padding-bottom: 17.5rem !important;
}

.py-37 {
  padding-top: 18rem !important;
  padding-bottom: 18rem !important;
}

.py-38 {
  padding-top: 18.5rem !important;
  padding-bottom: 18.5rem !important;
}

.py-39 {
  padding-top: 19rem !important;
  padding-bottom: 19rem !important;
}

.py-40 {
  padding-top: 19.5rem !important;
  padding-bottom: 19.5rem !important;
}

.py-41 {
  padding-top: 20rem !important;
  padding-bottom: 20rem !important;
}

.py-42 {
  padding-top: 20.5rem !important;
  padding-bottom: 20.5rem !important;
}

.py-43 {
  padding-top: 21rem !important;
  padding-bottom: 21rem !important;
}

.py-44 {
  padding-top: 21.5rem !important;
  padding-bottom: 21.5rem !important;
}

.py-45 {
  padding-top: 22rem !important;
  padding-bottom: 22rem !important;
}

.py-46 {
  padding-top: 22.5rem !important;
  padding-bottom: 22.5rem !important;
}

.py-47 {
  padding-top: 23rem !important;
  padding-bottom: 23rem !important;
}

.py-48 {
  padding-top: 23.5rem !important;
  padding-bottom: 23.5rem !important;
}

.py-49 {
  padding-top: 24rem !important;
  padding-bottom: 24rem !important;
}

.py-50 {
  padding-top: 24.5rem !important;
  padding-bottom: 24.5rem !important;
}

.py-51 {
  padding-top: 25rem !important;
  padding-bottom: 25rem !important;
}

.py-52 {
  padding-top: 25.5rem !important;
  padding-bottom: 25.5rem !important;
}

.py-53 {
  padding-top: 26rem !important;
  padding-bottom: 26rem !important;
}

.py-54 {
  padding-top: 26.5rem !important;
  padding-bottom: 26.5rem !important;
}

.py-55 {
  padding-top: 27rem !important;
  padding-bottom: 27rem !important;
}

.py-56 {
  padding-top: 27.5rem !important;
  padding-bottom: 27.5rem !important;
}

.py-57 {
  padding-top: 28rem !important;
  padding-bottom: 28rem !important;
}

.py-58 {
  padding-top: 28.5rem !important;
  padding-bottom: 28.5rem !important;
}

.py-59 {
  padding-top: 29rem !important;
  padding-bottom: 29rem !important;
}

.py-60 {
  padding-top: 29.5rem !important;
  padding-bottom: 29.5rem !important;
}

.py-61 {
  padding-top: 30rem !important;
  padding-bottom: 30rem !important;
}

.py-62 {
  padding-top: 30.5rem !important;
  padding-bottom: 30.5rem !important;
}

.py-63 {
  padding-top: 31rem !important;
  padding-bottom: 31rem !important;
}

.py-64 {
  padding-top: 31.5rem !important;
  padding-bottom: 31.5rem !important;
}

.py-65 {
  padding-top: 32rem !important;
  padding-bottom: 32rem !important;
}

.py-66 {
  padding-top: 32.5rem !important;
  padding-bottom: 32.5rem !important;
}

.py-67 {
  padding-top: 33rem !important;
  padding-bottom: 33rem !important;
}

.py-68 {
  padding-top: 33.5rem !important;
  padding-bottom: 33.5rem !important;
}

.py-69 {
  padding-top: 34rem !important;
  padding-bottom: 34rem !important;
}

.py-70 {
  padding-top: 34.5rem !important;
  padding-bottom: 34.5rem !important;
}

.py-71 {
  padding-top: 35rem !important;
  padding-bottom: 35rem !important;
}

.py-72 {
  padding-top: 35.5rem !important;
  padding-bottom: 35.5rem !important;
}

.py-73 {
  padding-top: 36rem !important;
  padding-bottom: 36rem !important;
}

.py-74 {
  padding-top: 36.5rem !important;
  padding-bottom: 36.5rem !important;
}

.py-75 {
  padding-top: 37rem !important;
  padding-bottom: 37rem !important;
}

.py-76 {
  padding-top: 37.5rem !important;
  padding-bottom: 37.5rem !important;
}

.py-77 {
  padding-top: 38rem !important;
  padding-bottom: 38rem !important;
}

.py-78 {
  padding-top: 38.5rem !important;
  padding-bottom: 38.5rem !important;
}

.py-79 {
  padding-top: 39rem !important;
  padding-bottom: 39rem !important;
}

.py-80 {
  padding-top: 39.5rem !important;
  padding-bottom: 39.5rem !important;
}

.py-81 {
  padding-top: 40rem !important;
  padding-bottom: 40rem !important;
}

.py-82 {
  padding-top: 40.5rem !important;
  padding-bottom: 40.5rem !important;
}

.py-83 {
  padding-top: 41rem !important;
  padding-bottom: 41rem !important;
}

.py-84 {
  padding-top: 41.5rem !important;
  padding-bottom: 41.5rem !important;
}

.py-85 {
  padding-top: 42rem !important;
  padding-bottom: 42rem !important;
}

.py-86 {
  padding-top: 42.5rem !important;
  padding-bottom: 42.5rem !important;
}

.py-87 {
  padding-top: 43rem !important;
  padding-bottom: 43rem !important;
}

.py-88 {
  padding-top: 43.5rem !important;
  padding-bottom: 43.5rem !important;
}

.py-89 {
  padding-top: 44rem !important;
  padding-bottom: 44rem !important;
}

.py-90 {
  padding-top: 44.5rem !important;
  padding-bottom: 44.5rem !important;
}

.py-91 {
  padding-top: 45rem !important;
  padding-bottom: 45rem !important;
}

.py-92 {
  padding-top: 45.5rem !important;
  padding-bottom: 45.5rem !important;
}

.py-93 {
  padding-top: 46rem !important;
  padding-bottom: 46rem !important;
}

.py-94 {
  padding-top: 46.5rem !important;
  padding-bottom: 46.5rem !important;
}

.py-95 {
  padding-top: 47rem !important;
  padding-bottom: 47rem !important;
}

.py-96 {
  padding-top: 47.5rem !important;
  padding-bottom: 47.5rem !important;
}

.py-97 {
  padding-top: 48rem !important;
  padding-bottom: 48rem !important;
}

.py-98 {
  padding-top: 48.5rem !important;
  padding-bottom: 48.5rem !important;
}

.py-99 {
  padding-top: 49rem !important;
  padding-bottom: 49rem !important;
}

.py-100 {
  padding-top: 49.5rem !important;
  padding-bottom: 49.5rem !important;
}

.py-101 {
  padding-top: 50rem !important;
  padding-bottom: 50rem !important;
}

.py-102 {
  padding-top: 50.5rem !important;
  padding-bottom: 50.5rem !important;
}

.py-103 {
  padding-top: 51rem !important;
  padding-bottom: 51rem !important;
}

.py-104 {
  padding-top: 51.5rem !important;
  padding-bottom: 51.5rem !important;
}

.py-105 {
  padding-top: 52rem !important;
  padding-bottom: 52rem !important;
}

.py-106 {
  padding-top: 52.5rem !important;
  padding-bottom: 52.5rem !important;
}

.py-107 {
  padding-top: 53rem !important;
  padding-bottom: 53rem !important;
}

.py-108 {
  padding-top: 53.5rem !important;
  padding-bottom: 53.5rem !important;
}

.py-109 {
  padding-top: 54rem !important;
  padding-bottom: 54rem !important;
}

.py-110 {
  padding-top: 54.5rem !important;
  padding-bottom: 54.5rem !important;
}

.py-111 {
  padding-top: 55rem !important;
  padding-bottom: 55rem !important;
}

.py-112 {
  padding-top: 55.5rem !important;
  padding-bottom: 55.5rem !important;
}

.py-113 {
  padding-top: 56rem !important;
  padding-bottom: 56rem !important;
}

.py-114 {
  padding-top: 56.5rem !important;
  padding-bottom: 56.5rem !important;
}

.py-115 {
  padding-top: 57rem !important;
  padding-bottom: 57rem !important;
}

.py-116 {
  padding-top: 57.5rem !important;
  padding-bottom: 57.5rem !important;
}

.py-117 {
  padding-top: 58rem !important;
  padding-bottom: 58rem !important;
}

.py-118 {
  padding-top: 58.5rem !important;
  padding-bottom: 58.5rem !important;
}

.py-119 {
  padding-top: 59rem !important;
  padding-bottom: 59rem !important;
}

.py-120 {
  padding-top: 59.5rem !important;
  padding-bottom: 59.5rem !important;
}

.py-121 {
  padding-top: 60rem !important;
  padding-bottom: 60rem !important;
}

.py-122 {
  padding-top: 60.5rem !important;
  padding-bottom: 60.5rem !important;
}

.py-123 {
  padding-top: 61rem !important;
  padding-bottom: 61rem !important;
}

.py-124 {
  padding-top: 61.5rem !important;
  padding-bottom: 61.5rem !important;
}

.py-125 {
  padding-top: 62rem !important;
  padding-bottom: 62rem !important;
}

.py-126 {
  padding-top: 62.5rem !important;
  padding-bottom: 62.5rem !important;
}

.py-127 {
  padding-top: 63rem !important;
  padding-bottom: 63rem !important;
}

.py-128 {
  padding-top: 63.5rem !important;
  padding-bottom: 63.5rem !important;
}

.py-129 {
  padding-top: 64rem !important;
  padding-bottom: 64rem !important;
}

.py-130 {
  padding-top: 64.5rem !important;
  padding-bottom: 64.5rem !important;
}

.py-131 {
  padding-top: 65rem !important;
  padding-bottom: 65rem !important;
}

.py-132 {
  padding-top: 65.5rem !important;
  padding-bottom: 65.5rem !important;
}

.py-133 {
  padding-top: 66rem !important;
  padding-bottom: 66rem !important;
}

.py-134 {
  padding-top: 66.5rem !important;
  padding-bottom: 66.5rem !important;
}

.py-135 {
  padding-top: 67rem !important;
  padding-bottom: 67rem !important;
}

.py-136 {
  padding-top: 67.5rem !important;
  padding-bottom: 67.5rem !important;
}

.py-137 {
  padding-top: 68rem !important;
  padding-bottom: 68rem !important;
}

.py-138 {
  padding-top: 68.5rem !important;
  padding-bottom: 68.5rem !important;
}

.py-139 {
  padding-top: 69rem !important;
  padding-bottom: 69rem !important;
}

.py-140 {
  padding-top: 69.5rem !important;
  padding-bottom: 69.5rem !important;
}

.py-141 {
  padding-top: 70rem !important;
  padding-bottom: 70rem !important;
}

.py-142 {
  padding-top: 70.5rem !important;
  padding-bottom: 70.5rem !important;
}

.py-143 {
  padding-top: 71rem !important;
  padding-bottom: 71rem !important;
}

.py-144 {
  padding-top: 71.5rem !important;
  padding-bottom: 71.5rem !important;
}

.py-145 {
  padding-top: 72rem !important;
  padding-bottom: 72rem !important;
}

.py-146 {
  padding-top: 72.5rem !important;
  padding-bottom: 72.5rem !important;
}

.py-147 {
  padding-top: 73rem !important;
  padding-bottom: 73rem !important;
}

.py-148 {
  padding-top: 73.5rem !important;
  padding-bottom: 73.5rem !important;
}

.py-149 {
  padding-top: 74rem !important;
  padding-bottom: 74rem !important;
}

.py-150 {
  padding-top: 74.5rem !important;
  padding-bottom: 74.5rem !important;
}

.py-151 {
  padding-top: 75rem !important;
  padding-bottom: 75rem !important;
}

.py-152 {
  padding-top: 75.5rem !important;
  padding-bottom: 75.5rem !important;
}

.py-153 {
  padding-top: 76rem !important;
  padding-bottom: 76rem !important;
}

.py-154 {
  padding-top: 76.5rem !important;
  padding-bottom: 76.5rem !important;
}

.py-155 {
  padding-top: 77rem !important;
  padding-bottom: 77rem !important;
}

.py-156 {
  padding-top: 77.5rem !important;
  padding-bottom: 77.5rem !important;
}

.py-157 {
  padding-top: 78rem !important;
  padding-bottom: 78rem !important;
}

.py-158 {
  padding-top: 78.5rem !important;
  padding-bottom: 78.5rem !important;
}

.py-159 {
  padding-top: 79rem !important;
  padding-bottom: 79rem !important;
}

.py-160 {
  padding-top: 79.5rem !important;
  padding-bottom: 79.5rem !important;
}

@media (min-width: 576px) {
  .p-sm-0 {
    padding: 0rem !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 2rem !important;
  }

  .p-sm-6 {
    padding: 2.5rem !important;
  }

  .p-sm-7 {
    padding: 3rem !important;
  }

  .p-sm-8 {
    padding: 3.5rem !important;
  }

  .p-sm-9 {
    padding: 4rem !important;
  }

  .p-sm-10 {
    padding: 4.5rem !important;
  }

  .p-sm-11 {
    padding: 5rem !important;
  }

  .p-sm-12 {
    padding: 5.5rem !important;
  }

  .p-sm-13 {
    padding: 6rem !important;
  }

  .p-sm-14 {
    padding: 6.5rem !important;
  }

  .p-sm-15 {
    padding: 7rem !important;
  }

  .p-sm-16 {
    padding: 7.5rem !important;
  }

  .p-sm-17 {
    padding: 8rem !important;
  }

  .p-sm-18 {
    padding: 8.5rem !important;
  }

  .p-sm-19 {
    padding: 9rem !important;
  }

  .p-sm-20 {
    padding: 9.5rem !important;
  }

  .p-sm-21 {
    padding: 10rem !important;
  }

  .p-sm-22 {
    padding: 10.5rem !important;
  }

  .p-sm-23 {
    padding: 11rem !important;
  }

  .p-sm-24 {
    padding: 11.5rem !important;
  }

  .p-sm-25 {
    padding: 12rem !important;
  }

  .p-sm-26 {
    padding: 12.5rem !important;
  }

  .p-sm-27 {
    padding: 13rem !important;
  }

  .p-sm-28 {
    padding: 13.5rem !important;
  }

  .p-sm-29 {
    padding: 14rem !important;
  }

  .p-sm-30 {
    padding: 14.5rem !important;
  }

  .p-sm-31 {
    padding: 15rem !important;
  }

  .p-sm-32 {
    padding: 15.5rem !important;
  }

  .p-sm-33 {
    padding: 16rem !important;
  }

  .p-sm-34 {
    padding: 16.5rem !important;
  }

  .p-sm-35 {
    padding: 17rem !important;
  }

  .p-sm-36 {
    padding: 17.5rem !important;
  }

  .p-sm-37 {
    padding: 18rem !important;
  }

  .p-sm-38 {
    padding: 18.5rem !important;
  }

  .p-sm-39 {
    padding: 19rem !important;
  }

  .p-sm-40 {
    padding: 19.5rem !important;
  }

  .p-sm-41 {
    padding: 20rem !important;
  }

  .p-sm-42 {
    padding: 20.5rem !important;
  }

  .p-sm-43 {
    padding: 21rem !important;
  }

  .p-sm-44 {
    padding: 21.5rem !important;
  }

  .p-sm-45 {
    padding: 22rem !important;
  }

  .p-sm-46 {
    padding: 22.5rem !important;
  }

  .p-sm-47 {
    padding: 23rem !important;
  }

  .p-sm-48 {
    padding: 23.5rem !important;
  }

  .p-sm-49 {
    padding: 24rem !important;
  }

  .p-sm-50 {
    padding: 24.5rem !important;
  }

  .p-sm-51 {
    padding: 25rem !important;
  }

  .p-sm-52 {
    padding: 25.5rem !important;
  }

  .p-sm-53 {
    padding: 26rem !important;
  }

  .p-sm-54 {
    padding: 26.5rem !important;
  }

  .p-sm-55 {
    padding: 27rem !important;
  }

  .p-sm-56 {
    padding: 27.5rem !important;
  }

  .p-sm-57 {
    padding: 28rem !important;
  }

  .p-sm-58 {
    padding: 28.5rem !important;
  }

  .p-sm-59 {
    padding: 29rem !important;
  }

  .p-sm-60 {
    padding: 29.5rem !important;
  }

  .p-sm-61 {
    padding: 30rem !important;
  }

  .p-sm-62 {
    padding: 30.5rem !important;
  }

  .p-sm-63 {
    padding: 31rem !important;
  }

  .p-sm-64 {
    padding: 31.5rem !important;
  }

  .p-sm-65 {
    padding: 32rem !important;
  }

  .p-sm-66 {
    padding: 32.5rem !important;
  }

  .p-sm-67 {
    padding: 33rem !important;
  }

  .p-sm-68 {
    padding: 33.5rem !important;
  }

  .p-sm-69 {
    padding: 34rem !important;
  }

  .p-sm-70 {
    padding: 34.5rem !important;
  }

  .p-sm-71 {
    padding: 35rem !important;
  }

  .p-sm-72 {
    padding: 35.5rem !important;
  }

  .p-sm-73 {
    padding: 36rem !important;
  }

  .p-sm-74 {
    padding: 36.5rem !important;
  }

  .p-sm-75 {
    padding: 37rem !important;
  }

  .p-sm-76 {
    padding: 37.5rem !important;
  }

  .p-sm-77 {
    padding: 38rem !important;
  }

  .p-sm-78 {
    padding: 38.5rem !important;
  }

  .p-sm-79 {
    padding: 39rem !important;
  }

  .p-sm-80 {
    padding: 39.5rem !important;
  }

  .p-sm-81 {
    padding: 40rem !important;
  }

  .p-sm-82 {
    padding: 40.5rem !important;
  }

  .p-sm-83 {
    padding: 41rem !important;
  }

  .p-sm-84 {
    padding: 41.5rem !important;
  }

  .p-sm-85 {
    padding: 42rem !important;
  }

  .p-sm-86 {
    padding: 42.5rem !important;
  }

  .p-sm-87 {
    padding: 43rem !important;
  }

  .p-sm-88 {
    padding: 43.5rem !important;
  }

  .p-sm-89 {
    padding: 44rem !important;
  }

  .p-sm-90 {
    padding: 44.5rem !important;
  }

  .p-sm-91 {
    padding: 45rem !important;
  }

  .p-sm-92 {
    padding: 45.5rem !important;
  }

  .p-sm-93 {
    padding: 46rem !important;
  }

  .p-sm-94 {
    padding: 46.5rem !important;
  }

  .p-sm-95 {
    padding: 47rem !important;
  }

  .p-sm-96 {
    padding: 47.5rem !important;
  }

  .p-sm-97 {
    padding: 48rem !important;
  }

  .p-sm-98 {
    padding: 48.5rem !important;
  }

  .p-sm-99 {
    padding: 49rem !important;
  }

  .p-sm-100 {
    padding: 49.5rem !important;
  }

  .p-sm-101 {
    padding: 50rem !important;
  }

  .p-sm-102 {
    padding: 50.5rem !important;
  }

  .p-sm-103 {
    padding: 51rem !important;
  }

  .p-sm-104 {
    padding: 51.5rem !important;
  }

  .p-sm-105 {
    padding: 52rem !important;
  }

  .p-sm-106 {
    padding: 52.5rem !important;
  }

  .p-sm-107 {
    padding: 53rem !important;
  }

  .p-sm-108 {
    padding: 53.5rem !important;
  }

  .p-sm-109 {
    padding: 54rem !important;
  }

  .p-sm-110 {
    padding: 54.5rem !important;
  }

  .p-sm-111 {
    padding: 55rem !important;
  }

  .p-sm-112 {
    padding: 55.5rem !important;
  }

  .p-sm-113 {
    padding: 56rem !important;
  }

  .p-sm-114 {
    padding: 56.5rem !important;
  }

  .p-sm-115 {
    padding: 57rem !important;
  }

  .p-sm-116 {
    padding: 57.5rem !important;
  }

  .p-sm-117 {
    padding: 58rem !important;
  }

  .p-sm-118 {
    padding: 58.5rem !important;
  }

  .p-sm-119 {
    padding: 59rem !important;
  }

  .p-sm-120 {
    padding: 59.5rem !important;
  }

  .p-sm-121 {
    padding: 60rem !important;
  }

  .p-sm-122 {
    padding: 60.5rem !important;
  }

  .p-sm-123 {
    padding: 61rem !important;
  }

  .p-sm-124 {
    padding: 61.5rem !important;
  }

  .p-sm-125 {
    padding: 62rem !important;
  }

  .p-sm-126 {
    padding: 62.5rem !important;
  }

  .p-sm-127 {
    padding: 63rem !important;
  }

  .p-sm-128 {
    padding: 63.5rem !important;
  }

  .p-sm-129 {
    padding: 64rem !important;
  }

  .p-sm-130 {
    padding: 64.5rem !important;
  }

  .p-sm-131 {
    padding: 65rem !important;
  }

  .p-sm-132 {
    padding: 65.5rem !important;
  }

  .p-sm-133 {
    padding: 66rem !important;
  }

  .p-sm-134 {
    padding: 66.5rem !important;
  }

  .p-sm-135 {
    padding: 67rem !important;
  }

  .p-sm-136 {
    padding: 67.5rem !important;
  }

  .p-sm-137 {
    padding: 68rem !important;
  }

  .p-sm-138 {
    padding: 68.5rem !important;
  }

  .p-sm-139 {
    padding: 69rem !important;
  }

  .p-sm-140 {
    padding: 69.5rem !important;
  }

  .p-sm-141 {
    padding: 70rem !important;
  }

  .p-sm-142 {
    padding: 70.5rem !important;
  }

  .p-sm-143 {
    padding: 71rem !important;
  }

  .p-sm-144 {
    padding: 71.5rem !important;
  }

  .p-sm-145 {
    padding: 72rem !important;
  }

  .p-sm-146 {
    padding: 72.5rem !important;
  }

  .p-sm-147 {
    padding: 73rem !important;
  }

  .p-sm-148 {
    padding: 73.5rem !important;
  }

  .p-sm-149 {
    padding: 74rem !important;
  }

  .p-sm-150 {
    padding: 74.5rem !important;
  }

  .p-sm-151 {
    padding: 75rem !important;
  }

  .p-sm-152 {
    padding: 75.5rem !important;
  }

  .p-sm-153 {
    padding: 76rem !important;
  }

  .p-sm-154 {
    padding: 76.5rem !important;
  }

  .p-sm-155 {
    padding: 77rem !important;
  }

  .p-sm-156 {
    padding: 77.5rem !important;
  }

  .p-sm-157 {
    padding: 78rem !important;
  }

  .p-sm-158 {
    padding: 78.5rem !important;
  }

  .p-sm-159 {
    padding: 79rem !important;
  }

  .p-sm-160 {
    padding: 79.5rem !important;
  }

  .pt-sm-0 {
    padding-top: 0rem !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 1rem !important;
  }

  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-5 {
    padding-top: 2rem !important;
  }

  .pt-sm-6 {
    padding-top: 2.5rem !important;
  }

  .pt-sm-7 {
    padding-top: 3rem !important;
  }

  .pt-sm-8 {
    padding-top: 3.5rem !important;
  }

  .pt-sm-9 {
    padding-top: 4rem !important;
  }

  .pt-sm-10 {
    padding-top: 4.5rem !important;
  }

  .pt-sm-11 {
    padding-top: 5rem !important;
  }

  .pt-sm-12 {
    padding-top: 5.5rem !important;
  }

  .pt-sm-13 {
    padding-top: 6rem !important;
  }

  .pt-sm-14 {
    padding-top: 6.5rem !important;
  }

  .pt-sm-15 {
    padding-top: 7rem !important;
  }

  .pt-sm-16 {
    padding-top: 7.5rem !important;
  }

  .pt-sm-17 {
    padding-top: 8rem !important;
  }

  .pt-sm-18 {
    padding-top: 8.5rem !important;
  }

  .pt-sm-19 {
    padding-top: 9rem !important;
  }

  .pt-sm-20 {
    padding-top: 9.5rem !important;
  }

  .pt-sm-21 {
    padding-top: 10rem !important;
  }

  .pt-sm-22 {
    padding-top: 10.5rem !important;
  }

  .pt-sm-23 {
    padding-top: 11rem !important;
  }

  .pt-sm-24 {
    padding-top: 11.5rem !important;
  }

  .pt-sm-25 {
    padding-top: 12rem !important;
  }

  .pt-sm-26 {
    padding-top: 12.5rem !important;
  }

  .pt-sm-27 {
    padding-top: 13rem !important;
  }

  .pt-sm-28 {
    padding-top: 13.5rem !important;
  }

  .pt-sm-29 {
    padding-top: 14rem !important;
  }

  .pt-sm-30 {
    padding-top: 14.5rem !important;
  }

  .pt-sm-31 {
    padding-top: 15rem !important;
  }

  .pt-sm-32 {
    padding-top: 15.5rem !important;
  }

  .pt-sm-33 {
    padding-top: 16rem !important;
  }

  .pt-sm-34 {
    padding-top: 16.5rem !important;
  }

  .pt-sm-35 {
    padding-top: 17rem !important;
  }

  .pt-sm-36 {
    padding-top: 17.5rem !important;
  }

  .pt-sm-37 {
    padding-top: 18rem !important;
  }

  .pt-sm-38 {
    padding-top: 18.5rem !important;
  }

  .pt-sm-39 {
    padding-top: 19rem !important;
  }

  .pt-sm-40 {
    padding-top: 19.5rem !important;
  }

  .pt-sm-41 {
    padding-top: 20rem !important;
  }

  .pt-sm-42 {
    padding-top: 20.5rem !important;
  }

  .pt-sm-43 {
    padding-top: 21rem !important;
  }

  .pt-sm-44 {
    padding-top: 21.5rem !important;
  }

  .pt-sm-45 {
    padding-top: 22rem !important;
  }

  .pt-sm-46 {
    padding-top: 22.5rem !important;
  }

  .pt-sm-47 {
    padding-top: 23rem !important;
  }

  .pt-sm-48 {
    padding-top: 23.5rem !important;
  }

  .pt-sm-49 {
    padding-top: 24rem !important;
  }

  .pt-sm-50 {
    padding-top: 24.5rem !important;
  }

  .pt-sm-51 {
    padding-top: 25rem !important;
  }

  .pt-sm-52 {
    padding-top: 25.5rem !important;
  }

  .pt-sm-53 {
    padding-top: 26rem !important;
  }

  .pt-sm-54 {
    padding-top: 26.5rem !important;
  }

  .pt-sm-55 {
    padding-top: 27rem !important;
  }

  .pt-sm-56 {
    padding-top: 27.5rem !important;
  }

  .pt-sm-57 {
    padding-top: 28rem !important;
  }

  .pt-sm-58 {
    padding-top: 28.5rem !important;
  }

  .pt-sm-59 {
    padding-top: 29rem !important;
  }

  .pt-sm-60 {
    padding-top: 29.5rem !important;
  }

  .pt-sm-61 {
    padding-top: 30rem !important;
  }

  .pt-sm-62 {
    padding-top: 30.5rem !important;
  }

  .pt-sm-63 {
    padding-top: 31rem !important;
  }

  .pt-sm-64 {
    padding-top: 31.5rem !important;
  }

  .pt-sm-65 {
    padding-top: 32rem !important;
  }

  .pt-sm-66 {
    padding-top: 32.5rem !important;
  }

  .pt-sm-67 {
    padding-top: 33rem !important;
  }

  .pt-sm-68 {
    padding-top: 33.5rem !important;
  }

  .pt-sm-69 {
    padding-top: 34rem !important;
  }

  .pt-sm-70 {
    padding-top: 34.5rem !important;
  }

  .pt-sm-71 {
    padding-top: 35rem !important;
  }

  .pt-sm-72 {
    padding-top: 35.5rem !important;
  }

  .pt-sm-73 {
    padding-top: 36rem !important;
  }

  .pt-sm-74 {
    padding-top: 36.5rem !important;
  }

  .pt-sm-75 {
    padding-top: 37rem !important;
  }

  .pt-sm-76 {
    padding-top: 37.5rem !important;
  }

  .pt-sm-77 {
    padding-top: 38rem !important;
  }

  .pt-sm-78 {
    padding-top: 38.5rem !important;
  }

  .pt-sm-79 {
    padding-top: 39rem !important;
  }

  .pt-sm-80 {
    padding-top: 39.5rem !important;
  }

  .pt-sm-81 {
    padding-top: 40rem !important;
  }

  .pt-sm-82 {
    padding-top: 40.5rem !important;
  }

  .pt-sm-83 {
    padding-top: 41rem !important;
  }

  .pt-sm-84 {
    padding-top: 41.5rem !important;
  }

  .pt-sm-85 {
    padding-top: 42rem !important;
  }

  .pt-sm-86 {
    padding-top: 42.5rem !important;
  }

  .pt-sm-87 {
    padding-top: 43rem !important;
  }

  .pt-sm-88 {
    padding-top: 43.5rem !important;
  }

  .pt-sm-89 {
    padding-top: 44rem !important;
  }

  .pt-sm-90 {
    padding-top: 44.5rem !important;
  }

  .pt-sm-91 {
    padding-top: 45rem !important;
  }

  .pt-sm-92 {
    padding-top: 45.5rem !important;
  }

  .pt-sm-93 {
    padding-top: 46rem !important;
  }

  .pt-sm-94 {
    padding-top: 46.5rem !important;
  }

  .pt-sm-95 {
    padding-top: 47rem !important;
  }

  .pt-sm-96 {
    padding-top: 47.5rem !important;
  }

  .pt-sm-97 {
    padding-top: 48rem !important;
  }

  .pt-sm-98 {
    padding-top: 48.5rem !important;
  }

  .pt-sm-99 {
    padding-top: 49rem !important;
  }

  .pt-sm-100 {
    padding-top: 49.5rem !important;
  }

  .pt-sm-101 {
    padding-top: 50rem !important;
  }

  .pt-sm-102 {
    padding-top: 50.5rem !important;
  }

  .pt-sm-103 {
    padding-top: 51rem !important;
  }

  .pt-sm-104 {
    padding-top: 51.5rem !important;
  }

  .pt-sm-105 {
    padding-top: 52rem !important;
  }

  .pt-sm-106 {
    padding-top: 52.5rem !important;
  }

  .pt-sm-107 {
    padding-top: 53rem !important;
  }

  .pt-sm-108 {
    padding-top: 53.5rem !important;
  }

  .pt-sm-109 {
    padding-top: 54rem !important;
  }

  .pt-sm-110 {
    padding-top: 54.5rem !important;
  }

  .pt-sm-111 {
    padding-top: 55rem !important;
  }

  .pt-sm-112 {
    padding-top: 55.5rem !important;
  }

  .pt-sm-113 {
    padding-top: 56rem !important;
  }

  .pt-sm-114 {
    padding-top: 56.5rem !important;
  }

  .pt-sm-115 {
    padding-top: 57rem !important;
  }

  .pt-sm-116 {
    padding-top: 57.5rem !important;
  }

  .pt-sm-117 {
    padding-top: 58rem !important;
  }

  .pt-sm-118 {
    padding-top: 58.5rem !important;
  }

  .pt-sm-119 {
    padding-top: 59rem !important;
  }

  .pt-sm-120 {
    padding-top: 59.5rem !important;
  }

  .pt-sm-121 {
    padding-top: 60rem !important;
  }

  .pt-sm-122 {
    padding-top: 60.5rem !important;
  }

  .pt-sm-123 {
    padding-top: 61rem !important;
  }

  .pt-sm-124 {
    padding-top: 61.5rem !important;
  }

  .pt-sm-125 {
    padding-top: 62rem !important;
  }

  .pt-sm-126 {
    padding-top: 62.5rem !important;
  }

  .pt-sm-127 {
    padding-top: 63rem !important;
  }

  .pt-sm-128 {
    padding-top: 63.5rem !important;
  }

  .pt-sm-129 {
    padding-top: 64rem !important;
  }

  .pt-sm-130 {
    padding-top: 64.5rem !important;
  }

  .pt-sm-131 {
    padding-top: 65rem !important;
  }

  .pt-sm-132 {
    padding-top: 65.5rem !important;
  }

  .pt-sm-133 {
    padding-top: 66rem !important;
  }

  .pt-sm-134 {
    padding-top: 66.5rem !important;
  }

  .pt-sm-135 {
    padding-top: 67rem !important;
  }

  .pt-sm-136 {
    padding-top: 67.5rem !important;
  }

  .pt-sm-137 {
    padding-top: 68rem !important;
  }

  .pt-sm-138 {
    padding-top: 68.5rem !important;
  }

  .pt-sm-139 {
    padding-top: 69rem !important;
  }

  .pt-sm-140 {
    padding-top: 69.5rem !important;
  }

  .pt-sm-141 {
    padding-top: 70rem !important;
  }

  .pt-sm-142 {
    padding-top: 70.5rem !important;
  }

  .pt-sm-143 {
    padding-top: 71rem !important;
  }

  .pt-sm-144 {
    padding-top: 71.5rem !important;
  }

  .pt-sm-145 {
    padding-top: 72rem !important;
  }

  .pt-sm-146 {
    padding-top: 72.5rem !important;
  }

  .pt-sm-147 {
    padding-top: 73rem !important;
  }

  .pt-sm-148 {
    padding-top: 73.5rem !important;
  }

  .pt-sm-149 {
    padding-top: 74rem !important;
  }

  .pt-sm-150 {
    padding-top: 74.5rem !important;
  }

  .pt-sm-151 {
    padding-top: 75rem !important;
  }

  .pt-sm-152 {
    padding-top: 75.5rem !important;
  }

  .pt-sm-153 {
    padding-top: 76rem !important;
  }

  .pt-sm-154 {
    padding-top: 76.5rem !important;
  }

  .pt-sm-155 {
    padding-top: 77rem !important;
  }

  .pt-sm-156 {
    padding-top: 77.5rem !important;
  }

  .pt-sm-157 {
    padding-top: 78rem !important;
  }

  .pt-sm-158 {
    padding-top: 78.5rem !important;
  }

  .pt-sm-159 {
    padding-top: 79rem !important;
  }

  .pt-sm-160 {
    padding-top: 79.5rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0rem !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 2rem !important;
  }

  .pb-sm-6 {
    padding-bottom: 2.5rem !important;
  }

  .pb-sm-7 {
    padding-bottom: 3rem !important;
  }

  .pb-sm-8 {
    padding-bottom: 3.5rem !important;
  }

  .pb-sm-9 {
    padding-bottom: 4rem !important;
  }

  .pb-sm-10 {
    padding-bottom: 4.5rem !important;
  }

  .pb-sm-11 {
    padding-bottom: 5rem !important;
  }

  .pb-sm-12 {
    padding-bottom: 5.5rem !important;
  }

  .pb-sm-13 {
    padding-bottom: 6rem !important;
  }

  .pb-sm-14 {
    padding-bottom: 6.5rem !important;
  }

  .pb-sm-15 {
    padding-bottom: 7rem !important;
  }

  .pb-sm-16 {
    padding-bottom: 7.5rem !important;
  }

  .pb-sm-17 {
    padding-bottom: 8rem !important;
  }

  .pb-sm-18 {
    padding-bottom: 8.5rem !important;
  }

  .pb-sm-19 {
    padding-bottom: 9rem !important;
  }

  .pb-sm-20 {
    padding-bottom: 9.5rem !important;
  }

  .pb-sm-21 {
    padding-bottom: 10rem !important;
  }

  .pb-sm-22 {
    padding-bottom: 10.5rem !important;
  }

  .pb-sm-23 {
    padding-bottom: 11rem !important;
  }

  .pb-sm-24 {
    padding-bottom: 11.5rem !important;
  }

  .pb-sm-25 {
    padding-bottom: 12rem !important;
  }

  .pb-sm-26 {
    padding-bottom: 12.5rem !important;
  }

  .pb-sm-27 {
    padding-bottom: 13rem !important;
  }

  .pb-sm-28 {
    padding-bottom: 13.5rem !important;
  }

  .pb-sm-29 {
    padding-bottom: 14rem !important;
  }

  .pb-sm-30 {
    padding-bottom: 14.5rem !important;
  }

  .pb-sm-31 {
    padding-bottom: 15rem !important;
  }

  .pb-sm-32 {
    padding-bottom: 15.5rem !important;
  }

  .pb-sm-33 {
    padding-bottom: 16rem !important;
  }

  .pb-sm-34 {
    padding-bottom: 16.5rem !important;
  }

  .pb-sm-35 {
    padding-bottom: 17rem !important;
  }

  .pb-sm-36 {
    padding-bottom: 17.5rem !important;
  }

  .pb-sm-37 {
    padding-bottom: 18rem !important;
  }

  .pb-sm-38 {
    padding-bottom: 18.5rem !important;
  }

  .pb-sm-39 {
    padding-bottom: 19rem !important;
  }

  .pb-sm-40 {
    padding-bottom: 19.5rem !important;
  }

  .pb-sm-41 {
    padding-bottom: 20rem !important;
  }

  .pb-sm-42 {
    padding-bottom: 20.5rem !important;
  }

  .pb-sm-43 {
    padding-bottom: 21rem !important;
  }

  .pb-sm-44 {
    padding-bottom: 21.5rem !important;
  }

  .pb-sm-45 {
    padding-bottom: 22rem !important;
  }

  .pb-sm-46 {
    padding-bottom: 22.5rem !important;
  }

  .pb-sm-47 {
    padding-bottom: 23rem !important;
  }

  .pb-sm-48 {
    padding-bottom: 23.5rem !important;
  }

  .pb-sm-49 {
    padding-bottom: 24rem !important;
  }

  .pb-sm-50 {
    padding-bottom: 24.5rem !important;
  }

  .pb-sm-51 {
    padding-bottom: 25rem !important;
  }

  .pb-sm-52 {
    padding-bottom: 25.5rem !important;
  }

  .pb-sm-53 {
    padding-bottom: 26rem !important;
  }

  .pb-sm-54 {
    padding-bottom: 26.5rem !important;
  }

  .pb-sm-55 {
    padding-bottom: 27rem !important;
  }

  .pb-sm-56 {
    padding-bottom: 27.5rem !important;
  }

  .pb-sm-57 {
    padding-bottom: 28rem !important;
  }

  .pb-sm-58 {
    padding-bottom: 28.5rem !important;
  }

  .pb-sm-59 {
    padding-bottom: 29rem !important;
  }

  .pb-sm-60 {
    padding-bottom: 29.5rem !important;
  }

  .pb-sm-61 {
    padding-bottom: 30rem !important;
  }

  .pb-sm-62 {
    padding-bottom: 30.5rem !important;
  }

  .pb-sm-63 {
    padding-bottom: 31rem !important;
  }

  .pb-sm-64 {
    padding-bottom: 31.5rem !important;
  }

  .pb-sm-65 {
    padding-bottom: 32rem !important;
  }

  .pb-sm-66 {
    padding-bottom: 32.5rem !important;
  }

  .pb-sm-67 {
    padding-bottom: 33rem !important;
  }

  .pb-sm-68 {
    padding-bottom: 33.5rem !important;
  }

  .pb-sm-69 {
    padding-bottom: 34rem !important;
  }

  .pb-sm-70 {
    padding-bottom: 34.5rem !important;
  }

  .pb-sm-71 {
    padding-bottom: 35rem !important;
  }

  .pb-sm-72 {
    padding-bottom: 35.5rem !important;
  }

  .pb-sm-73 {
    padding-bottom: 36rem !important;
  }

  .pb-sm-74 {
    padding-bottom: 36.5rem !important;
  }

  .pb-sm-75 {
    padding-bottom: 37rem !important;
  }

  .pb-sm-76 {
    padding-bottom: 37.5rem !important;
  }

  .pb-sm-77 {
    padding-bottom: 38rem !important;
  }

  .pb-sm-78 {
    padding-bottom: 38.5rem !important;
  }

  .pb-sm-79 {
    padding-bottom: 39rem !important;
  }

  .pb-sm-80 {
    padding-bottom: 39.5rem !important;
  }

  .pb-sm-81 {
    padding-bottom: 40rem !important;
  }

  .pb-sm-82 {
    padding-bottom: 40.5rem !important;
  }

  .pb-sm-83 {
    padding-bottom: 41rem !important;
  }

  .pb-sm-84 {
    padding-bottom: 41.5rem !important;
  }

  .pb-sm-85 {
    padding-bottom: 42rem !important;
  }

  .pb-sm-86 {
    padding-bottom: 42.5rem !important;
  }

  .pb-sm-87 {
    padding-bottom: 43rem !important;
  }

  .pb-sm-88 {
    padding-bottom: 43.5rem !important;
  }

  .pb-sm-89 {
    padding-bottom: 44rem !important;
  }

  .pb-sm-90 {
    padding-bottom: 44.5rem !important;
  }

  .pb-sm-91 {
    padding-bottom: 45rem !important;
  }

  .pb-sm-92 {
    padding-bottom: 45.5rem !important;
  }

  .pb-sm-93 {
    padding-bottom: 46rem !important;
  }

  .pb-sm-94 {
    padding-bottom: 46.5rem !important;
  }

  .pb-sm-95 {
    padding-bottom: 47rem !important;
  }

  .pb-sm-96 {
    padding-bottom: 47.5rem !important;
  }

  .pb-sm-97 {
    padding-bottom: 48rem !important;
  }

  .pb-sm-98 {
    padding-bottom: 48.5rem !important;
  }

  .pb-sm-99 {
    padding-bottom: 49rem !important;
  }

  .pb-sm-100 {
    padding-bottom: 49.5rem !important;
  }

  .pb-sm-101 {
    padding-bottom: 50rem !important;
  }

  .pb-sm-102 {
    padding-bottom: 50.5rem !important;
  }

  .pb-sm-103 {
    padding-bottom: 51rem !important;
  }

  .pb-sm-104 {
    padding-bottom: 51.5rem !important;
  }

  .pb-sm-105 {
    padding-bottom: 52rem !important;
  }

  .pb-sm-106 {
    padding-bottom: 52.5rem !important;
  }

  .pb-sm-107 {
    padding-bottom: 53rem !important;
  }

  .pb-sm-108 {
    padding-bottom: 53.5rem !important;
  }

  .pb-sm-109 {
    padding-bottom: 54rem !important;
  }

  .pb-sm-110 {
    padding-bottom: 54.5rem !important;
  }

  .pb-sm-111 {
    padding-bottom: 55rem !important;
  }

  .pb-sm-112 {
    padding-bottom: 55.5rem !important;
  }

  .pb-sm-113 {
    padding-bottom: 56rem !important;
  }

  .pb-sm-114 {
    padding-bottom: 56.5rem !important;
  }

  .pb-sm-115 {
    padding-bottom: 57rem !important;
  }

  .pb-sm-116 {
    padding-bottom: 57.5rem !important;
  }

  .pb-sm-117 {
    padding-bottom: 58rem !important;
  }

  .pb-sm-118 {
    padding-bottom: 58.5rem !important;
  }

  .pb-sm-119 {
    padding-bottom: 59rem !important;
  }

  .pb-sm-120 {
    padding-bottom: 59.5rem !important;
  }

  .pb-sm-121 {
    padding-bottom: 60rem !important;
  }

  .pb-sm-122 {
    padding-bottom: 60.5rem !important;
  }

  .pb-sm-123 {
    padding-bottom: 61rem !important;
  }

  .pb-sm-124 {
    padding-bottom: 61.5rem !important;
  }

  .pb-sm-125 {
    padding-bottom: 62rem !important;
  }

  .pb-sm-126 {
    padding-bottom: 62.5rem !important;
  }

  .pb-sm-127 {
    padding-bottom: 63rem !important;
  }

  .pb-sm-128 {
    padding-bottom: 63.5rem !important;
  }

  .pb-sm-129 {
    padding-bottom: 64rem !important;
  }

  .pb-sm-130 {
    padding-bottom: 64.5rem !important;
  }

  .pb-sm-131 {
    padding-bottom: 65rem !important;
  }

  .pb-sm-132 {
    padding-bottom: 65.5rem !important;
  }

  .pb-sm-133 {
    padding-bottom: 66rem !important;
  }

  .pb-sm-134 {
    padding-bottom: 66.5rem !important;
  }

  .pb-sm-135 {
    padding-bottom: 67rem !important;
  }

  .pb-sm-136 {
    padding-bottom: 67.5rem !important;
  }

  .pb-sm-137 {
    padding-bottom: 68rem !important;
  }

  .pb-sm-138 {
    padding-bottom: 68.5rem !important;
  }

  .pb-sm-139 {
    padding-bottom: 69rem !important;
  }

  .pb-sm-140 {
    padding-bottom: 69.5rem !important;
  }

  .pb-sm-141 {
    padding-bottom: 70rem !important;
  }

  .pb-sm-142 {
    padding-bottom: 70.5rem !important;
  }

  .pb-sm-143 {
    padding-bottom: 71rem !important;
  }

  .pb-sm-144 {
    padding-bottom: 71.5rem !important;
  }

  .pb-sm-145 {
    padding-bottom: 72rem !important;
  }

  .pb-sm-146 {
    padding-bottom: 72.5rem !important;
  }

  .pb-sm-147 {
    padding-bottom: 73rem !important;
  }

  .pb-sm-148 {
    padding-bottom: 73.5rem !important;
  }

  .pb-sm-149 {
    padding-bottom: 74rem !important;
  }

  .pb-sm-150 {
    padding-bottom: 74.5rem !important;
  }

  .pb-sm-151 {
    padding-bottom: 75rem !important;
  }

  .pb-sm-152 {
    padding-bottom: 75.5rem !important;
  }

  .pb-sm-153 {
    padding-bottom: 76rem !important;
  }

  .pb-sm-154 {
    padding-bottom: 76.5rem !important;
  }

  .pb-sm-155 {
    padding-bottom: 77rem !important;
  }

  .pb-sm-156 {
    padding-bottom: 77.5rem !important;
  }

  .pb-sm-157 {
    padding-bottom: 78rem !important;
  }

  .pb-sm-158 {
    padding-bottom: 78.5rem !important;
  }

  .pb-sm-159 {
    padding-bottom: 79rem !important;
  }

  .pb-sm-160 {
    padding-bottom: 79.5rem !important;
  }

  .ps-sm-0 {
    padding-left: 0rem !important;
  }

  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  .ps-sm-3 {
    padding-left: 1rem !important;
  }

  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }

  .ps-sm-5 {
    padding-left: 2rem !important;
  }

  .ps-sm-6 {
    padding-left: 2.5rem !important;
  }

  .ps-sm-7 {
    padding-left: 3rem !important;
  }

  .ps-sm-8 {
    padding-left: 3.5rem !important;
  }

  .ps-sm-9 {
    padding-left: 4rem !important;
  }

  .ps-sm-10 {
    padding-left: 4.5rem !important;
  }

  .ps-sm-11 {
    padding-left: 5rem !important;
  }

  .ps-sm-12 {
    padding-left: 5.5rem !important;
  }

  .ps-sm-13 {
    padding-left: 6rem !important;
  }

  .ps-sm-14 {
    padding-left: 6.5rem !important;
  }

  .ps-sm-15 {
    padding-left: 7rem !important;
  }

  .ps-sm-16 {
    padding-left: 7.5rem !important;
  }

  .ps-sm-17 {
    padding-left: 8rem !important;
  }

  .ps-sm-18 {
    padding-left: 8.5rem !important;
  }

  .ps-sm-19 {
    padding-left: 9rem !important;
  }

  .ps-sm-20 {
    padding-left: 9.5rem !important;
  }

  .ps-sm-21 {
    padding-left: 10rem !important;
  }

  .ps-sm-22 {
    padding-left: 10.5rem !important;
  }

  .ps-sm-23 {
    padding-left: 11rem !important;
  }

  .ps-sm-24 {
    padding-left: 11.5rem !important;
  }

  .ps-sm-25 {
    padding-left: 12rem !important;
  }

  .ps-sm-26 {
    padding-left: 12.5rem !important;
  }

  .ps-sm-27 {
    padding-left: 13rem !important;
  }

  .ps-sm-28 {
    padding-left: 13.5rem !important;
  }

  .ps-sm-29 {
    padding-left: 14rem !important;
  }

  .ps-sm-30 {
    padding-left: 14.5rem !important;
  }

  .ps-sm-31 {
    padding-left: 15rem !important;
  }

  .ps-sm-32 {
    padding-left: 15.5rem !important;
  }

  .ps-sm-33 {
    padding-left: 16rem !important;
  }

  .ps-sm-34 {
    padding-left: 16.5rem !important;
  }

  .ps-sm-35 {
    padding-left: 17rem !important;
  }

  .ps-sm-36 {
    padding-left: 17.5rem !important;
  }

  .ps-sm-37 {
    padding-left: 18rem !important;
  }

  .ps-sm-38 {
    padding-left: 18.5rem !important;
  }

  .ps-sm-39 {
    padding-left: 19rem !important;
  }

  .ps-sm-40 {
    padding-left: 19.5rem !important;
  }

  .ps-sm-41 {
    padding-left: 20rem !important;
  }

  .ps-sm-42 {
    padding-left: 20.5rem !important;
  }

  .ps-sm-43 {
    padding-left: 21rem !important;
  }

  .ps-sm-44 {
    padding-left: 21.5rem !important;
  }

  .ps-sm-45 {
    padding-left: 22rem !important;
  }

  .ps-sm-46 {
    padding-left: 22.5rem !important;
  }

  .ps-sm-47 {
    padding-left: 23rem !important;
  }

  .ps-sm-48 {
    padding-left: 23.5rem !important;
  }

  .ps-sm-49 {
    padding-left: 24rem !important;
  }

  .ps-sm-50 {
    padding-left: 24.5rem !important;
  }

  .ps-sm-51 {
    padding-left: 25rem !important;
  }

  .ps-sm-52 {
    padding-left: 25.5rem !important;
  }

  .ps-sm-53 {
    padding-left: 26rem !important;
  }

  .ps-sm-54 {
    padding-left: 26.5rem !important;
  }

  .ps-sm-55 {
    padding-left: 27rem !important;
  }

  .ps-sm-56 {
    padding-left: 27.5rem !important;
  }

  .ps-sm-57 {
    padding-left: 28rem !important;
  }

  .ps-sm-58 {
    padding-left: 28.5rem !important;
  }

  .ps-sm-59 {
    padding-left: 29rem !important;
  }

  .ps-sm-60 {
    padding-left: 29.5rem !important;
  }

  .ps-sm-61 {
    padding-left: 30rem !important;
  }

  .ps-sm-62 {
    padding-left: 30.5rem !important;
  }

  .ps-sm-63 {
    padding-left: 31rem !important;
  }

  .ps-sm-64 {
    padding-left: 31.5rem !important;
  }

  .ps-sm-65 {
    padding-left: 32rem !important;
  }

  .ps-sm-66 {
    padding-left: 32.5rem !important;
  }

  .ps-sm-67 {
    padding-left: 33rem !important;
  }

  .ps-sm-68 {
    padding-left: 33.5rem !important;
  }

  .ps-sm-69 {
    padding-left: 34rem !important;
  }

  .ps-sm-70 {
    padding-left: 34.5rem !important;
  }

  .ps-sm-71 {
    padding-left: 35rem !important;
  }

  .ps-sm-72 {
    padding-left: 35.5rem !important;
  }

  .ps-sm-73 {
    padding-left: 36rem !important;
  }

  .ps-sm-74 {
    padding-left: 36.5rem !important;
  }

  .ps-sm-75 {
    padding-left: 37rem !important;
  }

  .ps-sm-76 {
    padding-left: 37.5rem !important;
  }

  .ps-sm-77 {
    padding-left: 38rem !important;
  }

  .ps-sm-78 {
    padding-left: 38.5rem !important;
  }

  .ps-sm-79 {
    padding-left: 39rem !important;
  }

  .ps-sm-80 {
    padding-left: 39.5rem !important;
  }

  .ps-sm-81 {
    padding-left: 40rem !important;
  }

  .ps-sm-82 {
    padding-left: 40.5rem !important;
  }

  .ps-sm-83 {
    padding-left: 41rem !important;
  }

  .ps-sm-84 {
    padding-left: 41.5rem !important;
  }

  .ps-sm-85 {
    padding-left: 42rem !important;
  }

  .ps-sm-86 {
    padding-left: 42.5rem !important;
  }

  .ps-sm-87 {
    padding-left: 43rem !important;
  }

  .ps-sm-88 {
    padding-left: 43.5rem !important;
  }

  .ps-sm-89 {
    padding-left: 44rem !important;
  }

  .ps-sm-90 {
    padding-left: 44.5rem !important;
  }

  .ps-sm-91 {
    padding-left: 45rem !important;
  }

  .ps-sm-92 {
    padding-left: 45.5rem !important;
  }

  .ps-sm-93 {
    padding-left: 46rem !important;
  }

  .ps-sm-94 {
    padding-left: 46.5rem !important;
  }

  .ps-sm-95 {
    padding-left: 47rem !important;
  }

  .ps-sm-96 {
    padding-left: 47.5rem !important;
  }

  .ps-sm-97 {
    padding-left: 48rem !important;
  }

  .ps-sm-98 {
    padding-left: 48.5rem !important;
  }

  .ps-sm-99 {
    padding-left: 49rem !important;
  }

  .ps-sm-100 {
    padding-left: 49.5rem !important;
  }

  .ps-sm-101 {
    padding-left: 50rem !important;
  }

  .ps-sm-102 {
    padding-left: 50.5rem !important;
  }

  .ps-sm-103 {
    padding-left: 51rem !important;
  }

  .ps-sm-104 {
    padding-left: 51.5rem !important;
  }

  .ps-sm-105 {
    padding-left: 52rem !important;
  }

  .ps-sm-106 {
    padding-left: 52.5rem !important;
  }

  .ps-sm-107 {
    padding-left: 53rem !important;
  }

  .ps-sm-108 {
    padding-left: 53.5rem !important;
  }

  .ps-sm-109 {
    padding-left: 54rem !important;
  }

  .ps-sm-110 {
    padding-left: 54.5rem !important;
  }

  .ps-sm-111 {
    padding-left: 55rem !important;
  }

  .ps-sm-112 {
    padding-left: 55.5rem !important;
  }

  .ps-sm-113 {
    padding-left: 56rem !important;
  }

  .ps-sm-114 {
    padding-left: 56.5rem !important;
  }

  .ps-sm-115 {
    padding-left: 57rem !important;
  }

  .ps-sm-116 {
    padding-left: 57.5rem !important;
  }

  .ps-sm-117 {
    padding-left: 58rem !important;
  }

  .ps-sm-118 {
    padding-left: 58.5rem !important;
  }

  .ps-sm-119 {
    padding-left: 59rem !important;
  }

  .ps-sm-120 {
    padding-left: 59.5rem !important;
  }

  .ps-sm-121 {
    padding-left: 60rem !important;
  }

  .ps-sm-122 {
    padding-left: 60.5rem !important;
  }

  .ps-sm-123 {
    padding-left: 61rem !important;
  }

  .ps-sm-124 {
    padding-left: 61.5rem !important;
  }

  .ps-sm-125 {
    padding-left: 62rem !important;
  }

  .ps-sm-126 {
    padding-left: 62.5rem !important;
  }

  .ps-sm-127 {
    padding-left: 63rem !important;
  }

  .ps-sm-128 {
    padding-left: 63.5rem !important;
  }

  .ps-sm-129 {
    padding-left: 64rem !important;
  }

  .ps-sm-130 {
    padding-left: 64.5rem !important;
  }

  .ps-sm-131 {
    padding-left: 65rem !important;
  }

  .ps-sm-132 {
    padding-left: 65.5rem !important;
  }

  .ps-sm-133 {
    padding-left: 66rem !important;
  }

  .ps-sm-134 {
    padding-left: 66.5rem !important;
  }

  .ps-sm-135 {
    padding-left: 67rem !important;
  }

  .ps-sm-136 {
    padding-left: 67.5rem !important;
  }

  .ps-sm-137 {
    padding-left: 68rem !important;
  }

  .ps-sm-138 {
    padding-left: 68.5rem !important;
  }

  .ps-sm-139 {
    padding-left: 69rem !important;
  }

  .ps-sm-140 {
    padding-left: 69.5rem !important;
  }

  .ps-sm-141 {
    padding-left: 70rem !important;
  }

  .ps-sm-142 {
    padding-left: 70.5rem !important;
  }

  .ps-sm-143 {
    padding-left: 71rem !important;
  }

  .ps-sm-144 {
    padding-left: 71.5rem !important;
  }

  .ps-sm-145 {
    padding-left: 72rem !important;
  }

  .ps-sm-146 {
    padding-left: 72.5rem !important;
  }

  .ps-sm-147 {
    padding-left: 73rem !important;
  }

  .ps-sm-148 {
    padding-left: 73.5rem !important;
  }

  .ps-sm-149 {
    padding-left: 74rem !important;
  }

  .ps-sm-150 {
    padding-left: 74.5rem !important;
  }

  .ps-sm-151 {
    padding-left: 75rem !important;
  }

  .ps-sm-152 {
    padding-left: 75.5rem !important;
  }

  .ps-sm-153 {
    padding-left: 76rem !important;
  }

  .ps-sm-154 {
    padding-left: 76.5rem !important;
  }

  .ps-sm-155 {
    padding-left: 77rem !important;
  }

  .ps-sm-156 {
    padding-left: 77.5rem !important;
  }

  .ps-sm-157 {
    padding-left: 78rem !important;
  }

  .ps-sm-158 {
    padding-left: 78.5rem !important;
  }

  .ps-sm-159 {
    padding-left: 79rem !important;
  }

  .ps-sm-160 {
    padding-left: 79.5rem !important;
  }

  .pe-sm-0 {
    padding-right: 0rem !important;
  }

  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pe-sm-3 {
    padding-right: 1rem !important;
  }

  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }

  .pe-sm-5 {
    padding-right: 2rem !important;
  }

  .pe-sm-6 {
    padding-right: 2.5rem !important;
  }

  .pe-sm-7 {
    padding-right: 3rem !important;
  }

  .pe-sm-8 {
    padding-right: 3.5rem !important;
  }

  .pe-sm-9 {
    padding-right: 4rem !important;
  }

  .pe-sm-10 {
    padding-right: 4.5rem !important;
  }

  .pe-sm-11 {
    padding-right: 5rem !important;
  }

  .pe-sm-12 {
    padding-right: 5.5rem !important;
  }

  .pe-sm-13 {
    padding-right: 6rem !important;
  }

  .pe-sm-14 {
    padding-right: 6.5rem !important;
  }

  .pe-sm-15 {
    padding-right: 7rem !important;
  }

  .pe-sm-16 {
    padding-right: 7.5rem !important;
  }

  .pe-sm-17 {
    padding-right: 8rem !important;
  }

  .pe-sm-18 {
    padding-right: 8.5rem !important;
  }

  .pe-sm-19 {
    padding-right: 9rem !important;
  }

  .pe-sm-20 {
    padding-right: 9.5rem !important;
  }

  .pe-sm-21 {
    padding-right: 10rem !important;
  }

  .pe-sm-22 {
    padding-right: 10.5rem !important;
  }

  .pe-sm-23 {
    padding-right: 11rem !important;
  }

  .pe-sm-24 {
    padding-right: 11.5rem !important;
  }

  .pe-sm-25 {
    padding-right: 12rem !important;
  }

  .pe-sm-26 {
    padding-right: 12.5rem !important;
  }

  .pe-sm-27 {
    padding-right: 13rem !important;
  }

  .pe-sm-28 {
    padding-right: 13.5rem !important;
  }

  .pe-sm-29 {
    padding-right: 14rem !important;
  }

  .pe-sm-30 {
    padding-right: 14.5rem !important;
  }

  .pe-sm-31 {
    padding-right: 15rem !important;
  }

  .pe-sm-32 {
    padding-right: 15.5rem !important;
  }

  .pe-sm-33 {
    padding-right: 16rem !important;
  }

  .pe-sm-34 {
    padding-right: 16.5rem !important;
  }

  .pe-sm-35 {
    padding-right: 17rem !important;
  }

  .pe-sm-36 {
    padding-right: 17.5rem !important;
  }

  .pe-sm-37 {
    padding-right: 18rem !important;
  }

  .pe-sm-38 {
    padding-right: 18.5rem !important;
  }

  .pe-sm-39 {
    padding-right: 19rem !important;
  }

  .pe-sm-40 {
    padding-right: 19.5rem !important;
  }

  .pe-sm-41 {
    padding-right: 20rem !important;
  }

  .pe-sm-42 {
    padding-right: 20.5rem !important;
  }

  .pe-sm-43 {
    padding-right: 21rem !important;
  }

  .pe-sm-44 {
    padding-right: 21.5rem !important;
  }

  .pe-sm-45 {
    padding-right: 22rem !important;
  }

  .pe-sm-46 {
    padding-right: 22.5rem !important;
  }

  .pe-sm-47 {
    padding-right: 23rem !important;
  }

  .pe-sm-48 {
    padding-right: 23.5rem !important;
  }

  .pe-sm-49 {
    padding-right: 24rem !important;
  }

  .pe-sm-50 {
    padding-right: 24.5rem !important;
  }

  .pe-sm-51 {
    padding-right: 25rem !important;
  }

  .pe-sm-52 {
    padding-right: 25.5rem !important;
  }

  .pe-sm-53 {
    padding-right: 26rem !important;
  }

  .pe-sm-54 {
    padding-right: 26.5rem !important;
  }

  .pe-sm-55 {
    padding-right: 27rem !important;
  }

  .pe-sm-56 {
    padding-right: 27.5rem !important;
  }

  .pe-sm-57 {
    padding-right: 28rem !important;
  }

  .pe-sm-58 {
    padding-right: 28.5rem !important;
  }

  .pe-sm-59 {
    padding-right: 29rem !important;
  }

  .pe-sm-60 {
    padding-right: 29.5rem !important;
  }

  .pe-sm-61 {
    padding-right: 30rem !important;
  }

  .pe-sm-62 {
    padding-right: 30.5rem !important;
  }

  .pe-sm-63 {
    padding-right: 31rem !important;
  }

  .pe-sm-64 {
    padding-right: 31.5rem !important;
  }

  .pe-sm-65 {
    padding-right: 32rem !important;
  }

  .pe-sm-66 {
    padding-right: 32.5rem !important;
  }

  .pe-sm-67 {
    padding-right: 33rem !important;
  }

  .pe-sm-68 {
    padding-right: 33.5rem !important;
  }

  .pe-sm-69 {
    padding-right: 34rem !important;
  }

  .pe-sm-70 {
    padding-right: 34.5rem !important;
  }

  .pe-sm-71 {
    padding-right: 35rem !important;
  }

  .pe-sm-72 {
    padding-right: 35.5rem !important;
  }

  .pe-sm-73 {
    padding-right: 36rem !important;
  }

  .pe-sm-74 {
    padding-right: 36.5rem !important;
  }

  .pe-sm-75 {
    padding-right: 37rem !important;
  }

  .pe-sm-76 {
    padding-right: 37.5rem !important;
  }

  .pe-sm-77 {
    padding-right: 38rem !important;
  }

  .pe-sm-78 {
    padding-right: 38.5rem !important;
  }

  .pe-sm-79 {
    padding-right: 39rem !important;
  }

  .pe-sm-80 {
    padding-right: 39.5rem !important;
  }

  .pe-sm-81 {
    padding-right: 40rem !important;
  }

  .pe-sm-82 {
    padding-right: 40.5rem !important;
  }

  .pe-sm-83 {
    padding-right: 41rem !important;
  }

  .pe-sm-84 {
    padding-right: 41.5rem !important;
  }

  .pe-sm-85 {
    padding-right: 42rem !important;
  }

  .pe-sm-86 {
    padding-right: 42.5rem !important;
  }

  .pe-sm-87 {
    padding-right: 43rem !important;
  }

  .pe-sm-88 {
    padding-right: 43.5rem !important;
  }

  .pe-sm-89 {
    padding-right: 44rem !important;
  }

  .pe-sm-90 {
    padding-right: 44.5rem !important;
  }

  .pe-sm-91 {
    padding-right: 45rem !important;
  }

  .pe-sm-92 {
    padding-right: 45.5rem !important;
  }

  .pe-sm-93 {
    padding-right: 46rem !important;
  }

  .pe-sm-94 {
    padding-right: 46.5rem !important;
  }

  .pe-sm-95 {
    padding-right: 47rem !important;
  }

  .pe-sm-96 {
    padding-right: 47.5rem !important;
  }

  .pe-sm-97 {
    padding-right: 48rem !important;
  }

  .pe-sm-98 {
    padding-right: 48.5rem !important;
  }

  .pe-sm-99 {
    padding-right: 49rem !important;
  }

  .pe-sm-100 {
    padding-right: 49.5rem !important;
  }

  .pe-sm-101 {
    padding-right: 50rem !important;
  }

  .pe-sm-102 {
    padding-right: 50.5rem !important;
  }

  .pe-sm-103 {
    padding-right: 51rem !important;
  }

  .pe-sm-104 {
    padding-right: 51.5rem !important;
  }

  .pe-sm-105 {
    padding-right: 52rem !important;
  }

  .pe-sm-106 {
    padding-right: 52.5rem !important;
  }

  .pe-sm-107 {
    padding-right: 53rem !important;
  }

  .pe-sm-108 {
    padding-right: 53.5rem !important;
  }

  .pe-sm-109 {
    padding-right: 54rem !important;
  }

  .pe-sm-110 {
    padding-right: 54.5rem !important;
  }

  .pe-sm-111 {
    padding-right: 55rem !important;
  }

  .pe-sm-112 {
    padding-right: 55.5rem !important;
  }

  .pe-sm-113 {
    padding-right: 56rem !important;
  }

  .pe-sm-114 {
    padding-right: 56.5rem !important;
  }

  .pe-sm-115 {
    padding-right: 57rem !important;
  }

  .pe-sm-116 {
    padding-right: 57.5rem !important;
  }

  .pe-sm-117 {
    padding-right: 58rem !important;
  }

  .pe-sm-118 {
    padding-right: 58.5rem !important;
  }

  .pe-sm-119 {
    padding-right: 59rem !important;
  }

  .pe-sm-120 {
    padding-right: 59.5rem !important;
  }

  .pe-sm-121 {
    padding-right: 60rem !important;
  }

  .pe-sm-122 {
    padding-right: 60.5rem !important;
  }

  .pe-sm-123 {
    padding-right: 61rem !important;
  }

  .pe-sm-124 {
    padding-right: 61.5rem !important;
  }

  .pe-sm-125 {
    padding-right: 62rem !important;
  }

  .pe-sm-126 {
    padding-right: 62.5rem !important;
  }

  .pe-sm-127 {
    padding-right: 63rem !important;
  }

  .pe-sm-128 {
    padding-right: 63.5rem !important;
  }

  .pe-sm-129 {
    padding-right: 64rem !important;
  }

  .pe-sm-130 {
    padding-right: 64.5rem !important;
  }

  .pe-sm-131 {
    padding-right: 65rem !important;
  }

  .pe-sm-132 {
    padding-right: 65.5rem !important;
  }

  .pe-sm-133 {
    padding-right: 66rem !important;
  }

  .pe-sm-134 {
    padding-right: 66.5rem !important;
  }

  .pe-sm-135 {
    padding-right: 67rem !important;
  }

  .pe-sm-136 {
    padding-right: 67.5rem !important;
  }

  .pe-sm-137 {
    padding-right: 68rem !important;
  }

  .pe-sm-138 {
    padding-right: 68.5rem !important;
  }

  .pe-sm-139 {
    padding-right: 69rem !important;
  }

  .pe-sm-140 {
    padding-right: 69.5rem !important;
  }

  .pe-sm-141 {
    padding-right: 70rem !important;
  }

  .pe-sm-142 {
    padding-right: 70.5rem !important;
  }

  .pe-sm-143 {
    padding-right: 71rem !important;
  }

  .pe-sm-144 {
    padding-right: 71.5rem !important;
  }

  .pe-sm-145 {
    padding-right: 72rem !important;
  }

  .pe-sm-146 {
    padding-right: 72.5rem !important;
  }

  .pe-sm-147 {
    padding-right: 73rem !important;
  }

  .pe-sm-148 {
    padding-right: 73.5rem !important;
  }

  .pe-sm-149 {
    padding-right: 74rem !important;
  }

  .pe-sm-150 {
    padding-right: 74.5rem !important;
  }

  .pe-sm-151 {
    padding-right: 75rem !important;
  }

  .pe-sm-152 {
    padding-right: 75.5rem !important;
  }

  .pe-sm-153 {
    padding-right: 76rem !important;
  }

  .pe-sm-154 {
    padding-right: 76.5rem !important;
  }

  .pe-sm-155 {
    padding-right: 77rem !important;
  }

  .pe-sm-156 {
    padding-right: 77.5rem !important;
  }

  .pe-sm-157 {
    padding-right: 78rem !important;
  }

  .pe-sm-158 {
    padding-right: 78.5rem !important;
  }

  .pe-sm-159 {
    padding-right: 79rem !important;
  }

  .pe-sm-160 {
    padding-right: 79.5rem !important;
  }

  .px-sm-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }

  .px-sm-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  .px-sm-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .px-sm-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .px-sm-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .px-sm-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .px-sm-6 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .px-sm-7 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .px-sm-8 {
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important;
  }

  .px-sm-9 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  .px-sm-10 {
    padding-left: 4.5rem !important;
    padding-right: 4.5rem !important;
  }

  .px-sm-11 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  .px-sm-12 {
    padding-left: 5.5rem !important;
    padding-right: 5.5rem !important;
  }

  .px-sm-13 {
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  .px-sm-14 {
    padding-left: 6.5rem !important;
    padding-right: 6.5rem !important;
  }

  .px-sm-15 {
    padding-left: 7rem !important;
    padding-right: 7rem !important;
  }

  .px-sm-16 {
    padding-left: 7.5rem !important;
    padding-right: 7.5rem !important;
  }

  .px-sm-17 {
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  .px-sm-18 {
    padding-left: 8.5rem !important;
    padding-right: 8.5rem !important;
  }

  .px-sm-19 {
    padding-left: 9rem !important;
    padding-right: 9rem !important;
  }

  .px-sm-20 {
    padding-left: 9.5rem !important;
    padding-right: 9.5rem !important;
  }

  .px-sm-21 {
    padding-left: 10rem !important;
    padding-right: 10rem !important;
  }

  .px-sm-22 {
    padding-left: 10.5rem !important;
    padding-right: 10.5rem !important;
  }

  .px-sm-23 {
    padding-left: 11rem !important;
    padding-right: 11rem !important;
  }

  .px-sm-24 {
    padding-left: 11.5rem !important;
    padding-right: 11.5rem !important;
  }

  .px-sm-25 {
    padding-left: 12rem !important;
    padding-right: 12rem !important;
  }

  .px-sm-26 {
    padding-left: 12.5rem !important;
    padding-right: 12.5rem !important;
  }

  .px-sm-27 {
    padding-left: 13rem !important;
    padding-right: 13rem !important;
  }

  .px-sm-28 {
    padding-left: 13.5rem !important;
    padding-right: 13.5rem !important;
  }

  .px-sm-29 {
    padding-left: 14rem !important;
    padding-right: 14rem !important;
  }

  .px-sm-30 {
    padding-left: 14.5rem !important;
    padding-right: 14.5rem !important;
  }

  .px-sm-31 {
    padding-left: 15rem !important;
    padding-right: 15rem !important;
  }

  .px-sm-32 {
    padding-left: 15.5rem !important;
    padding-right: 15.5rem !important;
  }

  .px-sm-33 {
    padding-left: 16rem !important;
    padding-right: 16rem !important;
  }

  .px-sm-34 {
    padding-left: 16.5rem !important;
    padding-right: 16.5rem !important;
  }

  .px-sm-35 {
    padding-left: 17rem !important;
    padding-right: 17rem !important;
  }

  .px-sm-36 {
    padding-left: 17.5rem !important;
    padding-right: 17.5rem !important;
  }

  .px-sm-37 {
    padding-left: 18rem !important;
    padding-right: 18rem !important;
  }

  .px-sm-38 {
    padding-left: 18.5rem !important;
    padding-right: 18.5rem !important;
  }

  .px-sm-39 {
    padding-left: 19rem !important;
    padding-right: 19rem !important;
  }

  .px-sm-40 {
    padding-left: 19.5rem !important;
    padding-right: 19.5rem !important;
  }

  .px-sm-41 {
    padding-left: 20rem !important;
    padding-right: 20rem !important;
  }

  .px-sm-42 {
    padding-left: 20.5rem !important;
    padding-right: 20.5rem !important;
  }

  .px-sm-43 {
    padding-left: 21rem !important;
    padding-right: 21rem !important;
  }

  .px-sm-44 {
    padding-left: 21.5rem !important;
    padding-right: 21.5rem !important;
  }

  .px-sm-45 {
    padding-left: 22rem !important;
    padding-right: 22rem !important;
  }

  .px-sm-46 {
    padding-left: 22.5rem !important;
    padding-right: 22.5rem !important;
  }

  .px-sm-47 {
    padding-left: 23rem !important;
    padding-right: 23rem !important;
  }

  .px-sm-48 {
    padding-left: 23.5rem !important;
    padding-right: 23.5rem !important;
  }

  .px-sm-49 {
    padding-left: 24rem !important;
    padding-right: 24rem !important;
  }

  .px-sm-50 {
    padding-left: 24.5rem !important;
    padding-right: 24.5rem !important;
  }

  .px-sm-51 {
    padding-left: 25rem !important;
    padding-right: 25rem !important;
  }

  .px-sm-52 {
    padding-left: 25.5rem !important;
    padding-right: 25.5rem !important;
  }

  .px-sm-53 {
    padding-left: 26rem !important;
    padding-right: 26rem !important;
  }

  .px-sm-54 {
    padding-left: 26.5rem !important;
    padding-right: 26.5rem !important;
  }

  .px-sm-55 {
    padding-left: 27rem !important;
    padding-right: 27rem !important;
  }

  .px-sm-56 {
    padding-left: 27.5rem !important;
    padding-right: 27.5rem !important;
  }

  .px-sm-57 {
    padding-left: 28rem !important;
    padding-right: 28rem !important;
  }

  .px-sm-58 {
    padding-left: 28.5rem !important;
    padding-right: 28.5rem !important;
  }

  .px-sm-59 {
    padding-left: 29rem !important;
    padding-right: 29rem !important;
  }

  .px-sm-60 {
    padding-left: 29.5rem !important;
    padding-right: 29.5rem !important;
  }

  .px-sm-61 {
    padding-left: 30rem !important;
    padding-right: 30rem !important;
  }

  .px-sm-62 {
    padding-left: 30.5rem !important;
    padding-right: 30.5rem !important;
  }

  .px-sm-63 {
    padding-left: 31rem !important;
    padding-right: 31rem !important;
  }

  .px-sm-64 {
    padding-left: 31.5rem !important;
    padding-right: 31.5rem !important;
  }

  .px-sm-65 {
    padding-left: 32rem !important;
    padding-right: 32rem !important;
  }

  .px-sm-66 {
    padding-left: 32.5rem !important;
    padding-right: 32.5rem !important;
  }

  .px-sm-67 {
    padding-left: 33rem !important;
    padding-right: 33rem !important;
  }

  .px-sm-68 {
    padding-left: 33.5rem !important;
    padding-right: 33.5rem !important;
  }

  .px-sm-69 {
    padding-left: 34rem !important;
    padding-right: 34rem !important;
  }

  .px-sm-70 {
    padding-left: 34.5rem !important;
    padding-right: 34.5rem !important;
  }

  .px-sm-71 {
    padding-left: 35rem !important;
    padding-right: 35rem !important;
  }

  .px-sm-72 {
    padding-left: 35.5rem !important;
    padding-right: 35.5rem !important;
  }

  .px-sm-73 {
    padding-left: 36rem !important;
    padding-right: 36rem !important;
  }

  .px-sm-74 {
    padding-left: 36.5rem !important;
    padding-right: 36.5rem !important;
  }

  .px-sm-75 {
    padding-left: 37rem !important;
    padding-right: 37rem !important;
  }

  .px-sm-76 {
    padding-left: 37.5rem !important;
    padding-right: 37.5rem !important;
  }

  .px-sm-77 {
    padding-left: 38rem !important;
    padding-right: 38rem !important;
  }

  .px-sm-78 {
    padding-left: 38.5rem !important;
    padding-right: 38.5rem !important;
  }

  .px-sm-79 {
    padding-left: 39rem !important;
    padding-right: 39rem !important;
  }

  .px-sm-80 {
    padding-left: 39.5rem !important;
    padding-right: 39.5rem !important;
  }

  .px-sm-81 {
    padding-left: 40rem !important;
    padding-right: 40rem !important;
  }

  .px-sm-82 {
    padding-left: 40.5rem !important;
    padding-right: 40.5rem !important;
  }

  .px-sm-83 {
    padding-left: 41rem !important;
    padding-right: 41rem !important;
  }

  .px-sm-84 {
    padding-left: 41.5rem !important;
    padding-right: 41.5rem !important;
  }

  .px-sm-85 {
    padding-left: 42rem !important;
    padding-right: 42rem !important;
  }

  .px-sm-86 {
    padding-left: 42.5rem !important;
    padding-right: 42.5rem !important;
  }

  .px-sm-87 {
    padding-left: 43rem !important;
    padding-right: 43rem !important;
  }

  .px-sm-88 {
    padding-left: 43.5rem !important;
    padding-right: 43.5rem !important;
  }

  .px-sm-89 {
    padding-left: 44rem !important;
    padding-right: 44rem !important;
  }

  .px-sm-90 {
    padding-left: 44.5rem !important;
    padding-right: 44.5rem !important;
  }

  .px-sm-91 {
    padding-left: 45rem !important;
    padding-right: 45rem !important;
  }

  .px-sm-92 {
    padding-left: 45.5rem !important;
    padding-right: 45.5rem !important;
  }

  .px-sm-93 {
    padding-left: 46rem !important;
    padding-right: 46rem !important;
  }

  .px-sm-94 {
    padding-left: 46.5rem !important;
    padding-right: 46.5rem !important;
  }

  .px-sm-95 {
    padding-left: 47rem !important;
    padding-right: 47rem !important;
  }

  .px-sm-96 {
    padding-left: 47.5rem !important;
    padding-right: 47.5rem !important;
  }

  .px-sm-97 {
    padding-left: 48rem !important;
    padding-right: 48rem !important;
  }

  .px-sm-98 {
    padding-left: 48.5rem !important;
    padding-right: 48.5rem !important;
  }

  .px-sm-99 {
    padding-left: 49rem !important;
    padding-right: 49rem !important;
  }

  .px-sm-100 {
    padding-left: 49.5rem !important;
    padding-right: 49.5rem !important;
  }

  .px-sm-101 {
    padding-left: 50rem !important;
    padding-right: 50rem !important;
  }

  .px-sm-102 {
    padding-left: 50.5rem !important;
    padding-right: 50.5rem !important;
  }

  .px-sm-103 {
    padding-left: 51rem !important;
    padding-right: 51rem !important;
  }

  .px-sm-104 {
    padding-left: 51.5rem !important;
    padding-right: 51.5rem !important;
  }

  .px-sm-105 {
    padding-left: 52rem !important;
    padding-right: 52rem !important;
  }

  .px-sm-106 {
    padding-left: 52.5rem !important;
    padding-right: 52.5rem !important;
  }

  .px-sm-107 {
    padding-left: 53rem !important;
    padding-right: 53rem !important;
  }

  .px-sm-108 {
    padding-left: 53.5rem !important;
    padding-right: 53.5rem !important;
  }

  .px-sm-109 {
    padding-left: 54rem !important;
    padding-right: 54rem !important;
  }

  .px-sm-110 {
    padding-left: 54.5rem !important;
    padding-right: 54.5rem !important;
  }

  .px-sm-111 {
    padding-left: 55rem !important;
    padding-right: 55rem !important;
  }

  .px-sm-112 {
    padding-left: 55.5rem !important;
    padding-right: 55.5rem !important;
  }

  .px-sm-113 {
    padding-left: 56rem !important;
    padding-right: 56rem !important;
  }

  .px-sm-114 {
    padding-left: 56.5rem !important;
    padding-right: 56.5rem !important;
  }

  .px-sm-115 {
    padding-left: 57rem !important;
    padding-right: 57rem !important;
  }

  .px-sm-116 {
    padding-left: 57.5rem !important;
    padding-right: 57.5rem !important;
  }

  .px-sm-117 {
    padding-left: 58rem !important;
    padding-right: 58rem !important;
  }

  .px-sm-118 {
    padding-left: 58.5rem !important;
    padding-right: 58.5rem !important;
  }

  .px-sm-119 {
    padding-left: 59rem !important;
    padding-right: 59rem !important;
  }

  .px-sm-120 {
    padding-left: 59.5rem !important;
    padding-right: 59.5rem !important;
  }

  .px-sm-121 {
    padding-left: 60rem !important;
    padding-right: 60rem !important;
  }

  .px-sm-122 {
    padding-left: 60.5rem !important;
    padding-right: 60.5rem !important;
  }

  .px-sm-123 {
    padding-left: 61rem !important;
    padding-right: 61rem !important;
  }

  .px-sm-124 {
    padding-left: 61.5rem !important;
    padding-right: 61.5rem !important;
  }

  .px-sm-125 {
    padding-left: 62rem !important;
    padding-right: 62rem !important;
  }

  .px-sm-126 {
    padding-left: 62.5rem !important;
    padding-right: 62.5rem !important;
  }

  .px-sm-127 {
    padding-left: 63rem !important;
    padding-right: 63rem !important;
  }

  .px-sm-128 {
    padding-left: 63.5rem !important;
    padding-right: 63.5rem !important;
  }

  .px-sm-129 {
    padding-left: 64rem !important;
    padding-right: 64rem !important;
  }

  .px-sm-130 {
    padding-left: 64.5rem !important;
    padding-right: 64.5rem !important;
  }

  .px-sm-131 {
    padding-left: 65rem !important;
    padding-right: 65rem !important;
  }

  .px-sm-132 {
    padding-left: 65.5rem !important;
    padding-right: 65.5rem !important;
  }

  .px-sm-133 {
    padding-left: 66rem !important;
    padding-right: 66rem !important;
  }

  .px-sm-134 {
    padding-left: 66.5rem !important;
    padding-right: 66.5rem !important;
  }

  .px-sm-135 {
    padding-left: 67rem !important;
    padding-right: 67rem !important;
  }

  .px-sm-136 {
    padding-left: 67.5rem !important;
    padding-right: 67.5rem !important;
  }

  .px-sm-137 {
    padding-left: 68rem !important;
    padding-right: 68rem !important;
  }

  .px-sm-138 {
    padding-left: 68.5rem !important;
    padding-right: 68.5rem !important;
  }

  .px-sm-139 {
    padding-left: 69rem !important;
    padding-right: 69rem !important;
  }

  .px-sm-140 {
    padding-left: 69.5rem !important;
    padding-right: 69.5rem !important;
  }

  .px-sm-141 {
    padding-left: 70rem !important;
    padding-right: 70rem !important;
  }

  .px-sm-142 {
    padding-left: 70.5rem !important;
    padding-right: 70.5rem !important;
  }

  .px-sm-143 {
    padding-left: 71rem !important;
    padding-right: 71rem !important;
  }

  .px-sm-144 {
    padding-left: 71.5rem !important;
    padding-right: 71.5rem !important;
  }

  .px-sm-145 {
    padding-left: 72rem !important;
    padding-right: 72rem !important;
  }

  .px-sm-146 {
    padding-left: 72.5rem !important;
    padding-right: 72.5rem !important;
  }

  .px-sm-147 {
    padding-left: 73rem !important;
    padding-right: 73rem !important;
  }

  .px-sm-148 {
    padding-left: 73.5rem !important;
    padding-right: 73.5rem !important;
  }

  .px-sm-149 {
    padding-left: 74rem !important;
    padding-right: 74rem !important;
  }

  .px-sm-150 {
    padding-left: 74.5rem !important;
    padding-right: 74.5rem !important;
  }

  .px-sm-151 {
    padding-left: 75rem !important;
    padding-right: 75rem !important;
  }

  .px-sm-152 {
    padding-left: 75.5rem !important;
    padding-right: 75.5rem !important;
  }

  .px-sm-153 {
    padding-left: 76rem !important;
    padding-right: 76rem !important;
  }

  .px-sm-154 {
    padding-left: 76.5rem !important;
    padding-right: 76.5rem !important;
  }

  .px-sm-155 {
    padding-left: 77rem !important;
    padding-right: 77rem !important;
  }

  .px-sm-156 {
    padding-left: 77.5rem !important;
    padding-right: 77.5rem !important;
  }

  .px-sm-157 {
    padding-left: 78rem !important;
    padding-right: 78rem !important;
  }

  .px-sm-158 {
    padding-left: 78.5rem !important;
    padding-right: 78.5rem !important;
  }

  .px-sm-159 {
    padding-left: 79rem !important;
    padding-right: 79rem !important;
  }

  .px-sm-160 {
    padding-left: 79.5rem !important;
    padding-right: 79.5rem !important;
  }

  .py-sm-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-sm-6 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-sm-7 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-sm-8 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-sm-9 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-sm-10 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-sm-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .py-sm-12 {
    padding-top: 5.5rem !important;
    padding-bottom: 5.5rem !important;
  }

  .py-sm-13 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  .py-sm-14 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }

  .py-sm-15 {
    padding-top: 7rem !important;
    padding-bottom: 7rem !important;
  }

  .py-sm-16 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }

  .py-sm-17 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  .py-sm-18 {
    padding-top: 8.5rem !important;
    padding-bottom: 8.5rem !important;
  }

  .py-sm-19 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }

  .py-sm-20 {
    padding-top: 9.5rem !important;
    padding-bottom: 9.5rem !important;
  }

  .py-sm-21 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }

  .py-sm-22 {
    padding-top: 10.5rem !important;
    padding-bottom: 10.5rem !important;
  }

  .py-sm-23 {
    padding-top: 11rem !important;
    padding-bottom: 11rem !important;
  }

  .py-sm-24 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }

  .py-sm-25 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }

  .py-sm-26 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }

  .py-sm-27 {
    padding-top: 13rem !important;
    padding-bottom: 13rem !important;
  }

  .py-sm-28 {
    padding-top: 13.5rem !important;
    padding-bottom: 13.5rem !important;
  }

  .py-sm-29 {
    padding-top: 14rem !important;
    padding-bottom: 14rem !important;
  }

  .py-sm-30 {
    padding-top: 14.5rem !important;
    padding-bottom: 14.5rem !important;
  }

  .py-sm-31 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }

  .py-sm-32 {
    padding-top: 15.5rem !important;
    padding-bottom: 15.5rem !important;
  }

  .py-sm-33 {
    padding-top: 16rem !important;
    padding-bottom: 16rem !important;
  }

  .py-sm-34 {
    padding-top: 16.5rem !important;
    padding-bottom: 16.5rem !important;
  }

  .py-sm-35 {
    padding-top: 17rem !important;
    padding-bottom: 17rem !important;
  }

  .py-sm-36 {
    padding-top: 17.5rem !important;
    padding-bottom: 17.5rem !important;
  }

  .py-sm-37 {
    padding-top: 18rem !important;
    padding-bottom: 18rem !important;
  }

  .py-sm-38 {
    padding-top: 18.5rem !important;
    padding-bottom: 18.5rem !important;
  }

  .py-sm-39 {
    padding-top: 19rem !important;
    padding-bottom: 19rem !important;
  }

  .py-sm-40 {
    padding-top: 19.5rem !important;
    padding-bottom: 19.5rem !important;
  }

  .py-sm-41 {
    padding-top: 20rem !important;
    padding-bottom: 20rem !important;
  }

  .py-sm-42 {
    padding-top: 20.5rem !important;
    padding-bottom: 20.5rem !important;
  }

  .py-sm-43 {
    padding-top: 21rem !important;
    padding-bottom: 21rem !important;
  }

  .py-sm-44 {
    padding-top: 21.5rem !important;
    padding-bottom: 21.5rem !important;
  }

  .py-sm-45 {
    padding-top: 22rem !important;
    padding-bottom: 22rem !important;
  }

  .py-sm-46 {
    padding-top: 22.5rem !important;
    padding-bottom: 22.5rem !important;
  }

  .py-sm-47 {
    padding-top: 23rem !important;
    padding-bottom: 23rem !important;
  }

  .py-sm-48 {
    padding-top: 23.5rem !important;
    padding-bottom: 23.5rem !important;
  }

  .py-sm-49 {
    padding-top: 24rem !important;
    padding-bottom: 24rem !important;
  }

  .py-sm-50 {
    padding-top: 24.5rem !important;
    padding-bottom: 24.5rem !important;
  }

  .py-sm-51 {
    padding-top: 25rem !important;
    padding-bottom: 25rem !important;
  }

  .py-sm-52 {
    padding-top: 25.5rem !important;
    padding-bottom: 25.5rem !important;
  }

  .py-sm-53 {
    padding-top: 26rem !important;
    padding-bottom: 26rem !important;
  }

  .py-sm-54 {
    padding-top: 26.5rem !important;
    padding-bottom: 26.5rem !important;
  }

  .py-sm-55 {
    padding-top: 27rem !important;
    padding-bottom: 27rem !important;
  }

  .py-sm-56 {
    padding-top: 27.5rem !important;
    padding-bottom: 27.5rem !important;
  }

  .py-sm-57 {
    padding-top: 28rem !important;
    padding-bottom: 28rem !important;
  }

  .py-sm-58 {
    padding-top: 28.5rem !important;
    padding-bottom: 28.5rem !important;
  }

  .py-sm-59 {
    padding-top: 29rem !important;
    padding-bottom: 29rem !important;
  }

  .py-sm-60 {
    padding-top: 29.5rem !important;
    padding-bottom: 29.5rem !important;
  }

  .py-sm-61 {
    padding-top: 30rem !important;
    padding-bottom: 30rem !important;
  }

  .py-sm-62 {
    padding-top: 30.5rem !important;
    padding-bottom: 30.5rem !important;
  }

  .py-sm-63 {
    padding-top: 31rem !important;
    padding-bottom: 31rem !important;
  }

  .py-sm-64 {
    padding-top: 31.5rem !important;
    padding-bottom: 31.5rem !important;
  }

  .py-sm-65 {
    padding-top: 32rem !important;
    padding-bottom: 32rem !important;
  }

  .py-sm-66 {
    padding-top: 32.5rem !important;
    padding-bottom: 32.5rem !important;
  }

  .py-sm-67 {
    padding-top: 33rem !important;
    padding-bottom: 33rem !important;
  }

  .py-sm-68 {
    padding-top: 33.5rem !important;
    padding-bottom: 33.5rem !important;
  }

  .py-sm-69 {
    padding-top: 34rem !important;
    padding-bottom: 34rem !important;
  }

  .py-sm-70 {
    padding-top: 34.5rem !important;
    padding-bottom: 34.5rem !important;
  }

  .py-sm-71 {
    padding-top: 35rem !important;
    padding-bottom: 35rem !important;
  }

  .py-sm-72 {
    padding-top: 35.5rem !important;
    padding-bottom: 35.5rem !important;
  }

  .py-sm-73 {
    padding-top: 36rem !important;
    padding-bottom: 36rem !important;
  }

  .py-sm-74 {
    padding-top: 36.5rem !important;
    padding-bottom: 36.5rem !important;
  }

  .py-sm-75 {
    padding-top: 37rem !important;
    padding-bottom: 37rem !important;
  }

  .py-sm-76 {
    padding-top: 37.5rem !important;
    padding-bottom: 37.5rem !important;
  }

  .py-sm-77 {
    padding-top: 38rem !important;
    padding-bottom: 38rem !important;
  }

  .py-sm-78 {
    padding-top: 38.5rem !important;
    padding-bottom: 38.5rem !important;
  }

  .py-sm-79 {
    padding-top: 39rem !important;
    padding-bottom: 39rem !important;
  }

  .py-sm-80 {
    padding-top: 39.5rem !important;
    padding-bottom: 39.5rem !important;
  }

  .py-sm-81 {
    padding-top: 40rem !important;
    padding-bottom: 40rem !important;
  }

  .py-sm-82 {
    padding-top: 40.5rem !important;
    padding-bottom: 40.5rem !important;
  }

  .py-sm-83 {
    padding-top: 41rem !important;
    padding-bottom: 41rem !important;
  }

  .py-sm-84 {
    padding-top: 41.5rem !important;
    padding-bottom: 41.5rem !important;
  }

  .py-sm-85 {
    padding-top: 42rem !important;
    padding-bottom: 42rem !important;
  }

  .py-sm-86 {
    padding-top: 42.5rem !important;
    padding-bottom: 42.5rem !important;
  }

  .py-sm-87 {
    padding-top: 43rem !important;
    padding-bottom: 43rem !important;
  }

  .py-sm-88 {
    padding-top: 43.5rem !important;
    padding-bottom: 43.5rem !important;
  }

  .py-sm-89 {
    padding-top: 44rem !important;
    padding-bottom: 44rem !important;
  }

  .py-sm-90 {
    padding-top: 44.5rem !important;
    padding-bottom: 44.5rem !important;
  }

  .py-sm-91 {
    padding-top: 45rem !important;
    padding-bottom: 45rem !important;
  }

  .py-sm-92 {
    padding-top: 45.5rem !important;
    padding-bottom: 45.5rem !important;
  }

  .py-sm-93 {
    padding-top: 46rem !important;
    padding-bottom: 46rem !important;
  }

  .py-sm-94 {
    padding-top: 46.5rem !important;
    padding-bottom: 46.5rem !important;
  }

  .py-sm-95 {
    padding-top: 47rem !important;
    padding-bottom: 47rem !important;
  }

  .py-sm-96 {
    padding-top: 47.5rem !important;
    padding-bottom: 47.5rem !important;
  }

  .py-sm-97 {
    padding-top: 48rem !important;
    padding-bottom: 48rem !important;
  }

  .py-sm-98 {
    padding-top: 48.5rem !important;
    padding-bottom: 48.5rem !important;
  }

  .py-sm-99 {
    padding-top: 49rem !important;
    padding-bottom: 49rem !important;
  }

  .py-sm-100 {
    padding-top: 49.5rem !important;
    padding-bottom: 49.5rem !important;
  }

  .py-sm-101 {
    padding-top: 50rem !important;
    padding-bottom: 50rem !important;
  }

  .py-sm-102 {
    padding-top: 50.5rem !important;
    padding-bottom: 50.5rem !important;
  }

  .py-sm-103 {
    padding-top: 51rem !important;
    padding-bottom: 51rem !important;
  }

  .py-sm-104 {
    padding-top: 51.5rem !important;
    padding-bottom: 51.5rem !important;
  }

  .py-sm-105 {
    padding-top: 52rem !important;
    padding-bottom: 52rem !important;
  }

  .py-sm-106 {
    padding-top: 52.5rem !important;
    padding-bottom: 52.5rem !important;
  }

  .py-sm-107 {
    padding-top: 53rem !important;
    padding-bottom: 53rem !important;
  }

  .py-sm-108 {
    padding-top: 53.5rem !important;
    padding-bottom: 53.5rem !important;
  }

  .py-sm-109 {
    padding-top: 54rem !important;
    padding-bottom: 54rem !important;
  }

  .py-sm-110 {
    padding-top: 54.5rem !important;
    padding-bottom: 54.5rem !important;
  }

  .py-sm-111 {
    padding-top: 55rem !important;
    padding-bottom: 55rem !important;
  }

  .py-sm-112 {
    padding-top: 55.5rem !important;
    padding-bottom: 55.5rem !important;
  }

  .py-sm-113 {
    padding-top: 56rem !important;
    padding-bottom: 56rem !important;
  }

  .py-sm-114 {
    padding-top: 56.5rem !important;
    padding-bottom: 56.5rem !important;
  }

  .py-sm-115 {
    padding-top: 57rem !important;
    padding-bottom: 57rem !important;
  }

  .py-sm-116 {
    padding-top: 57.5rem !important;
    padding-bottom: 57.5rem !important;
  }

  .py-sm-117 {
    padding-top: 58rem !important;
    padding-bottom: 58rem !important;
  }

  .py-sm-118 {
    padding-top: 58.5rem !important;
    padding-bottom: 58.5rem !important;
  }

  .py-sm-119 {
    padding-top: 59rem !important;
    padding-bottom: 59rem !important;
  }

  .py-sm-120 {
    padding-top: 59.5rem !important;
    padding-bottom: 59.5rem !important;
  }

  .py-sm-121 {
    padding-top: 60rem !important;
    padding-bottom: 60rem !important;
  }

  .py-sm-122 {
    padding-top: 60.5rem !important;
    padding-bottom: 60.5rem !important;
  }

  .py-sm-123 {
    padding-top: 61rem !important;
    padding-bottom: 61rem !important;
  }

  .py-sm-124 {
    padding-top: 61.5rem !important;
    padding-bottom: 61.5rem !important;
  }

  .py-sm-125 {
    padding-top: 62rem !important;
    padding-bottom: 62rem !important;
  }

  .py-sm-126 {
    padding-top: 62.5rem !important;
    padding-bottom: 62.5rem !important;
  }

  .py-sm-127 {
    padding-top: 63rem !important;
    padding-bottom: 63rem !important;
  }

  .py-sm-128 {
    padding-top: 63.5rem !important;
    padding-bottom: 63.5rem !important;
  }

  .py-sm-129 {
    padding-top: 64rem !important;
    padding-bottom: 64rem !important;
  }

  .py-sm-130 {
    padding-top: 64.5rem !important;
    padding-bottom: 64.5rem !important;
  }

  .py-sm-131 {
    padding-top: 65rem !important;
    padding-bottom: 65rem !important;
  }

  .py-sm-132 {
    padding-top: 65.5rem !important;
    padding-bottom: 65.5rem !important;
  }

  .py-sm-133 {
    padding-top: 66rem !important;
    padding-bottom: 66rem !important;
  }

  .py-sm-134 {
    padding-top: 66.5rem !important;
    padding-bottom: 66.5rem !important;
  }

  .py-sm-135 {
    padding-top: 67rem !important;
    padding-bottom: 67rem !important;
  }

  .py-sm-136 {
    padding-top: 67.5rem !important;
    padding-bottom: 67.5rem !important;
  }

  .py-sm-137 {
    padding-top: 68rem !important;
    padding-bottom: 68rem !important;
  }

  .py-sm-138 {
    padding-top: 68.5rem !important;
    padding-bottom: 68.5rem !important;
  }

  .py-sm-139 {
    padding-top: 69rem !important;
    padding-bottom: 69rem !important;
  }

  .py-sm-140 {
    padding-top: 69.5rem !important;
    padding-bottom: 69.5rem !important;
  }

  .py-sm-141 {
    padding-top: 70rem !important;
    padding-bottom: 70rem !important;
  }

  .py-sm-142 {
    padding-top: 70.5rem !important;
    padding-bottom: 70.5rem !important;
  }

  .py-sm-143 {
    padding-top: 71rem !important;
    padding-bottom: 71rem !important;
  }

  .py-sm-144 {
    padding-top: 71.5rem !important;
    padding-bottom: 71.5rem !important;
  }

  .py-sm-145 {
    padding-top: 72rem !important;
    padding-bottom: 72rem !important;
  }

  .py-sm-146 {
    padding-top: 72.5rem !important;
    padding-bottom: 72.5rem !important;
  }

  .py-sm-147 {
    padding-top: 73rem !important;
    padding-bottom: 73rem !important;
  }

  .py-sm-148 {
    padding-top: 73.5rem !important;
    padding-bottom: 73.5rem !important;
  }

  .py-sm-149 {
    padding-top: 74rem !important;
    padding-bottom: 74rem !important;
  }

  .py-sm-150 {
    padding-top: 74.5rem !important;
    padding-bottom: 74.5rem !important;
  }

  .py-sm-151 {
    padding-top: 75rem !important;
    padding-bottom: 75rem !important;
  }

  .py-sm-152 {
    padding-top: 75.5rem !important;
    padding-bottom: 75.5rem !important;
  }

  .py-sm-153 {
    padding-top: 76rem !important;
    padding-bottom: 76rem !important;
  }

  .py-sm-154 {
    padding-top: 76.5rem !important;
    padding-bottom: 76.5rem !important;
  }

  .py-sm-155 {
    padding-top: 77rem !important;
    padding-bottom: 77rem !important;
  }

  .py-sm-156 {
    padding-top: 77.5rem !important;
    padding-bottom: 77.5rem !important;
  }

  .py-sm-157 {
    padding-top: 78rem !important;
    padding-bottom: 78rem !important;
  }

  .py-sm-158 {
    padding-top: 78.5rem !important;
    padding-bottom: 78.5rem !important;
  }

  .py-sm-159 {
    padding-top: 79rem !important;
    padding-bottom: 79rem !important;
  }

  .py-sm-160 {
    padding-top: 79.5rem !important;
    padding-bottom: 79.5rem !important;
  }
}
@media (min-width: 768px) {
  .p-md-0 {
    padding: 0rem !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .p-md-5 {
    padding: 2rem !important;
  }

  .p-md-6 {
    padding: 2.5rem !important;
  }

  .p-md-7 {
    padding: 3rem !important;
  }

  .p-md-8 {
    padding: 3.5rem !important;
  }

  .p-md-9 {
    padding: 4rem !important;
  }

  .p-md-10 {
    padding: 4.5rem !important;
  }

  .p-md-11 {
    padding: 5rem !important;
  }

  .p-md-12 {
    padding: 5.5rem !important;
  }

  .p-md-13 {
    padding: 6rem !important;
  }

  .p-md-14 {
    padding: 6.5rem !important;
  }

  .p-md-15 {
    padding: 7rem !important;
  }

  .p-md-16 {
    padding: 7.5rem !important;
  }

  .p-md-17 {
    padding: 8rem !important;
  }

  .p-md-18 {
    padding: 8.5rem !important;
  }

  .p-md-19 {
    padding: 9rem !important;
  }

  .p-md-20 {
    padding: 9.5rem !important;
  }

  .p-md-21 {
    padding: 10rem !important;
  }

  .p-md-22 {
    padding: 10.5rem !important;
  }

  .p-md-23 {
    padding: 11rem !important;
  }

  .p-md-24 {
    padding: 11.5rem !important;
  }

  .p-md-25 {
    padding: 12rem !important;
  }

  .p-md-26 {
    padding: 12.5rem !important;
  }

  .p-md-27 {
    padding: 13rem !important;
  }

  .p-md-28 {
    padding: 13.5rem !important;
  }

  .p-md-29 {
    padding: 14rem !important;
  }

  .p-md-30 {
    padding: 14.5rem !important;
  }

  .p-md-31 {
    padding: 15rem !important;
  }

  .p-md-32 {
    padding: 15.5rem !important;
  }

  .p-md-33 {
    padding: 16rem !important;
  }

  .p-md-34 {
    padding: 16.5rem !important;
  }

  .p-md-35 {
    padding: 17rem !important;
  }

  .p-md-36 {
    padding: 17.5rem !important;
  }

  .p-md-37 {
    padding: 18rem !important;
  }

  .p-md-38 {
    padding: 18.5rem !important;
  }

  .p-md-39 {
    padding: 19rem !important;
  }

  .p-md-40 {
    padding: 19.5rem !important;
  }

  .p-md-41 {
    padding: 20rem !important;
  }

  .p-md-42 {
    padding: 20.5rem !important;
  }

  .p-md-43 {
    padding: 21rem !important;
  }

  .p-md-44 {
    padding: 21.5rem !important;
  }

  .p-md-45 {
    padding: 22rem !important;
  }

  .p-md-46 {
    padding: 22.5rem !important;
  }

  .p-md-47 {
    padding: 23rem !important;
  }

  .p-md-48 {
    padding: 23.5rem !important;
  }

  .p-md-49 {
    padding: 24rem !important;
  }

  .p-md-50 {
    padding: 24.5rem !important;
  }

  .p-md-51 {
    padding: 25rem !important;
  }

  .p-md-52 {
    padding: 25.5rem !important;
  }

  .p-md-53 {
    padding: 26rem !important;
  }

  .p-md-54 {
    padding: 26.5rem !important;
  }

  .p-md-55 {
    padding: 27rem !important;
  }

  .p-md-56 {
    padding: 27.5rem !important;
  }

  .p-md-57 {
    padding: 28rem !important;
  }

  .p-md-58 {
    padding: 28.5rem !important;
  }

  .p-md-59 {
    padding: 29rem !important;
  }

  .p-md-60 {
    padding: 29.5rem !important;
  }

  .p-md-61 {
    padding: 30rem !important;
  }

  .p-md-62 {
    padding: 30.5rem !important;
  }

  .p-md-63 {
    padding: 31rem !important;
  }

  .p-md-64 {
    padding: 31.5rem !important;
  }

  .p-md-65 {
    padding: 32rem !important;
  }

  .p-md-66 {
    padding: 32.5rem !important;
  }

  .p-md-67 {
    padding: 33rem !important;
  }

  .p-md-68 {
    padding: 33.5rem !important;
  }

  .p-md-69 {
    padding: 34rem !important;
  }

  .p-md-70 {
    padding: 34.5rem !important;
  }

  .p-md-71 {
    padding: 35rem !important;
  }

  .p-md-72 {
    padding: 35.5rem !important;
  }

  .p-md-73 {
    padding: 36rem !important;
  }

  .p-md-74 {
    padding: 36.5rem !important;
  }

  .p-md-75 {
    padding: 37rem !important;
  }

  .p-md-76 {
    padding: 37.5rem !important;
  }

  .p-md-77 {
    padding: 38rem !important;
  }

  .p-md-78 {
    padding: 38.5rem !important;
  }

  .p-md-79 {
    padding: 39rem !important;
  }

  .p-md-80 {
    padding: 39.5rem !important;
  }

  .p-md-81 {
    padding: 40rem !important;
  }

  .p-md-82 {
    padding: 40.5rem !important;
  }

  .p-md-83 {
    padding: 41rem !important;
  }

  .p-md-84 {
    padding: 41.5rem !important;
  }

  .p-md-85 {
    padding: 42rem !important;
  }

  .p-md-86 {
    padding: 42.5rem !important;
  }

  .p-md-87 {
    padding: 43rem !important;
  }

  .p-md-88 {
    padding: 43.5rem !important;
  }

  .p-md-89 {
    padding: 44rem !important;
  }

  .p-md-90 {
    padding: 44.5rem !important;
  }

  .p-md-91 {
    padding: 45rem !important;
  }

  .p-md-92 {
    padding: 45.5rem !important;
  }

  .p-md-93 {
    padding: 46rem !important;
  }

  .p-md-94 {
    padding: 46.5rem !important;
  }

  .p-md-95 {
    padding: 47rem !important;
  }

  .p-md-96 {
    padding: 47.5rem !important;
  }

  .p-md-97 {
    padding: 48rem !important;
  }

  .p-md-98 {
    padding: 48.5rem !important;
  }

  .p-md-99 {
    padding: 49rem !important;
  }

  .p-md-100 {
    padding: 49.5rem !important;
  }

  .p-md-101 {
    padding: 50rem !important;
  }

  .p-md-102 {
    padding: 50.5rem !important;
  }

  .p-md-103 {
    padding: 51rem !important;
  }

  .p-md-104 {
    padding: 51.5rem !important;
  }

  .p-md-105 {
    padding: 52rem !important;
  }

  .p-md-106 {
    padding: 52.5rem !important;
  }

  .p-md-107 {
    padding: 53rem !important;
  }

  .p-md-108 {
    padding: 53.5rem !important;
  }

  .p-md-109 {
    padding: 54rem !important;
  }

  .p-md-110 {
    padding: 54.5rem !important;
  }

  .p-md-111 {
    padding: 55rem !important;
  }

  .p-md-112 {
    padding: 55.5rem !important;
  }

  .p-md-113 {
    padding: 56rem !important;
  }

  .p-md-114 {
    padding: 56.5rem !important;
  }

  .p-md-115 {
    padding: 57rem !important;
  }

  .p-md-116 {
    padding: 57.5rem !important;
  }

  .p-md-117 {
    padding: 58rem !important;
  }

  .p-md-118 {
    padding: 58.5rem !important;
  }

  .p-md-119 {
    padding: 59rem !important;
  }

  .p-md-120 {
    padding: 59.5rem !important;
  }

  .p-md-121 {
    padding: 60rem !important;
  }

  .p-md-122 {
    padding: 60.5rem !important;
  }

  .p-md-123 {
    padding: 61rem !important;
  }

  .p-md-124 {
    padding: 61.5rem !important;
  }

  .p-md-125 {
    padding: 62rem !important;
  }

  .p-md-126 {
    padding: 62.5rem !important;
  }

  .p-md-127 {
    padding: 63rem !important;
  }

  .p-md-128 {
    padding: 63.5rem !important;
  }

  .p-md-129 {
    padding: 64rem !important;
  }

  .p-md-130 {
    padding: 64.5rem !important;
  }

  .p-md-131 {
    padding: 65rem !important;
  }

  .p-md-132 {
    padding: 65.5rem !important;
  }

  .p-md-133 {
    padding: 66rem !important;
  }

  .p-md-134 {
    padding: 66.5rem !important;
  }

  .p-md-135 {
    padding: 67rem !important;
  }

  .p-md-136 {
    padding: 67.5rem !important;
  }

  .p-md-137 {
    padding: 68rem !important;
  }

  .p-md-138 {
    padding: 68.5rem !important;
  }

  .p-md-139 {
    padding: 69rem !important;
  }

  .p-md-140 {
    padding: 69.5rem !important;
  }

  .p-md-141 {
    padding: 70rem !important;
  }

  .p-md-142 {
    padding: 70.5rem !important;
  }

  .p-md-143 {
    padding: 71rem !important;
  }

  .p-md-144 {
    padding: 71.5rem !important;
  }

  .p-md-145 {
    padding: 72rem !important;
  }

  .p-md-146 {
    padding: 72.5rem !important;
  }

  .p-md-147 {
    padding: 73rem !important;
  }

  .p-md-148 {
    padding: 73.5rem !important;
  }

  .p-md-149 {
    padding: 74rem !important;
  }

  .p-md-150 {
    padding: 74.5rem !important;
  }

  .p-md-151 {
    padding: 75rem !important;
  }

  .p-md-152 {
    padding: 75.5rem !important;
  }

  .p-md-153 {
    padding: 76rem !important;
  }

  .p-md-154 {
    padding: 76.5rem !important;
  }

  .p-md-155 {
    padding: 77rem !important;
  }

  .p-md-156 {
    padding: 77.5rem !important;
  }

  .p-md-157 {
    padding: 78rem !important;
  }

  .p-md-158 {
    padding: 78.5rem !important;
  }

  .p-md-159 {
    padding: 79rem !important;
  }

  .p-md-160 {
    padding: 79.5rem !important;
  }

  .pt-md-0 {
    padding-top: 0rem !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 1rem !important;
  }

  .pt-md-4 {
    padding-top: 1.5rem !important;
  }

  .pt-md-5 {
    padding-top: 2rem !important;
  }

  .pt-md-6 {
    padding-top: 2.5rem !important;
  }

  .pt-md-7 {
    padding-top: 3rem !important;
  }

  .pt-md-8 {
    padding-top: 3.5rem !important;
  }

  .pt-md-9 {
    padding-top: 4rem !important;
  }

  .pt-md-10 {
    padding-top: 4.5rem !important;
  }

  .pt-md-11 {
    padding-top: 5rem !important;
  }

  .pt-md-12 {
    padding-top: 5.5rem !important;
  }

  .pt-md-13 {
    padding-top: 6rem !important;
  }

  .pt-md-14 {
    padding-top: 6.5rem !important;
  }

  .pt-md-15 {
    padding-top: 7rem !important;
  }

  .pt-md-16 {
    padding-top: 7.5rem !important;
  }

  .pt-md-17 {
    padding-top: 8rem !important;
  }

  .pt-md-18 {
    padding-top: 8.5rem !important;
  }

  .pt-md-19 {
    padding-top: 9rem !important;
  }

  .pt-md-20 {
    padding-top: 9.5rem !important;
  }

  .pt-md-21 {
    padding-top: 10rem !important;
  }

  .pt-md-22 {
    padding-top: 10.5rem !important;
  }

  .pt-md-23 {
    padding-top: 11rem !important;
  }

  .pt-md-24 {
    padding-top: 11.5rem !important;
  }

  .pt-md-25 {
    padding-top: 12rem !important;
  }

  .pt-md-26 {
    padding-top: 12.5rem !important;
  }

  .pt-md-27 {
    padding-top: 13rem !important;
  }

  .pt-md-28 {
    padding-top: 13.5rem !important;
  }

  .pt-md-29 {
    padding-top: 14rem !important;
  }

  .pt-md-30 {
    padding-top: 14.5rem !important;
  }

  .pt-md-31 {
    padding-top: 15rem !important;
  }

  .pt-md-32 {
    padding-top: 15.5rem !important;
  }

  .pt-md-33 {
    padding-top: 16rem !important;
  }

  .pt-md-34 {
    padding-top: 16.5rem !important;
  }

  .pt-md-35 {
    padding-top: 17rem !important;
  }

  .pt-md-36 {
    padding-top: 17.5rem !important;
  }

  .pt-md-37 {
    padding-top: 18rem !important;
  }

  .pt-md-38 {
    padding-top: 18.5rem !important;
  }

  .pt-md-39 {
    padding-top: 19rem !important;
  }

  .pt-md-40 {
    padding-top: 19.5rem !important;
  }

  .pt-md-41 {
    padding-top: 20rem !important;
  }

  .pt-md-42 {
    padding-top: 20.5rem !important;
  }

  .pt-md-43 {
    padding-top: 21rem !important;
  }

  .pt-md-44 {
    padding-top: 21.5rem !important;
  }

  .pt-md-45 {
    padding-top: 22rem !important;
  }

  .pt-md-46 {
    padding-top: 22.5rem !important;
  }

  .pt-md-47 {
    padding-top: 23rem !important;
  }

  .pt-md-48 {
    padding-top: 23.5rem !important;
  }

  .pt-md-49 {
    padding-top: 24rem !important;
  }

  .pt-md-50 {
    padding-top: 24.5rem !important;
  }

  .pt-md-51 {
    padding-top: 25rem !important;
  }

  .pt-md-52 {
    padding-top: 25.5rem !important;
  }

  .pt-md-53 {
    padding-top: 26rem !important;
  }

  .pt-md-54 {
    padding-top: 26.5rem !important;
  }

  .pt-md-55 {
    padding-top: 27rem !important;
  }

  .pt-md-56 {
    padding-top: 27.5rem !important;
  }

  .pt-md-57 {
    padding-top: 28rem !important;
  }

  .pt-md-58 {
    padding-top: 28.5rem !important;
  }

  .pt-md-59 {
    padding-top: 29rem !important;
  }

  .pt-md-60 {
    padding-top: 29.5rem !important;
  }

  .pt-md-61 {
    padding-top: 30rem !important;
  }

  .pt-md-62 {
    padding-top: 30.5rem !important;
  }

  .pt-md-63 {
    padding-top: 31rem !important;
  }

  .pt-md-64 {
    padding-top: 31.5rem !important;
  }

  .pt-md-65 {
    padding-top: 32rem !important;
  }

  .pt-md-66 {
    padding-top: 32.5rem !important;
  }

  .pt-md-67 {
    padding-top: 33rem !important;
  }

  .pt-md-68 {
    padding-top: 33.5rem !important;
  }

  .pt-md-69 {
    padding-top: 34rem !important;
  }

  .pt-md-70 {
    padding-top: 34.5rem !important;
  }

  .pt-md-71 {
    padding-top: 35rem !important;
  }

  .pt-md-72 {
    padding-top: 35.5rem !important;
  }

  .pt-md-73 {
    padding-top: 36rem !important;
  }

  .pt-md-74 {
    padding-top: 36.5rem !important;
  }

  .pt-md-75 {
    padding-top: 37rem !important;
  }

  .pt-md-76 {
    padding-top: 37.5rem !important;
  }

  .pt-md-77 {
    padding-top: 38rem !important;
  }

  .pt-md-78 {
    padding-top: 38.5rem !important;
  }

  .pt-md-79 {
    padding-top: 39rem !important;
  }

  .pt-md-80 {
    padding-top: 39.5rem !important;
  }

  .pt-md-81 {
    padding-top: 40rem !important;
  }

  .pt-md-82 {
    padding-top: 40.5rem !important;
  }

  .pt-md-83 {
    padding-top: 41rem !important;
  }

  .pt-md-84 {
    padding-top: 41.5rem !important;
  }

  .pt-md-85 {
    padding-top: 42rem !important;
  }

  .pt-md-86 {
    padding-top: 42.5rem !important;
  }

  .pt-md-87 {
    padding-top: 43rem !important;
  }

  .pt-md-88 {
    padding-top: 43.5rem !important;
  }

  .pt-md-89 {
    padding-top: 44rem !important;
  }

  .pt-md-90 {
    padding-top: 44.5rem !important;
  }

  .pt-md-91 {
    padding-top: 45rem !important;
  }

  .pt-md-92 {
    padding-top: 45.5rem !important;
  }

  .pt-md-93 {
    padding-top: 46rem !important;
  }

  .pt-md-94 {
    padding-top: 46.5rem !important;
  }

  .pt-md-95 {
    padding-top: 47rem !important;
  }

  .pt-md-96 {
    padding-top: 47.5rem !important;
  }

  .pt-md-97 {
    padding-top: 48rem !important;
  }

  .pt-md-98 {
    padding-top: 48.5rem !important;
  }

  .pt-md-99 {
    padding-top: 49rem !important;
  }

  .pt-md-100 {
    padding-top: 49.5rem !important;
  }

  .pt-md-101 {
    padding-top: 50rem !important;
  }

  .pt-md-102 {
    padding-top: 50.5rem !important;
  }

  .pt-md-103 {
    padding-top: 51rem !important;
  }

  .pt-md-104 {
    padding-top: 51.5rem !important;
  }

  .pt-md-105 {
    padding-top: 52rem !important;
  }

  .pt-md-106 {
    padding-top: 52.5rem !important;
  }

  .pt-md-107 {
    padding-top: 53rem !important;
  }

  .pt-md-108 {
    padding-top: 53.5rem !important;
  }

  .pt-md-109 {
    padding-top: 54rem !important;
  }

  .pt-md-110 {
    padding-top: 54.5rem !important;
  }

  .pt-md-111 {
    padding-top: 55rem !important;
  }

  .pt-md-112 {
    padding-top: 55.5rem !important;
  }

  .pt-md-113 {
    padding-top: 56rem !important;
  }

  .pt-md-114 {
    padding-top: 56.5rem !important;
  }

  .pt-md-115 {
    padding-top: 57rem !important;
  }

  .pt-md-116 {
    padding-top: 57.5rem !important;
  }

  .pt-md-117 {
    padding-top: 58rem !important;
  }

  .pt-md-118 {
    padding-top: 58.5rem !important;
  }

  .pt-md-119 {
    padding-top: 59rem !important;
  }

  .pt-md-120 {
    padding-top: 59.5rem !important;
  }

  .pt-md-121 {
    padding-top: 60rem !important;
  }

  .pt-md-122 {
    padding-top: 60.5rem !important;
  }

  .pt-md-123 {
    padding-top: 61rem !important;
  }

  .pt-md-124 {
    padding-top: 61.5rem !important;
  }

  .pt-md-125 {
    padding-top: 62rem !important;
  }

  .pt-md-126 {
    padding-top: 62.5rem !important;
  }

  .pt-md-127 {
    padding-top: 63rem !important;
  }

  .pt-md-128 {
    padding-top: 63.5rem !important;
  }

  .pt-md-129 {
    padding-top: 64rem !important;
  }

  .pt-md-130 {
    padding-top: 64.5rem !important;
  }

  .pt-md-131 {
    padding-top: 65rem !important;
  }

  .pt-md-132 {
    padding-top: 65.5rem !important;
  }

  .pt-md-133 {
    padding-top: 66rem !important;
  }

  .pt-md-134 {
    padding-top: 66.5rem !important;
  }

  .pt-md-135 {
    padding-top: 67rem !important;
  }

  .pt-md-136 {
    padding-top: 67.5rem !important;
  }

  .pt-md-137 {
    padding-top: 68rem !important;
  }

  .pt-md-138 {
    padding-top: 68.5rem !important;
  }

  .pt-md-139 {
    padding-top: 69rem !important;
  }

  .pt-md-140 {
    padding-top: 69.5rem !important;
  }

  .pt-md-141 {
    padding-top: 70rem !important;
  }

  .pt-md-142 {
    padding-top: 70.5rem !important;
  }

  .pt-md-143 {
    padding-top: 71rem !important;
  }

  .pt-md-144 {
    padding-top: 71.5rem !important;
  }

  .pt-md-145 {
    padding-top: 72rem !important;
  }

  .pt-md-146 {
    padding-top: 72.5rem !important;
  }

  .pt-md-147 {
    padding-top: 73rem !important;
  }

  .pt-md-148 {
    padding-top: 73.5rem !important;
  }

  .pt-md-149 {
    padding-top: 74rem !important;
  }

  .pt-md-150 {
    padding-top: 74.5rem !important;
  }

  .pt-md-151 {
    padding-top: 75rem !important;
  }

  .pt-md-152 {
    padding-top: 75.5rem !important;
  }

  .pt-md-153 {
    padding-top: 76rem !important;
  }

  .pt-md-154 {
    padding-top: 76.5rem !important;
  }

  .pt-md-155 {
    padding-top: 77rem !important;
  }

  .pt-md-156 {
    padding-top: 77.5rem !important;
  }

  .pt-md-157 {
    padding-top: 78rem !important;
  }

  .pt-md-158 {
    padding-top: 78.5rem !important;
  }

  .pt-md-159 {
    padding-top: 79rem !important;
  }

  .pt-md-160 {
    padding-top: 79.5rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0rem !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 1rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-5 {
    padding-bottom: 2rem !important;
  }

  .pb-md-6 {
    padding-bottom: 2.5rem !important;
  }

  .pb-md-7 {
    padding-bottom: 3rem !important;
  }

  .pb-md-8 {
    padding-bottom: 3.5rem !important;
  }

  .pb-md-9 {
    padding-bottom: 4rem !important;
  }

  .pb-md-10 {
    padding-bottom: 4.5rem !important;
  }

  .pb-md-11 {
    padding-bottom: 5rem !important;
  }

  .pb-md-12 {
    padding-bottom: 5.5rem !important;
  }

  .pb-md-13 {
    padding-bottom: 6rem !important;
  }

  .pb-md-14 {
    padding-bottom: 6.5rem !important;
  }

  .pb-md-15 {
    padding-bottom: 7rem !important;
  }

  .pb-md-16 {
    padding-bottom: 7.5rem !important;
  }

  .pb-md-17 {
    padding-bottom: 8rem !important;
  }

  .pb-md-18 {
    padding-bottom: 8.5rem !important;
  }

  .pb-md-19 {
    padding-bottom: 9rem !important;
  }

  .pb-md-20 {
    padding-bottom: 9.5rem !important;
  }

  .pb-md-21 {
    padding-bottom: 10rem !important;
  }

  .pb-md-22 {
    padding-bottom: 10.5rem !important;
  }

  .pb-md-23 {
    padding-bottom: 11rem !important;
  }

  .pb-md-24 {
    padding-bottom: 11.5rem !important;
  }

  .pb-md-25 {
    padding-bottom: 12rem !important;
  }

  .pb-md-26 {
    padding-bottom: 12.5rem !important;
  }

  .pb-md-27 {
    padding-bottom: 13rem !important;
  }

  .pb-md-28 {
    padding-bottom: 13.5rem !important;
  }

  .pb-md-29 {
    padding-bottom: 14rem !important;
  }

  .pb-md-30 {
    padding-bottom: 14.5rem !important;
  }

  .pb-md-31 {
    padding-bottom: 15rem !important;
  }

  .pb-md-32 {
    padding-bottom: 15.5rem !important;
  }

  .pb-md-33 {
    padding-bottom: 16rem !important;
  }

  .pb-md-34 {
    padding-bottom: 16.5rem !important;
  }

  .pb-md-35 {
    padding-bottom: 17rem !important;
  }

  .pb-md-36 {
    padding-bottom: 17.5rem !important;
  }

  .pb-md-37 {
    padding-bottom: 18rem !important;
  }

  .pb-md-38 {
    padding-bottom: 18.5rem !important;
  }

  .pb-md-39 {
    padding-bottom: 19rem !important;
  }

  .pb-md-40 {
    padding-bottom: 19.5rem !important;
  }

  .pb-md-41 {
    padding-bottom: 20rem !important;
  }

  .pb-md-42 {
    padding-bottom: 20.5rem !important;
  }

  .pb-md-43 {
    padding-bottom: 21rem !important;
  }

  .pb-md-44 {
    padding-bottom: 21.5rem !important;
  }

  .pb-md-45 {
    padding-bottom: 22rem !important;
  }

  .pb-md-46 {
    padding-bottom: 22.5rem !important;
  }

  .pb-md-47 {
    padding-bottom: 23rem !important;
  }

  .pb-md-48 {
    padding-bottom: 23.5rem !important;
  }

  .pb-md-49 {
    padding-bottom: 24rem !important;
  }

  .pb-md-50 {
    padding-bottom: 24.5rem !important;
  }

  .pb-md-51 {
    padding-bottom: 25rem !important;
  }

  .pb-md-52 {
    padding-bottom: 25.5rem !important;
  }

  .pb-md-53 {
    padding-bottom: 26rem !important;
  }

  .pb-md-54 {
    padding-bottom: 26.5rem !important;
  }

  .pb-md-55 {
    padding-bottom: 27rem !important;
  }

  .pb-md-56 {
    padding-bottom: 27.5rem !important;
  }

  .pb-md-57 {
    padding-bottom: 28rem !important;
  }

  .pb-md-58 {
    padding-bottom: 28.5rem !important;
  }

  .pb-md-59 {
    padding-bottom: 29rem !important;
  }

  .pb-md-60 {
    padding-bottom: 29.5rem !important;
  }

  .pb-md-61 {
    padding-bottom: 30rem !important;
  }

  .pb-md-62 {
    padding-bottom: 30.5rem !important;
  }

  .pb-md-63 {
    padding-bottom: 31rem !important;
  }

  .pb-md-64 {
    padding-bottom: 31.5rem !important;
  }

  .pb-md-65 {
    padding-bottom: 32rem !important;
  }

  .pb-md-66 {
    padding-bottom: 32.5rem !important;
  }

  .pb-md-67 {
    padding-bottom: 33rem !important;
  }

  .pb-md-68 {
    padding-bottom: 33.5rem !important;
  }

  .pb-md-69 {
    padding-bottom: 34rem !important;
  }

  .pb-md-70 {
    padding-bottom: 34.5rem !important;
  }

  .pb-md-71 {
    padding-bottom: 35rem !important;
  }

  .pb-md-72 {
    padding-bottom: 35.5rem !important;
  }

  .pb-md-73 {
    padding-bottom: 36rem !important;
  }

  .pb-md-74 {
    padding-bottom: 36.5rem !important;
  }

  .pb-md-75 {
    padding-bottom: 37rem !important;
  }

  .pb-md-76 {
    padding-bottom: 37.5rem !important;
  }

  .pb-md-77 {
    padding-bottom: 38rem !important;
  }

  .pb-md-78 {
    padding-bottom: 38.5rem !important;
  }

  .pb-md-79 {
    padding-bottom: 39rem !important;
  }

  .pb-md-80 {
    padding-bottom: 39.5rem !important;
  }

  .pb-md-81 {
    padding-bottom: 40rem !important;
  }

  .pb-md-82 {
    padding-bottom: 40.5rem !important;
  }

  .pb-md-83 {
    padding-bottom: 41rem !important;
  }

  .pb-md-84 {
    padding-bottom: 41.5rem !important;
  }

  .pb-md-85 {
    padding-bottom: 42rem !important;
  }

  .pb-md-86 {
    padding-bottom: 42.5rem !important;
  }

  .pb-md-87 {
    padding-bottom: 43rem !important;
  }

  .pb-md-88 {
    padding-bottom: 43.5rem !important;
  }

  .pb-md-89 {
    padding-bottom: 44rem !important;
  }

  .pb-md-90 {
    padding-bottom: 44.5rem !important;
  }

  .pb-md-91 {
    padding-bottom: 45rem !important;
  }

  .pb-md-92 {
    padding-bottom: 45.5rem !important;
  }

  .pb-md-93 {
    padding-bottom: 46rem !important;
  }

  .pb-md-94 {
    padding-bottom: 46.5rem !important;
  }

  .pb-md-95 {
    padding-bottom: 47rem !important;
  }

  .pb-md-96 {
    padding-bottom: 47.5rem !important;
  }

  .pb-md-97 {
    padding-bottom: 48rem !important;
  }

  .pb-md-98 {
    padding-bottom: 48.5rem !important;
  }

  .pb-md-99 {
    padding-bottom: 49rem !important;
  }

  .pb-md-100 {
    padding-bottom: 49.5rem !important;
  }

  .pb-md-101 {
    padding-bottom: 50rem !important;
  }

  .pb-md-102 {
    padding-bottom: 50.5rem !important;
  }

  .pb-md-103 {
    padding-bottom: 51rem !important;
  }

  .pb-md-104 {
    padding-bottom: 51.5rem !important;
  }

  .pb-md-105 {
    padding-bottom: 52rem !important;
  }

  .pb-md-106 {
    padding-bottom: 52.5rem !important;
  }

  .pb-md-107 {
    padding-bottom: 53rem !important;
  }

  .pb-md-108 {
    padding-bottom: 53.5rem !important;
  }

  .pb-md-109 {
    padding-bottom: 54rem !important;
  }

  .pb-md-110 {
    padding-bottom: 54.5rem !important;
  }

  .pb-md-111 {
    padding-bottom: 55rem !important;
  }

  .pb-md-112 {
    padding-bottom: 55.5rem !important;
  }

  .pb-md-113 {
    padding-bottom: 56rem !important;
  }

  .pb-md-114 {
    padding-bottom: 56.5rem !important;
  }

  .pb-md-115 {
    padding-bottom: 57rem !important;
  }

  .pb-md-116 {
    padding-bottom: 57.5rem !important;
  }

  .pb-md-117 {
    padding-bottom: 58rem !important;
  }

  .pb-md-118 {
    padding-bottom: 58.5rem !important;
  }

  .pb-md-119 {
    padding-bottom: 59rem !important;
  }

  .pb-md-120 {
    padding-bottom: 59.5rem !important;
  }

  .pb-md-121 {
    padding-bottom: 60rem !important;
  }

  .pb-md-122 {
    padding-bottom: 60.5rem !important;
  }

  .pb-md-123 {
    padding-bottom: 61rem !important;
  }

  .pb-md-124 {
    padding-bottom: 61.5rem !important;
  }

  .pb-md-125 {
    padding-bottom: 62rem !important;
  }

  .pb-md-126 {
    padding-bottom: 62.5rem !important;
  }

  .pb-md-127 {
    padding-bottom: 63rem !important;
  }

  .pb-md-128 {
    padding-bottom: 63.5rem !important;
  }

  .pb-md-129 {
    padding-bottom: 64rem !important;
  }

  .pb-md-130 {
    padding-bottom: 64.5rem !important;
  }

  .pb-md-131 {
    padding-bottom: 65rem !important;
  }

  .pb-md-132 {
    padding-bottom: 65.5rem !important;
  }

  .pb-md-133 {
    padding-bottom: 66rem !important;
  }

  .pb-md-134 {
    padding-bottom: 66.5rem !important;
  }

  .pb-md-135 {
    padding-bottom: 67rem !important;
  }

  .pb-md-136 {
    padding-bottom: 67.5rem !important;
  }

  .pb-md-137 {
    padding-bottom: 68rem !important;
  }

  .pb-md-138 {
    padding-bottom: 68.5rem !important;
  }

  .pb-md-139 {
    padding-bottom: 69rem !important;
  }

  .pb-md-140 {
    padding-bottom: 69.5rem !important;
  }

  .pb-md-141 {
    padding-bottom: 70rem !important;
  }

  .pb-md-142 {
    padding-bottom: 70.5rem !important;
  }

  .pb-md-143 {
    padding-bottom: 71rem !important;
  }

  .pb-md-144 {
    padding-bottom: 71.5rem !important;
  }

  .pb-md-145 {
    padding-bottom: 72rem !important;
  }

  .pb-md-146 {
    padding-bottom: 72.5rem !important;
  }

  .pb-md-147 {
    padding-bottom: 73rem !important;
  }

  .pb-md-148 {
    padding-bottom: 73.5rem !important;
  }

  .pb-md-149 {
    padding-bottom: 74rem !important;
  }

  .pb-md-150 {
    padding-bottom: 74.5rem !important;
  }

  .pb-md-151 {
    padding-bottom: 75rem !important;
  }

  .pb-md-152 {
    padding-bottom: 75.5rem !important;
  }

  .pb-md-153 {
    padding-bottom: 76rem !important;
  }

  .pb-md-154 {
    padding-bottom: 76.5rem !important;
  }

  .pb-md-155 {
    padding-bottom: 77rem !important;
  }

  .pb-md-156 {
    padding-bottom: 77.5rem !important;
  }

  .pb-md-157 {
    padding-bottom: 78rem !important;
  }

  .pb-md-158 {
    padding-bottom: 78.5rem !important;
  }

  .pb-md-159 {
    padding-bottom: 79rem !important;
  }

  .pb-md-160 {
    padding-bottom: 79.5rem !important;
  }

  .ps-md-0 {
    padding-left: 0rem !important;
  }

  .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  .ps-md-3 {
    padding-left: 1rem !important;
  }

  .ps-md-4 {
    padding-left: 1.5rem !important;
  }

  .ps-md-5 {
    padding-left: 2rem !important;
  }

  .ps-md-6 {
    padding-left: 2.5rem !important;
  }

  .ps-md-7 {
    padding-left: 3rem !important;
  }

  .ps-md-8 {
    padding-left: 3.5rem !important;
  }

  .ps-md-9 {
    padding-left: 4rem !important;
  }

  .ps-md-10 {
    padding-left: 4.5rem !important;
  }

  .ps-md-11 {
    padding-left: 5rem !important;
  }

  .ps-md-12 {
    padding-left: 5.5rem !important;
  }

  .ps-md-13 {
    padding-left: 6rem !important;
  }

  .ps-md-14 {
    padding-left: 6.5rem !important;
  }

  .ps-md-15 {
    padding-left: 7rem !important;
  }

  .ps-md-16 {
    padding-left: 7.5rem !important;
  }

  .ps-md-17 {
    padding-left: 8rem !important;
  }

  .ps-md-18 {
    padding-left: 8.5rem !important;
  }

  .ps-md-19 {
    padding-left: 9rem !important;
  }

  .ps-md-20 {
    padding-left: 9.5rem !important;
  }

  .ps-md-21 {
    padding-left: 10rem !important;
  }

  .ps-md-22 {
    padding-left: 10.5rem !important;
  }

  .ps-md-23 {
    padding-left: 11rem !important;
  }

  .ps-md-24 {
    padding-left: 11.5rem !important;
  }

  .ps-md-25 {
    padding-left: 12rem !important;
  }

  .ps-md-26 {
    padding-left: 12.5rem !important;
  }

  .ps-md-27 {
    padding-left: 13rem !important;
  }

  .ps-md-28 {
    padding-left: 13.5rem !important;
  }

  .ps-md-29 {
    padding-left: 14rem !important;
  }

  .ps-md-30 {
    padding-left: 14.5rem !important;
  }

  .ps-md-31 {
    padding-left: 15rem !important;
  }

  .ps-md-32 {
    padding-left: 15.5rem !important;
  }

  .ps-md-33 {
    padding-left: 16rem !important;
  }

  .ps-md-34 {
    padding-left: 16.5rem !important;
  }

  .ps-md-35 {
    padding-left: 17rem !important;
  }

  .ps-md-36 {
    padding-left: 17.5rem !important;
  }

  .ps-md-37 {
    padding-left: 18rem !important;
  }

  .ps-md-38 {
    padding-left: 18.5rem !important;
  }

  .ps-md-39 {
    padding-left: 19rem !important;
  }

  .ps-md-40 {
    padding-left: 19.5rem !important;
  }

  .ps-md-41 {
    padding-left: 20rem !important;
  }

  .ps-md-42 {
    padding-left: 20.5rem !important;
  }

  .ps-md-43 {
    padding-left: 21rem !important;
  }

  .ps-md-44 {
    padding-left: 21.5rem !important;
  }

  .ps-md-45 {
    padding-left: 22rem !important;
  }

  .ps-md-46 {
    padding-left: 22.5rem !important;
  }

  .ps-md-47 {
    padding-left: 23rem !important;
  }

  .ps-md-48 {
    padding-left: 23.5rem !important;
  }

  .ps-md-49 {
    padding-left: 24rem !important;
  }

  .ps-md-50 {
    padding-left: 24.5rem !important;
  }

  .ps-md-51 {
    padding-left: 25rem !important;
  }

  .ps-md-52 {
    padding-left: 25.5rem !important;
  }

  .ps-md-53 {
    padding-left: 26rem !important;
  }

  .ps-md-54 {
    padding-left: 26.5rem !important;
  }

  .ps-md-55 {
    padding-left: 27rem !important;
  }

  .ps-md-56 {
    padding-left: 27.5rem !important;
  }

  .ps-md-57 {
    padding-left: 28rem !important;
  }

  .ps-md-58 {
    padding-left: 28.5rem !important;
  }

  .ps-md-59 {
    padding-left: 29rem !important;
  }

  .ps-md-60 {
    padding-left: 29.5rem !important;
  }

  .ps-md-61 {
    padding-left: 30rem !important;
  }

  .ps-md-62 {
    padding-left: 30.5rem !important;
  }

  .ps-md-63 {
    padding-left: 31rem !important;
  }

  .ps-md-64 {
    padding-left: 31.5rem !important;
  }

  .ps-md-65 {
    padding-left: 32rem !important;
  }

  .ps-md-66 {
    padding-left: 32.5rem !important;
  }

  .ps-md-67 {
    padding-left: 33rem !important;
  }

  .ps-md-68 {
    padding-left: 33.5rem !important;
  }

  .ps-md-69 {
    padding-left: 34rem !important;
  }

  .ps-md-70 {
    padding-left: 34.5rem !important;
  }

  .ps-md-71 {
    padding-left: 35rem !important;
  }

  .ps-md-72 {
    padding-left: 35.5rem !important;
  }

  .ps-md-73 {
    padding-left: 36rem !important;
  }

  .ps-md-74 {
    padding-left: 36.5rem !important;
  }

  .ps-md-75 {
    padding-left: 37rem !important;
  }

  .ps-md-76 {
    padding-left: 37.5rem !important;
  }

  .ps-md-77 {
    padding-left: 38rem !important;
  }

  .ps-md-78 {
    padding-left: 38.5rem !important;
  }

  .ps-md-79 {
    padding-left: 39rem !important;
  }

  .ps-md-80 {
    padding-left: 39.5rem !important;
  }

  .ps-md-81 {
    padding-left: 40rem !important;
  }

  .ps-md-82 {
    padding-left: 40.5rem !important;
  }

  .ps-md-83 {
    padding-left: 41rem !important;
  }

  .ps-md-84 {
    padding-left: 41.5rem !important;
  }

  .ps-md-85 {
    padding-left: 42rem !important;
  }

  .ps-md-86 {
    padding-left: 42.5rem !important;
  }

  .ps-md-87 {
    padding-left: 43rem !important;
  }

  .ps-md-88 {
    padding-left: 43.5rem !important;
  }

  .ps-md-89 {
    padding-left: 44rem !important;
  }

  .ps-md-90 {
    padding-left: 44.5rem !important;
  }

  .ps-md-91 {
    padding-left: 45rem !important;
  }

  .ps-md-92 {
    padding-left: 45.5rem !important;
  }

  .ps-md-93 {
    padding-left: 46rem !important;
  }

  .ps-md-94 {
    padding-left: 46.5rem !important;
  }

  .ps-md-95 {
    padding-left: 47rem !important;
  }

  .ps-md-96 {
    padding-left: 47.5rem !important;
  }

  .ps-md-97 {
    padding-left: 48rem !important;
  }

  .ps-md-98 {
    padding-left: 48.5rem !important;
  }

  .ps-md-99 {
    padding-left: 49rem !important;
  }

  .ps-md-100 {
    padding-left: 49.5rem !important;
  }

  .ps-md-101 {
    padding-left: 50rem !important;
  }

  .ps-md-102 {
    padding-left: 50.5rem !important;
  }

  .ps-md-103 {
    padding-left: 51rem !important;
  }

  .ps-md-104 {
    padding-left: 51.5rem !important;
  }

  .ps-md-105 {
    padding-left: 52rem !important;
  }

  .ps-md-106 {
    padding-left: 52.5rem !important;
  }

  .ps-md-107 {
    padding-left: 53rem !important;
  }

  .ps-md-108 {
    padding-left: 53.5rem !important;
  }

  .ps-md-109 {
    padding-left: 54rem !important;
  }

  .ps-md-110 {
    padding-left: 54.5rem !important;
  }

  .ps-md-111 {
    padding-left: 55rem !important;
  }

  .ps-md-112 {
    padding-left: 55.5rem !important;
  }

  .ps-md-113 {
    padding-left: 56rem !important;
  }

  .ps-md-114 {
    padding-left: 56.5rem !important;
  }

  .ps-md-115 {
    padding-left: 57rem !important;
  }

  .ps-md-116 {
    padding-left: 57.5rem !important;
  }

  .ps-md-117 {
    padding-left: 58rem !important;
  }

  .ps-md-118 {
    padding-left: 58.5rem !important;
  }

  .ps-md-119 {
    padding-left: 59rem !important;
  }

  .ps-md-120 {
    padding-left: 59.5rem !important;
  }

  .ps-md-121 {
    padding-left: 60rem !important;
  }

  .ps-md-122 {
    padding-left: 60.5rem !important;
  }

  .ps-md-123 {
    padding-left: 61rem !important;
  }

  .ps-md-124 {
    padding-left: 61.5rem !important;
  }

  .ps-md-125 {
    padding-left: 62rem !important;
  }

  .ps-md-126 {
    padding-left: 62.5rem !important;
  }

  .ps-md-127 {
    padding-left: 63rem !important;
  }

  .ps-md-128 {
    padding-left: 63.5rem !important;
  }

  .ps-md-129 {
    padding-left: 64rem !important;
  }

  .ps-md-130 {
    padding-left: 64.5rem !important;
  }

  .ps-md-131 {
    padding-left: 65rem !important;
  }

  .ps-md-132 {
    padding-left: 65.5rem !important;
  }

  .ps-md-133 {
    padding-left: 66rem !important;
  }

  .ps-md-134 {
    padding-left: 66.5rem !important;
  }

  .ps-md-135 {
    padding-left: 67rem !important;
  }

  .ps-md-136 {
    padding-left: 67.5rem !important;
  }

  .ps-md-137 {
    padding-left: 68rem !important;
  }

  .ps-md-138 {
    padding-left: 68.5rem !important;
  }

  .ps-md-139 {
    padding-left: 69rem !important;
  }

  .ps-md-140 {
    padding-left: 69.5rem !important;
  }

  .ps-md-141 {
    padding-left: 70rem !important;
  }

  .ps-md-142 {
    padding-left: 70.5rem !important;
  }

  .ps-md-143 {
    padding-left: 71rem !important;
  }

  .ps-md-144 {
    padding-left: 71.5rem !important;
  }

  .ps-md-145 {
    padding-left: 72rem !important;
  }

  .ps-md-146 {
    padding-left: 72.5rem !important;
  }

  .ps-md-147 {
    padding-left: 73rem !important;
  }

  .ps-md-148 {
    padding-left: 73.5rem !important;
  }

  .ps-md-149 {
    padding-left: 74rem !important;
  }

  .ps-md-150 {
    padding-left: 74.5rem !important;
  }

  .ps-md-151 {
    padding-left: 75rem !important;
  }

  .ps-md-152 {
    padding-left: 75.5rem !important;
  }

  .ps-md-153 {
    padding-left: 76rem !important;
  }

  .ps-md-154 {
    padding-left: 76.5rem !important;
  }

  .ps-md-155 {
    padding-left: 77rem !important;
  }

  .ps-md-156 {
    padding-left: 77.5rem !important;
  }

  .ps-md-157 {
    padding-left: 78rem !important;
  }

  .ps-md-158 {
    padding-left: 78.5rem !important;
  }

  .ps-md-159 {
    padding-left: 79rem !important;
  }

  .ps-md-160 {
    padding-left: 79.5rem !important;
  }

  .pe-md-0 {
    padding-right: 0rem !important;
  }

  .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  .pe-md-3 {
    padding-right: 1rem !important;
  }

  .pe-md-4 {
    padding-right: 1.5rem !important;
  }

  .pe-md-5 {
    padding-right: 2rem !important;
  }

  .pe-md-6 {
    padding-right: 2.5rem !important;
  }

  .pe-md-7 {
    padding-right: 3rem !important;
  }

  .pe-md-8 {
    padding-right: 3.5rem !important;
  }

  .pe-md-9 {
    padding-right: 4rem !important;
  }

  .pe-md-10 {
    padding-right: 4.5rem !important;
  }

  .pe-md-11 {
    padding-right: 5rem !important;
  }

  .pe-md-12 {
    padding-right: 5.5rem !important;
  }

  .pe-md-13 {
    padding-right: 6rem !important;
  }

  .pe-md-14 {
    padding-right: 6.5rem !important;
  }

  .pe-md-15 {
    padding-right: 7rem !important;
  }

  .pe-md-16 {
    padding-right: 7.5rem !important;
  }

  .pe-md-17 {
    padding-right: 8rem !important;
  }

  .pe-md-18 {
    padding-right: 8.5rem !important;
  }

  .pe-md-19 {
    padding-right: 9rem !important;
  }

  .pe-md-20 {
    padding-right: 9.5rem !important;
  }

  .pe-md-21 {
    padding-right: 10rem !important;
  }

  .pe-md-22 {
    padding-right: 10.5rem !important;
  }

  .pe-md-23 {
    padding-right: 11rem !important;
  }

  .pe-md-24 {
    padding-right: 11.5rem !important;
  }

  .pe-md-25 {
    padding-right: 12rem !important;
  }

  .pe-md-26 {
    padding-right: 12.5rem !important;
  }

  .pe-md-27 {
    padding-right: 13rem !important;
  }

  .pe-md-28 {
    padding-right: 13.5rem !important;
  }

  .pe-md-29 {
    padding-right: 14rem !important;
  }

  .pe-md-30 {
    padding-right: 14.5rem !important;
  }

  .pe-md-31 {
    padding-right: 15rem !important;
  }

  .pe-md-32 {
    padding-right: 15.5rem !important;
  }

  .pe-md-33 {
    padding-right: 16rem !important;
  }

  .pe-md-34 {
    padding-right: 16.5rem !important;
  }

  .pe-md-35 {
    padding-right: 17rem !important;
  }

  .pe-md-36 {
    padding-right: 17.5rem !important;
  }

  .pe-md-37 {
    padding-right: 18rem !important;
  }

  .pe-md-38 {
    padding-right: 18.5rem !important;
  }

  .pe-md-39 {
    padding-right: 19rem !important;
  }

  .pe-md-40 {
    padding-right: 19.5rem !important;
  }

  .pe-md-41 {
    padding-right: 20rem !important;
  }

  .pe-md-42 {
    padding-right: 20.5rem !important;
  }

  .pe-md-43 {
    padding-right: 21rem !important;
  }

  .pe-md-44 {
    padding-right: 21.5rem !important;
  }

  .pe-md-45 {
    padding-right: 22rem !important;
  }

  .pe-md-46 {
    padding-right: 22.5rem !important;
  }

  .pe-md-47 {
    padding-right: 23rem !important;
  }

  .pe-md-48 {
    padding-right: 23.5rem !important;
  }

  .pe-md-49 {
    padding-right: 24rem !important;
  }

  .pe-md-50 {
    padding-right: 24.5rem !important;
  }

  .pe-md-51 {
    padding-right: 25rem !important;
  }

  .pe-md-52 {
    padding-right: 25.5rem !important;
  }

  .pe-md-53 {
    padding-right: 26rem !important;
  }

  .pe-md-54 {
    padding-right: 26.5rem !important;
  }

  .pe-md-55 {
    padding-right: 27rem !important;
  }

  .pe-md-56 {
    padding-right: 27.5rem !important;
  }

  .pe-md-57 {
    padding-right: 28rem !important;
  }

  .pe-md-58 {
    padding-right: 28.5rem !important;
  }

  .pe-md-59 {
    padding-right: 29rem !important;
  }

  .pe-md-60 {
    padding-right: 29.5rem !important;
  }

  .pe-md-61 {
    padding-right: 30rem !important;
  }

  .pe-md-62 {
    padding-right: 30.5rem !important;
  }

  .pe-md-63 {
    padding-right: 31rem !important;
  }

  .pe-md-64 {
    padding-right: 31.5rem !important;
  }

  .pe-md-65 {
    padding-right: 32rem !important;
  }

  .pe-md-66 {
    padding-right: 32.5rem !important;
  }

  .pe-md-67 {
    padding-right: 33rem !important;
  }

  .pe-md-68 {
    padding-right: 33.5rem !important;
  }

  .pe-md-69 {
    padding-right: 34rem !important;
  }

  .pe-md-70 {
    padding-right: 34.5rem !important;
  }

  .pe-md-71 {
    padding-right: 35rem !important;
  }

  .pe-md-72 {
    padding-right: 35.5rem !important;
  }

  .pe-md-73 {
    padding-right: 36rem !important;
  }

  .pe-md-74 {
    padding-right: 36.5rem !important;
  }

  .pe-md-75 {
    padding-right: 37rem !important;
  }

  .pe-md-76 {
    padding-right: 37.5rem !important;
  }

  .pe-md-77 {
    padding-right: 38rem !important;
  }

  .pe-md-78 {
    padding-right: 38.5rem !important;
  }

  .pe-md-79 {
    padding-right: 39rem !important;
  }

  .pe-md-80 {
    padding-right: 39.5rem !important;
  }

  .pe-md-81 {
    padding-right: 40rem !important;
  }

  .pe-md-82 {
    padding-right: 40.5rem !important;
  }

  .pe-md-83 {
    padding-right: 41rem !important;
  }

  .pe-md-84 {
    padding-right: 41.5rem !important;
  }

  .pe-md-85 {
    padding-right: 42rem !important;
  }

  .pe-md-86 {
    padding-right: 42.5rem !important;
  }

  .pe-md-87 {
    padding-right: 43rem !important;
  }

  .pe-md-88 {
    padding-right: 43.5rem !important;
  }

  .pe-md-89 {
    padding-right: 44rem !important;
  }

  .pe-md-90 {
    padding-right: 44.5rem !important;
  }

  .pe-md-91 {
    padding-right: 45rem !important;
  }

  .pe-md-92 {
    padding-right: 45.5rem !important;
  }

  .pe-md-93 {
    padding-right: 46rem !important;
  }

  .pe-md-94 {
    padding-right: 46.5rem !important;
  }

  .pe-md-95 {
    padding-right: 47rem !important;
  }

  .pe-md-96 {
    padding-right: 47.5rem !important;
  }

  .pe-md-97 {
    padding-right: 48rem !important;
  }

  .pe-md-98 {
    padding-right: 48.5rem !important;
  }

  .pe-md-99 {
    padding-right: 49rem !important;
  }

  .pe-md-100 {
    padding-right: 49.5rem !important;
  }

  .pe-md-101 {
    padding-right: 50rem !important;
  }

  .pe-md-102 {
    padding-right: 50.5rem !important;
  }

  .pe-md-103 {
    padding-right: 51rem !important;
  }

  .pe-md-104 {
    padding-right: 51.5rem !important;
  }

  .pe-md-105 {
    padding-right: 52rem !important;
  }

  .pe-md-106 {
    padding-right: 52.5rem !important;
  }

  .pe-md-107 {
    padding-right: 53rem !important;
  }

  .pe-md-108 {
    padding-right: 53.5rem !important;
  }

  .pe-md-109 {
    padding-right: 54rem !important;
  }

  .pe-md-110 {
    padding-right: 54.5rem !important;
  }

  .pe-md-111 {
    padding-right: 55rem !important;
  }

  .pe-md-112 {
    padding-right: 55.5rem !important;
  }

  .pe-md-113 {
    padding-right: 56rem !important;
  }

  .pe-md-114 {
    padding-right: 56.5rem !important;
  }

  .pe-md-115 {
    padding-right: 57rem !important;
  }

  .pe-md-116 {
    padding-right: 57.5rem !important;
  }

  .pe-md-117 {
    padding-right: 58rem !important;
  }

  .pe-md-118 {
    padding-right: 58.5rem !important;
  }

  .pe-md-119 {
    padding-right: 59rem !important;
  }

  .pe-md-120 {
    padding-right: 59.5rem !important;
  }

  .pe-md-121 {
    padding-right: 60rem !important;
  }

  .pe-md-122 {
    padding-right: 60.5rem !important;
  }

  .pe-md-123 {
    padding-right: 61rem !important;
  }

  .pe-md-124 {
    padding-right: 61.5rem !important;
  }

  .pe-md-125 {
    padding-right: 62rem !important;
  }

  .pe-md-126 {
    padding-right: 62.5rem !important;
  }

  .pe-md-127 {
    padding-right: 63rem !important;
  }

  .pe-md-128 {
    padding-right: 63.5rem !important;
  }

  .pe-md-129 {
    padding-right: 64rem !important;
  }

  .pe-md-130 {
    padding-right: 64.5rem !important;
  }

  .pe-md-131 {
    padding-right: 65rem !important;
  }

  .pe-md-132 {
    padding-right: 65.5rem !important;
  }

  .pe-md-133 {
    padding-right: 66rem !important;
  }

  .pe-md-134 {
    padding-right: 66.5rem !important;
  }

  .pe-md-135 {
    padding-right: 67rem !important;
  }

  .pe-md-136 {
    padding-right: 67.5rem !important;
  }

  .pe-md-137 {
    padding-right: 68rem !important;
  }

  .pe-md-138 {
    padding-right: 68.5rem !important;
  }

  .pe-md-139 {
    padding-right: 69rem !important;
  }

  .pe-md-140 {
    padding-right: 69.5rem !important;
  }

  .pe-md-141 {
    padding-right: 70rem !important;
  }

  .pe-md-142 {
    padding-right: 70.5rem !important;
  }

  .pe-md-143 {
    padding-right: 71rem !important;
  }

  .pe-md-144 {
    padding-right: 71.5rem !important;
  }

  .pe-md-145 {
    padding-right: 72rem !important;
  }

  .pe-md-146 {
    padding-right: 72.5rem !important;
  }

  .pe-md-147 {
    padding-right: 73rem !important;
  }

  .pe-md-148 {
    padding-right: 73.5rem !important;
  }

  .pe-md-149 {
    padding-right: 74rem !important;
  }

  .pe-md-150 {
    padding-right: 74.5rem !important;
  }

  .pe-md-151 {
    padding-right: 75rem !important;
  }

  .pe-md-152 {
    padding-right: 75.5rem !important;
  }

  .pe-md-153 {
    padding-right: 76rem !important;
  }

  .pe-md-154 {
    padding-right: 76.5rem !important;
  }

  .pe-md-155 {
    padding-right: 77rem !important;
  }

  .pe-md-156 {
    padding-right: 77.5rem !important;
  }

  .pe-md-157 {
    padding-right: 78rem !important;
  }

  .pe-md-158 {
    padding-right: 78.5rem !important;
  }

  .pe-md-159 {
    padding-right: 79rem !important;
  }

  .pe-md-160 {
    padding-right: 79.5rem !important;
  }

  .px-md-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }

  .px-md-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  .px-md-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .px-md-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .px-md-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .px-md-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .px-md-6 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .px-md-7 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .px-md-8 {
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important;
  }

  .px-md-9 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  .px-md-10 {
    padding-left: 4.5rem !important;
    padding-right: 4.5rem !important;
  }

  .px-md-11 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  .px-md-12 {
    padding-left: 5.5rem !important;
    padding-right: 5.5rem !important;
  }

  .px-md-13 {
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  .px-md-14 {
    padding-left: 6.5rem !important;
    padding-right: 6.5rem !important;
  }

  .px-md-15 {
    padding-left: 7rem !important;
    padding-right: 7rem !important;
  }

  .px-md-16 {
    padding-left: 7.5rem !important;
    padding-right: 7.5rem !important;
  }

  .px-md-17 {
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  .px-md-18 {
    padding-left: 8.5rem !important;
    padding-right: 8.5rem !important;
  }

  .px-md-19 {
    padding-left: 9rem !important;
    padding-right: 9rem !important;
  }

  .px-md-20 {
    padding-left: 9.5rem !important;
    padding-right: 9.5rem !important;
  }

  .px-md-21 {
    padding-left: 10rem !important;
    padding-right: 10rem !important;
  }

  .px-md-22 {
    padding-left: 10.5rem !important;
    padding-right: 10.5rem !important;
  }

  .px-md-23 {
    padding-left: 11rem !important;
    padding-right: 11rem !important;
  }

  .px-md-24 {
    padding-left: 11.5rem !important;
    padding-right: 11.5rem !important;
  }

  .px-md-25 {
    padding-left: 12rem !important;
    padding-right: 12rem !important;
  }

  .px-md-26 {
    padding-left: 12.5rem !important;
    padding-right: 12.5rem !important;
  }

  .px-md-27 {
    padding-left: 13rem !important;
    padding-right: 13rem !important;
  }

  .px-md-28 {
    padding-left: 13.5rem !important;
    padding-right: 13.5rem !important;
  }

  .px-md-29 {
    padding-left: 14rem !important;
    padding-right: 14rem !important;
  }

  .px-md-30 {
    padding-left: 14.5rem !important;
    padding-right: 14.5rem !important;
  }

  .px-md-31 {
    padding-left: 15rem !important;
    padding-right: 15rem !important;
  }

  .px-md-32 {
    padding-left: 15.5rem !important;
    padding-right: 15.5rem !important;
  }

  .px-md-33 {
    padding-left: 16rem !important;
    padding-right: 16rem !important;
  }

  .px-md-34 {
    padding-left: 16.5rem !important;
    padding-right: 16.5rem !important;
  }

  .px-md-35 {
    padding-left: 17rem !important;
    padding-right: 17rem !important;
  }

  .px-md-36 {
    padding-left: 17.5rem !important;
    padding-right: 17.5rem !important;
  }

  .px-md-37 {
    padding-left: 18rem !important;
    padding-right: 18rem !important;
  }

  .px-md-38 {
    padding-left: 18.5rem !important;
    padding-right: 18.5rem !important;
  }

  .px-md-39 {
    padding-left: 19rem !important;
    padding-right: 19rem !important;
  }

  .px-md-40 {
    padding-left: 19.5rem !important;
    padding-right: 19.5rem !important;
  }

  .px-md-41 {
    padding-left: 20rem !important;
    padding-right: 20rem !important;
  }

  .px-md-42 {
    padding-left: 20.5rem !important;
    padding-right: 20.5rem !important;
  }

  .px-md-43 {
    padding-left: 21rem !important;
    padding-right: 21rem !important;
  }

  .px-md-44 {
    padding-left: 21.5rem !important;
    padding-right: 21.5rem !important;
  }

  .px-md-45 {
    padding-left: 22rem !important;
    padding-right: 22rem !important;
  }

  .px-md-46 {
    padding-left: 22.5rem !important;
    padding-right: 22.5rem !important;
  }

  .px-md-47 {
    padding-left: 23rem !important;
    padding-right: 23rem !important;
  }

  .px-md-48 {
    padding-left: 23.5rem !important;
    padding-right: 23.5rem !important;
  }

  .px-md-49 {
    padding-left: 24rem !important;
    padding-right: 24rem !important;
  }

  .px-md-50 {
    padding-left: 24.5rem !important;
    padding-right: 24.5rem !important;
  }

  .px-md-51 {
    padding-left: 25rem !important;
    padding-right: 25rem !important;
  }

  .px-md-52 {
    padding-left: 25.5rem !important;
    padding-right: 25.5rem !important;
  }

  .px-md-53 {
    padding-left: 26rem !important;
    padding-right: 26rem !important;
  }

  .px-md-54 {
    padding-left: 26.5rem !important;
    padding-right: 26.5rem !important;
  }

  .px-md-55 {
    padding-left: 27rem !important;
    padding-right: 27rem !important;
  }

  .px-md-56 {
    padding-left: 27.5rem !important;
    padding-right: 27.5rem !important;
  }

  .px-md-57 {
    padding-left: 28rem !important;
    padding-right: 28rem !important;
  }

  .px-md-58 {
    padding-left: 28.5rem !important;
    padding-right: 28.5rem !important;
  }

  .px-md-59 {
    padding-left: 29rem !important;
    padding-right: 29rem !important;
  }

  .px-md-60 {
    padding-left: 29.5rem !important;
    padding-right: 29.5rem !important;
  }

  .px-md-61 {
    padding-left: 30rem !important;
    padding-right: 30rem !important;
  }

  .px-md-62 {
    padding-left: 30.5rem !important;
    padding-right: 30.5rem !important;
  }

  .px-md-63 {
    padding-left: 31rem !important;
    padding-right: 31rem !important;
  }

  .px-md-64 {
    padding-left: 31.5rem !important;
    padding-right: 31.5rem !important;
  }

  .px-md-65 {
    padding-left: 32rem !important;
    padding-right: 32rem !important;
  }

  .px-md-66 {
    padding-left: 32.5rem !important;
    padding-right: 32.5rem !important;
  }

  .px-md-67 {
    padding-left: 33rem !important;
    padding-right: 33rem !important;
  }

  .px-md-68 {
    padding-left: 33.5rem !important;
    padding-right: 33.5rem !important;
  }

  .px-md-69 {
    padding-left: 34rem !important;
    padding-right: 34rem !important;
  }

  .px-md-70 {
    padding-left: 34.5rem !important;
    padding-right: 34.5rem !important;
  }

  .px-md-71 {
    padding-left: 35rem !important;
    padding-right: 35rem !important;
  }

  .px-md-72 {
    padding-left: 35.5rem !important;
    padding-right: 35.5rem !important;
  }

  .px-md-73 {
    padding-left: 36rem !important;
    padding-right: 36rem !important;
  }

  .px-md-74 {
    padding-left: 36.5rem !important;
    padding-right: 36.5rem !important;
  }

  .px-md-75 {
    padding-left: 37rem !important;
    padding-right: 37rem !important;
  }

  .px-md-76 {
    padding-left: 37.5rem !important;
    padding-right: 37.5rem !important;
  }

  .px-md-77 {
    padding-left: 38rem !important;
    padding-right: 38rem !important;
  }

  .px-md-78 {
    padding-left: 38.5rem !important;
    padding-right: 38.5rem !important;
  }

  .px-md-79 {
    padding-left: 39rem !important;
    padding-right: 39rem !important;
  }

  .px-md-80 {
    padding-left: 39.5rem !important;
    padding-right: 39.5rem !important;
  }

  .px-md-81 {
    padding-left: 40rem !important;
    padding-right: 40rem !important;
  }

  .px-md-82 {
    padding-left: 40.5rem !important;
    padding-right: 40.5rem !important;
  }

  .px-md-83 {
    padding-left: 41rem !important;
    padding-right: 41rem !important;
  }

  .px-md-84 {
    padding-left: 41.5rem !important;
    padding-right: 41.5rem !important;
  }

  .px-md-85 {
    padding-left: 42rem !important;
    padding-right: 42rem !important;
  }

  .px-md-86 {
    padding-left: 42.5rem !important;
    padding-right: 42.5rem !important;
  }

  .px-md-87 {
    padding-left: 43rem !important;
    padding-right: 43rem !important;
  }

  .px-md-88 {
    padding-left: 43.5rem !important;
    padding-right: 43.5rem !important;
  }

  .px-md-89 {
    padding-left: 44rem !important;
    padding-right: 44rem !important;
  }

  .px-md-90 {
    padding-left: 44.5rem !important;
    padding-right: 44.5rem !important;
  }

  .px-md-91 {
    padding-left: 45rem !important;
    padding-right: 45rem !important;
  }

  .px-md-92 {
    padding-left: 45.5rem !important;
    padding-right: 45.5rem !important;
  }

  .px-md-93 {
    padding-left: 46rem !important;
    padding-right: 46rem !important;
  }

  .px-md-94 {
    padding-left: 46.5rem !important;
    padding-right: 46.5rem !important;
  }

  .px-md-95 {
    padding-left: 47rem !important;
    padding-right: 47rem !important;
  }

  .px-md-96 {
    padding-left: 47.5rem !important;
    padding-right: 47.5rem !important;
  }

  .px-md-97 {
    padding-left: 48rem !important;
    padding-right: 48rem !important;
  }

  .px-md-98 {
    padding-left: 48.5rem !important;
    padding-right: 48.5rem !important;
  }

  .px-md-99 {
    padding-left: 49rem !important;
    padding-right: 49rem !important;
  }

  .px-md-100 {
    padding-left: 49.5rem !important;
    padding-right: 49.5rem !important;
  }

  .px-md-101 {
    padding-left: 50rem !important;
    padding-right: 50rem !important;
  }

  .px-md-102 {
    padding-left: 50.5rem !important;
    padding-right: 50.5rem !important;
  }

  .px-md-103 {
    padding-left: 51rem !important;
    padding-right: 51rem !important;
  }

  .px-md-104 {
    padding-left: 51.5rem !important;
    padding-right: 51.5rem !important;
  }

  .px-md-105 {
    padding-left: 52rem !important;
    padding-right: 52rem !important;
  }

  .px-md-106 {
    padding-left: 52.5rem !important;
    padding-right: 52.5rem !important;
  }

  .px-md-107 {
    padding-left: 53rem !important;
    padding-right: 53rem !important;
  }

  .px-md-108 {
    padding-left: 53.5rem !important;
    padding-right: 53.5rem !important;
  }

  .px-md-109 {
    padding-left: 54rem !important;
    padding-right: 54rem !important;
  }

  .px-md-110 {
    padding-left: 54.5rem !important;
    padding-right: 54.5rem !important;
  }

  .px-md-111 {
    padding-left: 55rem !important;
    padding-right: 55rem !important;
  }

  .px-md-112 {
    padding-left: 55.5rem !important;
    padding-right: 55.5rem !important;
  }

  .px-md-113 {
    padding-left: 56rem !important;
    padding-right: 56rem !important;
  }

  .px-md-114 {
    padding-left: 56.5rem !important;
    padding-right: 56.5rem !important;
  }

  .px-md-115 {
    padding-left: 57rem !important;
    padding-right: 57rem !important;
  }

  .px-md-116 {
    padding-left: 57.5rem !important;
    padding-right: 57.5rem !important;
  }

  .px-md-117 {
    padding-left: 58rem !important;
    padding-right: 58rem !important;
  }

  .px-md-118 {
    padding-left: 58.5rem !important;
    padding-right: 58.5rem !important;
  }

  .px-md-119 {
    padding-left: 59rem !important;
    padding-right: 59rem !important;
  }

  .px-md-120 {
    padding-left: 59.5rem !important;
    padding-right: 59.5rem !important;
  }

  .px-md-121 {
    padding-left: 60rem !important;
    padding-right: 60rem !important;
  }

  .px-md-122 {
    padding-left: 60.5rem !important;
    padding-right: 60.5rem !important;
  }

  .px-md-123 {
    padding-left: 61rem !important;
    padding-right: 61rem !important;
  }

  .px-md-124 {
    padding-left: 61.5rem !important;
    padding-right: 61.5rem !important;
  }

  .px-md-125 {
    padding-left: 62rem !important;
    padding-right: 62rem !important;
  }

  .px-md-126 {
    padding-left: 62.5rem !important;
    padding-right: 62.5rem !important;
  }

  .px-md-127 {
    padding-left: 63rem !important;
    padding-right: 63rem !important;
  }

  .px-md-128 {
    padding-left: 63.5rem !important;
    padding-right: 63.5rem !important;
  }

  .px-md-129 {
    padding-left: 64rem !important;
    padding-right: 64rem !important;
  }

  .px-md-130 {
    padding-left: 64.5rem !important;
    padding-right: 64.5rem !important;
  }

  .px-md-131 {
    padding-left: 65rem !important;
    padding-right: 65rem !important;
  }

  .px-md-132 {
    padding-left: 65.5rem !important;
    padding-right: 65.5rem !important;
  }

  .px-md-133 {
    padding-left: 66rem !important;
    padding-right: 66rem !important;
  }

  .px-md-134 {
    padding-left: 66.5rem !important;
    padding-right: 66.5rem !important;
  }

  .px-md-135 {
    padding-left: 67rem !important;
    padding-right: 67rem !important;
  }

  .px-md-136 {
    padding-left: 67.5rem !important;
    padding-right: 67.5rem !important;
  }

  .px-md-137 {
    padding-left: 68rem !important;
    padding-right: 68rem !important;
  }

  .px-md-138 {
    padding-left: 68.5rem !important;
    padding-right: 68.5rem !important;
  }

  .px-md-139 {
    padding-left: 69rem !important;
    padding-right: 69rem !important;
  }

  .px-md-140 {
    padding-left: 69.5rem !important;
    padding-right: 69.5rem !important;
  }

  .px-md-141 {
    padding-left: 70rem !important;
    padding-right: 70rem !important;
  }

  .px-md-142 {
    padding-left: 70.5rem !important;
    padding-right: 70.5rem !important;
  }

  .px-md-143 {
    padding-left: 71rem !important;
    padding-right: 71rem !important;
  }

  .px-md-144 {
    padding-left: 71.5rem !important;
    padding-right: 71.5rem !important;
  }

  .px-md-145 {
    padding-left: 72rem !important;
    padding-right: 72rem !important;
  }

  .px-md-146 {
    padding-left: 72.5rem !important;
    padding-right: 72.5rem !important;
  }

  .px-md-147 {
    padding-left: 73rem !important;
    padding-right: 73rem !important;
  }

  .px-md-148 {
    padding-left: 73.5rem !important;
    padding-right: 73.5rem !important;
  }

  .px-md-149 {
    padding-left: 74rem !important;
    padding-right: 74rem !important;
  }

  .px-md-150 {
    padding-left: 74.5rem !important;
    padding-right: 74.5rem !important;
  }

  .px-md-151 {
    padding-left: 75rem !important;
    padding-right: 75rem !important;
  }

  .px-md-152 {
    padding-left: 75.5rem !important;
    padding-right: 75.5rem !important;
  }

  .px-md-153 {
    padding-left: 76rem !important;
    padding-right: 76rem !important;
  }

  .px-md-154 {
    padding-left: 76.5rem !important;
    padding-right: 76.5rem !important;
  }

  .px-md-155 {
    padding-left: 77rem !important;
    padding-right: 77rem !important;
  }

  .px-md-156 {
    padding-left: 77.5rem !important;
    padding-right: 77.5rem !important;
  }

  .px-md-157 {
    padding-left: 78rem !important;
    padding-right: 78rem !important;
  }

  .px-md-158 {
    padding-left: 78.5rem !important;
    padding-right: 78.5rem !important;
  }

  .px-md-159 {
    padding-left: 79rem !important;
    padding-right: 79rem !important;
  }

  .px-md-160 {
    padding-left: 79.5rem !important;
    padding-right: 79.5rem !important;
  }

  .py-md-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-md-6 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-md-7 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-md-8 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-md-9 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-md-10 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-md-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .py-md-12 {
    padding-top: 5.5rem !important;
    padding-bottom: 5.5rem !important;
  }

  .py-md-13 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  .py-md-14 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }

  .py-md-15 {
    padding-top: 7rem !important;
    padding-bottom: 7rem !important;
  }

  .py-md-16 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }

  .py-md-17 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  .py-md-18 {
    padding-top: 8.5rem !important;
    padding-bottom: 8.5rem !important;
  }

  .py-md-19 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }

  .py-md-20 {
    padding-top: 9.5rem !important;
    padding-bottom: 9.5rem !important;
  }

  .py-md-21 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }

  .py-md-22 {
    padding-top: 10.5rem !important;
    padding-bottom: 10.5rem !important;
  }

  .py-md-23 {
    padding-top: 11rem !important;
    padding-bottom: 11rem !important;
  }

  .py-md-24 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }

  .py-md-25 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }

  .py-md-26 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }

  .py-md-27 {
    padding-top: 13rem !important;
    padding-bottom: 13rem !important;
  }

  .py-md-28 {
    padding-top: 13.5rem !important;
    padding-bottom: 13.5rem !important;
  }

  .py-md-29 {
    padding-top: 14rem !important;
    padding-bottom: 14rem !important;
  }

  .py-md-30 {
    padding-top: 14.5rem !important;
    padding-bottom: 14.5rem !important;
  }

  .py-md-31 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }

  .py-md-32 {
    padding-top: 15.5rem !important;
    padding-bottom: 15.5rem !important;
  }

  .py-md-33 {
    padding-top: 16rem !important;
    padding-bottom: 16rem !important;
  }

  .py-md-34 {
    padding-top: 16.5rem !important;
    padding-bottom: 16.5rem !important;
  }

  .py-md-35 {
    padding-top: 17rem !important;
    padding-bottom: 17rem !important;
  }

  .py-md-36 {
    padding-top: 17.5rem !important;
    padding-bottom: 17.5rem !important;
  }

  .py-md-37 {
    padding-top: 18rem !important;
    padding-bottom: 18rem !important;
  }

  .py-md-38 {
    padding-top: 18.5rem !important;
    padding-bottom: 18.5rem !important;
  }

  .py-md-39 {
    padding-top: 19rem !important;
    padding-bottom: 19rem !important;
  }

  .py-md-40 {
    padding-top: 19.5rem !important;
    padding-bottom: 19.5rem !important;
  }

  .py-md-41 {
    padding-top: 20rem !important;
    padding-bottom: 20rem !important;
  }

  .py-md-42 {
    padding-top: 20.5rem !important;
    padding-bottom: 20.5rem !important;
  }

  .py-md-43 {
    padding-top: 21rem !important;
    padding-bottom: 21rem !important;
  }

  .py-md-44 {
    padding-top: 21.5rem !important;
    padding-bottom: 21.5rem !important;
  }

  .py-md-45 {
    padding-top: 22rem !important;
    padding-bottom: 22rem !important;
  }

  .py-md-46 {
    padding-top: 22.5rem !important;
    padding-bottom: 22.5rem !important;
  }

  .py-md-47 {
    padding-top: 23rem !important;
    padding-bottom: 23rem !important;
  }

  .py-md-48 {
    padding-top: 23.5rem !important;
    padding-bottom: 23.5rem !important;
  }

  .py-md-49 {
    padding-top: 24rem !important;
    padding-bottom: 24rem !important;
  }

  .py-md-50 {
    padding-top: 24.5rem !important;
    padding-bottom: 24.5rem !important;
  }

  .py-md-51 {
    padding-top: 25rem !important;
    padding-bottom: 25rem !important;
  }

  .py-md-52 {
    padding-top: 25.5rem !important;
    padding-bottom: 25.5rem !important;
  }

  .py-md-53 {
    padding-top: 26rem !important;
    padding-bottom: 26rem !important;
  }

  .py-md-54 {
    padding-top: 26.5rem !important;
    padding-bottom: 26.5rem !important;
  }

  .py-md-55 {
    padding-top: 27rem !important;
    padding-bottom: 27rem !important;
  }

  .py-md-56 {
    padding-top: 27.5rem !important;
    padding-bottom: 27.5rem !important;
  }

  .py-md-57 {
    padding-top: 28rem !important;
    padding-bottom: 28rem !important;
  }

  .py-md-58 {
    padding-top: 28.5rem !important;
    padding-bottom: 28.5rem !important;
  }

  .py-md-59 {
    padding-top: 29rem !important;
    padding-bottom: 29rem !important;
  }

  .py-md-60 {
    padding-top: 29.5rem !important;
    padding-bottom: 29.5rem !important;
  }

  .py-md-61 {
    padding-top: 30rem !important;
    padding-bottom: 30rem !important;
  }

  .py-md-62 {
    padding-top: 30.5rem !important;
    padding-bottom: 30.5rem !important;
  }

  .py-md-63 {
    padding-top: 31rem !important;
    padding-bottom: 31rem !important;
  }

  .py-md-64 {
    padding-top: 31.5rem !important;
    padding-bottom: 31.5rem !important;
  }

  .py-md-65 {
    padding-top: 32rem !important;
    padding-bottom: 32rem !important;
  }

  .py-md-66 {
    padding-top: 32.5rem !important;
    padding-bottom: 32.5rem !important;
  }

  .py-md-67 {
    padding-top: 33rem !important;
    padding-bottom: 33rem !important;
  }

  .py-md-68 {
    padding-top: 33.5rem !important;
    padding-bottom: 33.5rem !important;
  }

  .py-md-69 {
    padding-top: 34rem !important;
    padding-bottom: 34rem !important;
  }

  .py-md-70 {
    padding-top: 34.5rem !important;
    padding-bottom: 34.5rem !important;
  }

  .py-md-71 {
    padding-top: 35rem !important;
    padding-bottom: 35rem !important;
  }

  .py-md-72 {
    padding-top: 35.5rem !important;
    padding-bottom: 35.5rem !important;
  }

  .py-md-73 {
    padding-top: 36rem !important;
    padding-bottom: 36rem !important;
  }

  .py-md-74 {
    padding-top: 36.5rem !important;
    padding-bottom: 36.5rem !important;
  }

  .py-md-75 {
    padding-top: 37rem !important;
    padding-bottom: 37rem !important;
  }

  .py-md-76 {
    padding-top: 37.5rem !important;
    padding-bottom: 37.5rem !important;
  }

  .py-md-77 {
    padding-top: 38rem !important;
    padding-bottom: 38rem !important;
  }

  .py-md-78 {
    padding-top: 38.5rem !important;
    padding-bottom: 38.5rem !important;
  }

  .py-md-79 {
    padding-top: 39rem !important;
    padding-bottom: 39rem !important;
  }

  .py-md-80 {
    padding-top: 39.5rem !important;
    padding-bottom: 39.5rem !important;
  }

  .py-md-81 {
    padding-top: 40rem !important;
    padding-bottom: 40rem !important;
  }

  .py-md-82 {
    padding-top: 40.5rem !important;
    padding-bottom: 40.5rem !important;
  }

  .py-md-83 {
    padding-top: 41rem !important;
    padding-bottom: 41rem !important;
  }

  .py-md-84 {
    padding-top: 41.5rem !important;
    padding-bottom: 41.5rem !important;
  }

  .py-md-85 {
    padding-top: 42rem !important;
    padding-bottom: 42rem !important;
  }

  .py-md-86 {
    padding-top: 42.5rem !important;
    padding-bottom: 42.5rem !important;
  }

  .py-md-87 {
    padding-top: 43rem !important;
    padding-bottom: 43rem !important;
  }

  .py-md-88 {
    padding-top: 43.5rem !important;
    padding-bottom: 43.5rem !important;
  }

  .py-md-89 {
    padding-top: 44rem !important;
    padding-bottom: 44rem !important;
  }

  .py-md-90 {
    padding-top: 44.5rem !important;
    padding-bottom: 44.5rem !important;
  }

  .py-md-91 {
    padding-top: 45rem !important;
    padding-bottom: 45rem !important;
  }

  .py-md-92 {
    padding-top: 45.5rem !important;
    padding-bottom: 45.5rem !important;
  }

  .py-md-93 {
    padding-top: 46rem !important;
    padding-bottom: 46rem !important;
  }

  .py-md-94 {
    padding-top: 46.5rem !important;
    padding-bottom: 46.5rem !important;
  }

  .py-md-95 {
    padding-top: 47rem !important;
    padding-bottom: 47rem !important;
  }

  .py-md-96 {
    padding-top: 47.5rem !important;
    padding-bottom: 47.5rem !important;
  }

  .py-md-97 {
    padding-top: 48rem !important;
    padding-bottom: 48rem !important;
  }

  .py-md-98 {
    padding-top: 48.5rem !important;
    padding-bottom: 48.5rem !important;
  }

  .py-md-99 {
    padding-top: 49rem !important;
    padding-bottom: 49rem !important;
  }

  .py-md-100 {
    padding-top: 49.5rem !important;
    padding-bottom: 49.5rem !important;
  }

  .py-md-101 {
    padding-top: 50rem !important;
    padding-bottom: 50rem !important;
  }

  .py-md-102 {
    padding-top: 50.5rem !important;
    padding-bottom: 50.5rem !important;
  }

  .py-md-103 {
    padding-top: 51rem !important;
    padding-bottom: 51rem !important;
  }

  .py-md-104 {
    padding-top: 51.5rem !important;
    padding-bottom: 51.5rem !important;
  }

  .py-md-105 {
    padding-top: 52rem !important;
    padding-bottom: 52rem !important;
  }

  .py-md-106 {
    padding-top: 52.5rem !important;
    padding-bottom: 52.5rem !important;
  }

  .py-md-107 {
    padding-top: 53rem !important;
    padding-bottom: 53rem !important;
  }

  .py-md-108 {
    padding-top: 53.5rem !important;
    padding-bottom: 53.5rem !important;
  }

  .py-md-109 {
    padding-top: 54rem !important;
    padding-bottom: 54rem !important;
  }

  .py-md-110 {
    padding-top: 54.5rem !important;
    padding-bottom: 54.5rem !important;
  }

  .py-md-111 {
    padding-top: 55rem !important;
    padding-bottom: 55rem !important;
  }

  .py-md-112 {
    padding-top: 55.5rem !important;
    padding-bottom: 55.5rem !important;
  }

  .py-md-113 {
    padding-top: 56rem !important;
    padding-bottom: 56rem !important;
  }

  .py-md-114 {
    padding-top: 56.5rem !important;
    padding-bottom: 56.5rem !important;
  }

  .py-md-115 {
    padding-top: 57rem !important;
    padding-bottom: 57rem !important;
  }

  .py-md-116 {
    padding-top: 57.5rem !important;
    padding-bottom: 57.5rem !important;
  }

  .py-md-117 {
    padding-top: 58rem !important;
    padding-bottom: 58rem !important;
  }

  .py-md-118 {
    padding-top: 58.5rem !important;
    padding-bottom: 58.5rem !important;
  }

  .py-md-119 {
    padding-top: 59rem !important;
    padding-bottom: 59rem !important;
  }

  .py-md-120 {
    padding-top: 59.5rem !important;
    padding-bottom: 59.5rem !important;
  }

  .py-md-121 {
    padding-top: 60rem !important;
    padding-bottom: 60rem !important;
  }

  .py-md-122 {
    padding-top: 60.5rem !important;
    padding-bottom: 60.5rem !important;
  }

  .py-md-123 {
    padding-top: 61rem !important;
    padding-bottom: 61rem !important;
  }

  .py-md-124 {
    padding-top: 61.5rem !important;
    padding-bottom: 61.5rem !important;
  }

  .py-md-125 {
    padding-top: 62rem !important;
    padding-bottom: 62rem !important;
  }

  .py-md-126 {
    padding-top: 62.5rem !important;
    padding-bottom: 62.5rem !important;
  }

  .py-md-127 {
    padding-top: 63rem !important;
    padding-bottom: 63rem !important;
  }

  .py-md-128 {
    padding-top: 63.5rem !important;
    padding-bottom: 63.5rem !important;
  }

  .py-md-129 {
    padding-top: 64rem !important;
    padding-bottom: 64rem !important;
  }

  .py-md-130 {
    padding-top: 64.5rem !important;
    padding-bottom: 64.5rem !important;
  }

  .py-md-131 {
    padding-top: 65rem !important;
    padding-bottom: 65rem !important;
  }

  .py-md-132 {
    padding-top: 65.5rem !important;
    padding-bottom: 65.5rem !important;
  }

  .py-md-133 {
    padding-top: 66rem !important;
    padding-bottom: 66rem !important;
  }

  .py-md-134 {
    padding-top: 66.5rem !important;
    padding-bottom: 66.5rem !important;
  }

  .py-md-135 {
    padding-top: 67rem !important;
    padding-bottom: 67rem !important;
  }

  .py-md-136 {
    padding-top: 67.5rem !important;
    padding-bottom: 67.5rem !important;
  }

  .py-md-137 {
    padding-top: 68rem !important;
    padding-bottom: 68rem !important;
  }

  .py-md-138 {
    padding-top: 68.5rem !important;
    padding-bottom: 68.5rem !important;
  }

  .py-md-139 {
    padding-top: 69rem !important;
    padding-bottom: 69rem !important;
  }

  .py-md-140 {
    padding-top: 69.5rem !important;
    padding-bottom: 69.5rem !important;
  }

  .py-md-141 {
    padding-top: 70rem !important;
    padding-bottom: 70rem !important;
  }

  .py-md-142 {
    padding-top: 70.5rem !important;
    padding-bottom: 70.5rem !important;
  }

  .py-md-143 {
    padding-top: 71rem !important;
    padding-bottom: 71rem !important;
  }

  .py-md-144 {
    padding-top: 71.5rem !important;
    padding-bottom: 71.5rem !important;
  }

  .py-md-145 {
    padding-top: 72rem !important;
    padding-bottom: 72rem !important;
  }

  .py-md-146 {
    padding-top: 72.5rem !important;
    padding-bottom: 72.5rem !important;
  }

  .py-md-147 {
    padding-top: 73rem !important;
    padding-bottom: 73rem !important;
  }

  .py-md-148 {
    padding-top: 73.5rem !important;
    padding-bottom: 73.5rem !important;
  }

  .py-md-149 {
    padding-top: 74rem !important;
    padding-bottom: 74rem !important;
  }

  .py-md-150 {
    padding-top: 74.5rem !important;
    padding-bottom: 74.5rem !important;
  }

  .py-md-151 {
    padding-top: 75rem !important;
    padding-bottom: 75rem !important;
  }

  .py-md-152 {
    padding-top: 75.5rem !important;
    padding-bottom: 75.5rem !important;
  }

  .py-md-153 {
    padding-top: 76rem !important;
    padding-bottom: 76rem !important;
  }

  .py-md-154 {
    padding-top: 76.5rem !important;
    padding-bottom: 76.5rem !important;
  }

  .py-md-155 {
    padding-top: 77rem !important;
    padding-bottom: 77rem !important;
  }

  .py-md-156 {
    padding-top: 77.5rem !important;
    padding-bottom: 77.5rem !important;
  }

  .py-md-157 {
    padding-top: 78rem !important;
    padding-bottom: 78rem !important;
  }

  .py-md-158 {
    padding-top: 78.5rem !important;
    padding-bottom: 78.5rem !important;
  }

  .py-md-159 {
    padding-top: 79rem !important;
    padding-bottom: 79rem !important;
  }

  .py-md-160 {
    padding-top: 79.5rem !important;
    padding-bottom: 79.5rem !important;
  }
}
@media (min-width: 992px) {
  .p-lg-0 {
    padding: 0rem !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 2rem !important;
  }

  .p-lg-6 {
    padding: 2.5rem !important;
  }

  .p-lg-7 {
    padding: 3rem !important;
  }

  .p-lg-8 {
    padding: 3.5rem !important;
  }

  .p-lg-9 {
    padding: 4rem !important;
  }

  .p-lg-10 {
    padding: 4.5rem !important;
  }

  .p-lg-11 {
    padding: 5rem !important;
  }

  .p-lg-12 {
    padding: 5.5rem !important;
  }

  .p-lg-13 {
    padding: 6rem !important;
  }

  .p-lg-14 {
    padding: 6.5rem !important;
  }

  .p-lg-15 {
    padding: 7rem !important;
  }

  .p-lg-16 {
    padding: 7.5rem !important;
  }

  .p-lg-17 {
    padding: 8rem !important;
  }

  .p-lg-18 {
    padding: 8.5rem !important;
  }

  .p-lg-19 {
    padding: 9rem !important;
  }

  .p-lg-20 {
    padding: 9.5rem !important;
  }

  .p-lg-21 {
    padding: 10rem !important;
  }

  .p-lg-22 {
    padding: 10.5rem !important;
  }

  .p-lg-23 {
    padding: 11rem !important;
  }

  .p-lg-24 {
    padding: 11.5rem !important;
  }

  .p-lg-25 {
    padding: 12rem !important;
  }

  .p-lg-26 {
    padding: 12.5rem !important;
  }

  .p-lg-27 {
    padding: 13rem !important;
  }

  .p-lg-28 {
    padding: 13.5rem !important;
  }

  .p-lg-29 {
    padding: 14rem !important;
  }

  .p-lg-30 {
    padding: 14.5rem !important;
  }

  .p-lg-31 {
    padding: 15rem !important;
  }

  .p-lg-32 {
    padding: 15.5rem !important;
  }

  .p-lg-33 {
    padding: 16rem !important;
  }

  .p-lg-34 {
    padding: 16.5rem !important;
  }

  .p-lg-35 {
    padding: 17rem !important;
  }

  .p-lg-36 {
    padding: 17.5rem !important;
  }

  .p-lg-37 {
    padding: 18rem !important;
  }

  .p-lg-38 {
    padding: 18.5rem !important;
  }

  .p-lg-39 {
    padding: 19rem !important;
  }

  .p-lg-40 {
    padding: 19.5rem !important;
  }

  .p-lg-41 {
    padding: 20rem !important;
  }

  .p-lg-42 {
    padding: 20.5rem !important;
  }

  .p-lg-43 {
    padding: 21rem !important;
  }

  .p-lg-44 {
    padding: 21.5rem !important;
  }

  .p-lg-45 {
    padding: 22rem !important;
  }

  .p-lg-46 {
    padding: 22.5rem !important;
  }

  .p-lg-47 {
    padding: 23rem !important;
  }

  .p-lg-48 {
    padding: 23.5rem !important;
  }

  .p-lg-49 {
    padding: 24rem !important;
  }

  .p-lg-50 {
    padding: 24.5rem !important;
  }

  .p-lg-51 {
    padding: 25rem !important;
  }

  .p-lg-52 {
    padding: 25.5rem !important;
  }

  .p-lg-53 {
    padding: 26rem !important;
  }

  .p-lg-54 {
    padding: 26.5rem !important;
  }

  .p-lg-55 {
    padding: 27rem !important;
  }

  .p-lg-56 {
    padding: 27.5rem !important;
  }

  .p-lg-57 {
    padding: 28rem !important;
  }

  .p-lg-58 {
    padding: 28.5rem !important;
  }

  .p-lg-59 {
    padding: 29rem !important;
  }

  .p-lg-60 {
    padding: 29.5rem !important;
  }

  .p-lg-61 {
    padding: 30rem !important;
  }

  .p-lg-62 {
    padding: 30.5rem !important;
  }

  .p-lg-63 {
    padding: 31rem !important;
  }

  .p-lg-64 {
    padding: 31.5rem !important;
  }

  .p-lg-65 {
    padding: 32rem !important;
  }

  .p-lg-66 {
    padding: 32.5rem !important;
  }

  .p-lg-67 {
    padding: 33rem !important;
  }

  .p-lg-68 {
    padding: 33.5rem !important;
  }

  .p-lg-69 {
    padding: 34rem !important;
  }

  .p-lg-70 {
    padding: 34.5rem !important;
  }

  .p-lg-71 {
    padding: 35rem !important;
  }

  .p-lg-72 {
    padding: 35.5rem !important;
  }

  .p-lg-73 {
    padding: 36rem !important;
  }

  .p-lg-74 {
    padding: 36.5rem !important;
  }

  .p-lg-75 {
    padding: 37rem !important;
  }

  .p-lg-76 {
    padding: 37.5rem !important;
  }

  .p-lg-77 {
    padding: 38rem !important;
  }

  .p-lg-78 {
    padding: 38.5rem !important;
  }

  .p-lg-79 {
    padding: 39rem !important;
  }

  .p-lg-80 {
    padding: 39.5rem !important;
  }

  .p-lg-81 {
    padding: 40rem !important;
  }

  .p-lg-82 {
    padding: 40.5rem !important;
  }

  .p-lg-83 {
    padding: 41rem !important;
  }

  .p-lg-84 {
    padding: 41.5rem !important;
  }

  .p-lg-85 {
    padding: 42rem !important;
  }

  .p-lg-86 {
    padding: 42.5rem !important;
  }

  .p-lg-87 {
    padding: 43rem !important;
  }

  .p-lg-88 {
    padding: 43.5rem !important;
  }

  .p-lg-89 {
    padding: 44rem !important;
  }

  .p-lg-90 {
    padding: 44.5rem !important;
  }

  .p-lg-91 {
    padding: 45rem !important;
  }

  .p-lg-92 {
    padding: 45.5rem !important;
  }

  .p-lg-93 {
    padding: 46rem !important;
  }

  .p-lg-94 {
    padding: 46.5rem !important;
  }

  .p-lg-95 {
    padding: 47rem !important;
  }

  .p-lg-96 {
    padding: 47.5rem !important;
  }

  .p-lg-97 {
    padding: 48rem !important;
  }

  .p-lg-98 {
    padding: 48.5rem !important;
  }

  .p-lg-99 {
    padding: 49rem !important;
  }

  .p-lg-100 {
    padding: 49.5rem !important;
  }

  .p-lg-101 {
    padding: 50rem !important;
  }

  .p-lg-102 {
    padding: 50.5rem !important;
  }

  .p-lg-103 {
    padding: 51rem !important;
  }

  .p-lg-104 {
    padding: 51.5rem !important;
  }

  .p-lg-105 {
    padding: 52rem !important;
  }

  .p-lg-106 {
    padding: 52.5rem !important;
  }

  .p-lg-107 {
    padding: 53rem !important;
  }

  .p-lg-108 {
    padding: 53.5rem !important;
  }

  .p-lg-109 {
    padding: 54rem !important;
  }

  .p-lg-110 {
    padding: 54.5rem !important;
  }

  .p-lg-111 {
    padding: 55rem !important;
  }

  .p-lg-112 {
    padding: 55.5rem !important;
  }

  .p-lg-113 {
    padding: 56rem !important;
  }

  .p-lg-114 {
    padding: 56.5rem !important;
  }

  .p-lg-115 {
    padding: 57rem !important;
  }

  .p-lg-116 {
    padding: 57.5rem !important;
  }

  .p-lg-117 {
    padding: 58rem !important;
  }

  .p-lg-118 {
    padding: 58.5rem !important;
  }

  .p-lg-119 {
    padding: 59rem !important;
  }

  .p-lg-120 {
    padding: 59.5rem !important;
  }

  .p-lg-121 {
    padding: 60rem !important;
  }

  .p-lg-122 {
    padding: 60.5rem !important;
  }

  .p-lg-123 {
    padding: 61rem !important;
  }

  .p-lg-124 {
    padding: 61.5rem !important;
  }

  .p-lg-125 {
    padding: 62rem !important;
  }

  .p-lg-126 {
    padding: 62.5rem !important;
  }

  .p-lg-127 {
    padding: 63rem !important;
  }

  .p-lg-128 {
    padding: 63.5rem !important;
  }

  .p-lg-129 {
    padding: 64rem !important;
  }

  .p-lg-130 {
    padding: 64.5rem !important;
  }

  .p-lg-131 {
    padding: 65rem !important;
  }

  .p-lg-132 {
    padding: 65.5rem !important;
  }

  .p-lg-133 {
    padding: 66rem !important;
  }

  .p-lg-134 {
    padding: 66.5rem !important;
  }

  .p-lg-135 {
    padding: 67rem !important;
  }

  .p-lg-136 {
    padding: 67.5rem !important;
  }

  .p-lg-137 {
    padding: 68rem !important;
  }

  .p-lg-138 {
    padding: 68.5rem !important;
  }

  .p-lg-139 {
    padding: 69rem !important;
  }

  .p-lg-140 {
    padding: 69.5rem !important;
  }

  .p-lg-141 {
    padding: 70rem !important;
  }

  .p-lg-142 {
    padding: 70.5rem !important;
  }

  .p-lg-143 {
    padding: 71rem !important;
  }

  .p-lg-144 {
    padding: 71.5rem !important;
  }

  .p-lg-145 {
    padding: 72rem !important;
  }

  .p-lg-146 {
    padding: 72.5rem !important;
  }

  .p-lg-147 {
    padding: 73rem !important;
  }

  .p-lg-148 {
    padding: 73.5rem !important;
  }

  .p-lg-149 {
    padding: 74rem !important;
  }

  .p-lg-150 {
    padding: 74.5rem !important;
  }

  .p-lg-151 {
    padding: 75rem !important;
  }

  .p-lg-152 {
    padding: 75.5rem !important;
  }

  .p-lg-153 {
    padding: 76rem !important;
  }

  .p-lg-154 {
    padding: 76.5rem !important;
  }

  .p-lg-155 {
    padding: 77rem !important;
  }

  .p-lg-156 {
    padding: 77.5rem !important;
  }

  .p-lg-157 {
    padding: 78rem !important;
  }

  .p-lg-158 {
    padding: 78.5rem !important;
  }

  .p-lg-159 {
    padding: 79rem !important;
  }

  .p-lg-160 {
    padding: 79.5rem !important;
  }

  .pt-lg-0 {
    padding-top: 0rem !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 1rem !important;
  }

  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-5 {
    padding-top: 2rem !important;
  }

  .pt-lg-6 {
    padding-top: 2.5rem !important;
  }

  .pt-lg-7 {
    padding-top: 3rem !important;
  }

  .pt-lg-8 {
    padding-top: 3.5rem !important;
  }

  .pt-lg-9 {
    padding-top: 4rem !important;
  }

  .pt-lg-10 {
    padding-top: 4.5rem !important;
  }

  .pt-lg-11 {
    padding-top: 5rem !important;
  }

  .pt-lg-12 {
    padding-top: 5.5rem !important;
  }

  .pt-lg-13 {
    padding-top: 6rem !important;
  }

  .pt-lg-14 {
    padding-top: 6.5rem !important;
  }

  .pt-lg-15 {
    padding-top: 7rem !important;
  }

  .pt-lg-16 {
    padding-top: 7.5rem !important;
  }

  .pt-lg-17 {
    padding-top: 8rem !important;
  }

  .pt-lg-18 {
    padding-top: 8.5rem !important;
  }

  .pt-lg-19 {
    padding-top: 9rem !important;
  }

  .pt-lg-20 {
    padding-top: 9.5rem !important;
  }

  .pt-lg-21 {
    padding-top: 10rem !important;
  }

  .pt-lg-22 {
    padding-top: 10.5rem !important;
  }

  .pt-lg-23 {
    padding-top: 11rem !important;
  }

  .pt-lg-24 {
    padding-top: 11.5rem !important;
  }

  .pt-lg-25 {
    padding-top: 12rem !important;
  }

  .pt-lg-26 {
    padding-top: 12.5rem !important;
  }

  .pt-lg-27 {
    padding-top: 13rem !important;
  }

  .pt-lg-28 {
    padding-top: 13.5rem !important;
  }

  .pt-lg-29 {
    padding-top: 14rem !important;
  }

  .pt-lg-30 {
    padding-top: 14.5rem !important;
  }

  .pt-lg-31 {
    padding-top: 15rem !important;
  }

  .pt-lg-32 {
    padding-top: 15.5rem !important;
  }

  .pt-lg-33 {
    padding-top: 16rem !important;
  }

  .pt-lg-34 {
    padding-top: 16.5rem !important;
  }

  .pt-lg-35 {
    padding-top: 17rem !important;
  }

  .pt-lg-36 {
    padding-top: 17.5rem !important;
  }

  .pt-lg-37 {
    padding-top: 18rem !important;
  }

  .pt-lg-38 {
    padding-top: 18.5rem !important;
  }

  .pt-lg-39 {
    padding-top: 19rem !important;
  }

  .pt-lg-40 {
    padding-top: 19.5rem !important;
  }

  .pt-lg-41 {
    padding-top: 20rem !important;
  }

  .pt-lg-42 {
    padding-top: 20.5rem !important;
  }

  .pt-lg-43 {
    padding-top: 21rem !important;
  }

  .pt-lg-44 {
    padding-top: 21.5rem !important;
  }

  .pt-lg-45 {
    padding-top: 22rem !important;
  }

  .pt-lg-46 {
    padding-top: 22.5rem !important;
  }

  .pt-lg-47 {
    padding-top: 23rem !important;
  }

  .pt-lg-48 {
    padding-top: 23.5rem !important;
  }

  .pt-lg-49 {
    padding-top: 24rem !important;
  }

  .pt-lg-50 {
    padding-top: 24.5rem !important;
  }

  .pt-lg-51 {
    padding-top: 25rem !important;
  }

  .pt-lg-52 {
    padding-top: 25.5rem !important;
  }

  .pt-lg-53 {
    padding-top: 26rem !important;
  }

  .pt-lg-54 {
    padding-top: 26.5rem !important;
  }

  .pt-lg-55 {
    padding-top: 27rem !important;
  }

  .pt-lg-56 {
    padding-top: 27.5rem !important;
  }

  .pt-lg-57 {
    padding-top: 28rem !important;
  }

  .pt-lg-58 {
    padding-top: 28.5rem !important;
  }

  .pt-lg-59 {
    padding-top: 29rem !important;
  }

  .pt-lg-60 {
    padding-top: 29.5rem !important;
  }

  .pt-lg-61 {
    padding-top: 30rem !important;
  }

  .pt-lg-62 {
    padding-top: 30.5rem !important;
  }

  .pt-lg-63 {
    padding-top: 31rem !important;
  }

  .pt-lg-64 {
    padding-top: 31.5rem !important;
  }

  .pt-lg-65 {
    padding-top: 32rem !important;
  }

  .pt-lg-66 {
    padding-top: 32.5rem !important;
  }

  .pt-lg-67 {
    padding-top: 33rem !important;
  }

  .pt-lg-68 {
    padding-top: 33.5rem !important;
  }

  .pt-lg-69 {
    padding-top: 34rem !important;
  }

  .pt-lg-70 {
    padding-top: 34.5rem !important;
  }

  .pt-lg-71 {
    padding-top: 35rem !important;
  }

  .pt-lg-72 {
    padding-top: 35.5rem !important;
  }

  .pt-lg-73 {
    padding-top: 36rem !important;
  }

  .pt-lg-74 {
    padding-top: 36.5rem !important;
  }

  .pt-lg-75 {
    padding-top: 37rem !important;
  }

  .pt-lg-76 {
    padding-top: 37.5rem !important;
  }

  .pt-lg-77 {
    padding-top: 38rem !important;
  }

  .pt-lg-78 {
    padding-top: 38.5rem !important;
  }

  .pt-lg-79 {
    padding-top: 39rem !important;
  }

  .pt-lg-80 {
    padding-top: 39.5rem !important;
  }

  .pt-lg-81 {
    padding-top: 40rem !important;
  }

  .pt-lg-82 {
    padding-top: 40.5rem !important;
  }

  .pt-lg-83 {
    padding-top: 41rem !important;
  }

  .pt-lg-84 {
    padding-top: 41.5rem !important;
  }

  .pt-lg-85 {
    padding-top: 42rem !important;
  }

  .pt-lg-86 {
    padding-top: 42.5rem !important;
  }

  .pt-lg-87 {
    padding-top: 43rem !important;
  }

  .pt-lg-88 {
    padding-top: 43.5rem !important;
  }

  .pt-lg-89 {
    padding-top: 44rem !important;
  }

  .pt-lg-90 {
    padding-top: 44.5rem !important;
  }

  .pt-lg-91 {
    padding-top: 45rem !important;
  }

  .pt-lg-92 {
    padding-top: 45.5rem !important;
  }

  .pt-lg-93 {
    padding-top: 46rem !important;
  }

  .pt-lg-94 {
    padding-top: 46.5rem !important;
  }

  .pt-lg-95 {
    padding-top: 47rem !important;
  }

  .pt-lg-96 {
    padding-top: 47.5rem !important;
  }

  .pt-lg-97 {
    padding-top: 48rem !important;
  }

  .pt-lg-98 {
    padding-top: 48.5rem !important;
  }

  .pt-lg-99 {
    padding-top: 49rem !important;
  }

  .pt-lg-100 {
    padding-top: 49.5rem !important;
  }

  .pt-lg-101 {
    padding-top: 50rem !important;
  }

  .pt-lg-102 {
    padding-top: 50.5rem !important;
  }

  .pt-lg-103 {
    padding-top: 51rem !important;
  }

  .pt-lg-104 {
    padding-top: 51.5rem !important;
  }

  .pt-lg-105 {
    padding-top: 52rem !important;
  }

  .pt-lg-106 {
    padding-top: 52.5rem !important;
  }

  .pt-lg-107 {
    padding-top: 53rem !important;
  }

  .pt-lg-108 {
    padding-top: 53.5rem !important;
  }

  .pt-lg-109 {
    padding-top: 54rem !important;
  }

  .pt-lg-110 {
    padding-top: 54.5rem !important;
  }

  .pt-lg-111 {
    padding-top: 55rem !important;
  }

  .pt-lg-112 {
    padding-top: 55.5rem !important;
  }

  .pt-lg-113 {
    padding-top: 56rem !important;
  }

  .pt-lg-114 {
    padding-top: 56.5rem !important;
  }

  .pt-lg-115 {
    padding-top: 57rem !important;
  }

  .pt-lg-116 {
    padding-top: 57.5rem !important;
  }

  .pt-lg-117 {
    padding-top: 58rem !important;
  }

  .pt-lg-118 {
    padding-top: 58.5rem !important;
  }

  .pt-lg-119 {
    padding-top: 59rem !important;
  }

  .pt-lg-120 {
    padding-top: 59.5rem !important;
  }

  .pt-lg-121 {
    padding-top: 60rem !important;
  }

  .pt-lg-122 {
    padding-top: 60.5rem !important;
  }

  .pt-lg-123 {
    padding-top: 61rem !important;
  }

  .pt-lg-124 {
    padding-top: 61.5rem !important;
  }

  .pt-lg-125 {
    padding-top: 62rem !important;
  }

  .pt-lg-126 {
    padding-top: 62.5rem !important;
  }

  .pt-lg-127 {
    padding-top: 63rem !important;
  }

  .pt-lg-128 {
    padding-top: 63.5rem !important;
  }

  .pt-lg-129 {
    padding-top: 64rem !important;
  }

  .pt-lg-130 {
    padding-top: 64.5rem !important;
  }

  .pt-lg-131 {
    padding-top: 65rem !important;
  }

  .pt-lg-132 {
    padding-top: 65.5rem !important;
  }

  .pt-lg-133 {
    padding-top: 66rem !important;
  }

  .pt-lg-134 {
    padding-top: 66.5rem !important;
  }

  .pt-lg-135 {
    padding-top: 67rem !important;
  }

  .pt-lg-136 {
    padding-top: 67.5rem !important;
  }

  .pt-lg-137 {
    padding-top: 68rem !important;
  }

  .pt-lg-138 {
    padding-top: 68.5rem !important;
  }

  .pt-lg-139 {
    padding-top: 69rem !important;
  }

  .pt-lg-140 {
    padding-top: 69.5rem !important;
  }

  .pt-lg-141 {
    padding-top: 70rem !important;
  }

  .pt-lg-142 {
    padding-top: 70.5rem !important;
  }

  .pt-lg-143 {
    padding-top: 71rem !important;
  }

  .pt-lg-144 {
    padding-top: 71.5rem !important;
  }

  .pt-lg-145 {
    padding-top: 72rem !important;
  }

  .pt-lg-146 {
    padding-top: 72.5rem !important;
  }

  .pt-lg-147 {
    padding-top: 73rem !important;
  }

  .pt-lg-148 {
    padding-top: 73.5rem !important;
  }

  .pt-lg-149 {
    padding-top: 74rem !important;
  }

  .pt-lg-150 {
    padding-top: 74.5rem !important;
  }

  .pt-lg-151 {
    padding-top: 75rem !important;
  }

  .pt-lg-152 {
    padding-top: 75.5rem !important;
  }

  .pt-lg-153 {
    padding-top: 76rem !important;
  }

  .pt-lg-154 {
    padding-top: 76.5rem !important;
  }

  .pt-lg-155 {
    padding-top: 77rem !important;
  }

  .pt-lg-156 {
    padding-top: 77.5rem !important;
  }

  .pt-lg-157 {
    padding-top: 78rem !important;
  }

  .pt-lg-158 {
    padding-top: 78.5rem !important;
  }

  .pt-lg-159 {
    padding-top: 79rem !important;
  }

  .pt-lg-160 {
    padding-top: 79.5rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0rem !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 2rem !important;
  }

  .pb-lg-6 {
    padding-bottom: 2.5rem !important;
  }

  .pb-lg-7 {
    padding-bottom: 3rem !important;
  }

  .pb-lg-8 {
    padding-bottom: 3.5rem !important;
  }

  .pb-lg-9 {
    padding-bottom: 4rem !important;
  }

  .pb-lg-10 {
    padding-bottom: 4.5rem !important;
  }

  .pb-lg-11 {
    padding-bottom: 5rem !important;
  }

  .pb-lg-12 {
    padding-bottom: 5.5rem !important;
  }

  .pb-lg-13 {
    padding-bottom: 6rem !important;
  }

  .pb-lg-14 {
    padding-bottom: 6.5rem !important;
  }

  .pb-lg-15 {
    padding-bottom: 7rem !important;
  }

  .pb-lg-16 {
    padding-bottom: 7.5rem !important;
  }

  .pb-lg-17 {
    padding-bottom: 8rem !important;
  }

  .pb-lg-18 {
    padding-bottom: 8.5rem !important;
  }

  .pb-lg-19 {
    padding-bottom: 9rem !important;
  }

  .pb-lg-20 {
    padding-bottom: 9.5rem !important;
  }

  .pb-lg-21 {
    padding-bottom: 10rem !important;
  }

  .pb-lg-22 {
    padding-bottom: 10.5rem !important;
  }

  .pb-lg-23 {
    padding-bottom: 11rem !important;
  }

  .pb-lg-24 {
    padding-bottom: 11.5rem !important;
  }

  .pb-lg-25 {
    padding-bottom: 12rem !important;
  }

  .pb-lg-26 {
    padding-bottom: 12.5rem !important;
  }

  .pb-lg-27 {
    padding-bottom: 13rem !important;
  }

  .pb-lg-28 {
    padding-bottom: 13.5rem !important;
  }

  .pb-lg-29 {
    padding-bottom: 14rem !important;
  }

  .pb-lg-30 {
    padding-bottom: 14.5rem !important;
  }

  .pb-lg-31 {
    padding-bottom: 15rem !important;
  }

  .pb-lg-32 {
    padding-bottom: 15.5rem !important;
  }

  .pb-lg-33 {
    padding-bottom: 16rem !important;
  }

  .pb-lg-34 {
    padding-bottom: 16.5rem !important;
  }

  .pb-lg-35 {
    padding-bottom: 17rem !important;
  }

  .pb-lg-36 {
    padding-bottom: 17.5rem !important;
  }

  .pb-lg-37 {
    padding-bottom: 18rem !important;
  }

  .pb-lg-38 {
    padding-bottom: 18.5rem !important;
  }

  .pb-lg-39 {
    padding-bottom: 19rem !important;
  }

  .pb-lg-40 {
    padding-bottom: 19.5rem !important;
  }

  .pb-lg-41 {
    padding-bottom: 20rem !important;
  }

  .pb-lg-42 {
    padding-bottom: 20.5rem !important;
  }

  .pb-lg-43 {
    padding-bottom: 21rem !important;
  }

  .pb-lg-44 {
    padding-bottom: 21.5rem !important;
  }

  .pb-lg-45 {
    padding-bottom: 22rem !important;
  }

  .pb-lg-46 {
    padding-bottom: 22.5rem !important;
  }

  .pb-lg-47 {
    padding-bottom: 23rem !important;
  }

  .pb-lg-48 {
    padding-bottom: 23.5rem !important;
  }

  .pb-lg-49 {
    padding-bottom: 24rem !important;
  }

  .pb-lg-50 {
    padding-bottom: 24.5rem !important;
  }

  .pb-lg-51 {
    padding-bottom: 25rem !important;
  }

  .pb-lg-52 {
    padding-bottom: 25.5rem !important;
  }

  .pb-lg-53 {
    padding-bottom: 26rem !important;
  }

  .pb-lg-54 {
    padding-bottom: 26.5rem !important;
  }

  .pb-lg-55 {
    padding-bottom: 27rem !important;
  }

  .pb-lg-56 {
    padding-bottom: 27.5rem !important;
  }

  .pb-lg-57 {
    padding-bottom: 28rem !important;
  }

  .pb-lg-58 {
    padding-bottom: 28.5rem !important;
  }

  .pb-lg-59 {
    padding-bottom: 29rem !important;
  }

  .pb-lg-60 {
    padding-bottom: 29.5rem !important;
  }

  .pb-lg-61 {
    padding-bottom: 30rem !important;
  }

  .pb-lg-62 {
    padding-bottom: 30.5rem !important;
  }

  .pb-lg-63 {
    padding-bottom: 31rem !important;
  }

  .pb-lg-64 {
    padding-bottom: 31.5rem !important;
  }

  .pb-lg-65 {
    padding-bottom: 32rem !important;
  }

  .pb-lg-66 {
    padding-bottom: 32.5rem !important;
  }

  .pb-lg-67 {
    padding-bottom: 33rem !important;
  }

  .pb-lg-68 {
    padding-bottom: 33.5rem !important;
  }

  .pb-lg-69 {
    padding-bottom: 34rem !important;
  }

  .pb-lg-70 {
    padding-bottom: 34.5rem !important;
  }

  .pb-lg-71 {
    padding-bottom: 35rem !important;
  }

  .pb-lg-72 {
    padding-bottom: 35.5rem !important;
  }

  .pb-lg-73 {
    padding-bottom: 36rem !important;
  }

  .pb-lg-74 {
    padding-bottom: 36.5rem !important;
  }

  .pb-lg-75 {
    padding-bottom: 37rem !important;
  }

  .pb-lg-76 {
    padding-bottom: 37.5rem !important;
  }

  .pb-lg-77 {
    padding-bottom: 38rem !important;
  }

  .pb-lg-78 {
    padding-bottom: 38.5rem !important;
  }

  .pb-lg-79 {
    padding-bottom: 39rem !important;
  }

  .pb-lg-80 {
    padding-bottom: 39.5rem !important;
  }

  .pb-lg-81 {
    padding-bottom: 40rem !important;
  }

  .pb-lg-82 {
    padding-bottom: 40.5rem !important;
  }

  .pb-lg-83 {
    padding-bottom: 41rem !important;
  }

  .pb-lg-84 {
    padding-bottom: 41.5rem !important;
  }

  .pb-lg-85 {
    padding-bottom: 42rem !important;
  }

  .pb-lg-86 {
    padding-bottom: 42.5rem !important;
  }

  .pb-lg-87 {
    padding-bottom: 43rem !important;
  }

  .pb-lg-88 {
    padding-bottom: 43.5rem !important;
  }

  .pb-lg-89 {
    padding-bottom: 44rem !important;
  }

  .pb-lg-90 {
    padding-bottom: 44.5rem !important;
  }

  .pb-lg-91 {
    padding-bottom: 45rem !important;
  }

  .pb-lg-92 {
    padding-bottom: 45.5rem !important;
  }

  .pb-lg-93 {
    padding-bottom: 46rem !important;
  }

  .pb-lg-94 {
    padding-bottom: 46.5rem !important;
  }

  .pb-lg-95 {
    padding-bottom: 47rem !important;
  }

  .pb-lg-96 {
    padding-bottom: 47.5rem !important;
  }

  .pb-lg-97 {
    padding-bottom: 48rem !important;
  }

  .pb-lg-98 {
    padding-bottom: 48.5rem !important;
  }

  .pb-lg-99 {
    padding-bottom: 49rem !important;
  }

  .pb-lg-100 {
    padding-bottom: 49.5rem !important;
  }

  .pb-lg-101 {
    padding-bottom: 50rem !important;
  }

  .pb-lg-102 {
    padding-bottom: 50.5rem !important;
  }

  .pb-lg-103 {
    padding-bottom: 51rem !important;
  }

  .pb-lg-104 {
    padding-bottom: 51.5rem !important;
  }

  .pb-lg-105 {
    padding-bottom: 52rem !important;
  }

  .pb-lg-106 {
    padding-bottom: 52.5rem !important;
  }

  .pb-lg-107 {
    padding-bottom: 53rem !important;
  }

  .pb-lg-108 {
    padding-bottom: 53.5rem !important;
  }

  .pb-lg-109 {
    padding-bottom: 54rem !important;
  }

  .pb-lg-110 {
    padding-bottom: 54.5rem !important;
  }

  .pb-lg-111 {
    padding-bottom: 55rem !important;
  }

  .pb-lg-112 {
    padding-bottom: 55.5rem !important;
  }

  .pb-lg-113 {
    padding-bottom: 56rem !important;
  }

  .pb-lg-114 {
    padding-bottom: 56.5rem !important;
  }

  .pb-lg-115 {
    padding-bottom: 57rem !important;
  }

  .pb-lg-116 {
    padding-bottom: 57.5rem !important;
  }

  .pb-lg-117 {
    padding-bottom: 58rem !important;
  }

  .pb-lg-118 {
    padding-bottom: 58.5rem !important;
  }

  .pb-lg-119 {
    padding-bottom: 59rem !important;
  }

  .pb-lg-120 {
    padding-bottom: 59.5rem !important;
  }

  .pb-lg-121 {
    padding-bottom: 60rem !important;
  }

  .pb-lg-122 {
    padding-bottom: 60.5rem !important;
  }

  .pb-lg-123 {
    padding-bottom: 61rem !important;
  }

  .pb-lg-124 {
    padding-bottom: 61.5rem !important;
  }

  .pb-lg-125 {
    padding-bottom: 62rem !important;
  }

  .pb-lg-126 {
    padding-bottom: 62.5rem !important;
  }

  .pb-lg-127 {
    padding-bottom: 63rem !important;
  }

  .pb-lg-128 {
    padding-bottom: 63.5rem !important;
  }

  .pb-lg-129 {
    padding-bottom: 64rem !important;
  }

  .pb-lg-130 {
    padding-bottom: 64.5rem !important;
  }

  .pb-lg-131 {
    padding-bottom: 65rem !important;
  }

  .pb-lg-132 {
    padding-bottom: 65.5rem !important;
  }

  .pb-lg-133 {
    padding-bottom: 66rem !important;
  }

  .pb-lg-134 {
    padding-bottom: 66.5rem !important;
  }

  .pb-lg-135 {
    padding-bottom: 67rem !important;
  }

  .pb-lg-136 {
    padding-bottom: 67.5rem !important;
  }

  .pb-lg-137 {
    padding-bottom: 68rem !important;
  }

  .pb-lg-138 {
    padding-bottom: 68.5rem !important;
  }

  .pb-lg-139 {
    padding-bottom: 69rem !important;
  }

  .pb-lg-140 {
    padding-bottom: 69.5rem !important;
  }

  .pb-lg-141 {
    padding-bottom: 70rem !important;
  }

  .pb-lg-142 {
    padding-bottom: 70.5rem !important;
  }

  .pb-lg-143 {
    padding-bottom: 71rem !important;
  }

  .pb-lg-144 {
    padding-bottom: 71.5rem !important;
  }

  .pb-lg-145 {
    padding-bottom: 72rem !important;
  }

  .pb-lg-146 {
    padding-bottom: 72.5rem !important;
  }

  .pb-lg-147 {
    padding-bottom: 73rem !important;
  }

  .pb-lg-148 {
    padding-bottom: 73.5rem !important;
  }

  .pb-lg-149 {
    padding-bottom: 74rem !important;
  }

  .pb-lg-150 {
    padding-bottom: 74.5rem !important;
  }

  .pb-lg-151 {
    padding-bottom: 75rem !important;
  }

  .pb-lg-152 {
    padding-bottom: 75.5rem !important;
  }

  .pb-lg-153 {
    padding-bottom: 76rem !important;
  }

  .pb-lg-154 {
    padding-bottom: 76.5rem !important;
  }

  .pb-lg-155 {
    padding-bottom: 77rem !important;
  }

  .pb-lg-156 {
    padding-bottom: 77.5rem !important;
  }

  .pb-lg-157 {
    padding-bottom: 78rem !important;
  }

  .pb-lg-158 {
    padding-bottom: 78.5rem !important;
  }

  .pb-lg-159 {
    padding-bottom: 79rem !important;
  }

  .pb-lg-160 {
    padding-bottom: 79.5rem !important;
  }

  .ps-lg-0 {
    padding-left: 0rem !important;
  }

  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  .ps-lg-3 {
    padding-left: 1rem !important;
  }

  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }

  .ps-lg-5 {
    padding-left: 2rem !important;
  }

  .ps-lg-6 {
    padding-left: 2.5rem !important;
  }

  .ps-lg-7 {
    padding-left: 3rem !important;
  }

  .ps-lg-8 {
    padding-left: 3.5rem !important;
  }

  .ps-lg-9 {
    padding-left: 4rem !important;
  }

  .ps-lg-10 {
    padding-left: 4.5rem !important;
  }

  .ps-lg-11 {
    padding-left: 5rem !important;
  }

  .ps-lg-12 {
    padding-left: 5.5rem !important;
  }

  .ps-lg-13 {
    padding-left: 6rem !important;
  }

  .ps-lg-14 {
    padding-left: 6.5rem !important;
  }

  .ps-lg-15 {
    padding-left: 7rem !important;
  }

  .ps-lg-16 {
    padding-left: 7.5rem !important;
  }

  .ps-lg-17 {
    padding-left: 8rem !important;
  }

  .ps-lg-18 {
    padding-left: 8.5rem !important;
  }

  .ps-lg-19 {
    padding-left: 9rem !important;
  }

  .ps-lg-20 {
    padding-left: 9.5rem !important;
  }

  .ps-lg-21 {
    padding-left: 10rem !important;
  }

  .ps-lg-22 {
    padding-left: 10.5rem !important;
  }

  .ps-lg-23 {
    padding-left: 11rem !important;
  }

  .ps-lg-24 {
    padding-left: 11.5rem !important;
  }

  .ps-lg-25 {
    padding-left: 12rem !important;
  }

  .ps-lg-26 {
    padding-left: 12.5rem !important;
  }

  .ps-lg-27 {
    padding-left: 13rem !important;
  }

  .ps-lg-28 {
    padding-left: 13.5rem !important;
  }

  .ps-lg-29 {
    padding-left: 14rem !important;
  }

  .ps-lg-30 {
    padding-left: 14.5rem !important;
  }

  .ps-lg-31 {
    padding-left: 15rem !important;
  }

  .ps-lg-32 {
    padding-left: 15.5rem !important;
  }

  .ps-lg-33 {
    padding-left: 16rem !important;
  }

  .ps-lg-34 {
    padding-left: 16.5rem !important;
  }

  .ps-lg-35 {
    padding-left: 17rem !important;
  }

  .ps-lg-36 {
    padding-left: 17.5rem !important;
  }

  .ps-lg-37 {
    padding-left: 18rem !important;
  }

  .ps-lg-38 {
    padding-left: 18.5rem !important;
  }

  .ps-lg-39 {
    padding-left: 19rem !important;
  }

  .ps-lg-40 {
    padding-left: 19.5rem !important;
  }

  .ps-lg-41 {
    padding-left: 20rem !important;
  }

  .ps-lg-42 {
    padding-left: 20.5rem !important;
  }

  .ps-lg-43 {
    padding-left: 21rem !important;
  }

  .ps-lg-44 {
    padding-left: 21.5rem !important;
  }

  .ps-lg-45 {
    padding-left: 22rem !important;
  }

  .ps-lg-46 {
    padding-left: 22.5rem !important;
  }

  .ps-lg-47 {
    padding-left: 23rem !important;
  }

  .ps-lg-48 {
    padding-left: 23.5rem !important;
  }

  .ps-lg-49 {
    padding-left: 24rem !important;
  }

  .ps-lg-50 {
    padding-left: 24.5rem !important;
  }

  .ps-lg-51 {
    padding-left: 25rem !important;
  }

  .ps-lg-52 {
    padding-left: 25.5rem !important;
  }

  .ps-lg-53 {
    padding-left: 26rem !important;
  }

  .ps-lg-54 {
    padding-left: 26.5rem !important;
  }

  .ps-lg-55 {
    padding-left: 27rem !important;
  }

  .ps-lg-56 {
    padding-left: 27.5rem !important;
  }

  .ps-lg-57 {
    padding-left: 28rem !important;
  }

  .ps-lg-58 {
    padding-left: 28.5rem !important;
  }

  .ps-lg-59 {
    padding-left: 29rem !important;
  }

  .ps-lg-60 {
    padding-left: 29.5rem !important;
  }

  .ps-lg-61 {
    padding-left: 30rem !important;
  }

  .ps-lg-62 {
    padding-left: 30.5rem !important;
  }

  .ps-lg-63 {
    padding-left: 31rem !important;
  }

  .ps-lg-64 {
    padding-left: 31.5rem !important;
  }

  .ps-lg-65 {
    padding-left: 32rem !important;
  }

  .ps-lg-66 {
    padding-left: 32.5rem !important;
  }

  .ps-lg-67 {
    padding-left: 33rem !important;
  }

  .ps-lg-68 {
    padding-left: 33.5rem !important;
  }

  .ps-lg-69 {
    padding-left: 34rem !important;
  }

  .ps-lg-70 {
    padding-left: 34.5rem !important;
  }

  .ps-lg-71 {
    padding-left: 35rem !important;
  }

  .ps-lg-72 {
    padding-left: 35.5rem !important;
  }

  .ps-lg-73 {
    padding-left: 36rem !important;
  }

  .ps-lg-74 {
    padding-left: 36.5rem !important;
  }

  .ps-lg-75 {
    padding-left: 37rem !important;
  }

  .ps-lg-76 {
    padding-left: 37.5rem !important;
  }

  .ps-lg-77 {
    padding-left: 38rem !important;
  }

  .ps-lg-78 {
    padding-left: 38.5rem !important;
  }

  .ps-lg-79 {
    padding-left: 39rem !important;
  }

  .ps-lg-80 {
    padding-left: 39.5rem !important;
  }

  .ps-lg-81 {
    padding-left: 40rem !important;
  }

  .ps-lg-82 {
    padding-left: 40.5rem !important;
  }

  .ps-lg-83 {
    padding-left: 41rem !important;
  }

  .ps-lg-84 {
    padding-left: 41.5rem !important;
  }

  .ps-lg-85 {
    padding-left: 42rem !important;
  }

  .ps-lg-86 {
    padding-left: 42.5rem !important;
  }

  .ps-lg-87 {
    padding-left: 43rem !important;
  }

  .ps-lg-88 {
    padding-left: 43.5rem !important;
  }

  .ps-lg-89 {
    padding-left: 44rem !important;
  }

  .ps-lg-90 {
    padding-left: 44.5rem !important;
  }

  .ps-lg-91 {
    padding-left: 45rem !important;
  }

  .ps-lg-92 {
    padding-left: 45.5rem !important;
  }

  .ps-lg-93 {
    padding-left: 46rem !important;
  }

  .ps-lg-94 {
    padding-left: 46.5rem !important;
  }

  .ps-lg-95 {
    padding-left: 47rem !important;
  }

  .ps-lg-96 {
    padding-left: 47.5rem !important;
  }

  .ps-lg-97 {
    padding-left: 48rem !important;
  }

  .ps-lg-98 {
    padding-left: 48.5rem !important;
  }

  .ps-lg-99 {
    padding-left: 49rem !important;
  }

  .ps-lg-100 {
    padding-left: 49.5rem !important;
  }

  .ps-lg-101 {
    padding-left: 50rem !important;
  }

  .ps-lg-102 {
    padding-left: 50.5rem !important;
  }

  .ps-lg-103 {
    padding-left: 51rem !important;
  }

  .ps-lg-104 {
    padding-left: 51.5rem !important;
  }

  .ps-lg-105 {
    padding-left: 52rem !important;
  }

  .ps-lg-106 {
    padding-left: 52.5rem !important;
  }

  .ps-lg-107 {
    padding-left: 53rem !important;
  }

  .ps-lg-108 {
    padding-left: 53.5rem !important;
  }

  .ps-lg-109 {
    padding-left: 54rem !important;
  }

  .ps-lg-110 {
    padding-left: 54.5rem !important;
  }

  .ps-lg-111 {
    padding-left: 55rem !important;
  }

  .ps-lg-112 {
    padding-left: 55.5rem !important;
  }

  .ps-lg-113 {
    padding-left: 56rem !important;
  }

  .ps-lg-114 {
    padding-left: 56.5rem !important;
  }

  .ps-lg-115 {
    padding-left: 57rem !important;
  }

  .ps-lg-116 {
    padding-left: 57.5rem !important;
  }

  .ps-lg-117 {
    padding-left: 58rem !important;
  }

  .ps-lg-118 {
    padding-left: 58.5rem !important;
  }

  .ps-lg-119 {
    padding-left: 59rem !important;
  }

  .ps-lg-120 {
    padding-left: 59.5rem !important;
  }

  .ps-lg-121 {
    padding-left: 60rem !important;
  }

  .ps-lg-122 {
    padding-left: 60.5rem !important;
  }

  .ps-lg-123 {
    padding-left: 61rem !important;
  }

  .ps-lg-124 {
    padding-left: 61.5rem !important;
  }

  .ps-lg-125 {
    padding-left: 62rem !important;
  }

  .ps-lg-126 {
    padding-left: 62.5rem !important;
  }

  .ps-lg-127 {
    padding-left: 63rem !important;
  }

  .ps-lg-128 {
    padding-left: 63.5rem !important;
  }

  .ps-lg-129 {
    padding-left: 64rem !important;
  }

  .ps-lg-130 {
    padding-left: 64.5rem !important;
  }

  .ps-lg-131 {
    padding-left: 65rem !important;
  }

  .ps-lg-132 {
    padding-left: 65.5rem !important;
  }

  .ps-lg-133 {
    padding-left: 66rem !important;
  }

  .ps-lg-134 {
    padding-left: 66.5rem !important;
  }

  .ps-lg-135 {
    padding-left: 67rem !important;
  }

  .ps-lg-136 {
    padding-left: 67.5rem !important;
  }

  .ps-lg-137 {
    padding-left: 68rem !important;
  }

  .ps-lg-138 {
    padding-left: 68.5rem !important;
  }

  .ps-lg-139 {
    padding-left: 69rem !important;
  }

  .ps-lg-140 {
    padding-left: 69.5rem !important;
  }

  .ps-lg-141 {
    padding-left: 70rem !important;
  }

  .ps-lg-142 {
    padding-left: 70.5rem !important;
  }

  .ps-lg-143 {
    padding-left: 71rem !important;
  }

  .ps-lg-144 {
    padding-left: 71.5rem !important;
  }

  .ps-lg-145 {
    padding-left: 72rem !important;
  }

  .ps-lg-146 {
    padding-left: 72.5rem !important;
  }

  .ps-lg-147 {
    padding-left: 73rem !important;
  }

  .ps-lg-148 {
    padding-left: 73.5rem !important;
  }

  .ps-lg-149 {
    padding-left: 74rem !important;
  }

  .ps-lg-150 {
    padding-left: 74.5rem !important;
  }

  .ps-lg-151 {
    padding-left: 75rem !important;
  }

  .ps-lg-152 {
    padding-left: 75.5rem !important;
  }

  .ps-lg-153 {
    padding-left: 76rem !important;
  }

  .ps-lg-154 {
    padding-left: 76.5rem !important;
  }

  .ps-lg-155 {
    padding-left: 77rem !important;
  }

  .ps-lg-156 {
    padding-left: 77.5rem !important;
  }

  .ps-lg-157 {
    padding-left: 78rem !important;
  }

  .ps-lg-158 {
    padding-left: 78.5rem !important;
  }

  .ps-lg-159 {
    padding-left: 79rem !important;
  }

  .ps-lg-160 {
    padding-left: 79.5rem !important;
  }

  .pe-lg-0 {
    padding-right: 0rem !important;
  }

  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pe-lg-3 {
    padding-right: 1rem !important;
  }

  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }

  .pe-lg-5 {
    padding-right: 2rem !important;
  }

  .pe-lg-6 {
    padding-right: 2.5rem !important;
  }

  .pe-lg-7 {
    padding-right: 3rem !important;
  }

  .pe-lg-8 {
    padding-right: 3.5rem !important;
  }

  .pe-lg-9 {
    padding-right: 4rem !important;
  }

  .pe-lg-10 {
    padding-right: 4.5rem !important;
  }

  .pe-lg-11 {
    padding-right: 5rem !important;
  }

  .pe-lg-12 {
    padding-right: 5.5rem !important;
  }

  .pe-lg-13 {
    padding-right: 6rem !important;
  }

  .pe-lg-14 {
    padding-right: 6.5rem !important;
  }

  .pe-lg-15 {
    padding-right: 7rem !important;
  }

  .pe-lg-16 {
    padding-right: 7.5rem !important;
  }

  .pe-lg-17 {
    padding-right: 8rem !important;
  }

  .pe-lg-18 {
    padding-right: 8.5rem !important;
  }

  .pe-lg-19 {
    padding-right: 9rem !important;
  }

  .pe-lg-20 {
    padding-right: 9.5rem !important;
  }

  .pe-lg-21 {
    padding-right: 10rem !important;
  }

  .pe-lg-22 {
    padding-right: 10.5rem !important;
  }

  .pe-lg-23 {
    padding-right: 11rem !important;
  }

  .pe-lg-24 {
    padding-right: 11.5rem !important;
  }

  .pe-lg-25 {
    padding-right: 12rem !important;
  }

  .pe-lg-26 {
    padding-right: 12.5rem !important;
  }

  .pe-lg-27 {
    padding-right: 13rem !important;
  }

  .pe-lg-28 {
    padding-right: 13.5rem !important;
  }

  .pe-lg-29 {
    padding-right: 14rem !important;
  }

  .pe-lg-30 {
    padding-right: 14.5rem !important;
  }

  .pe-lg-31 {
    padding-right: 15rem !important;
  }

  .pe-lg-32 {
    padding-right: 15.5rem !important;
  }

  .pe-lg-33 {
    padding-right: 16rem !important;
  }

  .pe-lg-34 {
    padding-right: 16.5rem !important;
  }

  .pe-lg-35 {
    padding-right: 17rem !important;
  }

  .pe-lg-36 {
    padding-right: 17.5rem !important;
  }

  .pe-lg-37 {
    padding-right: 18rem !important;
  }

  .pe-lg-38 {
    padding-right: 18.5rem !important;
  }

  .pe-lg-39 {
    padding-right: 19rem !important;
  }

  .pe-lg-40 {
    padding-right: 19.5rem !important;
  }

  .pe-lg-41 {
    padding-right: 20rem !important;
  }

  .pe-lg-42 {
    padding-right: 20.5rem !important;
  }

  .pe-lg-43 {
    padding-right: 21rem !important;
  }

  .pe-lg-44 {
    padding-right: 21.5rem !important;
  }

  .pe-lg-45 {
    padding-right: 22rem !important;
  }

  .pe-lg-46 {
    padding-right: 22.5rem !important;
  }

  .pe-lg-47 {
    padding-right: 23rem !important;
  }

  .pe-lg-48 {
    padding-right: 23.5rem !important;
  }

  .pe-lg-49 {
    padding-right: 24rem !important;
  }

  .pe-lg-50 {
    padding-right: 24.5rem !important;
  }

  .pe-lg-51 {
    padding-right: 25rem !important;
  }

  .pe-lg-52 {
    padding-right: 25.5rem !important;
  }

  .pe-lg-53 {
    padding-right: 26rem !important;
  }

  .pe-lg-54 {
    padding-right: 26.5rem !important;
  }

  .pe-lg-55 {
    padding-right: 27rem !important;
  }

  .pe-lg-56 {
    padding-right: 27.5rem !important;
  }

  .pe-lg-57 {
    padding-right: 28rem !important;
  }

  .pe-lg-58 {
    padding-right: 28.5rem !important;
  }

  .pe-lg-59 {
    padding-right: 29rem !important;
  }

  .pe-lg-60 {
    padding-right: 29.5rem !important;
  }

  .pe-lg-61 {
    padding-right: 30rem !important;
  }

  .pe-lg-62 {
    padding-right: 30.5rem !important;
  }

  .pe-lg-63 {
    padding-right: 31rem !important;
  }

  .pe-lg-64 {
    padding-right: 31.5rem !important;
  }

  .pe-lg-65 {
    padding-right: 32rem !important;
  }

  .pe-lg-66 {
    padding-right: 32.5rem !important;
  }

  .pe-lg-67 {
    padding-right: 33rem !important;
  }

  .pe-lg-68 {
    padding-right: 33.5rem !important;
  }

  .pe-lg-69 {
    padding-right: 34rem !important;
  }

  .pe-lg-70 {
    padding-right: 34.5rem !important;
  }

  .pe-lg-71 {
    padding-right: 35rem !important;
  }

  .pe-lg-72 {
    padding-right: 35.5rem !important;
  }

  .pe-lg-73 {
    padding-right: 36rem !important;
  }

  .pe-lg-74 {
    padding-right: 36.5rem !important;
  }

  .pe-lg-75 {
    padding-right: 37rem !important;
  }

  .pe-lg-76 {
    padding-right: 37.5rem !important;
  }

  .pe-lg-77 {
    padding-right: 38rem !important;
  }

  .pe-lg-78 {
    padding-right: 38.5rem !important;
  }

  .pe-lg-79 {
    padding-right: 39rem !important;
  }

  .pe-lg-80 {
    padding-right: 39.5rem !important;
  }

  .pe-lg-81 {
    padding-right: 40rem !important;
  }

  .pe-lg-82 {
    padding-right: 40.5rem !important;
  }

  .pe-lg-83 {
    padding-right: 41rem !important;
  }

  .pe-lg-84 {
    padding-right: 41.5rem !important;
  }

  .pe-lg-85 {
    padding-right: 42rem !important;
  }

  .pe-lg-86 {
    padding-right: 42.5rem !important;
  }

  .pe-lg-87 {
    padding-right: 43rem !important;
  }

  .pe-lg-88 {
    padding-right: 43.5rem !important;
  }

  .pe-lg-89 {
    padding-right: 44rem !important;
  }

  .pe-lg-90 {
    padding-right: 44.5rem !important;
  }

  .pe-lg-91 {
    padding-right: 45rem !important;
  }

  .pe-lg-92 {
    padding-right: 45.5rem !important;
  }

  .pe-lg-93 {
    padding-right: 46rem !important;
  }

  .pe-lg-94 {
    padding-right: 46.5rem !important;
  }

  .pe-lg-95 {
    padding-right: 47rem !important;
  }

  .pe-lg-96 {
    padding-right: 47.5rem !important;
  }

  .pe-lg-97 {
    padding-right: 48rem !important;
  }

  .pe-lg-98 {
    padding-right: 48.5rem !important;
  }

  .pe-lg-99 {
    padding-right: 49rem !important;
  }

  .pe-lg-100 {
    padding-right: 49.5rem !important;
  }

  .pe-lg-101 {
    padding-right: 50rem !important;
  }

  .pe-lg-102 {
    padding-right: 50.5rem !important;
  }

  .pe-lg-103 {
    padding-right: 51rem !important;
  }

  .pe-lg-104 {
    padding-right: 51.5rem !important;
  }

  .pe-lg-105 {
    padding-right: 52rem !important;
  }

  .pe-lg-106 {
    padding-right: 52.5rem !important;
  }

  .pe-lg-107 {
    padding-right: 53rem !important;
  }

  .pe-lg-108 {
    padding-right: 53.5rem !important;
  }

  .pe-lg-109 {
    padding-right: 54rem !important;
  }

  .pe-lg-110 {
    padding-right: 54.5rem !important;
  }

  .pe-lg-111 {
    padding-right: 55rem !important;
  }

  .pe-lg-112 {
    padding-right: 55.5rem !important;
  }

  .pe-lg-113 {
    padding-right: 56rem !important;
  }

  .pe-lg-114 {
    padding-right: 56.5rem !important;
  }

  .pe-lg-115 {
    padding-right: 57rem !important;
  }

  .pe-lg-116 {
    padding-right: 57.5rem !important;
  }

  .pe-lg-117 {
    padding-right: 58rem !important;
  }

  .pe-lg-118 {
    padding-right: 58.5rem !important;
  }

  .pe-lg-119 {
    padding-right: 59rem !important;
  }

  .pe-lg-120 {
    padding-right: 59.5rem !important;
  }

  .pe-lg-121 {
    padding-right: 60rem !important;
  }

  .pe-lg-122 {
    padding-right: 60.5rem !important;
  }

  .pe-lg-123 {
    padding-right: 61rem !important;
  }

  .pe-lg-124 {
    padding-right: 61.5rem !important;
  }

  .pe-lg-125 {
    padding-right: 62rem !important;
  }

  .pe-lg-126 {
    padding-right: 62.5rem !important;
  }

  .pe-lg-127 {
    padding-right: 63rem !important;
  }

  .pe-lg-128 {
    padding-right: 63.5rem !important;
  }

  .pe-lg-129 {
    padding-right: 64rem !important;
  }

  .pe-lg-130 {
    padding-right: 64.5rem !important;
  }

  .pe-lg-131 {
    padding-right: 65rem !important;
  }

  .pe-lg-132 {
    padding-right: 65.5rem !important;
  }

  .pe-lg-133 {
    padding-right: 66rem !important;
  }

  .pe-lg-134 {
    padding-right: 66.5rem !important;
  }

  .pe-lg-135 {
    padding-right: 67rem !important;
  }

  .pe-lg-136 {
    padding-right: 67.5rem !important;
  }

  .pe-lg-137 {
    padding-right: 68rem !important;
  }

  .pe-lg-138 {
    padding-right: 68.5rem !important;
  }

  .pe-lg-139 {
    padding-right: 69rem !important;
  }

  .pe-lg-140 {
    padding-right: 69.5rem !important;
  }

  .pe-lg-141 {
    padding-right: 70rem !important;
  }

  .pe-lg-142 {
    padding-right: 70.5rem !important;
  }

  .pe-lg-143 {
    padding-right: 71rem !important;
  }

  .pe-lg-144 {
    padding-right: 71.5rem !important;
  }

  .pe-lg-145 {
    padding-right: 72rem !important;
  }

  .pe-lg-146 {
    padding-right: 72.5rem !important;
  }

  .pe-lg-147 {
    padding-right: 73rem !important;
  }

  .pe-lg-148 {
    padding-right: 73.5rem !important;
  }

  .pe-lg-149 {
    padding-right: 74rem !important;
  }

  .pe-lg-150 {
    padding-right: 74.5rem !important;
  }

  .pe-lg-151 {
    padding-right: 75rem !important;
  }

  .pe-lg-152 {
    padding-right: 75.5rem !important;
  }

  .pe-lg-153 {
    padding-right: 76rem !important;
  }

  .pe-lg-154 {
    padding-right: 76.5rem !important;
  }

  .pe-lg-155 {
    padding-right: 77rem !important;
  }

  .pe-lg-156 {
    padding-right: 77.5rem !important;
  }

  .pe-lg-157 {
    padding-right: 78rem !important;
  }

  .pe-lg-158 {
    padding-right: 78.5rem !important;
  }

  .pe-lg-159 {
    padding-right: 79rem !important;
  }

  .pe-lg-160 {
    padding-right: 79.5rem !important;
  }

  .px-lg-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }

  .px-lg-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  .px-lg-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .px-lg-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .px-lg-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .px-lg-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .px-lg-6 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .px-lg-7 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .px-lg-8 {
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important;
  }

  .px-lg-9 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  .px-lg-10 {
    padding-left: 4.5rem !important;
    padding-right: 4.5rem !important;
  }

  .px-lg-11 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  .px-lg-12 {
    padding-left: 5.5rem !important;
    padding-right: 5.5rem !important;
  }

  .px-lg-13 {
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  .px-lg-14 {
    padding-left: 6.5rem !important;
    padding-right: 6.5rem !important;
  }

  .px-lg-15 {
    padding-left: 7rem !important;
    padding-right: 7rem !important;
  }

  .px-lg-16 {
    padding-left: 7.5rem !important;
    padding-right: 7.5rem !important;
  }

  .px-lg-17 {
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  .px-lg-18 {
    padding-left: 8.5rem !important;
    padding-right: 8.5rem !important;
  }

  .px-lg-19 {
    padding-left: 9rem !important;
    padding-right: 9rem !important;
  }

  .px-lg-20 {
    padding-left: 9.5rem !important;
    padding-right: 9.5rem !important;
  }

  .px-lg-21 {
    padding-left: 10rem !important;
    padding-right: 10rem !important;
  }

  .px-lg-22 {
    padding-left: 10.5rem !important;
    padding-right: 10.5rem !important;
  }

  .px-lg-23 {
    padding-left: 11rem !important;
    padding-right: 11rem !important;
  }

  .px-lg-24 {
    padding-left: 11.5rem !important;
    padding-right: 11.5rem !important;
  }

  .px-lg-25 {
    padding-left: 12rem !important;
    padding-right: 12rem !important;
  }

  .px-lg-26 {
    padding-left: 12.5rem !important;
    padding-right: 12.5rem !important;
  }

  .px-lg-27 {
    padding-left: 13rem !important;
    padding-right: 13rem !important;
  }

  .px-lg-28 {
    padding-left: 13.5rem !important;
    padding-right: 13.5rem !important;
  }

  .px-lg-29 {
    padding-left: 14rem !important;
    padding-right: 14rem !important;
  }

  .px-lg-30 {
    padding-left: 14.5rem !important;
    padding-right: 14.5rem !important;
  }

  .px-lg-31 {
    padding-left: 15rem !important;
    padding-right: 15rem !important;
  }

  .px-lg-32 {
    padding-left: 15.5rem !important;
    padding-right: 15.5rem !important;
  }

  .px-lg-33 {
    padding-left: 16rem !important;
    padding-right: 16rem !important;
  }

  .px-lg-34 {
    padding-left: 16.5rem !important;
    padding-right: 16.5rem !important;
  }

  .px-lg-35 {
    padding-left: 17rem !important;
    padding-right: 17rem !important;
  }

  .px-lg-36 {
    padding-left: 17.5rem !important;
    padding-right: 17.5rem !important;
  }

  .px-lg-37 {
    padding-left: 18rem !important;
    padding-right: 18rem !important;
  }

  .px-lg-38 {
    padding-left: 18.5rem !important;
    padding-right: 18.5rem !important;
  }

  .px-lg-39 {
    padding-left: 19rem !important;
    padding-right: 19rem !important;
  }

  .px-lg-40 {
    padding-left: 19.5rem !important;
    padding-right: 19.5rem !important;
  }

  .px-lg-41 {
    padding-left: 20rem !important;
    padding-right: 20rem !important;
  }

  .px-lg-42 {
    padding-left: 20.5rem !important;
    padding-right: 20.5rem !important;
  }

  .px-lg-43 {
    padding-left: 21rem !important;
    padding-right: 21rem !important;
  }

  .px-lg-44 {
    padding-left: 21.5rem !important;
    padding-right: 21.5rem !important;
  }

  .px-lg-45 {
    padding-left: 22rem !important;
    padding-right: 22rem !important;
  }

  .px-lg-46 {
    padding-left: 22.5rem !important;
    padding-right: 22.5rem !important;
  }

  .px-lg-47 {
    padding-left: 23rem !important;
    padding-right: 23rem !important;
  }

  .px-lg-48 {
    padding-left: 23.5rem !important;
    padding-right: 23.5rem !important;
  }

  .px-lg-49 {
    padding-left: 24rem !important;
    padding-right: 24rem !important;
  }

  .px-lg-50 {
    padding-left: 24.5rem !important;
    padding-right: 24.5rem !important;
  }

  .px-lg-51 {
    padding-left: 25rem !important;
    padding-right: 25rem !important;
  }

  .px-lg-52 {
    padding-left: 25.5rem !important;
    padding-right: 25.5rem !important;
  }

  .px-lg-53 {
    padding-left: 26rem !important;
    padding-right: 26rem !important;
  }

  .px-lg-54 {
    padding-left: 26.5rem !important;
    padding-right: 26.5rem !important;
  }

  .px-lg-55 {
    padding-left: 27rem !important;
    padding-right: 27rem !important;
  }

  .px-lg-56 {
    padding-left: 27.5rem !important;
    padding-right: 27.5rem !important;
  }

  .px-lg-57 {
    padding-left: 28rem !important;
    padding-right: 28rem !important;
  }

  .px-lg-58 {
    padding-left: 28.5rem !important;
    padding-right: 28.5rem !important;
  }

  .px-lg-59 {
    padding-left: 29rem !important;
    padding-right: 29rem !important;
  }

  .px-lg-60 {
    padding-left: 29.5rem !important;
    padding-right: 29.5rem !important;
  }

  .px-lg-61 {
    padding-left: 30rem !important;
    padding-right: 30rem !important;
  }

  .px-lg-62 {
    padding-left: 30.5rem !important;
    padding-right: 30.5rem !important;
  }

  .px-lg-63 {
    padding-left: 31rem !important;
    padding-right: 31rem !important;
  }

  .px-lg-64 {
    padding-left: 31.5rem !important;
    padding-right: 31.5rem !important;
  }

  .px-lg-65 {
    padding-left: 32rem !important;
    padding-right: 32rem !important;
  }

  .px-lg-66 {
    padding-left: 32.5rem !important;
    padding-right: 32.5rem !important;
  }

  .px-lg-67 {
    padding-left: 33rem !important;
    padding-right: 33rem !important;
  }

  .px-lg-68 {
    padding-left: 33.5rem !important;
    padding-right: 33.5rem !important;
  }

  .px-lg-69 {
    padding-left: 34rem !important;
    padding-right: 34rem !important;
  }

  .px-lg-70 {
    padding-left: 34.5rem !important;
    padding-right: 34.5rem !important;
  }

  .px-lg-71 {
    padding-left: 35rem !important;
    padding-right: 35rem !important;
  }

  .px-lg-72 {
    padding-left: 35.5rem !important;
    padding-right: 35.5rem !important;
  }

  .px-lg-73 {
    padding-left: 36rem !important;
    padding-right: 36rem !important;
  }

  .px-lg-74 {
    padding-left: 36.5rem !important;
    padding-right: 36.5rem !important;
  }

  .px-lg-75 {
    padding-left: 37rem !important;
    padding-right: 37rem !important;
  }

  .px-lg-76 {
    padding-left: 37.5rem !important;
    padding-right: 37.5rem !important;
  }

  .px-lg-77 {
    padding-left: 38rem !important;
    padding-right: 38rem !important;
  }

  .px-lg-78 {
    padding-left: 38.5rem !important;
    padding-right: 38.5rem !important;
  }

  .px-lg-79 {
    padding-left: 39rem !important;
    padding-right: 39rem !important;
  }

  .px-lg-80 {
    padding-left: 39.5rem !important;
    padding-right: 39.5rem !important;
  }

  .px-lg-81 {
    padding-left: 40rem !important;
    padding-right: 40rem !important;
  }

  .px-lg-82 {
    padding-left: 40.5rem !important;
    padding-right: 40.5rem !important;
  }

  .px-lg-83 {
    padding-left: 41rem !important;
    padding-right: 41rem !important;
  }

  .px-lg-84 {
    padding-left: 41.5rem !important;
    padding-right: 41.5rem !important;
  }

  .px-lg-85 {
    padding-left: 42rem !important;
    padding-right: 42rem !important;
  }

  .px-lg-86 {
    padding-left: 42.5rem !important;
    padding-right: 42.5rem !important;
  }

  .px-lg-87 {
    padding-left: 43rem !important;
    padding-right: 43rem !important;
  }

  .px-lg-88 {
    padding-left: 43.5rem !important;
    padding-right: 43.5rem !important;
  }

  .px-lg-89 {
    padding-left: 44rem !important;
    padding-right: 44rem !important;
  }

  .px-lg-90 {
    padding-left: 44.5rem !important;
    padding-right: 44.5rem !important;
  }

  .px-lg-91 {
    padding-left: 45rem !important;
    padding-right: 45rem !important;
  }

  .px-lg-92 {
    padding-left: 45.5rem !important;
    padding-right: 45.5rem !important;
  }

  .px-lg-93 {
    padding-left: 46rem !important;
    padding-right: 46rem !important;
  }

  .px-lg-94 {
    padding-left: 46.5rem !important;
    padding-right: 46.5rem !important;
  }

  .px-lg-95 {
    padding-left: 47rem !important;
    padding-right: 47rem !important;
  }

  .px-lg-96 {
    padding-left: 47.5rem !important;
    padding-right: 47.5rem !important;
  }

  .px-lg-97 {
    padding-left: 48rem !important;
    padding-right: 48rem !important;
  }

  .px-lg-98 {
    padding-left: 48.5rem !important;
    padding-right: 48.5rem !important;
  }

  .px-lg-99 {
    padding-left: 49rem !important;
    padding-right: 49rem !important;
  }

  .px-lg-100 {
    padding-left: 49.5rem !important;
    padding-right: 49.5rem !important;
  }

  .px-lg-101 {
    padding-left: 50rem !important;
    padding-right: 50rem !important;
  }

  .px-lg-102 {
    padding-left: 50.5rem !important;
    padding-right: 50.5rem !important;
  }

  .px-lg-103 {
    padding-left: 51rem !important;
    padding-right: 51rem !important;
  }

  .px-lg-104 {
    padding-left: 51.5rem !important;
    padding-right: 51.5rem !important;
  }

  .px-lg-105 {
    padding-left: 52rem !important;
    padding-right: 52rem !important;
  }

  .px-lg-106 {
    padding-left: 52.5rem !important;
    padding-right: 52.5rem !important;
  }

  .px-lg-107 {
    padding-left: 53rem !important;
    padding-right: 53rem !important;
  }

  .px-lg-108 {
    padding-left: 53.5rem !important;
    padding-right: 53.5rem !important;
  }

  .px-lg-109 {
    padding-left: 54rem !important;
    padding-right: 54rem !important;
  }

  .px-lg-110 {
    padding-left: 54.5rem !important;
    padding-right: 54.5rem !important;
  }

  .px-lg-111 {
    padding-left: 55rem !important;
    padding-right: 55rem !important;
  }

  .px-lg-112 {
    padding-left: 55.5rem !important;
    padding-right: 55.5rem !important;
  }

  .px-lg-113 {
    padding-left: 56rem !important;
    padding-right: 56rem !important;
  }

  .px-lg-114 {
    padding-left: 56.5rem !important;
    padding-right: 56.5rem !important;
  }

  .px-lg-115 {
    padding-left: 57rem !important;
    padding-right: 57rem !important;
  }

  .px-lg-116 {
    padding-left: 57.5rem !important;
    padding-right: 57.5rem !important;
  }

  .px-lg-117 {
    padding-left: 58rem !important;
    padding-right: 58rem !important;
  }

  .px-lg-118 {
    padding-left: 58.5rem !important;
    padding-right: 58.5rem !important;
  }

  .px-lg-119 {
    padding-left: 59rem !important;
    padding-right: 59rem !important;
  }

  .px-lg-120 {
    padding-left: 59.5rem !important;
    padding-right: 59.5rem !important;
  }

  .px-lg-121 {
    padding-left: 60rem !important;
    padding-right: 60rem !important;
  }

  .px-lg-122 {
    padding-left: 60.5rem !important;
    padding-right: 60.5rem !important;
  }

  .px-lg-123 {
    padding-left: 61rem !important;
    padding-right: 61rem !important;
  }

  .px-lg-124 {
    padding-left: 61.5rem !important;
    padding-right: 61.5rem !important;
  }

  .px-lg-125 {
    padding-left: 62rem !important;
    padding-right: 62rem !important;
  }

  .px-lg-126 {
    padding-left: 62.5rem !important;
    padding-right: 62.5rem !important;
  }

  .px-lg-127 {
    padding-left: 63rem !important;
    padding-right: 63rem !important;
  }

  .px-lg-128 {
    padding-left: 63.5rem !important;
    padding-right: 63.5rem !important;
  }

  .px-lg-129 {
    padding-left: 64rem !important;
    padding-right: 64rem !important;
  }

  .px-lg-130 {
    padding-left: 64.5rem !important;
    padding-right: 64.5rem !important;
  }

  .px-lg-131 {
    padding-left: 65rem !important;
    padding-right: 65rem !important;
  }

  .px-lg-132 {
    padding-left: 65.5rem !important;
    padding-right: 65.5rem !important;
  }

  .px-lg-133 {
    padding-left: 66rem !important;
    padding-right: 66rem !important;
  }

  .px-lg-134 {
    padding-left: 66.5rem !important;
    padding-right: 66.5rem !important;
  }

  .px-lg-135 {
    padding-left: 67rem !important;
    padding-right: 67rem !important;
  }

  .px-lg-136 {
    padding-left: 67.5rem !important;
    padding-right: 67.5rem !important;
  }

  .px-lg-137 {
    padding-left: 68rem !important;
    padding-right: 68rem !important;
  }

  .px-lg-138 {
    padding-left: 68.5rem !important;
    padding-right: 68.5rem !important;
  }

  .px-lg-139 {
    padding-left: 69rem !important;
    padding-right: 69rem !important;
  }

  .px-lg-140 {
    padding-left: 69.5rem !important;
    padding-right: 69.5rem !important;
  }

  .px-lg-141 {
    padding-left: 70rem !important;
    padding-right: 70rem !important;
  }

  .px-lg-142 {
    padding-left: 70.5rem !important;
    padding-right: 70.5rem !important;
  }

  .px-lg-143 {
    padding-left: 71rem !important;
    padding-right: 71rem !important;
  }

  .px-lg-144 {
    padding-left: 71.5rem !important;
    padding-right: 71.5rem !important;
  }

  .px-lg-145 {
    padding-left: 72rem !important;
    padding-right: 72rem !important;
  }

  .px-lg-146 {
    padding-left: 72.5rem !important;
    padding-right: 72.5rem !important;
  }

  .px-lg-147 {
    padding-left: 73rem !important;
    padding-right: 73rem !important;
  }

  .px-lg-148 {
    padding-left: 73.5rem !important;
    padding-right: 73.5rem !important;
  }

  .px-lg-149 {
    padding-left: 74rem !important;
    padding-right: 74rem !important;
  }

  .px-lg-150 {
    padding-left: 74.5rem !important;
    padding-right: 74.5rem !important;
  }

  .px-lg-151 {
    padding-left: 75rem !important;
    padding-right: 75rem !important;
  }

  .px-lg-152 {
    padding-left: 75.5rem !important;
    padding-right: 75.5rem !important;
  }

  .px-lg-153 {
    padding-left: 76rem !important;
    padding-right: 76rem !important;
  }

  .px-lg-154 {
    padding-left: 76.5rem !important;
    padding-right: 76.5rem !important;
  }

  .px-lg-155 {
    padding-left: 77rem !important;
    padding-right: 77rem !important;
  }

  .px-lg-156 {
    padding-left: 77.5rem !important;
    padding-right: 77.5rem !important;
  }

  .px-lg-157 {
    padding-left: 78rem !important;
    padding-right: 78rem !important;
  }

  .px-lg-158 {
    padding-left: 78.5rem !important;
    padding-right: 78.5rem !important;
  }

  .px-lg-159 {
    padding-left: 79rem !important;
    padding-right: 79rem !important;
  }

  .px-lg-160 {
    padding-left: 79.5rem !important;
    padding-right: 79.5rem !important;
  }

  .py-lg-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-lg-6 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-lg-7 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-lg-8 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-lg-9 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-lg-10 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-lg-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .py-lg-12 {
    padding-top: 5.5rem !important;
    padding-bottom: 5.5rem !important;
  }

  .py-lg-13 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  .py-lg-14 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }

  .py-lg-15 {
    padding-top: 7rem !important;
    padding-bottom: 7rem !important;
  }

  .py-lg-16 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }

  .py-lg-17 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  .py-lg-18 {
    padding-top: 8.5rem !important;
    padding-bottom: 8.5rem !important;
  }

  .py-lg-19 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }

  .py-lg-20 {
    padding-top: 9.5rem !important;
    padding-bottom: 9.5rem !important;
  }

  .py-lg-21 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }

  .py-lg-22 {
    padding-top: 10.5rem !important;
    padding-bottom: 10.5rem !important;
  }

  .py-lg-23 {
    padding-top: 11rem !important;
    padding-bottom: 11rem !important;
  }

  .py-lg-24 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }

  .py-lg-25 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }

  .py-lg-26 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }

  .py-lg-27 {
    padding-top: 13rem !important;
    padding-bottom: 13rem !important;
  }

  .py-lg-28 {
    padding-top: 13.5rem !important;
    padding-bottom: 13.5rem !important;
  }

  .py-lg-29 {
    padding-top: 14rem !important;
    padding-bottom: 14rem !important;
  }

  .py-lg-30 {
    padding-top: 14.5rem !important;
    padding-bottom: 14.5rem !important;
  }

  .py-lg-31 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }

  .py-lg-32 {
    padding-top: 15.5rem !important;
    padding-bottom: 15.5rem !important;
  }

  .py-lg-33 {
    padding-top: 16rem !important;
    padding-bottom: 16rem !important;
  }

  .py-lg-34 {
    padding-top: 16.5rem !important;
    padding-bottom: 16.5rem !important;
  }

  .py-lg-35 {
    padding-top: 17rem !important;
    padding-bottom: 17rem !important;
  }

  .py-lg-36 {
    padding-top: 17.5rem !important;
    padding-bottom: 17.5rem !important;
  }

  .py-lg-37 {
    padding-top: 18rem !important;
    padding-bottom: 18rem !important;
  }

  .py-lg-38 {
    padding-top: 18.5rem !important;
    padding-bottom: 18.5rem !important;
  }

  .py-lg-39 {
    padding-top: 19rem !important;
    padding-bottom: 19rem !important;
  }

  .py-lg-40 {
    padding-top: 19.5rem !important;
    padding-bottom: 19.5rem !important;
  }

  .py-lg-41 {
    padding-top: 20rem !important;
    padding-bottom: 20rem !important;
  }

  .py-lg-42 {
    padding-top: 20.5rem !important;
    padding-bottom: 20.5rem !important;
  }

  .py-lg-43 {
    padding-top: 21rem !important;
    padding-bottom: 21rem !important;
  }

  .py-lg-44 {
    padding-top: 21.5rem !important;
    padding-bottom: 21.5rem !important;
  }

  .py-lg-45 {
    padding-top: 22rem !important;
    padding-bottom: 22rem !important;
  }

  .py-lg-46 {
    padding-top: 22.5rem !important;
    padding-bottom: 22.5rem !important;
  }

  .py-lg-47 {
    padding-top: 23rem !important;
    padding-bottom: 23rem !important;
  }

  .py-lg-48 {
    padding-top: 23.5rem !important;
    padding-bottom: 23.5rem !important;
  }

  .py-lg-49 {
    padding-top: 24rem !important;
    padding-bottom: 24rem !important;
  }

  .py-lg-50 {
    padding-top: 24.5rem !important;
    padding-bottom: 24.5rem !important;
  }

  .py-lg-51 {
    padding-top: 25rem !important;
    padding-bottom: 25rem !important;
  }

  .py-lg-52 {
    padding-top: 25.5rem !important;
    padding-bottom: 25.5rem !important;
  }

  .py-lg-53 {
    padding-top: 26rem !important;
    padding-bottom: 26rem !important;
  }

  .py-lg-54 {
    padding-top: 26.5rem !important;
    padding-bottom: 26.5rem !important;
  }

  .py-lg-55 {
    padding-top: 27rem !important;
    padding-bottom: 27rem !important;
  }

  .py-lg-56 {
    padding-top: 27.5rem !important;
    padding-bottom: 27.5rem !important;
  }

  .py-lg-57 {
    padding-top: 28rem !important;
    padding-bottom: 28rem !important;
  }

  .py-lg-58 {
    padding-top: 28.5rem !important;
    padding-bottom: 28.5rem !important;
  }

  .py-lg-59 {
    padding-top: 29rem !important;
    padding-bottom: 29rem !important;
  }

  .py-lg-60 {
    padding-top: 29.5rem !important;
    padding-bottom: 29.5rem !important;
  }

  .py-lg-61 {
    padding-top: 30rem !important;
    padding-bottom: 30rem !important;
  }

  .py-lg-62 {
    padding-top: 30.5rem !important;
    padding-bottom: 30.5rem !important;
  }

  .py-lg-63 {
    padding-top: 31rem !important;
    padding-bottom: 31rem !important;
  }

  .py-lg-64 {
    padding-top: 31.5rem !important;
    padding-bottom: 31.5rem !important;
  }

  .py-lg-65 {
    padding-top: 32rem !important;
    padding-bottom: 32rem !important;
  }

  .py-lg-66 {
    padding-top: 32.5rem !important;
    padding-bottom: 32.5rem !important;
  }

  .py-lg-67 {
    padding-top: 33rem !important;
    padding-bottom: 33rem !important;
  }

  .py-lg-68 {
    padding-top: 33.5rem !important;
    padding-bottom: 33.5rem !important;
  }

  .py-lg-69 {
    padding-top: 34rem !important;
    padding-bottom: 34rem !important;
  }

  .py-lg-70 {
    padding-top: 34.5rem !important;
    padding-bottom: 34.5rem !important;
  }

  .py-lg-71 {
    padding-top: 35rem !important;
    padding-bottom: 35rem !important;
  }

  .py-lg-72 {
    padding-top: 35.5rem !important;
    padding-bottom: 35.5rem !important;
  }

  .py-lg-73 {
    padding-top: 36rem !important;
    padding-bottom: 36rem !important;
  }

  .py-lg-74 {
    padding-top: 36.5rem !important;
    padding-bottom: 36.5rem !important;
  }

  .py-lg-75 {
    padding-top: 37rem !important;
    padding-bottom: 37rem !important;
  }

  .py-lg-76 {
    padding-top: 37.5rem !important;
    padding-bottom: 37.5rem !important;
  }

  .py-lg-77 {
    padding-top: 38rem !important;
    padding-bottom: 38rem !important;
  }

  .py-lg-78 {
    padding-top: 38.5rem !important;
    padding-bottom: 38.5rem !important;
  }

  .py-lg-79 {
    padding-top: 39rem !important;
    padding-bottom: 39rem !important;
  }

  .py-lg-80 {
    padding-top: 39.5rem !important;
    padding-bottom: 39.5rem !important;
  }

  .py-lg-81 {
    padding-top: 40rem !important;
    padding-bottom: 40rem !important;
  }

  .py-lg-82 {
    padding-top: 40.5rem !important;
    padding-bottom: 40.5rem !important;
  }

  .py-lg-83 {
    padding-top: 41rem !important;
    padding-bottom: 41rem !important;
  }

  .py-lg-84 {
    padding-top: 41.5rem !important;
    padding-bottom: 41.5rem !important;
  }

  .py-lg-85 {
    padding-top: 42rem !important;
    padding-bottom: 42rem !important;
  }

  .py-lg-86 {
    padding-top: 42.5rem !important;
    padding-bottom: 42.5rem !important;
  }

  .py-lg-87 {
    padding-top: 43rem !important;
    padding-bottom: 43rem !important;
  }

  .py-lg-88 {
    padding-top: 43.5rem !important;
    padding-bottom: 43.5rem !important;
  }

  .py-lg-89 {
    padding-top: 44rem !important;
    padding-bottom: 44rem !important;
  }

  .py-lg-90 {
    padding-top: 44.5rem !important;
    padding-bottom: 44.5rem !important;
  }

  .py-lg-91 {
    padding-top: 45rem !important;
    padding-bottom: 45rem !important;
  }

  .py-lg-92 {
    padding-top: 45.5rem !important;
    padding-bottom: 45.5rem !important;
  }

  .py-lg-93 {
    padding-top: 46rem !important;
    padding-bottom: 46rem !important;
  }

  .py-lg-94 {
    padding-top: 46.5rem !important;
    padding-bottom: 46.5rem !important;
  }

  .py-lg-95 {
    padding-top: 47rem !important;
    padding-bottom: 47rem !important;
  }

  .py-lg-96 {
    padding-top: 47.5rem !important;
    padding-bottom: 47.5rem !important;
  }

  .py-lg-97 {
    padding-top: 48rem !important;
    padding-bottom: 48rem !important;
  }

  .py-lg-98 {
    padding-top: 48.5rem !important;
    padding-bottom: 48.5rem !important;
  }

  .py-lg-99 {
    padding-top: 49rem !important;
    padding-bottom: 49rem !important;
  }

  .py-lg-100 {
    padding-top: 49.5rem !important;
    padding-bottom: 49.5rem !important;
  }

  .py-lg-101 {
    padding-top: 50rem !important;
    padding-bottom: 50rem !important;
  }

  .py-lg-102 {
    padding-top: 50.5rem !important;
    padding-bottom: 50.5rem !important;
  }

  .py-lg-103 {
    padding-top: 51rem !important;
    padding-bottom: 51rem !important;
  }

  .py-lg-104 {
    padding-top: 51.5rem !important;
    padding-bottom: 51.5rem !important;
  }

  .py-lg-105 {
    padding-top: 52rem !important;
    padding-bottom: 52rem !important;
  }

  .py-lg-106 {
    padding-top: 52.5rem !important;
    padding-bottom: 52.5rem !important;
  }

  .py-lg-107 {
    padding-top: 53rem !important;
    padding-bottom: 53rem !important;
  }

  .py-lg-108 {
    padding-top: 53.5rem !important;
    padding-bottom: 53.5rem !important;
  }

  .py-lg-109 {
    padding-top: 54rem !important;
    padding-bottom: 54rem !important;
  }

  .py-lg-110 {
    padding-top: 54.5rem !important;
    padding-bottom: 54.5rem !important;
  }

  .py-lg-111 {
    padding-top: 55rem !important;
    padding-bottom: 55rem !important;
  }

  .py-lg-112 {
    padding-top: 55.5rem !important;
    padding-bottom: 55.5rem !important;
  }

  .py-lg-113 {
    padding-top: 56rem !important;
    padding-bottom: 56rem !important;
  }

  .py-lg-114 {
    padding-top: 56.5rem !important;
    padding-bottom: 56.5rem !important;
  }

  .py-lg-115 {
    padding-top: 57rem !important;
    padding-bottom: 57rem !important;
  }

  .py-lg-116 {
    padding-top: 57.5rem !important;
    padding-bottom: 57.5rem !important;
  }

  .py-lg-117 {
    padding-top: 58rem !important;
    padding-bottom: 58rem !important;
  }

  .py-lg-118 {
    padding-top: 58.5rem !important;
    padding-bottom: 58.5rem !important;
  }

  .py-lg-119 {
    padding-top: 59rem !important;
    padding-bottom: 59rem !important;
  }

  .py-lg-120 {
    padding-top: 59.5rem !important;
    padding-bottom: 59.5rem !important;
  }

  .py-lg-121 {
    padding-top: 60rem !important;
    padding-bottom: 60rem !important;
  }

  .py-lg-122 {
    padding-top: 60.5rem !important;
    padding-bottom: 60.5rem !important;
  }

  .py-lg-123 {
    padding-top: 61rem !important;
    padding-bottom: 61rem !important;
  }

  .py-lg-124 {
    padding-top: 61.5rem !important;
    padding-bottom: 61.5rem !important;
  }

  .py-lg-125 {
    padding-top: 62rem !important;
    padding-bottom: 62rem !important;
  }

  .py-lg-126 {
    padding-top: 62.5rem !important;
    padding-bottom: 62.5rem !important;
  }

  .py-lg-127 {
    padding-top: 63rem !important;
    padding-bottom: 63rem !important;
  }

  .py-lg-128 {
    padding-top: 63.5rem !important;
    padding-bottom: 63.5rem !important;
  }

  .py-lg-129 {
    padding-top: 64rem !important;
    padding-bottom: 64rem !important;
  }

  .py-lg-130 {
    padding-top: 64.5rem !important;
    padding-bottom: 64.5rem !important;
  }

  .py-lg-131 {
    padding-top: 65rem !important;
    padding-bottom: 65rem !important;
  }

  .py-lg-132 {
    padding-top: 65.5rem !important;
    padding-bottom: 65.5rem !important;
  }

  .py-lg-133 {
    padding-top: 66rem !important;
    padding-bottom: 66rem !important;
  }

  .py-lg-134 {
    padding-top: 66.5rem !important;
    padding-bottom: 66.5rem !important;
  }

  .py-lg-135 {
    padding-top: 67rem !important;
    padding-bottom: 67rem !important;
  }

  .py-lg-136 {
    padding-top: 67.5rem !important;
    padding-bottom: 67.5rem !important;
  }

  .py-lg-137 {
    padding-top: 68rem !important;
    padding-bottom: 68rem !important;
  }

  .py-lg-138 {
    padding-top: 68.5rem !important;
    padding-bottom: 68.5rem !important;
  }

  .py-lg-139 {
    padding-top: 69rem !important;
    padding-bottom: 69rem !important;
  }

  .py-lg-140 {
    padding-top: 69.5rem !important;
    padding-bottom: 69.5rem !important;
  }

  .py-lg-141 {
    padding-top: 70rem !important;
    padding-bottom: 70rem !important;
  }

  .py-lg-142 {
    padding-top: 70.5rem !important;
    padding-bottom: 70.5rem !important;
  }

  .py-lg-143 {
    padding-top: 71rem !important;
    padding-bottom: 71rem !important;
  }

  .py-lg-144 {
    padding-top: 71.5rem !important;
    padding-bottom: 71.5rem !important;
  }

  .py-lg-145 {
    padding-top: 72rem !important;
    padding-bottom: 72rem !important;
  }

  .py-lg-146 {
    padding-top: 72.5rem !important;
    padding-bottom: 72.5rem !important;
  }

  .py-lg-147 {
    padding-top: 73rem !important;
    padding-bottom: 73rem !important;
  }

  .py-lg-148 {
    padding-top: 73.5rem !important;
    padding-bottom: 73.5rem !important;
  }

  .py-lg-149 {
    padding-top: 74rem !important;
    padding-bottom: 74rem !important;
  }

  .py-lg-150 {
    padding-top: 74.5rem !important;
    padding-bottom: 74.5rem !important;
  }

  .py-lg-151 {
    padding-top: 75rem !important;
    padding-bottom: 75rem !important;
  }

  .py-lg-152 {
    padding-top: 75.5rem !important;
    padding-bottom: 75.5rem !important;
  }

  .py-lg-153 {
    padding-top: 76rem !important;
    padding-bottom: 76rem !important;
  }

  .py-lg-154 {
    padding-top: 76.5rem !important;
    padding-bottom: 76.5rem !important;
  }

  .py-lg-155 {
    padding-top: 77rem !important;
    padding-bottom: 77rem !important;
  }

  .py-lg-156 {
    padding-top: 77.5rem !important;
    padding-bottom: 77.5rem !important;
  }

  .py-lg-157 {
    padding-top: 78rem !important;
    padding-bottom: 78rem !important;
  }

  .py-lg-158 {
    padding-top: 78.5rem !important;
    padding-bottom: 78.5rem !important;
  }

  .py-lg-159 {
    padding-top: 79rem !important;
    padding-bottom: 79rem !important;
  }

  .py-lg-160 {
    padding-top: 79.5rem !important;
    padding-bottom: 79.5rem !important;
  }
}
@media (min-width: 1200px) {
  .p-xl-0 {
    padding: 0rem !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 2rem !important;
  }

  .p-xl-6 {
    padding: 2.5rem !important;
  }

  .p-xl-7 {
    padding: 3rem !important;
  }

  .p-xl-8 {
    padding: 3.5rem !important;
  }

  .p-xl-9 {
    padding: 4rem !important;
  }

  .p-xl-10 {
    padding: 4.5rem !important;
  }

  .p-xl-11 {
    padding: 5rem !important;
  }

  .p-xl-12 {
    padding: 5.5rem !important;
  }

  .p-xl-13 {
    padding: 6rem !important;
  }

  .p-xl-14 {
    padding: 6.5rem !important;
  }

  .p-xl-15 {
    padding: 7rem !important;
  }

  .p-xl-16 {
    padding: 7.5rem !important;
  }

  .p-xl-17 {
    padding: 8rem !important;
  }

  .p-xl-18 {
    padding: 8.5rem !important;
  }

  .p-xl-19 {
    padding: 9rem !important;
  }

  .p-xl-20 {
    padding: 9.5rem !important;
  }

  .p-xl-21 {
    padding: 10rem !important;
  }

  .p-xl-22 {
    padding: 10.5rem !important;
  }

  .p-xl-23 {
    padding: 11rem !important;
  }

  .p-xl-24 {
    padding: 11.5rem !important;
  }

  .p-xl-25 {
    padding: 12rem !important;
  }

  .p-xl-26 {
    padding: 12.5rem !important;
  }

  .p-xl-27 {
    padding: 13rem !important;
  }

  .p-xl-28 {
    padding: 13.5rem !important;
  }

  .p-xl-29 {
    padding: 14rem !important;
  }

  .p-xl-30 {
    padding: 14.5rem !important;
  }

  .p-xl-31 {
    padding: 15rem !important;
  }

  .p-xl-32 {
    padding: 15.5rem !important;
  }

  .p-xl-33 {
    padding: 16rem !important;
  }

  .p-xl-34 {
    padding: 16.5rem !important;
  }

  .p-xl-35 {
    padding: 17rem !important;
  }

  .p-xl-36 {
    padding: 17.5rem !important;
  }

  .p-xl-37 {
    padding: 18rem !important;
  }

  .p-xl-38 {
    padding: 18.5rem !important;
  }

  .p-xl-39 {
    padding: 19rem !important;
  }

  .p-xl-40 {
    padding: 19.5rem !important;
  }

  .p-xl-41 {
    padding: 20rem !important;
  }

  .p-xl-42 {
    padding: 20.5rem !important;
  }

  .p-xl-43 {
    padding: 21rem !important;
  }

  .p-xl-44 {
    padding: 21.5rem !important;
  }

  .p-xl-45 {
    padding: 22rem !important;
  }

  .p-xl-46 {
    padding: 22.5rem !important;
  }

  .p-xl-47 {
    padding: 23rem !important;
  }

  .p-xl-48 {
    padding: 23.5rem !important;
  }

  .p-xl-49 {
    padding: 24rem !important;
  }

  .p-xl-50 {
    padding: 24.5rem !important;
  }

  .p-xl-51 {
    padding: 25rem !important;
  }

  .p-xl-52 {
    padding: 25.5rem !important;
  }

  .p-xl-53 {
    padding: 26rem !important;
  }

  .p-xl-54 {
    padding: 26.5rem !important;
  }

  .p-xl-55 {
    padding: 27rem !important;
  }

  .p-xl-56 {
    padding: 27.5rem !important;
  }

  .p-xl-57 {
    padding: 28rem !important;
  }

  .p-xl-58 {
    padding: 28.5rem !important;
  }

  .p-xl-59 {
    padding: 29rem !important;
  }

  .p-xl-60 {
    padding: 29.5rem !important;
  }

  .p-xl-61 {
    padding: 30rem !important;
  }

  .p-xl-62 {
    padding: 30.5rem !important;
  }

  .p-xl-63 {
    padding: 31rem !important;
  }

  .p-xl-64 {
    padding: 31.5rem !important;
  }

  .p-xl-65 {
    padding: 32rem !important;
  }

  .p-xl-66 {
    padding: 32.5rem !important;
  }

  .p-xl-67 {
    padding: 33rem !important;
  }

  .p-xl-68 {
    padding: 33.5rem !important;
  }

  .p-xl-69 {
    padding: 34rem !important;
  }

  .p-xl-70 {
    padding: 34.5rem !important;
  }

  .p-xl-71 {
    padding: 35rem !important;
  }

  .p-xl-72 {
    padding: 35.5rem !important;
  }

  .p-xl-73 {
    padding: 36rem !important;
  }

  .p-xl-74 {
    padding: 36.5rem !important;
  }

  .p-xl-75 {
    padding: 37rem !important;
  }

  .p-xl-76 {
    padding: 37.5rem !important;
  }

  .p-xl-77 {
    padding: 38rem !important;
  }

  .p-xl-78 {
    padding: 38.5rem !important;
  }

  .p-xl-79 {
    padding: 39rem !important;
  }

  .p-xl-80 {
    padding: 39.5rem !important;
  }

  .p-xl-81 {
    padding: 40rem !important;
  }

  .p-xl-82 {
    padding: 40.5rem !important;
  }

  .p-xl-83 {
    padding: 41rem !important;
  }

  .p-xl-84 {
    padding: 41.5rem !important;
  }

  .p-xl-85 {
    padding: 42rem !important;
  }

  .p-xl-86 {
    padding: 42.5rem !important;
  }

  .p-xl-87 {
    padding: 43rem !important;
  }

  .p-xl-88 {
    padding: 43.5rem !important;
  }

  .p-xl-89 {
    padding: 44rem !important;
  }

  .p-xl-90 {
    padding: 44.5rem !important;
  }

  .p-xl-91 {
    padding: 45rem !important;
  }

  .p-xl-92 {
    padding: 45.5rem !important;
  }

  .p-xl-93 {
    padding: 46rem !important;
  }

  .p-xl-94 {
    padding: 46.5rem !important;
  }

  .p-xl-95 {
    padding: 47rem !important;
  }

  .p-xl-96 {
    padding: 47.5rem !important;
  }

  .p-xl-97 {
    padding: 48rem !important;
  }

  .p-xl-98 {
    padding: 48.5rem !important;
  }

  .p-xl-99 {
    padding: 49rem !important;
  }

  .p-xl-100 {
    padding: 49.5rem !important;
  }

  .p-xl-101 {
    padding: 50rem !important;
  }

  .p-xl-102 {
    padding: 50.5rem !important;
  }

  .p-xl-103 {
    padding: 51rem !important;
  }

  .p-xl-104 {
    padding: 51.5rem !important;
  }

  .p-xl-105 {
    padding: 52rem !important;
  }

  .p-xl-106 {
    padding: 52.5rem !important;
  }

  .p-xl-107 {
    padding: 53rem !important;
  }

  .p-xl-108 {
    padding: 53.5rem !important;
  }

  .p-xl-109 {
    padding: 54rem !important;
  }

  .p-xl-110 {
    padding: 54.5rem !important;
  }

  .p-xl-111 {
    padding: 55rem !important;
  }

  .p-xl-112 {
    padding: 55.5rem !important;
  }

  .p-xl-113 {
    padding: 56rem !important;
  }

  .p-xl-114 {
    padding: 56.5rem !important;
  }

  .p-xl-115 {
    padding: 57rem !important;
  }

  .p-xl-116 {
    padding: 57.5rem !important;
  }

  .p-xl-117 {
    padding: 58rem !important;
  }

  .p-xl-118 {
    padding: 58.5rem !important;
  }

  .p-xl-119 {
    padding: 59rem !important;
  }

  .p-xl-120 {
    padding: 59.5rem !important;
  }

  .p-xl-121 {
    padding: 60rem !important;
  }

  .p-xl-122 {
    padding: 60.5rem !important;
  }

  .p-xl-123 {
    padding: 61rem !important;
  }

  .p-xl-124 {
    padding: 61.5rem !important;
  }

  .p-xl-125 {
    padding: 62rem !important;
  }

  .p-xl-126 {
    padding: 62.5rem !important;
  }

  .p-xl-127 {
    padding: 63rem !important;
  }

  .p-xl-128 {
    padding: 63.5rem !important;
  }

  .p-xl-129 {
    padding: 64rem !important;
  }

  .p-xl-130 {
    padding: 64.5rem !important;
  }

  .p-xl-131 {
    padding: 65rem !important;
  }

  .p-xl-132 {
    padding: 65.5rem !important;
  }

  .p-xl-133 {
    padding: 66rem !important;
  }

  .p-xl-134 {
    padding: 66.5rem !important;
  }

  .p-xl-135 {
    padding: 67rem !important;
  }

  .p-xl-136 {
    padding: 67.5rem !important;
  }

  .p-xl-137 {
    padding: 68rem !important;
  }

  .p-xl-138 {
    padding: 68.5rem !important;
  }

  .p-xl-139 {
    padding: 69rem !important;
  }

  .p-xl-140 {
    padding: 69.5rem !important;
  }

  .p-xl-141 {
    padding: 70rem !important;
  }

  .p-xl-142 {
    padding: 70.5rem !important;
  }

  .p-xl-143 {
    padding: 71rem !important;
  }

  .p-xl-144 {
    padding: 71.5rem !important;
  }

  .p-xl-145 {
    padding: 72rem !important;
  }

  .p-xl-146 {
    padding: 72.5rem !important;
  }

  .p-xl-147 {
    padding: 73rem !important;
  }

  .p-xl-148 {
    padding: 73.5rem !important;
  }

  .p-xl-149 {
    padding: 74rem !important;
  }

  .p-xl-150 {
    padding: 74.5rem !important;
  }

  .p-xl-151 {
    padding: 75rem !important;
  }

  .p-xl-152 {
    padding: 75.5rem !important;
  }

  .p-xl-153 {
    padding: 76rem !important;
  }

  .p-xl-154 {
    padding: 76.5rem !important;
  }

  .p-xl-155 {
    padding: 77rem !important;
  }

  .p-xl-156 {
    padding: 77.5rem !important;
  }

  .p-xl-157 {
    padding: 78rem !important;
  }

  .p-xl-158 {
    padding: 78.5rem !important;
  }

  .p-xl-159 {
    padding: 79rem !important;
  }

  .p-xl-160 {
    padding: 79.5rem !important;
  }

  .pt-xl-0 {
    padding-top: 0rem !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 1rem !important;
  }

  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-5 {
    padding-top: 2rem !important;
  }

  .pt-xl-6 {
    padding-top: 2.5rem !important;
  }

  .pt-xl-7 {
    padding-top: 3rem !important;
  }

  .pt-xl-8 {
    padding-top: 3.5rem !important;
  }

  .pt-xl-9 {
    padding-top: 4rem !important;
  }

  .pt-xl-10 {
    padding-top: 4.5rem !important;
  }

  .pt-xl-11 {
    padding-top: 5rem !important;
  }

  .pt-xl-12 {
    padding-top: 5.5rem !important;
  }

  .pt-xl-13 {
    padding-top: 6rem !important;
  }

  .pt-xl-14 {
    padding-top: 6.5rem !important;
  }

  .pt-xl-15 {
    padding-top: 7rem !important;
  }

  .pt-xl-16 {
    padding-top: 7.5rem !important;
  }

  .pt-xl-17 {
    padding-top: 8rem !important;
  }

  .pt-xl-18 {
    padding-top: 8.5rem !important;
  }

  .pt-xl-19 {
    padding-top: 9rem !important;
  }

  .pt-xl-20 {
    padding-top: 9.5rem !important;
  }

  .pt-xl-21 {
    padding-top: 10rem !important;
  }

  .pt-xl-22 {
    padding-top: 10.5rem !important;
  }

  .pt-xl-23 {
    padding-top: 11rem !important;
  }

  .pt-xl-24 {
    padding-top: 11.5rem !important;
  }

  .pt-xl-25 {
    padding-top: 12rem !important;
  }

  .pt-xl-26 {
    padding-top: 12.5rem !important;
  }

  .pt-xl-27 {
    padding-top: 13rem !important;
  }

  .pt-xl-28 {
    padding-top: 13.5rem !important;
  }

  .pt-xl-29 {
    padding-top: 14rem !important;
  }

  .pt-xl-30 {
    padding-top: 14.5rem !important;
  }

  .pt-xl-31 {
    padding-top: 15rem !important;
  }

  .pt-xl-32 {
    padding-top: 15.5rem !important;
  }

  .pt-xl-33 {
    padding-top: 16rem !important;
  }

  .pt-xl-34 {
    padding-top: 16.5rem !important;
  }

  .pt-xl-35 {
    padding-top: 17rem !important;
  }

  .pt-xl-36 {
    padding-top: 17.5rem !important;
  }

  .pt-xl-37 {
    padding-top: 18rem !important;
  }

  .pt-xl-38 {
    padding-top: 18.5rem !important;
  }

  .pt-xl-39 {
    padding-top: 19rem !important;
  }

  .pt-xl-40 {
    padding-top: 19.5rem !important;
  }

  .pt-xl-41 {
    padding-top: 20rem !important;
  }

  .pt-xl-42 {
    padding-top: 20.5rem !important;
  }

  .pt-xl-43 {
    padding-top: 21rem !important;
  }

  .pt-xl-44 {
    padding-top: 21.5rem !important;
  }

  .pt-xl-45 {
    padding-top: 22rem !important;
  }

  .pt-xl-46 {
    padding-top: 22.5rem !important;
  }

  .pt-xl-47 {
    padding-top: 23rem !important;
  }

  .pt-xl-48 {
    padding-top: 23.5rem !important;
  }

  .pt-xl-49 {
    padding-top: 24rem !important;
  }

  .pt-xl-50 {
    padding-top: 24.5rem !important;
  }

  .pt-xl-51 {
    padding-top: 25rem !important;
  }

  .pt-xl-52 {
    padding-top: 25.5rem !important;
  }

  .pt-xl-53 {
    padding-top: 26rem !important;
  }

  .pt-xl-54 {
    padding-top: 26.5rem !important;
  }

  .pt-xl-55 {
    padding-top: 27rem !important;
  }

  .pt-xl-56 {
    padding-top: 27.5rem !important;
  }

  .pt-xl-57 {
    padding-top: 28rem !important;
  }

  .pt-xl-58 {
    padding-top: 28.5rem !important;
  }

  .pt-xl-59 {
    padding-top: 29rem !important;
  }

  .pt-xl-60 {
    padding-top: 29.5rem !important;
  }

  .pt-xl-61 {
    padding-top: 30rem !important;
  }

  .pt-xl-62 {
    padding-top: 30.5rem !important;
  }

  .pt-xl-63 {
    padding-top: 31rem !important;
  }

  .pt-xl-64 {
    padding-top: 31.5rem !important;
  }

  .pt-xl-65 {
    padding-top: 32rem !important;
  }

  .pt-xl-66 {
    padding-top: 32.5rem !important;
  }

  .pt-xl-67 {
    padding-top: 33rem !important;
  }

  .pt-xl-68 {
    padding-top: 33.5rem !important;
  }

  .pt-xl-69 {
    padding-top: 34rem !important;
  }

  .pt-xl-70 {
    padding-top: 34.5rem !important;
  }

  .pt-xl-71 {
    padding-top: 35rem !important;
  }

  .pt-xl-72 {
    padding-top: 35.5rem !important;
  }

  .pt-xl-73 {
    padding-top: 36rem !important;
  }

  .pt-xl-74 {
    padding-top: 36.5rem !important;
  }

  .pt-xl-75 {
    padding-top: 37rem !important;
  }

  .pt-xl-76 {
    padding-top: 37.5rem !important;
  }

  .pt-xl-77 {
    padding-top: 38rem !important;
  }

  .pt-xl-78 {
    padding-top: 38.5rem !important;
  }

  .pt-xl-79 {
    padding-top: 39rem !important;
  }

  .pt-xl-80 {
    padding-top: 39.5rem !important;
  }

  .pt-xl-81 {
    padding-top: 40rem !important;
  }

  .pt-xl-82 {
    padding-top: 40.5rem !important;
  }

  .pt-xl-83 {
    padding-top: 41rem !important;
  }

  .pt-xl-84 {
    padding-top: 41.5rem !important;
  }

  .pt-xl-85 {
    padding-top: 42rem !important;
  }

  .pt-xl-86 {
    padding-top: 42.5rem !important;
  }

  .pt-xl-87 {
    padding-top: 43rem !important;
  }

  .pt-xl-88 {
    padding-top: 43.5rem !important;
  }

  .pt-xl-89 {
    padding-top: 44rem !important;
  }

  .pt-xl-90 {
    padding-top: 44.5rem !important;
  }

  .pt-xl-91 {
    padding-top: 45rem !important;
  }

  .pt-xl-92 {
    padding-top: 45.5rem !important;
  }

  .pt-xl-93 {
    padding-top: 46rem !important;
  }

  .pt-xl-94 {
    padding-top: 46.5rem !important;
  }

  .pt-xl-95 {
    padding-top: 47rem !important;
  }

  .pt-xl-96 {
    padding-top: 47.5rem !important;
  }

  .pt-xl-97 {
    padding-top: 48rem !important;
  }

  .pt-xl-98 {
    padding-top: 48.5rem !important;
  }

  .pt-xl-99 {
    padding-top: 49rem !important;
  }

  .pt-xl-100 {
    padding-top: 49.5rem !important;
  }

  .pt-xl-101 {
    padding-top: 50rem !important;
  }

  .pt-xl-102 {
    padding-top: 50.5rem !important;
  }

  .pt-xl-103 {
    padding-top: 51rem !important;
  }

  .pt-xl-104 {
    padding-top: 51.5rem !important;
  }

  .pt-xl-105 {
    padding-top: 52rem !important;
  }

  .pt-xl-106 {
    padding-top: 52.5rem !important;
  }

  .pt-xl-107 {
    padding-top: 53rem !important;
  }

  .pt-xl-108 {
    padding-top: 53.5rem !important;
  }

  .pt-xl-109 {
    padding-top: 54rem !important;
  }

  .pt-xl-110 {
    padding-top: 54.5rem !important;
  }

  .pt-xl-111 {
    padding-top: 55rem !important;
  }

  .pt-xl-112 {
    padding-top: 55.5rem !important;
  }

  .pt-xl-113 {
    padding-top: 56rem !important;
  }

  .pt-xl-114 {
    padding-top: 56.5rem !important;
  }

  .pt-xl-115 {
    padding-top: 57rem !important;
  }

  .pt-xl-116 {
    padding-top: 57.5rem !important;
  }

  .pt-xl-117 {
    padding-top: 58rem !important;
  }

  .pt-xl-118 {
    padding-top: 58.5rem !important;
  }

  .pt-xl-119 {
    padding-top: 59rem !important;
  }

  .pt-xl-120 {
    padding-top: 59.5rem !important;
  }

  .pt-xl-121 {
    padding-top: 60rem !important;
  }

  .pt-xl-122 {
    padding-top: 60.5rem !important;
  }

  .pt-xl-123 {
    padding-top: 61rem !important;
  }

  .pt-xl-124 {
    padding-top: 61.5rem !important;
  }

  .pt-xl-125 {
    padding-top: 62rem !important;
  }

  .pt-xl-126 {
    padding-top: 62.5rem !important;
  }

  .pt-xl-127 {
    padding-top: 63rem !important;
  }

  .pt-xl-128 {
    padding-top: 63.5rem !important;
  }

  .pt-xl-129 {
    padding-top: 64rem !important;
  }

  .pt-xl-130 {
    padding-top: 64.5rem !important;
  }

  .pt-xl-131 {
    padding-top: 65rem !important;
  }

  .pt-xl-132 {
    padding-top: 65.5rem !important;
  }

  .pt-xl-133 {
    padding-top: 66rem !important;
  }

  .pt-xl-134 {
    padding-top: 66.5rem !important;
  }

  .pt-xl-135 {
    padding-top: 67rem !important;
  }

  .pt-xl-136 {
    padding-top: 67.5rem !important;
  }

  .pt-xl-137 {
    padding-top: 68rem !important;
  }

  .pt-xl-138 {
    padding-top: 68.5rem !important;
  }

  .pt-xl-139 {
    padding-top: 69rem !important;
  }

  .pt-xl-140 {
    padding-top: 69.5rem !important;
  }

  .pt-xl-141 {
    padding-top: 70rem !important;
  }

  .pt-xl-142 {
    padding-top: 70.5rem !important;
  }

  .pt-xl-143 {
    padding-top: 71rem !important;
  }

  .pt-xl-144 {
    padding-top: 71.5rem !important;
  }

  .pt-xl-145 {
    padding-top: 72rem !important;
  }

  .pt-xl-146 {
    padding-top: 72.5rem !important;
  }

  .pt-xl-147 {
    padding-top: 73rem !important;
  }

  .pt-xl-148 {
    padding-top: 73.5rem !important;
  }

  .pt-xl-149 {
    padding-top: 74rem !important;
  }

  .pt-xl-150 {
    padding-top: 74.5rem !important;
  }

  .pt-xl-151 {
    padding-top: 75rem !important;
  }

  .pt-xl-152 {
    padding-top: 75.5rem !important;
  }

  .pt-xl-153 {
    padding-top: 76rem !important;
  }

  .pt-xl-154 {
    padding-top: 76.5rem !important;
  }

  .pt-xl-155 {
    padding-top: 77rem !important;
  }

  .pt-xl-156 {
    padding-top: 77.5rem !important;
  }

  .pt-xl-157 {
    padding-top: 78rem !important;
  }

  .pt-xl-158 {
    padding-top: 78.5rem !important;
  }

  .pt-xl-159 {
    padding-top: 79rem !important;
  }

  .pt-xl-160 {
    padding-top: 79.5rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0rem !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 2rem !important;
  }

  .pb-xl-6 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xl-7 {
    padding-bottom: 3rem !important;
  }

  .pb-xl-8 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xl-9 {
    padding-bottom: 4rem !important;
  }

  .pb-xl-10 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xl-11 {
    padding-bottom: 5rem !important;
  }

  .pb-xl-12 {
    padding-bottom: 5.5rem !important;
  }

  .pb-xl-13 {
    padding-bottom: 6rem !important;
  }

  .pb-xl-14 {
    padding-bottom: 6.5rem !important;
  }

  .pb-xl-15 {
    padding-bottom: 7rem !important;
  }

  .pb-xl-16 {
    padding-bottom: 7.5rem !important;
  }

  .pb-xl-17 {
    padding-bottom: 8rem !important;
  }

  .pb-xl-18 {
    padding-bottom: 8.5rem !important;
  }

  .pb-xl-19 {
    padding-bottom: 9rem !important;
  }

  .pb-xl-20 {
    padding-bottom: 9.5rem !important;
  }

  .pb-xl-21 {
    padding-bottom: 10rem !important;
  }

  .pb-xl-22 {
    padding-bottom: 10.5rem !important;
  }

  .pb-xl-23 {
    padding-bottom: 11rem !important;
  }

  .pb-xl-24 {
    padding-bottom: 11.5rem !important;
  }

  .pb-xl-25 {
    padding-bottom: 12rem !important;
  }

  .pb-xl-26 {
    padding-bottom: 12.5rem !important;
  }

  .pb-xl-27 {
    padding-bottom: 13rem !important;
  }

  .pb-xl-28 {
    padding-bottom: 13.5rem !important;
  }

  .pb-xl-29 {
    padding-bottom: 14rem !important;
  }

  .pb-xl-30 {
    padding-bottom: 14.5rem !important;
  }

  .pb-xl-31 {
    padding-bottom: 15rem !important;
  }

  .pb-xl-32 {
    padding-bottom: 15.5rem !important;
  }

  .pb-xl-33 {
    padding-bottom: 16rem !important;
  }

  .pb-xl-34 {
    padding-bottom: 16.5rem !important;
  }

  .pb-xl-35 {
    padding-bottom: 17rem !important;
  }

  .pb-xl-36 {
    padding-bottom: 17.5rem !important;
  }

  .pb-xl-37 {
    padding-bottom: 18rem !important;
  }

  .pb-xl-38 {
    padding-bottom: 18.5rem !important;
  }

  .pb-xl-39 {
    padding-bottom: 19rem !important;
  }

  .pb-xl-40 {
    padding-bottom: 19.5rem !important;
  }

  .pb-xl-41 {
    padding-bottom: 20rem !important;
  }

  .pb-xl-42 {
    padding-bottom: 20.5rem !important;
  }

  .pb-xl-43 {
    padding-bottom: 21rem !important;
  }

  .pb-xl-44 {
    padding-bottom: 21.5rem !important;
  }

  .pb-xl-45 {
    padding-bottom: 22rem !important;
  }

  .pb-xl-46 {
    padding-bottom: 22.5rem !important;
  }

  .pb-xl-47 {
    padding-bottom: 23rem !important;
  }

  .pb-xl-48 {
    padding-bottom: 23.5rem !important;
  }

  .pb-xl-49 {
    padding-bottom: 24rem !important;
  }

  .pb-xl-50 {
    padding-bottom: 24.5rem !important;
  }

  .pb-xl-51 {
    padding-bottom: 25rem !important;
  }

  .pb-xl-52 {
    padding-bottom: 25.5rem !important;
  }

  .pb-xl-53 {
    padding-bottom: 26rem !important;
  }

  .pb-xl-54 {
    padding-bottom: 26.5rem !important;
  }

  .pb-xl-55 {
    padding-bottom: 27rem !important;
  }

  .pb-xl-56 {
    padding-bottom: 27.5rem !important;
  }

  .pb-xl-57 {
    padding-bottom: 28rem !important;
  }

  .pb-xl-58 {
    padding-bottom: 28.5rem !important;
  }

  .pb-xl-59 {
    padding-bottom: 29rem !important;
  }

  .pb-xl-60 {
    padding-bottom: 29.5rem !important;
  }

  .pb-xl-61 {
    padding-bottom: 30rem !important;
  }

  .pb-xl-62 {
    padding-bottom: 30.5rem !important;
  }

  .pb-xl-63 {
    padding-bottom: 31rem !important;
  }

  .pb-xl-64 {
    padding-bottom: 31.5rem !important;
  }

  .pb-xl-65 {
    padding-bottom: 32rem !important;
  }

  .pb-xl-66 {
    padding-bottom: 32.5rem !important;
  }

  .pb-xl-67 {
    padding-bottom: 33rem !important;
  }

  .pb-xl-68 {
    padding-bottom: 33.5rem !important;
  }

  .pb-xl-69 {
    padding-bottom: 34rem !important;
  }

  .pb-xl-70 {
    padding-bottom: 34.5rem !important;
  }

  .pb-xl-71 {
    padding-bottom: 35rem !important;
  }

  .pb-xl-72 {
    padding-bottom: 35.5rem !important;
  }

  .pb-xl-73 {
    padding-bottom: 36rem !important;
  }

  .pb-xl-74 {
    padding-bottom: 36.5rem !important;
  }

  .pb-xl-75 {
    padding-bottom: 37rem !important;
  }

  .pb-xl-76 {
    padding-bottom: 37.5rem !important;
  }

  .pb-xl-77 {
    padding-bottom: 38rem !important;
  }

  .pb-xl-78 {
    padding-bottom: 38.5rem !important;
  }

  .pb-xl-79 {
    padding-bottom: 39rem !important;
  }

  .pb-xl-80 {
    padding-bottom: 39.5rem !important;
  }

  .pb-xl-81 {
    padding-bottom: 40rem !important;
  }

  .pb-xl-82 {
    padding-bottom: 40.5rem !important;
  }

  .pb-xl-83 {
    padding-bottom: 41rem !important;
  }

  .pb-xl-84 {
    padding-bottom: 41.5rem !important;
  }

  .pb-xl-85 {
    padding-bottom: 42rem !important;
  }

  .pb-xl-86 {
    padding-bottom: 42.5rem !important;
  }

  .pb-xl-87 {
    padding-bottom: 43rem !important;
  }

  .pb-xl-88 {
    padding-bottom: 43.5rem !important;
  }

  .pb-xl-89 {
    padding-bottom: 44rem !important;
  }

  .pb-xl-90 {
    padding-bottom: 44.5rem !important;
  }

  .pb-xl-91 {
    padding-bottom: 45rem !important;
  }

  .pb-xl-92 {
    padding-bottom: 45.5rem !important;
  }

  .pb-xl-93 {
    padding-bottom: 46rem !important;
  }

  .pb-xl-94 {
    padding-bottom: 46.5rem !important;
  }

  .pb-xl-95 {
    padding-bottom: 47rem !important;
  }

  .pb-xl-96 {
    padding-bottom: 47.5rem !important;
  }

  .pb-xl-97 {
    padding-bottom: 48rem !important;
  }

  .pb-xl-98 {
    padding-bottom: 48.5rem !important;
  }

  .pb-xl-99 {
    padding-bottom: 49rem !important;
  }

  .pb-xl-100 {
    padding-bottom: 49.5rem !important;
  }

  .pb-xl-101 {
    padding-bottom: 50rem !important;
  }

  .pb-xl-102 {
    padding-bottom: 50.5rem !important;
  }

  .pb-xl-103 {
    padding-bottom: 51rem !important;
  }

  .pb-xl-104 {
    padding-bottom: 51.5rem !important;
  }

  .pb-xl-105 {
    padding-bottom: 52rem !important;
  }

  .pb-xl-106 {
    padding-bottom: 52.5rem !important;
  }

  .pb-xl-107 {
    padding-bottom: 53rem !important;
  }

  .pb-xl-108 {
    padding-bottom: 53.5rem !important;
  }

  .pb-xl-109 {
    padding-bottom: 54rem !important;
  }

  .pb-xl-110 {
    padding-bottom: 54.5rem !important;
  }

  .pb-xl-111 {
    padding-bottom: 55rem !important;
  }

  .pb-xl-112 {
    padding-bottom: 55.5rem !important;
  }

  .pb-xl-113 {
    padding-bottom: 56rem !important;
  }

  .pb-xl-114 {
    padding-bottom: 56.5rem !important;
  }

  .pb-xl-115 {
    padding-bottom: 57rem !important;
  }

  .pb-xl-116 {
    padding-bottom: 57.5rem !important;
  }

  .pb-xl-117 {
    padding-bottom: 58rem !important;
  }

  .pb-xl-118 {
    padding-bottom: 58.5rem !important;
  }

  .pb-xl-119 {
    padding-bottom: 59rem !important;
  }

  .pb-xl-120 {
    padding-bottom: 59.5rem !important;
  }

  .pb-xl-121 {
    padding-bottom: 60rem !important;
  }

  .pb-xl-122 {
    padding-bottom: 60.5rem !important;
  }

  .pb-xl-123 {
    padding-bottom: 61rem !important;
  }

  .pb-xl-124 {
    padding-bottom: 61.5rem !important;
  }

  .pb-xl-125 {
    padding-bottom: 62rem !important;
  }

  .pb-xl-126 {
    padding-bottom: 62.5rem !important;
  }

  .pb-xl-127 {
    padding-bottom: 63rem !important;
  }

  .pb-xl-128 {
    padding-bottom: 63.5rem !important;
  }

  .pb-xl-129 {
    padding-bottom: 64rem !important;
  }

  .pb-xl-130 {
    padding-bottom: 64.5rem !important;
  }

  .pb-xl-131 {
    padding-bottom: 65rem !important;
  }

  .pb-xl-132 {
    padding-bottom: 65.5rem !important;
  }

  .pb-xl-133 {
    padding-bottom: 66rem !important;
  }

  .pb-xl-134 {
    padding-bottom: 66.5rem !important;
  }

  .pb-xl-135 {
    padding-bottom: 67rem !important;
  }

  .pb-xl-136 {
    padding-bottom: 67.5rem !important;
  }

  .pb-xl-137 {
    padding-bottom: 68rem !important;
  }

  .pb-xl-138 {
    padding-bottom: 68.5rem !important;
  }

  .pb-xl-139 {
    padding-bottom: 69rem !important;
  }

  .pb-xl-140 {
    padding-bottom: 69.5rem !important;
  }

  .pb-xl-141 {
    padding-bottom: 70rem !important;
  }

  .pb-xl-142 {
    padding-bottom: 70.5rem !important;
  }

  .pb-xl-143 {
    padding-bottom: 71rem !important;
  }

  .pb-xl-144 {
    padding-bottom: 71.5rem !important;
  }

  .pb-xl-145 {
    padding-bottom: 72rem !important;
  }

  .pb-xl-146 {
    padding-bottom: 72.5rem !important;
  }

  .pb-xl-147 {
    padding-bottom: 73rem !important;
  }

  .pb-xl-148 {
    padding-bottom: 73.5rem !important;
  }

  .pb-xl-149 {
    padding-bottom: 74rem !important;
  }

  .pb-xl-150 {
    padding-bottom: 74.5rem !important;
  }

  .pb-xl-151 {
    padding-bottom: 75rem !important;
  }

  .pb-xl-152 {
    padding-bottom: 75.5rem !important;
  }

  .pb-xl-153 {
    padding-bottom: 76rem !important;
  }

  .pb-xl-154 {
    padding-bottom: 76.5rem !important;
  }

  .pb-xl-155 {
    padding-bottom: 77rem !important;
  }

  .pb-xl-156 {
    padding-bottom: 77.5rem !important;
  }

  .pb-xl-157 {
    padding-bottom: 78rem !important;
  }

  .pb-xl-158 {
    padding-bottom: 78.5rem !important;
  }

  .pb-xl-159 {
    padding-bottom: 79rem !important;
  }

  .pb-xl-160 {
    padding-bottom: 79.5rem !important;
  }

  .ps-xl-0 {
    padding-left: 0rem !important;
  }

  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xl-3 {
    padding-left: 1rem !important;
  }

  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xl-5 {
    padding-left: 2rem !important;
  }

  .ps-xl-6 {
    padding-left: 2.5rem !important;
  }

  .ps-xl-7 {
    padding-left: 3rem !important;
  }

  .ps-xl-8 {
    padding-left: 3.5rem !important;
  }

  .ps-xl-9 {
    padding-left: 4rem !important;
  }

  .ps-xl-10 {
    padding-left: 4.5rem !important;
  }

  .ps-xl-11 {
    padding-left: 5rem !important;
  }

  .ps-xl-12 {
    padding-left: 5.5rem !important;
  }

  .ps-xl-13 {
    padding-left: 6rem !important;
  }

  .ps-xl-14 {
    padding-left: 6.5rem !important;
  }

  .ps-xl-15 {
    padding-left: 7rem !important;
  }

  .ps-xl-16 {
    padding-left: 7.5rem !important;
  }

  .ps-xl-17 {
    padding-left: 8rem !important;
  }

  .ps-xl-18 {
    padding-left: 8.5rem !important;
  }

  .ps-xl-19 {
    padding-left: 9rem !important;
  }

  .ps-xl-20 {
    padding-left: 9.5rem !important;
  }

  .ps-xl-21 {
    padding-left: 10rem !important;
  }

  .ps-xl-22 {
    padding-left: 10.5rem !important;
  }

  .ps-xl-23 {
    padding-left: 11rem !important;
  }

  .ps-xl-24 {
    padding-left: 11.5rem !important;
  }

  .ps-xl-25 {
    padding-left: 12rem !important;
  }

  .ps-xl-26 {
    padding-left: 12.5rem !important;
  }

  .ps-xl-27 {
    padding-left: 13rem !important;
  }

  .ps-xl-28 {
    padding-left: 13.5rem !important;
  }

  .ps-xl-29 {
    padding-left: 14rem !important;
  }

  .ps-xl-30 {
    padding-left: 14.5rem !important;
  }

  .ps-xl-31 {
    padding-left: 15rem !important;
  }

  .ps-xl-32 {
    padding-left: 15.5rem !important;
  }

  .ps-xl-33 {
    padding-left: 16rem !important;
  }

  .ps-xl-34 {
    padding-left: 16.5rem !important;
  }

  .ps-xl-35 {
    padding-left: 17rem !important;
  }

  .ps-xl-36 {
    padding-left: 17.5rem !important;
  }

  .ps-xl-37 {
    padding-left: 18rem !important;
  }

  .ps-xl-38 {
    padding-left: 18.5rem !important;
  }

  .ps-xl-39 {
    padding-left: 19rem !important;
  }

  .ps-xl-40 {
    padding-left: 19.5rem !important;
  }

  .ps-xl-41 {
    padding-left: 20rem !important;
  }

  .ps-xl-42 {
    padding-left: 20.5rem !important;
  }

  .ps-xl-43 {
    padding-left: 21rem !important;
  }

  .ps-xl-44 {
    padding-left: 21.5rem !important;
  }

  .ps-xl-45 {
    padding-left: 22rem !important;
  }

  .ps-xl-46 {
    padding-left: 22.5rem !important;
  }

  .ps-xl-47 {
    padding-left: 23rem !important;
  }

  .ps-xl-48 {
    padding-left: 23.5rem !important;
  }

  .ps-xl-49 {
    padding-left: 24rem !important;
  }

  .ps-xl-50 {
    padding-left: 24.5rem !important;
  }

  .ps-xl-51 {
    padding-left: 25rem !important;
  }

  .ps-xl-52 {
    padding-left: 25.5rem !important;
  }

  .ps-xl-53 {
    padding-left: 26rem !important;
  }

  .ps-xl-54 {
    padding-left: 26.5rem !important;
  }

  .ps-xl-55 {
    padding-left: 27rem !important;
  }

  .ps-xl-56 {
    padding-left: 27.5rem !important;
  }

  .ps-xl-57 {
    padding-left: 28rem !important;
  }

  .ps-xl-58 {
    padding-left: 28.5rem !important;
  }

  .ps-xl-59 {
    padding-left: 29rem !important;
  }

  .ps-xl-60 {
    padding-left: 29.5rem !important;
  }

  .ps-xl-61 {
    padding-left: 30rem !important;
  }

  .ps-xl-62 {
    padding-left: 30.5rem !important;
  }

  .ps-xl-63 {
    padding-left: 31rem !important;
  }

  .ps-xl-64 {
    padding-left: 31.5rem !important;
  }

  .ps-xl-65 {
    padding-left: 32rem !important;
  }

  .ps-xl-66 {
    padding-left: 32.5rem !important;
  }

  .ps-xl-67 {
    padding-left: 33rem !important;
  }

  .ps-xl-68 {
    padding-left: 33.5rem !important;
  }

  .ps-xl-69 {
    padding-left: 34rem !important;
  }

  .ps-xl-70 {
    padding-left: 34.5rem !important;
  }

  .ps-xl-71 {
    padding-left: 35rem !important;
  }

  .ps-xl-72 {
    padding-left: 35.5rem !important;
  }

  .ps-xl-73 {
    padding-left: 36rem !important;
  }

  .ps-xl-74 {
    padding-left: 36.5rem !important;
  }

  .ps-xl-75 {
    padding-left: 37rem !important;
  }

  .ps-xl-76 {
    padding-left: 37.5rem !important;
  }

  .ps-xl-77 {
    padding-left: 38rem !important;
  }

  .ps-xl-78 {
    padding-left: 38.5rem !important;
  }

  .ps-xl-79 {
    padding-left: 39rem !important;
  }

  .ps-xl-80 {
    padding-left: 39.5rem !important;
  }

  .ps-xl-81 {
    padding-left: 40rem !important;
  }

  .ps-xl-82 {
    padding-left: 40.5rem !important;
  }

  .ps-xl-83 {
    padding-left: 41rem !important;
  }

  .ps-xl-84 {
    padding-left: 41.5rem !important;
  }

  .ps-xl-85 {
    padding-left: 42rem !important;
  }

  .ps-xl-86 {
    padding-left: 42.5rem !important;
  }

  .ps-xl-87 {
    padding-left: 43rem !important;
  }

  .ps-xl-88 {
    padding-left: 43.5rem !important;
  }

  .ps-xl-89 {
    padding-left: 44rem !important;
  }

  .ps-xl-90 {
    padding-left: 44.5rem !important;
  }

  .ps-xl-91 {
    padding-left: 45rem !important;
  }

  .ps-xl-92 {
    padding-left: 45.5rem !important;
  }

  .ps-xl-93 {
    padding-left: 46rem !important;
  }

  .ps-xl-94 {
    padding-left: 46.5rem !important;
  }

  .ps-xl-95 {
    padding-left: 47rem !important;
  }

  .ps-xl-96 {
    padding-left: 47.5rem !important;
  }

  .ps-xl-97 {
    padding-left: 48rem !important;
  }

  .ps-xl-98 {
    padding-left: 48.5rem !important;
  }

  .ps-xl-99 {
    padding-left: 49rem !important;
  }

  .ps-xl-100 {
    padding-left: 49.5rem !important;
  }

  .ps-xl-101 {
    padding-left: 50rem !important;
  }

  .ps-xl-102 {
    padding-left: 50.5rem !important;
  }

  .ps-xl-103 {
    padding-left: 51rem !important;
  }

  .ps-xl-104 {
    padding-left: 51.5rem !important;
  }

  .ps-xl-105 {
    padding-left: 52rem !important;
  }

  .ps-xl-106 {
    padding-left: 52.5rem !important;
  }

  .ps-xl-107 {
    padding-left: 53rem !important;
  }

  .ps-xl-108 {
    padding-left: 53.5rem !important;
  }

  .ps-xl-109 {
    padding-left: 54rem !important;
  }

  .ps-xl-110 {
    padding-left: 54.5rem !important;
  }

  .ps-xl-111 {
    padding-left: 55rem !important;
  }

  .ps-xl-112 {
    padding-left: 55.5rem !important;
  }

  .ps-xl-113 {
    padding-left: 56rem !important;
  }

  .ps-xl-114 {
    padding-left: 56.5rem !important;
  }

  .ps-xl-115 {
    padding-left: 57rem !important;
  }

  .ps-xl-116 {
    padding-left: 57.5rem !important;
  }

  .ps-xl-117 {
    padding-left: 58rem !important;
  }

  .ps-xl-118 {
    padding-left: 58.5rem !important;
  }

  .ps-xl-119 {
    padding-left: 59rem !important;
  }

  .ps-xl-120 {
    padding-left: 59.5rem !important;
  }

  .ps-xl-121 {
    padding-left: 60rem !important;
  }

  .ps-xl-122 {
    padding-left: 60.5rem !important;
  }

  .ps-xl-123 {
    padding-left: 61rem !important;
  }

  .ps-xl-124 {
    padding-left: 61.5rem !important;
  }

  .ps-xl-125 {
    padding-left: 62rem !important;
  }

  .ps-xl-126 {
    padding-left: 62.5rem !important;
  }

  .ps-xl-127 {
    padding-left: 63rem !important;
  }

  .ps-xl-128 {
    padding-left: 63.5rem !important;
  }

  .ps-xl-129 {
    padding-left: 64rem !important;
  }

  .ps-xl-130 {
    padding-left: 64.5rem !important;
  }

  .ps-xl-131 {
    padding-left: 65rem !important;
  }

  .ps-xl-132 {
    padding-left: 65.5rem !important;
  }

  .ps-xl-133 {
    padding-left: 66rem !important;
  }

  .ps-xl-134 {
    padding-left: 66.5rem !important;
  }

  .ps-xl-135 {
    padding-left: 67rem !important;
  }

  .ps-xl-136 {
    padding-left: 67.5rem !important;
  }

  .ps-xl-137 {
    padding-left: 68rem !important;
  }

  .ps-xl-138 {
    padding-left: 68.5rem !important;
  }

  .ps-xl-139 {
    padding-left: 69rem !important;
  }

  .ps-xl-140 {
    padding-left: 69.5rem !important;
  }

  .ps-xl-141 {
    padding-left: 70rem !important;
  }

  .ps-xl-142 {
    padding-left: 70.5rem !important;
  }

  .ps-xl-143 {
    padding-left: 71rem !important;
  }

  .ps-xl-144 {
    padding-left: 71.5rem !important;
  }

  .ps-xl-145 {
    padding-left: 72rem !important;
  }

  .ps-xl-146 {
    padding-left: 72.5rem !important;
  }

  .ps-xl-147 {
    padding-left: 73rem !important;
  }

  .ps-xl-148 {
    padding-left: 73.5rem !important;
  }

  .ps-xl-149 {
    padding-left: 74rem !important;
  }

  .ps-xl-150 {
    padding-left: 74.5rem !important;
  }

  .ps-xl-151 {
    padding-left: 75rem !important;
  }

  .ps-xl-152 {
    padding-left: 75.5rem !important;
  }

  .ps-xl-153 {
    padding-left: 76rem !important;
  }

  .ps-xl-154 {
    padding-left: 76.5rem !important;
  }

  .ps-xl-155 {
    padding-left: 77rem !important;
  }

  .ps-xl-156 {
    padding-left: 77.5rem !important;
  }

  .ps-xl-157 {
    padding-left: 78rem !important;
  }

  .ps-xl-158 {
    padding-left: 78.5rem !important;
  }

  .ps-xl-159 {
    padding-left: 79rem !important;
  }

  .ps-xl-160 {
    padding-left: 79.5rem !important;
  }

  .pe-xl-0 {
    padding-right: 0rem !important;
  }

  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xl-3 {
    padding-right: 1rem !important;
  }

  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xl-5 {
    padding-right: 2rem !important;
  }

  .pe-xl-6 {
    padding-right: 2.5rem !important;
  }

  .pe-xl-7 {
    padding-right: 3rem !important;
  }

  .pe-xl-8 {
    padding-right: 3.5rem !important;
  }

  .pe-xl-9 {
    padding-right: 4rem !important;
  }

  .pe-xl-10 {
    padding-right: 4.5rem !important;
  }

  .pe-xl-11 {
    padding-right: 5rem !important;
  }

  .pe-xl-12 {
    padding-right: 5.5rem !important;
  }

  .pe-xl-13 {
    padding-right: 6rem !important;
  }

  .pe-xl-14 {
    padding-right: 6.5rem !important;
  }

  .pe-xl-15 {
    padding-right: 7rem !important;
  }

  .pe-xl-16 {
    padding-right: 7.5rem !important;
  }

  .pe-xl-17 {
    padding-right: 8rem !important;
  }

  .pe-xl-18 {
    padding-right: 8.5rem !important;
  }

  .pe-xl-19 {
    padding-right: 9rem !important;
  }

  .pe-xl-20 {
    padding-right: 9.5rem !important;
  }

  .pe-xl-21 {
    padding-right: 10rem !important;
  }

  .pe-xl-22 {
    padding-right: 10.5rem !important;
  }

  .pe-xl-23 {
    padding-right: 11rem !important;
  }

  .pe-xl-24 {
    padding-right: 11.5rem !important;
  }

  .pe-xl-25 {
    padding-right: 12rem !important;
  }

  .pe-xl-26 {
    padding-right: 12.5rem !important;
  }

  .pe-xl-27 {
    padding-right: 13rem !important;
  }

  .pe-xl-28 {
    padding-right: 13.5rem !important;
  }

  .pe-xl-29 {
    padding-right: 14rem !important;
  }

  .pe-xl-30 {
    padding-right: 14.5rem !important;
  }

  .pe-xl-31 {
    padding-right: 15rem !important;
  }

  .pe-xl-32 {
    padding-right: 15.5rem !important;
  }

  .pe-xl-33 {
    padding-right: 16rem !important;
  }

  .pe-xl-34 {
    padding-right: 16.5rem !important;
  }

  .pe-xl-35 {
    padding-right: 17rem !important;
  }

  .pe-xl-36 {
    padding-right: 17.5rem !important;
  }

  .pe-xl-37 {
    padding-right: 18rem !important;
  }

  .pe-xl-38 {
    padding-right: 18.5rem !important;
  }

  .pe-xl-39 {
    padding-right: 19rem !important;
  }

  .pe-xl-40 {
    padding-right: 19.5rem !important;
  }

  .pe-xl-41 {
    padding-right: 20rem !important;
  }

  .pe-xl-42 {
    padding-right: 20.5rem !important;
  }

  .pe-xl-43 {
    padding-right: 21rem !important;
  }

  .pe-xl-44 {
    padding-right: 21.5rem !important;
  }

  .pe-xl-45 {
    padding-right: 22rem !important;
  }

  .pe-xl-46 {
    padding-right: 22.5rem !important;
  }

  .pe-xl-47 {
    padding-right: 23rem !important;
  }

  .pe-xl-48 {
    padding-right: 23.5rem !important;
  }

  .pe-xl-49 {
    padding-right: 24rem !important;
  }

  .pe-xl-50 {
    padding-right: 24.5rem !important;
  }

  .pe-xl-51 {
    padding-right: 25rem !important;
  }

  .pe-xl-52 {
    padding-right: 25.5rem !important;
  }

  .pe-xl-53 {
    padding-right: 26rem !important;
  }

  .pe-xl-54 {
    padding-right: 26.5rem !important;
  }

  .pe-xl-55 {
    padding-right: 27rem !important;
  }

  .pe-xl-56 {
    padding-right: 27.5rem !important;
  }

  .pe-xl-57 {
    padding-right: 28rem !important;
  }

  .pe-xl-58 {
    padding-right: 28.5rem !important;
  }

  .pe-xl-59 {
    padding-right: 29rem !important;
  }

  .pe-xl-60 {
    padding-right: 29.5rem !important;
  }

  .pe-xl-61 {
    padding-right: 30rem !important;
  }

  .pe-xl-62 {
    padding-right: 30.5rem !important;
  }

  .pe-xl-63 {
    padding-right: 31rem !important;
  }

  .pe-xl-64 {
    padding-right: 31.5rem !important;
  }

  .pe-xl-65 {
    padding-right: 32rem !important;
  }

  .pe-xl-66 {
    padding-right: 32.5rem !important;
  }

  .pe-xl-67 {
    padding-right: 33rem !important;
  }

  .pe-xl-68 {
    padding-right: 33.5rem !important;
  }

  .pe-xl-69 {
    padding-right: 34rem !important;
  }

  .pe-xl-70 {
    padding-right: 34.5rem !important;
  }

  .pe-xl-71 {
    padding-right: 35rem !important;
  }

  .pe-xl-72 {
    padding-right: 35.5rem !important;
  }

  .pe-xl-73 {
    padding-right: 36rem !important;
  }

  .pe-xl-74 {
    padding-right: 36.5rem !important;
  }

  .pe-xl-75 {
    padding-right: 37rem !important;
  }

  .pe-xl-76 {
    padding-right: 37.5rem !important;
  }

  .pe-xl-77 {
    padding-right: 38rem !important;
  }

  .pe-xl-78 {
    padding-right: 38.5rem !important;
  }

  .pe-xl-79 {
    padding-right: 39rem !important;
  }

  .pe-xl-80 {
    padding-right: 39.5rem !important;
  }

  .pe-xl-81 {
    padding-right: 40rem !important;
  }

  .pe-xl-82 {
    padding-right: 40.5rem !important;
  }

  .pe-xl-83 {
    padding-right: 41rem !important;
  }

  .pe-xl-84 {
    padding-right: 41.5rem !important;
  }

  .pe-xl-85 {
    padding-right: 42rem !important;
  }

  .pe-xl-86 {
    padding-right: 42.5rem !important;
  }

  .pe-xl-87 {
    padding-right: 43rem !important;
  }

  .pe-xl-88 {
    padding-right: 43.5rem !important;
  }

  .pe-xl-89 {
    padding-right: 44rem !important;
  }

  .pe-xl-90 {
    padding-right: 44.5rem !important;
  }

  .pe-xl-91 {
    padding-right: 45rem !important;
  }

  .pe-xl-92 {
    padding-right: 45.5rem !important;
  }

  .pe-xl-93 {
    padding-right: 46rem !important;
  }

  .pe-xl-94 {
    padding-right: 46.5rem !important;
  }

  .pe-xl-95 {
    padding-right: 47rem !important;
  }

  .pe-xl-96 {
    padding-right: 47.5rem !important;
  }

  .pe-xl-97 {
    padding-right: 48rem !important;
  }

  .pe-xl-98 {
    padding-right: 48.5rem !important;
  }

  .pe-xl-99 {
    padding-right: 49rem !important;
  }

  .pe-xl-100 {
    padding-right: 49.5rem !important;
  }

  .pe-xl-101 {
    padding-right: 50rem !important;
  }

  .pe-xl-102 {
    padding-right: 50.5rem !important;
  }

  .pe-xl-103 {
    padding-right: 51rem !important;
  }

  .pe-xl-104 {
    padding-right: 51.5rem !important;
  }

  .pe-xl-105 {
    padding-right: 52rem !important;
  }

  .pe-xl-106 {
    padding-right: 52.5rem !important;
  }

  .pe-xl-107 {
    padding-right: 53rem !important;
  }

  .pe-xl-108 {
    padding-right: 53.5rem !important;
  }

  .pe-xl-109 {
    padding-right: 54rem !important;
  }

  .pe-xl-110 {
    padding-right: 54.5rem !important;
  }

  .pe-xl-111 {
    padding-right: 55rem !important;
  }

  .pe-xl-112 {
    padding-right: 55.5rem !important;
  }

  .pe-xl-113 {
    padding-right: 56rem !important;
  }

  .pe-xl-114 {
    padding-right: 56.5rem !important;
  }

  .pe-xl-115 {
    padding-right: 57rem !important;
  }

  .pe-xl-116 {
    padding-right: 57.5rem !important;
  }

  .pe-xl-117 {
    padding-right: 58rem !important;
  }

  .pe-xl-118 {
    padding-right: 58.5rem !important;
  }

  .pe-xl-119 {
    padding-right: 59rem !important;
  }

  .pe-xl-120 {
    padding-right: 59.5rem !important;
  }

  .pe-xl-121 {
    padding-right: 60rem !important;
  }

  .pe-xl-122 {
    padding-right: 60.5rem !important;
  }

  .pe-xl-123 {
    padding-right: 61rem !important;
  }

  .pe-xl-124 {
    padding-right: 61.5rem !important;
  }

  .pe-xl-125 {
    padding-right: 62rem !important;
  }

  .pe-xl-126 {
    padding-right: 62.5rem !important;
  }

  .pe-xl-127 {
    padding-right: 63rem !important;
  }

  .pe-xl-128 {
    padding-right: 63.5rem !important;
  }

  .pe-xl-129 {
    padding-right: 64rem !important;
  }

  .pe-xl-130 {
    padding-right: 64.5rem !important;
  }

  .pe-xl-131 {
    padding-right: 65rem !important;
  }

  .pe-xl-132 {
    padding-right: 65.5rem !important;
  }

  .pe-xl-133 {
    padding-right: 66rem !important;
  }

  .pe-xl-134 {
    padding-right: 66.5rem !important;
  }

  .pe-xl-135 {
    padding-right: 67rem !important;
  }

  .pe-xl-136 {
    padding-right: 67.5rem !important;
  }

  .pe-xl-137 {
    padding-right: 68rem !important;
  }

  .pe-xl-138 {
    padding-right: 68.5rem !important;
  }

  .pe-xl-139 {
    padding-right: 69rem !important;
  }

  .pe-xl-140 {
    padding-right: 69.5rem !important;
  }

  .pe-xl-141 {
    padding-right: 70rem !important;
  }

  .pe-xl-142 {
    padding-right: 70.5rem !important;
  }

  .pe-xl-143 {
    padding-right: 71rem !important;
  }

  .pe-xl-144 {
    padding-right: 71.5rem !important;
  }

  .pe-xl-145 {
    padding-right: 72rem !important;
  }

  .pe-xl-146 {
    padding-right: 72.5rem !important;
  }

  .pe-xl-147 {
    padding-right: 73rem !important;
  }

  .pe-xl-148 {
    padding-right: 73.5rem !important;
  }

  .pe-xl-149 {
    padding-right: 74rem !important;
  }

  .pe-xl-150 {
    padding-right: 74.5rem !important;
  }

  .pe-xl-151 {
    padding-right: 75rem !important;
  }

  .pe-xl-152 {
    padding-right: 75.5rem !important;
  }

  .pe-xl-153 {
    padding-right: 76rem !important;
  }

  .pe-xl-154 {
    padding-right: 76.5rem !important;
  }

  .pe-xl-155 {
    padding-right: 77rem !important;
  }

  .pe-xl-156 {
    padding-right: 77.5rem !important;
  }

  .pe-xl-157 {
    padding-right: 78rem !important;
  }

  .pe-xl-158 {
    padding-right: 78.5rem !important;
  }

  .pe-xl-159 {
    padding-right: 79rem !important;
  }

  .pe-xl-160 {
    padding-right: 79.5rem !important;
  }

  .px-xl-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }

  .px-xl-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  .px-xl-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .px-xl-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .px-xl-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .px-xl-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .px-xl-6 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .px-xl-7 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .px-xl-8 {
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important;
  }

  .px-xl-9 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  .px-xl-10 {
    padding-left: 4.5rem !important;
    padding-right: 4.5rem !important;
  }

  .px-xl-11 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  .px-xl-12 {
    padding-left: 5.5rem !important;
    padding-right: 5.5rem !important;
  }

  .px-xl-13 {
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  .px-xl-14 {
    padding-left: 6.5rem !important;
    padding-right: 6.5rem !important;
  }

  .px-xl-15 {
    padding-left: 7rem !important;
    padding-right: 7rem !important;
  }

  .px-xl-16 {
    padding-left: 7.5rem !important;
    padding-right: 7.5rem !important;
  }

  .px-xl-17 {
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  .px-xl-18 {
    padding-left: 8.5rem !important;
    padding-right: 8.5rem !important;
  }

  .px-xl-19 {
    padding-left: 9rem !important;
    padding-right: 9rem !important;
  }

  .px-xl-20 {
    padding-left: 9.5rem !important;
    padding-right: 9.5rem !important;
  }

  .px-xl-21 {
    padding-left: 10rem !important;
    padding-right: 10rem !important;
  }

  .px-xl-22 {
    padding-left: 10.5rem !important;
    padding-right: 10.5rem !important;
  }

  .px-xl-23 {
    padding-left: 11rem !important;
    padding-right: 11rem !important;
  }

  .px-xl-24 {
    padding-left: 11.5rem !important;
    padding-right: 11.5rem !important;
  }

  .px-xl-25 {
    padding-left: 12rem !important;
    padding-right: 12rem !important;
  }

  .px-xl-26 {
    padding-left: 12.5rem !important;
    padding-right: 12.5rem !important;
  }

  .px-xl-27 {
    padding-left: 13rem !important;
    padding-right: 13rem !important;
  }

  .px-xl-28 {
    padding-left: 13.5rem !important;
    padding-right: 13.5rem !important;
  }

  .px-xl-29 {
    padding-left: 14rem !important;
    padding-right: 14rem !important;
  }

  .px-xl-30 {
    padding-left: 14.5rem !important;
    padding-right: 14.5rem !important;
  }

  .px-xl-31 {
    padding-left: 15rem !important;
    padding-right: 15rem !important;
  }

  .px-xl-32 {
    padding-left: 15.5rem !important;
    padding-right: 15.5rem !important;
  }

  .px-xl-33 {
    padding-left: 16rem !important;
    padding-right: 16rem !important;
  }

  .px-xl-34 {
    padding-left: 16.5rem !important;
    padding-right: 16.5rem !important;
  }

  .px-xl-35 {
    padding-left: 17rem !important;
    padding-right: 17rem !important;
  }

  .px-xl-36 {
    padding-left: 17.5rem !important;
    padding-right: 17.5rem !important;
  }

  .px-xl-37 {
    padding-left: 18rem !important;
    padding-right: 18rem !important;
  }

  .px-xl-38 {
    padding-left: 18.5rem !important;
    padding-right: 18.5rem !important;
  }

  .px-xl-39 {
    padding-left: 19rem !important;
    padding-right: 19rem !important;
  }

  .px-xl-40 {
    padding-left: 19.5rem !important;
    padding-right: 19.5rem !important;
  }

  .px-xl-41 {
    padding-left: 20rem !important;
    padding-right: 20rem !important;
  }

  .px-xl-42 {
    padding-left: 20.5rem !important;
    padding-right: 20.5rem !important;
  }

  .px-xl-43 {
    padding-left: 21rem !important;
    padding-right: 21rem !important;
  }

  .px-xl-44 {
    padding-left: 21.5rem !important;
    padding-right: 21.5rem !important;
  }

  .px-xl-45 {
    padding-left: 22rem !important;
    padding-right: 22rem !important;
  }

  .px-xl-46 {
    padding-left: 22.5rem !important;
    padding-right: 22.5rem !important;
  }

  .px-xl-47 {
    padding-left: 23rem !important;
    padding-right: 23rem !important;
  }

  .px-xl-48 {
    padding-left: 23.5rem !important;
    padding-right: 23.5rem !important;
  }

  .px-xl-49 {
    padding-left: 24rem !important;
    padding-right: 24rem !important;
  }

  .px-xl-50 {
    padding-left: 24.5rem !important;
    padding-right: 24.5rem !important;
  }

  .px-xl-51 {
    padding-left: 25rem !important;
    padding-right: 25rem !important;
  }

  .px-xl-52 {
    padding-left: 25.5rem !important;
    padding-right: 25.5rem !important;
  }

  .px-xl-53 {
    padding-left: 26rem !important;
    padding-right: 26rem !important;
  }

  .px-xl-54 {
    padding-left: 26.5rem !important;
    padding-right: 26.5rem !important;
  }

  .px-xl-55 {
    padding-left: 27rem !important;
    padding-right: 27rem !important;
  }

  .px-xl-56 {
    padding-left: 27.5rem !important;
    padding-right: 27.5rem !important;
  }

  .px-xl-57 {
    padding-left: 28rem !important;
    padding-right: 28rem !important;
  }

  .px-xl-58 {
    padding-left: 28.5rem !important;
    padding-right: 28.5rem !important;
  }

  .px-xl-59 {
    padding-left: 29rem !important;
    padding-right: 29rem !important;
  }

  .px-xl-60 {
    padding-left: 29.5rem !important;
    padding-right: 29.5rem !important;
  }

  .px-xl-61 {
    padding-left: 30rem !important;
    padding-right: 30rem !important;
  }

  .px-xl-62 {
    padding-left: 30.5rem !important;
    padding-right: 30.5rem !important;
  }

  .px-xl-63 {
    padding-left: 31rem !important;
    padding-right: 31rem !important;
  }

  .px-xl-64 {
    padding-left: 31.5rem !important;
    padding-right: 31.5rem !important;
  }

  .px-xl-65 {
    padding-left: 32rem !important;
    padding-right: 32rem !important;
  }

  .px-xl-66 {
    padding-left: 32.5rem !important;
    padding-right: 32.5rem !important;
  }

  .px-xl-67 {
    padding-left: 33rem !important;
    padding-right: 33rem !important;
  }

  .px-xl-68 {
    padding-left: 33.5rem !important;
    padding-right: 33.5rem !important;
  }

  .px-xl-69 {
    padding-left: 34rem !important;
    padding-right: 34rem !important;
  }

  .px-xl-70 {
    padding-left: 34.5rem !important;
    padding-right: 34.5rem !important;
  }

  .px-xl-71 {
    padding-left: 35rem !important;
    padding-right: 35rem !important;
  }

  .px-xl-72 {
    padding-left: 35.5rem !important;
    padding-right: 35.5rem !important;
  }

  .px-xl-73 {
    padding-left: 36rem !important;
    padding-right: 36rem !important;
  }

  .px-xl-74 {
    padding-left: 36.5rem !important;
    padding-right: 36.5rem !important;
  }

  .px-xl-75 {
    padding-left: 37rem !important;
    padding-right: 37rem !important;
  }

  .px-xl-76 {
    padding-left: 37.5rem !important;
    padding-right: 37.5rem !important;
  }

  .px-xl-77 {
    padding-left: 38rem !important;
    padding-right: 38rem !important;
  }

  .px-xl-78 {
    padding-left: 38.5rem !important;
    padding-right: 38.5rem !important;
  }

  .px-xl-79 {
    padding-left: 39rem !important;
    padding-right: 39rem !important;
  }

  .px-xl-80 {
    padding-left: 39.5rem !important;
    padding-right: 39.5rem !important;
  }

  .px-xl-81 {
    padding-left: 40rem !important;
    padding-right: 40rem !important;
  }

  .px-xl-82 {
    padding-left: 40.5rem !important;
    padding-right: 40.5rem !important;
  }

  .px-xl-83 {
    padding-left: 41rem !important;
    padding-right: 41rem !important;
  }

  .px-xl-84 {
    padding-left: 41.5rem !important;
    padding-right: 41.5rem !important;
  }

  .px-xl-85 {
    padding-left: 42rem !important;
    padding-right: 42rem !important;
  }

  .px-xl-86 {
    padding-left: 42.5rem !important;
    padding-right: 42.5rem !important;
  }

  .px-xl-87 {
    padding-left: 43rem !important;
    padding-right: 43rem !important;
  }

  .px-xl-88 {
    padding-left: 43.5rem !important;
    padding-right: 43.5rem !important;
  }

  .px-xl-89 {
    padding-left: 44rem !important;
    padding-right: 44rem !important;
  }

  .px-xl-90 {
    padding-left: 44.5rem !important;
    padding-right: 44.5rem !important;
  }

  .px-xl-91 {
    padding-left: 45rem !important;
    padding-right: 45rem !important;
  }

  .px-xl-92 {
    padding-left: 45.5rem !important;
    padding-right: 45.5rem !important;
  }

  .px-xl-93 {
    padding-left: 46rem !important;
    padding-right: 46rem !important;
  }

  .px-xl-94 {
    padding-left: 46.5rem !important;
    padding-right: 46.5rem !important;
  }

  .px-xl-95 {
    padding-left: 47rem !important;
    padding-right: 47rem !important;
  }

  .px-xl-96 {
    padding-left: 47.5rem !important;
    padding-right: 47.5rem !important;
  }

  .px-xl-97 {
    padding-left: 48rem !important;
    padding-right: 48rem !important;
  }

  .px-xl-98 {
    padding-left: 48.5rem !important;
    padding-right: 48.5rem !important;
  }

  .px-xl-99 {
    padding-left: 49rem !important;
    padding-right: 49rem !important;
  }

  .px-xl-100 {
    padding-left: 49.5rem !important;
    padding-right: 49.5rem !important;
  }

  .px-xl-101 {
    padding-left: 50rem !important;
    padding-right: 50rem !important;
  }

  .px-xl-102 {
    padding-left: 50.5rem !important;
    padding-right: 50.5rem !important;
  }

  .px-xl-103 {
    padding-left: 51rem !important;
    padding-right: 51rem !important;
  }

  .px-xl-104 {
    padding-left: 51.5rem !important;
    padding-right: 51.5rem !important;
  }

  .px-xl-105 {
    padding-left: 52rem !important;
    padding-right: 52rem !important;
  }

  .px-xl-106 {
    padding-left: 52.5rem !important;
    padding-right: 52.5rem !important;
  }

  .px-xl-107 {
    padding-left: 53rem !important;
    padding-right: 53rem !important;
  }

  .px-xl-108 {
    padding-left: 53.5rem !important;
    padding-right: 53.5rem !important;
  }

  .px-xl-109 {
    padding-left: 54rem !important;
    padding-right: 54rem !important;
  }

  .px-xl-110 {
    padding-left: 54.5rem !important;
    padding-right: 54.5rem !important;
  }

  .px-xl-111 {
    padding-left: 55rem !important;
    padding-right: 55rem !important;
  }

  .px-xl-112 {
    padding-left: 55.5rem !important;
    padding-right: 55.5rem !important;
  }

  .px-xl-113 {
    padding-left: 56rem !important;
    padding-right: 56rem !important;
  }

  .px-xl-114 {
    padding-left: 56.5rem !important;
    padding-right: 56.5rem !important;
  }

  .px-xl-115 {
    padding-left: 57rem !important;
    padding-right: 57rem !important;
  }

  .px-xl-116 {
    padding-left: 57.5rem !important;
    padding-right: 57.5rem !important;
  }

  .px-xl-117 {
    padding-left: 58rem !important;
    padding-right: 58rem !important;
  }

  .px-xl-118 {
    padding-left: 58.5rem !important;
    padding-right: 58.5rem !important;
  }

  .px-xl-119 {
    padding-left: 59rem !important;
    padding-right: 59rem !important;
  }

  .px-xl-120 {
    padding-left: 59.5rem !important;
    padding-right: 59.5rem !important;
  }

  .px-xl-121 {
    padding-left: 60rem !important;
    padding-right: 60rem !important;
  }

  .px-xl-122 {
    padding-left: 60.5rem !important;
    padding-right: 60.5rem !important;
  }

  .px-xl-123 {
    padding-left: 61rem !important;
    padding-right: 61rem !important;
  }

  .px-xl-124 {
    padding-left: 61.5rem !important;
    padding-right: 61.5rem !important;
  }

  .px-xl-125 {
    padding-left: 62rem !important;
    padding-right: 62rem !important;
  }

  .px-xl-126 {
    padding-left: 62.5rem !important;
    padding-right: 62.5rem !important;
  }

  .px-xl-127 {
    padding-left: 63rem !important;
    padding-right: 63rem !important;
  }

  .px-xl-128 {
    padding-left: 63.5rem !important;
    padding-right: 63.5rem !important;
  }

  .px-xl-129 {
    padding-left: 64rem !important;
    padding-right: 64rem !important;
  }

  .px-xl-130 {
    padding-left: 64.5rem !important;
    padding-right: 64.5rem !important;
  }

  .px-xl-131 {
    padding-left: 65rem !important;
    padding-right: 65rem !important;
  }

  .px-xl-132 {
    padding-left: 65.5rem !important;
    padding-right: 65.5rem !important;
  }

  .px-xl-133 {
    padding-left: 66rem !important;
    padding-right: 66rem !important;
  }

  .px-xl-134 {
    padding-left: 66.5rem !important;
    padding-right: 66.5rem !important;
  }

  .px-xl-135 {
    padding-left: 67rem !important;
    padding-right: 67rem !important;
  }

  .px-xl-136 {
    padding-left: 67.5rem !important;
    padding-right: 67.5rem !important;
  }

  .px-xl-137 {
    padding-left: 68rem !important;
    padding-right: 68rem !important;
  }

  .px-xl-138 {
    padding-left: 68.5rem !important;
    padding-right: 68.5rem !important;
  }

  .px-xl-139 {
    padding-left: 69rem !important;
    padding-right: 69rem !important;
  }

  .px-xl-140 {
    padding-left: 69.5rem !important;
    padding-right: 69.5rem !important;
  }

  .px-xl-141 {
    padding-left: 70rem !important;
    padding-right: 70rem !important;
  }

  .px-xl-142 {
    padding-left: 70.5rem !important;
    padding-right: 70.5rem !important;
  }

  .px-xl-143 {
    padding-left: 71rem !important;
    padding-right: 71rem !important;
  }

  .px-xl-144 {
    padding-left: 71.5rem !important;
    padding-right: 71.5rem !important;
  }

  .px-xl-145 {
    padding-left: 72rem !important;
    padding-right: 72rem !important;
  }

  .px-xl-146 {
    padding-left: 72.5rem !important;
    padding-right: 72.5rem !important;
  }

  .px-xl-147 {
    padding-left: 73rem !important;
    padding-right: 73rem !important;
  }

  .px-xl-148 {
    padding-left: 73.5rem !important;
    padding-right: 73.5rem !important;
  }

  .px-xl-149 {
    padding-left: 74rem !important;
    padding-right: 74rem !important;
  }

  .px-xl-150 {
    padding-left: 74.5rem !important;
    padding-right: 74.5rem !important;
  }

  .px-xl-151 {
    padding-left: 75rem !important;
    padding-right: 75rem !important;
  }

  .px-xl-152 {
    padding-left: 75.5rem !important;
    padding-right: 75.5rem !important;
  }

  .px-xl-153 {
    padding-left: 76rem !important;
    padding-right: 76rem !important;
  }

  .px-xl-154 {
    padding-left: 76.5rem !important;
    padding-right: 76.5rem !important;
  }

  .px-xl-155 {
    padding-left: 77rem !important;
    padding-right: 77rem !important;
  }

  .px-xl-156 {
    padding-left: 77.5rem !important;
    padding-right: 77.5rem !important;
  }

  .px-xl-157 {
    padding-left: 78rem !important;
    padding-right: 78rem !important;
  }

  .px-xl-158 {
    padding-left: 78.5rem !important;
    padding-right: 78.5rem !important;
  }

  .px-xl-159 {
    padding-left: 79rem !important;
    padding-right: 79rem !important;
  }

  .px-xl-160 {
    padding-left: 79.5rem !important;
    padding-right: 79.5rem !important;
  }

  .py-xl-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xl-6 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xl-7 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xl-8 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xl-9 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xl-10 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xl-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .py-xl-12 {
    padding-top: 5.5rem !important;
    padding-bottom: 5.5rem !important;
  }

  .py-xl-13 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  .py-xl-14 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }

  .py-xl-15 {
    padding-top: 7rem !important;
    padding-bottom: 7rem !important;
  }

  .py-xl-16 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }

  .py-xl-17 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  .py-xl-18 {
    padding-top: 8.5rem !important;
    padding-bottom: 8.5rem !important;
  }

  .py-xl-19 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }

  .py-xl-20 {
    padding-top: 9.5rem !important;
    padding-bottom: 9.5rem !important;
  }

  .py-xl-21 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }

  .py-xl-22 {
    padding-top: 10.5rem !important;
    padding-bottom: 10.5rem !important;
  }

  .py-xl-23 {
    padding-top: 11rem !important;
    padding-bottom: 11rem !important;
  }

  .py-xl-24 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }

  .py-xl-25 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }

  .py-xl-26 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }

  .py-xl-27 {
    padding-top: 13rem !important;
    padding-bottom: 13rem !important;
  }

  .py-xl-28 {
    padding-top: 13.5rem !important;
    padding-bottom: 13.5rem !important;
  }

  .py-xl-29 {
    padding-top: 14rem !important;
    padding-bottom: 14rem !important;
  }

  .py-xl-30 {
    padding-top: 14.5rem !important;
    padding-bottom: 14.5rem !important;
  }

  .py-xl-31 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }

  .py-xl-32 {
    padding-top: 15.5rem !important;
    padding-bottom: 15.5rem !important;
  }

  .py-xl-33 {
    padding-top: 16rem !important;
    padding-bottom: 16rem !important;
  }

  .py-xl-34 {
    padding-top: 16.5rem !important;
    padding-bottom: 16.5rem !important;
  }

  .py-xl-35 {
    padding-top: 17rem !important;
    padding-bottom: 17rem !important;
  }

  .py-xl-36 {
    padding-top: 17.5rem !important;
    padding-bottom: 17.5rem !important;
  }

  .py-xl-37 {
    padding-top: 18rem !important;
    padding-bottom: 18rem !important;
  }

  .py-xl-38 {
    padding-top: 18.5rem !important;
    padding-bottom: 18.5rem !important;
  }

  .py-xl-39 {
    padding-top: 19rem !important;
    padding-bottom: 19rem !important;
  }

  .py-xl-40 {
    padding-top: 19.5rem !important;
    padding-bottom: 19.5rem !important;
  }

  .py-xl-41 {
    padding-top: 20rem !important;
    padding-bottom: 20rem !important;
  }

  .py-xl-42 {
    padding-top: 20.5rem !important;
    padding-bottom: 20.5rem !important;
  }

  .py-xl-43 {
    padding-top: 21rem !important;
    padding-bottom: 21rem !important;
  }

  .py-xl-44 {
    padding-top: 21.5rem !important;
    padding-bottom: 21.5rem !important;
  }

  .py-xl-45 {
    padding-top: 22rem !important;
    padding-bottom: 22rem !important;
  }

  .py-xl-46 {
    padding-top: 22.5rem !important;
    padding-bottom: 22.5rem !important;
  }

  .py-xl-47 {
    padding-top: 23rem !important;
    padding-bottom: 23rem !important;
  }

  .py-xl-48 {
    padding-top: 23.5rem !important;
    padding-bottom: 23.5rem !important;
  }

  .py-xl-49 {
    padding-top: 24rem !important;
    padding-bottom: 24rem !important;
  }

  .py-xl-50 {
    padding-top: 24.5rem !important;
    padding-bottom: 24.5rem !important;
  }

  .py-xl-51 {
    padding-top: 25rem !important;
    padding-bottom: 25rem !important;
  }

  .py-xl-52 {
    padding-top: 25.5rem !important;
    padding-bottom: 25.5rem !important;
  }

  .py-xl-53 {
    padding-top: 26rem !important;
    padding-bottom: 26rem !important;
  }

  .py-xl-54 {
    padding-top: 26.5rem !important;
    padding-bottom: 26.5rem !important;
  }

  .py-xl-55 {
    padding-top: 27rem !important;
    padding-bottom: 27rem !important;
  }

  .py-xl-56 {
    padding-top: 27.5rem !important;
    padding-bottom: 27.5rem !important;
  }

  .py-xl-57 {
    padding-top: 28rem !important;
    padding-bottom: 28rem !important;
  }

  .py-xl-58 {
    padding-top: 28.5rem !important;
    padding-bottom: 28.5rem !important;
  }

  .py-xl-59 {
    padding-top: 29rem !important;
    padding-bottom: 29rem !important;
  }

  .py-xl-60 {
    padding-top: 29.5rem !important;
    padding-bottom: 29.5rem !important;
  }

  .py-xl-61 {
    padding-top: 30rem !important;
    padding-bottom: 30rem !important;
  }

  .py-xl-62 {
    padding-top: 30.5rem !important;
    padding-bottom: 30.5rem !important;
  }

  .py-xl-63 {
    padding-top: 31rem !important;
    padding-bottom: 31rem !important;
  }

  .py-xl-64 {
    padding-top: 31.5rem !important;
    padding-bottom: 31.5rem !important;
  }

  .py-xl-65 {
    padding-top: 32rem !important;
    padding-bottom: 32rem !important;
  }

  .py-xl-66 {
    padding-top: 32.5rem !important;
    padding-bottom: 32.5rem !important;
  }

  .py-xl-67 {
    padding-top: 33rem !important;
    padding-bottom: 33rem !important;
  }

  .py-xl-68 {
    padding-top: 33.5rem !important;
    padding-bottom: 33.5rem !important;
  }

  .py-xl-69 {
    padding-top: 34rem !important;
    padding-bottom: 34rem !important;
  }

  .py-xl-70 {
    padding-top: 34.5rem !important;
    padding-bottom: 34.5rem !important;
  }

  .py-xl-71 {
    padding-top: 35rem !important;
    padding-bottom: 35rem !important;
  }

  .py-xl-72 {
    padding-top: 35.5rem !important;
    padding-bottom: 35.5rem !important;
  }

  .py-xl-73 {
    padding-top: 36rem !important;
    padding-bottom: 36rem !important;
  }

  .py-xl-74 {
    padding-top: 36.5rem !important;
    padding-bottom: 36.5rem !important;
  }

  .py-xl-75 {
    padding-top: 37rem !important;
    padding-bottom: 37rem !important;
  }

  .py-xl-76 {
    padding-top: 37.5rem !important;
    padding-bottom: 37.5rem !important;
  }

  .py-xl-77 {
    padding-top: 38rem !important;
    padding-bottom: 38rem !important;
  }

  .py-xl-78 {
    padding-top: 38.5rem !important;
    padding-bottom: 38.5rem !important;
  }

  .py-xl-79 {
    padding-top: 39rem !important;
    padding-bottom: 39rem !important;
  }

  .py-xl-80 {
    padding-top: 39.5rem !important;
    padding-bottom: 39.5rem !important;
  }

  .py-xl-81 {
    padding-top: 40rem !important;
    padding-bottom: 40rem !important;
  }

  .py-xl-82 {
    padding-top: 40.5rem !important;
    padding-bottom: 40.5rem !important;
  }

  .py-xl-83 {
    padding-top: 41rem !important;
    padding-bottom: 41rem !important;
  }

  .py-xl-84 {
    padding-top: 41.5rem !important;
    padding-bottom: 41.5rem !important;
  }

  .py-xl-85 {
    padding-top: 42rem !important;
    padding-bottom: 42rem !important;
  }

  .py-xl-86 {
    padding-top: 42.5rem !important;
    padding-bottom: 42.5rem !important;
  }

  .py-xl-87 {
    padding-top: 43rem !important;
    padding-bottom: 43rem !important;
  }

  .py-xl-88 {
    padding-top: 43.5rem !important;
    padding-bottom: 43.5rem !important;
  }

  .py-xl-89 {
    padding-top: 44rem !important;
    padding-bottom: 44rem !important;
  }

  .py-xl-90 {
    padding-top: 44.5rem !important;
    padding-bottom: 44.5rem !important;
  }

  .py-xl-91 {
    padding-top: 45rem !important;
    padding-bottom: 45rem !important;
  }

  .py-xl-92 {
    padding-top: 45.5rem !important;
    padding-bottom: 45.5rem !important;
  }

  .py-xl-93 {
    padding-top: 46rem !important;
    padding-bottom: 46rem !important;
  }

  .py-xl-94 {
    padding-top: 46.5rem !important;
    padding-bottom: 46.5rem !important;
  }

  .py-xl-95 {
    padding-top: 47rem !important;
    padding-bottom: 47rem !important;
  }

  .py-xl-96 {
    padding-top: 47.5rem !important;
    padding-bottom: 47.5rem !important;
  }

  .py-xl-97 {
    padding-top: 48rem !important;
    padding-bottom: 48rem !important;
  }

  .py-xl-98 {
    padding-top: 48.5rem !important;
    padding-bottom: 48.5rem !important;
  }

  .py-xl-99 {
    padding-top: 49rem !important;
    padding-bottom: 49rem !important;
  }

  .py-xl-100 {
    padding-top: 49.5rem !important;
    padding-bottom: 49.5rem !important;
  }

  .py-xl-101 {
    padding-top: 50rem !important;
    padding-bottom: 50rem !important;
  }

  .py-xl-102 {
    padding-top: 50.5rem !important;
    padding-bottom: 50.5rem !important;
  }

  .py-xl-103 {
    padding-top: 51rem !important;
    padding-bottom: 51rem !important;
  }

  .py-xl-104 {
    padding-top: 51.5rem !important;
    padding-bottom: 51.5rem !important;
  }

  .py-xl-105 {
    padding-top: 52rem !important;
    padding-bottom: 52rem !important;
  }

  .py-xl-106 {
    padding-top: 52.5rem !important;
    padding-bottom: 52.5rem !important;
  }

  .py-xl-107 {
    padding-top: 53rem !important;
    padding-bottom: 53rem !important;
  }

  .py-xl-108 {
    padding-top: 53.5rem !important;
    padding-bottom: 53.5rem !important;
  }

  .py-xl-109 {
    padding-top: 54rem !important;
    padding-bottom: 54rem !important;
  }

  .py-xl-110 {
    padding-top: 54.5rem !important;
    padding-bottom: 54.5rem !important;
  }

  .py-xl-111 {
    padding-top: 55rem !important;
    padding-bottom: 55rem !important;
  }

  .py-xl-112 {
    padding-top: 55.5rem !important;
    padding-bottom: 55.5rem !important;
  }

  .py-xl-113 {
    padding-top: 56rem !important;
    padding-bottom: 56rem !important;
  }

  .py-xl-114 {
    padding-top: 56.5rem !important;
    padding-bottom: 56.5rem !important;
  }

  .py-xl-115 {
    padding-top: 57rem !important;
    padding-bottom: 57rem !important;
  }

  .py-xl-116 {
    padding-top: 57.5rem !important;
    padding-bottom: 57.5rem !important;
  }

  .py-xl-117 {
    padding-top: 58rem !important;
    padding-bottom: 58rem !important;
  }

  .py-xl-118 {
    padding-top: 58.5rem !important;
    padding-bottom: 58.5rem !important;
  }

  .py-xl-119 {
    padding-top: 59rem !important;
    padding-bottom: 59rem !important;
  }

  .py-xl-120 {
    padding-top: 59.5rem !important;
    padding-bottom: 59.5rem !important;
  }

  .py-xl-121 {
    padding-top: 60rem !important;
    padding-bottom: 60rem !important;
  }

  .py-xl-122 {
    padding-top: 60.5rem !important;
    padding-bottom: 60.5rem !important;
  }

  .py-xl-123 {
    padding-top: 61rem !important;
    padding-bottom: 61rem !important;
  }

  .py-xl-124 {
    padding-top: 61.5rem !important;
    padding-bottom: 61.5rem !important;
  }

  .py-xl-125 {
    padding-top: 62rem !important;
    padding-bottom: 62rem !important;
  }

  .py-xl-126 {
    padding-top: 62.5rem !important;
    padding-bottom: 62.5rem !important;
  }

  .py-xl-127 {
    padding-top: 63rem !important;
    padding-bottom: 63rem !important;
  }

  .py-xl-128 {
    padding-top: 63.5rem !important;
    padding-bottom: 63.5rem !important;
  }

  .py-xl-129 {
    padding-top: 64rem !important;
    padding-bottom: 64rem !important;
  }

  .py-xl-130 {
    padding-top: 64.5rem !important;
    padding-bottom: 64.5rem !important;
  }

  .py-xl-131 {
    padding-top: 65rem !important;
    padding-bottom: 65rem !important;
  }

  .py-xl-132 {
    padding-top: 65.5rem !important;
    padding-bottom: 65.5rem !important;
  }

  .py-xl-133 {
    padding-top: 66rem !important;
    padding-bottom: 66rem !important;
  }

  .py-xl-134 {
    padding-top: 66.5rem !important;
    padding-bottom: 66.5rem !important;
  }

  .py-xl-135 {
    padding-top: 67rem !important;
    padding-bottom: 67rem !important;
  }

  .py-xl-136 {
    padding-top: 67.5rem !important;
    padding-bottom: 67.5rem !important;
  }

  .py-xl-137 {
    padding-top: 68rem !important;
    padding-bottom: 68rem !important;
  }

  .py-xl-138 {
    padding-top: 68.5rem !important;
    padding-bottom: 68.5rem !important;
  }

  .py-xl-139 {
    padding-top: 69rem !important;
    padding-bottom: 69rem !important;
  }

  .py-xl-140 {
    padding-top: 69.5rem !important;
    padding-bottom: 69.5rem !important;
  }

  .py-xl-141 {
    padding-top: 70rem !important;
    padding-bottom: 70rem !important;
  }

  .py-xl-142 {
    padding-top: 70.5rem !important;
    padding-bottom: 70.5rem !important;
  }

  .py-xl-143 {
    padding-top: 71rem !important;
    padding-bottom: 71rem !important;
  }

  .py-xl-144 {
    padding-top: 71.5rem !important;
    padding-bottom: 71.5rem !important;
  }

  .py-xl-145 {
    padding-top: 72rem !important;
    padding-bottom: 72rem !important;
  }

  .py-xl-146 {
    padding-top: 72.5rem !important;
    padding-bottom: 72.5rem !important;
  }

  .py-xl-147 {
    padding-top: 73rem !important;
    padding-bottom: 73rem !important;
  }

  .py-xl-148 {
    padding-top: 73.5rem !important;
    padding-bottom: 73.5rem !important;
  }

  .py-xl-149 {
    padding-top: 74rem !important;
    padding-bottom: 74rem !important;
  }

  .py-xl-150 {
    padding-top: 74.5rem !important;
    padding-bottom: 74.5rem !important;
  }

  .py-xl-151 {
    padding-top: 75rem !important;
    padding-bottom: 75rem !important;
  }

  .py-xl-152 {
    padding-top: 75.5rem !important;
    padding-bottom: 75.5rem !important;
  }

  .py-xl-153 {
    padding-top: 76rem !important;
    padding-bottom: 76rem !important;
  }

  .py-xl-154 {
    padding-top: 76.5rem !important;
    padding-bottom: 76.5rem !important;
  }

  .py-xl-155 {
    padding-top: 77rem !important;
    padding-bottom: 77rem !important;
  }

  .py-xl-156 {
    padding-top: 77.5rem !important;
    padding-bottom: 77.5rem !important;
  }

  .py-xl-157 {
    padding-top: 78rem !important;
    padding-bottom: 78rem !important;
  }

  .py-xl-158 {
    padding-top: 78.5rem !important;
    padding-bottom: 78.5rem !important;
  }

  .py-xl-159 {
    padding-top: 79rem !important;
    padding-bottom: 79rem !important;
  }

  .py-xl-160 {
    padding-top: 79.5rem !important;
    padding-bottom: 79.5rem !important;
  }
}
@media (min-width: 1400px) {
  .p-xxl-0 {
    padding: 0rem !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 1rem !important;
  }

  .p-xxl-4 {
    padding: 1.5rem !important;
  }

  .p-xxl-5 {
    padding: 2rem !important;
  }

  .p-xxl-6 {
    padding: 2.5rem !important;
  }

  .p-xxl-7 {
    padding: 3rem !important;
  }

  .p-xxl-8 {
    padding: 3.5rem !important;
  }

  .p-xxl-9 {
    padding: 4rem !important;
  }

  .p-xxl-10 {
    padding: 4.5rem !important;
  }

  .p-xxl-11 {
    padding: 5rem !important;
  }

  .p-xxl-12 {
    padding: 5.5rem !important;
  }

  .p-xxl-13 {
    padding: 6rem !important;
  }

  .p-xxl-14 {
    padding: 6.5rem !important;
  }

  .p-xxl-15 {
    padding: 7rem !important;
  }

  .p-xxl-16 {
    padding: 7.5rem !important;
  }

  .p-xxl-17 {
    padding: 8rem !important;
  }

  .p-xxl-18 {
    padding: 8.5rem !important;
  }

  .p-xxl-19 {
    padding: 9rem !important;
  }

  .p-xxl-20 {
    padding: 9.5rem !important;
  }

  .p-xxl-21 {
    padding: 10rem !important;
  }

  .p-xxl-22 {
    padding: 10.5rem !important;
  }

  .p-xxl-23 {
    padding: 11rem !important;
  }

  .p-xxl-24 {
    padding: 11.5rem !important;
  }

  .p-xxl-25 {
    padding: 12rem !important;
  }

  .p-xxl-26 {
    padding: 12.5rem !important;
  }

  .p-xxl-27 {
    padding: 13rem !important;
  }

  .p-xxl-28 {
    padding: 13.5rem !important;
  }

  .p-xxl-29 {
    padding: 14rem !important;
  }

  .p-xxl-30 {
    padding: 14.5rem !important;
  }

  .p-xxl-31 {
    padding: 15rem !important;
  }

  .p-xxl-32 {
    padding: 15.5rem !important;
  }

  .p-xxl-33 {
    padding: 16rem !important;
  }

  .p-xxl-34 {
    padding: 16.5rem !important;
  }

  .p-xxl-35 {
    padding: 17rem !important;
  }

  .p-xxl-36 {
    padding: 17.5rem !important;
  }

  .p-xxl-37 {
    padding: 18rem !important;
  }

  .p-xxl-38 {
    padding: 18.5rem !important;
  }

  .p-xxl-39 {
    padding: 19rem !important;
  }

  .p-xxl-40 {
    padding: 19.5rem !important;
  }

  .p-xxl-41 {
    padding: 20rem !important;
  }

  .p-xxl-42 {
    padding: 20.5rem !important;
  }

  .p-xxl-43 {
    padding: 21rem !important;
  }

  .p-xxl-44 {
    padding: 21.5rem !important;
  }

  .p-xxl-45 {
    padding: 22rem !important;
  }

  .p-xxl-46 {
    padding: 22.5rem !important;
  }

  .p-xxl-47 {
    padding: 23rem !important;
  }

  .p-xxl-48 {
    padding: 23.5rem !important;
  }

  .p-xxl-49 {
    padding: 24rem !important;
  }

  .p-xxl-50 {
    padding: 24.5rem !important;
  }

  .p-xxl-51 {
    padding: 25rem !important;
  }

  .p-xxl-52 {
    padding: 25.5rem !important;
  }

  .p-xxl-53 {
    padding: 26rem !important;
  }

  .p-xxl-54 {
    padding: 26.5rem !important;
  }

  .p-xxl-55 {
    padding: 27rem !important;
  }

  .p-xxl-56 {
    padding: 27.5rem !important;
  }

  .p-xxl-57 {
    padding: 28rem !important;
  }

  .p-xxl-58 {
    padding: 28.5rem !important;
  }

  .p-xxl-59 {
    padding: 29rem !important;
  }

  .p-xxl-60 {
    padding: 29.5rem !important;
  }

  .p-xxl-61 {
    padding: 30rem !important;
  }

  .p-xxl-62 {
    padding: 30.5rem !important;
  }

  .p-xxl-63 {
    padding: 31rem !important;
  }

  .p-xxl-64 {
    padding: 31.5rem !important;
  }

  .p-xxl-65 {
    padding: 32rem !important;
  }

  .p-xxl-66 {
    padding: 32.5rem !important;
  }

  .p-xxl-67 {
    padding: 33rem !important;
  }

  .p-xxl-68 {
    padding: 33.5rem !important;
  }

  .p-xxl-69 {
    padding: 34rem !important;
  }

  .p-xxl-70 {
    padding: 34.5rem !important;
  }

  .p-xxl-71 {
    padding: 35rem !important;
  }

  .p-xxl-72 {
    padding: 35.5rem !important;
  }

  .p-xxl-73 {
    padding: 36rem !important;
  }

  .p-xxl-74 {
    padding: 36.5rem !important;
  }

  .p-xxl-75 {
    padding: 37rem !important;
  }

  .p-xxl-76 {
    padding: 37.5rem !important;
  }

  .p-xxl-77 {
    padding: 38rem !important;
  }

  .p-xxl-78 {
    padding: 38.5rem !important;
  }

  .p-xxl-79 {
    padding: 39rem !important;
  }

  .p-xxl-80 {
    padding: 39.5rem !important;
  }

  .p-xxl-81 {
    padding: 40rem !important;
  }

  .p-xxl-82 {
    padding: 40.5rem !important;
  }

  .p-xxl-83 {
    padding: 41rem !important;
  }

  .p-xxl-84 {
    padding: 41.5rem !important;
  }

  .p-xxl-85 {
    padding: 42rem !important;
  }

  .p-xxl-86 {
    padding: 42.5rem !important;
  }

  .p-xxl-87 {
    padding: 43rem !important;
  }

  .p-xxl-88 {
    padding: 43.5rem !important;
  }

  .p-xxl-89 {
    padding: 44rem !important;
  }

  .p-xxl-90 {
    padding: 44.5rem !important;
  }

  .p-xxl-91 {
    padding: 45rem !important;
  }

  .p-xxl-92 {
    padding: 45.5rem !important;
  }

  .p-xxl-93 {
    padding: 46rem !important;
  }

  .p-xxl-94 {
    padding: 46.5rem !important;
  }

  .p-xxl-95 {
    padding: 47rem !important;
  }

  .p-xxl-96 {
    padding: 47.5rem !important;
  }

  .p-xxl-97 {
    padding: 48rem !important;
  }

  .p-xxl-98 {
    padding: 48.5rem !important;
  }

  .p-xxl-99 {
    padding: 49rem !important;
  }

  .p-xxl-100 {
    padding: 49.5rem !important;
  }

  .p-xxl-101 {
    padding: 50rem !important;
  }

  .p-xxl-102 {
    padding: 50.5rem !important;
  }

  .p-xxl-103 {
    padding: 51rem !important;
  }

  .p-xxl-104 {
    padding: 51.5rem !important;
  }

  .p-xxl-105 {
    padding: 52rem !important;
  }

  .p-xxl-106 {
    padding: 52.5rem !important;
  }

  .p-xxl-107 {
    padding: 53rem !important;
  }

  .p-xxl-108 {
    padding: 53.5rem !important;
  }

  .p-xxl-109 {
    padding: 54rem !important;
  }

  .p-xxl-110 {
    padding: 54.5rem !important;
  }

  .p-xxl-111 {
    padding: 55rem !important;
  }

  .p-xxl-112 {
    padding: 55.5rem !important;
  }

  .p-xxl-113 {
    padding: 56rem !important;
  }

  .p-xxl-114 {
    padding: 56.5rem !important;
  }

  .p-xxl-115 {
    padding: 57rem !important;
  }

  .p-xxl-116 {
    padding: 57.5rem !important;
  }

  .p-xxl-117 {
    padding: 58rem !important;
  }

  .p-xxl-118 {
    padding: 58.5rem !important;
  }

  .p-xxl-119 {
    padding: 59rem !important;
  }

  .p-xxl-120 {
    padding: 59.5rem !important;
  }

  .p-xxl-121 {
    padding: 60rem !important;
  }

  .p-xxl-122 {
    padding: 60.5rem !important;
  }

  .p-xxl-123 {
    padding: 61rem !important;
  }

  .p-xxl-124 {
    padding: 61.5rem !important;
  }

  .p-xxl-125 {
    padding: 62rem !important;
  }

  .p-xxl-126 {
    padding: 62.5rem !important;
  }

  .p-xxl-127 {
    padding: 63rem !important;
  }

  .p-xxl-128 {
    padding: 63.5rem !important;
  }

  .p-xxl-129 {
    padding: 64rem !important;
  }

  .p-xxl-130 {
    padding: 64.5rem !important;
  }

  .p-xxl-131 {
    padding: 65rem !important;
  }

  .p-xxl-132 {
    padding: 65.5rem !important;
  }

  .p-xxl-133 {
    padding: 66rem !important;
  }

  .p-xxl-134 {
    padding: 66.5rem !important;
  }

  .p-xxl-135 {
    padding: 67rem !important;
  }

  .p-xxl-136 {
    padding: 67.5rem !important;
  }

  .p-xxl-137 {
    padding: 68rem !important;
  }

  .p-xxl-138 {
    padding: 68.5rem !important;
  }

  .p-xxl-139 {
    padding: 69rem !important;
  }

  .p-xxl-140 {
    padding: 69.5rem !important;
  }

  .p-xxl-141 {
    padding: 70rem !important;
  }

  .p-xxl-142 {
    padding: 70.5rem !important;
  }

  .p-xxl-143 {
    padding: 71rem !important;
  }

  .p-xxl-144 {
    padding: 71.5rem !important;
  }

  .p-xxl-145 {
    padding: 72rem !important;
  }

  .p-xxl-146 {
    padding: 72.5rem !important;
  }

  .p-xxl-147 {
    padding: 73rem !important;
  }

  .p-xxl-148 {
    padding: 73.5rem !important;
  }

  .p-xxl-149 {
    padding: 74rem !important;
  }

  .p-xxl-150 {
    padding: 74.5rem !important;
  }

  .p-xxl-151 {
    padding: 75rem !important;
  }

  .p-xxl-152 {
    padding: 75.5rem !important;
  }

  .p-xxl-153 {
    padding: 76rem !important;
  }

  .p-xxl-154 {
    padding: 76.5rem !important;
  }

  .p-xxl-155 {
    padding: 77rem !important;
  }

  .p-xxl-156 {
    padding: 77.5rem !important;
  }

  .p-xxl-157 {
    padding: 78rem !important;
  }

  .p-xxl-158 {
    padding: 78.5rem !important;
  }

  .p-xxl-159 {
    padding: 79rem !important;
  }

  .p-xxl-160 {
    padding: 79.5rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0rem !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 1rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-5 {
    padding-top: 2rem !important;
  }

  .pt-xxl-6 {
    padding-top: 2.5rem !important;
  }

  .pt-xxl-7 {
    padding-top: 3rem !important;
  }

  .pt-xxl-8 {
    padding-top: 3.5rem !important;
  }

  .pt-xxl-9 {
    padding-top: 4rem !important;
  }

  .pt-xxl-10 {
    padding-top: 4.5rem !important;
  }

  .pt-xxl-11 {
    padding-top: 5rem !important;
  }

  .pt-xxl-12 {
    padding-top: 5.5rem !important;
  }

  .pt-xxl-13 {
    padding-top: 6rem !important;
  }

  .pt-xxl-14 {
    padding-top: 6.5rem !important;
  }

  .pt-xxl-15 {
    padding-top: 7rem !important;
  }

  .pt-xxl-16 {
    padding-top: 7.5rem !important;
  }

  .pt-xxl-17 {
    padding-top: 8rem !important;
  }

  .pt-xxl-18 {
    padding-top: 8.5rem !important;
  }

  .pt-xxl-19 {
    padding-top: 9rem !important;
  }

  .pt-xxl-20 {
    padding-top: 9.5rem !important;
  }

  .pt-xxl-21 {
    padding-top: 10rem !important;
  }

  .pt-xxl-22 {
    padding-top: 10.5rem !important;
  }

  .pt-xxl-23 {
    padding-top: 11rem !important;
  }

  .pt-xxl-24 {
    padding-top: 11.5rem !important;
  }

  .pt-xxl-25 {
    padding-top: 12rem !important;
  }

  .pt-xxl-26 {
    padding-top: 12.5rem !important;
  }

  .pt-xxl-27 {
    padding-top: 13rem !important;
  }

  .pt-xxl-28 {
    padding-top: 13.5rem !important;
  }

  .pt-xxl-29 {
    padding-top: 14rem !important;
  }

  .pt-xxl-30 {
    padding-top: 14.5rem !important;
  }

  .pt-xxl-31 {
    padding-top: 15rem !important;
  }

  .pt-xxl-32 {
    padding-top: 15.5rem !important;
  }

  .pt-xxl-33 {
    padding-top: 16rem !important;
  }

  .pt-xxl-34 {
    padding-top: 16.5rem !important;
  }

  .pt-xxl-35 {
    padding-top: 17rem !important;
  }

  .pt-xxl-36 {
    padding-top: 17.5rem !important;
  }

  .pt-xxl-37 {
    padding-top: 18rem !important;
  }

  .pt-xxl-38 {
    padding-top: 18.5rem !important;
  }

  .pt-xxl-39 {
    padding-top: 19rem !important;
  }

  .pt-xxl-40 {
    padding-top: 19.5rem !important;
  }

  .pt-xxl-41 {
    padding-top: 20rem !important;
  }

  .pt-xxl-42 {
    padding-top: 20.5rem !important;
  }

  .pt-xxl-43 {
    padding-top: 21rem !important;
  }

  .pt-xxl-44 {
    padding-top: 21.5rem !important;
  }

  .pt-xxl-45 {
    padding-top: 22rem !important;
  }

  .pt-xxl-46 {
    padding-top: 22.5rem !important;
  }

  .pt-xxl-47 {
    padding-top: 23rem !important;
  }

  .pt-xxl-48 {
    padding-top: 23.5rem !important;
  }

  .pt-xxl-49 {
    padding-top: 24rem !important;
  }

  .pt-xxl-50 {
    padding-top: 24.5rem !important;
  }

  .pt-xxl-51 {
    padding-top: 25rem !important;
  }

  .pt-xxl-52 {
    padding-top: 25.5rem !important;
  }

  .pt-xxl-53 {
    padding-top: 26rem !important;
  }

  .pt-xxl-54 {
    padding-top: 26.5rem !important;
  }

  .pt-xxl-55 {
    padding-top: 27rem !important;
  }

  .pt-xxl-56 {
    padding-top: 27.5rem !important;
  }

  .pt-xxl-57 {
    padding-top: 28rem !important;
  }

  .pt-xxl-58 {
    padding-top: 28.5rem !important;
  }

  .pt-xxl-59 {
    padding-top: 29rem !important;
  }

  .pt-xxl-60 {
    padding-top: 29.5rem !important;
  }

  .pt-xxl-61 {
    padding-top: 30rem !important;
  }

  .pt-xxl-62 {
    padding-top: 30.5rem !important;
  }

  .pt-xxl-63 {
    padding-top: 31rem !important;
  }

  .pt-xxl-64 {
    padding-top: 31.5rem !important;
  }

  .pt-xxl-65 {
    padding-top: 32rem !important;
  }

  .pt-xxl-66 {
    padding-top: 32.5rem !important;
  }

  .pt-xxl-67 {
    padding-top: 33rem !important;
  }

  .pt-xxl-68 {
    padding-top: 33.5rem !important;
  }

  .pt-xxl-69 {
    padding-top: 34rem !important;
  }

  .pt-xxl-70 {
    padding-top: 34.5rem !important;
  }

  .pt-xxl-71 {
    padding-top: 35rem !important;
  }

  .pt-xxl-72 {
    padding-top: 35.5rem !important;
  }

  .pt-xxl-73 {
    padding-top: 36rem !important;
  }

  .pt-xxl-74 {
    padding-top: 36.5rem !important;
  }

  .pt-xxl-75 {
    padding-top: 37rem !important;
  }

  .pt-xxl-76 {
    padding-top: 37.5rem !important;
  }

  .pt-xxl-77 {
    padding-top: 38rem !important;
  }

  .pt-xxl-78 {
    padding-top: 38.5rem !important;
  }

  .pt-xxl-79 {
    padding-top: 39rem !important;
  }

  .pt-xxl-80 {
    padding-top: 39.5rem !important;
  }

  .pt-xxl-81 {
    padding-top: 40rem !important;
  }

  .pt-xxl-82 {
    padding-top: 40.5rem !important;
  }

  .pt-xxl-83 {
    padding-top: 41rem !important;
  }

  .pt-xxl-84 {
    padding-top: 41.5rem !important;
  }

  .pt-xxl-85 {
    padding-top: 42rem !important;
  }

  .pt-xxl-86 {
    padding-top: 42.5rem !important;
  }

  .pt-xxl-87 {
    padding-top: 43rem !important;
  }

  .pt-xxl-88 {
    padding-top: 43.5rem !important;
  }

  .pt-xxl-89 {
    padding-top: 44rem !important;
  }

  .pt-xxl-90 {
    padding-top: 44.5rem !important;
  }

  .pt-xxl-91 {
    padding-top: 45rem !important;
  }

  .pt-xxl-92 {
    padding-top: 45.5rem !important;
  }

  .pt-xxl-93 {
    padding-top: 46rem !important;
  }

  .pt-xxl-94 {
    padding-top: 46.5rem !important;
  }

  .pt-xxl-95 {
    padding-top: 47rem !important;
  }

  .pt-xxl-96 {
    padding-top: 47.5rem !important;
  }

  .pt-xxl-97 {
    padding-top: 48rem !important;
  }

  .pt-xxl-98 {
    padding-top: 48.5rem !important;
  }

  .pt-xxl-99 {
    padding-top: 49rem !important;
  }

  .pt-xxl-100 {
    padding-top: 49.5rem !important;
  }

  .pt-xxl-101 {
    padding-top: 50rem !important;
  }

  .pt-xxl-102 {
    padding-top: 50.5rem !important;
  }

  .pt-xxl-103 {
    padding-top: 51rem !important;
  }

  .pt-xxl-104 {
    padding-top: 51.5rem !important;
  }

  .pt-xxl-105 {
    padding-top: 52rem !important;
  }

  .pt-xxl-106 {
    padding-top: 52.5rem !important;
  }

  .pt-xxl-107 {
    padding-top: 53rem !important;
  }

  .pt-xxl-108 {
    padding-top: 53.5rem !important;
  }

  .pt-xxl-109 {
    padding-top: 54rem !important;
  }

  .pt-xxl-110 {
    padding-top: 54.5rem !important;
  }

  .pt-xxl-111 {
    padding-top: 55rem !important;
  }

  .pt-xxl-112 {
    padding-top: 55.5rem !important;
  }

  .pt-xxl-113 {
    padding-top: 56rem !important;
  }

  .pt-xxl-114 {
    padding-top: 56.5rem !important;
  }

  .pt-xxl-115 {
    padding-top: 57rem !important;
  }

  .pt-xxl-116 {
    padding-top: 57.5rem !important;
  }

  .pt-xxl-117 {
    padding-top: 58rem !important;
  }

  .pt-xxl-118 {
    padding-top: 58.5rem !important;
  }

  .pt-xxl-119 {
    padding-top: 59rem !important;
  }

  .pt-xxl-120 {
    padding-top: 59.5rem !important;
  }

  .pt-xxl-121 {
    padding-top: 60rem !important;
  }

  .pt-xxl-122 {
    padding-top: 60.5rem !important;
  }

  .pt-xxl-123 {
    padding-top: 61rem !important;
  }

  .pt-xxl-124 {
    padding-top: 61.5rem !important;
  }

  .pt-xxl-125 {
    padding-top: 62rem !important;
  }

  .pt-xxl-126 {
    padding-top: 62.5rem !important;
  }

  .pt-xxl-127 {
    padding-top: 63rem !important;
  }

  .pt-xxl-128 {
    padding-top: 63.5rem !important;
  }

  .pt-xxl-129 {
    padding-top: 64rem !important;
  }

  .pt-xxl-130 {
    padding-top: 64.5rem !important;
  }

  .pt-xxl-131 {
    padding-top: 65rem !important;
  }

  .pt-xxl-132 {
    padding-top: 65.5rem !important;
  }

  .pt-xxl-133 {
    padding-top: 66rem !important;
  }

  .pt-xxl-134 {
    padding-top: 66.5rem !important;
  }

  .pt-xxl-135 {
    padding-top: 67rem !important;
  }

  .pt-xxl-136 {
    padding-top: 67.5rem !important;
  }

  .pt-xxl-137 {
    padding-top: 68rem !important;
  }

  .pt-xxl-138 {
    padding-top: 68.5rem !important;
  }

  .pt-xxl-139 {
    padding-top: 69rem !important;
  }

  .pt-xxl-140 {
    padding-top: 69.5rem !important;
  }

  .pt-xxl-141 {
    padding-top: 70rem !important;
  }

  .pt-xxl-142 {
    padding-top: 70.5rem !important;
  }

  .pt-xxl-143 {
    padding-top: 71rem !important;
  }

  .pt-xxl-144 {
    padding-top: 71.5rem !important;
  }

  .pt-xxl-145 {
    padding-top: 72rem !important;
  }

  .pt-xxl-146 {
    padding-top: 72.5rem !important;
  }

  .pt-xxl-147 {
    padding-top: 73rem !important;
  }

  .pt-xxl-148 {
    padding-top: 73.5rem !important;
  }

  .pt-xxl-149 {
    padding-top: 74rem !important;
  }

  .pt-xxl-150 {
    padding-top: 74.5rem !important;
  }

  .pt-xxl-151 {
    padding-top: 75rem !important;
  }

  .pt-xxl-152 {
    padding-top: 75.5rem !important;
  }

  .pt-xxl-153 {
    padding-top: 76rem !important;
  }

  .pt-xxl-154 {
    padding-top: 76.5rem !important;
  }

  .pt-xxl-155 {
    padding-top: 77rem !important;
  }

  .pt-xxl-156 {
    padding-top: 77.5rem !important;
  }

  .pt-xxl-157 {
    padding-top: 78rem !important;
  }

  .pt-xxl-158 {
    padding-top: 78.5rem !important;
  }

  .pt-xxl-159 {
    padding-top: 79rem !important;
  }

  .pt-xxl-160 {
    padding-top: 79.5rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0rem !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 2rem !important;
  }

  .pb-xxl-6 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xxl-7 {
    padding-bottom: 3rem !important;
  }

  .pb-xxl-8 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xxl-9 {
    padding-bottom: 4rem !important;
  }

  .pb-xxl-10 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xxl-11 {
    padding-bottom: 5rem !important;
  }

  .pb-xxl-12 {
    padding-bottom: 5.5rem !important;
  }

  .pb-xxl-13 {
    padding-bottom: 6rem !important;
  }

  .pb-xxl-14 {
    padding-bottom: 6.5rem !important;
  }

  .pb-xxl-15 {
    padding-bottom: 7rem !important;
  }

  .pb-xxl-16 {
    padding-bottom: 7.5rem !important;
  }

  .pb-xxl-17 {
    padding-bottom: 8rem !important;
  }

  .pb-xxl-18 {
    padding-bottom: 8.5rem !important;
  }

  .pb-xxl-19 {
    padding-bottom: 9rem !important;
  }

  .pb-xxl-20 {
    padding-bottom: 9.5rem !important;
  }

  .pb-xxl-21 {
    padding-bottom: 10rem !important;
  }

  .pb-xxl-22 {
    padding-bottom: 10.5rem !important;
  }

  .pb-xxl-23 {
    padding-bottom: 11rem !important;
  }

  .pb-xxl-24 {
    padding-bottom: 11.5rem !important;
  }

  .pb-xxl-25 {
    padding-bottom: 12rem !important;
  }

  .pb-xxl-26 {
    padding-bottom: 12.5rem !important;
  }

  .pb-xxl-27 {
    padding-bottom: 13rem !important;
  }

  .pb-xxl-28 {
    padding-bottom: 13.5rem !important;
  }

  .pb-xxl-29 {
    padding-bottom: 14rem !important;
  }

  .pb-xxl-30 {
    padding-bottom: 14.5rem !important;
  }

  .pb-xxl-31 {
    padding-bottom: 15rem !important;
  }

  .pb-xxl-32 {
    padding-bottom: 15.5rem !important;
  }

  .pb-xxl-33 {
    padding-bottom: 16rem !important;
  }

  .pb-xxl-34 {
    padding-bottom: 16.5rem !important;
  }

  .pb-xxl-35 {
    padding-bottom: 17rem !important;
  }

  .pb-xxl-36 {
    padding-bottom: 17.5rem !important;
  }

  .pb-xxl-37 {
    padding-bottom: 18rem !important;
  }

  .pb-xxl-38 {
    padding-bottom: 18.5rem !important;
  }

  .pb-xxl-39 {
    padding-bottom: 19rem !important;
  }

  .pb-xxl-40 {
    padding-bottom: 19.5rem !important;
  }

  .pb-xxl-41 {
    padding-bottom: 20rem !important;
  }

  .pb-xxl-42 {
    padding-bottom: 20.5rem !important;
  }

  .pb-xxl-43 {
    padding-bottom: 21rem !important;
  }

  .pb-xxl-44 {
    padding-bottom: 21.5rem !important;
  }

  .pb-xxl-45 {
    padding-bottom: 22rem !important;
  }

  .pb-xxl-46 {
    padding-bottom: 22.5rem !important;
  }

  .pb-xxl-47 {
    padding-bottom: 23rem !important;
  }

  .pb-xxl-48 {
    padding-bottom: 23.5rem !important;
  }

  .pb-xxl-49 {
    padding-bottom: 24rem !important;
  }

  .pb-xxl-50 {
    padding-bottom: 24.5rem !important;
  }

  .pb-xxl-51 {
    padding-bottom: 25rem !important;
  }

  .pb-xxl-52 {
    padding-bottom: 25.5rem !important;
  }

  .pb-xxl-53 {
    padding-bottom: 26rem !important;
  }

  .pb-xxl-54 {
    padding-bottom: 26.5rem !important;
  }

  .pb-xxl-55 {
    padding-bottom: 27rem !important;
  }

  .pb-xxl-56 {
    padding-bottom: 27.5rem !important;
  }

  .pb-xxl-57 {
    padding-bottom: 28rem !important;
  }

  .pb-xxl-58 {
    padding-bottom: 28.5rem !important;
  }

  .pb-xxl-59 {
    padding-bottom: 29rem !important;
  }

  .pb-xxl-60 {
    padding-bottom: 29.5rem !important;
  }

  .pb-xxl-61 {
    padding-bottom: 30rem !important;
  }

  .pb-xxl-62 {
    padding-bottom: 30.5rem !important;
  }

  .pb-xxl-63 {
    padding-bottom: 31rem !important;
  }

  .pb-xxl-64 {
    padding-bottom: 31.5rem !important;
  }

  .pb-xxl-65 {
    padding-bottom: 32rem !important;
  }

  .pb-xxl-66 {
    padding-bottom: 32.5rem !important;
  }

  .pb-xxl-67 {
    padding-bottom: 33rem !important;
  }

  .pb-xxl-68 {
    padding-bottom: 33.5rem !important;
  }

  .pb-xxl-69 {
    padding-bottom: 34rem !important;
  }

  .pb-xxl-70 {
    padding-bottom: 34.5rem !important;
  }

  .pb-xxl-71 {
    padding-bottom: 35rem !important;
  }

  .pb-xxl-72 {
    padding-bottom: 35.5rem !important;
  }

  .pb-xxl-73 {
    padding-bottom: 36rem !important;
  }

  .pb-xxl-74 {
    padding-bottom: 36.5rem !important;
  }

  .pb-xxl-75 {
    padding-bottom: 37rem !important;
  }

  .pb-xxl-76 {
    padding-bottom: 37.5rem !important;
  }

  .pb-xxl-77 {
    padding-bottom: 38rem !important;
  }

  .pb-xxl-78 {
    padding-bottom: 38.5rem !important;
  }

  .pb-xxl-79 {
    padding-bottom: 39rem !important;
  }

  .pb-xxl-80 {
    padding-bottom: 39.5rem !important;
  }

  .pb-xxl-81 {
    padding-bottom: 40rem !important;
  }

  .pb-xxl-82 {
    padding-bottom: 40.5rem !important;
  }

  .pb-xxl-83 {
    padding-bottom: 41rem !important;
  }

  .pb-xxl-84 {
    padding-bottom: 41.5rem !important;
  }

  .pb-xxl-85 {
    padding-bottom: 42rem !important;
  }

  .pb-xxl-86 {
    padding-bottom: 42.5rem !important;
  }

  .pb-xxl-87 {
    padding-bottom: 43rem !important;
  }

  .pb-xxl-88 {
    padding-bottom: 43.5rem !important;
  }

  .pb-xxl-89 {
    padding-bottom: 44rem !important;
  }

  .pb-xxl-90 {
    padding-bottom: 44.5rem !important;
  }

  .pb-xxl-91 {
    padding-bottom: 45rem !important;
  }

  .pb-xxl-92 {
    padding-bottom: 45.5rem !important;
  }

  .pb-xxl-93 {
    padding-bottom: 46rem !important;
  }

  .pb-xxl-94 {
    padding-bottom: 46.5rem !important;
  }

  .pb-xxl-95 {
    padding-bottom: 47rem !important;
  }

  .pb-xxl-96 {
    padding-bottom: 47.5rem !important;
  }

  .pb-xxl-97 {
    padding-bottom: 48rem !important;
  }

  .pb-xxl-98 {
    padding-bottom: 48.5rem !important;
  }

  .pb-xxl-99 {
    padding-bottom: 49rem !important;
  }

  .pb-xxl-100 {
    padding-bottom: 49.5rem !important;
  }

  .pb-xxl-101 {
    padding-bottom: 50rem !important;
  }

  .pb-xxl-102 {
    padding-bottom: 50.5rem !important;
  }

  .pb-xxl-103 {
    padding-bottom: 51rem !important;
  }

  .pb-xxl-104 {
    padding-bottom: 51.5rem !important;
  }

  .pb-xxl-105 {
    padding-bottom: 52rem !important;
  }

  .pb-xxl-106 {
    padding-bottom: 52.5rem !important;
  }

  .pb-xxl-107 {
    padding-bottom: 53rem !important;
  }

  .pb-xxl-108 {
    padding-bottom: 53.5rem !important;
  }

  .pb-xxl-109 {
    padding-bottom: 54rem !important;
  }

  .pb-xxl-110 {
    padding-bottom: 54.5rem !important;
  }

  .pb-xxl-111 {
    padding-bottom: 55rem !important;
  }

  .pb-xxl-112 {
    padding-bottom: 55.5rem !important;
  }

  .pb-xxl-113 {
    padding-bottom: 56rem !important;
  }

  .pb-xxl-114 {
    padding-bottom: 56.5rem !important;
  }

  .pb-xxl-115 {
    padding-bottom: 57rem !important;
  }

  .pb-xxl-116 {
    padding-bottom: 57.5rem !important;
  }

  .pb-xxl-117 {
    padding-bottom: 58rem !important;
  }

  .pb-xxl-118 {
    padding-bottom: 58.5rem !important;
  }

  .pb-xxl-119 {
    padding-bottom: 59rem !important;
  }

  .pb-xxl-120 {
    padding-bottom: 59.5rem !important;
  }

  .pb-xxl-121 {
    padding-bottom: 60rem !important;
  }

  .pb-xxl-122 {
    padding-bottom: 60.5rem !important;
  }

  .pb-xxl-123 {
    padding-bottom: 61rem !important;
  }

  .pb-xxl-124 {
    padding-bottom: 61.5rem !important;
  }

  .pb-xxl-125 {
    padding-bottom: 62rem !important;
  }

  .pb-xxl-126 {
    padding-bottom: 62.5rem !important;
  }

  .pb-xxl-127 {
    padding-bottom: 63rem !important;
  }

  .pb-xxl-128 {
    padding-bottom: 63.5rem !important;
  }

  .pb-xxl-129 {
    padding-bottom: 64rem !important;
  }

  .pb-xxl-130 {
    padding-bottom: 64.5rem !important;
  }

  .pb-xxl-131 {
    padding-bottom: 65rem !important;
  }

  .pb-xxl-132 {
    padding-bottom: 65.5rem !important;
  }

  .pb-xxl-133 {
    padding-bottom: 66rem !important;
  }

  .pb-xxl-134 {
    padding-bottom: 66.5rem !important;
  }

  .pb-xxl-135 {
    padding-bottom: 67rem !important;
  }

  .pb-xxl-136 {
    padding-bottom: 67.5rem !important;
  }

  .pb-xxl-137 {
    padding-bottom: 68rem !important;
  }

  .pb-xxl-138 {
    padding-bottom: 68.5rem !important;
  }

  .pb-xxl-139 {
    padding-bottom: 69rem !important;
  }

  .pb-xxl-140 {
    padding-bottom: 69.5rem !important;
  }

  .pb-xxl-141 {
    padding-bottom: 70rem !important;
  }

  .pb-xxl-142 {
    padding-bottom: 70.5rem !important;
  }

  .pb-xxl-143 {
    padding-bottom: 71rem !important;
  }

  .pb-xxl-144 {
    padding-bottom: 71.5rem !important;
  }

  .pb-xxl-145 {
    padding-bottom: 72rem !important;
  }

  .pb-xxl-146 {
    padding-bottom: 72.5rem !important;
  }

  .pb-xxl-147 {
    padding-bottom: 73rem !important;
  }

  .pb-xxl-148 {
    padding-bottom: 73.5rem !important;
  }

  .pb-xxl-149 {
    padding-bottom: 74rem !important;
  }

  .pb-xxl-150 {
    padding-bottom: 74.5rem !important;
  }

  .pb-xxl-151 {
    padding-bottom: 75rem !important;
  }

  .pb-xxl-152 {
    padding-bottom: 75.5rem !important;
  }

  .pb-xxl-153 {
    padding-bottom: 76rem !important;
  }

  .pb-xxl-154 {
    padding-bottom: 76.5rem !important;
  }

  .pb-xxl-155 {
    padding-bottom: 77rem !important;
  }

  .pb-xxl-156 {
    padding-bottom: 77.5rem !important;
  }

  .pb-xxl-157 {
    padding-bottom: 78rem !important;
  }

  .pb-xxl-158 {
    padding-bottom: 78.5rem !important;
  }

  .pb-xxl-159 {
    padding-bottom: 79rem !important;
  }

  .pb-xxl-160 {
    padding-bottom: 79.5rem !important;
  }

  .ps-xxl-0 {
    padding-left: 0rem !important;
  }

  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xxl-3 {
    padding-left: 1rem !important;
  }

  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xxl-5 {
    padding-left: 2rem !important;
  }

  .ps-xxl-6 {
    padding-left: 2.5rem !important;
  }

  .ps-xxl-7 {
    padding-left: 3rem !important;
  }

  .ps-xxl-8 {
    padding-left: 3.5rem !important;
  }

  .ps-xxl-9 {
    padding-left: 4rem !important;
  }

  .ps-xxl-10 {
    padding-left: 4.5rem !important;
  }

  .ps-xxl-11 {
    padding-left: 5rem !important;
  }

  .ps-xxl-12 {
    padding-left: 5.5rem !important;
  }

  .ps-xxl-13 {
    padding-left: 6rem !important;
  }

  .ps-xxl-14 {
    padding-left: 6.5rem !important;
  }

  .ps-xxl-15 {
    padding-left: 7rem !important;
  }

  .ps-xxl-16 {
    padding-left: 7.5rem !important;
  }

  .ps-xxl-17 {
    padding-left: 8rem !important;
  }

  .ps-xxl-18 {
    padding-left: 8.5rem !important;
  }

  .ps-xxl-19 {
    padding-left: 9rem !important;
  }

  .ps-xxl-20 {
    padding-left: 9.5rem !important;
  }

  .ps-xxl-21 {
    padding-left: 10rem !important;
  }

  .ps-xxl-22 {
    padding-left: 10.5rem !important;
  }

  .ps-xxl-23 {
    padding-left: 11rem !important;
  }

  .ps-xxl-24 {
    padding-left: 11.5rem !important;
  }

  .ps-xxl-25 {
    padding-left: 12rem !important;
  }

  .ps-xxl-26 {
    padding-left: 12.5rem !important;
  }

  .ps-xxl-27 {
    padding-left: 13rem !important;
  }

  .ps-xxl-28 {
    padding-left: 13.5rem !important;
  }

  .ps-xxl-29 {
    padding-left: 14rem !important;
  }

  .ps-xxl-30 {
    padding-left: 14.5rem !important;
  }

  .ps-xxl-31 {
    padding-left: 15rem !important;
  }

  .ps-xxl-32 {
    padding-left: 15.5rem !important;
  }

  .ps-xxl-33 {
    padding-left: 16rem !important;
  }

  .ps-xxl-34 {
    padding-left: 16.5rem !important;
  }

  .ps-xxl-35 {
    padding-left: 17rem !important;
  }

  .ps-xxl-36 {
    padding-left: 17.5rem !important;
  }

  .ps-xxl-37 {
    padding-left: 18rem !important;
  }

  .ps-xxl-38 {
    padding-left: 18.5rem !important;
  }

  .ps-xxl-39 {
    padding-left: 19rem !important;
  }

  .ps-xxl-40 {
    padding-left: 19.5rem !important;
  }

  .ps-xxl-41 {
    padding-left: 20rem !important;
  }

  .ps-xxl-42 {
    padding-left: 20.5rem !important;
  }

  .ps-xxl-43 {
    padding-left: 21rem !important;
  }

  .ps-xxl-44 {
    padding-left: 21.5rem !important;
  }

  .ps-xxl-45 {
    padding-left: 22rem !important;
  }

  .ps-xxl-46 {
    padding-left: 22.5rem !important;
  }

  .ps-xxl-47 {
    padding-left: 23rem !important;
  }

  .ps-xxl-48 {
    padding-left: 23.5rem !important;
  }

  .ps-xxl-49 {
    padding-left: 24rem !important;
  }

  .ps-xxl-50 {
    padding-left: 24.5rem !important;
  }

  .ps-xxl-51 {
    padding-left: 25rem !important;
  }

  .ps-xxl-52 {
    padding-left: 25.5rem !important;
  }

  .ps-xxl-53 {
    padding-left: 26rem !important;
  }

  .ps-xxl-54 {
    padding-left: 26.5rem !important;
  }

  .ps-xxl-55 {
    padding-left: 27rem !important;
  }

  .ps-xxl-56 {
    padding-left: 27.5rem !important;
  }

  .ps-xxl-57 {
    padding-left: 28rem !important;
  }

  .ps-xxl-58 {
    padding-left: 28.5rem !important;
  }

  .ps-xxl-59 {
    padding-left: 29rem !important;
  }

  .ps-xxl-60 {
    padding-left: 29.5rem !important;
  }

  .ps-xxl-61 {
    padding-left: 30rem !important;
  }

  .ps-xxl-62 {
    padding-left: 30.5rem !important;
  }

  .ps-xxl-63 {
    padding-left: 31rem !important;
  }

  .ps-xxl-64 {
    padding-left: 31.5rem !important;
  }

  .ps-xxl-65 {
    padding-left: 32rem !important;
  }

  .ps-xxl-66 {
    padding-left: 32.5rem !important;
  }

  .ps-xxl-67 {
    padding-left: 33rem !important;
  }

  .ps-xxl-68 {
    padding-left: 33.5rem !important;
  }

  .ps-xxl-69 {
    padding-left: 34rem !important;
  }

  .ps-xxl-70 {
    padding-left: 34.5rem !important;
  }

  .ps-xxl-71 {
    padding-left: 35rem !important;
  }

  .ps-xxl-72 {
    padding-left: 35.5rem !important;
  }

  .ps-xxl-73 {
    padding-left: 36rem !important;
  }

  .ps-xxl-74 {
    padding-left: 36.5rem !important;
  }

  .ps-xxl-75 {
    padding-left: 37rem !important;
  }

  .ps-xxl-76 {
    padding-left: 37.5rem !important;
  }

  .ps-xxl-77 {
    padding-left: 38rem !important;
  }

  .ps-xxl-78 {
    padding-left: 38.5rem !important;
  }

  .ps-xxl-79 {
    padding-left: 39rem !important;
  }

  .ps-xxl-80 {
    padding-left: 39.5rem !important;
  }

  .ps-xxl-81 {
    padding-left: 40rem !important;
  }

  .ps-xxl-82 {
    padding-left: 40.5rem !important;
  }

  .ps-xxl-83 {
    padding-left: 41rem !important;
  }

  .ps-xxl-84 {
    padding-left: 41.5rem !important;
  }

  .ps-xxl-85 {
    padding-left: 42rem !important;
  }

  .ps-xxl-86 {
    padding-left: 42.5rem !important;
  }

  .ps-xxl-87 {
    padding-left: 43rem !important;
  }

  .ps-xxl-88 {
    padding-left: 43.5rem !important;
  }

  .ps-xxl-89 {
    padding-left: 44rem !important;
  }

  .ps-xxl-90 {
    padding-left: 44.5rem !important;
  }

  .ps-xxl-91 {
    padding-left: 45rem !important;
  }

  .ps-xxl-92 {
    padding-left: 45.5rem !important;
  }

  .ps-xxl-93 {
    padding-left: 46rem !important;
  }

  .ps-xxl-94 {
    padding-left: 46.5rem !important;
  }

  .ps-xxl-95 {
    padding-left: 47rem !important;
  }

  .ps-xxl-96 {
    padding-left: 47.5rem !important;
  }

  .ps-xxl-97 {
    padding-left: 48rem !important;
  }

  .ps-xxl-98 {
    padding-left: 48.5rem !important;
  }

  .ps-xxl-99 {
    padding-left: 49rem !important;
  }

  .ps-xxl-100 {
    padding-left: 49.5rem !important;
  }

  .ps-xxl-101 {
    padding-left: 50rem !important;
  }

  .ps-xxl-102 {
    padding-left: 50.5rem !important;
  }

  .ps-xxl-103 {
    padding-left: 51rem !important;
  }

  .ps-xxl-104 {
    padding-left: 51.5rem !important;
  }

  .ps-xxl-105 {
    padding-left: 52rem !important;
  }

  .ps-xxl-106 {
    padding-left: 52.5rem !important;
  }

  .ps-xxl-107 {
    padding-left: 53rem !important;
  }

  .ps-xxl-108 {
    padding-left: 53.5rem !important;
  }

  .ps-xxl-109 {
    padding-left: 54rem !important;
  }

  .ps-xxl-110 {
    padding-left: 54.5rem !important;
  }

  .ps-xxl-111 {
    padding-left: 55rem !important;
  }

  .ps-xxl-112 {
    padding-left: 55.5rem !important;
  }

  .ps-xxl-113 {
    padding-left: 56rem !important;
  }

  .ps-xxl-114 {
    padding-left: 56.5rem !important;
  }

  .ps-xxl-115 {
    padding-left: 57rem !important;
  }

  .ps-xxl-116 {
    padding-left: 57.5rem !important;
  }

  .ps-xxl-117 {
    padding-left: 58rem !important;
  }

  .ps-xxl-118 {
    padding-left: 58.5rem !important;
  }

  .ps-xxl-119 {
    padding-left: 59rem !important;
  }

  .ps-xxl-120 {
    padding-left: 59.5rem !important;
  }

  .ps-xxl-121 {
    padding-left: 60rem !important;
  }

  .ps-xxl-122 {
    padding-left: 60.5rem !important;
  }

  .ps-xxl-123 {
    padding-left: 61rem !important;
  }

  .ps-xxl-124 {
    padding-left: 61.5rem !important;
  }

  .ps-xxl-125 {
    padding-left: 62rem !important;
  }

  .ps-xxl-126 {
    padding-left: 62.5rem !important;
  }

  .ps-xxl-127 {
    padding-left: 63rem !important;
  }

  .ps-xxl-128 {
    padding-left: 63.5rem !important;
  }

  .ps-xxl-129 {
    padding-left: 64rem !important;
  }

  .ps-xxl-130 {
    padding-left: 64.5rem !important;
  }

  .ps-xxl-131 {
    padding-left: 65rem !important;
  }

  .ps-xxl-132 {
    padding-left: 65.5rem !important;
  }

  .ps-xxl-133 {
    padding-left: 66rem !important;
  }

  .ps-xxl-134 {
    padding-left: 66.5rem !important;
  }

  .ps-xxl-135 {
    padding-left: 67rem !important;
  }

  .ps-xxl-136 {
    padding-left: 67.5rem !important;
  }

  .ps-xxl-137 {
    padding-left: 68rem !important;
  }

  .ps-xxl-138 {
    padding-left: 68.5rem !important;
  }

  .ps-xxl-139 {
    padding-left: 69rem !important;
  }

  .ps-xxl-140 {
    padding-left: 69.5rem !important;
  }

  .ps-xxl-141 {
    padding-left: 70rem !important;
  }

  .ps-xxl-142 {
    padding-left: 70.5rem !important;
  }

  .ps-xxl-143 {
    padding-left: 71rem !important;
  }

  .ps-xxl-144 {
    padding-left: 71.5rem !important;
  }

  .ps-xxl-145 {
    padding-left: 72rem !important;
  }

  .ps-xxl-146 {
    padding-left: 72.5rem !important;
  }

  .ps-xxl-147 {
    padding-left: 73rem !important;
  }

  .ps-xxl-148 {
    padding-left: 73.5rem !important;
  }

  .ps-xxl-149 {
    padding-left: 74rem !important;
  }

  .ps-xxl-150 {
    padding-left: 74.5rem !important;
  }

  .ps-xxl-151 {
    padding-left: 75rem !important;
  }

  .ps-xxl-152 {
    padding-left: 75.5rem !important;
  }

  .ps-xxl-153 {
    padding-left: 76rem !important;
  }

  .ps-xxl-154 {
    padding-left: 76.5rem !important;
  }

  .ps-xxl-155 {
    padding-left: 77rem !important;
  }

  .ps-xxl-156 {
    padding-left: 77.5rem !important;
  }

  .ps-xxl-157 {
    padding-left: 78rem !important;
  }

  .ps-xxl-158 {
    padding-left: 78.5rem !important;
  }

  .ps-xxl-159 {
    padding-left: 79rem !important;
  }

  .ps-xxl-160 {
    padding-left: 79.5rem !important;
  }

  .pe-xxl-0 {
    padding-right: 0rem !important;
  }

  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xxl-3 {
    padding-right: 1rem !important;
  }

  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xxl-5 {
    padding-right: 2rem !important;
  }

  .pe-xxl-6 {
    padding-right: 2.5rem !important;
  }

  .pe-xxl-7 {
    padding-right: 3rem !important;
  }

  .pe-xxl-8 {
    padding-right: 3.5rem !important;
  }

  .pe-xxl-9 {
    padding-right: 4rem !important;
  }

  .pe-xxl-10 {
    padding-right: 4.5rem !important;
  }

  .pe-xxl-11 {
    padding-right: 5rem !important;
  }

  .pe-xxl-12 {
    padding-right: 5.5rem !important;
  }

  .pe-xxl-13 {
    padding-right: 6rem !important;
  }

  .pe-xxl-14 {
    padding-right: 6.5rem !important;
  }

  .pe-xxl-15 {
    padding-right: 7rem !important;
  }

  .pe-xxl-16 {
    padding-right: 7.5rem !important;
  }

  .pe-xxl-17 {
    padding-right: 8rem !important;
  }

  .pe-xxl-18 {
    padding-right: 8.5rem !important;
  }

  .pe-xxl-19 {
    padding-right: 9rem !important;
  }

  .pe-xxl-20 {
    padding-right: 9.5rem !important;
  }

  .pe-xxl-21 {
    padding-right: 10rem !important;
  }

  .pe-xxl-22 {
    padding-right: 10.5rem !important;
  }

  .pe-xxl-23 {
    padding-right: 11rem !important;
  }

  .pe-xxl-24 {
    padding-right: 11.5rem !important;
  }

  .pe-xxl-25 {
    padding-right: 12rem !important;
  }

  .pe-xxl-26 {
    padding-right: 12.5rem !important;
  }

  .pe-xxl-27 {
    padding-right: 13rem !important;
  }

  .pe-xxl-28 {
    padding-right: 13.5rem !important;
  }

  .pe-xxl-29 {
    padding-right: 14rem !important;
  }

  .pe-xxl-30 {
    padding-right: 14.5rem !important;
  }

  .pe-xxl-31 {
    padding-right: 15rem !important;
  }

  .pe-xxl-32 {
    padding-right: 15.5rem !important;
  }

  .pe-xxl-33 {
    padding-right: 16rem !important;
  }

  .pe-xxl-34 {
    padding-right: 16.5rem !important;
  }

  .pe-xxl-35 {
    padding-right: 17rem !important;
  }

  .pe-xxl-36 {
    padding-right: 17.5rem !important;
  }

  .pe-xxl-37 {
    padding-right: 18rem !important;
  }

  .pe-xxl-38 {
    padding-right: 18.5rem !important;
  }

  .pe-xxl-39 {
    padding-right: 19rem !important;
  }

  .pe-xxl-40 {
    padding-right: 19.5rem !important;
  }

  .pe-xxl-41 {
    padding-right: 20rem !important;
  }

  .pe-xxl-42 {
    padding-right: 20.5rem !important;
  }

  .pe-xxl-43 {
    padding-right: 21rem !important;
  }

  .pe-xxl-44 {
    padding-right: 21.5rem !important;
  }

  .pe-xxl-45 {
    padding-right: 22rem !important;
  }

  .pe-xxl-46 {
    padding-right: 22.5rem !important;
  }

  .pe-xxl-47 {
    padding-right: 23rem !important;
  }

  .pe-xxl-48 {
    padding-right: 23.5rem !important;
  }

  .pe-xxl-49 {
    padding-right: 24rem !important;
  }

  .pe-xxl-50 {
    padding-right: 24.5rem !important;
  }

  .pe-xxl-51 {
    padding-right: 25rem !important;
  }

  .pe-xxl-52 {
    padding-right: 25.5rem !important;
  }

  .pe-xxl-53 {
    padding-right: 26rem !important;
  }

  .pe-xxl-54 {
    padding-right: 26.5rem !important;
  }

  .pe-xxl-55 {
    padding-right: 27rem !important;
  }

  .pe-xxl-56 {
    padding-right: 27.5rem !important;
  }

  .pe-xxl-57 {
    padding-right: 28rem !important;
  }

  .pe-xxl-58 {
    padding-right: 28.5rem !important;
  }

  .pe-xxl-59 {
    padding-right: 29rem !important;
  }

  .pe-xxl-60 {
    padding-right: 29.5rem !important;
  }

  .pe-xxl-61 {
    padding-right: 30rem !important;
  }

  .pe-xxl-62 {
    padding-right: 30.5rem !important;
  }

  .pe-xxl-63 {
    padding-right: 31rem !important;
  }

  .pe-xxl-64 {
    padding-right: 31.5rem !important;
  }

  .pe-xxl-65 {
    padding-right: 32rem !important;
  }

  .pe-xxl-66 {
    padding-right: 32.5rem !important;
  }

  .pe-xxl-67 {
    padding-right: 33rem !important;
  }

  .pe-xxl-68 {
    padding-right: 33.5rem !important;
  }

  .pe-xxl-69 {
    padding-right: 34rem !important;
  }

  .pe-xxl-70 {
    padding-right: 34.5rem !important;
  }

  .pe-xxl-71 {
    padding-right: 35rem !important;
  }

  .pe-xxl-72 {
    padding-right: 35.5rem !important;
  }

  .pe-xxl-73 {
    padding-right: 36rem !important;
  }

  .pe-xxl-74 {
    padding-right: 36.5rem !important;
  }

  .pe-xxl-75 {
    padding-right: 37rem !important;
  }

  .pe-xxl-76 {
    padding-right: 37.5rem !important;
  }

  .pe-xxl-77 {
    padding-right: 38rem !important;
  }

  .pe-xxl-78 {
    padding-right: 38.5rem !important;
  }

  .pe-xxl-79 {
    padding-right: 39rem !important;
  }

  .pe-xxl-80 {
    padding-right: 39.5rem !important;
  }

  .pe-xxl-81 {
    padding-right: 40rem !important;
  }

  .pe-xxl-82 {
    padding-right: 40.5rem !important;
  }

  .pe-xxl-83 {
    padding-right: 41rem !important;
  }

  .pe-xxl-84 {
    padding-right: 41.5rem !important;
  }

  .pe-xxl-85 {
    padding-right: 42rem !important;
  }

  .pe-xxl-86 {
    padding-right: 42.5rem !important;
  }

  .pe-xxl-87 {
    padding-right: 43rem !important;
  }

  .pe-xxl-88 {
    padding-right: 43.5rem !important;
  }

  .pe-xxl-89 {
    padding-right: 44rem !important;
  }

  .pe-xxl-90 {
    padding-right: 44.5rem !important;
  }

  .pe-xxl-91 {
    padding-right: 45rem !important;
  }

  .pe-xxl-92 {
    padding-right: 45.5rem !important;
  }

  .pe-xxl-93 {
    padding-right: 46rem !important;
  }

  .pe-xxl-94 {
    padding-right: 46.5rem !important;
  }

  .pe-xxl-95 {
    padding-right: 47rem !important;
  }

  .pe-xxl-96 {
    padding-right: 47.5rem !important;
  }

  .pe-xxl-97 {
    padding-right: 48rem !important;
  }

  .pe-xxl-98 {
    padding-right: 48.5rem !important;
  }

  .pe-xxl-99 {
    padding-right: 49rem !important;
  }

  .pe-xxl-100 {
    padding-right: 49.5rem !important;
  }

  .pe-xxl-101 {
    padding-right: 50rem !important;
  }

  .pe-xxl-102 {
    padding-right: 50.5rem !important;
  }

  .pe-xxl-103 {
    padding-right: 51rem !important;
  }

  .pe-xxl-104 {
    padding-right: 51.5rem !important;
  }

  .pe-xxl-105 {
    padding-right: 52rem !important;
  }

  .pe-xxl-106 {
    padding-right: 52.5rem !important;
  }

  .pe-xxl-107 {
    padding-right: 53rem !important;
  }

  .pe-xxl-108 {
    padding-right: 53.5rem !important;
  }

  .pe-xxl-109 {
    padding-right: 54rem !important;
  }

  .pe-xxl-110 {
    padding-right: 54.5rem !important;
  }

  .pe-xxl-111 {
    padding-right: 55rem !important;
  }

  .pe-xxl-112 {
    padding-right: 55.5rem !important;
  }

  .pe-xxl-113 {
    padding-right: 56rem !important;
  }

  .pe-xxl-114 {
    padding-right: 56.5rem !important;
  }

  .pe-xxl-115 {
    padding-right: 57rem !important;
  }

  .pe-xxl-116 {
    padding-right: 57.5rem !important;
  }

  .pe-xxl-117 {
    padding-right: 58rem !important;
  }

  .pe-xxl-118 {
    padding-right: 58.5rem !important;
  }

  .pe-xxl-119 {
    padding-right: 59rem !important;
  }

  .pe-xxl-120 {
    padding-right: 59.5rem !important;
  }

  .pe-xxl-121 {
    padding-right: 60rem !important;
  }

  .pe-xxl-122 {
    padding-right: 60.5rem !important;
  }

  .pe-xxl-123 {
    padding-right: 61rem !important;
  }

  .pe-xxl-124 {
    padding-right: 61.5rem !important;
  }

  .pe-xxl-125 {
    padding-right: 62rem !important;
  }

  .pe-xxl-126 {
    padding-right: 62.5rem !important;
  }

  .pe-xxl-127 {
    padding-right: 63rem !important;
  }

  .pe-xxl-128 {
    padding-right: 63.5rem !important;
  }

  .pe-xxl-129 {
    padding-right: 64rem !important;
  }

  .pe-xxl-130 {
    padding-right: 64.5rem !important;
  }

  .pe-xxl-131 {
    padding-right: 65rem !important;
  }

  .pe-xxl-132 {
    padding-right: 65.5rem !important;
  }

  .pe-xxl-133 {
    padding-right: 66rem !important;
  }

  .pe-xxl-134 {
    padding-right: 66.5rem !important;
  }

  .pe-xxl-135 {
    padding-right: 67rem !important;
  }

  .pe-xxl-136 {
    padding-right: 67.5rem !important;
  }

  .pe-xxl-137 {
    padding-right: 68rem !important;
  }

  .pe-xxl-138 {
    padding-right: 68.5rem !important;
  }

  .pe-xxl-139 {
    padding-right: 69rem !important;
  }

  .pe-xxl-140 {
    padding-right: 69.5rem !important;
  }

  .pe-xxl-141 {
    padding-right: 70rem !important;
  }

  .pe-xxl-142 {
    padding-right: 70.5rem !important;
  }

  .pe-xxl-143 {
    padding-right: 71rem !important;
  }

  .pe-xxl-144 {
    padding-right: 71.5rem !important;
  }

  .pe-xxl-145 {
    padding-right: 72rem !important;
  }

  .pe-xxl-146 {
    padding-right: 72.5rem !important;
  }

  .pe-xxl-147 {
    padding-right: 73rem !important;
  }

  .pe-xxl-148 {
    padding-right: 73.5rem !important;
  }

  .pe-xxl-149 {
    padding-right: 74rem !important;
  }

  .pe-xxl-150 {
    padding-right: 74.5rem !important;
  }

  .pe-xxl-151 {
    padding-right: 75rem !important;
  }

  .pe-xxl-152 {
    padding-right: 75.5rem !important;
  }

  .pe-xxl-153 {
    padding-right: 76rem !important;
  }

  .pe-xxl-154 {
    padding-right: 76.5rem !important;
  }

  .pe-xxl-155 {
    padding-right: 77rem !important;
  }

  .pe-xxl-156 {
    padding-right: 77.5rem !important;
  }

  .pe-xxl-157 {
    padding-right: 78rem !important;
  }

  .pe-xxl-158 {
    padding-right: 78.5rem !important;
  }

  .pe-xxl-159 {
    padding-right: 79rem !important;
  }

  .pe-xxl-160 {
    padding-right: 79.5rem !important;
  }

  .px-xxl-0 {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
  }

  .px-xxl-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .px-xxl-4 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .px-xxl-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .px-xxl-6 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .px-xxl-7 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .px-xxl-8 {
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important;
  }

  .px-xxl-9 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  .px-xxl-10 {
    padding-left: 4.5rem !important;
    padding-right: 4.5rem !important;
  }

  .px-xxl-11 {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  .px-xxl-12 {
    padding-left: 5.5rem !important;
    padding-right: 5.5rem !important;
  }

  .px-xxl-13 {
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  .px-xxl-14 {
    padding-left: 6.5rem !important;
    padding-right: 6.5rem !important;
  }

  .px-xxl-15 {
    padding-left: 7rem !important;
    padding-right: 7rem !important;
  }

  .px-xxl-16 {
    padding-left: 7.5rem !important;
    padding-right: 7.5rem !important;
  }

  .px-xxl-17 {
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  .px-xxl-18 {
    padding-left: 8.5rem !important;
    padding-right: 8.5rem !important;
  }

  .px-xxl-19 {
    padding-left: 9rem !important;
    padding-right: 9rem !important;
  }

  .px-xxl-20 {
    padding-left: 9.5rem !important;
    padding-right: 9.5rem !important;
  }

  .px-xxl-21 {
    padding-left: 10rem !important;
    padding-right: 10rem !important;
  }

  .px-xxl-22 {
    padding-left: 10.5rem !important;
    padding-right: 10.5rem !important;
  }

  .px-xxl-23 {
    padding-left: 11rem !important;
    padding-right: 11rem !important;
  }

  .px-xxl-24 {
    padding-left: 11.5rem !important;
    padding-right: 11.5rem !important;
  }

  .px-xxl-25 {
    padding-left: 12rem !important;
    padding-right: 12rem !important;
  }

  .px-xxl-26 {
    padding-left: 12.5rem !important;
    padding-right: 12.5rem !important;
  }

  .px-xxl-27 {
    padding-left: 13rem !important;
    padding-right: 13rem !important;
  }

  .px-xxl-28 {
    padding-left: 13.5rem !important;
    padding-right: 13.5rem !important;
  }

  .px-xxl-29 {
    padding-left: 14rem !important;
    padding-right: 14rem !important;
  }

  .px-xxl-30 {
    padding-left: 14.5rem !important;
    padding-right: 14.5rem !important;
  }

  .px-xxl-31 {
    padding-left: 15rem !important;
    padding-right: 15rem !important;
  }

  .px-xxl-32 {
    padding-left: 15.5rem !important;
    padding-right: 15.5rem !important;
  }

  .px-xxl-33 {
    padding-left: 16rem !important;
    padding-right: 16rem !important;
  }

  .px-xxl-34 {
    padding-left: 16.5rem !important;
    padding-right: 16.5rem !important;
  }

  .px-xxl-35 {
    padding-left: 17rem !important;
    padding-right: 17rem !important;
  }

  .px-xxl-36 {
    padding-left: 17.5rem !important;
    padding-right: 17.5rem !important;
  }

  .px-xxl-37 {
    padding-left: 18rem !important;
    padding-right: 18rem !important;
  }

  .px-xxl-38 {
    padding-left: 18.5rem !important;
    padding-right: 18.5rem !important;
  }

  .px-xxl-39 {
    padding-left: 19rem !important;
    padding-right: 19rem !important;
  }

  .px-xxl-40 {
    padding-left: 19.5rem !important;
    padding-right: 19.5rem !important;
  }

  .px-xxl-41 {
    padding-left: 20rem !important;
    padding-right: 20rem !important;
  }

  .px-xxl-42 {
    padding-left: 20.5rem !important;
    padding-right: 20.5rem !important;
  }

  .px-xxl-43 {
    padding-left: 21rem !important;
    padding-right: 21rem !important;
  }

  .px-xxl-44 {
    padding-left: 21.5rem !important;
    padding-right: 21.5rem !important;
  }

  .px-xxl-45 {
    padding-left: 22rem !important;
    padding-right: 22rem !important;
  }

  .px-xxl-46 {
    padding-left: 22.5rem !important;
    padding-right: 22.5rem !important;
  }

  .px-xxl-47 {
    padding-left: 23rem !important;
    padding-right: 23rem !important;
  }

  .px-xxl-48 {
    padding-left: 23.5rem !important;
    padding-right: 23.5rem !important;
  }

  .px-xxl-49 {
    padding-left: 24rem !important;
    padding-right: 24rem !important;
  }

  .px-xxl-50 {
    padding-left: 24.5rem !important;
    padding-right: 24.5rem !important;
  }

  .px-xxl-51 {
    padding-left: 25rem !important;
    padding-right: 25rem !important;
  }

  .px-xxl-52 {
    padding-left: 25.5rem !important;
    padding-right: 25.5rem !important;
  }

  .px-xxl-53 {
    padding-left: 26rem !important;
    padding-right: 26rem !important;
  }

  .px-xxl-54 {
    padding-left: 26.5rem !important;
    padding-right: 26.5rem !important;
  }

  .px-xxl-55 {
    padding-left: 27rem !important;
    padding-right: 27rem !important;
  }

  .px-xxl-56 {
    padding-left: 27.5rem !important;
    padding-right: 27.5rem !important;
  }

  .px-xxl-57 {
    padding-left: 28rem !important;
    padding-right: 28rem !important;
  }

  .px-xxl-58 {
    padding-left: 28.5rem !important;
    padding-right: 28.5rem !important;
  }

  .px-xxl-59 {
    padding-left: 29rem !important;
    padding-right: 29rem !important;
  }

  .px-xxl-60 {
    padding-left: 29.5rem !important;
    padding-right: 29.5rem !important;
  }

  .px-xxl-61 {
    padding-left: 30rem !important;
    padding-right: 30rem !important;
  }

  .px-xxl-62 {
    padding-left: 30.5rem !important;
    padding-right: 30.5rem !important;
  }

  .px-xxl-63 {
    padding-left: 31rem !important;
    padding-right: 31rem !important;
  }

  .px-xxl-64 {
    padding-left: 31.5rem !important;
    padding-right: 31.5rem !important;
  }

  .px-xxl-65 {
    padding-left: 32rem !important;
    padding-right: 32rem !important;
  }

  .px-xxl-66 {
    padding-left: 32.5rem !important;
    padding-right: 32.5rem !important;
  }

  .px-xxl-67 {
    padding-left: 33rem !important;
    padding-right: 33rem !important;
  }

  .px-xxl-68 {
    padding-left: 33.5rem !important;
    padding-right: 33.5rem !important;
  }

  .px-xxl-69 {
    padding-left: 34rem !important;
    padding-right: 34rem !important;
  }

  .px-xxl-70 {
    padding-left: 34.5rem !important;
    padding-right: 34.5rem !important;
  }

  .px-xxl-71 {
    padding-left: 35rem !important;
    padding-right: 35rem !important;
  }

  .px-xxl-72 {
    padding-left: 35.5rem !important;
    padding-right: 35.5rem !important;
  }

  .px-xxl-73 {
    padding-left: 36rem !important;
    padding-right: 36rem !important;
  }

  .px-xxl-74 {
    padding-left: 36.5rem !important;
    padding-right: 36.5rem !important;
  }

  .px-xxl-75 {
    padding-left: 37rem !important;
    padding-right: 37rem !important;
  }

  .px-xxl-76 {
    padding-left: 37.5rem !important;
    padding-right: 37.5rem !important;
  }

  .px-xxl-77 {
    padding-left: 38rem !important;
    padding-right: 38rem !important;
  }

  .px-xxl-78 {
    padding-left: 38.5rem !important;
    padding-right: 38.5rem !important;
  }

  .px-xxl-79 {
    padding-left: 39rem !important;
    padding-right: 39rem !important;
  }

  .px-xxl-80 {
    padding-left: 39.5rem !important;
    padding-right: 39.5rem !important;
  }

  .px-xxl-81 {
    padding-left: 40rem !important;
    padding-right: 40rem !important;
  }

  .px-xxl-82 {
    padding-left: 40.5rem !important;
    padding-right: 40.5rem !important;
  }

  .px-xxl-83 {
    padding-left: 41rem !important;
    padding-right: 41rem !important;
  }

  .px-xxl-84 {
    padding-left: 41.5rem !important;
    padding-right: 41.5rem !important;
  }

  .px-xxl-85 {
    padding-left: 42rem !important;
    padding-right: 42rem !important;
  }

  .px-xxl-86 {
    padding-left: 42.5rem !important;
    padding-right: 42.5rem !important;
  }

  .px-xxl-87 {
    padding-left: 43rem !important;
    padding-right: 43rem !important;
  }

  .px-xxl-88 {
    padding-left: 43.5rem !important;
    padding-right: 43.5rem !important;
  }

  .px-xxl-89 {
    padding-left: 44rem !important;
    padding-right: 44rem !important;
  }

  .px-xxl-90 {
    padding-left: 44.5rem !important;
    padding-right: 44.5rem !important;
  }

  .px-xxl-91 {
    padding-left: 45rem !important;
    padding-right: 45rem !important;
  }

  .px-xxl-92 {
    padding-left: 45.5rem !important;
    padding-right: 45.5rem !important;
  }

  .px-xxl-93 {
    padding-left: 46rem !important;
    padding-right: 46rem !important;
  }

  .px-xxl-94 {
    padding-left: 46.5rem !important;
    padding-right: 46.5rem !important;
  }

  .px-xxl-95 {
    padding-left: 47rem !important;
    padding-right: 47rem !important;
  }

  .px-xxl-96 {
    padding-left: 47.5rem !important;
    padding-right: 47.5rem !important;
  }

  .px-xxl-97 {
    padding-left: 48rem !important;
    padding-right: 48rem !important;
  }

  .px-xxl-98 {
    padding-left: 48.5rem !important;
    padding-right: 48.5rem !important;
  }

  .px-xxl-99 {
    padding-left: 49rem !important;
    padding-right: 49rem !important;
  }

  .px-xxl-100 {
    padding-left: 49.5rem !important;
    padding-right: 49.5rem !important;
  }

  .px-xxl-101 {
    padding-left: 50rem !important;
    padding-right: 50rem !important;
  }

  .px-xxl-102 {
    padding-left: 50.5rem !important;
    padding-right: 50.5rem !important;
  }

  .px-xxl-103 {
    padding-left: 51rem !important;
    padding-right: 51rem !important;
  }

  .px-xxl-104 {
    padding-left: 51.5rem !important;
    padding-right: 51.5rem !important;
  }

  .px-xxl-105 {
    padding-left: 52rem !important;
    padding-right: 52rem !important;
  }

  .px-xxl-106 {
    padding-left: 52.5rem !important;
    padding-right: 52.5rem !important;
  }

  .px-xxl-107 {
    padding-left: 53rem !important;
    padding-right: 53rem !important;
  }

  .px-xxl-108 {
    padding-left: 53.5rem !important;
    padding-right: 53.5rem !important;
  }

  .px-xxl-109 {
    padding-left: 54rem !important;
    padding-right: 54rem !important;
  }

  .px-xxl-110 {
    padding-left: 54.5rem !important;
    padding-right: 54.5rem !important;
  }

  .px-xxl-111 {
    padding-left: 55rem !important;
    padding-right: 55rem !important;
  }

  .px-xxl-112 {
    padding-left: 55.5rem !important;
    padding-right: 55.5rem !important;
  }

  .px-xxl-113 {
    padding-left: 56rem !important;
    padding-right: 56rem !important;
  }

  .px-xxl-114 {
    padding-left: 56.5rem !important;
    padding-right: 56.5rem !important;
  }

  .px-xxl-115 {
    padding-left: 57rem !important;
    padding-right: 57rem !important;
  }

  .px-xxl-116 {
    padding-left: 57.5rem !important;
    padding-right: 57.5rem !important;
  }

  .px-xxl-117 {
    padding-left: 58rem !important;
    padding-right: 58rem !important;
  }

  .px-xxl-118 {
    padding-left: 58.5rem !important;
    padding-right: 58.5rem !important;
  }

  .px-xxl-119 {
    padding-left: 59rem !important;
    padding-right: 59rem !important;
  }

  .px-xxl-120 {
    padding-left: 59.5rem !important;
    padding-right: 59.5rem !important;
  }

  .px-xxl-121 {
    padding-left: 60rem !important;
    padding-right: 60rem !important;
  }

  .px-xxl-122 {
    padding-left: 60.5rem !important;
    padding-right: 60.5rem !important;
  }

  .px-xxl-123 {
    padding-left: 61rem !important;
    padding-right: 61rem !important;
  }

  .px-xxl-124 {
    padding-left: 61.5rem !important;
    padding-right: 61.5rem !important;
  }

  .px-xxl-125 {
    padding-left: 62rem !important;
    padding-right: 62rem !important;
  }

  .px-xxl-126 {
    padding-left: 62.5rem !important;
    padding-right: 62.5rem !important;
  }

  .px-xxl-127 {
    padding-left: 63rem !important;
    padding-right: 63rem !important;
  }

  .px-xxl-128 {
    padding-left: 63.5rem !important;
    padding-right: 63.5rem !important;
  }

  .px-xxl-129 {
    padding-left: 64rem !important;
    padding-right: 64rem !important;
  }

  .px-xxl-130 {
    padding-left: 64.5rem !important;
    padding-right: 64.5rem !important;
  }

  .px-xxl-131 {
    padding-left: 65rem !important;
    padding-right: 65rem !important;
  }

  .px-xxl-132 {
    padding-left: 65.5rem !important;
    padding-right: 65.5rem !important;
  }

  .px-xxl-133 {
    padding-left: 66rem !important;
    padding-right: 66rem !important;
  }

  .px-xxl-134 {
    padding-left: 66.5rem !important;
    padding-right: 66.5rem !important;
  }

  .px-xxl-135 {
    padding-left: 67rem !important;
    padding-right: 67rem !important;
  }

  .px-xxl-136 {
    padding-left: 67.5rem !important;
    padding-right: 67.5rem !important;
  }

  .px-xxl-137 {
    padding-left: 68rem !important;
    padding-right: 68rem !important;
  }

  .px-xxl-138 {
    padding-left: 68.5rem !important;
    padding-right: 68.5rem !important;
  }

  .px-xxl-139 {
    padding-left: 69rem !important;
    padding-right: 69rem !important;
  }

  .px-xxl-140 {
    padding-left: 69.5rem !important;
    padding-right: 69.5rem !important;
  }

  .px-xxl-141 {
    padding-left: 70rem !important;
    padding-right: 70rem !important;
  }

  .px-xxl-142 {
    padding-left: 70.5rem !important;
    padding-right: 70.5rem !important;
  }

  .px-xxl-143 {
    padding-left: 71rem !important;
    padding-right: 71rem !important;
  }

  .px-xxl-144 {
    padding-left: 71.5rem !important;
    padding-right: 71.5rem !important;
  }

  .px-xxl-145 {
    padding-left: 72rem !important;
    padding-right: 72rem !important;
  }

  .px-xxl-146 {
    padding-left: 72.5rem !important;
    padding-right: 72.5rem !important;
  }

  .px-xxl-147 {
    padding-left: 73rem !important;
    padding-right: 73rem !important;
  }

  .px-xxl-148 {
    padding-left: 73.5rem !important;
    padding-right: 73.5rem !important;
  }

  .px-xxl-149 {
    padding-left: 74rem !important;
    padding-right: 74rem !important;
  }

  .px-xxl-150 {
    padding-left: 74.5rem !important;
    padding-right: 74.5rem !important;
  }

  .px-xxl-151 {
    padding-left: 75rem !important;
    padding-right: 75rem !important;
  }

  .px-xxl-152 {
    padding-left: 75.5rem !important;
    padding-right: 75.5rem !important;
  }

  .px-xxl-153 {
    padding-left: 76rem !important;
    padding-right: 76rem !important;
  }

  .px-xxl-154 {
    padding-left: 76.5rem !important;
    padding-right: 76.5rem !important;
  }

  .px-xxl-155 {
    padding-left: 77rem !important;
    padding-right: 77rem !important;
  }

  .px-xxl-156 {
    padding-left: 77.5rem !important;
    padding-right: 77.5rem !important;
  }

  .px-xxl-157 {
    padding-left: 78rem !important;
    padding-right: 78rem !important;
  }

  .px-xxl-158 {
    padding-left: 78.5rem !important;
    padding-right: 78.5rem !important;
  }

  .px-xxl-159 {
    padding-left: 79rem !important;
    padding-right: 79rem !important;
  }

  .px-xxl-160 {
    padding-left: 79.5rem !important;
    padding-right: 79.5rem !important;
  }

  .py-xxl-0 {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xxl-6 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xxl-7 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xxl-8 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xxl-9 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xxl-10 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xxl-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .py-xxl-12 {
    padding-top: 5.5rem !important;
    padding-bottom: 5.5rem !important;
  }

  .py-xxl-13 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  .py-xxl-14 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }

  .py-xxl-15 {
    padding-top: 7rem !important;
    padding-bottom: 7rem !important;
  }

  .py-xxl-16 {
    padding-top: 7.5rem !important;
    padding-bottom: 7.5rem !important;
  }

  .py-xxl-17 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  .py-xxl-18 {
    padding-top: 8.5rem !important;
    padding-bottom: 8.5rem !important;
  }

  .py-xxl-19 {
    padding-top: 9rem !important;
    padding-bottom: 9rem !important;
  }

  .py-xxl-20 {
    padding-top: 9.5rem !important;
    padding-bottom: 9.5rem !important;
  }

  .py-xxl-21 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important;
  }

  .py-xxl-22 {
    padding-top: 10.5rem !important;
    padding-bottom: 10.5rem !important;
  }

  .py-xxl-23 {
    padding-top: 11rem !important;
    padding-bottom: 11rem !important;
  }

  .py-xxl-24 {
    padding-top: 11.5rem !important;
    padding-bottom: 11.5rem !important;
  }

  .py-xxl-25 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }

  .py-xxl-26 {
    padding-top: 12.5rem !important;
    padding-bottom: 12.5rem !important;
  }

  .py-xxl-27 {
    padding-top: 13rem !important;
    padding-bottom: 13rem !important;
  }

  .py-xxl-28 {
    padding-top: 13.5rem !important;
    padding-bottom: 13.5rem !important;
  }

  .py-xxl-29 {
    padding-top: 14rem !important;
    padding-bottom: 14rem !important;
  }

  .py-xxl-30 {
    padding-top: 14.5rem !important;
    padding-bottom: 14.5rem !important;
  }

  .py-xxl-31 {
    padding-top: 15rem !important;
    padding-bottom: 15rem !important;
  }

  .py-xxl-32 {
    padding-top: 15.5rem !important;
    padding-bottom: 15.5rem !important;
  }

  .py-xxl-33 {
    padding-top: 16rem !important;
    padding-bottom: 16rem !important;
  }

  .py-xxl-34 {
    padding-top: 16.5rem !important;
    padding-bottom: 16.5rem !important;
  }

  .py-xxl-35 {
    padding-top: 17rem !important;
    padding-bottom: 17rem !important;
  }

  .py-xxl-36 {
    padding-top: 17.5rem !important;
    padding-bottom: 17.5rem !important;
  }

  .py-xxl-37 {
    padding-top: 18rem !important;
    padding-bottom: 18rem !important;
  }

  .py-xxl-38 {
    padding-top: 18.5rem !important;
    padding-bottom: 18.5rem !important;
  }

  .py-xxl-39 {
    padding-top: 19rem !important;
    padding-bottom: 19rem !important;
  }

  .py-xxl-40 {
    padding-top: 19.5rem !important;
    padding-bottom: 19.5rem !important;
  }

  .py-xxl-41 {
    padding-top: 20rem !important;
    padding-bottom: 20rem !important;
  }

  .py-xxl-42 {
    padding-top: 20.5rem !important;
    padding-bottom: 20.5rem !important;
  }

  .py-xxl-43 {
    padding-top: 21rem !important;
    padding-bottom: 21rem !important;
  }

  .py-xxl-44 {
    padding-top: 21.5rem !important;
    padding-bottom: 21.5rem !important;
  }

  .py-xxl-45 {
    padding-top: 22rem !important;
    padding-bottom: 22rem !important;
  }

  .py-xxl-46 {
    padding-top: 22.5rem !important;
    padding-bottom: 22.5rem !important;
  }

  .py-xxl-47 {
    padding-top: 23rem !important;
    padding-bottom: 23rem !important;
  }

  .py-xxl-48 {
    padding-top: 23.5rem !important;
    padding-bottom: 23.5rem !important;
  }

  .py-xxl-49 {
    padding-top: 24rem !important;
    padding-bottom: 24rem !important;
  }

  .py-xxl-50 {
    padding-top: 24.5rem !important;
    padding-bottom: 24.5rem !important;
  }

  .py-xxl-51 {
    padding-top: 25rem !important;
    padding-bottom: 25rem !important;
  }

  .py-xxl-52 {
    padding-top: 25.5rem !important;
    padding-bottom: 25.5rem !important;
  }

  .py-xxl-53 {
    padding-top: 26rem !important;
    padding-bottom: 26rem !important;
  }

  .py-xxl-54 {
    padding-top: 26.5rem !important;
    padding-bottom: 26.5rem !important;
  }

  .py-xxl-55 {
    padding-top: 27rem !important;
    padding-bottom: 27rem !important;
  }

  .py-xxl-56 {
    padding-top: 27.5rem !important;
    padding-bottom: 27.5rem !important;
  }

  .py-xxl-57 {
    padding-top: 28rem !important;
    padding-bottom: 28rem !important;
  }

  .py-xxl-58 {
    padding-top: 28.5rem !important;
    padding-bottom: 28.5rem !important;
  }

  .py-xxl-59 {
    padding-top: 29rem !important;
    padding-bottom: 29rem !important;
  }

  .py-xxl-60 {
    padding-top: 29.5rem !important;
    padding-bottom: 29.5rem !important;
  }

  .py-xxl-61 {
    padding-top: 30rem !important;
    padding-bottom: 30rem !important;
  }

  .py-xxl-62 {
    padding-top: 30.5rem !important;
    padding-bottom: 30.5rem !important;
  }

  .py-xxl-63 {
    padding-top: 31rem !important;
    padding-bottom: 31rem !important;
  }

  .py-xxl-64 {
    padding-top: 31.5rem !important;
    padding-bottom: 31.5rem !important;
  }

  .py-xxl-65 {
    padding-top: 32rem !important;
    padding-bottom: 32rem !important;
  }

  .py-xxl-66 {
    padding-top: 32.5rem !important;
    padding-bottom: 32.5rem !important;
  }

  .py-xxl-67 {
    padding-top: 33rem !important;
    padding-bottom: 33rem !important;
  }

  .py-xxl-68 {
    padding-top: 33.5rem !important;
    padding-bottom: 33.5rem !important;
  }

  .py-xxl-69 {
    padding-top: 34rem !important;
    padding-bottom: 34rem !important;
  }

  .py-xxl-70 {
    padding-top: 34.5rem !important;
    padding-bottom: 34.5rem !important;
  }

  .py-xxl-71 {
    padding-top: 35rem !important;
    padding-bottom: 35rem !important;
  }

  .py-xxl-72 {
    padding-top: 35.5rem !important;
    padding-bottom: 35.5rem !important;
  }

  .py-xxl-73 {
    padding-top: 36rem !important;
    padding-bottom: 36rem !important;
  }

  .py-xxl-74 {
    padding-top: 36.5rem !important;
    padding-bottom: 36.5rem !important;
  }

  .py-xxl-75 {
    padding-top: 37rem !important;
    padding-bottom: 37rem !important;
  }

  .py-xxl-76 {
    padding-top: 37.5rem !important;
    padding-bottom: 37.5rem !important;
  }

  .py-xxl-77 {
    padding-top: 38rem !important;
    padding-bottom: 38rem !important;
  }

  .py-xxl-78 {
    padding-top: 38.5rem !important;
    padding-bottom: 38.5rem !important;
  }

  .py-xxl-79 {
    padding-top: 39rem !important;
    padding-bottom: 39rem !important;
  }

  .py-xxl-80 {
    padding-top: 39.5rem !important;
    padding-bottom: 39.5rem !important;
  }

  .py-xxl-81 {
    padding-top: 40rem !important;
    padding-bottom: 40rem !important;
  }

  .py-xxl-82 {
    padding-top: 40.5rem !important;
    padding-bottom: 40.5rem !important;
  }

  .py-xxl-83 {
    padding-top: 41rem !important;
    padding-bottom: 41rem !important;
  }

  .py-xxl-84 {
    padding-top: 41.5rem !important;
    padding-bottom: 41.5rem !important;
  }

  .py-xxl-85 {
    padding-top: 42rem !important;
    padding-bottom: 42rem !important;
  }

  .py-xxl-86 {
    padding-top: 42.5rem !important;
    padding-bottom: 42.5rem !important;
  }

  .py-xxl-87 {
    padding-top: 43rem !important;
    padding-bottom: 43rem !important;
  }

  .py-xxl-88 {
    padding-top: 43.5rem !important;
    padding-bottom: 43.5rem !important;
  }

  .py-xxl-89 {
    padding-top: 44rem !important;
    padding-bottom: 44rem !important;
  }

  .py-xxl-90 {
    padding-top: 44.5rem !important;
    padding-bottom: 44.5rem !important;
  }

  .py-xxl-91 {
    padding-top: 45rem !important;
    padding-bottom: 45rem !important;
  }

  .py-xxl-92 {
    padding-top: 45.5rem !important;
    padding-bottom: 45.5rem !important;
  }

  .py-xxl-93 {
    padding-top: 46rem !important;
    padding-bottom: 46rem !important;
  }

  .py-xxl-94 {
    padding-top: 46.5rem !important;
    padding-bottom: 46.5rem !important;
  }

  .py-xxl-95 {
    padding-top: 47rem !important;
    padding-bottom: 47rem !important;
  }

  .py-xxl-96 {
    padding-top: 47.5rem !important;
    padding-bottom: 47.5rem !important;
  }

  .py-xxl-97 {
    padding-top: 48rem !important;
    padding-bottom: 48rem !important;
  }

  .py-xxl-98 {
    padding-top: 48.5rem !important;
    padding-bottom: 48.5rem !important;
  }

  .py-xxl-99 {
    padding-top: 49rem !important;
    padding-bottom: 49rem !important;
  }

  .py-xxl-100 {
    padding-top: 49.5rem !important;
    padding-bottom: 49.5rem !important;
  }

  .py-xxl-101 {
    padding-top: 50rem !important;
    padding-bottom: 50rem !important;
  }

  .py-xxl-102 {
    padding-top: 50.5rem !important;
    padding-bottom: 50.5rem !important;
  }

  .py-xxl-103 {
    padding-top: 51rem !important;
    padding-bottom: 51rem !important;
  }

  .py-xxl-104 {
    padding-top: 51.5rem !important;
    padding-bottom: 51.5rem !important;
  }

  .py-xxl-105 {
    padding-top: 52rem !important;
    padding-bottom: 52rem !important;
  }

  .py-xxl-106 {
    padding-top: 52.5rem !important;
    padding-bottom: 52.5rem !important;
  }

  .py-xxl-107 {
    padding-top: 53rem !important;
    padding-bottom: 53rem !important;
  }

  .py-xxl-108 {
    padding-top: 53.5rem !important;
    padding-bottom: 53.5rem !important;
  }

  .py-xxl-109 {
    padding-top: 54rem !important;
    padding-bottom: 54rem !important;
  }

  .py-xxl-110 {
    padding-top: 54.5rem !important;
    padding-bottom: 54.5rem !important;
  }

  .py-xxl-111 {
    padding-top: 55rem !important;
    padding-bottom: 55rem !important;
  }

  .py-xxl-112 {
    padding-top: 55.5rem !important;
    padding-bottom: 55.5rem !important;
  }

  .py-xxl-113 {
    padding-top: 56rem !important;
    padding-bottom: 56rem !important;
  }

  .py-xxl-114 {
    padding-top: 56.5rem !important;
    padding-bottom: 56.5rem !important;
  }

  .py-xxl-115 {
    padding-top: 57rem !important;
    padding-bottom: 57rem !important;
  }

  .py-xxl-116 {
    padding-top: 57.5rem !important;
    padding-bottom: 57.5rem !important;
  }

  .py-xxl-117 {
    padding-top: 58rem !important;
    padding-bottom: 58rem !important;
  }

  .py-xxl-118 {
    padding-top: 58.5rem !important;
    padding-bottom: 58.5rem !important;
  }

  .py-xxl-119 {
    padding-top: 59rem !important;
    padding-bottom: 59rem !important;
  }

  .py-xxl-120 {
    padding-top: 59.5rem !important;
    padding-bottom: 59.5rem !important;
  }

  .py-xxl-121 {
    padding-top: 60rem !important;
    padding-bottom: 60rem !important;
  }

  .py-xxl-122 {
    padding-top: 60.5rem !important;
    padding-bottom: 60.5rem !important;
  }

  .py-xxl-123 {
    padding-top: 61rem !important;
    padding-bottom: 61rem !important;
  }

  .py-xxl-124 {
    padding-top: 61.5rem !important;
    padding-bottom: 61.5rem !important;
  }

  .py-xxl-125 {
    padding-top: 62rem !important;
    padding-bottom: 62rem !important;
  }

  .py-xxl-126 {
    padding-top: 62.5rem !important;
    padding-bottom: 62.5rem !important;
  }

  .py-xxl-127 {
    padding-top: 63rem !important;
    padding-bottom: 63rem !important;
  }

  .py-xxl-128 {
    padding-top: 63.5rem !important;
    padding-bottom: 63.5rem !important;
  }

  .py-xxl-129 {
    padding-top: 64rem !important;
    padding-bottom: 64rem !important;
  }

  .py-xxl-130 {
    padding-top: 64.5rem !important;
    padding-bottom: 64.5rem !important;
  }

  .py-xxl-131 {
    padding-top: 65rem !important;
    padding-bottom: 65rem !important;
  }

  .py-xxl-132 {
    padding-top: 65.5rem !important;
    padding-bottom: 65.5rem !important;
  }

  .py-xxl-133 {
    padding-top: 66rem !important;
    padding-bottom: 66rem !important;
  }

  .py-xxl-134 {
    padding-top: 66.5rem !important;
    padding-bottom: 66.5rem !important;
  }

  .py-xxl-135 {
    padding-top: 67rem !important;
    padding-bottom: 67rem !important;
  }

  .py-xxl-136 {
    padding-top: 67.5rem !important;
    padding-bottom: 67.5rem !important;
  }

  .py-xxl-137 {
    padding-top: 68rem !important;
    padding-bottom: 68rem !important;
  }

  .py-xxl-138 {
    padding-top: 68.5rem !important;
    padding-bottom: 68.5rem !important;
  }

  .py-xxl-139 {
    padding-top: 69rem !important;
    padding-bottom: 69rem !important;
  }

  .py-xxl-140 {
    padding-top: 69.5rem !important;
    padding-bottom: 69.5rem !important;
  }

  .py-xxl-141 {
    padding-top: 70rem !important;
    padding-bottom: 70rem !important;
  }

  .py-xxl-142 {
    padding-top: 70.5rem !important;
    padding-bottom: 70.5rem !important;
  }

  .py-xxl-143 {
    padding-top: 71rem !important;
    padding-bottom: 71rem !important;
  }

  .py-xxl-144 {
    padding-top: 71.5rem !important;
    padding-bottom: 71.5rem !important;
  }

  .py-xxl-145 {
    padding-top: 72rem !important;
    padding-bottom: 72rem !important;
  }

  .py-xxl-146 {
    padding-top: 72.5rem !important;
    padding-bottom: 72.5rem !important;
  }

  .py-xxl-147 {
    padding-top: 73rem !important;
    padding-bottom: 73rem !important;
  }

  .py-xxl-148 {
    padding-top: 73.5rem !important;
    padding-bottom: 73.5rem !important;
  }

  .py-xxl-149 {
    padding-top: 74rem !important;
    padding-bottom: 74rem !important;
  }

  .py-xxl-150 {
    padding-top: 74.5rem !important;
    padding-bottom: 74.5rem !important;
  }

  .py-xxl-151 {
    padding-top: 75rem !important;
    padding-bottom: 75rem !important;
  }

  .py-xxl-152 {
    padding-top: 75.5rem !important;
    padding-bottom: 75.5rem !important;
  }

  .py-xxl-153 {
    padding-top: 76rem !important;
    padding-bottom: 76rem !important;
  }

  .py-xxl-154 {
    padding-top: 76.5rem !important;
    padding-bottom: 76.5rem !important;
  }

  .py-xxl-155 {
    padding-top: 77rem !important;
    padding-bottom: 77rem !important;
  }

  .py-xxl-156 {
    padding-top: 77.5rem !important;
    padding-bottom: 77.5rem !important;
  }

  .py-xxl-157 {
    padding-top: 78rem !important;
    padding-bottom: 78rem !important;
  }

  .py-xxl-158 {
    padding-top: 78.5rem !important;
    padding-bottom: 78.5rem !important;
  }

  .py-xxl-159 {
    padding-top: 79rem !important;
    padding-bottom: 79rem !important;
  }

  .py-xxl-160 {
    padding-top: 79.5rem !important;
    padding-bottom: 79.5rem !important;
  }
}
/*Margin*/
.m-0 {
  margin: 0rem !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 2rem !important;
}

.m-6 {
  margin: 2.5rem !important;
}

.m-7 {
  margin: 3rem !important;
}

.m-8 {
  margin: 3.5rem !important;
}

.m-9 {
  margin: 4rem !important;
}

.m-10 {
  margin: 4.5rem !important;
}

.m-11 {
  margin: 5rem !important;
}

.m-12 {
  margin: 5.5rem !important;
}

.m-13 {
  margin: 6rem !important;
}

.m-14 {
  margin: 6.5rem !important;
}

.m-15 {
  margin: 7rem !important;
}

.m-16 {
  margin: 7.5rem !important;
}

.m-17 {
  margin: 8rem !important;
}

.m-18 {
  margin: 8.5rem !important;
}

.m-19 {
  margin: 9rem !important;
}

.m-20 {
  margin: 9.5rem !important;
}

.m-21 {
  margin: 10rem !important;
}

.m-22 {
  margin: 10.5rem !important;
}

.m-23 {
  margin: 11rem !important;
}

.m-24 {
  margin: 11.5rem !important;
}

.m-25 {
  margin: 12rem !important;
}

.m-26 {
  margin: 12.5rem !important;
}

.m-27 {
  margin: 13rem !important;
}

.m-28 {
  margin: 13.5rem !important;
}

.m-29 {
  margin: 14rem !important;
}

.m-30 {
  margin: 14.5rem !important;
}

.m-31 {
  margin: 15rem !important;
}

.m-32 {
  margin: 15.5rem !important;
}

.m-33 {
  margin: 16rem !important;
}

.m-34 {
  margin: 16.5rem !important;
}

.m-35 {
  margin: 17rem !important;
}

.m-36 {
  margin: 17.5rem !important;
}

.m-37 {
  margin: 18rem !important;
}

.m-38 {
  margin: 18.5rem !important;
}

.m-39 {
  margin: 19rem !important;
}

.m-40 {
  margin: 19.5rem !important;
}

.m-41 {
  margin: 20rem !important;
}

.m-42 {
  margin: 20.5rem !important;
}

.m-43 {
  margin: 21rem !important;
}

.m-44 {
  margin: 21.5rem !important;
}

.m-45 {
  margin: 22rem !important;
}

.m-46 {
  margin: 22.5rem !important;
}

.m-47 {
  margin: 23rem !important;
}

.m-48 {
  margin: 23.5rem !important;
}

.m-49 {
  margin: 24rem !important;
}

.m-50 {
  margin: 24.5rem !important;
}

.m-51 {
  margin: 25rem !important;
}

.m-52 {
  margin: 25.5rem !important;
}

.m-53 {
  margin: 26rem !important;
}

.m-54 {
  margin: 26.5rem !important;
}

.m-55 {
  margin: 27rem !important;
}

.m-56 {
  margin: 27.5rem !important;
}

.m-57 {
  margin: 28rem !important;
}

.m-58 {
  margin: 28.5rem !important;
}

.m-59 {
  margin: 29rem !important;
}

.m-60 {
  margin: 29.5rem !important;
}

.m-61 {
  margin: 30rem !important;
}

.m-62 {
  margin: 30.5rem !important;
}

.m-63 {
  margin: 31rem !important;
}

.m-64 {
  margin: 31.5rem !important;
}

.m-65 {
  margin: 32rem !important;
}

.m-66 {
  margin: 32.5rem !important;
}

.m-67 {
  margin: 33rem !important;
}

.m-68 {
  margin: 33.5rem !important;
}

.m-69 {
  margin: 34rem !important;
}

.m-70 {
  margin: 34.5rem !important;
}

.m-71 {
  margin: 35rem !important;
}

.m-72 {
  margin: 35.5rem !important;
}

.m-73 {
  margin: 36rem !important;
}

.m-74 {
  margin: 36.5rem !important;
}

.m-75 {
  margin: 37rem !important;
}

.m-76 {
  margin: 37.5rem !important;
}

.m-77 {
  margin: 38rem !important;
}

.m-78 {
  margin: 38.5rem !important;
}

.m-79 {
  margin: 39rem !important;
}

.m-80 {
  margin: 39.5rem !important;
}

.m-81 {
  margin: 40rem !important;
}

.m-82 {
  margin: 40.5rem !important;
}

.m-83 {
  margin: 41rem !important;
}

.m-84 {
  margin: 41.5rem !important;
}

.m-85 {
  margin: 42rem !important;
}

.m-86 {
  margin: 42.5rem !important;
}

.m-87 {
  margin: 43rem !important;
}

.m-88 {
  margin: 43.5rem !important;
}

.m-89 {
  margin: 44rem !important;
}

.m-90 {
  margin: 44.5rem !important;
}

.m-91 {
  margin: 45rem !important;
}

.m-92 {
  margin: 45.5rem !important;
}

.m-93 {
  margin: 46rem !important;
}

.m-94 {
  margin: 46.5rem !important;
}

.m-95 {
  margin: 47rem !important;
}

.m-96 {
  margin: 47.5rem !important;
}

.m-97 {
  margin: 48rem !important;
}

.m-98 {
  margin: 48.5rem !important;
}

.m-99 {
  margin: 49rem !important;
}

.m-100 {
  margin: 49.5rem !important;
}

.m-101 {
  margin: 50rem !important;
}

.m-102 {
  margin: 50.5rem !important;
}

.m-103 {
  margin: 51rem !important;
}

.m-104 {
  margin: 51.5rem !important;
}

.m-105 {
  margin: 52rem !important;
}

.m-106 {
  margin: 52.5rem !important;
}

.m-107 {
  margin: 53rem !important;
}

.m-108 {
  margin: 53.5rem !important;
}

.m-109 {
  margin: 54rem !important;
}

.m-110 {
  margin: 54.5rem !important;
}

.m-111 {
  margin: 55rem !important;
}

.m-112 {
  margin: 55.5rem !important;
}

.m-113 {
  margin: 56rem !important;
}

.m-114 {
  margin: 56.5rem !important;
}

.m-115 {
  margin: 57rem !important;
}

.m-116 {
  margin: 57.5rem !important;
}

.m-117 {
  margin: 58rem !important;
}

.m-118 {
  margin: 58.5rem !important;
}

.m-119 {
  margin: 59rem !important;
}

.m-120 {
  margin: 59.5rem !important;
}

.m-121 {
  margin: 60rem !important;
}

.m-122 {
  margin: 60.5rem !important;
}

.m-123 {
  margin: 61rem !important;
}

.m-124 {
  margin: 61.5rem !important;
}

.m-125 {
  margin: 62rem !important;
}

.m-126 {
  margin: 62.5rem !important;
}

.m-127 {
  margin: 63rem !important;
}

.m-128 {
  margin: 63.5rem !important;
}

.m-129 {
  margin: 64rem !important;
}

.m-130 {
  margin: 64.5rem !important;
}

.m-131 {
  margin: 65rem !important;
}

.m-132 {
  margin: 65.5rem !important;
}

.m-133 {
  margin: 66rem !important;
}

.m-134 {
  margin: 66.5rem !important;
}

.m-135 {
  margin: 67rem !important;
}

.m-136 {
  margin: 67.5rem !important;
}

.m-137 {
  margin: 68rem !important;
}

.m-138 {
  margin: 68.5rem !important;
}

.m-139 {
  margin: 69rem !important;
}

.m-140 {
  margin: 69.5rem !important;
}

.m-141 {
  margin: 70rem !important;
}

.m-142 {
  margin: 70.5rem !important;
}

.m-143 {
  margin: 71rem !important;
}

.m-144 {
  margin: 71.5rem !important;
}

.m-145 {
  margin: 72rem !important;
}

.m-146 {
  margin: 72.5rem !important;
}

.m-147 {
  margin: 73rem !important;
}

.m-148 {
  margin: 73.5rem !important;
}

.m-149 {
  margin: 74rem !important;
}

.m-150 {
  margin: 74.5rem !important;
}

.m-151 {
  margin: 75rem !important;
}

.m-152 {
  margin: 75.5rem !important;
}

.m-153 {
  margin: 76rem !important;
}

.m-154 {
  margin: 76.5rem !important;
}

.m-155 {
  margin: 77rem !important;
}

.m-156 {
  margin: 77.5rem !important;
}

.m-157 {
  margin: 78rem !important;
}

.m-158 {
  margin: 78.5rem !important;
}

.m-159 {
  margin: 79rem !important;
}

.m-160 {
  margin: 79.5rem !important;
}

.mt-0 {
  margin-top: 0rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 2rem !important;
}

.mt-6 {
  margin-top: 2.5rem !important;
}

.mt-7 {
  margin-top: 3rem !important;
}

.mt-8 {
  margin-top: 3.5rem !important;
}

.mt-9 {
  margin-top: 4rem !important;
}

.mt-10 {
  margin-top: 4.5rem !important;
}

.mt-11 {
  margin-top: 5rem !important;
}

.mt-12 {
  margin-top: 5.5rem !important;
}

.mt-13 {
  margin-top: 6rem !important;
}

.mt-14 {
  margin-top: 6.5rem !important;
}

.mt-15 {
  margin-top: 7rem !important;
}

.mt-16 {
  margin-top: 7.5rem !important;
}

.mt-17 {
  margin-top: 8rem !important;
}

.mt-18 {
  margin-top: 8.5rem !important;
}

.mt-19 {
  margin-top: 9rem !important;
}

.mt-20 {
  margin-top: 9.5rem !important;
}

.mt-21 {
  margin-top: 10rem !important;
}

.mt-22 {
  margin-top: 10.5rem !important;
}

.mt-23 {
  margin-top: 11rem !important;
}

.mt-24 {
  margin-top: 11.5rem !important;
}

.mt-25 {
  margin-top: 12rem !important;
}

.mt-26 {
  margin-top: 12.5rem !important;
}

.mt-27 {
  margin-top: 13rem !important;
}

.mt-28 {
  margin-top: 13.5rem !important;
}

.mt-29 {
  margin-top: 14rem !important;
}

.mt-30 {
  margin-top: 14.5rem !important;
}

.mt-31 {
  margin-top: 15rem !important;
}

.mt-32 {
  margin-top: 15.5rem !important;
}

.mt-33 {
  margin-top: 16rem !important;
}

.mt-34 {
  margin-top: 16.5rem !important;
}

.mt-35 {
  margin-top: 17rem !important;
}

.mt-36 {
  margin-top: 17.5rem !important;
}

.mt-37 {
  margin-top: 18rem !important;
}

.mt-38 {
  margin-top: 18.5rem !important;
}

.mt-39 {
  margin-top: 19rem !important;
}

.mt-40 {
  margin-top: 19.5rem !important;
}

.mt-41 {
  margin-top: 20rem !important;
}

.mt-42 {
  margin-top: 20.5rem !important;
}

.mt-43 {
  margin-top: 21rem !important;
}

.mt-44 {
  margin-top: 21.5rem !important;
}

.mt-45 {
  margin-top: 22rem !important;
}

.mt-46 {
  margin-top: 22.5rem !important;
}

.mt-47 {
  margin-top: 23rem !important;
}

.mt-48 {
  margin-top: 23.5rem !important;
}

.mt-49 {
  margin-top: 24rem !important;
}

.mt-50 {
  margin-top: 24.5rem !important;
}

.mt-51 {
  margin-top: 25rem !important;
}

.mt-52 {
  margin-top: 25.5rem !important;
}

.mt-53 {
  margin-top: 26rem !important;
}

.mt-54 {
  margin-top: 26.5rem !important;
}

.mt-55 {
  margin-top: 27rem !important;
}

.mt-56 {
  margin-top: 27.5rem !important;
}

.mt-57 {
  margin-top: 28rem !important;
}

.mt-58 {
  margin-top: 28.5rem !important;
}

.mt-59 {
  margin-top: 29rem !important;
}

.mt-60 {
  margin-top: 29.5rem !important;
}

.mt-61 {
  margin-top: 30rem !important;
}

.mt-62 {
  margin-top: 30.5rem !important;
}

.mt-63 {
  margin-top: 31rem !important;
}

.mt-64 {
  margin-top: 31.5rem !important;
}

.mt-65 {
  margin-top: 32rem !important;
}

.mt-66 {
  margin-top: 32.5rem !important;
}

.mt-67 {
  margin-top: 33rem !important;
}

.mt-68 {
  margin-top: 33.5rem !important;
}

.mt-69 {
  margin-top: 34rem !important;
}

.mt-70 {
  margin-top: 34.5rem !important;
}

.mt-71 {
  margin-top: 35rem !important;
}

.mt-72 {
  margin-top: 35.5rem !important;
}

.mt-73 {
  margin-top: 36rem !important;
}

.mt-74 {
  margin-top: 36.5rem !important;
}

.mt-75 {
  margin-top: 37rem !important;
}

.mt-76 {
  margin-top: 37.5rem !important;
}

.mt-77 {
  margin-top: 38rem !important;
}

.mt-78 {
  margin-top: 38.5rem !important;
}

.mt-79 {
  margin-top: 39rem !important;
}

.mt-80 {
  margin-top: 39.5rem !important;
}

.mt-81 {
  margin-top: 40rem !important;
}

.mt-82 {
  margin-top: 40.5rem !important;
}

.mt-83 {
  margin-top: 41rem !important;
}

.mt-84 {
  margin-top: 41.5rem !important;
}

.mt-85 {
  margin-top: 42rem !important;
}

.mt-86 {
  margin-top: 42.5rem !important;
}

.mt-87 {
  margin-top: 43rem !important;
}

.mt-88 {
  margin-top: 43.5rem !important;
}

.mt-89 {
  margin-top: 44rem !important;
}

.mt-90 {
  margin-top: 44.5rem !important;
}

.mt-91 {
  margin-top: 45rem !important;
}

.mt-92 {
  margin-top: 45.5rem !important;
}

.mt-93 {
  margin-top: 46rem !important;
}

.mt-94 {
  margin-top: 46.5rem !important;
}

.mt-95 {
  margin-top: 47rem !important;
}

.mt-96 {
  margin-top: 47.5rem !important;
}

.mt-97 {
  margin-top: 48rem !important;
}

.mt-98 {
  margin-top: 48.5rem !important;
}

.mt-99 {
  margin-top: 49rem !important;
}

.mt-100 {
  margin-top: 49.5rem !important;
}

.mt-101 {
  margin-top: 50rem !important;
}

.mt-102 {
  margin-top: 50.5rem !important;
}

.mt-103 {
  margin-top: 51rem !important;
}

.mt-104 {
  margin-top: 51.5rem !important;
}

.mt-105 {
  margin-top: 52rem !important;
}

.mt-106 {
  margin-top: 52.5rem !important;
}

.mt-107 {
  margin-top: 53rem !important;
}

.mt-108 {
  margin-top: 53.5rem !important;
}

.mt-109 {
  margin-top: 54rem !important;
}

.mt-110 {
  margin-top: 54.5rem !important;
}

.mt-111 {
  margin-top: 55rem !important;
}

.mt-112 {
  margin-top: 55.5rem !important;
}

.mt-113 {
  margin-top: 56rem !important;
}

.mt-114 {
  margin-top: 56.5rem !important;
}

.mt-115 {
  margin-top: 57rem !important;
}

.mt-116 {
  margin-top: 57.5rem !important;
}

.mt-117 {
  margin-top: 58rem !important;
}

.mt-118 {
  margin-top: 58.5rem !important;
}

.mt-119 {
  margin-top: 59rem !important;
}

.mt-120 {
  margin-top: 59.5rem !important;
}

.mt-121 {
  margin-top: 60rem !important;
}

.mt-122 {
  margin-top: 60.5rem !important;
}

.mt-123 {
  margin-top: 61rem !important;
}

.mt-124 {
  margin-top: 61.5rem !important;
}

.mt-125 {
  margin-top: 62rem !important;
}

.mt-126 {
  margin-top: 62.5rem !important;
}

.mt-127 {
  margin-top: 63rem !important;
}

.mt-128 {
  margin-top: 63.5rem !important;
}

.mt-129 {
  margin-top: 64rem !important;
}

.mt-130 {
  margin-top: 64.5rem !important;
}

.mt-131 {
  margin-top: 65rem !important;
}

.mt-132 {
  margin-top: 65.5rem !important;
}

.mt-133 {
  margin-top: 66rem !important;
}

.mt-134 {
  margin-top: 66.5rem !important;
}

.mt-135 {
  margin-top: 67rem !important;
}

.mt-136 {
  margin-top: 67.5rem !important;
}

.mt-137 {
  margin-top: 68rem !important;
}

.mt-138 {
  margin-top: 68.5rem !important;
}

.mt-139 {
  margin-top: 69rem !important;
}

.mt-140 {
  margin-top: 69.5rem !important;
}

.mt-141 {
  margin-top: 70rem !important;
}

.mt-142 {
  margin-top: 70.5rem !important;
}

.mt-143 {
  margin-top: 71rem !important;
}

.mt-144 {
  margin-top: 71.5rem !important;
}

.mt-145 {
  margin-top: 72rem !important;
}

.mt-146 {
  margin-top: 72.5rem !important;
}

.mt-147 {
  margin-top: 73rem !important;
}

.mt-148 {
  margin-top: 73.5rem !important;
}

.mt-149 {
  margin-top: 74rem !important;
}

.mt-150 {
  margin-top: 74.5rem !important;
}

.mt-151 {
  margin-top: 75rem !important;
}

.mt-152 {
  margin-top: 75.5rem !important;
}

.mt-153 {
  margin-top: 76rem !important;
}

.mt-154 {
  margin-top: 76.5rem !important;
}

.mt-155 {
  margin-top: 77rem !important;
}

.mt-156 {
  margin-top: 77.5rem !important;
}

.mt-157 {
  margin-top: 78rem !important;
}

.mt-158 {
  margin-top: 78.5rem !important;
}

.mt-159 {
  margin-top: 79rem !important;
}

.mt-160 {
  margin-top: 79.5rem !important;
}

.mb-0 {
  margin-bottom: 0rem !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 2rem !important;
}

.mb-6 {
  margin-bottom: 2.5rem !important;
}

.mb-7 {
  margin-bottom: 3rem !important;
}

.mb-8 {
  margin-bottom: 3.5rem !important;
}

.mb-9 {
  margin-bottom: 4rem !important;
}

.mb-10 {
  margin-bottom: 4.5rem !important;
}

.mb-11 {
  margin-bottom: 5rem !important;
}

.mb-12 {
  margin-bottom: 5.5rem !important;
}

.mb-13 {
  margin-bottom: 6rem !important;
}

.mb-14 {
  margin-bottom: 6.5rem !important;
}

.mb-15 {
  margin-bottom: 7rem !important;
}

.mb-16 {
  margin-bottom: 7.5rem !important;
}

.mb-17 {
  margin-bottom: 8rem !important;
}

.mb-18 {
  margin-bottom: 8.5rem !important;
}

.mb-19 {
  margin-bottom: 9rem !important;
}

.mb-20 {
  margin-bottom: 9.5rem !important;
}

.mb-21 {
  margin-bottom: 10rem !important;
}

.mb-22 {
  margin-bottom: 10.5rem !important;
}

.mb-23 {
  margin-bottom: 11rem !important;
}

.mb-24 {
  margin-bottom: 11.5rem !important;
}

.mb-25 {
  margin-bottom: 12rem !important;
}

.mb-26 {
  margin-bottom: 12.5rem !important;
}

.mb-27 {
  margin-bottom: 13rem !important;
}

.mb-28 {
  margin-bottom: 13.5rem !important;
}

.mb-29 {
  margin-bottom: 14rem !important;
}

.mb-30 {
  margin-bottom: 14.5rem !important;
}

.mb-31 {
  margin-bottom: 15rem !important;
}

.mb-32 {
  margin-bottom: 15.5rem !important;
}

.mb-33 {
  margin-bottom: 16rem !important;
}

.mb-34 {
  margin-bottom: 16.5rem !important;
}

.mb-35 {
  margin-bottom: 17rem !important;
}

.mb-36 {
  margin-bottom: 17.5rem !important;
}

.mb-37 {
  margin-bottom: 18rem !important;
}

.mb-38 {
  margin-bottom: 18.5rem !important;
}

.mb-39 {
  margin-bottom: 19rem !important;
}

.mb-40 {
  margin-bottom: 19.5rem !important;
}

.mb-41 {
  margin-bottom: 20rem !important;
}

.mb-42 {
  margin-bottom: 20.5rem !important;
}

.mb-43 {
  margin-bottom: 21rem !important;
}

.mb-44 {
  margin-bottom: 21.5rem !important;
}

.mb-45 {
  margin-bottom: 22rem !important;
}

.mb-46 {
  margin-bottom: 22.5rem !important;
}

.mb-47 {
  margin-bottom: 23rem !important;
}

.mb-48 {
  margin-bottom: 23.5rem !important;
}

.mb-49 {
  margin-bottom: 24rem !important;
}

.mb-50 {
  margin-bottom: 24.5rem !important;
}

.mb-51 {
  margin-bottom: 25rem !important;
}

.mb-52 {
  margin-bottom: 25.5rem !important;
}

.mb-53 {
  margin-bottom: 26rem !important;
}

.mb-54 {
  margin-bottom: 26.5rem !important;
}

.mb-55 {
  margin-bottom: 27rem !important;
}

.mb-56 {
  margin-bottom: 27.5rem !important;
}

.mb-57 {
  margin-bottom: 28rem !important;
}

.mb-58 {
  margin-bottom: 28.5rem !important;
}

.mb-59 {
  margin-bottom: 29rem !important;
}

.mb-60 {
  margin-bottom: 29.5rem !important;
}

.mb-61 {
  margin-bottom: 30rem !important;
}

.mb-62 {
  margin-bottom: 30.5rem !important;
}

.mb-63 {
  margin-bottom: 31rem !important;
}

.mb-64 {
  margin-bottom: 31.5rem !important;
}

.mb-65 {
  margin-bottom: 32rem !important;
}

.mb-66 {
  margin-bottom: 32.5rem !important;
}

.mb-67 {
  margin-bottom: 33rem !important;
}

.mb-68 {
  margin-bottom: 33.5rem !important;
}

.mb-69 {
  margin-bottom: 34rem !important;
}

.mb-70 {
  margin-bottom: 34.5rem !important;
}

.mb-71 {
  margin-bottom: 35rem !important;
}

.mb-72 {
  margin-bottom: 35.5rem !important;
}

.mb-73 {
  margin-bottom: 36rem !important;
}

.mb-74 {
  margin-bottom: 36.5rem !important;
}

.mb-75 {
  margin-bottom: 37rem !important;
}

.mb-76 {
  margin-bottom: 37.5rem !important;
}

.mb-77 {
  margin-bottom: 38rem !important;
}

.mb-78 {
  margin-bottom: 38.5rem !important;
}

.mb-79 {
  margin-bottom: 39rem !important;
}

.mb-80 {
  margin-bottom: 39.5rem !important;
}

.mb-81 {
  margin-bottom: 40rem !important;
}

.mb-82 {
  margin-bottom: 40.5rem !important;
}

.mb-83 {
  margin-bottom: 41rem !important;
}

.mb-84 {
  margin-bottom: 41.5rem !important;
}

.mb-85 {
  margin-bottom: 42rem !important;
}

.mb-86 {
  margin-bottom: 42.5rem !important;
}

.mb-87 {
  margin-bottom: 43rem !important;
}

.mb-88 {
  margin-bottom: 43.5rem !important;
}

.mb-89 {
  margin-bottom: 44rem !important;
}

.mb-90 {
  margin-bottom: 44.5rem !important;
}

.mb-91 {
  margin-bottom: 45rem !important;
}

.mb-92 {
  margin-bottom: 45.5rem !important;
}

.mb-93 {
  margin-bottom: 46rem !important;
}

.mb-94 {
  margin-bottom: 46.5rem !important;
}

.mb-95 {
  margin-bottom: 47rem !important;
}

.mb-96 {
  margin-bottom: 47.5rem !important;
}

.mb-97 {
  margin-bottom: 48rem !important;
}

.mb-98 {
  margin-bottom: 48.5rem !important;
}

.mb-99 {
  margin-bottom: 49rem !important;
}

.mb-100 {
  margin-bottom: 49.5rem !important;
}

.mb-101 {
  margin-bottom: 50rem !important;
}

.mb-102 {
  margin-bottom: 50.5rem !important;
}

.mb-103 {
  margin-bottom: 51rem !important;
}

.mb-104 {
  margin-bottom: 51.5rem !important;
}

.mb-105 {
  margin-bottom: 52rem !important;
}

.mb-106 {
  margin-bottom: 52.5rem !important;
}

.mb-107 {
  margin-bottom: 53rem !important;
}

.mb-108 {
  margin-bottom: 53.5rem !important;
}

.mb-109 {
  margin-bottom: 54rem !important;
}

.mb-110 {
  margin-bottom: 54.5rem !important;
}

.mb-111 {
  margin-bottom: 55rem !important;
}

.mb-112 {
  margin-bottom: 55.5rem !important;
}

.mb-113 {
  margin-bottom: 56rem !important;
}

.mb-114 {
  margin-bottom: 56.5rem !important;
}

.mb-115 {
  margin-bottom: 57rem !important;
}

.mb-116 {
  margin-bottom: 57.5rem !important;
}

.mb-117 {
  margin-bottom: 58rem !important;
}

.mb-118 {
  margin-bottom: 58.5rem !important;
}

.mb-119 {
  margin-bottom: 59rem !important;
}

.mb-120 {
  margin-bottom: 59.5rem !important;
}

.mb-121 {
  margin-bottom: 60rem !important;
}

.mb-122 {
  margin-bottom: 60.5rem !important;
}

.mb-123 {
  margin-bottom: 61rem !important;
}

.mb-124 {
  margin-bottom: 61.5rem !important;
}

.mb-125 {
  margin-bottom: 62rem !important;
}

.mb-126 {
  margin-bottom: 62.5rem !important;
}

.mb-127 {
  margin-bottom: 63rem !important;
}

.mb-128 {
  margin-bottom: 63.5rem !important;
}

.mb-129 {
  margin-bottom: 64rem !important;
}

.mb-130 {
  margin-bottom: 64.5rem !important;
}

.mb-131 {
  margin-bottom: 65rem !important;
}

.mb-132 {
  margin-bottom: 65.5rem !important;
}

.mb-133 {
  margin-bottom: 66rem !important;
}

.mb-134 {
  margin-bottom: 66.5rem !important;
}

.mb-135 {
  margin-bottom: 67rem !important;
}

.mb-136 {
  margin-bottom: 67.5rem !important;
}

.mb-137 {
  margin-bottom: 68rem !important;
}

.mb-138 {
  margin-bottom: 68.5rem !important;
}

.mb-139 {
  margin-bottom: 69rem !important;
}

.mb-140 {
  margin-bottom: 69.5rem !important;
}

.mb-141 {
  margin-bottom: 70rem !important;
}

.mb-142 {
  margin-bottom: 70.5rem !important;
}

.mb-143 {
  margin-bottom: 71rem !important;
}

.mb-144 {
  margin-bottom: 71.5rem !important;
}

.mb-145 {
  margin-bottom: 72rem !important;
}

.mb-146 {
  margin-bottom: 72.5rem !important;
}

.mb-147 {
  margin-bottom: 73rem !important;
}

.mb-148 {
  margin-bottom: 73.5rem !important;
}

.mb-149 {
  margin-bottom: 74rem !important;
}

.mb-150 {
  margin-bottom: 74.5rem !important;
}

.mb-151 {
  margin-bottom: 75rem !important;
}

.mb-152 {
  margin-bottom: 75.5rem !important;
}

.mb-153 {
  margin-bottom: 76rem !important;
}

.mb-154 {
  margin-bottom: 76.5rem !important;
}

.mb-155 {
  margin-bottom: 77rem !important;
}

.mb-156 {
  margin-bottom: 77.5rem !important;
}

.mb-157 {
  margin-bottom: 78rem !important;
}

.mb-158 {
  margin-bottom: 78.5rem !important;
}

.mb-159 {
  margin-bottom: 79rem !important;
}

.mb-160 {
  margin-bottom: 79.5rem !important;
}

.ms-0 {
  margin-left: 0rem !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 2rem !important;
}

.ms-6 {
  margin-left: 2.5rem !important;
}

.ms-7 {
  margin-left: 3rem !important;
}

.ms-8 {
  margin-left: 3.5rem !important;
}

.ms-9 {
  margin-left: 4rem !important;
}

.ms-10 {
  margin-left: 4.5rem !important;
}

.ms-11 {
  margin-left: 5rem !important;
}

.ms-12 {
  margin-left: 5.5rem !important;
}

.ms-13 {
  margin-left: 6rem !important;
}

.ms-14 {
  margin-left: 6.5rem !important;
}

.ms-15 {
  margin-left: 7rem !important;
}

.ms-16 {
  margin-left: 7.5rem !important;
}

.ms-17 {
  margin-left: 8rem !important;
}

.ms-18 {
  margin-left: 8.5rem !important;
}

.ms-19 {
  margin-left: 9rem !important;
}

.ms-20 {
  margin-left: 9.5rem !important;
}

.ms-21 {
  margin-left: 10rem !important;
}

.ms-22 {
  margin-left: 10.5rem !important;
}

.ms-23 {
  margin-left: 11rem !important;
}

.ms-24 {
  margin-left: 11.5rem !important;
}

.ms-25 {
  margin-left: 12rem !important;
}

.ms-26 {
  margin-left: 12.5rem !important;
}

.ms-27 {
  margin-left: 13rem !important;
}

.ms-28 {
  margin-left: 13.5rem !important;
}

.ms-29 {
  margin-left: 14rem !important;
}

.ms-30 {
  margin-left: 14.5rem !important;
}

.ms-31 {
  margin-left: 15rem !important;
}

.ms-32 {
  margin-left: 15.5rem !important;
}

.ms-33 {
  margin-left: 16rem !important;
}

.ms-34 {
  margin-left: 16.5rem !important;
}

.ms-35 {
  margin-left: 17rem !important;
}

.ms-36 {
  margin-left: 17.5rem !important;
}

.ms-37 {
  margin-left: 18rem !important;
}

.ms-38 {
  margin-left: 18.5rem !important;
}

.ms-39 {
  margin-left: 19rem !important;
}

.ms-40 {
  margin-left: 19.5rem !important;
}

.ms-41 {
  margin-left: 20rem !important;
}

.ms-42 {
  margin-left: 20.5rem !important;
}

.ms-43 {
  margin-left: 21rem !important;
}

.ms-44 {
  margin-left: 21.5rem !important;
}

.ms-45 {
  margin-left: 22rem !important;
}

.ms-46 {
  margin-left: 22.5rem !important;
}

.ms-47 {
  margin-left: 23rem !important;
}

.ms-48 {
  margin-left: 23.5rem !important;
}

.ms-49 {
  margin-left: 24rem !important;
}

.ms-50 {
  margin-left: 24.5rem !important;
}

.ms-51 {
  margin-left: 25rem !important;
}

.ms-52 {
  margin-left: 25.5rem !important;
}

.ms-53 {
  margin-left: 26rem !important;
}

.ms-54 {
  margin-left: 26.5rem !important;
}

.ms-55 {
  margin-left: 27rem !important;
}

.ms-56 {
  margin-left: 27.5rem !important;
}

.ms-57 {
  margin-left: 28rem !important;
}

.ms-58 {
  margin-left: 28.5rem !important;
}

.ms-59 {
  margin-left: 29rem !important;
}

.ms-60 {
  margin-left: 29.5rem !important;
}

.ms-61 {
  margin-left: 30rem !important;
}

.ms-62 {
  margin-left: 30.5rem !important;
}

.ms-63 {
  margin-left: 31rem !important;
}

.ms-64 {
  margin-left: 31.5rem !important;
}

.ms-65 {
  margin-left: 32rem !important;
}

.ms-66 {
  margin-left: 32.5rem !important;
}

.ms-67 {
  margin-left: 33rem !important;
}

.ms-68 {
  margin-left: 33.5rem !important;
}

.ms-69 {
  margin-left: 34rem !important;
}

.ms-70 {
  margin-left: 34.5rem !important;
}

.ms-71 {
  margin-left: 35rem !important;
}

.ms-72 {
  margin-left: 35.5rem !important;
}

.ms-73 {
  margin-left: 36rem !important;
}

.ms-74 {
  margin-left: 36.5rem !important;
}

.ms-75 {
  margin-left: 37rem !important;
}

.ms-76 {
  margin-left: 37.5rem !important;
}

.ms-77 {
  margin-left: 38rem !important;
}

.ms-78 {
  margin-left: 38.5rem !important;
}

.ms-79 {
  margin-left: 39rem !important;
}

.ms-80 {
  margin-left: 39.5rem !important;
}

.ms-81 {
  margin-left: 40rem !important;
}

.ms-82 {
  margin-left: 40.5rem !important;
}

.ms-83 {
  margin-left: 41rem !important;
}

.ms-84 {
  margin-left: 41.5rem !important;
}

.ms-85 {
  margin-left: 42rem !important;
}

.ms-86 {
  margin-left: 42.5rem !important;
}

.ms-87 {
  margin-left: 43rem !important;
}

.ms-88 {
  margin-left: 43.5rem !important;
}

.ms-89 {
  margin-left: 44rem !important;
}

.ms-90 {
  margin-left: 44.5rem !important;
}

.ms-91 {
  margin-left: 45rem !important;
}

.ms-92 {
  margin-left: 45.5rem !important;
}

.ms-93 {
  margin-left: 46rem !important;
}

.ms-94 {
  margin-left: 46.5rem !important;
}

.ms-95 {
  margin-left: 47rem !important;
}

.ms-96 {
  margin-left: 47.5rem !important;
}

.ms-97 {
  margin-left: 48rem !important;
}

.ms-98 {
  margin-left: 48.5rem !important;
}

.ms-99 {
  margin-left: 49rem !important;
}

.ms-100 {
  margin-left: 49.5rem !important;
}

.ms-101 {
  margin-left: 50rem !important;
}

.ms-102 {
  margin-left: 50.5rem !important;
}

.ms-103 {
  margin-left: 51rem !important;
}

.ms-104 {
  margin-left: 51.5rem !important;
}

.ms-105 {
  margin-left: 52rem !important;
}

.ms-106 {
  margin-left: 52.5rem !important;
}

.ms-107 {
  margin-left: 53rem !important;
}

.ms-108 {
  margin-left: 53.5rem !important;
}

.ms-109 {
  margin-left: 54rem !important;
}

.ms-110 {
  margin-left: 54.5rem !important;
}

.ms-111 {
  margin-left: 55rem !important;
}

.ms-112 {
  margin-left: 55.5rem !important;
}

.ms-113 {
  margin-left: 56rem !important;
}

.ms-114 {
  margin-left: 56.5rem !important;
}

.ms-115 {
  margin-left: 57rem !important;
}

.ms-116 {
  margin-left: 57.5rem !important;
}

.ms-117 {
  margin-left: 58rem !important;
}

.ms-118 {
  margin-left: 58.5rem !important;
}

.ms-119 {
  margin-left: 59rem !important;
}

.ms-120 {
  margin-left: 59.5rem !important;
}

.ms-121 {
  margin-left: 60rem !important;
}

.ms-122 {
  margin-left: 60.5rem !important;
}

.ms-123 {
  margin-left: 61rem !important;
}

.ms-124 {
  margin-left: 61.5rem !important;
}

.ms-125 {
  margin-left: 62rem !important;
}

.ms-126 {
  margin-left: 62.5rem !important;
}

.ms-127 {
  margin-left: 63rem !important;
}

.ms-128 {
  margin-left: 63.5rem !important;
}

.ms-129 {
  margin-left: 64rem !important;
}

.ms-130 {
  margin-left: 64.5rem !important;
}

.ms-131 {
  margin-left: 65rem !important;
}

.ms-132 {
  margin-left: 65.5rem !important;
}

.ms-133 {
  margin-left: 66rem !important;
}

.ms-134 {
  margin-left: 66.5rem !important;
}

.ms-135 {
  margin-left: 67rem !important;
}

.ms-136 {
  margin-left: 67.5rem !important;
}

.ms-137 {
  margin-left: 68rem !important;
}

.ms-138 {
  margin-left: 68.5rem !important;
}

.ms-139 {
  margin-left: 69rem !important;
}

.ms-140 {
  margin-left: 69.5rem !important;
}

.ms-141 {
  margin-left: 70rem !important;
}

.ms-142 {
  margin-left: 70.5rem !important;
}

.ms-143 {
  margin-left: 71rem !important;
}

.ms-144 {
  margin-left: 71.5rem !important;
}

.ms-145 {
  margin-left: 72rem !important;
}

.ms-146 {
  margin-left: 72.5rem !important;
}

.ms-147 {
  margin-left: 73rem !important;
}

.ms-148 {
  margin-left: 73.5rem !important;
}

.ms-149 {
  margin-left: 74rem !important;
}

.ms-150 {
  margin-left: 74.5rem !important;
}

.ms-151 {
  margin-left: 75rem !important;
}

.ms-152 {
  margin-left: 75.5rem !important;
}

.ms-153 {
  margin-left: 76rem !important;
}

.ms-154 {
  margin-left: 76.5rem !important;
}

.ms-155 {
  margin-left: 77rem !important;
}

.ms-156 {
  margin-left: 77.5rem !important;
}

.ms-157 {
  margin-left: 78rem !important;
}

.ms-158 {
  margin-left: 78.5rem !important;
}

.ms-159 {
  margin-left: 79rem !important;
}

.ms-160 {
  margin-left: 79.5rem !important;
}

.me-0 {
  margin-right: 0rem !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 2rem !important;
}

.me-6 {
  margin-right: 2.5rem !important;
}

.me-7 {
  margin-right: 3rem !important;
}

.me-8 {
  margin-right: 3.5rem !important;
}

.me-9 {
  margin-right: 4rem !important;
}

.me-10 {
  margin-right: 4.5rem !important;
}

.me-11 {
  margin-right: 5rem !important;
}

.me-12 {
  margin-right: 5.5rem !important;
}

.me-13 {
  margin-right: 6rem !important;
}

.me-14 {
  margin-right: 6.5rem !important;
}

.me-15 {
  margin-right: 7rem !important;
}

.me-16 {
  margin-right: 7.5rem !important;
}

.me-17 {
  margin-right: 8rem !important;
}

.me-18 {
  margin-right: 8.5rem !important;
}

.me-19 {
  margin-right: 9rem !important;
}

.me-20 {
  margin-right: 9.5rem !important;
}

.me-21 {
  margin-right: 10rem !important;
}

.me-22 {
  margin-right: 10.5rem !important;
}

.me-23 {
  margin-right: 11rem !important;
}

.me-24 {
  margin-right: 11.5rem !important;
}

.me-25 {
  margin-right: 12rem !important;
}

.me-26 {
  margin-right: 12.5rem !important;
}

.me-27 {
  margin-right: 13rem !important;
}

.me-28 {
  margin-right: 13.5rem !important;
}

.me-29 {
  margin-right: 14rem !important;
}

.me-30 {
  margin-right: 14.5rem !important;
}

.me-31 {
  margin-right: 15rem !important;
}

.me-32 {
  margin-right: 15.5rem !important;
}

.me-33 {
  margin-right: 16rem !important;
}

.me-34 {
  margin-right: 16.5rem !important;
}

.me-35 {
  margin-right: 17rem !important;
}

.me-36 {
  margin-right: 17.5rem !important;
}

.me-37 {
  margin-right: 18rem !important;
}

.me-38 {
  margin-right: 18.5rem !important;
}

.me-39 {
  margin-right: 19rem !important;
}

.me-40 {
  margin-right: 19.5rem !important;
}

.me-41 {
  margin-right: 20rem !important;
}

.me-42 {
  margin-right: 20.5rem !important;
}

.me-43 {
  margin-right: 21rem !important;
}

.me-44 {
  margin-right: 21.5rem !important;
}

.me-45 {
  margin-right: 22rem !important;
}

.me-46 {
  margin-right: 22.5rem !important;
}

.me-47 {
  margin-right: 23rem !important;
}

.me-48 {
  margin-right: 23.5rem !important;
}

.me-49 {
  margin-right: 24rem !important;
}

.me-50 {
  margin-right: 24.5rem !important;
}

.me-51 {
  margin-right: 25rem !important;
}

.me-52 {
  margin-right: 25.5rem !important;
}

.me-53 {
  margin-right: 26rem !important;
}

.me-54 {
  margin-right: 26.5rem !important;
}

.me-55 {
  margin-right: 27rem !important;
}

.me-56 {
  margin-right: 27.5rem !important;
}

.me-57 {
  margin-right: 28rem !important;
}

.me-58 {
  margin-right: 28.5rem !important;
}

.me-59 {
  margin-right: 29rem !important;
}

.me-60 {
  margin-right: 29.5rem !important;
}

.me-61 {
  margin-right: 30rem !important;
}

.me-62 {
  margin-right: 30.5rem !important;
}

.me-63 {
  margin-right: 31rem !important;
}

.me-64 {
  margin-right: 31.5rem !important;
}

.me-65 {
  margin-right: 32rem !important;
}

.me-66 {
  margin-right: 32.5rem !important;
}

.me-67 {
  margin-right: 33rem !important;
}

.me-68 {
  margin-right: 33.5rem !important;
}

.me-69 {
  margin-right: 34rem !important;
}

.me-70 {
  margin-right: 34.5rem !important;
}

.me-71 {
  margin-right: 35rem !important;
}

.me-72 {
  margin-right: 35.5rem !important;
}

.me-73 {
  margin-right: 36rem !important;
}

.me-74 {
  margin-right: 36.5rem !important;
}

.me-75 {
  margin-right: 37rem !important;
}

.me-76 {
  margin-right: 37.5rem !important;
}

.me-77 {
  margin-right: 38rem !important;
}

.me-78 {
  margin-right: 38.5rem !important;
}

.me-79 {
  margin-right: 39rem !important;
}

.me-80 {
  margin-right: 39.5rem !important;
}

.me-81 {
  margin-right: 40rem !important;
}

.me-82 {
  margin-right: 40.5rem !important;
}

.me-83 {
  margin-right: 41rem !important;
}

.me-84 {
  margin-right: 41.5rem !important;
}

.me-85 {
  margin-right: 42rem !important;
}

.me-86 {
  margin-right: 42.5rem !important;
}

.me-87 {
  margin-right: 43rem !important;
}

.me-88 {
  margin-right: 43.5rem !important;
}

.me-89 {
  margin-right: 44rem !important;
}

.me-90 {
  margin-right: 44.5rem !important;
}

.me-91 {
  margin-right: 45rem !important;
}

.me-92 {
  margin-right: 45.5rem !important;
}

.me-93 {
  margin-right: 46rem !important;
}

.me-94 {
  margin-right: 46.5rem !important;
}

.me-95 {
  margin-right: 47rem !important;
}

.me-96 {
  margin-right: 47.5rem !important;
}

.me-97 {
  margin-right: 48rem !important;
}

.me-98 {
  margin-right: 48.5rem !important;
}

.me-99 {
  margin-right: 49rem !important;
}

.me-100 {
  margin-right: 49.5rem !important;
}

.me-101 {
  margin-right: 50rem !important;
}

.me-102 {
  margin-right: 50.5rem !important;
}

.me-103 {
  margin-right: 51rem !important;
}

.me-104 {
  margin-right: 51.5rem !important;
}

.me-105 {
  margin-right: 52rem !important;
}

.me-106 {
  margin-right: 52.5rem !important;
}

.me-107 {
  margin-right: 53rem !important;
}

.me-108 {
  margin-right: 53.5rem !important;
}

.me-109 {
  margin-right: 54rem !important;
}

.me-110 {
  margin-right: 54.5rem !important;
}

.me-111 {
  margin-right: 55rem !important;
}

.me-112 {
  margin-right: 55.5rem !important;
}

.me-113 {
  margin-right: 56rem !important;
}

.me-114 {
  margin-right: 56.5rem !important;
}

.me-115 {
  margin-right: 57rem !important;
}

.me-116 {
  margin-right: 57.5rem !important;
}

.me-117 {
  margin-right: 58rem !important;
}

.me-118 {
  margin-right: 58.5rem !important;
}

.me-119 {
  margin-right: 59rem !important;
}

.me-120 {
  margin-right: 59.5rem !important;
}

.me-121 {
  margin-right: 60rem !important;
}

.me-122 {
  margin-right: 60.5rem !important;
}

.me-123 {
  margin-right: 61rem !important;
}

.me-124 {
  margin-right: 61.5rem !important;
}

.me-125 {
  margin-right: 62rem !important;
}

.me-126 {
  margin-right: 62.5rem !important;
}

.me-127 {
  margin-right: 63rem !important;
}

.me-128 {
  margin-right: 63.5rem !important;
}

.me-129 {
  margin-right: 64rem !important;
}

.me-130 {
  margin-right: 64.5rem !important;
}

.me-131 {
  margin-right: 65rem !important;
}

.me-132 {
  margin-right: 65.5rem !important;
}

.me-133 {
  margin-right: 66rem !important;
}

.me-134 {
  margin-right: 66.5rem !important;
}

.me-135 {
  margin-right: 67rem !important;
}

.me-136 {
  margin-right: 67.5rem !important;
}

.me-137 {
  margin-right: 68rem !important;
}

.me-138 {
  margin-right: 68.5rem !important;
}

.me-139 {
  margin-right: 69rem !important;
}

.me-140 {
  margin-right: 69.5rem !important;
}

.me-141 {
  margin-right: 70rem !important;
}

.me-142 {
  margin-right: 70.5rem !important;
}

.me-143 {
  margin-right: 71rem !important;
}

.me-144 {
  margin-right: 71.5rem !important;
}

.me-145 {
  margin-right: 72rem !important;
}

.me-146 {
  margin-right: 72.5rem !important;
}

.me-147 {
  margin-right: 73rem !important;
}

.me-148 {
  margin-right: 73.5rem !important;
}

.me-149 {
  margin-right: 74rem !important;
}

.me-150 {
  margin-right: 74.5rem !important;
}

.me-151 {
  margin-right: 75rem !important;
}

.me-152 {
  margin-right: 75.5rem !important;
}

.me-153 {
  margin-right: 76rem !important;
}

.me-154 {
  margin-right: 76.5rem !important;
}

.me-155 {
  margin-right: 77rem !important;
}

.me-156 {
  margin-right: 77.5rem !important;
}

.me-157 {
  margin-right: 78rem !important;
}

.me-158 {
  margin-right: 78.5rem !important;
}

.me-159 {
  margin-right: 79rem !important;
}

.me-160 {
  margin-right: 79.5rem !important;
}

.mx-0 {
  margin-left: 0rem !important;
  margin-right: 0rem !important;
}

.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}

.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}

.mx-3 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}

.mx-4 {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}

.mx-5 {
  margin-left: 2rem !important;
  margin-right: 2rem !important;
}

.mx-6 {
  margin-left: 2.5rem !important;
  margin-right: 2.5rem !important;
}

.mx-7 {
  margin-left: 3rem !important;
  margin-right: 3rem !important;
}

.mx-8 {
  margin-left: 3.5rem !important;
  margin-right: 3.5rem !important;
}

.mx-9 {
  margin-left: 4rem !important;
  margin-right: 4rem !important;
}

.mx-10 {
  margin-left: 4.5rem !important;
  margin-right: 4.5rem !important;
}

.mx-11 {
  margin-left: 5rem !important;
  margin-right: 5rem !important;
}

.mx-12 {
  margin-left: 5.5rem !important;
  margin-right: 5.5rem !important;
}

.mx-13 {
  margin-left: 6rem !important;
  margin-right: 6rem !important;
}

.mx-14 {
  margin-left: 6.5rem !important;
  margin-right: 6.5rem !important;
}

.mx-15 {
  margin-left: 7rem !important;
  margin-right: 7rem !important;
}

.mx-16 {
  margin-left: 7.5rem !important;
  margin-right: 7.5rem !important;
}

.mx-17 {
  margin-left: 8rem !important;
  margin-right: 8rem !important;
}

.mx-18 {
  margin-left: 8.5rem !important;
  margin-right: 8.5rem !important;
}

.mx-19 {
  margin-left: 9rem !important;
  margin-right: 9rem !important;
}

.mx-20 {
  margin-left: 9.5rem !important;
  margin-right: 9.5rem !important;
}

.mx-21 {
  margin-left: 10rem !important;
  margin-right: 10rem !important;
}

.mx-22 {
  margin-left: 10.5rem !important;
  margin-right: 10.5rem !important;
}

.mx-23 {
  margin-left: 11rem !important;
  margin-right: 11rem !important;
}

.mx-24 {
  margin-left: 11.5rem !important;
  margin-right: 11.5rem !important;
}

.mx-25 {
  margin-left: 12rem !important;
  margin-right: 12rem !important;
}

.mx-26 {
  margin-left: 12.5rem !important;
  margin-right: 12.5rem !important;
}

.mx-27 {
  margin-left: 13rem !important;
  margin-right: 13rem !important;
}

.mx-28 {
  margin-left: 13.5rem !important;
  margin-right: 13.5rem !important;
}

.mx-29 {
  margin-left: 14rem !important;
  margin-right: 14rem !important;
}

.mx-30 {
  margin-left: 14.5rem !important;
  margin-right: 14.5rem !important;
}

.mx-31 {
  margin-left: 15rem !important;
  margin-right: 15rem !important;
}

.mx-32 {
  margin-left: 15.5rem !important;
  margin-right: 15.5rem !important;
}

.mx-33 {
  margin-left: 16rem !important;
  margin-right: 16rem !important;
}

.mx-34 {
  margin-left: 16.5rem !important;
  margin-right: 16.5rem !important;
}

.mx-35 {
  margin-left: 17rem !important;
  margin-right: 17rem !important;
}

.mx-36 {
  margin-left: 17.5rem !important;
  margin-right: 17.5rem !important;
}

.mx-37 {
  margin-left: 18rem !important;
  margin-right: 18rem !important;
}

.mx-38 {
  margin-left: 18.5rem !important;
  margin-right: 18.5rem !important;
}

.mx-39 {
  margin-left: 19rem !important;
  margin-right: 19rem !important;
}

.mx-40 {
  margin-left: 19.5rem !important;
  margin-right: 19.5rem !important;
}

.mx-41 {
  margin-left: 20rem !important;
  margin-right: 20rem !important;
}

.mx-42 {
  margin-left: 20.5rem !important;
  margin-right: 20.5rem !important;
}

.mx-43 {
  margin-left: 21rem !important;
  margin-right: 21rem !important;
}

.mx-44 {
  margin-left: 21.5rem !important;
  margin-right: 21.5rem !important;
}

.mx-45 {
  margin-left: 22rem !important;
  margin-right: 22rem !important;
}

.mx-46 {
  margin-left: 22.5rem !important;
  margin-right: 22.5rem !important;
}

.mx-47 {
  margin-left: 23rem !important;
  margin-right: 23rem !important;
}

.mx-48 {
  margin-left: 23.5rem !important;
  margin-right: 23.5rem !important;
}

.mx-49 {
  margin-left: 24rem !important;
  margin-right: 24rem !important;
}

.mx-50 {
  margin-left: 24.5rem !important;
  margin-right: 24.5rem !important;
}

.mx-51 {
  margin-left: 25rem !important;
  margin-right: 25rem !important;
}

.mx-52 {
  margin-left: 25.5rem !important;
  margin-right: 25.5rem !important;
}

.mx-53 {
  margin-left: 26rem !important;
  margin-right: 26rem !important;
}

.mx-54 {
  margin-left: 26.5rem !important;
  margin-right: 26.5rem !important;
}

.mx-55 {
  margin-left: 27rem !important;
  margin-right: 27rem !important;
}

.mx-56 {
  margin-left: 27.5rem !important;
  margin-right: 27.5rem !important;
}

.mx-57 {
  margin-left: 28rem !important;
  margin-right: 28rem !important;
}

.mx-58 {
  margin-left: 28.5rem !important;
  margin-right: 28.5rem !important;
}

.mx-59 {
  margin-left: 29rem !important;
  margin-right: 29rem !important;
}

.mx-60 {
  margin-left: 29.5rem !important;
  margin-right: 29.5rem !important;
}

.mx-61 {
  margin-left: 30rem !important;
  margin-right: 30rem !important;
}

.mx-62 {
  margin-left: 30.5rem !important;
  margin-right: 30.5rem !important;
}

.mx-63 {
  margin-left: 31rem !important;
  margin-right: 31rem !important;
}

.mx-64 {
  margin-left: 31.5rem !important;
  margin-right: 31.5rem !important;
}

.mx-65 {
  margin-left: 32rem !important;
  margin-right: 32rem !important;
}

.mx-66 {
  margin-left: 32.5rem !important;
  margin-right: 32.5rem !important;
}

.mx-67 {
  margin-left: 33rem !important;
  margin-right: 33rem !important;
}

.mx-68 {
  margin-left: 33.5rem !important;
  margin-right: 33.5rem !important;
}

.mx-69 {
  margin-left: 34rem !important;
  margin-right: 34rem !important;
}

.mx-70 {
  margin-left: 34.5rem !important;
  margin-right: 34.5rem !important;
}

.mx-71 {
  margin-left: 35rem !important;
  margin-right: 35rem !important;
}

.mx-72 {
  margin-left: 35.5rem !important;
  margin-right: 35.5rem !important;
}

.mx-73 {
  margin-left: 36rem !important;
  margin-right: 36rem !important;
}

.mx-74 {
  margin-left: 36.5rem !important;
  margin-right: 36.5rem !important;
}

.mx-75 {
  margin-left: 37rem !important;
  margin-right: 37rem !important;
}

.mx-76 {
  margin-left: 37.5rem !important;
  margin-right: 37.5rem !important;
}

.mx-77 {
  margin-left: 38rem !important;
  margin-right: 38rem !important;
}

.mx-78 {
  margin-left: 38.5rem !important;
  margin-right: 38.5rem !important;
}

.mx-79 {
  margin-left: 39rem !important;
  margin-right: 39rem !important;
}

.mx-80 {
  margin-left: 39.5rem !important;
  margin-right: 39.5rem !important;
}

.mx-81 {
  margin-left: 40rem !important;
  margin-right: 40rem !important;
}

.mx-82 {
  margin-left: 40.5rem !important;
  margin-right: 40.5rem !important;
}

.mx-83 {
  margin-left: 41rem !important;
  margin-right: 41rem !important;
}

.mx-84 {
  margin-left: 41.5rem !important;
  margin-right: 41.5rem !important;
}

.mx-85 {
  margin-left: 42rem !important;
  margin-right: 42rem !important;
}

.mx-86 {
  margin-left: 42.5rem !important;
  margin-right: 42.5rem !important;
}

.mx-87 {
  margin-left: 43rem !important;
  margin-right: 43rem !important;
}

.mx-88 {
  margin-left: 43.5rem !important;
  margin-right: 43.5rem !important;
}

.mx-89 {
  margin-left: 44rem !important;
  margin-right: 44rem !important;
}

.mx-90 {
  margin-left: 44.5rem !important;
  margin-right: 44.5rem !important;
}

.mx-91 {
  margin-left: 45rem !important;
  margin-right: 45rem !important;
}

.mx-92 {
  margin-left: 45.5rem !important;
  margin-right: 45.5rem !important;
}

.mx-93 {
  margin-left: 46rem !important;
  margin-right: 46rem !important;
}

.mx-94 {
  margin-left: 46.5rem !important;
  margin-right: 46.5rem !important;
}

.mx-95 {
  margin-left: 47rem !important;
  margin-right: 47rem !important;
}

.mx-96 {
  margin-left: 47.5rem !important;
  margin-right: 47.5rem !important;
}

.mx-97 {
  margin-left: 48rem !important;
  margin-right: 48rem !important;
}

.mx-98 {
  margin-left: 48.5rem !important;
  margin-right: 48.5rem !important;
}

.mx-99 {
  margin-left: 49rem !important;
  margin-right: 49rem !important;
}

.mx-100 {
  margin-left: 49.5rem !important;
  margin-right: 49.5rem !important;
}

.mx-101 {
  margin-left: 50rem !important;
  margin-right: 50rem !important;
}

.mx-102 {
  margin-left: 50.5rem !important;
  margin-right: 50.5rem !important;
}

.mx-103 {
  margin-left: 51rem !important;
  margin-right: 51rem !important;
}

.mx-104 {
  margin-left: 51.5rem !important;
  margin-right: 51.5rem !important;
}

.mx-105 {
  margin-left: 52rem !important;
  margin-right: 52rem !important;
}

.mx-106 {
  margin-left: 52.5rem !important;
  margin-right: 52.5rem !important;
}

.mx-107 {
  margin-left: 53rem !important;
  margin-right: 53rem !important;
}

.mx-108 {
  margin-left: 53.5rem !important;
  margin-right: 53.5rem !important;
}

.mx-109 {
  margin-left: 54rem !important;
  margin-right: 54rem !important;
}

.mx-110 {
  margin-left: 54.5rem !important;
  margin-right: 54.5rem !important;
}

.mx-111 {
  margin-left: 55rem !important;
  margin-right: 55rem !important;
}

.mx-112 {
  margin-left: 55.5rem !important;
  margin-right: 55.5rem !important;
}

.mx-113 {
  margin-left: 56rem !important;
  margin-right: 56rem !important;
}

.mx-114 {
  margin-left: 56.5rem !important;
  margin-right: 56.5rem !important;
}

.mx-115 {
  margin-left: 57rem !important;
  margin-right: 57rem !important;
}

.mx-116 {
  margin-left: 57.5rem !important;
  margin-right: 57.5rem !important;
}

.mx-117 {
  margin-left: 58rem !important;
  margin-right: 58rem !important;
}

.mx-118 {
  margin-left: 58.5rem !important;
  margin-right: 58.5rem !important;
}

.mx-119 {
  margin-left: 59rem !important;
  margin-right: 59rem !important;
}

.mx-120 {
  margin-left: 59.5rem !important;
  margin-right: 59.5rem !important;
}

.mx-121 {
  margin-left: 60rem !important;
  margin-right: 60rem !important;
}

.mx-122 {
  margin-left: 60.5rem !important;
  margin-right: 60.5rem !important;
}

.mx-123 {
  margin-left: 61rem !important;
  margin-right: 61rem !important;
}

.mx-124 {
  margin-left: 61.5rem !important;
  margin-right: 61.5rem !important;
}

.mx-125 {
  margin-left: 62rem !important;
  margin-right: 62rem !important;
}

.mx-126 {
  margin-left: 62.5rem !important;
  margin-right: 62.5rem !important;
}

.mx-127 {
  margin-left: 63rem !important;
  margin-right: 63rem !important;
}

.mx-128 {
  margin-left: 63.5rem !important;
  margin-right: 63.5rem !important;
}

.mx-129 {
  margin-left: 64rem !important;
  margin-right: 64rem !important;
}

.mx-130 {
  margin-left: 64.5rem !important;
  margin-right: 64.5rem !important;
}

.mx-131 {
  margin-left: 65rem !important;
  margin-right: 65rem !important;
}

.mx-132 {
  margin-left: 65.5rem !important;
  margin-right: 65.5rem !important;
}

.mx-133 {
  margin-left: 66rem !important;
  margin-right: 66rem !important;
}

.mx-134 {
  margin-left: 66.5rem !important;
  margin-right: 66.5rem !important;
}

.mx-135 {
  margin-left: 67rem !important;
  margin-right: 67rem !important;
}

.mx-136 {
  margin-left: 67.5rem !important;
  margin-right: 67.5rem !important;
}

.mx-137 {
  margin-left: 68rem !important;
  margin-right: 68rem !important;
}

.mx-138 {
  margin-left: 68.5rem !important;
  margin-right: 68.5rem !important;
}

.mx-139 {
  margin-left: 69rem !important;
  margin-right: 69rem !important;
}

.mx-140 {
  margin-left: 69.5rem !important;
  margin-right: 69.5rem !important;
}

.mx-141 {
  margin-left: 70rem !important;
  margin-right: 70rem !important;
}

.mx-142 {
  margin-left: 70.5rem !important;
  margin-right: 70.5rem !important;
}

.mx-143 {
  margin-left: 71rem !important;
  margin-right: 71rem !important;
}

.mx-144 {
  margin-left: 71.5rem !important;
  margin-right: 71.5rem !important;
}

.mx-145 {
  margin-left: 72rem !important;
  margin-right: 72rem !important;
}

.mx-146 {
  margin-left: 72.5rem !important;
  margin-right: 72.5rem !important;
}

.mx-147 {
  margin-left: 73rem !important;
  margin-right: 73rem !important;
}

.mx-148 {
  margin-left: 73.5rem !important;
  margin-right: 73.5rem !important;
}

.mx-149 {
  margin-left: 74rem !important;
  margin-right: 74rem !important;
}

.mx-150 {
  margin-left: 74.5rem !important;
  margin-right: 74.5rem !important;
}

.mx-151 {
  margin-left: 75rem !important;
  margin-right: 75rem !important;
}

.mx-152 {
  margin-left: 75.5rem !important;
  margin-right: 75.5rem !important;
}

.mx-153 {
  margin-left: 76rem !important;
  margin-right: 76rem !important;
}

.mx-154 {
  margin-left: 76.5rem !important;
  margin-right: 76.5rem !important;
}

.mx-155 {
  margin-left: 77rem !important;
  margin-right: 77rem !important;
}

.mx-156 {
  margin-left: 77.5rem !important;
  margin-right: 77.5rem !important;
}

.mx-157 {
  margin-left: 78rem !important;
  margin-right: 78rem !important;
}

.mx-158 {
  margin-left: 78.5rem !important;
  margin-right: 78.5rem !important;
}

.mx-159 {
  margin-left: 79rem !important;
  margin-right: 79rem !important;
}

.mx-160 {
  margin-left: 79.5rem !important;
  margin-right: 79.5rem !important;
}

.my-0 {
  margin-top: 0rem !important;
  margin-bottom: 0rem !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-6 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.my-7 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-8 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-9 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-10 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-11 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-12 {
  margin-top: 5.5rem !important;
  margin-bottom: 5.5rem !important;
}

.my-13 {
  margin-top: 6rem !important;
  margin-bottom: 6rem !important;
}

.my-14 {
  margin-top: 6.5rem !important;
  margin-bottom: 6.5rem !important;
}

.my-15 {
  margin-top: 7rem !important;
  margin-bottom: 7rem !important;
}

.my-16 {
  margin-top: 7.5rem !important;
  margin-bottom: 7.5rem !important;
}

.my-17 {
  margin-top: 8rem !important;
  margin-bottom: 8rem !important;
}

.my-18 {
  margin-top: 8.5rem !important;
  margin-bottom: 8.5rem !important;
}

.my-19 {
  margin-top: 9rem !important;
  margin-bottom: 9rem !important;
}

.my-20 {
  margin-top: 9.5rem !important;
  margin-bottom: 9.5rem !important;
}

.my-21 {
  margin-top: 10rem !important;
  margin-bottom: 10rem !important;
}

.my-22 {
  margin-top: 10.5rem !important;
  margin-bottom: 10.5rem !important;
}

.my-23 {
  margin-top: 11rem !important;
  margin-bottom: 11rem !important;
}

.my-24 {
  margin-top: 11.5rem !important;
  margin-bottom: 11.5rem !important;
}

.my-25 {
  margin-top: 12rem !important;
  margin-bottom: 12rem !important;
}

.my-26 {
  margin-top: 12.5rem !important;
  margin-bottom: 12.5rem !important;
}

.my-27 {
  margin-top: 13rem !important;
  margin-bottom: 13rem !important;
}

.my-28 {
  margin-top: 13.5rem !important;
  margin-bottom: 13.5rem !important;
}

.my-29 {
  margin-top: 14rem !important;
  margin-bottom: 14rem !important;
}

.my-30 {
  margin-top: 14.5rem !important;
  margin-bottom: 14.5rem !important;
}

.my-31 {
  margin-top: 15rem !important;
  margin-bottom: 15rem !important;
}

.my-32 {
  margin-top: 15.5rem !important;
  margin-bottom: 15.5rem !important;
}

.my-33 {
  margin-top: 16rem !important;
  margin-bottom: 16rem !important;
}

.my-34 {
  margin-top: 16.5rem !important;
  margin-bottom: 16.5rem !important;
}

.my-35 {
  margin-top: 17rem !important;
  margin-bottom: 17rem !important;
}

.my-36 {
  margin-top: 17.5rem !important;
  margin-bottom: 17.5rem !important;
}

.my-37 {
  margin-top: 18rem !important;
  margin-bottom: 18rem !important;
}

.my-38 {
  margin-top: 18.5rem !important;
  margin-bottom: 18.5rem !important;
}

.my-39 {
  margin-top: 19rem !important;
  margin-bottom: 19rem !important;
}

.my-40 {
  margin-top: 19.5rem !important;
  margin-bottom: 19.5rem !important;
}

.my-41 {
  margin-top: 20rem !important;
  margin-bottom: 20rem !important;
}

.my-42 {
  margin-top: 20.5rem !important;
  margin-bottom: 20.5rem !important;
}

.my-43 {
  margin-top: 21rem !important;
  margin-bottom: 21rem !important;
}

.my-44 {
  margin-top: 21.5rem !important;
  margin-bottom: 21.5rem !important;
}

.my-45 {
  margin-top: 22rem !important;
  margin-bottom: 22rem !important;
}

.my-46 {
  margin-top: 22.5rem !important;
  margin-bottom: 22.5rem !important;
}

.my-47 {
  margin-top: 23rem !important;
  margin-bottom: 23rem !important;
}

.my-48 {
  margin-top: 23.5rem !important;
  margin-bottom: 23.5rem !important;
}

.my-49 {
  margin-top: 24rem !important;
  margin-bottom: 24rem !important;
}

.my-50 {
  margin-top: 24.5rem !important;
  margin-bottom: 24.5rem !important;
}

.my-51 {
  margin-top: 25rem !important;
  margin-bottom: 25rem !important;
}

.my-52 {
  margin-top: 25.5rem !important;
  margin-bottom: 25.5rem !important;
}

.my-53 {
  margin-top: 26rem !important;
  margin-bottom: 26rem !important;
}

.my-54 {
  margin-top: 26.5rem !important;
  margin-bottom: 26.5rem !important;
}

.my-55 {
  margin-top: 27rem !important;
  margin-bottom: 27rem !important;
}

.my-56 {
  margin-top: 27.5rem !important;
  margin-bottom: 27.5rem !important;
}

.my-57 {
  margin-top: 28rem !important;
  margin-bottom: 28rem !important;
}

.my-58 {
  margin-top: 28.5rem !important;
  margin-bottom: 28.5rem !important;
}

.my-59 {
  margin-top: 29rem !important;
  margin-bottom: 29rem !important;
}

.my-60 {
  margin-top: 29.5rem !important;
  margin-bottom: 29.5rem !important;
}

.my-61 {
  margin-top: 30rem !important;
  margin-bottom: 30rem !important;
}

.my-62 {
  margin-top: 30.5rem !important;
  margin-bottom: 30.5rem !important;
}

.my-63 {
  margin-top: 31rem !important;
  margin-bottom: 31rem !important;
}

.my-64 {
  margin-top: 31.5rem !important;
  margin-bottom: 31.5rem !important;
}

.my-65 {
  margin-top: 32rem !important;
  margin-bottom: 32rem !important;
}

.my-66 {
  margin-top: 32.5rem !important;
  margin-bottom: 32.5rem !important;
}

.my-67 {
  margin-top: 33rem !important;
  margin-bottom: 33rem !important;
}

.my-68 {
  margin-top: 33.5rem !important;
  margin-bottom: 33.5rem !important;
}

.my-69 {
  margin-top: 34rem !important;
  margin-bottom: 34rem !important;
}

.my-70 {
  margin-top: 34.5rem !important;
  margin-bottom: 34.5rem !important;
}

.my-71 {
  margin-top: 35rem !important;
  margin-bottom: 35rem !important;
}

.my-72 {
  margin-top: 35.5rem !important;
  margin-bottom: 35.5rem !important;
}

.my-73 {
  margin-top: 36rem !important;
  margin-bottom: 36rem !important;
}

.my-74 {
  margin-top: 36.5rem !important;
  margin-bottom: 36.5rem !important;
}

.my-75 {
  margin-top: 37rem !important;
  margin-bottom: 37rem !important;
}

.my-76 {
  margin-top: 37.5rem !important;
  margin-bottom: 37.5rem !important;
}

.my-77 {
  margin-top: 38rem !important;
  margin-bottom: 38rem !important;
}

.my-78 {
  margin-top: 38.5rem !important;
  margin-bottom: 38.5rem !important;
}

.my-79 {
  margin-top: 39rem !important;
  margin-bottom: 39rem !important;
}

.my-80 {
  margin-top: 39.5rem !important;
  margin-bottom: 39.5rem !important;
}

.my-81 {
  margin-top: 40rem !important;
  margin-bottom: 40rem !important;
}

.my-82 {
  margin-top: 40.5rem !important;
  margin-bottom: 40.5rem !important;
}

.my-83 {
  margin-top: 41rem !important;
  margin-bottom: 41rem !important;
}

.my-84 {
  margin-top: 41.5rem !important;
  margin-bottom: 41.5rem !important;
}

.my-85 {
  margin-top: 42rem !important;
  margin-bottom: 42rem !important;
}

.my-86 {
  margin-top: 42.5rem !important;
  margin-bottom: 42.5rem !important;
}

.my-87 {
  margin-top: 43rem !important;
  margin-bottom: 43rem !important;
}

.my-88 {
  margin-top: 43.5rem !important;
  margin-bottom: 43.5rem !important;
}

.my-89 {
  margin-top: 44rem !important;
  margin-bottom: 44rem !important;
}

.my-90 {
  margin-top: 44.5rem !important;
  margin-bottom: 44.5rem !important;
}

.my-91 {
  margin-top: 45rem !important;
  margin-bottom: 45rem !important;
}

.my-92 {
  margin-top: 45.5rem !important;
  margin-bottom: 45.5rem !important;
}

.my-93 {
  margin-top: 46rem !important;
  margin-bottom: 46rem !important;
}

.my-94 {
  margin-top: 46.5rem !important;
  margin-bottom: 46.5rem !important;
}

.my-95 {
  margin-top: 47rem !important;
  margin-bottom: 47rem !important;
}

.my-96 {
  margin-top: 47.5rem !important;
  margin-bottom: 47.5rem !important;
}

.my-97 {
  margin-top: 48rem !important;
  margin-bottom: 48rem !important;
}

.my-98 {
  margin-top: 48.5rem !important;
  margin-bottom: 48.5rem !important;
}

.my-99 {
  margin-top: 49rem !important;
  margin-bottom: 49rem !important;
}

.my-100 {
  margin-top: 49.5rem !important;
  margin-bottom: 49.5rem !important;
}

.my-101 {
  margin-top: 50rem !important;
  margin-bottom: 50rem !important;
}

.my-102 {
  margin-top: 50.5rem !important;
  margin-bottom: 50.5rem !important;
}

.my-103 {
  margin-top: 51rem !important;
  margin-bottom: 51rem !important;
}

.my-104 {
  margin-top: 51.5rem !important;
  margin-bottom: 51.5rem !important;
}

.my-105 {
  margin-top: 52rem !important;
  margin-bottom: 52rem !important;
}

.my-106 {
  margin-top: 52.5rem !important;
  margin-bottom: 52.5rem !important;
}

.my-107 {
  margin-top: 53rem !important;
  margin-bottom: 53rem !important;
}

.my-108 {
  margin-top: 53.5rem !important;
  margin-bottom: 53.5rem !important;
}

.my-109 {
  margin-top: 54rem !important;
  margin-bottom: 54rem !important;
}

.my-110 {
  margin-top: 54.5rem !important;
  margin-bottom: 54.5rem !important;
}

.my-111 {
  margin-top: 55rem !important;
  margin-bottom: 55rem !important;
}

.my-112 {
  margin-top: 55.5rem !important;
  margin-bottom: 55.5rem !important;
}

.my-113 {
  margin-top: 56rem !important;
  margin-bottom: 56rem !important;
}

.my-114 {
  margin-top: 56.5rem !important;
  margin-bottom: 56.5rem !important;
}

.my-115 {
  margin-top: 57rem !important;
  margin-bottom: 57rem !important;
}

.my-116 {
  margin-top: 57.5rem !important;
  margin-bottom: 57.5rem !important;
}

.my-117 {
  margin-top: 58rem !important;
  margin-bottom: 58rem !important;
}

.my-118 {
  margin-top: 58.5rem !important;
  margin-bottom: 58.5rem !important;
}

.my-119 {
  margin-top: 59rem !important;
  margin-bottom: 59rem !important;
}

.my-120 {
  margin-top: 59.5rem !important;
  margin-bottom: 59.5rem !important;
}

.my-121 {
  margin-top: 60rem !important;
  margin-bottom: 60rem !important;
}

.my-122 {
  margin-top: 60.5rem !important;
  margin-bottom: 60.5rem !important;
}

.my-123 {
  margin-top: 61rem !important;
  margin-bottom: 61rem !important;
}

.my-124 {
  margin-top: 61.5rem !important;
  margin-bottom: 61.5rem !important;
}

.my-125 {
  margin-top: 62rem !important;
  margin-bottom: 62rem !important;
}

.my-126 {
  margin-top: 62.5rem !important;
  margin-bottom: 62.5rem !important;
}

.my-127 {
  margin-top: 63rem !important;
  margin-bottom: 63rem !important;
}

.my-128 {
  margin-top: 63.5rem !important;
  margin-bottom: 63.5rem !important;
}

.my-129 {
  margin-top: 64rem !important;
  margin-bottom: 64rem !important;
}

.my-130 {
  margin-top: 64.5rem !important;
  margin-bottom: 64.5rem !important;
}

.my-131 {
  margin-top: 65rem !important;
  margin-bottom: 65rem !important;
}

.my-132 {
  margin-top: 65.5rem !important;
  margin-bottom: 65.5rem !important;
}

.my-133 {
  margin-top: 66rem !important;
  margin-bottom: 66rem !important;
}

.my-134 {
  margin-top: 66.5rem !important;
  margin-bottom: 66.5rem !important;
}

.my-135 {
  margin-top: 67rem !important;
  margin-bottom: 67rem !important;
}

.my-136 {
  margin-top: 67.5rem !important;
  margin-bottom: 67.5rem !important;
}

.my-137 {
  margin-top: 68rem !important;
  margin-bottom: 68rem !important;
}

.my-138 {
  margin-top: 68.5rem !important;
  margin-bottom: 68.5rem !important;
}

.my-139 {
  margin-top: 69rem !important;
  margin-bottom: 69rem !important;
}

.my-140 {
  margin-top: 69.5rem !important;
  margin-bottom: 69.5rem !important;
}

.my-141 {
  margin-top: 70rem !important;
  margin-bottom: 70rem !important;
}

.my-142 {
  margin-top: 70.5rem !important;
  margin-bottom: 70.5rem !important;
}

.my-143 {
  margin-top: 71rem !important;
  margin-bottom: 71rem !important;
}

.my-144 {
  margin-top: 71.5rem !important;
  margin-bottom: 71.5rem !important;
}

.my-145 {
  margin-top: 72rem !important;
  margin-bottom: 72rem !important;
}

.my-146 {
  margin-top: 72.5rem !important;
  margin-bottom: 72.5rem !important;
}

.my-147 {
  margin-top: 73rem !important;
  margin-bottom: 73rem !important;
}

.my-148 {
  margin-top: 73.5rem !important;
  margin-bottom: 73.5rem !important;
}

.my-149 {
  margin-top: 74rem !important;
  margin-bottom: 74rem !important;
}

.my-150 {
  margin-top: 74.5rem !important;
  margin-bottom: 74.5rem !important;
}

.my-151 {
  margin-top: 75rem !important;
  margin-bottom: 75rem !important;
}

.my-152 {
  margin-top: 75.5rem !important;
  margin-bottom: 75.5rem !important;
}

.my-153 {
  margin-top: 76rem !important;
  margin-bottom: 76rem !important;
}

.my-154 {
  margin-top: 76.5rem !important;
  margin-bottom: 76.5rem !important;
}

.my-155 {
  margin-top: 77rem !important;
  margin-bottom: 77rem !important;
}

.my-156 {
  margin-top: 77.5rem !important;
  margin-bottom: 77.5rem !important;
}

.my-157 {
  margin-top: 78rem !important;
  margin-bottom: 78rem !important;
}

.my-158 {
  margin-top: 78.5rem !important;
  margin-bottom: 78.5rem !important;
}

.my-159 {
  margin-top: 79rem !important;
  margin-bottom: 79rem !important;
}

.my-160 {
  margin-top: 79.5rem !important;
  margin-bottom: 79.5rem !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0rem !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 2rem !important;
  }

  .m-sm-6 {
    margin: 2.5rem !important;
  }

  .m-sm-7 {
    margin: 3rem !important;
  }

  .m-sm-8 {
    margin: 3.5rem !important;
  }

  .m-sm-9 {
    margin: 4rem !important;
  }

  .m-sm-10 {
    margin: 4.5rem !important;
  }

  .m-sm-11 {
    margin: 5rem !important;
  }

  .m-sm-12 {
    margin: 5.5rem !important;
  }

  .m-sm-13 {
    margin: 6rem !important;
  }

  .m-sm-14 {
    margin: 6.5rem !important;
  }

  .m-sm-15 {
    margin: 7rem !important;
  }

  .m-sm-16 {
    margin: 7.5rem !important;
  }

  .m-sm-17 {
    margin: 8rem !important;
  }

  .m-sm-18 {
    margin: 8.5rem !important;
  }

  .m-sm-19 {
    margin: 9rem !important;
  }

  .m-sm-20 {
    margin: 9.5rem !important;
  }

  .m-sm-21 {
    margin: 10rem !important;
  }

  .m-sm-22 {
    margin: 10.5rem !important;
  }

  .m-sm-23 {
    margin: 11rem !important;
  }

  .m-sm-24 {
    margin: 11.5rem !important;
  }

  .m-sm-25 {
    margin: 12rem !important;
  }

  .m-sm-26 {
    margin: 12.5rem !important;
  }

  .m-sm-27 {
    margin: 13rem !important;
  }

  .m-sm-28 {
    margin: 13.5rem !important;
  }

  .m-sm-29 {
    margin: 14rem !important;
  }

  .m-sm-30 {
    margin: 14.5rem !important;
  }

  .m-sm-31 {
    margin: 15rem !important;
  }

  .m-sm-32 {
    margin: 15.5rem !important;
  }

  .m-sm-33 {
    margin: 16rem !important;
  }

  .m-sm-34 {
    margin: 16.5rem !important;
  }

  .m-sm-35 {
    margin: 17rem !important;
  }

  .m-sm-36 {
    margin: 17.5rem !important;
  }

  .m-sm-37 {
    margin: 18rem !important;
  }

  .m-sm-38 {
    margin: 18.5rem !important;
  }

  .m-sm-39 {
    margin: 19rem !important;
  }

  .m-sm-40 {
    margin: 19.5rem !important;
  }

  .m-sm-41 {
    margin: 20rem !important;
  }

  .m-sm-42 {
    margin: 20.5rem !important;
  }

  .m-sm-43 {
    margin: 21rem !important;
  }

  .m-sm-44 {
    margin: 21.5rem !important;
  }

  .m-sm-45 {
    margin: 22rem !important;
  }

  .m-sm-46 {
    margin: 22.5rem !important;
  }

  .m-sm-47 {
    margin: 23rem !important;
  }

  .m-sm-48 {
    margin: 23.5rem !important;
  }

  .m-sm-49 {
    margin: 24rem !important;
  }

  .m-sm-50 {
    margin: 24.5rem !important;
  }

  .m-sm-51 {
    margin: 25rem !important;
  }

  .m-sm-52 {
    margin: 25.5rem !important;
  }

  .m-sm-53 {
    margin: 26rem !important;
  }

  .m-sm-54 {
    margin: 26.5rem !important;
  }

  .m-sm-55 {
    margin: 27rem !important;
  }

  .m-sm-56 {
    margin: 27.5rem !important;
  }

  .m-sm-57 {
    margin: 28rem !important;
  }

  .m-sm-58 {
    margin: 28.5rem !important;
  }

  .m-sm-59 {
    margin: 29rem !important;
  }

  .m-sm-60 {
    margin: 29.5rem !important;
  }

  .m-sm-61 {
    margin: 30rem !important;
  }

  .m-sm-62 {
    margin: 30.5rem !important;
  }

  .m-sm-63 {
    margin: 31rem !important;
  }

  .m-sm-64 {
    margin: 31.5rem !important;
  }

  .m-sm-65 {
    margin: 32rem !important;
  }

  .m-sm-66 {
    margin: 32.5rem !important;
  }

  .m-sm-67 {
    margin: 33rem !important;
  }

  .m-sm-68 {
    margin: 33.5rem !important;
  }

  .m-sm-69 {
    margin: 34rem !important;
  }

  .m-sm-70 {
    margin: 34.5rem !important;
  }

  .m-sm-71 {
    margin: 35rem !important;
  }

  .m-sm-72 {
    margin: 35.5rem !important;
  }

  .m-sm-73 {
    margin: 36rem !important;
  }

  .m-sm-74 {
    margin: 36.5rem !important;
  }

  .m-sm-75 {
    margin: 37rem !important;
  }

  .m-sm-76 {
    margin: 37.5rem !important;
  }

  .m-sm-77 {
    margin: 38rem !important;
  }

  .m-sm-78 {
    margin: 38.5rem !important;
  }

  .m-sm-79 {
    margin: 39rem !important;
  }

  .m-sm-80 {
    margin: 39.5rem !important;
  }

  .m-sm-81 {
    margin: 40rem !important;
  }

  .m-sm-82 {
    margin: 40.5rem !important;
  }

  .m-sm-83 {
    margin: 41rem !important;
  }

  .m-sm-84 {
    margin: 41.5rem !important;
  }

  .m-sm-85 {
    margin: 42rem !important;
  }

  .m-sm-86 {
    margin: 42.5rem !important;
  }

  .m-sm-87 {
    margin: 43rem !important;
  }

  .m-sm-88 {
    margin: 43.5rem !important;
  }

  .m-sm-89 {
    margin: 44rem !important;
  }

  .m-sm-90 {
    margin: 44.5rem !important;
  }

  .m-sm-91 {
    margin: 45rem !important;
  }

  .m-sm-92 {
    margin: 45.5rem !important;
  }

  .m-sm-93 {
    margin: 46rem !important;
  }

  .m-sm-94 {
    margin: 46.5rem !important;
  }

  .m-sm-95 {
    margin: 47rem !important;
  }

  .m-sm-96 {
    margin: 47.5rem !important;
  }

  .m-sm-97 {
    margin: 48rem !important;
  }

  .m-sm-98 {
    margin: 48.5rem !important;
  }

  .m-sm-99 {
    margin: 49rem !important;
  }

  .m-sm-100 {
    margin: 49.5rem !important;
  }

  .m-sm-101 {
    margin: 50rem !important;
  }

  .m-sm-102 {
    margin: 50.5rem !important;
  }

  .m-sm-103 {
    margin: 51rem !important;
  }

  .m-sm-104 {
    margin: 51.5rem !important;
  }

  .m-sm-105 {
    margin: 52rem !important;
  }

  .m-sm-106 {
    margin: 52.5rem !important;
  }

  .m-sm-107 {
    margin: 53rem !important;
  }

  .m-sm-108 {
    margin: 53.5rem !important;
  }

  .m-sm-109 {
    margin: 54rem !important;
  }

  .m-sm-110 {
    margin: 54.5rem !important;
  }

  .m-sm-111 {
    margin: 55rem !important;
  }

  .m-sm-112 {
    margin: 55.5rem !important;
  }

  .m-sm-113 {
    margin: 56rem !important;
  }

  .m-sm-114 {
    margin: 56.5rem !important;
  }

  .m-sm-115 {
    margin: 57rem !important;
  }

  .m-sm-116 {
    margin: 57.5rem !important;
  }

  .m-sm-117 {
    margin: 58rem !important;
  }

  .m-sm-118 {
    margin: 58.5rem !important;
  }

  .m-sm-119 {
    margin: 59rem !important;
  }

  .m-sm-120 {
    margin: 59.5rem !important;
  }

  .m-sm-121 {
    margin: 60rem !important;
  }

  .m-sm-122 {
    margin: 60.5rem !important;
  }

  .m-sm-123 {
    margin: 61rem !important;
  }

  .m-sm-124 {
    margin: 61.5rem !important;
  }

  .m-sm-125 {
    margin: 62rem !important;
  }

  .m-sm-126 {
    margin: 62.5rem !important;
  }

  .m-sm-127 {
    margin: 63rem !important;
  }

  .m-sm-128 {
    margin: 63.5rem !important;
  }

  .m-sm-129 {
    margin: 64rem !important;
  }

  .m-sm-130 {
    margin: 64.5rem !important;
  }

  .m-sm-131 {
    margin: 65rem !important;
  }

  .m-sm-132 {
    margin: 65.5rem !important;
  }

  .m-sm-133 {
    margin: 66rem !important;
  }

  .m-sm-134 {
    margin: 66.5rem !important;
  }

  .m-sm-135 {
    margin: 67rem !important;
  }

  .m-sm-136 {
    margin: 67.5rem !important;
  }

  .m-sm-137 {
    margin: 68rem !important;
  }

  .m-sm-138 {
    margin: 68.5rem !important;
  }

  .m-sm-139 {
    margin: 69rem !important;
  }

  .m-sm-140 {
    margin: 69.5rem !important;
  }

  .m-sm-141 {
    margin: 70rem !important;
  }

  .m-sm-142 {
    margin: 70.5rem !important;
  }

  .m-sm-143 {
    margin: 71rem !important;
  }

  .m-sm-144 {
    margin: 71.5rem !important;
  }

  .m-sm-145 {
    margin: 72rem !important;
  }

  .m-sm-146 {
    margin: 72.5rem !important;
  }

  .m-sm-147 {
    margin: 73rem !important;
  }

  .m-sm-148 {
    margin: 73.5rem !important;
  }

  .m-sm-149 {
    margin: 74rem !important;
  }

  .m-sm-150 {
    margin: 74.5rem !important;
  }

  .m-sm-151 {
    margin: 75rem !important;
  }

  .m-sm-152 {
    margin: 75.5rem !important;
  }

  .m-sm-153 {
    margin: 76rem !important;
  }

  .m-sm-154 {
    margin: 76.5rem !important;
  }

  .m-sm-155 {
    margin: 77rem !important;
  }

  .m-sm-156 {
    margin: 77.5rem !important;
  }

  .m-sm-157 {
    margin: 78rem !important;
  }

  .m-sm-158 {
    margin: 78.5rem !important;
  }

  .m-sm-159 {
    margin: 79rem !important;
  }

  .m-sm-160 {
    margin: 79.5rem !important;
  }

  .mt-sm-0 {
    margin-top: 0rem !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 1rem !important;
  }

  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-5 {
    margin-top: 2rem !important;
  }

  .mt-sm-6 {
    margin-top: 2.5rem !important;
  }

  .mt-sm-7 {
    margin-top: 3rem !important;
  }

  .mt-sm-8 {
    margin-top: 3.5rem !important;
  }

  .mt-sm-9 {
    margin-top: 4rem !important;
  }

  .mt-sm-10 {
    margin-top: 4.5rem !important;
  }

  .mt-sm-11 {
    margin-top: 5rem !important;
  }

  .mt-sm-12 {
    margin-top: 5.5rem !important;
  }

  .mt-sm-13 {
    margin-top: 6rem !important;
  }

  .mt-sm-14 {
    margin-top: 6.5rem !important;
  }

  .mt-sm-15 {
    margin-top: 7rem !important;
  }

  .mt-sm-16 {
    margin-top: 7.5rem !important;
  }

  .mt-sm-17 {
    margin-top: 8rem !important;
  }

  .mt-sm-18 {
    margin-top: 8.5rem !important;
  }

  .mt-sm-19 {
    margin-top: 9rem !important;
  }

  .mt-sm-20 {
    margin-top: 9.5rem !important;
  }

  .mt-sm-21 {
    margin-top: 10rem !important;
  }

  .mt-sm-22 {
    margin-top: 10.5rem !important;
  }

  .mt-sm-23 {
    margin-top: 11rem !important;
  }

  .mt-sm-24 {
    margin-top: 11.5rem !important;
  }

  .mt-sm-25 {
    margin-top: 12rem !important;
  }

  .mt-sm-26 {
    margin-top: 12.5rem !important;
  }

  .mt-sm-27 {
    margin-top: 13rem !important;
  }

  .mt-sm-28 {
    margin-top: 13.5rem !important;
  }

  .mt-sm-29 {
    margin-top: 14rem !important;
  }

  .mt-sm-30 {
    margin-top: 14.5rem !important;
  }

  .mt-sm-31 {
    margin-top: 15rem !important;
  }

  .mt-sm-32 {
    margin-top: 15.5rem !important;
  }

  .mt-sm-33 {
    margin-top: 16rem !important;
  }

  .mt-sm-34 {
    margin-top: 16.5rem !important;
  }

  .mt-sm-35 {
    margin-top: 17rem !important;
  }

  .mt-sm-36 {
    margin-top: 17.5rem !important;
  }

  .mt-sm-37 {
    margin-top: 18rem !important;
  }

  .mt-sm-38 {
    margin-top: 18.5rem !important;
  }

  .mt-sm-39 {
    margin-top: 19rem !important;
  }

  .mt-sm-40 {
    margin-top: 19.5rem !important;
  }

  .mt-sm-41 {
    margin-top: 20rem !important;
  }

  .mt-sm-42 {
    margin-top: 20.5rem !important;
  }

  .mt-sm-43 {
    margin-top: 21rem !important;
  }

  .mt-sm-44 {
    margin-top: 21.5rem !important;
  }

  .mt-sm-45 {
    margin-top: 22rem !important;
  }

  .mt-sm-46 {
    margin-top: 22.5rem !important;
  }

  .mt-sm-47 {
    margin-top: 23rem !important;
  }

  .mt-sm-48 {
    margin-top: 23.5rem !important;
  }

  .mt-sm-49 {
    margin-top: 24rem !important;
  }

  .mt-sm-50 {
    margin-top: 24.5rem !important;
  }

  .mt-sm-51 {
    margin-top: 25rem !important;
  }

  .mt-sm-52 {
    margin-top: 25.5rem !important;
  }

  .mt-sm-53 {
    margin-top: 26rem !important;
  }

  .mt-sm-54 {
    margin-top: 26.5rem !important;
  }

  .mt-sm-55 {
    margin-top: 27rem !important;
  }

  .mt-sm-56 {
    margin-top: 27.5rem !important;
  }

  .mt-sm-57 {
    margin-top: 28rem !important;
  }

  .mt-sm-58 {
    margin-top: 28.5rem !important;
  }

  .mt-sm-59 {
    margin-top: 29rem !important;
  }

  .mt-sm-60 {
    margin-top: 29.5rem !important;
  }

  .mt-sm-61 {
    margin-top: 30rem !important;
  }

  .mt-sm-62 {
    margin-top: 30.5rem !important;
  }

  .mt-sm-63 {
    margin-top: 31rem !important;
  }

  .mt-sm-64 {
    margin-top: 31.5rem !important;
  }

  .mt-sm-65 {
    margin-top: 32rem !important;
  }

  .mt-sm-66 {
    margin-top: 32.5rem !important;
  }

  .mt-sm-67 {
    margin-top: 33rem !important;
  }

  .mt-sm-68 {
    margin-top: 33.5rem !important;
  }

  .mt-sm-69 {
    margin-top: 34rem !important;
  }

  .mt-sm-70 {
    margin-top: 34.5rem !important;
  }

  .mt-sm-71 {
    margin-top: 35rem !important;
  }

  .mt-sm-72 {
    margin-top: 35.5rem !important;
  }

  .mt-sm-73 {
    margin-top: 36rem !important;
  }

  .mt-sm-74 {
    margin-top: 36.5rem !important;
  }

  .mt-sm-75 {
    margin-top: 37rem !important;
  }

  .mt-sm-76 {
    margin-top: 37.5rem !important;
  }

  .mt-sm-77 {
    margin-top: 38rem !important;
  }

  .mt-sm-78 {
    margin-top: 38.5rem !important;
  }

  .mt-sm-79 {
    margin-top: 39rem !important;
  }

  .mt-sm-80 {
    margin-top: 39.5rem !important;
  }

  .mt-sm-81 {
    margin-top: 40rem !important;
  }

  .mt-sm-82 {
    margin-top: 40.5rem !important;
  }

  .mt-sm-83 {
    margin-top: 41rem !important;
  }

  .mt-sm-84 {
    margin-top: 41.5rem !important;
  }

  .mt-sm-85 {
    margin-top: 42rem !important;
  }

  .mt-sm-86 {
    margin-top: 42.5rem !important;
  }

  .mt-sm-87 {
    margin-top: 43rem !important;
  }

  .mt-sm-88 {
    margin-top: 43.5rem !important;
  }

  .mt-sm-89 {
    margin-top: 44rem !important;
  }

  .mt-sm-90 {
    margin-top: 44.5rem !important;
  }

  .mt-sm-91 {
    margin-top: 45rem !important;
  }

  .mt-sm-92 {
    margin-top: 45.5rem !important;
  }

  .mt-sm-93 {
    margin-top: 46rem !important;
  }

  .mt-sm-94 {
    margin-top: 46.5rem !important;
  }

  .mt-sm-95 {
    margin-top: 47rem !important;
  }

  .mt-sm-96 {
    margin-top: 47.5rem !important;
  }

  .mt-sm-97 {
    margin-top: 48rem !important;
  }

  .mt-sm-98 {
    margin-top: 48.5rem !important;
  }

  .mt-sm-99 {
    margin-top: 49rem !important;
  }

  .mt-sm-100 {
    margin-top: 49.5rem !important;
  }

  .mt-sm-101 {
    margin-top: 50rem !important;
  }

  .mt-sm-102 {
    margin-top: 50.5rem !important;
  }

  .mt-sm-103 {
    margin-top: 51rem !important;
  }

  .mt-sm-104 {
    margin-top: 51.5rem !important;
  }

  .mt-sm-105 {
    margin-top: 52rem !important;
  }

  .mt-sm-106 {
    margin-top: 52.5rem !important;
  }

  .mt-sm-107 {
    margin-top: 53rem !important;
  }

  .mt-sm-108 {
    margin-top: 53.5rem !important;
  }

  .mt-sm-109 {
    margin-top: 54rem !important;
  }

  .mt-sm-110 {
    margin-top: 54.5rem !important;
  }

  .mt-sm-111 {
    margin-top: 55rem !important;
  }

  .mt-sm-112 {
    margin-top: 55.5rem !important;
  }

  .mt-sm-113 {
    margin-top: 56rem !important;
  }

  .mt-sm-114 {
    margin-top: 56.5rem !important;
  }

  .mt-sm-115 {
    margin-top: 57rem !important;
  }

  .mt-sm-116 {
    margin-top: 57.5rem !important;
  }

  .mt-sm-117 {
    margin-top: 58rem !important;
  }

  .mt-sm-118 {
    margin-top: 58.5rem !important;
  }

  .mt-sm-119 {
    margin-top: 59rem !important;
  }

  .mt-sm-120 {
    margin-top: 59.5rem !important;
  }

  .mt-sm-121 {
    margin-top: 60rem !important;
  }

  .mt-sm-122 {
    margin-top: 60.5rem !important;
  }

  .mt-sm-123 {
    margin-top: 61rem !important;
  }

  .mt-sm-124 {
    margin-top: 61.5rem !important;
  }

  .mt-sm-125 {
    margin-top: 62rem !important;
  }

  .mt-sm-126 {
    margin-top: 62.5rem !important;
  }

  .mt-sm-127 {
    margin-top: 63rem !important;
  }

  .mt-sm-128 {
    margin-top: 63.5rem !important;
  }

  .mt-sm-129 {
    margin-top: 64rem !important;
  }

  .mt-sm-130 {
    margin-top: 64.5rem !important;
  }

  .mt-sm-131 {
    margin-top: 65rem !important;
  }

  .mt-sm-132 {
    margin-top: 65.5rem !important;
  }

  .mt-sm-133 {
    margin-top: 66rem !important;
  }

  .mt-sm-134 {
    margin-top: 66.5rem !important;
  }

  .mt-sm-135 {
    margin-top: 67rem !important;
  }

  .mt-sm-136 {
    margin-top: 67.5rem !important;
  }

  .mt-sm-137 {
    margin-top: 68rem !important;
  }

  .mt-sm-138 {
    margin-top: 68.5rem !important;
  }

  .mt-sm-139 {
    margin-top: 69rem !important;
  }

  .mt-sm-140 {
    margin-top: 69.5rem !important;
  }

  .mt-sm-141 {
    margin-top: 70rem !important;
  }

  .mt-sm-142 {
    margin-top: 70.5rem !important;
  }

  .mt-sm-143 {
    margin-top: 71rem !important;
  }

  .mt-sm-144 {
    margin-top: 71.5rem !important;
  }

  .mt-sm-145 {
    margin-top: 72rem !important;
  }

  .mt-sm-146 {
    margin-top: 72.5rem !important;
  }

  .mt-sm-147 {
    margin-top: 73rem !important;
  }

  .mt-sm-148 {
    margin-top: 73.5rem !important;
  }

  .mt-sm-149 {
    margin-top: 74rem !important;
  }

  .mt-sm-150 {
    margin-top: 74.5rem !important;
  }

  .mt-sm-151 {
    margin-top: 75rem !important;
  }

  .mt-sm-152 {
    margin-top: 75.5rem !important;
  }

  .mt-sm-153 {
    margin-top: 76rem !important;
  }

  .mt-sm-154 {
    margin-top: 76.5rem !important;
  }

  .mt-sm-155 {
    margin-top: 77rem !important;
  }

  .mt-sm-156 {
    margin-top: 77.5rem !important;
  }

  .mt-sm-157 {
    margin-top: 78rem !important;
  }

  .mt-sm-158 {
    margin-top: 78.5rem !important;
  }

  .mt-sm-159 {
    margin-top: 79rem !important;
  }

  .mt-sm-160 {
    margin-top: 79.5rem !important;
  }

  .mb-sm-0 {
    margin-bottom: 0rem !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 2rem !important;
  }

  .mb-sm-6 {
    margin-bottom: 2.5rem !important;
  }

  .mb-sm-7 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-8 {
    margin-bottom: 3.5rem !important;
  }

  .mb-sm-9 {
    margin-bottom: 4rem !important;
  }

  .mb-sm-10 {
    margin-bottom: 4.5rem !important;
  }

  .mb-sm-11 {
    margin-bottom: 5rem !important;
  }

  .mb-sm-12 {
    margin-bottom: 5.5rem !important;
  }

  .mb-sm-13 {
    margin-bottom: 6rem !important;
  }

  .mb-sm-14 {
    margin-bottom: 6.5rem !important;
  }

  .mb-sm-15 {
    margin-bottom: 7rem !important;
  }

  .mb-sm-16 {
    margin-bottom: 7.5rem !important;
  }

  .mb-sm-17 {
    margin-bottom: 8rem !important;
  }

  .mb-sm-18 {
    margin-bottom: 8.5rem !important;
  }

  .mb-sm-19 {
    margin-bottom: 9rem !important;
  }

  .mb-sm-20 {
    margin-bottom: 9.5rem !important;
  }

  .mb-sm-21 {
    margin-bottom: 10rem !important;
  }

  .mb-sm-22 {
    margin-bottom: 10.5rem !important;
  }

  .mb-sm-23 {
    margin-bottom: 11rem !important;
  }

  .mb-sm-24 {
    margin-bottom: 11.5rem !important;
  }

  .mb-sm-25 {
    margin-bottom: 12rem !important;
  }

  .mb-sm-26 {
    margin-bottom: 12.5rem !important;
  }

  .mb-sm-27 {
    margin-bottom: 13rem !important;
  }

  .mb-sm-28 {
    margin-bottom: 13.5rem !important;
  }

  .mb-sm-29 {
    margin-bottom: 14rem !important;
  }

  .mb-sm-30 {
    margin-bottom: 14.5rem !important;
  }

  .mb-sm-31 {
    margin-bottom: 15rem !important;
  }

  .mb-sm-32 {
    margin-bottom: 15.5rem !important;
  }

  .mb-sm-33 {
    margin-bottom: 16rem !important;
  }

  .mb-sm-34 {
    margin-bottom: 16.5rem !important;
  }

  .mb-sm-35 {
    margin-bottom: 17rem !important;
  }

  .mb-sm-36 {
    margin-bottom: 17.5rem !important;
  }

  .mb-sm-37 {
    margin-bottom: 18rem !important;
  }

  .mb-sm-38 {
    margin-bottom: 18.5rem !important;
  }

  .mb-sm-39 {
    margin-bottom: 19rem !important;
  }

  .mb-sm-40 {
    margin-bottom: 19.5rem !important;
  }

  .mb-sm-41 {
    margin-bottom: 20rem !important;
  }

  .mb-sm-42 {
    margin-bottom: 20.5rem !important;
  }

  .mb-sm-43 {
    margin-bottom: 21rem !important;
  }

  .mb-sm-44 {
    margin-bottom: 21.5rem !important;
  }

  .mb-sm-45 {
    margin-bottom: 22rem !important;
  }

  .mb-sm-46 {
    margin-bottom: 22.5rem !important;
  }

  .mb-sm-47 {
    margin-bottom: 23rem !important;
  }

  .mb-sm-48 {
    margin-bottom: 23.5rem !important;
  }

  .mb-sm-49 {
    margin-bottom: 24rem !important;
  }

  .mb-sm-50 {
    margin-bottom: 24.5rem !important;
  }

  .mb-sm-51 {
    margin-bottom: 25rem !important;
  }

  .mb-sm-52 {
    margin-bottom: 25.5rem !important;
  }

  .mb-sm-53 {
    margin-bottom: 26rem !important;
  }

  .mb-sm-54 {
    margin-bottom: 26.5rem !important;
  }

  .mb-sm-55 {
    margin-bottom: 27rem !important;
  }

  .mb-sm-56 {
    margin-bottom: 27.5rem !important;
  }

  .mb-sm-57 {
    margin-bottom: 28rem !important;
  }

  .mb-sm-58 {
    margin-bottom: 28.5rem !important;
  }

  .mb-sm-59 {
    margin-bottom: 29rem !important;
  }

  .mb-sm-60 {
    margin-bottom: 29.5rem !important;
  }

  .mb-sm-61 {
    margin-bottom: 30rem !important;
  }

  .mb-sm-62 {
    margin-bottom: 30.5rem !important;
  }

  .mb-sm-63 {
    margin-bottom: 31rem !important;
  }

  .mb-sm-64 {
    margin-bottom: 31.5rem !important;
  }

  .mb-sm-65 {
    margin-bottom: 32rem !important;
  }

  .mb-sm-66 {
    margin-bottom: 32.5rem !important;
  }

  .mb-sm-67 {
    margin-bottom: 33rem !important;
  }

  .mb-sm-68 {
    margin-bottom: 33.5rem !important;
  }

  .mb-sm-69 {
    margin-bottom: 34rem !important;
  }

  .mb-sm-70 {
    margin-bottom: 34.5rem !important;
  }

  .mb-sm-71 {
    margin-bottom: 35rem !important;
  }

  .mb-sm-72 {
    margin-bottom: 35.5rem !important;
  }

  .mb-sm-73 {
    margin-bottom: 36rem !important;
  }

  .mb-sm-74 {
    margin-bottom: 36.5rem !important;
  }

  .mb-sm-75 {
    margin-bottom: 37rem !important;
  }

  .mb-sm-76 {
    margin-bottom: 37.5rem !important;
  }

  .mb-sm-77 {
    margin-bottom: 38rem !important;
  }

  .mb-sm-78 {
    margin-bottom: 38.5rem !important;
  }

  .mb-sm-79 {
    margin-bottom: 39rem !important;
  }

  .mb-sm-80 {
    margin-bottom: 39.5rem !important;
  }

  .mb-sm-81 {
    margin-bottom: 40rem !important;
  }

  .mb-sm-82 {
    margin-bottom: 40.5rem !important;
  }

  .mb-sm-83 {
    margin-bottom: 41rem !important;
  }

  .mb-sm-84 {
    margin-bottom: 41.5rem !important;
  }

  .mb-sm-85 {
    margin-bottom: 42rem !important;
  }

  .mb-sm-86 {
    margin-bottom: 42.5rem !important;
  }

  .mb-sm-87 {
    margin-bottom: 43rem !important;
  }

  .mb-sm-88 {
    margin-bottom: 43.5rem !important;
  }

  .mb-sm-89 {
    margin-bottom: 44rem !important;
  }

  .mb-sm-90 {
    margin-bottom: 44.5rem !important;
  }

  .mb-sm-91 {
    margin-bottom: 45rem !important;
  }

  .mb-sm-92 {
    margin-bottom: 45.5rem !important;
  }

  .mb-sm-93 {
    margin-bottom: 46rem !important;
  }

  .mb-sm-94 {
    margin-bottom: 46.5rem !important;
  }

  .mb-sm-95 {
    margin-bottom: 47rem !important;
  }

  .mb-sm-96 {
    margin-bottom: 47.5rem !important;
  }

  .mb-sm-97 {
    margin-bottom: 48rem !important;
  }

  .mb-sm-98 {
    margin-bottom: 48.5rem !important;
  }

  .mb-sm-99 {
    margin-bottom: 49rem !important;
  }

  .mb-sm-100 {
    margin-bottom: 49.5rem !important;
  }

  .mb-sm-101 {
    margin-bottom: 50rem !important;
  }

  .mb-sm-102 {
    margin-bottom: 50.5rem !important;
  }

  .mb-sm-103 {
    margin-bottom: 51rem !important;
  }

  .mb-sm-104 {
    margin-bottom: 51.5rem !important;
  }

  .mb-sm-105 {
    margin-bottom: 52rem !important;
  }

  .mb-sm-106 {
    margin-bottom: 52.5rem !important;
  }

  .mb-sm-107 {
    margin-bottom: 53rem !important;
  }

  .mb-sm-108 {
    margin-bottom: 53.5rem !important;
  }

  .mb-sm-109 {
    margin-bottom: 54rem !important;
  }

  .mb-sm-110 {
    margin-bottom: 54.5rem !important;
  }

  .mb-sm-111 {
    margin-bottom: 55rem !important;
  }

  .mb-sm-112 {
    margin-bottom: 55.5rem !important;
  }

  .mb-sm-113 {
    margin-bottom: 56rem !important;
  }

  .mb-sm-114 {
    margin-bottom: 56.5rem !important;
  }

  .mb-sm-115 {
    margin-bottom: 57rem !important;
  }

  .mb-sm-116 {
    margin-bottom: 57.5rem !important;
  }

  .mb-sm-117 {
    margin-bottom: 58rem !important;
  }

  .mb-sm-118 {
    margin-bottom: 58.5rem !important;
  }

  .mb-sm-119 {
    margin-bottom: 59rem !important;
  }

  .mb-sm-120 {
    margin-bottom: 59.5rem !important;
  }

  .mb-sm-121 {
    margin-bottom: 60rem !important;
  }

  .mb-sm-122 {
    margin-bottom: 60.5rem !important;
  }

  .mb-sm-123 {
    margin-bottom: 61rem !important;
  }

  .mb-sm-124 {
    margin-bottom: 61.5rem !important;
  }

  .mb-sm-125 {
    margin-bottom: 62rem !important;
  }

  .mb-sm-126 {
    margin-bottom: 62.5rem !important;
  }

  .mb-sm-127 {
    margin-bottom: 63rem !important;
  }

  .mb-sm-128 {
    margin-bottom: 63.5rem !important;
  }

  .mb-sm-129 {
    margin-bottom: 64rem !important;
  }

  .mb-sm-130 {
    margin-bottom: 64.5rem !important;
  }

  .mb-sm-131 {
    margin-bottom: 65rem !important;
  }

  .mb-sm-132 {
    margin-bottom: 65.5rem !important;
  }

  .mb-sm-133 {
    margin-bottom: 66rem !important;
  }

  .mb-sm-134 {
    margin-bottom: 66.5rem !important;
  }

  .mb-sm-135 {
    margin-bottom: 67rem !important;
  }

  .mb-sm-136 {
    margin-bottom: 67.5rem !important;
  }

  .mb-sm-137 {
    margin-bottom: 68rem !important;
  }

  .mb-sm-138 {
    margin-bottom: 68.5rem !important;
  }

  .mb-sm-139 {
    margin-bottom: 69rem !important;
  }

  .mb-sm-140 {
    margin-bottom: 69.5rem !important;
  }

  .mb-sm-141 {
    margin-bottom: 70rem !important;
  }

  .mb-sm-142 {
    margin-bottom: 70.5rem !important;
  }

  .mb-sm-143 {
    margin-bottom: 71rem !important;
  }

  .mb-sm-144 {
    margin-bottom: 71.5rem !important;
  }

  .mb-sm-145 {
    margin-bottom: 72rem !important;
  }

  .mb-sm-146 {
    margin-bottom: 72.5rem !important;
  }

  .mb-sm-147 {
    margin-bottom: 73rem !important;
  }

  .mb-sm-148 {
    margin-bottom: 73.5rem !important;
  }

  .mb-sm-149 {
    margin-bottom: 74rem !important;
  }

  .mb-sm-150 {
    margin-bottom: 74.5rem !important;
  }

  .mb-sm-151 {
    margin-bottom: 75rem !important;
  }

  .mb-sm-152 {
    margin-bottom: 75.5rem !important;
  }

  .mb-sm-153 {
    margin-bottom: 76rem !important;
  }

  .mb-sm-154 {
    margin-bottom: 76.5rem !important;
  }

  .mb-sm-155 {
    margin-bottom: 77rem !important;
  }

  .mb-sm-156 {
    margin-bottom: 77.5rem !important;
  }

  .mb-sm-157 {
    margin-bottom: 78rem !important;
  }

  .mb-sm-158 {
    margin-bottom: 78.5rem !important;
  }

  .mb-sm-159 {
    margin-bottom: 79rem !important;
  }

  .mb-sm-160 {
    margin-bottom: 79.5rem !important;
  }

  .ms-sm-0 {
    margin-left: 0rem !important;
  }

  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  .ms-sm-3 {
    margin-left: 1rem !important;
  }

  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }

  .ms-sm-5 {
    margin-left: 2rem !important;
  }

  .ms-sm-6 {
    margin-left: 2.5rem !important;
  }

  .ms-sm-7 {
    margin-left: 3rem !important;
  }

  .ms-sm-8 {
    margin-left: 3.5rem !important;
  }

  .ms-sm-9 {
    margin-left: 4rem !important;
  }

  .ms-sm-10 {
    margin-left: 4.5rem !important;
  }

  .ms-sm-11 {
    margin-left: 5rem !important;
  }

  .ms-sm-12 {
    margin-left: 5.5rem !important;
  }

  .ms-sm-13 {
    margin-left: 6rem !important;
  }

  .ms-sm-14 {
    margin-left: 6.5rem !important;
  }

  .ms-sm-15 {
    margin-left: 7rem !important;
  }

  .ms-sm-16 {
    margin-left: 7.5rem !important;
  }

  .ms-sm-17 {
    margin-left: 8rem !important;
  }

  .ms-sm-18 {
    margin-left: 8.5rem !important;
  }

  .ms-sm-19 {
    margin-left: 9rem !important;
  }

  .ms-sm-20 {
    margin-left: 9.5rem !important;
  }

  .ms-sm-21 {
    margin-left: 10rem !important;
  }

  .ms-sm-22 {
    margin-left: 10.5rem !important;
  }

  .ms-sm-23 {
    margin-left: 11rem !important;
  }

  .ms-sm-24 {
    margin-left: 11.5rem !important;
  }

  .ms-sm-25 {
    margin-left: 12rem !important;
  }

  .ms-sm-26 {
    margin-left: 12.5rem !important;
  }

  .ms-sm-27 {
    margin-left: 13rem !important;
  }

  .ms-sm-28 {
    margin-left: 13.5rem !important;
  }

  .ms-sm-29 {
    margin-left: 14rem !important;
  }

  .ms-sm-30 {
    margin-left: 14.5rem !important;
  }

  .ms-sm-31 {
    margin-left: 15rem !important;
  }

  .ms-sm-32 {
    margin-left: 15.5rem !important;
  }

  .ms-sm-33 {
    margin-left: 16rem !important;
  }

  .ms-sm-34 {
    margin-left: 16.5rem !important;
  }

  .ms-sm-35 {
    margin-left: 17rem !important;
  }

  .ms-sm-36 {
    margin-left: 17.5rem !important;
  }

  .ms-sm-37 {
    margin-left: 18rem !important;
  }

  .ms-sm-38 {
    margin-left: 18.5rem !important;
  }

  .ms-sm-39 {
    margin-left: 19rem !important;
  }

  .ms-sm-40 {
    margin-left: 19.5rem !important;
  }

  .ms-sm-41 {
    margin-left: 20rem !important;
  }

  .ms-sm-42 {
    margin-left: 20.5rem !important;
  }

  .ms-sm-43 {
    margin-left: 21rem !important;
  }

  .ms-sm-44 {
    margin-left: 21.5rem !important;
  }

  .ms-sm-45 {
    margin-left: 22rem !important;
  }

  .ms-sm-46 {
    margin-left: 22.5rem !important;
  }

  .ms-sm-47 {
    margin-left: 23rem !important;
  }

  .ms-sm-48 {
    margin-left: 23.5rem !important;
  }

  .ms-sm-49 {
    margin-left: 24rem !important;
  }

  .ms-sm-50 {
    margin-left: 24.5rem !important;
  }

  .ms-sm-51 {
    margin-left: 25rem !important;
  }

  .ms-sm-52 {
    margin-left: 25.5rem !important;
  }

  .ms-sm-53 {
    margin-left: 26rem !important;
  }

  .ms-sm-54 {
    margin-left: 26.5rem !important;
  }

  .ms-sm-55 {
    margin-left: 27rem !important;
  }

  .ms-sm-56 {
    margin-left: 27.5rem !important;
  }

  .ms-sm-57 {
    margin-left: 28rem !important;
  }

  .ms-sm-58 {
    margin-left: 28.5rem !important;
  }

  .ms-sm-59 {
    margin-left: 29rem !important;
  }

  .ms-sm-60 {
    margin-left: 29.5rem !important;
  }

  .ms-sm-61 {
    margin-left: 30rem !important;
  }

  .ms-sm-62 {
    margin-left: 30.5rem !important;
  }

  .ms-sm-63 {
    margin-left: 31rem !important;
  }

  .ms-sm-64 {
    margin-left: 31.5rem !important;
  }

  .ms-sm-65 {
    margin-left: 32rem !important;
  }

  .ms-sm-66 {
    margin-left: 32.5rem !important;
  }

  .ms-sm-67 {
    margin-left: 33rem !important;
  }

  .ms-sm-68 {
    margin-left: 33.5rem !important;
  }

  .ms-sm-69 {
    margin-left: 34rem !important;
  }

  .ms-sm-70 {
    margin-left: 34.5rem !important;
  }

  .ms-sm-71 {
    margin-left: 35rem !important;
  }

  .ms-sm-72 {
    margin-left: 35.5rem !important;
  }

  .ms-sm-73 {
    margin-left: 36rem !important;
  }

  .ms-sm-74 {
    margin-left: 36.5rem !important;
  }

  .ms-sm-75 {
    margin-left: 37rem !important;
  }

  .ms-sm-76 {
    margin-left: 37.5rem !important;
  }

  .ms-sm-77 {
    margin-left: 38rem !important;
  }

  .ms-sm-78 {
    margin-left: 38.5rem !important;
  }

  .ms-sm-79 {
    margin-left: 39rem !important;
  }

  .ms-sm-80 {
    margin-left: 39.5rem !important;
  }

  .ms-sm-81 {
    margin-left: 40rem !important;
  }

  .ms-sm-82 {
    margin-left: 40.5rem !important;
  }

  .ms-sm-83 {
    margin-left: 41rem !important;
  }

  .ms-sm-84 {
    margin-left: 41.5rem !important;
  }

  .ms-sm-85 {
    margin-left: 42rem !important;
  }

  .ms-sm-86 {
    margin-left: 42.5rem !important;
  }

  .ms-sm-87 {
    margin-left: 43rem !important;
  }

  .ms-sm-88 {
    margin-left: 43.5rem !important;
  }

  .ms-sm-89 {
    margin-left: 44rem !important;
  }

  .ms-sm-90 {
    margin-left: 44.5rem !important;
  }

  .ms-sm-91 {
    margin-left: 45rem !important;
  }

  .ms-sm-92 {
    margin-left: 45.5rem !important;
  }

  .ms-sm-93 {
    margin-left: 46rem !important;
  }

  .ms-sm-94 {
    margin-left: 46.5rem !important;
  }

  .ms-sm-95 {
    margin-left: 47rem !important;
  }

  .ms-sm-96 {
    margin-left: 47.5rem !important;
  }

  .ms-sm-97 {
    margin-left: 48rem !important;
  }

  .ms-sm-98 {
    margin-left: 48.5rem !important;
  }

  .ms-sm-99 {
    margin-left: 49rem !important;
  }

  .ms-sm-100 {
    margin-left: 49.5rem !important;
  }

  .ms-sm-101 {
    margin-left: 50rem !important;
  }

  .ms-sm-102 {
    margin-left: 50.5rem !important;
  }

  .ms-sm-103 {
    margin-left: 51rem !important;
  }

  .ms-sm-104 {
    margin-left: 51.5rem !important;
  }

  .ms-sm-105 {
    margin-left: 52rem !important;
  }

  .ms-sm-106 {
    margin-left: 52.5rem !important;
  }

  .ms-sm-107 {
    margin-left: 53rem !important;
  }

  .ms-sm-108 {
    margin-left: 53.5rem !important;
  }

  .ms-sm-109 {
    margin-left: 54rem !important;
  }

  .ms-sm-110 {
    margin-left: 54.5rem !important;
  }

  .ms-sm-111 {
    margin-left: 55rem !important;
  }

  .ms-sm-112 {
    margin-left: 55.5rem !important;
  }

  .ms-sm-113 {
    margin-left: 56rem !important;
  }

  .ms-sm-114 {
    margin-left: 56.5rem !important;
  }

  .ms-sm-115 {
    margin-left: 57rem !important;
  }

  .ms-sm-116 {
    margin-left: 57.5rem !important;
  }

  .ms-sm-117 {
    margin-left: 58rem !important;
  }

  .ms-sm-118 {
    margin-left: 58.5rem !important;
  }

  .ms-sm-119 {
    margin-left: 59rem !important;
  }

  .ms-sm-120 {
    margin-left: 59.5rem !important;
  }

  .ms-sm-121 {
    margin-left: 60rem !important;
  }

  .ms-sm-122 {
    margin-left: 60.5rem !important;
  }

  .ms-sm-123 {
    margin-left: 61rem !important;
  }

  .ms-sm-124 {
    margin-left: 61.5rem !important;
  }

  .ms-sm-125 {
    margin-left: 62rem !important;
  }

  .ms-sm-126 {
    margin-left: 62.5rem !important;
  }

  .ms-sm-127 {
    margin-left: 63rem !important;
  }

  .ms-sm-128 {
    margin-left: 63.5rem !important;
  }

  .ms-sm-129 {
    margin-left: 64rem !important;
  }

  .ms-sm-130 {
    margin-left: 64.5rem !important;
  }

  .ms-sm-131 {
    margin-left: 65rem !important;
  }

  .ms-sm-132 {
    margin-left: 65.5rem !important;
  }

  .ms-sm-133 {
    margin-left: 66rem !important;
  }

  .ms-sm-134 {
    margin-left: 66.5rem !important;
  }

  .ms-sm-135 {
    margin-left: 67rem !important;
  }

  .ms-sm-136 {
    margin-left: 67.5rem !important;
  }

  .ms-sm-137 {
    margin-left: 68rem !important;
  }

  .ms-sm-138 {
    margin-left: 68.5rem !important;
  }

  .ms-sm-139 {
    margin-left: 69rem !important;
  }

  .ms-sm-140 {
    margin-left: 69.5rem !important;
  }

  .ms-sm-141 {
    margin-left: 70rem !important;
  }

  .ms-sm-142 {
    margin-left: 70.5rem !important;
  }

  .ms-sm-143 {
    margin-left: 71rem !important;
  }

  .ms-sm-144 {
    margin-left: 71.5rem !important;
  }

  .ms-sm-145 {
    margin-left: 72rem !important;
  }

  .ms-sm-146 {
    margin-left: 72.5rem !important;
  }

  .ms-sm-147 {
    margin-left: 73rem !important;
  }

  .ms-sm-148 {
    margin-left: 73.5rem !important;
  }

  .ms-sm-149 {
    margin-left: 74rem !important;
  }

  .ms-sm-150 {
    margin-left: 74.5rem !important;
  }

  .ms-sm-151 {
    margin-left: 75rem !important;
  }

  .ms-sm-152 {
    margin-left: 75.5rem !important;
  }

  .ms-sm-153 {
    margin-left: 76rem !important;
  }

  .ms-sm-154 {
    margin-left: 76.5rem !important;
  }

  .ms-sm-155 {
    margin-left: 77rem !important;
  }

  .ms-sm-156 {
    margin-left: 77.5rem !important;
  }

  .ms-sm-157 {
    margin-left: 78rem !important;
  }

  .ms-sm-158 {
    margin-left: 78.5rem !important;
  }

  .ms-sm-159 {
    margin-left: 79rem !important;
  }

  .ms-sm-160 {
    margin-left: 79.5rem !important;
  }

  .me-sm-0 {
    margin-right: 0rem !important;
  }

  .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  .me-sm-3 {
    margin-right: 1rem !important;
  }

  .me-sm-4 {
    margin-right: 1.5rem !important;
  }

  .me-sm-5 {
    margin-right: 2rem !important;
  }

  .me-sm-6 {
    margin-right: 2.5rem !important;
  }

  .me-sm-7 {
    margin-right: 3rem !important;
  }

  .me-sm-8 {
    margin-right: 3.5rem !important;
  }

  .me-sm-9 {
    margin-right: 4rem !important;
  }

  .me-sm-10 {
    margin-right: 4.5rem !important;
  }

  .me-sm-11 {
    margin-right: 5rem !important;
  }

  .me-sm-12 {
    margin-right: 5.5rem !important;
  }

  .me-sm-13 {
    margin-right: 6rem !important;
  }

  .me-sm-14 {
    margin-right: 6.5rem !important;
  }

  .me-sm-15 {
    margin-right: 7rem !important;
  }

  .me-sm-16 {
    margin-right: 7.5rem !important;
  }

  .me-sm-17 {
    margin-right: 8rem !important;
  }

  .me-sm-18 {
    margin-right: 8.5rem !important;
  }

  .me-sm-19 {
    margin-right: 9rem !important;
  }

  .me-sm-20 {
    margin-right: 9.5rem !important;
  }

  .me-sm-21 {
    margin-right: 10rem !important;
  }

  .me-sm-22 {
    margin-right: 10.5rem !important;
  }

  .me-sm-23 {
    margin-right: 11rem !important;
  }

  .me-sm-24 {
    margin-right: 11.5rem !important;
  }

  .me-sm-25 {
    margin-right: 12rem !important;
  }

  .me-sm-26 {
    margin-right: 12.5rem !important;
  }

  .me-sm-27 {
    margin-right: 13rem !important;
  }

  .me-sm-28 {
    margin-right: 13.5rem !important;
  }

  .me-sm-29 {
    margin-right: 14rem !important;
  }

  .me-sm-30 {
    margin-right: 14.5rem !important;
  }

  .me-sm-31 {
    margin-right: 15rem !important;
  }

  .me-sm-32 {
    margin-right: 15.5rem !important;
  }

  .me-sm-33 {
    margin-right: 16rem !important;
  }

  .me-sm-34 {
    margin-right: 16.5rem !important;
  }

  .me-sm-35 {
    margin-right: 17rem !important;
  }

  .me-sm-36 {
    margin-right: 17.5rem !important;
  }

  .me-sm-37 {
    margin-right: 18rem !important;
  }

  .me-sm-38 {
    margin-right: 18.5rem !important;
  }

  .me-sm-39 {
    margin-right: 19rem !important;
  }

  .me-sm-40 {
    margin-right: 19.5rem !important;
  }

  .me-sm-41 {
    margin-right: 20rem !important;
  }

  .me-sm-42 {
    margin-right: 20.5rem !important;
  }

  .me-sm-43 {
    margin-right: 21rem !important;
  }

  .me-sm-44 {
    margin-right: 21.5rem !important;
  }

  .me-sm-45 {
    margin-right: 22rem !important;
  }

  .me-sm-46 {
    margin-right: 22.5rem !important;
  }

  .me-sm-47 {
    margin-right: 23rem !important;
  }

  .me-sm-48 {
    margin-right: 23.5rem !important;
  }

  .me-sm-49 {
    margin-right: 24rem !important;
  }

  .me-sm-50 {
    margin-right: 24.5rem !important;
  }

  .me-sm-51 {
    margin-right: 25rem !important;
  }

  .me-sm-52 {
    margin-right: 25.5rem !important;
  }

  .me-sm-53 {
    margin-right: 26rem !important;
  }

  .me-sm-54 {
    margin-right: 26.5rem !important;
  }

  .me-sm-55 {
    margin-right: 27rem !important;
  }

  .me-sm-56 {
    margin-right: 27.5rem !important;
  }

  .me-sm-57 {
    margin-right: 28rem !important;
  }

  .me-sm-58 {
    margin-right: 28.5rem !important;
  }

  .me-sm-59 {
    margin-right: 29rem !important;
  }

  .me-sm-60 {
    margin-right: 29.5rem !important;
  }

  .me-sm-61 {
    margin-right: 30rem !important;
  }

  .me-sm-62 {
    margin-right: 30.5rem !important;
  }

  .me-sm-63 {
    margin-right: 31rem !important;
  }

  .me-sm-64 {
    margin-right: 31.5rem !important;
  }

  .me-sm-65 {
    margin-right: 32rem !important;
  }

  .me-sm-66 {
    margin-right: 32.5rem !important;
  }

  .me-sm-67 {
    margin-right: 33rem !important;
  }

  .me-sm-68 {
    margin-right: 33.5rem !important;
  }

  .me-sm-69 {
    margin-right: 34rem !important;
  }

  .me-sm-70 {
    margin-right: 34.5rem !important;
  }

  .me-sm-71 {
    margin-right: 35rem !important;
  }

  .me-sm-72 {
    margin-right: 35.5rem !important;
  }

  .me-sm-73 {
    margin-right: 36rem !important;
  }

  .me-sm-74 {
    margin-right: 36.5rem !important;
  }

  .me-sm-75 {
    margin-right: 37rem !important;
  }

  .me-sm-76 {
    margin-right: 37.5rem !important;
  }

  .me-sm-77 {
    margin-right: 38rem !important;
  }

  .me-sm-78 {
    margin-right: 38.5rem !important;
  }

  .me-sm-79 {
    margin-right: 39rem !important;
  }

  .me-sm-80 {
    margin-right: 39.5rem !important;
  }

  .me-sm-81 {
    margin-right: 40rem !important;
  }

  .me-sm-82 {
    margin-right: 40.5rem !important;
  }

  .me-sm-83 {
    margin-right: 41rem !important;
  }

  .me-sm-84 {
    margin-right: 41.5rem !important;
  }

  .me-sm-85 {
    margin-right: 42rem !important;
  }

  .me-sm-86 {
    margin-right: 42.5rem !important;
  }

  .me-sm-87 {
    margin-right: 43rem !important;
  }

  .me-sm-88 {
    margin-right: 43.5rem !important;
  }

  .me-sm-89 {
    margin-right: 44rem !important;
  }

  .me-sm-90 {
    margin-right: 44.5rem !important;
  }

  .me-sm-91 {
    margin-right: 45rem !important;
  }

  .me-sm-92 {
    margin-right: 45.5rem !important;
  }

  .me-sm-93 {
    margin-right: 46rem !important;
  }

  .me-sm-94 {
    margin-right: 46.5rem !important;
  }

  .me-sm-95 {
    margin-right: 47rem !important;
  }

  .me-sm-96 {
    margin-right: 47.5rem !important;
  }

  .me-sm-97 {
    margin-right: 48rem !important;
  }

  .me-sm-98 {
    margin-right: 48.5rem !important;
  }

  .me-sm-99 {
    margin-right: 49rem !important;
  }

  .me-sm-100 {
    margin-right: 49.5rem !important;
  }

  .me-sm-101 {
    margin-right: 50rem !important;
  }

  .me-sm-102 {
    margin-right: 50.5rem !important;
  }

  .me-sm-103 {
    margin-right: 51rem !important;
  }

  .me-sm-104 {
    margin-right: 51.5rem !important;
  }

  .me-sm-105 {
    margin-right: 52rem !important;
  }

  .me-sm-106 {
    margin-right: 52.5rem !important;
  }

  .me-sm-107 {
    margin-right: 53rem !important;
  }

  .me-sm-108 {
    margin-right: 53.5rem !important;
  }

  .me-sm-109 {
    margin-right: 54rem !important;
  }

  .me-sm-110 {
    margin-right: 54.5rem !important;
  }

  .me-sm-111 {
    margin-right: 55rem !important;
  }

  .me-sm-112 {
    margin-right: 55.5rem !important;
  }

  .me-sm-113 {
    margin-right: 56rem !important;
  }

  .me-sm-114 {
    margin-right: 56.5rem !important;
  }

  .me-sm-115 {
    margin-right: 57rem !important;
  }

  .me-sm-116 {
    margin-right: 57.5rem !important;
  }

  .me-sm-117 {
    margin-right: 58rem !important;
  }

  .me-sm-118 {
    margin-right: 58.5rem !important;
  }

  .me-sm-119 {
    margin-right: 59rem !important;
  }

  .me-sm-120 {
    margin-right: 59.5rem !important;
  }

  .me-sm-121 {
    margin-right: 60rem !important;
  }

  .me-sm-122 {
    margin-right: 60.5rem !important;
  }

  .me-sm-123 {
    margin-right: 61rem !important;
  }

  .me-sm-124 {
    margin-right: 61.5rem !important;
  }

  .me-sm-125 {
    margin-right: 62rem !important;
  }

  .me-sm-126 {
    margin-right: 62.5rem !important;
  }

  .me-sm-127 {
    margin-right: 63rem !important;
  }

  .me-sm-128 {
    margin-right: 63.5rem !important;
  }

  .me-sm-129 {
    margin-right: 64rem !important;
  }

  .me-sm-130 {
    margin-right: 64.5rem !important;
  }

  .me-sm-131 {
    margin-right: 65rem !important;
  }

  .me-sm-132 {
    margin-right: 65.5rem !important;
  }

  .me-sm-133 {
    margin-right: 66rem !important;
  }

  .me-sm-134 {
    margin-right: 66.5rem !important;
  }

  .me-sm-135 {
    margin-right: 67rem !important;
  }

  .me-sm-136 {
    margin-right: 67.5rem !important;
  }

  .me-sm-137 {
    margin-right: 68rem !important;
  }

  .me-sm-138 {
    margin-right: 68.5rem !important;
  }

  .me-sm-139 {
    margin-right: 69rem !important;
  }

  .me-sm-140 {
    margin-right: 69.5rem !important;
  }

  .me-sm-141 {
    margin-right: 70rem !important;
  }

  .me-sm-142 {
    margin-right: 70.5rem !important;
  }

  .me-sm-143 {
    margin-right: 71rem !important;
  }

  .me-sm-144 {
    margin-right: 71.5rem !important;
  }

  .me-sm-145 {
    margin-right: 72rem !important;
  }

  .me-sm-146 {
    margin-right: 72.5rem !important;
  }

  .me-sm-147 {
    margin-right: 73rem !important;
  }

  .me-sm-148 {
    margin-right: 73.5rem !important;
  }

  .me-sm-149 {
    margin-right: 74rem !important;
  }

  .me-sm-150 {
    margin-right: 74.5rem !important;
  }

  .me-sm-151 {
    margin-right: 75rem !important;
  }

  .me-sm-152 {
    margin-right: 75.5rem !important;
  }

  .me-sm-153 {
    margin-right: 76rem !important;
  }

  .me-sm-154 {
    margin-right: 76.5rem !important;
  }

  .me-sm-155 {
    margin-right: 77rem !important;
  }

  .me-sm-156 {
    margin-right: 77.5rem !important;
  }

  .me-sm-157 {
    margin-right: 78rem !important;
  }

  .me-sm-158 {
    margin-right: 78.5rem !important;
  }

  .me-sm-159 {
    margin-right: 79rem !important;
  }

  .me-sm-160 {
    margin-right: 79.5rem !important;
  }

  .mx-sm-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }

  .mx-sm-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .mx-sm-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  .mx-sm-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  .mx-sm-6 {
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  .mx-sm-7 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  .mx-sm-8 {
    margin-left: 3.5rem !important;
    margin-right: 3.5rem !important;
  }

  .mx-sm-9 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  .mx-sm-10 {
    margin-left: 4.5rem !important;
    margin-right: 4.5rem !important;
  }

  .mx-sm-11 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  .mx-sm-12 {
    margin-left: 5.5rem !important;
    margin-right: 5.5rem !important;
  }

  .mx-sm-13 {
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  .mx-sm-14 {
    margin-left: 6.5rem !important;
    margin-right: 6.5rem !important;
  }

  .mx-sm-15 {
    margin-left: 7rem !important;
    margin-right: 7rem !important;
  }

  .mx-sm-16 {
    margin-left: 7.5rem !important;
    margin-right: 7.5rem !important;
  }

  .mx-sm-17 {
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  .mx-sm-18 {
    margin-left: 8.5rem !important;
    margin-right: 8.5rem !important;
  }

  .mx-sm-19 {
    margin-left: 9rem !important;
    margin-right: 9rem !important;
  }

  .mx-sm-20 {
    margin-left: 9.5rem !important;
    margin-right: 9.5rem !important;
  }

  .mx-sm-21 {
    margin-left: 10rem !important;
    margin-right: 10rem !important;
  }

  .mx-sm-22 {
    margin-left: 10.5rem !important;
    margin-right: 10.5rem !important;
  }

  .mx-sm-23 {
    margin-left: 11rem !important;
    margin-right: 11rem !important;
  }

  .mx-sm-24 {
    margin-left: 11.5rem !important;
    margin-right: 11.5rem !important;
  }

  .mx-sm-25 {
    margin-left: 12rem !important;
    margin-right: 12rem !important;
  }

  .mx-sm-26 {
    margin-left: 12.5rem !important;
    margin-right: 12.5rem !important;
  }

  .mx-sm-27 {
    margin-left: 13rem !important;
    margin-right: 13rem !important;
  }

  .mx-sm-28 {
    margin-left: 13.5rem !important;
    margin-right: 13.5rem !important;
  }

  .mx-sm-29 {
    margin-left: 14rem !important;
    margin-right: 14rem !important;
  }

  .mx-sm-30 {
    margin-left: 14.5rem !important;
    margin-right: 14.5rem !important;
  }

  .mx-sm-31 {
    margin-left: 15rem !important;
    margin-right: 15rem !important;
  }

  .mx-sm-32 {
    margin-left: 15.5rem !important;
    margin-right: 15.5rem !important;
  }

  .mx-sm-33 {
    margin-left: 16rem !important;
    margin-right: 16rem !important;
  }

  .mx-sm-34 {
    margin-left: 16.5rem !important;
    margin-right: 16.5rem !important;
  }

  .mx-sm-35 {
    margin-left: 17rem !important;
    margin-right: 17rem !important;
  }

  .mx-sm-36 {
    margin-left: 17.5rem !important;
    margin-right: 17.5rem !important;
  }

  .mx-sm-37 {
    margin-left: 18rem !important;
    margin-right: 18rem !important;
  }

  .mx-sm-38 {
    margin-left: 18.5rem !important;
    margin-right: 18.5rem !important;
  }

  .mx-sm-39 {
    margin-left: 19rem !important;
    margin-right: 19rem !important;
  }

  .mx-sm-40 {
    margin-left: 19.5rem !important;
    margin-right: 19.5rem !important;
  }

  .mx-sm-41 {
    margin-left: 20rem !important;
    margin-right: 20rem !important;
  }

  .mx-sm-42 {
    margin-left: 20.5rem !important;
    margin-right: 20.5rem !important;
  }

  .mx-sm-43 {
    margin-left: 21rem !important;
    margin-right: 21rem !important;
  }

  .mx-sm-44 {
    margin-left: 21.5rem !important;
    margin-right: 21.5rem !important;
  }

  .mx-sm-45 {
    margin-left: 22rem !important;
    margin-right: 22rem !important;
  }

  .mx-sm-46 {
    margin-left: 22.5rem !important;
    margin-right: 22.5rem !important;
  }

  .mx-sm-47 {
    margin-left: 23rem !important;
    margin-right: 23rem !important;
  }

  .mx-sm-48 {
    margin-left: 23.5rem !important;
    margin-right: 23.5rem !important;
  }

  .mx-sm-49 {
    margin-left: 24rem !important;
    margin-right: 24rem !important;
  }

  .mx-sm-50 {
    margin-left: 24.5rem !important;
    margin-right: 24.5rem !important;
  }

  .mx-sm-51 {
    margin-left: 25rem !important;
    margin-right: 25rem !important;
  }

  .mx-sm-52 {
    margin-left: 25.5rem !important;
    margin-right: 25.5rem !important;
  }

  .mx-sm-53 {
    margin-left: 26rem !important;
    margin-right: 26rem !important;
  }

  .mx-sm-54 {
    margin-left: 26.5rem !important;
    margin-right: 26.5rem !important;
  }

  .mx-sm-55 {
    margin-left: 27rem !important;
    margin-right: 27rem !important;
  }

  .mx-sm-56 {
    margin-left: 27.5rem !important;
    margin-right: 27.5rem !important;
  }

  .mx-sm-57 {
    margin-left: 28rem !important;
    margin-right: 28rem !important;
  }

  .mx-sm-58 {
    margin-left: 28.5rem !important;
    margin-right: 28.5rem !important;
  }

  .mx-sm-59 {
    margin-left: 29rem !important;
    margin-right: 29rem !important;
  }

  .mx-sm-60 {
    margin-left: 29.5rem !important;
    margin-right: 29.5rem !important;
  }

  .mx-sm-61 {
    margin-left: 30rem !important;
    margin-right: 30rem !important;
  }

  .mx-sm-62 {
    margin-left: 30.5rem !important;
    margin-right: 30.5rem !important;
  }

  .mx-sm-63 {
    margin-left: 31rem !important;
    margin-right: 31rem !important;
  }

  .mx-sm-64 {
    margin-left: 31.5rem !important;
    margin-right: 31.5rem !important;
  }

  .mx-sm-65 {
    margin-left: 32rem !important;
    margin-right: 32rem !important;
  }

  .mx-sm-66 {
    margin-left: 32.5rem !important;
    margin-right: 32.5rem !important;
  }

  .mx-sm-67 {
    margin-left: 33rem !important;
    margin-right: 33rem !important;
  }

  .mx-sm-68 {
    margin-left: 33.5rem !important;
    margin-right: 33.5rem !important;
  }

  .mx-sm-69 {
    margin-left: 34rem !important;
    margin-right: 34rem !important;
  }

  .mx-sm-70 {
    margin-left: 34.5rem !important;
    margin-right: 34.5rem !important;
  }

  .mx-sm-71 {
    margin-left: 35rem !important;
    margin-right: 35rem !important;
  }

  .mx-sm-72 {
    margin-left: 35.5rem !important;
    margin-right: 35.5rem !important;
  }

  .mx-sm-73 {
    margin-left: 36rem !important;
    margin-right: 36rem !important;
  }

  .mx-sm-74 {
    margin-left: 36.5rem !important;
    margin-right: 36.5rem !important;
  }

  .mx-sm-75 {
    margin-left: 37rem !important;
    margin-right: 37rem !important;
  }

  .mx-sm-76 {
    margin-left: 37.5rem !important;
    margin-right: 37.5rem !important;
  }

  .mx-sm-77 {
    margin-left: 38rem !important;
    margin-right: 38rem !important;
  }

  .mx-sm-78 {
    margin-left: 38.5rem !important;
    margin-right: 38.5rem !important;
  }

  .mx-sm-79 {
    margin-left: 39rem !important;
    margin-right: 39rem !important;
  }

  .mx-sm-80 {
    margin-left: 39.5rem !important;
    margin-right: 39.5rem !important;
  }

  .mx-sm-81 {
    margin-left: 40rem !important;
    margin-right: 40rem !important;
  }

  .mx-sm-82 {
    margin-left: 40.5rem !important;
    margin-right: 40.5rem !important;
  }

  .mx-sm-83 {
    margin-left: 41rem !important;
    margin-right: 41rem !important;
  }

  .mx-sm-84 {
    margin-left: 41.5rem !important;
    margin-right: 41.5rem !important;
  }

  .mx-sm-85 {
    margin-left: 42rem !important;
    margin-right: 42rem !important;
  }

  .mx-sm-86 {
    margin-left: 42.5rem !important;
    margin-right: 42.5rem !important;
  }

  .mx-sm-87 {
    margin-left: 43rem !important;
    margin-right: 43rem !important;
  }

  .mx-sm-88 {
    margin-left: 43.5rem !important;
    margin-right: 43.5rem !important;
  }

  .mx-sm-89 {
    margin-left: 44rem !important;
    margin-right: 44rem !important;
  }

  .mx-sm-90 {
    margin-left: 44.5rem !important;
    margin-right: 44.5rem !important;
  }

  .mx-sm-91 {
    margin-left: 45rem !important;
    margin-right: 45rem !important;
  }

  .mx-sm-92 {
    margin-left: 45.5rem !important;
    margin-right: 45.5rem !important;
  }

  .mx-sm-93 {
    margin-left: 46rem !important;
    margin-right: 46rem !important;
  }

  .mx-sm-94 {
    margin-left: 46.5rem !important;
    margin-right: 46.5rem !important;
  }

  .mx-sm-95 {
    margin-left: 47rem !important;
    margin-right: 47rem !important;
  }

  .mx-sm-96 {
    margin-left: 47.5rem !important;
    margin-right: 47.5rem !important;
  }

  .mx-sm-97 {
    margin-left: 48rem !important;
    margin-right: 48rem !important;
  }

  .mx-sm-98 {
    margin-left: 48.5rem !important;
    margin-right: 48.5rem !important;
  }

  .mx-sm-99 {
    margin-left: 49rem !important;
    margin-right: 49rem !important;
  }

  .mx-sm-100 {
    margin-left: 49.5rem !important;
    margin-right: 49.5rem !important;
  }

  .mx-sm-101 {
    margin-left: 50rem !important;
    margin-right: 50rem !important;
  }

  .mx-sm-102 {
    margin-left: 50.5rem !important;
    margin-right: 50.5rem !important;
  }

  .mx-sm-103 {
    margin-left: 51rem !important;
    margin-right: 51rem !important;
  }

  .mx-sm-104 {
    margin-left: 51.5rem !important;
    margin-right: 51.5rem !important;
  }

  .mx-sm-105 {
    margin-left: 52rem !important;
    margin-right: 52rem !important;
  }

  .mx-sm-106 {
    margin-left: 52.5rem !important;
    margin-right: 52.5rem !important;
  }

  .mx-sm-107 {
    margin-left: 53rem !important;
    margin-right: 53rem !important;
  }

  .mx-sm-108 {
    margin-left: 53.5rem !important;
    margin-right: 53.5rem !important;
  }

  .mx-sm-109 {
    margin-left: 54rem !important;
    margin-right: 54rem !important;
  }

  .mx-sm-110 {
    margin-left: 54.5rem !important;
    margin-right: 54.5rem !important;
  }

  .mx-sm-111 {
    margin-left: 55rem !important;
    margin-right: 55rem !important;
  }

  .mx-sm-112 {
    margin-left: 55.5rem !important;
    margin-right: 55.5rem !important;
  }

  .mx-sm-113 {
    margin-left: 56rem !important;
    margin-right: 56rem !important;
  }

  .mx-sm-114 {
    margin-left: 56.5rem !important;
    margin-right: 56.5rem !important;
  }

  .mx-sm-115 {
    margin-left: 57rem !important;
    margin-right: 57rem !important;
  }

  .mx-sm-116 {
    margin-left: 57.5rem !important;
    margin-right: 57.5rem !important;
  }

  .mx-sm-117 {
    margin-left: 58rem !important;
    margin-right: 58rem !important;
  }

  .mx-sm-118 {
    margin-left: 58.5rem !important;
    margin-right: 58.5rem !important;
  }

  .mx-sm-119 {
    margin-left: 59rem !important;
    margin-right: 59rem !important;
  }

  .mx-sm-120 {
    margin-left: 59.5rem !important;
    margin-right: 59.5rem !important;
  }

  .mx-sm-121 {
    margin-left: 60rem !important;
    margin-right: 60rem !important;
  }

  .mx-sm-122 {
    margin-left: 60.5rem !important;
    margin-right: 60.5rem !important;
  }

  .mx-sm-123 {
    margin-left: 61rem !important;
    margin-right: 61rem !important;
  }

  .mx-sm-124 {
    margin-left: 61.5rem !important;
    margin-right: 61.5rem !important;
  }

  .mx-sm-125 {
    margin-left: 62rem !important;
    margin-right: 62rem !important;
  }

  .mx-sm-126 {
    margin-left: 62.5rem !important;
    margin-right: 62.5rem !important;
  }

  .mx-sm-127 {
    margin-left: 63rem !important;
    margin-right: 63rem !important;
  }

  .mx-sm-128 {
    margin-left: 63.5rem !important;
    margin-right: 63.5rem !important;
  }

  .mx-sm-129 {
    margin-left: 64rem !important;
    margin-right: 64rem !important;
  }

  .mx-sm-130 {
    margin-left: 64.5rem !important;
    margin-right: 64.5rem !important;
  }

  .mx-sm-131 {
    margin-left: 65rem !important;
    margin-right: 65rem !important;
  }

  .mx-sm-132 {
    margin-left: 65.5rem !important;
    margin-right: 65.5rem !important;
  }

  .mx-sm-133 {
    margin-left: 66rem !important;
    margin-right: 66rem !important;
  }

  .mx-sm-134 {
    margin-left: 66.5rem !important;
    margin-right: 66.5rem !important;
  }

  .mx-sm-135 {
    margin-left: 67rem !important;
    margin-right: 67rem !important;
  }

  .mx-sm-136 {
    margin-left: 67.5rem !important;
    margin-right: 67.5rem !important;
  }

  .mx-sm-137 {
    margin-left: 68rem !important;
    margin-right: 68rem !important;
  }

  .mx-sm-138 {
    margin-left: 68.5rem !important;
    margin-right: 68.5rem !important;
  }

  .mx-sm-139 {
    margin-left: 69rem !important;
    margin-right: 69rem !important;
  }

  .mx-sm-140 {
    margin-left: 69.5rem !important;
    margin-right: 69.5rem !important;
  }

  .mx-sm-141 {
    margin-left: 70rem !important;
    margin-right: 70rem !important;
  }

  .mx-sm-142 {
    margin-left: 70.5rem !important;
    margin-right: 70.5rem !important;
  }

  .mx-sm-143 {
    margin-left: 71rem !important;
    margin-right: 71rem !important;
  }

  .mx-sm-144 {
    margin-left: 71.5rem !important;
    margin-right: 71.5rem !important;
  }

  .mx-sm-145 {
    margin-left: 72rem !important;
    margin-right: 72rem !important;
  }

  .mx-sm-146 {
    margin-left: 72.5rem !important;
    margin-right: 72.5rem !important;
  }

  .mx-sm-147 {
    margin-left: 73rem !important;
    margin-right: 73rem !important;
  }

  .mx-sm-148 {
    margin-left: 73.5rem !important;
    margin-right: 73.5rem !important;
  }

  .mx-sm-149 {
    margin-left: 74rem !important;
    margin-right: 74rem !important;
  }

  .mx-sm-150 {
    margin-left: 74.5rem !important;
    margin-right: 74.5rem !important;
  }

  .mx-sm-151 {
    margin-left: 75rem !important;
    margin-right: 75rem !important;
  }

  .mx-sm-152 {
    margin-left: 75.5rem !important;
    margin-right: 75.5rem !important;
  }

  .mx-sm-153 {
    margin-left: 76rem !important;
    margin-right: 76rem !important;
  }

  .mx-sm-154 {
    margin-left: 76.5rem !important;
    margin-right: 76.5rem !important;
  }

  .mx-sm-155 {
    margin-left: 77rem !important;
    margin-right: 77rem !important;
  }

  .mx-sm-156 {
    margin-left: 77.5rem !important;
    margin-right: 77.5rem !important;
  }

  .mx-sm-157 {
    margin-left: 78rem !important;
    margin-right: 78rem !important;
  }

  .mx-sm-158 {
    margin-left: 78.5rem !important;
    margin-right: 78.5rem !important;
  }

  .mx-sm-159 {
    margin-left: 79rem !important;
    margin-right: 79rem !important;
  }

  .mx-sm-160 {
    margin-left: 79.5rem !important;
    margin-right: 79.5rem !important;
  }

  .my-sm-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-sm-6 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-sm-7 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-8 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-sm-9 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-sm-10 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-sm-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-sm-12 {
    margin-top: 5.5rem !important;
    margin-bottom: 5.5rem !important;
  }

  .my-sm-13 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  .my-sm-14 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }

  .my-sm-15 {
    margin-top: 7rem !important;
    margin-bottom: 7rem !important;
  }

  .my-sm-16 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }

  .my-sm-17 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  .my-sm-18 {
    margin-top: 8.5rem !important;
    margin-bottom: 8.5rem !important;
  }

  .my-sm-19 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }

  .my-sm-20 {
    margin-top: 9.5rem !important;
    margin-bottom: 9.5rem !important;
  }

  .my-sm-21 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }

  .my-sm-22 {
    margin-top: 10.5rem !important;
    margin-bottom: 10.5rem !important;
  }

  .my-sm-23 {
    margin-top: 11rem !important;
    margin-bottom: 11rem !important;
  }

  .my-sm-24 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }

  .my-sm-25 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }

  .my-sm-26 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }

  .my-sm-27 {
    margin-top: 13rem !important;
    margin-bottom: 13rem !important;
  }

  .my-sm-28 {
    margin-top: 13.5rem !important;
    margin-bottom: 13.5rem !important;
  }

  .my-sm-29 {
    margin-top: 14rem !important;
    margin-bottom: 14rem !important;
  }

  .my-sm-30 {
    margin-top: 14.5rem !important;
    margin-bottom: 14.5rem !important;
  }

  .my-sm-31 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }

  .my-sm-32 {
    margin-top: 15.5rem !important;
    margin-bottom: 15.5rem !important;
  }

  .my-sm-33 {
    margin-top: 16rem !important;
    margin-bottom: 16rem !important;
  }

  .my-sm-34 {
    margin-top: 16.5rem !important;
    margin-bottom: 16.5rem !important;
  }

  .my-sm-35 {
    margin-top: 17rem !important;
    margin-bottom: 17rem !important;
  }

  .my-sm-36 {
    margin-top: 17.5rem !important;
    margin-bottom: 17.5rem !important;
  }

  .my-sm-37 {
    margin-top: 18rem !important;
    margin-bottom: 18rem !important;
  }

  .my-sm-38 {
    margin-top: 18.5rem !important;
    margin-bottom: 18.5rem !important;
  }

  .my-sm-39 {
    margin-top: 19rem !important;
    margin-bottom: 19rem !important;
  }

  .my-sm-40 {
    margin-top: 19.5rem !important;
    margin-bottom: 19.5rem !important;
  }

  .my-sm-41 {
    margin-top: 20rem !important;
    margin-bottom: 20rem !important;
  }

  .my-sm-42 {
    margin-top: 20.5rem !important;
    margin-bottom: 20.5rem !important;
  }

  .my-sm-43 {
    margin-top: 21rem !important;
    margin-bottom: 21rem !important;
  }

  .my-sm-44 {
    margin-top: 21.5rem !important;
    margin-bottom: 21.5rem !important;
  }

  .my-sm-45 {
    margin-top: 22rem !important;
    margin-bottom: 22rem !important;
  }

  .my-sm-46 {
    margin-top: 22.5rem !important;
    margin-bottom: 22.5rem !important;
  }

  .my-sm-47 {
    margin-top: 23rem !important;
    margin-bottom: 23rem !important;
  }

  .my-sm-48 {
    margin-top: 23.5rem !important;
    margin-bottom: 23.5rem !important;
  }

  .my-sm-49 {
    margin-top: 24rem !important;
    margin-bottom: 24rem !important;
  }

  .my-sm-50 {
    margin-top: 24.5rem !important;
    margin-bottom: 24.5rem !important;
  }

  .my-sm-51 {
    margin-top: 25rem !important;
    margin-bottom: 25rem !important;
  }

  .my-sm-52 {
    margin-top: 25.5rem !important;
    margin-bottom: 25.5rem !important;
  }

  .my-sm-53 {
    margin-top: 26rem !important;
    margin-bottom: 26rem !important;
  }

  .my-sm-54 {
    margin-top: 26.5rem !important;
    margin-bottom: 26.5rem !important;
  }

  .my-sm-55 {
    margin-top: 27rem !important;
    margin-bottom: 27rem !important;
  }

  .my-sm-56 {
    margin-top: 27.5rem !important;
    margin-bottom: 27.5rem !important;
  }

  .my-sm-57 {
    margin-top: 28rem !important;
    margin-bottom: 28rem !important;
  }

  .my-sm-58 {
    margin-top: 28.5rem !important;
    margin-bottom: 28.5rem !important;
  }

  .my-sm-59 {
    margin-top: 29rem !important;
    margin-bottom: 29rem !important;
  }

  .my-sm-60 {
    margin-top: 29.5rem !important;
    margin-bottom: 29.5rem !important;
  }

  .my-sm-61 {
    margin-top: 30rem !important;
    margin-bottom: 30rem !important;
  }

  .my-sm-62 {
    margin-top: 30.5rem !important;
    margin-bottom: 30.5rem !important;
  }

  .my-sm-63 {
    margin-top: 31rem !important;
    margin-bottom: 31rem !important;
  }

  .my-sm-64 {
    margin-top: 31.5rem !important;
    margin-bottom: 31.5rem !important;
  }

  .my-sm-65 {
    margin-top: 32rem !important;
    margin-bottom: 32rem !important;
  }

  .my-sm-66 {
    margin-top: 32.5rem !important;
    margin-bottom: 32.5rem !important;
  }

  .my-sm-67 {
    margin-top: 33rem !important;
    margin-bottom: 33rem !important;
  }

  .my-sm-68 {
    margin-top: 33.5rem !important;
    margin-bottom: 33.5rem !important;
  }

  .my-sm-69 {
    margin-top: 34rem !important;
    margin-bottom: 34rem !important;
  }

  .my-sm-70 {
    margin-top: 34.5rem !important;
    margin-bottom: 34.5rem !important;
  }

  .my-sm-71 {
    margin-top: 35rem !important;
    margin-bottom: 35rem !important;
  }

  .my-sm-72 {
    margin-top: 35.5rem !important;
    margin-bottom: 35.5rem !important;
  }

  .my-sm-73 {
    margin-top: 36rem !important;
    margin-bottom: 36rem !important;
  }

  .my-sm-74 {
    margin-top: 36.5rem !important;
    margin-bottom: 36.5rem !important;
  }

  .my-sm-75 {
    margin-top: 37rem !important;
    margin-bottom: 37rem !important;
  }

  .my-sm-76 {
    margin-top: 37.5rem !important;
    margin-bottom: 37.5rem !important;
  }

  .my-sm-77 {
    margin-top: 38rem !important;
    margin-bottom: 38rem !important;
  }

  .my-sm-78 {
    margin-top: 38.5rem !important;
    margin-bottom: 38.5rem !important;
  }

  .my-sm-79 {
    margin-top: 39rem !important;
    margin-bottom: 39rem !important;
  }

  .my-sm-80 {
    margin-top: 39.5rem !important;
    margin-bottom: 39.5rem !important;
  }

  .my-sm-81 {
    margin-top: 40rem !important;
    margin-bottom: 40rem !important;
  }

  .my-sm-82 {
    margin-top: 40.5rem !important;
    margin-bottom: 40.5rem !important;
  }

  .my-sm-83 {
    margin-top: 41rem !important;
    margin-bottom: 41rem !important;
  }

  .my-sm-84 {
    margin-top: 41.5rem !important;
    margin-bottom: 41.5rem !important;
  }

  .my-sm-85 {
    margin-top: 42rem !important;
    margin-bottom: 42rem !important;
  }

  .my-sm-86 {
    margin-top: 42.5rem !important;
    margin-bottom: 42.5rem !important;
  }

  .my-sm-87 {
    margin-top: 43rem !important;
    margin-bottom: 43rem !important;
  }

  .my-sm-88 {
    margin-top: 43.5rem !important;
    margin-bottom: 43.5rem !important;
  }

  .my-sm-89 {
    margin-top: 44rem !important;
    margin-bottom: 44rem !important;
  }

  .my-sm-90 {
    margin-top: 44.5rem !important;
    margin-bottom: 44.5rem !important;
  }

  .my-sm-91 {
    margin-top: 45rem !important;
    margin-bottom: 45rem !important;
  }

  .my-sm-92 {
    margin-top: 45.5rem !important;
    margin-bottom: 45.5rem !important;
  }

  .my-sm-93 {
    margin-top: 46rem !important;
    margin-bottom: 46rem !important;
  }

  .my-sm-94 {
    margin-top: 46.5rem !important;
    margin-bottom: 46.5rem !important;
  }

  .my-sm-95 {
    margin-top: 47rem !important;
    margin-bottom: 47rem !important;
  }

  .my-sm-96 {
    margin-top: 47.5rem !important;
    margin-bottom: 47.5rem !important;
  }

  .my-sm-97 {
    margin-top: 48rem !important;
    margin-bottom: 48rem !important;
  }

  .my-sm-98 {
    margin-top: 48.5rem !important;
    margin-bottom: 48.5rem !important;
  }

  .my-sm-99 {
    margin-top: 49rem !important;
    margin-bottom: 49rem !important;
  }

  .my-sm-100 {
    margin-top: 49.5rem !important;
    margin-bottom: 49.5rem !important;
  }

  .my-sm-101 {
    margin-top: 50rem !important;
    margin-bottom: 50rem !important;
  }

  .my-sm-102 {
    margin-top: 50.5rem !important;
    margin-bottom: 50.5rem !important;
  }

  .my-sm-103 {
    margin-top: 51rem !important;
    margin-bottom: 51rem !important;
  }

  .my-sm-104 {
    margin-top: 51.5rem !important;
    margin-bottom: 51.5rem !important;
  }

  .my-sm-105 {
    margin-top: 52rem !important;
    margin-bottom: 52rem !important;
  }

  .my-sm-106 {
    margin-top: 52.5rem !important;
    margin-bottom: 52.5rem !important;
  }

  .my-sm-107 {
    margin-top: 53rem !important;
    margin-bottom: 53rem !important;
  }

  .my-sm-108 {
    margin-top: 53.5rem !important;
    margin-bottom: 53.5rem !important;
  }

  .my-sm-109 {
    margin-top: 54rem !important;
    margin-bottom: 54rem !important;
  }

  .my-sm-110 {
    margin-top: 54.5rem !important;
    margin-bottom: 54.5rem !important;
  }

  .my-sm-111 {
    margin-top: 55rem !important;
    margin-bottom: 55rem !important;
  }

  .my-sm-112 {
    margin-top: 55.5rem !important;
    margin-bottom: 55.5rem !important;
  }

  .my-sm-113 {
    margin-top: 56rem !important;
    margin-bottom: 56rem !important;
  }

  .my-sm-114 {
    margin-top: 56.5rem !important;
    margin-bottom: 56.5rem !important;
  }

  .my-sm-115 {
    margin-top: 57rem !important;
    margin-bottom: 57rem !important;
  }

  .my-sm-116 {
    margin-top: 57.5rem !important;
    margin-bottom: 57.5rem !important;
  }

  .my-sm-117 {
    margin-top: 58rem !important;
    margin-bottom: 58rem !important;
  }

  .my-sm-118 {
    margin-top: 58.5rem !important;
    margin-bottom: 58.5rem !important;
  }

  .my-sm-119 {
    margin-top: 59rem !important;
    margin-bottom: 59rem !important;
  }

  .my-sm-120 {
    margin-top: 59.5rem !important;
    margin-bottom: 59.5rem !important;
  }

  .my-sm-121 {
    margin-top: 60rem !important;
    margin-bottom: 60rem !important;
  }

  .my-sm-122 {
    margin-top: 60.5rem !important;
    margin-bottom: 60.5rem !important;
  }

  .my-sm-123 {
    margin-top: 61rem !important;
    margin-bottom: 61rem !important;
  }

  .my-sm-124 {
    margin-top: 61.5rem !important;
    margin-bottom: 61.5rem !important;
  }

  .my-sm-125 {
    margin-top: 62rem !important;
    margin-bottom: 62rem !important;
  }

  .my-sm-126 {
    margin-top: 62.5rem !important;
    margin-bottom: 62.5rem !important;
  }

  .my-sm-127 {
    margin-top: 63rem !important;
    margin-bottom: 63rem !important;
  }

  .my-sm-128 {
    margin-top: 63.5rem !important;
    margin-bottom: 63.5rem !important;
  }

  .my-sm-129 {
    margin-top: 64rem !important;
    margin-bottom: 64rem !important;
  }

  .my-sm-130 {
    margin-top: 64.5rem !important;
    margin-bottom: 64.5rem !important;
  }

  .my-sm-131 {
    margin-top: 65rem !important;
    margin-bottom: 65rem !important;
  }

  .my-sm-132 {
    margin-top: 65.5rem !important;
    margin-bottom: 65.5rem !important;
  }

  .my-sm-133 {
    margin-top: 66rem !important;
    margin-bottom: 66rem !important;
  }

  .my-sm-134 {
    margin-top: 66.5rem !important;
    margin-bottom: 66.5rem !important;
  }

  .my-sm-135 {
    margin-top: 67rem !important;
    margin-bottom: 67rem !important;
  }

  .my-sm-136 {
    margin-top: 67.5rem !important;
    margin-bottom: 67.5rem !important;
  }

  .my-sm-137 {
    margin-top: 68rem !important;
    margin-bottom: 68rem !important;
  }

  .my-sm-138 {
    margin-top: 68.5rem !important;
    margin-bottom: 68.5rem !important;
  }

  .my-sm-139 {
    margin-top: 69rem !important;
    margin-bottom: 69rem !important;
  }

  .my-sm-140 {
    margin-top: 69.5rem !important;
    margin-bottom: 69.5rem !important;
  }

  .my-sm-141 {
    margin-top: 70rem !important;
    margin-bottom: 70rem !important;
  }

  .my-sm-142 {
    margin-top: 70.5rem !important;
    margin-bottom: 70.5rem !important;
  }

  .my-sm-143 {
    margin-top: 71rem !important;
    margin-bottom: 71rem !important;
  }

  .my-sm-144 {
    margin-top: 71.5rem !important;
    margin-bottom: 71.5rem !important;
  }

  .my-sm-145 {
    margin-top: 72rem !important;
    margin-bottom: 72rem !important;
  }

  .my-sm-146 {
    margin-top: 72.5rem !important;
    margin-bottom: 72.5rem !important;
  }

  .my-sm-147 {
    margin-top: 73rem !important;
    margin-bottom: 73rem !important;
  }

  .my-sm-148 {
    margin-top: 73.5rem !important;
    margin-bottom: 73.5rem !important;
  }

  .my-sm-149 {
    margin-top: 74rem !important;
    margin-bottom: 74rem !important;
  }

  .my-sm-150 {
    margin-top: 74.5rem !important;
    margin-bottom: 74.5rem !important;
  }

  .my-sm-151 {
    margin-top: 75rem !important;
    margin-bottom: 75rem !important;
  }

  .my-sm-152 {
    margin-top: 75.5rem !important;
    margin-bottom: 75.5rem !important;
  }

  .my-sm-153 {
    margin-top: 76rem !important;
    margin-bottom: 76rem !important;
  }

  .my-sm-154 {
    margin-top: 76.5rem !important;
    margin-bottom: 76.5rem !important;
  }

  .my-sm-155 {
    margin-top: 77rem !important;
    margin-bottom: 77rem !important;
  }

  .my-sm-156 {
    margin-top: 77.5rem !important;
    margin-bottom: 77.5rem !important;
  }

  .my-sm-157 {
    margin-top: 78rem !important;
    margin-bottom: 78rem !important;
  }

  .my-sm-158 {
    margin-top: 78.5rem !important;
    margin-bottom: 78.5rem !important;
  }

  .my-sm-159 {
    margin-top: 79rem !important;
    margin-bottom: 79rem !important;
  }

  .my-sm-160 {
    margin-top: 79.5rem !important;
    margin-bottom: 79.5rem !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0rem !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .m-md-5 {
    margin: 2rem !important;
  }

  .m-md-6 {
    margin: 2.5rem !important;
  }

  .m-md-7 {
    margin: 3rem !important;
  }

  .m-md-8 {
    margin: 3.5rem !important;
  }

  .m-md-9 {
    margin: 4rem !important;
  }

  .m-md-10 {
    margin: 4.5rem !important;
  }

  .m-md-11 {
    margin: 5rem !important;
  }

  .m-md-12 {
    margin: 5.5rem !important;
  }

  .m-md-13 {
    margin: 6rem !important;
  }

  .m-md-14 {
    margin: 6.5rem !important;
  }

  .m-md-15 {
    margin: 7rem !important;
  }

  .m-md-16 {
    margin: 7.5rem !important;
  }

  .m-md-17 {
    margin: 8rem !important;
  }

  .m-md-18 {
    margin: 8.5rem !important;
  }

  .m-md-19 {
    margin: 9rem !important;
  }

  .m-md-20 {
    margin: 9.5rem !important;
  }

  .m-md-21 {
    margin: 10rem !important;
  }

  .m-md-22 {
    margin: 10.5rem !important;
  }

  .m-md-23 {
    margin: 11rem !important;
  }

  .m-md-24 {
    margin: 11.5rem !important;
  }

  .m-md-25 {
    margin: 12rem !important;
  }

  .m-md-26 {
    margin: 12.5rem !important;
  }

  .m-md-27 {
    margin: 13rem !important;
  }

  .m-md-28 {
    margin: 13.5rem !important;
  }

  .m-md-29 {
    margin: 14rem !important;
  }

  .m-md-30 {
    margin: 14.5rem !important;
  }

  .m-md-31 {
    margin: 15rem !important;
  }

  .m-md-32 {
    margin: 15.5rem !important;
  }

  .m-md-33 {
    margin: 16rem !important;
  }

  .m-md-34 {
    margin: 16.5rem !important;
  }

  .m-md-35 {
    margin: 17rem !important;
  }

  .m-md-36 {
    margin: 17.5rem !important;
  }

  .m-md-37 {
    margin: 18rem !important;
  }

  .m-md-38 {
    margin: 18.5rem !important;
  }

  .m-md-39 {
    margin: 19rem !important;
  }

  .m-md-40 {
    margin: 19.5rem !important;
  }

  .m-md-41 {
    margin: 20rem !important;
  }

  .m-md-42 {
    margin: 20.5rem !important;
  }

  .m-md-43 {
    margin: 21rem !important;
  }

  .m-md-44 {
    margin: 21.5rem !important;
  }

  .m-md-45 {
    margin: 22rem !important;
  }

  .m-md-46 {
    margin: 22.5rem !important;
  }

  .m-md-47 {
    margin: 23rem !important;
  }

  .m-md-48 {
    margin: 23.5rem !important;
  }

  .m-md-49 {
    margin: 24rem !important;
  }

  .m-md-50 {
    margin: 24.5rem !important;
  }

  .m-md-51 {
    margin: 25rem !important;
  }

  .m-md-52 {
    margin: 25.5rem !important;
  }

  .m-md-53 {
    margin: 26rem !important;
  }

  .m-md-54 {
    margin: 26.5rem !important;
  }

  .m-md-55 {
    margin: 27rem !important;
  }

  .m-md-56 {
    margin: 27.5rem !important;
  }

  .m-md-57 {
    margin: 28rem !important;
  }

  .m-md-58 {
    margin: 28.5rem !important;
  }

  .m-md-59 {
    margin: 29rem !important;
  }

  .m-md-60 {
    margin: 29.5rem !important;
  }

  .m-md-61 {
    margin: 30rem !important;
  }

  .m-md-62 {
    margin: 30.5rem !important;
  }

  .m-md-63 {
    margin: 31rem !important;
  }

  .m-md-64 {
    margin: 31.5rem !important;
  }

  .m-md-65 {
    margin: 32rem !important;
  }

  .m-md-66 {
    margin: 32.5rem !important;
  }

  .m-md-67 {
    margin: 33rem !important;
  }

  .m-md-68 {
    margin: 33.5rem !important;
  }

  .m-md-69 {
    margin: 34rem !important;
  }

  .m-md-70 {
    margin: 34.5rem !important;
  }

  .m-md-71 {
    margin: 35rem !important;
  }

  .m-md-72 {
    margin: 35.5rem !important;
  }

  .m-md-73 {
    margin: 36rem !important;
  }

  .m-md-74 {
    margin: 36.5rem !important;
  }

  .m-md-75 {
    margin: 37rem !important;
  }

  .m-md-76 {
    margin: 37.5rem !important;
  }

  .m-md-77 {
    margin: 38rem !important;
  }

  .m-md-78 {
    margin: 38.5rem !important;
  }

  .m-md-79 {
    margin: 39rem !important;
  }

  .m-md-80 {
    margin: 39.5rem !important;
  }

  .m-md-81 {
    margin: 40rem !important;
  }

  .m-md-82 {
    margin: 40.5rem !important;
  }

  .m-md-83 {
    margin: 41rem !important;
  }

  .m-md-84 {
    margin: 41.5rem !important;
  }

  .m-md-85 {
    margin: 42rem !important;
  }

  .m-md-86 {
    margin: 42.5rem !important;
  }

  .m-md-87 {
    margin: 43rem !important;
  }

  .m-md-88 {
    margin: 43.5rem !important;
  }

  .m-md-89 {
    margin: 44rem !important;
  }

  .m-md-90 {
    margin: 44.5rem !important;
  }

  .m-md-91 {
    margin: 45rem !important;
  }

  .m-md-92 {
    margin: 45.5rem !important;
  }

  .m-md-93 {
    margin: 46rem !important;
  }

  .m-md-94 {
    margin: 46.5rem !important;
  }

  .m-md-95 {
    margin: 47rem !important;
  }

  .m-md-96 {
    margin: 47.5rem !important;
  }

  .m-md-97 {
    margin: 48rem !important;
  }

  .m-md-98 {
    margin: 48.5rem !important;
  }

  .m-md-99 {
    margin: 49rem !important;
  }

  .m-md-100 {
    margin: 49.5rem !important;
  }

  .m-md-101 {
    margin: 50rem !important;
  }

  .m-md-102 {
    margin: 50.5rem !important;
  }

  .m-md-103 {
    margin: 51rem !important;
  }

  .m-md-104 {
    margin: 51.5rem !important;
  }

  .m-md-105 {
    margin: 52rem !important;
  }

  .m-md-106 {
    margin: 52.5rem !important;
  }

  .m-md-107 {
    margin: 53rem !important;
  }

  .m-md-108 {
    margin: 53.5rem !important;
  }

  .m-md-109 {
    margin: 54rem !important;
  }

  .m-md-110 {
    margin: 54.5rem !important;
  }

  .m-md-111 {
    margin: 55rem !important;
  }

  .m-md-112 {
    margin: 55.5rem !important;
  }

  .m-md-113 {
    margin: 56rem !important;
  }

  .m-md-114 {
    margin: 56.5rem !important;
  }

  .m-md-115 {
    margin: 57rem !important;
  }

  .m-md-116 {
    margin: 57.5rem !important;
  }

  .m-md-117 {
    margin: 58rem !important;
  }

  .m-md-118 {
    margin: 58.5rem !important;
  }

  .m-md-119 {
    margin: 59rem !important;
  }

  .m-md-120 {
    margin: 59.5rem !important;
  }

  .m-md-121 {
    margin: 60rem !important;
  }

  .m-md-122 {
    margin: 60.5rem !important;
  }

  .m-md-123 {
    margin: 61rem !important;
  }

  .m-md-124 {
    margin: 61.5rem !important;
  }

  .m-md-125 {
    margin: 62rem !important;
  }

  .m-md-126 {
    margin: 62.5rem !important;
  }

  .m-md-127 {
    margin: 63rem !important;
  }

  .m-md-128 {
    margin: 63.5rem !important;
  }

  .m-md-129 {
    margin: 64rem !important;
  }

  .m-md-130 {
    margin: 64.5rem !important;
  }

  .m-md-131 {
    margin: 65rem !important;
  }

  .m-md-132 {
    margin: 65.5rem !important;
  }

  .m-md-133 {
    margin: 66rem !important;
  }

  .m-md-134 {
    margin: 66.5rem !important;
  }

  .m-md-135 {
    margin: 67rem !important;
  }

  .m-md-136 {
    margin: 67.5rem !important;
  }

  .m-md-137 {
    margin: 68rem !important;
  }

  .m-md-138 {
    margin: 68.5rem !important;
  }

  .m-md-139 {
    margin: 69rem !important;
  }

  .m-md-140 {
    margin: 69.5rem !important;
  }

  .m-md-141 {
    margin: 70rem !important;
  }

  .m-md-142 {
    margin: 70.5rem !important;
  }

  .m-md-143 {
    margin: 71rem !important;
  }

  .m-md-144 {
    margin: 71.5rem !important;
  }

  .m-md-145 {
    margin: 72rem !important;
  }

  .m-md-146 {
    margin: 72.5rem !important;
  }

  .m-md-147 {
    margin: 73rem !important;
  }

  .m-md-148 {
    margin: 73.5rem !important;
  }

  .m-md-149 {
    margin: 74rem !important;
  }

  .m-md-150 {
    margin: 74.5rem !important;
  }

  .m-md-151 {
    margin: 75rem !important;
  }

  .m-md-152 {
    margin: 75.5rem !important;
  }

  .m-md-153 {
    margin: 76rem !important;
  }

  .m-md-154 {
    margin: 76.5rem !important;
  }

  .m-md-155 {
    margin: 77rem !important;
  }

  .m-md-156 {
    margin: 77.5rem !important;
  }

  .m-md-157 {
    margin: 78rem !important;
  }

  .m-md-158 {
    margin: 78.5rem !important;
  }

  .m-md-159 {
    margin: 79rem !important;
  }

  .m-md-160 {
    margin: 79.5rem !important;
  }

  .mt-md-0 {
    margin-top: 0rem !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 1rem !important;
  }

  .mt-md-4 {
    margin-top: 1.5rem !important;
  }

  .mt-md-5 {
    margin-top: 2rem !important;
  }

  .mt-md-6 {
    margin-top: 2.5rem !important;
  }

  .mt-md-7 {
    margin-top: 3rem !important;
  }

  .mt-md-8 {
    margin-top: 3.5rem !important;
  }

  .mt-md-9 {
    margin-top: 4rem !important;
  }

  .mt-md-10 {
    margin-top: 4.5rem !important;
  }

  .mt-md-11 {
    margin-top: 5rem !important;
  }

  .mt-md-12 {
    margin-top: 5.5rem !important;
  }

  .mt-md-13 {
    margin-top: 6rem !important;
  }

  .mt-md-14 {
    margin-top: 6.5rem !important;
  }

  .mt-md-15 {
    margin-top: 7rem !important;
  }

  .mt-md-16 {
    margin-top: 7.5rem !important;
  }

  .mt-md-17 {
    margin-top: 8rem !important;
  }

  .mt-md-18 {
    margin-top: 8.5rem !important;
  }

  .mt-md-19 {
    margin-top: 9rem !important;
  }

  .mt-md-20 {
    margin-top: 9.5rem !important;
  }

  .mt-md-21 {
    margin-top: 10rem !important;
  }

  .mt-md-22 {
    margin-top: 10.5rem !important;
  }

  .mt-md-23 {
    margin-top: 11rem !important;
  }

  .mt-md-24 {
    margin-top: 11.5rem !important;
  }

  .mt-md-25 {
    margin-top: 12rem !important;
  }

  .mt-md-26 {
    margin-top: 12.5rem !important;
  }

  .mt-md-27 {
    margin-top: 13rem !important;
  }

  .mt-md-28 {
    margin-top: 13.5rem !important;
  }

  .mt-md-29 {
    margin-top: 14rem !important;
  }

  .mt-md-30 {
    margin-top: 14.5rem !important;
  }

  .mt-md-31 {
    margin-top: 15rem !important;
  }

  .mt-md-32 {
    margin-top: 15.5rem !important;
  }

  .mt-md-33 {
    margin-top: 16rem !important;
  }

  .mt-md-34 {
    margin-top: 16.5rem !important;
  }

  .mt-md-35 {
    margin-top: 17rem !important;
  }

  .mt-md-36 {
    margin-top: 17.5rem !important;
  }

  .mt-md-37 {
    margin-top: 18rem !important;
  }

  .mt-md-38 {
    margin-top: 18.5rem !important;
  }

  .mt-md-39 {
    margin-top: 19rem !important;
  }

  .mt-md-40 {
    margin-top: 19.5rem !important;
  }

  .mt-md-41 {
    margin-top: 20rem !important;
  }

  .mt-md-42 {
    margin-top: 20.5rem !important;
  }

  .mt-md-43 {
    margin-top: 21rem !important;
  }

  .mt-md-44 {
    margin-top: 21.5rem !important;
  }

  .mt-md-45 {
    margin-top: 22rem !important;
  }

  .mt-md-46 {
    margin-top: 22.5rem !important;
  }

  .mt-md-47 {
    margin-top: 23rem !important;
  }

  .mt-md-48 {
    margin-top: 23.5rem !important;
  }

  .mt-md-49 {
    margin-top: 24rem !important;
  }

  .mt-md-50 {
    margin-top: 24.5rem !important;
  }

  .mt-md-51 {
    margin-top: 25rem !important;
  }

  .mt-md-52 {
    margin-top: 25.5rem !important;
  }

  .mt-md-53 {
    margin-top: 26rem !important;
  }

  .mt-md-54 {
    margin-top: 26.5rem !important;
  }

  .mt-md-55 {
    margin-top: 27rem !important;
  }

  .mt-md-56 {
    margin-top: 27.5rem !important;
  }

  .mt-md-57 {
    margin-top: 28rem !important;
  }

  .mt-md-58 {
    margin-top: 28.5rem !important;
  }

  .mt-md-59 {
    margin-top: 29rem !important;
  }

  .mt-md-60 {
    margin-top: 29.5rem !important;
  }

  .mt-md-61 {
    margin-top: 30rem !important;
  }

  .mt-md-62 {
    margin-top: 30.5rem !important;
  }

  .mt-md-63 {
    margin-top: 31rem !important;
  }

  .mt-md-64 {
    margin-top: 31.5rem !important;
  }

  .mt-md-65 {
    margin-top: 32rem !important;
  }

  .mt-md-66 {
    margin-top: 32.5rem !important;
  }

  .mt-md-67 {
    margin-top: 33rem !important;
  }

  .mt-md-68 {
    margin-top: 33.5rem !important;
  }

  .mt-md-69 {
    margin-top: 34rem !important;
  }

  .mt-md-70 {
    margin-top: 34.5rem !important;
  }

  .mt-md-71 {
    margin-top: 35rem !important;
  }

  .mt-md-72 {
    margin-top: 35.5rem !important;
  }

  .mt-md-73 {
    margin-top: 36rem !important;
  }

  .mt-md-74 {
    margin-top: 36.5rem !important;
  }

  .mt-md-75 {
    margin-top: 37rem !important;
  }

  .mt-md-76 {
    margin-top: 37.5rem !important;
  }

  .mt-md-77 {
    margin-top: 38rem !important;
  }

  .mt-md-78 {
    margin-top: 38.5rem !important;
  }

  .mt-md-79 {
    margin-top: 39rem !important;
  }

  .mt-md-80 {
    margin-top: 39.5rem !important;
  }

  .mt-md-81 {
    margin-top: 40rem !important;
  }

  .mt-md-82 {
    margin-top: 40.5rem !important;
  }

  .mt-md-83 {
    margin-top: 41rem !important;
  }

  .mt-md-84 {
    margin-top: 41.5rem !important;
  }

  .mt-md-85 {
    margin-top: 42rem !important;
  }

  .mt-md-86 {
    margin-top: 42.5rem !important;
  }

  .mt-md-87 {
    margin-top: 43rem !important;
  }

  .mt-md-88 {
    margin-top: 43.5rem !important;
  }

  .mt-md-89 {
    margin-top: 44rem !important;
  }

  .mt-md-90 {
    margin-top: 44.5rem !important;
  }

  .mt-md-91 {
    margin-top: 45rem !important;
  }

  .mt-md-92 {
    margin-top: 45.5rem !important;
  }

  .mt-md-93 {
    margin-top: 46rem !important;
  }

  .mt-md-94 {
    margin-top: 46.5rem !important;
  }

  .mt-md-95 {
    margin-top: 47rem !important;
  }

  .mt-md-96 {
    margin-top: 47.5rem !important;
  }

  .mt-md-97 {
    margin-top: 48rem !important;
  }

  .mt-md-98 {
    margin-top: 48.5rem !important;
  }

  .mt-md-99 {
    margin-top: 49rem !important;
  }

  .mt-md-100 {
    margin-top: 49.5rem !important;
  }

  .mt-md-101 {
    margin-top: 50rem !important;
  }

  .mt-md-102 {
    margin-top: 50.5rem !important;
  }

  .mt-md-103 {
    margin-top: 51rem !important;
  }

  .mt-md-104 {
    margin-top: 51.5rem !important;
  }

  .mt-md-105 {
    margin-top: 52rem !important;
  }

  .mt-md-106 {
    margin-top: 52.5rem !important;
  }

  .mt-md-107 {
    margin-top: 53rem !important;
  }

  .mt-md-108 {
    margin-top: 53.5rem !important;
  }

  .mt-md-109 {
    margin-top: 54rem !important;
  }

  .mt-md-110 {
    margin-top: 54.5rem !important;
  }

  .mt-md-111 {
    margin-top: 55rem !important;
  }

  .mt-md-112 {
    margin-top: 55.5rem !important;
  }

  .mt-md-113 {
    margin-top: 56rem !important;
  }

  .mt-md-114 {
    margin-top: 56.5rem !important;
  }

  .mt-md-115 {
    margin-top: 57rem !important;
  }

  .mt-md-116 {
    margin-top: 57.5rem !important;
  }

  .mt-md-117 {
    margin-top: 58rem !important;
  }

  .mt-md-118 {
    margin-top: 58.5rem !important;
  }

  .mt-md-119 {
    margin-top: 59rem !important;
  }

  .mt-md-120 {
    margin-top: 59.5rem !important;
  }

  .mt-md-121 {
    margin-top: 60rem !important;
  }

  .mt-md-122 {
    margin-top: 60.5rem !important;
  }

  .mt-md-123 {
    margin-top: 61rem !important;
  }

  .mt-md-124 {
    margin-top: 61.5rem !important;
  }

  .mt-md-125 {
    margin-top: 62rem !important;
  }

  .mt-md-126 {
    margin-top: 62.5rem !important;
  }

  .mt-md-127 {
    margin-top: 63rem !important;
  }

  .mt-md-128 {
    margin-top: 63.5rem !important;
  }

  .mt-md-129 {
    margin-top: 64rem !important;
  }

  .mt-md-130 {
    margin-top: 64.5rem !important;
  }

  .mt-md-131 {
    margin-top: 65rem !important;
  }

  .mt-md-132 {
    margin-top: 65.5rem !important;
  }

  .mt-md-133 {
    margin-top: 66rem !important;
  }

  .mt-md-134 {
    margin-top: 66.5rem !important;
  }

  .mt-md-135 {
    margin-top: 67rem !important;
  }

  .mt-md-136 {
    margin-top: 67.5rem !important;
  }

  .mt-md-137 {
    margin-top: 68rem !important;
  }

  .mt-md-138 {
    margin-top: 68.5rem !important;
  }

  .mt-md-139 {
    margin-top: 69rem !important;
  }

  .mt-md-140 {
    margin-top: 69.5rem !important;
  }

  .mt-md-141 {
    margin-top: 70rem !important;
  }

  .mt-md-142 {
    margin-top: 70.5rem !important;
  }

  .mt-md-143 {
    margin-top: 71rem !important;
  }

  .mt-md-144 {
    margin-top: 71.5rem !important;
  }

  .mt-md-145 {
    margin-top: 72rem !important;
  }

  .mt-md-146 {
    margin-top: 72.5rem !important;
  }

  .mt-md-147 {
    margin-top: 73rem !important;
  }

  .mt-md-148 {
    margin-top: 73.5rem !important;
  }

  .mt-md-149 {
    margin-top: 74rem !important;
  }

  .mt-md-150 {
    margin-top: 74.5rem !important;
  }

  .mt-md-151 {
    margin-top: 75rem !important;
  }

  .mt-md-152 {
    margin-top: 75.5rem !important;
  }

  .mt-md-153 {
    margin-top: 76rem !important;
  }

  .mt-md-154 {
    margin-top: 76.5rem !important;
  }

  .mt-md-155 {
    margin-top: 77rem !important;
  }

  .mt-md-156 {
    margin-top: 77.5rem !important;
  }

  .mt-md-157 {
    margin-top: 78rem !important;
  }

  .mt-md-158 {
    margin-top: 78.5rem !important;
  }

  .mt-md-159 {
    margin-top: 79rem !important;
  }

  .mt-md-160 {
    margin-top: 79.5rem !important;
  }

  .mb-md-0 {
    margin-bottom: 0rem !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 1rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-5 {
    margin-bottom: 2rem !important;
  }

  .mb-md-6 {
    margin-bottom: 2.5rem !important;
  }

  .mb-md-7 {
    margin-bottom: 3rem !important;
  }

  .mb-md-8 {
    margin-bottom: 3.5rem !important;
  }

  .mb-md-9 {
    margin-bottom: 4rem !important;
  }

  .mb-md-10 {
    margin-bottom: 4.5rem !important;
  }

  .mb-md-11 {
    margin-bottom: 5rem !important;
  }

  .mb-md-12 {
    margin-bottom: 5.5rem !important;
  }

  .mb-md-13 {
    margin-bottom: 6rem !important;
  }

  .mb-md-14 {
    margin-bottom: 6.5rem !important;
  }

  .mb-md-15 {
    margin-bottom: 7rem !important;
  }

  .mb-md-16 {
    margin-bottom: 7.5rem !important;
  }

  .mb-md-17 {
    margin-bottom: 8rem !important;
  }

  .mb-md-18 {
    margin-bottom: 8.5rem !important;
  }

  .mb-md-19 {
    margin-bottom: 9rem !important;
  }

  .mb-md-20 {
    margin-bottom: 9.5rem !important;
  }

  .mb-md-21 {
    margin-bottom: 10rem !important;
  }

  .mb-md-22 {
    margin-bottom: 10.5rem !important;
  }

  .mb-md-23 {
    margin-bottom: 11rem !important;
  }

  .mb-md-24 {
    margin-bottom: 11.5rem !important;
  }

  .mb-md-25 {
    margin-bottom: 12rem !important;
  }

  .mb-md-26 {
    margin-bottom: 12.5rem !important;
  }

  .mb-md-27 {
    margin-bottom: 13rem !important;
  }

  .mb-md-28 {
    margin-bottom: 13.5rem !important;
  }

  .mb-md-29 {
    margin-bottom: 14rem !important;
  }

  .mb-md-30 {
    margin-bottom: 14.5rem !important;
  }

  .mb-md-31 {
    margin-bottom: 15rem !important;
  }

  .mb-md-32 {
    margin-bottom: 15.5rem !important;
  }

  .mb-md-33 {
    margin-bottom: 16rem !important;
  }

  .mb-md-34 {
    margin-bottom: 16.5rem !important;
  }

  .mb-md-35 {
    margin-bottom: 17rem !important;
  }

  .mb-md-36 {
    margin-bottom: 17.5rem !important;
  }

  .mb-md-37 {
    margin-bottom: 18rem !important;
  }

  .mb-md-38 {
    margin-bottom: 18.5rem !important;
  }

  .mb-md-39 {
    margin-bottom: 19rem !important;
  }

  .mb-md-40 {
    margin-bottom: 19.5rem !important;
  }

  .mb-md-41 {
    margin-bottom: 20rem !important;
  }

  .mb-md-42 {
    margin-bottom: 20.5rem !important;
  }

  .mb-md-43 {
    margin-bottom: 21rem !important;
  }

  .mb-md-44 {
    margin-bottom: 21.5rem !important;
  }

  .mb-md-45 {
    margin-bottom: 22rem !important;
  }

  .mb-md-46 {
    margin-bottom: 22.5rem !important;
  }

  .mb-md-47 {
    margin-bottom: 23rem !important;
  }

  .mb-md-48 {
    margin-bottom: 23.5rem !important;
  }

  .mb-md-49 {
    margin-bottom: 24rem !important;
  }

  .mb-md-50 {
    margin-bottom: 24.5rem !important;
  }

  .mb-md-51 {
    margin-bottom: 25rem !important;
  }

  .mb-md-52 {
    margin-bottom: 25.5rem !important;
  }

  .mb-md-53 {
    margin-bottom: 26rem !important;
  }

  .mb-md-54 {
    margin-bottom: 26.5rem !important;
  }

  .mb-md-55 {
    margin-bottom: 27rem !important;
  }

  .mb-md-56 {
    margin-bottom: 27.5rem !important;
  }

  .mb-md-57 {
    margin-bottom: 28rem !important;
  }

  .mb-md-58 {
    margin-bottom: 28.5rem !important;
  }

  .mb-md-59 {
    margin-bottom: 29rem !important;
  }

  .mb-md-60 {
    margin-bottom: 29.5rem !important;
  }

  .mb-md-61 {
    margin-bottom: 30rem !important;
  }

  .mb-md-62 {
    margin-bottom: 30.5rem !important;
  }

  .mb-md-63 {
    margin-bottom: 31rem !important;
  }

  .mb-md-64 {
    margin-bottom: 31.5rem !important;
  }

  .mb-md-65 {
    margin-bottom: 32rem !important;
  }

  .mb-md-66 {
    margin-bottom: 32.5rem !important;
  }

  .mb-md-67 {
    margin-bottom: 33rem !important;
  }

  .mb-md-68 {
    margin-bottom: 33.5rem !important;
  }

  .mb-md-69 {
    margin-bottom: 34rem !important;
  }

  .mb-md-70 {
    margin-bottom: 34.5rem !important;
  }

  .mb-md-71 {
    margin-bottom: 35rem !important;
  }

  .mb-md-72 {
    margin-bottom: 35.5rem !important;
  }

  .mb-md-73 {
    margin-bottom: 36rem !important;
  }

  .mb-md-74 {
    margin-bottom: 36.5rem !important;
  }

  .mb-md-75 {
    margin-bottom: 37rem !important;
  }

  .mb-md-76 {
    margin-bottom: 37.5rem !important;
  }

  .mb-md-77 {
    margin-bottom: 38rem !important;
  }

  .mb-md-78 {
    margin-bottom: 38.5rem !important;
  }

  .mb-md-79 {
    margin-bottom: 39rem !important;
  }

  .mb-md-80 {
    margin-bottom: 39.5rem !important;
  }

  .mb-md-81 {
    margin-bottom: 40rem !important;
  }

  .mb-md-82 {
    margin-bottom: 40.5rem !important;
  }

  .mb-md-83 {
    margin-bottom: 41rem !important;
  }

  .mb-md-84 {
    margin-bottom: 41.5rem !important;
  }

  .mb-md-85 {
    margin-bottom: 42rem !important;
  }

  .mb-md-86 {
    margin-bottom: 42.5rem !important;
  }

  .mb-md-87 {
    margin-bottom: 43rem !important;
  }

  .mb-md-88 {
    margin-bottom: 43.5rem !important;
  }

  .mb-md-89 {
    margin-bottom: 44rem !important;
  }

  .mb-md-90 {
    margin-bottom: 44.5rem !important;
  }

  .mb-md-91 {
    margin-bottom: 45rem !important;
  }

  .mb-md-92 {
    margin-bottom: 45.5rem !important;
  }

  .mb-md-93 {
    margin-bottom: 46rem !important;
  }

  .mb-md-94 {
    margin-bottom: 46.5rem !important;
  }

  .mb-md-95 {
    margin-bottom: 47rem !important;
  }

  .mb-md-96 {
    margin-bottom: 47.5rem !important;
  }

  .mb-md-97 {
    margin-bottom: 48rem !important;
  }

  .mb-md-98 {
    margin-bottom: 48.5rem !important;
  }

  .mb-md-99 {
    margin-bottom: 49rem !important;
  }

  .mb-md-100 {
    margin-bottom: 49.5rem !important;
  }

  .mb-md-101 {
    margin-bottom: 50rem !important;
  }

  .mb-md-102 {
    margin-bottom: 50.5rem !important;
  }

  .mb-md-103 {
    margin-bottom: 51rem !important;
  }

  .mb-md-104 {
    margin-bottom: 51.5rem !important;
  }

  .mb-md-105 {
    margin-bottom: 52rem !important;
  }

  .mb-md-106 {
    margin-bottom: 52.5rem !important;
  }

  .mb-md-107 {
    margin-bottom: 53rem !important;
  }

  .mb-md-108 {
    margin-bottom: 53.5rem !important;
  }

  .mb-md-109 {
    margin-bottom: 54rem !important;
  }

  .mb-md-110 {
    margin-bottom: 54.5rem !important;
  }

  .mb-md-111 {
    margin-bottom: 55rem !important;
  }

  .mb-md-112 {
    margin-bottom: 55.5rem !important;
  }

  .mb-md-113 {
    margin-bottom: 56rem !important;
  }

  .mb-md-114 {
    margin-bottom: 56.5rem !important;
  }

  .mb-md-115 {
    margin-bottom: 57rem !important;
  }

  .mb-md-116 {
    margin-bottom: 57.5rem !important;
  }

  .mb-md-117 {
    margin-bottom: 58rem !important;
  }

  .mb-md-118 {
    margin-bottom: 58.5rem !important;
  }

  .mb-md-119 {
    margin-bottom: 59rem !important;
  }

  .mb-md-120 {
    margin-bottom: 59.5rem !important;
  }

  .mb-md-121 {
    margin-bottom: 60rem !important;
  }

  .mb-md-122 {
    margin-bottom: 60.5rem !important;
  }

  .mb-md-123 {
    margin-bottom: 61rem !important;
  }

  .mb-md-124 {
    margin-bottom: 61.5rem !important;
  }

  .mb-md-125 {
    margin-bottom: 62rem !important;
  }

  .mb-md-126 {
    margin-bottom: 62.5rem !important;
  }

  .mb-md-127 {
    margin-bottom: 63rem !important;
  }

  .mb-md-128 {
    margin-bottom: 63.5rem !important;
  }

  .mb-md-129 {
    margin-bottom: 64rem !important;
  }

  .mb-md-130 {
    margin-bottom: 64.5rem !important;
  }

  .mb-md-131 {
    margin-bottom: 65rem !important;
  }

  .mb-md-132 {
    margin-bottom: 65.5rem !important;
  }

  .mb-md-133 {
    margin-bottom: 66rem !important;
  }

  .mb-md-134 {
    margin-bottom: 66.5rem !important;
  }

  .mb-md-135 {
    margin-bottom: 67rem !important;
  }

  .mb-md-136 {
    margin-bottom: 67.5rem !important;
  }

  .mb-md-137 {
    margin-bottom: 68rem !important;
  }

  .mb-md-138 {
    margin-bottom: 68.5rem !important;
  }

  .mb-md-139 {
    margin-bottom: 69rem !important;
  }

  .mb-md-140 {
    margin-bottom: 69.5rem !important;
  }

  .mb-md-141 {
    margin-bottom: 70rem !important;
  }

  .mb-md-142 {
    margin-bottom: 70.5rem !important;
  }

  .mb-md-143 {
    margin-bottom: 71rem !important;
  }

  .mb-md-144 {
    margin-bottom: 71.5rem !important;
  }

  .mb-md-145 {
    margin-bottom: 72rem !important;
  }

  .mb-md-146 {
    margin-bottom: 72.5rem !important;
  }

  .mb-md-147 {
    margin-bottom: 73rem !important;
  }

  .mb-md-148 {
    margin-bottom: 73.5rem !important;
  }

  .mb-md-149 {
    margin-bottom: 74rem !important;
  }

  .mb-md-150 {
    margin-bottom: 74.5rem !important;
  }

  .mb-md-151 {
    margin-bottom: 75rem !important;
  }

  .mb-md-152 {
    margin-bottom: 75.5rem !important;
  }

  .mb-md-153 {
    margin-bottom: 76rem !important;
  }

  .mb-md-154 {
    margin-bottom: 76.5rem !important;
  }

  .mb-md-155 {
    margin-bottom: 77rem !important;
  }

  .mb-md-156 {
    margin-bottom: 77.5rem !important;
  }

  .mb-md-157 {
    margin-bottom: 78rem !important;
  }

  .mb-md-158 {
    margin-bottom: 78.5rem !important;
  }

  .mb-md-159 {
    margin-bottom: 79rem !important;
  }

  .mb-md-160 {
    margin-bottom: 79.5rem !important;
  }

  .ms-md-0 {
    margin-left: 0rem !important;
  }

  .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  .ms-md-3 {
    margin-left: 1rem !important;
  }

  .ms-md-4 {
    margin-left: 1.5rem !important;
  }

  .ms-md-5 {
    margin-left: 2rem !important;
  }

  .ms-md-6 {
    margin-left: 2.5rem !important;
  }

  .ms-md-7 {
    margin-left: 3rem !important;
  }

  .ms-md-8 {
    margin-left: 3.5rem !important;
  }

  .ms-md-9 {
    margin-left: 4rem !important;
  }

  .ms-md-10 {
    margin-left: 4.5rem !important;
  }

  .ms-md-11 {
    margin-left: 5rem !important;
  }

  .ms-md-12 {
    margin-left: 5.5rem !important;
  }

  .ms-md-13 {
    margin-left: 6rem !important;
  }

  .ms-md-14 {
    margin-left: 6.5rem !important;
  }

  .ms-md-15 {
    margin-left: 7rem !important;
  }

  .ms-md-16 {
    margin-left: 7.5rem !important;
  }

  .ms-md-17 {
    margin-left: 8rem !important;
  }

  .ms-md-18 {
    margin-left: 8.5rem !important;
  }

  .ms-md-19 {
    margin-left: 9rem !important;
  }

  .ms-md-20 {
    margin-left: 9.5rem !important;
  }

  .ms-md-21 {
    margin-left: 10rem !important;
  }

  .ms-md-22 {
    margin-left: 10.5rem !important;
  }

  .ms-md-23 {
    margin-left: 11rem !important;
  }

  .ms-md-24 {
    margin-left: 11.5rem !important;
  }

  .ms-md-25 {
    margin-left: 12rem !important;
  }

  .ms-md-26 {
    margin-left: 12.5rem !important;
  }

  .ms-md-27 {
    margin-left: 13rem !important;
  }

  .ms-md-28 {
    margin-left: 13.5rem !important;
  }

  .ms-md-29 {
    margin-left: 14rem !important;
  }

  .ms-md-30 {
    margin-left: 14.5rem !important;
  }

  .ms-md-31 {
    margin-left: 15rem !important;
  }

  .ms-md-32 {
    margin-left: 15.5rem !important;
  }

  .ms-md-33 {
    margin-left: 16rem !important;
  }

  .ms-md-34 {
    margin-left: 16.5rem !important;
  }

  .ms-md-35 {
    margin-left: 17rem !important;
  }

  .ms-md-36 {
    margin-left: 17.5rem !important;
  }

  .ms-md-37 {
    margin-left: 18rem !important;
  }

  .ms-md-38 {
    margin-left: 18.5rem !important;
  }

  .ms-md-39 {
    margin-left: 19rem !important;
  }

  .ms-md-40 {
    margin-left: 19.5rem !important;
  }

  .ms-md-41 {
    margin-left: 20rem !important;
  }

  .ms-md-42 {
    margin-left: 20.5rem !important;
  }

  .ms-md-43 {
    margin-left: 21rem !important;
  }

  .ms-md-44 {
    margin-left: 21.5rem !important;
  }

  .ms-md-45 {
    margin-left: 22rem !important;
  }

  .ms-md-46 {
    margin-left: 22.5rem !important;
  }

  .ms-md-47 {
    margin-left: 23rem !important;
  }

  .ms-md-48 {
    margin-left: 23.5rem !important;
  }

  .ms-md-49 {
    margin-left: 24rem !important;
  }

  .ms-md-50 {
    margin-left: 24.5rem !important;
  }

  .ms-md-51 {
    margin-left: 25rem !important;
  }

  .ms-md-52 {
    margin-left: 25.5rem !important;
  }

  .ms-md-53 {
    margin-left: 26rem !important;
  }

  .ms-md-54 {
    margin-left: 26.5rem !important;
  }

  .ms-md-55 {
    margin-left: 27rem !important;
  }

  .ms-md-56 {
    margin-left: 27.5rem !important;
  }

  .ms-md-57 {
    margin-left: 28rem !important;
  }

  .ms-md-58 {
    margin-left: 28.5rem !important;
  }

  .ms-md-59 {
    margin-left: 29rem !important;
  }

  .ms-md-60 {
    margin-left: 29.5rem !important;
  }

  .ms-md-61 {
    margin-left: 30rem !important;
  }

  .ms-md-62 {
    margin-left: 30.5rem !important;
  }

  .ms-md-63 {
    margin-left: 31rem !important;
  }

  .ms-md-64 {
    margin-left: 31.5rem !important;
  }

  .ms-md-65 {
    margin-left: 32rem !important;
  }

  .ms-md-66 {
    margin-left: 32.5rem !important;
  }

  .ms-md-67 {
    margin-left: 33rem !important;
  }

  .ms-md-68 {
    margin-left: 33.5rem !important;
  }

  .ms-md-69 {
    margin-left: 34rem !important;
  }

  .ms-md-70 {
    margin-left: 34.5rem !important;
  }

  .ms-md-71 {
    margin-left: 35rem !important;
  }

  .ms-md-72 {
    margin-left: 35.5rem !important;
  }

  .ms-md-73 {
    margin-left: 36rem !important;
  }

  .ms-md-74 {
    margin-left: 36.5rem !important;
  }

  .ms-md-75 {
    margin-left: 37rem !important;
  }

  .ms-md-76 {
    margin-left: 37.5rem !important;
  }

  .ms-md-77 {
    margin-left: 38rem !important;
  }

  .ms-md-78 {
    margin-left: 38.5rem !important;
  }

  .ms-md-79 {
    margin-left: 39rem !important;
  }

  .ms-md-80 {
    margin-left: 39.5rem !important;
  }

  .ms-md-81 {
    margin-left: 40rem !important;
  }

  .ms-md-82 {
    margin-left: 40.5rem !important;
  }

  .ms-md-83 {
    margin-left: 41rem !important;
  }

  .ms-md-84 {
    margin-left: 41.5rem !important;
  }

  .ms-md-85 {
    margin-left: 42rem !important;
  }

  .ms-md-86 {
    margin-left: 42.5rem !important;
  }

  .ms-md-87 {
    margin-left: 43rem !important;
  }

  .ms-md-88 {
    margin-left: 43.5rem !important;
  }

  .ms-md-89 {
    margin-left: 44rem !important;
  }

  .ms-md-90 {
    margin-left: 44.5rem !important;
  }

  .ms-md-91 {
    margin-left: 45rem !important;
  }

  .ms-md-92 {
    margin-left: 45.5rem !important;
  }

  .ms-md-93 {
    margin-left: 46rem !important;
  }

  .ms-md-94 {
    margin-left: 46.5rem !important;
  }

  .ms-md-95 {
    margin-left: 47rem !important;
  }

  .ms-md-96 {
    margin-left: 47.5rem !important;
  }

  .ms-md-97 {
    margin-left: 48rem !important;
  }

  .ms-md-98 {
    margin-left: 48.5rem !important;
  }

  .ms-md-99 {
    margin-left: 49rem !important;
  }

  .ms-md-100 {
    margin-left: 49.5rem !important;
  }

  .ms-md-101 {
    margin-left: 50rem !important;
  }

  .ms-md-102 {
    margin-left: 50.5rem !important;
  }

  .ms-md-103 {
    margin-left: 51rem !important;
  }

  .ms-md-104 {
    margin-left: 51.5rem !important;
  }

  .ms-md-105 {
    margin-left: 52rem !important;
  }

  .ms-md-106 {
    margin-left: 52.5rem !important;
  }

  .ms-md-107 {
    margin-left: 53rem !important;
  }

  .ms-md-108 {
    margin-left: 53.5rem !important;
  }

  .ms-md-109 {
    margin-left: 54rem !important;
  }

  .ms-md-110 {
    margin-left: 54.5rem !important;
  }

  .ms-md-111 {
    margin-left: 55rem !important;
  }

  .ms-md-112 {
    margin-left: 55.5rem !important;
  }

  .ms-md-113 {
    margin-left: 56rem !important;
  }

  .ms-md-114 {
    margin-left: 56.5rem !important;
  }

  .ms-md-115 {
    margin-left: 57rem !important;
  }

  .ms-md-116 {
    margin-left: 57.5rem !important;
  }

  .ms-md-117 {
    margin-left: 58rem !important;
  }

  .ms-md-118 {
    margin-left: 58.5rem !important;
  }

  .ms-md-119 {
    margin-left: 59rem !important;
  }

  .ms-md-120 {
    margin-left: 59.5rem !important;
  }

  .ms-md-121 {
    margin-left: 60rem !important;
  }

  .ms-md-122 {
    margin-left: 60.5rem !important;
  }

  .ms-md-123 {
    margin-left: 61rem !important;
  }

  .ms-md-124 {
    margin-left: 61.5rem !important;
  }

  .ms-md-125 {
    margin-left: 62rem !important;
  }

  .ms-md-126 {
    margin-left: 62.5rem !important;
  }

  .ms-md-127 {
    margin-left: 63rem !important;
  }

  .ms-md-128 {
    margin-left: 63.5rem !important;
  }

  .ms-md-129 {
    margin-left: 64rem !important;
  }

  .ms-md-130 {
    margin-left: 64.5rem !important;
  }

  .ms-md-131 {
    margin-left: 65rem !important;
  }

  .ms-md-132 {
    margin-left: 65.5rem !important;
  }

  .ms-md-133 {
    margin-left: 66rem !important;
  }

  .ms-md-134 {
    margin-left: 66.5rem !important;
  }

  .ms-md-135 {
    margin-left: 67rem !important;
  }

  .ms-md-136 {
    margin-left: 67.5rem !important;
  }

  .ms-md-137 {
    margin-left: 68rem !important;
  }

  .ms-md-138 {
    margin-left: 68.5rem !important;
  }

  .ms-md-139 {
    margin-left: 69rem !important;
  }

  .ms-md-140 {
    margin-left: 69.5rem !important;
  }

  .ms-md-141 {
    margin-left: 70rem !important;
  }

  .ms-md-142 {
    margin-left: 70.5rem !important;
  }

  .ms-md-143 {
    margin-left: 71rem !important;
  }

  .ms-md-144 {
    margin-left: 71.5rem !important;
  }

  .ms-md-145 {
    margin-left: 72rem !important;
  }

  .ms-md-146 {
    margin-left: 72.5rem !important;
  }

  .ms-md-147 {
    margin-left: 73rem !important;
  }

  .ms-md-148 {
    margin-left: 73.5rem !important;
  }

  .ms-md-149 {
    margin-left: 74rem !important;
  }

  .ms-md-150 {
    margin-left: 74.5rem !important;
  }

  .ms-md-151 {
    margin-left: 75rem !important;
  }

  .ms-md-152 {
    margin-left: 75.5rem !important;
  }

  .ms-md-153 {
    margin-left: 76rem !important;
  }

  .ms-md-154 {
    margin-left: 76.5rem !important;
  }

  .ms-md-155 {
    margin-left: 77rem !important;
  }

  .ms-md-156 {
    margin-left: 77.5rem !important;
  }

  .ms-md-157 {
    margin-left: 78rem !important;
  }

  .ms-md-158 {
    margin-left: 78.5rem !important;
  }

  .ms-md-159 {
    margin-left: 79rem !important;
  }

  .ms-md-160 {
    margin-left: 79.5rem !important;
  }

  .me-md-0 {
    margin-right: 0rem !important;
  }

  .me-md-1 {
    margin-right: 0.25rem !important;
  }

  .me-md-2 {
    margin-right: 0.5rem !important;
  }

  .me-md-3 {
    margin-right: 1rem !important;
  }

  .me-md-4 {
    margin-right: 1.5rem !important;
  }

  .me-md-5 {
    margin-right: 2rem !important;
  }

  .me-md-6 {
    margin-right: 2.5rem !important;
  }

  .me-md-7 {
    margin-right: 3rem !important;
  }

  .me-md-8 {
    margin-right: 3.5rem !important;
  }

  .me-md-9 {
    margin-right: 4rem !important;
  }

  .me-md-10 {
    margin-right: 4.5rem !important;
  }

  .me-md-11 {
    margin-right: 5rem !important;
  }

  .me-md-12 {
    margin-right: 5.5rem !important;
  }

  .me-md-13 {
    margin-right: 6rem !important;
  }

  .me-md-14 {
    margin-right: 6.5rem !important;
  }

  .me-md-15 {
    margin-right: 7rem !important;
  }

  .me-md-16 {
    margin-right: 7.5rem !important;
  }

  .me-md-17 {
    margin-right: 8rem !important;
  }

  .me-md-18 {
    margin-right: 8.5rem !important;
  }

  .me-md-19 {
    margin-right: 9rem !important;
  }

  .me-md-20 {
    margin-right: 9.5rem !important;
  }

  .me-md-21 {
    margin-right: 10rem !important;
  }

  .me-md-22 {
    margin-right: 10.5rem !important;
  }

  .me-md-23 {
    margin-right: 11rem !important;
  }

  .me-md-24 {
    margin-right: 11.5rem !important;
  }

  .me-md-25 {
    margin-right: 12rem !important;
  }

  .me-md-26 {
    margin-right: 12.5rem !important;
  }

  .me-md-27 {
    margin-right: 13rem !important;
  }

  .me-md-28 {
    margin-right: 13.5rem !important;
  }

  .me-md-29 {
    margin-right: 14rem !important;
  }

  .me-md-30 {
    margin-right: 14.5rem !important;
  }

  .me-md-31 {
    margin-right: 15rem !important;
  }

  .me-md-32 {
    margin-right: 15.5rem !important;
  }

  .me-md-33 {
    margin-right: 16rem !important;
  }

  .me-md-34 {
    margin-right: 16.5rem !important;
  }

  .me-md-35 {
    margin-right: 17rem !important;
  }

  .me-md-36 {
    margin-right: 17.5rem !important;
  }

  .me-md-37 {
    margin-right: 18rem !important;
  }

  .me-md-38 {
    margin-right: 18.5rem !important;
  }

  .me-md-39 {
    margin-right: 19rem !important;
  }

  .me-md-40 {
    margin-right: 19.5rem !important;
  }

  .me-md-41 {
    margin-right: 20rem !important;
  }

  .me-md-42 {
    margin-right: 20.5rem !important;
  }

  .me-md-43 {
    margin-right: 21rem !important;
  }

  .me-md-44 {
    margin-right: 21.5rem !important;
  }

  .me-md-45 {
    margin-right: 22rem !important;
  }

  .me-md-46 {
    margin-right: 22.5rem !important;
  }

  .me-md-47 {
    margin-right: 23rem !important;
  }

  .me-md-48 {
    margin-right: 23.5rem !important;
  }

  .me-md-49 {
    margin-right: 24rem !important;
  }

  .me-md-50 {
    margin-right: 24.5rem !important;
  }

  .me-md-51 {
    margin-right: 25rem !important;
  }

  .me-md-52 {
    margin-right: 25.5rem !important;
  }

  .me-md-53 {
    margin-right: 26rem !important;
  }

  .me-md-54 {
    margin-right: 26.5rem !important;
  }

  .me-md-55 {
    margin-right: 27rem !important;
  }

  .me-md-56 {
    margin-right: 27.5rem !important;
  }

  .me-md-57 {
    margin-right: 28rem !important;
  }

  .me-md-58 {
    margin-right: 28.5rem !important;
  }

  .me-md-59 {
    margin-right: 29rem !important;
  }

  .me-md-60 {
    margin-right: 29.5rem !important;
  }

  .me-md-61 {
    margin-right: 30rem !important;
  }

  .me-md-62 {
    margin-right: 30.5rem !important;
  }

  .me-md-63 {
    margin-right: 31rem !important;
  }

  .me-md-64 {
    margin-right: 31.5rem !important;
  }

  .me-md-65 {
    margin-right: 32rem !important;
  }

  .me-md-66 {
    margin-right: 32.5rem !important;
  }

  .me-md-67 {
    margin-right: 33rem !important;
  }

  .me-md-68 {
    margin-right: 33.5rem !important;
  }

  .me-md-69 {
    margin-right: 34rem !important;
  }

  .me-md-70 {
    margin-right: 34.5rem !important;
  }

  .me-md-71 {
    margin-right: 35rem !important;
  }

  .me-md-72 {
    margin-right: 35.5rem !important;
  }

  .me-md-73 {
    margin-right: 36rem !important;
  }

  .me-md-74 {
    margin-right: 36.5rem !important;
  }

  .me-md-75 {
    margin-right: 37rem !important;
  }

  .me-md-76 {
    margin-right: 37.5rem !important;
  }

  .me-md-77 {
    margin-right: 38rem !important;
  }

  .me-md-78 {
    margin-right: 38.5rem !important;
  }

  .me-md-79 {
    margin-right: 39rem !important;
  }

  .me-md-80 {
    margin-right: 39.5rem !important;
  }

  .me-md-81 {
    margin-right: 40rem !important;
  }

  .me-md-82 {
    margin-right: 40.5rem !important;
  }

  .me-md-83 {
    margin-right: 41rem !important;
  }

  .me-md-84 {
    margin-right: 41.5rem !important;
  }

  .me-md-85 {
    margin-right: 42rem !important;
  }

  .me-md-86 {
    margin-right: 42.5rem !important;
  }

  .me-md-87 {
    margin-right: 43rem !important;
  }

  .me-md-88 {
    margin-right: 43.5rem !important;
  }

  .me-md-89 {
    margin-right: 44rem !important;
  }

  .me-md-90 {
    margin-right: 44.5rem !important;
  }

  .me-md-91 {
    margin-right: 45rem !important;
  }

  .me-md-92 {
    margin-right: 45.5rem !important;
  }

  .me-md-93 {
    margin-right: 46rem !important;
  }

  .me-md-94 {
    margin-right: 46.5rem !important;
  }

  .me-md-95 {
    margin-right: 47rem !important;
  }

  .me-md-96 {
    margin-right: 47.5rem !important;
  }

  .me-md-97 {
    margin-right: 48rem !important;
  }

  .me-md-98 {
    margin-right: 48.5rem !important;
  }

  .me-md-99 {
    margin-right: 49rem !important;
  }

  .me-md-100 {
    margin-right: 49.5rem !important;
  }

  .me-md-101 {
    margin-right: 50rem !important;
  }

  .me-md-102 {
    margin-right: 50.5rem !important;
  }

  .me-md-103 {
    margin-right: 51rem !important;
  }

  .me-md-104 {
    margin-right: 51.5rem !important;
  }

  .me-md-105 {
    margin-right: 52rem !important;
  }

  .me-md-106 {
    margin-right: 52.5rem !important;
  }

  .me-md-107 {
    margin-right: 53rem !important;
  }

  .me-md-108 {
    margin-right: 53.5rem !important;
  }

  .me-md-109 {
    margin-right: 54rem !important;
  }

  .me-md-110 {
    margin-right: 54.5rem !important;
  }

  .me-md-111 {
    margin-right: 55rem !important;
  }

  .me-md-112 {
    margin-right: 55.5rem !important;
  }

  .me-md-113 {
    margin-right: 56rem !important;
  }

  .me-md-114 {
    margin-right: 56.5rem !important;
  }

  .me-md-115 {
    margin-right: 57rem !important;
  }

  .me-md-116 {
    margin-right: 57.5rem !important;
  }

  .me-md-117 {
    margin-right: 58rem !important;
  }

  .me-md-118 {
    margin-right: 58.5rem !important;
  }

  .me-md-119 {
    margin-right: 59rem !important;
  }

  .me-md-120 {
    margin-right: 59.5rem !important;
  }

  .me-md-121 {
    margin-right: 60rem !important;
  }

  .me-md-122 {
    margin-right: 60.5rem !important;
  }

  .me-md-123 {
    margin-right: 61rem !important;
  }

  .me-md-124 {
    margin-right: 61.5rem !important;
  }

  .me-md-125 {
    margin-right: 62rem !important;
  }

  .me-md-126 {
    margin-right: 62.5rem !important;
  }

  .me-md-127 {
    margin-right: 63rem !important;
  }

  .me-md-128 {
    margin-right: 63.5rem !important;
  }

  .me-md-129 {
    margin-right: 64rem !important;
  }

  .me-md-130 {
    margin-right: 64.5rem !important;
  }

  .me-md-131 {
    margin-right: 65rem !important;
  }

  .me-md-132 {
    margin-right: 65.5rem !important;
  }

  .me-md-133 {
    margin-right: 66rem !important;
  }

  .me-md-134 {
    margin-right: 66.5rem !important;
  }

  .me-md-135 {
    margin-right: 67rem !important;
  }

  .me-md-136 {
    margin-right: 67.5rem !important;
  }

  .me-md-137 {
    margin-right: 68rem !important;
  }

  .me-md-138 {
    margin-right: 68.5rem !important;
  }

  .me-md-139 {
    margin-right: 69rem !important;
  }

  .me-md-140 {
    margin-right: 69.5rem !important;
  }

  .me-md-141 {
    margin-right: 70rem !important;
  }

  .me-md-142 {
    margin-right: 70.5rem !important;
  }

  .me-md-143 {
    margin-right: 71rem !important;
  }

  .me-md-144 {
    margin-right: 71.5rem !important;
  }

  .me-md-145 {
    margin-right: 72rem !important;
  }

  .me-md-146 {
    margin-right: 72.5rem !important;
  }

  .me-md-147 {
    margin-right: 73rem !important;
  }

  .me-md-148 {
    margin-right: 73.5rem !important;
  }

  .me-md-149 {
    margin-right: 74rem !important;
  }

  .me-md-150 {
    margin-right: 74.5rem !important;
  }

  .me-md-151 {
    margin-right: 75rem !important;
  }

  .me-md-152 {
    margin-right: 75.5rem !important;
  }

  .me-md-153 {
    margin-right: 76rem !important;
  }

  .me-md-154 {
    margin-right: 76.5rem !important;
  }

  .me-md-155 {
    margin-right: 77rem !important;
  }

  .me-md-156 {
    margin-right: 77.5rem !important;
  }

  .me-md-157 {
    margin-right: 78rem !important;
  }

  .me-md-158 {
    margin-right: 78.5rem !important;
  }

  .me-md-159 {
    margin-right: 79rem !important;
  }

  .me-md-160 {
    margin-right: 79.5rem !important;
  }

  .mx-md-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }

  .mx-md-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  .mx-md-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .mx-md-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .mx-md-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  .mx-md-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  .mx-md-6 {
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  .mx-md-7 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  .mx-md-8 {
    margin-left: 3.5rem !important;
    margin-right: 3.5rem !important;
  }

  .mx-md-9 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  .mx-md-10 {
    margin-left: 4.5rem !important;
    margin-right: 4.5rem !important;
  }

  .mx-md-11 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  .mx-md-12 {
    margin-left: 5.5rem !important;
    margin-right: 5.5rem !important;
  }

  .mx-md-13 {
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  .mx-md-14 {
    margin-left: 6.5rem !important;
    margin-right: 6.5rem !important;
  }

  .mx-md-15 {
    margin-left: 7rem !important;
    margin-right: 7rem !important;
  }

  .mx-md-16 {
    margin-left: 7.5rem !important;
    margin-right: 7.5rem !important;
  }

  .mx-md-17 {
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  .mx-md-18 {
    margin-left: 8.5rem !important;
    margin-right: 8.5rem !important;
  }

  .mx-md-19 {
    margin-left: 9rem !important;
    margin-right: 9rem !important;
  }

  .mx-md-20 {
    margin-left: 9.5rem !important;
    margin-right: 9.5rem !important;
  }

  .mx-md-21 {
    margin-left: 10rem !important;
    margin-right: 10rem !important;
  }

  .mx-md-22 {
    margin-left: 10.5rem !important;
    margin-right: 10.5rem !important;
  }

  .mx-md-23 {
    margin-left: 11rem !important;
    margin-right: 11rem !important;
  }

  .mx-md-24 {
    margin-left: 11.5rem !important;
    margin-right: 11.5rem !important;
  }

  .mx-md-25 {
    margin-left: 12rem !important;
    margin-right: 12rem !important;
  }

  .mx-md-26 {
    margin-left: 12.5rem !important;
    margin-right: 12.5rem !important;
  }

  .mx-md-27 {
    margin-left: 13rem !important;
    margin-right: 13rem !important;
  }

  .mx-md-28 {
    margin-left: 13.5rem !important;
    margin-right: 13.5rem !important;
  }

  .mx-md-29 {
    margin-left: 14rem !important;
    margin-right: 14rem !important;
  }

  .mx-md-30 {
    margin-left: 14.5rem !important;
    margin-right: 14.5rem !important;
  }

  .mx-md-31 {
    margin-left: 15rem !important;
    margin-right: 15rem !important;
  }

  .mx-md-32 {
    margin-left: 15.5rem !important;
    margin-right: 15.5rem !important;
  }

  .mx-md-33 {
    margin-left: 16rem !important;
    margin-right: 16rem !important;
  }

  .mx-md-34 {
    margin-left: 16.5rem !important;
    margin-right: 16.5rem !important;
  }

  .mx-md-35 {
    margin-left: 17rem !important;
    margin-right: 17rem !important;
  }

  .mx-md-36 {
    margin-left: 17.5rem !important;
    margin-right: 17.5rem !important;
  }

  .mx-md-37 {
    margin-left: 18rem !important;
    margin-right: 18rem !important;
  }

  .mx-md-38 {
    margin-left: 18.5rem !important;
    margin-right: 18.5rem !important;
  }

  .mx-md-39 {
    margin-left: 19rem !important;
    margin-right: 19rem !important;
  }

  .mx-md-40 {
    margin-left: 19.5rem !important;
    margin-right: 19.5rem !important;
  }

  .mx-md-41 {
    margin-left: 20rem !important;
    margin-right: 20rem !important;
  }

  .mx-md-42 {
    margin-left: 20.5rem !important;
    margin-right: 20.5rem !important;
  }

  .mx-md-43 {
    margin-left: 21rem !important;
    margin-right: 21rem !important;
  }

  .mx-md-44 {
    margin-left: 21.5rem !important;
    margin-right: 21.5rem !important;
  }

  .mx-md-45 {
    margin-left: 22rem !important;
    margin-right: 22rem !important;
  }

  .mx-md-46 {
    margin-left: 22.5rem !important;
    margin-right: 22.5rem !important;
  }

  .mx-md-47 {
    margin-left: 23rem !important;
    margin-right: 23rem !important;
  }

  .mx-md-48 {
    margin-left: 23.5rem !important;
    margin-right: 23.5rem !important;
  }

  .mx-md-49 {
    margin-left: 24rem !important;
    margin-right: 24rem !important;
  }

  .mx-md-50 {
    margin-left: 24.5rem !important;
    margin-right: 24.5rem !important;
  }

  .mx-md-51 {
    margin-left: 25rem !important;
    margin-right: 25rem !important;
  }

  .mx-md-52 {
    margin-left: 25.5rem !important;
    margin-right: 25.5rem !important;
  }

  .mx-md-53 {
    margin-left: 26rem !important;
    margin-right: 26rem !important;
  }

  .mx-md-54 {
    margin-left: 26.5rem !important;
    margin-right: 26.5rem !important;
  }

  .mx-md-55 {
    margin-left: 27rem !important;
    margin-right: 27rem !important;
  }

  .mx-md-56 {
    margin-left: 27.5rem !important;
    margin-right: 27.5rem !important;
  }

  .mx-md-57 {
    margin-left: 28rem !important;
    margin-right: 28rem !important;
  }

  .mx-md-58 {
    margin-left: 28.5rem !important;
    margin-right: 28.5rem !important;
  }

  .mx-md-59 {
    margin-left: 29rem !important;
    margin-right: 29rem !important;
  }

  .mx-md-60 {
    margin-left: 29.5rem !important;
    margin-right: 29.5rem !important;
  }

  .mx-md-61 {
    margin-left: 30rem !important;
    margin-right: 30rem !important;
  }

  .mx-md-62 {
    margin-left: 30.5rem !important;
    margin-right: 30.5rem !important;
  }

  .mx-md-63 {
    margin-left: 31rem !important;
    margin-right: 31rem !important;
  }

  .mx-md-64 {
    margin-left: 31.5rem !important;
    margin-right: 31.5rem !important;
  }

  .mx-md-65 {
    margin-left: 32rem !important;
    margin-right: 32rem !important;
  }

  .mx-md-66 {
    margin-left: 32.5rem !important;
    margin-right: 32.5rem !important;
  }

  .mx-md-67 {
    margin-left: 33rem !important;
    margin-right: 33rem !important;
  }

  .mx-md-68 {
    margin-left: 33.5rem !important;
    margin-right: 33.5rem !important;
  }

  .mx-md-69 {
    margin-left: 34rem !important;
    margin-right: 34rem !important;
  }

  .mx-md-70 {
    margin-left: 34.5rem !important;
    margin-right: 34.5rem !important;
  }

  .mx-md-71 {
    margin-left: 35rem !important;
    margin-right: 35rem !important;
  }

  .mx-md-72 {
    margin-left: 35.5rem !important;
    margin-right: 35.5rem !important;
  }

  .mx-md-73 {
    margin-left: 36rem !important;
    margin-right: 36rem !important;
  }

  .mx-md-74 {
    margin-left: 36.5rem !important;
    margin-right: 36.5rem !important;
  }

  .mx-md-75 {
    margin-left: 37rem !important;
    margin-right: 37rem !important;
  }

  .mx-md-76 {
    margin-left: 37.5rem !important;
    margin-right: 37.5rem !important;
  }

  .mx-md-77 {
    margin-left: 38rem !important;
    margin-right: 38rem !important;
  }

  .mx-md-78 {
    margin-left: 38.5rem !important;
    margin-right: 38.5rem !important;
  }

  .mx-md-79 {
    margin-left: 39rem !important;
    margin-right: 39rem !important;
  }

  .mx-md-80 {
    margin-left: 39.5rem !important;
    margin-right: 39.5rem !important;
  }

  .mx-md-81 {
    margin-left: 40rem !important;
    margin-right: 40rem !important;
  }

  .mx-md-82 {
    margin-left: 40.5rem !important;
    margin-right: 40.5rem !important;
  }

  .mx-md-83 {
    margin-left: 41rem !important;
    margin-right: 41rem !important;
  }

  .mx-md-84 {
    margin-left: 41.5rem !important;
    margin-right: 41.5rem !important;
  }

  .mx-md-85 {
    margin-left: 42rem !important;
    margin-right: 42rem !important;
  }

  .mx-md-86 {
    margin-left: 42.5rem !important;
    margin-right: 42.5rem !important;
  }

  .mx-md-87 {
    margin-left: 43rem !important;
    margin-right: 43rem !important;
  }

  .mx-md-88 {
    margin-left: 43.5rem !important;
    margin-right: 43.5rem !important;
  }

  .mx-md-89 {
    margin-left: 44rem !important;
    margin-right: 44rem !important;
  }

  .mx-md-90 {
    margin-left: 44.5rem !important;
    margin-right: 44.5rem !important;
  }

  .mx-md-91 {
    margin-left: 45rem !important;
    margin-right: 45rem !important;
  }

  .mx-md-92 {
    margin-left: 45.5rem !important;
    margin-right: 45.5rem !important;
  }

  .mx-md-93 {
    margin-left: 46rem !important;
    margin-right: 46rem !important;
  }

  .mx-md-94 {
    margin-left: 46.5rem !important;
    margin-right: 46.5rem !important;
  }

  .mx-md-95 {
    margin-left: 47rem !important;
    margin-right: 47rem !important;
  }

  .mx-md-96 {
    margin-left: 47.5rem !important;
    margin-right: 47.5rem !important;
  }

  .mx-md-97 {
    margin-left: 48rem !important;
    margin-right: 48rem !important;
  }

  .mx-md-98 {
    margin-left: 48.5rem !important;
    margin-right: 48.5rem !important;
  }

  .mx-md-99 {
    margin-left: 49rem !important;
    margin-right: 49rem !important;
  }

  .mx-md-100 {
    margin-left: 49.5rem !important;
    margin-right: 49.5rem !important;
  }

  .mx-md-101 {
    margin-left: 50rem !important;
    margin-right: 50rem !important;
  }

  .mx-md-102 {
    margin-left: 50.5rem !important;
    margin-right: 50.5rem !important;
  }

  .mx-md-103 {
    margin-left: 51rem !important;
    margin-right: 51rem !important;
  }

  .mx-md-104 {
    margin-left: 51.5rem !important;
    margin-right: 51.5rem !important;
  }

  .mx-md-105 {
    margin-left: 52rem !important;
    margin-right: 52rem !important;
  }

  .mx-md-106 {
    margin-left: 52.5rem !important;
    margin-right: 52.5rem !important;
  }

  .mx-md-107 {
    margin-left: 53rem !important;
    margin-right: 53rem !important;
  }

  .mx-md-108 {
    margin-left: 53.5rem !important;
    margin-right: 53.5rem !important;
  }

  .mx-md-109 {
    margin-left: 54rem !important;
    margin-right: 54rem !important;
  }

  .mx-md-110 {
    margin-left: 54.5rem !important;
    margin-right: 54.5rem !important;
  }

  .mx-md-111 {
    margin-left: 55rem !important;
    margin-right: 55rem !important;
  }

  .mx-md-112 {
    margin-left: 55.5rem !important;
    margin-right: 55.5rem !important;
  }

  .mx-md-113 {
    margin-left: 56rem !important;
    margin-right: 56rem !important;
  }

  .mx-md-114 {
    margin-left: 56.5rem !important;
    margin-right: 56.5rem !important;
  }

  .mx-md-115 {
    margin-left: 57rem !important;
    margin-right: 57rem !important;
  }

  .mx-md-116 {
    margin-left: 57.5rem !important;
    margin-right: 57.5rem !important;
  }

  .mx-md-117 {
    margin-left: 58rem !important;
    margin-right: 58rem !important;
  }

  .mx-md-118 {
    margin-left: 58.5rem !important;
    margin-right: 58.5rem !important;
  }

  .mx-md-119 {
    margin-left: 59rem !important;
    margin-right: 59rem !important;
  }

  .mx-md-120 {
    margin-left: 59.5rem !important;
    margin-right: 59.5rem !important;
  }

  .mx-md-121 {
    margin-left: 60rem !important;
    margin-right: 60rem !important;
  }

  .mx-md-122 {
    margin-left: 60.5rem !important;
    margin-right: 60.5rem !important;
  }

  .mx-md-123 {
    margin-left: 61rem !important;
    margin-right: 61rem !important;
  }

  .mx-md-124 {
    margin-left: 61.5rem !important;
    margin-right: 61.5rem !important;
  }

  .mx-md-125 {
    margin-left: 62rem !important;
    margin-right: 62rem !important;
  }

  .mx-md-126 {
    margin-left: 62.5rem !important;
    margin-right: 62.5rem !important;
  }

  .mx-md-127 {
    margin-left: 63rem !important;
    margin-right: 63rem !important;
  }

  .mx-md-128 {
    margin-left: 63.5rem !important;
    margin-right: 63.5rem !important;
  }

  .mx-md-129 {
    margin-left: 64rem !important;
    margin-right: 64rem !important;
  }

  .mx-md-130 {
    margin-left: 64.5rem !important;
    margin-right: 64.5rem !important;
  }

  .mx-md-131 {
    margin-left: 65rem !important;
    margin-right: 65rem !important;
  }

  .mx-md-132 {
    margin-left: 65.5rem !important;
    margin-right: 65.5rem !important;
  }

  .mx-md-133 {
    margin-left: 66rem !important;
    margin-right: 66rem !important;
  }

  .mx-md-134 {
    margin-left: 66.5rem !important;
    margin-right: 66.5rem !important;
  }

  .mx-md-135 {
    margin-left: 67rem !important;
    margin-right: 67rem !important;
  }

  .mx-md-136 {
    margin-left: 67.5rem !important;
    margin-right: 67.5rem !important;
  }

  .mx-md-137 {
    margin-left: 68rem !important;
    margin-right: 68rem !important;
  }

  .mx-md-138 {
    margin-left: 68.5rem !important;
    margin-right: 68.5rem !important;
  }

  .mx-md-139 {
    margin-left: 69rem !important;
    margin-right: 69rem !important;
  }

  .mx-md-140 {
    margin-left: 69.5rem !important;
    margin-right: 69.5rem !important;
  }

  .mx-md-141 {
    margin-left: 70rem !important;
    margin-right: 70rem !important;
  }

  .mx-md-142 {
    margin-left: 70.5rem !important;
    margin-right: 70.5rem !important;
  }

  .mx-md-143 {
    margin-left: 71rem !important;
    margin-right: 71rem !important;
  }

  .mx-md-144 {
    margin-left: 71.5rem !important;
    margin-right: 71.5rem !important;
  }

  .mx-md-145 {
    margin-left: 72rem !important;
    margin-right: 72rem !important;
  }

  .mx-md-146 {
    margin-left: 72.5rem !important;
    margin-right: 72.5rem !important;
  }

  .mx-md-147 {
    margin-left: 73rem !important;
    margin-right: 73rem !important;
  }

  .mx-md-148 {
    margin-left: 73.5rem !important;
    margin-right: 73.5rem !important;
  }

  .mx-md-149 {
    margin-left: 74rem !important;
    margin-right: 74rem !important;
  }

  .mx-md-150 {
    margin-left: 74.5rem !important;
    margin-right: 74.5rem !important;
  }

  .mx-md-151 {
    margin-left: 75rem !important;
    margin-right: 75rem !important;
  }

  .mx-md-152 {
    margin-left: 75.5rem !important;
    margin-right: 75.5rem !important;
  }

  .mx-md-153 {
    margin-left: 76rem !important;
    margin-right: 76rem !important;
  }

  .mx-md-154 {
    margin-left: 76.5rem !important;
    margin-right: 76.5rem !important;
  }

  .mx-md-155 {
    margin-left: 77rem !important;
    margin-right: 77rem !important;
  }

  .mx-md-156 {
    margin-left: 77.5rem !important;
    margin-right: 77.5rem !important;
  }

  .mx-md-157 {
    margin-left: 78rem !important;
    margin-right: 78rem !important;
  }

  .mx-md-158 {
    margin-left: 78.5rem !important;
    margin-right: 78.5rem !important;
  }

  .mx-md-159 {
    margin-left: 79rem !important;
    margin-right: 79rem !important;
  }

  .mx-md-160 {
    margin-left: 79.5rem !important;
    margin-right: 79.5rem !important;
  }

  .my-md-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-md-6 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-md-7 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-8 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-md-9 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-md-10 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-md-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-md-12 {
    margin-top: 5.5rem !important;
    margin-bottom: 5.5rem !important;
  }

  .my-md-13 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  .my-md-14 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }

  .my-md-15 {
    margin-top: 7rem !important;
    margin-bottom: 7rem !important;
  }

  .my-md-16 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }

  .my-md-17 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  .my-md-18 {
    margin-top: 8.5rem !important;
    margin-bottom: 8.5rem !important;
  }

  .my-md-19 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }

  .my-md-20 {
    margin-top: 9.5rem !important;
    margin-bottom: 9.5rem !important;
  }

  .my-md-21 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }

  .my-md-22 {
    margin-top: 10.5rem !important;
    margin-bottom: 10.5rem !important;
  }

  .my-md-23 {
    margin-top: 11rem !important;
    margin-bottom: 11rem !important;
  }

  .my-md-24 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }

  .my-md-25 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }

  .my-md-26 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }

  .my-md-27 {
    margin-top: 13rem !important;
    margin-bottom: 13rem !important;
  }

  .my-md-28 {
    margin-top: 13.5rem !important;
    margin-bottom: 13.5rem !important;
  }

  .my-md-29 {
    margin-top: 14rem !important;
    margin-bottom: 14rem !important;
  }

  .my-md-30 {
    margin-top: 14.5rem !important;
    margin-bottom: 14.5rem !important;
  }

  .my-md-31 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }

  .my-md-32 {
    margin-top: 15.5rem !important;
    margin-bottom: 15.5rem !important;
  }

  .my-md-33 {
    margin-top: 16rem !important;
    margin-bottom: 16rem !important;
  }

  .my-md-34 {
    margin-top: 16.5rem !important;
    margin-bottom: 16.5rem !important;
  }

  .my-md-35 {
    margin-top: 17rem !important;
    margin-bottom: 17rem !important;
  }

  .my-md-36 {
    margin-top: 17.5rem !important;
    margin-bottom: 17.5rem !important;
  }

  .my-md-37 {
    margin-top: 18rem !important;
    margin-bottom: 18rem !important;
  }

  .my-md-38 {
    margin-top: 18.5rem !important;
    margin-bottom: 18.5rem !important;
  }

  .my-md-39 {
    margin-top: 19rem !important;
    margin-bottom: 19rem !important;
  }

  .my-md-40 {
    margin-top: 19.5rem !important;
    margin-bottom: 19.5rem !important;
  }

  .my-md-41 {
    margin-top: 20rem !important;
    margin-bottom: 20rem !important;
  }

  .my-md-42 {
    margin-top: 20.5rem !important;
    margin-bottom: 20.5rem !important;
  }

  .my-md-43 {
    margin-top: 21rem !important;
    margin-bottom: 21rem !important;
  }

  .my-md-44 {
    margin-top: 21.5rem !important;
    margin-bottom: 21.5rem !important;
  }

  .my-md-45 {
    margin-top: 22rem !important;
    margin-bottom: 22rem !important;
  }

  .my-md-46 {
    margin-top: 22.5rem !important;
    margin-bottom: 22.5rem !important;
  }

  .my-md-47 {
    margin-top: 23rem !important;
    margin-bottom: 23rem !important;
  }

  .my-md-48 {
    margin-top: 23.5rem !important;
    margin-bottom: 23.5rem !important;
  }

  .my-md-49 {
    margin-top: 24rem !important;
    margin-bottom: 24rem !important;
  }

  .my-md-50 {
    margin-top: 24.5rem !important;
    margin-bottom: 24.5rem !important;
  }

  .my-md-51 {
    margin-top: 25rem !important;
    margin-bottom: 25rem !important;
  }

  .my-md-52 {
    margin-top: 25.5rem !important;
    margin-bottom: 25.5rem !important;
  }

  .my-md-53 {
    margin-top: 26rem !important;
    margin-bottom: 26rem !important;
  }

  .my-md-54 {
    margin-top: 26.5rem !important;
    margin-bottom: 26.5rem !important;
  }

  .my-md-55 {
    margin-top: 27rem !important;
    margin-bottom: 27rem !important;
  }

  .my-md-56 {
    margin-top: 27.5rem !important;
    margin-bottom: 27.5rem !important;
  }

  .my-md-57 {
    margin-top: 28rem !important;
    margin-bottom: 28rem !important;
  }

  .my-md-58 {
    margin-top: 28.5rem !important;
    margin-bottom: 28.5rem !important;
  }

  .my-md-59 {
    margin-top: 29rem !important;
    margin-bottom: 29rem !important;
  }

  .my-md-60 {
    margin-top: 29.5rem !important;
    margin-bottom: 29.5rem !important;
  }

  .my-md-61 {
    margin-top: 30rem !important;
    margin-bottom: 30rem !important;
  }

  .my-md-62 {
    margin-top: 30.5rem !important;
    margin-bottom: 30.5rem !important;
  }

  .my-md-63 {
    margin-top: 31rem !important;
    margin-bottom: 31rem !important;
  }

  .my-md-64 {
    margin-top: 31.5rem !important;
    margin-bottom: 31.5rem !important;
  }

  .my-md-65 {
    margin-top: 32rem !important;
    margin-bottom: 32rem !important;
  }

  .my-md-66 {
    margin-top: 32.5rem !important;
    margin-bottom: 32.5rem !important;
  }

  .my-md-67 {
    margin-top: 33rem !important;
    margin-bottom: 33rem !important;
  }

  .my-md-68 {
    margin-top: 33.5rem !important;
    margin-bottom: 33.5rem !important;
  }

  .my-md-69 {
    margin-top: 34rem !important;
    margin-bottom: 34rem !important;
  }

  .my-md-70 {
    margin-top: 34.5rem !important;
    margin-bottom: 34.5rem !important;
  }

  .my-md-71 {
    margin-top: 35rem !important;
    margin-bottom: 35rem !important;
  }

  .my-md-72 {
    margin-top: 35.5rem !important;
    margin-bottom: 35.5rem !important;
  }

  .my-md-73 {
    margin-top: 36rem !important;
    margin-bottom: 36rem !important;
  }

  .my-md-74 {
    margin-top: 36.5rem !important;
    margin-bottom: 36.5rem !important;
  }

  .my-md-75 {
    margin-top: 37rem !important;
    margin-bottom: 37rem !important;
  }

  .my-md-76 {
    margin-top: 37.5rem !important;
    margin-bottom: 37.5rem !important;
  }

  .my-md-77 {
    margin-top: 38rem !important;
    margin-bottom: 38rem !important;
  }

  .my-md-78 {
    margin-top: 38.5rem !important;
    margin-bottom: 38.5rem !important;
  }

  .my-md-79 {
    margin-top: 39rem !important;
    margin-bottom: 39rem !important;
  }

  .my-md-80 {
    margin-top: 39.5rem !important;
    margin-bottom: 39.5rem !important;
  }

  .my-md-81 {
    margin-top: 40rem !important;
    margin-bottom: 40rem !important;
  }

  .my-md-82 {
    margin-top: 40.5rem !important;
    margin-bottom: 40.5rem !important;
  }

  .my-md-83 {
    margin-top: 41rem !important;
    margin-bottom: 41rem !important;
  }

  .my-md-84 {
    margin-top: 41.5rem !important;
    margin-bottom: 41.5rem !important;
  }

  .my-md-85 {
    margin-top: 42rem !important;
    margin-bottom: 42rem !important;
  }

  .my-md-86 {
    margin-top: 42.5rem !important;
    margin-bottom: 42.5rem !important;
  }

  .my-md-87 {
    margin-top: 43rem !important;
    margin-bottom: 43rem !important;
  }

  .my-md-88 {
    margin-top: 43.5rem !important;
    margin-bottom: 43.5rem !important;
  }

  .my-md-89 {
    margin-top: 44rem !important;
    margin-bottom: 44rem !important;
  }

  .my-md-90 {
    margin-top: 44.5rem !important;
    margin-bottom: 44.5rem !important;
  }

  .my-md-91 {
    margin-top: 45rem !important;
    margin-bottom: 45rem !important;
  }

  .my-md-92 {
    margin-top: 45.5rem !important;
    margin-bottom: 45.5rem !important;
  }

  .my-md-93 {
    margin-top: 46rem !important;
    margin-bottom: 46rem !important;
  }

  .my-md-94 {
    margin-top: 46.5rem !important;
    margin-bottom: 46.5rem !important;
  }

  .my-md-95 {
    margin-top: 47rem !important;
    margin-bottom: 47rem !important;
  }

  .my-md-96 {
    margin-top: 47.5rem !important;
    margin-bottom: 47.5rem !important;
  }

  .my-md-97 {
    margin-top: 48rem !important;
    margin-bottom: 48rem !important;
  }

  .my-md-98 {
    margin-top: 48.5rem !important;
    margin-bottom: 48.5rem !important;
  }

  .my-md-99 {
    margin-top: 49rem !important;
    margin-bottom: 49rem !important;
  }

  .my-md-100 {
    margin-top: 49.5rem !important;
    margin-bottom: 49.5rem !important;
  }

  .my-md-101 {
    margin-top: 50rem !important;
    margin-bottom: 50rem !important;
  }

  .my-md-102 {
    margin-top: 50.5rem !important;
    margin-bottom: 50.5rem !important;
  }

  .my-md-103 {
    margin-top: 51rem !important;
    margin-bottom: 51rem !important;
  }

  .my-md-104 {
    margin-top: 51.5rem !important;
    margin-bottom: 51.5rem !important;
  }

  .my-md-105 {
    margin-top: 52rem !important;
    margin-bottom: 52rem !important;
  }

  .my-md-106 {
    margin-top: 52.5rem !important;
    margin-bottom: 52.5rem !important;
  }

  .my-md-107 {
    margin-top: 53rem !important;
    margin-bottom: 53rem !important;
  }

  .my-md-108 {
    margin-top: 53.5rem !important;
    margin-bottom: 53.5rem !important;
  }

  .my-md-109 {
    margin-top: 54rem !important;
    margin-bottom: 54rem !important;
  }

  .my-md-110 {
    margin-top: 54.5rem !important;
    margin-bottom: 54.5rem !important;
  }

  .my-md-111 {
    margin-top: 55rem !important;
    margin-bottom: 55rem !important;
  }

  .my-md-112 {
    margin-top: 55.5rem !important;
    margin-bottom: 55.5rem !important;
  }

  .my-md-113 {
    margin-top: 56rem !important;
    margin-bottom: 56rem !important;
  }

  .my-md-114 {
    margin-top: 56.5rem !important;
    margin-bottom: 56.5rem !important;
  }

  .my-md-115 {
    margin-top: 57rem !important;
    margin-bottom: 57rem !important;
  }

  .my-md-116 {
    margin-top: 57.5rem !important;
    margin-bottom: 57.5rem !important;
  }

  .my-md-117 {
    margin-top: 58rem !important;
    margin-bottom: 58rem !important;
  }

  .my-md-118 {
    margin-top: 58.5rem !important;
    margin-bottom: 58.5rem !important;
  }

  .my-md-119 {
    margin-top: 59rem !important;
    margin-bottom: 59rem !important;
  }

  .my-md-120 {
    margin-top: 59.5rem !important;
    margin-bottom: 59.5rem !important;
  }

  .my-md-121 {
    margin-top: 60rem !important;
    margin-bottom: 60rem !important;
  }

  .my-md-122 {
    margin-top: 60.5rem !important;
    margin-bottom: 60.5rem !important;
  }

  .my-md-123 {
    margin-top: 61rem !important;
    margin-bottom: 61rem !important;
  }

  .my-md-124 {
    margin-top: 61.5rem !important;
    margin-bottom: 61.5rem !important;
  }

  .my-md-125 {
    margin-top: 62rem !important;
    margin-bottom: 62rem !important;
  }

  .my-md-126 {
    margin-top: 62.5rem !important;
    margin-bottom: 62.5rem !important;
  }

  .my-md-127 {
    margin-top: 63rem !important;
    margin-bottom: 63rem !important;
  }

  .my-md-128 {
    margin-top: 63.5rem !important;
    margin-bottom: 63.5rem !important;
  }

  .my-md-129 {
    margin-top: 64rem !important;
    margin-bottom: 64rem !important;
  }

  .my-md-130 {
    margin-top: 64.5rem !important;
    margin-bottom: 64.5rem !important;
  }

  .my-md-131 {
    margin-top: 65rem !important;
    margin-bottom: 65rem !important;
  }

  .my-md-132 {
    margin-top: 65.5rem !important;
    margin-bottom: 65.5rem !important;
  }

  .my-md-133 {
    margin-top: 66rem !important;
    margin-bottom: 66rem !important;
  }

  .my-md-134 {
    margin-top: 66.5rem !important;
    margin-bottom: 66.5rem !important;
  }

  .my-md-135 {
    margin-top: 67rem !important;
    margin-bottom: 67rem !important;
  }

  .my-md-136 {
    margin-top: 67.5rem !important;
    margin-bottom: 67.5rem !important;
  }

  .my-md-137 {
    margin-top: 68rem !important;
    margin-bottom: 68rem !important;
  }

  .my-md-138 {
    margin-top: 68.5rem !important;
    margin-bottom: 68.5rem !important;
  }

  .my-md-139 {
    margin-top: 69rem !important;
    margin-bottom: 69rem !important;
  }

  .my-md-140 {
    margin-top: 69.5rem !important;
    margin-bottom: 69.5rem !important;
  }

  .my-md-141 {
    margin-top: 70rem !important;
    margin-bottom: 70rem !important;
  }

  .my-md-142 {
    margin-top: 70.5rem !important;
    margin-bottom: 70.5rem !important;
  }

  .my-md-143 {
    margin-top: 71rem !important;
    margin-bottom: 71rem !important;
  }

  .my-md-144 {
    margin-top: 71.5rem !important;
    margin-bottom: 71.5rem !important;
  }

  .my-md-145 {
    margin-top: 72rem !important;
    margin-bottom: 72rem !important;
  }

  .my-md-146 {
    margin-top: 72.5rem !important;
    margin-bottom: 72.5rem !important;
  }

  .my-md-147 {
    margin-top: 73rem !important;
    margin-bottom: 73rem !important;
  }

  .my-md-148 {
    margin-top: 73.5rem !important;
    margin-bottom: 73.5rem !important;
  }

  .my-md-149 {
    margin-top: 74rem !important;
    margin-bottom: 74rem !important;
  }

  .my-md-150 {
    margin-top: 74.5rem !important;
    margin-bottom: 74.5rem !important;
  }

  .my-md-151 {
    margin-top: 75rem !important;
    margin-bottom: 75rem !important;
  }

  .my-md-152 {
    margin-top: 75.5rem !important;
    margin-bottom: 75.5rem !important;
  }

  .my-md-153 {
    margin-top: 76rem !important;
    margin-bottom: 76rem !important;
  }

  .my-md-154 {
    margin-top: 76.5rem !important;
    margin-bottom: 76.5rem !important;
  }

  .my-md-155 {
    margin-top: 77rem !important;
    margin-bottom: 77rem !important;
  }

  .my-md-156 {
    margin-top: 77.5rem !important;
    margin-bottom: 77.5rem !important;
  }

  .my-md-157 {
    margin-top: 78rem !important;
    margin-bottom: 78rem !important;
  }

  .my-md-158 {
    margin-top: 78.5rem !important;
    margin-bottom: 78.5rem !important;
  }

  .my-md-159 {
    margin-top: 79rem !important;
    margin-bottom: 79rem !important;
  }

  .my-md-160 {
    margin-top: 79.5rem !important;
    margin-bottom: 79.5rem !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0rem !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 2rem !important;
  }

  .m-lg-6 {
    margin: 2.5rem !important;
  }

  .m-lg-7 {
    margin: 3rem !important;
  }

  .m-lg-8 {
    margin: 3.5rem !important;
  }

  .m-lg-9 {
    margin: 4rem !important;
  }

  .m-lg-10 {
    margin: 4.5rem !important;
  }

  .m-lg-11 {
    margin: 5rem !important;
  }

  .m-lg-12 {
    margin: 5.5rem !important;
  }

  .m-lg-13 {
    margin: 6rem !important;
  }

  .m-lg-14 {
    margin: 6.5rem !important;
  }

  .m-lg-15 {
    margin: 7rem !important;
  }

  .m-lg-16 {
    margin: 7.5rem !important;
  }

  .m-lg-17 {
    margin: 8rem !important;
  }

  .m-lg-18 {
    margin: 8.5rem !important;
  }

  .m-lg-19 {
    margin: 9rem !important;
  }

  .m-lg-20 {
    margin: 9.5rem !important;
  }

  .m-lg-21 {
    margin: 10rem !important;
  }

  .m-lg-22 {
    margin: 10.5rem !important;
  }

  .m-lg-23 {
    margin: 11rem !important;
  }

  .m-lg-24 {
    margin: 11.5rem !important;
  }

  .m-lg-25 {
    margin: 12rem !important;
  }

  .m-lg-26 {
    margin: 12.5rem !important;
  }

  .m-lg-27 {
    margin: 13rem !important;
  }

  .m-lg-28 {
    margin: 13.5rem !important;
  }

  .m-lg-29 {
    margin: 14rem !important;
  }

  .m-lg-30 {
    margin: 14.5rem !important;
  }

  .m-lg-31 {
    margin: 15rem !important;
  }

  .m-lg-32 {
    margin: 15.5rem !important;
  }

  .m-lg-33 {
    margin: 16rem !important;
  }

  .m-lg-34 {
    margin: 16.5rem !important;
  }

  .m-lg-35 {
    margin: 17rem !important;
  }

  .m-lg-36 {
    margin: 17.5rem !important;
  }

  .m-lg-37 {
    margin: 18rem !important;
  }

  .m-lg-38 {
    margin: 18.5rem !important;
  }

  .m-lg-39 {
    margin: 19rem !important;
  }

  .m-lg-40 {
    margin: 19.5rem !important;
  }

  .m-lg-41 {
    margin: 20rem !important;
  }

  .m-lg-42 {
    margin: 20.5rem !important;
  }

  .m-lg-43 {
    margin: 21rem !important;
  }

  .m-lg-44 {
    margin: 21.5rem !important;
  }

  .m-lg-45 {
    margin: 22rem !important;
  }

  .m-lg-46 {
    margin: 22.5rem !important;
  }

  .m-lg-47 {
    margin: 23rem !important;
  }

  .m-lg-48 {
    margin: 23.5rem !important;
  }

  .m-lg-49 {
    margin: 24rem !important;
  }

  .m-lg-50 {
    margin: 24.5rem !important;
  }

  .m-lg-51 {
    margin: 25rem !important;
  }

  .m-lg-52 {
    margin: 25.5rem !important;
  }

  .m-lg-53 {
    margin: 26rem !important;
  }

  .m-lg-54 {
    margin: 26.5rem !important;
  }

  .m-lg-55 {
    margin: 27rem !important;
  }

  .m-lg-56 {
    margin: 27.5rem !important;
  }

  .m-lg-57 {
    margin: 28rem !important;
  }

  .m-lg-58 {
    margin: 28.5rem !important;
  }

  .m-lg-59 {
    margin: 29rem !important;
  }

  .m-lg-60 {
    margin: 29.5rem !important;
  }

  .m-lg-61 {
    margin: 30rem !important;
  }

  .m-lg-62 {
    margin: 30.5rem !important;
  }

  .m-lg-63 {
    margin: 31rem !important;
  }

  .m-lg-64 {
    margin: 31.5rem !important;
  }

  .m-lg-65 {
    margin: 32rem !important;
  }

  .m-lg-66 {
    margin: 32.5rem !important;
  }

  .m-lg-67 {
    margin: 33rem !important;
  }

  .m-lg-68 {
    margin: 33.5rem !important;
  }

  .m-lg-69 {
    margin: 34rem !important;
  }

  .m-lg-70 {
    margin: 34.5rem !important;
  }

  .m-lg-71 {
    margin: 35rem !important;
  }

  .m-lg-72 {
    margin: 35.5rem !important;
  }

  .m-lg-73 {
    margin: 36rem !important;
  }

  .m-lg-74 {
    margin: 36.5rem !important;
  }

  .m-lg-75 {
    margin: 37rem !important;
  }

  .m-lg-76 {
    margin: 37.5rem !important;
  }

  .m-lg-77 {
    margin: 38rem !important;
  }

  .m-lg-78 {
    margin: 38.5rem !important;
  }

  .m-lg-79 {
    margin: 39rem !important;
  }

  .m-lg-80 {
    margin: 39.5rem !important;
  }

  .m-lg-81 {
    margin: 40rem !important;
  }

  .m-lg-82 {
    margin: 40.5rem !important;
  }

  .m-lg-83 {
    margin: 41rem !important;
  }

  .m-lg-84 {
    margin: 41.5rem !important;
  }

  .m-lg-85 {
    margin: 42rem !important;
  }

  .m-lg-86 {
    margin: 42.5rem !important;
  }

  .m-lg-87 {
    margin: 43rem !important;
  }

  .m-lg-88 {
    margin: 43.5rem !important;
  }

  .m-lg-89 {
    margin: 44rem !important;
  }

  .m-lg-90 {
    margin: 44.5rem !important;
  }

  .m-lg-91 {
    margin: 45rem !important;
  }

  .m-lg-92 {
    margin: 45.5rem !important;
  }

  .m-lg-93 {
    margin: 46rem !important;
  }

  .m-lg-94 {
    margin: 46.5rem !important;
  }

  .m-lg-95 {
    margin: 47rem !important;
  }

  .m-lg-96 {
    margin: 47.5rem !important;
  }

  .m-lg-97 {
    margin: 48rem !important;
  }

  .m-lg-98 {
    margin: 48.5rem !important;
  }

  .m-lg-99 {
    margin: 49rem !important;
  }

  .m-lg-100 {
    margin: 49.5rem !important;
  }

  .m-lg-101 {
    margin: 50rem !important;
  }

  .m-lg-102 {
    margin: 50.5rem !important;
  }

  .m-lg-103 {
    margin: 51rem !important;
  }

  .m-lg-104 {
    margin: 51.5rem !important;
  }

  .m-lg-105 {
    margin: 52rem !important;
  }

  .m-lg-106 {
    margin: 52.5rem !important;
  }

  .m-lg-107 {
    margin: 53rem !important;
  }

  .m-lg-108 {
    margin: 53.5rem !important;
  }

  .m-lg-109 {
    margin: 54rem !important;
  }

  .m-lg-110 {
    margin: 54.5rem !important;
  }

  .m-lg-111 {
    margin: 55rem !important;
  }

  .m-lg-112 {
    margin: 55.5rem !important;
  }

  .m-lg-113 {
    margin: 56rem !important;
  }

  .m-lg-114 {
    margin: 56.5rem !important;
  }

  .m-lg-115 {
    margin: 57rem !important;
  }

  .m-lg-116 {
    margin: 57.5rem !important;
  }

  .m-lg-117 {
    margin: 58rem !important;
  }

  .m-lg-118 {
    margin: 58.5rem !important;
  }

  .m-lg-119 {
    margin: 59rem !important;
  }

  .m-lg-120 {
    margin: 59.5rem !important;
  }

  .m-lg-121 {
    margin: 60rem !important;
  }

  .m-lg-122 {
    margin: 60.5rem !important;
  }

  .m-lg-123 {
    margin: 61rem !important;
  }

  .m-lg-124 {
    margin: 61.5rem !important;
  }

  .m-lg-125 {
    margin: 62rem !important;
  }

  .m-lg-126 {
    margin: 62.5rem !important;
  }

  .m-lg-127 {
    margin: 63rem !important;
  }

  .m-lg-128 {
    margin: 63.5rem !important;
  }

  .m-lg-129 {
    margin: 64rem !important;
  }

  .m-lg-130 {
    margin: 64.5rem !important;
  }

  .m-lg-131 {
    margin: 65rem !important;
  }

  .m-lg-132 {
    margin: 65.5rem !important;
  }

  .m-lg-133 {
    margin: 66rem !important;
  }

  .m-lg-134 {
    margin: 66.5rem !important;
  }

  .m-lg-135 {
    margin: 67rem !important;
  }

  .m-lg-136 {
    margin: 67.5rem !important;
  }

  .m-lg-137 {
    margin: 68rem !important;
  }

  .m-lg-138 {
    margin: 68.5rem !important;
  }

  .m-lg-139 {
    margin: 69rem !important;
  }

  .m-lg-140 {
    margin: 69.5rem !important;
  }

  .m-lg-141 {
    margin: 70rem !important;
  }

  .m-lg-142 {
    margin: 70.5rem !important;
  }

  .m-lg-143 {
    margin: 71rem !important;
  }

  .m-lg-144 {
    margin: 71.5rem !important;
  }

  .m-lg-145 {
    margin: 72rem !important;
  }

  .m-lg-146 {
    margin: 72.5rem !important;
  }

  .m-lg-147 {
    margin: 73rem !important;
  }

  .m-lg-148 {
    margin: 73.5rem !important;
  }

  .m-lg-149 {
    margin: 74rem !important;
  }

  .m-lg-150 {
    margin: 74.5rem !important;
  }

  .m-lg-151 {
    margin: 75rem !important;
  }

  .m-lg-152 {
    margin: 75.5rem !important;
  }

  .m-lg-153 {
    margin: 76rem !important;
  }

  .m-lg-154 {
    margin: 76.5rem !important;
  }

  .m-lg-155 {
    margin: 77rem !important;
  }

  .m-lg-156 {
    margin: 77.5rem !important;
  }

  .m-lg-157 {
    margin: 78rem !important;
  }

  .m-lg-158 {
    margin: 78.5rem !important;
  }

  .m-lg-159 {
    margin: 79rem !important;
  }

  .m-lg-160 {
    margin: 79.5rem !important;
  }

  .mt-lg-0 {
    margin-top: 0rem !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 1rem !important;
  }

  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-5 {
    margin-top: 2rem !important;
  }

  .mt-lg-6 {
    margin-top: 2.5rem !important;
  }

  .mt-lg-7 {
    margin-top: 3rem !important;
  }

  .mt-lg-8 {
    margin-top: 3.5rem !important;
  }

  .mt-lg-9 {
    margin-top: 4rem !important;
  }

  .mt-lg-10 {
    margin-top: 4.5rem !important;
  }

  .mt-lg-11 {
    margin-top: 5rem !important;
  }

  .mt-lg-12 {
    margin-top: 5.5rem !important;
  }

  .mt-lg-13 {
    margin-top: 6rem !important;
  }

  .mt-lg-14 {
    margin-top: 6.5rem !important;
  }

  .mt-lg-15 {
    margin-top: 7rem !important;
  }

  .mt-lg-16 {
    margin-top: 7.5rem !important;
  }

  .mt-lg-17 {
    margin-top: 8rem !important;
  }

  .mt-lg-18 {
    margin-top: 8.5rem !important;
  }

  .mt-lg-19 {
    margin-top: 9rem !important;
  }

  .mt-lg-20 {
    margin-top: 9.5rem !important;
  }

  .mt-lg-21 {
    margin-top: 10rem !important;
  }

  .mt-lg-22 {
    margin-top: 10.5rem !important;
  }

  .mt-lg-23 {
    margin-top: 11rem !important;
  }

  .mt-lg-24 {
    margin-top: 11.5rem !important;
  }

  .mt-lg-25 {
    margin-top: 12rem !important;
  }

  .mt-lg-26 {
    margin-top: 12.5rem !important;
  }

  .mt-lg-27 {
    margin-top: 13rem !important;
  }

  .mt-lg-28 {
    margin-top: 13.5rem !important;
  }

  .mt-lg-29 {
    margin-top: 14rem !important;
  }

  .mt-lg-30 {
    margin-top: 14.5rem !important;
  }

  .mt-lg-31 {
    margin-top: 15rem !important;
  }

  .mt-lg-32 {
    margin-top: 15.5rem !important;
  }

  .mt-lg-33 {
    margin-top: 16rem !important;
  }

  .mt-lg-34 {
    margin-top: 16.5rem !important;
  }

  .mt-lg-35 {
    margin-top: 17rem !important;
  }

  .mt-lg-36 {
    margin-top: 17.5rem !important;
  }

  .mt-lg-37 {
    margin-top: 18rem !important;
  }

  .mt-lg-38 {
    margin-top: 18.5rem !important;
  }

  .mt-lg-39 {
    margin-top: 19rem !important;
  }

  .mt-lg-40 {
    margin-top: 19.5rem !important;
  }

  .mt-lg-41 {
    margin-top: 20rem !important;
  }

  .mt-lg-42 {
    margin-top: 20.5rem !important;
  }

  .mt-lg-43 {
    margin-top: 21rem !important;
  }

  .mt-lg-44 {
    margin-top: 21.5rem !important;
  }

  .mt-lg-45 {
    margin-top: 22rem !important;
  }

  .mt-lg-46 {
    margin-top: 22.5rem !important;
  }

  .mt-lg-47 {
    margin-top: 23rem !important;
  }

  .mt-lg-48 {
    margin-top: 23.5rem !important;
  }

  .mt-lg-49 {
    margin-top: 24rem !important;
  }

  .mt-lg-50 {
    margin-top: 24.5rem !important;
  }

  .mt-lg-51 {
    margin-top: 25rem !important;
  }

  .mt-lg-52 {
    margin-top: 25.5rem !important;
  }

  .mt-lg-53 {
    margin-top: 26rem !important;
  }

  .mt-lg-54 {
    margin-top: 26.5rem !important;
  }

  .mt-lg-55 {
    margin-top: 27rem !important;
  }

  .mt-lg-56 {
    margin-top: 27.5rem !important;
  }

  .mt-lg-57 {
    margin-top: 28rem !important;
  }

  .mt-lg-58 {
    margin-top: 28.5rem !important;
  }

  .mt-lg-59 {
    margin-top: 29rem !important;
  }

  .mt-lg-60 {
    margin-top: 29.5rem !important;
  }

  .mt-lg-61 {
    margin-top: 30rem !important;
  }

  .mt-lg-62 {
    margin-top: 30.5rem !important;
  }

  .mt-lg-63 {
    margin-top: 31rem !important;
  }

  .mt-lg-64 {
    margin-top: 31.5rem !important;
  }

  .mt-lg-65 {
    margin-top: 32rem !important;
  }

  .mt-lg-66 {
    margin-top: 32.5rem !important;
  }

  .mt-lg-67 {
    margin-top: 33rem !important;
  }

  .mt-lg-68 {
    margin-top: 33.5rem !important;
  }

  .mt-lg-69 {
    margin-top: 34rem !important;
  }

  .mt-lg-70 {
    margin-top: 34.5rem !important;
  }

  .mt-lg-71 {
    margin-top: 35rem !important;
  }

  .mt-lg-72 {
    margin-top: 35.5rem !important;
  }

  .mt-lg-73 {
    margin-top: 36rem !important;
  }

  .mt-lg-74 {
    margin-top: 36.5rem !important;
  }

  .mt-lg-75 {
    margin-top: 37rem !important;
  }

  .mt-lg-76 {
    margin-top: 37.5rem !important;
  }

  .mt-lg-77 {
    margin-top: 38rem !important;
  }

  .mt-lg-78 {
    margin-top: 38.5rem !important;
  }

  .mt-lg-79 {
    margin-top: 39rem !important;
  }

  .mt-lg-80 {
    margin-top: 39.5rem !important;
  }

  .mt-lg-81 {
    margin-top: 40rem !important;
  }

  .mt-lg-82 {
    margin-top: 40.5rem !important;
  }

  .mt-lg-83 {
    margin-top: 41rem !important;
  }

  .mt-lg-84 {
    margin-top: 41.5rem !important;
  }

  .mt-lg-85 {
    margin-top: 42rem !important;
  }

  .mt-lg-86 {
    margin-top: 42.5rem !important;
  }

  .mt-lg-87 {
    margin-top: 43rem !important;
  }

  .mt-lg-88 {
    margin-top: 43.5rem !important;
  }

  .mt-lg-89 {
    margin-top: 44rem !important;
  }

  .mt-lg-90 {
    margin-top: 44.5rem !important;
  }

  .mt-lg-91 {
    margin-top: 45rem !important;
  }

  .mt-lg-92 {
    margin-top: 45.5rem !important;
  }

  .mt-lg-93 {
    margin-top: 46rem !important;
  }

  .mt-lg-94 {
    margin-top: 46.5rem !important;
  }

  .mt-lg-95 {
    margin-top: 47rem !important;
  }

  .mt-lg-96 {
    margin-top: 47.5rem !important;
  }

  .mt-lg-97 {
    margin-top: 48rem !important;
  }

  .mt-lg-98 {
    margin-top: 48.5rem !important;
  }

  .mt-lg-99 {
    margin-top: 49rem !important;
  }

  .mt-lg-100 {
    margin-top: 49.5rem !important;
  }

  .mt-lg-101 {
    margin-top: 50rem !important;
  }

  .mt-lg-102 {
    margin-top: 50.5rem !important;
  }

  .mt-lg-103 {
    margin-top: 51rem !important;
  }

  .mt-lg-104 {
    margin-top: 51.5rem !important;
  }

  .mt-lg-105 {
    margin-top: 52rem !important;
  }

  .mt-lg-106 {
    margin-top: 52.5rem !important;
  }

  .mt-lg-107 {
    margin-top: 53rem !important;
  }

  .mt-lg-108 {
    margin-top: 53.5rem !important;
  }

  .mt-lg-109 {
    margin-top: 54rem !important;
  }

  .mt-lg-110 {
    margin-top: 54.5rem !important;
  }

  .mt-lg-111 {
    margin-top: 55rem !important;
  }

  .mt-lg-112 {
    margin-top: 55.5rem !important;
  }

  .mt-lg-113 {
    margin-top: 56rem !important;
  }

  .mt-lg-114 {
    margin-top: 56.5rem !important;
  }

  .mt-lg-115 {
    margin-top: 57rem !important;
  }

  .mt-lg-116 {
    margin-top: 57.5rem !important;
  }

  .mt-lg-117 {
    margin-top: 58rem !important;
  }

  .mt-lg-118 {
    margin-top: 58.5rem !important;
  }

  .mt-lg-119 {
    margin-top: 59rem !important;
  }

  .mt-lg-120 {
    margin-top: 59.5rem !important;
  }

  .mt-lg-121 {
    margin-top: 60rem !important;
  }

  .mt-lg-122 {
    margin-top: 60.5rem !important;
  }

  .mt-lg-123 {
    margin-top: 61rem !important;
  }

  .mt-lg-124 {
    margin-top: 61.5rem !important;
  }

  .mt-lg-125 {
    margin-top: 62rem !important;
  }

  .mt-lg-126 {
    margin-top: 62.5rem !important;
  }

  .mt-lg-127 {
    margin-top: 63rem !important;
  }

  .mt-lg-128 {
    margin-top: 63.5rem !important;
  }

  .mt-lg-129 {
    margin-top: 64rem !important;
  }

  .mt-lg-130 {
    margin-top: 64.5rem !important;
  }

  .mt-lg-131 {
    margin-top: 65rem !important;
  }

  .mt-lg-132 {
    margin-top: 65.5rem !important;
  }

  .mt-lg-133 {
    margin-top: 66rem !important;
  }

  .mt-lg-134 {
    margin-top: 66.5rem !important;
  }

  .mt-lg-135 {
    margin-top: 67rem !important;
  }

  .mt-lg-136 {
    margin-top: 67.5rem !important;
  }

  .mt-lg-137 {
    margin-top: 68rem !important;
  }

  .mt-lg-138 {
    margin-top: 68.5rem !important;
  }

  .mt-lg-139 {
    margin-top: 69rem !important;
  }

  .mt-lg-140 {
    margin-top: 69.5rem !important;
  }

  .mt-lg-141 {
    margin-top: 70rem !important;
  }

  .mt-lg-142 {
    margin-top: 70.5rem !important;
  }

  .mt-lg-143 {
    margin-top: 71rem !important;
  }

  .mt-lg-144 {
    margin-top: 71.5rem !important;
  }

  .mt-lg-145 {
    margin-top: 72rem !important;
  }

  .mt-lg-146 {
    margin-top: 72.5rem !important;
  }

  .mt-lg-147 {
    margin-top: 73rem !important;
  }

  .mt-lg-148 {
    margin-top: 73.5rem !important;
  }

  .mt-lg-149 {
    margin-top: 74rem !important;
  }

  .mt-lg-150 {
    margin-top: 74.5rem !important;
  }

  .mt-lg-151 {
    margin-top: 75rem !important;
  }

  .mt-lg-152 {
    margin-top: 75.5rem !important;
  }

  .mt-lg-153 {
    margin-top: 76rem !important;
  }

  .mt-lg-154 {
    margin-top: 76.5rem !important;
  }

  .mt-lg-155 {
    margin-top: 77rem !important;
  }

  .mt-lg-156 {
    margin-top: 77.5rem !important;
  }

  .mt-lg-157 {
    margin-top: 78rem !important;
  }

  .mt-lg-158 {
    margin-top: 78.5rem !important;
  }

  .mt-lg-159 {
    margin-top: 79rem !important;
  }

  .mt-lg-160 {
    margin-top: 79.5rem !important;
  }

  .mb-lg-0 {
    margin-bottom: 0rem !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 2rem !important;
  }

  .mb-lg-6 {
    margin-bottom: 2.5rem !important;
  }

  .mb-lg-7 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-8 {
    margin-bottom: 3.5rem !important;
  }

  .mb-lg-9 {
    margin-bottom: 4rem !important;
  }

  .mb-lg-10 {
    margin-bottom: 4.5rem !important;
  }

  .mb-lg-11 {
    margin-bottom: 5rem !important;
  }

  .mb-lg-12 {
    margin-bottom: 5.5rem !important;
  }

  .mb-lg-13 {
    margin-bottom: 6rem !important;
  }

  .mb-lg-14 {
    margin-bottom: 6.5rem !important;
  }

  .mb-lg-15 {
    margin-bottom: 7rem !important;
  }

  .mb-lg-16 {
    margin-bottom: 7.5rem !important;
  }

  .mb-lg-17 {
    margin-bottom: 8rem !important;
  }

  .mb-lg-18 {
    margin-bottom: 8.5rem !important;
  }

  .mb-lg-19 {
    margin-bottom: 9rem !important;
  }

  .mb-lg-20 {
    margin-bottom: 9.5rem !important;
  }

  .mb-lg-21 {
    margin-bottom: 10rem !important;
  }

  .mb-lg-22 {
    margin-bottom: 10.5rem !important;
  }

  .mb-lg-23 {
    margin-bottom: 11rem !important;
  }

  .mb-lg-24 {
    margin-bottom: 11.5rem !important;
  }

  .mb-lg-25 {
    margin-bottom: 12rem !important;
  }

  .mb-lg-26 {
    margin-bottom: 12.5rem !important;
  }

  .mb-lg-27 {
    margin-bottom: 13rem !important;
  }

  .mb-lg-28 {
    margin-bottom: 13.5rem !important;
  }

  .mb-lg-29 {
    margin-bottom: 14rem !important;
  }

  .mb-lg-30 {
    margin-bottom: 14.5rem !important;
  }

  .mb-lg-31 {
    margin-bottom: 15rem !important;
  }

  .mb-lg-32 {
    margin-bottom: 15.5rem !important;
  }

  .mb-lg-33 {
    margin-bottom: 16rem !important;
  }

  .mb-lg-34 {
    margin-bottom: 16.5rem !important;
  }

  .mb-lg-35 {
    margin-bottom: 17rem !important;
  }

  .mb-lg-36 {
    margin-bottom: 17.5rem !important;
  }

  .mb-lg-37 {
    margin-bottom: 18rem !important;
  }

  .mb-lg-38 {
    margin-bottom: 18.5rem !important;
  }

  .mb-lg-39 {
    margin-bottom: 19rem !important;
  }

  .mb-lg-40 {
    margin-bottom: 19.5rem !important;
  }

  .mb-lg-41 {
    margin-bottom: 20rem !important;
  }

  .mb-lg-42 {
    margin-bottom: 20.5rem !important;
  }

  .mb-lg-43 {
    margin-bottom: 21rem !important;
  }

  .mb-lg-44 {
    margin-bottom: 21.5rem !important;
  }

  .mb-lg-45 {
    margin-bottom: 22rem !important;
  }

  .mb-lg-46 {
    margin-bottom: 22.5rem !important;
  }

  .mb-lg-47 {
    margin-bottom: 23rem !important;
  }

  .mb-lg-48 {
    margin-bottom: 23.5rem !important;
  }

  .mb-lg-49 {
    margin-bottom: 24rem !important;
  }

  .mb-lg-50 {
    margin-bottom: 24.5rem !important;
  }

  .mb-lg-51 {
    margin-bottom: 25rem !important;
  }

  .mb-lg-52 {
    margin-bottom: 25.5rem !important;
  }

  .mb-lg-53 {
    margin-bottom: 26rem !important;
  }

  .mb-lg-54 {
    margin-bottom: 26.5rem !important;
  }

  .mb-lg-55 {
    margin-bottom: 27rem !important;
  }

  .mb-lg-56 {
    margin-bottom: 27.5rem !important;
  }

  .mb-lg-57 {
    margin-bottom: 28rem !important;
  }

  .mb-lg-58 {
    margin-bottom: 28.5rem !important;
  }

  .mb-lg-59 {
    margin-bottom: 29rem !important;
  }

  .mb-lg-60 {
    margin-bottom: 29.5rem !important;
  }

  .mb-lg-61 {
    margin-bottom: 30rem !important;
  }

  .mb-lg-62 {
    margin-bottom: 30.5rem !important;
  }

  .mb-lg-63 {
    margin-bottom: 31rem !important;
  }

  .mb-lg-64 {
    margin-bottom: 31.5rem !important;
  }

  .mb-lg-65 {
    margin-bottom: 32rem !important;
  }

  .mb-lg-66 {
    margin-bottom: 32.5rem !important;
  }

  .mb-lg-67 {
    margin-bottom: 33rem !important;
  }

  .mb-lg-68 {
    margin-bottom: 33.5rem !important;
  }

  .mb-lg-69 {
    margin-bottom: 34rem !important;
  }

  .mb-lg-70 {
    margin-bottom: 34.5rem !important;
  }

  .mb-lg-71 {
    margin-bottom: 35rem !important;
  }

  .mb-lg-72 {
    margin-bottom: 35.5rem !important;
  }

  .mb-lg-73 {
    margin-bottom: 36rem !important;
  }

  .mb-lg-74 {
    margin-bottom: 36.5rem !important;
  }

  .mb-lg-75 {
    margin-bottom: 37rem !important;
  }

  .mb-lg-76 {
    margin-bottom: 37.5rem !important;
  }

  .mb-lg-77 {
    margin-bottom: 38rem !important;
  }

  .mb-lg-78 {
    margin-bottom: 38.5rem !important;
  }

  .mb-lg-79 {
    margin-bottom: 39rem !important;
  }

  .mb-lg-80 {
    margin-bottom: 39.5rem !important;
  }

  .mb-lg-81 {
    margin-bottom: 40rem !important;
  }

  .mb-lg-82 {
    margin-bottom: 40.5rem !important;
  }

  .mb-lg-83 {
    margin-bottom: 41rem !important;
  }

  .mb-lg-84 {
    margin-bottom: 41.5rem !important;
  }

  .mb-lg-85 {
    margin-bottom: 42rem !important;
  }

  .mb-lg-86 {
    margin-bottom: 42.5rem !important;
  }

  .mb-lg-87 {
    margin-bottom: 43rem !important;
  }

  .mb-lg-88 {
    margin-bottom: 43.5rem !important;
  }

  .mb-lg-89 {
    margin-bottom: 44rem !important;
  }

  .mb-lg-90 {
    margin-bottom: 44.5rem !important;
  }

  .mb-lg-91 {
    margin-bottom: 45rem !important;
  }

  .mb-lg-92 {
    margin-bottom: 45.5rem !important;
  }

  .mb-lg-93 {
    margin-bottom: 46rem !important;
  }

  .mb-lg-94 {
    margin-bottom: 46.5rem !important;
  }

  .mb-lg-95 {
    margin-bottom: 47rem !important;
  }

  .mb-lg-96 {
    margin-bottom: 47.5rem !important;
  }

  .mb-lg-97 {
    margin-bottom: 48rem !important;
  }

  .mb-lg-98 {
    margin-bottom: 48.5rem !important;
  }

  .mb-lg-99 {
    margin-bottom: 49rem !important;
  }

  .mb-lg-100 {
    margin-bottom: 49.5rem !important;
  }

  .mb-lg-101 {
    margin-bottom: 50rem !important;
  }

  .mb-lg-102 {
    margin-bottom: 50.5rem !important;
  }

  .mb-lg-103 {
    margin-bottom: 51rem !important;
  }

  .mb-lg-104 {
    margin-bottom: 51.5rem !important;
  }

  .mb-lg-105 {
    margin-bottom: 52rem !important;
  }

  .mb-lg-106 {
    margin-bottom: 52.5rem !important;
  }

  .mb-lg-107 {
    margin-bottom: 53rem !important;
  }

  .mb-lg-108 {
    margin-bottom: 53.5rem !important;
  }

  .mb-lg-109 {
    margin-bottom: 54rem !important;
  }

  .mb-lg-110 {
    margin-bottom: 54.5rem !important;
  }

  .mb-lg-111 {
    margin-bottom: 55rem !important;
  }

  .mb-lg-112 {
    margin-bottom: 55.5rem !important;
  }

  .mb-lg-113 {
    margin-bottom: 56rem !important;
  }

  .mb-lg-114 {
    margin-bottom: 56.5rem !important;
  }

  .mb-lg-115 {
    margin-bottom: 57rem !important;
  }

  .mb-lg-116 {
    margin-bottom: 57.5rem !important;
  }

  .mb-lg-117 {
    margin-bottom: 58rem !important;
  }

  .mb-lg-118 {
    margin-bottom: 58.5rem !important;
  }

  .mb-lg-119 {
    margin-bottom: 59rem !important;
  }

  .mb-lg-120 {
    margin-bottom: 59.5rem !important;
  }

  .mb-lg-121 {
    margin-bottom: 60rem !important;
  }

  .mb-lg-122 {
    margin-bottom: 60.5rem !important;
  }

  .mb-lg-123 {
    margin-bottom: 61rem !important;
  }

  .mb-lg-124 {
    margin-bottom: 61.5rem !important;
  }

  .mb-lg-125 {
    margin-bottom: 62rem !important;
  }

  .mb-lg-126 {
    margin-bottom: 62.5rem !important;
  }

  .mb-lg-127 {
    margin-bottom: 63rem !important;
  }

  .mb-lg-128 {
    margin-bottom: 63.5rem !important;
  }

  .mb-lg-129 {
    margin-bottom: 64rem !important;
  }

  .mb-lg-130 {
    margin-bottom: 64.5rem !important;
  }

  .mb-lg-131 {
    margin-bottom: 65rem !important;
  }

  .mb-lg-132 {
    margin-bottom: 65.5rem !important;
  }

  .mb-lg-133 {
    margin-bottom: 66rem !important;
  }

  .mb-lg-134 {
    margin-bottom: 66.5rem !important;
  }

  .mb-lg-135 {
    margin-bottom: 67rem !important;
  }

  .mb-lg-136 {
    margin-bottom: 67.5rem !important;
  }

  .mb-lg-137 {
    margin-bottom: 68rem !important;
  }

  .mb-lg-138 {
    margin-bottom: 68.5rem !important;
  }

  .mb-lg-139 {
    margin-bottom: 69rem !important;
  }

  .mb-lg-140 {
    margin-bottom: 69.5rem !important;
  }

  .mb-lg-141 {
    margin-bottom: 70rem !important;
  }

  .mb-lg-142 {
    margin-bottom: 70.5rem !important;
  }

  .mb-lg-143 {
    margin-bottom: 71rem !important;
  }

  .mb-lg-144 {
    margin-bottom: 71.5rem !important;
  }

  .mb-lg-145 {
    margin-bottom: 72rem !important;
  }

  .mb-lg-146 {
    margin-bottom: 72.5rem !important;
  }

  .mb-lg-147 {
    margin-bottom: 73rem !important;
  }

  .mb-lg-148 {
    margin-bottom: 73.5rem !important;
  }

  .mb-lg-149 {
    margin-bottom: 74rem !important;
  }

  .mb-lg-150 {
    margin-bottom: 74.5rem !important;
  }

  .mb-lg-151 {
    margin-bottom: 75rem !important;
  }

  .mb-lg-152 {
    margin-bottom: 75.5rem !important;
  }

  .mb-lg-153 {
    margin-bottom: 76rem !important;
  }

  .mb-lg-154 {
    margin-bottom: 76.5rem !important;
  }

  .mb-lg-155 {
    margin-bottom: 77rem !important;
  }

  .mb-lg-156 {
    margin-bottom: 77.5rem !important;
  }

  .mb-lg-157 {
    margin-bottom: 78rem !important;
  }

  .mb-lg-158 {
    margin-bottom: 78.5rem !important;
  }

  .mb-lg-159 {
    margin-bottom: 79rem !important;
  }

  .mb-lg-160 {
    margin-bottom: 79.5rem !important;
  }

  .ms-lg-0 {
    margin-left: 0rem !important;
  }

  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  .ms-lg-3 {
    margin-left: 1rem !important;
  }

  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }

  .ms-lg-5 {
    margin-left: 2rem !important;
  }

  .ms-lg-6 {
    margin-left: 2.5rem !important;
  }

  .ms-lg-7 {
    margin-left: 3rem !important;
  }

  .ms-lg-8 {
    margin-left: 3.5rem !important;
  }

  .ms-lg-9 {
    margin-left: 4rem !important;
  }

  .ms-lg-10 {
    margin-left: 4.5rem !important;
  }

  .ms-lg-11 {
    margin-left: 5rem !important;
  }

  .ms-lg-12 {
    margin-left: 5.5rem !important;
  }

  .ms-lg-13 {
    margin-left: 6rem !important;
  }

  .ms-lg-14 {
    margin-left: 6.5rem !important;
  }

  .ms-lg-15 {
    margin-left: 7rem !important;
  }

  .ms-lg-16 {
    margin-left: 7.5rem !important;
  }

  .ms-lg-17 {
    margin-left: 8rem !important;
  }

  .ms-lg-18 {
    margin-left: 8.5rem !important;
  }

  .ms-lg-19 {
    margin-left: 9rem !important;
  }

  .ms-lg-20 {
    margin-left: 9.5rem !important;
  }

  .ms-lg-21 {
    margin-left: 10rem !important;
  }

  .ms-lg-22 {
    margin-left: 10.5rem !important;
  }

  .ms-lg-23 {
    margin-left: 11rem !important;
  }

  .ms-lg-24 {
    margin-left: 11.5rem !important;
  }

  .ms-lg-25 {
    margin-left: 12rem !important;
  }

  .ms-lg-26 {
    margin-left: 12.5rem !important;
  }

  .ms-lg-27 {
    margin-left: 13rem !important;
  }

  .ms-lg-28 {
    margin-left: 13.5rem !important;
  }

  .ms-lg-29 {
    margin-left: 14rem !important;
  }

  .ms-lg-30 {
    margin-left: 14.5rem !important;
  }

  .ms-lg-31 {
    margin-left: 15rem !important;
  }

  .ms-lg-32 {
    margin-left: 15.5rem !important;
  }

  .ms-lg-33 {
    margin-left: 16rem !important;
  }

  .ms-lg-34 {
    margin-left: 16.5rem !important;
  }

  .ms-lg-35 {
    margin-left: 17rem !important;
  }

  .ms-lg-36 {
    margin-left: 17.5rem !important;
  }

  .ms-lg-37 {
    margin-left: 18rem !important;
  }

  .ms-lg-38 {
    margin-left: 18.5rem !important;
  }

  .ms-lg-39 {
    margin-left: 19rem !important;
  }

  .ms-lg-40 {
    margin-left: 19.5rem !important;
  }

  .ms-lg-41 {
    margin-left: 20rem !important;
  }

  .ms-lg-42 {
    margin-left: 20.5rem !important;
  }

  .ms-lg-43 {
    margin-left: 21rem !important;
  }

  .ms-lg-44 {
    margin-left: 21.5rem !important;
  }

  .ms-lg-45 {
    margin-left: 22rem !important;
  }

  .ms-lg-46 {
    margin-left: 22.5rem !important;
  }

  .ms-lg-47 {
    margin-left: 23rem !important;
  }

  .ms-lg-48 {
    margin-left: 23.5rem !important;
  }

  .ms-lg-49 {
    margin-left: 24rem !important;
  }

  .ms-lg-50 {
    margin-left: 24.5rem !important;
  }

  .ms-lg-51 {
    margin-left: 25rem !important;
  }

  .ms-lg-52 {
    margin-left: 25.5rem !important;
  }

  .ms-lg-53 {
    margin-left: 26rem !important;
  }

  .ms-lg-54 {
    margin-left: 26.5rem !important;
  }

  .ms-lg-55 {
    margin-left: 27rem !important;
  }

  .ms-lg-56 {
    margin-left: 27.5rem !important;
  }

  .ms-lg-57 {
    margin-left: 28rem !important;
  }

  .ms-lg-58 {
    margin-left: 28.5rem !important;
  }

  .ms-lg-59 {
    margin-left: 29rem !important;
  }

  .ms-lg-60 {
    margin-left: 29.5rem !important;
  }

  .ms-lg-61 {
    margin-left: 30rem !important;
  }

  .ms-lg-62 {
    margin-left: 30.5rem !important;
  }

  .ms-lg-63 {
    margin-left: 31rem !important;
  }

  .ms-lg-64 {
    margin-left: 31.5rem !important;
  }

  .ms-lg-65 {
    margin-left: 32rem !important;
  }

  .ms-lg-66 {
    margin-left: 32.5rem !important;
  }

  .ms-lg-67 {
    margin-left: 33rem !important;
  }

  .ms-lg-68 {
    margin-left: 33.5rem !important;
  }

  .ms-lg-69 {
    margin-left: 34rem !important;
  }

  .ms-lg-70 {
    margin-left: 34.5rem !important;
  }

  .ms-lg-71 {
    margin-left: 35rem !important;
  }

  .ms-lg-72 {
    margin-left: 35.5rem !important;
  }

  .ms-lg-73 {
    margin-left: 36rem !important;
  }

  .ms-lg-74 {
    margin-left: 36.5rem !important;
  }

  .ms-lg-75 {
    margin-left: 37rem !important;
  }

  .ms-lg-76 {
    margin-left: 37.5rem !important;
  }

  .ms-lg-77 {
    margin-left: 38rem !important;
  }

  .ms-lg-78 {
    margin-left: 38.5rem !important;
  }

  .ms-lg-79 {
    margin-left: 39rem !important;
  }

  .ms-lg-80 {
    margin-left: 39.5rem !important;
  }

  .ms-lg-81 {
    margin-left: 40rem !important;
  }

  .ms-lg-82 {
    margin-left: 40.5rem !important;
  }

  .ms-lg-83 {
    margin-left: 41rem !important;
  }

  .ms-lg-84 {
    margin-left: 41.5rem !important;
  }

  .ms-lg-85 {
    margin-left: 42rem !important;
  }

  .ms-lg-86 {
    margin-left: 42.5rem !important;
  }

  .ms-lg-87 {
    margin-left: 43rem !important;
  }

  .ms-lg-88 {
    margin-left: 43.5rem !important;
  }

  .ms-lg-89 {
    margin-left: 44rem !important;
  }

  .ms-lg-90 {
    margin-left: 44.5rem !important;
  }

  .ms-lg-91 {
    margin-left: 45rem !important;
  }

  .ms-lg-92 {
    margin-left: 45.5rem !important;
  }

  .ms-lg-93 {
    margin-left: 46rem !important;
  }

  .ms-lg-94 {
    margin-left: 46.5rem !important;
  }

  .ms-lg-95 {
    margin-left: 47rem !important;
  }

  .ms-lg-96 {
    margin-left: 47.5rem !important;
  }

  .ms-lg-97 {
    margin-left: 48rem !important;
  }

  .ms-lg-98 {
    margin-left: 48.5rem !important;
  }

  .ms-lg-99 {
    margin-left: 49rem !important;
  }

  .ms-lg-100 {
    margin-left: 49.5rem !important;
  }

  .ms-lg-101 {
    margin-left: 50rem !important;
  }

  .ms-lg-102 {
    margin-left: 50.5rem !important;
  }

  .ms-lg-103 {
    margin-left: 51rem !important;
  }

  .ms-lg-104 {
    margin-left: 51.5rem !important;
  }

  .ms-lg-105 {
    margin-left: 52rem !important;
  }

  .ms-lg-106 {
    margin-left: 52.5rem !important;
  }

  .ms-lg-107 {
    margin-left: 53rem !important;
  }

  .ms-lg-108 {
    margin-left: 53.5rem !important;
  }

  .ms-lg-109 {
    margin-left: 54rem !important;
  }

  .ms-lg-110 {
    margin-left: 54.5rem !important;
  }

  .ms-lg-111 {
    margin-left: 55rem !important;
  }

  .ms-lg-112 {
    margin-left: 55.5rem !important;
  }

  .ms-lg-113 {
    margin-left: 56rem !important;
  }

  .ms-lg-114 {
    margin-left: 56.5rem !important;
  }

  .ms-lg-115 {
    margin-left: 57rem !important;
  }

  .ms-lg-116 {
    margin-left: 57.5rem !important;
  }

  .ms-lg-117 {
    margin-left: 58rem !important;
  }

  .ms-lg-118 {
    margin-left: 58.5rem !important;
  }

  .ms-lg-119 {
    margin-left: 59rem !important;
  }

  .ms-lg-120 {
    margin-left: 59.5rem !important;
  }

  .ms-lg-121 {
    margin-left: 60rem !important;
  }

  .ms-lg-122 {
    margin-left: 60.5rem !important;
  }

  .ms-lg-123 {
    margin-left: 61rem !important;
  }

  .ms-lg-124 {
    margin-left: 61.5rem !important;
  }

  .ms-lg-125 {
    margin-left: 62rem !important;
  }

  .ms-lg-126 {
    margin-left: 62.5rem !important;
  }

  .ms-lg-127 {
    margin-left: 63rem !important;
  }

  .ms-lg-128 {
    margin-left: 63.5rem !important;
  }

  .ms-lg-129 {
    margin-left: 64rem !important;
  }

  .ms-lg-130 {
    margin-left: 64.5rem !important;
  }

  .ms-lg-131 {
    margin-left: 65rem !important;
  }

  .ms-lg-132 {
    margin-left: 65.5rem !important;
  }

  .ms-lg-133 {
    margin-left: 66rem !important;
  }

  .ms-lg-134 {
    margin-left: 66.5rem !important;
  }

  .ms-lg-135 {
    margin-left: 67rem !important;
  }

  .ms-lg-136 {
    margin-left: 67.5rem !important;
  }

  .ms-lg-137 {
    margin-left: 68rem !important;
  }

  .ms-lg-138 {
    margin-left: 68.5rem !important;
  }

  .ms-lg-139 {
    margin-left: 69rem !important;
  }

  .ms-lg-140 {
    margin-left: 69.5rem !important;
  }

  .ms-lg-141 {
    margin-left: 70rem !important;
  }

  .ms-lg-142 {
    margin-left: 70.5rem !important;
  }

  .ms-lg-143 {
    margin-left: 71rem !important;
  }

  .ms-lg-144 {
    margin-left: 71.5rem !important;
  }

  .ms-lg-145 {
    margin-left: 72rem !important;
  }

  .ms-lg-146 {
    margin-left: 72.5rem !important;
  }

  .ms-lg-147 {
    margin-left: 73rem !important;
  }

  .ms-lg-148 {
    margin-left: 73.5rem !important;
  }

  .ms-lg-149 {
    margin-left: 74rem !important;
  }

  .ms-lg-150 {
    margin-left: 74.5rem !important;
  }

  .ms-lg-151 {
    margin-left: 75rem !important;
  }

  .ms-lg-152 {
    margin-left: 75.5rem !important;
  }

  .ms-lg-153 {
    margin-left: 76rem !important;
  }

  .ms-lg-154 {
    margin-left: 76.5rem !important;
  }

  .ms-lg-155 {
    margin-left: 77rem !important;
  }

  .ms-lg-156 {
    margin-left: 77.5rem !important;
  }

  .ms-lg-157 {
    margin-left: 78rem !important;
  }

  .ms-lg-158 {
    margin-left: 78.5rem !important;
  }

  .ms-lg-159 {
    margin-left: 79rem !important;
  }

  .ms-lg-160 {
    margin-left: 79.5rem !important;
  }

  .me-lg-0 {
    margin-right: 0rem !important;
  }

  .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  .me-lg-3 {
    margin-right: 1rem !important;
  }

  .me-lg-4 {
    margin-right: 1.5rem !important;
  }

  .me-lg-5 {
    margin-right: 2rem !important;
  }

  .me-lg-6 {
    margin-right: 2.5rem !important;
  }

  .me-lg-7 {
    margin-right: 3rem !important;
  }

  .me-lg-8 {
    margin-right: 3.5rem !important;
  }

  .me-lg-9 {
    margin-right: 4rem !important;
  }

  .me-lg-10 {
    margin-right: 4.5rem !important;
  }

  .me-lg-11 {
    margin-right: 5rem !important;
  }

  .me-lg-12 {
    margin-right: 5.5rem !important;
  }

  .me-lg-13 {
    margin-right: 6rem !important;
  }

  .me-lg-14 {
    margin-right: 6.5rem !important;
  }

  .me-lg-15 {
    margin-right: 7rem !important;
  }

  .me-lg-16 {
    margin-right: 7.5rem !important;
  }

  .me-lg-17 {
    margin-right: 8rem !important;
  }

  .me-lg-18 {
    margin-right: 8.5rem !important;
  }

  .me-lg-19 {
    margin-right: 9rem !important;
  }

  .me-lg-20 {
    margin-right: 9.5rem !important;
  }

  .me-lg-21 {
    margin-right: 10rem !important;
  }

  .me-lg-22 {
    margin-right: 10.5rem !important;
  }

  .me-lg-23 {
    margin-right: 11rem !important;
  }

  .me-lg-24 {
    margin-right: 11.5rem !important;
  }

  .me-lg-25 {
    margin-right: 12rem !important;
  }

  .me-lg-26 {
    margin-right: 12.5rem !important;
  }

  .me-lg-27 {
    margin-right: 13rem !important;
  }

  .me-lg-28 {
    margin-right: 13.5rem !important;
  }

  .me-lg-29 {
    margin-right: 14rem !important;
  }

  .me-lg-30 {
    margin-right: 14.5rem !important;
  }

  .me-lg-31 {
    margin-right: 15rem !important;
  }

  .me-lg-32 {
    margin-right: 15.5rem !important;
  }

  .me-lg-33 {
    margin-right: 16rem !important;
  }

  .me-lg-34 {
    margin-right: 16.5rem !important;
  }

  .me-lg-35 {
    margin-right: 17rem !important;
  }

  .me-lg-36 {
    margin-right: 17.5rem !important;
  }

  .me-lg-37 {
    margin-right: 18rem !important;
  }

  .me-lg-38 {
    margin-right: 18.5rem !important;
  }

  .me-lg-39 {
    margin-right: 19rem !important;
  }

  .me-lg-40 {
    margin-right: 19.5rem !important;
  }

  .me-lg-41 {
    margin-right: 20rem !important;
  }

  .me-lg-42 {
    margin-right: 20.5rem !important;
  }

  .me-lg-43 {
    margin-right: 21rem !important;
  }

  .me-lg-44 {
    margin-right: 21.5rem !important;
  }

  .me-lg-45 {
    margin-right: 22rem !important;
  }

  .me-lg-46 {
    margin-right: 22.5rem !important;
  }

  .me-lg-47 {
    margin-right: 23rem !important;
  }

  .me-lg-48 {
    margin-right: 23.5rem !important;
  }

  .me-lg-49 {
    margin-right: 24rem !important;
  }

  .me-lg-50 {
    margin-right: 24.5rem !important;
  }

  .me-lg-51 {
    margin-right: 25rem !important;
  }

  .me-lg-52 {
    margin-right: 25.5rem !important;
  }

  .me-lg-53 {
    margin-right: 26rem !important;
  }

  .me-lg-54 {
    margin-right: 26.5rem !important;
  }

  .me-lg-55 {
    margin-right: 27rem !important;
  }

  .me-lg-56 {
    margin-right: 27.5rem !important;
  }

  .me-lg-57 {
    margin-right: 28rem !important;
  }

  .me-lg-58 {
    margin-right: 28.5rem !important;
  }

  .me-lg-59 {
    margin-right: 29rem !important;
  }

  .me-lg-60 {
    margin-right: 29.5rem !important;
  }

  .me-lg-61 {
    margin-right: 30rem !important;
  }

  .me-lg-62 {
    margin-right: 30.5rem !important;
  }

  .me-lg-63 {
    margin-right: 31rem !important;
  }

  .me-lg-64 {
    margin-right: 31.5rem !important;
  }

  .me-lg-65 {
    margin-right: 32rem !important;
  }

  .me-lg-66 {
    margin-right: 32.5rem !important;
  }

  .me-lg-67 {
    margin-right: 33rem !important;
  }

  .me-lg-68 {
    margin-right: 33.5rem !important;
  }

  .me-lg-69 {
    margin-right: 34rem !important;
  }

  .me-lg-70 {
    margin-right: 34.5rem !important;
  }

  .me-lg-71 {
    margin-right: 35rem !important;
  }

  .me-lg-72 {
    margin-right: 35.5rem !important;
  }

  .me-lg-73 {
    margin-right: 36rem !important;
  }

  .me-lg-74 {
    margin-right: 36.5rem !important;
  }

  .me-lg-75 {
    margin-right: 37rem !important;
  }

  .me-lg-76 {
    margin-right: 37.5rem !important;
  }

  .me-lg-77 {
    margin-right: 38rem !important;
  }

  .me-lg-78 {
    margin-right: 38.5rem !important;
  }

  .me-lg-79 {
    margin-right: 39rem !important;
  }

  .me-lg-80 {
    margin-right: 39.5rem !important;
  }

  .me-lg-81 {
    margin-right: 40rem !important;
  }

  .me-lg-82 {
    margin-right: 40.5rem !important;
  }

  .me-lg-83 {
    margin-right: 41rem !important;
  }

  .me-lg-84 {
    margin-right: 41.5rem !important;
  }

  .me-lg-85 {
    margin-right: 42rem !important;
  }

  .me-lg-86 {
    margin-right: 42.5rem !important;
  }

  .me-lg-87 {
    margin-right: 43rem !important;
  }

  .me-lg-88 {
    margin-right: 43.5rem !important;
  }

  .me-lg-89 {
    margin-right: 44rem !important;
  }

  .me-lg-90 {
    margin-right: 44.5rem !important;
  }

  .me-lg-91 {
    margin-right: 45rem !important;
  }

  .me-lg-92 {
    margin-right: 45.5rem !important;
  }

  .me-lg-93 {
    margin-right: 46rem !important;
  }

  .me-lg-94 {
    margin-right: 46.5rem !important;
  }

  .me-lg-95 {
    margin-right: 47rem !important;
  }

  .me-lg-96 {
    margin-right: 47.5rem !important;
  }

  .me-lg-97 {
    margin-right: 48rem !important;
  }

  .me-lg-98 {
    margin-right: 48.5rem !important;
  }

  .me-lg-99 {
    margin-right: 49rem !important;
  }

  .me-lg-100 {
    margin-right: 49.5rem !important;
  }

  .me-lg-101 {
    margin-right: 50rem !important;
  }

  .me-lg-102 {
    margin-right: 50.5rem !important;
  }

  .me-lg-103 {
    margin-right: 51rem !important;
  }

  .me-lg-104 {
    margin-right: 51.5rem !important;
  }

  .me-lg-105 {
    margin-right: 52rem !important;
  }

  .me-lg-106 {
    margin-right: 52.5rem !important;
  }

  .me-lg-107 {
    margin-right: 53rem !important;
  }

  .me-lg-108 {
    margin-right: 53.5rem !important;
  }

  .me-lg-109 {
    margin-right: 54rem !important;
  }

  .me-lg-110 {
    margin-right: 54.5rem !important;
  }

  .me-lg-111 {
    margin-right: 55rem !important;
  }

  .me-lg-112 {
    margin-right: 55.5rem !important;
  }

  .me-lg-113 {
    margin-right: 56rem !important;
  }

  .me-lg-114 {
    margin-right: 56.5rem !important;
  }

  .me-lg-115 {
    margin-right: 57rem !important;
  }

  .me-lg-116 {
    margin-right: 57.5rem !important;
  }

  .me-lg-117 {
    margin-right: 58rem !important;
  }

  .me-lg-118 {
    margin-right: 58.5rem !important;
  }

  .me-lg-119 {
    margin-right: 59rem !important;
  }

  .me-lg-120 {
    margin-right: 59.5rem !important;
  }

  .me-lg-121 {
    margin-right: 60rem !important;
  }

  .me-lg-122 {
    margin-right: 60.5rem !important;
  }

  .me-lg-123 {
    margin-right: 61rem !important;
  }

  .me-lg-124 {
    margin-right: 61.5rem !important;
  }

  .me-lg-125 {
    margin-right: 62rem !important;
  }

  .me-lg-126 {
    margin-right: 62.5rem !important;
  }

  .me-lg-127 {
    margin-right: 63rem !important;
  }

  .me-lg-128 {
    margin-right: 63.5rem !important;
  }

  .me-lg-129 {
    margin-right: 64rem !important;
  }

  .me-lg-130 {
    margin-right: 64.5rem !important;
  }

  .me-lg-131 {
    margin-right: 65rem !important;
  }

  .me-lg-132 {
    margin-right: 65.5rem !important;
  }

  .me-lg-133 {
    margin-right: 66rem !important;
  }

  .me-lg-134 {
    margin-right: 66.5rem !important;
  }

  .me-lg-135 {
    margin-right: 67rem !important;
  }

  .me-lg-136 {
    margin-right: 67.5rem !important;
  }

  .me-lg-137 {
    margin-right: 68rem !important;
  }

  .me-lg-138 {
    margin-right: 68.5rem !important;
  }

  .me-lg-139 {
    margin-right: 69rem !important;
  }

  .me-lg-140 {
    margin-right: 69.5rem !important;
  }

  .me-lg-141 {
    margin-right: 70rem !important;
  }

  .me-lg-142 {
    margin-right: 70.5rem !important;
  }

  .me-lg-143 {
    margin-right: 71rem !important;
  }

  .me-lg-144 {
    margin-right: 71.5rem !important;
  }

  .me-lg-145 {
    margin-right: 72rem !important;
  }

  .me-lg-146 {
    margin-right: 72.5rem !important;
  }

  .me-lg-147 {
    margin-right: 73rem !important;
  }

  .me-lg-148 {
    margin-right: 73.5rem !important;
  }

  .me-lg-149 {
    margin-right: 74rem !important;
  }

  .me-lg-150 {
    margin-right: 74.5rem !important;
  }

  .me-lg-151 {
    margin-right: 75rem !important;
  }

  .me-lg-152 {
    margin-right: 75.5rem !important;
  }

  .me-lg-153 {
    margin-right: 76rem !important;
  }

  .me-lg-154 {
    margin-right: 76.5rem !important;
  }

  .me-lg-155 {
    margin-right: 77rem !important;
  }

  .me-lg-156 {
    margin-right: 77.5rem !important;
  }

  .me-lg-157 {
    margin-right: 78rem !important;
  }

  .me-lg-158 {
    margin-right: 78.5rem !important;
  }

  .me-lg-159 {
    margin-right: 79rem !important;
  }

  .me-lg-160 {
    margin-right: 79.5rem !important;
  }

  .mx-lg-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }

  .mx-lg-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .mx-lg-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  .mx-lg-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  .mx-lg-6 {
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  .mx-lg-7 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  .mx-lg-8 {
    margin-left: 3.5rem !important;
    margin-right: 3.5rem !important;
  }

  .mx-lg-9 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  .mx-lg-10 {
    margin-left: 4.5rem !important;
    margin-right: 4.5rem !important;
  }

  .mx-lg-11 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  .mx-lg-12 {
    margin-left: 5.5rem !important;
    margin-right: 5.5rem !important;
  }

  .mx-lg-13 {
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  .mx-lg-14 {
    margin-left: 6.5rem !important;
    margin-right: 6.5rem !important;
  }

  .mx-lg-15 {
    margin-left: 7rem !important;
    margin-right: 7rem !important;
  }

  .mx-lg-16 {
    margin-left: 7.5rem !important;
    margin-right: 7.5rem !important;
  }

  .mx-lg-17 {
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  .mx-lg-18 {
    margin-left: 8.5rem !important;
    margin-right: 8.5rem !important;
  }

  .mx-lg-19 {
    margin-left: 9rem !important;
    margin-right: 9rem !important;
  }

  .mx-lg-20 {
    margin-left: 9.5rem !important;
    margin-right: 9.5rem !important;
  }

  .mx-lg-21 {
    margin-left: 10rem !important;
    margin-right: 10rem !important;
  }

  .mx-lg-22 {
    margin-left: 10.5rem !important;
    margin-right: 10.5rem !important;
  }

  .mx-lg-23 {
    margin-left: 11rem !important;
    margin-right: 11rem !important;
  }

  .mx-lg-24 {
    margin-left: 11.5rem !important;
    margin-right: 11.5rem !important;
  }

  .mx-lg-25 {
    margin-left: 12rem !important;
    margin-right: 12rem !important;
  }

  .mx-lg-26 {
    margin-left: 12.5rem !important;
    margin-right: 12.5rem !important;
  }

  .mx-lg-27 {
    margin-left: 13rem !important;
    margin-right: 13rem !important;
  }

  .mx-lg-28 {
    margin-left: 13.5rem !important;
    margin-right: 13.5rem !important;
  }

  .mx-lg-29 {
    margin-left: 14rem !important;
    margin-right: 14rem !important;
  }

  .mx-lg-30 {
    margin-left: 14.5rem !important;
    margin-right: 14.5rem !important;
  }

  .mx-lg-31 {
    margin-left: 15rem !important;
    margin-right: 15rem !important;
  }

  .mx-lg-32 {
    margin-left: 15.5rem !important;
    margin-right: 15.5rem !important;
  }

  .mx-lg-33 {
    margin-left: 16rem !important;
    margin-right: 16rem !important;
  }

  .mx-lg-34 {
    margin-left: 16.5rem !important;
    margin-right: 16.5rem !important;
  }

  .mx-lg-35 {
    margin-left: 17rem !important;
    margin-right: 17rem !important;
  }

  .mx-lg-36 {
    margin-left: 17.5rem !important;
    margin-right: 17.5rem !important;
  }

  .mx-lg-37 {
    margin-left: 18rem !important;
    margin-right: 18rem !important;
  }

  .mx-lg-38 {
    margin-left: 18.5rem !important;
    margin-right: 18.5rem !important;
  }

  .mx-lg-39 {
    margin-left: 19rem !important;
    margin-right: 19rem !important;
  }

  .mx-lg-40 {
    margin-left: 19.5rem !important;
    margin-right: 19.5rem !important;
  }

  .mx-lg-41 {
    margin-left: 20rem !important;
    margin-right: 20rem !important;
  }

  .mx-lg-42 {
    margin-left: 20.5rem !important;
    margin-right: 20.5rem !important;
  }

  .mx-lg-43 {
    margin-left: 21rem !important;
    margin-right: 21rem !important;
  }

  .mx-lg-44 {
    margin-left: 21.5rem !important;
    margin-right: 21.5rem !important;
  }

  .mx-lg-45 {
    margin-left: 22rem !important;
    margin-right: 22rem !important;
  }

  .mx-lg-46 {
    margin-left: 22.5rem !important;
    margin-right: 22.5rem !important;
  }

  .mx-lg-47 {
    margin-left: 23rem !important;
    margin-right: 23rem !important;
  }

  .mx-lg-48 {
    margin-left: 23.5rem !important;
    margin-right: 23.5rem !important;
  }

  .mx-lg-49 {
    margin-left: 24rem !important;
    margin-right: 24rem !important;
  }

  .mx-lg-50 {
    margin-left: 24.5rem !important;
    margin-right: 24.5rem !important;
  }

  .mx-lg-51 {
    margin-left: 25rem !important;
    margin-right: 25rem !important;
  }

  .mx-lg-52 {
    margin-left: 25.5rem !important;
    margin-right: 25.5rem !important;
  }

  .mx-lg-53 {
    margin-left: 26rem !important;
    margin-right: 26rem !important;
  }

  .mx-lg-54 {
    margin-left: 26.5rem !important;
    margin-right: 26.5rem !important;
  }

  .mx-lg-55 {
    margin-left: 27rem !important;
    margin-right: 27rem !important;
  }

  .mx-lg-56 {
    margin-left: 27.5rem !important;
    margin-right: 27.5rem !important;
  }

  .mx-lg-57 {
    margin-left: 28rem !important;
    margin-right: 28rem !important;
  }

  .mx-lg-58 {
    margin-left: 28.5rem !important;
    margin-right: 28.5rem !important;
  }

  .mx-lg-59 {
    margin-left: 29rem !important;
    margin-right: 29rem !important;
  }

  .mx-lg-60 {
    margin-left: 29.5rem !important;
    margin-right: 29.5rem !important;
  }

  .mx-lg-61 {
    margin-left: 30rem !important;
    margin-right: 30rem !important;
  }

  .mx-lg-62 {
    margin-left: 30.5rem !important;
    margin-right: 30.5rem !important;
  }

  .mx-lg-63 {
    margin-left: 31rem !important;
    margin-right: 31rem !important;
  }

  .mx-lg-64 {
    margin-left: 31.5rem !important;
    margin-right: 31.5rem !important;
  }

  .mx-lg-65 {
    margin-left: 32rem !important;
    margin-right: 32rem !important;
  }

  .mx-lg-66 {
    margin-left: 32.5rem !important;
    margin-right: 32.5rem !important;
  }

  .mx-lg-67 {
    margin-left: 33rem !important;
    margin-right: 33rem !important;
  }

  .mx-lg-68 {
    margin-left: 33.5rem !important;
    margin-right: 33.5rem !important;
  }

  .mx-lg-69 {
    margin-left: 34rem !important;
    margin-right: 34rem !important;
  }

  .mx-lg-70 {
    margin-left: 34.5rem !important;
    margin-right: 34.5rem !important;
  }

  .mx-lg-71 {
    margin-left: 35rem !important;
    margin-right: 35rem !important;
  }

  .mx-lg-72 {
    margin-left: 35.5rem !important;
    margin-right: 35.5rem !important;
  }

  .mx-lg-73 {
    margin-left: 36rem !important;
    margin-right: 36rem !important;
  }

  .mx-lg-74 {
    margin-left: 36.5rem !important;
    margin-right: 36.5rem !important;
  }

  .mx-lg-75 {
    margin-left: 37rem !important;
    margin-right: 37rem !important;
  }

  .mx-lg-76 {
    margin-left: 37.5rem !important;
    margin-right: 37.5rem !important;
  }

  .mx-lg-77 {
    margin-left: 38rem !important;
    margin-right: 38rem !important;
  }

  .mx-lg-78 {
    margin-left: 38.5rem !important;
    margin-right: 38.5rem !important;
  }

  .mx-lg-79 {
    margin-left: 39rem !important;
    margin-right: 39rem !important;
  }

  .mx-lg-80 {
    margin-left: 39.5rem !important;
    margin-right: 39.5rem !important;
  }

  .mx-lg-81 {
    margin-left: 40rem !important;
    margin-right: 40rem !important;
  }

  .mx-lg-82 {
    margin-left: 40.5rem !important;
    margin-right: 40.5rem !important;
  }

  .mx-lg-83 {
    margin-left: 41rem !important;
    margin-right: 41rem !important;
  }

  .mx-lg-84 {
    margin-left: 41.5rem !important;
    margin-right: 41.5rem !important;
  }

  .mx-lg-85 {
    margin-left: 42rem !important;
    margin-right: 42rem !important;
  }

  .mx-lg-86 {
    margin-left: 42.5rem !important;
    margin-right: 42.5rem !important;
  }

  .mx-lg-87 {
    margin-left: 43rem !important;
    margin-right: 43rem !important;
  }

  .mx-lg-88 {
    margin-left: 43.5rem !important;
    margin-right: 43.5rem !important;
  }

  .mx-lg-89 {
    margin-left: 44rem !important;
    margin-right: 44rem !important;
  }

  .mx-lg-90 {
    margin-left: 44.5rem !important;
    margin-right: 44.5rem !important;
  }

  .mx-lg-91 {
    margin-left: 45rem !important;
    margin-right: 45rem !important;
  }

  .mx-lg-92 {
    margin-left: 45.5rem !important;
    margin-right: 45.5rem !important;
  }

  .mx-lg-93 {
    margin-left: 46rem !important;
    margin-right: 46rem !important;
  }

  .mx-lg-94 {
    margin-left: 46.5rem !important;
    margin-right: 46.5rem !important;
  }

  .mx-lg-95 {
    margin-left: 47rem !important;
    margin-right: 47rem !important;
  }

  .mx-lg-96 {
    margin-left: 47.5rem !important;
    margin-right: 47.5rem !important;
  }

  .mx-lg-97 {
    margin-left: 48rem !important;
    margin-right: 48rem !important;
  }

  .mx-lg-98 {
    margin-left: 48.5rem !important;
    margin-right: 48.5rem !important;
  }

  .mx-lg-99 {
    margin-left: 49rem !important;
    margin-right: 49rem !important;
  }

  .mx-lg-100 {
    margin-left: 49.5rem !important;
    margin-right: 49.5rem !important;
  }

  .mx-lg-101 {
    margin-left: 50rem !important;
    margin-right: 50rem !important;
  }

  .mx-lg-102 {
    margin-left: 50.5rem !important;
    margin-right: 50.5rem !important;
  }

  .mx-lg-103 {
    margin-left: 51rem !important;
    margin-right: 51rem !important;
  }

  .mx-lg-104 {
    margin-left: 51.5rem !important;
    margin-right: 51.5rem !important;
  }

  .mx-lg-105 {
    margin-left: 52rem !important;
    margin-right: 52rem !important;
  }

  .mx-lg-106 {
    margin-left: 52.5rem !important;
    margin-right: 52.5rem !important;
  }

  .mx-lg-107 {
    margin-left: 53rem !important;
    margin-right: 53rem !important;
  }

  .mx-lg-108 {
    margin-left: 53.5rem !important;
    margin-right: 53.5rem !important;
  }

  .mx-lg-109 {
    margin-left: 54rem !important;
    margin-right: 54rem !important;
  }

  .mx-lg-110 {
    margin-left: 54.5rem !important;
    margin-right: 54.5rem !important;
  }

  .mx-lg-111 {
    margin-left: 55rem !important;
    margin-right: 55rem !important;
  }

  .mx-lg-112 {
    margin-left: 55.5rem !important;
    margin-right: 55.5rem !important;
  }

  .mx-lg-113 {
    margin-left: 56rem !important;
    margin-right: 56rem !important;
  }

  .mx-lg-114 {
    margin-left: 56.5rem !important;
    margin-right: 56.5rem !important;
  }

  .mx-lg-115 {
    margin-left: 57rem !important;
    margin-right: 57rem !important;
  }

  .mx-lg-116 {
    margin-left: 57.5rem !important;
    margin-right: 57.5rem !important;
  }

  .mx-lg-117 {
    margin-left: 58rem !important;
    margin-right: 58rem !important;
  }

  .mx-lg-118 {
    margin-left: 58.5rem !important;
    margin-right: 58.5rem !important;
  }

  .mx-lg-119 {
    margin-left: 59rem !important;
    margin-right: 59rem !important;
  }

  .mx-lg-120 {
    margin-left: 59.5rem !important;
    margin-right: 59.5rem !important;
  }

  .mx-lg-121 {
    margin-left: 60rem !important;
    margin-right: 60rem !important;
  }

  .mx-lg-122 {
    margin-left: 60.5rem !important;
    margin-right: 60.5rem !important;
  }

  .mx-lg-123 {
    margin-left: 61rem !important;
    margin-right: 61rem !important;
  }

  .mx-lg-124 {
    margin-left: 61.5rem !important;
    margin-right: 61.5rem !important;
  }

  .mx-lg-125 {
    margin-left: 62rem !important;
    margin-right: 62rem !important;
  }

  .mx-lg-126 {
    margin-left: 62.5rem !important;
    margin-right: 62.5rem !important;
  }

  .mx-lg-127 {
    margin-left: 63rem !important;
    margin-right: 63rem !important;
  }

  .mx-lg-128 {
    margin-left: 63.5rem !important;
    margin-right: 63.5rem !important;
  }

  .mx-lg-129 {
    margin-left: 64rem !important;
    margin-right: 64rem !important;
  }

  .mx-lg-130 {
    margin-left: 64.5rem !important;
    margin-right: 64.5rem !important;
  }

  .mx-lg-131 {
    margin-left: 65rem !important;
    margin-right: 65rem !important;
  }

  .mx-lg-132 {
    margin-left: 65.5rem !important;
    margin-right: 65.5rem !important;
  }

  .mx-lg-133 {
    margin-left: 66rem !important;
    margin-right: 66rem !important;
  }

  .mx-lg-134 {
    margin-left: 66.5rem !important;
    margin-right: 66.5rem !important;
  }

  .mx-lg-135 {
    margin-left: 67rem !important;
    margin-right: 67rem !important;
  }

  .mx-lg-136 {
    margin-left: 67.5rem !important;
    margin-right: 67.5rem !important;
  }

  .mx-lg-137 {
    margin-left: 68rem !important;
    margin-right: 68rem !important;
  }

  .mx-lg-138 {
    margin-left: 68.5rem !important;
    margin-right: 68.5rem !important;
  }

  .mx-lg-139 {
    margin-left: 69rem !important;
    margin-right: 69rem !important;
  }

  .mx-lg-140 {
    margin-left: 69.5rem !important;
    margin-right: 69.5rem !important;
  }

  .mx-lg-141 {
    margin-left: 70rem !important;
    margin-right: 70rem !important;
  }

  .mx-lg-142 {
    margin-left: 70.5rem !important;
    margin-right: 70.5rem !important;
  }

  .mx-lg-143 {
    margin-left: 71rem !important;
    margin-right: 71rem !important;
  }

  .mx-lg-144 {
    margin-left: 71.5rem !important;
    margin-right: 71.5rem !important;
  }

  .mx-lg-145 {
    margin-left: 72rem !important;
    margin-right: 72rem !important;
  }

  .mx-lg-146 {
    margin-left: 72.5rem !important;
    margin-right: 72.5rem !important;
  }

  .mx-lg-147 {
    margin-left: 73rem !important;
    margin-right: 73rem !important;
  }

  .mx-lg-148 {
    margin-left: 73.5rem !important;
    margin-right: 73.5rem !important;
  }

  .mx-lg-149 {
    margin-left: 74rem !important;
    margin-right: 74rem !important;
  }

  .mx-lg-150 {
    margin-left: 74.5rem !important;
    margin-right: 74.5rem !important;
  }

  .mx-lg-151 {
    margin-left: 75rem !important;
    margin-right: 75rem !important;
  }

  .mx-lg-152 {
    margin-left: 75.5rem !important;
    margin-right: 75.5rem !important;
  }

  .mx-lg-153 {
    margin-left: 76rem !important;
    margin-right: 76rem !important;
  }

  .mx-lg-154 {
    margin-left: 76.5rem !important;
    margin-right: 76.5rem !important;
  }

  .mx-lg-155 {
    margin-left: 77rem !important;
    margin-right: 77rem !important;
  }

  .mx-lg-156 {
    margin-left: 77.5rem !important;
    margin-right: 77.5rem !important;
  }

  .mx-lg-157 {
    margin-left: 78rem !important;
    margin-right: 78rem !important;
  }

  .mx-lg-158 {
    margin-left: 78.5rem !important;
    margin-right: 78.5rem !important;
  }

  .mx-lg-159 {
    margin-left: 79rem !important;
    margin-right: 79rem !important;
  }

  .mx-lg-160 {
    margin-left: 79.5rem !important;
    margin-right: 79.5rem !important;
  }

  .my-lg-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-lg-6 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-lg-7 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-8 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-lg-9 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-lg-10 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-lg-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-lg-12 {
    margin-top: 5.5rem !important;
    margin-bottom: 5.5rem !important;
  }

  .my-lg-13 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  .my-lg-14 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }

  .my-lg-15 {
    margin-top: 7rem !important;
    margin-bottom: 7rem !important;
  }

  .my-lg-16 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }

  .my-lg-17 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  .my-lg-18 {
    margin-top: 8.5rem !important;
    margin-bottom: 8.5rem !important;
  }

  .my-lg-19 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }

  .my-lg-20 {
    margin-top: 9.5rem !important;
    margin-bottom: 9.5rem !important;
  }

  .my-lg-21 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }

  .my-lg-22 {
    margin-top: 10.5rem !important;
    margin-bottom: 10.5rem !important;
  }

  .my-lg-23 {
    margin-top: 11rem !important;
    margin-bottom: 11rem !important;
  }

  .my-lg-24 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }

  .my-lg-25 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }

  .my-lg-26 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }

  .my-lg-27 {
    margin-top: 13rem !important;
    margin-bottom: 13rem !important;
  }

  .my-lg-28 {
    margin-top: 13.5rem !important;
    margin-bottom: 13.5rem !important;
  }

  .my-lg-29 {
    margin-top: 14rem !important;
    margin-bottom: 14rem !important;
  }

  .my-lg-30 {
    margin-top: 14.5rem !important;
    margin-bottom: 14.5rem !important;
  }

  .my-lg-31 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }

  .my-lg-32 {
    margin-top: 15.5rem !important;
    margin-bottom: 15.5rem !important;
  }

  .my-lg-33 {
    margin-top: 16rem !important;
    margin-bottom: 16rem !important;
  }

  .my-lg-34 {
    margin-top: 16.5rem !important;
    margin-bottom: 16.5rem !important;
  }

  .my-lg-35 {
    margin-top: 17rem !important;
    margin-bottom: 17rem !important;
  }

  .my-lg-36 {
    margin-top: 17.5rem !important;
    margin-bottom: 17.5rem !important;
  }

  .my-lg-37 {
    margin-top: 18rem !important;
    margin-bottom: 18rem !important;
  }

  .my-lg-38 {
    margin-top: 18.5rem !important;
    margin-bottom: 18.5rem !important;
  }

  .my-lg-39 {
    margin-top: 19rem !important;
    margin-bottom: 19rem !important;
  }

  .my-lg-40 {
    margin-top: 19.5rem !important;
    margin-bottom: 19.5rem !important;
  }

  .my-lg-41 {
    margin-top: 20rem !important;
    margin-bottom: 20rem !important;
  }

  .my-lg-42 {
    margin-top: 20.5rem !important;
    margin-bottom: 20.5rem !important;
  }

  .my-lg-43 {
    margin-top: 21rem !important;
    margin-bottom: 21rem !important;
  }

  .my-lg-44 {
    margin-top: 21.5rem !important;
    margin-bottom: 21.5rem !important;
  }

  .my-lg-45 {
    margin-top: 22rem !important;
    margin-bottom: 22rem !important;
  }

  .my-lg-46 {
    margin-top: 22.5rem !important;
    margin-bottom: 22.5rem !important;
  }

  .my-lg-47 {
    margin-top: 23rem !important;
    margin-bottom: 23rem !important;
  }

  .my-lg-48 {
    margin-top: 23.5rem !important;
    margin-bottom: 23.5rem !important;
  }

  .my-lg-49 {
    margin-top: 24rem !important;
    margin-bottom: 24rem !important;
  }

  .my-lg-50 {
    margin-top: 24.5rem !important;
    margin-bottom: 24.5rem !important;
  }

  .my-lg-51 {
    margin-top: 25rem !important;
    margin-bottom: 25rem !important;
  }

  .my-lg-52 {
    margin-top: 25.5rem !important;
    margin-bottom: 25.5rem !important;
  }

  .my-lg-53 {
    margin-top: 26rem !important;
    margin-bottom: 26rem !important;
  }

  .my-lg-54 {
    margin-top: 26.5rem !important;
    margin-bottom: 26.5rem !important;
  }

  .my-lg-55 {
    margin-top: 27rem !important;
    margin-bottom: 27rem !important;
  }

  .my-lg-56 {
    margin-top: 27.5rem !important;
    margin-bottom: 27.5rem !important;
  }

  .my-lg-57 {
    margin-top: 28rem !important;
    margin-bottom: 28rem !important;
  }

  .my-lg-58 {
    margin-top: 28.5rem !important;
    margin-bottom: 28.5rem !important;
  }

  .my-lg-59 {
    margin-top: 29rem !important;
    margin-bottom: 29rem !important;
  }

  .my-lg-60 {
    margin-top: 29.5rem !important;
    margin-bottom: 29.5rem !important;
  }

  .my-lg-61 {
    margin-top: 30rem !important;
    margin-bottom: 30rem !important;
  }

  .my-lg-62 {
    margin-top: 30.5rem !important;
    margin-bottom: 30.5rem !important;
  }

  .my-lg-63 {
    margin-top: 31rem !important;
    margin-bottom: 31rem !important;
  }

  .my-lg-64 {
    margin-top: 31.5rem !important;
    margin-bottom: 31.5rem !important;
  }

  .my-lg-65 {
    margin-top: 32rem !important;
    margin-bottom: 32rem !important;
  }

  .my-lg-66 {
    margin-top: 32.5rem !important;
    margin-bottom: 32.5rem !important;
  }

  .my-lg-67 {
    margin-top: 33rem !important;
    margin-bottom: 33rem !important;
  }

  .my-lg-68 {
    margin-top: 33.5rem !important;
    margin-bottom: 33.5rem !important;
  }

  .my-lg-69 {
    margin-top: 34rem !important;
    margin-bottom: 34rem !important;
  }

  .my-lg-70 {
    margin-top: 34.5rem !important;
    margin-bottom: 34.5rem !important;
  }

  .my-lg-71 {
    margin-top: 35rem !important;
    margin-bottom: 35rem !important;
  }

  .my-lg-72 {
    margin-top: 35.5rem !important;
    margin-bottom: 35.5rem !important;
  }

  .my-lg-73 {
    margin-top: 36rem !important;
    margin-bottom: 36rem !important;
  }

  .my-lg-74 {
    margin-top: 36.5rem !important;
    margin-bottom: 36.5rem !important;
  }

  .my-lg-75 {
    margin-top: 37rem !important;
    margin-bottom: 37rem !important;
  }

  .my-lg-76 {
    margin-top: 37.5rem !important;
    margin-bottom: 37.5rem !important;
  }

  .my-lg-77 {
    margin-top: 38rem !important;
    margin-bottom: 38rem !important;
  }

  .my-lg-78 {
    margin-top: 38.5rem !important;
    margin-bottom: 38.5rem !important;
  }

  .my-lg-79 {
    margin-top: 39rem !important;
    margin-bottom: 39rem !important;
  }

  .my-lg-80 {
    margin-top: 39.5rem !important;
    margin-bottom: 39.5rem !important;
  }

  .my-lg-81 {
    margin-top: 40rem !important;
    margin-bottom: 40rem !important;
  }

  .my-lg-82 {
    margin-top: 40.5rem !important;
    margin-bottom: 40.5rem !important;
  }

  .my-lg-83 {
    margin-top: 41rem !important;
    margin-bottom: 41rem !important;
  }

  .my-lg-84 {
    margin-top: 41.5rem !important;
    margin-bottom: 41.5rem !important;
  }

  .my-lg-85 {
    margin-top: 42rem !important;
    margin-bottom: 42rem !important;
  }

  .my-lg-86 {
    margin-top: 42.5rem !important;
    margin-bottom: 42.5rem !important;
  }

  .my-lg-87 {
    margin-top: 43rem !important;
    margin-bottom: 43rem !important;
  }

  .my-lg-88 {
    margin-top: 43.5rem !important;
    margin-bottom: 43.5rem !important;
  }

  .my-lg-89 {
    margin-top: 44rem !important;
    margin-bottom: 44rem !important;
  }

  .my-lg-90 {
    margin-top: 44.5rem !important;
    margin-bottom: 44.5rem !important;
  }

  .my-lg-91 {
    margin-top: 45rem !important;
    margin-bottom: 45rem !important;
  }

  .my-lg-92 {
    margin-top: 45.5rem !important;
    margin-bottom: 45.5rem !important;
  }

  .my-lg-93 {
    margin-top: 46rem !important;
    margin-bottom: 46rem !important;
  }

  .my-lg-94 {
    margin-top: 46.5rem !important;
    margin-bottom: 46.5rem !important;
  }

  .my-lg-95 {
    margin-top: 47rem !important;
    margin-bottom: 47rem !important;
  }

  .my-lg-96 {
    margin-top: 47.5rem !important;
    margin-bottom: 47.5rem !important;
  }

  .my-lg-97 {
    margin-top: 48rem !important;
    margin-bottom: 48rem !important;
  }

  .my-lg-98 {
    margin-top: 48.5rem !important;
    margin-bottom: 48.5rem !important;
  }

  .my-lg-99 {
    margin-top: 49rem !important;
    margin-bottom: 49rem !important;
  }

  .my-lg-100 {
    margin-top: 49.5rem !important;
    margin-bottom: 49.5rem !important;
  }

  .my-lg-101 {
    margin-top: 50rem !important;
    margin-bottom: 50rem !important;
  }

  .my-lg-102 {
    margin-top: 50.5rem !important;
    margin-bottom: 50.5rem !important;
  }

  .my-lg-103 {
    margin-top: 51rem !important;
    margin-bottom: 51rem !important;
  }

  .my-lg-104 {
    margin-top: 51.5rem !important;
    margin-bottom: 51.5rem !important;
  }

  .my-lg-105 {
    margin-top: 52rem !important;
    margin-bottom: 52rem !important;
  }

  .my-lg-106 {
    margin-top: 52.5rem !important;
    margin-bottom: 52.5rem !important;
  }

  .my-lg-107 {
    margin-top: 53rem !important;
    margin-bottom: 53rem !important;
  }

  .my-lg-108 {
    margin-top: 53.5rem !important;
    margin-bottom: 53.5rem !important;
  }

  .my-lg-109 {
    margin-top: 54rem !important;
    margin-bottom: 54rem !important;
  }

  .my-lg-110 {
    margin-top: 54.5rem !important;
    margin-bottom: 54.5rem !important;
  }

  .my-lg-111 {
    margin-top: 55rem !important;
    margin-bottom: 55rem !important;
  }

  .my-lg-112 {
    margin-top: 55.5rem !important;
    margin-bottom: 55.5rem !important;
  }

  .my-lg-113 {
    margin-top: 56rem !important;
    margin-bottom: 56rem !important;
  }

  .my-lg-114 {
    margin-top: 56.5rem !important;
    margin-bottom: 56.5rem !important;
  }

  .my-lg-115 {
    margin-top: 57rem !important;
    margin-bottom: 57rem !important;
  }

  .my-lg-116 {
    margin-top: 57.5rem !important;
    margin-bottom: 57.5rem !important;
  }

  .my-lg-117 {
    margin-top: 58rem !important;
    margin-bottom: 58rem !important;
  }

  .my-lg-118 {
    margin-top: 58.5rem !important;
    margin-bottom: 58.5rem !important;
  }

  .my-lg-119 {
    margin-top: 59rem !important;
    margin-bottom: 59rem !important;
  }

  .my-lg-120 {
    margin-top: 59.5rem !important;
    margin-bottom: 59.5rem !important;
  }

  .my-lg-121 {
    margin-top: 60rem !important;
    margin-bottom: 60rem !important;
  }

  .my-lg-122 {
    margin-top: 60.5rem !important;
    margin-bottom: 60.5rem !important;
  }

  .my-lg-123 {
    margin-top: 61rem !important;
    margin-bottom: 61rem !important;
  }

  .my-lg-124 {
    margin-top: 61.5rem !important;
    margin-bottom: 61.5rem !important;
  }

  .my-lg-125 {
    margin-top: 62rem !important;
    margin-bottom: 62rem !important;
  }

  .my-lg-126 {
    margin-top: 62.5rem !important;
    margin-bottom: 62.5rem !important;
  }

  .my-lg-127 {
    margin-top: 63rem !important;
    margin-bottom: 63rem !important;
  }

  .my-lg-128 {
    margin-top: 63.5rem !important;
    margin-bottom: 63.5rem !important;
  }

  .my-lg-129 {
    margin-top: 64rem !important;
    margin-bottom: 64rem !important;
  }

  .my-lg-130 {
    margin-top: 64.5rem !important;
    margin-bottom: 64.5rem !important;
  }

  .my-lg-131 {
    margin-top: 65rem !important;
    margin-bottom: 65rem !important;
  }

  .my-lg-132 {
    margin-top: 65.5rem !important;
    margin-bottom: 65.5rem !important;
  }

  .my-lg-133 {
    margin-top: 66rem !important;
    margin-bottom: 66rem !important;
  }

  .my-lg-134 {
    margin-top: 66.5rem !important;
    margin-bottom: 66.5rem !important;
  }

  .my-lg-135 {
    margin-top: 67rem !important;
    margin-bottom: 67rem !important;
  }

  .my-lg-136 {
    margin-top: 67.5rem !important;
    margin-bottom: 67.5rem !important;
  }

  .my-lg-137 {
    margin-top: 68rem !important;
    margin-bottom: 68rem !important;
  }

  .my-lg-138 {
    margin-top: 68.5rem !important;
    margin-bottom: 68.5rem !important;
  }

  .my-lg-139 {
    margin-top: 69rem !important;
    margin-bottom: 69rem !important;
  }

  .my-lg-140 {
    margin-top: 69.5rem !important;
    margin-bottom: 69.5rem !important;
  }

  .my-lg-141 {
    margin-top: 70rem !important;
    margin-bottom: 70rem !important;
  }

  .my-lg-142 {
    margin-top: 70.5rem !important;
    margin-bottom: 70.5rem !important;
  }

  .my-lg-143 {
    margin-top: 71rem !important;
    margin-bottom: 71rem !important;
  }

  .my-lg-144 {
    margin-top: 71.5rem !important;
    margin-bottom: 71.5rem !important;
  }

  .my-lg-145 {
    margin-top: 72rem !important;
    margin-bottom: 72rem !important;
  }

  .my-lg-146 {
    margin-top: 72.5rem !important;
    margin-bottom: 72.5rem !important;
  }

  .my-lg-147 {
    margin-top: 73rem !important;
    margin-bottom: 73rem !important;
  }

  .my-lg-148 {
    margin-top: 73.5rem !important;
    margin-bottom: 73.5rem !important;
  }

  .my-lg-149 {
    margin-top: 74rem !important;
    margin-bottom: 74rem !important;
  }

  .my-lg-150 {
    margin-top: 74.5rem !important;
    margin-bottom: 74.5rem !important;
  }

  .my-lg-151 {
    margin-top: 75rem !important;
    margin-bottom: 75rem !important;
  }

  .my-lg-152 {
    margin-top: 75.5rem !important;
    margin-bottom: 75.5rem !important;
  }

  .my-lg-153 {
    margin-top: 76rem !important;
    margin-bottom: 76rem !important;
  }

  .my-lg-154 {
    margin-top: 76.5rem !important;
    margin-bottom: 76.5rem !important;
  }

  .my-lg-155 {
    margin-top: 77rem !important;
    margin-bottom: 77rem !important;
  }

  .my-lg-156 {
    margin-top: 77.5rem !important;
    margin-bottom: 77.5rem !important;
  }

  .my-lg-157 {
    margin-top: 78rem !important;
    margin-bottom: 78rem !important;
  }

  .my-lg-158 {
    margin-top: 78.5rem !important;
    margin-bottom: 78.5rem !important;
  }

  .my-lg-159 {
    margin-top: 79rem !important;
    margin-bottom: 79rem !important;
  }

  .my-lg-160 {
    margin-top: 79.5rem !important;
    margin-bottom: 79.5rem !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0rem !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 2rem !important;
  }

  .m-xl-6 {
    margin: 2.5rem !important;
  }

  .m-xl-7 {
    margin: 3rem !important;
  }

  .m-xl-8 {
    margin: 3.5rem !important;
  }

  .m-xl-9 {
    margin: 4rem !important;
  }

  .m-xl-10 {
    margin: 4.5rem !important;
  }

  .m-xl-11 {
    margin: 5rem !important;
  }

  .m-xl-12 {
    margin: 5.5rem !important;
  }

  .m-xl-13 {
    margin: 6rem !important;
  }

  .m-xl-14 {
    margin: 6.5rem !important;
  }

  .m-xl-15 {
    margin: 7rem !important;
  }

  .m-xl-16 {
    margin: 7.5rem !important;
  }

  .m-xl-17 {
    margin: 8rem !important;
  }

  .m-xl-18 {
    margin: 8.5rem !important;
  }

  .m-xl-19 {
    margin: 9rem !important;
  }

  .m-xl-20 {
    margin: 9.5rem !important;
  }

  .m-xl-21 {
    margin: 10rem !important;
  }

  .m-xl-22 {
    margin: 10.5rem !important;
  }

  .m-xl-23 {
    margin: 11rem !important;
  }

  .m-xl-24 {
    margin: 11.5rem !important;
  }

  .m-xl-25 {
    margin: 12rem !important;
  }

  .m-xl-26 {
    margin: 12.5rem !important;
  }

  .m-xl-27 {
    margin: 13rem !important;
  }

  .m-xl-28 {
    margin: 13.5rem !important;
  }

  .m-xl-29 {
    margin: 14rem !important;
  }

  .m-xl-30 {
    margin: 14.5rem !important;
  }

  .m-xl-31 {
    margin: 15rem !important;
  }

  .m-xl-32 {
    margin: 15.5rem !important;
  }

  .m-xl-33 {
    margin: 16rem !important;
  }

  .m-xl-34 {
    margin: 16.5rem !important;
  }

  .m-xl-35 {
    margin: 17rem !important;
  }

  .m-xl-36 {
    margin: 17.5rem !important;
  }

  .m-xl-37 {
    margin: 18rem !important;
  }

  .m-xl-38 {
    margin: 18.5rem !important;
  }

  .m-xl-39 {
    margin: 19rem !important;
  }

  .m-xl-40 {
    margin: 19.5rem !important;
  }

  .m-xl-41 {
    margin: 20rem !important;
  }

  .m-xl-42 {
    margin: 20.5rem !important;
  }

  .m-xl-43 {
    margin: 21rem !important;
  }

  .m-xl-44 {
    margin: 21.5rem !important;
  }

  .m-xl-45 {
    margin: 22rem !important;
  }

  .m-xl-46 {
    margin: 22.5rem !important;
  }

  .m-xl-47 {
    margin: 23rem !important;
  }

  .m-xl-48 {
    margin: 23.5rem !important;
  }

  .m-xl-49 {
    margin: 24rem !important;
  }

  .m-xl-50 {
    margin: 24.5rem !important;
  }

  .m-xl-51 {
    margin: 25rem !important;
  }

  .m-xl-52 {
    margin: 25.5rem !important;
  }

  .m-xl-53 {
    margin: 26rem !important;
  }

  .m-xl-54 {
    margin: 26.5rem !important;
  }

  .m-xl-55 {
    margin: 27rem !important;
  }

  .m-xl-56 {
    margin: 27.5rem !important;
  }

  .m-xl-57 {
    margin: 28rem !important;
  }

  .m-xl-58 {
    margin: 28.5rem !important;
  }

  .m-xl-59 {
    margin: 29rem !important;
  }

  .m-xl-60 {
    margin: 29.5rem !important;
  }

  .m-xl-61 {
    margin: 30rem !important;
  }

  .m-xl-62 {
    margin: 30.5rem !important;
  }

  .m-xl-63 {
    margin: 31rem !important;
  }

  .m-xl-64 {
    margin: 31.5rem !important;
  }

  .m-xl-65 {
    margin: 32rem !important;
  }

  .m-xl-66 {
    margin: 32.5rem !important;
  }

  .m-xl-67 {
    margin: 33rem !important;
  }

  .m-xl-68 {
    margin: 33.5rem !important;
  }

  .m-xl-69 {
    margin: 34rem !important;
  }

  .m-xl-70 {
    margin: 34.5rem !important;
  }

  .m-xl-71 {
    margin: 35rem !important;
  }

  .m-xl-72 {
    margin: 35.5rem !important;
  }

  .m-xl-73 {
    margin: 36rem !important;
  }

  .m-xl-74 {
    margin: 36.5rem !important;
  }

  .m-xl-75 {
    margin: 37rem !important;
  }

  .m-xl-76 {
    margin: 37.5rem !important;
  }

  .m-xl-77 {
    margin: 38rem !important;
  }

  .m-xl-78 {
    margin: 38.5rem !important;
  }

  .m-xl-79 {
    margin: 39rem !important;
  }

  .m-xl-80 {
    margin: 39.5rem !important;
  }

  .m-xl-81 {
    margin: 40rem !important;
  }

  .m-xl-82 {
    margin: 40.5rem !important;
  }

  .m-xl-83 {
    margin: 41rem !important;
  }

  .m-xl-84 {
    margin: 41.5rem !important;
  }

  .m-xl-85 {
    margin: 42rem !important;
  }

  .m-xl-86 {
    margin: 42.5rem !important;
  }

  .m-xl-87 {
    margin: 43rem !important;
  }

  .m-xl-88 {
    margin: 43.5rem !important;
  }

  .m-xl-89 {
    margin: 44rem !important;
  }

  .m-xl-90 {
    margin: 44.5rem !important;
  }

  .m-xl-91 {
    margin: 45rem !important;
  }

  .m-xl-92 {
    margin: 45.5rem !important;
  }

  .m-xl-93 {
    margin: 46rem !important;
  }

  .m-xl-94 {
    margin: 46.5rem !important;
  }

  .m-xl-95 {
    margin: 47rem !important;
  }

  .m-xl-96 {
    margin: 47.5rem !important;
  }

  .m-xl-97 {
    margin: 48rem !important;
  }

  .m-xl-98 {
    margin: 48.5rem !important;
  }

  .m-xl-99 {
    margin: 49rem !important;
  }

  .m-xl-100 {
    margin: 49.5rem !important;
  }

  .m-xl-101 {
    margin: 50rem !important;
  }

  .m-xl-102 {
    margin: 50.5rem !important;
  }

  .m-xl-103 {
    margin: 51rem !important;
  }

  .m-xl-104 {
    margin: 51.5rem !important;
  }

  .m-xl-105 {
    margin: 52rem !important;
  }

  .m-xl-106 {
    margin: 52.5rem !important;
  }

  .m-xl-107 {
    margin: 53rem !important;
  }

  .m-xl-108 {
    margin: 53.5rem !important;
  }

  .m-xl-109 {
    margin: 54rem !important;
  }

  .m-xl-110 {
    margin: 54.5rem !important;
  }

  .m-xl-111 {
    margin: 55rem !important;
  }

  .m-xl-112 {
    margin: 55.5rem !important;
  }

  .m-xl-113 {
    margin: 56rem !important;
  }

  .m-xl-114 {
    margin: 56.5rem !important;
  }

  .m-xl-115 {
    margin: 57rem !important;
  }

  .m-xl-116 {
    margin: 57.5rem !important;
  }

  .m-xl-117 {
    margin: 58rem !important;
  }

  .m-xl-118 {
    margin: 58.5rem !important;
  }

  .m-xl-119 {
    margin: 59rem !important;
  }

  .m-xl-120 {
    margin: 59.5rem !important;
  }

  .m-xl-121 {
    margin: 60rem !important;
  }

  .m-xl-122 {
    margin: 60.5rem !important;
  }

  .m-xl-123 {
    margin: 61rem !important;
  }

  .m-xl-124 {
    margin: 61.5rem !important;
  }

  .m-xl-125 {
    margin: 62rem !important;
  }

  .m-xl-126 {
    margin: 62.5rem !important;
  }

  .m-xl-127 {
    margin: 63rem !important;
  }

  .m-xl-128 {
    margin: 63.5rem !important;
  }

  .m-xl-129 {
    margin: 64rem !important;
  }

  .m-xl-130 {
    margin: 64.5rem !important;
  }

  .m-xl-131 {
    margin: 65rem !important;
  }

  .m-xl-132 {
    margin: 65.5rem !important;
  }

  .m-xl-133 {
    margin: 66rem !important;
  }

  .m-xl-134 {
    margin: 66.5rem !important;
  }

  .m-xl-135 {
    margin: 67rem !important;
  }

  .m-xl-136 {
    margin: 67.5rem !important;
  }

  .m-xl-137 {
    margin: 68rem !important;
  }

  .m-xl-138 {
    margin: 68.5rem !important;
  }

  .m-xl-139 {
    margin: 69rem !important;
  }

  .m-xl-140 {
    margin: 69.5rem !important;
  }

  .m-xl-141 {
    margin: 70rem !important;
  }

  .m-xl-142 {
    margin: 70.5rem !important;
  }

  .m-xl-143 {
    margin: 71rem !important;
  }

  .m-xl-144 {
    margin: 71.5rem !important;
  }

  .m-xl-145 {
    margin: 72rem !important;
  }

  .m-xl-146 {
    margin: 72.5rem !important;
  }

  .m-xl-147 {
    margin: 73rem !important;
  }

  .m-xl-148 {
    margin: 73.5rem !important;
  }

  .m-xl-149 {
    margin: 74rem !important;
  }

  .m-xl-150 {
    margin: 74.5rem !important;
  }

  .m-xl-151 {
    margin: 75rem !important;
  }

  .m-xl-152 {
    margin: 75.5rem !important;
  }

  .m-xl-153 {
    margin: 76rem !important;
  }

  .m-xl-154 {
    margin: 76.5rem !important;
  }

  .m-xl-155 {
    margin: 77rem !important;
  }

  .m-xl-156 {
    margin: 77.5rem !important;
  }

  .m-xl-157 {
    margin: 78rem !important;
  }

  .m-xl-158 {
    margin: 78.5rem !important;
  }

  .m-xl-159 {
    margin: 79rem !important;
  }

  .m-xl-160 {
    margin: 79.5rem !important;
  }

  .mt-xl-0 {
    margin-top: 0rem !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 1rem !important;
  }

  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-5 {
    margin-top: 2rem !important;
  }

  .mt-xl-6 {
    margin-top: 2.5rem !important;
  }

  .mt-xl-7 {
    margin-top: 3rem !important;
  }

  .mt-xl-8 {
    margin-top: 3.5rem !important;
  }

  .mt-xl-9 {
    margin-top: 4rem !important;
  }

  .mt-xl-10 {
    margin-top: 4.5rem !important;
  }

  .mt-xl-11 {
    margin-top: 5rem !important;
  }

  .mt-xl-12 {
    margin-top: 5.5rem !important;
  }

  .mt-xl-13 {
    margin-top: 6rem !important;
  }

  .mt-xl-14 {
    margin-top: 6.5rem !important;
  }

  .mt-xl-15 {
    margin-top: 7rem !important;
  }

  .mt-xl-16 {
    margin-top: 7.5rem !important;
  }

  .mt-xl-17 {
    margin-top: 8rem !important;
  }

  .mt-xl-18 {
    margin-top: 8.5rem !important;
  }

  .mt-xl-19 {
    margin-top: 9rem !important;
  }

  .mt-xl-20 {
    margin-top: 9.5rem !important;
  }

  .mt-xl-21 {
    margin-top: 10rem !important;
  }

  .mt-xl-22 {
    margin-top: 10.5rem !important;
  }

  .mt-xl-23 {
    margin-top: 11rem !important;
  }

  .mt-xl-24 {
    margin-top: 11.5rem !important;
  }

  .mt-xl-25 {
    margin-top: 12rem !important;
  }

  .mt-xl-26 {
    margin-top: 12.5rem !important;
  }

  .mt-xl-27 {
    margin-top: 13rem !important;
  }

  .mt-xl-28 {
    margin-top: 13.5rem !important;
  }

  .mt-xl-29 {
    margin-top: 14rem !important;
  }

  .mt-xl-30 {
    margin-top: 14.5rem !important;
  }

  .mt-xl-31 {
    margin-top: 15rem !important;
  }

  .mt-xl-32 {
    margin-top: 15.5rem !important;
  }

  .mt-xl-33 {
    margin-top: 16rem !important;
  }

  .mt-xl-34 {
    margin-top: 16.5rem !important;
  }

  .mt-xl-35 {
    margin-top: 17rem !important;
  }

  .mt-xl-36 {
    margin-top: 17.5rem !important;
  }

  .mt-xl-37 {
    margin-top: 18rem !important;
  }

  .mt-xl-38 {
    margin-top: 18.5rem !important;
  }

  .mt-xl-39 {
    margin-top: 19rem !important;
  }

  .mt-xl-40 {
    margin-top: 19.5rem !important;
  }

  .mt-xl-41 {
    margin-top: 20rem !important;
  }

  .mt-xl-42 {
    margin-top: 20.5rem !important;
  }

  .mt-xl-43 {
    margin-top: 21rem !important;
  }

  .mt-xl-44 {
    margin-top: 21.5rem !important;
  }

  .mt-xl-45 {
    margin-top: 22rem !important;
  }

  .mt-xl-46 {
    margin-top: 22.5rem !important;
  }

  .mt-xl-47 {
    margin-top: 23rem !important;
  }

  .mt-xl-48 {
    margin-top: 23.5rem !important;
  }

  .mt-xl-49 {
    margin-top: 24rem !important;
  }

  .mt-xl-50 {
    margin-top: 24.5rem !important;
  }

  .mt-xl-51 {
    margin-top: 25rem !important;
  }

  .mt-xl-52 {
    margin-top: 25.5rem !important;
  }

  .mt-xl-53 {
    margin-top: 26rem !important;
  }

  .mt-xl-54 {
    margin-top: 26.5rem !important;
  }

  .mt-xl-55 {
    margin-top: 27rem !important;
  }

  .mt-xl-56 {
    margin-top: 27.5rem !important;
  }

  .mt-xl-57 {
    margin-top: 28rem !important;
  }

  .mt-xl-58 {
    margin-top: 28.5rem !important;
  }

  .mt-xl-59 {
    margin-top: 29rem !important;
  }

  .mt-xl-60 {
    margin-top: 29.5rem !important;
  }

  .mt-xl-61 {
    margin-top: 30rem !important;
  }

  .mt-xl-62 {
    margin-top: 30.5rem !important;
  }

  .mt-xl-63 {
    margin-top: 31rem !important;
  }

  .mt-xl-64 {
    margin-top: 31.5rem !important;
  }

  .mt-xl-65 {
    margin-top: 32rem !important;
  }

  .mt-xl-66 {
    margin-top: 32.5rem !important;
  }

  .mt-xl-67 {
    margin-top: 33rem !important;
  }

  .mt-xl-68 {
    margin-top: 33.5rem !important;
  }

  .mt-xl-69 {
    margin-top: 34rem !important;
  }

  .mt-xl-70 {
    margin-top: 34.5rem !important;
  }

  .mt-xl-71 {
    margin-top: 35rem !important;
  }

  .mt-xl-72 {
    margin-top: 35.5rem !important;
  }

  .mt-xl-73 {
    margin-top: 36rem !important;
  }

  .mt-xl-74 {
    margin-top: 36.5rem !important;
  }

  .mt-xl-75 {
    margin-top: 37rem !important;
  }

  .mt-xl-76 {
    margin-top: 37.5rem !important;
  }

  .mt-xl-77 {
    margin-top: 38rem !important;
  }

  .mt-xl-78 {
    margin-top: 38.5rem !important;
  }

  .mt-xl-79 {
    margin-top: 39rem !important;
  }

  .mt-xl-80 {
    margin-top: 39.5rem !important;
  }

  .mt-xl-81 {
    margin-top: 40rem !important;
  }

  .mt-xl-82 {
    margin-top: 40.5rem !important;
  }

  .mt-xl-83 {
    margin-top: 41rem !important;
  }

  .mt-xl-84 {
    margin-top: 41.5rem !important;
  }

  .mt-xl-85 {
    margin-top: 42rem !important;
  }

  .mt-xl-86 {
    margin-top: 42.5rem !important;
  }

  .mt-xl-87 {
    margin-top: 43rem !important;
  }

  .mt-xl-88 {
    margin-top: 43.5rem !important;
  }

  .mt-xl-89 {
    margin-top: 44rem !important;
  }

  .mt-xl-90 {
    margin-top: 44.5rem !important;
  }

  .mt-xl-91 {
    margin-top: 45rem !important;
  }

  .mt-xl-92 {
    margin-top: 45.5rem !important;
  }

  .mt-xl-93 {
    margin-top: 46rem !important;
  }

  .mt-xl-94 {
    margin-top: 46.5rem !important;
  }

  .mt-xl-95 {
    margin-top: 47rem !important;
  }

  .mt-xl-96 {
    margin-top: 47.5rem !important;
  }

  .mt-xl-97 {
    margin-top: 48rem !important;
  }

  .mt-xl-98 {
    margin-top: 48.5rem !important;
  }

  .mt-xl-99 {
    margin-top: 49rem !important;
  }

  .mt-xl-100 {
    margin-top: 49.5rem !important;
  }

  .mt-xl-101 {
    margin-top: 50rem !important;
  }

  .mt-xl-102 {
    margin-top: 50.5rem !important;
  }

  .mt-xl-103 {
    margin-top: 51rem !important;
  }

  .mt-xl-104 {
    margin-top: 51.5rem !important;
  }

  .mt-xl-105 {
    margin-top: 52rem !important;
  }

  .mt-xl-106 {
    margin-top: 52.5rem !important;
  }

  .mt-xl-107 {
    margin-top: 53rem !important;
  }

  .mt-xl-108 {
    margin-top: 53.5rem !important;
  }

  .mt-xl-109 {
    margin-top: 54rem !important;
  }

  .mt-xl-110 {
    margin-top: 54.5rem !important;
  }

  .mt-xl-111 {
    margin-top: 55rem !important;
  }

  .mt-xl-112 {
    margin-top: 55.5rem !important;
  }

  .mt-xl-113 {
    margin-top: 56rem !important;
  }

  .mt-xl-114 {
    margin-top: 56.5rem !important;
  }

  .mt-xl-115 {
    margin-top: 57rem !important;
  }

  .mt-xl-116 {
    margin-top: 57.5rem !important;
  }

  .mt-xl-117 {
    margin-top: 58rem !important;
  }

  .mt-xl-118 {
    margin-top: 58.5rem !important;
  }

  .mt-xl-119 {
    margin-top: 59rem !important;
  }

  .mt-xl-120 {
    margin-top: 59.5rem !important;
  }

  .mt-xl-121 {
    margin-top: 60rem !important;
  }

  .mt-xl-122 {
    margin-top: 60.5rem !important;
  }

  .mt-xl-123 {
    margin-top: 61rem !important;
  }

  .mt-xl-124 {
    margin-top: 61.5rem !important;
  }

  .mt-xl-125 {
    margin-top: 62rem !important;
  }

  .mt-xl-126 {
    margin-top: 62.5rem !important;
  }

  .mt-xl-127 {
    margin-top: 63rem !important;
  }

  .mt-xl-128 {
    margin-top: 63.5rem !important;
  }

  .mt-xl-129 {
    margin-top: 64rem !important;
  }

  .mt-xl-130 {
    margin-top: 64.5rem !important;
  }

  .mt-xl-131 {
    margin-top: 65rem !important;
  }

  .mt-xl-132 {
    margin-top: 65.5rem !important;
  }

  .mt-xl-133 {
    margin-top: 66rem !important;
  }

  .mt-xl-134 {
    margin-top: 66.5rem !important;
  }

  .mt-xl-135 {
    margin-top: 67rem !important;
  }

  .mt-xl-136 {
    margin-top: 67.5rem !important;
  }

  .mt-xl-137 {
    margin-top: 68rem !important;
  }

  .mt-xl-138 {
    margin-top: 68.5rem !important;
  }

  .mt-xl-139 {
    margin-top: 69rem !important;
  }

  .mt-xl-140 {
    margin-top: 69.5rem !important;
  }

  .mt-xl-141 {
    margin-top: 70rem !important;
  }

  .mt-xl-142 {
    margin-top: 70.5rem !important;
  }

  .mt-xl-143 {
    margin-top: 71rem !important;
  }

  .mt-xl-144 {
    margin-top: 71.5rem !important;
  }

  .mt-xl-145 {
    margin-top: 72rem !important;
  }

  .mt-xl-146 {
    margin-top: 72.5rem !important;
  }

  .mt-xl-147 {
    margin-top: 73rem !important;
  }

  .mt-xl-148 {
    margin-top: 73.5rem !important;
  }

  .mt-xl-149 {
    margin-top: 74rem !important;
  }

  .mt-xl-150 {
    margin-top: 74.5rem !important;
  }

  .mt-xl-151 {
    margin-top: 75rem !important;
  }

  .mt-xl-152 {
    margin-top: 75.5rem !important;
  }

  .mt-xl-153 {
    margin-top: 76rem !important;
  }

  .mt-xl-154 {
    margin-top: 76.5rem !important;
  }

  .mt-xl-155 {
    margin-top: 77rem !important;
  }

  .mt-xl-156 {
    margin-top: 77.5rem !important;
  }

  .mt-xl-157 {
    margin-top: 78rem !important;
  }

  .mt-xl-158 {
    margin-top: 78.5rem !important;
  }

  .mt-xl-159 {
    margin-top: 79rem !important;
  }

  .mt-xl-160 {
    margin-top: 79.5rem !important;
  }

  .mb-xl-0 {
    margin-bottom: 0rem !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 2rem !important;
  }

  .mb-xl-6 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xl-7 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-8 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xl-9 {
    margin-bottom: 4rem !important;
  }

  .mb-xl-10 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xl-11 {
    margin-bottom: 5rem !important;
  }

  .mb-xl-12 {
    margin-bottom: 5.5rem !important;
  }

  .mb-xl-13 {
    margin-bottom: 6rem !important;
  }

  .mb-xl-14 {
    margin-bottom: 6.5rem !important;
  }

  .mb-xl-15 {
    margin-bottom: 7rem !important;
  }

  .mb-xl-16 {
    margin-bottom: 7.5rem !important;
  }

  .mb-xl-17 {
    margin-bottom: 8rem !important;
  }

  .mb-xl-18 {
    margin-bottom: 8.5rem !important;
  }

  .mb-xl-19 {
    margin-bottom: 9rem !important;
  }

  .mb-xl-20 {
    margin-bottom: 9.5rem !important;
  }

  .mb-xl-21 {
    margin-bottom: 10rem !important;
  }

  .mb-xl-22 {
    margin-bottom: 10.5rem !important;
  }

  .mb-xl-23 {
    margin-bottom: 11rem !important;
  }

  .mb-xl-24 {
    margin-bottom: 11.5rem !important;
  }

  .mb-xl-25 {
    margin-bottom: 12rem !important;
  }

  .mb-xl-26 {
    margin-bottom: 12.5rem !important;
  }

  .mb-xl-27 {
    margin-bottom: 13rem !important;
  }

  .mb-xl-28 {
    margin-bottom: 13.5rem !important;
  }

  .mb-xl-29 {
    margin-bottom: 14rem !important;
  }

  .mb-xl-30 {
    margin-bottom: 14.5rem !important;
  }

  .mb-xl-31 {
    margin-bottom: 15rem !important;
  }

  .mb-xl-32 {
    margin-bottom: 15.5rem !important;
  }

  .mb-xl-33 {
    margin-bottom: 16rem !important;
  }

  .mb-xl-34 {
    margin-bottom: 16.5rem !important;
  }

  .mb-xl-35 {
    margin-bottom: 17rem !important;
  }

  .mb-xl-36 {
    margin-bottom: 17.5rem !important;
  }

  .mb-xl-37 {
    margin-bottom: 18rem !important;
  }

  .mb-xl-38 {
    margin-bottom: 18.5rem !important;
  }

  .mb-xl-39 {
    margin-bottom: 19rem !important;
  }

  .mb-xl-40 {
    margin-bottom: 19.5rem !important;
  }

  .mb-xl-41 {
    margin-bottom: 20rem !important;
  }

  .mb-xl-42 {
    margin-bottom: 20.5rem !important;
  }

  .mb-xl-43 {
    margin-bottom: 21rem !important;
  }

  .mb-xl-44 {
    margin-bottom: 21.5rem !important;
  }

  .mb-xl-45 {
    margin-bottom: 22rem !important;
  }

  .mb-xl-46 {
    margin-bottom: 22.5rem !important;
  }

  .mb-xl-47 {
    margin-bottom: 23rem !important;
  }

  .mb-xl-48 {
    margin-bottom: 23.5rem !important;
  }

  .mb-xl-49 {
    margin-bottom: 24rem !important;
  }

  .mb-xl-50 {
    margin-bottom: 24.5rem !important;
  }

  .mb-xl-51 {
    margin-bottom: 25rem !important;
  }

  .mb-xl-52 {
    margin-bottom: 25.5rem !important;
  }

  .mb-xl-53 {
    margin-bottom: 26rem !important;
  }

  .mb-xl-54 {
    margin-bottom: 26.5rem !important;
  }

  .mb-xl-55 {
    margin-bottom: 27rem !important;
  }

  .mb-xl-56 {
    margin-bottom: 27.5rem !important;
  }

  .mb-xl-57 {
    margin-bottom: 28rem !important;
  }

  .mb-xl-58 {
    margin-bottom: 28.5rem !important;
  }

  .mb-xl-59 {
    margin-bottom: 29rem !important;
  }

  .mb-xl-60 {
    margin-bottom: 29.5rem !important;
  }

  .mb-xl-61 {
    margin-bottom: 30rem !important;
  }

  .mb-xl-62 {
    margin-bottom: 30.5rem !important;
  }

  .mb-xl-63 {
    margin-bottom: 31rem !important;
  }

  .mb-xl-64 {
    margin-bottom: 31.5rem !important;
  }

  .mb-xl-65 {
    margin-bottom: 32rem !important;
  }

  .mb-xl-66 {
    margin-bottom: 32.5rem !important;
  }

  .mb-xl-67 {
    margin-bottom: 33rem !important;
  }

  .mb-xl-68 {
    margin-bottom: 33.5rem !important;
  }

  .mb-xl-69 {
    margin-bottom: 34rem !important;
  }

  .mb-xl-70 {
    margin-bottom: 34.5rem !important;
  }

  .mb-xl-71 {
    margin-bottom: 35rem !important;
  }

  .mb-xl-72 {
    margin-bottom: 35.5rem !important;
  }

  .mb-xl-73 {
    margin-bottom: 36rem !important;
  }

  .mb-xl-74 {
    margin-bottom: 36.5rem !important;
  }

  .mb-xl-75 {
    margin-bottom: 37rem !important;
  }

  .mb-xl-76 {
    margin-bottom: 37.5rem !important;
  }

  .mb-xl-77 {
    margin-bottom: 38rem !important;
  }

  .mb-xl-78 {
    margin-bottom: 38.5rem !important;
  }

  .mb-xl-79 {
    margin-bottom: 39rem !important;
  }

  .mb-xl-80 {
    margin-bottom: 39.5rem !important;
  }

  .mb-xl-81 {
    margin-bottom: 40rem !important;
  }

  .mb-xl-82 {
    margin-bottom: 40.5rem !important;
  }

  .mb-xl-83 {
    margin-bottom: 41rem !important;
  }

  .mb-xl-84 {
    margin-bottom: 41.5rem !important;
  }

  .mb-xl-85 {
    margin-bottom: 42rem !important;
  }

  .mb-xl-86 {
    margin-bottom: 42.5rem !important;
  }

  .mb-xl-87 {
    margin-bottom: 43rem !important;
  }

  .mb-xl-88 {
    margin-bottom: 43.5rem !important;
  }

  .mb-xl-89 {
    margin-bottom: 44rem !important;
  }

  .mb-xl-90 {
    margin-bottom: 44.5rem !important;
  }

  .mb-xl-91 {
    margin-bottom: 45rem !important;
  }

  .mb-xl-92 {
    margin-bottom: 45.5rem !important;
  }

  .mb-xl-93 {
    margin-bottom: 46rem !important;
  }

  .mb-xl-94 {
    margin-bottom: 46.5rem !important;
  }

  .mb-xl-95 {
    margin-bottom: 47rem !important;
  }

  .mb-xl-96 {
    margin-bottom: 47.5rem !important;
  }

  .mb-xl-97 {
    margin-bottom: 48rem !important;
  }

  .mb-xl-98 {
    margin-bottom: 48.5rem !important;
  }

  .mb-xl-99 {
    margin-bottom: 49rem !important;
  }

  .mb-xl-100 {
    margin-bottom: 49.5rem !important;
  }

  .mb-xl-101 {
    margin-bottom: 50rem !important;
  }

  .mb-xl-102 {
    margin-bottom: 50.5rem !important;
  }

  .mb-xl-103 {
    margin-bottom: 51rem !important;
  }

  .mb-xl-104 {
    margin-bottom: 51.5rem !important;
  }

  .mb-xl-105 {
    margin-bottom: 52rem !important;
  }

  .mb-xl-106 {
    margin-bottom: 52.5rem !important;
  }

  .mb-xl-107 {
    margin-bottom: 53rem !important;
  }

  .mb-xl-108 {
    margin-bottom: 53.5rem !important;
  }

  .mb-xl-109 {
    margin-bottom: 54rem !important;
  }

  .mb-xl-110 {
    margin-bottom: 54.5rem !important;
  }

  .mb-xl-111 {
    margin-bottom: 55rem !important;
  }

  .mb-xl-112 {
    margin-bottom: 55.5rem !important;
  }

  .mb-xl-113 {
    margin-bottom: 56rem !important;
  }

  .mb-xl-114 {
    margin-bottom: 56.5rem !important;
  }

  .mb-xl-115 {
    margin-bottom: 57rem !important;
  }

  .mb-xl-116 {
    margin-bottom: 57.5rem !important;
  }

  .mb-xl-117 {
    margin-bottom: 58rem !important;
  }

  .mb-xl-118 {
    margin-bottom: 58.5rem !important;
  }

  .mb-xl-119 {
    margin-bottom: 59rem !important;
  }

  .mb-xl-120 {
    margin-bottom: 59.5rem !important;
  }

  .mb-xl-121 {
    margin-bottom: 60rem !important;
  }

  .mb-xl-122 {
    margin-bottom: 60.5rem !important;
  }

  .mb-xl-123 {
    margin-bottom: 61rem !important;
  }

  .mb-xl-124 {
    margin-bottom: 61.5rem !important;
  }

  .mb-xl-125 {
    margin-bottom: 62rem !important;
  }

  .mb-xl-126 {
    margin-bottom: 62.5rem !important;
  }

  .mb-xl-127 {
    margin-bottom: 63rem !important;
  }

  .mb-xl-128 {
    margin-bottom: 63.5rem !important;
  }

  .mb-xl-129 {
    margin-bottom: 64rem !important;
  }

  .mb-xl-130 {
    margin-bottom: 64.5rem !important;
  }

  .mb-xl-131 {
    margin-bottom: 65rem !important;
  }

  .mb-xl-132 {
    margin-bottom: 65.5rem !important;
  }

  .mb-xl-133 {
    margin-bottom: 66rem !important;
  }

  .mb-xl-134 {
    margin-bottom: 66.5rem !important;
  }

  .mb-xl-135 {
    margin-bottom: 67rem !important;
  }

  .mb-xl-136 {
    margin-bottom: 67.5rem !important;
  }

  .mb-xl-137 {
    margin-bottom: 68rem !important;
  }

  .mb-xl-138 {
    margin-bottom: 68.5rem !important;
  }

  .mb-xl-139 {
    margin-bottom: 69rem !important;
  }

  .mb-xl-140 {
    margin-bottom: 69.5rem !important;
  }

  .mb-xl-141 {
    margin-bottom: 70rem !important;
  }

  .mb-xl-142 {
    margin-bottom: 70.5rem !important;
  }

  .mb-xl-143 {
    margin-bottom: 71rem !important;
  }

  .mb-xl-144 {
    margin-bottom: 71.5rem !important;
  }

  .mb-xl-145 {
    margin-bottom: 72rem !important;
  }

  .mb-xl-146 {
    margin-bottom: 72.5rem !important;
  }

  .mb-xl-147 {
    margin-bottom: 73rem !important;
  }

  .mb-xl-148 {
    margin-bottom: 73.5rem !important;
  }

  .mb-xl-149 {
    margin-bottom: 74rem !important;
  }

  .mb-xl-150 {
    margin-bottom: 74.5rem !important;
  }

  .mb-xl-151 {
    margin-bottom: 75rem !important;
  }

  .mb-xl-152 {
    margin-bottom: 75.5rem !important;
  }

  .mb-xl-153 {
    margin-bottom: 76rem !important;
  }

  .mb-xl-154 {
    margin-bottom: 76.5rem !important;
  }

  .mb-xl-155 {
    margin-bottom: 77rem !important;
  }

  .mb-xl-156 {
    margin-bottom: 77.5rem !important;
  }

  .mb-xl-157 {
    margin-bottom: 78rem !important;
  }

  .mb-xl-158 {
    margin-bottom: 78.5rem !important;
  }

  .mb-xl-159 {
    margin-bottom: 79rem !important;
  }

  .mb-xl-160 {
    margin-bottom: 79.5rem !important;
  }

  .ms-xl-0 {
    margin-left: 0rem !important;
  }

  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xl-3 {
    margin-left: 1rem !important;
  }

  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xl-5 {
    margin-left: 2rem !important;
  }

  .ms-xl-6 {
    margin-left: 2.5rem !important;
  }

  .ms-xl-7 {
    margin-left: 3rem !important;
  }

  .ms-xl-8 {
    margin-left: 3.5rem !important;
  }

  .ms-xl-9 {
    margin-left: 4rem !important;
  }

  .ms-xl-10 {
    margin-left: 4.5rem !important;
  }

  .ms-xl-11 {
    margin-left: 5rem !important;
  }

  .ms-xl-12 {
    margin-left: 5.5rem !important;
  }

  .ms-xl-13 {
    margin-left: 6rem !important;
  }

  .ms-xl-14 {
    margin-left: 6.5rem !important;
  }

  .ms-xl-15 {
    margin-left: 7rem !important;
  }

  .ms-xl-16 {
    margin-left: 7.5rem !important;
  }

  .ms-xl-17 {
    margin-left: 8rem !important;
  }

  .ms-xl-18 {
    margin-left: 8.5rem !important;
  }

  .ms-xl-19 {
    margin-left: 9rem !important;
  }

  .ms-xl-20 {
    margin-left: 9.5rem !important;
  }

  .ms-xl-21 {
    margin-left: 10rem !important;
  }

  .ms-xl-22 {
    margin-left: 10.5rem !important;
  }

  .ms-xl-23 {
    margin-left: 11rem !important;
  }

  .ms-xl-24 {
    margin-left: 11.5rem !important;
  }

  .ms-xl-25 {
    margin-left: 12rem !important;
  }

  .ms-xl-26 {
    margin-left: 12.5rem !important;
  }

  .ms-xl-27 {
    margin-left: 13rem !important;
  }

  .ms-xl-28 {
    margin-left: 13.5rem !important;
  }

  .ms-xl-29 {
    margin-left: 14rem !important;
  }

  .ms-xl-30 {
    margin-left: 14.5rem !important;
  }

  .ms-xl-31 {
    margin-left: 15rem !important;
  }

  .ms-xl-32 {
    margin-left: 15.5rem !important;
  }

  .ms-xl-33 {
    margin-left: 16rem !important;
  }

  .ms-xl-34 {
    margin-left: 16.5rem !important;
  }

  .ms-xl-35 {
    margin-left: 17rem !important;
  }

  .ms-xl-36 {
    margin-left: 17.5rem !important;
  }

  .ms-xl-37 {
    margin-left: 18rem !important;
  }

  .ms-xl-38 {
    margin-left: 18.5rem !important;
  }

  .ms-xl-39 {
    margin-left: 19rem !important;
  }

  .ms-xl-40 {
    margin-left: 19.5rem !important;
  }

  .ms-xl-41 {
    margin-left: 20rem !important;
  }

  .ms-xl-42 {
    margin-left: 20.5rem !important;
  }

  .ms-xl-43 {
    margin-left: 21rem !important;
  }

  .ms-xl-44 {
    margin-left: 21.5rem !important;
  }

  .ms-xl-45 {
    margin-left: 22rem !important;
  }

  .ms-xl-46 {
    margin-left: 22.5rem !important;
  }

  .ms-xl-47 {
    margin-left: 23rem !important;
  }

  .ms-xl-48 {
    margin-left: 23.5rem !important;
  }

  .ms-xl-49 {
    margin-left: 24rem !important;
  }

  .ms-xl-50 {
    margin-left: 24.5rem !important;
  }

  .ms-xl-51 {
    margin-left: 25rem !important;
  }

  .ms-xl-52 {
    margin-left: 25.5rem !important;
  }

  .ms-xl-53 {
    margin-left: 26rem !important;
  }

  .ms-xl-54 {
    margin-left: 26.5rem !important;
  }

  .ms-xl-55 {
    margin-left: 27rem !important;
  }

  .ms-xl-56 {
    margin-left: 27.5rem !important;
  }

  .ms-xl-57 {
    margin-left: 28rem !important;
  }

  .ms-xl-58 {
    margin-left: 28.5rem !important;
  }

  .ms-xl-59 {
    margin-left: 29rem !important;
  }

  .ms-xl-60 {
    margin-left: 29.5rem !important;
  }

  .ms-xl-61 {
    margin-left: 30rem !important;
  }

  .ms-xl-62 {
    margin-left: 30.5rem !important;
  }

  .ms-xl-63 {
    margin-left: 31rem !important;
  }

  .ms-xl-64 {
    margin-left: 31.5rem !important;
  }

  .ms-xl-65 {
    margin-left: 32rem !important;
  }

  .ms-xl-66 {
    margin-left: 32.5rem !important;
  }

  .ms-xl-67 {
    margin-left: 33rem !important;
  }

  .ms-xl-68 {
    margin-left: 33.5rem !important;
  }

  .ms-xl-69 {
    margin-left: 34rem !important;
  }

  .ms-xl-70 {
    margin-left: 34.5rem !important;
  }

  .ms-xl-71 {
    margin-left: 35rem !important;
  }

  .ms-xl-72 {
    margin-left: 35.5rem !important;
  }

  .ms-xl-73 {
    margin-left: 36rem !important;
  }

  .ms-xl-74 {
    margin-left: 36.5rem !important;
  }

  .ms-xl-75 {
    margin-left: 37rem !important;
  }

  .ms-xl-76 {
    margin-left: 37.5rem !important;
  }

  .ms-xl-77 {
    margin-left: 38rem !important;
  }

  .ms-xl-78 {
    margin-left: 38.5rem !important;
  }

  .ms-xl-79 {
    margin-left: 39rem !important;
  }

  .ms-xl-80 {
    margin-left: 39.5rem !important;
  }

  .ms-xl-81 {
    margin-left: 40rem !important;
  }

  .ms-xl-82 {
    margin-left: 40.5rem !important;
  }

  .ms-xl-83 {
    margin-left: 41rem !important;
  }

  .ms-xl-84 {
    margin-left: 41.5rem !important;
  }

  .ms-xl-85 {
    margin-left: 42rem !important;
  }

  .ms-xl-86 {
    margin-left: 42.5rem !important;
  }

  .ms-xl-87 {
    margin-left: 43rem !important;
  }

  .ms-xl-88 {
    margin-left: 43.5rem !important;
  }

  .ms-xl-89 {
    margin-left: 44rem !important;
  }

  .ms-xl-90 {
    margin-left: 44.5rem !important;
  }

  .ms-xl-91 {
    margin-left: 45rem !important;
  }

  .ms-xl-92 {
    margin-left: 45.5rem !important;
  }

  .ms-xl-93 {
    margin-left: 46rem !important;
  }

  .ms-xl-94 {
    margin-left: 46.5rem !important;
  }

  .ms-xl-95 {
    margin-left: 47rem !important;
  }

  .ms-xl-96 {
    margin-left: 47.5rem !important;
  }

  .ms-xl-97 {
    margin-left: 48rem !important;
  }

  .ms-xl-98 {
    margin-left: 48.5rem !important;
  }

  .ms-xl-99 {
    margin-left: 49rem !important;
  }

  .ms-xl-100 {
    margin-left: 49.5rem !important;
  }

  .ms-xl-101 {
    margin-left: 50rem !important;
  }

  .ms-xl-102 {
    margin-left: 50.5rem !important;
  }

  .ms-xl-103 {
    margin-left: 51rem !important;
  }

  .ms-xl-104 {
    margin-left: 51.5rem !important;
  }

  .ms-xl-105 {
    margin-left: 52rem !important;
  }

  .ms-xl-106 {
    margin-left: 52.5rem !important;
  }

  .ms-xl-107 {
    margin-left: 53rem !important;
  }

  .ms-xl-108 {
    margin-left: 53.5rem !important;
  }

  .ms-xl-109 {
    margin-left: 54rem !important;
  }

  .ms-xl-110 {
    margin-left: 54.5rem !important;
  }

  .ms-xl-111 {
    margin-left: 55rem !important;
  }

  .ms-xl-112 {
    margin-left: 55.5rem !important;
  }

  .ms-xl-113 {
    margin-left: 56rem !important;
  }

  .ms-xl-114 {
    margin-left: 56.5rem !important;
  }

  .ms-xl-115 {
    margin-left: 57rem !important;
  }

  .ms-xl-116 {
    margin-left: 57.5rem !important;
  }

  .ms-xl-117 {
    margin-left: 58rem !important;
  }

  .ms-xl-118 {
    margin-left: 58.5rem !important;
  }

  .ms-xl-119 {
    margin-left: 59rem !important;
  }

  .ms-xl-120 {
    margin-left: 59.5rem !important;
  }

  .ms-xl-121 {
    margin-left: 60rem !important;
  }

  .ms-xl-122 {
    margin-left: 60.5rem !important;
  }

  .ms-xl-123 {
    margin-left: 61rem !important;
  }

  .ms-xl-124 {
    margin-left: 61.5rem !important;
  }

  .ms-xl-125 {
    margin-left: 62rem !important;
  }

  .ms-xl-126 {
    margin-left: 62.5rem !important;
  }

  .ms-xl-127 {
    margin-left: 63rem !important;
  }

  .ms-xl-128 {
    margin-left: 63.5rem !important;
  }

  .ms-xl-129 {
    margin-left: 64rem !important;
  }

  .ms-xl-130 {
    margin-left: 64.5rem !important;
  }

  .ms-xl-131 {
    margin-left: 65rem !important;
  }

  .ms-xl-132 {
    margin-left: 65.5rem !important;
  }

  .ms-xl-133 {
    margin-left: 66rem !important;
  }

  .ms-xl-134 {
    margin-left: 66.5rem !important;
  }

  .ms-xl-135 {
    margin-left: 67rem !important;
  }

  .ms-xl-136 {
    margin-left: 67.5rem !important;
  }

  .ms-xl-137 {
    margin-left: 68rem !important;
  }

  .ms-xl-138 {
    margin-left: 68.5rem !important;
  }

  .ms-xl-139 {
    margin-left: 69rem !important;
  }

  .ms-xl-140 {
    margin-left: 69.5rem !important;
  }

  .ms-xl-141 {
    margin-left: 70rem !important;
  }

  .ms-xl-142 {
    margin-left: 70.5rem !important;
  }

  .ms-xl-143 {
    margin-left: 71rem !important;
  }

  .ms-xl-144 {
    margin-left: 71.5rem !important;
  }

  .ms-xl-145 {
    margin-left: 72rem !important;
  }

  .ms-xl-146 {
    margin-left: 72.5rem !important;
  }

  .ms-xl-147 {
    margin-left: 73rem !important;
  }

  .ms-xl-148 {
    margin-left: 73.5rem !important;
  }

  .ms-xl-149 {
    margin-left: 74rem !important;
  }

  .ms-xl-150 {
    margin-left: 74.5rem !important;
  }

  .ms-xl-151 {
    margin-left: 75rem !important;
  }

  .ms-xl-152 {
    margin-left: 75.5rem !important;
  }

  .ms-xl-153 {
    margin-left: 76rem !important;
  }

  .ms-xl-154 {
    margin-left: 76.5rem !important;
  }

  .ms-xl-155 {
    margin-left: 77rem !important;
  }

  .ms-xl-156 {
    margin-left: 77.5rem !important;
  }

  .ms-xl-157 {
    margin-left: 78rem !important;
  }

  .ms-xl-158 {
    margin-left: 78.5rem !important;
  }

  .ms-xl-159 {
    margin-left: 79rem !important;
  }

  .ms-xl-160 {
    margin-left: 79.5rem !important;
  }

  .me-xl-0 {
    margin-right: 0rem !important;
  }

  .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xl-3 {
    margin-right: 1rem !important;
  }

  .me-xl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xl-5 {
    margin-right: 2rem !important;
  }

  .me-xl-6 {
    margin-right: 2.5rem !important;
  }

  .me-xl-7 {
    margin-right: 3rem !important;
  }

  .me-xl-8 {
    margin-right: 3.5rem !important;
  }

  .me-xl-9 {
    margin-right: 4rem !important;
  }

  .me-xl-10 {
    margin-right: 4.5rem !important;
  }

  .me-xl-11 {
    margin-right: 5rem !important;
  }

  .me-xl-12 {
    margin-right: 5.5rem !important;
  }

  .me-xl-13 {
    margin-right: 6rem !important;
  }

  .me-xl-14 {
    margin-right: 6.5rem !important;
  }

  .me-xl-15 {
    margin-right: 7rem !important;
  }

  .me-xl-16 {
    margin-right: 7.5rem !important;
  }

  .me-xl-17 {
    margin-right: 8rem !important;
  }

  .me-xl-18 {
    margin-right: 8.5rem !important;
  }

  .me-xl-19 {
    margin-right: 9rem !important;
  }

  .me-xl-20 {
    margin-right: 9.5rem !important;
  }

  .me-xl-21 {
    margin-right: 10rem !important;
  }

  .me-xl-22 {
    margin-right: 10.5rem !important;
  }

  .me-xl-23 {
    margin-right: 11rem !important;
  }

  .me-xl-24 {
    margin-right: 11.5rem !important;
  }

  .me-xl-25 {
    margin-right: 12rem !important;
  }

  .me-xl-26 {
    margin-right: 12.5rem !important;
  }

  .me-xl-27 {
    margin-right: 13rem !important;
  }

  .me-xl-28 {
    margin-right: 13.5rem !important;
  }

  .me-xl-29 {
    margin-right: 14rem !important;
  }

  .me-xl-30 {
    margin-right: 14.5rem !important;
  }

  .me-xl-31 {
    margin-right: 15rem !important;
  }

  .me-xl-32 {
    margin-right: 15.5rem !important;
  }

  .me-xl-33 {
    margin-right: 16rem !important;
  }

  .me-xl-34 {
    margin-right: 16.5rem !important;
  }

  .me-xl-35 {
    margin-right: 17rem !important;
  }

  .me-xl-36 {
    margin-right: 17.5rem !important;
  }

  .me-xl-37 {
    margin-right: 18rem !important;
  }

  .me-xl-38 {
    margin-right: 18.5rem !important;
  }

  .me-xl-39 {
    margin-right: 19rem !important;
  }

  .me-xl-40 {
    margin-right: 19.5rem !important;
  }

  .me-xl-41 {
    margin-right: 20rem !important;
  }

  .me-xl-42 {
    margin-right: 20.5rem !important;
  }

  .me-xl-43 {
    margin-right: 21rem !important;
  }

  .me-xl-44 {
    margin-right: 21.5rem !important;
  }

  .me-xl-45 {
    margin-right: 22rem !important;
  }

  .me-xl-46 {
    margin-right: 22.5rem !important;
  }

  .me-xl-47 {
    margin-right: 23rem !important;
  }

  .me-xl-48 {
    margin-right: 23.5rem !important;
  }

  .me-xl-49 {
    margin-right: 24rem !important;
  }

  .me-xl-50 {
    margin-right: 24.5rem !important;
  }

  .me-xl-51 {
    margin-right: 25rem !important;
  }

  .me-xl-52 {
    margin-right: 25.5rem !important;
  }

  .me-xl-53 {
    margin-right: 26rem !important;
  }

  .me-xl-54 {
    margin-right: 26.5rem !important;
  }

  .me-xl-55 {
    margin-right: 27rem !important;
  }

  .me-xl-56 {
    margin-right: 27.5rem !important;
  }

  .me-xl-57 {
    margin-right: 28rem !important;
  }

  .me-xl-58 {
    margin-right: 28.5rem !important;
  }

  .me-xl-59 {
    margin-right: 29rem !important;
  }

  .me-xl-60 {
    margin-right: 29.5rem !important;
  }

  .me-xl-61 {
    margin-right: 30rem !important;
  }

  .me-xl-62 {
    margin-right: 30.5rem !important;
  }

  .me-xl-63 {
    margin-right: 31rem !important;
  }

  .me-xl-64 {
    margin-right: 31.5rem !important;
  }

  .me-xl-65 {
    margin-right: 32rem !important;
  }

  .me-xl-66 {
    margin-right: 32.5rem !important;
  }

  .me-xl-67 {
    margin-right: 33rem !important;
  }

  .me-xl-68 {
    margin-right: 33.5rem !important;
  }

  .me-xl-69 {
    margin-right: 34rem !important;
  }

  .me-xl-70 {
    margin-right: 34.5rem !important;
  }

  .me-xl-71 {
    margin-right: 35rem !important;
  }

  .me-xl-72 {
    margin-right: 35.5rem !important;
  }

  .me-xl-73 {
    margin-right: 36rem !important;
  }

  .me-xl-74 {
    margin-right: 36.5rem !important;
  }

  .me-xl-75 {
    margin-right: 37rem !important;
  }

  .me-xl-76 {
    margin-right: 37.5rem !important;
  }

  .me-xl-77 {
    margin-right: 38rem !important;
  }

  .me-xl-78 {
    margin-right: 38.5rem !important;
  }

  .me-xl-79 {
    margin-right: 39rem !important;
  }

  .me-xl-80 {
    margin-right: 39.5rem !important;
  }

  .me-xl-81 {
    margin-right: 40rem !important;
  }

  .me-xl-82 {
    margin-right: 40.5rem !important;
  }

  .me-xl-83 {
    margin-right: 41rem !important;
  }

  .me-xl-84 {
    margin-right: 41.5rem !important;
  }

  .me-xl-85 {
    margin-right: 42rem !important;
  }

  .me-xl-86 {
    margin-right: 42.5rem !important;
  }

  .me-xl-87 {
    margin-right: 43rem !important;
  }

  .me-xl-88 {
    margin-right: 43.5rem !important;
  }

  .me-xl-89 {
    margin-right: 44rem !important;
  }

  .me-xl-90 {
    margin-right: 44.5rem !important;
  }

  .me-xl-91 {
    margin-right: 45rem !important;
  }

  .me-xl-92 {
    margin-right: 45.5rem !important;
  }

  .me-xl-93 {
    margin-right: 46rem !important;
  }

  .me-xl-94 {
    margin-right: 46.5rem !important;
  }

  .me-xl-95 {
    margin-right: 47rem !important;
  }

  .me-xl-96 {
    margin-right: 47.5rem !important;
  }

  .me-xl-97 {
    margin-right: 48rem !important;
  }

  .me-xl-98 {
    margin-right: 48.5rem !important;
  }

  .me-xl-99 {
    margin-right: 49rem !important;
  }

  .me-xl-100 {
    margin-right: 49.5rem !important;
  }

  .me-xl-101 {
    margin-right: 50rem !important;
  }

  .me-xl-102 {
    margin-right: 50.5rem !important;
  }

  .me-xl-103 {
    margin-right: 51rem !important;
  }

  .me-xl-104 {
    margin-right: 51.5rem !important;
  }

  .me-xl-105 {
    margin-right: 52rem !important;
  }

  .me-xl-106 {
    margin-right: 52.5rem !important;
  }

  .me-xl-107 {
    margin-right: 53rem !important;
  }

  .me-xl-108 {
    margin-right: 53.5rem !important;
  }

  .me-xl-109 {
    margin-right: 54rem !important;
  }

  .me-xl-110 {
    margin-right: 54.5rem !important;
  }

  .me-xl-111 {
    margin-right: 55rem !important;
  }

  .me-xl-112 {
    margin-right: 55.5rem !important;
  }

  .me-xl-113 {
    margin-right: 56rem !important;
  }

  .me-xl-114 {
    margin-right: 56.5rem !important;
  }

  .me-xl-115 {
    margin-right: 57rem !important;
  }

  .me-xl-116 {
    margin-right: 57.5rem !important;
  }

  .me-xl-117 {
    margin-right: 58rem !important;
  }

  .me-xl-118 {
    margin-right: 58.5rem !important;
  }

  .me-xl-119 {
    margin-right: 59rem !important;
  }

  .me-xl-120 {
    margin-right: 59.5rem !important;
  }

  .me-xl-121 {
    margin-right: 60rem !important;
  }

  .me-xl-122 {
    margin-right: 60.5rem !important;
  }

  .me-xl-123 {
    margin-right: 61rem !important;
  }

  .me-xl-124 {
    margin-right: 61.5rem !important;
  }

  .me-xl-125 {
    margin-right: 62rem !important;
  }

  .me-xl-126 {
    margin-right: 62.5rem !important;
  }

  .me-xl-127 {
    margin-right: 63rem !important;
  }

  .me-xl-128 {
    margin-right: 63.5rem !important;
  }

  .me-xl-129 {
    margin-right: 64rem !important;
  }

  .me-xl-130 {
    margin-right: 64.5rem !important;
  }

  .me-xl-131 {
    margin-right: 65rem !important;
  }

  .me-xl-132 {
    margin-right: 65.5rem !important;
  }

  .me-xl-133 {
    margin-right: 66rem !important;
  }

  .me-xl-134 {
    margin-right: 66.5rem !important;
  }

  .me-xl-135 {
    margin-right: 67rem !important;
  }

  .me-xl-136 {
    margin-right: 67.5rem !important;
  }

  .me-xl-137 {
    margin-right: 68rem !important;
  }

  .me-xl-138 {
    margin-right: 68.5rem !important;
  }

  .me-xl-139 {
    margin-right: 69rem !important;
  }

  .me-xl-140 {
    margin-right: 69.5rem !important;
  }

  .me-xl-141 {
    margin-right: 70rem !important;
  }

  .me-xl-142 {
    margin-right: 70.5rem !important;
  }

  .me-xl-143 {
    margin-right: 71rem !important;
  }

  .me-xl-144 {
    margin-right: 71.5rem !important;
  }

  .me-xl-145 {
    margin-right: 72rem !important;
  }

  .me-xl-146 {
    margin-right: 72.5rem !important;
  }

  .me-xl-147 {
    margin-right: 73rem !important;
  }

  .me-xl-148 {
    margin-right: 73.5rem !important;
  }

  .me-xl-149 {
    margin-right: 74rem !important;
  }

  .me-xl-150 {
    margin-right: 74.5rem !important;
  }

  .me-xl-151 {
    margin-right: 75rem !important;
  }

  .me-xl-152 {
    margin-right: 75.5rem !important;
  }

  .me-xl-153 {
    margin-right: 76rem !important;
  }

  .me-xl-154 {
    margin-right: 76.5rem !important;
  }

  .me-xl-155 {
    margin-right: 77rem !important;
  }

  .me-xl-156 {
    margin-right: 77.5rem !important;
  }

  .me-xl-157 {
    margin-right: 78rem !important;
  }

  .me-xl-158 {
    margin-right: 78.5rem !important;
  }

  .me-xl-159 {
    margin-right: 79rem !important;
  }

  .me-xl-160 {
    margin-right: 79.5rem !important;
  }

  .mx-xl-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }

  .mx-xl-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .mx-xl-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  .mx-xl-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  .mx-xl-6 {
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  .mx-xl-7 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  .mx-xl-8 {
    margin-left: 3.5rem !important;
    margin-right: 3.5rem !important;
  }

  .mx-xl-9 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  .mx-xl-10 {
    margin-left: 4.5rem !important;
    margin-right: 4.5rem !important;
  }

  .mx-xl-11 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  .mx-xl-12 {
    margin-left: 5.5rem !important;
    margin-right: 5.5rem !important;
  }

  .mx-xl-13 {
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  .mx-xl-14 {
    margin-left: 6.5rem !important;
    margin-right: 6.5rem !important;
  }

  .mx-xl-15 {
    margin-left: 7rem !important;
    margin-right: 7rem !important;
  }

  .mx-xl-16 {
    margin-left: 7.5rem !important;
    margin-right: 7.5rem !important;
  }

  .mx-xl-17 {
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  .mx-xl-18 {
    margin-left: 8.5rem !important;
    margin-right: 8.5rem !important;
  }

  .mx-xl-19 {
    margin-left: 9rem !important;
    margin-right: 9rem !important;
  }

  .mx-xl-20 {
    margin-left: 9.5rem !important;
    margin-right: 9.5rem !important;
  }

  .mx-xl-21 {
    margin-left: 10rem !important;
    margin-right: 10rem !important;
  }

  .mx-xl-22 {
    margin-left: 10.5rem !important;
    margin-right: 10.5rem !important;
  }

  .mx-xl-23 {
    margin-left: 11rem !important;
    margin-right: 11rem !important;
  }

  .mx-xl-24 {
    margin-left: 11.5rem !important;
    margin-right: 11.5rem !important;
  }

  .mx-xl-25 {
    margin-left: 12rem !important;
    margin-right: 12rem !important;
  }

  .mx-xl-26 {
    margin-left: 12.5rem !important;
    margin-right: 12.5rem !important;
  }

  .mx-xl-27 {
    margin-left: 13rem !important;
    margin-right: 13rem !important;
  }

  .mx-xl-28 {
    margin-left: 13.5rem !important;
    margin-right: 13.5rem !important;
  }

  .mx-xl-29 {
    margin-left: 14rem !important;
    margin-right: 14rem !important;
  }

  .mx-xl-30 {
    margin-left: 14.5rem !important;
    margin-right: 14.5rem !important;
  }

  .mx-xl-31 {
    margin-left: 15rem !important;
    margin-right: 15rem !important;
  }

  .mx-xl-32 {
    margin-left: 15.5rem !important;
    margin-right: 15.5rem !important;
  }

  .mx-xl-33 {
    margin-left: 16rem !important;
    margin-right: 16rem !important;
  }

  .mx-xl-34 {
    margin-left: 16.5rem !important;
    margin-right: 16.5rem !important;
  }

  .mx-xl-35 {
    margin-left: 17rem !important;
    margin-right: 17rem !important;
  }

  .mx-xl-36 {
    margin-left: 17.5rem !important;
    margin-right: 17.5rem !important;
  }

  .mx-xl-37 {
    margin-left: 18rem !important;
    margin-right: 18rem !important;
  }

  .mx-xl-38 {
    margin-left: 18.5rem !important;
    margin-right: 18.5rem !important;
  }

  .mx-xl-39 {
    margin-left: 19rem !important;
    margin-right: 19rem !important;
  }

  .mx-xl-40 {
    margin-left: 19.5rem !important;
    margin-right: 19.5rem !important;
  }

  .mx-xl-41 {
    margin-left: 20rem !important;
    margin-right: 20rem !important;
  }

  .mx-xl-42 {
    margin-left: 20.5rem !important;
    margin-right: 20.5rem !important;
  }

  .mx-xl-43 {
    margin-left: 21rem !important;
    margin-right: 21rem !important;
  }

  .mx-xl-44 {
    margin-left: 21.5rem !important;
    margin-right: 21.5rem !important;
  }

  .mx-xl-45 {
    margin-left: 22rem !important;
    margin-right: 22rem !important;
  }

  .mx-xl-46 {
    margin-left: 22.5rem !important;
    margin-right: 22.5rem !important;
  }

  .mx-xl-47 {
    margin-left: 23rem !important;
    margin-right: 23rem !important;
  }

  .mx-xl-48 {
    margin-left: 23.5rem !important;
    margin-right: 23.5rem !important;
  }

  .mx-xl-49 {
    margin-left: 24rem !important;
    margin-right: 24rem !important;
  }

  .mx-xl-50 {
    margin-left: 24.5rem !important;
    margin-right: 24.5rem !important;
  }

  .mx-xl-51 {
    margin-left: 25rem !important;
    margin-right: 25rem !important;
  }

  .mx-xl-52 {
    margin-left: 25.5rem !important;
    margin-right: 25.5rem !important;
  }

  .mx-xl-53 {
    margin-left: 26rem !important;
    margin-right: 26rem !important;
  }

  .mx-xl-54 {
    margin-left: 26.5rem !important;
    margin-right: 26.5rem !important;
  }

  .mx-xl-55 {
    margin-left: 27rem !important;
    margin-right: 27rem !important;
  }

  .mx-xl-56 {
    margin-left: 27.5rem !important;
    margin-right: 27.5rem !important;
  }

  .mx-xl-57 {
    margin-left: 28rem !important;
    margin-right: 28rem !important;
  }

  .mx-xl-58 {
    margin-left: 28.5rem !important;
    margin-right: 28.5rem !important;
  }

  .mx-xl-59 {
    margin-left: 29rem !important;
    margin-right: 29rem !important;
  }

  .mx-xl-60 {
    margin-left: 29.5rem !important;
    margin-right: 29.5rem !important;
  }

  .mx-xl-61 {
    margin-left: 30rem !important;
    margin-right: 30rem !important;
  }

  .mx-xl-62 {
    margin-left: 30.5rem !important;
    margin-right: 30.5rem !important;
  }

  .mx-xl-63 {
    margin-left: 31rem !important;
    margin-right: 31rem !important;
  }

  .mx-xl-64 {
    margin-left: 31.5rem !important;
    margin-right: 31.5rem !important;
  }

  .mx-xl-65 {
    margin-left: 32rem !important;
    margin-right: 32rem !important;
  }

  .mx-xl-66 {
    margin-left: 32.5rem !important;
    margin-right: 32.5rem !important;
  }

  .mx-xl-67 {
    margin-left: 33rem !important;
    margin-right: 33rem !important;
  }

  .mx-xl-68 {
    margin-left: 33.5rem !important;
    margin-right: 33.5rem !important;
  }

  .mx-xl-69 {
    margin-left: 34rem !important;
    margin-right: 34rem !important;
  }

  .mx-xl-70 {
    margin-left: 34.5rem !important;
    margin-right: 34.5rem !important;
  }

  .mx-xl-71 {
    margin-left: 35rem !important;
    margin-right: 35rem !important;
  }

  .mx-xl-72 {
    margin-left: 35.5rem !important;
    margin-right: 35.5rem !important;
  }

  .mx-xl-73 {
    margin-left: 36rem !important;
    margin-right: 36rem !important;
  }

  .mx-xl-74 {
    margin-left: 36.5rem !important;
    margin-right: 36.5rem !important;
  }

  .mx-xl-75 {
    margin-left: 37rem !important;
    margin-right: 37rem !important;
  }

  .mx-xl-76 {
    margin-left: 37.5rem !important;
    margin-right: 37.5rem !important;
  }

  .mx-xl-77 {
    margin-left: 38rem !important;
    margin-right: 38rem !important;
  }

  .mx-xl-78 {
    margin-left: 38.5rem !important;
    margin-right: 38.5rem !important;
  }

  .mx-xl-79 {
    margin-left: 39rem !important;
    margin-right: 39rem !important;
  }

  .mx-xl-80 {
    margin-left: 39.5rem !important;
    margin-right: 39.5rem !important;
  }

  .mx-xl-81 {
    margin-left: 40rem !important;
    margin-right: 40rem !important;
  }

  .mx-xl-82 {
    margin-left: 40.5rem !important;
    margin-right: 40.5rem !important;
  }

  .mx-xl-83 {
    margin-left: 41rem !important;
    margin-right: 41rem !important;
  }

  .mx-xl-84 {
    margin-left: 41.5rem !important;
    margin-right: 41.5rem !important;
  }

  .mx-xl-85 {
    margin-left: 42rem !important;
    margin-right: 42rem !important;
  }

  .mx-xl-86 {
    margin-left: 42.5rem !important;
    margin-right: 42.5rem !important;
  }

  .mx-xl-87 {
    margin-left: 43rem !important;
    margin-right: 43rem !important;
  }

  .mx-xl-88 {
    margin-left: 43.5rem !important;
    margin-right: 43.5rem !important;
  }

  .mx-xl-89 {
    margin-left: 44rem !important;
    margin-right: 44rem !important;
  }

  .mx-xl-90 {
    margin-left: 44.5rem !important;
    margin-right: 44.5rem !important;
  }

  .mx-xl-91 {
    margin-left: 45rem !important;
    margin-right: 45rem !important;
  }

  .mx-xl-92 {
    margin-left: 45.5rem !important;
    margin-right: 45.5rem !important;
  }

  .mx-xl-93 {
    margin-left: 46rem !important;
    margin-right: 46rem !important;
  }

  .mx-xl-94 {
    margin-left: 46.5rem !important;
    margin-right: 46.5rem !important;
  }

  .mx-xl-95 {
    margin-left: 47rem !important;
    margin-right: 47rem !important;
  }

  .mx-xl-96 {
    margin-left: 47.5rem !important;
    margin-right: 47.5rem !important;
  }

  .mx-xl-97 {
    margin-left: 48rem !important;
    margin-right: 48rem !important;
  }

  .mx-xl-98 {
    margin-left: 48.5rem !important;
    margin-right: 48.5rem !important;
  }

  .mx-xl-99 {
    margin-left: 49rem !important;
    margin-right: 49rem !important;
  }

  .mx-xl-100 {
    margin-left: 49.5rem !important;
    margin-right: 49.5rem !important;
  }

  .mx-xl-101 {
    margin-left: 50rem !important;
    margin-right: 50rem !important;
  }

  .mx-xl-102 {
    margin-left: 50.5rem !important;
    margin-right: 50.5rem !important;
  }

  .mx-xl-103 {
    margin-left: 51rem !important;
    margin-right: 51rem !important;
  }

  .mx-xl-104 {
    margin-left: 51.5rem !important;
    margin-right: 51.5rem !important;
  }

  .mx-xl-105 {
    margin-left: 52rem !important;
    margin-right: 52rem !important;
  }

  .mx-xl-106 {
    margin-left: 52.5rem !important;
    margin-right: 52.5rem !important;
  }

  .mx-xl-107 {
    margin-left: 53rem !important;
    margin-right: 53rem !important;
  }

  .mx-xl-108 {
    margin-left: 53.5rem !important;
    margin-right: 53.5rem !important;
  }

  .mx-xl-109 {
    margin-left: 54rem !important;
    margin-right: 54rem !important;
  }

  .mx-xl-110 {
    margin-left: 54.5rem !important;
    margin-right: 54.5rem !important;
  }

  .mx-xl-111 {
    margin-left: 55rem !important;
    margin-right: 55rem !important;
  }

  .mx-xl-112 {
    margin-left: 55.5rem !important;
    margin-right: 55.5rem !important;
  }

  .mx-xl-113 {
    margin-left: 56rem !important;
    margin-right: 56rem !important;
  }

  .mx-xl-114 {
    margin-left: 56.5rem !important;
    margin-right: 56.5rem !important;
  }

  .mx-xl-115 {
    margin-left: 57rem !important;
    margin-right: 57rem !important;
  }

  .mx-xl-116 {
    margin-left: 57.5rem !important;
    margin-right: 57.5rem !important;
  }

  .mx-xl-117 {
    margin-left: 58rem !important;
    margin-right: 58rem !important;
  }

  .mx-xl-118 {
    margin-left: 58.5rem !important;
    margin-right: 58.5rem !important;
  }

  .mx-xl-119 {
    margin-left: 59rem !important;
    margin-right: 59rem !important;
  }

  .mx-xl-120 {
    margin-left: 59.5rem !important;
    margin-right: 59.5rem !important;
  }

  .mx-xl-121 {
    margin-left: 60rem !important;
    margin-right: 60rem !important;
  }

  .mx-xl-122 {
    margin-left: 60.5rem !important;
    margin-right: 60.5rem !important;
  }

  .mx-xl-123 {
    margin-left: 61rem !important;
    margin-right: 61rem !important;
  }

  .mx-xl-124 {
    margin-left: 61.5rem !important;
    margin-right: 61.5rem !important;
  }

  .mx-xl-125 {
    margin-left: 62rem !important;
    margin-right: 62rem !important;
  }

  .mx-xl-126 {
    margin-left: 62.5rem !important;
    margin-right: 62.5rem !important;
  }

  .mx-xl-127 {
    margin-left: 63rem !important;
    margin-right: 63rem !important;
  }

  .mx-xl-128 {
    margin-left: 63.5rem !important;
    margin-right: 63.5rem !important;
  }

  .mx-xl-129 {
    margin-left: 64rem !important;
    margin-right: 64rem !important;
  }

  .mx-xl-130 {
    margin-left: 64.5rem !important;
    margin-right: 64.5rem !important;
  }

  .mx-xl-131 {
    margin-left: 65rem !important;
    margin-right: 65rem !important;
  }

  .mx-xl-132 {
    margin-left: 65.5rem !important;
    margin-right: 65.5rem !important;
  }

  .mx-xl-133 {
    margin-left: 66rem !important;
    margin-right: 66rem !important;
  }

  .mx-xl-134 {
    margin-left: 66.5rem !important;
    margin-right: 66.5rem !important;
  }

  .mx-xl-135 {
    margin-left: 67rem !important;
    margin-right: 67rem !important;
  }

  .mx-xl-136 {
    margin-left: 67.5rem !important;
    margin-right: 67.5rem !important;
  }

  .mx-xl-137 {
    margin-left: 68rem !important;
    margin-right: 68rem !important;
  }

  .mx-xl-138 {
    margin-left: 68.5rem !important;
    margin-right: 68.5rem !important;
  }

  .mx-xl-139 {
    margin-left: 69rem !important;
    margin-right: 69rem !important;
  }

  .mx-xl-140 {
    margin-left: 69.5rem !important;
    margin-right: 69.5rem !important;
  }

  .mx-xl-141 {
    margin-left: 70rem !important;
    margin-right: 70rem !important;
  }

  .mx-xl-142 {
    margin-left: 70.5rem !important;
    margin-right: 70.5rem !important;
  }

  .mx-xl-143 {
    margin-left: 71rem !important;
    margin-right: 71rem !important;
  }

  .mx-xl-144 {
    margin-left: 71.5rem !important;
    margin-right: 71.5rem !important;
  }

  .mx-xl-145 {
    margin-left: 72rem !important;
    margin-right: 72rem !important;
  }

  .mx-xl-146 {
    margin-left: 72.5rem !important;
    margin-right: 72.5rem !important;
  }

  .mx-xl-147 {
    margin-left: 73rem !important;
    margin-right: 73rem !important;
  }

  .mx-xl-148 {
    margin-left: 73.5rem !important;
    margin-right: 73.5rem !important;
  }

  .mx-xl-149 {
    margin-left: 74rem !important;
    margin-right: 74rem !important;
  }

  .mx-xl-150 {
    margin-left: 74.5rem !important;
    margin-right: 74.5rem !important;
  }

  .mx-xl-151 {
    margin-left: 75rem !important;
    margin-right: 75rem !important;
  }

  .mx-xl-152 {
    margin-left: 75.5rem !important;
    margin-right: 75.5rem !important;
  }

  .mx-xl-153 {
    margin-left: 76rem !important;
    margin-right: 76rem !important;
  }

  .mx-xl-154 {
    margin-left: 76.5rem !important;
    margin-right: 76.5rem !important;
  }

  .mx-xl-155 {
    margin-left: 77rem !important;
    margin-right: 77rem !important;
  }

  .mx-xl-156 {
    margin-left: 77.5rem !important;
    margin-right: 77.5rem !important;
  }

  .mx-xl-157 {
    margin-left: 78rem !important;
    margin-right: 78rem !important;
  }

  .mx-xl-158 {
    margin-left: 78.5rem !important;
    margin-right: 78.5rem !important;
  }

  .mx-xl-159 {
    margin-left: 79rem !important;
    margin-right: 79rem !important;
  }

  .mx-xl-160 {
    margin-left: 79.5rem !important;
    margin-right: 79.5rem !important;
  }

  .my-xl-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xl-6 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xl-7 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-8 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xl-9 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xl-10 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xl-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xl-12 {
    margin-top: 5.5rem !important;
    margin-bottom: 5.5rem !important;
  }

  .my-xl-13 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  .my-xl-14 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }

  .my-xl-15 {
    margin-top: 7rem !important;
    margin-bottom: 7rem !important;
  }

  .my-xl-16 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }

  .my-xl-17 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  .my-xl-18 {
    margin-top: 8.5rem !important;
    margin-bottom: 8.5rem !important;
  }

  .my-xl-19 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }

  .my-xl-20 {
    margin-top: 9.5rem !important;
    margin-bottom: 9.5rem !important;
  }

  .my-xl-21 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }

  .my-xl-22 {
    margin-top: 10.5rem !important;
    margin-bottom: 10.5rem !important;
  }

  .my-xl-23 {
    margin-top: 11rem !important;
    margin-bottom: 11rem !important;
  }

  .my-xl-24 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }

  .my-xl-25 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }

  .my-xl-26 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }

  .my-xl-27 {
    margin-top: 13rem !important;
    margin-bottom: 13rem !important;
  }

  .my-xl-28 {
    margin-top: 13.5rem !important;
    margin-bottom: 13.5rem !important;
  }

  .my-xl-29 {
    margin-top: 14rem !important;
    margin-bottom: 14rem !important;
  }

  .my-xl-30 {
    margin-top: 14.5rem !important;
    margin-bottom: 14.5rem !important;
  }

  .my-xl-31 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }

  .my-xl-32 {
    margin-top: 15.5rem !important;
    margin-bottom: 15.5rem !important;
  }

  .my-xl-33 {
    margin-top: 16rem !important;
    margin-bottom: 16rem !important;
  }

  .my-xl-34 {
    margin-top: 16.5rem !important;
    margin-bottom: 16.5rem !important;
  }

  .my-xl-35 {
    margin-top: 17rem !important;
    margin-bottom: 17rem !important;
  }

  .my-xl-36 {
    margin-top: 17.5rem !important;
    margin-bottom: 17.5rem !important;
  }

  .my-xl-37 {
    margin-top: 18rem !important;
    margin-bottom: 18rem !important;
  }

  .my-xl-38 {
    margin-top: 18.5rem !important;
    margin-bottom: 18.5rem !important;
  }

  .my-xl-39 {
    margin-top: 19rem !important;
    margin-bottom: 19rem !important;
  }

  .my-xl-40 {
    margin-top: 19.5rem !important;
    margin-bottom: 19.5rem !important;
  }

  .my-xl-41 {
    margin-top: 20rem !important;
    margin-bottom: 20rem !important;
  }

  .my-xl-42 {
    margin-top: 20.5rem !important;
    margin-bottom: 20.5rem !important;
  }

  .my-xl-43 {
    margin-top: 21rem !important;
    margin-bottom: 21rem !important;
  }

  .my-xl-44 {
    margin-top: 21.5rem !important;
    margin-bottom: 21.5rem !important;
  }

  .my-xl-45 {
    margin-top: 22rem !important;
    margin-bottom: 22rem !important;
  }

  .my-xl-46 {
    margin-top: 22.5rem !important;
    margin-bottom: 22.5rem !important;
  }

  .my-xl-47 {
    margin-top: 23rem !important;
    margin-bottom: 23rem !important;
  }

  .my-xl-48 {
    margin-top: 23.5rem !important;
    margin-bottom: 23.5rem !important;
  }

  .my-xl-49 {
    margin-top: 24rem !important;
    margin-bottom: 24rem !important;
  }

  .my-xl-50 {
    margin-top: 24.5rem !important;
    margin-bottom: 24.5rem !important;
  }

  .my-xl-51 {
    margin-top: 25rem !important;
    margin-bottom: 25rem !important;
  }

  .my-xl-52 {
    margin-top: 25.5rem !important;
    margin-bottom: 25.5rem !important;
  }

  .my-xl-53 {
    margin-top: 26rem !important;
    margin-bottom: 26rem !important;
  }

  .my-xl-54 {
    margin-top: 26.5rem !important;
    margin-bottom: 26.5rem !important;
  }

  .my-xl-55 {
    margin-top: 27rem !important;
    margin-bottom: 27rem !important;
  }

  .my-xl-56 {
    margin-top: 27.5rem !important;
    margin-bottom: 27.5rem !important;
  }

  .my-xl-57 {
    margin-top: 28rem !important;
    margin-bottom: 28rem !important;
  }

  .my-xl-58 {
    margin-top: 28.5rem !important;
    margin-bottom: 28.5rem !important;
  }

  .my-xl-59 {
    margin-top: 29rem !important;
    margin-bottom: 29rem !important;
  }

  .my-xl-60 {
    margin-top: 29.5rem !important;
    margin-bottom: 29.5rem !important;
  }

  .my-xl-61 {
    margin-top: 30rem !important;
    margin-bottom: 30rem !important;
  }

  .my-xl-62 {
    margin-top: 30.5rem !important;
    margin-bottom: 30.5rem !important;
  }

  .my-xl-63 {
    margin-top: 31rem !important;
    margin-bottom: 31rem !important;
  }

  .my-xl-64 {
    margin-top: 31.5rem !important;
    margin-bottom: 31.5rem !important;
  }

  .my-xl-65 {
    margin-top: 32rem !important;
    margin-bottom: 32rem !important;
  }

  .my-xl-66 {
    margin-top: 32.5rem !important;
    margin-bottom: 32.5rem !important;
  }

  .my-xl-67 {
    margin-top: 33rem !important;
    margin-bottom: 33rem !important;
  }

  .my-xl-68 {
    margin-top: 33.5rem !important;
    margin-bottom: 33.5rem !important;
  }

  .my-xl-69 {
    margin-top: 34rem !important;
    margin-bottom: 34rem !important;
  }

  .my-xl-70 {
    margin-top: 34.5rem !important;
    margin-bottom: 34.5rem !important;
  }

  .my-xl-71 {
    margin-top: 35rem !important;
    margin-bottom: 35rem !important;
  }

  .my-xl-72 {
    margin-top: 35.5rem !important;
    margin-bottom: 35.5rem !important;
  }

  .my-xl-73 {
    margin-top: 36rem !important;
    margin-bottom: 36rem !important;
  }

  .my-xl-74 {
    margin-top: 36.5rem !important;
    margin-bottom: 36.5rem !important;
  }

  .my-xl-75 {
    margin-top: 37rem !important;
    margin-bottom: 37rem !important;
  }

  .my-xl-76 {
    margin-top: 37.5rem !important;
    margin-bottom: 37.5rem !important;
  }

  .my-xl-77 {
    margin-top: 38rem !important;
    margin-bottom: 38rem !important;
  }

  .my-xl-78 {
    margin-top: 38.5rem !important;
    margin-bottom: 38.5rem !important;
  }

  .my-xl-79 {
    margin-top: 39rem !important;
    margin-bottom: 39rem !important;
  }

  .my-xl-80 {
    margin-top: 39.5rem !important;
    margin-bottom: 39.5rem !important;
  }

  .my-xl-81 {
    margin-top: 40rem !important;
    margin-bottom: 40rem !important;
  }

  .my-xl-82 {
    margin-top: 40.5rem !important;
    margin-bottom: 40.5rem !important;
  }

  .my-xl-83 {
    margin-top: 41rem !important;
    margin-bottom: 41rem !important;
  }

  .my-xl-84 {
    margin-top: 41.5rem !important;
    margin-bottom: 41.5rem !important;
  }

  .my-xl-85 {
    margin-top: 42rem !important;
    margin-bottom: 42rem !important;
  }

  .my-xl-86 {
    margin-top: 42.5rem !important;
    margin-bottom: 42.5rem !important;
  }

  .my-xl-87 {
    margin-top: 43rem !important;
    margin-bottom: 43rem !important;
  }

  .my-xl-88 {
    margin-top: 43.5rem !important;
    margin-bottom: 43.5rem !important;
  }

  .my-xl-89 {
    margin-top: 44rem !important;
    margin-bottom: 44rem !important;
  }

  .my-xl-90 {
    margin-top: 44.5rem !important;
    margin-bottom: 44.5rem !important;
  }

  .my-xl-91 {
    margin-top: 45rem !important;
    margin-bottom: 45rem !important;
  }

  .my-xl-92 {
    margin-top: 45.5rem !important;
    margin-bottom: 45.5rem !important;
  }

  .my-xl-93 {
    margin-top: 46rem !important;
    margin-bottom: 46rem !important;
  }

  .my-xl-94 {
    margin-top: 46.5rem !important;
    margin-bottom: 46.5rem !important;
  }

  .my-xl-95 {
    margin-top: 47rem !important;
    margin-bottom: 47rem !important;
  }

  .my-xl-96 {
    margin-top: 47.5rem !important;
    margin-bottom: 47.5rem !important;
  }

  .my-xl-97 {
    margin-top: 48rem !important;
    margin-bottom: 48rem !important;
  }

  .my-xl-98 {
    margin-top: 48.5rem !important;
    margin-bottom: 48.5rem !important;
  }

  .my-xl-99 {
    margin-top: 49rem !important;
    margin-bottom: 49rem !important;
  }

  .my-xl-100 {
    margin-top: 49.5rem !important;
    margin-bottom: 49.5rem !important;
  }

  .my-xl-101 {
    margin-top: 50rem !important;
    margin-bottom: 50rem !important;
  }

  .my-xl-102 {
    margin-top: 50.5rem !important;
    margin-bottom: 50.5rem !important;
  }

  .my-xl-103 {
    margin-top: 51rem !important;
    margin-bottom: 51rem !important;
  }

  .my-xl-104 {
    margin-top: 51.5rem !important;
    margin-bottom: 51.5rem !important;
  }

  .my-xl-105 {
    margin-top: 52rem !important;
    margin-bottom: 52rem !important;
  }

  .my-xl-106 {
    margin-top: 52.5rem !important;
    margin-bottom: 52.5rem !important;
  }

  .my-xl-107 {
    margin-top: 53rem !important;
    margin-bottom: 53rem !important;
  }

  .my-xl-108 {
    margin-top: 53.5rem !important;
    margin-bottom: 53.5rem !important;
  }

  .my-xl-109 {
    margin-top: 54rem !important;
    margin-bottom: 54rem !important;
  }

  .my-xl-110 {
    margin-top: 54.5rem !important;
    margin-bottom: 54.5rem !important;
  }

  .my-xl-111 {
    margin-top: 55rem !important;
    margin-bottom: 55rem !important;
  }

  .my-xl-112 {
    margin-top: 55.5rem !important;
    margin-bottom: 55.5rem !important;
  }

  .my-xl-113 {
    margin-top: 56rem !important;
    margin-bottom: 56rem !important;
  }

  .my-xl-114 {
    margin-top: 56.5rem !important;
    margin-bottom: 56.5rem !important;
  }

  .my-xl-115 {
    margin-top: 57rem !important;
    margin-bottom: 57rem !important;
  }

  .my-xl-116 {
    margin-top: 57.5rem !important;
    margin-bottom: 57.5rem !important;
  }

  .my-xl-117 {
    margin-top: 58rem !important;
    margin-bottom: 58rem !important;
  }

  .my-xl-118 {
    margin-top: 58.5rem !important;
    margin-bottom: 58.5rem !important;
  }

  .my-xl-119 {
    margin-top: 59rem !important;
    margin-bottom: 59rem !important;
  }

  .my-xl-120 {
    margin-top: 59.5rem !important;
    margin-bottom: 59.5rem !important;
  }

  .my-xl-121 {
    margin-top: 60rem !important;
    margin-bottom: 60rem !important;
  }

  .my-xl-122 {
    margin-top: 60.5rem !important;
    margin-bottom: 60.5rem !important;
  }

  .my-xl-123 {
    margin-top: 61rem !important;
    margin-bottom: 61rem !important;
  }

  .my-xl-124 {
    margin-top: 61.5rem !important;
    margin-bottom: 61.5rem !important;
  }

  .my-xl-125 {
    margin-top: 62rem !important;
    margin-bottom: 62rem !important;
  }

  .my-xl-126 {
    margin-top: 62.5rem !important;
    margin-bottom: 62.5rem !important;
  }

  .my-xl-127 {
    margin-top: 63rem !important;
    margin-bottom: 63rem !important;
  }

  .my-xl-128 {
    margin-top: 63.5rem !important;
    margin-bottom: 63.5rem !important;
  }

  .my-xl-129 {
    margin-top: 64rem !important;
    margin-bottom: 64rem !important;
  }

  .my-xl-130 {
    margin-top: 64.5rem !important;
    margin-bottom: 64.5rem !important;
  }

  .my-xl-131 {
    margin-top: 65rem !important;
    margin-bottom: 65rem !important;
  }

  .my-xl-132 {
    margin-top: 65.5rem !important;
    margin-bottom: 65.5rem !important;
  }

  .my-xl-133 {
    margin-top: 66rem !important;
    margin-bottom: 66rem !important;
  }

  .my-xl-134 {
    margin-top: 66.5rem !important;
    margin-bottom: 66.5rem !important;
  }

  .my-xl-135 {
    margin-top: 67rem !important;
    margin-bottom: 67rem !important;
  }

  .my-xl-136 {
    margin-top: 67.5rem !important;
    margin-bottom: 67.5rem !important;
  }

  .my-xl-137 {
    margin-top: 68rem !important;
    margin-bottom: 68rem !important;
  }

  .my-xl-138 {
    margin-top: 68.5rem !important;
    margin-bottom: 68.5rem !important;
  }

  .my-xl-139 {
    margin-top: 69rem !important;
    margin-bottom: 69rem !important;
  }

  .my-xl-140 {
    margin-top: 69.5rem !important;
    margin-bottom: 69.5rem !important;
  }

  .my-xl-141 {
    margin-top: 70rem !important;
    margin-bottom: 70rem !important;
  }

  .my-xl-142 {
    margin-top: 70.5rem !important;
    margin-bottom: 70.5rem !important;
  }

  .my-xl-143 {
    margin-top: 71rem !important;
    margin-bottom: 71rem !important;
  }

  .my-xl-144 {
    margin-top: 71.5rem !important;
    margin-bottom: 71.5rem !important;
  }

  .my-xl-145 {
    margin-top: 72rem !important;
    margin-bottom: 72rem !important;
  }

  .my-xl-146 {
    margin-top: 72.5rem !important;
    margin-bottom: 72.5rem !important;
  }

  .my-xl-147 {
    margin-top: 73rem !important;
    margin-bottom: 73rem !important;
  }

  .my-xl-148 {
    margin-top: 73.5rem !important;
    margin-bottom: 73.5rem !important;
  }

  .my-xl-149 {
    margin-top: 74rem !important;
    margin-bottom: 74rem !important;
  }

  .my-xl-150 {
    margin-top: 74.5rem !important;
    margin-bottom: 74.5rem !important;
  }

  .my-xl-151 {
    margin-top: 75rem !important;
    margin-bottom: 75rem !important;
  }

  .my-xl-152 {
    margin-top: 75.5rem !important;
    margin-bottom: 75.5rem !important;
  }

  .my-xl-153 {
    margin-top: 76rem !important;
    margin-bottom: 76rem !important;
  }

  .my-xl-154 {
    margin-top: 76.5rem !important;
    margin-bottom: 76.5rem !important;
  }

  .my-xl-155 {
    margin-top: 77rem !important;
    margin-bottom: 77rem !important;
  }

  .my-xl-156 {
    margin-top: 77.5rem !important;
    margin-bottom: 77.5rem !important;
  }

  .my-xl-157 {
    margin-top: 78rem !important;
    margin-bottom: 78rem !important;
  }

  .my-xl-158 {
    margin-top: 78.5rem !important;
    margin-bottom: 78.5rem !important;
  }

  .my-xl-159 {
    margin-top: 79rem !important;
    margin-bottom: 79rem !important;
  }

  .my-xl-160 {
    margin-top: 79.5rem !important;
    margin-bottom: 79.5rem !important;
  }
}
@media (min-width: 1400px) {
  .m-xxl-0 {
    margin: 0rem !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 1rem !important;
  }

  .m-xxl-4 {
    margin: 1.5rem !important;
  }

  .m-xxl-5 {
    margin: 2rem !important;
  }

  .m-xxl-6 {
    margin: 2.5rem !important;
  }

  .m-xxl-7 {
    margin: 3rem !important;
  }

  .m-xxl-8 {
    margin: 3.5rem !important;
  }

  .m-xxl-9 {
    margin: 4rem !important;
  }

  .m-xxl-10 {
    margin: 4.5rem !important;
  }

  .m-xxl-11 {
    margin: 5rem !important;
  }

  .m-xxl-12 {
    margin: 5.5rem !important;
  }

  .m-xxl-13 {
    margin: 6rem !important;
  }

  .m-xxl-14 {
    margin: 6.5rem !important;
  }

  .m-xxl-15 {
    margin: 7rem !important;
  }

  .m-xxl-16 {
    margin: 7.5rem !important;
  }

  .m-xxl-17 {
    margin: 8rem !important;
  }

  .m-xxl-18 {
    margin: 8.5rem !important;
  }

  .m-xxl-19 {
    margin: 9rem !important;
  }

  .m-xxl-20 {
    margin: 9.5rem !important;
  }

  .m-xxl-21 {
    margin: 10rem !important;
  }

  .m-xxl-22 {
    margin: 10.5rem !important;
  }

  .m-xxl-23 {
    margin: 11rem !important;
  }

  .m-xxl-24 {
    margin: 11.5rem !important;
  }

  .m-xxl-25 {
    margin: 12rem !important;
  }

  .m-xxl-26 {
    margin: 12.5rem !important;
  }

  .m-xxl-27 {
    margin: 13rem !important;
  }

  .m-xxl-28 {
    margin: 13.5rem !important;
  }

  .m-xxl-29 {
    margin: 14rem !important;
  }

  .m-xxl-30 {
    margin: 14.5rem !important;
  }

  .m-xxl-31 {
    margin: 15rem !important;
  }

  .m-xxl-32 {
    margin: 15.5rem !important;
  }

  .m-xxl-33 {
    margin: 16rem !important;
  }

  .m-xxl-34 {
    margin: 16.5rem !important;
  }

  .m-xxl-35 {
    margin: 17rem !important;
  }

  .m-xxl-36 {
    margin: 17.5rem !important;
  }

  .m-xxl-37 {
    margin: 18rem !important;
  }

  .m-xxl-38 {
    margin: 18.5rem !important;
  }

  .m-xxl-39 {
    margin: 19rem !important;
  }

  .m-xxl-40 {
    margin: 19.5rem !important;
  }

  .m-xxl-41 {
    margin: 20rem !important;
  }

  .m-xxl-42 {
    margin: 20.5rem !important;
  }

  .m-xxl-43 {
    margin: 21rem !important;
  }

  .m-xxl-44 {
    margin: 21.5rem !important;
  }

  .m-xxl-45 {
    margin: 22rem !important;
  }

  .m-xxl-46 {
    margin: 22.5rem !important;
  }

  .m-xxl-47 {
    margin: 23rem !important;
  }

  .m-xxl-48 {
    margin: 23.5rem !important;
  }

  .m-xxl-49 {
    margin: 24rem !important;
  }

  .m-xxl-50 {
    margin: 24.5rem !important;
  }

  .m-xxl-51 {
    margin: 25rem !important;
  }

  .m-xxl-52 {
    margin: 25.5rem !important;
  }

  .m-xxl-53 {
    margin: 26rem !important;
  }

  .m-xxl-54 {
    margin: 26.5rem !important;
  }

  .m-xxl-55 {
    margin: 27rem !important;
  }

  .m-xxl-56 {
    margin: 27.5rem !important;
  }

  .m-xxl-57 {
    margin: 28rem !important;
  }

  .m-xxl-58 {
    margin: 28.5rem !important;
  }

  .m-xxl-59 {
    margin: 29rem !important;
  }

  .m-xxl-60 {
    margin: 29.5rem !important;
  }

  .m-xxl-61 {
    margin: 30rem !important;
  }

  .m-xxl-62 {
    margin: 30.5rem !important;
  }

  .m-xxl-63 {
    margin: 31rem !important;
  }

  .m-xxl-64 {
    margin: 31.5rem !important;
  }

  .m-xxl-65 {
    margin: 32rem !important;
  }

  .m-xxl-66 {
    margin: 32.5rem !important;
  }

  .m-xxl-67 {
    margin: 33rem !important;
  }

  .m-xxl-68 {
    margin: 33.5rem !important;
  }

  .m-xxl-69 {
    margin: 34rem !important;
  }

  .m-xxl-70 {
    margin: 34.5rem !important;
  }

  .m-xxl-71 {
    margin: 35rem !important;
  }

  .m-xxl-72 {
    margin: 35.5rem !important;
  }

  .m-xxl-73 {
    margin: 36rem !important;
  }

  .m-xxl-74 {
    margin: 36.5rem !important;
  }

  .m-xxl-75 {
    margin: 37rem !important;
  }

  .m-xxl-76 {
    margin: 37.5rem !important;
  }

  .m-xxl-77 {
    margin: 38rem !important;
  }

  .m-xxl-78 {
    margin: 38.5rem !important;
  }

  .m-xxl-79 {
    margin: 39rem !important;
  }

  .m-xxl-80 {
    margin: 39.5rem !important;
  }

  .m-xxl-81 {
    margin: 40rem !important;
  }

  .m-xxl-82 {
    margin: 40.5rem !important;
  }

  .m-xxl-83 {
    margin: 41rem !important;
  }

  .m-xxl-84 {
    margin: 41.5rem !important;
  }

  .m-xxl-85 {
    margin: 42rem !important;
  }

  .m-xxl-86 {
    margin: 42.5rem !important;
  }

  .m-xxl-87 {
    margin: 43rem !important;
  }

  .m-xxl-88 {
    margin: 43.5rem !important;
  }

  .m-xxl-89 {
    margin: 44rem !important;
  }

  .m-xxl-90 {
    margin: 44.5rem !important;
  }

  .m-xxl-91 {
    margin: 45rem !important;
  }

  .m-xxl-92 {
    margin: 45.5rem !important;
  }

  .m-xxl-93 {
    margin: 46rem !important;
  }

  .m-xxl-94 {
    margin: 46.5rem !important;
  }

  .m-xxl-95 {
    margin: 47rem !important;
  }

  .m-xxl-96 {
    margin: 47.5rem !important;
  }

  .m-xxl-97 {
    margin: 48rem !important;
  }

  .m-xxl-98 {
    margin: 48.5rem !important;
  }

  .m-xxl-99 {
    margin: 49rem !important;
  }

  .m-xxl-100 {
    margin: 49.5rem !important;
  }

  .m-xxl-101 {
    margin: 50rem !important;
  }

  .m-xxl-102 {
    margin: 50.5rem !important;
  }

  .m-xxl-103 {
    margin: 51rem !important;
  }

  .m-xxl-104 {
    margin: 51.5rem !important;
  }

  .m-xxl-105 {
    margin: 52rem !important;
  }

  .m-xxl-106 {
    margin: 52.5rem !important;
  }

  .m-xxl-107 {
    margin: 53rem !important;
  }

  .m-xxl-108 {
    margin: 53.5rem !important;
  }

  .m-xxl-109 {
    margin: 54rem !important;
  }

  .m-xxl-110 {
    margin: 54.5rem !important;
  }

  .m-xxl-111 {
    margin: 55rem !important;
  }

  .m-xxl-112 {
    margin: 55.5rem !important;
  }

  .m-xxl-113 {
    margin: 56rem !important;
  }

  .m-xxl-114 {
    margin: 56.5rem !important;
  }

  .m-xxl-115 {
    margin: 57rem !important;
  }

  .m-xxl-116 {
    margin: 57.5rem !important;
  }

  .m-xxl-117 {
    margin: 58rem !important;
  }

  .m-xxl-118 {
    margin: 58.5rem !important;
  }

  .m-xxl-119 {
    margin: 59rem !important;
  }

  .m-xxl-120 {
    margin: 59.5rem !important;
  }

  .m-xxl-121 {
    margin: 60rem !important;
  }

  .m-xxl-122 {
    margin: 60.5rem !important;
  }

  .m-xxl-123 {
    margin: 61rem !important;
  }

  .m-xxl-124 {
    margin: 61.5rem !important;
  }

  .m-xxl-125 {
    margin: 62rem !important;
  }

  .m-xxl-126 {
    margin: 62.5rem !important;
  }

  .m-xxl-127 {
    margin: 63rem !important;
  }

  .m-xxl-128 {
    margin: 63.5rem !important;
  }

  .m-xxl-129 {
    margin: 64rem !important;
  }

  .m-xxl-130 {
    margin: 64.5rem !important;
  }

  .m-xxl-131 {
    margin: 65rem !important;
  }

  .m-xxl-132 {
    margin: 65.5rem !important;
  }

  .m-xxl-133 {
    margin: 66rem !important;
  }

  .m-xxl-134 {
    margin: 66.5rem !important;
  }

  .m-xxl-135 {
    margin: 67rem !important;
  }

  .m-xxl-136 {
    margin: 67.5rem !important;
  }

  .m-xxl-137 {
    margin: 68rem !important;
  }

  .m-xxl-138 {
    margin: 68.5rem !important;
  }

  .m-xxl-139 {
    margin: 69rem !important;
  }

  .m-xxl-140 {
    margin: 69.5rem !important;
  }

  .m-xxl-141 {
    margin: 70rem !important;
  }

  .m-xxl-142 {
    margin: 70.5rem !important;
  }

  .m-xxl-143 {
    margin: 71rem !important;
  }

  .m-xxl-144 {
    margin: 71.5rem !important;
  }

  .m-xxl-145 {
    margin: 72rem !important;
  }

  .m-xxl-146 {
    margin: 72.5rem !important;
  }

  .m-xxl-147 {
    margin: 73rem !important;
  }

  .m-xxl-148 {
    margin: 73.5rem !important;
  }

  .m-xxl-149 {
    margin: 74rem !important;
  }

  .m-xxl-150 {
    margin: 74.5rem !important;
  }

  .m-xxl-151 {
    margin: 75rem !important;
  }

  .m-xxl-152 {
    margin: 75.5rem !important;
  }

  .m-xxl-153 {
    margin: 76rem !important;
  }

  .m-xxl-154 {
    margin: 76.5rem !important;
  }

  .m-xxl-155 {
    margin: 77rem !important;
  }

  .m-xxl-156 {
    margin: 77.5rem !important;
  }

  .m-xxl-157 {
    margin: 78rem !important;
  }

  .m-xxl-158 {
    margin: 78.5rem !important;
  }

  .m-xxl-159 {
    margin: 79rem !important;
  }

  .m-xxl-160 {
    margin: 79.5rem !important;
  }

  .mt-xxl-0 {
    margin-top: 0rem !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 1rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-5 {
    margin-top: 2rem !important;
  }

  .mt-xxl-6 {
    margin-top: 2.5rem !important;
  }

  .mt-xxl-7 {
    margin-top: 3rem !important;
  }

  .mt-xxl-8 {
    margin-top: 3.5rem !important;
  }

  .mt-xxl-9 {
    margin-top: 4rem !important;
  }

  .mt-xxl-10 {
    margin-top: 4.5rem !important;
  }

  .mt-xxl-11 {
    margin-top: 5rem !important;
  }

  .mt-xxl-12 {
    margin-top: 5.5rem !important;
  }

  .mt-xxl-13 {
    margin-top: 6rem !important;
  }

  .mt-xxl-14 {
    margin-top: 6.5rem !important;
  }

  .mt-xxl-15 {
    margin-top: 7rem !important;
  }

  .mt-xxl-16 {
    margin-top: 7.5rem !important;
  }

  .mt-xxl-17 {
    margin-top: 8rem !important;
  }

  .mt-xxl-18 {
    margin-top: 8.5rem !important;
  }

  .mt-xxl-19 {
    margin-top: 9rem !important;
  }

  .mt-xxl-20 {
    margin-top: 9.5rem !important;
  }

  .mt-xxl-21 {
    margin-top: 10rem !important;
  }

  .mt-xxl-22 {
    margin-top: 10.5rem !important;
  }

  .mt-xxl-23 {
    margin-top: 11rem !important;
  }

  .mt-xxl-24 {
    margin-top: 11.5rem !important;
  }

  .mt-xxl-25 {
    margin-top: 12rem !important;
  }

  .mt-xxl-26 {
    margin-top: 12.5rem !important;
  }

  .mt-xxl-27 {
    margin-top: 13rem !important;
  }

  .mt-xxl-28 {
    margin-top: 13.5rem !important;
  }

  .mt-xxl-29 {
    margin-top: 14rem !important;
  }

  .mt-xxl-30 {
    margin-top: 14.5rem !important;
  }

  .mt-xxl-31 {
    margin-top: 15rem !important;
  }

  .mt-xxl-32 {
    margin-top: 15.5rem !important;
  }

  .mt-xxl-33 {
    margin-top: 16rem !important;
  }

  .mt-xxl-34 {
    margin-top: 16.5rem !important;
  }

  .mt-xxl-35 {
    margin-top: 17rem !important;
  }

  .mt-xxl-36 {
    margin-top: 17.5rem !important;
  }

  .mt-xxl-37 {
    margin-top: 18rem !important;
  }

  .mt-xxl-38 {
    margin-top: 18.5rem !important;
  }

  .mt-xxl-39 {
    margin-top: 19rem !important;
  }

  .mt-xxl-40 {
    margin-top: 19.5rem !important;
  }

  .mt-xxl-41 {
    margin-top: 20rem !important;
  }

  .mt-xxl-42 {
    margin-top: 20.5rem !important;
  }

  .mt-xxl-43 {
    margin-top: 21rem !important;
  }

  .mt-xxl-44 {
    margin-top: 21.5rem !important;
  }

  .mt-xxl-45 {
    margin-top: 22rem !important;
  }

  .mt-xxl-46 {
    margin-top: 22.5rem !important;
  }

  .mt-xxl-47 {
    margin-top: 23rem !important;
  }

  .mt-xxl-48 {
    margin-top: 23.5rem !important;
  }

  .mt-xxl-49 {
    margin-top: 24rem !important;
  }

  .mt-xxl-50 {
    margin-top: 24.5rem !important;
  }

  .mt-xxl-51 {
    margin-top: 25rem !important;
  }

  .mt-xxl-52 {
    margin-top: 25.5rem !important;
  }

  .mt-xxl-53 {
    margin-top: 26rem !important;
  }

  .mt-xxl-54 {
    margin-top: 26.5rem !important;
  }

  .mt-xxl-55 {
    margin-top: 27rem !important;
  }

  .mt-xxl-56 {
    margin-top: 27.5rem !important;
  }

  .mt-xxl-57 {
    margin-top: 28rem !important;
  }

  .mt-xxl-58 {
    margin-top: 28.5rem !important;
  }

  .mt-xxl-59 {
    margin-top: 29rem !important;
  }

  .mt-xxl-60 {
    margin-top: 29.5rem !important;
  }

  .mt-xxl-61 {
    margin-top: 30rem !important;
  }

  .mt-xxl-62 {
    margin-top: 30.5rem !important;
  }

  .mt-xxl-63 {
    margin-top: 31rem !important;
  }

  .mt-xxl-64 {
    margin-top: 31.5rem !important;
  }

  .mt-xxl-65 {
    margin-top: 32rem !important;
  }

  .mt-xxl-66 {
    margin-top: 32.5rem !important;
  }

  .mt-xxl-67 {
    margin-top: 33rem !important;
  }

  .mt-xxl-68 {
    margin-top: 33.5rem !important;
  }

  .mt-xxl-69 {
    margin-top: 34rem !important;
  }

  .mt-xxl-70 {
    margin-top: 34.5rem !important;
  }

  .mt-xxl-71 {
    margin-top: 35rem !important;
  }

  .mt-xxl-72 {
    margin-top: 35.5rem !important;
  }

  .mt-xxl-73 {
    margin-top: 36rem !important;
  }

  .mt-xxl-74 {
    margin-top: 36.5rem !important;
  }

  .mt-xxl-75 {
    margin-top: 37rem !important;
  }

  .mt-xxl-76 {
    margin-top: 37.5rem !important;
  }

  .mt-xxl-77 {
    margin-top: 38rem !important;
  }

  .mt-xxl-78 {
    margin-top: 38.5rem !important;
  }

  .mt-xxl-79 {
    margin-top: 39rem !important;
  }

  .mt-xxl-80 {
    margin-top: 39.5rem !important;
  }

  .mt-xxl-81 {
    margin-top: 40rem !important;
  }

  .mt-xxl-82 {
    margin-top: 40.5rem !important;
  }

  .mt-xxl-83 {
    margin-top: 41rem !important;
  }

  .mt-xxl-84 {
    margin-top: 41.5rem !important;
  }

  .mt-xxl-85 {
    margin-top: 42rem !important;
  }

  .mt-xxl-86 {
    margin-top: 42.5rem !important;
  }

  .mt-xxl-87 {
    margin-top: 43rem !important;
  }

  .mt-xxl-88 {
    margin-top: 43.5rem !important;
  }

  .mt-xxl-89 {
    margin-top: 44rem !important;
  }

  .mt-xxl-90 {
    margin-top: 44.5rem !important;
  }

  .mt-xxl-91 {
    margin-top: 45rem !important;
  }

  .mt-xxl-92 {
    margin-top: 45.5rem !important;
  }

  .mt-xxl-93 {
    margin-top: 46rem !important;
  }

  .mt-xxl-94 {
    margin-top: 46.5rem !important;
  }

  .mt-xxl-95 {
    margin-top: 47rem !important;
  }

  .mt-xxl-96 {
    margin-top: 47.5rem !important;
  }

  .mt-xxl-97 {
    margin-top: 48rem !important;
  }

  .mt-xxl-98 {
    margin-top: 48.5rem !important;
  }

  .mt-xxl-99 {
    margin-top: 49rem !important;
  }

  .mt-xxl-100 {
    margin-top: 49.5rem !important;
  }

  .mt-xxl-101 {
    margin-top: 50rem !important;
  }

  .mt-xxl-102 {
    margin-top: 50.5rem !important;
  }

  .mt-xxl-103 {
    margin-top: 51rem !important;
  }

  .mt-xxl-104 {
    margin-top: 51.5rem !important;
  }

  .mt-xxl-105 {
    margin-top: 52rem !important;
  }

  .mt-xxl-106 {
    margin-top: 52.5rem !important;
  }

  .mt-xxl-107 {
    margin-top: 53rem !important;
  }

  .mt-xxl-108 {
    margin-top: 53.5rem !important;
  }

  .mt-xxl-109 {
    margin-top: 54rem !important;
  }

  .mt-xxl-110 {
    margin-top: 54.5rem !important;
  }

  .mt-xxl-111 {
    margin-top: 55rem !important;
  }

  .mt-xxl-112 {
    margin-top: 55.5rem !important;
  }

  .mt-xxl-113 {
    margin-top: 56rem !important;
  }

  .mt-xxl-114 {
    margin-top: 56.5rem !important;
  }

  .mt-xxl-115 {
    margin-top: 57rem !important;
  }

  .mt-xxl-116 {
    margin-top: 57.5rem !important;
  }

  .mt-xxl-117 {
    margin-top: 58rem !important;
  }

  .mt-xxl-118 {
    margin-top: 58.5rem !important;
  }

  .mt-xxl-119 {
    margin-top: 59rem !important;
  }

  .mt-xxl-120 {
    margin-top: 59.5rem !important;
  }

  .mt-xxl-121 {
    margin-top: 60rem !important;
  }

  .mt-xxl-122 {
    margin-top: 60.5rem !important;
  }

  .mt-xxl-123 {
    margin-top: 61rem !important;
  }

  .mt-xxl-124 {
    margin-top: 61.5rem !important;
  }

  .mt-xxl-125 {
    margin-top: 62rem !important;
  }

  .mt-xxl-126 {
    margin-top: 62.5rem !important;
  }

  .mt-xxl-127 {
    margin-top: 63rem !important;
  }

  .mt-xxl-128 {
    margin-top: 63.5rem !important;
  }

  .mt-xxl-129 {
    margin-top: 64rem !important;
  }

  .mt-xxl-130 {
    margin-top: 64.5rem !important;
  }

  .mt-xxl-131 {
    margin-top: 65rem !important;
  }

  .mt-xxl-132 {
    margin-top: 65.5rem !important;
  }

  .mt-xxl-133 {
    margin-top: 66rem !important;
  }

  .mt-xxl-134 {
    margin-top: 66.5rem !important;
  }

  .mt-xxl-135 {
    margin-top: 67rem !important;
  }

  .mt-xxl-136 {
    margin-top: 67.5rem !important;
  }

  .mt-xxl-137 {
    margin-top: 68rem !important;
  }

  .mt-xxl-138 {
    margin-top: 68.5rem !important;
  }

  .mt-xxl-139 {
    margin-top: 69rem !important;
  }

  .mt-xxl-140 {
    margin-top: 69.5rem !important;
  }

  .mt-xxl-141 {
    margin-top: 70rem !important;
  }

  .mt-xxl-142 {
    margin-top: 70.5rem !important;
  }

  .mt-xxl-143 {
    margin-top: 71rem !important;
  }

  .mt-xxl-144 {
    margin-top: 71.5rem !important;
  }

  .mt-xxl-145 {
    margin-top: 72rem !important;
  }

  .mt-xxl-146 {
    margin-top: 72.5rem !important;
  }

  .mt-xxl-147 {
    margin-top: 73rem !important;
  }

  .mt-xxl-148 {
    margin-top: 73.5rem !important;
  }

  .mt-xxl-149 {
    margin-top: 74rem !important;
  }

  .mt-xxl-150 {
    margin-top: 74.5rem !important;
  }

  .mt-xxl-151 {
    margin-top: 75rem !important;
  }

  .mt-xxl-152 {
    margin-top: 75.5rem !important;
  }

  .mt-xxl-153 {
    margin-top: 76rem !important;
  }

  .mt-xxl-154 {
    margin-top: 76.5rem !important;
  }

  .mt-xxl-155 {
    margin-top: 77rem !important;
  }

  .mt-xxl-156 {
    margin-top: 77.5rem !important;
  }

  .mt-xxl-157 {
    margin-top: 78rem !important;
  }

  .mt-xxl-158 {
    margin-top: 78.5rem !important;
  }

  .mt-xxl-159 {
    margin-top: 79rem !important;
  }

  .mt-xxl-160 {
    margin-top: 79.5rem !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0rem !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 2rem !important;
  }

  .mb-xxl-6 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xxl-7 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-8 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xxl-9 {
    margin-bottom: 4rem !important;
  }

  .mb-xxl-10 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xxl-11 {
    margin-bottom: 5rem !important;
  }

  .mb-xxl-12 {
    margin-bottom: 5.5rem !important;
  }

  .mb-xxl-13 {
    margin-bottom: 6rem !important;
  }

  .mb-xxl-14 {
    margin-bottom: 6.5rem !important;
  }

  .mb-xxl-15 {
    margin-bottom: 7rem !important;
  }

  .mb-xxl-16 {
    margin-bottom: 7.5rem !important;
  }

  .mb-xxl-17 {
    margin-bottom: 8rem !important;
  }

  .mb-xxl-18 {
    margin-bottom: 8.5rem !important;
  }

  .mb-xxl-19 {
    margin-bottom: 9rem !important;
  }

  .mb-xxl-20 {
    margin-bottom: 9.5rem !important;
  }

  .mb-xxl-21 {
    margin-bottom: 10rem !important;
  }

  .mb-xxl-22 {
    margin-bottom: 10.5rem !important;
  }

  .mb-xxl-23 {
    margin-bottom: 11rem !important;
  }

  .mb-xxl-24 {
    margin-bottom: 11.5rem !important;
  }

  .mb-xxl-25 {
    margin-bottom: 12rem !important;
  }

  .mb-xxl-26 {
    margin-bottom: 12.5rem !important;
  }

  .mb-xxl-27 {
    margin-bottom: 13rem !important;
  }

  .mb-xxl-28 {
    margin-bottom: 13.5rem !important;
  }

  .mb-xxl-29 {
    margin-bottom: 14rem !important;
  }

  .mb-xxl-30 {
    margin-bottom: 14.5rem !important;
  }

  .mb-xxl-31 {
    margin-bottom: 15rem !important;
  }

  .mb-xxl-32 {
    margin-bottom: 15.5rem !important;
  }

  .mb-xxl-33 {
    margin-bottom: 16rem !important;
  }

  .mb-xxl-34 {
    margin-bottom: 16.5rem !important;
  }

  .mb-xxl-35 {
    margin-bottom: 17rem !important;
  }

  .mb-xxl-36 {
    margin-bottom: 17.5rem !important;
  }

  .mb-xxl-37 {
    margin-bottom: 18rem !important;
  }

  .mb-xxl-38 {
    margin-bottom: 18.5rem !important;
  }

  .mb-xxl-39 {
    margin-bottom: 19rem !important;
  }

  .mb-xxl-40 {
    margin-bottom: 19.5rem !important;
  }

  .mb-xxl-41 {
    margin-bottom: 20rem !important;
  }

  .mb-xxl-42 {
    margin-bottom: 20.5rem !important;
  }

  .mb-xxl-43 {
    margin-bottom: 21rem !important;
  }

  .mb-xxl-44 {
    margin-bottom: 21.5rem !important;
  }

  .mb-xxl-45 {
    margin-bottom: 22rem !important;
  }

  .mb-xxl-46 {
    margin-bottom: 22.5rem !important;
  }

  .mb-xxl-47 {
    margin-bottom: 23rem !important;
  }

  .mb-xxl-48 {
    margin-bottom: 23.5rem !important;
  }

  .mb-xxl-49 {
    margin-bottom: 24rem !important;
  }

  .mb-xxl-50 {
    margin-bottom: 24.5rem !important;
  }

  .mb-xxl-51 {
    margin-bottom: 25rem !important;
  }

  .mb-xxl-52 {
    margin-bottom: 25.5rem !important;
  }

  .mb-xxl-53 {
    margin-bottom: 26rem !important;
  }

  .mb-xxl-54 {
    margin-bottom: 26.5rem !important;
  }

  .mb-xxl-55 {
    margin-bottom: 27rem !important;
  }

  .mb-xxl-56 {
    margin-bottom: 27.5rem !important;
  }

  .mb-xxl-57 {
    margin-bottom: 28rem !important;
  }

  .mb-xxl-58 {
    margin-bottom: 28.5rem !important;
  }

  .mb-xxl-59 {
    margin-bottom: 29rem !important;
  }

  .mb-xxl-60 {
    margin-bottom: 29.5rem !important;
  }

  .mb-xxl-61 {
    margin-bottom: 30rem !important;
  }

  .mb-xxl-62 {
    margin-bottom: 30.5rem !important;
  }

  .mb-xxl-63 {
    margin-bottom: 31rem !important;
  }

  .mb-xxl-64 {
    margin-bottom: 31.5rem !important;
  }

  .mb-xxl-65 {
    margin-bottom: 32rem !important;
  }

  .mb-xxl-66 {
    margin-bottom: 32.5rem !important;
  }

  .mb-xxl-67 {
    margin-bottom: 33rem !important;
  }

  .mb-xxl-68 {
    margin-bottom: 33.5rem !important;
  }

  .mb-xxl-69 {
    margin-bottom: 34rem !important;
  }

  .mb-xxl-70 {
    margin-bottom: 34.5rem !important;
  }

  .mb-xxl-71 {
    margin-bottom: 35rem !important;
  }

  .mb-xxl-72 {
    margin-bottom: 35.5rem !important;
  }

  .mb-xxl-73 {
    margin-bottom: 36rem !important;
  }

  .mb-xxl-74 {
    margin-bottom: 36.5rem !important;
  }

  .mb-xxl-75 {
    margin-bottom: 37rem !important;
  }

  .mb-xxl-76 {
    margin-bottom: 37.5rem !important;
  }

  .mb-xxl-77 {
    margin-bottom: 38rem !important;
  }

  .mb-xxl-78 {
    margin-bottom: 38.5rem !important;
  }

  .mb-xxl-79 {
    margin-bottom: 39rem !important;
  }

  .mb-xxl-80 {
    margin-bottom: 39.5rem !important;
  }

  .mb-xxl-81 {
    margin-bottom: 40rem !important;
  }

  .mb-xxl-82 {
    margin-bottom: 40.5rem !important;
  }

  .mb-xxl-83 {
    margin-bottom: 41rem !important;
  }

  .mb-xxl-84 {
    margin-bottom: 41.5rem !important;
  }

  .mb-xxl-85 {
    margin-bottom: 42rem !important;
  }

  .mb-xxl-86 {
    margin-bottom: 42.5rem !important;
  }

  .mb-xxl-87 {
    margin-bottom: 43rem !important;
  }

  .mb-xxl-88 {
    margin-bottom: 43.5rem !important;
  }

  .mb-xxl-89 {
    margin-bottom: 44rem !important;
  }

  .mb-xxl-90 {
    margin-bottom: 44.5rem !important;
  }

  .mb-xxl-91 {
    margin-bottom: 45rem !important;
  }

  .mb-xxl-92 {
    margin-bottom: 45.5rem !important;
  }

  .mb-xxl-93 {
    margin-bottom: 46rem !important;
  }

  .mb-xxl-94 {
    margin-bottom: 46.5rem !important;
  }

  .mb-xxl-95 {
    margin-bottom: 47rem !important;
  }

  .mb-xxl-96 {
    margin-bottom: 47.5rem !important;
  }

  .mb-xxl-97 {
    margin-bottom: 48rem !important;
  }

  .mb-xxl-98 {
    margin-bottom: 48.5rem !important;
  }

  .mb-xxl-99 {
    margin-bottom: 49rem !important;
  }

  .mb-xxl-100 {
    margin-bottom: 49.5rem !important;
  }

  .mb-xxl-101 {
    margin-bottom: 50rem !important;
  }

  .mb-xxl-102 {
    margin-bottom: 50.5rem !important;
  }

  .mb-xxl-103 {
    margin-bottom: 51rem !important;
  }

  .mb-xxl-104 {
    margin-bottom: 51.5rem !important;
  }

  .mb-xxl-105 {
    margin-bottom: 52rem !important;
  }

  .mb-xxl-106 {
    margin-bottom: 52.5rem !important;
  }

  .mb-xxl-107 {
    margin-bottom: 53rem !important;
  }

  .mb-xxl-108 {
    margin-bottom: 53.5rem !important;
  }

  .mb-xxl-109 {
    margin-bottom: 54rem !important;
  }

  .mb-xxl-110 {
    margin-bottom: 54.5rem !important;
  }

  .mb-xxl-111 {
    margin-bottom: 55rem !important;
  }

  .mb-xxl-112 {
    margin-bottom: 55.5rem !important;
  }

  .mb-xxl-113 {
    margin-bottom: 56rem !important;
  }

  .mb-xxl-114 {
    margin-bottom: 56.5rem !important;
  }

  .mb-xxl-115 {
    margin-bottom: 57rem !important;
  }

  .mb-xxl-116 {
    margin-bottom: 57.5rem !important;
  }

  .mb-xxl-117 {
    margin-bottom: 58rem !important;
  }

  .mb-xxl-118 {
    margin-bottom: 58.5rem !important;
  }

  .mb-xxl-119 {
    margin-bottom: 59rem !important;
  }

  .mb-xxl-120 {
    margin-bottom: 59.5rem !important;
  }

  .mb-xxl-121 {
    margin-bottom: 60rem !important;
  }

  .mb-xxl-122 {
    margin-bottom: 60.5rem !important;
  }

  .mb-xxl-123 {
    margin-bottom: 61rem !important;
  }

  .mb-xxl-124 {
    margin-bottom: 61.5rem !important;
  }

  .mb-xxl-125 {
    margin-bottom: 62rem !important;
  }

  .mb-xxl-126 {
    margin-bottom: 62.5rem !important;
  }

  .mb-xxl-127 {
    margin-bottom: 63rem !important;
  }

  .mb-xxl-128 {
    margin-bottom: 63.5rem !important;
  }

  .mb-xxl-129 {
    margin-bottom: 64rem !important;
  }

  .mb-xxl-130 {
    margin-bottom: 64.5rem !important;
  }

  .mb-xxl-131 {
    margin-bottom: 65rem !important;
  }

  .mb-xxl-132 {
    margin-bottom: 65.5rem !important;
  }

  .mb-xxl-133 {
    margin-bottom: 66rem !important;
  }

  .mb-xxl-134 {
    margin-bottom: 66.5rem !important;
  }

  .mb-xxl-135 {
    margin-bottom: 67rem !important;
  }

  .mb-xxl-136 {
    margin-bottom: 67.5rem !important;
  }

  .mb-xxl-137 {
    margin-bottom: 68rem !important;
  }

  .mb-xxl-138 {
    margin-bottom: 68.5rem !important;
  }

  .mb-xxl-139 {
    margin-bottom: 69rem !important;
  }

  .mb-xxl-140 {
    margin-bottom: 69.5rem !important;
  }

  .mb-xxl-141 {
    margin-bottom: 70rem !important;
  }

  .mb-xxl-142 {
    margin-bottom: 70.5rem !important;
  }

  .mb-xxl-143 {
    margin-bottom: 71rem !important;
  }

  .mb-xxl-144 {
    margin-bottom: 71.5rem !important;
  }

  .mb-xxl-145 {
    margin-bottom: 72rem !important;
  }

  .mb-xxl-146 {
    margin-bottom: 72.5rem !important;
  }

  .mb-xxl-147 {
    margin-bottom: 73rem !important;
  }

  .mb-xxl-148 {
    margin-bottom: 73.5rem !important;
  }

  .mb-xxl-149 {
    margin-bottom: 74rem !important;
  }

  .mb-xxl-150 {
    margin-bottom: 74.5rem !important;
  }

  .mb-xxl-151 {
    margin-bottom: 75rem !important;
  }

  .mb-xxl-152 {
    margin-bottom: 75.5rem !important;
  }

  .mb-xxl-153 {
    margin-bottom: 76rem !important;
  }

  .mb-xxl-154 {
    margin-bottom: 76.5rem !important;
  }

  .mb-xxl-155 {
    margin-bottom: 77rem !important;
  }

  .mb-xxl-156 {
    margin-bottom: 77.5rem !important;
  }

  .mb-xxl-157 {
    margin-bottom: 78rem !important;
  }

  .mb-xxl-158 {
    margin-bottom: 78.5rem !important;
  }

  .mb-xxl-159 {
    margin-bottom: 79rem !important;
  }

  .mb-xxl-160 {
    margin-bottom: 79.5rem !important;
  }

  .ms-xxl-0 {
    margin-left: 0rem !important;
  }

  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xxl-3 {
    margin-left: 1rem !important;
  }

  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xxl-5 {
    margin-left: 2rem !important;
  }

  .ms-xxl-6 {
    margin-left: 2.5rem !important;
  }

  .ms-xxl-7 {
    margin-left: 3rem !important;
  }

  .ms-xxl-8 {
    margin-left: 3.5rem !important;
  }

  .ms-xxl-9 {
    margin-left: 4rem !important;
  }

  .ms-xxl-10 {
    margin-left: 4.5rem !important;
  }

  .ms-xxl-11 {
    margin-left: 5rem !important;
  }

  .ms-xxl-12 {
    margin-left: 5.5rem !important;
  }

  .ms-xxl-13 {
    margin-left: 6rem !important;
  }

  .ms-xxl-14 {
    margin-left: 6.5rem !important;
  }

  .ms-xxl-15 {
    margin-left: 7rem !important;
  }

  .ms-xxl-16 {
    margin-left: 7.5rem !important;
  }

  .ms-xxl-17 {
    margin-left: 8rem !important;
  }

  .ms-xxl-18 {
    margin-left: 8.5rem !important;
  }

  .ms-xxl-19 {
    margin-left: 9rem !important;
  }

  .ms-xxl-20 {
    margin-left: 9.5rem !important;
  }

  .ms-xxl-21 {
    margin-left: 10rem !important;
  }

  .ms-xxl-22 {
    margin-left: 10.5rem !important;
  }

  .ms-xxl-23 {
    margin-left: 11rem !important;
  }

  .ms-xxl-24 {
    margin-left: 11.5rem !important;
  }

  .ms-xxl-25 {
    margin-left: 12rem !important;
  }

  .ms-xxl-26 {
    margin-left: 12.5rem !important;
  }

  .ms-xxl-27 {
    margin-left: 13rem !important;
  }

  .ms-xxl-28 {
    margin-left: 13.5rem !important;
  }

  .ms-xxl-29 {
    margin-left: 14rem !important;
  }

  .ms-xxl-30 {
    margin-left: 14.5rem !important;
  }

  .ms-xxl-31 {
    margin-left: 15rem !important;
  }

  .ms-xxl-32 {
    margin-left: 15.5rem !important;
  }

  .ms-xxl-33 {
    margin-left: 16rem !important;
  }

  .ms-xxl-34 {
    margin-left: 16.5rem !important;
  }

  .ms-xxl-35 {
    margin-left: 17rem !important;
  }

  .ms-xxl-36 {
    margin-left: 17.5rem !important;
  }

  .ms-xxl-37 {
    margin-left: 18rem !important;
  }

  .ms-xxl-38 {
    margin-left: 18.5rem !important;
  }

  .ms-xxl-39 {
    margin-left: 19rem !important;
  }

  .ms-xxl-40 {
    margin-left: 19.5rem !important;
  }

  .ms-xxl-41 {
    margin-left: 20rem !important;
  }

  .ms-xxl-42 {
    margin-left: 20.5rem !important;
  }

  .ms-xxl-43 {
    margin-left: 21rem !important;
  }

  .ms-xxl-44 {
    margin-left: 21.5rem !important;
  }

  .ms-xxl-45 {
    margin-left: 22rem !important;
  }

  .ms-xxl-46 {
    margin-left: 22.5rem !important;
  }

  .ms-xxl-47 {
    margin-left: 23rem !important;
  }

  .ms-xxl-48 {
    margin-left: 23.5rem !important;
  }

  .ms-xxl-49 {
    margin-left: 24rem !important;
  }

  .ms-xxl-50 {
    margin-left: 24.5rem !important;
  }

  .ms-xxl-51 {
    margin-left: 25rem !important;
  }

  .ms-xxl-52 {
    margin-left: 25.5rem !important;
  }

  .ms-xxl-53 {
    margin-left: 26rem !important;
  }

  .ms-xxl-54 {
    margin-left: 26.5rem !important;
  }

  .ms-xxl-55 {
    margin-left: 27rem !important;
  }

  .ms-xxl-56 {
    margin-left: 27.5rem !important;
  }

  .ms-xxl-57 {
    margin-left: 28rem !important;
  }

  .ms-xxl-58 {
    margin-left: 28.5rem !important;
  }

  .ms-xxl-59 {
    margin-left: 29rem !important;
  }

  .ms-xxl-60 {
    margin-left: 29.5rem !important;
  }

  .ms-xxl-61 {
    margin-left: 30rem !important;
  }

  .ms-xxl-62 {
    margin-left: 30.5rem !important;
  }

  .ms-xxl-63 {
    margin-left: 31rem !important;
  }

  .ms-xxl-64 {
    margin-left: 31.5rem !important;
  }

  .ms-xxl-65 {
    margin-left: 32rem !important;
  }

  .ms-xxl-66 {
    margin-left: 32.5rem !important;
  }

  .ms-xxl-67 {
    margin-left: 33rem !important;
  }

  .ms-xxl-68 {
    margin-left: 33.5rem !important;
  }

  .ms-xxl-69 {
    margin-left: 34rem !important;
  }

  .ms-xxl-70 {
    margin-left: 34.5rem !important;
  }

  .ms-xxl-71 {
    margin-left: 35rem !important;
  }

  .ms-xxl-72 {
    margin-left: 35.5rem !important;
  }

  .ms-xxl-73 {
    margin-left: 36rem !important;
  }

  .ms-xxl-74 {
    margin-left: 36.5rem !important;
  }

  .ms-xxl-75 {
    margin-left: 37rem !important;
  }

  .ms-xxl-76 {
    margin-left: 37.5rem !important;
  }

  .ms-xxl-77 {
    margin-left: 38rem !important;
  }

  .ms-xxl-78 {
    margin-left: 38.5rem !important;
  }

  .ms-xxl-79 {
    margin-left: 39rem !important;
  }

  .ms-xxl-80 {
    margin-left: 39.5rem !important;
  }

  .ms-xxl-81 {
    margin-left: 40rem !important;
  }

  .ms-xxl-82 {
    margin-left: 40.5rem !important;
  }

  .ms-xxl-83 {
    margin-left: 41rem !important;
  }

  .ms-xxl-84 {
    margin-left: 41.5rem !important;
  }

  .ms-xxl-85 {
    margin-left: 42rem !important;
  }

  .ms-xxl-86 {
    margin-left: 42.5rem !important;
  }

  .ms-xxl-87 {
    margin-left: 43rem !important;
  }

  .ms-xxl-88 {
    margin-left: 43.5rem !important;
  }

  .ms-xxl-89 {
    margin-left: 44rem !important;
  }

  .ms-xxl-90 {
    margin-left: 44.5rem !important;
  }

  .ms-xxl-91 {
    margin-left: 45rem !important;
  }

  .ms-xxl-92 {
    margin-left: 45.5rem !important;
  }

  .ms-xxl-93 {
    margin-left: 46rem !important;
  }

  .ms-xxl-94 {
    margin-left: 46.5rem !important;
  }

  .ms-xxl-95 {
    margin-left: 47rem !important;
  }

  .ms-xxl-96 {
    margin-left: 47.5rem !important;
  }

  .ms-xxl-97 {
    margin-left: 48rem !important;
  }

  .ms-xxl-98 {
    margin-left: 48.5rem !important;
  }

  .ms-xxl-99 {
    margin-left: 49rem !important;
  }

  .ms-xxl-100 {
    margin-left: 49.5rem !important;
  }

  .ms-xxl-101 {
    margin-left: 50rem !important;
  }

  .ms-xxl-102 {
    margin-left: 50.5rem !important;
  }

  .ms-xxl-103 {
    margin-left: 51rem !important;
  }

  .ms-xxl-104 {
    margin-left: 51.5rem !important;
  }

  .ms-xxl-105 {
    margin-left: 52rem !important;
  }

  .ms-xxl-106 {
    margin-left: 52.5rem !important;
  }

  .ms-xxl-107 {
    margin-left: 53rem !important;
  }

  .ms-xxl-108 {
    margin-left: 53.5rem !important;
  }

  .ms-xxl-109 {
    margin-left: 54rem !important;
  }

  .ms-xxl-110 {
    margin-left: 54.5rem !important;
  }

  .ms-xxl-111 {
    margin-left: 55rem !important;
  }

  .ms-xxl-112 {
    margin-left: 55.5rem !important;
  }

  .ms-xxl-113 {
    margin-left: 56rem !important;
  }

  .ms-xxl-114 {
    margin-left: 56.5rem !important;
  }

  .ms-xxl-115 {
    margin-left: 57rem !important;
  }

  .ms-xxl-116 {
    margin-left: 57.5rem !important;
  }

  .ms-xxl-117 {
    margin-left: 58rem !important;
  }

  .ms-xxl-118 {
    margin-left: 58.5rem !important;
  }

  .ms-xxl-119 {
    margin-left: 59rem !important;
  }

  .ms-xxl-120 {
    margin-left: 59.5rem !important;
  }

  .ms-xxl-121 {
    margin-left: 60rem !important;
  }

  .ms-xxl-122 {
    margin-left: 60.5rem !important;
  }

  .ms-xxl-123 {
    margin-left: 61rem !important;
  }

  .ms-xxl-124 {
    margin-left: 61.5rem !important;
  }

  .ms-xxl-125 {
    margin-left: 62rem !important;
  }

  .ms-xxl-126 {
    margin-left: 62.5rem !important;
  }

  .ms-xxl-127 {
    margin-left: 63rem !important;
  }

  .ms-xxl-128 {
    margin-left: 63.5rem !important;
  }

  .ms-xxl-129 {
    margin-left: 64rem !important;
  }

  .ms-xxl-130 {
    margin-left: 64.5rem !important;
  }

  .ms-xxl-131 {
    margin-left: 65rem !important;
  }

  .ms-xxl-132 {
    margin-left: 65.5rem !important;
  }

  .ms-xxl-133 {
    margin-left: 66rem !important;
  }

  .ms-xxl-134 {
    margin-left: 66.5rem !important;
  }

  .ms-xxl-135 {
    margin-left: 67rem !important;
  }

  .ms-xxl-136 {
    margin-left: 67.5rem !important;
  }

  .ms-xxl-137 {
    margin-left: 68rem !important;
  }

  .ms-xxl-138 {
    margin-left: 68.5rem !important;
  }

  .ms-xxl-139 {
    margin-left: 69rem !important;
  }

  .ms-xxl-140 {
    margin-left: 69.5rem !important;
  }

  .ms-xxl-141 {
    margin-left: 70rem !important;
  }

  .ms-xxl-142 {
    margin-left: 70.5rem !important;
  }

  .ms-xxl-143 {
    margin-left: 71rem !important;
  }

  .ms-xxl-144 {
    margin-left: 71.5rem !important;
  }

  .ms-xxl-145 {
    margin-left: 72rem !important;
  }

  .ms-xxl-146 {
    margin-left: 72.5rem !important;
  }

  .ms-xxl-147 {
    margin-left: 73rem !important;
  }

  .ms-xxl-148 {
    margin-left: 73.5rem !important;
  }

  .ms-xxl-149 {
    margin-left: 74rem !important;
  }

  .ms-xxl-150 {
    margin-left: 74.5rem !important;
  }

  .ms-xxl-151 {
    margin-left: 75rem !important;
  }

  .ms-xxl-152 {
    margin-left: 75.5rem !important;
  }

  .ms-xxl-153 {
    margin-left: 76rem !important;
  }

  .ms-xxl-154 {
    margin-left: 76.5rem !important;
  }

  .ms-xxl-155 {
    margin-left: 77rem !important;
  }

  .ms-xxl-156 {
    margin-left: 77.5rem !important;
  }

  .ms-xxl-157 {
    margin-left: 78rem !important;
  }

  .ms-xxl-158 {
    margin-left: 78.5rem !important;
  }

  .ms-xxl-159 {
    margin-left: 79rem !important;
  }

  .ms-xxl-160 {
    margin-left: 79.5rem !important;
  }

  .me-xxl-0 {
    margin-right: 0rem !important;
  }

  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xxl-3 {
    margin-right: 1rem !important;
  }

  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xxl-5 {
    margin-right: 2rem !important;
  }

  .me-xxl-6 {
    margin-right: 2.5rem !important;
  }

  .me-xxl-7 {
    margin-right: 3rem !important;
  }

  .me-xxl-8 {
    margin-right: 3.5rem !important;
  }

  .me-xxl-9 {
    margin-right: 4rem !important;
  }

  .me-xxl-10 {
    margin-right: 4.5rem !important;
  }

  .me-xxl-11 {
    margin-right: 5rem !important;
  }

  .me-xxl-12 {
    margin-right: 5.5rem !important;
  }

  .me-xxl-13 {
    margin-right: 6rem !important;
  }

  .me-xxl-14 {
    margin-right: 6.5rem !important;
  }

  .me-xxl-15 {
    margin-right: 7rem !important;
  }

  .me-xxl-16 {
    margin-right: 7.5rem !important;
  }

  .me-xxl-17 {
    margin-right: 8rem !important;
  }

  .me-xxl-18 {
    margin-right: 8.5rem !important;
  }

  .me-xxl-19 {
    margin-right: 9rem !important;
  }

  .me-xxl-20 {
    margin-right: 9.5rem !important;
  }

  .me-xxl-21 {
    margin-right: 10rem !important;
  }

  .me-xxl-22 {
    margin-right: 10.5rem !important;
  }

  .me-xxl-23 {
    margin-right: 11rem !important;
  }

  .me-xxl-24 {
    margin-right: 11.5rem !important;
  }

  .me-xxl-25 {
    margin-right: 12rem !important;
  }

  .me-xxl-26 {
    margin-right: 12.5rem !important;
  }

  .me-xxl-27 {
    margin-right: 13rem !important;
  }

  .me-xxl-28 {
    margin-right: 13.5rem !important;
  }

  .me-xxl-29 {
    margin-right: 14rem !important;
  }

  .me-xxl-30 {
    margin-right: 14.5rem !important;
  }

  .me-xxl-31 {
    margin-right: 15rem !important;
  }

  .me-xxl-32 {
    margin-right: 15.5rem !important;
  }

  .me-xxl-33 {
    margin-right: 16rem !important;
  }

  .me-xxl-34 {
    margin-right: 16.5rem !important;
  }

  .me-xxl-35 {
    margin-right: 17rem !important;
  }

  .me-xxl-36 {
    margin-right: 17.5rem !important;
  }

  .me-xxl-37 {
    margin-right: 18rem !important;
  }

  .me-xxl-38 {
    margin-right: 18.5rem !important;
  }

  .me-xxl-39 {
    margin-right: 19rem !important;
  }

  .me-xxl-40 {
    margin-right: 19.5rem !important;
  }

  .me-xxl-41 {
    margin-right: 20rem !important;
  }

  .me-xxl-42 {
    margin-right: 20.5rem !important;
  }

  .me-xxl-43 {
    margin-right: 21rem !important;
  }

  .me-xxl-44 {
    margin-right: 21.5rem !important;
  }

  .me-xxl-45 {
    margin-right: 22rem !important;
  }

  .me-xxl-46 {
    margin-right: 22.5rem !important;
  }

  .me-xxl-47 {
    margin-right: 23rem !important;
  }

  .me-xxl-48 {
    margin-right: 23.5rem !important;
  }

  .me-xxl-49 {
    margin-right: 24rem !important;
  }

  .me-xxl-50 {
    margin-right: 24.5rem !important;
  }

  .me-xxl-51 {
    margin-right: 25rem !important;
  }

  .me-xxl-52 {
    margin-right: 25.5rem !important;
  }

  .me-xxl-53 {
    margin-right: 26rem !important;
  }

  .me-xxl-54 {
    margin-right: 26.5rem !important;
  }

  .me-xxl-55 {
    margin-right: 27rem !important;
  }

  .me-xxl-56 {
    margin-right: 27.5rem !important;
  }

  .me-xxl-57 {
    margin-right: 28rem !important;
  }

  .me-xxl-58 {
    margin-right: 28.5rem !important;
  }

  .me-xxl-59 {
    margin-right: 29rem !important;
  }

  .me-xxl-60 {
    margin-right: 29.5rem !important;
  }

  .me-xxl-61 {
    margin-right: 30rem !important;
  }

  .me-xxl-62 {
    margin-right: 30.5rem !important;
  }

  .me-xxl-63 {
    margin-right: 31rem !important;
  }

  .me-xxl-64 {
    margin-right: 31.5rem !important;
  }

  .me-xxl-65 {
    margin-right: 32rem !important;
  }

  .me-xxl-66 {
    margin-right: 32.5rem !important;
  }

  .me-xxl-67 {
    margin-right: 33rem !important;
  }

  .me-xxl-68 {
    margin-right: 33.5rem !important;
  }

  .me-xxl-69 {
    margin-right: 34rem !important;
  }

  .me-xxl-70 {
    margin-right: 34.5rem !important;
  }

  .me-xxl-71 {
    margin-right: 35rem !important;
  }

  .me-xxl-72 {
    margin-right: 35.5rem !important;
  }

  .me-xxl-73 {
    margin-right: 36rem !important;
  }

  .me-xxl-74 {
    margin-right: 36.5rem !important;
  }

  .me-xxl-75 {
    margin-right: 37rem !important;
  }

  .me-xxl-76 {
    margin-right: 37.5rem !important;
  }

  .me-xxl-77 {
    margin-right: 38rem !important;
  }

  .me-xxl-78 {
    margin-right: 38.5rem !important;
  }

  .me-xxl-79 {
    margin-right: 39rem !important;
  }

  .me-xxl-80 {
    margin-right: 39.5rem !important;
  }

  .me-xxl-81 {
    margin-right: 40rem !important;
  }

  .me-xxl-82 {
    margin-right: 40.5rem !important;
  }

  .me-xxl-83 {
    margin-right: 41rem !important;
  }

  .me-xxl-84 {
    margin-right: 41.5rem !important;
  }

  .me-xxl-85 {
    margin-right: 42rem !important;
  }

  .me-xxl-86 {
    margin-right: 42.5rem !important;
  }

  .me-xxl-87 {
    margin-right: 43rem !important;
  }

  .me-xxl-88 {
    margin-right: 43.5rem !important;
  }

  .me-xxl-89 {
    margin-right: 44rem !important;
  }

  .me-xxl-90 {
    margin-right: 44.5rem !important;
  }

  .me-xxl-91 {
    margin-right: 45rem !important;
  }

  .me-xxl-92 {
    margin-right: 45.5rem !important;
  }

  .me-xxl-93 {
    margin-right: 46rem !important;
  }

  .me-xxl-94 {
    margin-right: 46.5rem !important;
  }

  .me-xxl-95 {
    margin-right: 47rem !important;
  }

  .me-xxl-96 {
    margin-right: 47.5rem !important;
  }

  .me-xxl-97 {
    margin-right: 48rem !important;
  }

  .me-xxl-98 {
    margin-right: 48.5rem !important;
  }

  .me-xxl-99 {
    margin-right: 49rem !important;
  }

  .me-xxl-100 {
    margin-right: 49.5rem !important;
  }

  .me-xxl-101 {
    margin-right: 50rem !important;
  }

  .me-xxl-102 {
    margin-right: 50.5rem !important;
  }

  .me-xxl-103 {
    margin-right: 51rem !important;
  }

  .me-xxl-104 {
    margin-right: 51.5rem !important;
  }

  .me-xxl-105 {
    margin-right: 52rem !important;
  }

  .me-xxl-106 {
    margin-right: 52.5rem !important;
  }

  .me-xxl-107 {
    margin-right: 53rem !important;
  }

  .me-xxl-108 {
    margin-right: 53.5rem !important;
  }

  .me-xxl-109 {
    margin-right: 54rem !important;
  }

  .me-xxl-110 {
    margin-right: 54.5rem !important;
  }

  .me-xxl-111 {
    margin-right: 55rem !important;
  }

  .me-xxl-112 {
    margin-right: 55.5rem !important;
  }

  .me-xxl-113 {
    margin-right: 56rem !important;
  }

  .me-xxl-114 {
    margin-right: 56.5rem !important;
  }

  .me-xxl-115 {
    margin-right: 57rem !important;
  }

  .me-xxl-116 {
    margin-right: 57.5rem !important;
  }

  .me-xxl-117 {
    margin-right: 58rem !important;
  }

  .me-xxl-118 {
    margin-right: 58.5rem !important;
  }

  .me-xxl-119 {
    margin-right: 59rem !important;
  }

  .me-xxl-120 {
    margin-right: 59.5rem !important;
  }

  .me-xxl-121 {
    margin-right: 60rem !important;
  }

  .me-xxl-122 {
    margin-right: 60.5rem !important;
  }

  .me-xxl-123 {
    margin-right: 61rem !important;
  }

  .me-xxl-124 {
    margin-right: 61.5rem !important;
  }

  .me-xxl-125 {
    margin-right: 62rem !important;
  }

  .me-xxl-126 {
    margin-right: 62.5rem !important;
  }

  .me-xxl-127 {
    margin-right: 63rem !important;
  }

  .me-xxl-128 {
    margin-right: 63.5rem !important;
  }

  .me-xxl-129 {
    margin-right: 64rem !important;
  }

  .me-xxl-130 {
    margin-right: 64.5rem !important;
  }

  .me-xxl-131 {
    margin-right: 65rem !important;
  }

  .me-xxl-132 {
    margin-right: 65.5rem !important;
  }

  .me-xxl-133 {
    margin-right: 66rem !important;
  }

  .me-xxl-134 {
    margin-right: 66.5rem !important;
  }

  .me-xxl-135 {
    margin-right: 67rem !important;
  }

  .me-xxl-136 {
    margin-right: 67.5rem !important;
  }

  .me-xxl-137 {
    margin-right: 68rem !important;
  }

  .me-xxl-138 {
    margin-right: 68.5rem !important;
  }

  .me-xxl-139 {
    margin-right: 69rem !important;
  }

  .me-xxl-140 {
    margin-right: 69.5rem !important;
  }

  .me-xxl-141 {
    margin-right: 70rem !important;
  }

  .me-xxl-142 {
    margin-right: 70.5rem !important;
  }

  .me-xxl-143 {
    margin-right: 71rem !important;
  }

  .me-xxl-144 {
    margin-right: 71.5rem !important;
  }

  .me-xxl-145 {
    margin-right: 72rem !important;
  }

  .me-xxl-146 {
    margin-right: 72.5rem !important;
  }

  .me-xxl-147 {
    margin-right: 73rem !important;
  }

  .me-xxl-148 {
    margin-right: 73.5rem !important;
  }

  .me-xxl-149 {
    margin-right: 74rem !important;
  }

  .me-xxl-150 {
    margin-right: 74.5rem !important;
  }

  .me-xxl-151 {
    margin-right: 75rem !important;
  }

  .me-xxl-152 {
    margin-right: 75.5rem !important;
  }

  .me-xxl-153 {
    margin-right: 76rem !important;
  }

  .me-xxl-154 {
    margin-right: 76.5rem !important;
  }

  .me-xxl-155 {
    margin-right: 77rem !important;
  }

  .me-xxl-156 {
    margin-right: 77.5rem !important;
  }

  .me-xxl-157 {
    margin-right: 78rem !important;
  }

  .me-xxl-158 {
    margin-right: 78.5rem !important;
  }

  .me-xxl-159 {
    margin-right: 79rem !important;
  }

  .me-xxl-160 {
    margin-right: 79.5rem !important;
  }

  .mx-xxl-0 {
    margin-left: 0rem !important;
    margin-right: 0rem !important;
  }

  .mx-xxl-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .mx-xxl-4 {
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  .mx-xxl-5 {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  .mx-xxl-6 {
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  .mx-xxl-7 {
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  .mx-xxl-8 {
    margin-left: 3.5rem !important;
    margin-right: 3.5rem !important;
  }

  .mx-xxl-9 {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  .mx-xxl-10 {
    margin-left: 4.5rem !important;
    margin-right: 4.5rem !important;
  }

  .mx-xxl-11 {
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  .mx-xxl-12 {
    margin-left: 5.5rem !important;
    margin-right: 5.5rem !important;
  }

  .mx-xxl-13 {
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  .mx-xxl-14 {
    margin-left: 6.5rem !important;
    margin-right: 6.5rem !important;
  }

  .mx-xxl-15 {
    margin-left: 7rem !important;
    margin-right: 7rem !important;
  }

  .mx-xxl-16 {
    margin-left: 7.5rem !important;
    margin-right: 7.5rem !important;
  }

  .mx-xxl-17 {
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  .mx-xxl-18 {
    margin-left: 8.5rem !important;
    margin-right: 8.5rem !important;
  }

  .mx-xxl-19 {
    margin-left: 9rem !important;
    margin-right: 9rem !important;
  }

  .mx-xxl-20 {
    margin-left: 9.5rem !important;
    margin-right: 9.5rem !important;
  }

  .mx-xxl-21 {
    margin-left: 10rem !important;
    margin-right: 10rem !important;
  }

  .mx-xxl-22 {
    margin-left: 10.5rem !important;
    margin-right: 10.5rem !important;
  }

  .mx-xxl-23 {
    margin-left: 11rem !important;
    margin-right: 11rem !important;
  }

  .mx-xxl-24 {
    margin-left: 11.5rem !important;
    margin-right: 11.5rem !important;
  }

  .mx-xxl-25 {
    margin-left: 12rem !important;
    margin-right: 12rem !important;
  }

  .mx-xxl-26 {
    margin-left: 12.5rem !important;
    margin-right: 12.5rem !important;
  }

  .mx-xxl-27 {
    margin-left: 13rem !important;
    margin-right: 13rem !important;
  }

  .mx-xxl-28 {
    margin-left: 13.5rem !important;
    margin-right: 13.5rem !important;
  }

  .mx-xxl-29 {
    margin-left: 14rem !important;
    margin-right: 14rem !important;
  }

  .mx-xxl-30 {
    margin-left: 14.5rem !important;
    margin-right: 14.5rem !important;
  }

  .mx-xxl-31 {
    margin-left: 15rem !important;
    margin-right: 15rem !important;
  }

  .mx-xxl-32 {
    margin-left: 15.5rem !important;
    margin-right: 15.5rem !important;
  }

  .mx-xxl-33 {
    margin-left: 16rem !important;
    margin-right: 16rem !important;
  }

  .mx-xxl-34 {
    margin-left: 16.5rem !important;
    margin-right: 16.5rem !important;
  }

  .mx-xxl-35 {
    margin-left: 17rem !important;
    margin-right: 17rem !important;
  }

  .mx-xxl-36 {
    margin-left: 17.5rem !important;
    margin-right: 17.5rem !important;
  }

  .mx-xxl-37 {
    margin-left: 18rem !important;
    margin-right: 18rem !important;
  }

  .mx-xxl-38 {
    margin-left: 18.5rem !important;
    margin-right: 18.5rem !important;
  }

  .mx-xxl-39 {
    margin-left: 19rem !important;
    margin-right: 19rem !important;
  }

  .mx-xxl-40 {
    margin-left: 19.5rem !important;
    margin-right: 19.5rem !important;
  }

  .mx-xxl-41 {
    margin-left: 20rem !important;
    margin-right: 20rem !important;
  }

  .mx-xxl-42 {
    margin-left: 20.5rem !important;
    margin-right: 20.5rem !important;
  }

  .mx-xxl-43 {
    margin-left: 21rem !important;
    margin-right: 21rem !important;
  }

  .mx-xxl-44 {
    margin-left: 21.5rem !important;
    margin-right: 21.5rem !important;
  }

  .mx-xxl-45 {
    margin-left: 22rem !important;
    margin-right: 22rem !important;
  }

  .mx-xxl-46 {
    margin-left: 22.5rem !important;
    margin-right: 22.5rem !important;
  }

  .mx-xxl-47 {
    margin-left: 23rem !important;
    margin-right: 23rem !important;
  }

  .mx-xxl-48 {
    margin-left: 23.5rem !important;
    margin-right: 23.5rem !important;
  }

  .mx-xxl-49 {
    margin-left: 24rem !important;
    margin-right: 24rem !important;
  }

  .mx-xxl-50 {
    margin-left: 24.5rem !important;
    margin-right: 24.5rem !important;
  }

  .mx-xxl-51 {
    margin-left: 25rem !important;
    margin-right: 25rem !important;
  }

  .mx-xxl-52 {
    margin-left: 25.5rem !important;
    margin-right: 25.5rem !important;
  }

  .mx-xxl-53 {
    margin-left: 26rem !important;
    margin-right: 26rem !important;
  }

  .mx-xxl-54 {
    margin-left: 26.5rem !important;
    margin-right: 26.5rem !important;
  }

  .mx-xxl-55 {
    margin-left: 27rem !important;
    margin-right: 27rem !important;
  }

  .mx-xxl-56 {
    margin-left: 27.5rem !important;
    margin-right: 27.5rem !important;
  }

  .mx-xxl-57 {
    margin-left: 28rem !important;
    margin-right: 28rem !important;
  }

  .mx-xxl-58 {
    margin-left: 28.5rem !important;
    margin-right: 28.5rem !important;
  }

  .mx-xxl-59 {
    margin-left: 29rem !important;
    margin-right: 29rem !important;
  }

  .mx-xxl-60 {
    margin-left: 29.5rem !important;
    margin-right: 29.5rem !important;
  }

  .mx-xxl-61 {
    margin-left: 30rem !important;
    margin-right: 30rem !important;
  }

  .mx-xxl-62 {
    margin-left: 30.5rem !important;
    margin-right: 30.5rem !important;
  }

  .mx-xxl-63 {
    margin-left: 31rem !important;
    margin-right: 31rem !important;
  }

  .mx-xxl-64 {
    margin-left: 31.5rem !important;
    margin-right: 31.5rem !important;
  }

  .mx-xxl-65 {
    margin-left: 32rem !important;
    margin-right: 32rem !important;
  }

  .mx-xxl-66 {
    margin-left: 32.5rem !important;
    margin-right: 32.5rem !important;
  }

  .mx-xxl-67 {
    margin-left: 33rem !important;
    margin-right: 33rem !important;
  }

  .mx-xxl-68 {
    margin-left: 33.5rem !important;
    margin-right: 33.5rem !important;
  }

  .mx-xxl-69 {
    margin-left: 34rem !important;
    margin-right: 34rem !important;
  }

  .mx-xxl-70 {
    margin-left: 34.5rem !important;
    margin-right: 34.5rem !important;
  }

  .mx-xxl-71 {
    margin-left: 35rem !important;
    margin-right: 35rem !important;
  }

  .mx-xxl-72 {
    margin-left: 35.5rem !important;
    margin-right: 35.5rem !important;
  }

  .mx-xxl-73 {
    margin-left: 36rem !important;
    margin-right: 36rem !important;
  }

  .mx-xxl-74 {
    margin-left: 36.5rem !important;
    margin-right: 36.5rem !important;
  }

  .mx-xxl-75 {
    margin-left: 37rem !important;
    margin-right: 37rem !important;
  }

  .mx-xxl-76 {
    margin-left: 37.5rem !important;
    margin-right: 37.5rem !important;
  }

  .mx-xxl-77 {
    margin-left: 38rem !important;
    margin-right: 38rem !important;
  }

  .mx-xxl-78 {
    margin-left: 38.5rem !important;
    margin-right: 38.5rem !important;
  }

  .mx-xxl-79 {
    margin-left: 39rem !important;
    margin-right: 39rem !important;
  }

  .mx-xxl-80 {
    margin-left: 39.5rem !important;
    margin-right: 39.5rem !important;
  }

  .mx-xxl-81 {
    margin-left: 40rem !important;
    margin-right: 40rem !important;
  }

  .mx-xxl-82 {
    margin-left: 40.5rem !important;
    margin-right: 40.5rem !important;
  }

  .mx-xxl-83 {
    margin-left: 41rem !important;
    margin-right: 41rem !important;
  }

  .mx-xxl-84 {
    margin-left: 41.5rem !important;
    margin-right: 41.5rem !important;
  }

  .mx-xxl-85 {
    margin-left: 42rem !important;
    margin-right: 42rem !important;
  }

  .mx-xxl-86 {
    margin-left: 42.5rem !important;
    margin-right: 42.5rem !important;
  }

  .mx-xxl-87 {
    margin-left: 43rem !important;
    margin-right: 43rem !important;
  }

  .mx-xxl-88 {
    margin-left: 43.5rem !important;
    margin-right: 43.5rem !important;
  }

  .mx-xxl-89 {
    margin-left: 44rem !important;
    margin-right: 44rem !important;
  }

  .mx-xxl-90 {
    margin-left: 44.5rem !important;
    margin-right: 44.5rem !important;
  }

  .mx-xxl-91 {
    margin-left: 45rem !important;
    margin-right: 45rem !important;
  }

  .mx-xxl-92 {
    margin-left: 45.5rem !important;
    margin-right: 45.5rem !important;
  }

  .mx-xxl-93 {
    margin-left: 46rem !important;
    margin-right: 46rem !important;
  }

  .mx-xxl-94 {
    margin-left: 46.5rem !important;
    margin-right: 46.5rem !important;
  }

  .mx-xxl-95 {
    margin-left: 47rem !important;
    margin-right: 47rem !important;
  }

  .mx-xxl-96 {
    margin-left: 47.5rem !important;
    margin-right: 47.5rem !important;
  }

  .mx-xxl-97 {
    margin-left: 48rem !important;
    margin-right: 48rem !important;
  }

  .mx-xxl-98 {
    margin-left: 48.5rem !important;
    margin-right: 48.5rem !important;
  }

  .mx-xxl-99 {
    margin-left: 49rem !important;
    margin-right: 49rem !important;
  }

  .mx-xxl-100 {
    margin-left: 49.5rem !important;
    margin-right: 49.5rem !important;
  }

  .mx-xxl-101 {
    margin-left: 50rem !important;
    margin-right: 50rem !important;
  }

  .mx-xxl-102 {
    margin-left: 50.5rem !important;
    margin-right: 50.5rem !important;
  }

  .mx-xxl-103 {
    margin-left: 51rem !important;
    margin-right: 51rem !important;
  }

  .mx-xxl-104 {
    margin-left: 51.5rem !important;
    margin-right: 51.5rem !important;
  }

  .mx-xxl-105 {
    margin-left: 52rem !important;
    margin-right: 52rem !important;
  }

  .mx-xxl-106 {
    margin-left: 52.5rem !important;
    margin-right: 52.5rem !important;
  }

  .mx-xxl-107 {
    margin-left: 53rem !important;
    margin-right: 53rem !important;
  }

  .mx-xxl-108 {
    margin-left: 53.5rem !important;
    margin-right: 53.5rem !important;
  }

  .mx-xxl-109 {
    margin-left: 54rem !important;
    margin-right: 54rem !important;
  }

  .mx-xxl-110 {
    margin-left: 54.5rem !important;
    margin-right: 54.5rem !important;
  }

  .mx-xxl-111 {
    margin-left: 55rem !important;
    margin-right: 55rem !important;
  }

  .mx-xxl-112 {
    margin-left: 55.5rem !important;
    margin-right: 55.5rem !important;
  }

  .mx-xxl-113 {
    margin-left: 56rem !important;
    margin-right: 56rem !important;
  }

  .mx-xxl-114 {
    margin-left: 56.5rem !important;
    margin-right: 56.5rem !important;
  }

  .mx-xxl-115 {
    margin-left: 57rem !important;
    margin-right: 57rem !important;
  }

  .mx-xxl-116 {
    margin-left: 57.5rem !important;
    margin-right: 57.5rem !important;
  }

  .mx-xxl-117 {
    margin-left: 58rem !important;
    margin-right: 58rem !important;
  }

  .mx-xxl-118 {
    margin-left: 58.5rem !important;
    margin-right: 58.5rem !important;
  }

  .mx-xxl-119 {
    margin-left: 59rem !important;
    margin-right: 59rem !important;
  }

  .mx-xxl-120 {
    margin-left: 59.5rem !important;
    margin-right: 59.5rem !important;
  }

  .mx-xxl-121 {
    margin-left: 60rem !important;
    margin-right: 60rem !important;
  }

  .mx-xxl-122 {
    margin-left: 60.5rem !important;
    margin-right: 60.5rem !important;
  }

  .mx-xxl-123 {
    margin-left: 61rem !important;
    margin-right: 61rem !important;
  }

  .mx-xxl-124 {
    margin-left: 61.5rem !important;
    margin-right: 61.5rem !important;
  }

  .mx-xxl-125 {
    margin-left: 62rem !important;
    margin-right: 62rem !important;
  }

  .mx-xxl-126 {
    margin-left: 62.5rem !important;
    margin-right: 62.5rem !important;
  }

  .mx-xxl-127 {
    margin-left: 63rem !important;
    margin-right: 63rem !important;
  }

  .mx-xxl-128 {
    margin-left: 63.5rem !important;
    margin-right: 63.5rem !important;
  }

  .mx-xxl-129 {
    margin-left: 64rem !important;
    margin-right: 64rem !important;
  }

  .mx-xxl-130 {
    margin-left: 64.5rem !important;
    margin-right: 64.5rem !important;
  }

  .mx-xxl-131 {
    margin-left: 65rem !important;
    margin-right: 65rem !important;
  }

  .mx-xxl-132 {
    margin-left: 65.5rem !important;
    margin-right: 65.5rem !important;
  }

  .mx-xxl-133 {
    margin-left: 66rem !important;
    margin-right: 66rem !important;
  }

  .mx-xxl-134 {
    margin-left: 66.5rem !important;
    margin-right: 66.5rem !important;
  }

  .mx-xxl-135 {
    margin-left: 67rem !important;
    margin-right: 67rem !important;
  }

  .mx-xxl-136 {
    margin-left: 67.5rem !important;
    margin-right: 67.5rem !important;
  }

  .mx-xxl-137 {
    margin-left: 68rem !important;
    margin-right: 68rem !important;
  }

  .mx-xxl-138 {
    margin-left: 68.5rem !important;
    margin-right: 68.5rem !important;
  }

  .mx-xxl-139 {
    margin-left: 69rem !important;
    margin-right: 69rem !important;
  }

  .mx-xxl-140 {
    margin-left: 69.5rem !important;
    margin-right: 69.5rem !important;
  }

  .mx-xxl-141 {
    margin-left: 70rem !important;
    margin-right: 70rem !important;
  }

  .mx-xxl-142 {
    margin-left: 70.5rem !important;
    margin-right: 70.5rem !important;
  }

  .mx-xxl-143 {
    margin-left: 71rem !important;
    margin-right: 71rem !important;
  }

  .mx-xxl-144 {
    margin-left: 71.5rem !important;
    margin-right: 71.5rem !important;
  }

  .mx-xxl-145 {
    margin-left: 72rem !important;
    margin-right: 72rem !important;
  }

  .mx-xxl-146 {
    margin-left: 72.5rem !important;
    margin-right: 72.5rem !important;
  }

  .mx-xxl-147 {
    margin-left: 73rem !important;
    margin-right: 73rem !important;
  }

  .mx-xxl-148 {
    margin-left: 73.5rem !important;
    margin-right: 73.5rem !important;
  }

  .mx-xxl-149 {
    margin-left: 74rem !important;
    margin-right: 74rem !important;
  }

  .mx-xxl-150 {
    margin-left: 74.5rem !important;
    margin-right: 74.5rem !important;
  }

  .mx-xxl-151 {
    margin-left: 75rem !important;
    margin-right: 75rem !important;
  }

  .mx-xxl-152 {
    margin-left: 75.5rem !important;
    margin-right: 75.5rem !important;
  }

  .mx-xxl-153 {
    margin-left: 76rem !important;
    margin-right: 76rem !important;
  }

  .mx-xxl-154 {
    margin-left: 76.5rem !important;
    margin-right: 76.5rem !important;
  }

  .mx-xxl-155 {
    margin-left: 77rem !important;
    margin-right: 77rem !important;
  }

  .mx-xxl-156 {
    margin-left: 77.5rem !important;
    margin-right: 77.5rem !important;
  }

  .mx-xxl-157 {
    margin-left: 78rem !important;
    margin-right: 78rem !important;
  }

  .mx-xxl-158 {
    margin-left: 78.5rem !important;
    margin-right: 78.5rem !important;
  }

  .mx-xxl-159 {
    margin-left: 79rem !important;
    margin-right: 79rem !important;
  }

  .mx-xxl-160 {
    margin-left: 79.5rem !important;
    margin-right: 79.5rem !important;
  }

  .my-xxl-0 {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-5 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xxl-6 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xxl-7 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-8 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xxl-9 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xxl-10 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xxl-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xxl-12 {
    margin-top: 5.5rem !important;
    margin-bottom: 5.5rem !important;
  }

  .my-xxl-13 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  .my-xxl-14 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }

  .my-xxl-15 {
    margin-top: 7rem !important;
    margin-bottom: 7rem !important;
  }

  .my-xxl-16 {
    margin-top: 7.5rem !important;
    margin-bottom: 7.5rem !important;
  }

  .my-xxl-17 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  .my-xxl-18 {
    margin-top: 8.5rem !important;
    margin-bottom: 8.5rem !important;
  }

  .my-xxl-19 {
    margin-top: 9rem !important;
    margin-bottom: 9rem !important;
  }

  .my-xxl-20 {
    margin-top: 9.5rem !important;
    margin-bottom: 9.5rem !important;
  }

  .my-xxl-21 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important;
  }

  .my-xxl-22 {
    margin-top: 10.5rem !important;
    margin-bottom: 10.5rem !important;
  }

  .my-xxl-23 {
    margin-top: 11rem !important;
    margin-bottom: 11rem !important;
  }

  .my-xxl-24 {
    margin-top: 11.5rem !important;
    margin-bottom: 11.5rem !important;
  }

  .my-xxl-25 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }

  .my-xxl-26 {
    margin-top: 12.5rem !important;
    margin-bottom: 12.5rem !important;
  }

  .my-xxl-27 {
    margin-top: 13rem !important;
    margin-bottom: 13rem !important;
  }

  .my-xxl-28 {
    margin-top: 13.5rem !important;
    margin-bottom: 13.5rem !important;
  }

  .my-xxl-29 {
    margin-top: 14rem !important;
    margin-bottom: 14rem !important;
  }

  .my-xxl-30 {
    margin-top: 14.5rem !important;
    margin-bottom: 14.5rem !important;
  }

  .my-xxl-31 {
    margin-top: 15rem !important;
    margin-bottom: 15rem !important;
  }

  .my-xxl-32 {
    margin-top: 15.5rem !important;
    margin-bottom: 15.5rem !important;
  }

  .my-xxl-33 {
    margin-top: 16rem !important;
    margin-bottom: 16rem !important;
  }

  .my-xxl-34 {
    margin-top: 16.5rem !important;
    margin-bottom: 16.5rem !important;
  }

  .my-xxl-35 {
    margin-top: 17rem !important;
    margin-bottom: 17rem !important;
  }

  .my-xxl-36 {
    margin-top: 17.5rem !important;
    margin-bottom: 17.5rem !important;
  }

  .my-xxl-37 {
    margin-top: 18rem !important;
    margin-bottom: 18rem !important;
  }

  .my-xxl-38 {
    margin-top: 18.5rem !important;
    margin-bottom: 18.5rem !important;
  }

  .my-xxl-39 {
    margin-top: 19rem !important;
    margin-bottom: 19rem !important;
  }

  .my-xxl-40 {
    margin-top: 19.5rem !important;
    margin-bottom: 19.5rem !important;
  }

  .my-xxl-41 {
    margin-top: 20rem !important;
    margin-bottom: 20rem !important;
  }

  .my-xxl-42 {
    margin-top: 20.5rem !important;
    margin-bottom: 20.5rem !important;
  }

  .my-xxl-43 {
    margin-top: 21rem !important;
    margin-bottom: 21rem !important;
  }

  .my-xxl-44 {
    margin-top: 21.5rem !important;
    margin-bottom: 21.5rem !important;
  }

  .my-xxl-45 {
    margin-top: 22rem !important;
    margin-bottom: 22rem !important;
  }

  .my-xxl-46 {
    margin-top: 22.5rem !important;
    margin-bottom: 22.5rem !important;
  }

  .my-xxl-47 {
    margin-top: 23rem !important;
    margin-bottom: 23rem !important;
  }

  .my-xxl-48 {
    margin-top: 23.5rem !important;
    margin-bottom: 23.5rem !important;
  }

  .my-xxl-49 {
    margin-top: 24rem !important;
    margin-bottom: 24rem !important;
  }

  .my-xxl-50 {
    margin-top: 24.5rem !important;
    margin-bottom: 24.5rem !important;
  }

  .my-xxl-51 {
    margin-top: 25rem !important;
    margin-bottom: 25rem !important;
  }

  .my-xxl-52 {
    margin-top: 25.5rem !important;
    margin-bottom: 25.5rem !important;
  }

  .my-xxl-53 {
    margin-top: 26rem !important;
    margin-bottom: 26rem !important;
  }

  .my-xxl-54 {
    margin-top: 26.5rem !important;
    margin-bottom: 26.5rem !important;
  }

  .my-xxl-55 {
    margin-top: 27rem !important;
    margin-bottom: 27rem !important;
  }

  .my-xxl-56 {
    margin-top: 27.5rem !important;
    margin-bottom: 27.5rem !important;
  }

  .my-xxl-57 {
    margin-top: 28rem !important;
    margin-bottom: 28rem !important;
  }

  .my-xxl-58 {
    margin-top: 28.5rem !important;
    margin-bottom: 28.5rem !important;
  }

  .my-xxl-59 {
    margin-top: 29rem !important;
    margin-bottom: 29rem !important;
  }

  .my-xxl-60 {
    margin-top: 29.5rem !important;
    margin-bottom: 29.5rem !important;
  }

  .my-xxl-61 {
    margin-top: 30rem !important;
    margin-bottom: 30rem !important;
  }

  .my-xxl-62 {
    margin-top: 30.5rem !important;
    margin-bottom: 30.5rem !important;
  }

  .my-xxl-63 {
    margin-top: 31rem !important;
    margin-bottom: 31rem !important;
  }

  .my-xxl-64 {
    margin-top: 31.5rem !important;
    margin-bottom: 31.5rem !important;
  }

  .my-xxl-65 {
    margin-top: 32rem !important;
    margin-bottom: 32rem !important;
  }

  .my-xxl-66 {
    margin-top: 32.5rem !important;
    margin-bottom: 32.5rem !important;
  }

  .my-xxl-67 {
    margin-top: 33rem !important;
    margin-bottom: 33rem !important;
  }

  .my-xxl-68 {
    margin-top: 33.5rem !important;
    margin-bottom: 33.5rem !important;
  }

  .my-xxl-69 {
    margin-top: 34rem !important;
    margin-bottom: 34rem !important;
  }

  .my-xxl-70 {
    margin-top: 34.5rem !important;
    margin-bottom: 34.5rem !important;
  }

  .my-xxl-71 {
    margin-top: 35rem !important;
    margin-bottom: 35rem !important;
  }

  .my-xxl-72 {
    margin-top: 35.5rem !important;
    margin-bottom: 35.5rem !important;
  }

  .my-xxl-73 {
    margin-top: 36rem !important;
    margin-bottom: 36rem !important;
  }

  .my-xxl-74 {
    margin-top: 36.5rem !important;
    margin-bottom: 36.5rem !important;
  }

  .my-xxl-75 {
    margin-top: 37rem !important;
    margin-bottom: 37rem !important;
  }

  .my-xxl-76 {
    margin-top: 37.5rem !important;
    margin-bottom: 37.5rem !important;
  }

  .my-xxl-77 {
    margin-top: 38rem !important;
    margin-bottom: 38rem !important;
  }

  .my-xxl-78 {
    margin-top: 38.5rem !important;
    margin-bottom: 38.5rem !important;
  }

  .my-xxl-79 {
    margin-top: 39rem !important;
    margin-bottom: 39rem !important;
  }

  .my-xxl-80 {
    margin-top: 39.5rem !important;
    margin-bottom: 39.5rem !important;
  }

  .my-xxl-81 {
    margin-top: 40rem !important;
    margin-bottom: 40rem !important;
  }

  .my-xxl-82 {
    margin-top: 40.5rem !important;
    margin-bottom: 40.5rem !important;
  }

  .my-xxl-83 {
    margin-top: 41rem !important;
    margin-bottom: 41rem !important;
  }

  .my-xxl-84 {
    margin-top: 41.5rem !important;
    margin-bottom: 41.5rem !important;
  }

  .my-xxl-85 {
    margin-top: 42rem !important;
    margin-bottom: 42rem !important;
  }

  .my-xxl-86 {
    margin-top: 42.5rem !important;
    margin-bottom: 42.5rem !important;
  }

  .my-xxl-87 {
    margin-top: 43rem !important;
    margin-bottom: 43rem !important;
  }

  .my-xxl-88 {
    margin-top: 43.5rem !important;
    margin-bottom: 43.5rem !important;
  }

  .my-xxl-89 {
    margin-top: 44rem !important;
    margin-bottom: 44rem !important;
  }

  .my-xxl-90 {
    margin-top: 44.5rem !important;
    margin-bottom: 44.5rem !important;
  }

  .my-xxl-91 {
    margin-top: 45rem !important;
    margin-bottom: 45rem !important;
  }

  .my-xxl-92 {
    margin-top: 45.5rem !important;
    margin-bottom: 45.5rem !important;
  }

  .my-xxl-93 {
    margin-top: 46rem !important;
    margin-bottom: 46rem !important;
  }

  .my-xxl-94 {
    margin-top: 46.5rem !important;
    margin-bottom: 46.5rem !important;
  }

  .my-xxl-95 {
    margin-top: 47rem !important;
    margin-bottom: 47rem !important;
  }

  .my-xxl-96 {
    margin-top: 47.5rem !important;
    margin-bottom: 47.5rem !important;
  }

  .my-xxl-97 {
    margin-top: 48rem !important;
    margin-bottom: 48rem !important;
  }

  .my-xxl-98 {
    margin-top: 48.5rem !important;
    margin-bottom: 48.5rem !important;
  }

  .my-xxl-99 {
    margin-top: 49rem !important;
    margin-bottom: 49rem !important;
  }

  .my-xxl-100 {
    margin-top: 49.5rem !important;
    margin-bottom: 49.5rem !important;
  }

  .my-xxl-101 {
    margin-top: 50rem !important;
    margin-bottom: 50rem !important;
  }

  .my-xxl-102 {
    margin-top: 50.5rem !important;
    margin-bottom: 50.5rem !important;
  }

  .my-xxl-103 {
    margin-top: 51rem !important;
    margin-bottom: 51rem !important;
  }

  .my-xxl-104 {
    margin-top: 51.5rem !important;
    margin-bottom: 51.5rem !important;
  }

  .my-xxl-105 {
    margin-top: 52rem !important;
    margin-bottom: 52rem !important;
  }

  .my-xxl-106 {
    margin-top: 52.5rem !important;
    margin-bottom: 52.5rem !important;
  }

  .my-xxl-107 {
    margin-top: 53rem !important;
    margin-bottom: 53rem !important;
  }

  .my-xxl-108 {
    margin-top: 53.5rem !important;
    margin-bottom: 53.5rem !important;
  }

  .my-xxl-109 {
    margin-top: 54rem !important;
    margin-bottom: 54rem !important;
  }

  .my-xxl-110 {
    margin-top: 54.5rem !important;
    margin-bottom: 54.5rem !important;
  }

  .my-xxl-111 {
    margin-top: 55rem !important;
    margin-bottom: 55rem !important;
  }

  .my-xxl-112 {
    margin-top: 55.5rem !important;
    margin-bottom: 55.5rem !important;
  }

  .my-xxl-113 {
    margin-top: 56rem !important;
    margin-bottom: 56rem !important;
  }

  .my-xxl-114 {
    margin-top: 56.5rem !important;
    margin-bottom: 56.5rem !important;
  }

  .my-xxl-115 {
    margin-top: 57rem !important;
    margin-bottom: 57rem !important;
  }

  .my-xxl-116 {
    margin-top: 57.5rem !important;
    margin-bottom: 57.5rem !important;
  }

  .my-xxl-117 {
    margin-top: 58rem !important;
    margin-bottom: 58rem !important;
  }

  .my-xxl-118 {
    margin-top: 58.5rem !important;
    margin-bottom: 58.5rem !important;
  }

  .my-xxl-119 {
    margin-top: 59rem !important;
    margin-bottom: 59rem !important;
  }

  .my-xxl-120 {
    margin-top: 59.5rem !important;
    margin-bottom: 59.5rem !important;
  }

  .my-xxl-121 {
    margin-top: 60rem !important;
    margin-bottom: 60rem !important;
  }

  .my-xxl-122 {
    margin-top: 60.5rem !important;
    margin-bottom: 60.5rem !important;
  }

  .my-xxl-123 {
    margin-top: 61rem !important;
    margin-bottom: 61rem !important;
  }

  .my-xxl-124 {
    margin-top: 61.5rem !important;
    margin-bottom: 61.5rem !important;
  }

  .my-xxl-125 {
    margin-top: 62rem !important;
    margin-bottom: 62rem !important;
  }

  .my-xxl-126 {
    margin-top: 62.5rem !important;
    margin-bottom: 62.5rem !important;
  }

  .my-xxl-127 {
    margin-top: 63rem !important;
    margin-bottom: 63rem !important;
  }

  .my-xxl-128 {
    margin-top: 63.5rem !important;
    margin-bottom: 63.5rem !important;
  }

  .my-xxl-129 {
    margin-top: 64rem !important;
    margin-bottom: 64rem !important;
  }

  .my-xxl-130 {
    margin-top: 64.5rem !important;
    margin-bottom: 64.5rem !important;
  }

  .my-xxl-131 {
    margin-top: 65rem !important;
    margin-bottom: 65rem !important;
  }

  .my-xxl-132 {
    margin-top: 65.5rem !important;
    margin-bottom: 65.5rem !important;
  }

  .my-xxl-133 {
    margin-top: 66rem !important;
    margin-bottom: 66rem !important;
  }

  .my-xxl-134 {
    margin-top: 66.5rem !important;
    margin-bottom: 66.5rem !important;
  }

  .my-xxl-135 {
    margin-top: 67rem !important;
    margin-bottom: 67rem !important;
  }

  .my-xxl-136 {
    margin-top: 67.5rem !important;
    margin-bottom: 67.5rem !important;
  }

  .my-xxl-137 {
    margin-top: 68rem !important;
    margin-bottom: 68rem !important;
  }

  .my-xxl-138 {
    margin-top: 68.5rem !important;
    margin-bottom: 68.5rem !important;
  }

  .my-xxl-139 {
    margin-top: 69rem !important;
    margin-bottom: 69rem !important;
  }

  .my-xxl-140 {
    margin-top: 69.5rem !important;
    margin-bottom: 69.5rem !important;
  }

  .my-xxl-141 {
    margin-top: 70rem !important;
    margin-bottom: 70rem !important;
  }

  .my-xxl-142 {
    margin-top: 70.5rem !important;
    margin-bottom: 70.5rem !important;
  }

  .my-xxl-143 {
    margin-top: 71rem !important;
    margin-bottom: 71rem !important;
  }

  .my-xxl-144 {
    margin-top: 71.5rem !important;
    margin-bottom: 71.5rem !important;
  }

  .my-xxl-145 {
    margin-top: 72rem !important;
    margin-bottom: 72rem !important;
  }

  .my-xxl-146 {
    margin-top: 72.5rem !important;
    margin-bottom: 72.5rem !important;
  }

  .my-xxl-147 {
    margin-top: 73rem !important;
    margin-bottom: 73rem !important;
  }

  .my-xxl-148 {
    margin-top: 73.5rem !important;
    margin-bottom: 73.5rem !important;
  }

  .my-xxl-149 {
    margin-top: 74rem !important;
    margin-bottom: 74rem !important;
  }

  .my-xxl-150 {
    margin-top: 74.5rem !important;
    margin-bottom: 74.5rem !important;
  }

  .my-xxl-151 {
    margin-top: 75rem !important;
    margin-bottom: 75rem !important;
  }

  .my-xxl-152 {
    margin-top: 75.5rem !important;
    margin-bottom: 75.5rem !important;
  }

  .my-xxl-153 {
    margin-top: 76rem !important;
    margin-bottom: 76rem !important;
  }

  .my-xxl-154 {
    margin-top: 76.5rem !important;
    margin-bottom: 76.5rem !important;
  }

  .my-xxl-155 {
    margin-top: 77rem !important;
    margin-bottom: 77rem !important;
  }

  .my-xxl-156 {
    margin-top: 77.5rem !important;
    margin-bottom: 77.5rem !important;
  }

  .my-xxl-157 {
    margin-top: 78rem !important;
    margin-bottom: 78rem !important;
  }

  .my-xxl-158 {
    margin-top: 78.5rem !important;
    margin-bottom: 78.5rem !important;
  }

  .my-xxl-159 {
    margin-top: 79rem !important;
    margin-bottom: 79rem !important;
  }

  .my-xxl-160 {
    margin-top: 79.5rem !important;
    margin-bottom: 79.5rem !important;
  }
}
/*Background Colors*/
.bg-sky-light-5 {
  background-color: rgba(235, 249, 255, var(--bs-bg-opacity)) !important;
}

.bg-sky-light-4 {
  background-color: rgba(199, 238, 255, var(--bs-bg-opacity)) !important;
}

.bg-sky-light-3 {
  background-color: rgba(153, 223, 255, var(--bs-bg-opacity)) !important;
}

.bg-sky-light-2 {
  background-color: rgba(107, 209, 255, var(--bs-bg-opacity)) !important;
}

.bg-sky-light-1 {
  background-color: rgba(61, 195, 255, var(--bs-bg-opacity)) !important;
}

.bg-sky {
  background-color: rgba(0, 176, 255, var(--bs-bg-opacity)) !important;
}

.bg-sky-dark-5 {
  background-color: rgba(0, 88, 128, var(--bs-bg-opacity)) !important;
}

.bg-sky-dark-4 {
  background-color: rgba(0, 106, 153, var(--bs-bg-opacity)) !important;
}

.bg-sky-dark-3 {
  background-color: rgba(0, 123, 179, var(--bs-bg-opacity)) !important;
}

.bg-sky-dark-2 {
  background-color: rgba(0, 141, 204, var(--bs-bg-opacity)) !important;
}

.bg-sky-dark-1 {
  background-color: rgba(0, 158, 230, var(--bs-bg-opacity)) !important;
}

.bg-green-light-5 {
  background-color: rgba(235, 252, 245, var(--bs-bg-opacity)) !important;
}

.bg-green-light-4 {
  background-color: rgba(199, 246, 227, var(--bs-bg-opacity)) !important;
}

.bg-green-light-3 {
  background-color: rgba(153, 239, 204, var(--bs-bg-opacity)) !important;
}

.bg-green-light-2 {
  background-color: rgba(107, 231, 181, var(--bs-bg-opacity)) !important;
}

.bg-green-light-1 {
  background-color: rgba(61, 224, 158, var(--bs-bg-opacity)) !important;
}

.bg-green {
  background-color: rgba(0, 214, 127, var(--bs-bg-opacity)) !important;
}

.bg-green-dark-5 {
  background-color: rgba(0, 107, 64, var(--bs-bg-opacity)) !important;
}

.bg-green-dark-4 {
  background-color: rgba(0, 128, 76, var(--bs-bg-opacity)) !important;
}

.bg-green-dark-3 {
  background-color: rgba(0, 150, 89, var(--bs-bg-opacity)) !important;
}

.bg-green-dark-2 {
  background-color: rgba(0, 171, 102, var(--bs-bg-opacity)) !important;
}

.bg-green-dark-1 {
  background-color: rgba(0, 193, 114, var(--bs-bg-opacity)) !important;
}

.bg-success-light-5 {
  background-color: rgba(235, 252, 245, var(--bs-bg-opacity)) !important;
}

.bg-success-light-4 {
  background-color: rgba(199, 246, 227, var(--bs-bg-opacity)) !important;
}

.bg-success-light-3 {
  background-color: rgba(153, 239, 204, var(--bs-bg-opacity)) !important;
}

.bg-success-light-2 {
  background-color: rgba(107, 231, 181, var(--bs-bg-opacity)) !important;
}

.bg-success-light-1 {
  background-color: rgba(61, 224, 158, var(--bs-bg-opacity)) !important;
}

.bg-success {
  background-color: rgba(0, 214, 127, var(--bs-bg-opacity)) !important;
}

.bg-success-dark-5 {
  background-color: rgba(0, 107, 64, var(--bs-bg-opacity)) !important;
}

.bg-success-dark-4 {
  background-color: rgba(0, 128, 76, var(--bs-bg-opacity)) !important;
}

.bg-success-dark-3 {
  background-color: rgba(0, 150, 89, var(--bs-bg-opacity)) !important;
}

.bg-success-dark-2 {
  background-color: rgba(0, 171, 102, var(--bs-bg-opacity)) !important;
}

.bg-success-dark-1 {
  background-color: rgba(0, 193, 114, var(--bs-bg-opacity)) !important;
}

.bg-yellow-light-5 {
  background-color: rgba(255, 250, 235, var(--bs-bg-opacity)) !important;
}

.bg-yellow-light-4 {
  background-color: rgba(255, 242, 199, var(--bs-bg-opacity)) !important;
}

.bg-yellow-light-3 {
  background-color: rgba(255, 231, 153, var(--bs-bg-opacity)) !important;
}

.bg-yellow-light-2 {
  background-color: rgba(255, 221, 107, var(--bs-bg-opacity)) !important;
}

.bg-yellow-light-1 {
  background-color: rgba(255, 210, 61, var(--bs-bg-opacity)) !important;
}

.bg-yellow {
  background-color: rgba(255, 196, 0, var(--bs-bg-opacity)) !important;
}

.bg-yellow-dark-5 {
  background-color: rgba(128, 98, 0, var(--bs-bg-opacity)) !important;
}

.bg-yellow-dark-4 {
  background-color: rgba(153, 118, 0, var(--bs-bg-opacity)) !important;
}

.bg-yellow-dark-3 {
  background-color: rgba(179, 137, 0, var(--bs-bg-opacity)) !important;
}

.bg-yellow-dark-2 {
  background-color: rgba(204, 157, 0, var(--bs-bg-opacity)) !important;
}

.bg-yellow-dark-1 {
  background-color: rgba(230, 176, 0, var(--bs-bg-opacity)) !important;
}

.bg-warning-light-5 {
  background-color: rgba(255, 250, 235, var(--bs-bg-opacity)) !important;
}

.bg-warning-light-4 {
  background-color: rgba(255, 242, 199, var(--bs-bg-opacity)) !important;
}

.bg-warning-light-3 {
  background-color: rgba(255, 231, 153, var(--bs-bg-opacity)) !important;
}

.bg-warning-light-2 {
  background-color: rgba(255, 221, 107, var(--bs-bg-opacity)) !important;
}

.bg-warning-light-1 {
  background-color: rgba(255, 210, 61, var(--bs-bg-opacity)) !important;
}

.bg-warning {
  background-color: rgba(255, 196, 0, var(--bs-bg-opacity)) !important;
}

.bg-warning-dark-5 {
  background-color: rgba(128, 98, 0, var(--bs-bg-opacity)) !important;
}

.bg-warning-dark-4 {
  background-color: rgba(153, 118, 0, var(--bs-bg-opacity)) !important;
}

.bg-warning-dark-3 {
  background-color: rgba(179, 137, 0, var(--bs-bg-opacity)) !important;
}

.bg-warning-dark-2 {
  background-color: rgba(204, 157, 0, var(--bs-bg-opacity)) !important;
}

.bg-warning-dark-1 {
  background-color: rgba(230, 176, 0, var(--bs-bg-opacity)) !important;
}

.bg-red-light-5 {
  background-color: rgba(255, 235, 235, var(--bs-bg-opacity)) !important;
}

.bg-red-light-4 {
  background-color: rgba(255, 199, 199, var(--bs-bg-opacity)) !important;
}

.bg-red-light-3 {
  background-color: rgba(255, 153, 153, var(--bs-bg-opacity)) !important;
}

.bg-red-light-2 {
  background-color: rgba(255, 107, 107, var(--bs-bg-opacity)) !important;
}

.bg-red-light-1 {
  background-color: rgba(255, 61, 61, var(--bs-bg-opacity)) !important;
}

.bg-red {
  background-color: rgba(255, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-red-dark-5 {
  background-color: rgba(128, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-red-dark-4 {
  background-color: rgba(153, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-red-dark-3 {
  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-red-dark-2 {
  background-color: rgba(204, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-red-dark-1 {
  background-color: rgba(230, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-danger-light-5 {
  background-color: rgba(255, 235, 235, var(--bs-bg-opacity)) !important;
}

.bg-danger-light-4 {
  background-color: rgba(255, 199, 199, var(--bs-bg-opacity)) !important;
}

.bg-danger-light-3 {
  background-color: rgba(255, 153, 153, var(--bs-bg-opacity)) !important;
}

.bg-danger-light-2 {
  background-color: rgba(255, 107, 107, var(--bs-bg-opacity)) !important;
}

.bg-danger-light-1 {
  background-color: rgba(255, 61, 61, var(--bs-bg-opacity)) !important;
}

.bg-danger {
  background-color: rgba(255, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-danger-dark-5 {
  background-color: rgba(128, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-danger-dark-4 {
  background-color: rgba(153, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-danger-dark-3 {
  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-danger-dark-2 {
  background-color: rgba(204, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-danger-dark-1 {
  background-color: rgba(230, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-blue-light-5 {
  background-color: rgba(238, 246, 255, var(--bs-bg-opacity)) !important;
}

.bg-blue-light-4 {
  background-color: rgba(208, 230, 255, var(--bs-bg-opacity)) !important;
}

.bg-blue-light-3 {
  background-color: rgba(169, 209, 255, var(--bs-bg-opacity)) !important;
}

.bg-blue-light-2 {
  background-color: rgba(131, 189, 255, var(--bs-bg-opacity)) !important;
}

.bg-blue-light-1 {
  background-color: rgba(92, 168, 255, var(--bs-bg-opacity)) !important;
}

.bg-blue {
  background-color: rgba(41, 141, 255, var(--bs-bg-opacity)) !important;
}

.bg-blue-dark-5 {
  background-color: rgba(21, 71, 128, var(--bs-bg-opacity)) !important;
}

.bg-blue-dark-4 {
  background-color: rgba(25, 85, 153, var(--bs-bg-opacity)) !important;
}

.bg-blue-dark-3 {
  background-color: rgba(29, 99, 179, var(--bs-bg-opacity)) !important;
}

.bg-blue-dark-2 {
  background-color: rgba(33, 113, 204, var(--bs-bg-opacity)) !important;
}

.bg-blue-dark-1 {
  background-color: rgba(37, 127, 230, var(--bs-bg-opacity)) !important;
}

.bg-primary-light-5 {
  background-color: rgba(8, 54, 77, var(--bs-bg-opacity)) !important;
}

.bg-primary-light-4 {
  background-color: rgba(199, 226, 229, var(--bs-bg-opacity)) !important;
}

.bg-primary-light-3 {
  background-color: rgba(153, 203, 207, var(--bs-bg-opacity)) !important;
}

.bg-primary-light-2 {
  background-color: rgba(107, 180, 186, var(--bs-bg-opacity)) !important;
}

.bg-primary-light-1 {
  background-color: rgba(61, 156, 165, var(--bs-bg-opacity)) !important;
}

.bg-primary {
  background-color: rgba(0, 125, 136, var(--bs-bg-opacity)) !important;
}

.bg-primary-dark-5 {
  background-color: rgba(0, 63, 68, var(--bs-bg-opacity)) !important;
}

.bg-primary-dark-4 {
  background-color: rgba(0, 75, 82, var(--bs-bg-opacity)) !important;
}

.bg-primary-dark-3 {
  background-color: rgba(0, 88, 95, var(--bs-bg-opacity)) !important;
}

.bg-primary-dark-2 {
  background-color: rgba(0, 100, 109, var(--bs-bg-opacity)) !important;
}

.bg-primary-dark-1 {
  background-color: rgba(0, 113, 122, var(--bs-bg-opacity)) !important;
}

.bg-cyan-light-5 {
  background-color: rgba(237, 252, 254, var(--bs-bg-opacity)) !important;
}

.bg-cyan-light-4 {
  background-color: rgba(204, 248, 251, var(--bs-bg-opacity)) !important;
}

.bg-cyan-light-3 {
  background-color: rgba(163, 241, 249, var(--bs-bg-opacity)) !important;
}

.bg-cyan-light-2 {
  background-color: rgba(121, 235, 246, var(--bs-bg-opacity)) !important;
}

.bg-cyan-light-1 {
  background-color: rgba(79, 229, 243, var(--bs-bg-opacity)) !important;
}

.bg-cyan {
  background-color: rgba(24, 221, 239, var(--bs-bg-opacity)) !important;
}

.bg-cyan-dark-5 {
  background-color: rgba(12, 111, 120, var(--bs-bg-opacity)) !important;
}

.bg-cyan-dark-4 {
  background-color: rgba(14, 133, 143, var(--bs-bg-opacity)) !important;
}

.bg-cyan-dark-3 {
  background-color: rgba(17, 155, 167, var(--bs-bg-opacity)) !important;
}

.bg-cyan-dark-2 {
  background-color: rgba(19, 177, 191, var(--bs-bg-opacity)) !important;
}

.bg-cyan-dark-1 {
  background-color: rgba(22, 199, 215, var(--bs-bg-opacity)) !important;
}

.bg-info-light-5 {
  background-color: rgba(237, 252, 254, var(--bs-bg-opacity)) !important;
}

.bg-info-light-4 {
  background-color: rgba(204, 248, 251, var(--bs-bg-opacity)) !important;
}

.bg-info-light-3 {
  background-color: rgba(163, 241, 249, var(--bs-bg-opacity)) !important;
}

.bg-info-light-2 {
  background-color: rgba(121, 235, 246, var(--bs-bg-opacity)) !important;
}

.bg-info-light-1 {
  background-color: rgba(79, 229, 243, var(--bs-bg-opacity)) !important;
}

.bg-info {
  background-color: rgba(24, 221, 239, var(--bs-bg-opacity)) !important;
}

.bg-info-dark-5 {
  background-color: rgba(12, 111, 120, var(--bs-bg-opacity)) !important;
}

.bg-info-dark-4 {
  background-color: rgba(14, 133, 143, var(--bs-bg-opacity)) !important;
}

.bg-info-dark-3 {
  background-color: rgba(17, 155, 167, var(--bs-bg-opacity)) !important;
}

.bg-info-dark-2 {
  background-color: rgba(19, 177, 191, var(--bs-bg-opacity)) !important;
}

.bg-info-dark-1 {
  background-color: rgba(22, 199, 215, var(--bs-bg-opacity)) !important;
}

.bg-grey-light-5 {
  background-color: rgba(247, 247, 247, var(--bs-bg-opacity)) !important;
}

.bg-grey-light-4 {
  background-color: rgba(234, 234, 234, var(--bs-bg-opacity)) !important;
}

.bg-grey-light-3 {
  background-color: rgba(216, 216, 216, var(--bs-bg-opacity)) !important;
}

.bg-grey-light-2 {
  background-color: rgba(199, 199, 199, var(--bs-bg-opacity)) !important;
}

.bg-grey-light-1 {
  background-color: rgba(181, 181, 181, var(--bs-bg-opacity)) !important;
}

.bg-grey {
  background-color: rgba(158, 158, 158, var(--bs-bg-opacity)) !important;
}

.bg-grey-dark-1 {
  background-color: rgba(142, 142, 142, var(--bs-bg-opacity)) !important;
}

.bg-grey-dark-2 {
  background-color: rgba(126, 126, 126, var(--bs-bg-opacity)) !important;
}

.bg-grey-dark-3 {
  background-color: rgba(111, 111, 111, var(--bs-bg-opacity)) !important;
}

.bg-grey-dark-4 {
  background-color: rgba(95, 95, 95, var(--bs-bg-opacity)) !important;
}

.bg-grey-dark-5 {
  background-color: rgba(79, 79, 79, var(--bs-bg-opacity)) !important;
}

.bg-secondary-light-5 {
  background-color: rgba(243, 243, 243, var(--bs-bg-opacity)) !important;
}

.bg-secondary-light-4 {
  background-color: rgba(223, 223, 223, var(--bs-bg-opacity)) !important;
}

.bg-secondary-light-3 {
  background-color: rgba(197, 197, 197, var(--bs-bg-opacity)) !important;
}

.bg-secondary-light-2 {
  background-color: rgba(171, 171, 171, var(--bs-bg-opacity)) !important;
}

.bg-secondary-light-1 {
  background-color: rgba(146, 146, 146, var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  background-color: rgba(111, 111, 111, var(--bs-bg-opacity)) !important;
}

.bg-secondary-dark-1 {
  background-color: rgba(100, 100, 100, var(--bs-bg-opacity)) !important;
}

.bg-secondary-dark-2 {
  background-color: rgba(89, 89, 89, var(--bs-bg-opacity)) !important;
}

.bg-secondary-dark-3 {
  background-color: rgba(78, 78, 78, var(--bs-bg-opacity)) !important;
}

.bg-secondary-dark-4 {
  background-color: rgba(67, 67, 67, var(--bs-bg-opacity)) !important;
}

.bg-secondary-dark-5 {
  background-color: rgba(56, 56, 56, var(--bs-bg-opacity)) !important;
}

.bg-pink-light-5 {
  background-color: rgba(253, 238, 246, var(--bs-bg-opacity)) !important;
}

.bg-pink-light-4 {
  background-color: rgba(250, 208, 231, var(--bs-bg-opacity)) !important;
}

.bg-pink-light-3 {
  background-color: rgba(246, 169, 211, var(--bs-bg-opacity)) !important;
}

.bg-pink-light-2 {
  background-color: rgba(242, 131, 191, var(--bs-bg-opacity)) !important;
}

.bg-pink-light-1 {
  background-color: rgba(238, 92, 171, var(--bs-bg-opacity)) !important;
}

.bg-pink {
  background-color: rgba(233, 41, 144, var(--bs-bg-opacity)) !important;
}

.bg-pink-dark-5 {
  background-color: rgba(117, 21, 72, var(--bs-bg-opacity)) !important;
}

.bg-pink-dark-4 {
  background-color: rgba(140, 25, 86, var(--bs-bg-opacity)) !important;
}

.bg-pink-dark-3 {
  background-color: rgba(163, 29, 101, var(--bs-bg-opacity)) !important;
}

.bg-pink-dark-2 {
  background-color: rgba(186, 33, 115, var(--bs-bg-opacity)) !important;
}

.bg-pink-dark-1 {
  background-color: rgba(210, 37, 130, var(--bs-bg-opacity)) !important;
}

.bg-purple-light-5 {
  background-color: rgba(250, 238, 254, var(--bs-bg-opacity)) !important;
}

.bg-purple-light-4 {
  background-color: rgba(241, 209, 252, var(--bs-bg-opacity)) !important;
}

.bg-purple-light-3 {
  background-color: rgba(230, 172, 250, var(--bs-bg-opacity)) !important;
}

.bg-purple-light-2 {
  background-color: rgba(218, 134, 248, var(--bs-bg-opacity)) !important;
}

.bg-purple-light-1 {
  background-color: rgba(207, 97, 246, var(--bs-bg-opacity)) !important;
}

.bg-purple {
  background-color: rgba(192, 47, 243, var(--bs-bg-opacity)) !important;
}

.bg-purple-dark-5 {
  background-color: rgba(96, 24, 122, var(--bs-bg-opacity)) !important;
}

.bg-purple-dark-4 {
  background-color: rgba(115, 28, 146, var(--bs-bg-opacity)) !important;
}

.bg-purple-dark-3 {
  background-color: rgba(134, 33, 170, var(--bs-bg-opacity)) !important;
}

.bg-purple-dark-2 {
  background-color: rgba(154, 38, 194, var(--bs-bg-opacity)) !important;
}

.bg-purple-dark-1 {
  background-color: rgba(173, 42, 219, var(--bs-bg-opacity)) !important;
}

.bg-violet-light-5 {
  background-color: rgba(244, 238, 254, var(--bs-bg-opacity)) !important;
}

.bg-violet-light-4 {
  background-color: rgba(224, 208, 253, var(--bs-bg-opacity)) !important;
}

.bg-violet-light-3 {
  background-color: rgba(199, 169, 252, var(--bs-bg-opacity)) !important;
}

.bg-violet-light-2 {
  background-color: rgba(174, 131, 251, var(--bs-bg-opacity)) !important;
}

.bg-violet-light-1 {
  background-color: rgba(149, 92, 250, var(--bs-bg-opacity)) !important;
}

.bg-violet {
  background-color: rgba(116, 41, 248, var(--bs-bg-opacity)) !important;
}

.bg-violet-dark-5 {
  background-color: rgba(58, 21, 124, var(--bs-bg-opacity)) !important;
}

.bg-violet-dark-4 {
  background-color: rgba(70, 25, 149, var(--bs-bg-opacity)) !important;
}

.bg-violet-dark-3 {
  background-color: rgba(81, 29, 174, var(--bs-bg-opacity)) !important;
}

.bg-violet-dark-2 {
  background-color: rgba(93, 33, 198, var(--bs-bg-opacity)) !important;
}

.bg-violet-dark-1 {
  background-color: rgba(104, 37, 223, var(--bs-bg-opacity)) !important;
}

.bg-indigo-light-5 {
  background-color: rgba(235, 243, 254, var(--bs-bg-opacity)) !important;
}

.bg-indigo-light-4 {
  background-color: rgba(199, 222, 253, var(--bs-bg-opacity)) !important;
}

.bg-indigo-light-3 {
  background-color: rgba(153, 195, 252, var(--bs-bg-opacity)) !important;
}

.bg-indigo-light-2 {
  background-color: rgba(107, 168, 250, var(--bs-bg-opacity)) !important;
}

.bg-indigo-light-1 {
  background-color: rgba(61, 141, 249, var(--bs-bg-opacity)) !important;
}

.bg-indigo {
  background-color: rgba(0, 105, 247, var(--bs-bg-opacity)) !important;
}

.bg-indigo-dark-5 {
  background-color: rgba(0, 53, 124, var(--bs-bg-opacity)) !important;
}

.bg-indigo-dark-4 {
  background-color: rgba(0, 63, 148, var(--bs-bg-opacity)) !important;
}

.bg-indigo-dark-3 {
  background-color: rgba(0, 74, 173, var(--bs-bg-opacity)) !important;
}

.bg-indigo-dark-2 {
  background-color: rgba(0, 84, 198, var(--bs-bg-opacity)) !important;
}

.bg-indigo-dark-1 {
  background-color: rgba(0, 95, 222, var(--bs-bg-opacity)) !important;
}

.bg-teal-light-5 {
  background-color: rgba(235, 245, 245, var(--bs-bg-opacity)) !important;
}

.bg-teal-light-4 {
  background-color: rgba(199, 226, 229, var(--bs-bg-opacity)) !important;
}

.bg-teal-light-3 {
  background-color: rgba(153, 203, 207, var(--bs-bg-opacity)) !important;
}

.bg-teal-light-2 {
  background-color: rgba(107, 180, 186, var(--bs-bg-opacity)) !important;
}

.bg-teal-light-1 {
  background-color: rgba(61, 156, 165, var(--bs-bg-opacity)) !important;
}

.bg-teal {
  background-color: rgba(0, 125, 136, var(--bs-bg-opacity)) !important;
}

.bg-teal-dark-5 {
  background-color: rgba(0, 63, 68, var(--bs-bg-opacity)) !important;
}

.bg-teal-dark-4 {
  background-color: rgba(0, 75, 82, var(--bs-bg-opacity)) !important;
}

.bg-teal-dark-3 {
  background-color: rgba(0, 88, 95, var(--bs-bg-opacity)) !important;
}

.bg-teal-dark-2 {
  background-color: rgba(0, 100, 109, var(--bs-bg-opacity)) !important;
}

.bg-teal-dark-1 {
  background-color: rgba(0, 113, 122, var(--bs-bg-opacity)) !important;
}

.bg-neon-light-5 {
  background-color: rgba(245, 253, 238, var(--bs-bg-opacity)) !important;
}

.bg-neon-light-4 {
  background-color: rgba(227, 249, 209, var(--bs-bg-opacity)) !important;
}

.bg-neon-light-3 {
  background-color: rgba(205, 243, 172, var(--bs-bg-opacity)) !important;
}

.bg-neon-light-2 {
  background-color: rgba(182, 238, 135, var(--bs-bg-opacity)) !important;
}

.bg-neon-light-1 {
  background-color: rgba(159, 233, 98, var(--bs-bg-opacity)) !important;
}

.bg-neon {
  background-color: rgba(129, 226, 48, var(--bs-bg-opacity)) !important;
}

.bg-neon-dark-5 {
  background-color: rgba(65, 113, 24, var(--bs-bg-opacity)) !important;
}

.bg-neon-dark-4 {
  background-color: rgba(77, 136, 29, var(--bs-bg-opacity)) !important;
}

.bg-neon-dark-3 {
  background-color: rgba(90, 158, 34, var(--bs-bg-opacity)) !important;
}

.bg-neon-dark-2 {
  background-color: rgba(103, 181, 38, var(--bs-bg-opacity)) !important;
}

.bg-neon-dark-1 {
  background-color: rgba(116, 203, 43, var(--bs-bg-opacity)) !important;
}

.bg-lime-light-5 {
  background-color: rgba(250, 253, 239, var(--bs-bg-opacity)) !important;
}

.bg-lime-light-4 {
  background-color: rgba(242, 250, 211, var(--bs-bg-opacity)) !important;
}

.bg-lime-light-3 {
  background-color: rgba(231, 246, 176, var(--bs-bg-opacity)) !important;
}

.bg-lime-light-2 {
  background-color: rgba(220, 242, 140, var(--bs-bg-opacity)) !important;
}

.bg-lime-light-1 {
  background-color: rgba(209, 238, 105, var(--bs-bg-opacity)) !important;
}

.bg-lime {
  background-color: rgba(194, 233, 57, var(--bs-bg-opacity)) !important;
}

.bg-lime-dark-5 {
  background-color: rgba(97, 117, 29, var(--bs-bg-opacity)) !important;
}

.bg-lime-dark-4 {
  background-color: rgba(116, 140, 34, var(--bs-bg-opacity)) !important;
}

.bg-lime-dark-3 {
  background-color: rgba(136, 163, 40, var(--bs-bg-opacity)) !important;
}

.bg-lime-dark-2 {
  background-color: rgba(155, 186, 46, var(--bs-bg-opacity)) !important;
}

.bg-lime-dark-1 {
  background-color: rgba(175, 210, 51, var(--bs-bg-opacity)) !important;
}

.bg-sun-light-5 {
  background-color: rgba(255, 253, 235, var(--bs-bg-opacity)) !important;
}

.bg-sun-light-4 {
  background-color: rgba(255, 250, 199, var(--bs-bg-opacity)) !important;
}

.bg-sun-light-3 {
  background-color: rgba(255, 247, 153, var(--bs-bg-opacity)) !important;
}

.bg-sun-light-2 {
  background-color: rgba(255, 243, 107, var(--bs-bg-opacity)) !important;
}

.bg-sun-light-1 {
  background-color: rgba(255, 239, 61, var(--bs-bg-opacity)) !important;
}

.bg-sun {
  background-color: rgba(255, 234, 0, var(--bs-bg-opacity)) !important;
}

.bg-sun-dark-5 {
  background-color: rgba(128, 117, 0, var(--bs-bg-opacity)) !important;
}

.bg-sun-dark-4 {
  background-color: rgba(153, 140, 0, var(--bs-bg-opacity)) !important;
}

.bg-sun-dark-3 {
  background-color: rgba(179, 164, 0, var(--bs-bg-opacity)) !important;
}

.bg-sun-dark-2 {
  background-color: rgba(204, 187, 0, var(--bs-bg-opacity)) !important;
}

.bg-sun-dark-1 {
  background-color: rgba(230, 211, 0, var(--bs-bg-opacity)) !important;
}

.bg-orange-light-5 {
  background-color: rgba(255, 246, 235, var(--bs-bg-opacity)) !important;
}

.bg-orange-light-4 {
  background-color: rgba(255, 231, 199, var(--bs-bg-opacity)) !important;
}

.bg-orange-light-3 {
  background-color: rgba(255, 211, 153, var(--bs-bg-opacity)) !important;
}

.bg-orange-light-2 {
  background-color: rgba(255, 191, 107, var(--bs-bg-opacity)) !important;
}

.bg-orange-light-1 {
  background-color: rgba(255, 171, 61, var(--bs-bg-opacity)) !important;
}

.bg-orange {
  background-color: rgba(255, 145, 0, var(--bs-bg-opacity)) !important;
}

.bg-orange-dark-5 {
  background-color: rgba(128, 73, 0, var(--bs-bg-opacity)) !important;
}

.bg-orange-dark-4 {
  background-color: rgba(153, 87, 0, var(--bs-bg-opacity)) !important;
}

.bg-orange-dark-3 {
  background-color: rgba(179, 102, 0, var(--bs-bg-opacity)) !important;
}

.bg-orange-dark-2 {
  background-color: rgba(204, 116, 0, var(--bs-bg-opacity)) !important;
}

.bg-orange-dark-1 {
  background-color: rgba(230, 131, 0, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-light-5 {
  background-color: rgba(255, 242, 235, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-light-4 {
  background-color: rgba(255, 218, 199, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-light-3 {
  background-color: rgba(255, 188, 153, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-light-2 {
  background-color: rgba(255, 158, 107, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-light-1 {
  background-color: rgba(255, 127, 61, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin {
  background-color: rgba(255, 87, 0, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-dark-5 {
  background-color: rgba(128, 44, 0, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-dark-4 {
  background-color: rgba(153, 52, 0, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-dark-3 {
  background-color: rgba(179, 61, 0, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-dark-2 {
  background-color: rgba(204, 70, 0, var(--bs-bg-opacity)) !important;
}

.bg-pumpkin-dark-1 {
  background-color: rgba(230, 78, 0, var(--bs-bg-opacity)) !important;
}

.bg-brown-light-5 {
  background-color: rgba(247, 241, 236, var(--bs-bg-opacity)) !important;
}

.bg-brown-light-4 {
  background-color: rgba(232, 216, 204, var(--bs-bg-opacity)) !important;
}

.bg-brown-light-3 {
  background-color: rgba(213, 184, 161, var(--bs-bg-opacity)) !important;
}

.bg-brown-light-2 {
  background-color: rgba(194, 152, 119, var(--bs-bg-opacity)) !important;
}

.bg-brown-light-1 {
  background-color: rgba(174, 120, 77, var(--bs-bg-opacity)) !important;
}

.bg-brown {
  background-color: rgba(149, 77, 21, var(--bs-bg-opacity)) !important;
}

.bg-brown-dark-5 {
  background-color: rgba(75, 39, 11, var(--bs-bg-opacity)) !important;
}

.bg-brown-dark-4 {
  background-color: rgba(89, 46, 13, var(--bs-bg-opacity)) !important;
}

.bg-brown-dark-3 {
  background-color: rgba(104, 54, 15, var(--bs-bg-opacity)) !important;
}

.bg-brown-dark-2 {
  background-color: rgba(119, 62, 17, var(--bs-bg-opacity)) !important;
}

.bg-brown-dark-1 {
  background-color: rgba(134, 69, 19, var(--bs-bg-opacity)) !important;
}

.bg-gold-light-5 {
  background-color: rgba(250, 247, 240, var(--bs-bg-opacity)) !important;
}

.bg-gold-light-4 {
  background-color: rgba(242, 232, 215, var(--bs-bg-opacity)) !important;
}

.bg-gold-light-3 {
  background-color: rgba(231, 213, 182, var(--bs-bg-opacity)) !important;
}

.bg-gold-light-2 {
  background-color: rgba(220, 195, 149, var(--bs-bg-opacity)) !important;
}

.bg-gold-light-1 {
  background-color: rgba(209, 176, 117, var(--bs-bg-opacity)) !important;
}

.bg-gold {
  background-color: rgba(195, 151, 73, var(--bs-bg-opacity)) !important;
}

.bg-gold-dark-5 {
  background-color: rgba(98, 76, 37, var(--bs-bg-opacity)) !important;
}

.bg-gold-dark-4 {
  background-color: rgba(117, 91, 44, var(--bs-bg-opacity)) !important;
}

.bg-gold-dark-3 {
  background-color: rgba(137, 106, 51, var(--bs-bg-opacity)) !important;
}

.bg-gold-dark-2 {
  background-color: rgba(156, 121, 58, var(--bs-bg-opacity)) !important;
}

.bg-gold-dark-1 {
  background-color: rgba(176, 136, 66, var(--bs-bg-opacity)) !important;
}

.bg-smoke-light-5 {
  background-color: rgba(242, 245, 246, var(--bs-bg-opacity)) !important;
}

.bg-smoke-light-4 {
  background-color: rgba(220, 226, 229, var(--bs-bg-opacity)) !important;
}

.bg-smoke-light-3 {
  background-color: rgba(191, 203, 208, var(--bs-bg-opacity)) !important;
}

.bg-smoke-light-2 {
  background-color: rgba(162, 180, 187, var(--bs-bg-opacity)) !important;
}

.bg-smoke-light-1 {
  background-color: rgba(133, 156, 166, var(--bs-bg-opacity)) !important;
}

.bg-smoke {
  background-color: rgba(94, 125, 138, var(--bs-bg-opacity)) !important;
}

.bg-smoke-dark-5 {
  background-color: rgba(47, 63, 69, var(--bs-bg-opacity)) !important;
}

.bg-smoke-dark-4 {
  background-color: rgba(56, 75, 83, var(--bs-bg-opacity)) !important;
}

.bg-smoke-dark-3 {
  background-color: rgba(66, 88, 97, var(--bs-bg-opacity)) !important;
}

.bg-smoke-dark-2 {
  background-color: rgba(75, 100, 110, var(--bs-bg-opacity)) !important;
}

.bg-smoke-dark-1 {
  background-color: rgba(85, 113, 124, var(--bs-bg-opacity)) !important;
}

.bg-white {
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.bg-light {
  background-color: rgba(247, 247, 247, var(--bs-bg-opacity)) !important;
}

.bg-dark-10 {
  background-color: rgba(47, 52, 58, var(--bs-bg-opacity)) !important;
}

.bg-dark-20 {
  background-color: rgba(42, 47, 52, var(--bs-bg-opacity)) !important;
}

.bg-dark,
.bg-dark-40 {
  background-color: rgba(38, 42, 46, var(--bs-bg-opacity)) !important;
}

.bg-dark-60 {
  background-color: rgba(33, 36, 41, var(--bs-bg-opacity)) !important;
}

.bg-dark-80 {
  background-color: rgba(28, 31, 35, var(--bs-bg-opacity)) !important;
}

.bg-dark-100 {
  background-color: rgba(24, 26, 29, var(--bs-bg-opacity)) !important;
}

.bg-twitter {
  background-color: #00acee !important;
}

.bg-facebook {
  background-color: #1778F2 !important;
}

.bg-gradient-primary {
  background: #0a2f4c;
  background: linear-gradient(45deg, #0a2f4c, #955cfa) !important;
}

.bg-gradient-info {
  background: #18DDEF;
  background: linear-gradient(45deg, #18DDEF, #0a2f4c) !important;
}

.bg-gradient-success {
  background: #00D67F;
  background: linear-gradient(45deg, #00D67F, #81E230) !important;
}

.bg-gradient-warning {
  background: #FFC400;
  background: linear-gradient(45deg, #FFC400, #FFEA00) !important;
}

.bg-gradient-danger {
  background: #ff3d3d;
  background: linear-gradient(45deg, #ff3d3d, #E92990) !important;
}

.bg-gradient-secondary {
  background: #6f6f6f;
  background: linear-gradient(45deg, #6f6f6f, #d8d8d8) !important;
}

.bg-gradient-light {
  background: #b5b5b5;
  background: linear-gradient(45deg, #b5b5b5, #f7f7f7) !important;
}

.bg-gradient-dark {
  background: #262a2e;
  background: linear-gradient(45deg, #262a2e, #6f6f6f) !important;
}

.bg-gradient-pony {
  background: #f6a9d3;
  background: linear-gradient(45deg, #f6a9d3, #4fe5f3) !important;
}

.bg-gradient-space {
  background: #cf61f6;
  background: linear-gradient(45deg, #cf61f6, #ffdd6b) !important;
}

.bg-gradient-streaks {
  background: #7429F8;
  background: linear-gradient(45deg, #7429F8, #0a2f4c) !important;
}

.bg-gradient-bunting {
  background: #5ca8ff;
  background: linear-gradient(45deg, #5ca8ff, #d5b8a1) !important;
}

.bg-gradient-paradise {
  background: #00357c;
  background: linear-gradient(45deg, #00357c, #7429F8) !important;
}

.bg-gradient-heaven {
  background: #81E230;
  background: linear-gradient(45deg, #81E230, #00B0FF) !important;
}

.bg-gradient-honey {
  background: #C2E939;
  background: linear-gradient(45deg, #C2E939, #FF9100) !important;
}

.bg-gradient-warbler {
  background: #FFEA00;
  background: linear-gradient(45deg, #FFEA00, #9e9e9e) !important;
}

.bg-gradient-dusk {
  background: #ff7f3d;
  background: linear-gradient(45deg, #ff7f3d, #955cfa) !important;
}

.bg-gradient-citrine {
  background: #ba2173;
  background: linear-gradient(45deg, #ba2173, #68360f) !important;
}

.bg-gradient-royston {
  background: #6be7b5;
  background: linear-gradient(45deg, #6be7b5, #c29877) !important;
}

.bg-gradient-ashes {
  background: #2f3f45;
  background: linear-gradient(45deg, #2f3f45, #4b646e) !important;
}

.bg-gradient-metal {
  background: #C39749;
  background: linear-gradient(45deg, #C39749, #9e9e9e) !important;
}

.bg-gradient-sunset {
  background: #ff7f3d;
  background: linear-gradient(45deg, #ff7f3d, #ffab3d) !important;
}

.overlay-wrap {
  position: relative;
}
.overlay-wrap .bg-overlay {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}

/*Text Colors*/
.text-sky {
  color: rgba(0, 176, 255, var(--bs-text-opacity)) !important;
}

.text-cyan {
  color: rgba(24, 221, 239, var(--bs-text-opacity)) !important;
}

.text-info {
  color: rgba(24, 221, 239, var(--bs-text-opacity)) !important;
}

.text-green {
  color: rgba(0, 214, 127, var(--bs-text-opacity)) !important;
}

.text-success {
  color: rgba(0, 214, 127, var(--bs-text-opacity)) !important;
}

.text-yellow {
  color: rgba(255, 196, 0, var(--bs-text-opacity)) !important;
}

.text-warning {
  color: rgba(255, 196, 0, var(--bs-text-opacity)) !important;
}

.text-red {
  color: rgba(255, 0, 0, var(--bs-text-opacity)) !important;
}

.text-danger {
  color: rgba(255, 0, 0, var(--bs-text-opacity)) !important;
}

.text-blue {
  color: rgba(41, 141, 255, var(--bs-text-opacity)) !important;
}

.text-primary {
  color: rgba(0, 125, 136, var(--bs-text-opacity)) !important;
}

.text-pink {
  color: rgba(233, 41, 144, var(--bs-text-opacity)) !important;
}

.text-purple {
  color: rgba(192, 47, 243, var(--bs-text-opacity)) !important;
}

.text-violet {
  color: rgba(116, 41, 248, var(--bs-text-opacity)) !important;
}

.text-indigo {
  color: rgba(0, 105, 247, var(--bs-text-opacity)) !important;
}

.text-teal {
  color: rgba(0, 125, 136, var(--bs-text-opacity)) !important;
}

.text-neon {
  color: rgba(129, 226, 48, var(--bs-text-opacity)) !important;
}

.text-lime {
  color: rgba(194, 233, 57, var(--bs-text-opacity)) !important;
}

.text-sun {
  color: rgba(255, 234, 0, var(--bs-text-opacity)) !important;
}

.text-orange {
  color: rgba(255, 145, 0, var(--bs-text-opacity)) !important;
}

.text-pumpkin {
  color: rgba(255, 87, 0, var(--bs-text-opacity)) !important;
}

.text-brown {
  color: rgba(149, 77, 21, var(--bs-text-opacity)) !important;
}

.text-gold {
  color: rgba(195, 151, 73, var(--bs-text-opacity)) !important;
}

.text-smoke {
  color: rgba(94, 125, 138, var(--bs-text-opacity)) !important;
}

.text-muted {
  color: rgba(111, 111, 111, var(--bs-text-opacity)) !important;
}

.text-secondary {
  color: rgba(111, 111, 111, var(--bs-text-opacity)) !important;
}

.text-grey {
  color: rgba(158, 158, 158, var(--bs-text-opacity)) !important;
}

.text-dark-10 {
  color: rgba(47, 52, 58, var(--bs-text-opacity)) !important;
}

.text-dark-20 {
  color: rgba(42, 47, 52, var(--bs-text-opacity)) !important;
}

.text-dark,
.text-dark-40 {
  color: rgba(38, 42, 46, var(--bs-text-opacity)) !important;
}

.text-dark-60 {
  color: rgba(33, 36, 41, var(--bs-text-opacity)) !important;
}

.text-dark-80 {
  color: rgba(28, 31, 35, var(--bs-text-opacity)) !important;
}

.text-dark-100 {
  color: rgba(24, 26, 29, var(--bs-text-opacity)) !important;
}

.text-light {
  color: rgba(126, 126, 126, var(--bs-text-opacity)) !important;
}

.text-white {
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.text-body {
  color: rgba(111, 111, 111, var(--bs-text-opacity)) !important;
}

.text-disabled {
  color: rgba(181, 181, 181, var(--bs-text-opacity)) !important;
}

.text-high-em {
  color: #262a2e;
  font-weight: 500;
}

.text-medium-em {
  color: #262a2e;
  font-size: .875rem;
}

.text-low-em {
  font-size: .75rem;
}

/*Border*/
.border-dashed {
  border-style: dashed !important;
}

.border-dotted {
  border-style: dotted !important;
}

.circle {
  border-radius: 50% !important;
}

.rounded-pill-start {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
}

.rounded-pill-end {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
}

.rounded-top-start {
  border-top-left-radius: 0.25rem !important;
}

.rounded-top-end {
  border-top-right-radius: 0.25rem !important;
}

.rounded-bottom-start {
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-bottom-end {
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-start-0 {
  border-top-left-radius: 0 !important;
}

.rounded-top-end-0 {
  border-top-right-radius: 0 !important;
}

.rounded-start-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-bottom-start-0 {
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-end-0 {
  border-bottom-right-radius: 0 !important;
}

.rounded-0 {
  border-radius: 0rem !important;
}

.rounded-1 {
  border-radius: 0.125rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 0.375rem !important;
}

.rounded-4 {
  border-radius: 0.5rem !important;
}

.rounded-5 {
  border-radius: 0.625rem !important;
}

.rounded-6 {
  border-radius: 0.75rem !important;
}

.rounded-7 {
  border-radius: 0.875rem !important;
}

.rounded-8 {
  border-radius: 1rem !important;
}

.rounded-9 {
  border-radius: 1.125rem !important;
}

.rounded-10 {
  border-radius: 1.25rem !important;
}

.rounded-11 {
  border-radius: 1.375rem !important;
}

.rounded-12 {
  border-radius: 1.5rem !important;
}

.rounded-13 {
  border-radius: 1.625rem !important;
}

.rounded-14 {
  border-radius: 1.75rem !important;
}

.rounded-15 {
  border-radius: 1.875rem !important;
}

.rounded-16 {
  border-radius: 2rem !important;
}

.rounded-17 {
  border-radius: 2.125rem !important;
}

.rounded-18 {
  border-radius: 2.25rem !important;
}

.rounded-19 {
  border-radius: 2.375rem !important;
}

.rounded-20 {
  border-radius: 2.5rem !important;
}

.rounded-21 {
  border-radius: 2.75rem !important;
}

.rounded-22 {
  border-radius: 3rem !important;
}

.rounded-23 {
  border-radius: 3.25rem !important;
}

.rounded-24 {
  border-radius: 3.5rem !important;
}

.rounded-25 {
  border-radius: 3.75rem !important;
}

.rounded-26 {
  border-radius: 4rem !important;
}

.rounded-27 {
  border-radius: 4.25rem !important;
}

.rounded-28 {
  border-radius: 4.5rem !important;
}

.rounded-29 {
  border-radius: 4.75rem !important;
}

.rounded-30 {
  border-radius: 5rem !important;
}

.rounded-31 {
  border-radius: 5.25rem !important;
}

.rounded-32 {
  border-radius: 5.5rem !important;
}

.rounded-33 {
  border-radius: 5.75rem !important;
}

.rounded-34 {
  border-radius: 6rem !important;
}

.border-sky {
  border-color: #00B0FF !important;
}

.border-cyan {
  border-color: #18DDEF !important;
}

.border-info {
  border-color: #18DDEF !important;
}

.border-red {
  border-color: #FF0000 !important;
}

.border-danger {
  border-color: #FF0000 !important;
}

.border-green {
  border-color: #00D67F !important;
}

.border-success {
  border-color: #00D67F !important;
}

.border-yellow {
  border-color: #FFC400 !important;
}

.border-warning {
  border-color: #FFC400 !important;
}

.border-pink {
  border-color: #E92990 !important;
}

.border-purple {
  border-color: #C02FF3 !important;
}

.border-violet {
  border-color: #7429F8 !important;
}

.border-indigo {
  border-color: #0069F7 !important;
}

.border-blue {
  border-color: #298DFF !important;
}

.border-primary {
  border-color: #0a2f4c !important;
}

.border-teal {
  border-color: #0a2f4c !important;
}

.border-neon {
  border-color: #81E230 !important;
}

.border-lime {
  border-color: #C2E939 !important;
}

.border-sun {
  border-color: #FFEA00 !important;
}

.border-orange {
  border-color: #FF9100 !important;
}

.border-pumpkin {
  border-color: #FF5700 !important;
}

.border-brown {
  border-color: #954D15 !important;
}

.border-gold {
  border-color: #C39749 !important;
}

.border-smoke {
  border-color: #5e7d8a !important;
}

.border-white {
  border-color: #fff !important;
}

.border-light {
  border-color: #d8d8d8 !important;
}

.border-dark-10 {
  border-color: #2F343A !important;
}

.border-dark-20 {
  border-color: #2a2f34 !important;
}

.border-dark,
.border-dark-40 {
  border-color: #262a2e !important;
}

.border-dark-60 {
  border-color: #212429 !important;
}

.border-dark-80 {
  border-color: #1c1f23 !important;
}

.border-dark-100 {
  border-color: #181a1d !important;
}

.border-grey {
  border-color: #9e9e9e !important;
}

.border-secondary {
  border-color: #6f6f6f !important;
}

.subtractive-example > .d-inline-block {
  border: 1px solid #9e9e9e;
}

/*Colors*/
.color-palette-wrap .color-wrap {
  padding: 1rem;
}

/*Shadow*/
.shadow-none {
  box-shadow: none !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover-sm {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover {
  transition: box-shadow 0.3s ease;
}
.shadow-hover:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-lg {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover-lg {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-xl {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover-xl {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-sm-sky {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sm-sky.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sm-sky.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sm-sky.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sm-sky.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-hover-sm-sky {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-sky:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sm-sky:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sm-sky:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sm-sky:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sm-sky:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-sky {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sky.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sky.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sky.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-sky.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-hover-sky {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sky:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sky:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sky:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sky:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-sky:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-lg-sky {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-lg-sky.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-lg-sky.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-lg-sky.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-lg-sky.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-hover-lg-sky {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-sky:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-lg-sky:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-lg-sky:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-lg-sky:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-lg-sky:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-xl-sky {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-xl-sky.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-xl-sky.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-xl-sky.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-xl-sky.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-hover-xl-sky {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-sky:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-xl-sky:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-xl-sky:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-xl-sky:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}
.shadow-hover-xl-sky:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;
}

.shadow-sm-cyan {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-cyan.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-cyan.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-cyan.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-cyan.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-sm-cyan {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-cyan:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-cyan:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-cyan:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-cyan:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-cyan:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-cyan {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-cyan.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-cyan.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-cyan.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-cyan.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-cyan {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-cyan:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-cyan:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-cyan:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-cyan:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-cyan:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-lg-cyan {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-cyan.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-cyan.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-cyan.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-cyan.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-lg-cyan {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-cyan:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-cyan:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-cyan:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-cyan:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-cyan:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-xl-cyan {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-cyan.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-cyan.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-cyan.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-cyan.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-xl-cyan {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-cyan:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-cyan:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-cyan:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-cyan:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-cyan:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-sm-info {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-info.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-info.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-info.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-sm-info.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-sm-info {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-info:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-info:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-info:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-info:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-sm-info:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-info {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-info.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-info.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-info.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-info.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-info {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-info:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-info:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-info:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-info:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-info:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-lg-info {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-info.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-info.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-info.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-lg-info.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-lg-info {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-info:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-info:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-info:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-info:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-lg-info:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-xl-info {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-info.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-info.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-info.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-xl-info.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-hover-xl-info {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-info:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-info:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-info:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-info:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}
.shadow-hover-xl-info:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;
}

.shadow-sm-green {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-green.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-green.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-green.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-green.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-sm-green {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-green:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-green:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-green:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-green:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-green:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-green {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-green.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-green.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-green.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-green.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-green {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-green:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-green:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-green:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-green:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-green:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-lg-green {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-green.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-green.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-green.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-green.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-lg-green {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-green:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-green:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-green:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-green:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-green:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-xl-green {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-green.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-green.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-green.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-green.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-xl-green {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-green:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-green:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-green:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-green:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-green:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-sm-success {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-success.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-success.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-success.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-sm-success.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-sm-success {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-success:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-success:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-success:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-success:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-sm-success:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-success {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-success.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-success.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-success.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-success.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-success {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-success:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-success:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-success:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-success:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-success:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-lg-success {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-success.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-success.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-success.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-lg-success.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-lg-success {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-success:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-success:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-success:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-success:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-lg-success:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-xl-success {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-success.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-success.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-success.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-xl-success.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-hover-xl-success {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-success:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-success:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-success:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-success:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}
.shadow-hover-xl-success:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;
}

.shadow-sm-yellow {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-yellow.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-yellow.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-yellow.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-yellow.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-sm-yellow {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-yellow:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-yellow:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-yellow:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-yellow:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-yellow:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-yellow {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-yellow.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-yellow.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-yellow.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-yellow.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-yellow {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-yellow:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-yellow:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-yellow:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-yellow:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-yellow:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-lg-yellow {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-yellow.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-yellow.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-yellow.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-yellow.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-lg-yellow {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-yellow:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-yellow:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-yellow:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-yellow:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-yellow:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-xl-yellow {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-yellow.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-yellow.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-yellow.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-yellow.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-xl-yellow {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-yellow:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-yellow:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-yellow:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-yellow:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-yellow:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-sm-warning {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-warning.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-warning.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-warning.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-sm-warning.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-sm-warning {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-warning:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-warning:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-warning:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-warning:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-sm-warning:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-warning {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-warning.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-warning.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-warning.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-warning.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-warning {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-warning:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-warning:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-warning:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-warning:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-warning:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-lg-warning {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-warning.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-warning.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-warning.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-lg-warning.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-lg-warning {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-warning:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-warning:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-warning:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-warning:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-lg-warning:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-xl-warning {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-warning.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-warning.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-warning.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-xl-warning.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-hover-xl-warning {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-warning:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-warning:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-warning:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-warning:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}
.shadow-hover-xl-warning:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;
}

.shadow-sm-red {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-red.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-red.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-red.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-red.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-sm-red {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-red:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-red:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-red:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-red:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-red:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-red {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-red.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-red.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-red.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-red.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-red {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-red:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-red:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-red:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-red:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-red:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-lg-red {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-red.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-red.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-red.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-red.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-lg-red {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-red:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-red:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-red:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-red:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-red:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-xl-red {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-red.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-red.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-red.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-red.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-xl-red {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-red:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-red:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-red:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-red:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-red:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-sm-danger {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-danger.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-danger.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-danger.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-sm-danger.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-sm-danger {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-danger:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-danger:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-danger:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-danger:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-sm-danger:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-danger {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-danger.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-danger.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-danger.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-danger.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-danger {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-danger:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-danger:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-danger:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-danger:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-danger:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-lg-danger {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-danger.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-danger.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-danger.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-lg-danger.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-lg-danger {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-danger:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-danger:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-danger:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-danger:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-lg-danger:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-xl-danger {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-danger.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-danger.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-danger.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-xl-danger.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-hover-xl-danger {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-danger:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-danger:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-danger:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-danger:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}
.shadow-hover-xl-danger:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;
}

.shadow-sm-blue {
  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-sm-blue.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-sm-blue.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-sm-blue.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-sm-blue.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-hover-sm-blue {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-blue:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-sm-blue:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-sm-blue:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-sm-blue:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-sm-blue:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-blue {
  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-blue.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-blue.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-blue.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-blue.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-hover-blue {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-blue:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-blue:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-blue:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-blue:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-blue:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-lg-blue {
  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-lg-blue.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-lg-blue.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-lg-blue.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-lg-blue.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-hover-lg-blue {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-blue:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-lg-blue:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-lg-blue:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-lg-blue:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-lg-blue:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-xl-blue {
  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-xl-blue.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-xl-blue.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-xl-blue.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-xl-blue.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-hover-xl-blue {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-blue:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-xl-blue:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-xl-blue:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-xl-blue:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}
.shadow-hover-xl-blue:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;
}

.shadow-sm-primary {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-primary.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-primary.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-primary.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-primary.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-sm-primary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-primary:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-primary:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-primary:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-primary:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-primary:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-primary {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-primary.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-primary.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-primary.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-primary.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-primary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-primary:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-primary:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-primary:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-primary:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-primary:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-lg-primary {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-primary.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-primary.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-primary.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-primary.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-lg-primary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-primary:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-primary:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-primary:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-primary:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-primary:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-xl-primary {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-primary.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-primary.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-primary.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-primary.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-xl-primary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-primary:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-primary:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-primary:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-primary:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-primary:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-sm-pink {
  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-sm-pink.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-sm-pink.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-sm-pink.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-sm-pink.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-hover-sm-pink {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-pink:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-sm-pink:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-sm-pink:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-sm-pink:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-sm-pink:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-pink {
  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-pink.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-pink.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-pink.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-pink.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-hover-pink {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-pink:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-pink:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-pink:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-pink:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-pink:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-lg-pink {
  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-lg-pink.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-lg-pink.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-lg-pink.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-lg-pink.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-hover-lg-pink {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-pink:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-lg-pink:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-lg-pink:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-lg-pink:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-lg-pink:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-xl-pink {
  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-xl-pink.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-xl-pink.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-xl-pink.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-xl-pink.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-hover-xl-pink {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-pink:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-xl-pink:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-xl-pink:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-xl-pink:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}
.shadow-hover-xl-pink:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;
}

.shadow-sm-purple {
  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-sm-purple.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-sm-purple.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-sm-purple.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-sm-purple.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-hover-sm-purple {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-purple:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-sm-purple:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-sm-purple:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-sm-purple:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-sm-purple:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-purple {
  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-purple.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-purple.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-purple.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-purple.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-hover-purple {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-purple:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-purple:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-purple:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-purple:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-purple:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-lg-purple {
  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-lg-purple.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-lg-purple.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-lg-purple.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-lg-purple.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-hover-lg-purple {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-purple:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-lg-purple:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-lg-purple:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-lg-purple:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-lg-purple:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-xl-purple {
  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-xl-purple.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-xl-purple.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-xl-purple.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-xl-purple.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-hover-xl-purple {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-purple:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-xl-purple:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-xl-purple:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-xl-purple:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}
.shadow-hover-xl-purple:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;
}

.shadow-sm-violet {
  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-sm-violet.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-sm-violet.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-sm-violet.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-sm-violet.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-hover-sm-violet {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-violet:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-sm-violet:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-sm-violet:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-sm-violet:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-sm-violet:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-violet {
  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-violet.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-violet.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-violet.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-violet.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-hover-violet {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-violet:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-violet:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-violet:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-violet:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-violet:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-lg-violet {
  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-lg-violet.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-lg-violet.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-lg-violet.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-lg-violet.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-hover-lg-violet {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-violet:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-lg-violet:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-lg-violet:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-lg-violet:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-lg-violet:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-xl-violet {
  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-xl-violet.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-xl-violet.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-xl-violet.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-xl-violet.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-hover-xl-violet {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-violet:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-xl-violet:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-xl-violet:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-xl-violet:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}
.shadow-hover-xl-violet:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;
}

.shadow-sm-indigo {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-sm-indigo.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-sm-indigo.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-sm-indigo.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-sm-indigo.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-hover-sm-indigo {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-indigo:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-sm-indigo:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-sm-indigo:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-sm-indigo:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-sm-indigo:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-indigo {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-indigo.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-indigo.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-indigo.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-indigo.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-hover-indigo {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-indigo:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-indigo:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-indigo:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-indigo:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-indigo:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-lg-indigo {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-lg-indigo.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-lg-indigo.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-lg-indigo.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-lg-indigo.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-hover-lg-indigo {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-indigo:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-lg-indigo:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-lg-indigo:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-lg-indigo:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-lg-indigo:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-xl-indigo {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-xl-indigo.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-xl-indigo.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-xl-indigo.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-xl-indigo.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-hover-xl-indigo {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-indigo:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-xl-indigo:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-xl-indigo:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-xl-indigo:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}
.shadow-hover-xl-indigo:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;
}

.shadow-sm-teal {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-teal.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-teal.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-teal.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-sm-teal.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-sm-teal {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-teal:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-teal:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-teal:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-teal:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-sm-teal:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-teal {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-teal.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-teal.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-teal.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-teal.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-teal {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-teal:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-teal:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-teal:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-teal:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-teal:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-lg-teal {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-teal.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-teal.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-teal.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-lg-teal.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-lg-teal {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-teal:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-teal:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-teal:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-teal:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-lg-teal:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-xl-teal {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-teal.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-teal.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-teal.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-xl-teal.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-hover-xl-teal {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-teal:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-teal:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-teal:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-teal:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}
.shadow-hover-xl-teal:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;
}

.shadow-sm-neon {
  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-sm-neon.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-sm-neon.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-sm-neon.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-sm-neon.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-hover-sm-neon {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-neon:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-sm-neon:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-sm-neon:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-sm-neon:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-sm-neon:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-neon {
  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-neon.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-neon.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-neon.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-neon.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-hover-neon {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-neon:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-neon:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-neon:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-neon:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-neon:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-lg-neon {
  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-lg-neon.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-lg-neon.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-lg-neon.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-lg-neon.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-hover-lg-neon {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-neon:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-lg-neon:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-lg-neon:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-lg-neon:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-lg-neon:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-xl-neon {
  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-xl-neon.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-xl-neon.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-xl-neon.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-xl-neon.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-hover-xl-neon {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-neon:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-xl-neon:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-xl-neon:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-xl-neon:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}
.shadow-hover-xl-neon:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;
}

.shadow-sm-lime {
  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-sm-lime.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-sm-lime.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-sm-lime.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-sm-lime.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-hover-sm-lime {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-lime:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-sm-lime:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-sm-lime:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-sm-lime:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-sm-lime:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-lime {
  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lime.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lime.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lime.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lime.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-hover-lime {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lime:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lime:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lime:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lime:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lime:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-lg-lime {
  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lg-lime.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lg-lime.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lg-lime.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-lg-lime.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-hover-lg-lime {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-lime:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lg-lime:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lg-lime:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lg-lime:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-lg-lime:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-xl-lime {
  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-xl-lime.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-xl-lime.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-xl-lime.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-xl-lime.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-hover-xl-lime {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-lime:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-xl-lime:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-xl-lime:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-xl-lime:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}
.shadow-hover-xl-lime:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;
}

.shadow-sm-sun {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sm-sun.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sm-sun.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sm-sun.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sm-sun.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-hover-sm-sun {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-sun:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sm-sun:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sm-sun:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sm-sun:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sm-sun:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-sun {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sun.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sun.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sun.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-sun.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-hover-sun {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sun:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sun:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sun:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sun:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-sun:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-lg-sun {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-lg-sun.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-lg-sun.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-lg-sun.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-lg-sun.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-hover-lg-sun {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-sun:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-lg-sun:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-lg-sun:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-lg-sun:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-lg-sun:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-xl-sun {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-xl-sun.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-xl-sun.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-xl-sun.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-xl-sun.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-hover-xl-sun {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-sun:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-xl-sun:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-xl-sun:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-xl-sun:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}
.shadow-hover-xl-sun:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;
}

.shadow-sm-orange {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-sm-orange.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-sm-orange.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-sm-orange.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-sm-orange.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-hover-sm-orange {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-orange:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-sm-orange:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-sm-orange:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-sm-orange:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-sm-orange:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-orange {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-orange.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-orange.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-orange.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-orange.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-hover-orange {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-orange:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-orange:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-orange:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-orange:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-orange:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-lg-orange {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-lg-orange.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-lg-orange.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-lg-orange.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-lg-orange.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-hover-lg-orange {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-orange:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-lg-orange:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-lg-orange:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-lg-orange:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-lg-orange:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-xl-orange {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-xl-orange.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-xl-orange.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-xl-orange.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-xl-orange.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-hover-xl-orange {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-orange:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-xl-orange:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-xl-orange:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-xl-orange:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}
.shadow-hover-xl-orange:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;
}

.shadow-sm-pumpkin {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-sm-pumpkin.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-sm-pumpkin.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-sm-pumpkin.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-sm-pumpkin.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-hover-sm-pumpkin {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-pumpkin:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-sm-pumpkin:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-sm-pumpkin:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-sm-pumpkin:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-sm-pumpkin:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-pumpkin {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-pumpkin.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-pumpkin.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-pumpkin.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-pumpkin.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-hover-pumpkin {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-pumpkin:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-pumpkin:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-pumpkin:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-pumpkin:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-pumpkin:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-lg-pumpkin {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-lg-pumpkin.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-lg-pumpkin.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-lg-pumpkin.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-lg-pumpkin.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-hover-lg-pumpkin {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-pumpkin:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-lg-pumpkin:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-lg-pumpkin:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-lg-pumpkin:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-lg-pumpkin:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-xl-pumpkin {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-xl-pumpkin.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-xl-pumpkin.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-xl-pumpkin.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-xl-pumpkin.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-hover-xl-pumpkin {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-pumpkin:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-xl-pumpkin:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-xl-pumpkin:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-xl-pumpkin:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}
.shadow-hover-xl-pumpkin:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;
}

.shadow-sm-brown {
  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-sm-brown.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-sm-brown.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-sm-brown.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-sm-brown.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-hover-sm-brown {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-brown:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-sm-brown:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-sm-brown:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-sm-brown:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-sm-brown:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-brown {
  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-brown.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-brown.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-brown.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-brown.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-hover-brown {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-brown:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-brown:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-brown:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-brown:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-brown:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-lg-brown {
  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-lg-brown.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-lg-brown.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-lg-brown.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-lg-brown.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-hover-lg-brown {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-brown:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-lg-brown:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-lg-brown:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-lg-brown:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-lg-brown:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-xl-brown {
  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-xl-brown.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-xl-brown.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-xl-brown.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-xl-brown.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-hover-xl-brown {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-brown:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-xl-brown:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-xl-brown:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-xl-brown:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}
.shadow-hover-xl-brown:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;
}

.shadow-sm-gold {
  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-sm-gold.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-sm-gold.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-sm-gold.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-sm-gold.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-hover-sm-gold {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-gold:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-sm-gold:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-sm-gold:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-sm-gold:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-sm-gold:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-gold {
  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-gold.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-gold.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-gold.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-gold.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-hover-gold {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-gold:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-gold:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-gold:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-gold:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-gold:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-lg-gold {
  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-lg-gold.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-lg-gold.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-lg-gold.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-lg-gold.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-hover-lg-gold {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-gold:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-lg-gold:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-lg-gold:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-lg-gold:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-lg-gold:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-xl-gold {
  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-xl-gold.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-xl-gold.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-xl-gold.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-xl-gold.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-hover-xl-gold {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-gold:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-xl-gold:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-xl-gold:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-xl-gold:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}
.shadow-hover-xl-gold:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;
}

.shadow-sm-smoke {
  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-sm-smoke.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-sm-smoke.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-sm-smoke.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-sm-smoke.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-hover-sm-smoke {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-smoke:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-sm-smoke:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-sm-smoke:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-sm-smoke:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-sm-smoke:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-smoke {
  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-smoke.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-smoke.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-smoke.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-smoke.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-hover-smoke {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-smoke:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-smoke:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-smoke:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-smoke:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-smoke:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-lg-smoke {
  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-lg-smoke.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-lg-smoke.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-lg-smoke.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-lg-smoke.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-hover-lg-smoke {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-smoke:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-lg-smoke:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-lg-smoke:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-lg-smoke:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-lg-smoke:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-xl-smoke {
  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-xl-smoke.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-xl-smoke.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-xl-smoke.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-xl-smoke.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-hover-xl-smoke {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-smoke:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-xl-smoke:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-xl-smoke:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-xl-smoke:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}
.shadow-hover-xl-smoke:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;
}

.shadow-sm-grey {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-grey.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-grey.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-grey.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-grey.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-sm-grey {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-grey:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-grey:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-grey:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-grey:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-grey:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-grey {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-grey.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-grey.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-grey.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-grey.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-grey {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-grey:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-grey:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-grey:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-grey:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-grey:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-lg-grey {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-grey.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-grey.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-grey.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-grey.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-lg-grey {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-grey:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-grey:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-grey:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-grey:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-grey:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-xl-grey {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-grey.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-grey.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-grey.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-grey.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-xl-grey {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-grey:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-grey:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-grey:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-grey:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-grey:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-sm-secondary {
  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-sm-secondary.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-sm-secondary.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-sm-secondary.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-sm-secondary.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-hover-sm-secondary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-secondary:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-sm-secondary:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-sm-secondary:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-sm-secondary:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-sm-secondary:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-secondary {
  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-secondary.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-secondary.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-secondary.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-secondary.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-hover-secondary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-secondary:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-secondary:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-secondary:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-secondary:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-secondary:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-lg-secondary {
  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-lg-secondary.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-lg-secondary.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-lg-secondary.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-lg-secondary.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-hover-lg-secondary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-secondary:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-lg-secondary:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-lg-secondary:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-lg-secondary:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-lg-secondary:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-xl-secondary {
  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-xl-secondary.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-xl-secondary.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-xl-secondary.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-xl-secondary.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-hover-xl-secondary {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-secondary:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-xl-secondary:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-xl-secondary:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-xl-secondary:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}
.shadow-hover-xl-secondary:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;
}

.shadow-sm-light {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-light.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-light.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-light.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-sm-light.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-sm-light {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-light:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-light:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-light:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-light:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-sm-light:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-light {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-light.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-light.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-light.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-light.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-light {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-light:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-light:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-light:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-light:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-light:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-lg-light {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-light.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-light.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-light.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-lg-light.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-lg-light {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-light:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-light:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-light:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-light:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-lg-light:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-xl-light {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-light.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-light.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-light.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-xl-light.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-hover-xl-light {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-light:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-light:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-light:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-light:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}
.shadow-hover-xl-light:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;
}

.shadow-sm-dark {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm-dark.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm-dark.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm-dark.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-sm-dark.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover-sm-dark {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-dark:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm-dark:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm-dark:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm-dark:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-sm-dark:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-dark {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-dark.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-dark.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-dark.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-dark.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover-dark {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-dark:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-dark:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-dark:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-dark:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-dark:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-lg-dark {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg-dark.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg-dark.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg-dark.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-lg-dark.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover-lg-dark {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-dark:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg-dark:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg-dark:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg-dark:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-lg-dark:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-xl-dark {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl-dark.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl-dark.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl-dark.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-xl-dark.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-hover-xl-dark {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-dark:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl-dark:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl-dark:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl-dark:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}
.shadow-hover-xl-dark:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;
}

.shadow-sm-white {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-sm-white.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-sm-white.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-sm-white.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-sm-white.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;
}

.shadow-hover-sm-white {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-sm-white:hover {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-sm-white:hover.shadow-top {
  box-shadow: 0 -0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-sm-white:hover.shadow-bottom {
  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-sm-white:hover.shadow-left {
  box-shadow: -0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-sm-white:hover.shadow-right {
  box-shadow: 0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;
}

.shadow-white {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-white.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-white.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-white.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-white.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;
}

.shadow-hover-white {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-white:hover {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-white:hover.shadow-top {
  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-white:hover.shadow-bottom {
  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-white:hover.shadow-left {
  box-shadow: -0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-white:hover.shadow-right {
  box-shadow: 0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;
}

.shadow-lg-white {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-lg-white.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-lg-white.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-lg-white.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-lg-white.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}

.shadow-hover-lg-white {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-lg-white:hover {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-lg-white:hover.shadow-top {
  box-shadow: 0 -0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-lg-white:hover.shadow-bottom {
  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-lg-white:hover.shadow-left {
  box-shadow: -0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-lg-white:hover.shadow-right {
  box-shadow: 0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}

.shadow-xl-white {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-xl-white.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-xl-white.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-xl-white.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-xl-white.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}

.shadow-hover-xl-white {
  transition: box-shadow 0.3s ease;
}
.shadow-hover-xl-white:hover {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-xl-white:hover.shadow-top {
  box-shadow: 0 -0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-xl-white:hover.shadow-bottom {
  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-xl-white:hover.shadow-left {
  box-shadow: -0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}
.shadow-hover-xl-white:hover.shadow-right {
  box-shadow: 0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;
}

/*Font Size*/
.fs-7 {
  font-size: 0.875rem !important;
}

.fs-8 {
  font-size: 0.75rem !important;
}

.font-1 {
  font-size: 0.5rem !important;
}

.font-2 {
  font-size: 0.75rem !important;
}

.font-3 {
  font-size: 1rem !important;
}

.font-4 {
  font-size: 1.25rem !important;
}

.font-5 {
  font-size: 1.5rem !important;
}

.font-6 {
  font-size: 1.75rem !important;
}

.font-7 {
  font-size: 2rem !important;
}

.font-8 {
  font-size: 2.25rem !important;
}

.font-9 {
  font-size: 2.5rem !important;
}

.font-10 {
  font-size: 2.75rem !important;
}

/*Font Weight*/
.fw-semibold {
  font-weight: 600 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

/*Text Case*/
.text-nonecase {
  text-transform: none !important;
}

/*Letter Spacing*/
.ls-0 {
  letter-spacing: 0px !important;
}

.ls-1 {
  letter-spacing: 0.25px !important;
}

.ls-2 {
  letter-spacing: 0.5px !important;
}

.ls-3 {
  letter-spacing: 0.75px !important;
}

.ls-4 {
  letter-spacing: 1px !important;
}

.ls-n-1 {
  letter-spacing: -0.25px !important;
}

.ls-n-2 {
  letter-spacing: -0.5px !important;
}

.ls-n-3 {
  letter-spacing: -0.75px !important;
}

.ls-n-4 {
  letter-spacing: -1px !important;
}

/*Line Height*/
.lh-0 {
  line-height: 0 !important;
}

/*Width*/
.w-0 {
  width: 0 !important;
}

.w-25p {
  width: 25px !important;
}

.w-30p {
  width: 30px !important;
}

.w-35p {
  width: 35px !important;
}

.w-40p {
  width: 40px !important;
}

.w-45p {
  width: 45px !important;
}

.w-50p {
  width: 50px !important;
}

.w-55p {
  width: 55px !important;
}

.w-60p {
  width: 60px !important;
}

.w-65p {
  width: 65px !important;
}

.w-70p {
  width: 70px !important;
}

.w-75p {
  width: 75px !important;
}

.w-80p {
  width: 80px !important;
}

.w-85p {
  width: 85px !important;
}

.w-90p {
  width: 90px !important;
}

.w-95p {
  width: 95px !important;
}

.w-100p {
  width: 100px !important;
}

.w-105p {
  width: 105px !important;
}

.w-110p {
  width: 110px !important;
}

.w-115p {
  width: 115px !important;
}

.w-120p {
  width: 120px !important;
}

.w-125p {
  width: 125px !important;
}

.w-130p {
  width: 130px !important;
}

.w-135p {
  width: 135px !important;
}

.w-140p {
  width: 140px !important;
}

.w-145p {
  width: 145px !important;
}

.w-150p {
  width: 150px !important;
}

.w-155p {
  width: 155px !important;
}

.w-160p {
  width: 160px !important;
}

.w-165p {
  width: 165px !important;
}

.w-170p {
  width: 170px !important;
}

.w-175p {
  width: 175px !important;
}

.w-180p {
  width: 180px !important;
}

.w-185p {
  width: 185px !important;
}

.w-190p {
  width: 190px !important;
}

.w-195p {
  width: 195px !important;
}

.w-200p {
  width: 200px !important;
}

.w-205p {
  width: 205px !important;
}

.w-210p {
  width: 210px !important;
}

.w-215p {
  width: 215px !important;
}

.w-220p {
  width: 220px !important;
}

.w-225p {
  width: 225px !important;
}

.w-230p {
  width: 230px !important;
}

.w-235p {
  width: 235px !important;
}

.w-240p {
  width: 240px !important;
}

.w-245p {
  width: 245px !important;
}

.w-250p {
  width: 250px !important;
}

.w-255p {
  width: 255px !important;
}

.w-260p {
  width: 260px !important;
}

.w-265p {
  width: 265px !important;
}

.w-270p {
  width: 270px !important;
}

.w-275p {
  width: 275px !important;
}

.w-280p {
  width: 280px !important;
}

.w-285p {
  width: 285px !important;
}

.w-290p {
  width: 290px !important;
}

.w-295p {
  width: 295px !important;
}

.w-300p {
  width: 300px !important;
}

.w-305p {
  width: 305px !important;
}

.w-310p {
  width: 310px !important;
}

.w-315p {
  width: 315px !important;
}

.w-320p {
  width: 320px !important;
}

.w-325p {
  width: 325px !important;
}

.w-330p {
  width: 330px !important;
}

.w-335p {
  width: 335px !important;
}

.w-340p {
  width: 340px !important;
}

.w-345p {
  width: 345px !important;
}

.w-350p {
  width: 350px !important;
}

.w-355p {
  width: 355px !important;
}

.w-360p {
  width: 360px !important;
}

.w-365p {
  width: 365px !important;
}

.w-370p {
  width: 370px !important;
}

.w-375p {
  width: 375px !important;
}

.w-380p {
  width: 380px !important;
}

.w-385p {
  width: 385px !important;
}

.w-390p {
  width: 390px !important;
}

.w-395p {
  width: 395px !important;
}

.w-400p {
  width: 400px !important;
}

.w-405p {
  width: 405px !important;
}

.w-410p {
  width: 410px !important;
}

.w-415p {
  width: 415px !important;
}

.w-420p {
  width: 420px !important;
}

.w-425p {
  width: 425px !important;
}

.w-430p {
  width: 430px !important;
}

.w-435p {
  width: 435px !important;
}

.w-440p {
  width: 440px !important;
}

.w-445p {
  width: 445px !important;
}

.w-450p {
  width: 450px !important;
}

.w-455p {
  width: 455px !important;
}

.w-460p {
  width: 460px !important;
}

.w-465p {
  width: 465px !important;
}

.w-470p {
  width: 470px !important;
}

.w-475p {
  width: 475px !important;
}

.w-480p {
  width: 480px !important;
}

.w-485p {
  width: 485px !important;
}

.w-490p {
  width: 490px !important;
}

.w-495p {
  width: 495px !important;
}

.w-500p {
  width: 500px !important;
}

.w-505p {
  width: 505px !important;
}

.w-510p {
  width: 510px !important;
}

.w-515p {
  width: 515px !important;
}

.w-520p {
  width: 520px !important;
}

.w-525p {
  width: 525px !important;
}

.w-530p {
  width: 530px !important;
}

.w-535p {
  width: 535px !important;
}

.w-540p {
  width: 540px !important;
}

.w-545p {
  width: 545px !important;
}

.w-550p {
  width: 550px !important;
}

.w-555p {
  width: 555px !important;
}

.w-560p {
  width: 560px !important;
}

.w-565p {
  width: 565px !important;
}

.w-570p {
  width: 570px !important;
}

.w-575p {
  width: 575px !important;
}

.w-580p {
  width: 580px !important;
}

.w-585p {
  width: 585px !important;
}

.w-590p {
  width: 590px !important;
}

.w-595p {
  width: 595px !important;
}

.w-600p {
  width: 600px !important;
}

.w-605p {
  width: 605px !important;
}

.w-610p {
  width: 610px !important;
}

.w-615p {
  width: 615px !important;
}

.w-620p {
  width: 620px !important;
}

.w-625p {
  width: 625px !important;
}

.w-630p {
  width: 630px !important;
}

.w-635p {
  width: 635px !important;
}

.w-640p {
  width: 640px !important;
}

.w-645p {
  width: 645px !important;
}

.w-650p {
  width: 650px !important;
}

.w-655p {
  width: 655px !important;
}

.w-660p {
  width: 660px !important;
}

.w-665p {
  width: 665px !important;
}

.w-670p {
  width: 670px !important;
}

.w-675p {
  width: 675px !important;
}

.w-680p {
  width: 680px !important;
}

.w-685p {
  width: 685px !important;
}

.w-690p {
  width: 690px !important;
}

.w-695p {
  width: 695px !important;
}

.w-700p {
  width: 700px !important;
}

.w-705p {
  width: 705px !important;
}

.w-710p {
  width: 710px !important;
}

.w-715p {
  width: 715px !important;
}

.w-720p {
  width: 720px !important;
}

.w-725p {
  width: 725px !important;
}

.w-730p {
  width: 730px !important;
}

.w-735p {
  width: 735px !important;
}

.w-740p {
  width: 740px !important;
}

.w-745p {
  width: 745px !important;
}

.w-750p {
  width: 750px !important;
}

.w-755p {
  width: 755px !important;
}

.w-760p {
  width: 760px !important;
}

.w-765p {
  width: 765px !important;
}

.w-770p {
  width: 770px !important;
}

.w-775p {
  width: 775px !important;
}

.w-780p {
  width: 780px !important;
}

.w-785p {
  width: 785px !important;
}

.w-790p {
  width: 790px !important;
}

.w-795p {
  width: 795px !important;
}

.w-800p {
  width: 800px !important;
}

@media (min-width: 576px) {
  .w-sm-25p {
    width: 25px !important;
  }

  .w-sm-30p {
    width: 30px !important;
  }

  .w-sm-35p {
    width: 35px !important;
  }

  .w-sm-40p {
    width: 40px !important;
  }

  .w-sm-45p {
    width: 45px !important;
  }

  .w-sm-50p {
    width: 50px !important;
  }

  .w-sm-55p {
    width: 55px !important;
  }

  .w-sm-60p {
    width: 60px !important;
  }

  .w-sm-65p {
    width: 65px !important;
  }

  .w-sm-70p {
    width: 70px !important;
  }

  .w-sm-75p {
    width: 75px !important;
  }

  .w-sm-80p {
    width: 80px !important;
  }

  .w-sm-85p {
    width: 85px !important;
  }

  .w-sm-90p {
    width: 90px !important;
  }

  .w-sm-95p {
    width: 95px !important;
  }

  .w-sm-100p {
    width: 100px !important;
  }

  .w-sm-105p {
    width: 105px !important;
  }

  .w-sm-110p {
    width: 110px !important;
  }

  .w-sm-115p {
    width: 115px !important;
  }

  .w-sm-120p {
    width: 120px !important;
  }

  .w-sm-125p {
    width: 125px !important;
  }

  .w-sm-130p {
    width: 130px !important;
  }

  .w-sm-135p {
    width: 135px !important;
  }

  .w-sm-140p {
    width: 140px !important;
  }

  .w-sm-145p {
    width: 145px !important;
  }

  .w-sm-150p {
    width: 150px !important;
  }

  .w-sm-155p {
    width: 155px !important;
  }

  .w-sm-160p {
    width: 160px !important;
  }

  .w-sm-165p {
    width: 165px !important;
  }

  .w-sm-170p {
    width: 170px !important;
  }

  .w-sm-175p {
    width: 175px !important;
  }

  .w-sm-180p {
    width: 180px !important;
  }

  .w-sm-185p {
    width: 185px !important;
  }

  .w-sm-190p {
    width: 190px !important;
  }

  .w-sm-195p {
    width: 195px !important;
  }

  .w-sm-200p {
    width: 200px !important;
  }

  .w-sm-205p {
    width: 205px !important;
  }

  .w-sm-210p {
    width: 210px !important;
  }

  .w-sm-215p {
    width: 215px !important;
  }

  .w-sm-220p {
    width: 220px !important;
  }

  .w-sm-225p {
    width: 225px !important;
  }

  .w-sm-230p {
    width: 230px !important;
  }

  .w-sm-235p {
    width: 235px !important;
  }

  .w-sm-240p {
    width: 240px !important;
  }

  .w-sm-245p {
    width: 245px !important;
  }

  .w-sm-250p {
    width: 250px !important;
  }

  .w-sm-255p {
    width: 255px !important;
  }

  .w-sm-260p {
    width: 260px !important;
  }

  .w-sm-265p {
    width: 265px !important;
  }

  .w-sm-270p {
    width: 270px !important;
  }

  .w-sm-275p {
    width: 275px !important;
  }

  .w-sm-280p {
    width: 280px !important;
  }

  .w-sm-285p {
    width: 285px !important;
  }

  .w-sm-290p {
    width: 290px !important;
  }

  .w-sm-295p {
    width: 295px !important;
  }

  .w-sm-300p {
    width: 300px !important;
  }

  .w-sm-305p {
    width: 305px !important;
  }

  .w-sm-310p {
    width: 310px !important;
  }

  .w-sm-315p {
    width: 315px !important;
  }

  .w-sm-320p {
    width: 320px !important;
  }

  .w-sm-325p {
    width: 325px !important;
  }

  .w-sm-330p {
    width: 330px !important;
  }

  .w-sm-335p {
    width: 335px !important;
  }

  .w-sm-340p {
    width: 340px !important;
  }

  .w-sm-345p {
    width: 345px !important;
  }

  .w-sm-350p {
    width: 350px !important;
  }

  .w-sm-355p {
    width: 355px !important;
  }

  .w-sm-360p {
    width: 360px !important;
  }

  .w-sm-365p {
    width: 365px !important;
  }

  .w-sm-370p {
    width: 370px !important;
  }

  .w-sm-375p {
    width: 375px !important;
  }

  .w-sm-380p {
    width: 380px !important;
  }

  .w-sm-385p {
    width: 385px !important;
  }

  .w-sm-390p {
    width: 390px !important;
  }

  .w-sm-395p {
    width: 395px !important;
  }

  .w-sm-400p {
    width: 400px !important;
  }

  .w-sm-405p {
    width: 405px !important;
  }

  .w-sm-410p {
    width: 410px !important;
  }

  .w-sm-415p {
    width: 415px !important;
  }

  .w-sm-420p {
    width: 420px !important;
  }

  .w-sm-425p {
    width: 425px !important;
  }

  .w-sm-430p {
    width: 430px !important;
  }

  .w-sm-435p {
    width: 435px !important;
  }

  .w-sm-440p {
    width: 440px !important;
  }

  .w-sm-445p {
    width: 445px !important;
  }

  .w-sm-450p {
    width: 450px !important;
  }

  .w-sm-455p {
    width: 455px !important;
  }

  .w-sm-460p {
    width: 460px !important;
  }

  .w-sm-465p {
    width: 465px !important;
  }

  .w-sm-470p {
    width: 470px !important;
  }

  .w-sm-475p {
    width: 475px !important;
  }

  .w-sm-480p {
    width: 480px !important;
  }

  .w-sm-485p {
    width: 485px !important;
  }

  .w-sm-490p {
    width: 490px !important;
  }

  .w-sm-495p {
    width: 495px !important;
  }

  .w-sm-500p {
    width: 500px !important;
  }

  .w-sm-505p {
    width: 505px !important;
  }

  .w-sm-510p {
    width: 510px !important;
  }

  .w-sm-515p {
    width: 515px !important;
  }

  .w-sm-520p {
    width: 520px !important;
  }

  .w-sm-525p {
    width: 525px !important;
  }

  .w-sm-530p {
    width: 530px !important;
  }

  .w-sm-535p {
    width: 535px !important;
  }

  .w-sm-540p {
    width: 540px !important;
  }

  .w-sm-545p {
    width: 545px !important;
  }

  .w-sm-550p {
    width: 550px !important;
  }

  .w-sm-555p {
    width: 555px !important;
  }

  .w-sm-560p {
    width: 560px !important;
  }

  .w-sm-565p {
    width: 565px !important;
  }

  .w-sm-570p {
    width: 570px !important;
  }

  .w-sm-575p {
    width: 575px !important;
  }

  .w-sm-580p {
    width: 580px !important;
  }

  .w-sm-585p {
    width: 585px !important;
  }

  .w-sm-590p {
    width: 590px !important;
  }

  .w-sm-595p {
    width: 595px !important;
  }

  .w-sm-600p {
    width: 600px !important;
  }

  .w-sm-605p {
    width: 605px !important;
  }

  .w-sm-610p {
    width: 610px !important;
  }

  .w-sm-615p {
    width: 615px !important;
  }

  .w-sm-620p {
    width: 620px !important;
  }

  .w-sm-625p {
    width: 625px !important;
  }

  .w-sm-630p {
    width: 630px !important;
  }

  .w-sm-635p {
    width: 635px !important;
  }

  .w-sm-640p {
    width: 640px !important;
  }

  .w-sm-645p {
    width: 645px !important;
  }

  .w-sm-650p {
    width: 650px !important;
  }

  .w-sm-655p {
    width: 655px !important;
  }

  .w-sm-660p {
    width: 660px !important;
  }

  .w-sm-665p {
    width: 665px !important;
  }

  .w-sm-670p {
    width: 670px !important;
  }

  .w-sm-675p {
    width: 675px !important;
  }

  .w-sm-680p {
    width: 680px !important;
  }

  .w-sm-685p {
    width: 685px !important;
  }

  .w-sm-690p {
    width: 690px !important;
  }

  .w-sm-695p {
    width: 695px !important;
  }

  .w-sm-700p {
    width: 700px !important;
  }

  .w-sm-705p {
    width: 705px !important;
  }

  .w-sm-710p {
    width: 710px !important;
  }

  .w-sm-715p {
    width: 715px !important;
  }

  .w-sm-720p {
    width: 720px !important;
  }

  .w-sm-725p {
    width: 725px !important;
  }

  .w-sm-730p {
    width: 730px !important;
  }

  .w-sm-735p {
    width: 735px !important;
  }

  .w-sm-740p {
    width: 740px !important;
  }

  .w-sm-745p {
    width: 745px !important;
  }

  .w-sm-750p {
    width: 750px !important;
  }

  .w-sm-755p {
    width: 755px !important;
  }

  .w-sm-760p {
    width: 760px !important;
  }

  .w-sm-765p {
    width: 765px !important;
  }

  .w-sm-770p {
    width: 770px !important;
  }

  .w-sm-775p {
    width: 775px !important;
  }

  .w-sm-780p {
    width: 780px !important;
  }

  .w-sm-785p {
    width: 785px !important;
  }

  .w-sm-790p {
    width: 790px !important;
  }

  .w-sm-795p {
    width: 795px !important;
  }

  .w-sm-800p {
    width: 800px !important;
  }
}
@media (min-width: 768px) {
  .w-md-25p {
    width: 25px !important;
  }

  .w-md-30p {
    width: 30px !important;
  }

  .w-md-35p {
    width: 35px !important;
  }

  .w-md-40p {
    width: 40px !important;
  }

  .w-md-45p {
    width: 45px !important;
  }

  .w-md-50p {
    width: 50px !important;
  }

  .w-md-55p {
    width: 55px !important;
  }

  .w-md-60p {
    width: 60px !important;
  }

  .w-md-65p {
    width: 65px !important;
  }

  .w-md-70p {
    width: 70px !important;
  }

  .w-md-75p {
    width: 75px !important;
  }

  .w-md-80p {
    width: 80px !important;
  }

  .w-md-85p {
    width: 85px !important;
  }

  .w-md-90p {
    width: 90px !important;
  }

  .w-md-95p {
    width: 95px !important;
  }

  .w-md-100p {
    width: 100px !important;
  }

  .w-md-105p {
    width: 105px !important;
  }

  .w-md-110p {
    width: 110px !important;
  }

  .w-md-115p {
    width: 115px !important;
  }

  .w-md-120p {
    width: 120px !important;
  }

  .w-md-125p {
    width: 125px !important;
  }

  .w-md-130p {
    width: 130px !important;
  }

  .w-md-135p {
    width: 135px !important;
  }

  .w-md-140p {
    width: 140px !important;
  }

  .w-md-145p {
    width: 145px !important;
  }

  .w-md-150p {
    width: 150px !important;
  }

  .w-md-155p {
    width: 155px !important;
  }

  .w-md-160p {
    width: 160px !important;
  }

  .w-md-165p {
    width: 165px !important;
  }

  .w-md-170p {
    width: 170px !important;
  }

  .w-md-175p {
    width: 175px !important;
  }

  .w-md-180p {
    width: 180px !important;
  }

  .w-md-185p {
    width: 185px !important;
  }

  .w-md-190p {
    width: 190px !important;
  }

  .w-md-195p {
    width: 195px !important;
  }

  .w-md-200p {
    width: 200px !important;
  }

  .w-md-205p {
    width: 205px !important;
  }

  .w-md-210p {
    width: 210px !important;
  }

  .w-md-215p {
    width: 215px !important;
  }

  .w-md-220p {
    width: 220px !important;
  }

  .w-md-225p {
    width: 225px !important;
  }

  .w-md-230p {
    width: 230px !important;
  }

  .w-md-235p {
    width: 235px !important;
  }

  .w-md-240p {
    width: 240px !important;
  }

  .w-md-245p {
    width: 245px !important;
  }

  .w-md-250p {
    width: 250px !important;
  }

  .w-md-255p {
    width: 255px !important;
  }

  .w-md-260p {
    width: 260px !important;
  }

  .w-md-265p {
    width: 265px !important;
  }

  .w-md-270p {
    width: 270px !important;
  }

  .w-md-275p {
    width: 275px !important;
  }

  .w-md-280p {
    width: 280px !important;
  }

  .w-md-285p {
    width: 285px !important;
  }

  .w-md-290p {
    width: 290px !important;
  }

  .w-md-295p {
    width: 295px !important;
  }

  .w-md-300p {
    width: 300px !important;
  }

  .w-md-305p {
    width: 305px !important;
  }

  .w-md-310p {
    width: 310px !important;
  }

  .w-md-315p {
    width: 315px !important;
  }

  .w-md-320p {
    width: 320px !important;
  }

  .w-md-325p {
    width: 325px !important;
  }

  .w-md-330p {
    width: 330px !important;
  }

  .w-md-335p {
    width: 335px !important;
  }

  .w-md-340p {
    width: 340px !important;
  }

  .w-md-345p {
    width: 345px !important;
  }

  .w-md-350p {
    width: 350px !important;
  }

  .w-md-355p {
    width: 355px !important;
  }

  .w-md-360p {
    width: 360px !important;
  }

  .w-md-365p {
    width: 365px !important;
  }

  .w-md-370p {
    width: 370px !important;
  }

  .w-md-375p {
    width: 375px !important;
  }

  .w-md-380p {
    width: 380px !important;
  }

  .w-md-385p {
    width: 385px !important;
  }

  .w-md-390p {
    width: 390px !important;
  }

  .w-md-395p {
    width: 395px !important;
  }

  .w-md-400p {
    width: 400px !important;
  }

  .w-md-405p {
    width: 405px !important;
  }

  .w-md-410p {
    width: 410px !important;
  }

  .w-md-415p {
    width: 415px !important;
  }

  .w-md-420p {
    width: 420px !important;
  }

  .w-md-425p {
    width: 425px !important;
  }

  .w-md-430p {
    width: 430px !important;
  }

  .w-md-435p {
    width: 435px !important;
  }

  .w-md-440p {
    width: 440px !important;
  }

  .w-md-445p {
    width: 445px !important;
  }

  .w-md-450p {
    width: 450px !important;
  }

  .w-md-455p {
    width: 455px !important;
  }

  .w-md-460p {
    width: 460px !important;
  }

  .w-md-465p {
    width: 465px !important;
  }

  .w-md-470p {
    width: 470px !important;
  }

  .w-md-475p {
    width: 475px !important;
  }

  .w-md-480p {
    width: 480px !important;
  }

  .w-md-485p {
    width: 485px !important;
  }

  .w-md-490p {
    width: 490px !important;
  }

  .w-md-495p {
    width: 495px !important;
  }

  .w-md-500p {
    width: 500px !important;
  }

  .w-md-505p {
    width: 505px !important;
  }

  .w-md-510p {
    width: 510px !important;
  }

  .w-md-515p {
    width: 515px !important;
  }

  .w-md-520p {
    width: 520px !important;
  }

  .w-md-525p {
    width: 525px !important;
  }

  .w-md-530p {
    width: 530px !important;
  }

  .w-md-535p {
    width: 535px !important;
  }

  .w-md-540p {
    width: 540px !important;
  }

  .w-md-545p {
    width: 545px !important;
  }

  .w-md-550p {
    width: 550px !important;
  }

  .w-md-555p {
    width: 555px !important;
  }

  .w-md-560p {
    width: 560px !important;
  }

  .w-md-565p {
    width: 565px !important;
  }

  .w-md-570p {
    width: 570px !important;
  }

  .w-md-575p {
    width: 575px !important;
  }

  .w-md-580p {
    width: 580px !important;
  }

  .w-md-585p {
    width: 585px !important;
  }

  .w-md-590p {
    width: 590px !important;
  }

  .w-md-595p {
    width: 595px !important;
  }

  .w-md-600p {
    width: 600px !important;
  }

  .w-md-605p {
    width: 605px !important;
  }

  .w-md-610p {
    width: 610px !important;
  }

  .w-md-615p {
    width: 615px !important;
  }

  .w-md-620p {
    width: 620px !important;
  }

  .w-md-625p {
    width: 625px !important;
  }

  .w-md-630p {
    width: 630px !important;
  }

  .w-md-635p {
    width: 635px !important;
  }

  .w-md-640p {
    width: 640px !important;
  }

  .w-md-645p {
    width: 645px !important;
  }

  .w-md-650p {
    width: 650px !important;
  }

  .w-md-655p {
    width: 655px !important;
  }

  .w-md-660p {
    width: 660px !important;
  }

  .w-md-665p {
    width: 665px !important;
  }

  .w-md-670p {
    width: 670px !important;
  }

  .w-md-675p {
    width: 675px !important;
  }

  .w-md-680p {
    width: 680px !important;
  }

  .w-md-685p {
    width: 685px !important;
  }

  .w-md-690p {
    width: 690px !important;
  }

  .w-md-695p {
    width: 695px !important;
  }

  .w-md-700p {
    width: 700px !important;
  }

  .w-md-705p {
    width: 705px !important;
  }

  .w-md-710p {
    width: 710px !important;
  }

  .w-md-715p {
    width: 715px !important;
  }

  .w-md-720p {
    width: 720px !important;
  }

  .w-md-725p {
    width: 725px !important;
  }

  .w-md-730p {
    width: 730px !important;
  }

  .w-md-735p {
    width: 735px !important;
  }

  .w-md-740p {
    width: 740px !important;
  }

  .w-md-745p {
    width: 745px !important;
  }

  .w-md-750p {
    width: 750px !important;
  }

  .w-md-755p {
    width: 755px !important;
  }

  .w-md-760p {
    width: 760px !important;
  }

  .w-md-765p {
    width: 765px !important;
  }

  .w-md-770p {
    width: 770px !important;
  }

  .w-md-775p {
    width: 775px !important;
  }

  .w-md-780p {
    width: 780px !important;
  }

  .w-md-785p {
    width: 785px !important;
  }

  .w-md-790p {
    width: 790px !important;
  }

  .w-md-795p {
    width: 795px !important;
  }

  .w-md-800p {
    width: 800px !important;
  }
}
@media (min-width: 992px) {
  .w-lg-25p {
    width: 25px !important;
  }

  .w-lg-30p {
    width: 30px !important;
  }

  .w-lg-35p {
    width: 35px !important;
  }

  .w-lg-40p {
    width: 40px !important;
  }

  .w-lg-45p {
    width: 45px !important;
  }

  .w-lg-50p {
    width: 50px !important;
  }

  .w-lg-55p {
    width: 55px !important;
  }

  .w-lg-60p {
    width: 60px !important;
  }

  .w-lg-65p {
    width: 65px !important;
  }

  .w-lg-70p {
    width: 70px !important;
  }

  .w-lg-75p {
    width: 75px !important;
  }

  .w-lg-80p {
    width: 80px !important;
  }

  .w-lg-85p {
    width: 85px !important;
  }

  .w-lg-90p {
    width: 90px !important;
  }

  .w-lg-95p {
    width: 95px !important;
  }

  .w-lg-100p {
    width: 100px !important;
  }

  .w-lg-105p {
    width: 105px !important;
  }

  .w-lg-110p {
    width: 110px !important;
  }

  .w-lg-115p {
    width: 115px !important;
  }

  .w-lg-120p {
    width: 120px !important;
  }

  .w-lg-125p {
    width: 125px !important;
  }

  .w-lg-130p {
    width: 130px !important;
  }

  .w-lg-135p {
    width: 135px !important;
  }

  .w-lg-140p {
    width: 140px !important;
  }

  .w-lg-145p {
    width: 145px !important;
  }

  .w-lg-150p {
    width: 150px !important;
  }

  .w-lg-155p {
    width: 155px !important;
  }

  .w-lg-160p {
    width: 160px !important;
  }

  .w-lg-165p {
    width: 165px !important;
  }

  .w-lg-170p {
    width: 170px !important;
  }

  .w-lg-175p {
    width: 175px !important;
  }

  .w-lg-180p {
    width: 180px !important;
  }

  .w-lg-185p {
    width: 185px !important;
  }

  .w-lg-190p {
    width: 190px !important;
  }

  .w-lg-195p {
    width: 195px !important;
  }

  .w-lg-200p {
    width: 200px !important;
  }

  .w-lg-205p {
    width: 205px !important;
  }

  .w-lg-210p {
    width: 210px !important;
  }

  .w-lg-215p {
    width: 215px !important;
  }

  .w-lg-220p {
    width: 220px !important;
  }

  .w-lg-225p {
    width: 225px !important;
  }

  .w-lg-230p {
    width: 230px !important;
  }

  .w-lg-235p {
    width: 235px !important;
  }

  .w-lg-240p {
    width: 240px !important;
  }

  .w-lg-245p {
    width: 245px !important;
  }

  .w-lg-250p {
    width: 250px !important;
  }

  .w-lg-255p {
    width: 255px !important;
  }

  .w-lg-260p {
    width: 260px !important;
  }

  .w-lg-265p {
    width: 265px !important;
  }

  .w-lg-270p {
    width: 270px !important;
  }

  .w-lg-275p {
    width: 275px !important;
  }

  .w-lg-280p {
    width: 280px !important;
  }

  .w-lg-285p {
    width: 285px !important;
  }

  .w-lg-290p {
    width: 290px !important;
  }

  .w-lg-295p {
    width: 295px !important;
  }

  .w-lg-300p {
    width: 300px !important;
  }

  .w-lg-305p {
    width: 305px !important;
  }

  .w-lg-310p {
    width: 310px !important;
  }

  .w-lg-315p {
    width: 315px !important;
  }

  .w-lg-320p {
    width: 320px !important;
  }

  .w-lg-325p {
    width: 325px !important;
  }

  .w-lg-330p {
    width: 330px !important;
  }

  .w-lg-335p {
    width: 335px !important;
  }

  .w-lg-340p {
    width: 340px !important;
  }

  .w-lg-345p {
    width: 345px !important;
  }

  .w-lg-350p {
    width: 350px !important;
  }

  .w-lg-355p {
    width: 355px !important;
  }

  .w-lg-360p {
    width: 360px !important;
  }

  .w-lg-365p {
    width: 365px !important;
  }

  .w-lg-370p {
    width: 370px !important;
  }

  .w-lg-375p {
    width: 375px !important;
  }

  .w-lg-380p {
    width: 380px !important;
  }

  .w-lg-385p {
    width: 385px !important;
  }

  .w-lg-390p {
    width: 390px !important;
  }

  .w-lg-395p {
    width: 395px !important;
  }

  .w-lg-400p {
    width: 400px !important;
  }

  .w-lg-405p {
    width: 405px !important;
  }

  .w-lg-410p {
    width: 410px !important;
  }

  .w-lg-415p {
    width: 415px !important;
  }

  .w-lg-420p {
    width: 420px !important;
  }

  .w-lg-425p {
    width: 425px !important;
  }

  .w-lg-430p {
    width: 430px !important;
  }

  .w-lg-435p {
    width: 435px !important;
  }

  .w-lg-440p {
    width: 440px !important;
  }

  .w-lg-445p {
    width: 445px !important;
  }

  .w-lg-450p {
    width: 450px !important;
  }

  .w-lg-455p {
    width: 455px !important;
  }

  .w-lg-460p {
    width: 460px !important;
  }

  .w-lg-465p {
    width: 465px !important;
  }

  .w-lg-470p {
    width: 470px !important;
  }

  .w-lg-475p {
    width: 475px !important;
  }

  .w-lg-480p {
    width: 480px !important;
  }

  .w-lg-485p {
    width: 485px !important;
  }

  .w-lg-490p {
    width: 490px !important;
  }

  .w-lg-495p {
    width: 495px !important;
  }

  .w-lg-500p {
    width: 500px !important;
  }

  .w-lg-505p {
    width: 505px !important;
  }

  .w-lg-510p {
    width: 510px !important;
  }

  .w-lg-515p {
    width: 515px !important;
  }

  .w-lg-520p {
    width: 520px !important;
  }

  .w-lg-525p {
    width: 525px !important;
  }

  .w-lg-530p {
    width: 530px !important;
  }

  .w-lg-535p {
    width: 535px !important;
  }

  .w-lg-540p {
    width: 540px !important;
  }

  .w-lg-545p {
    width: 545px !important;
  }

  .w-lg-550p {
    width: 550px !important;
  }

  .w-lg-555p {
    width: 555px !important;
  }

  .w-lg-560p {
    width: 560px !important;
  }

  .w-lg-565p {
    width: 565px !important;
  }

  .w-lg-570p {
    width: 570px !important;
  }

  .w-lg-575p {
    width: 575px !important;
  }

  .w-lg-580p {
    width: 580px !important;
  }

  .w-lg-585p {
    width: 585px !important;
  }

  .w-lg-590p {
    width: 590px !important;
  }

  .w-lg-595p {
    width: 595px !important;
  }

  .w-lg-600p {
    width: 600px !important;
  }

  .w-lg-605p {
    width: 605px !important;
  }

  .w-lg-610p {
    width: 610px !important;
  }

  .w-lg-615p {
    width: 615px !important;
  }

  .w-lg-620p {
    width: 620px !important;
  }

  .w-lg-625p {
    width: 625px !important;
  }

  .w-lg-630p {
    width: 630px !important;
  }

  .w-lg-635p {
    width: 635px !important;
  }

  .w-lg-640p {
    width: 640px !important;
  }

  .w-lg-645p {
    width: 645px !important;
  }

  .w-lg-650p {
    width: 650px !important;
  }

  .w-lg-655p {
    width: 655px !important;
  }

  .w-lg-660p {
    width: 660px !important;
  }

  .w-lg-665p {
    width: 665px !important;
  }

  .w-lg-670p {
    width: 670px !important;
  }

  .w-lg-675p {
    width: 675px !important;
  }

  .w-lg-680p {
    width: 680px !important;
  }

  .w-lg-685p {
    width: 685px !important;
  }

  .w-lg-690p {
    width: 690px !important;
  }

  .w-lg-695p {
    width: 695px !important;
  }

  .w-lg-700p {
    width: 700px !important;
  }

  .w-lg-705p {
    width: 705px !important;
  }

  .w-lg-710p {
    width: 710px !important;
  }

  .w-lg-715p {
    width: 715px !important;
  }

  .w-lg-720p {
    width: 720px !important;
  }

  .w-lg-725p {
    width: 725px !important;
  }

  .w-lg-730p {
    width: 730px !important;
  }

  .w-lg-735p {
    width: 735px !important;
  }

  .w-lg-740p {
    width: 740px !important;
  }

  .w-lg-745p {
    width: 745px !important;
  }

  .w-lg-750p {
    width: 750px !important;
  }

  .w-lg-755p {
    width: 755px !important;
  }

  .w-lg-760p {
    width: 760px !important;
  }

  .w-lg-765p {
    width: 765px !important;
  }

  .w-lg-770p {
    width: 770px !important;
  }

  .w-lg-775p {
    width: 775px !important;
  }

  .w-lg-780p {
    width: 780px !important;
  }

  .w-lg-785p {
    width: 785px !important;
  }

  .w-lg-790p {
    width: 790px !important;
  }

  .w-lg-795p {
    width: 795px !important;
  }

  .w-lg-800p {
    width: 800px !important;
  }
}
@media (min-width: 1200px) {
  .w-xl-25p {
    width: 25px !important;
  }

  .w-xl-30p {
    width: 30px !important;
  }

  .w-xl-35p {
    width: 35px !important;
  }

  .w-xl-40p {
    width: 40px !important;
  }

  .w-xl-45p {
    width: 45px !important;
  }

  .w-xl-50p {
    width: 50px !important;
  }

  .w-xl-55p {
    width: 55px !important;
  }

  .w-xl-60p {
    width: 60px !important;
  }

  .w-xl-65p {
    width: 65px !important;
  }

  .w-xl-70p {
    width: 70px !important;
  }

  .w-xl-75p {
    width: 75px !important;
  }

  .w-xl-80p {
    width: 80px !important;
  }

  .w-xl-85p {
    width: 85px !important;
  }

  .w-xl-90p {
    width: 90px !important;
  }

  .w-xl-95p {
    width: 95px !important;
  }

  .w-xl-100p {
    width: 100px !important;
  }

  .w-xl-105p {
    width: 105px !important;
  }

  .w-xl-110p {
    width: 110px !important;
  }

  .w-xl-115p {
    width: 115px !important;
  }

  .w-xl-120p {
    width: 120px !important;
  }

  .w-xl-125p {
    width: 125px !important;
  }

  .w-xl-130p {
    width: 130px !important;
  }

  .w-xl-135p {
    width: 135px !important;
  }

  .w-xl-140p {
    width: 140px !important;
  }

  .w-xl-145p {
    width: 145px !important;
  }

  .w-xl-150p {
    width: 150px !important;
  }

  .w-xl-155p {
    width: 155px !important;
  }

  .w-xl-160p {
    width: 160px !important;
  }

  .w-xl-165p {
    width: 165px !important;
  }

  .w-xl-170p {
    width: 170px !important;
  }

  .w-xl-175p {
    width: 175px !important;
  }

  .w-xl-180p {
    width: 180px !important;
  }

  .w-xl-185p {
    width: 185px !important;
  }

  .w-xl-190p {
    width: 190px !important;
  }

  .w-xl-195p {
    width: 195px !important;
  }

  .w-xl-200p {
    width: 200px !important;
  }

  .w-xl-205p {
    width: 205px !important;
  }

  .w-xl-210p {
    width: 210px !important;
  }

  .w-xl-215p {
    width: 215px !important;
  }

  .w-xl-220p {
    width: 220px !important;
  }

  .w-xl-225p {
    width: 225px !important;
  }

  .w-xl-230p {
    width: 230px !important;
  }

  .w-xl-235p {
    width: 235px !important;
  }

  .w-xl-240p {
    width: 240px !important;
  }

  .w-xl-245p {
    width: 245px !important;
  }

  .w-xl-250p {
    width: 250px !important;
  }

  .w-xl-255p {
    width: 255px !important;
  }

  .w-xl-260p {
    width: 260px !important;
  }

  .w-xl-265p {
    width: 265px !important;
  }

  .w-xl-270p {
    width: 270px !important;
  }

  .w-xl-275p {
    width: 275px !important;
  }

  .w-xl-280p {
    width: 280px !important;
  }

  .w-xl-285p {
    width: 285px !important;
  }

  .w-xl-290p {
    width: 290px !important;
  }

  .w-xl-295p {
    width: 295px !important;
  }

  .w-xl-300p {
    width: 300px !important;
  }

  .w-xl-305p {
    width: 305px !important;
  }

  .w-xl-310p {
    width: 310px !important;
  }

  .w-xl-315p {
    width: 315px !important;
  }

  .w-xl-320p {
    width: 320px !important;
  }

  .w-xl-325p {
    width: 325px !important;
  }

  .w-xl-330p {
    width: 330px !important;
  }

  .w-xl-335p {
    width: 335px !important;
  }

  .w-xl-340p {
    width: 340px !important;
  }

  .w-xl-345p {
    width: 345px !important;
  }

  .w-xl-350p {
    width: 350px !important;
  }

  .w-xl-355p {
    width: 355px !important;
  }

  .w-xl-360p {
    width: 360px !important;
  }

  .w-xl-365p {
    width: 365px !important;
  }

  .w-xl-370p {
    width: 370px !important;
  }

  .w-xl-375p {
    width: 375px !important;
  }

  .w-xl-380p {
    width: 380px !important;
  }

  .w-xl-385p {
    width: 385px !important;
  }

  .w-xl-390p {
    width: 390px !important;
  }

  .w-xl-395p {
    width: 395px !important;
  }

  .w-xl-400p {
    width: 400px !important;
  }

  .w-xl-405p {
    width: 405px !important;
  }

  .w-xl-410p {
    width: 410px !important;
  }

  .w-xl-415p {
    width: 415px !important;
  }

  .w-xl-420p {
    width: 420px !important;
  }

  .w-xl-425p {
    width: 425px !important;
  }

  .w-xl-430p {
    width: 430px !important;
  }

  .w-xl-435p {
    width: 435px !important;
  }

  .w-xl-440p {
    width: 440px !important;
  }

  .w-xl-445p {
    width: 445px !important;
  }

  .w-xl-450p {
    width: 450px !important;
  }

  .w-xl-455p {
    width: 455px !important;
  }

  .w-xl-460p {
    width: 460px !important;
  }

  .w-xl-465p {
    width: 465px !important;
  }

  .w-xl-470p {
    width: 470px !important;
  }

  .w-xl-475p {
    width: 475px !important;
  }

  .w-xl-480p {
    width: 480px !important;
  }

  .w-xl-485p {
    width: 485px !important;
  }

  .w-xl-490p {
    width: 490px !important;
  }

  .w-xl-495p {
    width: 495px !important;
  }

  .w-xl-500p {
    width: 500px !important;
  }

  .w-xl-505p {
    width: 505px !important;
  }

  .w-xl-510p {
    width: 510px !important;
  }

  .w-xl-515p {
    width: 515px !important;
  }

  .w-xl-520p {
    width: 520px !important;
  }

  .w-xl-525p {
    width: 525px !important;
  }

  .w-xl-530p {
    width: 530px !important;
  }

  .w-xl-535p {
    width: 535px !important;
  }

  .w-xl-540p {
    width: 540px !important;
  }

  .w-xl-545p {
    width: 545px !important;
  }

  .w-xl-550p {
    width: 550px !important;
  }

  .w-xl-555p {
    width: 555px !important;
  }

  .w-xl-560p {
    width: 560px !important;
  }

  .w-xl-565p {
    width: 565px !important;
  }

  .w-xl-570p {
    width: 570px !important;
  }

  .w-xl-575p {
    width: 575px !important;
  }

  .w-xl-580p {
    width: 580px !important;
  }

  .w-xl-585p {
    width: 585px !important;
  }

  .w-xl-590p {
    width: 590px !important;
  }

  .w-xl-595p {
    width: 595px !important;
  }

  .w-xl-600p {
    width: 600px !important;
  }

  .w-xl-605p {
    width: 605px !important;
  }

  .w-xl-610p {
    width: 610px !important;
  }

  .w-xl-615p {
    width: 615px !important;
  }

  .w-xl-620p {
    width: 620px !important;
  }

  .w-xl-625p {
    width: 625px !important;
  }

  .w-xl-630p {
    width: 630px !important;
  }

  .w-xl-635p {
    width: 635px !important;
  }

  .w-xl-640p {
    width: 640px !important;
  }

  .w-xl-645p {
    width: 645px !important;
  }

  .w-xl-650p {
    width: 650px !important;
  }

  .w-xl-655p {
    width: 655px !important;
  }

  .w-xl-660p {
    width: 660px !important;
  }

  .w-xl-665p {
    width: 665px !important;
  }

  .w-xl-670p {
    width: 670px !important;
  }

  .w-xl-675p {
    width: 675px !important;
  }

  .w-xl-680p {
    width: 680px !important;
  }

  .w-xl-685p {
    width: 685px !important;
  }

  .w-xl-690p {
    width: 690px !important;
  }

  .w-xl-695p {
    width: 695px !important;
  }

  .w-xl-700p {
    width: 700px !important;
  }

  .w-xl-705p {
    width: 705px !important;
  }

  .w-xl-710p {
    width: 710px !important;
  }

  .w-xl-715p {
    width: 715px !important;
  }

  .w-xl-720p {
    width: 720px !important;
  }

  .w-xl-725p {
    width: 725px !important;
  }

  .w-xl-730p {
    width: 730px !important;
  }

  .w-xl-735p {
    width: 735px !important;
  }

  .w-xl-740p {
    width: 740px !important;
  }

  .w-xl-745p {
    width: 745px !important;
  }

  .w-xl-750p {
    width: 750px !important;
  }

  .w-xl-755p {
    width: 755px !important;
  }

  .w-xl-760p {
    width: 760px !important;
  }

  .w-xl-765p {
    width: 765px !important;
  }

  .w-xl-770p {
    width: 770px !important;
  }

  .w-xl-775p {
    width: 775px !important;
  }

  .w-xl-780p {
    width: 780px !important;
  }

  .w-xl-785p {
    width: 785px !important;
  }

  .w-xl-790p {
    width: 790px !important;
  }

  .w-xl-795p {
    width: 795px !important;
  }

  .w-xl-800p {
    width: 800px !important;
  }
}
@media (min-width: 1400px) {
  .w-xxl-25p {
    width: 25px !important;
  }

  .w-xxl-30p {
    width: 30px !important;
  }

  .w-xxl-35p {
    width: 35px !important;
  }

  .w-xxl-40p {
    width: 40px !important;
  }

  .w-xxl-45p {
    width: 45px !important;
  }

  .w-xxl-50p {
    width: 50px !important;
  }

  .w-xxl-55p {
    width: 55px !important;
  }

  .w-xxl-60p {
    width: 60px !important;
  }

  .w-xxl-65p {
    width: 65px !important;
  }

  .w-xxl-70p {
    width: 70px !important;
  }

  .w-xxl-75p {
    width: 75px !important;
  }

  .w-xxl-80p {
    width: 80px !important;
  }

  .w-xxl-85p {
    width: 85px !important;
  }

  .w-xxl-90p {
    width: 90px !important;
  }

  .w-xxl-95p {
    width: 95px !important;
  }

  .w-xxl-100p {
    width: 100px !important;
  }

  .w-xxl-105p {
    width: 105px !important;
  }

  .w-xxl-110p {
    width: 110px !important;
  }

  .w-xxl-115p {
    width: 115px !important;
  }

  .w-xxl-120p {
    width: 120px !important;
  }

  .w-xxl-125p {
    width: 125px !important;
  }

  .w-xxl-130p {
    width: 130px !important;
  }

  .w-xxl-135p {
    width: 135px !important;
  }

  .w-xxl-140p {
    width: 140px !important;
  }

  .w-xxl-145p {
    width: 145px !important;
  }

  .w-xxl-150p {
    width: 150px !important;
  }

  .w-xxl-155p {
    width: 155px !important;
  }

  .w-xxl-160p {
    width: 160px !important;
  }

  .w-xxl-165p {
    width: 165px !important;
  }

  .w-xxl-170p {
    width: 170px !important;
  }

  .w-xxl-175p {
    width: 175px !important;
  }

  .w-xxl-180p {
    width: 180px !important;
  }

  .w-xxl-185p {
    width: 185px !important;
  }

  .w-xxl-190p {
    width: 190px !important;
  }

  .w-xxl-195p {
    width: 195px !important;
  }

  .w-xxl-200p {
    width: 200px !important;
  }

  .w-xxl-205p {
    width: 205px !important;
  }

  .w-xxl-210p {
    width: 210px !important;
  }

  .w-xxl-215p {
    width: 215px !important;
  }

  .w-xxl-220p {
    width: 220px !important;
  }

  .w-xxl-225p {
    width: 225px !important;
  }

  .w-xxl-230p {
    width: 230px !important;
  }

  .w-xxl-235p {
    width: 235px !important;
  }

  .w-xxl-240p {
    width: 240px !important;
  }

  .w-xxl-245p {
    width: 245px !important;
  }

  .w-xxl-250p {
    width: 250px !important;
  }

  .w-xxl-255p {
    width: 255px !important;
  }

  .w-xxl-260p {
    width: 260px !important;
  }

  .w-xxl-265p {
    width: 265px !important;
  }

  .w-xxl-270p {
    width: 270px !important;
  }

  .w-xxl-275p {
    width: 275px !important;
  }

  .w-xxl-280p {
    width: 280px !important;
  }

  .w-xxl-285p {
    width: 285px !important;
  }

  .w-xxl-290p {
    width: 290px !important;
  }

  .w-xxl-295p {
    width: 295px !important;
  }

  .w-xxl-300p {
    width: 300px !important;
  }

  .w-xxl-305p {
    width: 305px !important;
  }

  .w-xxl-310p {
    width: 310px !important;
  }

  .w-xxl-315p {
    width: 315px !important;
  }

  .w-xxl-320p {
    width: 320px !important;
  }

  .w-xxl-325p {
    width: 325px !important;
  }

  .w-xxl-330p {
    width: 330px !important;
  }

  .w-xxl-335p {
    width: 335px !important;
  }

  .w-xxl-340p {
    width: 340px !important;
  }

  .w-xxl-345p {
    width: 345px !important;
  }

  .w-xxl-350p {
    width: 350px !important;
  }

  .w-xxl-355p {
    width: 355px !important;
  }

  .w-xxl-360p {
    width: 360px !important;
  }

  .w-xxl-365p {
    width: 365px !important;
  }

  .w-xxl-370p {
    width: 370px !important;
  }

  .w-xxl-375p {
    width: 375px !important;
  }

  .w-xxl-380p {
    width: 380px !important;
  }

  .w-xxl-385p {
    width: 385px !important;
  }

  .w-xxl-390p {
    width: 390px !important;
  }

  .w-xxl-395p {
    width: 395px !important;
  }

  .w-xxl-400p {
    width: 400px !important;
  }

  .w-xxl-405p {
    width: 405px !important;
  }

  .w-xxl-410p {
    width: 410px !important;
  }

  .w-xxl-415p {
    width: 415px !important;
  }

  .w-xxl-420p {
    width: 420px !important;
  }

  .w-xxl-425p {
    width: 425px !important;
  }

  .w-xxl-430p {
    width: 430px !important;
  }

  .w-xxl-435p {
    width: 435px !important;
  }

  .w-xxl-440p {
    width: 440px !important;
  }

  .w-xxl-445p {
    width: 445px !important;
  }

  .w-xxl-450p {
    width: 450px !important;
  }

  .w-xxl-455p {
    width: 455px !important;
  }

  .w-xxl-460p {
    width: 460px !important;
  }

  .w-xxl-465p {
    width: 465px !important;
  }

  .w-xxl-470p {
    width: 470px !important;
  }

  .w-xxl-475p {
    width: 475px !important;
  }

  .w-xxl-480p {
    width: 480px !important;
  }

  .w-xxl-485p {
    width: 485px !important;
  }

  .w-xxl-490p {
    width: 490px !important;
  }

  .w-xxl-495p {
    width: 495px !important;
  }

  .w-xxl-500p {
    width: 500px !important;
  }

  .w-xxl-505p {
    width: 505px !important;
  }

  .w-xxl-510p {
    width: 510px !important;
  }

  .w-xxl-515p {
    width: 515px !important;
  }

  .w-xxl-520p {
    width: 520px !important;
  }

  .w-xxl-525p {
    width: 525px !important;
  }

  .w-xxl-530p {
    width: 530px !important;
  }

  .w-xxl-535p {
    width: 535px !important;
  }

  .w-xxl-540p {
    width: 540px !important;
  }

  .w-xxl-545p {
    width: 545px !important;
  }

  .w-xxl-550p {
    width: 550px !important;
  }

  .w-xxl-555p {
    width: 555px !important;
  }

  .w-xxl-560p {
    width: 560px !important;
  }

  .w-xxl-565p {
    width: 565px !important;
  }

  .w-xxl-570p {
    width: 570px !important;
  }

  .w-xxl-575p {
    width: 575px !important;
  }

  .w-xxl-580p {
    width: 580px !important;
  }

  .w-xxl-585p {
    width: 585px !important;
  }

  .w-xxl-590p {
    width: 590px !important;
  }

  .w-xxl-595p {
    width: 595px !important;
  }

  .w-xxl-600p {
    width: 600px !important;
  }

  .w-xxl-605p {
    width: 605px !important;
  }

  .w-xxl-610p {
    width: 610px !important;
  }

  .w-xxl-615p {
    width: 615px !important;
  }

  .w-xxl-620p {
    width: 620px !important;
  }

  .w-xxl-625p {
    width: 625px !important;
  }

  .w-xxl-630p {
    width: 630px !important;
  }

  .w-xxl-635p {
    width: 635px !important;
  }

  .w-xxl-640p {
    width: 640px !important;
  }

  .w-xxl-645p {
    width: 645px !important;
  }

  .w-xxl-650p {
    width: 650px !important;
  }

  .w-xxl-655p {
    width: 655px !important;
  }

  .w-xxl-660p {
    width: 660px !important;
  }

  .w-xxl-665p {
    width: 665px !important;
  }

  .w-xxl-670p {
    width: 670px !important;
  }

  .w-xxl-675p {
    width: 675px !important;
  }

  .w-xxl-680p {
    width: 680px !important;
  }

  .w-xxl-685p {
    width: 685px !important;
  }

  .w-xxl-690p {
    width: 690px !important;
  }

  .w-xxl-695p {
    width: 695px !important;
  }

  .w-xxl-700p {
    width: 700px !important;
  }

  .w-xxl-705p {
    width: 705px !important;
  }

  .w-xxl-710p {
    width: 710px !important;
  }

  .w-xxl-715p {
    width: 715px !important;
  }

  .w-xxl-720p {
    width: 720px !important;
  }

  .w-xxl-725p {
    width: 725px !important;
  }

  .w-xxl-730p {
    width: 730px !important;
  }

  .w-xxl-735p {
    width: 735px !important;
  }

  .w-xxl-740p {
    width: 740px !important;
  }

  .w-xxl-745p {
    width: 745px !important;
  }

  .w-xxl-750p {
    width: 750px !important;
  }

  .w-xxl-755p {
    width: 755px !important;
  }

  .w-xxl-760p {
    width: 760px !important;
  }

  .w-xxl-765p {
    width: 765px !important;
  }

  .w-xxl-770p {
    width: 770px !important;
  }

  .w-xxl-775p {
    width: 775px !important;
  }

  .w-xxl-780p {
    width: 780px !important;
  }

  .w-xxl-785p {
    width: 785px !important;
  }

  .w-xxl-790p {
    width: 790px !important;
  }

  .w-xxl-795p {
    width: 795px !important;
  }

  .w-xxl-800p {
    width: 800px !important;
  }
}
/*Width In Percentage*/
.w-5 {
  width: 5% !important;
}

.w-10 {
  width: 10% !important;
}

.w-15 {
  width: 15% !important;
}

.w-20 {
  width: 20% !important;
}

.w-25 {
  width: 25% !important;
}

.w-30 {
  width: 30% !important;
}

.w-35 {
  width: 35% !important;
}

.w-40 {
  width: 40% !important;
}

.w-45 {
  width: 45% !important;
}

.w-50 {
  width: 50% !important;
}

.w-55 {
  width: 55% !important;
}

.w-60 {
  width: 60% !important;
}

.w-65 {
  width: 65% !important;
}

.w-70 {
  width: 70% !important;
}

.w-75 {
  width: 75% !important;
}

.w-80 {
  width: 80% !important;
}

.w-85 {
  width: 85% !important;
}

.w-90 {
  width: 90% !important;
}

.w-95 {
  width: 95% !important;
}

.w-100 {
  width: 100% !important;
}

@media (min-width: 576px) {
  .w-sm-5 {
    width: 5% !important;
  }

  .w-sm-10 {
    width: 10% !important;
  }

  .w-sm-15 {
    width: 15% !important;
  }

  .w-sm-20 {
    width: 20% !important;
  }

  .w-sm-25 {
    width: 25% !important;
  }

  .w-sm-30 {
    width: 30% !important;
  }

  .w-sm-35 {
    width: 35% !important;
  }

  .w-sm-40 {
    width: 40% !important;
  }

  .w-sm-45 {
    width: 45% !important;
  }

  .w-sm-50 {
    width: 50% !important;
  }

  .w-sm-55 {
    width: 55% !important;
  }

  .w-sm-60 {
    width: 60% !important;
  }

  .w-sm-65 {
    width: 65% !important;
  }

  .w-sm-70 {
    width: 70% !important;
  }

  .w-sm-75 {
    width: 75% !important;
  }

  .w-sm-80 {
    width: 80% !important;
  }

  .w-sm-85 {
    width: 85% !important;
  }

  .w-sm-90 {
    width: 90% !important;
  }

  .w-sm-95 {
    width: 95% !important;
  }

  .w-sm-100 {
    width: 100% !important;
  }
}
@media (min-width: 768px) {
  .w-md-5 {
    width: 5% !important;
  }

  .w-md-10 {
    width: 10% !important;
  }

  .w-md-15 {
    width: 15% !important;
  }

  .w-md-20 {
    width: 20% !important;
  }

  .w-md-25 {
    width: 25% !important;
  }

  .w-md-30 {
    width: 30% !important;
  }

  .w-md-35 {
    width: 35% !important;
  }

  .w-md-40 {
    width: 40% !important;
  }

  .w-md-45 {
    width: 45% !important;
  }

  .w-md-50 {
    width: 50% !important;
  }

  .w-md-55 {
    width: 55% !important;
  }

  .w-md-60 {
    width: 60% !important;
  }

  .w-md-65 {
    width: 65% !important;
  }

  .w-md-70 {
    width: 70% !important;
  }

  .w-md-75 {
    width: 75% !important;
  }

  .w-md-80 {
    width: 80% !important;
  }

  .w-md-85 {
    width: 85% !important;
  }

  .w-md-90 {
    width: 90% !important;
  }

  .w-md-95 {
    width: 95% !important;
  }

  .w-md-100 {
    width: 100% !important;
  }
}
@media (min-width: 992px) {
  .w-lg-5 {
    width: 5% !important;
  }

  .w-lg-10 {
    width: 10% !important;
  }

  .w-lg-15 {
    width: 15% !important;
  }

  .w-lg-20 {
    width: 20% !important;
  }

  .w-lg-25 {
    width: 25% !important;
  }

  .w-lg-30 {
    width: 30% !important;
  }

  .w-lg-35 {
    width: 35% !important;
  }

  .w-lg-40 {
    width: 40% !important;
  }

  .w-lg-45 {
    width: 45% !important;
  }

  .w-lg-50 {
    width: 50% !important;
  }

  .w-lg-55 {
    width: 55% !important;
  }

  .w-lg-60 {
    width: 60% !important;
  }

  .w-lg-65 {
    width: 65% !important;
  }

  .w-lg-70 {
    width: 70% !important;
  }

  .w-lg-75 {
    width: 75% !important;
  }

  .w-lg-80 {
    width: 80% !important;
  }

  .w-lg-85 {
    width: 85% !important;
  }

  .w-lg-90 {
    width: 90% !important;
  }

  .w-lg-95 {
    width: 95% !important;
  }

  .w-lg-100 {
    width: 100% !important;
  }
}
@media (min-width: 1200px) {
  .w-xl-5 {
    width: 5% !important;
  }

  .w-xl-10 {
    width: 10% !important;
  }

  .w-xl-15 {
    width: 15% !important;
  }

  .w-xl-20 {
    width: 20% !important;
  }

  .w-xl-25 {
    width: 25% !important;
  }

  .w-xl-30 {
    width: 30% !important;
  }

  .w-xl-35 {
    width: 35% !important;
  }

  .w-xl-40 {
    width: 40% !important;
  }

  .w-xl-45 {
    width: 45% !important;
  }

  .w-xl-50 {
    width: 50% !important;
  }

  .w-xl-55 {
    width: 55% !important;
  }

  .w-xl-60 {
    width: 60% !important;
  }

  .w-xl-65 {
    width: 65% !important;
  }

  .w-xl-70 {
    width: 70% !important;
  }

  .w-xl-75 {
    width: 75% !important;
  }

  .w-xl-80 {
    width: 80% !important;
  }

  .w-xl-85 {
    width: 85% !important;
  }

  .w-xl-90 {
    width: 90% !important;
  }

  .w-xl-95 {
    width: 95% !important;
  }

  .w-xl-100 {
    width: 100% !important;
  }
}
@media (min-width: 1400px) {
  .w-xxl-5 {
    width: 5% !important;
  }

  .w-xxl-10 {
    width: 10% !important;
  }

  .w-xxl-15 {
    width: 15% !important;
  }

  .w-xxl-20 {
    width: 20% !important;
  }

  .w-xxl-25 {
    width: 25% !important;
  }

  .w-xxl-30 {
    width: 30% !important;
  }

  .w-xxl-35 {
    width: 35% !important;
  }

  .w-xxl-40 {
    width: 40% !important;
  }

  .w-xxl-45 {
    width: 45% !important;
  }

  .w-xxl-50 {
    width: 50% !important;
  }

  .w-xxl-55 {
    width: 55% !important;
  }

  .w-xxl-60 {
    width: 60% !important;
  }

  .w-xxl-65 {
    width: 65% !important;
  }

  .w-xxl-70 {
    width: 70% !important;
  }

  .w-xxl-75 {
    width: 75% !important;
  }

  .w-xxl-80 {
    width: 80% !important;
  }

  .w-xxl-85 {
    width: 85% !important;
  }

  .w-xxl-90 {
    width: 90% !important;
  }

  .w-xxl-95 {
    width: 95% !important;
  }

  .w-xxl-100 {
    width: 100% !important;
  }
}
/*Max Width*/
.mw-25p {
  max-width: 25px !important;
}

.mw-50p {
  max-width: 50px !important;
}

.mw-75p {
  max-width: 75px !important;
}

.mw-100p {
  max-width: 100px !important;
}

.mw-125p {
  max-width: 125px !important;
}

.mw-150p {
  max-width: 150px !important;
}

.mw-175p {
  max-width: 175px !important;
}

.mw-200p {
  max-width: 200px !important;
}

.mw-225p {
  max-width: 225px !important;
}

.mw-250p {
  max-width: 250px !important;
}

.mw-275p {
  max-width: 275px !important;
}

.mw-300p {
  max-width: 300px !important;
}

.mw-325p {
  max-width: 325px !important;
}

.mw-350p {
  max-width: 350px !important;
}

.mw-375p {
  max-width: 375px !important;
}

.mw-400p {
  max-width: 400px !important;
}

.mw-425p {
  max-width: 425px !important;
}

.mw-450p {
  max-width: 450px !important;
}

.mw-475p {
  max-width: 475px !important;
}

.mw-500p {
  max-width: 500px !important;
}

.mw-525p {
  max-width: 525px !important;
}

.mw-550p {
  max-width: 550px !important;
}

.mw-575p {
  max-width: 575px !important;
}

.mw-600p {
  max-width: 600px !important;
}

.mw-625p {
  max-width: 625px !important;
}

.mw-650p {
  max-width: 650px !important;
}

.mw-675p {
  max-width: 675px !important;
}

.mw-700p {
  max-width: 700px !important;
}

.mw-725p {
  max-width: 725px !important;
}

.mw-750p {
  max-width: 750px !important;
}

.mw-775p {
  max-width: 775px !important;
}

.mw-800p {
  max-width: 800px !important;
}

/*Min Width*/
.mnw-0 {
  min-width: 0 !important;
}

.mnw-25p {
  min-width: 25px !important;
}

.mnw-50p {
  min-width: 50px !important;
}

.mnw-75p {
  min-width: 75px !important;
}

.mnw-100p {
  min-width: 100px !important;
}

.mnw-125p {
  min-width: 125px !important;
}

.mnw-150p {
  min-width: 150px !important;
}

.mnw-175p {
  min-width: 175px !important;
}

.mnw-200p {
  min-width: 200px !important;
}

.mnw-225p {
  min-width: 225px !important;
}

.mnw-250p {
  min-width: 250px !important;
}

.mnw-275p {
  min-width: 275px !important;
}

.mnw-300p {
  min-width: 300px !important;
}

.mnw-325p {
  min-width: 325px !important;
}

.mnw-350p {
  min-width: 350px !important;
}

.mnw-375p {
  min-width: 375px !important;
}

.mnw-400p {
  min-width: 400px !important;
}

.mnw-425p {
  min-width: 425px !important;
}

.mnw-450p {
  min-width: 450px !important;
}

.mnw-475p {
  min-width: 475px !important;
}

.mnw-500p {
  min-width: 500px !important;
}

.mnw-525p {
  min-width: 525px !important;
}

.mnw-550p {
  min-width: 550px !important;
}

.mnw-575p {
  min-width: 575px !important;
}

.mnw-600p {
  min-width: 600px !important;
}

.mnw-625p {
  min-width: 625px !important;
}

.mnw-650p {
  min-width: 650px !important;
}

.mnw-675p {
  min-width: 675px !important;
}

.mnw-700p {
  min-width: 700px !important;
}

.mnw-725p {
  min-width: 725px !important;
}

.mnw-750p {
  min-width: 750px !important;
}

.mnw-775p {
  min-width: 775px !important;
}

.mnw-800p {
  min-width: 800px !important;
}

/*Height*/
.h-0 {
  height: 0 !important;
}

.h-25p {
  height: 25px !important;
}

.h-30p {
  height: 30px !important;
}

.h-35p {
  height: 35px !important;
}

.h-40p {
  height: 40px !important;
}

.h-45p {
  height: 45px !important;
}

.h-50p {
  height: 50px !important;
}

.h-55p {
  height: 55px !important;
}

.h-60p {
  height: 60px !important;
}

.h-65p {
  height: 65px !important;
}

.h-70p {
  height: 70px !important;
}

.h-75p {
  height: 75px !important;
}

.h-80p {
  height: 80px !important;
}

.h-85p {
  height: 85px !important;
}

.h-90p {
  height: 90px !important;
}

.h-95p {
  height: 95px !important;
}

.h-100p {
  height: 100px !important;
}

.h-105p {
  height: 105px !important;
}

.h-110p {
  height: 110px !important;
}

.h-115p {
  height: 115px !important;
}

.h-120p {
  height: 120px !important;
}

.h-125p {
  height: 125px !important;
}

.h-130p {
  height: 130px !important;
}

.h-135p {
  height: 135px !important;
}

.h-140p {
  height: 140px !important;
}

.h-145p {
  height: 145px !important;
}

.h-150p {
  height: 150px !important;
}

.h-155p {
  height: 155px !important;
}

.h-160p {
  height: 160px !important;
}

.h-165p {
  height: 165px !important;
}

.h-170p {
  height: 170px !important;
}

.h-175p {
  height: 175px !important;
}

.h-180p {
  height: 180px !important;
}

.h-185p {
  height: 185px !important;
}

.h-190p {
  height: 190px !important;
}

.h-195p {
  height: 195px !important;
}

.h-200p {
  height: 200px !important;
}

.h-205p {
  height: 205px !important;
}

.h-210p {
  height: 210px !important;
}

.h-215p {
  height: 215px !important;
}

.h-220p {
  height: 220px !important;
}

.h-225p {
  height: 225px !important;
}

.h-230p {
  height: 230px !important;
}

.h-235p {
  height: 235px !important;
}

.h-240p {
  height: 240px !important;
}

.h-245p {
  height: 245px !important;
}

.h-250p {
  height: 250px !important;
}

.h-255p {
  height: 255px !important;
}

.h-260p {
  height: 260px !important;
}

.h-265p {
  height: 265px !important;
}

.h-270p {
  height: 270px !important;
}

.h-275p {
  height: 275px !important;
}

.h-280p {
  height: 280px !important;
}

.h-285p {
  height: 285px !important;
}

.h-290p {
  height: 290px !important;
}

.h-295p {
  height: 295px !important;
}

.h-300p {
  height: 300px !important;
}

.h-305p {
  height: 305px !important;
}

.h-310p {
  height: 310px !important;
}

.h-315p {
  height: 315px !important;
}

.h-320p {
  height: 320px !important;
}

.h-325p {
  height: 325px !important;
}

.h-330p {
  height: 330px !important;
}

.h-335p {
  height: 335px !important;
}

.h-340p {
  height: 340px !important;
}

.h-345p {
  height: 345px !important;
}

.h-350p {
  height: 350px !important;
}

.h-355p {
  height: 355px !important;
}

.h-360p {
  height: 360px !important;
}

.h-365p {
  height: 365px !important;
}

.h-370p {
  height: 370px !important;
}

.h-375p {
  height: 375px !important;
}

.h-380p {
  height: 380px !important;
}

.h-385p {
  height: 385px !important;
}

.h-390p {
  height: 390px !important;
}

.h-395p {
  height: 395px !important;
}

.h-400p {
  height: 400px !important;
}

.h-405p {
  height: 405px !important;
}

.h-410p {
  height: 410px !important;
}

.h-415p {
  height: 415px !important;
}

.h-420p {
  height: 420px !important;
}

.h-425p {
  height: 425px !important;
}

.h-430p {
  height: 430px !important;
}

.h-435p {
  height: 435px !important;
}

.h-440p {
  height: 440px !important;
}

.h-445p {
  height: 445px !important;
}

.h-450p {
  height: 450px !important;
}

.h-455p {
  height: 455px !important;
}

.h-460p {
  height: 460px !important;
}

.h-465p {
  height: 465px !important;
}

.h-470p {
  height: 470px !important;
}

.h-475p {
  height: 475px !important;
}

.h-480p {
  height: 480px !important;
}

.h-485p {
  height: 485px !important;
}

.h-490p {
  height: 490px !important;
}

.h-495p {
  height: 495px !important;
}

.h-500p {
  height: 500px !important;
}

.h-505p {
  height: 505px !important;
}

.h-510p {
  height: 510px !important;
}

.h-515p {
  height: 515px !important;
}

.h-520p {
  height: 520px !important;
}

.h-525p {
  height: 525px !important;
}

.h-530p {
  height: 530px !important;
}

.h-535p {
  height: 535px !important;
}

.h-540p {
  height: 540px !important;
}

.h-545p {
  height: 545px !important;
}

.h-550p {
  height: 550px !important;
}

.h-555p {
  height: 555px !important;
}

.h-560p {
  height: 560px !important;
}

.h-565p {
  height: 565px !important;
}

.h-570p {
  height: 570px !important;
}

.h-575p {
  height: 575px !important;
}

.h-580p {
  height: 580px !important;
}

.h-585p {
  height: 585px !important;
}

.h-590p {
  height: 590px !important;
}

.h-595p {
  height: 595px !important;
}

.h-600p {
  height: 600px !important;
}

.h-605p {
  height: 605px !important;
}

.h-610p {
  height: 610px !important;
}

.h-615p {
  height: 615px !important;
}

.h-620p {
  height: 620px !important;
}

.h-625p {
  height: 625px !important;
}

.h-630p {
  height: 630px !important;
}

.h-635p {
  height: 635px !important;
}

.h-640p {
  height: 640px !important;
}

.h-645p {
  height: 645px !important;
}

.h-650p {
  height: 650px !important;
}

.h-655p {
  height: 655px !important;
}

.h-660p {
  height: 660px !important;
}

.h-665p {
  height: 665px !important;
}

.h-670p {
  height: 670px !important;
}

.h-675p {
  height: 675px !important;
}

.h-680p {
  height: 680px !important;
}

.h-685p {
  height: 685px !important;
}

.h-690p {
  height: 690px !important;
}

.h-695p {
  height: 695px !important;
}

.h-700p {
  height: 700px !important;
}

.h-705p {
  height: 705px !important;
}

.h-710p {
  height: 710px !important;
}

.h-715p {
  height: 715px !important;
}

.h-720p {
  height: 720px !important;
}

.h-725p {
  height: 725px !important;
}

.h-730p {
  height: 730px !important;
}

.h-735p {
  height: 735px !important;
}

.h-740p {
  height: 740px !important;
}

.h-745p {
  height: 745px !important;
}

.h-750p {
  height: 750px !important;
}

.h-755p {
  height: 755px !important;
}

.h-760p {
  height: 760px !important;
}

.h-765p {
  height: 765px !important;
}

.h-770p {
  height: 770px !important;
}

.h-775p {
  height: 775px !important;
}

.h-780p {
  height: 780px !important;
}

.h-785p {
  height: 785px !important;
}

.h-790p {
  height: 790px !important;
}

.h-795p {
  height: 795px !important;
}

.h-800p {
  height: 800px !important;
}

/*Height In Percentage*/
.h-25 {
  height: 25% !important;
}

.h-30 {
  height: 30% !important;
}

.h-35 {
  height: 35% !important;
}

.h-40 {
  height: 40% !important;
}

.h-45 {
  height: 45% !important;
}

.h-50 {
  height: 50% !important;
}

.h-55 {
  height: 55% !important;
}

.h-60 {
  height: 60% !important;
}

.h-65 {
  height: 65% !important;
}

.h-70 {
  height: 70% !important;
}

.h-75 {
  height: 75% !important;
}

.h-80 {
  height: 80% !important;
}

.h-85 {
  height: 85% !important;
}

.h-90 {
  height: 90% !important;
}

.h-95 {
  height: 95% !important;
}

.h-100 {
  height: 100% !important;
}

/*Max Height*/
.mh-100p {
  max-height: 100px !important;
}

.mh-125p {
  max-height: 125px !important;
}

.mh-150p {
  max-height: 150px !important;
}

.mh-175p {
  max-height: 175px !important;
}

.mh-200p {
  max-height: 200px !important;
}

.mh-225p {
  max-height: 225px !important;
}

.mh-250p {
  max-height: 250px !important;
}

.mh-275p {
  max-height: 275px !important;
}

.mh-300p {
  max-height: 300px !important;
}

.mh-325p {
  max-height: 325px !important;
}

.mh-350p {
  max-height: 350px !important;
}

.mh-375p {
  max-height: 375px !important;
}

.mh-400p {
  max-height: 400px !important;
}

.mh-425p {
  max-height: 425px !important;
}

.mh-450p {
  max-height: 450px !important;
}

.mh-475p {
  max-height: 475px !important;
}

.mh-500p {
  max-height: 500px !important;
}

.mh-525p {
  max-height: 525px !important;
}

.mh-550p {
  max-height: 550px !important;
}

.mh-575p {
  max-height: 575px !important;
}

.mh-600p {
  max-height: 600px !important;
}

.mh-625p {
  max-height: 625px !important;
}

.mh-650p {
  max-height: 650px !important;
}

.mh-675p {
  max-height: 675px !important;
}

.mh-700p {
  max-height: 700px !important;
}

.mh-725p {
  max-height: 725px !important;
}

.mh-750p {
  max-height: 750px !important;
}

.mh-775p {
  max-height: 775px !important;
}

.mh-800p {
  max-height: 800px !important;
}

/*Min Height*/
.mnh-0 {
  min-height: 0 !important;
}

.mnh-100p {
  min-height: 100px !important;
}

.mnh-125p {
  min-height: 125px !important;
}

.mnh-150p {
  min-height: 150px !important;
}

.mnh-175p {
  min-height: 175px !important;
}

.mnh-200p {
  min-height: 200px !important;
}

.mnh-225p {
  min-height: 225px !important;
}

.mnh-250p {
  min-height: 250px !important;
}

.mnh-275p {
  min-height: 275px !important;
}

.mnh-300p {
  min-height: 300px !important;
}

.mnh-325p {
  min-height: 325px !important;
}

.mnh-350p {
  min-height: 350px !important;
}

.mnh-375p {
  min-height: 375px !important;
}

.mnh-400p {
  min-height: 400px !important;
}

.mnh-425p {
  min-height: 425px !important;
}

.mnh-450p {
  min-height: 450px !important;
}

.mnh-475p {
  min-height: 475px !important;
}

.mnh-500p {
  min-height: 500px !important;
}

.mnh-525p {
  min-height: 525px !important;
}

.mnh-550p {
  min-height: 550px !important;
}

.mnh-575p {
  min-height: 575px !important;
}

.mnh-600p {
  min-height: 600px !important;
}

.mnh-625p {
  min-height: 625px !important;
}

.mnh-650p {
  min-height: 650px !important;
}

.mnh-675p {
  min-height: 675px !important;
}

.mnh-700p {
  min-height: 700px !important;
}

.mnh-725p {
  min-height: 725px !important;
}

.mnh-750p {
  min-height: 750px !important;
}

.mnh-775p {
  min-height: 775px !important;
}

.mnh-800p {
  min-height: 800px !important;
}

.mnh-100vh {
  min-height: 100vh !important;
}

/*Hr*/
hr {
  background: #eaeaea;
}
hr.hr-2 {
  height: 2px !important;
}
hr.hr-3 {
  height: 3px !important;
}

/*opacity*/
.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-30 {
  opacity: 0.3 !important;
}

.opacity-35 {
  opacity: 0.35 !important;
}

.opacity-40 {
  opacity: 0.4 !important;
}

.opacity-45 {
  opacity: 0.45 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-55 {
  opacity: 0.55 !important;
}

.opacity-60 {
  opacity: 0.6 !important;
}

.opacity-65 {
  opacity: 0.65 !important;
}

.opacity-70 {
  opacity: 0.7 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-80 {
  opacity: 0.8 !important;
}

.opacity-85 {
  opacity: 0.85 !important;
}

.opacity-90 {
  opacity: 0.9 !important;
}

.opacity-95 {
  opacity: 0.95 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.bg-opacity-85 {
  --bs-bg-opacity: 0.85;
}

/*Div Sizes*/
.d-1 {
  height: 0.5rem !important;
  width: 0.5rem !important;
}

.d-2 {
  height: 0.75rem !important;
  width: 0.75rem !important;
}

.d-3 {
  height: 1rem !important;
  width: 1rem !important;
}

.d-4 {
  height: 1.25rem !important;
  width: 1.25rem !important;
}

.d-5 {
  height: 1.5rem !important;
  width: 1.5rem !important;
}

.d-6 {
  height: 1.75rem !important;
  width: 1.75rem !important;
}

.d-7 {
  height: 2rem !important;
  width: 2rem !important;
}

.d-8 {
  height: 2.5rem !important;
  width: 2.5rem !important;
}

.d-9 {
  height: 3rem !important;
  width: 3rem !important;
}

.d-10 {
  height: 3.5rem !important;
  width: 3.5rem !important;
}

.d-11 {
  height: 4rem !important;
  width: 4rem !important;
}

.d-12 {
  height: 4.5rem !important;
  width: 4.5rem !important;
}

.d-13 {
  height: 5rem !important;
  width: 5rem !important;
}

.d-14 {
  height: 5.5rem !important;
  width: 5.5rem !important;
}

.d-15 {
  height: 6rem !important;
  width: 6rem !important;
}

.d-16 {
  height: 7rem !important;
  width: 7rem !important;
}

.d-17 {
  height: 8rem !important;
  width: 8rem !important;
}

.d-18 {
  height: 9rem !important;
  width: 9rem !important;
}

.d-19 {
  height: 10rem !important;
  width: 10rem !important;
}

.d-20 {
  height: 11rem !important;
  width: 11rem !important;
}

/*Z-Index*/
.z-index-1 {
  z-index: 1 !important;
}

.z-index-2 {
  z-index: 2 !important;
}

.z-index-3 {
  z-index: 3 !important;
}

.z-index-4 {
  z-index: 4 !important;
}

.z-index-5 {
  z-index: 5 !important;
}

.z-index-6 {
  z-index: 6 !important;
}

.z-index-7 {
  z-index: 7 !important;
}

.z-index-8 {
  z-index: 8 !important;
}

.z-index-9 {
  z-index: 9 !important;
}

.z-index-10 {
  z-index: 10 !important;
}

/*Loader*/
.preloader-it {
  background: #fff;
  position: fixed;
  z-index: 10001;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.loader-pendulums {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  margin: 0 auto;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 4rem;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: 0.1em solid #d8d8d8;
}
.loader-pendulums:before, .loader-pendulums:after {
  content: '';
  width: 1em;
  height: 1em;
  left: -.1em;
  top: -.1em;
  padding: .1em;
  display: block;
  border-radius: 50%;
  position: absolute;
  transform-origin: center center;
  border: .1em solid;
  border-color: #9e9e9e transparent transparent transparent;
  animation: pendulum infinite 2s cubic-bezier(0.3, 1.65, 0.7, -0.65);
}
.loader-pendulums:before {
  border-color: #262a2e transparent transparent transparent;
  animation-delay: -1s;
  animation-name: pendulum2;
}
@keyframes pendulum {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
@keyframes pendulum2 {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(520deg);
  }
}
/*Scrollbar*/
.slimScrollBar {
  right: 0 !important;
}

.nicescroll-rails.nicescroll-rails-vr {
  z-index: 999 !important;
}

.simplebar-placeholder {
  width: auto !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-scroll-content::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

.simplebar-scrollbar:before {
  background: #d6d9da;
}
.simplebar-scrollbar.simplebar-visible:before {
  opacity: .8;
}

.simplebar-content:after,
.simplebar-content:before {
  clear: both;
}

.nicescroll-bar {
  height: 100%;
  width: 100%;
}

.ps__thumb-y,
.ps__thumb-x {
  border-radius: 0;
  background: #d6d9da;
}

.ps__thumb-x,
.ps__rail-x {
  height: 6px;
}

.ps__thumb-y,
.ps__rail-y {
  width: 6px;
}

.ps__rail-x,
.ps__rail-y {
  background: transparent;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
  border-radius: 0;
  height: 6px;
  background: #d6d9da;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  border-radius: 0;
  width: 6px;
  background: #d6d9da;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: transparent;
  opacity: 1;
}

.ps:hover >
.ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 1;
}

/*Separator*/
.separator {
  padding: 1px 0;
  margin: 1.25rem 0;
}
.separator:after {
  content: "";
  display: block;
  width: 100%;
  border-bottom: 1px solid #eaeaea;
}

.separator-full {
  padding: 1px 0;
  margin: 1.25rem 0;
}
.separator-full:after {
  content: "";
  display: block;
  position: absolute;
  height: 1px;
  width: 100%;
  left: 0;
  border-bottom: 1px solid #eaeaea;
}

.v-separator-full {
  margin: 0 1rem;
  display: flex;
}
.v-separator-full:after {
  content: "";
  position: absolute;
  top: 0;
  display: block;
  height: 100%;
  border-right: 1px solid #eaeaea;
}

.v-separator {
  margin: 0 1rem;
}
.v-separator:after {
  content: "";
  position: absolute;
  display: block;
  height: calc(100% - 30px);
  border-right: 1px solid #d8d8d8;
  top: 0;
  bottom: 0;
  margin: auto;
}

.separator-light:after {
  border-color: #f7f7f7;
}

/*Typography*/
p.p-xl {
  font-size: 1.25rem;
}
p.p-lg {
  font-size: 1.125rem;
}
p.p-sm {
  font-size: 0.875rem;
}
p.p-xs {
  font-size: 0.75rem;
}

.title,
.title-lg,
.title-sm,
.title-xs {
  display: flex;
  align-items: center;
  margin-bottom: .5rem;
}
.title .title-icon,
.title-lg .title-icon,
.title-sm .title-icon,
.title-xs .title-icon {
  margin-right: .5rem;
  display: inline-flex;
}
.title .title-icon i,
.title-lg .title-icon i,
.title-sm .title-icon i,
.title-xs .title-icon i {
  line-height: 0;
}
.title.title-wth-divider,
.title-lg.title-wth-divider,
.title-sm.title-wth-divider,
.title-xs.title-wth-divider {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.title.title-wth-divider > span,
.title-lg.title-wth-divider > span,
.title-sm.title-wth-divider > span,
.title-xs.title-wth-divider > span {
  display: flex;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.title.title-wth-divider::before,
.title-lg.title-wth-divider::before,
.title-sm.title-wth-divider::before,
.title-xs.title-wth-divider::before {
  content: "";
  display: block;
  height: 1px;
  width: 0;
  background: #d8d8d8;
}
.title.title-wth-divider::after,
.title-lg.title-wth-divider::after,
.title-sm.title-wth-divider::after,
.title-xs.title-wth-divider::after {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  margin-left: .625rem;
  background: #d8d8d8;
}
.title.title-wth-divider.divider-right::before,
.title-lg.title-wth-divider.divider-right::before,
.title-sm.title-wth-divider.divider-right::before,
.title-xs.title-wth-divider.divider-right::before {
  width: 100%;
  margin-right: .625rem;
}
.title.title-wth-divider.divider-right::after,
.title-lg.title-wth-divider.divider-right::after,
.title-sm.title-wth-divider.divider-right::after,
.title-xs.title-wth-divider.divider-right::after {
  width: 0;
  margin: 0;
}
.title.title-wth-divider.divider-center::before,
.title-lg.title-wth-divider.divider-center::before,
.title-sm.title-wth-divider.divider-center::before,
.title-xs.title-wth-divider.divider-center::before {
  width: 100%;
  margin-right: .625rem;
}
.title.title-wth-divider.divider-center::after,
.title-lg.title-wth-divider.divider-center::after,
.title-sm.title-wth-divider.divider-center::after,
.title-xs.title-wth-divider.divider-center::after {
  width: 100%;
  margin-left: .625rem;
}

.title {
  font-size: 1rem;
  color: #262a2e;
  font-weight: 500;
}
.title .title-icon {
  font-size: 1.5rem;
}

.title-lg {
  font-size: 1.125rem;
  color: #262a2e;
  font-weight: 500;
}
.title-lg .title-icon {
  font-size: 1.75rem;
}

.title-sm {
  font-size: 0.875rem;
  color: #262a2e;
  font-weight: 500;
}
.title-sm .title-icon {
  font-size: 1.25rem;
}

.title-xs {
  font-size: 0.75rem;
  color: #262a2e;
  font-weight: 500;
}
.title-xs .title-icon {
  font-size: 1rem;
}

.small, small {
  font-size: 80%;
  font-weight: 400;
}

.hidden-element {
  display: none !important;
}

code {
  margin: 0 .25rem;
  color: #0a2f4c;
}

.strikethrough s, .strikethrough del {
  position: relative;
  text-decoration: none;
}
.strikethrough s:after, .strikethrough del:after {
  content: "";
  height: 12px;
  background: #0a2f4c;
  mix-blend-mode: multiply;
  opacity: .3;
  width: 100%;
  position: absolute;
  margin-left: 0;
  top: 5px;
  left: 0;
  pointer-events: none;
}
.strikethrough del:after {
  background: #FF0000;
}

.mark, mark {
  padding: 0;
  background: none;
  color: #262a2e;
  position: relative;
}
.mark:after, mark:after {
  content: "";
  height: 12px;
  background: #FF9100;
  mix-blend-mode: multiply;
  opacity: .3;
  width: 100%;
  position: absolute;
  margin-left: 0;
  top: 5px;
  left: 0;
  pointer-events: none;
}

.display-1,
.display-2,
.display-3,
.display-4,
.display-5,
.display-6 {
  color: #262a2e;
}

.hk-dragger {
  font-size: 2rem;
  cursor: grab;
  color: #9e9e9e;
  margin-right: .625rem;
}

/*Buttons*/
.btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button {
  /* text-transform: capitalize; */
  outline: none;
  font-size: 1rem;
  padding: .375rem  1rem;
  border-width: 1px;
  border-radius: 0.375rem;
  /*Buttons with Icon*/
  /*HK Custom Buttons*/
  /*Buttons Icon*/
  /*Buttons Options*/

}
.btn:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:focus, .btn:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:active, .btn:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:hover {
  box-shadow: none;
}
.btn > span:not(.badge):not(.sr-only):not(span[class^="spinner"]), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 100%;
  width: 100%;
  position: relative;
}
.btn > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon {
  display: flex;
}
.btn > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child) {
  margin-right: .75rem;
}
.btn > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child) {
  margin-left: .75rem;
}
.btn.btn-lg > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child) {
  margin-right: 1.25rem;
}
.btn.btn-lg > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child) {
  margin-left: 1.25rem;
}
.btn.btn-sm > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child) {
  margin-right: 0.75rem;
}
.btn.btn-sm > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child) {
  margin-left: 0.75rem;
}
.btn.btn-xs > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child) {
  margin-right: 0.5rem;
}
.btn.btn-xs > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child) {
  margin-left: 0.5rem;
}
.btn.btn-custom, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button {
  position: relative;
}
.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^="spinner"]), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) {
  position: static;
}
.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon {
  background: rgba(0, 0, 0, 0.08) none repeat scroll 0 0;
  position: absolute;
  border-radius: 0.5rem;
  top: -1px;
  bottom: -1px;
  width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:last-child) {
  left: -1px;
  margin: 0;
}
.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon:not(:first-child) {
  right: -1px;
  left: auto;
}
.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child) {
  padding-right: 2.25rem;
}
.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child) {
  padding-left: 2.25rem;
}
.btn.btn-custom.btn-lg > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon {
  width: 46px;
  border-radius: 0.5rem;
}
.btn.btn-custom.btn-lg > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child) {
  padding-right: 2.625rem;
}
.btn.btn-custom.btn-lg > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child) {
  padding-left: 2.625rem;
}
.btn.btn-custom.btn-sm > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon {
  width: 33px;
  border-radius: .2rem;
}
.btn.btn-custom.btn-sm > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child) {
  padding-right: 2rem;
}
.btn.btn-custom.btn-sm > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child) {
  padding-left: 2rem;
}
.btn.btn-custom.btn-xs > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon {
  width: 26px;
  border-radius: .2rem;
}
.btn.btn-custom.btn-xs > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:last-child) {
  padding-right: 1.5rem;
}
.btn.btn-custom.btn-xs > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) > span:not(.icon):not(:first-child) {
  padding-left: 1.5rem;
}
.btn.btn-custom.btn-square > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-square.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^="spinner"]) .icon {
  border-radius: 0;
}
.btn.btn-icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.hopscotch-nav-button {
  height: 38px;
  width: 38px;
  padding: 0;
}
.btn.btn-icon[class*="btn-flush-"], div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button {
  position: relative;
  border: none;
  background: transparent !important;
}
.btn.btn-icon[class*="btn-flush-"]::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  height: 0;
  width: 0;
  background: #298DFF;
  border-radius: 0.5rem;
  transition: all 200ms;
}
.btn.btn-icon[class*="btn-flush-"]:not(:disabled):not(.disabled).active::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:not(:disabled):not(.disabled).active::before, .btn.btn-icon[class*="btn-flush-"]:not(:disabled):not(.disabled):active::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:not(:disabled):not(.disabled):active::before, .btn.btn-icon[class*="btn-flush-"]:hover::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:hover::before, .btn.btn-icon[class*="btn-flush-"]:focus::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:focus::before {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.btn.btn-icon[class*="btn-flush-"]:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"]:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"]:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"]:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].hopscotch-nav-button:focus .icon {
  color: #fff;
}
.btn.btn-icon[class*="btn-flush-"].btn-rounded::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-rounded.hopscotch-nav-button::before {
  border-radius: 50%;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-info:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.hopscotch-nav-button:before {
  background: #18DDEF;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:before {
  background: #edfcfe;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #18DDEF;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-info.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-info:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-info.hopscotch-nav-button:disabled {
  color: rgba(24, 221, 239, 0.8);
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-success:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.hopscotch-nav-button:before {
  background: #00D67F;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:before {
  background: #ebfcf5;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #00D67F;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-success.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-success:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-success.hopscotch-nav-button:disabled {
  color: rgba(0, 214, 127, 0.8);
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-warning:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.hopscotch-nav-button:before {
  background: #FFC400;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:before {
  background: #fffaeb;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #FFC400;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-warning.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-warning:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-warning.hopscotch-nav-button:disabled {
  color: rgba(255, 196, 0, 0.8);
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-danger:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.hopscotch-nav-button:before {
  background: #FF0000;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:before {
  background: #ffebeb;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #FF0000;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-danger.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-danger:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-danger.hopscotch-nav-button:disabled {
  color: rgba(255, 0, 0, 0.8);
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-secondary:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.hopscotch-nav-button:before {
  background: #6f6f6f;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:before {
  background: #f3f3f3;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #6f6f6f;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-secondary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-secondary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-secondary.hopscotch-nav-button:disabled {
  color: rgba(158, 158, 158, 0.8);
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-primary:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.hopscotch-nav-button:before {
  background: #0a2f4c;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:before {
  background: #ebf5f5;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #0a2f4c;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-primary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-primary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-primary.hopscotch-nav-button:disabled {
  color: rgba(41, 141, 255, 0.8);
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-dark:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.hopscotch-nav-button:before {
  background: #262a2e;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:before {
  background: #f7f7f7;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #262a2e;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-dark.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-dark:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.hopscotch-nav-button:disabled {
  color: rgba(38, 42, 46, 0.8);
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-light:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.hopscotch-nav-button:before {
  background: #6f6f6f;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:before {
  background: #f7f7f7;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #6f6f6f;
}
.btn.btn-icon[class*="btn-flush-"].btn-flush-light.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.disabled.hopscotch-nav-button, .btn.btn-icon[class*="btn-flush-"].btn-flush-light:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-light.hopscotch-nav-button:disabled {
  color: rgba(111, 111, 111, 0.8);
}
.btn.btn-icon.btn-lg, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-lg.hopscotch-nav-button {
  height: 45px;
  width: 45px;
}
.btn.btn-icon.btn-lg .btn-icon-wrap, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-lg.hopscotch-nav-button .btn-icon-wrap {
  font-size: 1.125rem;
}
.btn.btn-icon.btn-sm, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.hopscotch-nav-button {
  height: 31px;
  width: 31px;
}
.btn.btn-icon.btn-sm .btn-icon-wrap, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.hopscotch-nav-button .btn-icon-wrap {
  font-size: 0.875rem;
}
.btn.btn-icon.btn-xs, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-xs.hopscotch-nav-button {
  height: 28px;
  width: 28px;
  padding-left: 0;
  padding-right: 0;
}
.btn.btn-icon.btn-xs .btn-icon-wrap, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-xs.hopscotch-nav-button .btn-icon-wrap {
  font-size: 0.875rem;
}
.btn.btn-rounded, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-rounded.hopscotch-nav-button {
  border-radius: 50rem !important;
}
.btn.btn-rounded .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-rounded.hopscotch-nav-button .icon {
  border-radius: 50% !important;
}
.btn.btn-square, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-square.hopscotch-nav-button {
  border-radius: 0 !important;
}
.btn.btn-uppercase, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-uppercase.hopscotch-nav-button {
  text-transform: uppercase !important;
  font-weight: 600;
}
.btn.btn-floating, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-floating.hopscotch-nav-button {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14) !important;
  z-index: 1001;
}
.btn.btn-animated, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button {
  transition: all 0.15s ease;
}
.btn.btn-animated:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button:hover, .btn.btn-animated:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button:focus {
  transform: translateY(-3px);
}
.btn .custom-caret, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button .custom-caret {
  display: inline-block !important;
  margin-left: 5px;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=button].btn-block,
input[type=reset].btn-block,
input[type=submit].btn-block {
  width: 100%;
}

.btn-icon-dropdown {
  display: flex;
  align-items: center;
}

/*Button Colors*/
.btn-info {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-info:hover, .btn-info:focus {
  color: #fff;
  background-color: #16c7d7;
  border-color: #16c7d7;
}
.btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #16c7d7;
  border-color: #16c7d7;
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #a3f1f9;
  border-color: #a3f1f9;
}
.btn-info.btn-animated:focus, .btn-info.btn-animated:active, .btn-info.btn-animated:hover, .btn-info.btn-animated:not(:disabled):not(.disabled).active, .btn-info.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-green {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-green:hover, .btn-green:focus {
  color: #fff;
  background-color: #00c172;
  border-color: #00c172;
}
.btn-green:not(:disabled):not(.disabled).active, .btn-green:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #00c172;
  border-color: #00c172;
}
.btn-green.disabled, .btn-green:disabled {
  color: #fff;
  background-color: #99efcc;
  border-color: #99efcc;
}
.btn-green.btn-animated:focus, .btn-green.btn-animated:active, .btn-green.btn-animated:hover, .btn-green.btn-animated:not(:disabled):not(.disabled).active, .btn-green.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-success {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-success:hover, .btn-success:focus {
  color: #fff;
  background-color: #00c172;
  border-color: #00c172;
}
.btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #00c172;
  border-color: #00c172;
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #99efcc;
  border-color: #99efcc;
}
.btn-success.btn-animated:focus, .btn-success.btn-animated:active, .btn-success.btn-animated:hover, .btn-success.btn-animated:not(:disabled):not(.disabled).active, .btn-success.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-warning {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-warning:hover, .btn-warning:focus {
  color: #fff;
  background-color: #e6b000;
  border-color: #e6b000;
}
.btn-warning:not(:disabled):not(.disabled).active, .btn-warning:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #e6b000;
  border-color: #e6b000;
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #fff;
  background-color: #ffe799;
  border-color: #ffe799;
}
.btn-warning.btn-animated:focus, .btn-warning.btn-animated:active, .btn-warning.btn-animated:hover, .btn-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-warning.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-danger {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-danger:hover, .btn-danger:focus {
  color: #fff;
  background-color: #e60000;
  border-color: #e60000;
}
.btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #e60000;
  border-color: #e60000;
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #ff9999;
  border-color: #ff9999;
}
.btn-danger.btn-animated:focus, .btn-danger.btn-animated:active, .btn-danger.btn-animated:hover, .btn-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-danger.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-grey {
  color: #fff;
  background-color: #9e9e9e;
  border-color: #9e9e9e;
}
.btn-grey:hover, .btn-grey:focus {
  color: #fff;
  background-color: #8e8e8e;
  border-color: #8e8e8e;
}
.btn-grey:not(:disabled):not(.disabled).active, .btn-grey:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #8e8e8e;
  border-color: #8e8e8e;
}
.btn-grey.disabled, .btn-grey:disabled {
  color: #fff;
  background-color: #d8d8d8;
  border-color: #d8d8d8;
}
.btn-grey.btn-animated:focus, .btn-grey.btn-animated:active, .btn-grey.btn-animated:hover, .btn-grey.btn-animated:not(:disabled):not(.disabled).active, .btn-grey.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #9e9e9e;
  border-color: #9e9e9e;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-secondary {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-secondary:hover, .btn-secondary:focus {
  color: #fff;
  background-color: #646464;
  border-color: #646464;
}
.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #646464;
  border-color: #646464;
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #c5c5c5;
  border-color: #c5c5c5;
}
.btn-secondary.btn-animated:focus, .btn-secondary.btn-animated:active, .btn-secondary.btn-animated:hover, .btn-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-secondary.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-primary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next {
  color: #fff;
  background-color: #08364d;
  border-color: #08364d;
}
.btn-primary:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:hover, .btn-primary:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:focus {
  color: #fff;
  background-color: #0c4f71;
  border-color: #0c4f71;
}
.btn-primary:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #0c4f71;
  border-color: #0c4f71;
}
.btn-primary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.next, .btn-primary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:disabled {
  color: #fff;
  background-color: #99cbcf;
  border-color: #99cbcf;
}
.btn-primary.btn-animated:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:focus, .btn-primary.btn-animated:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:active, .btn-primary.btn-animated:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:hover, .btn-primary.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-primary.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #08364d;
  border-color: #08364d;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-dark {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-dark:hover, .btn-dark:focus {
  color: #fff;
  background-color: #212429;
  border-color: #212429;
}
.btn-dark:not(:disabled):not(.disabled).active, .btn-dark:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #212429;
  border-color: #212429;
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #9e9e9e;
  border-color: #9e9e9e;
}
.btn-dark.btn-animated:focus, .btn-dark.btn-animated:active, .btn-dark.btn-animated:hover, .btn-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-dark.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-default,
.btn-light {
  color: #262a2e;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.btn-default:hover, .btn-default:focus,
.btn-light:hover,
.btn-light:focus {
  color: #6f6f6f;
  background-color: #d8d8d8;
  border-color: #d8d8d8;
}
.btn-default:not(:disabled):not(.disabled).active, .btn-default:not(:disabled):not(.disabled):active,
.btn-light:not(:disabled):not(.disabled).active,
.btn-light:not(:disabled):not(.disabled):active {
  color: #262a2e;
  background-color: #d8d8d8;
  border-color: #d8d8d8;
}
.btn-default.disabled, .btn-default:disabled,
.btn-light.disabled,
.btn-light:disabled {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.btn-default.btn-animated:focus, .btn-default.btn-animated:active, .btn-default.btn-animated:hover, .btn-default.btn-animated:not(:disabled):not(.disabled).active, .btn-default.btn-animated:not(:disabled):not(.disabled):active,
.btn-light.btn-animated:focus,
.btn-light.btn-animated:active,
.btn-light.btn-animated:hover,
.btn-light.btn-animated:not(:disabled):not(.disabled).active,
.btn-light.btn-animated:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-white, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next {
  color: #262a2e;
  background-color: #fff;
  border-color: #fff;
}
.btn-white:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:hover, .btn-white:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:focus {
  color: #5f5f5f;
  background-color: #fff;
  border-color: #fff;
}
.btn-white:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-white:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled):active {
  color: #5f5f5f;
  background-color: #fff;
  border-color: #fff;
}
.btn-white.disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.next, .btn-white:disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:disabled {
  color: #5f5f5f;
  background-color: #fff;
  border-color: #fff;
}
.btn-white.btn-animated:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:focus, .btn-white.btn-animated:active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:active, .btn-white.btn-animated:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:hover, .btn-white.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-white.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active {
  color: #5f5f5f;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-link {
  color: #0a2f4c;
  text-decoration: none !important;
}
.btn-link:hover, .btn-link:focus {
  color: #0a2f4c;
}

.btn:not(:disabled):not(.disabled).active:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:not(:disabled):not(.disabled).active:focus,
.btn:not(:disabled):not(.disabled):active:focus,
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:not(:disabled):not(.disabled):active:focus,
.show > .btn.dropdown-toggle:focus,
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button:focus {
  box-shadow: none;
}

.btn-group-vertical > .btn:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button:hover,
.btn-group > .btn:hover,
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group > .hopscotch-nav-button:hover {
  z-index: 0;
}

.show > .btn-primary.dropdown-toggle, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button.next {
  color: #fff;
  background-color: #00717a;
  border-color: #00717a;
}
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #646464;
  border-color: #646464;
}
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #16c7d7;
  border-color: #16c7d7;
}
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #00c172;
  border-color: #00c172;
}
.show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #e6b000;
  border-color: #e6b000;
}
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #e60000;
  border-color: #e60000;
}
.show > .btn-light.dropdown-toggle {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #00717a;
  border-color: #00717a;
}
.show > .btn-outline-secondary.dropdown-toggle, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button.prev {
  color: #fff;
  background-color: #646464;
  border-color: #646464;
}
.show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #16c7d7;
  border-color: #16c7d7;
}
.show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #00c172;
  border-color: #00c172;
}
.show > .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e6b000;
  border-color: #e6b000;
}
.show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #e60000;
  border-color: #e60000;
}
.show > .btn-outline-light.dropdown-toggle, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .show > .dropdown-toggle.btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .show > .dropdown-toggle.hopscotch-nav-button.next {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #2a2f34;
  border-color: #2a2f34;
}

.dropdown > .btn-wth-icon {
  display: flex;
}

/*Buttons Soft*/
.btn-soft-info {
  color: #18DDEF;
  background-color: #edfcfe;
  border-color: #edfcfe;
}
.btn-soft-info:hover, .btn-soft-info:focus {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-soft-info:not(:disabled):not(.disabled).active, .btn-soft-info:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-soft-info.disabled, .btn-soft-info:disabled {
  color: #18DDEF;
  background-color: #a3f1f9;
  border-color: #a3f1f9;
}
.btn-soft-info.btn-animated:focus, .btn-soft-info.btn-animated:active, .btn-soft-info.btn-animated:hover, .btn-soft-info.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-info.btn-animated:not(:disabled):not(.disabled):active {
  color: #18DDEF;
  background-color: #edfcfe;
  border-color: #edfcfe;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-soft-success {
  color: #00D67F;
  background-color: #ebfcf5;
  border-color: #ebfcf5;
}
.btn-soft-success:hover, .btn-soft-success:focus {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-soft-success:not(:disabled):not(.disabled).active, .btn-soft-success:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-soft-success.disabled, .btn-soft-success:disabled {
  color: #00D67F;
  background-color: #99efcc;
  border-color: #99efcc;
}
.btn-soft-success.btn-animated:focus, .btn-soft-success.btn-animated:active, .btn-soft-success.btn-animated:hover, .btn-soft-success.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-success.btn-animated:not(:disabled):not(.disabled):active {
  color: #00D67F;
  background-color: #ebfcf5;
  border-color: #ebfcf5;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-soft-warning {
  color: #FFC400;
  background-color: #fffaeb;
  border-color: #fffaeb;
}
.btn-soft-warning:hover, .btn-soft-warning:focus {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-soft-warning:not(:disabled):not(.disabled).active, .btn-soft-warning:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-soft-warning.disabled, .btn-soft-warning:disabled {
  color: #FFC400;
  background-color: #ffe799;
  border-color: #ffe799;
}
.btn-soft-warning.btn-animated:focus, .btn-soft-warning.btn-animated:active, .btn-soft-warning.btn-animated:hover, .btn-soft-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-warning.btn-animated:not(:disabled):not(.disabled):active {
  color: #FFC400;
  background-color: #fffaeb;
  border-color: #fffaeb;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-soft-danger {
  color: #FF0000;
  background-color: #ffebeb;
  border-color: #ffebeb;
}
.btn-soft-danger:hover, .btn-soft-danger:focus {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-soft-danger:not(:disabled):not(.disabled).active, .btn-soft-danger:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-soft-danger.disabled, .btn-soft-danger:disabled {
  color: #FF0000;
  background-color: #ff9999;
  border-color: #ff9999;
}
.btn-soft-danger.btn-animated:focus, .btn-soft-danger.btn-animated:active, .btn-soft-danger.btn-animated:hover, .btn-soft-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-danger.btn-animated:not(:disabled):not(.disabled):active {
  color: #FF0000;
  background-color: #ffebeb;
  border-color: #ffebeb;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-soft-secondary {
  color: #262a2e;
  background-color: #f3f3f3;
  border-color: #f3f3f3;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-soft-secondary:not(:disabled):not(.disabled).active, .btn-soft-secondary:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-soft-secondary.disabled, .btn-soft-secondary:disabled {
  color: #6f6f6f;
  background-color: #c5c5c5;
  border-color: #c5c5c5;
}
.btn-soft-secondary.btn-animated:focus, .btn-soft-secondary.btn-animated:active, .btn-soft-secondary.btn-animated:hover, .btn-soft-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-secondary.btn-animated:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: #f3f3f3;
  border-color: #f3f3f3;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-soft-primary {
  color: #0a2f4c;
  background-color: #ebf5f5;
  border-color: #ebf5f5;
}
.btn-soft-primary:hover, .btn-soft-primary:focus {
  color: #fff;
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.btn-soft-primary:not(:disabled):not(.disabled).active, .btn-soft-primary:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.btn-soft-primary.disabled, .btn-soft-primary:disabled {
  color: #0a2f4c;
  background-color: #99cbcf;
  border-color: #99cbcf;
}
.btn-soft-primary.btn-animated:focus, .btn-soft-primary.btn-animated:active, .btn-soft-primary.btn-animated:hover, .btn-soft-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-primary.btn-animated:not(:disabled):not(.disabled):active {
  color: #0a2f4c;
  background-color: #ebf5f5;
  border-color: #ebf5f5;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-soft-light {
  color: #6f6f6f;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
}
.btn-soft-light:hover, .btn-soft-light:focus {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-soft-light:not(:disabled):not(.disabled).active, .btn-soft-light:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-soft-light.disabled, .btn-soft-light:disabled {
  color: #6f6f6f;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
}
.btn-soft-light.btn-animated:focus, .btn-soft-light.btn-animated:active, .btn-soft-light.btn-animated:hover, .btn-soft-light.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-light.btn-animated:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-soft-dark {
  color: #262a2e;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
}
.btn-soft-dark:hover, .btn-soft-dark:focus {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-soft-dark:not(:disabled):not(.disabled).active, .btn-soft-dark:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-soft-dark.disabled, .btn-soft-dark:disabled {
  color: #fff;
  background-color: #9e9e9e;
  border-color: #9e9e9e;
}
.btn-soft-dark.btn-animated:focus, .btn-soft-dark.btn-animated:active, .btn-soft-dark.btn-animated:hover, .btn-soft-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-dark.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

/*Buttons Flush*/
.btn-flush-info {
  color: #18DDEF;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-info:hover, .btn-flush-info:focus {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-flush-info:not(:disabled):not(.disabled).active, .btn-flush-info:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-flush-info.disabled, .btn-flush-info:disabled {
  color: #18DDEF;
  background-color: #a3f1f9;
  border-color: #a3f1f9;
}
.btn-flush-info.flush-outline-hover:hover, .btn-flush-info.flush-outline-hover:focus, .btn-flush-info.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-info.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #18DDEF;
  background-color: transparent;
  border-color: #18DDEF;
}
.btn-flush-info.flush-soft-hover:hover, .btn-flush-info.flush-soft-hover:focus, .btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #18DDEF;
  background-color: #edfcfe;
  border-color: #edfcfe;
}
.btn-flush-info.btn-animated:focus, .btn-flush-info.btn-animated:active, .btn-flush-info.btn-animated:hover, .btn-flush-info.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-info.btn-animated:not(:disabled):not(.disabled):active {
  color: #18DDEF;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-flush-success {
  color: #00D67F;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-success:hover, .btn-flush-success:focus {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-flush-success:not(:disabled):not(.disabled).active, .btn-flush-success:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-flush-success.disabled, .btn-flush-success:disabled {
  color: #00D67F;
  background-color: #99efcc;
  border-color: #99efcc;
}
.btn-flush-success.flush-outline-hover:hover, .btn-flush-success.flush-outline-hover:focus, .btn-flush-success.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-success.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #00D67F;
  background-color: transparent;
  border-color: #00D67F;
}
.btn-flush-success.flush-soft-hover:hover, .btn-flush-success.flush-soft-hover:focus, .btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #00D67F;
  background-color: #ebfcf5;
  border-color: #ebfcf5;
}
.btn-flush-success.btn-animated:focus, .btn-flush-success.btn-animated:active, .btn-flush-success.btn-animated:hover, .btn-flush-success.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-success.btn-animated:not(:disabled):not(.disabled):active {
  color: #00D67F;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-flush-warning {
  color: #FFC400;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-warning:hover, .btn-flush-warning:focus {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-flush-warning:not(:disabled):not(.disabled).active, .btn-flush-warning:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-flush-warning.disabled, .btn-flush-warning:disabled {
  color: #FFC400;
  background-color: #ffe799;
  border-color: #ffe799;
}
.btn-flush-warning.flush-outline-hover:hover, .btn-flush-warning.flush-outline-hover:focus, .btn-flush-warning.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-warning.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #FFC400;
  background-color: transparent;
  border-color: #FFC400;
}
.btn-flush-warning.flush-soft-hover:hover, .btn-flush-warning.flush-soft-hover:focus, .btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #FFC400;
  background-color: #fffaeb;
  border-color: #fffaeb;
}
.btn-flush-warning.btn-animated:focus, .btn-flush-warning.btn-animated:active, .btn-flush-warning.btn-animated:hover, .btn-flush-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-warning.btn-animated:not(:disabled):not(.disabled):active {
  color: #FFC400;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-flush-danger {
  color: #FF0000;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-danger:hover, .btn-flush-danger:focus {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-flush-danger:not(:disabled):not(.disabled).active, .btn-flush-danger:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-flush-danger.disabled, .btn-flush-danger:disabled {
  color: #FF0000;
  background-color: #ff9999;
  border-color: #ff9999;
}
.btn-flush-danger.flush-outline-hover:hover, .btn-flush-danger.flush-outline-hover:focus, .btn-flush-danger.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-danger.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #FF0000;
  background-color: transparent;
  border-color: #FF0000;
}
.btn-flush-danger.flush-soft-hover:hover, .btn-flush-danger.flush-soft-hover:focus, .btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #FF0000;
  background-color: #ffebeb;
  border-color: #ffebeb;
}
.btn-flush-danger.btn-animated:focus, .btn-flush-danger.btn-animated:active, .btn-flush-danger.btn-animated:hover, .btn-flush-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-danger.btn-animated:not(:disabled):not(.disabled):active {
  color: #FF0000;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-flush-secondary {
  color: #6f6f6f;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-secondary:hover, .btn-flush-secondary:focus {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-flush-secondary:not(:disabled):not(.disabled).active, .btn-flush-secondary:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-flush-secondary.disabled, .btn-flush-secondary:disabled {
  color: #6f6f6f;
  background-color: #c5c5c5;
  border-color: #c5c5c5;
}
.btn-flush-secondary.flush-outline-hover:hover, .btn-flush-secondary.flush-outline-hover:focus, .btn-flush-secondary.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-secondary.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: transparent;
  border-color: #6f6f6f;
}
.btn-flush-secondary.flush-soft-hover:hover, .btn-flush-secondary.flush-soft-hover:focus, .btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: #f3f3f3;
  border-color: #f3f3f3;
}
.btn-flush-secondary.btn-animated:focus, .btn-flush-secondary.btn-animated:active, .btn-flush-secondary.btn-animated:hover, .btn-flush-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-secondary.btn-animated:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-flush-primary {
  color: #0a2f4c;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-primary:hover, .btn-flush-primary:focus {
  color: #fff;
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.btn-flush-primary:not(:disabled):not(.disabled).active, .btn-flush-primary:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.btn-flush-primary.disabled, .btn-flush-primary:disabled {
  color: #0a2f4c;
  background-color: #99cbcf;
  border-color: #99cbcf;
}
.btn-flush-primary.flush-outline-hover:hover, .btn-flush-primary.flush-outline-hover:focus, .btn-flush-primary.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-primary.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #0a2f4c;
  background-color: transparent;
  border-color: #0a2f4c;
}
.btn-flush-primary.flush-soft-hover:hover, .btn-flush-primary.flush-soft-hover:focus, .btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #0a2f4c;
  background-color: #ebf5f5;
  border-color: #ebf5f5;
}
.btn-flush-primary.btn-animated:focus, .btn-flush-primary.btn-animated:active, .btn-flush-primary.btn-animated:hover, .btn-flush-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-primary.btn-animated:not(:disabled):not(.disabled):active {
  color: #0a2f4c;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-flush-dark {
  color: #262a2e;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-dark:hover, .btn-flush-dark:focus {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-flush-dark:not(:disabled):not(.disabled).active, .btn-flush-dark:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-flush-dark.disabled, .btn-flush-dark:disabled {
  color: #fff;
  background-color: #9e9e9e;
  border-color: #9e9e9e;
}
.btn-flush-dark.flush-outline-hover:hover, .btn-flush-dark.flush-outline-hover:focus, .btn-flush-dark.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-dark.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #262a2e;
  background-color: transparent;
  border-color: #262a2e;
}
.btn-flush-dark.flush-soft-hover:hover, .btn-flush-dark.flush-soft-hover:focus, .btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #262a2e;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
}
.btn-flush-dark.btn-animated:focus, .btn-flush-dark.btn-animated:active, .btn-flush-dark.btn-animated:hover, .btn-flush-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-dark.btn-animated:not(:disabled):not(.disabled):active {
  color: #262a2e;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-flush-light {
  color: #6f6f6f;
  background-color: transparent;
  border-color: transparent;
}
.btn-flush-light:hover, .btn-flush-light:focus {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-flush-light:not(:disabled):not(.disabled).active, .btn-flush-light:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-flush-light.disabled, .btn-flush-light:disabled {
  color: #6f6f6f;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
}
.btn-flush-light.flush-outline-hover:hover, .btn-flush-light.flush-outline-hover:focus, .btn-flush-light.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-light.flush-outline-hover:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: transparent;
  background-image: none;
  border-color: #eaeaea;
}
.btn-flush-light.flush-soft-hover:hover, .btn-flush-light.flush-soft-hover:focus, .btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: #f7f7f7;
  border-color: #f7f7f7;
}
.btn-flush-light.btn-animated:focus, .btn-flush-light.btn-animated:active, .btn-flush-light.btn-animated:hover, .btn-flush-light.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-light.btn-animated:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

/*Buttons Gradien*/
.btn-gradient-primary {
  color: #fff;
  border: none;
  background: #0a2f4c;
  background: linear-gradient(45deg, #0a2f4c, #955cfa) !important;
}
.btn-gradient-primary:hover, .btn-gradient-primary:focus {
  color: #fff;
  background: #00717a;
  background: linear-gradient(45deg, #00717a, #7429F8) !important;
}
.btn-gradient-primary:not(:disabled):not(.disabled).active, .btn-gradient-primary:not(:disabled):not(.disabled):active {
  color: #fff;
  background: #00717a;
  background: linear-gradient(45deg, #00717a, #7429F8) !important;
}
.btn-gradient-primary.disabled, .btn-gradient-primary:disabled {
  color: #fff;
  background: #99cbcf;
  background: linear-gradient(45deg, #99cbcf, #c7a9fc) !important;
}
.btn-gradient-primary.btn-animated:focus, .btn-gradient-primary.btn-animated:active, .btn-gradient-primary.btn-animated:hover, .btn-gradient-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-primary.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  border: none;
  background: #0a2f4c;
  background: linear-gradient(45deg, #0a2f4c, #955cfa) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-gradient-info {
  color: #fff;
  border: none;
  background: #18DDEF;
  background: linear-gradient(45deg, #18DDEF, #0a2f4c) !important;
}
.btn-gradient-info:hover, .btn-gradient-info:focus {
  color: #fff;
  background: #16c7d7;
  background: linear-gradient(45deg, #16c7d7, #00717a) !important;
}
.btn-gradient-info:not(:disabled):not(.disabled).active, .btn-gradient-info:not(:disabled):not(.disabled):active {
  color: #fff;
  background: #16c7d7;
  background: linear-gradient(45deg, #16c7d7, #00717a) !important;
}
.btn-gradient-info.disabled, .btn-gradient-info:disabled {
  color: #fff;
  background: #a3f1f9;
  background: linear-gradient(45deg, #a3f1f9, #99cbcf) !important;
}
.btn-gradient-info.btn-animated:focus, .btn-gradient-info.btn-animated:active, .btn-gradient-info.btn-animated:hover, .btn-gradient-info.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-info.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  border: none;
  background: #18DDEF;
  background: linear-gradient(45deg, #18DDEF, #0a2f4c) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-gradient-success {
  color: #fff;
  border: none;
  background: #00D67F;
  background: linear-gradient(45deg, #00D67F, #81E230) !important;
}
.btn-gradient-success:hover, .btn-gradient-success:focus {
  color: #fff;
  background: #00c172;
  background: linear-gradient(45deg, #00c172, #74cb2b) !important;
}
.btn-gradient-success:not(:disabled):not(.disabled).active, .btn-gradient-success:not(:disabled):not(.disabled):active {
  color: #fff;
  background: #00c172;
  background: linear-gradient(45deg, #00c172, #74cb2b) !important;
}
.btn-gradient-success.disabled, .btn-gradient-success:disabled {
  color: #fff;
  background: #99efcc;
  background: linear-gradient(45deg, #99efcc, #cdf3ac) !important;
}
.btn-gradient-success.btn-animated:focus, .btn-gradient-success.btn-animated:active, .btn-gradient-success.btn-animated:hover, .btn-gradient-success.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-success.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  border: none;
  background: #00D67F;
  background: linear-gradient(45deg, #00D67F, #81E230) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-gradient-warning {
  color: #fff;
  border: none;
  background: #FFC400;
  background: linear-gradient(45deg, #FFC400, #FFEA00) !important;
}
.btn-gradient-warning:hover, .btn-gradient-warning:focus {
  color: #fff;
  background: #e6b000;
  background: linear-gradient(45deg, #e6b000, #e6d300) !important;
}
.btn-gradient-warning:not(:disabled):not(.disabled).active, .btn-gradient-warning:not(:disabled):not(.disabled):active {
  color: #fff;
  background: #e6b000;
  background: linear-gradient(45deg, #e6b000, #e6d300) !important;
}
.btn-gradient-warning.disabled, .btn-gradient-warning:disabled {
  color: #fff;
  background: #ffe799;
  background: linear-gradient(45deg, #ffe799, #fff799) !important;
}
.btn-gradient-warning.btn-animated:focus, .btn-gradient-warning.btn-animated:active, .btn-gradient-warning.btn-animated:hover, .btn-gradient-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-warning.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  border: none;
  background: #FFC400;
  background: linear-gradient(45deg, #FFC400, #FFEA00) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-gradient-danger {
  color: #fff;
  border: none;
  background: #ff3d3d;
  background: linear-gradient(45deg, #ff3d3d, #E92990) !important;
}
.btn-gradient-danger:hover, .btn-gradient-danger:focus {
  color: #fff;
  background: #FF0000;
  background: linear-gradient(45deg, #FF0000, #d22582) !important;
}
.btn-gradient-danger:not(:disabled):not(.disabled).active, .btn-gradient-danger:not(:disabled):not(.disabled):active {
  color: #fff;
  background: #FF0000;
  background: linear-gradient(45deg, #FF0000, #d22582) !important;
}
.btn-gradient-danger.disabled, .btn-gradient-danger:disabled {
  color: #fff;
  background: #ff9999;
  background: linear-gradient(45deg, #ff9999, #f6a9d3) !important;
}
.btn-gradient-danger.btn-animated:focus, .btn-gradient-danger.btn-animated:active, .btn-gradient-danger.btn-animated:hover, .btn-gradient-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-danger.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  border: none;
  background: #ff3d3d;
  background: linear-gradient(45deg, #ff3d3d, #E92990) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-gradient-secondary {
  color: #fff;
  border: none;
  background: #6f6f6f;
  background: linear-gradient(45deg, #6f6f6f, #d8d8d8) !important;
}
.btn-gradient-secondary:hover, .btn-gradient-secondary:focus {
  color: #fff;
  background: #646464;
  background: linear-gradient(45deg, #646464, #c7c7c7) !important;
}
.btn-gradient-secondary:not(:disabled):not(.disabled).active, .btn-gradient-secondary:not(:disabled):not(.disabled):active {
  color: #fff;
  background: #646464;
  background: linear-gradient(45deg, #646464, #c7c7c7) !important;
}
.btn-gradient-secondary.disabled, .btn-gradient-secondary:disabled {
  color: #fff;
  background: #c5c5c5;
  background: linear-gradient(45deg, #c5c5c5, #d8d8d8) !important;
}
.btn-gradient-secondary.btn-animated:focus, .btn-gradient-secondary.btn-animated:active, .btn-gradient-secondary.btn-animated:hover, .btn-gradient-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-secondary.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  border: none;
  background: #6f6f6f;
  background: linear-gradient(45deg, #6f6f6f, #d8d8d8) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-gradient-light {
  color: #262a2e;
  border: none;
  background: #b5b5b5;
  background: linear-gradient(45deg, #b5b5b5, #f7f7f7) !important;
}
.btn-gradient-light:hover, .btn-gradient-light:focus {
  color: #262a2e;
  background: #d8d8d8;
  background: linear-gradient(45deg, #d8d8d8, #eaeaea) !important;
}
.btn-gradient-light:not(:disabled):not(.disabled).active, .btn-gradient-light:not(:disabled):not(.disabled):active {
  color: #262a2e;
  background: #d8d8d8;
  background: linear-gradient(45deg, #d8d8d8, #eaeaea) !important;
}
.btn-gradient-light.disabled, .btn-gradient-light:disabled {
  color: #262a2e;
  background: #f7f7f7;
  background: linear-gradient(45deg, #f7f7f7, #d8d8d8) !important;
}
.btn-gradient-light.btn-animated:focus, .btn-gradient-light.btn-animated:active, .btn-gradient-light.btn-animated:hover, .btn-gradient-light.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-light.btn-animated:not(:disabled):not(.disabled):active {
  color: #262a2e;
  border: none;
  background: #b5b5b5;
  background: linear-gradient(45deg, #b5b5b5, #f7f7f7) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-gradient-dark {
  color: #fff;
  border: none;
  background: #262a2e;
  background: linear-gradient(45deg, #262a2e, #6f6f6f) !important;
}
.btn-gradient-dark:hover, .btn-gradient-dark:focus {
  color: #fff;
  background: #212429;
  background: linear-gradient(45deg, #212429, #4f4f4f) !important;
}
.btn-gradient-dark:not(:disabled):not(.disabled).active, .btn-gradient-dark:not(:disabled):not(.disabled):active {
  color: #fff;
  background: #212429;
  background: linear-gradient(45deg, #212429, #4f4f4f) !important;
}
.btn-gradient-dark.disabled, .btn-gradient-dark:disabled {
  color: #fff;
  background: #2F343A;
  background: linear-gradient(45deg, #2F343A, #d8d8d8) !important;
}
.btn-gradient-dark.btn-animated:focus, .btn-gradient-dark.btn-animated:active, .btn-gradient-dark.btn-animated:hover, .btn-gradient-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-dark.btn-animated:not(:disabled):not(.disabled):active {
  color: #fff;
  border: none;
  background: #262a2e;
  background: linear-gradient(45deg, #262a2e, #6f6f6f) !important;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

/*Buttons Outline*/
.btn-outline-info {
  color: #18DDEF;
  background-color: transparent;
  background-image: none;
  border-color: #18DDEF;
}
.btn-outline-info:hover, .btn-outline-info:focus {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-outline-info:not(:disabled):not(.disabled).active, .btn-outline-info:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #fff;
  background-color: #a3f1f9;
  border-color: #a3f1f9;
}
.btn-outline-info.btn-animated:focus, .btn-outline-info.btn-animated:active, .btn-outline-info.btn-animated:hover, .btn-outline-info.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-info.btn-animated:not(:disabled):not(.disabled):active {
  color: #18DDEF;
  background-color: transparent;
  background-image: none;
  border-color: #18DDEF;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-success {
  color: #00D67F;
  background-color: transparent;
  background-image: none;
  border-color: #00D67F;
}
.btn-outline-success:hover, .btn-outline-success:focus {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-outline-success:not(:disabled):not(.disabled).active, .btn-outline-success:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #fff;
  background-color: #99efcc;
  border-color: #99efcc;
}
.btn-outline-success.btn-animated:focus, .btn-outline-success.btn-animated:active, .btn-outline-success.btn-animated:hover, .btn-outline-success.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-success.btn-animated:not(:disabled):not(.disabled):active {
  color: #00D67F;
  background-color: transparent;
  background-image: none;
  border-color: #00D67F;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-warning {
  color: #FFC400;
  background-color: transparent;
  background-image: none;
  border-color: #FFC400;
}
.btn-outline-warning:hover, .btn-outline-warning:focus {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-outline-warning:not(:disabled):not(.disabled).active, .btn-outline-warning:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #fff;
  background-color: #ffe799;
  border-color: #ffe799;
}
.btn-outline-warning.btn-animated:focus, .btn-outline-warning.btn-animated:active, .btn-outline-warning.btn-animated:hover, .btn-outline-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-warning.btn-animated:not(:disabled):not(.disabled):active {
  color: #FFC400;
  background-color: transparent;
  background-image: none;
  border-color: #FFC400;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-danger {
  color: #FF0000;
  background-color: transparent;
  background-image: none;
  border-color: #FF0000;
}
.btn-outline-danger:hover, .btn-outline-danger:focus {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #fff;
  background-color: #ff9999;
  border-color: #ff9999;
}
.btn-outline-danger.btn-animated:focus, .btn-outline-danger.btn-animated:active, .btn-outline-danger.btn-animated:hover, .btn-outline-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-danger.btn-animated:not(:disabled):not(.disabled):active {
  color: #FF0000;
  background-color: transparent;
  background-image: none;
  border-color: #FF0000;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-secondary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {
  color: #6f6f6f;
  background-color: transparent;
  background-image: none;
  border-color: #6f6f6f;
}
.btn-outline-secondary:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:hover, .btn-outline-secondary:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:focus {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-outline-secondary:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-secondary:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-outline-secondary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.prev, .btn-outline-secondary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:disabled {
  color: #fff;
  background-color: #c5c5c5;
  border-color: #c5c5c5;
}
.btn-outline-secondary.btn-animated:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:focus, .btn-outline-secondary.btn-animated:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:active, .btn-outline-secondary.btn-animated:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:hover, .btn-outline-secondary.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-secondary.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: transparent;
  background-image: none;
  border-color: #6f6f6f;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-primary {
  color: #08364d;
  background-color: transparent;
  background-image: none;
  border-color: #08364d;
}
.btn-outline-primary:hover, .btn-outline-primary:focus {
  color: #fff;
  background-color: #08364d;
  border-color: #08364d;
}
.btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #08364d;
  border-color: #08364d;
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #fff;
  background-color: #99cbcf;
  border-color: #99cbcf;
}
.btn-outline-primary.btn-animated:focus, .btn-outline-primary.btn-animated:active, .btn-outline-primary.btn-animated:hover, .btn-outline-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-primary.btn-animated:not(:disabled):not(.disabled):active {
  color: #08364d;
  background-color: transparent;
  background-image: none;
  border-color: #0a2f4c;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-dark {
  color: #262a2e;
  background-color: transparent;
  background-image: none;
  border-color: #262a2e;
}
.btn-outline-dark:hover, .btn-outline-dark:focus {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-outline-dark:not(:disabled):not(.disabled).active, .btn-outline-dark:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #fff;
  background-color: #9e9e9e;
  border-color: #9e9e9e;
}
.btn-outline-dark.btn-animated:focus, .btn-outline-dark.btn-animated:active, .btn-outline-dark.btn-animated:hover, .btn-outline-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-dark.btn-animated:not(:disabled):not(.disabled):active {
  color: #262a2e;
  background-color: transparent;
  background-image: none;
  border-color: #262a2e;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-light, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next {
  color: #6f6f6f;
  background-color: transparent;
  background-image: none;
  border-color: #eaeaea;
}
.btn-outline-light:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:hover, .btn-outline-light:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:focus {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.btn-outline-light:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-outline-light:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.btn-outline-light.disabled, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .disabled.btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .disabled.hopscotch-nav-button.next, .btn-outline-light:disabled, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:disabled, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:disabled {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.btn-outline-light.btn-animated:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:focus, .btn-outline-light.btn-animated:active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:active, .btn-outline-light.btn-animated:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:hover, .btn-outline-light.btn-animated:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-outline-light.btn-animated:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active {
  color: #6f6f6f;
  background-color: transparent;
  background-image: none;
  border-color: #eaeaea;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-outline-white, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}
.btn-outline-white:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:hover, .btn-outline-white:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:focus {
  color: #fff;
  background-color: transparent;
  border-color: #fff;
}
.btn-outline-white:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-white:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: transparent;
  border-color: #fff;
}
.btn-outline-white.disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.prev, .btn-outline-white:disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:disabled {
  color: #fff;
  background-color: transparent;
  border-color: #fff;
}
.btn-outline-white.btn-animated:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:focus, .btn-outline-white.btn-animated:active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:active, .btn-outline-white.btn-animated:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:hover, .btn-outline-white.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-white.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

/*Buttons Check*/
.btn-check:active + .btn-info, .btn-check:checked + .btn-info {
  color: #fff;
  background-color: #16c7d7;
  border-color: #16c7d7;
}
.btn-check:active + .btn-success, .btn-check:checked + .btn-success {
  color: #fff;
  background-color: #00c172;
  border-color: #00c172;
}
.btn-check:active + .btn-warning, .btn-check:checked + .btn-warning {
  color: #fff;
  background-color: #e6b000;
  border-color: #e6b000;
}
.btn-check:active + .btn-danger, .btn-check:checked + .btn-danger {
  color: #fff;
  background-color: #e60000;
  border-color: #e60000;
}
.btn-check:active + .btn-secondary, .btn-check:checked + .btn-secondary {
  color: #fff;
  background-color: #646464;
  border-color: #646464;
}
.btn-check:active + .btn-primary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:active + .hopscotch-nav-button.next, .btn-check:checked + .btn-primary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:checked + .hopscotch-nav-button.next {
  color: #fff;
  background-color: #00717a;
  border-color: #00717a;
}
.btn-check:active + .btn-dark, .btn-check:checked + .btn-dark {
  color: #fff;
  background-color: #212429;
  border-color: #212429;
}
.btn-check:active + .btn-light, .btn-check:checked + .btn-light {
  color: #262a2e;
  background-color: #d8d8d8;
  border-color: #d8d8d8;
}
.btn-check:active + .btn-outline-info, .btn-check:checked + .btn-outline-info {
  color: #fff;
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.btn-check:active + .btn-outline-success, .btn-check:checked + .btn-outline-success {
  color: #fff;
  background-color: #00D67F;
  border-color: #00D67F;
}
.btn-check:active + .btn-outline-warning, .btn-check:checked + .btn-outline-warning {
  color: #fff;
  background-color: #FFC400;
  border-color: #FFC400;
}
.btn-check:active + .btn-outline-danger, .btn-check:checked + .btn-outline-danger {
  color: #fff;
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-check:active + .btn-outline-secondary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:active + .hopscotch-nav-button.prev, .btn-check:checked + .btn-outline-secondary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:checked + .hopscotch-nav-button.prev {
  color: #fff;
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-check:active + .btn-outline-primary, .btn-check:checked + .btn-outline-primary {
  color: #fff;
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.btn-check:active + .btn-outline-dark, .btn-check:checked + .btn-outline-dark {
  color: #fff;
  background-color: #262a2e;
  border-color: #262a2e;
}
.btn-check:active + .btn-outline-light, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:active + .btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:active + .hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:active + .hopscotch-nav-button.next, .btn-check:checked + .btn-outline-light, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:checked + .btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:checked + .hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:checked + .hopscotch-nav-button.next {
  color: #6f6f6f;
  background-color: #eaeaea;
  border-color: #eaeaea;
}

/*Buttons Group*/
.btn-group .btn + .btn, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .hopscotch-nav-button + .btn, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .btn + .hopscotch-nav-button, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .hopscotch-nav-button + .hopscotch-nav-button, .btn-group .btn + .btn-group, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .btn-group, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .hopscotch-nav-button + .btn-group, .btn-group .btn-group + .btn, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .btn-group + .hopscotch-nav-button, .btn-group .btn-group + .btn-group {
  margin-left: -1px;
}

.btn-group-vertical > .btn + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .btn + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button + .hopscotch-nav-button, .btn-group-vertical > .btn + .btn-group, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button + .btn-group, .btn-group-vertical > .btn-group + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .btn-group + .hopscotch-nav-button, .btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}

.btn-group-lg > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-lg > .hopscotch-nav-button,
.btn-lg {
  font-size: 1.125rem;
  padding: 0.5rem 1.3rem;
  border-radius: 0.375rem;
}

.btn-group-sm > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-sm > .hopscotch-nav-button,
.btn-sm,
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button {
  font-size: 0.875rem;
  padding: .25rem .8rem;
  border-radius: 0.375rem;
}

.btn-group-xs > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-xs > .hopscotch-nav-button,
.btn-xs {
  font-size: .75rem;
  padding: .25rem .6rem;
}

/*Button Social*/
.btn-social {
  color: #fff;
  transition: all 0.15s ease;
}
.btn-social:focus, .btn-social:active, .btn-social:hover {
  color: #fff;
  transform: translateY(-3px);
}
.btn-social.btn-social-facebook {
  background-color: #1778F2;
  border-color: #1778F2;
}
.btn-social.btn-social-facebook:focus, .btn-social.btn-social-facebook:active, .btn-social.btn-social-facebook:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(23, 120, 242, 0.6) !important;
}
.btn-social.btn-social-twitter {
  background-color: #00acee;
  border-color: #00acee;
}
.btn-social.btn-social-twitter:focus, .btn-social.btn-social-twitter:active, .btn-social.btn-social-twitter:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 172, 238, 0.6) !important;
}
.btn-social.btn-social-gplus {
  background-color: #db4a39;
  border-color: #db4a39;
}
.btn-social.btn-social-gplus:focus, .btn-social.btn-social-gplus:active, .btn-social.btn-social-gplus:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(219, 74, 57, 0.6) !important;
}
.btn-social.btn-social-linkedin {
  background-color: #0077B5;
  border-color: #0077B5;
}
.btn-social.btn-social-linkedin:focus, .btn-social.btn-social-linkedin:active, .btn-social.btn-social-linkedin:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 119, 181, 0.6) !important;
}
.btn-social.btn-social-instagram {
  border-color: transparent;
  background: #f0100f;
  background: linear-gradient(45deg, #f0100f, #b900b3) !important;
}
.btn-social.btn-social-instagram:focus, .btn-social.btn-social-instagram:active, .btn-social.btn-social-instagram:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(240, 16, 15, 0.6) !important;
  background: #f0100f;
  background: linear-gradient(45deg, #f0100f, #b900b3) !important;
}
.btn-social.btn-social-pinterest {
  background-color: #E60023;
  border-color: #E60023;
}
.btn-social.btn-social-pinterest:focus, .btn-social.btn-social-pinterest:active, .btn-social.btn-social-pinterest:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(230, 0, 35, 0.6) !important;
}
.btn-social.btn-social-dribbble {
  background-color: #ea4c89;
  border-color: #ea4c89;
}
.btn-social.btn-social-dribbble:focus, .btn-social.btn-social-dribbble:active, .btn-social.btn-social-dribbble:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(234, 76, 137, 0.6) !important;
}
.btn-social.btn-social-youtube {
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-social.btn-social-youtube:focus, .btn-social.btn-social-youtube:active, .btn-social.btn-social-youtube:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(255, 0, 0, 0.6) !important;
}
.btn-social.btn-social-dropbox {
  background-color: #0061ff;
  border-color: #0061ff;
}
.btn-social.btn-social-dropbox:focus, .btn-social.btn-social-dropbox:active, .btn-social.btn-social-dropbox:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 97, 255, 0.6) !important;
}
.btn-social.btn-social-github {
  background-color: #24292e;
  border-color: #24292e;
}
.btn-social.btn-social-github:focus, .btn-social.btn-social-github:active, .btn-social.btn-social-github:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(36, 41, 46, 0.6) !important;
}
.btn-social.btn-social-skype {
  background-color: #00aff0;
  border-color: #00aff0;
}
.btn-social.btn-social-skype:focus, .btn-social.btn-social-skype:active, .btn-social.btn-social-skype:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 175, 240, 0.6) !important;
}
.btn-social.btn-social-tumblr {
  background-color: #000000;
  border-color: #000000;
}
.btn-social.btn-social-tumblr:focus, .btn-social.btn-social-tumblr:active, .btn-social.btn-social-tumblr:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 0, 0, 0.6) !important;
}
.btn-social.btn-social-flickr {
  background-color: #0063dc;
  border-color: #0063dc;
}
.btn-social.btn-social-flickr:focus, .btn-social.btn-social-flickr:active, .btn-social.btn-social-flickr:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 99, 220, 0.6) !important;
}
.btn-social.btn-social-behance {
  background-color: #1769ff;
  border-color: #1769ff;
}
.btn-social.btn-social-behance:focus, .btn-social.btn-social-behance:active, .btn-social.btn-social-behance:hover {
  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(23, 105, 255, 0.6) !important;
}

/*Wrapper*/
.hk-wrapper {
  position: relative;
}

.hk-pg-wrapper {
  padding: 65px 0 60px;
  position: relative;
  min-height: 100vh;
}

/*Gutter*/
.g-5, .gx-5 {
  --bs-gutter-x: 2rem;
}

.g-5, .gy-5 {
  --bs-gutter-y: 2rem;
}

.g-6, .gx-6 {
  --bs-gutter-x: 2.5rem;
}

.g-6, .gy-6 {
  --bs-gutter-y: 2.5rem;
}

.g-7, .gx-7 {
  --bs-gutter-x: 3rem;
}

.g-7, .gy-7 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .g-sm-5, .gx-sm-5 {
    --bs-gutter-x: 2rem;
  }

  .g-sm-5, .gy-sm-5 {
    --bs-gutter-y: 2rem;
  }

  .g-sm-6, .gx-sm-6 {
    --bs-gutter-x: 2.5rem;
  }

  .g-sm-6, .gy-sm-6 {
    --bs-gutter-y: 2.5rem;
  }

  .g-sm-7, .gx-sm-7 {
    --bs-gutter-x: 3rem;
  }

  .g-sm-7, .gy-sm-7 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .g-md-5, .gx-md-5 {
    --bs-gutter-x: 2rem;
  }

  .g-md-5, .gy-md-5 {
    --bs-gutter-y: 2rem;
  }

  .g-md-6, .gx-md-6 {
    --bs-gutter-x: 2.5rem;
  }

  .g-md-6, .gy-md-6 {
    --bs-gutter-y: 2.5rem;
  }

  .g-md-7, .gx-md-7 {
    --bs-gutter-x: 3rem;
  }

  .g-md-7, .gy-md-7 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .g-lg-5, .gx-lg-5 {
    --bs-gutter-x: 2rem;
  }

  .g-lg-5, .gy-lg-5 {
    --bs-gutter-y: 2rem;
  }

  .g-lg-6, .gx-lg-6 {
    --bs-gutter-x: 2.5rem;
  }

  .g-lg-6, .gy-lg-6 {
    --bs-gutter-y: 2.5rem;
  }

  .g-lg-7, .gx-lg-7 {
    --bs-gutter-x: 3rem;
  }

  .g-lg-7, .gy-lg-7 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .g-xl-5, .gx-xl-5 {
    --bs-gutter-x: 2rem;
  }

  .g-xl-5, .gy-xl-5 {
    --bs-gutter-y: 2rem;
  }

  .g-xl-6, .gx-xl-6 {
    --bs-gutter-x: 2.5rem;
  }

  .g-xl-6, .gy-xl-6 {
    --bs-gutter-y: 2.5rem;
  }

  .g-xl-7, .gx-xl-7 {
    --bs-gutter-x: 3rem;
  }

  .g-xl-7, .gy-xl-7 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .g-xxl-5, .gx-xxl-5 {
    --bs-gutter-x: 2rem;
  }

  .g-xxl-5, .gy-xxl-5 {
    --bs-gutter-y: 2rem;
  }

  .g-xxl-6, .gx-xxl-6 {
    --bs-gutter-x: 2.5rem;
  }

  .g-xxl-6, .gy-xxl-6 {
    --bs-gutter-y: 2.5rem;
  }

  .g-xxl-7, .gx-xxl-7 {
    --bs-gutter-x: 3rem;
  }

  .g-xxl-7, .gy-xxl-7 {
    --bs-gutter-y: 3rem;
  }
}
/*Hk Section*/
.hk-section {
  margin-bottom: 3.125rem;
}
.hk-section .hk-sec-title {
  margin-bottom: 1.25rem;
}

/*Card*/
.card {
  border-color: #eaeaea;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: .875rem;
  border-radius: 0.5rem;
}
.card .card-header {
  background: transparent;
  border-color: #eaeaea;
  padding: 0.75rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.card .card-header > h1, .card .card-header > h2, .card .card-header > h3, .card .card-header > h4, .card .card-header > h5, .card .card-header > h6, .card .card-header > .h1, .card .card-header > .h2, .card .card-header > .h3, .card .card-header > .h4, .card .card-header > .h5, .card .card-header > .h6 {
  margin-bottom: 0;
}
.card .card-header.card-header-bold {
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: 600;
}
.card .card-header.card-header-wth-bg {
  background: #f7f7f7;
  border-color: transparent;
}
.card .card-header.card-header-wth-bg.card-header-action .card-action-wrap {
  color: #fff;
}
.card .card-header.card-header-action .card-action-wrap {
  display: flex;
  align-items: center;
}
.card .card-header.card-header-action .card-action-wrap > a.collapsed {
  transform: rotate(180deg);
}
.card .card-header.card-header-action.card-header-wth-text {
  align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  border-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;
}
.card .card-header.card-header-wth-bg-inv {
  color: #fff;
  background: #0a2f4c;
  border-color: transparent;
}
.card .card-header.card-header-wth-bg-inv h1, .card .card-header.card-header-wth-bg-inv h2, .card .card-header.card-header-wth-bg-inv h3, .card .card-header.card-header-wth-bg-inv h4, .card .card-header.card-header-wth-bg-inv h5, .card .card-header.card-header-wth-bg-inv h6, .card .card-header.card-header-wth-bg-inv .h1, .card .card-header.card-header-wth-bg-inv .h2, .card .card-header.card-header-wth-bg-inv .h3, .card .card-header.card-header-wth-bg-inv .h4, .card .card-header.card-header-wth-bg-inv .h5, .card .card-header.card-header-wth-bg-inv .h6 {
  color: #fff;
}
.card .card-header:first-child {
  border-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;
}
.card .card-header .nav-tabs.card-header-tabs {
  border-bottom: 0;
}
.card.sticky-card-header .card-header {
  top: 64px;
  position: sticky;
  z-index: 100;
}
.card .card-text {
  margin-bottom: 1rem;
}
.card .card-text:last-child {
  margin-bottom: 0;
}
.card .card-title {
  font-size: 1rem;
  color: #262a2e;
  font-weight: 500;
}
.card .card-subtitle {
  font-size: 0.875rem;
}
.card .card-body {
  padding: 1.25rem;
  min-height: 1px;
}
.card .card-body > .card-action-wrap {
  display: flex;
  align-items: center;
  position: absolute;
  right: 14px;
  top: 8px;
}
.card .card-body > .card-action-wrap .btn, .card .card-body > .card-action-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .card .card-body > .card-action-wrap .hopscotch-nav-button {
  display: flex;
  flex-shrink: 0;
}
.card .card-body > .card-close {
  position: absolute;
  right: 14px;
  top: 10px;
  cursor: pointer;
}
.card .card-body > .card-close a {
  color: #262a2e;
  transition: 0.2s ease;
  margin-left: 1rem;
  display: flex;
  opacity: .6;
  font-size: 1.125rem;
}
.card .card-body > .card-close a:hover {
  opacity: 1;
}
.card.close-over .btn-close {
  position: absolute;
  top: -10px;
  right: -10px;
}
.card.card-selected {
  position: relative;
  border-color: #0a2f4c;
}
.card.card-selected:after {
  height: 22px;
  width: 22px;
  background: #0a2f4c;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  cursor: pointer;
  font: normal normal normal 16px/1 'Material-Design-Iconic-Font';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f26b";
  top: -10px;
  right: -10px;
  line-height: 0;
  position: absolute;
}
.card .card-footer {
  background: transparent;
  border-color: #eaeaea;
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
}
.card .card-footer:last-child {
  border-radius: 0 0 calc(0.5rem - 1px) calc(0.5rem - 1px);
}
.card .card-img-bg {
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.card.card-refresh {
  position: relative;
}
.card.card-refresh .refresh-container {
  background: rgba(255, 255, 255, 0.9);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  display: none;
  z-index: 5;
  cursor: wait;
  border-radius: 0.5rem;
  overflow: hidden;
}
.card.card-refresh .refresh-container .loader-pendulums {
  font-size: 2rem;
}
.card.fullscreen {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0;
  position: fixed;
  overflow-y: auto;
  z-index: 1040;
  border-radius: 0;
  transition: all 0.2s ease;
}
.card.card-lg .card-header,
.card.card-lg .card-footer {
  padding: 1rem 1.5rem;
}
.card.card-lg .card-body {
  padding: 1.5rem;
}
.card.card-sm .card-header,
.card.card-sm .card-footer {
  padding: .625rem 1rem;
}
.card.card-sm .card-body {
  padding: 1rem;
}
.card.card-shadow {
  border: none;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}
.card.card-flush {
  border: none;
  box-shadow: none;
}
.card.card-border {
  border: 1px solid #eaeaea;
  box-shadow: none;
}
.card.card-simple .card-header,
.card.card-simple .card-footer {
  border: none;
}
.card.card-wth-line {
  padding-top: .25rem;
  border-top: 0;
}
.card.card-wth-line .card-line {
  position: absolute;
  top: 0;
  height: 30px;
  width: 100%;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.card.card-wth-line .card-body {
  position: relative;
  z-index: 1;
  background: #fff;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.card.card-wth-progress .progress {
  background: transparent;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.card.card-wth-tabs > .card-header {
  padding-bottom: .5rem;
}

.card-img, .card-img-top {
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
}

.card-img, .card-img-bottom {
  border-bottom-right-radius: calc(0.5rem - 1px);
  border-bottom-left-radius: calc(0.5rem - 1px);
}

.card-group > .card {
  margin-bottom: .875rem;
}

.hk-wrapper.hk-menu-toggle .card.fullscreen {
  left: 0;
}

@media (max-width: 1199px) {
  .card.fullscreen {
    left: 0;
  }

  .hk-wrapper.hk-menu-toggle .card.fullscreen {
    left: 269px;
    right: -269px;
  }
}
@media (max-width: 576px) {
  .card.card-lg .card-header,
  .card.card-lg .card-footer {
    padding: .75rem 1.25rem;
  }
  .card.card-lg .card-body {
    padding: 1.25rem;
  }
}
/*Placehoder*/
.placeholder {
  border-radius: 0.25rem;
}

/*Breadcrumb*/
.breadcrumb .breadcrumb-item {
  font-size: 0.875rem;
}
.breadcrumb .breadcrumb-item > a {
  color: #2F343A;
}
.breadcrumb .breadcrumb-item > a:hover, .breadcrumb .breadcrumb-item > a:focus {
  color: #0a2f4c;
}
.breadcrumb .breadcrumb-item.active {
  color: #6f6f6f;
}
.breadcrumb.breadcrumb-sm .breadcrumb-item {
  font-size: 0.75rem;
}
.breadcrumb.breadcrumb-dark .breadcrumb-item > a {
  color: rgba(255, 255, 255, 0.85);
}
.breadcrumb.breadcrumb-dark .breadcrumb-item > a:hover, .breadcrumb.breadcrumb-dark .breadcrumb-item > a:focus {
  color: white;
}
.breadcrumb.breadcrumb-dark .breadcrumb-item.active {
  color: rgba(255, 255, 255, 0.7);
}
.breadcrumb.breadcrumb-dark .breadcrumb-item + .breadcrumb-item:before {
  color: rgba(255, 255, 255, 0.3);
}
.breadcrumb.breadcrumb-full-width {
  border-radius: 0;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: .3rem;
  align-items: center;
  display: flex;
}
.breadcrumb-item + .breadcrumb-item:before {
  font-family: "dripicons-v2" !important;
  content: "V";
  padding-right: .3rem;
  position: relative;
  top: 1px;
  font-size: 0.625rem;
  color: rgba(181, 181, 181, 0.8);
}

/*Page Header*/
.hk-pg-header {
  padding: 1.25rem 0;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
}
.hk-pg-header .pg-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: .3rem;
}
.hk-pg-header .pg-title-sm {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: .25rem;
}
.hk-pg-header .pg-title-xs {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: .25rem;
}
.hk-pg-header .breadcrumb {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 0.5rem;
}
.hk-pg-header .pg-subtitle {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: .3rem;
}
.hk-pg-header .pg-stats-group {
  display: flex;
  align-items: center;
}
.hk-pg-header .pg-stats-group .stats-symbol {
  display: flex;
  padding-right: .25rem;
}
.hk-pg-header .pg-stats-group .stats-symbol .feather-icon svg, .hk-pg-header .pg-stats-group .stats-symbol .svg-icon svg {
  height: 13px;
  width: 13px;
}
.hk-pg-header .pg-stats-group .stats-title {
  font-size: 0.875rem;
}
.hk-pg-header .pg-stats-group .stats-dot-sep {
  padding: 0 .625rem;
  color: #d8d8d8;
}
.hk-pg-header .pg-stats-group .stats-line-sep {
  padding: 0 .625rem;
  color: #d8d8d8;
}
.hk-pg-header .pg-header-action-wrap {
  display: flex;
  align-items: center;
}
.hk-pg-header.pg-header-wth-tab {
  padding-bottom: 0;
}
.hk-pg-header.pg-header-wth-tab .nav-tabs {
  margin-top: 1.875rem;
  border-bottom: none;
}
.hk-pg-header.pg-header-wth-img {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.hk-pg-header.pg-header-wth-img:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #262a2e;
  opacity: .6;
}
.hk-pg-header.pg-header-wth-img > div, .hk-pg-header.pg-header-wth-img > .nav-tabs {
  position: relative;
  z-index: 2;
}
.hk-pg-header.pg-header-wth-bg {
  background: #f7f7f7;
  border-bottom: none;
}
.hk-pg-header.pg-header-wth-bg .nav-tabs .nav-item .nav-link,
.hk-pg-header.pg-header-wth-bg .nav-tabs .nav-item .nav-link.active {
  border: none;
}
.hk-pg-header.pg-header-wth-bg .nav-tabs .nav-item.show .nav-link {
  border: none;
}
.hk-pg-header.pg-header-dark .pg-title,
.hk-pg-header.pg-header-dark .pg-title-sm,
.hk-pg-header.pg-header-dark .pg-title-xs {
  color: #fff;
}
.hk-pg-header.pg-header-dark .pg-subtitle, .hk-pg-header.pg-header-dark p {
  color: rgba(255, 255, 255, 0.8);
}
.hk-pg-header.pg-header-dark .pg-stats-group .stats-symbol,
.hk-pg-header.pg-header-dark .pg-stats-group .stats-title {
  color: rgba(255, 255, 255, 0.8);
}
.hk-pg-header.pg-header-dark .pg-stats-group .stats-line-sep,
.hk-pg-header.pg-header-dark .pg-stats-group .stats-dot-sep {
  color: rgba(255, 255, 255, 0.3);
}
.hk-pg-header.pg-header-dark .hk-vertical-separator-full:after {
  background: rgba(255, 255, 255, 0.2);
}

@media (max-width: 767px) {
  .hk-pg-header .pg-title {
    font-size: 1.625rem;
  }
}
/*Page Body*/
.hk-pg-body {
  padding: 2rem 0;
}

/*Form*/
.form-group {
  margin-bottom: 1rem;
}

.form-control, .form-select, .wizard > .content > .body input, .dd-handle {
  color: #262a2e;
  border-color: #d8d8d8;
  border-radius: 0.375rem;
}
.form-control.square-input, .square-input.form-select, .wizard > .content > .body input.square-input, .square-input.dd-handle {
  border-radius: 0;
}
.form-control:focus, .form-select:focus, .wizard > .content > .body input:focus, .dd-handle:focus {
  border-color: #0a2f4c;
  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.16);
}
.form-control:disabled, .form-select:disabled, .wizard > .content > .body input:disabled, .dd-handle:disabled {
  color: #b5b5b5;
  background-color: #f7f7f7;
  cursor: not-allowed;
}
.form-control[readonly], [readonly].form-select, .wizard > .content > .body input[readonly], [readonly].dd-handle {
  border-color: #c7c7c7;
  box-shadow: none;
  color: #6f6f6f;
  background-color: #f7f7f7;
}
.form-control:hover:not(:disabled):not([readonly]), .form-select:hover:not(:disabled):not([readonly]), .wizard > .content > .body input:hover:not(:disabled):not([readonly]), .dd-handle:hover:not(:disabled):not([readonly]) {
  border-color: #0a2f4c;
  z-index: 4;
}
.form-control.rounded-input, .rounded-input.form-select, .wizard > .content > .body input.rounded-input, .rounded-input.dd-handle {
  border-radius: 50rem !important;
}
.form-control::placeholder, .form-select::placeholder, .wizard > .content > .body input::placeholder, .dd-handle::placeholder {
  color: #9e9e9e;
}
.form-control::-webkit-input-placeholder, .form-select::-webkit-input-placeholder, .wizard > .content > .body input::-webkit-input-placeholder, .dd-handle::-webkit-input-placeholder {
  color: #9e9e9e;
}
.form-control:-moz-placeholder, .form-select:-moz-placeholder, .wizard > .content > .body input:-moz-placeholder, .dd-handle:-moz-placeholder {
  color: #9e9e9e;
}
.form-control:-ms-input-placeholder, .form-select:-ms-input-placeholder, .wizard > .content > .body input:-ms-input-placeholder, .dd-handle:-ms-input-placeholder {
  color: #9e9e9e;
}
.form-control.form-control-line, .form-control-line.form-select, .wizard > .content > .body input.form-control-line, .form-control-line.dd-handle {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
  background: transparent !important;
}
.form-control.form-control-line:focus, .form-control-line.form-select:focus, .wizard > .content > .body input.form-control-line:focus, .form-control-line.dd-handle:focus {
  box-shadow: none;
}
.form-control::file-selector-button, .form-select::file-selector-button, .wizard > .content > .body input::file-selector-button, .dd-handle::file-selector-button, .form-control::-webkit-file-upload-button, .form-select::-webkit-file-upload-button, .wizard > .content > .body input::-webkit-file-upload-button, .dd-handle::-webkit-file-upload-button {
  background: #fff !important;
  color: #262a2e;
}

textarea.form-control, textarea.form-select, textarea.dd-handle {
  height: auto;
}

.form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}
.form-select:hover:not(:disabled) {
  border-color: #0a2f4c;
  z-index: 4;
}

.form-select[multiple], .form-select[size]:not([size="1"]) {
  height: auto;
}

.input-group-lg > .form-select,
.form-select-lg {
  padding-right: 1.75rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.input-group-sm > .form-select,
.form-select-sm {
  padding-right: 1.75rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.form-control-lg,
.form-select-lg {
  font-size: 1.125rem;
}

/*Checkbox*/
.form-check-input[type=checkbox] {
  border-radius: 0.125em;
}
.form-check-input:checked {
  background-color: #08364d;
  border-color: #08364d;
}
.form-check-input:focus {
  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.16);
}
.form-check-input:disabled ~ .form-check-label {
  color: #5e7d8a;
}

.form-switch .form-check-input[type=checkbox] {
  border-radius: 2em;
}

.form-check-lg {
  min-height: 2rem;
  padding-left: 2em;
}
.form-check-lg .form-check-input {
  height: 1.25rem;
  width: 1.25rem;
  margin-left: -2em;
  margin-top: 0.3rem;
}
.form-check-lg .form-check-label {
  font-size: 1.025rem;
  margin-top: .2rem;
}

.form-check-sm .form-check-input {
  height: 0.875rem;
  width: 0.875rem;
  margin-top: 0.275em;
}
.form-check-sm .form-check-label {
  font-size: .875rem;
}

.checkbox-circle.form-check-input {
  border-radius: 50%;
}

/*Form Switch*/
.form-switch.form-switch-lg {
  padding-left: 3.5rem;
}
.form-switch.form-switch-lg .form-check-input {
  height: 1.3em;
  width: 2.8em;
  margin-left: -3.5em;
}
.form-switch.form-switch-lg .form-check-label {
  font-size: 1.025rem;
  margin-top: 0.1rem;
}
.form-switch.form-switch-xl {
  padding-left: 4.5rem;
}
.form-switch.form-switch-xl .form-check-input {
  height: 1.8em;
  width: 3.5em;
  margin-left: -4.5em;
}
.form-switch.form-switch-xl .form-check-label {
  font-size: 1.2rem;
  margin-top: 0.2rem;
}

/*Form Range*/
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);
}
.form-range::-webkit-slider-thumb {
  background-color: #0a2f4c;
}
.form-range::-webkit-slider-thumb:active {
  background-color: #99cbcf;
}

/*Form validation*/
.form-control.is-valid, .is-valid.form-select, .wizard > .content > .body input.is-valid, .is-valid.dd-handle {
  border-color: #00D67F;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.form-control.is-valid:hover, .is-valid.form-select:hover, .wizard > .content > .body input.is-valid:hover, .is-valid.dd-handle:hover {
  border-color: #00D67F !important;
}
.form-control.is-valid:focus, .is-valid.form-select:focus, .wizard > .content > .body input.is-valid:focus, .is-valid.dd-handle:focus {
  border-color: #00D67F;
  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);
}
.form-control.is-invalid, .is-invalid.form-select, .wizard > .content > .body input.is-invalid, .is-invalid.dd-handle {
  border-color: #FF0000 !important;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.form-control.is-invalid:focus, .is-invalid.form-select:focus, .wizard > .content > .body input.is-invalid:focus, .is-invalid.dd-handle:focus {
  border-color: #FF0000;
  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);
}

.form-select.is-valid {
  border-color: #00D67F;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.form-select.is-valid:hover {
  border-color: #00D67F !important;
}
.form-select.is-valid:focus {
  border-color: #00D67F;
  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);
}
.form-select.is-invalid {
  border-color: #FF0000;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.form-select.is-invalid:hover {
  border-color: #FF0000 !important;
}
.form-select.is-invalid:focus {
  border-color: #FF0000;
  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);
}

.form-check-input.is-valid {
  border-color: #00D67F;
}
.form-check-input.is-valid:checked {
  background-color: #00D67F;
}
.form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);
}
.form-check-input.is-valid ~ .form-check-label {
  color: #00D67F;
}
.form-check-input.is-invalid {
  border-color: #FF0000;
}
.form-check-input.is-invalid:checked {
  background-color: #FF0000;
}
.form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);
}
.form-check-input.is-invalid ~ .form-check-label {
  color: #FF0000;
}

.was-validated .form-select:valid {
  border-color: #00D67F;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.was-validated .form-select:valid:hover {
  border-color: #00D67F !important;
}
.was-validated .form-select:valid:focus {
  border-color: #00D67F;
  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);
}
.was-validated .form-select:invalid {
  border-color: #FF0000;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.was-validated .form-select:invalid:hover {
  border-color: #FF0000 !important;
}
.was-validated .form-select:invalid:focus {
  border-color: #FF0000;
  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);
}
.was-validated .form-control:valid, .was-validated .form-select:valid, .was-validated .wizard > .content > .body input:valid, .wizard > .content > .body .was-validated input:valid, .was-validated .dd-handle:valid {
  border-color: #00D67F;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.was-validated .form-control:valid:hover, .was-validated .form-select:valid:hover, .was-validated .wizard > .content > .body input:valid:hover, .wizard > .content > .body .was-validated input:valid:hover, .was-validated .dd-handle:valid:hover {
  border-color: #00D67F !important;
}
.was-validated .form-control:valid:focus, .was-validated .form-select:valid:focus, .was-validated .wizard > .content > .body input:valid:focus, .wizard > .content > .body .was-validated input:valid:focus, .was-validated .dd-handle:valid:focus {
  border-color: #00D67F;
  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);
}
.was-validated .form-control:invalid, .was-validated .form-select:invalid, .was-validated .wizard > .content > .body input:invalid, .wizard > .content > .body .was-validated input:invalid, .was-validated .dd-handle:invalid {
  border-color: #FF0000;
  background-image: none;
  padding-right: inherit;
  z-index: 4;
}
.was-validated .form-control:invalid:hover, .was-validated .form-select:invalid:hover, .was-validated .wizard > .content > .body input:invalid:hover, .wizard > .content > .body .was-validated input:invalid:hover, .was-validated .dd-handle:invalid:hover {
  border-color: #FF0000 !important;
}
.was-validated .form-control:invalid:focus, .was-validated .form-select:invalid:focus, .was-validated .wizard > .content > .body input:invalid:focus, .wizard > .content > .body .was-validated input:invalid:focus, .was-validated .dd-handle:invalid:focus {
  border-color: #FF0000;
  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);
}
.was-validated .form-check-input:valid {
  border-color: #00D67F;
}
.was-validated .form-check-input:valid:checked {
  background-color: #00D67F;
}
.was-validated .form-check-input:valid:focus {
  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label {
  color: #00D67F;
}
.was-validated .form-check-input:invalid {
  border-color: #FF0000;
}
.was-validated .form-check-input:invalid:checked {
  background-color: #FF0000;
}
.was-validated .form-check-input:invalid:focus {
  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label {
  color: #FF0000;
}

.valid-feedback {
  color: #00D67F;
}

.invalid-feedback {
  color: #FF0000;
}

.valid-tooltip {
  background: #00D67F;
}

.invalid-tooltip {
  background: #FF0000;
}

/*Input group*/
.input-affix-wrapper {
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-items: center;
}
.input-affix-wrapper .input-prefix,
.input-affix-wrapper .input-suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  z-index: 5;
  padding: 0.375rem 0rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  min-width: 1.8rem;
}
.input-affix-wrapper .input-prefix {
  left: 0;
}
.input-affix-wrapper .input-suffix {
  right: 0;
}
.input-affix-wrapper .form-control:not(:first-child), .input-affix-wrapper .form-select:not(:first-child), .input-affix-wrapper .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper input:not(:first-child), .input-affix-wrapper .dd-handle:not(:first-child),
.input-affix-wrapper .form-select:not(:first-child) {
  padding-left: 2.5rem;
}
.input-affix-wrapper .form-control:not(:last-child), .input-affix-wrapper .form-select:not(:last-child), .input-affix-wrapper .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper input:not(:last-child), .input-affix-wrapper .dd-handle:not(:last-child),
.input-affix-wrapper .form-select:not(:last-child) {
  /*padding-right: 2.5rem;*/
}
.input-affix-wrapper.input-affix-wrapper-sm .input-prefix,
.input-affix-wrapper.input-affix-wrapper-sm .input-suffix {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  min-width: 1.5rem;
}
.input-affix-wrapper.input-affix-wrapper-sm .form-control, .input-affix-wrapper.input-affix-wrapper-sm .form-select, .input-affix-wrapper.input-affix-wrapper-sm .wizard > .content > .body input, .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-sm input, .input-affix-wrapper.input-affix-wrapper-sm .dd-handle,
.input-affix-wrapper.input-affix-wrapper-sm .form-select {
  padding: .25rem .5rem;
  font-size: .875rem;
}
.input-affix-wrapper.input-affix-wrapper-sm .form-control:not(:first-child), .input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:first-child), .input-affix-wrapper.input-affix-wrapper-sm .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-sm input:not(:first-child), .input-affix-wrapper.input-affix-wrapper-sm .dd-handle:not(:first-child),
.input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:first-child) {
  padding-left: 2rem;
}
.input-affix-wrapper.input-affix-wrapper-sm .form-control:not(:last-child), .input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:last-child), .input-affix-wrapper.input-affix-wrapper-sm .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-sm input:not(:last-child), .input-affix-wrapper.input-affix-wrapper-sm .dd-handle:not(:last-child),
.input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:last-child) {
  padding-right: 2rem;
}
.input-affix-wrapper.input-affix-wrapper-lg .input-prefix,
.input-affix-wrapper.input-affix-wrapper-lg .input-suffix {
  font-size: 1.25rem;
  padding: 0.5rem 1rem;
  min-width: 2rem;
}
.input-affix-wrapper.input-affix-wrapper-lg .form-control, .input-affix-wrapper.input-affix-wrapper-lg .form-select, .input-affix-wrapper.input-affix-wrapper-lg .wizard > .content > .body input, .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-lg input, .input-affix-wrapper.input-affix-wrapper-lg .dd-handle,
.input-affix-wrapper.input-affix-wrapper-lg .form-select {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-affix-wrapper.input-affix-wrapper-lg .form-control:not(:first-child), .input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:first-child), .input-affix-wrapper.input-affix-wrapper-lg .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-lg input:not(:first-child), .input-affix-wrapper.input-affix-wrapper-lg .dd-handle:not(:first-child),
.input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:first-child) {
  padding-left: 3rem;
}
.input-affix-wrapper.input-affix-wrapper-lg .form-control:not(:last-child), .input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:last-child), .input-affix-wrapper.input-affix-wrapper-lg .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-lg input:not(:last-child), .input-affix-wrapper.input-affix-wrapper-lg .dd-handle:not(:last-child),
.input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:last-child) {
  padding-right: 3rem;
}
.input-affix-wrapper.affix-border .input-prefix,
.input-affix-wrapper.affix-border .input-suffix {
  border: 1px solid #d8d8d8;
  border-radius: 0.375rem;
  padding: 0;
}
.input-affix-wrapper.affix-border .input-suffix {
  margin-right: 0.5rem;
}
.input-affix-wrapper.affix-border .input-prefix {
  margin-left: 0.5rem;
}
.input-affix-wrapper.affix-wth-text .form-control:not(:first-child), .input-affix-wrapper.affix-wth-text .form-select:not(:first-child), .input-affix-wrapper.affix-wth-text .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text input:not(:first-child), .input-affix-wrapper.affix-wth-text .dd-handle:not(:first-child),
.input-affix-wrapper.affix-wth-text .form-select:not(:first-child) {
  padding-left: 3.5rem;
}
.input-affix-wrapper.affix-wth-text .form-control:not(:last-child), .input-affix-wrapper.affix-wth-text .form-select:not(:last-child), .input-affix-wrapper.affix-wth-text .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text input:not(:last-child), .input-affix-wrapper.affix-wth-text .dd-handle:not(:last-child),
.input-affix-wrapper.affix-wth-text .form-select:not(:last-child) {
  padding-right: 3.5rem;
}
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-control:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm input:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .dd-handle:not(:first-child),
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:first-child) {
  padding-left: 3rem;
}
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-control:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm input:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .dd-handle:not(:last-child),
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:last-child) {
  padding-right: 3rem;
}
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-control:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg input:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .dd-handle:not(:first-child),
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:first-child) {
  padding-left: 4.5rem;
}
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-control:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg input:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .dd-handle:not(:last-child),
.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:last-child) {
  padding-right: 4.5rem;
}

.input-group-lg > .form-select,
.input-group-lg > .form-control,
.input-group-lg > .form-select,
.wizard > .content > .body .input-group-lg > input,
.input-group-lg > .dd-handle,
.input-group-sm > .form-select,
.input-group-sm > .form-control,
.input-group-sm > .form-select,
.wizard > .content > .body .input-group-sm > input,
.input-group-sm > .dd-handle {
  border-radius: 0.375rem;
}

.input-group > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-group > .hopscotch-nav-button, .input-group > .form-control, .input-group > .form-select, .wizard > .content > .body .input-group > input, .input-group > .dd-handle, .input-group > .form-select, .input-group > .input-group-text,
.input-group-sm > .btn,
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-group-sm > .hopscotch-nav-button, .input-group-sm > .form-control, .input-group-sm > .form-select, .wizard > .content > .body .input-group-sm > input, .input-group-sm > .dd-handle, .input-group-sm > .form-select, .input-group-sm > .input-group-text,
.input-group-lg > .btn,
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-group-lg > .hopscotch-nav-button, .input-group-lg > .form-control, .input-group-lg > .form-select, .wizard > .content > .body .input-group-lg > input, .input-group-lg > .dd-handle, .input-group-lg > .form-select, .input-group-lg > .input-group-text {
  border-radius: 0.375rem;
}

.input-group-text {
  border-color: #d8d8d8;
  background-color: #fff;
  border-width: 1px;
  border-radius: 0.375rem;
  color: #6f6f6f;
  overflow: hidden;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  min-width: 45px;
}

.input-group-lg .input-group-text {
  min-width: 55px;
}

.input-group-sm .input-group-text {
  min-width: 40px;
}

.input-group.input-group-wth-icon {
  position: relative;
  align-items: center;
}
.input-group.input-group-wth-icon .input-group-text {
  position: absolute;
  height: calc(100% - 2px);
  z-index: 5;
  border: 0;
  background: transparent;
  pointer-events: none;
}
.input-group.input-group-wth-icon .input-group-text:not(:last-child) {
  left: 0;
}
.input-group.input-group-wth-icon .input-group-text:not(:first-child) {
  right: 0;
}
.input-group.input-group-wth-icon .form-control, .input-group.input-group-wth-icon .form-select, .input-group.input-group-wth-icon .wizard > .content > .body input, .wizard > .content > .body .input-group.input-group-wth-icon input, .input-group.input-group-wth-icon .dd-handle {
  border-radius: 0.5rem !important;
}
.input-group.input-group-wth-icon .form-control:not(:first-child), .input-group.input-group-wth-icon .form-select:not(:first-child), .input-group.input-group-wth-icon .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-group.input-group-wth-icon input:not(:first-child), .input-group.input-group-wth-icon .dd-handle:not(:first-child) {
  padding-left: 2.6rem;
}
.input-group.input-group-wth-icon .form-control:not(:last-child), .input-group.input-group-wth-icon .form-select:not(:last-child), .input-group.input-group-wth-icon .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-group.input-group-wth-icon input:not(:last-child), .input-group.input-group-wth-icon .dd-handle:not(:last-child) {
  padding-right: 2.6rem;
}
.input-group.input-group-sm.input-group-wth-icon .form-control:not(:first-child), .input-group.input-group-sm.input-group-wth-icon .form-select:not(:first-child), .input-group.input-group-sm.input-group-wth-icon .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-group.input-group-sm.input-group-wth-icon input:not(:first-child), .input-group.input-group-sm.input-group-wth-icon .dd-handle:not(:first-child) {
  padding-left: 2.3rem;
}
.input-group.input-group-sm.input-group-wth-icon .form-control:not(:last-child), .input-group.input-group-sm.input-group-wth-icon .form-select:not(:last-child), .input-group.input-group-sm.input-group-wth-icon .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-group.input-group-sm.input-group-wth-icon input:not(:last-child), .input-group.input-group-sm.input-group-wth-icon .dd-handle:not(:last-child) {
  padding-right: 2.3rem;
}
.input-group.input-group-lg.input-group-wth-icon .form-control:not(:first-child), .input-group.input-group-lg.input-group-wth-icon .form-select:not(:first-child), .input-group.input-group-lg.input-group-wth-icon .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-group.input-group-lg.input-group-wth-icon input:not(:first-child), .input-group.input-group-lg.input-group-wth-icon .dd-handle:not(:first-child) {
  padding-left: 3.1rem;
}
.input-group.input-group-lg.input-group-wth-icon .form-control:not(:last-child), .input-group.input-group-lg.input-group-wth-icon .form-select:not(:last-child), .input-group.input-group-lg.input-group-wth-icon .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-group.input-group-lg.input-group-wth-icon input:not(:last-child), .input-group.input-group-lg.input-group-wth-icon .dd-handle:not(:last-child) {
  padding-right: 3.1rem;
}
.input-group .form-select.is-valid, .input-group .form-select.is-invalid,
.input-group .form-control.is-valid,
.input-group .is-valid.form-select,
.input-group .wizard > .content > .body input.is-valid,
.wizard > .content > .body .input-group input.is-valid,
.input-group .is-valid.dd-handle,
.input-group .form-control.is-invalid,
.input-group .is-invalid.form-select,
.input-group .wizard > .content > .body input.is-invalid,
.wizard > .content > .body .input-group input.is-invalid,
.input-group .is-invalid.dd-handle {
  z-index: 4;
}
.input-group > .input-affix-wrapper {
  flex: 1 1 auto;
  min-width: 0;
  width: 1%;
}
.input-group > .input-affix-wrapper:not(:first-child) .form-control, .input-group > .input-affix-wrapper:not(:first-child) .form-select, .input-group > .input-affix-wrapper:not(:first-child) .wizard > .content > .body input, .wizard > .content > .body .input-group > .input-affix-wrapper:not(:first-child) input, .input-group > .input-affix-wrapper:not(:first-child) .dd-handle,
.input-group > .input-affix-wrapper:not(:first-child) .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .input-affix-wrapper:not(:last-child) .form-control, .input-group > .input-affix-wrapper:not(:last-child) .form-select, .input-group > .input-affix-wrapper:not(:last-child) .wizard > .content > .body input, .wizard > .content > .body .input-group > .input-affix-wrapper:not(:last-child) input, .input-group > .input-affix-wrapper:not(:last-child) .dd-handle,
.input-group > .input-affix-wrapper:not(:last-child) .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

label {
  color: #262a2e;
}

.custom-file-label {
  color: #262a2e;
  border: 1px solid #d8d8d8;
  height: calc(2.25rem + 2px);
}
.custom-file-label:after {
  border-left: 0;
  background: #f7f7f7;
}

.form-label-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: .5rem;
}
.form-label-group label {
  margin-bottom: 0;
}

/*Input Search*/
.input-search .btn-input-clear {
  cursor: pointer;
  line-height: 0;
}
.input-search .btn-input-clear,
.input-search .input-loader {
  display: none;
}
.input-search.loading .btn-input-clear {
  display: none !important;
}
.input-search.loading .input-loader {
  display: block;
}

/*Spinner*/
.spinner-border {
  border-width: 0.125em;
}

.spinner-border-sm {
  border-width: 0.1em;
}

/*Input Spinner*/
.input-spinner-wrap .btn, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .hopscotch-nav-button {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-color: #d8d8d8 !important;
  background: #fff !important;
  color: #9e9e9e !important;
}
.input-spinner-wrap .btn strong, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button strong, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .hopscotch-nav-button strong {
  display: none;
}
.input-spinner-wrap .btn:after, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .hopscotch-nav-button:after {
  font: normal normal normal 20px/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
}
.input-spinner-wrap .btn.btn-decrement:after, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-decrement.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .btn-decrement.hopscotch-nav-button:after {
  content: '\\f273';
}
.input-spinner-wrap .btn.btn-increment:after, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-increment.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .btn-increment.hopscotch-nav-button:after {
  content: '\\f278';
}
.input-spinner-wrap .input-group.input-group-sm .btn.btn-outline-light:after, .input-spinner-wrap .input-group.input-group-sm div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-outline-light.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-sm .btn-outline-light.hopscotch-nav-button:after, .input-spinner-wrap .input-group.input-group-sm div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.btn-primary:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-sm .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-sm .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-sm div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-sm .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-sm .btn.btn-primary:after {
  font-size: 1rem;
}
.input-spinner-wrap .input-group.input-group-lg .btn.btn-outline-light:after, .input-spinner-wrap .input-group.input-group-lg div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-outline-light.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-lg .btn-outline-light.hopscotch-nav-button:after, .input-spinner-wrap .input-group.input-group-lg div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.btn-primary:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-lg .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-lg .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-lg div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-lg .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-lg .btn.btn-primary:after {
  font-size: 1.5rem;
}

/*Select2*/
.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,
.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.select2-dropdown {
  border-color: #d8d8d8;
}

.select2-container {
  width: 100% !important;
}
.select2-container.select2-container--default.select2-container--disabled {
  cursor: not-allowed;
}
.select2-container.select2-container--default.select2-container--disabled .select2-selection--single {
  background-color: #f7f7f7;
  pointer-events: none;
}

.select2-container--default .select2-selection--single,
.select2-container--default .select2-selection--multiple {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: .375rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #262a2e;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 0.5rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.select2-container--default .select2-selection--single:hover,
.select2-container--default .select2-selection--multiple:hover {
  border-color: #0a2f4c;
}
.select2-container--default .select2-selection--single:focus,
.select2-container--default .select2-selection--multiple:focus {
  border-color: #0a2f4c;
  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);
}
.select2-container--default .select2-selection--single .select2-selection__arrow,
.select2-container--default .select2-selection--multiple .select2-selection__arrow {
  height: calc(2.25rem + 2px);
  top: 0;
  right: 6px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b,
.select2-container--default .select2-selection--multiple .select2-selection__arrow b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px 12px;
  height: 100%;
  width: 20px;
  display: block;
  border: none;
  margin: auto;
  position: static;
}
.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--multiple .select2-selection__rendered {
  color: #262a2e;
  line-height: inherit;
  padding-left: 0;
  padding-right: 0;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  border-color: #d8d8d8;
}
.select2-container--default.select2-container--focus .select2-selection--multiple {
  border: solid #0a2f4c 1px;
  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);
}
.select2-container--default.select2-container--open .select2-selection--single {
  border-color: #0a2f4c;
}
.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,
.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #0a2f4c;
}
.select2-container--default .select2-results__option[aria-selected="true"] {
  background-color: #f7f7f7;
  color: #262a2e;
}
.select2-container--default .select2-selection--multiple {
  height: auto;
  min-height: calc(2.25rem + 2px);
  padding: 0;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice {
  background-color: #f7f7f7;
  border: none;
  font-size: 75%;
  border-radius: .25rem;
  color: #262a2e;
  margin-right: .375rem;
  margin-top: .375rem;
  padding: .25rem .5rem;
  font-weight: 500;
  text-transform: capitalize;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove {
  color: #262a2e;
  font-weight: 600;
  margin-left: .375rem;
  float: right;
  font-size: 0.875rem;
  opacity: 0.5;
  padding-top: 1px;
  height: 0;
  position: relative;
  top: -2px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:hover {
  opacity: 1;
}
.select2-container--default .select2-selection--multiple .select2-selection__rendered {
  padding: 0 1rem;
}

.select2-container--default .select2-results__group,
.select2-results__option {
  padding: .375rem 1rem;
}

/*Tinymce*/
.mce-container, .mce-container *, .mce-widget, .mce-widget *, .mce-reset {
  color: #8e8e8e !important;
}

.mce-text {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.mce-menu-item .mce-caret {
  border-left-color: #8e8e8e !important;
}

div.mce-menu .mce-menu-item-sep, .mce-menu-item-sep:hover {
  border-bottom-color: #d8d8d8 !important;
}

.mce-menu {
  border-bottom-color: #d8d8d8 !important;
}

.tinymce-wrap .mce-tinymce {
  box-shadow: none;
}
.tinymce-wrap .mce-toolbar .mce-btn-group {
  padding: .25rem 0;
}
.tinymce-wrap .mce-btn-group .mce-btn {
  margin-left: .25rem;
  margin-right: .25rem;
}
.tinymce-wrap .mce-btn-group:not(:first-child) {
  border-left: none;
  padding-left: 0;
  margin-left: 0;
}
.tinymce-wrap .mce-container, .tinymce-wrap .mce-container *, .tinymce-wrap .mce-widget, .tinymce-wrap .mce-widget *, .tinymce-wrap .mce-reset {
  font-family: inherit;
  color: #8e8e8e;
}
.tinymce-wrap .mce-panel {
  border-color: #d8d8d8;
  border-radius: .25rem;
}
.tinymce-wrap .mce-top-part::before {
  box-shadow: none;
}
.tinymce-wrap .mce-btn:hover, .tinymce-wrap .mce-btn.mce-disabled:hover button,
.tinymce-wrap .mce-menubar .mce-menubtn:hover, .tinymce-wrap .mce-menubar .mce-menubtn:focus {
  border-color: transparent;
  border-radius: .25rem;
  background: #f7f7f7;
  color: #262a2e;
}
.tinymce-wrap .mce-btn.mce-active:hover, .tinymce-wrap .mce-btn.mce-active:focus, .tinymce-wrap .mce-btn.mce-active:active {
  background: #f7f7f7;
  border-color: transparent;
}
.tinymce-wrap .mce-btn.mce-active,
.tinymce-wrap .mce-btn:active {
  background: #f7f7f7;
  border-color: transparent;
}
.tinymce-wrap .mce-btn.mce-active button i,
.tinymce-wrap .mce-btn:active button i {
  color: #0a2f4c !important;
}
.tinymce-wrap .mce-btn.mce-active button, .tinymce-wrap .mce-btn.mce-active:hover button, .tinymce-wrap .mce-btn.mce-active i, .tinymce-wrap .mce-btn.mce-active:hover i {
  color: #0a2f4c;
}
.tinymce-wrap .mce-btn.mce-active .mce-caret, .tinymce-wrap .mce-btn.mce-active:hover .mce-caret {
  border-top-color: #8e8e8e;
}

.mce-ico {
  font-family: 'tinymce',Arial !important;
  color: #5f5f5f !important;
}

.mce-menu-item.mce-active.mce-menu-item-normal {
  background: #f7f7f7 !important;
}

.mce-tooltip {
  opacity: 1 !important;
  filter: alpha(opacity=100) !important;
}

.mce-tooltip-inner {
  font-size: 0.75rem !important;
  background-color: #262a2e !important;
  padding: 0.25rem 0.5rem !important;
  border-radius: 0.5rem;
  color: #fff !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.mce-tooltip-arrow {
  border-bottom-color: #262a2e !important;
}

.mce-menu-item:hover, .mce-menu-item:focus {
  background: #f7f7f7 !important;
}

/*File Upload*/
.btn-file {
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  display: inline-block;
}
.btn-file input {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 1.5rem;
  height: 100%;
  width: 100%;
  direction: ltr;
  cursor: pointer;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
  display: none;
}

.fileinput.input-group > .input-group-append:last-child > .btn.btn-file:not(:last-child):not(.dropdown-toggle), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.input-group > .input-group-append:last-child > .btn-file.hopscotch-nav-button:not(:last-child):not(.dropdown-toggle), .fileinput.input-group > .input-group-append:not(:last-child) > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.input-group > .input-group-append:not(:last-child) > .btn-file.hopscotch-nav-button, .fileinput.input-group > .input-group-prepend > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.input-group > .input-group-prepend > .btn-file.hopscotch-nav-button {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.fileinput.fileinput-exists.input-group > .input-group-append:last-child > .btn.btn-file:not(:last-child):not(.dropdown-toggle), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.fileinput-exists.input-group > .input-group-append:last-child > .btn-file.hopscotch-nav-button:not(:last-child):not(.dropdown-toggle), .fileinput.fileinput-exists.input-group > .input-group-append:not(:last-child) > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.fileinput-exists.input-group > .input-group-append:not(:last-child) > .btn-file.hopscotch-nav-button, .fileinput.fileinput-exists.input-group > .input-group-prepend > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.fileinput-exists.input-group > .input-group-prepend > .btn-file.hopscotch-nav-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.dropzone {
  border: 1px dashed #d8d8d8;
  color: #262a2e;
  border-radius: 0.25rem;
}
.dropzone .dz-message {
  margin: 3em 0;
  font-weight: 500;
  color: #262a2e;
}
.dropzone .dz-preview .dz-details {
  color: #262a2e;
}
.dropzone .dz-preview .dz-filename span {
  background-color: transparent;
}
.dropzone .dz-preview .dz-image {
  border-radius: 0.25rem;
}
.dropzone .dz-preview.dz-file-preview .dz-image {
  border-radius: 0.25rem;
}

.dropify-wrapper {
  border: 1px dashed #d8d8d8;
  border-radius: 0.25rem;
  font-family: inherit;
  color: #262a2e;
  font-size: 1rem;
  padding: 1rem;
}
.dropify-wrapper .dropify-message p .main-text {
  display: block;
  color: #262a2e;
  font-weight: 500;
}
.dropify-wrapper .dropify-message p .sub-text {
  font-size: 0.875rem;
  display: block;
  color: #6f6f6f;
}
.dropify-wrapper .dropify-message span.file-icon {
  font-size: 2rem;
  color: #fff;
  height: 3rem;
  width: 3rem;
  display: block;
  margin: auto;
  color: #9e9e9e;
  position: relative;
}
.dropify-wrapper .dropify-message span.file-icon:before {
  content: "\\F603";
  display: inline-block;
  font-family: bootstrap-icons !important;
  font-style: normal;
  font-weight: normal !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  top: 50%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateY(-50%);
}
.dropify-wrapper .dropify-preview .dropify-infos {
  background: rgba(47, 52, 58, 0.85);
}
.dropify-wrapper .dropify-preview .dropify-infos .dropify-infos-inner p {
  font-weight: 500;
}
.dropify-wrapper .dropify-preview .dropify-infos .dropify-infos-inner p.dropify-infos-message {
  margin-top: 0px;
  padding-top: 0px;
  opacity: 1;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9e9e9e;
  font-size: 0.875rem;
}
.dropify-wrapper .dropify-preview .dropify-infos .dropify-infos-inner p.dropify-infos-message:before {
  display: none;
}
.dropify-wrapper .dropify-clear {
  border: none;
  font-size: 0.75rem;
  padding: .125rem .375rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  top: 8px;
  right: 8px;
}
.dropify-wrapper .dropify-clear:hover {
  border-radius: 1rem;
}
.dropify-wrapper:hover {
  background-image: none;
}

.dropify-square .dropify-wrapper,
.dropify-circle .dropify-wrapper {
  height: 7.5rem;
  width: 7.5rem;
  overflow: visible;
}
.dropify-square .dropify-wrapper .dropify-message,
.dropify-circle .dropify-wrapper .dropify-message {
  font-size: 0.875rem;
}
.dropify-square .dropify-wrapper .dropify-message span.file-icon,
.dropify-circle .dropify-wrapper .dropify-message span.file-icon {
  font-size: 1.25rem;
  height: 1.25rem;
  width: 1.25rem;
}
.dropify-square .dropify-wrapper .dropify-message p,
.dropify-circle .dropify-wrapper .dropify-message p {
  font-size: 0.875rem;
}
.dropify-square .dropify-wrapper .dropify-preview,
.dropify-circle .dropify-wrapper .dropify-preview {
  border-radius: 50%;
  padding: 0;
}
.dropify-square .dropify-wrapper:hover .dropify-clear, .dropify-square .dropify-wrapper:hover .dropify-preview .dropify-infos,
.dropify-circle .dropify-wrapper:hover .dropify-clear,
.dropify-circle .dropify-wrapper:hover .dropify-preview .dropify-infos {
  opacity: 0;
}

.dropify-circle .dropify-wrapper {
  border-radius: 50%;
}

/*Form-Wizard*/
.wizard > .steps li > a {
  border: 1px solid #d8d8d8;
  border-radius: 0 !important;
  background: #fff !important;
  font-weight: 500;
  position: relative;
}
.wizard > .steps li > a:after {
  content: "\\eb74";
  font-family: 'remixicon';
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 1rem;
  width: 1rem;
  background: #d8d8d8;
  border-radius: 50%;
  right: 0.5rem;
  top: 0.5rem;
  color: #fff;
  font-size: 0.875rem;
  transition: all 0.1s ease;
}
.wizard > .steps li > a:before {
  content: "";
  position: absolute;
  background: transparent;
  height: 3px;
  width: 100%;
  left: 0;
  bottom: 0;
  transition: all 0.1s ease;
}
.wizard > .steps .current a, .wizard > .steps .current a:hover, .wizard > .steps .current a:active {
  color: #262a2e;
}
.wizard > .steps .current a:before, .wizard > .steps .current a:hover:before, .wizard > .steps .current a:active:before {
  background: #0a2f4c;
}
.wizard > .steps .current.error a, .wizard > .steps .current.error a:hover, .wizard > .steps .current.error a:active {
  color: #FF0000;
}
.wizard > .steps .current.error a:before, .wizard > .steps .current.error a:hover:before, .wizard > .steps .current.error a:active:before {
  background: #FF0000;
}
.wizard > .steps .done a, .wizard > .steps .done a:hover, .wizard > .steps .done a:active {
  color: #262a2e;
  overflow: hidden;
}
.wizard > .steps .done a:after, .wizard > .steps .done a:hover:after, .wizard > .steps .done a:active:after {
  background: #00D67F;
}
.wizard > .steps .done a:before, .wizard > .steps .done a:hover:before, .wizard > .steps .done a:active:before {
  background: transparent;
}
.wizard > .content {
  background: #fff;
  border-radius: 0;
  min-height: 100px;
  margin: 0;
  border: none;
  padding-bottom: .625rem;
}
.wizard > .content > .body {
  width: 100%;
  height: auto;
  padding: 1.875rem;
  position: static;
}
.wizard > .content > .body label.error {
  color: #FF0000;
}
.wizard > .content > .body input.error {
  background: #fff;
  border-color: #FF0000 !important;
  color: #262a2e;
}
.wizard > .content > .body input.error:focus {
  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);
}
.wizard > .actions {
  background: #fff;
  padding: .625rem 1.875rem;
}
.wizard > .actions a, .wizard > .actions a:hover, .wizard > .actions a:active {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  background: #0a2f4c;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid #0a2f4c;
  text-transform: capitalize;
  outline: none;
  font-size: 1rem;
  padding: 0.375rem 1rem;
  border-radius: 0.5rem;
}
.wizard > .actions .disabled a, .wizard > .actions .disabled a:hover, .wizard > .actions .disabled a:active {
  color: #fff;
  background-color: #99cbcf;
  border-color: #99cbcf;
}

@media (max-width: 991px) {
  .wizard .steps ul > li {
    width: 100%;
  }
}
/*Popover*/
.popover {
  border: none;
  border-radius: 0.5rem;
  font-family: var(--bs-body-font-family);
  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.1);
}

.popover-header {
  color: #262a2e;
  background-color: #fff;
  padding: 0.65rem .75rem;
  border-radius: 0.5rem 0.5rem 0 0;
  border-color: #d8d8d8;
}

.popover-body {
  padding: .65rem .75rem;
  color: #6f6f6f;
  border-radius: 0.5rem;
  font-size: 1rem;
}

.bs-popover-auto[x-placement^="top"] > .arrow::before, .bs-popover-top > .arrow::before {
  border-top-color: transparent;
}

.bs-popover-auto[x-placement^="bottom"] > .arrow::before, .bs-popover-bottom > .arrow::before {
  border-bottom-color: transparent;
}

.bs-popover-auto[x-placement^="left"] > .arrow::before, .bs-popover-left > .arrow::before {
  border-left-color: transparent;
}

.bs-popover-auto[x-placement^="right"] > .arrow::before, .bs-popover-right > .arrow::before {
  border-right-color: transparent;
}

/*Collapse*/
.collapse-simple > .card {
  margin-bottom: 0;
  box-shadow: none;
  border: 0;
  border-bottom: 1px solid #eaeaea;
  border-radius: 0;
  padding: 0.5rem 0;
}
.collapse-simple > .card:last-child {
  border-bottom: 0;
}
.collapse-simple > .card > .card-header {
  padding: 0;
  border: 0;
}
.collapse-simple > .card > .card-header > * {
  font-size: 0.875rem;
  font-weight: 500;
  padding: .5rem 0;
  display: block;
  width: 100%;
  color: #0a2f4c;
  text-align: left;
  position: relative;
  display: flex;
  background: transparent;
  border: none;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  transition: all 0.2s ease-in-out;
}
.collapse-simple > .card > .card-header > *::before {
  content: '\\f2f9';
  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';
  font-size: 1.25rem;
  text-rendering: auto;
  position: absolute;
  top: 8px;
  right: 0;
  color: rgba(38, 42, 46, 0.3);
}
.collapse-simple > .card > .card-header > *.collapsed:before {
  content: '\\f2fc';
}
.collapse-simple > .card > div > .card-body {
  padding: .5rem 0;
}

/*Accordion*/
.accordion .accordion-button {
  color: #262a2e;
  font-weight: 500;
  padding: .75rem 1.25rem;
}
.accordion .accordion-button:not(.collapsed) {
  background: #0a2f4c;
  color: #fff;
  box-shadow: none;
  border-bottom: 1px solid #d8d8d8;
}
.accordion .accordion-button:not(.collapsed)::after {
  background: none;
  color: rgba(255, 255, 255, 0.3);
}
.accordion .accordion-button:focus {
  box-shadow: none;
}
.accordion .accordion-button::after {
  width: auto;
  height: auto;
  background: none;
  content: '\\f2f9';
  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';
  font-size: 1.25rem;
  text-rendering: auto;
  position: absolute;
  top: 12px;
  right: 20px;
  color: rgba(38, 42, 46, 0.3);
}
.accordion .accordion-item:first-of-type {
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
}
.accordion .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
}
.accordion .accordion-item:last-of-type {
  border-bottom-left-radius: calc(0.5rem - 1px);
  border-bottom-right-radius: calc(0.5rem - 1px);
}
.accordion .accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: calc(0.5rem - 1px);
  border-bottom-left-radius: calc(0.5rem - 1px);
}
.accordion.accordion-flush .accordion-item:first-of-type {
  border-radius: 0;
}
.accordion.accordion-flush .accordion-item:first-of-type .accordion-button {
  border-radius: 0;
}
.accordion.accordion-flush .accordion-item:last-of-type {
  border-radius: 0;
}
.accordion.accordion-flush .accordion-item:last-of-type .accordion-button.collapsed {
  border-radius: 0;
}
.accordion.accordion-card > .accordion-item {
  margin-bottom: 1.875rem;
  border-bottom: 1px;
  border: 1px solid #d8d8d8;
  border-radius: calc(0.5rem - 1px);
  overflow: hidden;
}
.accordion.accordion-card.accordion-card-shadow > .accordion-item {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}
.accordion.accordion-card.accordion-card-bold > .accordion-item .accordion-body {
  background: #0a2f4c;
  color: #fff;
}
.accordion.accordion-soft .accordion-button:not(.collapsed) {
  background: #ebf5f5;
  color: #0a2f4c;
}
.accordion.accordion-soft .accordion-button:not(.collapsed):after {
  color: rgba(38, 42, 46, 0.3);
}
.accordion.accordion-soft.accordion-card.accordion-card-bold > .accordion-item .accordion-body {
  background: #ebf5f5;
  color: #0a2f4c;
}
.accordion.accordion-soft.accordion-soft-content .accordion-button:not(.collapsed) {
  background: transparent;
}
.accordion.accordion-soft.accordion-soft-content > .accordion-item .accordion-body {
  background: #ebf5f5;
  color: #262a2e;
}
.accordion.accordion-simple .accordion-button:not(.collapsed) {
  background: transparent;
  color: #0a2f4c;
}
.accordion.accordion-simple .accordion-button:not(.collapsed)::after {
  color: rgba(38, 42, 46, 0.3);
}
.accordion.accordion-simple.accordion-card.accordion-card-bold .accordion-button {
  border-color: transparent;
}
.accordion.accordion-simple.accordion-card.accordion-card-bold .accordion-item .accordion-body {
  background: transparent;
  color: inherit;
}
.accordion.accordion-icon .accordion-button .acon-icon {
  min-width: 30px;
  display: inline-block;
  margin-right: .625rem;
  font-size: 1.5rem;
}

/*Table*/
.table {
  --bs-table-striped-color: #262a2e;
  --bs-table-active-color: #262a2e;
  --bs-table-hover-color: #262a2e;
  --bs-table-hover-bg: #f7f7f7;
  color: #6f6f6f;
  border-color: #eaeaea;
}
.table thead th,
.table tfoot th {
  vertical-align: middle;
  font-weight: 500;
  color: #262a2e;
  font-size: 0.875rem;
  /* text-transform: capitalize; */
}
.table thead th .form-check,
.table tfoot th .form-check {
  font-size: 1rem;
}
.table td, .table th {
  vertical-align: middle;
  padding: .75rem .4rem;
}
.table td a.table-link-text:hover, .table th a.table-link-text:hover {
  text-decoration: underline;
}
.table.table-fixed {
  table-layout: fixed;
}
.table.table-lg td, .table.table-lg th {
  padding: 1rem 1.5rem;
}
.table:not(.table-borderless) > :not(:first-child) {
  border-top: 0;
}
.table.table-sm td, .table.table-sm th {
  padding: .625rem 1rem;
}
.table.nowrap th, .table.nowrap td {
  white-space: nowrap;
}
.table .tb-truncate {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table .tb-truncate > * {
  overflow: hidden;
  text-overflow: ellipsis;
}
.table .thead-primary th,
.table .thead-success th,
.table .thead-info th,
.table .thead-warning th,
.table .thead-danger th,
.table .thead-secondary th,
.table .thead-dark th {
  color: #fff;
}
.table .thead-success th {
  background-color: #00D67F;
}
.table .thead-info th {
  background-color: #18DDEF;
}
.table .thead-warning th {
  background-color: #FFC400;
}
.table .thead-danger th {
  background-color: #FF0000;
}
.table .thead-secondary th {
  background-color: #6f6f6f;
}
.table .thead-primary th {
  background-color: #0a2f4c;
}
.table .thead-light th {
  background-color: #f7f7f7;
}
.table .thead-dark th {
  background-color: #262a2e;
}
.table.table-dark thead th, .table.table-dark tfoot th {
  color: #fff;
}
.table.table-fc-fixed thead th:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  background: #fff;
}
.table.table-fc-fixed tbody th, .table.table-fc-fixed tbody tr td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  background: #fff;
}
.table.table-lc-fixed thead th:last-child {
  position: sticky;
  right: 0;
  z-index: 2;
  background: #fff;
}
.table.table-lc-fixed tbody tr td:last-child {
  position: sticky;
  right: 0;
  z-index: 2;
  background: #fff;
}
.table table thead th:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
}

.table-row-gap td {
  border: 0 !important;
}

table.sticky-table-header thead tr th {
  position: sticky;
  top: 64px;
  z-index: 99;
}

.table-action-hover .table-action {
  opacity: 0;
  display: flex;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  right: 1.25rem;
  transition: all 0.1s;
}
.table-action-hover .table-action::before {
  width: 120px;
  content: "";
  height: 100%;
  margin-left: -120px;
  position: absolute;
  top: 0;
  left: 0;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
}
.table-action-hover tr:hover .table-action {
  opacity: 1;
}
.table-action-hover.table-hover .table-action {
  background-color: var(--bs-table-hover-bg);
}
.table-action-hover.table-hover .table-action::before {
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, var(--bs-table-hover-bg) 100%);
}

.table-primary {
  --bs-table-bg: #e6f2f3;
  --bs-table-striped-bg: #b3d8db;
  --bs-table-striped-color: color-contrast(#b3d8db);
  --bs-table-active-bg: #d9eced;
  --bs-table-active-color: color-contrast(#d9eced);
  --bs-table-hover-bg: #cce5e7;
  --bs-table-hover-color: color-contrast(#cce5e7);
  color: #0a2f4c;
  border-color: #80bec4;
}

.table-secondary {
  --bs-table-bg: #f1f1f1;
  --bs-table-striped-bg: #d4d4d4;
  --bs-table-striped-color: color-contrast(#d4d4d4);
  --bs-table-active-bg: #e9e9e9;
  --bs-table-active-color: color-contrast(#e9e9e9);
  --bs-table-hover-bg: #e2e2e2;
  --bs-table-hover-color: color-contrast(#e2e2e2);
  color: #6f6f6f;
  border-color: #b7b7b7;
}

.table-success {
  --bs-table-bg: #e6fbf2;
  --bs-table-striped-bg: #b3f3d9;
  --bs-table-striped-color: color-contrast(#b3f3d9);
  --bs-table-active-bg: #d9f9ec;
  --bs-table-active-color: color-contrast(#d9f9ec);
  --bs-table-hover-bg: #ccf7e5;
  --bs-table-hover-color: color-contrast(#ccf7e5);
  color: #00D67F;
  border-color: #80ebbf;
}

.table-info {
  --bs-table-bg: #e8fcfd;
  --bs-table-striped-bg: #baf5fa;
  --bs-table-striped-color: color-contrast(#baf5fa);
  --bs-table-active-bg: #dcfafd;
  --bs-table-active-color: color-contrast(#dcfafd);
  --bs-table-hover-bg: #d1f8fc;
  --bs-table-hover-color: color-contrast(#d1f8fc);
  color: #18DDEF;
  border-color: #8ceef7;
}

.table-warning {
  --bs-table-bg: #fff9e6;
  --bs-table-striped-bg: #ffedb3;
  --bs-table-striped-color: color-contrast(#ffedb3);
  --bs-table-active-bg: #fff6d9;
  --bs-table-active-color: color-contrast(#fff6d9);
  --bs-table-hover-bg: #fff3cc;
  --bs-table-hover-color: color-contrast(#fff3cc);
  color: #FFC400;
  border-color: #ffe280;
}

.table-danger {
  --bs-table-bg: #ffe6e6;
  --bs-table-striped-bg: #ffb3b3;
  --bs-table-striped-color: color-contrast(#ffb3b3);
  --bs-table-active-bg: #ffd9d9;
  --bs-table-active-color: color-contrast(#ffd9d9);
  --bs-table-hover-bg: #ffcccc;
  --bs-table-hover-color: color-contrast(#ffcccc);
  color: #FF0000;
  border-color: #ff8080;
}

.table-light {
  --bs-table-bg: #f7f7f7;
  --bs-table-striped-bg: #eaeaea;
  --bs-table-striped-color: color-contrast(#eaeaea);
  --bs-table-active-bg: #e9e9e9;
  --bs-table-active-color: color-contrast(#e9e9e9);
  --bs-table-hover-bg: #d8d8d8;
  --bs-table-hover-color: color-contrast(#d8d8d8);
  color: #6f6f6f;
  border-color: #d8d8d8;
}

.table-dark {
  --bs-table-bg: #262a2e;
  --bs-table-striped-bg: #2a2f34;
  --bs-table-striped-color: color-contrast(#2a2f34);
  --bs-table-active-bg: #3c3f43;
  --bs-table-active-color: color-contrast(#3c3f43);
  --bs-table-hover-bg: #2a2f34;
  --bs-table-hover-color: color-contrast(#2a2f34);
  color: #fff;
  border-color: #2a2f34;
}

@media (max-width: 1200px) {
  .table-responsive .table > tbody > tr > td,
  .table-responsive .table > tbody > tr > th,
  .table-responsive .table > tfoot > tr > td,
  .table-responsive .table > tfoot > tr > th,
  .table-responsive .table > thead > tr > td,
  .table-responsive .table > thead > tr > th {
    white-space: nowrap;
  }
}
/*Data Table*/
table.dataTable thead td, table.dataTable thead th {
  position: relative;
  background-image: none !important;
}
table.dataTable thead td.sorting_asc, table.dataTable thead td.sorting_desc, table.dataTable thead th.sorting_asc, table.dataTable thead th.sorting_desc {
  color: #0a2f4c;
  background-image: none !important;
}
table.dataTable thead td.sorting::before, 
table.dataTable thead td.sorting_asc::before, 
table.dataTable thead td.sorting_desc::before, 
table.dataTable thead td.sorting::after, 
table.dataTable thead td.sorting_asc::after, 
table.dataTable thead td.sorting_desc::after, 
table.dataTable thead th.sorting::before, 
table.dataTable thead th.sorting_asc::before,
table.dataTable thead th.sorting_desc::before, 
table.dataTable thead th.sorting::after, 
table.dataTable thead th.sorting_asc::after,
table.dataTable thead th.sorting_desc::after
 {
  display: inline-block;
  font-family: remixicon;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.875rem;
  text-transform: none;
  text-rendering: auto;
  line-height: 1;
  position: absolute;
  z-index: 10;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
}

table.dataTable thead span.sorting::before, 
table.dataTable thead span.sorting::after,
table.dataTable thead span.sorting_asc::after,
table.dataTable thead span.sorting_desc::after,
table.dataTable thead span.sorting_asc::before,
table.dataTable thead span.sorting_desc::before
{
	bottom:0px!important;
} 


table.dataTable thead td.sorting::before, table.dataTable thead td.sorting_asc::before, table.dataTable thead td.sorting_desc::before, table.dataTable thead td.sorting::after, table.dataTable thead td.sorting_asc::after, table.dataTable thead td.sorting_desc::after, table.dataTable thead th.sorting::before, table.dataTable thead th.sorting_asc::before, table.dataTable thead th.sorting_desc::before, table.dataTable thead th.sorting::after, table.dataTable thead th.sorting_asc::after, table.dataTable thead th.sorting_desc::after {
  content: "";
  bottom: auto;
  opacity: 1;
}
table.dataTable thead td.sorting::before, table.dataTable thead th.sorting::before, table.dataTable thead span.sorting::before{
  content: "\\ea72";
}
table.dataTable thead td.sorting.sorting_asc::before, table.dataTable thead th.sorting.sorting_asc::before, table.dataTable thead span.sorting::before {
  content: "\\f0f9";
}
table.dataTable thead td.sorting.sorting_desc::after, table.dataTable thead th.sorting.sorting_desc::after, table.dataTable thead span.sorting::before {
  content: "\\f0fa";
}
table.dataTable thead td.sorting.sorting_desc::before, table.dataTable thead th.sorting.sorting_desc::before, table.dataTable thead span.sorting::before {
  content: "";
}
table.dataTable tbody tr.selected td {
  background-color: #ebf5f5;
  color: #262a2e;
}
table.dataTable tbody tr.group, table.dataTable tbody tr.group:hover {
  color: #0a2f4c !important;
  font-weight: 600;
  text-transform: uppercase;
}
table.dt-rowReorder-float {
  outline-offset: 0;
  outline-color: #0a2f4c;
}

div.dataTables_wrapper .dataTables_length select {
  margin-right: .625rem;
}
div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0 !important;
  width: 100% !important;
}
div.dataTables_wrapper .dataTables_scrollBody {
  border-left: 0 !important;
}
div.dataTables_wrapper .dataTables_scrollBody thead th {
  overflow: hidden;
}
div.dataTables_wrapper .dataTables_scrollBody table {
  margin-bottom: 1rem !important;
}
div.dataTables_wrapper div.dataTables_info {
  display: flex;
  align-items: center;
  height: 100%;
  padding-top: 0;
}

/*Advance Table*/
.table-advance th, .table-advance td {
  border: none;
}
.table-advance tbody tr {
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 0.5rem;
}
.table-advance tbody tr th, .table-advance tbody tr td {
  border: none;
  position: relative;
}
.table-advance tbody tr th:after, .table-advance tbody tr td:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  left: 0;
  top: 0;
  pointer-events: none;
}
.table-advance tbody tr th:first-child:after, .table-advance tbody tr td:first-child:after {
  border-left: 1px solid #d8d8d8;
  border-radius: 0.5rem 0 0 0.5rem;
}
.table-advance tbody tr th:last-child:after, .table-advance tbody tr td:last-child:after {
  border-right: 1px solid #d8d8d8;
  border-radius: 0 0.5rem 0.5rem 0;
}
.table-advance tbody tr.table-row-gap {
  box-shadow: none;
  pointer-events: none;
}
.table-advance tbody tr.table-row-gap th, .table-advance tbody tr.table-row-gap td {
  padding: .5rem;
}
.table-advance tbody tr.table-row-gap th:after, .table-advance tbody tr.table-row-gap td:after {
  display: none;
}
.table-advance.table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}

/*Apex Chart*/
.apexcharts-legend .apexcharts-legend-marker {
  margin-right: .625rem;
}

.apexcharts-toolbar {
  max-width: inherit !important;
}
.apexcharts-toolbar .apexcharts-zoom-icon,
.apexcharts-toolbar .apexcharts-zoomin-icon,
.apexcharts-toolbar .apexcharts-zoomout-icon,
.apexcharts-toolbar .apexcharts-reset-icon,
.apexcharts-toolbar .apexcharts-pan-icon,
.apexcharts-toolbar .apexcharts-selection-icon,
.apexcharts-toolbar .apexcharts-menu-icon,
.apexcharts-toolbar .apexcharts-toolbar-custom-icon {
  height: auto;
  width: auto;
  color: #262a2e;
  transform: scale(1);
  margin-left: 1rem;
  margin-right: 0;
}
.apexcharts-toolbar svg {
  fill: none !important;
  height: 18px;
  width: 18px;
}
.apexcharts-toolbar .apexcharts-menu {
  min-width: 10rem;
  padding: .5rem 0;
  margin: .125rem 0 0;
}
.apexcharts-toolbar .apexcharts-menu .apexcharts-menu-item {
  padding: .25rem 1.5rem;
  text-align: left;
  color: #262a2e;
  font-size: 1rem;
}
.apexcharts-toolbar .apexcharts-menu .apexcharts-menu-item:hover {
  background-color: #f7f7f7;
}

.apexcharts-canvas .apexcharts-xaxistooltip,
.apexcharts-canvas .apexcharts-yaxistooltip {
  font-size: 0.75rem;
  background: #262a2e;
  color: #fff;
  border-radius: 0.5rem;
  max-width: 200px;
  padding: .25rem .5rem;
  text-align: center;
}
.apexcharts-canvas .apexcharts-xaxistooltip:before, .apexcharts-canvas .apexcharts-xaxistooltip:after,
.apexcharts-canvas .apexcharts-yaxistooltip:before,
.apexcharts-canvas .apexcharts-yaxistooltip:after {
  display: none;
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {
  border-radius: 0.5rem;
  max-width: 200px;
  text-align: center;
  font-size: 0.75rem;
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light {
  border-radius: 0.5rem;
  font-size: 1rem;
  color: #6f6f6f;
  border: none;
  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.1);
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  color: #fff;
  background-color: #0a2f4c;
  border-bottom: none;
  padding: 0.65rem .75rem;
  border-radius: 0.5rem 0.5rem 0 0;
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-series-group {
  padding-left: .75rem;
  padding-right: .75rem;
}

#chart_year,
#chart_quarter {
  width: 96%;
  max-width: 48%;
  box-shadow: none;
  padding-left: 0;
  padding-top: 1.25rem;
  background: #fff;
}

#chart_year {
  float: left;
  position: relative;
  transition: 1s ease transform;
  z-index: 3;
}

#chart_year.chart_quarter-activated {
  transform: translateX(0);
  transition: 1s ease transform;
}

#chart_quarter {
  float: left;
  position: relative;
  z-index: -2;
  transition: 1s ease transform;
}

#chart_quarter.active {
  transition: 1.1s ease-in-out transform;
  transform: translateX(0);
  z-index: 1;
}

.apexcharts-datalabel-value {
  fill: #262a2e !important;
}

@media screen and (min-width: 480px) {
  #chart_year {
    transform: translateX(50%);
  }

  #chart_quarter {
    transform: translateX(-50%);
  }
}
/*charts*/
.hk-charts-pg .hk-container-mwlg .card .card-footer {
  transition: all 0.2s ease;
  min-height: 139px;
}
.hk-charts-pg .hk-container-mwlg .card:hover .card-footer {
  background: #f7f7f7;
}

/*Nestable*/
.dd-handle {
  font-weight: 500;
  margin: 0 0 .375rem;
  padding: .5rem 1rem;
  background: #fff;
  color: #262a2e;
  height: 37px;
  border-width: 1px;
  border-color: #d8d8d8;
}
.dd-handle:hover, .dd-handle:focus, .dd-handle:active {
  color: #262a2e;
  background: #f7f7f7;
}

.dd-item > button {
  margin: 0;
  height: 37px;
  font-size: 1.5rem;
  width: 42px;
  color: #9e9e9e;
  outline: none;
}
.dd-item > button.dd-expand:before, .dd-item > button.dd-collapse:before {
  font-family: 'Line Awesome Free';
  font-weight: 900;
  line-height: 1;
}
.dd-item > button.dd-expand::before {
  content: "\\f067";
}
.dd-item > button.dd-collapse::before {
  content: "\\f068";
}
.dd-item > button:hover, .dd-item > button:focus, .dd-item > button:active {
  outline: none;
}

.dd-placeholder {
  background: transparent;
  border-color: #d8d8d8;
}

.dd3-content {
  display: block;
  width: 100%;
  border-radius: 0.5rem;
  font-weight: 500;
  margin: 0 0 .375rem;
  font-size: 0.875rem;
  padding: .5rem 1rem .5rem 4rem;
  background: #fff;
  color: #262a2e;
  border: 1px solid #d8d8d8;
}
.dd3-content:hover, .dd3-content:focus, .dd3-content:active {
  color: #262a2e;
  background: #f7f7f7;
}

.dd-dragel > .dd3-item > .dd3-content {
  margin: 0;
}

.dd3-item > button {
  margin-left: 2.625rem;
}

.dd3-handle {
  position: absolute;
  margin: 0;
  left: 0;
  top: 0;
  cursor: grab;
  color: #9e9e9e;
  width: 42px;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  padding: 1.125rem;
  border-color: #d8d8d8;
  border-radius: 0.5rem 0 0 0.5rem;
}
.dd3-handle:before {
  font-family: 'Line Awesome Free';
  font-weight: 900;
  color: #9e9e9e;
  content: "\\f2a1";
  font-size: 1.625rem;
  color: #d8d8d8;
  display: block;
  position: absolute;
  left: 0;
  top: 8px;
  width: 100%;
  text-align: center;
  text-indent: 0;
}

/*Treeview*/
.jstree-default .jstree-clicked,
.jstree-default .jstree-hovered {
  background: none;
  box-shadow: none;
  color: #298DFF;
}

/*Modals*/
.modal-content,
.modal-header,
.modal-footer {
  border-color: #d8d8d8;
}

.modal-content {
  border-radius: 0.5rem;
  overflow: hidden;
  border: none;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
}

.modal-header {
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
  align-items: center;
}
.modal-header.header-wth-bg {
  background: #f7f7f7;
  border-bottom: 0;
}
.modal-header.header-wth-bg-inv {
  background: #0a2f4c;
  border-bottom: 0;
}
.modal-header.header-wth-bg-inv .modal-title {
  color: #fff;
}

.modal-body > .btn-close {
  position: absolute;
  right: 1.5rem;
  top: 1.25rem;
}
.modal-body > .btn-close ~ :is(h1, h2, h3, h4, h5, h6) {
  padding-right: 1.5rem;
  margin-top: 0.5rem;
}

.modal-footer {
  border-bottom-right-radius: calc(0.5rem- 1px);
  border-bottom-left-radius: calc(0.5rem - 1px);
}

.modal-backdrop {
  background-color: #262a2e;
}

body.modal-open {
  padding-right: 0 !important;
}
body.modal-open .hk-navbar {
  padding-right: 1rem !important;
}

/*Close*/
.btn-close {
  color: #262a2e;
  opacity: .6;
  outline: none;
  height: auto;
  width: auto;
  text-shadow: none;
  font: normal normal normal 0/1 'Material-Design-Iconic-Font';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.btn-close:before {
  content: "\\f136";
  font-size: 1rem;
}
.btn-close:focus {
  box-shadow: none;
}
.btn-close:not(:disabled):not(.disabled):not(.btn-close-white):focus, .btn-close:not(:disabled):not(.disabled):not(.btn-close-white):hover {
  color: #6f6f6f;
  opacity: 1;
}
.btn-close span {
  display: none;
}

.close-over .btn-close {
  height: 22px;
  width: 22px;
  background: #6f6f6f;
  color: #fff !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  cursor: pointer;
  position: absolute;
  right: -11px;
  top: -11px;
  opacity: 1;
}
.close-over .btn-close:before {
  content: "\\f136";
  font-size: 1rem;
  line-height: 0;
}
.close-over .btn-close:hover {
  background: #262a2e;
}

/*Sweet-alert*/
.swal2-container .swal2-content {
  color: #6f6f6f;
}
.swal2-container .swal2-title {
  color: #262a2e;
}
.swal2-container .swal2-popup {
  border-radius: 0.5rem;
}
.swal2-container .swal2-popup .swal2-validation-message {
  background: transparent;
  align-items: start;
  border: none;
  color: #FF0000;
}
.swal2-container .swal2-popup .swal2-validation-message:before {
  content: "\\ED77";
  font-family: remixicon !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: transparent;
  color: #FF0000;
  min-width: auto;
}
.swal2-container .swal2-popup .swal2-image {
  border-radius: 2rem;
}
.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step {
  background: #00D67F;
}
.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #298DFF;
}
.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {
  background: #d8d8d8;
}
.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step-line {
  height: .2rem;
  background: #298DFF;
}
.swal2-container .swal2-popup .swal2-close {
  outline: none;
}
.swal2-container .swal2-title {
  font-size: 1.1rem;
}
.swal2-container .swal2-title span {
  display: flex;
}
.swal2-container.swal2-has-header .swal2-popup .swal2-header {
  padding-right: 1rem;
  padding-left: 1rem;
  padding-bottom: 1rem;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #d8d8d8;
}
.swal2-container.swal2-has-footer .swal2-popup.swal2-modal {
  padding-bottom: 0;
}
.swal2-container.swal2-has-footer .swal2-popup.swal2-modal .swal2-footer {
  margin-left: -1rem;
  margin-right: -1rem;
  border-top: 1px solid #d8d8d8;
}
.swal2-container.swal2-has-bg .swal2-popup .swal2-content {
  background: #f7f7f7;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-top: -1rem;
  padding-bottom: 2rem;
  padding-top: 2rem;
}
.swal2-container.swal2-has-bg .swal2-popup .swal2-actions .btn, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .hopscotch-nav-button {
  flex: 1 1;
  border: 0;
  padding: 0;
}
.swal2-container.swal2-has-bg .swal2-popup .swal2-actions .btn:hover, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .hopscotch-nav-button:hover, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .btn:focus, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .hopscotch-nav-button:focus {
  background: transparent;
  color: #9e9e9e;
}

.swal2-shown {
  padding-right: 0 !important;
}

/*Notification*/
.alert {
  color: #262a2e;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
}
.alert .alert-link {
  font-weight: normal;
  color: inherit;
  text-decoration: underline;
}
.alert.alert-dismissible .btn-close {
  padding: 0.9rem 1rem;
  color: inherit;
}
.alert.alert-dismissible .btn-close:before {
  position: relative;
  top: -2px;
}
.alert.alert-dismissible .btn-close:hover {
  opacity: 1;
  color: inherit;
}
.alert.alert-primary {
  color: #0a2f4c;
  background: #ebf5f5;
  border-color: rgba(199, 226, 229, 0.3);
}
.alert.alert-success {
  color: #00D67F;
  background: #ebfcf5;
  border-color: rgba(199, 246, 227, 0.3);
}
.alert.alert-info {
  color: #16c7d7;
  background: #edfcfe;
  border-color: rgba(204, 248, 251, 0.3);
}
.alert.alert-danger {
  color: #FF0000;
  background: #ffebeb;
  border-color: rgba(255, 199, 199, 0.3);
}
.alert.alert-warning {
  color: #cc9d00;
  background: #fffaeb;
  border-color: rgba(255, 242, 199, 0.3);
}
.alert.alert-secondary {
  color: #6f6f6f;
  background: #f3f3f3;
  border-color: rgba(223, 223, 223, 0.3);
}
.alert.alert-light {
  color: #5f5f5f;
  background: #f7f7f7;
  border-color: #eaeaea;
}
.alert.alert-dark {
  color: #fff;
  background: #262a2e;
  border-color: #262a2e;
}
.alert.alert-dark.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-dark.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}
.alert.alert-inv {
  color: #fff;
}
.alert.alert-inv.alert-inv-primary {
  background: #0a2f4c;
  color: #ebf5f5;
}
.alert.alert-inv.alert-inv-primary.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-primary.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}
.alert.alert-inv.alert-inv-info {
  background: #18DDEF;
  color: #edfcfe;
}
.alert.alert-inv.alert-inv-info.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-info.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}
.alert.alert-inv.alert-inv-success {
  background: #00D67F;
  color: #ebfcf5;
}
.alert.alert-inv.alert-inv-success.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-success.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}
.alert.alert-inv.alert-inv-warning {
  background: #FFC400;
  color: #fffaeb;
}
.alert.alert-inv.alert-inv-warning.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-warning.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}
.alert.alert-inv.alert-inv-danger {
  background: #FF0000;
  color: #ffebeb;
}
.alert.alert-inv.alert-inv-danger.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-danger.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}
.alert.alert-inv.alert-inv-secondary {
  background: #6f6f6f;
  color: #f3f3f3;
}
.alert.alert-inv.alert-inv-secondary.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-secondary.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}
.alert.alert-border-primary {
  border-color: #0a2f4c;
  color: #0a2f4c;
}
.alert.alert-border-info {
  border-color: #18DDEF;
  color: #18DDEF;
}
.alert.alert-border-success {
  border-color: #00D67F;
  color: #00D67F;
}
.alert.alert-border-warning {
  border-color: #FFC400;
  color: #FFC400;
}
.alert.alert-border-danger {
  border-color: #FF0000;
  color: #FF0000;
}
.alert.alert-border-secondary {
  border-color: #6f6f6f;
  color: #6f6f6f;
}
.alert.alert-wth-icon {
  padding-left: 3.375rem;
  position: relative;
}
.alert.alert-wth-icon .alert-icon-wrap {
  display: flex;
  font-size: 1.5rem;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 100%;
  width: 54px;
  left: 0;
  top: 0;
  position: absolute;
}
.alert.alert-square {
  border-radius: 0;
}

.alert-dismissible {
  padding-right: 3rem;
}

.jq-toast-wrap {
  width: 300px;
}
.jq-toast-wrap .jq-toast-single {
  color: #262a2e;
  border-radius: 0.5rem;
  margin: 0;
  border: none;
  background: #fff;
  font-size: 0.875rem;
  line-height: 1.3;
}
.jq-toast-wrap .jq-toast-single .jq-toast-loader {
  border-radius: 2px 2px 0 0;
  height: 2px;
}
.jq-toast-wrap .jq-toast-single a {
  color: inherit;
  text-decoration: underline;
  font-weight: inherit;
  border-bottom: none;
  padding-bottom: 0;
  font-size: inherit;
}
.jq-toast-wrap .jq-toast-single .close-jq-toast-single {
  font-size: 1.5rem;
  top: 0;
}
.jq-toast-wrap .jq-toast-single .jq-toast-heading {
  font-size: 1rem !important;
  color: inherit;
  font-weight: 500;
}
.jq-toast-wrap .jq-toast-single.jq-toast-primary {
  background: #ebf5f5;
  color: #0a2f4c;
  border: 1px solid;
  border-color: rgba(199, 226, 229, 0.3);
}
.jq-toast-wrap .jq-toast-single.jq-toast-secondary {
  background: #f3f3f3;
  color: #6f6f6f;
  border: 1px solid;
  border-color: rgba(223, 223, 223, 0.3);
}
.jq-toast-wrap .jq-toast-single.jq-toast-info {
  background: #edfcfe;
  color: #18DDEF;
  border: 1px solid;
  border-color: rgba(204, 248, 251, 0.3);
}
.jq-toast-wrap .jq-toast-single.jq-toast-success {
  background: #ebfcf5;
  color: #00D67F;
  border: 1px solid;
  border-color: rgba(199, 246, 227, 0.3);
}
.jq-toast-wrap .jq-toast-single.jq-toast-warning {
  background: #fffaeb;
  color: #FFC400;
  border: 1px solid;
  border-color: rgba(255, 242, 199, 0.3);
}
.jq-toast-wrap .jq-toast-single.jq-toast-danger {
  background: #ffebeb;
  color: #FF0000;
  border: 1px solid;
  border-color: rgba(255, 199, 199, 0.3);
}
.jq-toast-wrap .jq-toast-single.jq-toast-light {
  background: #f7f7f7;
  color: #5f5f5f;
  border: 1px solid;
  border-color: #d8d8d8;
}
.jq-toast-wrap .jq-toast-single.jq-toast-dark {
  background: #262a2e;
  color: #fff;
  border: 1px solid;
  border-color: #2a2f34;
}
.jq-toast-wrap .jq-toast-single.jq-has-icon {
  padding: .75rem 1.5rem .875rem 2.75rem;
}
.jq-toast-wrap .jq-toast-single.jq-has-icon .jq-toast-icon {
  position: absolute;
  font-size: 1rem;
  left: 11px;
  top: 14px;
}
.jq-toast-wrap .jq-toast-single.jq-toast-inv {
  color: #fff;
  border: none;
  background: #262a2e;
}
.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-primary {
  background: #0a2f4c;
  color: #ebf5f5;
}
.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-danger {
  background: #FF0000;
  color: #ffebeb;
}
.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-warning {
  background: #FFC400;
  color: #fffaeb;
}
.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-info {
  background: #18DDEF;
  color: #edfcfe;
}
.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-success {
  background: #00D67F;
  color: #ebfcf5;
}

.bottom-center-fullwidth .jq-toast-wrap {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  bottom: 0 !important;
}
.bottom-center-fullwidth .jq-toast-wrap .jq-toast-single {
  border-radius: 0;
}

.top-center-fullwidth .jq-toast-wrap {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  top: 2px !important;
}
.top-center-fullwidth .jq-toast-wrap .jq-toast-single {
  border-radius: 0;
}

@media (max-width: 576px) {
  .jq-toast-wrap.top-right, .jq-toast-wrap.top-left, .jq-toast-wrap.bottom-right, .jq-toast-wrap.bottom-left {
    left: 0;
    right: 0;
    width: 100%;
  }
}
/*Toast*/
.toast {
  border: none;
  border-radius: 0.5rem;
}

/*Bootstrap Notify*/
span[data-notify="icon"] {
  position: relative;
  top: 3px;
  line-height: 0;
  font-size: 1rem;
}

/*Tooltop*/
.tooltip {
  font-size: 0.75rem;
  font-family: var(--bs-body-font-family);
}
.tooltip .tooltip-inner {
  background: #262a2e;
  border-radius: 0.5rem;
}
.tooltip.show {
  opacity: 1;
}
.tooltip .tooltip-arrow {
  display: none;
}

@media (max-width: 1024px) {
  .tooltip {
    display: none !important;
  }
}
/*Images*/
.img-thumbnail {
  border-color: #d8d8d8;
  border-radius: 0;
}

.img-background {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

/*Icons*/
.font-icons-wrap li {
  text-align: center;
  vertical-align: middle;
  padding: 1.875rem .625rem 1.875rem .625rem;
  height: 100px;
  width: 100px;
  margin: .625rem;
  min-height: 60px;
  border: solid 1px #eee;
  border-radius: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  cursor: pointer;
}
.font-icons-wrap li a {
  color: #262a2e;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 1.25rem;
}
.font-icons-wrap li a > i {
  font-size: 1.625rem;
  line-height: 20px;
}
.font-icons-wrap li a span {
  display: inline-block;
  position: absolute;
  background-color: #298DFF;
  color: #fff;
  padding: .25rem .5rem;
  font-size: 0.75rem;
  white-space: nowrap;
  top: 45px;
  left: 50%;
  min-width: 98px;
  display: none;
  border-radius: .25rem;
  transform: translateX(-50%);
}
.font-icons-wrap li:hover {
  background: #262a2e;
}
.font-icons-wrap li:hover a {
  color: #fff;
}
.font-icons-wrap li:hover a span {
  display: block;
}

.feather {
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

.svg-icon {
  line-height: 0 !important;
}

.feather-icon {
  line-height: 0 !important;
}
.feather-icon.fe-x > svg {
  height: 16px;
  width: 16px;
}
.feather-icon.fe-2x > svg {
  height: 32px;
  width: 32px;
}

.feather-icon > svg,
.svg-icon > svg {
  height: 1em;
  width: 1em;
}

.flag-icon {
  height: 20px;
  width: 20px;
}

/*Carousel*/
.carousel-control-prev,
.carousel-control-next {
  opacity: 1;
}
.carousel-control-prev:hover .carousel-control-next-icon,
.carousel-control-prev:hover .carousel-control-prev-icon,
.carousel-control-next:hover .carousel-control-next-icon,
.carousel-control-next:hover .carousel-control-prev-icon {
  border-color: white;
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
  height: 50px;
  width: 50px;
  border: 2px solid;
  border-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 1.25rem;
}
.carousel-control-next-icon:before,
.carousel-control-prev-icon:before {
  display: inline-block;
  font: normal normal normal 22px/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  padding-left: .25rem;
  speak: none;
  text-transform: none;
  text-rendering: auto;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.carousel-control-next-icon:before {
  content: "\\f2fb";
}

.carousel-control-prev-icon:before {
  content: "\\f2fa";
}

.custom-carousel-nav .carousel-text-nav {
  position: static;
  color: #262a2e;
}
.custom-carousel-nav .carousel-text-nav:hover, .custom-carousel-nav .carousel-text-nav:focus {
  color: #262a2e;
}
.custom-carousel-nav .carousel-indicators {
  position: static;
}

.carousel-indicators {
  bottom: 20px;
}
.carousel-indicators li[data-bs-target] {
  width: 6px;
  height: 6px;
  margin-right: .25rem;
  margin-left: .25rem;
  border: 1px solid #fff;
  border-radius: 50%;
  background: transparent;
}
.carousel-indicators li[data-bs-target].active {
  background: #b5b5b5;
}
.carousel-indicators.dark-indicators li {
  border-color: #262a2e;
}
.carousel-indicators.dark-indicators li.active {
  background: #2f343a;
}
.carousel-indicators.theme-indicators li {
  border-color: #0a2f4c;
}
.carousel-indicators.theme-indicators li.active {
  background: #007d88;
}

.carousel-caption {
  bottom: 30px;
}

.owl-carousel .item-video {
  height: auto;
}
.owl-carousel .owl-video-tn {
  background-size: cover;
}
.owl-carousel .owl-dots .owl-dot span {
  width: 8px;
  height: 8px;
  margin: 0 .25rem;
  background: transparent;
  border: 1px solid #262a2e;
}
.owl-carousel .owl-dots .owl-dot:focus {
  outline: none;
}
.owl-carousel .owl-dots .owl-dot:hover span {
  background: #262a2e;
}
.owl-carousel .owl-dots .owl-dot.active span {
  background: #262a2e;
}
.owl-carousel.light-owl-dots .owl-dots .owl-dot span {
  border: 1px solid #fff;
}
.owl-carousel.light-owl-dots .owl-dots .owl-dot:focus {
  outline: none;
}
.owl-carousel.light-owl-dots .owl-dots .owl-dot:hover span {
  background: #fff;
}
.owl-carousel.light-owl-dots .owl-dots .owl-dot.active span {
  background: #fff;
}
.owl-carousel.theme-owl-dots .owl-dots .owl-dot span {
  border: 1px solid #0a2f4c;
}
.owl-carousel.theme-owl-dots .owl-dots .owl-dot:focus {
  outline: none;
}
.owl-carousel.theme-owl-dots .owl-dots .owl-dot:hover span {
  background: #0a2f4c;
}
.owl-carousel.theme-owl-dots .owl-dots .owl-dot.active span {
  background: #0a2f4c;
}
.owl-carousel .owl-video-play-icon {
  background: rgba(255, 255, 255, 0.8);
  left: 20px;
  bottom: 20px;
  margin: 0;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #298DFF;
}
.owl-carousel .owl-video-play-icon:before {
  display: inline-block;
  font: normal normal normal 22px/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  padding-left: .25rem;
  speak: none;
  text-transform: none;
  text-rendering: auto;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f3aa";
}
.owl-carousel .owl-video-play-icon:hover {
  transform: scale(1.1, 1.1);
}
.owl-carousel.dots-on-item .owl-dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 15px;
}

@media (max-width: 991px) {
  .carousel-control-next-icon, .carousel-control-prev-icon {
    height: 30px;
    width: 30px;
    font-size: 1rem;
  }
}
/*Twitter slider*/
.twitter-slider-wrap i.fa-twitter {
  font-size: 1.875rem;
  color: #fff;
}
.twitter-slider-wrap .owl-carousel {
  text-align: center;
}
.twitter-slider-wrap .owl-carousel .user, .twitter-slider-wrap .owl-carousel .interact {
  display: none;
}
.twitter-slider-wrap .owl-carousel .tweet {
  font-size: 1rem;
  color: #fff;
  margin-bottom: 1.875rem;
}
.twitter-slider-wrap .owl-carousel .tweet > a {
  color: #fff;
}
.twitter-slider-wrap .owl-carousel .timePosted > a {
  font-size: 0.75rem;
  color: #fff;
}

.product-detail-slider .owl-carousel {
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
}
.product-detail-slider .thumb-wrap {
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-top: 1rem;
}
.product-detail-slider .thumb-wrap > a {
  display: block;
  background-size: cover;
  background-position: center;
  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
  height: 50px;
  width: 100px;
  border-radius: 0.5rem;
  margin: 0 .625rem;
  background-color: #d8d8d8;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}
.product-detail-slider .thumb-wrap > a.active-thumb {
  border: 1px solid #298DFF;
}

/*Color Pickr*/
.form-control-color {
  padding: .375rem;
}

.colorpicker-input-addon {
  padding: 0;
}
.colorpicker-input-addon i {
  height: 100%;
  width: 100%;
}

.pickr .pcr-app {
  z-index: 1035;
}
.pickr .pcr-app .pcr-interaction input {
  padding: .3em .5em;
  letter-spacing: inherit;
  border-radius: .25rem;
  background: #f7f7f7;
  color: #b5b5b5;
}
.pickr .pcr-app .pcr-interaction .pcr-save {
  background: #298DFF;
  color: #fff;
}
.pickr .pcr-app .pcr-interaction .pcr-clear {
  background: #FF0000;
  color: #fff;
}
.pickr .pcr-app .pcr-interaction .pcr-type.active {
  background: #eef6ff;
  color: #298DFF;
}
.pickr .pcr-app .pcr-interaction .pcr-result {
  color: #262a2e;
  border: 1px solid #d8d8d8;
  background: #fff;
  border-radius: 0.5rem;
}
.pickr .pcr-app .pcr-interaction .pcr-result:focus {
  box-shadow: none;
  border-color: #298DFF;
}
.pickr .pcr-button {
  width: 100%;
  border-radius: 0;
}

@media (max-width: 414px) {
  .pcr-app {
    max-width: 310px;
  }
}
/*Range Slider*/
.irs-line {
  height: 7px;
  background: #f7f7f7;
  border: none;
}

.irs-bar {
  height: 7px;
  border: none;
  background: #0a2f4c;
}

.irs-slider {
  top: 24px;
  width: 25px;
  height: 25px;
  border: none;
  background: #0a2f4c;
  border-radius: 50%;
}
.irs-slider.state_hover, .irs-slider:hover {
  background: #0a2f4c;
}

.irs-bar-edge {
  height: 7px;
  top: 33px;
  width: 14px;
  border: none;
  background: #0a2f4c;
}

.irs-from, .irs-to, .irs-single {
  font-size: 0.75rem;
  font-weight: 500;
  background: #262a2e;
  line-height: 1.5;
  padding: .0625rem .5rem;
  border-radius: 0.5rem;
}

.irs-min, .irs-max {
  color: inherit;
  font-size: 0.75rem;
  background: none;
  line-height: 1.5;
  border-radius: .25rem;
  -moz-border-radius: .25rem;
  font-weight: 500;
}

.irs.irs-sm .irs-line {
  height: 3px;
}
.irs.irs-sm .irs-bar {
  height: 3px;
}
.irs.irs-sm .irs-slider {
  top: 25px;
  width: 18px;
  height: 18px;
}
.irs.irs-sm .irs-bar-edge {
  height: 3px;
}

/*Daterangepicker*/
.daterangepicker {
  font-family: inherit;
  border-color: #d8d8d8;
}
.daterangepicker:before, .daterangepicker:after {
  display: none;
}
.daterangepicker .drp-buttons .btn, .daterangepicker .drp-buttons div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .daterangepicker .drp-buttons .hopscotch-nav-button {
  margin-left: .5rem;
  padding: .25rem .5rem;
  font-size: .875rem;
  font-weight: 400;
}
.daterangepicker td.active, .daterangepicker td.active:hover {
  background-color: #0a2f4c;
}
.daterangepicker td.active.available:hover, .daterangepicker td.active:hover.available:hover {
  background-color: #0a2f4c;
}
.daterangepicker td.in-range {
  background-color: #ebf5f5;
  color: #262a2e;
}
.daterangepicker td.in-range.active, .daterangepicker td.in-range.active:hover {
  background-color: #0a2f4c;
}
.daterangepicker td.available:hover {
  background-color: #f7f7f7;
}
.daterangepicker th.available:hover {
  background-color: transparent;
}
.daterangepicker .calendar-table th, .daterangepicker .calendar-table td {
  min-width: 33px;
  width: 33px;
  height: 33px;
  font-size: 0.875rem;
  position: relative;
  border: none;
}
.daterangepicker .calendar-table th.active, .daterangepicker .calendar-table th.active:hover, .daterangepicker .calendar-table td.active, .daterangepicker .calendar-table td.active:hover {
  color: #fff;
}
.daterangepicker .calendar-table th.active.available:hover, .daterangepicker .calendar-table th.active:hover.available:hover, .daterangepicker .calendar-table td.active.available:hover, .daterangepicker .calendar-table td.active:hover.available:hover {
  color: #fff;
}
.daterangepicker .calendar-table th.next span, .daterangepicker .calendar-table th.prev span {
  border-color: #b5b5b5;
}
.daterangepicker .calendar-table th:hover.next span, .daterangepicker .calendar-table th:hover.prev span {
  border-color: #262a2e;
}
.daterangepicker th.month {
  width: auto;
  font-size: 0.875rem;
  color: #262a2e;
  letter-spacing: .5px;
  text-transform: uppercase;
  font-weight: 600;
}
.daterangepicker .drp-selected {
  font-size: 0.875rem;
  padding-right: .25rem;
  color: #262a2e;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {
  color: #d8d8d8;
}
.daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {
  background: #fff;
  width: 60px;
  margin: .625rem auto;
  border: 1px solid #d8d8d8;
  padding: .25rem;
  border-radius: .25rem;
  font-size: 0.875rem;
  color: #262a2e;
}
.daterangepicker select.monthselect, .daterangepicker select.yearselect {
  background: #fff;
  border: 1px solid #d8d8d8;
  padding: .25rem;
  border-radius: .25rem;
  font-size: 0.875rem;
  color: #262a2e;
}
.daterangepicker .ranges li {
  font-size: 0.875rem;
  padding: .625rem .75rem;
}
.daterangepicker .ranges li:hover {
  background-color: #f7f7f7;
}
.daterangepicker .ranges li.active {
  background-color: #0a2f4c;
}
.daterangepicker.show-ranges .drp-calendar.left {
  border-color: #d8d8d8;
}
.daterangepicker .drp-calendar.single .calendar-time {
  padding-right: 8px;
}

@media (max-width: 767px) {
  .daterangepicker {
    width: 281px;
  }
  .daterangepicker.show-ranges .drp-calendar.left {
    border: none;
  }
  .daterangepicker .drp-buttons {
    text-align: left;
  }
  .daterangepicker .drp-buttons .btn, .daterangepicker .drp-buttons div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .daterangepicker .drp-buttons .hopscotch-nav-button {
    margin-left: 0;
    margin-right: .5rem;
  }
  .daterangepicker .drp-buttons .drp-selected {
    display: block;
    margin-bottom: .625rem;
  }
  .daterangepicker.ltr .ranges {
    width: 100%;
  }
  .daterangepicker.ltr .ranges ul {
    width: 100%;
  }
  .daterangepicker.ltr .drp-calendar {
    width: 100%;
  }
  .daterangepicker.ltr .drp-calendar.left .calendar-table {
    padding-right: 0;
  }
}
/*Profile*/
.profile-wrap .profile-intro {
  position: relative;
  z-index: 1;
  margin-top: -6rem;
}
.profile-wrap .profile-img-wrap {
  height: 10rem;
  position: relative;
}
.profile-wrap .profile-img-wrap > img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.profile-wrap header.profile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  background: #fff;
  border-bottom: 1px solid #d8d8d8;
  position: relative;
}
.profile-wrap header.profile-header .profile-options-wrap {
  display: flex;
}
.profile-wrap header.profile-header .profile-options-wrap > a {
  margin-left: .5rem;
  display: inline-block;
}
.profile-wrap header.profile-header .profile-options-wrap > a:first-child {
  margin-left: 0;
}
.profile-wrap .comment-block .media .media-head {
  margin-right: 1rem;
}
.profile-wrap .comment-block .media .media-body > div:first-child {
  display: flex;
  align-items: center;
  margin-bottom: .25rem;
}
.profile-wrap .comment-block .media .media-body > div:first-child .cm-name {
  font-weight: 500;
  color: #262a2e;
}
.profile-wrap .comment-block .media .media-body > div:first-child .badge {
  margin-left: .625rem;
  flex-shrink: 0;
}
.profile-wrap .comment-block .media .media-body .comment-action-wrap span, .profile-wrap .comment-block .media .media-body .comment-action-wrap a {
  color: #6f6f6f;
  font-size: 0.75rem;
}
.profile-wrap .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {
  margin: 0 .25rem;
  color: #d8d8d8;
}
.profile-wrap .comment-block .media .media-body > .media {
  margin-top: 1.875rem;
}
.profile-wrap .comment-block .media .media-head {
  margin-right: 1rem;
}
.profile-wrap .comment-block .media .media-body > div:first-child {
  display: flex;
  align-items: center;
  margin-bottom: .25rem;
}
.profile-wrap .comment-block .media .media-body > div:first-child .cm-name {
  font-weight: 500;
  color: #262a2e;
}
.profile-wrap .comment-block .media .media-body > div:first-child .badge {
  margin-left: .625rem;
  flex-shrink: 0;
}
.profile-wrap .comment-block .media .media-body .comment-action-wrap span, .profile-wrap .comment-block .media .media-body .comment-action-wrap a {
  color: #6f6f6f;
  font-size: 0.75rem;
}
.profile-wrap .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {
  margin: 0 .25rem;
  color: #d8d8d8;
}
.profile-wrap .comment-block .media .media-body > .media {
  margin-top: 1.875rem;
}
.profile-wrap .card.card-profile-feed .btn-pg-link {
  position: absolute;
  bottom: 25px;
  left: 25px;
}
.profile-wrap .card.card-profile-feed .feed-img-layout .row {
  margin-right: -0.25rem;
  margin-left: -0.25rem;
}
.profile-wrap .card.card-profile-feed .feed-img-layout .row > [class*="col-"] {
  padding-right: .25rem;
  padding-left: .25rem;
}
.profile-wrap .card.card-profile-feed .feed-img-layout .feed-img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
}
.profile-wrap .card.card-profile-feed .btn-video-link {
  background: rgba(47, 52, 58, 0.5);
  height: 45px;
  width: 45px;
  position: absolute;
  border-radius: 50%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
}
.profile-wrap .card.card-profile-feed .btn-video-link:before {
  display: inline-block;
  font: normal normal normal 1.5rem/1 'Material-Design-Iconic-Font';
  padding-left: .25rem;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  text-rendering: auto;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f3aa";
}
.profile-wrap .card.card-profile-feed .card-footer > div a {
  display: flex;
  align-items: center;
  color: #9e9e9e;
  font-size: .875rem;
}
.profile-wrap .card.card-profile-feed .card-footer > div a > i {
  line-height: 1;
  margin-right: .5rem;
}
.profile-wrap .card.card-profile-feed .card-footer > div:last-child {
  display: flex;
}
.profile-wrap .card.card-profile-feed .card-footer > div:last-child a {
  margin-right: .625rem;
}
.profile-wrap .card.card-profile-feed .card-footer > div:last-child a:last-child {
  margin-right: 0;
}

.edit-profile-wrap .nav-profile .nav-header {
  font-size: .75rem;
  text-transform: uppercase;
  font-weight: 600;
  color: #9e9e9e;
}
.edit-profile-wrap .nav-profile .nav {
  margin: 1rem 0;
  font-size: .875rem;
  flex-wrap: nowrap;
  border: 0;
}
.edit-profile-wrap .nav-profile .nav .nav-item {
  margin-bottom: .25rem;
}
.edit-profile-wrap .nav-profile .nav .nav-item:last-child {
  margin-bottom: 0;
}
.edit-profile-wrap .nav-profile .nav .nav-item a.nav-link {
  color: #262a2e;
  border: 0;
  padding: 0;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.edit-profile-wrap .nav-profile .nav .nav-item a.nav-link:hover, .edit-profile-wrap .nav-profile .nav .nav-item a.nav-link:focus {
  color: rgba(38, 42, 46, 0.8);
}
.edit-profile-wrap .nav-profile .nav .nav-item a.nav-link .active {
  color: #0a2f4c;
}

/*Activity*/
.activity-list .list-group-item {
  padding: 0;
  border: none;
}
.activity-list .list-group-item .media {
  position: relative;
  align-items: inherit;
}
.activity-list .list-group-item .media .media-head {
  position: relative;
  margin-right: 1rem;
  display: flex;
  flex-flow: column;
  min-width: 48px;
  align-items: center;
}
.activity-list .list-group-item .media .media-head > .avatar {
  flex-shrink: 0;
}
.activity-list .list-group-item .media .media-body {
  padding-bottom: 1.5rem;
}
.activity-list .list-group-item .media .media-body .last-activity-time {
  font-size: 0.75rem;
  margin-top: .25rem;
}
.activity-list .list-group-item.toggle-activity .media .media-body {
  padding-bottom: 0;
  display: flex;
  align-items: center;
}
.activity-list .list-group-item:last-child .media .media-head:after {
  display: none;
}
.activity-list.activity-wth-line .list-group-item .media .media-head:after {
  content: "";
  background: #d8d8d8;
  width: 2.5px;
  height: 100%;
  border-radius: 50rem;
  margin: .5rem auto;
  min-height: 25px;
}

.activity-list-h {
  flex-direction: row;
}
.activity-list-h .list-group-item {
  padding: 0;
  border: none;
  display: flex;
  flex-direction: column;
  padding-bottom: 6.25rem;
  align-items: center;
}
.activity-list-h .list-group-item .media {
  flex-flow: column;
  align-items: center;
  flex: 1 1;
}
.activity-list-h .list-group-item .media .media-body {
  width: 400px;
  padding: 0 .625rem;
  display: flex;
}
.activity-list-h .list-group-item .media .media-body .last-activity-time {
  font-size: 0.75rem;
  margin-top: .25rem;
}
.activity-list-h .list-group-item .media .media-body .card {
  width: 100%;
}
.activity-list-h .list-group-item .media .media-head {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  min-height: 48px;
  align-items: center;
  position: absolute;
  bottom: 45px;
}
.activity-list-h .list-group-item .media .media-head:after, .activity-list-h .list-group-item .media .media-head:before {
  content: "";
  height: 2.5px;
  background: #d8d8d8;
  width: 100%;
  position: absolute;
  margin: .5rem auto;
  right: 0;
  width: 50%;
  top: 0;
  bottom: 0;
  margin: auto 0;
}
.activity-list-h .list-group-item .media .media-head:before {
  left: 0;
}
.activity-list-h .list-group-item .media .media-head .avatar {
  z-index: 1;
  outline: 7px solid #fff;
}
.activity-list-h .list-group-item:first-child .media .media-head:before {
  display: none;
}
.activity-list-h .list-group-item:last-child .media .media-head:after {
  display: none;
}
.activity-list-h .list-group-item .activity-time {
  text-align: center;
  font-size: 0.875rem;
  font-weight: 500;
  padding: .5rem 0;
  color: #0a2f4c;
  text-align: center;
  position: absolute;
  bottom: 0;
}

.user-activity .media {
  position: relative;
  padding-bottom: 1.25rem;
  margin-left: 1.25rem;
}
.user-activity .media .media-head {
  position: absolute;
  left: -20px;
}
.user-activity .media:after {
  content: "";
  position: absolute;
  width: 1px;
  height: calc(100% - 77px);
  background: #d8d8d8;
  top: 60px;
}
.user-activity .media .media-body {
  padding-bottom: 1.875rem;
  margin-left: 2.5rem;
  min-width: 0;
}
.user-activity .media:last-child .media-body {
  border-bottom: none;
}
.user-activity.user-activity-sm .media {
  padding-bottom: .625rem;
  margin-left: 1rem;
}
.user-activity.user-activity-sm .media .media-head {
  left: -16px;
}
.user-activity.user-activity-sm .media .media-body {
  padding-bottom: .625rem;
  margin-left: 1.875rem;
}

@media (max-width: 576px) {
  .user-activity .media .media-body {
    margin-left: 2.125rem;
  }
}
/*Wizards*/
.hk-wizard {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 0.875rem;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  display: flex;
  width: 100%;
  font-size: 0;
  text-align: initial;
}
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] {
  cursor: pointer;
}
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-title .hk-wizard-icon,
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-subtitle .hk-wizard-icon,
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-description .hk-wizard-icon,
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-icon .hk-wizard-icon {
  transition: color 0.3s;
}
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-title,
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-subtitle,
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-description {
  color: #0a2f4c;
}
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active):not(.hk-wizard-item-process) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-icon {
  border-color: #0a2f4c;
}
.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active):not(.hk-wizard-item-process) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-icon .hk-wizard-icon {
  color: #0a2f4c;
}
.hk-wizard:not(.hk-wizard-vertical) .hk-wizard-item-custom .hk-wizard-item-icon {
  width: auto;
  background: 0 0;
}

.hk-wizard-item {
  position: relative;
  display: inline-block;
  flex: 1 1;
  overflow: hidden;
  vertical-align: top;
}
.hk-wizard-item:last-child {
  flex: none;
}
.hk-wizard-item:last-child > .hk-wizard-item-container > .hk-wizard-item-tail {
  display: none;
}
.hk-wizard-item:last-child > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {
  display: none;
}

.hk-wizard-item-container {
  outline: none;
}

.hk-wizard-item-icon {
  display: inline-block;
  vertical-align: top;
  width: 32px;
  height: 32px;
  margin: 0 .5rem 0 0;
  font-size: 1rem;
  line-height: 32px;
  text-align: center;
  border: 1px solid #c7c7c7;
  border-radius: 2rem;
  transition: background-color .3s, border-color .3s;
}
.hk-wizard-item-icon .hk-wizard-icon {
  position: relative;
  top: -.5px;
  color: #0a2f4c;
}

.hk-wizard-item-content {
  display: inline-block;
  vertical-align: top;
}

.hk-wizard-item-tail {
  position: absolute;
  top: 12px;
  left: 0;
  width: 100%;
  padding: 0 .625rem;
}
.hk-wizard-item-tail:after {
  display: inline-block;
  width: 100%;
  height: 1px;
  background: #d8d8d8;
  border-radius: 1px;
  transition: background 0.3s;
  content: "";
}

.hk-wizard-item-title {
  position: relative;
  display: inline-block;
  padding-right: 1rem;
  font-size: 1rem;
  line-height: 32px;
  color: #262a2e;
}
.hk-wizard-item-title:after {
  position: absolute;
  top: 16px;
  left: 100%;
  display: block;
  width: 9999px;
  height: 1px;
  background: #d8d8d8;
  content: "";
}

.hk-wizard-item-subtitle {
  display: inline;
  margin-left: .5rem;
  font-weight: 400;
  font-size: 0.875rem;
}

.hk-wizard-item-description {
  font-size: 0.875rem;
}

.hk-wizard-item-wait > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {
  color: #6f6f6f;
}
.hk-wizard-item-wait .hk-wizard-item-icon {
  background-color: #fff;
  border-color: #c7c7c7;
}
.hk-wizard-item-wait .hk-wizard-item-icon > .hk-wizard-icon {
  color: #c7c7c7;
}
.hk-wizard-item-wait .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {
  background: #c7c7c7;
}
.hk-wizard-item-wait > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {
  background-color: #d8d8d8;
}
.hk-wizard-item-wait > .hk-wizard-item-container > .hk-wizard-item-tail:after {
  background-color: #d8d8d8;
}

.hk-wizard-item-process .hk-wizard-item-icon {
  background-color: #fff;
  border-color: #0a2f4c;
}
.hk-wizard-item-process .hk-wizard-item-icon > .hk-wizard-icon {
  color: #0a2f4c;
}
.hk-wizard-item-process .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {
  background: #0a2f4c;
}
.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {
  color: #262a2e;
}
.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {
  background-color: #d8d8d8;
}
.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-description {
  color: #262a2e;
}
.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-tail:after {
  background-color: #d8d8d8;
}
.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-icon {
  background: #0a2f4c;
}
.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-icon .hk-wizard-icon {
  color: #fff;
}
.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-title {
  font-weight: 500;
}

.hk-wizard-item-finish .hk-wizard-item-icon {
  background-color: #fff;
  border-color: #0a2f4c;
}
.hk-wizard-item-finish .hk-wizard-item-icon > .hk-wizard-icon {
  color: #0a2f4c;
}
.hk-wizard-item-finish .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {
  background: #0a2f4c;
}
.hk-wizard-item-finish > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {
  color: #262a2e;
}
.hk-wizard-item-finish > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {
  background-color: #0a2f4c;
}
.hk-wizard-item-finish > .hk-wizard-item-container > .hk-wizard-item-tail:after {
  background-color: #0a2f4c;
}

.hk-wizard-item-error .hk-wizard-item-icon {
  background-color: #fff;
  border-color: #FF0000;
}
.hk-wizard-item-error .hk-wizard-item-icon > .hk-wizard-icon {
  color: #FF0000;
}
.hk-wizard-item-error .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {
  background: #FF0000;
}
.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {
  color: #FF0000;
}
.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {
  background-color: #d8d8d8;
}
.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-description {
  color: #FF0000;
}
.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-tail:after {
  background-color: #d8d8d8;
}

.hk-wizard-item.hk-wizard-next-error .hk-wizard-item-title:after {
  background: #FF0000;
}

.hk-wizard-item-disabled {
  cursor: not-allowed;
}

.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item {
  padding-left: 1rem;
  white-space: nowrap;
}
.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item:first-child {
  padding-left: 0;
}
.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item:last-child .hk-wizard-item-title {
  padding-right: 0;
}
.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item-tail {
  display: none;
}
.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item-description {
  max-width: 140px;
  white-space: normal;
}

.hk-wizard-item-custom > .hk-wizard-item-container > .hk-wizard-item-icon {
  height: auto;
  background: 0 0;
  border: 0;
}
.hk-wizard-item-custom > .hk-wizard-item-container > .hk-wizard-item-icon > .hk-wizard-icon {
  top: 0;
  left: .5px;
  width: 32px;
  height: 32px;
  font-size: 1.5rem;
  line-height: 32px;
}

.hk-wizard-item-custom.hk-wizard-item-process .hk-wizard-item-icon > .hk-wizard-icon {
  color: #0a2f4c;
}

.hk-wizard-sm.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item {
  padding-left: .75rem;
}
.hk-wizard-sm.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item:first-child {
  padding-left: 0;
}

.hk-wizard-sm .hk-wizard-item-icon {
  width: 24px;
  height: 24px;
  margin: 0 .5rem 0 0;
  font-size: 0.75rem;
  line-height: 24px;
  text-align: center;
  border-radius: 1.5rem;
}
.hk-wizard-sm .hk-wizard-item-title {
  padding-right: .75rem;
  font-size: 0.875rem;
  line-height: 24px;
}
.hk-wizard-sm .hk-wizard-item-title:after {
  top: 12px;
}
.hk-wizard-sm .hk-wizard-item-description {
  font-size: 0.875rem;
}
.hk-wizard-sm .hk-wizard-item-tail {
  top: 8px;
}
.hk-wizard-sm .hk-wizard-item-custom .hk-wizard-item-icon {
  width: inherit;
  height: inherit;
  line-height: inherit;
  background: 0 0;
  border: 0;
  border-radius: 0;
}
.hk-wizard-sm .hk-wizard-item-custom .hk-wizard-item-icon > .hk-wizard-icon {
  font-size: 1.5rem;
  line-height: 24px;
  transform: none;
}

.hk-wizard-vertical {
  display: flex;
  flex-direction: column;
}
.hk-wizard-vertical > .hk-wizard-item {
  display: block;
  flex: 1 0 auto;
  padding-left: 0;
  overflow: visible;
}
.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-icon {
  float: left;
  margin-right: 1rem;
}
.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-content {
  display: block;
  min-height: 48px;
  overflow: hidden;
}
.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-title {
  line-height: 32px;
}
.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-description {
  padding-bottom: .75rem;
}
.hk-wizard-vertical > .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-tail {
  position: absolute;
  top: 0;
  left: 16px;
  width: 1px;
  height: 100%;
  padding: 2.375rem 0 .375rem;
}
.hk-wizard-vertical > .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-tail:after {
  width: 1px;
  height: 100%;
}
.hk-wizard-vertical > .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {
  display: none;
}
.hk-wizard-vertical > .hk-wizard-item:not(:last-child) > .hk-wizard-item-container > .hk-wizard-item-tail {
  display: block;
}

.hk-wizard-vertical.hk-wizard-sm .hk-wizard-item-container .hk-wizard-item-tail {
  position: absolute;
  top: 0;
  left: 12px;
  padding: 1.875rem 0 .375rem;
}
.hk-wizard-vertical.hk-wizard-sm .hk-wizard-item-container .hk-wizard-item-title {
  line-height: 24px;
}

.hk-wizard-label-vertical .hk-wizard-item {
  overflow: visible;
}
.hk-wizard-label-vertical .hk-wizard-item-tail {
  margin-left: 3.625rem;
  padding: .25rem 1.5rem;
}
.hk-wizard-label-vertical .hk-wizard-item-content {
  display: block;
  width: 116px;
  margin-top: .5rem;
  text-align: center;
}
.hk-wizard-label-vertical .hk-wizard-item-icon {
  display: inline-block;
  margin-left: 2.625rem;
}
.hk-wizard-label-vertical .hk-wizard-item-title {
  padding-right: 0;
  padding-left: 0;
}
.hk-wizard-label-vertical .hk-wizard-item-title:after {
  display: none;
}
.hk-wizard-label-vertical .hk-wizard-item-subtitle {
  display: block;
  margin-bottom: 4px;
  margin-left: 0;
  line-height: 1.5715;
}

.hk-wizard-label-vertical.hk-wizard-sm:not(.hk-wizard-dot) .hk-wizard-item-icon {
  margin-left: 2.875rem;
}

.hk-wizard-dot .hk-wizard-item-title {
  line-height: 1.5715;
}
.hk-wizard-dot .hk-wizard-item-tail {
  top: 2px;
  width: 100%;
  margin: 0 0 0 4.375rem;
  padding: 0;
}
.hk-wizard-dot .hk-wizard-item-tail:after {
  width: calc(100% - 20px);
  height: 3px;
  margin-left: .75rem;
}
.hk-wizard-dot .hk-wizard-item:first-child .hk-wizard-icon-dot {
  left: 2px;
}
.hk-wizard-dot .hk-wizard-item-icon {
  width: 8px;
  height: 8px;
  margin-left: 4.25rem;
  padding-right: 0;
  line-height: 8px;
  background: 0 0;
  border: 0;
}
.hk-wizard-dot .hk-wizard-item-icon .hk-wizard-icon-dot {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 6.25rem;
  transition: all .3s;
}
.hk-wizard-dot .hk-wizard-item-icon .hk-wizard-icon-dot:after {
  position: absolute;
  top: -12px;
  left: -26px;
  width: 60px;
  height: 32px;
  content: "";
}
.hk-wizard-dot .hk-wizard-item-content {
  width: 140px;
}
.hk-wizard-dot .hk-wizard-item-process .hk-wizard-item-icon {
  position: relative;
  top: -1px;
  width: 10px;
  height: 10px;
  line-height: 10px;
  background: 0 0;
}
.hk-wizard-dot .hk-wizard-item-process .hk-wizard-icon:first-child .hk-wizard-icon-dot {
  left: 0;
}

.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-title {
  line-height: 1.5715;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-tail {
  top: 2px;
  width: 100%;
  margin: 0 0 0 4.375rem;
  padding: 0;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-tail:after {
  width: calc(100% - 20px);
  height: 3px;
  margin-left: .75rem;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item:first-child .hk-wizard-icon-dot {
  left: 2px;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-icon {
  width: 8px;
  height: 8px;
  margin-left: 4.25rem;
  padding-right: 0;
  line-height: 8px;
  background: 0 0;
  border: 0;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-icon .hk-wizard-icon-dot {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  border-radius: 6.25rem;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-icon .hk-wizard-icon-dot:after {
  position: absolute;
  top: -12px;
  left: -26px;
  width: 60px;
  height: 32px;
  content: "";
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-content {
  width: 140px;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-process .hk-wizard-item-icon {
  position: relative;
  top: -1px;
  width: 10px;
  height: 10px;
  line-height: 10px;
  background: 0 0;
}
.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-process .hk-wizard-icon:first-child .hk-wizard-icon-dot {
  left: 0;
}

.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item-icon {
  margin-top: .75rem;
  margin-left: 0;
  background: 0 0;
}
.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-tail {
  top: 6.5px;
  left: -9px;
  margin: 0;
  padding: 1.375rem 0 .25rem;
}
.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item:first-child .hk-wizard-icon-dot {
  left: 0;
}
.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item-content {
  width: inherit;
}
.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item-process .hk-wizard-item-container .hk-wizard-item-icon .hk-wizard-icon-dot {
  top: -1px;
  left: -1px;
}

/*Pricing Table*/
.hk-pricing-table-1 .table th {
  font-size: 1rem;
  white-space: inherit !important;
}
.hk-pricing-table-1 .table thead tr th h5 {
  padding: .75rem 1.25rem;
  margin: 0 -1.25rem;
  border-bottom: 1px solid #d8d8d8;
}
.hk-pricing-table-1 .table thead tr th.pricing-highlighted h5 {
  background: #0a2f4c;
  color: #fff;
}
.hk-pricing-table-1 .table tbody .monthly-price {
  text-align: center;
}
.hk-pricing-table-1 .table tbody .monthly-price .money {
  display: inline-block;
  vertical-align: top;
  padding-top: 1rem;
}
.hk-pricing-table-1 .table tbody .monthly-price .price sup {
  display: inline-block;
  vertical-align: top;
  padding-top: 1.5rem;
  font-size: 1.125rem;
}
.hk-pricing-table-1 .table tbody .monthly-price .price .price-number {
  font-size: 3.3rem;
  font-weight: 500;
}
.hk-pricing-table-1 .table tbody .monthly-price .duration {
  position: relative;
  top: 10px;
}

.hk-pricing-table-2 .table-responsive {
  padding-top: 3.125rem;
}
.hk-pricing-table-2 .table th {
  font-size: 1rem;
  white-space: inherit !important;
}
.hk-pricing-table-2 .table .pricing-highlighted {
  background: rgba(0, 125, 136, 0.15);
}
.hk-pricing-table-2 .table thead tr th {
  position: relative;
}
.hk-pricing-table-2 .table thead tr th.pricing-highlighted h5 {
  padding: .75rem 1.25rem;
  top: -47px;
  position: absolute;
  border-bottom: 1px solid #d8d8d8;
  background: #0a2f4c;
  color: #fff;
  left: -1px;
  right: -1px;
}
.hk-pricing-table-2 .table tbody .monthly-price {
  text-align: center;
}
.hk-pricing-table-2 .table tbody .monthly-price .money {
  display: inline-block;
  vertical-align: top;
  padding-top: 1rem;
}
.hk-pricing-table-2 .table tbody .monthly-price .price sup {
  display: inline-block;
  vertical-align: top;
  padding-top: 1.5rem;
  font-size: 1.125rem;
}
.hk-pricing-table-2 .table tbody .monthly-price .price .price-number {
  font-size: 3.3rem;
  font-weight: 500;
}
.hk-pricing-table-2 .table tbody .monthly-price .duration {
  position: relative;
  top: 10px;
}

.hk-pricing-table-3 {
  text-align: center;
}
.hk-pricing-table-3 .table-responsive {
  padding-top: 3.125rem;
}
.hk-pricing-table-3 .table th {
  font-size: 1rem;
  white-space: inherit !important;
}
.hk-pricing-table-3 .table th .icon-wrap {
  margin-top: 1.5rem;
  font-size: 2.5rem;
}
.hk-pricing-table-3 .table tbody .monthly-price .money {
  display: inline-block;
  vertical-align: top;
  padding-top: 1rem;
}
.hk-pricing-table-3 .table tbody .monthly-price .price sup {
  display: inline-block;
  vertical-align: top;
  padding-top: 1.5rem;
  font-size: 1.125rem;
}
.hk-pricing-table-3 .table tbody .monthly-price .price .price-number {
  font-size: 2.6rem;
  font-weight: 500;
}
.hk-pricing-table-3 .table tbody .monthly-price .duration {
  display: inline-block;
  vertical-align: top;
  padding-top: 1.125rem;
}

/*Dropdown*/
.dropdown-toggle.no-caret:after {
  display: none;
}
.dropdown-toggle:after {
  content: '\\f2f9';
  font: normal normal normal 1rem/1 'Material-Design-Iconic-Font';
  border: none !important;
  vertical-align: 0 !important;
  margin-left: .4em;
}
.dropdown-toggle.dropdown-toggle-split:after, .dropdown-toggle.dropdown-toggle-split:before {
  margin: 0 !important;
}

.dropup .dropdown-toggle::after {
  content: '\\f2fc';
  margin-left: .4em;
}

.dropstart .dropdown-toggle::before {
  content: '\\f2fa';
  vertical-align: 0 !important;
  font: normal normal normal 1rem/1 'Material-Design-Iconic-Font';
  border: none !important;
  margin-right: .4em;
}
.dropstart .dropdown-toggle::after {
  display: none;
}

.dropend .dropdown-toggle::after {
  content: '\\f2fb';
  vertical-align: 0;
  margin-left: .4em;
}

.btn.btn-lg.dropdown-toggle:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.dropdown-toggle.hopscotch-nav-button:after, .btn.btn-lg.dropdown-toggle:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.dropdown-toggle.hopscotch-nav-button:before, .btn.btn-sm.dropdown-toggle:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .dropdown-toggle.hopscotch-nav-button:after, .btn.btn-sm.dropdown-toggle:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .dropdown-toggle.hopscotch-nav-button:before, .btn.btn-xs.dropdown-toggle:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.dropdown-toggle.hopscotch-nav-button:after, .btn.btn-xs.dropdown-toggle:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.dropdown-toggle.hopscotch-nav-button:before {
  font-size: inherit;
}

.dropdown-menu, .apexcharts-toolbar .apexcharts-menu {
  color: #6f6f6f;
  border: none;
  border-radius: 0.5rem;
  padding: .5rem;
  box-shadow: 0px 6px 16px rgba(47, 52, 58, 0.1);
}
.dropdown-menu .dropdown-item-text, .apexcharts-toolbar .apexcharts-menu .dropdown-item-text {
  color: #6f6f6f;
  padding: .5rem .75rem;
}
.dropdown-menu .dropdown-header, .apexcharts-toolbar .apexcharts-menu .dropdown-header {
  color: #9e9e9e;
  padding: .5rem .75rem;
  font-weight: 500;
}
.dropdown-menu .dropdown-header.dropdown-header-bold, .apexcharts-toolbar .apexcharts-menu .dropdown-header.dropdown-header-bold {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
}
.dropdown-menu .dropdown-header.header-wth-bg, .apexcharts-toolbar .apexcharts-menu .dropdown-header.header-wth-bg {
  background: #262a2e;
  color: #fff;
  margin-top: -.5rem;
  margin-left: -.5rem;
  margin-right: -.5rem;
  margin-bottom: .5rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  padding-top: .8rem;
  padding-bottom: .8rem;
}
.dropdown-menu.dropdown-bordered, .apexcharts-toolbar .dropdown-bordered.apexcharts-menu {
  border: 1px solid #d8d8d8;
  box-shadow: none;
}
.dropdown-menu.dropdown-menu-icon-text .dropdown-item .dropdown-item-text, .apexcharts-toolbar .dropdown-menu-icon-text.apexcharts-menu .dropdown-item .dropdown-item-text {
  padding: 0;
}
.dropdown-menu.dropdown-menu-avatar .dropdown-item, .apexcharts-toolbar .dropdown-menu-avatar.apexcharts-menu .dropdown-item {
  padding-top: .3rem;
  padding-bottom: .3rem;
}
.dropdown-menu.dropdown-menu-avatar .dropdown-item .dropdown-item-text, .apexcharts-toolbar .dropdown-menu-avatar.apexcharts-menu .dropdown-item .dropdown-item-text {
  padding: 0;
}
.dropdown-menu.dropdown-menu-avatar .dropdown-item .avatar, .apexcharts-toolbar .dropdown-menu-avatar.apexcharts-menu .dropdown-item .avatar {
  margin-right: 1rem;
}
.dropdown-menu .dropdown-item, .apexcharts-toolbar .apexcharts-menu .dropdown-item {
  color: #262a2e;
  cursor: pointer;
  border-radius: .25rem;
  padding: .25rem .75rem;
}
.dropdown-menu .dropdown-item .dropdown-icon, .apexcharts-toolbar .apexcharts-menu .dropdown-item .dropdown-icon {
  font-size: 1.125rem;
  margin-right: .625rem;
  width: 21px;
  position: relative;
  top: 2px;
}
.dropdown-menu .dropdown-item .dropdown-icon.feather-icon, .apexcharts-toolbar .apexcharts-menu .dropdown-item .dropdown-icon.feather-icon, .dropdown-menu .dropdown-item .dropdown-icon .svg-icon, .apexcharts-toolbar .apexcharts-menu .dropdown-item .dropdown-icon .svg-icon {
  top: -2px;
}
.dropdown-menu .dropdown-item.active, .apexcharts-toolbar .apexcharts-menu .dropdown-item.active, .dropdown-menu .dropdown-item:active, .apexcharts-toolbar .apexcharts-menu .dropdown-item:active {
  background-color: #0a2f4c;
  color: #fff;
}
.dropdown-menu .dropdown-item:focus:not(.active):not(.disabled), .apexcharts-toolbar .apexcharts-menu .dropdown-item:focus:not(.active):not(.disabled), .dropdown-menu .dropdown-item:hover:not(.active):not(.disabled), .apexcharts-toolbar .apexcharts-menu .dropdown-item:hover:not(.active):not(.disabled) {
  background-color: #f7f7f7;
  color: #262a2e;
}
.dropdown-menu .dropdown-item:disabled, .apexcharts-toolbar .apexcharts-menu .dropdown-item:disabled, .dropdown-menu .dropdown-item.disabled, .apexcharts-toolbar .apexcharts-menu .dropdown-item.disabled {
  color: #b5b5b5;
  background-color: transparent;
}
.dropdown-menu .sub-dropdown-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu {
  position: relative;
}
.dropdown-menu .sub-dropdown-menu .dropdown-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .apexcharts-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .apexcharts-menu {
  top: 0;
}
.dropdown-menu .sub-dropdown-menu .dropdown-menu:before, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu:before, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .apexcharts-menu:before, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .apexcharts-menu:before, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .apexcharts-menu:before, .dropdown-menu .sub-dropdown-menu .dropdown-menu:after, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu:after, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .apexcharts-menu:after, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .apexcharts-menu:after, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .apexcharts-menu:after {
  display: none !important;
}
.dropdown-menu .sub-dropdown-menu .dropdown-menu.open-left-side, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu.open-left-side, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .open-left-side.apexcharts-menu, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .open-left-side.apexcharts-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .open-left-side.apexcharts-menu {
  right: 100% !important;
  left: auto !important;
}
.dropdown-menu .sub-dropdown-menu .dropdown-menu.open-right-side, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu.open-right-side, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .open-right-side.apexcharts-menu, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .open-right-side.apexcharts-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .open-right-side.apexcharts-menu {
  left: 100% !important;
}
.dropdown-menu.dropdown-menu-dark, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu {
  background: #262a2e;
  border-color: #262a2e;
  color: #fff;
}
.dropdown-menu.dropdown-menu-dark .dropdown-header, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-header,
.dropdown-menu.dropdown-menu-dark .dropdown-item-text,
.apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item-text {
  color: #6f6f6f;
}
.dropdown-menu.dropdown-menu-dark .dropdown-item, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item {
  color: #eaeaea;
}
.dropdown-menu.dropdown-menu-dark .dropdown-item:focus:not(.active):not(.disabled), .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:focus:not(.active):not(.disabled), .dropdown-menu.dropdown-menu-dark .dropdown-item:hover:not(.active):not(.disabled), .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:hover:not(.active):not(.disabled) {
  background-color: #4f4f4f;
  color: #fff;
}
.dropdown-menu.dropdown-menu-dark .dropdown-item.active, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item.active, .dropdown-menu.dropdown-menu-dark .dropdown-item:active, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:active {
  color: #fff;
}
.dropdown-menu.dropdown-menu-dark .dropdown-item:disabled, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:disabled, .dropdown-menu.dropdown-menu-dark .dropdown-item.disabled, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item.disabled {
  color: #5f5f5f;
}
.dropdown-menu.dropdown-menu-dark .dropdown-divider, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-divider {
  border-color: #262a2e;
}

.dropdown-menu-active {
  position: absolute; 
  inset: 0px auto auto 0px; 
  margin: 0px; 
  transform: translate(0px, 33px);
}

.dropdown-divider {
  border-color: #eaeaea;
  margin-right: -.5rem;
  margin-left: -.5rem;
}

.show-on-hover:hover > .dropdown-menu, .apexcharts-toolbar .show-on-hover:hover > .apexcharts-menu {
  display: block;
}
.show-on-hover > .dropdown-toggle:active {
  pointer-events: none;
}

.dropdown-menu.animated, .apexcharts-toolbar .animated.apexcharts-menu {
  animation-duration: 0.55s;
  animation-timing-function: ease;
}

.custom-caret svg {
  height: 19px;
  width: 19px;
}

.btn-sm .custom-caret svg, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button .custom-caret svg {
  height: 17px;
  width: 17px;
}

.btn-group-lg > .btn + .dropdown-toggle-split, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-lg > .hopscotch-nav-button + .dropdown-toggle-split,
.btn-lg + .dropdown-toggle-split {
  padding-right: 1.3rem;
  padding-left: 1.3rem;
}

.btn-group-sm > .btn + .dropdown-toggle-split, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-sm > .hopscotch-nav-button + .dropdown-toggle-split,
.btn-sm + .dropdown-toggle-split,
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .dropdown-toggle-split {
  padding-right: .8rem;
  padding-left: .8rem;
}

/*Avatar*/
.avatar {
  position: relative;
  display: inline-block;
  width: 4rem;
  height: 4rem;
  vertical-align: middle;
  background-color: transparent;
}
.avatar .avatar-img,
.avatar .initial-wrap {
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  object-fit: cover;
}
.avatar > .initial-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  font-size: 1.1rem;
  font-weight: 600;
}
.avatar.avatar-rounded .avatar-img,
.avatar.avatar-rounded .initial-wrap {
  border-radius: 50%;
}
.avatar.avatar-square .avatar-img,
.avatar.avatar-square .initial-wrap {
  border-radius: 0;
}
.avatar.avatar-xxxl {
  width: 9rem;
  height: 9rem;
}
.avatar.avatar-xxxl > .initial-wrap {
  font-size: 2.25rem;
}
.avatar.avatar-xxl {
  width: 8rem;
  height: 8rem;
}
.avatar.avatar-xxl > .initial-wrap {
  font-size: 2rem;
}
.avatar.avatar-xl {
  width: 7rem;
  height: 7rem;
}
.avatar.avatar-xl > .initial-wrap {
  font-size: 1.75rem;
}
.avatar.avatar-lg {
  width: 6rem;
  height: 6rem;
}
.avatar.avatar-lg > .initial-wrap {
  font-size: 1.5rem;
}
.avatar.avatar-md {
  width: 5rem;
  height: 5rem;
}
.avatar.avatar-md > .initial-wrap {
  font-size: 1.25rem;
}
.avatar.avatar-sm {
  width: 3rem;
  height: 3rem;
}
.avatar.avatar-sm > .initial-wrap {
  font-size: 1rem;
}
.avatar.avatar-xs {
  width: 2rem;
  height: 2rem;
}
.avatar.avatar-xs > .initial-wrap {
  font-size: 0.75rem;
}
.avatar.avatar-xxs {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar.avatar-xxs > .initial-wrap {
  font-size: 0.6rem;
}
.avatar.avatar-icon > .initial-wrap {
  font-size: 1.5rem;
  font-weight: inherit;
}
.avatar.avatar-icon.avatar-xxxl > .initial-wrap {
  font-size: 2.75rem;
}
.avatar.avatar-icon.avatar-xxl > .initial-wrap {
  font-size: 2.5rem;
}
.avatar.avatar-icon.avatar-xl > .initial-wrap {
  font-size: 2.25rem;
}
.avatar.avatar-icon.avatar-lg > .initial-wrap {
  font-size: 2rem;
}
.avatar.avatar-icon.avatar-md > .initial-wrap {
  font-size: 1.75rem;
}
.avatar.avatar-icon.avatar-sm > .initial-wrap {
  font-size: 1.25rem;
}
.avatar.avatar-icon.avatar-xs > .initial-wrap {
  font-size: 1.25rem;
}
.avatar.avatar-icon.avatar-xxs > .initial-wrap {
  font-size: 1rem;
}
.avatar.avatar-logo > .initial-wrap {
  background: #f7f7f7;
}
.avatar.avatar-logo > .initial-wrap > img {
  height: 50%;
}
.avatar.avatar-cyan > .initial-wrap {
  background-color: #18DDEF !important;
  color: #fff;
}
.avatar.avatar-info > .initial-wrap {
  background-color: #18DDEF !important;
  color: #fff;
}
.avatar.avatar-sky > .initial-wrap {
  background-color: #00B0FF !important;
  color: #fff;
}
.avatar.avatar-green > .initial-wrap {
  background-color: #00D67F !important;
  color: #fff;
}
.avatar.avatar-success > .initial-wrap {
  background-color: #00D67F !important;
  color: #fff;
}
.avatar.avatar-red > .initial-wrap {
  background-color: #FF0000 !important;
  color: #fff;
}
.avatar.avatar-danger > .initial-wrap {
  background-color: #FF0000 !important;
  color: #fff;
}
.avatar.avatar-yellow > .initial-wrap {
  background-color: #FFC400 !important;
  color: #fff;
}
.avatar.avatar-warning > .initial-wrap {
  background-color: #FFC400 !important;
  color: #fff;
}
.avatar.avatar-pink > .initial-wrap {
  background-color: #E92990 !important;
  color: #fff;
}
.avatar.avatar-purple > .initial-wrap {
  background-color: #C02FF3 !important;
  color: #fff;
}
.avatar.avatar-violet > .initial-wrap {
  background-color: #7429F8 !important;
  color: #fff;
}
.avatar.avatar-indigo > .initial-wrap {
  background-color: #0069F7 !important;
  color: #fff;
}
.avatar.avatar-blue > .initial-wrap {
  background-color: #298DFF !important;
  color: #fff;
}
.avatar.avatar-primary > .initial-wrap {
  background-color: #0a2f4c !important;
  color: #fff;
}
.avatar.avatar-teal > .initial-wrap {
  background-color: #0a2f4c !important;
  color: #fff;
}
.avatar.avatar-neon > .initial-wrap {
  background-color: #81E230 !important;
  color: #fff;
}
.avatar.avatar-lime > .initial-wrap {
  background-color: #C2E939 !important;
  color: #fff;
}
.avatar.avatar-sun > .initial-wrap {
  background-color: #FFEA00 !important;
  color: #262a2e;
}
.avatar.avatar-orange > .initial-wrap {
  background-color: #FF9100 !important;
  color: #fff;
}
.avatar.avatar-pumpkin > .initial-wrap {
  background-color: #FF5700 !important;
  color: #fff;
}
.avatar.avatar-brown > .initial-wrap {
  background-color: #954D15 !important;
  color: #fff;
}
.avatar.avatar-gold > .initial-wrap {
  background-color: #C39749 !important;
  color: #fff;
}
.avatar.avatar-dark > .initial-wrap {
  background-color: #262a2e !important;
  color: #fff;
}
.avatar.avatar-light > .initial-wrap {
  background-color: #eaeaea !important;
  color: #262a2e;
}
.avatar.avatar-grey > .initial-wrap {
  background-color: #9e9e9e !important;
  color: #fff;
}
.avatar.avatar-secondary > .initial-wrap {
  background-color: #6f6f6f !important;
  color: #fff;
}
.avatar.avatar-soft-cyan > .initial-wrap {
  background-color: #edfcfe !important;
  color: #18DDEF;
}
.avatar.avatar-soft-info > .initial-wrap {
  background-color: #edfcfe !important;
  color: #18DDEF;
}
.avatar.avatar-soft-sky > .initial-wrap {
  background-color: #ebf9ff !important;
  color: #00B0FF;
}
.avatar.avatar-soft-green > .initial-wrap {
  background-color: #ebfcf5 !important;
  color: #00D67F;
}
.avatar.avatar-soft-success > .initial-wrap {
  background-color: #ebfcf5 !important;
  color: #00D67F;
}
.avatar.avatar-soft-red > .initial-wrap {
  background-color: #ffebeb !important;
  color: #FF0000;
}
.avatar.avatar-soft-danger > .initial-wrap {
  background-color: #ffebeb !important;
  color: #FF0000;
}
.avatar.avatar-soft-yellow > .initial-wrap {
  background-color: #fffaeb !important;
  color: #FFC400;
}
.avatar.avatar-soft-warning > .initial-wrap {
  background-color: #fffaeb !important;
  color: #FFC400;
}
.avatar.avatar-soft-pink > .initial-wrap {
  background-color: #fdeef6 !important;
  color: #E92990;
}
.avatar.avatar-soft-purple > .initial-wrap {
  background-color: #faeefe !important;
  color: #C02FF3;
}
.avatar.avatar-soft-violet > .initial-wrap {
  background-color: #f4eefe !important;
  color: #7429F8;
}
.avatar.avatar-soft-indigo > .initial-wrap {
  background-color: #ebf3fe !important;
  color: #0069F7;
}
.avatar.avatar-soft-blue > .initial-wrap {
  background-color: #eef6ff !important;
  color: #298DFF;
}
.avatar.avatar-soft-primary > .initial-wrap {
  background-color: #ebf5f5 !important;
  color: #0a2f4c;
}
.avatar.avatar-soft-teal > .initial-wrap {
  background-color: #ebf5f5 !important;
  color: #0a2f4c;
}
.avatar.avatar-soft-neon > .initial-wrap {
  background-color: #f5fdee !important;
  color: #81E230;
}
.avatar.avatar-soft-lime > .initial-wrap {
  background-color: #fafdef !important;
  color: #C2E939;
}
.avatar.avatar-soft-sun > .initial-wrap {
  background-color: #fffdeb !important;
  color: #FFEA00;
}
.avatar.avatar-soft-orange > .initial-wrap {
  background-color: #fff6eb !important;
  color: #FF9100;
}
.avatar.avatar-soft-pumpkin > .initial-wrap {
  background-color: #fff2eb !important;
  color: #FF5700;
}
.avatar.avatar-soft-brown > .initial-wrap {
  background-color: #f7f1ec !important;
  color: #954D15;
}
.avatar.avatar-soft-gold > .initial-wrap {
  background-color: #faf7f0 !important;
  color: #C39749;
}
.avatar.avatar-soft-dark > .initial-wrap {
  background-color: #d8d8d8 !important;
  color: #262a2e;
}
.avatar.avatar-soft-light > .initial-wrap {
  background-color: #f7f7f7 !important;
  color: #6f6f6f;
}
.avatar.avatar-soft-grey > .initial-wrap {
  background-color: #f7f7f7 !important;
  color: #9e9e9e;
}
.avatar.avatar-soft-secondary > .initial-wrap {
  background-color: #f3f3f3 !important;
  color: #6f6f6f;
}

.avatar-group {
  display: inline-flex;
}
.avatar-group .avatar {
  width: 2.625rem;
  height: 2.625rem;
}
.avatar-group .avatar .avatar-img,
.avatar-group .avatar > .initial-wrap {
  border: 2px solid #fff;
  font-size: .9rem;
}
.avatar-group.avatar-group-overlapped .avatar {
  margin-right: -.875rem;
}
.avatar-group.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-group.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-group.avatar-group-lg .avatar > .initial-wrap {
  font-size: .95rem;
}
.avatar-group.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-group.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-group.avatar-group-sm .avatar > .initial-wrap {
  font-size: .6rem;
}
.avatar-group.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}

/*Pagination*/
.pagination-wrap {
  display: flex;
  align-items: center;
}

.page-link {
  color: #262a2e;
  border-color: #d8d8d8;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.page-link:focus, .page-link:hover {
  color: #262a2e;
  box-shadow: none;
  background-color: #eaeaea;
  border-color: #d8d8d8;
}

.pagination .page-item.active .page-link {
  background: #0a2f4c;
  border-color: #0a2f4c;
  color: #fff;
}
.pagination .page-item.disabled .page-link {
  color: #b5b5b5;
}
.pagination .page-item:first-child .page-link {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.pagination .page-item:last-child .page-link {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.pagination.custom-pagination .page-item + .page-item {
  padding-left: .5rem;
  margin: 0;
}
.pagination.custom-pagination .page-link {
  padding: .5rem .8rem;
  border-radius: 0.5rem;
}
.pagination.custom-pagination.pagination-rounded .page-link {
  border-radius: 50rem;
}
.pagination.custom-pagination.pagination-rounded .page-item:first-child .page-link,
.pagination.custom-pagination.pagination-rounded .page-item:last-child .page-link {
  border-radius: 50rem;
}
.pagination.custom-pagination.pagination-filled .page-item:not(.active) .page-link {
  background: #f7f7f7;
  border-color: #f7f7f7;
}
.pagination.custom-pagination.pagination-filled .page-item:not(.active):hover .page-link {
  background-color: #eaeaea;
}
.pagination.custom-pagination.pagination-simple .page-item:not(.active) .page-link {
  border-color: transparent;
}
.pagination.pagination-sm .page-link {
  padding: .3rem .6rem;
  min-height: 30px;
  min-width: 30px;
}

/*Badge*/
.badge {
  font-weight: 500;
  border-radius: 0.5rem;
  padding: .5rem .625rem;
  font-size: 70%;
  min-width: 25px;
  letter-spacing: 0.3px;
  vertical-align: middle;
  display: inline-block;
  text-align: center;
  text-transform: capitalize;
}
.badge.badge-indicator {
  width: 10px;
  height: 10px;
  min-width: initial;
  border: 2px solid #fff;
  border-radius: 50%;
  padding: 0;
  position: relative;
}
.badge.badge-indicator:empty {
  display: inline-block;
}
.badge.badge-indicator.badge-indicator-sm {
  width: 7px;
  height: 7px;
}
.badge.badge-indicator.badge-indicator-lg {
  width: 12px;
  height: 12px;
}
.badge.badge-indicator.badge-indicator-xl {
  width: 16px;
  height: 16px;
}
.badge.badge-indicator.badge-indicator-nobdr {
  width: 8px;
  height: 8px;
  border: none;
}
.badge.badge-indicator.badge-indicator-nobdr-sm {
  width: 5px;
  height: 5px;
  border: none;
}
@keyframes ripple {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  to {
    transform: scale(2.4);
    opacity: 0;
  }
}
.badge.badge-indicator.badge-indicator-processing {
  position: relative;
}
.badge.badge-indicator.badge-indicator-processing::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid;
  border-radius: 50%;
  animation: ripple 1.2s infinite ease-in-out;
  content: "";
}
.badge > span {
  display: flex;
  align-items: center;
}
.badge > span .icon {
  display: flex;
  font-size: 0.875rem;
  margin-right: .25rem;
}
.badge > span .badge-dot {
  display: flex;
  font-size: 8px;
  margin-right: .25rem;
}
.badge.badge-sm {
  font-size: 60%;
  padding: .25rem .5rem;
  min-width: 19px;
}
.badge.badge-sm > span .badge-dot {
  font-size: .375rem;
}
.badge.badge-sm > span .icon {
  font-size: 0.75rem;
}
.badge.badge-cyan {
  background: #18DDEF;
  color: #fff;
}
.badge.badge-cyan.badge-indicator-processing:after {
  border-color: #18DDEF;
}
.badge.badge-info {
  background: #18DDEF;
  color: #fff;
}
.badge.badge-info.badge-indicator-processing:after {
  border-color: #18DDEF;
}
.badge.badge-sky {
  background: #00B0FF;
  color: #fff;
}
.badge.badge-sky.badge-indicator-processing:after {
  border-color: #00B0FF;
}
.badge.badge-green {
  background: #00D67F;
  color: #fff;
}
.badge.badge-green.badge-indicator-processing:after {
  border-color: #00D67F;
}
.badge.badge-success {
  background: #00D67F;
  color: #fff;
}
.badge.badge-success.badge-indicator-processing:after {
  border-color: #00D67F;
}
.badge.badge-red {
  background: #FF0000;
  color: #fff;
}
.badge.badge-red.badge-indicator-processing:after {
  border-color: #FF0000;
}
.badge.badge-danger {
  background: #FF0000;
  color: #fff;
}
.badge.badge-danger.badge-indicator-processing:after {
  border-color: #FF0000;
}
.badge.badge-yellow {
  background: #FFC400;
  color: #fff;
}
.badge.badge-yellow.badge-indicator-processing:after {
  border-color: #FFC400;
}
.badge.badge-warning {
  background: #FFC400;
  color: #fff;
}
.badge.badge-warning.badge-indicator-processing:after {
  border-color: #FFC400;
}
.badge.badge-pink {
  background: #E92990;
  color: #fff;
}
.badge.badge-pink.badge-indicator-processing:after {
  border-color: #E92990;
}
.badge.badge-purple {
  background: #C02FF3;
  color: #fff;
}
.badge.badge-purple.badge-indicator-processing:after {
  border-color: #C02FF3;
}
.badge.badge-violet {
  background: #7429F8;
  color: #fff;
}
.badge.badge-violet.badge-indicator-processing:after {
  border-color: #7429F8;
}
.badge.badge-indigo {
  background: #0069F7;
  color: #fff;
}
.badge.badge-indigo.badge-indicator-processing:after {
  border-color: #0069F7;
}
.badge.badge-blue {
  background: #298DFF;
  color: #fff;
}
.badge.badge-blue.badge-indicator-processing:after {
  border-color: #298DFF;
}
.badge.badge-primary {
  background: #4eafcb;
  color: #fff;
}
.badge.badge-primary.badge-indicator-processing:after {
  border-color: #4eafcb;
}
.badge.badge-teal {
  background: #4eafcb;
  color: #fff;
}
.badge.badge-teal.badge-indicator-processing:after {
  border-color: #4eafcb;
}
.badge.badge-neon {
  background: #81E230;
  color: #fff;
}
.badge.badge-neon.badge-indicator-processing:after {
  border-color: #81E230;
}
.badge.badge-lime {
  background: #C2E939;
  color: #fff;
}
.badge.badge-lime.badge-indicator-processing:after {
  border-color: #C2E939;
}
.badge.badge-sun {
  background: #FFEA00;
  color: #262a2e;
}
.badge.badge-sun.badge-indicator-processing:after {
  border-color: #FFEA00;
}
.badge.badge-orange {
  background: #FF9100;
  color: #fff;
}
.badge.badge-orange.badge-indicator-processing:after {
  border-color: #FF9100;
}
.badge.badge-pumpkin {
  background: #FF5700;
  color: #fff;
}
.badge.badge-pumpkin.badge-indicator-processing:after {
  border-color: #FF5700;
}
.badge.badge-smoke {
  background: #5e7d8a;
  color: #fff;
}
.badge.badge-smoke.badge-indicator-processing:after {
  border-color: #5e7d8a;
}
.badge.badge-brown {
  background: #954D15;
  color: #fff;
}
.badge.badge-brown.badge-indicator-processing:after {
  border-color: #954D15;
}
.badge.badge-gold {
  background: #C39749;
  color: #fff;
}
.badge.badge-gold.badge-indicator-processing:after {
  border-color: #C39749;
}
.badge.badge-grey {
  background: #9e9e9e;
  color: #fff;
}
.badge.badge-grey.badge-indicator-processing:after {
  border-color: #9e9e9e;
}
.badge.badge-secondary {
  background: #6f6f6f;
  color: #fff;
}
.badge.badge-secondary.badge-indicator-processing:after {
  border-color: #6f6f6f;
}
.badge.badge-light {
  background: #eaeaea;
  color: #262a2e;
}
.badge.badge-light.badge-indicator-processing:after {
  border-color: #eaeaea;
}
.badge.badge-dark {
  background: #262a2e;
  color: #fff;
}
.badge.badge-dark.badge-indicator-processing:after {
  border-color: #262a2e;
}
.badge.badge-outline {
  background: transparent;
  border: 1px solid;
}
.badge.badge-outline.badge-cyan {
  border-color: #18DDEF;
  color: #18DDEF;
}
.badge.badge-outline.badge-info {
  border-color: #18DDEF;
  color: #18DDEF;
}
.badge.badge-outline.badge-sky {
  border-color: #00B0FF;
  color: #00B0FF;
}
.badge.badge-outline.badge-green {
  border-color: #00D67F;
  color: #00ab66;
}
.badge.badge-outline.badge-success {
  border-color: #00D67F;
  color: #00ab66;
}
.badge.badge-outline.badge-red {
  border-color: #FF0000;
  color: #e60000;
}
.badge.badge-outline.badge-danger {
  border-color: #FF0000;
  color: #e60000;
}
.badge.badge-outline.badge-yellow {
  border-color: #FFC400;
  color: #cc9d00;
}
.badge.badge-outline.badge-warning {
  border-color: #FFC400;
  color: #cc9d00;
}
.badge.badge-outline.badge-grey {
  border-color: #9e9e9e;
  color: #9e9e9e;
}
.badge.badge-outline.badge-secondary {
  border-color: #6f6f6f;
  color: #6f6f6f;
}
.badge.badge-outline.badge-light {
  border-color: #eaeaea;
  color: #262a2e;
}
.badge.badge-outline.badge-dark {
  border-color: #262a2e;
  color: #262a2e;
}
.badge.badge-outline.badge-pink {
  border-color: #E92990;
  color: #E92990;
}
.badge.badge-outline.badge-purple {
  border-color: #C02FF3;
  color: #C02FF3;
}
.badge.badge-outline.badge-violet {
  border-color: #7429F8;
  color: #7429F8;
}
.badge.badge-outline.badge-indigo {
  border-color: #0069F7;
  color: #0069F7;
}
.badge.badge-outline.badge-blue {
  border-color: #298DFF;
  color: #298DFF;
}
.badge.badge-outline.badge-primary {
  border-color: #0a2f4c;
  color: #0a2f4c;
}
.badge.badge-outline.badge-teal {
  border-color: #0a2f4c;
  color: #0a2f4c;
}
.badge.badge-outline.badge-neon {
  border-color: #81E230;
  color: #81E230;
}
.badge.badge-outline.badge-lime {
  border-color: #C2E939;
  color: #C2E939;
}
.badge.badge-outline.badge-sun {
  border-color: #FFEA00;
  color: #FFEA00;
}
.badge.badge-outline.badge-orange {
  border-color: #FF9100;
  color: #FF9100;
}
.badge.badge-outline.badge-pumpkin {
  border-color: #FF5700;
  color: #FF5700;
}
.badge.badge-outline.badge-smoke {
  border-color: #5e7d8a;
  color: #5e7d8a;
}
.badge.badge-outline.badge-brown {
  border-color: #954D15;
  color: #954D15;
}
.badge.badge-outline.badge-gold {
  border-color: #C39749;
  color: #C39749;
}
.badge.badge-soft-cyan {
  background: #edfcfe;
  color: #18DDEF;
}
.badge.badge-soft-cyan.badge-indicator-processing:after {
  border-color: #edfcfe;
}
.badge.badge-soft-info {
  background: #edfcfe;
  color: #18DDEF;
}
.badge.badge-soft-info.badge-indicator-processing:after {
  border-color: #edfcfe;
}
.badge.badge-soft-sky {
  background: #ebf9ff;
  color: #00B0FF;
}
.badge.badge-soft-sky.badge-indicator-processing:after {
  border-color: #ebf9ff;
}
.badge.badge-soft-green {
  background: #ebfcf5;
  color: #00ab66;
}
.badge.badge-soft-green.badge-indicator-processing:after {
  border-color: #ebfcf5;
}
.badge.badge-soft-success {
  background: #ebfcf5;
  color: #00ab66;
}
.badge.badge-soft-success.badge-indicator-processing:after {
  border-color: #ebfcf5;
}
.badge.badge-soft-red {
  background: #ffebeb;
  color: #e60000;
}
.badge.badge-soft-red.badge-indicator-processing:after {
  border-color: #ffebeb;
}
.badge.badge-soft-danger {
  background: #ffebeb;
  color: #e60000;
}
.badge.badge-soft-danger.badge-indicator-processing:after {
  border-color: #ffebeb;
}
.badge.badge-soft-yellow {
  background: #fffaeb;
  color: #cc9d00;
}
.badge.badge-soft-yellow.badge-indicator-processing:after {
  border-color: #fffaeb;
}
.badge.badge-soft-warning {
  background: #fffaeb;
  color: #cc9d00;
}
.badge.badge-soft-warning.badge-indicator-processing:after {
  border-color: #fffaeb;
}
.badge.badge-soft-pink {
  background: #fdeef6;
  color: #E92990;
}
.badge.badge-soft-pink.badge-indicator-processing:after {
  border-color: #fdeef6;
}
.badge.badge-soft-purple {
  background: #faeefe;
  color: #C02FF3;
}
.badge.badge-soft-purple.badge-indicator-processing:after {
  border-color: #faeefe;
}
.badge.badge-soft-violet {
  background: #f4eefe;
  color: #7429F8;
}
.badge.badge-soft-violet.badge-indicator-processing:after {
  border-color: #f4eefe;
}
.badge.badge-soft-indigo {
  background: #ebf3fe;
  color: #0069F7;
}
.badge.badge-soft-indigo.badge-indicator-processing:after {
  border-color: #ebf3fe;
}
.badge.badge-soft-blue {
  background: #eef6ff;
  color: #298DFF;
}
.badge.badge-soft-blue.badge-indicator-processing:after {
  border-color: #eef6ff;
}
.badge.badge-soft-primary {
  background: #ebf5f5;
  color: #0a2f4c;
}
.badge.badge-soft-primary.badge-indicator-processing:after {
  border-color: #ebf5f5;
}
.badge.badge-soft-teal {
  background: #ebf5f5;
  color: #0a2f4c;
}
.badge.badge-soft-teal.badge-indicator-processing:after {
  border-color: #ebf5f5;
}
.badge.badge-soft-neon {
  background: #f5fdee;
  color: #81E230;
}
.badge.badge-soft-neon.badge-indicator-processing:after {
  border-color: #f5fdee;
}
.badge.badge-soft-lime {
  background: #fafdef;
  color: #C2E939;
}
.badge.badge-soft-lime.badge-indicator-processing:after {
  border-color: #fafdef;
}
.badge.badge-soft-sun {
  background: #fffdeb;
  color: #FFEA00;
}
.badge.badge-soft-sun.badge-indicator-processing:after {
  border-color: #fffdeb;
}
.badge.badge-soft-orange {
  background: #fff6eb;
  color: #FF9100;
}
.badge.badge-soft-orange.badge-indicator-processing:after {
  border-color: #fff6eb;
}
.badge.badge-soft-pumpkin {
  background: #fff2eb;
  color: #FF5700;
}
.badge.badge-soft-pumpkin.badge-indicator-processing:after {
  border-color: #fff2eb;
}
.badge.badge-soft-smoke {
  background: #f2f5f6;
  color: #5e7d8a;
}
.badge.badge-soft-smoke.badge-indicator-processing:after {
  border-color: #f2f5f6;
}
.badge.badge-soft-brown {
  background: #f7f1ec;
  color: #954D15;
}
.badge.badge-soft-brown.badge-indicator-processing:after {
  border-color: #f7f1ec;
}
.badge.badge-soft-gold {
  background: #faf7f0;
  color: #C39749;
}
.badge.badge-soft-gold.badge-indicator-processing:after {
  border-color: #faf7f0;
}
.badge.badge-soft-grey {
  background: #f7f7f7;
  color: #9e9e9e;
}
.badge.badge-soft-grey.badge-indicator-processing:after {
  border-color: #f7f7f7;
}
.badge.badge-soft-secondary {
  background: #f3f3f3;
  color: #6f6f6f;
}
.badge.badge-soft-secondary.badge-indicator-processing:after {
  border-color: #f3f3f3;
}
.badge.badge-soft-light {
  background: #f7f7f7;
  color: #6f6f6f;
}
.badge.badge-soft-light.badge-indicator-processing:after {
  border-color: #f7f7f7;
}
.badge.badge-soft-dark {
  background: #d8d8d8;
  color: #262a2e;
}
.badge.badge-soft-dark.badge-indicator-processing:after {
  border-color: #d8d8d8;
}
.badge.badge-pill {
  border-radius: 50rem;
}

a.badge {
  transition: all 0.15s ease;
}
a.badge:hover, a.badge:focus {
  transform: translateY(-3px);
  box-shadow: 0 0.1875rem 0.5rem rgba(47, 52, 58, 0.3) !important;
}
a.badge-sky:hover, a.badge-sky:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(0, 176, 255, 0.3) !important;
}
a.badge-cyan:hover, a.badge-cyan:focus {
  background: #18DDEF;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(24, 221, 239, 0.3) !important;
}
a.badge-info:hover, a.badge-info:focus {
  background: #18DDEF;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(24, 221, 239, 0.3) !important;
}
a.badge-blue:hover, a.badge-blue:focus {
  background: #298DFF;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(41, 141, 255, 0.3) !important;
}
a.badge-primary:hover, a.badge-primary:focus {
  background: #0a2f4c;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(0, 125, 136, 0.3) !important;
}
a.badge-green:hover, a.badge-green:focus {
  background: #00D67F;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(0, 214, 127, 0.3) !important;
}
a.badge-success:hover, a.badge-success:focus {
  background: #00D67F;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(0, 214, 127, 0.3) !important;
}
a.badge-red:hover, a.badge-red:focus {
  background: #FF0000;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(255, 0, 0, 0.3) !important;
}
a.badge-danger:hover, a.badge-danger:focus {
  background: #FF0000;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(255, 0, 0, 0.3) !important;
}
a.badge-yellow:hover, a.badge-yellow:focus {
  background: #FFC400;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(255, 196, 0, 0.3) !important;
}
a.badge-warning:hover, a.badge-warning:focus {
  background: #FFC400;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(255, 196, 0, 0.3) !important;
}
a.badge-grey:hover, a.badge-grey:focus {
  background: #9e9e9e;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(158, 158, 158, 0.3) !important;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  background: #6f6f6f;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(111, 111, 111, 0.3) !important;
}
a.badge-pink:hover, a.badge-pink:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(233, 41, 144, 0.3) !important;
}
a.badge-purple:hover, a.badge-purple:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(192, 47, 243, 0.3) !important;
}
a.badge-violet:hover, a.badge-violet:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(116, 41, 248, 0.3) !important;
}
a.badge-indigo:hover, a.badge-indigo:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(0, 105, 247, 0.3) !important;
}
a.badge-teal:hover, a.badge-teal:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(0, 125, 136, 0.3) !important;
}
a.badge-neon:hover, a.badge-neon:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(129, 226, 48, 0.3) !important;
}
a.badge-lime:hover, a.badge-lime:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(194, 233, 57, 0.3) !important;
}
a.badge-sun:hover, a.badge-sun:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(255, 234, 0, 0.3) !important;
}
a.badge-orange:hover, a.badge-orange:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(255, 145, 0, 0.3) !important;
}
a.badge-pumpkin:hover, a.badge-pumpkin:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(255, 87, 0, 0.3) !important;
}
a.badge-smoke:hover, a.badge-smoke:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(94, 125, 138, 0.3) !important;
}
a.badge-brown:hover, a.badge-brown:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(149, 77, 21, 0.3) !important;
}
a.badge-gold:hover, a.badge-gold:focus {
  box-shadow: 0 0.1875rem 0.5rem rgba(195, 151, 73, 0.3) !important;
}
a.badge-light:hover, a.badge-light:focus {
  background: #eaeaea;
  color: #262a2e;
  box-shadow: 0 0.1875rem 0.5rem #d8d8d8 !important;
}
a.badge-dark:hover, a.badge-dark:focus {
  background: #262a2e;
  color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(38, 42, 46, 0.3) !important;
}
a.badge-outline:hover, a.badge-outline:focus {
  background: transparent;
  box-shadow: none;
}

.badge-status .badge-label {
  margin-left: .25rem;
  font-size: 0.875rem;
}

.badge-on-text .badge {
  position: relative;
  top: -5px;
  right: 0;
}

.badge-on-text-end .badge {
  margin-left: .5rem;
  position: relative;
  top: -1px;
}

/*List Group*/
.list-group-item {
  border-color: #d8d8d8;
}
.list-group-item:first-child {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.list-group-item:last-child {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.list-group-item.active {
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.list-group-item.active h1, .list-group-item.active h2, .list-group-item.active h3, .list-group-item.active h4, .list-group-item.active h5, .list-group-item.active h6 {
  color: #fff;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #b5b5b5;
}
.list-group-item.list-group-item-action:not(.active):focus, .list-group-item.list-group-item-action:not(.active):hover {
  background-color: #f7f7f7;
}
.list-group-item.list-group-item-primary:not(.active) {
  color: #0a2f4c;
  background-color: #ebf5f5;
}
.list-group-item.list-group-item-info:not(.active) {
  color: #18DDEF;
  background-color: #edfcfe;
}
.list-group-item.list-group-item-success:not(.active) {
  color: #00D67F;
  background-color: #ebfcf5;
}
.list-group-item.list-group-item-warning:not(.active) {
  color: #FFC400;
  background-color: #fffaeb;
}
.list-group-item.list-group-item-danger:not(.active) {
  color: #FF0000;
  background-color: #ffebeb;
}
.list-group-item.list-group-item-secondary:not(.active) {
  color: #6f6f6f;
  background-color: #f3f3f3;
}
.list-group-item.list-group-item-light:not(.active) {
  color: #5f5f5f;
  background-color: #f7f7f7;
}
.list-group-item.list-group-item-dark:not(.active) {
  color: #fff;
  background-color: #262a2e;
}
.list-group-item.list-group-inv {
  color: #fff;
}
.list-group-item.list-group-inv.list-group-inv-primary:not(.active) {
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.list-group-item.list-group-inv.list-group-inv-info:not(.active) {
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.list-group-item.list-group-inv.list-group-inv-success:not(.active) {
  background-color: #00D67F;
  border-color: #00D67F;
}
.list-group-item.list-group-inv.list-group-inv-warning:not(.active) {
  background-color: #FFC400;
  border-color: #FFC400;
}
.list-group-item.list-group-inv.list-group-inv-danger:not(.active) {
  background-color: #FF0000;
  border-color: #FF0000;
}
.list-group-item.list-group-inv.list-group-inv-secondary:not(.active) {
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}

.list-group-horizontal-xxl > .list-group-item:first-child,
.list-group-horizontal-xl > .list-group-item:first-child,
.list-group-horizontal-lg > .list-group-item:first-child,
.list-group-horizontal-md > .list-group-item:first-child,
.list-group-horizontal-sm > .list-group-item:first-child,
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.5rem;
}
.list-group-horizontal-xxl > .list-group-item:last-child,
.list-group-horizontal-xl > .list-group-item:last-child,
.list-group-horizontal-lg > .list-group-item:last-child,
.list-group-horizontal-md > .list-group-item:last-child,
.list-group-horizontal-sm > .list-group-item:last-child,
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.5rem;
}

.list-group.active-info .list-group-item.active {
  background-color: #18DDEF;
  border-color: #18DDEF;
}
.list-group.active-success .list-group-item.active {
  background-color: #00D67F;
  border-color: #00D67F;
}
.list-group.active-warning .list-group-item.active {
  background-color: #FFC400;
  border-color: #FFC400;
}
.list-group.active-danger .list-group-item.active {
  background-color: #FF0000;
  border-color: #FF0000;
}
.list-group.active-primary .list-group-item.active {
  background-color: #0a2f4c;
  border-color: #0a2f4c;
}
.list-group.active-secondary .list-group-item.active {
  background-color: #6f6f6f;
  border-color: #6f6f6f;
}

/*Google Map*/
.infowindow-wrap .infowindow-header {
  color: #262a2e;
  padding: 0 5px;
}
.infowindow-wrap .infowindow-body {
  padding: 0 .25rem;
  color: #6f6f6f;
  font-size: 1rem;
}

/*Vecotor Map*/
.jvectormap-zoomin,
.jvectormap-zoomout {
  line-height: 9px;
  background: #262a2e;
  padding: .25rem;
  width: .75rem;
  height: 13px;
  border-radius: 0;
}

.jvectormap-zoomout {
  top: 31px;
}

.jvectormap-goback {
  padding: .15rem .4rem;
  font-size: .75rem;
  background: #0a2f4c;
  border-radius: 0.2rem;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 23px;
}
.jvectormap-legend-cnt-h .jvectormap-legend {
  background: #262a2e;
  padding: .25rem;
  border-radius: .125rem;
}
.jvectormap-legend-cnt-h .jvectormap-legend.jvectormap-legend-icons {
  color: #262a2e;
  background: #fff;
  border: #c7c7c7 1px solid;
}
.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-title {
  font-weight: 500;
  margin-bottom: 0.625rem;
}
.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  width: 55px;
}
.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick .jvectormap-legend-tick-text {
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
  margin-top: .25rem;
}

/*Progressbar*/
.progress {
  border-radius: 0;
}
.progress.progress-bar-rounded {
  border-radius: 50rem;
}
.progress.progress-bar-rounded .progress-bar {
  border-radius: 50rem;
}
.progress.progress-bar-xs {
  height: 5px;
}
.progress.progress-bar-sm {
  height: 9px;
}
.progress.progress-bar-md {
  height: 13px;
}
.progress.progress-bar-lg {
  height: 18px;
}
.progress.progress-bar-xl {
  height: 20px;
}
.progress .progress-bar {
  background-color: #0a2f4c;
}
.progress .progress-bar .progress-tooltip {
  position: absolute;
  right: -20px;
  width: 50px;
  background: #262a2e;
  bottom: 25px;
  border-radius: .3rem;
  padding: .25rem .625rem;
  font-size: 0.75rem;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.progress .progress-bar .progress-tooltip:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  bottom: -10px;
  left: -5px;
  right: 0;
  margin: auto;
  box-sizing: border-box;
  border: 0.6em solid rgba(240, 210, 210, 0.1);
  border-color: transparent transparent #262a2e #262a2e;
  transform-origin: 0 0;
  transform: rotate(-45deg);
}
.progress.progress-width-animated {
  overflow: visible !important;
}
.progress.progress-width-animated .progress-bar {
  overflow: visible !important;
  position: relative;
}

.progress-label {
  text-transform: capitalize;
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: .5rem;
}

.progress-wrap.lb-side-left .progress-lb-wrap {
  display: flex;
  align-items: center;
}
.progress-wrap.lb-side-left .progress-lb-wrap .progress-label {
  display: inline-block;
  padding-right: 1rem;
  flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  margin-bottom: 0;
}
.progress-wrap.lb-side-left .progress-lb-wrap .progress {
  flex: 1 1 100%;
  -ms-flex: 1 1 100%;
  max-width: 100%;
}

/*Togglable*/
.hk-sidebar-togglable {
  height: 25px;
  width: 25px;
  left: -12.5px;
  border-radius: 50%;
  top: 52px;
  position: absolute;
  background: #fff;
  cursor: pointer;
  border: 1px solid #d8d8d8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;
  transition: transform 0.3s ease-in-out;
  z-index: 2;
}
.hk-sidebar-togglable:after {
  content: "\\ea62";
  font-family: remixicon;
  text-rendering: auto;
}
.hk-sidebar-togglable.active {
  transform: translateX(32px);
}
.hk-sidebar-togglable.active:after {
  content: "\\ea6c";
}

/*Advance List*/
.advance-list {
  padding-left: 0;
}
.advance-list > li {
  margin-bottom: 1.25rem;
}
.advance-list > li:last-child {
  margin-bottom: 0;
}

.advance-list-item {
  padding: .5rem 1.25rem;
  min-height: 50px;
  border: 1px solid #d8d8d8;
  border-radius: 0.5rem;
  list-style: none;
  background: #fff;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.advance-list-item:hover {
  transform: scale(1.02, 1.02);
  z-index: 1;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.advance-list-item.drp-open {
  z-index: 4;
}

/*Light Gallery*/
.lg-outer .lg-img-wrap {
  padding: 0;
}

.lg-outer .lg-video .lg-object {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: auto !important;
  height: 100% !important;
}

/*Cropperjs*/
.img-container, .img-preview {
  background-color: #f7f7f7;
  width: 100%;
  text-align: center;
}

.img-container {
  min-height: 200px;
  max-height: 469px;
  margin-bottom: 1rem;
}
.img-container > img {
  max-width: 100%;
}

.docs-preview {
  margin-right: -1rem;
}

.img-preview {
  float: left;
  margin-right: .5rem;
  margin-bottom: .5rem;
  overflow: hidden;
}
.img-preview > img {
  max-width: 100%;
}

.preview-lg {
  width: 255px;
  height: 143px;
}

.preview-md {
  width: 128px;
  height: 72px;
}

.preview-sm {
  width: 72px;
  height: 41px;
}

.preview-xs {
  width: 40px;
  height: 24px;
  margin-right: 0;
}

.docs-data > .input-group {
  margin-bottom: .5rem;
}
.docs-data > .input-group > label {
  min-width: 80px;
}

.docs-buttons > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-buttons > .hopscotch-nav-button, .docs-buttons > .btn-group, .docs-buttons > .form-control, .docs-buttons > .form-select, .wizard > .content > .body .docs-buttons > input, .docs-buttons > .dd-handle {
  margin-right: .25rem;
  margin-bottom: .5rem;
}

.docs-toggles > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-toggles > .hopscotch-nav-button, .docs-toggles > .btn-group, .docs-toggles > .dropdown {
  margin-bottom: .5rem;
}

.docs-tooltip {
  display: block;
  margin: -0.5rem -0.75rem;
  padding: .5rem .75rem;
}

.docs-aspect-ratios, .docs-view-modes {
  width: 100%;
}

.docs-aspect-ratios > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-aspect-ratios > .hopscotch-nav-button {
  width: 20%;
}

.docs-view-modes > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-view-modes > .hopscotch-nav-button {
  width: 25%;
}

.docs-options .dropdown-menu, .docs-options .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .docs-options .apexcharts-menu {
  width: 100%;
}
.docs-options .dropdown-menu > li, .docs-options .apexcharts-toolbar .apexcharts-menu > li, .apexcharts-toolbar .docs-options .apexcharts-menu > li {
  padding: .25rem 1rem;
}
.docs-options .dropdown-menu > li:hover, .docs-options .apexcharts-toolbar .apexcharts-menu > li:hover, .apexcharts-toolbar .docs-options .apexcharts-menu > li:hover {
  background-color: #f7f7f7;
}
.docs-options .dropdown-menu > li > label, .docs-options .apexcharts-toolbar .apexcharts-menu > li > label, .apexcharts-toolbar .docs-options .apexcharts-menu > li > label {
  margin-bottom: 0;
}

.docs-cropped .modal-body {
  text-align: center;
}
.docs-cropped .modal-body > img, .docs-cropped .modal-body > canvas {
  max-width: 100%;
}

.common-credits > li {
  display: block;
  margin-bottom: 1rem;
}
.common-credits > li:last-child {
  margin-bottom: 0;
}

/*Bootstrap TimeOut*/
#session-timeout-dialog .modal-header {
  background: #FF0000;
}
#session-timeout-dialog .modal-header .modal-title {
  color: #fff;
}
#session-timeout-dialog .modal-header button.btn-close {
  color: #fff;
}
#session-timeout-dialog .modal-body p.mb-10 {
  font-size: 1.1rem;
}
#session-timeout-dialog .modal-body .countdown-holder {
  color: #FF0000;
}
#session-timeout-dialog .modal-body .progress {
  margin-top: 1.25rem;
}
#session-timeout-dialog .modal-footer {
  border-top: none;
}

/*Hopscotch*/
div.hopscotch-bubble {
  border: none;
  box-shadow: 0px 4px 16px 0 rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: var(--bs-body-font-family);
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-number {
  display: none;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-content {
  margin: 0;
}
div.hopscotch-bubble .hopscotch-bubble-container h3 {
  color: #262a2e;
  font-family: var(--bs-body-font-family);
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.2;
  margin: -1px 16px 4px 0;
  padding: 0;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-content {
  color: #6f6f6f;
  font-family: var(--bs-body-font-family);
  line-height: inherit;
  margin: .5rem 0;
  font-weight: inherit;
  padding: 0;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions {
  margin: 1.25rem 0 0;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button {
  outline: none;
  background-image: none;
  font-weight: 400;
  margin: 0;
  overflow: visible;
  text-decoration: none !important;
  width: auto;
  height: auto;
  line-height: inherit;
  text-shadow: none;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:hover {
  box-shadow: none !important;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {
  margin-right: .625rem;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-close {
  text-shadow: none;
  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  outline: none;
  color: #262a2e;
  background: transparent;
  webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-indent: inherit;
  width: auto;
  height: auto;
  font-size: 0;
  z-index: 1;
  opacity: .6;
  right: 3px;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-close:before {
  content: "\\f136";
  font-size: 1.125rem;
}
div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-close:hover {
  opacity: 1;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.up {
  top: 2px;
  left: 32px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.down {
  bottom: -32px;
  left: 4px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.down:after {
  transform: rotate(-45deg);
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.right {
  top: 30px;
  right: -32px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.right:after {
  transform: rotate(225deg);
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.left {
  top: 10px;
  left: 2px;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container.left:after {
  transform: rotate(45deg);
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container .hopscotch-bubble-arrow-border,
div.hopscotch-bubble .hopscotch-bubble-arrow-container .hopscotch-bubble-arrow {
  display: none;
}
div.hopscotch-bubble .hopscotch-bubble-arrow-container:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  margin-left: 0;
  top: 0;
  left: 0;
  box-sizing: border-box;
  border: 0.6em solid rgba(0, 0, 0, 0.1);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -2px 2px 16px rgba(0, 0, 0, 0.05);
}
div.hopscotch-bubble.animated {
  animation-fill-mode: both;
  animation-duration: 1s;
}
div.hopscotch-bubble.tour-hopscotch-dark {
  background: #00585f;
}
div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container h3 {
  color: #fff;
}
div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-content {
  color: #fff;
}
div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {
  margin-right: .625rem;
}
div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-bubble-close {
  outline: none;
  color: #fff;
}
div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-arrow-container::after {
  border-color: transparent transparent #00585f #00585f;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
div.hopscotch-bubble.fade-in-up {
  animation-name: fadeInUp;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
div.hopscotch-bubble.fade-in-down {
  animation-name: fadeInDown;
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
div.hopscotch-bubble.fade-in-right {
  animation-name: fadeInRight;
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
div.hopscotch-bubble.fade-in-left {
  animation-name: fadeInLeft;
}

@media (max-width: 1199px) {
  div.hopscotch-bubble {
    display: none;
  }
}
/*Rating*/
.rating .jq-star {
  width: 1rem !important;
  height: 1rem !important;
  display: inline-block;
  line-height: 0;
  cursor: pointer;
  margin-right: .25rem;
}
.rating .jq-star:last-child {
  margin-right: 0;
}
.rating .jq-star polygon[class^="svg-empty"] {
  fill: #eaeaea;
}
.rating .jq-star polygon[class^="svg-hovered"], .rating .jq-star polygon[class^="svg-rated"], .rating .jq-star polygon[class^="svg-active"] {
  fill: #0a2f4c;
}
.rating .jq-star .jq-star-svg {
  width: 100%;
  height: 100%;
}
.rating.rating-yellow .jq-star polygon[class^="svg-hovered"], .rating.rating-yellow .jq-star polygon[class^="svg-rated"], .rating.rating-yellow .jq-star polygon[class^="svg-active"] {
  fill: #FFC400;
}
.rating.rating-progressive[data-rating="1"] .jq-star polygon[class^="svg-rated"], .rating.rating-progressive[data-rating="1"] .jq-star polygon[class^="svg-active"] {
  fill: #FF0000;
}
.rating.rating-progressive[data-rating="2"] .jq-star polygon[class^="svg-rated"], .rating.rating-progressive[data-rating="2"] .jq-star polygon[class^="svg-active"] {
  fill: #ffd23d;
}
.rating.rating-progressive[data-rating="3"] .jq-star polygon[class^="svg-rated"], .rating.rating-progressive[data-rating="3"] .jq-star polygon[class^="svg-active"] {
  fill: #FFC400;
}
.rating.rating-progressive[data-rating="4"] .jq-star polygon[class^="svg-rated"], .rating.rating-progressive[data-rating="4"] .jq-star polygon[class^="svg-active"] {
  fill: #3de09e;
}
.rating.rating-progressive[data-rating="5"] .jq-star polygon[class^="svg-rated"], .rating.rating-progressive[data-rating="5"] .jq-star polygon[class^="svg-active"] {
  fill: #00D67F;
}
.rating.rating-progressive.rating-level-1 .jq-star polygon[class^="svg-hovered"] {
  fill: #FF0000;
}
.rating.rating-progressive.rating-level-2 .jq-star polygon[class^="svg-hovered"] {
  fill: #ffd23d;
}
.rating.rating-progressive.rating-level-3 .jq-star polygon[class^="svg-hovered"] {
  fill: #FFC400;
}
.rating.rating-progressive.rating-level-4 .jq-star polygon[class^="svg-hovered"] {
  fill: #3de09e;
}
.rating.rating-progressive.rating-level-5 .jq-star polygon[class^="svg-hovered"] {
  fill: #00D67F;
}
.rating.rating-lg .jq-star {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.rating.rating-xl .jq-star {
  width: 2rem !important;
  height: 2rem !important;
}

/*Tinyemce*/
.editable {
  outline: none;
}

.tox.tox-tinymce {
  z-index: 11;
}

/*Chips*/
.chip {
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.chip > span {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: .5rem;
  color: #262a2e;
}
.chip .chip-text {
  pointer-events: none;
}
.chip input {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
.chip input + span {
  pointer-events: none;
}
.chip.chip-primary > span {
  background-color: #ebf5f5;
  border: 1px solid #ebf5f5;
  color: #0a2f4c;
}
.chip.chip-primary:hover input + span {
  border-color: #c7e2e5;
  background-color: #c7e2e5;
}
.chip.chip-primary input:checked + span {
  color: #fff;
  border-color: #0a2f4c;
  background-color: #0a2f4c;
}
.chip.chip-secondary > span {
  background-color: #f7f7f7;
  border: 1px solid #f7f7f7;
  color: #262a2e;
}
.chip.chip-secondary:hover input + span {
  border-color: #eaeaea;
  background-color: #eaeaea;
}
.chip.chip-secondary input:checked + span {
  color: #fff;
  border-color: #262a2e;
  background-color: #262a2e;
}
.chip.chip-outline-primary > span {
  background: transparent;
  border: 1px solid #99cbcf;
  color: #0a2f4c;
}
.chip.chip-outline-primary:hover input + span {
  border-color: #0a2f4c;
}
.chip.chip-outline-primary input:checked + span {
  color: #fff;
  border-color: #0a2f4c;
  background-color: #0a2f4c;
}
.chip.chip-outline-secondary > span {
  background: transparent;
  border: 1px solid #b5b5b5;
  color: #262a2e;
}
.chip.chip-outline-secondary:hover input + span {
  border-color: #262a2e;
}
.chip.chip-outline-secondary input:checked + span {
  color: #fff;
  border-color: #262a2e;
  background-color: #262a2e;
}
.chip.chip-wth-icon > span i, .chip.chip-wth-icon > span .feather-icon, .chip.chip-wth-icon > span .svg-icon {
  font-size: 1rem;
  line-height: 1;
  margin-right: 0.5rem;
  display: flex;
}
.chip.chip-wth-icon > span .feather-icon > svg,
.chip.chip-wth-icon > span .svg-icon > svg {
  height: 1em;
  width: 1em;
}
.chip.chip-ticked > span:before {
  font: normal normal normal 0/1 'Material-Design-Iconic-Font';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f26b";
  transition: all 0.15s ease;
}
.chip.chip-ticked > span .chip-text {
  transition: all 0.15s ease;
}
.chip.chip-ticked input:checked + span:before {
  font-size: 1rem;
}
.chip.chip-ticked input:checked + span .chip-text {
  margin-left: 0.5rem;
}
.chip.chip-dismissable .btn-close {
  margin-left: 0.5rem;
  color: inherit !important;
}
.chip.chip-pill > span {
  border-radius: 50rem;
}
.chip.chip-disabled {
  cursor: not-allowed;
}
.chip.chip-disabled input {
  pointer-events: none;
}
.chip.chip-disabled > span {
  border-color: #f7f7f7 !important;
  background-color: #f7f7f7 !important;
  color: #b5b5b5 !important;
}
.chip.chip-disabled > span .btn-close {
  color: #b5b5b5 !important;
  pointer-events: none;
}
.chip.user-chip > span {
  border-radius: 50rem;
}
.chip.user-chip > span .avatar {
  height: 100%;
  width: auto;
  padding: 0.2rem;
  position: absolute;
  left: 0;
}
.chip.user-chip > span .avatar img {
  border-radius: 50%;
}
.chip.user-chip > span .chip-text {
  margin-left: 1.375rem;
}
.chip.chip-lg > span {
  padding: 0.5rem 1rem;
  font-size: 1rem;
}
.chip.chip-lg.chip-wth-icon > span i, .chip.chip-lg.chip-wth-icon > span svg {
  font-size: 1.125rem;
}
.chip.chip-lg.chip-ticked input:checked + span:before {
  font-size: 1.25rem;
}
.chip.chip-lg.user-chip > span .chip-text {
  margin-left: 1.875rem;
}

.tag-input {
  border: none;
  outline: none;
}

.tags-container .hk-chip {
  margin-right: .625rem;
  margin-bottom: .625rem;
}

/*Playlist widget*/
.hk-playlist-wrap .media {
  cursor: pointer;
}
.hk-playlist-wrap .media .media-body .song-name {
  color: #262a2e;
}
.hk-playlist-wrap .media .media-body .palyer-action-wrap .volume-ctrl {
  opacity: 0;
  transition: 0.15 ease-in-out;
}
.hk-playlist-wrap .media.active .media-body .song-name {
  color: #0a2f4c;
}
.hk-playlist-wrap .media.active .media-body .palyer-action-wrap .volume-ctrl {
  opacity: 1;
}

/*Ribbons*/
.hk-ribbon-type-1 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 20px;
  background: #0a2f4c;
  color: #fff;
  padding: .25rem .75rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  min-height: 26px;
  top: 0;
  text-align: center;
  transform: translateY(-50%);
}
.hk-ribbon-type-1 > span {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}
.hk-ribbon-type-1.ribbon-wth-flag:before {
  background-color: transparent;
  top: 0;
  bottom: 0;
  content: "";
  position: absolute;
  border-top: 13px solid #0a2f4c;
  border-bottom: 13px solid #0a2f4c;
  border-right: 13px solid #0a2f4c;
  border-left: 0.6rem solid transparent !important;
  left: -14px;
}
.hk-ribbon-type-1.ribbon-wth-flag:after {
  background-color: transparent;
  border: 13px solid #0a2f4c;
  top: 0;
  bottom: 0;
  content: "";
  position: absolute;
  right: -14px;
  border-top: 13px solid #0a2f4c;
  border-bottom: 13px solid #0a2f4c;
  border-left: 13px solid #0a2f4c;
  border-right: 0.6rem solid transparent !important;
}
.hk-ribbon-type-1.overhead-start {
  left: 14px;
}
.hk-ribbon-type-1.overhead-start.ribbon-wth-flag {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.hk-ribbon-type-1.overhead-start.ribbon-wth-flag:before {
  display: none;
}
.hk-ribbon-type-1.overhead-end {
  right: 14px;
  left: auto;
}
.hk-ribbon-type-1.overhead-end.ribbon-wth-flag {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.hk-ribbon-type-1.overhead-end.ribbon-wth-flag:after {
  display: none;
}
.hk-ribbon-type-1.overhead-center {
  left: 50%;
  transform: translate(-50%, -50%);
  right: auto;
}
.hk-ribbon-type-1.overhead-center.ribbon-wth-flag {
  border-radius: 0;
}
.hk-ribbon-type-1.start-over {
  left: -14px;
  top: 14px;
  transform: none;
}
.hk-ribbon-type-1.start-over.ribbon-wth-flag {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.hk-ribbon-type-1.start-over.ribbon-wth-flag:before {
  display: none;
}
.hk-ribbon-type-1.end-over {
  right: -14px;
  left: auto;
  top: 14px;
  transform: none;
}
.hk-ribbon-type-1.end-over.ribbon-wth-flag {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.hk-ribbon-type-1.end-over.ribbon-wth-flag:after {
  display: none;
}
.hk-ribbon-type-1.start-touch {
  left: 0;
  top: 14px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transform: none;
}
.hk-ribbon-type-1.start-touch.ribbon-wth-flag {
  border-radius: 0;
}
.hk-ribbon-type-1.start-touch.ribbon-wth-flag:before {
  display: none;
}
.hk-ribbon-type-1.end-touch {
  right: 0;
  left: auto;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  top: 14px;
  transform: none;
}
.hk-ribbon-type-1.end-touch.ribbon-wth-flag {
  border-radius: 0;
}
.hk-ribbon-type-1.end-touch.ribbon-wth-flag:after {
  display: none;
}
.hk-ribbon-type-1.ribbon-square {
  border-radius: 0;
}
.hk-ribbon-type-1.ribbon-wth-icon > span > * {
  font-size: 1.125rem;
  margin-right: .25rem;
}
.hk-ribbon-type-1.hk-ribbon-uppercase {
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
}
.hk-ribbon-type-1.hk-ribbon-blue {
  background: #298DFF;
}
.hk-ribbon-type-1.hk-ribbon-blue.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-blue.ribbon-wth-flag:after {
  border-color: #298DFF;
}
.hk-ribbon-type-1.hk-ribbon-primary {
  background: #0a2f4c;
}
.hk-ribbon-type-1.hk-ribbon-primary.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-primary.ribbon-wth-flag:after {
  border-color: #0a2f4c;
}
.hk-ribbon-type-1.hk-ribbon-info {
  background: #18DDEF;
}
.hk-ribbon-type-1.hk-ribbon-info.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-info.ribbon-wth-flag:after {
  border-color: #18DDEF;
}
.hk-ribbon-type-1.hk-ribbon-cyan {
  background: #18DDEF;
}
.hk-ribbon-type-1.hk-ribbon-cyan.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-cyan.ribbon-wth-flag:after {
  border-color: #18DDEF;
}
.hk-ribbon-type-1.hk-ribbon-green {
  background: #00D67F;
}
.hk-ribbon-type-1.hk-ribbon-green.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-green.ribbon-wth-flag:after {
  border-color: #00D67F;
}
.hk-ribbon-type-1.hk-ribbon-success {
  background: #00D67F;
}
.hk-ribbon-type-1.hk-ribbon-success.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-success.ribbon-wth-flag:after {
  border-color: #00D67F;
}
.hk-ribbon-type-1.hk-ribbon-red {
  background: #FF0000;
}
.hk-ribbon-type-1.hk-ribbon-red.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-red.ribbon-wth-flag:after {
  border-color: #FF0000;
}
.hk-ribbon-type-1.hk-ribbon-danger {
  background: #FF0000;
}
.hk-ribbon-type-1.hk-ribbon-danger.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-danger.ribbon-wth-flag:after {
  border-color: #FF0000;
}
.hk-ribbon-type-1.hk-ribbon-yellow {
  background: #FFC400;
}
.hk-ribbon-type-1.hk-ribbon-yellow.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-yellow.ribbon-wth-flag:after {
  border-color: #FFC400;
}
.hk-ribbon-type-1.hk-ribbon-warning {
  background: #FFC400;
}
.hk-ribbon-type-1.hk-ribbon-warning.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-warning.ribbon-wth-flag:after {
  border-color: #FFC400;
}
.hk-ribbon-type-1.hk-ribbon-sky {
  background: #00B0FF;
}
.hk-ribbon-type-1.hk-ribbon-sky.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-sky.ribbon-wth-flag:after {
  border-color: #00B0FF;
}
.hk-ribbon-type-1.hk-ribbon-pink {
  background: #E92990;
}
.hk-ribbon-type-1.hk-ribbon-pink.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-pink.ribbon-wth-flag:after {
  border-color: #E92990;
}
.hk-ribbon-type-1.hk-ribbon-purple {
  background: #C02FF3;
}
.hk-ribbon-type-1.hk-ribbon-purple.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-purple.ribbon-wth-flag:after {
  border-color: #C02FF3;
}
.hk-ribbon-type-1.hk-ribbon-violet {
  background: #7429F8;
}
.hk-ribbon-type-1.hk-ribbon-violet.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-violet.ribbon-wth-flag:after {
  border-color: #7429F8;
}
.hk-ribbon-type-1.hk-ribbon-indigo {
  background: #0069F7;
}
.hk-ribbon-type-1.hk-ribbon-indigo.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-indigo.ribbon-wth-flag:after {
  border-color: #0069F7;
}
.hk-ribbon-type-1.hk-ribbon-teal {
  background: #0a2f4c;
}
.hk-ribbon-type-1.hk-ribbon-teal.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-teal.ribbon-wth-flag:after {
  border-color: #0a2f4c;
}
.hk-ribbon-type-1.hk-ribbon-neon {
  background: #81E230;
}
.hk-ribbon-type-1.hk-ribbon-neon.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-neon.ribbon-wth-flag:after {
  border-color: #81E230;
}
.hk-ribbon-type-1.hk-ribbon-lime {
  background: #C2E939;
}
.hk-ribbon-type-1.hk-ribbon-lime.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-lime.ribbon-wth-flag:after {
  border-color: #C2E939;
}
.hk-ribbon-type-1.hk-ribbon-sun {
  color: #262a2e;
  background: #FFEA00;
}
.hk-ribbon-type-1.hk-ribbon-sun.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-sun.ribbon-wth-flag:after {
  border-color: #FFEA00;
}
.hk-ribbon-type-1.hk-ribbon-orange {
  background: #FF9100;
}
.hk-ribbon-type-1.hk-ribbon-orange.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-orange.ribbon-wth-flag:after {
  border-color: #FF9100;
}
.hk-ribbon-type-1.hk-ribbon-pumpkin {
  background: #FF5700;
}
.hk-ribbon-type-1.hk-ribbon-pumpkin.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-pumpkin.ribbon-wth-flag:after {
  border-color: #FF5700;
}
.hk-ribbon-type-1.hk-ribbon-brown {
  background: #954D15;
}
.hk-ribbon-type-1.hk-ribbon-brown.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-brown.ribbon-wth-flag:after {
  border-color: #954D15;
}
.hk-ribbon-type-1.hk-ribbon-gold {
  background: #C39749;
}
.hk-ribbon-type-1.hk-ribbon-gold.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-gold.ribbon-wth-flag:after {
  border-color: #C39749;
}
.hk-ribbon-type-1.hk-ribbon-smoke {
  background: #5e7d8a;
}
.hk-ribbon-type-1.hk-ribbon-smoke.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-smoke.ribbon-wth-flag:after {
  border-color: #5e7d8a;
}
.hk-ribbon-type-1.hk-ribbon-grey {
  background: #9e9e9e;
}
.hk-ribbon-type-1.hk-ribbon-grey.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-grey.ribbon-wth-flag:after {
  border-color: #9e9e9e;
}
.hk-ribbon-type-1.hk-ribbon-secondary {
  background: #6f6f6f;
}
.hk-ribbon-type-1.hk-ribbon-secondary.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-secondary.ribbon-wth-flag:after {
  border-color: #6f6f6f;
}
.hk-ribbon-type-1.hk-ribbon-light {
  background: #eaeaea;
  color: #262a2e;
}
.hk-ribbon-type-1.hk-ribbon-light.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-light.ribbon-wth-flag:after {
  border-color: #eaeaea;
}
.hk-ribbon-type-1.hk-ribbon-dark {
  background: #262a2e;
}
.hk-ribbon-type-1.hk-ribbon-dark.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-dark.ribbon-wth-flag:after {
  border-color: #262a2e;
}

.hk-ribbon-type-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 20px;
  background: #0a2f4c;
  color: #fff;
  padding: .25rem .5rem;
  font-size: 1.125rem;
  font-weight: 500;
  top: -8px;
  height: 39px;
  width: 34px;
  text-align: center;
}
.hk-ribbon-type-2 > span {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  font-size: 1.25rem;
}
.hk-ribbon-type-2:after {
  background-color: transparent;
  border-top: 17px solid #0a2f4c;
  border-right: 17px solid #0a2f4c;
  border-left: 17px solid #0a2f4c;
  border-bottom: 0.6rem solid transparent !important;
  bottom: -10px;
  content: "";
  position: absolute;
  left: 0;
  right: 0;
}
.hk-ribbon-type-2.overhead-start {
  left: 20px;
}
.hk-ribbon-type-2.overhead-end {
  right: 20px;
  left: auto;
}
.hk-ribbon-type-2.overhead-center {
  left: 50%;
  transform: translate(-50%, 0);
  right: auto;
}
.hk-ribbon-type-2.top-touch {
  transform: none;
  top: 0;
}
.hk-ribbon-type-2.top-touch.overhead-center {
  transform: translate(-50%, 0);
}
.hk-ribbon-type-2.hk-ribbon-blue {
  background: #298DFF;
}
.hk-ribbon-type-2.hk-ribbon-blue:after {
  border-color: #298DFF;
}
.hk-ribbon-type-2.hk-ribbon-primary {
  background: #0a2f4c;
}
.hk-ribbon-type-2.hk-ribbon-primary:after {
  border-color: #0a2f4c;
}
.hk-ribbon-type-2.hk-ribbon-cyan {
  background: #18DDEF;
}
.hk-ribbon-type-2.hk-ribbon-cyan:before, .hk-ribbon-type-2.hk-ribbon-cyan:after {
  border-color: #18DDEF;
}
.hk-ribbon-type-2.hk-ribbon-info {
  background: #18DDEF;
}
.hk-ribbon-type-2.hk-ribbon-info:before, .hk-ribbon-type-2.hk-ribbon-info:after {
  border-color: #18DDEF;
}
.hk-ribbon-type-2.hk-ribbon-green {
  background: #00D67F;
}
.hk-ribbon-type-2.hk-ribbon-green:before, .hk-ribbon-type-2.hk-ribbon-green:after {
  border-color: #00D67F;
}
.hk-ribbon-type-2.hk-ribbon-success {
  background: #00D67F;
}
.hk-ribbon-type-2.hk-ribbon-success:before, .hk-ribbon-type-2.hk-ribbon-success:after {
  border-color: #00D67F;
}
.hk-ribbon-type-2.hk-ribbon-red {
  background: #FF0000;
}
.hk-ribbon-type-2.hk-ribbon-red:before, .hk-ribbon-type-2.hk-ribbon-red:after {
  border-color: #FF0000;
}
.hk-ribbon-type-2.hk-ribbon-danger {
  background: #FF0000;
}
.hk-ribbon-type-2.hk-ribbon-danger:before, .hk-ribbon-type-2.hk-ribbon-danger:after {
  border-color: #FF0000;
}
.hk-ribbon-type-2.hk-ribbon-yellow {
  background: #FFC400;
}
.hk-ribbon-type-2.hk-ribbon-yellow:before, .hk-ribbon-type-2.hk-ribbon-yellow:after {
  border-color: #FFC400;
}
.hk-ribbon-type-2.hk-ribbon-warning {
  background: #FFC400;
}
.hk-ribbon-type-2.hk-ribbon-warning:before, .hk-ribbon-type-2.hk-ribbon-warning:after {
  border-color: #FFC400;
}
.hk-ribbon-type-2.hk-ribbon-sky {
  background: #00B0FF;
}
.hk-ribbon-type-2.hk-ribbon-sky:before, .hk-ribbon-type-2.hk-ribbon-sky:after {
  border-color: #00B0FF;
}
.hk-ribbon-type-2.hk-ribbon-pink {
  background: #E92990;
}
.hk-ribbon-type-2.hk-ribbon-pink:before, .hk-ribbon-type-2.hk-ribbon-pink:after {
  border-color: #E92990;
}
.hk-ribbon-type-2.hk-ribbon-purple {
  background: #C02FF3;
}
.hk-ribbon-type-2.hk-ribbon-purple:before, .hk-ribbon-type-2.hk-ribbon-purple:after {
  border-color: #C02FF3;
}
.hk-ribbon-type-2.hk-ribbon-violet {
  background: #7429F8;
}
.hk-ribbon-type-2.hk-ribbon-violet:before, .hk-ribbon-type-2.hk-ribbon-violet:after {
  border-color: #7429F8;
}
.hk-ribbon-type-2.hk-ribbon-indigo {
  background: #0069F7;
}
.hk-ribbon-type-2.hk-ribbon-indigo:before, .hk-ribbon-type-2.hk-ribbon-indigo:after {
  border-color: #0069F7;
}
.hk-ribbon-type-2.hk-ribbon-teal {
  background: #0a2f4c;
}
.hk-ribbon-type-2.hk-ribbon-teal:before, .hk-ribbon-type-2.hk-ribbon-teal:after {
  border-color: #0a2f4c;
}
.hk-ribbon-type-2.hk-ribbon-neon {
  background: #81E230;
}
.hk-ribbon-type-2.hk-ribbon-neon:before, .hk-ribbon-type-2.hk-ribbon-neon:after {
  border-color: #81E230;
}
.hk-ribbon-type-2.hk-ribbon-lime {
  background: #C2E939;
}
.hk-ribbon-type-2.hk-ribbon-lime:before, .hk-ribbon-type-2.hk-ribbon-lime:after {
  border-color: #C2E939;
}
.hk-ribbon-type-2.hk-ribbon-sun {
  background: #FFEA00;
  color: #262a2e;
}
.hk-ribbon-type-2.hk-ribbon-sun:before, .hk-ribbon-type-2.hk-ribbon-sun:after {
  border-color: #FFEA00;
}
.hk-ribbon-type-2.hk-ribbon-orange {
  background: #FF9100;
}
.hk-ribbon-type-2.hk-ribbon-orange:before, .hk-ribbon-type-2.hk-ribbon-orange:after {
  border-color: #FF9100;
}
.hk-ribbon-type-2.hk-ribbon-pumpkin {
  background: #FF5700;
}
.hk-ribbon-type-2.hk-ribbon-pumpkin:before, .hk-ribbon-type-2.hk-ribbon-pumpkin:after {
  border-color: #FF5700;
}
.hk-ribbon-type-2.hk-ribbon-brown {
  background: #954D15;
}
.hk-ribbon-type-2.hk-ribbon-brown:before, .hk-ribbon-type-2.hk-ribbon-brown:after {
  border-color: #954D15;
}
.hk-ribbon-type-2.hk-ribbon-gold {
  background: #C39749;
}
.hk-ribbon-type-2.hk-ribbon-gold:before, .hk-ribbon-type-2.hk-ribbon-gold:after {
  border-color: #C39749;
}
.hk-ribbon-type-2.hk-ribbon-smoke {
  background: #5e7d8a;
}
.hk-ribbon-type-2.hk-ribbon-smoke:before, .hk-ribbon-type-2.hk-ribbon-smoke:after {
  border-color: #5e7d8a;
}
.hk-ribbon-type-2.hk-ribbon-grey {
  background: #9e9e9e;
}
.hk-ribbon-type-2.hk-ribbon-grey:before, .hk-ribbon-type-2.hk-ribbon-grey:after {
  border-color: #9e9e9e;
}
.hk-ribbon-type-2.hk-ribbon-secondary {
  background: #6f6f6f;
}
.hk-ribbon-type-2.hk-ribbon-secondary:before, .hk-ribbon-type-2.hk-ribbon-secondary:after {
  border-color: #6f6f6f;
}
.hk-ribbon-type-2.hk-ribbon-light {
  background: #eaeaea;
  color: #262a2e;
}
.hk-ribbon-type-2.hk-ribbon-light:before, .hk-ribbon-type-2.hk-ribbon-light:after {
  border-color: #eaeaea;
}
.hk-ribbon-type-2.hk-ribbon-dark {
  background: #262a2e;
}
.hk-ribbon-type-2.hk-ribbon-dark:before, .hk-ribbon-type-2.hk-ribbon-dark:after {
  border-color: #262a2e;
}

/*Advance Badges*/
.badge-icon {
  width: 4rem;
  height: 4.313rem;
  font-size: 2.25rem;
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.badge-icon > svg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}
.badge-icon .badge-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 100%;
  width: 100%;
  color: #fff;
  position: relative;
  z-index: 1;
}
.badge-icon.badge-icon-lg {
  width: 6rem;
  height: 6.031rem;
  font-size: 3.25rem;
}
.badge-icon.badge-icon-md {
  width: 5rem;
  height: 5.031rem;
  font-size: 2.75rem;
}
.badge-icon.badge-icon-sm {
  width: 3rem;
  height: 3.313rem;
  font-size: 1.75rem;
}
.badge-icon.badge-icon-xs {
  width: 2rem;
  height: 2.313rem;
  font-size: 1.25rem;
}
.badge-icon.badge-icon-xxs {
  width: 1.5rem;
  height: 1.813rem;
  font-size: 1rem;
}
.badge-icon.badge-circle {
  height: 4rem;
}
.badge-icon.badge-circle.badge-icon-lg {
  height: 6rem;
}
.badge-icon.badge-circle.badge-icon-md {
  height: 5rem;
}
.badge-icon.badge-circle.badge-icon-sm {
  height: 3rem;
}
.badge-icon.badge-circle.badge-icon-xs {
  height: 2rem;
}
.badge-icon.badge-circle.badge-icon-xxs {
  height: 1.5rem;
}
.badge-icon.badge-level {
  position: relative;
}
.badge-icon.badge-level > span {
  position: absolute;
  bottom: 0;
  right: 16%;
  z-index: 1;
  font-weight: 600;
  color: inherit;
  font-size: 40%;
  background: transparent;
}
.badge-icon.badge-level > span:before {
  content: attr(title);
  position: absolute;
  -webkit-text-stroke: 4px #fff;
  left: 0;
  z-index: -1;
}

.avatar.custom-badge-on-avatar .badge-icon {
  font-size: inherit;
}

/*Callout*/
.callout {
  margin-bottom: 0;
}
.callout.callout-floating {
  position: fixed;
  width: 300px;
  z-index: 1055;
  margin-bottom: 0;
}
.callout.callout-floating.top-end {
  top: 25px;
  right: 25px;
}
.callout.callout-floating.bottom-end {
  bottom: 25px;
  right: 25px;
}
.callout.callout-floating.top-start {
  top: 25px;
  left: 25px;
}
.callout.callout-floating.bottom-start {
  bottom: 25px;
  left: 25px;
}
.callout.callout-floating.top-center {
  top: 25px;
  left: 50%;
  width: auto;
  transform: translateX(-50%);
}
.callout.callout-floating.bottom-center {
  bottom: 25px;
  left: 50%;
  width: auto;
  transform: translateX(-50%);
}
.callout.callout-dark {
  color: #fff;
}
.callout.callout-dark h1, .callout.callout-dark h2, .callout.callout-dark h3, .callout.callout-dark h4, .callout.callout-dark h5, .callout.callout-dark h6, .callout.callout-dark p {
  color: inherit;
}

/*Toolbar*/
.hk-toolbar .nav {
  align-items: center;
  justify-content: space-around;
  height: 100%;
}
.hk-toolbar .nav .nav-item {
  height: 100%;
}
.hk-toolbar.toolbar-asymmetric {
  display: flex;
  justify-content: space-between;
}

/*Filter Component*/
.btn-filter {
  color: #6f6f6f;
  background-color: transparent;
  background-image: none;
  border-color: #f7f7f7;
}
.btn-filter:hover, .btn-filter:focus {
  color: #6f6f6f;
  background-color: transparent;
  background-image: none;
  border-color: #f7f7f7;
}
.btn-filter.active {
  color: #0a2f4c;
  background-color: #ebf5f5;
  border-color: #0a2f4c;
  box-shadow: none !important;
}
.btn-filter.active:hover, .btn-filter.active:focus {
  color: #0a2f4c;
  background-color: #ebf5f5;
  border-color: #0a2f4c;
}

.filter-block-wrap .filter-block.card .card-img {
  object-fit: cover;
}
.filter-block-wrap .filter-block.card .card-img-overlay {
  background-color: rgba(38, 42, 46, var(--bs-bg-opacity));
}
.filter-block-wrap .filter-block.card input {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.filter-block-wrap .filter-block.card input:checked ~ .card-img-overlay {
  background-color: rgba(41, 141, 255, var(--bs-bg-opacity));
}

/*Content sidebar*/
[data-content-sidebar="active"].hk-wrapper .hk-pg-wrapper {
  margin-right: 17.5rem;
}
[data-content-sidebar="active"].hk-wrapper .hk-content-sidebar {
  position: fixed;
  top: 64px;
  overflow-y: auto;
  width: 280px;
  right: 0;
  z-index: 2;
  background: #fff;
  padding-top: 1.5rem;
  border-left: 1px solid #d8d8d8;
  bottom: 0;
}
[data-content-sidebar="active"].hk-wrapper .hk-content-sidebar .sidebar-content-wrap {
  padding: 1.25rem;
}

/*Fixed Footer*/
.hk-fixed-footer {
  position: fixed;
  bottom: 0;
  z-index: 1032;
  background: #fff;
  box-shadow: 1px 1px 3px 5px rgba(0, 0, 0, 0.1);
  right: 0;
  left: 0;
}

.hk-wrapper.fixed-footer-active .hk-pg-wrapper {
  padding-bottom: 8.125rem;
}

/*Dragula*/
.gu-mirror {
  cursor: grabbing;
  position: fixed !important;
  margin: 0 !important;
  z-index: 9999 !important;
  opacity: 1;
}

.dragula-demo .dragula-block {
  border: 1px dotted #b5b5b5;
  border-radius: .25rem;
  padding: .625rem;
}
.dragula-demo .dragula-block > div {
  border: 1px solid #d8d8d8;
  border-radius: .25rem;
  margin: .625rem;
  padding: .625rem;
  cursor: move;
}

/*Authantication Pages*/
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .hk-pg-body .auth-content {
  min-height: calc(100vh - 249px);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .v-separator {
  margin: 0;
  position: relative;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .v-separator:after {
  height: 100%;
  right: 0;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .v-separator.separator-sm:after {
  height: 70%;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split {
  min-height: 100vh;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content mark {
  z-index: 1;
  color: #262a2e;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content mark:after {
  z-index: -1;
  background: #00D67F;
  opacity: 1;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link {
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .feather-icon, .hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .svg-icon {
  margin-right: .25rem;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .feather-icon svg, .hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .svg-icon svg {
  height: 14px;
  width: 14px;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .credit-text {
  position: absolute;
  left: 30px;
  bottom: 30px;
  mix-blend-mode: inherit;
}
.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .bg-img {
  position: absolute;
  left: 0;
  top: 0;
  max-width: 100%;
  object-fit: cover;
  height: 100%;
  z-index: -1;
}

@media (max-width: 767px) {
  .hk-wrapper.hk-pg-auth .hk-pg-wrapper .hk-pg-body .container-xxl .auth-content {
    min-height: auto;
    align-items: flex-start;
  }
  .hk-wrapper.hk-pg-auth .v-separator:after {
    display: none;
  }
}
/****************************/
/** Componets Import **/
/****************************/
/*------------------------------------------------------------------
[Header]
Project:	Jampack
-------------------------------------------------------------------*/
/*Top Nav*/
.hk-wrapper .hk-navbar {
  border-bottom: 1px solid #eaeaea;
  height: 65px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown .dropdown-menu, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown .apexcharts-menu {
  position: absolute;
  right:10px;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu {
  width: 21.875rem;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-header, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-header, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-header {
  color: #262a2e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-bottom: 1px solid #f7f7f7;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-body, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-body, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-body {
  height: 23.75rem;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-footer, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-footer, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-footer {
  border-top: 1px solid #f7f7f7;
  padding: 1rem;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #0a2f4c;
  font-size: 0.875rem;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item {
  white-space: inherit;
  padding-top: .75rem;
  padding-bottom: .75rem;
  border-radius: .5rem;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-head, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-head, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-head {
  margin-right: 1rem;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-body > div .notifications-info, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info {
  display: flex;
  align-items: center;
  margin-top: .25rem;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-body > div .notifications-info > .badge, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info > .badge, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info > .badge {
  margin-right: .625rem;
}
.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-body > div .notifications-info .notifications-time, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info .notifications-time, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info .notifications-time {
  font-size: 0.75rem;
  color: #6f6f6f;
}
.hk-wrapper .hk-navbar .navbar-search {
  display: flex;
}
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input > span.btn-input-clear, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle > span.btn-input-clear {
  display: none;
}
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-suffix, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-suffix,
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-prefix,
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-prefix,
.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-prefix,
.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-prefix,
.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-prefix {
  pointer-events: none;
}
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-suffix > span.spinner-border, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-suffix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-prefix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-prefix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-prefix > span.spinner-border,
.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-prefix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-prefix > span.spinner-border {
  display: none;
}
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-suffix, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-suffix,
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-prefix,
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-prefix,
.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-prefix,
.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-prefix,
.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-prefix {
  border: none;
  pointer-events: auto;
}
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border),
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),
.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),
.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),
.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),
.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border) {
  display: none;
}
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-suffix > span.btn-input-clear, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-suffix > span.btn-input-clear,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-prefix > span.btn-input-clear,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-prefix > span.btn-input-clear,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-prefix > span.btn-input-clear,
.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-prefix > span.btn-input-clear,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-prefix > span.btn-input-clear {
  display: none !important;
}
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-suffix > span.spinner-border, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-suffix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-prefix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-prefix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-prefix > span.spinner-border,
.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-prefix > span.spinner-border,
.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-prefix > span.spinner-border {
  display: inline;
}
.hk-wrapper .hk-navbar .navbar-search .dropdown-menu, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu {
  width: 18rem;
}
.hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-body, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-body, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-body {
  max-height: 19.75rem;
}
.hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-footer, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-footer, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-footer {
  border-top: 1px solid #f7f7f7;
  padding: 1rem;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #0a2f4c;
  font-size: 0.875rem;
}
.hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-item, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-item, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-item {
  white-space: inherit;
}
.hk-wrapper .hk-navbar .nav-start-wrap,
.hk-wrapper .hk-navbar .nav-end-wrap {
  display: flex;
  align-items: center;
}
.hk-wrapper .hk-navbar .nav-start-wrap > .navbar-nav,
.hk-wrapper .hk-navbar .nav-end-wrap > .navbar-nav {
  align-items: center;
}
.hk-wrapper .hk-navbar .navbar-brand .brand-img:last-child {
  margin-left: 0.5rem;
}
.login-brand-image{
  width:200px;
}

.hk-wrapper[data-navbar-style="collapsed"] .hk-navbar {
  transform: translateY(-100%);
  overflow: hidden;
}
.hk-wrapper[data-navbar-style="collapsed"] .hk-pg-wrapper {
  padding-top: 0;
}

@media (min-width: 992px) {
  .hk-wrapper .hk-navbar {
    transition: 0.2s ease;
  }
}
@media (min-width: 1200px) {
  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-control, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle {
    width: 18rem;
  }
  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-suffix > span.btn-input-clear, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-suffix > span.btn-input-clear,
  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-prefix > span.btn-input-clear,
  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-prefix > span.btn-input-clear,
  .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-prefix > span.btn-input-clear,
  .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-prefix > span.btn-input-clear,
  .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-prefix > span.btn-input-clear {
    display: inline !important;
  }
  .hk-wrapper .hk-navbar .nav-start-wrap,
  .hk-wrapper .hk-navbar .nav-end-wrap {
    display: flex;
  }
  .hk-wrapper .hk-navbar .nav-start-wrap > .navbar-nav,
  .hk-wrapper .hk-navbar .nav-end-wrap > .navbar-nav {
    align-items: center;
  }
  .hk-wrapper[data-navbar-style="collapsed"][data-layout="horizontal"] .hk-pg-wrapper {
    padding-top: 65px;
  }
  .hk-wrapper[data-navbar-style="collapsed"][data-layout="horizontal"][data-layout-style="default"] .hk-menu {
    top: 0;
  }
}
@media (max-width: 1199px) {
  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-suffix,
  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-prefix {
    pointer-events: auto !important;
  }
  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-suffix > span.btn-input-clear,
  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-prefix > span.btn-input-clear {
    display: inline !important;
  }
  .hk-wrapper .hk-navbar .navbar-search .dropdown-menu, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-body, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-body, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-body {
    max-height: calc(100% - 55px);
  }
}
/*------------------------------------------------------------------
[Footer]
Project:	Jampack
-------------------------------------------------------------------*/
/*Footer*/
[data-footer="simple"].hk-wrapper .hk-pg-wrapper, .footer-simple-example.hk-wrapper .hk-pg-wrapper {
  /*padding-bottom: 120px;*/
}
[data-footer="simple"] .hk-footer, .footer-simple-example .hk-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-top: 1px solid #eaeaea;
  background: #fff;
}
[data-footer="simple"] .hk-footer .footer > .row, .footer-simple-example .hk-footer .footer > .row {
  height: 60px;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  padding: 22px 0;
}
[data-footer="simple"] .hk-footer .footer .footer-text, .footer-simple-example .hk-footer .footer .footer-text {
  font-size: 0.75rem;
}
[data-footer="simple"] .hk-footer .footer .footer-text a, .footer-simple-example .hk-footer .footer .footer-text a {
  color: #08364d;
}
[data-footer="simple"] .hk-footer .footer .footer-text .copy-text, .footer-simple-example .hk-footer .footer .footer-text .copy-text {
  padding-right: 5px;
}
[data-footer="simple"] .hk-footer .footer .footer-text .footer-link-sep, .footer-simple-example .hk-footer .footer .footer-text .footer-link-sep {
  padding: 0 5px;
  color: #d8d8d8;
}
[data-footer="simple"] .hk-footer .footer .footer-extr-link, .footer-simple-example .hk-footer .footer .footer-extr-link {
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
[data-footer="simple"] .hk-footer .footer .footer-extr-link .feather-icon, .footer-simple-example .hk-footer .footer .footer-extr-link .feather-icon {
  margin-right: .25rem;
  color: #08364d;
}
[data-footer="simple"] .hk-footer .footer .footer-extr-link .feather-icon svg, .footer-simple-example .hk-footer .footer .footer-extr-link .feather-icon svg {
  height: 14px;
  width: 14px;
}
[data-footer="simple"] .hk-footer.footer-wth-bg, .footer-simple-example .hk-footer.footer-wth-bg {
  background: #f7f7f7;
  border-top: none;
}

[data-footer="complex"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {
  padding-bottom: 400px;
}
[data-footer="complex"] .hk-footer, .footer-complex-example .hk-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #d8d8d8;
}
[data-footer="complex"] .hk-footer.footer-wth-bg, .footer-complex-example .hk-footer.footer-wth-bg {
  background: #f7f7f7;
  border-top: none;
}
[data-footer="complex"] .hk-footer .footer, .footer-complex-example .hk-footer .footer {
  padding-top: 40px;
  padding-bottom: 30px;
}
[data-footer="complex"] .hk-footer .footer > .row:last-child, .footer-complex-example .hk-footer .footer > .row:last-child {
  margin-top: 3.375rem;
  align-items: center;
}
[data-footer="complex"] .hk-footer .footer .footer-brand, .footer-complex-example .hk-footer .footer .footer-brand {
  display: block;
  margin-bottom: .25rem;
}
[data-footer="complex"] .hk-footer .footer .footer-info-text, .footer-complex-example .hk-footer .footer .footer-info-text {
  font-size: 0.875rem;
  width: 85%;
}
[data-footer="complex"] .hk-footer .footer .quick-links-head, .footer-complex-example .hk-footer .footer .quick-links-head {
  text-transform: uppercase;
  margin-bottom: 1rem;
  font-size: .85rem;
  font-weight: 600;
}
[data-footer="complex"] .hk-footer .footer .quick-links, .footer-complex-example .hk-footer .footer .quick-links {
  display: block;
  color: #262a2e;
  margin-bottom: .25rem;
  font-size: 0.875rem;
}
[data-footer="complex"] .hk-footer .footer .quick-links:hover, .footer-complex-example .hk-footer .footer .quick-links:hover {
  color: #262a2e;
}
[data-footer="complex"] .hk-footer .footer .footer-text, .footer-complex-example .hk-footer .footer .footer-text {
  font-size: 0.75rem;
}
[data-footer="complex"] .hk-footer .footer .footer-text a, .footer-complex-example .hk-footer .footer .footer-text a {
  color: #0a2f4c;
}
[data-footer="complex"] .hk-footer .footer .footer-text .copy-text, .footer-complex-example .hk-footer .footer .footer-text .copy-text {
  padding-right: .25rem;
}
[data-footer="complex"] .hk-footer .footer .footer-text .footer-link-sep, .footer-complex-example .hk-footer .footer .footer-text .footer-link-sep {
  padding: 0 .25rem;
  color: #d8d8d8;
}
[data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
[data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap .btn, [data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions [data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .btn, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button {
  margin-left: .625rem;
  flex-shrink: 0;
}

.footer-complex-example.hk-wrapper .hk-pg-wrapper {
  padding-bottom: 120px;
}

@media (max-width: 1400px) {
  [data-footer="complex"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {
    padding-bottom: 31.875rem;
  }
  [data-footer="complex"] .hk-footer .footer .footer-info-text, .footer-complex-example .hk-footer .footer .footer-info-text {
    width: 100%;
  }
  [data-footer="complex"] .hk-footer .footer > .row > .col-xl-6, .footer-complex-example .hk-footer .footer > .row > .col-xl-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  [data-footer="complex"] .hk-footer .footer > .row > .col-xl-6:last-child, .footer-complex-example .hk-footer .footer > .row > .col-xl-6:last-child {
    margin-top: 2.125rem;
  }
  [data-footer="complex"] .hk-footer .footer > .row:last-child, .footer-complex-example .hk-footer .footer > .row:last-child {
    margin-top: 2.125rem;
  }
}
@media (max-width: 1199px) {
  [data-footer="simple"] .hk-footer .footer > .row, .footer-simple-example .hk-footer .footer > .row {
    height: auto;
  }
  [data-footer="simple"] .hk-footer .footer > .row > .col-xl-6 .col-xl-4, .footer-simple-example .hk-footer .footer > .row > .col-xl-6 .col-xl-4 {
    margin-bottom: 1.875rem;
  }
  [data-footer="simple"] .hk-footer .footer > .row > .col-xl-6 .col-xl-4:last-child, .footer-simple-example .hk-footer .footer > .row > .col-xl-6 .col-xl-4:last-child {
    margin-bottom: 0;
  }
  [data-footer="simple"] .hk-footer .footer .footer-text, .footer-simple-example .hk-footer .footer .footer-text {
    text-align: center;
    margin-bottom: .625rem;
  }
  [data-footer="simple"] .hk-footer .footer .footer-extr-link, .footer-simple-example .hk-footer .footer .footer-extr-link {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }

  [data-footer="complex"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {
    padding-bottom: 34.5rem;
  }
  [data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap {
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: flex-start;
    margin-top: 1.5rem;
  }
  [data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap .btn:first-child, [data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:first-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions [data-footer="complex"] .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button:first-child, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .btn:first-child, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:first-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button:first-child {
    margin-left: 0;
  }
}
@media (max-width: 767px) {
  [data-footer="complex"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {
    padding-bottom: 63rem;
  }
  [data-footer="complex"] .hk-footer .footer > .row > .col-xl-6 .col-md-4, .footer-complex-example .hk-footer .footer > .row > .col-xl-6 .col-md-4 {
    margin-bottom: 1.875rem;
  }
  [data-footer="complex"] .hk-footer .footer > .row > .col-xl-6 .col-md-4:last-child, .footer-complex-example .hk-footer .footer > .row > .col-xl-6 .col-md-4:last-child {
    margin-bottom: 0;
  }
}
@media (max-width: 666px) {
  [data-footer="simple"].hk-wrapper .hk-pg-wrapper, .footer-simple-example.hk-wrapper .hk-pg-wrapper {
    padding-bottom: 10rem;
  }
}
/*------------------------------------------------------------------
[Nav]
Project:	Jampack
-------------------------------------------------------------------*/
/*Navbar*/
.navbar .navbar-toggler-menu,
.navbar .navbar-toggler {
  border: none;
  padding: 0;
}
.navbar .navbar-toggler-menu {
  align-self: center;
  margin-right: .625rem;
}
.navbar .navbar-brand {
  display: inline-flex;
}
.navbar.navbar-dark {
  background: #262a2e;
}
.navbar.navbar-dark .badge.badge-indicator {
  border-color: #262a2e;
}
.navbar.navbar-dark .form-control, .navbar.navbar-dark .form-select, .navbar.navbar-dark .wizard > .content > .body input, .wizard > .content > .body .navbar.navbar-dark input, .navbar.navbar-dark .dd-handle {
  border-color: #fff;
  color: #fff;
}
.navbar.navbar-dark .input-affix-wrapper.affix-border .input-prefix, .navbar.navbar-dark .input-affix-wrapper.affix-border .input-suffix {
  border-color: #fff;
  color: #fff;
}
.navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.hopscotch-nav-button {
  color: #fff;
}
.navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:before, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:before {
  background: rgba(255, 255, 255, 0.05);
}
.navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled).active .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled):active .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:hover .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:hover .icon, .navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover:focus .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:focus .icon {
  color: #fff;
}
.navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark.disabled, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.disabled.hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.disabled.hopscotch-nav-button, .navbar.navbar-dark .btn.btn-icon[class*="btn-flush-"].btn-flush-dark:disabled, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*="btn-flush-"].btn-flush-dark.hopscotch-nav-button:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*="btn-flush-"].btn-flush-dark.hopscotch-nav-button:disabled {
  color: rgba(255, 255, 255, 0.8);
}
.navbar.navbar-light {
  background: #fff;
}
.navbar.navbar-light .badge.badge-indicator {
  border-color: #fff;
}

/*Nav*/
.nav-link {
  color: #0a2f4c;
}
.nav-link:hover, .nav-link:focus {
  color: #3d9ca5;
}

.nav .nav-item {
  position: relative;
}
.nav .nav-item .nav-link.no-arrow {
  padding-right: 0.75rem !important;
}
.nav .nav-item .nav-link.no-arrow:after {
  display: none;
}
.nav .nav-item .nav-link.link-with-arrow {
  padding-right: 1.8rem !important;
  position: relative;
}
.nav .nav-item .nav-link.link-with-arrow:after {
  content: '\\f2f9';
  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';
  font-size: 1rem;
  text-rendering: auto;
  margin-left: auto;
  position: absolute;
  right: 1rem;
  top: calc(50% - 8px);
  transform: rotate(0deg);
  transition: all 0.4s ease;
}
.nav.nav-icon > .nav-item .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.nav.nav-icon > .nav-item .nav-link > .nav-icon-wrap {
  margin-right: .875rem;
  font-size: 1.25rem;
  line-height: 0;
  position: relative;
}
.nav.nav-icon.nav-icon-top > .nav-item > .nav-link {
  text-align: center;
  display: block;
}
.nav.nav-icon.nav-icon-top > .nav-item > .nav-link > .nav-icon-wrap {
  margin-right: 0;
  margin-bottom: .5rem;
  display: block;
}
.nav.nav-pills > .nav-item > .nav-link {
  border-radius: 0.5rem;
  margin-left: .25rem;
  margin-right: .25rem;
}
.nav.nav-pills > .nav-item > .nav-link.active {
  background-color: #0a2f4c !important;
}
.nav.nav-pills > .nav-item > .nav-link.active.link-with-arrow:after {
  color: rgba(255, 255, 255, 0.6);
}
.nav.nav-pills > .nav-item > .nav-link.active:after {
  color: rgba(255, 255, 255, 0.6);
}
.nav.nav-pills .show > .nav-link {
  background-color: transparent;
}
.nav.nav-pills.nav-pills-square > .nav-item > .nav-link {
  border-radius: 0;
}
.nav.nav-pills.nav-pills-rounded > .nav-item > .nav-link {
  border-radius: 50rem;
}
.nav.nav-pills.nav-pills-soft > .nav-item > .nav-link.active {
  background-color: #ebf5f5 !important;
  color: #0a2f4c !important;
}
.nav.nav-pills.nav-pills-soft > .nav-item > .nav-link.active.link-with-arrow:after {
  color: inherit;
}
.nav.nav-pills.nav-pills-soft > .nav-item > .nav-link.active:after {
  color: inherit;
}
.nav.nav-pills.nav-icon.nav-icon-top > .nav-item > .nav-link {
  padding-top: .95rem;
  padding-bottom: .95rem;
}
.nav.nav-line > .nav-item > .nav-link {
  border-bottom: 1px solid transparent;
  transition: 0.2s ease-in-out;
}
.nav.nav-line > .nav-item > .nav-link.active {
  border-color: #0a2f4c !important;
}
.nav.nav-vertical {
  flex-direction: column !important;
}
.nav.nav-vertical .nav-item .nav-link {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  position: relative;
}
.nav.nav-vertical .nav-item .nav-link[data-toggle="collapse"]::after {
  content: '\\f2f9';
  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';
  font-size: 1rem;
  text-rendering: auto;
  margin-left: auto;
  transform: rotate(0deg);
  transition: all 0.4s ease;
}
.nav.nav-vertical .nav-item .nav-link[data-toggle="collapse"][aria-expanded="true"]::after {
  transform: rotate(-180deg);
}
.nav.nav-vertical.nav-pills > .nav-item > .nav-link {
  margin: .25rem 0;
}
.nav.nav-vertical.nav-line > .nav-item > .nav-link {
  border-bottom: none;
  border-left: 1px solid transparent;
}
.nav.nav-vertical.nav-separator > .nav-item > .nav-link {
  padding: .75rem 1.5rem;
}
.nav.nav-vertical.nav-separator > .nav-item::after {
  content: "";
  position: absolute;
  width: 100%;
  left: 0;
  top: auto;
  bottom: 0;
  height: 1px;
  margin: 0;
}
.nav.nav-dark .nav-link {
  color: white;
}
.nav.nav-dark .nav-link:hover, .nav.nav-dark .nav-link:focus {
  color: rgba(255, 255, 255, 0.8);
}
.nav.nav-dark .nav-link.disabled {
  color: rgba(255, 255, 255, 0.3);
}
.nav.nav-dark .nav-link.active {
  color: #0a2f4c;
}
.nav.nav-dark .nav-link:after {
  color: rgba(255, 255, 255, 0.3);
}
.nav.nav-dark .nav-link.link-with-arrow:after {
  color: rgba(255, 255, 255, 0.3);
}
.nav.nav-dark .nav-item.show .nav-link {
  color: #fff;
}
.nav.nav-dark.nav-pills > .nav-item > .nav-link.active {
  color: #fff;
}
.nav.nav-dark.nav-pills > .nav-item > .nav-link.active:hover, .nav.nav-dark.nav-pills > .nav-item > .nav-link.active:focus {
  color: #fff;
}
.nav.nav-dark.nav-pills > .nav-item > .nav-link {
  color: #fff;
}
.nav.nav-dark.nav-pills > .nav-item > .nav-link:hover, .nav.nav-dark.nav-pills > .nav-item > .nav-link:focus {
  background: rgba(255, 255, 255, 0.1);
}
.nav.nav-dark.nav-pills > .nav-item > .nav-link.disabled {
  color: rgba(255, 255, 255, 0.3);
}
.nav.nav-dark.nav-vertical .nav-item .nav-link[data-toggle="collapse"]::after {
  color: rgba(255, 255, 255, 0.3);
}
.nav.nav-dark.nav-line .nav-item.show .nav-link {
  color: #fff;
}
.nav.nav-light .nav-link {
  color: #262a2e;
}
.nav.nav-light .nav-link:hover, .nav.nav-light .nav-link:focus {
  color: rgba(38, 42, 46, 0.8);
}
.nav.nav-light .nav-link.disabled {
  color: rgba(38, 42, 46, 0.3);
}
.nav.nav-light .nav-link.active {
  color: #0a2f4c;
}
.nav.nav-light .nav-link:after {
  color: rgba(38, 42, 46, 0.3);
}
.nav.nav-light .nav-link.link-with-arrow:after {
  color: rgba(38, 42, 46, 0.3);
}
.nav.nav-light .nav-item.show .nav-link {
  color: #262a2e;
}
.nav.nav-light.nav-vertical .nav-item .nav-link[data-toggle="collapse"]::after {
  color: rgba(38, 42, 46, 0.3);
}
.nav.nav-light.nav-pills > .nav-item > .nav-link.active {
  color: #fff;
}
.nav.nav-light.nav-pills > .nav-item > .nav-link.active:hover, .nav.nav-light.nav-pills > .nav-item > .nav-link.active:focus {
  color: #fff;
}
.nav.nav-light.nav-pills > .nav-item > .nav-link {
  color: #262a2e;
}
.nav.nav-light.nav-pills > .nav-item > .nav-link:hover, .nav.nav-light.nav-pills > .nav-item > .nav-link:focus {
  background: rgba(38, 42, 46, 0.08);
}
.nav.nav-light.nav-pills > .nav-item > .nav-link.disabled {
  color: rgba(38, 42, 46, 0.3);
}
.nav.nav-sm > .nav-item .nav-link > .nav-icon-wrap {
  margin-right: .875rem;
  font-size: 1rem;
}
.nav.nav-sm .nav-link {
  padding: .25rem 0.75rem;
  font-size: 0.875rem;
}

.nav-tabs {
  border-bottom: 1px solid #d8d8d8;
}
.nav-tabs .nav-item.show .nav-link:hover, .nav-tabs .nav-item.show .nav-link:focus,
.nav-tabs > .nav-item > .nav-link:hover,
.nav-tabs > .nav-item > .nav-link:focus {
  border-color: transparent;
}
.nav-tabs .nav-item.show .nav-link.active,
.nav-tabs > .nav-item > .nav-link.active {
  background-color: transparent;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;
}
.nav-tabs.nav-sm .nav-item.show .nav-link,
.nav-tabs.nav-sm > .nav-item > .nav-link {
  padding: .4rem 0.75rem;
}
.nav-tabs .nav-item.show .nav-link {
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;
}
.nav-tabs.nav-pills {
  border-bottom: 0;
}
.nav-tabs.nav-pills > .nav-item {
  margin-bottom: 0;
}
.nav-tabs.nav-pills > .nav-item > .nav-link {
  border: none !important;
}
.nav-tabs.nav-light > .nav-item > .nav-link.active {
  background: #fff;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;
}
.nav-tabs.nav-light .nav-item.show .nav-link {
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;
}
.nav-tabs.nav-dark {
  border-color: rgba(255, 255, 255, 0.1);
}
.nav-tabs.nav-dark > .nav-item > .nav-link.active {
  background: #fff;
  border-color: rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1) #fff;
}
.nav-tabs.nav-dark .nav-item.show .nav-link {
  border-color: rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1) #fff;
}
.nav-tabs.nav-line {
  border-bottom: 0;
}
.nav-tabs.nav-line > .nav-item {
  margin-bottom: 0;
}
.nav-tabs.nav-line > .nav-item > .nav-link {
  background: transparent;
  border-left: 0;
  border-top: 0;
  border-right: 0;
}
.nav-tabs.nav-line > .nav-item > .nav-link.active {
  background: transparent;
}

.tab-content {
  margin-top: 1rem;
}

.nav-segmented-tabs {
  display: flex;
  border-bottom: none;
}
.nav-segmented-tabs > .nav-item {
  margin-right: -1px;
}
.nav-segmented-tabs > .nav-item:first-child .nav-link {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.nav-segmented-tabs > .nav-item:last-child .nav-link {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.nav-segmented-tabs > .nav-item > .nav-link {
  border: 1px solid #d8d8d8 !important;
  border-radius: 0;
  text-align: center;
  background: transparent;
  height: 100%;
}
.nav-segmented-tabs > .nav-item > .nav-link.active {
  color: #fff !important;
  background: #0a2f4c !important;
  border-color: #0a2f4c !important;
}
.nav-segmented-tabs.segmented-tabs-rounded > .nav-item:first-child .nav-link {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
}
.nav-segmented-tabs.segmented-tabs-rounded > .nav-item:last-child .nav-link {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}
.nav-segmented-tabs.segmented-tabs-square > .nav-item > .nav-link {
  border-radius: 0;
}
.nav-segmented-tabs.segmented-tabs-filled > .nav-item {
  margin-right: 0;
}
.nav-segmented-tabs.segmented-tabs-filled > .nav-item .nav-link {
  border: none !important;
  background: #f7f7f7;
}
.nav-segmented-tabs.nav-dark > .nav-item > .nav-link {
  border-color: rgba(255, 255, 255, 0.15) !important;
}
.nav-segmented-tabs.nav-dark > .nav-item.show > .nav-link {
  background: transparent;
  color: white;
}
.nav-segmented-tabs.nav-dark.segmented-tabs-filled > .nav-item .nav-link {
  background: rgba(255, 255, 255, 0.05);
}

.nav-header-bold {
  padding: 1.5rem 0 .5rem 0;
  width: 240px;
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
  color: #0a2f4c;
}

/*Section Nav*/
.hk-wrapper[data-aside="fixed"] .hk-pg-wrapper {
  margin-right: 180px;
}
.hk-wrapper[data-aside="fixed"] .hk-aside {
  position: fixed;
  top: 65px;
  overflow-y: auto;
  width: 180px;
  right: 0;
  z-index: 1;
  background: #fff;
  border-left: 1px solid #d8d8d8;
  bottom: 0;
}
.hk-wrapper[data-aside="fixed"] .hk-aside .nicescroll-bar {
  padding: 1.5rem;
}
.hk-wrapper[data-aside="sticky"] .hk-aside {
  position: sticky;
  top: 70px;
  overflow-y: auto;
  height: calc(100vh - 250px);
  z-index: 1;
  margin-top: 3rem;
}
.hk-wrapper .nav-toc .nav-header {
  font-size: .75rem;
  text-transform: uppercase;
  font-weight: 600;
  color: #9e9e9e;
}
.hk-wrapper .nav-toc .nav {
  margin: 1rem 0;
  font-size: .875rem;
  flex-wrap: nowrap;
  border-left: 1px solid;
  border-color: #d8d8d8;
}
.hk-wrapper .nav-toc .nav .nav-item {
  margin-bottom: .25rem;
}
.hk-wrapper .nav-toc .nav .nav-item:last-child {
  margin-bottom: 0;
}
.hk-wrapper .nav-toc .nav .nav-item a.nav-link {
  color: #262a2e;
  padding: 0 0 0 1rem;
  display: block;
  margin-left: -1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-left: 1px solid transparent;
}
.hk-wrapper .nav-toc .nav .nav-item a.nav-link:hover, .hk-wrapper .nav-toc .nav .nav-item a.nav-link:focus {
  color: rgba(38, 42, 46, 0.8);
}
.hk-wrapper .nav-toc .nav .nav-item a.nav-link.active {
  color: #0a2f4c;
  border-color: #0a2f4c;
}

@media (max-width: 767px) {
  .hk-wrapper[data-aside="fixed"] .hk-pg-wrapper {
    margin-right: 0;
  }
  .hk-wrapper[data-aside="fixed"] .hk-aside {
    display: none;
  }
}
.toc-wrapper .nav.nav-vertical .nav-item .nav-link {
  font-size: 0.875rem;
  padding: 0.125rem 0;
}

/*------------------------------------------------------------------
[Horizontal Menu]
Project:	Jampack
--------------------------------------------------------------------*/
/**Horizontal Navigation**/
.hk-wrapper[data-layout="horizontal"] .hk-pg-wrapper {
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu {
  display: flex;
  flex-flow: column;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 270px;
  margin-left: 0;
  z-index: 1032;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu > .nicescroll-bar {
  overflow: auto;
  flex: 1 1 auto;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap {
  padding: 1.5rem;
  position: relative;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .nav-header {
  padding: 0 0 .5rem 0;
  font-size: 0.875rem;
  color: #0a2f4c;
  font-weight: 500;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  position: relative;
  display: flex;
  align-items: center;
  padding: .5rem 1rem;
  margin: 0 -1rem;
  white-space: nowrap;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {
  transition: transform 0.25s ease;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {
  font-size: 1.5rem;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  position: absolute;
  right: 1rem;
  z-index: -1;
  content: '\\f2f9';
  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  margin-left: auto;
  transform: rotate(0deg);
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after {
  transform: rotate(-180deg);
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {
  transform: translateX(5px);
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item > .nav-link[data-bs-toggle="collapse"]::after {
  display: none;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item .nav-children .nav-item .nav-link .nav-icon-wrap {
  display: none;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {
  position: relative;
  padding: 0.5rem 0;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  content: "";
  width: 1px;
  height: calc(100% - 20px);
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {
  font-size: 0.875rem;
  padding: 0.15rem 0 0.15rem 1.4rem;
  margin: 0 0 0 1rem;
  transition: all 0.25s ease;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  right: 0;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {
  padding: 0.15rem 0 0.15rem 2rem;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap .menu-gap {
  height: 25px;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-header {
  padding: 0.5rem 1.5rem;
  display: flex;
  flex: 0 0 auto;
  height: 65px;
  align-items: center;
  overflow: hidden;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-header .navbar-toggle {
  flex-shrink: 0;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-header > span {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
}
.hk-wrapper[data-layout="horizontal"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {
  margin-left: 0.5rem;
}
.hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-pg-wrapper {
  margin-left: 0;
}
.hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-navbar {
  left: 0;
}
.hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu {
  left: -270px;
}
.hk-wrapper[data-layout="horizontal"][data-layout-style="collapsed"] .hk-menu {
  left: 0;
}
.hk-wrapper[data-layout="horizontal"][data-layout-style="collapsed"] .hk-menu-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1031;
  transition: all 0.25s ease;
  background: rgba(38, 42, 46, 0.5);
  opacity: 1;
  height: auto;
  width: auto;
  visibility: visible;
}
.hk-wrapper[data-layout="horizontal"][data-menu="light"] .hk-menu {
  background: #fff;
}
.hk-wrapper[data-layout="horizontal"][data-menu="light"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #262a2e;
}
.hk-wrapper[data-layout="horizontal"][data-menu="light"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(38, 42, 46, 0.3);
}
.hk-wrapper[data-layout="horizontal"][data-menu="light"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}
.hk-wrapper[data-layout="horizontal"][data-menu="dark"] .hk-menu {
  background: #262a2e;
}
.hk-wrapper[data-layout="horizontal"][data-menu="dark"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #fff;
}
.hk-wrapper[data-layout="horizontal"][data-menu="dark"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(255, 255, 255, 0.3);
}
.hk-wrapper[data-layout="horizontal"][data-menu="dark"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}

@media (max-width: 1199px) {
  .hk-wrapper[data-layout="horizontal"] .hk-menu .menu-content-wrap > .menu-group {
    padding: 0;
  }
}
@media (min-width: 1200px) {
  .hk-wrapper[data-layout="horizontal"].hk-section-nav-active .hk-section-nav {
    top: 130px;
  }
  .hk-wrapper[data-layout="horizontal"] .hk-pg-wrapper {
    padding-top: 130px;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu {
    left: 0;
    top: 65px;
    right: 0;
    bottom: auto;
    width: 100%;
    transform: translateY(0);
    border-bottom: 1px solid #eaeaea;
    border-right: 0;
    z-index: 1029;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu > .nicescroll-bar {
    overflow: visible !important;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap {
    padding: 0;
    position: relative;
    min-height: auto;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group > .navbar-nav.flex-column {
    flex-direction: row !important;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
    display: none;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link {
    min-height: 65px;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link:hover > * {
    transform: translateX(0);
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item {
    position: relative;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
    margin: 0;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
    position: static;
    margin-left: 0.75rem;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:first-child > .nav-link {
    padding-left: 0;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {
    height: auto !important;
    min-width: 10rem;
    position: absolute;
    z-index: 1;
    border-radius: .25rem;
    border: 1px solid #eaeaea;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children {
    padding: 1rem 0;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link {
    padding: .25rem 1.5rem;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link[data-bs-toggle="collapse"]::after {
    margin-left: auto;
    transform: rotate(-90deg);
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children {
    padding: 0.5rem 0;
    left: 100%;
    top: 0;
    position: absolute;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children .nav-item .nav-link {
    padding: .25rem 1rem;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item.edge ul.nav-children {
    left: auto !important;
    right: 100%;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse, .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse.show, .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapsing {
    display: block;
    clip: rect(1px, 1px, 1px, 1px);
    opacity: 0.1;
    transition: transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);
    transform: translateY(-10px) scaleY(0.5);
    transform-origin: top;
    box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
    top: 100%;
    position: fixed;
  }
  .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse, .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse.show, .hk-wrapper[data-layout="horizontal"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapsing {
    clip: auto;
    opacity: 1;
    transform: translateY(0) scaleY(1);
  }
  .hk-wrapper[data-layout="horizontal"][data-menu="light"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {
    background: #fff;
  }
  .hk-wrapper[data-layout="horizontal"][data-menu="dark"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {
    background: #262a2e;
  }
}
/*------------------------------------------------------------------
[Classic Menu]
Project:	Jampack
--------------------------------------------------------------------*/
/**Vertical Navigation**/
.hk-wrapper[data-layout="vertical"] .hk-pg-wrapper {
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="vertical"] .hk-menu {
  display: flex;
  flex-flow: column;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 270px;
  margin-left: 0;
  z-index: 1032;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
  /*Sidebar fixednav*/
  /*Horizontal Scrollbar*/
}
.hk-wrapper[data-layout="vertical"] .hk-menu > .nicescroll-bar {
  overflow: auto;
  flex: 1 1 auto;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap {
  padding: 1.5rem;
  position: relative;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .nav-header {
  padding: 0 0 .5rem 0;
  font-size: 0.875rem;
  color: #9e9e9e;
  font-weight: 500;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  position: relative;
  display: flex;
  align-items: center;
  padding: .5rem 1rem;
  margin: 0 -1rem;
  white-space: nowrap;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link.active{
  background: rgba(0, 76, 136, 0.15);
  color: #0a2f4c !important;
  border-radius: 0.5rem;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {
  transition: transform 0.25s ease;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {
  font-size: 1.5rem;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  position: absolute;
  right: 1rem;
  z-index: -1;
  content: '\\f2f9';
  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  margin-left: auto;
  transform: rotate(0deg);
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after {
  transform: rotate(-180deg);
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {
  transform: translateX(5px);
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link.active {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c !important;
  border-radius: 0.5rem;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {
  position: relative;
  padding: 0.5rem 0;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  content: "";
  width: 1px;
  height: calc(100% - 20px);
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {
  font-size: 0.875rem;
  padding: 0.15rem 0 0.15rem 1.4rem;
  margin: 0 0 0 1rem;
  transition: all 0.25s ease;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  right: 0;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {
  padding: 0.15rem 0 0.15rem 2rem;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-content-wrap .menu-gap {
  height: 25px;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-header {
  padding: 0.5rem 1.1875rem;
  display: flex;
  flex: 0 0 auto;
  height: 65px;
  align-items: center;
  overflow: hidden;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-header .navbar-toggle {
  flex-shrink: 0;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-header > span {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {
  margin-left: 0.5rem;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .bottom-nav {
  flex: 0 0 auto;
  padding-bottom: .5rem;
}
.hk-wrapper[data-layout="vertical"] .hk-menu .simplebar-track.simplebar-horizontal {
  display: none;
}
.hk-wrapper[data-layout="vertical"][data-layout-style="default"] .hk-pg-wrapper {
  margin-left: 0;
}
.hk-wrapper[data-layout="vertical"][data-layout-style="default"] .hk-navbar {
  left: 0;
}
.hk-wrapper[data-layout="vertical"][data-layout-style="default"] .hk-menu {
  left: -270px;
}
.hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu {
  left: 0;
}
.hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1031;
  transition: all 0.25s ease;
  background: rgba(38, 42, 46, 0.5);
  opacity: 1;
  height: auto;
  width: auto;
  visibility: visible;
}
.hk-wrapper[data-layout="vertical"][data-menu="light"] .hk-menu {
  background: #fff;
}
.hk-wrapper[data-layout="vertical"][data-menu="light"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #262a2e;
}
.hk-wrapper[data-layout="vertical"][data-menu="light"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(38, 42, 46, 0.3);
}
.hk-wrapper[data-layout="vertical"][data-menu="light"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}
.hk-wrapper[data-layout="vertical"][data-menu="dark"] .hk-menu {
  background: #262a2e;
}
.hk-wrapper[data-layout="vertical"][data-menu="dark"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #fff;
}
.hk-wrapper[data-layout="vertical"][data-menu="dark"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(255, 255, 255, 0.3);
}
.hk-wrapper[data-layout="vertical"][data-menu="dark"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}

@media (min-width: 1200px) {
  .hk-wrapper[data-layout="vertical"][data-layout-style="default"] .hk-pg-wrapper {
    margin-left: 270px;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="default"] .hk-navbar {
    left: 270px;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="default"] .hk-menu {
    left: 0;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-pg-wrapper {
    margin-left: 72px;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-navbar {
    left: 72px;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu {
    width: 72px;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .menu-content-wrap > .callout {
    display: none;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .menu-content-wrap .menu-group .nav-header {
    display: none;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link > *:not(.nav-icon-wrap) {
    visibility: hidden;
    flex-shrink: 0;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link[data-bs-toggle="collapse"]::after {
    right: -1.5rem;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .menu-content-wrap .menu-group .collapse.show {
    display: none;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .menu-content-wrap .menu-gap {
    display: none;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {
    display: none;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu .navbar-toggle {
    transform: rotate(180deg);
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover {
    width: 270px;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover .menu-content-wrap > .callout {
    display: flex;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover .menu-content-wrap .menu-group .nav-header {
    display: block;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link > *:not(.nav-icon-wrap) {
    visibility: visible;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link[data-bs-toggle="collapse"]::after {
    right: 1rem;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover .menu-content-wrap .menu-group .collapse.show {
    display: flex;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover .menu-content-wrap .menu-gap {
    display: block;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"][data-hover="active"] .hk-menu:hover .menu-header > span .navbar-brand .brand-img:last-child {
    display: inline;
  }
  .hk-wrapper[data-layout="vertical"][data-layout-style="collapsed"] .hk-menu-backdrop {
    opacity: 0;
    height: 0;
    width: 0;
    visibility: hidden;
  }
}
/*------------------------------------------------------------------
[Icon Menu]
Project:	Jampack
-------------------------------------------------------------------*/
/**Vertical Icon Navigation**/
.hk-wrapper[data-layout="twocolumn"] .hk-pg-wrapper {
  margin-left: 72px;
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="twocolumn"] .hk-navbar {
  left: 72px;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu {
  display: flex;
  flex-flow: column;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 72px;
  margin-left: 0;
  z-index: 1032;
  border-right: 1px solid #d8d8d8;
  transition: all 0.2s ease;
  /*Sidebar fixednav*/
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu > .nicescroll-bar {
  overflow: auto;
  flex: 1 1 auto;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-content-wrap {
  padding: 1.5rem;
  position: relative;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item .nav-link {
  position: relative;
  display: flex;
  align-items: center;
  padding: .5rem 1rem;
  margin: 0 -1rem;
  white-space: nowrap;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {
  font-size: 1.5rem;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item.active > .nav-link {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-content-wrap .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c !important;
  border-radius: 0.5rem;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-header {
  padding: 0.5rem 1.5rem;
  display: flex;
  height: 65px;
  align-items: center;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .menu-header .navbar-brand {
  margin: 0;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu .bottom-nav {
  flex: 0 0 auto;
  padding-bottom: .5rem;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu {
  display: flex;
  flex-flow: column;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 72px;
  width: 270px;
  margin-left: 0;
  z-index: 1031;
  overflow: hidden;
  border-right: 1px solid #d8d8d8;
  transform: translate(-100%);
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu > .nicescroll-bar {
  overflow: auto;
  flex: 1 1 auto;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap {
  padding: 1.5rem;
  position: relative;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-header {
  padding: 0 0 .5rem 0;
  font-size: 0.875rem;
  color: #0a2f4c;
  font-weight: 500;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  position: relative;
  display: flex;
  align-items: center;
  padding: .5rem 1rem;
  margin: 0 -1rem;
  white-space: nowrap;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {
  transition: transform 0.25s ease;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {
  font-size: 1.5rem;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  position: absolute;
  right: 1rem;
  z-index: -1;
  content: '\\f2f9';
  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  margin-left: auto;
  transform: rotate(0deg);
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"][aria-default="true"]::after {
  transform: rotate(-180deg);
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {
  transform: translateX(5px);
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {
  position: relative;
  padding: 0.5rem 0;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  content: "";
  width: 1px;
  height: calc(100% - 20px);
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {
  font-size: 0.875rem;
  padding: 0.15rem 0 0.15rem 1.4rem;
  margin: 0 0 0 1rem;
  transition: all 0.25s ease;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  right: 0;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {
  padding: 0.15rem 0 0.15rem 2rem;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-content-wrap .menu-gap {
  height: 25px;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-header {
  padding: 0 1.5rem;
  display: flex;
  flex: 0 0 auto;
  min-height: 65px;
  width: 269px;
  align-items: center;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .menu-header .navbar-toggle {
  flex-shrink: 0;
}
.hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu .subnav-list {
  display: none;
}
.hk-wrapper[data-layout="twocolumn"][data-submenu="active"] .hk-menu .sub-menu {
  transform: translate(0);
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .main-menu {
  background: #fff;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #262a2e;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(38, 42, 46, 0.3);
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .sub-menu {
  background: #fff;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #262a2e;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(38, 42, 46, 0.3);
}
.hk-wrapper[data-layout="twocolumn"][data-menu="light"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .main-menu {
  background: #262a2e;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #fff;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(255, 255, 255, 0.3);
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .sub-menu {
  background: #2F343A;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #fff;
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(255, 255, 255, 0.3);
}
.hk-wrapper[data-layout="twocolumn"][data-menu="dark"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}

@media (max-width: 1199px) {
  .hk-wrapper[data-layout="twocolumn"] .hk-pg-wrapper {
    margin-left: 0;
  }
  .hk-wrapper[data-layout="twocolumn"] .hk-navbar {
    left: 0;
  }
  .hk-wrapper[data-layout="twocolumn"] .hk-menu .main-menu {
    left: -72px;
  }
  .hk-wrapper[data-layout="twocolumn"] .hk-menu .sub-menu {
    left: 0;
  }
  .hk-wrapper[data-layout="twocolumn"][data-layout-style="offcanvas"] .hk-menu .main-menu {
    left: 0;
  }
  .hk-wrapper[data-layout="twocolumn"][data-layout-style="offcanvas"] .hk-menu .sub-menu {
    left: 72px;
  }
  .hk-wrapper[data-layout="twocolumn"][data-layout-style="offcanvas"] .hk-menu-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1030;
    background: rgba(38, 42, 46, 0.5);
    height: auto;
    width: auto;
  }
}
/*------------------------------------------------------------------
[Navbar Menu]
Project:	Jampack
--------------------------------------------------------------------*/
/**Navbar Navigation**/
.hk-wrapper[data-layout="navbar"] .hk-pg-wrapper {
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="navbar"] .hk-menu {
  display: flex;
  flex-flow: column;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 270px;
  margin-left: 0;
  z-index: 1032;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="navbar"] .hk-menu > .nicescroll-bar {
  overflow: auto;
  flex: 1 1 auto;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap {
  padding: 1.5rem;
  position: relative;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .nav-header {
  padding: 0 0 .5rem 0;
  font-size: 0.875rem;
  color: #0a2f4c;
  font-weight: 500;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  position: relative;
  display: flex;
  align-items: center;
  padding: .5rem 1rem;
  margin: 0 -1rem;
  white-space: nowrap;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {
  transition: transform 0.25s ease;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {
  font-size: 1.5rem;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  position: absolute;
  right: 1rem;
  z-index: -1;
  content: '\\f2f9';
  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  margin-left: auto;
  transform: rotate(0deg);
  transition: all 0.2s ease;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after {
  transform: rotate(-180deg);
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {
  transform: translateX(5px);
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item > .nav-link[data-bs-toggle="collapse"]::after {
  display: none;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item .nav-children .nav-item .nav-link .nav-icon-wrap {
  display: none;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {
  color: #0a2f4c !important;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {
  position: relative;
  padding: 0.5rem 0;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  content: "";
  width: 1px;
  height: calc(100% - 20px);
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {
  font-size: 0.875rem;
  padding: 0.15rem 0 0.15rem 1.4rem;
  margin: 0 0 0 1rem;
  transition: all 0.25s ease;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  right: 0;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {
  padding: 0.15rem 0 0.15rem 2rem;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-content-wrap .menu-gap {
  height: 25px;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-header {
  padding: 0.5rem 1.5rem;
  display: flex;
  flex: 0 0 auto;
  height: 65px;
  align-items: center;
  overflow: hidden;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-header .navbar-toggle {
  flex-shrink: 0;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-header > span {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
}
.hk-wrapper[data-layout="navbar"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {
  margin-left: 0.5rem;
}


.hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-pg-wrapper {
  margin-left: 0;
}
.hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-navbar {
  left: 0;
}
.hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu {
  left: -270px;
}
.hk-wrapper[data-layout="navbar"][data-layout-style="collapsed"] .hk-menu {
  left: 0;
}
.hk-wrapper[data-layout="navbar"][data-layout-style="collapsed"] .hk-menu-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1031;
  transition: all 0.25s ease;
  background: rgba(38, 42, 46, 0.5);
  opacity: 1;
  height: auto;
  width: auto;
  visibility: visible;
}
.hk-wrapper[data-layout="navbar"] .simplebar-track.simplebar-horizontal {
  display: none;
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-light .hk-menu {
  background: #fff;
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #262a2e;
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(38, 42, 46, 0.3);
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-dark .hk-menu {
  background: #262a2e;
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
  color: #fff;
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
  color: rgba(255, 255, 255, 0.3);
}
.hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
  background: #d8d8d8;
}

@media (max-width: 1199px) {
  .hk-wrapper[data-layout="navbar"] .hk-menu .container.menu-group {
    padding: 0;
  }
}
@media (min-width: 1200px) {
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu {
    background: inherit !important;
    width: 100%;
    position: static;
    transform: translateY(0);
    border: 0;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu > .nicescroll-bar {
    overflow: visible !important;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap {
    padding: 0;
    position: relative;
    min-height: auto;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group > .navbar-nav.flex-column {
    flex-direction: row !important;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {
    display: none;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link {
    min-height: 65px;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link:hover > * {
    transform: translateX(0);
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item {
    position: relative;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {
    margin: 0;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]::after {
    position: static;
    margin-left: 0.75rem;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {
    height: auto !important;
    min-width: 10rem;
    position: absolute;
    z-index: 1;
    border-radius: .25rem;
    border: 1px solid #eaeaea;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children {
    padding: 1rem 0;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link {
    padding: .25rem 1.5rem;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link[data-bs-toggle="collapse"]::after {
    margin-left: auto;
    transform: rotate(-90deg);
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children {
    padding: 0.5rem 0;
    left: 100%;
    top: 0;
    position: absolute;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children .nav-item .nav-link {
    padding: .25rem 1rem;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item.edge ul.nav-children {
    left: auto !important;
    right: 100%;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse, .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse.show, .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapsing {
    display: block;
    clip: rect(1px, 1px, 1px, 1px);
    opacity: 0.1;
    transition: transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);
    transform: translateY(-10px) scaleY(0.5);
    transform-origin: top;
    box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;
    top: 100%;
    position: fixed;
  }
  .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse, .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse.show, .hk-wrapper[data-layout="navbar"][data-layout-style="default"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapsing {
    clip: auto;
    opacity: 1;
    transform: translateY(0) scaleY(1);
  }
  .hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {
    background: #fff;
  }
  .hk-wrapper[data-layout="navbar"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {
    background: #262a2e;
  }
}
/*------------------------------------------------------------------
[Drawer]
Project:	Jampack
-------------------------------------------------------------------*/
/*Drawer*/
.hk-wrapper .hk-drawer {
  position: fixed;
  display: flex;
  flex-flow: column;
  top: 0;
  right: -320px;
  width: 320px;
  bottom: 0;
  z-index: 1050;
  border: none;
  background: #fff;
  transition: all 0.2s ease;
}
.hk-wrapper .hk-drawer .drawer-header {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #d8d8d8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.hk-wrapper .hk-drawer .drawer-header .drawer-text {
  font-size: 1rem;
  color: #2F343A;
  font-weight: 500;
}
.hk-wrapper .hk-drawer .drawer-header .drawer-header-action {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.hk-wrapper .hk-drawer .drawer-header.header-bold .drawer-text {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
}
.hk-wrapper .hk-drawer .drawer-header.header-wth-bg {
  background: #0a2f4c;
  border-bottom: 0;
}
.hk-wrapper .hk-drawer .drawer-header.header-wth-bg .drawer-text {
  color: #fff;
}
.hk-wrapper .hk-drawer .drawer-header.header-wth-bg .drawer-close {
  color: #fff;
}
.hk-wrapper .hk-drawer .drawer-header.header-flush {
  border-bottom: 0;
}
.hk-wrapper .hk-drawer .drawer-body {
  overflow: auto;
  flex: 1 1 auto;
}
.hk-wrapper .hk-drawer .drawer-body .drawer-content-wrap {
  Padding: 1.25rem 1.25rem 7rem 1.25rem;
}
.hk-wrapper .hk-drawer .drawer-body .drawer-content-wrap .drawer-close {
  position: absolute;
  right: 14px;
  top: 10px;
  cursor: pointer;
}
.hk-wrapper .hk-drawer .drawer-footer {
  padding: 0.75rem 1.25rem;
  background: #fff;
  border-top: 1px solid #d8d8d8;
}
.hk-wrapper .hk-drawer.drawer-left {
  left: -320px;
  border-right: 1px solid #d8d8d8;
}
.hk-wrapper .hk-drawer.drawer-right {
  right: -320px;
  border-left: 1px solid #d8d8d8;
}
.hk-wrapper .hk-drawer.drawer-small {
  top: 65px;
}
.hk-wrapper .hk-drawer.drawer-toggle.hk-drawer.drawer-left {
  left: 0;
}
.hk-wrapper .hk-drawer.drawer-toggle.hk-drawer.drawer-right {
  right: 0;
}
.hk-wrapper.hk-drawer-push.hk-drawer-pushleft .hk-pg-wrapper {
  margin-left: 20rem;
}
.hk-wrapper.hk-drawer-push.hk-drawer-pushright .hk-pg-wrapper {
  margin-right: 20rem;
}
.hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push .hk-navbar {
  transition: all 0.2s ease;
}
.hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushleft .hk-navbar {
  left: 320px;
}
.hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushright .hk-navbar {
  right: 320px;
}
.hk-wrapper .hk-drawer-backdrop {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #262a2e;
  opacity: 0.25;
  z-index: 1033;
  top: 0;
  left: 0;
}

@media (max-width: 1199px) {
  .hk-wrapper.hk-drawer-push.hk-drawer-pushleft .hk-pg-wrapper {
    margin-left: 0;
  }
  .hk-wrapper.hk-drawer-push.hk-drawer-pushright .hk-pg-wrapper {
    margin-right: 0;
  }
  .hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push .hk-navbar {
    transition: all 0.2s ease;
  }
  .hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushleft .hk-navbar {
    left: 0;
  }
  .hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushright .hk-navbar {
    right: 0;
  }
}
/*------------------------------------------------------------------
[Master Stylesheet]
Project:	Jampack
++++ ChatApp ++++
++++ Chat Popup ++++
++++ Chatbot Popup ++++
++++ Calendar ++++
++++ Email UI ++++
++++ Taskboard ++++
++++ Checklist List ++++
++++ Contact ++++
++++ File Manager ++++
++++ Gallery App ++++
++++ Todo ++++
++++ Blog App ++++
++++ invoice ++++
++++ Integrations ++++
-------------------------------------------------------------------*/
/*ChatApp*/
.chatapp-wrap {
  position: relative;
  overflow: hidden;
  height: calc(100vh - 65px);
  transition: height 0.2s ease;
}
.chatapp-wrap .chatapp-content {
  display: flex;
  height: 100%;
  position: relative;
  overflow: hidden;
  left: 0;
  transition: all 0.2s ease;
}
.chatapp-wrap .chatapp-content .chatapp-aside {
  border-right: 1px solid #eaeaea;
  background: #fff;
  position: relative;
  display: flex;
  flex-flow: column;
  height: 100%;
  z-index: 1;
  left: 0;
  margin-top: 0;
  width: 370px;
  flex-shrink: 0;
}
.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  border-bottom: 1px solid #eaeaea;
  background: #fff;
  color: #262a2e;
}
.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .chatapp-title {
  display: flex;
  align-items: center;
}
.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .chatapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .chatapp-title:after {
  top: 0;
}
.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .btn, .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .hopscotch-nav-button {
  margin-right: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .btn:last-child, .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:last-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .hopscotch-nav-button:last-child {
  margin-right: 0;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body {
  flex: 1 1;
  height: 100%;
  overflow: auto;
  padding: 1.25rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .aside-search {
  margin-bottom: 1.25rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .frequent-contact {
  margin-bottom: 1.25rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .frequent-contact ul li .avatar {
  cursor: pointer;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list {
  margin: 0 -0.8rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item {
  padding: 0;
  border: none;
  margin-bottom: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item:last-child {
  margin-bottom: 0;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media {
  padding: .75rem .8rem;
  border-radius: 0.5rem;
  transition: 0.2s ease;
  align-items: center;
  display: flex;
  cursor: pointer;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-head {
  position: relative;
  margin-right: 1rem;
  display: flex;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body {
  display: flex;
  min-width: 0;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child {
  min-width: 0;
  flex: 1 1;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name,
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-last-chat,
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-status {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name {
  color: #262a2e;
  font-weight: 500;
  margin-bottom: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child {
  text-align: right;
  padding-left: 1rem;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  align-items: flex-end;
  width: 4.5rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child .last-chat-time {
  font-size: 0.75rem;
  color: #0a2f4c;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child .badge {
  margin-top: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child .action-drp {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 15px;
  transition: all 0.2s ease-in-out;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover, .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus {
  background-color: #f2f2f2;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .action-drp, .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .action-drp {
  opacity: 1;
  visibility: visible;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .last-chat-time,
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .badge-pill, .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .last-chat-time,
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .badge-pill {
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-in-out;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media.read-chat .media-body > div:last-child .last-chat-time {
  color: #6f6f6f;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media.read-chat.active-user {
  background-color: #f2f2f2;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media.read-chat.active-user .media-body > div:first-child .user-name {
  color: #0a2f4c;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .title-wth-divider {
  padding: 0 .8rem;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .title-wth-divider:after {
  background: #f7f7f7;
}
.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .channels-list .nav-item .nav-link {
  padding-left: 0;
  padding-right: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat {
  display: flex;
  flex-grow: 1;
  flex-flow: column;
  height: 100%;
  background: #fff;
  z-index: 10;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .back-user-list {
  display: none;
  margin-right: .625rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media {
  align-items: center;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-name {
  font-size: 1rem;
  font-weight: 500;
  color: #262a2e;
  text-transform: capitalize;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-status {
  font-size: 0.875rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-name, .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-status {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .chat-options-wrap {
  display: flex;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .chat-options-wrap > a {
  margin-left: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body {
  transition: all 0.2s ease;
  flex: 1 1;
  height: 100%;
  overflow: auto;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body ul.list-unstyled {
  width: 90%;
  margin: 0 auto;
  padding: 2rem 1.25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body {
  margin-left: 0.75rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box {
  display: flex;
  align-items: center;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box > div {
  padding: .625rem 1rem;
  border-radius: 1.25rem;
  display: inline-block;
  position: relative;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box > div p:first-child {
  color: #262a2e;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box > div .chat-time {
  display: block;
  text-transform: uppercase;
  font-size: 0.75rem;
  margin-top: .25rem;
  opacity: .5;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box + .msg-box {
  margin-top: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box .msg-action {
  margin-left: 1rem;
  opacity: 0;
  display: flex;
  padding: 0;
  background: transparent !important;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box .msg-action:after {
  display: none;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box:hover .msg-action {
  opacity: 1;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs {
  display: flex;
  flex-wrap: wrap;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div {
  cursor: pointer;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media {
  align-items: center;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .file-name {
  color: #262a2e;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 165px;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .file-size {
  font-size: 0.875rem;
  margin-top: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .file-overlay {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  color: #fff;
  background: rgba(38, 42, 46, 0.4);
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div:hover .file-overlay {
  opacity: 1;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div.msg-action:after {
  display: none;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box + .msg-box {
  margin-top: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box > div {
  padding: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box > div img {
  border-radius: 1.25rem;
  max-width: 336px;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box:first-child > div, .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box:last-child > div {
  border-radius: 1.25rem !important;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.received {
  margin-bottom: 1.25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.received .media-body .msg-box > div {
  background: #f2f2f2;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.received .media-body .msg-box:first-child > div {
  border-top-left-radius: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent {
  margin-bottom: 1.25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body {
  margin-left: 0;
  display: flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  flex-direction: column;
  align-items: flex-end;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box {
  flex-direction: row-reverse;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box > div {
  background: #0a2f4c;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box > div p {
  color: #fff;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box > div .chat-time {
  color: #fff;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box:first-child > div {
  border-top-right-radius: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box .msg-action {
  margin-left: 0;
  margin-right: 1rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.media-attachment {
  margin-bottom: 1.125rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.media-attachment .media-body > .msg-box {
  margin-bottom: .25rem;
  margin-right: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep {
  position: relative;
  text-align: center;
  overflow: hidden;
  font-size: 0.875rem;
  margin: 1.875rem 0;
  text-transform: capitalize;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep:before {
  background: #eaeaea;
  content: "";
  height: 1px;
  right: 50%;
  position: absolute;
  top: 50%;
  width: 100%;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep:after {
  background: #eaeaea;
  content: "";
  height: 1px;
  left: 50%;
  position: absolute;
  top: 50%;
  width: 100%;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep span {
  display: inline-block;
  background: #fff;
  z-index: 1;
  position: relative;
  padding: 0 .625rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .start-conversation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 195px);
  flex-flow: column;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  background: #fff;
  border-top: 1px solid #eaeaea;
  margin-top: -1px;
  position: relative;
  transition: all 0.2s ease;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .feather-icon, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .svg-icon {
  display: block;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group {
  width: 100%;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .form-control, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .form-select, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .wizard > .content > .body input, .wizard > .content > .body .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group input, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .dd-handle {
  margin: 0 0.75rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info {
  position: absolute;
  top: 65px;
  right: -370px;
  width: 370px;
  margin-left: 0;
  bottom: 0;
  z-index: 100;
  border: none;
  background: #fff;
  border-left: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .nicescroll-bar {
  padding: 1.25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-name {
  font-size: 1.25rem;
  font-weight: 500;
  color: #262a2e;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info {
  padding-left: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li {
  margin-bottom: .625rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a {
  color: #262a2e;
  display: flex;
  align-items: center;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a .cp-icon-wrap {
  display: flex;
  margin-right: .5rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a .cp-icon-wrap .feather-icon, .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a .cp-icon-wrap .svg-icon {
  font-size: 1.125rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action {
  padding-left: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action li {
  margin-bottom: .625rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action li a {
  color: #262a2e;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action li:last-child {
  margin-bottom: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files {
  margin: 0 -.8rem;
  padding-left: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li {
  padding: .8rem;
  border-radius: 0.5rem;
  transition: 0.2s ease;
  margin-bottom: .25rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:last-child {
  margin-bottom: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media {
  align-items: center;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-head {
  margin-right: 1rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-head .avatar.avatar-sm .avatar-icon {
  font-size: 1.75rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body {
  display: flex;
  align-items: center;
  min-width: 0;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body > div:first-child {
  min-width: 0;
  flex: 1 1;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body .file-name {
  color: #262a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body .file-size {
  margin-top: .25rem;
  font-size: 0.875rem;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:hover {
  background-color: #f2f2f2;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:hover .media .media-body .file-name {
  color: #0a2f4c;
}
.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:hover .media .media-body a.cp-file-action {
  color: #262a2e;
}
.chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-body {
  margin-right: 370px;
}
.chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-info {
  right: 0;
}
.chatapp-wrap.chatapp-info-active .chatapp-single-chat footer.chat-footer {
  margin-right: 370px;
}
.chatapp-wrap .chatapp-call-window .modal-content {
  min-height: calc(100vh - 100px);
}
.chatapp-wrap .chatapp-call-window .modal-content .modal-header {
  Padding: 0.3rem 1.25rem;
}
.chatapp-wrap .chatapp-call-window .modal-content .modal-header .modal-title {
  text-align: center;
  width: 100%;
  font-size: 0.875rem;
}
.chatapp-wrap .chatapp-call-window .modal-content .modal-header > .modal-action {
  display: flex;
  right: 1.25rem;
  position: absolute;
}
.chatapp-wrap .chatapp-call-window .modal-content .modal-body {
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
  padding: 3.125rem;
}
.chatapp-wrap .chatapp-call-window .modal-content .modal-footer {
  border-top: 0;
  min-height: 160px;
  justify-content: center;
}
.chatapp-wrap .chatapp-call-window .modal-content .modal-footer .chatapp-caller-img {
  right: 30px;
  bottom: 30px;
  position: absolute;
}
.chatapp-wrap .chatapp-call-window .modal-content.fullscreen {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  border-radius: 0;
}
.chatapp-wrap .chatapp-call-window .modal-content.fullscreen .modal-header {
  border-radius: 0;
}
.chatapp-wrap .invite-user-list {
  padding: 0 1rem;
}
.chatapp-wrap .invite-user-list > li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: .625rem;
}
.chatapp-wrap .invite-user-list > li .user-name {
  color: #262a2e;
  font-weight: 500;
}

.hk-wrapper[data-navbar-style="collapsed"] .chatapp-wrap {
  height: 100vh;
}

.one {
  opacity: 0;
  -webkit-animation: dot 1.3s infinite;
  -webkit-animation-delay: 0.0s;
  animation: dot 1.3s infinite;
  animation-delay: 0.0s;
}

.two {
  opacity: 0;
  -webkit-animation: dot 1.3s infinite;
  -webkit-animation-delay: 0.2s;
  animation: dot 1.3s infinite;
  animation-delay: 0.2s;
}

.three {
  opacity: 0;
  -webkit-animation: dot 1.3s infinite;
  -webkit-animation-delay: 0.3s;
  animation: dot 1.3s infinite;
  animation-delay: 0.3s;
}
@keyframes dot {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 1599px) {
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info {
    right: -320px;
    width: 320px;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body ul.list-unstyled {
    width: 100%;
  }
  .chatapp-wrap .chatapp-content .chatapp-aside {
    width: 320px;
  }
  .chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-info {
    right: 0;
  }
  .chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-body {
    margin-right: 20rem;
  }
  .chatapp-wrap.chatapp-info-active .chatapp-single-chat footer.chat-footer {
    margin-right: 20rem;
  }

  ul.hk-list {
    margin: 0 -.28rem;
  }
  ul.hk-list li {
    padding: .68rem .28rem;
  }
}
@media (min-width: 1200px) {
  button.btn-close.info-close {
    display: none;
  }
}
@media (max-width: 1199px) {
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info {
    top: 0;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body {
    margin-right: 0;
  }
  .chatapp-wrap.chatapp-info-active .chatapp-content .chatapp-single-chat .chat-body {
    margin-right: 0;
  }
  .chatapp-wrap.chatapp-info-active .chatapp-content .chatapp-single-chat footer {
    margin-right: 0;
  }

  /*Common for all App*/
  button.btn-close.info-close {
    top: 20px;
    position: absolute;
    right: 20px;
    z-index: 1;
  }
}
@media (min-width: 992px) {
  .chatapp-wrap .chatapp-content .chatapp-aside .hk-sidebar-togglable {
    display: none;
  }
}
@media (max-width: 991px) {
  .chatapp-wrap .chatapp-content .chatapp-aside {
    width: 100%;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat {
    right: -100%;
    position: fixed;
    top: 0;
    width: 100%;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header {
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: flex-start;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .back-user-list {
    display: block;
    flex-shrink: 0;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .chat-options-wrap {
    margin-left: auto;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body ul.list-unstyled {
    width: 100%;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .avatar.avatar-xxl {
    width: 6rem;
    height: 6rem;
  }
  .chatapp-wrap.chatapp-slide .chatapp-content .chatapp-aside {
    left: -100%;
  }
  .chatapp-wrap.chatapp-slide .chatapp-content .chatapp-single-chat {
    right: 0;
  }
  .chatapp-wrap .chatapp-call-window .modal-content .modal-footer .chatapp-caller-img {
    display: none;
  }
}
@media (max-width: 767px) {
  .chatapp-wrap .chatapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .frequent-contact ul {
    flex-wrap: nowrap;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-head .avatar.avatar-sm {
    width: 2.5rem;
    height: 2.5rem;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .avatar.avatar-xs {
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
  }
  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .file-name {
    max-width: calc(100vw - 300px);
  }
  .chatapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .chatapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .chatapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .chatapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
/*Chat Popup*/
@keyframes mercuryTypingAnimation {
  0% {
    transform: translateY(0px);
    background-color: #99cbcf;
  }
  28% {
    transform: translateY(-7px);
    background-color: #6bb4ba;
  }
  44% {
    transform: translateY(0px);
    background-color: #3d9ca5;
  }
}
.typing {
  align-items: center;
  display: flex;
  height: 17px;
}
.typing .dot {
  animation: mercuryTypingAnimation 1.8s infinite ease-in-out;
  background-color: #99cbcf;
  height: 5px;
  border-radius: 50%;
  margin-right: .25rem;
  vertical-align: middle;
  width: 5px;
  display: inline-block;
}
.typing .dot:nth-child(1) {
  animation-delay: 200ms;
}
.typing .dot:nth-child(2) {
  animation-delay: 300ms;
}
.typing .dot:nth-child(3) {
  animation-delay: 400ms;
}
.typing .dot:last-child {
  margin-right: 0;
}

.hk-chat-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  display: none;
  width: 380px;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  background: #fff;
  flex-flow: column;
}
.hk-chat-popup header {
  background: #262a2e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-shrink: 0;
  Padding: 0.5rem 1.25rem;
  height: 64px;
}
.hk-chat-popup header .media-wrap .media {
  align-items: center;
}
.hk-chat-popup header .media-wrap .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.hk-chat-popup header .media-wrap .media .media-body .user-name {
  font-size: 1rem;
  color: #fff;
  text-transform: capitalize;
}
.hk-chat-popup header .media-wrap .media .media-body .user-status {
  font-size: 0.875rem;
  color: #fff;
  text-transform: capitalize;
}
.hk-chat-popup header .input-group .contact-search {
  padding: 0;
  color: #fff;
  border: none;
  background: transparent;
}
.hk-chat-popup .chat-popup-body {
  overflow: auto;
  flex: 1 1 auto;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap {
  padding: 0 1.25rem 1.25rem;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list {
  margin: 0 -0.8rem;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item {
  padding: 0;
  border: none;
  margin-bottom: .25rem;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item:last-child {
  margin-bottom: 0;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media {
  padding: .75rem .8rem;
  border-radius: 0.5rem;
  transition: 0.2s ease;
  align-items: center;
  display: flex;
  cursor: pointer;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-head {
  position: relative;
  margin-right: 1rem;
  display: flex;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body {
  display: flex;
  min-width: 0;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child {
  min-width: 0;
  flex: 1 1;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name,
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-last-chat,
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-status {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name {
  color: #262a2e;
  font-weight: 500;
  margin-bottom: .25rem;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child {
  text-align: right;
  padding-left: 1rem;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  align-items: flex-end;
  width: 4.5rem;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child .last-chat-time {
  font-size: 0.75rem;
  color: #0a2f4c;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child .badge {
  margin-top: .25rem;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child .action-drp {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 15px;
  transition: all 0.2s ease-in-out;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover, .hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus {
  background-color: #f2f2f2;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .action-drp, .hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .action-drp {
  opacity: 1;
  visibility: visible;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .last-chat-time,
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .badge-pill, .hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .last-chat-time,
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .badge-pill {
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-in-out;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media.read-chat .media-body > div:last-child .last-chat-time {
  color: #6f6f6f;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media.read-chat.active-user {
  background-color: #f2f2f2;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media.read-chat.active-user .media-body > div:first-child .user-name {
  color: #0a2f4c;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .title-wth-divider {
  padding: 0 .8rem;
}
.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .title-wth-divider:after {
  background: #f7f7f7;
}
.hk-chat-popup .chat-popup-body ul.list-unstyled {
  width: 95%;
  margin: 0 auto;
  padding: 1.25rem 0;
}
.hk-chat-popup .chat-popup-body .media .media-body {
  margin-left: 0.75rem;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box {
  display: flex;
  align-items: center;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div {
  padding: .625rem 1rem;
  border-radius: 1.25rem;
  display: inline-block;
  position: relative;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div p:first-child {
  color: #262a2e;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div .chat-time {
  display: block;
  text-transform: uppercase;
  font-size: 0.75rem;
  margin-top: .25rem;
  opacity: .5;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div .file-overlay {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  color: #fff;
  background: rgba(38, 42, 46, 0.4);
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div:hover .file-overlay {
  opacity: 1;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box + .msg-box {
  margin-top: .25rem;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box .msg-action {
  margin-left: 1rem;
  opacity: 0;
  display: flex;
  padding: 0;
  background: transparent !important;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.hk-chat-popup .chat-popup-body .media .media-body .msg-box:hover .msg-action {
  opacity: 1;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-docs {
  display: flex;
  flex-wrap: wrap;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media {
  align-items: center;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media .avatar.avatar-sm .avatar-icon {
  font-size: 1.75rem;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media .file-name {
  color: #262a2e;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 165px;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media .file-size {
  font-size: 0.875rem;
  margin-top: .25rem;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box + .msg-box {
  margin-top: 0;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box > div {
  padding: 0;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box > div img {
  border-radius: 1.25rem;
  height: 150px;
}
.hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box:first-child > div, .hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box:last-child > div {
  border-radius: 1.25rem !important;
}
.hk-chat-popup .chat-popup-body .media.received {
  margin-bottom: 1.25rem;
}
.hk-chat-popup .chat-popup-body .media.received .media-body .msg-box > div {
  background: #f2f2f2;
}
.hk-chat-popup .chat-popup-body .media.received .media-body .msg-box:first-child > div {
  border-top-left-radius: 0;
}
.hk-chat-popup .chat-popup-body .media.sent {
  margin-bottom: 1.25rem;
}
.hk-chat-popup .chat-popup-body .media.sent .media-body {
  margin-left: 0;
  display: flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  flex-direction: column;
  align-items: flex-end;
}
.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box {
  flex-direction: row-reverse;
}
.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box > div {
  background: #0a2f4c;
}
.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box > div p {
  color: #fff;
}
.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box > div .chat-time {
  color: #fff;
}
.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box:first-child > div {
  border-top-right-radius: 0;
}
.hk-chat-popup .chat-popup-body .media.media-attachment {
  margin-bottom: 17px;
}
.hk-chat-popup .chat-popup-body .media.media-attachment .media-body > .msg-box {
  margin-bottom: .25rem;
  margin-right: .25rem;
}
.hk-chat-popup .chat-popup-body .media.typing-wrap .media-body .msg-box > div:after {
  display: none;
}
.hk-chat-popup .chat-popup-body .day-sep {
  position: relative;
  text-align: center;
  overflow: hidden;
  font-size: 0.875rem;
  margin: 1.875rem 0;
  text-transform: capitalize;
}
.hk-chat-popup .chat-popup-body .day-sep:before {
  background: #eaeaea;
  content: "";
  height: 1px;
  right: 50%;
  position: absolute;
  top: 50%;
  width: 100%;
}
.hk-chat-popup .chat-popup-body .day-sep:after {
  background: #eaeaea;
  content: "";
  height: 1px;
  left: 50%;
  position: absolute;
  top: 50%;
  width: 100%;
}
.hk-chat-popup .chat-popup-body .day-sep span {
  display: inline-block;
  background: #fff;
  z-index: 1;
  position: relative;
  padding: 0 .625rem;
}
.hk-chat-popup footer {
  background: #fff;
  border-top: 1px solid #eaeaea;
  margin-top: -1px;
  position: relative;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.hk-chat-popup footer .feather-icon, .hk-chat-popup footer .svg-icon {
  display: block;
}
.hk-chat-popup footer .form-control, .hk-chat-popup footer .form-select, .hk-chat-popup footer .wizard > .content > .body input, .wizard > .content > .body .hk-chat-popup footer input, .hk-chat-popup footer .dd-handle {
  height: 57px;
}

.btn-popup-open,
.btn-popup-close {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 111;
}

.chat-popover {
  position: fixed;
  right: 20px;
  bottom: 100px;
  background: #fff;
  width: 270px;
  border-radius: 0.5rem;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  display: none;
  z-index: 99;
}
.chat-popover p {
  font-size: 0.875rem;
}

@media (max-width: 800px) {
  .hk-chat-popup {
    width: 100%;
  }
}
/*Chatbot Popup*/
.hk-chatbot-popup {
  position: fixed;
  bottom: 100px;
  right: 30px;
  display: none;
  width: 380px;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  background: #fff;
}
.hk-chatbot-popup header {
  background: #262a2e;
  Padding: 0.5rem 1.25rem 5.5rem;
}
.hk-chatbot-popup header .chatbot-head-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.hk-chatbot-popup header .media-wrap .media {
  align-items: center;
}
.hk-chatbot-popup header .media-wrap .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.hk-chatbot-popup header .media-wrap .media .media-body .user-name,
.hk-chatbot-popup header .media-wrap .media .media-body .user-status {
  font-size: 1rem;
  color: #fff;
  text-transform: capitalize;
}
.hk-chatbot-popup header .media-wrap .media .media-body .user-status {
  font-size: 0.875rem;
}
.hk-chatbot-popup .chatbot-popup-body {
  height: calc(100vh - 440px);
  position: relative;
}
.hk-chatbot-popup .chatbot-popup-body .nicescroll-bar {
  margin-top: -5.25rem;
}
.hk-chatbot-popup .chatbot-popup-body .init-content-wrap {
  padding: 1.25rem 1.25rem 1.25rem;
}
.hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap {
  text-align: right;
}
.hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap .btn, .hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap .hopscotch-nav-button {
  margin-bottom: .625rem;
}
.hk-chatbot-popup .chatbot-popup-body ul.list-unstyled {
  width: 95%;
  margin: 0 auto;
  padding: 1.25rem 0;
}
.hk-chatbot-popup .chatbot-popup-body .media .media-body {
  margin-left: 0.75rem;
}
.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box {
  display: flex;
  align-items: center;
}
.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box > div {
  padding: .625rem 1rem;
  border-radius: 1.25rem;
  display: inline-block;
  position: relative;
}
.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box > div p:first-child {
  color: #262a2e;
}
.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box + .msg-box {
  margin-top: .25rem;
}
.hk-chatbot-popup .chatbot-popup-body .media.received {
  margin-bottom: 1.25rem;
}
.hk-chatbot-popup .chatbot-popup-body .media.received .media-body .msg-box > div {
  background: #f2f2f2;
}
.hk-chatbot-popup .chatbot-popup-body .media.received .media-body .msg-box:first-child > div {
  border-top-left-radius: 0;
}
.hk-chatbot-popup .chatbot-popup-body .media.sent {
  margin-bottom: 1.25rem;
}
.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body {
  margin-left: 0;
  display: flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  flex-direction: column;
  align-items: flex-end;
}
.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box {
  flex-direction: row-reverse;
}
.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box > div {
  background: #0a2f4c;
}
.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box > div p {
  color: #fff;
}
.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box > div .chat-time {
  color: #fff;
}
.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box:first-child > div {
  border-top-right-radius: 0;
}
.hk-chatbot-popup .chatbot-popup-body .media.typing-wrap .media-body .msg-box > div:after {
  display: none;
}
.hk-chatbot-popup .chatbot-popup-body .day-sep {
  position: relative;
  text-align: center;
  overflow: hidden;
  font-size: 0.875rem;
  margin: 1.875rem 0;
  text-transform: capitalize;
}
.hk-chatbot-popup .chatbot-popup-body .day-sep:before {
  background: #eaeaea;
  content: "";
  height: 1px;
  right: 50%;
  position: absolute;
  top: 50%;
  width: 100%;
}
.hk-chatbot-popup .chatbot-popup-body .day-sep:after {
  background: #eaeaea;
  content: "";
  height: 1px;
  left: 50%;
  position: absolute;
  top: 50%;
  width: 100%;
}
.hk-chatbot-popup .chatbot-popup-body .day-sep span {
  display: inline-block;
  background: #fff;
  z-index: 1;
  position: relative;
  padding: 0 .625rem;
}
.hk-chatbot-popup footer {
  background: #fff;
}
.hk-chatbot-popup footer .input-group {
  border-top: 1px solid #eaeaea;
}
.hk-chatbot-popup footer .input-group .form-control, .hk-chatbot-popup footer .input-group .form-select, .hk-chatbot-popup footer .input-group .wizard > .content > .body input, .wizard > .content > .body .hk-chatbot-popup footer .input-group input, .hk-chatbot-popup footer .input-group .dd-handle {
  height: 57px;
}
.hk-chatbot-popup footer .chatbot-intro-text {
  text-align: center;
  padding: .5rem 1.25rem;
}
.hk-chatbot-popup footer .footer-copy-text {
  background: #f7f7f7;
  padding: .5rem 1.25rem;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  align-items: center;
  text-align: center;
  font-size: 0.75rem;
}
.hk-chatbot-popup footer .footer-copy-text .brand-link img {
  width: 75px;
  margin-left: .25rem;
}

@media (max-width: 767px) {
  .hk-chatbot-popup {
    width: 100%;
    flex-flow: column;
    border-radius: 0;
    bottom: 0;
    right: 0;
    top: 0;
  }
  .hk-chatbot-popup header {
    Padding: 0.5rem 1.25rem 1rem;
  }
  .hk-chatbot-popup .chatbot-popup-body {
    overflow: auto;
    flex: 1 1 auto;
    height: auto;
  }
  .hk-chatbot-popup .chatbot-popup-body .nicescroll-bar {
    margin-top: 0;
  }
  .hk-chatbot-popup footer .chatbot-intro-text {
    display: none;
  }
}
/*Calendar*/
.calendarapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
  transition: height 0.2s ease;
}
.calendarapp-wrap .calendarapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.calendarapp-wrap .calendarapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap > .navbar-nav > .nav-item > .nav-link {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker {
  position: static;
  display: block !important;
  margin: 0;
  border: none;
  overflow: hidden;
  width: auto;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar {
  padding: 0;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table {
  padding: 0;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table th, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td {
  min-width: 30px;
  width: 30px;
  height: 30px;
  z-index: 1;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table th.active, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table th:hover, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td.active, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:hover {
  background: transparent;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:after {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
  z-index: -1;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td.active, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:hover {
  background: transparent;
  color: #0a2f4c;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td.active:after, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:hover:after {
  background: #c7e2e5;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .upcoming-event-wrap .nav .nav-item .event-time {
  color: #6f6f6f;
  font-size: 0.75rem;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .upcoming-event-wrap .nav .nav-item .event-name {
  margin-top: .25rem;
  font-weight: 500;
}
.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .categories-wrap .form-check {
  padding-top: .5rem;
  padding-bottom: .5rem;
}
.calendarapp-wrap .calendarapp-sidebar .calendarapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.calendarapp-wrap .calendarapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 270px;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  margin-bottom: 0;
  background: #fff;
  position: relative;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk {
  display: flex;
  align-items: center;
  flex: 1 1;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group {
  order: 2;
  float: none;
  display: flex;
  align-items: center;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group .fc-prev-button,
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group .fc-next-button {
  border: none;
  background: transparent;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .fc-today-button {
  border-radius: 0.5rem;
  margin-left: 0 !important;
  margin-right: 1rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2) {
  justify-content: center;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2) h2 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) {
  justify-content: flex-end;
}
.calendarapp-wrap .calendarapp-content .fc .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.25rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-col-header td, .calendarapp-wrap .calendarapp-content .fc .fc-col-header th {
  border: 1px solid #eaeaea;
}
.calendarapp-wrap .calendarapp-content .fc .fc-col-header-cell-cushion {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  padding: .25rem 0;
  color: #262a2e;
}
.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-axis-cushion,
.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-slot-label-cushion {
  font-size: 0.875rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body {
  width: 100% !important;
  height: 100% !important;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body .fc-scrollgrid-sync-table {
  width: 100% !important;
  height: 100% !important;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body .fc-scrollgrid-sync-table td, .calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body .fc-scrollgrid-sync-table th {
  border: 1px solid #eaeaea;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day-top {
  justify-content: center;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day-number {
  padding: .625rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day.fc-day-today {
  background: transparent;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top {
  padding: .25rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top .fc-daygrid-day-number {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  width: 35px;
  background: #0a2f4c;
  border-radius: 50%;
  color: #fff;
  position: relative;
}
.calendarapp-wrap .calendarapp-content .fc .fc-list-event-dot {
  border-color: #0a2f4c;
}
.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-slot {
  border-left: 0;
}
.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-divider {
  border: 0;
}
.calendarapp-wrap .calendarapp-content .fc .fc-v-event {
  background-color: #0a2f4c;
}
.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-divider {
  padding: 0;
}
.calendarapp-wrap .calendarapp-content .fc .table-bordered {
  border: 1px solid #eaeaea;
  border-left: 0;
}
.calendarapp-wrap .calendarapp-content .fc .fc-view-harness .fc-daygrid {
  background: #fff;
}
.calendarapp-wrap .calendarapp-content .fc .fc-view-harness .fc-daygrid .table-bordered .fc-day-other {
  background-color: #f7f7f7;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event {
  padding: .125rem .375rem;
  border-radius: 0.5rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event.has-avatar {
  padding: .375rem .625rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event.has-avatar .avatar {
  margin-right: .625rem;
  flex-shrink: 0;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main {
  display: flex;
  align-items: center;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main i {
  margin-right: .25rem;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main .fc-event-main-frame {
  overflow: hidden;
}
.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main .fc-event-main-frame .fc-event-title {
  text-overflow: ellipsis;
}
.calendarapp-wrap .calendarapp-content .fc-daygrid-event-dot {
  border-color: #0a2f4c;
}
.calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-sidebar {
  left: -270px;
}
.calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-content {
  padding-left: 0;
}

.hk-wrapper[data-navbar-style="collapsed"] .calendarapp-wrap {
  height: 100vh;
}
.hk-wrapper .calendar-drawer > div {
  display: flex;
  height: 100%;
  flex-flow: column;
}
.hk-wrapper .calendar-drawer .event-head {
  display: flex;
}
.hk-wrapper .calendar-drawer .event-head .event-name {
  font-size: 1.25rem;
  font-weight: 500;
  color: #262a2e;
  outline: none;
}
.hk-wrapper .calendar-drawer .event-head .badge-indicator {
  position: relative;
  top: 7px;
}
.hk-wrapper .calendar-drawer .event-detail {
  padding-left: 0;
}
.hk-wrapper .calendar-drawer .event-detail li {
  display: flex;
  margin-bottom: 1.125rem;
}
.hk-wrapper .calendar-drawer .event-detail li .ev-icon-wrap {
  display: flex;
  color: #262a2e;
  position: relative;
  top: 1px;
  margin-right: .625rem;
}
.hk-wrapper .calendar-drawer .event-detail li .ev-icon-wrap .feather-icon, .hk-wrapper .calendar-drawer .event-detail li .ev-icon-wrap .svg-icon {
  font-size: 1.125rem;
}

@media (max-width: 1199px) {
  .calendarapp-wrap .calendarapp-sidebar {
    left: -270px;
  }
  .calendarapp-wrap .calendarapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .calendarapp-wrap .calendarapp-content .fc-toolbar-chunk:nth-child(3) > .btn-group {
    display: none;
  }
  .calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-sidebar {
    left: 0;
  }
  .calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-content {
    left: 270px;
    padding-left: 270px;
    margin-left: -270px;
  }
  .calendarapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .calendarapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .calendarapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .calendarapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
/*Email UI*/
.emailapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
  transition: height 0.2s ease;
}
.emailapp-wrap .emailapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.emailapp-wrap .emailapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.emailapp-wrap .emailapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {
  border-radius: .375rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
  font-size: 1.5rem;
}
.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.emailapp-wrap .emailapp-sidebar .emailapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.emailapp-wrap .emailapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 270px;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.emailapp-wrap .emailapp-content .emailapp-aside {
  border-right: 1px solid #eaeaea;
  background: #fff;
  position: relative;
  display: flex;
  flex-flow: column;
  height: 100%;
  z-index: 1;
  left: 0;
  width: 370px;
  flex-shrink: 0;
  margin-top: 0;
}
.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  border-bottom: 1px solid #eaeaea;
  background: #fff;
  color: #262a2e;
}
.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .emailapp-title {
  display: flex;
  align-items: center;
}
.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .emailapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .emailapp-title:after {
  top: 0;
}
.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .btn, .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .hopscotch-nav-button {
  margin-right: .5rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .btn:last-child, .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:last-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .hopscotch-nav-button:last-child {
  margin-right: 0;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-search {
  margin-bottom: 1.25rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body {
  overflow: auto;
  flex: 1 1;
  height: 100%;
  padding: 1.25rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list {
  margin: 0 -0.8rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item {
  padding: 0;
  border: none;
  margin-bottom: .25rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media {
  padding: .75rem .8rem;
  border-radius: 0.5rem;
  transition: 0.2s ease;
  display: flex;
  cursor: pointer;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-head {
  position: relative;
  margin-right: 1rem;
  display: flex;
  flex-flow: column;
  align-items: center;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-head .badge-indicator {
  margin-top: .875rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body {
  display: flex;
  min-width: 0;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div {
  min-width: 0;
  flex: 1 1;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child {
  display: flex;
  align-items: center;
  margin-bottom: .25rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star {
  display: flex;
  margin-left: .625rem;
  opacity: 0;
  color: #6f6f6f;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star .svg-icon > svg {
  cursor: pointer;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked {
  opacity: 1;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-time {
  font-size: 0.75rem;
  margin-left: .625rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-head,
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-subject {
  color: #262a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: capitalize;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-subject {
  margin-bottom: .25rem;
  font-weight: 500;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-head {
  font-weight: 500;
  margin-right: .5rem;
  max-width: 150px;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 0.875rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:hover, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:focus {
  background-color: #f2f2f2;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:hover .media-body > div > div:first-child div:last-child .email-star, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:focus .media-body > div > div:first-child div:last-child .email-star {
  opacity: 1;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media.read-email.active-user {
  background-color: #f2f2f2;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .hk-section-head-border {
  padding: 0 .8rem;
}
.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .hk-section-head-border:after {
  background: #f7f7f7;
}
.emailapp-wrap .emailapp-content .emailapp-single-email {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .feather-icon, .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .svg-icon {
  display: block;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .back-user-list {
  display: none;
  margin-right: .625rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media {
  align-items: center;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media .media-body .user-name {
  font-size: 1rem;
  font-weight: 500;
  color: #262a2e;
  text-transform: capitalize;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media .media-body .user-status {
  font-size: 0.875rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap {
  display: flex;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap > a:first-child {
  margin-left: 0;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body {
  transition: all 0.2s ease;
  overflow: hidden;
  flex: 1 1;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .nicescroll-bar {
  padding: 1.25rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-subject {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 1.25rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-subject > div {
  display: flex;
  align-items: center;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-subject > div h4 {
  margin-bottom: 0;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item {
  overflow: auto;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header {
  border-color: transparent;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div {
  padding: 1.25rem;
  cursor: pointer;
  width: 100%;
  position: relative;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .media {
  align-items: center;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .media .media-head {
  margin-right: 1rem;
  display: flex;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .media .media-body > div:first-child {
  color: #262a2e;
  font-weight: 500;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action {
  display: flex;
  align-items: center;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-time {
  font-size: 0.75rem;
  margin-right: 1.25rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star {
  display: flex;
  margin-right: .625rem;
  position: relative;
  z-index: 1;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star .svg-icon > svg {
  cursor: pointer;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action > a {
  display: none;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle="collapse"] {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle="collapse"] ~ .media .media-body > div:last-child {
  display: none;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle="collapse"][aria-expanded="true"] ~ .email-head-action > a {
  display: inline-block;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle="collapse"][aria-expanded="true"] ~ .media .media-body > div:last-child {
  display: block;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div[data-bs-toggle="collapse"][aria-expanded="true"] .email-head .email-head-action > a {
  display: inline-block;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap {
  display: flex;
  flex-wrap: wrap;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box {
  margin-bottom: .5rem;
  margin-right: .25rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div {
  cursor: pointer;
  padding: .625rem 1rem;
  border-radius: 1.25rem;
  display: inline-block;
  position: relative;
  background: #f2f2f2;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media {
  align-items: center;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media .avatar.avatar-sm .avatar-icon {
  font-size: 1.75rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media .media-body {
  margin-left: 1.25rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media .file-size {
  margin-top: .25rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .file-overlay {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  color: #fff;
  background: rgba(38, 42, 46, 0.4);
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div:hover .file-overlay {
  opacity: 1;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div.msg-action:after {
  display: none;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown {
  display: inline-block;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown > .dropdown-toggle {
  position: relative;
  z-index: 1;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu {
  padding: 1rem;
  font-size: .875rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div {
  margin-bottom: .25rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div:last-child, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div:last-child, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div:last-child {
  margin-bottom: 0;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div > span, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div > span, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div > span {
  display: inline-block;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div > span:first-child, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div > span:first-child, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div > span:first-child {
  min-width: 50px;
  text-align: right;
  margin-right: .5rem;
}
.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div > span:last-child, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div > span:last-child, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div > span:last-child {
  color: #262a2e;
}
.emailapp-wrap.emailapp-sidebar-toggle .emailapp-sidebar {
  left: -270px;
}
.emailapp-wrap.emailapp-sidebar-toggle .emailapp-content {
  padding-left: 0;
}
.emailapp-wrap .compose-email-popup {
  position: fixed;
  bottom: 0;
  right: 20px;
  width: 700px;
  overflow-y: auto;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  background: #fff;
  display: none;
  border-radius: 0.5rem 0.5rem 0 0;
}
.emailapp-wrap .compose-email-popup header {
  Padding: 0.75rem 1.25rem;
  background: #262a2e;
  color: #fff;
}
.emailapp-wrap .compose-email-popup header #max_compose_popup .icon > span:last-child {
  display: none;
}
.emailapp-wrap .compose-email-popup header .btn-close {
  color: #fff;
  opacity: .6;
}
.emailapp-wrap .compose-email-popup header .btn-close:not(:disabled):not(.disabled):focus, .emailapp-wrap .compose-email-popup header .btn-close:not(:disabled):not(.disabled):hover {
  color: #fff;
  opacity: 1;
}
.emailapp-wrap .compose-email-popup form {
  padding: 1rem;
  flex: 1 1 auto;
  overflow: auto;
}
.emailapp-wrap .compose-email-popup form textarea {
  height: 230px;
}
.emailapp-wrap .compose-email-popup.minimize-email-popup {
  width: 300px;
  min-height: auto;
}
.emailapp-wrap .compose-email-popup.minimize-email-popup form, .emailapp-wrap .compose-email-popup.minimize-email-popup .compose-email-footer {
  display: none;
}
.emailapp-wrap .compose-email-popup.maximize-email-popup {
  width: calc(100vw - 700px);
  height: calc(100vh - 200px);
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  margin: auto;
}
.emailapp-wrap .compose-email-popup.maximize-email-popup header #max_compose_popup .icon > span:first-child {
  display: none;
}
.emailapp-wrap .compose-email-popup.maximize-email-popup header #max_compose_popup .icon > span:last-child {
  display: inline;
}
.emailapp-wrap .compose-email-popup.maximize-email-popup form textarea.form-control, .emailapp-wrap .compose-email-popup.maximize-email-popup form textarea.form-select, .emailapp-wrap .compose-email-popup.maximize-email-popup form textarea.dd-handle {
  height: calc( 100vh - 500px);
}
.emailapp-wrap .compose-email-popup .compose-email-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 0 1rem 1rem;
}

.hk-wrapper.hk__email__backdrop::after {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #262a2e;
  opacity: 0.5;
  z-index: 1033;
  top: 0;
  left: 0;
  content: "";
}

.hk-wrapper[data-navbar-style="collapsed"] .emailapp-wrap {
  height: 100vh;
}

@media (max-width: 1199px) {
  .emailapp-wrap .emailapp-sidebar {
    left: -270px;
  }
  .emailapp-wrap .emailapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .emailapp-wrap.emailapp-sidebar-toggle .emailapp-sidebar {
    left: 0;
  }
  .emailapp-wrap.emailapp-sidebar-toggle .emailapp-content {
    left: 270px;
    padding-left: 270px;
    margin-left: -270px;
  }
  .emailapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .emailapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .emailapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .emailapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
@media (max-width: 991px) {
  .emailapp-wrap .emailapp-content .emailapp-aside {
    width: 100%;
  }
  .emailapp-wrap .emailapp-content .emailapp-single-email {
    right: -100%;
    position: fixed;
    top: 0;
    width: 100%;
  }
  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header {
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: flex-start;
  }
  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .back-user-list {
    display: block;
    flex-shrink: 0;
  }
  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap + .email-options-wrap {
    margin-left: auto;
  }
  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .hk-navbar-togglable {
    display: none !important;
  }
  .emailapp-wrap.emailapp-slide .emailapp-content .emailapp-aside {
    left: -100%;
  }
  .emailapp-wrap.emailapp-slide .emailapp-content .emailapp-single-email {
    right: 0;
  }
  .emailapp-wrap .compose-email-popup {
    width: 100%;
    height: 100%;
    right: 0;
    border-radius: 0;
  }
  .emailapp-wrap .compose-email-popup form textarea.form-control, .emailapp-wrap .compose-email-popup form textarea.form-select, .emailapp-wrap .compose-email-popup form textarea.dd-handle {
    height: calc( 100vh - 300px) !important;
  }
  .emailapp-wrap .compose-email-popup.maximize-email-popup {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 0;
  }
}
/*Taskboard*/
.taskboardapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
  transition: height 0.2s ease;
}
.taskboardapp-wrap .taskboardapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.taskboardapp-wrap .taskboardapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link,
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap,
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap {
  display: flex;
  font-size: 1.5rem;
  margin-right: .875rem;
}
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text,
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.taskboardapp-wrap .taskboardapp-sidebar .taskboardapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.taskboardapp-wrap .taskboardapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 270px;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  width: 100%;
  z-index: 10;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 {
  display: flex;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star {
  display: flex;
  align-items: center;
  margin-left: .625rem;
  font-size: 1.25rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star > .feather-icon > svg, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star .svg-icon > svg {
  cursor: pointer;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star > .feather-icon > svg:hover, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked > .feather-icon > svg, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked > .feather-icon > svg:hover, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title:after {
  top: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media {
  align-items: center;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media .media-body .user-name {
  font-size: 1rem;
  font-weight: 500;
  color: #262a2e;
  text-transform: capitalize;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media .media-body .user-status {
  font-size: 0.875rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap {
  display: flex;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > a:first-child {
  margin-left: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > .d-flex.ms-auto > a {
  margin-left: .25rem;
  display: inline-block;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > .d-flex.ms-auto > a:first-child {
  margin-left: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body {
  overflow: hidden;
  flex: 1 1;
  display: flex;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div {
  display: flex;
  flex-flow: column;
  width: 100%;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .taskbar-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 1.25rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-scroll {
  display: flex;
  overflow-x: auto;
  max-height: 100%;
  overflow-y: hidden;
  margin-top: 2.25rem;
  padding-bottom: 1.25rem;
  transition: width 0.2s ease;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap {
  display: flex;
  align-items: flex-start;
  padding: 0 1.25rem;
  float: left;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .tasklist {
  max-height: 100%;
  margin: 0 .875rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .tasklist:first-child {
  margin-left: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .tasklist:last-child {
  margin-right: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .spipeline-list {
  margin: 0 .875rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .spipeline-list:first-child {
  margin-left: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .spipeline-list:last-child {
  margin-right: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap {
  margin-top: 3.75rem;
  margin-bottom: 3.75rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] {
  margin-bottom: 1.875rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card {
  margin-bottom: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card .media .media-head {
  margin-right: 1rem;
  display: flex;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.board-card .media .media-head {
  margin-right: 1rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.board-card .media .media-body {
  overflow: hidden;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.board-card .media .media-body span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #262a2e;
  font-weight: 500;
  font-size: 1.125rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.team-card .media .media-head {
  margin-right: 1rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.team-card .media .media-body {
  overflow: hidden;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.team-card .media .media-body > div:first-child {
  color: #262a2e;
  font-weight: 500;
  font-size: 1.125rem;
  margin-bottom: .25rem;
  display: flex;
  align-items: center;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.team-card .media .media-body > div:first-child .badge {
  margin-left: .625rem;
  flex-shrink: 0;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.team-card .media .media-body > div:first-child span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*="col-"] .card.team-card .media .media-body > div:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body.taskboard-body-alt {
  background: #f7f7f7;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body.taskboard-body-alt > div .tasklist-scroll {
  overflow: auto;
  max-height: inherit;
  height: 100%;
  margin-top: 0;
  padding-bottom: 1.25rem;
  padding-top: 1.875rem;
  margin-bottom: 5.125rem;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-info {
  position: absolute;
  top: 65px;
  right: -370px;
  width: 370px;
  margin-left: 0;
  bottom: 0;
  z-index: 100;
  border: none;
  background: #fff;
  border-left: 1px solid #eaeaea;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-info .nicescroll-bar {
  padding: 1.25rem;
}
.taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-sidebar {
  left: -270px;
}
.taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-content {
  padding-left: 0;
}
.taskboardapp-wrap.taskboardapp-info-active .taskboardapp-detail-wrap .taskboard-info {
  right: 0;
}

.tasklist {
  min-height: 100px;
  width: 350px;
  flex: 0 0 auto;
  background: #f7f7f7;
}
.tasklist > .card-header {
  flex-flow: column;
}
.tasklist > .card-header > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
  margin-bottom: 1rem;
}
.tasklist .tasklist-handle {
  cursor: grab;
}
.tasklist .tasklist-handle h6 {
  pointer-events: none;
}
.tasklist.add-new-task {
  min-height: 0;
  border: 0;
  background: transparent;
}

.spipeline-list {
  min-height: 100px;
  width: 350px;
  flex: 0 0 auto;
  background: transparent;
}
.spipeline-list > .card-header {
  flex-flow: column;
  background: #fff;
  border-radius: 0.5rem !important;
  margin-bottom: .875rem;
}
.spipeline-list > .card-header > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}
.spipeline-list > .card-header > div .overall-estimation {
  color: #262a2e;
  font-weight: 500;
}
.spipeline-list > .card-header > div .spipeline-dot-sep {
  color: #d8d8d8;
  margin: 0 5px;
}
.spipeline-list > .card-header > div .lead-count {
  font-size: 0.75rem;
}
.spipeline-list > .card-header .btn-block {
  margin-top: 1rem;
}
.spipeline-list > .card-body {
  border-radius: 0.5rem !important;
  padding: 0;
}
.spipeline-list .spipeline-handle {
  cursor: grab;
}
.spipeline-list .spipeline-handle h6 {
  pointer-events: none;
}
.spipeline-list.create-new-list {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  min-height: 139px;
}
.spipeline-list.create-new-list > .card-header {
  background: transparent;
  margin: 0;
}
.spipeline-list.create-new-list > .card-header .btn-block {
  margin: 0;
}

.tasklist-card .card-header .card-action-wrap {
  opacity: 0;
  transition: opacity 0.2s ease;
}
.tasklist-card:hover .card-header .card-action-wrap {
  opacity: 1;
}
.tasklist-card .card-body {
  padding-top: 0;
}
.tasklist-card .card-footer > div {
  display: flex;
}
.tasklist-card .card-footer .task-counter,
.tasklist-card .card-footer .task-discuss {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
}
.tasklist-card .card-footer .task-counter > span,
.tasklist-card .card-footer .task-discuss > span {
  display: flex;
}
.tasklist-card .card-footer .task-counter > span:first-child,
.tasklist-card .card-footer .task-discuss > span:first-child {
  margin-right: .25rem;
}
.tasklist-card .card-footer .task-discuss {
  margin-left: .5rem;
}
.tasklist-card .card-footer .task-deadline {
  font-size: 0.875rem;
}

.spipeline-card .card-body {
  padding: .75rem 1.25rem;
}
.spipeline-card .card-body > .media .media-head {
  margin-right: 1rem;
}
.spipeline-card .card-body > .media .media-body .brand-name {
  color: #262a2e;
  font-weight: 600;
}
.spipeline-card .card-body > .media .media-body .price-estimation {
  color: #262a2e;
  font-weight: 500;
}
.spipeline-card .card-body > .media .media-body .media {
  margin-top: .25rem;
}
.spipeline-card .card-body > .media .media-body .media .media-head {
  margin-right: .25rem;
}
.spipeline-card .card-body > .media .media-body .media .media-body p {
  font-size: 0.75rem;
}
.spipeline-card .card-body .spipeline-dropdown .position-relative {
  top: -10px;
}
.spipeline-card .card-body .spipeline-dropdown .dropdown-item {
  padding: .5rem .75rem;
}
.spipeline-card.lost-deal {
  background: #ffebeb;
}
.spipeline-card.won-deal {
  background: #ebfcf5;
}

.hk-wrapper[data-navbar-style="collapsed"] .taskboardapp-wrap {
  height: 100vh;
}

.task-detail-modal .modal-body header.task-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 1.25rem;
  border-radius: 0.5rem 0.5rem 0 0;
  height: 65px;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
  margin-right: 12.5rem;
}
.task-detail-modal .modal-body header.task-header .apexcharts-datalabels-group text {
  font-family: inherit;
  font-size: 0.75rem;
  fill: #6f6f6f;
  position: absolute;
  transform: translateY(5px);
}
.task-detail-modal .modal-body header.task-header .apexcharts-datalabels-group text:last-child {
  display: none;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap {
  display: flex;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star {
  display: flex;
  align-items: center;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star > .feather-icon > svg, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star .svg-icon > svg {
  height: 21px;
  width: 21px;
  cursor: pointer;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star > .feather-icon > svg:hover, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg:hover, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap > a {
  display: inline-block;
}
.task-detail-modal .modal-body header.task-header .task-options-wrap > a:first-child {
  margin-left: 0;
}
.task-detail-modal .modal-body .task-detail-body {
  padding: 1.25rem;
  margin-right: 12.5rem;
}
.task-detail-modal .modal-body .task-detail-body form .media .media-head {
  margin-right: 1rem;
}
.task-detail-modal .modal-body .task-detail-body form .media .media-body .as-name {
  font-weight: 500;
  color: #262a2e;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media {
  margin-bottom: 1.25rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media .media-head {
  margin-right: 1rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:first-child {
  font-weight: 500;
  color: #262a2e;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:last-child {
  font-size: 0.875rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-head {
  margin-right: 1rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .cm-name {
  font-weight: 500;
  color: #262a2e;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .badge {
  margin-left: .625rem;
  flex-shrink: 0;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap span, .task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap a {
  color: #6f6f6f;
  font-size: 0.75rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {
  margin: 0 .25rem;
  color: #d8d8d8;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > .media {
  margin-top: 1.875rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files {
  margin: 0 -.8rem;
  padding-left: 0;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li {
  padding: .8rem;
  border-radius: 0.5rem;
  transition: 0.2s ease;
  margin-bottom: .25rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:last-child {
  margin-bottom: 0;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media {
  align-items: center;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-head {
  margin-right: 1rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-head .avatar.avatar-sm .avatar-icon {
  font-size: 1.75rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body {
  display: flex;
  align-items: center;
  min-width: 0;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:first-child {
  min-width: 0;
  flex: 1 1;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:last-child {
  display: flex;
  align-items: center;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-name {
  color: #262a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  max-width: 200px;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-size {
  margin-top: .25rem;
  font-size: 0.875rem;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover {
  background-color: #f2f2f2;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body .file-name {
  color: #0a2f4c;
}
.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body a.cp-file-action {
  color: #262a2e;
}
.task-detail-modal .modal-body .task-action-wrap {
  position: absolute;
  top: 0;
  width: 200px;
  right: 0;
  z-index: 1;
  border-left: 1px solid #eaeaea;
  bottom: 0;
  background: #fff;
}
.task-detail-modal .modal-body .task-action-wrap .nicescroll-bar {
  padding: 1.5rem;
}
.task-detail-modal .modal-body .task-action-wrap .nicescroll-bar .nav-vertical > .nav-item > .nav-link {
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 1399px) {
  .taskboardapp-wrap .taskboardapp-sidebar {
    left: -270px;
  }
  .taskboardapp-wrap .taskboardapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-sidebar {
    left: 0;
  }
  .taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-content {
    left: 270px;
    padding-left: 270px;
    margin-left: -270px;
  }
  .taskboardapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .taskboardapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .taskboardapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .taskboardapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
@media (max-width: 1199px) {
  .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-info {
    top: 0;
  }

  .info-close {
    position: relative;
    top: -4px;
  }

  .task-detail-modal .modal-body header.task-header,
  .task-detail-modal .modal-body .task-detail-body {
    margin-right: 0;
  }

  .task-action-wrap {
    display: none;
  }
}
/*Checklist List*/
.hk-checklist .form-check {
  margin-bottom: .625rem;
  position: relative;
}
.hk-checklist .form-check .form-check-label {
  position: relative;
}
.hk-checklist .form-check .done-strikethrough {
  display: block;
  height: 12px;
  background: #FF0000;
  mix-blend-mode: multiply;
  opacity: .08;
  width: 0;
  transition: width .35s ease-in-out, opacity .25s ease-in-out;
  position: absolute;
  margin-left: 0;
  top: 35%;
  left: 0;
  pointer-events: none;
  content: "";
}
.hk-checklist .form-check.form-check input:checked + label .done-strikethrough {
  width: 100%;
}
.hk-checklist .form-check .delete-checklist {
  position: absolute;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.hk-checklist .form-check:hover .delete-checklist {
  opacity: 1;
}
.hk-checklist .add-new-checklist .feather-icon {
  margin-right: .25rem;
}
.hk-checklist .form-control.checklist-input, .hk-checklist .checklist-input.form-select, .hk-checklist .wizard > .content > .body input.checklist-input, .wizard > .content > .body .hk-checklist input.checklist-input, .hk-checklist .checklist-input.dd-handle {
  position: absolute;
  top: 0;
  border: none;
  box-shadow: none;
  padding: 0;
  height: auto;
  width: auto;
}

/*Contact */
.contactapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
}
.contactapp-wrap .contactapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.contactapp-wrap .contactapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
  font-size: 1.5rem;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.contactapp-wrap .contactapp-sidebar .menu-content-wrap .tag-cloud .badge {
  margin-bottom: .25rem;
}
.contactapp-wrap .contactapp-sidebar .contactapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.contactapp-wrap .contactapp-content {
  display: flex;
  overflow: hidden;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.contactapp-wrap .contactapp-content header.contact-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.contactapp-wrap .contactapp-content header.contact-header .contactapp-title {
  display: flex;
  align-items: center;
}
.contactapp-wrap .contactapp-content header.contact-header .contactapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.contactapp-wrap .contactapp-content header.contact-header .contactapp-title:after {
  top: 0;
}
.contactapp-wrap .contactapp-content header.contact-header .media {
  align-items: center;
}
.contactapp-wrap .contactapp-content header.contact-header .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.contactapp-wrap .contactapp-content header.contact-header .media .media-body .user-name {
  font-size: 1rem;
  font-weight: 500;
  color: #262a2e;
  text-transform: capitalize;
}
.contactapp-wrap .contactapp-content header.contact-header .media .media-body .user-status {
  font-size: 0.875rem;
}
.contactapp-wrap .contactapp-content header.contact-header .contact-options-wrap {
  display: flex;
}
.contactapp-wrap .contactapp-content header.contact-header .contact-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.contactapp-wrap .contactapp-content header.contact-header .contact-options-wrap > a:first-child {
  margin-left: 0;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body {
  transition: all 0.2s ease;
  overflow: hidden;
  flex: 1 1;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar {
  padding: 1.25rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap {
  padding: 1rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form {
  border-radius: 0.5rem;
  padding: 1.25rem;
  background: #f7f7f7;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form .dropify-square {
  position: absolute;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form .dropify-square .dropify-wrapper {
  height: 5.75rem;
  width: 5.75rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form .col-md-12 {
  padding-left: 7.125rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-left,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-left,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right {
  min-height: 45px;
  display: flex;
  align-items: center;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-left > div,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-left > div {
  margin-right: 1rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-left > div:last-child,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-left > div:last-child {
  margin-right: 0;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right > div,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right > div {
  margin-left: 1rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right > div:first-child,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right > div:first-child {
  margin-left: 0;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_filter,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_filter,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info {
  float: none;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_filter label,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length label,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info label,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_filter label,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length label,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info label {
  margin-bottom: 0;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info {
  padding-top: 0;
  width: 95px;
  text-align: right;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_paginate,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_paginate {
  padding-top: 0;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child),
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {
  display: none;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link {
  padding: 0;
  background: transparent;
  min-width: auto;
  font-size: 1.25rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length select,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length select {
  margin-right: 0;
  margin-left: .625rem;
  display: inline-block;
  width: auto;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star {
  display: flex;
  margin-left: .625rem;
  font-size: 1rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star .svg-icon > svg {
  cursor: pointer;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .form-check.form-check-lg {
  position: absolute;
  left: 14px;
  top: 17px;
  cursor: pointer;
  opacity: 0;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-name {
  color: #262a2e;
  font-weight: 500;
  margin-top: .625rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-name,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-email,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-contact,
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-desg {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: .25rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .card-footer {
  padding: 0;
  justify-content: center;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .card-footer > .d-flex {
  padding: 0.75rem 1.25rem;
  justify-content: center;
  width: 100%;
  color: #6f6f6f;
  font-size: 1rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card:hover .form-check.form-check-lg {
  opacity: 1;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star {
  display: flex;
  margin-right: .625rem;
  opacity: 0;
  font-size: 1rem;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star .svg-icon > svg {
  cursor: pointer;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked {
  opacity: 1;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card:hover .contact-star {
  opacity: 1;
}
.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view.select-multiple .card.contact-card .form-check.form-check-lg {
  opacity: 1;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar {
  padding: 0 !important;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info {
  position: relative;
  padding: 1.25rem;
  flex-shrink: 0;
  border-right: 1px solid #eaeaea;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .action-btn {
  position: absolute;
  right: 1.25rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .cp-name {
  font-size: 1.25rem;
  font-weight: 500;
  color: #262a2e;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .cp-info {
  padding-left: 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .dropify-circle .dropify-wrapper {
  margin: 0 auto;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card {
  margin-bottom: 0;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  border-radius: 0;
  padding: 0.5rem 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-header {
  border: none;
  padding: .5rem 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-header > a {
  font-size: 0.875rem;
  font-weight: 500;
  display: block;
  width: 100%;
  color: #0a2f4c;
  text-align: left;
  position: relative;
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body {
  padding: .5rem 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li {
  margin-bottom: .625rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li a {
  color: #262a2e;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li > span {
  display: inline-block;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li > span:first-child {
  min-width: 100px;
  margin-right: 1rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li > span:last-child {
  color: #262a2e;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action {
  padding-left: 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li {
  margin-bottom: 10px;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li a {
  color: #262a2e;
  display: flex;
  align-items: center;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li a .cp-icon-wrap {
  display: flex;
  margin-right: .5rem;
  font-size: 1.125rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li:last-child {
  margin-bottom: .25rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info {
  flex-grow: 1;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .nav-tabs .nav-item .nav-link {
  padding: .75rem 1.25rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .nav-tabs.nav-line {
  border-bottom: 1px solid #eaeaea;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .tab-content {
  padding: 0 1.25rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap {
  padding: 0 1.25rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus {
  padding: 0;
  list-style-type: none;
  font-family: arial;
  font-size: 0.875rem;
  clear: both;
  line-height: 1em;
  margin: 0 -1px;
  text-align: center;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li {
  float: left;
  padding: 1rem 1.875rem 1rem 2.5rem;
  background: #d8d8d8;
  position: relative;
  width: 19.5%;
  margin: 0 1px;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:before {
  content: '';
  border-left: 20px solid #fff;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:first-child {
  border-radius: 0.5rem 0 0 0.5rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:first-child:before {
  display: none;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:last-child {
  border-radius: 0 0.5rem 0.5rem 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:last-child:after {
  display: none;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:after {
  content: '';
  border-left: 20px solid #d8d8d8;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 100%;
  z-index: 20;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.active {
  background: #FF9100;
  color: #fff;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.active:after {
  border-left-color: #FF9100;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.completed {
  background: #0a2f4c;
  color: #fff;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.completed:after {
  border-left-color: #0a2f4c;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li > span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap {
  padding: 0 1.25rem 1.25rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread {
  padding-left: 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li {
  margin-bottom: 1rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li:last-child {
  margin-bottom: 0;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li .media .media-head {
  margin-right: 1rem;
}
.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li .media .media-body > div .activity-time {
  font-size: 0.75rem;
  margin-top: .25rem;
}
.contactapp-wrap .contactapp-content .contact-detail-modal header.contact-header {
  height: auto;
  padding: 1.25rem;
  border-radius: 0.5rem 0.5rem 0 0;
}
.contactapp-wrap .contactapp-content .contact-detail-modal header.contact-header ul.hk-list.hk-list-sm li {
  padding: 0 .4rem;
}
.contactapp-wrap.contactapp-sidebar-toggle .contactapp-sidebar {
  left: -270px;
}
.contactapp-wrap.contactapp-sidebar-toggle .contactapp-content {
  padding-left: 0;
}

.hk-wrapper[data-navbar-style="collapsed"] .contactapp-wrap {
  height: 100vh;
}

@media (max-width: 1740px) {
  .contactapp-wrap .contactapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info,
  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length,
  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info,
  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length {
    display: none;
  }
  .contactapp-wrap .contactapp-sidebar {
    left: -270px;
  }
  .contactapp-wrap.contactapp-sidebar-toggle .contactapp-sidebar {
    left: 0;
  }
  .contactapp-wrap.contactapp-sidebar-toggle .contactapp-content {
    left: 270px;
    padding-left: 270px;
    margin-left: -270px;
  }
  .contactapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .contactapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .contactapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .contactapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
/*File Manager*/
.fmapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
}
.fmapp-wrap .fmapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.fmapp-wrap .fmapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.fmapp-wrap .fmapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
  font-size: 1.5rem;
}
.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.fmapp-wrap .fmapp-sidebar .fmapp-storage {
  padding: 1.5rem;
}
.fmapp-wrap .fmapp-sidebar .fmapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.fmapp-wrap .fmapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 270px;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fmapp-title {
  display: flex;
  align-items: center;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fmapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fmapp-title:after {
  top: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fm-options-wrap {
  display: flex;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fm-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fm-options-wrap > a:first-child {
  margin-left: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body {
  transition: all 0.2s ease;
  overflow: hidden;
  flex: 1 1;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar {
  padding: 1.25rem;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .nav-line {
  margin: 0 -1.25rem;
  border-bottom: 1px solid #eaeaea;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star {
  display: flex;
  margin-left: .625rem;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star .svg-icon > svg {
  height: 16px;
  width: 16px;
  cursor: pointer;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .media .media-body .file-name {
  color: #262a2e;
  font-weight: 500;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .fmapp-info-trigger.media {
  align-items: center;
  cursor: pointer;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .fmapp-info-trigger.media .media-body .file-name {
  transition: color 0.2s ease;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .fmapp-info-trigger.media:hover .media-body .file-name {
  color: #0a2f4c;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star {
  display: flex;
  margin-right: .25rem;
  margin-top: .4rem;
  margin-left: .625rem;
  opacity: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star .svg-icon > svg {
  cursor: pointer;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card {
  cursor: pointer;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-body {
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-body i {
  font-size: 2.375rem;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-footer {
  display: block;
  transition: background 0.2s ease;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-footer > .d-flex > div {
  min-width: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-footer > .d-flex > div .file-name {
  color: #262a2e;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .file-star.marked {
  opacity: 1;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card:hover .file-star {
  opacity: 1;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card:hover .card-footer {
  background: #ebf5f5;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card:hover .card-footer .file-name {
  color: #0a2f4c;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card {
  transition: background 0.2s ease;
  cursor: pointer;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media {
  overflow: hidden;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media .avatar {
  flex-shrink: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media .media-body {
  min-width: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media .media-body .file-name {
  color: #262a2e;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .file-star.marked {
  opacity: 1;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover {
  background: #ebf5f5;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover .file-star {
  opacity: 1;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover .card-body .media .avatar {
  flex-shrink: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover .card-body .media .media-body .file-name {
  color: #0a2f4c;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info {
  position: absolute;
  top: 65px;
  right: -370px;
  width: 370px;
  margin-left: 0;
  bottom: 0;
  z-index: 100;
  border: none;
  background: #fff;
  border-left: 1px solid #eaeaea;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .nicescroll-bar {
  padding: 1.25rem;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .file-name {
  color: #262a2e;
  font-size: 1.25rem;
  font-weight: 500;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info {
  padding-left: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li {
  margin-bottom: .625rem;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li a {
  color: #262a2e;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li > span {
  display: inline-block;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li > span:first-child {
  min-width: 100px;
  margin-right: 1rem;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li > span:last-child {
  color: #262a2e;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action {
  padding-left: 0;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action li {
  margin-bottom: .625rem;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action li a {
  color: #262a2e;
}
.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action li:last-child {
  margin-bottom: .25rem;
}
.fmapp-wrap.fmapp-info-active .fmapp-detail-wrap .file-info {
  right: 0;
}
.fmapp-wrap.fmapp-sidebar-toggle .fmapp-sidebar {
  left: -270px;
}
.fmapp-wrap.fmapp-sidebar-toggle .fmapp-content {
  padding-left: 0;
}

.hk-wrapper[data-navbar-style="collapsed"] .fmapp-wrap {
  height: 100vh;
}

@media (max-width: 1199px) {
  .fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info {
    top: 0;
  }
}
@media (max-width: 767px) {
  .fmapp-wrap .fmapp-sidebar {
    left: -270px;
  }
  .fmapp-wrap .fmapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .fmapp-wrap.fmapp-sidebar-toggle .fmapp-sidebar {
    left: 0;
  }
  .fmapp-wrap.fmapp-sidebar-toggle .fmapp-content {
    left: 270px;
    padding-left: 270px;
    margin-left: -270px;
  }
  .fmapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .fmapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .fmapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .fmapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
/*Gallery App*/
.galleryapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
}
.galleryapp-wrap .galleryapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.galleryapp-wrap .galleryapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
  font-size: 1.5rem;
}
.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.galleryapp-wrap .galleryapp-sidebar .galleryapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.galleryapp-wrap .galleryapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 270px;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .galleryapp-title {
  display: flex;
  align-items: center;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .galleryapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .galleryapp-title:after {
  top: 0;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .gallery-options-wrap {
  display: flex;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .gallery-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .gallery-options-wrap > a:first-child {
  margin-left: 0;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body {
  transition: all 0.2s ease;
  overflow: hidden;
  flex: 1 1;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar {
  padding: 1.25rem;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a {
  position: relative;
  display: block;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .form-check {
  position: absolute;
  left: 14px;
  top: 17px;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star {
  display: flex;
  position: absolute;
  right: 14px;
  top: 20px;
  opacity: 0;
  color: #6f6f6f;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star > .feather-icon > svg, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star .svg-icon > svg {
  cursor: pointer;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star > .feather-icon > svg:hover, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked {
  opacity: 1;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked > .feather-icon > svg, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked > .feather-icon > svg:hover, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a:hover .form-check {
  opacity: 1;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a:hover .gallery-star {
  opacity: 1;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-img {
  min-height: 230px;
  background-size: cover;
  background-position: center;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-img.gallery-video:after {
  content: "\\efb6";
  font-family: remixicon;
  font-style: normal;
  position: absolute;
  right: 14px;
  bottom: 14px;
  font-size: 1.5rem;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body.select-multiple .nicescroll-bar {
  padding: 1.25rem;
}
.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body.select-multiple .nicescroll-bar .hk-gallery a .form-check {
  opacity: 1;
}
.galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-sidebar {
  left: -270px;
}
.galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-content {
  padding-left: 0;
}

.lg-outer.galleryapp-info-active .lg-img-wrap {
  padding-right: 26.25rem !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll transparent;
  background-position: center center;
  background-position: calc((100% - 300px) / 2) center;
}
.lg-outer.galleryapp-info-active .lg-video-cont {
  padding-right: 20rem !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll transparent;
  background-position: center center;
  background-position: calc((100% - 300px) / 2) center;
}
.lg-outer.galleryapp-info-active .lg-sub-html {
  height: 100%;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 420px;
  z-index: 99999;
  left: auto;
  color: inherit;
  padding: 0;
  text-align: left;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll center center;
}
.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 1.25rem;
  margin: 0 -1.25rem;
  height: 65px;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .file-name {
  font-weight: 500;
  color: #262a2e;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .file-type {
  font-size: 0.75rem;
}
.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .gallery-options-wrap {
  display: flex;
}
.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .gallery-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .gallery-options-wrap > a:first-child {
  margin-left: 0;
}
.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li {
  margin-bottom: .625rem;
}
.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li > span {
  display: inline-block;
}
.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li > span:first-child {
  min-width: 100px;
  margin-right: 1rem;
}
.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li > span:last-child {
  color: #262a2e;
}
.lg-outer.galleryapp-info-active .galleryapp-info-active.fb_iframe_widget {
  background-image: none;
}
.lg-outer.galleryapp-info-active .galleryapp-info-active.fb_iframe_widget.fb_iframe_widget_loader {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll center center;
}
.lg-outer.galleryapp-info-active .lg-toolbar {
  right: 420px;
  width: auto;
}
.lg-outer.galleryapp-info-active .lg-actions .lg-next {
  right: 440px;
}
.lg-outer.galleryapp-info-active .lg-item {
  background-image: none;
}
.lg-outer.galleryapp-info-active .lg-item.lg-complete .lg-img-wrap {
  background-image: none;
}
.lg-outer.galleryapp-info-active .lg-item.lg-complete .lg-video-cont {
  background-image: none;
}

.hk-wrapper[data-navbar-style="collapsed"] .galleryapp-wrap {
  height: 100vh;
}

@media (max-width: 767px) {
  .galleryapp-wrap .galleryapp-sidebar {
    left: -270px;
  }
  .galleryapp-wrap .galleryapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-sidebar {
    left: 0;
  }
  .galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-content {
    left: 270px;
    padding-left: 270px;
    margin-left: -270px;
  }
  .galleryapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .galleryapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .galleryapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .galleryapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }

  .lg-outer.galleryapp-info-active .lg-img-wrap {
    padding-right: 0 !important;
  }
  .lg-outer.galleryapp-info-active .lg-video-cont {
    padding-right: 0 !important;
  }
  .lg-outer.galleryapp-info-active .lg-sub-html {
    display: none;
  }
  .lg-outer.galleryapp-info-active .lg-toolbar {
    right: 0;
  }
  .lg-outer.galleryapp-info-active .lg-actions .lg-next {
    right: 20px;
  }
}
/*Todo*/
.todoapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
}
.todoapp-wrap .todoapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.todoapp-wrap .todoapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.todoapp-wrap .todoapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link,
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap,
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap {
  display: flex;
  font-size: 1.5rem;
  margin-right: .875rem;
}
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text,
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.todoapp-wrap .todoapp-sidebar .todoapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.todoapp-wrap .todoapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 270px;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
  width: calc(100vw - 270px);
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 {
  display: flex;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star {
  display: flex;
  align-items: center;
  margin-left: .625rem;
  font-size: 1.25rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star .svg-icon > svg {
  cursor: pointer;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title:after {
  top: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media {
  align-items: center;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media .media-body .user-name {
  font-size: 1rem;
  font-weight: 500;
  color: #262a2e;
  text-transform: capitalize;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media .media-body .user-status {
  font-size: 0.875rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap {
  display: flex;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > .d-flex.ms-auto > a,
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > .d-flex.ms-auto > a:first-child,
.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > a:first-child {
  margin-left: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body {
  overflow: hidden;
  flex: 1 1;
  display: flex;
  margin-right: 0;
  transition: all 0.2s ease;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar {
  padding: 1.25rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar > div {
  display: flex;
  align-items: center;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar > div .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {
  display: none;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar > div .pagination.custom-pagination .page-link {
  padding: 0;
  background: transparent;
  min-width: auto;
  font-size: 1.25rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap {
  display: flex;
  height: 100%;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .gutter.gutter-horizontal {
  cursor: ew-resize;
  position: relative;
  width: 7px;
  cursor: ew-resize;
  text-align: center;
  background: #fff;
  border-left: 1px solid #eaeaea;
  border-right: 1px solid #eaeaea;
  z-index: 5;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .gutter.gutter-horizontal:after {
  display: inline-block;
  font-family: remixicon !important;
  font-style: normal;
  content: "\\ef26";
  position: absolute;
  top: 50%;
  left: -8px;
  font-size: 1.25rem;
  transform: translateY(-50%);
  color: #0a2f4c;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap {
  width: calc(100vw - 270px);
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star {
  display: flex;
  align-items: center;
  margin-left: .625rem;
  margin-right: .625rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star .svg-icon > svg {
  cursor: pointer;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-text {
  color: #262a2e;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task > div {
  display: flex;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable {
  margin-top: 0 !important;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable th:first-child, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable td:first-child {
  border-left-width: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable thead tr:first-child th, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable thead tr:first-child td {
  border-top-width: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container {
  overflow: initial;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt {
  fill: #0a2f4c;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .grid-row:nth-child(even) {
  fill: #fff;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .row-line, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .tick {
  stroke: #d8d8d8;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .bar {
  fill: #8e8e8e;
  stroke: #6f6f6f;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .bar-progress {
  fill: #0a2f4c;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .grid-header {
  stroke-width: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info {
  position: absolute;
  top: 65px;
  right: -550px;
  width: 550px;
  margin-left: 0;
  bottom: 0;
  z-index: 100;
  border: none;
  background: #fff;
  border-left: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 0 1.25rem;
  border-radius: 0.5rem 0.5rem 0 0;
  height: 65px;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .apexcharts-datalabels-group text {
  font-family: inherit;
  font-size: 0.75rem;
  fill: #6f6f6f;
  position: absolute;
  transform: translateY(5px);
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .apexcharts-datalabels-group text:last-child {
  display: none;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap {
  display: flex;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star {
  display: flex;
  align-items: center;
  margin-left: .625rem;
  font-size: 1.25rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star .svg-icon > svg {
  cursor: pointer;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap > a {
  display: inline-block;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap > a:first-child {
  margin-left: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body {
  padding: 1.25rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body form .media .media-head {
  margin-right: 1rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body form .media .media-body .as-name {
  font-weight: 500;
  color: #262a2e;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media {
  margin-bottom: 1.25rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media .media-head {
  margin-right: 1rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:first-child {
  font-weight: 500;
  color: #262a2e;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:last-child {
  font-size: 0.875rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-head {
  margin-right: 1rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .cm-name {
  font-weight: 500;
  color: #262a2e;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .badge {
  margin-left: .625rem;
  flex-shrink: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap span, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap a {
  color: #6f6f6f;
  font-size: 0.75rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {
  margin: 0 .25rem;
  color: #d8d8d8;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > .media {
  margin-top: 1.875rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files {
  padding-left: 0;
  margin: 0 -.8rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li {
  padding: .8rem;
  border-radius: 0.5rem;
  transition: 0.2s ease;
  margin-bottom: .25rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:last-child {
  margin-bottom: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media {
  align-items: center;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .avatar.avatar-sm {
  margin-right: 1rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .avatar.avatar-sm .avatar-icon {
  font-size: 1.75rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body {
  display: flex;
  align-items: center;
  min-width: 0;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:first-child {
  min-width: 0;
  flex: 1 1;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:last-child {
  display: flex;
  align-items: center;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-name {
  color: #262a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  max-width: 200px;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-size {
  margin-top: .25rem;
  font-size: 0.875rem;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover {
  background-color: #f2f2f2;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body .file-name {
  color: #0a2f4c;
}
.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body a.cp-file-action {
  color: #262a2e;
}
.todoapp-wrap.todoapp-sidebar-toggle .todoapp-sidebar {
  left: -270px;
}
.todoapp-wrap.todoapp-sidebar-toggle .todoapp-content {
  padding-left: 0;
}
.todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .todo-body {
  margin-right: 550px;
}
.todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .task-info {
  right: 0;
}
.todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar {
  padding: 0;
}
.todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar table.dataTable.cell-border thead th {
  border-right: 1px solid #eaeaea;
}
.todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar table.dataTable.cell-border tbody tr th:first-child, .todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar table.dataTable.cell-border tbody tr td:first-child {
  border-left: 0;
}

.advance-list-item.single-task-list .form-check {
  display: flex;
  margin-bottom: 0;
}
.advance-list-item.single-task-list .form-check + div {
  display: flex;
  align-items: center;
  font-weight: 500;
}
.advance-list-item.single-task-list .form-check + div .todo-star {
  display: flex;
  margin-left: .625rem;
}
.advance-list-item.single-task-list .form-check + div .todo-star > .feather-icon > svg, .advance-list-item.single-task-list .form-check + div .todo-star .svg-icon > svg {
  cursor: pointer;
}
.advance-list-item.single-task-list .form-check + div .todo-star > .feather-icon > svg:hover, .advance-list-item.single-task-list .form-check + div .todo-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.advance-list-item.single-task-list .form-check + div .todo-star.marked > .feather-icon > svg, .advance-list-item.single-task-list .form-check + div .todo-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.advance-list-item.single-task-list .form-check + div .todo-star.marked > .feather-icon > svg:hover, .advance-list-item.single-task-list .form-check + div .todo-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.advance-list-item.single-task-list .form-check + div .todo-text {
  cursor: pointer;
  max-width: 300px;
}
.advance-list-item.single-task-list .form-check + div .badge-indicator {
  margin: 0 .75rem  0 .5rem;
  flex-shrink: 0;
}
.advance-list-item.single-task-list.selected {
  background: #ebf5f5;
}

.hk-wrapper[data-navbar-style="collapsed"] .todoapp-wrap {
  height: 100vh;
}

@media (max-width: 1740px) {
  .todoapp-wrap .todoapp-sidebar {
    left: -270px;
  }
  .todoapp-wrap .todoapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .todoapp-wrap.todoapp-sidebar-toggle .todoapp-sidebar {
    left: 0;
  }
  .todoapp-wrap.todoapp-sidebar-toggle .todoapp-content {
    left: 270px;
    padding-left: 270px;
    margin-left: -270px;
  }
  .todoapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .todoapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .todoapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .todoapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
@media (max-width: 1500px) {
  .todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .todo-body {
    margin-right: 0;
  }
  .todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .task-info {
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  }
}
@media (max-width: 1199px) {
  .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info {
    top: 0;
    width: 100%;
    right: -100%;
  }
  .todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .task-info {
    right: 0;
  }
}
@media (max-width: 767px) {
  .advance-list-item.single-task-list {
    min-height: auto;
  }
  .advance-list-item.single-task-list .form-check + div .todo-text {
    cursor: pointer;
    max-width: calc(100vw - 250px);
  }
}
/*Blog App*/
.blogapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
}
.blogapp-wrap .blogapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.blogapp-wrap .blogapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .nav-header {
  padding: 0 0 .5rem 0;
  font-size: 0.875rem;
  color: #0a2f4c;
  font-weight: 500;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link[data-toggle="collapse"]::after {
  content: '\\f2f9';
  font: normal normal normal 18px/1 'Material-Design-Iconic-Font';
  text-rendering: auto;
  margin-left: auto;
  transform: translateX(0) rotate(0deg);
  transition: all 0.4s ease;
  color: rgba(38, 42, 46, 0.3);
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link[data-toggle="collapse"][aria-expanded="true"]::after {
  transform: translateX(0) rotate(-180deg);
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
  font-size: 1.5rem;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item .secondary-nav .nav-item .nav-link {
  padding-left: 3.3rem;
}
.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.blogapp-wrap .blogapp-sidebar .tag-cloud .badge {
  margin-bottom: .25rem;
}
.blogapp-wrap .blogapp-sidebar .blogapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.blogapp-wrap .blogapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 16.875rem;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blogapp-title {
  display: flex;
  align-items: center;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blogapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blogapp-title:after {
  top: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blog-options-wrap {
  display: flex;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blog-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blog-options-wrap > a:first-child {
  margin-left: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body {
  transition: all 0.2s ease;
  overflow: hidden;
  flex: 1 1;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar {
  padding: 1.25rem;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-left,
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right {
  min-height: 45px;
  display: flex;
  align-items: center;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-left > div {
  margin-right: 1rem;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-left > div:last-child {
  margin-right: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right > div {
  margin-left: 1rem;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right > div:first-child {
  margin-left: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_filter,
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length,
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info {
  float: none;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_filter label,
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length label,
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info label {
  margin-bottom: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info {
  padding-top: 0;
  width: 95px;
  text-align: right;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_paginate {
  padding-top: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {
  display: none;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link {
  padding: 0;
  background: transparent;
  min-width: auto;
  font-size: 1.25rem;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length select {
  margin-right: 0;
  margin-left: .625rem;
  display: inline-block;
  width: auto;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .tox-tinymce {
  border: 0;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .tox-tinymce .tox-statusbar__text-container {
  display: none !important;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .nav-tabs > .nav-item > .nav-link {
  position: relative;
  z-index: 1;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .nav-tabs > .nav-item > .nav-link.active {
  border-color: #eaeaea #eaeaea #fff;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .advance-option-post .nav-tabs {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .advance-option-post .uploaded-img-prev a .card {
  min-height: 100px;
  background-size: cover;
  background-position: center;
  margin-bottom: 0;
  margin-top: 1rem;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .nav-line {
  margin: 0 -1.25rem;
  border-bottom: 1px solid #eaeaea;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star {
  display: flex;
  margin-left: .625rem;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star > .feather-icon > svg, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star .svg-icon > svg {
  height: 16px;
  width: 16px;
  cursor: pointer;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star > .feather-icon > svg:hover, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked > .feather-icon > svg, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked > .feather-icon > svg:hover, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.blogapp-wrap.blogapp-sidebar-toggle .blogapp-sidebar {
  left: -270px;
}
.blogapp-wrap.blogapp-sidebar-toggle .blogapp-content {
  padding-left: 0;
}

.hk-wrapper[data-navbar-style="collapsed"] .blogapp-wrap {
  height: 100vh;
}

@media (max-width: 1740px) {
  .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info,
  .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length {
    display: none;
  }
}
@media (max-width: 767px) {
  .blogapp-wrap .blogapp-sidebar {
    left: -270px;
  }
  .blogapp-wrap .blogapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .blogapp-wrap.blogapp-sidebar-toggle .blogapp-sidebar {
    left: 0;
  }
  .blogapp-wrap.blogapp-sidebar-toggle .blogapp-content {
    left: 16.875rem;
    padding-left: 16.875rem;
    margin-left: -16.875rem;
  }
  .blogapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .blogapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .blogapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .blogapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
/*invoice*/
.invoiceapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
}
.invoiceapp-wrap .invoiceapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.invoiceapp-wrap .invoiceapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .nav-header {
  padding: 0 0 .5rem 0;
  font-size: 0.875rem;
  color: #0a2f4c;
  font-weight: 500;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
  font-size: 1.5rem;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.invoiceapp-wrap .invoiceapp-sidebar .invoiceapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.invoiceapp-wrap .invoiceapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 16.875rem;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoiceapp-title {
  display: flex;
  align-items: center;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoiceapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoiceapp-title:after {
  top: 0;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .media {
  align-items: center;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .media .media-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1rem;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .media .media-body .user-name {
  font-size: 1rem;
  font-weight: 500;
  color: #262a2e;
  text-transform: capitalize;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .media .media-body .user-status {
  font-size: 0.875rem;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoice-options-wrap {
  display: flex;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoice-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoice-options-wrap > a:first-child {
  margin-left: 0;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {
  transition: all 0.2s ease;
  overflow: hidden;
  flex: 1 1;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar {
  padding: 1.25rem;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-left,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right {
  min-height: 45px;
  display: flex;
  align-items: center;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-left > div {
  margin-right: 1rem;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-left > div:last-child {
  margin-right: 0;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right > div {
  margin-left: 1rem;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right > div:first-child {
  margin-left: 0;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_filter,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info {
  float: none;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_filter label,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length label,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info label {
  margin-bottom: 0;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info {
  padding-top: 0;
  width: 95px;
  text-align: right;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_paginate {
  padding-top: 0;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {
  display: none;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link {
  padding: 0;
  background: transparent;
  min-width: auto;
  font-size: 1.25rem;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length select {
  margin-right: 0;
  margin-left: .625rem;
  display: inline-block;
  width: auto;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star {
  display: flex;
  margin-left: .625rem;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star > .feather-icon > svg, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star .svg-icon > svg {
  cursor: pointer;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star > .feather-icon > svg:hover, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star .svg-icon > svg:hover {
  fill: #FFC400;
  stroke: #FFC400;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked > .feather-icon > svg, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked .svg-icon > svg {
  fill: #FFC400;
  stroke: #FFC400;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked > .feather-icon > svg:hover, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked .svg-icon > svg:hover {
  fill: none;
  stroke: currentColor;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap {
  border: 1px solid #eaeaea;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table thead tr th,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table thead tr th {
  border-color: transparent;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table thead tr th:first-child,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table thead tr th:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table thead tr th:last-child,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table thead tr th:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table {
  min-width: 450px;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table {
  border-collapse: separate;
  border-spacing: 0px;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table td, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table th,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table td,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table th,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table td,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table th,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table td,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table th {
  border: 1px solid #eaeaea;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .form-group,
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .form-group {
  position: relative;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {
  position: absolute;
  top: 65px;
  right: -370px;
  width: 370px;
  margin-left: 0;
  bottom: 0;
  z-index: 100;
  border: none;
  background: #fff;
  border-left: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings .nicescroll-bar {
  padding: 1.25rem;
}
.invoiceapp-wrap.invoiceapp-setting-active .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {
  margin-right: 370px;
}
.invoiceapp-wrap.invoiceapp-setting-active .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {
  right: 0;
}
.invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-sidebar {
  left: -270px;
}
.invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-content {
  padding-left: 0;
}

.hk-wrapper[data-navbar-style="collapsed"] .invoiceapp-wrap {
  height: 100vh;
}

@media (max-width: 1740px) {
  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info,
  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length {
    display: none;
  }
}
@media (max-width: 1600px) {
  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  }
  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {
    margin-right: 0;
  }
  .invoiceapp-wrap.invoiceapp-setting-active .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {
    margin-right: 0;
  }
}
@media (max-width: 1199px) {
  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {
    top: 0;
  }
  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table-wrap .invoice-table {
    min-width: 900px;
  }
  .invoiceapp-wrap .invoiceapp-sidebar {
    left: -270px;
  }
  .invoiceapp-wrap .invoiceapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-sidebar {
    left: 0;
  }
  .invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-content {
    left: 16.875rem;
    padding-left: 16.875rem;
    margin-left: -16.875rem;
  }
  .invoiceapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .invoiceapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .invoiceapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .invoiceapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
/*Integrations*/
.integrationsapp-wrap {
  position: relative;
  height: calc(100vh - 65px);
}
.integrationsapp-wrap .integrationsapp-sidebar {
  position: absolute;
  display: flex;
  flex-flow: column;
  left: 0;
  width: 270px;
  margin-left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
  border: none;
  background: #fff;
  border-right: 1px solid #eaeaea;
  transition: all 0.2s ease;
}
.integrationsapp-wrap .integrationsapp-sidebar > div.nicescroll-bar {
  flex: 1 1 auto;
  overflow: auto;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap {
  padding: 1.5rem;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-gap {
  height: 25px;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .nav-header {
  padding: 0 0 .5rem 0;
  font-size: 0.875rem;
  color: #0a2f4c;
  font-weight: 500;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {
  margin-left: -1rem;
  margin-right: -1rem;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {
  border-radius: .5rem;
  padding: .5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {
  display: flex;
  margin-right: .875rem;
  font-size: 1.5rem;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {
  display: inline-block;
}
.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {
  background: rgba(0, 125, 136, 0.15);
  color: #0a2f4c;
}
.integrationsapp-wrap .integrationsapp-sidebar .integrationsapp-fixednav {
  height: 61px;
  border-top: 1px solid #eaeaea;
}
.integrationsapp-wrap .integrationsapp-content {
  display: flex;
  overflow: hidden;
  padding-left: 16.875rem;
  position: relative;
  height: 100%;
  left: 0;
  transition: all 0.2s ease;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap {
  position: relative;
  display: flex;
  flex-grow: 1;
  background: #fff;
  flex-flow: column;
  height: 100%;
  z-index: 10;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 65px;
  padding: 0 1.25rem;
  background: #fff;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrationsapp-title {
  display: flex;
  align-items: center;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrationsapp-title h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrationsapp-title:after {
  top: 0;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrations-options-wrap {
  display: flex;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrations-options-wrap > a {
  margin-left: .25rem;
  display: inline-block;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrations-options-wrap > a:first-child {
  margin-left: 0;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body {
  transition: all 0.2s ease;
  overflow: hidden;
  flex: 1 1;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar {
  padding: 1.25rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .app-name {
  color: #262a2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .app-cat {
  font-size: 0.875rem;
  margin-bottom: .625rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-head {
  margin-right: 1rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > div:first-child {
  display: flex;
  align-items: center;
  margin-bottom: .25rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > div:first-child .cm-name {
  font-weight: 500;
  color: #262a2e;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > div:first-child .badge {
  margin-left: .625rem;
  flex-shrink: 0;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body .comment-action-wrap span, .integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body .comment-action-wrap a {
  color: #6f6f6f;
  font-size: 0.75rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {
  margin: 0 .25rem;
  color: #d8d8d8;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > .media {
  margin-top: 1.875rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .media .media-head {
  margin-right: 1rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .media .media-body .cr-name {
  font-weight: 500;
  color: #262a2e;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review-action-wrap span, .integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review-action-wrap a {
  font-size: 0.75rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review-action-wrap .review-dot-sep {
  margin: 0 .25rem;
  color: #d8d8d8;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review .review {
  margin-left: 3.125rem;
  margin-top: 1.875rem;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .card-int {
  min-height: 250px;
}
.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .content-aside .tag-cloud .badge {
  margin-bottom: .25rem;
}
.integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-sidebar {
  left: -270px;
}
.integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-content {
  padding-left: 0;
}

.hk-wrapper[data-navbar-style="collapsed"] .integrationsapp-wrap {
  height: 100vh;
}

/*------------------------ custom --------------------------------*/


.swal2-styled.swal2-confirm {
  background-color: #08364d;
}
.hk-pg-wrapper-custom{
  height: 100vh;
  padding-bottom:60px;
}
.text-white-color{
  color:#fff!important;
}
.text-white-color h2{
  color:#fff!important;
}

/*-------------------Multiselect Dropdown---------------------*/
.chips{
  background-color: green !important;
}
/*----------------------------------------*/
/*-------------------Multiselect Dropdown---------------------*/
@media (max-width: 660px) {
  .setDiscount_section{
flex-wrap: wrap;
justify-content: center;
align-items: center;
  }
.showDiscounts_section{
  justify-content:center;
   align-items:center;
}
.discount-header_section{
  margin-bottom: 30px;
}
}
@media (max-width: 480px) {
  .colomns_wrapper{
flex-wrap: wrap;
justify-content: center;
align-items: center;
  }
  .discount-header_section{
    margin-bottom: 50px;
  }
}
.new_box-content{
  width: 100%;
  padding: 20px;
  p{
    font-size: 18px;
    background: linear-gradient(to left, #000 , #11749e);
    -webkit-background-clip: text;
    background-clip:text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
  }
  h3{
    font-size: 17px;
    background: linear-gradient(to left, #000 , #11749e);
    -webkit-background-clip: text;
    background-clip:text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
  }
  }
@media (max-width: 360px) {
  .new_box-content{
font-size: 15px;
}
}
.colomns_wrapper{
  display:flex;
  gap:30px
}
.discount-section_box,.new_discount-box{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  max-width: 300px;
  box-shadow: 0 0 1rem #08364d;
  overflow: hidden;
  display: flex;
  padding: 0;
  margin-bottom: 20px;
  cursor: pointer;
}
.section_box-content, .new_box-content{
  position: absolute;
  color: #000;
}
/*----------------------------------------*/

@media (max-width: 991px) {
  .integrationsapp-wrap .integrationsapp-sidebar {
    left: -270px;
  }
  .integrationsapp-wrap .integrationsapp-content {
    margin-left: 0;
    padding-left: 0;
  }
  .integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-sidebar {
    left: 0;
  }
  .integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-content {
    left: 16.875rem;
    padding-left: 16.875rem;
    margin-left: -16.875rem;
  }
  .integrationsapp-wrap .hk-sidebar-togglable {
    transform: translateX(32px);
  }
  .integrationsapp-wrap .hk-sidebar-togglable:after {
    content: "\\ea6c";
  }
  .integrationsapp-wrap .hk-sidebar-togglable.active {
    transform: translateX(0);
  }
  .integrationsapp-wrap .hk-sidebar-togglable.active:after {
    content: "\\ea62";
  }
}
/*Horizontal Menu*/
@media (min-width: 1200px) {
  .hk-wrapper[data-layout="horizontal"] .chatapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .calendarapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .emailapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .taskboardapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .contactapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .fmapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .galleryapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .todoapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .blogapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .invoiceapp-wrap,
  .hk-wrapper[data-layout="horizontal"] .integrationsapp-wrap {
    height: calc(100vh - 130px);
  }
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .chatapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .calendarapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .emailapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .taskboardapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .contactapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .fmapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .galleryapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .todoapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .blogapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .invoiceapp-wrap,
  .hk-wrapper[data-layout="horizontal"][data-navbar-style="collapsed"] .integrationsapp-wrap {
    height: calc(100vh - 65px);
  }
}


/* Change react multiselect dropdown size */
.optionContainer {
  height: 10rem;
  overflow: hidden;
}
/*______________________________________________*/
/*--------------------Table Column Header------------------------------*/
.columnHeader{
  display:flex;
  justify-content:center;
  align-items:center
}
td{
  overflow: hidden;
}
/*---------------------------------------------------------------------*/
/*-------------------------Payment Progress Bar--------------------------------*/
.progress-bar-container{
  width: 180px;
}
.progress-bar{
  width: 100%;
  height: 1.5rem;
  border-radius: 10px;
  background-color: #e6e6e6;
  position: relative; 
  p{
    z-index: 100;
    color: #000;
    font-weight: 500;
  }
}
.progress-bar-fill{
  height: 100%;
  border-radius: 10px;
  background-color: #2ecc71;
  transition: width 0.5s ease-out;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center; 
  align-items: center;
 
}
/*---------------------------------------------------------------------*/
@media print {
  body{
    counter-reset: page;
  }
  #pageNumber::before{
    counter-increment: page;
    content: 'Էջ:' counter(page);
    display: flex;
    flex-direction: row-reverse;
  }
}
.form-control.custom-datepicker{
  min-width: 250px;
  }`, "",{"version":3,"sources":["webpack://./src/dist/css/style.css","webpack://./src/dist/src/scss/style.scss","webpack://./src/dist/src/scss/mixins.scss","webpack://./src/dist/src/scss/variables.scss","webpack://./../vendors/bourbon/app/assets/stylesheets/addons/_prefixer.scss","webpack://./src/dist/src/scss/header.scss","webpack://./src/dist/src/scss/footer.scss","webpack://./src/dist/src/scss/nav.scss","webpack://./src/dist/src/scss/horizontal-menu.scss","webpack://./../vendors/bourbon/app/assets/stylesheets/css3/_transition.scss","webpack://./src/dist/src/scss/vertical-classic-menu.scss","webpack://./src/dist/src/scss/vertical-icon-menu.scss","webpack://./src/dist/src/scss/navbar-menu.scss","webpack://./src/dist/src/scss/drawer.scss","webpack://./src/dist/src/scss/apps.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACChB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;oEDyHoE;ACEpE,6BAAA;AACA,cAAA;AACA,6BAAA;ADoBA;;;oEEjIU;AA0FV,SAAA;AC3GA,iBAAA;AHwJA;;;oEGyOM;AHrON;EGuOE,4CAAmB;EACnB,mBAAkB;EHrOlB,kBAAkB;AACpB;ACXA;;AAEA,aAAA;AACA;;ADcA,6BCZW;ADaX,YCZU;ADaV,6BAA6B;AAC7B;ECZA,SAAQ;EACP,UAAU;EDcT,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;ECZC,iBAAa;ADcd;;AAEA;ECZC,cAAW;EDcV,uCAAuC;EACvC,mCAAmC;ECZrC,8BAAA;EACC,wCAAuC;EDctC,YAAY;;ACZd;ADeA,6BCdc;ADed,oBAAoB;AACpB,qBAAqB,YAAY,CAAC;ACblC,6BAAG;;ADgBH;ECdC,uCAAU;ADgBX;;ACdE;EACC,UAAA;ADiBH;;AAEA;ECdE,gBAAe;ADgBjB;ACfE;EACC,gBAAc;ADiBjB;AACA;EChBG,uBAAA;ADkBH;AACA;EChBI,gBAAS;EACT,eAAY;ADkBhB;AACA;EChBI,sBAAqB;EACrB,qBAAkB;ADkBtB;AACA;;;ECbG,qBAAE;EACD,YAAU;EACV,WAAO;EDiBT,kBAAkB;ECbnB,qBAAU;EACT,kBAAS;EACT,WAAS;EACT,YAAS;EACT,SAAA;ADeF;AACA;ECbE,eAAe;EDef,QAAQ;ACdR;ADgBF;ECZI,aAAQ;EACT,eAAA;EACC,iBAAc;EDiBhB,eAAe;AACjB;ACZA;EACG,eAAe;ADclB;AACA;EIpNQ,gBAAiB;AJsNzB;AACA;ECfC,cAAQ;ADiBT;;AAEA;ECfC,qBAAQ;EACP,cAAA;EDmBA,2BAA2B;ACf5B;ADiBD;EACE,qBAAqB;EChBrB,cAAA;ADkBF;AACA;ECfC,qBAAe;EACd,aAAO;EDiBP,cAAc;AChBd;ADkBF;EACE,yBAAyB;ACf1B;ADiBD;EACE,yBAAyB;AChBzB;ADkBF;EACE,yBAAyB;ACf1B;ADiBD;EACE,yBAAyB;AChBzB;ADkBF;EACE,yBAAyB;ACf1B;ADiBD;EACE,yBAAyB;AChBzB;ADkBF;EACE,yBAAyB;ACf1B;ADiBD;EACE,yBAAyB;AChBzB;ADkBF;EACE,yBAAyB;ACf1B;ADiBD;EACE,yBAAyB;AChBzB;ADkBF;EACE,yBAAyB;ACf1B;ADiBD;EACE,yBAAyB;AChBzB;ADkBF;EACE,yBAAyB;ACd1B;ADgBD;EACE,yBAAyB;ACfzB;ADiBF;EACE,yBAAyB;ACd1B;ADgBD;EACE,yBAAyB;ACfzB;ADiBF;EACE,yBAAyB;ACd1B;ADgBD;ECdE,yBAAoB;ADgBtB;AACA;ECfE,sBAAA;ADiBF;AACA;ECdC,+BAAe;ADgBhB;AACA;ECdC,yBAAiB;EAChB,oBAAkB;EDgBlB,yBAAiB;UAAjB,iBAAiB;ACdlB;ADgBD;EACE,yBAAyB;AAC3B;ACdA;EACC,gBE1D+B;AH0EhC;AACA;ECfA,kBAAkB;ADiBlB;AACA;ECfC,iBAAY;ADiBb;;ACfC;EACC,cAAS;ADkBX;;AAEA;EAGE,aAAa;EACb,mBAAmB;ACdnB;ADgBF;ECXA,aAAA;ADeA;AACA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;ACAA;ADEF;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;ACOA;ADLF;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;ECexB;ADbF;AACA;EACE,oBAAoB;ACgBtB;;ADbA;EACE,qBAAqB;ACevB;;ADZA;EACE,mBAAmB;ACcrB;;ADXA;EACE,YAAY;ACWd;;AAEA;EAEA,gBAAa;AACb;;ADTA;EACE,eAAe;ACWjB;;ADRA,6BAA6B;AAC7B,YAAY;ACUZ,6BAAiB;ADRjB,YCSC;ADRD;EACE,kBAAkB;ACSpB;;ADNA;EACE,kBAAkB;ACQpB;;ADLA;EACE,oBAAoB;AACtB;;AAEA;ECOC,mBAAS;ADLV;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;ECKtB,qBAAe;EGnaP,gBAAA;EAIA,uBAAyB;EAYzB,mBAAoB;AJmZ5B;;ACGA;EACC,mBAAW;ADAZ;;ACEA;EDGE,cAAc;AAChB;;AAEA;ECAI,0BAAa;ADEjB;;AAEA;ECDA,yBAAc;EACb,gBAAW;ADGZ;;ACDA;EACC,4BAAqB;EACrB,aAAM;EDIL,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EAEE,oBAAkB;ACHpB;;ADMA;EI/bQ,cAAgB;AJicxB;;AAEA;EACE,aAAa;ACRf;;ADWA;EAKE,0BAA0B;ACb5B;;ADgBA;EAKE,0BAA0B;ACd5B;;ADiBA,eAAe;AACf;ECdI,aAAW;EDkBb,uBAAuB;AACzB;;ACZI;EACI,aAAK;ADeb;;AChBI;EDoBF,SAAO;AACT;;AAEA,MCtBW;ADuBX;EACE,oBAAoB;ACnBtB;;ADsBA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,WAAW;AACX;;;;;;;;;;;;;;;;ECNC,6BAAgB;EAChB,UAAO;ADuBR;;ACrBA;EACC,iBAAQ;EACR,kBAAiB;ADwBlB;;AAEA;ECvBA,iBAAA;EACC,mBAAQ;ADyBT;;AAEA;EACE,oBAAoB;ECxBtB,kBAAqB;EACpB,oBAAgB;AD0BjB;;AAEA;EI1hBQ,oBHggBY;EG5fZ,mBH4fY;EGxfZ,oBHwfY;AD8BpB;;AC5BA;EACC,iBAAQ;EACR,qBAAoB;EG5fb,qCH6fqC;ADmC7C;;ACjCA;EACC,oBAAiB;EACjB,qBAAkB;EGjgBX,qCHkgBY;ADwCpB;;ACtCA;EACC,kBAAO;EACP,mBAAkB;EGtgBX,sCHugBsC;AD6C9C;;AC3CA;EACC,mBAAM;EACN,mBAAkB;EG3gBX,sCH4gBY;ADkDpB;;AChDA;EACC,oBAAgB;EAChB,mBAAiB;EGhhBV,2CHihB2C;ADuDnD;;ACrDA;EACC,iBAAgB;EAChB,kBAAO;EGrhBA,2CHshB0C;AD4DlD;;AC1DA;EACC,iBAAQ;EACR,mBAAiB;EG9hBV,0CHgiBY;ADgEpB;;AAEA;EChEA,oBAAA;EACC,kBAAQ;EACR,oBAAkB;EGpiBX,0CHsiBY;ADqEpB;;AAEA;ECrEA,oBAAA;EACC,mBAAgB;EAChB,oBAAO;EGtiBA,yCHuiBY;AD2EpB;;ACzEA;EACC,iBAAQ;EACR,qBAAoB;EG3iBb,0CH4iByC;ADgFjD;;AC9EA;EACC,oBAAiB;EACjB,qBAAkB;EGhjBX,yCHijBY;ADqFpB;;ACnFA;EACC,kBAAO;EACP,mBAAkB;EGrjBX,2CHsjB0C;AD0FlD;;ACxFA;ED2FE,mBAAmB;EACnB,mBAAmB;EAKnB,0CAA0C;AC1F5C;;AD6FA;;;;EIhqBQ,6BHskBY;EGlkBZ,UAAY;AJkqBpB;;AC9FA;EACC,mBAAkB;EAClB,oBAAM;EGtkBC,2CHukB0C;ADqGlD;;ACnGA;EACC,mBAAQ;EACR,qBAAkB;EG/kBX,0CHilBY;ADyGpB;;AAEA;ECzGA,sBAAA;EACC,oBAAQ;EACR,oBAAM;EGrlBC,0CHulBY;AD8GpB;;AAEA;EC9GA,sBAAW;EAaP,qBAAW;EACP,oBAAS;EDwGf,yCAAyC;AAC3C;;AAEA,UC3Ge;AD4Gf;EACE,wBAAwB;AC9GtB;;ADiHJ;EACE,2BAA2B;AClHzB;;ADqHJ;EACE,0BAA0B;ACtHxB;;ADyHJ;EACE,wBAAwB;AC1HtB;;AD6HJ;EACE,0BAA0B;AC9HxB;;ADiIJ;EACE,wBAAwB;AClItB;;ADqIJ;EACE,0BAA0B;ACtIxB;;ADyIJ;EACE,wBAAwB;AC1ItB;;AD6IJ;EACE,0BAA0B;AC9IxB;;ADiJJ;EACE,wBAAwB;AClJtB;;ADqJJ;EACE,0BAA0B;ACtJxB;;ADyJJ;EACE,wBAAwB;AC1JtB;;AD6JJ;EACE,0BAA0B;AC9JxB;;ADiKJ;EACE,wBAAwB;AClKtB;;ADqKJ;EACE,0BAA0B;ACtKxB;;ADyKJ;EACE,wBAAwB;AC1KtB;;AD6KJ;EACE,0BAA0B;AC9KxB;;ADiLJ;EACE,wBAAwB;AClLtB;;ADqLJ;EACE,0BAA0B;ACtLxB;;ADyLJ;EACE,wBAAwB;AC1LtB;;AD6LJ;EACE,0BAA0B;AC9LxB;;ADiMJ;EACE,yBAAyB;AClMvB;;ADqMJ;EACE,2BAA2B;ACtMzB;;ADyMJ;EACE,yBAAyB;AC1MvB;;AD6MJ;EACE,2BAA2B;AC9MzB;;ADiNJ;EACE,yBAAyB;AClNvB;;ADqNJ;EACE,2BAA2B;ACtNzB;;ADyNJ;EACE,yBAAyB;AC1NvB;;AD6NJ;EACE,2BAA2B;AC9NzB;;ADiOJ;EACE,yBAAyB;AClOvB;;ADqOJ;EACE,2BAA2B;ACtOzB;;ADyOJ;EACE,yBAAyB;AC1OvB;;AD6OJ;EACE,2BAA2B;AC9OzB;;ADiPJ;EACE,yBAAyB;AClPvB;;ADqPJ;EACE,2BAA2B;ACtPzB;;ADyPJ;EACE,yBAAyB;AC1PvB;;AD6PJ;EACE,2BAA2B;AC9PzB;;ADiQJ;EACE,yBAAyB;AClQvB;;ADqQJ;EACE,2BAA2B;ACtQzB;;ADyQJ;EACE,yBAAyB;AC1QvB;;AD6QJ;EACE,2BAA2B;AC9QzB;;ADiRJ;EACE,yBAAyB;AClRvB;;ADqRJ;EACE,2BAA2B;ACtRzB;;ADyRJ;EACE,yBAAyB;AC1RvB;;AD6RJ;EACE,2BAA2B;AC9RzB;;ADiSJ;EACE,yBAAyB;AClSvB;;ADqSJ;EACE,2BAA2B;ACtSzB;;ADySJ;EACE,yBAAyB;AC1SvB;;AD6SJ;EACE,2BAA2B;AC9SzB;;ADiTJ;EACE,yBAAyB;AClTvB;;ADqTJ;EACE,2BAA2B;ACtTzB;;ADyTJ;EACE,yBAAyB;AC1TvB;;AD6TJ;EACE,2BAA2B;AC9TzB;;ADiUJ;EACE,yBAAyB;AClUvB;;ADqUJ;EACE,2BAA2B;ACtUzB;;ADyUJ;EACE,yBAAyB;AC1UvB;;AD6UJ;EACE,2BAA2B;AC9UzB;;ADiVJ;EACE,yBAAyB;AClVvB;;ADqVJ;EACE,2BAA2B;ACtVzB;;ADyVJ;EACE,yBAAyB;AC1VvB;;AD6VJ;EACE,2BAA2B;AC9VzB;;ADiWJ;EACE,yBAAyB;AClWvB;;ADqWJ;EACE,2BAA2B;ACtWzB;;ADyWJ;EACE,yBAAyB;AC1WvB;;AD6WJ;EACE,2BAA2B;AC9WzB;;ADiXJ;EACE,yBAAyB;AClXvB;;ADqXJ;EACE,2BAA2B;ACtXzB;;ADyXJ;EACE,yBAAyB;AC1XvB;;AD6XJ;EACE,2BAA2B;AC9XzB;;ADiYJ;EACE,yBAAyB;AClYvB;;ADqYJ;EACE,2BAA2B;ACtYzB;;ADyYJ;EACE,yBAAyB;AC1YvB;;AD6YJ;EACE,2BAA2B;AC9YzB;;ADiZJ;EACE,yBAAyB;AClZvB;;ADqZJ;EACE,2BAA2B;ACtZzB;;ADyZJ;EACE,yBAAyB;AC1ZvB;;AD6ZJ;EACE,2BAA2B;AC9ZzB;;ADiaJ;EACE,yBAAyB;AClavB;;ADqaJ;EACE,2BAA2B;ACtazB;;ADyaJ;EACE,yBAAyB;AC1avB;;AD6aJ;EACE,2BAA2B;AC9azB;;ADibJ;EACE,yBAAyB;AClbvB;;ADqbJ;EACE,2BAA2B;ACtbzB;;ADybJ;EACE,yBAAyB;AC1bvB;;AD6bJ;EACE,2BAA2B;AC9bzB;;ADicJ;EACE,yBAAyB;AClcvB;;ADqcJ;EACE,2BAA2B;ACtczB;;ADycJ;EACE,yBAAyB;AC1cvB;;AD6cJ;EACE,2BAA2B;AC9czB;;ADidJ;EACE,yBAAyB;ACldvB;;ADqdJ;EACE,2BAA2B;ACtdzB;;ADydJ;EACE,yBAAyB;AC1dvB;;AD6dJ;EACE,2BAA2B;AC9dzB;;ADieJ;EACE,yBAAyB;AClevB;;ADqeJ;EACE,2BAA2B;ACtezB;;ADyeJ;EACE,yBAAyB;AC1evB;;AD6eJ;EACE,2BAA2B;AC9ezB;;ADifJ;EACE,yBAAyB;AClfvB;;ADqfJ;EACE,2BAA2B;ACtfzB;;ADyfJ;EACE,yBAAyB;AC1fvB;;AD6fJ;EACE,2BAA2B;AC9fzB;;ADigBJ;EACE,yBAAyB;AClgBvB;;ADqgBJ;EACE,2BAA2B;ACtgBzB;;ADygBJ;EACE,yBAAyB;AC1gBvB;;AD6gBJ;EACE,2BAA2B;AC9gBzB;;ADihBJ;EACE,yBAAyB;AClhBvB;;ADqhBJ;EACE,2BAA2B;ACthBzB;;ADyhBJ;EACE,yBAAyB;AC1hBvB;;AD6hBJ;EACE,2BAA2B;AC9hBzB;;ADiiBJ;EACE,yBAAyB;ACliBvB;;ADqiBJ;EACE,2BAA2B;ACtiBzB;;ADyiBJ;EACE,yBAAyB;AC1iBvB;;AD6iBJ;EACE,2BAA2B;AC9iBzB;;ADijBJ;EACE,yBAAyB;ACljBvB;;ADqjBJ;EACE,2BAA2B;ACtjBzB;;ADyjBJ;EACE,yBAAyB;AC1jBvB;;AD6jBJ;EACE,2BAA2B;AC9jBzB;;ADikBJ;EACE,yBAAyB;AClkBvB;;ADqkBJ;EACE,2BAA2B;ACtkBzB;;ADykBJ;EACE,yBAAyB;AC1kBvB;;AD6kBJ;EACE,2BAA2B;AC9kBzB;;ADilBJ;EACE,yBAAyB;ACllBvB;;ADqlBJ;EACE,2BAA2B;ACtlBzB;;ADylBJ;EACE,yBAAyB;AC1lBvB;;AD6lBJ;EACE,2BAA2B;AC9lBzB;;ADimBJ;EACE,yBAAyB;AClmBvB;;ADqmBJ;EACE,2BAA2B;ACtmBzB;;ADymBJ;EACE,yBAAyB;AC1mBvB;;AD6mBJ;EACE,2BAA2B;AC9mBzB;;ADinBJ;EACE,yBAAyB;AClnBvB;;ADqnBJ;EACE,2BAA2B;ACtnBzB;;ADynBJ;EACE,yBAAyB;AC1nBvB;;AD6nBJ;EACE,2BAA2B;AC9nBzB;;ADioBJ;EACE,yBAAyB;ACloBvB;;ADqoBJ;EACE,2BAA2B;ACtoBzB;;ADyoBJ;EACE,yBAAyB;AC1oBvB;;AD6oBJ;EACE,2BAA2B;AC9oBzB;;ADipBJ;EACE,yBAAyB;AClpBvB;;ADqpBJ;EACE,2BAA2B;ACtpBzB;;ADypBJ;EACE,yBAAyB;AC1pBvB;;AD6pBJ;EACE,2BAA2B;AC9pBzB;;ADiqBJ;EACE,yBAAyB;AClqBvB;;ADqqBJ;EACE,2BAA2B;ACtqBzB;;ADyqBJ;EACE,yBAAyB;AC1qBvB;;AD6qBJ;EACE,2BAA2B;AC9qBzB;;ADirBJ;EACE,yBAAyB;AClrBvB;;ADqrBJ;EACE,2BAA2B;ACtrBzB;;ADyrBJ;EACE,yBAAyB;AC1rBvB;;AD6rBJ;EACE,2BAA2B;AC9rBzB;;ADisBJ;EACE,yBAAyB;AClsBvB;;ADqsBJ;EACE,2BAA2B;ACtsBzB;;ADysBJ;EACE,yBAAyB;AC1sBvB;;AD6sBJ;EACE,2BAA2B;AC9sBzB;;ADitBJ;EACE,yBAAyB;ACltBvB;;ADqtBJ;EACE,2BAA2B;ACttBzB;;ADytBJ;EACE,yBAAyB;AC1tBvB;;AD6tBJ;EACE,2BAA2B;AC9tBzB;;ADiuBJ;EACE,yBAAyB;ACluBvB;;ADquBJ;EACE,2BAA2B;ACntBzB;;ADstBJ;EACE,yBAAyB;ACvtBvB;;AD0tBJ;EACE,2BAA2B;AC3tBzB;;AD8tBJ;EACE,4BAA4B;AC/tB1B;;ADkuBJ;EACE,+BAA+B;ACnuB7B;;ADsuBJ;EACE,8BAA8B;ACvuB5B;;AD0uBJ;EACE,4BAA4B;AC3uB1B;;AD8uBJ;EACE,8BAA8B;AC/uB5B;;ADkvBJ;EACE,4BAA4B;ACnvB1B;;ADsvBJ;EACE,8BAA8B;ACvvB5B;;AD0vBJ;EACE,4BAA4B;AC3vB1B;;AD8vBJ;EACE,8BAA8B;AC/vB5B;;ADkwBJ;EACE,4BAA4B;ACnwB1B;;ADswBJ;EACE,8BAA8B;ACvwB5B;;AD0wBJ;EACE,4BAA4B;AC3wB1B;;AD8wBJ;EACE,8BAA8B;AC/wB5B;;ADkxBJ;EACE,4BAA4B;ACnxB1B;;ADsxBJ;EACE,8BAA8B;ACvxB5B;;AD0xBJ;EACE,4BAA4B;AC3xB1B;;AD8xBJ;EACE,8BAA8B;AC/xB5B;;ADkyBJ;EACE,4BAA4B;ACnyB1B;;ADsyBJ;EACE,8BAA8B;ACvyB5B;;AD0yBJ;EACE,4BAA4B;AC3yB1B;;AD8yBJ;EACE,8BAA8B;AC/yB5B;;ADkzBJ;EACE,6BAA6B;ACnzB3B;;ADszBJ;EACE,+BAA+B;ACvzB7B;;AD0zBJ;EACE,6BAA6B;AC3zB3B;;AD8zBJ;EACE,+BAA+B;AC/zB7B;;ADk0BJ;EACE,6BAA6B;ACn0B3B;;ADs0BJ;EACE,+BAA+B;ACv0B7B;;AD00BJ;EACE,6BAA6B;AC30B3B;;AD80BJ;EACE,+BAA+B;AC/0B7B;;ADk1BJ;EACE,6BAA6B;ACn1B3B;;ADs1BJ;EACE,+BAA+B;ACv1B7B;;AD01BJ;EACE,6BAA6B;AC31B3B;;AD81BJ;EACE,+BAA+B;AC/1B7B;;ADk2BJ;EACE,6BAA6B;ACn2B3B;;ADs2BJ;EACE,+BAA+B;ACv2B7B;;AD02BJ;EACE,6BAA6B;AC32B3B;;AD82BJ;EACE,+BAA+B;AC/2B7B;;ADk3BJ;EACE,6BAA6B;ACn3B3B;;ADs3BJ;EACE,+BAA+B;ACv3B7B;;AD03BJ;EACE,6BAA6B;AC33B3B;;AD83BJ;EACE,+BAA+B;AC/3B7B;;ADk4BJ;EACE,6BAA6B;ACn4B3B;;ADs4BJ;EACE,+BAA+B;ACv4B7B;;AD04BJ;EACE,6BAA6B;AC34B3B;;AD84BJ;EACE,+BAA+B;AC/4B7B;;ADk5BJ;EACE,6BAA6B;ACn5B3B;;ADs5BJ;EACE,+BAA+B;ACv5B7B;;AD05BJ;EACE,6BAA6B;AC35B3B;;AD85BJ;EACE,+BAA+B;AC/5B7B;;ADk6BJ;EACE,6BAA6B;ACn6B3B;;ADs6BJ;EACE,+BAA+B;ACv6B7B;;AD06BJ;EACE,6BAA6B;AC36B3B;;AD86BJ;EACE,+BAA+B;AC/6B7B;;ADk7BJ;EACE,6BAA6B;ACn7B3B;;ADs7BJ;EACE,+BAA+B;ACv7B7B;;AD07BJ;EACE,6BAA6B;AC37B3B;;AD87BJ;EACE,+BAA+B;AC/7B7B;;ADk8BJ;EACE,6BAA6B;ACn8B3B;;ADs8BJ;EACE,+BAA+B;ACv8B7B;;AD08BJ;EACE,6BAA6B;AC38B3B;;AD88BJ;EACE,+BAA+B;AC/8B7B;;ADk9BJ;EACE,6BAA6B;ACn9B3B;;ADs9BJ;EACE,+BAA+B;ACv9B7B;;AD09BJ;EACE,6BAA6B;AC39B3B;;AD89BJ;EACE,+BAA+B;AC/9B7B;;ADk+BJ;EACE,6BAA6B;ACn+B3B;;ADs+BJ;EACE,+BAA+B;ACv+B7B;;AD0+BJ;EACE,6BAA6B;AC3+B3B;;AD8+BJ;EACE,+BAA+B;AC/+B7B;;ADk/BJ;EACE,6BAA6B;ACn/B3B;;ADs/BJ;EACE,+BAA+B;ACv/B7B;;AD0/BJ;EACE,6BAA6B;AC3/B3B;;AD8/BJ;EACE,+BAA+B;AC//B7B;;ADkgCJ;EACE,6BAA6B;ACngC3B;;ADsgCJ;EACE,+BAA+B;ACvgC7B;;AD0gCJ;EACE,6BAA6B;AC3gC3B;;AD8gCJ;EACE,+BAA+B;AC/gC7B;;ADkhCJ;EACE,6BAA6B;ACnhC3B;;ADshCJ;EACE,+BAA+B;ACvhC7B;;AD0hCJ;EACE,6BAA6B;AC3hC3B;;AD8hCJ;EACE,+BAA+B;AC/hC7B;;ADkiCJ;EACE,6BAA6B;ACniC3B;;ADsiCJ;EACE,+BAA+B;ACviC7B;;AD0iCJ;EACE,6BAA6B;AC3iC3B;;AD8iCJ;EACE,+BAA+B;AC/iC7B;;ADkjCJ;EACE,6BAA6B;ACnjC3B;;ADsjCJ;EACE,+BAA+B;ACvjC7B;;AD0jCJ;EACE,6BAA6B;AC3jC3B;;AD8jCJ;EACE,+BAA+B;AC/jC7B;;ADkkCJ;EACE,6BAA6B;ACnkC3B;;ADskCJ;EACE,+BAA+B;ACvkC7B;;AD0kCJ;EACE,6BAA6B;AC3kC3B;;AD8kCJ;EACE,+BAA+B;AC/kC7B;;ADklCJ;EACE,6BAA6B;ACnlC3B;;ADslCJ;EACE,+BAA+B;ACvlC7B;;AD0lCJ;EACE,6BAA6B;AC3lC3B;;AD8lCJ;EACE,+BAA+B;AC/lC7B;;ADkmCJ;EACE,6BAA6B;ACnmC3B;;ADsmCJ;EACE,+BAA+B;ACvmC7B;;AD0mCJ;EACE,6BAA6B;AC3mC3B;;AD8mCJ;EACE,+BAA+B;AC/mC7B;;ADknCJ;EACE,6BAA6B;ACnnC3B;;ADsnCJ;EACE,+BAA+B;ACvnC7B;;AD0nCJ;EACE,6BAA6B;AC3nC3B;;AD8nCJ;EACE,+BAA+B;AC/nC7B;;ADkoCJ;EACE,6BAA6B;ACnoC3B;;ADsoCJ;EACE,+BAA+B;ACvoC7B;;AD0oCJ;EACE,6BAA6B;AC3oC3B;;AD8oCJ;EACE,+BAA+B;AC/oC7B;;ADkpCJ;EACE,6BAA6B;ACnpC3B;;ADspCJ;EACE,+BAA+B;ACvpC7B;;AD0pCJ;EACE,6BAA6B;AC3pC3B;;AD8pCJ;EACE,+BAA+B;AC/pC7B;;ADkqCJ;EACE,6BAA6B;ACnqC3B;;ADsqCJ;EACE,+BAA+B;ACvqC7B;;AD0qCJ;EACE,6BAA6B;AC3qC3B;;AD8qCJ;EACE,+BAA+B;AC/qC7B;;ADkrCJ;EACE,6BAA6B;ACnrC3B;;ADsrCJ;EACE,+BAA+B;ACvrC7B;;AD0rCJ;EACE,6BAA6B;AC3rC3B;;AD8rCJ;EACE,+BAA+B;AC/rC7B;;ADksCJ;EACE,6BAA6B;ACnsC3B;;ADssCJ;EACE,+BAA+B;ACvsC7B;;AD0sCJ;EACE,6BAA6B;AC3sC3B;;AD8sCJ;EACE,+BAA+B;AC/sC7B;;ADktCJ;EACE,6BAA6B;ACntC3B;;ADstCJ;EACE,+BAA+B;ACvtC7B;;AD0tCJ;EACE,6BAA6B;AC3tC3B;;AD8tCJ;EACE,+BAA+B;AC/tC7B;;ADkuCJ;EACE,6BAA6B;ACnuC3B;;ADsuCJ;EACE,+BAA+B;ACvuC7B;;AD0uCJ;EACE,6BAA6B;AC3uC3B;;AD8uCJ;EACE,+BAA+B;AC/uC7B;;ADkvCJ;EACE,6BAA6B;ACnvC3B;;ADsvCJ;EACE,+BAA+B;ACvvC7B;;AD0vCJ;EACE,6BAA6B;AC3vC3B;;AD8vCJ;EACE,+BAA+B;AC/vC7B;;ADkwCJ;EACE,6BAA6B;ACnwC3B;;ADswCJ;EACE,+BAA+B;ACvwC7B;;AD0wCJ;EACE,6BAA6B;AC3wC3B;;AD8wCJ;EACE,+BAA+B;AC/wC7B;;ADkxCJ;EACE,6BAA6B;ACnxC3B;;ADsxCJ;EACE,+BAA+B;ACvxC7B;;AD0xCJ;EACE,6BAA6B;AC3xC3B;;AD8xCJ;EACE,+BAA+B;AC/xC7B;;ADkyCJ;EACE,6BAA6B;ACnyC3B;;ADsyCJ;EACE,+BAA+B;ACvyC7B;;AD0yCJ;EACE,6BAA6B;AC3yC3B;;AD8yCJ;EACE,+BAA+B;AC/yC7B;;ADkzCJ;EACE,6BAA6B;ACnzC3B;;ADszCJ;EACE,+BAA+B;ACvzC7B;;AD0zCJ;EACE,6BAA6B;AC3zC3B;;AD8zCJ;EACE,+BAA+B;AC/zC7B;;ADk0CJ;EACE,6BAA6B;ACn0C3B;;ADs0CJ;EACE,+BAA+B;ACv0C7B;;AD00CJ;EACE,6BAA6B;AC30C3B;;AD80CJ;EACE,+BAA+B;AC/0C7B;;ADk1CJ;EACE,6BAA6B;ACn1C3B;;ADs1CJ;EACE,+BAA+B;ACp0C7B;;ADu0CJ;EACE,6BAA6B;ACx0C3B;;AD20CJ;EACE,+BAA+B;AC50C7B;;AD+0CJ;EACE,+BAA+B;ACh1C7B;;ADm1CJ;EACE,kCAAkC;ACp1ChC;;ADu1CJ;EACE,iCAAiC;ACx1C/B;;AD21CJ;EACE,+BAA+B;AC51C7B;;AD+1CJ;EACE,iCAAiC;ACh2C/B;;ADm2CJ;EACE,+BAA+B;ACp2C7B;;ADu2CJ;EACE,iCAAiC;ACx2C/B;;AD22CJ;EACE,+BAA+B;AC52C7B;;AD+2CJ;EACE,iCAAiC;ACh3C/B;;ADm3CJ;EACE,+BAA+B;ACp3C7B;;ADu3CJ;EACE,iCAAiC;ACx3C/B;;AD23CJ;EACE,+BAA+B;AC53C7B;;AD+3CJ;EACE,iCAAiC;ACh4C/B;;ADm4CJ;EACE,+BAA+B;ACp4C7B;;ADu4CJ;EACE,iCAAiC;ACx4C/B;;AD24CJ;EACE,+BAA+B;AC54C7B;;AD+4CJ;EACE,iCAAiC;ACh5C/B;;ADm5CJ;EACE,+BAA+B;ACp5C7B;;ADu5CJ;EACE,iCAAiC;ACx5C/B;;AD25CJ;EACE,+BAA+B;AC55C7B;;AD+5CJ;EACE,iCAAiC;ACh6C/B;;ADm6CJ;EACE,gCAAgC;ACp6C9B;;ADu6CJ;EACE,kCAAkC;ACx6ChC;;AD26CJ;EACE,gCAAgC;AC56C9B;;AD+6CJ;EACE,kCAAkC;ACh7ChC;;ADm7CJ;EACE,gCAAgC;ACp7C9B;;ADu7CJ;EACE,kCAAkC;ACx7ChC;;AD27CJ;EACE,gCAAgC;AC57C9B;;AD+7CJ;EACE,kCAAkC;ACh8ChC;;ADm8CJ;EACE,gCAAgC;ACp8C9B;;ADu8CJ;EACE,kCAAkC;ACx8ChC;;AD28CJ;EACE,gCAAgC;AC58C9B;;AD+8CJ;EACE,kCAAkC;ACh9ChC;;ADm9CJ;EACE,gCAAgC;ACp9C9B;;ADu9CJ;EACE,kCAAkC;ACx9ChC;;AD29CJ;EACE,gCAAgC;AC59C9B;;AD+9CJ;EACE,kCAAkC;ACh+ChC;;ADm+CJ;EACE,gCAAgC;ACp+C9B;;ADu+CJ;EACE,kCAAkC;ACx+ChC;;AD2+CJ;EACE,gCAAgC;AC5+C9B;;AD++CJ;EACE,kCAAkC;ACh/ChC;;ADm/CJ;EACE,gCAAgC;ACp/C9B;;ADu/CJ;EACE,kCAAkC;ACx/ChC;;AD2/CJ;EACE,gCAAgC;AC5/C9B;;AD+/CJ;EACE,kCAAkC;AChgDhC;;ADmgDJ;EACE,gCAAgC;ACpgD9B;;ADugDJ;EACE,kCAAkC;ACxgDhC;;AD2gDJ;EACE,gCAAgC;AC5gD9B;;AD+gDJ;EACE,kCAAkC;AChhDhC;;ADmhDJ;EACE,gCAAgC;ACphD9B;;ADuhDJ;EACE,kCAAkC;ACxhDhC;;AD2hDJ;EACE,gCAAgC;AC5hD9B;;AD+hDJ;EACE,kCAAkC;AChiDhC;;ADmiDJ;EACE,gCAAgC;ACpiD9B;;ADuiDJ;EACE,kCAAkC;ACxiDhC;;AD2iDJ;EACE,gCAAgC;AC5iD9B;;AD+iDJ;EACE,kCAAkC;AChjDhC;;ADmjDJ;EACE,gCAAgC;ACpjD9B;;ADujDJ;EACE,kCAAkC;ACxjDhC;;AD2jDJ;EACE,gCAAgC;AC5jD9B;;AD+jDJ;EACE,kCAAkC;AChkDhC;;ADmkDJ;EACE,gCAAgC;ACpkD9B;;ADukDJ;EACE,kCAAkC;ACxkDhC;;AD2kDJ;EACE,gCAAgC;AC5kD9B;;AD+kDJ;EACE,kCAAkC;AChlDhC;;ADmlDJ;EACE,gCAAgC;ACplD9B;;ADulDJ;EACE,kCAAkC;ACxlDhC;;AD2lDJ;EACE,gCAAgC;AC5lD9B;;AD+lDJ;EACE,kCAAkC;AChmDhC;;ADmmDJ;EACE,gCAAgC;ACpmD9B;;ADumDJ;EACE,kCAAkC;ACxmDhC;;AD2mDJ;EACE,gCAAgC;AC5mD9B;;AD+mDJ;EACE,kCAAkC;AChnDhC;;ADmnDJ;EACE,gCAAgC;ACpnD9B;;ADunDJ;EACE,kCAAkC;ACxnDhC;;AD2nDJ;EACE,gCAAgC;AC5nD9B;;AD+nDJ;EACE,kCAAkC;AChoDhC;;ADmoDJ;EACE,gCAAgC;ACpoD9B;;ADuoDJ;EACE,kCAAkC;ACxoDhC;;AD2oDJ;EACE,gCAAgC;AC5oD9B;;AD+oDJ;EACE,kCAAkC;AChpDhC;;ADmpDJ;EACE,gCAAgC;ACppD9B;;ADupDJ;EACE,kCAAkC;ACxpDhC;;AD2pDJ;EACE,gCAAgC;AC5pD9B;;AD+pDJ;EACE,kCAAkC;AChqDhC;;ADmqDJ;EACE,gCAAgC;ACpqD9B;;ADuqDJ;EACE,kCAAkC;ACxqDhC;;AD2qDJ;EACE,gCAAgC;AC5qD9B;;AD+qDJ;EACE,kCAAkC;AChrDhC;;ADmrDJ;EACE,gCAAgC;ACprD9B;;ADurDJ;EACE,kCAAkC;ACxrDhC;;AD2rDJ;EACE,gCAAgC;AC5rD9B;;AD+rDJ;EACE,kCAAkC;AChsDhC;;ADmsDJ;EACE,gCAAgC;ACpsD9B;;ADusDJ;EACE,kCAAkC;ACxsDhC;;AD2sDJ;EACE,gCAAgC;AC5sD9B;;AD+sDJ;EACE,kCAAkC;AChtDhC;;ADmtDJ;EACE,gCAAgC;ACptD9B;;ADutDJ;EACE,kCAAkC;ACxtDhC;;AD2tDJ;EACE,gCAAgC;AC5tD9B;;AD+tDJ;EACE,kCAAkC;AChuDhC;;ADmuDJ;EACE,gCAAgC;ACpuD9B;;ADuuDJ;EACE,kCAAkC;ACxuDhC;;AD2uDJ;EACE,gCAAgC;AC5uD9B;;AD+uDJ;EACE,kCAAkC;AChvDhC;;ADmvDJ;EACE,gCAAgC;ACpvD9B;;ADuvDJ;EACE,kCAAkC;ACxvDhC;;AD2vDJ;EACE,gCAAgC;AC5vD9B;;AD+vDJ;EACE,kCAAkC;AChwDhC;;ADmwDJ;EACE,gCAAgC;ACpwD9B;;ADuwDJ;EACE,kCAAkC;ACxwDhC;;AD2wDJ;EACE,gCAAgC;AC5wD9B;;AD+wDJ;EACE,kCAAkC;AChxDhC;;ADmxDJ;EACE,gCAAgC;ACpxD9B;;ADuxDJ;EACE,kCAAkC;ACxxDhC;;AD2xDJ;EACE,gCAAgC;AC5xD9B;;AD+xDJ;EACE,kCAAkC;AChyDhC;;ADmyDJ;EACE,gCAAgC;ACpyD9B;;ADuyDJ;EACE,kCAAkC;ACxyDhC;;AD2yDJ;EACE,gCAAgC;AC5yD9B;;AD+yDJ;EACE,kCAAkC;AChzDhC;;ADmzDJ;EACE,gCAAgC;ACpzD9B;;ADuzDJ;EACE,kCAAkC;ACxzDhC;;AD2zDJ;EACE,gCAAgC;AC5zD9B;;AD+zDJ;EACE,kCAAkC;ACh0DhC;;ADm0DJ;EACE,gCAAgC;ACp0D9B;;ADu0DJ;EACE,kCAAkC;ACx0DhC;;AD20DJ;EACE,gCAAgC;AC50D9B;;AD+0DJ;EACE,kCAAkC;ACh1DhC;;ADm1DJ;EACE,gCAAgC;ACp1D9B;;ADu1DJ;EACE,kCAAkC;ACx1DhC;;AD21DJ;EACE,gCAAgC;AC51D9B;;AD+1DJ;EACE,kCAAkC;ACh2DhC;;ADm2DJ;EACE,gCAAgC;ACp2D9B;;ADu2DJ;EACE,kCAAkC;ACx2DhC;;AD22DJ;EACE,gCAAgC;AC52D9B;;AD+2DJ;EACE,kCAAkC;ACh3DhC;;ADm3DJ;EACE,gCAAgC;ACp3D9B;;ADu3DJ;EACE,kCAAkC;ACx3DhC;;AD23DJ;EACE,gCAAgC;AC53D9B;;AD+3DJ;EACE,kCAAkC;ACh4DhC;;ADm4DJ;EACE,gCAAgC;ACp4D9B;;ADu4DJ;EACE,kCAAkC;ACx4DhC;;AD24DJ;EACE,gCAAgC;AC54D9B;;AD+4DJ;EACE,kCAAkC;ACh5DhC;;ADm5DJ;EACE,gCAAgC;ACp5D9B;;ADu5DJ;EACE,kCAAkC;ACx5DhC;;AD25DJ;EACE,gCAAgC;AC55D9B;;AD+5DJ;EACE,kCAAkC;ACh6DhC;;ADm6DJ;EACE,gCAAgC;ACp6D9B;;ADu6DJ;EACE,kCAAkC;ACx6DhC;;AD26DJ;EACE,gCAAgC;AC56D9B;;AD+6DJ;EACE,kCAAkC;ACh7DhC;;ADm7DJ;EACE,gCAAgC;ACp7D9B;;ADu7DJ;EACE,kCAAkC;ACx7DhC;;AD27DJ;EACE,gCAAgC;AC57D9B;;AD+7DJ;EACE,kCAAkC;ACh8DhC;;ADm8DJ;EACE,gCAAgC;ACp8D9B;;ADu8DJ;EACE,kCAAkC;ACr7DhC;;ADw7DJ;EACE,gCAAgC;ACz7D9B;;AD47DJ;EACE,kCAAkC;AC77DhC;;ADg8DJ;EACE,6BAA6B;ACj8D3B;;ADo8DJ;EACE,gCAAgC;ACr8D9B;;ADw8DJ;EACE,+BAA+B;ACz8D7B;;AD48DJ;EACE,6BAA6B;AC78D3B;;ADg9DJ;EACE,+BAA+B;ACj9D7B;;ADo9DJ;EACE,6BAA6B;ACr9D3B;;ADw9DJ;EACE,+BAA+B;ACz9D7B;;AD49DJ;EACE,6BAA6B;AC79D3B;;ADg+DJ;EACE,+BAA+B;ACj+D7B;;ADo+DJ;EACE,6BAA6B;ACr+D3B;;ADw+DJ;EACE,+BAA+B;ACz+D7B;;AD4+DJ;EACE,6BAA6B;AC7+D3B;;ADg/DJ;EACE,+BAA+B;ACj/D7B;;ADo/DJ;EACE,6BAA6B;ACr/D3B;;ADw/DJ;EACE,+BAA+B;ACz/D7B;;AD4/DJ;EACE,6BAA6B;AC7/D3B;;ADggEJ;EACE,+BAA+B;ACjgE7B;;ADogEJ;EACE,6BAA6B;ACrgE3B;;ADwgEJ;EACE,+BAA+B;ACzgE7B;;AD4gEJ;EACE,6BAA6B;AC7gE3B;;ADghEJ;EACE,+BAA+B;ACjhE7B;;ADohEJ;EACE,8BAA8B;ACrhE5B;;ADwhEJ;EACE,gCAAgC;ACzhE9B;;AD4hEJ;EACE,8BAA8B;AC7hE5B;;ADgiEJ;EACE,gCAAgC;ACjiE9B;;ADoiEJ;EACE,8BAA8B;ACriE5B;;ADwiEJ;EACE,gCAAgC;ACziE9B;;AD4iEJ;EACE,8BAA8B;AC7iE5B;;ADgjEJ;EACE,gCAAgC;ACjjE9B;;ADojEJ;EACE,8BAA8B;ACrjE5B;;ADwjEJ;EACE,gCAAgC;ACzjE9B;;AD4jEJ;EACE,8BAA8B;AC7jE5B;;ADgkEJ;EACE,gCAAgC;ACjkE9B;;ADokEJ;EACE,8BAA8B;ACrkE5B;;ADwkEJ;EACE,gCAAgC;ACzkE9B;;AD4kEJ;EACE,8BAA8B;AC7kE5B;;ADglEJ;EACE,gCAAgC;ACjlE9B;;ADolEJ;EACE,8BAA8B;ACrlE5B;;ADwlEJ;EACE,gCAAgC;ACzlE9B;;AD4lEJ;EACE,8BAA8B;AC7lE5B;;ADgmEJ;EACE,gCAAgC;ACjmE9B;;ADomEJ;EACE,8BAA8B;ACrmE5B;;ADwmEJ;EACE,gCAAgC;ACzmE9B;;AD4mEJ;EACE,8BAA8B;AC7mE5B;;ADgnEJ;EACE,gCAAgC;ACjnE9B;;ADonEJ;EACE,8BAA8B;ACrnE5B;;ADwnEJ;EACE,gCAAgC;ACznE9B;;AD4nEJ;EACE,8BAA8B;AC7nE5B;;ADgoEJ;EACE,gCAAgC;ACjoE9B;;ADooEJ;EACE,8BAA8B;ACroE5B;;ADwoEJ;EACE,gCAAgC;ACzoE9B;;AD4oEJ;EACE,8BAA8B;AC7oE5B;;ADgpEJ;EACE,gCAAgC;ACjpE9B;;ADopEJ;EACE,8BAA8B;ACrpE5B;;ADwpEJ;EACE,gCAAgC;ACzpE9B;;AD4pEJ;EACE,8BAA8B;AC7pE5B;;ADgqEJ;EACE,gCAAgC;ACjqE9B;;ADoqEJ;EACE,8BAA8B;ACrqE5B;;ADwqEJ;EACE,gCAAgC;ACzqE9B;;AD4qEJ;EACE,8BAA8B;AC7qE5B;;ADgrEJ;EACE,gCAAgC;ACjrE9B;;ADorEJ;EACE,8BAA8B;ACrrE5B;;ADwrEJ;EACE,gCAAgC;ACzrE9B;;AD4rEJ;EACE,8BAA8B;AC7rE5B;;ADgsEJ;EACE,gCAAgC;ACjsE9B;;ADosEJ;EACE,8BAA8B;ACrsE5B;;ADwsEJ;EACE,gCAAgC;ACzsE9B;;AD4sEJ;EACE,8BAA8B;AC7sE5B;;ADgtEJ;EACE,gCAAgC;ACjtE9B;;ADotEJ;EACE,8BAA8B;ACrtE5B;;ADwtEJ;EACE,gCAAgC;ACztE9B;;AD4tEJ;EACE,8BAA8B;AC7tE5B;;ADguEJ;EACE,gCAAgC;ACjuE9B;;ADouEJ;EACE,8BAA8B;ACruE5B;;ADwuEJ;EACE,gCAAgC;ACzuE9B;;AD4uEJ;EACE,8BAA8B;AC7uE5B;;ADgvEJ;EACE,gCAAgC;ACjvE9B;;ADovEJ;EACE,8BAA8B;ACrvE5B;;ADwvEJ;EACE,gCAAgC;ACzvE9B;;AD4vEJ;EACE,8BAA8B;AC7vE5B;;ADgwEJ;EACE,gCAAgC;ACjwE9B;;ADowEJ;EACE,8BAA8B;ACrwE5B;;ADwwEJ;EACE,gCAAgC;ACzwE9B;;AD4wEJ;EACE,8BAA8B;AC7wE5B;;ADgxEJ;EACE,gCAAgC;ACjxE9B;;ADoxEJ;EACE,8BAA8B;ACrxE5B;;ADwxEJ;EACE,gCAAgC;ACzxE9B;;AD4xEJ;EACE,8BAA8B;AC7xE5B;;ADgyEJ;EACE,gCAAgC;ACjyE9B;;ADoyEJ;EACE,8BAA8B;ACryE5B;;ADwyEJ;EACE,gCAAgC;ACzyE9B;;AD4yEJ;EACE,8BAA8B;AC7yE5B;;ADgzEJ;EACE,gCAAgC;ACjzE9B;;ADozEJ;EACE,8BAA8B;ACrzE5B;;ADwzEJ;EACE,gCAAgC;ACzzE9B;;AD4zEJ;EACE,8BAA8B;AC7zE5B;;ADg0EJ;EACE,gCAAgC;ACj0E9B;;ADo0EJ;EACE,8BAA8B;ACr0E5B;;ADw0EJ;EACE,gCAAgC;ACz0E9B;;AD40EJ;EACE,8BAA8B;AC70E5B;;ADg1EJ;EACE,gCAAgC;ACj1E9B;;ADo1EJ;EACE,8BAA8B;ACr1E5B;;ADw1EJ;EACE,gCAAgC;ACz1E9B;;AD41EJ;EACE,8BAA8B;AC71E5B;;ADg2EJ;EACE,gCAAgC;ACj2E9B;;ADo2EJ;EACE,8BAA8B;ACr2E5B;;ADw2EJ;EACE,gCAAgC;ACz2E9B;;AD42EJ;EACE,8BAA8B;AC72E5B;;ADg3EJ;EACE,gCAAgC;ACj3E9B;;ADo3EJ;EACE,8BAA8B;ACr3E5B;;ADw3EJ;EACE,gCAAgC;ACz3E9B;;AD43EJ;EACE,8BAA8B;AC73E5B;;ADg4EJ;EACE,gCAAgC;ACj4E9B;;ADo4EJ;EACE,8BAA8B;ACr4E5B;;ADw4EJ;EACE,gCAAgC;ACz4E9B;;AD44EJ;EACE,8BAA8B;AC74E5B;;ADg5EJ;EACE,gCAAgC;ACj5E9B;;ADo5EJ;EACE,8BAA8B;ACr5E5B;;ADw5EJ;EACE,gCAAgC;ACz5E9B;;AD45EJ;EACE,8BAA8B;AC75E5B;;ADg6EJ;EACE,gCAAgC;ACj6E9B;;ADo6EJ;EACE,8BAA8B;ACr6E5B;;ADw6EJ;EACE,gCAAgC;ACz6E9B;;AD46EJ;EACE,8BAA8B;AC76E5B;;ADg7EJ;EACE,gCAAgC;ACj7E9B;;ADo7EJ;EACE,8BAA8B;ACr7E5B;;ADw7EJ;EACE,gCAAgC;ACz7E9B;;AD47EJ;EACE,8BAA8B;AC77E5B;;ADg8EJ;EACE,gCAAgC;ACj8E9B;;ADo8EJ;EACE,8BAA8B;ACr8E5B;;ADw8EJ;EACE,gCAAgC;ACz8E9B;;AD48EJ;EACE,8BAA8B;AC78E5B;;ADg9EJ;EACE,gCAAgC;ACj9E9B;;ADo9EJ;EACE,8BAA8B;ACr9E5B;;ADw9EJ;EACE,gCAAgC;ACz9E9B;;AD49EJ;EACE,8BAA8B;AC79E5B;;ADg+EJ;EACE,gCAAgC;ACj+E9B;;ADo+EJ;EACE,8BAA8B;ACr+E5B;;ADw+EJ;EACE,gCAAgC;ACz+E9B;;AD4+EJ;EACE,8BAA8B;AC7+E5B;;ADg/EJ;EACE,gCAAgC;ACj/E9B;;ADo/EJ;EACE,8BAA8B;ACr/E5B;;ADw/EJ;EACE,gCAAgC;ACz/E9B;;AD4/EJ;EACE,8BAA8B;AC7/E5B;;ADggFJ;EACE,gCAAgC;ACjgF9B;;ADogFJ;EACE,8BAA8B;ACrgF5B;;ADwgFJ;EACE,gCAAgC;ACzgF9B;;AD4gFJ;EACE,8BAA8B;AC7gF5B;;ADghFJ;EACE,gCAAgC;ACjhF9B;;ADohFJ;EACE,8BAA8B;ACrhF5B;;ADwhFJ;EACE,gCAAgC;ACzhF9B;;AD4hFJ;EACE,8BAA8B;AC7hF5B;;ADgiFJ;EACE,gCAAgC;ACjiF9B;;ADoiFJ;EACE,8BAA8B;ACriF5B;;ADwiFJ;EACE,gCAAgC;ACziF9B;;AD4iFJ;EACE,8BAA8B;AC7iF5B;;ADgjFJ;EACE,gCAAgC;ACjjF9B;;ADojFJ;EACE,8BAA8B;ACrjF5B;;ADwjFJ;EACE,gCAAgC;ACtiF9B;;ADyiFJ;EACE,8BAA8B;AC1iF5B;;AD6iFJ;EACE,gCAAgC;AC9iF9B;;ADijFJ;EACE,8BAA8B;ACljF5B;;ADqjFJ;EACE,iCAAiC;ACtjF/B;;ADyjFJ;EACE,gCAAgC;AC1jF9B;;AD6jFJ;EACE,8BAA8B;AC9jF5B;;ADikFJ;EACE,gCAAgC;AClkF9B;;ADqkFJ;EACE,8BAA8B;ACtkF5B;;ADykFJ;EACE,gCAAgC;AC1kF9B;;AD6kFJ;EACE,8BAA8B;AC9kF5B;;ADilFJ;EACE,gCAAgC;ACllF9B;;ADqlFJ;EACE,8BAA8B;ACtlF5B;;ADylFJ;EACE,gCAAgC;AC1lF9B;;AD6lFJ;EACE,8BAA8B;AC9lF5B;;ADimFJ;EACE,gCAAgC;AClmF9B;;ADqmFJ;EACE,8BAA8B;ACtmF5B;;ADymFJ;EACE,gCAAgC;AC1mF9B;;AD6mFJ;EACE,8BAA8B;AC9mF5B;;ADinFJ;EACE,gCAAgC;AClnF9B;;ADqnFJ;EACE,8BAA8B;ACtnF5B;;ADynFJ;EACE,gCAAgC;AC1nF9B;;AD6nFJ;EACE,8BAA8B;AC9nF5B;;ADioFJ;EACE,gCAAgC;ACloF9B;;ADqoFJ;EACE,+BAA+B;ACtoF7B;;ADyoFJ;EACE,iCAAiC;AC1oF/B;;AD6oFJ;EACE,+BAA+B;AC9oF7B;;ADipFJ;EACE,iCAAiC;AClpF/B;;ADqpFJ;EACE,+BAA+B;ACtpF7B;;ADypFJ;EACE,iCAAiC;AC1pF/B;;AD6pFJ;EACE,+BAA+B;AC9pF7B;;ADiqFJ;EACE,iCAAiC;AClqF/B;;ADqqFJ;EACE,+BAA+B;ACtqF7B;;ADyqFJ;EACE,iCAAiC;AC1qF/B;;AD6qFJ;EACE,+BAA+B;AC9qF7B;;ADirFJ;EACE,iCAAiC;AClrF/B;;ADqrFJ;EACE,+BAA+B;ACtrF7B;;ADyrFJ;EACE,iCAAiC;AC1rF/B;;AD6rFJ;EACE,+BAA+B;AC9rF7B;;ADisFJ;EACE,iCAAiC;AClsF/B;;ADqsFJ;EACE,+BAA+B;ACtsF7B;;ADysFJ;EACE,iCAAiC;AC1sF/B;;AD6sFJ;EACE,+BAA+B;AC9sF7B;;ADitFJ;EACE,iCAAiC;ACltF/B;;ADqtFJ;EACE,+BAA+B;ACttF7B;;ADytFJ;EACE,iCAAiC;AC1tF/B;;AD6tFJ;EACE,+BAA+B;AC9tF7B;;ADiuFJ;EACE,iCAAiC;ACluF/B;;ADquFJ;EACE,+BAA+B;ACtuF7B;;ADyuFJ;EACE,iCAAiC;AC1uF/B;;AD6uFJ;EACE,+BAA+B;AC9uF7B;;ADivFJ;EACE,iCAAiC;AClvF/B;;ADqvFJ;EACE,+BAA+B;ACtvF7B;;ADyvFJ;EACE,iCAAiC;AC1vF/B;;AD6vFJ;EACE,+BAA+B;AC9vF7B;;ADiwFJ;EACE,iCAAiC;AClwF/B;;ADqwFJ;EACE,+BAA+B;ACtwF7B;;ADywFJ;EACE,iCAAiC;AC1wF/B;;AD6wFJ;EACE,+BAA+B;AC9wF7B;;ADixFJ;EACE,iCAAiC;AClxF/B;;ADqxFJ;EACE,+BAA+B;ACtxF7B;;ADyxFJ;EACE,iCAAiC;AC1xF/B;;AD6xFJ;EACE,+BAA+B;AC9xF7B;;ADiyFJ;EACE,iCAAiC;AClyF/B;;ADqyFJ;EACE,+BAA+B;ACtyF7B;;ADyyFJ;EACE,iCAAiC;AC1yF/B;;AD6yFJ;EACE,+BAA+B;AC9yF7B;;ADizFJ;EACE,iCAAiC;AClzF/B;;ADqzFJ;EACE,+BAA+B;ACtzF7B;;ADyzFJ;EACE,iCAAiC;AC1zF/B;;AD6zFJ;EACE,+BAA+B;AC9zF7B;;ADi0FJ;EACE,iCAAiC;ACl0F/B;;ADq0FJ;EACE,+BAA+B;ACt0F7B;;ADy0FJ;EACE,iCAAiC;AC10F/B;;AD60FJ;EACE,+BAA+B;AC90F7B;;ADi1FJ;EACE,iCAAiC;ACl1F/B;;ADq1FJ;EACE,+BAA+B;ACt1F7B;;ADy1FJ;EACE,iCAAiC;AC11F/B;;AD61FJ;EACE,+BAA+B;AC91F7B;;ADi2FJ;EACE,iCAAiC;ACl2F/B;;ADq2FJ;EACE,+BAA+B;ACt2F7B;;ADy2FJ;EACE,iCAAiC;AC12F/B;;AD62FJ;EACE,+BAA+B;AC92F7B;;ADi3FJ;EACE,iCAAiC;ACl3F/B;;ADq3FJ;EACE,+BAA+B;ACt3F7B;;ADy3FJ;EACE,iCAAiC;AC13F/B;;AD63FJ;EACE,+BAA+B;AC93F7B;;ADi4FJ;EACE,iCAAiC;ACl4F/B;;ADq4FJ;EACE,+BAA+B;ACt4F7B;;ADy4FJ;EACE,iCAAiC;AC14F/B;;AD64FJ;EACE,+BAA+B;AC94F7B;;ADi5FJ;EACE,iCAAiC;ACl5F/B;;ADq5FJ;EACE,+BAA+B;ACt5F7B;;ADy5FJ;EACE,iCAAiC;AC15F/B;;AD65FJ;EACE,+BAA+B;AC95F7B;;ADi6FJ;EACE,iCAAiC;ACl6F/B;;ADq6FJ;EACE,+BAA+B;ACt6F7B;;ADy6FJ;EACE,iCAAiC;AC16F/B;;AD66FJ;EACE,+BAA+B;AC96F7B;;ADi7FJ;EACE,iCAAiC;ACl7F/B;;ADq7FJ;EACE,+BAA+B;ACt7F7B;;ADy7FJ;EACE,iCAAiC;AC17F/B;;AD67FJ;EACE,+BAA+B;AC97F7B;;ADi8FJ;EACE,iCAAiC;ACl8F/B;;ADq8FJ;EACE,+BAA+B;ACt8F7B;;ADy8FJ;EACE,iCAAiC;AC18F/B;;AD68FJ;EACE,+BAA+B;AC98F7B;;ADi9FJ;EACE,iCAAiC;ACl9F/B;;ADq9FJ;EACE,+BAA+B;ACt9F7B;;ADy9FJ;EACE,iCAAiC;AC19F/B;;AD69FJ;EACE,+BAA+B;AC99F7B;;ADi+FJ;EACE,iCAAiC;ACl+F/B;;ADq+FJ;EACE,+BAA+B;ACt+F7B;;ADy+FJ;EACE,iCAAiC;AC1+F/B;;AD6+FJ;EACE,+BAA+B;AC9+F7B;;ADi/FJ;EACE,iCAAiC;ACl/F/B;;ADq/FJ;EACE,+BAA+B;ACt/F7B;;ADy/FJ;EACE,iCAAiC;AC1/F/B;;AD6/FJ;EACE,+BAA+B;AC9/F7B;;ADigGJ;EACE,iCAAiC;AClgG/B;;ADqgGJ;EACE,+BAA+B;ACtgG7B;;ADygGJ;EACE,iCAAiC;AC1gG/B;;AD6gGJ;EACE,+BAA+B;AC9gG7B;;ADihGJ;EACE,iCAAiC;AClhG/B;;ADqhGJ;EACE,+BAA+B;ACthG7B;;ADyhGJ;EACE,iCAAiC;AC1hG/B;;AD6hGJ;EACE,+BAA+B;AC9hG7B;;ADiiGJ;EACE,iCAAiC;ACliG/B;;ADqiGJ;EACE,+BAA+B;ACtiG7B;;ADyiGJ;EACE,iCAAiC;AC1iG/B;;AD6iGJ;EACE,+BAA+B;AC9iG7B;;ADijGJ;EACE,iCAAiC;ACljG/B;;ADqjGJ;EACE,+BAA+B;ACtjG7B;;ADyjGJ;EACE,iCAAiC;AC1jG/B;;AD6jGJ;EACE,+BAA+B;AC9jG7B;;ADikGJ;EACE,iCAAiC;AClkG/B;;ADqkGJ;EACE,+BAA+B;ACtkG7B;;ADykGJ;EACE,iCAAiC;AC1kG/B;;AD6kGJ;EACE,+BAA+B;AC9kG7B;;ADilGJ;EACE,iCAAiC;ACllG/B;;ADqlGJ;EACE,+BAA+B;ACtlG7B;;ADylGJ;EACE,iCAAiC;AC1lG/B;;AD6lGJ;EACE,+BAA+B;AC9lG7B;;ADimGJ;EACE,iCAAiC;AClmG/B;;ADqmGJ;EACE,+BAA+B;ACtmG7B;;ADymGJ;EACE,iCAAiC;AC1mG/B;;AD6mGJ;EACE,+BAA+B;AC9mG7B;;ADinGJ;EACE,iCAAiC;AClnG/B;;ADqnGJ;EACE,+BAA+B;ACtnG7B;;ADynGJ;EACE,iCAAiC;AC1nG/B;;AD6nGJ;EACE,+BAA+B;AC9nG7B;;ADioGJ;EACE,iCAAiC;ACloG/B;;ADqoGJ;EACE,+BAA+B;ACtoG7B;;ADyoGJ;EACE,iCAAiC;AC1oG/B;;AD6oGJ;EACE,+BAA+B;AC9oG7B;;ADipGJ;EACE,iCAAiC;AClpG/B;;ADqpGJ;EACE,+BAA+B;ACtpG7B;;ADypGJ;EACE,iCAAiC;AC1pG/B;;AD6pGJ;EACE,+BAA+B;AC9pG7B;;ADiqGJ;EACE,iCAAiC;AClqG/B;;ADqqGJ;EACE,+BAA+B;ACtqG7B;;ADyqGJ;EACE,iCAAiC;ACvpG/B;;AD0pGJ;EACE,+BAA+B;AACjC;;AAEA;EC5pGQ,iCAAuC;AD8pG/C;;AChqGI;EACI,6BAAc;EACd,8BAAe;ADmqGvB;;ACrqGI;EACI,gCAAsC;EACtC,iCAAuC;ADwqG/C;;AC1qGI;EACI,+BAAsC;EACtC,gCAAuC;AD6qG/C;;AC/qGI;EACI,6BAAsC;EACtC,8BAAuC;ADkrG/C;;ACprGI;EACI,+BAAsC;EACtC,gCAAuC;ADurG/C;;ACzrGI;EACI,6BAAsC;EACtC,8BAAuC;AD4rG/C;;AC9rGI;EACI,+BAAsC;EACtC,gCAAuC;ADisG/C;;ACnsGI;EACI,6BAAsC;EACtC,8BAAuC;ADssG/C;;ACxsGI;EACI,+BAAsC;EACtC,gCAAuC;AD2sG/C;;AC7sGI;EACI,6BAAsC;EACtC,8BAAuC;ADgtG/C;;ACltGI;EACI,+BAAsC;EACtC,gCAAuC;ADqtG/C;;ACvtGI;EACI,6BAAsC;EACtC,8BAAuC;AD0tG/C;;AC5tGI;EACI,+BAAsC;EACtC,gCAAuC;AD+tG/C;;ACjuGI;EACI,6BAAsC;EACtC,8BAAuC;ADouG/C;;ACtuGI;EACI,+BAAsC;EACtC,gCAAuC;ADyuG/C;;AC3uGI;EACI,6BAAsC;EACtC,8BAAuC;AD8uG/C;;AChvGI;EACI,+BAAsC;EACtC,gCAAuC;ADmvG/C;;ACrvGI;EACI,6BAAsC;EACtC,8BAAuC;ADwvG/C;;AC1vGI;EACI,+BAAsC;EACtC,gCAAuC;AD6vG/C;;AC/vGI;EACI,6BAAc;EACd,8BAAe;ADkwGvB;;ACpwGI;EACI,+BAAc;EACd,gCAAe;ADuwGvB;;ACzwGI;EACI,8BAAsC;EACtC,+BAAuC;AD4wG/C;;AC9wGI;EACI,gCAAsC;EACtC,iCAAuC;ADixG/C;;ACnxGI;EACI,8BAAsC;EACtC,+BAAuC;ADsxG/C;;ACxxGI;EACI,gCAAsC;EACtC,iCAAuC;AD2xG/C;;AC7xGI;EACI,8BAAsC;EACtC,+BAAuC;ADgyG/C;;AClyGI;EACI,gCAAsC;EACtC,iCAAuC;ADqyG/C;;ACvyGI;EACI,8BAAsC;EACtC,+BAAuC;AD0yG/C;;AC5yGI;EACI,gCAAsC;EACtC,iCAAuC;AD+yG/C;;ACjzGI;EACI,8BAAsC;EACtC,+BAAuC;ADozG/C;;ACtzGI;EACI,gCAAsC;EACtC,iCAAuC;ADyzG/C;;AC3zGI;EACI,8BAAsC;EACtC,+BAAuC;AD8zG/C;;ACh0GI;EACI,gCAAsC;EACtC,iCAAuC;ADm0G/C;;ACr0GI;EACI,8BAAsC;EACtC,+BAAuC;ADw0G/C;;AC10GI;EACI,gCAAsC;EACtC,iCAAuC;AD60G/C;;AC/0GI;EACI,8BAAsC;EACtC,+BAAuC;ADk1G/C;;ACp1GI;EACI,gCAAsC;EACtC,iCAAuC;ADu1G/C;;ACz1GI;EACI,8BAAsC;EACtC,+BAAuC;AD41G/C;;AC91GI;EACI,gCAAsC;EACtC,iCAAuC;ADi2G/C;;ACn2GI;EACI,8BAAsC;EACtC,+BAAuC;ADs2G/C;;ACx2GI;EACI,gCAAsC;EACtC,iCAAuC;AD22G/C;;AC72GI;EACI,8BAAsC;EACtC,+BAAuC;ADg3G/C;;ACl3GI;EACI,gCAAsC;EACtC,iCAAuC;ADq3G/C;;ACv3GI;EACI,8BAAsC;EACtC,+BAAuC;AD03G/C;;AC53GI;EACI,gCAAsC;EACtC,iCAAuC;AD+3G/C;;ACj4GI;EACI,8BAAsC;EACtC,+BAAuC;ADo4G/C;;ACt4GI;EACI,gCAAsC;EACtC,iCAAuC;ADy4G/C;;AC34GI;EACI,8BAAsC;EACtC,+BAAuC;AD84G/C;;ACh5GI;EACI,gCAAsC;EACtC,iCAAuC;ADm5G/C;;ACr5GI;EACI,8BAAsC;EACtC,+BAAuC;ADw5G/C;;AC15GI;EACI,gCAAsC;EACtC,iCAAuC;AD65G/C;;AC/5GI;EACI,8BAAsC;EACtC,+BAAuC;ADk6G/C;;ACp6GI;EACI,gCAAsC;EACtC,iCAAuC;ADu6G/C;;ACz6GI;EACI,8BAAsC;EACtC,+BAAuC;AD46G/C;;AC96GI;EACI,gCAAsC;EACtC,iCAAuC;ADi7G/C;;ACn7GI;EACI,8BAAsC;EACtC,+BAAuC;ADs7G/C;;ACx7GI;EACI,gCAAsC;EACtC,iCAAuC;AD27G/C;;AC77GI;EACI,8BAAsC;EACtC,+BAAuC;ADg8G/C;;ACl8GI;EACI,gCAAsC;EACtC,iCAAuC;ADq8G/C;;ACv8GI;EACI,8BAAsC;EACtC,+BAAuC;AD08G/C;;AC58GI;EACI,gCAAsC;EACtC,iCAAuC;AD+8G/C;;ACj9GI;EACI,8BAAsC;EACtC,+BAAuC;ADo9G/C;;ACt9GI;EACI,gCAAsC;EACtC,iCAAuC;ADy9G/C;;AC39GI;EACI,8BAAsC;EACtC,+BAAuC;AD89G/C;;ACh+GI;EACI,gCAAsC;EACtC,iCAAuC;ADm+G/C;;ACr+GI;EACI,8BAAsC;EACtC,+BAAuC;ADw+G/C;;AC1+GI;EACI,gCAAsC;EACtC,iCAAuC;AD6+G/C;;AC/+GI;EACI,8BAAsC;EACtC,+BAAuC;ADk/G/C;;ACp/GI;EACI,gCAAsC;EACtC,iCAAuC;ADu/G/C;;ACz/GI;EACI,8BAAsC;EACtC,+BAAuC;AD4/G/C;;AC9/GI;EACI,gCAAsC;EACtC,iCAAuC;ADigH/C;;ACngHI;EACI,8BAAsC;EACtC,+BAAuC;ADsgH/C;;ACxgHI;EACI,gCAAsC;EACtC,iCAAuC;AD2gH/C;;AC7gHI;EACI,8BAAsC;EACtC,+BAAuC;ADghH/C;;AClhHI;EACI,gCAAsC;EACtC,iCAAuC;ADqhH/C;;ACvhHI;EACI,8BAAsC;EACtC,+BAAuC;AD0hH/C;;AC5hHI;EACI,gCAAsC;EACtC,iCAAuC;AD+hH/C;;ACjiHI;EACI,8BAAsC;EACtC,+BAAuC;ADoiH/C;;ACtiHI;EACI,gCAAsC;EACtC,iCAAuC;ADyiH/C;;AC3iHI;EACI,8BAAsC;EACtC,+BAAuC;AD8iH/C;;AChjHI;EACI,gCAAsC;EACtC,iCAAuC;ADmjH/C;;ACrjHI;EACI,8BAAsC;EACtC,+BAAuC;ADwjH/C;;AC1jHI;EACI,gCAAsC;EACtC,iCAAuC;AD6jH/C;;AC/jHI;EACI,8BAAsC;EACtC,+BAAuC;ADkkH/C;;ACpkHI;EACI,gCAAsC;EACtC,iCAAuC;ADukH/C;;ACzkHI;EACI,8BAAsC;EACtC,+BAAuC;AD4kH/C;;AC9kHI;EACI,gCAAsC;EACtC,iCAAuC;ADilH/C;;ACnlHI;EACI,8BAAsC;EACtC,+BAAuC;ADslH/C;;ACxlHI;EACI,gCAAsC;EACtC,iCAAuC;AD2lH/C;;AC7lHI;EACI,8BAAsC;EACtC,+BAAuC;ADgmH/C;;AClmHI;EACI,gCAAsC;EACtC,iCAAuC;ADqmH/C;;ACvmHI;EACI,8BAAsC;EACtC,+BAAuC;AD0mH/C;;AC5mHI;EACI,gCAAsC;EACtC,iCAAuC;AD+mH/C;;ACjnHI;EACI,8BAAsC;EACtC,+BAAuC;ADonH/C;;ACtnHI;EACI,gCAAsC;EACtC,iCAAuC;ADynH/C;;AC3nHI;EACI,8BAAsC;EACtC,+BAAuC;AD8nH/C;;AChoHI;EACI,gCAAsC;EACtC,iCAAuC;ADmoH/C;;ACroHI;EACI,8BAAsC;EACtC,+BAAuC;ADwoH/C;;AC1oHI;EACI,gCAAsC;EACtC,iCAAuC;AD6oH/C;;AC/oHI;EACI,8BAAsC;EACtC,+BAAuC;ADkpH/C;;ACppHI;EACI,gCAAsC;EACtC,iCAAuC;ADupH/C;;ACzpHI;EACI,8BAAsC;EACtC,+BAAuC;AD4pH/C;;AC9pHI;EACI,gCAAsC;EACtC,iCAAuC;ADiqH/C;;ACnqHI;EACI,8BAAsC;EACtC,+BAAuC;ADsqH/C;;ACxqHI;EACI,gCAAsC;EACtC,iCAAuC;AD2qH/C;;AC7qHI;EACI,8BAAsC;EACtC,+BAAuC;ADgrH/C;;AClrHI;EACI,gCAAsC;EACtC,iCAAuC;ADqrH/C;;ACvrHI;EACI,8BAAsC;EACtC,+BAAuC;AD0rH/C;;AC5rHI;EACI,gCAAsC;EACtC,iCAAuC;AD+rH/C;;ACjsHI;EACI,8BAAsC;EACtC,+BAAuC;ADosH/C;;ACtsHI;EACI,gCAAsC;EACtC,iCAAuC;ADysH/C;;AC3sHI;EACI,8BAAsC;EACtC,+BAAuC;AD8sH/C;;AChtHI;EACI,gCAAsC;EACtC,iCAAuC;ADmtH/C;;ACrtHI;EACI,8BAAsC;EACtC,+BAAuC;ADwtH/C;;AC1tHI;EACI,gCAAsC;EACtC,iCAAuC;AD6tH/C;;AC/tHI;EACI,8BAAsC;EACtC,+BAAuC;ADkuH/C;;ACpuHI;EACI,gCAAsC;EACtC,iCAAuC;ADuuH/C;;ACzuHI;EACI,8BAAsC;EACtC,+BAAuC;AD4uH/C;;AC9uHI;EACI,gCAAsC;EACtC,iCAAuC;ADivH/C;;ACnvHI;EACI,8BAAsC;EACtC,+BAAuC;ADsvH/C;;ACxvHI;EACI,gCAAsC;EACtC,iCAAuC;AD2vH/C;;AC7vHI;EACI,8BAAsC;EACtC,+BAAuC;ADgwH/C;;AClwHI;EACI,gCAAsC;EACtC,iCAAuC;ADqwH/C;;ACvwHI;EACI,8BAAsC;EACtC,+BAAuC;AD0wH/C;;AC5wHI;EACI,gCAAsC;EACtC,iCAAuC;AD+wH/C;;ACjxHI;EACI,8BAAsC;EACtC,+BAAuC;ADoxH/C;;ACtxHI;EACI,gCAAsC;EACtC,iCAAuC;ADyxH/C;;AC3xHI;EACI,8BAAsC;EACtC,+BAAuC;AD8xH/C;;AChyHI;EACI,gCAAsC;EACtC,iCAAuC;ADmyH/C;;ACryHI;EACI,8BAAsC;EACtC,+BAAuC;ADwyH/C;;AC1yHI;EACI,gCAAsC;EACtC,iCAAuC;AD6yH/C;;AC/yHI;EACI,8BAAsC;EACtC,+BAAuC;ADkzH/C;;ACpzHI;EACI,gCAAsC;EACtC,iCAAuC;ADuzH/C;;ACzzHI;EACI,8BAAsC;EACtC,+BAAuC;AD4zH/C;;AC9zHI;EACI,gCAAsC;EACtC,iCAAuC;ADi0H/C;;ACn0HI;EACI,8BAAsC;EACtC,+BAAuC;ADs0H/C;;ACx0HI;EACI,gCAAsC;EACtC,iCAAuC;AD20H/C;;AC70HI;EACI,8BAAsC;EACtC,+BAAuC;ADg1H/C;;ACl1HI;EACI,gCAAsC;EACtC,iCAAuC;ADq1H/C;;ACv1HI;EACI,8BAAsC;EACtC,+BAAuC;AD01H/C;;AC51HI;EACI,gCAAsC;EACtC,iCAAuC;AD+1H/C;;ACj2HI;EACI,8BAAsC;EACtC,+BAAuC;ADo2H/C;;ACt2HI;EACI,gCAAsC;EACtC,iCAAuC;ADy2H/C;;AC32HI;EACI,8BAAsC;EACtC,+BAAuC;AD82H/C;;ACh3HI;EACI,gCAAsC;EACtC,iCAAuC;ADm3H/C;;ACr3HI;EACI,8BAAsC;EACtC,+BAAuC;ADw3H/C;;AC13HI;EACI,gCAAsC;EACtC,iCAAuC;AD63H/C;;AC/3HI;EACI,8BAAsC;EACtC,+BAAuC;ADk4H/C;;ACp4HI;EACI,gCAAsC;EACtC,iCAAuC;ADu4H/C;;ACz4HI;EACI,8BAAsC;EACtC,+BAAuC;AD44H/C;;AC94HI;EACI,gCAAsC;EACtC,iCAAuC;ADi5H/C;;ACn5HI;EACI,8BAAsC;EACtC,+BAAuC;ADs5H/C;;ACx5HI;EACI,gCAAsC;EACtC,iCAAuC;AD25H/C;;AC75HI;EACI,8BAAsC;EACtC,+BAAuC;ADg6H/C;;ACl6HI;EACI,gCAAsC;EACtC,iCAAuC;ADq6H/C;;ACv6HI;EACI,8BAAsC;EACtC,+BAAuC;AD06H/C;;AC56HI;EACI,gCAAsC;EACtC,iCAAuC;AD+6H/C;;ACj7HI;EACI,8BAAsC;EACtC,+BAAuC;ADo7H/C;;ACt7HI;EACI,gCAAsC;EACtC,iCAAuC;ADy7H/C;;ACv6HI;EACI,8BAAqC;EACrC,+BAAwC;AD06HhD;;AC56HI;EACI,gCAAqC;EACrC,iCAAgB;AD+6HxB;;ACj7HI;EACI,4BAAa;EACb,+BAAgB;ADo7HxB;;ACt7HI;EACI,+BAAqC;EACrC,kCAAwC;ADy7HhD;;AC37HI;EACI,8BAAqC;EACrC,iCAAwC;AD87HhD;;ACh8HI;EACI,4BAAqC;EACrC,+BAAwC;ADm8HhD;;ACr8HI;EACI,8BAAqC;EACrC,iCAAwC;ADw8HhD;;AC18HI;EACI,4BAAqC;EACrC,+BAAwC;AD68HhD;;AC/8HI;EACI,8BAAqC;EACrC,iCAAwC;ADk9HhD;;ACp9HI;EACI,4BAAqC;EACrC,+BAAwC;ADu9HhD;;ACz9HI;EACI,8BAAqC;EACrC,iCAAwC;AD49HhD;;AC99HI;EACI,4BAAqC;EACrC,+BAAwC;ADi+HhD;;ACn+HI;EACI,8BAAqC;EACrC,iCAAwC;ADs+HhD;;ACx+HI;EACI,4BAAqC;EACrC,+BAAwC;AD2+HhD;;AC7+HI;EACI,8BAAqC;EACrC,iCAAwC;ADg/HhD;;ACl/HI;EACI,4BAAqC;EACrC,+BAAwC;ADq/HhD;;ACv/HI;EACI,8BAAqC;EACrC,iCAAwC;AD0/HhD;;AC5/HI;EACI,4BAAqC;EACrC,+BAAwC;AD+/HhD;;ACjgII;EACI,8BAAqC;EACrC,iCAAwC;ADogIhD;;ACtgII;EACI,4BAAqC;EACrC,+BAAwC;ADygIhD;;AC3gII;EACI,8BAAqC;EACrC,iCAAwC;AD8gIhD;;AChhII;EACI,4BAAa;EACb,+BAAgB;ADmhIxB;;ACrhII;EACI,8BAAa;EACb,iCAAgB;ADwhIxB;;AC1hII;EACI,6BAAqC;EACrC,gCAAwC;AD6hIhD;;AC/hII;EACI,+BAAqC;EACrC,kCAAwC;ADkiIhD;;ACpiII;EACI,6BAAqC;EACrC,gCAAwC;ADuiIhD;;ACziII;EACI,+BAAqC;EACrC,kCAAwC;AD4iIhD;;AC9iII;EACI,6BAAqC;EACrC,gCAAwC;ADijIhD;;ACnjII;EACI,+BAAqC;EACrC,kCAAwC;ADsjIhD;;ACxjII;EACI,6BAAqC;EACrC,gCAAwC;AD2jIhD;;AC7jII;EACI,+BAAqC;EACrC,kCAAwC;ADgkIhD;;AClkII;EACI,6BAAqC;EACrC,gCAAwC;ADqkIhD;;ACvkII;EACI,+BAAqC;EACrC,kCAAwC;AD0kIhD;;AC5kII;EACI,6BAAqC;EACrC,gCAAwC;AD+kIhD;;ACjlII;EACI,+BAAqC;EACrC,kCAAwC;ADolIhD;;ACtlII;EACI,6BAAqC;EACrC,gCAAwC;ADylIhD;;AC3lII;EACI,+BAAqC;EACrC,kCAAwC;AD8lIhD;;AChmII;EACI,6BAAqC;EACrC,gCAAwC;ADmmIhD;;ACrmII;EACI,+BAAqC;EACrC,kCAAwC;ADwmIhD;;AC1mII;EACI,6BAAqC;EACrC,gCAAwC;AD6mIhD;;AC/mII;EACI,+BAAqC;EACrC,kCAAwC;ADknIhD;;ACpnII;EACI,6BAAqC;EACrC,gCAAwC;ADunIhD;;ACznII;EACI,+BAAqC;EACrC,kCAAwC;AD4nIhD;;AC9nII;EACI,6BAAqC;EACrC,gCAAwC;ADioIhD;;ACnoII;EACI,+BAAqC;EACrC,kCAAwC;ADsoIhD;;ACxoII;EACI,6BAAqC;EACrC,gCAAwC;AD2oIhD;;AC7oII;EACI,+BAAqC;EACrC,kCAAwC;ADgpIhD;;AClpII;EACI,6BAAqC;EACrC,gCAAwC;ADqpIhD;;ACvpII;EACI,+BAAqC;EACrC,kCAAwC;AD0pIhD;;AC5pII;EACI,6BAAqC;EACrC,gCAAwC;AD+pIhD;;ACjqII;EACI,+BAAqC;EACrC,kCAAwC;ADoqIhD;;ACtqII;EACI,6BAAqC;EACrC,gCAAwC;ADyqIhD;;AC3qII;EACI,+BAAqC;EACrC,kCAAwC;AD8qIhD;;AChrII;EACI,6BAAqC;EACrC,gCAAwC;ADmrIhD;;ACrrII;EACI,+BAAqC;EACrC,kCAAwC;ADwrIhD;;AC1rII;EACI,6BAAqC;EACrC,gCAAwC;AD6rIhD;;AC/rII;EACI,+BAAqC;EACrC,kCAAwC;ADksIhD;;ACpsII;EACI,6BAAqC;EACrC,gCAAwC;ADusIhD;;ACzsII;EACI,+BAAqC;EACrC,kCAAwC;AD4sIhD;;AC9sII;EACI,6BAAqC;EACrC,gCAAwC;ADitIhD;;ACntII;EACI,+BAAqC;EACrC,kCAAwC;ADstIhD;;ACxtII;EACI,6BAAqC;EACrC,gCAAwC;AD2tIhD;;AC7tII;EACI,+BAAqC;EACrC,kCAAwC;ADguIhD;;ACluII;EACI,6BAAqC;EACrC,gCAAwC;ADquIhD;;ACvuII;EACI,+BAAqC;EACrC,kCAAwC;AD0uIhD;;AC5uII;EACI,6BAAqC;EACrC,gCAAwC;AD+uIhD;;ACjvII;EACI,+BAAqC;EACrC,kCAAwC;ADovIhD;;ACtvII;EACI,6BAAqC;EACrC,gCAAwC;ADyvIhD;;AC3vII;EACI,+BAAqC;EACrC,kCAAwC;AD8vIhD;;AChwII;EACI,6BAAqC;EACrC,gCAAwC;ADmwIhD;;ACrwII;EACI,+BAAqC;EACrC,kCAAwC;ADwwIhD;;AC1wII;EACI,6BAAqC;EACrC,gCAAwC;AD6wIhD;;AC/wII;EACI,+BAAqC;EACrC,kCAAwC;ADkxIhD;;ACpxII;EACI,6BAAqC;EACrC,gCAAwC;ADuxIhD;;ACzxII;EACI,+BAAqC;EACrC,kCAAwC;AD4xIhD;;AC9xII;EACI,6BAAqC;EACrC,gCAAwC;ADiyIhD;;ACnyII;EACI,+BAAqC;EACrC,kCAAwC;ADsyIhD;;ACxyII;EACI,6BAAqC;EACrC,gCAAwC;AD2yIhD;;AC7yII;EACI,+BAAqC;EACrC,kCAAwC;ADgzIhD;;AClzII;EACI,6BAAqC;EACrC,gCAAwC;ADqzIhD;;ACvzII;EACI,+BAAqC;EACrC,kCAAwC;AD0zIhD;;AC5zII;EACI,6BAAqC;EACrC,gCAAwC;AD+zIhD;;ACj0II;EACI,+BAAqC;EACrC,kCAAwC;ADo0IhD;;ACt0II;EACI,6BAAqC;EACrC,gCAAwC;ADy0IhD;;AC30II;EACI,+BAAqC;EACrC,kCAAwC;AD80IhD;;ACh1II;EACI,6BAAqC;EACrC,gCAAwC;ADm1IhD;;ACr1II;EACI,+BAAqC;EACrC,kCAAwC;ADw1IhD;;AC11II;EACI,6BAAqC;EACrC,gCAAwC;AD61IhD;;AC/1II;EACI,+BAAqC;EACrC,kCAAwC;ADk2IhD;;ACp2II;EACI,6BAAqC;EACrC,gCAAwC;ADu2IhD;;ACz2II;EACI,+BAAqC;EACrC,kCAAwC;AD42IhD;;AC92II;EACI,6BAAqC;EACrC,gCAAwC;ADi3IhD;;ACn3II;EACI,+BAAqC;EACrC,kCAAwC;ADs3IhD;;ACx3II;EACI,6BAAqC;EACrC,gCAAwC;AD23IhD;;AC73II;EACI,+BAAqC;EACrC,kCAAwC;ADg4IhD;;ACl4II;EACI,6BAAqC;EACrC,gCAAwC;ADq4IhD;;ACv4II;EACI,+BAAqC;EACrC,kCAAwC;AD04IhD;;AC54II;EACI,6BAAqC;EACrC,gCAAwC;AD+4IhD;;ACj5II;EACI,+BAAqC;EACrC,kCAAwC;ADo5IhD;;ACt5II;EACI,6BAAqC;EACrC,gCAAwC;ADy5IhD;;AC35II;EACI,+BAAqC;EACrC,kCAAwC;AD85IhD;;ACh6II;EACI,6BAAqC;EACrC,gCAAwC;ADm6IhD;;ACr6II;EACI,+BAAqC;EACrC,kCAAwC;ADw6IhD;;AC16II;EACI,6BAAqC;EACrC,gCAAwC;AD66IhD;;AC/6II;EACI,+BAAqC;EACrC,kCAAwC;ADk7IhD;;ACp7II;EACI,6BAAqC;EACrC,gCAAwC;ADu7IhD;;ACz7II;EACI,+BAAqC;EACrC,kCAAwC;AD47IhD;;AC97II;EACI,6BAAqC;EACrC,gCAAwC;ADi8IhD;;ACn8II;EACI,+BAAqC;EACrC,kCAAwC;ADs8IhD;;ACx8II;EACI,6BAAqC;EACrC,gCAAwC;AD28IhD;;AC78II;EACI,+BAAqC;EACrC,kCAAwC;ADg9IhD;;ACl9II;EACI,6BAAqC;EACrC,gCAAwC;ADq9IhD;;ACv9II;EACI,+BAAqC;EACrC,kCAAwC;AD09IhD;;AC59II;EACI,6BAAqC;EACrC,gCAAwC;AD+9IhD;;ACj+II;EACI,+BAAqC;EACrC,kCAAwC;ADo+IhD;;ACt+II;EACI,6BAAqC;EACrC,gCAAwC;ADy+IhD;;AC3+II;EACI,+BAAqC;EACrC,kCAAwC;AD8+IhD;;ACh/II;EACI,6BAAqC;EACrC,gCAAwC;ADm/IhD;;ACr/II;EACI,+BAAqC;EACrC,kCAAwC;ADw/IhD;;AC1/II;EACI,6BAAqC;EACrC,gCAAwC;AD6/IhD;;AC//II;EACI,+BAAqC;EACrC,kCAAwC;ADkgJhD;;ACpgJI;EACI,6BAAqC;EACrC,gCAAwC;ADugJhD;;ACzgJI;EACI,+BAAqC;EACrC,kCAAwC;AD4gJhD;;AC9gJI;EACI,6BAAqC;EACrC,gCAAwC;ADihJhD;;ACnhJI;EACI,+BAAqC;EACrC,kCAAwC;ADshJhD;;ACxhJI;EACI,6BAAqC;EACrC,gCAAwC;AD2hJhD;;AC7hJI;EACI,+BAAqC;EACrC,kCAAwC;ADgiJhD;;ACliJI;EACI,6BAAqC;EACrC,gCAAwC;ADqiJhD;;ACviJI;EACI,+BAAqC;EACrC,kCAAwC;AD0iJhD;;AC5iJI;EACI,6BAAqC;EACrC,gCAAwC;AD+iJhD;;ACjjJI;EACI,+BAAqC;EACrC,kCAAwC;ADojJhD;;ACtjJI;EACI,6BAAqC;EACrC,gCAAwC;ADyjJhD;;AC3jJI;EACI,+BAAqC;EACrC,kCAAwC;AD8jJhD;;AChkJI;EACI,6BAAqC;EACrC,gCAAwC;ADmkJhD;;ACrkJI;EACI,+BAAqC;EACrC,kCAAwC;ADwkJhD;;AC1kJI;EACI,6BAAqC;EACrC,gCAAwC;AD6kJhD;;AC/kJI;EACI,+BAAqC;EACrC,kCAAwC;ADklJhD;;ACplJI;EACI,6BAAqC;EACrC,gCAAwC;ADulJhD;;ACzlJI;EACI,+BAAqC;EACrC,kCAAwC;AD4lJhD;;AC9lJI;EACI,6BAAqC;EACrC,gCAAwC;ADimJhD;;ACnmJI;EACI,+BAAqC;EACrC,kCAAwC;ADsmJhD;;ACxmJI;EACI,6BAAqC;EACrC,gCAAwC;AD2mJhD;;AC7mJI;EACI,+BAAqC;EACrC,kCAAwC;ADgnJhD;;AClnJI;EACI,6BAAqC;EACrC,gCAAwC;ADqnJhD;;ACvnJI;EACI,+BAAqC;EACrC,kCAAwC;AD0nJhD;;AC5nJI;EACI,6BAAqC;EACrC,gCAAwC;AD+nJhD;;ACjoJI;EACI,+BAAqC;EACrC,kCAAwC;ADooJhD;;ACtoJI;EACI,6BAAqC;EACrC,gCAAwC;ADyoJhD;;AC3oJI;EACI,+BAAqC;EACrC,kCAAwC;AD8oJhD;;AChpJI;EACI,6BAAqC;EACrC,gCAAwC;ADmpJhD;;ACrpJI;EACI,+BAAqC;EACrC,kCAAwC;ADwpJhD;;AC1pJI;EACI,6BAAqC;EACrC,gCAAwC;AD6pJhD;;AC/pJI;EACI,+BAAqC;EACrC,kCAAwC;ADkqJhD;;ACpqJI;EACI,6BAAqC;EACrC,gCAAwC;ADuqJhD;;ACzqJI;EACI,+BAAqC;EACrC,kCAAwC;AD4qJhD;;AC9qJI;EACI,6BAAqC;EACrC,gCAAwC;ADirJhD;;ACnrJI;EACI,+BAAqC;EACrC,kCAAwC;ADsrJhD;;ACxrJI;EACI,6BAAqC;EACrC,gCAAwC;AD2rJhD;;AC7rJI;EACI,+BAAqC;EACrC,kCAAwC;ADgsJhD;;AClsJI;EACI,6BAAqC;EACrC,gCAAwC;ADqsJhD;;ACvsJI;EACI,+BAAqC;EACrC,kCAAwC;AD0sJhD;;ACrsJA;EAaE,6BAAc;ED4rJd,gCC3rJkC;AD4rJpC;;AAEA;EACE,+BC/rJkC;EDgsJlC,kCAAkC;AACpC;;AAEA;EACE;IACE,wBAAwB;ECtsJ1B;;EDysJA;IACE,2BAA2B;EC1sJ7B;;ED6sJA;IACE,0BAA0B;EC9sJ5B;;EDitJA;IACE,wBAAwB;ECltJ1B;;EDqtJA;IACE,0BAA0B;ECttJ5B;;EDytJA;IACE,wBAAwB;EC1tJ1B;;ED6tJA;IACE,0BAA0B;EC9tJ5B;;EDiuJA;IACE,wBAAwB;ECluJ1B;;EDquJA;IACE,0BAA0B;ECtuJ5B;;EDyuJA;IACE,wBAAwB;EC1uJ1B;;ED6uJA;IACE,0BAA0B;EC9uJ5B;;EDivJA;IACE,wBAAwB;EClvJ1B;;EDqvJA;IACE,0BAA0B;ECtvJ5B;;EDyvJA;IACE,wBAAwB;EC1vJ1B;;ED6vJA;IACE,0BAA0B;EC9vJ5B;;EDiwJA;IACE,wBAAwB;EClwJ1B;;EDqwJA;IACE,0BAA0B;ECtwJ5B;;EDywJA;IACE,wBAAwB;EC1wJ1B;;ED6wJA;IACE,0BAA0B;EC9wJ5B;;EDixJA;IACE,wBAAwB;EClxJ1B;;EDqxJA;IACE,0BAA0B;ECtxJ5B;;EDyxJA;IACE,yBAAyB;EC1xJ3B;;ED6xJA;IACE,2BAA2B;EC9xJ7B;;EDiyJA;IACE,yBAAyB;EClyJ3B;;EDqyJA;IACE,2BAA2B;ECtyJ7B;;EDyyJA;IACE,yBAAyB;EC1yJ3B;;ED6yJA;IACE,2BAA2B;EC9yJ7B;;EDizJA;IACE,yBAAyB;EClzJ3B;;EDqzJA;IACE,2BAA2B;ECtzJ7B;;EDyzJA;IACE,yBAAyB;EC1zJ3B;;ED6zJA;IACE,2BAA2B;EC9zJ7B;;EDi0JA;IACE,yBAAyB;ECl0J3B;;EDq0JA;IACE,2BAA2B;ECt0J7B;;EDy0JA;IACE,yBAAyB;EC10J3B;;ED60JA;IACE,2BAA2B;EC90J7B;;EDi1JA;IACE,yBAAyB;ECl1J3B;;EDq1JA;IACE,2BAA2B;ECt1J7B;;EDy1JA;IACE,yBAAyB;EC11J3B;;ED61JA;IACE,2BAA2B;EC91J7B;;EDi2JA;IACE,yBAAyB;ECl2J3B;;EDq2JA;IACE,2BAA2B;ECt2J7B;;EDy2JA;IACE,yBAAyB;EC12J3B;;ED62JA;IACE,2BAA2B;EC92J7B;;EDi3JA;IACE,yBAAyB;ECl3J3B;;EDq3JA;IACE,2BAA2B;ECt3J7B;;EDy3JA;IACE,yBAAyB;EC13J3B;;ED63JA;IACE,2BAA2B;EC93J7B;;EDi4JA;IACE,yBAAyB;ECl4J3B;;EDq4JA;IACE,2BAA2B;ECt4J7B;;EDy4JA;IACE,yBAAyB;EC14J3B;;ED64JA;IACE,2BAA2B;EC94J7B;;EDi5JA;IACE,yBAAyB;ECl5J3B;;EDq5JA;IACE,2BAA2B;ECt5J7B;;EDy5JA;IACE,yBAAyB;EC15J3B;;ED65JA;IACE,2BAA2B;EC95J7B;;EDi6JA;IACE,yBAAyB;ECl6J3B;;EDq6JA;IACE,2BAA2B;ECt6J7B;;EDy6JA;IACE,yBAAyB;EC16J3B;;ED66JA;IACE,2BAA2B;EC96J7B;;EDi7JA;IACE,yBAAyB;ECl7J3B;;EDq7JA;IACE,2BAA2B;ECt7J7B;;EDy7JA;IACE,yBAAyB;EC17J3B;;ED67JA;IACE,2BAA2B;EC97J7B;;EDi8JA;IACE,yBAAyB;ECl8J3B;;EDq8JA;IACE,2BAA2B;ECt8J7B;;EDy8JA;IACE,yBAAyB;EC18J3B;;ED68JA;IACE,2BAA2B;EC98J7B;;EDi9JA;IACE,yBAAyB;ECl9J3B;;EDq9JA;IACE,2BAA2B;ECt9J7B;;EDy9JA;IACE,yBAAyB;EC19J3B;;ED69JA;IACE,2BAA2B;EC99J7B;;EDi+JA;IACE,yBAAyB;ECl+J3B;;EDq+JA;IACE,2BAA2B;ECt+J7B;;EDy+JA;IACE,yBAAyB;EC1+J3B;;ED6+JA;IACE,2BAA2B;EC9+J7B;;EDi/JA;IACE,yBAAyB;ECl/J3B;;EDq/JA;IACE,2BAA2B;ECt/J7B;;EDy/JA;IACE,yBAAyB;EC1/J3B;;ED6/JA;IACE,2BAA2B;EC9/J7B;;EDigKA;IACE,yBAAyB;EClgK3B;;EDqgKA;IACE,2BAA2B;ECtgK7B;;EDygKA;IACE,yBAAyB;EC1gK3B;;ED6gKA;IACE,2BAA2B;EC9gK7B;;EDihKA;IACE,yBAAyB;EClhK3B;;EDqhKA;IACE,2BAA2B;ECthK7B;;EDyhKA;IACE,yBAAyB;EC1hK3B;;ED6hKA;IACE,2BAA2B;EC9hK7B;;EDiiKA;IACE,yBAAyB;ECliK3B;;EDqiKA;IACE,2BAA2B;ECtiK7B;;EDyiKA;IACE,yBAAyB;EC1iK3B;;ED6iKA;IACE,2BAA2B;EC9iK7B;;EDijKA;IACE,yBAAyB;ECljK3B;;EDqjKA;IACE,2BAA2B;ECtjK7B;;EDyjKA;IACE,yBAAyB;EC1jK3B;;ED6jKA;IACE,2BAA2B;EC9jK7B;;EDikKA;IACE,yBAAyB;EClkK3B;;EDqkKA;IACE,2BAA2B;ECtkK7B;;EDykKA;IACE,yBAAyB;EC1kK3B;;ED6kKA;IACE,2BAA2B;EC9kK7B;;EDilKA;IACE,yBAAyB;ECllK3B;;EDqlKA;IACE,2BAA2B;ECtlK7B;;EDylKA;IACE,yBAAyB;EC1lK3B;;ED6lKA;IACE,2BAA2B;EC9lK7B;;EDimKA;IACE,yBAAyB;EClmK3B;;EDqmKA;IACE,2BAA2B;ECtmK7B;;EDymKA;IACE,yBAAyB;EC1mK3B;;ED6mKA;IACE,2BAA2B;EC9mK7B;;EDinKA;IACE,yBAAyB;EClnK3B;;EDqnKA;IACE,2BAA2B;ECtnK7B;;EDynKA;IACE,yBAAyB;EC1nK3B;;ED6nKA;IACE,2BAA2B;EC9nK7B;;EDioKA;IACE,yBAAyB;ECloK3B;;EDqoKA;IACE,2BAA2B;ECtoK7B;;EDyoKA;IACE,yBAAyB;EC1oK3B;;ED6oKA;IACE,2BAA2B;EC9oK7B;;EDipKA;IACE,yBAAyB;EClpK3B;;EDqpKA;IACE,2BAA2B;ECtpK7B;;EDypKA;IACE,yBAAyB;EC1pK3B;;ED6pKA;IACE,2BAA2B;EC9pK7B;;EDiqKA;IACE,yBAAyB;EClqK3B;;EDqqKA;IACE,2BAA2B;ECtqK7B;;EDyqKA;IACE,yBAAyB;EC1qK3B;;ED6qKA;IACE,2BAA2B;EC9qK7B;;EDirKA;IACE,yBAAyB;EClrK3B;;EDqrKA;IACE,2BAA2B;ECtrK7B;;EDyrKA;IACE,yBAAyB;EC1rK3B;;ED6rKA;IACE,2BAA2B;EC9rK7B;;EDisKA;IACE,yBAAyB;EClsK3B;;EDqsKA;IACE,2BAA2B;ECtsK7B;;EDysKA;IACE,yBAAyB;EC1sK3B;;ED6sKA;IACE,2BAA2B;EC9sK7B;;EDitKA;IACE,yBAAyB;ECltK3B;;EDqtKA;IACE,2BAA2B;ECttK7B;;EDytKA;IACE,yBAAyB;EC1tK3B;;ED6tKA;IACE,2BAA2B;EC9tK7B;;EDiuKA;IACE,yBAAyB;ECluK3B;;EDquKA;IACE,2BAA2B;ECtuK7B;;EDyuKA;IACE,yBAAyB;EC1uK3B;;ED6uKA;IACE,2BAA2B;EC9uK7B;;EDivKA;IACE,yBAAyB;EClvK3B;;EDqvKA;IACE,2BAA2B;ECtvK7B;;EDyvKA;IACE,yBAAyB;EC1vK3B;;ED6vKA;IACE,2BAA2B;EC9vK7B;;EDiwKA;IACE,yBAAyB;EClwK3B;;EDqwKA;IACE,2BAA2B;ECtwK7B;;EDywKA;IACE,yBAAyB;EC1wK3B;;ED6wKA;IACE,2BAA2B;EC9wK7B;;EDixKA;IACE,yBAAyB;EClxK3B;;EDqxKA;IACE,2BAA2B;ECtxK7B;;EDyxKA;IACE,yBAAyB;EC1xK3B;;ED6xKA;IACE,2BAA2B;EC9xK7B;;EDiyKA;IACE,yBAAyB;EClyK3B;;EDqyKA;IACE,2BAA2B;ECtyK7B;;EDyyKA;IACE,yBAAyB;EC1yK3B;;ED6yKA;IACE,2BAA2B;EC9yK7B;;EDizKA;IACE,yBAAyB;EClzK3B;;EDqzKA;IACE,2BAA2B;ECtzK7B;;EDyzKA;IACE,yBAAyB;EC1zK3B;;ED6zKA;IACE,2BAA2B;EC3yK7B;;ED8yKA;IACE,yBAAyB;EC/yK3B;;EDkzKA;IACE,2BAA2B;ECnzK7B;;EDszKA;IACE,4BAA4B;ECvzK9B;;ED0zKA;IACE,+BAA+B;EC3zKjC;;ED8zKA;IACE,8BAA8B;EC/zKhC;;EDk0KA;IACE,4BAA4B;ECn0K9B;;EDs0KA;IACE,8BAA8B;ECv0KhC;;ED00KA;IACE,4BAA4B;EC30K9B;;ED80KA;IACE,8BAA8B;EC/0KhC;;EDk1KA;IACE,4BAA4B;ECn1K9B;;EDs1KA;IACE,8BAA8B;ECv1KhC;;ED01KA;IACE,4BAA4B;EC31K9B;;ED81KA;IACE,8BAA8B;EC/1KhC;;EDk2KA;IACE,4BAA4B;ECn2K9B;;EDs2KA;IACE,8BAA8B;ECv2KhC;;ED02KA;IACE,4BAA4B;EC32K9B;;ED82KA;IACE,8BAA8B;EC/2KhC;;EDk3KA;IACE,4BAA4B;ECn3K9B;;EDs3KA;IACE,8BAA8B;ECv3KhC;;ED03KA;IACE,4BAA4B;EC33K9B;;ED83KA;IACE,8BAA8B;EC/3KhC;;EDk4KA;IACE,4BAA4B;ECn4K9B;;EDs4KA;IACE,8BAA8B;ECv4KhC;;ED04KA;IACE,6BAA6B;EC34K/B;;ED84KA;IACE,+BAA+B;EC/4KjC;;EDk5KA;IACE,6BAA6B;ECn5K/B;;EDs5KA;IACE,+BAA+B;ECv5KjC;;ED05KA;IACE,6BAA6B;EC35K/B;;ED85KA;IACE,+BAA+B;EC/5KjC;;EDk6KA;IACE,6BAA6B;ECn6K/B;;EDs6KA;IACE,+BAA+B;ECv6KjC;;ED06KA;IACE,6BAA6B;EC36K/B;;ED86KA;IACE,+BAA+B;EC/6KjC;;EDk7KA;IACE,6BAA6B;ECn7K/B;;EDs7KA;IACE,+BAA+B;ECv7KjC;;ED07KA;IACE,6BAA6B;EC37K/B;;ED87KA;IACE,+BAA+B;EC/7KjC;;EDk8KA;IACE,6BAA6B;ECn8K/B;;EDs8KA;IACE,+BAA+B;ECv8KjC;;ED08KA;IACE,6BAA6B;EC38K/B;;ED88KA;IACE,+BAA+B;EC/8KjC;;EDk9KA;IACE,6BAA6B;ECn9K/B;;EDs9KA;IACE,+BAA+B;ECv9KjC;;ED09KA;IACE,6BAA6B;EC39K/B;;ED89KA;IACE,+BAA+B;EC/9KjC;;EDk+KA;IACE,6BAA6B;ECn+K/B;;EDs+KA;IACE,+BAA+B;ECv+KjC;;ED0+KA;IACE,6BAA6B;EC3+K/B;;ED8+KA;IACE,+BAA+B;EC/+KjC;;EDk/KA;IACE,6BAA6B;ECn/K/B;;EDs/KA;IACE,+BAA+B;ECv/KjC;;ED0/KA;IACE,6BAA6B;EC3/K/B;;ED8/KA;IACE,+BAA+B;EC//KjC;;EDkgLA;IACE,6BAA6B;ECngL/B;;EDsgLA;IACE,+BAA+B;ECvgLjC;;ED0gLA;IACE,6BAA6B;EC3gL/B;;ED8gLA;IACE,+BAA+B;EC/gLjC;;EDkhLA;IACE,6BAA6B;ECnhL/B;;EDshLA;IACE,+BAA+B;ECvhLjC;;ED0hLA;IACE,6BAA6B;EC3hL/B;;ED8hLA;IACE,+BAA+B;EC/hLjC;;EDkiLA;IACE,6BAA6B;ECniL/B;;EDsiLA;IACE,+BAA+B;ECviLjC;;ED0iLA;IACE,6BAA6B;EC3iL/B;;ED8iLA;IACE,+BAA+B;EC/iLjC;;EDkjLA;IACE,6BAA6B;ECnjL/B;;EDsjLA;IACE,+BAA+B;ECvjLjC;;ED0jLA;IACE,6BAA6B;EC3jL/B;;ED8jLA;IACE,+BAA+B;EC/jLjC;;EDkkLA;IACE,6BAA6B;ECnkL/B;;EDskLA;IACE,+BAA+B;ECvkLjC;;ED0kLA;IACE,6BAA6B;EC3kL/B;;ED8kLA;IACE,+BAA+B;EC/kLjC;;EDklLA;IACE,6BAA6B;ECnlL/B;;EDslLA;IACE,+BAA+B;ECvlLjC;;ED0lLA;IACE,6BAA6B;EC3lL/B;;ED8lLA;IACE,+BAA+B;EC/lLjC;;EDkmLA;IACE,6BAA6B;ECnmL/B;;EDsmLA;IACE,+BAA+B;ECvmLjC;;ED0mLA;IACE,6BAA6B;EC3mL/B;;ED8mLA;IACE,+BAA+B;EC/mLjC;;EDknLA;IACE,6BAA6B;ECnnL/B;;EDsnLA;IACE,+BAA+B;ECvnLjC;;ED0nLA;IACE,6BAA6B;EC3nL/B;;ED8nLA;IACE,+BAA+B;EC/nLjC;;EDkoLA;IACE,6BAA6B;ECnoL/B;;EDsoLA;IACE,+BAA+B;ECvoLjC;;ED0oLA;IACE,6BAA6B;EC3oL/B;;ED8oLA;IACE,+BAA+B;EC/oLjC;;EDkpLA;IACE,6BAA6B;ECnpL/B;;EDspLA;IACE,+BAA+B;ECvpLjC;;ED0pLA;IACE,6BAA6B;EC3pL/B;;ED8pLA;IACE,+BAA+B;EC/pLjC;;EDkqLA;IACE,6BAA6B;ECnqL/B;;EDsqLA;IACE,+BAA+B;ECvqLjC;;ED0qLA;IACE,6BAA6B;EC3qL/B;;ED8qLA;IACE,+BAA+B;EC/qLjC;;EDkrLA;IACE,6BAA6B;ECnrL/B;;EDsrLA;IACE,+BAA+B;ECvrLjC;;ED0rLA;IACE,6BAA6B;EC3rL/B;;ED8rLA;IACE,+BAA+B;EC/rLjC;;EDksLA;IACE,6BAA6B;ECnsL/B;;EDssLA;IACE,+BAA+B;ECvsLjC;;ED0sLA;IACE,6BAA6B;EC3sL/B;;ED8sLA;IACE,+BAA+B;EC/sLjC;;EDktLA;IACE,6BAA6B;ECntL/B;;EDstLA;IACE,+BAA+B;ECvtLjC;;ED0tLA;IACE,6BAA6B;EC3tL/B;;ED8tLA;IACE,+BAA+B;EC/tLjC;;EDkuLA;IACE,6BAA6B;ECnuL/B;;EDsuLA;IACE,+BAA+B;ECvuLjC;;ED0uLA;IACE,6BAA6B;EC3uL/B;;ED8uLA;IACE,+BAA+B;EC/uLjC;;EDkvLA;IACE,6BAA6B;ECnvL/B;;EDsvLA;IACE,+BAA+B;ECvvLjC;;ED0vLA;IACE,6BAA6B;EC3vL/B;;ED8vLA;IACE,+BAA+B;EC/vLjC;;EDkwLA;IACE,6BAA6B;ECnwL/B;;EDswLA;IACE,+BAA+B;ECvwLjC;;ED0wLA;IACE,6BAA6B;EC3wL/B;;ED8wLA;IACE,+BAA+B;EC/wLjC;;EDkxLA;IACE,6BAA6B;ECnxL/B;;EDsxLA;IACE,+BAA+B;ECvxLjC;;ED0xLA;IACE,6BAA6B;EC3xL/B;;ED8xLA;IACE,+BAA+B;EC/xLjC;;EDkyLA;IACE,6BAA6B;ECnyL/B;;EDsyLA;IACE,+BAA+B;ECvyLjC;;ED0yLA;IACE,6BAA6B;EC3yL/B;;ED8yLA;IACE,+BAA+B;EC/yLjC;;EDkzLA;IACE,6BAA6B;ECnzL/B;;EDszLA;IACE,+BAA+B;ECvzLjC;;ED0zLA;IACE,6BAA6B;EC3zL/B;;ED8zLA;IACE,+BAA+B;EC/zLjC;;EDk0LA;IACE,6BAA6B;ECn0L/B;;EDs0LA;IACE,+BAA+B;ECv0LjC;;ED00LA;IACE,6BAA6B;EC30L/B;;ED80LA;IACE,+BAA+B;EC/0LjC;;EDk1LA;IACE,6BAA6B;ECn1L/B;;EDs1LA;IACE,+BAA+B;ECv1LjC;;ED01LA;IACE,6BAA6B;EC31L/B;;ED81LA;IACE,+BAA+B;EC/1LjC;;EDk2LA;IACE,6BAA6B;ECn2L/B;;EDs2LA;IACE,+BAA+B;ECv2LjC;;ED02LA;IACE,6BAA6B;EC32L/B;;ED82LA;IACE,+BAA+B;EC/2LjC;;EDk3LA;IACE,6BAA6B;ECn3L/B;;EDs3LA;IACE,+BAA+B;ECv3LjC;;ED03LA;IACE,6BAA6B;EC33L/B;;ED83LA;IACE,+BAA+B;EC/3LjC;;EDk4LA;IACE,6BAA6B;ECn4L/B;;EDs4LA;IACE,+BAA+B;ECv4LjC;;ED04LA;IACE,6BAA6B;EC34L/B;;ED84LA;IACE,+BAA+B;EC/4LjC;;EDk5LA;IACE,6BAA6B;ECn5L/B;;EDs5LA;IACE,+BAA+B;ECv5LjC;;ED05LA;IACE,6BAA6B;EC35L/B;;ED85LA;IACE,+BAA+B;EC/5LjC;;EDk6LA;IACE,6BAA6B;ECn6L/B;;EDs6LA;IACE,+BAA+B;ECv6LjC;;ED06LA;IACE,6BAA6B;EC36L/B;;ED86LA;IACE,+BAA+B;EC55LjC;;ED+5LA;IACE,6BAA6B;ECh6L/B;;EDm6LA;IACE,+BAA+B;ECp6LjC;;EDu6LA;IACE,+BAA+B;ECx6LjC;;ED26LA;IACE,kCAAkC;EC56LpC;;ED+6LA;IACE,iCAAiC;ECh7LnC;;EDm7LA;IACE,+BAA+B;ECp7LjC;;EDu7LA;IACE,iCAAiC;ECx7LnC;;ED27LA;IACE,+BAA+B;EC57LjC;;ED+7LA;IACE,iCAAiC;ECh8LnC;;EDm8LA;IACE,+BAA+B;ECp8LjC;;EDu8LA;IACE,iCAAiC;ECx8LnC;;ED28LA;IACE,+BAA+B;EC58LjC;;ED+8LA;IACE,iCAAiC;ECh9LnC;;EDm9LA;IACE,+BAA+B;ECp9LjC;;EDu9LA;IACE,iCAAiC;ECx9LnC;;ED29LA;IACE,+BAA+B;EC59LjC;;ED+9LA;IACE,iCAAiC;ECh+LnC;;EDm+LA;IACE,+BAA+B;ECp+LjC;;EDu+LA;IACE,iCAAiC;ECx+LnC;;ED2+LA;IACE,+BAA+B;EC5+LjC;;ED++LA;IACE,iCAAiC;ECh/LnC;;EDm/LA;IACE,+BAA+B;ECp/LjC;;EDu/LA;IACE,iCAAiC;ECx/LnC;;ED2/LA;IACE,gCAAgC;EC5/LlC;;ED+/LA;IACE,kCAAkC;EChgMpC;;EDmgMA;IACE,gCAAgC;ECpgMlC;;EDugMA;IACE,kCAAkC;ECxgMpC;;ED2gMA;IACE,gCAAgC;EC5gMlC;;ED+gMA;IACE,kCAAkC;EChhMpC;;EDmhMA;IACE,gCAAgC;ECphMlC;;EDuhMA;IACE,kCAAkC;ECxhMpC;;ED2hMA;IACE,gCAAgC;EC5hMlC;;ED+hMA;IACE,kCAAkC;EChiMpC;;EDmiMA;IACE,gCAAgC;ECpiMlC;;EDuiMA;IACE,kCAAkC;ECxiMpC;;ED2iMA;IACE,gCAAgC;EC5iMlC;;ED+iMA;IACE,kCAAkC;EChjMpC;;EDmjMA;IACE,gCAAgC;ECpjMlC;;EDujMA;IACE,kCAAkC;ECxjMpC;;ED2jMA;IACE,gCAAgC;EC5jMlC;;ED+jMA;IACE,kCAAkC;EChkMpC;;EDmkMA;IACE,gCAAgC;ECpkMlC;;EDukMA;IACE,kCAAkC;ECxkMpC;;ED2kMA;IACE,gCAAgC;EC5kMlC;;ED+kMA;IACE,kCAAkC;EChlMpC;;EDmlMA;IACE,gCAAgC;ECplMlC;;EDulMA;IACE,kCAAkC;ECxlMpC;;ED2lMA;IACE,gCAAgC;EC5lMlC;;ED+lMA;IACE,kCAAkC;EChmMpC;;EDmmMA;IACE,gCAAgC;ECpmMlC;;EDumMA;IACE,kCAAkC;ECxmMpC;;ED2mMA;IACE,gCAAgC;EC5mMlC;;ED+mMA;IACE,kCAAkC;EChnMpC;;EDmnMA;IACE,gCAAgC;ECpnMlC;;EDunMA;IACE,kCAAkC;ECxnMpC;;ED2nMA;IACE,gCAAgC;EC5nMlC;;ED+nMA;IACE,kCAAkC;EChoMpC;;EDmoMA;IACE,gCAAgC;ECpoMlC;;EDuoMA;IACE,kCAAkC;ECxoMpC;;ED2oMA;IACE,gCAAgC;EC5oMlC;;ED+oMA;IACE,kCAAkC;EChpMpC;;EDmpMA;IACE,gCAAgC;ECppMlC;;EDupMA;IACE,kCAAkC;ECxpMpC;;ED2pMA;IACE,gCAAgC;EC5pMlC;;ED+pMA;IACE,kCAAkC;EChqMpC;;EDmqMA;IACE,gCAAgC;ECpqMlC;;EDuqMA;IACE,kCAAkC;ECxqMpC;;ED2qMA;IACE,gCAAgC;EC5qMlC;;ED+qMA;IACE,kCAAkC;EChrMpC;;EDmrMA;IACE,gCAAgC;ECprMlC;;EDurMA;IACE,kCAAkC;ECxrMpC;;ED2rMA;IACE,gCAAgC;EC5rMlC;;ED+rMA;IACE,kCAAkC;EChsMpC;;EDmsMA;IACE,gCAAgC;ECpsMlC;;EDusMA;IACE,kCAAkC;ECxsMpC;;ED2sMA;IACE,gCAAgC;EC5sMlC;;ED+sMA;IACE,kCAAkC;EChtMpC;;EDmtMA;IACE,gCAAgC;ECptMlC;;EDutMA;IACE,kCAAkC;ECxtMpC;;ED2tMA;IACE,gCAAgC;EC5tMlC;;ED+tMA;IACE,kCAAkC;EChuMpC;;EDmuMA;IACE,gCAAgC;ECpuMlC;;EDuuMA;IACE,kCAAkC;ECxuMpC;;ED2uMA;IACE,gCAAgC;EC5uMlC;;ED+uMA;IACE,kCAAkC;EChvMpC;;EDmvMA;IACE,gCAAgC;ECpvMlC;;EDuvMA;IACE,kCAAkC;ECxvMpC;;ED2vMA;IACE,gCAAgC;EC5vMlC;;ED+vMA;IACE,kCAAkC;EChwMpC;;EDmwMA;IACE,gCAAgC;ECpwMlC;;EDuwMA;IACE,kCAAkC;ECxwMpC;;ED2wMA;IACE,gCAAgC;EC5wMlC;;ED+wMA;IACE,kCAAkC;EChxMpC;;EDmxMA;IACE,gCAAgC;ECpxMlC;;EDuxMA;IACE,kCAAkC;ECxxMpC;;ED2xMA;IACE,gCAAgC;EC5xMlC;;ED+xMA;IACE,kCAAkC;EChyMpC;;EDmyMA;IACE,gCAAgC;ECpyMlC;;EDuyMA;IACE,kCAAkC;ECxyMpC;;ED2yMA;IACE,gCAAgC;EC5yMlC;;ED+yMA;IACE,kCAAkC;EChzMpC;;EDmzMA;IACE,gCAAgC;ECpzMlC;;EDuzMA;IACE,kCAAkC;ECxzMpC;;ED2zMA;IACE,gCAAgC;EC5zMlC;;ED+zMA;IACE,kCAAkC;ECh0MpC;;EDm0MA;IACE,gCAAgC;ECp0MlC;;EDu0MA;IACE,kCAAkC;ECx0MpC;;ED20MA;IACE,gCAAgC;EC50MlC;;ED+0MA;IACE,kCAAkC;ECh1MpC;;EDm1MA;IACE,gCAAgC;ECp1MlC;;EDu1MA;IACE,kCAAkC;ECx1MpC;;ED21MA;IACE,gCAAgC;EC51MlC;;ED+1MA;IACE,kCAAkC;ECh2MpC;;EDm2MA;IACE,gCAAgC;ECp2MlC;;EDu2MA;IACE,kCAAkC;ECx2MpC;;ED22MA;IACE,gCAAgC;EC52MlC;;ED+2MA;IACE,kCAAkC;ECh3MpC;;EDm3MA;IACE,gCAAgC;ECp3MlC;;EDu3MA;IACE,kCAAkC;ECx3MpC;;ED23MA;IACE,gCAAgC;EC53MlC;;ED+3MA;IACE,kCAAkC;ECh4MpC;;EDm4MA;IACE,gCAAgC;ECp4MlC;;EDu4MA;IACE,kCAAkC;ECx4MpC;;ED24MA;IACE,gCAAgC;EC54MlC;;ED+4MA;IACE,kCAAkC;ECh5MpC;;EDm5MA;IACE,gCAAgC;ECp5MlC;;EDu5MA;IACE,kCAAkC;ECx5MpC;;ED25MA;IACE,gCAAgC;EC55MlC;;ED+5MA;IACE,kCAAkC;ECh6MpC;;EDm6MA;IACE,gCAAgC;ECp6MlC;;EDu6MA;IACE,kCAAkC;ECx6MpC;;ED26MA;IACE,gCAAgC;EC56MlC;;ED+6MA;IACE,kCAAkC;ECh7MpC;;EDm7MA;IACE,gCAAgC;ECp7MlC;;EDu7MA;IACE,kCAAkC;ECx7MpC;;ED27MA;IACE,gCAAgC;EC57MlC;;ED+7MA;IACE,kCAAkC;ECh8MpC;;EDm8MA;IACE,gCAAgC;ECp8MlC;;EDu8MA;IACE,kCAAkC;ECx8MpC;;ED28MA;IACE,gCAAgC;EC58MlC;;ED+8MA;IACE,kCAAkC;ECh9MpC;;EDm9MA;IACE,gCAAgC;ECp9MlC;;EDu9MA;IACE,kCAAkC;ECx9MpC;;ED29MA;IACE,gCAAgC;EC59MlC;;ED+9MA;IACE,kCAAkC;ECh+MpC;;EDm+MA;IACE,gCAAgC;ECp+MlC;;EDu+MA;IACE,kCAAkC;ECx+MpC;;ED2+MA;IACE,gCAAgC;EC5+MlC;;ED++MA;IACE,kCAAkC;ECh/MpC;;EDm/MA;IACE,gCAAgC;ECp/MlC;;EDu/MA;IACE,kCAAkC;ECx/MpC;;ED2/MA;IACE,gCAAgC;EC5/MlC;;ED+/MA;IACE,kCAAkC;EChgNpC;;EDmgNA;IACE,gCAAgC;ECpgNlC;;EDugNA;IACE,kCAAkC;ECxgNpC;;ED2gNA;IACE,gCAAgC;EC5gNlC;;ED+gNA;IACE,kCAAkC;EChhNpC;;EDmhNA;IACE,gCAAgC;ECphNlC;;EDuhNA;IACE,kCAAkC;ECxhNpC;;ED2hNA;IACE,gCAAgC;EC5hNlC;;ED+hNA;IACE,kCAAkC;EC7gNpC;;EDghNA;IACE,gCAAgC;ECjhNlC;;EDohNA;IACE,kCAAkC;ECrhNpC;;EDwhNA;IACE,6BAA6B;ECzhN/B;;ED4hNA;IACE,gCAAgC;EC7hNlC;;EDgiNA;IACE,+BAA+B;ECjiNjC;;EDoiNA;IACE,6BAA6B;ECriN/B;;EDwiNA;IACE,+BAA+B;ECziNjC;;ED4iNA;IACE,6BAA6B;EC7iN/B;;EDgjNA;IACE,+BAA+B;ECjjNjC;;EDojNA;IACE,6BAA6B;ECrjN/B;;EDwjNA;IACE,+BAA+B;ECzjNjC;;ED4jNA;IACE,6BAA6B;EC7jN/B;;EDgkNA;IACE,+BAA+B;ECjkNjC;;EDokNA;IACE,6BAA6B;ECrkN/B;;EDwkNA;IACE,+BAA+B;ECzkNjC;;ED4kNA;IACE,6BAA6B;EC7kN/B;;EDglNA;IACE,+BAA+B;ECjlNjC;;EDolNA;IACE,6BAA6B;ECrlN/B;;EDwlNA;IACE,+BAA+B;ECzlNjC;;ED4lNA;IACE,6BAA6B;EC7lN/B;;EDgmNA;IACE,+BAA+B;ECjmNjC;;EDomNA;IACE,6BAA6B;ECrmN/B;;EDwmNA;IACE,+BAA+B;ECzmNjC;;ED4mNA;IACE,8BAA8B;EC7mNhC;;EDgnNA;IACE,gCAAgC;ECjnNlC;;EDonNA;IACE,8BAA8B;ECrnNhC;;EDwnNA;IACE,gCAAgC;ECznNlC;;ED4nNA;IACE,8BAA8B;EC7nNhC;;EDgoNA;IACE,gCAAgC;ECjoNlC;;EDooNA;IACE,8BAA8B;ECroNhC;;EDwoNA;IACE,gCAAgC;ECzoNlC;;ED4oNA;IACE,8BAA8B;EC7oNhC;;EDgpNA;IACE,gCAAgC;ECjpNlC;;EDopNA;IACE,8BAA8B;ECrpNhC;;EDwpNA;IACE,gCAAgC;ECzpNlC;;ED4pNA;IACE,8BAA8B;EC7pNhC;;EDgqNA;IACE,gCAAgC;ECjqNlC;;EDoqNA;IACE,8BAA8B;ECrqNhC;;EDwqNA;IACE,gCAAgC;ECzqNlC;;ED4qNA;IACE,8BAA8B;EC7qNhC;;EDgrNA;IACE,gCAAgC;ECjrNlC;;EDorNA;IACE,8BAA8B;ECrrNhC;;EDwrNA;IACE,gCAAgC;ECzrNlC;;ED4rNA;IACE,8BAA8B;EC7rNhC;;EDgsNA;IACE,gCAAgC;ECjsNlC;;EDosNA;IACE,8BAA8B;ECrsNhC;;EDwsNA;IACE,gCAAgC;ECzsNlC;;ED4sNA;IACE,8BAA8B;EC7sNhC;;EDgtNA;IACE,gCAAgC;ECjtNlC;;EDotNA;IACE,8BAA8B;ECrtNhC;;EDwtNA;IACE,gCAAgC;ECztNlC;;ED4tNA;IACE,8BAA8B;EC7tNhC;;EDguNA;IACE,gCAAgC;ECjuNlC;;EDouNA;IACE,8BAA8B;ECruNhC;;EDwuNA;IACE,gCAAgC;ECzuNlC;;ED4uNA;IACE,8BAA8B;EC7uNhC;;EDgvNA;IACE,gCAAgC;ECjvNlC;;EDovNA;IACE,8BAA8B;ECrvNhC;;EDwvNA;IACE,gCAAgC;ECzvNlC;;ED4vNA;IACE,8BAA8B;EC7vNhC;;EDgwNA;IACE,gCAAgC;ECjwNlC;;EDowNA;IACE,8BAA8B;ECrwNhC;;EDwwNA;IACE,gCAAgC;ECzwNlC;;ED4wNA;IACE,8BAA8B;EC7wNhC;;EDgxNA;IACE,gCAAgC;ECjxNlC;;EDoxNA;IACE,8BAA8B;ECrxNhC;;EDwxNA;IACE,gCAAgC;ECzxNlC;;ED4xNA;IACE,8BAA8B;EC7xNhC;;EDgyNA;IACE,gCAAgC;ECjyNlC;;EDoyNA;IACE,8BAA8B;ECryNhC;;EDwyNA;IACE,gCAAgC;ECzyNlC;;ED4yNA;IACE,8BAA8B;EC7yNhC;;EDgzNA;IACE,gCAAgC;ECjzNlC;;EDozNA;IACE,8BAA8B;ECrzNhC;;EDwzNA;IACE,gCAAgC;ECzzNlC;;ED4zNA;IACE,8BAA8B;EC7zNhC;;EDg0NA;IACE,gCAAgC;ECj0NlC;;EDo0NA;IACE,8BAA8B;ECr0NhC;;EDw0NA;IACE,gCAAgC;ECz0NlC;;ED40NA;IACE,8BAA8B;EC70NhC;;EDg1NA;IACE,gCAAgC;ECj1NlC;;EDo1NA;IACE,8BAA8B;ECr1NhC;;EDw1NA;IACE,gCAAgC;ECz1NlC;;ED41NA;IACE,8BAA8B;EC71NhC;;EDg2NA;IACE,gCAAgC;ECj2NlC;;EDo2NA;IACE,8BAA8B;ECr2NhC;;EDw2NA;IACE,gCAAgC;ECz2NlC;;ED42NA;IACE,8BAA8B;EC72NhC;;EDg3NA;IACE,gCAAgC;ECj3NlC;;EDo3NA;IACE,8BAA8B;ECr3NhC;;EDw3NA;IACE,gCAAgC;ECz3NlC;;ED43NA;IACE,8BAA8B;EC73NhC;;EDg4NA;IACE,gCAAgC;ECj4NlC;;EDo4NA;IACE,8BAA8B;ECr4NhC;;EDw4NA;IACE,gCAAgC;ECz4NlC;;ED44NA;IACE,8BAA8B;EC74NhC;;EDg5NA;IACE,gCAAgC;ECj5NlC;;EDo5NA;IACE,8BAA8B;ECr5NhC;;EDw5NA;IACE,gCAAgC;ECz5NlC;;ED45NA;IACE,8BAA8B;EC75NhC;;EDg6NA;IACE,gCAAgC;ECj6NlC;;EDo6NA;IACE,8BAA8B;ECr6NhC;;EDw6NA;IACE,gCAAgC;ECz6NlC;;ED46NA;IACE,8BAA8B;EC76NhC;;EDg7NA;IACE,gCAAgC;ECj7NlC;;EDo7NA;IACE,8BAA8B;ECr7NhC;;EDw7NA;IACE,gCAAgC;ECz7NlC;;ED47NA;IACE,8BAA8B;EC77NhC;;EDg8NA;IACE,gCAAgC;ECj8NlC;;EDo8NA;IACE,8BAA8B;ECr8NhC;;EDw8NA;IACE,gCAAgC;ECz8NlC;;ED48NA;IACE,8BAA8B;EC78NhC;;EDg9NA;IACE,gCAAgC;ECj9NlC;;EDo9NA;IACE,8BAA8B;ECr9NhC;;EDw9NA;IACE,gCAAgC;ECz9NlC;;ED49NA;IACE,8BAA8B;EC79NhC;;EDg+NA;IACE,gCAAgC;ECj+NlC;;EDo+NA;IACE,8BAA8B;ECr+NhC;;EDw+NA;IACE,gCAAgC;ECz+NlC;;ED4+NA;IACE,8BAA8B;EC7+NhC;;EDg/NA;IACE,gCAAgC;ECj/NlC;;EDo/NA;IACE,8BAA8B;ECr/NhC;;EDw/NA;IACE,gCAAgC;ECz/NlC;;ED4/NA;IACE,8BAA8B;EC7/NhC;;EDggOA;IACE,gCAAgC;ECjgOlC;;EDogOA;IACE,8BAA8B;ECrgOhC;;EDwgOA;IACE,gCAAgC;ECzgOlC;;ED4gOA;IACE,8BAA8B;EC7gOhC;;EDghOA;IACE,gCAAgC;ECjhOlC;;EDohOA;IACE,8BAA8B;ECrhOhC;;EDwhOA;IACE,gCAAgC;ECzhOlC;;ED4hOA;IACE,8BAA8B;EC7hOhC;;EDgiOA;IACE,gCAAgC;ECjiOlC;;EDoiOA;IACE,8BAA8B;ECriOhC;;EDwiOA;IACE,gCAAgC;ECziOlC;;ED4iOA;IACE,8BAA8B;EC7iOhC;;EDgjOA;IACE,gCAAgC;ECjjOlC;;EDojOA;IACE,8BAA8B;ECrjOhC;;EDwjOA;IACE,gCAAgC;ECzjOlC;;ED4jOA;IACE,8BAA8B;EC7jOhC;;EDgkOA;IACE,gCAAgC;ECjkOlC;;EDokOA;IACE,8BAA8B;ECrkOhC;;EDwkOA;IACE,gCAAgC;ECzkOlC;;ED4kOA;IACE,8BAA8B;EC7kOhC;;EDglOA;IACE,gCAAgC;ECjlOlC;;EDolOA;IACE,8BAA8B;ECrlOhC;;EDwlOA;IACE,gCAAgC;ECzlOlC;;ED4lOA;IACE,8BAA8B;EC7lOhC;;EDgmOA;IACE,gCAAgC;ECjmOlC;;EDomOA;IACE,8BAA8B;ECrmOhC;;EDwmOA;IACE,gCAAgC;ECzmOlC;;ED4mOA;IACE,8BAA8B;EC7mOhC;;EDgnOA;IACE,gCAAgC;ECjnOlC;;EDonOA;IACE,8BAA8B;ECrnOhC;;EDwnOA;IACE,gCAAgC;ECznOlC;;ED4nOA;IACE,8BAA8B;EC7nOhC;;EDgoOA;IACE,gCAAgC;ECjoOlC;;EDooOA;IACE,8BAA8B;ECroOhC;;EDwoOA;IACE,gCAAgC;ECzoOlC;;ED4oOA;IACE,8BAA8B;EC7oOhC;;EDgpOA;IACE,gCAAgC;EC9nOlC;;EDioOA;IACE,8BAA8B;ECloOhC;;EDqoOA;IACE,gCAAgC;ECtoOlC;;EDyoOA;IACE,8BAA8B;EC1oOhC;;ED6oOA;IACE,iCAAiC;EC9oOnC;;EDipOA;IACE,gCAAgC;EClpOlC;;EDqpOA;IACE,8BAA8B;ECtpOhC;;EDypOA;IACE,gCAAgC;EC1pOlC;;ED6pOA;IACE,8BAA8B;EC9pOhC;;EDiqOA;IACE,gCAAgC;EClqOlC;;EDqqOA;IACE,8BAA8B;ECtqOhC;;EDyqOA;IACE,gCAAgC;EC1qOlC;;ED6qOA;IACE,8BAA8B;EC9qOhC;;EDirOA;IACE,gCAAgC;EClrOlC;;EDqrOA;IACE,8BAA8B;ECtrOhC;;EDyrOA;IACE,gCAAgC;EC1rOlC;;ED6rOA;IACE,8BAA8B;EC9rOhC;;EDisOA;IACE,gCAAgC;EClsOlC;;EDqsOA;IACE,8BAA8B;ECtsOhC;;EDysOA;IACE,gCAAgC;EC1sOlC;;ED6sOA;IACE,8BAA8B;EC9sOhC;;EDitOA;IACE,gCAAgC;ECltOlC;;EDqtOA;IACE,8BAA8B;ECttOhC;;EDytOA;IACE,gCAAgC;EC1tOlC;;ED6tOA;IACE,+BAA+B;EC9tOjC;;EDiuOA;IACE,iCAAiC;ECluOnC;;EDquOA;IACE,+BAA+B;ECtuOjC;;EDyuOA;IACE,iCAAiC;EC1uOnC;;ED6uOA;IACE,+BAA+B;EC9uOjC;;EDivOA;IACE,iCAAiC;EClvOnC;;EDqvOA;IACE,+BAA+B;ECtvOjC;;EDyvOA;IACE,iCAAiC;EC1vOnC;;ED6vOA;IACE,+BAA+B;EC9vOjC;;EDiwOA;IACE,iCAAiC;EClwOnC;;EDqwOA;IACE,+BAA+B;ECtwOjC;;EDywOA;IACE,iCAAiC;EC1wOnC;;ED6wOA;IACE,+BAA+B;EC9wOjC;;EDixOA;IACE,iCAAiC;EClxOnC;;EDqxOA;IACE,+BAA+B;ECtxOjC;;EDyxOA;IACE,iCAAiC;EC1xOnC;;ED6xOA;IACE,+BAA+B;EC9xOjC;;EDiyOA;IACE,iCAAiC;EClyOnC;;EDqyOA;IACE,+BAA+B;ECtyOjC;;EDyyOA;IACE,iCAAiC;EC1yOnC;;ED6yOA;IACE,+BAA+B;EC9yOjC;;EDizOA;IACE,iCAAiC;EClzOnC;;EDqzOA;IACE,+BAA+B;ECtzOjC;;EDyzOA;IACE,iCAAiC;EC1zOnC;;ED6zOA;IACE,+BAA+B;EC9zOjC;;EDi0OA;IACE,iCAAiC;ECl0OnC;;EDq0OA;IACE,+BAA+B;ECt0OjC;;EDy0OA;IACE,iCAAiC;EC10OnC;;ED60OA;IACE,+BAA+B;EC90OjC;;EDi1OA;IACE,iCAAiC;ECl1OnC;;EDq1OA;IACE,+BAA+B;ECt1OjC;;EDy1OA;IACE,iCAAiC;EC11OnC;;ED61OA;IACE,+BAA+B;EC91OjC;;EDi2OA;IACE,iCAAiC;ECl2OnC;;EDq2OA;IACE,+BAA+B;ECt2OjC;;EDy2OA;IACE,iCAAiC;EC12OnC;;ED62OA;IACE,+BAA+B;EC92OjC;;EDi3OA;IACE,iCAAiC;ECl3OnC;;EDq3OA;IACE,+BAA+B;ECt3OjC;;EDy3OA;IACE,iCAAiC;EC13OnC;;ED63OA;IACE,+BAA+B;EC93OjC;;EDi4OA;IACE,iCAAiC;ECl4OnC;;EDq4OA;IACE,+BAA+B;ECt4OjC;;EDy4OA;IACE,iCAAiC;EC14OnC;;ED64OA;IACE,+BAA+B;EC94OjC;;EDi5OA;IACE,iCAAiC;ECl5OnC;;EDq5OA;IACE,+BAA+B;ECt5OjC;;EDy5OA;IACE,iCAAiC;EC15OnC;;ED65OA;IACE,+BAA+B;EC95OjC;;EDi6OA;IACE,iCAAiC;ECl6OnC;;EDq6OA;IACE,+BAA+B;ECt6OjC;;EDy6OA;IACE,iCAAiC;EC16OnC;;ED66OA;IACE,+BAA+B;EC96OjC;;EDi7OA;IACE,iCAAiC;ECl7OnC;;EDq7OA;IACE,+BAA+B;ECt7OjC;;EDy7OA;IACE,iCAAiC;EC17OnC;;ED67OA;IACE,+BAA+B;EC97OjC;;EDi8OA;IACE,iCAAiC;ECl8OnC;;EDq8OA;IACE,+BAA+B;ECt8OjC;;EDy8OA;IACE,iCAAiC;EC18OnC;;ED68OA;IACE,+BAA+B;EC98OjC;;EDi9OA;IACE,iCAAiC;ECl9OnC;;EDq9OA;IACE,+BAA+B;ECt9OjC;;EDy9OA;IACE,iCAAiC;EC19OnC;;ED69OA;IACE,+BAA+B;EC99OjC;;EDi+OA;IACE,iCAAiC;ECl+OnC;;EDq+OA;IACE,+BAA+B;ECt+OjC;;EDy+OA;IACE,iCAAiC;EC1+OnC;;ED6+OA;IACE,+BAA+B;EC9+OjC;;EDi/OA;IACE,iCAAiC;ECl/OnC;;EDq/OA;IACE,+BAA+B;ECt/OjC;;EDy/OA;IACE,iCAAiC;EC1/OnC;;ED6/OA;IACE,+BAA+B;EC9/OjC;;EDigPA;IACE,iCAAiC;EClgPnC;;EDqgPA;IACE,+BAA+B;ECtgPjC;;EDygPA;IACE,iCAAiC;EC1gPnC;;ED6gPA;IACE,+BAA+B;EC9gPjC;;EDihPA;IACE,iCAAiC;EClhPnC;;EDqhPA;IACE,+BAA+B;ECthPjC;;EDyhPA;IACE,iCAAiC;EC1hPnC;;ED6hPA;IACE,+BAA+B;EC9hPjC;;EDiiPA;IACE,iCAAiC;ECliPnC;;EDqiPA;IACE,+BAA+B;ECtiPjC;;EDyiPA;IACE,iCAAiC;EC1iPnC;;ED6iPA;IACE,+BAA+B;EC9iPjC;;EDijPA;IACE,iCAAiC;ECljPnC;;EDqjPA;IACE,+BAA+B;ECtjPjC;;EDyjPA;IACE,iCAAiC;EC1jPnC;;ED6jPA;IACE,+BAA+B;EC9jPjC;;EDikPA;IACE,iCAAiC;EClkPnC;;EDqkPA;IACE,+BAA+B;ECtkPjC;;EDykPA;IACE,iCAAiC;EC1kPnC;;ED6kPA;IACE,+BAA+B;EC9kPjC;;EDilPA;IACE,iCAAiC;ECllPnC;;EDqlPA;IACE,+BAA+B;ECtlPjC;;EDylPA;IACE,iCAAiC;EC1lPnC;;ED6lPA;IACE,+BAA+B;EC9lPjC;;EDimPA;IACE,iCAAiC;EClmPnC;;EDqmPA;IACE,+BAA+B;ECtmPjC;;EDymPA;IACE,iCAAiC;EC1mPnC;;ED6mPA;IACE,+BAA+B;EC9mPjC;;EDinPA;IACE,iCAAiC;EClnPnC;;EDqnPA;IACE,+BAA+B;ECtnPjC;;EDynPA;IACE,iCAAiC;EC1nPnC;;ED6nPA;IACE,+BAA+B;EC9nPjC;;EDioPA;IACE,iCAAiC;ECloPnC;;EDqoPA;IACE,+BAA+B;ECtoPjC;;EDyoPA;IACE,iCAAiC;EC1oPnC;;ED6oPA;IACE,+BAA+B;EC9oPjC;;EDipPA;IACE,iCAAiC;EClpPnC;;EDqpPA;IACE,+BAA+B;ECtpPjC;;EDypPA;IACE,iCAAiC;EC1pPnC;;ED6pPA;IACE,+BAA+B;EC9pPjC;;EDiqPA;IACE,iCAAiC;EClqPnC;;EDqqPA;IACE,+BAA+B;ECtqPjC;;EDyqPA;IACE,iCAAiC;EC1qPnC;;ED6qPA;IACE,+BAA+B;EC9qPjC;;EDirPA;IACE,iCAAiC;EClrPnC;;EDqrPA;IACE,+BAA+B;ECtrPjC;;EDyrPA;IACE,iCAAiC;EC1rPnC;;ED6rPA;IACE,+BAA+B;EC9rPjC;;EDisPA;IACE,iCAAiC;EClsPnC;;EDqsPA;IACE,+BAA+B;ECtsPjC;;EDysPA;IACE,iCAAiC;EC1sPnC;;ED6sPA;IACE,+BAA+B;EC9sPjC;;EDitPA;IACE,iCAAiC;ECltPnC;;EDqtPA;IACE,+BAA+B;ECttPjC;;EDytPA;IACE,iCAAiC;EC1tPnC;;ED6tPA;IACE,+BAA+B;EC9tPjC;;EDiuPA;IACE,iCAAiC;ECluPnC;;EDquPA;IACE,+BAA+B;ECtuPjC;;EDyuPA;IACE,iCAAiC;EC1uPnC;;ED6uPA;IACE,+BAA+B;EC9uPjC;;EDivPA;IACE,iCAAiC;EClvPnC;;EDqvPA;IACE,+BAA+B;ECtvPjC;;EDyvPA;IACE,iCAAiC;EC1vPnC;;ED6vPA;IACE,+BAA+B;EC9vPjC;;EDiwPA;IACE,iCAAiC;EC/uPnC;;EDkvPA;IACE,+BAA+B;EACjC;;EAEA;ICpvPC,iCAAuC;EDsvPxC;;ECxvPA;IACC,6BAAc;IACd,8BAAe;ED2vPhB;;EC7vPA;IACC,gCAAsC;IACtC,iCAAuC;EDgwPxC;;EClwPA;IACC,+BAAsC;IACtC,gCAAuC;EDqwPxC;;ECvwPA;IACC,6BAAsC;IACtC,8BAAuC;ED0wPxC;;EC5wPA;IACC,+BAAsC;IACtC,gCAAuC;ED+wPxC;;ECjxPA;IACC,6BAAsC;IACtC,8BAAuC;EDoxPxC;;ECtxPA;IACC,+BAAsC;IACtC,gCAAuC;EDyxPxC;;EC3xPA;IACC,6BAAsC;IACtC,8BAAuC;ED8xPxC;;EChyPA;IACC,+BAAsC;IACtC,gCAAuC;EDmyPxC;;ECryPA;IACC,6BAAsC;IACtC,8BAAuC;EDwyPxC;;EC1yPA;IACC,+BAAsC;IACtC,gCAAuC;ED6yPxC;;EC/yPA;IACC,6BAAsC;IACtC,8BAAuC;EDkzPxC;;ECpzPA;IACC,+BAAsC;IACtC,gCAAuC;EDuzPxC;;ECzzPA;IACC,6BAAsC;IACtC,8BAAuC;ED4zPxC;;EC9zPA;IACC,+BAAsC;IACtC,gCAAuC;EDi0PxC;;ECn0PA;IACC,6BAAsC;IACtC,8BAAuC;EDs0PxC;;ECx0PA;IACC,+BAAsC;IACtC,gCAAuC;ED20PxC;;EC70PA;IACC,6BAAsC;IACtC,8BAAuC;EDg1PxC;;ECl1PA;IACC,+BAAsC;IACtC,gCAAuC;EDq1PxC;;ECv1PA;IACC,6BAAc;IACd,8BAAe;ED01PhB;;EC51PA;IACC,+BAAc;IACd,gCAAe;ED+1PhB;;ECj2PA;IACC,8BAAsC;IACtC,+BAAuC;EDo2PxC;;ECt2PA;IACC,gCAAsC;IACtC,iCAAuC;EDy2PxC;;EC32PA;IACC,8BAAsC;IACtC,+BAAuC;ED82PxC;;ECh3PA;IACC,gCAAsC;IACtC,iCAAuC;EDm3PxC;;ECr3PA;IACC,8BAAsC;IACtC,+BAAuC;EDw3PxC;;EC13PA;IACC,gCAAsC;IACtC,iCAAuC;ED63PxC;;EC/3PA;IACC,8BAAsC;IACtC,+BAAuC;EDk4PxC;;ECp4PA;IACC,gCAAsC;IACtC,iCAAuC;EDu4PxC;;ECz4PA;IACC,8BAAsC;IACtC,+BAAuC;ED44PxC;;EC94PA;IACC,gCAAsC;IACtC,iCAAuC;EDi5PxC;;ECn5PA;IACC,8BAAsC;IACtC,+BAAuC;EDs5PxC;;ECx5PA;IACC,gCAAsC;IACtC,iCAAuC;ED25PxC;;EC75PA;IACC,8BAAsC;IACtC,+BAAuC;EDg6PxC;;ECl6PA;IACC,gCAAsC;IACtC,iCAAuC;EDq6PxC;;ECv6PA;IACC,8BAAsC;IACtC,+BAAuC;ED06PxC;;EC56PA;IACC,gCAAsC;IACtC,iCAAuC;ED+6PxC;;ECj7PA;IACC,8BAAsC;IACtC,+BAAuC;EDo7PxC;;ECt7PA;IACC,gCAAsC;IACtC,iCAAuC;EDy7PxC;;EC37PA;IACC,8BAAsC;IACtC,+BAAuC;ED87PxC;;ECh8PA;IACC,gCAAsC;IACtC,iCAAuC;EDm8PxC;;ECr8PA;IACC,8BAAsC;IACtC,+BAAuC;EDw8PxC;;EC18PA;IACC,gCAAsC;IACtC,iCAAuC;ED68PxC;;EC/8PA;IACC,8BAAsC;IACtC,+BAAuC;EDk9PxC;;ECp9PA;IACC,gCAAsC;IACtC,iCAAuC;EDu9PxC;;ECz9PA;IACC,8BAAsC;IACtC,+BAAuC;ED49PxC;;EC99PA;IACC,gCAAsC;IACtC,iCAAuC;EDi+PxC;;ECn+PA;IACC,8BAAsC;IACtC,+BAAuC;EDs+PxC;;ECx+PA;IACC,gCAAsC;IACtC,iCAAuC;ED2+PxC;;EC7+PA;IACC,8BAAsC;IACtC,+BAAuC;EDg/PxC;;ECl/PA;IACC,gCAAsC;IACtC,iCAAuC;EDq/PxC;;ECv/PA;IACC,8BAAsC;IACtC,+BAAuC;ED0/PxC;;EC5/PA;IACC,gCAAsC;IACtC,iCAAuC;ED+/PxC;;ECjgQA;IACC,8BAAsC;IACtC,+BAAuC;EDogQxC;;ECtgQA;IACC,gCAAsC;IACtC,iCAAuC;EDygQxC;;EC3gQA;IACC,8BAAsC;IACtC,+BAAuC;ED8gQxC;;EChhQA;IACC,gCAAsC;IACtC,iCAAuC;EDmhQxC;;ECrhQA;IACC,8BAAsC;IACtC,+BAAuC;EDwhQxC;;EC1hQA;IACC,gCAAsC;IACtC,iCAAuC;ED6hQxC;;EC/hQA;IACC,8BAAsC;IACtC,+BAAuC;EDkiQxC;;ECpiQA;IACC,gCAAsC;IACtC,iCAAuC;EDuiQxC;;ECziQA;IACC,8BAAsC;IACtC,+BAAuC;ED4iQxC;;EC9iQA;IACC,gCAAsC;IACtC,iCAAuC;EDijQxC;;ECnjQA;IACC,8BAAsC;IACtC,+BAAuC;EDsjQxC;;ECxjQA;IACC,gCAAsC;IACtC,iCAAuC;ED2jQxC;;EC7jQA;IACC,8BAAsC;IACtC,+BAAuC;EDgkQxC;;EClkQA;IACC,gCAAsC;IACtC,iCAAuC;EDqkQxC;;ECvkQA;IACC,8BAAsC;IACtC,+BAAuC;ED0kQxC;;EC5kQA;IACC,gCAAsC;IACtC,iCAAuC;ED+kQxC;;ECjlQA;IACC,8BAAsC;IACtC,+BAAuC;EDolQxC;;ECtlQA;IACC,gCAAsC;IACtC,iCAAuC;EDylQxC;;EC3lQA;IACC,8BAAsC;IACtC,+BAAuC;ED8lQxC;;EChmQA;IACC,gCAAsC;IACtC,iCAAuC;EDmmQxC;;ECrmQA;IACC,8BAAsC;IACtC,+BAAuC;EDwmQxC;;EC1mQA;IACC,gCAAsC;IACtC,iCAAuC;ED6mQxC;;EC/mQA;IACC,8BAAsC;IACtC,+BAAuC;EDknQxC;;ECpnQA;IACC,gCAAsC;IACtC,iCAAuC;EDunQxC;;ECznQA;IACC,8BAAsC;IACtC,+BAAuC;ED4nQxC;;EC9nQA;IACC,gCAAsC;IACtC,iCAAuC;EDioQxC;;ECnoQA;IACC,8BAAsC;IACtC,+BAAuC;EDsoQxC;;ECxoQA;IACC,gCAAsC;IACtC,iCAAuC;ED2oQxC;;EC7oQA;IACC,8BAAsC;IACtC,+BAAuC;EDgpQxC;;EClpQA;IACC,gCAAsC;IACtC,iCAAuC;EDqpQxC;;ECvpQA;IACC,8BAAsC;IACtC,+BAAuC;ED0pQxC;;EC5pQA;IACC,gCAAsC;IACtC,iCAAuC;ED+pQxC;;ECjqQA;IACC,8BAAsC;IACtC,+BAAuC;EDoqQxC;;ECtqQA;IACC,gCAAsC;IACtC,iCAAuC;EDyqQxC;;EC3qQA;IACC,8BAAsC;IACtC,+BAAuC;ED8qQxC;;EChrQA;IACC,gCAAsC;IACtC,iCAAuC;EDmrQxC;;ECrrQA;IACC,8BAAsC;IACtC,+BAAuC;EDwrQxC;;EC1rQA;IACC,gCAAsC;IACtC,iCAAuC;ED6rQxC;;EC/rQA;IACC,8BAAsC;IACtC,+BAAuC;EDksQxC;;ECpsQA;IACC,gCAAsC;IACtC,iCAAuC;EDusQxC;;ECzsQA;IACC,8BAAsC;IACtC,+BAAuC;ED4sQxC;;EC9sQA;IACC,gCAAsC;IACtC,iCAAuC;EDitQxC;;ECntQA;IACC,8BAAsC;IACtC,+BAAuC;EDstQxC;;ECxtQA;IACC,gCAAsC;IACtC,iCAAuC;ED2tQxC;;EC7tQA;IACC,8BAAsC;IACtC,+BAAuC;EDguQxC;;ECluQA;IACC,gCAAsC;IACtC,iCAAuC;EDquQxC;;ECvuQA;IACC,8BAAsC;IACtC,+BAAuC;ED0uQxC;;EC5uQA;IACC,gCAAsC;IACtC,iCAAuC;ED+uQxC;;ECjvQA;IACC,8BAAsC;IACtC,+BAAuC;EDovQxC;;ECtvQA;IACC,gCAAsC;IACtC,iCAAuC;EDyvQxC;;EC3vQA;IACC,8BAAsC;IACtC,+BAAuC;ED8vQxC;;EChwQA;IACC,gCAAsC;IACtC,iCAAuC;EDmwQxC;;ECrwQA;IACC,8BAAsC;IACtC,+BAAuC;EDwwQxC;;EC1wQA;IACC,gCAAsC;IACtC,iCAAuC;ED6wQxC;;EC/wQA;IACC,8BAAsC;IACtC,+BAAuC;EDkxQxC;;ECpxQA;IACC,gCAAsC;IACtC,iCAAuC;EDuxQxC;;ECzxQA;IACC,8BAAsC;IACtC,+BAAuC;ED4xQxC;;EC9xQA;IACC,gCAAsC;IACtC,iCAAuC;EDiyQxC;;ECnyQA;IACC,8BAAsC;IACtC,+BAAuC;EDsyQxC;;ECxyQA;IACC,gCAAsC;IACtC,iCAAuC;ED2yQxC;;EC7yQA;IACC,8BAAsC;IACtC,+BAAuC;EDgzQxC;;EClzQA;IACC,gCAAsC;IACtC,iCAAuC;EDqzQxC;;ECvzQA;IACC,8BAAsC;IACtC,+BAAuC;ED0zQxC;;EC5zQA;IACC,gCAAsC;IACtC,iCAAuC;ED+zQxC;;ECj0QA;IACC,8BAAsC;IACtC,+BAAuC;EDo0QxC;;ECt0QA;IACC,gCAAsC;IACtC,iCAAuC;EDy0QxC;;EC30QA;IACC,8BAAsC;IACtC,+BAAuC;ED80QxC;;ECh1QA;IACC,gCAAsC;IACtC,iCAAuC;EDm1QxC;;ECr1QA;IACC,8BAAsC;IACtC,+BAAuC;EDw1QxC;;EC11QA;IACC,gCAAsC;IACtC,iCAAuC;ED61QxC;;EC/1QA;IACC,8BAAsC;IACtC,+BAAuC;EDk2QxC;;ECp2QA;IACC,gCAAsC;IACtC,iCAAuC;EDu2QxC;;ECz2QA;IACC,8BAAsC;IACtC,+BAAuC;ED42QxC;;EC92QA;IACC,gCAAsC;IACtC,iCAAuC;EDi3QxC;;ECn3QA;IACC,8BAAsC;IACtC,+BAAuC;EDs3QxC;;ECx3QA;IACC,gCAAsC;IACtC,iCAAuC;ED23QxC;;EC73QA;IACC,8BAAsC;IACtC,+BAAuC;EDg4QxC;;ECl4QA;IACC,gCAAsC;IACtC,iCAAuC;EDq4QxC;;ECv4QA;IACC,8BAAsC;IACtC,+BAAuC;ED04QxC;;EC54QA;IACC,gCAAsC;IACtC,iCAAuC;ED+4QxC;;ECj5QA;IACC,8BAAsC;IACtC,+BAAuC;EDo5QxC;;ECt5QA;IACC,gCAAsC;IACtC,iCAAuC;EDy5QxC;;EC35QA;IACC,8BAAsC;IACtC,+BAAuC;ED85QxC;;ECh6QA;IACC,gCAAsC;IACtC,iCAAuC;EDm6QxC;;ECr6QA;IACC,8BAAsC;IACtC,+BAAuC;EDw6QxC;;EC16QA;IACC,gCAAsC;IACtC,iCAAuC;ED66QxC;;EC/6QA;IACC,8BAAsC;IACtC,+BAAuC;EDk7QxC;;ECp7QA;IACC,gCAAsC;IACtC,iCAAuC;EDu7QxC;;ECz7QA;IACC,8BAAsC;IACtC,+BAAuC;ED47QxC;;EC97QA;IACC,gCAAsC;IACtC,iCAAuC;EDi8QxC;;ECn8QA;IACC,8BAAsC;IACtC,+BAAuC;EDs8QxC;;ECx8QA;IACC,gCAAsC;IACtC,iCAAuC;ED28QxC;;EC78QA;IACC,8BAAsC;IACtC,+BAAuC;EDg9QxC;;ECl9QA;IACC,gCAAsC;IACtC,iCAAuC;EDq9QxC;;ECv9QA;IACC,8BAAsC;IACtC,+BAAuC;ED09QxC;;EC59QA;IACC,gCAAsC;IACtC,iCAAuC;ED+9QxC;;ECj+QA;IACC,8BAAsC;IACtC,+BAAuC;EDo+QxC;;ECt+QA;IACC,gCAAsC;IACtC,iCAAuC;EDy+QxC;;EC3+QA;IACC,8BAAsC;IACtC,+BAAuC;ED8+QxC;;ECh/QA;IACC,gCAAsC;IACtC,iCAAuC;EDm/QxC;;ECr/QA;IACC,8BAAsC;IACtC,+BAAuC;EDw/QxC;;EC1/QA;IACC,gCAAsC;IACtC,iCAAuC;ED6/QxC;;EC//QA;IACC,8BAAsC;IACtC,+BAAuC;EDkgRxC;;ECpgRA;IACC,gCAAsC;IACtC,iCAAuC;EDugRxC;;ECzgRA;IACC,8BAAsC;IACtC,+BAAuC;ED4gRxC;;EC9gRA;IACC,gCAAsC;IACtC,iCAAuC;EDihRxC;;EC//QA;IACC,8BAAqC;IACrC,+BAAwC;EDkgRzC;;ECpgRA;IACC,gCAAqC;IACrC,iCAAgB;EDugRjB;;ECzgRA;IACC,4BAAa;IACb,+BAAgB;ED4gRjB;;EC9gRA;IACC,+BAAqC;IACrC,kCAAwC;EDihRzC;;ECnhRA;IACC,8BAAqC;IACrC,iCAAwC;EDshRzC;;ECxhRA;IACC,4BAAqC;IACrC,+BAAwC;ED2hRzC;;EC7hRA;IACC,8BAAqC;IACrC,iCAAwC;EDgiRzC;;ECliRA;IACC,4BAAqC;IACrC,+BAAwC;EDqiRzC;;ECviRA;IACC,8BAAqC;IACrC,iCAAwC;ED0iRzC;;EC5iRA;IACC,4BAAqC;IACrC,+BAAwC;ED+iRzC;;ECjjRA;IACC,8BAAqC;IACrC,iCAAwC;EDojRzC;;ECtjRA;IACC,4BAAqC;IACrC,+BAAwC;EDyjRzC;;EC3jRA;IACC,8BAAqC;IACrC,iCAAwC;ED8jRzC;;EChkRA;IACC,4BAAqC;IACrC,+BAAwC;EDmkRzC;;ECrkRA;IACC,8BAAqC;IACrC,iCAAwC;EDwkRzC;;EC1kRA;IACC,4BAAqC;IACrC,+BAAwC;ED6kRzC;;EC/kRA;IACC,8BAAqC;IACrC,iCAAwC;EDklRzC;;ECplRA;IACC,4BAAqC;IACrC,+BAAwC;EDulRzC;;ECzlRA;IACC,8BAAqC;IACrC,iCAAwC;ED4lRzC;;EC9lRA;IACC,4BAAqC;IACrC,+BAAwC;EDimRzC;;ECnmRA;IACC,8BAAqC;IACrC,iCAAwC;EDsmRzC;;ECxmRA;IACC,4BAAa;IACb,+BAAgB;ED2mRjB;;EC7mRA;IACC,8BAAa;IACb,iCAAgB;EDgnRjB;;EClnRA;IACC,6BAAqC;IACrC,gCAAwC;EDqnRzC;;ECvnRA;IACC,+BAAqC;IACrC,kCAAwC;ED0nRzC;;EC5nRA;IACC,6BAAqC;IACrC,gCAAwC;ED+nRzC;;ECjoRA;IACC,+BAAqC;IACrC,kCAAwC;EDooRzC;;ECtoRA;IACC,6BAAqC;IACrC,gCAAwC;EDyoRzC;;EC3oRA;IACC,+BAAqC;IACrC,kCAAwC;ED8oRzC;;EChpRA;IACC,6BAAqC;IACrC,gCAAwC;EDmpRzC;;ECrpRA;IACC,+BAAqC;IACrC,kCAAwC;EDwpRzC;;EC1pRA;IACC,6BAAqC;IACrC,gCAAwC;ED6pRzC;;EC/pRA;IACC,+BAAqC;IACrC,kCAAwC;EDkqRzC;;ECpqRA;IACC,6BAAqC;IACrC,gCAAwC;EDuqRzC;;ECzqRA;IACC,+BAAqC;IACrC,kCAAwC;ED4qRzC;;EC9qRA;IACC,6BAAqC;IACrC,gCAAwC;EDirRzC;;ECnrRA;IACC,+BAAqC;IACrC,kCAAwC;EDsrRzC;;ECxrRA;IACC,6BAAqC;IACrC,gCAAwC;ED2rRzC;;EC7rRA;IACC,+BAAqC;IACrC,kCAAwC;EDgsRzC;;EClsRA;IACC,6BAAqC;IACrC,gCAAwC;EDqsRzC;;ECvsRA;IACC,+BAAqC;IACrC,kCAAwC;ED0sRzC;;EC5sRA;IACC,6BAAqC;IACrC,gCAAwC;ED+sRzC;;ECjtRA;IACC,+BAAqC;IACrC,kCAAwC;EDotRzC;;ECttRA;IACC,6BAAqC;IACrC,gCAAwC;EDytRzC;;EC3tRA;IACC,+BAAqC;IACrC,kCAAwC;ED8tRzC;;EChuRA;IACC,6BAAqC;IACrC,gCAAwC;EDmuRzC;;ECruRA;IACC,+BAAqC;IACrC,kCAAwC;EDwuRzC;;EC1uRA;IACC,6BAAqC;IACrC,gCAAwC;ED6uRzC;;EC/uRA;IACC,+BAAqC;IACrC,kCAAwC;EDkvRzC;;ECpvRA;IACC,6BAAqC;IACrC,gCAAwC;EDuvRzC;;ECzvRA;IACC,+BAAqC;IACrC,kCAAwC;ED4vRzC;;EC9vRA;IACC,6BAAqC;IACrC,gCAAwC;EDiwRzC;;ECnwRA;IACC,+BAAqC;IACrC,kCAAwC;EDswRzC;;ECxwRA;IACC,6BAAqC;IACrC,gCAAwC;ED2wRzC;;EC7wRA;IACC,+BAAqC;IACrC,kCAAwC;EDgxRzC;;EClxRA;IACC,6BAAqC;IACrC,gCAAwC;EDqxRzC;;ECvxRA;IACC,+BAAqC;IACrC,kCAAwC;ED0xRzC;;EC5xRA;IACC,6BAAqC;IACrC,gCAAwC;ED+xRzC;;ECjyRA;IACC,+BAAqC;IACrC,kCAAwC;EDoyRzC;;ECtyRA;IACC,6BAAqC;IACrC,gCAAwC;EDyyRzC;;EC3yRA;IACC,+BAAqC;IACrC,kCAAwC;ED8yRzC;;EChzRA;IACC,6BAAqC;IACrC,gCAAwC;EDmzRzC;;ECrzRA;IACC,+BAAqC;IACrC,kCAAwC;EDwzRzC;;EC1zRA;IACC,6BAAqC;IACrC,gCAAwC;ED6zRzC;;EC/zRA;IACC,+BAAqC;IACrC,kCAAwC;EDk0RzC;;ECp0RA;IACC,6BAAqC;IACrC,gCAAwC;EDu0RzC;;ECz0RA;IACC,+BAAqC;IACrC,kCAAwC;ED40RzC;;EC90RA;IACC,6BAAqC;IACrC,gCAAwC;EDi1RzC;;ECn1RA;IACC,+BAAqC;IACrC,kCAAwC;EDs1RzC;;ECx1RA;IACC,6BAAqC;IACrC,gCAAwC;ED21RzC;;EC71RA;IACC,+BAAqC;IACrC,kCAAwC;EDg2RzC;;ECl2RA;IACC,6BAAqC;IACrC,gCAAwC;EDq2RzC;;ECv2RA;IACC,+BAAqC;IACrC,kCAAwC;ED02RzC;;EC52RA;IACC,6BAAqC;IACrC,gCAAwC;ED+2RzC;;ECj3RA;IACC,+BAAqC;IACrC,kCAAwC;EDo3RzC;;ECt3RA;IACC,6BAAqC;IACrC,gCAAwC;EDy3RzC;;EC33RA;IACC,+BAAqC;IACrC,kCAAwC;ED83RzC;;ECh4RA;IACC,6BAAqC;IACrC,gCAAwC;EDm4RzC;;ECr4RA;IACC,+BAAqC;IACrC,kCAAwC;EDw4RzC;;EC14RA;IACC,6BAAqC;IACrC,gCAAwC;ED64RzC;;EC/4RA;IACC,+BAAqC;IACrC,kCAAwC;EDk5RzC;;ECp5RA;IACC,6BAAqC;IACrC,gCAAwC;EDu5RzC;;ECz5RA;IACC,+BAAqC;IACrC,kCAAwC;ED45RzC;;EC95RA;IACC,6BAAqC;IACrC,gCAAwC;EDi6RzC;;ECn6RA;IACC,+BAAqC;IACrC,kCAAwC;EDs6RzC;;ECx6RA;IACC,6BAAqC;IACrC,gCAAwC;ED26RzC;;EC76RA;IACC,+BAAqC;IACrC,kCAAwC;EDg7RzC;;ECl7RA;IACC,6BAAqC;IACrC,gCAAwC;EDq7RzC;;ECv7RA;IACC,+BAAqC;IACrC,kCAAwC;ED07RzC;;EC57RA;IACC,6BAAqC;IACrC,gCAAwC;ED+7RzC;;ECj8RA;IACC,+BAAqC;IACrC,kCAAwC;EDo8RzC;;ECt8RA;IACC,6BAAqC;IACrC,gCAAwC;EDy8RzC;;EC38RA;IACC,+BAAqC;IACrC,kCAAwC;ED88RzC;;ECh9RA;IACC,6BAAqC;IACrC,gCAAwC;EDm9RzC;;ECr9RA;IACC,+BAAqC;IACrC,kCAAwC;EDw9RzC;;EC19RA;IACC,6BAAqC;IACrC,gCAAwC;ED69RzC;;EC/9RA;IACC,+BAAqC;IACrC,kCAAwC;EDk+RzC;;ECp+RA;IACC,6BAAqC;IACrC,gCAAwC;EDu+RzC;;ECz+RA;IACC,+BAAqC;IACrC,kCAAwC;ED4+RzC;;EC9+RA;IACC,6BAAqC;IACrC,gCAAwC;EDi/RzC;;ECn/RA;IACC,+BAAqC;IACrC,kCAAwC;EDs/RzC;;ECx/RA;IACC,6BAAqC;IACrC,gCAAwC;ED2/RzC;;EC7/RA;IACC,+BAAqC;IACrC,kCAAwC;EDggSzC;;EClgSA;IACC,6BAAqC;IACrC,gCAAwC;EDqgSzC;;ECvgSA;IACC,+BAAqC;IACrC,kCAAwC;ED0gSzC;;EC5gSA;IACC,6BAAqC;IACrC,gCAAwC;ED+gSzC;;ECjhSA;IACC,+BAAqC;IACrC,kCAAwC;EDohSzC;;ECthSA;IACC,6BAAqC;IACrC,gCAAwC;EDyhSzC;;EC3hSA;IACC,+BAAqC;IACrC,kCAAwC;ED8hSzC;;EChiSA;IACC,6BAAqC;IACrC,gCAAwC;EDmiSzC;;ECriSA;IACC,+BAAqC;IACrC,kCAAwC;EDwiSzC;;EC1iSA;IACC,6BAAqC;IACrC,gCAAwC;ED6iSzC;;EC/iSA;IACC,+BAAqC;IACrC,kCAAwC;EDkjSzC;;ECpjSA;IACC,6BAAqC;IACrC,gCAAwC;EDujSzC;;ECzjSA;IACC,+BAAqC;IACrC,kCAAwC;ED4jSzC;;EC9jSA;IACC,6BAAqC;IACrC,gCAAwC;EDikSzC;;ECnkSA;IACC,+BAAqC;IACrC,kCAAwC;EDskSzC;;ECxkSA;IACC,6BAAqC;IACrC,gCAAwC;ED2kSzC;;EC7kSA;IACC,+BAAqC;IACrC,kCAAwC;EDglSzC;;ECllSA;IACC,6BAAqC;IACrC,gCAAwC;EDqlSzC;;ECvlSA;IACC,+BAAqC;IACrC,kCAAwC;ED0lSzC;;EC5lSA;IACC,6BAAqC;IACrC,gCAAwC;ED+lSzC;;ECjmSA;IACC,+BAAqC;IACrC,kCAAwC;EDomSzC;;ECtmSA;IACC,6BAAqC;IACrC,gCAAwC;EDymSzC;;EC3mSA;IACC,+BAAqC;IACrC,kCAAwC;ED8mSzC;;EChnSA;IACC,6BAAqC;IACrC,gCAAwC;EDmnSzC;;ECrnSA;IACC,+BAAqC;IACrC,kCAAwC;EDwnSzC;;EC1nSA;IACC,6BAAqC;IACrC,gCAAwC;ED6nSzC;;EC/nSA;IACC,+BAAqC;IACrC,kCAAwC;EDkoSzC;;ECpoSA;IACC,6BAAqC;IACrC,gCAAwC;EDuoSzC;;ECzoSA;IACC,+BAAqC;IACrC,kCAAwC;ED4oSzC;;EC9oSA;IACC,6BAAqC;IACrC,gCAAwC;EDipSzC;;ECnpSA;IACC,+BAAqC;IACrC,kCAAwC;EDspSzC;;ECxpSA;IACC,6BAAqC;IACrC,gCAAwC;ED2pSzC;;EC7pSA;IACC,+BAAqC;IACrC,kCAAwC;EDgqSzC;;EClqSA;IACC,6BAAqC;IACrC,gCAAwC;EDqqSzC;;ECvqSA;IACC,+BAAqC;IACrC,kCAAwC;ED0qSzC;;EC5qSA;IACC,6BAAqC;IACrC,gCAAwC;ED+qSzC;;ECjrSA;IACC,+BAAqC;IACrC,kCAAwC;EDorSzC;;ECtrSA;IACC,6BAAqC;IACrC,gCAAwC;EDyrSzC;;EC3rSA;IACC,+BAAqC;IACrC,kCAAwC;ED8rSzC;;EChsSA;IACC,6BAAqC;IACrC,gCAAwC;EDmsSzC;;ECrsSA;IACC,+BAAqC;IACrC,kCAAwC;EDwsSzC;;EC1sSA;IACC,6BAAqC;IACrC,gCAAwC;ED6sSzC;;EC/sSA;IACC,+BAAqC;IACrC,kCAAwC;EDktSzC;;ECptSA;IACC,6BAAqC;IACrC,gCAAwC;EDutSzC;;ECztSA;IACC,+BAAqC;IACrC,kCAAwC;ED4tSzC;;EC9tSA;IACC,6BAAqC;IACrC,gCAAwC;EDiuSzC;;ECnuSA;IACC,+BAAqC;IACrC,kCAAwC;EDsuSzC;;ECxuSA;IACC,6BAAqC;IACrC,gCAAwC;ED2uSzC;;EC7uSA;IACC,+BAAqC;IACrC,kCAAwC;EDgvSzC;;EClvSA;IACC,6BAAqC;IACrC,gCAAwC;EDqvSzC;;ECvvSA;IACC,+BAAqC;IACrC,kCAAwC;ED0vSzC;;EC5vSA;IACC,6BAAqC;IACrC,gCAAwC;ED+vSzC;;ECjwSA;IACC,+BAAqC;IACrC,kCAAwC;EDowSzC;;ECtwSA;IACC,6BAAqC;IACrC,gCAAwC;EDywSzC;;EC3wSA;IACC,+BAAqC;IACrC,kCAAwC;ED8wSzC;;EChxSA;IACC,6BAAqC;IACrC,gCAAwC;EDmxSzC;;ECrxSA;IACC,+BAAqC;IACrC,kCAAwC;EDwxSzC;;EC1xSA;IACC,6BAAqC;IACrC,gCAAwC;ED6xSzC;;EC/xSA;IACC,+BAAqC;IACrC,kCAAwC;EDkySzC;;EC5xSF;IAaE,6BAAc;IACb,gCAAiC;EDmxSlC;;ECpxSA;IACC,+BAAiC;IDuxShC,kCAAkC;EACpC;AACF;AACA;EACE;IACE,wBAAwB;EC7xS1B;;EDgySA;IACE,2BAA2B;ECjyS7B;;EDoySA;IACE,0BAA0B;ECryS5B;;EDwySA;IACE,wBAAwB;ECzyS1B;;ED4ySA;IACE,0BAA0B;EC7yS5B;;EDgzSA;IACE,wBAAwB;ECjzS1B;;EDozSA;IACE,0BAA0B;ECrzS5B;;EDwzSA;IACE,wBAAwB;ECzzS1B;;ED4zSA;IACE,0BAA0B;EC7zS5B;;EDg0SA;IACE,wBAAwB;ECj0S1B;;EDo0SA;IACE,0BAA0B;ECr0S5B;;EDw0SA;IACE,wBAAwB;ECz0S1B;;ED40SA;IACE,0BAA0B;EC70S5B;;EDg1SA;IACE,wBAAwB;ECj1S1B;;EDo1SA;IACE,0BAA0B;ECr1S5B;;EDw1SA;IACE,wBAAwB;ECz1S1B;;ED41SA;IACE,0BAA0B;EC71S5B;;EDg2SA;IACE,wBAAwB;ECj2S1B;;EDo2SA;IACE,0BAA0B;ECr2S5B;;EDw2SA;IACE,wBAAwB;ECz2S1B;;ED42SA;IACE,0BAA0B;EC72S5B;;EDg3SA;IACE,yBAAyB;ECj3S3B;;EDo3SA;IACE,2BAA2B;ECr3S7B;;EDw3SA;IACE,yBAAyB;ECz3S3B;;ED43SA;IACE,2BAA2B;EC73S7B;;EDg4SA;IACE,yBAAyB;ECj4S3B;;EDo4SA;IACE,2BAA2B;ECr4S7B;;EDw4SA;IACE,yBAAyB;ECz4S3B;;ED44SA;IACE,2BAA2B;EC74S7B;;EDg5SA;IACE,yBAAyB;ECj5S3B;;EDo5SA;IACE,2BAA2B;ECr5S7B;;EDw5SA;IACE,yBAAyB;ECz5S3B;;ED45SA;IACE,2BAA2B;EC75S7B;;EDg6SA;IACE,yBAAyB;ECj6S3B;;EDo6SA;IACE,2BAA2B;ECr6S7B;;EDw6SA;IACE,yBAAyB;ECz6S3B;;ED46SA;IACE,2BAA2B;EC76S7B;;EDg7SA;IACE,yBAAyB;ECj7S3B;;EDo7SA;IACE,2BAA2B;ECr7S7B;;EDw7SA;IACE,yBAAyB;ECz7S3B;;ED47SA;IACE,2BAA2B;EC77S7B;;EDg8SA;IACE,yBAAyB;ECj8S3B;;EDo8SA;IACE,2BAA2B;ECr8S7B;;EDw8SA;IACE,yBAAyB;ECz8S3B;;ED48SA;IACE,2BAA2B;EC78S7B;;EDg9SA;IACE,yBAAyB;ECj9S3B;;EDo9SA;IACE,2BAA2B;ECr9S7B;;EDw9SA;IACE,yBAAyB;ECz9S3B;;ED49SA;IACE,2BAA2B;EC79S7B;;EDg+SA;IACE,yBAAyB;ECj+S3B;;EDo+SA;IACE,2BAA2B;ECr+S7B;;EDw+SA;IACE,yBAAyB;ECz+S3B;;ED4+SA;IACE,2BAA2B;EC7+S7B;;EDg/SA;IACE,yBAAyB;ECj/S3B;;EDo/SA;IACE,2BAA2B;ECr/S7B;;EDw/SA;IACE,yBAAyB;ECz/S3B;;ED4/SA;IACE,2BAA2B;EC7/S7B;;EDggTA;IACE,yBAAyB;ECjgT3B;;EDogTA;IACE,2BAA2B;ECrgT7B;;EDwgTA;IACE,yBAAyB;ECzgT3B;;ED4gTA;IACE,2BAA2B;EC7gT7B;;EDghTA;IACE,yBAAyB;ECjhT3B;;EDohTA;IACE,2BAA2B;ECrhT7B;;EDwhTA;IACE,yBAAyB;ECzhT3B;;ED4hTA;IACE,2BAA2B;EC7hT7B;;EDgiTA;IACE,yBAAyB;ECjiT3B;;EDoiTA;IACE,2BAA2B;ECriT7B;;EDwiTA;IACE,yBAAyB;ECziT3B;;ED4iTA;IACE,2BAA2B;EC7iT7B;;EDgjTA;IACE,yBAAyB;ECjjT3B;;EDojTA;IACE,2BAA2B;ECrjT7B;;EDwjTA;IACE,yBAAyB;ECzjT3B;;ED4jTA;IACE,2BAA2B;EC7jT7B;;EDgkTA;IACE,yBAAyB;ECjkT3B;;EDokTA;IACE,2BAA2B;ECrkT7B;;EDwkTA;IACE,yBAAyB;ECzkT3B;;ED4kTA;IACE,2BAA2B;EC7kT7B;;EDglTA;IACE,yBAAyB;ECjlT3B;;EDolTA;IACE,2BAA2B;ECrlT7B;;EDwlTA;IACE,yBAAyB;ECzlT3B;;ED4lTA;IACE,2BAA2B;EC7lT7B;;EDgmTA;IACE,yBAAyB;ECjmT3B;;EDomTA;IACE,2BAA2B;ECrmT7B;;EDwmTA;IACE,yBAAyB;ECzmT3B;;ED4mTA;IACE,2BAA2B;EC7mT7B;;EDgnTA;IACE,yBAAyB;ECjnT3B;;EDonTA;IACE,2BAA2B;ECrnT7B;;EDwnTA;IACE,yBAAyB;ECznT3B;;ED4nTA;IACE,2BAA2B;EC7nT7B;;EDgoTA;IACE,yBAAyB;ECjoT3B;;EDooTA;IACE,2BAA2B;ECroT7B;;EDwoTA;IACE,yBAAyB;ECzoT3B;;ED4oTA;IACE,2BAA2B;EC7oT7B;;EDgpTA;IACE,yBAAyB;ECjpT3B;;EDopTA;IACE,2BAA2B;ECrpT7B;;EDwpTA;IACE,yBAAyB;ECzpT3B;;ED4pTA;IACE,2BAA2B;EC7pT7B;;EDgqTA;IACE,yBAAyB;ECjqT3B;;EDoqTA;IACE,2BAA2B;ECrqT7B;;EDwqTA;IACE,yBAAyB;ECzqT3B;;ED4qTA;IACE,2BAA2B;EC7qT7B;;EDgrTA;IACE,yBAAyB;ECjrT3B;;EDorTA;IACE,2BAA2B;ECrrT7B;;EDwrTA;IACE,yBAAyB;ECzrT3B;;ED4rTA;IACE,2BAA2B;EC7rT7B;;EDgsTA;IACE,yBAAyB;ECjsT3B;;EDosTA;IACE,2BAA2B;ECrsT7B;;EDwsTA;IACE,yBAAyB;ECzsT3B;;ED4sTA;IACE,2BAA2B;EC7sT7B;;EDgtTA;IACE,yBAAyB;ECjtT3B;;EDotTA;IACE,2BAA2B;ECrtT7B;;EDwtTA;IACE,yBAAyB;ECztT3B;;ED4tTA;IACE,2BAA2B;EC7tT7B;;EDguTA;IACE,yBAAyB;ECjuT3B;;EDouTA;IACE,2BAA2B;ECruT7B;;EDwuTA;IACE,yBAAyB;ECzuT3B;;ED4uTA;IACE,2BAA2B;EC7uT7B;;EDgvTA;IACE,yBAAyB;ECjvT3B;;EDovTA;IACE,2BAA2B;ECrvT7B;;EDwvTA;IACE,yBAAyB;ECzvT3B;;ED4vTA;IACE,2BAA2B;EC7vT7B;;EDgwTA;IACE,yBAAyB;ECjwT3B;;EDowTA;IACE,2BAA2B;ECrwT7B;;EDwwTA;IACE,yBAAyB;ECzwT3B;;ED4wTA;IACE,2BAA2B;EC7wT7B;;EDgxTA;IACE,yBAAyB;ECjxT3B;;EDoxTA;IACE,2BAA2B;ECrxT7B;;EDwxTA;IACE,yBAAyB;ECzxT3B;;ED4xTA;IACE,2BAA2B;EC7xT7B;;EDgyTA;IACE,yBAAyB;ECjyT3B;;EDoyTA;IACE,2BAA2B;ECryT7B;;EDwyTA;IACE,yBAAyB;ECzyT3B;;ED4yTA;IACE,2BAA2B;EC7yT7B;;EDgzTA;IACE,yBAAyB;ECjzT3B;;EDozTA;IACE,2BAA2B;ECrzT7B;;EDwzTA;IACE,yBAAyB;ECzzT3B;;ED4zTA;IACE,2BAA2B;EC7zT7B;;EDg0TA;IACE,yBAAyB;ECj0T3B;;EDo0TA;IACE,2BAA2B;ECr0T7B;;EDw0TA;IACE,yBAAyB;ECz0T3B;;ED40TA;IACE,2BAA2B;EC70T7B;;EDg1TA;IACE,yBAAyB;ECj1T3B;;EDo1TA;IACE,2BAA2B;ECr1T7B;;EDw1TA;IACE,yBAAyB;ECz1T3B;;ED41TA;IACE,2BAA2B;EC71T7B;;EDg2TA;IACE,yBAAyB;ECj2T3B;;EDo2TA;IACE,2BAA2B;ECr2T7B;;EDw2TA;IACE,yBAAyB;ECz2T3B;;ED42TA;IACE,2BAA2B;EC72T7B;;EDg3TA;IACE,yBAAyB;ECj3T3B;;EDo3TA;IACE,2BAA2B;ECr3T7B;;EDw3TA;IACE,yBAAyB;ECz3T3B;;ED43TA;IACE,2BAA2B;EC73T7B;;EDg4TA;IACE,yBAAyB;ECj4T3B;;EDo4TA;IACE,2BAA2B;ECr4T7B;;EDw4TA;IACE,yBAAyB;ECz4T3B;;ED44TA;IACE,2BAA2B;EC74T7B;;EDg5TA;IACE,yBAAyB;ECj5T3B;;EDo5TA;IACE,2BAA2B;ECl4T7B;;EDq4TA;IACE,yBAAyB;ECt4T3B;;EDy4TA;IACE,2BAA2B;EC14T7B;;ED64TA;IACE,4BAA4B;EC94T9B;;EDi5TA;IACE,+BAA+B;ECl5TjC;;EDq5TA;IACE,8BAA8B;ECt5ThC;;EDy5TA;IACE,4BAA4B;EC15T9B;;ED65TA;IACE,8BAA8B;EC95ThC;;EDi6TA;IACE,4BAA4B;ECl6T9B;;EDq6TA;IACE,8BAA8B;ECt6ThC;;EDy6TA;IACE,4BAA4B;EC16T9B;;ED66TA;IACE,8BAA8B;EC96ThC;;EDi7TA;IACE,4BAA4B;ECl7T9B;;EDq7TA;IACE,8BAA8B;ECt7ThC;;EDy7TA;IACE,4BAA4B;EC17T9B;;ED67TA;IACE,8BAA8B;EC97ThC;;EDi8TA;IACE,4BAA4B;ECl8T9B;;EDq8TA;IACE,8BAA8B;ECt8ThC;;EDy8TA;IACE,4BAA4B;EC18T9B;;ED68TA;IACE,8BAA8B;EC98ThC;;EDi9TA;IACE,4BAA4B;ECl9T9B;;EDq9TA;IACE,8BAA8B;ECt9ThC;;EDy9TA;IACE,4BAA4B;EC19T9B;;ED69TA;IACE,8BAA8B;EC99ThC;;EDi+TA;IACE,6BAA6B;ECl+T/B;;EDq+TA;IACE,+BAA+B;ECt+TjC;;EDy+TA;IACE,6BAA6B;EC1+T/B;;ED6+TA;IACE,+BAA+B;EC9+TjC;;EDi/TA;IACE,6BAA6B;ECl/T/B;;EDq/TA;IACE,+BAA+B;ECt/TjC;;EDy/TA;IACE,6BAA6B;EC1/T/B;;ED6/TA;IACE,+BAA+B;EC9/TjC;;EDigUA;IACE,6BAA6B;EClgU/B;;EDqgUA;IACE,+BAA+B;ECtgUjC;;EDygUA;IACE,6BAA6B;EC1gU/B;;ED6gUA;IACE,+BAA+B;EC9gUjC;;EDihUA;IACE,6BAA6B;EClhU/B;;EDqhUA;IACE,+BAA+B;ECthUjC;;EDyhUA;IACE,6BAA6B;EC1hU/B;;ED6hUA;IACE,+BAA+B;EC9hUjC;;EDiiUA;IACE,6BAA6B;ECliU/B;;EDqiUA;IACE,+BAA+B;ECtiUjC;;EDyiUA;IACE,6BAA6B;EC1iU/B;;ED6iUA;IACE,+BAA+B;EC9iUjC;;EDijUA;IACE,6BAA6B;ECljU/B;;EDqjUA;IACE,+BAA+B;ECtjUjC;;EDyjUA;IACE,6BAA6B;EC1jU/B;;ED6jUA;IACE,+BAA+B;EC9jUjC;;EDikUA;IACE,6BAA6B;EClkU/B;;EDqkUA;IACE,+BAA+B;ECtkUjC;;EDykUA;IACE,6BAA6B;EC1kU/B;;ED6kUA;IACE,+BAA+B;EC9kUjC;;EDilUA;IACE,6BAA6B;ECllU/B;;EDqlUA;IACE,+BAA+B;ECtlUjC;;EDylUA;IACE,6BAA6B;EC1lU/B;;ED6lUA;IACE,+BAA+B;EC9lUjC;;EDimUA;IACE,6BAA6B;EClmU/B;;EDqmUA;IACE,+BAA+B;ECtmUjC;;EDymUA;IACE,6BAA6B;EC1mU/B;;ED6mUA;IACE,+BAA+B;EC9mUjC;;EDinUA;IACE,6BAA6B;EClnU/B;;EDqnUA;IACE,+BAA+B;ECtnUjC;;EDynUA;IACE,6BAA6B;EC1nU/B;;ED6nUA;IACE,+BAA+B;EC9nUjC;;EDioUA;IACE,6BAA6B;ECloU/B;;EDqoUA;IACE,+BAA+B;ECtoUjC;;EDyoUA;IACE,6BAA6B;EC1oU/B;;ED6oUA;IACE,+BAA+B;EC9oUjC;;EDipUA;IACE,6BAA6B;EClpU/B;;EDqpUA;IACE,+BAA+B;ECtpUjC;;EDypUA;IACE,6BAA6B;EC1pU/B;;ED6pUA;IACE,+BAA+B;EC9pUjC;;EDiqUA;IACE,6BAA6B;EClqU/B;;EDqqUA;IACE,+BAA+B;ECtqUjC;;EDyqUA;IACE,6BAA6B;EC1qU/B;;ED6qUA;IACE,+BAA+B;EC9qUjC;;EDirUA;IACE,6BAA6B;EClrU/B;;EDqrUA;IACE,+BAA+B;ECtrUjC;;EDyrUA;IACE,6BAA6B;EC1rU/B;;ED6rUA;IACE,+BAA+B;EC9rUjC;;EDisUA;IACE,6BAA6B;EClsU/B;;EDqsUA;IACE,+BAA+B;ECtsUjC;;EDysUA;IACE,6BAA6B;EC1sU/B;;ED6sUA;IACE,+BAA+B;EC9sUjC;;EDitUA;IACE,6BAA6B;ECltU/B;;EDqtUA;IACE,+BAA+B;ECttUjC;;EDytUA;IACE,6BAA6B;EC1tU/B;;ED6tUA;IACE,+BAA+B;EC9tUjC;;EDiuUA;IACE,6BAA6B;ECluU/B;;EDquUA;IACE,+BAA+B;ECtuUjC;;EDyuUA;IACE,6BAA6B;EC1uU/B;;ED6uUA;IACE,+BAA+B;EC9uUjC;;EDivUA;IACE,6BAA6B;EClvU/B;;EDqvUA;IACE,+BAA+B;ECtvUjC;;EDyvUA;IACE,6BAA6B;EC1vU/B;;ED6vUA;IACE,+BAA+B;EC9vUjC;;EDiwUA;IACE,6BAA6B;EClwU/B;;EDqwUA;IACE,+BAA+B;ECtwUjC;;EDywUA;IACE,6BAA6B;EC1wU/B;;ED6wUA;IACE,+BAA+B;EC9wUjC;;EDixUA;IACE,6BAA6B;EClxU/B;;EDqxUA;IACE,+BAA+B;ECtxUjC;;EDyxUA;IACE,6BAA6B;EC1xU/B;;ED6xUA;IACE,+BAA+B;EC9xUjC;;EDiyUA;IACE,6BAA6B;EClyU/B;;EDqyUA;IACE,+BAA+B;ECtyUjC;;EDyyUA;IACE,6BAA6B;EC1yU/B;;ED6yUA;IACE,+BAA+B;EC9yUjC;;EDizUA;IACE,6BAA6B;EClzU/B;;EDqzUA;IACE,+BAA+B;ECtzUjC;;EDyzUA;IACE,6BAA6B;EC1zU/B;;ED6zUA;IACE,+BAA+B;EC9zUjC;;EDi0UA;IACE,6BAA6B;ECl0U/B;;EDq0UA;IACE,+BAA+B;ECt0UjC;;EDy0UA;IACE,6BAA6B;EC10U/B;;ED60UA;IACE,+BAA+B;EC90UjC;;EDi1UA;IACE,6BAA6B;ECl1U/B;;EDq1UA;IACE,+BAA+B;ECt1UjC;;EDy1UA;IACE,6BAA6B;EC11U/B;;ED61UA;IACE,+BAA+B;EC91UjC;;EDi2UA;IACE,6BAA6B;ECl2U/B;;EDq2UA;IACE,+BAA+B;ECt2UjC;;EDy2UA;IACE,6BAA6B;EC12U/B;;ED62UA;IACE,+BAA+B;EC92UjC;;EDi3UA;IACE,6BAA6B;ECl3U/B;;EDq3UA;IACE,+BAA+B;ECt3UjC;;EDy3UA;IACE,6BAA6B;EC13U/B;;ED63UA;IACE,+BAA+B;EC93UjC;;EDi4UA;IACE,6BAA6B;ECl4U/B;;EDq4UA;IACE,+BAA+B;ECt4UjC;;EDy4UA;IACE,6BAA6B;EC14U/B;;ED64UA;IACE,+BAA+B;EC94UjC;;EDi5UA;IACE,6BAA6B;ECl5U/B;;EDq5UA;IACE,+BAA+B;ECt5UjC;;EDy5UA;IACE,6BAA6B;EC15U/B;;ED65UA;IACE,+BAA+B;EC95UjC;;EDi6UA;IACE,6BAA6B;ECl6U/B;;EDq6UA;IACE,+BAA+B;ECt6UjC;;EDy6UA;IACE,6BAA6B;EC16U/B;;ED66UA;IACE,+BAA+B;EC96UjC;;EDi7UA;IACE,6BAA6B;ECl7U/B;;EDq7UA;IACE,+BAA+B;ECt7UjC;;EDy7UA;IACE,6BAA6B;EC17U/B;;ED67UA;IACE,+BAA+B;EC97UjC;;EDi8UA;IACE,6BAA6B;ECl8U/B;;EDq8UA;IACE,+BAA+B;ECt8UjC;;EDy8UA;IACE,6BAA6B;EC18U/B;;ED68UA;IACE,+BAA+B;EC98UjC;;EDi9UA;IACE,6BAA6B;ECl9U/B;;EDq9UA;IACE,+BAA+B;ECt9UjC;;EDy9UA;IACE,6BAA6B;EC19U/B;;ED69UA;IACE,+BAA+B;EC99UjC;;EDi+UA;IACE,6BAA6B;ECl+U/B;;EDq+UA;IACE,+BAA+B;ECt+UjC;;EDy+UA;IACE,6BAA6B;EC1+U/B;;ED6+UA;IACE,+BAA+B;EC9+UjC;;EDi/UA;IACE,6BAA6B;ECl/U/B;;EDq/UA;IACE,+BAA+B;ECt/UjC;;EDy/UA;IACE,6BAA6B;EC1/U/B;;ED6/UA;IACE,+BAA+B;EC9/UjC;;EDigVA;IACE,6BAA6B;EClgV/B;;EDqgVA;IACE,+BAA+B;ECn/UjC;;EDs/UA;IACE,6BAA6B;ECv/U/B;;ED0/UA;IACE,+BAA+B;EC3/UjC;;ED8/UA;IACE,+BAA+B;EC//UjC;;EDkgVA;IACE,kCAAkC;ECngVpC;;EDsgVA;IACE,iCAAiC;ECvgVnC;;ED0gVA;IACE,+BAA+B;EC3gVjC;;ED8gVA;IACE,iCAAiC;EC/gVnC;;EDkhVA;IACE,+BAA+B;ECnhVjC;;EDshVA;IACE,iCAAiC;ECvhVnC;;ED0hVA;IACE,+BAA+B;EC3hVjC;;ED8hVA;IACE,iCAAiC;EC/hVnC;;EDkiVA;IACE,+BAA+B;ECniVjC;;EDsiVA;IACE,iCAAiC;ECviVnC;;ED0iVA;IACE,+BAA+B;EC3iVjC;;ED8iVA;IACE,iCAAiC;EC/iVnC;;EDkjVA;IACE,+BAA+B;ECnjVjC;;EDsjVA;IACE,iCAAiC;ECvjVnC;;ED0jVA;IACE,+BAA+B;EC3jVjC;;ED8jVA;IACE,iCAAiC;EC/jVnC;;EDkkVA;IACE,+BAA+B;ECnkVjC;;EDskVA;IACE,iCAAiC;ECvkVnC;;ED0kVA;IACE,+BAA+B;EC3kVjC;;ED8kVA;IACE,iCAAiC;EC/kVnC;;EDklVA;IACE,gCAAgC;ECnlVlC;;EDslVA;IACE,kCAAkC;ECvlVpC;;ED0lVA;IACE,gCAAgC;EC3lVlC;;ED8lVA;IACE,kCAAkC;EC/lVpC;;EDkmVA;IACE,gCAAgC;ECnmVlC;;EDsmVA;IACE,kCAAkC;ECvmVpC;;ED0mVA;IACE,gCAAgC;EC3mVlC;;ED8mVA;IACE,kCAAkC;EC/mVpC;;EDknVA;IACE,gCAAgC;ECnnVlC;;EDsnVA;IACE,kCAAkC;ECvnVpC;;ED0nVA;IACE,gCAAgC;EC3nVlC;;ED8nVA;IACE,kCAAkC;EC/nVpC;;EDkoVA;IACE,gCAAgC;ECnoVlC;;EDsoVA;IACE,kCAAkC;ECvoVpC;;ED0oVA;IACE,gCAAgC;EC3oVlC;;ED8oVA;IACE,kCAAkC;EC/oVpC;;EDkpVA;IACE,gCAAgC;ECnpVlC;;EDspVA;IACE,kCAAkC;ECvpVpC;;ED0pVA;IACE,gCAAgC;EC3pVlC;;ED8pVA;IACE,kCAAkC;EC/pVpC;;EDkqVA;IACE,gCAAgC;ECnqVlC;;EDsqVA;IACE,kCAAkC;ECvqVpC;;ED0qVA;IACE,gCAAgC;EC3qVlC;;ED8qVA;IACE,kCAAkC;EC/qVpC;;EDkrVA;IACE,gCAAgC;ECnrVlC;;EDsrVA;IACE,kCAAkC;ECvrVpC;;ED0rVA;IACE,gCAAgC;EC3rVlC;;ED8rVA;IACE,kCAAkC;EC/rVpC;;EDksVA;IACE,gCAAgC;ECnsVlC;;EDssVA;IACE,kCAAkC;ECvsVpC;;ED0sVA;IACE,gCAAgC;EC3sVlC;;ED8sVA;IACE,kCAAkC;EC/sVpC;;EDktVA;IACE,gCAAgC;ECntVlC;;EDstVA;IACE,kCAAkC;ECvtVpC;;ED0tVA;IACE,gCAAgC;EC3tVlC;;ED8tVA;IACE,kCAAkC;EC/tVpC;;EDkuVA;IACE,gCAAgC;ECnuVlC;;EDsuVA;IACE,kCAAkC;ECvuVpC;;ED0uVA;IACE,gCAAgC;EC3uVlC;;ED8uVA;IACE,kCAAkC;EC/uVpC;;EDkvVA;IACE,gCAAgC;ECnvVlC;;EDsvVA;IACE,kCAAkC;ECvvVpC;;ED0vVA;IACE,gCAAgC;EC3vVlC;;ED8vVA;IACE,kCAAkC;EC/vVpC;;EDkwVA;IACE,gCAAgC;ECnwVlC;;EDswVA;IACE,kCAAkC;ECvwVpC;;ED0wVA;IACE,gCAAgC;EC3wVlC;;ED8wVA;IACE,kCAAkC;EC/wVpC;;EDkxVA;IACE,gCAAgC;ECnxVlC;;EDsxVA;IACE,kCAAkC;ECvxVpC;;ED0xVA;IACE,gCAAgC;EC3xVlC;;ED8xVA;IACE,kCAAkC;EC/xVpC;;EDkyVA;IACE,gCAAgC;ECnyVlC;;EDsyVA;IACE,kCAAkC;ECvyVpC;;ED0yVA;IACE,gCAAgC;EC3yVlC;;ED8yVA;IACE,kCAAkC;EC/yVpC;;EDkzVA;IACE,gCAAgC;ECnzVlC;;EDszVA;IACE,kCAAkC;ECvzVpC;;ED0zVA;IACE,gCAAgC;EC3zVlC;;ED8zVA;IACE,kCAAkC;EC/zVpC;;EDk0VA;IACE,gCAAgC;ECn0VlC;;EDs0VA;IACE,kCAAkC;ECv0VpC;;ED00VA;IACE,gCAAgC;EC30VlC;;ED80VA;IACE,kCAAkC;EC/0VpC;;EDk1VA;IACE,gCAAgC;ECn1VlC;;EDs1VA;IACE,kCAAkC;ECv1VpC;;ED01VA;IACE,gCAAgC;EC31VlC;;ED81VA;IACE,kCAAkC;EC/1VpC;;EDk2VA;IACE,gCAAgC;ECn2VlC;;EDs2VA;IACE,kCAAkC;ECv2VpC;;ED02VA;IACE,gCAAgC;EC32VlC;;ED82VA;IACE,kCAAkC;EC/2VpC;;EDk3VA;IACE,gCAAgC;ECn3VlC;;EDs3VA;IACE,kCAAkC;ECv3VpC;;ED03VA;IACE,gCAAgC;EC33VlC;;ED83VA;IACE,kCAAkC;EC/3VpC;;EDk4VA;IACE,gCAAgC;ECn4VlC;;EDs4VA;IACE,kCAAkC;ECv4VpC;;ED04VA;IACE,gCAAgC;EC34VlC;;ED84VA;IACE,kCAAkC;EC/4VpC;;EDk5VA;IACE,gCAAgC;ECn5VlC;;EDs5VA;IACE,kCAAkC;ECv5VpC;;ED05VA;IACE,gCAAgC;EC35VlC;;ED85VA;IACE,kCAAkC;EC/5VpC;;EDk6VA;IACE,gCAAgC;ECn6VlC;;EDs6VA;IACE,kCAAkC;ECv6VpC;;ED06VA;IACE,gCAAgC;EC36VlC;;ED86VA;IACE,kCAAkC;EC/6VpC;;EDk7VA;IACE,gCAAgC;ECn7VlC;;EDs7VA;IACE,kCAAkC;ECv7VpC;;ED07VA;IACE,gCAAgC;EC37VlC;;ED87VA;IACE,kCAAkC;EC/7VpC;;EDk8VA;IACE,gCAAgC;ECn8VlC;;EDs8VA;IACE,kCAAkC;ECv8VpC;;ED08VA;IACE,gCAAgC;EC38VlC;;ED88VA;IACE,kCAAkC;EC/8VpC;;EDk9VA;IACE,gCAAgC;ECn9VlC;;EDs9VA;IACE,kCAAkC;ECv9VpC;;ED09VA;IACE,gCAAgC;EC39VlC;;ED89VA;IACE,kCAAkC;EC/9VpC;;EDk+VA;IACE,gCAAgC;ECn+VlC;;EDs+VA;IACE,kCAAkC;ECv+VpC;;ED0+VA;IACE,gCAAgC;EC3+VlC;;ED8+VA;IACE,kCAAkC;EC/+VpC;;EDk/VA;IACE,gCAAgC;ECn/VlC;;EDs/VA;IACE,kCAAkC;ECv/VpC;;ED0/VA;IACE,gCAAgC;EC3/VlC;;ED8/VA;IACE,kCAAkC;EC//VpC;;EDkgWA;IACE,gCAAgC;ECngWlC;;EDsgWA;IACE,kCAAkC;ECvgWpC;;ED0gWA;IACE,gCAAgC;EC3gWlC;;ED8gWA;IACE,kCAAkC;EC/gWpC;;EDkhWA;IACE,gCAAgC;ECnhWlC;;EDshWA;IACE,kCAAkC;ECvhWpC;;ED0hWA;IACE,gCAAgC;EC3hWlC;;ED8hWA;IACE,kCAAkC;EC/hWpC;;EDkiWA;IACE,gCAAgC;ECniWlC;;EDsiWA;IACE,kCAAkC;ECviWpC;;ED0iWA;IACE,gCAAgC;EC3iWlC;;ED8iWA;IACE,kCAAkC;EC/iWpC;;EDkjWA;IACE,gCAAgC;ECnjWlC;;EDsjWA;IACE,kCAAkC;ECvjWpC;;ED0jWA;IACE,gCAAgC;EC3jWlC;;ED8jWA;IACE,kCAAkC;EC/jWpC;;EDkkWA;IACE,gCAAgC;ECnkWlC;;EDskWA;IACE,kCAAkC;ECvkWpC;;ED0kWA;IACE,gCAAgC;EC3kWlC;;ED8kWA;IACE,kCAAkC;EC/kWpC;;EDklWA;IACE,gCAAgC;ECnlWlC;;EDslWA;IACE,kCAAkC;ECvlWpC;;ED0lWA;IACE,gCAAgC;EC3lWlC;;ED8lWA;IACE,kCAAkC;EC/lWpC;;EDkmWA;IACE,gCAAgC;ECnmWlC;;EDsmWA;IACE,kCAAkC;ECvmWpC;;ED0mWA;IACE,gCAAgC;EC3mWlC;;ED8mWA;IACE,kCAAkC;EC/mWpC;;EDknWA;IACE,gCAAgC;ECnnWlC;;EDsnWA;IACE,kCAAkC;ECpmWpC;;EDumWA;IACE,gCAAgC;ECxmWlC;;ED2mWA;IACE,kCAAkC;EC5mWpC;;ED+mWA;IACE,6BAA6B;EChnW/B;;EDmnWA;IACE,gCAAgC;ECpnWlC;;EDunWA;IACE,+BAA+B;ECxnWjC;;ED2nWA;IACE,6BAA6B;EC5nW/B;;ED+nWA;IACE,+BAA+B;EChoWjC;;EDmoWA;IACE,6BAA6B;ECpoW/B;;EDuoWA;IACE,+BAA+B;ECxoWjC;;ED2oWA;IACE,6BAA6B;EC5oW/B;;ED+oWA;IACE,+BAA+B;EChpWjC;;EDmpWA;IACE,6BAA6B;ECppW/B;;EDupWA;IACE,+BAA+B;ECxpWjC;;ED2pWA;IACE,6BAA6B;EC5pW/B;;ED+pWA;IACE,+BAA+B;EChqWjC;;EDmqWA;IACE,6BAA6B;ECpqW/B;;EDuqWA;IACE,+BAA+B;ECxqWjC;;ED2qWA;IACE,6BAA6B;EC5qW/B;;ED+qWA;IACE,+BAA+B;EChrWjC;;EDmrWA;IACE,6BAA6B;ECprW/B;;EDurWA;IACE,+BAA+B;ECxrWjC;;ED2rWA;IACE,6BAA6B;EC5rW/B;;ED+rWA;IACE,+BAA+B;EChsWjC;;EDmsWA;IACE,8BAA8B;ECpsWhC;;EDusWA;IACE,gCAAgC;ECxsWlC;;ED2sWA;IACE,8BAA8B;EC5sWhC;;ED+sWA;IACE,gCAAgC;EChtWlC;;EDmtWA;IACE,8BAA8B;ECptWhC;;EDutWA;IACE,gCAAgC;ECxtWlC;;ED2tWA;IACE,8BAA8B;EC5tWhC;;ED+tWA;IACE,gCAAgC;EChuWlC;;EDmuWA;IACE,8BAA8B;ECpuWhC;;EDuuWA;IACE,gCAAgC;ECxuWlC;;ED2uWA;IACE,8BAA8B;EC5uWhC;;ED+uWA;IACE,gCAAgC;EChvWlC;;EDmvWA;IACE,8BAA8B;ECpvWhC;;EDuvWA;IACE,gCAAgC;ECxvWlC;;ED2vWA;IACE,8BAA8B;EC5vWhC;;ED+vWA;IACE,gCAAgC;EChwWlC;;EDmwWA;IACE,8BAA8B;ECpwWhC;;EDuwWA;IACE,gCAAgC;ECxwWlC;;ED2wWA;IACE,8BAA8B;EC5wWhC;;ED+wWA;IACE,gCAAgC;EChxWlC;;EDmxWA;IACE,8BAA8B;ECpxWhC;;EDuxWA;IACE,gCAAgC;ECxxWlC;;ED2xWA;IACE,8BAA8B;EC5xWhC;;ED+xWA;IACE,gCAAgC;EChyWlC;;EDmyWA;IACE,8BAA8B;ECpyWhC;;EDuyWA;IACE,gCAAgC;ECxyWlC;;ED2yWA;IACE,8BAA8B;EC5yWhC;;ED+yWA;IACE,gCAAgC;EChzWlC;;EDmzWA;IACE,8BAA8B;ECpzWhC;;EDuzWA;IACE,gCAAgC;ECxzWlC;;ED2zWA;IACE,8BAA8B;EC5zWhC;;ED+zWA;IACE,gCAAgC;ECh0WlC;;EDm0WA;IACE,8BAA8B;ECp0WhC;;EDu0WA;IACE,gCAAgC;ECx0WlC;;ED20WA;IACE,8BAA8B;EC50WhC;;ED+0WA;IACE,gCAAgC;ECh1WlC;;EDm1WA;IACE,8BAA8B;ECp1WhC;;EDu1WA;IACE,gCAAgC;ECx1WlC;;ED21WA;IACE,8BAA8B;EC51WhC;;ED+1WA;IACE,gCAAgC;ECh2WlC;;EDm2WA;IACE,8BAA8B;ECp2WhC;;EDu2WA;IACE,gCAAgC;ECx2WlC;;ED22WA;IACE,8BAA8B;EC52WhC;;ED+2WA;IACE,gCAAgC;ECh3WlC;;EDm3WA;IACE,8BAA8B;ECp3WhC;;EDu3WA;IACE,gCAAgC;ECx3WlC;;ED23WA;IACE,8BAA8B;EC53WhC;;ED+3WA;IACE,gCAAgC;ECh4WlC;;EDm4WA;IACE,8BAA8B;ECp4WhC;;EDu4WA;IACE,gCAAgC;ECx4WlC;;ED24WA;IACE,8BAA8B;EC54WhC;;ED+4WA;IACE,gCAAgC;ECh5WlC;;EDm5WA;IACE,8BAA8B;ECp5WhC;;EDu5WA;IACE,gCAAgC;ECx5WlC;;ED25WA;IACE,8BAA8B;EC55WhC;;ED+5WA;IACE,gCAAgC;ECh6WlC;;EDm6WA;IACE,8BAA8B;ECp6WhC;;EDu6WA;IACE,gCAAgC;ECx6WlC;;ED26WA;IACE,8BAA8B;EC56WhC;;ED+6WA;IACE,gCAAgC;ECh7WlC;;EDm7WA;IACE,8BAA8B;ECp7WhC;;EDu7WA;IACE,gCAAgC;ECx7WlC;;ED27WA;IACE,8BAA8B;EC57WhC;;ED+7WA;IACE,gCAAgC;ECh8WlC;;EDm8WA;IACE,8BAA8B;ECp8WhC;;EDu8WA;IACE,gCAAgC;ECx8WlC;;ED28WA;IACE,8BAA8B;EC58WhC;;ED+8WA;IACE,gCAAgC;ECh9WlC;;EDm9WA;IACE,8BAA8B;ECp9WhC;;EDu9WA;IACE,gCAAgC;ECx9WlC;;ED29WA;IACE,8BAA8B;EC59WhC;;ED+9WA;IACE,gCAAgC;ECh+WlC;;EDm+WA;IACE,8BAA8B;ECp+WhC;;EDu+WA;IACE,gCAAgC;ECx+WlC;;ED2+WA;IACE,8BAA8B;EC5+WhC;;ED++WA;IACE,gCAAgC;ECh/WlC;;EDm/WA;IACE,8BAA8B;ECp/WhC;;EDu/WA;IACE,gCAAgC;ECx/WlC;;ED2/WA;IACE,8BAA8B;EC5/WhC;;ED+/WA;IACE,gCAAgC;EChgXlC;;EDmgXA;IACE,8BAA8B;ECpgXhC;;EDugXA;IACE,gCAAgC;ECxgXlC;;ED2gXA;IACE,8BAA8B;EC5gXhC;;ED+gXA;IACE,gCAAgC;EChhXlC;;EDmhXA;IACE,8BAA8B;ECphXhC;;EDuhXA;IACE,gCAAgC;ECxhXlC;;ED2hXA;IACE,8BAA8B;EC5hXhC;;ED+hXA;IACE,gCAAgC;EChiXlC;;EDmiXA;IACE,8BAA8B;ECpiXhC;;EDuiXA;IACE,gCAAgC;ECxiXlC;;ED2iXA;IACE,8BAA8B;EC5iXhC;;ED+iXA;IACE,gCAAgC;EChjXlC;;EDmjXA;IACE,8BAA8B;ECpjXhC;;EDujXA;IACE,gCAAgC;ECxjXlC;;ED2jXA;IACE,8BAA8B;EC5jXhC;;ED+jXA;IACE,gCAAgC;EChkXlC;;EDmkXA;IACE,8BAA8B;ECpkXhC;;EDukXA;IACE,gCAAgC;ECxkXlC;;ED2kXA;IACE,8BAA8B;EC5kXhC;;ED+kXA;IACE,gCAAgC;EChlXlC;;EDmlXA;IACE,8BAA8B;ECplXhC;;EDulXA;IACE,gCAAgC;ECxlXlC;;ED2lXA;IACE,8BAA8B;EC5lXhC;;ED+lXA;IACE,gCAAgC;EChmXlC;;EDmmXA;IACE,8BAA8B;ECpmXhC;;EDumXA;IACE,gCAAgC;ECxmXlC;;ED2mXA;IACE,8BAA8B;EC5mXhC;;ED+mXA;IACE,gCAAgC;EChnXlC;;EDmnXA;IACE,8BAA8B;ECpnXhC;;EDunXA;IACE,gCAAgC;ECxnXlC;;ED2nXA;IACE,8BAA8B;EC5nXhC;;ED+nXA;IACE,gCAAgC;EChoXlC;;EDmoXA;IACE,8BAA8B;ECpoXhC;;EDuoXA;IACE,gCAAgC;ECxoXlC;;ED2oXA;IACE,8BAA8B;EC5oXhC;;ED+oXA;IACE,gCAAgC;EChpXlC;;EDmpXA;IACE,8BAA8B;ECppXhC;;EDupXA;IACE,gCAAgC;ECxpXlC;;ED2pXA;IACE,8BAA8B;EC5pXhC;;ED+pXA;IACE,gCAAgC;EChqXlC;;EDmqXA;IACE,8BAA8B;ECpqXhC;;EDuqXA;IACE,gCAAgC;ECxqXlC;;ED2qXA;IACE,8BAA8B;EC5qXhC;;ED+qXA;IACE,gCAAgC;EChrXlC;;EDmrXA;IACE,8BAA8B;ECprXhC;;EDurXA;IACE,gCAAgC;ECxrXlC;;ED2rXA;IACE,8BAA8B;EC5rXhC;;ED+rXA;IACE,gCAAgC;EChsXlC;;EDmsXA;IACE,8BAA8B;ECpsXhC;;EDusXA;IACE,gCAAgC;ECxsXlC;;ED2sXA;IACE,8BAA8B;EC5sXhC;;ED+sXA;IACE,gCAAgC;EChtXlC;;EDmtXA;IACE,8BAA8B;ECptXhC;;EDutXA;IACE,gCAAgC;ECxtXlC;;ED2tXA;IACE,8BAA8B;EC5tXhC;;ED+tXA;IACE,gCAAgC;EChuXlC;;EDmuXA;IACE,8BAA8B;ECpuXhC;;EDuuXA;IACE,gCAAgC;ECrtXlC;;EDwtXA;IACE,8BAA8B;ECztXhC;;ED4tXA;IACE,gCAAgC;EC7tXlC;;EDguXA;IACE,8BAA8B;ECjuXhC;;EDouXA;IACE,iCAAiC;ECruXnC;;EDwuXA;IACE,gCAAgC;ECzuXlC;;ED4uXA;IACE,8BAA8B;EC7uXhC;;EDgvXA;IACE,gCAAgC;ECjvXlC;;EDovXA;IACE,8BAA8B;ECrvXhC;;EDwvXA;IACE,gCAAgC;ECzvXlC;;ED4vXA;IACE,8BAA8B;EC7vXhC;;EDgwXA;IACE,gCAAgC;ECjwXlC;;EDowXA;IACE,8BAA8B;ECrwXhC;;EDwwXA;IACE,gCAAgC;ECzwXlC;;ED4wXA;IACE,8BAA8B;EC7wXhC;;EDgxXA;IACE,gCAAgC;ECjxXlC;;EDoxXA;IACE,8BAA8B;ECrxXhC;;EDwxXA;IACE,gCAAgC;ECzxXlC;;ED4xXA;IACE,8BAA8B;EC7xXhC;;EDgyXA;IACE,gCAAgC;ECjyXlC;;EDoyXA;IACE,8BAA8B;ECryXhC;;EDwyXA;IACE,gCAAgC;ECzyXlC;;ED4yXA;IACE,8BAA8B;EC7yXhC;;EDgzXA;IACE,gCAAgC;ECjzXlC;;EDozXA;IACE,+BAA+B;ECrzXjC;;EDwzXA;IACE,iCAAiC;ECzzXnC;;ED4zXA;IACE,+BAA+B;EC7zXjC;;EDg0XA;IACE,iCAAiC;ECj0XnC;;EDo0XA;IACE,+BAA+B;ECr0XjC;;EDw0XA;IACE,iCAAiC;ECz0XnC;;ED40XA;IACE,+BAA+B;EC70XjC;;EDg1XA;IACE,iCAAiC;ECj1XnC;;EDo1XA;IACE,+BAA+B;ECr1XjC;;EDw1XA;IACE,iCAAiC;ECz1XnC;;ED41XA;IACE,+BAA+B;EC71XjC;;EDg2XA;IACE,iCAAiC;ECj2XnC;;EDo2XA;IACE,+BAA+B;ECr2XjC;;EDw2XA;IACE,iCAAiC;ECz2XnC;;ED42XA;IACE,+BAA+B;EC72XjC;;EDg3XA;IACE,iCAAiC;ECj3XnC;;EDo3XA;IACE,+BAA+B;ECr3XjC;;EDw3XA;IACE,iCAAiC;ECz3XnC;;ED43XA;IACE,+BAA+B;EC73XjC;;EDg4XA;IACE,iCAAiC;ECj4XnC;;EDo4XA;IACE,+BAA+B;ECr4XjC;;EDw4XA;IACE,iCAAiC;ECz4XnC;;ED44XA;IACE,+BAA+B;EC74XjC;;EDg5XA;IACE,iCAAiC;ECj5XnC;;EDo5XA;IACE,+BAA+B;ECr5XjC;;EDw5XA;IACE,iCAAiC;ECz5XnC;;ED45XA;IACE,+BAA+B;EC75XjC;;EDg6XA;IACE,iCAAiC;ECj6XnC;;EDo6XA;IACE,+BAA+B;ECr6XjC;;EDw6XA;IACE,iCAAiC;ECz6XnC;;ED46XA;IACE,+BAA+B;EC76XjC;;EDg7XA;IACE,iCAAiC;ECj7XnC;;EDo7XA;IACE,+BAA+B;ECr7XjC;;EDw7XA;IACE,iCAAiC;ECz7XnC;;ED47XA;IACE,+BAA+B;EC77XjC;;EDg8XA;IACE,iCAAiC;ECj8XnC;;EDo8XA;IACE,+BAA+B;ECr8XjC;;EDw8XA;IACE,iCAAiC;ECz8XnC;;ED48XA;IACE,+BAA+B;EC78XjC;;EDg9XA;IACE,iCAAiC;ECj9XnC;;EDo9XA;IACE,+BAA+B;ECr9XjC;;EDw9XA;IACE,iCAAiC;ECz9XnC;;ED49XA;IACE,+BAA+B;EC79XjC;;EDg+XA;IACE,iCAAiC;ECj+XnC;;EDo+XA;IACE,+BAA+B;ECr+XjC;;EDw+XA;IACE,iCAAiC;ECz+XnC;;ED4+XA;IACE,+BAA+B;EC7+XjC;;EDg/XA;IACE,iCAAiC;ECj/XnC;;EDo/XA;IACE,+BAA+B;ECr/XjC;;EDw/XA;IACE,iCAAiC;ECz/XnC;;ED4/XA;IACE,+BAA+B;EC7/XjC;;EDggYA;IACE,iCAAiC;ECjgYnC;;EDogYA;IACE,+BAA+B;ECrgYjC;;EDwgYA;IACE,iCAAiC;ECzgYnC;;ED4gYA;IACE,+BAA+B;EC7gYjC;;EDghYA;IACE,iCAAiC;ECjhYnC;;EDohYA;IACE,+BAA+B;ECrhYjC;;EDwhYA;IACE,iCAAiC;ECzhYnC;;ED4hYA;IACE,+BAA+B;EC7hYjC;;EDgiYA;IACE,iCAAiC;ECjiYnC;;EDoiYA;IACE,+BAA+B;ECriYjC;;EDwiYA;IACE,iCAAiC;ECziYnC;;ED4iYA;IACE,+BAA+B;EC7iYjC;;EDgjYA;IACE,iCAAiC;ECjjYnC;;EDojYA;IACE,+BAA+B;ECrjYjC;;EDwjYA;IACE,iCAAiC;ECzjYnC;;ED4jYA;IACE,+BAA+B;EC7jYjC;;EDgkYA;IACE,iCAAiC;ECjkYnC;;EDokYA;IACE,+BAA+B;ECrkYjC;;EDwkYA;IACE,iCAAiC;ECzkYnC;;ED4kYA;IACE,+BAA+B;EC7kYjC;;EDglYA;IACE,iCAAiC;ECjlYnC;;EDolYA;IACE,+BAA+B;ECrlYjC;;EDwlYA;IACE,iCAAiC;ECzlYnC;;ED4lYA;IACE,+BAA+B;EC7lYjC;;EDgmYA;IACE,iCAAiC;ECjmYnC;;EDomYA;IACE,+BAA+B;ECrmYjC;;EDwmYA;IACE,iCAAiC;ECzmYnC;;ED4mYA;IACE,+BAA+B;EC7mYjC;;EDgnYA;IACE,iCAAiC;ECjnYnC;;EDonYA;IACE,+BAA+B;ECrnYjC;;EDwnYA;IACE,iCAAiC;ECznYnC;;ED4nYA;IACE,+BAA+B;EC7nYjC;;EDgoYA;IACE,iCAAiC;ECjoYnC;;EDooYA;IACE,+BAA+B;ECroYjC;;EDwoYA;IACE,iCAAiC;ECzoYnC;;ED4oYA;IACE,+BAA+B;EC7oYjC;;EDgpYA;IACE,iCAAiC;ECjpYnC;;EDopYA;IACE,+BAA+B;ECrpYjC;;EDwpYA;IACE,iCAAiC;ECzpYnC;;ED4pYA;IACE,+BAA+B;EC7pYjC;;EDgqYA;IACE,iCAAiC;ECjqYnC;;EDoqYA;IACE,+BAA+B;ECrqYjC;;EDwqYA;IACE,iCAAiC;ECzqYnC;;ED4qYA;IACE,+BAA+B;EC7qYjC;;EDgrYA;IACE,iCAAiC;ECjrYnC;;EDorYA;IACE,+BAA+B;ECrrYjC;;EDwrYA;IACE,iCAAiC;ECzrYnC;;ED4rYA;IACE,+BAA+B;EC7rYjC;;EDgsYA;IACE,iCAAiC;ECjsYnC;;EDosYA;IACE,+BAA+B;ECrsYjC;;EDwsYA;IACE,iCAAiC;ECzsYnC;;ED4sYA;IACE,+BAA+B;EC7sYjC;;EDgtYA;IACE,iCAAiC;ECjtYnC;;EDotYA;IACE,+BAA+B;ECrtYjC;;EDwtYA;IACE,iCAAiC;ECztYnC;;ED4tYA;IACE,+BAA+B;EC7tYjC;;EDguYA;IACE,iCAAiC;ECjuYnC;;EDouYA;IACE,+BAA+B;ECruYjC;;EDwuYA;IACE,iCAAiC;ECzuYnC;;ED4uYA;IACE,+BAA+B;EC7uYjC;;EDgvYA;IACE,iCAAiC;ECjvYnC;;EDovYA;IACE,+BAA+B;ECrvYjC;;EDwvYA;IACE,iCAAiC;ECzvYnC;;ED4vYA;IACE,+BAA+B;EC7vYjC;;EDgwYA;IACE,iCAAiC;ECjwYnC;;EDowYA;IACE,+BAA+B;ECrwYjC;;EDwwYA;IACE,iCAAiC;ECzwYnC;;ED4wYA;IACE,+BAA+B;EC7wYjC;;EDgxYA;IACE,iCAAiC;ECjxYnC;;EDoxYA;IACE,+BAA+B;ECrxYjC;;EDwxYA;IACE,iCAAiC;ECzxYnC;;ED4xYA;IACE,+BAA+B;EC7xYjC;;EDgyYA;IACE,iCAAiC;ECjyYnC;;EDoyYA;IACE,+BAA+B;ECryYjC;;EDwyYA;IACE,iCAAiC;ECzyYnC;;ED4yYA;IACE,+BAA+B;EC7yYjC;;EDgzYA;IACE,iCAAiC;ECjzYnC;;EDozYA;IACE,+BAA+B;ECrzYjC;;EDwzYA;IACE,iCAAiC;ECzzYnC;;ED4zYA;IACE,+BAA+B;EC7zYjC;;EDg0YA;IACE,iCAAiC;ECj0YnC;;EDo0YA;IACE,+BAA+B;ECr0YjC;;EDw0YA;IACE,iCAAiC;ECz0YnC;;ED40YA;IACE,+BAA+B;EC70YjC;;EDg1YA;IACE,iCAAiC;ECj1YnC;;EDo1YA;IACE,+BAA+B;ECr1YjC;;EDw1YA;IACE,iCAAiC;ECt0YnC;;EDy0YA;IACE,+BAA+B;EACjC;;EAEA;IC30YC,iCAAuC;ED60YxC;;EC/0YA;IACC,6BAAc;IACd,8BAAe;EDk1YhB;;ECp1YA;IACC,gCAAsC;IACtC,iCAAuC;EDu1YxC;;ECz1YA;IACC,+BAAsC;IACtC,gCAAuC;ED41YxC;;EC91YA;IACC,6BAAsC;IACtC,8BAAuC;EDi2YxC;;ECn2YA;IACC,+BAAsC;IACtC,gCAAuC;EDs2YxC;;ECx2YA;IACC,6BAAsC;IACtC,8BAAuC;ED22YxC;;EC72YA;IACC,+BAAsC;IACtC,gCAAuC;EDg3YxC;;ECl3YA;IACC,6BAAsC;IACtC,8BAAuC;EDq3YxC;;ECv3YA;IACC,+BAAsC;IACtC,gCAAuC;ED03YxC;;EC53YA;IACC,6BAAsC;IACtC,8BAAuC;ED+3YxC;;ECj4YA;IACC,+BAAsC;IACtC,gCAAuC;EDo4YxC;;ECt4YA;IACC,6BAAsC;IACtC,8BAAuC;EDy4YxC;;EC34YA;IACC,+BAAsC;IACtC,gCAAuC;ED84YxC;;ECh5YA;IACC,6BAAsC;IACtC,8BAAuC;EDm5YxC;;ECr5YA;IACC,+BAAsC;IACtC,gCAAuC;EDw5YxC;;EC15YA;IACC,6BAAsC;IACtC,8BAAuC;ED65YxC;;EC/5YA;IACC,+BAAsC;IACtC,gCAAuC;EDk6YxC;;ECp6YA;IACC,6BAAsC;IACtC,8BAAuC;EDu6YxC;;ECz6YA;IACC,+BAAsC;IACtC,gCAAuC;ED46YxC;;EC96YA;IACC,6BAAc;IACd,8BAAe;EDi7YhB;;ECn7YA;IACC,+BAAc;IACd,gCAAe;EDs7YhB;;ECx7YA;IACC,8BAAsC;IACtC,+BAAuC;ED27YxC;;EC77YA;IACC,gCAAsC;IACtC,iCAAuC;EDg8YxC;;ECl8YA;IACC,8BAAsC;IACtC,+BAAuC;EDq8YxC;;ECv8YA;IACC,gCAAsC;IACtC,iCAAuC;ED08YxC;;EC58YA;IACC,8BAAsC;IACtC,+BAAuC;ED+8YxC;;ECj9YA;IACC,gCAAsC;IACtC,iCAAuC;EDo9YxC;;ECt9YA;IACC,8BAAsC;IACtC,+BAAuC;EDy9YxC;;EC39YA;IACC,gCAAsC;IACtC,iCAAuC;ED89YxC;;ECh+YA;IACC,8BAAsC;IACtC,+BAAuC;EDm+YxC;;ECr+YA;IACC,gCAAsC;IACtC,iCAAuC;EDw+YxC;;EC1+YA;IACC,8BAAsC;IACtC,+BAAuC;ED6+YxC;;EC/+YA;IACC,gCAAsC;IACtC,iCAAuC;EDk/YxC;;ECp/YA;IACC,8BAAsC;IACtC,+BAAuC;EDu/YxC;;ECz/YA;IACC,gCAAsC;IACtC,iCAAuC;ED4/YxC;;EC9/YA;IACC,8BAAsC;IACtC,+BAAuC;EDigZxC;;ECngZA;IACC,gCAAsC;IACtC,iCAAuC;EDsgZxC;;ECxgZA;IACC,8BAAsC;IACtC,+BAAuC;ED2gZxC;;EC7gZA;IACC,gCAAsC;IACtC,iCAAuC;EDghZxC;;EClhZA;IACC,8BAAsC;IACtC,+BAAuC;EDqhZxC;;ECvhZA;IACC,gCAAsC;IACtC,iCAAuC;ED0hZxC;;EC5hZA;IACC,8BAAsC;IACtC,+BAAuC;ED+hZxC;;ECjiZA;IACC,gCAAsC;IACtC,iCAAuC;EDoiZxC;;ECtiZA;IACC,8BAAsC;IACtC,+BAAuC;EDyiZxC;;EC3iZA;IACC,gCAAsC;IACtC,iCAAuC;ED8iZxC;;EChjZA;IACC,8BAAsC;IACtC,+BAAuC;EDmjZxC;;ECrjZA;IACC,gCAAsC;IACtC,iCAAuC;EDwjZxC;;EC1jZA;IACC,8BAAsC;IACtC,+BAAuC;ED6jZxC;;EC/jZA;IACC,gCAAsC;IACtC,iCAAuC;EDkkZxC;;ECpkZA;IACC,8BAAsC;IACtC,+BAAuC;EDukZxC;;ECzkZA;IACC,gCAAsC;IACtC,iCAAuC;ED4kZxC;;EC9kZA;IACC,8BAAsC;IACtC,+BAAuC;EDilZxC;;ECnlZA;IACC,gCAAsC;IACtC,iCAAuC;EDslZxC;;ECxlZA;IACC,8BAAsC;IACtC,+BAAuC;ED2lZxC;;EC7lZA;IACC,gCAAsC;IACtC,iCAAuC;EDgmZxC;;EClmZA;IACC,8BAAsC;IACtC,+BAAuC;EDqmZxC;;ECvmZA;IACC,gCAAsC;IACtC,iCAAuC;ED0mZxC;;EC5mZA;IACC,8BAAsC;IACtC,+BAAuC;ED+mZxC;;ECjnZA;IACC,gCAAsC;IACtC,iCAAuC;EDonZxC;;ECtnZA;IACC,8BAAsC;IACtC,+BAAuC;EDynZxC;;EC3nZA;IACC,gCAAsC;IACtC,iCAAuC;ED8nZxC;;EChoZA;IACC,8BAAsC;IACtC,+BAAuC;EDmoZxC;;ECroZA;IACC,gCAAsC;IACtC,iCAAuC;EDwoZxC;;EC1oZA;IACC,8BAAsC;IACtC,+BAAuC;ED6oZxC;;EC/oZA;IACC,gCAAsC;IACtC,iCAAuC;EDkpZxC;;ECppZA;IACC,8BAAsC;IACtC,+BAAuC;EDupZxC;;ECzpZA;IACC,gCAAsC;IACtC,iCAAuC;ED4pZxC;;EC9pZA;IACC,8BAAsC;IACtC,+BAAuC;EDiqZxC;;ECnqZA;IACC,gCAAsC;IACtC,iCAAuC;EDsqZxC;;ECxqZA;IACC,8BAAsC;IACtC,+BAAuC;ED2qZxC;;EC7qZA;IACC,gCAAsC;IACtC,iCAAuC;EDgrZxC;;EClrZA;IACC,8BAAsC;IACtC,+BAAuC;EDqrZxC;;ECvrZA;IACC,gCAAsC;IACtC,iCAAuC;ED0rZxC;;EC5rZA;IACC,8BAAsC;IACtC,+BAAuC;ED+rZxC;;ECjsZA;IACC,gCAAsC;IACtC,iCAAuC;EDosZxC;;ECtsZA;IACC,8BAAsC;IACtC,+BAAuC;EDysZxC;;EC3sZA;IACC,gCAAsC;IACtC,iCAAuC;ED8sZxC;;EChtZA;IACC,8BAAsC;IACtC,+BAAuC;EDmtZxC;;ECrtZA;IACC,gCAAsC;IACtC,iCAAuC;EDwtZxC;;EC1tZA;IACC,8BAAsC;IACtC,+BAAuC;ED6tZxC;;EC/tZA;IACC,gCAAsC;IACtC,iCAAuC;EDkuZxC;;ECpuZA;IACC,8BAAsC;IACtC,+BAAuC;EDuuZxC;;ECzuZA;IACC,gCAAsC;IACtC,iCAAuC;ED4uZxC;;EC9uZA;IACC,8BAAsC;IACtC,+BAAuC;EDivZxC;;ECnvZA;IACC,gCAAsC;IACtC,iCAAuC;EDsvZxC;;ECxvZA;IACC,8BAAsC;IACtC,+BAAuC;ED2vZxC;;EC7vZA;IACC,gCAAsC;IACtC,iCAAuC;EDgwZxC;;EClwZA;IACC,8BAAsC;IACtC,+BAAuC;EDqwZxC;;ECvwZA;IACC,gCAAsC;IACtC,iCAAuC;ED0wZxC;;EC5wZA;IACC,8BAAsC;IACtC,+BAAuC;ED+wZxC;;ECjxZA;IACC,gCAAsC;IACtC,iCAAuC;EDoxZxC;;ECtxZA;IACC,8BAAsC;IACtC,+BAAuC;EDyxZxC;;EC3xZA;IACC,gCAAsC;IACtC,iCAAuC;ED8xZxC;;EChyZA;IACC,8BAAsC;IACtC,+BAAuC;EDmyZxC;;ECryZA;IACC,gCAAsC;IACtC,iCAAuC;EDwyZxC;;EC1yZA;IACC,8BAAsC;IACtC,+BAAuC;ED6yZxC;;EC/yZA;IACC,gCAAsC;IACtC,iCAAuC;EDkzZxC;;ECpzZA;IACC,8BAAsC;IACtC,+BAAuC;EDuzZxC;;ECzzZA;IACC,gCAAsC;IACtC,iCAAuC;ED4zZxC;;EC9zZA;IACC,8BAAsC;IACtC,+BAAuC;EDi0ZxC;;ECn0ZA;IACC,gCAAsC;IACtC,iCAAuC;EDs0ZxC;;ECx0ZA;IACC,8BAAsC;IACtC,+BAAuC;ED20ZxC;;EC70ZA;IACC,gCAAsC;IACtC,iCAAuC;EDg1ZxC;;ECl1ZA;IACC,8BAAsC;IACtC,+BAAuC;EDq1ZxC;;ECv1ZA;IACC,gCAAsC;IACtC,iCAAuC;ED01ZxC;;EC51ZA;IACC,8BAAsC;IACtC,+BAAuC;ED+1ZxC;;ECj2ZA;IACC,gCAAsC;IACtC,iCAAuC;EDo2ZxC;;ECt2ZA;IACC,8BAAsC;IACtC,+BAAuC;EDy2ZxC;;EC32ZA;IACC,gCAAsC;IACtC,iCAAuC;ED82ZxC;;ECh3ZA;IACC,8BAAsC;IACtC,+BAAuC;EDm3ZxC;;ECr3ZA;IACC,gCAAsC;IACtC,iCAAuC;EDw3ZxC;;EC13ZA;IACC,8BAAsC;IACtC,+BAAuC;ED63ZxC;;EC/3ZA;IACC,gCAAsC;IACtC,iCAAuC;EDk4ZxC;;ECp4ZA;IACC,8BAAsC;IACtC,+BAAuC;EDu4ZxC;;ECz4ZA;IACC,gCAAsC;IACtC,iCAAuC;ED44ZxC;;EC94ZA;IACC,8BAAsC;IACtC,+BAAuC;EDi5ZxC;;ECn5ZA;IACC,gCAAsC;IACtC,iCAAuC;EDs5ZxC;;ECx5ZA;IACC,8BAAsC;IACtC,+BAAuC;ED25ZxC;;EC75ZA;IACC,gCAAsC;IACtC,iCAAuC;EDg6ZxC;;ECl6ZA;IACC,8BAAsC;IACtC,+BAAuC;EDq6ZxC;;ECv6ZA;IACC,gCAAsC;IACtC,iCAAuC;ED06ZxC;;EC56ZA;IACC,8BAAsC;IACtC,+BAAuC;ED+6ZxC;;ECj7ZA;IACC,gCAAsC;IACtC,iCAAuC;EDo7ZxC;;ECt7ZA;IACC,8BAAsC;IACtC,+BAAuC;EDy7ZxC;;EC37ZA;IACC,gCAAsC;IACtC,iCAAuC;ED87ZxC;;ECh8ZA;IACC,8BAAsC;IACtC,+BAAuC;EDm8ZxC;;ECr8ZA;IACC,gCAAsC;IACtC,iCAAuC;EDw8ZxC;;EC18ZA;IACC,8BAAsC;IACtC,+BAAuC;ED68ZxC;;EC/8ZA;IACC,gCAAsC;IACtC,iCAAuC;EDk9ZxC;;ECp9ZA;IACC,8BAAsC;IACtC,+BAAuC;EDu9ZxC;;ECz9ZA;IACC,gCAAsC;IACtC,iCAAuC;ED49ZxC;;EC99ZA;IACC,8BAAsC;IACtC,+BAAuC;EDi+ZxC;;ECn+ZA;IACC,gCAAsC;IACtC,iCAAuC;EDs+ZxC;;ECx+ZA;IACC,8BAAsC;IACtC,+BAAuC;ED2+ZxC;;EC7+ZA;IACC,gCAAsC;IACtC,iCAAuC;EDg/ZxC;;ECl/ZA;IACC,8BAAsC;IACtC,+BAAuC;EDq/ZxC;;ECv/ZA;IACC,gCAAsC;IACtC,iCAAuC;ED0/ZxC;;EC5/ZA;IACC,8BAAsC;IACtC,+BAAuC;ED+/ZxC;;ECjgaA;IACC,gCAAsC;IACtC,iCAAuC;EDogaxC;;ECtgaA;IACC,8BAAsC;IACtC,+BAAuC;EDygaxC;;EC3gaA;IACC,gCAAsC;IACtC,iCAAuC;ED8gaxC;;EChhaA;IACC,8BAAsC;IACtC,+BAAuC;EDmhaxC;;ECrhaA;IACC,gCAAsC;IACtC,iCAAuC;EDwhaxC;;EC1haA;IACC,8BAAsC;IACtC,+BAAuC;ED6haxC;;EC/haA;IACC,gCAAsC;IACtC,iCAAuC;EDkiaxC;;ECpiaA;IACC,8BAAsC;IACtC,+BAAuC;EDuiaxC;;ECziaA;IACC,gCAAsC;IACtC,iCAAuC;ED4iaxC;;EC9iaA;IACC,8BAAsC;IACtC,+BAAuC;EDijaxC;;ECnjaA;IACC,gCAAsC;IACtC,iCAAuC;EDsjaxC;;ECxjaA;IACC,8BAAsC;IACtC,+BAAuC;ED2jaxC;;EC7jaA;IACC,gCAAsC;IACtC,iCAAuC;EDgkaxC;;EClkaA;IACC,8BAAsC;IACtC,+BAAuC;EDqkaxC;;ECvkaA;IACC,gCAAsC;IACtC,iCAAuC;ED0kaxC;;EC5kaA;IACC,8BAAsC;IACtC,+BAAuC;ED+kaxC;;ECjlaA;IACC,gCAAsC;IACtC,iCAAuC;EDolaxC;;ECtlaA;IACC,8BAAsC;IACtC,+BAAuC;EDylaxC;;EC3laA;IACC,gCAAsC;IACtC,iCAAuC;ED8laxC;;EChmaA;IACC,8BAAsC;IACtC,+BAAuC;EDmmaxC;;ECrmaA;IACC,gCAAsC;IACtC,iCAAuC;EDwmaxC;;ECtlaA;IACC,8BAAqC;IACrC,+BAAwC;EDylazC;;EC3laA;IACC,gCAAqC;IACrC,iCAAgB;ED8lajB;;EChmaA;IACC,4BAAa;IACb,+BAAgB;EDmmajB;;ECrmaA;IACC,+BAAqC;IACrC,kCAAwC;EDwmazC;;EC1maA;IACC,8BAAqC;IACrC,iCAAwC;ED6mazC;;EC/maA;IACC,4BAAqC;IACrC,+BAAwC;EDknazC;;ECpnaA;IACC,8BAAqC;IACrC,iCAAwC;EDunazC;;ECznaA;IACC,4BAAqC;IACrC,+BAAwC;ED4nazC;;EC9naA;IACC,8BAAqC;IACrC,iCAAwC;EDioazC;;ECnoaA;IACC,4BAAqC;IACrC,+BAAwC;EDsoazC;;ECxoaA;IACC,8BAAqC;IACrC,iCAAwC;ED2oazC;;EC7oaA;IACC,4BAAqC;IACrC,+BAAwC;EDgpazC;;EClpaA;IACC,8BAAqC;IACrC,iCAAwC;EDqpazC;;ECvpaA;IACC,4BAAqC;IACrC,+BAAwC;ED0pazC;;EC5paA;IACC,8BAAqC;IACrC,iCAAwC;ED+pazC;;ECjqaA;IACC,4BAAqC;IACrC,+BAAwC;EDoqazC;;ECtqaA;IACC,8BAAqC;IACrC,iCAAwC;EDyqazC;;EC3qaA;IACC,4BAAqC;IACrC,+BAAwC;ED8qazC;;EChraA;IACC,8BAAqC;IACrC,iCAAwC;EDmrazC;;ECrraA;IACC,4BAAqC;IACrC,+BAAwC;EDwrazC;;EC1raA;IACC,8BAAqC;IACrC,iCAAwC;ED6razC;;EC/raA;IACC,4BAAa;IACb,+BAAgB;EDksajB;;ECpsaA;IACC,8BAAa;IACb,iCAAgB;EDusajB;;ECzsaA;IACC,6BAAqC;IACrC,gCAAwC;ED4sazC;;EC9saA;IACC,+BAAqC;IACrC,kCAAwC;EDitazC;;ECntaA;IACC,6BAAqC;IACrC,gCAAwC;EDstazC;;ECxtaA;IACC,+BAAqC;IACrC,kCAAwC;ED2tazC;;EC7taA;IACC,6BAAqC;IACrC,gCAAwC;EDguazC;;ECluaA;IACC,+BAAqC;IACrC,kCAAwC;EDquazC;;ECvuaA;IACC,6BAAqC;IACrC,gCAAwC;ED0uazC;;EC5uaA;IACC,+BAAqC;IACrC,kCAAwC;ED+uazC;;ECjvaA;IACC,6BAAqC;IACrC,gCAAwC;EDovazC;;ECtvaA;IACC,+BAAqC;IACrC,kCAAwC;EDyvazC;;EC3vaA;IACC,6BAAqC;IACrC,gCAAwC;ED8vazC;;EChwaA;IACC,+BAAqC;IACrC,kCAAwC;EDmwazC;;ECrwaA;IACC,6BAAqC;IACrC,gCAAwC;EDwwazC;;EC1waA;IACC,+BAAqC;IACrC,kCAAwC;ED6wazC;;EC/waA;IACC,6BAAqC;IACrC,gCAAwC;EDkxazC;;ECpxaA;IACC,+BAAqC;IACrC,kCAAwC;EDuxazC;;ECzxaA;IACC,6BAAqC;IACrC,gCAAwC;ED4xazC;;EC9xaA;IACC,+BAAqC;IACrC,kCAAwC;EDiyazC;;ECnyaA;IACC,6BAAqC;IACrC,gCAAwC;EDsyazC;;ECxyaA;IACC,+BAAqC;IACrC,kCAAwC;ED2yazC;;EC7yaA;IACC,6BAAqC;IACrC,gCAAwC;EDgzazC;;EClzaA;IACC,+BAAqC;IACrC,kCAAwC;EDqzazC;;ECvzaA;IACC,6BAAqC;IACrC,gCAAwC;ED0zazC;;EC5zaA;IACC,+BAAqC;IACrC,kCAAwC;ED+zazC;;ECj0aA;IACC,6BAAqC;IACrC,gCAAwC;EDo0azC;;ECt0aA;IACC,+BAAqC;IACrC,kCAAwC;EDy0azC;;EC30aA;IACC,6BAAqC;IACrC,gCAAwC;ED80azC;;ECh1aA;IACC,+BAAqC;IACrC,kCAAwC;EDm1azC;;ECr1aA;IACC,6BAAqC;IACrC,gCAAwC;EDw1azC;;EC11aA;IACC,+BAAqC;IACrC,kCAAwC;ED61azC;;EC/1aA;IACC,6BAAqC;IACrC,gCAAwC;EDk2azC;;ECp2aA;IACC,+BAAqC;IACrC,kCAAwC;EDu2azC;;ECz2aA;IACC,6BAAqC;IACrC,gCAAwC;ED42azC;;EC92aA;IACC,+BAAqC;IACrC,kCAAwC;EDi3azC;;ECn3aA;IACC,6BAAqC;IACrC,gCAAwC;EDs3azC;;ECx3aA;IACC,+BAAqC;IACrC,kCAAwC;ED23azC;;EC73aA;IACC,6BAAqC;IACrC,gCAAwC;EDg4azC;;ECl4aA;IACC,+BAAqC;IACrC,kCAAwC;EDq4azC;;ECv4aA;IACC,6BAAqC;IACrC,gCAAwC;ED04azC;;EC54aA;IACC,+BAAqC;IACrC,kCAAwC;ED+4azC;;ECj5aA;IACC,6BAAqC;IACrC,gCAAwC;EDo5azC;;ECt5aA;IACC,+BAAqC;IACrC,kCAAwC;EDy5azC;;EC35aA;IACC,6BAAqC;IACrC,gCAAwC;ED85azC;;ECh6aA;IACC,+BAAqC;IACrC,kCAAwC;EDm6azC;;ECr6aA;IACC,6BAAqC;IACrC,gCAAwC;EDw6azC;;EC16aA;IACC,+BAAqC;IACrC,kCAAwC;ED66azC;;EC/6aA;IACC,6BAAqC;IACrC,gCAAwC;EDk7azC;;ECp7aA;IACC,+BAAqC;IACrC,kCAAwC;EDu7azC;;ECz7aA;IACC,6BAAqC;IACrC,gCAAwC;ED47azC;;EC97aA;IACC,+BAAqC;IACrC,kCAAwC;EDi8azC;;ECn8aA;IACC,6BAAqC;IACrC,gCAAwC;EDs8azC;;ECx8aA;IACC,+BAAqC;IACrC,kCAAwC;ED28azC;;EC78aA;IACC,6BAAqC;IACrC,gCAAwC;EDg9azC;;ECl9aA;IACC,+BAAqC;IACrC,kCAAwC;EDq9azC;;ECv9aA;IACC,6BAAqC;IACrC,gCAAwC;ED09azC;;EC59aA;IACC,+BAAqC;IACrC,kCAAwC;ED+9azC;;ECj+aA;IACC,6BAAqC;IACrC,gCAAwC;EDo+azC;;ECt+aA;IACC,+BAAqC;IACrC,kCAAwC;EDy+azC;;EC3+aA;IACC,6BAAqC;IACrC,gCAAwC;ED8+azC;;ECh/aA;IACC,+BAAqC;IACrC,kCAAwC;EDm/azC;;ECr/aA;IACC,6BAAqC;IACrC,gCAAwC;EDw/azC;;EC1/aA;IACC,+BAAqC;IACrC,kCAAwC;ED6/azC;;EC//aA;IACC,6BAAqC;IACrC,gCAAwC;EDkgbzC;;ECpgbA;IACC,+BAAqC;IACrC,kCAAwC;EDugbzC;;ECzgbA;IACC,6BAAqC;IACrC,gCAAwC;ED4gbzC;;EC9gbA;IACC,+BAAqC;IACrC,kCAAwC;EDihbzC;;ECnhbA;IACC,6BAAqC;IACrC,gCAAwC;EDshbzC;;ECxhbA;IACC,+BAAqC;IACrC,kCAAwC;ED2hbzC;;EC7hbA;IACC,6BAAqC;IACrC,gCAAwC;EDgibzC;;EClibA;IACC,+BAAqC;IACrC,kCAAwC;EDqibzC;;ECvibA;IACC,6BAAqC;IACrC,gCAAwC;ED0ibzC;;EC5ibA;IACC,+BAAqC;IACrC,kCAAwC;ED+ibzC;;ECjjbA;IACC,6BAAqC;IACrC,gCAAwC;EDojbzC;;ECtjbA;IACC,+BAAqC;IACrC,kCAAwC;EDyjbzC;;EC3jbA;IACC,6BAAqC;IACrC,gCAAwC;ED8jbzC;;EChkbA;IACC,+BAAqC;IACrC,kCAAwC;EDmkbzC;;ECrkbA;IACC,6BAAqC;IACrC,gCAAwC;EDwkbzC;;EC1kbA;IACC,+BAAqC;IACrC,kCAAwC;ED6kbzC;;EC/kbA;IACC,6BAAqC;IACrC,gCAAwC;EDklbzC;;ECplbA;IACC,+BAAqC;IACrC,kCAAwC;EDulbzC;;ECzlbA;IACC,6BAAqC;IACrC,gCAAwC;ED4lbzC;;EC9lbA;IACC,+BAAqC;IACrC,kCAAwC;EDimbzC;;ECnmbA;IACC,6BAAqC;IACrC,gCAAwC;EDsmbzC;;ECxmbA;IACC,+BAAqC;IACrC,kCAAwC;ED2mbzC;;EC7mbA;IACC,6BAAqC;IACrC,gCAAwC;EDgnbzC;;EClnbA;IACC,+BAAqC;IACrC,kCAAwC;EDqnbzC;;ECvnbA;IACC,6BAAqC;IACrC,gCAAwC;ED0nbzC;;EC5nbA;IACC,+BAAqC;IACrC,kCAAwC;ED+nbzC;;ECjobA;IACC,6BAAqC;IACrC,gCAAwC;EDoobzC;;ECtobA;IACC,+BAAqC;IACrC,kCAAwC;EDyobzC;;EC3obA;IACC,6BAAqC;IACrC,gCAAwC;ED8obzC;;EChpbA;IACC,+BAAqC;IACrC,kCAAwC;EDmpbzC;;ECrpbA;IACC,6BAAqC;IACrC,gCAAwC;EDwpbzC;;EC1pbA;IACC,+BAAqC;IACrC,kCAAwC;ED6pbzC;;EC/pbA;IACC,6BAAqC;IACrC,gCAAwC;EDkqbzC;;ECpqbA;IACC,+BAAqC;IACrC,kCAAwC;EDuqbzC;;ECzqbA;IACC,6BAAqC;IACrC,gCAAwC;ED4qbzC;;EC9qbA;IACC,+BAAqC;IACrC,kCAAwC;EDirbzC;;ECnrbA;IACC,6BAAqC;IACrC,gCAAwC;EDsrbzC;;ECxrbA;IACC,+BAAqC;IACrC,kCAAwC;ED2rbzC;;EC7rbA;IACC,6BAAqC;IACrC,gCAAwC;EDgsbzC;;EClsbA;IACC,+BAAqC;IACrC,kCAAwC;EDqsbzC;;ECvsbA;IACC,6BAAqC;IACrC,gCAAwC;ED0sbzC;;EC5sbA;IACC,+BAAqC;IACrC,kCAAwC;ED+sbzC;;ECjtbA;IACC,6BAAqC;IACrC,gCAAwC;EDotbzC;;ECttbA;IACC,+BAAqC;IACrC,kCAAwC;EDytbzC;;EC3tbA;IACC,6BAAqC;IACrC,gCAAwC;ED8tbzC;;EChubA;IACC,+BAAqC;IACrC,kCAAwC;EDmubzC;;ECrubA;IACC,6BAAqC;IACrC,gCAAwC;EDwubzC;;EC1ubA;IACC,+BAAqC;IACrC,kCAAwC;ED6ubzC;;EC/ubA;IACC,6BAAqC;IACrC,gCAAwC;EDkvbzC;;ECpvbA;IACC,+BAAqC;IACrC,kCAAwC;EDuvbzC;;ECzvbA;IACC,6BAAqC;IACrC,gCAAwC;ED4vbzC;;EC9vbA;IACC,+BAAqC;IACrC,kCAAwC;EDiwbzC;;ECnwbA;IACC,6BAAqC;IACrC,gCAAwC;EDswbzC;;ECxwbA;IACC,+BAAqC;IACrC,kCAAwC;ED2wbzC;;EC7wbA;IACC,6BAAqC;IACrC,gCAAwC;EDgxbzC;;EClxbA;IACC,+BAAqC;IACrC,kCAAwC;EDqxbzC;;ECvxbA;IACC,6BAAqC;IACrC,gCAAwC;ED0xbzC;;EC5xbA;IACC,+BAAqC;IACrC,kCAAwC;ED+xbzC;;ECjybA;IACC,6BAAqC;IACrC,gCAAwC;EDoybzC;;ECtybA;IACC,+BAAqC;IACrC,kCAAwC;EDyybzC;;EC3ybA;IACC,6BAAqC;IACrC,gCAAwC;ED8ybzC;;EChzbA;IACC,+BAAqC;IACrC,kCAAwC;EDmzbzC;;ECrzbA;IACC,6BAAqC;IACrC,gCAAwC;EDwzbzC;;EC1zbA;IACC,+BAAqC;IACrC,kCAAwC;ED6zbzC;;EC/zbA;IACC,6BAAqC;IACrC,gCAAwC;EDk0bzC;;ECp0bA;IACC,+BAAqC;IACrC,kCAAwC;EDu0bzC;;ECz0bA;IACC,6BAAqC;IACrC,gCAAwC;ED40bzC;;EC90bA;IACC,+BAAqC;IACrC,kCAAwC;EDi1bzC;;ECn1bA;IACC,6BAAqC;IACrC,gCAAwC;EDs1bzC;;ECx1bA;IACC,+BAAqC;IACrC,kCAAwC;ED21bzC;;EC71bA;IACC,6BAAqC;IACrC,gCAAwC;EDg2bzC;;ECl2bA;IACC,+BAAqC;IACrC,kCAAwC;EDq2bzC;;ECv2bA;IACC,6BAAqC;IACrC,gCAAwC;ED02bzC;;EC52bA;IACC,+BAAqC;IACrC,kCAAwC;ED+2bzC;;ECj3bA;IACC,6BAAqC;IACrC,gCAAwC;EDo3bzC;;ECt3bA;IACC,+BAAqC;IACrC,kCAAwC;EDy3bzC;;ECn3bF;IAaE,6BAAc;IACb,gCAAiC;ED02blC;;EC32bA;IACC,+BAAiC;ID82bhC,kCAAkC;EACpC;AACF;AACA;EACE;IACE,wBAAwB;ECp3b1B;;EDu3bA;IACE,2BAA2B;ECx3b7B;;ED23bA;IACE,0BAA0B;EC53b5B;;ED+3bA;IACE,wBAAwB;ECh4b1B;;EDm4bA;IACE,0BAA0B;ECp4b5B;;EDu4bA;IACE,wBAAwB;ECx4b1B;;ED24bA;IACE,0BAA0B;EC54b5B;;ED+4bA;IACE,wBAAwB;ECh5b1B;;EDm5bA;IACE,0BAA0B;ECp5b5B;;EDu5bA;IACE,wBAAwB;ECx5b1B;;ED25bA;IACE,0BAA0B;EC55b5B;;ED+5bA;IACE,wBAAwB;ECh6b1B;;EDm6bA;IACE,0BAA0B;ECp6b5B;;EDu6bA;IACE,wBAAwB;ECx6b1B;;ED26bA;IACE,0BAA0B;EC56b5B;;ED+6bA;IACE,wBAAwB;ECh7b1B;;EDm7bA;IACE,0BAA0B;ECp7b5B;;EDu7bA;IACE,wBAAwB;ECx7b1B;;ED27bA;IACE,0BAA0B;EC57b5B;;ED+7bA;IACE,wBAAwB;ECh8b1B;;EDm8bA;IACE,0BAA0B;ECp8b5B;;EDu8bA;IACE,yBAAyB;ECx8b3B;;ED28bA;IACE,2BAA2B;EC58b7B;;ED+8bA;IACE,yBAAyB;ECh9b3B;;EDm9bA;IACE,2BAA2B;ECp9b7B;;EDu9bA;IACE,yBAAyB;ECx9b3B;;ED29bA;IACE,2BAA2B;EC59b7B;;ED+9bA;IACE,yBAAyB;ECh+b3B;;EDm+bA;IACE,2BAA2B;ECp+b7B;;EDu+bA;IACE,yBAAyB;ECx+b3B;;ED2+bA;IACE,2BAA2B;EC5+b7B;;ED++bA;IACE,yBAAyB;ECh/b3B;;EDm/bA;IACE,2BAA2B;ECp/b7B;;EDu/bA;IACE,yBAAyB;ECx/b3B;;ED2/bA;IACE,2BAA2B;EC5/b7B;;ED+/bA;IACE,yBAAyB;EChgc3B;;EDmgcA;IACE,2BAA2B;ECpgc7B;;EDugcA;IACE,yBAAyB;ECxgc3B;;ED2gcA;IACE,2BAA2B;EC5gc7B;;ED+gcA;IACE,yBAAyB;EChhc3B;;EDmhcA;IACE,2BAA2B;ECphc7B;;EDuhcA;IACE,yBAAyB;ECxhc3B;;ED2hcA;IACE,2BAA2B;EC5hc7B;;ED+hcA;IACE,yBAAyB;EChic3B;;EDmicA;IACE,2BAA2B;ECpic7B;;EDuicA;IACE,yBAAyB;ECxic3B;;ED2icA;IACE,2BAA2B;EC5ic7B;;ED+icA;IACE,yBAAyB;EChjc3B;;EDmjcA;IACE,2BAA2B;ECpjc7B;;EDujcA;IACE,yBAAyB;ECxjc3B;;ED2jcA;IACE,2BAA2B;EC5jc7B;;ED+jcA;IACE,yBAAyB;EChkc3B;;EDmkcA;IACE,2BAA2B;ECpkc7B;;EDukcA;IACE,yBAAyB;ECxkc3B;;ED2kcA;IACE,2BAA2B;EC5kc7B;;ED+kcA;IACE,yBAAyB;EChlc3B;;EDmlcA;IACE,2BAA2B;ECplc7B;;EDulcA;IACE,yBAAyB;ECxlc3B;;ED2lcA;IACE,2BAA2B;EC5lc7B;;ED+lcA;IACE,yBAAyB;EChmc3B;;EDmmcA;IACE,2BAA2B;ECpmc7B;;EDumcA;IACE,yBAAyB;ECxmc3B;;ED2mcA;IACE,2BAA2B;EC5mc7B;;ED+mcA;IACE,yBAAyB;EChnc3B;;EDmncA;IACE,2BAA2B;ECpnc7B;;EDuncA;IACE,yBAAyB;ECxnc3B;;ED2ncA;IACE,2BAA2B;EC5nc7B;;ED+ncA;IACE,yBAAyB;EChoc3B;;EDmocA;IACE,2BAA2B;ECpoc7B;;EDuocA;IACE,yBAAyB;ECxoc3B;;ED2ocA;IACE,2BAA2B;EC5oc7B;;ED+ocA;IACE,yBAAyB;EChpc3B;;EDmpcA;IACE,2BAA2B;ECppc7B;;EDupcA;IACE,yBAAyB;ECxpc3B;;ED2pcA;IACE,2BAA2B;EC5pc7B;;ED+pcA;IACE,yBAAyB;EChqc3B;;EDmqcA;IACE,2BAA2B;ECpqc7B;;EDuqcA;IACE,yBAAyB;ECxqc3B;;ED2qcA;IACE,2BAA2B;EC5qc7B;;ED+qcA;IACE,yBAAyB;EChrc3B;;EDmrcA;IACE,2BAA2B;ECprc7B;;EDurcA;IACE,yBAAyB;ECxrc3B;;ED2rcA;IACE,2BAA2B;EC5rc7B;;ED+rcA;IACE,yBAAyB;EChsc3B;;EDmscA;IACE,2BAA2B;ECpsc7B;;EDuscA;IACE,yBAAyB;ECxsc3B;;ED2scA;IACE,2BAA2B;EC5sc7B;;ED+scA;IACE,yBAAyB;EChtc3B;;EDmtcA;IACE,2BAA2B;ECptc7B;;EDutcA;IACE,yBAAyB;ECxtc3B;;ED2tcA;IACE,2BAA2B;EC5tc7B;;ED+tcA;IACE,yBAAyB;EChuc3B;;EDmucA;IACE,2BAA2B;ECpuc7B;;EDuucA;IACE,yBAAyB;ECxuc3B;;ED2ucA;IACE,2BAA2B;EC5uc7B;;ED+ucA;IACE,yBAAyB;EChvc3B;;EDmvcA;IACE,2BAA2B;ECpvc7B;;EDuvcA;IACE,yBAAyB;ECxvc3B;;ED2vcA;IACE,2BAA2B;EC5vc7B;;ED+vcA;IACE,yBAAyB;EChwc3B;;EDmwcA;IACE,2BAA2B;ECpwc7B;;EDuwcA;IACE,yBAAyB;ECxwc3B;;ED2wcA;IACE,2BAA2B;EC5wc7B;;ED+wcA;IACE,yBAAyB;EChxc3B;;EDmxcA;IACE,2BAA2B;ECpxc7B;;EDuxcA;IACE,yBAAyB;ECxxc3B;;ED2xcA;IACE,2BAA2B;EC5xc7B;;ED+xcA;IACE,yBAAyB;EChyc3B;;EDmycA;IACE,2BAA2B;ECpyc7B;;EDuycA;IACE,yBAAyB;ECxyc3B;;ED2ycA;IACE,2BAA2B;EC5yc7B;;ED+ycA;IACE,yBAAyB;EChzc3B;;EDmzcA;IACE,2BAA2B;ECpzc7B;;EDuzcA;IACE,yBAAyB;ECxzc3B;;ED2zcA;IACE,2BAA2B;EC5zc7B;;ED+zcA;IACE,yBAAyB;ECh0c3B;;EDm0cA;IACE,2BAA2B;ECp0c7B;;EDu0cA;IACE,yBAAyB;ECx0c3B;;ED20cA;IACE,2BAA2B;EC50c7B;;ED+0cA;IACE,yBAAyB;ECh1c3B;;EDm1cA;IACE,2BAA2B;ECp1c7B;;EDu1cA;IACE,yBAAyB;ECx1c3B;;ED21cA;IACE,2BAA2B;EC51c7B;;ED+1cA;IACE,yBAAyB;ECh2c3B;;EDm2cA;IACE,2BAA2B;ECp2c7B;;EDu2cA;IACE,yBAAyB;ECx2c3B;;ED22cA;IACE,2BAA2B;EC52c7B;;ED+2cA;IACE,yBAAyB;ECh3c3B;;EDm3cA;IACE,2BAA2B;ECp3c7B;;EDu3cA;IACE,yBAAyB;ECx3c3B;;ED23cA;IACE,2BAA2B;EC53c7B;;ED+3cA;IACE,yBAAyB;ECh4c3B;;EDm4cA;IACE,2BAA2B;ECp4c7B;;EDu4cA;IACE,yBAAyB;ECx4c3B;;ED24cA;IACE,2BAA2B;EC54c7B;;ED+4cA;IACE,yBAAyB;ECh5c3B;;EDm5cA;IACE,2BAA2B;ECp5c7B;;EDu5cA;IACE,yBAAyB;ECx5c3B;;ED25cA;IACE,2BAA2B;EC55c7B;;ED+5cA;IACE,yBAAyB;ECh6c3B;;EDm6cA;IACE,2BAA2B;ECp6c7B;;EDu6cA;IACE,yBAAyB;ECx6c3B;;ED26cA;IACE,2BAA2B;EC56c7B;;ED+6cA;IACE,yBAAyB;ECh7c3B;;EDm7cA;IACE,2BAA2B;ECp7c7B;;EDu7cA;IACE,yBAAyB;ECx7c3B;;ED27cA;IACE,2BAA2B;EC57c7B;;ED+7cA;IACE,yBAAyB;ECh8c3B;;EDm8cA;IACE,2BAA2B;ECp8c7B;;EDu8cA;IACE,yBAAyB;ECx8c3B;;ED28cA;IACE,2BAA2B;EC58c7B;;ED+8cA;IACE,yBAAyB;ECh9c3B;;EDm9cA;IACE,2BAA2B;ECp9c7B;;EDu9cA;IACE,yBAAyB;ECx9c3B;;ED29cA;IACE,2BAA2B;EC59c7B;;ED+9cA;IACE,yBAAyB;ECh+c3B;;EDm+cA;IACE,2BAA2B;ECp+c7B;;EDu+cA;IACE,yBAAyB;ECx+c3B;;ED2+cA;IACE,2BAA2B;ECz9c7B;;ED49cA;IACE,yBAAyB;EC79c3B;;EDg+cA;IACE,2BAA2B;ECj+c7B;;EDo+cA;IACE,4BAA4B;ECr+c9B;;EDw+cA;IACE,+BAA+B;ECz+cjC;;ED4+cA;IACE,8BAA8B;EC7+chC;;EDg/cA;IACE,4BAA4B;ECj/c9B;;EDo/cA;IACE,8BAA8B;ECr/chC;;EDw/cA;IACE,4BAA4B;ECz/c9B;;ED4/cA;IACE,8BAA8B;EC7/chC;;EDggdA;IACE,4BAA4B;ECjgd9B;;EDogdA;IACE,8BAA8B;ECrgdhC;;EDwgdA;IACE,4BAA4B;ECzgd9B;;ED4gdA;IACE,8BAA8B;EC7gdhC;;EDghdA;IACE,4BAA4B;ECjhd9B;;EDohdA;IACE,8BAA8B;ECrhdhC;;EDwhdA;IACE,4BAA4B;ECzhd9B;;ED4hdA;IACE,8BAA8B;EC7hdhC;;EDgidA;IACE,4BAA4B;ECjid9B;;EDoidA;IACE,8BAA8B;ECridhC;;EDwidA;IACE,4BAA4B;ECzid9B;;ED4idA;IACE,8BAA8B;EC7idhC;;EDgjdA;IACE,4BAA4B;ECjjd9B;;EDojdA;IACE,8BAA8B;ECrjdhC;;EDwjdA;IACE,6BAA6B;ECzjd/B;;ED4jdA;IACE,+BAA+B;EC7jdjC;;EDgkdA;IACE,6BAA6B;ECjkd/B;;EDokdA;IACE,+BAA+B;ECrkdjC;;EDwkdA;IACE,6BAA6B;ECzkd/B;;ED4kdA;IACE,+BAA+B;EC7kdjC;;EDgldA;IACE,6BAA6B;ECjld/B;;EDoldA;IACE,+BAA+B;ECrldjC;;EDwldA;IACE,6BAA6B;ECzld/B;;ED4ldA;IACE,+BAA+B;EC7ldjC;;EDgmdA;IACE,6BAA6B;ECjmd/B;;EDomdA;IACE,+BAA+B;ECrmdjC;;EDwmdA;IACE,6BAA6B;ECzmd/B;;ED4mdA;IACE,+BAA+B;EC7mdjC;;EDgndA;IACE,6BAA6B;ECjnd/B;;EDondA;IACE,+BAA+B;ECrndjC;;EDwndA;IACE,6BAA6B;ECznd/B;;ED4ndA;IACE,+BAA+B;EC7ndjC;;EDgodA;IACE,6BAA6B;ECjod/B;;EDoodA;IACE,+BAA+B;ECrodjC;;EDwodA;IACE,6BAA6B;ECzod/B;;ED4odA;IACE,+BAA+B;EC7odjC;;EDgpdA;IACE,6BAA6B;ECjpd/B;;EDopdA;IACE,+BAA+B;ECrpdjC;;EDwpdA;IACE,6BAA6B;ECzpd/B;;ED4pdA;IACE,+BAA+B;EC7pdjC;;EDgqdA;IACE,6BAA6B;ECjqd/B;;EDoqdA;IACE,+BAA+B;ECrqdjC;;EDwqdA;IACE,6BAA6B;ECzqd/B;;ED4qdA;IACE,+BAA+B;EC7qdjC;;EDgrdA;IACE,6BAA6B;ECjrd/B;;EDordA;IACE,+BAA+B;ECrrdjC;;EDwrdA;IACE,6BAA6B;ECzrd/B;;ED4rdA;IACE,+BAA+B;EC7rdjC;;EDgsdA;IACE,6BAA6B;ECjsd/B;;EDosdA;IACE,+BAA+B;ECrsdjC;;EDwsdA;IACE,6BAA6B;ECzsd/B;;ED4sdA;IACE,+BAA+B;EC7sdjC;;EDgtdA;IACE,6BAA6B;ECjtd/B;;EDotdA;IACE,+BAA+B;ECrtdjC;;EDwtdA;IACE,6BAA6B;ECztd/B;;ED4tdA;IACE,+BAA+B;EC7tdjC;;EDgudA;IACE,6BAA6B;ECjud/B;;EDoudA;IACE,+BAA+B;ECrudjC;;EDwudA;IACE,6BAA6B;ECzud/B;;ED4udA;IACE,+BAA+B;EC7udjC;;EDgvdA;IACE,6BAA6B;ECjvd/B;;EDovdA;IACE,+BAA+B;ECrvdjC;;EDwvdA;IACE,6BAA6B;ECzvd/B;;ED4vdA;IACE,+BAA+B;EC7vdjC;;EDgwdA;IACE,6BAA6B;ECjwd/B;;EDowdA;IACE,+BAA+B;ECrwdjC;;EDwwdA;IACE,6BAA6B;ECzwd/B;;ED4wdA;IACE,+BAA+B;EC7wdjC;;EDgxdA;IACE,6BAA6B;ECjxd/B;;EDoxdA;IACE,+BAA+B;ECrxdjC;;EDwxdA;IACE,6BAA6B;ECzxd/B;;ED4xdA;IACE,+BAA+B;EC7xdjC;;EDgydA;IACE,6BAA6B;ECjyd/B;;EDoydA;IACE,+BAA+B;ECrydjC;;EDwydA;IACE,6BAA6B;ECzyd/B;;ED4ydA;IACE,+BAA+B;EC7ydjC;;EDgzdA;IACE,6BAA6B;ECjzd/B;;EDozdA;IACE,+BAA+B;ECrzdjC;;EDwzdA;IACE,6BAA6B;ECzzd/B;;ED4zdA;IACE,+BAA+B;EC7zdjC;;EDg0dA;IACE,6BAA6B;ECj0d/B;;EDo0dA;IACE,+BAA+B;ECr0djC;;EDw0dA;IACE,6BAA6B;ECz0d/B;;ED40dA;IACE,+BAA+B;EC70djC;;EDg1dA;IACE,6BAA6B;ECj1d/B;;EDo1dA;IACE,+BAA+B;ECr1djC;;EDw1dA;IACE,6BAA6B;ECz1d/B;;ED41dA;IACE,+BAA+B;EC71djC;;EDg2dA;IACE,6BAA6B;ECj2d/B;;EDo2dA;IACE,+BAA+B;ECr2djC;;EDw2dA;IACE,6BAA6B;ECz2d/B;;ED42dA;IACE,+BAA+B;EC72djC;;EDg3dA;IACE,6BAA6B;ECj3d/B;;EDo3dA;IACE,+BAA+B;ECr3djC;;EDw3dA;IACE,6BAA6B;ECz3d/B;;ED43dA;IACE,+BAA+B;EC73djC;;EDg4dA;IACE,6BAA6B;ECj4d/B;;EDo4dA;IACE,+BAA+B;ECr4djC;;EDw4dA;IACE,6BAA6B;ECz4d/B;;ED44dA;IACE,+BAA+B;EC74djC;;EDg5dA;IACE,6BAA6B;ECj5d/B;;EDo5dA;IACE,+BAA+B;ECr5djC;;EDw5dA;IACE,6BAA6B;ECz5d/B;;ED45dA;IACE,+BAA+B;EC75djC;;EDg6dA;IACE,6BAA6B;ECj6d/B;;EDo6dA;IACE,+BAA+B;ECr6djC;;EDw6dA;IACE,6BAA6B;ECz6d/B;;ED46dA;IACE,+BAA+B;EC76djC;;EDg7dA;IACE,6BAA6B;ECj7d/B;;EDo7dA;IACE,+BAA+B;ECr7djC;;EDw7dA;IACE,6BAA6B;ECz7d/B;;ED47dA;IACE,+BAA+B;EC77djC;;EDg8dA;IACE,6BAA6B;ECj8d/B;;EDo8dA;IACE,+BAA+B;ECr8djC;;EDw8dA;IACE,6BAA6B;ECz8d/B;;ED48dA;IACE,+BAA+B;EC78djC;;EDg9dA;IACE,6BAA6B;ECj9d/B;;EDo9dA;IACE,+BAA+B;ECr9djC;;EDw9dA;IACE,6BAA6B;ECz9d/B;;ED49dA;IACE,+BAA+B;EC79djC;;EDg+dA;IACE,6BAA6B;ECj+d/B;;EDo+dA;IACE,+BAA+B;ECr+djC;;EDw+dA;IACE,6BAA6B;ECz+d/B;;ED4+dA;IACE,+BAA+B;EC7+djC;;EDg/dA;IACE,6BAA6B;ECj/d/B;;EDo/dA;IACE,+BAA+B;ECr/djC;;EDw/dA;IACE,6BAA6B;ECz/d/B;;ED4/dA;IACE,+BAA+B;EC7/djC;;EDggeA;IACE,6BAA6B;ECjge/B;;EDogeA;IACE,+BAA+B;ECrgejC;;EDwgeA;IACE,6BAA6B;ECzge/B;;ED4geA;IACE,+BAA+B;EC7gejC;;EDgheA;IACE,6BAA6B;ECjhe/B;;EDoheA;IACE,+BAA+B;ECrhejC;;EDwheA;IACE,6BAA6B;ECzhe/B;;ED4heA;IACE,+BAA+B;EC7hejC;;EDgieA;IACE,6BAA6B;ECjie/B;;EDoieA;IACE,+BAA+B;ECriejC;;EDwieA;IACE,6BAA6B;ECzie/B;;ED4ieA;IACE,+BAA+B;EC7iejC;;EDgjeA;IACE,6BAA6B;ECjje/B;;EDojeA;IACE,+BAA+B;ECrjejC;;EDwjeA;IACE,6BAA6B;ECzje/B;;ED4jeA;IACE,+BAA+B;EC7jejC;;EDgkeA;IACE,6BAA6B;ECjke/B;;EDokeA;IACE,+BAA+B;ECrkejC;;EDwkeA;IACE,6BAA6B;ECzke/B;;ED4keA;IACE,+BAA+B;EC7kejC;;EDgleA;IACE,6BAA6B;ECjle/B;;EDoleA;IACE,+BAA+B;ECrlejC;;EDwleA;IACE,6BAA6B;ECzle/B;;ED4leA;IACE,+BAA+B;EC1kejC;;ED6keA;IACE,6BAA6B;EC9ke/B;;EDileA;IACE,+BAA+B;ECllejC;;EDqleA;IACE,+BAA+B;ECtlejC;;EDyleA;IACE,kCAAkC;EC1lepC;;ED6leA;IACE,iCAAiC;EC9lenC;;EDimeA;IACE,+BAA+B;EClmejC;;EDqmeA;IACE,iCAAiC;ECtmenC;;EDymeA;IACE,+BAA+B;EC1mejC;;ED6meA;IACE,iCAAiC;EC9menC;;EDineA;IACE,+BAA+B;EClnejC;;EDqneA;IACE,iCAAiC;ECtnenC;;EDyneA;IACE,+BAA+B;EC1nejC;;ED6neA;IACE,iCAAiC;EC9nenC;;EDioeA;IACE,+BAA+B;ECloejC;;EDqoeA;IACE,iCAAiC;ECtoenC;;EDyoeA;IACE,+BAA+B;EC1oejC;;ED6oeA;IACE,iCAAiC;EC9oenC;;EDipeA;IACE,+BAA+B;EClpejC;;EDqpeA;IACE,iCAAiC;ECtpenC;;EDypeA;IACE,+BAA+B;EC1pejC;;ED6peA;IACE,iCAAiC;EC9penC;;EDiqeA;IACE,+BAA+B;EClqejC;;EDqqeA;IACE,iCAAiC;ECtqenC;;EDyqeA;IACE,gCAAgC;EC1qelC;;ED6qeA;IACE,kCAAkC;EC9qepC;;EDireA;IACE,gCAAgC;EClrelC;;EDqreA;IACE,kCAAkC;ECtrepC;;EDyreA;IACE,gCAAgC;EC1relC;;ED6reA;IACE,kCAAkC;EC9repC;;EDiseA;IACE,gCAAgC;EClselC;;EDqseA;IACE,kCAAkC;ECtsepC;;EDyseA;IACE,gCAAgC;EC1selC;;ED6seA;IACE,kCAAkC;EC9sepC;;EDiteA;IACE,gCAAgC;ECltelC;;EDqteA;IACE,kCAAkC;ECttepC;;EDyteA;IACE,gCAAgC;EC1telC;;ED6teA;IACE,kCAAkC;EC9tepC;;EDiueA;IACE,gCAAgC;ECluelC;;EDqueA;IACE,kCAAkC;ECtuepC;;EDyueA;IACE,gCAAgC;EC1uelC;;ED6ueA;IACE,kCAAkC;EC9uepC;;EDiveA;IACE,gCAAgC;EClvelC;;EDqveA;IACE,kCAAkC;ECtvepC;;EDyveA;IACE,gCAAgC;EC1velC;;ED6veA;IACE,kCAAkC;EC9vepC;;EDiweA;IACE,gCAAgC;EClwelC;;EDqweA;IACE,kCAAkC;ECtwepC;;EDyweA;IACE,gCAAgC;EC1welC;;ED6weA;IACE,kCAAkC;EC9wepC;;EDixeA;IACE,gCAAgC;EClxelC;;EDqxeA;IACE,kCAAkC;ECtxepC;;EDyxeA;IACE,gCAAgC;EC1xelC;;ED6xeA;IACE,kCAAkC;EC9xepC;;EDiyeA;IACE,gCAAgC;EClyelC;;EDqyeA;IACE,kCAAkC;ECtyepC;;EDyyeA;IACE,gCAAgC;EC1yelC;;ED6yeA;IACE,kCAAkC;EC9yepC;;EDizeA;IACE,gCAAgC;EClzelC;;EDqzeA;IACE,kCAAkC;ECtzepC;;EDyzeA;IACE,gCAAgC;EC1zelC;;ED6zeA;IACE,kCAAkC;EC9zepC;;EDi0eA;IACE,gCAAgC;ECl0elC;;EDq0eA;IACE,kCAAkC;ECt0epC;;EDy0eA;IACE,gCAAgC;EC10elC;;ED60eA;IACE,kCAAkC;EC90epC;;EDi1eA;IACE,gCAAgC;ECl1elC;;EDq1eA;IACE,kCAAkC;ECt1epC;;EDy1eA;IACE,gCAAgC;EC11elC;;ED61eA;IACE,kCAAkC;EC91epC;;EDi2eA;IACE,gCAAgC;ECl2elC;;EDq2eA;IACE,kCAAkC;ECt2epC;;EDy2eA;IACE,gCAAgC;EC12elC;;ED62eA;IACE,kCAAkC;EC92epC;;EDi3eA;IACE,gCAAgC;ECl3elC;;EDq3eA;IACE,kCAAkC;ECt3epC;;EDy3eA;IACE,gCAAgC;EC13elC;;ED63eA;IACE,kCAAkC;EC93epC;;EDi4eA;IACE,gCAAgC;ECl4elC;;EDq4eA;IACE,kCAAkC;ECt4epC;;EDy4eA;IACE,gCAAgC;EC14elC;;ED64eA;IACE,kCAAkC;EC94epC;;EDi5eA;IACE,gCAAgC;ECl5elC;;EDq5eA;IACE,kCAAkC;ECt5epC;;EDy5eA;IACE,gCAAgC;EC15elC;;ED65eA;IACE,kCAAkC;EC95epC;;EDi6eA;IACE,gCAAgC;ECl6elC;;EDq6eA;IACE,kCAAkC;ECt6epC;;EDy6eA;IACE,gCAAgC;EC16elC;;ED66eA;IACE,kCAAkC;EC96epC;;EDi7eA;IACE,gCAAgC;ECl7elC;;EDq7eA;IACE,kCAAkC;ECt7epC;;EDy7eA;IACE,gCAAgC;EC17elC;;ED67eA;IACE,kCAAkC;EC97epC;;EDi8eA;IACE,gCAAgC;ECl8elC;;EDq8eA;IACE,kCAAkC;ECt8epC;;EDy8eA;IACE,gCAAgC;EC18elC;;ED68eA;IACE,kCAAkC;EC98epC;;EDi9eA;IACE,gCAAgC;ECl9elC;;EDq9eA;IACE,kCAAkC;ECt9epC;;EDy9eA;IACE,gCAAgC;EC19elC;;ED69eA;IACE,kCAAkC;EC99epC;;EDi+eA;IACE,gCAAgC;ECl+elC;;EDq+eA;IACE,kCAAkC;ECt+epC;;EDy+eA;IACE,gCAAgC;EC1+elC;;ED6+eA;IACE,kCAAkC;EC9+epC;;EDi/eA;IACE,gCAAgC;ECl/elC;;EDq/eA;IACE,kCAAkC;ECt/epC;;EDy/eA;IACE,gCAAgC;EC1/elC;;ED6/eA;IACE,kCAAkC;EC9/epC;;EDigfA;IACE,gCAAgC;EClgflC;;EDqgfA;IACE,kCAAkC;ECtgfpC;;EDygfA;IACE,gCAAgC;EC1gflC;;ED6gfA;IACE,kCAAkC;EC9gfpC;;EDihfA;IACE,gCAAgC;EClhflC;;EDqhfA;IACE,kCAAkC;ECthfpC;;EDyhfA;IACE,gCAAgC;EC1hflC;;ED6hfA;IACE,kCAAkC;EC9hfpC;;EDiifA;IACE,gCAAgC;ECliflC;;EDqifA;IACE,kCAAkC;ECtifpC;;EDyifA;IACE,gCAAgC;EC1iflC;;ED6ifA;IACE,kCAAkC;EC9ifpC;;EDijfA;IACE,gCAAgC;ECljflC;;EDqjfA;IACE,kCAAkC;ECtjfpC;;EDyjfA;IACE,gCAAgC;EC1jflC;;ED6jfA;IACE,kCAAkC;EC9jfpC;;EDikfA;IACE,gCAAgC;EClkflC;;EDqkfA;IACE,kCAAkC;ECtkfpC;;EDykfA;IACE,gCAAgC;EC1kflC;;ED6kfA;IACE,kCAAkC;EC9kfpC;;EDilfA;IACE,gCAAgC;ECllflC;;EDqlfA;IACE,kCAAkC;ECtlfpC;;EDylfA;IACE,gCAAgC;EC1lflC;;ED6lfA;IACE,kCAAkC;EC9lfpC;;EDimfA;IACE,gCAAgC;EClmflC;;EDqmfA;IACE,kCAAkC;ECtmfpC;;EDymfA;IACE,gCAAgC;EC1mflC;;ED6mfA;IACE,kCAAkC;EC9mfpC;;EDinfA;IACE,gCAAgC;EClnflC;;EDqnfA;IACE,kCAAkC;ECtnfpC;;EDynfA;IACE,gCAAgC;EC1nflC;;ED6nfA;IACE,kCAAkC;EC9nfpC;;EDiofA;IACE,gCAAgC;ECloflC;;EDqofA;IACE,kCAAkC;ECtofpC;;EDyofA;IACE,gCAAgC;EC1oflC;;ED6ofA;IACE,kCAAkC;EC9ofpC;;EDipfA;IACE,gCAAgC;EClpflC;;EDqpfA;IACE,kCAAkC;ECtpfpC;;EDypfA;IACE,gCAAgC;EC1pflC;;ED6pfA;IACE,kCAAkC;EC9pfpC;;EDiqfA;IACE,gCAAgC;EClqflC;;EDqqfA;IACE,kCAAkC;ECtqfpC;;EDyqfA;IACE,gCAAgC;EC1qflC;;ED6qfA;IACE,kCAAkC;EC9qfpC;;EDirfA;IACE,gCAAgC;EClrflC;;EDqrfA;IACE,kCAAkC;ECtrfpC;;EDyrfA;IACE,gCAAgC;EC1rflC;;ED6rfA;IACE,kCAAkC;EC9rfpC;;EDisfA;IACE,gCAAgC;EClsflC;;EDqsfA;IACE,kCAAkC;ECtsfpC;;EDysfA;IACE,gCAAgC;EC1sflC;;ED6sfA;IACE,kCAAkC;EC3rfpC;;ED8rfA;IACE,gCAAgC;EC/rflC;;EDksfA;IACE,kCAAkC;ECnsfpC;;EDssfA;IACE,6BAA6B;ECvsf/B;;ED0sfA;IACE,gCAAgC;EC3sflC;;ED8sfA;IACE,+BAA+B;EC/sfjC;;EDktfA;IACE,6BAA6B;ECntf/B;;EDstfA;IACE,+BAA+B;ECvtfjC;;ED0tfA;IACE,6BAA6B;EC3tf/B;;ED8tfA;IACE,+BAA+B;EC/tfjC;;EDkufA;IACE,6BAA6B;ECnuf/B;;EDsufA;IACE,+BAA+B;ECvufjC;;ED0ufA;IACE,6BAA6B;EC3uf/B;;ED8ufA;IACE,+BAA+B;EC/ufjC;;EDkvfA;IACE,6BAA6B;ECnvf/B;;EDsvfA;IACE,+BAA+B;ECvvfjC;;ED0vfA;IACE,6BAA6B;EC3vf/B;;ED8vfA;IACE,+BAA+B;EC/vfjC;;EDkwfA;IACE,6BAA6B;ECnwf/B;;EDswfA;IACE,+BAA+B;ECvwfjC;;ED0wfA;IACE,6BAA6B;EC3wf/B;;ED8wfA;IACE,+BAA+B;EC/wfjC;;EDkxfA;IACE,6BAA6B;ECnxf/B;;EDsxfA;IACE,+BAA+B;ECvxfjC;;ED0xfA;IACE,8BAA8B;EC3xfhC;;ED8xfA;IACE,gCAAgC;EC/xflC;;EDkyfA;IACE,8BAA8B;ECnyfhC;;EDsyfA;IACE,gCAAgC;ECvyflC;;ED0yfA;IACE,8BAA8B;EC3yfhC;;ED8yfA;IACE,gCAAgC;EC/yflC;;EDkzfA;IACE,8BAA8B;ECnzfhC;;EDszfA;IACE,gCAAgC;ECvzflC;;ED0zfA;IACE,8BAA8B;EC3zfhC;;ED8zfA;IACE,gCAAgC;EC/zflC;;EDk0fA;IACE,8BAA8B;ECn0fhC;;EDs0fA;IACE,gCAAgC;ECv0flC;;ED00fA;IACE,8BAA8B;EC30fhC;;ED80fA;IACE,gCAAgC;EC/0flC;;EDk1fA;IACE,8BAA8B;ECn1fhC;;EDs1fA;IACE,gCAAgC;ECv1flC;;ED01fA;IACE,8BAA8B;EC31fhC;;ED81fA;IACE,gCAAgC;EC/1flC;;EDk2fA;IACE,8BAA8B;ECn2fhC;;EDs2fA;IACE,gCAAgC;ECv2flC;;ED02fA;IACE,8BAA8B;EC32fhC;;ED82fA;IACE,gCAAgC;EC/2flC;;EDk3fA;IACE,8BAA8B;ECn3fhC;;EDs3fA;IACE,gCAAgC;ECv3flC;;ED03fA;IACE,8BAA8B;EC33fhC;;ED83fA;IACE,gCAAgC;EC/3flC;;EDk4fA;IACE,8BAA8B;ECn4fhC;;EDs4fA;IACE,gCAAgC;ECv4flC;;ED04fA;IACE,8BAA8B;EC34fhC;;ED84fA;IACE,gCAAgC;EC/4flC;;EDk5fA;IACE,8BAA8B;ECn5fhC;;EDs5fA;IACE,gCAAgC;ECv5flC;;ED05fA;IACE,8BAA8B;EC35fhC;;ED85fA;IACE,gCAAgC;EC/5flC;;EDk6fA;IACE,8BAA8B;ECn6fhC;;EDs6fA;IACE,gCAAgC;ECv6flC;;ED06fA;IACE,8BAA8B;EC36fhC;;ED86fA;IACE,gCAAgC;EC/6flC;;EDk7fA;IACE,8BAA8B;ECn7fhC;;EDs7fA;IACE,gCAAgC;ECv7flC;;ED07fA;IACE,8BAA8B;EC37fhC;;ED87fA;IACE,gCAAgC;EC/7flC;;EDk8fA;IACE,8BAA8B;ECn8fhC;;EDs8fA;IACE,gCAAgC;ECv8flC;;ED08fA;IACE,8BAA8B;EC38fhC;;ED88fA;IACE,gCAAgC;EC/8flC;;EDk9fA;IACE,8BAA8B;ECn9fhC;;EDs9fA;IACE,gCAAgC;ECv9flC;;ED09fA;IACE,8BAA8B;EC39fhC;;ED89fA;IACE,gCAAgC;EC/9flC;;EDk+fA;IACE,8BAA8B;ECn+fhC;;EDs+fA;IACE,gCAAgC;ECv+flC;;ED0+fA;IACE,8BAA8B;EC3+fhC;;ED8+fA;IACE,gCAAgC;EC/+flC;;EDk/fA;IACE,8BAA8B;ECn/fhC;;EDs/fA;IACE,gCAAgC;ECv/flC;;ED0/fA;IACE,8BAA8B;EC3/fhC;;ED8/fA;IACE,gCAAgC;EC//flC;;EDkggBA;IACE,8BAA8B;ECnggBhC;;EDsggBA;IACE,gCAAgC;ECvggBlC;;ED0ggBA;IACE,8BAA8B;EC3ggBhC;;ED8ggBA;IACE,gCAAgC;EC/ggBlC;;EDkhgBA;IACE,8BAA8B;ECnhgBhC;;EDshgBA;IACE,gCAAgC;ECvhgBlC;;ED0hgBA;IACE,8BAA8B;EC3hgBhC;;ED8hgBA;IACE,gCAAgC;EC/hgBlC;;EDkigBA;IACE,8BAA8B;ECnigBhC;;EDsigBA;IACE,gCAAgC;ECvigBlC;;ED0igBA;IACE,8BAA8B;EC3igBhC;;ED8igBA;IACE,gCAAgC;EC/igBlC;;EDkjgBA;IACE,8BAA8B;ECnjgBhC;;EDsjgBA;IACE,gCAAgC;ECvjgBlC;;ED0jgBA;IACE,8BAA8B;EC3jgBhC;;ED8jgBA;IACE,gCAAgC;EC/jgBlC;;EDkkgBA;IACE,8BAA8B;ECnkgBhC;;EDskgBA;IACE,gCAAgC;ECvkgBlC;;ED0kgBA;IACE,8BAA8B;EC3kgBhC;;ED8kgBA;IACE,gCAAgC;EC/kgBlC;;EDklgBA;IACE,8BAA8B;ECnlgBhC;;EDslgBA;IACE,gCAAgC;ECvlgBlC;;ED0lgBA;IACE,8BAA8B;EC3lgBhC;;ED8lgBA;IACE,gCAAgC;EC/lgBlC;;EDkmgBA;IACE,8BAA8B;ECnmgBhC;;EDsmgBA;IACE,gCAAgC;ECvmgBlC;;ED0mgBA;IACE,8BAA8B;EC3mgBhC;;ED8mgBA;IACE,gCAAgC;EC/mgBlC;;EDkngBA;IACE,8BAA8B;ECnngBhC;;EDsngBA;IACE,gCAAgC;ECvngBlC;;ED0ngBA;IACE,8BAA8B;EC3ngBhC;;ED8ngBA;IACE,gCAAgC;EC/ngBlC;;EDkogBA;IACE,8BAA8B;ECnogBhC;;EDsogBA;IACE,gCAAgC;ECvogBlC;;ED0ogBA;IACE,8BAA8B;EC3ogBhC;;ED8ogBA;IACE,gCAAgC;EC/ogBlC;;EDkpgBA;IACE,8BAA8B;ECnpgBhC;;EDspgBA;IACE,gCAAgC;ECvpgBlC;;ED0pgBA;IACE,8BAA8B;EC3pgBhC;;ED8pgBA;IACE,gCAAgC;EC/pgBlC;;EDkqgBA;IACE,8BAA8B;ECnqgBhC;;EDsqgBA;IACE,gCAAgC;ECvqgBlC;;ED0qgBA;IACE,8BAA8B;EC3qgBhC;;ED8qgBA;IACE,gCAAgC;EC/qgBlC;;EDkrgBA;IACE,8BAA8B;ECnrgBhC;;EDsrgBA;IACE,gCAAgC;ECvrgBlC;;ED0rgBA;IACE,8BAA8B;EC3rgBhC;;ED8rgBA;IACE,gCAAgC;EC/rgBlC;;EDksgBA;IACE,8BAA8B;ECnsgBhC;;EDssgBA;IACE,gCAAgC;ECvsgBlC;;ED0sgBA;IACE,8BAA8B;EC3sgBhC;;ED8sgBA;IACE,gCAAgC;EC/sgBlC;;EDktgBA;IACE,8BAA8B;ECntgBhC;;EDstgBA;IACE,gCAAgC;ECvtgBlC;;ED0tgBA;IACE,8BAA8B;EC3tgBhC;;ED8tgBA;IACE,gCAAgC;EC/tgBlC;;EDkugBA;IACE,8BAA8B;ECnugBhC;;EDsugBA;IACE,gCAAgC;ECvugBlC;;ED0ugBA;IACE,8BAA8B;EC3ugBhC;;ED8ugBA;IACE,gCAAgC;EC/ugBlC;;EDkvgBA;IACE,8BAA8B;ECnvgBhC;;EDsvgBA;IACE,gCAAgC;ECvvgBlC;;ED0vgBA;IACE,8BAA8B;EC3vgBhC;;ED8vgBA;IACE,gCAAgC;EC/vgBlC;;EDkwgBA;IACE,8BAA8B;ECnwgBhC;;EDswgBA;IACE,gCAAgC;ECvwgBlC;;ED0wgBA;IACE,8BAA8B;EC3wgBhC;;ED8wgBA;IACE,gCAAgC;EC/wgBlC;;EDkxgBA;IACE,8BAA8B;ECnxgBhC;;EDsxgBA;IACE,gCAAgC;ECvxgBlC;;ED0xgBA;IACE,8BAA8B;EC3xgBhC;;ED8xgBA;IACE,gCAAgC;EC/xgBlC;;EDkygBA;IACE,8BAA8B;ECnygBhC;;EDsygBA;IACE,gCAAgC;ECvygBlC;;ED0ygBA;IACE,8BAA8B;EC3ygBhC;;ED8ygBA;IACE,gCAAgC;EC/ygBlC;;EDkzgBA;IACE,8BAA8B;ECnzgBhC;;EDszgBA;IACE,gCAAgC;ECvzgBlC;;ED0zgBA;IACE,8BAA8B;EC3zgBhC;;ED8zgBA;IACE,gCAAgC;EC5ygBlC;;ED+ygBA;IACE,8BAA8B;EChzgBhC;;EDmzgBA;IACE,gCAAgC;ECpzgBlC;;EDuzgBA;IACE,8BAA8B;ECxzgBhC;;ED2zgBA;IACE,iCAAiC;EC5zgBnC;;ED+zgBA;IACE,gCAAgC;ECh0gBlC;;EDm0gBA;IACE,8BAA8B;ECp0gBhC;;EDu0gBA;IACE,gCAAgC;ECx0gBlC;;ED20gBA;IACE,8BAA8B;EC50gBhC;;ED+0gBA;IACE,gCAAgC;ECh1gBlC;;EDm1gBA;IACE,8BAA8B;ECp1gBhC;;EDu1gBA;IACE,gCAAgC;ECx1gBlC;;ED21gBA;IACE,8BAA8B;EC51gBhC;;ED+1gBA;IACE,gCAAgC;ECh2gBlC;;EDm2gBA;IACE,8BAA8B;ECp2gBhC;;EDu2gBA;IACE,gCAAgC;ECx2gBlC;;ED22gBA;IACE,8BAA8B;EC52gBhC;;ED+2gBA;IACE,gCAAgC;ECh3gBlC;;EDm3gBA;IACE,8BAA8B;ECp3gBhC;;EDu3gBA;IACE,gCAAgC;ECx3gBlC;;ED23gBA;IACE,8BAA8B;EC53gBhC;;ED+3gBA;IACE,gCAAgC;ECh4gBlC;;EDm4gBA;IACE,8BAA8B;ECp4gBhC;;EDu4gBA;IACE,gCAAgC;ECx4gBlC;;ED24gBA;IACE,+BAA+B;EC54gBjC;;ED+4gBA;IACE,iCAAiC;ECh5gBnC;;EDm5gBA;IACE,+BAA+B;ECp5gBjC;;EDu5gBA;IACE,iCAAiC;ECx5gBnC;;ED25gBA;IACE,+BAA+B;EC55gBjC;;ED+5gBA;IACE,iCAAiC;ECh6gBnC;;EDm6gBA;IACE,+BAA+B;ECp6gBjC;;EDu6gBA;IACE,iCAAiC;ECx6gBnC;;ED26gBA;IACE,+BAA+B;EC56gBjC;;ED+6gBA;IACE,iCAAiC;ECh7gBnC;;EDm7gBA;IACE,+BAA+B;ECp7gBjC;;EDu7gBA;IACE,iCAAiC;ECx7gBnC;;ED27gBA;IACE,+BAA+B;EC57gBjC;;ED+7gBA;IACE,iCAAiC;ECh8gBnC;;EDm8gBA;IACE,+BAA+B;ECp8gBjC;;EDu8gBA;IACE,iCAAiC;ECx8gBnC;;ED28gBA;IACE,+BAA+B;EC58gBjC;;ED+8gBA;IACE,iCAAiC;ECh9gBnC;;EDm9gBA;IACE,+BAA+B;ECp9gBjC;;EDu9gBA;IACE,iCAAiC;ECx9gBnC;;ED29gBA;IACE,+BAA+B;EC59gBjC;;ED+9gBA;IACE,iCAAiC;ECh+gBnC;;EDm+gBA;IACE,+BAA+B;ECp+gBjC;;EDu+gBA;IACE,iCAAiC;ECx+gBnC;;ED2+gBA;IACE,+BAA+B;EC5+gBjC;;ED++gBA;IACE,iCAAiC;ECh/gBnC;;EDm/gBA;IACE,+BAA+B;ECp/gBjC;;EDu/gBA;IACE,iCAAiC;ECx/gBnC;;ED2/gBA;IACE,+BAA+B;EC5/gBjC;;ED+/gBA;IACE,iCAAiC;EChghBnC;;EDmghBA;IACE,+BAA+B;ECpghBjC;;EDughBA;IACE,iCAAiC;ECxghBnC;;ED2ghBA;IACE,+BAA+B;EC5ghBjC;;ED+ghBA;IACE,iCAAiC;EChhhBnC;;EDmhhBA;IACE,+BAA+B;ECphhBjC;;EDuhhBA;IACE,iCAAiC;ECxhhBnC;;ED2hhBA;IACE,+BAA+B;EC5hhBjC;;ED+hhBA;IACE,iCAAiC;EChihBnC;;EDmihBA;IACE,+BAA+B;ECpihBjC;;EDuihBA;IACE,iCAAiC;ECxihBnC;;ED2ihBA;IACE,+BAA+B;EC5ihBjC;;ED+ihBA;IACE,iCAAiC;EChjhBnC;;EDmjhBA;IACE,+BAA+B;ECpjhBjC;;EDujhBA;IACE,iCAAiC;ECxjhBnC;;ED2jhBA;IACE,+BAA+B;EC5jhBjC;;ED+jhBA;IACE,iCAAiC;EChkhBnC;;EDmkhBA;IACE,+BAA+B;ECpkhBjC;;EDukhBA;IACE,iCAAiC;ECxkhBnC;;ED2khBA;IACE,+BAA+B;EC5khBjC;;ED+khBA;IACE,iCAAiC;EChlhBnC;;EDmlhBA;IACE,+BAA+B;ECplhBjC;;EDulhBA;IACE,iCAAiC;ECxlhBnC;;ED2lhBA;IACE,+BAA+B;EC5lhBjC;;ED+lhBA;IACE,iCAAiC;EChmhBnC;;EDmmhBA;IACE,+BAA+B;ECpmhBjC;;EDumhBA;IACE,iCAAiC;ECxmhBnC;;ED2mhBA;IACE,+BAA+B;EC5mhBjC;;ED+mhBA;IACE,iCAAiC;EChnhBnC;;EDmnhBA;IACE,+BAA+B;ECpnhBjC;;EDunhBA;IACE,iCAAiC;ECxnhBnC;;ED2nhBA;IACE,+BAA+B;EC5nhBjC;;ED+nhBA;IACE,iCAAiC;EChohBnC;;EDmohBA;IACE,+BAA+B;ECpohBjC;;EDuohBA;IACE,iCAAiC;ECxohBnC;;ED2ohBA;IACE,+BAA+B;EC5ohBjC;;ED+ohBA;IACE,iCAAiC;EChphBnC;;EDmphBA;IACE,+BAA+B;ECpphBjC;;EDuphBA;IACE,iCAAiC;ECxphBnC;;ED2phBA;IACE,+BAA+B;EC5phBjC;;ED+phBA;IACE,iCAAiC;EChqhBnC;;EDmqhBA;IACE,+BAA+B;ECpqhBjC;;EDuqhBA;IACE,iCAAiC;ECxqhBnC;;ED2qhBA;IACE,+BAA+B;EC5qhBjC;;ED+qhBA;IACE,iCAAiC;EChrhBnC;;EDmrhBA;IACE,+BAA+B;ECprhBjC;;EDurhBA;IACE,iCAAiC;ECxrhBnC;;ED2rhBA;IACE,+BAA+B;EC5rhBjC;;ED+rhBA;IACE,iCAAiC;EChshBnC;;EDmshBA;IACE,+BAA+B;ECpshBjC;;EDushBA;IACE,iCAAiC;ECxshBnC;;ED2shBA;IACE,+BAA+B;EC5shBjC;;ED+shBA;IACE,iCAAiC;EChthBnC;;EDmthBA;IACE,+BAA+B;ECpthBjC;;EDuthBA;IACE,iCAAiC;ECxthBnC;;ED2thBA;IACE,+BAA+B;EC5thBjC;;ED+thBA;IACE,iCAAiC;EChuhBnC;;EDmuhBA;IACE,+BAA+B;ECpuhBjC;;EDuuhBA;IACE,iCAAiC;ECxuhBnC;;ED2uhBA;IACE,+BAA+B;EC5uhBjC;;ED+uhBA;IACE,iCAAiC;EChvhBnC;;EDmvhBA;IACE,+BAA+B;ECpvhBjC;;EDuvhBA;IACE,iCAAiC;ECxvhBnC;;ED2vhBA;IACE,+BAA+B;EC5vhBjC;;ED+vhBA;IACE,iCAAiC;EChwhBnC;;EDmwhBA;IACE,+BAA+B;ECpwhBjC;;EDuwhBA;IACE,iCAAiC;ECxwhBnC;;ED2whBA;IACE,+BAA+B;EC5whBjC;;ED+whBA;IACE,iCAAiC;EChxhBnC;;EDmxhBA;IACE,+BAA+B;ECpxhBjC;;EDuxhBA;IACE,iCAAiC;ECxxhBnC;;ED2xhBA;IACE,+BAA+B;EC5xhBjC;;ED+xhBA;IACE,iCAAiC;EChyhBnC;;EDmyhBA;IACE,+BAA+B;ECpyhBjC;;EDuyhBA;IACE,iCAAiC;ECxyhBnC;;ED2yhBA;IACE,+BAA+B;EC5yhBjC;;ED+yhBA;IACE,iCAAiC;EChzhBnC;;EDmzhBA;IACE,+BAA+B;ECpzhBjC;;EDuzhBA;IACE,iCAAiC;ECxzhBnC;;ED2zhBA;IACE,+BAA+B;EC5zhBjC;;ED+zhBA;IACE,iCAAiC;ECh0hBnC;;EDm0hBA;IACE,+BAA+B;ECp0hBjC;;EDu0hBA;IACE,iCAAiC;ECx0hBnC;;ED20hBA;IACE,+BAA+B;EC50hBjC;;ED+0hBA;IACE,iCAAiC;ECh1hBnC;;EDm1hBA;IACE,+BAA+B;ECp1hBjC;;EDu1hBA;IACE,iCAAiC;ECx1hBnC;;ED21hBA;IACE,+BAA+B;EC51hBjC;;ED+1hBA;IACE,iCAAiC;ECh2hBnC;;EDm2hBA;IACE,+BAA+B;ECp2hBjC;;EDu2hBA;IACE,iCAAiC;ECx2hBnC;;ED22hBA;IACE,+BAA+B;EC52hBjC;;ED+2hBA;IACE,iCAAiC;ECh3hBnC;;EDm3hBA;IACE,+BAA+B;ECp3hBjC;;EDu3hBA;IACE,iCAAiC;ECx3hBnC;;ED23hBA;IACE,+BAA+B;EC53hBjC;;ED+3hBA;IACE,iCAAiC;ECh4hBnC;;EDm4hBA;IACE,+BAA+B;ECp4hBjC;;EDu4hBA;IACE,iCAAiC;ECx4hBnC;;ED24hBA;IACE,+BAA+B;EC54hBjC;;ED+4hBA;IACE,iCAAiC;ECh5hBnC;;EDm5hBA;IACE,+BAA+B;ECp5hBjC;;EDu5hBA;IACE,iCAAiC;ECx5hBnC;;ED25hBA;IACE,+BAA+B;EC55hBjC;;ED+5hBA;IACE,iCAAiC;ECh6hBnC;;EDm6hBA;IACE,+BAA+B;ECp6hBjC;;EDu6hBA;IACE,iCAAiC;ECx6hBnC;;ED26hBA;IACE,+BAA+B;EC56hBjC;;ED+6hBA;IACE,iCAAiC;EC75hBnC;;EDg6hBA;IACE,+BAA+B;EACjC;;EAEA;ICl6hBC,iCAAuC;EDo6hBxC;;ECt6hBA;IACC,6BAAc;IACd,8BAAe;EDy6hBhB;;EC36hBA;IACC,gCAAsC;IACtC,iCAAuC;ED86hBxC;;ECh7hBA;IACC,+BAAsC;IACtC,gCAAuC;EDm7hBxC;;ECr7hBA;IACC,6BAAsC;IACtC,8BAAuC;EDw7hBxC;;EC17hBA;IACC,+BAAsC;IACtC,gCAAuC;ED67hBxC;;EC/7hBA;IACC,6BAAsC;IACtC,8BAAuC;EDk8hBxC;;ECp8hBA;IACC,+BAAsC;IACtC,gCAAuC;EDu8hBxC;;ECz8hBA;IACC,6BAAsC;IACtC,8BAAuC;ED48hBxC;;EC98hBA;IACC,+BAAsC;IACtC,gCAAuC;EDi9hBxC;;ECn9hBA;IACC,6BAAsC;IACtC,8BAAuC;EDs9hBxC;;ECx9hBA;IACC,+BAAsC;IACtC,gCAAuC;ED29hBxC;;EC79hBA;IACC,6BAAsC;IACtC,8BAAuC;EDg+hBxC;;ECl+hBA;IACC,+BAAsC;IACtC,gCAAuC;EDq+hBxC;;ECv+hBA;IACC,6BAAsC;IACtC,8BAAuC;ED0+hBxC;;EC5+hBA;IACC,+BAAsC;IACtC,gCAAuC;ED++hBxC;;ECj/hBA;IACC,6BAAsC;IACtC,8BAAuC;EDo/hBxC;;ECt/hBA;IACC,+BAAsC;IACtC,gCAAuC;EDy/hBxC;;EC3/hBA;IACC,6BAAsC;IACtC,8BAAuC;ED8/hBxC;;EChgiBA;IACC,+BAAsC;IACtC,gCAAuC;EDmgiBxC;;ECrgiBA;IACC,6BAAc;IACd,8BAAe;EDwgiBhB;;EC1giBA;IACC,+BAAc;IACd,gCAAe;ED6giBhB;;EC/giBA;IACC,8BAAsC;IACtC,+BAAuC;EDkhiBxC;;ECphiBA;IACC,gCAAsC;IACtC,iCAAuC;EDuhiBxC;;ECzhiBA;IACC,8BAAsC;IACtC,+BAAuC;ED4hiBxC;;EC9hiBA;IACC,gCAAsC;IACtC,iCAAuC;EDiiiBxC;;ECniiBA;IACC,8BAAsC;IACtC,+BAAuC;EDsiiBxC;;ECxiiBA;IACC,gCAAsC;IACtC,iCAAuC;ED2iiBxC;;EC7iiBA;IACC,8BAAsC;IACtC,+BAAuC;EDgjiBxC;;ECljiBA;IACC,gCAAsC;IACtC,iCAAuC;EDqjiBxC;;ECvjiBA;IACC,8BAAsC;IACtC,+BAAuC;ED0jiBxC;;EC5jiBA;IACC,gCAAsC;IACtC,iCAAuC;ED+jiBxC;;ECjkiBA;IACC,8BAAsC;IACtC,+BAAuC;EDokiBxC;;ECtkiBA;IACC,gCAAsC;IACtC,iCAAuC;EDykiBxC;;EC3kiBA;IACC,8BAAsC;IACtC,+BAAuC;ED8kiBxC;;EChliBA;IACC,gCAAsC;IACtC,iCAAuC;EDmliBxC;;ECrliBA;IACC,8BAAsC;IACtC,+BAAuC;EDwliBxC;;EC1liBA;IACC,gCAAsC;IACtC,iCAAuC;ED6liBxC;;EC/liBA;IACC,8BAAsC;IACtC,+BAAuC;EDkmiBxC;;ECpmiBA;IACC,gCAAsC;IACtC,iCAAuC;EDumiBxC;;ECzmiBA;IACC,8BAAsC;IACtC,+BAAuC;ED4miBxC;;EC9miBA;IACC,gCAAsC;IACtC,iCAAuC;EDiniBxC;;ECnniBA;IACC,8BAAsC;IACtC,+BAAuC;EDsniBxC;;ECxniBA;IACC,gCAAsC;IACtC,iCAAuC;ED2niBxC;;EC7niBA;IACC,8BAAsC;IACtC,+BAAuC;EDgoiBxC;;ECloiBA;IACC,gCAAsC;IACtC,iCAAuC;EDqoiBxC;;ECvoiBA;IACC,8BAAsC;IACtC,+BAAuC;ED0oiBxC;;EC5oiBA;IACC,gCAAsC;IACtC,iCAAuC;ED+oiBxC;;ECjpiBA;IACC,8BAAsC;IACtC,+BAAuC;EDopiBxC;;ECtpiBA;IACC,gCAAsC;IACtC,iCAAuC;EDypiBxC;;EC3piBA;IACC,8BAAsC;IACtC,+BAAuC;ED8piBxC;;EChqiBA;IACC,gCAAsC;IACtC,iCAAuC;EDmqiBxC;;ECrqiBA;IACC,8BAAsC;IACtC,+BAAuC;EDwqiBxC;;EC1qiBA;IACC,gCAAsC;IACtC,iCAAuC;ED6qiBxC;;EC/qiBA;IACC,8BAAsC;IACtC,+BAAuC;EDkriBxC;;ECpriBA;IACC,gCAAsC;IACtC,iCAAuC;EDuriBxC;;ECzriBA;IACC,8BAAsC;IACtC,+BAAuC;ED4riBxC;;EC9riBA;IACC,gCAAsC;IACtC,iCAAuC;EDisiBxC;;ECnsiBA;IACC,8BAAsC;IACtC,+BAAuC;EDssiBxC;;ECxsiBA;IACC,gCAAsC;IACtC,iCAAuC;ED2siBxC;;EC7siBA;IACC,8BAAsC;IACtC,+BAAuC;EDgtiBxC;;ECltiBA;IACC,gCAAsC;IACtC,iCAAuC;EDqtiBxC;;ECvtiBA;IACC,8BAAsC;IACtC,+BAAuC;ED0tiBxC;;EC5tiBA;IACC,gCAAsC;IACtC,iCAAuC;ED+tiBxC;;ECjuiBA;IACC,8BAAsC;IACtC,+BAAuC;EDouiBxC;;ECtuiBA;IACC,gCAAsC;IACtC,iCAAuC;EDyuiBxC;;EC3uiBA;IACC,8BAAsC;IACtC,+BAAuC;ED8uiBxC;;EChviBA;IACC,gCAAsC;IACtC,iCAAuC;EDmviBxC;;ECrviBA;IACC,8BAAsC;IACtC,+BAAuC;EDwviBxC;;EC1viBA;IACC,gCAAsC;IACtC,iCAAuC;ED6viBxC;;EC/viBA;IACC,8BAAsC;IACtC,+BAAuC;EDkwiBxC;;ECpwiBA;IACC,gCAAsC;IACtC,iCAAuC;EDuwiBxC;;ECzwiBA;IACC,8BAAsC;IACtC,+BAAuC;ED4wiBxC;;EC9wiBA;IACC,gCAAsC;IACtC,iCAAuC;EDixiBxC;;ECnxiBA;IACC,8BAAsC;IACtC,+BAAuC;EDsxiBxC;;ECxxiBA;IACC,gCAAsC;IACtC,iCAAuC;ED2xiBxC;;EC7xiBA;IACC,8BAAsC;IACtC,+BAAuC;EDgyiBxC;;EClyiBA;IACC,gCAAsC;IACtC,iCAAuC;EDqyiBxC;;ECvyiBA;IACC,8BAAsC;IACtC,+BAAuC;ED0yiBxC;;EC5yiBA;IACC,gCAAsC;IACtC,iCAAuC;ED+yiBxC;;ECjziBA;IACC,8BAAsC;IACtC,+BAAuC;EDoziBxC;;ECtziBA;IACC,gCAAsC;IACtC,iCAAuC;EDyziBxC;;EC3ziBA;IACC,8BAAsC;IACtC,+BAAuC;ED8ziBxC;;ECh0iBA;IACC,gCAAsC;IACtC,iCAAuC;EDm0iBxC;;ECr0iBA;IACC,8BAAsC;IACtC,+BAAuC;EDw0iBxC;;EC10iBA;IACC,gCAAsC;IACtC,iCAAuC;ED60iBxC;;EC/0iBA;IACC,8BAAsC;IACtC,+BAAuC;EDk1iBxC;;ECp1iBA;IACC,gCAAsC;IACtC,iCAAuC;EDu1iBxC;;ECz1iBA;IACC,8BAAsC;IACtC,+BAAuC;ED41iBxC;;EC91iBA;IACC,gCAAsC;IACtC,iCAAuC;EDi2iBxC;;ECn2iBA;IACC,8BAAsC;IACtC,+BAAuC;EDs2iBxC;;ECx2iBA;IACC,gCAAsC;IACtC,iCAAuC;ED22iBxC;;EC72iBA;IACC,8BAAsC;IACtC,+BAAuC;EDg3iBxC;;ECl3iBA;IACC,gCAAsC;IACtC,iCAAuC;EDq3iBxC;;ECv3iBA;IACC,8BAAsC;IACtC,+BAAuC;ED03iBxC;;EC53iBA;IACC,gCAAsC;IACtC,iCAAuC;ED+3iBxC;;ECj4iBA;IACC,8BAAsC;IACtC,+BAAuC;EDo4iBxC;;ECt4iBA;IACC,gCAAsC;IACtC,iCAAuC;EDy4iBxC;;EC34iBA;IACC,8BAAsC;IACtC,+BAAuC;ED84iBxC;;ECh5iBA;IACC,gCAAsC;IACtC,iCAAuC;EDm5iBxC;;ECr5iBA;IACC,8BAAsC;IACtC,+BAAuC;EDw5iBxC;;EC15iBA;IACC,gCAAsC;IACtC,iCAAuC;ED65iBxC;;EC/5iBA;IACC,8BAAsC;IACtC,+BAAuC;EDk6iBxC;;ECp6iBA;IACC,gCAAsC;IACtC,iCAAuC;EDu6iBxC;;ECz6iBA;IACC,8BAAsC;IACtC,+BAAuC;ED46iBxC;;EC96iBA;IACC,gCAAsC;IACtC,iCAAuC;EDi7iBxC;;ECn7iBA;IACC,8BAAsC;IACtC,+BAAuC;EDs7iBxC;;ECx7iBA;IACC,gCAAsC;IACtC,iCAAuC;ED27iBxC;;EC77iBA;IACC,8BAAsC;IACtC,+BAAuC;EDg8iBxC;;ECl8iBA;IACC,gCAAsC;IACtC,iCAAuC;EDq8iBxC;;ECv8iBA;IACC,8BAAsC;IACtC,+BAAuC;ED08iBxC;;EC58iBA;IACC,gCAAsC;IACtC,iCAAuC;ED+8iBxC;;ECj9iBA;IACC,8BAAsC;IACtC,+BAAuC;EDo9iBxC;;ECt9iBA;IACC,gCAAsC;IACtC,iCAAuC;EDy9iBxC;;EC39iBA;IACC,8BAAsC;IACtC,+BAAuC;ED89iBxC;;ECh+iBA;IACC,gCAAsC;IACtC,iCAAuC;EDm+iBxC;;ECr+iBA;IACC,8BAAsC;IACtC,+BAAuC;EDw+iBxC;;EC1+iBA;IACC,gCAAsC;IACtC,iCAAuC;ED6+iBxC;;EC/+iBA;IACC,8BAAsC;IACtC,+BAAuC;EDk/iBxC;;ECp/iBA;IACC,gCAAsC;IACtC,iCAAuC;EDu/iBxC;;ECz/iBA;IACC,8BAAsC;IACtC,+BAAuC;ED4/iBxC;;EC9/iBA;IACC,gCAAsC;IACtC,iCAAuC;EDigjBxC;;ECngjBA;IACC,8BAAsC;IACtC,+BAAuC;EDsgjBxC;;ECxgjBA;IACC,gCAAsC;IACtC,iCAAuC;ED2gjBxC;;EC7gjBA;IACC,8BAAsC;IACtC,+BAAuC;EDghjBxC;;EClhjBA;IACC,gCAAsC;IACtC,iCAAuC;EDqhjBxC;;ECvhjBA;IACC,8BAAsC;IACtC,+BAAuC;ED0hjBxC;;EC5hjBA;IACC,gCAAsC;IACtC,iCAAuC;ED+hjBxC;;ECjijBA;IACC,8BAAsC;IACtC,+BAAuC;EDoijBxC;;ECtijBA;IACC,gCAAsC;IACtC,iCAAuC;EDyijBxC;;EC3ijBA;IACC,8BAAsC;IACtC,+BAAuC;ED8ijBxC;;EChjjBA;IACC,gCAAsC;IACtC,iCAAuC;EDmjjBxC;;ECrjjBA;IACC,8BAAsC;IACtC,+BAAuC;EDwjjBxC;;EC1jjBA;IACC,gCAAsC;IACtC,iCAAuC;ED6jjBxC;;EC/jjBA;IACC,8BAAsC;IACtC,+BAAuC;EDkkjBxC;;ECpkjBA;IACC,gCAAsC;IACtC,iCAAuC;EDukjBxC;;ECzkjBA;IACC,8BAAsC;IACtC,+BAAuC;ED4kjBxC;;EC9kjBA;IACC,gCAAsC;IACtC,iCAAuC;EDiljBxC;;ECnljBA;IACC,8BAAsC;IACtC,+BAAuC;EDsljBxC;;ECxljBA;IACC,gCAAsC;IACtC,iCAAuC;ED2ljBxC;;EC7ljBA;IACC,8BAAsC;IACtC,+BAAuC;EDgmjBxC;;EClmjBA;IACC,gCAAsC;IACtC,iCAAuC;EDqmjBxC;;ECvmjBA;IACC,8BAAsC;IACtC,+BAAuC;ED0mjBxC;;EC5mjBA;IACC,gCAAsC;IACtC,iCAAuC;ED+mjBxC;;ECjnjBA;IACC,8BAAsC;IACtC,+BAAuC;EDonjBxC;;ECtnjBA;IACC,gCAAsC;IACtC,iCAAuC;EDynjBxC;;EC3njBA;IACC,8BAAsC;IACtC,+BAAuC;ED8njBxC;;EChojBA;IACC,gCAAsC;IACtC,iCAAuC;EDmojBxC;;ECrojBA;IACC,8BAAsC;IACtC,+BAAuC;EDwojBxC;;EC1ojBA;IACC,gCAAsC;IACtC,iCAAuC;ED6ojBxC;;EC/ojBA;IACC,8BAAsC;IACtC,+BAAuC;EDkpjBxC;;ECppjBA;IACC,gCAAsC;IACtC,iCAAuC;EDupjBxC;;ECzpjBA;IACC,8BAAsC;IACtC,+BAAuC;ED4pjBxC;;EC9pjBA;IACC,gCAAsC;IACtC,iCAAuC;EDiqjBxC;;ECnqjBA;IACC,8BAAsC;IACtC,+BAAuC;EDsqjBxC;;ECxqjBA;IACC,gCAAsC;IACtC,iCAAuC;ED2qjBxC;;EC7qjBA;IACC,8BAAsC;IACtC,+BAAuC;EDgrjBxC;;EClrjBA;IACC,gCAAsC;IACtC,iCAAuC;EDqrjBxC;;ECvrjBA;IACC,8BAAsC;IACtC,+BAAuC;ED0rjBxC;;EC5rjBA;IACC,gCAAsC;IACtC,iCAAuC;ED+rjBxC;;EC7qjBA;IACC,8BAAqC;IACrC,+BAAwC;EDgrjBzC;;EClrjBA;IACC,gCAAqC;IACrC,iCAAgB;EDqrjBjB;;ECvrjBA;IACC,4BAAa;IACb,+BAAgB;ED0rjBjB;;EC5rjBA;IACC,+BAAqC;IACrC,kCAAwC;ED+rjBzC;;ECjsjBA;IACC,8BAAqC;IACrC,iCAAwC;EDosjBzC;;ECtsjBA;IACC,4BAAqC;IACrC,+BAAwC;EDysjBzC;;EC3sjBA;IACC,8BAAqC;IACrC,iCAAwC;ED8sjBzC;;EChtjBA;IACC,4BAAqC;IACrC,+BAAwC;EDmtjBzC;;ECrtjBA;IACC,8BAAqC;IACrC,iCAAwC;EDwtjBzC;;EC1tjBA;IACC,4BAAqC;IACrC,+BAAwC;ED6tjBzC;;EC/tjBA;IACC,8BAAqC;IACrC,iCAAwC;EDkujBzC;;ECpujBA;IACC,4BAAqC;IACrC,+BAAwC;EDuujBzC;;ECzujBA;IACC,8BAAqC;IACrC,iCAAwC;ED4ujBzC;;EC9ujBA;IACC,4BAAqC;IACrC,+BAAwC;EDivjBzC;;ECnvjBA;IACC,8BAAqC;IACrC,iCAAwC;EDsvjBzC;;ECxvjBA;IACC,4BAAqC;IACrC,+BAAwC;ED2vjBzC;;EC7vjBA;IACC,8BAAqC;IACrC,iCAAwC;EDgwjBzC;;EClwjBA;IACC,4BAAqC;IACrC,+BAAwC;EDqwjBzC;;ECvwjBA;IACC,8BAAqC;IACrC,iCAAwC;ED0wjBzC;;EC5wjBA;IACC,4BAAqC;IACrC,+BAAwC;ED+wjBzC;;ECjxjBA;IACC,8BAAqC;IACrC,iCAAwC;EDoxjBzC;;ECtxjBA;IACC,4BAAa;IACb,+BAAgB;EDyxjBjB;;EC3xjBA;IACC,8BAAa;IACb,iCAAgB;ED8xjBjB;;EChyjBA;IACC,6BAAqC;IACrC,gCAAwC;EDmyjBzC;;ECryjBA;IACC,+BAAqC;IACrC,kCAAwC;EDwyjBzC;;EC1yjBA;IACC,6BAAqC;IACrC,gCAAwC;ED6yjBzC;;EC/yjBA;IACC,+BAAqC;IACrC,kCAAwC;EDkzjBzC;;ECpzjBA;IACC,6BAAqC;IACrC,gCAAwC;EDuzjBzC;;ECzzjBA;IACC,+BAAqC;IACrC,kCAAwC;ED4zjBzC;;EC9zjBA;IACC,6BAAqC;IACrC,gCAAwC;EDi0jBzC;;ECn0jBA;IACC,+BAAqC;IACrC,kCAAwC;EDs0jBzC;;ECx0jBA;IACC,6BAAqC;IACrC,gCAAwC;ED20jBzC;;EC70jBA;IACC,+BAAqC;IACrC,kCAAwC;EDg1jBzC;;ECl1jBA;IACC,6BAAqC;IACrC,gCAAwC;EDq1jBzC;;ECv1jBA;IACC,+BAAqC;IACrC,kCAAwC;ED01jBzC;;EC51jBA;IACC,6BAAqC;IACrC,gCAAwC;ED+1jBzC;;ECj2jBA;IACC,+BAAqC;IACrC,kCAAwC;EDo2jBzC;;ECt2jBA;IACC,6BAAqC;IACrC,gCAAwC;EDy2jBzC;;EC32jBA;IACC,+BAAqC;IACrC,kCAAwC;ED82jBzC;;ECh3jBA;IACC,6BAAqC;IACrC,gCAAwC;EDm3jBzC;;ECr3jBA;IACC,+BAAqC;IACrC,kCAAwC;EDw3jBzC;;EC13jBA;IACC,6BAAqC;IACrC,gCAAwC;ED63jBzC;;EC/3jBA;IACC,+BAAqC;IACrC,kCAAwC;EDk4jBzC;;ECp4jBA;IACC,6BAAqC;IACrC,gCAAwC;EDu4jBzC;;ECz4jBA;IACC,+BAAqC;IACrC,kCAAwC;ED44jBzC;;EC94jBA;IACC,6BAAqC;IACrC,gCAAwC;EDi5jBzC;;ECn5jBA;IACC,+BAAqC;IACrC,kCAAwC;EDs5jBzC;;ECx5jBA;IACC,6BAAqC;IACrC,gCAAwC;ED25jBzC;;EC75jBA;IACC,+BAAqC;IACrC,kCAAwC;EDg6jBzC;;ECl6jBA;IACC,6BAAqC;IACrC,gCAAwC;EDq6jBzC;;ECv6jBA;IACC,+BAAqC;IACrC,kCAAwC;ED06jBzC;;EC56jBA;IACC,6BAAqC;IACrC,gCAAwC;ED+6jBzC;;ECj7jBA;IACC,+BAAqC;IACrC,kCAAwC;EDo7jBzC;;ECt7jBA;IACC,6BAAqC;IACrC,gCAAwC;EDy7jBzC;;EC37jBA;IACC,+BAAqC;IACrC,kCAAwC;ED87jBzC;;ECh8jBA;IACC,6BAAqC;IACrC,gCAAwC;EDm8jBzC;;ECr8jBA;IACC,+BAAqC;IACrC,kCAAwC;EDw8jBzC;;EC18jBA;IACC,6BAAqC;IACrC,gCAAwC;ED68jBzC;;EC/8jBA;IACC,+BAAqC;IACrC,kCAAwC;EDk9jBzC;;ECp9jBA;IACC,6BAAqC;IACrC,gCAAwC;EDu9jBzC;;ECz9jBA;IACC,+BAAqC;IACrC,kCAAwC;ED49jBzC;;EC99jBA;IACC,6BAAqC;IACrC,gCAAwC;EDi+jBzC;;ECn+jBA;IACC,+BAAqC;IACrC,kCAAwC;EDs+jBzC;;ECx+jBA;IACC,6BAAqC;IACrC,gCAAwC;ED2+jBzC;;EC7+jBA;IACC,+BAAqC;IACrC,kCAAwC;EDg/jBzC;;ECl/jBA;IACC,6BAAqC;IACrC,gCAAwC;EDq/jBzC;;ECv/jBA;IACC,+BAAqC;IACrC,kCAAwC;ED0/jBzC;;EC5/jBA;IACC,6BAAqC;IACrC,gCAAwC;ED+/jBzC;;ECjgkBA;IACC,+BAAqC;IACrC,kCAAwC;EDogkBzC;;ECtgkBA;IACC,6BAAqC;IACrC,gCAAwC;EDygkBzC;;EC3gkBA;IACC,+BAAqC;IACrC,kCAAwC;ED8gkBzC;;EChhkBA;IACC,6BAAqC;IACrC,gCAAwC;EDmhkBzC;;ECrhkBA;IACC,+BAAqC;IACrC,kCAAwC;EDwhkBzC;;EC1hkBA;IACC,6BAAqC;IACrC,gCAAwC;ED6hkBzC;;EC/hkBA;IACC,+BAAqC;IACrC,kCAAwC;EDkikBzC;;ECpikBA;IACC,6BAAqC;IACrC,gCAAwC;EDuikBzC;;ECzikBA;IACC,+BAAqC;IACrC,kCAAwC;ED4ikBzC;;EC9ikBA;IACC,6BAAqC;IACrC,gCAAwC;EDijkBzC;;ECnjkBA;IACC,+BAAqC;IACrC,kCAAwC;EDsjkBzC;;ECxjkBA;IACC,6BAAqC;IACrC,gCAAwC;ED2jkBzC;;EC7jkBA;IACC,+BAAqC;IACrC,kCAAwC;EDgkkBzC;;EClkkBA;IACC,6BAAqC;IACrC,gCAAwC;EDqkkBzC;;ECvkkBA;IACC,+BAAqC;IACrC,kCAAwC;ED0kkBzC;;EC5kkBA;IACC,6BAAqC;IACrC,gCAAwC;ED+kkBzC;;ECjlkBA;IACC,+BAAqC;IACrC,kCAAwC;EDolkBzC;;ECtlkBA;IACC,6BAAqC;IACrC,gCAAwC;EDylkBzC;;EC3lkBA;IACC,+BAAqC;IACrC,kCAAwC;ED8lkBzC;;EChmkBA;IACC,6BAAqC;IACrC,gCAAwC;EDmmkBzC;;ECrmkBA;IACC,+BAAqC;IACrC,kCAAwC;EDwmkBzC;;EC1mkBA;IACC,6BAAqC;IACrC,gCAAwC;ED6mkBzC;;EC/mkBA;IACC,+BAAqC;IACrC,kCAAwC;EDknkBzC;;ECpnkBA;IACC,6BAAqC;IACrC,gCAAwC;EDunkBzC;;ECznkBA;IACC,+BAAqC;IACrC,kCAAwC;ED4nkBzC;;EC9nkBA;IACC,6BAAqC;IACrC,gCAAwC;EDiokBzC;;ECnokBA;IACC,+BAAqC;IACrC,kCAAwC;EDsokBzC;;ECxokBA;IACC,6BAAqC;IACrC,gCAAwC;ED2okBzC;;EC7okBA;IACC,+BAAqC;IACrC,kCAAwC;EDgpkBzC;;EClpkBA;IACC,6BAAqC;IACrC,gCAAwC;EDqpkBzC;;ECvpkBA;IACC,+BAAqC;IACrC,kCAAwC;ED0pkBzC;;EC5pkBA;IACC,6BAAqC;IACrC,gCAAwC;ED+pkBzC;;ECjqkBA;IACC,+BAAqC;IACrC,kCAAwC;EDoqkBzC;;ECtqkBA;IACC,6BAAqC;IACrC,gCAAwC;EDyqkBzC;;EC3qkBA;IACC,+BAAqC;IACrC,kCAAwC;ED8qkBzC;;EChrkBA;IACC,6BAAqC;IACrC,gCAAwC;EDmrkBzC;;ECrrkBA;IACC,+BAAqC;IACrC,kCAAwC;EDwrkBzC;;EC1rkBA;IACC,6BAAqC;IACrC,gCAAwC;ED6rkBzC;;EC/rkBA;IACC,+BAAqC;IACrC,kCAAwC;EDkskBzC;;ECpskBA;IACC,6BAAqC;IACrC,gCAAwC;EDuskBzC;;ECzskBA;IACC,+BAAqC;IACrC,kCAAwC;ED4skBzC;;EC9skBA;IACC,6BAAqC;IACrC,gCAAwC;EDitkBzC;;ECntkBA;IACC,+BAAqC;IACrC,kCAAwC;EDstkBzC;;ECxtkBA;IACC,6BAAqC;IACrC,gCAAwC;ED2tkBzC;;EC7tkBA;IACC,+BAAqC;IACrC,kCAAwC;EDgukBzC;;EClukBA;IACC,6BAAqC;IACrC,gCAAwC;EDqukBzC;;ECvukBA;IACC,+BAAqC;IACrC,kCAAwC;ED0ukBzC;;EC5ukBA;IACC,6BAAqC;IACrC,gCAAwC;ED+ukBzC;;ECjvkBA;IACC,+BAAqC;IACrC,kCAAwC;EDovkBzC;;ECtvkBA;IACC,6BAAqC;IACrC,gCAAwC;EDyvkBzC;;EC3vkBA;IACC,+BAAqC;IACrC,kCAAwC;ED8vkBzC;;EChwkBA;IACC,6BAAqC;IACrC,gCAAwC;EDmwkBzC;;ECrwkBA;IACC,+BAAqC;IACrC,kCAAwC;EDwwkBzC;;EC1wkBA;IACC,6BAAqC;IACrC,gCAAwC;ED6wkBzC;;EC/wkBA;IACC,+BAAqC;IACrC,kCAAwC;EDkxkBzC;;ECpxkBA;IACC,6BAAqC;IACrC,gCAAwC;EDuxkBzC;;ECzxkBA;IACC,+BAAqC;IACrC,kCAAwC;ED4xkBzC;;EC9xkBA;IACC,6BAAqC;IACrC,gCAAwC;EDiykBzC;;ECnykBA;IACC,+BAAqC;IACrC,kCAAwC;EDsykBzC;;ECxykBA;IACC,6BAAqC;IACrC,gCAAwC;ED2ykBzC;;EC7ykBA;IACC,+BAAqC;IACrC,kCAAwC;EDgzkBzC;;EClzkBA;IACC,6BAAqC;IACrC,gCAAwC;EDqzkBzC;;ECvzkBA;IACC,+BAAqC;IACrC,kCAAwC;ED0zkBzC;;EC5zkBA;IACC,6BAAqC;IACrC,gCAAwC;ED+zkBzC;;ECj0kBA;IACC,+BAAqC;IACrC,kCAAwC;EDo0kBzC;;ECt0kBA;IACC,6BAAqC;IACrC,gCAAwC;EDy0kBzC;;EC30kBA;IACC,+BAAqC;IACrC,kCAAwC;ED80kBzC;;ECh1kBA;IACC,6BAAqC;IACrC,gCAAwC;EDm1kBzC;;ECr1kBA;IACC,+BAAqC;IACrC,kCAAwC;EDw1kBzC;;EC11kBA;IACC,6BAAqC;IACrC,gCAAwC;ED61kBzC;;EC/1kBA;IACC,+BAAqC;IACrC,kCAAwC;EDk2kBzC;;ECp2kBA;IACC,6BAAqC;IACrC,gCAAwC;EDu2kBzC;;ECz2kBA;IACC,+BAAqC;IACrC,kCAAwC;ED42kBzC;;EC92kBA;IACC,6BAAqC;IACrC,gCAAwC;EDi3kBzC;;ECn3kBA;IACC,+BAAqC;IACrC,kCAAwC;EDs3kBzC;;ECx3kBA;IACC,6BAAqC;IACrC,gCAAwC;ED23kBzC;;EC73kBA;IACC,+BAAqC;IACrC,kCAAwC;EDg4kBzC;;ECl4kBA;IACC,6BAAqC;IACrC,gCAAwC;EDq4kBzC;;ECv4kBA;IACC,+BAAqC;IACrC,kCAAwC;ED04kBzC;;EC54kBA;IACC,6BAAqC;IACrC,gCAAwC;ED+4kBzC;;ECj5kBA;IACC,+BAAqC;IACrC,kCAAwC;EDo5kBzC;;ECt5kBA;IACC,6BAAqC;IACrC,gCAAwC;EDy5kBzC;;EC35kBA;IACC,+BAAqC;IACrC,kCAAwC;ED85kBzC;;ECh6kBA;IACC,6BAAqC;IACrC,gCAAwC;EDm6kBzC;;ECr6kBA;IACC,+BAAqC;IACrC,kCAAwC;EDw6kBzC;;EC16kBA;IACC,6BAAqC;IACrC,gCAAwC;ED66kBzC;;EC/6kBA;IACC,+BAAqC;IACrC,kCAAwC;EDk7kBzC;;ECp7kBA;IACC,6BAAqC;IACrC,gCAAwC;EDu7kBzC;;ECz7kBA;IACC,+BAAqC;IACrC,kCAAwC;ED47kBzC;;EC97kBA;IACC,6BAAqC;IACrC,gCAAwC;EDi8kBzC;;ECn8kBA;IACC,+BAAqC;IACrC,kCAAwC;EDs8kBzC;;ECx8kBA;IACC,6BAAqC;IACrC,gCAAwC;ED28kBzC;;EC78kBA;IACC,+BAAqC;IACrC,kCAAwC;EDg9kBzC;;EC18kBF;IAaE,6BAAc;IACb,gCAAiC;EDi8kBlC;;ECl8kBA;IACC,+BAAiC;IDq8kBhC,kCAAkC;EACpC;AACF;AACA;EACE;IACE,wBAAwB;EC38kB1B;;ED88kBA;IACE,2BAA2B;EC/8kB7B;;EDk9kBA;IACE,0BAA0B;ECn9kB5B;;EDs9kBA;IACE,wBAAwB;ECv9kB1B;;ED09kBA;IACE,0BAA0B;EC39kB5B;;ED89kBA;IACE,wBAAwB;EC/9kB1B;;EDk+kBA;IACE,0BAA0B;ECn+kB5B;;EDs+kBA;IACE,wBAAwB;ECv+kB1B;;ED0+kBA;IACE,0BAA0B;EC3+kB5B;;ED8+kBA;IACE,wBAAwB;EC/+kB1B;;EDk/kBA;IACE,0BAA0B;ECn/kB5B;;EDs/kBA;IACE,wBAAwB;ECv/kB1B;;ED0/kBA;IACE,0BAA0B;EC3/kB5B;;ED8/kBA;IACE,wBAAwB;EC//kB1B;;EDkglBA;IACE,0BAA0B;ECnglB5B;;EDsglBA;IACE,wBAAwB;ECvglB1B;;ED0glBA;IACE,0BAA0B;EC3glB5B;;ED8glBA;IACE,wBAAwB;EC/glB1B;;EDkhlBA;IACE,0BAA0B;ECnhlB5B;;EDshlBA;IACE,wBAAwB;ECvhlB1B;;ED0hlBA;IACE,0BAA0B;EC3hlB5B;;ED8hlBA;IACE,yBAAyB;EC/hlB3B;;EDkilBA;IACE,2BAA2B;ECnilB7B;;EDsilBA;IACE,yBAAyB;ECvilB3B;;ED0ilBA;IACE,2BAA2B;EC3ilB7B;;ED8ilBA;IACE,yBAAyB;EC/ilB3B;;EDkjlBA;IACE,2BAA2B;ECnjlB7B;;EDsjlBA;IACE,yBAAyB;ECvjlB3B;;ED0jlBA;IACE,2BAA2B;EC3jlB7B;;ED8jlBA;IACE,yBAAyB;EC/jlB3B;;EDkklBA;IACE,2BAA2B;ECnklB7B;;EDsklBA;IACE,yBAAyB;ECvklB3B;;ED0klBA;IACE,2BAA2B;EC3klB7B;;ED8klBA;IACE,yBAAyB;EC/klB3B;;EDkllBA;IACE,2BAA2B;ECnllB7B;;EDsllBA;IACE,yBAAyB;ECvllB3B;;ED0llBA;IACE,2BAA2B;EC3llB7B;;ED8llBA;IACE,yBAAyB;EC/llB3B;;EDkmlBA;IACE,2BAA2B;ECnmlB7B;;EDsmlBA;IACE,yBAAyB;ECvmlB3B;;ED0mlBA;IACE,2BAA2B;EC3mlB7B;;ED8mlBA;IACE,yBAAyB;EC/mlB3B;;EDknlBA;IACE,2BAA2B;ECnnlB7B;;EDsnlBA;IACE,yBAAyB;ECvnlB3B;;ED0nlBA;IACE,2BAA2B;EC3nlB7B;;ED8nlBA;IACE,yBAAyB;EC/nlB3B;;EDkolBA;IACE,2BAA2B;ECnolB7B;;EDsolBA;IACE,yBAAyB;ECvolB3B;;ED0olBA;IACE,2BAA2B;EC3olB7B;;ED8olBA;IACE,yBAAyB;EC/olB3B;;EDkplBA;IACE,2BAA2B;ECnplB7B;;EDsplBA;IACE,yBAAyB;ECvplB3B;;ED0plBA;IACE,2BAA2B;EC3plB7B;;ED8plBA;IACE,yBAAyB;EC/plB3B;;EDkqlBA;IACE,2BAA2B;ECnqlB7B;;EDsqlBA;IACE,yBAAyB;ECvqlB3B;;ED0qlBA;IACE,2BAA2B;EC3qlB7B;;ED8qlBA;IACE,yBAAyB;EC/qlB3B;;EDkrlBA;IACE,2BAA2B;ECnrlB7B;;EDsrlBA;IACE,yBAAyB;ECvrlB3B;;ED0rlBA;IACE,2BAA2B;EC3rlB7B;;ED8rlBA;IACE,yBAAyB;EC/rlB3B;;EDkslBA;IACE,2BAA2B;ECnslB7B;;EDsslBA;IACE,yBAAyB;ECvslB3B;;ED0slBA;IACE,2BAA2B;EC3slB7B;;ED8slBA;IACE,yBAAyB;EC/slB3B;;EDktlBA;IACE,2BAA2B;ECntlB7B;;EDstlBA;IACE,yBAAyB;ECvtlB3B;;ED0tlBA;IACE,2BAA2B;EC3tlB7B;;ED8tlBA;IACE,yBAAyB;EC/tlB3B;;EDkulBA;IACE,2BAA2B;ECnulB7B;;EDsulBA;IACE,yBAAyB;ECvulB3B;;ED0ulBA;IACE,2BAA2B;EC3ulB7B;;ED8ulBA;IACE,yBAAyB;EC/ulB3B;;EDkvlBA;IACE,2BAA2B;ECnvlB7B;;EDsvlBA;IACE,yBAAyB;ECvvlB3B;;ED0vlBA;IACE,2BAA2B;EC3vlB7B;;ED8vlBA;IACE,yBAAyB;EC/vlB3B;;EDkwlBA;IACE,2BAA2B;ECnwlB7B;;EDswlBA;IACE,yBAAyB;ECvwlB3B;;ED0wlBA;IACE,2BAA2B;EC3wlB7B;;ED8wlBA;IACE,yBAAyB;EC/wlB3B;;EDkxlBA;IACE,2BAA2B;ECnxlB7B;;EDsxlBA;IACE,yBAAyB;ECvxlB3B;;ED0xlBA;IACE,2BAA2B;EC3xlB7B;;ED8xlBA;IACE,yBAAyB;EC/xlB3B;;EDkylBA;IACE,2BAA2B;ECnylB7B;;EDsylBA;IACE,yBAAyB;ECvylB3B;;ED0ylBA;IACE,2BAA2B;EC3ylB7B;;ED8ylBA;IACE,yBAAyB;EC/ylB3B;;EDkzlBA;IACE,2BAA2B;ECnzlB7B;;EDszlBA;IACE,yBAAyB;ECvzlB3B;;ED0zlBA;IACE,2BAA2B;EC3zlB7B;;ED8zlBA;IACE,yBAAyB;EC/zlB3B;;EDk0lBA;IACE,2BAA2B;ECn0lB7B;;EDs0lBA;IACE,yBAAyB;ECv0lB3B;;ED00lBA;IACE,2BAA2B;EC30lB7B;;ED80lBA;IACE,yBAAyB;EC/0lB3B;;EDk1lBA;IACE,2BAA2B;ECn1lB7B;;EDs1lBA;IACE,yBAAyB;ECv1lB3B;;ED01lBA;IACE,2BAA2B;EC31lB7B;;ED81lBA;IACE,yBAAyB;EC/1lB3B;;EDk2lBA;IACE,2BAA2B;ECn2lB7B;;EDs2lBA;IACE,yBAAyB;ECv2lB3B;;ED02lBA;IACE,2BAA2B;EC32lB7B;;ED82lBA;IACE,yBAAyB;EC/2lB3B;;EDk3lBA;IACE,2BAA2B;ECn3lB7B;;EDs3lBA;IACE,yBAAyB;ECv3lB3B;;ED03lBA;IACE,2BAA2B;EC33lB7B;;ED83lBA;IACE,yBAAyB;EC/3lB3B;;EDk4lBA;IACE,2BAA2B;ECn4lB7B;;EDs4lBA;IACE,yBAAyB;ECv4lB3B;;ED04lBA;IACE,2BAA2B;EC34lB7B;;ED84lBA;IACE,yBAAyB;EC/4lB3B;;EDk5lBA;IACE,2BAA2B;ECn5lB7B;;EDs5lBA;IACE,yBAAyB;ECv5lB3B;;ED05lBA;IACE,2BAA2B;EC35lB7B;;ED85lBA;IACE,yBAAyB;EC/5lB3B;;EDk6lBA;IACE,2BAA2B;ECn6lB7B;;EDs6lBA;IACE,yBAAyB;ECv6lB3B;;ED06lBA;IACE,2BAA2B;EC36lB7B;;ED86lBA;IACE,yBAAyB;EC/6lB3B;;EDk7lBA;IACE,2BAA2B;ECn7lB7B;;EDs7lBA;IACE,yBAAyB;ECv7lB3B;;ED07lBA;IACE,2BAA2B;EC37lB7B;;ED87lBA;IACE,yBAAyB;EC/7lB3B;;EDk8lBA;IACE,2BAA2B;ECn8lB7B;;EDs8lBA;IACE,yBAAyB;ECv8lB3B;;ED08lBA;IACE,2BAA2B;EC38lB7B;;ED88lBA;IACE,yBAAyB;EC/8lB3B;;EDk9lBA;IACE,2BAA2B;ECn9lB7B;;EDs9lBA;IACE,yBAAyB;ECv9lB3B;;ED09lBA;IACE,2BAA2B;EC39lB7B;;ED89lBA;IACE,yBAAyB;EC/9lB3B;;EDk+lBA;IACE,2BAA2B;ECn+lB7B;;EDs+lBA;IACE,yBAAyB;ECv+lB3B;;ED0+lBA;IACE,2BAA2B;EC3+lB7B;;ED8+lBA;IACE,yBAAyB;EC/+lB3B;;EDk/lBA;IACE,2BAA2B;ECn/lB7B;;EDs/lBA;IACE,yBAAyB;ECv/lB3B;;ED0/lBA;IACE,2BAA2B;EC3/lB7B;;ED8/lBA;IACE,yBAAyB;EC//lB3B;;EDkgmBA;IACE,2BAA2B;ECngmB7B;;EDsgmBA;IACE,yBAAyB;ECvgmB3B;;ED0gmBA;IACE,2BAA2B;EC3gmB7B;;ED8gmBA;IACE,yBAAyB;EC/gmB3B;;EDkhmBA;IACE,2BAA2B;ECnhmB7B;;EDshmBA;IACE,yBAAyB;ECvhmB3B;;ED0hmBA;IACE,2BAA2B;EC3hmB7B;;ED8hmBA;IACE,yBAAyB;EC/hmB3B;;EDkimBA;IACE,2BAA2B;ECnimB7B;;EDsimBA;IACE,yBAAyB;ECvimB3B;;ED0imBA;IACE,2BAA2B;EC3imB7B;;ED8imBA;IACE,yBAAyB;EC/imB3B;;EDkjmBA;IACE,2BAA2B;ECnjmB7B;;EDsjmBA;IACE,yBAAyB;ECvjmB3B;;ED0jmBA;IACE,2BAA2B;EC3jmB7B;;ED8jmBA;IACE,yBAAyB;EC/jmB3B;;EDkkmBA;IACE,2BAA2B;EChjmB7B;;EDmjmBA;IACE,yBAAyB;ECpjmB3B;;EDujmBA;IACE,2BAA2B;ECxjmB7B;;ED2jmBA;IACE,4BAA4B;EC5jmB9B;;ED+jmBA;IACE,+BAA+B;EChkmBjC;;EDmkmBA;IACE,8BAA8B;ECpkmBhC;;EDukmBA;IACE,4BAA4B;ECxkmB9B;;ED2kmBA;IACE,8BAA8B;EC5kmBhC;;ED+kmBA;IACE,4BAA4B;EChlmB9B;;EDmlmBA;IACE,8BAA8B;ECplmBhC;;EDulmBA;IACE,4BAA4B;ECxlmB9B;;ED2lmBA;IACE,8BAA8B;EC5lmBhC;;ED+lmBA;IACE,4BAA4B;EChmmB9B;;EDmmmBA;IACE,8BAA8B;ECpmmBhC;;EDummBA;IACE,4BAA4B;ECxmmB9B;;ED2mmBA;IACE,8BAA8B;EC5mmBhC;;ED+mmBA;IACE,4BAA4B;EChnmB9B;;EDmnmBA;IACE,8BAA8B;ECpnmBhC;;EDunmBA;IACE,4BAA4B;ECxnmB9B;;ED2nmBA;IACE,8BAA8B;EC5nmBhC;;ED+nmBA;IACE,4BAA4B;EChomB9B;;EDmomBA;IACE,8BAA8B;ECpomBhC;;EDuomBA;IACE,4BAA4B;ECxomB9B;;ED2omBA;IACE,8BAA8B;EC5omBhC;;ED+omBA;IACE,6BAA6B;EChpmB/B;;EDmpmBA;IACE,+BAA+B;ECppmBjC;;EDupmBA;IACE,6BAA6B;ECxpmB/B;;ED2pmBA;IACE,+BAA+B;EC5pmBjC;;ED+pmBA;IACE,6BAA6B;EChqmB/B;;EDmqmBA;IACE,+BAA+B;ECpqmBjC;;EDuqmBA;IACE,6BAA6B;ECxqmB/B;;ED2qmBA;IACE,+BAA+B;EC5qmBjC;;ED+qmBA;IACE,6BAA6B;EChrmB/B;;EDmrmBA;IACE,+BAA+B;ECprmBjC;;EDurmBA;IACE,6BAA6B;ECxrmB/B;;ED2rmBA;IACE,+BAA+B;EC5rmBjC;;ED+rmBA;IACE,6BAA6B;EChsmB/B;;EDmsmBA;IACE,+BAA+B;ECpsmBjC;;EDusmBA;IACE,6BAA6B;ECxsmB/B;;ED2smBA;IACE,+BAA+B;EC5smBjC;;ED+smBA;IACE,6BAA6B;EChtmB/B;;EDmtmBA;IACE,+BAA+B;ECptmBjC;;EDutmBA;IACE,6BAA6B;ECxtmB/B;;ED2tmBA;IACE,+BAA+B;EC5tmBjC;;ED+tmBA;IACE,6BAA6B;EChumB/B;;EDmumBA;IACE,+BAA+B;ECpumBjC;;EDuumBA;IACE,6BAA6B;ECxumB/B;;ED2umBA;IACE,+BAA+B;EC5umBjC;;ED+umBA;IACE,6BAA6B;EChvmB/B;;EDmvmBA;IACE,+BAA+B;ECpvmBjC;;EDuvmBA;IACE,6BAA6B;ECxvmB/B;;ED2vmBA;IACE,+BAA+B;EC5vmBjC;;ED+vmBA;IACE,6BAA6B;EChwmB/B;;EDmwmBA;IACE,+BAA+B;ECpwmBjC;;EDuwmBA;IACE,6BAA6B;ECxwmB/B;;ED2wmBA;IACE,+BAA+B;EC5wmBjC;;ED+wmBA;IACE,6BAA6B;EChxmB/B;;EDmxmBA;IACE,+BAA+B;ECpxmBjC;;EDuxmBA;IACE,6BAA6B;ECxxmB/B;;ED2xmBA;IACE,+BAA+B;EC5xmBjC;;ED+xmBA;IACE,6BAA6B;EChymB/B;;EDmymBA;IACE,+BAA+B;ECpymBjC;;EDuymBA;IACE,6BAA6B;ECxymB/B;;ED2ymBA;IACE,+BAA+B;EC5ymBjC;;ED+ymBA;IACE,6BAA6B;EChzmB/B;;EDmzmBA;IACE,+BAA+B;ECpzmBjC;;EDuzmBA;IACE,6BAA6B;ECxzmB/B;;ED2zmBA;IACE,+BAA+B;EC5zmBjC;;ED+zmBA;IACE,6BAA6B;ECh0mB/B;;EDm0mBA;IACE,+BAA+B;ECp0mBjC;;EDu0mBA;IACE,6BAA6B;ECx0mB/B;;ED20mBA;IACE,+BAA+B;EC50mBjC;;ED+0mBA;IACE,6BAA6B;ECh1mB/B;;EDm1mBA;IACE,+BAA+B;ECp1mBjC;;EDu1mBA;IACE,6BAA6B;ECx1mB/B;;ED21mBA;IACE,+BAA+B;EC51mBjC;;ED+1mBA;IACE,6BAA6B;ECh2mB/B;;EDm2mBA;IACE,+BAA+B;ECp2mBjC;;EDu2mBA;IACE,6BAA6B;ECx2mB/B;;ED22mBA;IACE,+BAA+B;EC52mBjC;;ED+2mBA;IACE,6BAA6B;ECh3mB/B;;EDm3mBA;IACE,+BAA+B;ECp3mBjC;;EDu3mBA;IACE,6BAA6B;ECx3mB/B;;ED23mBA;IACE,+BAA+B;EC53mBjC;;ED+3mBA;IACE,6BAA6B;ECh4mB/B;;EDm4mBA;IACE,+BAA+B;ECp4mBjC;;EDu4mBA;IACE,6BAA6B;ECx4mB/B;;ED24mBA;IACE,+BAA+B;EC54mBjC;;ED+4mBA;IACE,6BAA6B;ECh5mB/B;;EDm5mBA;IACE,+BAA+B;ECp5mBjC;;EDu5mBA;IACE,6BAA6B;ECx5mB/B;;ED25mBA;IACE,+BAA+B;EC55mBjC;;ED+5mBA;IACE,6BAA6B;ECh6mB/B;;EDm6mBA;IACE,+BAA+B;ECp6mBjC;;EDu6mBA;IACE,6BAA6B;ECx6mB/B;;ED26mBA;IACE,+BAA+B;EC56mBjC;;ED+6mBA;IACE,6BAA6B;ECh7mB/B;;EDm7mBA;IACE,+BAA+B;ECp7mBjC;;EDu7mBA;IACE,6BAA6B;ECx7mB/B;;ED27mBA;IACE,+BAA+B;EC57mBjC;;ED+7mBA;IACE,6BAA6B;ECh8mB/B;;EDm8mBA;IACE,+BAA+B;ECp8mBjC;;EDu8mBA;IACE,6BAA6B;ECx8mB/B;;ED28mBA;IACE,+BAA+B;EC58mBjC;;ED+8mBA;IACE,6BAA6B;ECh9mB/B;;EDm9mBA;IACE,+BAA+B;ECp9mBjC;;EDu9mBA;IACE,6BAA6B;ECx9mB/B;;ED29mBA;IACE,+BAA+B;EC59mBjC;;ED+9mBA;IACE,6BAA6B;ECh+mB/B;;EDm+mBA;IACE,+BAA+B;ECp+mBjC;;EDu+mBA;IACE,6BAA6B;ECx+mB/B;;ED2+mBA;IACE,+BAA+B;EC5+mBjC;;ED++mBA;IACE,6BAA6B;ECh/mB/B;;EDm/mBA;IACE,+BAA+B;ECp/mBjC;;EDu/mBA;IACE,6BAA6B;ECx/mB/B;;ED2/mBA;IACE,+BAA+B;EC5/mBjC;;ED+/mBA;IACE,6BAA6B;EChgnB/B;;EDmgnBA;IACE,+BAA+B;ECpgnBjC;;EDugnBA;IACE,6BAA6B;ECxgnB/B;;ED2gnBA;IACE,+BAA+B;EC5gnBjC;;ED+gnBA;IACE,6BAA6B;EChhnB/B;;EDmhnBA;IACE,+BAA+B;ECphnBjC;;EDuhnBA;IACE,6BAA6B;ECxhnB/B;;ED2hnBA;IACE,+BAA+B;EC5hnBjC;;ED+hnBA;IACE,6BAA6B;EChinB/B;;EDminBA;IACE,+BAA+B;ECpinBjC;;EDuinBA;IACE,6BAA6B;ECxinB/B;;ED2inBA;IACE,+BAA+B;EC5inBjC;;ED+inBA;IACE,6BAA6B;EChjnB/B;;EDmjnBA;IACE,+BAA+B;ECpjnBjC;;EDujnBA;IACE,6BAA6B;ECxjnB/B;;ED2jnBA;IACE,+BAA+B;EC5jnBjC;;ED+jnBA;IACE,6BAA6B;EChknB/B;;EDmknBA;IACE,+BAA+B;ECpknBjC;;EDuknBA;IACE,6BAA6B;ECxknB/B;;ED2knBA;IACE,+BAA+B;EC5knBjC;;ED+knBA;IACE,6BAA6B;EChlnB/B;;EDmlnBA;IACE,+BAA+B;ECplnBjC;;EDulnBA;IACE,6BAA6B;ECxlnB/B;;ED2lnBA;IACE,+BAA+B;EC5lnBjC;;ED+lnBA;IACE,6BAA6B;EChmnB/B;;EDmmnBA;IACE,+BAA+B;ECpmnBjC;;EDumnBA;IACE,6BAA6B;ECxmnB/B;;ED2mnBA;IACE,+BAA+B;EC5mnBjC;;ED+mnBA;IACE,6BAA6B;EChnnB/B;;EDmnnBA;IACE,+BAA+B;ECpnnBjC;;EDunnBA;IACE,6BAA6B;ECxnnB/B;;ED2nnBA;IACE,+BAA+B;EC5nnBjC;;ED+nnBA;IACE,6BAA6B;EChonB/B;;EDmonBA;IACE,+BAA+B;ECponBjC;;EDuonBA;IACE,6BAA6B;ECxonB/B;;ED2onBA;IACE,+BAA+B;EC5onBjC;;ED+onBA;IACE,6BAA6B;EChpnB/B;;EDmpnBA;IACE,+BAA+B;ECppnBjC;;EDupnBA;IACE,6BAA6B;ECxpnB/B;;ED2pnBA;IACE,+BAA+B;EC5pnBjC;;ED+pnBA;IACE,6BAA6B;EChqnB/B;;EDmqnBA;IACE,+BAA+B;ECpqnBjC;;EDuqnBA;IACE,6BAA6B;ECxqnB/B;;ED2qnBA;IACE,+BAA+B;EC5qnBjC;;ED+qnBA;IACE,6BAA6B;EChrnB/B;;EDmrnBA;IACE,+BAA+B;ECjqnBjC;;EDoqnBA;IACE,6BAA6B;ECrqnB/B;;EDwqnBA;IACE,+BAA+B;ECzqnBjC;;ED4qnBA;IACE,+BAA+B;EC7qnBjC;;EDgrnBA;IACE,kCAAkC;ECjrnBpC;;EDornBA;IACE,iCAAiC;ECrrnBnC;;EDwrnBA;IACE,+BAA+B;ECzrnBjC;;ED4rnBA;IACE,iCAAiC;EC7rnBnC;;EDgsnBA;IACE,+BAA+B;ECjsnBjC;;EDosnBA;IACE,iCAAiC;ECrsnBnC;;EDwsnBA;IACE,+BAA+B;ECzsnBjC;;ED4snBA;IACE,iCAAiC;EC7snBnC;;EDgtnBA;IACE,+BAA+B;ECjtnBjC;;EDotnBA;IACE,iCAAiC;ECrtnBnC;;EDwtnBA;IACE,+BAA+B;ECztnBjC;;ED4tnBA;IACE,iCAAiC;EC7tnBnC;;EDgunBA;IACE,+BAA+B;ECjunBjC;;EDounBA;IACE,iCAAiC;ECrunBnC;;EDwunBA;IACE,+BAA+B;ECzunBjC;;ED4unBA;IACE,iCAAiC;EC7unBnC;;EDgvnBA;IACE,+BAA+B;ECjvnBjC;;EDovnBA;IACE,iCAAiC;ECrvnBnC;;EDwvnBA;IACE,+BAA+B;ECzvnBjC;;ED4vnBA;IACE,iCAAiC;EC7vnBnC;;EDgwnBA;IACE,gCAAgC;ECjwnBlC;;EDownBA;IACE,kCAAkC;ECrwnBpC;;EDwwnBA;IACE,gCAAgC;ECzwnBlC;;ED4wnBA;IACE,kCAAkC;EC7wnBpC;;EDgxnBA;IACE,gCAAgC;ECjxnBlC;;EDoxnBA;IACE,kCAAkC;ECrxnBpC;;EDwxnBA;IACE,gCAAgC;ECzxnBlC;;ED4xnBA;IACE,kCAAkC;EC7xnBpC;;EDgynBA;IACE,gCAAgC;ECjynBlC;;EDoynBA;IACE,kCAAkC;ECrynBpC;;EDwynBA;IACE,gCAAgC;ECzynBlC;;ED4ynBA;IACE,kCAAkC;EC7ynBpC;;EDgznBA;IACE,gCAAgC;ECjznBlC;;EDoznBA;IACE,kCAAkC;ECrznBpC;;EDwznBA;IACE,gCAAgC;ECzznBlC;;ED4znBA;IACE,kCAAkC;EC7znBpC;;EDg0nBA;IACE,gCAAgC;ECj0nBlC;;EDo0nBA;IACE,kCAAkC;ECr0nBpC;;EDw0nBA;IACE,gCAAgC;ECz0nBlC;;ED40nBA;IACE,kCAAkC;EC70nBpC;;EDg1nBA;IACE,gCAAgC;ECj1nBlC;;EDo1nBA;IACE,kCAAkC;ECr1nBpC;;EDw1nBA;IACE,gCAAgC;ECz1nBlC;;ED41nBA;IACE,kCAAkC;EC71nBpC;;EDg2nBA;IACE,gCAAgC;ECj2nBlC;;EDo2nBA;IACE,kCAAkC;ECr2nBpC;;EDw2nBA;IACE,gCAAgC;ECz2nBlC;;ED42nBA;IACE,kCAAkC;EC72nBpC;;EDg3nBA;IACE,gCAAgC;ECj3nBlC;;EDo3nBA;IACE,kCAAkC;ECr3nBpC;;EDw3nBA;IACE,gCAAgC;ECz3nBlC;;ED43nBA;IACE,kCAAkC;EC73nBpC;;EDg4nBA;IACE,gCAAgC;ECj4nBlC;;EDo4nBA;IACE,kCAAkC;ECr4nBpC;;EDw4nBA;IACE,gCAAgC;ECz4nBlC;;ED44nBA;IACE,kCAAkC;EC74nBpC;;EDg5nBA;IACE,gCAAgC;ECj5nBlC;;EDo5nBA;IACE,kCAAkC;ECr5nBpC;;EDw5nBA;IACE,gCAAgC;ECz5nBlC;;ED45nBA;IACE,kCAAkC;EC75nBpC;;EDg6nBA;IACE,gCAAgC;ECj6nBlC;;EDo6nBA;IACE,kCAAkC;ECr6nBpC;;EDw6nBA;IACE,gCAAgC;ECz6nBlC;;ED46nBA;IACE,kCAAkC;EC76nBpC;;EDg7nBA;IACE,gCAAgC;ECj7nBlC;;EDo7nBA;IACE,kCAAkC;ECr7nBpC;;EDw7nBA;IACE,gCAAgC;ECz7nBlC;;ED47nBA;IACE,kCAAkC;EC77nBpC;;EDg8nBA;IACE,gCAAgC;ECj8nBlC;;EDo8nBA;IACE,kCAAkC;ECr8nBpC;;EDw8nBA;IACE,gCAAgC;ECz8nBlC;;ED48nBA;IACE,kCAAkC;EC78nBpC;;EDg9nBA;IACE,gCAAgC;ECj9nBlC;;EDo9nBA;IACE,kCAAkC;ECr9nBpC;;EDw9nBA;IACE,gCAAgC;ECz9nBlC;;ED49nBA;IACE,kCAAkC;EC79nBpC;;EDg+nBA;IACE,gCAAgC;ECj+nBlC;;EDo+nBA;IACE,kCAAkC;ECr+nBpC;;EDw+nBA;IACE,gCAAgC;ECz+nBlC;;ED4+nBA;IACE,kCAAkC;EC7+nBpC;;EDg/nBA;IACE,gCAAgC;ECj/nBlC;;EDo/nBA;IACE,kCAAkC;ECr/nBpC;;EDw/nBA;IACE,gCAAgC;ECz/nBlC;;ED4/nBA;IACE,kCAAkC;EC7/nBpC;;EDggoBA;IACE,gCAAgC;ECjgoBlC;;EDogoBA;IACE,kCAAkC;ECrgoBpC;;EDwgoBA;IACE,gCAAgC;ECzgoBlC;;ED4goBA;IACE,kCAAkC;EC7goBpC;;EDghoBA;IACE,gCAAgC;ECjhoBlC;;EDohoBA;IACE,kCAAkC;ECrhoBpC;;EDwhoBA;IACE,gCAAgC;ECzhoBlC;;ED4hoBA;IACE,kCAAkC;EC7hoBpC;;EDgioBA;IACE,gCAAgC;ECjioBlC;;EDoioBA;IACE,kCAAkC;ECrioBpC;;EDwioBA;IACE,gCAAgC;ECzioBlC;;ED4ioBA;IACE,kCAAkC;EC7ioBpC;;EDgjoBA;IACE,gCAAgC;ECjjoBlC;;EDojoBA;IACE,kCAAkC;ECrjoBpC;;EDwjoBA;IACE,gCAAgC;ECzjoBlC;;ED4joBA;IACE,kCAAkC;EC7joBpC;;EDgkoBA;IACE,gCAAgC;ECjkoBlC;;EDokoBA;IACE,kCAAkC;ECrkoBpC;;EDwkoBA;IACE,gCAAgC;ECzkoBlC;;ED4koBA;IACE,kCAAkC;EC7koBpC;;EDgloBA;IACE,gCAAgC;ECjloBlC;;EDoloBA;IACE,kCAAkC;ECrloBpC;;EDwloBA;IACE,gCAAgC;ECzloBlC;;ED4loBA;IACE,kCAAkC;EC7loBpC;;EDgmoBA;IACE,gCAAgC;ECjmoBlC;;EDomoBA;IACE,kCAAkC;ECrmoBpC;;EDwmoBA;IACE,gCAAgC;ECzmoBlC;;ED4moBA;IACE,kCAAkC;EC7moBpC;;EDgnoBA;IACE,gCAAgC;ECjnoBlC;;EDonoBA;IACE,kCAAkC;ECrnoBpC;;EDwnoBA;IACE,gCAAgC;ECznoBlC;;ED4noBA;IACE,kCAAkC;EC7noBpC;;EDgooBA;IACE,gCAAgC;ECjooBlC;;EDoooBA;IACE,kCAAkC;ECrooBpC;;EDwooBA;IACE,gCAAgC;ECzooBlC;;ED4ooBA;IACE,kCAAkC;EC7ooBpC;;EDgpoBA;IACE,gCAAgC;ECjpoBlC;;EDopoBA;IACE,kCAAkC;ECrpoBpC;;EDwpoBA;IACE,gCAAgC;ECzpoBlC;;ED4poBA;IACE,kCAAkC;EC7poBpC;;EDgqoBA;IACE,gCAAgC;ECjqoBlC;;EDoqoBA;IACE,kCAAkC;ECrqoBpC;;EDwqoBA;IACE,gCAAgC;ECzqoBlC;;ED4qoBA;IACE,kCAAkC;EC7qoBpC;;EDgroBA;IACE,gCAAgC;ECjroBlC;;EDoroBA;IACE,kCAAkC;ECrroBpC;;EDwroBA;IACE,gCAAgC;ECzroBlC;;ED4roBA;IACE,kCAAkC;EC7roBpC;;EDgsoBA;IACE,gCAAgC;ECjsoBlC;;EDosoBA;IACE,kCAAkC;ECrsoBpC;;EDwsoBA;IACE,gCAAgC;ECzsoBlC;;ED4soBA;IACE,kCAAkC;EC7soBpC;;EDgtoBA;IACE,gCAAgC;ECjtoBlC;;EDotoBA;IACE,kCAAkC;ECrtoBpC;;EDwtoBA;IACE,gCAAgC;ECztoBlC;;ED4toBA;IACE,kCAAkC;EC7toBpC;;EDguoBA;IACE,gCAAgC;ECjuoBlC;;EDouoBA;IACE,kCAAkC;ECruoBpC;;EDwuoBA;IACE,gCAAgC;ECzuoBlC;;ED4uoBA;IACE,kCAAkC;EC7uoBpC;;EDgvoBA;IACE,gCAAgC;ECjvoBlC;;EDovoBA;IACE,kCAAkC;ECrvoBpC;;EDwvoBA;IACE,gCAAgC;ECzvoBlC;;ED4voBA;IACE,kCAAkC;EC7voBpC;;EDgwoBA;IACE,gCAAgC;ECjwoBlC;;EDowoBA;IACE,kCAAkC;ECrwoBpC;;EDwwoBA;IACE,gCAAgC;ECzwoBlC;;ED4woBA;IACE,kCAAkC;EC7woBpC;;EDgxoBA;IACE,gCAAgC;ECjxoBlC;;EDoxoBA;IACE,kCAAkC;ECrxoBpC;;EDwxoBA;IACE,gCAAgC;ECzxoBlC;;ED4xoBA;IACE,kCAAkC;EC7xoBpC;;EDgyoBA;IACE,gCAAgC;ECjyoBlC;;EDoyoBA;IACE,kCAAkC;EClxoBpC;;EDqxoBA;IACE,gCAAgC;ECtxoBlC;;EDyxoBA;IACE,kCAAkC;EC1xoBpC;;ED6xoBA;IACE,6BAA6B;EC9xoB/B;;EDiyoBA;IACE,gCAAgC;EClyoBlC;;EDqyoBA;IACE,+BAA+B;ECtyoBjC;;EDyyoBA;IACE,6BAA6B;EC1yoB/B;;ED6yoBA;IACE,+BAA+B;EC9yoBjC;;EDizoBA;IACE,6BAA6B;EClzoB/B;;EDqzoBA;IACE,+BAA+B;ECtzoBjC;;EDyzoBA;IACE,6BAA6B;EC1zoB/B;;ED6zoBA;IACE,+BAA+B;EC9zoBjC;;EDi0oBA;IACE,6BAA6B;ECl0oB/B;;EDq0oBA;IACE,+BAA+B;ECt0oBjC;;EDy0oBA;IACE,6BAA6B;EC10oB/B;;ED60oBA;IACE,+BAA+B;EC90oBjC;;EDi1oBA;IACE,6BAA6B;ECl1oB/B;;EDq1oBA;IACE,+BAA+B;ECt1oBjC;;EDy1oBA;IACE,6BAA6B;EC11oB/B;;ED61oBA;IACE,+BAA+B;EC91oBjC;;EDi2oBA;IACE,6BAA6B;ECl2oB/B;;EDq2oBA;IACE,+BAA+B;ECt2oBjC;;EDy2oBA;IACE,6BAA6B;EC12oB/B;;ED62oBA;IACE,+BAA+B;EC92oBjC;;EDi3oBA;IACE,8BAA8B;ECl3oBhC;;EDq3oBA;IACE,gCAAgC;ECt3oBlC;;EDy3oBA;IACE,8BAA8B;EC13oBhC;;ED63oBA;IACE,gCAAgC;EC93oBlC;;EDi4oBA;IACE,8BAA8B;ECl4oBhC;;EDq4oBA;IACE,gCAAgC;ECt4oBlC;;EDy4oBA;IACE,8BAA8B;EC14oBhC;;ED64oBA;IACE,gCAAgC;EC94oBlC;;EDi5oBA;IACE,8BAA8B;ECl5oBhC;;EDq5oBA;IACE,gCAAgC;ECt5oBlC;;EDy5oBA;IACE,8BAA8B;EC15oBhC;;ED65oBA;IACE,gCAAgC;EC95oBlC;;EDi6oBA;IACE,8BAA8B;ECl6oBhC;;EDq6oBA;IACE,gCAAgC;ECt6oBlC;;EDy6oBA;IACE,8BAA8B;EC16oBhC;;ED66oBA;IACE,gCAAgC;EC96oBlC;;EDi7oBA;IACE,8BAA8B;ECl7oBhC;;EDq7oBA;IACE,gCAAgC;ECt7oBlC;;EDy7oBA;IACE,8BAA8B;EC17oBhC;;ED67oBA;IACE,gCAAgC;EC97oBlC;;EDi8oBA;IACE,8BAA8B;ECl8oBhC;;EDq8oBA;IACE,gCAAgC;ECt8oBlC;;EDy8oBA;IACE,8BAA8B;EC18oBhC;;ED68oBA;IACE,gCAAgC;EC98oBlC;;EDi9oBA;IACE,8BAA8B;ECl9oBhC;;EDq9oBA;IACE,gCAAgC;ECt9oBlC;;EDy9oBA;IACE,8BAA8B;EC19oBhC;;ED69oBA;IACE,gCAAgC;EC99oBlC;;EDi+oBA;IACE,8BAA8B;ECl+oBhC;;EDq+oBA;IACE,gCAAgC;ECt+oBlC;;EDy+oBA;IACE,8BAA8B;EC1+oBhC;;ED6+oBA;IACE,gCAAgC;EC9+oBlC;;EDi/oBA;IACE,8BAA8B;ECl/oBhC;;EDq/oBA;IACE,gCAAgC;ECt/oBlC;;EDy/oBA;IACE,8BAA8B;EC1/oBhC;;ED6/oBA;IACE,gCAAgC;EC9/oBlC;;EDigpBA;IACE,8BAA8B;EClgpBhC;;EDqgpBA;IACE,gCAAgC;ECtgpBlC;;EDygpBA;IACE,8BAA8B;EC1gpBhC;;ED6gpBA;IACE,gCAAgC;EC9gpBlC;;EDihpBA;IACE,8BAA8B;EClhpBhC;;EDqhpBA;IACE,gCAAgC;ECthpBlC;;EDyhpBA;IACE,8BAA8B;EC1hpBhC;;ED6hpBA;IACE,gCAAgC;EC9hpBlC;;EDiipBA;IACE,8BAA8B;EClipBhC;;EDqipBA;IACE,gCAAgC;ECtipBlC;;EDyipBA;IACE,8BAA8B;EC1ipBhC;;ED6ipBA;IACE,gCAAgC;EC9ipBlC;;EDijpBA;IACE,8BAA8B;ECljpBhC;;EDqjpBA;IACE,gCAAgC;ECtjpBlC;;EDyjpBA;IACE,8BAA8B;EC1jpBhC;;ED6jpBA;IACE,gCAAgC;EC9jpBlC;;EDikpBA;IACE,8BAA8B;EClkpBhC;;EDqkpBA;IACE,gCAAgC;ECtkpBlC;;EDykpBA;IACE,8BAA8B;EC1kpBhC;;ED6kpBA;IACE,gCAAgC;EC9kpBlC;;EDilpBA;IACE,8BAA8B;ECllpBhC;;EDqlpBA;IACE,gCAAgC;ECtlpBlC;;EDylpBA;IACE,8BAA8B;EC1lpBhC;;ED6lpBA;IACE,gCAAgC;EC9lpBlC;;EDimpBA;IACE,8BAA8B;EClmpBhC;;EDqmpBA;IACE,gCAAgC;ECtmpBlC;;EDympBA;IACE,8BAA8B;EC1mpBhC;;ED6mpBA;IACE,gCAAgC;EC9mpBlC;;EDinpBA;IACE,8BAA8B;EClnpBhC;;EDqnpBA;IACE,gCAAgC;ECtnpBlC;;EDynpBA;IACE,8BAA8B;EC1npBhC;;ED6npBA;IACE,gCAAgC;EC9npBlC;;EDiopBA;IACE,8BAA8B;EClopBhC;;EDqopBA;IACE,gCAAgC;ECtopBlC;;EDyopBA;IACE,8BAA8B;EC1opBhC;;ED6opBA;IACE,gCAAgC;EC9opBlC;;EDippBA;IACE,8BAA8B;EClppBhC;;EDqppBA;IACE,gCAAgC;ECtppBlC;;EDyppBA;IACE,8BAA8B;EC1ppBhC;;ED6ppBA;IACE,gCAAgC;EC9ppBlC;;EDiqpBA;IACE,8BAA8B;EClqpBhC;;EDqqpBA;IACE,gCAAgC;ECtqpBlC;;EDyqpBA;IACE,8BAA8B;EC1qpBhC;;ED6qpBA;IACE,gCAAgC;EC9qpBlC;;EDirpBA;IACE,8BAA8B;EClrpBhC;;EDqrpBA;IACE,gCAAgC;ECtrpBlC;;EDyrpBA;IACE,8BAA8B;EC1rpBhC;;ED6rpBA;IACE,gCAAgC;EC9rpBlC;;EDispBA;IACE,8BAA8B;EClspBhC;;EDqspBA;IACE,gCAAgC;ECtspBlC;;EDyspBA;IACE,8BAA8B;EC1spBhC;;ED6spBA;IACE,gCAAgC;EC9spBlC;;EDitpBA;IACE,8BAA8B;ECltpBhC;;EDqtpBA;IACE,gCAAgC;ECttpBlC;;EDytpBA;IACE,8BAA8B;EC1tpBhC;;ED6tpBA;IACE,gCAAgC;EC9tpBlC;;EDiupBA;IACE,8BAA8B;EClupBhC;;EDqupBA;IACE,gCAAgC;ECtupBlC;;EDyupBA;IACE,8BAA8B;EC1upBhC;;ED6upBA;IACE,gCAAgC;EC9upBlC;;EDivpBA;IACE,8BAA8B;EClvpBhC;;EDqvpBA;IACE,gCAAgC;ECtvpBlC;;EDyvpBA;IACE,8BAA8B;EC1vpBhC;;ED6vpBA;IACE,gCAAgC;EC9vpBlC;;EDiwpBA;IACE,8BAA8B;EClwpBhC;;EDqwpBA;IACE,gCAAgC;ECtwpBlC;;EDywpBA;IACE,8BAA8B;EC1wpBhC;;ED6wpBA;IACE,gCAAgC;EC9wpBlC;;EDixpBA;IACE,8BAA8B;EClxpBhC;;EDqxpBA;IACE,gCAAgC;ECtxpBlC;;EDyxpBA;IACE,8BAA8B;EC1xpBhC;;ED6xpBA;IACE,gCAAgC;EC9xpBlC;;EDiypBA;IACE,8BAA8B;EClypBhC;;EDqypBA;IACE,gCAAgC;ECtypBlC;;EDyypBA;IACE,8BAA8B;EC1ypBhC;;ED6ypBA;IACE,gCAAgC;EC9ypBlC;;EDizpBA;IACE,8BAA8B;EClzpBhC;;EDqzpBA;IACE,gCAAgC;ECtzpBlC;;EDyzpBA;IACE,8BAA8B;EC1zpBhC;;ED6zpBA;IACE,gCAAgC;EC9zpBlC;;EDi0pBA;IACE,8BAA8B;ECl0pBhC;;EDq0pBA;IACE,gCAAgC;ECt0pBlC;;EDy0pBA;IACE,8BAA8B;EC10pBhC;;ED60pBA;IACE,gCAAgC;EC90pBlC;;EDi1pBA;IACE,8BAA8B;ECl1pBhC;;EDq1pBA;IACE,gCAAgC;ECt1pBlC;;EDy1pBA;IACE,8BAA8B;EC11pBhC;;ED61pBA;IACE,gCAAgC;EC91pBlC;;EDi2pBA;IACE,8BAA8B;ECl2pBhC;;EDq2pBA;IACE,gCAAgC;ECt2pBlC;;EDy2pBA;IACE,8BAA8B;EC12pBhC;;ED62pBA;IACE,gCAAgC;EC92pBlC;;EDi3pBA;IACE,8BAA8B;ECl3pBhC;;EDq3pBA;IACE,gCAAgC;ECt3pBlC;;EDy3pBA;IACE,8BAA8B;EC13pBhC;;ED63pBA;IACE,gCAAgC;EC93pBlC;;EDi4pBA;IACE,8BAA8B;ECl4pBhC;;EDq4pBA;IACE,gCAAgC;ECt4pBlC;;EDy4pBA;IACE,8BAA8B;EC14pBhC;;ED64pBA;IACE,gCAAgC;EC94pBlC;;EDi5pBA;IACE,8BAA8B;ECl5pBhC;;EDq5pBA;IACE,gCAAgC;ECn4pBlC;;EDs4pBA;IACE,8BAA8B;ECv4pBhC;;ED04pBA;IACE,gCAAgC;EC34pBlC;;ED84pBA;IACE,8BAA8B;EC/4pBhC;;EDk5pBA;IACE,iCAAiC;ECn5pBnC;;EDs5pBA;IACE,gCAAgC;ECv5pBlC;;ED05pBA;IACE,8BAA8B;EC35pBhC;;ED85pBA;IACE,gCAAgC;EC/5pBlC;;EDk6pBA;IACE,8BAA8B;ECn6pBhC;;EDs6pBA;IACE,gCAAgC;ECv6pBlC;;ED06pBA;IACE,8BAA8B;EC36pBhC;;ED86pBA;IACE,gCAAgC;EC/6pBlC;;EDk7pBA;IACE,8BAA8B;ECn7pBhC;;EDs7pBA;IACE,gCAAgC;ECv7pBlC;;ED07pBA;IACE,8BAA8B;EC37pBhC;;ED87pBA;IACE,gCAAgC;EC/7pBlC;;EDk8pBA;IACE,8BAA8B;ECn8pBhC;;EDs8pBA;IACE,gCAAgC;ECv8pBlC;;ED08pBA;IACE,8BAA8B;EC38pBhC;;ED88pBA;IACE,gCAAgC;EC/8pBlC;;EDk9pBA;IACE,8BAA8B;ECn9pBhC;;EDs9pBA;IACE,gCAAgC;ECv9pBlC;;ED09pBA;IACE,8BAA8B;EC39pBhC;;ED89pBA;IACE,gCAAgC;EC/9pBlC;;EDk+pBA;IACE,+BAA+B;ECn+pBjC;;EDs+pBA;IACE,iCAAiC;ECv+pBnC;;ED0+pBA;IACE,+BAA+B;EC3+pBjC;;ED8+pBA;IACE,iCAAiC;EC/+pBnC;;EDk/pBA;IACE,+BAA+B;ECn/pBjC;;EDs/pBA;IACE,iCAAiC;ECv/pBnC;;ED0/pBA;IACE,+BAA+B;EC3/pBjC;;ED8/pBA;IACE,iCAAiC;EC//pBnC;;EDkgqBA;IACE,+BAA+B;ECngqBjC;;EDsgqBA;IACE,iCAAiC;ECvgqBnC;;ED0gqBA;IACE,+BAA+B;EC3gqBjC;;ED8gqBA;IACE,iCAAiC;EC/gqBnC;;EDkhqBA;IACE,+BAA+B;ECnhqBjC;;EDshqBA;IACE,iCAAiC;ECvhqBnC;;ED0hqBA;IACE,+BAA+B;EC3hqBjC;;ED8hqBA;IACE,iCAAiC;EC/hqBnC;;EDkiqBA;IACE,+BAA+B;ECniqBjC;;EDsiqBA;IACE,iCAAiC;ECviqBnC;;ED0iqBA;IACE,+BAA+B;EC3iqBjC;;ED8iqBA;IACE,iCAAiC;EC/iqBnC;;EDkjqBA;IACE,+BAA+B;ECnjqBjC;;EDsjqBA;IACE,iCAAiC;ECvjqBnC;;ED0jqBA;IACE,+BAA+B;EC3jqBjC;;ED8jqBA;IACE,iCAAiC;EC/jqBnC;;EDkkqBA;IACE,+BAA+B;ECnkqBjC;;EDskqBA;IACE,iCAAiC;ECvkqBnC;;ED0kqBA;IACE,+BAA+B;EC3kqBjC;;ED8kqBA;IACE,iCAAiC;EC/kqBnC;;EDklqBA;IACE,+BAA+B;ECnlqBjC;;EDslqBA;IACE,iCAAiC;ECvlqBnC;;ED0lqBA;IACE,+BAA+B;EC3lqBjC;;ED8lqBA;IACE,iCAAiC;EC/lqBnC;;EDkmqBA;IACE,+BAA+B;ECnmqBjC;;EDsmqBA;IACE,iCAAiC;ECvmqBnC;;ED0mqBA;IACE,+BAA+B;EC3mqBjC;;ED8mqBA;IACE,iCAAiC;EC/mqBnC;;EDknqBA;IACE,+BAA+B;ECnnqBjC;;EDsnqBA;IACE,iCAAiC;ECvnqBnC;;ED0nqBA;IACE,+BAA+B;EC3nqBjC;;ED8nqBA;IACE,iCAAiC;EC/nqBnC;;EDkoqBA;IACE,+BAA+B;ECnoqBjC;;EDsoqBA;IACE,iCAAiC;ECvoqBnC;;ED0oqBA;IACE,+BAA+B;EC3oqBjC;;ED8oqBA;IACE,iCAAiC;EC/oqBnC;;EDkpqBA;IACE,+BAA+B;ECnpqBjC;;EDspqBA;IACE,iCAAiC;ECvpqBnC;;ED0pqBA;IACE,+BAA+B;EC3pqBjC;;ED8pqBA;IACE,iCAAiC;EC/pqBnC;;EDkqqBA;IACE,+BAA+B;ECnqqBjC;;EDsqqBA;IACE,iCAAiC;ECvqqBnC;;ED0qqBA;IACE,+BAA+B;EC3qqBjC;;ED8qqBA;IACE,iCAAiC;EC/qqBnC;;EDkrqBA;IACE,+BAA+B;ECnrqBjC;;EDsrqBA;IACE,iCAAiC;ECvrqBnC;;ED0rqBA;IACE,+BAA+B;EC3rqBjC;;ED8rqBA;IACE,iCAAiC;EC/rqBnC;;EDksqBA;IACE,+BAA+B;ECnsqBjC;;EDssqBA;IACE,iCAAiC;ECvsqBnC;;ED0sqBA;IACE,+BAA+B;EC3sqBjC;;ED8sqBA;IACE,iCAAiC;EC/sqBnC;;EDktqBA;IACE,+BAA+B;ECntqBjC;;EDstqBA;IACE,iCAAiC;ECvtqBnC;;ED0tqBA;IACE,+BAA+B;EC3tqBjC;;ED8tqBA;IACE,iCAAiC;EC/tqBnC;;EDkuqBA;IACE,+BAA+B;ECnuqBjC;;EDsuqBA;IACE,iCAAiC;ECvuqBnC;;ED0uqBA;IACE,+BAA+B;EC3uqBjC;;ED8uqBA;IACE,iCAAiC;EC/uqBnC;;EDkvqBA;IACE,+BAA+B;ECnvqBjC;;EDsvqBA;IACE,iCAAiC;ECvvqBnC;;ED0vqBA;IACE,+BAA+B;EC3vqBjC;;ED8vqBA;IACE,iCAAiC;EC/vqBnC;;EDkwqBA;IACE,+BAA+B;ECnwqBjC;;EDswqBA;IACE,iCAAiC;ECvwqBnC;;ED0wqBA;IACE,+BAA+B;EC3wqBjC;;ED8wqBA;IACE,iCAAiC;EC/wqBnC;;EDkxqBA;IACE,+BAA+B;ECnxqBjC;;EDsxqBA;IACE,iCAAiC;ECvxqBnC;;ED0xqBA;IACE,+BAA+B;EC3xqBjC;;ED8xqBA;IACE,iCAAiC;EC/xqBnC;;EDkyqBA;IACE,+BAA+B;ECnyqBjC;;EDsyqBA;IACE,iCAAiC;ECvyqBnC;;ED0yqBA;IACE,+BAA+B;EC3yqBjC;;ED8yqBA;IACE,iCAAiC;EC/yqBnC;;EDkzqBA;IACE,+BAA+B;ECnzqBjC;;EDszqBA;IACE,iCAAiC;ECvzqBnC;;ED0zqBA;IACE,+BAA+B;EC3zqBjC;;ED8zqBA;IACE,iCAAiC;EC/zqBnC;;EDk0qBA;IACE,+BAA+B;ECn0qBjC;;EDs0qBA;IACE,iCAAiC;ECv0qBnC;;ED00qBA;IACE,+BAA+B;EC30qBjC;;ED80qBA;IACE,iCAAiC;EC/0qBnC;;EDk1qBA;IACE,+BAA+B;ECn1qBjC;;EDs1qBA;IACE,iCAAiC;ECv1qBnC;;ED01qBA;IACE,+BAA+B;EC31qBjC;;ED81qBA;IACE,iCAAiC;EC/1qBnC;;EDk2qBA;IACE,+BAA+B;ECn2qBjC;;EDs2qBA;IACE,iCAAiC;ECv2qBnC;;ED02qBA;IACE,+BAA+B;EC32qBjC;;ED82qBA;IACE,iCAAiC;EC/2qBnC;;EDk3qBA;IACE,+BAA+B;ECn3qBjC;;EDs3qBA;IACE,iCAAiC;ECv3qBnC;;ED03qBA;IACE,+BAA+B;EC33qBjC;;ED83qBA;IACE,iCAAiC;EC/3qBnC;;EDk4qBA;IACE,+BAA+B;ECn4qBjC;;EDs4qBA;IACE,iCAAiC;ECv4qBnC;;ED04qBA;IACE,+BAA+B;EC34qBjC;;ED84qBA;IACE,iCAAiC;EC/4qBnC;;EDk5qBA;IACE,+BAA+B;ECn5qBjC;;EDs5qBA;IACE,iCAAiC;ECv5qBnC;;ED05qBA;IACE,+BAA+B;EC35qBjC;;ED85qBA;IACE,iCAAiC;EC/5qBnC;;EDk6qBA;IACE,+BAA+B;ECn6qBjC;;EDs6qBA;IACE,iCAAiC;ECv6qBnC;;ED06qBA;IACE,+BAA+B;EC36qBjC;;ED86qBA;IACE,iCAAiC;EC/6qBnC;;EDk7qBA;IACE,+BAA+B;ECn7qBjC;;EDs7qBA;IACE,iCAAiC;ECv7qBnC;;ED07qBA;IACE,+BAA+B;EC37qBjC;;ED87qBA;IACE,iCAAiC;EC/7qBnC;;EDk8qBA;IACE,+BAA+B;ECn8qBjC;;EDs8qBA;IACE,iCAAiC;ECv8qBnC;;ED08qBA;IACE,+BAA+B;EC38qBjC;;ED88qBA;IACE,iCAAiC;EC/8qBnC;;EDk9qBA;IACE,+BAA+B;ECn9qBjC;;EDs9qBA;IACE,iCAAiC;ECv9qBnC;;ED09qBA;IACE,+BAA+B;EC39qBjC;;ED89qBA;IACE,iCAAiC;EC/9qBnC;;EDk+qBA;IACE,+BAA+B;ECn+qBjC;;EDs+qBA;IACE,iCAAiC;ECv+qBnC;;ED0+qBA;IACE,+BAA+B;EC3+qBjC;;ED8+qBA;IACE,iCAAiC;EC/+qBnC;;EDk/qBA;IACE,+BAA+B;ECn/qBjC;;EDs/qBA;IACE,iCAAiC;ECv/qBnC;;ED0/qBA;IACE,+BAA+B;EC3/qBjC;;ED8/qBA;IACE,iCAAiC;EC//qBnC;;EDkgrBA;IACE,+BAA+B;ECngrBjC;;EDsgrBA;IACE,iCAAiC;ECp/qBnC;;EDu/qBA;IACE,+BAA+B;EACjC;;EAEA;ICz/qBC,iCAAuC;ED2/qBxC;;EC7/qBA;IACC,6BAAc;IACd,8BAAe;EDggrBhB;;EClgrBA;IACC,gCAAsC;IACtC,iCAAuC;EDqgrBxC;;ECvgrBA;IACC,+BAAsC;IACtC,gCAAuC;ED0grBxC;;EC5grBA;IACC,6BAAsC;IACtC,8BAAuC;ED+grBxC;;ECjhrBA;IACC,+BAAsC;IACtC,gCAAuC;EDohrBxC;;ECthrBA;IACC,6BAAsC;IACtC,8BAAuC;EDyhrBxC;;EC3hrBA;IACC,+BAAsC;IACtC,gCAAuC;ED8hrBxC;;EChirBA;IACC,6BAAsC;IACtC,8BAAuC;EDmirBxC;;ECrirBA;IACC,+BAAsC;IACtC,gCAAuC;EDwirBxC;;EC1irBA;IACC,6BAAsC;IACtC,8BAAuC;ED6irBxC;;EC/irBA;IACC,+BAAsC;IACtC,gCAAuC;EDkjrBxC;;ECpjrBA;IACC,6BAAsC;IACtC,8BAAuC;EDujrBxC;;ECzjrBA;IACC,+BAAsC;IACtC,gCAAuC;ED4jrBxC;;EC9jrBA;IACC,6BAAsC;IACtC,8BAAuC;EDikrBxC;;ECnkrBA;IACC,+BAAsC;IACtC,gCAAuC;EDskrBxC;;ECxkrBA;IACC,6BAAsC;IACtC,8BAAuC;ED2krBxC;;EC7krBA;IACC,+BAAsC;IACtC,gCAAuC;EDglrBxC;;ECllrBA;IACC,6BAAsC;IACtC,8BAAuC;EDqlrBxC;;ECvlrBA;IACC,+BAAsC;IACtC,gCAAuC;ED0lrBxC;;EC5lrBA;IACC,6BAAc;IACd,8BAAe;ED+lrBhB;;ECjmrBA;IACC,+BAAc;IACd,gCAAe;EDomrBhB;;ECtmrBA;IACC,8BAAsC;IACtC,+BAAuC;EDymrBxC;;EC3mrBA;IACC,gCAAsC;IACtC,iCAAuC;ED8mrBxC;;EChnrBA;IACC,8BAAsC;IACtC,+BAAuC;EDmnrBxC;;ECrnrBA;IACC,gCAAsC;IACtC,iCAAuC;EDwnrBxC;;EC1nrBA;IACC,8BAAsC;IACtC,+BAAuC;ED6nrBxC;;EC/nrBA;IACC,gCAAsC;IACtC,iCAAuC;EDkorBxC;;ECporBA;IACC,8BAAsC;IACtC,+BAAuC;EDuorBxC;;ECzorBA;IACC,gCAAsC;IACtC,iCAAuC;ED4orBxC;;EC9orBA;IACC,8BAAsC;IACtC,+BAAuC;EDiprBxC;;ECnprBA;IACC,gCAAsC;IACtC,iCAAuC;EDsprBxC;;ECxprBA;IACC,8BAAsC;IACtC,+BAAuC;ED2prBxC;;EC7prBA;IACC,gCAAsC;IACtC,iCAAuC;EDgqrBxC;;EClqrBA;IACC,8BAAsC;IACtC,+BAAuC;EDqqrBxC;;ECvqrBA;IACC,gCAAsC;IACtC,iCAAuC;ED0qrBxC;;EC5qrBA;IACC,8BAAsC;IACtC,+BAAuC;ED+qrBxC;;ECjrrBA;IACC,gCAAsC;IACtC,iCAAuC;EDorrBxC;;ECtrrBA;IACC,8BAAsC;IACtC,+BAAuC;EDyrrBxC;;EC3rrBA;IACC,gCAAsC;IACtC,iCAAuC;ED8rrBxC;;EChsrBA;IACC,8BAAsC;IACtC,+BAAuC;EDmsrBxC;;ECrsrBA;IACC,gCAAsC;IACtC,iCAAuC;EDwsrBxC;;EC1srBA;IACC,8BAAsC;IACtC,+BAAuC;ED6srBxC;;EC/srBA;IACC,gCAAsC;IACtC,iCAAuC;EDktrBxC;;ECptrBA;IACC,8BAAsC;IACtC,+BAAuC;EDutrBxC;;ECztrBA;IACC,gCAAsC;IACtC,iCAAuC;ED4trBxC;;EC9trBA;IACC,8BAAsC;IACtC,+BAAuC;EDiurBxC;;ECnurBA;IACC,gCAAsC;IACtC,iCAAuC;EDsurBxC;;ECxurBA;IACC,8BAAsC;IACtC,+BAAuC;ED2urBxC;;EC7urBA;IACC,gCAAsC;IACtC,iCAAuC;EDgvrBxC;;EClvrBA;IACC,8BAAsC;IACtC,+BAAuC;EDqvrBxC;;ECvvrBA;IACC,gCAAsC;IACtC,iCAAuC;ED0vrBxC;;EC5vrBA;IACC,8BAAsC;IACtC,+BAAuC;ED+vrBxC;;ECjwrBA;IACC,gCAAsC;IACtC,iCAAuC;EDowrBxC;;ECtwrBA;IACC,8BAAsC;IACtC,+BAAuC;EDywrBxC;;EC3wrBA;IACC,gCAAsC;IACtC,iCAAuC;ED8wrBxC;;EChxrBA;IACC,8BAAsC;IACtC,+BAAuC;EDmxrBxC;;ECrxrBA;IACC,gCAAsC;IACtC,iCAAuC;EDwxrBxC;;EC1xrBA;IACC,8BAAsC;IACtC,+BAAuC;ED6xrBxC;;EC/xrBA;IACC,gCAAsC;IACtC,iCAAuC;EDkyrBxC;;ECpyrBA;IACC,8BAAsC;IACtC,+BAAuC;EDuyrBxC;;ECzyrBA;IACC,gCAAsC;IACtC,iCAAuC;ED4yrBxC;;EC9yrBA;IACC,8BAAsC;IACtC,+BAAuC;EDizrBxC;;ECnzrBA;IACC,gCAAsC;IACtC,iCAAuC;EDszrBxC;;ECxzrBA;IACC,8BAAsC;IACtC,+BAAuC;ED2zrBxC;;EC7zrBA;IACC,gCAAsC;IACtC,iCAAuC;EDg0rBxC;;ECl0rBA;IACC,8BAAsC;IACtC,+BAAuC;EDq0rBxC;;ECv0rBA;IACC,gCAAsC;IACtC,iCAAuC;ED00rBxC;;EC50rBA;IACC,8BAAsC;IACtC,+BAAuC;ED+0rBxC;;ECj1rBA;IACC,gCAAsC;IACtC,iCAAuC;EDo1rBxC;;ECt1rBA;IACC,8BAAsC;IACtC,+BAAuC;EDy1rBxC;;EC31rBA;IACC,gCAAsC;IACtC,iCAAuC;ED81rBxC;;ECh2rBA;IACC,8BAAsC;IACtC,+BAAuC;EDm2rBxC;;ECr2rBA;IACC,gCAAsC;IACtC,iCAAuC;EDw2rBxC;;EC12rBA;IACC,8BAAsC;IACtC,+BAAuC;ED62rBxC;;EC/2rBA;IACC,gCAAsC;IACtC,iCAAuC;EDk3rBxC;;ECp3rBA;IACC,8BAAsC;IACtC,+BAAuC;EDu3rBxC;;ECz3rBA;IACC,gCAAsC;IACtC,iCAAuC;ED43rBxC;;EC93rBA;IACC,8BAAsC;IACtC,+BAAuC;EDi4rBxC;;ECn4rBA;IACC,gCAAsC;IACtC,iCAAuC;EDs4rBxC;;ECx4rBA;IACC,8BAAsC;IACtC,+BAAuC;ED24rBxC;;EC74rBA;IACC,gCAAsC;IACtC,iCAAuC;EDg5rBxC;;ECl5rBA;IACC,8BAAsC;IACtC,+BAAuC;EDq5rBxC;;ECv5rBA;IACC,gCAAsC;IACtC,iCAAuC;ED05rBxC;;EC55rBA;IACC,8BAAsC;IACtC,+BAAuC;ED+5rBxC;;ECj6rBA;IACC,gCAAsC;IACtC,iCAAuC;EDo6rBxC;;ECt6rBA;IACC,8BAAsC;IACtC,+BAAuC;EDy6rBxC;;EC36rBA;IACC,gCAAsC;IACtC,iCAAuC;ED86rBxC;;ECh7rBA;IACC,8BAAsC;IACtC,+BAAuC;EDm7rBxC;;ECr7rBA;IACC,gCAAsC;IACtC,iCAAuC;EDw7rBxC;;EC17rBA;IACC,8BAAsC;IACtC,+BAAuC;ED67rBxC;;EC/7rBA;IACC,gCAAsC;IACtC,iCAAuC;EDk8rBxC;;ECp8rBA;IACC,8BAAsC;IACtC,+BAAuC;EDu8rBxC;;ECz8rBA;IACC,gCAAsC;IACtC,iCAAuC;ED48rBxC;;EC98rBA;IACC,8BAAsC;IACtC,+BAAuC;EDi9rBxC;;ECn9rBA;IACC,gCAAsC;IACtC,iCAAuC;EDs9rBxC;;ECx9rBA;IACC,8BAAsC;IACtC,+BAAuC;ED29rBxC;;EC79rBA;IACC,gCAAsC;IACtC,iCAAuC;EDg+rBxC;;ECl+rBA;IACC,8BAAsC;IACtC,+BAAuC;EDq+rBxC;;ECv+rBA;IACC,gCAAsC;IACtC,iCAAuC;ED0+rBxC;;EC5+rBA;IACC,8BAAsC;IACtC,+BAAuC;ED++rBxC;;ECj/rBA;IACC,gCAAsC;IACtC,iCAAuC;EDo/rBxC;;ECt/rBA;IACC,8BAAsC;IACtC,+BAAuC;EDy/rBxC;;EC3/rBA;IACC,gCAAsC;IACtC,iCAAuC;ED8/rBxC;;EChgsBA;IACC,8BAAsC;IACtC,+BAAuC;EDmgsBxC;;ECrgsBA;IACC,gCAAsC;IACtC,iCAAuC;EDwgsBxC;;EC1gsBA;IACC,8BAAsC;IACtC,+BAAuC;ED6gsBxC;;EC/gsBA;IACC,gCAAsC;IACtC,iCAAuC;EDkhsBxC;;ECphsBA;IACC,8BAAsC;IACtC,+BAAuC;EDuhsBxC;;ECzhsBA;IACC,gCAAsC;IACtC,iCAAuC;ED4hsBxC;;EC9hsBA;IACC,8BAAsC;IACtC,+BAAuC;EDiisBxC;;ECnisBA;IACC,gCAAsC;IACtC,iCAAuC;EDsisBxC;;ECxisBA;IACC,8BAAsC;IACtC,+BAAuC;ED2isBxC;;EC7isBA;IACC,gCAAsC;IACtC,iCAAuC;EDgjsBxC;;ECljsBA;IACC,8BAAsC;IACtC,+BAAuC;EDqjsBxC;;ECvjsBA;IACC,gCAAsC;IACtC,iCAAuC;ED0jsBxC;;EC5jsBA;IACC,8BAAsC;IACtC,+BAAuC;ED+jsBxC;;ECjksBA;IACC,gCAAsC;IACtC,iCAAuC;EDoksBxC;;ECtksBA;IACC,8BAAsC;IACtC,+BAAuC;EDyksBxC;;EC3ksBA;IACC,gCAAsC;IACtC,iCAAuC;ED8ksBxC;;EChlsBA;IACC,8BAAsC;IACtC,+BAAuC;EDmlsBxC;;ECrlsBA;IACC,gCAAsC;IACtC,iCAAuC;EDwlsBxC;;EC1lsBA;IACC,8BAAsC;IACtC,+BAAuC;ED6lsBxC;;EC/lsBA;IACC,gCAAsC;IACtC,iCAAuC;EDkmsBxC;;ECpmsBA;IACC,8BAAsC;IACtC,+BAAuC;EDumsBxC;;ECzmsBA;IACC,gCAAsC;IACtC,iCAAuC;ED4msBxC;;EC9msBA;IACC,8BAAsC;IACtC,+BAAuC;EDinsBxC;;ECnnsBA;IACC,gCAAsC;IACtC,iCAAuC;EDsnsBxC;;ECxnsBA;IACC,8BAAsC;IACtC,+BAAuC;ED2nsBxC;;EC7nsBA;IACC,gCAAsC;IACtC,iCAAuC;EDgosBxC;;EClosBA;IACC,8BAAsC;IACtC,+BAAuC;EDqosBxC;;ECvosBA;IACC,gCAAsC;IACtC,iCAAuC;ED0osBxC;;EC5osBA;IACC,8BAAsC;IACtC,+BAAuC;ED+osBxC;;ECjpsBA;IACC,gCAAsC;IACtC,iCAAuC;EDopsBxC;;ECtpsBA;IACC,8BAAsC;IACtC,+BAAuC;EDypsBxC;;EC3psBA;IACC,gCAAsC;IACtC,iCAAuC;ED8psBxC;;EChqsBA;IACC,8BAAsC;IACtC,+BAAuC;EDmqsBxC;;ECrqsBA;IACC,gCAAsC;IACtC,iCAAuC;EDwqsBxC;;EC1qsBA;IACC,8BAAsC;IACtC,+BAAuC;ED6qsBxC;;EC/qsBA;IACC,gCAAsC;IACtC,iCAAuC;EDkrsBxC;;ECprsBA;IACC,8BAAsC;IACtC,+BAAuC;EDursBxC;;ECzrsBA;IACC,gCAAsC;IACtC,iCAAuC;ED4rsBxC;;EC9rsBA;IACC,8BAAsC;IACtC,+BAAuC;EDissBxC;;ECnssBA;IACC,gCAAsC;IACtC,iCAAuC;EDsssBxC;;ECxssBA;IACC,8BAAsC;IACtC,+BAAuC;ED2ssBxC;;EC7ssBA;IACC,gCAAsC;IACtC,iCAAuC;EDgtsBxC;;ECltsBA;IACC,8BAAsC;IACtC,+BAAuC;EDqtsBxC;;ECvtsBA;IACC,gCAAsC;IACtC,iCAAuC;ED0tsBxC;;EC5tsBA;IACC,8BAAsC;IACtC,+BAAuC;ED+tsBxC;;ECjusBA;IACC,gCAAsC;IACtC,iCAAuC;EDousBxC;;ECtusBA;IACC,8BAAsC;IACtC,+BAAuC;EDyusBxC;;EC3usBA;IACC,gCAAsC;IACtC,iCAAuC;ED8usBxC;;EChvsBA;IACC,8BAAsC;IACtC,+BAAuC;EDmvsBxC;;ECrvsBA;IACC,gCAAsC;IACtC,iCAAuC;EDwvsBxC;;EC1vsBA;IACC,8BAAsC;IACtC,+BAAuC;ED6vsBxC;;EC/vsBA;IACC,gCAAsC;IACtC,iCAAuC;EDkwsBxC;;ECpwsBA;IACC,8BAAsC;IACtC,+BAAuC;EDuwsBxC;;ECzwsBA;IACC,gCAAsC;IACtC,iCAAuC;ED4wsBxC;;EC9wsBA;IACC,8BAAsC;IACtC,+BAAuC;EDixsBxC;;ECnxsBA;IACC,gCAAsC;IACtC,iCAAuC;EDsxsBxC;;ECpwsBA;IACC,8BAAqC;IACrC,+BAAwC;EDuwsBzC;;ECzwsBA;IACC,gCAAqC;IACrC,iCAAgB;ED4wsBjB;;EC9wsBA;IACC,4BAAa;IACb,+BAAgB;EDixsBjB;;ECnxsBA;IACC,+BAAqC;IACrC,kCAAwC;EDsxsBzC;;ECxxsBA;IACC,8BAAqC;IACrC,iCAAwC;ED2xsBzC;;EC7xsBA;IACC,4BAAqC;IACrC,+BAAwC;EDgysBzC;;EClysBA;IACC,8BAAqC;IACrC,iCAAwC;EDqysBzC;;ECvysBA;IACC,4BAAqC;IACrC,+BAAwC;ED0ysBzC;;EC5ysBA;IACC,8BAAqC;IACrC,iCAAwC;ED+ysBzC;;ECjzsBA;IACC,4BAAqC;IACrC,+BAAwC;EDozsBzC;;ECtzsBA;IACC,8BAAqC;IACrC,iCAAwC;EDyzsBzC;;EC3zsBA;IACC,4BAAqC;IACrC,+BAAwC;ED8zsBzC;;ECh0sBA;IACC,8BAAqC;IACrC,iCAAwC;EDm0sBzC;;ECr0sBA;IACC,4BAAqC;IACrC,+BAAwC;EDw0sBzC;;EC10sBA;IACC,8BAAqC;IACrC,iCAAwC;ED60sBzC;;EC/0sBA;IACC,4BAAqC;IACrC,+BAAwC;EDk1sBzC;;ECp1sBA;IACC,8BAAqC;IACrC,iCAAwC;EDu1sBzC;;ECz1sBA;IACC,4BAAqC;IACrC,+BAAwC;ED41sBzC;;EC91sBA;IACC,8BAAqC;IACrC,iCAAwC;EDi2sBzC;;ECn2sBA;IACC,4BAAqC;IACrC,+BAAwC;EDs2sBzC;;ECx2sBA;IACC,8BAAqC;IACrC,iCAAwC;ED22sBzC;;EC72sBA;IACC,4BAAa;IACb,+BAAgB;EDg3sBjB;;ECl3sBA;IACC,8BAAa;IACb,iCAAgB;EDq3sBjB;;ECv3sBA;IACC,6BAAqC;IACrC,gCAAwC;ED03sBzC;;EC53sBA;IACC,+BAAqC;IACrC,kCAAwC;ED+3sBzC;;ECj4sBA;IACC,6BAAqC;IACrC,gCAAwC;EDo4sBzC;;ECt4sBA;IACC,+BAAqC;IACrC,kCAAwC;EDy4sBzC;;EC34sBA;IACC,6BAAqC;IACrC,gCAAwC;ED84sBzC;;ECh5sBA;IACC,+BAAqC;IACrC,kCAAwC;EDm5sBzC;;ECr5sBA;IACC,6BAAqC;IACrC,gCAAwC;EDw5sBzC;;EC15sBA;IACC,+BAAqC;IACrC,kCAAwC;ED65sBzC;;EC/5sBA;IACC,6BAAqC;IACrC,gCAAwC;EDk6sBzC;;ECp6sBA;IACC,+BAAqC;IACrC,kCAAwC;EDu6sBzC;;ECz6sBA;IACC,6BAAqC;IACrC,gCAAwC;ED46sBzC;;EC96sBA;IACC,+BAAqC;IACrC,kCAAwC;EDi7sBzC;;ECn7sBA;IACC,6BAAqC;IACrC,gCAAwC;EDs7sBzC;;ECx7sBA;IACC,+BAAqC;IACrC,kCAAwC;ED27sBzC;;EC77sBA;IACC,6BAAqC;IACrC,gCAAwC;EDg8sBzC;;ECl8sBA;IACC,+BAAqC;IACrC,kCAAwC;EDq8sBzC;;ECv8sBA;IACC,6BAAqC;IACrC,gCAAwC;ED08sBzC;;EC58sBA;IACC,+BAAqC;IACrC,kCAAwC;ED+8sBzC;;ECj9sBA;IACC,6BAAqC;IACrC,gCAAwC;EDo9sBzC;;ECt9sBA;IACC,+BAAqC;IACrC,kCAAwC;EDy9sBzC;;EC39sBA;IACC,6BAAqC;IACrC,gCAAwC;ED89sBzC;;ECh+sBA;IACC,+BAAqC;IACrC,kCAAwC;EDm+sBzC;;ECr+sBA;IACC,6BAAqC;IACrC,gCAAwC;EDw+sBzC;;EC1+sBA;IACC,+BAAqC;IACrC,kCAAwC;ED6+sBzC;;EC/+sBA;IACC,6BAAqC;IACrC,gCAAwC;EDk/sBzC;;ECp/sBA;IACC,+BAAqC;IACrC,kCAAwC;EDu/sBzC;;ECz/sBA;IACC,6BAAqC;IACrC,gCAAwC;ED4/sBzC;;EC9/sBA;IACC,+BAAqC;IACrC,kCAAwC;EDigtBzC;;ECngtBA;IACC,6BAAqC;IACrC,gCAAwC;EDsgtBzC;;ECxgtBA;IACC,+BAAqC;IACrC,kCAAwC;ED2gtBzC;;EC7gtBA;IACC,6BAAqC;IACrC,gCAAwC;EDghtBzC;;EClhtBA;IACC,+BAAqC;IACrC,kCAAwC;EDqhtBzC;;ECvhtBA;IACC,6BAAqC;IACrC,gCAAwC;ED0htBzC;;EC5htBA;IACC,+BAAqC;IACrC,kCAAwC;ED+htBzC;;ECjitBA;IACC,6BAAqC;IACrC,gCAAwC;EDoitBzC;;ECtitBA;IACC,+BAAqC;IACrC,kCAAwC;EDyitBzC;;EC3itBA;IACC,6BAAqC;IACrC,gCAAwC;ED8itBzC;;EChjtBA;IACC,+BAAqC;IACrC,kCAAwC;EDmjtBzC;;ECrjtBA;IACC,6BAAqC;IACrC,gCAAwC;EDwjtBzC;;EC1jtBA;IACC,+BAAqC;IACrC,kCAAwC;ED6jtBzC;;EC/jtBA;IACC,6BAAqC;IACrC,gCAAwC;EDkktBzC;;ECpktBA;IACC,+BAAqC;IACrC,kCAAwC;EDuktBzC;;ECzktBA;IACC,6BAAqC;IACrC,gCAAwC;ED4ktBzC;;EC9ktBA;IACC,+BAAqC;IACrC,kCAAwC;EDiltBzC;;ECnltBA;IACC,6BAAqC;IACrC,gCAAwC;EDsltBzC;;ECxltBA;IACC,+BAAqC;IACrC,kCAAwC;ED2ltBzC;;EC7ltBA;IACC,6BAAqC;IACrC,gCAAwC;EDgmtBzC;;EClmtBA;IACC,+BAAqC;IACrC,kCAAwC;EDqmtBzC;;ECvmtBA;IACC,6BAAqC;IACrC,gCAAwC;ED0mtBzC;;EC5mtBA;IACC,+BAAqC;IACrC,kCAAwC;ED+mtBzC;;ECjntBA;IACC,6BAAqC;IACrC,gCAAwC;EDontBzC;;ECtntBA;IACC,+BAAqC;IACrC,kCAAwC;EDyntBzC;;EC3ntBA;IACC,6BAAqC;IACrC,gCAAwC;ED8ntBzC;;EChotBA;IACC,+BAAqC;IACrC,kCAAwC;EDmotBzC;;ECrotBA;IACC,6BAAqC;IACrC,gCAAwC;EDwotBzC;;EC1otBA;IACC,+BAAqC;IACrC,kCAAwC;ED6otBzC;;EC/otBA;IACC,6BAAqC;IACrC,gCAAwC;EDkptBzC;;ECpptBA;IACC,+BAAqC;IACrC,kCAAwC;EDuptBzC;;ECzptBA;IACC,6BAAqC;IACrC,gCAAwC;ED4ptBzC;;EC9ptBA;IACC,+BAAqC;IACrC,kCAAwC;EDiqtBzC;;ECnqtBA;IACC,6BAAqC;IACrC,gCAAwC;EDsqtBzC;;ECxqtBA;IACC,+BAAqC;IACrC,kCAAwC;ED2qtBzC;;EC7qtBA;IACC,6BAAqC;IACrC,gCAAwC;EDgrtBzC;;EClrtBA;IACC,+BAAqC;IACrC,kCAAwC;EDqrtBzC;;ECvrtBA;IACC,6BAAqC;IACrC,gCAAwC;ED0rtBzC;;EC5rtBA;IACC,+BAAqC;IACrC,kCAAwC;ED+rtBzC;;ECjstBA;IACC,6BAAqC;IACrC,gCAAwC;EDostBzC;;ECtstBA;IACC,+BAAqC;IACrC,kCAAwC;EDystBzC;;EC3stBA;IACC,6BAAqC;IACrC,gCAAwC;ED8stBzC;;EChttBA;IACC,+BAAqC;IACrC,kCAAwC;EDmttBzC;;ECrttBA;IACC,6BAAqC;IACrC,gCAAwC;EDwttBzC;;EC1ttBA;IACC,+BAAqC;IACrC,kCAAwC;ED6ttBzC;;EC/ttBA;IACC,6BAAqC;IACrC,gCAAwC;EDkutBzC;;ECputBA;IACC,+BAAqC;IACrC,kCAAwC;EDuutBzC;;ECzutBA;IACC,6BAAqC;IACrC,gCAAwC;ED4utBzC;;EC9utBA;IACC,+BAAqC;IACrC,kCAAwC;EDivtBzC;;ECnvtBA;IACC,6BAAqC;IACrC,gCAAwC;EDsvtBzC;;ECxvtBA;IACC,+BAAqC;IACrC,kCAAwC;ED2vtBzC;;EC7vtBA;IACC,6BAAqC;IACrC,gCAAwC;EDgwtBzC;;EClwtBA;IACC,+BAAqC;IACrC,kCAAwC;EDqwtBzC;;ECvwtBA;IACC,6BAAqC;IACrC,gCAAwC;ED0wtBzC;;EC5wtBA;IACC,+BAAqC;IACrC,kCAAwC;ED+wtBzC;;ECjxtBA;IACC,6BAAqC;IACrC,gCAAwC;EDoxtBzC;;ECtxtBA;IACC,+BAAqC;IACrC,kCAAwC;EDyxtBzC;;EC3xtBA;IACC,6BAAqC;IACrC,gCAAwC;ED8xtBzC;;EChytBA;IACC,+BAAqC;IACrC,kCAAwC;EDmytBzC;;ECrytBA;IACC,6BAAqC;IACrC,gCAAwC;EDwytBzC;;EC1ytBA;IACC,+BAAqC;IACrC,kCAAwC;ED6ytBzC;;EC/ytBA;IACC,6BAAqC;IACrC,gCAAwC;EDkztBzC;;ECpztBA;IACC,+BAAqC;IACrC,kCAAwC;EDuztBzC;;ECzztBA;IACC,6BAAqC;IACrC,gCAAwC;ED4ztBzC;;EC9ztBA;IACC,+BAAqC;IACrC,kCAAwC;EDi0tBzC;;ECn0tBA;IACC,6BAAqC;IACrC,gCAAwC;EDs0tBzC;;ECx0tBA;IACC,+BAAqC;IACrC,kCAAwC;ED20tBzC;;EC70tBA;IACC,6BAAqC;IACrC,gCAAwC;EDg1tBzC;;ECl1tBA;IACC,+BAAqC;IACrC,kCAAwC;EDq1tBzC;;ECv1tBA;IACC,6BAAqC;IACrC,gCAAwC;ED01tBzC;;EC51tBA;IACC,+BAAqC;IACrC,kCAAwC;ED+1tBzC;;ECj2tBA;IACC,6BAAqC;IACrC,gCAAwC;EDo2tBzC;;ECt2tBA;IACC,+BAAqC;IACrC,kCAAwC;EDy2tBzC;;EC32tBA;IACC,6BAAqC;IACrC,gCAAwC;ED82tBzC;;ECh3tBA;IACC,+BAAqC;IACrC,kCAAwC;EDm3tBzC;;ECr3tBA;IACC,6BAAqC;IACrC,gCAAwC;EDw3tBzC;;EC13tBA;IACC,+BAAqC;IACrC,kCAAwC;ED63tBzC;;EC/3tBA;IACC,6BAAqC;IACrC,gCAAwC;EDk4tBzC;;ECp4tBA;IACC,+BAAqC;IACrC,kCAAwC;EDu4tBzC;;ECz4tBA;IACC,6BAAqC;IACrC,gCAAwC;ED44tBzC;;EC94tBA;IACC,+BAAqC;IACrC,kCAAwC;EDi5tBzC;;ECn5tBA;IACC,6BAAqC;IACrC,gCAAwC;EDs5tBzC;;ECx5tBA;IACC,+BAAqC;IACrC,kCAAwC;ED25tBzC;;EC75tBA;IACC,6BAAqC;IACrC,gCAAwC;EDg6tBzC;;ECl6tBA;IACC,+BAAqC;IACrC,kCAAwC;EDq6tBzC;;ECv6tBA;IACC,6BAAqC;IACrC,gCAAwC;ED06tBzC;;EC56tBA;IACC,+BAAqC;IACrC,kCAAwC;ED+6tBzC;;ECj7tBA;IACC,6BAAqC;IACrC,gCAAwC;EDo7tBzC;;ECt7tBA;IACC,+BAAqC;IACrC,kCAAwC;EDy7tBzC;;EC37tBA;IACC,6BAAqC;IACrC,gCAAwC;ED87tBzC;;ECh8tBA;IACC,+BAAqC;IACrC,kCAAwC;EDm8tBzC;;ECr8tBA;IACC,6BAAqC;IACrC,gCAAwC;EDw8tBzC;;EC18tBA;IACC,+BAAqC;IACrC,kCAAwC;ED68tBzC;;EC/8tBA;IACC,6BAAqC;IACrC,gCAAwC;EDk9tBzC;;ECp9tBA;IACC,+BAAqC;IACrC,kCAAwC;EDu9tBzC;;ECz9tBA;IACC,6BAAqC;IACrC,gCAAwC;ED49tBzC;;EC99tBA;IACC,+BAAqC;IACrC,kCAAwC;EDi+tBzC;;ECn+tBA;IACC,6BAAqC;IACrC,gCAAwC;EDs+tBzC;;ECx+tBA;IACC,+BAAqC;IACrC,kCAAwC;ED2+tBzC;;EC7+tBA;IACC,6BAAqC;IACrC,gCAAwC;EDg/tBzC;;ECl/tBA;IACC,+BAAqC;IACrC,kCAAwC;EDq/tBzC;;ECv/tBA;IACC,6BAAqC;IACrC,gCAAwC;ED0/tBzC;;EC5/tBA;IACC,+BAAqC;IACrC,kCAAwC;ED+/tBzC;;ECjguBA;IACC,6BAAqC;IACrC,gCAAwC;EDoguBzC;;ECtguBA;IACC,+BAAqC;IACrC,kCAAwC;EDyguBzC;;EC3guBA;IACC,6BAAqC;IACrC,gCAAwC;ED8guBzC;;EChhuBA;IACC,+BAAqC;IACrC,kCAAwC;EDmhuBzC;;ECrhuBA;IACC,6BAAqC;IACrC,gCAAwC;EDwhuBzC;;EC1huBA;IACC,+BAAqC;IACrC,kCAAwC;ED6huBzC;;EC/huBA;IACC,6BAAqC;IACrC,gCAAwC;EDkiuBzC;;ECpiuBA;IACC,+BAAqC;IACrC,kCAAwC;EDuiuBzC;;ECjiuBF;IAaE,6BAAe;IACd,gCAAiC;EDwhuBlC;;ECzhuBA;IACC,+BAAiC;ID4huBhC,kCAAkC;EACpC;AACF;AACA;EACE;IACE,wBAAwB;ECliuB1B;;EDqiuBA;IACE,2BAA2B;ECtiuB7B;;EDyiuBA;IACE,0BAA0B;EC1iuB5B;;ED6iuBA;IACE,wBAAwB;EC9iuB1B;;EDijuBA;IACE,0BAA0B;ECljuB5B;;EDqjuBA;IACE,wBAAwB;ECtjuB1B;;EDyjuBA;IACE,0BAA0B;EC1juB5B;;ED6juBA;IACE,wBAAwB;EC9juB1B;;EDikuBA;IACE,0BAA0B;EClkuB5B;;EDqkuBA;IACE,wBAAwB;ECtkuB1B;;EDykuBA;IACE,0BAA0B;EC1kuB5B;;ED6kuBA;IACE,wBAAwB;EC9kuB1B;;EDiluBA;IACE,0BAA0B;EClluB5B;;EDqluBA;IACE,wBAAwB;ECtluB1B;;EDyluBA;IACE,0BAA0B;EC1luB5B;;ED6luBA;IACE,wBAAwB;EC9luB1B;;EDimuBA;IACE,0BAA0B;EClmuB5B;;EDqmuBA;IACE,wBAAwB;ECtmuB1B;;EDymuBA;IACE,0BAA0B;EC1muB5B;;ED6muBA;IACE,wBAAwB;EC9muB1B;;EDinuBA;IACE,0BAA0B;EClnuB5B;;EDqnuBA;IACE,yBAAyB;ECtnuB3B;;EDynuBA;IACE,2BAA2B;EC1nuB7B;;ED6nuBA;IACE,yBAAyB;EC9nuB3B;;EDiouBA;IACE,2BAA2B;EClouB7B;;EDqouBA;IACE,yBAAyB;ECtouB3B;;EDyouBA;IACE,2BAA2B;EC1ouB7B;;ED6ouBA;IACE,yBAAyB;EC9ouB3B;;EDipuBA;IACE,2BAA2B;EClpuB7B;;EDqpuBA;IACE,yBAAyB;ECtpuB3B;;EDypuBA;IACE,2BAA2B;EC1puB7B;;ED6puBA;IACE,yBAAyB;EC9puB3B;;EDiquBA;IACE,2BAA2B;EClquB7B;;EDqquBA;IACE,yBAAyB;ECtquB3B;;EDyquBA;IACE,2BAA2B;EC1quB7B;;ED6quBA;IACE,yBAAyB;EC9quB3B;;EDiruBA;IACE,2BAA2B;EClruB7B;;EDqruBA;IACE,yBAAyB;ECtruB3B;;EDyruBA;IACE,2BAA2B;EC1ruB7B;;ED6ruBA;IACE,yBAAyB;EC9ruB3B;;EDisuBA;IACE,2BAA2B;EClsuB7B;;EDqsuBA;IACE,yBAAyB;ECtsuB3B;;EDysuBA;IACE,2BAA2B;EC1suB7B;;ED6suBA;IACE,yBAAyB;EC9suB3B;;EDituBA;IACE,2BAA2B;ECltuB7B;;EDqtuBA;IACE,yBAAyB;ECttuB3B;;EDytuBA;IACE,2BAA2B;EC1tuB7B;;ED6tuBA;IACE,yBAAyB;EC9tuB3B;;EDiuuBA;IACE,2BAA2B;ECluuB7B;;EDquuBA;IACE,yBAAyB;ECtuuB3B;;EDyuuBA;IACE,2BAA2B;EC1uuB7B;;ED6uuBA;IACE,yBAAyB;EC9uuB3B;;EDivuBA;IACE,2BAA2B;EClvuB7B;;EDqvuBA;IACE,yBAAyB;ECtvuB3B;;EDyvuBA;IACE,2BAA2B;EC1vuB7B;;ED6vuBA;IACE,yBAAyB;EC9vuB3B;;EDiwuBA;IACE,2BAA2B;EClwuB7B;;EDqwuBA;IACE,yBAAyB;ECtwuB3B;;EDywuBA;IACE,2BAA2B;EC1wuB7B;;ED6wuBA;IACE,yBAAyB;EC9wuB3B;;EDixuBA;IACE,2BAA2B;EClxuB7B;;EDqxuBA;IACE,yBAAyB;ECtxuB3B;;EDyxuBA;IACE,2BAA2B;EC1xuB7B;;ED6xuBA;IACE,yBAAyB;EC9xuB3B;;EDiyuBA;IACE,2BAA2B;EClyuB7B;;EDqyuBA;IACE,yBAAyB;ECtyuB3B;;EDyyuBA;IACE,2BAA2B;EC1yuB7B;;ED6yuBA;IACE,yBAAyB;EC9yuB3B;;EDizuBA;IACE,2BAA2B;EClzuB7B;;EDqzuBA;IACE,yBAAyB;ECtzuB3B;;EDyzuBA;IACE,2BAA2B;EC1zuB7B;;ED6zuBA;IACE,yBAAyB;EC9zuB3B;;EDi0uBA;IACE,2BAA2B;ECl0uB7B;;EDq0uBA;IACE,yBAAyB;ECt0uB3B;;EDy0uBA;IACE,2BAA2B;EC10uB7B;;ED60uBA;IACE,yBAAyB;EC90uB3B;;EDi1uBA;IACE,2BAA2B;ECl1uB7B;;EDq1uBA;IACE,yBAAyB;ECt1uB3B;;EDy1uBA;IACE,2BAA2B;EC11uB7B;;ED61uBA;IACE,yBAAyB;EC91uB3B;;EDi2uBA;IACE,2BAA2B;ECl2uB7B;;EDq2uBA;IACE,yBAAyB;ECt2uB3B;;EDy2uBA;IACE,2BAA2B;EC12uB7B;;ED62uBA;IACE,yBAAyB;EC92uB3B;;EDi3uBA;IACE,2BAA2B;ECl3uB7B;;EDq3uBA;IACE,yBAAyB;ECt3uB3B;;EDy3uBA;IACE,2BAA2B;EC13uB7B;;ED63uBA;IACE,yBAAyB;EC93uB3B;;EDi4uBA;IACE,2BAA2B;ECl4uB7B;;EDq4uBA;IACE,yBAAyB;ECt4uB3B;;EDy4uBA;IACE,2BAA2B;EC14uB7B;;ED64uBA;IACE,yBAAyB;EC94uB3B;;EDi5uBA;IACE,2BAA2B;ECl5uB7B;;EDq5uBA;IACE,yBAAyB;ECt5uB3B;;EDy5uBA;IACE,2BAA2B;EC15uB7B;;ED65uBA;IACE,yBAAyB;EC95uB3B;;EDi6uBA;IACE,2BAA2B;ECl6uB7B;;EDq6uBA;IACE,yBAAyB;ECt6uB3B;;EDy6uBA;IACE,2BAA2B;EC16uB7B;;ED66uBA;IACE,yBAAyB;EC96uB3B;;EDi7uBA;IACE,2BAA2B;ECl7uB7B;;EDq7uBA;IACE,yBAAyB;ECt7uB3B;;EDy7uBA;IACE,2BAA2B;EC17uB7B;;ED67uBA;IACE,yBAAyB;EC97uB3B;;EDi8uBA;IACE,2BAA2B;ECl8uB7B;;EDq8uBA;IACE,yBAAyB;ECt8uB3B;;EDy8uBA;IACE,2BAA2B;EC18uB7B;;ED68uBA;IACE,yBAAyB;EC98uB3B;;EDi9uBA;IACE,2BAA2B;ECl9uB7B;;EDq9uBA;IACE,yBAAyB;ECt9uB3B;;EDy9uBA;IACE,2BAA2B;EC19uB7B;;ED69uBA;IACE,yBAAyB;EC99uB3B;;EDi+uBA;IACE,2BAA2B;ECl+uB7B;;EDq+uBA;IACE,yBAAyB;ECt+uB3B;;EDy+uBA;IACE,2BAA2B;EC1+uB7B;;ED6+uBA;IACE,yBAAyB;EC9+uB3B;;EDi/uBA;IACE,2BAA2B;ECl/uB7B;;EDq/uBA;IACE,yBAAyB;ECt/uB3B;;EDy/uBA;IACE,2BAA2B;EC1/uB7B;;ED6/uBA;IACE,yBAAyB;EC9/uB3B;;EDigvBA;IACE,2BAA2B;EClgvB7B;;EDqgvBA;IACE,yBAAyB;ECtgvB3B;;EDygvBA;IACE,2BAA2B;EC1gvB7B;;ED6gvBA;IACE,yBAAyB;EC9gvB3B;;EDihvBA;IACE,2BAA2B;EClhvB7B;;EDqhvBA;IACE,yBAAyB;ECthvB3B;;EDyhvBA;IACE,2BAA2B;EC1hvB7B;;ED6hvBA;IACE,yBAAyB;EC9hvB3B;;EDiivBA;IACE,2BAA2B;EClivB7B;;EDqivBA;IACE,yBAAyB;ECtivB3B;;EDyivBA;IACE,2BAA2B;EC1ivB7B;;ED6ivBA;IACE,yBAAyB;EC9ivB3B;;EDijvBA;IACE,2BAA2B;ECljvB7B;;EDqjvBA;IACE,yBAAyB;ECtjvB3B;;EDyjvBA;IACE,2BAA2B;EC1jvB7B;;ED6jvBA;IACE,yBAAyB;EC9jvB3B;;EDikvBA;IACE,2BAA2B;EClkvB7B;;EDqkvBA;IACE,yBAAyB;ECtkvB3B;;EDykvBA;IACE,2BAA2B;EC1kvB7B;;ED6kvBA;IACE,yBAAyB;EC9kvB3B;;EDilvBA;IACE,2BAA2B;ECllvB7B;;EDqlvBA;IACE,yBAAyB;ECtlvB3B;;EDylvBA;IACE,2BAA2B;EC1lvB7B;;ED6lvBA;IACE,yBAAyB;EC9lvB3B;;EDimvBA;IACE,2BAA2B;EClmvB7B;;EDqmvBA;IACE,yBAAyB;ECtmvB3B;;EDymvBA;IACE,2BAA2B;EC1mvB7B;;ED6mvBA;IACE,yBAAyB;EC9mvB3B;;EDinvBA;IACE,2BAA2B;EClnvB7B;;EDqnvBA;IACE,yBAAyB;ECtnvB3B;;EDynvBA;IACE,2BAA2B;EC1nvB7B;;ED6nvBA;IACE,yBAAyB;EC9nvB3B;;EDiovBA;IACE,2BAA2B;EClovB7B;;EDqovBA;IACE,yBAAyB;ECtovB3B;;EDyovBA;IACE,2BAA2B;EC1ovB7B;;ED6ovBA;IACE,yBAAyB;EC9ovB3B;;EDipvBA;IACE,2BAA2B;EClpvB7B;;EDqpvBA;IACE,yBAAyB;ECtpvB3B;;EDypvBA;IACE,2BAA2B;ECvovB7B;;ED0ovBA;IACE,yBAAyB;EC3ovB3B;;ED8ovBA;IACE,2BAA2B;EC/ovB7B;;EDkpvBA;IACE,4BAA4B;ECnpvB9B;;EDspvBA;IACE,+BAA+B;ECvpvBjC;;ED0pvBA;IACE,8BAA8B;EC3pvBhC;;ED8pvBA;IACE,4BAA4B;EC/pvB9B;;EDkqvBA;IACE,8BAA8B;ECnqvBhC;;EDsqvBA;IACE,4BAA4B;ECvqvB9B;;ED0qvBA;IACE,8BAA8B;EC3qvBhC;;ED8qvBA;IACE,4BAA4B;EC/qvB9B;;EDkrvBA;IACE,8BAA8B;ECnrvBhC;;EDsrvBA;IACE,4BAA4B;ECvrvB9B;;ED0rvBA;IACE,8BAA8B;EC3rvBhC;;ED8rvBA;IACE,4BAA4B;EC/rvB9B;;EDksvBA;IACE,8BAA8B;ECnsvBhC;;EDssvBA;IACE,4BAA4B;ECvsvB9B;;ED0svBA;IACE,8BAA8B;EC3svBhC;;ED8svBA;IACE,4BAA4B;EC/svB9B;;EDktvBA;IACE,8BAA8B;ECntvBhC;;EDstvBA;IACE,4BAA4B;ECvtvB9B;;ED0tvBA;IACE,8BAA8B;EC3tvBhC;;ED8tvBA;IACE,4BAA4B;EC/tvB9B;;EDkuvBA;IACE,8BAA8B;ECnuvBhC;;EDsuvBA;IACE,6BAA6B;ECvuvB/B;;ED0uvBA;IACE,+BAA+B;EC3uvBjC;;ED8uvBA;IACE,6BAA6B;EC/uvB/B;;EDkvvBA;IACE,+BAA+B;ECnvvBjC;;EDsvvBA;IACE,6BAA6B;ECvvvB/B;;ED0vvBA;IACE,+BAA+B;EC3vvBjC;;ED8vvBA;IACE,6BAA6B;EC/vvB/B;;EDkwvBA;IACE,+BAA+B;ECnwvBjC;;EDswvBA;IACE,6BAA6B;ECvwvB/B;;ED0wvBA;IACE,+BAA+B;EC3wvBjC;;ED8wvBA;IACE,6BAA6B;EC/wvB/B;;EDkxvBA;IACE,+BAA+B;ECnxvBjC;;EDsxvBA;IACE,6BAA6B;ECvxvB/B;;ED0xvBA;IACE,+BAA+B;EC3xvBjC;;ED8xvBA;IACE,6BAA6B;EC/xvB/B;;EDkyvBA;IACE,+BAA+B;ECnyvBjC;;EDsyvBA;IACE,6BAA6B;ECvyvB/B;;ED0yvBA;IACE,+BAA+B;EC3yvBjC;;ED8yvBA;IACE,6BAA6B;EC/yvB/B;;EDkzvBA;IACE,+BAA+B;ECnzvBjC;;EDszvBA;IACE,6BAA6B;ECvzvB/B;;ED0zvBA;IACE,+BAA+B;EC3zvBjC;;ED8zvBA;IACE,6BAA6B;EC/zvB/B;;EDk0vBA;IACE,+BAA+B;ECn0vBjC;;EDs0vBA;IACE,6BAA6B;ECv0vB/B;;ED00vBA;IACE,+BAA+B;EC30vBjC;;ED80vBA;IACE,6BAA6B;EC/0vB/B;;EDk1vBA;IACE,+BAA+B;ECn1vBjC;;EDs1vBA;IACE,6BAA6B;ECv1vB/B;;ED01vBA;IACE,+BAA+B;EC31vBjC;;ED81vBA;IACE,6BAA6B;EC/1vB/B;;EDk2vBA;IACE,+BAA+B;ECn2vBjC;;EDs2vBA;IACE,6BAA6B;ECv2vB/B;;ED02vBA;IACE,+BAA+B;EC32vBjC;;ED82vBA;IACE,6BAA6B;EC/2vB/B;;EDk3vBA;IACE,+BAA+B;ECn3vBjC;;EDs3vBA;IACE,6BAA6B;ECv3vB/B;;ED03vBA;IACE,+BAA+B;EC33vBjC;;ED83vBA;IACE,6BAA6B;EC/3vB/B;;EDk4vBA;IACE,+BAA+B;ECn4vBjC;;EDs4vBA;IACE,6BAA6B;ECv4vB/B;;ED04vBA;IACE,+BAA+B;EC34vBjC;;ED84vBA;IACE,6BAA6B;EC/4vB/B;;EDk5vBA;IACE,+BAA+B;ECn5vBjC;;EDs5vBA;IACE,6BAA6B;ECv5vB/B;;ED05vBA;IACE,+BAA+B;EC35vBjC;;ED85vBA;IACE,6BAA6B;EC/5vB/B;;EDk6vBA;IACE,+BAA+B;ECn6vBjC;;EDs6vBA;IACE,6BAA6B;ECv6vB/B;;ED06vBA;IACE,+BAA+B;EC36vBjC;;ED86vBA;IACE,6BAA6B;EC/6vB/B;;EDk7vBA;IACE,+BAA+B;ECn7vBjC;;EDs7vBA;IACE,6BAA6B;ECv7vB/B;;ED07vBA;IACE,+BAA+B;EC37vBjC;;ED87vBA;IACE,6BAA6B;EC/7vB/B;;EDk8vBA;IACE,+BAA+B;ECn8vBjC;;EDs8vBA;IACE,6BAA6B;ECv8vB/B;;ED08vBA;IACE,+BAA+B;EC38vBjC;;ED88vBA;IACE,6BAA6B;EC/8vB/B;;EDk9vBA;IACE,+BAA+B;ECn9vBjC;;EDs9vBA;IACE,6BAA6B;ECv9vB/B;;ED09vBA;IACE,+BAA+B;EC39vBjC;;ED89vBA;IACE,6BAA6B;EC/9vB/B;;EDk+vBA;IACE,+BAA+B;ECn+vBjC;;EDs+vBA;IACE,6BAA6B;ECv+vB/B;;ED0+vBA;IACE,+BAA+B;EC3+vBjC;;ED8+vBA;IACE,6BAA6B;EC/+vB/B;;EDk/vBA;IACE,+BAA+B;ECn/vBjC;;EDs/vBA;IACE,6BAA6B;ECv/vB/B;;ED0/vBA;IACE,+BAA+B;EC3/vBjC;;ED8/vBA;IACE,6BAA6B;EC//vB/B;;EDkgwBA;IACE,+BAA+B;ECngwBjC;;EDsgwBA;IACE,6BAA6B;ECvgwB/B;;ED0gwBA;IACE,+BAA+B;EC3gwBjC;;ED8gwBA;IACE,6BAA6B;EC/gwB/B;;EDkhwBA;IACE,+BAA+B;ECnhwBjC;;EDshwBA;IACE,6BAA6B;ECvhwB/B;;ED0hwBA;IACE,+BAA+B;EC3hwBjC;;ED8hwBA;IACE,6BAA6B;EC/hwB/B;;EDkiwBA;IACE,+BAA+B;ECniwBjC;;EDsiwBA;IACE,6BAA6B;ECviwB/B;;ED0iwBA;IACE,+BAA+B;EC3iwBjC;;ED8iwBA;IACE,6BAA6B;EC/iwB/B;;EDkjwBA;IACE,+BAA+B;ECnjwBjC;;EDsjwBA;IACE,6BAA6B;ECvjwB/B;;ED0jwBA;IACE,+BAA+B;EC3jwBjC;;ED8jwBA;IACE,6BAA6B;EC/jwB/B;;EDkkwBA;IACE,+BAA+B;ECnkwBjC;;EDskwBA;IACE,6BAA6B;ECvkwB/B;;ED0kwBA;IACE,+BAA+B;EC3kwBjC;;ED8kwBA;IACE,6BAA6B;EC/kwB/B;;EDklwBA;IACE,+BAA+B;ECnlwBjC;;EDslwBA;IACE,6BAA6B;ECvlwB/B;;ED0lwBA;IACE,+BAA+B;EC3lwBjC;;ED8lwBA;IACE,6BAA6B;EC/lwB/B;;EDkmwBA;IACE,+BAA+B;ECnmwBjC;;EDsmwBA;IACE,6BAA6B;ECvmwB/B;;ED0mwBA;IACE,+BAA+B;EC3mwBjC;;ED8mwBA;IACE,6BAA6B;EC/mwB/B;;EDknwBA;IACE,+BAA+B;ECnnwBjC;;EDsnwBA;IACE,6BAA6B;ECvnwB/B;;ED0nwBA;IACE,+BAA+B;EC3nwBjC;;ED8nwBA;IACE,6BAA6B;EC/nwB/B;;EDkowBA;IACE,+BAA+B;ECnowBjC;;EDsowBA;IACE,6BAA6B;ECvowB/B;;ED0owBA;IACE,+BAA+B;EC3owBjC;;ED8owBA;IACE,6BAA6B;EC/owB/B;;EDkpwBA;IACE,+BAA+B;ECnpwBjC;;EDspwBA;IACE,6BAA6B;ECvpwB/B;;ED0pwBA;IACE,+BAA+B;EC3pwBjC;;ED8pwBA;IACE,6BAA6B;EC/pwB/B;;EDkqwBA;IACE,+BAA+B;ECnqwBjC;;EDsqwBA;IACE,6BAA6B;ECvqwB/B;;ED0qwBA;IACE,+BAA+B;EC3qwBjC;;ED8qwBA;IACE,6BAA6B;EC/qwB/B;;EDkrwBA;IACE,+BAA+B;ECnrwBjC;;EDsrwBA;IACE,6BAA6B;ECvrwB/B;;ED0rwBA;IACE,+BAA+B;EC3rwBjC;;ED8rwBA;IACE,6BAA6B;EC/rwB/B;;EDkswBA;IACE,+BAA+B;ECnswBjC;;EDsswBA;IACE,6BAA6B;ECvswB/B;;ED0swBA;IACE,+BAA+B;EC3swBjC;;ED8swBA;IACE,6BAA6B;EC/swB/B;;EDktwBA;IACE,+BAA+B;ECntwBjC;;EDstwBA;IACE,6BAA6B;ECvtwB/B;;ED0twBA;IACE,+BAA+B;EC3twBjC;;ED8twBA;IACE,6BAA6B;EC/twB/B;;EDkuwBA;IACE,+BAA+B;ECnuwBjC;;EDsuwBA;IACE,6BAA6B;ECvuwB/B;;ED0uwBA;IACE,+BAA+B;EC3uwBjC;;ED8uwBA;IACE,6BAA6B;EC/uwB/B;;EDkvwBA;IACE,+BAA+B;ECnvwBjC;;EDsvwBA;IACE,6BAA6B;ECvvwB/B;;ED0vwBA;IACE,+BAA+B;EC3vwBjC;;ED8vwBA;IACE,6BAA6B;EC/vwB/B;;EDkwwBA;IACE,+BAA+B;ECnwwBjC;;EDswwBA;IACE,6BAA6B;ECvwwB/B;;ED0wwBA;IACE,+BAA+B;ECxvwBjC;;ED2vwBA;IACE,6BAA6B;EC5vwB/B;;ED+vwBA;IACE,+BAA+B;EChwwBjC;;EDmwwBA;IACE,+BAA+B;ECpwwBjC;;EDuwwBA;IACE,kCAAkC;ECxwwBpC;;ED2wwBA;IACE,iCAAiC;EC5wwBnC;;ED+wwBA;IACE,+BAA+B;EChxwBjC;;EDmxwBA;IACE,iCAAiC;ECpxwBnC;;EDuxwBA;IACE,+BAA+B;ECxxwBjC;;ED2xwBA;IACE,iCAAiC;EC5xwBnC;;ED+xwBA;IACE,+BAA+B;EChywBjC;;EDmywBA;IACE,iCAAiC;ECpywBnC;;EDuywBA;IACE,+BAA+B;ECxywBjC;;ED2ywBA;IACE,iCAAiC;EC5ywBnC;;ED+ywBA;IACE,+BAA+B;EChzwBjC;;EDmzwBA;IACE,iCAAiC;ECpzwBnC;;EDuzwBA;IACE,+BAA+B;ECxzwBjC;;ED2zwBA;IACE,iCAAiC;EC5zwBnC;;ED+zwBA;IACE,+BAA+B;ECh0wBjC;;EDm0wBA;IACE,iCAAiC;ECp0wBnC;;EDu0wBA;IACE,+BAA+B;ECx0wBjC;;ED20wBA;IACE,iCAAiC;EC50wBnC;;ED+0wBA;IACE,+BAA+B;ECh1wBjC;;EDm1wBA;IACE,iCAAiC;ECp1wBnC;;EDu1wBA;IACE,gCAAgC;ECx1wBlC;;ED21wBA;IACE,kCAAkC;EC51wBpC;;ED+1wBA;IACE,gCAAgC;ECh2wBlC;;EDm2wBA;IACE,kCAAkC;ECp2wBpC;;EDu2wBA;IACE,gCAAgC;ECx2wBlC;;ED22wBA;IACE,kCAAkC;EC52wBpC;;ED+2wBA;IACE,gCAAgC;ECh3wBlC;;EDm3wBA;IACE,kCAAkC;ECp3wBpC;;EDu3wBA;IACE,gCAAgC;ECx3wBlC;;ED23wBA;IACE,kCAAkC;EC53wBpC;;ED+3wBA;IACE,gCAAgC;ECh4wBlC;;EDm4wBA;IACE,kCAAkC;ECp4wBpC;;EDu4wBA;IACE,gCAAgC;ECx4wBlC;;ED24wBA;IACE,kCAAkC;EC54wBpC;;ED+4wBA;IACE,gCAAgC;ECh5wBlC;;EDm5wBA;IACE,kCAAkC;ECp5wBpC;;EDu5wBA;IACE,gCAAgC;ECx5wBlC;;ED25wBA;IACE,kCAAkC;EC55wBpC;;ED+5wBA;IACE,gCAAgC;ECh6wBlC;;EDm6wBA;IACE,kCAAkC;ECp6wBpC;;EDu6wBA;IACE,gCAAgC;ECx6wBlC;;ED26wBA;IACE,kCAAkC;EC56wBpC;;ED+6wBA;IACE,gCAAgC;ECh7wBlC;;EDm7wBA;IACE,kCAAkC;ECp7wBpC;;EDu7wBA;IACE,gCAAgC;ECx7wBlC;;ED27wBA;IACE,kCAAkC;EC57wBpC;;ED+7wBA;IACE,gCAAgC;ECh8wBlC;;EDm8wBA;IACE,kCAAkC;ECp8wBpC;;EDu8wBA;IACE,gCAAgC;ECx8wBlC;;ED28wBA;IACE,kCAAkC;EC58wBpC;;ED+8wBA;IACE,gCAAgC;ECh9wBlC;;EDm9wBA;IACE,kCAAkC;ECp9wBpC;;EDu9wBA;IACE,gCAAgC;ECx9wBlC;;ED29wBA;IACE,kCAAkC;EC59wBpC;;ED+9wBA;IACE,gCAAgC;ECh+wBlC;;EDm+wBA;IACE,kCAAkC;ECp+wBpC;;EDu+wBA;IACE,gCAAgC;ECx+wBlC;;ED2+wBA;IACE,kCAAkC;EC5+wBpC;;ED++wBA;IACE,gCAAgC;ECh/wBlC;;EDm/wBA;IACE,kCAAkC;ECp/wBpC;;EDu/wBA;IACE,gCAAgC;ECx/wBlC;;ED2/wBA;IACE,kCAAkC;EC5/wBpC;;ED+/wBA;IACE,gCAAgC;EChgxBlC;;EDmgxBA;IACE,kCAAkC;ECpgxBpC;;EDugxBA;IACE,gCAAgC;ECxgxBlC;;ED2gxBA;IACE,kCAAkC;EC5gxBpC;;ED+gxBA;IACE,gCAAgC;EChhxBlC;;EDmhxBA;IACE,kCAAkC;ECphxBpC;;EDuhxBA;IACE,gCAAgC;ECxhxBlC;;ED2hxBA;IACE,kCAAkC;EC5hxBpC;;ED+hxBA;IACE,gCAAgC;EChixBlC;;EDmixBA;IACE,kCAAkC;ECpixBpC;;EDuixBA;IACE,gCAAgC;ECxixBlC;;ED2ixBA;IACE,kCAAkC;EC5ixBpC;;ED+ixBA;IACE,gCAAgC;EChjxBlC;;EDmjxBA;IACE,kCAAkC;ECpjxBpC;;EDujxBA;IACE,gCAAgC;ECxjxBlC;;ED2jxBA;IACE,kCAAkC;EC5jxBpC;;ED+jxBA;IACE,gCAAgC;EChkxBlC;;EDmkxBA;IACE,kCAAkC;ECpkxBpC;;EDukxBA;IACE,gCAAgC;ECxkxBlC;;ED2kxBA;IACE,kCAAkC;EC5kxBpC;;ED+kxBA;IACE,gCAAgC;EChlxBlC;;EDmlxBA;IACE,kCAAkC;ECplxBpC;;EDulxBA;IACE,gCAAgC;ECxlxBlC;;ED2lxBA;IACE,kCAAkC;EC5lxBpC;;ED+lxBA;IACE,gCAAgC;EChmxBlC;;EDmmxBA;IACE,kCAAkC;ECpmxBpC;;EDumxBA;IACE,gCAAgC;ECxmxBlC;;ED2mxBA;IACE,kCAAkC;EC5mxBpC;;ED+mxBA;IACE,gCAAgC;EChnxBlC;;EDmnxBA;IACE,kCAAkC;ECpnxBpC;;EDunxBA;IACE,gCAAgC;ECxnxBlC;;ED2nxBA;IACE,kCAAkC;EC5nxBpC;;ED+nxBA;IACE,gCAAgC;EChoxBlC;;EDmoxBA;IACE,kCAAkC;ECpoxBpC;;EDuoxBA;IACE,gCAAgC;ECxoxBlC;;ED2oxBA;IACE,kCAAkC;EC5oxBpC;;ED+oxBA;IACE,gCAAgC;EChpxBlC;;EDmpxBA;IACE,kCAAkC;ECppxBpC;;EDupxBA;IACE,gCAAgC;ECxpxBlC;;ED2pxBA;IACE,kCAAkC;EC5pxBpC;;ED+pxBA;IACE,gCAAgC;EChqxBlC;;EDmqxBA;IACE,kCAAkC;ECpqxBpC;;EDuqxBA;IACE,gCAAgC;ECxqxBlC;;ED2qxBA;IACE,kCAAkC;EC5qxBpC;;ED+qxBA;IACE,gCAAgC;EChrxBlC;;EDmrxBA;IACE,kCAAkC;ECprxBpC;;EDurxBA;IACE,gCAAgC;ECxrxBlC;;ED2rxBA;IACE,kCAAkC;EC5rxBpC;;ED+rxBA;IACE,gCAAgC;EChsxBlC;;EDmsxBA;IACE,kCAAkC;ECpsxBpC;;EDusxBA;IACE,gCAAgC;ECxsxBlC;;ED2sxBA;IACE,kCAAkC;EC5sxBpC;;ED+sxBA;IACE,gCAAgC;EChtxBlC;;EDmtxBA;IACE,kCAAkC;ECptxBpC;;EDutxBA;IACE,gCAAgC;ECxtxBlC;;ED2txBA;IACE,kCAAkC;EC5txBpC;;ED+txBA;IACE,gCAAgC;EChuxBlC;;EDmuxBA;IACE,kCAAkC;ECpuxBpC;;EDuuxBA;IACE,gCAAgC;ECxuxBlC;;ED2uxBA;IACE,kCAAkC;EC5uxBpC;;ED+uxBA;IACE,gCAAgC;EChvxBlC;;EDmvxBA;IACE,kCAAkC;ECpvxBpC;;EDuvxBA;IACE,gCAAgC;ECxvxBlC;;ED2vxBA;IACE,kCAAkC;EC5vxBpC;;ED+vxBA;IACE,gCAAgC;EChwxBlC;;EDmwxBA;IACE,kCAAkC;ECpwxBpC;;EDuwxBA;IACE,gCAAgC;ECxwxBlC;;ED2wxBA;IACE,kCAAkC;EC5wxBpC;;ED+wxBA;IACE,gCAAgC;EChxxBlC;;EDmxxBA;IACE,kCAAkC;ECpxxBpC;;EDuxxBA;IACE,gCAAgC;ECxxxBlC;;ED2xxBA;IACE,kCAAkC;EC5xxBpC;;ED+xxBA;IACE,gCAAgC;EChyxBlC;;EDmyxBA;IACE,kCAAkC;ECpyxBpC;;EDuyxBA;IACE,gCAAgC;ECxyxBlC;;ED2yxBA;IACE,kCAAkC;EC5yxBpC;;ED+yxBA;IACE,gCAAgC;EChzxBlC;;EDmzxBA;IACE,kCAAkC;ECpzxBpC;;EDuzxBA;IACE,gCAAgC;ECxzxBlC;;ED2zxBA;IACE,kCAAkC;EC5zxBpC;;ED+zxBA;IACE,gCAAgC;ECh0xBlC;;EDm0xBA;IACE,kCAAkC;ECp0xBpC;;EDu0xBA;IACE,gCAAgC;ECx0xBlC;;ED20xBA;IACE,kCAAkC;EC50xBpC;;ED+0xBA;IACE,gCAAgC;ECh1xBlC;;EDm1xBA;IACE,kCAAkC;ECp1xBpC;;EDu1xBA;IACE,gCAAgC;ECx1xBlC;;ED21xBA;IACE,kCAAkC;EC51xBpC;;ED+1xBA;IACE,gCAAgC;ECh2xBlC;;EDm2xBA;IACE,kCAAkC;ECp2xBpC;;EDu2xBA;IACE,gCAAgC;ECx2xBlC;;ED22xBA;IACE,kCAAkC;EC52xBpC;;ED+2xBA;IACE,gCAAgC;ECh3xBlC;;EDm3xBA;IACE,kCAAkC;ECp3xBpC;;EDu3xBA;IACE,gCAAgC;ECx3xBlC;;ED23xBA;IACE,kCAAkC;ECz2xBpC;;ED42xBA;IACE,gCAAgC;EC72xBlC;;EDg3xBA;IACE,kCAAkC;ECj3xBpC;;EDo3xBA;IACE,6BAA6B;ECr3xB/B;;EDw3xBA;IACE,gCAAgC;ECz3xBlC;;ED43xBA;IACE,+BAA+B;EC73xBjC;;EDg4xBA;IACE,6BAA6B;ECj4xB/B;;EDo4xBA;IACE,+BAA+B;ECr4xBjC;;EDw4xBA;IACE,6BAA6B;ECz4xB/B;;ED44xBA;IACE,+BAA+B;EC74xBjC;;EDg5xBA;IACE,6BAA6B;ECj5xB/B;;EDo5xBA;IACE,+BAA+B;ECr5xBjC;;EDw5xBA;IACE,6BAA6B;ECz5xB/B;;ED45xBA;IACE,+BAA+B;EC75xBjC;;EDg6xBA;IACE,6BAA6B;ECj6xB/B;;EDo6xBA;IACE,+BAA+B;ECr6xBjC;;EDw6xBA;IACE,6BAA6B;ECz6xB/B;;ED46xBA;IACE,+BAA+B;EC76xBjC;;EDg7xBA;IACE,6BAA6B;ECj7xB/B;;EDo7xBA;IACE,+BAA+B;ECr7xBjC;;EDw7xBA;IACE,6BAA6B;ECz7xB/B;;ED47xBA;IACE,+BAA+B;EC77xBjC;;EDg8xBA;IACE,6BAA6B;ECj8xB/B;;EDo8xBA;IACE,+BAA+B;ECr8xBjC;;EDw8xBA;IACE,8BAA8B;ECz8xBhC;;ED48xBA;IACE,gCAAgC;EC78xBlC;;EDg9xBA;IACE,8BAA8B;ECj9xBhC;;EDo9xBA;IACE,gCAAgC;ECr9xBlC;;EDw9xBA;IACE,8BAA8B;ECz9xBhC;;ED49xBA;IACE,gCAAgC;EC79xBlC;;EDg+xBA;IACE,8BAA8B;ECj+xBhC;;EDo+xBA;IACE,gCAAgC;ECr+xBlC;;EDw+xBA;IACE,8BAA8B;ECz+xBhC;;ED4+xBA;IACE,gCAAgC;EC7+xBlC;;EDg/xBA;IACE,8BAA8B;ECj/xBhC;;EDo/xBA;IACE,gCAAgC;ECr/xBlC;;EDw/xBA;IACE,8BAA8B;ECz/xBhC;;ED4/xBA;IACE,gCAAgC;EC7/xBlC;;EDggyBA;IACE,8BAA8B;ECjgyBhC;;EDogyBA;IACE,gCAAgC;ECrgyBlC;;EDwgyBA;IACE,8BAA8B;ECzgyBhC;;ED4gyBA;IACE,gCAAgC;EC7gyBlC;;EDghyBA;IACE,8BAA8B;ECjhyBhC;;EDohyBA;IACE,gCAAgC;ECrhyBlC;;EDwhyBA;IACE,8BAA8B;ECzhyBhC;;ED4hyBA;IACE,gCAAgC;EC7hyBlC;;EDgiyBA;IACE,8BAA8B;ECjiyBhC;;EDoiyBA;IACE,gCAAgC;ECriyBlC;;EDwiyBA;IACE,8BAA8B;ECziyBhC;;ED4iyBA;IACE,gCAAgC;EC7iyBlC;;EDgjyBA;IACE,8BAA8B;ECjjyBhC;;EDojyBA;IACE,gCAAgC;ECrjyBlC;;EDwjyBA;IACE,8BAA8B;ECzjyBhC;;ED4jyBA;IACE,gCAAgC;EC7jyBlC;;EDgkyBA;IACE,8BAA8B;ECjkyBhC;;EDokyBA;IACE,gCAAgC;ECrkyBlC;;EDwkyBA;IACE,8BAA8B;ECzkyBhC;;ED4kyBA;IACE,gCAAgC;EC7kyBlC;;EDglyBA;IACE,8BAA8B;ECjlyBhC;;EDolyBA;IACE,gCAAgC;ECrlyBlC;;EDwlyBA;IACE,8BAA8B;ECzlyBhC;;ED4lyBA;IACE,gCAAgC;EC7lyBlC;;EDgmyBA;IACE,8BAA8B;ECjmyBhC;;EDomyBA;IACE,gCAAgC;ECrmyBlC;;EDwmyBA;IACE,8BAA8B;ECzmyBhC;;ED4myBA;IACE,gCAAgC;EC7myBlC;;EDgnyBA;IACE,8BAA8B;ECjnyBhC;;EDonyBA;IACE,gCAAgC;ECrnyBlC;;EDwnyBA;IACE,8BAA8B;ECznyBhC;;ED4nyBA;IACE,gCAAgC;EC7nyBlC;;EDgoyBA;IACE,8BAA8B;ECjoyBhC;;EDooyBA;IACE,gCAAgC;ECroyBlC;;EDwoyBA;IACE,8BAA8B;ECzoyBhC;;ED4oyBA;IACE,gCAAgC;EC7oyBlC;;EDgpyBA;IACE,8BAA8B;ECjpyBhC;;EDopyBA;IACE,gCAAgC;ECrpyBlC;;EDwpyBA;IACE,8BAA8B;ECzpyBhC;;ED4pyBA;IACE,gCAAgC;EC7pyBlC;;EDgqyBA;IACE,8BAA8B;ECjqyBhC;;EDoqyBA;IACE,gCAAgC;ECrqyBlC;;EDwqyBA;IACE,8BAA8B;ECzqyBhC;;ED4qyBA;IACE,gCAAgC;EC7qyBlC;;EDgryBA;IACE,8BAA8B;ECjryBhC;;EDoryBA;IACE,gCAAgC;ECrryBlC;;EDwryBA;IACE,8BAA8B;ECzryBhC;;ED4ryBA;IACE,gCAAgC;EC7ryBlC;;EDgsyBA;IACE,8BAA8B;ECjsyBhC;;EDosyBA;IACE,gCAAgC;ECrsyBlC;;EDwsyBA;IACE,8BAA8B;ECzsyBhC;;ED4syBA;IACE,gCAAgC;EC7syBlC;;EDgtyBA;IACE,8BAA8B;ECjtyBhC;;EDotyBA;IACE,gCAAgC;ECrtyBlC;;EDwtyBA;IACE,8BAA8B;ECztyBhC;;ED4tyBA;IACE,gCAAgC;EC7tyBlC;;EDguyBA;IACE,8BAA8B;ECjuyBhC;;EDouyBA;IACE,gCAAgC;ECruyBlC;;EDwuyBA;IACE,8BAA8B;ECzuyBhC;;ED4uyBA;IACE,gCAAgC;EC7uyBlC;;EDgvyBA;IACE,8BAA8B;ECjvyBhC;;EDovyBA;IACE,gCAAgC;ECrvyBlC;;EDwvyBA;IACE,8BAA8B;ECzvyBhC;;ED4vyBA;IACE,gCAAgC;EC7vyBlC;;EDgwyBA;IACE,8BAA8B;ECjwyBhC;;EDowyBA;IACE,gCAAgC;ECrwyBlC;;EDwwyBA;IACE,8BAA8B;ECzwyBhC;;ED4wyBA;IACE,gCAAgC;EC7wyBlC;;EDgxyBA;IACE,8BAA8B;ECjxyBhC;;EDoxyBA;IACE,gCAAgC;ECrxyBlC;;EDwxyBA;IACE,8BAA8B;ECzxyBhC;;ED4xyBA;IACE,gCAAgC;EC7xyBlC;;EDgyyBA;IACE,8BAA8B;ECjyyBhC;;EDoyyBA;IACE,gCAAgC;ECryyBlC;;EDwyyBA;IACE,8BAA8B;ECzyyBhC;;ED4yyBA;IACE,gCAAgC;EC7yyBlC;;EDgzyBA;IACE,8BAA8B;ECjzyBhC;;EDozyBA;IACE,gCAAgC;ECrzyBlC;;EDwzyBA;IACE,8BAA8B;ECzzyBhC;;ED4zyBA;IACE,gCAAgC;EC7zyBlC;;EDg0yBA;IACE,8BAA8B;ECj0yBhC;;EDo0yBA;IACE,gCAAgC;ECr0yBlC;;EDw0yBA;IACE,8BAA8B;ECz0yBhC;;ED40yBA;IACE,gCAAgC;EC70yBlC;;EDg1yBA;IACE,8BAA8B;ECj1yBhC;;EDo1yBA;IACE,gCAAgC;ECr1yBlC;;EDw1yBA;IACE,8BAA8B;ECz1yBhC;;ED41yBA;IACE,gCAAgC;EC71yBlC;;EDg2yBA;IACE,8BAA8B;ECj2yBhC;;EDo2yBA;IACE,gCAAgC;ECr2yBlC;;EDw2yBA;IACE,8BAA8B;ECz2yBhC;;ED42yBA;IACE,gCAAgC;EC72yBlC;;EDg3yBA;IACE,8BAA8B;ECj3yBhC;;EDo3yBA;IACE,gCAAgC;ECr3yBlC;;EDw3yBA;IACE,8BAA8B;ECz3yBhC;;ED43yBA;IACE,gCAAgC;EC73yBlC;;EDg4yBA;IACE,8BAA8B;ECj4yBhC;;EDo4yBA;IACE,gCAAgC;ECr4yBlC;;EDw4yBA;IACE,8BAA8B;ECz4yBhC;;ED44yBA;IACE,gCAAgC;EC74yBlC;;EDg5yBA;IACE,8BAA8B;ECj5yBhC;;EDo5yBA;IACE,gCAAgC;ECr5yBlC;;EDw5yBA;IACE,8BAA8B;ECz5yBhC;;ED45yBA;IACE,gCAAgC;EC75yBlC;;EDg6yBA;IACE,8BAA8B;ECj6yBhC;;EDo6yBA;IACE,gCAAgC;ECr6yBlC;;EDw6yBA;IACE,8BAA8B;ECz6yBhC;;ED46yBA;IACE,gCAAgC;EC76yBlC;;EDg7yBA;IACE,8BAA8B;ECj7yBhC;;EDo7yBA;IACE,gCAAgC;ECr7yBlC;;EDw7yBA;IACE,8BAA8B;ECz7yBhC;;ED47yBA;IACE,gCAAgC;EC77yBlC;;EDg8yBA;IACE,8BAA8B;ECj8yBhC;;EDo8yBA;IACE,gCAAgC;ECr8yBlC;;EDw8yBA;IACE,8BAA8B;ECz8yBhC;;ED48yBA;IACE,gCAAgC;EC78yBlC;;EDg9yBA;IACE,8BAA8B;ECj9yBhC;;EDo9yBA;IACE,gCAAgC;ECr9yBlC;;EDw9yBA;IACE,8BAA8B;ECz9yBhC;;ED49yBA;IACE,gCAAgC;EC79yBlC;;EDg+yBA;IACE,8BAA8B;ECj+yBhC;;EDo+yBA;IACE,gCAAgC;ECr+yBlC;;EDw+yBA;IACE,8BAA8B;ECz+yBhC;;ED4+yBA;IACE,gCAAgC;EC19yBlC;;ED69yBA;IACE,8BAA8B;EC99yBhC;;EDi+yBA;IACE,gCAAgC;ECl+yBlC;;EDq+yBA;IACE,8BAA8B;ECt+yBhC;;EDy+yBA;IACE,iCAAiC;EC1+yBnC;;ED6+yBA;IACE,gCAAgC;EC9+yBlC;;EDi/yBA;IACE,8BAA8B;ECl/yBhC;;EDq/yBA;IACE,gCAAgC;ECt/yBlC;;EDy/yBA;IACE,8BAA8B;EC1/yBhC;;ED6/yBA;IACE,gCAAgC;EC9/yBlC;;EDigzBA;IACE,8BAA8B;EClgzBhC;;EDqgzBA;IACE,gCAAgC;ECtgzBlC;;EDygzBA;IACE,8BAA8B;EC1gzBhC;;ED6gzBA;IACE,gCAAgC;EC9gzBlC;;EDihzBA;IACE,8BAA8B;EClhzBhC;;EDqhzBA;IACE,gCAAgC;ECthzBlC;;EDyhzBA;IACE,8BAA8B;EC1hzBhC;;ED6hzBA;IACE,gCAAgC;EC9hzBlC;;EDiizBA;IACE,8BAA8B;EClizBhC;;EDqizBA;IACE,gCAAgC;ECtizBlC;;EDyizBA;IACE,8BAA8B;EC1izBhC;;ED6izBA;IACE,gCAAgC;EC9izBlC;;EDijzBA;IACE,8BAA8B;ECljzBhC;;EDqjzBA;IACE,gCAAgC;ECtjzBlC;;EDyjzBA;IACE,+BAA+B;EC1jzBjC;;ED6jzBA;IACE,iCAAiC;EC9jzBnC;;EDikzBA;IACE,+BAA+B;EClkzBjC;;EDqkzBA;IACE,iCAAiC;ECtkzBnC;;EDykzBA;IACE,+BAA+B;EC1kzBjC;;ED6kzBA;IACE,iCAAiC;EC9kzBnC;;EDilzBA;IACE,+BAA+B;ECllzBjC;;EDqlzBA;IACE,iCAAiC;ECtlzBnC;;EDylzBA;IACE,+BAA+B;EC1lzBjC;;ED6lzBA;IACE,iCAAiC;EC9lzBnC;;EDimzBA;IACE,+BAA+B;EClmzBjC;;EDqmzBA;IACE,iCAAiC;ECtmzBnC;;EDymzBA;IACE,+BAA+B;EC1mzBjC;;ED6mzBA;IACE,iCAAiC;EC9mzBnC;;EDinzBA;IACE,+BAA+B;EClnzBjC;;EDqnzBA;IACE,iCAAiC;ECtnzBnC;;EDynzBA;IACE,+BAA+B;EC1nzBjC;;ED6nzBA;IACE,iCAAiC;EC9nzBnC;;EDiozBA;IACE,+BAA+B;EClozBjC;;EDqozBA;IACE,iCAAiC;ECtozBnC;;EDyozBA;IACE,+BAA+B;EC1ozBjC;;ED6ozBA;IACE,iCAAiC;EC9ozBnC;;EDipzBA;IACE,+BAA+B;EClpzBjC;;EDqpzBA;IACE,iCAAiC;ECtpzBnC;;EDypzBA;IACE,+BAA+B;EC1pzBjC;;ED6pzBA;IACE,iCAAiC;EC9pzBnC;;EDiqzBA;IACE,+BAA+B;EClqzBjC;;EDqqzBA;IACE,iCAAiC;ECtqzBnC;;EDyqzBA;IACE,+BAA+B;EC1qzBjC;;ED6qzBA;IACE,iCAAiC;EC9qzBnC;;EDirzBA;IACE,+BAA+B;EClrzBjC;;EDqrzBA;IACE,iCAAiC;ECtrzBnC;;EDyrzBA;IACE,+BAA+B;EC1rzBjC;;ED6rzBA;IACE,iCAAiC;EC9rzBnC;;EDiszBA;IACE,+BAA+B;EClszBjC;;EDqszBA;IACE,iCAAiC;ECtszBnC;;EDyszBA;IACE,+BAA+B;EC1szBjC;;ED6szBA;IACE,iCAAiC;EC9szBnC;;EDitzBA;IACE,+BAA+B;ECltzBjC;;EDqtzBA;IACE,iCAAiC;ECttzBnC;;EDytzBA;IACE,+BAA+B;EC1tzBjC;;ED6tzBA;IACE,iCAAiC;EC9tzBnC;;EDiuzBA;IACE,+BAA+B;ECluzBjC;;EDquzBA;IACE,iCAAiC;ECtuzBnC;;EDyuzBA;IACE,+BAA+B;EC1uzBjC;;ED6uzBA;IACE,iCAAiC;EC9uzBnC;;EDivzBA;IACE,+BAA+B;EClvzBjC;;EDqvzBA;IACE,iCAAiC;ECtvzBnC;;EDyvzBA;IACE,+BAA+B;EC1vzBjC;;ED6vzBA;IACE,iCAAiC;EC9vzBnC;;EDiwzBA;IACE,+BAA+B;EClwzBjC;;EDqwzBA;IACE,iCAAiC;ECtwzBnC;;EDywzBA;IACE,+BAA+B;EC1wzBjC;;ED6wzBA;IACE,iCAAiC;EC9wzBnC;;EDixzBA;IACE,+BAA+B;EClxzBjC;;EDqxzBA;IACE,iCAAiC;ECtxzBnC;;EDyxzBA;IACE,+BAA+B;EC1xzBjC;;ED6xzBA;IACE,iCAAiC;EC9xzBnC;;EDiyzBA;IACE,+BAA+B;EClyzBjC;;EDqyzBA;IACE,iCAAiC;ECtyzBnC;;EDyyzBA;IACE,+BAA+B;EC1yzBjC;;ED6yzBA;IACE,iCAAiC;EC9yzBnC;;EDizzBA;IACE,+BAA+B;EClzzBjC;;EDqzzBA;IACE,iCAAiC;ECtzzBnC;;EDyzzBA;IACE,+BAA+B;EC1zzBjC;;ED6zzBA;IACE,iCAAiC;EC9zzBnC;;EDi0zBA;IACE,+BAA+B;ECl0zBjC;;EDq0zBA;IACE,iCAAiC;ECt0zBnC;;EDy0zBA;IACE,+BAA+B;EC10zBjC;;ED60zBA;IACE,iCAAiC;EC90zBnC;;EDi1zBA;IACE,+BAA+B;ECl1zBjC;;EDq1zBA;IACE,iCAAiC;ECt1zBnC;;EDy1zBA;IACE,+BAA+B;EC11zBjC;;ED61zBA;IACE,iCAAiC;EC91zBnC;;EDi2zBA;IACE,+BAA+B;ECl2zBjC;;EDq2zBA;IACE,iCAAiC;ECt2zBnC;;EDy2zBA;IACE,+BAA+B;EC12zBjC;;ED62zBA;IACE,iCAAiC;EC92zBnC;;EDi3zBA;IACE,+BAA+B;ECl3zBjC;;EDq3zBA;IACE,iCAAiC;ECt3zBnC;;EDy3zBA;IACE,+BAA+B;EC13zBjC;;ED63zBA;IACE,iCAAiC;EC93zBnC;;EDi4zBA;IACE,+BAA+B;ECl4zBjC;;EDq4zBA;IACE,iCAAiC;ECt4zBnC;;EDy4zBA;IACE,+BAA+B;EC14zBjC;;ED64zBA;IACE,iCAAiC;EC94zBnC;;EDi5zBA;IACE,+BAA+B;ECl5zBjC;;EDq5zBA;IACE,iCAAiC;ECt5zBnC;;EDy5zBA;IACE,+BAA+B;EC15zBjC;;ED65zBA;IACE,iCAAiC;EC95zBnC;;EDi6zBA;IACE,+BAA+B;ECl6zBjC;;EDq6zBA;IACE,iCAAiC;ECt6zBnC;;EDy6zBA;IACE,+BAA+B;EC16zBjC;;ED66zBA;IACE,iCAAiC;EC96zBnC;;EDi7zBA;IACE,+BAA+B;ECl7zBjC;;EDq7zBA;IACE,iCAAiC;ECt7zBnC;;EDy7zBA;IACE,+BAA+B;EC17zBjC;;ED67zBA;IACE,iCAAiC;EC97zBnC;;EDi8zBA;IACE,+BAA+B;ECl8zBjC;;EDq8zBA;IACE,iCAAiC;ECt8zBnC;;EDy8zBA;IACE,+BAA+B;EC18zBjC;;ED68zBA;IACE,iCAAiC;EC98zBnC;;EDi9zBA;IACE,+BAA+B;ECl9zBjC;;EDq9zBA;IACE,iCAAiC;ECt9zBnC;;EDy9zBA;IACE,+BAA+B;EC19zBjC;;ED69zBA;IACE,iCAAiC;EC99zBnC;;EDi+zBA;IACE,+BAA+B;ECl+zBjC;;EDq+zBA;IACE,iCAAiC;ECt+zBnC;;EDy+zBA;IACE,+BAA+B;EC1+zBjC;;ED6+zBA;IACE,iCAAiC;EC9+zBnC;;EDi/zBA;IACE,+BAA+B;ECl/zBjC;;EDq/zBA;IACE,iCAAiC;ECt/zBnC;;EDy/zBA;IACE,+BAA+B;EC1/zBjC;;ED6/zBA;IACE,iCAAiC;EC9/zBnC;;EDig0BA;IACE,+BAA+B;EClg0BjC;;EDqg0BA;IACE,iCAAiC;ECtg0BnC;;EDyg0BA;IACE,+BAA+B;EC1g0BjC;;ED6g0BA;IACE,iCAAiC;EC9g0BnC;;EDih0BA;IACE,+BAA+B;EClh0BjC;;EDqh0BA;IACE,iCAAiC;ECth0BnC;;EDyh0BA;IACE,+BAA+B;EC1h0BjC;;ED6h0BA;IACE,iCAAiC;EC9h0BnC;;EDii0BA;IACE,+BAA+B;ECli0BjC;;EDqi0BA;IACE,iCAAiC;ECti0BnC;;EDyi0BA;IACE,+BAA+B;EC1i0BjC;;ED6i0BA;IACE,iCAAiC;EC9i0BnC;;EDij0BA;IACE,+BAA+B;EClj0BjC;;EDqj0BA;IACE,iCAAiC;ECtj0BnC;;EDyj0BA;IACE,+BAA+B;EC1j0BjC;;ED6j0BA;IACE,iCAAiC;EC9j0BnC;;EDik0BA;IACE,+BAA+B;EClk0BjC;;EDqk0BA;IACE,iCAAiC;ECtk0BnC;;EDyk0BA;IACE,+BAA+B;EC1k0BjC;;ED6k0BA;IACE,iCAAiC;EC9k0BnC;;EDil0BA;IACE,+BAA+B;ECll0BjC;;EDql0BA;IACE,iCAAiC;ECtl0BnC;;EDyl0BA;IACE,+BAA+B;EC1l0BjC;;ED6l0BA;IACE,iCAAiC;EC3k0BnC;;ED8k0BA;IACE,+BAA+B;EACjC;;EAEA;IChl0BC,iCAAuC;EDkl0BxC;;ECpl0BA;IACC,6BAAc;IACd,8BAAe;EDul0BhB;;ECzl0BA;IACC,gCAAsC;IACtC,iCAAuC;ED4l0BxC;;EC9l0BA;IACC,+BAAsC;IACtC,gCAAuC;EDim0BxC;;ECnm0BA;IACC,6BAAsC;IACtC,8BAAuC;EDsm0BxC;;ECxm0BA;IACC,+BAAsC;IACtC,gCAAuC;ED2m0BxC;;EC7m0BA;IACC,6BAAsC;IACtC,8BAAuC;EDgn0BxC;;ECln0BA;IACC,+BAAsC;IACtC,gCAAuC;EDqn0BxC;;ECvn0BA;IACC,6BAAsC;IACtC,8BAAuC;ED0n0BxC;;EC5n0BA;IACC,+BAAsC;IACtC,gCAAuC;ED+n0BxC;;ECjo0BA;IACC,6BAAsC;IACtC,8BAAuC;EDoo0BxC;;ECto0BA;IACC,+BAAsC;IACtC,gCAAuC;EDyo0BxC;;EC3o0BA;IACC,6BAAsC;IACtC,8BAAuC;ED8o0BxC;;EChp0BA;IACC,+BAAsC;IACtC,gCAAuC;EDmp0BxC;;ECrp0BA;IACC,6BAAsC;IACtC,8BAAuC;EDwp0BxC;;EC1p0BA;IACC,+BAAsC;IACtC,gCAAuC;ED6p0BxC;;EC/p0BA;IACC,6BAAsC;IACtC,8BAAuC;EDkq0BxC;;ECpq0BA;IACC,+BAAsC;IACtC,gCAAuC;EDuq0BxC;;ECzq0BA;IACC,6BAAsC;IACtC,8BAAuC;ED4q0BxC;;EC9q0BA;IACC,+BAAsC;IACtC,gCAAuC;EDir0BxC;;ECnr0BA;IACC,6BAAc;IACd,8BAAe;EDsr0BhB;;ECxr0BA;IACC,+BAAc;IACd,gCAAe;ED2r0BhB;;EC7r0BA;IACC,8BAAsC;IACtC,+BAAuC;EDgs0BxC;;ECls0BA;IACC,gCAAsC;IACtC,iCAAuC;EDqs0BxC;;ECvs0BA;IACC,8BAAsC;IACtC,+BAAuC;ED0s0BxC;;EC5s0BA;IACC,gCAAsC;IACtC,iCAAuC;ED+s0BxC;;ECjt0BA;IACC,8BAAsC;IACtC,+BAAuC;EDot0BxC;;ECtt0BA;IACC,gCAAsC;IACtC,iCAAuC;EDyt0BxC;;EC3t0BA;IACC,8BAAsC;IACtC,+BAAuC;ED8t0BxC;;EChu0BA;IACC,gCAAsC;IACtC,iCAAuC;EDmu0BxC;;ECru0BA;IACC,8BAAsC;IACtC,+BAAuC;EDwu0BxC;;EC1u0BA;IACC,gCAAsC;IACtC,iCAAuC;ED6u0BxC;;EC/u0BA;IACC,8BAAsC;IACtC,+BAAuC;EDkv0BxC;;ECpv0BA;IACC,gCAAsC;IACtC,iCAAuC;EDuv0BxC;;ECzv0BA;IACC,8BAAsC;IACtC,+BAAuC;ED4v0BxC;;EC9v0BA;IACC,gCAAsC;IACtC,iCAAuC;EDiw0BxC;;ECnw0BA;IACC,8BAAsC;IACtC,+BAAuC;EDsw0BxC;;ECxw0BA;IACC,gCAAsC;IACtC,iCAAuC;ED2w0BxC;;EC7w0BA;IACC,8BAAsC;IACtC,+BAAuC;EDgx0BxC;;EClx0BA;IACC,gCAAsC;IACtC,iCAAuC;EDqx0BxC;;ECvx0BA;IACC,8BAAsC;IACtC,+BAAuC;ED0x0BxC;;EC5x0BA;IACC,gCAAsC;IACtC,iCAAuC;ED+x0BxC;;ECjy0BA;IACC,8BAAsC;IACtC,+BAAuC;EDoy0BxC;;ECty0BA;IACC,gCAAsC;IACtC,iCAAuC;EDyy0BxC;;EC3y0BA;IACC,8BAAsC;IACtC,+BAAuC;ED8y0BxC;;EChz0BA;IACC,gCAAsC;IACtC,iCAAuC;EDmz0BxC;;ECrz0BA;IACC,8BAAsC;IACtC,+BAAuC;EDwz0BxC;;EC1z0BA;IACC,gCAAsC;IACtC,iCAAuC;ED6z0BxC;;EC/z0BA;IACC,8BAAsC;IACtC,+BAAuC;EDk00BxC;;ECp00BA;IACC,gCAAsC;IACtC,iCAAuC;EDu00BxC;;ECz00BA;IACC,8BAAsC;IACtC,+BAAuC;ED400BxC;;EC900BA;IACC,gCAAsC;IACtC,iCAAuC;EDi10BxC;;ECn10BA;IACC,8BAAsC;IACtC,+BAAuC;EDs10BxC;;ECx10BA;IACC,gCAAsC;IACtC,iCAAuC;ED210BxC;;EC710BA;IACC,8BAAsC;IACtC,+BAAuC;EDg20BxC;;ECl20BA;IACC,gCAAsC;IACtC,iCAAuC;EDq20BxC;;ECv20BA;IACC,8BAAsC;IACtC,+BAAuC;ED020BxC;;EC520BA;IACC,gCAAsC;IACtC,iCAAuC;ED+20BxC;;ECj30BA;IACC,8BAAsC;IACtC,+BAAuC;EDo30BxC;;ECt30BA;IACC,gCAAsC;IACtC,iCAAuC;EDy30BxC;;EC330BA;IACC,8BAAsC;IACtC,+BAAuC;ED830BxC;;ECh40BA;IACC,gCAAsC;IACtC,iCAAuC;EDm40BxC;;ECr40BA;IACC,8BAAsC;IACtC,+BAAuC;EDw40BxC;;EC140BA;IACC,gCAAsC;IACtC,iCAAuC;ED640BxC;;EC/40BA;IACC,8BAAsC;IACtC,+BAAuC;EDk50BxC;;ECp50BA;IACC,gCAAsC;IACtC,iCAAuC;EDu50BxC;;ECz50BA;IACC,8BAAsC;IACtC,+BAAuC;ED450BxC;;EC950BA;IACC,gCAAsC;IACtC,iCAAuC;EDi60BxC;;ECn60BA;IACC,8BAAsC;IACtC,+BAAuC;EDs60BxC;;ECx60BA;IACC,gCAAsC;IACtC,iCAAuC;ED260BxC;;EC760BA;IACC,8BAAsC;IACtC,+BAAuC;EDg70BxC;;ECl70BA;IACC,gCAAsC;IACtC,iCAAuC;EDq70BxC;;ECv70BA;IACC,8BAAsC;IACtC,+BAAuC;ED070BxC;;EC570BA;IACC,gCAAsC;IACtC,iCAAuC;ED+70BxC;;ECj80BA;IACC,8BAAsC;IACtC,+BAAuC;EDo80BxC;;ECt80BA;IACC,gCAAsC;IACtC,iCAAuC;EDy80BxC;;EC380BA;IACC,8BAAsC;IACtC,+BAAuC;ED880BxC;;ECh90BA;IACC,gCAAsC;IACtC,iCAAuC;EDm90BxC;;ECr90BA;IACC,8BAAsC;IACtC,+BAAuC;EDw90BxC;;EC190BA;IACC,gCAAsC;IACtC,iCAAuC;ED690BxC;;EC/90BA;IACC,8BAAsC;IACtC,+BAAuC;EDk+0BxC;;ECp+0BA;IACC,gCAAsC;IACtC,iCAAuC;EDu+0BxC;;ECz+0BA;IACC,8BAAsC;IACtC,+BAAuC;ED4+0BxC;;EC9+0BA;IACC,gCAAsC;IACtC,iCAAuC;EDi/0BxC;;ECn/0BA;IACC,8BAAsC;IACtC,+BAAuC;EDs/0BxC;;ECx/0BA;IACC,gCAAsC;IACtC,iCAAuC;ED2/0BxC;;EC7/0BA;IACC,8BAAsC;IACtC,+BAAuC;EDgg1BxC;;EClg1BA;IACC,gCAAsC;IACtC,iCAAuC;EDqg1BxC;;ECvg1BA;IACC,8BAAsC;IACtC,+BAAuC;ED0g1BxC;;EC5g1BA;IACC,gCAAsC;IACtC,iCAAuC;ED+g1BxC;;ECjh1BA;IACC,8BAAsC;IACtC,+BAAuC;EDoh1BxC;;ECth1BA;IACC,gCAAsC;IACtC,iCAAuC;EDyh1BxC;;EC3h1BA;IACC,8BAAsC;IACtC,+BAAuC;ED8h1BxC;;EChi1BA;IACC,gCAAsC;IACtC,iCAAuC;EDmi1BxC;;ECri1BA;IACC,8BAAsC;IACtC,+BAAuC;EDwi1BxC;;EC1i1BA;IACC,gCAAsC;IACtC,iCAAuC;ED6i1BxC;;EC/i1BA;IACC,8BAAsC;IACtC,+BAAuC;EDkj1BxC;;ECpj1BA;IACC,gCAAsC;IACtC,iCAAuC;EDuj1BxC;;ECzj1BA;IACC,8BAAsC;IACtC,+BAAuC;ED4j1BxC;;EC9j1BA;IACC,gCAAsC;IACtC,iCAAuC;EDik1BxC;;ECnk1BA;IACC,8BAAsC;IACtC,+BAAuC;EDsk1BxC;;ECxk1BA;IACC,gCAAsC;IACtC,iCAAuC;ED2k1BxC;;EC7k1BA;IACC,8BAAsC;IACtC,+BAAuC;EDgl1BxC;;ECll1BA;IACC,gCAAsC;IACtC,iCAAuC;EDql1BxC;;ECvl1BA;IACC,8BAAsC;IACtC,+BAAuC;ED0l1BxC;;EC5l1BA;IACC,gCAAsC;IACtC,iCAAuC;ED+l1BxC;;ECjm1BA;IACC,8BAAsC;IACtC,+BAAuC;EDom1BxC;;ECtm1BA;IACC,gCAAsC;IACtC,iCAAuC;EDym1BxC;;EC3m1BA;IACC,8BAAsC;IACtC,+BAAuC;ED8m1BxC;;EChn1BA;IACC,gCAAsC;IACtC,iCAAuC;EDmn1BxC;;ECrn1BA;IACC,8BAAsC;IACtC,+BAAuC;EDwn1BxC;;EC1n1BA;IACC,gCAAsC;IACtC,iCAAuC;ED6n1BxC;;EC/n1BA;IACC,8BAAsC;IACtC,+BAAuC;EDko1BxC;;ECpo1BA;IACC,gCAAsC;IACtC,iCAAuC;EDuo1BxC;;ECzo1BA;IACC,8BAAsC;IACtC,+BAAuC;ED4o1BxC;;EC9o1BA;IACC,gCAAsC;IACtC,iCAAuC;EDip1BxC;;ECnp1BA;IACC,8BAAsC;IACtC,+BAAuC;EDsp1BxC;;ECxp1BA;IACC,gCAAsC;IACtC,iCAAuC;ED2p1BxC;;EC7p1BA;IACC,8BAAsC;IACtC,+BAAuC;EDgq1BxC;;EClq1BA;IACC,gCAAsC;IACtC,iCAAuC;EDqq1BxC;;ECvq1BA;IACC,8BAAsC;IACtC,+BAAuC;ED0q1BxC;;EC5q1BA;IACC,gCAAsC;IACtC,iCAAuC;ED+q1BxC;;ECjr1BA;IACC,8BAAsC;IACtC,+BAAuC;EDor1BxC;;ECtr1BA;IACC,gCAAsC;IACtC,iCAAuC;EDyr1BxC;;EC3r1BA;IACC,8BAAsC;IACtC,+BAAuC;ED8r1BxC;;EChs1BA;IACC,gCAAsC;IACtC,iCAAuC;EDms1BxC;;ECrs1BA;IACC,8BAAsC;IACtC,+BAAuC;EDws1BxC;;EC1s1BA;IACC,gCAAsC;IACtC,iCAAuC;ED6s1BxC;;EC/s1BA;IACC,8BAAsC;IACtC,+BAAuC;EDkt1BxC;;ECpt1BA;IACC,gCAAsC;IACtC,iCAAuC;EDut1BxC;;ECzt1BA;IACC,8BAAsC;IACtC,+BAAuC;ED4t1BxC;;EC9t1BA;IACC,gCAAsC;IACtC,iCAAuC;EDiu1BxC;;ECnu1BA;IACC,8BAAsC;IACtC,+BAAuC;EDsu1BxC;;ECxu1BA;IACC,gCAAsC;IACtC,iCAAuC;ED2u1BxC;;EC7u1BA;IACC,8BAAsC;IACtC,+BAAuC;EDgv1BxC;;EClv1BA;IACC,gCAAsC;IACtC,iCAAuC;EDqv1BxC;;ECvv1BA;IACC,8BAAsC;IACtC,+BAAuC;ED0v1BxC;;EC5v1BA;IACC,gCAAsC;IACtC,iCAAuC;ED+v1BxC;;ECjw1BA;IACC,8BAAsC;IACtC,+BAAuC;EDow1BxC;;ECtw1BA;IACC,gCAAsC;IACtC,iCAAuC;EDyw1BxC;;EC3w1BA;IACC,8BAAsC;IACtC,+BAAuC;ED8w1BxC;;EChx1BA;IACC,gCAAsC;IACtC,iCAAuC;EDmx1BxC;;ECrx1BA;IACC,8BAAsC;IACtC,+BAAuC;EDwx1BxC;;EC1x1BA;IACC,gCAAsC;IACtC,iCAAuC;ED6x1BxC;;EC/x1BA;IACC,8BAAsC;IACtC,+BAAuC;EDky1BxC;;ECpy1BA;IACC,gCAAsC;IACtC,iCAAuC;EDuy1BxC;;ECzy1BA;IACC,8BAAsC;IACtC,+BAAuC;ED4y1BxC;;EC9y1BA;IACC,gCAAsC;IACtC,iCAAuC;EDiz1BxC;;ECnz1BA;IACC,8BAAsC;IACtC,+BAAuC;EDsz1BxC;;ECxz1BA;IACC,gCAAsC;IACtC,iCAAuC;ED2z1BxC;;EC7z1BA;IACC,8BAAsC;IACtC,+BAAuC;EDg01BxC;;ECl01BA;IACC,gCAAsC;IACtC,iCAAuC;EDq01BxC;;ECv01BA;IACC,8BAAsC;IACtC,+BAAuC;ED001BxC;;EC501BA;IACC,gCAAsC;IACtC,iCAAuC;ED+01BxC;;ECj11BA;IACC,8BAAsC;IACtC,+BAAuC;EDo11BxC;;ECt11BA;IACC,gCAAsC;IACtC,iCAAuC;EDy11BxC;;EC311BA;IACC,8BAAsC;IACtC,+BAAuC;ED811BxC;;ECh21BA;IACC,gCAAsC;IACtC,iCAAuC;EDm21BxC;;ECr21BA;IACC,8BAAsC;IACtC,+BAAuC;EDw21BxC;;EC121BA;IACC,gCAAsC;IACtC,iCAAuC;ED621BxC;;EC311BA;IACC,8BAAqC;IACrC,+BAAwC;ED811BzC;;ECh21BA;IACC,gCAAqC;IACrC,iCAAgB;EDm21BjB;;ECr21BA;IACC,4BAAa;IACb,+BAAgB;EDw21BjB;;EC121BA;IACC,+BAAqC;IACrC,kCAAwC;ED621BzC;;EC/21BA;IACC,8BAAqC;IACrC,iCAAwC;EDk31BzC;;ECp31BA;IACC,4BAAqC;IACrC,+BAAwC;EDu31BzC;;ECz31BA;IACC,8BAAqC;IACrC,iCAAwC;ED431BzC;;EC931BA;IACC,4BAAqC;IACrC,+BAAwC;EDi41BzC;;ECn41BA;IACC,8BAAqC;IACrC,iCAAwC;EDs41BzC;;ECx41BA;IACC,4BAAqC;IACrC,+BAAwC;ED241BzC;;EC741BA;IACC,8BAAqC;IACrC,iCAAwC;EDg51BzC;;ECl51BA;IACC,4BAAqC;IACrC,+BAAwC;EDq51BzC;;ECv51BA;IACC,8BAAqC;IACrC,iCAAwC;ED051BzC;;EC551BA;IACC,4BAAqC;IACrC,+BAAwC;ED+51BzC;;ECj61BA;IACC,8BAAqC;IACrC,iCAAwC;EDo61BzC;;ECt61BA;IACC,4BAAqC;IACrC,+BAAwC;EDy61BzC;;EC361BA;IACC,8BAAqC;IACrC,iCAAwC;ED861BzC;;ECh71BA;IACC,4BAAqC;IACrC,+BAAwC;EDm71BzC;;ECr71BA;IACC,8BAAqC;IACrC,iCAAwC;EDw71BzC;;EC171BA;IACC,4BAAqC;IACrC,+BAAwC;ED671BzC;;EC/71BA;IACC,8BAAqC;IACrC,iCAAwC;EDk81BzC;;ECp81BA;IACC,4BAAa;IACb,+BAAgB;EDu81BjB;;ECz81BA;IACC,8BAAa;IACb,iCAAgB;ED481BjB;;EC981BA;IACC,6BAAqC;IACrC,gCAAwC;EDi91BzC;;ECn91BA;IACC,+BAAqC;IACrC,kCAAwC;EDs91BzC;;ECx91BA;IACC,6BAAqC;IACrC,gCAAwC;ED291BzC;;EC791BA;IACC,+BAAqC;IACrC,kCAAwC;EDg+1BzC;;ECl+1BA;IACC,6BAAqC;IACrC,gCAAwC;EDq+1BzC;;ECv+1BA;IACC,+BAAqC;IACrC,kCAAwC;ED0+1BzC;;EC5+1BA;IACC,6BAAqC;IACrC,gCAAwC;ED++1BzC;;ECj/1BA;IACC,+BAAqC;IACrC,kCAAwC;EDo/1BzC;;ECt/1BA;IACC,6BAAqC;IACrC,gCAAwC;EDy/1BzC;;EC3/1BA;IACC,+BAAqC;IACrC,kCAAwC;ED8/1BzC;;EChg2BA;IACC,6BAAqC;IACrC,gCAAwC;EDmg2BzC;;ECrg2BA;IACC,+BAAqC;IACrC,kCAAwC;EDwg2BzC;;EC1g2BA;IACC,6BAAqC;IACrC,gCAAwC;ED6g2BzC;;EC/g2BA;IACC,+BAAqC;IACrC,kCAAwC;EDkh2BzC;;ECph2BA;IACC,6BAAqC;IACrC,gCAAwC;EDuh2BzC;;ECzh2BA;IACC,+BAAqC;IACrC,kCAAwC;ED4h2BzC;;EC9h2BA;IACC,6BAAqC;IACrC,gCAAwC;EDii2BzC;;ECni2BA;IACC,+BAAqC;IACrC,kCAAwC;EDsi2BzC;;ECxi2BA;IACC,6BAAqC;IACrC,gCAAwC;ED2i2BzC;;EC7i2BA;IACC,+BAAqC;IACrC,kCAAwC;EDgj2BzC;;EClj2BA;IACC,6BAAqC;IACrC,gCAAwC;EDqj2BzC;;ECvj2BA;IACC,+BAAqC;IACrC,kCAAwC;ED0j2BzC;;EC5j2BA;IACC,6BAAqC;IACrC,gCAAwC;ED+j2BzC;;ECjk2BA;IACC,+BAAqC;IACrC,kCAAwC;EDok2BzC;;ECtk2BA;IACC,6BAAqC;IACrC,gCAAwC;EDyk2BzC;;EC3k2BA;IACC,+BAAqC;IACrC,kCAAwC;ED8k2BzC;;EChl2BA;IACC,6BAAqC;IACrC,gCAAwC;EDml2BzC;;ECrl2BA;IACC,+BAAqC;IACrC,kCAAwC;EDwl2BzC;;EC1l2BA;IACC,6BAAqC;IACrC,gCAAwC;ED6l2BzC;;EC/l2BA;IACC,+BAAqC;IACrC,kCAAwC;EDkm2BzC;;ECpm2BA;IACC,6BAAqC;IACrC,gCAAwC;EDum2BzC;;ECzm2BA;IACC,+BAAqC;IACrC,kCAAwC;ED4m2BzC;;EC9m2BA;IACC,6BAAqC;IACrC,gCAAwC;EDin2BzC;;ECnn2BA;IACC,+BAAqC;IACrC,kCAAwC;EDsn2BzC;;ECxn2BA;IACC,6BAAqC;IACrC,gCAAwC;ED2n2BzC;;EC7n2BA;IACC,+BAAqC;IACrC,kCAAwC;EDgo2BzC;;EClo2BA;IACC,6BAAqC;IACrC,gCAAwC;EDqo2BzC;;ECvo2BA;IACC,+BAAqC;IACrC,kCAAwC;ED0o2BzC;;EC5o2BA;IACC,6BAAqC;IACrC,gCAAwC;ED+o2BzC;;ECjp2BA;IACC,+BAAqC;IACrC,kCAAwC;EDop2BzC;;ECtp2BA;IACC,6BAAqC;IACrC,gCAAwC;EDyp2BzC;;EC3p2BA;IACC,+BAAqC;IACrC,kCAAwC;ED8p2BzC;;EChq2BA;IACC,6BAAqC;IACrC,gCAAwC;EDmq2BzC;;ECrq2BA;IACC,+BAAqC;IACrC,kCAAwC;EDwq2BzC;;EC1q2BA;IACC,6BAAqC;IACrC,gCAAwC;ED6q2BzC;;EC/q2BA;IACC,+BAAqC;IACrC,kCAAwC;EDkr2BzC;;ECpr2BA;IACC,6BAAqC;IACrC,gCAAwC;EDur2BzC;;ECzr2BA;IACC,+BAAqC;IACrC,kCAAwC;ED4r2BzC;;EC9r2BA;IACC,6BAAqC;IACrC,gCAAwC;EDis2BzC;;ECns2BA;IACC,+BAAqC;IACrC,kCAAwC;EDss2BzC;;ECxs2BA;IACC,6BAAqC;IACrC,gCAAwC;ED2s2BzC;;EC7s2BA;IACC,+BAAqC;IACrC,kCAAwC;EDgt2BzC;;EClt2BA;IACC,6BAAqC;IACrC,gCAAwC;EDqt2BzC;;ECvt2BA;IACC,+BAAqC;IACrC,kCAAwC;ED0t2BzC;;EC5t2BA;IACC,6BAAqC;IACrC,gCAAwC;ED+t2BzC;;ECju2BA;IACC,+BAAqC;IACrC,kCAAwC;EDou2BzC;;ECtu2BA;IACC,6BAAqC;IACrC,gCAAwC;EDyu2BzC;;EC3u2BA;IACC,+BAAqC;IACrC,kCAAwC;ED8u2BzC;;EChv2BA;IACC,6BAAqC;IACrC,gCAAwC;EDmv2BzC;;ECrv2BA;IACC,+BAAqC;IACrC,kCAAwC;EDwv2BzC;;EC1v2BA;IACC,6BAAqC;IACrC,gCAAwC;ED6v2BzC;;EC/v2BA;IACC,+BAAqC;IACrC,kCAAwC;EDkw2BzC;;ECpw2BA;IACC,6BAAqC;IACrC,gCAAwC;EDuw2BzC;;ECzw2BA;IACC,+BAAqC;IACrC,kCAAwC;ED4w2BzC;;EC9w2BA;IACC,6BAAqC;IACrC,gCAAwC;EDix2BzC;;ECnx2BA;IACC,+BAAqC;IACrC,kCAAwC;EDsx2BzC;;ECxx2BA;IACC,6BAAqC;IACrC,gCAAwC;ED2x2BzC;;EC7x2BA;IACC,+BAAqC;IACrC,kCAAwC;EDgy2BzC;;ECly2BA;IACC,6BAAqC;IACrC,gCAAwC;EDqy2BzC;;ECvy2BA;IACC,+BAAqC;IACrC,kCAAwC;ED0y2BzC;;EC5y2BA;IACC,6BAAqC;IACrC,gCAAwC;ED+y2BzC;;ECjz2BA;IACC,+BAAqC;IACrC,kCAAwC;EDoz2BzC;;ECtz2BA;IACC,6BAAqC;IACrC,gCAAwC;EDyz2BzC;;EC3z2BA;IACC,+BAAqC;IACrC,kCAAwC;ED8z2BzC;;ECh02BA;IACC,6BAAqC;IACrC,gCAAwC;EDm02BzC;;ECr02BA;IACC,+BAAqC;IACrC,kCAAwC;EDw02BzC;;EC102BA;IACC,6BAAqC;IACrC,gCAAwC;ED602BzC;;EC/02BA;IACC,+BAAqC;IACrC,kCAAwC;EDk12BzC;;ECp12BA;IACC,6BAAqC;IACrC,gCAAwC;EDu12BzC;;ECz12BA;IACC,+BAAqC;IACrC,kCAAwC;ED412BzC;;EC912BA;IACC,6BAAqC;IACrC,gCAAwC;EDi22BzC;;ECn22BA;IACC,+BAAqC;IACrC,kCAAwC;EDs22BzC;;ECx22BA;IACC,6BAAqC;IACrC,gCAAwC;ED222BzC;;EC722BA;IACC,+BAAqC;IACrC,kCAAwC;EDg32BzC;;ECl32BA;IACC,6BAAqC;IACrC,gCAAwC;EDq32BzC;;ECv32BA;IACC,+BAAqC;IACrC,kCAAwC;ED032BzC;;EC532BA;IACC,6BAAqC;IACrC,gCAAwC;ED+32BzC;;ECj42BA;IACC,+BAAqC;IACrC,kCAAwC;EDo42BzC;;ECt42BA;IACC,6BAAqC;IACrC,gCAAwC;EDy42BzC;;EC342BA;IACC,+BAAqC;IACrC,kCAAwC;ED842BzC;;ECh52BA;IACC,6BAAqC;IACrC,gCAAwC;EDm52BzC;;ECr52BA;IACC,+BAAqC;IACrC,kCAAwC;EDw52BzC;;EC152BA;IACC,6BAAqC;IACrC,gCAAwC;ED652BzC;;EC/52BA;IACC,+BAAqC;IACrC,kCAAwC;EDk62BzC;;ECp62BA;IACC,6BAAqC;IACrC,gCAAwC;EDu62BzC;;ECz62BA;IACC,+BAAqC;IACrC,kCAAwC;ED462BzC;;EC962BA;IACC,6BAAqC;IACrC,gCAAwC;EDi72BzC;;ECn72BA;IACC,+BAAqC;IACrC,kCAAwC;EDs72BzC;;ECx72BA;IACC,6BAAqC;IACrC,gCAAwC;ED272BzC;;EC772BA;IACC,+BAAqC;IACrC,kCAAwC;EDg82BzC;;ECl82BA;IACC,6BAAqC;IACrC,gCAAwC;EDq82BzC;;ECv82BA;IACC,+BAAqC;IACrC,kCAAwC;ED082BzC;;EC582BA;IACC,6BAAqC;IACrC,gCAAwC;ED+82BzC;;ECj92BA;IACC,+BAAqC;IACrC,kCAAwC;EDo92BzC;;ECt92BA;IACC,6BAAqC;IACrC,gCAAwC;EDy92BzC;;EC392BA;IACC,+BAAqC;IACrC,kCAAwC;ED892BzC;;ECh+2BA;IACC,6BAAqC;IACrC,gCAAwC;EDm+2BzC;;ECr+2BA;IACC,+BAAqC;IACrC,kCAAwC;EDw+2BzC;;EC1+2BA;IACC,6BAAqC;IACrC,gCAAwC;ED6+2BzC;;EC/+2BA;IACC,+BAAqC;IACrC,kCAAwC;EDk/2BzC;;ECp/2BA;IACC,6BAAqC;IACrC,gCAAwC;EDu/2BzC;;ECz/2BA;IACC,+BAAqC;IACrC,kCAAwC;ED4/2BzC;;EC9/2BA;IACC,6BAAqC;IACrC,gCAAwC;EDig3BzC;;ECng3BA;IACC,+BAAqC;IACrC,kCAAwC;EDsg3BzC;;ECxg3BA;IACC,6BAAqC;IACrC,gCAAwC;ED2g3BzC;;EC7g3BA;IACC,+BAAqC;IACrC,kCAAwC;EDgh3BzC;;EClh3BA;IACC,6BAAqC;IACrC,gCAAwC;EDqh3BzC;;ECvh3BA;IACC,+BAAqC;IACrC,kCAAwC;ED0h3BzC;;EC5h3BA;IACC,6BAAqC;IACrC,gCAAwC;ED+h3BzC;;ECji3BA;IACC,+BAAqC;IACrC,kCAAwC;EDoi3BzC;;ECti3BA;IACC,6BAAqC;IACrC,gCAAwC;EDyi3BzC;;EC3i3BA;IACC,+BAAqC;IACrC,kCAAwC;ED8i3BzC;;EChj3BA;IACC,6BAAqC;IACrC,gCAAwC;EDmj3BzC;;ECrj3BA;IACC,+BAAqC;IACrC,kCAAwC;EDwj3BzC;;EC1j3BA;IACC,6BAAqC;IACrC,gCAAwC;ED6j3BzC;;EC/j3BA;IACC,+BAAqC;IACrC,kCAAwC;EDkk3BzC;;ECpk3BA;IACC,6BAAqC;IACrC,gCAAwC;EDuk3BzC;;ECzk3BA;IACC,+BAAqC;IACrC,kCAAwC;ED4k3BzC;;EC9k3BA;IACC,6BAAqC;IACrC,gCAAwC;EDil3BzC;;ECnl3BA;IACC,+BAAqC;IACrC,kCAAwC;EDsl3BzC;;ECxl3BA;IACC,6BAAqC;IACrC,gCAAwC;ED2l3BzC;;EC7l3BA;IACC,+BAAqC;IACrC,kCAAwC;EDgm3BzC;;EClm3BA;IACC,6BAAqC;IACrC,gCAAwC;EDqm3BzC;;ECvm3BA;IACC,+BAAqC;IACrC,kCAAwC;ED0m3BzC;;EC5m3BA;IACC,6BAAqC;IACrC,gCAAwC;ED+m3BzC;;ECjn3BA;IACC,+BAAqC;IACrC,kCAAwC;EDon3BzC;;ECtn3BA;IACC,6BAAqC;IACrC,gCAAwC;EDyn3BzC;;EC3n3BA;IACC,+BAAqC;IACrC,kCAAwC;ED8n3BzC;;ECvn3BF;IAaY,6BAAA;IACV,gCAAgC;ED8m3BhC;;EC/m3BD;IACC,+BAAgC;IDkn3B9B,kCAAkC;EACpC;ACpn3BD;ADsn3BD,SCrn3BQ;ADsn3BR;EACE,uBAAuB;ACxn3BxB;;AD2n3BD;EACE,0BAA0B;AC5n3B3B;;AD+n3BD;EACE,yBAAyB;ACho3B1B;;ADmo3BD;EACE,uBAAuB;ACpo3BxB;;ADuo3BD;EACE,yBAAyB;ACxo3B1B;;AD2o3BD;EACE,uBAAuB;AC5o3BxB;;AD+o3BD;EACE,yBAAyB;AChp3B1B;;ADmp3BD;EACE,uBAAuB;ACpp3BxB;;ADup3BD;EACE,yBAAyB;ACxp3B1B;;AD2p3BD;EACE,uBAAuB;AC5p3BxB;;AD+p3BD;EACE,yBAAyB;AChq3B1B;;ADmq3BD;EACE,uBAAuB;ACpq3BxB;;ADuq3BD;EACE,yBAAyB;ACxq3B1B;;AD2q3BD;EACE,uBAAuB;AC5q3BxB;;AD+q3BD;EACE,yBAAyB;AChr3B1B;;ADmr3BD;EACE,uBAAuB;ACpr3BxB;;ADur3BD;EACE,yBAAyB;ACxr3B1B;;AD2r3BD;EACE,uBAAuB;AC5r3BxB;;AD+r3BD;EACE,yBAAyB;AChs3B1B;;ADms3BD;EACE,uBAAuB;ACps3BxB;;ADus3BD;EACE,yBAAyB;ACxs3B1B;;AD2s3BD;EACE,wBAAwB;AC5s3BzB;;AD+s3BD;EACE,0BAA0B;ACht3B3B;;ADmt3BD;EACE,wBAAwB;ACpt3BzB;;ADut3BD;EACE,0BAA0B;ACxt3B3B;;AD2t3BD;EACE,wBAAwB;AC5t3BzB;;AD+t3BD;EACE,0BAA0B;AChu3B3B;;ADmu3BD;EACE,wBAAwB;ACpu3BzB;;ADuu3BD;EACE,0BAA0B;ACxu3B3B;;AD2u3BD;EACE,wBAAwB;AC5u3BzB;;AD+u3BD;EACE,0BAA0B;AChv3B3B;;ADmv3BD;EACE,wBAAwB;ACpv3BzB;;ADuv3BD;EACE,0BAA0B;ACxv3B3B;;AD2v3BD;EACE,wBAAwB;AC5v3BzB;;AD+v3BD;EACE,0BAA0B;AChw3B3B;;ADmw3BD;EACE,wBAAwB;ACpw3BzB;;ADuw3BD;EACE,0BAA0B;ACxw3B3B;;AD2w3BD;EACE,wBAAwB;AC5w3BzB;;AD+w3BD;EACE,0BAA0B;AChx3B3B;;ADmx3BD;EACE,wBAAwB;ACpx3BzB;;ADux3BD;EACE,0BAA0B;ACxx3B3B;;AD2x3BD;EACE,wBAAwB;AC5x3BzB;;AD+x3BD;EACE,0BAA0B;AChy3B3B;;ADmy3BD;EACE,wBAAwB;ACpy3BzB;;ADuy3BD;EACE,0BAA0B;ACxy3B3B;;AD2y3BD;EACE,wBAAwB;AC5y3BzB;;AD+y3BD;EACE,0BAA0B;AChz3B3B;;ADmz3BD;EACE,wBAAwB;ACpz3BzB;;ADuz3BD;EACE,0BAA0B;ACxz3B3B;;AD2z3BD;EACE,wBAAwB;AC5z3BzB;;AD+z3BD;EACE,0BAA0B;ACh03B3B;;ADm03BD;EACE,wBAAwB;ACp03BzB;;ADu03BD;EACE,0BAA0B;ACx03B3B;;AD203BD;EACE,wBAAwB;AC503BzB;;AD+03BD;EACE,0BAA0B;ACh13B3B;;ADm13BD;EACE,wBAAwB;ACp13BzB;;ADu13BD;EACE,0BAA0B;ACx13B3B;;AD213BD;EACE,wBAAwB;AC513BzB;;AD+13BD;EACE,0BAA0B;ACh23B3B;;ADm23BD;EACE,wBAAwB;ACp23BzB;;ADu23BD;EACE,0BAA0B;ACx23B3B;;AD223BD;EACE,wBAAwB;AC523BzB;;AD+23BD;EACE,0BAA0B;ACh33B3B;;ADm33BD;EACE,wBAAwB;ACp33BzB;;ADu33BD;EACE,0BAA0B;ACx33B3B;;AD233BD;EACE,wBAAwB;AC533BzB;;AD+33BD;EACE,0BAA0B;ACh43B3B;;ADm43BD;EACE,wBAAwB;ACp43BzB;;ADu43BD;EACE,0BAA0B;ACx43B3B;;AD243BD;EACE,wBAAwB;AC543BzB;;AD+43BD;EACE,0BAA0B;ACh53B3B;;ADm53BD;EACE,wBAAwB;ACp53BzB;;ADu53BD;EACE,0BAA0B;ACx53B3B;;AD253BD;EACE,wBAAwB;AC553BzB;;AD+53BD;EACE,0BAA0B;ACh63B3B;;ADm63BD;EACE,wBAAwB;ACp63BzB;;ADu63BD;EACE,0BAA0B;ACx63B3B;;AD263BD;EACE,wBAAwB;AC563BzB;;AD+63BD;EACE,0BAA0B;ACh73B3B;;ADm73BD;EACE,wBAAwB;ACp73BzB;;ADu73BD;EACE,0BAA0B;ACx73B3B;;AD273BD;EACE,wBAAwB;AC573BzB;;AD+73BD;EACE,0BAA0B;ACh83B3B;;ADm83BD;EACE,wBAAwB;ACp83BzB;;ADu83BD;EACE,0BAA0B;ACx83B3B;;AD283BD;EACE,wBAAwB;AC583BzB;;AD+83BD;EACE,0BAA0B;ACh93B3B;;ADm93BD;EACE,wBAAwB;ACp93BzB;;ADu93BD;EACE,0BAA0B;ACx93B3B;;AD293BD;EACE,wBAAwB;AC593BzB;;AD+93BD;EACE,0BAA0B;ACh+3B3B;;ADm+3BD;EACE,wBAAwB;ACp+3BzB;;ADu+3BD;EACE,0BAA0B;ACx+3B3B;;AD2+3BD;EACE,wBAAwB;AC5+3BzB;;AD++3BD;EACE,0BAA0B;ACh/3B3B;;ADm/3BD;EACE,wBAAwB;ACp/3BzB;;ADu/3BD;EACE,0BAA0B;ACx/3B3B;;AD2/3BD;EACE,wBAAwB;AC5/3BzB;;AD+/3BD;EACE,0BAA0B;AChg4B3B;;ADmg4BD;EACE,wBAAwB;ACpg4BzB;;ADug4BD;EACE,0BAA0B;ACxg4B3B;;AD2g4BD;EACE,wBAAwB;AC5g4BzB;;AD+g4BD;EACE,0BAA0B;AChh4B3B;;ADmh4BD;EACE,wBAAwB;ACph4BzB;;ADuh4BD;EACE,0BAA0B;ACxh4B3B;;AD2h4BD;EACE,wBAAwB;AC5h4BzB;;AD+h4BD;EACE,0BAA0B;AChi4B3B;;ADmi4BD;EACE,wBAAwB;ACpi4BzB;;ADui4BD;EACE,0BAA0B;ACxi4B3B;;AD2i4BD;EACE,wBAAwB;AC5i4BzB;;AD+i4BD;EACE,0BAA0B;AChj4B3B;;ADmj4BD;EACE,wBAAwB;ACpj4BzB;;ADuj4BD;EACE,0BAA0B;ACxj4B3B;;AD2j4BD;EACE,wBAAwB;AC5j4BzB;;AD+j4BD;EACE,0BAA0B;AChk4B3B;;ADmk4BD;EACE,wBAAwB;ACpk4BzB;;ADuk4BD;EACE,0BAA0B;ACxk4B3B;;AD2k4BD;EACE,wBAAwB;AC5k4BzB;;AD+k4BD;EACE,0BAA0B;AChl4B3B;;ADml4BD;EACE,wBAAwB;ACpl4BzB;;ADul4BD;EACE,0BAA0B;ACxl4B3B;;AD2l4BD;EACE,wBAAwB;AC5l4BzB;;AD+l4BD;EACE,0BAA0B;AChm4B3B;;ADmm4BD;EACE,wBAAwB;ACpm4BzB;;ADum4BD;EACE,0BAA0B;ACxm4B3B;;AD2m4BD;EACE,wBAAwB;AC5m4BzB;;AD+m4BD;EACE,0BAA0B;AChn4B3B;;ADmn4BD;EACE,wBAAwB;ACpn4BzB;;ADun4BD;EACE,0BAA0B;ACxn4B3B;;AD2n4BD;EACE,wBAAwB;AC5n4BzB;;AD+n4BD;EACE,0BAA0B;ACho4B3B;;ADmo4BD;EACE,wBAAwB;ACpo4BzB;;ADuo4BD;EACE,0BAA0B;ACxo4B3B;;AD2o4BD;EACE,wBAAwB;AC5o4BzB;;AD+o4BD;EACE,0BAA0B;AChp4B3B;;ADmp4BD;EACE,wBAAwB;ACpp4BzB;;ADup4BD;EACE,0BAA0B;ACxp4B3B;;AD2p4BD;EACE,wBAAwB;AC5p4BzB;;AD+p4BD;EACE,0BAA0B;AChq4B3B;;ADmq4BD;EACE,wBAAwB;ACpq4BzB;;ADuq4BD;EACE,0BAA0B;ACxq4B3B;;AD2q4BD;EACE,wBAAwB;AC5q4BzB;;AD+q4BD;EACE,0BAA0B;AChr4B3B;;ADmr4BD;EACE,wBAAwB;ACpr4BzB;;ADur4BD;EACE,0BAA0B;ACxr4B3B;;AD2r4BD;EACE,wBAAwB;AC5r4BzB;;AD+r4BD;EACE,0BAA0B;AChs4B3B;;ADms4BD;EACE,wBAAwB;ACps4BzB;;ADus4BD;EACE,0BAA0B;ACxs4B3B;;AD2s4BD;EACE,wBAAwB;AC5s4BzB;;AD+s4BD;EACE,0BAA0B;ACht4B3B;;ADmt4BD;EACE,wBAAwB;ACpt4BzB;;ADut4BD;EACE,0BAA0B;ACxt4B3B;;AD2t4BD;EACE,wBAAwB;AC5t4BzB;;AD+t4BD;EACE,0BAA0B;AChu4B3B;;ADmu4BD;EACE,wBAAwB;ACpu4BzB;;ADuu4BD;EACE,0BAA0B;ACxu4B3B;;AD2u4BD;EACE,wBAAwB;AC5u4BzB;;AD+u4BD;EACE,0BAA0B;AC7t4B3B;;ADgu4BD;EACE,wBAAwB;ACju4BzB;;ADou4BD;EACE,0BAA0B;ACru4B3B;;ADwu4BD;EACE,2BAA2B;ACzu4B5B;;AD4u4BD;EACE,8BAA8B;AC7u4B/B;;ADgv4BD;EACE,6BAA6B;ACjv4B9B;;ADov4BD;EACE,2BAA2B;ACrv4B5B;;ADwv4BD;EACE,6BAA6B;ACzv4B9B;;AD4v4BD;EACE,2BAA2B;AC7v4B5B;;ADgw4BD;EACE,6BAA6B;ACjw4B9B;;ADow4BD;EACE,2BAA2B;ACrw4B5B;;ADww4BD;EACE,6BAA6B;ACzw4B9B;;AD4w4BD;EACE,2BAA2B;AC7w4B5B;;ADgx4BD;EACE,6BAA6B;ACjx4B9B;;ADox4BD;EACE,2BAA2B;ACrx4B5B;;ADwx4BD;EACE,6BAA6B;ACzx4B9B;;AD4x4BD;EACE,2BAA2B;AC7x4B5B;;ADgy4BD;EACE,6BAA6B;ACjy4B9B;;ADoy4BD;EACE,2BAA2B;ACry4B5B;;ADwy4BD;EACE,6BAA6B;ACzy4B9B;;AD4y4BD;EACE,2BAA2B;AC7y4B5B;;ADgz4BD;EACE,6BAA6B;ACjz4B9B;;ADoz4BD;EACE,2BAA2B;ACrz4B5B;;ADwz4BD;EACE,6BAA6B;ACzz4B9B;;AD4z4BD;EACE,4BAA4B;AC7z4B7B;;ADg04BD;EACE,8BAA8B;ACj04B/B;;ADo04BD;EACE,4BAA4B;ACr04B7B;;ADw04BD;EACE,8BAA8B;ACz04B/B;;AD404BD;EACE,4BAA4B;AC704B7B;;ADg14BD;EACE,8BAA8B;ACj14B/B;;ADo14BD;EACE,4BAA4B;ACr14B7B;;ADw14BD;EACE,8BAA8B;ACz14B/B;;AD414BD;EACE,4BAA4B;AC714B7B;;ADg24BD;EACE,8BAA8B;ACj24B/B;;ADo24BD;EACE,4BAA4B;ACr24B7B;;ADw24BD;EACE,8BAA8B;ACz24B/B;;AD424BD;EACE,4BAA4B;AC724B7B;;ADg34BD;EACE,8BAA8B;ACj34B/B;;ADo34BD;EACE,4BAA4B;ACr34B7B;;ADw34BD;EACE,8BAA8B;ACz34B/B;;AD434BD;EACE,4BAA4B;AC734B7B;;ADg44BD;EACE,8BAA8B;ACj44B/B;;ADo44BD;EACE,4BAA4B;ACr44B7B;;ADw44BD;EACE,8BAA8B;ACz44B/B;;AD444BD;EACE,4BAA4B;AC744B7B;;ADg54BD;EACE,8BAA8B;ACj54B/B;;ADo54BD;EACE,4BAA4B;ACr54B7B;;ADw54BD;EACE,8BAA8B;ACz54B/B;;AD454BD;EACE,4BAA4B;AC754B7B;;ADg64BD;EACE,8BAA8B;ACj64B/B;;ADo64BD;EACE,4BAA4B;ACr64B7B;;ADw64BD;EACE,8BAA8B;ACz64B/B;;AD464BD;EACE,4BAA4B;AC764B7B;;ADg74BD;EACE,8BAA8B;ACj74B/B;;ADo74BD;EACE,4BAA4B;ACr74B7B;;ADw74BD;EACE,8BAA8B;ACz74B/B;;AD474BD;EACE,4BAA4B;AC774B7B;;ADg84BD;EACE,8BAA8B;ACj84B/B;;ADo84BD;EACE,4BAA4B;ACr84B7B;;ADw84BD;EACE,8BAA8B;ACz84B/B;;AD484BD;EACE,4BAA4B;AC784B7B;;ADg94BD;EACE,8BAA8B;ACj94B/B;;ADo94BD;EACE,4BAA4B;ACr94B7B;;ADw94BD;EACE,8BAA8B;ACz94B/B;;AD494BD;EACE,4BAA4B;AC794B7B;;ADg+4BD;EACE,8BAA8B;ACj+4B/B;;ADo+4BD;EACE,4BAA4B;ACr+4B7B;;ADw+4BD;EACE,8BAA8B;ACz+4B/B;;AD4+4BD;EACE,4BAA4B;AC7+4B7B;;ADg/4BD;EACE,8BAA8B;ACj/4B/B;;ADo/4BD;EACE,4BAA4B;ACr/4B7B;;ADw/4BD;EACE,8BAA8B;ACz/4B/B;;AD4/4BD;EACE,4BAA4B;AC7/4B7B;;ADgg5BD;EACE,8BAA8B;ACjg5B/B;;ADog5BD;EACE,4BAA4B;ACrg5B7B;;ADwg5BD;EACE,8BAA8B;ACzg5B/B;;AD4g5BD;EACE,4BAA4B;AC7g5B7B;;ADgh5BD;EACE,8BAA8B;ACjh5B/B;;ADoh5BD;EACE,4BAA4B;ACrh5B7B;;ADwh5BD;EACE,8BAA8B;ACzh5B/B;;AD4h5BD;EACE,4BAA4B;AC7h5B7B;;ADgi5BD;EACE,8BAA8B;ACji5B/B;;ADoi5BD;EACE,4BAA4B;ACri5B7B;;ADwi5BD;EACE,8BAA8B;ACzi5B/B;;AD4i5BD;EACE,4BAA4B;AC7i5B7B;;ADgj5BD;EACE,8BAA8B;ACjj5B/B;;ADoj5BD;EACE,4BAA4B;ACrj5B7B;;ADwj5BD;EACE,8BAA8B;ACzj5B/B;;AD4j5BD;EACE,4BAA4B;AC7j5B7B;;ADgk5BD;EACE,8BAA8B;ACjk5B/B;;ADok5BD;EACE,4BAA4B;ACrk5B7B;;ADwk5BD;EACE,8BAA8B;ACzk5B/B;;AD4k5BD;EACE,4BAA4B;AC7k5B7B;;ADgl5BD;EACE,8BAA8B;ACjl5B/B;;ADol5BD;EACE,4BAA4B;ACrl5B7B;;ADwl5BD;EACE,8BAA8B;ACzl5B/B;;AD4l5BD;EACE,4BAA4B;AC7l5B7B;;ADgm5BD;EACE,8BAA8B;ACjm5B/B;;ADom5BD;EACE,4BAA4B;ACrm5B7B;;ADwm5BD;EACE,8BAA8B;ACzm5B/B;;AD4m5BD;EACE,4BAA4B;AC7m5B7B;;ADgn5BD;EACE,8BAA8B;ACjn5B/B;;ADon5BD;EACE,4BAA4B;ACrn5B7B;;ADwn5BD;EACE,8BAA8B;ACzn5B/B;;AD4n5BD;EACE,4BAA4B;AC7n5B7B;;ADgo5BD;EACE,8BAA8B;ACjo5B/B;;ADoo5BD;EACE,4BAA4B;ACro5B7B;;ADwo5BD;EACE,8BAA8B;ACzo5B/B;;AD4o5BD;EACE,4BAA4B;AC7o5B7B;;ADgp5BD;EACE,8BAA8B;ACjp5B/B;;ADop5BD;EACE,4BAA4B;ACrp5B7B;;ADwp5BD;EACE,8BAA8B;ACzp5B/B;;AD4p5BD;EACE,4BAA4B;AC7p5B7B;;ADgq5BD;EACE,8BAA8B;ACjq5B/B;;ADoq5BD;EACE,4BAA4B;ACrq5B7B;;ADwq5BD;EACE,8BAA8B;ACzq5B/B;;AD4q5BD;EACE,4BAA4B;AC7q5B7B;;ADgr5BD;EACE,8BAA8B;ACjr5B/B;;ADor5BD;EACE,4BAA4B;ACrr5B7B;;ADwr5BD;EACE,8BAA8B;ACzr5B/B;;AD4r5BD;EACE,4BAA4B;AC7r5B7B;;ADgs5BD;EACE,8BAA8B;ACjs5B/B;;ADos5BD;EACE,4BAA4B;ACrs5B7B;;ADws5BD;EACE,8BAA8B;ACzs5B/B;;AD4s5BD;EACE,4BAA4B;AC7s5B7B;;ADgt5BD;EACE,8BAA8B;ACjt5B/B;;ADot5BD;EACE,4BAA4B;ACrt5B7B;;ADwt5BD;EACE,8BAA8B;ACzt5B/B;;AD4t5BD;EACE,4BAA4B;AC7t5B7B;;ADgu5BD;EACE,8BAA8B;ACju5B/B;;ADou5BD;EACE,4BAA4B;ACru5B7B;;ADwu5BD;EACE,8BAA8B;ACzu5B/B;;AD4u5BD;EACE,4BAA4B;AC7u5B7B;;ADgv5BD;EACE,8BAA8B;ACjv5B/B;;ADov5BD;EACE,4BAA4B;ACrv5B7B;;ADwv5BD;EACE,8BAA8B;ACzv5B/B;;AD4v5BD;EACE,4BAA4B;AC7v5B7B;;ADgw5BD;EACE,8BAA8B;ACjw5B/B;;ADow5BD;EACE,4BAA4B;ACrw5B7B;;ADww5BD;EACE,8BAA8B;ACzw5B/B;;AD4w5BD;EACE,4BAA4B;AC7w5B7B;;ADgx5BD;EACE,8BAA8B;ACjx5B/B;;ADox5BD;EACE,4BAA4B;ACrx5B7B;;ADwx5BD;EACE,8BAA8B;ACzx5B/B;;AD4x5BD;EACE,4BAA4B;AC7x5B7B;;ADgy5BD;EACE,8BAA8B;ACjy5B/B;;ADoy5BD;EACE,4BAA4B;ACry5B7B;;ADwy5BD;EACE,8BAA8B;ACzy5B/B;;AD4y5BD;EACE,4BAA4B;AC7y5B7B;;ADgz5BD;EACE,8BAA8B;ACjz5B/B;;ADoz5BD;EACE,4BAA4B;ACrz5B7B;;ADwz5BD;EACE,8BAA8B;ACzz5B/B;;AD4z5BD;EACE,4BAA4B;AC7z5B7B;;ADg05BD;EACE,8BAA8B;ACj05B/B;;ADo05BD;EACE,4BAA4B;ACr05B7B;;ADw05BD;EACE,8BAA8B;ACz05B/B;;AD405BD;EACE,4BAA4B;AC705B7B;;ADg15BD;EACE,8BAA8B;ACj15B/B;;ADo15BD;EACE,4BAA4B;ACr15B7B;;ADw15BD;EACE,8BAA8B;ACz15B/B;;AD415BD;EACE,4BAA4B;AC715B7B;;ADg25BD;EACE,8BAA8B;AC905B/B;;ADi15BD;EACE,4BAA4B;ACl15B7B;;ADq15BD;EACE,8BAA8B;ACt15B/B;;ADy15BD;EACE,8BAA8B;AC115B/B;;AD615BD;EACE,iCAAiC;AC915BlC;;ADi25BD;EACE,gCAAgC;ACl25BjC;;ADq25BD;EACE,8BAA8B;ACt25B/B;;ADy25BD;EACE,gCAAgC;AC125BjC;;AD625BD;EACE,8BAA8B;AC925B/B;;ADi35BD;EACE,gCAAgC;ACl35BjC;;ADq35BD;EACE,8BAA8B;ACt35B/B;;ADy35BD;EACE,gCAAgC;AC135BjC;;AD635BD;EACE,8BAA8B;AC935B/B;;ADi45BD;EACE,gCAAgC;ACl45BjC;;ADq45BD;EACE,8BAA8B;ACt45B/B;;ADy45BD;EACE,gCAAgC;AC145BjC;;AD645BD;EACE,8BAA8B;AC945B/B;;ADi55BD;EACE,gCAAgC;ACl55BjC;;ADq55BD;EACE,8BAA8B;ACt55B/B;;ADy55BD;EACE,gCAAgC;AC155BjC;;AD655BD;EACE,8BAA8B;AC955B/B;;ADi65BD;EACE,gCAAgC;ACl65BjC;;ADq65BD;EACE,8BAA8B;ACt65B/B;;ADy65BD;EACE,gCAAgC;AC165BjC;;AD665BD;EACE,+BAA+B;AC965BhC;;ADi75BD;EACE,iCAAiC;ACl75BlC;;ADq75BD;EACE,+BAA+B;ACt75BhC;;ADy75BD;EACE,iCAAiC;AC175BlC;;AD675BD;EACE,+BAA+B;AC975BhC;;ADi85BD;EACE,iCAAiC;ACl85BlC;;ADq85BD;EACE,+BAA+B;ACt85BhC;;ADy85BD;EACE,iCAAiC;AC185BlC;;AD685BD;EACE,+BAA+B;AC985BhC;;ADi95BD;EACE,iCAAiC;ACl95BlC;;ADq95BD;EACE,+BAA+B;ACt95BhC;;ADy95BD;EACE,iCAAiC;AC195BlC;;AD695BD;EACE,+BAA+B;AC995BhC;;ADi+5BD;EACE,iCAAiC;ACl+5BlC;;ADq+5BD;EACE,+BAA+B;ACt+5BhC;;ADy+5BD;EACE,iCAAiC;AC1+5BlC;;AD6+5BD;EACE,+BAA+B;AC9+5BhC;;ADi/5BD;EACE,iCAAiC;ACl/5BlC;;ADq/5BD;EACE,+BAA+B;ACt/5BhC;;ADy/5BD;EACE,iCAAiC;AC1/5BlC;;AD6/5BD;EACE,+BAA+B;AC9/5BhC;;ADig6BD;EACE,iCAAiC;AClg6BlC;;ADqg6BD;EACE,+BAA+B;ACtg6BhC;;ADyg6BD;EACE,iCAAiC;AC1g6BlC;;AD6g6BD;EACE,+BAA+B;AC9g6BhC;;ADih6BD;EACE,iCAAiC;AClh6BlC;;ADqh6BD;EACE,+BAA+B;ACth6BhC;;ADyh6BD;EACE,iCAAiC;AC1h6BlC;;AD6h6BD;EACE,+BAA+B;AC9h6BhC;;ADii6BD;EACE,iCAAiC;ACli6BlC;;ADqi6BD;EACE,+BAA+B;ACti6BhC;;ADyi6BD;EACE,iCAAiC;AC1i6BlC;;AD6i6BD;EACE,+BAA+B;AC9i6BhC;;ADij6BD;EACE,iCAAiC;AClj6BlC;;ADqj6BD;EACE,+BAA+B;ACtj6BhC;;ADyj6BD;EACE,iCAAiC;AC1j6BlC;;AD6j6BD;EACE,+BAA+B;AC9j6BhC;;ADik6BD;EACE,iCAAiC;AClk6BlC;;ADqk6BD;EACE,+BAA+B;ACtk6BhC;;ADyk6BD;EACE,iCAAiC;AC1k6BlC;;AD6k6BD;EACE,+BAA+B;AC9k6BhC;;ADil6BD;EACE,iCAAiC;ACll6BlC;;ADql6BD;EACE,+BAA+B;ACtl6BhC;;ADyl6BD;EACE,iCAAiC;AC1l6BlC;;AD6l6BD;EACE,+BAA+B;AC9l6BhC;;ADim6BD;EACE,iCAAiC;AClm6BlC;;ADqm6BD;EACE,+BAA+B;ACtm6BhC;;ADym6BD;EACE,iCAAiC;AC1m6BlC;;AD6m6BD;EACE,+BAA+B;AC9m6BhC;;ADin6BD;EACE,iCAAiC;ACln6BlC;;ADqn6BD;EACE,+BAA+B;ACtn6BhC;;ADyn6BD;EACE,iCAAiC;AC1n6BlC;;AD6n6BD;EACE,+BAA+B;AC9n6BhC;;ADio6BD;EACE,iCAAiC;AClo6BlC;;ADqo6BD;EACE,+BAA+B;ACto6BhC;;ADyo6BD;EACE,iCAAiC;AC1o6BlC;;AD6o6BD;EACE,+BAA+B;AC9o6BhC;;ADip6BD;EACE,iCAAiC;AClp6BlC;;ADqp6BD;EACE,+BAA+B;ACtp6BhC;;ADyp6BD;EACE,iCAAiC;AC1p6BlC;;AD6p6BD;EACE,+BAA+B;AC9p6BhC;;ADiq6BD;EACE,iCAAiC;AClq6BlC;;ADqq6BD;EACE,+BAA+B;ACtq6BhC;;ADyq6BD;EACE,iCAAiC;AC1q6BlC;;AD6q6BD;EACE,+BAA+B;AC9q6BhC;;ADir6BD;EACE,iCAAiC;AClr6BlC;;ADqr6BD;EACE,+BAA+B;ACtr6BhC;;ADyr6BD;EACE,iCAAiC;AC1r6BlC;;AD6r6BD;EACE,+BAA+B;AC9r6BhC;;ADis6BD;EACE,iCAAiC;ACls6BlC;;ADqs6BD;EACE,+BAA+B;ACts6BhC;;ADys6BD;EACE,iCAAiC;AC1s6BlC;;AD6s6BD;EACE,+BAA+B;AC9s6BhC;;ADit6BD;EACE,iCAAiC;AClt6BlC;;ADqt6BD;EACE,+BAA+B;ACtt6BhC;;ADyt6BD;EACE,iCAAiC;AC1t6BlC;;AD6t6BD;EACE,+BAA+B;AC9t6BhC;;ADiu6BD;EACE,iCAAiC;AClu6BlC;;ADqu6BD;EACE,+BAA+B;ACtu6BhC;;ADyu6BD;EACE,iCAAiC;AC1u6BlC;;AD6u6BD;EACE,+BAA+B;AC9u6BhC;;ADiv6BD;EACE,iCAAiC;AClv6BlC;;ADqv6BD;EACE,+BAA+B;ACtv6BhC;;ADyv6BD;EACE,iCAAiC;AC1v6BlC;;AD6v6BD;EACE,+BAA+B;AC9v6BhC;;ADiw6BD;EACE,iCAAiC;AClw6BlC;;ADqw6BD;EACE,+BAA+B;ACtw6BhC;;ADyw6BD;EACE,iCAAiC;AC1w6BlC;;AD6w6BD;EACE,+BAA+B;AC9w6BhC;;ADix6BD;EACE,iCAAiC;AClx6BlC;;ADqx6BD;EACE,+BAA+B;ACtx6BhC;;ADyx6BD;EACE,iCAAiC;AC1x6BlC;;AD6x6BD;EACE,+BAA+B;AC9x6BhC;;ADiy6BD;EACE,iCAAiC;ACly6BlC;;ADqy6BD;EACE,+BAA+B;ACty6BhC;;ADyy6BD;EACE,iCAAiC;AC1y6BlC;;AD6y6BD;EACE,+BAA+B;AC9y6BhC;;ADiz6BD;EACE,iCAAiC;AClz6BlC;;ADqz6BD;EACE,+BAA+B;ACtz6BhC;;ADyz6BD;EACE,iCAAiC;AC1z6BlC;;AD6z6BD;EACE,+BAA+B;AC9z6BhC;;ADi06BD;EACE,iCAAiC;ACl06BlC;;ADq06BD;EACE,+BAA+B;ACt06BhC;;ADy06BD;EACE,iCAAiC;AC106BlC;;AD606BD;EACE,+BAA+B;AC906BhC;;ADi16BD;EACE,iCAAiC;ACl16BlC;;ADq16BD;EACE,+BAA+B;ACt16BhC;;ADy16BD;EACE,iCAAiC;AC116BlC;;AD616BD;EACE,+BAA+B;AC916BhC;;ADi26BD;EACE,iCAAiC;ACl26BlC;;ADq26BD;EACE,+BAA+B;ACt26BhC;;ADy26BD;EACE,iCAAiC;AC126BlC;;AD626BD;EACE,+BAA+B;AC926BhC;;ADi36BD;EACE,iCAAiC;ACl36BlC;;ADq36BD;EACE,+BAA+B;ACt36BhC;;ADy36BD;EACE,iCAAiC;AC136BlC;;AD636BD;EACE,+BAA+B;AC936BhC;;ADi46BD;EACE,iCAAiC;ACl46BlC;;ADq46BD;EACE,+BAA+B;ACt46BhC;;ADy46BD;EACE,iCAAiC;AC146BlC;;AD646BD;EACE,+BAA+B;AC946BhC;;ADi56BD;EACE,iCAAiC;ACl56BlC;;ADq56BD;EACE,+BAA+B;ACt56BhC;;ADy56BD;EACE,iCAAiC;AC156BlC;;AD656BD;EACE,+BAA+B;AC956BhC;;ADi66BD;EACE,iCAAiC;ACl66BlC;;ADq66BD;EACE,+BAA+B;ACt66BhC;;ADy66BD;EACE,iCAAiC;AC166BlC;;AD666BD;EACE,+BAA+B;AC966BhC;;ADi76BD;EACE,iCAAiC;ACl76BlC;;ADq76BD;EACE,+BAA+B;ACt76BhC;;ADy76BD;EACE,iCAAiC;AC176BlC;;AD676BD;EACE,+BAA+B;AC976BhC;;ADi86BD;EACE,iCAAiC;ACl86BlC;;ADq86BD;EACE,+BAA+B;ACt86BhC;;ADy86BD;EACE,iCAAiC;AC186BlC;;AD686BD;EACE,+BAA+B;AC986BhC;;ADi96BD;EACE,iCAAiC;AC/76BlC;;ADk86BD;EACE,+BAA+B;ACn86BhC;;ADs86BD;EACE,iCAAiC;ACv86BlC;;AD086BD;EACE,4BAA4B;AC386B7B;;AD886BD;EACE,+BAA+B;AC/86BhC;;ADk96BD;EACE,8BAA8B;ACn96B/B;;ADs96BD;EACE,4BAA4B;ACv96B7B;;AD096BD;EACE,8BAA8B;AC396B/B;;AD896BD;EACE,4BAA4B;AC/96B7B;;ADk+6BD;EACE,8BAA8B;ACn+6B/B;;ADs+6BD;EACE,4BAA4B;ACv+6B7B;;AD0+6BD;EACE,8BAA8B;AC3+6B/B;;AD8+6BD;EACE,4BAA4B;AC/+6B7B;;ADk/6BD;EACE,8BAA8B;ACn/6B/B;;ADs/6BD;EACE,4BAA4B;ACv/6B7B;;AD0/6BD;EACE,8BAA8B;AC3/6B/B;;AD8/6BD;EACE,4BAA4B;AC//6B7B;;ADkg7BD;EACE,8BAA8B;ACng7B/B;;ADsg7BD;EACE,4BAA4B;ACvg7B7B;;AD0g7BD;EACE,8BAA8B;AC3g7B/B;;AD8g7BD;EACE,4BAA4B;AC/g7B7B;;ADkh7BD;EACE,8BAA8B;ACnh7B/B;;ADsh7BD;EACE,4BAA4B;ACvh7B7B;;AD0h7BD;EACE,8BAA8B;AC3h7B/B;;AD8h7BD;EACE,6BAA6B;AC/h7B9B;;ADki7BD;EACE,+BAA+B;ACni7BhC;;ADsi7BD;EACE,6BAA6B;ACvi7B9B;;AD0i7BD;EACE,+BAA+B;AC3i7BhC;;AD8i7BD;EACE,6BAA6B;AC/i7B9B;;ADkj7BD;EACE,+BAA+B;ACnj7BhC;;ADsj7BD;EACE,6BAA6B;ACvj7B9B;;AD0j7BD;EACE,+BAA+B;AC3j7BhC;;AD8j7BD;EACE,6BAA6B;AC/j7B9B;;ADkk7BD;EACE,+BAA+B;ACnk7BhC;;ADsk7BD;EACE,6BAA6B;ACvk7B9B;;AD0k7BD;EACE,+BAA+B;AC3k7BhC;;AD8k7BD;EACE,6BAA6B;AC/k7B9B;;ADkl7BD;EACE,+BAA+B;ACnl7BhC;;ADsl7BD;EACE,6BAA6B;ACvl7B9B;;AD0l7BD;EACE,+BAA+B;AC3l7BhC;;AD8l7BD;EACE,6BAA6B;AC/l7B9B;;ADkm7BD;EACE,+BAA+B;ACnm7BhC;;ADsm7BD;EACE,6BAA6B;ACvm7B9B;;AD0m7BD;EACE,+BAA+B;AC3m7BhC;;AD8m7BD;EACE,6BAA6B;AC/m7B9B;;ADkn7BD;EACE,+BAA+B;ACnn7BhC;;ADsn7BD;EACE,6BAA6B;ACvn7B9B;;AD0n7BD;EACE,+BAA+B;AC3n7BhC;;AD8n7BD;EACE,6BAA6B;AC/n7B9B;;ADko7BD;EACE,+BAA+B;ACno7BhC;;ADso7BD;EACE,6BAA6B;ACvo7B9B;;AD0o7BD;EACE,+BAA+B;AC3o7BhC;;AD8o7BD;EACE,6BAA6B;AC/o7B9B;;ADkp7BD;EACE,+BAA+B;ACnp7BhC;;ADsp7BD;EACE,6BAA6B;ACvp7B9B;;AD0p7BD;EACE,+BAA+B;AC3p7BhC;;AD8p7BD;EACE,6BAA6B;AC/p7B9B;;ADkq7BD;EACE,+BAA+B;ACnq7BhC;;ADsq7BD;EACE,6BAA6B;ACvq7B9B;;AD0q7BD;EACE,+BAA+B;AC3q7BhC;;AD8q7BD;EACE,6BAA6B;AC/q7B9B;;ADkr7BD;EACE,+BAA+B;ACnr7BhC;;ADsr7BD;EACE,6BAA6B;ACvr7B9B;;AD0r7BD;EACE,+BAA+B;AC3r7BhC;;AD8r7BD;EACE,6BAA6B;AC/r7B9B;;ADks7BD;EACE,+BAA+B;ACns7BhC;;ADss7BD;EACE,6BAA6B;ACvs7B9B;;AD0s7BD;EACE,+BAA+B;AC3s7BhC;;AD8s7BD;EACE,6BAA6B;AC/s7B9B;;ADkt7BD;EACE,+BAA+B;ACnt7BhC;;ADst7BD;EACE,6BAA6B;ACvt7B9B;;AD0t7BD;EACE,+BAA+B;AC3t7BhC;;AD8t7BD;EACE,6BAA6B;AC/t7B9B;;ADku7BD;EACE,+BAA+B;ACnu7BhC;;ADsu7BD;EACE,6BAA6B;ACvu7B9B;;AD0u7BD;EACE,+BAA+B;AC3u7BhC;;AD8u7BD;EACE,6BAA6B;AC/u7B9B;;ADkv7BD;EACE,+BAA+B;ACnv7BhC;;ADsv7BD;EACE,6BAA6B;ACvv7B9B;;AD0v7BD;EACE,+BAA+B;AC3v7BhC;;AD8v7BD;EACE,6BAA6B;AC/v7B9B;;ADkw7BD;EACE,+BAA+B;ACnw7BhC;;ADsw7BD;EACE,6BAA6B;ACvw7B9B;;AD0w7BD;EACE,+BAA+B;AC3w7BhC;;AD8w7BD;EACE,6BAA6B;AC/w7B9B;;ADkx7BD;EACE,+BAA+B;ACnx7BhC;;ADsx7BD;EACE,6BAA6B;ACvx7B9B;;AD0x7BD;EACE,+BAA+B;AC3x7BhC;;AD8x7BD;EACE,6BAA6B;AC/x7B9B;;ADky7BD;EACE,+BAA+B;ACny7BhC;;ADsy7BD;EACE,6BAA6B;ACvy7B9B;;AD0y7BD;EACE,+BAA+B;AC3y7BhC;;AD8y7BD;EACE,6BAA6B;AC/y7B9B;;ADkz7BD;EACE,+BAA+B;ACnz7BhC;;ADsz7BD;EACE,6BAA6B;ACvz7B9B;;AD0z7BD;EACE,+BAA+B;AC3z7BhC;;AD8z7BD;EACE,6BAA6B;AC/z7B9B;;ADk07BD;EACE,+BAA+B;ACn07BhC;;ADs07BD;EACE,6BAA6B;ACv07B9B;;AD007BD;EACE,+BAA+B;AC307BhC;;AD807BD;EACE,6BAA6B;AC/07B9B;;ADk17BD;EACE,+BAA+B;ACn17BhC;;ADs17BD;EACE,6BAA6B;ACv17B9B;;AD017BD;EACE,+BAA+B;AC317BhC;;AD817BD;EACE,6BAA6B;AC/17B9B;;ADk27BD;EACE,+BAA+B;ACn27BhC;;ADs27BD;EACE,6BAA6B;ACv27B9B;;AD027BD;EACE,+BAA+B;AC327BhC;;AD827BD;EACE,6BAA6B;AC/27B9B;;ADk37BD;EACE,+BAA+B;ACn37BhC;;ADs37BD;EACE,6BAA6B;ACv37B9B;;AD037BD;EACE,+BAA+B;AC337BhC;;AD837BD;EACE,6BAA6B;AC/37B9B;;ADk47BD;EACE,+BAA+B;ACn47BhC;;ADs47BD;EACE,6BAA6B;ACv47B9B;;AD047BD;EACE,+BAA+B;AC347BhC;;AD847BD;EACE,6BAA6B;AC/47B9B;;ADk57BD;EACE,+BAA+B;ACn57BhC;;ADs57BD;EACE,6BAA6B;ACv57B9B;;AD057BD;EACE,+BAA+B;AC357BhC;;AD857BD;EACE,6BAA6B;AC/57B9B;;ADk67BD;EACE,+BAA+B;ACn67BhC;;ADs67BD;EACE,6BAA6B;ACv67B9B;;AD067BD;EACE,+BAA+B;AC367BhC;;AD867BD;EACE,6BAA6B;AC/67B9B;;ADk77BD;EACE,+BAA+B;ACn77BhC;;ADs77BD;EACE,6BAA6B;ACv77B9B;;AD077BD;EACE,+BAA+B;AC377BhC;;AD877BD;EACE,6BAA6B;AC/77B9B;;ADk87BD;EACE,+BAA+B;ACn87BhC;;ADs87BD;EACE,6BAA6B;ACv87B9B;;AD087BD;EACE,+BAA+B;AC387BhC;;AD887BD;EACE,6BAA6B;AC/87B9B;;ADk97BD;EACE,+BAA+B;ACn97BhC;;ADs97BD;EACE,6BAA6B;ACv97B9B;;AD097BD;EACE,+BAA+B;AC397BhC;;AD897BD;EACE,6BAA6B;AC/97B9B;;ADk+7BD;EACE,+BAA+B;ACn+7BhC;;ADs+7BD;EACE,6BAA6B;ACv+7B9B;;AD0+7BD;EACE,+BAA+B;AC3+7BhC;;AD8+7BD;EACE,6BAA6B;AC/+7B9B;;ADk/7BD;EACE,+BAA+B;ACn/7BhC;;ADs/7BD;EACE,6BAA6B;ACv/7B9B;;AD0/7BD;EACE,+BAA+B;AC3/7BhC;;AD8/7BD;EACE,6BAA6B;AC//7B9B;;ADkg8BD;EACE,+BAA+B;ACng8BhC;;ADsg8BD;EACE,6BAA6B;ACvg8B9B;;AD0g8BD;EACE,+BAA+B;AC3g8BhC;;AD8g8BD;EACE,6BAA6B;AC/g8B9B;;ADkh8BD;EACE,+BAA+B;ACnh8BhC;;ADsh8BD;EACE,6BAA6B;ACvh8B9B;;AD0h8BD;EACE,+BAA+B;AC3h8BhC;;AD8h8BD;EACE,6BAA6B;AC/h8B9B;;ADki8BD;EACE,+BAA+B;ACni8BhC;;ADsi8BD;EACE,6BAA6B;ACvi8B9B;;AD0i8BD;EACE,+BAA+B;AC3i8BhC;;AD8i8BD;EACE,6BAA6B;AC/i8B9B;;ADkj8BD;EACE,+BAA+B;ACnj8BhC;;ADsj8BD;EACE,6BAA6B;ACvj8B9B;;AD0j8BD;EACE,+BAA+B;AC3j8BhC;;AD8j8BD;EACE,6BAA6B;AC/j8B9B;;ADkk8BD;EACE,+BAA+B;AChj8BhC;;ADmj8BD;EACE,6BAA6B;ACpj8B9B;;ADuj8BD;EACE,+BAA+B;ACxj8BhC;;AD2j8BD;EACE,6BAA6B;AC5j8B9B;;AD+j8BD;EACE,gCAAgC;AChk8BjC;;ADmk8BD;EACE,+BAA+B;ACpk8BhC;;ADuk8BD;EACE,6BAA6B;ACxk8B9B;;AD2k8BD;EACE,+BAA+B;AC5k8BhC;;AD+k8BD;EACE,6BAA6B;AChl8B9B;;ADml8BD;EACE,+BAA+B;ACpl8BhC;;ADul8BD;EACE,6BAA6B;ACxl8B9B;;AD2l8BD;EACE,+BAA+B;AC5l8BhC;;AD+l8BD;EACE,6BAA6B;AChm8B9B;;ADmm8BD;EACE,+BAA+B;ACpm8BhC;;ADum8BD;EACE,6BAA6B;ACxm8B9B;;AD2m8BD;EACE,+BAA+B;AC5m8BhC;;AD+m8BD;EACE,6BAA6B;AChn8B9B;;ADmn8BD;EACE,+BAA+B;ACpn8BhC;;ADun8BD;EACE,6BAA6B;ACxn8B9B;;AD2n8BD;EACE,+BAA+B;AC5n8BhC;;AD+n8BD;EACE,6BAA6B;ACho8B9B;;ADmo8BD;EACE,+BAA+B;ACpo8BhC;;ADuo8BD;EACE,6BAA6B;ACxo8B9B;;AD2o8BD;EACE,+BAA+B;AC5o8BhC;;AD+o8BD;EACE,8BAA8B;AChp8B/B;;ADmp8BD;EACE,gCAAgC;ACpp8BjC;;ADup8BD;EACE,8BAA8B;ACxp8B/B;;AD2p8BD;EACE,gCAAgC;AC5p8BjC;;AD+p8BD;EACE,8BAA8B;AChq8B/B;;ADmq8BD;EACE,gCAAgC;ACpq8BjC;;ADuq8BD;EACE,8BAA8B;ACxq8B/B;;AD2q8BD;EACE,gCAAgC;AC5q8BjC;;AD+q8BD;EACE,8BAA8B;AChr8B/B;;ADmr8BD;EACE,gCAAgC;ACpr8BjC;;ADur8BD;EACE,8BAA8B;ACxr8B/B;;AD2r8BD;EACE,gCAAgC;AC5r8BjC;;AD+r8BD;EACE,8BAA8B;AChs8B/B;;ADms8BD;EACE,gCAAgC;ACps8BjC;;ADus8BD;EACE,8BAA8B;ACxs8B/B;;AD2s8BD;EACE,gCAAgC;AC5s8BjC;;AD+s8BD;EACE,8BAA8B;ACht8B/B;;ADmt8BD;EACE,gCAAgC;ACpt8BjC;;ADut8BD;EACE,8BAA8B;ACxt8B/B;;AD2t8BD;EACE,gCAAgC;AC5t8BjC;;AD+t8BD;EACE,8BAA8B;AChu8B/B;;ADmu8BD;EACE,gCAAgC;ACpu8BjC;;ADuu8BD;EACE,8BAA8B;ACxu8B/B;;AD2u8BD;EACE,gCAAgC;AC5u8BjC;;AD+u8BD;EACE,8BAA8B;AChv8B/B;;ADmv8BD;EACE,gCAAgC;ACpv8BjC;;ADuv8BD;EACE,8BAA8B;ACxv8B/B;;AD2v8BD;EACE,gCAAgC;AC5v8BjC;;AD+v8BD;EACE,8BAA8B;AChw8B/B;;ADmw8BD;EACE,gCAAgC;ACpw8BjC;;ADuw8BD;EACE,8BAA8B;ACxw8B/B;;AD2w8BD;EACE,gCAAgC;AC5w8BjC;;AD+w8BD;EACE,8BAA8B;AChx8B/B;;ADmx8BD;EACE,gCAAgC;ACpx8BjC;;ADux8BD;EACE,8BAA8B;ACxx8B/B;;AD2x8BD;EACE,gCAAgC;AC5x8BjC;;AD+x8BD;EACE,8BAA8B;AChy8B/B;;ADmy8BD;EACE,gCAAgC;ACpy8BjC;;ADuy8BD;EACE,8BAA8B;ACxy8B/B;;AD2y8BD;EACE,gCAAgC;AC5y8BjC;;AD+y8BD;EACE,8BAA8B;AChz8B/B;;ADmz8BD;EACE,gCAAgC;ACpz8BjC;;ADuz8BD;EACE,8BAA8B;ACxz8B/B;;AD2z8BD;EACE,gCAAgC;AC5z8BjC;;AD+z8BD;EACE,8BAA8B;ACh08B/B;;ADm08BD;EACE,gCAAgC;ACp08BjC;;ADu08BD;EACE,8BAA8B;ACx08B/B;;AD208BD;EACE,gCAAgC;AC508BjC;;AD+08BD;EACE,8BAA8B;ACh18B/B;;ADm18BD;EACE,gCAAgC;ACp18BjC;;ADu18BD;EACE,8BAA8B;ACx18B/B;;AD218BD;EACE,gCAAgC;AC518BjC;;AD+18BD;EACE,8BAA8B;ACh28B/B;;ADm28BD;EACE,gCAAgC;ACp28BjC;;ADu28BD;EACE,8BAA8B;ACx28B/B;;AD228BD;EACE,gCAAgC;AC528BjC;;AD+28BD;EACE,8BAA8B;ACh38B/B;;ADm38BD;EACE,gCAAgC;ACp38BjC;;ADu38BD;EACE,8BAA8B;ACx38B/B;;AD238BD;EACE,gCAAgC;AC538BjC;;AD+38BD;EACE,8BAA8B;ACh48B/B;;ADm48BD;EACE,gCAAgC;ACp48BjC;;ADu48BD;EACE,8BAA8B;ACx48B/B;;AD248BD;EACE,gCAAgC;AC548BjC;;AD+48BD;EACE,8BAA8B;ACh58B/B;;ADm58BD;EACE,gCAAgC;ACp58BjC;;ADu58BD;EACE,8BAA8B;ACx58B/B;;AD258BD;EACE,gCAAgC;AC558BjC;;AD+58BD;EACE,8BAA8B;ACh68B/B;;ADm68BD;EACE,gCAAgC;ACp68BjC;;ADu68BD;EACE,8BAA8B;ACx68B/B;;AD268BD;EACE,gCAAgC;AC568BjC;;AD+68BD;EACE,8BAA8B;ACh78B/B;;ADm78BD;EACE,gCAAgC;ACp78BjC;;ADu78BD;EACE,8BAA8B;ACx78B/B;;AD278BD;EACE,gCAAgC;AC578BjC;;AD+78BD;EACE,8BAA8B;ACh88B/B;;ADm88BD;EACE,gCAAgC;ACp88BjC;;ADu88BD;EACE,8BAA8B;ACx88B/B;;AD288BD;EACE,gCAAgC;AC588BjC;;AD+88BD;EACE,8BAA8B;ACh98B/B;;ADm98BD;EACE,gCAAgC;ACp98BjC;;ADu98BD;EACE,8BAA8B;ACx98B/B;;AD298BD;EACE,gCAAgC;AC598BjC;;AD+98BD;EACE,8BAA8B;ACh+8B/B;;ADm+8BD;EACE,gCAAgC;ACp+8BjC;;ADu+8BD;EACE,8BAA8B;ACx+8B/B;;AD2+8BD;EACE,gCAAgC;AC5+8BjC;;AD++8BD;EACE,8BAA8B;ACh/8B/B;;ADm/8BD;EACE,gCAAgC;ACp/8BjC;;ADu/8BD;EACE,8BAA8B;ACx/8B/B;;AD2/8BD;EACE,gCAAgC;AC5/8BjC;;AD+/8BD;EACE,8BAA8B;AChg9B/B;;ADmg9BD;EACE,gCAAgC;ACpg9BjC;;ADug9BD;EACE,8BAA8B;ACxg9B/B;;AD2g9BD;EACE,gCAAgC;AC5g9BjC;;AD+g9BD;EACE,8BAA8B;AChh9B/B;;ADmh9BD;EACE,gCAAgC;ACph9BjC;;ADuh9BD;EACE,8BAA8B;ACxh9B/B;;AD2h9BD;EACE,gCAAgC;AC5h9BjC;;AD+h9BD;EACE,8BAA8B;AChi9B/B;;ADmi9BD;EACE,gCAAgC;ACpi9BjC;;ADui9BD;EACE,8BAA8B;ACxi9B/B;;AD2i9BD;EACE,gCAAgC;AC5i9BjC;;AD+i9BD;EACE,8BAA8B;AChj9B/B;;ADmj9BD;EACE,gCAAgC;ACpj9BjC;;ADuj9BD;EACE,8BAA8B;ACxj9B/B;;AD2j9BD;EACE,gCAAgC;AC5j9BjC;;AD+j9BD;EACE,8BAA8B;AChk9B/B;;ADmk9BD;EACE,gCAAgC;ACpk9BjC;;ADuk9BD;EACE,8BAA8B;ACxk9B/B;;AD2k9BD;EACE,gCAAgC;AC5k9BjC;;AD+k9BD;EACE,8BAA8B;AChl9B/B;;ADml9BD;EACE,gCAAgC;ACpl9BjC;;ADul9BD;EACE,8BAA8B;ACxl9B/B;;AD2l9BD;EACE,gCAAgC;AC5l9BjC;;AD+l9BD;EACE,8BAA8B;AChm9B/B;;ADmm9BD;EACE,gCAAgC;ACpm9BjC;;ADum9BD;EACE,8BAA8B;ACxm9B/B;;AD2m9BD;EACE,gCAAgC;AC5m9BjC;;AD+m9BD;EACE,8BAA8B;AChn9B/B;;ADmn9BD;EACE,gCAAgC;ACpn9BjC;;ADun9BD;EACE,8BAA8B;ACxn9B/B;;AD2n9BD;EACE,gCAAgC;AC5n9BjC;;AD+n9BD;EACE,8BAA8B;ACho9B/B;;ADmo9BD;EACE,gCAAgC;ACpo9BjC;;ADuo9BD;EACE,8BAA8B;ACxo9B/B;;AD2o9BD;EACE,gCAAgC;AC5o9BjC;;AD+o9BD;EACE,8BAA8B;AChp9B/B;;ADmp9BD;EACE,gCAAgC;ACpp9BjC;;ADup9BD;EACE,8BAA8B;ACxp9B/B;;AD2p9BD;EACE,gCAAgC;AC5p9BjC;;AD+p9BD;EACE,8BAA8B;AChq9B/B;;ADmq9BD;EACE,gCAAgC;ACpq9BjC;;ADuq9BD;EACE,8BAA8B;ACxq9B/B;;AD2q9BD;EACE,gCAAgC;AC5q9BjC;;AD+q9BD;EACE,8BAA8B;AChr9B/B;;ADmr9BD;EACE,gCAAgC;ACjq9BjC;;ADoq9BD;EACE,8BAA8B;AAChC;;AAEA;ECtq9BE,gCAAsC;ADwq9BxC;;AC1q9BC;EACC,4BAAa;EACb,6BAAc;AD6q9BhB;;AC/q9BC;EACC,+BAAqC;EACrC,gCAAsC;ADkr9BxC;;ACpr9BC;EACC,8BAAqC;EACrC,+BAAsC;ADur9BxC;;ACzr9BC;EACC,4BAAqC;EACrC,6BAAsC;AD4r9BxC;;AC9r9BC;EACC,8BAAqC;EACrC,+BAAsC;ADis9BxC;;ACns9BC;EACC,4BAAqC;EACrC,6BAAsC;ADss9BxC;;ACxs9BC;EACC,8BAAqC;EACrC,+BAAsC;AD2s9BxC;;AC7s9BC;EACC,4BAAqC;EACrC,6BAAsC;ADgt9BxC;;AClt9BC;EACC,8BAAqC;EACrC,+BAAsC;ADqt9BxC;;ACvt9BC;EACC,4BAAqC;EACrC,6BAAsC;AD0t9BxC;;AC5t9BC;EACC,8BAAqC;EACrC,+BAAsC;AD+t9BxC;;ACju9BC;EACC,4BAAqC;EACrC,6BAAsC;ADou9BxC;;ACtu9BC;EACC,8BAAqC;EACrC,+BAAsC;ADyu9BxC;;AC3u9BC;EACC,4BAAqC;EACrC,6BAAsC;AD8u9BxC;;AChv9BC;EACC,8BAAqC;EACrC,+BAAsC;ADmv9BxC;;ACrv9BC;EACC,4BAAqC;EACrC,6BAAsC;ADwv9BxC;;AC1v9BC;EACC,8BAAqC;EACrC,+BAAsC;AD6v9BxC;;AC/v9BC;EACC,4BAAqC;EACrC,6BAAsC;ADkw9BxC;;ACpw9BC;EACC,8BAAqC;EACrC,+BAAsC;ADuw9BxC;;ACzw9BC;EACC,4BAAa;EACb,6BAAc;AD4w9BhB;;AC9w9BC;EACC,8BAAa;EACb,+BAAc;ADix9BhB;;ACnx9BC;EACC,6BAAqC;EACrC,8BAAsC;ADsx9BxC;;ACxx9BC;EACC,+BAAqC;EACrC,gCAAsC;AD2x9BxC;;AC7x9BC;EACC,6BAAqC;EACrC,8BAAsC;ADgy9BxC;;ACly9BC;EACC,+BAAqC;EACrC,gCAAsC;ADqy9BxC;;ACvy9BC;EACC,6BAAqC;EACrC,8BAAsC;AD0y9BxC;;AC5y9BC;EACC,+BAAqC;EACrC,gCAAsC;AD+y9BxC;;ACjz9BC;EACC,6BAAqC;EACrC,8BAAsC;ADoz9BxC;;ACtz9BC;EACC,+BAAqC;EACrC,gCAAsC;ADyz9BxC;;AC3z9BC;EACC,6BAAqC;EACrC,8BAAsC;AD8z9BxC;;ACh09BC;EACC,+BAAqC;EACrC,gCAAsC;ADm09BxC;;ACr09BC;EACC,6BAAqC;EACrC,8BAAsC;ADw09BxC;;AC109BC;EACC,+BAAqC;EACrC,gCAAsC;AD609BxC;;AC/09BC;EACC,6BAAqC;EACrC,8BAAsC;ADk19BxC;;ACp19BC;EACC,+BAAqC;EACrC,gCAAsC;ADu19BxC;;ACz19BC;EACC,6BAAqC;EACrC,8BAAsC;AD419BxC;;AC919BC;EACC,+BAAqC;EACrC,gCAAsC;ADi29BxC;;ACn29BC;EACC,6BAAqC;EACrC,8BAAsC;ADs29BxC;;ACx29BC;EACC,+BAAqC;EACrC,gCAAsC;AD229BxC;;AC729BC;EACC,6BAAqC;EACrC,8BAAsC;ADg39BxC;;ACl39BC;EACC,+BAAqC;EACrC,gCAAsC;ADq39BxC;;ACv39BC;EACC,6BAAqC;EACrC,8BAAsC;AD039BxC;;AC539BC;EACC,+BAAqC;EACrC,gCAAsC;AD+39BxC;;ACj49BC;EACC,6BAAqC;EACrC,8BAAsC;ADo49BxC;;ACt49BC;EACC,+BAAqC;EACrC,gCAAsC;ADy49BxC;;AC349BC;EACC,6BAAqC;EACrC,8BAAsC;AD849BxC;;ACh59BC;EACC,+BAAqC;EACrC,gCAAsC;ADm59BxC;;ACr59BC;EACC,6BAAqC;EACrC,8BAAsC;ADw59BxC;;AC159BC;EACC,+BAAqC;EACrC,gCAAsC;AD659BxC;;AC/59BC;EACC,6BAAqC;EACrC,8BAAsC;ADk69BxC;;ACp69BC;EACC,+BAAqC;EACrC,gCAAsC;ADu69BxC;;ACz69BC;EACC,6BAAqC;EACrC,8BAAsC;AD469BxC;;AC969BC;EACC,+BAAqC;EACrC,gCAAsC;ADi79BxC;;ACn79BC;EACC,6BAAqC;EACrC,8BAAsC;ADs79BxC;;ACx79BC;EACC,+BAAqC;EACrC,gCAAsC;AD279BxC;;AC779BC;EACC,6BAAqC;EACrC,8BAAsC;ADg89BxC;;ACl89BC;EACC,+BAAqC;EACrC,gCAAsC;ADq89BxC;;ACv89BC;EACC,6BAAqC;EACrC,8BAAsC;AD089BxC;;AC589BC;EACC,+BAAqC;EACrC,gCAAsC;AD+89BxC;;ACj99BC;EACC,6BAAqC;EACrC,8BAAsC;ADo99BxC;;ACt99BC;EACC,+BAAqC;EACrC,gCAAsC;ADy99BxC;;AC399BC;EACC,6BAAqC;EACrC,8BAAsC;AD899BxC;;ACh+9BC;EACC,+BAAqC;EACrC,gCAAsC;ADm+9BxC;;ACr+9BC;EACC,6BAAqC;EACrC,8BAAsC;ADw+9BxC;;AC1+9BC;EACC,+BAAqC;EACrC,gCAAsC;AD6+9BxC;;AC/+9BC;EACC,6BAAqC;EACrC,8BAAsC;ADk/9BxC;;ACp/9BC;EACC,+BAAqC;EACrC,gCAAsC;ADu/9BxC;;ACz/9BC;EACC,6BAAqC;EACrC,8BAAsC;AD4/9BxC;;AC9/9BC;EACC,+BAAqC;EACrC,gCAAsC;ADig+BxC;;ACng+BC;EACC,6BAAqC;EACrC,8BAAsC;ADsg+BxC;;ACxg+BC;EACC,+BAAqC;EACrC,gCAAsC;AD2g+BxC;;AC7g+BC;EACC,6BAAqC;EACrC,8BAAsC;ADgh+BxC;;AClh+BC;EACC,+BAAqC;EACrC,gCAAsC;ADqh+BxC;;ACvh+BC;EACC,6BAAqC;EACrC,8BAAsC;AD0h+BxC;;AC5h+BC;EACC,+BAAqC;EACrC,gCAAsC;AD+h+BxC;;ACji+BC;EACC,6BAAqC;EACrC,8BAAsC;ADoi+BxC;;ACti+BC;EACC,+BAAqC;EACrC,gCAAsC;ADyi+BxC;;AC3i+BC;EACC,6BAAqC;EACrC,8BAAsC;AD8i+BxC;;AChj+BC;EACC,+BAAqC;EACrC,gCAAsC;ADmj+BxC;;ACrj+BC;EACC,6BAAqC;EACrC,8BAAsC;ADwj+BxC;;AC1j+BC;EACC,+BAAqC;EACrC,gCAAsC;AD6j+BxC;;AC/j+BC;EACC,6BAAqC;EACrC,8BAAsC;ADkk+BxC;;ACpk+BC;EACC,+BAAqC;EACrC,gCAAsC;ADuk+BxC;;ACzk+BC;EACC,6BAAqC;EACrC,8BAAsC;AD4k+BxC;;AC9k+BC;EACC,+BAAqC;EACrC,gCAAsC;ADil+BxC;;ACnl+BC;EACC,6BAAqC;EACrC,8BAAsC;ADsl+BxC;;ACxl+BC;EACC,+BAAqC;EACrC,gCAAsC;AD2l+BxC;;AC7l+BC;EACC,6BAAqC;EACrC,8BAAsC;ADgm+BxC;;AClm+BC;EACC,+BAAqC;EACrC,gCAAsC;ADqm+BxC;;ACvm+BC;EACC,6BAAqC;EACrC,8BAAsC;AD0m+BxC;;AC5m+BC;EACC,+BAAqC;EACrC,gCAAsC;AD+m+BxC;;ACjn+BC;EACC,6BAAqC;EACrC,8BAAsC;ADon+BxC;;ACtn+BC;EACC,+BAAqC;EACrC,gCAAsC;ADyn+BxC;;AC3n+BC;EACC,6BAAqC;EACrC,8BAAsC;AD8n+BxC;;ACho+BC;EACC,+BAAqC;EACrC,gCAAsC;ADmo+BxC;;ACro+BC;EACC,6BAAqC;EACrC,8BAAsC;ADwo+BxC;;AC1o+BC;EACC,+BAAqC;EACrC,gCAAsC;AD6o+BxC;;AC/o+BC;EACC,6BAAqC;EACrC,8BAAsC;ADkp+BxC;;ACpp+BC;EACC,+BAAqC;EACrC,gCAAsC;ADup+BxC;;ACzp+BC;EACC,6BAAqC;EACrC,8BAAsC;AD4p+BxC;;AC9p+BC;EACC,+BAAqC;EACrC,gCAAsC;ADiq+BxC;;ACnq+BC;EACC,6BAAqC;EACrC,8BAAsC;ADsq+BxC;;ACxq+BC;EACC,+BAAqC;EACrC,gCAAsC;AD2q+BxC;;AC7q+BC;EACC,6BAAqC;EACrC,8BAAsC;ADgr+BxC;;AClr+BC;EACC,+BAAqC;EACrC,gCAAsC;ADqr+BxC;;ACvr+BC;EACC,6BAAqC;EACrC,8BAAsC;AD0r+BxC;;AC5r+BC;EACC,+BAAqC;EACrC,gCAAsC;AD+r+BxC;;ACjs+BC;EACC,6BAAqC;EACrC,8BAAsC;ADos+BxC;;ACts+BC;EACC,+BAAqC;EACrC,gCAAsC;ADys+BxC;;AC3s+BC;EACC,6BAAqC;EACrC,8BAAsC;AD8s+BxC;;ACht+BC;EACC,+BAAqC;EACrC,gCAAsC;ADmt+BxC;;ACrt+BC;EACC,6BAAqC;EACrC,8BAAsC;ADwt+BxC;;AC1t+BC;EACC,+BAAqC;EACrC,gCAAsC;AD6t+BxC;;AC/t+BC;EACC,6BAAqC;EACrC,8BAAsC;ADku+BxC;;ACpu+BC;EACC,+BAAqC;EACrC,gCAAsC;ADuu+BxC;;ACzu+BC;EACC,6BAAqC;EACrC,8BAAsC;AD4u+BxC;;AC9u+BC;EACC,+BAAqC;EACrC,gCAAsC;ADiv+BxC;;ACnv+BC;EACC,6BAAqC;EACrC,8BAAsC;ADsv+BxC;;ACxv+BC;EACC,+BAAqC;EACrC,gCAAsC;AD2v+BxC;;AC7v+BC;EACC,6BAAqC;EACrC,8BAAsC;ADgw+BxC;;AClw+BC;EACC,+BAAqC;EACrC,gCAAsC;ADqw+BxC;;ACvw+BC;EACC,6BAAqC;EACrC,8BAAsC;AD0w+BxC;;AC5w+BC;EACC,+BAAqC;EACrC,gCAAsC;AD+w+BxC;;ACjx+BC;EACC,6BAAqC;EACrC,8BAAsC;ADox+BxC;;ACtx+BC;EACC,+BAAqC;EACrC,gCAAsC;ADyx+BxC;;AC3x+BC;EACC,6BAAqC;EACrC,8BAAsC;AD8x+BxC;;AChy+BC;EACC,+BAAqC;EACrC,gCAAsC;ADmy+BxC;;ACry+BC;EACC,6BAAqC;EACrC,8BAAsC;ADwy+BxC;;AC1y+BC;EACC,+BAAqC;EACrC,gCAAsC;AD6y+BxC;;AC/y+BC;EACC,6BAAqC;EACrC,8BAAsC;ADkz+BxC;;ACpz+BC;EACC,+BAAqC;EACrC,gCAAsC;ADuz+BxC;;ACzz+BC;EACC,6BAAqC;EACrC,8BAAsC;AD4z+BxC;;AC9z+BC;EACC,+BAAqC;EACrC,gCAAsC;ADi0+BxC;;ACn0+BC;EACC,6BAAqC;EACrC,8BAAsC;ADs0+BxC;;ACx0+BC;EACC,+BAAqC;EACrC,gCAAsC;AD20+BxC;;AC70+BC;EACC,6BAAqC;EACrC,8BAAsC;ADg1+BxC;;ACl1+BC;EACC,+BAAqC;EACrC,gCAAsC;ADq1+BxC;;ACv1+BC;EACC,6BAAqC;EACrC,8BAAsC;AD01+BxC;;AC51+BC;EACC,+BAAqC;EACrC,gCAAsC;AD+1+BxC;;ACj2+BC;EACC,6BAAqC;EACrC,8BAAsC;ADo2+BxC;;ACt2+BC;EACC,+BAAqC;EACrC,gCAAsC;ADy2+BxC;;AC32+BC;EACC,6BAAqC;EACrC,8BAAsC;AD82+BxC;;ACh3+BC;EACC,+BAAqC;EACrC,gCAAsC;ADm3+BxC;;ACr3+BC;EACC,6BAAqC;EACrC,8BAAsC;ADw3+BxC;;AC13+BC;EACC,+BAAqC;EACrC,gCAAsC;AD63+BxC;;AC/3+BC;EACC,6BAAqC;EACrC,8BAAsC;ADk4+BxC;;ACp4+BC;EACC,+BAAqC;EACrC,gCAAsC;ADu4+BxC;;ACz4+BC;EACC,6BAAqC;EACrC,8BAAsC;AD44+BxC;;AC94+BC;EACC,+BAAqC;EACrC,gCAAsC;ADi5+BxC;;ACn5+BC;EACC,6BAAqC;EACrC,8BAAsC;ADs5+BxC;;ACx5+BC;EACC,+BAAqC;EACrC,gCAAsC;AD25+BxC;;AC75+BC;EACC,6BAAqC;EACrC,8BAAsC;ADg6+BxC;;ACl6+BC;EACC,+BAAqC;EACrC,gCAAsC;ADq6+BxC;;ACv6+BC;EACC,6BAAqC;EACrC,8BAAsC;AD06+BxC;;AC56+BC;EACC,+BAAqC;EACrC,gCAAsC;AD+6+BxC;;ACj7+BC;EACC,6BAAqC;EACrC,8BAAsC;ADo7+BxC;;ACt7+BC;EACC,+BAAqC;EACrC,gCAAsC;ADy7+BxC;;AC37+BC;EACC,6BAAqC;EACrC,8BAAsC;AD87+BxC;;ACh8+BC;EACC,+BAAqC;EACrC,gCAAsC;ADm8+BxC;;ACj7+BC;EACC,6BAAoC;EACpC,8BAAuC;ADo7+BzC;;ACt7+BC;EACC,+BAAoC;EACpC,gCAAe;ADy7+BjB;;AC37+BC;EACC,2BAAY;EACZ,8BAAe;AD87+BjB;;ACh8+BC;EACC,8BAAoC;EACpC,iCAAuC;ADm8+BzC;;ACr8+BC;EACC,6BAAoC;EACpC,gCAAuC;ADw8+BzC;;AC18+BC;EACC,2BAAoC;EACpC,8BAAuC;AD68+BzC;;AC/8+BC;EACC,6BAAoC;EACpC,gCAAuC;ADk9+BzC;;ACp9+BC;EACC,2BAAoC;EACpC,8BAAuC;ADu9+BzC;;ACz9+BC;EACC,6BAAoC;EACpC,gCAAuC;AD49+BzC;;AC99+BC;EACC,2BAAoC;EACpC,8BAAuC;ADi++BzC;;ACn++BC;EACC,6BAAoC;EACpC,gCAAuC;ADs++BzC;;ACx++BC;EACC,2BAAoC;EACpC,8BAAuC;AD2++BzC;;AC7++BC;EACC,6BAAoC;EACpC,gCAAuC;ADg/+BzC;;ACl/+BC;EACC,2BAAoC;EACpC,8BAAuC;ADq/+BzC;;ACv/+BC;EACC,6BAAoC;EACpC,gCAAuC;AD0/+BzC;;AC5/+BC;EACC,2BAAoC;EACpC,8BAAuC;AD+/+BzC;;ACjg/BC;EACC,6BAAoC;EACpC,gCAAuC;ADog/BzC;;ACtg/BC;EACC,2BAAoC;EACpC,8BAAuC;ADyg/BzC;;AC3g/BC;EACC,6BAAoC;EACpC,gCAAuC;AD8g/BzC;;AChh/BC;EACC,2BAAoC;EACpC,8BAAuC;ADmh/BzC;;ACrh/BC;EACC,6BAAoC;EACpC,gCAAuC;ADwh/BzC;;AC1h/BC;EACC,2BAAY;EACZ,8BAAe;AD6h/BjB;;AC/h/BC;EACC,6BAAY;EACZ,gCAAe;ADki/BjB;;ACpi/BC;EACC,4BAAoC;EACpC,+BAAuC;ADui/BzC;;ACzi/BC;EACC,8BAAoC;EACpC,iCAAuC;AD4i/BzC;;AC9i/BC;EACC,4BAAoC;EACpC,+BAAuC;ADij/BzC;;ACnj/BC;EACC,8BAAoC;EACpC,iCAAuC;ADsj/BzC;;ACxj/BC;EACC,4BAAoC;EACpC,+BAAuC;AD2j/BzC;;AC7j/BC;EACC,8BAAoC;EACpC,iCAAuC;ADgk/BzC;;AClk/BC;EACC,4BAAoC;EACpC,+BAAuC;ADqk/BzC;;ACvk/BC;EACC,8BAAoC;EACpC,iCAAuC;AD0k/BzC;;AC5k/BC;EACC,4BAAoC;EACpC,+BAAuC;AD+k/BzC;;ACjl/BC;EACC,8BAAoC;EACpC,iCAAuC;ADol/BzC;;ACtl/BC;EACC,4BAAoC;EACpC,+BAAuC;ADyl/BzC;;AC3l/BC;EACC,8BAAoC;EACpC,iCAAuC;AD8l/BzC;;AChm/BC;EACC,4BAAoC;EACpC,+BAAuC;ADmm/BzC;;ACrm/BC;EACC,8BAAoC;EACpC,iCAAuC;ADwm/BzC;;AC1m/BC;EACC,4BAAoC;EACpC,+BAAuC;AD6m/BzC;;AC/m/BC;EACC,8BAAoC;EACpC,iCAAuC;ADkn/BzC;;ACpn/BC;EACC,4BAAoC;EACpC,+BAAuC;ADun/BzC;;ACzn/BC;EACC,8BAAoC;EACpC,iCAAuC;AD4n/BzC;;AC9n/BC;EACC,4BAAoC;EACpC,+BAAuC;ADio/BzC;;ACno/BC;EACC,8BAAoC;EACpC,iCAAuC;ADso/BzC;;ACxo/BC;EACC,4BAAoC;EACpC,+BAAuC;AD2o/BzC;;AC7o/BC;EACC,8BAAoC;EACpC,iCAAuC;ADgp/BzC;;AClp/BC;EACC,4BAAoC;EACpC,+BAAuC;ADqp/BzC;;ACvp/BC;EACC,8BAAoC;EACpC,iCAAuC;AD0p/BzC;;AC5p/BC;EACC,4BAAoC;EACpC,+BAAuC;AD+p/BzC;;ACjq/BC;EACC,8BAAoC;EACpC,iCAAuC;ADoq/BzC;;ACtq/BC;EACC,4BAAoC;EACpC,+BAAuC;ADyq/BzC;;AC3q/BC;EACC,8BAAoC;EACpC,iCAAuC;AD8q/BzC;;AChr/BC;EACC,4BAAoC;EACpC,+BAAuC;ADmr/BzC;;ACrr/BC;EACC,8BAAoC;EACpC,iCAAuC;ADwr/BzC;;AC1r/BC;EACC,4BAAoC;EACpC,+BAAuC;AD6r/BzC;;AC/r/BC;EACC,8BAAoC;EACpC,iCAAuC;ADks/BzC;;ACps/BC;EACC,4BAAoC;EACpC,+BAAuC;ADus/BzC;;ACzs/BC;EACC,8BAAoC;EACpC,iCAAuC;AD4s/BzC;;AC9s/BC;EACC,4BAAoC;EACpC,+BAAuC;ADit/BzC;;ACnt/BC;EACC,8BAAoC;EACpC,iCAAuC;ADst/BzC;;ACxt/BC;EACC,4BAAoC;EACpC,+BAAuC;AD2t/BzC;;AC7t/BC;EACC,8BAAoC;EACpC,iCAAuC;ADgu/BzC;;AClu/BC;EACC,4BAAoC;EACpC,+BAAuC;ADqu/BzC;;ACvu/BC;EACC,8BAAoC;EACpC,iCAAuC;AD0u/BzC;;AC5u/BC;EACC,4BAAoC;EACpC,+BAAuC;AD+u/BzC;;ACjv/BC;EACC,8BAAoC;EACpC,iCAAuC;ADov/BzC;;ACtv/BC;EACC,4BAAoC;EACpC,+BAAuC;ADyv/BzC;;AC3v/BC;EACC,8BAAoC;EACpC,iCAAuC;AD8v/BzC;;AChw/BC;EACC,4BAAoC;EACpC,+BAAuC;ADmw/BzC;;ACrw/BC;EACC,8BAAoC;EACpC,iCAAuC;ADww/BzC;;AC1w/BC;EACC,4BAAoC;EACpC,+BAAuC;AD6w/BzC;;AC/w/BC;EACC,8BAAoC;EACpC,iCAAuC;ADkx/BzC;;ACpx/BC;EACC,4BAAoC;EACpC,+BAAuC;ADux/BzC;;ACzx/BC;EACC,8BAAoC;EACpC,iCAAuC;AD4x/BzC;;AC9x/BC;EACC,4BAAoC;EACpC,+BAAuC;ADiy/BzC;;ACny/BC;EACC,8BAAoC;EACpC,iCAAuC;ADsy/BzC;;ACxy/BC;EACC,4BAAoC;EACpC,+BAAuC;AD2y/BzC;;AC7y/BC;EACC,8BAAoC;EACpC,iCAAuC;ADgz/BzC;;AClz/BC;EACC,4BAAoC;EACpC,+BAAuC;ADqz/BzC;;ACvz/BC;EACC,8BAAoC;EACpC,iCAAuC;AD0z/BzC;;AC5z/BC;EACC,4BAAoC;EACpC,+BAAuC;AD+z/BzC;;ACj0/BC;EACC,8BAAoC;EACpC,iCAAuC;ADo0/BzC;;ACt0/BC;EACC,4BAAoC;EACpC,+BAAuC;ADy0/BzC;;AC30/BC;EACC,8BAAoC;EACpC,iCAAuC;AD80/BzC;;ACh1/BC;EACC,4BAAoC;EACpC,+BAAuC;ADm1/BzC;;ACr1/BC;EACC,8BAAoC;EACpC,iCAAuC;ADw1/BzC;;AC11/BC;EACC,4BAAoC;EACpC,+BAAuC;AD61/BzC;;AC/1/BC;EACC,8BAAoC;EACpC,iCAAuC;ADk2/BzC;;ACp2/BC;EACC,4BAAoC;EACpC,+BAAuC;ADu2/BzC;;ACz2/BC;EACC,8BAAoC;EACpC,iCAAuC;AD42/BzC;;AC92/BC;EACC,4BAAoC;EACpC,+BAAuC;ADi3/BzC;;ACn3/BC;EACC,8BAAoC;EACpC,iCAAuC;ADs3/BzC;;ACx3/BC;EACC,4BAAoC;EACpC,+BAAuC;AD23/BzC;;AC73/BC;EACC,8BAAoC;EACpC,iCAAuC;ADg4/BzC;;ACl4/BC;EACC,4BAAoC;EACpC,+BAAuC;ADq4/BzC;;ACv4/BC;EACC,8BAAoC;EACpC,iCAAuC;AD04/BzC;;AC54/BC;EACC,4BAAoC;EACpC,+BAAuC;AD+4/BzC;;ACj5/BC;EACC,8BAAoC;EACpC,iCAAuC;ADo5/BzC;;ACt5/BC;EACC,4BAAoC;EACpC,+BAAuC;ADy5/BzC;;AC35/BC;EACC,8BAAoC;EACpC,iCAAuC;AD85/BzC;;ACh6/BC;EACC,4BAAoC;EACpC,+BAAuC;ADm6/BzC;;ACr6/BC;EACC,8BAAoC;EACpC,iCAAuC;ADw6/BzC;;AC16/BC;EACC,4BAAoC;EACpC,+BAAuC;AD66/BzC;;AC/6/BC;EACC,8BAAoC;EACpC,iCAAuC;ADk7/BzC;;ACp7/BC;EACC,4BAAoC;EACpC,+BAAuC;ADu7/BzC;;ACz7/BC;EACC,8BAAoC;EACpC,iCAAuC;AD47/BzC;;AC97/BC;EACC,4BAAoC;EACpC,+BAAuC;ADi8/BzC;;ACn8/BC;EACC,8BAAoC;EACpC,iCAAuC;ADs8/BzC;;ACx8/BC;EACC,4BAAoC;EACpC,+BAAuC;AD28/BzC;;AC78/BC;EACC,8BAAoC;EACpC,iCAAuC;ADg9/BzC;;ACl9/BC;EACC,4BAAoC;EACpC,+BAAuC;ADq9/BzC;;ACv9/BC;EACC,8BAAoC;EACpC,iCAAuC;AD09/BzC;;AC59/BC;EACC,4BAAoC;EACpC,+BAAuC;AD+9/BzC;;ACj+/BC;EACC,8BAAoC;EACpC,iCAAuC;ADo+/BzC;;ACt+/BC;EACC,4BAAoC;EACpC,+BAAuC;ADy+/BzC;;AC3+/BC;EACC,8BAAoC;EACpC,iCAAuC;AD8+/BzC;;ACh//BC;EACC,4BAAoC;EACpC,+BAAuC;ADm//BzC;;ACr//BC;EACC,8BAAoC;EACpC,iCAAuC;ADw//BzC;;AC1//BC;EACC,4BAAoC;EACpC,+BAAuC;AD6//BzC;;AC///BC;EACC,8BAAoC;EACpC,iCAAuC;ADkggCzC;;ACpggCC;EACC,4BAAoC;EACpC,+BAAuC;ADuggCzC;;ACzggCC;EACC,8BAAoC;EACpC,iCAAuC;AD4ggCzC;;AC9ggCC;EACC,4BAAoC;EACpC,+BAAuC;ADihgCzC;;ACnhgCC;EACC,8BAAoC;EACpC,iCAAuC;ADshgCzC;;ACxhgCC;EACC,4BAAoC;EACpC,+BAAuC;AD2hgCzC;;AC7hgCC;EACC,8BAAoC;EACpC,iCAAuC;ADgigCzC;;ACligCC;EACC,4BAAoC;EACpC,+BAAuC;ADqigCzC;;ACvigCC;EACC,8BAAoC;EACpC,iCAAuC;AD0igCzC;;AC5igCC;EACC,4BAAoC;EACpC,+BAAuC;AD+igCzC;;ACjjgCC;EACC,8BAAoC;EACpC,iCAAuC;ADojgCzC;;ACtjgCC;EACC,4BAAoC;EACpC,+BAAuC;ADyjgCzC;;AC3jgCC;EACC,8BAAoC;EACpC,iCAAuC;AD8jgCzC;;AChkgCC;EACC,4BAAoC;EACpC,+BAAuC;ADmkgCzC;;ACrkgCC;EACC,8BAAoC;EACpC,iCAAuC;ADwkgCzC;;AC1kgCC;EACC,4BAAoC;EACpC,+BAAuC;AD6kgCzC;;AC/kgCC;EACC,8BAAoC;EACpC,iCAAuC;ADklgCzC;;ACplgCC;EACC,4BAAoC;EACpC,+BAAuC;ADulgCzC;;ACzlgCC;EACC,8BAAoC;EACpC,iCAAuC;AD4lgCzC;;AC9lgCC;EACC,4BAAoC;EACpC,+BAAuC;ADimgCzC;;ACnmgCC;EACC,8BAAoC;EACpC,iCAAuC;ADsmgCzC;;ACxmgCC;EACC,4BAAoC;EACpC,+BAAuC;AD2mgCzC;;AC7mgCC;EACC,8BAAoC;EACpC,iCAAuC;ADgngCzC;;AClngCC;EACC,4BAAoC;EACpC,+BAAuC;ADqngCzC;;ACvngCC;EACC,8BAAoC;EACpC,iCAAuC;AD0ngCzC;;AC5ngCC;EACC,4BAAoC;EACpC,+BAAuC;AD+ngCzC;;ACjogCC;EACC,8BAAoC;EACpC,iCAAuC;ADoogCzC;;ACtogCC;EACC,4BAAoC;EACpC,+BAAuC;ADyogCzC;;AC3ogCC;EACC,8BAAoC;EACpC,iCAAuC;AD8ogCzC;;AChpgCC;EACC,4BAAoC;EACpC,+BAAuC;ADmpgCzC;;ACrpgCC;EACC,8BAAoC;EACpC,iCAAuC;ADwpgCzC;;AC1pgCC;EACC,4BAAoC;EACpC,+BAAuC;AD6pgCzC;;AC/pgCC;EACC,8BAAoC;EACpC,iCAAuC;ADkqgCzC;;ACpqgCC;EACC,4BAAoC;EACpC,+BAAuC;ADuqgCzC;;ACzqgCC;EACC,8BAAoC;EACpC,iCAAuC;AD4qgCzC;;AC9qgCC;EACC,4BAAoC;EACpC,+BAAuC;ADirgCzC;;ACnrgCC;EACC,8BAAoC;EACpC,iCAAuC;ADsrgCzC;;ACxrgCC;EACC,4BAAoC;EACpC,+BAAuC;AD2rgCzC;;AC7rgCC;EACC,8BAAoC;EACpC,iCAAuC;ADgsgCzC;;AClsgCC;EACC,4BAAoC;EACpC,+BAAuC;ADqsgCzC;;ACvsgCC;EACC,8BAAoC;EACpC,iCAAuC;AD0sgCzC;;AC5sgCC;EACC,4BAAoC;EACpC,+BAAuC;AD+sgCzC;;ACjtgCC;EACC,8BAAoC;EACpC,iCAAuC;ADotgCzC;;AC/sgCA;EAaE,4BAAc;EDssgCd,+BCrsgCiC;ADssgCnC;;AAEA;EACE,8BCzsgCiC;ED0sgCjC,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;EChtgCzB;;EDmtgCA;IACE,0BAA0B;ECptgC5B;;EDutgCA;IACE,yBAAyB;ECxtgC3B;;ED2tgCA;IACE,uBAAuB;EC5tgCzB;;ED+tgCA;IACE,yBAAyB;EChugC3B;;EDmugCA;IACE,uBAAuB;ECpugCzB;;EDuugCA;IACE,yBAAyB;ECxugC3B;;ED2ugCA;IACE,uBAAuB;EC5ugCzB;;ED+ugCA;IACE,yBAAyB;EChvgC3B;;EDmvgCA;IACE,uBAAuB;ECpvgCzB;;EDuvgCA;IACE,yBAAyB;ECxvgC3B;;ED2vgCA;IACE,uBAAuB;EC5vgCzB;;ED+vgCA;IACE,yBAAyB;EChwgC3B;;EDmwgCA;IACE,uBAAuB;ECpwgCzB;;EDuwgCA;IACE,yBAAyB;ECxwgC3B;;ED2wgCA;IACE,uBAAuB;EC5wgCzB;;ED+wgCA;IACE,yBAAyB;EChxgC3B;;EDmxgCA;IACE,uBAAuB;ECpxgCzB;;EDuxgCA;IACE,yBAAyB;ECxxgC3B;;ED2xgCA;IACE,uBAAuB;EC5xgCzB;;ED+xgCA;IACE,yBAAyB;EChygC3B;;EDmygCA;IACE,wBAAwB;ECpygC1B;;EDuygCA;IACE,0BAA0B;ECxygC5B;;ED2ygCA;IACE,wBAAwB;EC5ygC1B;;ED+ygCA;IACE,0BAA0B;EChzgC5B;;EDmzgCA;IACE,wBAAwB;ECpzgC1B;;EDuzgCA;IACE,0BAA0B;ECxzgC5B;;ED2zgCA;IACE,wBAAwB;EC5zgC1B;;ED+zgCA;IACE,0BAA0B;ECh0gC5B;;EDm0gCA;IACE,wBAAwB;ECp0gC1B;;EDu0gCA;IACE,0BAA0B;ECx0gC5B;;ED20gCA;IACE,wBAAwB;EC50gC1B;;ED+0gCA;IACE,0BAA0B;ECh1gC5B;;EDm1gCA;IACE,wBAAwB;ECp1gC1B;;EDu1gCA;IACE,0BAA0B;ECx1gC5B;;ED21gCA;IACE,wBAAwB;EC51gC1B;;ED+1gCA;IACE,0BAA0B;ECh2gC5B;;EDm2gCA;IACE,wBAAwB;ECp2gC1B;;EDu2gCA;IACE,0BAA0B;ECx2gC5B;;ED22gCA;IACE,wBAAwB;EC52gC1B;;ED+2gCA;IACE,0BAA0B;ECh3gC5B;;EDm3gCA;IACE,wBAAwB;ECp3gC1B;;EDu3gCA;IACE,0BAA0B;ECx3gC5B;;ED23gCA;IACE,wBAAwB;EC53gC1B;;ED+3gCA;IACE,0BAA0B;ECh4gC5B;;EDm4gCA;IACE,wBAAwB;ECp4gC1B;;EDu4gCA;IACE,0BAA0B;ECx4gC5B;;ED24gCA;IACE,wBAAwB;EC54gC1B;;ED+4gCA;IACE,0BAA0B;ECh5gC5B;;EDm5gCA;IACE,wBAAwB;ECp5gC1B;;EDu5gCA;IACE,0BAA0B;ECx5gC5B;;ED25gCA;IACE,wBAAwB;EC55gC1B;;ED+5gCA;IACE,0BAA0B;ECh6gC5B;;EDm6gCA;IACE,wBAAwB;ECp6gC1B;;EDu6gCA;IACE,0BAA0B;ECx6gC5B;;ED26gCA;IACE,wBAAwB;EC56gC1B;;ED+6gCA;IACE,0BAA0B;ECh7gC5B;;EDm7gCA;IACE,wBAAwB;ECp7gC1B;;EDu7gCA;IACE,0BAA0B;ECx7gC5B;;ED27gCA;IACE,wBAAwB;EC57gC1B;;ED+7gCA;IACE,0BAA0B;ECh8gC5B;;EDm8gCA;IACE,wBAAwB;ECp8gC1B;;EDu8gCA;IACE,0BAA0B;ECx8gC5B;;ED28gCA;IACE,wBAAwB;EC58gC1B;;ED+8gCA;IACE,0BAA0B;ECh9gC5B;;EDm9gCA;IACE,wBAAwB;ECp9gC1B;;EDu9gCA;IACE,0BAA0B;ECx9gC5B;;ED29gCA;IACE,wBAAwB;EC59gC1B;;ED+9gCA;IACE,0BAA0B;ECh+gC5B;;EDm+gCA;IACE,wBAAwB;ECp+gC1B;;EDu+gCA;IACE,0BAA0B;ECx+gC5B;;ED2+gCA;IACE,wBAAwB;EC5+gC1B;;ED++gCA;IACE,0BAA0B;ECh/gC5B;;EDm/gCA;IACE,wBAAwB;ECp/gC1B;;EDu/gCA;IACE,0BAA0B;ECx/gC5B;;ED2/gCA;IACE,wBAAwB;EC5/gC1B;;ED+/gCA;IACE,0BAA0B;EChghC5B;;EDmghCA;IACE,wBAAwB;ECpghC1B;;EDughCA;IACE,0BAA0B;ECxghC5B;;ED2ghCA;IACE,wBAAwB;EC5ghC1B;;ED+ghCA;IACE,0BAA0B;EChhhC5B;;EDmhhCA;IACE,wBAAwB;ECphhC1B;;EDuhhCA;IACE,0BAA0B;ECxhhC5B;;ED2hhCA;IACE,wBAAwB;EC5hhC1B;;ED+hhCA;IACE,0BAA0B;EChihC5B;;EDmihCA;IACE,wBAAwB;ECpihC1B;;EDuihCA;IACE,0BAA0B;ECxihC5B;;ED2ihCA;IACE,wBAAwB;EC5ihC1B;;ED+ihCA;IACE,0BAA0B;EChjhC5B;;EDmjhCA;IACE,wBAAwB;ECpjhC1B;;EDujhCA;IACE,0BAA0B;ECxjhC5B;;ED2jhCA;IACE,wBAAwB;EC5jhC1B;;ED+jhCA;IACE,0BAA0B;EChkhC5B;;EDmkhCA;IACE,wBAAwB;ECpkhC1B;;EDukhCA;IACE,0BAA0B;ECxkhC5B;;ED2khCA;IACE,wBAAwB;EC5khC1B;;ED+khCA;IACE,0BAA0B;EChlhC5B;;EDmlhCA;IACE,wBAAwB;ECplhC1B;;EDulhCA;IACE,0BAA0B;ECxlhC5B;;ED2lhCA;IACE,wBAAwB;EC5lhC1B;;ED+lhCA;IACE,0BAA0B;EChmhC5B;;EDmmhCA;IACE,wBAAwB;ECpmhC1B;;EDumhCA;IACE,0BAA0B;ECxmhC5B;;ED2mhCA;IACE,wBAAwB;EC5mhC1B;;ED+mhCA;IACE,0BAA0B;EChnhC5B;;EDmnhCA;IACE,wBAAwB;ECpnhC1B;;EDunhCA;IACE,0BAA0B;ECxnhC5B;;ED2nhCA;IACE,wBAAwB;EC5nhC1B;;ED+nhCA;IACE,0BAA0B;EChohC5B;;EDmohCA;IACE,wBAAwB;ECpohC1B;;EDuohCA;IACE,0BAA0B;ECxohC5B;;ED2ohCA;IACE,wBAAwB;EC5ohC1B;;ED+ohCA;IACE,0BAA0B;EChphC5B;;EDmphCA;IACE,wBAAwB;ECpphC1B;;EDuphCA;IACE,0BAA0B;ECxphC5B;;ED2phCA;IACE,wBAAwB;EC5phC1B;;ED+phCA;IACE,0BAA0B;EChqhC5B;;EDmqhCA;IACE,wBAAwB;ECpqhC1B;;EDuqhCA;IACE,0BAA0B;ECxqhC5B;;ED2qhCA;IACE,wBAAwB;EC5qhC1B;;ED+qhCA;IACE,0BAA0B;EChrhC5B;;EDmrhCA;IACE,wBAAwB;ECprhC1B;;EDurhCA;IACE,0BAA0B;ECxrhC5B;;ED2rhCA;IACE,wBAAwB;EC5rhC1B;;ED+rhCA;IACE,0BAA0B;EChshC5B;;EDmshCA;IACE,wBAAwB;ECpshC1B;;EDushCA;IACE,0BAA0B;ECxshC5B;;ED2shCA;IACE,wBAAwB;EC5shC1B;;ED+shCA;IACE,0BAA0B;EChthC5B;;EDmthCA;IACE,wBAAwB;ECpthC1B;;EDuthCA;IACE,0BAA0B;ECxthC5B;;ED2thCA;IACE,wBAAwB;EC5thC1B;;ED+thCA;IACE,0BAA0B;EChuhC5B;;EDmuhCA;IACE,wBAAwB;ECpuhC1B;;EDuuhCA;IACE,0BAA0B;ECxuhC5B;;ED2uhCA;IACE,wBAAwB;EC5uhC1B;;ED+uhCA;IACE,0BAA0B;EChvhC5B;;EDmvhCA;IACE,wBAAwB;ECpvhC1B;;EDuvhCA;IACE,0BAA0B;ECxvhC5B;;ED2vhCA;IACE,wBAAwB;EC5vhC1B;;ED+vhCA;IACE,0BAA0B;EChwhC5B;;EDmwhCA;IACE,wBAAwB;ECpwhC1B;;EDuwhCA;IACE,0BAA0B;ECxwhC5B;;ED2whCA;IACE,wBAAwB;EC5whC1B;;ED+whCA;IACE,0BAA0B;EChxhC5B;;EDmxhCA;IACE,wBAAwB;ECpxhC1B;;EDuxhCA;IACE,0BAA0B;ECxxhC5B;;ED2xhCA;IACE,wBAAwB;EC5xhC1B;;ED+xhCA;IACE,0BAA0B;EChyhC5B;;EDmyhCA;IACE,wBAAwB;ECpyhC1B;;EDuyhCA;IACE,0BAA0B;ECxyhC5B;;ED2yhCA;IACE,wBAAwB;EC5yhC1B;;ED+yhCA;IACE,0BAA0B;EChzhC5B;;EDmzhCA;IACE,wBAAwB;ECpzhC1B;;EDuzhCA;IACE,0BAA0B;ECxzhC5B;;ED2zhCA;IACE,wBAAwB;EC5zhC1B;;ED+zhCA;IACE,0BAA0B;ECh0hC5B;;EDm0hCA;IACE,wBAAwB;ECp0hC1B;;EDu0hCA;IACE,0BAA0B;ECrzhC5B;;EDwzhCA;IACE,wBAAwB;ECzzhC1B;;ED4zhCA;IACE,0BAA0B;EC7zhC5B;;EDg0hCA;IACE,2BAA2B;ECj0hC7B;;EDo0hCA;IACE,8BAA8B;ECr0hChC;;EDw0hCA;IACE,6BAA6B;ECz0hC/B;;ED40hCA;IACE,2BAA2B;EC70hC7B;;EDg1hCA;IACE,6BAA6B;ECj1hC/B;;EDo1hCA;IACE,2BAA2B;ECr1hC7B;;EDw1hCA;IACE,6BAA6B;ECz1hC/B;;ED41hCA;IACE,2BAA2B;EC71hC7B;;EDg2hCA;IACE,6BAA6B;ECj2hC/B;;EDo2hCA;IACE,2BAA2B;ECr2hC7B;;EDw2hCA;IACE,6BAA6B;ECz2hC/B;;ED42hCA;IACE,2BAA2B;EC72hC7B;;EDg3hCA;IACE,6BAA6B;ECj3hC/B;;EDo3hCA;IACE,2BAA2B;ECr3hC7B;;EDw3hCA;IACE,6BAA6B;ECz3hC/B;;ED43hCA;IACE,2BAA2B;EC73hC7B;;EDg4hCA;IACE,6BAA6B;ECj4hC/B;;EDo4hCA;IACE,2BAA2B;ECr4hC7B;;EDw4hCA;IACE,6BAA6B;ECz4hC/B;;ED44hCA;IACE,2BAA2B;EC74hC7B;;EDg5hCA;IACE,6BAA6B;ECj5hC/B;;EDo5hCA;IACE,4BAA4B;ECr5hC9B;;EDw5hCA;IACE,8BAA8B;ECz5hChC;;ED45hCA;IACE,4BAA4B;EC75hC9B;;EDg6hCA;IACE,8BAA8B;ECj6hChC;;EDo6hCA;IACE,4BAA4B;ECr6hC9B;;EDw6hCA;IACE,8BAA8B;ECz6hChC;;ED46hCA;IACE,4BAA4B;EC76hC9B;;EDg7hCA;IACE,8BAA8B;ECj7hChC;;EDo7hCA;IACE,4BAA4B;ECr7hC9B;;EDw7hCA;IACE,8BAA8B;ECz7hChC;;ED47hCA;IACE,4BAA4B;EC77hC9B;;EDg8hCA;IACE,8BAA8B;ECj8hChC;;EDo8hCA;IACE,4BAA4B;ECr8hC9B;;EDw8hCA;IACE,8BAA8B;ECz8hChC;;ED48hCA;IACE,4BAA4B;EC78hC9B;;EDg9hCA;IACE,8BAA8B;ECj9hChC;;EDo9hCA;IACE,4BAA4B;ECr9hC9B;;EDw9hCA;IACE,8BAA8B;ECz9hChC;;ED49hCA;IACE,4BAA4B;EC79hC9B;;EDg+hCA;IACE,8BAA8B;ECj+hChC;;EDo+hCA;IACE,4BAA4B;ECr+hC9B;;EDw+hCA;IACE,8BAA8B;ECz+hChC;;ED4+hCA;IACE,4BAA4B;EC7+hC9B;;EDg/hCA;IACE,8BAA8B;ECj/hChC;;EDo/hCA;IACE,4BAA4B;ECr/hC9B;;EDw/hCA;IACE,8BAA8B;ECz/hChC;;ED4/hCA;IACE,4BAA4B;EC7/hC9B;;EDggiCA;IACE,8BAA8B;ECjgiChC;;EDogiCA;IACE,4BAA4B;ECrgiC9B;;EDwgiCA;IACE,8BAA8B;ECzgiChC;;ED4giCA;IACE,4BAA4B;EC7giC9B;;EDghiCA;IACE,8BAA8B;ECjhiChC;;EDohiCA;IACE,4BAA4B;ECrhiC9B;;EDwhiCA;IACE,8BAA8B;ECzhiChC;;ED4hiCA;IACE,4BAA4B;EC7hiC9B;;EDgiiCA;IACE,8BAA8B;ECjiiChC;;EDoiiCA;IACE,4BAA4B;ECriiC9B;;EDwiiCA;IACE,8BAA8B;ECziiChC;;ED4iiCA;IACE,4BAA4B;EC7iiC9B;;EDgjiCA;IACE,8BAA8B;ECjjiChC;;EDojiCA;IACE,4BAA4B;ECrjiC9B;;EDwjiCA;IACE,8BAA8B;ECzjiChC;;ED4jiCA;IACE,4BAA4B;EC7jiC9B;;EDgkiCA;IACE,8BAA8B;ECjkiChC;;EDokiCA;IACE,4BAA4B;ECrkiC9B;;EDwkiCA;IACE,8BAA8B;ECzkiChC;;ED4kiCA;IACE,4BAA4B;EC7kiC9B;;EDgliCA;IACE,8BAA8B;ECjliChC;;EDoliCA;IACE,4BAA4B;ECrliC9B;;EDwliCA;IACE,8BAA8B;ECzliChC;;ED4liCA;IACE,4BAA4B;EC7liC9B;;EDgmiCA;IACE,8BAA8B;ECjmiChC;;EDomiCA;IACE,4BAA4B;ECrmiC9B;;EDwmiCA;IACE,8BAA8B;ECzmiChC;;ED4miCA;IACE,4BAA4B;EC7miC9B;;EDgniCA;IACE,8BAA8B;ECjniChC;;EDoniCA;IACE,4BAA4B;ECrniC9B;;EDwniCA;IACE,8BAA8B;ECzniChC;;ED4niCA;IACE,4BAA4B;EC7niC9B;;EDgoiCA;IACE,8BAA8B;ECjoiChC;;EDooiCA;IACE,4BAA4B;ECroiC9B;;EDwoiCA;IACE,8BAA8B;ECzoiChC;;ED4oiCA;IACE,4BAA4B;EC7oiC9B;;EDgpiCA;IACE,8BAA8B;ECjpiChC;;EDopiCA;IACE,4BAA4B;ECrpiC9B;;EDwpiCA;IACE,8BAA8B;ECzpiChC;;ED4piCA;IACE,4BAA4B;EC7piC9B;;EDgqiCA;IACE,8BAA8B;ECjqiChC;;EDoqiCA;IACE,4BAA4B;ECrqiC9B;;EDwqiCA;IACE,8BAA8B;ECzqiChC;;ED4qiCA;IACE,4BAA4B;EC7qiC9B;;EDgriCA;IACE,8BAA8B;ECjriChC;;EDoriCA;IACE,4BAA4B;ECrriC9B;;EDwriCA;IACE,8BAA8B;ECzriChC;;ED4riCA;IACE,4BAA4B;EC7riC9B;;EDgsiCA;IACE,8BAA8B;ECjsiChC;;EDosiCA;IACE,4BAA4B;ECrsiC9B;;EDwsiCA;IACE,8BAA8B;ECzsiChC;;ED4siCA;IACE,4BAA4B;EC7siC9B;;EDgtiCA;IACE,8BAA8B;ECjtiChC;;EDotiCA;IACE,4BAA4B;ECrtiC9B;;EDwtiCA;IACE,8BAA8B;ECztiChC;;ED4tiCA;IACE,4BAA4B;EC7tiC9B;;EDguiCA;IACE,8BAA8B;ECjuiChC;;EDouiCA;IACE,4BAA4B;ECruiC9B;;EDwuiCA;IACE,8BAA8B;ECzuiChC;;ED4uiCA;IACE,4BAA4B;EC7uiC9B;;EDgviCA;IACE,8BAA8B;ECjviChC;;EDoviCA;IACE,4BAA4B;ECrviC9B;;EDwviCA;IACE,8BAA8B;ECzviChC;;ED4viCA;IACE,4BAA4B;EC7viC9B;;EDgwiCA;IACE,8BAA8B;ECjwiChC;;EDowiCA;IACE,4BAA4B;ECrwiC9B;;EDwwiCA;IACE,8BAA8B;ECzwiChC;;ED4wiCA;IACE,4BAA4B;EC7wiC9B;;EDgxiCA;IACE,8BAA8B;ECjxiChC;;EDoxiCA;IACE,4BAA4B;ECrxiC9B;;EDwxiCA;IACE,8BAA8B;ECzxiChC;;ED4xiCA;IACE,4BAA4B;EC7xiC9B;;EDgyiCA;IACE,8BAA8B;ECjyiChC;;EDoyiCA;IACE,4BAA4B;ECryiC9B;;EDwyiCA;IACE,8BAA8B;ECzyiChC;;ED4yiCA;IACE,4BAA4B;EC7yiC9B;;EDgziCA;IACE,8BAA8B;ECjziChC;;EDoziCA;IACE,4BAA4B;ECrziC9B;;EDwziCA;IACE,8BAA8B;ECzziChC;;ED4ziCA;IACE,4BAA4B;EC7ziC9B;;EDg0iCA;IACE,8BAA8B;ECj0iChC;;EDo0iCA;IACE,4BAA4B;ECr0iC9B;;EDw0iCA;IACE,8BAA8B;ECz0iChC;;ED40iCA;IACE,4BAA4B;EC70iC9B;;EDg1iCA;IACE,8BAA8B;ECj1iChC;;EDo1iCA;IACE,4BAA4B;ECr1iC9B;;EDw1iCA;IACE,8BAA8B;ECz1iChC;;ED41iCA;IACE,4BAA4B;EC71iC9B;;EDg2iCA;IACE,8BAA8B;ECj2iChC;;EDo2iCA;IACE,4BAA4B;ECr2iC9B;;EDw2iCA;IACE,8BAA8B;ECz2iChC;;ED42iCA;IACE,4BAA4B;EC72iC9B;;EDg3iCA;IACE,8BAA8B;ECj3iChC;;EDo3iCA;IACE,4BAA4B;ECr3iC9B;;EDw3iCA;IACE,8BAA8B;ECz3iChC;;ED43iCA;IACE,4BAA4B;EC73iC9B;;EDg4iCA;IACE,8BAA8B;ECj4iChC;;EDo4iCA;IACE,4BAA4B;ECr4iC9B;;EDw4iCA;IACE,8BAA8B;ECz4iChC;;ED44iCA;IACE,4BAA4B;EC74iC9B;;EDg5iCA;IACE,8BAA8B;ECj5iChC;;EDo5iCA;IACE,4BAA4B;ECr5iC9B;;EDw5iCA;IACE,8BAA8B;ECz5iChC;;ED45iCA;IACE,4BAA4B;EC75iC9B;;EDg6iCA;IACE,8BAA8B;ECj6iChC;;EDo6iCA;IACE,4BAA4B;ECr6iC9B;;EDw6iCA;IACE,8BAA8B;ECz6iChC;;ED46iCA;IACE,4BAA4B;EC76iC9B;;EDg7iCA;IACE,8BAA8B;ECj7iChC;;EDo7iCA;IACE,4BAA4B;ECr7iC9B;;EDw7iCA;IACE,8BAA8B;ECt6iChC;;EDy6iCA;IACE,4BAA4B;EC16iC9B;;ED66iCA;IACE,8BAA8B;EC96iChC;;EDi7iCA;IACE,8BAA8B;ECl7iChC;;EDq7iCA;IACE,iCAAiC;ECt7iCnC;;EDy7iCA;IACE,gCAAgC;EC17iClC;;ED67iCA;IACE,8BAA8B;EC97iChC;;EDi8iCA;IACE,gCAAgC;ECl8iClC;;EDq8iCA;IACE,8BAA8B;ECt8iChC;;EDy8iCA;IACE,gCAAgC;EC18iClC;;ED68iCA;IACE,8BAA8B;EC98iChC;;EDi9iCA;IACE,gCAAgC;ECl9iClC;;EDq9iCA;IACE,8BAA8B;ECt9iChC;;EDy9iCA;IACE,gCAAgC;EC19iClC;;ED69iCA;IACE,8BAA8B;EC99iChC;;EDi+iCA;IACE,gCAAgC;ECl+iClC;;EDq+iCA;IACE,8BAA8B;ECt+iChC;;EDy+iCA;IACE,gCAAgC;EC1+iClC;;ED6+iCA;IACE,8BAA8B;EC9+iChC;;EDi/iCA;IACE,gCAAgC;ECl/iClC;;EDq/iCA;IACE,8BAA8B;ECt/iChC;;EDy/iCA;IACE,gCAAgC;EC1/iClC;;ED6/iCA;IACE,8BAA8B;EC9/iChC;;EDigjCA;IACE,gCAAgC;EClgjClC;;EDqgjCA;IACE,+BAA+B;ECtgjCjC;;EDygjCA;IACE,iCAAiC;EC1gjCnC;;ED6gjCA;IACE,+BAA+B;EC9gjCjC;;EDihjCA;IACE,iCAAiC;EClhjCnC;;EDqhjCA;IACE,+BAA+B;ECthjCjC;;EDyhjCA;IACE,iCAAiC;EC1hjCnC;;ED6hjCA;IACE,+BAA+B;EC9hjCjC;;EDiijCA;IACE,iCAAiC;EClijCnC;;EDqijCA;IACE,+BAA+B;ECtijCjC;;EDyijCA;IACE,iCAAiC;EC1ijCnC;;ED6ijCA;IACE,+BAA+B;EC9ijCjC;;EDijjCA;IACE,iCAAiC;ECljjCnC;;EDqjjCA;IACE,+BAA+B;ECtjjCjC;;EDyjjCA;IACE,iCAAiC;EC1jjCnC;;ED6jjCA;IACE,+BAA+B;EC9jjCjC;;EDikjCA;IACE,iCAAiC;EClkjCnC;;EDqkjCA;IACE,+BAA+B;ECtkjCjC;;EDykjCA;IACE,iCAAiC;EC1kjCnC;;ED6kjCA;IACE,+BAA+B;EC9kjCjC;;EDiljCA;IACE,iCAAiC;EClljCnC;;EDqljCA;IACE,+BAA+B;ECtljCjC;;EDyljCA;IACE,iCAAiC;EC1ljCnC;;ED6ljCA;IACE,+BAA+B;EC9ljCjC;;EDimjCA;IACE,iCAAiC;EClmjCnC;;EDqmjCA;IACE,+BAA+B;ECtmjCjC;;EDymjCA;IACE,iCAAiC;EC1mjCnC;;ED6mjCA;IACE,+BAA+B;EC9mjCjC;;EDinjCA;IACE,iCAAiC;EClnjCnC;;EDqnjCA;IACE,+BAA+B;ECtnjCjC;;EDynjCA;IACE,iCAAiC;EC1njCnC;;ED6njCA;IACE,+BAA+B;EC9njCjC;;EDiojCA;IACE,iCAAiC;EClojCnC;;EDqojCA;IACE,+BAA+B;ECtojCjC;;EDyojCA;IACE,iCAAiC;EC1ojCnC;;ED6ojCA;IACE,+BAA+B;EC9ojCjC;;EDipjCA;IACE,iCAAiC;EClpjCnC;;EDqpjCA;IACE,+BAA+B;ECtpjCjC;;EDypjCA;IACE,iCAAiC;EC1pjCnC;;ED6pjCA;IACE,+BAA+B;EC9pjCjC;;EDiqjCA;IACE,iCAAiC;EClqjCnC;;EDqqjCA;IACE,+BAA+B;ECtqjCjC;;EDyqjCA;IACE,iCAAiC;EC1qjCnC;;ED6qjCA;IACE,+BAA+B;EC9qjCjC;;EDirjCA;IACE,iCAAiC;EClrjCnC;;EDqrjCA;IACE,+BAA+B;ECtrjCjC;;EDyrjCA;IACE,iCAAiC;EC1rjCnC;;ED6rjCA;IACE,+BAA+B;EC9rjCjC;;EDisjCA;IACE,iCAAiC;EClsjCnC;;EDqsjCA;IACE,+BAA+B;ECtsjCjC;;EDysjCA;IACE,iCAAiC;EC1sjCnC;;ED6sjCA;IACE,+BAA+B;EC9sjCjC;;EDitjCA;IACE,iCAAiC;ECltjCnC;;EDqtjCA;IACE,+BAA+B;ECttjCjC;;EDytjCA;IACE,iCAAiC;EC1tjCnC;;ED6tjCA;IACE,+BAA+B;EC9tjCjC;;EDiujCA;IACE,iCAAiC;EClujCnC;;EDqujCA;IACE,+BAA+B;ECtujCjC;;EDyujCA;IACE,iCAAiC;EC1ujCnC;;ED6ujCA;IACE,+BAA+B;EC9ujCjC;;EDivjCA;IACE,iCAAiC;EClvjCnC;;EDqvjCA;IACE,+BAA+B;ECtvjCjC;;EDyvjCA;IACE,iCAAiC;EC1vjCnC;;ED6vjCA;IACE,+BAA+B;EC9vjCjC;;EDiwjCA;IACE,iCAAiC;EClwjCnC;;EDqwjCA;IACE,+BAA+B;ECtwjCjC;;EDywjCA;IACE,iCAAiC;EC1wjCnC;;ED6wjCA;IACE,+BAA+B;EC9wjCjC;;EDixjCA;IACE,iCAAiC;EClxjCnC;;EDqxjCA;IACE,+BAA+B;ECtxjCjC;;EDyxjCA;IACE,iCAAiC;EC1xjCnC;;ED6xjCA;IACE,+BAA+B;EC9xjCjC;;EDiyjCA;IACE,iCAAiC;EClyjCnC;;EDqyjCA;IACE,+BAA+B;ECtyjCjC;;EDyyjCA;IACE,iCAAiC;EC1yjCnC;;ED6yjCA;IACE,+BAA+B;EC9yjCjC;;EDizjCA;IACE,iCAAiC;EClzjCnC;;EDqzjCA;IACE,+BAA+B;ECtzjCjC;;EDyzjCA;IACE,iCAAiC;EC1zjCnC;;ED6zjCA;IACE,+BAA+B;EC9zjCjC;;EDi0jCA;IACE,iCAAiC;ECl0jCnC;;EDq0jCA;IACE,+BAA+B;ECt0jCjC;;EDy0jCA;IACE,iCAAiC;EC10jCnC;;ED60jCA;IACE,+BAA+B;EC90jCjC;;EDi1jCA;IACE,iCAAiC;ECl1jCnC;;EDq1jCA;IACE,+BAA+B;ECt1jCjC;;EDy1jCA;IACE,iCAAiC;EC11jCnC;;ED61jCA;IACE,+BAA+B;EC91jCjC;;EDi2jCA;IACE,iCAAiC;ECl2jCnC;;EDq2jCA;IACE,+BAA+B;ECt2jCjC;;EDy2jCA;IACE,iCAAiC;EC12jCnC;;ED62jCA;IACE,+BAA+B;EC92jCjC;;EDi3jCA;IACE,iCAAiC;ECl3jCnC;;EDq3jCA;IACE,+BAA+B;ECt3jCjC;;EDy3jCA;IACE,iCAAiC;EC13jCnC;;ED63jCA;IACE,+BAA+B;EC93jCjC;;EDi4jCA;IACE,iCAAiC;ECl4jCnC;;EDq4jCA;IACE,+BAA+B;ECt4jCjC;;EDy4jCA;IACE,iCAAiC;EC14jCnC;;ED64jCA;IACE,+BAA+B;EC94jCjC;;EDi5jCA;IACE,iCAAiC;ECl5jCnC;;EDq5jCA;IACE,+BAA+B;ECt5jCjC;;EDy5jCA;IACE,iCAAiC;EC15jCnC;;ED65jCA;IACE,+BAA+B;EC95jCjC;;EDi6jCA;IACE,iCAAiC;ECl6jCnC;;EDq6jCA;IACE,+BAA+B;ECt6jCjC;;EDy6jCA;IACE,iCAAiC;EC16jCnC;;ED66jCA;IACE,+BAA+B;EC96jCjC;;EDi7jCA;IACE,iCAAiC;ECl7jCnC;;EDq7jCA;IACE,+BAA+B;ECt7jCjC;;EDy7jCA;IACE,iCAAiC;EC17jCnC;;ED67jCA;IACE,+BAA+B;EC97jCjC;;EDi8jCA;IACE,iCAAiC;ECl8jCnC;;EDq8jCA;IACE,+BAA+B;ECt8jCjC;;EDy8jCA;IACE,iCAAiC;EC18jCnC;;ED68jCA;IACE,+BAA+B;EC98jCjC;;EDi9jCA;IACE,iCAAiC;ECl9jCnC;;EDq9jCA;IACE,+BAA+B;ECt9jCjC;;EDy9jCA;IACE,iCAAiC;EC19jCnC;;ED69jCA;IACE,+BAA+B;EC99jCjC;;EDi+jCA;IACE,iCAAiC;ECl+jCnC;;EDq+jCA;IACE,+BAA+B;ECt+jCjC;;EDy+jCA;IACE,iCAAiC;EC1+jCnC;;ED6+jCA;IACE,+BAA+B;EC9+jCjC;;EDi/jCA;IACE,iCAAiC;ECl/jCnC;;EDq/jCA;IACE,+BAA+B;ECt/jCjC;;EDy/jCA;IACE,iCAAiC;EC1/jCnC;;ED6/jCA;IACE,+BAA+B;EC9/jCjC;;EDigkCA;IACE,iCAAiC;EClgkCnC;;EDqgkCA;IACE,+BAA+B;ECtgkCjC;;EDygkCA;IACE,iCAAiC;EC1gkCnC;;ED6gkCA;IACE,+BAA+B;EC9gkCjC;;EDihkCA;IACE,iCAAiC;EClhkCnC;;EDqhkCA;IACE,+BAA+B;ECthkCjC;;EDyhkCA;IACE,iCAAiC;EC1hkCnC;;ED6hkCA;IACE,+BAA+B;EC9hkCjC;;EDiikCA;IACE,iCAAiC;EClikCnC;;EDqikCA;IACE,+BAA+B;ECtikCjC;;EDyikCA;IACE,iCAAiC;ECvhkCnC;;ED0hkCA;IACE,+BAA+B;EC3hkCjC;;ED8hkCA;IACE,iCAAiC;EC/hkCnC;;EDkikCA;IACE,4BAA4B;ECnikC9B;;EDsikCA;IACE,+BAA+B;ECvikCjC;;ED0ikCA;IACE,8BAA8B;EC3ikChC;;ED8ikCA;IACE,4BAA4B;EC/ikC9B;;EDkjkCA;IACE,8BAA8B;ECnjkChC;;EDsjkCA;IACE,4BAA4B;ECvjkC9B;;ED0jkCA;IACE,8BAA8B;EC3jkChC;;ED8jkCA;IACE,4BAA4B;EC/jkC9B;;EDkkkCA;IACE,8BAA8B;ECnkkChC;;EDskkCA;IACE,4BAA4B;ECvkkC9B;;ED0kkCA;IACE,8BAA8B;EC3kkChC;;ED8kkCA;IACE,4BAA4B;EC/kkC9B;;EDklkCA;IACE,8BAA8B;ECnlkChC;;EDslkCA;IACE,4BAA4B;ECvlkC9B;;ED0lkCA;IACE,8BAA8B;EC3lkChC;;ED8lkCA;IACE,4BAA4B;EC/lkC9B;;EDkmkCA;IACE,8BAA8B;ECnmkChC;;EDsmkCA;IACE,4BAA4B;ECvmkC9B;;ED0mkCA;IACE,8BAA8B;EC3mkChC;;ED8mkCA;IACE,4BAA4B;EC/mkC9B;;EDknkCA;IACE,8BAA8B;ECnnkChC;;EDsnkCA;IACE,6BAA6B;ECvnkC/B;;ED0nkCA;IACE,+BAA+B;EC3nkCjC;;ED8nkCA;IACE,6BAA6B;EC/nkC/B;;EDkokCA;IACE,+BAA+B;ECnokCjC;;EDsokCA;IACE,6BAA6B;ECvokC/B;;ED0okCA;IACE,+BAA+B;EC3okCjC;;ED8okCA;IACE,6BAA6B;EC/okC/B;;EDkpkCA;IACE,+BAA+B;ECnpkCjC;;EDspkCA;IACE,6BAA6B;ECvpkC/B;;ED0pkCA;IACE,+BAA+B;EC3pkCjC;;ED8pkCA;IACE,6BAA6B;EC/pkC/B;;EDkqkCA;IACE,+BAA+B;ECnqkCjC;;EDsqkCA;IACE,6BAA6B;ECvqkC/B;;ED0qkCA;IACE,+BAA+B;EC3qkCjC;;ED8qkCA;IACE,6BAA6B;EC/qkC/B;;EDkrkCA;IACE,+BAA+B;ECnrkCjC;;EDsrkCA;IACE,6BAA6B;ECvrkC/B;;ED0rkCA;IACE,+BAA+B;EC3rkCjC;;ED8rkCA;IACE,6BAA6B;EC/rkC/B;;EDkskCA;IACE,+BAA+B;ECnskCjC;;EDsskCA;IACE,6BAA6B;ECvskC/B;;ED0skCA;IACE,+BAA+B;EC3skCjC;;ED8skCA;IACE,6BAA6B;EC/skC/B;;EDktkCA;IACE,+BAA+B;ECntkCjC;;EDstkCA;IACE,6BAA6B;ECvtkC/B;;ED0tkCA;IACE,+BAA+B;EC3tkCjC;;ED8tkCA;IACE,6BAA6B;EC/tkC/B;;EDkukCA;IACE,+BAA+B;ECnukCjC;;EDsukCA;IACE,6BAA6B;ECvukC/B;;ED0ukCA;IACE,+BAA+B;EC3ukCjC;;ED8ukCA;IACE,6BAA6B;EC/ukC/B;;EDkvkCA;IACE,+BAA+B;ECnvkCjC;;EDsvkCA;IACE,6BAA6B;ECvvkC/B;;ED0vkCA;IACE,+BAA+B;EC3vkCjC;;ED8vkCA;IACE,6BAA6B;EC/vkC/B;;EDkwkCA;IACE,+BAA+B;ECnwkCjC;;EDswkCA;IACE,6BAA6B;ECvwkC/B;;ED0wkCA;IACE,+BAA+B;EC3wkCjC;;ED8wkCA;IACE,6BAA6B;EC/wkC/B;;EDkxkCA;IACE,+BAA+B;ECnxkCjC;;EDsxkCA;IACE,6BAA6B;ECvxkC/B;;ED0xkCA;IACE,+BAA+B;EC3xkCjC;;ED8xkCA;IACE,6BAA6B;EC/xkC/B;;EDkykCA;IACE,+BAA+B;ECnykCjC;;EDsykCA;IACE,6BAA6B;ECvykC/B;;ED0ykCA;IACE,+BAA+B;EC3ykCjC;;ED8ykCA;IACE,6BAA6B;EC/ykC/B;;EDkzkCA;IACE,+BAA+B;ECnzkCjC;;EDszkCA;IACE,6BAA6B;ECvzkC/B;;ED0zkCA;IACE,+BAA+B;EC3zkCjC;;ED8zkCA;IACE,6BAA6B;EC/zkC/B;;EDk0kCA;IACE,+BAA+B;ECn0kCjC;;EDs0kCA;IACE,6BAA6B;ECv0kC/B;;ED00kCA;IACE,+BAA+B;EC30kCjC;;ED80kCA;IACE,6BAA6B;EC/0kC/B;;EDk1kCA;IACE,+BAA+B;ECn1kCjC;;EDs1kCA;IACE,6BAA6B;ECv1kC/B;;ED01kCA;IACE,+BAA+B;EC31kCjC;;ED81kCA;IACE,6BAA6B;EC/1kC/B;;EDk2kCA;IACE,+BAA+B;ECn2kCjC;;EDs2kCA;IACE,6BAA6B;ECv2kC/B;;ED02kCA;IACE,+BAA+B;EC32kCjC;;ED82kCA;IACE,6BAA6B;EC/2kC/B;;EDk3kCA;IACE,+BAA+B;ECn3kCjC;;EDs3kCA;IACE,6BAA6B;ECv3kC/B;;ED03kCA;IACE,+BAA+B;EC33kCjC;;ED83kCA;IACE,6BAA6B;EC/3kC/B;;EDk4kCA;IACE,+BAA+B;ECn4kCjC;;EDs4kCA;IACE,6BAA6B;ECv4kC/B;;ED04kCA;IACE,+BAA+B;EC34kCjC;;ED84kCA;IACE,6BAA6B;EC/4kC/B;;EDk5kCA;IACE,+BAA+B;ECn5kCjC;;EDs5kCA;IACE,6BAA6B;ECv5kC/B;;ED05kCA;IACE,+BAA+B;EC35kCjC;;ED85kCA;IACE,6BAA6B;EC/5kC/B;;EDk6kCA;IACE,+BAA+B;ECn6kCjC;;EDs6kCA;IACE,6BAA6B;ECv6kC/B;;ED06kCA;IACE,+BAA+B;EC36kCjC;;ED86kCA;IACE,6BAA6B;EC/6kC/B;;EDk7kCA;IACE,+BAA+B;ECn7kCjC;;EDs7kCA;IACE,6BAA6B;ECv7kC/B;;ED07kCA;IACE,+BAA+B;EC37kCjC;;ED87kCA;IACE,6BAA6B;EC/7kC/B;;EDk8kCA;IACE,+BAA+B;ECn8kCjC;;EDs8kCA;IACE,6BAA6B;ECv8kC/B;;ED08kCA;IACE,+BAA+B;EC38kCjC;;ED88kCA;IACE,6BAA6B;EC/8kC/B;;EDk9kCA;IACE,+BAA+B;ECn9kCjC;;EDs9kCA;IACE,6BAA6B;ECv9kC/B;;ED09kCA;IACE,+BAA+B;EC39kCjC;;ED89kCA;IACE,6BAA6B;EC/9kC/B;;EDk+kCA;IACE,+BAA+B;ECn+kCjC;;EDs+kCA;IACE,6BAA6B;ECv+kC/B;;ED0+kCA;IACE,+BAA+B;EC3+kCjC;;ED8+kCA;IACE,6BAA6B;EC/+kC/B;;EDk/kCA;IACE,+BAA+B;ECn/kCjC;;EDs/kCA;IACE,6BAA6B;ECv/kC/B;;ED0/kCA;IACE,+BAA+B;EC3/kCjC;;ED8/kCA;IACE,6BAA6B;EC//kC/B;;EDkglCA;IACE,+BAA+B;ECnglCjC;;EDsglCA;IACE,6BAA6B;ECvglC/B;;ED0glCA;IACE,+BAA+B;EC3glCjC;;ED8glCA;IACE,6BAA6B;EC/glC/B;;EDkhlCA;IACE,+BAA+B;ECnhlCjC;;EDshlCA;IACE,6BAA6B;ECvhlC/B;;ED0hlCA;IACE,+BAA+B;EC3hlCjC;;ED8hlCA;IACE,6BAA6B;EC/hlC/B;;EDkilCA;IACE,+BAA+B;ECnilCjC;;EDsilCA;IACE,6BAA6B;ECvilC/B;;ED0ilCA;IACE,+BAA+B;EC3ilCjC;;ED8ilCA;IACE,6BAA6B;EC/ilC/B;;EDkjlCA;IACE,+BAA+B;ECnjlCjC;;EDsjlCA;IACE,6BAA6B;ECvjlC/B;;ED0jlCA;IACE,+BAA+B;EC3jlCjC;;ED8jlCA;IACE,6BAA6B;EC/jlC/B;;EDkklCA;IACE,+BAA+B;ECnklCjC;;EDsklCA;IACE,6BAA6B;ECvklC/B;;ED0klCA;IACE,+BAA+B;EC3klCjC;;ED8klCA;IACE,6BAA6B;EC/klC/B;;EDkllCA;IACE,+BAA+B;ECnllCjC;;EDsllCA;IACE,6BAA6B;ECvllC/B;;ED0llCA;IACE,+BAA+B;EC3llCjC;;ED8llCA;IACE,6BAA6B;EC/llC/B;;EDkmlCA;IACE,+BAA+B;ECnmlCjC;;EDsmlCA;IACE,6BAA6B;ECvmlC/B;;ED0mlCA;IACE,+BAA+B;EC3mlCjC;;ED8mlCA;IACE,6BAA6B;EC/mlC/B;;EDknlCA;IACE,+BAA+B;ECnnlCjC;;EDsnlCA;IACE,6BAA6B;ECvnlC/B;;ED0nlCA;IACE,+BAA+B;EC3nlCjC;;ED8nlCA;IACE,6BAA6B;EC/nlC/B;;EDkolCA;IACE,+BAA+B;ECnolCjC;;EDsolCA;IACE,6BAA6B;ECvolC/B;;ED0olCA;IACE,+BAA+B;EC3olCjC;;ED8olCA;IACE,6BAA6B;EC/olC/B;;EDkplCA;IACE,+BAA+B;ECnplCjC;;EDsplCA;IACE,6BAA6B;ECvplC/B;;ED0plCA;IACE,+BAA+B;ECxolCjC;;ED2olCA;IACE,6BAA6B;EC5olC/B;;ED+olCA;IACE,+BAA+B;EChplCjC;;EDmplCA;IACE,6BAA6B;ECpplC/B;;EDuplCA;IACE,gCAAgC;ECxplClC;;ED2plCA;IACE,+BAA+B;EC5plCjC;;ED+plCA;IACE,6BAA6B;EChqlC/B;;EDmqlCA;IACE,+BAA+B;ECpqlCjC;;EDuqlCA;IACE,6BAA6B;ECxqlC/B;;ED2qlCA;IACE,+BAA+B;EC5qlCjC;;ED+qlCA;IACE,6BAA6B;EChrlC/B;;EDmrlCA;IACE,+BAA+B;ECprlCjC;;EDurlCA;IACE,6BAA6B;ECxrlC/B;;ED2rlCA;IACE,+BAA+B;EC5rlCjC;;ED+rlCA;IACE,6BAA6B;EChslC/B;;EDmslCA;IACE,+BAA+B;ECpslCjC;;EDuslCA;IACE,6BAA6B;ECxslC/B;;ED2slCA;IACE,+BAA+B;EC5slCjC;;ED+slCA;IACE,6BAA6B;EChtlC/B;;EDmtlCA;IACE,+BAA+B;ECptlCjC;;EDutlCA;IACE,6BAA6B;ECxtlC/B;;ED2tlCA;IACE,+BAA+B;EC5tlCjC;;ED+tlCA;IACE,6BAA6B;EChulC/B;;EDmulCA;IACE,+BAA+B;ECpulCjC;;EDuulCA;IACE,8BAA8B;ECxulChC;;ED2ulCA;IACE,gCAAgC;EC5ulClC;;ED+ulCA;IACE,8BAA8B;EChvlChC;;EDmvlCA;IACE,gCAAgC;ECpvlClC;;EDuvlCA;IACE,8BAA8B;ECxvlChC;;ED2vlCA;IACE,gCAAgC;EC5vlClC;;ED+vlCA;IACE,8BAA8B;EChwlChC;;EDmwlCA;IACE,gCAAgC;ECpwlClC;;EDuwlCA;IACE,8BAA8B;ECxwlChC;;ED2wlCA;IACE,gCAAgC;EC5wlClC;;ED+wlCA;IACE,8BAA8B;EChxlChC;;EDmxlCA;IACE,gCAAgC;ECpxlClC;;EDuxlCA;IACE,8BAA8B;ECxxlChC;;ED2xlCA;IACE,gCAAgC;EC5xlClC;;ED+xlCA;IACE,8BAA8B;EChylChC;;EDmylCA;IACE,gCAAgC;ECpylClC;;EDuylCA;IACE,8BAA8B;ECxylChC;;ED2ylCA;IACE,gCAAgC;EC5ylClC;;ED+ylCA;IACE,8BAA8B;EChzlChC;;EDmzlCA;IACE,gCAAgC;ECpzlClC;;EDuzlCA;IACE,8BAA8B;ECxzlChC;;ED2zlCA;IACE,gCAAgC;EC5zlClC;;ED+zlCA;IACE,8BAA8B;ECh0lChC;;EDm0lCA;IACE,gCAAgC;ECp0lClC;;EDu0lCA;IACE,8BAA8B;ECx0lChC;;ED20lCA;IACE,gCAAgC;EC50lClC;;ED+0lCA;IACE,8BAA8B;ECh1lChC;;EDm1lCA;IACE,gCAAgC;ECp1lClC;;EDu1lCA;IACE,8BAA8B;ECx1lChC;;ED21lCA;IACE,gCAAgC;EC51lClC;;ED+1lCA;IACE,8BAA8B;ECh2lChC;;EDm2lCA;IACE,gCAAgC;ECp2lClC;;EDu2lCA;IACE,8BAA8B;ECx2lChC;;ED22lCA;IACE,gCAAgC;EC52lClC;;ED+2lCA;IACE,8BAA8B;ECh3lChC;;EDm3lCA;IACE,gCAAgC;ECp3lClC;;EDu3lCA;IACE,8BAA8B;ECx3lChC;;ED23lCA;IACE,gCAAgC;EC53lClC;;ED+3lCA;IACE,8BAA8B;ECh4lChC;;EDm4lCA;IACE,gCAAgC;ECp4lClC;;EDu4lCA;IACE,8BAA8B;ECx4lChC;;ED24lCA;IACE,gCAAgC;EC54lClC;;ED+4lCA;IACE,8BAA8B;ECh5lChC;;EDm5lCA;IACE,gCAAgC;ECp5lClC;;EDu5lCA;IACE,8BAA8B;ECx5lChC;;ED25lCA;IACE,gCAAgC;EC55lClC;;ED+5lCA;IACE,8BAA8B;ECh6lChC;;EDm6lCA;IACE,gCAAgC;ECp6lClC;;EDu6lCA;IACE,8BAA8B;ECx6lChC;;ED26lCA;IACE,gCAAgC;EC56lClC;;ED+6lCA;IACE,8BAA8B;ECh7lChC;;EDm7lCA;IACE,gCAAgC;ECp7lClC;;EDu7lCA;IACE,8BAA8B;ECx7lChC;;ED27lCA;IACE,gCAAgC;EC57lClC;;ED+7lCA;IACE,8BAA8B;ECh8lChC;;EDm8lCA;IACE,gCAAgC;ECp8lClC;;EDu8lCA;IACE,8BAA8B;ECx8lChC;;ED28lCA;IACE,gCAAgC;EC58lClC;;ED+8lCA;IACE,8BAA8B;ECh9lChC;;EDm9lCA;IACE,gCAAgC;ECp9lClC;;EDu9lCA;IACE,8BAA8B;ECx9lChC;;ED29lCA;IACE,gCAAgC;EC59lClC;;ED+9lCA;IACE,8BAA8B;ECh+lChC;;EDm+lCA;IACE,gCAAgC;ECp+lClC;;EDu+lCA;IACE,8BAA8B;ECx+lChC;;ED2+lCA;IACE,gCAAgC;EC5+lClC;;ED++lCA;IACE,8BAA8B;ECh/lChC;;EDm/lCA;IACE,gCAAgC;ECp/lClC;;EDu/lCA;IACE,8BAA8B;ECx/lChC;;ED2/lCA;IACE,gCAAgC;EC5/lClC;;ED+/lCA;IACE,8BAA8B;EChgmChC;;EDmgmCA;IACE,gCAAgC;ECpgmClC;;EDugmCA;IACE,8BAA8B;ECxgmChC;;ED2gmCA;IACE,gCAAgC;EC5gmClC;;ED+gmCA;IACE,8BAA8B;EChhmChC;;EDmhmCA;IACE,gCAAgC;ECphmClC;;EDuhmCA;IACE,8BAA8B;ECxhmChC;;ED2hmCA;IACE,gCAAgC;EC5hmClC;;ED+hmCA;IACE,8BAA8B;EChimChC;;EDmimCA;IACE,gCAAgC;ECpimClC;;EDuimCA;IACE,8BAA8B;ECximChC;;ED2imCA;IACE,gCAAgC;EC5imClC;;ED+imCA;IACE,8BAA8B;EChjmChC;;EDmjmCA;IACE,gCAAgC;ECpjmClC;;EDujmCA;IACE,8BAA8B;ECxjmChC;;ED2jmCA;IACE,gCAAgC;EC5jmClC;;ED+jmCA;IACE,8BAA8B;EChkmChC;;EDmkmCA;IACE,gCAAgC;ECpkmClC;;EDukmCA;IACE,8BAA8B;ECxkmChC;;ED2kmCA;IACE,gCAAgC;EC5kmClC;;ED+kmCA;IACE,8BAA8B;EChlmChC;;EDmlmCA;IACE,gCAAgC;ECplmClC;;EDulmCA;IACE,8BAA8B;ECxlmChC;;ED2lmCA;IACE,gCAAgC;EC5lmClC;;ED+lmCA;IACE,8BAA8B;EChmmChC;;EDmmmCA;IACE,gCAAgC;ECpmmClC;;EDummCA;IACE,8BAA8B;ECxmmChC;;ED2mmCA;IACE,gCAAgC;EC5mmClC;;ED+mmCA;IACE,8BAA8B;EChnmChC;;EDmnmCA;IACE,gCAAgC;ECpnmClC;;EDunmCA;IACE,8BAA8B;ECxnmChC;;ED2nmCA;IACE,gCAAgC;EC5nmClC;;ED+nmCA;IACE,8BAA8B;EChomChC;;EDmomCA;IACE,gCAAgC;ECpomClC;;EDuomCA;IACE,8BAA8B;ECxomChC;;ED2omCA;IACE,gCAAgC;EC5omClC;;ED+omCA;IACE,8BAA8B;EChpmChC;;EDmpmCA;IACE,gCAAgC;ECppmClC;;EDupmCA;IACE,8BAA8B;ECxpmChC;;ED2pmCA;IACE,gCAAgC;EC5pmClC;;ED+pmCA;IACE,8BAA8B;EChqmChC;;EDmqmCA;IACE,gCAAgC;ECpqmClC;;EDuqmCA;IACE,8BAA8B;ECxqmChC;;ED2qmCA;IACE,gCAAgC;EC5qmClC;;ED+qmCA;IACE,8BAA8B;EChrmChC;;EDmrmCA;IACE,gCAAgC;ECprmClC;;EDurmCA;IACE,8BAA8B;ECxrmChC;;ED2rmCA;IACE,gCAAgC;EC5rmClC;;ED+rmCA;IACE,8BAA8B;EChsmChC;;EDmsmCA;IACE,gCAAgC;ECpsmClC;;EDusmCA;IACE,8BAA8B;ECxsmChC;;ED2smCA;IACE,gCAAgC;EC5smClC;;ED+smCA;IACE,8BAA8B;EChtmChC;;EDmtmCA;IACE,gCAAgC;ECptmClC;;EDutmCA;IACE,8BAA8B;ECxtmChC;;ED2tmCA;IACE,gCAAgC;EC5tmClC;;ED+tmCA;IACE,8BAA8B;EChumChC;;EDmumCA;IACE,gCAAgC;ECpumClC;;EDuumCA;IACE,8BAA8B;ECxumChC;;ED2umCA;IACE,gCAAgC;EC5umClC;;ED+umCA;IACE,8BAA8B;EChvmChC;;EDmvmCA;IACE,gCAAgC;ECpvmClC;;EDuvmCA;IACE,8BAA8B;ECxvmChC;;ED2vmCA;IACE,gCAAgC;EC5vmClC;;ED+vmCA;IACE,8BAA8B;EChwmChC;;EDmwmCA;IACE,gCAAgC;ECpwmClC;;EDuwmCA;IACE,8BAA8B;ECxwmChC;;ED2wmCA;IACE,gCAAgC;ECzvmClC;;ED4vmCA;IACE,8BAA8B;EAChC;;EAEA;IC9vmCC,gCAAsC;EDgwmCvC;;EClwmCA;IACC,4BAAa;IACb,6BAAc;EDqwmCf;;ECvwmCA;IACC,+BAAqC;IACrC,gCAAsC;ED0wmCvC;;EC5wmCA;IACC,8BAAqC;IACrC,+BAAsC;ED+wmCvC;;ECjxmCA;IACC,4BAAqC;IACrC,6BAAsC;EDoxmCvC;;ECtxmCA;IACC,8BAAqC;IACrC,+BAAsC;EDyxmCvC;;EC3xmCA;IACC,4BAAqC;IACrC,6BAAsC;ED8xmCvC;;EChymCA;IACC,8BAAqC;IACrC,+BAAsC;EDmymCvC;;ECrymCA;IACC,4BAAqC;IACrC,6BAAsC;EDwymCvC;;EC1ymCA;IACC,8BAAqC;IACrC,+BAAsC;ED6ymCvC;;EC/ymCA;IACC,4BAAqC;IACrC,6BAAsC;EDkzmCvC;;ECpzmCA;IACC,8BAAqC;IACrC,+BAAsC;EDuzmCvC;;ECzzmCA;IACC,4BAAqC;IACrC,6BAAsC;ED4zmCvC;;EC9zmCA;IACC,8BAAqC;IACrC,+BAAsC;EDi0mCvC;;ECn0mCA;IACC,4BAAqC;IACrC,6BAAsC;EDs0mCvC;;ECx0mCA;IACC,8BAAqC;IACrC,+BAAsC;ED20mCvC;;EC70mCA;IACC,4BAAqC;IACrC,6BAAsC;EDg1mCvC;;ECl1mCA;IACC,8BAAqC;IACrC,+BAAsC;EDq1mCvC;;ECv1mCA;IACC,4BAAqC;IACrC,6BAAsC;ED01mCvC;;EC51mCA;IACC,8BAAqC;IACrC,+BAAsC;ED+1mCvC;;ECj2mCA;IACC,4BAAa;IACb,6BAAc;EDo2mCf;;ECt2mCA;IACC,8BAAa;IACb,+BAAc;EDy2mCf;;EC32mCA;IACC,6BAAqC;IACrC,8BAAsC;ED82mCvC;;ECh3mCA;IACC,+BAAqC;IACrC,gCAAsC;EDm3mCvC;;ECr3mCA;IACC,6BAAqC;IACrC,8BAAsC;EDw3mCvC;;EC13mCA;IACC,+BAAqC;IACrC,gCAAsC;ED63mCvC;;EC/3mCA;IACC,6BAAqC;IACrC,8BAAsC;EDk4mCvC;;ECp4mCA;IACC,+BAAqC;IACrC,gCAAsC;EDu4mCvC;;ECz4mCA;IACC,6BAAqC;IACrC,8BAAsC;ED44mCvC;;EC94mCA;IACC,+BAAqC;IACrC,gCAAsC;EDi5mCvC;;ECn5mCA;IACC,6BAAqC;IACrC,8BAAsC;EDs5mCvC;;ECx5mCA;IACC,+BAAqC;IACrC,gCAAsC;ED25mCvC;;EC75mCA;IACC,6BAAqC;IACrC,8BAAsC;EDg6mCvC;;ECl6mCA;IACC,+BAAqC;IACrC,gCAAsC;EDq6mCvC;;ECv6mCA;IACC,6BAAqC;IACrC,8BAAsC;ED06mCvC;;EC56mCA;IACC,+BAAqC;IACrC,gCAAsC;ED+6mCvC;;ECj7mCA;IACC,6BAAqC;IACrC,8BAAsC;EDo7mCvC;;ECt7mCA;IACC,+BAAqC;IACrC,gCAAsC;EDy7mCvC;;EC37mCA;IACC,6BAAqC;IACrC,8BAAsC;ED87mCvC;;ECh8mCA;IACC,+BAAqC;IACrC,gCAAsC;EDm8mCvC;;ECr8mCA;IACC,6BAAqC;IACrC,8BAAsC;EDw8mCvC;;EC18mCA;IACC,+BAAqC;IACrC,gCAAsC;ED68mCvC;;EC/8mCA;IACC,6BAAqC;IACrC,8BAAsC;EDk9mCvC;;ECp9mCA;IACC,+BAAqC;IACrC,gCAAsC;EDu9mCvC;;ECz9mCA;IACC,6BAAqC;IACrC,8BAAsC;ED49mCvC;;EC99mCA;IACC,+BAAqC;IACrC,gCAAsC;EDi+mCvC;;ECn+mCA;IACC,6BAAqC;IACrC,8BAAsC;EDs+mCvC;;ECx+mCA;IACC,+BAAqC;IACrC,gCAAsC;ED2+mCvC;;EC7+mCA;IACC,6BAAqC;IACrC,8BAAsC;EDg/mCvC;;ECl/mCA;IACC,+BAAqC;IACrC,gCAAsC;EDq/mCvC;;ECv/mCA;IACC,6BAAqC;IACrC,8BAAsC;ED0/mCvC;;EC5/mCA;IACC,+BAAqC;IACrC,gCAAsC;ED+/mCvC;;ECjgnCA;IACC,6BAAqC;IACrC,8BAAsC;EDognCvC;;ECtgnCA;IACC,+BAAqC;IACrC,gCAAsC;EDygnCvC;;EC3gnCA;IACC,6BAAqC;IACrC,8BAAsC;ED8gnCvC;;EChhnCA;IACC,+BAAqC;IACrC,gCAAsC;EDmhnCvC;;ECrhnCA;IACC,6BAAqC;IACrC,8BAAsC;EDwhnCvC;;EC1hnCA;IACC,+BAAqC;IACrC,gCAAsC;ED6hnCvC;;EC/hnCA;IACC,6BAAqC;IACrC,8BAAsC;EDkinCvC;;ECpinCA;IACC,+BAAqC;IACrC,gCAAsC;EDuinCvC;;ECzinCA;IACC,6BAAqC;IACrC,8BAAsC;ED4inCvC;;EC9inCA;IACC,+BAAqC;IACrC,gCAAsC;EDijnCvC;;ECnjnCA;IACC,6BAAqC;IACrC,8BAAsC;EDsjnCvC;;ECxjnCA;IACC,+BAAqC;IACrC,gCAAsC;ED2jnCvC;;EC7jnCA;IACC,6BAAqC;IACrC,8BAAsC;EDgknCvC;;EClknCA;IACC,+BAAqC;IACrC,gCAAsC;EDqknCvC;;ECvknCA;IACC,6BAAqC;IACrC,8BAAsC;ED0knCvC;;EC5knCA;IACC,+BAAqC;IACrC,gCAAsC;ED+knCvC;;ECjlnCA;IACC,6BAAqC;IACrC,8BAAsC;EDolnCvC;;ECtlnCA;IACC,+BAAqC;IACrC,gCAAsC;EDylnCvC;;EC3lnCA;IACC,6BAAqC;IACrC,8BAAsC;ED8lnCvC;;EChmnCA;IACC,+BAAqC;IACrC,gCAAsC;EDmmnCvC;;ECrmnCA;IACC,6BAAqC;IACrC,8BAAsC;EDwmnCvC;;EC1mnCA;IACC,+BAAqC;IACrC,gCAAsC;ED6mnCvC;;EC/mnCA;IACC,6BAAqC;IACrC,8BAAsC;EDknnCvC;;ECpnnCA;IACC,+BAAqC;IACrC,gCAAsC;EDunnCvC;;ECznnCA;IACC,6BAAqC;IACrC,8BAAsC;ED4nnCvC;;EC9nnCA;IACC,+BAAqC;IACrC,gCAAsC;EDionCvC;;ECnonCA;IACC,6BAAqC;IACrC,8BAAsC;EDsonCvC;;ECxonCA;IACC,+BAAqC;IACrC,gCAAsC;ED2onCvC;;EC7onCA;IACC,6BAAqC;IACrC,8BAAsC;EDgpnCvC;;EClpnCA;IACC,+BAAqC;IACrC,gCAAsC;EDqpnCvC;;ECvpnCA;IACC,6BAAqC;IACrC,8BAAsC;ED0pnCvC;;EC5pnCA;IACC,+BAAqC;IACrC,gCAAsC;ED+pnCvC;;ECjqnCA;IACC,6BAAqC;IACrC,8BAAsC;EDoqnCvC;;ECtqnCA;IACC,+BAAqC;IACrC,gCAAsC;EDyqnCvC;;EC3qnCA;IACC,6BAAqC;IACrC,8BAAsC;ED8qnCvC;;EChrnCA;IACC,+BAAqC;IACrC,gCAAsC;EDmrnCvC;;ECrrnCA;IACC,6BAAqC;IACrC,8BAAsC;EDwrnCvC;;EC1rnCA;IACC,+BAAqC;IACrC,gCAAsC;ED6rnCvC;;EC/rnCA;IACC,6BAAqC;IACrC,8BAAsC;EDksnCvC;;ECpsnCA;IACC,+BAAqC;IACrC,gCAAsC;EDusnCvC;;ECzsnCA;IACC,6BAAqC;IACrC,8BAAsC;ED4snCvC;;EC9snCA;IACC,+BAAqC;IACrC,gCAAsC;EDitnCvC;;ECntnCA;IACC,6BAAqC;IACrC,8BAAsC;EDstnCvC;;ECxtnCA;IACC,+BAAqC;IACrC,gCAAsC;ED2tnCvC;;EC7tnCA;IACC,6BAAqC;IACrC,8BAAsC;EDgunCvC;;EClunCA;IACC,+BAAqC;IACrC,gCAAsC;EDqunCvC;;ECvunCA;IACC,6BAAqC;IACrC,8BAAsC;ED0unCvC;;EC5unCA;IACC,+BAAqC;IACrC,gCAAsC;ED+unCvC;;ECjvnCA;IACC,6BAAqC;IACrC,8BAAsC;EDovnCvC;;ECtvnCA;IACC,+BAAqC;IACrC,gCAAsC;EDyvnCvC;;EC3vnCA;IACC,6BAAqC;IACrC,8BAAsC;ED8vnCvC;;EChwnCA;IACC,+BAAqC;IACrC,gCAAsC;EDmwnCvC;;ECrwnCA;IACC,6BAAqC;IACrC,8BAAsC;EDwwnCvC;;EC1wnCA;IACC,+BAAqC;IACrC,gCAAsC;ED6wnCvC;;EC/wnCA;IACC,6BAAqC;IACrC,8BAAsC;EDkxnCvC;;ECpxnCA;IACC,+BAAqC;IACrC,gCAAsC;EDuxnCvC;;ECzxnCA;IACC,6BAAqC;IACrC,8BAAsC;ED4xnCvC;;EC9xnCA;IACC,+BAAqC;IACrC,gCAAsC;EDiynCvC;;ECnynCA;IACC,6BAAqC;IACrC,8BAAsC;EDsynCvC;;ECxynCA;IACC,+BAAqC;IACrC,gCAAsC;ED2ynCvC;;EC7ynCA;IACC,6BAAqC;IACrC,8BAAsC;EDgznCvC;;EClznCA;IACC,+BAAqC;IACrC,gCAAsC;EDqznCvC;;ECvznCA;IACC,6BAAqC;IACrC,8BAAsC;ED0znCvC;;EC5znCA;IACC,+BAAqC;IACrC,gCAAsC;ED+znCvC;;ECj0nCA;IACC,6BAAqC;IACrC,8BAAsC;EDo0nCvC;;ECt0nCA;IACC,+BAAqC;IACrC,gCAAsC;EDy0nCvC;;EC30nCA;IACC,6BAAqC;IACrC,8BAAsC;ED80nCvC;;ECh1nCA;IACC,+BAAqC;IACrC,gCAAsC;EDm1nCvC;;ECr1nCA;IACC,6BAAqC;IACrC,8BAAsC;EDw1nCvC;;EC11nCA;IACC,+BAAqC;IACrC,gCAAsC;ED61nCvC;;EC/1nCA;IACC,6BAAqC;IACrC,8BAAsC;EDk2nCvC;;ECp2nCA;IACC,+BAAqC;IACrC,gCAAsC;EDu2nCvC;;ECz2nCA;IACC,6BAAqC;IACrC,8BAAsC;ED42nCvC;;EC92nCA;IACC,+BAAqC;IACrC,gCAAsC;EDi3nCvC;;ECn3nCA;IACC,6BAAqC;IACrC,8BAAsC;EDs3nCvC;;ECx3nCA;IACC,+BAAqC;IACrC,gCAAsC;ED23nCvC;;EC73nCA;IACC,6BAAqC;IACrC,8BAAsC;EDg4nCvC;;ECl4nCA;IACC,+BAAqC;IACrC,gCAAsC;EDq4nCvC;;ECv4nCA;IACC,6BAAqC;IACrC,8BAAsC;ED04nCvC;;EC54nCA;IACC,+BAAqC;IACrC,gCAAsC;ED+4nCvC;;ECj5nCA;IACC,6BAAqC;IACrC,8BAAsC;EDo5nCvC;;ECt5nCA;IACC,+BAAqC;IACrC,gCAAsC;EDy5nCvC;;EC35nCA;IACC,6BAAqC;IACrC,8BAAsC;ED85nCvC;;ECh6nCA;IACC,+BAAqC;IACrC,gCAAsC;EDm6nCvC;;ECr6nCA;IACC,6BAAqC;IACrC,8BAAsC;EDw6nCvC;;EC16nCA;IACC,+BAAqC;IACrC,gCAAsC;ED66nCvC;;EC/6nCA;IACC,6BAAqC;IACrC,8BAAsC;EDk7nCvC;;ECp7nCA;IACC,+BAAqC;IACrC,gCAAsC;EDu7nCvC;;ECz7nCA;IACC,6BAAqC;IACrC,8BAAsC;ED47nCvC;;EC97nCA;IACC,+BAAqC;IACrC,gCAAsC;EDi8nCvC;;ECn8nCA;IACC,6BAAqC;IACrC,8BAAsC;EDs8nCvC;;ECx8nCA;IACC,+BAAqC;IACrC,gCAAsC;ED28nCvC;;EC78nCA;IACC,6BAAqC;IACrC,8BAAsC;EDg9nCvC;;ECl9nCA;IACC,+BAAqC;IACrC,gCAAsC;EDq9nCvC;;ECv9nCA;IACC,6BAAqC;IACrC,8BAAsC;ED09nCvC;;EC59nCA;IACC,+BAAqC;IACrC,gCAAsC;ED+9nCvC;;ECj+nCA;IACC,6BAAqC;IACrC,8BAAsC;EDo+nCvC;;ECt+nCA;IACC,+BAAqC;IACrC,gCAAsC;EDy+nCvC;;EC3+nCA;IACC,6BAAqC;IACrC,8BAAsC;ED8+nCvC;;ECh/nCA;IACC,+BAAqC;IACrC,gCAAsC;EDm/nCvC;;ECr/nCA;IACC,6BAAqC;IACrC,8BAAsC;EDw/nCvC;;EC1/nCA;IACC,+BAAqC;IACrC,gCAAsC;ED6/nCvC;;EC//nCA;IACC,6BAAqC;IACrC,8BAAsC;EDkgoCvC;;ECpgoCA;IACC,+BAAqC;IACrC,gCAAsC;EDugoCvC;;ECzgoCA;IACC,6BAAqC;IACrC,8BAAsC;ED4goCvC;;EC9goCA;IACC,+BAAqC;IACrC,gCAAsC;EDihoCvC;;ECnhoCA;IACC,6BAAqC;IACrC,8BAAsC;EDshoCvC;;ECxhoCA;IACC,+BAAqC;IACrC,gCAAsC;ED2hoCvC;;ECzgoCA;IACC,6BAAoC;IACpC,8BAAuC;ED4goCxC;;EC9goCA;IACC,+BAAoC;IACpC,gCAAe;EDihoChB;;ECnhoCA;IACC,2BAAY;IACZ,8BAAe;EDshoChB;;ECxhoCA;IACC,8BAAoC;IACpC,iCAAuC;ED2hoCxC;;EC7hoCA;IACC,6BAAoC;IACpC,gCAAuC;EDgioCxC;;EClioCA;IACC,2BAAoC;IACpC,8BAAuC;EDqioCxC;;ECvioCA;IACC,6BAAoC;IACpC,gCAAuC;ED0ioCxC;;EC5ioCA;IACC,2BAAoC;IACpC,8BAAuC;ED+ioCxC;;ECjjoCA;IACC,6BAAoC;IACpC,gCAAuC;EDojoCxC;;ECtjoCA;IACC,2BAAoC;IACpC,8BAAuC;EDyjoCxC;;EC3joCA;IACC,6BAAoC;IACpC,gCAAuC;ED8joCxC;;EChkoCA;IACC,2BAAoC;IACpC,8BAAuC;EDmkoCxC;;ECrkoCA;IACC,6BAAoC;IACpC,gCAAuC;EDwkoCxC;;EC1koCA;IACC,2BAAoC;IACpC,8BAAuC;ED6koCxC;;EC/koCA;IACC,6BAAoC;IACpC,gCAAuC;EDkloCxC;;ECploCA;IACC,2BAAoC;IACpC,8BAAuC;EDuloCxC;;ECzloCA;IACC,6BAAoC;IACpC,gCAAuC;ED4loCxC;;EC9loCA;IACC,2BAAoC;IACpC,8BAAuC;EDimoCxC;;ECnmoCA;IACC,6BAAoC;IACpC,gCAAuC;EDsmoCxC;;ECxmoCA;IACC,2BAAoC;IACpC,8BAAuC;ED2moCxC;;EC7moCA;IACC,6BAAoC;IACpC,gCAAuC;EDgnoCxC;;EClnoCA;IACC,2BAAY;IACZ,8BAAe;EDqnoChB;;ECvnoCA;IACC,6BAAY;IACZ,gCAAe;ED0noChB;;EC5noCA;IACC,4BAAoC;IACpC,+BAAuC;ED+noCxC;;ECjooCA;IACC,8BAAoC;IACpC,iCAAuC;EDoooCxC;;ECtooCA;IACC,4BAAoC;IACpC,+BAAuC;EDyooCxC;;EC3ooCA;IACC,8BAAoC;IACpC,iCAAuC;ED8ooCxC;;EChpoCA;IACC,4BAAoC;IACpC,+BAAuC;EDmpoCxC;;ECrpoCA;IACC,8BAAoC;IACpC,iCAAuC;EDwpoCxC;;EC1poCA;IACC,4BAAoC;IACpC,+BAAuC;ED6poCxC;;EC/poCA;IACC,8BAAoC;IACpC,iCAAuC;EDkqoCxC;;ECpqoCA;IACC,4BAAoC;IACpC,+BAAuC;EDuqoCxC;;ECzqoCA;IACC,8BAAoC;IACpC,iCAAuC;ED4qoCxC;;EC9qoCA;IACC,4BAAoC;IACpC,+BAAuC;EDiroCxC;;ECnroCA;IACC,8BAAoC;IACpC,iCAAuC;EDsroCxC;;ECxroCA;IACC,4BAAoC;IACpC,+BAAuC;ED2roCxC;;EC7roCA;IACC,8BAAoC;IACpC,iCAAuC;EDgsoCxC;;EClsoCA;IACC,4BAAoC;IACpC,+BAAuC;EDqsoCxC;;ECvsoCA;IACC,8BAAoC;IACpC,iCAAuC;ED0soCxC;;EC5soCA;IACC,4BAAoC;IACpC,+BAAuC;ED+soCxC;;ECjtoCA;IACC,8BAAoC;IACpC,iCAAuC;EDotoCxC;;ECttoCA;IACC,4BAAoC;IACpC,+BAAuC;EDytoCxC;;EC3toCA;IACC,8BAAoC;IACpC,iCAAuC;ED8toCxC;;EChuoCA;IACC,4BAAoC;IACpC,+BAAuC;EDmuoCxC;;ECruoCA;IACC,8BAAoC;IACpC,iCAAuC;EDwuoCxC;;EC1uoCA;IACC,4BAAoC;IACpC,+BAAuC;ED6uoCxC;;EC/uoCA;IACC,8BAAoC;IACpC,iCAAuC;EDkvoCxC;;ECpvoCA;IACC,4BAAoC;IACpC,+BAAuC;EDuvoCxC;;ECzvoCA;IACC,8BAAoC;IACpC,iCAAuC;ED4voCxC;;EC9voCA;IACC,4BAAoC;IACpC,+BAAuC;EDiwoCxC;;ECnwoCA;IACC,8BAAoC;IACpC,iCAAuC;EDswoCxC;;ECxwoCA;IACC,4BAAoC;IACpC,+BAAuC;ED2woCxC;;EC7woCA;IACC,8BAAoC;IACpC,iCAAuC;EDgxoCxC;;EClxoCA;IACC,4BAAoC;IACpC,+BAAuC;EDqxoCxC;;ECvxoCA;IACC,8BAAoC;IACpC,iCAAuC;ED0xoCxC;;EC5xoCA;IACC,4BAAoC;IACpC,+BAAuC;ED+xoCxC;;ECjyoCA;IACC,8BAAoC;IACpC,iCAAuC;EDoyoCxC;;ECtyoCA;IACC,4BAAoC;IACpC,+BAAuC;EDyyoCxC;;EC3yoCA;IACC,8BAAoC;IACpC,iCAAuC;ED8yoCxC;;EChzoCA;IACC,4BAAoC;IACpC,+BAAuC;EDmzoCxC;;ECrzoCA;IACC,8BAAoC;IACpC,iCAAuC;EDwzoCxC;;EC1zoCA;IACC,4BAAoC;IACpC,+BAAuC;ED6zoCxC;;EC/zoCA;IACC,8BAAoC;IACpC,iCAAuC;EDk0oCxC;;ECp0oCA;IACC,4BAAoC;IACpC,+BAAuC;EDu0oCxC;;ECz0oCA;IACC,8BAAoC;IACpC,iCAAuC;ED40oCxC;;EC90oCA;IACC,4BAAoC;IACpC,+BAAuC;EDi1oCxC;;ECn1oCA;IACC,8BAAoC;IACpC,iCAAuC;EDs1oCxC;;ECx1oCA;IACC,4BAAoC;IACpC,+BAAuC;ED21oCxC;;EC71oCA;IACC,8BAAoC;IACpC,iCAAuC;EDg2oCxC;;ECl2oCA;IACC,4BAAoC;IACpC,+BAAuC;EDq2oCxC;;ECv2oCA;IACC,8BAAoC;IACpC,iCAAuC;ED02oCxC;;EC52oCA;IACC,4BAAoC;IACpC,+BAAuC;ED+2oCxC;;ECj3oCA;IACC,8BAAoC;IACpC,iCAAuC;EDo3oCxC;;ECt3oCA;IACC,4BAAoC;IACpC,+BAAuC;EDy3oCxC;;EC33oCA;IACC,8BAAoC;IACpC,iCAAuC;ED83oCxC;;ECh4oCA;IACC,4BAAoC;IACpC,+BAAuC;EDm4oCxC;;ECr4oCA;IACC,8BAAoC;IACpC,iCAAuC;EDw4oCxC;;EC14oCA;IACC,4BAAoC;IACpC,+BAAuC;ED64oCxC;;EC/4oCA;IACC,8BAAoC;IACpC,iCAAuC;EDk5oCxC;;ECp5oCA;IACC,4BAAoC;IACpC,+BAAuC;EDu5oCxC;;ECz5oCA;IACC,8BAAoC;IACpC,iCAAuC;ED45oCxC;;EC95oCA;IACC,4BAAoC;IACpC,+BAAuC;EDi6oCxC;;ECn6oCA;IACC,8BAAoC;IACpC,iCAAuC;EDs6oCxC;;ECx6oCA;IACC,4BAAoC;IACpC,+BAAuC;ED26oCxC;;EC76oCA;IACC,8BAAoC;IACpC,iCAAuC;EDg7oCxC;;ECl7oCA;IACC,4BAAoC;IACpC,+BAAuC;EDq7oCxC;;ECv7oCA;IACC,8BAAoC;IACpC,iCAAuC;ED07oCxC;;EC57oCA;IACC,4BAAoC;IACpC,+BAAuC;ED+7oCxC;;ECj8oCA;IACC,8BAAoC;IACpC,iCAAuC;EDo8oCxC;;ECt8oCA;IACC,4BAAoC;IACpC,+BAAuC;EDy8oCxC;;EC38oCA;IACC,8BAAoC;IACpC,iCAAuC;ED88oCxC;;ECh9oCA;IACC,4BAAoC;IACpC,+BAAuC;EDm9oCxC;;ECr9oCA;IACC,8BAAoC;IACpC,iCAAuC;EDw9oCxC;;EC19oCA;IACC,4BAAoC;IACpC,+BAAuC;ED69oCxC;;EC/9oCA;IACC,8BAAoC;IACpC,iCAAuC;EDk+oCxC;;ECp+oCA;IACC,4BAAoC;IACpC,+BAAuC;EDu+oCxC;;ECz+oCA;IACC,8BAAoC;IACpC,iCAAuC;ED4+oCxC;;EC9+oCA;IACC,4BAAoC;IACpC,+BAAuC;EDi/oCxC;;ECn/oCA;IACC,8BAAoC;IACpC,iCAAuC;EDs/oCxC;;ECx/oCA;IACC,4BAAoC;IACpC,+BAAuC;ED2/oCxC;;EC7/oCA;IACC,8BAAoC;IACpC,iCAAuC;EDggpCxC;;EClgpCA;IACC,4BAAoC;IACpC,+BAAuC;EDqgpCxC;;ECvgpCA;IACC,8BAAoC;IACpC,iCAAuC;ED0gpCxC;;EC5gpCA;IACC,4BAAoC;IACpC,+BAAuC;ED+gpCxC;;ECjhpCA;IACC,8BAAoC;IACpC,iCAAuC;EDohpCxC;;ECthpCA;IACC,4BAAoC;IACpC,+BAAuC;EDyhpCxC;;EC3hpCA;IACC,8BAAoC;IACpC,iCAAuC;ED8hpCxC;;EChipCA;IACC,4BAAoC;IACpC,+BAAuC;EDmipCxC;;ECripCA;IACC,8BAAoC;IACpC,iCAAuC;EDwipCxC;;EC1ipCA;IACC,4BAAoC;IACpC,+BAAuC;ED6ipCxC;;EC/ipCA;IACC,8BAAoC;IACpC,iCAAuC;EDkjpCxC;;ECpjpCA;IACC,4BAAoC;IACpC,+BAAuC;EDujpCxC;;ECzjpCA;IACC,8BAAoC;IACpC,iCAAuC;ED4jpCxC;;EC9jpCA;IACC,4BAAoC;IACpC,+BAAuC;EDikpCxC;;ECnkpCA;IACC,8BAAoC;IACpC,iCAAuC;EDskpCxC;;ECxkpCA;IACC,4BAAoC;IACpC,+BAAuC;ED2kpCxC;;EC7kpCA;IACC,8BAAoC;IACpC,iCAAuC;EDglpCxC;;ECllpCA;IACC,4BAAoC;IACpC,+BAAuC;EDqlpCxC;;ECvlpCA;IACC,8BAAoC;IACpC,iCAAuC;ED0lpCxC;;EC5lpCA;IACC,4BAAoC;IACpC,+BAAuC;ED+lpCxC;;ECjmpCA;IACC,8BAAoC;IACpC,iCAAuC;EDompCxC;;ECtmpCA;IACC,4BAAoC;IACpC,+BAAuC;EDympCxC;;EC3mpCA;IACC,8BAAoC;IACpC,iCAAuC;ED8mpCxC;;EChnpCA;IACC,4BAAoC;IACpC,+BAAuC;EDmnpCxC;;ECrnpCA;IACC,8BAAoC;IACpC,iCAAuC;EDwnpCxC;;EC1npCA;IACC,4BAAoC;IACpC,+BAAuC;ED6npCxC;;EC/npCA;IACC,8BAAoC;IACpC,iCAAuC;EDkopCxC;;ECpopCA;IACC,4BAAoC;IACpC,+BAAuC;EDuopCxC;;ECzopCA;IACC,8BAAoC;IACpC,iCAAuC;ED4opCxC;;EC9opCA;IACC,4BAAoC;IACpC,+BAAuC;EDippCxC;;ECnppCA;IACC,8BAAoC;IACpC,iCAAuC;EDsppCxC;;ECxppCA;IACC,4BAAoC;IACpC,+BAAuC;ED2ppCxC;;EC7ppCA;IACC,8BAAoC;IACpC,iCAAuC;EDgqpCxC;;EClqpCA;IACC,4BAAoC;IACpC,+BAAuC;EDqqpCxC;;ECvqpCA;IACC,8BAAoC;IACpC,iCAAuC;ED0qpCxC;;EC5qpCA;IACC,4BAAoC;IACpC,+BAAuC;ED+qpCxC;;ECjrpCA;IACC,8BAAoC;IACpC,iCAAuC;EDorpCxC;;ECtrpCA;IACC,4BAAoC;IACpC,+BAAuC;EDyrpCxC;;EC3rpCA;IACC,8BAAoC;IACpC,iCAAuC;ED8rpCxC;;EChspCA;IACC,4BAAoC;IACpC,+BAAuC;EDmspCxC;;ECrspCA;IACC,8BAAoC;IACpC,iCAAuC;EDwspCxC;;EC1spCA;IACC,4BAAoC;IACpC,+BAAuC;ED6spCxC;;EC/spCA;IACC,8BAAoC;IACpC,iCAAuC;EDktpCxC;;ECptpCA;IACC,4BAAoC;IACpC,+BAAuC;EDutpCxC;;ECztpCA;IACC,8BAAoC;IACpC,iCAAuC;ED4tpCxC;;EC9tpCA;IACC,4BAAoC;IACpC,+BAAuC;EDiupCxC;;ECnupCA;IACC,8BAAoC;IACpC,iCAAuC;EDsupCxC;;ECxupCA;IACC,4BAAoC;IACpC,+BAAuC;ED2upCxC;;EC7upCA;IACC,8BAAoC;IACpC,iCAAuC;EDgvpCxC;;EClvpCA;IACC,4BAAoC;IACpC,+BAAuC;EDqvpCxC;;ECvvpCA;IACC,8BAAoC;IACpC,iCAAuC;ED0vpCxC;;EC5vpCA;IACC,4BAAoC;IACpC,+BAAuC;ED+vpCxC;;ECjwpCA;IACC,8BAAoC;IACpC,iCAAuC;EDowpCxC;;ECtwpCA;IACC,4BAAoC;IACpC,+BAAuC;EDywpCxC;;EC3wpCA;IACC,8BAAoC;IACpC,iCAAuC;ED8wpCxC;;EChxpCA;IACC,4BAAoC;IACpC,+BAAuC;EDmxpCxC;;ECrxpCA;IACC,8BAAoC;IACpC,iCAAuC;EDwxpCxC;;EC1xpCA;IACC,4BAAoC;IACpC,+BAAuC;ED6xpCxC;;EC/xpCA;IACC,8BAAoC;IACpC,iCAAuC;EDkypCxC;;ECpypCA;IACC,4BAAoC;IACpC,+BAAuC;EDuypCxC;;ECzypCA;IACC,8BAAoC;IACpC,iCAAuC;ED4ypCxC;;ECtypCF;IAaE,4BAAc;IACb,+BAAgC;ED6xpCjC;;EC9xpCA;IACC,8BAAgC;IDiypC/B,iCAAiC;EACnC;AACF;AACA;EACE;IACE,uBAAuB;ECvypCzB;;ED0ypCA;IACE,0BAA0B;EC3ypC5B;;ED8ypCA;IACE,yBAAyB;EC/ypC3B;;EDkzpCA;IACE,uBAAuB;ECnzpCzB;;EDszpCA;IACE,yBAAyB;ECvzpC3B;;ED0zpCA;IACE,uBAAuB;EC3zpCzB;;ED8zpCA;IACE,yBAAyB;EC/zpC3B;;EDk0pCA;IACE,uBAAuB;ECn0pCzB;;EDs0pCA;IACE,yBAAyB;ECv0pC3B;;ED00pCA;IACE,uBAAuB;EC30pCzB;;ED80pCA;IACE,yBAAyB;EC/0pC3B;;EDk1pCA;IACE,uBAAuB;ECn1pCzB;;EDs1pCA;IACE,yBAAyB;ECv1pC3B;;ED01pCA;IACE,uBAAuB;EC31pCzB;;ED81pCA;IACE,yBAAyB;EC/1pC3B;;EDk2pCA;IACE,uBAAuB;ECn2pCzB;;EDs2pCA;IACE,yBAAyB;ECv2pC3B;;ED02pCA;IACE,uBAAuB;EC32pCzB;;ED82pCA;IACE,yBAAyB;EC/2pC3B;;EDk3pCA;IACE,uBAAuB;ECn3pCzB;;EDs3pCA;IACE,yBAAyB;ECv3pC3B;;ED03pCA;IACE,wBAAwB;EC33pC1B;;ED83pCA;IACE,0BAA0B;EC/3pC5B;;EDk4pCA;IACE,wBAAwB;ECn4pC1B;;EDs4pCA;IACE,0BAA0B;ECv4pC5B;;ED04pCA;IACE,wBAAwB;EC34pC1B;;ED84pCA;IACE,0BAA0B;EC/4pC5B;;EDk5pCA;IACE,wBAAwB;ECn5pC1B;;EDs5pCA;IACE,0BAA0B;ECv5pC5B;;ED05pCA;IACE,wBAAwB;EC35pC1B;;ED85pCA;IACE,0BAA0B;EC/5pC5B;;EDk6pCA;IACE,wBAAwB;ECn6pC1B;;EDs6pCA;IACE,0BAA0B;ECv6pC5B;;ED06pCA;IACE,wBAAwB;EC36pC1B;;ED86pCA;IACE,0BAA0B;EC/6pC5B;;EDk7pCA;IACE,wBAAwB;ECn7pC1B;;EDs7pCA;IACE,0BAA0B;ECv7pC5B;;ED07pCA;IACE,wBAAwB;EC37pC1B;;ED87pCA;IACE,0BAA0B;EC/7pC5B;;EDk8pCA;IACE,wBAAwB;ECn8pC1B;;EDs8pCA;IACE,0BAA0B;ECv8pC5B;;ED08pCA;IACE,wBAAwB;EC38pC1B;;ED88pCA;IACE,0BAA0B;EC/8pC5B;;EDk9pCA;IACE,wBAAwB;ECn9pC1B;;EDs9pCA;IACE,0BAA0B;ECv9pC5B;;ED09pCA;IACE,wBAAwB;EC39pC1B;;ED89pCA;IACE,0BAA0B;EC/9pC5B;;EDk+pCA;IACE,wBAAwB;ECn+pC1B;;EDs+pCA;IACE,0BAA0B;ECv+pC5B;;ED0+pCA;IACE,wBAAwB;EC3+pC1B;;ED8+pCA;IACE,0BAA0B;EC/+pC5B;;EDk/pCA;IACE,wBAAwB;ECn/pC1B;;EDs/pCA;IACE,0BAA0B;ECv/pC5B;;ED0/pCA;IACE,wBAAwB;EC3/pC1B;;ED8/pCA;IACE,0BAA0B;EC//pC5B;;EDkgqCA;IACE,wBAAwB;ECngqC1B;;EDsgqCA;IACE,0BAA0B;ECvgqC5B;;ED0gqCA;IACE,wBAAwB;EC3gqC1B;;ED8gqCA;IACE,0BAA0B;EC/gqC5B;;EDkhqCA;IACE,wBAAwB;ECnhqC1B;;EDshqCA;IACE,0BAA0B;ECvhqC5B;;ED0hqCA;IACE,wBAAwB;EC3hqC1B;;ED8hqCA;IACE,0BAA0B;EC/hqC5B;;EDkiqCA;IACE,wBAAwB;ECniqC1B;;EDsiqCA;IACE,0BAA0B;ECviqC5B;;ED0iqCA;IACE,wBAAwB;EC3iqC1B;;ED8iqCA;IACE,0BAA0B;EC/iqC5B;;EDkjqCA;IACE,wBAAwB;ECnjqC1B;;EDsjqCA;IACE,0BAA0B;ECvjqC5B;;ED0jqCA;IACE,wBAAwB;EC3jqC1B;;ED8jqCA;IACE,0BAA0B;EC/jqC5B;;EDkkqCA;IACE,wBAAwB;ECnkqC1B;;EDskqCA;IACE,0BAA0B;ECvkqC5B;;ED0kqCA;IACE,wBAAwB;EC3kqC1B;;ED8kqCA;IACE,0BAA0B;EC/kqC5B;;EDklqCA;IACE,wBAAwB;ECnlqC1B;;EDslqCA;IACE,0BAA0B;ECvlqC5B;;ED0lqCA;IACE,wBAAwB;EC3lqC1B;;ED8lqCA;IACE,0BAA0B;EC/lqC5B;;EDkmqCA;IACE,wBAAwB;ECnmqC1B;;EDsmqCA;IACE,0BAA0B;ECvmqC5B;;ED0mqCA;IACE,wBAAwB;EC3mqC1B;;ED8mqCA;IACE,0BAA0B;EC/mqC5B;;EDknqCA;IACE,wBAAwB;ECnnqC1B;;EDsnqCA;IACE,0BAA0B;ECvnqC5B;;ED0nqCA;IACE,wBAAwB;EC3nqC1B;;ED8nqCA;IACE,0BAA0B;EC/nqC5B;;EDkoqCA;IACE,wBAAwB;ECnoqC1B;;EDsoqCA;IACE,0BAA0B;ECvoqC5B;;ED0oqCA;IACE,wBAAwB;EC3oqC1B;;ED8oqCA;IACE,0BAA0B;EC/oqC5B;;EDkpqCA;IACE,wBAAwB;ECnpqC1B;;EDspqCA;IACE,0BAA0B;ECvpqC5B;;ED0pqCA;IACE,wBAAwB;EC3pqC1B;;ED8pqCA;IACE,0BAA0B;EC/pqC5B;;EDkqqCA;IACE,wBAAwB;ECnqqC1B;;EDsqqCA;IACE,0BAA0B;ECvqqC5B;;ED0qqCA;IACE,wBAAwB;EC3qqC1B;;ED8qqCA;IACE,0BAA0B;EC/qqC5B;;EDkrqCA;IACE,wBAAwB;ECnrqC1B;;EDsrqCA;IACE,0BAA0B;ECvrqC5B;;ED0rqCA;IACE,wBAAwB;EC3rqC1B;;ED8rqCA;IACE,0BAA0B;EC/rqC5B;;EDksqCA;IACE,wBAAwB;ECnsqC1B;;EDssqCA;IACE,0BAA0B;ECvsqC5B;;ED0sqCA;IACE,wBAAwB;EC3sqC1B;;ED8sqCA;IACE,0BAA0B;EC/sqC5B;;EDktqCA;IACE,wBAAwB;ECntqC1B;;EDstqCA;IACE,0BAA0B;ECvtqC5B;;ED0tqCA;IACE,wBAAwB;EC3tqC1B;;ED8tqCA;IACE,0BAA0B;EC/tqC5B;;EDkuqCA;IACE,wBAAwB;ECnuqC1B;;EDsuqCA;IACE,0BAA0B;ECvuqC5B;;ED0uqCA;IACE,wBAAwB;EC3uqC1B;;ED8uqCA;IACE,0BAA0B;EC/uqC5B;;EDkvqCA;IACE,wBAAwB;ECnvqC1B;;EDsvqCA;IACE,0BAA0B;ECvvqC5B;;ED0vqCA;IACE,wBAAwB;EC3vqC1B;;ED8vqCA;IACE,0BAA0B;EC/vqC5B;;EDkwqCA;IACE,wBAAwB;ECnwqC1B;;EDswqCA;IACE,0BAA0B;ECvwqC5B;;ED0wqCA;IACE,wBAAwB;EC3wqC1B;;ED8wqCA;IACE,0BAA0B;EC/wqC5B;;EDkxqCA;IACE,wBAAwB;ECnxqC1B;;EDsxqCA;IACE,0BAA0B;ECvxqC5B;;ED0xqCA;IACE,wBAAwB;EC3xqC1B;;ED8xqCA;IACE,0BAA0B;EC/xqC5B;;EDkyqCA;IACE,wBAAwB;ECnyqC1B;;EDsyqCA;IACE,0BAA0B;ECvyqC5B;;ED0yqCA;IACE,wBAAwB;EC3yqC1B;;ED8yqCA;IACE,0BAA0B;EC/yqC5B;;EDkzqCA;IACE,wBAAwB;ECnzqC1B;;EDszqCA;IACE,0BAA0B;ECvzqC5B;;ED0zqCA;IACE,wBAAwB;EC3zqC1B;;ED8zqCA;IACE,0BAA0B;EC/zqC5B;;EDk0qCA;IACE,wBAAwB;ECn0qC1B;;EDs0qCA;IACE,0BAA0B;ECv0qC5B;;ED00qCA;IACE,wBAAwB;EC30qC1B;;ED80qCA;IACE,0BAA0B;EC/0qC5B;;EDk1qCA;IACE,wBAAwB;ECn1qC1B;;EDs1qCA;IACE,0BAA0B;ECv1qC5B;;ED01qCA;IACE,wBAAwB;EC31qC1B;;ED81qCA;IACE,0BAA0B;EC/1qC5B;;EDk2qCA;IACE,wBAAwB;ECn2qC1B;;EDs2qCA;IACE,0BAA0B;ECv2qC5B;;ED02qCA;IACE,wBAAwB;EC32qC1B;;ED82qCA;IACE,0BAA0B;EC/2qC5B;;EDk3qCA;IACE,wBAAwB;ECn3qC1B;;EDs3qCA;IACE,0BAA0B;ECv3qC5B;;ED03qCA;IACE,wBAAwB;EC33qC1B;;ED83qCA;IACE,0BAA0B;EC/3qC5B;;EDk4qCA;IACE,wBAAwB;ECn4qC1B;;EDs4qCA;IACE,0BAA0B;ECv4qC5B;;ED04qCA;IACE,wBAAwB;EC34qC1B;;ED84qCA;IACE,0BAA0B;EC/4qC5B;;EDk5qCA;IACE,wBAAwB;ECn5qC1B;;EDs5qCA;IACE,0BAA0B;ECv5qC5B;;ED05qCA;IACE,wBAAwB;EC35qC1B;;ED85qCA;IACE,0BAA0B;EC54qC5B;;ED+4qCA;IACE,wBAAwB;ECh5qC1B;;EDm5qCA;IACE,0BAA0B;ECp5qC5B;;EDu5qCA;IACE,2BAA2B;ECx5qC7B;;ED25qCA;IACE,8BAA8B;EC55qChC;;ED+5qCA;IACE,6BAA6B;ECh6qC/B;;EDm6qCA;IACE,2BAA2B;ECp6qC7B;;EDu6qCA;IACE,6BAA6B;ECx6qC/B;;ED26qCA;IACE,2BAA2B;EC56qC7B;;ED+6qCA;IACE,6BAA6B;ECh7qC/B;;EDm7qCA;IACE,2BAA2B;ECp7qC7B;;EDu7qCA;IACE,6BAA6B;ECx7qC/B;;ED27qCA;IACE,2BAA2B;EC57qC7B;;ED+7qCA;IACE,6BAA6B;ECh8qC/B;;EDm8qCA;IACE,2BAA2B;ECp8qC7B;;EDu8qCA;IACE,6BAA6B;ECx8qC/B;;ED28qCA;IACE,2BAA2B;EC58qC7B;;ED+8qCA;IACE,6BAA6B;ECh9qC/B;;EDm9qCA;IACE,2BAA2B;ECp9qC7B;;EDu9qCA;IACE,6BAA6B;ECx9qC/B;;ED29qCA;IACE,2BAA2B;EC59qC7B;;ED+9qCA;IACE,6BAA6B;ECh+qC/B;;EDm+qCA;IACE,2BAA2B;ECp+qC7B;;EDu+qCA;IACE,6BAA6B;ECx+qC/B;;ED2+qCA;IACE,4BAA4B;EC5+qC9B;;ED++qCA;IACE,8BAA8B;ECh/qChC;;EDm/qCA;IACE,4BAA4B;ECp/qC9B;;EDu/qCA;IACE,8BAA8B;ECx/qChC;;ED2/qCA;IACE,4BAA4B;EC5/qC9B;;ED+/qCA;IACE,8BAA8B;EChgrChC;;EDmgrCA;IACE,4BAA4B;ECpgrC9B;;EDugrCA;IACE,8BAA8B;ECxgrChC;;ED2grCA;IACE,4BAA4B;EC5grC9B;;ED+grCA;IACE,8BAA8B;EChhrChC;;EDmhrCA;IACE,4BAA4B;ECphrC9B;;EDuhrCA;IACE,8BAA8B;ECxhrChC;;ED2hrCA;IACE,4BAA4B;EC5hrC9B;;ED+hrCA;IACE,8BAA8B;EChirChC;;EDmirCA;IACE,4BAA4B;ECpirC9B;;EDuirCA;IACE,8BAA8B;ECxirChC;;ED2irCA;IACE,4BAA4B;EC5irC9B;;ED+irCA;IACE,8BAA8B;EChjrChC;;EDmjrCA;IACE,4BAA4B;ECpjrC9B;;EDujrCA;IACE,8BAA8B;ECxjrChC;;ED2jrCA;IACE,4BAA4B;EC5jrC9B;;ED+jrCA;IACE,8BAA8B;EChkrChC;;EDmkrCA;IACE,4BAA4B;ECpkrC9B;;EDukrCA;IACE,8BAA8B;ECxkrChC;;ED2krCA;IACE,4BAA4B;EC5krC9B;;ED+krCA;IACE,8BAA8B;EChlrChC;;EDmlrCA;IACE,4BAA4B;ECplrC9B;;EDulrCA;IACE,8BAA8B;ECxlrChC;;ED2lrCA;IACE,4BAA4B;EC5lrC9B;;ED+lrCA;IACE,8BAA8B;EChmrChC;;EDmmrCA;IACE,4BAA4B;ECpmrC9B;;EDumrCA;IACE,8BAA8B;ECxmrChC;;ED2mrCA;IACE,4BAA4B;EC5mrC9B;;ED+mrCA;IACE,8BAA8B;EChnrChC;;EDmnrCA;IACE,4BAA4B;ECpnrC9B;;EDunrCA;IACE,8BAA8B;ECxnrChC;;ED2nrCA;IACE,4BAA4B;EC5nrC9B;;ED+nrCA;IACE,8BAA8B;EChorChC;;EDmorCA;IACE,4BAA4B;ECporC9B;;EDuorCA;IACE,8BAA8B;ECxorChC;;ED2orCA;IACE,4BAA4B;EC5orC9B;;ED+orCA;IACE,8BAA8B;EChprChC;;EDmprCA;IACE,4BAA4B;ECpprC9B;;EDuprCA;IACE,8BAA8B;ECxprChC;;ED2prCA;IACE,4BAA4B;EC5prC9B;;ED+prCA;IACE,8BAA8B;EChqrChC;;EDmqrCA;IACE,4BAA4B;ECpqrC9B;;EDuqrCA;IACE,8BAA8B;ECxqrChC;;ED2qrCA;IACE,4BAA4B;EC5qrC9B;;ED+qrCA;IACE,8BAA8B;EChrrChC;;EDmrrCA;IACE,4BAA4B;ECprrC9B;;EDurrCA;IACE,8BAA8B;ECxrrChC;;ED2rrCA;IACE,4BAA4B;EC5rrC9B;;ED+rrCA;IACE,8BAA8B;EChsrChC;;EDmsrCA;IACE,4BAA4B;ECpsrC9B;;EDusrCA;IACE,8BAA8B;ECxsrChC;;ED2srCA;IACE,4BAA4B;EC5srC9B;;ED+srCA;IACE,8BAA8B;EChtrChC;;EDmtrCA;IACE,4BAA4B;ECptrC9B;;EDutrCA;IACE,8BAA8B;ECxtrChC;;ED2trCA;IACE,4BAA4B;EC5trC9B;;ED+trCA;IACE,8BAA8B;EChurChC;;EDmurCA;IACE,4BAA4B;ECpurC9B;;EDuurCA;IACE,8BAA8B;ECxurChC;;ED2urCA;IACE,4BAA4B;EC5urC9B;;ED+urCA;IACE,8BAA8B;EChvrChC;;EDmvrCA;IACE,4BAA4B;ECpvrC9B;;EDuvrCA;IACE,8BAA8B;ECxvrChC;;ED2vrCA;IACE,4BAA4B;EC5vrC9B;;ED+vrCA;IACE,8BAA8B;EChwrChC;;EDmwrCA;IACE,4BAA4B;ECpwrC9B;;EDuwrCA;IACE,8BAA8B;ECxwrChC;;ED2wrCA;IACE,4BAA4B;EC5wrC9B;;ED+wrCA;IACE,8BAA8B;EChxrChC;;EDmxrCA;IACE,4BAA4B;ECpxrC9B;;EDuxrCA;IACE,8BAA8B;ECxxrChC;;ED2xrCA;IACE,4BAA4B;EC5xrC9B;;ED+xrCA;IACE,8BAA8B;EChyrChC;;EDmyrCA;IACE,4BAA4B;ECpyrC9B;;EDuyrCA;IACE,8BAA8B;ECxyrChC;;ED2yrCA;IACE,4BAA4B;EC5yrC9B;;ED+yrCA;IACE,8BAA8B;EChzrChC;;EDmzrCA;IACE,4BAA4B;ECpzrC9B;;EDuzrCA;IACE,8BAA8B;ECxzrChC;;ED2zrCA;IACE,4BAA4B;EC5zrC9B;;ED+zrCA;IACE,8BAA8B;ECh0rChC;;EDm0rCA;IACE,4BAA4B;ECp0rC9B;;EDu0rCA;IACE,8BAA8B;ECx0rChC;;ED20rCA;IACE,4BAA4B;EC50rC9B;;ED+0rCA;IACE,8BAA8B;ECh1rChC;;EDm1rCA;IACE,4BAA4B;ECp1rC9B;;EDu1rCA;IACE,8BAA8B;ECx1rChC;;ED21rCA;IACE,4BAA4B;EC51rC9B;;ED+1rCA;IACE,8BAA8B;ECh2rChC;;EDm2rCA;IACE,4BAA4B;ECp2rC9B;;EDu2rCA;IACE,8BAA8B;ECx2rChC;;ED22rCA;IACE,4BAA4B;EC52rC9B;;ED+2rCA;IACE,8BAA8B;ECh3rChC;;EDm3rCA;IACE,4BAA4B;ECp3rC9B;;EDu3rCA;IACE,8BAA8B;ECx3rChC;;ED23rCA;IACE,4BAA4B;EC53rC9B;;ED+3rCA;IACE,8BAA8B;ECh4rChC;;EDm4rCA;IACE,4BAA4B;ECp4rC9B;;EDu4rCA;IACE,8BAA8B;ECx4rChC;;ED24rCA;IACE,4BAA4B;EC54rC9B;;ED+4rCA;IACE,8BAA8B;ECh5rChC;;EDm5rCA;IACE,4BAA4B;ECp5rC9B;;EDu5rCA;IACE,8BAA8B;ECx5rChC;;ED25rCA;IACE,4BAA4B;EC55rC9B;;ED+5rCA;IACE,8BAA8B;ECh6rChC;;EDm6rCA;IACE,4BAA4B;ECp6rC9B;;EDu6rCA;IACE,8BAA8B;ECx6rChC;;ED26rCA;IACE,4BAA4B;EC56rC9B;;ED+6rCA;IACE,8BAA8B;ECh7rChC;;EDm7rCA;IACE,4BAA4B;ECp7rC9B;;EDu7rCA;IACE,8BAA8B;ECx7rChC;;ED27rCA;IACE,4BAA4B;EC57rC9B;;ED+7rCA;IACE,8BAA8B;ECh8rChC;;EDm8rCA;IACE,4BAA4B;ECp8rC9B;;EDu8rCA;IACE,8BAA8B;ECx8rChC;;ED28rCA;IACE,4BAA4B;EC58rC9B;;ED+8rCA;IACE,8BAA8B;ECh9rChC;;EDm9rCA;IACE,4BAA4B;ECp9rC9B;;EDu9rCA;IACE,8BAA8B;ECx9rChC;;ED29rCA;IACE,4BAA4B;EC59rC9B;;ED+9rCA;IACE,8BAA8B;ECh+rChC;;EDm+rCA;IACE,4BAA4B;ECp+rC9B;;EDu+rCA;IACE,8BAA8B;ECx+rChC;;ED2+rCA;IACE,4BAA4B;EC5+rC9B;;ED++rCA;IACE,8BAA8B;ECh/rChC;;EDm/rCA;IACE,4BAA4B;ECp/rC9B;;EDu/rCA;IACE,8BAA8B;ECx/rChC;;ED2/rCA;IACE,4BAA4B;EC5/rC9B;;ED+/rCA;IACE,8BAA8B;EChgsChC;;EDmgsCA;IACE,4BAA4B;ECpgsC9B;;EDugsCA;IACE,8BAA8B;ECxgsChC;;ED2gsCA;IACE,4BAA4B;EC5gsC9B;;ED+gsCA;IACE,8BAA8B;EC7/rChC;;EDggsCA;IACE,4BAA4B;ECjgsC9B;;EDogsCA;IACE,8BAA8B;ECrgsChC;;EDwgsCA;IACE,8BAA8B;ECzgsChC;;ED4gsCA;IACE,iCAAiC;EC7gsCnC;;EDghsCA;IACE,gCAAgC;ECjhsClC;;EDohsCA;IACE,8BAA8B;ECrhsChC;;EDwhsCA;IACE,gCAAgC;ECzhsClC;;ED4hsCA;IACE,8BAA8B;EC7hsChC;;EDgisCA;IACE,gCAAgC;ECjisClC;;EDoisCA;IACE,8BAA8B;ECrisChC;;EDwisCA;IACE,gCAAgC;ECzisClC;;ED4isCA;IACE,8BAA8B;EC7isChC;;EDgjsCA;IACE,gCAAgC;ECjjsClC;;EDojsCA;IACE,8BAA8B;ECrjsChC;;EDwjsCA;IACE,gCAAgC;ECzjsClC;;ED4jsCA;IACE,8BAA8B;EC7jsChC;;EDgksCA;IACE,gCAAgC;ECjksClC;;EDoksCA;IACE,8BAA8B;ECrksChC;;EDwksCA;IACE,gCAAgC;ECzksClC;;ED4ksCA;IACE,8BAA8B;EC7ksChC;;EDglsCA;IACE,gCAAgC;ECjlsClC;;EDolsCA;IACE,8BAA8B;ECrlsChC;;EDwlsCA;IACE,gCAAgC;ECzlsClC;;ED4lsCA;IACE,+BAA+B;EC7lsCjC;;EDgmsCA;IACE,iCAAiC;ECjmsCnC;;EDomsCA;IACE,+BAA+B;ECrmsCjC;;EDwmsCA;IACE,iCAAiC;ECzmsCnC;;ED4msCA;IACE,+BAA+B;EC7msCjC;;EDgnsCA;IACE,iCAAiC;ECjnsCnC;;EDonsCA;IACE,+BAA+B;ECrnsCjC;;EDwnsCA;IACE,iCAAiC;ECznsCnC;;ED4nsCA;IACE,+BAA+B;EC7nsCjC;;EDgosCA;IACE,iCAAiC;ECjosCnC;;EDoosCA;IACE,+BAA+B;ECrosCjC;;EDwosCA;IACE,iCAAiC;ECzosCnC;;ED4osCA;IACE,+BAA+B;EC7osCjC;;EDgpsCA;IACE,iCAAiC;ECjpsCnC;;EDopsCA;IACE,+BAA+B;ECrpsCjC;;EDwpsCA;IACE,iCAAiC;ECzpsCnC;;ED4psCA;IACE,+BAA+B;EC7psCjC;;EDgqsCA;IACE,iCAAiC;ECjqsCnC;;EDoqsCA;IACE,+BAA+B;ECrqsCjC;;EDwqsCA;IACE,iCAAiC;ECzqsCnC;;ED4qsCA;IACE,+BAA+B;EC7qsCjC;;EDgrsCA;IACE,iCAAiC;ECjrsCnC;;EDorsCA;IACE,+BAA+B;ECrrsCjC;;EDwrsCA;IACE,iCAAiC;ECzrsCnC;;ED4rsCA;IACE,+BAA+B;EC7rsCjC;;EDgssCA;IACE,iCAAiC;ECjssCnC;;EDossCA;IACE,+BAA+B;ECrssCjC;;EDwssCA;IACE,iCAAiC;ECzssCnC;;ED4ssCA;IACE,+BAA+B;EC7ssCjC;;EDgtsCA;IACE,iCAAiC;ECjtsCnC;;EDotsCA;IACE,+BAA+B;ECrtsCjC;;EDwtsCA;IACE,iCAAiC;ECztsCnC;;ED4tsCA;IACE,+BAA+B;EC7tsCjC;;EDgusCA;IACE,iCAAiC;ECjusCnC;;EDousCA;IACE,+BAA+B;ECrusCjC;;EDwusCA;IACE,iCAAiC;ECzusCnC;;ED4usCA;IACE,+BAA+B;EC7usCjC;;EDgvsCA;IACE,iCAAiC;ECjvsCnC;;EDovsCA;IACE,+BAA+B;ECrvsCjC;;EDwvsCA;IACE,iCAAiC;ECzvsCnC;;ED4vsCA;IACE,+BAA+B;EC7vsCjC;;EDgwsCA;IACE,iCAAiC;ECjwsCnC;;EDowsCA;IACE,+BAA+B;ECrwsCjC;;EDwwsCA;IACE,iCAAiC;ECzwsCnC;;ED4wsCA;IACE,+BAA+B;EC7wsCjC;;EDgxsCA;IACE,iCAAiC;ECjxsCnC;;EDoxsCA;IACE,+BAA+B;ECrxsCjC;;EDwxsCA;IACE,iCAAiC;ECzxsCnC;;ED4xsCA;IACE,+BAA+B;EC7xsCjC;;EDgysCA;IACE,iCAAiC;ECjysCnC;;EDoysCA;IACE,+BAA+B;ECrysCjC;;EDwysCA;IACE,iCAAiC;ECzysCnC;;ED4ysCA;IACE,+BAA+B;EC7ysCjC;;EDgzsCA;IACE,iCAAiC;ECjzsCnC;;EDozsCA;IACE,+BAA+B;ECrzsCjC;;EDwzsCA;IACE,iCAAiC;ECzzsCnC;;ED4zsCA;IACE,+BAA+B;EC7zsCjC;;EDg0sCA;IACE,iCAAiC;ECj0sCnC;;EDo0sCA;IACE,+BAA+B;ECr0sCjC;;EDw0sCA;IACE,iCAAiC;ECz0sCnC;;ED40sCA;IACE,+BAA+B;EC70sCjC;;EDg1sCA;IACE,iCAAiC;ECj1sCnC;;EDo1sCA;IACE,+BAA+B;ECr1sCjC;;EDw1sCA;IACE,iCAAiC;ECz1sCnC;;ED41sCA;IACE,+BAA+B;EC71sCjC;;EDg2sCA;IACE,iCAAiC;ECj2sCnC;;EDo2sCA;IACE,+BAA+B;ECr2sCjC;;EDw2sCA;IACE,iCAAiC;ECz2sCnC;;ED42sCA;IACE,+BAA+B;EC72sCjC;;EDg3sCA;IACE,iCAAiC;ECj3sCnC;;EDo3sCA;IACE,+BAA+B;ECr3sCjC;;EDw3sCA;IACE,iCAAiC;ECz3sCnC;;ED43sCA;IACE,+BAA+B;EC73sCjC;;EDg4sCA;IACE,iCAAiC;ECj4sCnC;;EDo4sCA;IACE,+BAA+B;ECr4sCjC;;EDw4sCA;IACE,iCAAiC;ECz4sCnC;;ED44sCA;IACE,+BAA+B;EC74sCjC;;EDg5sCA;IACE,iCAAiC;ECj5sCnC;;EDo5sCA;IACE,+BAA+B;ECr5sCjC;;EDw5sCA;IACE,iCAAiC;ECz5sCnC;;ED45sCA;IACE,+BAA+B;EC75sCjC;;EDg6sCA;IACE,iCAAiC;ECj6sCnC;;EDo6sCA;IACE,+BAA+B;ECr6sCjC;;EDw6sCA;IACE,iCAAiC;ECz6sCnC;;ED46sCA;IACE,+BAA+B;EC76sCjC;;EDg7sCA;IACE,iCAAiC;ECj7sCnC;;EDo7sCA;IACE,+BAA+B;ECr7sCjC;;EDw7sCA;IACE,iCAAiC;ECz7sCnC;;ED47sCA;IACE,+BAA+B;EC77sCjC;;EDg8sCA;IACE,iCAAiC;ECj8sCnC;;EDo8sCA;IACE,+BAA+B;ECr8sCjC;;EDw8sCA;IACE,iCAAiC;ECz8sCnC;;ED48sCA;IACE,+BAA+B;EC78sCjC;;EDg9sCA;IACE,iCAAiC;ECj9sCnC;;EDo9sCA;IACE,+BAA+B;ECr9sCjC;;EDw9sCA;IACE,iCAAiC;ECz9sCnC;;ED49sCA;IACE,+BAA+B;EC79sCjC;;EDg+sCA;IACE,iCAAiC;ECj+sCnC;;EDo+sCA;IACE,+BAA+B;ECr+sCjC;;EDw+sCA;IACE,iCAAiC;ECz+sCnC;;ED4+sCA;IACE,+BAA+B;EC7+sCjC;;EDg/sCA;IACE,iCAAiC;ECj/sCnC;;EDo/sCA;IACE,+BAA+B;ECr/sCjC;;EDw/sCA;IACE,iCAAiC;ECz/sCnC;;ED4/sCA;IACE,+BAA+B;EC7/sCjC;;EDggtCA;IACE,iCAAiC;ECjgtCnC;;EDogtCA;IACE,+BAA+B;ECrgtCjC;;EDwgtCA;IACE,iCAAiC;ECzgtCnC;;ED4gtCA;IACE,+BAA+B;EC7gtCjC;;EDghtCA;IACE,iCAAiC;ECjhtCnC;;EDohtCA;IACE,+BAA+B;ECrhtCjC;;EDwhtCA;IACE,iCAAiC;ECzhtCnC;;ED4htCA;IACE,+BAA+B;EC7htCjC;;EDgitCA;IACE,iCAAiC;ECjitCnC;;EDoitCA;IACE,+BAA+B;ECritCjC;;EDwitCA;IACE,iCAAiC;ECzitCnC;;ED4itCA;IACE,+BAA+B;EC7itCjC;;EDgjtCA;IACE,iCAAiC;ECjjtCnC;;EDojtCA;IACE,+BAA+B;ECrjtCjC;;EDwjtCA;IACE,iCAAiC;ECzjtCnC;;ED4jtCA;IACE,+BAA+B;EC7jtCjC;;EDgktCA;IACE,iCAAiC;ECjktCnC;;EDoktCA;IACE,+BAA+B;ECrktCjC;;EDwktCA;IACE,iCAAiC;ECzktCnC;;ED4ktCA;IACE,+BAA+B;EC7ktCjC;;EDgltCA;IACE,iCAAiC;ECjltCnC;;EDoltCA;IACE,+BAA+B;ECrltCjC;;EDwltCA;IACE,iCAAiC;ECzltCnC;;ED4ltCA;IACE,+BAA+B;EC7ltCjC;;EDgmtCA;IACE,iCAAiC;ECjmtCnC;;EDomtCA;IACE,+BAA+B;ECrmtCjC;;EDwmtCA;IACE,iCAAiC;ECzmtCnC;;ED4mtCA;IACE,+BAA+B;EC7mtCjC;;EDgntCA;IACE,iCAAiC;ECjntCnC;;EDontCA;IACE,+BAA+B;ECrntCjC;;EDwntCA;IACE,iCAAiC;ECzntCnC;;ED4ntCA;IACE,+BAA+B;EC7ntCjC;;EDgotCA;IACE,iCAAiC;EC9mtCnC;;EDintCA;IACE,+BAA+B;EClntCjC;;EDqntCA;IACE,iCAAiC;ECtntCnC;;EDyntCA;IACE,4BAA4B;EC1ntC9B;;ED6ntCA;IACE,+BAA+B;EC9ntCjC;;EDiotCA;IACE,8BAA8B;EClotChC;;EDqotCA;IACE,4BAA4B;ECtotC9B;;EDyotCA;IACE,8BAA8B;EC1otChC;;ED6otCA;IACE,4BAA4B;EC9otC9B;;EDiptCA;IACE,8BAA8B;EClptChC;;EDqptCA;IACE,4BAA4B;ECtptC9B;;EDyptCA;IACE,8BAA8B;EC1ptChC;;ED6ptCA;IACE,4BAA4B;EC9ptC9B;;EDiqtCA;IACE,8BAA8B;EClqtChC;;EDqqtCA;IACE,4BAA4B;ECtqtC9B;;EDyqtCA;IACE,8BAA8B;EC1qtChC;;ED6qtCA;IACE,4BAA4B;EC9qtC9B;;EDirtCA;IACE,8BAA8B;EClrtChC;;EDqrtCA;IACE,4BAA4B;ECtrtC9B;;EDyrtCA;IACE,8BAA8B;EC1rtChC;;ED6rtCA;IACE,4BAA4B;EC9rtC9B;;EDistCA;IACE,8BAA8B;EClstChC;;EDqstCA;IACE,4BAA4B;ECtstC9B;;EDystCA;IACE,8BAA8B;EC1stChC;;ED6stCA;IACE,6BAA6B;EC9stC/B;;EDittCA;IACE,+BAA+B;EClttCjC;;EDqttCA;IACE,6BAA6B;ECtttC/B;;EDyttCA;IACE,+BAA+B;EC1ttCjC;;ED6ttCA;IACE,6BAA6B;EC9ttC/B;;EDiutCA;IACE,+BAA+B;EClutCjC;;EDqutCA;IACE,6BAA6B;ECtutC/B;;EDyutCA;IACE,+BAA+B;EC1utCjC;;ED6utCA;IACE,6BAA6B;EC9utC/B;;EDivtCA;IACE,+BAA+B;EClvtCjC;;EDqvtCA;IACE,6BAA6B;ECtvtC/B;;EDyvtCA;IACE,+BAA+B;EC1vtCjC;;ED6vtCA;IACE,6BAA6B;EC9vtC/B;;EDiwtCA;IACE,+BAA+B;EClwtCjC;;EDqwtCA;IACE,6BAA6B;ECtwtC/B;;EDywtCA;IACE,+BAA+B;EC1wtCjC;;ED6wtCA;IACE,6BAA6B;EC9wtC/B;;EDixtCA;IACE,+BAA+B;EClxtCjC;;EDqxtCA;IACE,6BAA6B;ECtxtC/B;;EDyxtCA;IACE,+BAA+B;EC1xtCjC;;ED6xtCA;IACE,6BAA6B;EC9xtC/B;;EDiytCA;IACE,+BAA+B;EClytCjC;;EDqytCA;IACE,6BAA6B;ECtytC/B;;EDyytCA;IACE,+BAA+B;EC1ytCjC;;ED6ytCA;IACE,6BAA6B;EC9ytC/B;;EDiztCA;IACE,+BAA+B;EClztCjC;;EDqztCA;IACE,6BAA6B;ECtztC/B;;EDyztCA;IACE,+BAA+B;EC1ztCjC;;ED6ztCA;IACE,6BAA6B;EC9ztC/B;;EDi0tCA;IACE,+BAA+B;ECl0tCjC;;EDq0tCA;IACE,6BAA6B;ECt0tC/B;;EDy0tCA;IACE,+BAA+B;EC10tCjC;;ED60tCA;IACE,6BAA6B;EC90tC/B;;EDi1tCA;IACE,+BAA+B;ECl1tCjC;;EDq1tCA;IACE,6BAA6B;ECt1tC/B;;EDy1tCA;IACE,+BAA+B;EC11tCjC;;ED61tCA;IACE,6BAA6B;EC91tC/B;;EDi2tCA;IACE,+BAA+B;ECl2tCjC;;EDq2tCA;IACE,6BAA6B;ECt2tC/B;;EDy2tCA;IACE,+BAA+B;EC12tCjC;;ED62tCA;IACE,6BAA6B;EC92tC/B;;EDi3tCA;IACE,+BAA+B;ECl3tCjC;;EDq3tCA;IACE,6BAA6B;ECt3tC/B;;EDy3tCA;IACE,+BAA+B;EC13tCjC;;ED63tCA;IACE,6BAA6B;EC93tC/B;;EDi4tCA;IACE,+BAA+B;ECl4tCjC;;EDq4tCA;IACE,6BAA6B;ECt4tC/B;;EDy4tCA;IACE,+BAA+B;EC14tCjC;;ED64tCA;IACE,6BAA6B;EC94tC/B;;EDi5tCA;IACE,+BAA+B;ECl5tCjC;;EDq5tCA;IACE,6BAA6B;ECt5tC/B;;EDy5tCA;IACE,+BAA+B;EC15tCjC;;ED65tCA;IACE,6BAA6B;EC95tC/B;;EDi6tCA;IACE,+BAA+B;ECl6tCjC;;EDq6tCA;IACE,6BAA6B;ECt6tC/B;;EDy6tCA;IACE,+BAA+B;EC16tCjC;;ED66tCA;IACE,6BAA6B;EC96tC/B;;EDi7tCA;IACE,+BAA+B;ECl7tCjC;;EDq7tCA;IACE,6BAA6B;ECt7tC/B;;EDy7tCA;IACE,+BAA+B;EC17tCjC;;ED67tCA;IACE,6BAA6B;EC97tC/B;;EDi8tCA;IACE,+BAA+B;ECl8tCjC;;EDq8tCA;IACE,6BAA6B;ECt8tC/B;;EDy8tCA;IACE,+BAA+B;EC18tCjC;;ED68tCA;IACE,6BAA6B;EC98tC/B;;EDi9tCA;IACE,+BAA+B;ECl9tCjC;;EDq9tCA;IACE,6BAA6B;ECt9tC/B;;EDy9tCA;IACE,+BAA+B;EC19tCjC;;ED69tCA;IACE,6BAA6B;EC99tC/B;;EDi+tCA;IACE,+BAA+B;ECl+tCjC;;EDq+tCA;IACE,6BAA6B;ECt+tC/B;;EDy+tCA;IACE,+BAA+B;EC1+tCjC;;ED6+tCA;IACE,6BAA6B;EC9+tC/B;;EDi/tCA;IACE,+BAA+B;ECl/tCjC;;EDq/tCA;IACE,6BAA6B;ECt/tC/B;;EDy/tCA;IACE,+BAA+B;EC1/tCjC;;ED6/tCA;IACE,6BAA6B;EC9/tC/B;;EDiguCA;IACE,+BAA+B;EClguCjC;;EDqguCA;IACE,6BAA6B;ECtguC/B;;EDyguCA;IACE,+BAA+B;EC1guCjC;;ED6guCA;IACE,6BAA6B;EC9guC/B;;EDihuCA;IACE,+BAA+B;EClhuCjC;;EDqhuCA;IACE,6BAA6B;ECthuC/B;;EDyhuCA;IACE,+BAA+B;EC1huCjC;;ED6huCA;IACE,6BAA6B;EC9huC/B;;EDiiuCA;IACE,+BAA+B;ECliuCjC;;EDqiuCA;IACE,6BAA6B;ECtiuC/B;;EDyiuCA;IACE,+BAA+B;EC1iuCjC;;ED6iuCA;IACE,6BAA6B;EC9iuC/B;;EDijuCA;IACE,+BAA+B;ECljuCjC;;EDqjuCA;IACE,6BAA6B;ECtjuC/B;;EDyjuCA;IACE,+BAA+B;EC1juCjC;;ED6juCA;IACE,6BAA6B;EC9juC/B;;EDikuCA;IACE,+BAA+B;EClkuCjC;;EDqkuCA;IACE,6BAA6B;ECtkuC/B;;EDykuCA;IACE,+BAA+B;EC1kuCjC;;ED6kuCA;IACE,6BAA6B;EC9kuC/B;;EDiluCA;IACE,+BAA+B;EClluCjC;;EDqluCA;IACE,6BAA6B;ECtluC/B;;EDyluCA;IACE,+BAA+B;EC1luCjC;;ED6luCA;IACE,6BAA6B;EC9luC/B;;EDimuCA;IACE,+BAA+B;EClmuCjC;;EDqmuCA;IACE,6BAA6B;ECtmuC/B;;EDymuCA;IACE,+BAA+B;EC1muCjC;;ED6muCA;IACE,6BAA6B;EC9muC/B;;EDinuCA;IACE,+BAA+B;EClnuCjC;;EDqnuCA;IACE,6BAA6B;ECtnuC/B;;EDynuCA;IACE,+BAA+B;EC1nuCjC;;ED6nuCA;IACE,6BAA6B;EC9nuC/B;;EDiouCA;IACE,+BAA+B;EClouCjC;;EDqouCA;IACE,6BAA6B;ECtouC/B;;EDyouCA;IACE,+BAA+B;EC1ouCjC;;ED6ouCA;IACE,6BAA6B;EC9ouC/B;;EDipuCA;IACE,+BAA+B;EClpuCjC;;EDqpuCA;IACE,6BAA6B;ECtpuC/B;;EDypuCA;IACE,+BAA+B;EC1puCjC;;ED6puCA;IACE,6BAA6B;EC9puC/B;;EDiquCA;IACE,+BAA+B;EClquCjC;;EDqquCA;IACE,6BAA6B;ECtquC/B;;EDyquCA;IACE,+BAA+B;EC1quCjC;;ED6quCA;IACE,6BAA6B;EC9quC/B;;EDiruCA;IACE,+BAA+B;EClruCjC;;EDqruCA;IACE,6BAA6B;ECtruC/B;;EDyruCA;IACE,+BAA+B;EC1ruCjC;;ED6ruCA;IACE,6BAA6B;EC9ruC/B;;EDisuCA;IACE,+BAA+B;EClsuCjC;;EDqsuCA;IACE,6BAA6B;ECtsuC/B;;EDysuCA;IACE,+BAA+B;EC1suCjC;;ED6suCA;IACE,6BAA6B;EC9suC/B;;EDituCA;IACE,+BAA+B;ECltuCjC;;EDqtuCA;IACE,6BAA6B;ECttuC/B;;EDytuCA;IACE,+BAA+B;EC1tuCjC;;ED6tuCA;IACE,6BAA6B;EC9tuC/B;;EDiuuCA;IACE,+BAA+B;ECluuCjC;;EDquuCA;IACE,6BAA6B;ECtuuC/B;;EDyuuCA;IACE,+BAA+B;EC1uuCjC;;ED6uuCA;IACE,6BAA6B;EC9uuC/B;;EDivuCA;IACE,+BAA+B;EC/tuCjC;;EDkuuCA;IACE,6BAA6B;ECnuuC/B;;EDsuuCA;IACE,+BAA+B;ECvuuCjC;;ED0uuCA;IACE,6BAA6B;EC3uuC/B;;ED8uuCA;IACE,gCAAgC;EC/uuClC;;EDkvuCA;IACE,+BAA+B;ECnvuCjC;;EDsvuCA;IACE,6BAA6B;ECvvuC/B;;ED0vuCA;IACE,+BAA+B;EC3vuCjC;;ED8vuCA;IACE,6BAA6B;EC/vuC/B;;EDkwuCA;IACE,+BAA+B;ECnwuCjC;;EDswuCA;IACE,6BAA6B;ECvwuC/B;;ED0wuCA;IACE,+BAA+B;EC3wuCjC;;ED8wuCA;IACE,6BAA6B;EC/wuC/B;;EDkxuCA;IACE,+BAA+B;ECnxuCjC;;EDsxuCA;IACE,6BAA6B;ECvxuC/B;;ED0xuCA;IACE,+BAA+B;EC3xuCjC;;ED8xuCA;IACE,6BAA6B;EC/xuC/B;;EDkyuCA;IACE,+BAA+B;ECnyuCjC;;EDsyuCA;IACE,6BAA6B;ECvyuC/B;;ED0yuCA;IACE,+BAA+B;EC3yuCjC;;ED8yuCA;IACE,6BAA6B;EC/yuC/B;;EDkzuCA;IACE,+BAA+B;ECnzuCjC;;EDszuCA;IACE,6BAA6B;ECvzuC/B;;ED0zuCA;IACE,+BAA+B;EC3zuCjC;;ED8zuCA;IACE,8BAA8B;EC/zuChC;;EDk0uCA;IACE,gCAAgC;ECn0uClC;;EDs0uCA;IACE,8BAA8B;ECv0uChC;;ED00uCA;IACE,gCAAgC;EC30uClC;;ED80uCA;IACE,8BAA8B;EC/0uChC;;EDk1uCA;IACE,gCAAgC;ECn1uClC;;EDs1uCA;IACE,8BAA8B;ECv1uChC;;ED01uCA;IACE,gCAAgC;EC31uClC;;ED81uCA;IACE,8BAA8B;EC/1uChC;;EDk2uCA;IACE,gCAAgC;ECn2uClC;;EDs2uCA;IACE,8BAA8B;ECv2uChC;;ED02uCA;IACE,gCAAgC;EC32uClC;;ED82uCA;IACE,8BAA8B;EC/2uChC;;EDk3uCA;IACE,gCAAgC;ECn3uClC;;EDs3uCA;IACE,8BAA8B;ECv3uChC;;ED03uCA;IACE,gCAAgC;EC33uClC;;ED83uCA;IACE,8BAA8B;EC/3uChC;;EDk4uCA;IACE,gCAAgC;ECn4uClC;;EDs4uCA;IACE,8BAA8B;ECv4uChC;;ED04uCA;IACE,gCAAgC;EC34uClC;;ED84uCA;IACE,8BAA8B;EC/4uChC;;EDk5uCA;IACE,gCAAgC;ECn5uClC;;EDs5uCA;IACE,8BAA8B;ECv5uChC;;ED05uCA;IACE,gCAAgC;EC35uClC;;ED85uCA;IACE,8BAA8B;EC/5uChC;;EDk6uCA;IACE,gCAAgC;ECn6uClC;;EDs6uCA;IACE,8BAA8B;ECv6uChC;;ED06uCA;IACE,gCAAgC;EC36uClC;;ED86uCA;IACE,8BAA8B;EC/6uChC;;EDk7uCA;IACE,gCAAgC;ECn7uClC;;EDs7uCA;IACE,8BAA8B;ECv7uChC;;ED07uCA;IACE,gCAAgC;EC37uClC;;ED87uCA;IACE,8BAA8B;EC/7uChC;;EDk8uCA;IACE,gCAAgC;ECn8uClC;;EDs8uCA;IACE,8BAA8B;ECv8uChC;;ED08uCA;IACE,gCAAgC;EC38uClC;;ED88uCA;IACE,8BAA8B;EC/8uChC;;EDk9uCA;IACE,gCAAgC;ECn9uClC;;EDs9uCA;IACE,8BAA8B;ECv9uChC;;ED09uCA;IACE,gCAAgC;EC39uClC;;ED89uCA;IACE,8BAA8B;EC/9uChC;;EDk+uCA;IACE,gCAAgC;ECn+uClC;;EDs+uCA;IACE,8BAA8B;ECv+uChC;;ED0+uCA;IACE,gCAAgC;EC3+uClC;;ED8+uCA;IACE,8BAA8B;EC/+uChC;;EDk/uCA;IACE,gCAAgC;ECn/uClC;;EDs/uCA;IACE,8BAA8B;ECv/uChC;;ED0/uCA;IACE,gCAAgC;EC3/uClC;;ED8/uCA;IACE,8BAA8B;EC//uChC;;EDkgvCA;IACE,gCAAgC;ECngvClC;;EDsgvCA;IACE,8BAA8B;ECvgvChC;;ED0gvCA;IACE,gCAAgC;EC3gvClC;;ED8gvCA;IACE,8BAA8B;EC/gvChC;;EDkhvCA;IACE,gCAAgC;ECnhvClC;;EDshvCA;IACE,8BAA8B;ECvhvChC;;ED0hvCA;IACE,gCAAgC;EC3hvClC;;ED8hvCA;IACE,8BAA8B;EC/hvChC;;EDkivCA;IACE,gCAAgC;ECnivClC;;EDsivCA;IACE,8BAA8B;ECvivChC;;ED0ivCA;IACE,gCAAgC;EC3ivClC;;ED8ivCA;IACE,8BAA8B;EC/ivChC;;EDkjvCA;IACE,gCAAgC;ECnjvClC;;EDsjvCA;IACE,8BAA8B;ECvjvChC;;ED0jvCA;IACE,gCAAgC;EC3jvClC;;ED8jvCA;IACE,8BAA8B;EC/jvChC;;EDkkvCA;IACE,gCAAgC;ECnkvClC;;EDskvCA;IACE,8BAA8B;ECvkvChC;;ED0kvCA;IACE,gCAAgC;EC3kvClC;;ED8kvCA;IACE,8BAA8B;EC/kvChC;;EDklvCA;IACE,gCAAgC;ECnlvClC;;EDslvCA;IACE,8BAA8B;ECvlvChC;;ED0lvCA;IACE,gCAAgC;EC3lvClC;;ED8lvCA;IACE,8BAA8B;EC/lvChC;;EDkmvCA;IACE,gCAAgC;ECnmvClC;;EDsmvCA;IACE,8BAA8B;ECvmvChC;;ED0mvCA;IACE,gCAAgC;EC3mvClC;;ED8mvCA;IACE,8BAA8B;EC/mvChC;;EDknvCA;IACE,gCAAgC;ECnnvClC;;EDsnvCA;IACE,8BAA8B;ECvnvChC;;ED0nvCA;IACE,gCAAgC;EC3nvClC;;ED8nvCA;IACE,8BAA8B;EC/nvChC;;EDkovCA;IACE,gCAAgC;ECnovClC;;EDsovCA;IACE,8BAA8B;ECvovChC;;ED0ovCA;IACE,gCAAgC;EC3ovClC;;ED8ovCA;IACE,8BAA8B;EC/ovChC;;EDkpvCA;IACE,gCAAgC;ECnpvClC;;EDspvCA;IACE,8BAA8B;ECvpvChC;;ED0pvCA;IACE,gCAAgC;EC3pvClC;;ED8pvCA;IACE,8BAA8B;EC/pvChC;;EDkqvCA;IACE,gCAAgC;ECnqvClC;;EDsqvCA;IACE,8BAA8B;ECvqvChC;;ED0qvCA;IACE,gCAAgC;EC3qvClC;;ED8qvCA;IACE,8BAA8B;EC/qvChC;;EDkrvCA;IACE,gCAAgC;ECnrvClC;;EDsrvCA;IACE,8BAA8B;ECvrvChC;;ED0rvCA;IACE,gCAAgC;EC3rvClC;;ED8rvCA;IACE,8BAA8B;EC/rvChC;;EDksvCA;IACE,gCAAgC;ECnsvClC;;EDssvCA;IACE,8BAA8B;ECvsvChC;;ED0svCA;IACE,gCAAgC;EC3svClC;;ED8svCA;IACE,8BAA8B;EC/svChC;;EDktvCA;IACE,gCAAgC;ECntvClC;;EDstvCA;IACE,8BAA8B;ECvtvChC;;ED0tvCA;IACE,gCAAgC;EC3tvClC;;ED8tvCA;IACE,8BAA8B;EC/tvChC;;EDkuvCA;IACE,gCAAgC;ECnuvClC;;EDsuvCA;IACE,8BAA8B;ECvuvChC;;ED0uvCA;IACE,gCAAgC;EC3uvClC;;ED8uvCA;IACE,8BAA8B;EC/uvChC;;EDkvvCA;IACE,gCAAgC;ECnvvClC;;EDsvvCA;IACE,8BAA8B;ECvvvChC;;ED0vvCA;IACE,gCAAgC;EC3vvClC;;ED8vvCA;IACE,8BAA8B;EC/vvChC;;EDkwvCA;IACE,gCAAgC;ECnwvClC;;EDswvCA;IACE,8BAA8B;ECvwvChC;;ED0wvCA;IACE,gCAAgC;EC3wvClC;;ED8wvCA;IACE,8BAA8B;EC/wvChC;;EDkxvCA;IACE,gCAAgC;ECnxvClC;;EDsxvCA;IACE,8BAA8B;ECvxvChC;;ED0xvCA;IACE,gCAAgC;EC3xvClC;;ED8xvCA;IACE,8BAA8B;EC/xvChC;;EDkyvCA;IACE,gCAAgC;ECnyvClC;;EDsyvCA;IACE,8BAA8B;ECvyvChC;;ED0yvCA;IACE,gCAAgC;EC3yvClC;;ED8yvCA;IACE,8BAA8B;EC/yvChC;;EDkzvCA;IACE,gCAAgC;ECnzvClC;;EDszvCA;IACE,8BAA8B;ECvzvChC;;ED0zvCA;IACE,gCAAgC;EC3zvClC;;ED8zvCA;IACE,8BAA8B;EC/zvChC;;EDk0vCA;IACE,gCAAgC;ECn0vClC;;EDs0vCA;IACE,8BAA8B;ECv0vChC;;ED00vCA;IACE,gCAAgC;EC30vClC;;ED80vCA;IACE,8BAA8B;EC/0vChC;;EDk1vCA;IACE,gCAAgC;ECn1vClC;;EDs1vCA;IACE,8BAA8B;ECv1vChC;;ED01vCA;IACE,gCAAgC;EC31vClC;;ED81vCA;IACE,8BAA8B;EC/1vChC;;EDk2vCA;IACE,gCAAgC;ECh1vClC;;EDm1vCA;IACE,8BAA8B;EAChC;;EAEA;ICr1vCC,gCAAsC;EDu1vCvC;;ECz1vCA;IACC,4BAAa;IACb,6BAAc;ED41vCf;;EC91vCA;IACC,+BAAqC;IACrC,gCAAsC;EDi2vCvC;;ECn2vCA;IACC,8BAAqC;IACrC,+BAAsC;EDs2vCvC;;ECx2vCA;IACC,4BAAqC;IACrC,6BAAsC;ED22vCvC;;EC72vCA;IACC,8BAAqC;IACrC,+BAAsC;EDg3vCvC;;ECl3vCA;IACC,4BAAqC;IACrC,6BAAsC;EDq3vCvC;;ECv3vCA;IACC,8BAAqC;IACrC,+BAAsC;ED03vCvC;;EC53vCA;IACC,4BAAqC;IACrC,6BAAsC;ED+3vCvC;;ECj4vCA;IACC,8BAAqC;IACrC,+BAAsC;EDo4vCvC;;ECt4vCA;IACC,4BAAqC;IACrC,6BAAsC;EDy4vCvC;;EC34vCA;IACC,8BAAqC;IACrC,+BAAsC;ED84vCvC;;ECh5vCA;IACC,4BAAqC;IACrC,6BAAsC;EDm5vCvC;;ECr5vCA;IACC,8BAAqC;IACrC,+BAAsC;EDw5vCvC;;EC15vCA;IACC,4BAAqC;IACrC,6BAAsC;ED65vCvC;;EC/5vCA;IACC,8BAAqC;IACrC,+BAAsC;EDk6vCvC;;ECp6vCA;IACC,4BAAqC;IACrC,6BAAsC;EDu6vCvC;;ECz6vCA;IACC,8BAAqC;IACrC,+BAAsC;ED46vCvC;;EC96vCA;IACC,4BAAqC;IACrC,6BAAsC;EDi7vCvC;;ECn7vCA;IACC,8BAAqC;IACrC,+BAAsC;EDs7vCvC;;ECx7vCA;IACC,4BAAa;IACb,6BAAc;ED27vCf;;EC77vCA;IACC,8BAAa;IACb,+BAAc;EDg8vCf;;ECl8vCA;IACC,6BAAqC;IACrC,8BAAsC;EDq8vCvC;;ECv8vCA;IACC,+BAAqC;IACrC,gCAAsC;ED08vCvC;;EC58vCA;IACC,6BAAqC;IACrC,8BAAsC;ED+8vCvC;;ECj9vCA;IACC,+BAAqC;IACrC,gCAAsC;EDo9vCvC;;ECt9vCA;IACC,6BAAqC;IACrC,8BAAsC;EDy9vCvC;;EC39vCA;IACC,+BAAqC;IACrC,gCAAsC;ED89vCvC;;ECh+vCA;IACC,6BAAqC;IACrC,8BAAsC;EDm+vCvC;;ECr+vCA;IACC,+BAAqC;IACrC,gCAAsC;EDw+vCvC;;EC1+vCA;IACC,6BAAqC;IACrC,8BAAsC;ED6+vCvC;;EC/+vCA;IACC,+BAAqC;IACrC,gCAAsC;EDk/vCvC;;ECp/vCA;IACC,6BAAqC;IACrC,8BAAsC;EDu/vCvC;;ECz/vCA;IACC,+BAAqC;IACrC,gCAAsC;ED4/vCvC;;EC9/vCA;IACC,6BAAqC;IACrC,8BAAsC;EDigwCvC;;ECngwCA;IACC,+BAAqC;IACrC,gCAAsC;EDsgwCvC;;ECxgwCA;IACC,6BAAqC;IACrC,8BAAsC;ED2gwCvC;;EC7gwCA;IACC,+BAAqC;IACrC,gCAAsC;EDghwCvC;;EClhwCA;IACC,6BAAqC;IACrC,8BAAsC;EDqhwCvC;;ECvhwCA;IACC,+BAAqC;IACrC,gCAAsC;ED0hwCvC;;EC5hwCA;IACC,6BAAqC;IACrC,8BAAsC;ED+hwCvC;;ECjiwCA;IACC,+BAAqC;IACrC,gCAAsC;EDoiwCvC;;ECtiwCA;IACC,6BAAqC;IACrC,8BAAsC;EDyiwCvC;;EC3iwCA;IACC,+BAAqC;IACrC,gCAAsC;ED8iwCvC;;EChjwCA;IACC,6BAAqC;IACrC,8BAAsC;EDmjwCvC;;ECrjwCA;IACC,+BAAqC;IACrC,gCAAsC;EDwjwCvC;;EC1jwCA;IACC,6BAAqC;IACrC,8BAAsC;ED6jwCvC;;EC/jwCA;IACC,+BAAqC;IACrC,gCAAsC;EDkkwCvC;;ECpkwCA;IACC,6BAAqC;IACrC,8BAAsC;EDukwCvC;;ECzkwCA;IACC,+BAAqC;IACrC,gCAAsC;ED4kwCvC;;EC9kwCA;IACC,6BAAqC;IACrC,8BAAsC;EDilwCvC;;ECnlwCA;IACC,+BAAqC;IACrC,gCAAsC;EDslwCvC;;ECxlwCA;IACC,6BAAqC;IACrC,8BAAsC;ED2lwCvC;;EC7lwCA;IACC,+BAAqC;IACrC,gCAAsC;EDgmwCvC;;EClmwCA;IACC,6BAAqC;IACrC,8BAAsC;EDqmwCvC;;ECvmwCA;IACC,+BAAqC;IACrC,gCAAsC;ED0mwCvC;;EC5mwCA;IACC,6BAAqC;IACrC,8BAAsC;ED+mwCvC;;ECjnwCA;IACC,+BAAqC;IACrC,gCAAsC;EDonwCvC;;ECtnwCA;IACC,6BAAqC;IACrC,8BAAsC;EDynwCvC;;EC3nwCA;IACC,+BAAqC;IACrC,gCAAsC;ED8nwCvC;;EChowCA;IACC,6BAAqC;IACrC,8BAAsC;EDmowCvC;;ECrowCA;IACC,+BAAqC;IACrC,gCAAsC;EDwowCvC;;EC1owCA;IACC,6BAAqC;IACrC,8BAAsC;ED6owCvC;;EC/owCA;IACC,+BAAqC;IACrC,gCAAsC;EDkpwCvC;;ECppwCA;IACC,6BAAqC;IACrC,8BAAsC;EDupwCvC;;ECzpwCA;IACC,+BAAqC;IACrC,gCAAsC;ED4pwCvC;;EC9pwCA;IACC,6BAAqC;IACrC,8BAAsC;EDiqwCvC;;ECnqwCA;IACC,+BAAqC;IACrC,gCAAsC;EDsqwCvC;;ECxqwCA;IACC,6BAAqC;IACrC,8BAAsC;ED2qwCvC;;EC7qwCA;IACC,+BAAqC;IACrC,gCAAsC;EDgrwCvC;;EClrwCA;IACC,6BAAqC;IACrC,8BAAsC;EDqrwCvC;;ECvrwCA;IACC,+BAAqC;IACrC,gCAAsC;ED0rwCvC;;EC5rwCA;IACC,6BAAqC;IACrC,8BAAsC;ED+rwCvC;;ECjswCA;IACC,+BAAqC;IACrC,gCAAsC;EDoswCvC;;ECtswCA;IACC,6BAAqC;IACrC,8BAAsC;EDyswCvC;;EC3swCA;IACC,+BAAqC;IACrC,gCAAsC;ED8swCvC;;EChtwCA;IACC,6BAAqC;IACrC,8BAAsC;EDmtwCvC;;ECrtwCA;IACC,+BAAqC;IACrC,gCAAsC;EDwtwCvC;;EC1twCA;IACC,6BAAqC;IACrC,8BAAsC;ED6twCvC;;EC/twCA;IACC,+BAAqC;IACrC,gCAAsC;EDkuwCvC;;ECpuwCA;IACC,6BAAqC;IACrC,8BAAsC;EDuuwCvC;;ECzuwCA;IACC,+BAAqC;IACrC,gCAAsC;ED4uwCvC;;EC9uwCA;IACC,6BAAqC;IACrC,8BAAsC;EDivwCvC;;ECnvwCA;IACC,+BAAqC;IACrC,gCAAsC;EDsvwCvC;;ECxvwCA;IACC,6BAAqC;IACrC,8BAAsC;ED2vwCvC;;EC7vwCA;IACC,+BAAqC;IACrC,gCAAsC;EDgwwCvC;;EClwwCA;IACC,6BAAqC;IACrC,8BAAsC;EDqwwCvC;;ECvwwCA;IACC,+BAAqC;IACrC,gCAAsC;ED0wwCvC;;EC5wwCA;IACC,6BAAqC;IACrC,8BAAsC;ED+wwCvC;;ECjxwCA;IACC,+BAAqC;IACrC,gCAAsC;EDoxwCvC;;ECtxwCA;IACC,6BAAqC;IACrC,8BAAsC;EDyxwCvC;;EC3xwCA;IACC,+BAAqC;IACrC,gCAAsC;ED8xwCvC;;EChywCA;IACC,6BAAqC;IACrC,8BAAsC;EDmywCvC;;ECrywCA;IACC,+BAAqC;IACrC,gCAAsC;EDwywCvC;;EC1ywCA;IACC,6BAAqC;IACrC,8BAAsC;ED6ywCvC;;EC/ywCA;IACC,+BAAqC;IACrC,gCAAsC;EDkzwCvC;;ECpzwCA;IACC,6BAAqC;IACrC,8BAAsC;EDuzwCvC;;ECzzwCA;IACC,+BAAqC;IACrC,gCAAsC;ED4zwCvC;;EC9zwCA;IACC,6BAAqC;IACrC,8BAAsC;EDi0wCvC;;ECn0wCA;IACC,+BAAqC;IACrC,gCAAsC;EDs0wCvC;;ECx0wCA;IACC,6BAAqC;IACrC,8BAAsC;ED20wCvC;;EC70wCA;IACC,+BAAqC;IACrC,gCAAsC;EDg1wCvC;;ECl1wCA;IACC,6BAAqC;IACrC,8BAAsC;EDq1wCvC;;ECv1wCA;IACC,+BAAqC;IACrC,gCAAsC;ED01wCvC;;EC51wCA;IACC,6BAAqC;IACrC,8BAAsC;ED+1wCvC;;ECj2wCA;IACC,+BAAqC;IACrC,gCAAsC;EDo2wCvC;;ECt2wCA;IACC,6BAAqC;IACrC,8BAAsC;EDy2wCvC;;EC32wCA;IACC,+BAAqC;IACrC,gCAAsC;ED82wCvC;;ECh3wCA;IACC,6BAAqC;IACrC,8BAAsC;EDm3wCvC;;ECr3wCA;IACC,+BAAqC;IACrC,gCAAsC;EDw3wCvC;;EC13wCA;IACC,6BAAqC;IACrC,8BAAsC;ED63wCvC;;EC/3wCA;IACC,+BAAqC;IACrC,gCAAsC;EDk4wCvC;;ECp4wCA;IACC,6BAAqC;IACrC,8BAAsC;EDu4wCvC;;ECz4wCA;IACC,+BAAqC;IACrC,gCAAsC;ED44wCvC;;EC94wCA;IACC,6BAAqC;IACrC,8BAAsC;EDi5wCvC;;ECn5wCA;IACC,+BAAqC;IACrC,gCAAsC;EDs5wCvC;;ECx5wCA;IACC,6BAAqC;IACrC,8BAAsC;ED25wCvC;;EC75wCA;IACC,+BAAqC;IACrC,gCAAsC;EDg6wCvC;;ECl6wCA;IACC,6BAAqC;IACrC,8BAAsC;EDq6wCvC;;ECv6wCA;IACC,+BAAqC;IACrC,gCAAsC;ED06wCvC;;EC56wCA;IACC,6BAAqC;IACrC,8BAAsC;ED+6wCvC;;ECj7wCA;IACC,+BAAqC;IACrC,gCAAsC;EDo7wCvC;;ECt7wCA;IACC,6BAAqC;IACrC,8BAAsC;EDy7wCvC;;EC37wCA;IACC,+BAAqC;IACrC,gCAAsC;ED87wCvC;;ECh8wCA;IACC,6BAAqC;IACrC,8BAAsC;EDm8wCvC;;ECr8wCA;IACC,+BAAqC;IACrC,gCAAsC;EDw8wCvC;;EC18wCA;IACC,6BAAqC;IACrC,8BAAsC;ED68wCvC;;EC/8wCA;IACC,+BAAqC;IACrC,gCAAsC;EDk9wCvC;;ECp9wCA;IACC,6BAAqC;IACrC,8BAAsC;EDu9wCvC;;ECz9wCA;IACC,+BAAqC;IACrC,gCAAsC;ED49wCvC;;EC99wCA;IACC,6BAAqC;IACrC,8BAAsC;EDi+wCvC;;ECn+wCA;IACC,+BAAqC;IACrC,gCAAsC;EDs+wCvC;;ECx+wCA;IACC,6BAAqC;IACrC,8BAAsC;ED2+wCvC;;EC7+wCA;IACC,+BAAqC;IACrC,gCAAsC;EDg/wCvC;;ECl/wCA;IACC,6BAAqC;IACrC,8BAAsC;EDq/wCvC;;ECv/wCA;IACC,+BAAqC;IACrC,gCAAsC;ED0/wCvC;;EC5/wCA;IACC,6BAAqC;IACrC,8BAAsC;ED+/wCvC;;ECjgxCA;IACC,+BAAqC;IACrC,gCAAsC;EDogxCvC;;ECtgxCA;IACC,6BAAqC;IACrC,8BAAsC;EDygxCvC;;EC3gxCA;IACC,+BAAqC;IACrC,gCAAsC;ED8gxCvC;;EChhxCA;IACC,6BAAqC;IACrC,8BAAsC;EDmhxCvC;;ECrhxCA;IACC,+BAAqC;IACrC,gCAAsC;EDwhxCvC;;EC1hxCA;IACC,6BAAqC;IACrC,8BAAsC;ED6hxCvC;;EC/hxCA;IACC,+BAAqC;IACrC,gCAAsC;EDkixCvC;;ECpixCA;IACC,6BAAqC;IACrC,8BAAsC;EDuixCvC;;ECzixCA;IACC,+BAAqC;IACrC,gCAAsC;ED4ixCvC;;EC9ixCA;IACC,6BAAqC;IACrC,8BAAsC;EDijxCvC;;ECnjxCA;IACC,+BAAqC;IACrC,gCAAsC;EDsjxCvC;;ECxjxCA;IACC,6BAAqC;IACrC,8BAAsC;ED2jxCvC;;EC7jxCA;IACC,+BAAqC;IACrC,gCAAsC;EDgkxCvC;;EClkxCA;IACC,6BAAqC;IACrC,8BAAsC;EDqkxCvC;;ECvkxCA;IACC,+BAAqC;IACrC,gCAAsC;ED0kxCvC;;EC5kxCA;IACC,6BAAqC;IACrC,8BAAsC;ED+kxCvC;;ECjlxCA;IACC,+BAAqC;IACrC,gCAAsC;EDolxCvC;;ECtlxCA;IACC,6BAAqC;IACrC,8BAAsC;EDylxCvC;;EC3lxCA;IACC,+BAAqC;IACrC,gCAAsC;ED8lxCvC;;EChmxCA;IACC,6BAAqC;IACrC,8BAAsC;EDmmxCvC;;ECrmxCA;IACC,+BAAqC;IACrC,gCAAsC;EDwmxCvC;;EC1mxCA;IACC,6BAAqC;IACrC,8BAAsC;ED6mxCvC;;EC/mxCA;IACC,+BAAqC;IACrC,gCAAsC;EDknxCvC;;EChmxCA;IACC,6BAAoC;IACpC,8BAAuC;EDmmxCxC;;ECrmxCA;IACC,+BAAoC;IACpC,gCAAe;EDwmxChB;;EC1mxCA;IACC,2BAAY;IACZ,8BAAe;ED6mxChB;;EC/mxCA;IACC,8BAAoC;IACpC,iCAAuC;EDknxCxC;;ECpnxCA;IACC,6BAAoC;IACpC,gCAAuC;EDunxCxC;;ECznxCA;IACC,2BAAoC;IACpC,8BAAuC;ED4nxCxC;;EC9nxCA;IACC,6BAAoC;IACpC,gCAAuC;EDioxCxC;;ECnoxCA;IACC,2BAAoC;IACpC,8BAAuC;EDsoxCxC;;ECxoxCA;IACC,6BAAoC;IACpC,gCAAuC;ED2oxCxC;;EC7oxCA;IACC,2BAAoC;IACpC,8BAAuC;EDgpxCxC;;EClpxCA;IACC,6BAAoC;IACpC,gCAAuC;EDqpxCxC;;ECvpxCA;IACC,2BAAoC;IACpC,8BAAuC;ED0pxCxC;;EC5pxCA;IACC,6BAAoC;IACpC,gCAAuC;ED+pxCxC;;ECjqxCA;IACC,2BAAoC;IACpC,8BAAuC;EDoqxCxC;;ECtqxCA;IACC,6BAAoC;IACpC,gCAAuC;EDyqxCxC;;EC3qxCA;IACC,2BAAoC;IACpC,8BAAuC;ED8qxCxC;;EChrxCA;IACC,6BAAoC;IACpC,gCAAuC;EDmrxCxC;;ECrrxCA;IACC,2BAAoC;IACpC,8BAAuC;EDwrxCxC;;EC1rxCA;IACC,6BAAoC;IACpC,gCAAuC;ED6rxCxC;;EC/rxCA;IACC,2BAAoC;IACpC,8BAAuC;EDksxCxC;;ECpsxCA;IACC,6BAAoC;IACpC,gCAAuC;EDusxCxC;;ECzsxCA;IACC,2BAAY;IACZ,8BAAe;ED4sxChB;;EC9sxCA;IACC,6BAAY;IACZ,gCAAe;EDitxChB;;ECntxCA;IACC,4BAAoC;IACpC,+BAAuC;EDstxCxC;;ECxtxCA;IACC,8BAAoC;IACpC,iCAAuC;ED2txCxC;;EC7txCA;IACC,4BAAoC;IACpC,+BAAuC;EDguxCxC;;ECluxCA;IACC,8BAAoC;IACpC,iCAAuC;EDquxCxC;;ECvuxCA;IACC,4BAAoC;IACpC,+BAAuC;ED0uxCxC;;EC5uxCA;IACC,8BAAoC;IACpC,iCAAuC;ED+uxCxC;;ECjvxCA;IACC,4BAAoC;IACpC,+BAAuC;EDovxCxC;;ECtvxCA;IACC,8BAAoC;IACpC,iCAAuC;EDyvxCxC;;EC3vxCA;IACC,4BAAoC;IACpC,+BAAuC;ED8vxCxC;;EChwxCA;IACC,8BAAoC;IACpC,iCAAuC;EDmwxCxC;;ECrwxCA;IACC,4BAAoC;IACpC,+BAAuC;EDwwxCxC;;EC1wxCA;IACC,8BAAoC;IACpC,iCAAuC;ED6wxCxC;;EC/wxCA;IACC,4BAAoC;IACpC,+BAAuC;EDkxxCxC;;ECpxxCA;IACC,8BAAoC;IACpC,iCAAuC;EDuxxCxC;;ECzxxCA;IACC,4BAAoC;IACpC,+BAAuC;ED4xxCxC;;EC9xxCA;IACC,8BAAoC;IACpC,iCAAuC;EDiyxCxC;;ECnyxCA;IACC,4BAAoC;IACpC,+BAAuC;EDsyxCxC;;ECxyxCA;IACC,8BAAoC;IACpC,iCAAuC;ED2yxCxC;;EC7yxCA;IACC,4BAAoC;IACpC,+BAAuC;EDgzxCxC;;EClzxCA;IACC,8BAAoC;IACpC,iCAAuC;EDqzxCxC;;ECvzxCA;IACC,4BAAoC;IACpC,+BAAuC;ED0zxCxC;;EC5zxCA;IACC,8BAAoC;IACpC,iCAAuC;ED+zxCxC;;ECj0xCA;IACC,4BAAoC;IACpC,+BAAuC;EDo0xCxC;;ECt0xCA;IACC,8BAAoC;IACpC,iCAAuC;EDy0xCxC;;EC30xCA;IACC,4BAAoC;IACpC,+BAAuC;ED80xCxC;;ECh1xCA;IACC,8BAAoC;IACpC,iCAAuC;EDm1xCxC;;ECr1xCA;IACC,4BAAoC;IACpC,+BAAuC;EDw1xCxC;;EC11xCA;IACC,8BAAoC;IACpC,iCAAuC;ED61xCxC;;EC/1xCA;IACC,4BAAoC;IACpC,+BAAuC;EDk2xCxC;;ECp2xCA;IACC,8BAAoC;IACpC,iCAAuC;EDu2xCxC;;ECz2xCA;IACC,4BAAoC;IACpC,+BAAuC;ED42xCxC;;EC92xCA;IACC,8BAAoC;IACpC,iCAAuC;EDi3xCxC;;ECn3xCA;IACC,4BAAoC;IACpC,+BAAuC;EDs3xCxC;;ECx3xCA;IACC,8BAAoC;IACpC,iCAAuC;ED23xCxC;;EC73xCA;IACC,4BAAoC;IACpC,+BAAuC;EDg4xCxC;;ECl4xCA;IACC,8BAAoC;IACpC,iCAAuC;EDq4xCxC;;ECv4xCA;IACC,4BAAoC;IACpC,+BAAuC;ED04xCxC;;EC54xCA;IACC,8BAAoC;IACpC,iCAAuC;ED+4xCxC;;ECj5xCA;IACC,4BAAoC;IACpC,+BAAuC;EDo5xCxC;;ECt5xCA;IACC,8BAAoC;IACpC,iCAAuC;EDy5xCxC;;EC35xCA;IACC,4BAAoC;IACpC,+BAAuC;ED85xCxC;;ECh6xCA;IACC,8BAAoC;IACpC,iCAAuC;EDm6xCxC;;ECr6xCA;IACC,4BAAoC;IACpC,+BAAuC;EDw6xCxC;;EC16xCA;IACC,8BAAoC;IACpC,iCAAuC;ED66xCxC;;EC/6xCA;IACC,4BAAoC;IACpC,+BAAuC;EDk7xCxC;;ECp7xCA;IACC,8BAAoC;IACpC,iCAAuC;EDu7xCxC;;ECz7xCA;IACC,4BAAoC;IACpC,+BAAuC;ED47xCxC;;EC97xCA;IACC,8BAAoC;IACpC,iCAAuC;EDi8xCxC;;ECn8xCA;IACC,4BAAoC;IACpC,+BAAuC;EDs8xCxC;;ECx8xCA;IACC,8BAAoC;IACpC,iCAAuC;ED28xCxC;;EC78xCA;IACC,4BAAoC;IACpC,+BAAuC;EDg9xCxC;;ECl9xCA;IACC,8BAAoC;IACpC,iCAAuC;EDq9xCxC;;ECv9xCA;IACC,4BAAoC;IACpC,+BAAuC;ED09xCxC;;EC59xCA;IACC,8BAAoC;IACpC,iCAAuC;ED+9xCxC;;ECj+xCA;IACC,4BAAoC;IACpC,+BAAuC;EDo+xCxC;;ECt+xCA;IACC,8BAAoC;IACpC,iCAAuC;EDy+xCxC;;EC3+xCA;IACC,4BAAoC;IACpC,+BAAuC;ED8+xCxC;;ECh/xCA;IACC,8BAAoC;IACpC,iCAAuC;EDm/xCxC;;ECr/xCA;IACC,4BAAoC;IACpC,+BAAuC;EDw/xCxC;;EC1/xCA;IACC,8BAAoC;IACpC,iCAAuC;ED6/xCxC;;EC//xCA;IACC,4BAAoC;IACpC,+BAAuC;EDkgyCxC;;ECpgyCA;IACC,8BAAoC;IACpC,iCAAuC;EDugyCxC;;ECzgyCA;IACC,4BAAoC;IACpC,+BAAuC;ED4gyCxC;;EC9gyCA;IACC,8BAAoC;IACpC,iCAAuC;EDihyCxC;;ECnhyCA;IACC,4BAAoC;IACpC,+BAAuC;EDshyCxC;;ECxhyCA;IACC,8BAAoC;IACpC,iCAAuC;ED2hyCxC;;EC7hyCA;IACC,4BAAoC;IACpC,+BAAuC;EDgiyCxC;;ECliyCA;IACC,8BAAoC;IACpC,iCAAuC;EDqiyCxC;;ECviyCA;IACC,4BAAoC;IACpC,+BAAuC;ED0iyCxC;;EC5iyCA;IACC,8BAAoC;IACpC,iCAAuC;ED+iyCxC;;ECjjyCA;IACC,4BAAoC;IACpC,+BAAuC;EDojyCxC;;ECtjyCA;IACC,8BAAoC;IACpC,iCAAuC;EDyjyCxC;;EC3jyCA;IACC,4BAAoC;IACpC,+BAAuC;ED8jyCxC;;EChkyCA;IACC,8BAAoC;IACpC,iCAAuC;EDmkyCxC;;ECrkyCA;IACC,4BAAoC;IACpC,+BAAuC;EDwkyCxC;;EC1kyCA;IACC,8BAAoC;IACpC,iCAAuC;ED6kyCxC;;EC/kyCA;IACC,4BAAoC;IACpC,+BAAuC;EDklyCxC;;ECplyCA;IACC,8BAAoC;IACpC,iCAAuC;EDulyCxC;;ECzlyCA;IACC,4BAAoC;IACpC,+BAAuC;ED4lyCxC;;EC9lyCA;IACC,8BAAoC;IACpC,iCAAuC;EDimyCxC;;ECnmyCA;IACC,4BAAoC;IACpC,+BAAuC;EDsmyCxC;;ECxmyCA;IACC,8BAAoC;IACpC,iCAAuC;ED2myCxC;;EC7myCA;IACC,4BAAoC;IACpC,+BAAuC;EDgnyCxC;;EClnyCA;IACC,8BAAoC;IACpC,iCAAuC;EDqnyCxC;;ECvnyCA;IACC,4BAAoC;IACpC,+BAAuC;ED0nyCxC;;EC5nyCA;IACC,8BAAoC;IACpC,iCAAuC;ED+nyCxC;;ECjoyCA;IACC,4BAAoC;IACpC,+BAAuC;EDooyCxC;;ECtoyCA;IACC,8BAAoC;IACpC,iCAAuC;EDyoyCxC;;EC3oyCA;IACC,4BAAoC;IACpC,+BAAuC;ED8oyCxC;;EChpyCA;IACC,8BAAoC;IACpC,iCAAuC;EDmpyCxC;;ECrpyCA;IACC,4BAAoC;IACpC,+BAAuC;EDwpyCxC;;EC1pyCA;IACC,8BAAoC;IACpC,iCAAuC;ED6pyCxC;;EC/pyCA;IACC,4BAAoC;IACpC,+BAAuC;EDkqyCxC;;ECpqyCA;IACC,8BAAoC;IACpC,iCAAuC;EDuqyCxC;;ECzqyCA;IACC,4BAAoC;IACpC,+BAAuC;ED4qyCxC;;EC9qyCA;IACC,8BAAoC;IACpC,iCAAuC;EDiryCxC;;ECnryCA;IACC,4BAAoC;IACpC,+BAAuC;EDsryCxC;;ECxryCA;IACC,8BAAoC;IACpC,iCAAuC;ED2ryCxC;;EC7ryCA;IACC,4BAAoC;IACpC,+BAAuC;EDgsyCxC;;EClsyCA;IACC,8BAAoC;IACpC,iCAAuC;EDqsyCxC;;ECvsyCA;IACC,4BAAoC;IACpC,+BAAuC;ED0syCxC;;EC5syCA;IACC,8BAAoC;IACpC,iCAAuC;ED+syCxC;;ECjtyCA;IACC,4BAAoC;IACpC,+BAAuC;EDotyCxC;;ECttyCA;IACC,8BAAoC;IACpC,iCAAuC;EDytyCxC;;EC3tyCA;IACC,4BAAoC;IACpC,+BAAuC;ED8tyCxC;;EChuyCA;IACC,8BAAoC;IACpC,iCAAuC;EDmuyCxC;;ECruyCA;IACC,4BAAoC;IACpC,+BAAuC;EDwuyCxC;;EC1uyCA;IACC,8BAAoC;IACpC,iCAAuC;ED6uyCxC;;EC/uyCA;IACC,4BAAoC;IACpC,+BAAuC;EDkvyCxC;;ECpvyCA;IACC,8BAAoC;IACpC,iCAAuC;EDuvyCxC;;ECzvyCA;IACC,4BAAoC;IACpC,+BAAuC;ED4vyCxC;;EC9vyCA;IACC,8BAAoC;IACpC,iCAAuC;EDiwyCxC;;ECnwyCA;IACC,4BAAoC;IACpC,+BAAuC;EDswyCxC;;ECxwyCA;IACC,8BAAoC;IACpC,iCAAuC;ED2wyCxC;;EC7wyCA;IACC,4BAAoC;IACpC,+BAAuC;EDgxyCxC;;EClxyCA;IACC,8BAAoC;IACpC,iCAAuC;EDqxyCxC;;ECvxyCA;IACC,4BAAoC;IACpC,+BAAuC;ED0xyCxC;;EC5xyCA;IACC,8BAAoC;IACpC,iCAAuC;ED+xyCxC;;ECjyyCA;IACC,4BAAoC;IACpC,+BAAuC;EDoyyCxC;;ECtyyCA;IACC,8BAAoC;IACpC,iCAAuC;EDyyyCxC;;EC3yyCA;IACC,4BAAoC;IACpC,+BAAuC;ED8yyCxC;;EChzyCA;IACC,8BAAoC;IACpC,iCAAuC;EDmzyCxC;;ECrzyCA;IACC,4BAAoC;IACpC,+BAAuC;EDwzyCxC;;EC1zyCA;IACC,8BAAoC;IACpC,iCAAuC;ED6zyCxC;;EC/zyCA;IACC,4BAAoC;IACpC,+BAAuC;EDk0yCxC;;ECp0yCA;IACC,8BAAoC;IACpC,iCAAuC;EDu0yCxC;;ECz0yCA;IACC,4BAAoC;IACpC,+BAAuC;ED40yCxC;;EC90yCA;IACC,8BAAoC;IACpC,iCAAuC;EDi1yCxC;;ECn1yCA;IACC,4BAAoC;IACpC,+BAAuC;EDs1yCxC;;ECx1yCA;IACC,8BAAoC;IACpC,iCAAuC;ED21yCxC;;EC71yCA;IACC,4BAAoC;IACpC,+BAAuC;EDg2yCxC;;ECl2yCA;IACC,8BAAoC;IACpC,iCAAuC;EDq2yCxC;;ECv2yCA;IACC,4BAAoC;IACpC,+BAAuC;ED02yCxC;;EC52yCA;IACC,8BAAoC;IACpC,iCAAuC;ED+2yCxC;;ECj3yCA;IACC,4BAAoC;IACpC,+BAAuC;EDo3yCxC;;ECt3yCA;IACC,8BAAoC;IACpC,iCAAuC;EDy3yCxC;;EC33yCA;IACC,4BAAoC;IACpC,+BAAuC;ED83yCxC;;ECh4yCA;IACC,8BAAoC;IACpC,iCAAuC;EDm4yCxC;;EC73yCF;IAaE,4BAAc;IACb,+BAAgC;EDo3yCjC;;ECr3yCA;IACC,8BAAgC;IDw3yC/B,iCAAiC;EACnC;AACF;AACA;EACE;IACE,uBAAuB;EC93yCzB;;EDi4yCA;IACE,0BAA0B;ECl4yC5B;;EDq4yCA;IACE,yBAAyB;ECt4yC3B;;EDy4yCA;IACE,uBAAuB;EC14yCzB;;ED64yCA;IACE,yBAAyB;EC94yC3B;;EDi5yCA;IACE,uBAAuB;ECl5yCzB;;EDq5yCA;IACE,yBAAyB;ECt5yC3B;;EDy5yCA;IACE,uBAAuB;EC15yCzB;;ED65yCA;IACE,yBAAyB;EC95yC3B;;EDi6yCA;IACE,uBAAuB;ECl6yCzB;;EDq6yCA;IACE,yBAAyB;ECt6yC3B;;EDy6yCA;IACE,uBAAuB;EC16yCzB;;ED66yCA;IACE,yBAAyB;EC96yC3B;;EDi7yCA;IACE,uBAAuB;ECl7yCzB;;EDq7yCA;IACE,yBAAyB;ECt7yC3B;;EDy7yCA;IACE,uBAAuB;EC17yCzB;;ED67yCA;IACE,yBAAyB;EC97yC3B;;EDi8yCA;IACE,uBAAuB;ECl8yCzB;;EDq8yCA;IACE,yBAAyB;ECt8yC3B;;EDy8yCA;IACE,uBAAuB;EC18yCzB;;ED68yCA;IACE,yBAAyB;EC98yC3B;;EDi9yCA;IACE,wBAAwB;ECl9yC1B;;EDq9yCA;IACE,0BAA0B;ECt9yC5B;;EDy9yCA;IACE,wBAAwB;EC19yC1B;;ED69yCA;IACE,0BAA0B;EC99yC5B;;EDi+yCA;IACE,wBAAwB;ECl+yC1B;;EDq+yCA;IACE,0BAA0B;ECt+yC5B;;EDy+yCA;IACE,wBAAwB;EC1+yC1B;;ED6+yCA;IACE,0BAA0B;EC9+yC5B;;EDi/yCA;IACE,wBAAwB;ECl/yC1B;;EDq/yCA;IACE,0BAA0B;ECt/yC5B;;EDy/yCA;IACE,wBAAwB;EC1/yC1B;;ED6/yCA;IACE,0BAA0B;EC9/yC5B;;EDigzCA;IACE,wBAAwB;EClgzC1B;;EDqgzCA;IACE,0BAA0B;ECtgzC5B;;EDygzCA;IACE,wBAAwB;EC1gzC1B;;ED6gzCA;IACE,0BAA0B;EC9gzC5B;;EDihzCA;IACE,wBAAwB;EClhzC1B;;EDqhzCA;IACE,0BAA0B;ECthzC5B;;EDyhzCA;IACE,wBAAwB;EC1hzC1B;;ED6hzCA;IACE,0BAA0B;EC9hzC5B;;EDiizCA;IACE,wBAAwB;EClizC1B;;EDqizCA;IACE,0BAA0B;ECtizC5B;;EDyizCA;IACE,wBAAwB;EC1izC1B;;ED6izCA;IACE,0BAA0B;EC9izC5B;;EDijzCA;IACE,wBAAwB;ECljzC1B;;EDqjzCA;IACE,0BAA0B;ECtjzC5B;;EDyjzCA;IACE,wBAAwB;EC1jzC1B;;ED6jzCA;IACE,0BAA0B;EC9jzC5B;;EDikzCA;IACE,wBAAwB;EClkzC1B;;EDqkzCA;IACE,0BAA0B;ECtkzC5B;;EDykzCA;IACE,wBAAwB;EC1kzC1B;;ED6kzCA;IACE,0BAA0B;EC9kzC5B;;EDilzCA;IACE,wBAAwB;ECllzC1B;;EDqlzCA;IACE,0BAA0B;ECtlzC5B;;EDylzCA;IACE,wBAAwB;EC1lzC1B;;ED6lzCA;IACE,0BAA0B;EC9lzC5B;;EDimzCA;IACE,wBAAwB;EClmzC1B;;EDqmzCA;IACE,0BAA0B;ECtmzC5B;;EDymzCA;IACE,wBAAwB;EC1mzC1B;;ED6mzCA;IACE,0BAA0B;EC9mzC5B;;EDinzCA;IACE,wBAAwB;EClnzC1B;;EDqnzCA;IACE,0BAA0B;ECtnzC5B;;EDynzCA;IACE,wBAAwB;EC1nzC1B;;ED6nzCA;IACE,0BAA0B;EC9nzC5B;;EDiozCA;IACE,wBAAwB;EClozC1B;;EDqozCA;IACE,0BAA0B;ECtozC5B;;EDyozCA;IACE,wBAAwB;EC1ozC1B;;ED6ozCA;IACE,0BAA0B;EC9ozC5B;;EDipzCA;IACE,wBAAwB;EClpzC1B;;EDqpzCA;IACE,0BAA0B;ECtpzC5B;;EDypzCA;IACE,wBAAwB;EC1pzC1B;;ED6pzCA;IACE,0BAA0B;EC9pzC5B;;EDiqzCA;IACE,wBAAwB;EClqzC1B;;EDqqzCA;IACE,0BAA0B;ECtqzC5B;;EDyqzCA;IACE,wBAAwB;EC1qzC1B;;ED6qzCA;IACE,0BAA0B;EC9qzC5B;;EDirzCA;IACE,wBAAwB;EClrzC1B;;EDqrzCA;IACE,0BAA0B;ECtrzC5B;;EDyrzCA;IACE,wBAAwB;EC1rzC1B;;ED6rzCA;IACE,0BAA0B;EC9rzC5B;;EDiszCA;IACE,wBAAwB;EClszC1B;;EDqszCA;IACE,0BAA0B;ECtszC5B;;EDyszCA;IACE,wBAAwB;EC1szC1B;;ED6szCA;IACE,0BAA0B;EC9szC5B;;EDitzCA;IACE,wBAAwB;ECltzC1B;;EDqtzCA;IACE,0BAA0B;ECttzC5B;;EDytzCA;IACE,wBAAwB;EC1tzC1B;;ED6tzCA;IACE,0BAA0B;EC9tzC5B;;EDiuzCA;IACE,wBAAwB;ECluzC1B;;EDquzCA;IACE,0BAA0B;ECtuzC5B;;EDyuzCA;IACE,wBAAwB;EC1uzC1B;;ED6uzCA;IACE,0BAA0B;EC9uzC5B;;EDivzCA;IACE,wBAAwB;EClvzC1B;;EDqvzCA;IACE,0BAA0B;ECtvzC5B;;EDyvzCA;IACE,wBAAwB;EC1vzC1B;;ED6vzCA;IACE,0BAA0B;EC9vzC5B;;EDiwzCA;IACE,wBAAwB;EClwzC1B;;EDqwzCA;IACE,0BAA0B;ECtwzC5B;;EDywzCA;IACE,wBAAwB;EC1wzC1B;;ED6wzCA;IACE,0BAA0B;EC9wzC5B;;EDixzCA;IACE,wBAAwB;EClxzC1B;;EDqxzCA;IACE,0BAA0B;ECtxzC5B;;EDyxzCA;IACE,wBAAwB;EC1xzC1B;;ED6xzCA;IACE,0BAA0B;EC9xzC5B;;EDiyzCA;IACE,wBAAwB;EClyzC1B;;EDqyzCA;IACE,0BAA0B;ECtyzC5B;;EDyyzCA;IACE,wBAAwB;EC1yzC1B;;ED6yzCA;IACE,0BAA0B;EC9yzC5B;;EDizzCA;IACE,wBAAwB;EClzzC1B;;EDqzzCA;IACE,0BAA0B;ECtzzC5B;;EDyzzCA;IACE,wBAAwB;EC1zzC1B;;ED6zzCA;IACE,0BAA0B;EC9zzC5B;;EDi0zCA;IACE,wBAAwB;ECl0zC1B;;EDq0zCA;IACE,0BAA0B;ECt0zC5B;;EDy0zCA;IACE,wBAAwB;EC10zC1B;;ED60zCA;IACE,0BAA0B;EC90zC5B;;EDi1zCA;IACE,wBAAwB;ECl1zC1B;;EDq1zCA;IACE,0BAA0B;ECt1zC5B;;EDy1zCA;IACE,wBAAwB;EC11zC1B;;ED61zCA;IACE,0BAA0B;EC91zC5B;;EDi2zCA;IACE,wBAAwB;ECl2zC1B;;EDq2zCA;IACE,0BAA0B;ECt2zC5B;;EDy2zCA;IACE,wBAAwB;EC12zC1B;;ED62zCA;IACE,0BAA0B;EC92zC5B;;EDi3zCA;IACE,wBAAwB;ECl3zC1B;;EDq3zCA;IACE,0BAA0B;ECt3zC5B;;EDy3zCA;IACE,wBAAwB;EC13zC1B;;ED63zCA;IACE,0BAA0B;EC93zC5B;;EDi4zCA;IACE,wBAAwB;ECl4zC1B;;EDq4zCA;IACE,0BAA0B;ECt4zC5B;;EDy4zCA;IACE,wBAAwB;EC14zC1B;;ED64zCA;IACE,0BAA0B;EC94zC5B;;EDi5zCA;IACE,wBAAwB;ECl5zC1B;;EDq5zCA;IACE,0BAA0B;ECt5zC5B;;EDy5zCA;IACE,wBAAwB;EC15zC1B;;ED65zCA;IACE,0BAA0B;EC95zC5B;;EDi6zCA;IACE,wBAAwB;ECl6zC1B;;EDq6zCA;IACE,0BAA0B;ECt6zC5B;;EDy6zCA;IACE,wBAAwB;EC16zC1B;;ED66zCA;IACE,0BAA0B;EC96zC5B;;EDi7zCA;IACE,wBAAwB;ECl7zC1B;;EDq7zCA;IACE,0BAA0B;ECt7zC5B;;EDy7zCA;IACE,wBAAwB;EC17zC1B;;ED67zCA;IACE,0BAA0B;EC97zC5B;;EDi8zCA;IACE,wBAAwB;ECl8zC1B;;EDq8zCA;IACE,0BAA0B;ECt8zC5B;;EDy8zCA;IACE,wBAAwB;EC18zC1B;;ED68zCA;IACE,0BAA0B;EC98zC5B;;EDi9zCA;IACE,wBAAwB;ECl9zC1B;;EDq9zCA;IACE,0BAA0B;ECt9zC5B;;EDy9zCA;IACE,wBAAwB;EC19zC1B;;ED69zCA;IACE,0BAA0B;EC99zC5B;;EDi+zCA;IACE,wBAAwB;ECl+zC1B;;EDq+zCA;IACE,0BAA0B;ECt+zC5B;;EDy+zCA;IACE,wBAAwB;EC1+zC1B;;ED6+zCA;IACE,0BAA0B;EC9+zC5B;;EDi/zCA;IACE,wBAAwB;ECl/zC1B;;EDq/zCA;IACE,0BAA0B;ECn+zC5B;;EDs+zCA;IACE,wBAAwB;ECv+zC1B;;ED0+zCA;IACE,0BAA0B;EC3+zC5B;;ED8+zCA;IACE,2BAA2B;EC/+zC7B;;EDk/zCA;IACE,8BAA8B;ECn/zChC;;EDs/zCA;IACE,6BAA6B;ECv/zC/B;;ED0/zCA;IACE,2BAA2B;EC3/zC7B;;ED8/zCA;IACE,6BAA6B;EC//zC/B;;EDkg0CA;IACE,2BAA2B;ECng0C7B;;EDsg0CA;IACE,6BAA6B;ECvg0C/B;;ED0g0CA;IACE,2BAA2B;EC3g0C7B;;ED8g0CA;IACE,6BAA6B;EC/g0C/B;;EDkh0CA;IACE,2BAA2B;ECnh0C7B;;EDsh0CA;IACE,6BAA6B;ECvh0C/B;;ED0h0CA;IACE,2BAA2B;EC3h0C7B;;ED8h0CA;IACE,6BAA6B;EC/h0C/B;;EDki0CA;IACE,2BAA2B;ECni0C7B;;EDsi0CA;IACE,6BAA6B;ECvi0C/B;;ED0i0CA;IACE,2BAA2B;EC3i0C7B;;ED8i0CA;IACE,6BAA6B;EC/i0C/B;;EDkj0CA;IACE,2BAA2B;ECnj0C7B;;EDsj0CA;IACE,6BAA6B;ECvj0C/B;;ED0j0CA;IACE,2BAA2B;EC3j0C7B;;ED8j0CA;IACE,6BAA6B;EC/j0C/B;;EDkk0CA;IACE,4BAA4B;ECnk0C9B;;EDsk0CA;IACE,8BAA8B;ECvk0ChC;;ED0k0CA;IACE,4BAA4B;EC3k0C9B;;ED8k0CA;IACE,8BAA8B;EC/k0ChC;;EDkl0CA;IACE,4BAA4B;ECnl0C9B;;EDsl0CA;IACE,8BAA8B;ECvl0ChC;;ED0l0CA;IACE,4BAA4B;EC3l0C9B;;ED8l0CA;IACE,8BAA8B;EC/l0ChC;;EDkm0CA;IACE,4BAA4B;ECnm0C9B;;EDsm0CA;IACE,8BAA8B;ECvm0ChC;;ED0m0CA;IACE,4BAA4B;EC3m0C9B;;ED8m0CA;IACE,8BAA8B;EC/m0ChC;;EDkn0CA;IACE,4BAA4B;ECnn0C9B;;EDsn0CA;IACE,8BAA8B;ECvn0ChC;;ED0n0CA;IACE,4BAA4B;EC3n0C9B;;ED8n0CA;IACE,8BAA8B;EC/n0ChC;;EDko0CA;IACE,4BAA4B;ECno0C9B;;EDso0CA;IACE,8BAA8B;ECvo0ChC;;ED0o0CA;IACE,4BAA4B;EC3o0C9B;;ED8o0CA;IACE,8BAA8B;EC/o0ChC;;EDkp0CA;IACE,4BAA4B;ECnp0C9B;;EDsp0CA;IACE,8BAA8B;ECvp0ChC;;ED0p0CA;IACE,4BAA4B;EC3p0C9B;;ED8p0CA;IACE,8BAA8B;EC/p0ChC;;EDkq0CA;IACE,4BAA4B;ECnq0C9B;;EDsq0CA;IACE,8BAA8B;ECvq0ChC;;ED0q0CA;IACE,4BAA4B;EC3q0C9B;;ED8q0CA;IACE,8BAA8B;EC/q0ChC;;EDkr0CA;IACE,4BAA4B;ECnr0C9B;;EDsr0CA;IACE,8BAA8B;ECvr0ChC;;ED0r0CA;IACE,4BAA4B;EC3r0C9B;;ED8r0CA;IACE,8BAA8B;EC/r0ChC;;EDks0CA;IACE,4BAA4B;ECns0C9B;;EDss0CA;IACE,8BAA8B;ECvs0ChC;;ED0s0CA;IACE,4BAA4B;EC3s0C9B;;ED8s0CA;IACE,8BAA8B;EC/s0ChC;;EDkt0CA;IACE,4BAA4B;ECnt0C9B;;EDst0CA;IACE,8BAA8B;ECvt0ChC;;ED0t0CA;IACE,4BAA4B;EC3t0C9B;;ED8t0CA;IACE,8BAA8B;EC/t0ChC;;EDku0CA;IACE,4BAA4B;ECnu0C9B;;EDsu0CA;IACE,8BAA8B;ECvu0ChC;;ED0u0CA;IACE,4BAA4B;EC3u0C9B;;ED8u0CA;IACE,8BAA8B;EC/u0ChC;;EDkv0CA;IACE,4BAA4B;ECnv0C9B;;EDsv0CA;IACE,8BAA8B;ECvv0ChC;;ED0v0CA;IACE,4BAA4B;EC3v0C9B;;ED8v0CA;IACE,8BAA8B;EC/v0ChC;;EDkw0CA;IACE,4BAA4B;ECnw0C9B;;EDsw0CA;IACE,8BAA8B;ECvw0ChC;;ED0w0CA;IACE,4BAA4B;EC3w0C9B;;ED8w0CA;IACE,8BAA8B;EC/w0ChC;;EDkx0CA;IACE,4BAA4B;ECnx0C9B;;EDsx0CA;IACE,8BAA8B;ECvx0ChC;;ED0x0CA;IACE,4BAA4B;EC3x0C9B;;ED8x0CA;IACE,8BAA8B;EC/x0ChC;;EDky0CA;IACE,4BAA4B;ECny0C9B;;EDsy0CA;IACE,8BAA8B;ECvy0ChC;;ED0y0CA;IACE,4BAA4B;EC3y0C9B;;ED8y0CA;IACE,8BAA8B;EC/y0ChC;;EDkz0CA;IACE,4BAA4B;ECnz0C9B;;EDsz0CA;IACE,8BAA8B;ECvz0ChC;;ED0z0CA;IACE,4BAA4B;EC3z0C9B;;ED8z0CA;IACE,8BAA8B;EC/z0ChC;;EDk00CA;IACE,4BAA4B;ECn00C9B;;EDs00CA;IACE,8BAA8B;ECv00ChC;;ED000CA;IACE,4BAA4B;EC300C9B;;ED800CA;IACE,8BAA8B;EC/00ChC;;EDk10CA;IACE,4BAA4B;ECn10C9B;;EDs10CA;IACE,8BAA8B;ECv10ChC;;ED010CA;IACE,4BAA4B;EC310C9B;;ED810CA;IACE,8BAA8B;EC/10ChC;;EDk20CA;IACE,4BAA4B;ECn20C9B;;EDs20CA;IACE,8BAA8B;ECv20ChC;;ED020CA;IACE,4BAA4B;EC320C9B;;ED820CA;IACE,8BAA8B;EC/20ChC;;EDk30CA;IACE,4BAA4B;ECn30C9B;;EDs30CA;IACE,8BAA8B;ECv30ChC;;ED030CA;IACE,4BAA4B;EC330C9B;;ED830CA;IACE,8BAA8B;EC/30ChC;;EDk40CA;IACE,4BAA4B;ECn40C9B;;EDs40CA;IACE,8BAA8B;ECv40ChC;;ED040CA;IACE,4BAA4B;EC340C9B;;ED840CA;IACE,8BAA8B;EC/40ChC;;EDk50CA;IACE,4BAA4B;ECn50C9B;;EDs50CA;IACE,8BAA8B;ECv50ChC;;ED050CA;IACE,4BAA4B;EC350C9B;;ED850CA;IACE,8BAA8B;EC/50ChC;;EDk60CA;IACE,4BAA4B;ECn60C9B;;EDs60CA;IACE,8BAA8B;ECv60ChC;;ED060CA;IACE,4BAA4B;EC360C9B;;ED860CA;IACE,8BAA8B;EC/60ChC;;EDk70CA;IACE,4BAA4B;ECn70C9B;;EDs70CA;IACE,8BAA8B;ECv70ChC;;ED070CA;IACE,4BAA4B;EC370C9B;;ED870CA;IACE,8BAA8B;EC/70ChC;;EDk80CA;IACE,4BAA4B;ECn80C9B;;EDs80CA;IACE,8BAA8B;ECv80ChC;;ED080CA;IACE,4BAA4B;EC380C9B;;ED880CA;IACE,8BAA8B;EC/80ChC;;EDk90CA;IACE,4BAA4B;ECn90C9B;;EDs90CA;IACE,8BAA8B;ECv90ChC;;ED090CA;IACE,4BAA4B;EC390C9B;;ED890CA;IACE,8BAA8B;EC/90ChC;;EDk+0CA;IACE,4BAA4B;ECn+0C9B;;EDs+0CA;IACE,8BAA8B;ECv+0ChC;;ED0+0CA;IACE,4BAA4B;EC3+0C9B;;ED8+0CA;IACE,8BAA8B;EC/+0ChC;;EDk/0CA;IACE,4BAA4B;ECn/0C9B;;EDs/0CA;IACE,8BAA8B;ECv/0ChC;;ED0/0CA;IACE,4BAA4B;EC3/0C9B;;ED8/0CA;IACE,8BAA8B;EC//0ChC;;EDkg1CA;IACE,4BAA4B;ECng1C9B;;EDsg1CA;IACE,8BAA8B;ECvg1ChC;;ED0g1CA;IACE,4BAA4B;EC3g1C9B;;ED8g1CA;IACE,8BAA8B;EC/g1ChC;;EDkh1CA;IACE,4BAA4B;ECnh1C9B;;EDsh1CA;IACE,8BAA8B;ECvh1ChC;;ED0h1CA;IACE,4BAA4B;EC3h1C9B;;ED8h1CA;IACE,8BAA8B;EC/h1ChC;;EDki1CA;IACE,4BAA4B;ECni1C9B;;EDsi1CA;IACE,8BAA8B;ECvi1ChC;;ED0i1CA;IACE,4BAA4B;EC3i1C9B;;ED8i1CA;IACE,8BAA8B;EC/i1ChC;;EDkj1CA;IACE,4BAA4B;ECnj1C9B;;EDsj1CA;IACE,8BAA8B;ECvj1ChC;;ED0j1CA;IACE,4BAA4B;EC3j1C9B;;ED8j1CA;IACE,8BAA8B;EC/j1ChC;;EDkk1CA;IACE,4BAA4B;ECnk1C9B;;EDsk1CA;IACE,8BAA8B;ECvk1ChC;;ED0k1CA;IACE,4BAA4B;EC3k1C9B;;ED8k1CA;IACE,8BAA8B;EC/k1ChC;;EDkl1CA;IACE,4BAA4B;ECnl1C9B;;EDsl1CA;IACE,8BAA8B;ECvl1ChC;;ED0l1CA;IACE,4BAA4B;EC3l1C9B;;ED8l1CA;IACE,8BAA8B;EC/l1ChC;;EDkm1CA;IACE,4BAA4B;ECnm1C9B;;EDsm1CA;IACE,8BAA8B;ECpl1ChC;;EDul1CA;IACE,4BAA4B;ECxl1C9B;;ED2l1CA;IACE,8BAA8B;EC5l1ChC;;ED+l1CA;IACE,8BAA8B;EChm1ChC;;EDmm1CA;IACE,iCAAiC;ECpm1CnC;;EDum1CA;IACE,gCAAgC;ECxm1ClC;;ED2m1CA;IACE,8BAA8B;EC5m1ChC;;ED+m1CA;IACE,gCAAgC;EChn1ClC;;EDmn1CA;IACE,8BAA8B;ECpn1ChC;;EDun1CA;IACE,gCAAgC;ECxn1ClC;;ED2n1CA;IACE,8BAA8B;EC5n1ChC;;ED+n1CA;IACE,gCAAgC;ECho1ClC;;EDmo1CA;IACE,8BAA8B;ECpo1ChC;;EDuo1CA;IACE,gCAAgC;ECxo1ClC;;ED2o1CA;IACE,8BAA8B;EC5o1ChC;;ED+o1CA;IACE,gCAAgC;EChp1ClC;;EDmp1CA;IACE,8BAA8B;ECpp1ChC;;EDup1CA;IACE,gCAAgC;ECxp1ClC;;ED2p1CA;IACE,8BAA8B;EC5p1ChC;;ED+p1CA;IACE,gCAAgC;EChq1ClC;;EDmq1CA;IACE,8BAA8B;ECpq1ChC;;EDuq1CA;IACE,gCAAgC;ECxq1ClC;;ED2q1CA;IACE,8BAA8B;EC5q1ChC;;ED+q1CA;IACE,gCAAgC;EChr1ClC;;EDmr1CA;IACE,+BAA+B;ECpr1CjC;;EDur1CA;IACE,iCAAiC;ECxr1CnC;;ED2r1CA;IACE,+BAA+B;EC5r1CjC;;ED+r1CA;IACE,iCAAiC;EChs1CnC;;EDms1CA;IACE,+BAA+B;ECps1CjC;;EDus1CA;IACE,iCAAiC;ECxs1CnC;;ED2s1CA;IACE,+BAA+B;EC5s1CjC;;ED+s1CA;IACE,iCAAiC;ECht1CnC;;EDmt1CA;IACE,+BAA+B;ECpt1CjC;;EDut1CA;IACE,iCAAiC;ECxt1CnC;;ED2t1CA;IACE,+BAA+B;EC5t1CjC;;ED+t1CA;IACE,iCAAiC;EChu1CnC;;EDmu1CA;IACE,+BAA+B;ECpu1CjC;;EDuu1CA;IACE,iCAAiC;ECxu1CnC;;ED2u1CA;IACE,+BAA+B;EC5u1CjC;;ED+u1CA;IACE,iCAAiC;EChv1CnC;;EDmv1CA;IACE,+BAA+B;ECpv1CjC;;EDuv1CA;IACE,iCAAiC;ECxv1CnC;;ED2v1CA;IACE,+BAA+B;EC5v1CjC;;ED+v1CA;IACE,iCAAiC;EChw1CnC;;EDmw1CA;IACE,+BAA+B;ECpw1CjC;;EDuw1CA;IACE,iCAAiC;ECxw1CnC;;ED2w1CA;IACE,+BAA+B;EC5w1CjC;;ED+w1CA;IACE,iCAAiC;EChx1CnC;;EDmx1CA;IACE,+BAA+B;ECpx1CjC;;EDux1CA;IACE,iCAAiC;ECxx1CnC;;ED2x1CA;IACE,+BAA+B;EC5x1CjC;;ED+x1CA;IACE,iCAAiC;EChy1CnC;;EDmy1CA;IACE,+BAA+B;ECpy1CjC;;EDuy1CA;IACE,iCAAiC;ECxy1CnC;;ED2y1CA;IACE,+BAA+B;EC5y1CjC;;ED+y1CA;IACE,iCAAiC;EChz1CnC;;EDmz1CA;IACE,+BAA+B;ECpz1CjC;;EDuz1CA;IACE,iCAAiC;ECxz1CnC;;ED2z1CA;IACE,+BAA+B;EC5z1CjC;;ED+z1CA;IACE,iCAAiC;ECh01CnC;;EDm01CA;IACE,+BAA+B;ECp01CjC;;EDu01CA;IACE,iCAAiC;ECx01CnC;;ED201CA;IACE,+BAA+B;EC501CjC;;ED+01CA;IACE,iCAAiC;ECh11CnC;;EDm11CA;IACE,+BAA+B;ECp11CjC;;EDu11CA;IACE,iCAAiC;ECx11CnC;;ED211CA;IACE,+BAA+B;EC511CjC;;ED+11CA;IACE,iCAAiC;ECh21CnC;;EDm21CA;IACE,+BAA+B;ECp21CjC;;EDu21CA;IACE,iCAAiC;ECx21CnC;;ED221CA;IACE,+BAA+B;EC521CjC;;ED+21CA;IACE,iCAAiC;ECh31CnC;;EDm31CA;IACE,+BAA+B;ECp31CjC;;EDu31CA;IACE,iCAAiC;ECx31CnC;;ED231CA;IACE,+BAA+B;EC531CjC;;ED+31CA;IACE,iCAAiC;ECh41CnC;;EDm41CA;IACE,+BAA+B;ECp41CjC;;EDu41CA;IACE,iCAAiC;ECx41CnC;;ED241CA;IACE,+BAA+B;EC541CjC;;ED+41CA;IACE,iCAAiC;ECh51CnC;;EDm51CA;IACE,+BAA+B;ECp51CjC;;EDu51CA;IACE,iCAAiC;ECx51CnC;;ED251CA;IACE,+BAA+B;EC551CjC;;ED+51CA;IACE,iCAAiC;ECh61CnC;;EDm61CA;IACE,+BAA+B;ECp61CjC;;EDu61CA;IACE,iCAAiC;ECx61CnC;;ED261CA;IACE,+BAA+B;EC561CjC;;ED+61CA;IACE,iCAAiC;ECh71CnC;;EDm71CA;IACE,+BAA+B;ECp71CjC;;EDu71CA;IACE,iCAAiC;ECx71CnC;;ED271CA;IACE,+BAA+B;EC571CjC;;ED+71CA;IACE,iCAAiC;ECh81CnC;;EDm81CA;IACE,+BAA+B;ECp81CjC;;EDu81CA;IACE,iCAAiC;ECx81CnC;;ED281CA;IACE,+BAA+B;EC581CjC;;ED+81CA;IACE,iCAAiC;ECh91CnC;;EDm91CA;IACE,+BAA+B;ECp91CjC;;EDu91CA;IACE,iCAAiC;ECx91CnC;;ED291CA;IACE,+BAA+B;EC591CjC;;ED+91CA;IACE,iCAAiC;ECh+1CnC;;EDm+1CA;IACE,+BAA+B;ECp+1CjC;;EDu+1CA;IACE,iCAAiC;ECx+1CnC;;ED2+1CA;IACE,+BAA+B;EC5+1CjC;;ED++1CA;IACE,iCAAiC;ECh/1CnC;;EDm/1CA;IACE,+BAA+B;ECp/1CjC;;EDu/1CA;IACE,iCAAiC;ECx/1CnC;;ED2/1CA;IACE,+BAA+B;EC5/1CjC;;ED+/1CA;IACE,iCAAiC;EChg2CnC;;EDmg2CA;IACE,+BAA+B;ECpg2CjC;;EDug2CA;IACE,iCAAiC;ECxg2CnC;;ED2g2CA;IACE,+BAA+B;EC5g2CjC;;ED+g2CA;IACE,iCAAiC;EChh2CnC;;EDmh2CA;IACE,+BAA+B;ECph2CjC;;EDuh2CA;IACE,iCAAiC;ECxh2CnC;;ED2h2CA;IACE,+BAA+B;EC5h2CjC;;ED+h2CA;IACE,iCAAiC;EChi2CnC;;EDmi2CA;IACE,+BAA+B;ECpi2CjC;;EDui2CA;IACE,iCAAiC;ECxi2CnC;;ED2i2CA;IACE,+BAA+B;EC5i2CjC;;ED+i2CA;IACE,iCAAiC;EChj2CnC;;EDmj2CA;IACE,+BAA+B;ECpj2CjC;;EDuj2CA;IACE,iCAAiC;ECxj2CnC;;ED2j2CA;IACE,+BAA+B;EC5j2CjC;;ED+j2CA;IACE,iCAAiC;EChk2CnC;;EDmk2CA;IACE,+BAA+B;ECpk2CjC;;EDuk2CA;IACE,iCAAiC;ECxk2CnC;;ED2k2CA;IACE,+BAA+B;EC5k2CjC;;ED+k2CA;IACE,iCAAiC;EChl2CnC;;EDml2CA;IACE,+BAA+B;ECpl2CjC;;EDul2CA;IACE,iCAAiC;ECxl2CnC;;ED2l2CA;IACE,+BAA+B;EC5l2CjC;;ED+l2CA;IACE,iCAAiC;EChm2CnC;;EDmm2CA;IACE,+BAA+B;ECpm2CjC;;EDum2CA;IACE,iCAAiC;ECxm2CnC;;ED2m2CA;IACE,+BAA+B;EC5m2CjC;;ED+m2CA;IACE,iCAAiC;EChn2CnC;;EDmn2CA;IACE,+BAA+B;ECpn2CjC;;EDun2CA;IACE,iCAAiC;ECxn2CnC;;ED2n2CA;IACE,+BAA+B;EC5n2CjC;;ED+n2CA;IACE,iCAAiC;ECho2CnC;;EDmo2CA;IACE,+BAA+B;ECpo2CjC;;EDuo2CA;IACE,iCAAiC;ECxo2CnC;;ED2o2CA;IACE,+BAA+B;EC5o2CjC;;ED+o2CA;IACE,iCAAiC;EChp2CnC;;EDmp2CA;IACE,+BAA+B;ECpp2CjC;;EDup2CA;IACE,iCAAiC;ECxp2CnC;;ED2p2CA;IACE,+BAA+B;EC5p2CjC;;ED+p2CA;IACE,iCAAiC;EChq2CnC;;EDmq2CA;IACE,+BAA+B;ECpq2CjC;;EDuq2CA;IACE,iCAAiC;ECxq2CnC;;ED2q2CA;IACE,+BAA+B;EC5q2CjC;;ED+q2CA;IACE,iCAAiC;EChr2CnC;;EDmr2CA;IACE,+BAA+B;ECpr2CjC;;EDur2CA;IACE,iCAAiC;ECxr2CnC;;ED2r2CA;IACE,+BAA+B;EC5r2CjC;;ED+r2CA;IACE,iCAAiC;EChs2CnC;;EDms2CA;IACE,+BAA+B;ECps2CjC;;EDus2CA;IACE,iCAAiC;ECxs2CnC;;ED2s2CA;IACE,+BAA+B;EC5s2CjC;;ED+s2CA;IACE,iCAAiC;ECht2CnC;;EDmt2CA;IACE,+BAA+B;ECpt2CjC;;EDut2CA;IACE,iCAAiC;ECrs2CnC;;EDws2CA;IACE,+BAA+B;ECzs2CjC;;ED4s2CA;IACE,iCAAiC;EC7s2CnC;;EDgt2CA;IACE,4BAA4B;ECjt2C9B;;EDot2CA;IACE,+BAA+B;ECrt2CjC;;EDwt2CA;IACE,8BAA8B;ECzt2ChC;;ED4t2CA;IACE,4BAA4B;EC7t2C9B;;EDgu2CA;IACE,8BAA8B;ECju2ChC;;EDou2CA;IACE,4BAA4B;ECru2C9B;;EDwu2CA;IACE,8BAA8B;ECzu2ChC;;ED4u2CA;IACE,4BAA4B;EC7u2C9B;;EDgv2CA;IACE,8BAA8B;ECjv2ChC;;EDov2CA;IACE,4BAA4B;ECrv2C9B;;EDwv2CA;IACE,8BAA8B;ECzv2ChC;;ED4v2CA;IACE,4BAA4B;EC7v2C9B;;EDgw2CA;IACE,8BAA8B;ECjw2ChC;;EDow2CA;IACE,4BAA4B;ECrw2C9B;;EDww2CA;IACE,8BAA8B;ECzw2ChC;;ED4w2CA;IACE,4BAA4B;EC7w2C9B;;EDgx2CA;IACE,8BAA8B;ECjx2ChC;;EDox2CA;IACE,4BAA4B;ECrx2C9B;;EDwx2CA;IACE,8BAA8B;ECzx2ChC;;ED4x2CA;IACE,4BAA4B;EC7x2C9B;;EDgy2CA;IACE,8BAA8B;ECjy2ChC;;EDoy2CA;IACE,6BAA6B;ECry2C/B;;EDwy2CA;IACE,+BAA+B;ECzy2CjC;;ED4y2CA;IACE,6BAA6B;EC7y2C/B;;EDgz2CA;IACE,+BAA+B;ECjz2CjC;;EDoz2CA;IACE,6BAA6B;ECrz2C/B;;EDwz2CA;IACE,+BAA+B;ECzz2CjC;;ED4z2CA;IACE,6BAA6B;EC7z2C/B;;EDg02CA;IACE,+BAA+B;ECj02CjC;;EDo02CA;IACE,6BAA6B;ECr02C/B;;EDw02CA;IACE,+BAA+B;ECz02CjC;;ED402CA;IACE,6BAA6B;EC702C/B;;EDg12CA;IACE,+BAA+B;ECj12CjC;;EDo12CA;IACE,6BAA6B;ECr12C/B;;EDw12CA;IACE,+BAA+B;ECz12CjC;;ED412CA;IACE,6BAA6B;EC712C/B;;EDg22CA;IACE,+BAA+B;ECj22CjC;;EDo22CA;IACE,6BAA6B;ECr22C/B;;EDw22CA;IACE,+BAA+B;ECz22CjC;;ED422CA;IACE,6BAA6B;EC722C/B;;EDg32CA;IACE,+BAA+B;ECj32CjC;;EDo32CA;IACE,6BAA6B;ECr32C/B;;EDw32CA;IACE,+BAA+B;ECz32CjC;;ED432CA;IACE,6BAA6B;EC732C/B;;EDg42CA;IACE,+BAA+B;ECj42CjC;;EDo42CA;IACE,6BAA6B;ECr42C/B;;EDw42CA;IACE,+BAA+B;ECz42CjC;;ED442CA;IACE,6BAA6B;EC742C/B;;EDg52CA;IACE,+BAA+B;ECj52CjC;;EDo52CA;IACE,6BAA6B;ECr52C/B;;EDw52CA;IACE,+BAA+B;ECz52CjC;;ED452CA;IACE,6BAA6B;EC752C/B;;EDg62CA;IACE,+BAA+B;ECj62CjC;;EDo62CA;IACE,6BAA6B;ECr62C/B;;EDw62CA;IACE,+BAA+B;ECz62CjC;;ED462CA;IACE,6BAA6B;EC762C/B;;EDg72CA;IACE,+BAA+B;ECj72CjC;;EDo72CA;IACE,6BAA6B;ECr72C/B;;EDw72CA;IACE,+BAA+B;ECz72CjC;;ED472CA;IACE,6BAA6B;EC772C/B;;EDg82CA;IACE,+BAA+B;ECj82CjC;;EDo82CA;IACE,6BAA6B;ECr82C/B;;EDw82CA;IACE,+BAA+B;ECz82CjC;;ED482CA;IACE,6BAA6B;EC782C/B;;EDg92CA;IACE,+BAA+B;ECj92CjC;;EDo92CA;IACE,6BAA6B;ECr92C/B;;EDw92CA;IACE,+BAA+B;ECz92CjC;;ED492CA;IACE,6BAA6B;EC792C/B;;EDg+2CA;IACE,+BAA+B;ECj+2CjC;;EDo+2CA;IACE,6BAA6B;ECr+2C/B;;EDw+2CA;IACE,+BAA+B;ECz+2CjC;;ED4+2CA;IACE,6BAA6B;EC7+2C/B;;EDg/2CA;IACE,+BAA+B;ECj/2CjC;;EDo/2CA;IACE,6BAA6B;ECr/2C/B;;EDw/2CA;IACE,+BAA+B;ECz/2CjC;;ED4/2CA;IACE,6BAA6B;EC7/2C/B;;EDgg3CA;IACE,+BAA+B;ECjg3CjC;;EDog3CA;IACE,6BAA6B;ECrg3C/B;;EDwg3CA;IACE,+BAA+B;ECzg3CjC;;ED4g3CA;IACE,6BAA6B;EC7g3C/B;;EDgh3CA;IACE,+BAA+B;ECjh3CjC;;EDoh3CA;IACE,6BAA6B;ECrh3C/B;;EDwh3CA;IACE,+BAA+B;ECzh3CjC;;ED4h3CA;IACE,6BAA6B;EC7h3C/B;;EDgi3CA;IACE,+BAA+B;ECji3CjC;;EDoi3CA;IACE,6BAA6B;ECri3C/B;;EDwi3CA;IACE,+BAA+B;ECzi3CjC;;ED4i3CA;IACE,6BAA6B;EC7i3C/B;;EDgj3CA;IACE,+BAA+B;ECjj3CjC;;EDoj3CA;IACE,6BAA6B;ECrj3C/B;;EDwj3CA;IACE,+BAA+B;ECzj3CjC;;ED4j3CA;IACE,6BAA6B;EC7j3C/B;;EDgk3CA;IACE,+BAA+B;ECjk3CjC;;EDok3CA;IACE,6BAA6B;ECrk3C/B;;EDwk3CA;IACE,+BAA+B;ECzk3CjC;;ED4k3CA;IACE,6BAA6B;EC7k3C/B;;EDgl3CA;IACE,+BAA+B;ECjl3CjC;;EDol3CA;IACE,6BAA6B;ECrl3C/B;;EDwl3CA;IACE,+BAA+B;ECzl3CjC;;ED4l3CA;IACE,6BAA6B;EC7l3C/B;;EDgm3CA;IACE,+BAA+B;ECjm3CjC;;EDom3CA;IACE,6BAA6B;ECrm3C/B;;EDwm3CA;IACE,+BAA+B;ECzm3CjC;;ED4m3CA;IACE,6BAA6B;EC7m3C/B;;EDgn3CA;IACE,+BAA+B;ECjn3CjC;;EDon3CA;IACE,6BAA6B;ECrn3C/B;;EDwn3CA;IACE,+BAA+B;ECzn3CjC;;ED4n3CA;IACE,6BAA6B;EC7n3C/B;;EDgo3CA;IACE,+BAA+B;ECjo3CjC;;EDoo3CA;IACE,6BAA6B;ECro3C/B;;EDwo3CA;IACE,+BAA+B;ECzo3CjC;;ED4o3CA;IACE,6BAA6B;EC7o3C/B;;EDgp3CA;IACE,+BAA+B;ECjp3CjC;;EDop3CA;IACE,6BAA6B;ECrp3C/B;;EDwp3CA;IACE,+BAA+B;ECzp3CjC;;ED4p3CA;IACE,6BAA6B;EC7p3C/B;;EDgq3CA;IACE,+BAA+B;ECjq3CjC;;EDoq3CA;IACE,6BAA6B;ECrq3C/B;;EDwq3CA;IACE,+BAA+B;ECzq3CjC;;ED4q3CA;IACE,6BAA6B;EC7q3C/B;;EDgr3CA;IACE,+BAA+B;ECjr3CjC;;EDor3CA;IACE,6BAA6B;ECrr3C/B;;EDwr3CA;IACE,+BAA+B;ECzr3CjC;;ED4r3CA;IACE,6BAA6B;EC7r3C/B;;EDgs3CA;IACE,+BAA+B;ECjs3CjC;;EDos3CA;IACE,6BAA6B;ECrs3C/B;;EDws3CA;IACE,+BAA+B;ECzs3CjC;;ED4s3CA;IACE,6BAA6B;EC7s3C/B;;EDgt3CA;IACE,+BAA+B;ECjt3CjC;;EDot3CA;IACE,6BAA6B;ECrt3C/B;;EDwt3CA;IACE,+BAA+B;ECzt3CjC;;ED4t3CA;IACE,6BAA6B;EC7t3C/B;;EDgu3CA;IACE,+BAA+B;ECju3CjC;;EDou3CA;IACE,6BAA6B;ECru3C/B;;EDwu3CA;IACE,+BAA+B;ECzu3CjC;;ED4u3CA;IACE,6BAA6B;EC7u3C/B;;EDgv3CA;IACE,+BAA+B;ECjv3CjC;;EDov3CA;IACE,6BAA6B;ECrv3C/B;;EDwv3CA;IACE,+BAA+B;ECzv3CjC;;ED4v3CA;IACE,6BAA6B;EC7v3C/B;;EDgw3CA;IACE,+BAA+B;ECjw3CjC;;EDow3CA;IACE,6BAA6B;ECrw3C/B;;EDww3CA;IACE,+BAA+B;ECzw3CjC;;ED4w3CA;IACE,6BAA6B;EC7w3C/B;;EDgx3CA;IACE,+BAA+B;ECjx3CjC;;EDox3CA;IACE,6BAA6B;ECrx3C/B;;EDwx3CA;IACE,+BAA+B;ECzx3CjC;;ED4x3CA;IACE,6BAA6B;EC7x3C/B;;EDgy3CA;IACE,+BAA+B;ECjy3CjC;;EDoy3CA;IACE,6BAA6B;ECry3C/B;;EDwy3CA;IACE,+BAA+B;ECzy3CjC;;ED4y3CA;IACE,6BAA6B;EC7y3C/B;;EDgz3CA;IACE,+BAA+B;ECjz3CjC;;EDoz3CA;IACE,6BAA6B;ECrz3C/B;;EDwz3CA;IACE,+BAA+B;ECzz3CjC;;ED4z3CA;IACE,6BAA6B;EC7z3C/B;;EDg03CA;IACE,+BAA+B;ECj03CjC;;EDo03CA;IACE,6BAA6B;ECr03C/B;;EDw03CA;IACE,+BAA+B;ECtz3CjC;;EDyz3CA;IACE,6BAA6B;EC1z3C/B;;ED6z3CA;IACE,+BAA+B;EC9z3CjC;;EDi03CA;IACE,6BAA6B;ECl03C/B;;EDq03CA;IACE,gCAAgC;ECt03ClC;;EDy03CA;IACE,+BAA+B;EC103CjC;;ED603CA;IACE,6BAA6B;EC903C/B;;EDi13CA;IACE,+BAA+B;ECl13CjC;;EDq13CA;IACE,6BAA6B;ECt13C/B;;EDy13CA;IACE,+BAA+B;EC113CjC;;ED613CA;IACE,6BAA6B;EC913C/B;;EDi23CA;IACE,+BAA+B;ECl23CjC;;EDq23CA;IACE,6BAA6B;ECt23C/B;;EDy23CA;IACE,+BAA+B;EC123CjC;;ED623CA;IACE,6BAA6B;EC923C/B;;EDi33CA;IACE,+BAA+B;ECl33CjC;;EDq33CA;IACE,6BAA6B;ECt33C/B;;EDy33CA;IACE,+BAA+B;EC133CjC;;ED633CA;IACE,6BAA6B;EC933C/B;;EDi43CA;IACE,+BAA+B;ECl43CjC;;EDq43CA;IACE,6BAA6B;ECt43C/B;;EDy43CA;IACE,+BAA+B;EC143CjC;;ED643CA;IACE,6BAA6B;EC943C/B;;EDi53CA;IACE,+BAA+B;ECl53CjC;;EDq53CA;IACE,8BAA8B;ECt53ChC;;EDy53CA;IACE,gCAAgC;EC153ClC;;ED653CA;IACE,8BAA8B;EC953ChC;;EDi63CA;IACE,gCAAgC;ECl63ClC;;EDq63CA;IACE,8BAA8B;ECt63ChC;;EDy63CA;IACE,gCAAgC;EC163ClC;;ED663CA;IACE,8BAA8B;EC963ChC;;EDi73CA;IACE,gCAAgC;ECl73ClC;;EDq73CA;IACE,8BAA8B;ECt73ChC;;EDy73CA;IACE,gCAAgC;EC173ClC;;ED673CA;IACE,8BAA8B;EC973ChC;;EDi83CA;IACE,gCAAgC;ECl83ClC;;EDq83CA;IACE,8BAA8B;ECt83ChC;;EDy83CA;IACE,gCAAgC;EC183ClC;;ED683CA;IACE,8BAA8B;EC983ChC;;EDi93CA;IACE,gCAAgC;ECl93ClC;;EDq93CA;IACE,8BAA8B;ECt93ChC;;EDy93CA;IACE,gCAAgC;EC193ClC;;ED693CA;IACE,8BAA8B;EC993ChC;;EDi+3CA;IACE,gCAAgC;ECl+3ClC;;EDq+3CA;IACE,8BAA8B;ECt+3ChC;;EDy+3CA;IACE,gCAAgC;EC1+3ClC;;ED6+3CA;IACE,8BAA8B;EC9+3ChC;;EDi/3CA;IACE,gCAAgC;ECl/3ClC;;EDq/3CA;IACE,8BAA8B;ECt/3ChC;;EDy/3CA;IACE,gCAAgC;EC1/3ClC;;ED6/3CA;IACE,8BAA8B;EC9/3ChC;;EDig4CA;IACE,gCAAgC;EClg4ClC;;EDqg4CA;IACE,8BAA8B;ECtg4ChC;;EDyg4CA;IACE,gCAAgC;EC1g4ClC;;ED6g4CA;IACE,8BAA8B;EC9g4ChC;;EDih4CA;IACE,gCAAgC;EClh4ClC;;EDqh4CA;IACE,8BAA8B;ECth4ChC;;EDyh4CA;IACE,gCAAgC;EC1h4ClC;;ED6h4CA;IACE,8BAA8B;EC9h4ChC;;EDii4CA;IACE,gCAAgC;ECli4ClC;;EDqi4CA;IACE,8BAA8B;ECti4ChC;;EDyi4CA;IACE,gCAAgC;EC1i4ClC;;ED6i4CA;IACE,8BAA8B;EC9i4ChC;;EDij4CA;IACE,gCAAgC;EClj4ClC;;EDqj4CA;IACE,8BAA8B;ECtj4ChC;;EDyj4CA;IACE,gCAAgC;EC1j4ClC;;ED6j4CA;IACE,8BAA8B;EC9j4ChC;;EDik4CA;IACE,gCAAgC;EClk4ClC;;EDqk4CA;IACE,8BAA8B;ECtk4ChC;;EDyk4CA;IACE,gCAAgC;EC1k4ClC;;ED6k4CA;IACE,8BAA8B;EC9k4ChC;;EDil4CA;IACE,gCAAgC;ECll4ClC;;EDql4CA;IACE,8BAA8B;ECtl4ChC;;EDyl4CA;IACE,gCAAgC;EC1l4ClC;;ED6l4CA;IACE,8BAA8B;EC9l4ChC;;EDim4CA;IACE,gCAAgC;EClm4ClC;;EDqm4CA;IACE,8BAA8B;ECtm4ChC;;EDym4CA;IACE,gCAAgC;EC1m4ClC;;ED6m4CA;IACE,8BAA8B;EC9m4ChC;;EDin4CA;IACE,gCAAgC;ECln4ClC;;EDqn4CA;IACE,8BAA8B;ECtn4ChC;;EDyn4CA;IACE,gCAAgC;EC1n4ClC;;ED6n4CA;IACE,8BAA8B;EC9n4ChC;;EDio4CA;IACE,gCAAgC;EClo4ClC;;EDqo4CA;IACE,8BAA8B;ECto4ChC;;EDyo4CA;IACE,gCAAgC;EC1o4ClC;;ED6o4CA;IACE,8BAA8B;EC9o4ChC;;EDip4CA;IACE,gCAAgC;EClp4ClC;;EDqp4CA;IACE,8BAA8B;ECtp4ChC;;EDyp4CA;IACE,gCAAgC;EC1p4ClC;;ED6p4CA;IACE,8BAA8B;EC9p4ChC;;EDiq4CA;IACE,gCAAgC;EClq4ClC;;EDqq4CA;IACE,8BAA8B;ECtq4ChC;;EDyq4CA;IACE,gCAAgC;EC1q4ClC;;ED6q4CA;IACE,8BAA8B;EC9q4ChC;;EDir4CA;IACE,gCAAgC;EClr4ClC;;EDqr4CA;IACE,8BAA8B;ECtr4ChC;;EDyr4CA;IACE,gCAAgC;EC1r4ClC;;ED6r4CA;IACE,8BAA8B;EC9r4ChC;;EDis4CA;IACE,gCAAgC;ECls4ClC;;EDqs4CA;IACE,8BAA8B;ECts4ChC;;EDys4CA;IACE,gCAAgC;EC1s4ClC;;ED6s4CA;IACE,8BAA8B;EC9s4ChC;;EDit4CA;IACE,gCAAgC;EClt4ClC;;EDqt4CA;IACE,8BAA8B;ECtt4ChC;;EDyt4CA;IACE,gCAAgC;EC1t4ClC;;ED6t4CA;IACE,8BAA8B;EC9t4ChC;;EDiu4CA;IACE,gCAAgC;EClu4ClC;;EDqu4CA;IACE,8BAA8B;ECtu4ChC;;EDyu4CA;IACE,gCAAgC;EC1u4ClC;;ED6u4CA;IACE,8BAA8B;EC9u4ChC;;EDiv4CA;IACE,gCAAgC;EClv4ClC;;EDqv4CA;IACE,8BAA8B;ECtv4ChC;;EDyv4CA;IACE,gCAAgC;EC1v4ClC;;ED6v4CA;IACE,8BAA8B;EC9v4ChC;;EDiw4CA;IACE,gCAAgC;EClw4ClC;;EDqw4CA;IACE,8BAA8B;ECtw4ChC;;EDyw4CA;IACE,gCAAgC;EC1w4ClC;;ED6w4CA;IACE,8BAA8B;EC9w4ChC;;EDix4CA;IACE,gCAAgC;EClx4ClC;;EDqx4CA;IACE,8BAA8B;ECtx4ChC;;EDyx4CA;IACE,gCAAgC;EC1x4ClC;;ED6x4CA;IACE,8BAA8B;EC9x4ChC;;EDiy4CA;IACE,gCAAgC;ECly4ClC;;EDqy4CA;IACE,8BAA8B;ECty4ChC;;EDyy4CA;IACE,gCAAgC;EC1y4ClC;;ED6y4CA;IACE,8BAA8B;EC9y4ChC;;EDiz4CA;IACE,gCAAgC;EClz4ClC;;EDqz4CA;IACE,8BAA8B;ECtz4ChC;;EDyz4CA;IACE,gCAAgC;EC1z4ClC;;ED6z4CA;IACE,8BAA8B;EC9z4ChC;;EDi04CA;IACE,gCAAgC;ECl04ClC;;EDq04CA;IACE,8BAA8B;ECt04ChC;;EDy04CA;IACE,gCAAgC;EC104ClC;;ED604CA;IACE,8BAA8B;EC904ChC;;EDi14CA;IACE,gCAAgC;ECl14ClC;;EDq14CA;IACE,8BAA8B;ECt14ChC;;EDy14CA;IACE,gCAAgC;EC114ClC;;ED614CA;IACE,8BAA8B;EC914ChC;;EDi24CA;IACE,gCAAgC;ECl24ClC;;EDq24CA;IACE,8BAA8B;ECt24ChC;;EDy24CA;IACE,gCAAgC;EC124ClC;;ED624CA;IACE,8BAA8B;EC924ChC;;EDi34CA;IACE,gCAAgC;ECl34ClC;;EDq34CA;IACE,8BAA8B;ECt34ChC;;EDy34CA;IACE,gCAAgC;EC134ClC;;ED634CA;IACE,8BAA8B;EC934ChC;;EDi44CA;IACE,gCAAgC;ECl44ClC;;EDq44CA;IACE,8BAA8B;ECt44ChC;;EDy44CA;IACE,gCAAgC;EC144ClC;;ED644CA;IACE,8BAA8B;EC944ChC;;EDi54CA;IACE,gCAAgC;ECl54ClC;;EDq54CA;IACE,8BAA8B;ECt54ChC;;EDy54CA;IACE,gCAAgC;EC154ClC;;ED654CA;IACE,8BAA8B;EC954ChC;;EDi64CA;IACE,gCAAgC;ECl64ClC;;EDq64CA;IACE,8BAA8B;ECt64ChC;;EDy64CA;IACE,gCAAgC;EC164ClC;;ED664CA;IACE,8BAA8B;EC964ChC;;EDi74CA;IACE,gCAAgC;ECl74ClC;;EDq74CA;IACE,8BAA8B;ECt74ChC;;EDy74CA;IACE,gCAAgC;ECv64ClC;;ED064CA;IACE,8BAA8B;EAChC;;EAEA;IC564CC,gCAAsC;ED864CvC;;ECh74CA;IACC,4BAAa;IACb,6BAAc;EDm74Cf;;ECr74CA;IACC,+BAAqC;IACrC,gCAAsC;EDw74CvC;;EC174CA;IACC,8BAAqC;IACrC,+BAAsC;ED674CvC;;EC/74CA;IACC,4BAAqC;IACrC,6BAAsC;EDk84CvC;;ECp84CA;IACC,8BAAqC;IACrC,+BAAsC;EDu84CvC;;ECz84CA;IACC,4BAAqC;IACrC,6BAAsC;ED484CvC;;EC984CA;IACC,8BAAqC;IACrC,+BAAsC;EDi94CvC;;ECn94CA;IACC,4BAAqC;IACrC,6BAAsC;EDs94CvC;;ECx94CA;IACC,8BAAqC;IACrC,+BAAsC;ED294CvC;;EC794CA;IACC,4BAAqC;IACrC,6BAAsC;EDg+4CvC;;ECl+4CA;IACC,8BAAqC;IACrC,+BAAsC;EDq+4CvC;;ECv+4CA;IACC,4BAAqC;IACrC,6BAAsC;ED0+4CvC;;EC5+4CA;IACC,8BAAqC;IACrC,+BAAsC;ED++4CvC;;ECj/4CA;IACC,4BAAqC;IACrC,6BAAsC;EDo/4CvC;;ECt/4CA;IACC,8BAAqC;IACrC,+BAAsC;EDy/4CvC;;EC3/4CA;IACC,4BAAqC;IACrC,6BAAsC;ED8/4CvC;;EChg5CA;IACC,8BAAqC;IACrC,+BAAsC;EDmg5CvC;;ECrg5CA;IACC,4BAAqC;IACrC,6BAAsC;EDwg5CvC;;EC1g5CA;IACC,8BAAqC;IACrC,+BAAsC;ED6g5CvC;;EC/g5CA;IACC,4BAAa;IACb,6BAAc;EDkh5Cf;;ECph5CA;IACC,8BAAa;IACb,+BAAc;EDuh5Cf;;ECzh5CA;IACC,6BAAqC;IACrC,8BAAsC;ED4h5CvC;;EC9h5CA;IACC,+BAAqC;IACrC,gCAAsC;EDii5CvC;;ECni5CA;IACC,6BAAqC;IACrC,8BAAsC;EDsi5CvC;;ECxi5CA;IACC,+BAAqC;IACrC,gCAAsC;ED2i5CvC;;EC7i5CA;IACC,6BAAqC;IACrC,8BAAsC;EDgj5CvC;;EClj5CA;IACC,+BAAqC;IACrC,gCAAsC;EDqj5CvC;;ECvj5CA;IACC,6BAAqC;IACrC,8BAAsC;ED0j5CvC;;EC5j5CA;IACC,+BAAqC;IACrC,gCAAsC;ED+j5CvC;;ECjk5CA;IACC,6BAAqC;IACrC,8BAAsC;EDok5CvC;;ECtk5CA;IACC,+BAAqC;IACrC,gCAAsC;EDyk5CvC;;EC3k5CA;IACC,6BAAqC;IACrC,8BAAsC;ED8k5CvC;;EChl5CA;IACC,+BAAqC;IACrC,gCAAsC;EDml5CvC;;ECrl5CA;IACC,6BAAqC;IACrC,8BAAsC;EDwl5CvC;;EC1l5CA;IACC,+BAAqC;IACrC,gCAAsC;ED6l5CvC;;EC/l5CA;IACC,6BAAqC;IACrC,8BAAsC;EDkm5CvC;;ECpm5CA;IACC,+BAAqC;IACrC,gCAAsC;EDum5CvC;;ECzm5CA;IACC,6BAAqC;IACrC,8BAAsC;ED4m5CvC;;EC9m5CA;IACC,+BAAqC;IACrC,gCAAsC;EDin5CvC;;ECnn5CA;IACC,6BAAqC;IACrC,8BAAsC;EDsn5CvC;;ECxn5CA;IACC,+BAAqC;IACrC,gCAAsC;ED2n5CvC;;EC7n5CA;IACC,6BAAqC;IACrC,8BAAsC;EDgo5CvC;;EClo5CA;IACC,+BAAqC;IACrC,gCAAsC;EDqo5CvC;;ECvo5CA;IACC,6BAAqC;IACrC,8BAAsC;ED0o5CvC;;EC5o5CA;IACC,+BAAqC;IACrC,gCAAsC;ED+o5CvC;;ECjp5CA;IACC,6BAAqC;IACrC,8BAAsC;EDop5CvC;;ECtp5CA;IACC,+BAAqC;IACrC,gCAAsC;EDyp5CvC;;EC3p5CA;IACC,6BAAqC;IACrC,8BAAsC;ED8p5CvC;;EChq5CA;IACC,+BAAqC;IACrC,gCAAsC;EDmq5CvC;;ECrq5CA;IACC,6BAAqC;IACrC,8BAAsC;EDwq5CvC;;EC1q5CA;IACC,+BAAqC;IACrC,gCAAsC;ED6q5CvC;;EC/q5CA;IACC,6BAAqC;IACrC,8BAAsC;EDkr5CvC;;ECpr5CA;IACC,+BAAqC;IACrC,gCAAsC;EDur5CvC;;ECzr5CA;IACC,6BAAqC;IACrC,8BAAsC;ED4r5CvC;;EC9r5CA;IACC,+BAAqC;IACrC,gCAAsC;EDis5CvC;;ECns5CA;IACC,6BAAqC;IACrC,8BAAsC;EDss5CvC;;ECxs5CA;IACC,+BAAqC;IACrC,gCAAsC;ED2s5CvC;;EC7s5CA;IACC,6BAAqC;IACrC,8BAAsC;EDgt5CvC;;EClt5CA;IACC,+BAAqC;IACrC,gCAAsC;EDqt5CvC;;ECvt5CA;IACC,6BAAqC;IACrC,8BAAsC;ED0t5CvC;;EC5t5CA;IACC,+BAAqC;IACrC,gCAAsC;ED+t5CvC;;ECju5CA;IACC,6BAAqC;IACrC,8BAAsC;EDou5CvC;;ECtu5CA;IACC,+BAAqC;IACrC,gCAAsC;EDyu5CvC;;EC3u5CA;IACC,6BAAqC;IACrC,8BAAsC;ED8u5CvC;;EChv5CA;IACC,+BAAqC;IACrC,gCAAsC;EDmv5CvC;;ECrv5CA;IACC,6BAAqC;IACrC,8BAAsC;EDwv5CvC;;EC1v5CA;IACC,+BAAqC;IACrC,gCAAsC;ED6v5CvC;;EC/v5CA;IACC,6BAAqC;IACrC,8BAAsC;EDkw5CvC;;ECpw5CA;IACC,+BAAqC;IACrC,gCAAsC;EDuw5CvC;;ECzw5CA;IACC,6BAAqC;IACrC,8BAAsC;ED4w5CvC;;EC9w5CA;IACC,+BAAqC;IACrC,gCAAsC;EDix5CvC;;ECnx5CA;IACC,6BAAqC;IACrC,8BAAsC;EDsx5CvC;;ECxx5CA;IACC,+BAAqC;IACrC,gCAAsC;ED2x5CvC;;EC7x5CA;IACC,6BAAqC;IACrC,8BAAsC;EDgy5CvC;;ECly5CA;IACC,+BAAqC;IACrC,gCAAsC;EDqy5CvC;;ECvy5CA;IACC,6BAAqC;IACrC,8BAAsC;ED0y5CvC;;EC5y5CA;IACC,+BAAqC;IACrC,gCAAsC;ED+y5CvC;;ECjz5CA;IACC,6BAAqC;IACrC,8BAAsC;EDoz5CvC;;ECtz5CA;IACC,+BAAqC;IACrC,gCAAsC;EDyz5CvC;;EC3z5CA;IACC,6BAAqC;IACrC,8BAAsC;ED8z5CvC;;ECh05CA;IACC,+BAAqC;IACrC,gCAAsC;EDm05CvC;;ECr05CA;IACC,6BAAqC;IACrC,8BAAsC;EDw05CvC;;EC105CA;IACC,+BAAqC;IACrC,gCAAsC;ED605CvC;;EC/05CA;IACC,6BAAqC;IACrC,8BAAsC;EDk15CvC;;ECp15CA;IACC,+BAAqC;IACrC,gCAAsC;EDu15CvC;;ECz15CA;IACC,6BAAqC;IACrC,8BAAsC;ED415CvC;;EC915CA;IACC,+BAAqC;IACrC,gCAAsC;EDi25CvC;;ECn25CA;IACC,6BAAqC;IACrC,8BAAsC;EDs25CvC;;ECx25CA;IACC,+BAAqC;IACrC,gCAAsC;ED225CvC;;EC725CA;IACC,6BAAqC;IACrC,8BAAsC;EDg35CvC;;ECl35CA;IACC,+BAAqC;IACrC,gCAAsC;EDq35CvC;;ECv35CA;IACC,6BAAqC;IACrC,8BAAsC;ED035CvC;;EC535CA;IACC,+BAAqC;IACrC,gCAAsC;ED+35CvC;;ECj45CA;IACC,6BAAqC;IACrC,8BAAsC;EDo45CvC;;ECt45CA;IACC,+BAAqC;IACrC,gCAAsC;EDy45CvC;;EC345CA;IACC,6BAAqC;IACrC,8BAAsC;ED845CvC;;ECh55CA;IACC,+BAAqC;IACrC,gCAAsC;EDm55CvC;;ECr55CA;IACC,6BAAqC;IACrC,8BAAsC;EDw55CvC;;EC155CA;IACC,+BAAqC;IACrC,gCAAsC;ED655CvC;;EC/55CA;IACC,6BAAqC;IACrC,8BAAsC;EDk65CvC;;ECp65CA;IACC,+BAAqC;IACrC,gCAAsC;EDu65CvC;;ECz65CA;IACC,6BAAqC;IACrC,8BAAsC;ED465CvC;;EC965CA;IACC,+BAAqC;IACrC,gCAAsC;EDi75CvC;;ECn75CA;IACC,6BAAqC;IACrC,8BAAsC;EDs75CvC;;ECx75CA;IACC,+BAAqC;IACrC,gCAAsC;ED275CvC;;EC775CA;IACC,6BAAqC;IACrC,8BAAsC;EDg85CvC;;ECl85CA;IACC,+BAAqC;IACrC,gCAAsC;EDq85CvC;;ECv85CA;IACC,6BAAqC;IACrC,8BAAsC;ED085CvC;;EC585CA;IACC,+BAAqC;IACrC,gCAAsC;ED+85CvC;;ECj95CA;IACC,6BAAqC;IACrC,8BAAsC;EDo95CvC;;ECt95CA;IACC,+BAAqC;IACrC,gCAAsC;EDy95CvC;;EC395CA;IACC,6BAAqC;IACrC,8BAAsC;ED895CvC;;ECh+5CA;IACC,+BAAqC;IACrC,gCAAsC;EDm+5CvC;;ECr+5CA;IACC,6BAAqC;IACrC,8BAAsC;EDw+5CvC;;EC1+5CA;IACC,+BAAqC;IACrC,gCAAsC;ED6+5CvC;;EC/+5CA;IACC,6BAAqC;IACrC,8BAAsC;EDk/5CvC;;ECp/5CA;IACC,+BAAqC;IACrC,gCAAsC;EDu/5CvC;;ECz/5CA;IACC,6BAAqC;IACrC,8BAAsC;ED4/5CvC;;EC9/5CA;IACC,+BAAqC;IACrC,gCAAsC;EDig6CvC;;ECng6CA;IACC,6BAAqC;IACrC,8BAAsC;EDsg6CvC;;ECxg6CA;IACC,+BAAqC;IACrC,gCAAsC;ED2g6CvC;;EC7g6CA;IACC,6BAAqC;IACrC,8BAAsC;EDgh6CvC;;EClh6CA;IACC,+BAAqC;IACrC,gCAAsC;EDqh6CvC;;ECvh6CA;IACC,6BAAqC;IACrC,8BAAsC;ED0h6CvC;;EC5h6CA;IACC,+BAAqC;IACrC,gCAAsC;ED+h6CvC;;ECji6CA;IACC,6BAAqC;IACrC,8BAAsC;EDoi6CvC;;ECti6CA;IACC,+BAAqC;IACrC,gCAAsC;EDyi6CvC;;EC3i6CA;IACC,6BAAqC;IACrC,8BAAsC;ED8i6CvC;;EChj6CA;IACC,+BAAqC;IACrC,gCAAsC;EDmj6CvC;;ECrj6CA;IACC,6BAAqC;IACrC,8BAAsC;EDwj6CvC;;EC1j6CA;IACC,+BAAqC;IACrC,gCAAsC;ED6j6CvC;;EC/j6CA;IACC,6BAAqC;IACrC,8BAAsC;EDkk6CvC;;ECpk6CA;IACC,+BAAqC;IACrC,gCAAsC;EDuk6CvC;;ECzk6CA;IACC,6BAAqC;IACrC,8BAAsC;ED4k6CvC;;EC9k6CA;IACC,+BAAqC;IACrC,gCAAsC;EDil6CvC;;ECnl6CA;IACC,6BAAqC;IACrC,8BAAsC;EDsl6CvC;;ECxl6CA;IACC,+BAAqC;IACrC,gCAAsC;ED2l6CvC;;EC7l6CA;IACC,6BAAqC;IACrC,8BAAsC;EDgm6CvC;;EClm6CA;IACC,+BAAqC;IACrC,gCAAsC;EDqm6CvC;;ECvm6CA;IACC,6BAAqC;IACrC,8BAAsC;ED0m6CvC;;EC5m6CA;IACC,+BAAqC;IACrC,gCAAsC;ED+m6CvC;;ECjn6CA;IACC,6BAAqC;IACrC,8BAAsC;EDon6CvC;;ECtn6CA;IACC,+BAAqC;IACrC,gCAAsC;EDyn6CvC;;EC3n6CA;IACC,6BAAqC;IACrC,8BAAsC;ED8n6CvC;;ECho6CA;IACC,+BAAqC;IACrC,gCAAsC;EDmo6CvC;;ECro6CA;IACC,6BAAqC;IACrC,8BAAsC;EDwo6CvC;;EC1o6CA;IACC,+BAAqC;IACrC,gCAAsC;ED6o6CvC;;EC/o6CA;IACC,6BAAqC;IACrC,8BAAsC;EDkp6CvC;;ECpp6CA;IACC,+BAAqC;IACrC,gCAAsC;EDup6CvC;;ECzp6CA;IACC,6BAAqC;IACrC,8BAAsC;ED4p6CvC;;EC9p6CA;IACC,+BAAqC;IACrC,gCAAsC;EDiq6CvC;;ECnq6CA;IACC,6BAAqC;IACrC,8BAAsC;EDsq6CvC;;ECxq6CA;IACC,+BAAqC;IACrC,gCAAsC;ED2q6CvC;;EC7q6CA;IACC,6BAAqC;IACrC,8BAAsC;EDgr6CvC;;EClr6CA;IACC,+BAAqC;IACrC,gCAAsC;EDqr6CvC;;ECvr6CA;IACC,6BAAqC;IACrC,8BAAsC;ED0r6CvC;;EC5r6CA;IACC,+BAAqC;IACrC,gCAAsC;ED+r6CvC;;ECjs6CA;IACC,6BAAqC;IACrC,8BAAsC;EDos6CvC;;ECts6CA;IACC,+BAAqC;IACrC,gCAAsC;EDys6CvC;;ECvr6CA;IACC,6BAAoC;IACpC,8BAAuC;ED0r6CxC;;EC5r6CA;IACC,+BAAoC;IACpC,gCAAe;ED+r6ChB;;ECjs6CA;IACC,2BAAY;IACZ,8BAAe;EDos6ChB;;ECts6CA;IACC,8BAAoC;IACpC,iCAAuC;EDys6CxC;;EC3s6CA;IACC,6BAAoC;IACpC,gCAAuC;ED8s6CxC;;ECht6CA;IACC,2BAAoC;IACpC,8BAAuC;EDmt6CxC;;ECrt6CA;IACC,6BAAoC;IACpC,gCAAuC;EDwt6CxC;;EC1t6CA;IACC,2BAAoC;IACpC,8BAAuC;ED6t6CxC;;EC/t6CA;IACC,6BAAoC;IACpC,gCAAuC;EDku6CxC;;ECpu6CA;IACC,2BAAoC;IACpC,8BAAuC;EDuu6CxC;;ECzu6CA;IACC,6BAAoC;IACpC,gCAAuC;ED4u6CxC;;EC9u6CA;IACC,2BAAoC;IACpC,8BAAuC;EDiv6CxC;;ECnv6CA;IACC,6BAAoC;IACpC,gCAAuC;EDsv6CxC;;ECxv6CA;IACC,2BAAoC;IACpC,8BAAuC;ED2v6CxC;;EC7v6CA;IACC,6BAAoC;IACpC,gCAAuC;EDgw6CxC;;EClw6CA;IACC,2BAAoC;IACpC,8BAAuC;EDqw6CxC;;ECvw6CA;IACC,6BAAoC;IACpC,gCAAuC;ED0w6CxC;;EC5w6CA;IACC,2BAAoC;IACpC,8BAAuC;ED+w6CxC;;ECjx6CA;IACC,6BAAoC;IACpC,gCAAuC;EDox6CxC;;ECtx6CA;IACC,2BAAoC;IACpC,8BAAuC;EDyx6CxC;;EC3x6CA;IACC,6BAAoC;IACpC,gCAAuC;ED8x6CxC;;EChy6CA;IACC,2BAAY;IACZ,8BAAe;EDmy6ChB;;ECry6CA;IACC,6BAAY;IACZ,gCAAe;EDwy6ChB;;EC1y6CA;IACC,4BAAoC;IACpC,+BAAuC;ED6y6CxC;;EC/y6CA;IACC,8BAAoC;IACpC,iCAAuC;EDkz6CxC;;ECpz6CA;IACC,4BAAoC;IACpC,+BAAuC;EDuz6CxC;;ECzz6CA;IACC,8BAAoC;IACpC,iCAAuC;ED4z6CxC;;EC9z6CA;IACC,4BAAoC;IACpC,+BAAuC;EDi06CxC;;ECn06CA;IACC,8BAAoC;IACpC,iCAAuC;EDs06CxC;;ECx06CA;IACC,4BAAoC;IACpC,+BAAuC;ED206CxC;;EC706CA;IACC,8BAAoC;IACpC,iCAAuC;EDg16CxC;;ECl16CA;IACC,4BAAoC;IACpC,+BAAuC;EDq16CxC;;ECv16CA;IACC,8BAAoC;IACpC,iCAAuC;ED016CxC;;EC516CA;IACC,4BAAoC;IACpC,+BAAuC;ED+16CxC;;ECj26CA;IACC,8BAAoC;IACpC,iCAAuC;EDo26CxC;;ECt26CA;IACC,4BAAoC;IACpC,+BAAuC;EDy26CxC;;EC326CA;IACC,8BAAoC;IACpC,iCAAuC;ED826CxC;;ECh36CA;IACC,4BAAoC;IACpC,+BAAuC;EDm36CxC;;ECr36CA;IACC,8BAAoC;IACpC,iCAAuC;EDw36CxC;;EC136CA;IACC,4BAAoC;IACpC,+BAAuC;ED636CxC;;EC/36CA;IACC,8BAAoC;IACpC,iCAAuC;EDk46CxC;;ECp46CA;IACC,4BAAoC;IACpC,+BAAuC;EDu46CxC;;ECz46CA;IACC,8BAAoC;IACpC,iCAAuC;ED446CxC;;EC946CA;IACC,4BAAoC;IACpC,+BAAuC;EDi56CxC;;ECn56CA;IACC,8BAAoC;IACpC,iCAAuC;EDs56CxC;;ECx56CA;IACC,4BAAoC;IACpC,+BAAuC;ED256CxC;;EC756CA;IACC,8BAAoC;IACpC,iCAAuC;EDg66CxC;;ECl66CA;IACC,4BAAoC;IACpC,+BAAuC;EDq66CxC;;ECv66CA;IACC,8BAAoC;IACpC,iCAAuC;ED066CxC;;EC566CA;IACC,4BAAoC;IACpC,+BAAuC;ED+66CxC;;ECj76CA;IACC,8BAAoC;IACpC,iCAAuC;EDo76CxC;;ECt76CA;IACC,4BAAoC;IACpC,+BAAuC;EDy76CxC;;EC376CA;IACC,8BAAoC;IACpC,iCAAuC;ED876CxC;;ECh86CA;IACC,4BAAoC;IACpC,+BAAuC;EDm86CxC;;ECr86CA;IACC,8BAAoC;IACpC,iCAAuC;EDw86CxC;;EC186CA;IACC,4BAAoC;IACpC,+BAAuC;ED686CxC;;EC/86CA;IACC,8BAAoC;IACpC,iCAAuC;EDk96CxC;;ECp96CA;IACC,4BAAoC;IACpC,+BAAuC;EDu96CxC;;ECz96CA;IACC,8BAAoC;IACpC,iCAAuC;ED496CxC;;EC996CA;IACC,4BAAoC;IACpC,+BAAuC;EDi+6CxC;;ECn+6CA;IACC,8BAAoC;IACpC,iCAAuC;EDs+6CxC;;ECx+6CA;IACC,4BAAoC;IACpC,+BAAuC;ED2+6CxC;;EC7+6CA;IACC,8BAAoC;IACpC,iCAAuC;EDg/6CxC;;ECl/6CA;IACC,4BAAoC;IACpC,+BAAuC;EDq/6CxC;;ECv/6CA;IACC,8BAAoC;IACpC,iCAAuC;ED0/6CxC;;EC5/6CA;IACC,4BAAoC;IACpC,+BAAuC;ED+/6CxC;;ECjg7CA;IACC,8BAAoC;IACpC,iCAAuC;EDog7CxC;;ECtg7CA;IACC,4BAAoC;IACpC,+BAAuC;EDyg7CxC;;EC3g7CA;IACC,8BAAoC;IACpC,iCAAuC;ED8g7CxC;;EChh7CA;IACC,4BAAoC;IACpC,+BAAuC;EDmh7CxC;;ECrh7CA;IACC,8BAAoC;IACpC,iCAAuC;EDwh7CxC;;EC1h7CA;IACC,4BAAoC;IACpC,+BAAuC;ED6h7CxC;;EC/h7CA;IACC,8BAAoC;IACpC,iCAAuC;EDki7CxC;;ECpi7CA;IACC,4BAAoC;IACpC,+BAAuC;EDui7CxC;;ECzi7CA;IACC,8BAAoC;IACpC,iCAAuC;ED4i7CxC;;EC9i7CA;IACC,4BAAoC;IACpC,+BAAuC;EDij7CxC;;ECnj7CA;IACC,8BAAoC;IACpC,iCAAuC;EDsj7CxC;;ECxj7CA;IACC,4BAAoC;IACpC,+BAAuC;ED2j7CxC;;EC7j7CA;IACC,8BAAoC;IACpC,iCAAuC;EDgk7CxC;;EClk7CA;IACC,4BAAoC;IACpC,+BAAuC;EDqk7CxC;;ECvk7CA;IACC,8BAAoC;IACpC,iCAAuC;ED0k7CxC;;EC5k7CA;IACC,4BAAoC;IACpC,+BAAuC;ED+k7CxC;;ECjl7CA;IACC,8BAAoC;IACpC,iCAAuC;EDol7CxC;;ECtl7CA;IACC,4BAAoC;IACpC,+BAAuC;EDyl7CxC;;EC3l7CA;IACC,8BAAoC;IACpC,iCAAuC;ED8l7CxC;;EChm7CA;IACC,4BAAoC;IACpC,+BAAuC;EDmm7CxC;;ECrm7CA;IACC,8BAAoC;IACpC,iCAAuC;EDwm7CxC;;EC1m7CA;IACC,4BAAoC;IACpC,+BAAuC;ED6m7CxC;;EC/m7CA;IACC,8BAAoC;IACpC,iCAAuC;EDkn7CxC;;ECpn7CA;IACC,4BAAoC;IACpC,+BAAuC;EDun7CxC;;ECzn7CA;IACC,8BAAoC;IACpC,iCAAuC;ED4n7CxC;;EC9n7CA;IACC,4BAAoC;IACpC,+BAAuC;EDio7CxC;;ECno7CA;IACC,8BAAoC;IACpC,iCAAuC;EDso7CxC;;ECxo7CA;IACC,4BAAoC;IACpC,+BAAuC;ED2o7CxC;;EC7o7CA;IACC,8BAAoC;IACpC,iCAAuC;EDgp7CxC;;EClp7CA;IACC,4BAAoC;IACpC,+BAAuC;EDqp7CxC;;ECvp7CA;IACC,8BAAoC;IACpC,iCAAuC;ED0p7CxC;;EC5p7CA;IACC,4BAAoC;IACpC,+BAAuC;ED+p7CxC;;ECjq7CA;IACC,8BAAoC;IACpC,iCAAuC;EDoq7CxC;;ECtq7CA;IACC,4BAAoC;IACpC,+BAAuC;EDyq7CxC;;EC3q7CA;IACC,8BAAoC;IACpC,iCAAuC;ED8q7CxC;;EChr7CA;IACC,4BAAoC;IACpC,+BAAuC;EDmr7CxC;;ECrr7CA;IACC,8BAAoC;IACpC,iCAAuC;EDwr7CxC;;EC1r7CA;IACC,4BAAoC;IACpC,+BAAuC;ED6r7CxC;;EC/r7CA;IACC,8BAAoC;IACpC,iCAAuC;EDks7CxC;;ECps7CA;IACC,4BAAoC;IACpC,+BAAuC;EDus7CxC;;ECzs7CA;IACC,8BAAoC;IACpC,iCAAuC;ED4s7CxC;;EC9s7CA;IACC,4BAAoC;IACpC,+BAAuC;EDit7CxC;;ECnt7CA;IACC,8BAAoC;IACpC,iCAAuC;EDst7CxC;;ECxt7CA;IACC,4BAAoC;IACpC,+BAAuC;ED2t7CxC;;EC7t7CA;IACC,8BAAoC;IACpC,iCAAuC;EDgu7CxC;;EClu7CA;IACC,4BAAoC;IACpC,+BAAuC;EDqu7CxC;;ECvu7CA;IACC,8BAAoC;IACpC,iCAAuC;ED0u7CxC;;EC5u7CA;IACC,4BAAoC;IACpC,+BAAuC;ED+u7CxC;;ECjv7CA;IACC,8BAAoC;IACpC,iCAAuC;EDov7CxC;;ECtv7CA;IACC,4BAAoC;IACpC,+BAAuC;EDyv7CxC;;EC3v7CA;IACC,8BAAoC;IACpC,iCAAuC;ED8v7CxC;;EChw7CA;IACC,4BAAoC;IACpC,+BAAuC;EDmw7CxC;;ECrw7CA;IACC,8BAAoC;IACpC,iCAAuC;EDww7CxC;;EC1w7CA;IACC,4BAAoC;IACpC,+BAAuC;ED6w7CxC;;EC/w7CA;IACC,8BAAoC;IACpC,iCAAuC;EDkx7CxC;;ECpx7CA;IACC,4BAAoC;IACpC,+BAAuC;EDux7CxC;;ECzx7CA;IACC,8BAAoC;IACpC,iCAAuC;ED4x7CxC;;EC9x7CA;IACC,4BAAoC;IACpC,+BAAuC;EDiy7CxC;;ECny7CA;IACC,8BAAoC;IACpC,iCAAuC;EDsy7CxC;;ECxy7CA;IACC,4BAAoC;IACpC,+BAAuC;ED2y7CxC;;EC7y7CA;IACC,8BAAoC;IACpC,iCAAuC;EDgz7CxC;;EClz7CA;IACC,4BAAoC;IACpC,+BAAuC;EDqz7CxC;;ECvz7CA;IACC,8BAAoC;IACpC,iCAAuC;ED0z7CxC;;EC5z7CA;IACC,4BAAoC;IACpC,+BAAuC;ED+z7CxC;;ECj07CA;IACC,8BAAoC;IACpC,iCAAuC;EDo07CxC;;ECt07CA;IACC,4BAAoC;IACpC,+BAAuC;EDy07CxC;;EC307CA;IACC,8BAAoC;IACpC,iCAAuC;ED807CxC;;ECh17CA;IACC,4BAAoC;IACpC,+BAAuC;EDm17CxC;;ECr17CA;IACC,8BAAoC;IACpC,iCAAuC;EDw17CxC;;EC117CA;IACC,4BAAoC;IACpC,+BAAuC;ED617CxC;;EC/17CA;IACC,8BAAoC;IACpC,iCAAuC;EDk27CxC;;ECp27CA;IACC,4BAAoC;IACpC,+BAAuC;EDu27CxC;;ECz27CA;IACC,8BAAoC;IACpC,iCAAuC;ED427CxC;;EC927CA;IACC,4BAAoC;IACpC,+BAAuC;EDi37CxC;;ECn37CA;IACC,8BAAoC;IACpC,iCAAuC;EDs37CxC;;ECx37CA;IACC,4BAAoC;IACpC,+BAAuC;ED237CxC;;EC737CA;IACC,8BAAoC;IACpC,iCAAuC;EDg47CxC;;ECl47CA;IACC,4BAAoC;IACpC,+BAAuC;EDq47CxC;;ECv47CA;IACC,8BAAoC;IACpC,iCAAuC;ED047CxC;;EC547CA;IACC,4BAAoC;IACpC,+BAAuC;ED+47CxC;;ECj57CA;IACC,8BAAoC;IACpC,iCAAuC;EDo57CxC;;ECt57CA;IACC,4BAAoC;IACpC,+BAAuC;EDy57CxC;;EC357CA;IACC,8BAAoC;IACpC,iCAAuC;ED857CxC;;ECh67CA;IACC,4BAAoC;IACpC,+BAAuC;EDm67CxC;;ECr67CA;IACC,8BAAoC;IACpC,iCAAuC;EDw67CxC;;EC167CA;IACC,4BAAoC;IACpC,+BAAuC;ED667CxC;;EC/67CA;IACC,8BAAoC;IACpC,iCAAuC;EDk77CxC;;ECp77CA;IACC,4BAAoC;IACpC,+BAAuC;EDu77CxC;;ECz77CA;IACC,8BAAoC;IACpC,iCAAuC;ED477CxC;;EC977CA;IACC,4BAAoC;IACpC,+BAAuC;EDi87CxC;;ECn87CA;IACC,8BAAoC;IACpC,iCAAuC;EDs87CxC;;ECx87CA;IACC,4BAAoC;IACpC,+BAAuC;ED287CxC;;EC787CA;IACC,8BAAoC;IACpC,iCAAuC;EDg97CxC;;ECl97CA;IACC,4BAAoC;IACpC,+BAAuC;EDq97CxC;;ECv97CA;IACC,8BAAoC;IACpC,iCAAuC;ED097CxC;;ECp97CF;IAaE,4BAAc;IACb,+BAAgC;ED287CjC;;EC587CA;IACC,8BAAgC;ID+87C/B,iCAAiC;EACnC;AACF;AACA;EACE;IACE,uBAAuB;ECr97CzB;;EDw97CA;IACE,0BAA0B;ECz97C5B;;ED497CA;IACE,yBAAyB;EC797C3B;;EDg+7CA;IACE,uBAAuB;ECj+7CzB;;EDo+7CA;IACE,yBAAyB;ECr+7C3B;;EDw+7CA;IACE,uBAAuB;ECz+7CzB;;ED4+7CA;IACE,yBAAyB;EC7+7C3B;;EDg/7CA;IACE,uBAAuB;ECj/7CzB;;EDo/7CA;IACE,yBAAyB;ECr/7C3B;;EDw/7CA;IACE,uBAAuB;ECz/7CzB;;ED4/7CA;IACE,yBAAyB;EC7/7C3B;;EDgg8CA;IACE,uBAAuB;ECjg8CzB;;EDog8CA;IACE,yBAAyB;ECrg8C3B;;EDwg8CA;IACE,uBAAuB;ECzg8CzB;;ED4g8CA;IACE,yBAAyB;EC7g8C3B;;EDgh8CA;IACE,uBAAuB;ECjh8CzB;;EDoh8CA;IACE,yBAAyB;ECrh8C3B;;EDwh8CA;IACE,uBAAuB;ECzh8CzB;;ED4h8CA;IACE,yBAAyB;EC7h8C3B;;EDgi8CA;IACE,uBAAuB;ECji8CzB;;EDoi8CA;IACE,yBAAyB;ECri8C3B;;EDwi8CA;IACE,wBAAwB;ECzi8C1B;;ED4i8CA;IACE,0BAA0B;EC7i8C5B;;EDgj8CA;IACE,wBAAwB;ECjj8C1B;;EDoj8CA;IACE,0BAA0B;ECrj8C5B;;EDwj8CA;IACE,wBAAwB;ECzj8C1B;;ED4j8CA;IACE,0BAA0B;EC7j8C5B;;EDgk8CA;IACE,wBAAwB;ECjk8C1B;;EDok8CA;IACE,0BAA0B;ECrk8C5B;;EDwk8CA;IACE,wBAAwB;ECzk8C1B;;ED4k8CA;IACE,0BAA0B;EC7k8C5B;;EDgl8CA;IACE,wBAAwB;ECjl8C1B;;EDol8CA;IACE,0BAA0B;ECrl8C5B;;EDwl8CA;IACE,wBAAwB;ECzl8C1B;;ED4l8CA;IACE,0BAA0B;EC7l8C5B;;EDgm8CA;IACE,wBAAwB;ECjm8C1B;;EDom8CA;IACE,0BAA0B;ECrm8C5B;;EDwm8CA;IACE,wBAAwB;ECzm8C1B;;ED4m8CA;IACE,0BAA0B;EC7m8C5B;;EDgn8CA;IACE,wBAAwB;ECjn8C1B;;EDon8CA;IACE,0BAA0B;ECrn8C5B;;EDwn8CA;IACE,wBAAwB;ECzn8C1B;;ED4n8CA;IACE,0BAA0B;EC7n8C5B;;EDgo8CA;IACE,wBAAwB;ECjo8C1B;;EDoo8CA;IACE,0BAA0B;ECro8C5B;;EDwo8CA;IACE,wBAAwB;ECzo8C1B;;ED4o8CA;IACE,0BAA0B;EC7o8C5B;;EDgp8CA;IACE,wBAAwB;ECjp8C1B;;EDop8CA;IACE,0BAA0B;ECrp8C5B;;EDwp8CA;IACE,wBAAwB;ECzp8C1B;;ED4p8CA;IACE,0BAA0B;EC7p8C5B;;EDgq8CA;IACE,wBAAwB;ECjq8C1B;;EDoq8CA;IACE,0BAA0B;ECrq8C5B;;EDwq8CA;IACE,wBAAwB;ECzq8C1B;;ED4q8CA;IACE,0BAA0B;EC7q8C5B;;EDgr8CA;IACE,wBAAwB;ECjr8C1B;;EDor8CA;IACE,0BAA0B;ECrr8C5B;;EDwr8CA;IACE,wBAAwB;ECzr8C1B;;ED4r8CA;IACE,0BAA0B;EC7r8C5B;;EDgs8CA;IACE,wBAAwB;ECjs8C1B;;EDos8CA;IACE,0BAA0B;ECrs8C5B;;EDws8CA;IACE,wBAAwB;ECzs8C1B;;ED4s8CA;IACE,0BAA0B;EC7s8C5B;;EDgt8CA;IACE,wBAAwB;ECjt8C1B;;EDot8CA;IACE,0BAA0B;ECrt8C5B;;EDwt8CA;IACE,wBAAwB;ECzt8C1B;;ED4t8CA;IACE,0BAA0B;EC7t8C5B;;EDgu8CA;IACE,wBAAwB;ECju8C1B;;EDou8CA;IACE,0BAA0B;ECru8C5B;;EDwu8CA;IACE,wBAAwB;ECzu8C1B;;ED4u8CA;IACE,0BAA0B;EC7u8C5B;;EDgv8CA;IACE,wBAAwB;ECjv8C1B;;EDov8CA;IACE,0BAA0B;ECrv8C5B;;EDwv8CA;IACE,wBAAwB;ECzv8C1B;;ED4v8CA;IACE,0BAA0B;EC7v8C5B;;EDgw8CA;IACE,wBAAwB;ECjw8C1B;;EDow8CA;IACE,0BAA0B;ECrw8C5B;;EDww8CA;IACE,wBAAwB;ECzw8C1B;;ED4w8CA;IACE,0BAA0B;EC7w8C5B;;EDgx8CA;IACE,wBAAwB;ECjx8C1B;;EDox8CA;IACE,0BAA0B;ECrx8C5B;;EDwx8CA;IACE,wBAAwB;ECzx8C1B;;ED4x8CA;IACE,0BAA0B;EC7x8C5B;;EDgy8CA;IACE,wBAAwB;ECjy8C1B;;EDoy8CA;IACE,0BAA0B;ECry8C5B;;EDwy8CA;IACE,wBAAwB;ECzy8C1B;;ED4y8CA;IACE,0BAA0B;EC7y8C5B;;EDgz8CA;IACE,wBAAwB;ECjz8C1B;;EDoz8CA;IACE,0BAA0B;ECrz8C5B;;EDwz8CA;IACE,wBAAwB;ECzz8C1B;;ED4z8CA;IACE,0BAA0B;EC7z8C5B;;EDg08CA;IACE,wBAAwB;ECj08C1B;;EDo08CA;IACE,0BAA0B;ECr08C5B;;EDw08CA;IACE,wBAAwB;ECz08C1B;;ED408CA;IACE,0BAA0B;EC708C5B;;EDg18CA;IACE,wBAAwB;ECj18C1B;;EDo18CA;IACE,0BAA0B;ECr18C5B;;EDw18CA;IACE,wBAAwB;ECz18C1B;;ED418CA;IACE,0BAA0B;EC718C5B;;EDg28CA;IACE,wBAAwB;ECj28C1B;;EDo28CA;IACE,0BAA0B;ECr28C5B;;EDw28CA;IACE,wBAAwB;ECz28C1B;;ED428CA;IACE,0BAA0B;EC728C5B;;EDg38CA;IACE,wBAAwB;ECj38C1B;;EDo38CA;IACE,0BAA0B;ECr38C5B;;EDw38CA;IACE,wBAAwB;ECz38C1B;;ED438CA;IACE,0BAA0B;EC738C5B;;EDg48CA;IACE,wBAAwB;ECj48C1B;;EDo48CA;IACE,0BAA0B;ECr48C5B;;EDw48CA;IACE,wBAAwB;ECz48C1B;;ED448CA;IACE,0BAA0B;EC748C5B;;EDg58CA;IACE,wBAAwB;ECj58C1B;;EDo58CA;IACE,0BAA0B;ECr58C5B;;EDw58CA;IACE,wBAAwB;ECz58C1B;;ED458CA;IACE,0BAA0B;EC758C5B;;EDg68CA;IACE,wBAAwB;ECj68C1B;;EDo68CA;IACE,0BAA0B;ECr68C5B;;EDw68CA;IACE,wBAAwB;ECz68C1B;;ED468CA;IACE,0BAA0B;EC768C5B;;EDg78CA;IACE,wBAAwB;ECj78C1B;;EDo78CA;IACE,0BAA0B;ECr78C5B;;EDw78CA;IACE,wBAAwB;ECz78C1B;;ED478CA;IACE,0BAA0B;EC778C5B;;EDg88CA;IACE,wBAAwB;ECj88C1B;;EDo88CA;IACE,0BAA0B;ECr88C5B;;EDw88CA;IACE,wBAAwB;ECz88C1B;;ED488CA;IACE,0BAA0B;EC788C5B;;EDg98CA;IACE,wBAAwB;ECj98C1B;;EDo98CA;IACE,0BAA0B;ECr98C5B;;EDw98CA;IACE,wBAAwB;ECz98C1B;;ED498CA;IACE,0BAA0B;EC798C5B;;EDg+8CA;IACE,wBAAwB;ECj+8C1B;;EDo+8CA;IACE,0BAA0B;ECr+8C5B;;EDw+8CA;IACE,wBAAwB;ECz+8C1B;;ED4+8CA;IACE,0BAA0B;EC7+8C5B;;EDg/8CA;IACE,wBAAwB;ECj/8C1B;;EDo/8CA;IACE,0BAA0B;ECr/8C5B;;EDw/8CA;IACE,wBAAwB;ECz/8C1B;;ED4/8CA;IACE,0BAA0B;EC7/8C5B;;EDgg9CA;IACE,wBAAwB;ECjg9C1B;;EDog9CA;IACE,0BAA0B;ECrg9C5B;;EDwg9CA;IACE,wBAAwB;ECzg9C1B;;ED4g9CA;IACE,0BAA0B;EC7g9C5B;;EDgh9CA;IACE,wBAAwB;ECjh9C1B;;EDoh9CA;IACE,0BAA0B;ECrh9C5B;;EDwh9CA;IACE,wBAAwB;ECzh9C1B;;ED4h9CA;IACE,0BAA0B;EC7h9C5B;;EDgi9CA;IACE,wBAAwB;ECji9C1B;;EDoi9CA;IACE,0BAA0B;ECri9C5B;;EDwi9CA;IACE,wBAAwB;ECzi9C1B;;ED4i9CA;IACE,0BAA0B;EC7i9C5B;;EDgj9CA;IACE,wBAAwB;ECjj9C1B;;EDoj9CA;IACE,0BAA0B;ECrj9C5B;;EDwj9CA;IACE,wBAAwB;ECzj9C1B;;ED4j9CA;IACE,0BAA0B;EC7j9C5B;;EDgk9CA;IACE,wBAAwB;ECjk9C1B;;EDok9CA;IACE,0BAA0B;ECrk9C5B;;EDwk9CA;IACE,wBAAwB;ECzk9C1B;;ED4k9CA;IACE,0BAA0B;EC1j9C5B;;ED6j9CA;IACE,wBAAwB;EC9j9C1B;;EDik9CA;IACE,0BAA0B;EClk9C5B;;EDqk9CA;IACE,2BAA2B;ECtk9C7B;;EDyk9CA;IACE,8BAA8B;EC1k9ChC;;ED6k9CA;IACE,6BAA6B;EC9k9C/B;;EDil9CA;IACE,2BAA2B;ECll9C7B;;EDql9CA;IACE,6BAA6B;ECtl9C/B;;EDyl9CA;IACE,2BAA2B;EC1l9C7B;;ED6l9CA;IACE,6BAA6B;EC9l9C/B;;EDim9CA;IACE,2BAA2B;EClm9C7B;;EDqm9CA;IACE,6BAA6B;ECtm9C/B;;EDym9CA;IACE,2BAA2B;EC1m9C7B;;ED6m9CA;IACE,6BAA6B;EC9m9C/B;;EDin9CA;IACE,2BAA2B;ECln9C7B;;EDqn9CA;IACE,6BAA6B;ECtn9C/B;;EDyn9CA;IACE,2BAA2B;EC1n9C7B;;ED6n9CA;IACE,6BAA6B;EC9n9C/B;;EDio9CA;IACE,2BAA2B;EClo9C7B;;EDqo9CA;IACE,6BAA6B;ECto9C/B;;EDyo9CA;IACE,2BAA2B;EC1o9C7B;;ED6o9CA;IACE,6BAA6B;EC9o9C/B;;EDip9CA;IACE,2BAA2B;EClp9C7B;;EDqp9CA;IACE,6BAA6B;ECtp9C/B;;EDyp9CA;IACE,4BAA4B;EC1p9C9B;;ED6p9CA;IACE,8BAA8B;EC9p9ChC;;EDiq9CA;IACE,4BAA4B;EClq9C9B;;EDqq9CA;IACE,8BAA8B;ECtq9ChC;;EDyq9CA;IACE,4BAA4B;EC1q9C9B;;ED6q9CA;IACE,8BAA8B;EC9q9ChC;;EDir9CA;IACE,4BAA4B;EClr9C9B;;EDqr9CA;IACE,8BAA8B;ECtr9ChC;;EDyr9CA;IACE,4BAA4B;EC1r9C9B;;ED6r9CA;IACE,8BAA8B;EC9r9ChC;;EDis9CA;IACE,4BAA4B;ECls9C9B;;EDqs9CA;IACE,8BAA8B;ECts9ChC;;EDys9CA;IACE,4BAA4B;EC1s9C9B;;ED6s9CA;IACE,8BAA8B;EC9s9ChC;;EDit9CA;IACE,4BAA4B;EClt9C9B;;EDqt9CA;IACE,8BAA8B;ECtt9ChC;;EDyt9CA;IACE,4BAA4B;EC1t9C9B;;ED6t9CA;IACE,8BAA8B;EC9t9ChC;;EDiu9CA;IACE,4BAA4B;EClu9C9B;;EDqu9CA;IACE,8BAA8B;ECtu9ChC;;EDyu9CA;IACE,4BAA4B;EC1u9C9B;;ED6u9CA;IACE,8BAA8B;EC9u9ChC;;EDiv9CA;IACE,4BAA4B;EClv9C9B;;EDqv9CA;IACE,8BAA8B;ECtv9ChC;;EDyv9CA;IACE,4BAA4B;EC1v9C9B;;ED6v9CA;IACE,8BAA8B;EC9v9ChC;;EDiw9CA;IACE,4BAA4B;EClw9C9B;;EDqw9CA;IACE,8BAA8B;ECtw9ChC;;EDyw9CA;IACE,4BAA4B;EC1w9C9B;;ED6w9CA;IACE,8BAA8B;EC9w9ChC;;EDix9CA;IACE,4BAA4B;EClx9C9B;;EDqx9CA;IACE,8BAA8B;ECtx9ChC;;EDyx9CA;IACE,4BAA4B;EC1x9C9B;;ED6x9CA;IACE,8BAA8B;EC9x9ChC;;EDiy9CA;IACE,4BAA4B;ECly9C9B;;EDqy9CA;IACE,8BAA8B;ECty9ChC;;EDyy9CA;IACE,4BAA4B;EC1y9C9B;;ED6y9CA;IACE,8BAA8B;EC9y9ChC;;EDiz9CA;IACE,4BAA4B;EClz9C9B;;EDqz9CA;IACE,8BAA8B;ECtz9ChC;;EDyz9CA;IACE,4BAA4B;EC1z9C9B;;ED6z9CA;IACE,8BAA8B;EC9z9ChC;;EDi09CA;IACE,4BAA4B;ECl09C9B;;EDq09CA;IACE,8BAA8B;ECt09ChC;;EDy09CA;IACE,4BAA4B;EC109C9B;;ED609CA;IACE,8BAA8B;EC909ChC;;EDi19CA;IACE,4BAA4B;ECl19C9B;;EDq19CA;IACE,8BAA8B;ECt19ChC;;EDy19CA;IACE,4BAA4B;EC119C9B;;ED619CA;IACE,8BAA8B;EC919ChC;;EDi29CA;IACE,4BAA4B;ECl29C9B;;EDq29CA;IACE,8BAA8B;ECt29ChC;;EDy29CA;IACE,4BAA4B;EC129C9B;;ED629CA;IACE,8BAA8B;EC929ChC;;EDi39CA;IACE,4BAA4B;ECl39C9B;;EDq39CA;IACE,8BAA8B;ECt39ChC;;EDy39CA;IACE,4BAA4B;EC139C9B;;ED639CA;IACE,8BAA8B;EC939ChC;;EDi49CA;IACE,4BAA4B;ECl49C9B;;EDq49CA;IACE,8BAA8B;ECt49ChC;;EDy49CA;IACE,4BAA4B;EC149C9B;;ED649CA;IACE,8BAA8B;EC949ChC;;EDi59CA;IACE,4BAA4B;ECl59C9B;;EDq59CA;IACE,8BAA8B;ECt59ChC;;EDy59CA;IACE,4BAA4B;EC159C9B;;ED659CA;IACE,8BAA8B;EC959ChC;;EDi69CA;IACE,4BAA4B;ECl69C9B;;EDq69CA;IACE,8BAA8B;ECt69ChC;;EDy69CA;IACE,4BAA4B;EC169C9B;;ED669CA;IACE,8BAA8B;EC969ChC;;EDi79CA;IACE,4BAA4B;ECl79C9B;;EDq79CA;IACE,8BAA8B;ECt79ChC;;EDy79CA;IACE,4BAA4B;EC179C9B;;ED679CA;IACE,8BAA8B;EC979ChC;;EDi89CA;IACE,4BAA4B;ECl89C9B;;EDq89CA;IACE,8BAA8B;ECt89ChC;;EDy89CA;IACE,4BAA4B;EC189C9B;;ED689CA;IACE,8BAA8B;EC989ChC;;EDi99CA;IACE,4BAA4B;ECl99C9B;;EDq99CA;IACE,8BAA8B;ECt99ChC;;EDy99CA;IACE,4BAA4B;EC199C9B;;ED699CA;IACE,8BAA8B;EC999ChC;;EDi+9CA;IACE,4BAA4B;ECl+9C9B;;EDq+9CA;IACE,8BAA8B;ECt+9ChC;;EDy+9CA;IACE,4BAA4B;EC1+9C9B;;ED6+9CA;IACE,8BAA8B;EC9+9ChC;;EDi/9CA;IACE,4BAA4B;ECl/9C9B;;EDq/9CA;IACE,8BAA8B;ECt/9ChC;;EDy/9CA;IACE,4BAA4B;EC1/9C9B;;ED6/9CA;IACE,8BAA8B;EC9/9ChC;;EDig+CA;IACE,4BAA4B;EClg+C9B;;EDqg+CA;IACE,8BAA8B;ECtg+ChC;;EDyg+CA;IACE,4BAA4B;EC1g+C9B;;ED6g+CA;IACE,8BAA8B;EC9g+ChC;;EDih+CA;IACE,4BAA4B;EClh+C9B;;EDqh+CA;IACE,8BAA8B;ECth+ChC;;EDyh+CA;IACE,4BAA4B;EC1h+C9B;;ED6h+CA;IACE,8BAA8B;EC9h+ChC;;EDii+CA;IACE,4BAA4B;ECli+C9B;;EDqi+CA;IACE,8BAA8B;ECti+ChC;;EDyi+CA;IACE,4BAA4B;EC1i+C9B;;ED6i+CA;IACE,8BAA8B;EC9i+ChC;;EDij+CA;IACE,4BAA4B;EClj+C9B;;EDqj+CA;IACE,8BAA8B;ECtj+ChC;;EDyj+CA;IACE,4BAA4B;EC1j+C9B;;ED6j+CA;IACE,8BAA8B;EC9j+ChC;;EDik+CA;IACE,4BAA4B;EClk+C9B;;EDqk+CA;IACE,8BAA8B;ECtk+ChC;;EDyk+CA;IACE,4BAA4B;EC1k+C9B;;ED6k+CA;IACE,8BAA8B;EC9k+ChC;;EDil+CA;IACE,4BAA4B;ECll+C9B;;EDql+CA;IACE,8BAA8B;ECtl+ChC;;EDyl+CA;IACE,4BAA4B;EC1l+C9B;;ED6l+CA;IACE,8BAA8B;EC9l+ChC;;EDim+CA;IACE,4BAA4B;EClm+C9B;;EDqm+CA;IACE,8BAA8B;ECtm+ChC;;EDym+CA;IACE,4BAA4B;EC1m+C9B;;ED6m+CA;IACE,8BAA8B;EC9m+ChC;;EDin+CA;IACE,4BAA4B;ECln+C9B;;EDqn+CA;IACE,8BAA8B;ECtn+ChC;;EDyn+CA;IACE,4BAA4B;EC1n+C9B;;ED6n+CA;IACE,8BAA8B;EC9n+ChC;;EDio+CA;IACE,4BAA4B;EClo+C9B;;EDqo+CA;IACE,8BAA8B;ECto+ChC;;EDyo+CA;IACE,4BAA4B;EC1o+C9B;;ED6o+CA;IACE,8BAA8B;EC9o+ChC;;EDip+CA;IACE,4BAA4B;EClp+C9B;;EDqp+CA;IACE,8BAA8B;ECtp+ChC;;EDyp+CA;IACE,4BAA4B;EC1p+C9B;;ED6p+CA;IACE,8BAA8B;EC9p+ChC;;EDiq+CA;IACE,4BAA4B;EClq+C9B;;EDqq+CA;IACE,8BAA8B;ECtq+ChC;;EDyq+CA;IACE,4BAA4B;EC1q+C9B;;ED6q+CA;IACE,8BAA8B;EC9q+ChC;;EDir+CA;IACE,4BAA4B;EClr+C9B;;EDqr+CA;IACE,8BAA8B;ECtr+ChC;;EDyr+CA;IACE,4BAA4B;EC1r+C9B;;ED6r+CA;IACE,8BAA8B;EC3q+ChC;;ED8q+CA;IACE,4BAA4B;EC/q+C9B;;EDkr+CA;IACE,8BAA8B;ECnr+ChC;;EDsr+CA;IACE,8BAA8B;ECvr+ChC;;ED0r+CA;IACE,iCAAiC;EC3r+CnC;;ED8r+CA;IACE,gCAAgC;EC/r+ClC;;EDks+CA;IACE,8BAA8B;ECns+ChC;;EDss+CA;IACE,gCAAgC;ECvs+ClC;;ED0s+CA;IACE,8BAA8B;EC3s+ChC;;ED8s+CA;IACE,gCAAgC;EC/s+ClC;;EDkt+CA;IACE,8BAA8B;ECnt+ChC;;EDst+CA;IACE,gCAAgC;ECvt+ClC;;ED0t+CA;IACE,8BAA8B;EC3t+ChC;;ED8t+CA;IACE,gCAAgC;EC/t+ClC;;EDku+CA;IACE,8BAA8B;ECnu+ChC;;EDsu+CA;IACE,gCAAgC;ECvu+ClC;;ED0u+CA;IACE,8BAA8B;EC3u+ChC;;ED8u+CA;IACE,gCAAgC;EC/u+ClC;;EDkv+CA;IACE,8BAA8B;ECnv+ChC;;EDsv+CA;IACE,gCAAgC;ECvv+ClC;;ED0v+CA;IACE,8BAA8B;EC3v+ChC;;ED8v+CA;IACE,gCAAgC;EC/v+ClC;;EDkw+CA;IACE,8BAA8B;ECnw+ChC;;EDsw+CA;IACE,gCAAgC;ECvw+ClC;;ED0w+CA;IACE,+BAA+B;EC3w+CjC;;ED8w+CA;IACE,iCAAiC;EC/w+CnC;;EDkx+CA;IACE,+BAA+B;ECnx+CjC;;EDsx+CA;IACE,iCAAiC;ECvx+CnC;;ED0x+CA;IACE,+BAA+B;EC3x+CjC;;ED8x+CA;IACE,iCAAiC;EC/x+CnC;;EDky+CA;IACE,+BAA+B;ECny+CjC;;EDsy+CA;IACE,iCAAiC;ECvy+CnC;;ED0y+CA;IACE,+BAA+B;EC3y+CjC;;ED8y+CA;IACE,iCAAiC;EC/y+CnC;;EDkz+CA;IACE,+BAA+B;ECnz+CjC;;EDsz+CA;IACE,iCAAiC;ECvz+CnC;;ED0z+CA;IACE,+BAA+B;EC3z+CjC;;ED8z+CA;IACE,iCAAiC;EC/z+CnC;;EDk0+CA;IACE,+BAA+B;ECn0+CjC;;EDs0+CA;IACE,iCAAiC;ECv0+CnC;;ED00+CA;IACE,+BAA+B;EC30+CjC;;ED80+CA;IACE,iCAAiC;EC/0+CnC;;EDk1+CA;IACE,+BAA+B;ECn1+CjC;;EDs1+CA;IACE,iCAAiC;ECv1+CnC;;ED01+CA;IACE,+BAA+B;EC31+CjC;;ED81+CA;IACE,iCAAiC;EC/1+CnC;;EDk2+CA;IACE,+BAA+B;ECn2+CjC;;EDs2+CA;IACE,iCAAiC;ECv2+CnC;;ED02+CA;IACE,+BAA+B;EC32+CjC;;ED82+CA;IACE,iCAAiC;EC/2+CnC;;EDk3+CA;IACE,+BAA+B;ECn3+CjC;;EDs3+CA;IACE,iCAAiC;ECv3+CnC;;ED03+CA;IACE,+BAA+B;EC33+CjC;;ED83+CA;IACE,iCAAiC;EC/3+CnC;;EDk4+CA;IACE,+BAA+B;ECn4+CjC;;EDs4+CA;IACE,iCAAiC;ECv4+CnC;;ED04+CA;IACE,+BAA+B;EC34+CjC;;ED84+CA;IACE,iCAAiC;EC/4+CnC;;EDk5+CA;IACE,+BAA+B;ECn5+CjC;;EDs5+CA;IACE,iCAAiC;ECv5+CnC;;ED05+CA;IACE,+BAA+B;EC35+CjC;;ED85+CA;IACE,iCAAiC;EC/5+CnC;;EDk6+CA;IACE,+BAA+B;ECn6+CjC;;EDs6+CA;IACE,iCAAiC;ECv6+CnC;;ED06+CA;IACE,+BAA+B;EC36+CjC;;ED86+CA;IACE,iCAAiC;EC/6+CnC;;EDk7+CA;IACE,+BAA+B;ECn7+CjC;;EDs7+CA;IACE,iCAAiC;ECv7+CnC;;ED07+CA;IACE,+BAA+B;EC37+CjC;;ED87+CA;IACE,iCAAiC;EC/7+CnC;;EDk8+CA;IACE,+BAA+B;ECn8+CjC;;EDs8+CA;IACE,iCAAiC;ECv8+CnC;;ED08+CA;IACE,+BAA+B;EC38+CjC;;ED88+CA;IACE,iCAAiC;EC/8+CnC;;EDk9+CA;IACE,+BAA+B;ECn9+CjC;;EDs9+CA;IACE,iCAAiC;ECv9+CnC;;ED09+CA;IACE,+BAA+B;EC39+CjC;;ED89+CA;IACE,iCAAiC;EC/9+CnC;;EDk++CA;IACE,+BAA+B;ECn++CjC;;EDs++CA;IACE,iCAAiC;ECv++CnC;;ED0++CA;IACE,+BAA+B;EC3++CjC;;ED8++CA;IACE,iCAAiC;EC/++CnC;;EDk/+CA;IACE,+BAA+B;ECn/+CjC;;EDs/+CA;IACE,iCAAiC;ECv/+CnC;;ED0/+CA;IACE,+BAA+B;EC3/+CjC;;ED8/+CA;IACE,iCAAiC;EC//+CnC;;EDkg/CA;IACE,+BAA+B;ECng/CjC;;EDsg/CA;IACE,iCAAiC;ECvg/CnC;;ED0g/CA;IACE,+BAA+B;EC3g/CjC;;ED8g/CA;IACE,iCAAiC;EC/g/CnC;;EDkh/CA;IACE,+BAA+B;ECnh/CjC;;EDsh/CA;IACE,iCAAiC;ECvh/CnC;;ED0h/CA;IACE,+BAA+B;EC3h/CjC;;ED8h/CA;IACE,iCAAiC;EC/h/CnC;;EDki/CA;IACE,+BAA+B;ECni/CjC;;EDsi/CA;IACE,iCAAiC;ECvi/CnC;;ED0i/CA;IACE,+BAA+B;EC3i/CjC;;ED8i/CA;IACE,iCAAiC;EC/i/CnC;;EDkj/CA;IACE,+BAA+B;ECnj/CjC;;EDsj/CA;IACE,iCAAiC;ECvj/CnC;;ED0j/CA;IACE,+BAA+B;EC3j/CjC;;ED8j/CA;IACE,iCAAiC;EC/j/CnC;;EDkk/CA;IACE,+BAA+B;ECnk/CjC;;EDsk/CA;IACE,iCAAiC;ECvk/CnC;;ED0k/CA;IACE,+BAA+B;EC3k/CjC;;ED8k/CA;IACE,iCAAiC;EC/k/CnC;;EDkl/CA;IACE,+BAA+B;ECnl/CjC;;EDsl/CA;IACE,iCAAiC;ECvl/CnC;;ED0l/CA;IACE,+BAA+B;EC3l/CjC;;ED8l/CA;IACE,iCAAiC;EC/l/CnC;;EDkm/CA;IACE,+BAA+B;ECnm/CjC;;EDsm/CA;IACE,iCAAiC;ECvm/CnC;;ED0m/CA;IACE,+BAA+B;EC3m/CjC;;ED8m/CA;IACE,iCAAiC;EC/m/CnC;;EDkn/CA;IACE,+BAA+B;ECnn/CjC;;EDsn/CA;IACE,iCAAiC;ECvn/CnC;;ED0n/CA;IACE,+BAA+B;EC3n/CjC;;ED8n/CA;IACE,iCAAiC;EC/n/CnC;;EDko/CA;IACE,+BAA+B;ECno/CjC;;EDso/CA;IACE,iCAAiC;ECvo/CnC;;ED0o/CA;IACE,+BAA+B;EC3o/CjC;;ED8o/CA;IACE,iCAAiC;EC/o/CnC;;EDkp/CA;IACE,+BAA+B;ECnp/CjC;;EDsp/CA;IACE,iCAAiC;ECvp/CnC;;ED0p/CA;IACE,+BAA+B;EC3p/CjC;;ED8p/CA;IACE,iCAAiC;EC/p/CnC;;EDkq/CA;IACE,+BAA+B;ECnq/CjC;;EDsq/CA;IACE,iCAAiC;ECvq/CnC;;ED0q/CA;IACE,+BAA+B;EC3q/CjC;;ED8q/CA;IACE,iCAAiC;EC/q/CnC;;EDkr/CA;IACE,+BAA+B;ECnr/CjC;;EDsr/CA;IACE,iCAAiC;ECvr/CnC;;ED0r/CA;IACE,+BAA+B;EC3r/CjC;;ED8r/CA;IACE,iCAAiC;EC/r/CnC;;EDks/CA;IACE,+BAA+B;ECns/CjC;;EDss/CA;IACE,iCAAiC;ECvs/CnC;;ED0s/CA;IACE,+BAA+B;EC3s/CjC;;ED8s/CA;IACE,iCAAiC;EC/s/CnC;;EDkt/CA;IACE,+BAA+B;ECnt/CjC;;EDst/CA;IACE,iCAAiC;ECvt/CnC;;ED0t/CA;IACE,+BAA+B;EC3t/CjC;;ED8t/CA;IACE,iCAAiC;EC/t/CnC;;EDku/CA;IACE,+BAA+B;ECnu/CjC;;EDsu/CA;IACE,iCAAiC;ECvu/CnC;;ED0u/CA;IACE,+BAA+B;EC3u/CjC;;ED8u/CA;IACE,iCAAiC;EC/u/CnC;;EDkv/CA;IACE,+BAA+B;ECnv/CjC;;EDsv/CA;IACE,iCAAiC;ECvv/CnC;;ED0v/CA;IACE,+BAA+B;EC3v/CjC;;ED8v/CA;IACE,iCAAiC;EC/v/CnC;;EDkw/CA;IACE,+BAA+B;ECnw/CjC;;EDsw/CA;IACE,iCAAiC;ECvw/CnC;;ED0w/CA;IACE,+BAA+B;EC3w/CjC;;ED8w/CA;IACE,iCAAiC;EC/w/CnC;;EDkx/CA;IACE,+BAA+B;ECnx/CjC;;EDsx/CA;IACE,iCAAiC;ECvx/CnC;;ED0x/CA;IACE,+BAA+B;EC3x/CjC;;ED8x/CA;IACE,iCAAiC;EC/x/CnC;;EDky/CA;IACE,+BAA+B;ECny/CjC;;EDsy/CA;IACE,iCAAiC;ECvy/CnC;;ED0y/CA;IACE,+BAA+B;EC3y/CjC;;ED8y/CA;IACE,iCAAiC;EC5x/CnC;;ED+x/CA;IACE,+BAA+B;EChy/CjC;;EDmy/CA;IACE,iCAAiC;ECpy/CnC;;EDuy/CA;IACE,4BAA4B;ECxy/C9B;;ED2y/CA;IACE,+BAA+B;EC5y/CjC;;ED+y/CA;IACE,8BAA8B;EChz/ChC;;EDmz/CA;IACE,4BAA4B;ECpz/C9B;;EDuz/CA;IACE,8BAA8B;ECxz/ChC;;ED2z/CA;IACE,4BAA4B;EC5z/C9B;;ED+z/CA;IACE,8BAA8B;ECh0/ChC;;EDm0/CA;IACE,4BAA4B;ECp0/C9B;;EDu0/CA;IACE,8BAA8B;ECx0/ChC;;ED20/CA;IACE,4BAA4B;EC50/C9B;;ED+0/CA;IACE,8BAA8B;ECh1/ChC;;EDm1/CA;IACE,4BAA4B;ECp1/C9B;;EDu1/CA;IACE,8BAA8B;ECx1/ChC;;ED21/CA;IACE,4BAA4B;EC51/C9B;;ED+1/CA;IACE,8BAA8B;ECh2/ChC;;EDm2/CA;IACE,4BAA4B;ECp2/C9B;;EDu2/CA;IACE,8BAA8B;ECx2/ChC;;ED22/CA;IACE,4BAA4B;EC52/C9B;;ED+2/CA;IACE,8BAA8B;ECh3/ChC;;EDm3/CA;IACE,4BAA4B;ECp3/C9B;;EDu3/CA;IACE,8BAA8B;ECx3/ChC;;ED23/CA;IACE,6BAA6B;EC53/C/B;;ED+3/CA;IACE,+BAA+B;ECh4/CjC;;EDm4/CA;IACE,6BAA6B;ECp4/C/B;;EDu4/CA;IACE,+BAA+B;ECx4/CjC;;ED24/CA;IACE,6BAA6B;EC54/C/B;;ED+4/CA;IACE,+BAA+B;ECh5/CjC;;EDm5/CA;IACE,6BAA6B;ECp5/C/B;;EDu5/CA;IACE,+BAA+B;ECx5/CjC;;ED25/CA;IACE,6BAA6B;EC55/C/B;;ED+5/CA;IACE,+BAA+B;ECh6/CjC;;EDm6/CA;IACE,6BAA6B;ECp6/C/B;;EDu6/CA;IACE,+BAA+B;ECx6/CjC;;ED26/CA;IACE,6BAA6B;EC56/C/B;;ED+6/CA;IACE,+BAA+B;ECh7/CjC;;EDm7/CA;IACE,6BAA6B;ECp7/C/B;;EDu7/CA;IACE,+BAA+B;ECx7/CjC;;ED27/CA;IACE,6BAA6B;EC57/C/B;;ED+7/CA;IACE,+BAA+B;ECh8/CjC;;EDm8/CA;IACE,6BAA6B;ECp8/C/B;;EDu8/CA;IACE,+BAA+B;ECx8/CjC;;ED28/CA;IACE,6BAA6B;EC58/C/B;;ED+8/CA;IACE,+BAA+B;ECh9/CjC;;EDm9/CA;IACE,6BAA6B;ECp9/C/B;;EDu9/CA;IACE,+BAA+B;ECx9/CjC;;ED29/CA;IACE,6BAA6B;EC59/C/B;;ED+9/CA;IACE,+BAA+B;ECh+/CjC;;EDm+/CA;IACE,6BAA6B;ECp+/C/B;;EDu+/CA;IACE,+BAA+B;ECx+/CjC;;ED2+/CA;IACE,6BAA6B;EC5+/C/B;;ED++/CA;IACE,+BAA+B;ECh//CjC;;EDm//CA;IACE,6BAA6B;ECp//C/B;;EDu//CA;IACE,+BAA+B;ECx//CjC;;ED2//CA;IACE,6BAA6B;EC5//C/B;;ED+//CA;IACE,+BAA+B;EChggDjC;;EDmggDA;IACE,6BAA6B;ECpggD/B;;EDuggDA;IACE,+BAA+B;ECxggDjC;;ED2ggDA;IACE,6BAA6B;EC5ggD/B;;ED+ggDA;IACE,+BAA+B;EChhgDjC;;EDmhgDA;IACE,6BAA6B;ECphgD/B;;EDuhgDA;IACE,+BAA+B;ECxhgDjC;;ED2hgDA;IACE,6BAA6B;EC5hgD/B;;ED+hgDA;IACE,+BAA+B;EChigDjC;;EDmigDA;IACE,6BAA6B;ECpigD/B;;EDuigDA;IACE,+BAA+B;ECxigDjC;;ED2igDA;IACE,6BAA6B;EC5igD/B;;ED+igDA;IACE,+BAA+B;EChjgDjC;;EDmjgDA;IACE,6BAA6B;ECpjgD/B;;EDujgDA;IACE,+BAA+B;ECxjgDjC;;ED2jgDA;IACE,6BAA6B;EC5jgD/B;;ED+jgDA;IACE,+BAA+B;EChkgDjC;;EDmkgDA;IACE,6BAA6B;ECpkgD/B;;EDukgDA;IACE,+BAA+B;ECxkgDjC;;ED2kgDA;IACE,6BAA6B;EC5kgD/B;;ED+kgDA;IACE,+BAA+B;EChlgDjC;;EDmlgDA;IACE,6BAA6B;ECplgD/B;;EDulgDA;IACE,+BAA+B;ECxlgDjC;;ED2lgDA;IACE,6BAA6B;EC5lgD/B;;ED+lgDA;IACE,+BAA+B;EChmgDjC;;EDmmgDA;IACE,6BAA6B;ECpmgD/B;;EDumgDA;IACE,+BAA+B;ECxmgDjC;;ED2mgDA;IACE,6BAA6B;EC5mgD/B;;ED+mgDA;IACE,+BAA+B;EChngDjC;;EDmngDA;IACE,6BAA6B;ECpngD/B;;EDungDA;IACE,+BAA+B;ECxngDjC;;ED2ngDA;IACE,6BAA6B;EC5ngD/B;;ED+ngDA;IACE,+BAA+B;EChogDjC;;EDmogDA;IACE,6BAA6B;ECpogD/B;;EDuogDA;IACE,+BAA+B;ECxogDjC;;ED2ogDA;IACE,6BAA6B;EC5ogD/B;;ED+ogDA;IACE,+BAA+B;EChpgDjC;;EDmpgDA;IACE,6BAA6B;ECppgD/B;;EDupgDA;IACE,+BAA+B;ECxpgDjC;;ED2pgDA;IACE,6BAA6B;EC5pgD/B;;ED+pgDA;IACE,+BAA+B;EChqgDjC;;EDmqgDA;IACE,6BAA6B;ECpqgD/B;;EDuqgDA;IACE,+BAA+B;ECxqgDjC;;ED2qgDA;IACE,6BAA6B;EC5qgD/B;;ED+qgDA;IACE,+BAA+B;EChrgDjC;;EDmrgDA;IACE,6BAA6B;ECprgD/B;;EDurgDA;IACE,+BAA+B;ECxrgDjC;;ED2rgDA;IACE,6BAA6B;EC5rgD/B;;ED+rgDA;IACE,+BAA+B;EChsgDjC;;EDmsgDA;IACE,6BAA6B;ECpsgD/B;;EDusgDA;IACE,+BAA+B;ECxsgDjC;;ED2sgDA;IACE,6BAA6B;EC5sgD/B;;ED+sgDA;IACE,+BAA+B;EChtgDjC;;EDmtgDA;IACE,6BAA6B;ECptgD/B;;EDutgDA;IACE,+BAA+B;ECxtgDjC;;ED2tgDA;IACE,6BAA6B;EC5tgD/B;;ED+tgDA;IACE,+BAA+B;EChugDjC;;EDmugDA;IACE,6BAA6B;ECpugD/B;;EDuugDA;IACE,+BAA+B;ECxugDjC;;ED2ugDA;IACE,6BAA6B;EC5ugD/B;;ED+ugDA;IACE,+BAA+B;EChvgDjC;;EDmvgDA;IACE,6BAA6B;ECpvgD/B;;EDuvgDA;IACE,+BAA+B;ECxvgDjC;;ED2vgDA;IACE,6BAA6B;EC5vgD/B;;ED+vgDA;IACE,+BAA+B;EChwgDjC;;EDmwgDA;IACE,6BAA6B;ECpwgD/B;;EDuwgDA;IACE,+BAA+B;ECxwgDjC;;ED2wgDA;IACE,6BAA6B;EC5wgD/B;;ED+wgDA;IACE,+BAA+B;EChxgDjC;;EDmxgDA;IACE,6BAA6B;ECpxgD/B;;EDuxgDA;IACE,+BAA+B;ECxxgDjC;;ED2xgDA;IACE,6BAA6B;EC5xgD/B;;ED+xgDA;IACE,+BAA+B;EChygDjC;;EDmygDA;IACE,6BAA6B;ECpygD/B;;EDuygDA;IACE,+BAA+B;ECxygDjC;;ED2ygDA;IACE,6BAA6B;EC5ygD/B;;ED+ygDA;IACE,+BAA+B;EChzgDjC;;EDmzgDA;IACE,6BAA6B;ECpzgD/B;;EDuzgDA;IACE,+BAA+B;ECxzgDjC;;ED2zgDA;IACE,6BAA6B;EC5zgD/B;;ED+zgDA;IACE,+BAA+B;ECh0gDjC;;EDm0gDA;IACE,6BAA6B;ECp0gD/B;;EDu0gDA;IACE,+BAA+B;ECx0gDjC;;ED20gDA;IACE,6BAA6B;EC50gD/B;;ED+0gDA;IACE,+BAA+B;ECh1gDjC;;EDm1gDA;IACE,6BAA6B;ECp1gD/B;;EDu1gDA;IACE,+BAA+B;ECx1gDjC;;ED21gDA;IACE,6BAA6B;EC51gD/B;;ED+1gDA;IACE,+BAA+B;ECh2gDjC;;EDm2gDA;IACE,6BAA6B;ECp2gD/B;;EDu2gDA;IACE,+BAA+B;ECx2gDjC;;ED22gDA;IACE,6BAA6B;EC52gD/B;;ED+2gDA;IACE,+BAA+B;ECh3gDjC;;EDm3gDA;IACE,6BAA6B;ECp3gD/B;;EDu3gDA;IACE,+BAA+B;ECx3gDjC;;ED23gDA;IACE,6BAA6B;EC53gD/B;;ED+3gDA;IACE,+BAA+B;ECh4gDjC;;EDm4gDA;IACE,6BAA6B;ECp4gD/B;;EDu4gDA;IACE,+BAA+B;ECx4gDjC;;ED24gDA;IACE,6BAA6B;EC54gD/B;;ED+4gDA;IACE,+BAA+B;ECh5gDjC;;EDm5gDA;IACE,6BAA6B;ECp5gD/B;;EDu5gDA;IACE,+BAA+B;ECx5gDjC;;ED25gDA;IACE,6BAA6B;EC55gD/B;;ED+5gDA;IACE,+BAA+B;EC74gDjC;;EDg5gDA;IACE,6BAA6B;ECj5gD/B;;EDo5gDA;IACE,+BAA+B;ECr5gDjC;;EDw5gDA;IACE,6BAA6B;ECz5gD/B;;ED45gDA;IACE,gCAAgC;EC75gDlC;;EDg6gDA;IACE,+BAA+B;ECj6gDjC;;EDo6gDA;IACE,6BAA6B;ECr6gD/B;;EDw6gDA;IACE,+BAA+B;ECz6gDjC;;ED46gDA;IACE,6BAA6B;EC76gD/B;;EDg7gDA;IACE,+BAA+B;ECj7gDjC;;EDo7gDA;IACE,6BAA6B;ECr7gD/B;;EDw7gDA;IACE,+BAA+B;ECz7gDjC;;ED47gDA;IACE,6BAA6B;EC77gD/B;;EDg8gDA;IACE,+BAA+B;ECj8gDjC;;EDo8gDA;IACE,6BAA6B;ECr8gD/B;;EDw8gDA;IACE,+BAA+B;ECz8gDjC;;ED48gDA;IACE,6BAA6B;EC78gD/B;;EDg9gDA;IACE,+BAA+B;ECj9gDjC;;EDo9gDA;IACE,6BAA6B;ECr9gD/B;;EDw9gDA;IACE,+BAA+B;ECz9gDjC;;ED49gDA;IACE,6BAA6B;EC79gD/B;;EDg+gDA;IACE,+BAA+B;ECj+gDjC;;EDo+gDA;IACE,6BAA6B;ECr+gD/B;;EDw+gDA;IACE,+BAA+B;ECz+gDjC;;ED4+gDA;IACE,8BAA8B;EC7+gDhC;;EDg/gDA;IACE,gCAAgC;ECj/gDlC;;EDo/gDA;IACE,8BAA8B;ECr/gDhC;;EDw/gDA;IACE,gCAAgC;ECz/gDlC;;ED4/gDA;IACE,8BAA8B;EC7/gDhC;;EDgghDA;IACE,gCAAgC;ECjghDlC;;EDoghDA;IACE,8BAA8B;ECrghDhC;;EDwghDA;IACE,gCAAgC;ECzghDlC;;ED4ghDA;IACE,8BAA8B;EC7ghDhC;;EDghhDA;IACE,gCAAgC;ECjhhDlC;;EDohhDA;IACE,8BAA8B;ECrhhDhC;;EDwhhDA;IACE,gCAAgC;ECzhhDlC;;ED4hhDA;IACE,8BAA8B;EC7hhDhC;;EDgihDA;IACE,gCAAgC;ECjihDlC;;EDoihDA;IACE,8BAA8B;ECrihDhC;;EDwihDA;IACE,gCAAgC;ECzihDlC;;ED4ihDA;IACE,8BAA8B;EC7ihDhC;;EDgjhDA;IACE,gCAAgC;ECjjhDlC;;EDojhDA;IACE,8BAA8B;ECrjhDhC;;EDwjhDA;IACE,gCAAgC;ECzjhDlC;;ED4jhDA;IACE,8BAA8B;EC7jhDhC;;EDgkhDA;IACE,gCAAgC;ECjkhDlC;;EDokhDA;IACE,8BAA8B;ECrkhDhC;;EDwkhDA;IACE,gCAAgC;ECzkhDlC;;ED4khDA;IACE,8BAA8B;EC7khDhC;;EDglhDA;IACE,gCAAgC;ECjlhDlC;;EDolhDA;IACE,8BAA8B;ECrlhDhC;;EDwlhDA;IACE,gCAAgC;ECzlhDlC;;ED4lhDA;IACE,8BAA8B;EC7lhDhC;;EDgmhDA;IACE,gCAAgC;ECjmhDlC;;EDomhDA;IACE,8BAA8B;ECrmhDhC;;EDwmhDA;IACE,gCAAgC;ECzmhDlC;;ED4mhDA;IACE,8BAA8B;EC7mhDhC;;EDgnhDA;IACE,gCAAgC;ECjnhDlC;;EDonhDA;IACE,8BAA8B;ECrnhDhC;;EDwnhDA;IACE,gCAAgC;ECznhDlC;;ED4nhDA;IACE,8BAA8B;EC7nhDhC;;EDgohDA;IACE,gCAAgC;ECjohDlC;;EDoohDA;IACE,8BAA8B;ECrohDhC;;EDwohDA;IACE,gCAAgC;ECzohDlC;;ED4ohDA;IACE,8BAA8B;EC7ohDhC;;EDgphDA;IACE,gCAAgC;ECjphDlC;;EDophDA;IACE,8BAA8B;ECrphDhC;;EDwphDA;IACE,gCAAgC;ECzphDlC;;ED4phDA;IACE,8BAA8B;EC7phDhC;;EDgqhDA;IACE,gCAAgC;ECjqhDlC;;EDoqhDA;IACE,8BAA8B;ECrqhDhC;;EDwqhDA;IACE,gCAAgC;ECzqhDlC;;ED4qhDA;IACE,8BAA8B;EC7qhDhC;;EDgrhDA;IACE,gCAAgC;ECjrhDlC;;EDorhDA;IACE,8BAA8B;ECrrhDhC;;EDwrhDA;IACE,gCAAgC;ECzrhDlC;;ED4rhDA;IACE,8BAA8B;EC7rhDhC;;EDgshDA;IACE,gCAAgC;ECjshDlC;;EDoshDA;IACE,8BAA8B;ECrshDhC;;EDwshDA;IACE,gCAAgC;ECzshDlC;;ED4shDA;IACE,8BAA8B;EC7shDhC;;EDgthDA;IACE,gCAAgC;ECjthDlC;;EDothDA;IACE,8BAA8B;ECrthDhC;;EDwthDA;IACE,gCAAgC;ECzthDlC;;ED4thDA;IACE,8BAA8B;EC7thDhC;;EDguhDA;IACE,gCAAgC;ECjuhDlC;;EDouhDA;IACE,8BAA8B;ECruhDhC;;EDwuhDA;IACE,gCAAgC;ECzuhDlC;;ED4uhDA;IACE,8BAA8B;EC7uhDhC;;EDgvhDA;IACE,gCAAgC;ECjvhDlC;;EDovhDA;IACE,8BAA8B;ECrvhDhC;;EDwvhDA;IACE,gCAAgC;ECzvhDlC;;ED4vhDA;IACE,8BAA8B;EC7vhDhC;;EDgwhDA;IACE,gCAAgC;ECjwhDlC;;EDowhDA;IACE,8BAA8B;ECrwhDhC;;EDwwhDA;IACE,gCAAgC;ECzwhDlC;;ED4whDA;IACE,8BAA8B;EC7whDhC;;EDgxhDA;IACE,gCAAgC;ECjxhDlC;;EDoxhDA;IACE,8BAA8B;ECrxhDhC;;EDwxhDA;IACE,gCAAgC;ECzxhDlC;;ED4xhDA;IACE,8BAA8B;EC7xhDhC;;EDgyhDA;IACE,gCAAgC;ECjyhDlC;;EDoyhDA;IACE,8BAA8B;ECryhDhC;;EDwyhDA;IACE,gCAAgC;ECzyhDlC;;ED4yhDA;IACE,8BAA8B;EC7yhDhC;;EDgzhDA;IACE,gCAAgC;ECjzhDlC;;EDozhDA;IACE,8BAA8B;ECrzhDhC;;EDwzhDA;IACE,gCAAgC;ECzzhDlC;;ED4zhDA;IACE,8BAA8B;EC7zhDhC;;EDg0hDA;IACE,gCAAgC;ECj0hDlC;;EDo0hDA;IACE,8BAA8B;ECr0hDhC;;EDw0hDA;IACE,gCAAgC;ECz0hDlC;;ED40hDA;IACE,8BAA8B;EC70hDhC;;EDg1hDA;IACE,gCAAgC;ECj1hDlC;;EDo1hDA;IACE,8BAA8B;ECr1hDhC;;EDw1hDA;IACE,gCAAgC;ECz1hDlC;;ED41hDA;IACE,8BAA8B;EC71hDhC;;EDg2hDA;IACE,gCAAgC;ECj2hDlC;;EDo2hDA;IACE,8BAA8B;ECr2hDhC;;EDw2hDA;IACE,gCAAgC;ECz2hDlC;;ED42hDA;IACE,8BAA8B;EC72hDhC;;EDg3hDA;IACE,gCAAgC;ECj3hDlC;;EDo3hDA;IACE,8BAA8B;ECr3hDhC;;EDw3hDA;IACE,gCAAgC;ECz3hDlC;;ED43hDA;IACE,8BAA8B;EC73hDhC;;EDg4hDA;IACE,gCAAgC;ECj4hDlC;;EDo4hDA;IACE,8BAA8B;ECr4hDhC;;EDw4hDA;IACE,gCAAgC;ECz4hDlC;;ED44hDA;IACE,8BAA8B;EC74hDhC;;EDg5hDA;IACE,gCAAgC;ECj5hDlC;;EDo5hDA;IACE,8BAA8B;ECr5hDhC;;EDw5hDA;IACE,gCAAgC;ECz5hDlC;;ED45hDA;IACE,8BAA8B;EC75hDhC;;EDg6hDA;IACE,gCAAgC;ECj6hDlC;;EDo6hDA;IACE,8BAA8B;ECr6hDhC;;EDw6hDA;IACE,gCAAgC;ECz6hDlC;;ED46hDA;IACE,8BAA8B;EC76hDhC;;EDg7hDA;IACE,gCAAgC;ECj7hDlC;;EDo7hDA;IACE,8BAA8B;ECr7hDhC;;EDw7hDA;IACE,gCAAgC;ECz7hDlC;;ED47hDA;IACE,8BAA8B;EC77hDhC;;EDg8hDA;IACE,gCAAgC;ECj8hDlC;;EDo8hDA;IACE,8BAA8B;ECr8hDhC;;EDw8hDA;IACE,gCAAgC;ECz8hDlC;;ED48hDA;IACE,8BAA8B;EC78hDhC;;EDg9hDA;IACE,gCAAgC;ECj9hDlC;;EDo9hDA;IACE,8BAA8B;ECr9hDhC;;EDw9hDA;IACE,gCAAgC;ECz9hDlC;;ED49hDA;IACE,8BAA8B;EC79hDhC;;EDg+hDA;IACE,gCAAgC;ECj+hDlC;;EDo+hDA;IACE,8BAA8B;ECr+hDhC;;EDw+hDA;IACE,gCAAgC;ECz+hDlC;;ED4+hDA;IACE,8BAA8B;EC7+hDhC;;EDg/hDA;IACE,gCAAgC;ECj/hDlC;;EDo/hDA;IACE,8BAA8B;ECr/hDhC;;EDw/hDA;IACE,gCAAgC;ECz/hDlC;;ED4/hDA;IACE,8BAA8B;EC7/hDhC;;EDggiDA;IACE,gCAAgC;ECjgiDlC;;EDogiDA;IACE,8BAA8B;ECrgiDhC;;EDwgiDA;IACE,gCAAgC;ECzgiDlC;;ED4giDA;IACE,8BAA8B;EC7giDhC;;EDghiDA;IACE,gCAAgC;EC9/hDlC;;EDigiDA;IACE,8BAA8B;EAChC;;EAEA;ICngiDC,gCAAsC;EDqgiDvC;;ECvgiDA;IACC,4BAAa;IACb,6BAAc;ED0giDf;;EC5giDA;IACC,+BAAqC;IACrC,gCAAsC;ED+giDvC;;ECjhiDA;IACC,8BAAqC;IACrC,+BAAsC;EDohiDvC;;ECthiDA;IACC,4BAAqC;IACrC,6BAAsC;EDyhiDvC;;EC3hiDA;IACC,8BAAqC;IACrC,+BAAsC;ED8hiDvC;;EChiiDA;IACC,4BAAqC;IACrC,6BAAsC;EDmiiDvC;;ECriiDA;IACC,8BAAqC;IACrC,+BAAsC;EDwiiDvC;;EC1iiDA;IACC,4BAAqC;IACrC,6BAAsC;ED6iiDvC;;EC/iiDA;IACC,8BAAqC;IACrC,+BAAsC;EDkjiDvC;;ECpjiDA;IACC,4BAAqC;IACrC,6BAAsC;EDujiDvC;;ECzjiDA;IACC,8BAAqC;IACrC,+BAAsC;ED4jiDvC;;EC9jiDA;IACC,4BAAqC;IACrC,6BAAsC;EDikiDvC;;ECnkiDA;IACC,8BAAqC;IACrC,+BAAsC;EDskiDvC;;ECxkiDA;IACC,4BAAqC;IACrC,6BAAsC;ED2kiDvC;;EC7kiDA;IACC,8BAAqC;IACrC,+BAAsC;EDgliDvC;;EClliDA;IACC,4BAAqC;IACrC,6BAAsC;EDqliDvC;;ECvliDA;IACC,8BAAqC;IACrC,+BAAsC;ED0liDvC;;EC5liDA;IACC,4BAAqC;IACrC,6BAAsC;ED+liDvC;;ECjmiDA;IACC,8BAAqC;IACrC,+BAAsC;EDomiDvC;;ECtmiDA;IACC,4BAAa;IACb,6BAAc;EDymiDf;;EC3miDA;IACC,8BAAa;IACb,+BAAc;ED8miDf;;EChniDA;IACC,6BAAqC;IACrC,8BAAsC;EDmniDvC;;ECrniDA;IACC,+BAAqC;IACrC,gCAAsC;EDwniDvC;;EC1niDA;IACC,6BAAqC;IACrC,8BAAsC;ED6niDvC;;EC/niDA;IACC,+BAAqC;IACrC,gCAAsC;EDkoiDvC;;ECpoiDA;IACC,6BAAqC;IACrC,8BAAsC;EDuoiDvC;;ECzoiDA;IACC,+BAAqC;IACrC,gCAAsC;ED4oiDvC;;EC9oiDA;IACC,6BAAqC;IACrC,8BAAsC;EDipiDvC;;ECnpiDA;IACC,+BAAqC;IACrC,gCAAsC;EDspiDvC;;ECxpiDA;IACC,6BAAqC;IACrC,8BAAsC;ED2piDvC;;EC7piDA;IACC,+BAAqC;IACrC,gCAAsC;EDgqiDvC;;EClqiDA;IACC,6BAAqC;IACrC,8BAAsC;EDqqiDvC;;ECvqiDA;IACC,+BAAqC;IACrC,gCAAsC;ED0qiDvC;;EC5qiDA;IACC,6BAAqC;IACrC,8BAAsC;ED+qiDvC;;ECjriDA;IACC,+BAAqC;IACrC,gCAAsC;EDoriDvC;;ECtriDA;IACC,6BAAqC;IACrC,8BAAsC;EDyriDvC;;EC3riDA;IACC,+BAAqC;IACrC,gCAAsC;ED8riDvC;;EChsiDA;IACC,6BAAqC;IACrC,8BAAsC;EDmsiDvC;;ECrsiDA;IACC,+BAAqC;IACrC,gCAAsC;EDwsiDvC;;EC1siDA;IACC,6BAAqC;IACrC,8BAAsC;ED6siDvC;;EC/siDA;IACC,+BAAqC;IACrC,gCAAsC;EDktiDvC;;ECptiDA;IACC,6BAAqC;IACrC,8BAAsC;EDutiDvC;;ECztiDA;IACC,+BAAqC;IACrC,gCAAsC;ED4tiDvC;;EC9tiDA;IACC,6BAAqC;IACrC,8BAAsC;EDiuiDvC;;ECnuiDA;IACC,+BAAqC;IACrC,gCAAsC;EDsuiDvC;;ECxuiDA;IACC,6BAAqC;IACrC,8BAAsC;ED2uiDvC;;EC7uiDA;IACC,+BAAqC;IACrC,gCAAsC;EDgviDvC;;EClviDA;IACC,6BAAqC;IACrC,8BAAsC;EDqviDvC;;ECvviDA;IACC,+BAAqC;IACrC,gCAAsC;ED0viDvC;;EC5viDA;IACC,6BAAqC;IACrC,8BAAsC;ED+viDvC;;ECjwiDA;IACC,+BAAqC;IACrC,gCAAsC;EDowiDvC;;ECtwiDA;IACC,6BAAqC;IACrC,8BAAsC;EDywiDvC;;EC3wiDA;IACC,+BAAqC;IACrC,gCAAsC;ED8wiDvC;;EChxiDA;IACC,6BAAqC;IACrC,8BAAsC;EDmxiDvC;;ECrxiDA;IACC,+BAAqC;IACrC,gCAAsC;EDwxiDvC;;EC1xiDA;IACC,6BAAqC;IACrC,8BAAsC;ED6xiDvC;;EC/xiDA;IACC,+BAAqC;IACrC,gCAAsC;EDkyiDvC;;ECpyiDA;IACC,6BAAqC;IACrC,8BAAsC;EDuyiDvC;;ECzyiDA;IACC,+BAAqC;IACrC,gCAAsC;ED4yiDvC;;EC9yiDA;IACC,6BAAqC;IACrC,8BAAsC;EDiziDvC;;ECnziDA;IACC,+BAAqC;IACrC,gCAAsC;EDsziDvC;;ECxziDA;IACC,6BAAqC;IACrC,8BAAsC;ED2ziDvC;;EC7ziDA;IACC,+BAAqC;IACrC,gCAAsC;EDg0iDvC;;ECl0iDA;IACC,6BAAqC;IACrC,8BAAsC;EDq0iDvC;;ECv0iDA;IACC,+BAAqC;IACrC,gCAAsC;ED00iDvC;;EC50iDA;IACC,6BAAqC;IACrC,8BAAsC;ED+0iDvC;;ECj1iDA;IACC,+BAAqC;IACrC,gCAAsC;EDo1iDvC;;ECt1iDA;IACC,6BAAqC;IACrC,8BAAsC;EDy1iDvC;;EC31iDA;IACC,+BAAqC;IACrC,gCAAsC;ED81iDvC;;ECh2iDA;IACC,6BAAqC;IACrC,8BAAsC;EDm2iDvC;;ECr2iDA;IACC,+BAAqC;IACrC,gCAAsC;EDw2iDvC;;EC12iDA;IACC,6BAAqC;IACrC,8BAAsC;ED62iDvC;;EC/2iDA;IACC,+BAAqC;IACrC,gCAAsC;EDk3iDvC;;ECp3iDA;IACC,6BAAqC;IACrC,8BAAsC;EDu3iDvC;;ECz3iDA;IACC,+BAAqC;IACrC,gCAAsC;ED43iDvC;;EC93iDA;IACC,6BAAqC;IACrC,8BAAsC;EDi4iDvC;;ECn4iDA;IACC,+BAAqC;IACrC,gCAAsC;EDs4iDvC;;ECx4iDA;IACC,6BAAqC;IACrC,8BAAsC;ED24iDvC;;EC74iDA;IACC,+BAAqC;IACrC,gCAAsC;EDg5iDvC;;ECl5iDA;IACC,6BAAqC;IACrC,8BAAsC;EDq5iDvC;;ECv5iDA;IACC,+BAAqC;IACrC,gCAAsC;ED05iDvC;;EC55iDA;IACC,6BAAqC;IACrC,8BAAsC;ED+5iDvC;;ECj6iDA;IACC,+BAAqC;IACrC,gCAAsC;EDo6iDvC;;ECt6iDA;IACC,6BAAqC;IACrC,8BAAsC;EDy6iDvC;;EC36iDA;IACC,+BAAqC;IACrC,gCAAsC;ED86iDvC;;ECh7iDA;IACC,6BAAqC;IACrC,8BAAsC;EDm7iDvC;;ECr7iDA;IACC,+BAAqC;IACrC,gCAAsC;EDw7iDvC;;EC17iDA;IACC,6BAAqC;IACrC,8BAAsC;ED67iDvC;;EC/7iDA;IACC,+BAAqC;IACrC,gCAAsC;EDk8iDvC;;ECp8iDA;IACC,6BAAqC;IACrC,8BAAsC;EDu8iDvC;;ECz8iDA;IACC,+BAAqC;IACrC,gCAAsC;ED48iDvC;;EC98iDA;IACC,6BAAqC;IACrC,8BAAsC;EDi9iDvC;;ECn9iDA;IACC,+BAAqC;IACrC,gCAAsC;EDs9iDvC;;ECx9iDA;IACC,6BAAqC;IACrC,8BAAsC;ED29iDvC;;EC79iDA;IACC,+BAAqC;IACrC,gCAAsC;EDg+iDvC;;ECl+iDA;IACC,6BAAqC;IACrC,8BAAsC;EDq+iDvC;;ECv+iDA;IACC,+BAAqC;IACrC,gCAAsC;ED0+iDvC;;EC5+iDA;IACC,6BAAqC;IACrC,8BAAsC;ED++iDvC;;ECj/iDA;IACC,+BAAqC;IACrC,gCAAsC;EDo/iDvC;;ECt/iDA;IACC,6BAAqC;IACrC,8BAAsC;EDy/iDvC;;EC3/iDA;IACC,+BAAqC;IACrC,gCAAsC;ED8/iDvC;;EChgjDA;IACC,6BAAqC;IACrC,8BAAsC;EDmgjDvC;;ECrgjDA;IACC,+BAAqC;IACrC,gCAAsC;EDwgjDvC;;EC1gjDA;IACC,6BAAqC;IACrC,8BAAsC;ED6gjDvC;;EC/gjDA;IACC,+BAAqC;IACrC,gCAAsC;EDkhjDvC;;ECphjDA;IACC,6BAAqC;IACrC,8BAAsC;EDuhjDvC;;ECzhjDA;IACC,+BAAqC;IACrC,gCAAsC;ED4hjDvC;;EC9hjDA;IACC,6BAAqC;IACrC,8BAAsC;EDiijDvC;;ECnijDA;IACC,+BAAqC;IACrC,gCAAsC;EDsijDvC;;ECxijDA;IACC,6BAAqC;IACrC,8BAAsC;ED2ijDvC;;EC7ijDA;IACC,+BAAqC;IACrC,gCAAsC;EDgjjDvC;;ECljjDA;IACC,6BAAqC;IACrC,8BAAsC;EDqjjDvC;;ECvjjDA;IACC,+BAAqC;IACrC,gCAAsC;ED0jjDvC;;EC5jjDA;IACC,6BAAqC;IACrC,8BAAsC;ED+jjDvC;;ECjkjDA;IACC,+BAAqC;IACrC,gCAAsC;EDokjDvC;;ECtkjDA;IACC,6BAAqC;IACrC,8BAAsC;EDykjDvC;;EC3kjDA;IACC,+BAAqC;IACrC,gCAAsC;ED8kjDvC;;EChljDA;IACC,6BAAqC;IACrC,8BAAsC;EDmljDvC;;ECrljDA;IACC,+BAAqC;IACrC,gCAAsC;EDwljDvC;;EC1ljDA;IACC,6BAAqC;IACrC,8BAAsC;ED6ljDvC;;EC/ljDA;IACC,+BAAqC;IACrC,gCAAsC;EDkmjDvC;;ECpmjDA;IACC,6BAAqC;IACrC,8BAAsC;EDumjDvC;;ECzmjDA;IACC,+BAAqC;IACrC,gCAAsC;ED4mjDvC;;EC9mjDA;IACC,6BAAqC;IACrC,8BAAsC;EDinjDvC;;ECnnjDA;IACC,+BAAqC;IACrC,gCAAsC;EDsnjDvC;;ECxnjDA;IACC,6BAAqC;IACrC,8BAAsC;ED2njDvC;;EC7njDA;IACC,+BAAqC;IACrC,gCAAsC;EDgojDvC;;EClojDA;IACC,6BAAqC;IACrC,8BAAsC;EDqojDvC;;ECvojDA;IACC,+BAAqC;IACrC,gCAAsC;ED0ojDvC;;EC5ojDA;IACC,6BAAqC;IACrC,8BAAsC;ED+ojDvC;;ECjpjDA;IACC,+BAAqC;IACrC,gCAAsC;EDopjDvC;;ECtpjDA;IACC,6BAAqC;IACrC,8BAAsC;EDypjDvC;;EC3pjDA;IACC,+BAAqC;IACrC,gCAAsC;ED8pjDvC;;EChqjDA;IACC,6BAAqC;IACrC,8BAAsC;EDmqjDvC;;ECrqjDA;IACC,+BAAqC;IACrC,gCAAsC;EDwqjDvC;;EC1qjDA;IACC,6BAAqC;IACrC,8BAAsC;ED6qjDvC;;EC/qjDA;IACC,+BAAqC;IACrC,gCAAsC;EDkrjDvC;;ECprjDA;IACC,6BAAqC;IACrC,8BAAsC;EDurjDvC;;ECzrjDA;IACC,+BAAqC;IACrC,gCAAsC;ED4rjDvC;;EC9rjDA;IACC,6BAAqC;IACrC,8BAAsC;EDisjDvC;;ECnsjDA;IACC,+BAAqC;IACrC,gCAAsC;EDssjDvC;;ECxsjDA;IACC,6BAAqC;IACrC,8BAAsC;ED2sjDvC;;EC7sjDA;IACC,+BAAqC;IACrC,gCAAsC;EDgtjDvC;;ECltjDA;IACC,6BAAqC;IACrC,8BAAsC;EDqtjDvC;;ECvtjDA;IACC,+BAAqC;IACrC,gCAAsC;ED0tjDvC;;EC5tjDA;IACC,6BAAqC;IACrC,8BAAsC;ED+tjDvC;;ECjujDA;IACC,+BAAqC;IACrC,gCAAsC;EDoujDvC;;ECtujDA;IACC,6BAAqC;IACrC,8BAAsC;EDyujDvC;;EC3ujDA;IACC,+BAAqC;IACrC,gCAAsC;ED8ujDvC;;EChvjDA;IACC,6BAAqC;IACrC,8BAAsC;EDmvjDvC;;ECrvjDA;IACC,+BAAqC;IACrC,gCAAsC;EDwvjDvC;;EC1vjDA;IACC,6BAAqC;IACrC,8BAAsC;ED6vjDvC;;EC/vjDA;IACC,+BAAqC;IACrC,gCAAsC;EDkwjDvC;;ECpwjDA;IACC,6BAAqC;IACrC,8BAAsC;EDuwjDvC;;ECzwjDA;IACC,+BAAqC;IACrC,gCAAsC;ED4wjDvC;;EC9wjDA;IACC,6BAAqC;IACrC,8BAAsC;EDixjDvC;;ECnxjDA;IACC,+BAAqC;IACrC,gCAAsC;EDsxjDvC;;ECxxjDA;IACC,6BAAqC;IACrC,8BAAsC;ED2xjDvC;;EC7xjDA;IACC,+BAAqC;IACrC,gCAAsC;EDgyjDvC;;EC9wjDA;IACC,6BAAoC;IACpC,8BAAuC;EDixjDxC;;ECnxjDA;IACC,+BAAoC;IACpC,gCAAe;EDsxjDhB;;ECxxjDA;IACC,2BAAY;IACZ,8BAAe;ED2xjDhB;;EC7xjDA;IACC,8BAAoC;IACpC,iCAAuC;EDgyjDxC;;EClyjDA;IACC,6BAAoC;IACpC,gCAAuC;EDqyjDxC;;ECvyjDA;IACC,2BAAoC;IACpC,8BAAuC;ED0yjDxC;;EC5yjDA;IACC,6BAAoC;IACpC,gCAAuC;ED+yjDxC;;ECjzjDA;IACC,2BAAoC;IACpC,8BAAuC;EDozjDxC;;ECtzjDA;IACC,6BAAoC;IACpC,gCAAuC;EDyzjDxC;;EC3zjDA;IACC,2BAAoC;IACpC,8BAAuC;ED8zjDxC;;ECh0jDA;IACC,6BAAoC;IACpC,gCAAuC;EDm0jDxC;;ECr0jDA;IACC,2BAAoC;IACpC,8BAAuC;EDw0jDxC;;EC10jDA;IACC,6BAAoC;IACpC,gCAAuC;ED60jDxC;;EC/0jDA;IACC,2BAAoC;IACpC,8BAAuC;EDk1jDxC;;ECp1jDA;IACC,6BAAoC;IACpC,gCAAuC;EDu1jDxC;;ECz1jDA;IACC,2BAAoC;IACpC,8BAAuC;ED41jDxC;;EC91jDA;IACC,6BAAoC;IACpC,gCAAuC;EDi2jDxC;;ECn2jDA;IACC,2BAAoC;IACpC,8BAAuC;EDs2jDxC;;ECx2jDA;IACC,6BAAoC;IACpC,gCAAuC;ED22jDxC;;EC72jDA;IACC,2BAAoC;IACpC,8BAAuC;EDg3jDxC;;ECl3jDA;IACC,6BAAoC;IACpC,gCAAuC;EDq3jDxC;;ECv3jDA;IACC,2BAAY;IACZ,8BAAe;ED03jDhB;;EC53jDA;IACC,6BAAY;IACZ,gCAAe;ED+3jDhB;;ECj4jDA;IACC,4BAAoC;IACpC,+BAAuC;EDo4jDxC;;ECt4jDA;IACC,8BAAoC;IACpC,iCAAuC;EDy4jDxC;;EC34jDA;IACC,4BAAoC;IACpC,+BAAuC;ED84jDxC;;ECh5jDA;IACC,8BAAoC;IACpC,iCAAuC;EDm5jDxC;;ECr5jDA;IACC,4BAAoC;IACpC,+BAAuC;EDw5jDxC;;EC15jDA;IACC,8BAAoC;IACpC,iCAAuC;ED65jDxC;;EC/5jDA;IACC,4BAAoC;IACpC,+BAAuC;EDk6jDxC;;ECp6jDA;IACC,8BAAoC;IACpC,iCAAuC;EDu6jDxC;;ECz6jDA;IACC,4BAAoC;IACpC,+BAAuC;ED46jDxC;;EC96jDA;IACC,8BAAoC;IACpC,iCAAuC;EDi7jDxC;;ECn7jDA;IACC,4BAAoC;IACpC,+BAAuC;EDs7jDxC;;ECx7jDA;IACC,8BAAoC;IACpC,iCAAuC;ED27jDxC;;EC77jDA;IACC,4BAAoC;IACpC,+BAAuC;EDg8jDxC;;ECl8jDA;IACC,8BAAoC;IACpC,iCAAuC;EDq8jDxC;;ECv8jDA;IACC,4BAAoC;IACpC,+BAAuC;ED08jDxC;;EC58jDA;IACC,8BAAoC;IACpC,iCAAuC;ED+8jDxC;;ECj9jDA;IACC,4BAAoC;IACpC,+BAAuC;EDo9jDxC;;ECt9jDA;IACC,8BAAoC;IACpC,iCAAuC;EDy9jDxC;;EC39jDA;IACC,4BAAoC;IACpC,+BAAuC;ED89jDxC;;ECh+jDA;IACC,8BAAoC;IACpC,iCAAuC;EDm+jDxC;;ECr+jDA;IACC,4BAAoC;IACpC,+BAAuC;EDw+jDxC;;EC1+jDA;IACC,8BAAoC;IACpC,iCAAuC;ED6+jDxC;;EC/+jDA;IACC,4BAAoC;IACpC,+BAAuC;EDk/jDxC;;ECp/jDA;IACC,8BAAoC;IACpC,iCAAuC;EDu/jDxC;;ECz/jDA;IACC,4BAAoC;IACpC,+BAAuC;ED4/jDxC;;EC9/jDA;IACC,8BAAoC;IACpC,iCAAuC;EDigkDxC;;ECngkDA;IACC,4BAAoC;IACpC,+BAAuC;EDsgkDxC;;ECxgkDA;IACC,8BAAoC;IACpC,iCAAuC;ED2gkDxC;;EC7gkDA;IACC,4BAAoC;IACpC,+BAAuC;EDghkDxC;;EClhkDA;IACC,8BAAoC;IACpC,iCAAuC;EDqhkDxC;;ECvhkDA;IACC,4BAAoC;IACpC,+BAAuC;ED0hkDxC;;EC5hkDA;IACC,8BAAoC;IACpC,iCAAuC;ED+hkDxC;;ECjikDA;IACC,4BAAoC;IACpC,+BAAuC;EDoikDxC;;ECtikDA;IACC,8BAAoC;IACpC,iCAAuC;EDyikDxC;;EC3ikDA;IACC,4BAAoC;IACpC,+BAAuC;ED8ikDxC;;EChjkDA;IACC,8BAAoC;IACpC,iCAAuC;EDmjkDxC;;ECrjkDA;IACC,4BAAoC;IACpC,+BAAuC;EDwjkDxC;;EC1jkDA;IACC,8BAAoC;IACpC,iCAAuC;ED6jkDxC;;EC/jkDA;IACC,4BAAoC;IACpC,+BAAuC;EDkkkDxC;;ECpkkDA;IACC,8BAAoC;IACpC,iCAAuC;EDukkDxC;;ECzkkDA;IACC,4BAAoC;IACpC,+BAAuC;ED4kkDxC;;EC9kkDA;IACC,8BAAoC;IACpC,iCAAuC;EDilkDxC;;ECnlkDA;IACC,4BAAoC;IACpC,+BAAuC;EDslkDxC;;ECxlkDA;IACC,8BAAoC;IACpC,iCAAuC;ED2lkDxC;;EC7lkDA;IACC,4BAAoC;IACpC,+BAAuC;EDgmkDxC;;EClmkDA;IACC,8BAAoC;IACpC,iCAAuC;EDqmkDxC;;ECvmkDA;IACC,4BAAoC;IACpC,+BAAuC;ED0mkDxC;;EC5mkDA;IACC,8BAAoC;IACpC,iCAAuC;ED+mkDxC;;ECjnkDA;IACC,4BAAoC;IACpC,+BAAuC;EDonkDxC;;ECtnkDA;IACC,8BAAoC;IACpC,iCAAuC;EDynkDxC;;EC3nkDA;IACC,4BAAoC;IACpC,+BAAuC;ED8nkDxC;;EChokDA;IACC,8BAAoC;IACpC,iCAAuC;EDmokDxC;;ECrokDA;IACC,4BAAoC;IACpC,+BAAuC;EDwokDxC;;EC1okDA;IACC,8BAAoC;IACpC,iCAAuC;ED6okDxC;;EC/okDA;IACC,4BAAoC;IACpC,+BAAuC;EDkpkDxC;;ECppkDA;IACC,8BAAoC;IACpC,iCAAuC;EDupkDxC;;ECzpkDA;IACC,4BAAoC;IACpC,+BAAuC;ED4pkDxC;;EC9pkDA;IACC,8BAAoC;IACpC,iCAAuC;EDiqkDxC;;ECnqkDA;IACC,4BAAoC;IACpC,+BAAuC;EDsqkDxC;;ECxqkDA;IACC,8BAAoC;IACpC,iCAAuC;ED2qkDxC;;EC7qkDA;IACC,4BAAoC;IACpC,+BAAuC;EDgrkDxC;;EClrkDA;IACC,8BAAoC;IACpC,iCAAuC;EDqrkDxC;;ECvrkDA;IACC,4BAAoC;IACpC,+BAAuC;ED0rkDxC;;EC5rkDA;IACC,8BAAoC;IACpC,iCAAuC;ED+rkDxC;;ECjskDA;IACC,4BAAoC;IACpC,+BAAuC;EDoskDxC;;ECtskDA;IACC,8BAAoC;IACpC,iCAAuC;EDyskDxC;;EC3skDA;IACC,4BAAoC;IACpC,+BAAuC;ED8skDxC;;EChtkDA;IACC,8BAAoC;IACpC,iCAAuC;EDmtkDxC;;ECrtkDA;IACC,4BAAoC;IACpC,+BAAuC;EDwtkDxC;;EC1tkDA;IACC,8BAAoC;IACpC,iCAAuC;ED6tkDxC;;EC/tkDA;IACC,4BAAoC;IACpC,+BAAuC;EDkukDxC;;ECpukDA;IACC,8BAAoC;IACpC,iCAAuC;EDuukDxC;;ECzukDA;IACC,4BAAoC;IACpC,+BAAuC;ED4ukDxC;;EC9ukDA;IACC,8BAAoC;IACpC,iCAAuC;EDivkDxC;;ECnvkDA;IACC,4BAAoC;IACpC,+BAAuC;EDsvkDxC;;ECxvkDA;IACC,8BAAoC;IACpC,iCAAuC;ED2vkDxC;;EC7vkDA;IACC,4BAAoC;IACpC,+BAAuC;EDgwkDxC;;EClwkDA;IACC,8BAAoC;IACpC,iCAAuC;EDqwkDxC;;ECvwkDA;IACC,4BAAoC;IACpC,+BAAuC;ED0wkDxC;;EC5wkDA;IACC,8BAAoC;IACpC,iCAAuC;ED+wkDxC;;ECjxkDA;IACC,4BAAoC;IACpC,+BAAuC;EDoxkDxC;;ECtxkDA;IACC,8BAAoC;IACpC,iCAAuC;EDyxkDxC;;EC3xkDA;IACC,4BAAoC;IACpC,+BAAuC;ED8xkDxC;;EChykDA;IACC,8BAAoC;IACpC,iCAAuC;EDmykDxC;;ECrykDA;IACC,4BAAoC;IACpC,+BAAuC;EDwykDxC;;EC1ykDA;IACC,8BAAoC;IACpC,iCAAuC;ED6ykDxC;;EC/ykDA;IACC,4BAAoC;IACpC,+BAAuC;EDkzkDxC;;ECpzkDA;IACC,8BAAoC;IACpC,iCAAuC;EDuzkDxC;;ECzzkDA;IACC,4BAAoC;IACpC,+BAAuC;ED4zkDxC;;EC9zkDA;IACC,8BAAoC;IACpC,iCAAuC;EDi0kDxC;;ECn0kDA;IACC,4BAAoC;IACpC,+BAAuC;EDs0kDxC;;ECx0kDA;IACC,8BAAoC;IACpC,iCAAuC;ED20kDxC;;EC70kDA;IACC,4BAAoC;IACpC,+BAAuC;EDg1kDxC;;ECl1kDA;IACC,8BAAoC;IACpC,iCAAuC;EDq1kDxC;;ECv1kDA;IACC,4BAAoC;IACpC,+BAAuC;ED01kDxC;;EC51kDA;IACC,8BAAoC;IACpC,iCAAuC;ED+1kDxC;;ECj2kDA;IACC,4BAAoC;IACpC,+BAAuC;EDo2kDxC;;ECt2kDA;IACC,8BAAoC;IACpC,iCAAuC;EDy2kDxC;;EC32kDA;IACC,4BAAoC;IACpC,+BAAuC;ED82kDxC;;ECh3kDA;IACC,8BAAoC;IACpC,iCAAuC;EDm3kDxC;;ECr3kDA;IACC,4BAAoC;IACpC,+BAAuC;EDw3kDxC;;EC13kDA;IACC,8BAAoC;IACpC,iCAAuC;ED63kDxC;;EC/3kDA;IACC,4BAAoC;IACpC,+BAAuC;EDk4kDxC;;ECp4kDA;IACC,8BAAoC;IACpC,iCAAuC;EDu4kDxC;;ECz4kDA;IACC,4BAAoC;IACpC,+BAAuC;ED44kDxC;;EC94kDA;IACC,8BAAoC;IACpC,iCAAuC;EDi5kDxC;;ECn5kDA;IACC,4BAAoC;IACpC,+BAAuC;EDs5kDxC;;ECx5kDA;IACC,8BAAoC;IACpC,iCAAuC;ED25kDxC;;EC75kDA;IACC,4BAAoC;IACpC,+BAAuC;EDg6kDxC;;ECl6kDA;IACC,8BAAoC;IACpC,iCAAuC;EDq6kDxC;;ECv6kDA;IACC,4BAAoC;IACpC,+BAAuC;ED06kDxC;;EC56kDA;IACC,8BAAoC;IACpC,iCAAuC;ED+6kDxC;;ECj7kDA;IACC,4BAAoC;IACpC,+BAAuC;EDo7kDxC;;ECt7kDA;IACC,8BAAoC;IACpC,iCAAuC;EDy7kDxC;;EC37kDA;IACC,4BAAoC;IACpC,+BAAuC;ED87kDxC;;ECh8kDA;IACC,8BAAoC;IACpC,iCAAuC;EDm8kDxC;;ECr8kDA;IACC,4BAAoC;IACpC,+BAAuC;EDw8kDxC;;EC18kDA;IACC,8BAAoC;IACpC,iCAAuC;ED68kDxC;;EC/8kDA;IACC,4BAAoC;IACpC,+BAAuC;EDk9kDxC;;ECp9kDA;IACC,8BAAoC;IACpC,iCAAuC;EDu9kDxC;;ECz9kDA;IACC,4BAAoC;IACpC,+BAAuC;ED49kDxC;;EC99kDA;IACC,8BAAoC;IACpC,iCAAuC;EDi+kDxC;;ECn+kDA;IACC,4BAAoC;IACpC,+BAAuC;EDs+kDxC;;ECx+kDA;IACC,8BAAoC;IACpC,iCAAuC;ED2+kDxC;;EC7+kDA;IACC,4BAAoC;IACpC,+BAAuC;EDg/kDxC;;ECl/kDA;IACC,8BAAoC;IACpC,iCAAuC;EDq/kDxC;;ECv/kDA;IACC,4BAAoC;IACpC,+BAAuC;ED0/kDxC;;EC5/kDA;IACC,8BAAoC;IACpC,iCAAuC;ED+/kDxC;;ECjglDA;IACC,4BAAoC;IACpC,+BAAuC;EDoglDxC;;ECtglDA;IACC,8BAAoC;IACpC,iCAAuC;EDyglDxC;;EC3glDA;IACC,4BAAoC;IACpC,+BAAuC;ED8glDxC;;EChhlDA;IACC,8BAAoC;IACpC,iCAAuC;EDmhlDxC;;ECrhlDA;IACC,4BAAoC;IACpC,+BAAuC;EDwhlDxC;;EC1hlDA;IACC,8BAAoC;IACpC,iCAAuC;ED6hlDxC;;EC/hlDA;IACC,4BAAoC;IACpC,+BAAuC;EDkilDxC;;ECpilDA;IACC,8BAAoC;IACpC,iCAAuC;EDuilDxC;;ECzilDA;IACC,4BAAoC;IACpC,+BAAuC;ED4ilDxC;;EC9ilDA;IACC,8BAAoC;IACpC,iCAAuC;EDijlDxC;;EC3ilDF;IAaE,4BAAe;IACd,+BAAgC;EDkilDjC;;ECnilDA;IACC,8BAAgC;IDsilD/B,iCAAiC;EACnC;AACF;AACA;EACE;IACE,uBAAuB;EC5ilDzB;;ED+ilDA;IACE,0BAA0B;EChjlD5B;;EDmjlDA;IACE,yBAAyB;ECpjlD3B;;EDujlDA;IACE,uBAAuB;ECxjlDzB;;ED2jlDA;IACE,yBAAyB;EC5jlD3B;;ED+jlDA;IACE,uBAAuB;EChklDzB;;EDmklDA;IACE,yBAAyB;ECpklD3B;;EDuklDA;IACE,uBAAuB;ECxklDzB;;ED2klDA;IACE,yBAAyB;EC5klD3B;;ED+klDA;IACE,uBAAuB;EChllDzB;;EDmllDA;IACE,yBAAyB;ECpllD3B;;EDullDA;IACE,uBAAuB;ECxllDzB;;ED2llDA;IACE,yBAAyB;EC5llD3B;;ED+llDA;IACE,uBAAuB;EChmlDzB;;EDmmlDA;IACE,yBAAyB;ECpmlD3B;;EDumlDA;IACE,uBAAuB;ECxmlDzB;;ED2mlDA;IACE,yBAAyB;EC5mlD3B;;ED+mlDA;IACE,uBAAuB;EChnlDzB;;EDmnlDA;IACE,yBAAyB;ECpnlD3B;;EDunlDA;IACE,uBAAuB;ECxnlDzB;;ED2nlDA;IACE,yBAAyB;EC5nlD3B;;ED+nlDA;IACE,wBAAwB;ECholD1B;;EDmolDA;IACE,0BAA0B;ECpolD5B;;EDuolDA;IACE,wBAAwB;ECxolD1B;;ED2olDA;IACE,0BAA0B;EC5olD5B;;ED+olDA;IACE,wBAAwB;EChplD1B;;EDmplDA;IACE,0BAA0B;ECpplD5B;;EDuplDA;IACE,wBAAwB;ECxplD1B;;ED2plDA;IACE,0BAA0B;EC5plD5B;;ED+plDA;IACE,wBAAwB;EChqlD1B;;EDmqlDA;IACE,0BAA0B;ECpqlD5B;;EDuqlDA;IACE,wBAAwB;ECxqlD1B;;ED2qlDA;IACE,0BAA0B;EC5qlD5B;;ED+qlDA;IACE,wBAAwB;EChrlD1B;;EDmrlDA;IACE,0BAA0B;ECprlD5B;;EDurlDA;IACE,wBAAwB;ECxrlD1B;;ED2rlDA;IACE,0BAA0B;EC5rlD5B;;ED+rlDA;IACE,wBAAwB;EChslD1B;;EDmslDA;IACE,0BAA0B;ECpslD5B;;EDuslDA;IACE,wBAAwB;ECxslD1B;;ED2slDA;IACE,0BAA0B;EC5slD5B;;ED+slDA;IACE,wBAAwB;EChtlD1B;;EDmtlDA;IACE,0BAA0B;ECptlD5B;;EDutlDA;IACE,wBAAwB;ECxtlD1B;;ED2tlDA;IACE,0BAA0B;EC5tlD5B;;ED+tlDA;IACE,wBAAwB;EChulD1B;;EDmulDA;IACE,0BAA0B;ECpulD5B;;EDuulDA;IACE,wBAAwB;ECxulD1B;;ED2ulDA;IACE,0BAA0B;EC5ulD5B;;ED+ulDA;IACE,wBAAwB;EChvlD1B;;EDmvlDA;IACE,0BAA0B;ECpvlD5B;;EDuvlDA;IACE,wBAAwB;ECxvlD1B;;ED2vlDA;IACE,0BAA0B;EC5vlD5B;;ED+vlDA;IACE,wBAAwB;EChwlD1B;;EDmwlDA;IACE,0BAA0B;ECpwlD5B;;EDuwlDA;IACE,wBAAwB;ECxwlD1B;;ED2wlDA;IACE,0BAA0B;EC5wlD5B;;ED+wlDA;IACE,wBAAwB;EChxlD1B;;EDmxlDA;IACE,0BAA0B;ECpxlD5B;;EDuxlDA;IACE,wBAAwB;ECxxlD1B;;ED2xlDA;IACE,0BAA0B;EC5xlD5B;;ED+xlDA;IACE,wBAAwB;EChylD1B;;EDmylDA;IACE,0BAA0B;ECpylD5B;;EDuylDA;IACE,wBAAwB;ECxylD1B;;ED2ylDA;IACE,0BAA0B;EC5ylD5B;;ED+ylDA;IACE,wBAAwB;EChzlD1B;;EDmzlDA;IACE,0BAA0B;ECpzlD5B;;EDuzlDA;IACE,wBAAwB;ECxzlD1B;;ED2zlDA;IACE,0BAA0B;EC5zlD5B;;ED+zlDA;IACE,wBAAwB;ECh0lD1B;;EDm0lDA;IACE,0BAA0B;ECp0lD5B;;EDu0lDA;IACE,wBAAwB;ECx0lD1B;;ED20lDA;IACE,0BAA0B;EC50lD5B;;ED+0lDA;IACE,wBAAwB;ECh1lD1B;;EDm1lDA;IACE,0BAA0B;ECp1lD5B;;EDu1lDA;IACE,wBAAwB;ECx1lD1B;;ED21lDA;IACE,0BAA0B;EC51lD5B;;ED+1lDA;IACE,wBAAwB;ECh2lD1B;;EDm2lDA;IACE,0BAA0B;ECp2lD5B;;EDu2lDA;IACE,wBAAwB;ECx2lD1B;;ED22lDA;IACE,0BAA0B;EC52lD5B;;ED+2lDA;IACE,wBAAwB;ECh3lD1B;;EDm3lDA;IACE,0BAA0B;ECp3lD5B;;EDu3lDA;IACE,wBAAwB;ECx3lD1B;;ED23lDA;IACE,0BAA0B;EC53lD5B;;ED+3lDA;IACE,wBAAwB;ECh4lD1B;;EDm4lDA;IACE,0BAA0B;ECp4lD5B;;EDu4lDA;IACE,wBAAwB;ECx4lD1B;;ED24lDA;IACE,0BAA0B;EC54lD5B;;ED+4lDA;IACE,wBAAwB;ECh5lD1B;;EDm5lDA;IACE,0BAA0B;ECp5lD5B;;EDu5lDA;IACE,wBAAwB;ECx5lD1B;;ED25lDA;IACE,0BAA0B;EC55lD5B;;ED+5lDA;IACE,wBAAwB;ECh6lD1B;;EDm6lDA;IACE,0BAA0B;ECp6lD5B;;EDu6lDA;IACE,wBAAwB;ECx6lD1B;;ED26lDA;IACE,0BAA0B;EC56lD5B;;ED+6lDA;IACE,wBAAwB;ECh7lD1B;;EDm7lDA;IACE,0BAA0B;ECp7lD5B;;EDu7lDA;IACE,wBAAwB;ECx7lD1B;;ED27lDA;IACE,0BAA0B;EC57lD5B;;ED+7lDA;IACE,wBAAwB;ECh8lD1B;;EDm8lDA;IACE,0BAA0B;ECp8lD5B;;EDu8lDA;IACE,wBAAwB;ECx8lD1B;;ED28lDA;IACE,0BAA0B;EC58lD5B;;ED+8lDA;IACE,wBAAwB;ECh9lD1B;;EDm9lDA;IACE,0BAA0B;ECp9lD5B;;EDu9lDA;IACE,wBAAwB;ECx9lD1B;;ED29lDA;IACE,0BAA0B;EC59lD5B;;ED+9lDA;IACE,wBAAwB;ECh+lD1B;;EDm+lDA;IACE,0BAA0B;ECp+lD5B;;EDu+lDA;IACE,wBAAwB;ECx+lD1B;;ED2+lDA;IACE,0BAA0B;EC5+lD5B;;ED++lDA;IACE,wBAAwB;ECh/lD1B;;EDm/lDA;IACE,0BAA0B;ECp/lD5B;;EDu/lDA;IACE,wBAAwB;ECx/lD1B;;ED2/lDA;IACE,0BAA0B;EC5/lD5B;;ED+/lDA;IACE,wBAAwB;EChgmD1B;;EDmgmDA;IACE,0BAA0B;ECpgmD5B;;EDugmDA;IACE,wBAAwB;ECxgmD1B;;ED2gmDA;IACE,0BAA0B;EC5gmD5B;;ED+gmDA;IACE,wBAAwB;EChhmD1B;;EDmhmDA;IACE,0BAA0B;ECphmD5B;;EDuhmDA;IACE,wBAAwB;ECxhmD1B;;ED2hmDA;IACE,0BAA0B;EC5hmD5B;;ED+hmDA;IACE,wBAAwB;EChimD1B;;EDmimDA;IACE,0BAA0B;ECpimD5B;;EDuimDA;IACE,wBAAwB;ECximD1B;;ED2imDA;IACE,0BAA0B;EC5imD5B;;ED+imDA;IACE,wBAAwB;EChjmD1B;;EDmjmDA;IACE,0BAA0B;ECpjmD5B;;EDujmDA;IACE,wBAAwB;ECxjmD1B;;ED2jmDA;IACE,0BAA0B;EC5jmD5B;;ED+jmDA;IACE,wBAAwB;EChkmD1B;;EDmkmDA;IACE,0BAA0B;ECpkmD5B;;EDukmDA;IACE,wBAAwB;ECxkmD1B;;ED2kmDA;IACE,0BAA0B;EC5kmD5B;;ED+kmDA;IACE,wBAAwB;EChlmD1B;;EDmlmDA;IACE,0BAA0B;ECplmD5B;;EDulmDA;IACE,wBAAwB;ECxlmD1B;;ED2lmDA;IACE,0BAA0B;EC5lmD5B;;ED+lmDA;IACE,wBAAwB;EChmmD1B;;EDmmmDA;IACE,0BAA0B;ECpmmD5B;;EDummDA;IACE,wBAAwB;ECxmmD1B;;ED2mmDA;IACE,0BAA0B;EC5mmD5B;;ED+mmDA;IACE,wBAAwB;EChnmD1B;;EDmnmDA;IACE,0BAA0B;ECpnmD5B;;EDunmDA;IACE,wBAAwB;ECxnmD1B;;ED2nmDA;IACE,0BAA0B;EC5nmD5B;;ED+nmDA;IACE,wBAAwB;EChomD1B;;EDmomDA;IACE,0BAA0B;ECpomD5B;;EDuomDA;IACE,wBAAwB;ECxomD1B;;ED2omDA;IACE,0BAA0B;EC5omD5B;;ED+omDA;IACE,wBAAwB;EChpmD1B;;EDmpmDA;IACE,0BAA0B;ECppmD5B;;EDupmDA;IACE,wBAAwB;ECxpmD1B;;ED2pmDA;IACE,0BAA0B;EC5pmD5B;;ED+pmDA;IACE,wBAAwB;EChqmD1B;;EDmqmDA;IACE,0BAA0B;ECjpmD5B;;EDopmDA;IACE,wBAAwB;ECrpmD1B;;EDwpmDA;IACE,0BAA0B;ECzpmD5B;;ED4pmDA;IACE,2BAA2B;EC7pmD7B;;EDgqmDA;IACE,8BAA8B;ECjqmDhC;;EDoqmDA;IACE,6BAA6B;ECrqmD/B;;EDwqmDA;IACE,2BAA2B;ECzqmD7B;;ED4qmDA;IACE,6BAA6B;EC7qmD/B;;EDgrmDA;IACE,2BAA2B;ECjrmD7B;;EDormDA;IACE,6BAA6B;ECrrmD/B;;EDwrmDA;IACE,2BAA2B;ECzrmD7B;;ED4rmDA;IACE,6BAA6B;EC7rmD/B;;EDgsmDA;IACE,2BAA2B;ECjsmD7B;;EDosmDA;IACE,6BAA6B;ECrsmD/B;;EDwsmDA;IACE,2BAA2B;ECzsmD7B;;ED4smDA;IACE,6BAA6B;EC7smD/B;;EDgtmDA;IACE,2BAA2B;ECjtmD7B;;EDotmDA;IACE,6BAA6B;ECrtmD/B;;EDwtmDA;IACE,2BAA2B;ECztmD7B;;ED4tmDA;IACE,6BAA6B;EC7tmD/B;;EDgumDA;IACE,2BAA2B;ECjumD7B;;EDoumDA;IACE,6BAA6B;ECrumD/B;;EDwumDA;IACE,2BAA2B;ECzumD7B;;ED4umDA;IACE,6BAA6B;EC7umD/B;;EDgvmDA;IACE,4BAA4B;ECjvmD9B;;EDovmDA;IACE,8BAA8B;ECrvmDhC;;EDwvmDA;IACE,4BAA4B;ECzvmD9B;;ED4vmDA;IACE,8BAA8B;EC7vmDhC;;EDgwmDA;IACE,4BAA4B;ECjwmD9B;;EDowmDA;IACE,8BAA8B;ECrwmDhC;;EDwwmDA;IACE,4BAA4B;ECzwmD9B;;ED4wmDA;IACE,8BAA8B;EC7wmDhC;;EDgxmDA;IACE,4BAA4B;ECjxmD9B;;EDoxmDA;IACE,8BAA8B;ECrxmDhC;;EDwxmDA;IACE,4BAA4B;ECzxmD9B;;ED4xmDA;IACE,8BAA8B;EC7xmDhC;;EDgymDA;IACE,4BAA4B;ECjymD9B;;EDoymDA;IACE,8BAA8B;ECrymDhC;;EDwymDA;IACE,4BAA4B;ECzymD9B;;ED4ymDA;IACE,8BAA8B;EC7ymDhC;;EDgzmDA;IACE,4BAA4B;ECjzmD9B;;EDozmDA;IACE,8BAA8B;ECrzmDhC;;EDwzmDA;IACE,4BAA4B;ECzzmD9B;;ED4zmDA;IACE,8BAA8B;EC7zmDhC;;EDg0mDA;IACE,4BAA4B;ECj0mD9B;;EDo0mDA;IACE,8BAA8B;ECr0mDhC;;EDw0mDA;IACE,4BAA4B;ECz0mD9B;;ED40mDA;IACE,8BAA8B;EC70mDhC;;EDg1mDA;IACE,4BAA4B;ECj1mD9B;;EDo1mDA;IACE,8BAA8B;ECr1mDhC;;EDw1mDA;IACE,4BAA4B;ECz1mD9B;;ED41mDA;IACE,8BAA8B;EC71mDhC;;EDg2mDA;IACE,4BAA4B;ECj2mD9B;;EDo2mDA;IACE,8BAA8B;ECr2mDhC;;EDw2mDA;IACE,4BAA4B;ECz2mD9B;;ED42mDA;IACE,8BAA8B;EC72mDhC;;EDg3mDA;IACE,4BAA4B;ECj3mD9B;;EDo3mDA;IACE,8BAA8B;ECr3mDhC;;EDw3mDA;IACE,4BAA4B;ECz3mD9B;;ED43mDA;IACE,8BAA8B;EC73mDhC;;EDg4mDA;IACE,4BAA4B;ECj4mD9B;;EDo4mDA;IACE,8BAA8B;ECr4mDhC;;EDw4mDA;IACE,4BAA4B;ECz4mD9B;;ED44mDA;IACE,8BAA8B;EC74mDhC;;EDg5mDA;IACE,4BAA4B;ECj5mD9B;;EDo5mDA;IACE,8BAA8B;ECr5mDhC;;EDw5mDA;IACE,4BAA4B;ECz5mD9B;;ED45mDA;IACE,8BAA8B;EC75mDhC;;EDg6mDA;IACE,4BAA4B;ECj6mD9B;;EDo6mDA;IACE,8BAA8B;ECr6mDhC;;EDw6mDA;IACE,4BAA4B;ECz6mD9B;;ED46mDA;IACE,8BAA8B;EC76mDhC;;EDg7mDA;IACE,4BAA4B;ECj7mD9B;;EDo7mDA;IACE,8BAA8B;ECr7mDhC;;EDw7mDA;IACE,4BAA4B;ECz7mD9B;;ED47mDA;IACE,8BAA8B;EC77mDhC;;EDg8mDA;IACE,4BAA4B;ECj8mD9B;;EDo8mDA;IACE,8BAA8B;ECr8mDhC;;EDw8mDA;IACE,4BAA4B;ECz8mD9B;;ED48mDA;IACE,8BAA8B;EC78mDhC;;EDg9mDA;IACE,4BAA4B;ECj9mD9B;;EDo9mDA;IACE,8BAA8B;ECr9mDhC;;EDw9mDA;IACE,4BAA4B;ECz9mD9B;;ED49mDA;IACE,8BAA8B;EC79mDhC;;EDg+mDA;IACE,4BAA4B;ECj+mD9B;;EDo+mDA;IACE,8BAA8B;ECr+mDhC;;EDw+mDA;IACE,4BAA4B;ECz+mD9B;;ED4+mDA;IACE,8BAA8B;EC7+mDhC;;EDg/mDA;IACE,4BAA4B;ECj/mD9B;;EDo/mDA;IACE,8BAA8B;ECr/mDhC;;EDw/mDA;IACE,4BAA4B;ECz/mD9B;;ED4/mDA;IACE,8BAA8B;EC7/mDhC;;EDggnDA;IACE,4BAA4B;ECjgnD9B;;EDognDA;IACE,8BAA8B;ECrgnDhC;;EDwgnDA;IACE,4BAA4B;ECzgnD9B;;ED4gnDA;IACE,8BAA8B;EC7gnDhC;;EDghnDA;IACE,4BAA4B;ECjhnD9B;;EDohnDA;IACE,8BAA8B;ECrhnDhC;;EDwhnDA;IACE,4BAA4B;ECzhnD9B;;ED4hnDA;IACE,8BAA8B;EC7hnDhC;;EDginDA;IACE,4BAA4B;ECjinD9B;;EDoinDA;IACE,8BAA8B;ECrinDhC;;EDwinDA;IACE,4BAA4B;ECzinD9B;;ED4inDA;IACE,8BAA8B;EC7inDhC;;EDgjnDA;IACE,4BAA4B;ECjjnD9B;;EDojnDA;IACE,8BAA8B;ECrjnDhC;;EDwjnDA;IACE,4BAA4B;ECzjnD9B;;ED4jnDA;IACE,8BAA8B;EC7jnDhC;;EDgknDA;IACE,4BAA4B;ECjknD9B;;EDoknDA;IACE,8BAA8B;ECrknDhC;;EDwknDA;IACE,4BAA4B;ECzknD9B;;ED4knDA;IACE,8BAA8B;EC7knDhC;;EDglnDA;IACE,4BAA4B;ECjlnD9B;;EDolnDA;IACE,8BAA8B;ECrlnDhC;;EDwlnDA;IACE,4BAA4B;ECzlnD9B;;ED4lnDA;IACE,8BAA8B;EC7lnDhC;;EDgmnDA;IACE,4BAA4B;ECjmnD9B;;EDomnDA;IACE,8BAA8B;ECrmnDhC;;EDwmnDA;IACE,4BAA4B;ECzmnD9B;;ED4mnDA;IACE,8BAA8B;EC7mnDhC;;EDgnnDA;IACE,4BAA4B;ECjnnD9B;;EDonnDA;IACE,8BAA8B;ECrnnDhC;;EDwnnDA;IACE,4BAA4B;ECznnD9B;;ED4nnDA;IACE,8BAA8B;EC7nnDhC;;EDgonDA;IACE,4BAA4B;ECjonD9B;;EDoonDA;IACE,8BAA8B;ECronDhC;;EDwonDA;IACE,4BAA4B;ECzonD9B;;ED4onDA;IACE,8BAA8B;EC7onDhC;;EDgpnDA;IACE,4BAA4B;ECjpnD9B;;EDopnDA;IACE,8BAA8B;ECrpnDhC;;EDwpnDA;IACE,4BAA4B;ECzpnD9B;;ED4pnDA;IACE,8BAA8B;EC7pnDhC;;EDgqnDA;IACE,4BAA4B;ECjqnD9B;;EDoqnDA;IACE,8BAA8B;ECrqnDhC;;EDwqnDA;IACE,4BAA4B;ECzqnD9B;;ED4qnDA;IACE,8BAA8B;EC7qnDhC;;EDgrnDA;IACE,4BAA4B;ECjrnD9B;;EDornDA;IACE,8BAA8B;ECrrnDhC;;EDwrnDA;IACE,4BAA4B;ECzrnD9B;;ED4rnDA;IACE,8BAA8B;EC7rnDhC;;EDgsnDA;IACE,4BAA4B;ECjsnD9B;;EDosnDA;IACE,8BAA8B;ECrsnDhC;;EDwsnDA;IACE,4BAA4B;ECzsnD9B;;ED4snDA;IACE,8BAA8B;EC7snDhC;;EDgtnDA;IACE,4BAA4B;ECjtnD9B;;EDotnDA;IACE,8BAA8B;ECrtnDhC;;EDwtnDA;IACE,4BAA4B;ECztnD9B;;ED4tnDA;IACE,8BAA8B;EC7tnDhC;;EDgunDA;IACE,4BAA4B;ECjunD9B;;EDounDA;IACE,8BAA8B;ECrunDhC;;EDwunDA;IACE,4BAA4B;ECzunD9B;;ED4unDA;IACE,8BAA8B;EC7unDhC;;EDgvnDA;IACE,4BAA4B;ECjvnD9B;;EDovnDA;IACE,8BAA8B;ECrvnDhC;;EDwvnDA;IACE,4BAA4B;ECzvnD9B;;ED4vnDA;IACE,8BAA8B;EC7vnDhC;;EDgwnDA;IACE,4BAA4B;ECjwnD9B;;EDownDA;IACE,8BAA8B;ECrwnDhC;;EDwwnDA;IACE,4BAA4B;ECzwnD9B;;ED4wnDA;IACE,8BAA8B;EC7wnDhC;;EDgxnDA;IACE,4BAA4B;ECjxnD9B;;EDoxnDA;IACE,8BAA8B;EClwnDhC;;EDqwnDA;IACE,4BAA4B;ECtwnD9B;;EDywnDA;IACE,8BAA8B;EC1wnDhC;;ED6wnDA;IACE,8BAA8B;EC9wnDhC;;EDixnDA;IACE,iCAAiC;EClxnDnC;;EDqxnDA;IACE,gCAAgC;ECtxnDlC;;EDyxnDA;IACE,8BAA8B;EC1xnDhC;;ED6xnDA;IACE,gCAAgC;EC9xnDlC;;EDiynDA;IACE,8BAA8B;EClynDhC;;EDqynDA;IACE,gCAAgC;ECtynDlC;;EDyynDA;IACE,8BAA8B;EC1ynDhC;;ED6ynDA;IACE,gCAAgC;EC9ynDlC;;EDiznDA;IACE,8BAA8B;EClznDhC;;EDqznDA;IACE,gCAAgC;ECtznDlC;;EDyznDA;IACE,8BAA8B;EC1znDhC;;ED6znDA;IACE,gCAAgC;EC9znDlC;;EDi0nDA;IACE,8BAA8B;ECl0nDhC;;EDq0nDA;IACE,gCAAgC;ECt0nDlC;;EDy0nDA;IACE,8BAA8B;EC10nDhC;;ED60nDA;IACE,gCAAgC;EC90nDlC;;EDi1nDA;IACE,8BAA8B;ECl1nDhC;;EDq1nDA;IACE,gCAAgC;ECt1nDlC;;EDy1nDA;IACE,8BAA8B;EC11nDhC;;ED61nDA;IACE,gCAAgC;EC91nDlC;;EDi2nDA;IACE,+BAA+B;ECl2nDjC;;EDq2nDA;IACE,iCAAiC;ECt2nDnC;;EDy2nDA;IACE,+BAA+B;EC12nDjC;;ED62nDA;IACE,iCAAiC;EC92nDnC;;EDi3nDA;IACE,+BAA+B;ECl3nDjC;;EDq3nDA;IACE,iCAAiC;ECt3nDnC;;EDy3nDA;IACE,+BAA+B;EC13nDjC;;ED63nDA;IACE,iCAAiC;EC93nDnC;;EDi4nDA;IACE,+BAA+B;ECl4nDjC;;EDq4nDA;IACE,iCAAiC;ECt4nDnC;;EDy4nDA;IACE,+BAA+B;EC14nDjC;;ED64nDA;IACE,iCAAiC;EC94nDnC;;EDi5nDA;IACE,+BAA+B;ECl5nDjC;;EDq5nDA;IACE,iCAAiC;ECt5nDnC;;EDy5nDA;IACE,+BAA+B;EC15nDjC;;ED65nDA;IACE,iCAAiC;EC95nDnC;;EDi6nDA;IACE,+BAA+B;ECl6nDjC;;EDq6nDA;IACE,iCAAiC;ECt6nDnC;;EDy6nDA;IACE,+BAA+B;EC16nDjC;;ED66nDA;IACE,iCAAiC;EC96nDnC;;EDi7nDA;IACE,+BAA+B;ECl7nDjC;;EDq7nDA;IACE,iCAAiC;ECt7nDnC;;EDy7nDA;IACE,+BAA+B;EC17nDjC;;ED67nDA;IACE,iCAAiC;EC97nDnC;;EDi8nDA;IACE,+BAA+B;ECl8nDjC;;EDq8nDA;IACE,iCAAiC;ECt8nDnC;;EDy8nDA;IACE,+BAA+B;EC18nDjC;;ED68nDA;IACE,iCAAiC;EC98nDnC;;EDi9nDA;IACE,+BAA+B;ECl9nDjC;;EDq9nDA;IACE,iCAAiC;ECt9nDnC;;EDy9nDA;IACE,+BAA+B;EC19nDjC;;ED69nDA;IACE,iCAAiC;EC99nDnC;;EDi+nDA;IACE,+BAA+B;ECl+nDjC;;EDq+nDA;IACE,iCAAiC;ECt+nDnC;;EDy+nDA;IACE,+BAA+B;EC1+nDjC;;ED6+nDA;IACE,iCAAiC;EC9+nDnC;;EDi/nDA;IACE,+BAA+B;ECl/nDjC;;EDq/nDA;IACE,iCAAiC;ECt/nDnC;;EDy/nDA;IACE,+BAA+B;EC1/nDjC;;ED6/nDA;IACE,iCAAiC;EC9/nDnC;;EDigoDA;IACE,+BAA+B;EClgoDjC;;EDqgoDA;IACE,iCAAiC;ECtgoDnC;;EDygoDA;IACE,+BAA+B;EC1goDjC;;ED6goDA;IACE,iCAAiC;EC9goDnC;;EDihoDA;IACE,+BAA+B;EClhoDjC;;EDqhoDA;IACE,iCAAiC;ECthoDnC;;EDyhoDA;IACE,+BAA+B;EC1hoDjC;;ED6hoDA;IACE,iCAAiC;EC9hoDnC;;EDiioDA;IACE,+BAA+B;EClioDjC;;EDqioDA;IACE,iCAAiC;ECtioDnC;;EDyioDA;IACE,+BAA+B;EC1ioDjC;;ED6ioDA;IACE,iCAAiC;EC9ioDnC;;EDijoDA;IACE,+BAA+B;ECljoDjC;;EDqjoDA;IACE,iCAAiC;ECtjoDnC;;EDyjoDA;IACE,+BAA+B;EC1joDjC;;ED6joDA;IACE,iCAAiC;EC9joDnC;;EDikoDA;IACE,+BAA+B;EClkoDjC;;EDqkoDA;IACE,iCAAiC;ECtkoDnC;;EDykoDA;IACE,+BAA+B;EC1koDjC;;ED6koDA;IACE,iCAAiC;EC9koDnC;;EDiloDA;IACE,+BAA+B;EClloDjC;;EDqloDA;IACE,iCAAiC;ECtloDnC;;EDyloDA;IACE,+BAA+B;EC1loDjC;;ED6loDA;IACE,iCAAiC;EC9loDnC;;EDimoDA;IACE,+BAA+B;EClmoDjC;;EDqmoDA;IACE,iCAAiC;ECtmoDnC;;EDymoDA;IACE,+BAA+B;EC1moDjC;;ED6moDA;IACE,iCAAiC;EC9moDnC;;EDinoDA;IACE,+BAA+B;EClnoDjC;;EDqnoDA;IACE,iCAAiC;ECtnoDnC;;EDynoDA;IACE,+BAA+B;EC1noDjC;;ED6noDA;IACE,iCAAiC;EC9noDnC;;EDiooDA;IACE,+BAA+B;EClooDjC;;EDqooDA;IACE,iCAAiC;ECtooDnC;;EDyooDA;IACE,+BAA+B;EC1ooDjC;;ED6ooDA;IACE,iCAAiC;EC9ooDnC;;EDipoDA;IACE,+BAA+B;EClpoDjC;;EDqpoDA;IACE,iCAAiC;ECtpoDnC;;EDypoDA;IACE,+BAA+B;EC1poDjC;;ED6poDA;IACE,iCAAiC;EC9poDnC;;EDiqoDA;IACE,+BAA+B;EClqoDjC;;EDqqoDA;IACE,iCAAiC;ECtqoDnC;;EDyqoDA;IACE,+BAA+B;EC1qoDjC;;ED6qoDA;IACE,iCAAiC;EC9qoDnC;;EDiroDA;IACE,+BAA+B;EClroDjC;;EDqroDA;IACE,iCAAiC;ECtroDnC;;EDyroDA;IACE,+BAA+B;EC1roDjC;;ED6roDA;IACE,iCAAiC;EC9roDnC;;EDisoDA;IACE,+BAA+B;EClsoDjC;;EDqsoDA;IACE,iCAAiC;ECtsoDnC;;EDysoDA;IACE,+BAA+B;EC1soDjC;;ED6soDA;IACE,iCAAiC;EC9soDnC;;EDitoDA;IACE,+BAA+B;ECltoDjC;;EDqtoDA;IACE,iCAAiC;ECttoDnC;;EDytoDA;IACE,+BAA+B;EC1toDjC;;ED6toDA;IACE,iCAAiC;EC9toDnC;;EDiuoDA;IACE,+BAA+B;ECluoDjC;;EDquoDA;IACE,iCAAiC;ECtuoDnC;;EDyuoDA;IACE,+BAA+B;EC1uoDjC;;ED6uoDA;IACE,iCAAiC;EC9uoDnC;;EDivoDA;IACE,+BAA+B;EClvoDjC;;EDqvoDA;IACE,iCAAiC;ECtvoDnC;;EDyvoDA;IACE,+BAA+B;EC1voDjC;;ED6voDA;IACE,iCAAiC;EC9voDnC;;EDiwoDA;IACE,+BAA+B;EClwoDjC;;EDqwoDA;IACE,iCAAiC;ECtwoDnC;;EDywoDA;IACE,+BAA+B;EC1woDjC;;ED6woDA;IACE,iCAAiC;EC9woDnC;;EDixoDA;IACE,+BAA+B;EClxoDjC;;EDqxoDA;IACE,iCAAiC;ECtxoDnC;;EDyxoDA;IACE,+BAA+B;EC1xoDjC;;ED6xoDA;IACE,iCAAiC;EC9xoDnC;;EDiyoDA;IACE,+BAA+B;EClyoDjC;;EDqyoDA;IACE,iCAAiC;ECtyoDnC;;EDyyoDA;IACE,+BAA+B;EC1yoDjC;;ED6yoDA;IACE,iCAAiC;EC9yoDnC;;EDizoDA;IACE,+BAA+B;EClzoDjC;;EDqzoDA;IACE,iCAAiC;ECtzoDnC;;EDyzoDA;IACE,+BAA+B;EC1zoDjC;;ED6zoDA;IACE,iCAAiC;EC9zoDnC;;EDi0oDA;IACE,+BAA+B;ECl0oDjC;;EDq0oDA;IACE,iCAAiC;ECt0oDnC;;EDy0oDA;IACE,+BAA+B;EC10oDjC;;ED60oDA;IACE,iCAAiC;EC90oDnC;;EDi1oDA;IACE,+BAA+B;ECl1oDjC;;EDq1oDA;IACE,iCAAiC;ECt1oDnC;;EDy1oDA;IACE,+BAA+B;EC11oDjC;;ED61oDA;IACE,iCAAiC;EC91oDnC;;EDi2oDA;IACE,+BAA+B;ECl2oDjC;;EDq2oDA;IACE,iCAAiC;ECt2oDnC;;EDy2oDA;IACE,+BAA+B;EC12oDjC;;ED62oDA;IACE,iCAAiC;EC92oDnC;;EDi3oDA;IACE,+BAA+B;ECl3oDjC;;EDq3oDA;IACE,iCAAiC;ECt3oDnC;;EDy3oDA;IACE,+BAA+B;EC13oDjC;;ED63oDA;IACE,iCAAiC;EC93oDnC;;EDi4oDA;IACE,+BAA+B;ECl4oDjC;;EDq4oDA;IACE,iCAAiC;ECn3oDnC;;EDs3oDA;IACE,+BAA+B;ECv3oDjC;;ED03oDA;IACE,iCAAiC;EC33oDnC;;ED83oDA;IACE,4BAA4B;EC/3oD9B;;EDk4oDA;IACE,+BAA+B;ECn4oDjC;;EDs4oDA;IACE,8BAA8B;ECv4oDhC;;ED04oDA;IACE,4BAA4B;EC34oD9B;;ED84oDA;IACE,8BAA8B;EC/4oDhC;;EDk5oDA;IACE,4BAA4B;ECn5oD9B;;EDs5oDA;IACE,8BAA8B;ECv5oDhC;;ED05oDA;IACE,4BAA4B;EC35oD9B;;ED85oDA;IACE,8BAA8B;EC/5oDhC;;EDk6oDA;IACE,4BAA4B;ECn6oD9B;;EDs6oDA;IACE,8BAA8B;ECv6oDhC;;ED06oDA;IACE,4BAA4B;EC36oD9B;;ED86oDA;IACE,8BAA8B;EC/6oDhC;;EDk7oDA;IACE,4BAA4B;ECn7oD9B;;EDs7oDA;IACE,8BAA8B;ECv7oDhC;;ED07oDA;IACE,4BAA4B;EC37oD9B;;ED87oDA;IACE,8BAA8B;EC/7oDhC;;EDk8oDA;IACE,4BAA4B;ECn8oD9B;;EDs8oDA;IACE,8BAA8B;ECv8oDhC;;ED08oDA;IACE,4BAA4B;EC38oD9B;;ED88oDA;IACE,8BAA8B;EC/8oDhC;;EDk9oDA;IACE,6BAA6B;ECn9oD/B;;EDs9oDA;IACE,+BAA+B;ECv9oDjC;;ED09oDA;IACE,6BAA6B;EC39oD/B;;ED89oDA;IACE,+BAA+B;EC/9oDjC;;EDk+oDA;IACE,6BAA6B;ECn+oD/B;;EDs+oDA;IACE,+BAA+B;ECv+oDjC;;ED0+oDA;IACE,6BAA6B;EC3+oD/B;;ED8+oDA;IACE,+BAA+B;EC/+oDjC;;EDk/oDA;IACE,6BAA6B;ECn/oD/B;;EDs/oDA;IACE,+BAA+B;ECv/oDjC;;ED0/oDA;IACE,6BAA6B;EC3/oD/B;;ED8/oDA;IACE,+BAA+B;EC//oDjC;;EDkgpDA;IACE,6BAA6B;ECngpD/B;;EDsgpDA;IACE,+BAA+B;ECvgpDjC;;ED0gpDA;IACE,6BAA6B;EC3gpD/B;;ED8gpDA;IACE,+BAA+B;EC/gpDjC;;EDkhpDA;IACE,6BAA6B;ECnhpD/B;;EDshpDA;IACE,+BAA+B;ECvhpDjC;;ED0hpDA;IACE,6BAA6B;EC3hpD/B;;ED8hpDA;IACE,+BAA+B;EC/hpDjC;;EDkipDA;IACE,6BAA6B;ECnipD/B;;EDsipDA;IACE,+BAA+B;ECvipDjC;;ED0ipDA;IACE,6BAA6B;EC3ipD/B;;ED8ipDA;IACE,+BAA+B;EC/ipDjC;;EDkjpDA;IACE,6BAA6B;ECnjpD/B;;EDsjpDA;IACE,+BAA+B;ECvjpDjC;;ED0jpDA;IACE,6BAA6B;EC3jpD/B;;ED8jpDA;IACE,+BAA+B;EC/jpDjC;;EDkkpDA;IACE,6BAA6B;ECnkpD/B;;EDskpDA;IACE,+BAA+B;ECvkpDjC;;ED0kpDA;IACE,6BAA6B;EC3kpD/B;;ED8kpDA;IACE,+BAA+B;EC/kpDjC;;EDklpDA;IACE,6BAA6B;ECnlpD/B;;EDslpDA;IACE,+BAA+B;ECvlpDjC;;ED0lpDA;IACE,6BAA6B;EC3lpD/B;;ED8lpDA;IACE,+BAA+B;EC/lpDjC;;EDkmpDA;IACE,6BAA6B;ECnmpD/B;;EDsmpDA;IACE,+BAA+B;ECvmpDjC;;ED0mpDA;IACE,6BAA6B;EC3mpD/B;;ED8mpDA;IACE,+BAA+B;EC/mpDjC;;EDknpDA;IACE,6BAA6B;ECnnpD/B;;EDsnpDA;IACE,+BAA+B;ECvnpDjC;;ED0npDA;IACE,6BAA6B;EC3npD/B;;ED8npDA;IACE,+BAA+B;EC/npDjC;;EDkopDA;IACE,6BAA6B;ECnopD/B;;EDsopDA;IACE,+BAA+B;ECvopDjC;;ED0opDA;IACE,6BAA6B;EC3opD/B;;ED8opDA;IACE,+BAA+B;EC/opDjC;;EDkppDA;IACE,6BAA6B;ECnppD/B;;EDsppDA;IACE,+BAA+B;ECvppDjC;;ED0ppDA;IACE,6BAA6B;EC3ppD/B;;ED8ppDA;IACE,+BAA+B;EC/ppDjC;;EDkqpDA;IACE,6BAA6B;ECnqpD/B;;EDsqpDA;IACE,+BAA+B;ECvqpDjC;;ED0qpDA;IACE,6BAA6B;EC3qpD/B;;ED8qpDA;IACE,+BAA+B;EC/qpDjC;;EDkrpDA;IACE,6BAA6B;ECnrpD/B;;EDsrpDA;IACE,+BAA+B;ECvrpDjC;;ED0rpDA;IACE,6BAA6B;EC3rpD/B;;ED8rpDA;IACE,+BAA+B;EC/rpDjC;;EDkspDA;IACE,6BAA6B;ECnspD/B;;EDsspDA;IACE,+BAA+B;ECvspDjC;;ED0spDA;IACE,6BAA6B;EC3spD/B;;ED8spDA;IACE,+BAA+B;EC/spDjC;;EDktpDA;IACE,6BAA6B;ECntpD/B;;EDstpDA;IACE,+BAA+B;ECvtpDjC;;ED0tpDA;IACE,6BAA6B;EC3tpD/B;;ED8tpDA;IACE,+BAA+B;EC/tpDjC;;EDkupDA;IACE,6BAA6B;ECnupD/B;;EDsupDA;IACE,+BAA+B;ECvupDjC;;ED0upDA;IACE,6BAA6B;EC3upD/B;;ED8upDA;IACE,+BAA+B;EC/upDjC;;EDkvpDA;IACE,6BAA6B;ECnvpD/B;;EDsvpDA;IACE,+BAA+B;ECvvpDjC;;ED0vpDA;IACE,6BAA6B;EC3vpD/B;;ED8vpDA;IACE,+BAA+B;EC/vpDjC;;EDkwpDA;IACE,6BAA6B;ECnwpD/B;;EDswpDA;IACE,+BAA+B;ECvwpDjC;;ED0wpDA;IACE,6BAA6B;EC3wpD/B;;ED8wpDA;IACE,+BAA+B;EC/wpDjC;;EDkxpDA;IACE,6BAA6B;ECnxpD/B;;EDsxpDA;IACE,+BAA+B;ECvxpDjC;;ED0xpDA;IACE,6BAA6B;EC3xpD/B;;ED8xpDA;IACE,+BAA+B;EC/xpDjC;;EDkypDA;IACE,6BAA6B;ECnypD/B;;EDsypDA;IACE,+BAA+B;ECvypDjC;;ED0ypDA;IACE,6BAA6B;EC3ypD/B;;ED8ypDA;IACE,+BAA+B;EC/ypDjC;;EDkzpDA;IACE,6BAA6B;ECnzpD/B;;EDszpDA;IACE,+BAA+B;ECvzpDjC;;ED0zpDA;IACE,6BAA6B;EC3zpD/B;;ED8zpDA;IACE,+BAA+B;EC/zpDjC;;EDk0pDA;IACE,6BAA6B;ECn0pD/B;;EDs0pDA;IACE,+BAA+B;ECv0pDjC;;ED00pDA;IACE,6BAA6B;EC30pD/B;;ED80pDA;IACE,+BAA+B;EC/0pDjC;;EDk1pDA;IACE,6BAA6B;ECn1pD/B;;EDs1pDA;IACE,+BAA+B;ECv1pDjC;;ED01pDA;IACE,6BAA6B;EC31pD/B;;ED81pDA;IACE,+BAA+B;EC/1pDjC;;EDk2pDA;IACE,6BAA6B;ECn2pD/B;;EDs2pDA;IACE,+BAA+B;ECv2pDjC;;ED02pDA;IACE,6BAA6B;EC32pD/B;;ED82pDA;IACE,+BAA+B;EC/2pDjC;;EDk3pDA;IACE,6BAA6B;ECn3pD/B;;EDs3pDA;IACE,+BAA+B;ECv3pDjC;;ED03pDA;IACE,6BAA6B;EC33pD/B;;ED83pDA;IACE,+BAA+B;EC/3pDjC;;EDk4pDA;IACE,6BAA6B;ECn4pD/B;;EDs4pDA;IACE,+BAA+B;ECv4pDjC;;ED04pDA;IACE,6BAA6B;EC34pD/B;;ED84pDA;IACE,+BAA+B;EC/4pDjC;;EDk5pDA;IACE,6BAA6B;ECn5pD/B;;EDs5pDA;IACE,+BAA+B;ECv5pDjC;;ED05pDA;IACE,6BAA6B;EC35pD/B;;ED85pDA;IACE,+BAA+B;EC/5pDjC;;EDk6pDA;IACE,6BAA6B;ECn6pD/B;;EDs6pDA;IACE,+BAA+B;ECv6pDjC;;ED06pDA;IACE,6BAA6B;EC36pD/B;;ED86pDA;IACE,+BAA+B;EC/6pDjC;;EDk7pDA;IACE,6BAA6B;ECn7pD/B;;EDs7pDA;IACE,+BAA+B;ECv7pDjC;;ED07pDA;IACE,6BAA6B;EC37pD/B;;ED87pDA;IACE,+BAA+B;EC/7pDjC;;EDk8pDA;IACE,6BAA6B;ECn8pD/B;;EDs8pDA;IACE,+BAA+B;ECv8pDjC;;ED08pDA;IACE,6BAA6B;EC38pD/B;;ED88pDA;IACE,+BAA+B;EC/8pDjC;;EDk9pDA;IACE,6BAA6B;ECn9pD/B;;EDs9pDA;IACE,+BAA+B;ECv9pDjC;;ED09pDA;IACE,6BAA6B;EC39pD/B;;ED89pDA;IACE,+BAA+B;EC/9pDjC;;EDk+pDA;IACE,6BAA6B;ECn+pD/B;;EDs+pDA;IACE,+BAA+B;ECv+pDjC;;ED0+pDA;IACE,6BAA6B;EC3+pD/B;;ED8+pDA;IACE,+BAA+B;EC/+pDjC;;EDk/pDA;IACE,6BAA6B;ECn/pD/B;;EDs/pDA;IACE,+BAA+B;ECp+pDjC;;EDu+pDA;IACE,6BAA6B;ECx+pD/B;;ED2+pDA;IACE,+BAA+B;EC5+pDjC;;ED++pDA;IACE,6BAA6B;ECh/pD/B;;EDm/pDA;IACE,gCAAgC;ECp/pDlC;;EDu/pDA;IACE,+BAA+B;ECx/pDjC;;ED2/pDA;IACE,6BAA6B;EC5/pD/B;;ED+/pDA;IACE,+BAA+B;EChgqDjC;;EDmgqDA;IACE,6BAA6B;ECpgqD/B;;EDugqDA;IACE,+BAA+B;ECxgqDjC;;ED2gqDA;IACE,6BAA6B;EC5gqD/B;;ED+gqDA;IACE,+BAA+B;EChhqDjC;;EDmhqDA;IACE,6BAA6B;ECphqD/B;;EDuhqDA;IACE,+BAA+B;ECxhqDjC;;ED2hqDA;IACE,6BAA6B;EC5hqD/B;;ED+hqDA;IACE,+BAA+B;EChiqDjC;;EDmiqDA;IACE,6BAA6B;ECpiqD/B;;EDuiqDA;IACE,+BAA+B;ECxiqDjC;;ED2iqDA;IACE,6BAA6B;EC5iqD/B;;ED+iqDA;IACE,+BAA+B;EChjqDjC;;EDmjqDA;IACE,6BAA6B;ECpjqD/B;;EDujqDA;IACE,+BAA+B;ECxjqDjC;;ED2jqDA;IACE,6BAA6B;EC5jqD/B;;ED+jqDA;IACE,+BAA+B;EChkqDjC;;EDmkqDA;IACE,8BAA8B;ECpkqDhC;;EDukqDA;IACE,gCAAgC;ECxkqDlC;;ED2kqDA;IACE,8BAA8B;EC5kqDhC;;ED+kqDA;IACE,gCAAgC;EChlqDlC;;EDmlqDA;IACE,8BAA8B;ECplqDhC;;EDulqDA;IACE,gCAAgC;ECxlqDlC;;ED2lqDA;IACE,8BAA8B;EC5lqDhC;;ED+lqDA;IACE,gCAAgC;EChmqDlC;;EDmmqDA;IACE,8BAA8B;ECpmqDhC;;EDumqDA;IACE,gCAAgC;ECxmqDlC;;ED2mqDA;IACE,8BAA8B;EC5mqDhC;;ED+mqDA;IACE,gCAAgC;EChnqDlC;;EDmnqDA;IACE,8BAA8B;ECpnqDhC;;EDunqDA;IACE,gCAAgC;ECxnqDlC;;ED2nqDA;IACE,8BAA8B;EC5nqDhC;;ED+nqDA;IACE,gCAAgC;EChoqDlC;;EDmoqDA;IACE,8BAA8B;ECpoqDhC;;EDuoqDA;IACE,gCAAgC;ECxoqDlC;;ED2oqDA;IACE,8BAA8B;EC5oqDhC;;ED+oqDA;IACE,gCAAgC;EChpqDlC;;EDmpqDA;IACE,8BAA8B;ECppqDhC;;EDupqDA;IACE,gCAAgC;ECxpqDlC;;ED2pqDA;IACE,8BAA8B;EC5pqDhC;;ED+pqDA;IACE,gCAAgC;EChqqDlC;;EDmqqDA;IACE,8BAA8B;ECpqqDhC;;EDuqqDA;IACE,gCAAgC;ECxqqDlC;;ED2qqDA;IACE,8BAA8B;EC5qqDhC;;ED+qqDA;IACE,gCAAgC;EChrqDlC;;EDmrqDA;IACE,8BAA8B;ECprqDhC;;EDurqDA;IACE,gCAAgC;ECxrqDlC;;ED2rqDA;IACE,8BAA8B;EC5rqDhC;;ED+rqDA;IACE,gCAAgC;EChsqDlC;;EDmsqDA;IACE,8BAA8B;ECpsqDhC;;EDusqDA;IACE,gCAAgC;ECxsqDlC;;ED2sqDA;IACE,8BAA8B;EC5sqDhC;;ED+sqDA;IACE,gCAAgC;EChtqDlC;;EDmtqDA;IACE,8BAA8B;ECptqDhC;;EDutqDA;IACE,gCAAgC;ECxtqDlC;;ED2tqDA;IACE,8BAA8B;EC5tqDhC;;ED+tqDA;IACE,gCAAgC;EChuqDlC;;EDmuqDA;IACE,8BAA8B;ECpuqDhC;;EDuuqDA;IACE,gCAAgC;ECxuqDlC;;ED2uqDA;IACE,8BAA8B;EC5uqDhC;;ED+uqDA;IACE,gCAAgC;EChvqDlC;;EDmvqDA;IACE,8BAA8B;ECpvqDhC;;EDuvqDA;IACE,gCAAgC;ECxvqDlC;;ED2vqDA;IACE,8BAA8B;EC5vqDhC;;ED+vqDA;IACE,gCAAgC;EChwqDlC;;EDmwqDA;IACE,8BAA8B;ECpwqDhC;;EDuwqDA;IACE,gCAAgC;ECxwqDlC;;ED2wqDA;IACE,8BAA8B;EC5wqDhC;;ED+wqDA;IACE,gCAAgC;EChxqDlC;;EDmxqDA;IACE,8BAA8B;ECpxqDhC;;EDuxqDA;IACE,gCAAgC;ECxxqDlC;;ED2xqDA;IACE,8BAA8B;EC5xqDhC;;ED+xqDA;IACE,gCAAgC;EChyqDlC;;EDmyqDA;IACE,8BAA8B;ECpyqDhC;;EDuyqDA;IACE,gCAAgC;ECxyqDlC;;ED2yqDA;IACE,8BAA8B;EC5yqDhC;;ED+yqDA;IACE,gCAAgC;EChzqDlC;;EDmzqDA;IACE,8BAA8B;ECpzqDhC;;EDuzqDA;IACE,gCAAgC;ECxzqDlC;;ED2zqDA;IACE,8BAA8B;EC5zqDhC;;ED+zqDA;IACE,gCAAgC;ECh0qDlC;;EDm0qDA;IACE,8BAA8B;ECp0qDhC;;EDu0qDA;IACE,gCAAgC;ECx0qDlC;;ED20qDA;IACE,8BAA8B;EC50qDhC;;ED+0qDA;IACE,gCAAgC;ECh1qDlC;;EDm1qDA;IACE,8BAA8B;ECp1qDhC;;EDu1qDA;IACE,gCAAgC;ECx1qDlC;;ED21qDA;IACE,8BAA8B;EC51qDhC;;ED+1qDA;IACE,gCAAgC;ECh2qDlC;;EDm2qDA;IACE,8BAA8B;ECp2qDhC;;EDu2qDA;IACE,gCAAgC;ECx2qDlC;;ED22qDA;IACE,8BAA8B;EC52qDhC;;ED+2qDA;IACE,gCAAgC;ECh3qDlC;;EDm3qDA;IACE,8BAA8B;ECp3qDhC;;EDu3qDA;IACE,gCAAgC;ECx3qDlC;;ED23qDA;IACE,8BAA8B;EC53qDhC;;ED+3qDA;IACE,gCAAgC;ECh4qDlC;;EDm4qDA;IACE,8BAA8B;ECp4qDhC;;EDu4qDA;IACE,gCAAgC;ECx4qDlC;;ED24qDA;IACE,8BAA8B;EC54qDhC;;ED+4qDA;IACE,gCAAgC;ECh5qDlC;;EDm5qDA;IACE,8BAA8B;ECp5qDhC;;EDu5qDA;IACE,gCAAgC;ECx5qDlC;;ED25qDA;IACE,8BAA8B;EC55qDhC;;ED+5qDA;IACE,gCAAgC;ECh6qDlC;;EDm6qDA;IACE,8BAA8B;ECp6qDhC;;EDu6qDA;IACE,gCAAgC;ECx6qDlC;;ED26qDA;IACE,8BAA8B;EC56qDhC;;ED+6qDA;IACE,gCAAgC;ECh7qDlC;;EDm7qDA;IACE,8BAA8B;ECp7qDhC;;EDu7qDA;IACE,gCAAgC;ECx7qDlC;;ED27qDA;IACE,8BAA8B;EC57qDhC;;ED+7qDA;IACE,gCAAgC;ECh8qDlC;;EDm8qDA;IACE,8BAA8B;ECp8qDhC;;EDu8qDA;IACE,gCAAgC;ECx8qDlC;;ED28qDA;IACE,8BAA8B;EC58qDhC;;ED+8qDA;IACE,gCAAgC;ECh9qDlC;;EDm9qDA;IACE,8BAA8B;ECp9qDhC;;EDu9qDA;IACE,gCAAgC;ECx9qDlC;;ED29qDA;IACE,8BAA8B;EC59qDhC;;ED+9qDA;IACE,gCAAgC;ECh+qDlC;;EDm+qDA;IACE,8BAA8B;ECp+qDhC;;EDu+qDA;IACE,gCAAgC;ECx+qDlC;;ED2+qDA;IACE,8BAA8B;EC5+qDhC;;ED++qDA;IACE,gCAAgC;ECh/qDlC;;EDm/qDA;IACE,8BAA8B;ECp/qDhC;;EDu/qDA;IACE,gCAAgC;ECx/qDlC;;ED2/qDA;IACE,8BAA8B;EC5/qDhC;;ED+/qDA;IACE,gCAAgC;EChgrDlC;;EDmgrDA;IACE,8BAA8B;ECpgrDhC;;EDugrDA;IACE,gCAAgC;ECxgrDlC;;ED2grDA;IACE,8BAA8B;EC5grDhC;;ED+grDA;IACE,gCAAgC;EChhrDlC;;EDmhrDA;IACE,8BAA8B;ECphrDhC;;EDuhrDA;IACE,gCAAgC;ECxhrDlC;;ED2hrDA;IACE,8BAA8B;EC5hrDhC;;ED+hrDA;IACE,gCAAgC;EChirDlC;;EDmirDA;IACE,8BAA8B;ECpirDhC;;EDuirDA;IACE,gCAAgC;ECxirDlC;;ED2irDA;IACE,8BAA8B;EC5irDhC;;ED+irDA;IACE,gCAAgC;EChjrDlC;;EDmjrDA;IACE,8BAA8B;ECpjrDhC;;EDujrDA;IACE,gCAAgC;ECxjrDlC;;ED2jrDA;IACE,8BAA8B;EC5jrDhC;;ED+jrDA;IACE,gCAAgC;EChkrDlC;;EDmkrDA;IACE,8BAA8B;ECpkrDhC;;EDukrDA;IACE,gCAAgC;ECxkrDlC;;ED2krDA;IACE,8BAA8B;EC5krDhC;;ED+krDA;IACE,gCAAgC;EChlrDlC;;EDmlrDA;IACE,8BAA8B;ECplrDhC;;EDulrDA;IACE,gCAAgC;ECxlrDlC;;ED2lrDA;IACE,8BAA8B;EC5lrDhC;;ED+lrDA;IACE,gCAAgC;EChmrDlC;;EDmmrDA;IACE,8BAA8B;ECpmrDhC;;EDumrDA;IACE,gCAAgC;ECrlrDlC;;EDwlrDA;IACE,8BAA8B;EAChC;;EAEA;IC1lrDC,gCAAsC;ED4lrDvC;;EC9lrDA;IACC,4BAAa;IACb,6BAAc;EDimrDf;;ECnmrDA;IACC,+BAAqC;IACrC,gCAAsC;EDsmrDvC;;ECxmrDA;IACC,8BAAqC;IACrC,+BAAsC;ED2mrDvC;;EC7mrDA;IACC,4BAAqC;IACrC,6BAAsC;EDgnrDvC;;EClnrDA;IACC,8BAAqC;IACrC,+BAAsC;EDqnrDvC;;ECvnrDA;IACC,4BAAqC;IACrC,6BAAsC;ED0nrDvC;;EC5nrDA;IACC,8BAAqC;IACrC,+BAAsC;ED+nrDvC;;ECjorDA;IACC,4BAAqC;IACrC,6BAAsC;EDoorDvC;;ECtorDA;IACC,8BAAqC;IACrC,+BAAsC;EDyorDvC;;EC3orDA;IACC,4BAAqC;IACrC,6BAAsC;ED8orDvC;;EChprDA;IACC,8BAAqC;IACrC,+BAAsC;EDmprDvC;;ECrprDA;IACC,4BAAqC;IACrC,6BAAsC;EDwprDvC;;EC1prDA;IACC,8BAAqC;IACrC,+BAAsC;ED6prDvC;;EC/prDA;IACC,4BAAqC;IACrC,6BAAsC;EDkqrDvC;;ECpqrDA;IACC,8BAAqC;IACrC,+BAAsC;EDuqrDvC;;ECzqrDA;IACC,4BAAqC;IACrC,6BAAsC;ED4qrDvC;;EC9qrDA;IACC,8BAAqC;IACrC,+BAAsC;EDirrDvC;;ECnrrDA;IACC,4BAAqC;IACrC,6BAAsC;EDsrrDvC;;ECxrrDA;IACC,8BAAqC;IACrC,+BAAsC;ED2rrDvC;;EC7rrDA;IACC,4BAAa;IACb,6BAAc;EDgsrDf;;EClsrDA;IACC,8BAAa;IACb,+BAAc;EDqsrDf;;ECvsrDA;IACC,6BAAqC;IACrC,8BAAsC;ED0srDvC;;EC5srDA;IACC,+BAAqC;IACrC,gCAAsC;ED+srDvC;;ECjtrDA;IACC,6BAAqC;IACrC,8BAAsC;EDotrDvC;;ECttrDA;IACC,+BAAqC;IACrC,gCAAsC;EDytrDvC;;EC3trDA;IACC,6BAAqC;IACrC,8BAAsC;ED8trDvC;;EChurDA;IACC,+BAAqC;IACrC,gCAAsC;EDmurDvC;;ECrurDA;IACC,6BAAqC;IACrC,8BAAsC;EDwurDvC;;EC1urDA;IACC,+BAAqC;IACrC,gCAAsC;ED6urDvC;;EC/urDA;IACC,6BAAqC;IACrC,8BAAsC;EDkvrDvC;;ECpvrDA;IACC,+BAAqC;IACrC,gCAAsC;EDuvrDvC;;ECzvrDA;IACC,6BAAqC;IACrC,8BAAsC;ED4vrDvC;;EC9vrDA;IACC,+BAAqC;IACrC,gCAAsC;EDiwrDvC;;ECnwrDA;IACC,6BAAqC;IACrC,8BAAsC;EDswrDvC;;ECxwrDA;IACC,+BAAqC;IACrC,gCAAsC;ED2wrDvC;;EC7wrDA;IACC,6BAAqC;IACrC,8BAAsC;EDgxrDvC;;EClxrDA;IACC,+BAAqC;IACrC,gCAAsC;EDqxrDvC;;ECvxrDA;IACC,6BAAqC;IACrC,8BAAsC;ED0xrDvC;;EC5xrDA;IACC,+BAAqC;IACrC,gCAAsC;ED+xrDvC;;ECjyrDA;IACC,6BAAqC;IACrC,8BAAsC;EDoyrDvC;;ECtyrDA;IACC,+BAAqC;IACrC,gCAAsC;EDyyrDvC;;EC3yrDA;IACC,6BAAqC;IACrC,8BAAsC;ED8yrDvC;;EChzrDA;IACC,+BAAqC;IACrC,gCAAsC;EDmzrDvC;;ECrzrDA;IACC,6BAAqC;IACrC,8BAAsC;EDwzrDvC;;EC1zrDA;IACC,+BAAqC;IACrC,gCAAsC;ED6zrDvC;;EC/zrDA;IACC,6BAAqC;IACrC,8BAAsC;EDk0rDvC;;ECp0rDA;IACC,+BAAqC;IACrC,gCAAsC;EDu0rDvC;;ECz0rDA;IACC,6BAAqC;IACrC,8BAAsC;ED40rDvC;;EC90rDA;IACC,+BAAqC;IACrC,gCAAsC;EDi1rDvC;;ECn1rDA;IACC,6BAAqC;IACrC,8BAAsC;EDs1rDvC;;ECx1rDA;IACC,+BAAqC;IACrC,gCAAsC;ED21rDvC;;EC71rDA;IACC,6BAAqC;IACrC,8BAAsC;EDg2rDvC;;ECl2rDA;IACC,+BAAqC;IACrC,gCAAsC;EDq2rDvC;;ECv2rDA;IACC,6BAAqC;IACrC,8BAAsC;ED02rDvC;;EC52rDA;IACC,+BAAqC;IACrC,gCAAsC;ED+2rDvC;;ECj3rDA;IACC,6BAAqC;IACrC,8BAAsC;EDo3rDvC;;ECt3rDA;IACC,+BAAqC;IACrC,gCAAsC;EDy3rDvC;;EC33rDA;IACC,6BAAqC;IACrC,8BAAsC;ED83rDvC;;ECh4rDA;IACC,+BAAqC;IACrC,gCAAsC;EDm4rDvC;;ECr4rDA;IACC,6BAAqC;IACrC,8BAAsC;EDw4rDvC;;EC14rDA;IACC,+BAAqC;IACrC,gCAAsC;ED64rDvC;;EC/4rDA;IACC,6BAAqC;IACrC,8BAAsC;EDk5rDvC;;ECp5rDA;IACC,+BAAqC;IACrC,gCAAsC;EDu5rDvC;;ECz5rDA;IACC,6BAAqC;IACrC,8BAAsC;ED45rDvC;;EC95rDA;IACC,+BAAqC;IACrC,gCAAsC;EDi6rDvC;;ECn6rDA;IACC,6BAAqC;IACrC,8BAAsC;EDs6rDvC;;ECx6rDA;IACC,+BAAqC;IACrC,gCAAsC;ED26rDvC;;EC76rDA;IACC,6BAAqC;IACrC,8BAAsC;EDg7rDvC;;ECl7rDA;IACC,+BAAqC;IACrC,gCAAsC;EDq7rDvC;;ECv7rDA;IACC,6BAAqC;IACrC,8BAAsC;ED07rDvC;;EC57rDA;IACC,+BAAqC;IACrC,gCAAsC;ED+7rDvC;;ECj8rDA;IACC,6BAAqC;IACrC,8BAAsC;EDo8rDvC;;ECt8rDA;IACC,+BAAqC;IACrC,gCAAsC;EDy8rDvC;;EC38rDA;IACC,6BAAqC;IACrC,8BAAsC;ED88rDvC;;ECh9rDA;IACC,+BAAqC;IACrC,gCAAsC;EDm9rDvC;;ECr9rDA;IACC,6BAAqC;IACrC,8BAAsC;EDw9rDvC;;EC19rDA;IACC,+BAAqC;IACrC,gCAAsC;ED69rDvC;;EC/9rDA;IACC,6BAAqC;IACrC,8BAAsC;EDk+rDvC;;ECp+rDA;IACC,+BAAqC;IACrC,gCAAsC;EDu+rDvC;;ECz+rDA;IACC,6BAAqC;IACrC,8BAAsC;ED4+rDvC;;EC9+rDA;IACC,+BAAqC;IACrC,gCAAsC;EDi/rDvC;;ECn/rDA;IACC,6BAAqC;IACrC,8BAAsC;EDs/rDvC;;ECx/rDA;IACC,+BAAqC;IACrC,gCAAsC;ED2/rDvC;;EC7/rDA;IACC,6BAAqC;IACrC,8BAAsC;EDggsDvC;;EClgsDA;IACC,+BAAqC;IACrC,gCAAsC;EDqgsDvC;;ECvgsDA;IACC,6BAAqC;IACrC,8BAAsC;ED0gsDvC;;EC5gsDA;IACC,+BAAqC;IACrC,gCAAsC;ED+gsDvC;;ECjhsDA;IACC,6BAAqC;IACrC,8BAAsC;EDohsDvC;;ECthsDA;IACC,+BAAqC;IACrC,gCAAsC;EDyhsDvC;;EC3hsDA;IACC,6BAAqC;IACrC,8BAAsC;ED8hsDvC;;EChisDA;IACC,+BAAqC;IACrC,gCAAsC;EDmisDvC;;ECrisDA;IACC,6BAAqC;IACrC,8BAAsC;EDwisDvC;;EC1isDA;IACC,+BAAqC;IACrC,gCAAsC;ED6isDvC;;EC/isDA;IACC,6BAAqC;IACrC,8BAAsC;EDkjsDvC;;ECpjsDA;IACC,+BAAqC;IACrC,gCAAsC;EDujsDvC;;ECzjsDA;IACC,6BAAqC;IACrC,8BAAsC;ED4jsDvC;;EC9jsDA;IACC,+BAAqC;IACrC,gCAAsC;EDiksDvC;;ECnksDA;IACC,6BAAqC;IACrC,8BAAsC;EDsksDvC;;ECxksDA;IACC,+BAAqC;IACrC,gCAAsC;ED2ksDvC;;EC7ksDA;IACC,6BAAqC;IACrC,8BAAsC;EDglsDvC;;ECllsDA;IACC,+BAAqC;IACrC,gCAAsC;EDqlsDvC;;ECvlsDA;IACC,6BAAqC;IACrC,8BAAsC;ED0lsDvC;;EC5lsDA;IACC,+BAAqC;IACrC,gCAAsC;ED+lsDvC;;ECjmsDA;IACC,6BAAqC;IACrC,8BAAsC;EDomsDvC;;ECtmsDA;IACC,+BAAqC;IACrC,gCAAsC;EDymsDvC;;EC3msDA;IACC,6BAAqC;IACrC,8BAAsC;ED8msDvC;;EChnsDA;IACC,+BAAqC;IACrC,gCAAsC;EDmnsDvC;;ECrnsDA;IACC,6BAAqC;IACrC,8BAAsC;EDwnsDvC;;EC1nsDA;IACC,+BAAqC;IACrC,gCAAsC;ED6nsDvC;;EC/nsDA;IACC,6BAAqC;IACrC,8BAAsC;EDkosDvC;;ECposDA;IACC,+BAAqC;IACrC,gCAAsC;EDuosDvC;;ECzosDA;IACC,6BAAqC;IACrC,8BAAsC;ED4osDvC;;EC9osDA;IACC,+BAAqC;IACrC,gCAAsC;EDipsDvC;;ECnpsDA;IACC,6BAAqC;IACrC,8BAAsC;EDspsDvC;;ECxpsDA;IACC,+BAAqC;IACrC,gCAAsC;ED2psDvC;;EC7psDA;IACC,6BAAqC;IACrC,8BAAsC;EDgqsDvC;;EClqsDA;IACC,+BAAqC;IACrC,gCAAsC;EDqqsDvC;;ECvqsDA;IACC,6BAAqC;IACrC,8BAAsC;ED0qsDvC;;EC5qsDA;IACC,+BAAqC;IACrC,gCAAsC;ED+qsDvC;;ECjrsDA;IACC,6BAAqC;IACrC,8BAAsC;EDorsDvC;;ECtrsDA;IACC,+BAAqC;IACrC,gCAAsC;EDyrsDvC;;EC3rsDA;IACC,6BAAqC;IACrC,8BAAsC;ED8rsDvC;;EChssDA;IACC,+BAAqC;IACrC,gCAAsC;EDmssDvC;;ECrssDA;IACC,6BAAqC;IACrC,8BAAsC;EDwssDvC;;EC1ssDA;IACC,+BAAqC;IACrC,gCAAsC;ED6ssDvC;;EC/ssDA;IACC,6BAAqC;IACrC,8BAAsC;EDktsDvC;;ECptsDA;IACC,+BAAqC;IACrC,gCAAsC;EDutsDvC;;ECztsDA;IACC,6BAAqC;IACrC,8BAAsC;ED4tsDvC;;EC9tsDA;IACC,+BAAqC;IACrC,gCAAsC;EDiusDvC;;ECnusDA;IACC,6BAAqC;IACrC,8BAAsC;EDsusDvC;;ECxusDA;IACC,+BAAqC;IACrC,gCAAsC;ED2usDvC;;EC7usDA;IACC,6BAAqC;IACrC,8BAAsC;EDgvsDvC;;EClvsDA;IACC,+BAAqC;IACrC,gCAAsC;EDqvsDvC;;ECvvsDA;IACC,6BAAqC;IACrC,8BAAsC;ED0vsDvC;;EC5vsDA;IACC,+BAAqC;IACrC,gCAAsC;ED+vsDvC;;ECjwsDA;IACC,6BAAqC;IACrC,8BAAsC;EDowsDvC;;ECtwsDA;IACC,+BAAqC;IACrC,gCAAsC;EDywsDvC;;EC3wsDA;IACC,6BAAqC;IACrC,8BAAsC;ED8wsDvC;;EChxsDA;IACC,+BAAqC;IACrC,gCAAsC;EDmxsDvC;;ECrxsDA;IACC,6BAAqC;IACrC,8BAAsC;EDwxsDvC;;EC1xsDA;IACC,+BAAqC;IACrC,gCAAsC;ED6xsDvC;;EC/xsDA;IACC,6BAAqC;IACrC,8BAAsC;EDkysDvC;;ECpysDA;IACC,+BAAqC;IACrC,gCAAsC;EDuysDvC;;ECzysDA;IACC,6BAAqC;IACrC,8BAAsC;ED4ysDvC;;EC9ysDA;IACC,+BAAqC;IACrC,gCAAsC;EDizsDvC;;ECnzsDA;IACC,6BAAqC;IACrC,8BAAsC;EDszsDvC;;ECxzsDA;IACC,+BAAqC;IACrC,gCAAsC;ED2zsDvC;;EC7zsDA;IACC,6BAAqC;IACrC,8BAAsC;EDg0sDvC;;ECl0sDA;IACC,+BAAqC;IACrC,gCAAsC;EDq0sDvC;;ECv0sDA;IACC,6BAAqC;IACrC,8BAAsC;ED00sDvC;;EC50sDA;IACC,+BAAqC;IACrC,gCAAsC;ED+0sDvC;;ECj1sDA;IACC,6BAAqC;IACrC,8BAAsC;EDo1sDvC;;ECt1sDA;IACC,+BAAqC;IACrC,gCAAsC;EDy1sDvC;;EC31sDA;IACC,6BAAqC;IACrC,8BAAsC;ED81sDvC;;ECh2sDA;IACC,+BAAqC;IACrC,gCAAsC;EDm2sDvC;;ECr2sDA;IACC,6BAAqC;IACrC,8BAAsC;EDw2sDvC;;EC12sDA;IACC,+BAAqC;IACrC,gCAAsC;ED62sDvC;;EC/2sDA;IACC,6BAAqC;IACrC,8BAAsC;EDk3sDvC;;ECp3sDA;IACC,+BAAqC;IACrC,gCAAsC;EDu3sDvC;;ECr2sDA;IACC,6BAAoC;IACpC,8BAAuC;EDw2sDxC;;EC12sDA;IACC,+BAAoC;IACpC,gCAAe;ED62sDhB;;EC/2sDA;IACC,2BAAY;IACZ,8BAAe;EDk3sDhB;;ECp3sDA;IACC,8BAAoC;IACpC,iCAAuC;EDu3sDxC;;ECz3sDA;IACC,6BAAoC;IACpC,gCAAuC;ED43sDxC;;EC93sDA;IACC,2BAAoC;IACpC,8BAAuC;EDi4sDxC;;ECn4sDA;IACC,6BAAoC;IACpC,gCAAuC;EDs4sDxC;;ECx4sDA;IACC,2BAAoC;IACpC,8BAAuC;ED24sDxC;;EC74sDA;IACC,6BAAoC;IACpC,gCAAuC;EDg5sDxC;;ECl5sDA;IACC,2BAAoC;IACpC,8BAAuC;EDq5sDxC;;ECv5sDA;IACC,6BAAoC;IACpC,gCAAuC;ED05sDxC;;EC55sDA;IACC,2BAAoC;IACpC,8BAAuC;ED+5sDxC;;ECj6sDA;IACC,6BAAoC;IACpC,gCAAuC;EDo6sDxC;;ECt6sDA;IACC,2BAAoC;IACpC,8BAAuC;EDy6sDxC;;EC36sDA;IACC,6BAAoC;IACpC,gCAAuC;ED86sDxC;;ECh7sDA;IACC,2BAAoC;IACpC,8BAAuC;EDm7sDxC;;ECr7sDA;IACC,6BAAoC;IACpC,gCAAuC;EDw7sDxC;;EC17sDA;IACC,2BAAoC;IACpC,8BAAuC;ED67sDxC;;EC/7sDA;IACC,6BAAoC;IACpC,gCAAuC;EDk8sDxC;;ECp8sDA;IACC,2BAAoC;IACpC,8BAAuC;EDu8sDxC;;ECz8sDA;IACC,6BAAoC;IACpC,gCAAuC;ED48sDxC;;EC98sDA;IACC,2BAAY;IACZ,8BAAe;EDi9sDhB;;ECn9sDA;IACC,6BAAY;IACZ,gCAAe;EDs9sDhB;;ECx9sDA;IACC,4BAAoC;IACpC,+BAAuC;ED29sDxC;;EC79sDA;IACC,8BAAoC;IACpC,iCAAuC;EDg+sDxC;;ECl+sDA;IACC,4BAAoC;IACpC,+BAAuC;EDq+sDxC;;ECv+sDA;IACC,8BAAoC;IACpC,iCAAuC;ED0+sDxC;;EC5+sDA;IACC,4BAAoC;IACpC,+BAAuC;ED++sDxC;;ECj/sDA;IACC,8BAAoC;IACpC,iCAAuC;EDo/sDxC;;ECt/sDA;IACC,4BAAoC;IACpC,+BAAuC;EDy/sDxC;;EC3/sDA;IACC,8BAAoC;IACpC,iCAAuC;ED8/sDxC;;EChgtDA;IACC,4BAAoC;IACpC,+BAAuC;EDmgtDxC;;ECrgtDA;IACC,8BAAoC;IACpC,iCAAuC;EDwgtDxC;;EC1gtDA;IACC,4BAAoC;IACpC,+BAAuC;ED6gtDxC;;EC/gtDA;IACC,8BAAoC;IACpC,iCAAuC;EDkhtDxC;;ECphtDA;IACC,4BAAoC;IACpC,+BAAuC;EDuhtDxC;;ECzhtDA;IACC,8BAAoC;IACpC,iCAAuC;ED4htDxC;;EC9htDA;IACC,4BAAoC;IACpC,+BAAuC;EDiitDxC;;ECnitDA;IACC,8BAAoC;IACpC,iCAAuC;EDsitDxC;;ECxitDA;IACC,4BAAoC;IACpC,+BAAuC;ED2itDxC;;EC7itDA;IACC,8BAAoC;IACpC,iCAAuC;EDgjtDxC;;ECljtDA;IACC,4BAAoC;IACpC,+BAAuC;EDqjtDxC;;ECvjtDA;IACC,8BAAoC;IACpC,iCAAuC;ED0jtDxC;;EC5jtDA;IACC,4BAAoC;IACpC,+BAAuC;ED+jtDxC;;ECjktDA;IACC,8BAAoC;IACpC,iCAAuC;EDoktDxC;;ECtktDA;IACC,4BAAoC;IACpC,+BAAuC;EDyktDxC;;EC3ktDA;IACC,8BAAoC;IACpC,iCAAuC;ED8ktDxC;;EChltDA;IACC,4BAAoC;IACpC,+BAAuC;EDmltDxC;;ECrltDA;IACC,8BAAoC;IACpC,iCAAuC;EDwltDxC;;EC1ltDA;IACC,4BAAoC;IACpC,+BAAuC;ED6ltDxC;;EC/ltDA;IACC,8BAAoC;IACpC,iCAAuC;EDkmtDxC;;ECpmtDA;IACC,4BAAoC;IACpC,+BAAuC;EDumtDxC;;ECzmtDA;IACC,8BAAoC;IACpC,iCAAuC;ED4mtDxC;;EC9mtDA;IACC,4BAAoC;IACpC,+BAAuC;EDintDxC;;ECnntDA;IACC,8BAAoC;IACpC,iCAAuC;EDsntDxC;;ECxntDA;IACC,4BAAoC;IACpC,+BAAuC;ED2ntDxC;;EC7ntDA;IACC,8BAAoC;IACpC,iCAAuC;EDgotDxC;;EClotDA;IACC,4BAAoC;IACpC,+BAAuC;EDqotDxC;;ECvotDA;IACC,8BAAoC;IACpC,iCAAuC;ED0otDxC;;EC5otDA;IACC,4BAAoC;IACpC,+BAAuC;ED+otDxC;;ECjptDA;IACC,8BAAoC;IACpC,iCAAuC;EDoptDxC;;ECtptDA;IACC,4BAAoC;IACpC,+BAAuC;EDyptDxC;;EC3ptDA;IACC,8BAAoC;IACpC,iCAAuC;ED8ptDxC;;EChqtDA;IACC,4BAAoC;IACpC,+BAAuC;EDmqtDxC;;ECrqtDA;IACC,8BAAoC;IACpC,iCAAuC;EDwqtDxC;;EC1qtDA;IACC,4BAAoC;IACpC,+BAAuC;ED6qtDxC;;EC/qtDA;IACC,8BAAoC;IACpC,iCAAuC;EDkrtDxC;;ECprtDA;IACC,4BAAoC;IACpC,+BAAuC;EDurtDxC;;ECzrtDA;IACC,8BAAoC;IACpC,iCAAuC;ED4rtDxC;;EC9rtDA;IACC,4BAAoC;IACpC,+BAAuC;EDistDxC;;ECnstDA;IACC,8BAAoC;IACpC,iCAAuC;EDsstDxC;;ECxstDA;IACC,4BAAoC;IACpC,+BAAuC;ED2stDxC;;EC7stDA;IACC,8BAAoC;IACpC,iCAAuC;EDgttDxC;;EClttDA;IACC,4BAAoC;IACpC,+BAAuC;EDqttDxC;;ECvttDA;IACC,8BAAoC;IACpC,iCAAuC;ED0ttDxC;;EC5ttDA;IACC,4BAAoC;IACpC,+BAAuC;ED+ttDxC;;ECjutDA;IACC,8BAAoC;IACpC,iCAAuC;EDoutDxC;;ECtutDA;IACC,4BAAoC;IACpC,+BAAuC;EDyutDxC;;EC3utDA;IACC,8BAAoC;IACpC,iCAAuC;ED8utDxC;;EChvtDA;IACC,4BAAoC;IACpC,+BAAuC;EDmvtDxC;;ECrvtDA;IACC,8BAAoC;IACpC,iCAAuC;EDwvtDxC;;EC1vtDA;IACC,4BAAoC;IACpC,+BAAuC;ED6vtDxC;;EC/vtDA;IACC,8BAAoC;IACpC,iCAAuC;EDkwtDxC;;ECpwtDA;IACC,4BAAoC;IACpC,+BAAuC;EDuwtDxC;;ECzwtDA;IACC,8BAAoC;IACpC,iCAAuC;ED4wtDxC;;EC9wtDA;IACC,4BAAoC;IACpC,+BAAuC;EDixtDxC;;ECnxtDA;IACC,8BAAoC;IACpC,iCAAuC;EDsxtDxC;;ECxxtDA;IACC,4BAAoC;IACpC,+BAAuC;ED2xtDxC;;EC7xtDA;IACC,8BAAoC;IACpC,iCAAuC;EDgytDxC;;EClytDA;IACC,4BAAoC;IACpC,+BAAuC;EDqytDxC;;ECvytDA;IACC,8BAAoC;IACpC,iCAAuC;ED0ytDxC;;EC5ytDA;IACC,4BAAoC;IACpC,+BAAuC;ED+ytDxC;;ECjztDA;IACC,8BAAoC;IACpC,iCAAuC;EDoztDxC;;ECtztDA;IACC,4BAAoC;IACpC,+BAAuC;EDyztDxC;;EC3ztDA;IACC,8BAAoC;IACpC,iCAAuC;ED8ztDxC;;ECh0tDA;IACC,4BAAoC;IACpC,+BAAuC;EDm0tDxC;;ECr0tDA;IACC,8BAAoC;IACpC,iCAAuC;EDw0tDxC;;EC10tDA;IACC,4BAAoC;IACpC,+BAAuC;ED60tDxC;;EC/0tDA;IACC,8BAAoC;IACpC,iCAAuC;EDk1tDxC;;ECp1tDA;IACC,4BAAoC;IACpC,+BAAuC;EDu1tDxC;;ECz1tDA;IACC,8BAAoC;IACpC,iCAAuC;ED41tDxC;;EC91tDA;IACC,4BAAoC;IACpC,+BAAuC;EDi2tDxC;;ECn2tDA;IACC,8BAAoC;IACpC,iCAAuC;EDs2tDxC;;ECx2tDA;IACC,4BAAoC;IACpC,+BAAuC;ED22tDxC;;EC72tDA;IACC,8BAAoC;IACpC,iCAAuC;EDg3tDxC;;ECl3tDA;IACC,4BAAoC;IACpC,+BAAuC;EDq3tDxC;;ECv3tDA;IACC,8BAAoC;IACpC,iCAAuC;ED03tDxC;;EC53tDA;IACC,4BAAoC;IACpC,+BAAuC;ED+3tDxC;;ECj4tDA;IACC,8BAAoC;IACpC,iCAAuC;EDo4tDxC;;ECt4tDA;IACC,4BAAoC;IACpC,+BAAuC;EDy4tDxC;;EC34tDA;IACC,8BAAoC;IACpC,iCAAuC;ED84tDxC;;ECh5tDA;IACC,4BAAoC;IACpC,+BAAuC;EDm5tDxC;;ECr5tDA;IACC,8BAAoC;IACpC,iCAAuC;EDw5tDxC;;EC15tDA;IACC,4BAAoC;IACpC,+BAAuC;ED65tDxC;;EC/5tDA;IACC,8BAAoC;IACpC,iCAAuC;EDk6tDxC;;ECp6tDA;IACC,4BAAoC;IACpC,+BAAuC;EDu6tDxC;;ECz6tDA;IACC,8BAAoC;IACpC,iCAAuC;ED46tDxC;;EC96tDA;IACC,4BAAoC;IACpC,+BAAuC;EDi7tDxC;;ECn7tDA;IACC,8BAAoC;IACpC,iCAAuC;EDs7tDxC;;ECx7tDA;IACC,4BAAoC;IACpC,+BAAuC;ED27tDxC;;EC77tDA;IACC,8BAAoC;IACpC,iCAAuC;EDg8tDxC;;ECl8tDA;IACC,4BAAoC;IACpC,+BAAuC;EDq8tDxC;;ECv8tDA;IACC,8BAAoC;IACpC,iCAAuC;ED08tDxC;;EC58tDA;IACC,4BAAoC;IACpC,+BAAuC;ED+8tDxC;;ECj9tDA;IACC,8BAAoC;IACpC,iCAAuC;EDo9tDxC;;ECt9tDA;IACC,4BAAoC;IACpC,+BAAuC;EDy9tDxC;;EC39tDA;IACC,8BAAoC;IACpC,iCAAuC;ED89tDxC;;ECh+tDA;IACC,4BAAoC;IACpC,+BAAuC;EDm+tDxC;;ECr+tDA;IACC,8BAAoC;IACpC,iCAAuC;EDw+tDxC;;EC1+tDA;IACC,4BAAoC;IACpC,+BAAuC;ED6+tDxC;;EC/+tDA;IACC,8BAAoC;IACpC,iCAAuC;EDk/tDxC;;ECp/tDA;IACC,4BAAoC;IACpC,+BAAuC;EDu/tDxC;;ECz/tDA;IACC,8BAAoC;IACpC,iCAAuC;ED4/tDxC;;EC9/tDA;IACC,4BAAoC;IACpC,+BAAuC;EDiguDxC;;ECnguDA;IACC,8BAAoC;IACpC,iCAAuC;EDsguDxC;;ECxguDA;IACC,4BAAoC;IACpC,+BAAuC;ED2guDxC;;EC7guDA;IACC,8BAAoC;IACpC,iCAAuC;EDghuDxC;;EClhuDA;IACC,4BAAoC;IACpC,+BAAuC;EDqhuDxC;;ECvhuDA;IACC,8BAAoC;IACpC,iCAAuC;ED0huDxC;;EC5huDA;IACC,4BAAoC;IACpC,+BAAuC;ED+huDxC;;ECjiuDA;IACC,8BAAoC;IACpC,iCAAuC;EDoiuDxC;;ECtiuDA;IACC,4BAAoC;IACpC,+BAAuC;EDyiuDxC;;EC3iuDA;IACC,8BAAoC;IACpC,iCAAuC;ED8iuDxC;;EChjuDA;IACC,4BAAoC;IACpC,+BAAuC;EDmjuDxC;;ECrjuDA;IACC,8BAAoC;IACpC,iCAAuC;EDwjuDxC;;EC1juDA;IACC,4BAAoC;IACpC,+BAAuC;ED6juDxC;;EC/juDA;IACC,8BAAoC;IACpC,iCAAuC;EDkkuDxC;;ECpkuDA;IACC,4BAAoC;IACpC,+BAAuC;EDukuDxC;;ECzkuDA;IACC,8BAAoC;IACpC,iCAAuC;ED4kuDxC;;EC9kuDA;IACC,4BAAoC;IACpC,+BAAuC;EDiluDxC;;ECnluDA;IACC,8BAAoC;IACpC,iCAAuC;EDsluDxC;;ECxluDA;IACC,4BAAoC;IACpC,+BAAuC;ED2luDxC;;EC7luDA;IACC,8BAAoC;IACpC,iCAAuC;EDgmuDxC;;EClmuDA;IACC,4BAAoC;IACpC,+BAAuC;EDqmuDxC;;ECvmuDA;IACC,8BAAoC;IACpC,iCAAuC;ED0muDxC;;EC5muDA;IACC,4BAAoC;IACpC,+BAAuC;ED+muDxC;;ECjnuDA;IACC,8BAAoC;IACpC,iCAAuC;EDonuDxC;;ECtnuDA;IACC,4BAAoC;IACpC,+BAAuC;EDynuDxC;;EC3nuDA;IACC,8BAAoC;IACpC,iCAAuC;ED8nuDxC;;EChouDA;IACC,4BAAoC;IACpC,+BAAuC;EDmouDxC;;ECrouDA;IACC,8BAAoC;IACpC,iCAAuC;EDwouDxC;;ECjouDF;IACA,4BAAgB;IACf,+BAAiB;EDoouDhB;;EClouDF;IACC,8BAAiB;IDqouDd,iCAAiC;EACnC;ACpouDF;ADsouDA,oBCrouDkB;ADsouDlB;EACE,sEAAsE;ACrouDxE;;ADwouDA;EACE,sEAAsE;ACtouDxE;;ADyouDA;EACE,sEAAsE;ACvouDxE;;AD0ouDA;EACE,sEAAsE;ACxouDxE;;AD2ouDA;EACE,qEAAqE;ACzouDvE;;AD4ouDA;EACE,oEAAoE;AC1ouDtE;;AD6ouDA;EACE,mEAAmE;AC3ouDrE;;AD8ouDA;EACE,oEAAoE;AC5ouDtE;;AD+ouDA;EACE,oEAAoE;AC7ouDtE;;ADgpuDA;EACE,oEAAoE;AC9ouDtE;;ADipuDA;EACE,oEAAoE;AC/ouDtE;;ADkpuDA;EACE,sEAAsE;AChpuDxE;;ADmpuDA;EACE,sEAAsE;ACjpuDxE;;ADopuDA;EACE,sEAAsE;AClpuDxE;;ADqpuDA;EACE,sEAAsE;ACnpuDxE;;ADspuDA;EACE,qEAAqE;ACppuDvE;;ADupuDA;EACE,oEAAoE;ACrpuDtE;;ADwpuDA;EACE,mEAAmE;ACtpuDrE;;ADypuDA;EACE,mEAAmE;ACvpuDrE;;AD0puDA;EACE,mEAAmE;ACxpuDrE;;AD2puDA;EACE,oEAAoE;ACzpuDtE;;AD4puDA;EACE,oEAAoE;AC1puDtE;;AD6puDA;EACE,sEAAsE;AC3puDxE;;AD8puDA;EACE,sEAAsE;AC5puDxE;;AD+puDA;EACE,sEAAsE;AC7puDxE;;ADgquDA;EACE,sEAAsE;AC9puDxE;;ADiquDA;EACE,qEAAqE;AC/puDvE;;ADkquDA;EACE,oEAAoE;AChquDtE;;ADmquDA;EACE,mEAAmE;ACjquDrE;;ADoquDA;EACE,mEAAmE;AClquDrE;;ADqquDA;EACE,mEAAmE;ACnquDrE;;ADsquDA;EACE,oEAAoE;ACpquDtE;;ADuquDA;EACE,oEAAoE;ACrquDtE;;ADwquDA;EACE,sEAAsE;ACtquDxE;;ADyquDA;EACE,sEAAsE;ACvquDxE;;AD0quDA;EACE,sEAAsE;ACxquDxE;;AD2quDA;EACE,sEAAsE;ACzquDxE;;AD4quDA;EACE,qEAAqE;AC1quDvE;;AD6quDA;EACE,oEAAoE;AC3quDtE;;AD8quDA;EACE,mEAAmE;AC5quDrE;;AD+quDA;EACE,oEAAoE;AC7quDtE;;ADgruDA;EACE,oEAAoE;AC9quDtE;;ADiruDA;EACE,oEAAoE;AC/quDtE;;ADkruDA;EACE,oEAAoE;AChruDtE;;ADmruDA;EACE,sEAAsE;ACjruDxE;;ADoruDA;EACE,sEAAsE;AClruDxE;;ADqruDA;EACE,sEAAsE;ACnruDxE;;ADsruDA;EACE,sEAAsE;ACpruDxE;;ADuruDA;EACE,qEAAqE;ACrruDvE;;ADwruDA;EACE,oEAAoE;ACtruDtE;;ADyruDA;EACE,mEAAmE;ACvruDrE;;AD0ruDA;EACE,oEAAoE;ACxruDtE;;AD2ruDA;EACE,oEAAoE;ACzruDtE;;AD4ruDA;EACE,oEAAoE;AC1ruDtE;;AD6ruDA;EACE,oEAAoE;AC3ruDtE;;AD8ruDA;EACE,sEAAsE;AC5ruDxE;;AD+ruDA;EACE,sEAAsE;AC7ruDxE;;ADgsuDA;EACE,sEAAsE;AC9ruDxE;;ADisuDA;EACE,sEAAsE;AC/ruDxE;;ADksuDA;EACE,oEAAoE;AChsuDtE;;ADmsuDA;EACE,kEAAkE;ACjsuDpE;;ADosuDA;EACE,kEAAkE;AClsuDpE;;ADqsuDA;EACE,kEAAkE;ACnsuDpE;;ADssuDA;EACE,kEAAkE;ACpsuDpE;;ADusuDA;EACE,kEAAkE;ACrsuDpE;;ADwsuDA;EACE,kEAAkE;ACtsuDpE;;ADysuDA;EACE,sEAAsE;ACvsuDxE;;AD0suDA;EACE,sEAAsE;ACxsuDxE;;AD2suDA;EACE,sEAAsE;ACzsuDxE;;AD4suDA;EACE,sEAAsE;AC1suDxE;;AD6suDA;EACE,oEAAoE;AC3suDtE;;AD8suDA;EACE,kEAAkE;AC5suDpE;;AD+suDA;EACE,kEAAkE;AC7suDpE;;ADgtuDA;EACE,kEAAkE;AC9suDpE;;ADituDA;EACE,kEAAkE;AC/suDpE;;ADktuDA;EACE,kEAAkE;AChtuDpE;;ADmtuDA;EACE,kEAAkE;ACjtuDpE;;ADotuDA;EACE,sEAAsE;ACltuDxE;;ADqtuDA;EACE,sEAAsE;ACntuDxE;;ADstuDA;EACE,sEAAsE;ACptuDxE;;ADutuDA;EACE,sEAAsE;ACrtuDxE;;ADwtuDA;EACE,qEAAqE;ACttuDvE;;ADytuDA;EACE,qEAAqE;ACvtuDvE;;AD0tuDA;EACE,oEAAoE;ACxtuDtE;;AD2tuDA;EACE,oEAAoE;ACztuDtE;;AD4tuDA;EACE,oEAAoE;AC1tuDtE;;AD6tuDA;EACE,qEAAqE;AC3tuDvE;;AD8tuDA;EACE,qEAAqE;AC5tuDvE;;AD+tuDA;EACE,kEAAkE;AC7tuDpE;;ADguuDA;EACE,sEAAsE;AC9tuDxE;;ADiuuDA;EACE,sEAAsE;AC/tuDxE;;ADkuuDA;EACE,sEAAsE;AChuuDxE;;ADmuuDA;EACE,qEAAqE;ACjuuDvE;;ADouuDA;EACE,oEAAoE;ACluuDtE;;ADquuDA;EACE,kEAAkE;ACnuuDpE;;ADsuuDA;EACE,kEAAkE;ACpuuDpE;;ADuuuDA;EACE,kEAAkE;ACruuDpE;;ADwuuDA;EACE,oEAAoE;ACtuuDtE;;ADyuuDA;EACE,oEAAoE;ACvuuDtE;;AD0uuDA;EACE,sEAAsE;ACxuuDxE;;AD2uuDA;EACE,sEAAsE;ACzuuDxE;;AD4uuDA;EACE,sEAAsE;AC1uuDxE;;AD6uuDA;EACE,sEAAsE;AC3uuDxE;;AD8uuDA;EACE,qEAAqE;AC5uuDvE;;AD+uuDA;EACE,qEAAqE;AC7uuDvE;;ADgvuDA;EACE,qEAAqE;AC9uuDvE;;ADivuDA;EACE,qEAAqE;AC/uuDvE;;ADkvuDA;EACE,qEAAqE;AChvuDvE;;ADmvuDA;EACE,qEAAqE;ACjvuDvE;;ADovuDA;EACE,qEAAqE;AClvuDvE;;ADqvuDA;EACE,sEAAsE;ACnvuDxE;;ADsvuDA;EACE,sEAAsE;ACpvuDxE;;ADuvuDA;EACE,sEAAsE;ACrvuDxE;;ADwvuDA;EACE,sEAAsE;ACtvuDxE;;ADyvuDA;EACE,qEAAqE;ACvvuDvE;;AD0vuDA;EACE,qEAAqE;ACxvuDvE;;AD2vuDA;EACE,qEAAqE;ACzvuDvE;;AD4vuDA;EACE,qEAAqE;AC1vuDvE;;AD6vuDA;EACE,qEAAqE;AC1vuDvE;;AD6vuDA;EACE,qEAAqE;AC3vuDvE;;AD8vuDA;EACE,qEAAqE;AC5vuDvE;;AD+vuDA;EACE,sEAAsE;AC7vuDxE;;ADgwuDA;EACE,sEAAsE;AC9vuDxE;;ADiwuDA;EACE,sEAAsE;AC/vuDxE;;ADkwuDA;EACE,sEAAsE;AChwuDxE;;ADmwuDA;EACE,sEAAsE;ACjwuDxE;;ADowuDA;EACE,sEAAsE;AClwuDxE;;ADqwuDA;EACE,sEAAsE;ACnwuDxE;;ADswuDA;EACE,sEAAsE;ACpwuDxE;;ADuwuDA;EACE,sEAAsE;ACrwuDxE;;ADwwuDA;EACE,mEAAmE;ACtwuDrE;;ADywuDA;EACE,mEAAmE;ACvwuDrE;;AD0wuDA;EACE,sEAAsE;ACxwuDxE;;AD2wuDA;EACE,sEAAsE;ACzwuDxE;;AD4wuDA;EACE,sEAAsE;AC1wuDxE;;AD6wuDA;EACE,sEAAsE;AC3wuDxE;;AD8wuDA;EACE,sEAAsE;AC5wuDxE;;AD+wuDA;EACE,sEAAsE;AC7wuDxE;;ADgxuDA;EACE,sEAAsE;AC9wuDxE;;ADixuDA;EACE,mEAAmE;AC/wuDrE;;ADkxuDA;EACE,mEAAmE;AChxuDrE;;ADmxuDA;EACE,mEAAmE;ACjxuDrE;;ADoxuDA;EACE,mEAAmE;AClxuDrE;;ADqxuDA;EACE,sEAAsE;ACnxuDxE;;ADsxuDA;EACE,sEAAsE;ACpxuDxE;;ADuxuDA;EACE,sEAAsE;ACrxuDxE;;ADwxuDA;EACE,sEAAsE;ACtxuDxE;;ADyxuDA;EACE,qEAAqE;ACvxuDvE;;AD0xuDA;EACE,qEAAqE;ACxxuDvE;;AD2xuDA;EACE,oEAAoE;ACzxuDtE;;AD4xuDA;EACE,oEAAoE;AC1xuDtE;;AD6xuDA;EACE,qEAAqE;AC3xuDvE;;AD8xuDA;EACE,qEAAqE;AC5xuDvE;;AD+xuDA;EACE,qEAAqE;AC7xuDvE;;ADgyuDA;EACE,sEAAsE;AC9xuDxE;;ADiyuDA;EACE,sEAAsE;AC/xuDxE;;ADkyuDA;EACE,sEAAsE;AChyuDxE;;ADmyuDA;EACE,sEAAsE;ACjyuDxE;;ADoyuDA;EACE,qEAAqE;AClyuDvE;;ADqyuDA;EACE,qEAAqE;ACnyuDvE;;ADsyuDA;EACE,oEAAoE;ACpyuDtE;;ADuyuDA;EACE,qEAAqE;ACryuDvE;;ADwyuDA;EACE,qEAAqE;ACtyuDvE;;ADyyuDA;EACE,qEAAqE;ACvyuDvE;;AD0yuDA;EACE,qEAAqE;ACxyuDvE;;AD2yuDA;EACE,sEAAsE;ACzyuDxE;;AD4yuDA;EACE,sEAAsE;AC1yuDxE;;AD6yuDA;EACE,sEAAsE;AC3yuDxE;;AD8yuDA;EACE,sEAAsE;AC5yuDxE;;AD+yuDA;EACE,qEAAqE;AC7yuDvE;;ADgzuDA;EACE,qEAAqE;AC9yuDvE;;ADizuDA;EACE,oEAAoE;AC/yuDtE;;ADkzuDA;EACE,oEAAoE;AChzuDtE;;ADmzuDA;EACE,oEAAoE;ACjzuDtE;;ADozuDA;EACE,oEAAoE;AClzuDtE;;ADqzuDA;EACE,qEAAqE;ACnzuDvE;;ADszuDA;EACE,sEAAsE;ACpzuDxE;;ADuzuDA;EACE,sEAAsE;ACrzuDxE;;ADwzuDA;EACE,sEAAsE;ACtzuDxE;;ADyzuDA;EACE,sEAAsE;ACvzuDxE;;AD0zuDA;EACE,qEAAqE;ACxzuDvE;;AD2zuDA;EACE,oEAAoE;ACzzuDtE;;AD4zuDA;EACE,mEAAmE;AC1zuDrE;;AD6zuDA;EACE,mEAAmE;AC3zuDrE;;AD8zuDA;EACE,mEAAmE;AC5zuDrE;;AD+zuDA;EACE,mEAAmE;AC7zuDrE;;ADg0uDA;EACE,mEAAmE;AC9zuDrE;;ADi0uDA;EACE,sEAAsE;AC/zuDxE;;ADk0uDA;EACE,sEAAsE;ACh0uDxE;;ADm0uDA;EACE,sEAAsE;ACj0uDxE;;ADo0uDA;EACE,sEAAsE;ACl0uDxE;;ADq0uDA;EACE,qEAAqE;ACn0uDvE;;ADs0uDA;EACE,oEAAoE;ACp0uDtE;;ADu0uDA;EACE,kEAAkE;ACr0uDpE;;ADw0uDA;EACE,kEAAkE;ACt0uDpE;;ADy0uDA;EACE,kEAAkE;ACv0uDpE;;AD00uDA;EACE,oEAAoE;ACx0uDtE;;AD20uDA;EACE,oEAAoE;ACz0uDtE;;AD40uDA;EACE,sEAAsE;AC10uDxE;;AD60uDA;EACE,sEAAsE;AC30uDxE;;AD80uDA;EACE,sEAAsE;AC50uDxE;;AD+0uDA;EACE,sEAAsE;AC70uDxE;;ADg1uDA;EACE,qEAAqE;AC90uDvE;;ADi1uDA;EACE,qEAAqE;AC/0uDvE;;ADk1uDA;EACE,oEAAoE;ACh1uDtE;;ADm1uDA;EACE,oEAAoE;ACj1uDtE;;ADo1uDA;EACE,oEAAoE;ACl1uDtE;;ADq1uDA;EACE,qEAAqE;ACn1uDvE;;ADs1uDA;EACE,qEAAqE;ACp1uDvE;;ADu1uDA;EACE,sEAAsE;ACr1uDxE;;ADw1uDA;EACE,sEAAsE;ACt1uDxE;;ADy1uDA;EACE,sEAAsE;ACv1uDxE;;AD01uDA;EACE,sEAAsE;ACx1uDxE;;AD21uDA;EACE,sEAAsE;ACz1uDxE;;AD41uDA;EACE,qEAAqE;AC11uDvE;;AD61uDA;EACE,oEAAoE;AC31uDtE;;AD81uDA;EACE,qEAAqE;AC51uDvE;;AD+1uDA;EACE,qEAAqE;AC71uDvE;;ADg2uDA;EACE,qEAAqE;AC91uDvE;;ADi2uDA;EACE,qEAAqE;AC/1uDvE;;ADk2uDA;EACE,sEAAsE;ACh2uDxE;;ADm2uDA;EACE,sEAAsE;ACj2uDxE;;ADo2uDA;EACE,sEAAsE;ACl2uDxE;;ADq2uDA;EACE,sEAAsE;ACn2uDxE;;ADs2uDA;EACE,qEAAqE;ACp2uDvE;;ADu2uDA;EACE,oEAAoE;ACr2uDtE;;ADw2uDA;EACE,oEAAoE;ACt2uDtE;;ADy2uDA;EACE,oEAAoE;ACv2uDtE;;AD02uDA;EACE,oEAAoE;ACx2uDtE;;AD22uDA;EACE,oEAAoE;ACz2uDtE;;AD42uDA;EACE,oEAAoE;AC12uDtE;;AD62uDA;EACE,sEAAsE;AC32uDxE;;AD82uDA;EACE,sEAAsE;AC52uDxE;;AD+2uDA;EACE,sEAAsE;AC72uDxE;;ADg3uDA;EACE,sEAAsE;AC92uDxE;;ADi3uDA;EACE,qEAAqE;AC/2uDvE;;ADk3uDA;EACE,oEAAoE;ACh3uDtE;;ADm3uDA;EACE,mEAAmE;ACj3uDrE;;ADo3uDA;EACE,mEAAmE;ACl3uDrE;;ADq3uDA;EACE,oEAAoE;ACn3uDtE;;ADs3uDA;EACE,oEAAoE;ACp3uDtE;;ADu3uDA;EACE,oEAAoE;ACr3uDtE;;ADw3uDA;EACE,sEAAsE;ACt3uDxE;;ADy3uDA;EACE,sEAAsE;ACv3uDxE;;AD03uDA;EACE,sEAAsE;ACx3uDxE;;AD23uDA;EACE,sEAAsE;ACz3uDxE;;AD43uDA;EACE,qEAAqE;AC13uDvE;;AD63uDA;EACE,mEAAmE;AC33uDrE;;AD83uDA;EACE,mEAAmE;AC53uDrE;;AD+3uDA;EACE,mEAAmE;AC73uDrE;;ADg4uDA;EACE,mEAAmE;AC93uDrE;;ADi4uDA;EACE,mEAAmE;AC/3uDrE;;ADk4uDA;EACE,mEAAmE;ACh4uDrE;;ADm4uDA;EACE,sEAAsE;ACj4uDxE;;ADo4uDA;EACE,sEAAsE;ACl4uDxE;;ADq4uDA;EACE,sEAAsE;ACn4uDxE;;ADs4uDA;EACE,sEAAsE;ACp4uDxE;;ADu4uDA;EACE,qEAAqE;ACr4uDvE;;ADw4uDA;EACE,oEAAoE;ACt4uDtE;;ADy4uDA;EACE,mEAAmE;ACv4uDrE;;AD04uDA;EACE,mEAAmE;ACx4uDrE;;AD24uDA;EACE,oEAAoE;ACz4uDtE;;AD44uDA;EACE,oEAAoE;AC14uDtE;;AD64uDA;EACE,oEAAoE;AC34uDtE;;AD84uDA;EACE,sEAAsE;AC54uDxE;;AD+4uDA;EACE,sEAAsE;AC74uDxE;;ADg5uDA;EACE,sEAAsE;AC94uDxE;;ADi5uDA;EACE,sEAAsE;AC/4uDxE;;ADk5uDA;EACE,sEAAsE;ACh5uDxE;;ADm5uDA;EACE,qEAAqE;ACj5uDvE;;ADo5uDA;EACE,mEAAmE;ACl5uDrE;;ADq5uDA;EACE,oEAAoE;ACn5uDtE;;ADs5uDA;EACE,qEAAqE;ACp5uDvE;;ADu5uDA;EACE,qEAAqE;ACr5uDvE;;ADw5uDA;EACE,qEAAqE;ACt5uDvE;;ADy5uDA;EACE,sEAAsE;ACv5uDxE;;AD05uDA;EACE,sEAAsE;ACx5uDxE;;AD25uDA;EACE,sEAAsE;ACz5uDxE;;AD45uDA;EACE,sEAAsE;AC15uDxE;;AD65uDA;EACE,sEAAsE;AC35uDxE;;AD85uDA;EACE,qEAAqE;AC55uDvE;;AD+5uDA;EACE,mEAAmE;AC75uDrE;;ADg6uDA;EACE,mEAAmE;AC95uDrE;;ADi6uDA;EACE,mEAAmE;AC/5uDrE;;ADk6uDA;EACE,qEAAqE;ACh6uDvE;;ADm6uDA;EACE,qEAAqE;ACj6uDvE;;ADo6uDA;EACE,sEAAsE;ACl6uDxE;;ADq6uDA;EACE,sEAAsE;ACn6uDxE;;ADs6uDA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;;EAEE,mEAAmE;ACt6uDrE;;ADy6uDA;EACE,mEAAmE;ACv6uDrE;;AD06uDA;EACE,mEAAmE;ACx6uDrE;;AD26uDA;EACE,mEAAmE;ACz6uDrE;;AD46uDA;EACE,oCAAoC;AACtC;;AAEA;EE/60DE,oCAAY;AFi70Dd;;AC56uDA;ECtgGE,mBCmLe;EDlLf,+DAA+D;AFs70DjE;;AC96uDA;ECzgGE,mBCqLgB;EDpLhB,+DAA+D;AF270DjE;;ACh7uDA;EC5gGE,mBCiOuC;EDhOvC,+DAA+D;AFg80DjE;;ACl7uDA;EC/gGE,mBCsLuB;EDrLvB,+DAA+D;AFq80DjE;;ACp7uDA;EClhGE,mBCkKmC;EDjKnC,+DAA+D;AF080DjE;;ACt7uDA;ECrhGE,mBC2K8B;ED1K9B,+DAA+D;AF+80DjE;;ACx7uDA;ECxhGE,mBC5CmC;ED6CnC,+DAA+D;AFo90DjE;;AC17uDA;EC3hGE,mBC9BuC;ED+BvC,+DAA+D;AFy90DjE;;AC57uDA;EC9hGE,mBC1Fa;ED2Fb,+DAA+D;AF890DjE;;AC97uDA;ECjiGE,mBCMmC;EDLnC,+DAA+D;AFm+0DjE;;ACh8uDA;ECpiGE,mBCDsC;EDEtC,+DAA+D;AFw+0DjE;;ACl8uDA;ECviGE,mBCpFW;EDqFX,+DAA+D;AF6+0DjE;;ACp8uDA;EC1iGE,mBCnFW;EDoFX,+DAA+D;AFk/0DjE;;ACt8uDA;EC7iGE,mBClFU;EDmFV,+DAA+D;AFu/0DjE;;ACx8uDA;EChjGE,mBCkHyC;EDjHzC,+DAA+D;AF4/0DjE;;AC18uDA;ECnjGE,mBCxCkC;EDyClC,+DAA+D;AFig1DjE;;AC58uDA;ECtjGE,mBCvDqC;EDwDrC,+DAA+D;AFsg1DjE;;AC98uDA;ECzjGE,mBC2JoC;ED1JpC,+DAA+D;AF2g1DjE;;ACh9uDA;EC5jGE,mBC7EW;ED8EX,+DAA+D;AFgh1DjE;;ACl9uDA;EC/jGE,mBCkHyC;EDjHzC,+DAA+D;AFqh1DjE;;ACp9uDA;EACC,mBAAiB;EDu9uDhB,+DAA+D;ACt9uDhE;;ADy9uDD;ECt9uDE,mBAAK;EACL,+DAAW;ADw9uDb;;AAEA;EACE,kBAAkB;ACt9uDpB;AACA;EACC,kBAAM;EDw9uDL,OAAO;EACP,MAAM;ECv9uDR,YAAW;EACV,WAAM;EDy9uDL,UAAU;AACZ;;AAEA,cCz9uDO;AD09uDP;EACE,2DAA2D;ACz9uD7D;;AD49uDA;EACE,4DAA4D;AC19uD9D;;AD69uDA;EACE,4DAA4D;AC39uD9D;;AD89uDA;EACE,2DAA2D;AC59uD7D;;AD+9uDA;EACE,2DAA2D;AC79uD7D;;ADg+uDA;EACE,2DAA2D;AC99uD7D;;ADi+uDA;EACE,2DAA2D;AC/9uD7D;;ADk+uDA;EACE,yDAAyD;ACh+uD3D;;ADm+uDA;EACE,yDAAyD;ACj+uD3D;;ADo+uDA;EACE,4DAA4D;ACl+uD9D;;ADq+uDA;EACE,2DAA2D;ACn+uD7D;;ADs+uDA;EACE,4DAA4D;ACp+uD9D;;ADu+uDA;EACE,4DAA4D;ACr+uD9D;;ADw+uDA;EACE,4DAA4D;ACt+uD9D;;ADy+uDA;EACE,2DAA2D;ACv+uD7D;;AD0+uDA;EACE,2DAA2D;ACx+uD7D;;AD2+uDA;EACE,4DAA4D;ACz+uD9D;;AD4+uDA;EACE,4DAA4D;AC1+uD9D;;AD6+uDA;EACE,2DAA2D;AC3+uD7D;;AD8+uDA;EACE,2DAA2D;AC5+uD7D;;AD++uDA;EACE,0DAA0D;AC7+uD5D;;ADg/uDA;EACE,2DAA2D;AC9+uD7D;;ADi/uDA;EACE,4DAA4D;AC/+uD9D;;ADk/uDA;EACE,4DAA4D;ACh/uD9D;;ADm/uDA;EACE,6DAA6D;ACj/uD/D;;ADo/uDA;EACE,6DAA6D;ACl/uD/D;;ADq/uDA;EACE,6DAA6D;ACn/uD/D;;ADs/uDA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;EAEE,0DAA0D;ACt/uD5D;;ADy/uDA;EACE,0DAA0D;ACv/uD5D;;AD0/uDA;EACE,0DAA0D;ACx/uD5D;;AD2/uDA;EACE,0DAA0D;ACz/uD5D;;AD4/uDA;EACE,6DAA6D;AC1/uD/D;;AD6/uDA;EACE,6DAA6D;AC3/uD/D;;AD8/uDA;EACE,6DAA6D;AAC/D;;AAEA;EC5/uDC,6DAAkB;AD8/uDnB;;AC5/uDA;EACC,cAAW;ED+/uDV,gBAAgB;AAClB;;AC7/uDA;EACC,cAAa;EDggvDZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SCjgvDI;ADkgvDJ;EACE,+BAA+B;ACjgvDjC;;ADogvDA;EACE,+BAA+B;AACjC;;AAEA;EClgvDC,6BAA2B;ADogvD5B;;AClgvDA;EACI,wCAAwB;EDqgvD1B,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;ACrgvD9C;;ADwgvDA;EACE,0CAA0C;ACtgvD5C;;ADygvDA;EACE,2CAA2C;ACvgvD7C;;AD0gvDA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AC1gvDvC;;AD6gvDA;EACE,oCAAoC;AACtC;;AAEA;EC3gvDI,qCAA4B;AD6gvDhC;;AC3gvDA;EACI,oCAA2B;EAC3B,uCAA4B;AD8gvDhC;;AC5gvDA;EACI,qCAA2B;ED+gvD7B,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AC5gvDtC;;AD+gvDJ;EACE,uCAAuC;AChhvDrC;;ADmhvDJ;EACE,wCAAwC;ACphvDtC;;ADuhvDJ;EACE,8BAA8B;ACxhvD5B;;AD2hvDJ;EACE,kCAAkC;AC5hvDhC;;AD+hvDJ;EACE,iCAAiC;AChivD/B;;ADmivDJ;EACE,kCAAkC;ACpivDhC;;ADuivDJ;EACE,gCAAgC;ACxivD9B;;AD2ivDJ;EACE,kCAAkC;AC5ivDhC;;AD+ivDJ;EACE,iCAAiC;AChjvD/B;;ADmjvDJ;EACE,kCAAkC;ACpjvDhC;;ADujvDJ;EACE,8BAA8B;ACxjvD5B;;AD2jvDJ;EACE,kCAAkC;AC5jvDhC;;AD+jvDJ;EACE,iCAAiC;AChkvD/B;;ADmkvDJ;EACE,kCAAkC;ACpkvDhC;;ADukvDJ;EACE,gCAAgC;ACxkvD9B;;AD2kvDJ;EACE,kCAAkC;AC5kvDhC;;AD+kvDJ;EACE,iCAAiC;AChlvD/B;;ADmlvDJ;EACE,kCAAkC;ACplvDhC;;ADulvDJ;EACE,8BAA8B;ACxlvD5B;;AD2lvDJ;EACE,kCAAkC;AC5lvDhC;;AD+lvDJ;EACE,iCAAiC;ACvlvD/B;;AD0lvDJ;EACE,kCAAkC;AC3lvDhC;;AD8lvDJ;EACE,gCAAgC;AC/lvD9B;;ADkmvDJ;EACE,iCAAiC;ACnmvD/B;;ADsmvDJ;EACE,8BAA8B;ACvmvD5B;;AD0mvDJ;EACE,iCAAiC;AC3mvD/B;;AD8mvDJ;EACE,gCAAgC;AC/mvD9B;;ADknvDJ;EACE,iCAAiC;ACnnvD/B;;ADsnvDJ;EACE,8BAA8B;ACvnvD5B;;AD0nvDJ;EACE,iCAAiC;AC3nvD/B;;AD8nvDJ;EACE,gCAAgC;AC/nvD9B;;ADkovDJ;EACE,iCAAiC;ACnovD/B;;ADsovDJ;EACE,8BAA8B;ACvovD5B;;AD0ovDJ;EACE,iCAAiC;AC3ovD/B;;AD8ovDJ;EACE,gCAAgC;ACvovDlC;;AD0ovDA;EACE,iCAAiC;ACxovDnC;;AD2ovDA;EACE,8BAA8B;ACzovDhC;;AD4ovDA;EACE,gCAAgC;AC1ovDlC;;AD6ovDA;EACE,gCAAgC;AC3ovDlC;;AD8ovDA;EACE,gCAAgC;AC5ovDlC;;AD+ovDA;EACE,gCAAgC;AC7ovDlC;;ADgpvDA;EACE,gCAAgC;AC9ovDlC;;ADipvDA;EACE,gCAAgC;AC/ovDlC;;ADkpvDA;EACE,gCAAgC;AChpvDlC;;ADmpvDA;EACE,gCAAgC;ACjpvDlC;;ADopvDA;EACE,gCAAgC;AClpvDlC;;ADqpvDA;EACE,gCAAgC;ACnpvDlC;;ADspvDA;EACE,gCAAgC;ACppvDlC;;ADupvDA;EACE,gCAAgC;ACrpvDlC;;ADwpvDA;EACE,gCAAgC;ACtpvDlC;;ADypvDA;EACE,gCAAgC;ACvpvDlC;;AD0pvDA;EACE,gCAAgC;ACxpvDlC;;AD2pvDA;EACE,gCAAgC;ACzpvDlC;;AD4pvDA;EACE,gCAAgC;AC1pvDlC;;AD6pvDA;EACE,gCAAgC;AC3pvDlC;;AD8pvDA;EACE,gCAAgC;AC5pvDlC;;AD+pvDA;EACE,gCAAgC;AC7pvDlC;;ADgqvDA;EACE,gCAAgC;AC9pvDlC;;ADiqvDA;EACE,gCAAgC;AC/pvDlC;;ADkqvDA;EACE,gCAAgC;AChqvDlC;;ADmqvDA;EACE,gCAAgC;ACjqvDlC;;ADoqvDA;EACE,6BAA6B;AClqvD/B;;ADqqvDA;EACE,gCAAgC;ACnqvDlC;;ADsqvDA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;ACtqvDlC;;ADyqvDA;EACE,gCAAgC;ACvqvDlC;;AD0qvDA;EACE,gCAAgC;ACxqvDlC;;AD2qvDA;EACE,gCAAgC;ACzqvDlC;;AD4qvDA;EACE,gCAAgC;AC1qvDlC;;AD6qvDA;EACE,gCAAgC;AAClC;;ACxqvDA;EACC,yBAAW;AD2qvDZ;;ACzqvDA,SAAA;AD4qvDA;EACE,aAAa;AC3qvDd;;AD8qvDD,SAAS;AC3qvDR;ECj9GE,2BAAY;AF+n2Df;;AAEA;EACE,gEAAgE;AC3qvDjE;AD6qvDD;EACE,iEAAiE;AACnE;AC3qvDA;EG19GQ,gEAA4B;AJwo2DpC;AACA;EACE,iEAAiE;AC9qvDlE;ADgrvDD;EACE,gEAAgE;AC/qvDhE;;ADkrvDF;EAGE,gCAAgC;AC/qvDhC;ADirvDF;EACE,gEAAgE;AC/qvDhE;ADirvDF;EACE,iEAAiE;AACnE;AC9qvDA;ECp+GG,gEAA8D;AFqp2DjE;AC/qvDC;ECn+GE,iEAAgE;AFqp2DnE;AC/qvDC;ECn+GE,gEAA8D;AFqp2DjE;;AAEA;EACE,gEAAgE;AC/qvDjE;ADirvDD;EACE,iEAAiE;AACnE;AC/qvDA;EG3/GQ,gEAA4B;AJ6q2DpC;AACA;EACE,iEAAiE;AClrvDlE;ADorvDD;EACE,gEAAgE;ACnrvDhE;;ADsrvDF;EAGE,gCAAgC;ACnrvDhC;ADqrvDF;EACE,gEAAgE;ACnrvDhE;ADqrvDF;EACE,iEAAiE;AACnE;AClrvDA;ECt/GG,gEAA8D;AF2q2DjE;ACnrvDC;ECr/GE,iEAAgE;AF2q2DnE;ACnrvDC;ECr/GE,gEAA8D;AF2q2DjE;;AAEA;EACE,gEAAgE;ACnrvDjE;ADqrvDD;EACE,iEAAiE;AACnE;ACnrvDA;EG5hHQ,gEAA4B;AJkt2DpC;AACA;EACE,iEAAiE;ACtrvDlE;ADwrvDD;EACE,gEAAgE;ACvrvDhE;;AD0rvDF;EAGE,gCAAgC;ACvrvDhC;ADyrvDF;EACE,gEAAgE;ACvrvDhE;ADyrvDF;EACE,iEAAiE;AACnE;ACtrvDA;ECxgHG,gEAA4D;AFis2D/D;ACvrvDC;ECvgHE,iEAA8D;AFis2DjE;ACvrvDC;ECvgHE,gEAA4D;AFis2D/D;;AAEA;EACE,8DAA8D;ACvrvD/D;ADyrvDD;EACE,+DAA+D;AACjE;ACvrvDA;EG7jHQ,8DAA4B;AJuv2DpC;AACA;EACE,+DAA+D;AC1rvDhE;AD4rvDD;EACE,8DAA8D;AC3rvD9D;;AD8rvDF;EAGE,gCAAgC;AC3rvDhC;AD6rvDF;EACE,8DAA8D;AC3rvD9D;AD6rvDF;EACE,+DAA+D;AACjE;AC1rvDA;ECtlHG,8DAAY;AFmx2Df;AC3rvDC;ECrlHE,+DAAY;AFmx2Df;AC3rvDC;ECrlHE,8DAAY;AFmx2Df;;AAEA;EACE,iEAAiE;AC3rvDlE;AD6rvDD;EACE,kEAAkE;AACpE;AC3rvDA;EG9lHQ,iEAA4B;AJ4x2DpC;AACA;EACE,kEAAkE;AC9rvDnE;ADgsvDD;EACE,iEAAiE;AC/rvDjE;;ADksvDF;EAGE,gCAAgC;AC/rvDhC;ADisvDF;EACE,iEAAiE;AC/rvDjE;ADisvDF;EACE,kEAAkE;AACpE;AC9rvDA;ECxmHG,iEAA8D;AFyy2DjE;AC/rvDC;ECvmHE,kEAAgE;AFyy2DnE;AC/rvDC;ECvmHE,iEAA8D;AFyy2DjE;;AAEA;EACE,iEAAiE;AC/rvDlE;ADisvDD;EACE,kEAAkE;AACpE;AC/rvDA;EG/nHQ,iEAA4B;AJi02DpC;AACA;EACE,kEAAkE;AClsvDnE;ADosvDD;EACE,iEAAiE;ACnsvDjE;;ADssvDF;EAGE,gCAAgC;ACnsvDhC;ADqsvDF;EACE,iEAAiE;ACnsvDjE;ADqsvDF;EACE,kEAAkE;AACpE;AClsvDA;EC1nHG,iEAA8D;AF+z2DjE;ACnsvDC;ECznHE,kEAAgE;AF+z2DnE;ACnsvDC;ECznHE,iEAA8D;AF+z2DjE;;AAEA;EACE,iEAAiE;ACnsvDlE;ADqsvDD;EACE,kEAAkE;AACpE;ACnsvDA;EGhqHQ,iEAA4B;AJs22DpC;AACA;EACE,kEAAkE;ACtsvDnE;ADwsvDD;EACE,iEAAiE;ACvsvDjE;;AD0svDF;EAGE,gCAAgC;ACvsvDhC;ADysvDF;EACE,iEAAiE;ACvsvDjE;ADysvDF;EACE,kEAAkE;AACpE;ACtsvDA;EC5oHG,iEAA4D;AFq12D/D;ACvsvDC;EC3oHE,kEAA8D;AFq12DjE;ACvsvDC;EC3oHE,iEAA4D;AFq12D/D;;AAEA;EACE,+DAA+D;ACvsvDhE;ADysvDD;EACE,gEAAgE;AAClE;ACvsvDA;EGjsHQ,+DAA4B;AJ242DpC;AACA;EACE,gEAAgE;AC1svDjE;AD4svDD;EACE,+DAA+D;AC3svD/D;;AD8svDF;EAGE,gCAAgC;AC3svDhC;AD6svDF;EACE,+DAA+D;AC3svD/D;AD6svDF;EACE,gEAAgE;AAClE;AC1svDA;EC1tHG,+DAAY;AFu62Df;AC3svDC;ECztHE,gEAAY;AFu62Df;AC3svDC;ECztHE,+DAAY;AFu62Df;;AAEA;EACE,kEAAkE;AC3svDnE;AD6svDD;EACE,mEAAmE;AACrE;AC3svDA;EGluHQ,kEAA4B;AJg72DpC;AACA;EACE,mEAAmE;AC9svDpE;ADgtvDD;EACE,kEAAkE;AC/svDlE;;ADktvDF;EAGE,gCAAgC;AC/svDhC;ADitvDF;EACE,kEAAkE;AC/svDlE;ADitvDF;EACE,mEAAmE;AACrE;AC9svDA;EC5uHG,kEAA8D;AF672DjE;AC/svDC;EC3uHE,mEAAgE;AF672DnE;AC/svDC;EC3uHE,kEAA8D;AF672DjE;;AAEA;EACE,kEAAkE;AC/svDnE;ADitvDD;EACE,mEAAmE;AACrE;AC/svDA;EGnwHQ,kEAA4B;AJq92DpC;AACA;EACE,mEAAmE;ACltvDpE;ADotvDD;EACE,kEAAkE;ACntvDlE;;ADstvDF;EAGE,gCAAgC;ACntvDhC;ADqtvDF;EACE,kEAAkE;ACntvDlE;ADqtvDF;EACE,mEAAmE;AACrE;ACltvDA;EC9vHG,kEAA8D;AFm92DjE;ACntvDC;EC7vHE,mEAAgE;AFm92DnE;ACntvDC;EC7vHE,kEAA8D;AFm92DjE;;AAEA;EACE,kEAAkE;ACntvDnE;ADqtvDD;EACE,mEAAmE;AACrE;ACntvDA;EGpyHQ,kEAA4B;AJ0/2DpC;AACA;EACE,mEAAmE;ACttvDpE;ADwtvDD;EACE,kEAAkE;ACvtvDlE;;AD0tvDF;EAGE,gCAAgC;ACvtvDhC;ADytvDF;EACE,kEAAkE;ACvtvDlE;ADytvDF;EACE,mEAAmE;AACrE;ACttvDA;EChxHG,kEAA4D;AFy+2D/D;ACvtvDC;EC/wHE,mEAA8D;AFy+2DjE;ACvtvDC;EC/wHE,kEAA4D;AFy+2D/D;;AAEA;EACE,gEAAgE;ACvtvDjE;ADytvDD;EACE,iEAAiE;AACnE;ACvtvDA;EGr0HQ,gEAA4B;AJ+h3DpC;AACA;EACE,iEAAiE;AC1tvDlE;AD4tvDD;EACE,gEAAgE;AC3tvDhE;;AD8tvDF;EAGE,gCAAgC;AC3tvDhC;AD6tvDF;EACE,gEAAgE;AC3tvDhE;AD6tvDF;EACE,iEAAiE;AACnE;AC1tvDA;EC91HG,gEAAY;AF2j3Df;AC3tvDC;EC71HE,iEAAY;AF2j3Df;AC3tvDC;EC71HE,gEAAY;AF2j3Df;;AAEA;EACE,kEAAkE;AC3tvDnE;AD6tvDD;EACE,mEAAmE;AACrE;AC3tvDA;EGt2HQ,kEAA4B;AJok3DpC;AACA;EACE,mEAAmE;AC9tvDpE;ADguvDD;EACE,kEAAkE;AC/tvDlE;;ADkuvDF;EAGE,gCAAgC;AC/tvDhC;ADiuvDF;EACE,kEAAkE;AC/tvDlE;ADiuvDF;EACE,mEAAmE;AACrE;AC9tvDA;ECh3HG,kEAA8D;AFil3DjE;AC/tvDC;EC/2HE,mEAAgE;AFil3DnE;AC/tvDC;EC/2HE,kEAA8D;AFil3DjE;;AAEA;EACE,kEAAkE;AC/tvDnE;ADiuvDD;EACE,mEAAmE;AACrE;AC/tvDA;EGv4HQ,kEAA4B;AJym3DpC;AACA;EACE,mEAAmE;ACluvDpE;ADouvDD;EACE,kEAAkE;ACnuvDlE;;ADsuvDF;EAGE,gCAAgC;ACnuvDhC;ADquvDF;EACE,kEAAkE;ACnuvDlE;ADquvDF;EACE,mEAAmE;AACrE;ACluvDA;ECl4HG,kEAA8D;AFum3DjE;ACnuvDC;ECj4HE,mEAAgE;AFum3DnE;ACnuvDC;ECj4HE,kEAA8D;AFum3DjE;;AAEA;EACE,kEAAkE;ACnuvDnE;ADquvDD;EACE,mEAAmE;AACrE;ACnuvDA;EGx6HQ,kEAA4B;AJ8o3DpC;AACA;EACE,mEAAmE;ACtuvDpE;ADwuvDD;EACE,kEAAkE;ACvuvDlE;;AD0uvDF;EAGE,gCAAgC;ACvuvDhC;ADyuvDF;EACE,kEAAkE;ACvuvDlE;ADyuvDF;EACE,mEAAmE;AACrE;ACtuvDA;ECp5HG,kEAA4D;AF6n3D/D;ACvuvDC;ECn5HE,mEAA8D;AF6n3DjE;ACvuvDC;ECn5HE,kEAA4D;AF6n3D/D;;AAEA;EACE,gEAAgE;ACvuvDjE;ADyuvDD;EACE,iEAAiE;AACnE;ACvuvDA;EGz8HQ,gEAA4B;AJmr3DpC;AACA;EACE,iEAAiE;AC1uvDlE;AD4uvDD;EACE,gEAAgE;AC3uvDhE;;AD8uvDF;EAGE,gCAAgC;AC3uvDhC;AD6uvDF;EACE,gEAAgE;AC3uvDhE;AD6uvDF;EACE,iEAAiE;AACnE;AC1uvDA;ECl+HG,gEAAY;AF+s3Df;AC3uvDC;ECj+HE,iEAAY;AF+s3Df;AC3uvDC;ECj+HE,gEAAY;AF+s3Df;;AAEA;EACE,iEAAiE;AC3uvDlE;AD6uvDD;EACE,kEAAkE;AACpE;AC3uvDA;EG1+HQ,iEAA4B;AJwt3DpC;AACA;EACE,kEAAkE;AC9uvDnE;ADgvvDD;EACE,iEAAiE;AC/uvDjE;;ADkvvDF;EAGE,gCAAgC;AC/uvDhC;ADivvDF;EACE,iEAAiE;AC/uvDjE;ADivvDF;EACE,kEAAkE;AACpE;AC9uvDA;ECp/HG,iEAA8D;AFqu3DjE;AC/uvDC;ECn/HE,kEAAgE;AFqu3DnE;AC/uvDC;ECn/HE,iEAA8D;AFqu3DjE;;AAEA;EACE,iEAAiE;AC/uvDlE;ADivvDD;EACE,kEAAkE;AACpE;AC/uvDA;EG3gIQ,iEAA4B;AJ6v3DpC;AACA;EACE,kEAAkE;AClvvDnE;ADovvDD;EACE,iEAAiE;ACnvvDjE;;ADsvvDF;EAGE,gCAAgC;ACnvvDhC;ADqvvDF;EACE,iEAAiE;ACnvvDjE;ADqvvDF;EACE,kEAAkE;AACpE;AClvvDA;ECtgIG,iEAA8D;AF2v3DjE;ACnvvDC;ECrgIE,kEAAgE;AF2v3DnE;ACnvvDC;ECrgIE,iEAA8D;AF2v3DjE;;AAEA;EACE,iEAAiE;ACnvvDlE;ADqvvDD;EACE,kEAAkE;AACpE;ACnvvDA;EG5iIQ,iEAA4B;AJky3DpC;AACA;EACE,kEAAkE;ACtvvDnE;ADwvvDD;EACE,iEAAiE;ACvvvDjE;;AD0vvDF;EAGE,gCAAgC;ACvvvDhC;ADyvvDF;EACE,iEAAiE;ACvvvDjE;ADyvvDF;EACE,kEAAkE;AACpE;ACtvvDA;ECxhIG,iEAA4D;AFix3D/D;ACvvvDC;ECvhIE,kEAA8D;AFix3DjE;ACvvvDC;ECvhIE,iEAA4D;AFix3D/D;;AAEA;EACE,+DAA+D;ACvvvDhE;ADyvvDD;EACE,gEAAgE;AAClE;ACvvvDA;EG7kIQ,+DAA4B;AJu03DpC;AACA;EACE,gEAAgE;AC1vvDjE;AD4vvDD;EACE,+DAA+D;AC3vvD/D;;AD8vvDF;EAGE,gCAAgC;AC3vvDhC;AD6vvDF;EACE,+DAA+D;AC3vvD/D;AD6vvDF;EACE,gEAAgE;AAClE;AC1vvDA;ECtmIG,+DAAY;AFm23Df;AC3vvDC;ECrmIE,gEAAY;AFm23Df;AC3vvDC;ECrmIE,+DAAY;AFm23Df;;AAEA;EACE,iEAAiE;AC3vvDlE;AD6vvDD;EACE,kEAAkE;AACpE;AC3vvDA;EG9mIQ,iEAA4B;AJ423DpC;AACA;EACE,kEAAkE;AC9vvDnE;ADgwvDD;EACE,iEAAiE;AC/vvDjE;;ADkwvDF;EAGE,gCAAgC;AC/vvDhC;ADiwvDF;EACE,iEAAiE;AC/vvDjE;ADiwvDF;EACE,kEAAkE;AACpE;AC9vvDA;ECxnIG,iEAA8D;AFy33DjE;AC/vvDC;ECvnIE,kEAAgE;AFy33DnE;AC/vvDC;ECvnIE,iEAA8D;AFy33DjE;;AAEA;EACE,iEAAiE;AC/vvDlE;ADiwvDD;EACE,kEAAkE;AACpE;AC/vvDA;EG/oIQ,iEAA4B;AJi53DpC;AACA;EACE,kEAAkE;AClwvDnE;ADowvDD;EACE,iEAAiE;ACnwvDjE;;ADswvDF;EAGE,gCAAgC;ACnwvDhC;ADqwvDF;EACE,iEAAiE;ACnwvDjE;ADqwvDF;EACE,kEAAkE;AACpE;AClwvDA;EC1oIG,iEAA8D;AF+43DjE;ACnwvDC;ECzoIE,kEAAgE;AF+43DnE;ACnwvDC;ECzoIE,iEAA8D;AF+43DjE;;AAEA;EACE,iEAAiE;ACnwvDlE;ADqwvDD;EACE,kEAAkE;AACpE;ACnwvDA;EGhrIQ,iEAA4B;AJs73DpC;AACA;EACE,kEAAkE;ACtwvDnE;ADwwvDD;EACE,iEAAiE;ACvwvDjE;;AD0wvDF;EAGE,gCAAgC;ACvwvDhC;ADywvDF;EACE,iEAAiE;ACvwvDjE;ADywvDF;EACE,kEAAkE;AACpE;ACtwvDA;EC5pIG,iEAA4D;AFq63D/D;ACvwvDC;EC3pIE,kEAA8D;AFq63DjE;ACvwvDC;EC3pIE,iEAA4D;AFq63D/D;;AAEA;EACE,+DAA+D;ACvwvDhE;ADywvDD;EACE,gEAAgE;AAClE;ACvwvDA;EGjtIQ,+DAA4B;AJ293DpC;AACA;EACE,gEAAgE;AC1wvDjE;AD4wvDD;EACE,+DAA+D;AC3wvD/D;;AD8wvDF;EAGE,gCAAgC;AC3wvDhC;AD6wvDF;EACE,+DAA+D;AC3wvD/D;AD6wvDF;EACE,gEAAgE;AAClE;AC1wvDA;EC1uIG,+DAAY;AFu/3Df;AC3wvDC;ECzuIE,gEAAY;AFu/3Df;AC3wvDC;ECzuIE,+DAAY;AFu/3Df;;AAEA;EACE,iEAAiE;AC3wvDlE;AD6wvDD;EACE,kEAAkE;AACpE;AC3wvDA;EGlvIQ,iEAA4B;AJgg4DpC;AACA;EACE,kEAAkE;AC9wvDnE;ADgxvDD;EACE,iEAAiE;AC/wvDjE;;ADkxvDF;EAGE,gCAAgC;AC/wvDhC;ADixvDF;EACE,iEAAiE;AC/wvDjE;ADixvDF;EACE,kEAAkE;AACpE;AC9wvDA;EC5vIG,iEAA8D;AF6g4DjE;AC/wvDC;EC3vIE,kEAAgE;AF6g4DnE;AC/wvDC;EC3vIE,iEAA8D;AF6g4DjE;;AAEA;EACE,iEAAiE;AC/wvDlE;ADixvDD;EACE,kEAAkE;AACpE;AC/wvDA;EGnxIQ,iEAA4B;AJqi4DpC;AACA;EACE,kEAAkE;AClxvDnE;ADoxvDD;EACE,iEAAiE;ACnxvDjE;;ADsxvDF;EAGE,gCAAgC;ACnxvDhC;ADqxvDF;EACE,iEAAiE;ACnxvDjE;ADqxvDF;EACE,kEAAkE;AACpE;AClxvDA;EC9wIG,iEAA8D;AFmi4DjE;ACnxvDC;EC7wIE,kEAAgE;AFmi4DnE;ACnxvDC;EC7wIE,iEAA8D;AFmi4DjE;;AAEA;EACE,iEAAiE;ACnxvDlE;ADqxvDD;EACE,kEAAkE;AACpE;ACnxvDA;EGpzIQ,iEAA4B;AJ0k4DpC;AACA;EACE,kEAAkE;ACtxvDnE;ADwxvDD;EACE,iEAAiE;ACvxvDjE;;AD0xvDF;EAGE,gCAAgC;ACvxvDhC;ADyxvDF;EACE,iEAAiE;ACvxvDjE;ADyxvDF;EACE,kEAAkE;AACpE;ACtxvDA;EChyIG,iEAA4D;AFyj4D/D;ACvxvDC;EC/xIE,kEAA8D;AFyj4DjE;ACvxvDC;EC/xIE,iEAA4D;AFyj4D/D;;AAEA;EACE,+DAA+D;ACvxvDhE;ADyxvDD;EACE,gEAAgE;AAClE;ACvxvDA;EGr1IQ,+DAA4B;AJ+m4DpC;AACA;EACE,gEAAgE;AC1xvDjE;AD4xvDD;EACE,+DAA+D;AC3xvD/D;;AD8xvDF;EAGE,gCAAgC;AC3xvDhC;AD6xvDF;EACE,+DAA+D;AC3xvD/D;AD6xvDF;EACE,gEAAgE;AAClE;AC1xvDA;EC92IG,+DAAY;AF2o4Df;AC3xvDC;EC72IE,gEAAY;AF2o4Df;AC3xvDC;EC72IE,+DAAY;AF2o4Df;;AAEA;EACE,iEAAiE;AC3xvDlE;AD6xvDD;EACE,kEAAkE;AACpE;AC3xvDA;EGt3IQ,iEAA4B;AJop4DpC;AACA;EACE,kEAAkE;AC9xvDnE;ADgyvDD;EACE,iEAAiE;AC/xvDjE;;ADkyvDF;EAGE,gCAAgC;AC/xvDhC;ADiyvDF;EACE,iEAAiE;AC/xvDjE;ADiyvDF;EACE,kEAAkE;AACpE;AC9xvDA;ECh4IG,iEAA8D;AFiq4DjE;AC/xvDC;EC/3IE,kEAAgE;AFiq4DnE;AC/xvDC;EC/3IE,iEAA8D;AFiq4DjE;;AAEA;EACE,iEAAiE;AC/xvDlE;ADiyvDD;EACE,kEAAkE;AACpE;AC/xvDA;EGv5IQ,iEAA4B;AJyr4DpC;AACA;EACE,kEAAkE;AClyvDnE;ADoyvDD;EACE,iEAAiE;ACnyvDjE;;ADsyvDF;EAGE,gCAAgC;ACnyvDhC;ADqyvDF;EACE,iEAAiE;ACnyvDjE;ADqyvDF;EACE,kEAAkE;AACpE;AClyvDA;ECl5IG,iEAA8D;AFur4DjE;ACnyvDC;ECj5IE,kEAAgE;AFur4DnE;ACnyvDC;ECj5IE,iEAA8D;AFur4DjE;;AAEA;EACE,iEAAiE;ACnyvDlE;ADqyvDD;EACE,kEAAkE;AACpE;ACnyvDA;EGx7IQ,iEAA4B;AJ8t4DpC;AACA;EACE,kEAAkE;ACtyvDnE;ADwyvDD;EACE,iEAAiE;ACvyvDjE;;AD0yvDF;EAGE,gCAAgC;ACvyvDhC;ADyyvDF;EACE,iEAAiE;ACvyvDjE;ADyyvDF;EACE,kEAAkE;AACpE;ACtyvDA;ECp6IG,iEAA4D;AF6s4D/D;ACvyvDC;ECn6IE,kEAA8D;AF6s4DjE;ACvyvDC;ECn6IE,iEAA4D;AF6s4D/D;;AAEA;EACE,+DAA+D;ACvyvDhE;ADyyvDD;EACE,gEAAgE;AAClE;ACvyvDA;EGz9IQ,+DAA4B;AJmw4DpC;AACA;EACE,gEAAgE;AC1yvDjE;AD4yvDD;EACE,+DAA+D;AC3yvD/D;;AD8yvDF;EAGE,gCAAgC;AC3yvDhC;AD6yvDF;EACE,+DAA+D;AC3yvD/D;AD6yvDF;EACE,gEAAgE;AAClE;AC1yvDA;ECl/IG,+DAA8D;AF+x4DjE;AC3yvDC;ECj/IE,gEAAgE;AF+x4DnE;AC3yvDC;ECj/IE,+DAA8D;AF+x4DjE;;AAEA;EACE,+DAA+D;AC3yvDhE;AD6yvDD;EACE,gEAAgE;AAClE;AC3yvDA;EG1/IQ,+DAA4B;AJwy4DpC;AACA;EACE,gEAAgE;AC9yvDjE;ADgzvDD;EACE,+DAA+D;AC/yvD/D;;ADkzvDF;EAGE,gCAAgC;AC/yvDhC;ADizvDF;EACE,+DAA+D;AC/yvD/D;ADizvDF;EACE,gEAAgE;AAClE;AC9yvDA;ECpgJG,+DAA8D;AFqz4DjE;AC/yvDC;ECngJE,gEAAgE;AFqz4DnE;AC/yvDC;ECngJE,+DAA8D;AFqz4DjE;;AAEA;EACE,+DAA+D;AC/yvDhE;ADizvDD;EACE,gEAAgE;AAClE;AC/yvDA;EG3hJQ,+DAA4B;AJ604DpC;AACA;EACE,gEAAgE;AClzvDjE;ADozvDD;EACE,+DAA+D;ACnzvD/D;;ADszvDF;EAGE,gCAAgC;ACnzvDhC;ADqzvDF;EACE,+DAA+D;ACnzvD/D;ADqzvDF;EACE,gEAAgE;AAClE;AClzvDA;ECthJG,+DAA8D;AF204DjE;ACnzvDC;ECrhJE,gEAAgE;AF204DnE;ACnzvDC;ECrhJE,+DAA8D;AF204DjE;;AAEA;EACE,+DAA+D;ACnzvDhE;ADqzvDD;EACE,gEAAgE;AAClE;ACnzvDA;EG5jJQ,+DAA4B;AJk34DpC;AACA;EACE,gEAAgE;ACtzvDjE;ADwzvDD;EACE,+DAA+D;ACvzvD/D;;AD0zvDF;EAGE,gCAAgC;ACvzvDhC;ADyzvDF;EACE,+DAA+D;ACvzvD/D;ADyzvDF;EACE,gEAAgE;AAClE;ACtzvDA;ECxiJG,+DAA4D;AFi24D/D;ACvzvDC;ECviJE,gEAA8D;AFi24DjE;ACvzvDC;ECviJE,+DAA4D;AFi24D/D;;AAEA;EACE,6DAA6D;ACvzvD9D;ADyzvDD;EACE,8DAA8D;AAChE;ACvzvDA;EG7lJQ,6DAA4B;AJu54DpC;AACA;EACE,8DAA8D;AC1zvD/D;AD4zvDD;EACE,6DAA6D;AC3zvD7D;;AD8zvDF;EAGE,gCAAgC;AC3zvDhC;AD6zvDF;EACE,6DAA6D;AC3zvD7D;AD6zvDF;EACE,8DAA8D;AAChE;AC1zvDA;ECtnJG,6DAAY;AFm74Df;AC3zvDC;ECrnJE,8DAAY;AFm74Df;AC3zvDC;ECrnJE,6DAAY;AFm74Df;;AAEA;EACE,+DAA+D;AC3zvDhE;AD6zvDD;EACE,gEAAgE;AAClE;AC3zvDA;EG9nJQ,+DAA4B;AJ474DpC;AACA;EACE,gEAAgE;AC9zvDjE;ADg0vDD;EACE,+DAA+D;AC/zvD/D;;ADk0vDF;EAGE,gCAAgC;AC/zvDhC;ADi0vDF;EACE,+DAA+D;AC/zvD/D;ADi0vDF;EACE,gEAAgE;AAClE;AC9zvDA;ECxoJG,+DAA8D;AFy84DjE;AC/zvDC;ECvoJE,gEAAgE;AFy84DnE;AC/zvDC;ECvoJE,+DAA8D;AFy84DjE;;AAEA;EACE,+DAA+D;AC/zvDhE;ADi0vDD;EACE,gEAAgE;AAClE;AC/zvDA;EG/pJQ,+DAA4B;AJi+4DpC;AACA;EACE,gEAAgE;ACl0vDjE;ADo0vDD;EACE,+DAA+D;ACn0vD/D;;ADs0vDF;EAGE,gCAAgC;ACn0vDhC;ADq0vDF;EACE,+DAA+D;ACn0vD/D;ADq0vDF;EACE,gEAAgE;AAClE;ACl0vDA;EC1pJG,+DAA8D;AF+94DjE;ACn0vDC;ECzpJE,gEAAgE;AF+94DnE;ACn0vDC;ECzpJE,+DAA8D;AF+94DjE;;AAEA;EACE,+DAA+D;ACn0vDhE;ADq0vDD;EACE,gEAAgE;AAClE;ACn0vDA;EGhsJQ,+DAA4B;AJsg5DpC;AACA;EACE,gEAAgE;ACt0vDjE;ADw0vDD;EACE,+DAA+D;ACv0vD/D;;AD00vDF;EAGE,gCAAgC;ACv0vDhC;ADy0vDF;EACE,+DAA+D;ACv0vD/D;ADy0vDF;EACE,gEAAgE;AAClE;ACt0vDA;EC5qJG,+DAA4D;AFq/4D/D;ACv0vDC;EC3qJE,gEAA8D;AFq/4DjE;ACv0vDC;EC3qJE,+DAA4D;AFq/4D/D;;AAEA;EACE,6DAA6D;ACv0vD9D;ADy0vDD;EACE,8DAA8D;AAChE;ACv0vDA;EGjuJQ,6DAA4B;AJ2i5DpC;AACA;EACE,8DAA8D;AC10vD/D;AD40vDD;EACE,6DAA6D;AC30vD7D;;AD80vDF;EAGE,gCAAgC;AC30vDhC;AD60vDF;EACE,6DAA6D;AC30vD7D;AD60vDF;EACE,8DAA8D;AAChE;AC10vDA;EC1vJG,6DAAY;AFuk5Df;AC30vDC;ECzvJE,8DAAY;AFuk5Df;AC30vDC;ECzvJE,6DAAY;AFuk5Df;;AAEA;EACE,kEAAkE;AC30vDnE;AD60vDD;EACE,mEAAmE;AACrE;AC30vDA;EGlwJQ,kEAA4B;AJgl5DpC;AACA;EACE,mEAAmE;AC90vDpE;ADg1vDD;EACE,kEAAkE;AC/0vDlE;;ADk1vDF;EAGE,gCAAgC;AC/0vDhC;ADi1vDF;EACE,kEAAkE;AC/0vDlE;ADi1vDF;EACE,mEAAmE;AACrE;AC90vDA;EC5wJG,kEAA8D;AF6l5DjE;AC/0vDC;EC3wJE,mEAAgE;AF6l5DnE;AC/0vDC;EC3wJE,kEAA8D;AF6l5DjE;;AAEA;EACE,kEAAkE;AC/0vDnE;ADi1vDD;EACE,mEAAmE;AACrE;AC/0vDA;EGnyJQ,kEAA4B;AJqn5DpC;AACA;EACE,mEAAmE;ACl1vDpE;ADo1vDD;EACE,kEAAkE;ACn1vDlE;;ADs1vDF;EAGE,gCAAgC;ACn1vDhC;ADq1vDF;EACE,kEAAkE;ACn1vDlE;ADq1vDF;EACE,mEAAmE;AACrE;ACl1vDA;EC9xJG,kEAA8D;AFmn5DjE;ACn1vDC;EC7xJE,mEAAgE;AFmn5DnE;ACn1vDC;EC7xJE,kEAA8D;AFmn5DjE;;AAEA;EACE,kEAAkE;ACn1vDnE;ADq1vDD;EACE,mEAAmE;AACrE;ACn1vDA;EGp0JQ,kEAA4B;AJ0p5DpC;AACA;EACE,mEAAmE;ACt1vDpE;ADw1vDD;EACE,kEAAkE;ACv1vDlE;;AD01vDF;EAGE,gCAAgC;ACv1vDhC;ADy1vDF;EACE,kEAAkE;ACv1vDlE;ADy1vDF;EACE,mEAAmE;AACrE;ACt1vDA;EChzJG,kEAA4D;AFyo5D/D;ACv1vDC;EC/yJE,mEAA8D;AFyo5DjE;ACv1vDC;EC/yJE,kEAA4D;AFyo5D/D;;AAEA;EACE,gEAAgE;ACv1vDjE;ADy1vDD;EACE,iEAAiE;AACnE;ACv1vDA;EGr2JQ,gEAA4B;AJ+r5DpC;AACA;EACE,iEAAiE;AC11vDlE;AD41vDD;EACE,gEAAgE;AC31vDhE;;AD81vDF;EAGE,gCAAgC;AC31vDhC;AD61vDF;EACE,gEAAgE;AC31vDhE;AD61vDF;EACE,iEAAiE;AACnE;AC11vDA;EC93JG,gEAAY;AF2t5Df;AC31vDC;EC73JE,iEAAY;AF2t5Df;AC31vDC;EC73JE,gEAAY;AF2t5Df;;AAEA;EACE,iEAAiE;AC31vDlE;AD61vDD;EACE,kEAAkE;AACpE;AC31vDA;EGt4JQ,iEAA4B;AJou5DpC;AACA;EACE,kEAAkE;AC91vDnE;ADg2vDD;EACE,iEAAiE;AC/1vDjE;;ADk2vDF;EAGE,gCAAgC;AC/1vDhC;ADi2vDF;EACE,iEAAiE;AC/1vDjE;ADi2vDF;EACE,kEAAkE;AACpE;AC91vDA;ECh5JG,iEAA8D;AFiv5DjE;AC/1vDC;EC/4JE,kEAAgE;AFiv5DnE;AC/1vDC;EC/4JE,iEAA8D;AFiv5DjE;;AAEA;EACE,iEAAiE;AC/1vDlE;ADi2vDD;EACE,kEAAkE;AACpE;AC/1vDA;EGv6JQ,iEAA4B;AJyw5DpC;AACA;EACE,kEAAkE;ACl2vDnE;ADo2vDD;EACE,iEAAiE;ACn2vDjE;;ADs2vDF;EAGE,gCAAgC;ACn2vDhC;ADq2vDF;EACE,iEAAiE;ACn2vDjE;ADq2vDF;EACE,kEAAkE;AACpE;ACl2vDA;ECl6JG,iEAA8D;AFuw5DjE;ACn2vDC;ECj6JE,kEAAgE;AFuw5DnE;ACn2vDC;ECj6JE,iEAA8D;AFuw5DjE;;AAEA;EACE,iEAAiE;ACn2vDlE;ADq2vDD;EACE,kEAAkE;AACpE;ACn2vDA;EGx8JQ,iEAA4B;AJ8y5DpC;AACA;EACE,kEAAkE;ACt2vDnE;ADw2vDD;EACE,iEAAiE;ACv2vDjE;;AD02vDF;EAGE,gCAAgC;ACv2vDhC;ADy2vDF;EACE,iEAAiE;ACv2vDjE;ADy2vDF;EACE,kEAAkE;AACpE;ACt2vDA;ECp7JG,iEAA4D;AF6x5D/D;ACv2vDC;ECn7JE,kEAA8D;AF6x5DjE;ACv2vDC;ECn7JE,iEAA4D;AF6x5D/D;;AAEA;EACE,+DAA+D;ACv2vDhE;ADy2vDD;EACE,gEAAgE;AAClE;ACv2vDA;EGz+JQ,+DAA4B;AJm15DpC;AACA;EACE,gEAAgE;AC12vDjE;AD42vDD;EACE,+DAA+D;AC32vD/D;;AD82vDF;EAGE,gCAAgC;AC32vDhC;AD62vDF;EACE,+DAA+D;AC32vD/D;AD62vDF;EACE,gEAAgE;AAClE;AC12vDA;EClgKG,+DAAY;AF+25Df;AC32vDC;ECjgKE,gEAAY;AF+25Df;AC32vDC;ECjgKE,+DAAY;AF+25Df;;AAEA;EACE,kEAAkE;AC32vDnE;AD62vDD;EACE,mEAAmE;AACrE;AC32vDA;EG1gKQ,kEAA4B;AJw35DpC;AACA;EACE,mEAAmE;AC92vDpE;ADg3vDD;EACE,kEAAkE;AC/2vDlE;;ADk3vDF;EAGE,gCAAgC;AC/2vDhC;ADi3vDF;EACE,kEAAkE;AC/2vDlE;ADi3vDF;EACE,mEAAmE;AACrE;AC92vDA;ECphKG,kEAA8D;AFq45DjE;AC/2vDC;ECnhKE,mEAAgE;AFq45DnE;AC/2vDC;ECnhKE,kEAA8D;AFq45DjE;;AAEA;EACE,kEAAkE;AC/2vDnE;ADi3vDD;EACE,mEAAmE;AACrE;AC/2vDA;EG3iKQ,kEAA4B;AJ655DpC;AACA;EACE,mEAAmE;ACl3vDpE;ADo3vDD;EACE,kEAAkE;ACn3vDlE;;ADs3vDF;EAGE,gCAAgC;ACn3vDhC;ADq3vDF;EACE,kEAAkE;ACn3vDlE;ADq3vDF;EACE,mEAAmE;AACrE;ACl3vDA;ECtiKG,kEAA8D;AF255DjE;ACn3vDC;ECriKE,mEAAgE;AF255DnE;ACn3vDC;ECriKE,kEAA8D;AF255DjE;;AAEA;EACE,kEAAkE;ACn3vDnE;ADq3vDD;EACE,mEAAmE;AACrE;ACn3vDA;EG5kKQ,kEAA4B;AJk85DpC;AACA;EACE,mEAAmE;ACt3vDpE;ADw3vDD;EACE,kEAAkE;ACv3vDlE;;AD03vDF;EAGE,gCAAgC;ACv3vDhC;ADy3vDF;EACE,kEAAkE;ACv3vDlE;ADy3vDF;EACE,mEAAmE;AACrE;ACt3vDA;ECxjKG,kEAA4D;AFi75D/D;ACv3vDC;ECvjKE,mEAA8D;AFi75DjE;ACv3vDC;ECvjKE,kEAA4D;AFi75D/D;;AAEA;EACE,gEAAgE;ACv3vDjE;ADy3vDD;EACE,iEAAiE;AACnE;ACv3vDA;EG7mKQ,gEAA4B;AJu+5DpC;AACA;EACE,iEAAiE;AC13vDlE;AD43vDD;EACE,gEAAgE;AC33vDhE;;AD83vDF;EAGE,gCAAgC;AC33vDhC;AD63vDF;EACE,gEAAgE;AC33vDhE;AD63vDF;EACE,iEAAiE;AACnE;AC13vDA;ECtoKG,gEAAY;AFmg6Df;AC33vDC;ECroKE,iEAAY;AFmg6Df;AC33vDC;ECroKE,gEAAY;AFmg6Df;;AAEA;EACE,kEAAkE;AC33vDnE;AD63vDD;EACE,mEAAmE;AACrE;AC33vDA;EG9oKQ,kEAA4B;AJ4g6DpC;AACA;EACE,mEAAmE;AC93vDpE;ADg4vDD;EACE,kEAAkE;AC/3vDlE;;ADk4vDF;EAGE,gCAAgC;AC/3vDhC;ADi4vDF;EACE,kEAAkE;AC/3vDlE;ADi4vDF;EACE,mEAAmE;AACrE;AC93vDA;ECxpKG,kEAA8D;AFyh6DjE;AC/3vDC;ECvpKE,mEAAgE;AFyh6DnE;AC/3vDC;ECvpKE,kEAA8D;AFyh6DjE;;AAEA;EACE,kEAAkE;AC/3vDnE;ADi4vDD;EACE,mEAAmE;AACrE;AC/3vDA;EG/qKQ,kEAA4B;AJij6DpC;AACA;EACE,mEAAmE;ACl4vDpE;ADo4vDD;EACE,kEAAkE;ACn4vDlE;;ADs4vDF;EAGE,gCAAgC;ACn4vDhC;ADq4vDF;EACE,kEAAkE;ACn4vDlE;ADq4vDF;EACE,mEAAmE;AACrE;ACl4vDA;EC1qKG,kEAA8D;AF+i6DjE;ACn4vDC;ECzqKE,mEAAgE;AF+i6DnE;ACn4vDC;ECzqKE,kEAA8D;AF+i6DjE;;AAEA;EACE,kEAAkE;ACn4vDnE;ADq4vDD;EACE,mEAAmE;AACrE;ACn4vDA;EGhtKQ,kEAA4B;AJsl6DpC;AACA;EACE,mEAAmE;ACt4vDpE;ADw4vDD;EACE,kEAAkE;ACv4vDlE;;AD04vDF;EAGE,gCAAgC;ACv4vDhC;ADy4vDF;EACE,kEAAkE;ACv4vDlE;ADy4vDF;EACE,mEAAmE;AACrE;ACt4vDA;EC5rKG,kEAA4D;AFqk6D/D;ACv4vDC;EC3rKE,mEAA8D;AFqk6DjE;ACv4vDC;EC3rKE,kEAA4D;AFqk6D/D;;AAEA;EACE,gEAAgE;ACv4vDjE;ADy4vDD;EACE,iEAAiE;AACnE;ACv4vDA;EGjvKQ,gEAA4B;AJ2n6DpC;AACA;EACE,iEAAiE;AC14vDlE;AD44vDD;EACE,gEAAgE;AC34vDhE;;AD84vDF;EAGE,gCAAgC;AC34vDhC;AD64vDF;EACE,gEAAgE;AC34vDhE;AD64vDF;EACE,iEAAiE;AACnE;AC14vDA;EC1wKG,gEAAY;AFup6Df;AC34vDC;ECzwKE,iEAAY;AFup6Df;AC34vDC;ECzwKE,gEAAY;AFup6Df;;AAEA;EACE,kEAAkE;AC34vDnE;AD64vDD;EACE,mEAAmE;AACrE;AC34vDA;EGlxKQ,kEAA4B;AJgq6DpC;AACA;EACE,mEAAmE;AC94vDpE;ADg5vDD;EACE,kEAAkE;AC/4vDlE;;ADk5vDF;EAGE,gCAAgC;AC/4vDhC;ADi5vDF;EACE,kEAAkE;AC/4vDlE;ADi5vDF;EACE,mEAAmE;AACrE;AC94vDA;EC5xKG,kEAA8D;AF6q6DjE;AC/4vDC;EC3xKE,mEAAgE;AF6q6DnE;AC/4vDC;EC3xKE,kEAA8D;AF6q6DjE;;AAEA;EACE,kEAAkE;AC/4vDnE;ADi5vDD;EACE,mEAAmE;AACrE;AC/4vDA;EGnzKQ,kEAA4B;AJqs6DpC;AACA;EACE,mEAAmE;ACl5vDpE;ADo5vDD;EACE,kEAAkE;ACn5vDlE;;ADs5vDF;EAGE,gCAAgC;ACn5vDhC;ADq5vDF;EACE,kEAAkE;ACn5vDlE;ADq5vDF;EACE,mEAAmE;AACrE;ACl5vDA;EC9yKG,kEAA8D;AFms6DjE;ACn5vDC;EC7yKE,mEAAgE;AFms6DnE;ACn5vDC;EC7yKE,kEAA8D;AFms6DjE;;AAEA;EACE,kEAAkE;ACn5vDnE;ADq5vDD;EACE,mEAAmE;AACrE;ACn5vDA;EGp1KQ,kEAA4B;AJ0u6DpC;AACA;EACE,mEAAmE;ACt5vDpE;ADw5vDD;EACE,kEAAkE;ACv5vDlE;;AD05vDF;EAGE,gCAAgC;ACv5vDhC;ADy5vDF;EACE,kEAAkE;ACv5vDlE;ADy5vDF;EACE,mEAAmE;AACrE;ACt5vDA;ECh0KG,kEAA4D;AFyt6D/D;ACv5vDC;EC/zKE,mEAA8D;AFyt6DjE;ACv5vDC;EC/zKE,kEAA4D;AFyt6D/D;;AAEA;EACE,gEAAgE;ACv5vDjE;ADy5vDD;EACE,iEAAiE;AACnE;ACv5vDA;EGr3KQ,gEAA4B;AJ+w6DpC;AACA;EACE,iEAAiE;AC15vDlE;AD45vDD;EACE,gEAAgE;AC35vDhE;;AD85vDF;EAGE,gCAAgC;AC35vDhC;AD65vDF;EACE,gEAAgE;AC35vDhE;AD65vDF;EACE,iEAAiE;AACnE;AC15vDA;EC94KG,gEAAY;AF2y6Df;AC35vDC;EC74KE,iEAAY;AF2y6Df;AC35vDC;EC74KE,gEAAY;AF2y6Df;;AAEA;EACE,iEAAiE;AC35vDlE;AD65vDD;EACE,kEAAkE;AACpE;AC35vDA;EGt5KQ,iEAA4B;AJoz6DpC;AACA;EACE,kEAAkE;AC95vDnE;ADg6vDD;EACE,iEAAiE;AC/5vDjE;;ADk6vDF;EAGE,gCAAgC;AC/5vDhC;ADi6vDF;EACE,iEAAiE;AC/5vDjE;ADi6vDF;EACE,kEAAkE;AACpE;AC95vDA;ECh6KG,iEAA8D;AFi06DjE;AC/5vDC;EC/5KE,kEAAgE;AFi06DnE;AC/5vDC;EC/5KE,iEAA8D;AFi06DjE;;AAEA;EACE,iEAAiE;AC/5vDlE;ADi6vDD;EACE,kEAAkE;AACpE;AC/5vDA;EGv7KQ,iEAA4B;AJy16DpC;AACA;EACE,kEAAkE;ACl6vDnE;ADo6vDD;EACE,iEAAiE;ACn6vDjE;;ADs6vDF;EAGE,gCAAgC;ACn6vDhC;ADq6vDF;EACE,iEAAiE;ACn6vDjE;ADq6vDF;EACE,kEAAkE;AACpE;ACl6vDA;ECl7KG,iEAA8D;AFu16DjE;ACn6vDC;ECj7KE,kEAAgE;AFu16DnE;ACn6vDC;ECj7KE,iEAA8D;AFu16DjE;;AAEA;EACE,iEAAiE;ACn6vDlE;ADq6vDD;EACE,kEAAkE;AACpE;ACn6vDA;EGx9KQ,iEAA4B;AJ836DpC;AACA;EACE,kEAAkE;ACt6vDnE;ADw6vDD;EACE,iEAAiE;ACv6vDjE;;AD06vDF;EAGE,gCAAgC;ACv6vDhC;ADy6vDF;EACE,iEAAiE;ACv6vDjE;ADy6vDF;EACE,kEAAkE;AACpE;ACt6vDA;ECp8KG,iEAA4D;AF626D/D;ACv6vDC;ECn8KE,kEAA8D;AF626DjE;ACv6vDC;ECn8KE,iEAA4D;AF626D/D;;AAEA;EACE,+DAA+D;ACv6vDhE;ADy6vDD;EACE,gEAAgE;AAClE;ACv6vDA;EGz/KQ,+DAA4B;AJm66DpC;AACA;EACE,gEAAgE;AC16vDjE;AD46vDD;EACE,+DAA+D;AC36vD/D;;AD86vDF;EAGE,gCAAgC;AC36vDhC;AD66vDF;EACE,+DAA+D;AC36vD/D;AD66vDF;EACE,gEAAgE;AAClE;AC16vDA;EClhLG,+DAAY;AF+76Df;AC36vDC;ECjhLE,gEAAY;AF+76Df;AC36vDC;ECjhLE,+DAAY;AF+76Df;;AAEA;EACE,iEAAiE;AC36vDlE;AD66vDD;EACE,kEAAkE;AACpE;AC36vDA;EG1hLQ,iEAA4B;AJw86DpC;AACA;EACE,kEAAkE;AC96vDnE;ADg7vDD;EACE,iEAAiE;AC/6vDjE;;ADk7vDF;EAGE,gCAAgC;AC/6vDhC;ADi7vDF;EACE,iEAAiE;AC/6vDjE;ADi7vDF;EACE,kEAAkE;AACpE;AC96vDA;ECpiLG,iEAA8D;AFq96DjE;AC/6vDC;ECniLE,kEAAgE;AFq96DnE;AC/6vDC;ECniLE,iEAA8D;AFq96DjE;;AAEA;EACE,iEAAiE;AC/6vDlE;ADi7vDD;EACE,kEAAkE;AACpE;AC/6vDA;EG3jLQ,iEAA4B;AJ6+6DpC;AACA;EACE,kEAAkE;ACl7vDnE;ADo7vDD;EACE,iEAAiE;ACn7vDjE;;ADs7vDF;EAGE,gCAAgC;ACn7vDhC;ADq7vDF;EACE,iEAAiE;ACn7vDjE;ADq7vDF;EACE,kEAAkE;AACpE;ACl7vDA;ECtjLG,iEAA8D;AF2+6DjE;ACn7vDC;ECrjLE,kEAAgE;AF2+6DnE;ACn7vDC;ECrjLE,iEAA8D;AF2+6DjE;;AAEA;EACE,iEAAiE;ACn7vDlE;ADq7vDD;EACE,kEAAkE;AACpE;ACn7vDA;EG5lLQ,iEAA4B;AJkh7DpC;AACA;EACE,kEAAkE;ACt7vDnE;ADw7vDD;EACE,iEAAiE;ACv7vDjE;;AD07vDF;EAGE,gCAAgC;ACv7vDhC;ADy7vDF;EACE,iEAAiE;ACv7vDjE;ADy7vDF;EACE,kEAAkE;AACpE;ACt7vDA;ECxkLG,iEAA4D;AFig7D/D;ACv7vDC;ECvkLE,kEAA8D;AFig7DjE;ACv7vDC;ECvkLE,iEAA4D;AFig7D/D;;AAEA;EACE,+DAA+D;ACv7vDhE;ADy7vDD;EACE,gEAAgE;AAClE;ACv7vDA;EG7nLQ,+DAA4B;AJuj7DpC;AACA;EACE,gEAAgE;AC17vDjE;AD47vDD;EACE,+DAA+D;AC37vD/D;;AD87vDF;EAGE,gCAAgC;AC37vDhC;AD67vDF;EACE,+DAA+D;AC37vD/D;AD67vDF;EACE,gEAAgE;AAClE;AC17vDA;ECtpLG,+DAAY;AFml7Df;AC37vDC;ECrpLE,gEAAY;AFml7Df;AC37vDC;ECrpLE,+DAAY;AFml7Df;;AAEA;EACE,kEAAkE;AC37vDnE;AD67vDD;EACE,mEAAmE;AACrE;AC37vDA;EG9pLQ,kEAA4B;AJ4l7DpC;AACA;EACE,mEAAmE;AC97vDpE;ADg8vDD;EACE,kEAAkE;AC/7vDlE;;ADk8vDF;EAGE,gCAAgC;AC/7vDhC;ADi8vDF;EACE,kEAAkE;AC/7vDlE;ADi8vDF;EACE,mEAAmE;AACrE;AC97vDA;ECxqLG,kEAA8D;AFym7DjE;AC/7vDC;ECvqLE,mEAAgE;AFym7DnE;AC/7vDC;ECvqLE,kEAA8D;AFym7DjE;;AAEA;EACE,kEAAkE;AC/7vDnE;ADi8vDD;EACE,mEAAmE;AACrE;AC/7vDA;EG/rLQ,kEAA4B;AJio7DpC;AACA;EACE,mEAAmE;ACl8vDpE;ADo8vDD;EACE,kEAAkE;ACn8vDlE;;ADs8vDF;EAGE,gCAAgC;ACn8vDhC;ADq8vDF;EACE,kEAAkE;ACn8vDlE;ADq8vDF;EACE,mEAAmE;AACrE;ACl8vDA;EC1rLG,kEAA8D;AF+n7DjE;ACn8vDC;ECzrLE,mEAAgE;AF+n7DnE;ACn8vDC;ECzrLE,kEAA8D;AF+n7DjE;;AAEA;EACE,kEAAkE;ACn8vDnE;ADq8vDD;EACE,mEAAmE;AACrE;ACn8vDA;EGhuLQ,kEAA4B;AJsq7DpC;AACA;EACE,mEAAmE;ACt8vDpE;ADw8vDD;EACE,kEAAkE;ACv8vDlE;;AD08vDF;EAGE,gCAAgC;ACv8vDhC;ADy8vDF;EACE,kEAAkE;ACv8vDlE;ADy8vDF;EACE,mEAAmE;AACrE;ACt8vDA;EC5sLG,kEAA4D;AFqp7D/D;ACv8vDC;EC3sLE,mEAA8D;AFqp7DjE;ACv8vDC;EC3sLE,kEAA4D;AFqp7D/D;;AAEA;EACE,gEAAgE;ACv8vDjE;ADy8vDD;EACE,iEAAiE;AACnE;ACv8vDA;EGjwLQ,gEAA4B;AJ2s7DpC;AACA;EACE,iEAAiE;AC18vDlE;AD48vDD;EACE,gEAAgE;AC38vDhE;;AD88vDF;EAGE,gCAAgC;AC38vDhC;AD68vDF;EACE,gEAAgE;AC38vDhE;AD68vDF;EACE,iEAAiE;AACnE;AC18vDA;EC1xLG,gEAAY;AFuu7Df;AC38vDC;ECzxLE,iEAAY;AFuu7Df;AC38vDC;ECzxLE,gEAAY;AFuu7Df;;AAEA;EACE,kEAAkE;AC38vDnE;AD68vDD;EACE,mEAAmE;AACrE;AC38vDA;EGlyLQ,kEAA4B;AJgv7DpC;AACA;EACE,mEAAmE;AC98vDpE;ADg9vDD;EACE,kEAAkE;AC/8vDlE;;ADk9vDF;EAGE,gCAAgC;AC/8vDhC;ADi9vDF;EACE,kEAAkE;AC/8vDlE;ADi9vDF;EACE,mEAAmE;AACrE;AC98vDA;EC5yLG,kEAA8D;AF6v7DjE;AC/8vDC;EC3yLE,mEAAgE;AF6v7DnE;AC/8vDC;EC3yLE,kEAA8D;AF6v7DjE;;AAEA;EACE,kEAAkE;AC/8vDnE;ADi9vDD;EACE,mEAAmE;AACrE;AC/8vDA;EGn0LQ,kEAA4B;AJqx7DpC;AACA;EACE,mEAAmE;ACl9vDpE;ADo9vDD;EACE,kEAAkE;ACn9vDlE;;ADs9vDF;EAGE,gCAAgC;ACn9vDhC;ADq9vDF;EACE,kEAAkE;ACn9vDlE;ADq9vDF;EACE,mEAAmE;AACrE;ACl9vDA;EC9zLG,kEAA8D;AFmx7DjE;ACn9vDC;EC7zLE,mEAAgE;AFmx7DnE;ACn9vDC;EC7zLE,kEAA8D;AFmx7DjE;;AAEA;EACE,kEAAkE;ACn9vDnE;ADq9vDD;EACE,mEAAmE;AACrE;ACn9vDA;EGp2LQ,kEAA4B;AJ0z7DpC;AACA;EACE,mEAAmE;ACt9vDpE;ADw9vDD;EACE,kEAAkE;ACv9vDlE;;AD09vDF;EAGE,gCAAgC;ACv9vDhC;ADy9vDF;EACE,kEAAkE;ACv9vDlE;ADy9vDF;EACE,mEAAmE;AACrE;ACt9vDA;ECh1LG,kEAA4D;AFyy7D/D;ACv9vDC;EC/0LE,mEAA8D;AFyy7DjE;ACv9vDC;EC/0LE,kEAA4D;AFyy7D/D;;AAEA;EACE,gEAAgE;ACv9vDjE;ADy9vDD;EACE,iEAAiE;AACnE;ACv9vDA;EGr4LQ,gEAA4B;AJ+17DpC;AACA;EACE,iEAAiE;AC19vDlE;AD49vDD;EACE,gEAAgE;AC39vDhE;;AD89vDF;EAGE,gCAAgC;AC39vDhC;AD69vDF;EACE,gEAAgE;AC39vDhE;AD69vDF;EACE,iEAAiE;AACnE;AC19vDA;EC95LG,gEAAY;AF237Df;AC39vDC;EC75LE,iEAAY;AF237Df;AC39vDC;EC75LE,gEAAY;AF237Df;;AAEA;EACE,iEAAiE;AC39vDlE;AD69vDD;EACE,kEAAkE;AACpE;AC39vDA;EGt6LQ,iEAA4B;AJo47DpC;AACA;EACE,kEAAkE;AC99vDnE;ADg+vDD;EACE,iEAAiE;AC/9vDjE;;ADk+vDF;EAGE,gCAAgC;AC/9vDhC;ADi+vDF;EACE,iEAAiE;AC/9vDjE;ADi+vDF;EACE,kEAAkE;AACpE;AC99vDA;ECh7LG,iEAA8D;AFi57DjE;AC/9vDC;EC/6LE,kEAAgE;AFi57DnE;AC/9vDC;EC/6LE,iEAA8D;AFi57DjE;;AAEA;EACE,iEAAiE;AC/9vDlE;ADi+vDD;EACE,kEAAkE;AACpE;AC/9vDA;EGv8LQ,iEAA4B;AJy67DpC;AACA;EACE,kEAAkE;ACl+vDnE;ADo+vDD;EACE,iEAAiE;ACn+vDjE;;ADs+vDF;EAGE,gCAAgC;ACn+vDhC;ADq+vDF;EACE,iEAAiE;ACn+vDjE;ADq+vDF;EACE,kEAAkE;AACpE;ACl+vDA;ECl8LG,iEAA8D;AFu67DjE;ACn+vDC;ECj8LE,kEAAgE;AFu67DnE;ACn+vDC;ECj8LE,iEAA8D;AFu67DjE;;AAEA;EACE,iEAAiE;ACn+vDlE;ADq+vDD;EACE,kEAAkE;AACpE;ACn+vDA;EGx+LQ,iEAA4B;AJ887DpC;AACA;EACE,kEAAkE;ACt+vDnE;ADw+vDD;EACE,iEAAiE;ACv+vDjE;;AD0+vDF;EAGE,gCAAgC;ACv+vDhC;ADy+vDF;EACE,iEAAiE;ACv+vDjE;ADy+vDF;EACE,kEAAkE;AACpE;ACt+vDA;ECp9LG,iEAA4D;AF677D/D;ACv+vDC;ECn9LE,kEAA8D;AF677DjE;ACv+vDC;ECn9LE,iEAA4D;AF677D/D;;AAEA;EACE,+DAA+D;ACv+vDhE;ADy+vDD;EACE,gEAAgE;AAClE;ACv+vDA;EGzgMQ,+DAA4B;AJm/7DpC;AACA;EACE,gEAAgE;AC1+vDjE;AD4+vDD;EACE,+DAA+D;AC3+vD/D;;AD8+vDF;EAGE,gCAAgC;AC3+vDhC;AD6+vDF;EACE,+DAA+D;AC3+vD/D;AD6+vDF;EACE,gEAAgE;AAClE;AC1+vDA;ECliMG,+DAAY;AF+g8Df;AC3+vDC;ECjiME,gEAAY;AF+g8Df;AC3+vDC;ECjiME,+DAAY;AF+g8Df;;AAEA;EACE,iEAAiE;AC3+vDlE;AD6+vDD;EACE,kEAAkE;AACpE;AC3+vDA;EG1iMQ,iEAA4B;AJwh8DpC;AACA;EACE,kEAAkE;AC9+vDnE;ADg/vDD;EACE,iEAAiE;AC/+vDjE;;ADk/vDF;EAGE,gCAAgC;AC/+vDhC;ADi/vDF;EACE,iEAAiE;AC/+vDjE;ADi/vDF;EACE,kEAAkE;AACpE;AC9+vDA;ECpjMG,iEAA8D;AFqi8DjE;AC/+vDC;ECnjME,kEAAgE;AFqi8DnE;AC/+vDC;ECnjME,iEAA8D;AFqi8DjE;;AAEA;EACE,iEAAiE;AC/+vDlE;ADi/vDD;EACE,kEAAkE;AACpE;AC/+vDA;EG3kMQ,iEAA4B;AJ6j8DpC;AACA;EACE,kEAAkE;ACl/vDnE;ADo/vDD;EACE,iEAAiE;ACn/vDjE;;ADs/vDF;EAGE,gCAAgC;ACn/vDhC;ADq/vDF;EACE,iEAAiE;ACn/vDjE;ADq/vDF;EACE,kEAAkE;AACpE;ACl/vDA;ECtkMG,iEAA8D;AF2j8DjE;ACn/vDC;ECrkME,kEAAgE;AF2j8DnE;ACn/vDC;ECrkME,iEAA8D;AF2j8DjE;;AAEA;EACE,iEAAiE;ACn/vDlE;ADq/vDD;EACE,kEAAkE;AACpE;ACn/vDA;EG5mMQ,iEAA4B;AJkm8DpC;AACA;EACE,kEAAkE;ACt/vDnE;ADw/vDD;EACE,iEAAiE;ACv/vDjE;;AD0/vDF;EAGE,gCAAgC;ACv/vDhC;ADy/vDF;EACE,iEAAiE;ACv/vDjE;ADy/vDF;EACE,kEAAkE;AACpE;ACt/vDA;ECxlMG,iEAA4D;AFil8D/D;ACv/vDC;ECvlME,kEAA8D;AFil8DjE;ACv/vDC;ECvlME,iEAA4D;AFil8D/D;;AAEA;EACE,+DAA+D;ACv/vDhE;ADy/vDD;EACE,gEAAgE;AAClE;ACv/vDA;EG7oMQ,+DAA4B;AJuo8DpC;AACA;EACE,gEAAgE;AC1/vDjE;AD4/vDD;EACE,+DAA+D;AC3/vD/D;;AD8/vDF;EAGE,gCAAgC;AC3/vDhC;AD6/vDF;EACE,+DAA+D;AC3/vD/D;AD6/vDF;EACE,gEAAgE;AAClE;AC1/vDA;ECtqMG,+DAAY;AFmq8Df;AC3/vDC;ECrqME,gEAAY;AFmq8Df;AC3/vDC;ECrqME,+DAAY;AFmq8Df;;AAEA;EACE,gEAAgE;AC3/vDjE;AD6/vDD;EACE,iEAAiE;AACnE;AC3/vDA;EG9qMQ,gEAA4B;AJ4q8DpC;AACA;EACE,iEAAiE;AC9/vDlE;ADggwDD;EACE,gEAAgE;AC//vDhE;;ADkgwDF;EAGE,gCAAgC;AC//vDhC;ADigwDF;EACE,gEAAgE;AC//vDhE;ADigwDF;EACE,iEAAiE;AACnE;AC9/vDA;ECxrMG,gEAA8D;AFyr8DjE;AC//vDC;ECvrME,iEAAgE;AFyr8DnE;AC//vDC;ECvrME,gEAA8D;AFyr8DjE;;AAEA;EACE,gEAAgE;AC//vDjE;ADigwDD;EACE,iEAAiE;AACnE;AC//vDA;EG/sMQ,gEAA4B;AJit8DpC;AACA;EACE,iEAAiE;AClgwDlE;ADogwDD;EACE,gEAAgE;ACngwDhE;;ADsgwDF;EAGE,gCAAgC;ACngwDhC;ADqgwDF;EACE,gEAAgE;ACngwDhE;ADqgwDF;EACE,iEAAiE;AACnE;AClgwDA;EC1sMG,gEAA8D;AF+s8DjE;ACngwDC;ECzsME,iEAAgE;AF+s8DnE;ACngwDC;ECzsME,gEAA8D;AF+s8DjE;;AAEA;EACE,gEAAgE;ACngwDjE;ADqgwDD;EACE,iEAAiE;AACnE;ACngwDA;EGhvMQ,gEAA4B;AJsv8DpC;AACA;EACE,iEAAiE;ACtgwDlE;ADwgwDD;EACE,gEAAgE;ACvgwDhE;;AD0gwDF;EAGE,gCAAgC;ACvgwDhC;ADygwDF;EACE,gEAAgE;ACvgwDhE;ADygwDF;EACE,iEAAiE;AACnE;ACtgwDA;EC5tMG,gEAA4D;AFqu8D/D;ACvgwDC;EC3tME,iEAA8D;AFqu8DjE;ACvgwDC;EC3tME,gEAA4D;AFqu8D/D;;AAEA;EACE,8DAA8D;ACvgwD/D;ADygwDD;EACE,+DAA+D;AACjE;ACvgwDA;EGjxMQ,8DAA4B;AJ2x8DpC;AACA;EACE,+DAA+D;AC1gwDhE;AD4gwDD;EACE,8DAA8D;AC3gwD9D;;AD8gwDF;EAGE,gCAAgC;AC3gwDhC;AD6gwDF;EACE,8DAA8D;AC3gwD9D;AD6gwDF;EACE,+DAA+D;AACjE;AC1gwDA;EC1yMG,8DAAY;AFuz8Df;AC3gwDC;ECzyME,+DAAY;AFuz8Df;AC3gwDC;ECzyME,8DAAY;AFuz8Df;;AAEA;EACE,iEAAiE;AC3gwDlE;AD6gwDD;EACE,kEAAkE;AACpE;AC3gwDA;EGlzMQ,iEAA4B;AJg08DpC;AACA;EACE,kEAAkE;AC9gwDnE;ADghwDD;EACE,iEAAiE;AC/gwDjE;;ADkhwDF;EAGE,gCAAgC;AC/gwDhC;ADihwDF;EACE,iEAAiE;AC/gwDjE;ADihwDF;EACE,kEAAkE;AACpE;AC9gwDA;EC5zMG,iEAA8D;AF608DjE;AC/gwDC;EC3zME,kEAAgE;AF608DnE;AC/gwDC;EC3zME,iEAA8D;AF608DjE;;AAEA;EACE,iEAAiE;AC/gwDlE;ADihwDD;EACE,kEAAkE;AACpE;AC/gwDA;EGn1MQ,iEAA4B;AJq28DpC;AACA;EACE,kEAAkE;AClhwDnE;ADohwDD;EACE,iEAAiE;ACnhwDjE;;ADshwDF;EAGE,gCAAgC;ACnhwDhC;ADqhwDF;EACE,iEAAiE;ACnhwDjE;ADqhwDF;EACE,kEAAkE;AACpE;AClhwDA;EC90MG,iEAA8D;AFm28DjE;ACnhwDC;EC70ME,kEAAgE;AFm28DnE;ACnhwDC;EC70ME,iEAA8D;AFm28DjE;;AAEA;EACE,iEAAiE;ACnhwDlE;ADqhwDD;EACE,kEAAkE;AACpE;ACnhwDA;EGp3MQ,iEAA4B;AJ048DpC;AACA;EACE,kEAAkE;ACthwDnE;ADwhwDD;EACE,iEAAiE;ACvhwDjE;;AD0hwDF;EAGE,gCAAgC;ACvhwDhC;ADyhwDF;EACE,iEAAiE;ACvhwDjE;ADyhwDF;EACE,kEAAkE;AACpE;ACthwDA;ECh2MG,iEAA4D;AFy38D/D;ACvhwDC;EC/1ME,kEAA8D;AFy38DjE;ACvhwDC;EC/1ME,iEAA4D;AFy38D/D;;AAEA;EACE,+DAA+D;ACvhwDhE;ADyhwDD;EACE,gEAAgE;AAClE;ACvhwDA;EGr5MQ,+DAA4B;AJ+68DpC;AACA;EACE,gEAAgE;AC1hwDjE;AD4hwDD;EACE,+DAA+D;AC3hwD/D;;AD8hwDF;EAGE,gCAAgC;AC3hwDhC;AD6hwDF;EACE,+DAA+D;AC3hwD/D;AD6hwDF;EACE,gEAAgE;AAClE;AC1hwDA;EC96MG,+DAAY;AF288Df;AC3hwDC;EC76ME,gEAAY;AF288Df;AC3hwDC;EC76ME,+DAAY;AF288Df;;AAEA;EACE,kEAAkE;AC3hwDnE;AD6hwDD;EACE,mEAAmE;AACrE;AC3hwDA;EGt7MQ,kEAA4B;AJo98DpC;AACA;EACE,mEAAmE;AC9hwDpE;ADgiwDD;EACE,kEAAkE;AC/hwDlE;;ADkiwDF;EAGE,gCAAgC;AC/hwDhC;ADiiwDF;EACE,kEAAkE;AC/hwDlE;ADiiwDF;EACE,mEAAmE;AACrE;AC9hwDA;ECh8MG,kEAA8D;AFi+8DjE;AC/hwDC;EC/7ME,mEAAgE;AFi+8DnE;AC/hwDC;EC/7ME,kEAA8D;AFi+8DjE;;AAEA;EACE,kEAAkE;AC/hwDnE;ADiiwDD;EACE,mEAAmE;AACrE;AC/hwDA;EGv9MQ,kEAA4B;AJy/8DpC;AACA;EACE,mEAAmE;ACliwDpE;ADoiwDD;EACE,kEAAkE;ACniwDlE;;ADsiwDF;EAGE,gCAAgC;ACniwDhC;ADqiwDF;EACE,kEAAkE;ACniwDlE;ADqiwDF;EACE,mEAAmE;AACrE;ACliwDA;ECl9MG,kEAA8D;AFu/8DjE;ACniwDC;ECj9ME,mEAAgE;AFu/8DnE;ACniwDC;ECj9ME,kEAA8D;AFu/8DjE;;AAEA;EACE,kEAAkE;ACniwDnE;ADqiwDD;EACE,mEAAmE;AACrE;ACniwDA;EGx/MQ,kEAA4B;AJ8h9DpC;AACA;EACE,mEAAmE;ACtiwDpE;ADwiwDD;EACE,kEAAkE;ACviwDlE;;AD0iwDF;EAGE,gCAAgC;ACviwDhC;ADyiwDF;EACE,kEAAkE;ACviwDlE;ADyiwDF;EACE,mEAAmE;AACrE;ACtiwDA;ECp+MG,kEAA4D;AF6g9D/D;ACviwDC;ECn+ME,mEAA8D;AF6g9DjE;ACviwDC;ECn+ME,kEAA4D;AF6g9D/D;;AAEA;EACE,gEAAgE;ACviwDjE;ADyiwDD;EACE,iEAAiE;AACnE;ACviwDA;EGzhNQ,gEAA4B;AJmk9DpC;AACA;EACE,iEAAiE;AC1iwDlE;AD4iwDD;EACE,gEAAgE;AC3iwDhE;;AD8iwDF;EAGE,gCAAgC;AC3iwDhC;AD6iwDF;EACE,gEAAgE;AC3iwDhE;AD6iwDF;EACE,iEAAiE;AACnE;AC1iwDA;ECljNG,gEAAY;AF+l9Df;AC3iwDC;ECjjNE,iEAAY;AF+l9Df;AC3iwDC;ECjjNE,gEAAY;AF+l9Df;;AAEA;EACE,kEAAkE;AC3iwDnE;AD6iwDD;EACE,mEAAmE;AACrE;AC3iwDA;EG1jNQ,kEAA4B;AJwm9DpC;AACA;EACE,mEAAmE;AC9iwDpE;ADgjwDD;EACE,kEAAkE;AC/iwDlE;;ADkjwDF;EAGE,gCAAgC;AC/iwDhC;ADijwDF;EACE,kEAAkE;AC/iwDlE;ADijwDF;EACE,mEAAmE;AACrE;AC9iwDA;ECpkNG,kEAA8D;AFqn9DjE;AC/iwDC;ECnkNE,mEAAgE;AFqn9DnE;AC/iwDC;ECnkNE,kEAA8D;AFqn9DjE;;AAEA;EACE,kEAAkE;AC/iwDnE;ADijwDD;EACE,mEAAmE;AACrE;AC/iwDA;EG3lNQ,kEAA4B;AJ6o9DpC;AACA;EACE,mEAAmE;ACljwDpE;ADojwDD;EACE,kEAAkE;ACnjwDlE;;ADsjwDF;EAGE,gCAAgC;ACnjwDhC;ADqjwDF;EACE,kEAAkE;ACnjwDlE;ADqjwDF;EACE,mEAAmE;AACrE;ACljwDA;ECtlNG,kEAA8D;AF2o9DjE;ACnjwDC;ECrlNE,mEAAgE;AF2o9DnE;ACnjwDC;ECrlNE,kEAA8D;AF2o9DjE;;AAEA;EACE,kEAAkE;ACnjwDnE;ADqjwDD;EACE,mEAAmE;AACrE;ACnjwDA;EG5nNQ,kEAA4B;AJkr9DpC;AACA;EACE,mEAAmE;ACtjwDpE;ADwjwDD;EACE,kEAAkE;ACvjwDlE;;AD0jwDF;EAGE,gCAAgC;ACvjwDhC;ADyjwDF;EACE,kEAAkE;ACvjwDlE;ADyjwDF;EACE,mEAAmE;AACrE;ACtjwDA;ECxmNG,kEAA4D;AFiq9D/D;ACvjwDC;ECvmNE,mEAA8D;AFiq9DjE;ACvjwDC;ECvmNE,kEAA4D;AFiq9D/D;;AAEA;EACE,gEAAgE;ACvjwDjE;ADyjwDD;EACE,iEAAiE;AACnE;ACvjwDA;EG7pNQ,gEAA4B;AJut9DpC;AACA;EACE,iEAAiE;AC1jwDlE;AD4jwDD;EACE,gEAAgE;AC3jwDhE;;AD8jwDF;EAGE,gCAAgC;AC3jwDhC;AD6jwDF;EACE,gEAAgE;AC3jwDhE;AD6jwDF;EACE,iEAAiE;AACnE;AC1jwDA;ECtrNG,gEAAY;AFmv9Df;AC3jwDC;ECrrNE,iEAAY;AFmv9Df;AC3jwDC;ECrrNE,gEAAY;AFmv9Df;;AAEA;EACE,mEAAmE;AC3jwDpE;AD6jwDD;EACE,oEAAoE;AACtE;AC3jwDA;EG9rNQ,mEAA4B;AJ4v9DpC;AACA;EACE,oEAAoE;AC9jwDrE;ADgkwDD;EACE,mEAAmE;AC/jwDnE;;ADkkwDF;EAGE,gCAAgC;AC/jwDhC;ADikwDF;EACE,mEAAmE;AC/jwDnE;ADikwDF;EACE,oEAAoE;AACtE;AC9jwDA;ECxsNG,mEAA8D;AFyw9DjE;AC/jwDC;ECvsNE,oEAAgE;AFyw9DnE;AC/jwDC;ECvsNE,mEAA8D;AFyw9DjE;;AAEA;EACE,mEAAmE;AC/jwDpE;ADikwDD;EACE,oEAAoE;AACtE;AC/jwDA;EG/tNQ,mEAA4B;AJiy9DpC;AACA;EACE,oEAAoE;AClkwDrE;ADokwDD;EACE,mEAAmE;ACnkwDnE;;ADskwDF;EAGE,gCAAgC;ACnkwDhC;ADqkwDF;EACE,mEAAmE;ACnkwDnE;ADqkwDF;EACE,oEAAoE;AACtE;AClkwDA;EC1tNG,mEAA8D;AF+x9DjE;ACnkwDC;ECztNE,oEAAgE;AF+x9DnE;ACnkwDC;ECztNE,mEAA8D;AF+x9DjE;;AAEA;EACE,mEAAmE;ACnkwDpE;ADqkwDD;EACE,oEAAoE;AACtE;ACnkwDA;EGhwNQ,mEAA4B;AJs09DpC;AACA;EACE,oEAAoE;ACtkwDrE;ADwkwDD;EACE,mEAAmE;ACvkwDnE;;AD0kwDF;EAGE,gCAAgC;ACvkwDhC;ADykwDF;EACE,mEAAmE;ACvkwDnE;ADykwDF;EACE,oEAAoE;AACtE;ACtkwDA;EC5uNG,mEAA4D;AFqz9D/D;ACvkwDC;EC3uNE,oEAA8D;AFqz9DjE;ACvkwDC;EC3uNE,mEAA4D;AFqz9D/D;;AAEA;EACE,iEAAiE;ACvkwDlE;ADykwDD;EACE,kEAAkE;AACpE;ACvkwDA;EGjyNQ,iEAA4B;AJ229DpC;AACA;EACE,kEAAkE;AC1kwDnE;AD4kwDD;EACE,iEAAiE;AC3kwDjE;;AD8kwDF;EAGE,gCAAgC;AC3kwDhC;AD6kwDF;EACE,iEAAiE;AC3kwDjE;AD6kwDF;EACE,kEAAkE;AACpE;AC1kwDA;EC1zNG,iEAAY;AFu49Df;AC3kwDC;ECzzNE,kEAAY;AFu49Df;AC3kwDC;ECzzNE,iEAAY;AFu49Df;;AAEA;EACE,mEAAmE;AC3kwDpE;AD6kwDD;EACE,oEAAoE;AACtE;AC3kwDA;EGl0NQ,mEAA4B;AJg59DpC;AACA;EACE,oEAAoE;AC9kwDrE;ADglwDD;EACE,mEAAmE;AC/kwDnE;;ADklwDF;EAGE,gCAAgC;AC/kwDhC;ADilwDF;EACE,mEAAmE;AC/kwDnE;ADilwDF;EACE,oEAAoE;AACtE;AC9kwDA;EC50NG,mEAA8D;AF659DjE;AC/kwDC;EC30NE,oEAAgE;AF659DnE;AC/kwDC;EC30NE,mEAA8D;AF659DjE;;AAEA;EACE,mEAAmE;AC/kwDpE;ADilwDD;EACE,oEAAoE;AACtE;AC/kwDA;EGn2NQ,mEAA4B;AJq79DpC;AACA;EACE,oEAAoE;ACllwDrE;ADolwDD;EACE,mEAAmE;ACnlwDnE;;ADslwDF;EAGE,gCAAgC;ACnlwDhC;ADqlwDF;EACE,mEAAmE;ACnlwDnE;ADqlwDF;EACE,oEAAoE;AACtE;ACllwDA;EC91NG,mEAA8D;AFm79DjE;ACnlwDC;EC71NE,oEAAgE;AFm79DnE;ACnlwDC;EC71NE,mEAA8D;AFm79DjE;;AAEA;EACE,mEAAmE;ACnlwDpE;ADqlwDD;EACE,oEAAoE;AACtE;ACnlwDA;EGp4NQ,mEAA4B;AJ099DpC;AACA;EACE,oEAAoE;ACtlwDrE;ADwlwDD;EACE,mEAAmE;ACvlwDnE;;AD0lwDF;EAGE,gCAAgC;ACvlwDhC;ADylwDF;EACE,mEAAmE;ACvlwDnE;ADylwDF;EACE,oEAAoE;AACtE;ACtlwDA;ECh3NG,mEAA4D;AFy89D/D;ACvlwDC;EC/2NE,oEAA8D;AFy89DjE;ACvlwDC;EC/2NE,mEAA4D;AFy89D/D;;AAEA;EACE,iEAAiE;ACvlwDlE;ADylwDD;EACE,kEAAkE;AACpE;ACvlwDA;EGr6NQ,iEAA4B;AJ+/9DpC;AACA;EACE,kEAAkE;AC1lwDnE;AD4lwDD;EACE,iEAAiE;AC3lwDjE;;AD8lwDF;EAGE,gCAAgC;AC3lwDhC;AD6lwDF;EACE,iEAAiE;AC3lwDjE;AD6lwDF;EACE,kEAAkE;AACpE;AC1lwDA;EC97NG,iEAAY;AF2h+Df;AC3lwDC;EC77NE,kEAAY;AF2h+Df;AC3lwDC;EC77NE,iEAAY;AF2h+Df;;AAEA;EACE,mEAAmE;AC3lwDpE;AD6lwDD;EACE,oEAAoE;AACtE;AC3lwDA;EGt8NQ,mEAA4B;AJoi+DpC;AACA;EACE,oEAAoE;AC9lwDrE;ADgmwDD;EACE,mEAAmE;AC/lwDnE;;ADkmwDF;EAGE,gCAAgC;AC/lwDhC;ADimwDF;EACE,mEAAmE;AC/lwDnE;ADimwDF;EACE,oEAAoE;AACtE;AC9lwDA;ECh9NG,mEAA8D;AFij+DjE;AC/lwDC;EC/8NE,oEAAgE;AFij+DnE;AC/lwDC;EC/8NE,mEAA8D;AFij+DjE;;AAEA;EACE,mEAAmE;AC/lwDpE;ADimwDD;EACE,oEAAoE;AACtE;AC/lwDA;EGv+NQ,mEAA4B;AJyk+DpC;AACA;EACE,oEAAoE;AClmwDrE;ADomwDD;EACE,mEAAmE;ACnmwDnE;;ADsmwDF;EAGE,gCAAgC;ACnmwDhC;ADqmwDF;EACE,mEAAmE;ACnmwDnE;ADqmwDF;EACE,oEAAoE;AACtE;AClmwDA;ECl+NG,mEAA8D;AFuk+DjE;ACnmwDC;ECj+NE,oEAAgE;AFuk+DnE;ACnmwDC;ECj+NE,mEAA8D;AFuk+DjE;;AAEA;EACE,mEAAmE;ACnmwDpE;ADqmwDD;EACE,oEAAoE;AACtE;ACnmwDA;EGxgOQ,mEAA4B;AJ8m+DpC;AACA;EACE,oEAAoE;ACtmwDrE;ADwmwDD;EACE,mEAAmE;ACvmwDnE;;AD0mwDF;EAGE,gCAAgC;ACvmwDhC;ADymwDF;EACE,mEAAmE;ACvmwDnE;ADymwDF;EACE,oEAAoE;AACtE;ACtmwDA;ECp/NG,mEAA4D;AF6l+D/D;ACvmwDC;ECn/NE,oEAA8D;AF6l+DjE;ACvmwDC;ECn/NE,mEAA4D;AF6l+D/D;;AAEA;EACE,iEAAiE;ACvmwDlE;ADymwDD;EACE,kEAAkE;AACpE;ACvmwDA;EGziOQ,iEAA4B;AJmp+DpC;AACA;EACE,kEAAkE;AC1mwDnE;AD4mwDD;EACE,iEAAiE;AC3mwDjE;;AD8mwDF;EAGE,gCAAgC;AC3mwDhC;AD6mwDF;EACE,iEAAiE;AC3mwDjE;AD6mwDF;EACE,kEAAkE;AACpE;AC1mwDA;EClkOG,iEAA8D;AF+q+DjE;AC3mwDC;ECjkOE,kEAAgE;AF+q+DnE;AC3mwDC;ECjkOE,iEAA8D;AF+q+DjE;;AAEA;EACE,gEAAgE;AC3mwDjE;AD6mwDD;EACE,iEAAiE;AACnE;AC3mwDA;EG1kOQ,gEAA4B;AJwr+DpC;AACA;EACE,iEAAiE;AC9mwDlE;ADgnwDD;EACE,gEAAgE;AC/mwDhE;;ADknwDF;EAGE,gCAAgC;AC/mwDhC;ADinwDF;EACE,gEAAgE;AC/mwDhE;ADinwDF;EACE,iEAAiE;AACnE;AC9mwDA;ECplOG,gEAA8D;AFqs+DjE;AC/mwDC;ECnlOE,iEAAgE;AFqs+DnE;AC/mwDC;ECnlOE,gEAA8D;AFqs+DjE;;AAEA;EACE,gEAAgE;AC/mwDjE;ADinwDD;EACE,iEAAiE;AACnE;AC/mwDA;EG3mOQ,gEAA4B;AJ6t+DpC;AACA;EACE,iEAAiE;AClnwDlE;ADonwDD;EACE,gEAAgE;ACnnwDhE;;ADsnwDF;EAGE,gCAAgC;ACnnwDhC;ADqnwDF;EACE,gEAAgE;ACnnwDhE;ADqnwDF;EACE,iEAAiE;AACnE;AClnwDA;ECtmOG,gEAA8D;AF2t+DjE;ACnnwDC;ECrmOE,iEAAgE;AF2t+DnE;ACnnwDC;ECrmOE,gEAA8D;AF2t+DjE;;AAEA;EACE,gEAAgE;ACnnwDjE;ADqnwDD;EACE,iEAAiE;AACnE;ACnnwDA;EG5oOQ,gEAA4B;AJkw+DpC;AACA;EACE,iEAAiE;ACtnwDlE;ADwnwDD;EACE,gEAAgE;ACvnwDhE;;AD0nwDF;EAGE,gCAAgC;ACvnwDhC;ADynwDF;EACE,gEAAgE;ACvnwDhE;ADynwDF;EACE,iEAAiE;AACnE;ACtnwDA;ECxnOG,gEAA4D;AFiv+D/D;ACvnwDC;ECvnOE,iEAA8D;AFiv+DjE;ACvnwDC;ECvnOE,gEAA4D;AFiv+D/D;;AAEA;EACE,8DAA8D;ACvnwD/D;ADynwDD;EACE,+DAA+D;AACjE;ACvnwDA;EG7qOQ,8DAA4B;AJuy+DpC;AACA;EACE,+DAA+D;AC1nwDhE;AD4nwDD;EACE,8DAA8D;AC3nwD9D;;AD8nwDF;EAGE,gCAAgC;AC3nwDhC;AD6nwDF;EACE,8DAA8D;AC3nwD9D;AD6nwDF;EACE,+DAA+D;AACjE;AC1nwDA;ECtsOG,8DAAY;AFm0+Df;AC3nwDC;ECrsOE,+DAAY;AFm0+Df;AC3nwDC;ECrsOE,8DAAY;AFm0+Df;;AAEA;EACE,mEAAmE;AC3nwDpE;AD6nwDD;EACE,oEAAoE;AACtE;AC3nwDA;EG9sOQ,mEAA4B;AJ40+DpC;AACA;EACE,oEAAoE;AC9nwDrE;ADgowDD;EACE,mEAAmE;AC/nwDnE;;ADkowDF;EAGE,gCAAgC;AC/nwDhC;ADiowDF;EACE,mEAAmE;AC/nwDnE;ADiowDF;EACE,oEAAoE;AACtE;AC9nwDA;ECxtOG,mEAA8D;AFy1+DjE;AC/nwDC;ECvtOE,oEAAgE;AFy1+DnE;AC/nwDC;ECvtOE,mEAA8D;AFy1+DjE;;AAEA;EACE,mEAAmE;AC/nwDpE;ADiowDD;EACE,oEAAoE;AACtE;AC/nwDA;EG/uOQ,mEAA4B;AJi3+DpC;AACA;EACE,oEAAoE;AClowDrE;ADoowDD;EACE,mEAAmE;ACnowDnE;;ADsowDF;EAGE,gCAAgC;ACnowDhC;ADqowDF;EACE,mEAAmE;ACnowDnE;ADqowDF;EACE,oEAAoE;AACtE;AClowDA;EC1uOG,mEAA8D;AF+2+DjE;ACnowDC;ECzuOE,oEAAgE;AF+2+DnE;ACnowDC;ECzuOE,mEAA8D;AF+2+DjE;;AAEA;EACE,mEAAmE;ACnowDpE;ADqowDD;EACE,oEAAoE;AACtE;ACnowDA;EGhxOQ,mEAA4B;AJs5+DpC;AACA;EACE,oEAAoE;ACtowDrE;ADwowDD;EACE,mEAAmE;ACvowDnE;;AD0owDF;EAGE,gCAAgC;ACvowDhC;ADyowDF;EACE,mEAAmE;ACvowDnE;ADyowDF;EACE,oEAAoE;AACtE;ACtowDA;EC5vOG,mEAA4D;AFq4+D/D;ACvowDC;EC3vOE,oEAA8D;AFq4+DjE;ACvowDC;EC3vOE,mEAA4D;AFq4+D/D;;AAEA;EACE,iEAAiE;ACvowDlE;ADyowDD;EACE,kEAAkE;AACpE;ACvowDA;EGjzOQ,iEAA4B;AJ27+DpC;AACA;EACE,kEAAkE;AC1owDnE;AD4owDD;EACE,iEAAiE;AC3owDjE;;AD8owDF;EAGE,gCAAgC;AC3owDhC;AD6owDF;EACE,iEAAiE;AC3owDjE;AD6owDF;EACE,kEAAkE;AACpE;AC1owDA;EACA,iEAAM;AD4owDN;AACA;EACE,kEAAkE;AC3owDpE;AD6owDA;EACE,iEAAiE;AACnE;;AAEA,YC1owDiB;AD2owDjB;EACE,8BAA8B;AC7owD5B;;ADgpwDJ;EACE,6BAA6B;ACjpwD3B;;ADopwDJ;EACE,4BAA4B;ACrpwD1B;;ADwpwDJ;EACE,6BAA6B;ACzpwD3B;;AD4pwDJ;EACE,0BAA0B;AC7pwDxB;;ADgqwDJ;EACE,6BAA6B;ACjqwD3B;;ADoqwDJ;EACE,4BAA4B;ACrqwD1B;;ADwqwDJ;EACE,6BAA6B;ACzqwD3B;;AD4qwDJ;EACE,0BAA0B;AC7qwDxB;;ADgrwDJ;EACE,6BAA6B;AC3qwD/B;;AD8qwDA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AC5qwDA,cAAe;AD+qwDf;EACE,2BAA2B;AAC7B;;AC1qwDI;EACI,2BAAgB;AD6qwDxB;;AC9qwDI,YAAY;ADirwDhB;EACE,+BAA+B;AACjC;;AAEA,iBCprwDsB;ADqrwDtB;EACE,8BAA8B;ACvrwD5B;;AD0rwDJ;EACE,iCAAiC;AC3rwD/B;;AD8rwDJ;EACE,gCAAgC;ACrrwD9B;;ADwrwDJ;EACE,iCAAiC;ACzrwD/B;;AD4rwDJ;EACE,8BAA8B;AC7rwD5B;;ADgswDJ;EACE,kCAAkC;ACjswDhC;;ADoswDJ;EACE,iCAAiC;AC9rwDnC;;ADiswDA;EACE,kCAAkC;AACpC;;AC9rwDA;EACC,+BAAiB;ADiswDlB;;AC7rwDI,cAAY;ADgswDhB;EACE,yBAAyB;AAC3B;;AAEA,QCnswDa;ADoswDb;EACE,mBAAmB;ACtswDjB;;ADyswDJ;EACE,sBAAsB;AC1swDpB;;AD6swDJ;EACE,sBAAsB;AC9swDpB;;ADitwDJ;EACE,sBAAsB;ACltwDpB;;ADqtwDJ;EACE,sBAAsB;ACttwDpB;;ADytwDJ;EACE,sBAAsB;AC1twDpB;;AD6twDJ;EACE,sBAAsB;AC9twDpB;;ADiuwDJ;EACE,sBAAsB;ACluwDpB;;ADquwDJ;EACE,sBAAsB;ACtuwDpB;;ADyuwDJ;EACE,sBAAsB;AC1uwDpB;;AD6uwDJ;EACE,sBAAsB;AC9uwDpB;;ADivwDJ;EACE,sBAAsB;AClvwDpB;;ADqvwDJ;EACE,sBAAsB;ACtvwDpB;;ADyvwDJ;EACE,sBAAsB;AC1vwDpB;;AD6vwDJ;EACE,sBAAsB;AC9vwDpB;;ADiwwDJ;EACE,sBAAsB;AClwwDpB;;ADqwwDJ;EACE,uBAAuB;ACtwwDrB;;ADywwDJ;EACE,uBAAuB;AC1wwDrB;;AD6wwDJ;EACE,uBAAuB;AC9wwDrB;;ADixwDJ;EACE,uBAAuB;AClxwDrB;;ADqxwDJ;EACE,uBAAuB;ACtxwDrB;;ADyxwDJ;EACE,uBAAuB;AC1xwDrB;;AD6xwDJ;EACE,uBAAuB;AC9xwDrB;;ADiywDJ;EACE,uBAAuB;AClywDrB;;ADqywDJ;EACE,uBAAuB;ACtywDrB;;ADyywDJ;EACE,uBAAuB;AC1ywDrB;;AD6ywDJ;EACE,uBAAuB;AC9ywDrB;;ADizwDJ;EACE,uBAAuB;AClzwDrB;;ADqzwDJ;EACE,uBAAuB;ACtzwDrB;;ADyzwDJ;EACE,uBAAuB;AC1zwDrB;;AD6zwDJ;EACE,uBAAuB;AC9zwDrB;;ADi0wDJ;EACE,uBAAuB;ACl0wDrB;;ADq0wDJ;EACE,uBAAuB;ACt0wDrB;;ADy0wDJ;EACE,uBAAuB;AC10wDrB;;AD60wDJ;EACE,uBAAuB;AC90wDrB;;ADi1wDJ;EACE,uBAAuB;ACl1wDrB;;ADq1wDJ;EACE,uBAAuB;ACt1wDrB;;ADy1wDJ;EACE,uBAAuB;AC11wDrB;;AD61wDJ;EACE,uBAAuB;AC91wDrB;;ADi2wDJ;EACE,uBAAuB;ACl2wDrB;;ADq2wDJ;EACE,uBAAuB;ACt2wDrB;;ADy2wDJ;EACE,uBAAuB;AC12wDrB;;AD62wDJ;EACE,uBAAuB;AC92wDrB;;ADi3wDJ;EACE,uBAAuB;ACl3wDrB;;ADq3wDJ;EACE,uBAAuB;ACt3wDrB;;ADy3wDJ;EACE,uBAAuB;AC13wDrB;;AD63wDJ;EACE,uBAAuB;AC93wDrB;;ADi4wDJ;EACE,uBAAuB;ACl4wDrB;;ADq4wDJ;EACE,uBAAuB;ACt4wDrB;;ADy4wDJ;EACE,uBAAuB;AC14wDrB;;AD64wDJ;EACE,uBAAuB;AC94wDrB;;ADi5wDJ;EACE,uBAAuB;ACl5wDrB;;ADq5wDJ;EACE,uBAAuB;ACt5wDrB;;ADy5wDJ;EACE,uBAAuB;AC15wDrB;;AD65wDJ;EACE,uBAAuB;AC95wDrB;;ADi6wDJ;EACE,uBAAuB;ACl6wDrB;;ADq6wDJ;EACE,uBAAuB;ACt6wDrB;;ADy6wDJ;EACE,uBAAuB;AC16wDrB;;AD66wDJ;EACE,uBAAuB;AC96wDrB;;ADi7wDJ;EACE,uBAAuB;ACl7wDrB;;ADq7wDJ;EACE,uBAAuB;ACt7wDrB;;ADy7wDJ;EACE,uBAAuB;AC17wDrB;;AD67wDJ;EACE,uBAAuB;AC97wDrB;;ADi8wDJ;EACE,uBAAuB;ACl8wDrB;;ADq8wDJ;EACE,uBAAuB;ACt8wDrB;;ADy8wDJ;EACE,uBAAuB;AC18wDrB;;AD68wDJ;EACE,uBAAuB;AC98wDrB;;ADi9wDJ;EACE,uBAAuB;ACl9wDrB;;ADq9wDJ;EACE,uBAAuB;ACt9wDrB;;ADy9wDJ;EACE,uBAAuB;AC19wDrB;;AD69wDJ;EACE,uBAAuB;AC99wDrB;;ADi+wDJ;EACE,uBAAuB;ACl+wDrB;;ADq+wDJ;EACE,uBAAuB;ACt+wDrB;;ADy+wDJ;EACE,uBAAuB;AC1+wDrB;;AD6+wDJ;EACE,uBAAuB;AC9+wDrB;;ADi/wDJ;EACE,uBAAuB;ACl/wDrB;;ADq/wDJ;EACE,uBAAuB;ACt/wDrB;;ADy/wDJ;EACE,uBAAuB;AC1/wDrB;;AD6/wDJ;EACE,uBAAuB;AC9/wDrB;;ADigxDJ;EACE,uBAAuB;AClgxDrB;;ADqgxDJ;EACE,uBAAuB;ACtgxDrB;;ADygxDJ;EACE,uBAAuB;AC1gxDrB;;AD6gxDJ;EACE,uBAAuB;AC9gxDrB;;ADihxDJ;EACE,uBAAuB;AClhxDrB;;ADqhxDJ;EACE,uBAAuB;ACthxDrB;;ADyhxDJ;EACE,uBAAuB;AC1hxDrB;;AD6hxDJ;EACE,uBAAuB;AC9hxDrB;;ADiixDJ;EACE,uBAAuB;AClixDrB;;ADqixDJ;EACE,uBAAuB;ACtixDrB;;ADyixDJ;EACE,uBAAuB;AC1ixDrB;;AD6ixDJ;EACE,uBAAuB;AC9ixDrB;;ADijxDJ;EACE,uBAAuB;ACljxDrB;;ADqjxDJ;EACE,uBAAuB;ACtjxDrB;;ADyjxDJ;EACE,uBAAuB;AC1jxDrB;;AD6jxDJ;EACE,uBAAuB;AC9jxDrB;;ADikxDJ;EACE,uBAAuB;AClkxDrB;;ADqkxDJ;EACE,uBAAuB;ACtkxDrB;;ADykxDJ;EACE,uBAAuB;AC1kxDrB;;AD6kxDJ;EACE,uBAAuB;AC9kxDrB;;ADilxDJ;EACE,uBAAuB;ACllxDrB;;ADqlxDJ;EACE,uBAAuB;ACtlxDrB;;ADylxDJ;EACE,uBAAuB;AC1lxDrB;;AD6lxDJ;EACE,uBAAuB;AC9lxDrB;;ADimxDJ;EACE,uBAAuB;AClmxDrB;;ADqmxDJ;EACE,uBAAuB;ACtmxDrB;;ADymxDJ;EACE,uBAAuB;AC1mxDrB;;AD6mxDJ;EACE,uBAAuB;AC9mxDrB;;ADinxDJ;EACE,uBAAuB;AClnxDrB;;ADqnxDJ;EACE,uBAAuB;ACtnxDrB;;ADynxDJ;EACE,uBAAuB;AC1nxDrB;;AD6nxDJ;EACE,uBAAuB;AC9nxDrB;;ADioxDJ;EACE,uBAAuB;ACloxDrB;;ADqoxDJ;EACE,uBAAuB;ACtoxDrB;;ADyoxDJ;EACE,uBAAuB;AC1oxDrB;;AD6oxDJ;EACE,uBAAuB;AC9oxDrB;;ADipxDJ;EACE,uBAAuB;AClpxDrB;;ADqpxDJ;EACE,uBAAuB;ACtpxDrB;;ADypxDJ;EACE,uBAAuB;AC1pxDrB;;AD6pxDJ;EACE,uBAAuB;AC9pxDrB;;ADiqxDJ;EACE,uBAAuB;AClqxDrB;;ADqqxDJ;EACE,uBAAuB;ACtqxDrB;;ADyqxDJ;EACE,uBAAuB;AC1qxDrB;;AD6qxDJ;EACE,uBAAuB;AC9qxDrB;;ADirxDJ;EACE,uBAAuB;AClrxDrB;;ADqrxDJ;EACE,uBAAuB;ACtrxDrB;;ADyrxDJ;EACE,uBAAuB;AC1rxDrB;;AD6rxDJ;EACE,uBAAuB;AC9rxDrB;;ADisxDJ;EACE,uBAAuB;AClsxDrB;;ADqsxDJ;EACE,uBAAuB;ACtsxDrB;;ADysxDJ;EACE,uBAAuB;AC1sxDrB;;AD6sxDJ;EACE,uBAAuB;AC9sxDrB;;ADitxDJ;EACE,uBAAuB;ACltxDrB;;ADqtxDJ;EACE,uBAAuB;ACttxDrB;;ADytxDJ;EACE,uBAAuB;AC1txDrB;;AD6txDJ;EACE,uBAAuB;AC9txDrB;;ADiuxDJ;EACE,uBAAuB;ACluxDrB;;ADquxDJ;EACE,uBAAuB;ACtuxDrB;;ADyuxDJ;EACE,uBAAuB;AC1uxDrB;;AD6uxDJ;EACE,uBAAuB;AC9uxDrB;;ADivxDJ;EACE,uBAAuB;AClvxDrB;;ADqvxDJ;EACE,uBAAuB;ACtvxDrB;;ADyvxDJ;EACE,uBAAuB;AC1vxDrB;;AD6vxDJ;EACE,uBAAuB;AC9vxDrB;;ADiwxDJ;EACE,uBAAuB;AClwxDrB;;ADqwxDJ;EACE,uBAAuB;ACtwxDrB;;ADywxDJ;EACE,uBAAuB;AC1wxDrB;;AD6wxDJ;EACE,uBAAuB;AC9wxDrB;;ADixxDJ;EACE,uBAAuB;AClxxDrB;;ADqxxDJ;EACE,uBAAuB;ACtxxDrB;;ADyxxDJ;EACE,uBAAuB;AC1xxDrB;;AD6xxDJ;EACE,uBAAuB;AC9xxDrB;;ADiyxDJ;EACE,uBAAuB;AClyxDrB;;ADqyxDJ;EACE,uBAAuB;ACtyxDrB;;ADyyxDJ;EACE,uBAAuB;AC1yxDrB;;AD6yxDJ;EACE,uBAAuB;ACzyxDzB;;AD4yxDA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;ECnzxDxB;;EDszxDA;IACE,sBAAsB;ECvzxDxB;;ED0zxDA;IACE,sBAAsB;EC3zxDxB;;ED8zxDA;IACE,sBAAsB;EC/zxDxB;;EDk0xDA;IACE,sBAAsB;ECn0xDxB;;EDs0xDA;IACE,sBAAsB;ECv0xDxB;;ED00xDA;IACE,sBAAsB;EC30xDxB;;ED80xDA;IACE,sBAAsB;EC/0xDxB;;EDk1xDA;IACE,sBAAsB;ECn1xDxB;;EDs1xDA;IACE,sBAAsB;ECv1xDxB;;ED01xDA;IACE,sBAAsB;EC31xDxB;;ED81xDA;IACE,sBAAsB;EC/1xDxB;;EDk2xDA;IACE,sBAAsB;ECn2xDxB;;EDs2xDA;IACE,sBAAsB;ECv2xDxB;;ED02xDA;IACE,sBAAsB;EC32xDxB;;ED82xDA;IACE,uBAAuB;EC/2xDzB;;EDk3xDA;IACE,uBAAuB;ECn3xDzB;;EDs3xDA;IACE,uBAAuB;ECv3xDzB;;ED03xDA;IACE,uBAAuB;EC33xDzB;;ED83xDA;IACE,uBAAuB;EC/3xDzB;;EDk4xDA;IACE,uBAAuB;ECn4xDzB;;EDs4xDA;IACE,uBAAuB;ECv4xDzB;;ED04xDA;IACE,uBAAuB;EC34xDzB;;ED84xDA;IACE,uBAAuB;EC/4xDzB;;EDk5xDA;IACE,uBAAuB;ECn5xDzB;;EDs5xDA;IACE,uBAAuB;ECv5xDzB;;ED05xDA;IACE,uBAAuB;EC35xDzB;;ED85xDA;IACE,uBAAuB;EC/5xDzB;;EDk6xDA;IACE,uBAAuB;ECn6xDzB;;EDs6xDA;IACE,uBAAuB;ECv6xDzB;;ED06xDA;IACE,uBAAuB;EC36xDzB;;ED86xDA;IACE,uBAAuB;EC/6xDzB;;EDk7xDA;IACE,uBAAuB;ECn7xDzB;;EDs7xDA;IACE,uBAAuB;ECv7xDzB;;ED07xDA;IACE,uBAAuB;EC37xDzB;;ED87xDA;IACE,uBAAuB;EC/7xDzB;;EDk8xDA;IACE,uBAAuB;ECn8xDzB;;EDs8xDA;IACE,uBAAuB;ECv8xDzB;;ED08xDA;IACE,uBAAuB;EC38xDzB;;ED88xDA;IACE,uBAAuB;EC/8xDzB;;EDk9xDA;IACE,uBAAuB;ECn9xDzB;;EDs9xDA;IACE,uBAAuB;ECv9xDzB;;ED09xDA;IACE,uBAAuB;EC39xDzB;;ED89xDA;IACE,uBAAuB;EC/9xDzB;;EDk+xDA;IACE,uBAAuB;ECn+xDzB;;EDs+xDA;IACE,uBAAuB;ECv+xDzB;;ED0+xDA;IACE,uBAAuB;EC3+xDzB;;ED8+xDA;IACE,uBAAuB;EC/+xDzB;;EDk/xDA;IACE,uBAAuB;ECn/xDzB;;EDs/xDA;IACE,uBAAuB;ECv/xDzB;;ED0/xDA;IACE,uBAAuB;EC3/xDzB;;ED8/xDA;IACE,uBAAuB;EC//xDzB;;EDkgyDA;IACE,uBAAuB;ECngyDzB;;EDsgyDA;IACE,uBAAuB;ECvgyDzB;;ED0gyDA;IACE,uBAAuB;EC3gyDzB;;ED8gyDA;IACE,uBAAuB;EC/gyDzB;;EDkhyDA;IACE,uBAAuB;ECnhyDzB;;EDshyDA;IACE,uBAAuB;ECvhyDzB;;ED0hyDA;IACE,uBAAuB;EC3hyDzB;;ED8hyDA;IACE,uBAAuB;EC/hyDzB;;EDkiyDA;IACE,uBAAuB;ECniyDzB;;EDsiyDA;IACE,uBAAuB;ECviyDzB;;ED0iyDA;IACE,uBAAuB;EC3iyDzB;;ED8iyDA;IACE,uBAAuB;EC/iyDzB;;EDkjyDA;IACE,uBAAuB;ECnjyDzB;;EDsjyDA;IACE,uBAAuB;ECvjyDzB;;ED0jyDA;IACE,uBAAuB;EC3jyDzB;;ED8jyDA;IACE,uBAAuB;EC/jyDzB;;EDkkyDA;IACE,uBAAuB;ECnkyDzB;;EDskyDA;IACE,uBAAuB;ECvkyDzB;;ED0kyDA;IACE,uBAAuB;EC3kyDzB;;ED8kyDA;IACE,uBAAuB;EC/kyDzB;;EDklyDA;IACE,uBAAuB;ECnlyDzB;;EDslyDA;IACE,uBAAuB;ECvlyDzB;;ED0lyDA;IACE,uBAAuB;EC3lyDzB;;ED8lyDA;IACE,uBAAuB;EC/lyDzB;;EDkmyDA;IACE,uBAAuB;ECnmyDzB;;EDsmyDA;IACE,uBAAuB;ECvmyDzB;;ED0myDA;IACE,uBAAuB;EC3myDzB;;ED8myDA;IACE,uBAAuB;EC/myDzB;;EDknyDA;IACE,uBAAuB;ECnnyDzB;;EDsnyDA;IACE,uBAAuB;ECvnyDzB;;ED0nyDA;IACE,uBAAuB;EC3nyDzB;;ED8nyDA;IACE,uBAAuB;EC/nyDzB;;EDkoyDA;IACE,uBAAuB;ECnoyDzB;;EDsoyDA;IACE,uBAAuB;ECvoyDzB;;ED0oyDA;IACE,uBAAuB;EC3oyDzB;;ED8oyDA;IACE,uBAAuB;EC/oyDzB;;EDkpyDA;IACE,uBAAuB;ECnpyDzB;;EDspyDA;IACE,uBAAuB;ECvpyDzB;;ED0pyDA;IACE,uBAAuB;EC3pyDzB;;ED8pyDA;IACE,uBAAuB;EC/pyDzB;;EDkqyDA;IACE,uBAAuB;ECnqyDzB;;EDsqyDA;IACE,uBAAuB;ECvqyDzB;;ED0qyDA;IACE,uBAAuB;EC3qyDzB;;ED8qyDA;IACE,uBAAuB;EC/qyDzB;;EDkryDA;IACE,uBAAuB;ECnryDzB;;EDsryDA;IACE,uBAAuB;ECvryDzB;;ED0ryDA;IACE,uBAAuB;EC3ryDzB;;ED8ryDA;IACE,uBAAuB;EC/ryDzB;;EDksyDA;IACE,uBAAuB;ECnsyDzB;;EDssyDA;IACE,uBAAuB;ECvsyDzB;;ED0syDA;IACE,uBAAuB;EC3syDzB;;ED8syDA;IACE,uBAAuB;EC/syDzB;;EDktyDA;IACE,uBAAuB;ECntyDzB;;EDstyDA;IACE,uBAAuB;ECvtyDzB;;ED0tyDA;IACE,uBAAuB;EC3tyDzB;;ED8tyDA;IACE,uBAAuB;EC/tyDzB;;EDkuyDA;IACE,uBAAuB;ECnuyDzB;;EDsuyDA;IACE,uBAAuB;ECvuyDzB;;ED0uyDA;IACE,uBAAuB;EC3uyDzB;;ED8uyDA;IACE,uBAAuB;EC/uyDzB;;EDkvyDA;IACE,uBAAuB;ECnvyDzB;;EDsvyDA;IACE,uBAAuB;ECvvyDzB;;ED0vyDA;IACE,uBAAuB;EC3vyDzB;;ED8vyDA;IACE,uBAAuB;EC/vyDzB;;EDkwyDA;IACE,uBAAuB;ECnwyDzB;;EDswyDA;IACE,uBAAuB;ECvwyDzB;;ED0wyDA;IACE,uBAAuB;EC3wyDzB;;ED8wyDA;IACE,uBAAuB;EC/wyDzB;;EDkxyDA;IACE,uBAAuB;ECnxyDzB;;EDsxyDA;IACE,uBAAuB;ECvxyDzB;;ED0xyDA;IACE,uBAAuB;EC3xyDzB;;ED8xyDA;IACE,uBAAuB;EC/xyDzB;;EDkyyDA;IACE,uBAAuB;ECnyyDzB;;EDsyyDA;IACE,uBAAuB;ECvyyDzB;;ED0yyDA;IACE,uBAAuB;EC3yyDzB;;ED8yyDA;IACE,uBAAuB;EC/yyDzB;;EDkzyDA;IACE,uBAAuB;ECnzyDzB;;EDszyDA;IACE,uBAAuB;ECvzyDzB;;ED0zyDA;IACE,uBAAuB;EC3zyDzB;;ED8zyDA;IACE,uBAAuB;EC/zyDzB;;EDk0yDA;IACE,uBAAuB;ECn0yDzB;;EDs0yDA;IACE,uBAAuB;ECv0yDzB;;ED00yDA;IACE,uBAAuB;EC30yDzB;;ED80yDA;IACE,uBAAuB;EC/0yDzB;;EDk1yDA;IACE,uBAAuB;ECn1yDzB;;EDs1yDA;IACE,uBAAuB;ECv1yDzB;;ED01yDA;IACE,uBAAuB;EC31yDzB;;ED81yDA;IACE,uBAAuB;EC/1yDzB;;EDk2yDA;IACE,uBAAuB;ECn2yDzB;;EDs2yDA;IACE,uBAAuB;ECv2yDzB;;ED02yDA;IACE,uBAAuB;EC32yDzB;;ED82yDA;IACE,uBAAuB;EC/2yDzB;;EDk3yDA;IACE,uBAAuB;ECn3yDzB;;EDs3yDA;IACE,uBAAuB;ECv3yDzB;;ED03yDA;IACE,uBAAuB;EC33yDzB;;ED83yDA;IACE,uBAAuB;EC/3yDzB;;EDk4yDA;IACE,uBAAuB;ECn4yDzB;;EDs4yDA;IACE,uBAAuB;ECv4yDzB;;ED04yDA;IACE,uBAAuB;EC34yDzB;;ED84yDA;IACE,uBAAuB;EC/4yDzB;;EDk5yDA;IACE,uBAAuB;ECn5yDzB;;EDs5yDA;IACE,uBAAuB;ECj5yD3B;;EDo5yDE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;EC35yDxB;;ED85yDA;IACE,sBAAsB;EC/5yDxB;;EDk6yDA;IACE,sBAAsB;ECn6yDxB;;EDs6yDA;IACE,sBAAsB;ECv6yDxB;;ED06yDA;IACE,sBAAsB;EC36yDxB;;ED86yDA;IACE,sBAAsB;EC/6yDxB;;EDk7yDA;IACE,sBAAsB;ECn7yDxB;;EDs7yDA;IACE,sBAAsB;ECv7yDxB;;ED07yDA;IACE,sBAAsB;EC37yDxB;;ED87yDA;IACE,sBAAsB;EC/7yDxB;;EDk8yDA;IACE,sBAAsB;ECn8yDxB;;EDs8yDA;IACE,sBAAsB;ECv8yDxB;;ED08yDA;IACE,sBAAsB;EC38yDxB;;ED88yDA;IACE,sBAAsB;EC/8yDxB;;EDk9yDA;IACE,sBAAsB;ECn9yDxB;;EDs9yDA;IACE,uBAAuB;ECv9yDzB;;ED09yDA;IACE,uBAAuB;EC39yDzB;;ED89yDA;IACE,uBAAuB;EC/9yDzB;;EDk+yDA;IACE,uBAAuB;ECn+yDzB;;EDs+yDA;IACE,uBAAuB;ECv+yDzB;;ED0+yDA;IACE,uBAAuB;EC3+yDzB;;ED8+yDA;IACE,uBAAuB;EC/+yDzB;;EDk/yDA;IACE,uBAAuB;ECn/yDzB;;EDs/yDA;IACE,uBAAuB;ECv/yDzB;;ED0/yDA;IACE,uBAAuB;EC3/yDzB;;ED8/yDA;IACE,uBAAuB;EC//yDzB;;EDkgzDA;IACE,uBAAuB;ECngzDzB;;EDsgzDA;IACE,uBAAuB;ECvgzDzB;;ED0gzDA;IACE,uBAAuB;EC3gzDzB;;ED8gzDA;IACE,uBAAuB;EC/gzDzB;;EDkhzDA;IACE,uBAAuB;ECnhzDzB;;EDshzDA;IACE,uBAAuB;ECvhzDzB;;ED0hzDA;IACE,uBAAuB;EC3hzDzB;;ED8hzDA;IACE,uBAAuB;EC/hzDzB;;EDkizDA;IACE,uBAAuB;ECnizDzB;;EDsizDA;IACE,uBAAuB;ECvizDzB;;ED0izDA;IACE,uBAAuB;EC3izDzB;;ED8izDA;IACE,uBAAuB;EC/izDzB;;EDkjzDA;IACE,uBAAuB;ECnjzDzB;;EDsjzDA;IACE,uBAAuB;ECvjzDzB;;ED0jzDA;IACE,uBAAuB;EC3jzDzB;;ED8jzDA;IACE,uBAAuB;EC/jzDzB;;EDkkzDA;IACE,uBAAuB;ECnkzDzB;;EDskzDA;IACE,uBAAuB;ECvkzDzB;;ED0kzDA;IACE,uBAAuB;EC3kzDzB;;ED8kzDA;IACE,uBAAuB;EC/kzDzB;;EDklzDA;IACE,uBAAuB;ECnlzDzB;;EDslzDA;IACE,uBAAuB;ECvlzDzB;;ED0lzDA;IACE,uBAAuB;EC3lzDzB;;ED8lzDA;IACE,uBAAuB;EC/lzDzB;;EDkmzDA;IACE,uBAAuB;ECnmzDzB;;EDsmzDA;IACE,uBAAuB;ECvmzDzB;;ED0mzDA;IACE,uBAAuB;EC3mzDzB;;ED8mzDA;IACE,uBAAuB;EC/mzDzB;;EDknzDA;IACE,uBAAuB;ECnnzDzB;;EDsnzDA;IACE,uBAAuB;ECvnzDzB;;ED0nzDA;IACE,uBAAuB;EC3nzDzB;;ED8nzDA;IACE,uBAAuB;EC/nzDzB;;EDkozDA;IACE,uBAAuB;ECnozDzB;;EDsozDA;IACE,uBAAuB;ECvozDzB;;ED0ozDA;IACE,uBAAuB;EC3ozDzB;;ED8ozDA;IACE,uBAAuB;EC/ozDzB;;EDkpzDA;IACE,uBAAuB;ECnpzDzB;;EDspzDA;IACE,uBAAuB;ECvpzDzB;;ED0pzDA;IACE,uBAAuB;EC3pzDzB;;ED8pzDA;IACE,uBAAuB;EC/pzDzB;;EDkqzDA;IACE,uBAAuB;ECnqzDzB;;EDsqzDA;IACE,uBAAuB;ECvqzDzB;;ED0qzDA;IACE,uBAAuB;EC3qzDzB;;ED8qzDA;IACE,uBAAuB;EC/qzDzB;;EDkrzDA;IACE,uBAAuB;ECnrzDzB;;EDsrzDA;IACE,uBAAuB;ECvrzDzB;;ED0rzDA;IACE,uBAAuB;EC3rzDzB;;ED8rzDA;IACE,uBAAuB;EC/rzDzB;;EDkszDA;IACE,uBAAuB;ECnszDzB;;EDsszDA;IACE,uBAAuB;ECvszDzB;;ED0szDA;IACE,uBAAuB;EC3szDzB;;ED8szDA;IACE,uBAAuB;EC/szDzB;;EDktzDA;IACE,uBAAuB;ECntzDzB;;EDstzDA;IACE,uBAAuB;ECvtzDzB;;ED0tzDA;IACE,uBAAuB;EC3tzDzB;;ED8tzDA;IACE,uBAAuB;EC/tzDzB;;EDkuzDA;IACE,uBAAuB;ECnuzDzB;;EDsuzDA;IACE,uBAAuB;ECvuzDzB;;ED0uzDA;IACE,uBAAuB;EC3uzDzB;;ED8uzDA;IACE,uBAAuB;EC/uzDzB;;EDkvzDA;IACE,uBAAuB;ECnvzDzB;;EDsvzDA;IACE,uBAAuB;ECvvzDzB;;ED0vzDA;IACE,uBAAuB;EC3vzDzB;;ED8vzDA;IACE,uBAAuB;EC/vzDzB;;EDkwzDA;IACE,uBAAuB;ECnwzDzB;;EDswzDA;IACE,uBAAuB;ECvwzDzB;;ED0wzDA;IACE,uBAAuB;EC3wzDzB;;ED8wzDA;IACE,uBAAuB;EC/wzDzB;;EDkxzDA;IACE,uBAAuB;ECnxzDzB;;EDsxzDA;IACE,uBAAuB;ECvxzDzB;;ED0xzDA;IACE,uBAAuB;EC3xzDzB;;ED8xzDA;IACE,uBAAuB;EC/xzDzB;;EDkyzDA;IACE,uBAAuB;ECnyzDzB;;EDsyzDA;IACE,uBAAuB;ECvyzDzB;;ED0yzDA;IACE,uBAAuB;EC3yzDzB;;ED8yzDA;IACE,uBAAuB;EC/yzDzB;;EDkzzDA;IACE,uBAAuB;ECnzzDzB;;EDszzDA;IACE,uBAAuB;ECvzzDzB;;ED0zzDA;IACE,uBAAuB;EC3zzDzB;;ED8zzDA;IACE,uBAAuB;EC/zzDzB;;EDk0zDA;IACE,uBAAuB;ECn0zDzB;;EDs0zDA;IACE,uBAAuB;ECv0zDzB;;ED00zDA;IACE,uBAAuB;EC30zDzB;;ED80zDA;IACE,uBAAuB;EC/0zDzB;;EDk1zDA;IACE,uBAAuB;ECn1zDzB;;EDs1zDA;IACE,uBAAuB;ECv1zDzB;;ED01zDA;IACE,uBAAuB;EC31zDzB;;ED81zDA;IACE,uBAAuB;EC/1zDzB;;EDk2zDA;IACE,uBAAuB;ECn2zDzB;;EDs2zDA;IACE,uBAAuB;ECv2zDzB;;ED02zDA;IACE,uBAAuB;EC32zDzB;;ED82zDA;IACE,uBAAuB;EC/2zDzB;;EDk3zDA;IACE,uBAAuB;ECn3zDzB;;EDs3zDA;IACE,uBAAuB;ECv3zDzB;;ED03zDA;IACE,uBAAuB;EC33zDzB;;ED83zDA;IACE,uBAAuB;EC/3zDzB;;EDk4zDA;IACE,uBAAuB;ECn4zDzB;;EDs4zDA;IACE,uBAAuB;ECv4zDzB;;ED04zDA;IACE,uBAAuB;EC34zDzB;;ED84zDA;IACE,uBAAuB;EC/4zDzB;;EDk5zDA;IACE,uBAAuB;ECn5zDzB;;EDs5zDA;IACE,uBAAuB;ECv5zDzB;;ED05zDA;IACE,uBAAuB;EC35zDzB;;ED85zDA;IACE,uBAAuB;EC/5zDzB;;EDk6zDA;IACE,uBAAuB;ECn6zDzB;;EDs6zDA;IACE,uBAAuB;ECv6zDzB;;ED06zDA;IACE,uBAAuB;EC36zDzB;;ED86zDA;IACE,uBAAuB;EC/6zDzB;;EDk7zDA;IACE,uBAAuB;ECn7zDzB;;EDs7zDA;IACE,uBAAuB;ECv7zDzB;;ED07zDA;IACE,uBAAuB;EC37zDzB;;ED87zDA;IACE,uBAAuB;EC/7zDzB;;EDk8zDA;IACE,uBAAuB;ECn8zDzB;;EDs8zDA;IACE,uBAAuB;ECv8zDzB;;ED08zDA;IACE,uBAAuB;EC38zDzB;;ED88zDA;IACE,uBAAuB;EC/8zDzB;;EDk9zDA;IACE,uBAAuB;ECn9zDzB;;EDs9zDA;IACE,uBAAuB;ECv9zDzB;;ED09zDA;IACE,uBAAuB;EC39zDzB;;ED89zDA;IACE,uBAAuB;EC/9zDzB;;EDk+zDA;IACE,uBAAuB;ECn+zDzB;;EDs+zDA;IACE,uBAAuB;ECv+zDzB;;ED0+zDA;IACE,uBAAuB;EC3+zDzB;;ED8+zDA;IACE,uBAAuB;EC/+zDzB;;EDk/zDA;IACE,uBAAuB;ECn/zDzB;;EDs/zDA;IACE,uBAAuB;ECv/zDzB;;ED0/zDA;IACE,uBAAuB;EC3/zDzB;;ED8/zDA;IACE,uBAAuB;ECz/zD3B;;ED4/zDE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;ECng0DxB;;EDsg0DA;IACE,sBAAsB;ECvg0DxB;;ED0g0DA;IACE,sBAAsB;EC3g0DxB;;ED8g0DA;IACE,sBAAsB;EC/g0DxB;;EDkh0DA;IACE,sBAAsB;ECnh0DxB;;EDsh0DA;IACE,sBAAsB;ECvh0DxB;;ED0h0DA;IACE,sBAAsB;EC3h0DxB;;ED8h0DA;IACE,sBAAsB;EC/h0DxB;;EDki0DA;IACE,sBAAsB;ECni0DxB;;EDsi0DA;IACE,sBAAsB;ECvi0DxB;;ED0i0DA;IACE,sBAAsB;EC3i0DxB;;ED8i0DA;IACE,sBAAsB;EC/i0DxB;;EDkj0DA;IACE,sBAAsB;ECnj0DxB;;EDsj0DA;IACE,sBAAsB;ECvj0DxB;;ED0j0DA;IACE,sBAAsB;EC3j0DxB;;ED8j0DA;IACE,uBAAuB;EC/j0DzB;;EDkk0DA;IACE,uBAAuB;ECnk0DzB;;EDsk0DA;IACE,uBAAuB;ECvk0DzB;;ED0k0DA;IACE,uBAAuB;EC3k0DzB;;ED8k0DA;IACE,uBAAuB;EC/k0DzB;;EDkl0DA;IACE,uBAAuB;ECnl0DzB;;EDsl0DA;IACE,uBAAuB;ECvl0DzB;;ED0l0DA;IACE,uBAAuB;EC3l0DzB;;ED8l0DA;IACE,uBAAuB;EC/l0DzB;;EDkm0DA;IACE,uBAAuB;ECnm0DzB;;EDsm0DA;IACE,uBAAuB;ECvm0DzB;;ED0m0DA;IACE,uBAAuB;EC3m0DzB;;ED8m0DA;IACE,uBAAuB;EC/m0DzB;;EDkn0DA;IACE,uBAAuB;ECnn0DzB;;EDsn0DA;IACE,uBAAuB;ECvn0DzB;;ED0n0DA;IACE,uBAAuB;EC3n0DzB;;ED8n0DA;IACE,uBAAuB;EC/n0DzB;;EDko0DA;IACE,uBAAuB;ECno0DzB;;EDso0DA;IACE,uBAAuB;ECvo0DzB;;ED0o0DA;IACE,uBAAuB;EC3o0DzB;;ED8o0DA;IACE,uBAAuB;EC/o0DzB;;EDkp0DA;IACE,uBAAuB;ECnp0DzB;;EDsp0DA;IACE,uBAAuB;ECvp0DzB;;ED0p0DA;IACE,uBAAuB;EC3p0DzB;;ED8p0DA;IACE,uBAAuB;EC/p0DzB;;EDkq0DA;IACE,uBAAuB;ECnq0DzB;;EDsq0DA;IACE,uBAAuB;ECvq0DzB;;ED0q0DA;IACE,uBAAuB;EC3q0DzB;;ED8q0DA;IACE,uBAAuB;EC/q0DzB;;EDkr0DA;IACE,uBAAuB;ECnr0DzB;;EDsr0DA;IACE,uBAAuB;ECvr0DzB;;ED0r0DA;IACE,uBAAuB;EC3r0DzB;;ED8r0DA;IACE,uBAAuB;EC/r0DzB;;EDks0DA;IACE,uBAAuB;ECns0DzB;;EDss0DA;IACE,uBAAuB;ECvs0DzB;;ED0s0DA;IACE,uBAAuB;EC3s0DzB;;ED8s0DA;IACE,uBAAuB;EC/s0DzB;;EDkt0DA;IACE,uBAAuB;ECnt0DzB;;EDst0DA;IACE,uBAAuB;ECvt0DzB;;ED0t0DA;IACE,uBAAuB;EC3t0DzB;;ED8t0DA;IACE,uBAAuB;EC/t0DzB;;EDku0DA;IACE,uBAAuB;ECnu0DzB;;EDsu0DA;IACE,uBAAuB;ECvu0DzB;;ED0u0DA;IACE,uBAAuB;EC3u0DzB;;ED8u0DA;IACE,uBAAuB;EC/u0DzB;;EDkv0DA;IACE,uBAAuB;ECnv0DzB;;EDsv0DA;IACE,uBAAuB;ECvv0DzB;;ED0v0DA;IACE,uBAAuB;EC3v0DzB;;ED8v0DA;IACE,uBAAuB;EC/v0DzB;;EDkw0DA;IACE,uBAAuB;ECnw0DzB;;EDsw0DA;IACE,uBAAuB;ECvw0DzB;;ED0w0DA;IACE,uBAAuB;EC3w0DzB;;ED8w0DA;IACE,uBAAuB;EC/w0DzB;;EDkx0DA;IACE,uBAAuB;ECnx0DzB;;EDsx0DA;IACE,uBAAuB;ECvx0DzB;;ED0x0DA;IACE,uBAAuB;EC3x0DzB;;ED8x0DA;IACE,uBAAuB;EC/x0DzB;;EDky0DA;IACE,uBAAuB;ECny0DzB;;EDsy0DA;IACE,uBAAuB;ECvy0DzB;;ED0y0DA;IACE,uBAAuB;EC3y0DzB;;ED8y0DA;IACE,uBAAuB;EC/y0DzB;;EDkz0DA;IACE,uBAAuB;ECnz0DzB;;EDsz0DA;IACE,uBAAuB;ECvz0DzB;;ED0z0DA;IACE,uBAAuB;EC3z0DzB;;ED8z0DA;IACE,uBAAuB;EC/z0DzB;;EDk00DA;IACE,uBAAuB;ECn00DzB;;EDs00DA;IACE,uBAAuB;ECv00DzB;;ED000DA;IACE,uBAAuB;EC300DzB;;ED800DA;IACE,uBAAuB;EC/00DzB;;EDk10DA;IACE,uBAAuB;ECn10DzB;;EDs10DA;IACE,uBAAuB;ECv10DzB;;ED010DA;IACE,uBAAuB;EC310DzB;;ED810DA;IACE,uBAAuB;EC/10DzB;;EDk20DA;IACE,uBAAuB;ECn20DzB;;EDs20DA;IACE,uBAAuB;ECv20DzB;;ED020DA;IACE,uBAAuB;EC320DzB;;ED820DA;IACE,uBAAuB;EC/20DzB;;EDk30DA;IACE,uBAAuB;ECn30DzB;;EDs30DA;IACE,uBAAuB;ECv30DzB;;ED030DA;IACE,uBAAuB;EC330DzB;;ED830DA;IACE,uBAAuB;EC/30DzB;;EDk40DA;IACE,uBAAuB;ECn40DzB;;EDs40DA;IACE,uBAAuB;ECv40DzB;;ED040DA;IACE,uBAAuB;EC340DzB;;ED840DA;IACE,uBAAuB;EC/40DzB;;EDk50DA;IACE,uBAAuB;ECn50DzB;;EDs50DA;IACE,uBAAuB;ECv50DzB;;ED050DA;IACE,uBAAuB;EC350DzB;;ED850DA;IACE,uBAAuB;EC/50DzB;;EDk60DA;IACE,uBAAuB;ECn60DzB;;EDs60DA;IACE,uBAAuB;ECv60DzB;;ED060DA;IACE,uBAAuB;EC360DzB;;ED860DA;IACE,uBAAuB;EC/60DzB;;EDk70DA;IACE,uBAAuB;ECn70DzB;;EDs70DA;IACE,uBAAuB;ECv70DzB;;ED070DA;IACE,uBAAuB;EC370DzB;;ED870DA;IACE,uBAAuB;EC/70DzB;;EDk80DA;IACE,uBAAuB;ECn80DzB;;EDs80DA;IACE,uBAAuB;ECv80DzB;;ED080DA;IACE,uBAAuB;EC380DzB;;ED880DA;IACE,uBAAuB;EC/80DzB;;EDk90DA;IACE,uBAAuB;ECn90DzB;;EDs90DA;IACE,uBAAuB;ECv90DzB;;ED090DA;IACE,uBAAuB;EC390DzB;;ED890DA;IACE,uBAAuB;EC/90DzB;;EDk+0DA;IACE,uBAAuB;ECn+0DzB;;EDs+0DA;IACE,uBAAuB;ECv+0DzB;;ED0+0DA;IACE,uBAAuB;EC3+0DzB;;ED8+0DA;IACE,uBAAuB;EC/+0DzB;;EDk/0DA;IACE,uBAAuB;ECn/0DzB;;EDs/0DA;IACE,uBAAuB;ECv/0DzB;;ED0/0DA;IACE,uBAAuB;EC3/0DzB;;ED8/0DA;IACE,uBAAuB;EC//0DzB;;EDkg1DA;IACE,uBAAuB;ECng1DzB;;EDsg1DA;IACE,uBAAuB;ECvg1DzB;;ED0g1DA;IACE,uBAAuB;EC3g1DzB;;ED8g1DA;IACE,uBAAuB;EC/g1DzB;;EDkh1DA;IACE,uBAAuB;ECnh1DzB;;EDsh1DA;IACE,uBAAuB;ECvh1DzB;;ED0h1DA;IACE,uBAAuB;EC3h1DzB;;ED8h1DA;IACE,uBAAuB;EC/h1DzB;;EDki1DA;IACE,uBAAuB;ECni1DzB;;EDsi1DA;IACE,uBAAuB;ECvi1DzB;;ED0i1DA;IACE,uBAAuB;EC3i1DzB;;ED8i1DA;IACE,uBAAuB;EC/i1DzB;;EDkj1DA;IACE,uBAAuB;ECnj1DzB;;EDsj1DA;IACE,uBAAuB;ECvj1DzB;;ED0j1DA;IACE,uBAAuB;EC3j1DzB;;ED8j1DA;IACE,uBAAuB;EC/j1DzB;;EDkk1DA;IACE,uBAAuB;ECnk1DzB;;EDsk1DA;IACE,uBAAuB;ECvk1DzB;;ED0k1DA;IACE,uBAAuB;EC3k1DzB;;ED8k1DA;IACE,uBAAuB;EC/k1DzB;;EDkl1DA;IACE,uBAAuB;ECnl1DzB;;EDsl1DA;IACE,uBAAuB;ECvl1DzB;;ED0l1DA;IACE,uBAAuB;EC3l1DzB;;ED8l1DA;IACE,uBAAuB;EC/l1DzB;;EDkm1DA;IACE,uBAAuB;ECnm1DzB;;EDsm1DA;IACE,uBAAuB;ECjm1D3B;;EDom1DE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;EC3m1DxB;;ED8m1DA;IACE,sBAAsB;EC/m1DxB;;EDkn1DA;IACE,sBAAsB;ECnn1DxB;;EDsn1DA;IACE,sBAAsB;ECvn1DxB;;ED0n1DA;IACE,sBAAsB;EC3n1DxB;;ED8n1DA;IACE,sBAAsB;EC/n1DxB;;EDko1DA;IACE,sBAAsB;ECno1DxB;;EDso1DA;IACE,sBAAsB;ECvo1DxB;;ED0o1DA;IACE,sBAAsB;EC3o1DxB;;ED8o1DA;IACE,sBAAsB;EC/o1DxB;;EDkp1DA;IACE,sBAAsB;ECnp1DxB;;EDsp1DA;IACE,sBAAsB;ECvp1DxB;;ED0p1DA;IACE,sBAAsB;EC3p1DxB;;ED8p1DA;IACE,sBAAsB;EC/p1DxB;;EDkq1DA;IACE,sBAAsB;ECnq1DxB;;EDsq1DA;IACE,uBAAuB;ECvq1DzB;;ED0q1DA;IACE,uBAAuB;EC3q1DzB;;ED8q1DA;IACE,uBAAuB;EC/q1DzB;;EDkr1DA;IACE,uBAAuB;ECnr1DzB;;EDsr1DA;IACE,uBAAuB;ECvr1DzB;;ED0r1DA;IACE,uBAAuB;EC3r1DzB;;ED8r1DA;IACE,uBAAuB;EC/r1DzB;;EDks1DA;IACE,uBAAuB;ECns1DzB;;EDss1DA;IACE,uBAAuB;ECvs1DzB;;ED0s1DA;IACE,uBAAuB;EC3s1DzB;;ED8s1DA;IACE,uBAAuB;EC/s1DzB;;EDkt1DA;IACE,uBAAuB;ECnt1DzB;;EDst1DA;IACE,uBAAuB;ECvt1DzB;;ED0t1DA;IACE,uBAAuB;EC3t1DzB;;ED8t1DA;IACE,uBAAuB;EC/t1DzB;;EDku1DA;IACE,uBAAuB;ECnu1DzB;;EDsu1DA;IACE,uBAAuB;ECvu1DzB;;ED0u1DA;IACE,uBAAuB;EC3u1DzB;;ED8u1DA;IACE,uBAAuB;EC/u1DzB;;EDkv1DA;IACE,uBAAuB;ECnv1DzB;;EDsv1DA;IACE,uBAAuB;ECvv1DzB;;ED0v1DA;IACE,uBAAuB;EC3v1DzB;;ED8v1DA;IACE,uBAAuB;EC/v1DzB;;EDkw1DA;IACE,uBAAuB;ECnw1DzB;;EDsw1DA;IACE,uBAAuB;ECvw1DzB;;ED0w1DA;IACE,uBAAuB;EC3w1DzB;;ED8w1DA;IACE,uBAAuB;EC/w1DzB;;EDkx1DA;IACE,uBAAuB;ECnx1DzB;;EDsx1DA;IACE,uBAAuB;ECvx1DzB;;ED0x1DA;IACE,uBAAuB;EC3x1DzB;;ED8x1DA;IACE,uBAAuB;EC/x1DzB;;EDky1DA;IACE,uBAAuB;ECny1DzB;;EDsy1DA;IACE,uBAAuB;ECvy1DzB;;ED0y1DA;IACE,uBAAuB;EC3y1DzB;;ED8y1DA;IACE,uBAAuB;EC/y1DzB;;EDkz1DA;IACE,uBAAuB;ECnz1DzB;;EDsz1DA;IACE,uBAAuB;ECvz1DzB;;ED0z1DA;IACE,uBAAuB;EC3z1DzB;;ED8z1DA;IACE,uBAAuB;EC/z1DzB;;EDk01DA;IACE,uBAAuB;ECn01DzB;;EDs01DA;IACE,uBAAuB;ECv01DzB;;ED001DA;IACE,uBAAuB;EC301DzB;;ED801DA;IACE,uBAAuB;EC/01DzB;;EDk11DA;IACE,uBAAuB;ECn11DzB;;EDs11DA;IACE,uBAAuB;ECv11DzB;;ED011DA;IACE,uBAAuB;EC311DzB;;ED811DA;IACE,uBAAuB;EC/11DzB;;EDk21DA;IACE,uBAAuB;ECn21DzB;;EDs21DA;IACE,uBAAuB;ECv21DzB;;ED021DA;IACE,uBAAuB;EC321DzB;;ED821DA;IACE,uBAAuB;EC/21DzB;;EDk31DA;IACE,uBAAuB;ECn31DzB;;EDs31DA;IACE,uBAAuB;ECv31DzB;;ED031DA;IACE,uBAAuB;EC331DzB;;ED831DA;IACE,uBAAuB;EC/31DzB;;EDk41DA;IACE,uBAAuB;ECn41DzB;;EDs41DA;IACE,uBAAuB;ECv41DzB;;ED041DA;IACE,uBAAuB;EC341DzB;;ED841DA;IACE,uBAAuB;EC/41DzB;;EDk51DA;IACE,uBAAuB;ECn51DzB;;EDs51DA;IACE,uBAAuB;ECv51DzB;;ED051DA;IACE,uBAAuB;EC351DzB;;ED851DA;IACE,uBAAuB;EC/51DzB;;EDk61DA;IACE,uBAAuB;ECn61DzB;;EDs61DA;IACE,uBAAuB;ECv61DzB;;ED061DA;IACE,uBAAuB;EC361DzB;;ED861DA;IACE,uBAAuB;EC/61DzB;;EDk71DA;IACE,uBAAuB;ECn71DzB;;EDs71DA;IACE,uBAAuB;ECv71DzB;;ED071DA;IACE,uBAAuB;EC371DzB;;ED871DA;IACE,uBAAuB;EC/71DzB;;EDk81DA;IACE,uBAAuB;ECn81DzB;;EDs81DA;IACE,uBAAuB;ECv81DzB;;ED081DA;IACE,uBAAuB;EC381DzB;;ED881DA;IACE,uBAAuB;EC/81DzB;;EDk91DA;IACE,uBAAuB;ECn91DzB;;EDs91DA;IACE,uBAAuB;ECv91DzB;;ED091DA;IACE,uBAAuB;EC391DzB;;ED891DA;IACE,uBAAuB;EC/91DzB;;EDk+1DA;IACE,uBAAuB;ECn+1DzB;;EDs+1DA;IACE,uBAAuB;ECv+1DzB;;ED0+1DA;IACE,uBAAuB;EC3+1DzB;;ED8+1DA;IACE,uBAAuB;EC/+1DzB;;EDk/1DA;IACE,uBAAuB;ECn/1DzB;;EDs/1DA;IACE,uBAAuB;ECv/1DzB;;ED0/1DA;IACE,uBAAuB;EC3/1DzB;;ED8/1DA;IACE,uBAAuB;EC//1DzB;;EDkg2DA;IACE,uBAAuB;ECng2DzB;;EDsg2DA;IACE,uBAAuB;ECvg2DzB;;ED0g2DA;IACE,uBAAuB;EC3g2DzB;;ED8g2DA;IACE,uBAAuB;EC/g2DzB;;EDkh2DA;IACE,uBAAuB;ECnh2DzB;;EDsh2DA;IACE,uBAAuB;ECvh2DzB;;ED0h2DA;IACE,uBAAuB;EC3h2DzB;;ED8h2DA;IACE,uBAAuB;EC/h2DzB;;EDki2DA;IACE,uBAAuB;ECni2DzB;;EDsi2DA;IACE,uBAAuB;ECvi2DzB;;ED0i2DA;IACE,uBAAuB;EC3i2DzB;;ED8i2DA;IACE,uBAAuB;EC/i2DzB;;EDkj2DA;IACE,uBAAuB;ECnj2DzB;;EDsj2DA;IACE,uBAAuB;ECvj2DzB;;ED0j2DA;IACE,uBAAuB;EC3j2DzB;;ED8j2DA;IACE,uBAAuB;EC/j2DzB;;EDkk2DA;IACE,uBAAuB;ECnk2DzB;;EDsk2DA;IACE,uBAAuB;ECvk2DzB;;ED0k2DA;IACE,uBAAuB;EC3k2DzB;;ED8k2DA;IACE,uBAAuB;EC/k2DzB;;EDkl2DA;IACE,uBAAuB;ECnl2DzB;;EDsl2DA;IACE,uBAAuB;ECvl2DzB;;ED0l2DA;IACE,uBAAuB;EC3l2DzB;;ED8l2DA;IACE,uBAAuB;EC/l2DzB;;EDkm2DA;IACE,uBAAuB;ECnm2DzB;;EDsm2DA;IACE,uBAAuB;ECvm2DzB;;ED0m2DA;IACE,uBAAuB;EC3m2DzB;;ED8m2DA;IACE,uBAAuB;EC/m2DzB;;EDkn2DA;IACE,uBAAuB;ECnn2DzB;;EDsn2DA;IACE,uBAAuB;ECvn2DzB;;ED0n2DA;IACE,uBAAuB;EC3n2DzB;;ED8n2DA;IACE,uBAAuB;EC/n2DzB;;EDko2DA;IACE,uBAAuB;ECno2DzB;;EDso2DA;IACE,uBAAuB;ECvo2DzB;;ED0o2DA;IACE,uBAAuB;EC3o2DzB;;ED8o2DA;IACE,uBAAuB;EC/o2DzB;;EDkp2DA;IACE,uBAAuB;ECnp2DzB;;EDsp2DA;IACE,uBAAuB;ECvp2DzB;;ED0p2DA;IACE,uBAAuB;EC3p2DzB;;ED8p2DA;IACE,uBAAuB;EC/p2DzB;;EDkq2DA;IACE,uBAAuB;ECnq2DzB;;EDsq2DA;IACE,uBAAuB;ECvq2DzB;;ED0q2DA;IACE,uBAAuB;EC3q2DzB;;ED8q2DA;IACE,uBAAuB;EC/q2DzB;;EDkr2DA;IACE,uBAAuB;ECnr2DzB;;EDsr2DA;IACE,uBAAuB;ECvr2DzB;;ED0r2DA;IACE,uBAAuB;EC3r2DzB;;ED8r2DA;IACE,uBAAuB;EC/r2DzB;;EDks2DA;IACE,uBAAuB;ECns2DzB;;EDss2DA;IACE,uBAAuB;ECvs2DzB;;ED0s2DA;IACE,uBAAuB;EC3s2DzB;;ED8s2DA;IACE,uBAAuB;ECzs2D3B;;ED4s2DE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;ECnt2DxB;;EDst2DA;IACE,sBAAsB;ECvt2DxB;;ED0t2DA;IACE,sBAAsB;EC3t2DxB;;ED8t2DA;IACE,sBAAsB;EC/t2DxB;;EDku2DA;IACE,sBAAsB;ECnu2DxB;;EDsu2DA;IACE,sBAAsB;ECvu2DxB;;ED0u2DA;IACE,sBAAsB;EC3u2DxB;;ED8u2DA;IACE,sBAAsB;EC/u2DxB;;EDkv2DA;IACE,sBAAsB;ECnv2DxB;;EDsv2DA;IACE,sBAAsB;ECvv2DxB;;ED0v2DA;IACE,sBAAsB;EC3v2DxB;;ED8v2DA;IACE,sBAAsB;EC/v2DxB;;EDkw2DA;IACE,sBAAsB;ECnw2DxB;;EDsw2DA;IACE,sBAAsB;ECvw2DxB;;ED0w2DA;IACE,sBAAsB;EC3w2DxB;;ED8w2DA;IACE,uBAAuB;EC/w2DzB;;EDkx2DA;IACE,uBAAuB;ECnx2DzB;;EDsx2DA;IACE,uBAAuB;ECvx2DzB;;ED0x2DA;IACE,uBAAuB;EC3x2DzB;;ED8x2DA;IACE,uBAAuB;EC/x2DzB;;EDky2DA;IACE,uBAAuB;ECny2DzB;;EDsy2DA;IACE,uBAAuB;ECvy2DzB;;ED0y2DA;IACE,uBAAuB;EC3y2DzB;;ED8y2DA;IACE,uBAAuB;EC/y2DzB;;EDkz2DA;IACE,uBAAuB;ECnz2DzB;;EDsz2DA;IACE,uBAAuB;ECvz2DzB;;ED0z2DA;IACE,uBAAuB;EC3z2DzB;;ED8z2DA;IACE,uBAAuB;EC/z2DzB;;EDk02DA;IACE,uBAAuB;ECn02DzB;;EDs02DA;IACE,uBAAuB;ECv02DzB;;ED002DA;IACE,uBAAuB;EC302DzB;;ED802DA;IACE,uBAAuB;EC/02DzB;;EDk12DA;IACE,uBAAuB;ECn12DzB;;EDs12DA;IACE,uBAAuB;ECv12DzB;;ED012DA;IACE,uBAAuB;EC312DzB;;ED812DA;IACE,uBAAuB;EC/12DzB;;EDk22DA;IACE,uBAAuB;ECn22DzB;;EDs22DA;IACE,uBAAuB;ECv22DzB;;ED022DA;IACE,uBAAuB;EC322DzB;;ED822DA;IACE,uBAAuB;EC/22DzB;;EDk32DA;IACE,uBAAuB;ECn32DzB;;EDs32DA;IACE,uBAAuB;ECv32DzB;;ED032DA;IACE,uBAAuB;EC332DzB;;ED832DA;IACE,uBAAuB;EC/32DzB;;EDk42DA;IACE,uBAAuB;ECn42DzB;;EDs42DA;IACE,uBAAuB;ECv42DzB;;ED042DA;IACE,uBAAuB;EC342DzB;;ED842DA;IACE,uBAAuB;EC/42DzB;;EDk52DA;IACE,uBAAuB;ECn52DzB;;EDs52DA;IACE,uBAAuB;ECv52DzB;;ED052DA;IACE,uBAAuB;EC352DzB;;ED852DA;IACE,uBAAuB;EC/52DzB;;EDk62DA;IACE,uBAAuB;ECn62DzB;;EDs62DA;IACE,uBAAuB;ECv62DzB;;ED062DA;IACE,uBAAuB;EC362DzB;;ED862DA;IACE,uBAAuB;EC/62DzB;;EDk72DA;IACE,uBAAuB;ECn72DzB;;EDs72DA;IACE,uBAAuB;ECv72DzB;;ED072DA;IACE,uBAAuB;EC372DzB;;ED872DA;IACE,uBAAuB;EC/72DzB;;EDk82DA;IACE,uBAAuB;ECn82DzB;;EDs82DA;IACE,uBAAuB;ECv82DzB;;ED082DA;IACE,uBAAuB;EC382DzB;;ED882DA;IACE,uBAAuB;EC/82DzB;;EDk92DA;IACE,uBAAuB;ECn92DzB;;EDs92DA;IACE,uBAAuB;ECv92DzB;;ED092DA;IACE,uBAAuB;EC392DzB;;ED892DA;IACE,uBAAuB;EC/92DzB;;EDk+2DA;IACE,uBAAuB;ECn+2DzB;;EDs+2DA;IACE,uBAAuB;ECv+2DzB;;ED0+2DA;IACE,uBAAuB;EC3+2DzB;;ED8+2DA;IACE,uBAAuB;EC/+2DzB;;EDk/2DA;IACE,uBAAuB;ECn/2DzB;;EDs/2DA;IACE,uBAAuB;ECv/2DzB;;ED0/2DA;IACE,uBAAuB;EC3/2DzB;;ED8/2DA;IACE,uBAAuB;EC//2DzB;;EDkg3DA;IACE,uBAAuB;ECng3DzB;;EDsg3DA;IACE,uBAAuB;ECvg3DzB;;ED0g3DA;IACE,uBAAuB;EC3g3DzB;;ED8g3DA;IACE,uBAAuB;EC/g3DzB;;EDkh3DA;IACE,uBAAuB;ECnh3DzB;;EDsh3DA;IACE,uBAAuB;ECvh3DzB;;ED0h3DA;IACE,uBAAuB;EC3h3DzB;;ED8h3DA;IACE,uBAAuB;EC/h3DzB;;EDki3DA;IACE,uBAAuB;ECni3DzB;;EDsi3DA;IACE,uBAAuB;ECvi3DzB;;ED0i3DA;IACE,uBAAuB;EC3i3DzB;;ED8i3DA;IACE,uBAAuB;EC/i3DzB;;EDkj3DA;IACE,uBAAuB;ECnj3DzB;;EDsj3DA;IACE,uBAAuB;ECvj3DzB;;ED0j3DA;IACE,uBAAuB;EC3j3DzB;;ED8j3DA;IACE,uBAAuB;EC/j3DzB;;EDkk3DA;IACE,uBAAuB;ECnk3DzB;;EDsk3DA;IACE,uBAAuB;ECvk3DzB;;ED0k3DA;IACE,uBAAuB;EC3k3DzB;;ED8k3DA;IACE,uBAAuB;EC/k3DzB;;EDkl3DA;IACE,uBAAuB;ECnl3DzB;;EDsl3DA;IACE,uBAAuB;ECvl3DzB;;ED0l3DA;IACE,uBAAuB;EC3l3DzB;;ED8l3DA;IACE,uBAAuB;EC/l3DzB;;EDkm3DA;IACE,uBAAuB;ECnm3DzB;;EDsm3DA;IACE,uBAAuB;ECvm3DzB;;ED0m3DA;IACE,uBAAuB;EC3m3DzB;;ED8m3DA;IACE,uBAAuB;EC/m3DzB;;EDkn3DA;IACE,uBAAuB;ECnn3DzB;;EDsn3DA;IACE,uBAAuB;ECvn3DzB;;ED0n3DA;IACE,uBAAuB;EC3n3DzB;;ED8n3DA;IACE,uBAAuB;EC/n3DzB;;EDko3DA;IACE,uBAAuB;ECno3DzB;;EDso3DA;IACE,uBAAuB;ECvo3DzB;;ED0o3DA;IACE,uBAAuB;EC3o3DzB;;ED8o3DA;IACE,uBAAuB;EC/o3DzB;;EDkp3DA;IACE,uBAAuB;ECnp3DzB;;EDsp3DA;IACE,uBAAuB;ECvp3DzB;;ED0p3DA;IACE,uBAAuB;EC3p3DzB;;ED8p3DA;IACE,uBAAuB;EC/p3DzB;;EDkq3DA;IACE,uBAAuB;ECnq3DzB;;EDsq3DA;IACE,uBAAuB;ECvq3DzB;;ED0q3DA;IACE,uBAAuB;EC3q3DzB;;ED8q3DA;IACE,uBAAuB;EC/q3DzB;;EDkr3DA;IACE,uBAAuB;ECnr3DzB;;EDsr3DA;IACE,uBAAuB;ECvr3DzB;;ED0r3DA;IACE,uBAAuB;EC3r3DzB;;ED8r3DA;IACE,uBAAuB;EC/r3DzB;;EDks3DA;IACE,uBAAuB;ECns3DzB;;EDss3DA;IACE,uBAAuB;ECvs3DzB;;ED0s3DA;IACE,uBAAuB;EC3s3DzB;;ED8s3DA;IACE,uBAAuB;EC/s3DzB;;EDkt3DA;IACE,uBAAuB;ECnt3DzB;;EDst3DA;IACE,uBAAuB;ECvt3DzB;;ED0t3DA;IACE,uBAAuB;EC3t3DzB;;ED8t3DA;IACE,uBAAuB;EC/t3DzB;;EDku3DA;IACE,uBAAuB;ECnu3DzB;;EDsu3DA;IACE,uBAAuB;ECvu3DzB;;ED0u3DA;IACE,uBAAuB;EC3u3DzB;;ED8u3DA;IACE,uBAAuB;EC/u3DzB;;EDkv3DA;IACE,uBAAuB;ECnv3DzB;;EDsv3DA;IACE,uBAAuB;ECvv3DzB;;ED0v3DA;IACE,uBAAuB;EC3v3DzB;;ED8v3DA;IACE,uBAAuB;EC/v3DzB;;EDkw3DA;IACE,uBAAuB;ECnw3DzB;;EDsw3DA;IACE,uBAAuB;ECvw3DzB;;ED0w3DA;IACE,uBAAuB;EC3w3DzB;;ED8w3DA;IACE,uBAAuB;EC/w3DzB;;EDkx3DA;IACE,uBAAuB;ECnx3DzB;;EDsx3DA;IACE,uBAAuB;ECvx3DzB;;ED0x3DA;IACE,uBAAuB;EC3x3DzB;;ED8x3DA;IACE,uBAAuB;EC/x3DzB;;EDky3DA;IACE,uBAAuB;ECny3DzB;;EDsy3DA;IACE,uBAAuB;ECvy3DzB;;ED0y3DA;IACE,uBAAuB;EC3y3DzB;;ED8y3DA;IACE,uBAAuB;EC/y3DzB;;EDkz3DA;IACE,uBAAuB;ECnz3DzB;;EDsz3DA;IACE,uBAAuB;ECjz3D3B;;EAIQ;IDiz3DJ,uBAAuB;EACzB;;EClz3DM;IDqz3DJ,uBAAuB;EACzB;ACvz3DD;ADyz3DD,sBCxz3De;ADyz3Df;EACE,oBAAoB;AC3z3DrB;;AD8z3DD;EACE,qBAAqB;AC/z3DtB;;ADk03DD;EACE,qBAAqB;ACn03DtB;;ADs03DD;EACE,qBAAqB;ACv03DtB;;AD003DD;EACE,qBAAqB;AC303DtB;;AD803DD;EACE,qBAAqB;AC/03DtB;;ADk13DD;EACE,qBAAqB;ACn13DtB;;ADs13DD;EACE,qBAAqB;ACv13DtB;;AD013DD;EACE,qBAAqB;AC313DtB;;AD813DD;EACE,qBAAqB;AC/13DtB;;ADk23DD;EACE,qBAAqB;ACn23DtB;;ADs23DD;EACE,qBAAqB;ACv23DtB;;AD023DD;EACE,qBAAqB;AC323DtB;;AD823DD;EACE,qBAAqB;AC/23DtB;;ADk33DD;EACE,qBAAqB;ACn33DtB;;ADs33DD;EACE,qBAAqB;ACv33DtB;;AD033DD;EACE,qBAAqB;AC333DtB;;AD833DD;EACE,qBAAqB;AC133DvB;;AD633DA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,oBAAoB;ECp43DtB;;EDu43DA;IACE,qBAAqB;ECx43DvB;;ED243DA;IACE,qBAAqB;EC543DvB;;ED+43DA;IACE,qBAAqB;ECh53DvB;;EDm53DA;IACE,qBAAqB;ECp53DvB;;EDu53DA;IACE,qBAAqB;ECx53DvB;;ED253DA;IACE,qBAAqB;EC553DvB;;ED+53DA;IACE,qBAAqB;ECh63DvB;;EDm63DA;IACE,qBAAqB;ECp63DvB;;EDu63DA;IACE,qBAAqB;ECx63DvB;;ED263DA;IACE,qBAAqB;EC563DvB;;ED+63DA;IACE,qBAAqB;ECh73DvB;;EDm73DA;IACE,qBAAqB;ECp73DvB;;EDu73DA;IACE,qBAAqB;ECx73DvB;;ED273DA;IACE,qBAAqB;EC573DvB;;ED+73DA;IACE,qBAAqB;ECh83DvB;;EDm83DA;IACE,qBAAqB;ECp83DvB;;EDu83DA;IACE,qBAAqB;ECl83DzB;;EDq83DE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,oBAAoB;EC583DtB;;ED+83DA;IACE,qBAAqB;ECh93DvB;;EDm93DA;IACE,qBAAqB;ECp93DvB;;EDu93DA;IACE,qBAAqB;ECx93DvB;;ED293DA;IACE,qBAAqB;EC593DvB;;ED+93DA;IACE,qBAAqB;ECh+3DvB;;EDm+3DA;IACE,qBAAqB;ECp+3DvB;;EDu+3DA;IACE,qBAAqB;ECx+3DvB;;ED2+3DA;IACE,qBAAqB;EC5+3DvB;;ED++3DA;IACE,qBAAqB;ECh/3DvB;;EDm/3DA;IACE,qBAAqB;ECp/3DvB;;EDu/3DA;IACE,qBAAqB;ECx/3DvB;;ED2/3DA;IACE,qBAAqB;EC5/3DvB;;ED+/3DA;IACE,qBAAqB;EChg4DvB;;EDmg4DA;IACE,qBAAqB;ECpg4DvB;;EDug4DA;IACE,qBAAqB;ECxg4DvB;;ED2g4DA;IACE,qBAAqB;EC5g4DvB;;ED+g4DA;IACE,qBAAqB;EC1g4DzB;;ED6g4DE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,oBAAoB;ECph4DtB;;EDuh4DA;IACE,qBAAqB;ECxh4DvB;;ED2h4DA;IACE,qBAAqB;EC5h4DvB;;ED+h4DA;IACE,qBAAqB;EChi4DvB;;EDmi4DA;IACE,qBAAqB;ECpi4DvB;;EDui4DA;IACE,qBAAqB;ECxi4DvB;;ED2i4DA;IACE,qBAAqB;EC5i4DvB;;ED+i4DA;IACE,qBAAqB;EChj4DvB;;EDmj4DA;IACE,qBAAqB;ECpj4DvB;;EDuj4DA;IACE,qBAAqB;ECxj4DvB;;ED2j4DA;IACE,qBAAqB;EC5j4DvB;;ED+j4DA;IACE,qBAAqB;EChk4DvB;;EDmk4DA;IACE,qBAAqB;ECpk4DvB;;EDuk4DA;IACE,qBAAqB;ECxk4DvB;;ED2k4DA;IACE,qBAAqB;EC5k4DvB;;ED+k4DA;IACE,qBAAqB;EChl4DvB;;EDml4DA;IACE,qBAAqB;ECpl4DvB;;EDul4DA;IACE,qBAAqB;ECll4DzB;;EDql4DE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,oBAAoB;EC5l4DtB;;ED+l4DA;IACE,qBAAqB;EChm4DvB;;EDmm4DA;IACE,qBAAqB;ECpm4DvB;;EDum4DA;IACE,qBAAqB;ECxm4DvB;;ED2m4DA;IACE,qBAAqB;EC5m4DvB;;ED+m4DA;IACE,qBAAqB;EChn4DvB;;EDmn4DA;IACE,qBAAqB;ECpn4DvB;;EDun4DA;IACE,qBAAqB;ECxn4DvB;;ED2n4DA;IACE,qBAAqB;EC5n4DvB;;ED+n4DA;IACE,qBAAqB;ECho4DvB;;EDmo4DA;IACE,qBAAqB;ECpo4DvB;;EDuo4DA;IACE,qBAAqB;ECxo4DvB;;ED2o4DA;IACE,qBAAqB;EC5o4DvB;;ED+o4DA;IACE,qBAAqB;EChp4DvB;;EDmp4DA;IACE,qBAAqB;ECpp4DvB;;EDup4DA;IACE,qBAAqB;ECxp4DvB;;ED2p4DA;IACE,qBAAqB;EC5p4DvB;;ED+p4DA;IACE,qBAAqB;EC1p4DzB;;ED6p4DE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,oBAAoB;ECpq4DtB;;EDuq4DA;IACE,qBAAqB;ECxq4DvB;;ED2q4DA;IACE,qBAAqB;EC5q4DvB;;ED+q4DA;IACE,qBAAqB;EChr4DvB;;EDmr4DA;IACE,qBAAqB;ECpr4DvB;;EDur4DA;IACE,qBAAqB;ECxr4DvB;;ED2r4DA;IACE,qBAAqB;EC5r4DvB;;ED+r4DA;IACE,qBAAqB;EChs4DvB;;EDms4DA;IACE,qBAAqB;ECps4DvB;;EDus4DA;IACE,qBAAqB;ECxs4DvB;;ED2s4DA;IACE,qBAAqB;EC5s4DvB;;ED+s4DA;IACE,qBAAqB;ECht4DvB;;EDmt4DA;IACE,qBAAqB;ECpt4DvB;;EDut4DA;IACE,qBAAqB;ECxt4DvB;;ED2t4DA;IACE,qBAAqB;EC5t4DvB;;ED+t4DA;IACE,qBAAqB;EChu4DvB;;EDmu4DA;IACE,qBAAqB;ECpu4DvB;;EDuu4DA;IACE,qBAAqB;EClu4DzB;;EAIQ;IDku4DJ,qBAAqB;EACvB;;ECnu4DM;IDsu4DJ,sBAAsB;EACxB;ACxu4DE;AD0u4DJ,YCzu4DiB;AD0u4DjB;EACE,0BAA0B;AC5u4DxB;;AD+u4DJ;EACE,0BAA0B;AChv4DxB;;ADmv4DJ;EACE,0BAA0B;ACpv4DxB;;ADuv4DJ;EACE,2BAA2B;ACxv4DzB;;AD2v4DJ;EACE,2BAA2B;AC5v4DzB;;AD+v4DJ;EACE,2BAA2B;AChw4DzB;;ADmw4DJ;EACE,2BAA2B;ACpw4DzB;;ADuw4DJ;EACE,2BAA2B;ACxw4DzB;;AD2w4DJ;EACE,2BAA2B;AC5w4DzB;;AD+w4DJ;EACE,2BAA2B;AChx4DzB;;ADmx4DJ;EACE,2BAA2B;ACpx4DzB;;ADux4DJ;EACE,2BAA2B;ACxx4DzB;;AD2x4DJ;EACE,2BAA2B;AC5x4DzB;;AD+x4DJ;EACE,2BAA2B;AChy4DzB;;ADmy4DJ;EACE,2BAA2B;ACpy4DzB;;ADuy4DJ;EACE,2BAA2B;ACxy4DzB;;AD2y4DJ;EACE,2BAA2B;AC5y4DzB;;AD+y4DJ;EACE,2BAA2B;AChz4DzB;;ADmz4DJ;EACE,2BAA2B;ACpz4DzB;;ADuz4DJ;EACE,2BAA2B;ACxz4DzB;;AD2z4DJ;EACE,2BAA2B;AC5z4DzB;;AD+z4DJ;EACE,2BAA2B;ACh04DzB;;ADm04DJ;EACE,2BAA2B;ACp04DzB;;ADu04DJ;EACE,2BAA2B;ACx04DzB;;AD204DJ;EACE,2BAA2B;AC504DzB;;AD+04DJ;EACE,2BAA2B;ACh14DzB;;ADm14DJ;EACE,2BAA2B;ACp14DzB;;ADu14DJ;EACE,2BAA2B;ACx14DzB;;AD214DJ;EACE,2BAA2B;AC514DzB;;AD+14DJ;EACE,2BAA2B;AC114D7B;;AD614DA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YC914DiB;AD+14DjB;EACE,uBAAuB;ACj24DrB;;ADo24DJ;EACE,0BAA0B;ACr24DxB;;ADw24DJ;EACE,0BAA0B;ACz24DxB;;AD424DJ;EACE,0BAA0B;AC724DxB;;ADg34DJ;EACE,2BAA2B;ACj34DzB;;ADo34DJ;EACE,2BAA2B;ACr34DzB;;ADw34DJ;EACE,2BAA2B;ACz34DzB;;AD434DJ;EACE,2BAA2B;AC734DzB;;ADg44DJ;EACE,2BAA2B;ACj44DzB;;ADo44DJ;EACE,2BAA2B;ACr44DzB;;ADw44DJ;EACE,2BAA2B;ACz44DzB;;AD444DJ;EACE,2BAA2B;AC744DzB;;ADg54DJ;EACE,2BAA2B;ACj54DzB;;ADo54DJ;EACE,2BAA2B;ACr54DzB;;ADw54DJ;EACE,2BAA2B;ACz54DzB;;AD454DJ;EACE,2BAA2B;AC754DzB;;ADg64DJ;EACE,2BAA2B;ACj64DzB;;ADo64DJ;EACE,2BAA2B;ACr64DzB;;ADw64DJ;EACE,2BAA2B;ACz64DzB;;AD464DJ;EACE,2BAA2B;AC764DzB;;ADg74DJ;EACE,2BAA2B;ACj74DzB;;ADo74DJ;EACE,2BAA2B;ACr74DzB;;ADw74DJ;EACE,2BAA2B;ACz74DzB;;AD474DJ;EACE,2BAA2B;AC774DzB;;ADg84DJ;EACE,2BAA2B;ACj84DzB;;ADo84DJ;EACE,2BAA2B;ACr84DzB;;ADw84DJ;EACE,2BAA2B;ACz84DzB;;AD484DJ;EACE,2BAA2B;AC784DzB;;ADg94DJ;EACE,2BAA2B;ACj94DzB;;ADo94DJ;EACE,2BAA2B;ACr94DzB;;ADw94DJ;EACE,2BAA2B;ACn94D7B;;ADs94DA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,SCv94Dc;ADw94Dd;EACE,oBAAoB;AC194DlB;;AD694DJ;EACE,uBAAuB;AC994DrB;;ADi+4DJ;EACE,uBAAuB;ACl+4DrB;;ADq+4DJ;EACE,uBAAuB;ACt+4DrB;;ADy+4DJ;EACE,uBAAuB;AC1+4DrB;;AD6+4DJ;EACE,uBAAuB;AC9+4DrB;;ADi/4DJ;EACE,uBAAuB;ACl/4DrB;;ADq/4DJ;EACE,uBAAuB;ACt/4DrB;;ADy/4DJ;EACE,uBAAuB;AC1/4DrB;;AD6/4DJ;EACE,uBAAuB;AC9/4DrB;;ADig5DJ;EACE,uBAAuB;AClg5DrB;;ADqg5DJ;EACE,uBAAuB;ACtg5DrB;;ADyg5DJ;EACE,uBAAuB;AC1g5DrB;;AD6g5DJ;EACE,uBAAuB;AC9g5DrB;;ADih5DJ;EACE,uBAAuB;AClh5DrB;;ADqh5DJ;EACE,uBAAuB;ACth5DrB;;ADyh5DJ;EACE,wBAAwB;AC1h5DtB;;AD6h5DJ;EACE,wBAAwB;AC9h5DtB;;ADii5DJ;EACE,wBAAwB;ACli5DtB;;ADqi5DJ;EACE,wBAAwB;ACti5DtB;;ADyi5DJ;EACE,wBAAwB;AC1i5DtB;;AD6i5DJ;EACE,wBAAwB;AC9i5DtB;;ADij5DJ;EACE,wBAAwB;AClj5DtB;;ADqj5DJ;EACE,wBAAwB;ACtj5DtB;;ADyj5DJ;EACE,wBAAwB;AC1j5DtB;;AD6j5DJ;EACE,wBAAwB;AC9j5DtB;;ADik5DJ;EACE,wBAAwB;AClk5DtB;;ADqk5DJ;EACE,wBAAwB;ACtk5DtB;;ADyk5DJ;EACE,wBAAwB;AC1k5DtB;;AD6k5DJ;EACE,wBAAwB;AC9k5DtB;;ADil5DJ;EACE,wBAAwB;ACll5DtB;;ADql5DJ;EACE,wBAAwB;ACtl5DtB;;ADyl5DJ;EACE,wBAAwB;AC1l5DtB;;AD6l5DJ;EACE,wBAAwB;AC9l5DtB;;ADim5DJ;EACE,wBAAwB;AClm5DtB;;ADqm5DJ;EACE,wBAAwB;ACtm5DtB;;ADym5DJ;EACE,wBAAwB;AC1m5DtB;;AD6m5DJ;EACE,wBAAwB;AC9m5DtB;;ADin5DJ;EACE,wBAAwB;ACln5DtB;;ADqn5DJ;EACE,wBAAwB;ACtn5DtB;;ADyn5DJ;EACE,wBAAwB;AC1n5DtB;;AD6n5DJ;EACE,wBAAwB;AC9n5DtB;;ADio5DJ;EACE,wBAAwB;AClo5DtB;;ADqo5DJ;EACE,wBAAwB;ACto5DtB;;ADyo5DJ;EACE,wBAAwB;AC1o5DtB;;AD6o5DJ;EACE,wBAAwB;AC9o5DtB;;ADip5DJ;EACE,wBAAwB;AClp5DtB;;ADqp5DJ;EACE,wBAAwB;ACtp5DtB;;ADyp5DJ;EACE,wBAAwB;AC1p5DtB;;AD6p5DJ;EACE,wBAAwB;AC9p5DtB;;ADiq5DJ;EACE,wBAAwB;AClq5DtB;;ADqq5DJ;EACE,wBAAwB;ACtq5DtB;;ADyq5DJ;EACE,wBAAwB;AC1q5DtB;;AD6q5DJ;EACE,wBAAwB;AC9q5DtB;;ADir5DJ;EACE,wBAAwB;AClr5DtB;;ADqr5DJ;EACE,wBAAwB;ACtr5DtB;;ADyr5DJ;EACE,wBAAwB;AC1r5DtB;;AD6r5DJ;EACE,wBAAwB;AC9r5DtB;;ADis5DJ;EACE,wBAAwB;ACls5DtB;;ADqs5DJ;EACE,wBAAwB;ACts5DtB;;ADys5DJ;EACE,wBAAwB;AC1s5DtB;;AD6s5DJ;EACE,wBAAwB;AC9s5DtB;;ADit5DJ;EACE,wBAAwB;AClt5DtB;;ADqt5DJ;EACE,wBAAwB;ACtt5DtB;;ADyt5DJ;EACE,wBAAwB;AC1t5DtB;;AD6t5DJ;EACE,wBAAwB;AC9t5DtB;;ADiu5DJ;EACE,wBAAwB;AClu5DtB;;ADqu5DJ;EACE,wBAAwB;ACtu5DtB;;ADyu5DJ;EACE,wBAAwB;AC1u5DtB;;AD6u5DJ;EACE,wBAAwB;AC9u5DtB;;ADiv5DJ;EACE,wBAAwB;AClv5DtB;;ADqv5DJ;EACE,wBAAwB;ACtv5DtB;;ADyv5DJ;EACE,wBAAwB;AC1v5DtB;;AD6v5DJ;EACE,wBAAwB;AC9v5DtB;;ADiw5DJ;EACE,wBAAwB;AClw5DtB;;ADqw5DJ;EACE,wBAAwB;ACtw5DtB;;ADyw5DJ;EACE,wBAAwB;AC1w5DtB;;AD6w5DJ;EACE,wBAAwB;AC9w5DtB;;ADix5DJ;EACE,wBAAwB;AClx5DtB;;ADqx5DJ;EACE,wBAAwB;ACtx5DtB;;ADyx5DJ;EACE,wBAAwB;AC1x5DtB;;AD6x5DJ;EACE,wBAAwB;AC9x5DtB;;ADiy5DJ;EACE,wBAAwB;ACly5DtB;;ADqy5DJ;EACE,wBAAwB;ACty5DtB;;ADyy5DJ;EACE,wBAAwB;AC1y5DtB;;AD6y5DJ;EACE,wBAAwB;AC9y5DtB;;ADiz5DJ;EACE,wBAAwB;AClz5DtB;;ADqz5DJ;EACE,wBAAwB;ACtz5DtB;;ADyz5DJ;EACE,wBAAwB;AC1z5DtB;;AD6z5DJ;EACE,wBAAwB;AC9z5DtB;;ADi05DJ;EACE,wBAAwB;ACl05DtB;;ADq05DJ;EACE,wBAAwB;ACt05DtB;;ADy05DJ;EACE,wBAAwB;AC105DtB;;AD605DJ;EACE,wBAAwB;AC905DtB;;ADi15DJ;EACE,wBAAwB;ACl15DtB;;ADq15DJ;EACE,wBAAwB;ACt15DtB;;ADy15DJ;EACE,wBAAwB;AC115DtB;;AD615DJ;EACE,wBAAwB;AC915DtB;;ADi25DJ;EACE,wBAAwB;ACl25DtB;;ADq25DJ;EACE,wBAAwB;ACt25DtB;;ADy25DJ;EACE,wBAAwB;AC125DtB;;AD625DJ;EACE,wBAAwB;AC925DtB;;ADi35DJ;EACE,wBAAwB;ACl35DtB;;ADq35DJ;EACE,wBAAwB;ACt35DtB;;ADy35DJ;EACE,wBAAwB;AC135DtB;;AD635DJ;EACE,wBAAwB;AC935DtB;;ADi45DJ;EACE,wBAAwB;ACl45DtB;;ADq45DJ;EACE,wBAAwB;ACt45DtB;;ADy45DJ;EACE,wBAAwB;AC145DtB;;AD645DJ;EACE,wBAAwB;AC945DtB;;ADi55DJ;EACE,wBAAwB;ACl55DtB;;ADq55DJ;EACE,wBAAwB;ACt55DtB;;ADy55DJ;EACE,wBAAwB;AC155DtB;;AD655DJ;EACE,wBAAwB;AC955DtB;;ADi65DJ;EACE,wBAAwB;ACl65DtB;;ADq65DJ;EACE,wBAAwB;ACt65DtB;;ADy65DJ;EACE,wBAAwB;AC165DtB;;AD665DJ;EACE,wBAAwB;AC965DtB;;ADi75DJ;EACE,wBAAwB;ACl75DtB;;ADq75DJ;EACE,wBAAwB;ACt75DtB;;ADy75DJ;EACE,wBAAwB;AC175DtB;;AD675DJ;EACE,wBAAwB;AC975DtB;;ADi85DJ;EACE,wBAAwB;ACl85DtB;;ADq85DJ;EACE,wBAAwB;ACt85DtB;;ADy85DJ;EACE,wBAAwB;AC185DtB;;AD685DJ;EACE,wBAAwB;AC985DtB;;ADi95DJ;EACE,wBAAwB;ACl95DtB;;ADq95DJ;EACE,wBAAwB;ACt95DtB;;ADy95DJ;EACE,wBAAwB;AC195DtB;;AD695DJ;EACE,wBAAwB;AC995DtB;;ADi+5DJ;EACE,wBAAwB;ACl+5DtB;;ADq+5DJ;EACE,wBAAwB;ACt+5DtB;;ADy+5DJ;EACE,wBAAwB;AC1+5DtB;;AD6+5DJ;EACE,wBAAwB;AC9+5DtB;;ADi/5DJ;EACE,wBAAwB;ACl/5DtB;;ADq/5DJ;EACE,wBAAwB;ACt/5DtB;;ADy/5DJ;EACE,wBAAwB;AC1/5DtB;;AD6/5DJ;EACE,wBAAwB;AC9/5DtB;;ADig6DJ;EACE,wBAAwB;AClg6DtB;;ADqg6DJ;EACE,wBAAwB;ACtg6DtB;;ADyg6DJ;EACE,wBAAwB;AC1g6DtB;;AD6g6DJ;EACE,wBAAwB;AC9g6DtB;;ADih6DJ;EACE,wBAAwB;AClh6DtB;;ADqh6DJ;EACE,wBAAwB;ACth6DtB;;ADyh6DJ;EACE,wBAAwB;AC1h6DtB;;AD6h6DJ;EACE,wBAAwB;AC9h6DtB;;ADii6DJ;EACE,wBAAwB;ACli6DtB;;ADqi6DJ;EACE,wBAAwB;ACti6DtB;;ADyi6DJ;EACE,wBAAwB;AC1i6DtB;;AD6i6DJ;EACE,wBAAwB;AC9i6DtB;;ADij6DJ;EACE,wBAAwB;AClj6DtB;;ADqj6DJ;EACE,wBAAwB;ACtj6DtB;;ADyj6DJ;EACE,wBAAwB;AC1j6DtB;;AD6j6DJ;EACE,wBAAwB;AC9j6DtB;;ADik6DJ;EACE,wBAAwB;AC7j6D1B;;ADgk6DA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uBCpk6DgB;ADqk6DhB;EACE,sBAAsB;ACvk6DpB;;AD0k6DJ;EACE,sBAAsB;AC3k6DpB;;AD8k6DJ;EACE,sBAAsB;AC/k6DpB;;ADkl6DJ;EACE,sBAAsB;ACnl6DpB;;ADsl6DJ;EACE,sBAAsB;ACvl6DpB;;AD0l6DJ;EACE,sBAAsB;AC3l6DpB;;AD8l6DJ;EACE,sBAAsB;AC/l6DpB;;ADkm6DJ;EACE,sBAAsB;ACnm6DpB;;ADsm6DJ;EACE,sBAAsB;ACvm6DpB;;AD0m6DJ;EACE,sBAAsB;AC3m6DpB;;AD8m6DJ;EACE,sBAAsB;AC/m6DpB;;ADkn6DJ;EACE,sBAAsB;ACnn6DpB;;ADsn6DJ;EACE,sBAAsB;ACvn6DpB;;AD0n6DJ;EACE,sBAAsB;ACrn6DxB;;ADwn6DA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,aC5n6DkB;AD6n6DlB;EACE,4BAA4B;AC/n6D1B;;ADko6DJ;EACE,4BAA4B;ACno6D1B;;ADso6DJ;EACE,4BAA4B;ACvo6D1B;;AD0o6DJ;EACE,4BAA4B;AC3o6D1B;;AD8o6DJ;EACE,4BAA4B;AC/o6D1B;;ADkp6DJ;EACE,4BAA4B;ACnp6D1B;;ADsp6DJ;EACE,4BAA4B;ACvp6D1B;;AD0p6DJ;EACE,4BAA4B;AC3p6D1B;;AD8p6DJ;EACE,4BAA4B;AC/p6D1B;;ADkq6DJ;EACE,4BAA4B;ACnq6D1B;;ADsq6DJ;EACE,4BAA4B;ACvq6D1B;;AD0q6DJ;EACE,4BAA4B;AC3q6D1B;;AD8q6DJ;EACE,4BAA4B;AC/q6D1B;;ADkr6DJ;EACE,4BAA4B;ACnr6D1B;;ADsr6DJ;EACE,4BAA4B;ACvr6D1B;;AD0r6DJ;EACE,4BAA4B;AC3r6D1B;;AD8r6DJ;EACE,4BAA4B;AC/r6D1B;;ADks6DJ;EACE,4BAA4B;ACns6D1B;;ADss6DJ;EACE,4BAA4B;ACvs6D1B;;AD0s6DJ;EACE,4BAA4B;AC3s6D1B;;AD8s6DJ;EACE,4BAA4B;AC/s6D1B;;ADkt6DJ;EACE,4BAA4B;ACnt6D1B;;ADst6DJ;EACE,4BAA4B;ACvt6D1B;;AD0t6DJ;EACE,4BAA4B;AC3t6D1B;;AD8t6DJ;EACE,4BAA4B;AC/t6D1B;;ADku6DJ;EACE,4BAA4B;ACnu6D1B;;ADsu6DJ;EACE,4BAA4B;ACju6D9B;;ADou6DA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,aCru6DkB;ADsu6DlB;EACE,wBAAwB;ACxu6DtB;;AD2u6DJ;EACE,4BAA4B;AC5u6D1B;;AD+u6DJ;EACE,4BAA4B;AChv6D1B;;ADmv6DJ;EACE,4BAA4B;ACpv6D1B;;ADuv6DJ;EACE,4BAA4B;ACxv6D1B;;AD2v6DJ;EACE,4BAA4B;AC5v6D1B;;AD+v6DJ;EACE,4BAA4B;AChw6D1B;;ADmw6DJ;EACE,4BAA4B;ACpw6D1B;;ADuw6DJ;EACE,4BAA4B;ACxw6D1B;;AD2w6DJ;EACE,4BAA4B;AC5w6D1B;;AD+w6DJ;EACE,4BAA4B;AChx6D1B;;ADmx6DJ;EACE,4BAA4B;ACpx6D1B;;ADux6DJ;EACE,4BAA4B;ACxx6D1B;;AD2x6DJ;EACE,4BAA4B;AC5x6D1B;;AD+x6DJ;EACE,4BAA4B;AChy6D1B;;ADmy6DJ;EACE,4BAA4B;ACpy6D1B;;ADuy6DJ;EACE,4BAA4B;ACxy6D1B;;AD2y6DJ;EACE,4BAA4B;AC5y6D1B;;AD+y6DJ;EACE,4BAA4B;AChz6D1B;;ADmz6DJ;EACE,4BAA4B;ACpz6D1B;;ADuz6DJ;EACE,4BAA4B;ACxz6D1B;;AD2z6DJ;EACE,4BAA4B;AC5z6D1B;;AD+z6DJ;EACE,4BAA4B;ACh06D1B;;ADm06DJ;EACE,4BAA4B;ACp06D1B;;ADu06DJ;EACE,4BAA4B;ACx06D1B;;AD206DJ;EACE,4BAA4B;AC506D1B;;AD+06DJ;EACE,4BAA4B;ACh16D1B;;ADm16DJ;EACE,4BAA4B;AC/06D9B;;ADk16DA;EACE,4BAA4B;ACh16D9B;;ADm16DA;EACE,4BAA4B;ACj16D7B;;ADo16DD;ECj16DC,4BAAO;ADm16DR;;AAEA,KAAK;ACh16DL;EAII,mBAAkB;AD+06DtB;AACA;EACE,sBAAsB;ACj16DpB;ADm16DJ;EACE,sBAAsB;AACxB;;AAEA,UCt16De;ADu16Df;EACE,uBAAuB;ACz16DrB;;AD416DJ;EACE,wBAAwB;AC716DtB;;ADg26DJ;EACE,uBAAuB;ACj26DrB;;ADo26DJ;EACE,wBAAwB;ACr26DtB;;ADw26DJ;EACE,uBAAuB;ACz26DrB;;AD426DJ;EACE,wBAAwB;AC726DtB;;ADg36DJ;EACE,uBAAuB;ACj36DrB;;ADo36DJ;EACE,wBAAwB;ACr36DtB;;ADw36DJ;EACE,uBAAuB;ACz36DrB;;AD436DJ;EACE,wBAAwB;AC736DtB;;ADg46DJ;EACE,uBAAuB;ACj46DrB;;ADo46DJ;EACE,wBAAwB;ACr46DtB;;ADw46DJ;EACE,uBAAuB;ACz46DrB;;AD446DJ;EACE,wBAAwB;AC746DtB;;ADg56DJ;EACE,uBAAuB;ACj56DrB;;ADo56DJ;EACE,wBAAwB;ACr56DtB;;ADw56DJ;EACE,uBAAuB;ACn56DzB;;ADs56DA;EACE,wBAAwB;ACp56D1B;;ADu56DA;ECj56DQ,qBAAO;ADm56Df;;ACr56DI;EACI,qBAAQ;ADw56DhB;;AAEA,YAAY;AC356DR;EACI,yBAAiC;EACjC,wBAAgC;AD656DxC;;AC/56DI;EACI,0BAAiC;EACjC,yBAAgC;ADk66DxC;;ACp66DI;EACI,uBAAQ;EACR,sBAAO;ADu66Df;;ACz66DI;EACI,0BAAiC;EACjC,yBAAgC;AD466DxC;;ACp66DI;EACI,yBAAgC;EAChC,wBAA+B;ADu66DvC;;ACz66DI;EACI,0BAAgC;EAChC,yBAA+B;AD466DvC;;AC966DI;EACI,uBAAgC;EAChC,sBAA+B;ADi76DvC;;ACn76DI;EACI,yBAAgC;EAChC,wBAA+B;ADs76DvC;;ACx76DI;EACI,uBAAgC;EAChC,sBAA+B;AD276DvC;;AC776DI;EACI,yBAAgC;EAChC,wBAA+B;ADg86DvC;;ACl86DI;EACI,uBAAgC;EAChC,sBAA+B;ADq86DvC;;ACv86DI;EACI,yBAAgC;EAChC,wBAA+B;AD086DvC;;AC586DI;EACI,uBAAgC;EAChC,sBAA+B;AD+86DvC;;ACv86DI;EACI,yBAA8B;EAC9B,wBAA6B;AD086DrC;;AC586DI;EACI,uBAA8B;EAC9B,sBAA6B;AD+86DrC;;ACj96DI;EACI,uBAA8B;EAC9B,sBAA6B;ADo96DrC;;ACt96DI;EACI,uBAAQ;EACR,sBAAO;ADy96Df;;AC396DI;EACI,uBAAQ;EACR,sBAAO;AD896Df;;ACz96DA;EAGI,wBAAiB;EACb,uBAA2B;AD096DnC;;AC396DI;EACI,wBAA2B;ED896DjC,uBAAuB;AACzB;;AAEA,UCj+6De;ADk+6Df;EACE,qBAAqB;ACp+6DnB;;ADu+6DJ;EACE,qBAAqB;ACx+6DnB;;AD2+6DJ;EACE,qBAAqB;AC5+6DnB;;AD++6DJ;EACE,qBAAqB;ACh/6DnB;;ADm/6DJ;EACE,qBAAqB;ACp/6DnB;;ADu/6DJ;EACE,qBAAqB;ACx/6DnB;;AD2/6DJ;EACE,qBAAqB;AC5/6DnB;;AD+/6DJ;EACE,qBAAqB;AC3/6DvB;;AD8/6DA;EC3/6DC,qBAAe;AD6/6DhB;;AAEA;EC3/6DC,sBAAe;AD6/6DhB;;AC3/6DA,SAAA;AD8/6DA;EC5/6DC,gBAAQ;EG9mPD,eAAA;EAIA,cAAiB;EAIjB,YAAA;EAIA,WAAA;EAIA,gBAAc;AJimqEtB;;AAEA;EChg7DC,kBAAA;EACA,QAAA;EAKA,2BAAiC;EDkg7DhC,cAAc;ECjg7Df,cAAA;EACC,kCAAW;EACX,mCAAU;EACV,kCAAW;EACX,eAAW;EACX,UAAU;EACV,WAAS;EACT,kBAAc;EACd,2BAAkB;ADmg7DpB;AACA;ECjg7DE,WAAA;EACA,UAAQ;EACR,WAAA;EACA,WAAA;EACA,UAAS;EDmg7DT,aAAa;ECjg7Dd,cAAA;EACC,kBAAc;EACd,kBAAA;EAEA,+BAAwB;EACxB,kBAAgB;EDmg7DhB,yDAAyD;EC//6D3D,mEAOC;AD2/6DD;AACA;EACE,yDIppqE+B;EJspqE/B,oBI9oqEuB;EJgpqEvB,yBAAyB;AAC3B;AAkBA;EACE;IC3g7DF,uBAAA;EACC;EDih7DC;IAKE,yBAAyB;ECnh7D5B;ADqh7DD;AAiBA;EACE;IC3h7DF,yBAAa;EACb;EACC;IDqi7DG,yBAAyB;EAC3B;ACji7DF;ADmi7DA,YCli7DQ;ADmi7DR;EACE,mBAAmB;ACji7DrB;;ADoi7DA;ECji7DC,uBAAQ;ADmi7DT;;AAEA;EACE,sBAAsB;AChi7DvB;;ADmi7DD;;;EAGE,QAAQ;EACR,SAAS;EChi7DX,aAAA;ADki7DA;;AAEA;EACE,mBAAmB;ACji7DrB;ADmi7DA;ECji7DC,WAAW;ADmi7DZ;;ACji7DA;;EAEC,WAAA;ADoi7DD;;AAEA;ECli7DA,YAAA;EDoi7DE,WCni7DU;ADoi7DZ;;AAEA;;EAEE,gBCpi7DU;EACX,mBAAU;ADqi7DX;;ACli7DA;;EAEC,WAAU;ADqi7DX;;ACni7DA;;EDui7DE,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;ACri7DzB;;ADwi7DA;;;ECni7DC,gBAAW;EDui7DV,WAAW;EACX,mBAAmB;ACri7DpB;;ADwi7DD;;;EAGE,gBAAgB;ECri7DhB,UAAA;EACA,mBAAU;ADui7DZ;;ACni7DA;;;;;;ED2i7DE,6BCri7D6B;EAC9B,UAAS;ADsi7DV;;ACpi7DA;;;;;;;EAME,UAAS;ADwi7DX;;AAEA,YAAY;AACZ;ECti7DA,cAAe;EACd,iBAAa;ADwi7Dd;AACA;ECvi7DE,WAAA;EACA,cAAU;EACV,WAAS;EACT,gCAAiB;ADyi7DnB;;AAEA;ECvi7DE,cAAa;EDyi7Db,iBAAiB;AACnB;ACvi7DA;EACC,WAAO;EACP,cAAS;EACT,kBAAS;EACT,WAAS;EDyi7DR,WAAW;ECxi7DZ,OAAA;EACC,gCAAU;AD0i7DZ;;AAEA;ECxi7DE,cAAY;ED4i7DZ,aAAa;ACxi7Df;AD0i7DA;EACE,WAAW;ECzi7DZ,kBAAQ;EACP,MAAA;EACA,cAAU;EACV,YAAS;EACT,+BAAyB;AD2i7D3B;;AAEA;ECzi7DE,cAAY;AD2i7Dd;AACA;ECxi7DC,WAAA;EACC,kBErmPa;EH+oqEb,cAAc;EACd,yBAAyB;ECvi7D3B,+BAAc;EAEb,MAAO;EACN,SAAS;EDwi7DT,YAAY;ACti7Db;;ADyi7DD;ECti7DC,qBAAO;ADwi7DR;;ACri7DC,aAAO;ADwi7DR;EACE,kBAAkB;AACpB;ACti7DA;EDwi7DE,mBAAmB;AACrB;AACA;ECti7DC,mBAAS;ADwi7DV;AACA;ECti7DC,kBAAa;ADwi7Dd;;ACti7DC;;;;ED8i7DC,aAAa;EC3i7Db,mBAAA;ED6i7DA,oBAAoB;AACtB;AACA;;;;EAIE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EC9i7DE,cAAA;ADmj7DF;AACA;;;;ECjj7DG,uBAAmB;EACnB,+BAAuB;EACvB,qBAAA;ADsj7DH;AACA;;;;EAIE,aAAa;ECvj7DZ,mBAAU;EACV,mBAAc;EACd,uBAAW;EACX,+BAAQ;EACR,qBEvpPkC;AHgtqErC;ACvj7DE;;;;EACC,WAAU;EACV,cAAc;EACd,WAAW;EACX,QAAO;EACP,mBAAY;AD4j7Df;AACA;;;;EAIE,WAAW;EC5j7DT,cAAW;EACX,WAAA;ED8j7DF,WAAW;EC5j7DV,oBAAA;ED8j7DD,mBAAmB;AACrB;AACA;;;;EC1j7DG,WAAA;ED+j7DD,qBAAqB;AACvB;AACA;;;;EC7j7DG,QAAA;EDkk7DD,SAAS;AACX;AACA;;;;EAIE,WAAW;ECjk7Db,qBAAO;ADmk7DP;AACA;;;;EC/j7DE,WAAU;EDok7DV,oBAAoB;AACtB;;AAEA;EClk7DC,eEtrP+B;EFurP/B,cAAY;EDok7DX,gBAAgB;ACnk7DjB;ADqk7DD;EACE,iBAAiB;AACnB;;AAEA;ECnk7DC,mBE9rP+B;EF+rP/B,cAAY;EDqk7DX,gBAAgB;ACpk7DjB;ADsk7DD;EACE,kBAAkB;AACpB;;AAEA;ECnk7DC,mBEvsP+B;EFwsP/B,cAAY;EDqk7DX,gBAAgB;ACpk7DjB;ADsk7DD;EACE,kBAAkB;AACpB;;AAEA;ECpk7DI,kBAAgB;EDsk7DlB,cAAc;EACd,gBAAgB;ACrk7DlB;ADuk7DA;EACE,eAAe;AACjB;;AAEA;ECtk7DC,cEhtPe;EHwxqEd,gBAAgB;AAClB;;AAEA;ECtk7DE,wBAAoB;ADwk7DtB;;AAEA;ECvk7DG,gBAAY;EACZ,cEztPQ;AHkyqEX;;AAEA;ECvk7DG,kBAAkB;EAClB,qBAAc;ADyk7DjB;AACA;ECvk7DG,WAAA;EDyk7DD,YAAY;ECtk7Db,mBAAA;EACC,wBEluPY;EH0yqEZ,WAAW;EACX,WAAW;ECtk7Db,kBAAY;EACX,cAAS;EACT,QAAA;EACA,OEjvPQ;EFkvPR,oBAAkB;ADwk7DnB;ACvk7DC;EACC,mBAAU;ADyk7DZ;;AAEA;ECvk7DE,UAAS;EACT,gBAAW;EACX,cAAU;EACV,kBAAc;ADyk7DhB;AACA;ECvk7DE,WAAA;EDyk7DA,YAAY;EACZ,mBAAmB;ECvk7DrB,wBAAA;EDyk7DE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,QCxk7DS;EACV,OEvwPQ;EHg1qEP,oBAAoB;AACtB;;AAEA;;;;;;ECnk7DA,cAAW;AACX;;AD2k7DA;ECxk7DC,eAAe;EACf,YAAS;EACT,cAAa;EACb,qBAAe;AD0k7DhB;;AAEA,UCl76DC;ADm76DD;EACE,gCAAgC;EC7k7DjC,aAAA;EACC,eAAW;ED+k7DX,sBAAsB;EC5k7DvB,iBAAA;EACC,uBAAoB;EACpB,oBAAoB;EACpB,oBAAa;EACb,eAAA;EACA,kBAAgB;;AD+k7DlB;AACA;EC5k7DE,gBAAe;AD8k7DjB;AACA;EC3k7DE,aAAA;EAGC,mBAAa;ED+k7Dd,uBAAuB;EC9k7DtB,+BAAA;EACC,qBAAmB;EDgl7DrB,YAAY;EC9k7DX,WAAA;EACC,kBAAY;ADgl7DhB;ACzk7DI;EAGA,aAAA;AD2k7DJ;AACA;ECnk7DI,oBAAA;ADqk7DJ;AACA;ECnk7DI,mBAAA;ADqk7DJ;AACA;EC7j7DI,qBAAA;AD+j7DJ;AACA;EC7j7DI,oBAAA;AD+j7DJ;AACA;ECzj7DC,qBAAA;AD2j7DD;AACA;EC1j7DE,oBAAA;AD4j7DF;AACA;EC3j7DG,oBAAA;AD6j7DH;AACA;EC3j7DI,mBAAc;AD6j7DlB;AACA;EC3j7DI,kBAAU;AD6j7Dd;AACA;EC3j7DI,gBAAS;AD6j7Db;AACA;EC3j7DI,sDAAmB;EACnB,kBAAiB;EACjB,qBAAA;EACA,SAAA;ED6j7DF,YAAY;EC5j7DV,WAAA;EDgk7DF,oBAAoB;EC1j7DjB,mBAAU;ED8j7Db,uBAAuB;EC3j7DtB,+BAAA;EACC,qBAAc;AD6j7DlB;AC3j7DG;EACC,UAAA;ED6j7DF,SAAS;ACxj7DP;AD0j7DJ;ECxj7DK,WAAA;ED0j7DH,UAAU;ACxj7DR;AD0j7DJ;EACE,sBAAsB;ACxj7DpB;AD0j7DJ;EACE,qBAAqB;ACpj7DnB;ADsj7DJ;ECpj7DK,WAAA;EDsj7DH,qBAAqB;ACpj7DnB;ADsj7DJ;EACE,uBAAuB;ACpj7DrB;ADsj7DJ;EACE,sBAAsB;AChj7DpB;ADkj7DJ;EChj7DK,WAAA;EDkj7DH,oBAAoB;AChj7DlB;ADkj7DJ;EACE,mBAAmB;AChj7DjB;ADkj7DJ;EACE,kBAAkB;AC5i7DhB;AD8i7DJ;EACE,WAAW;ECvi7DZ,oBAAA;ADyi7DD;AACA;ECvi7DE,qBAAS;ADyi7DX;ACxi7DE;EACE,oBAAiB;AD0i7DrB;AACA;EACE,gBAAgB;ACzi7Dd;AD2i7DJ;ECzi7DK,YAAU;EACV,WAAQ;EACR,UAAS;AD2i7Dd;AACA;ECzi7DK,kBEpsQC;EFqsQD,YAAA;EG7qQG,kCAA4B;AJytrEpC;AACA;EACE,WAAW;ECxi7DR,kBAAA;EACC,QAAK;EACL,SAAM;EACN,SAAO;EACP,QAAM;ED0i7DV,mBAAmB;ECxi7DhB,qBAAA;EAKA,qBAAA;ADwi7DL;AACA;ECni7DI,MAAA;EACC,OAAA;EDqi7DH,YAAY;ECli7DT,WAAA;ADoi7DL;AACA;EC/h7DM,WAAA;ADii7DN;AACA;EC7h7DI,kBAAA;AD+h7DJ;AACA;EC1h7DI,mBAAA;AD4h7DJ;AACA;ECzh7DK,mBAAA;AD2h7DL;AACA;ECth7DM,cAAA;ADwh7DN;AACA;ECph7DI,8BAAA;ADsh7DJ;AACA;ECjh7DI,mBAAA;ADmh7DJ;AACA;EChh7DK,mBAAA;ADkh7DL;AACA;EC7g7DM,cAAA;AD+g7DN;AACA;EC3g7DI,6BAAA;AD6g7DJ;AACA;ECxg7DI,mBAAA;AD0g7DJ;AACA;ECvg7DK,mBAAA;ADyg7DL;AACA;ECpg7DM,cAAA;ADsg7DN;AACA;EClg7DI,6BAAA;ADog7DJ;AACA;EC//6DI,mBAAA;ADig7DJ;AACA;EC9/6DK,mBAAA;ADgg7DL;AACA;EC3/6DM,cAAA;AD6/6DN;AACA;ECz/6DI,2BAAA;AD2/6DJ;AACA;ECt/6DI,mBAAA;ADw/6DJ;AACA;ECr/6DK,mBAAA;ADu/6DL;AACA;ECl/6DM,cAAA;ADo/6DN;AACA;ECh/6DI,+BAAA;ADk/6DJ;AACA;EC7+6DI,mBAAA;AD++6DJ;AACA;EC5+6DK,mBAAA;AD8+6DL;AACA;ECz+6DM,cAAA;AD2+6DN;AACA;ECv+6DI,8BAAA;ADy+6DJ;AACA;ECp+6DI,mBAAA;ADs+6DJ;AACA;ECn+6DK,mBAAA;ADq+6DL;AACA;ECh+6DM,cAAA;ADk+6DN;AACA;EC996DI,4BAAA;ADg+6DJ;AACA;ECz96DE,mBAAA;AD296DF;AACA;EACE,mBAAmB;AC196DlB;AD496DH;EACE,cAAc;ACz96Dd;AD296DF;ECz96DG,+BAAU;AD296Db;AC196DG;EACC,YAAW;ED496Db,WAAW;ACz96DX;AD296DF;ECz96DG,mBAAW;AD296Dd;AACA;EACE,YAAY;EC196DX,WAAA;AD496DH;AACA;ECt96DC,mBAAA;ADw96DD;AACA;ECv96DE,YAAA;EACC,WAAA;EDy96DD,eAAe;ECt96DhB,gBAAA;ADw96DD;AACA;ECt96DC,mBAAA;ADw96DD;AACA;EACE,+BAA+B;ACt96DhC;ADw96DD;ECt96DE,6BAAY;ADw96Dd;ACt96DC;EGz5QO,2BAAsB;AJk3rE9B;AACA;EACE,oCAAoC;ECz96DpC,gBAAA;AD296DF;AACA;EI/2rEQ,qDAAwB;EAIxB,aAAe;AJ82rEvB;AACA;EC196DE,0BAAgB;AD896DlB;AACA;EAKE,2BAA2B;AC796D7B;AD+96DA;EACE,gCAAgC;EAChC,gBAAgB;AC796DlB;;ADg+6DA;EC796DC,cAAW;ED+96DV,WAAW;AACb;;AAEA;EC996DC,kBAAS;ADg+6DV;;AAEA;;;EAGE,WAAW;AC996Db;;ADi+6DA;EAGE,aAAa;EC796Db,mBEvrQY;AHwprEd;;AC996DC,gBAAA;ADi+6DD;EC996DE,WAAA;EACA,yBE9rQkC;EH8prElC,qBAAqB;AC996DtB;ADg+6DD;EC996DE,WAAA;EACA,yBEtsQmC;EHsqrEnC,qBAAqB;AC796DrB;AD+96DF;EC796DG,WAAA;EACA,yBEjuQU;EFkuQV,qBAAW;AD+96Dd;AACA;EC596DA,WAAW;EACV,yBEl+QU;EFm+QV,qBEvuQU;AHqsrEX;AACA;EC796DC,WAAA;EACC,yBEt+QS;EFu+QT,qBEn9Qa;EFo9Qb,oDEp9QoC;AHm7rEtC;;AAEA;EC596DE,WAAA;EACA,yBE19QoC;EHw7rEpC,qBAAqB;AC596DtB;AD896DD;EC596DE,WAAA;EACA,yBEl+QqC;EHg8rErC,qBAAqB;AC396DrB;AD696DF;EC396DG,WAAA;EACA,yBE7vQc;EF8vQd,qBAAW;AD696Dd;AACA;EC196DA,WAAa;EACZ,yBE//QU;EFggRV,qBEpwQU;AHgurEX;AACA;EC396DC,WAAA;EACC,yBEngRS;EFogRT,qBEruQe;EFsuQf,oDEtuQwC;AHmsrE1C;;AAEA;EC196DE,WAAA;EACA,yBE5uQwC;EHwsrExC,qBAAqB;AC196DtB;AD496DD;EC196DE,WAAA;EACA,yBEpvQyC;EHgtrEzC,qBAAqB;ACz96DrB;AD296DF;ECz96DG,WAAA;EACA,yBE1xQc;EF2xQd,qBAAW;AD296Dd;AACA;ECx96DA,WAAa;EACZ,yBE5hRU;EF6hRV,qBE/xQU;AHyvrEX;AACA;ECz96DC,WAAA;EACC,yBEhiRS;EFiiRT,qBE1uQe;EF2uQf,oDE3uQwC;AHssrE1C;;AAEA;ECx96DE,WAAA;EACA,yBEjvQwC;EH2srExC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEzvQyC;EHmtrEzC,qBAAqB;ACv96DrB;ADy96DF;ECv96DG,WAAA;EACA,yBErzQe;EFszQf,qBAAW;ADy96Dd;AACA;ECt96DA,WAAY;EACX,yBEzjRU;EF0jRV,qBE7zQS;AHqxrEV;AACA;ECv96DC,WAAA;EACC,yBE7jRS;EF8jRT,qBEnxQc;EFoxQd,oDEpxQsC;AH6urExC;;AAEA;ECt96DE,WAAA;EACA,yBE1xQsC;EHkvrEtC,qBAAqB;ACt96DtB;ADw96DD;ECt96DE,WAAA;EACA,yBElyQuC;EH0vrEvC,qBAAqB;ACr96DrB;ADu96DF;ECr96DG,WAAA;EACA,yBEn1QW;EFo1QX,qBAAW;ADu96Dd;AACA;ECp96DA,WAAU;EACT,yBEtlRU;EFulRV,qBEzlRK;AH+isEN;AACA;ECr96DC,WAAA;EACC,yBE1lRS;EF2lRT,qBE/2QY;EFg3QZ,oDEh3QkC;AHu0rEpC;;AAEA;ECp96DE,WAAA;EACA,yBEt3QkC;EH40rElC,qBAAqB;ACp96DtB;ADs96DD;ECp96DE,WAAA;EACA,yBE93QmC;EHo1rEnC,qBAAqB;ACn96DrB;ADq96DF;ECn96DG,WAAA;EACA,yBE/mRU;EFgnRV,qBAAW;ADq96Dd;AACA;ECl96DA,WAAA;EACC,yBEnnRU;EFonRV,qBEr3QY;AHy0rEb;AACA;ECn96DC,WAAA;EACC,yBEvnRS;EFwnRT,qBErzQiB;EFszQjB,oDEtzQ4C;AH2wrE9C;;AAEA;ECl96DE,WAAA;EACA,yBE5zQ4C;EHgxrE5C,qBAAqB;ACl96DtB;ADo96DD;ECl96DE,WAAA;EACA,yBEp0Q6C;EHwxrE7C,qBAAqB;ACj96DrB;ADm96DF;ECj96DG,WAAA;EACA,yBE34QsB;EF44QtB,qBAAW;ADm96Dd;AACA;ECh96DA,WAAA;EACC,yBEhpRU;EFipRV,qBEv5QU;AHy2rEX;AACA;ECj96DC,WAAA;EACC,yBEppRS;EFqpRT,qBE94Qe;EF+4Qf,oDE/4QwC;AHk2rE1C;;AAEA;ECh96DE,WAAA;EACA,yBEr5QwC;EHu2rExC,qBAAqB;ACh96DtB;ADk96DD;ECh96DE,WAAA;EACA,yBE75QyC;EH+2rEzC,qBAAqB;AC/86DrB;ADi96DF;EC/86DG,WAAA;EACA,yBE76Qa;EF86Qb,qBAAW;ADi96Dd;AACA;EC986DA,WAAU;EACT,yBE7qRU;EF8qRV,qBE17QQ;AH04rET;AACA;EC/86DC,WAAA;EACC,yBEjrRS;EFkrRT,qBE77QO;EF87QP,oDE97Q8B;AH+4rEhC;;AAEA;EC986DE,WAAA;EACA,yBEp8Q8B;EHo5rE9B,qBAAqB;AC986DtB;ADg96DD;EC986DE,WAAA;EACA,yBEhsRW;EHgpsEX,qBAAqB;AC786DrB;AD+86DF;EC786DG,WAAA;EACA,yBEh9Q6B;EFi9Q7B,qBAAW;AD+86Dd;AACA;EC586DA,WAAA;ED886DE,yBC786DS;EACV,qBEv9Q+B;AHq6rEhC;AACA;EACE,WAAW;EC786DZ,yBAAA;ED+86DC,qBAAqB;EACrB,oDCh96De;ADi96DjB;;AAEA;;EC986DC,cAAA;EDi96DC,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EC986DC,cAAA;EDk96DC,yBAAyB;EACzB,qBCn96DqB;ADo96DvB;AACA;;;EC/86DE,cAAA;EDm96DA,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;ECp96DG,cAAA;EACA,yBE1/QkC;EF2/QlC,qBAAW;ADw96Dd;AACA;;;;;;ECj96DC,cAAA;EACC,yBE7/QkC;EF8/QlC,qBE7uRK;EF8uRL,oDE9uRS;AHsssEX;;AAEA;ECr96DE,cAAA;EACA,sBEpvRS;EH2ssET,kBAAkB;ACr96DnB;ADu96DD;ECr96DE,cAAA;EACA,sBEzvRS;EHgtsET,kBAAkB;ACp96DlB;ADs96DF;ECp96DG,cAAA;EACA,sBE/vRQ;EFgwRR,kBAAW;ADs96Dd;AACA;ECn96DA,cAAU;EACT,sBE3gRe;EF4gRf,kBAAgB;ADq96DjB;ACp96DC;EACC,cE9gRc;EHo+rEd,sBAAsB;EACtB,kBAAkB;ECp96DpB,oDAAA;ADs96DA;;AAEA;EACE,cAAc;ECt96Df,gCAAgB;ADw96DjB;AACA;ECv96DA,cAAA;ADy96DA;;AAEA;;;;;ECp96DE,gBAAgB;AD096DlB;;ACv96DC;;;EAGC,UAAA;AD096DF;;AAEA;ECx96DE,WAAA;EACA,yBE/gRkC;EHy+rElC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBExgRwC;EHk+rExC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEr/QwC;EH+8rExC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEtgRsC;EHg+rEtC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBE9kRmC;EHwisEnC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEvkR8B;EHiisE9B,qBAAqB;ACx96DtB;AD096DD;ECx96DE,cAAA;EACA,yBEzjRwC;EHmhsExC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBElgR4C;EH49rE5C,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEvjRkC;EHihsElC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEhjRwC;EH0gsExC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBE7hRwC;EHu/rExC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBE9iRsC;EHwgsEtC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEtnRmC;EHglsEnC,qBAAqB;ACx96DtB;AD096DD;ECx96DE,WAAA;EACA,yBEhnR8B;EH0ksE9B,qBAAqB;AACvB;ACv96DC;EACC,cAAS;EACT,yBAAoB;EACpB,qBAAY;ADy96Dd;AACA;ECv96DA,WAAA;EACA,yBAAe;EACd,qBEpnRY;AH6ksEb;;AAEA;ECt96DE,aAAA;AD096DF;;ACv96DC,eAAA;AD096DD;ECv96DE,cAAA;EACA,yBEhoRW;EHylsEX,qBAAqB;ACv96DtB;ADy96DD;ECv96DE,WAAA;EACA,yBEhnRmC;EHyksEnC,qBAAqB;ACt96DrB;ADw96DF;ECt96DG,WAAA;EACA,yBExnRkC;EFynRlC,qBAAW;ADw96Dd;AACA;ECr96DA,cAAA;EACC,yBEhpRgB;EFipRhB,qBEnnRiB;AH0ksElB;AACA;ECt96DC,cAAA;EACC,yBEh5RS;EFi5RT,qBErpRS;EFspRT,oDEtpRe;AH8msEjB;;AAEA;ECr96DE,cAAA;EACA,yBE5pRe;EHmnsEf,qBAAqB;ACr96DtB;ADu96DD;ECr96DE,WAAA;EACA,yBEjoRyC;EHwlsEzC,qBAAqB;ACp96DrB;ADs96DF;ECp96DG,WAAA;EACA,yBEzoRwC;EF0oRxC,qBAAW;ADs96Dd;AACA;ECn96DA,cAAA;EACC,yBE3qRiB;EF4qRjB,qBExnRiB;AH6ksElB;AACA;ECp96DC,cAAA;EACC,yBE76RS;EF86RT,qBEhrRS;EFirRT,oDEjrRgB;AHuosElB;;AAEA;ECn96DE,cAAA;EACA,yBEvrRgB;EH4osEhB,qBAAqB;ACn96DtB;ADq96DD;ECn96DE,WAAA;EACA,yBEtoRyC;EH2lsEzC,qBAAqB;ACl96DrB;ADo96DF;ECl96DG,WAAA;EACA,yBE9oRwC;EF+oRxC,qBAAW;ADo96Dd;AACA;ECj96DA,cAAiB;EAChB,yBEzsRa;EF0sRb,qBEjqRgB;AHonsEjB;AACA;ECl96DC,cAAA;EACC,yBE18RS;EF28RT,qBE9sRQ;EF+sRR,oDE/sRY;AHmqsEd;;AAEA;ECj96DE,cAAA;EACA,yBErtRY;EHwqsEZ,qBAAqB;ACj96DtB;ADm96DD;ECj96DE,WAAA;EACA,yBE/qRuC;EHkosEvC,qBAAqB;ACh96DrB;ADk96DF;ECh96DG,WAAA;EACA,yBEvrRsC;EFwrRtC,qBAAW;ADk96Dd;AACA;EC/86DA,cAAA;EACC,yBE/uR+B;EFgvR/B,qBEtqRmB;AHunsEpB;AACA;ECh96DC,cAAA;EACC,yBEv+RS;EFw+RT,qBEzuRW;EF0uRX,oDE1uRuB;AH4rsEzB;;AAEA;EC/86DE,cAAA;EACA,yBEhvRuB;EHissEvB,qBAAqB;AC/86DtB;ADi96DD;EC/86DE,WAAA;EACA,yBEprR6C;EHqosE7C,qBAAqB;AC986DrB;ADg96DF;EC986DG,WAAA;EACA,yBE5rR4C;EF6rR5C,qBAAW;ADg96Dd;AACA;EC786DA,cAAA;EACC,yBEtwRe;EFuwRf,qBE/vRiB;AH8ssElB;AACA;EC986DC,cAAA;EACC,yBEpgSS;EFqgST,qBE3wRS;EF4wRT,oDE5wRc;AH4tsEhB;;AAEA;EC786DE,cAAA;EACA,yBElxRc;EHiusEd,qBAAqB;AC786DtB;AD+86DD;EC786DE,WAAA;EACA,yBE7wRyC;EH4tsEzC,qBAAqB;AC586DrB;AD886DF;EC586DG,WAAA;EACA,yBErxRwC;EFsxRxC,qBAAW;AD886Dd;AACA;EC386DA,cAAgB;EACf,yBE9xRwB;EF+xRxB,qBEvzRc;AHowsEf;AACA;EC586DC,cAAA;EACC,yBEjiSS;EFkiST,qBEnyRW;EFoyRX,oDEpyRuB;AHkvsEzB;;AAEA;EC386DE,cAAA;EACA,yBE1yRuB;EHuvsEvB,qBAAqB;AC386DtB;AD686DD;EC386DE,WAAA;EACA,yBEv0RmC;EHoxsEnC,qBAAqB;AC186DrB;AD486DF;EC186DG,WAAA;EACA,yBE70RkC;EF80RlC,qBAAW;AD486Dd;AACA;ECz86DA,cAAe;EACd,yBEt0R+B;EFu0R/B,qBEp1Rc;AH+xsEf;AACA;EC186DC,cAAA;EACC,yBE9jSS;EF+jST,qBE30RO;EF40RP,oDE50R8B;AHwxsEhC;;AAEA;ECz86DE,cAAA;EACA,yBEl1R8B;EH6xsE9B,qBAAqB;ACz86DtB;AD286DD;ECz86DE,WAAA;EACA,yBE7kSW;EHwhtEX,qBAAqB;ACx86DrB;AD086DF;ECx86DG,WAAA;EACA,yBE12RkC;EF22RlC,qBAAW;AD086Dd;AACA;ECt86DA,WAAA;EACA,yBAAgB;EACf,qBE91RY;AHsysEb;AACA;EACE,WAAW;ECv86DZ,yBAAA;EACC,qBE7lSS;EF8lST,oDEn2RW;AH4ysEb;;ACt86DC,gBAAA;ADy86DD;ECt86DE,cAAA;EACA,6BE12RW;EHkzsEX,yBAAyB;ACt86D1B;ADw86DD;ECt86DE,WAAA;EACA,yBE11RmC;EHkysEnC,qBAAqB;ACr86DrB;ADu86DF;ECp86DG,WAAA;EACA,yBEt3RU;EH4zsEX,qBAAqB;ACl86DrB;ADo86DF;ECj86DG,cAAA;EACA,yBE32RkC;EH8ysEnC,qBAAqB;AC/76DrB;ADi86DF;EC976DG,cAAA;EACA,6BAAwB;EACxB,qBAAW;ADg86Dd;AACA;EC776DA,cAAA;EACC,yBE34RgB;EF44RhB,qBAAiB;AD+76DlB;AACA;EC976DC,cAAA;EACC,6BE3oSS;EF4oST,yBEh5Re;EFi5Rf,oDEj5Re;AHi1sEjB;;AAEA;EC776DE,cAAA;EACA,6BEv5Re;EHs1sEf,yBAAyB;AC776D1B;AD+76DD;EC776DE,WAAA;EACA,yBE53RyC;EH2zsEzC,qBAAqB;AC576DrB;AD876DF;EC376DG,WAAA;EACA,yBEn6Rc;EHg2sEf,qBAAqB;ACz76DrB;AD276DF;ECx76DG,cAAA;EACA,yBE74RwC;EHu0sEzC,qBAAqB;ACt76DrB;ADw76DF;ECr76DG,cAAA;EACA,6BAAwB;EACxB,qBAAW;ADu76Dd;AACA;ECp76DA,cAAA;EACC,yBEv7RiB;EFw7RjB,qBAAiB;ADs76DlB;AACA;ECr76DC,cAAA;EACC,6BEzrSS;EF0rST,yBE57RgB;EF67RhB,oDE77RgB;AHo3sElB;;AAEA;ECp76DE,cAAA;EACA,6BEn8RgB;EHy3sEhB,yBAAyB;ACp76D1B;ADs76DD;ECp76DE,WAAA;EACA,yBEl5RyC;EHw0sEzC,qBAAqB;ACn76DrB;ADq76DF;ECl76DG,WAAA;EACA,yBE/8Re;EHm4sEhB,qBAAqB;ACh76DrB;ADk76DF;EC/66DG,cAAA;EACA,yBEn6RwC;EHo1sEzC,qBAAqB;AC766DrB;AD+66DF;EC566DG,cAAA;EACA,6BAAwB;EACxB,qBAAW;AD866Dd;AACA;EC366DA,cAAA;EACC,yBEt+Ra;EFu+Rb,qBAAiB;AD666DlB;AACA;EC566DC,cAAA;EACC,6BEvuSS;EFwuST,yBE3+RY;EF4+RZ,oDE5+RY;AH05sEd;;AAEA;EC366DE,cAAA;EACA,6BEl/RY;EH+5sEZ,yBAAyB;AC366D1B;AD666DD;EC366DE,WAAA;EACA,yBE58RuC;EHy3sEvC,qBAAqB;AC166DrB;AD466DF;ECz66DG,WAAA;EACA,yBE9/RW;EHy6sEZ,qBAAqB;ACv66DrB;ADy66DF;ECt66DG,cAAA;EACA,yBE79RsC;EHq4sEvC,qBAAqB;ACp66DrB;ADs66DF;ECn66DG,cAAA;EACA,6BAAwB;EACxB,qBAAW;ADq66Dd;AACA;ECl66DA,cAAA;EACC,yBElhSwB;EFmhSxB,qBAAiB;ADo66DlB;AACA;ECn66DC,cAAA;EACC,6BErxSS;EFsxST,yBEvhSuB;EFwhSvB,oDExhSuB;AH67sEzB;;AAEA;ECl66DE,cAAA;EACA,6BE9hSuB;EHk8sEvB,yBAAyB;ACl66D1B;ADo66DD;ECl66DE,WAAA;EACA,yBEl+R6C;EHs4sE7C,qBAAqB;ACj66DrB;ADm66DF;ECh66DG,WAAA;EACA,yBE1iSsB;EH48sEvB,qBAAqB;AC956DrB;ADg66DF;EC756DG,cAAA;EACA,yBEn/R4C;EHk5sE7C,qBAAqB;AC356DrB;AD656DF;EC156DG,cAAA;EACA,6BAAwB;EACxB,qBAAW;AD456Dd;AACA;ECz56DA,cAAA;EACC,yBErkSe;EFskSf,qBAAiB;AD256DlB;AACA;EC156DC,cAAA;EACC,6BEn0SS;EFo0ST,yBE1kSc;EF2kSd,oDE3kSc;AHu+sEhB;;AAEA;ECz56DE,cAAA;EACA,6BEjlSc;EH4+sEd,yBAAyB;ACz56D1B;AD256DD;ECz56DE,WAAA;EACA,yBE5kSyC;EHu+sEzC,qBAAqB;ACx56DrB;AD056DF;ECv56DG,WAAA;EACA,yBE7lSa;EHs/sEd,qBAAqB;ACr56DrB;ADu56DF;ECp56DG,cAAA;EACA,yBE7lSwC;EHm/sEzC,qBAAqB;ACl56DrB;ADo56DF;ECj56DG,cAAA;EACA,6BAAwB;EACxB,qBAAW;ADm56Dd;AACA;ECh56DA,cAAgB;EACf,yBEznS+B;EF0nS/B,qBAAkB;ADk56DnB;AACA;ECj56DC,cAAA;EACC,6BEj3SS;EFk3ST,yBE9nS8B;EF+nS9B,oDE/nS8B;AHkhtEhC;;AAEA;ECh56DE,cAAA;EACA,6BEroS8B;EHuhtE9B,yBAAyB;ACh56D1B;ADk56DD;ECh56DE,WAAA;EACA,yBEh4SW;EHkxtEX,qBAAqB;AC/46DrB;ADi56DF;EC946DG,WAAA;EACA,yBEjpS6B;EHiitE9B,qBAAqB;AC546DrB;AD846DF;EC346DG,WAAA;EACA,yBEtqSkC;EHmjtEnC,qBAAqB;ACz46DrB;AD246DF;ECx46DG,cAAA;EACA,6BAAyB;EACzB,qBAAW;AD046Dd;AACA;ECv46DA,cAAiB;EAChB,yBE5pSwB;EF6pSxB,qBAAkB;ADy46DnB;AACA;ECx46DC,cAAA;EACC,6BE/5SS;EFg6ST,yBEjqSuB;EFkqSvB,oDElqSuB;AH4itEzB;;AAEA;ECv46DE,cAAA;EACA,6BExqSuB;EHijtEvB,yBAAyB;ACv46D1B;ADy46DD;ECv46DE,WAAA;EACA,yBErsSmC;EH8ktEnC,qBAAqB;ACt46DrB;ADw46DF;ECr46DG,WAAA;EACA,yBAAsB;EACtB,qBE5sSkC;AHmltErC;ACn46DE;EAEC,cE3rSsB;EF4rStB,yBEptSkC;EFqtSlC,qBErtSkC;AHyltErC;ACh46DE;EAEC,cEnsSsB;EFosStB,6BAA6B;EAC7B,sBAAc;EACd,qBAAW;ADi46Dd;AACA;EC936DA,cAAA;EACA,yBAAsB;EACrB,qBE38SU;AH20tEX;AACA;EElwtEE,cAAY;EFowtEZ,6BAA6B;ECh46D9B,yBAAA;EACC,oDE/8SS;AHi1tEX;;AAEA,kBAAkB;ACj46DjB;EAEC,WEp9SS;EDyET,YC8Le;ED7Lf,mBAAY;EF8wtEZ,+DAA+D;ACj46DhE;ADm46DD;EEjxtEE,WAAU;EACV,mBAAY;EFmxtEZ,+DAA+D;ACj46D/D;ADm46DF;ECh46DG,WAAO;ECt5SR,mBCiLc;EDhLd,+DAA+D;AFyxtEjE;AACA;EACE,WAAW;ECh46Db,mBAAmB;EAClB,+DEt+SU;AHw2tEX;AACA;EE/xtEE,WAAU;EFiytEV,YAAY;ECl46Db,mBAAA;EACC,+DE1+SS;EDyET,oDC0MkC;AH4ltEpC;;ACl46DC;EAEC,WE/+SS;EDyET,YC0MY;EDzMZ,mBAAY;EF2ytEZ,+DAA+D;ACn46DhE;ADq46DD;EE9ytEE,WAAU;EACV,mBAAY;EFgztEZ,+DAA+D;ACn46D/D;ADq46DF;ECl46DG,WAAO;ECj7SR,mBCkLW;EDjLX,+DAA+D;AFsztEjE;AACA;EACE,WAAW;ECl46Db,mBAAsB;EACrB,+DEjgTU;AHq4tEX;AACA;EE5ztEE,WAAU;EF8ztEV,YAAY;ECp46Db,mBAAA;EACC,+DErgTS;EDyET,oDCsNwC;AH6mtE1C;;ACp46DC;EAEC,WE1gTS;EDyET,YCsNe;EDrNf,mBAAY;EFw0tEZ,+DAA+D;ACr46DhE;ADu46DD;EE30tEE,WAAU;EACV,mBAAY;EF60tEZ,+DAA+D;ACr46D/D;ADu46DF;ECp46DG,WAAO;EC58SR,mBCmLe;EDlLf,+DAA+D;AFm1tEjE;AACA;EACE,WAAW;ECp46Db,mBAAsB;EACrB,+DE5hTU;AHk6tEX;AACA;EEz1tEE,WAAU;EF21tEV,YAAY;ECt46Db,mBAAA;EACC,+DEhiTS;EDyET,oDC8OwC;AHkntE1C;;ACt46DC;EAEC,WEriTS;EDyET,YC8Oe;ED7Of,mBAAY;EFq2tEZ,+DAA+D;ACv46DhE;ADy46DD;EEx2tEE,WAAU;EACV,mBAAY;EF02tEZ,+DAA+D;ACv46D/D;ADy46DF;ECt46DG,WAAO;ECv+SR,mBCqLgB;EDpLhB,+DAA+D;AFg3tEjE;AACA;EACE,WAAW;ECt46Db,mBAAqB;EACpB,+DEvjTU;AH+7tEX;AACA;EEt3tEE,WAAU;EFw3tEV,YAAY;ECx46Db,mBAAA;EACC,+DE3jTS;EDyET,oDCoLY;AHystEd;;ACx46DC;EAEC,WEhkTS;EDyET,YCoLQ;EDnLR,mBAAY;EFk4tEZ,+DAA+D;ACz46DhE;AD246DD;EEr4tEE,WAAU;EACV,mBAAY;EFu4tEZ,+DAA+D;ACz46D/D;AD246DF;ECx46DG,WAAO;EClgTR,mBCiOuC;EDhOvC,+DAA+D;AF64tEjE;AACA;EACE,WAAW;ECx46Db,mBAAA;EACC,+DEllTU;AH49tEX;AACA;EEn5tEE,WAAU;EFq5tEV,YAAY;EC146Db,mBAAA;EACC,+DEtlTS;EDyET,oDC0P4C;AHgqtE9C;;AC146DC;EAEC,WE3lTS;EDyET,YC0PiB;EDzPjB,mBAAY;EF+5tEZ,+DAA+D;AC346DhE;AD646DD;EEl6tEE,WAAU;EACV,mBAAY;EFo6tEZ,+DAA+D;AC346D/D;AD646DF;EC146DG,WAAO;EC7hTR,mBCsLuB;EDrLvB,+DAA+D;AF06tEjE;AACA;EACE,WAAW;EC146Db,mBAAoB;EACnB,+DEz3S+B;AHqwtEhC;AACA;EEh7tEE,WAAU;EFk7tEV,YAAY;EC546Db,mBAAA;EACC,+DE73S8B;ED3K9B,oDCgKmC;AHuxtErC;;AC546DC;EAEC,cEl4S8B;ED3K9B,YCgKa;ED/Jb,mBAAY;EF47tEZ,+DAA+D;AC746DhE;AD+46DD;EE/7tEE,cC8Ja;ED7Jb,mBAAY;EFi8tEZ,+DAA+D;AC746D/D;AD+46DF;EC546DG,cAAW;ECxjTZ,mBCkKmC;EDjKnC,+DAA+D;AFu8tEjE;AACA;EACE,cAAc;EC546DhB,mBAAmB;EAClB,+DExoTU;AHshuEX;AACA;EE78tEE,cAAY;EF+8tEZ,YAAY;EC946Db,mBAAA;EACC,+DE5oTS;EDyET,oDC4K8B;AHwytEhC;;AC946DC;EAEC,WEjpTS;EDyET,YC4KO;ED3KP,mBAAY;EFy9tEZ,+DAA+D;AC/46DhE;ADi56DD;EE59tEE,WAAU;EACV,mBAAY;EF89tEZ,+DAA+D;AC/46D/D;ADi56DF;EC946DG,WAAO;ECnlTR,mBC2K8B;ED1K9B,+DAA+D;AFo+tEjE;AACA;EACE,WAAW;EC746Db,mBAAmB;EACnB,+DAAkB;AD+46DlB;AACA;EC746DI,WAAA;EACH,YAAY;ED+46DX,mBAAmB;EC946DpB,+DAAgB;EACf,oDE1qTS;AH0juEX;;AAEA,kBAAkB;AC946DjB;EAEC,cEhrTS;EFirTT,6BEt7SW;EFu7SX,sBEv7SW;EHs0tEX,qBAAqB;AC746DtB;AD+46DD;EC746DE,WAAA;EACA,yBEv6SmC;EHsztEnC,qBAAqB;AC546DrB;AD846DF;EC546DG,WAAA;EACA,yBAAsB;EACtB,qBEn8SU;AHi1tEb;AACA;EACE,WAAW;EC346Db,yBAAqB;EACpB,qBEx8SgB;AHq1tEjB;AACA;EC346DC,cE38SU;EHw1tET,6BAA6B;EC546D9B,sBAAA;EACC,qBEzsTS;EF0sTT,oDE98Se;AH41tEjB;;AC346DC;EAEC,cE/sTS;EFgtTT,6BEp9Se;EFq9Sf,sBEr9Se;EHk2tEf,qBAAqB;AC346DtB;AD646DD;EC346DE,WAAA;EACA,yBE17SyC;EHu0tEzC,qBAAqB;AC146DrB;AD446DF;EC146DG,WAAA;EACA,yBAAsB;EACtB,qBEj+Sc;AH62tEjB;AACA;EACE,WAAW;ECz46Db,yBAAqB;EACpB,qBEr+SiB;AHg3tElB;AACA;ECz46DC,cEx+SU;EHm3tET,6BAA6B;EC146D9B,sBAAA;EACC,qBExuTS;EFyuTT,oDE3+SgB;AHu3tElB;;ACz46DC;EAEC,cE9uTS;EF+uTT,6BEj/SgB;EFk/ShB,sBEl/SgB;EH63tEhB,qBAAqB;ACz46DtB;AD246DD;ECz46DE,WAAA;EACA,yBEj8SyC;EH40tEzC,qBAAqB;ACx46DrB;AD046DF;ECx46DG,WAAA;EACA,yBAAsB;EACtB,qBE9/Se;AHw4tElB;AACA;EACE,WAAW;ECv46Db,yBAAoB;EACnB,qBErgTa;AH84tEd;AACA;ECv46DC,cExgTS;EHi5tER,6BAA6B;ECx46D9B,sBAAA;EACC,qBEvwTS;EFwwTT,oDE3gTY;AHq5tEd;;ACv46DC;EAEC,cE7wTS;EF8wTT,6BEjhTY;EFkhTZ,sBElhTY;EH25tEZ,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,WAAA;EACA,yBE5+SuC;EHq3tEvC,qBAAqB;ACt46DrB;ADw46DF;ECt46DG,WAAA;EACA,yBAAsB;EACtB,qBE9hTW;AHs6tEd;AACA;EACE,WAAW;ECr46Db,yBAAA;EACC,qBEliTwB;AHy6tEzB;AACA;ECr46DC,cEriTY;EH46tEX,6BAA6B;ECt46D9B,sBAAA;EACC,qBEtyTS;EFuyTT,oDExiTuB;AHg7tEzB;;ACr46DC;EAEC,cE5yTS;EF6yTT,6BE9iTuB;EF+iTvB,sBE/iTuB;EHs7tEvB,qBAAqB;ACr46DtB;ADu46DD;ECr46DE,WAAA;EACA,yBEn/S6C;EH03tE7C,qBAAqB;ACp46DrB;ADs46DF;ECp46DG,WAAA;EACA,yBAAsB;EACtB,qBE3jTsB;AHi8tEzB;AACA;EACE,WAAW;ECn46Db,yBAAqB;EACpB,qBEtkTe;AH28tEhB;AACA;ECn46DC,cEzkTU;EH88tET,6BAA6B;ECp46D9B,sBAAA;EACC,qBEr0TS;EFs0TT,oDE5kTc;AHk9tEhB;;ACn46DC;EAEC,cE30TS;EF40TT,6BEllTc;EFmlTd,sBEnlTc;EHw9tEd,qBAAqB;ACn46DtB;ADq46DD;ECn46DE,WAAA;EACA,yBE9kTyC;EHm9tEzC,qBAAqB;ACl46DrB;ADo46DF;ECl46DG,WAAA;EACA,yBAAsB;EACtB,qBE/lTa;AHm+tEhB;AACA;EACE,WAAW;ECj46Db,yBAAkB;EACjB,qBE3mT+B;AH8+tEhC;AACA;ECj46DC,cE9mTQ;EHi/tEP,6BAA6B;ECl46D9B,sBAAA;EACC,qBEp2TS;EFq2TT,oDEjnT8B;AHq/tEhC;;ACj46DC;EAEC,cE12TS;EF22TT,6BEvnT8B;EFwnT9B,sBExnT8B;EH2/tE9B,qBAAqB;ACj46DtB;ADm46DD;ECj46DE,WAAA;EACA,yBEn3TW;EHsvuEX,qBAAqB;ACh46DrB;ADk46DF;ECh46DG,WAAA;EACA,yBAAsB;EACtB,qBEpoT6B;AHsguEhC;AACA;EACE,WAAW;EC/36Db,yBAAA;EACC,qBE/nTwB;AHgguEzB;AACA;EC/36DC,cEzpTc;EH0huEb,6BAA6B;ECh46D9B,sBAAA;EACC,qBEpoTuB;EFqoTvB,oDE5pTmC;AH8huErC;;AC/36DC;EAEC,cE1oTuB;EF2oTvB,6BElqTmC;EFmqTnC,sBEnqTmC;EHoiuEnC,qBAAqB;AC/36DtB;ADi46DD;EC/36DE,cAAA;EACA,yBExqTmC;EHyiuEnC,qBAAqB;AC936DrB;ADg46DF;EC936DG,cAAA;EACA,yBAAsB;EACtB,qBE/qTkC;AH+iuErC;AACA;EACE,cAAc;EC736DhB,yBAAA;EACC,qBE75TU;AH4xuEX;AACA;EC736DC,cEh6TM;EH+xuEL,6BAA6B;EC936D9B,sBAAA;EACC,qBEl6TS;EFm6TT,oDAA6B;ADg46D/B;;AC736DC;EAEC,WEx6TS;EFy6TT,6BAA6B;EAC7B,sBE16TS;EHyyuET,kBAAkB;AC736DnB;AD+36DD;EC736DE,WAAA;EACA,6BE/6TS;EH8yuET,kBAAkB;AC536DlB;AD836DF;EC536DG,WAAA;EACA,6BAAsB;EACtB,kBEt7TQ;AHozuEX;AACA;EACE,WAAW;EC336Db,6BAAiB;EAGf,kBAAA;AD236DF;AACA;ECz36DG,WAAA;ED236DD,6BAA6B;ECz36D7B,sBAAA;EACC,kBEp8TQ;EFq8TR,oDEtqTuC;AHiiuE1C;;ACx36DE,gBAAA;AD236DF;ECz36DG,WAAA;EACA,yBEppTuC;EH+guExC,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBErqTqC;EHgiuEtC,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBElpT2C;EH6guE5C,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBEntTuC;EH8kuExC,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBE1uT6B;EHqmuE9B,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBE3vTkC;EHsnuEnC,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBE9uTU;EHymuEX,qBAAqB;ACz36DrB;AD236DF;ECz36DG,cAAA;EACA,yBElvTc;EH6muEf,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBErvTe;EHgnuEhB,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBE3vTW;EHsnuEZ,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBE9vTsB;EHynuEvB,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBExwTa;EHmouEd,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBEnxT6B;EH8ouE9B,qBAAqB;ACz36DrB;AD236DF;ECz36DG,WAAA;EACA,yBEpyTkC;EH+puEnC,qBAAqB;AACvB;ACx36DA;EACA,WAAA;EACI,yBAAiB;ED036DnB,qBAAqB;AACvB;ACz36DA;EACI,cAAY;EACd,yBAAc;ED236Dd,qBAAqB;AACvB;;AAEA,gBC336DQ;AD436DR;EC136DC,iBAAS;AD436DV;;AAEA;EC336DA,gBAAA;ED636DE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EC736DxB,uBAAA;AD+36DA;;AAEA;;;EC536DA,mBAAiB;EACjB,qBAAY;EACX,uBE3iUU;AH26uEX;;AAEA;;ECh46DC,iBAAA;EACC,qBE9iUS;AHi7uEX;;AAEA,gBIl6uEwB;AJm6uExB;EI35uEQ,WAAc;EHyhUpB,0BExuTe;AH+muEjB;AACA;ECt46DE,WAAA;EAMA,2BE/uTc;AHsnuEhB;ACt46DE;EC/jUC,yBAAY;EFw8uEb,qBAAqB;ACr46DtB;ADu46DD;ECr46DE,2EElvTiB;AHynuEnB;ACt46DE;ECtkUC,yBAAY;EF+8uEb,qBAAqB;ACr46DtB;ADu46DD;ECr46DE,0EErvTe;AH4nuEjB;ACt46DE;EC7kUC,yBAAY;EFs9uEb,qBAAqB;ACr46DtB;ADu46DD;EE34uEE,0EDsgUyC;ADu46D3C;AACA;ECv46DE,yBAAA;ECplUC,qBAAY;AF89uEf;AACA;EACE,0EAA0E;ACv46D3E;ADy46DD;ECv46DE,yBE1wTgB;EHmpuEhB,mBAAmB;ECx46DnB,+DAAA;AD046DF;AACA;ECv46DC,0EAAsB;EACrB,mBEjxTQ;EFkxTR,+DElxTe;AH2puEjB;ACx46DE;ECnmUC,yBAAY;EF8+uEb,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,yEEvxTc;AHgquEhB;ACx46DE;EC1mUC,yBAAY;EFq/uEb,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,2EE1xTc;AHmquEhB;ACx46DE;ECjnUC,yBAAY;EF4/uEb,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,wEE3xTc;AHoquEhB;ACx46DE;ECxnUC,yBAAY;EFmgvEb,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,yEEtyTa;AH+quEf;ACx46DE;EC/nUC,yBAAY;EF0gvEb,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,yEE5yTc;AHqruEhB;ACx46DE;ECtoUC,yBAAY;EFihvEb,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,0EElzTc;AH2ruEhB;ACx46DE;EC7oUC,yBAAY;EFwhvEb,qBAAqB;ACv46DtB;ADy46DD;ECv46DE,sEExzTe;AHisuEjB;ACx46DE;ECppUC,yBAAY;EF+hvEb,qBAAqB;AACvB;ACt46DA;EACA,yEAAa;ADw46Db;AACA;EACE,yBAAyB;ECt46D3B,qBAAe;ADw46Df;AACA;ECt46DC,2EAAiB;ADw46DlB;;ACr46DA,UAAU;AAIN;EACI,kBAAe;ADq46DvB;;ACn46DC;EACO,oBAAgC;EDs46DtC,kBAAkB;EAClB,iBAAiB;AC346Df;;AD846DJ,SAAS;AACT;EC546DC,mBAAuB;AD846DxB;;AAEA;ECn56DI,mBAAuB;ADq56D3B;;AAEA;ECp56DC,qBAAuB;ADs56DxB;;AAEA;ECl56DA,qBAAA;ADo56DA;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;ICx56DA,mBAA6B;ED056D7B;;EAEA;IC/56DA,mBAA6B;EDi66D7B;;EAEA;ICh66DA,qBAA6B;EDk66D7B;;EAEA;IC756DF,qBAA0B;EAIxB;;ED656DA;IACE,mBAAmB;EC356DrB;;ED856DA;IACE,mBAAmB;ECl66DrB;ADo66DF;AACA;EACE;ICn66DA,mBAA6B;EDq66D7B;;EAEA;IC166DA,mBAA6B;ED466D7B;;EAEA;IC366DA,qBAA6B;ED666D7B;;EAEA;ICx66DF,qBAA0B;EAIxB;;EDw66DA;IACE,mBAAmB;ECt66DrB;;EDy66DA;IACE,mBAAmB;EC766DrB;AD+66DF;AACA;EACE;IC966DA,mBAA6B;EDg76D7B;;EAEA;ICr76DA,mBAA6B;EDu76D7B;;EAEA;ICt76DA,qBAA6B;EDw76D7B;;EAEA;ICn76DF,qBAAA;EAIE;;EDm76DA;IACE,mBAAmB;ECj76DrB;;EDo76DA;IACE,mBAAmB;ECx76DrB;AD076DF;AACA;EACE;ICz76DA,mBAA6B;ED276D7B;;EAEA;ICh86DA,mBAA6B;EDk86D7B;;EAEA;ICj86DA,qBAA6B;EDm86D7B;;EAEA;IC976DF,qBAAA;EAIE;;ED876DA;IACE,mBAAmB;EC576DrB;;ED+76DA;IACE,mBAAmB;ECn86DrB;ADq86DF;AACA;EACE;ICp86DA,mBAA+B;EDs86D/B;;EAEA;IC386DA,mBAA+B;ED686D/B;;EAEA;IC586DA,qBAA+B;ED886D/B;;EAEA;ICz86DF,qBAAc;EACd;;ED486DE;IC186DD,mBAAA;EACC;;ED686DA;IC186DF,mBAAQ;EACR;AD486DA;AACA,aC386DW;AD486DX;EC186DC,uBAAoB;AD486DrB;AC386DC;EACC,sBAAW;AD686Db;;AAEA,OC586DE;AD686DF;EC386DE,qBAAa;EACb,wCAAyB;EACzB,sBAAsB;EACtB,qBAAmB;AD686DrB;AACA;EC386DE,uBAAe;ED686Df,qBAAqB;EC586DrB,wBAAA;EAGA,aAAA;EAGC,mBAAe;ED886DhB,8BAA8B;EC586D9B,sCAAqB;EACpB,4BEhjUkC;AH8/uErC;AACA;EC586DI,gBAAA;AD886DJ;AACA;ECz86DG,mBAAA;EACC,yBAAoB;EACpB,gBAAS;AD286Db;AACA;ECz86DI,mBAAgB;EAChB,yBAAmB;AD286DvB;AC186DI;EG9xUI,WAAA;AJ2uvER;AACA;EAGE,aAAa;EC386DX,mBAAmB;AD+86DvB;AACA;ECx86DG,yBAAwB;AD886D3B;AC786DG;EACC,uBEvzUO;EHswvET,6BAA6B;EC386D7B,0BAAA;EACC,wDAAwD;AD686D3D;AC386DE;EACC,WAAA;ED686DD,mBAAmB;ECz86DnB,yBAAA;AD286DF;AACA;ECz86DG,WAAU;AD286Db;AACA;ECx86DC,wDAAW;AD086DZ;AACA;ECz86DE,gBAAA;AD286DF;AACA;ECx86DC,SAAA;EAEC,gBE9lU8B;EF+lU9B,YAAW;AD086Db;ACx86DC;EACC,mBAAmB;AD086DrB;ACx86DC;EACC,gBAAe;AD086DjB;AACA;ECz86DE,eAAA;EACC,cAAS;EACT,gBAAS;AD286DZ;AACA;ECz86DG,mBAAgB;AD286DnB;AACA;ECz86DG,gBAAW;EACX,eAAQ;AD286DX;AC186DG;EAGC,aAAa;EAIf,mBAAA;EACC,kBAAkB;EAClB,WAAW;EACX,QAAK;AD286DR;AACA;EIlzvEQ,aAAA;EAIA,cAAA;AJmzvER;AACA;EC586DI,kBAAS;EACT,WAAS;EACT,SAAS;EACT,eAAU;AD886Dd;AACA;EC786DI,cAAA;EAOF,qBAAA;EACC,iBAAS;ED686DV,aAAa;ECx86Dd,WAAA;EACC,mBAAiB;AD086DnB;AACA;ECz86DE,UAAA;AD286DF;AACA;ECz86DG,kBEnpUQ;EFopUR,UE94UI;EF+4UJ,YAAA;AD286DH;AACA;ECz86DG,kBAAa;EACb,qBAAmB;AD286DtB;AACA;ECz86DG,YAAA;EACA,WAAA;EACA,mBAAe;EACf,WAAQ;EACR,kBAAM;EAGN,aAAS;EAGT,mBAAc;EACd,uBAAiB;ED286DlB,+BAA+B;ECx86DhC,qBAAa;EACZ,eAAW;EACX,+DE9rUmC;EF+rUnC,mCAAoB;EACpB,kCAAoB;EACpB,gBAAa;EACb,UAAA;EACA,YAAA;EACA,cAAa;EACb,kBAAQ;AD086DV;ACz86DE;EACC,uBAAe;ED286DhB,qBAAqB;ECt86DrB,aAAA;ED486DA,mBAAmB;ECx86DpB,wBAAe;AD086DhB;AACA;ECz86DE,wDAAmB;AD286DrB;AACA;ECz86DG,gBAAO;EACP,sBAAkB;EAClB,2BAAM;EACN,4BAAW;AD286Dd;AACA;ECz86DG,kBAAW;AD286Dd;AACA;EACE,oCAAoC;EC186DnC,YAAA;EACC,OAAA;ED486DF,kBAAkB;ECx86DnB,MAAA;EACC,WAAO;EACP,aAAQ;EACR,UAAM;EACN,YAAS;EACT,qBAAS;EACT,gBAAe;AD086DjB;AACA;ECx86DE,eAAe;AD086DjB;AACA;EIt4vEQ,OAAA;EJw4vEN,QAAQ;ECz86DR,MAAA;ED286DA,SAAS;ECz86DR,SAAQ;ED286DT,eAAe;ECz86Df,gBAAA;EACC,aAAQ;ED286DT,gBAAgB;ECr86Df,yBAAoB;ADy86DvB;ACv86DE;;ED086DA,oBAAoB;ACt86DrB;ADw86DD;ECt86DE,eAAW;ADw86Db;ACt86DC;;EAEC,qBAAe;ADw86DjB;ACt86DC;EACC,aAAO;ADw86DT;AACA;ECr86DE,YAAA;EDu86DA,yCCt86Da;ADu86Df;AACA;ECp86DC,YAAA;EACC,gBAAa;ADs86Df;AACA;ECr86DE,yBAAA;EACC,gBAAU;ADu86Db;AACA;;ECp86DG,YAAA;ADu86DH;AACA;ECr86DE,mBAAA;EACC,aAAU;ADu86Db;AACA;ECr86DG,kBAAA;EACA,MAAA;EDu86DD,YAAY;ECn86DZ,WAAA;EACC,8BAAsB;EACtB,+BAA8B;ADq86DjC;AACA;ECj86DE,kBAAA;EACC,UAAA;EDm86DD,gBAAgB;EAChB,8BAA8B;ECh86DhC,+BAAyB;ADk86DzB;AACA;EACE,uBAAuB;EACvB,8BAA8B;ECj86DhC,+BAA4B;ADm86D5B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;ACl86D5C;;ADq86DD;EACE,8CAA8C;ECl86DhD,6CAA0B;ADo86D1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;ICh86DC,OAAO;EDk86DR;;EAEA;IACE,WAAW;IACX,aAAa;EC/76DjB;AACA;ADi86DA;EACE;;IC/76DF,uBAAc;EAEb;EACC;IDi86DE,gBAAgB;ECh86DlB;ADk86DF;AACA,aAAa;ACj86DV;EACC,sBEl1UY;AHqxvEhB;;AAEA,aGlxvEa;AHmxvEb;EC976DE,mBAAA;ADg86DF;AACA;EC376DG,cAAA;AD676DH;AACA;EC576DI,cAAA;AD876DJ;AACA;EC376DG,cAAA;AD676DH;AACA;ECz76DG,kBAAA;AD276DH;AACA;ECv76DC,gCAAwB;ADy76DzB;AACA;EACE,YAAY;ACv76Dd;ADy76DA;ECv76DC,+BAAyB;ADy76D1B;AACA;ECv76DC,+BAAa;ADy76Dd;ACx76DC;EACC,gBAAa;AD076Df;;AAEA;ECx76DE,mBAAQ;ED476DR,mBAAmB;EACnB,aAAa;ACv76Df;AACA;EACC,sCAAiB;EACjB,YEloVM;EFmoVN,oBAAe;EDy76Dd,kBAAkB;ECx76DnB,QAAA;EACC,mBAAiB;EACjB,+BAAgB;AD076DlB;;ACv76DC,cAAA;AD076DD;ECx76DE,kBAAgB;EAChB,gBAAc;ED076Dd,gCAAgC;ACx76DjC;AD076DD;ECx76DE,kBAAgB;EAChB,gBAAc;ED076Dd,oBAAoB;ACx76DrB;AD076DD;ECx76DE,iBAAc;EACd,gBAAe;EACf,qBAAqB;AD076DvB;ACx76DC;EACC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAgB;AD076DlB;AACA;ECx76DC,cAAA;EACC,eAAS;EACT,gBAAa;EACb,qBAAmB;AD076DrB;AACA;EACE,kBAAkB;ECz76DlB,yBAAA;EACC,gBAAS;EACT,oBAAa;AD276DhB;AACA;ECz76DI,aAAW;EAIb,mBAAA;AD276DF;AACA;ECx76DG,aAAQ;EACR,qBE18UkC;AHq4vErC;ACz76DE;EACC,YAAQ;EACR,WE98UY;AHy4vEf;ACx76DC;EACC,mBAAS;AD076DX;AACA;ECx76DE,kBAAgB;EAChB,cAAY;AD076Dd;ACx76DC;EACC,kBAAgB;ED076DhB,cAAc;ACz76Dd;AD276DF;EAEE,aAAa;ECt76Db,mBAAiB;AD076DnB;AACA;ECx76DE,iBAAiB;AD076DnB;ACz76DE;EACC,oBAAW;EACX,mBAAkB;AD276DrB;AACA;ECz76DG,kBAAW;EACX,yDAAY;EACZ,sBEj+U6B;EFk+U7B,2BAAW;ED276DZ,4BAA4B;ACz76D5B;AD276DF;ECz76DG,WAAS;ED276DV,kBAAkB;ECx76DnB,OAAA;EACC,MAAA;EACA,WAAA;ED076DA,YAAY;ECv76DV,mBAAA;EDy76DF,WAAW;AACb;AACA;ECt76DK,kBAAA;EACC,UAAO;ADw76Db;ACj76DE;EDm76DA,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EErrwEI,YAAO;AFwrwEX;ACh76DG;EDk76DD,YAAY;AACd;AACA;;;EE5rwEI,WAAO;AFgswEX;AC/66DE;ECrxVE,+BAAY;AFuswEhB;AACA;;EC366DE,+BAAU;AD866DZ;AACA;;EC166DA,+BAAa;AACb;AD666DA;EACE,oCAAoC;AACtC;;AC366DA;EACC;ID866DG,mBAAmB;EACrB;AC766DF;AD+66DA,YGj9vES;AHk9vET;EC766DC,eAAc;AD+66Df;;AAEA,OC/66DE;ADg76DF;EC966DC,mBAAA;ADg76DD;;AAEA;EC966DC,cAAA;EACC,qBEvjVmC;EFwjVnC,uBE5jVa;AH4+vEf;AACA;EC966DC,gBAAA;ADg76DD;AACA;EC966DE,qBE1iVuB;EF2iVvB,kDEnkVmC;AHm/vErC;AC966DC;EACC,cEnjVS;EFojVT,yBAAU;EDg76DV,mBAAmB;AC966DpB;ADg76DD;EACE,qBAAqB;EC966DtB,gBAAA;EACC,cEtzVW;EHsuwEX,yBAAyB;AC966D1B;ADg76DD;EACE,qBAAqB;EC966DtB,UAAA;ADg76DD;AACA;EC966DC,+BAAA;ADg76DD;AACA;EC966DC,cAAA;ADg76DD;AACA;EC966DE,cAAa;ADg76Df;AACA;EC966DE,cAAW;ADg76Db;AC/66DE;EACC,cAAW;ADi76Dd;AC966DC;EAEC,aAAW;EACX,cEzlV8B;EHwgwE9B,eAAe;EACf,gBAAgB;EC766DlB,eAAA;EACC,kCAAY;AD+66Db;AACA;EC966DA,gBAAa;ADg76Db;AACA;EC966DC,2BAAA;EACC,cE7lVS;AH6gwEX;;AAEA;EC966DA,YAAA;ADg76DA;;AAEA;EC/66DA,oEAAA;ADi76DA;AACA;EC/66DI,qBAAkB;EDi76DpB,UAAU;AACZ;;AAEA;EC/66DC,YAAA;ADi76DD;;AAEA;;EAEE,sBCj76Dc;EACZ,oEAAmB;ADk76DvB;;ACh76DA;;EAGE,sBAAsB;EDk76DtB,oEAA6V;ACh76D9V;;ADm76DD;;EC/66DC,mBAAA;ADk76DD;;AC966DE,WAAA;ADi76DF;EACE,sBAAsB;AACxB;AC566DE;EACC,yBAAkB;ED866DnB,qBAAqB;AACvB;AC366DA;EACC,kDAAgB;AD666DjB;AACA;EC566DC,cAAA;AD866DD;;AAEA;EC566DE,kBAAkB;AD866DpB;;AAEA;EC566DE,gBAAY;ED866DZ,iBAAiB;AACnB;AC366DC;EACC,eAAQ;EACR,cAAO;EACP,iBAAY;ED666DZ,kBAAkB;AC366DnB;AD666DD;EACE,mBAAmB;EACnB,iBAAiB;AC166DlB;;AD666DD;EACE,gBAAgB;EC166DlB,eAAe;EAEd,mBAAA;AD266DD;AACA;EC166DE,kBAAA;AD466DF;;AAEA;EACE,kBAAkB;AC166DlB;;AD666DF,cC366De;AD466Df;ECz66DC,oBAAA;AD266DD;AACA;EC166DE,aAAA;EACC,YAAQ;EACR,mBAAY;AD466Df;AACA;EC166DE,mBAAA;EACC,kBAAiB;AD466DpB;AACA;EACE,oBAAoB;ACz66DtB;AAGE;EACC,aAAY;EDy66Db,YAAY;ECv66DZ,mBAAA;ADy66DF;AACA;ECt66DC,iBAAA;EACC,kBE/sVS;AHunwEX;;AAEA,aCx66DG;ADy66DH;EACE,kDAAkD;ACp66DpD;AAEC;EACC,kDExtVe;AH6nwEjB;AACA;ECn66DE,yBAAU;ADq66DZ;ACp66DE;EACC,yBAAc;ADs66DjB;;AAEA,kBGrowEW;AHsowEX;EACE,qBAAqB;ECn66DtB,sBAAA;EACC,sBAAc;EACd,UAAA;ADq66DF;AACA;EACE,gCAAgC;ACp66DhC;ADs66DF;ECp66DG,qBAAY;EDs66Db,kDAAkD;AACpD;ACl66DC;EACC,gCEjvVe;EFkvVf,sBAAsB;EACtB,sBAAsB;EACtB,UAAU;ADo66DZ;ACn66DE;EACC,qBAAc;EDq66Df,gDAAgD;ACn66DhD;;ADs66DF;EACE,qBAAqB;ECl66DtB,sBAAa;EACZ,sBE7vVY;EF8vVZ,UAAA;ADo66DF;AACA;EACE,gCAAgC;ACn66DhC;ADq66DF;EACE,qBAAqB;ECn66DrB,kDAAQ;ADq66DV;AACA;EACE,qBAAqB;EACrB,sBAAsB;ECj66DvB,sBAAA;EACC,UAAA;ADm66DF;ACl66DE;EACC,gCE/wVc;AHmrwEjB;ACl66DE;EACC,qBAAY;EDo66Db,gDAAgD;ACj66D/C;;ADo66DH;EC/56DC,qBAAA;ADi66DD;AACA;ECh66DE,yBAAA;ADk66DF;AACA;ECh66DE,kDAAQ;ADk66DV;AACA;EC/56DG,cAAA;ADi66DH;AACA;EACE,qBAAqB;AC356DrB;AD656DF;EC356DG,yBAAsB;AD656DzB;AACA;EACE,gDAAgD;AC556D/C;AD856DH;EACE,cAAc;AC556Db;;AD+56DH;EACE,qBAAqB;EC356DrB,sBAAA;EACC,sBExzVW;EFyzVX,UAAA;AD656DH;AACA;EACE,gCAAgC;AC556D/B;AD856DH;EACE,qBAAqB;EC556DpB,kDAAQ;AD856DX;AACA;EACE,qBAAqB;ECz56DrB,sBAAA;EACC,sBEx0Vc;EFy0Vd,UAAA;AD256DH;AACA;EACE,gCAAgC;AC156D/B;AD456DH;EACE,qBAAqB;EC156DpB,gDAAA;AD456DH;AACA;EACE,qBAAqB;ECz56DrB,sBAAA;EACC,sBEp1VW;EFq1VX,UAAA;AD256DH;AACA;EACE,gCAAgC;AC156D/B;AD456DH;EACE,qBAAqB;EC156DpB,kDAAA;AD456DH;AACA;EACE,qBAAqB;ECv56DrB,sBAAA;EACC,sBEp2Vc;EH6vwEf,UAAU;ACx56DT;AD056DH;EACE,gCAAgC;ACx56D/B;AD056DH;EACE,qBAAqB;ECv56DnB,gDAAA;ADy56DJ;AACA;ECr56DE,qBAAA;ADu56DF;AACA;ECt56DG,yBAAA;ADw56DH;AACA;ECt56DG,kDAAQ;ADw56DX;AACA;ECr56DI,cAAA;ADu56DJ;AACA;EACE,qBAAqB;ACj56DvB;ADm56DA;EACE,yBAAyB;AAC3B;ACl56DA;EACC,gDEr4Va;AHyxwEd;AACA;ECn56DA,cAAe;ADq56Df;;AAEA;ECp56DA,cAAiB;ADs56DjB;;AAEA;ECr56DA,cAAe;AACf;;ADw56DA;ECr56DC,mBAAe;ADu56DhB;;AAEA;EACE,mBAAmB;ACt56DnB;;ADy56DF,cCv56DY;ADw56DZ;ECt56DG,aAAA;EACA,kBAAa;EACb,eAAe;EAGf,mBAAkB;ADw56DrB;AACA;;ECr56DG,aAAW;ED056DZ,mBAAmB;ECt56DpB,uBAAA;EACC,+BAAM;EDw56DN,qBAAqB;ECt56DtB,kBAAA;EACC,UAAO;EDw56DP,sBAAsB;ECp56DtB,gBAAA;EDs56DA,eAAe;ECr56Dd,gBAAa;EDu56Dd,iBAAiB;ACr56DjB;ADu56DF;ECt56DG,OAAA;ADw56DH;ACp56DE;EDs56DA,QAAQ;AACV;AACA;;EAEE,oBAAoB;ACp56DpB;ADs56DF;;ECn56DG,yBAAkB;ADs56DrB;ACr56DG;;EACC,mBAAiB;EDw56DnB,uBAAuB;ECt56DtB,iBAAA;ADw56DH;AACA;;ECn56DE,qBAAA;EDs56DA,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;ACp56DlB;ADs56DF;;ECn56DG,mBAAkB;ADs56DrB;ACr56DG;;EACC,kBAAiB;EDw56DnB,oBAAoB;ECt56DnB,eAAA;ADw56DH;AACA;;ECn56DE,oBAAA;EDs56DA,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;ACp56DlB;ADs56DF;;ECn56DE,mBAAA;ADs56DF;AACA;;EAEE,yBAAyB;ECj56DvB,uBAAmB;EDm56DrB,UAAU;ACj56DT;ADm56DH;ECl56DI,oBAAc;ADo56DlB;AC946DI;EDg56DF,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;AACpB;AACA;;ECz46DA,mBAAA;AD446DA;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;AACvB;;AAEA;;;;;;;;;;EC146DA,uBAAkB;ADq56DlB;;AAEA;;;;;EC/46DC,uBAAuB;ADq56DxB;;AAEA;EACE,qBAAqB;ECp56DvB,sBAAA;EACC,iBAAc;EDs56Db,uBAAuB;EACvB,cAAc;ECr56DhB,gBAAA;EACC,uBAAc;EDu56Db,+BAA+B;EAC/B,qBAAqB;ECp56DtB,eAAA;ADs56DD;;AAEA;ECr56DE,eAAA;ADu56DF;;AAEA;ECr56DG,eAAS;ADu56DZ;;AAEA;ECt56DG,kBAAA;EACC,mBAAM;ADw56DV;ACt56DG;EACC,kBAAO;EDw56DT,wBAAwB;ECr56DxB,UAAA;EACC,SAAA;EDu56DD,uBAAuB;ECt56DtB,oBAAA;ADw56DH;AACA;ECt56DG,OAAA;ADw56DH;AACA;ECj56DI,QAAA;ADm56DJ;AACA;ECj56DI,gCAAA;ADm56DJ;AACA;EC346DI,oBAAA;AD646DJ;AACA;EC346DI,qBAAA;AD646DJ;AACA;ECt46DE,oBAAA;ADw46DF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;;;;;;;;;;;EAWE,UAAU;AC546DT;AD846DH;EC546DI,cAAA;EACA,YAAA;ED846DF,SAAS;AACX;AC146DA;;ED646DE,yBAAyB;EACzB,4BAA4B;AC346D9B;AD646DA;;EC146DC,0BAAQ;ED646DP,6BAA6B;AC546D9B;;AD+46DD;EACE,cAAc;AAChB;;AAEA;EC546DC,cAAa;EACb,yBAAyB;EACzB,2BAAsB;AD846DvB;AACA;EC546DC,cAAA;EACA,mBAAe;AD846DhB;;AC546DC;EDg56DC,aAAa;ECz46Dd,mBAAA;EACC,8BAAc;EACd,sCAAc;ED646Dd,4BAA4B;EC346D7B,oBAAA;AD646DD;AACA;EACE,gBAAgB;AC146DhB;;AD646DF,eAAe;AC146Db;EACC,eAAc;ED446Df,cAAc;AAChB;ACz46DA;;EAEC,aAAY;AD246Db;AACA;EC146DA,wBAAmB;AD446DnB;AACA;EACE,cAAc;AC346DhB;;AD846DA,UC346DS;AD446DT;EC146DE,qBAAgB;AD446DlB;;AAEA;EC146DE,mBAAe;AD446DjB;;AAEA,gBC346DQ;AD446DR;EC346DE,aAAA;EAGA,mBAAA;EACC,uBAAM;EACN,+BAAoB;ED646DrB,qBAAqB;EC146DpB,gCAAA;EACC,2BAAe;ED446DjB,yBAAyB;ACx46DxB;AD046DH;EACE,aAAa;ACn46DX;ADq46DJ;EACE,+DAA+D;EC/36D7D,oBAAA;ADi46DJ;AACA;EACE,gBAAgB;AC336DlB;AACA;ED636DE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AC136DA;EACC,iBE5vWc;AHwnxEf;;AC136DA,UAAA;AD636DA;;EC136DE,4BAAA;EACC,6BAAkB;AD636DrB;;AAEA;EC536DI,qBAAoB;AD836DxB;;ACx36DC;ED236DC,sBAAsB;AACxB;AACA;ECz36DE,mBAAQ;AD236DV;AACA;ECz36DE,yBAAgB;EAChB,oBExwW8B;AHmoxEhC;;AAEA;;EAEE,cAAc;EC136Dd,WAAA;ED436DA,2BAA2B;EC336D1B,qBExwWa;EHqoxEd,eAAe;EC336Df,gBAAA;ED636DA,cAAc;EC536Db,sBE3wWa;EF4wWb,yBAAY;ED836Db,qBAAqB;EC536DrB,qEAAA;AD836DF;AACA;;EC536DG,qBAAU;AD+36Db;AC936DG;;EACC,qBAAiB;EACjB,kDAA4B;ADi46DhC;AACA;;EC936DI,2BAAW;EACX,MAAA;EACA,UAAQ;ADi46DZ;AACA;;EC736DE,oEAAA;EDg46DA,4BAA4B;EC/36D3B,2BEtyW6B;EFuyW7B,0BAAoB;EACpB,YAAY;EACZ,WAAA;EDi46DD,cAAc;EC936Df,YAAA;EACC,YAAY;EDg46DZ,gBAAgB;AC936DjB;ADg46DD;;EAEE,cAAc;EC736Dd,oBAAA;EACC,eE/yWQ;EH8qxET,gBAAgB;AC536Df;AD836DH;EC536DI,qBAAA;AD836DJ;AACA;ECz36DC,yBAAA;EACC,kDE3zWc;AHsrxEhB;ACz36DC;EACC,qBEj1Wa;AH4sxEf;AACA;;ECx36DG,+BAAW;EACX,8BAAW;AD236Dd;AACA;EC136DE,yBAAA;AD436DF;AACA;EC136DG,yBAAa;EACb,cAAa;AD436DhB;AACA;EC136DG,YAAY;EACZ,+BAAqB;EACrB,UAAA;AD436DH;AACA;EC336DG,yBAAA;EACC,YEv1WK;EFw1WL,cAAa;EACb,qBAAoB;EACpB,cAAY;EACZ,qBAAmB;EACnB,mBAAY;EACZ,qBAAe;EACf,gBAAS;EACT,0BAAkB;AD636DtB;AACA;EC536DI,cAAA;EACC,gBAAS;ED836DZ,oBAAoB;EC136DpB,YAAA;EACC,mBAAe;ED436DhB,YAAY;EACZ,gBAAgB;ECx36DlB,SAAA;ED036DE,kBAAkB;ECx36DhB,SAAS;AD036Db;AACA;ECx36DA,UAAW;AACX;AD036DA;EACE,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AC136DvB;;AD636DA,UAAU;AACV;EC336DA,yBAAA;AD636DA;;AAEA;EC536DA,gMAAU;AD836DV;;AAEA;EC536DC,qCAAa;AD836Dd;;AC336DC;EACC,uCAAiB;AD836DnB;;AAEA;EC336DG,uCAAoB;AD636DvB;;AAEA;EC336DG,gBAAe;AD636DlB;AACA;EC136DC,iBAAA;AD436DD;AACA;EACE,mBAAmB;EC136DpB,oBAAA;AD436DD;AACA;EACE,iBAAiB;EC136DlB,eAAA;EACC,cAAY;AD436Dd;AC136DC;ED436DC,oBAAoB;EC136DpB,cAAc;AD436DhB;AACA;EC136DE,qBEn6W8B;EH+xxE9B,qBAAqB;AC136DtB;AD436DD;EC136DE,gBAAc;AD436DhB;AC136DC;;EAEC,yBEx7WmC;EFy7WnC,qBAAc;ED436Dd,mBAAmB;EC136DlB,cAAA;AD436DH;AACA;EACE,mBAAmB;ECz36DpB,yBAAA;AD236DD;AACA;;ECx36DE,mBE/7WY;EH0zxEZ,yBAAyB;AAC3B;ACz36DA;;EAEC,yBAA4B;AD236D7B;AACA;EC136DA,cAAA;AD436DA;AACA;EACE,yBAAyB;AC336D3B;;AD836DA;EACE,uCAAuC;EACvC,yBAAyB;AC536D3B;;AD+36DA;EC536DC,8BAAS;AD836DV;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AC736DvC;;ADg46DA;EACE,6BAA6B;EC936D/B,oCAAA;EACI,kCAAmC;EDg46DrC,qBAAqB;EACrB,sBAAsB;EC936DxB,gMAAe;AACf;;ADi46DA;EC936DC,uCAAsB;ADg46DvB;;AC936DC;EACC,8BAAkB;ADi46DpB;;AAEA,cCh46DW;ADi46DX;EC/36DE,gBAAQ;EACR,kBAAiB;EACjB,sBAAY;EACZ,qBAAW;ADi46Db;AACA;EACE,kBAAkB;EAClB,MAAM;EC/36DR,QAAA;EDi46DE,SAAS;EC/36DV,UAAS;EDi46DR,wBAAwB;EACxB,iBAAiB;EC/36DlB,YAAA;EACC,WAAA;EACA,cAAA;EDi46DA,eAAe;AC936Df;;ADi46DF;;EAEE,aAAa;AC736Df;;ADg46DA;EC736DC,+BAAsB;ED+36DrB,kCAAkC;AC936DnC;ADg46DD;EC936DE,0BAAe;EACf,6BE//W8B;AH+3xEhC;;AAEA;EACE,0BAA0B;EC736D1B,cAAA;EACC,sBAAkB;AD+36DrB;AC736DE;EACC,aAAa;ED+36Dd,gBAAgB;EC736DhB,cAAA;AD+36DF;AACA;EACE,cAAc;AC536DhB;AD836DA;EC536DC,6BAAsB;AD836DvB;AACA;EC536DC,sBAAc;AD836Df;AACA;EC336DG,sBAAA;AD636DH;;AAEA;EACE,0BAA0B;EC336DzB,sBAAA;EACC,oBAAkB;EAClB,cAAa;EACb,eEthXqB;EHm5xEvB,aAAa;AC136Db;AD436DF;EC136DG,cE1xXQ;EF2xXR,cAAY;EACZ,gBAAW;AD436Dd;AACA;EC136DG,mBEjyXU;EFkyXV,cAAS;ED436DV,cAAc;AC336Db;AD636DH;EC336DI,eAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAA;EACA,cAAc;EACd,kBAAgB;AD636DpB;AACA;EC336DI,gBAAQ;EACR,qBAAkB;EAClB,uCAAO;EACP,kBAAQ;EACR,8BAAY;EGxyXR,oBAAsB;EAItB,oBAAmB;EAInB,cAAgB;EAIhB,wBAAiB;EAIjB,mCAAoB;EJ0pyE1B,kCAAkC;EC736DnC,QAAA;EC10XG,kBAAY;EF0syEd,OAAO;EC936DP,QAAA;EACC,YAAW;EAIV,2BAAS;ADi46Db;AACA;EC/36DI,kCAAoB;ADi46DxB;AACA;EACE,gBAAgB;ACh46Dd;ADk46DJ;EACE,eAAe;EC736DhB,gBAAA;EACC,UAAO;EACP,gBAAW;EACX,yBAAwB;EACxB,qBAAgB;EAChB,cAAc;EACd,mBAAQ;AD+36DV;AACA;EC936DE,aAAA;ADg46DF;AACA;EC736DC,YAAA;EACC,kBAAkB;ED+36DlB,wBAAwB;EACxB,gBAAgB;EC336DjB,qBAAA;ED636DC,QAAQ;EC536DR,UAAQ;AD836DV;AACA;EACE,mBAAmB;AC736DnB;AD+36DF;EC936DG,sBAAkB;ADg46DrB;;AAEA;;EC/36DI,cAAQ;EACR,aAAO;EDk46DT,iBAAiB;ACh46DhB;ADk46DH;;EAEE,mBAAmB;ACh46DnB;ADk46DF;;ECh46DG,kBAAU;EDm46DX,eAAe;ECh46Dd,cAAA;ADk46DH;AACA;;EAEE,mBAAmB;AACrB;AC/36DC;;EDk46DC,kBAAkB;EAClB,UAAU;AC/36DZ;AAGE;;;EAGC,UAAU;AD+36Db;;AAEA;EC936DG,kBAAA;ADg46DH;;AAEA,cC/36DgB;ADg46DhB;EC936DI,yBAAyB;EACzB,2BAAkB;EAClB,2BAAa;EACb,gBAAA;EACA,kBAAgB;ADg46DpB;AACA;EC936DI,gBAAA;EACA,wBAAqB;EACrB,kBAAY;EACZ,mCAAW;EACX,kCE1qXiC;EF2qXjC,kBAAkB;EAClB,aAAa;EAGb,mBAAmB;EG/4Xf,uBAAsB;EAItB,+BAAyB;EAYzB,qBAAc;EJkwyEpB,YAAY;ECh46DX,WAAA;EACC,mBAAW;EACX,kBAAkB;EAClB,aAAY;EACZ,WAAW;EACX,WAAW;EACX,mBAAO;EGp5XH,yBAAmB;AJyxyE3B;AACA;ECh46DG,WAAA;EACC,kBEprX4B;EHsjyE9B,uBAAuB;ECj46DrB,WAAA;EACC,WAAU;EDm46Db,OAAO;EC936DL,SAAA;EAEC,yBAAA;ADi46DL;AACA;EC336DG,cAAA;AD636DH;AACA;EACE,mBAAmB;AC536DjB;AD836DJ;EACE,cAAc;AC536DZ;AD836DJ;EACE,mBAAmB;ACz36DpB;AD236DD;ECz36DE,cAAa;EACb,gBAAY;AD236Dd;AACA;ECz36DE,mBAAgB;AD236DlB;AC136DE;EACC,uBAAW;AD436Dd;AACA;EC136DG,gBAAgB;ED436DjB,gBAAgB;EC336Df,iBAAA;EACC,SEptXM;EHilyER,YAAY;ECz36DV,uBAAA;AD236DJ;AACA;ECz36DK,WEpuXI;EH+lyEP,YAAY;EC136DT,iBAAA;EACC,gBAAY;AD436DlB;ACt36DC;EACC,cEj+XK;AHy1yEP;AACA;ECv36DE,gBAAA;EACC,gCAAqB;EACrB,cAAa;ADy36DhB;AACA;ECv36DG,gDE9uXa;AHumyEhB;AACA;ECv36DG,gBAAgB;EAChB,yBAAqB;ADy36DxB;AACA;ECv36DG,qBAAe;EACf,gBAAY;EACZ,kBAAe;EACf,mBAAS;EACT,mBAAe;EDy36DhB,sBAAsB;ECt36DrB,yBAAA;EAGC,iBErvXc;EH6myEhB,yBAAyB;EACzB,0BAA0B;ECp36D5B,aAAA;EACC,eAAA;EDs36DC,sBCr36DW;EDs36DX,qBAAqB;AACvB;ACn36DA;EACA,WAAS;EACR,yBAAY;EACZ,qBAAoB;ADq36DrB;;AAEA;EACE;ICp36DF,WAAgB;EACf;ADs36DD;AACA,UCr36DQ;ADs36DR;ECp36DC,YAAY;EDs36DX,qBAAqB;EACrB,uCAAuC;ECr36DzC,6CAAc;ADu36Dd;;AAEA;ECr36DC,cAAW;EDu36DV,sBAAsB;EACtB,uBAAuB;ECr36DzB,gCAAA;EACC,qBAAkB;ADu36DnB;;ACr36DA;EACC,sBAAqB;EDw36DpB,cAAc;EACd,qBAAqB;ECv36DvB,eAAA;ADy36DA;;AAEA;ECx36DA,6BAAA;AD036DA;;AAEA;ECx36DA,gCAAY;AAEX;;AD036DD;ECv36DE,8BAAQ;ADy36DV;;AAEA;EACE,+BAA+B;ACx36D/B;;AD236DF,WAAW;ACx36DT;EACC,gBAAS;EACT,gBAAQ;ED036DT,SAAS;ECz36DR,gCAAA;EACC,gBAAU;EACV,iBAAe;AD236DnB;AACA;ECz36DI,gBAAU;AD236Dd;AACA;ECz36DI,UAAS;EACT,SAAS;AD236Db;AACA;ECz36DI,mBAAY;EACZ,gBAAY;EACZ,gBAAe;EACf,cAAA;EACA,WAAA;EG5jYI,cAAA;EAIA,gBAAiB;EAYjB,kBAAc;EH+iYjB,aAAS;EACT,uBAAM;EACN,YAAW;EACX,8BAAoB;EACpB,sCAAkB;EAClB,4BAAQ;EDg46DX,gCAAgC;ACz36D7B;AD236DL;EACE,gBAAgB;ECr36Df,+DAAY;EACX,kBAAe;EDu36DjB,oBAAoB;EACpB,kBAAkB;ECl36DpB,QAAA;EAEC,QAAA;EACA,4BEj3X+B;AHouyEhC;AACA;EACE,gBAAgB;ACl36DjB;ADo36DD;ECl36DE,gBE1mYS;AH89yEX;;AAEA,YAAY;ACn36DV;EACC,cAAW;EC9nYV,gBAAO;EFo/yET,uBAAuB;ACl36DvB;ADo36DF;EACE,mBAAmB;ECl36DnB,WAAA;EACC,gBAAW;EACX,gCAAY;ADo36Df;AACA;ECl36DG,gBAAM;EACN,+BAAkB;ADo36DrB;AACA;ECl36DG,gBAAS;ADo36DZ;AACA;EACE,WAAW;EC/26DX,YAAA;EACC,gBAAA;EACA,gBAAA;EDi36DD,+DAA+D;ECh36D9D,kBAAA;EACC,oBAAA;EACA,kBAAA;EDk36DF,SAAS;EC/26DT,WAAA;EACC,4BAA2B;ADi36D9B;AACA;ECh36DG,0CAAA;EACC,2CAA4B;ADk36DhC;AACA;EC526DG,0CAAA;EACC,2CAAgB;AD826DpB;AC726DI;EACC,6CAAgB;ED+26DnB,8CAA8C;AC526D7C;AD826DH;EACE,8CAA8C;EC726D5C,6CAAA;AD+26DJ;AACA;ECz26DE,gBAAA;AD226DF;AACA;ECz26DG,gBAAQ;AD226DX;AACA;EACE,gBAAgB;ACz26DhB;AD226DF;EACE,gBAAgB;ACv26Dd;ADy26DJ;ECv26DK,uBErrYM;EH8hzET,kBAAkB;ECl26DjB,yBAAA;EACC,iCE37XuC;EF47XvC,gBEp8XY;AHwyyEhB;ACn26DI;EC/sYA,wCAA6B;AFqjzEjC;AC916DK;EACC,mBEt8XqC;EFu8XrC,WE/8XK;AH+yyEX;ACz16DI;EACC,mBAAW;ED216Dd,cAAc;ACv16DZ;ADy16DJ;ECv16DK,4BEn+X2B;AH4zyEhC;ACl16DG;EACC,mBAAW;EACX,cEt+XY;AH0zyEhB;ACn16DI;ECjvYA,uBAAO;AFukzEX;AC/06DI;EACC,mBAAc;EDi16DjB,cAAc;AC/06DZ;ADi16DJ;EC/06DK,uBAAa;EDi16DhB,cAAc;AC106Db;AD406DH;EC106DI,4BAAqB;AD406DzB;AACA;EACE,yBAAyB;AAC3B;ACt06DA;EACA,uBAAO;EACL,cAAA;ADw06DF;AACA;ECt06DE,eAAA;EACD,qBEtgYwB;EFugYxB,qBE9hYoC;EHs2yEnC,iBAAiB;ACv06DlB;;AD006DD,QCx06DE;ADy06DF;ECv06DE,iCEvhY8B;EFwhY9B,gCAAmB;EACnB,+BAA0B;EDy06D1B,4BAA4B;ECx06D5B,cAAA;ED006DA,qBAAqB;AACvB;AACA;;ECv06DE,sBAAsB;EACtB,gBAAS;ED006DT,cAAc;ECx06Db,mBAAA;EACC,gCAA0B;AD006D9B;ACt06DC;;EDy06DC,eAAe;ACr06Df;ADu06DF;EACE,sBAAsB;ECn06DtB,qBAAA;ADq06DF;AACA;ECj06DE,0BAAA;ADm06DF;AACA;EC/z6DE,mBAAA;ADi06DF;AACA;EC9z6DC,oBAAa;ADg06Dd;AACA;EC9z6DE,aAAU;ADg06DZ;AACA;EC/z6DE,qBAAG;ADi06DL;AACA;EACE,mBAAmB;AC9z6DpB;ADg06DD;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EC9z6DjB,uBAAkB;ADg06DnB;AACA;;;;;;;ECxz6DC,WAAA;ADg06DD;AACA;EC9z6DC,yBAAoB;ADg06DrB;AACA;EC9z6DC,yBAAkB;ADg06DnB;AACA;EC9z6DC,yBAAgB;ADg06DjB;AACA;EC9z6DC,yBAAe;ADg06DhB;AACA;EC7z6DE,yBAAA;AD+z6DF;AACA;EC3z6DE,yBAAA;AD6z6DF;AACA;EC3z6DG,yBAAU;AD6z6Db;AACA;EC1z6DG,yBAAA;AD4z6DH;AACA;EC1z6DI,WAAU;AD4z6Dd;AACA;ECvz6DE,gBAAA;EACC,OAAA;EACA,UAAQ;EACR,gBAAU;ADyz6Db;AACA;ECtz6DG,gBAAA;EACC,OAAA;EACA,UAAQ;EACR,gBAAU;ADwz6Dd;AACA;ECpz6DC,gBAAA;EACC,QAAQ;EACR,UAAO;EACP,gBAAU;ADsz6DZ;AACA;ECnz6DC,gBAAG;EACF,QAAO;EDqz6DP,UAAU;EACV,gBAAgB;ACnz6DlB;ADqz6DA;ECnz6DC,gBAAS;EACT,OAAO;EDqz6DN,UAAU;AACZ;;AAEA;ECnz6DE,oBAAoB;ADqz6DtB;;AAEA;ECnz6DE,gBAAQ;EACR,SAAS;EACT,WAAU;ADqz6DZ;;AAEA;ECpz6DE,UAAA;EAGC,aAAY;EACZ,kBAAa;EACb,QAAQ;EACR,2BAAM;EACN,gBAAO;EACP,cAAA;EDsz6DD,oBAAoB;AClz6DpB;ADoz6DF;EACE,YAAY;EChz6DZ,WAAA;EACC,YAAA;EDkz6DD,mBAAmB;ECjz6DlB,kBAAA;EACC,MAAA;EDmz6DF,OAAO;EACP,8EAA8E;AErmzE1E;AFumzEN;EE9lzES,UAAA;AFgmzET;AACA;EE9lzES,0CAAwB;AFgmzEjC;AACA;EE7lzES,kGAfmB;AF8mzE5B;;AAEA;EEjnzEM,sBAAiB;EAQd,8BAA2B;EAC3B,iDAAqC;EACrC,6BAAyB;EACzB,gDAAmC;EACnC,4BAAwB;EACxB,+CAAiC;EACjC,cAAA;EAEA,qBAfmB;AF0nzE5B;;AAEA;EE7nzEM,sBAAiB;EAQd,8BAA2B;EAC3B,iDAAqC;EACrC,6BAAyB;EACzB,gDAAmC;EACnC,4BAAwB;EACxB,+CAAiC;EACjC,cAAA;EAEA,qBAfmB;AFsozE5B;;AAEA;EEzozEM,sBAAiB;EAQd,8BAA2B;EAC3B,iDAAqC;EACrC,6BAAyB;EACzB,gDAAmC;EACnC,4BAAwB;EACxB,+CAAiC;EACjC,cAAA;EAEA,qBAfmB;AFkpzE5B;;AAEA;EErpzEM,sBAAiB;EAQd,8BAA2B;EAC3B,iDAAqC;EACrC,6BAAyB;EACzB,gDAAmC;EACnC,4BAAwB;EACxB,+CAAiC;EACjC,cAAA;EAEA,qBAfmB;AF8pzE5B;;AAEA;EEjqzEM,sBAAiB;EAQd,8BAA2B;EAC3B,iDAAqC;EACrC,6BAAyB;EACzB,gDAAmC;EACnC,4BAAwB;EACxB,+CAAiC;EACjC,cAAA;EAEA,qBAfmB;AF0qzE5B;;AAEA;EElszEM,sBAAiB;EAQd,8BAA2B;EAC3B,iDAAqC;EACrC,6BAAyB;EACzB,gDAAmC;EACnC,4BAAwB;EACxB,+CAAiC;EACjC,cAAA;EAEA,qBAfoB;AF2szE7B;;AAEA;EEruzEM,sBAAiB;EAQd,8BAA2B;EAC3B,iDAAqC;EACrC,6BAAyB;EACzB,gDAAmC;EACnC,4BAAwB;EACxB,+CAAiC;EACjC,cAAA;EAEA,qBAfc;AF8uzEvB;;AAEA;EC146DA,sBAAA;EACC,8BAAA;ED446DC,iDAAiD;EACjD,6BAA6B;EAC7B,gDAAgD;EAChD,4BAA4B;EAC5B,+CC346D2C;ED446D3C,WC346DA;ED446DA,qBAAqB;AACvB;;ACt46DG;EACC;;;;;;ID846DA,mBAAmB;ECx46DnB;AD046DJ;AACA,aCp46DgB;ADq46DhB;ECn46DK,kBAAA;EACA,iCAAyB;ADq46D9B;AACA;ECn46DK,cAAc;EACd,iCAAc;ADq46DnB;AACA;;;;;;;;;;;;;EAaE,qBAAqB;ECl46DnB,sBAAA;EACC,kBAAgB;EDo46DnB,mCAAmC;ECj46DhC,kCAAA;EACC,mBAAgB;EDm46DpB,oBAAoB;ECh46DjB,oBAAA;EACC,cAAS;EDk46Db,kBAAkB;ECh46Df,WAAA;EACC,UAAS;EDk46Db,QAAQ;ECr36DN,2BAAA;AD236DJ;;AAEA;;;;;;;CC926DE,oBAAA;ADs36DF;;;AAGA;ECn36DE,WAAO;EDq36DP,YAAY;ECn36Db,UAAA;ADq36DD;AACA;ECr36DE,gBAAA;ADu36DF;AACA;ECp36DE,gBAAA;ADs36DF;AACA;ECn36DC,gBAAA;ADq36DD;AACA;ECn36DE,WAAS;ADq36DX;AACA;ECn36DE,yBAAc;EDq36Dd,cAAc;AAChB;ACl36DA;EAEC,yBAAA;EACC,gBAAW;EDm36DX,yBAAyB;ACj36D1B;ADm36DD;EI95zEQ,iBAAmB;EAYnB,sBAAc;AJq5zEtB;;ACn36DE;EACC,qBAAW;ADs36Dd;AACA;ECr36DG,yBAAA;EACC,sBAAW;ADu36Df;AACA;ECr36DI,yBAAY;ADu36DhB;AACA;ECr36DI,gBAAO;ADu36DX;AACA;EACE,8BAA8B;ACp36D5B;ADs36DJ;ECh36DI,aAAA;EACC,mBAAc;EACd,YAAA;EDo36DH,cAAc;ACh36Dd;;ADm36DF,gBCj36DiB;ADk36DjB;ECj36DG,YAAA;ADm36DH;AACA;EAGE,kDAAkD;EC/26DnD,qBAAA;ADi36DD;AACA;EACE,YAAY;EC926Dd,kBAAc;AAEb;AD+26DD;EACE,WAAW;EACX,kBAAkB;EC726DpB,WAAA;EACC,YAAW;ED+26DV,6BAA6B;EC926D9B,gCAAA;EDg36DC,OAAO;EACP,MAAM;EACN,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EC926DE,+BC9hZ6B;EEjFvB,gCAA4B;AJg+zEpC;AACA;EIr9zEQ,gBAAiB;EAIjB,oBAAoB;AJo9zE5B;AACA;EACE,cAAc;ACl36Df;ADo36DD;ECl36DE,aAAY;ADo36Dd;AACA;ECl36DC,6BAAA;ADo36DD;;AAEA,aCl36DU;ADm36DV;ECl36DE,qBAAA;ADo36DF;;AAEA;ECl36DG,6BAAc;ADo36DjB;ACn36DG;;;;;;;;EAWD,YCjkZqB;EDkkZrB,WAAA;EACA,cAAU;EDs36DV,mBAAmB;EACnB,iBAAiB;ECn36DhB,eAAY;ADq36Df;ACl36DC;EACC,qBAAoB;EACpB,YAAU;EACV,WAAU;ADo36DZ;AACA;ECl36DC,gBAAA;EACC,gBAAc;EACd,mBAAe;ADo36DjB;AACA;ECl36DE,sBAAY;EDo36DZ,gBAAgB;ECn36DhB,cAAA;EACC,eCvlZoB;AF48zEvB;AACA;ECn36DG,yBAAuB;ADq36D1B;;ACl36DE;;EAEC,kBAAc;EDq36Df,mBAAmB;EACnB,WAAW;ECl36Db,qBAAA;EDo36DE,gBCn36Da;EACb,qBAAU;EACV,kBAAc;ADo36DhB;AACA;;;EAGE,aAAa;AACf;ACl36DA;EACE,qBAAW;EACX,gBAAU;EG5rZJ,kBAAoB;EAIpB,kBAAmB;AJ8i0E3B;AACA;EACE,qBAAqB;EACrB,eAAe;ECp36DjB,cAAA;EACE,YAAW;EGlsZL,6CAA4B;AJyj0EpC;AACA;EACE,WAAW;EACX,yBAAyB;ECt36D3B,mBAAe;EACb,uBAAW;EACX,gCAAkB;ADw36DpB;AACA;EI7j0EQ,oBAAmB;EAYnB,qBAAc;AJoj0EtB;;ACv36DA;;EGzsZQ,UAAA;EAYA,cAAc;EAhBd,gBAAA;EAIA,eAAiB;EAIjB,oBAAkB;EAIlB,gBAAiB;AJkk0EzB;;AAEA;EACE,WAAW;EC936Db,kBAAA;EDk46DE,6BAA6B;EC/36D/B,UAAA;ADi46DA;;AAEA;EACE,wBIll0EwB;EJql0ExB,6BAA6B;AAC/B;;AAEA;EACE,WI7l0EM;EJ8l0EN,kBI1l0EwB;EJ2l0ExB,WIvl0EM;EJ0l0EN,6BAA6B;ACv46D/B;;AD046DA;ECr46DG,sCAAiB;ED646DlB,wBAAwB;ECn46D1B,UAAY;AACZ;;ADs46DA;ECl46DC,wBAAmB;ADo46DpB;;AAEA;ECl46DC;IAIC,0BCnpZ+B;EFwh0E/B;;ECl46DF;IAKC,2BE9wZY;EF+wZZ;ADq46DD;ACp46DE,SAAA;ADs46DF;EAGE,yBAAyB;ECp46DzB,iBAAA;ADs46DF;AACA;ECp46DE,mBAAA;ADs46DF;;ACn46DE,WAAA;ADs46DF;EACE,gBAAgB;EAChB,mBAAmB;ECp46DrB,mBAAgB;EACf,gBAAW;EACX,cC7qZuB;EFmj0EtB,YAAY;EACZ,iBAAiB;ECp46DnB,qBAAa;ADs46Db;AACA;ECp46DC,cAAa;EACb,mBAAgB;ADs46DjB;;AAEA;ECp46DC,SAAA;EACA,YCjtZmB;EDktZnB,iBAAO;EDs46DN,WAAW;ECr46DZ,cAAA;EACC,aCptZkB;AF2l0EpB;AACA;EACE,gCAAgC;ECr46DlC,gBAAA;EACE,cAAS;ADu46DX;AACA;ECt46DA,gBAAmB;ADw46DnB;AACA;EACE,gBAAgB;ACv46DlB;ADy46DA;ECv46DC,aAAS;ADy46DV;;AAEA;ECv46DC,uBEh0ZY;EFi0ZZ,qBAAW;ADy46DZ;;AAEA;ECv46DC,cAAQ;EACR,WAAA;EACA,qBAAc;EDy46Db,gBAAgB;ECx46DjB,mBAAS;EACR,mBAAa;EACb,8BAAgB;EAChB,gBE30ZW;EF40ZX,cAAQ;EACR,yBAAmB;AD046DrB;AACA;ECx46DE,cAAU;EACV,mBAAO;AD046DT;;AAEA;ECx46DE,SAAA;AD046DF;;ACv46DA;EAEC,qBAAA;ADy46DD;;AAEA;ECv46DE,kBE32ZW;EHov0EX,SAAS;EACT,OAAO;ECv46DT,MAAA;EACA,YAAA;EDy46DE,cAAc;EACd,WCx46DY;EACb,iBCjvZuB;EF0n0EtB,mBAAmB;EACnB,gBAAgB;ECx46DlB,iBAAe;EACd,qBAAoB;EACpB,gCAAgB;AD046DjB;AACA;EACE,gCAAgC;EAChC,gBAAgB;ECz46DlB,cAAc;EACb,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAc;EACd,kBAAa;ED246DZ,OAAO;EC146DR,QAAA;EACC,WAAU;EACV,kBAAgB;ED446DhB,cAAc;AC146Df;;AD646DD,WC346DE;AD446DF;;EC146DG,gBCnyZoB;EFgr0ErB,gBAAgB;EAChB,cAAc;ACz46Df;;AD446DD,SC146DS;AD246DT;;;ECx46DG,qBAAqB;AD446DxB;;AAEA;ECz46DA,qBAAc;EACV,gBAAA;EACA,YAAA;ED246DF,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAG3C,mBAAmB;AC546DpB;AD846DD;EACE,mBAAmB;EACnB,gBAAgB;AC546DlB;AACA;EACC,mBC7zZ8B;ED8zZ9B,gBAAW;AD846DZ;AACA;EC546DC,WAAW;AD846DZ;;AAEA;EC546DI,kBAAA;ED846DF,aAAa;EC746Dd,YAAA;AD+46DD;AACA;EACE,qBAAqB;EC746DtB,kBAAQ;AD+46DT;;AC546DC;EACC,6CC3zZ2B;ED4zZ3B,6CAAU;AD+46DZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EC546DE,2BAAW;AD846Db;AACA;EC546DE,8BAAkB;AD846DpB;;AAEA,QC746DE;AD846DF;EC546DE,cAAc;EACd,WAAW;EACX,aAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAe;EACf,4DAAkB;EAClB,mCAAY;EACT,kCAAU;AD846Df;AACA;EC746DE,gBAAA;EACC,eAAS;AD+46DZ;AACA;EACE,gBAAgB;AC746DhB;AD+46DF;EACE,cAAc;EACd,UAAU;AC546DZ;AAEC;EACC,aCp2Ze;AFiv0EjB;;AAEA;EACE,YAAY;EC346Db,WAAA;EACC,mBAAc;ED646Dd,sBAAsB;EC546DtB,kBAAA;EAGC,aAAW;EAEX,mBAAA;EACC,uBAAgB;EAChB,+BAAa;EACb,qBAAkB;EAClB,eAAA;EACA,kBAAA;EACA,YAAW;EACX,UCl2Za;EDm2Zb,UAAS;AD+46Db;AC346DE;EACC,gBAAe;ED646DhB,eAAe;EC146Dd,cAAA;AD446DH;AACA;EC346DI,mBAAA;AD646DJ;;AC146DI,cAAA;AD646DJ;EACE,cAAc;AC146Db;AD446DH;EC146DI,cEvgaE;AHm50EN;ACz46DE;EACC,qBAAY;AD246Df;ACx46DC;EACC,uBAAiB;ED046DjB,kBAAkB;ECz46DlB,YAAA;EACC,cAAS;AD246DZ;AACA;ECt46DG,gBAAA;EACC,iCAAmB;EACnB,kBAAkB;EAClB,mCAAmB;EACnB,kCAAiB;EACjB,uBAAkB;EAClB,cAAa;EACb,eAAe;ADw46DnB;ACn46DE;EACC,mBAAgB;ADq46DnB;ACp46DG;EACC,mBAAiB;ADs46DrB;AACA;EACE,mBAAmB;ACh46DlB;ADk46DH;ECh46DI,mBAAiB;ADk46DrB;AACA;ECh46DI,aAAA;EACA,mBAAiB;ADk46DrB;AC/36DI;EACC,aAAM;ADi46DX;AACA;EACE,iBAAiB;ACh46Dd;ADk46DL;EAEE,aAAa;AACf;AC536DA;EACC,mBAAc;ED836Db,kBAAkB;EAClB,oBAAoB;EC736DtB,kBAAgB;EAChB,mBAAO;EACN,mBCh+Z8B;EDi+Z9B,gCAAoB;AD+36DrB;AACA;EC936DC,iBAAY;ADg46Db;AACA;EC936DE,kBAAgB;EDg46DhB,mBAAmB;EC936DpB,6BAAA;ADg46DD;AACA;EACE,mBAAmB;EC/36DnB,kBAAA;EACC,mBAAiB;EACjB,iBAAQ;EDi46DT,oBAAoB;EC/36DpB,iBAAA;ADi46DF;AACA;EACE,SAAO;EC936DR,SAAA;EACC,UC78Ze;AF600EjB;AACA;EACE,uBAAuB;EC936DxB,cAAA;ADg46DD;;AAEA;EACE,2BAA2B;AC936D5B;;ADi46DD,eG3s0Ee;AH4s0Ef;EACE,cAAc;EC936Df,qBAAe;EACd,qBC59Z0B;AF410E5B;AACA;EACE,mBAAmB;EC936DpB,cAAA;EACC,0BE3yZwC;AH2q0E1C;AACA;EACE,oBAAoB;EC936DrB,cAAA;ADg46DD;AACA;EEp/0EI,kBAAc;EFs/0EhB,SAAS;AC936DV;ADg46DD;EC936DE,UAAU;EC1naR,cAAc;AF2/0ElB;AC936DC;EACC,cC5haqB;ED6harB,mBCzha6B;EDiia7B,sCCjia6B;AF050E/B;AC/36DG;EACC,cChiamB;EDiianB,mBAAiB;EACjB,sCAAU;ADi46Dd;AC536DC;EACA,cCxiasB;EFs60ErB,mBAAmB;EC736DnB,sCAAoB;AD+36DtB;AACA;EACE,cAAc;EC736DZ,mBAAA;EACC,sCC9iakB;AF660EvB;AACA;EACE,cAAc;EC336Dd,mBAAA;EACC,sCCzgayB;AFs40E5B;AACA;EC336DI,cAAA;EACC,mBCzjakB;ED0jalB,sCAAqB;AD636D1B;AACA;ECz36DE,cAAA;EACC,mBCphayB;EDqhazB,qBE73ZwC;AHwv0E3C;ACz36DI;EACC,WCpkakB;EDqkalB,mBAAiB;EACjB,qBAAU;AD236Df;ACv36DE;EACC,WAAU;EACV,qBEh3ZwC;EHyu0EzC,UAAU;ACv36DR;ADy36DJ;ECv36DK,WAAA;ADy36DL;AACA;ECr36DE,mBAAA;EACC,cC1iac;AFi60EjB;AACA;ECr36DI,WAAA;EACC,qBC1lakB;ED2lalB,UAAA;ADu36DL;AACA;ECn36DE,mBAAA;EACC,cC1kac;AF+70EjB;AACA;ECn36DI,WAAA;EACC,qBCrmakB;EDsmalB,UAAA;ADq36DL;AACA;ECh36DC,mBAAA;EACC,cCjkae;AFm70EjB;AACA;ECh36DC,WAAA;EACC,qBCrka0B;EDska1B,UCtkae;AFw70EjB;ACh36DC;EACC,mBCzkae;ED0kaf,cC1ka0B;AF470E5B;ACh36DC;EACC,WAAA;EACA,qBC9ka0B;EFg80E1B,UAAU;ACh36DX;ADk36DD;ECh36DE,mBClla0B;EFo80E1B,cAAc;ACh36Df;ADk36DD;ECh36DE,WC3mae;EF690Ef,qBAAqB;ECh36DtB,UAAA;ADk36DD;AACA;EACE,mBAAmB;ECj36DnB,cAAA;ADm36DF;AACA;ECj36DG,WAAS;EACT,qBAAiB;EACjB,UAAA;ADm36DH;AACA;ECj36DG,qBAAiB;EACjB,cAAA;ADm36DH;AACA;ECj36DG,qBAAU;EACV,cAAM;ADm36DT;AACA;EACE,qBAAqB;ECh36DtB,cAAA;ADk36DD;AACA;EACE,qBAAqB;ECh36DvB,cAAA;ADk36DA;AACA;EACE,qBAAqB;ECj36DvB,cAAe;ADm36Df;AACA;ECl36DC,qBAAA;EACC,cC/pa6B;AFmh1E/B;AACA;ECl36DE,sBAAW;EACX,kBCvqaqB;AF2h1EvB;AACA;ECh36DG,aAAa;EACb,iBAAW;EAGX,mBAAc;EACd,uBAAiB;EACjB,+BAAoB;EACpB,qBAAkB;EAClB,YAAA;EACA,WAAW;EDo36DZ,OAAO;ECl36DP,MAAA;EACC,kBAAiB;ADo36DpB;AACA;ECl36DE,gBAAA;ADo36DF;;AAEA;EACE,mBAAmB;ACj36DnB;;ADo36DF;ECj36DG,YAAO;ADm36DV;AACA;ECj36DE,cAAA;EACC,qBEh+Z4C;EFi+Z5C,SClrac;EDmrad,YAAO;EC5yaN,gBAAc;EFgq1EhB,mBAAmB;ECj36DnB,gBAAA;ADm36DF;AACA;ECj36DG,0BAAgB;EClzaf,WAAA;AFsq1EJ;ACj36DE;EACC,cEhhae;EFihaf,0BCzqayB;ED0qazB,oBAAgB;ECxzaf,mBAAc;EF4q1EhB,iBAAiB;ECj36DjB,kBAAA;ADm36DF;AACA;ECj36DG,iBAAgB;EC9zaf,MAAA;AFkr1EJ;ACj36DE;EACC,0BEhhasC;EFihatC,cCrrayB;EDsrazB,gBAAO;ADm36DV;AACA;ECj36DE,mBAAA;EACC,cC3saiB;ED4sajB,iBE9kaiC;EF+kajC,sCAAgB;ADm36DnB;AACA;ECj36DE,mBAAA;EACC,cCxuaiB;EDyuajB,iBC7uaoB;ED8uapB,sCAAgB;ADm36DnB;AACA;ECj36DE,mBAAA;EACC,cAAS;EDm36DV,iBAAiB;ECl36DhB,sCAAA;ADo36DH;AACA;ECl36DI,mBAAU;EACV,cAAS;EDo36DX,iBAAiB;ECj36DjB,sCAAA;ADm36DF;AACA;ECj36DG,mBCzva4B;EF4m1E7B,cAAc;ECl36Db,iBAAA;EACC,sCCntawB;AFuk1E5B;AACA;ECl36DG,mBAAA;EACC,cCvtaa;EDwtab,iBEpjaqC;EHw60EvC,sCAAsC;ACl36DrC;ADo36DH;ECl36DI,mBE5iauC;EHg60EzC,cAAc;ECl36Db,iBAAA;EACC,qBC/tawB;AFml1E5B;AACA;ECl36DG,mBAAA;EACC,WAAU;EACV,iBE5kauC;EHg80EzC,qBAAqB;AACvB;AC/26DC;EACC,sCAAgB;ADi36DlB;AACA;EC/26DE,kBAAO;EDi36DP,eAAe;ECh36Df,UAAA;EACC,SAAA;ADk36DH;AACA;EC926DC,WAAA;EACC,YAAK;EACL,mBAAiB;ADg36DnB;AACA;EACE,mBAAmB;EC/26DnB,cAAA;ADi36DF;AACA;EACE,mBAAmB;EC926DrB,cAAA;ADg36DA;AACA;EACE,mBC326DQ;ED426DR,cC326DW;AD426Db;AACA;ECz26DA,mBAAS;EACT,cAAO;AD226DP;AACA;EACE,mBAAmB;EACnB,cAAc;AC126DhB;;AD626DA;EC126DC,kBAAO;EACP,mBAAa;EACb,sBAAe;ED426Dd,oBAAoB;AACtB;AC326DA;EACA,gBAAS;AD626DT;;AAEA;EC526DC,kBAAA;EACC,mBCp0a6B;EDq0a7B,sBAAoB;ED826DpB,mBAAmB;AC526DpB;AD826DD;EACE,gBAAgB;AC526DjB;;AD+26DD;EACE;IC526DF,OAAA;IACC,QAAS;IACR,WAAQ;ED826DR;AACF;AC526DA,QAAA;AACA;EACI,YAAY;EACZ,qBAAgB;AD826DpB;;AC526DA,mBAAgB;AD+26DhB;EC726DC,kBAAiB;EACjB,QAAA;ED+26DC,cAAc;EACd,eAAe;AC926DjB;;ADi36DA,UC926DE;AD+26DF;EC726DE,kBAAS;EACT,uCAAa;AD+26Df;AACA;EC726DE,mBAAgB;EAChB,qBAAQ;AD+26DV;AACA;EC726DE,UAAS;AD+26DX;AACA;EC726DE,aAAA;AD+26DF;;AAEA;EC726DE;IACA,wBAAc;ED+26Dd;AC926DA;ADg36DF,SEnu1EoB;AFou1EpB;EC926DG,qBAAoB;EACpB,gBAAS;ADg36DZ;;AAEA;EC926DG,sBAAmB;EACnB,4BAAuB;EACvB,2BAAyB;ADg36D5B;;AAEA,QAAQ;AC/26DL;EACC,kBAAW;EACX,sBAAiB;EDi36DnB,0CAA0C;EC/26DzC,aAAA;EACC,YAAS;EACT,eAAU;EACV,gBAAgB;EAChB,sBC54amB;ED64anB,qBAAqB;EAGrB,oBAAS;EAGT,mBAAY;EACZ,uBAAoB;EGj+ahB,+BAAsB;EAItB,qBAAmB;EAInB,eAAkB;AJ601E1B;AACA;EACE,cAAc;ECl36Dd,kBAAA;EAEC,aAAA;EAEC,mBAAA;EACC,uBAAc;EDs36DjB,+BAA+B;EAC/B,qBAAqB;ECj36DvB,kBAAS;ADm36DT;AACA;ECj36DE,mBAAgB;EAChB,iBAAiB;ADm36DnB;AACA;EACE,qBAAqB;ECl36DvB,kBAAS;EACR,yBAAyB;EDo36DxB,WAAW;EACX,qBAAqB;ECn36DvB,kBAAa;EACZ,mBAAa;EDq36DZ,SAAS;ECn36DT,SAAA;EACC,eAAW;EACX,aAAU;EDq36DX,qBAAqB;EAKrB,2BAA2B;ACh36D7B;ADk36DA;ECh36DC,mBAAU;ADk36DX;AACA;EACE,WAAW;ACj36Db;ADm36DA;ECj36DC,cAAU;ADm36DX;;ACh36DA;EACA,oBAAA;EDm36DE,eAAe;ECj36DhB,qBAAS;EDm36DR,sBAAsB;ECj36DtB,UAAA;ADm36DF;;AAEA;EEl61EI,yBAAoC;AFo61ExC;;ACj36DA;EDo36DE,yBCn36D0B;ADo36D5B;AACA;ECl36DC,YAAQ;ECvjbL,WAAA;AF461EJ;AACA;ECl36DC,YAAS;EACT,WAAS;ADo36DV;;AAEA;;ECj36DC,WAAA;EACA,UAAA;ADo36DD;;AAEA;ECn36DC,YAAA;EDq36DC,WAAW;AACb;;AAEA,WCr36DE;ADs36DF;;ECn36DE,UAAA;ADs36DF;AACA;;;;EAIE,mBAAmB;ACp36DrB;;ADu36DA;;ECp36DA,YAAA;EACC,WAAS;EDu36DR,iBAAiB;EACjB,sCAAsC;ECr36DvC,kBAAA;EACC,gBAAe;EAEf,aAAA;EAID,mBAAA;EACC,uBAAe;EDu36Df,+BAA+B;EAC/B,qBAAqB;ECp36DvB,kBAAqB;ADs36DrB;AACA;;ECp36DE,qBAAU;EACV,+DAAW;EACX,oBAAoB;EACpB,oBAAmB;EACnB,WAAO;EACP,oBAAkB;EAClB,oBAAW;EDu36DX,cAAc;ECt36Dd,mCAAA;ECvnbE,kCAAkC;AFg/1EtC;;AAEA;EACE,gBAAgB;ACr36Df;;ADw36DH;ECl36DE,gBAAA;ADo36DF;;ACl36DG;ECtobC,gBAAY;EF4/1Ed,cAAc;AAChB;ACj36DA;EACI,cAAY;ADm36DhB;AACA;ECj36DC,gBAAA;ADm36DD;;ACh36DC;EACC,YAAA;ADm36DF;ACh36DE;EACC,UAAU;EACV,WAAW;EACX,oBAAgB;EAChB,mBAAW;EACX,sBAAO;EDk36DR,kBAAkB;ECh36DlB,uBAAA;ADk36DF;AACA;EC/26DG,mBAAA;ADi36DH;AACA;EC726DG,qBAAA;AD+26DH;AACA;ECz26DG,mBAAA;AD226DH;AACA;ECz26DG,qBAAA;AD226DH;AACA;ECx26DI,mBAAA;AD026DJ;;ACr26DI;EACC,YCjlbY;AFy71EjB;;AAEA;EACE,YAAY;ACj26DX;ADm26DH;EACE,sBAAsB;ACh26DpB;ADk26DJ;EACE,UAAU;EC916DR,WAAA;EACC,gBCzjbY;EFy51Ef,uBAAuB;EC316DxB,yBAAA;AD616DD;AACA;EC316DE,aAAY;AD616Dd;AACA;EC316DE,mBAAW;AD616Db;AACA;EC316DE,mBAAS;AD616DX;AACA;EC316DE,sBAAmB;AD616DrB;AACA;EC316DE,aAAA;AD616DF;AACA;EC316DE,gBEjubW;AH8j2Eb;AC516DE;EACC,gBAAS;AD816DZ;AACA;EC516DG,yBAAmB;AD816DtB;AACA;EC516DG,aAAA;AD816DH;AACA;EC516DG,mBAAA;AD816DH;AACA;EC516DE,mBAAA;AD816DF;AACA;EI9i2EQ,oCAAwB;EAIxB,UAAA;EAIA,YAAc;EJ0i2EpB,SAAS;EC916DT,YAAA;EACC,WAAS;EACT,kBAAM;EACN,SAAO;EDk26DR,aAAa;EAGb,mBC916DY;ED+16DZ,uBC916DW;ED+16DX,+BC916De;ED+16Df,qBAAqB;EACrB,cAAc;AC716DhB;AAEC;EACC,qBAAkB;EAClB,+DClqbqB;EFgg2ErB,oBAAoB;EC516DrB,oBAAA;EACC,WAAU;ED816DV,oBAAoB;EC716DpB,oBAAA;EACC,cAAY;ED+16Db,mCAAmC;EC716DnC,kCAAA;EACC,gBAAc;AD+16DjB;AACA;ECx16DG,0BAAA;AD816DH;AACA;EACE,kBAAkB;EAClB,OAAO;ECz16DR,QAAA;EACC,YAAA;AD216DF;;AAEA;ECz16DC;IACC,YAAS;IACT,WAAS;IACT,eAAa;EACb;AD216DF;AACA,iBC116DiB;AD216DjB;EACE,mBAAmB;EC116DnB,WAAA;AD416DF;AACA;EC116DG,kBAAA;AD416DH;AACA;EC116DG,aAAW;AD416Dd;AACA;EC116DG,eAAA;EACA,WAAO;EG9xbF,uBAAsB;AJ2n2E9B;AACA;EACE,WAAW;AC716DV;AD+16DH;EACE,kBAAkB;EAClB,WAAW;AC316Db;;AD816DA;EACE,qBAAqB;EACrB,gBAAgB;EC516DlB,gEAAyB;AD816DzB;AACA;EC316DE,aAAW;ED+16DX,uBAAuB;EACvB,+BAA+B;EC516DhC,qBAAS;EACR,gBAAa;AD816Df;AC516DG;EACC,cAAS;EACT,sBAAe;EACf,2BAAqB;EACrB,gECjtb6B;EDktb7B,YExlbW;EHs71Eb,YAAY;EC516DX,qBAAA;EACC,iBEr1bE;EFs1bF,yBCjvbmB;EF+k2ErB,6BAA6B;EC116D3B,yBCrvbmB;AFml2EvB;AC516DG;EACC,yBEnwbiC;AHim2ErC;;AC316DG,cAAA;AD816DH;EC516DI,gBAAO;AD816DX;;AAEA;EC716DI,UAAA;AD+16DJ;AACA;EACE,YAAY;EC116Db,WAAA;AD416DD;;AAEA;EACE,aAAa;ACz16Df;AD216DA;EACE,kBC116De;ED216Df,uBAAuB;EACvB,qBAAqB;ECz16DvB,mBAAgB;EAChB,cAAU;AD216DV;AACA;ECz16DI,mBAAY;ED216Dd,WAAW;AACb;AC116DA;EACI,mBAAW;EACd,WAAO;AD416DR;AACA;EACE,mBAAmB;EC316DrB,cAAY;AD616DZ;AACA;EC316DI,cAAY;EACZ,yBAAY;EACZ,gBCtvba;EDuvbhB,qBAAkB;AD616DnB;AC516DI;EACF,gBCzvbe;EFul2Ef,qBAAqB;AACvB;AC316DA;EACI,WAAW;EACX,gBAAS;AD616Db;;AAEA;EACE;IACE,gBAAgB;EC516DpB;AD816DA;AACA,eC716Da;AD816Db;EC516DC,WAAW;EACX,mBAAS;EACN,YAAA;AD816DJ;;AC516DA;EACI,WAAO;EACP,YAAW;EACX,mBAAgB;AD+16DpB;;AAEA;EC716DI,SAAA;ED+16DF,WAAW;EACX,YAAY;EC716Db,YAAA;EACC,mBAAW;ED+16DX,kBAAkB;AC716DnB;AD+16DD;EACE,mBAAmB;AC716DpB;;ADg26DD;EC716DE,WAAQ;ED+16DR,SAAS;EC516DV,WAAA;EACC,YAAW;ED816DX,mBAAmB;AACrB;;AC116DA;EACC,kBAAa;EACb,gBC1zbuB;EFup2EtB,mBAAmB;EC516DpB,gBAAA;EACC,uBAAY;ED816DZ,qBAAqB;AC516DtB;;AD+16DD;EC516DE,cAAW;EACX,kBAAe;ED816Df,gBAAgB;EC316DhB,gBAAA;EACC,qBCtzbc;EFmp2Ef,0BAA0B;EC516DzB,gBAAA;AD816DH;;AC116DE;EACC,WAAA;AD616DH;AACA;EC516DG,WAAA;AD816DH;AACA;EC316DE,SAAA;EACC,WAAA;ED616DD,YAAY;ACz16DZ;AD216DF;EACE,WAAW;ACv16DX;;AD016DF,kBCx16Dc;ADy16Dd;ECv16DG,oBAAkB;EAClB,qBAAkB;ADy16DrB;AACA;ECx16DG,aAAA;AD016DH;AACA;ECz16DI,kBAAA;EACC,qBCl4bkB;EF6t2ErB,kBAAkB;ECt16DjB,gBAAA;ADw16DH;AACA;ECr16DI,yBAAA;ADu16DJ;AACA;ECl16DC,yBAAS;ADo16DV;AACA;ECl16DE,yBCh5b6B;EDi5b7B,cAAc;ADo16DhB;AACA;EACE,yBAAyB;ACl16D1B;ADo16DD;ECl16DE,yBAAqB;ADo16DvB;AACA;ECl16DE,6BAAqB;ADo16DvB;ACl16DC;EACC,eCr4bmC;EFyt2EnC,WAAW;ECl16DZ,YAAA;EACC,mBCp6bqB;EDq6brB,kBAAW;EACX,YAAQ;ADo16DV;AACA;ECl16DE,WAAA;ADo16DF;AACA;EACE,WAAW;ACl16DZ;ADo16DD;ECl16DE,qBAAQ;ADo16DV;AACA;ECl16DE,qBAAmB;ADo16DrB;AACA;ECl16DC,WAAA;EACC,mBAAmB;EACnB,cAAQ;EDo16DR,oBAAoB;ECn16DpB,yBAAA;EACC,gBAAgB;ADq16DnB;ACn16DE;EACC,mBCh5bc;EFqu2Ef,qBAAqB;ECl16DtB,cAAA;EACC,gBCp6bsB;EFwv2EtB,qBAAqB;ACj16DrB;ADm16DF;EACE,cAAc;AAChB;ACh16DA;EACE,gBAAiB;EDk16DjB,WCj16DO;EDk16DP,oBAAoB;ECh16DnB,yBAAA;EDk16DD,eCj16Da;EDk16Db,qBAAqB;EC/06DrB,mBAAA;EDi16DA,cCh16DY;ADi16Dd;AACA;EACE,gBCj16DgB;EDk16DhB,yBCj16DqB;EDk16DrB,eAAe;ECh16Dd,qBAAA;EDk16DD,mBCj16DgB;EDk16DhB,cCj16DE;ADk16DJ;AACA;EACE,mBCh16DY;EDi16DZ,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AC706DA;EAEC,kBAAA;AD806DD;;AAEA;EACE;IC506DD,YAAA;EACC;EACA;ID806DE,YAAY;EC706Dd;EACC;IACA,gBAAM;EACN;EACA;IACA,cAAY;IACZ,mBAAW;EACX;ED+06DD;IC506DD,cAAA;IACC,sBAAoB;EACpB;EACA;IACA,WAAA;EACA;EACA;IACA,WAAA;EACA;EACA;IACA,WAAW;EACX;EACA;IACA,gBAAiB;ED806DjB;AC706DA;AD+06DF,UC906DU;AD+06DV;EC706DG,kBAAa;ED+06Dd,UAAU;EC906DT,iBAAA;ADg16DH;AACA;EACE,aAAa;EC/06DX,kBAAA;ADi16DJ;AACA;EC106DG,kBAAA;EACC,MAAA;ED406DF,OAAO;ECx06DJ,QAAA;EACC,YAAS;EACT,WAAS;EACT,iBAAa;AD006DnB;AACA;EAGE,aAAa;ECv06DR,mBCticwB;EFi32E7B,8BAA8B;ECz06D1B,sCAAA;EACC,4BAAoB;EACpB,YAAW;ED206DhB,gBAAgB;ECt06Db,gCAAA;EACC,kBC7hcuB;AFq22E7B;AACA;ECp06DM,aC7hckB;AFq22ExB;ACr06DI;EACC,kBAAW;EDu06Dd,qBAAqB;ACh06DpB;ADk06DH;EACE,cAAc;AC9z6DX;ADg06DL;EC9z6DM,kBAAS;ADg06Df;AACA;EC5z6DM,aAAa;EAEZ,mBAAe;EACf,qBC/kcwB;AFg52E/B;AC/z6DM;EACC,gBAAa;EACb,cAAc;ADi06DrB;AC5z6DK;EACC,oBCtkcuB;EDukcvB,cAAU;AD8z6DhB;AC5z6DK;EACC,cAAO;EACP,kBCtkc+B;AFo42ErC;AC3z6DI;EACC,gBAAW;ED6z6Dd,cAAc;ACvz6Dd;ADyz6DF;ECvz6DG,oBAAW;ADyz6Dd;AACA;ECtz6DG,kBAAA;ADwz6DH;AACA;ECrz6DK,aAAa;EAIf,mBAAA;EACC,qBAAgB;ADwz6DpB;AACA;ECtz6DI,gBAAW;EDwz6Db,cAAc;ACrz6Dd;ADuz6DF;ECrz6DG,oBAAY;EACZ,cAAW;ADuz6Dd;AACA;ECrz6DG,cAAO;EACP,kBAAQ;ADuz6DX;AACA;ECrz6DG,gBAAW;EACX,cAAS;ADuz6DZ;AACA;ECrz6DG,oBAAmB;ADuz6DtB;AACA;ECrz6DG,kBAAiB;EACjB,YAAA;EACA,UAAA;ADuz6DH;AACA;ECtz6DG,sBAAA;EACC,qBAAqB;ADwz6DzB;AACA;ECtz6DI,qBAAkB;EAClB,oBAAmB;ADwz6DvB;AACA;ECtz6DI,sBAAoB;EACpB,4BAAc;EACd,2BAAwB;EACxB,WAAA;ADwz6DJ;AACA;ECnz6DI,iCAAA;EACC,YAAS;EACT,WAAS;EACT,kBAAa;EACb,kBAAiB;EACjB,OAAA;EACA,QAAA;EACA,MAAK;EACL,SAAS;EDqz6DZ,YAAY;EClz6DR,aAAY;EAIb,mBAAS;EACT,uBAAoB;EACpB,+BAAa;EDqz6DhB,qBAAqB;ECpz6DlB,WAAA;ADsz6DL;AACA;ECrz6DM,qBAAA;EACC,iEAAc;EDuz6DnB,oBAAoB;EACpB,kBAAkB;EC9y6DlB,mBAAA;EACC,oBAAiB;EACjB,oBAAgB;EAChB,oBAAgB;EAChB,cElycU;EHkl3EX,mCAAmC;EC9y6DnC,kCAAK;EACJ,gBAAc;ADgz6DjB;AACA;EC7y6DG,aAAA;EAEC,mBAAA;EACC,cAAa;EDkz6DhB,kBAAkB;AChz6DhB;ADkz6DJ;EChz6DK,cAAS;EAIT,mBAAU;AD+y6Df;AACA;EAGE,aAAa;ACtz6DV;ADwz6DL;EACE,qBAAqB;ACjz6DlB;ADmz6DL;EACE,eAAe;AACjB;;AC3y6DC;EACC,iBAAU;EACV,yBAAY;ED8y6DZ,gBAAgB;EC7y6DhB,cAAA;AD+y6DF;AACA;EACE,cAAc;EC9y6Db,kBAAA;EACC,iBAAU;EACV,SAAA;ADgz6DJ;AACA;EC9y6DI,qBAAa;ADgz6DjB;AACA;EC9y6DO,gBAAa;ADgz6DpB;AC/y6DI;EACC,cAAc;EDiz6DjB,SAAS;EC9y6DR,UAAA;EACC,cAAc;EDgz6DhB,gBAAgB;EC/y6Dd,mBAAA;EACC,uBAAkB;ADiz6DvB;AACA;EC5y6DG,4BAAA;AD8y6DH;AACA;EC5y6DI,cAAa;AD8y6DjB;;AAEA,WCzy6De;AD0y6Df;EChy6DK,UAAA;EACC,YAAW;ADky6DjB;AACA;EChy6DM,kBAAY;EACZ,oBAAoB;ADky6D1B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAGlB,aAAa;EC7x6DX,iBAAA;EACF,eAAU;EACV,mBAAY;AD+x6Dd;AACA;EC7x6DE,cAAc;AD+x6DhB;AACA;EC9x6DE,sBAAA;ADgy6DF;AACA;EC9x6DG,kBAAM;EDgy6DP,kBAAkB;AC/x6DjB;ADiy6DH;EC/x6DI,iBAAS;EACT,aAAa;EDiy6Df,mBAAmB;AChy6DjB;ADky6DJ;EChy6DK,aAAY;ADky6DjB;AChy6DI;EACC,WAAU;EDky6Db,mBAAmB;EC/x6DlB,YAAA;EACC,YAAW;EACX,oBAAa;EACb,kBAAiB;EACjB,gBAAS;ADiy6Db;;AAEA;EC/x6DI,mBAAY;ADiy6DhB;AChy6DI;EAEC,UAAS;EACT,YAAQ;EACR,aCnzcmB;EDozcnB,sBAAW;EACX,uBAAkB;EAClB,mBAAkB;ADiy6DvB;AACA;EC/x6DK,iBAAM;EACN,mBAAS;EACT,SAAM;ADiy6DX;AC/x6DI;EACC,YAAM;EDiy6DT,kBAAkB;EC/x6DhB,aAAA;ADiy6DJ;AACA;EACE,kBAAkB;EC1x6Df,kBAAA;AD4x6DL;AACA;ECpx6DK,WAAA;ADsx6DL;AACA;ECjx6DE,WAAA;EACC,aAAY;EACZ,uBAAkB;EAClB,kBAAe;EACf,gBAAe;EACf,mBC70cyB;ED80czB,kBAAiB;EACjB,YAAU;ADmx6Db;AACA;EACE,WAAW;EC/w6DX,aAAA;EACA,mBAAkB;EAClB,WAAA;EACA,kBAAY;EDix6DZ,kBAAkB;EChx6DlB,QAAA;EACC,UAAU;EACV,MAAM;EDkx6DP,SAAS;EChx6DT,cAAA;ADkx6DF;AACA;EChx6DG,OAAO;ADkx6DV;AACA;EChx6DG,UAAS;EDkx6DV,uBAAuB;AChx6DvB;ADkx6DF;EChx6DG,aAAa;ADkx6DhB;AACA;EC/w6DG,aAAA;ADix6DH;AACA;EC5w6DG,kBAAA;EACA,mBAAgB;EAChB,gBAAY;ED8w6Db,gBAAgB;EC7w6Df,cAAA;EACC,kBAAW;ED+w6Db,kBAAkB;EC7w6DjB,SAAA;AD+w6DH;;AAEA;EACE,kBAAkB;EC3w6DpB,uBAA0B;EACzB,oBAAA;AD6w6DD;AACA;EACE,kBAAkB;EC3w6DpB,WAAW;AACX;AD6w6DA;EC3w6DC,WAAS;EACT,kBAAU;EACV,UAAS;EACT,yBAAc;EACd,mBAAmB;EACnB,SAAA;AD6w6DD;AACA;EC3w6DC,wBAAW;EACX,mBAAY;EACZ,YAAY;AD6w6Db;AC1w6DG;EACC,mBAAe;AD4w6DnB;ACvw6DK;EDyw6DH,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EI1x3EQ,WAAA;AJ4x3ER;AACA;EC1w6DK,uBAAA;ED4w6DH,qBAAqB;AACvB;;AAEA;ECrw6DM;IACC,qBCz6cqB;EFgr3E1B;ACtw6DK;ADww6DP,UElr3EiB;AFmr3EjB;EC9v6DG,sBAAA;EACC,SAAO;EACP,UAAU;EDgw6DZ,mBAAmB;EACnB,0BAA0B;EC5v6D5B,mBAAgB;EACf,gBAAU;EACV,6BAAqB;EACrB,aAAO;EACP,WAAU;EACV,YAAA;ED8v6DC,mBAAmB;AC7v6DpB;AD+v6DD;EACE,eAAe;AC7v6Dd;AD+v6DH;;;;EClv6DA,sBAAA;ADyv6DA;AACA;;;ECtv6DC,cAAS;AD0v6DV;AACA;ECxv6DC,qBAAY;AD0v6Db;AACA;ECxv6DC,cAAa;AD0v6Dd;AACA;ECxv6DC,WAAA;EACA,eAAY;AD0v6Db;;AAEA;ECzv6DE,kBAAU;EACV,qBCp+c0B;EF+t3E1B,SAAO;EACP,gBAAgB;ECzv6DlB,mBAAA;AD2v6DA;AACA;EACE,UAAU;AACZ;AC1v6DA;EACC,aAAU;AD4v6DX;AACA;EC1v6DC,aAAW;AD4v6DZ;;AC1v6DC;EACC,aAAS;AD6v6DX;;AAEA;EC3v6DE,qBAAkB;EG/mdZ,mBAAoB;EAIpB,WAAA;EAYA,YAAc;EHimdpB,mBAAW;ED+v6DX,eAAe;EACf,iBAAiB;EC7v6DnB,kBAAA;EACC,yBAAkB;EAClB,mBAAS;EACT,kDAAmB;AD+v6DpB;AACA;EC7v6DC,kBCzid8B;EFwy3E7B,UAAU;EC9v6DX,cAAA;ADgw6DD;;AAEA;EC9v6DE,qBAAc;EACd,mBAAa;ADgw6Df;;AAEA;EACE,kBAAkB;EAClB,SAAS;EC9v6DX,OAAA;EACC,WAAS;EACT,kBAAkB;ADgw6DnB;AACA;EACE,qBAAqB;EACrB,WAAW;EC/v6Db,WAAA;EACC,mBAAmB;EDiw6DlB,kBAAkB;EC7v6DlB,2BC7id2B;EF8y3E3B,WAAW;AC/v6DZ;;ADkw6DD;EACE,kBAAkB;EChw6DlB,qBAAA;EACC,mBEt7ckC;EHwr3EnC,eAAe;ECjw6Dd,iBAAA;EACC,cEx7cW;AH2r3Ef;AC5v6DI;EACC,kBCxjdmB;EFsz3EtB,SAAS;ECzv6DR,UAAA;EACC,cAAA;ED2v6DF,aAAa;EACb,WAAW;ECtv6DZ,mBAAA;EACC,WAAA;ADwv6DF;;ACtv6DE;EACC,eCxjdyB;EFiz3E1B,kBAAkB;ECxv6DjB,gBAAA;EACC,mBC1jdwB;AFoz3E5B;;AAEA;EACE,mBAAmB;ACrv6DjB;;ADwv6DJ;ECpv6DG,cAAA;ADsv6DH;AACA;EClv6DG,sBAAA;EACC,qBC5ldoB;AFg13ExB;ACjv6DE;EACC,cChldc;AFm03EjB;AClv6DG;EACC,mBC9ndmB;AFk33EvB;ACjv6DE;EACC,yBAAgB;ADmv6DnB;AACA;EC/u6DC,yBAAA;ADiv6DD;;AAEA;EChv6DE,sBAAA;EACC,qBC/ldyB;AFi13E5B;ACjv6DG;EACC,cCjmda;AFo13EjB;AC7u6DG;EACC,mBChpd2B;AF+33E/B;AC9u6DI;EACC,cAAA;ADgv6DL;AC3u6DG;EACC,yBChndwB;AF613E5B;AACA;ECxu6DC,cAAA;AD0u6DD;AACA;EACE,yBAAyB;ACzu6DzB;AD2u6DF;EACE,mBAAmB;AC1u6DlB;AD4u6DH;EACE,WAAW;ACtu6DV;ADwu6DH;EACE,gBAAgB;ACvu6Dd;;AD0u6DJ;ECtu6DG,sBAAA;EACC,qBCzodwB;AFi33E5B;ACpu6DG;EACC,cAAA;ADsu6DJ;AACA;EChu6DE,mBAAA;ADku6DF;AACA;EACE,cAAc;AC/t6DhB;ADiu6DA;EACE,yBAAyB;AAC3B;AC9t6DE;EACC,yBAAkB;ADgu6DrB;;AC9t6DG;EACC,sBAAe;EDiu6DjB,qBAAqB;AC9t6DnB;ADgu6DJ;EACE,cAAc;AC5t6Dd;AD8t6DF;EACE,mBAAmB;AC5t6DnB;AD8t6DF;EC5t6DG,cAAa;AD8t6DhB;AACA;ECzt6DE,yBAAA;AD2t6DF;AACA;ECzt6DG,cAAS;AD2t6DZ;AC1t6DG;EACC,yBAAM;AD4t6DV;;AAEA;EC1t6DI,mBAAiB;AD4t6DrB;;AAEA;ECtt6DE,mBAAA;ADwt6DF;;AAEA;ECnt6DE,kBAAA;EACC,mBAAc;ADqt6DjB;ACpt6DG;EACC,eAAe;ADst6DnB;AACA;ECjt6DC,gBAAA;ADmt6DD;AACA;ECjt6DE,aAAQ;ADmt6DV;AACA;ECjt6DE,gBAAY;EACZ,mBAAe;ADmt6DjB;;AAEA;ECjt6DE,YAAW;EACX,eAAa;EDmt6Db,SAAS;AClt6DT;ADot6DF;EACE,MAAM;ECjt6DP,UAAA;EACC,WAAW;EDmt6DX,YAAY;ECjt6Db,iBAAA;EACC,iBAAQ;ADmt6DV;;AAEA;ECht6DG,cAAQ;ADkt6DX;;AAEA;ECht6DG,oBAAgB;ADkt6DnB;ACjt6DG;EACC,eAAW;ADmt6Df;;AAEA;EACE,WAAW;EC/s6Db,YAAA;EACC,mBAAa;EACb,kBAAgB;EDit6Df,iBAAiB;ECht6DlB,kBAAA;EACC,qBAAc;ADkt6DhB;AACA;ECht6DE,qBAAiB;EDkt6DjB,mBAAmB;ECjt6DnB,iBAAA;ADmt6DF;AACA;EACE,SAAS;ACjt6DT;ADmt6DF;ECjt6DG,mBAAgB;ADmt6DnB;AACA;ECjt6DE,QAAA;ADmt6DF;AACA;ECjt6DE,cAAA;EACC,eAAc;EDmt6Df,oBAAoB;ECht6DnB,eAAA;EACC,SAAQ;EACR,gBAAM;ADkt6DV;AACA;ECht6DI,iBAAY;EACZ,iBAAS;EDkt6DX,eAAe;ACjt6Db;;ADot6DJ;EACE,aAAa;EC9s6DV,sBAAA;ADgt6DL;AACA;ECzs6DI,cAAA;EACC,cAAc;ED2s6DjB,eAAe;EACf,iBAAiB;ACps6DjB;ADss6DF;ECps6DG,WAAM;EACN,kBAAU;ADss6Db;AACA;ECps6DE,cAAA;EACC,gBAAa;EDss6Dd,gBAAgB;AAClB;ACls6DC;EACC,iBAAiB;ADos6DnB;ACls6DC;EACC,sBAAqB;ADos6DvB;AACA;ECls6DC,kBAAA;EACC,MAAA;EACA,UAAO;EACP,UAAU;EACV,YAAY;EDos6DZ,2BAA2B;ACls6D5B;ADos6DD;ECls6DE,UAAA;EDos6DA,YAAY;ACls6Db;ADos6DD;ECls6DE,aAAY;ADos6Dd;ACns6DE;EACC,cAAa;ADqs6DhB;;AAEA;ECls6DE,kBAAkB;EAClB,MAAA;EACA,UAAA;EDos6DA,2BAA2B;AAC7B;AChs6DE;EACC,iBAAa;ADks6DhB;;AC7r6DC;EACC,iBAAa;ADgs6Df;AC9r6DC;EACC,qBAAQ;EACR,sBAAW;ADgs6Db;AACA;EACE,cAAc;EC/r6Dd,YAAA;EACC,iBAAO;EACP,kBAAW;ADis6Dd;AACA;EC5r6DG,qBAAA;EACC,qBAAS;AD8r6Db;AC1r6DC;EACC,gBAAU;EACV,eAAW;AD4r6Db;AACA;EC1r6DE,aAAa;AD4r6Df;AACA;EACE,cAAc;EC3r6Dd,kBAAA;EACC,cAAU;EACV,mBAAW;AD6r6Dd;;AAEA;EC3r6DG,qBAAmB;AD6r6DtB;;AAEA;EC5r6DI,mBAAU;AD8r6Dd;AACA;EC5r6DI,QAAQ;EACR,WAAW;ED8r6Db,sBAAsB;EC1r6DvB,UAAA;AD4r6DD;AACA;ECzr6DE,wBAAA;EACC,WAAU;EACV,mBAAS;AD2r6DZ;AACA;ECzr6DG,SAAA;AD2r6DH;AACA;ECvr6DI,UAAA;EACC,WAAO;EDyr6DV,oBAAoB;EACpB,gBAAgB;ECnr6DjB,gBAAA;EACC,eAAa;EDqr6Db,SAAS;ACnr6DV;ADqr6DD;ECnr6DE,kBAAW;EACX,WAAQ;EACR,WAAU;EDqr6DV,YAAY;ECpr6DZ,sBAAA;EACC,mBAAO;ADsr6DV;AACA;EACE,kBAAkB;ECjr6DjB,UAAA;EACC,WAAS;EDmr6DX,WAAW;EC/q6DZ,YAAA;EACC,WAAU;ADir6DZ;AACA;EC/q6DE,YAAA;ADir6DF;AACA;EC/q6DE,kBAAS;EDir6DT,SAAS;EChr6DT,WAAA;EACC,YAAU;EACV,iBAAW;EACX,eAAW;ADkr6Dd;AACA;EACE,OAAO;ACjr6DN;;ADor6DH;ECjr6DI,mBAAW;ADmr6Df;AACA;ECjr6DI,QAAO;EDmr6DT,WAAW;EC/q6DZ,sBAAA;EACC,UAAO;ADir6DT;AC9q6DE;EACC,wBAAkB;EAClB,WAAS;EACT,mBAAW;ADgr6Dd;AACA;EC9q6DG,SAAA;ADgr6DH;AC5q6DI;EACC,UAAO;ED8q6DV,WAAW;EACX,oBAAoB;ECxq6DrB,gBAAA;EACC,gBAAY;EACZ,eAAc;EACd,SAAA;AD0q6DF;ACtq6DG;EACC,kBAAU;EACV,WAAU;EACV,WAAS;EACT,YAAS;EDwq6DX,sBAAsB;ACpq6DrB;ADsq6DH;EACE,kBAAkB;EClq6DnB,UAAA;EACC,WAAO;EDoq6DP,WAAW;EC/p6DT,YAAA;EACC,WAAS;ADiq6Dd;AACA;EACE,YAAY;AC3p6Dd;AAGE;EACC,kBAAc;EACd,SAAA;ED2p6DD,WAAW;ECxp6DV,YAAA;EACC,iBAAS;EACT,eAAO;AD0p6DX;AACA;ECvp6DI,OAAA;ADyp6DJ;;AAEA;ECpp6DG,kBAAA;EACC,cAAW;EDsp6Db,eAAe;ACrp6Db;ADup6DJ;ECrp6DK,UAAA;EACA,UAAA;EDup6DH,SAAS;ECpp6DN,0BAAA;ADsp6DL;AACA;ECpp6DM,OAAA;ADsp6DN;AACA;ECpp6DK,cAAA;ADsp6DL;AACA;EACE,SAAS;ECnp6DP,UAAA;ADqp6DJ;;AAEA,gBAAgB;AAChB;EC/o6DC,eAAA;EACC,+BAAoB;ADip6DtB;AC9o6DE;EACC,uBAAc;EACd,kBAAY;EDgp6Db,gCAAgC;AC9o6DhC;ADgp6DF;EACE,mBAAmB;EC9o6DnB,WAAA;ADgp6DF;AACA;EC9o6DI,kBAAA;ADgp6DJ;AACA;EC9o6DK,qBAAiB;EACjB,mBAAe;EACf,iBCtleY;AFsu4EjB;AACA;EC9o6DK,qBAAU;EDgp6Db,mBAAmB;EC3o6DlB,mBAAA;EACC,mBAAiB;AD6o6DrB;AC5o6DI;EACC,iBAAS;EACT,gBAAgB;AD8o6DrB;AACA;EC3o6DK,kBAAA;EACC,SAAS;AD6o6Df;;AAEA;EACE,qBAAqB;AC3o6DlB;AD6o6DL;EC3o6DM,eAAa;ED6o6DjB,+BAA+B;AC1o6D7B;AD4o6DJ;EC1o6DK,mCAAS;AD4o6Dd;AACA;ECvo6DA,kBAAoB;ADyo6DpB;AACA;ECxo6DC,uBAAA;EACC,UAAA;ED0o6DA,kBAAkB;ECvo6DlB,gCAAE;EACD,mBAAc;EACd,WAAW;EDyo6DZ,UAAU;ECxo6DT,WAAA;AD0o6DH;AACA;EACE,kBAAkB;ACro6DhB;ADuo6DJ;ECro6DK,qBAAmB;EACnB,mBAAiB;EDuo6DpB,iBAAiB;ACpo6Dd;ADso6DL;ECpo6DM,qBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EDso6DvB,mBAAmB;ACpo6DhB;ADso6DL;ECpo6DM,iBAAgB;EDso6DpB,gBAAgB;ACno6Dd;ADqo6DJ;ECno6DK,kBAAgB;EAChB,SAAA;ADqo6DL;;AC9n6DA;EAGE,kBAAA;AD+n6DF;AACA;EC5n6DC,qBAAQ;AD8n6DT;AACA;EC5n6DE,eAAQ;EACR,+BAA4B;AD8n6D9B;AACA;EC3n6DE,kBAAA;EACC,iBAAO;AD6n6DV;AACA;EC1n6DA,qBAAA;EACC,mBAAgB;EAChB,iBAAiB;AD4n6DlB;AACA;EC1n6DC,qBAAA;EACC,mBAAgB;EAChB,mBAAgB;EAChB,mBAAM;AD4n6DR;AACA;EACE,iBAAiB;EC1n6DlB,gBAAA;AD4n6DD;AACA;EACE,qBAAqB;EC1n6DvB,mBAAA;EACC,qBAAgB;AD4n6DjB;;AAEA,WAAW;AACX;ECxn6DG,aAAA;AD0n6DH;AACA;EACE,gBAAgB;ECtn6DlB,+DAAe;EACd,uBC5ue4B;ED6ue5B,4BAAW;EACX,iBAAc;ADwn6Df;AACA;EACE,oBAAoB;ACvn6DrB;;AD0n6DD;EACE,gBAAgB;ECvn6DjB,iBAAA;ADyn6DD;;AAEA;EACE,gBAAgB;ECxn6DhB,4BAAA;EACC,+DAAkB;EAClB,uBAAe;EACf,kBAAe;AD0n6DlB;ACxn6DE;EACC,aClxeiB;AF444EpB;;AAEA;ECxn6DG,gBAAc;EACd,iBAAe;EACf,iBAAA;AD0n6DH;;AAEA;EACE,kBAAkB;ACvn6DnB;;AD0n6DD;EACE,cAAc;ECrn6Db,YAAA;EACC,qBAAS;EDun6DX,cAAc;ECln6Dd,8CAAA;ADon6DF;AACA;EACE,cAAc;ECnn6Db,qBAAA;ADqn6DH;AACA;ECnn6DG,cAAA;EACC,qBAAiB;EDqn6DnB,gBAAgB;ACjn6DjB;ADmn6DD;ECjn6DE,kBAAc;EACd,yBAAoB;EACpB,gBAAS;ADmn6DX;ACln6DE;EACC,mBAAmB;EACnB,WAAA;EACA,kBAAW;EACX,mBAAkB;EAClB,oBAAO;EDon6DR,oBAAoB;ECnn6DnB,8BAAA;EACC,+BAAQ;EDqn6DV,kBAAkB;ECln6DlB,qBAAA;ADon6DF;AACA;EACE,yBAAyB;ECln6DzB,gBAAA;ADon6DF;AACA;EACE,UAAU;ACln6DV;ADon6DF;ECln6DG,kBAAiB;EDon6DlB,qBAAqB;ACjn6DtB;ADmn6DD;EACE,UAAU;ACln6DV;ADon6DF;EACE,kBAAkB;ACpn6DjB;ADsn6DH;EACE,cAAc;ECnn6Db,eAAA;EACC,qBAAM;EACN,sBAAmB;ADqn6DvB;ACnn6DG;EACC,mBAAK;EDqn6DP,qBAAqB;ECjn6DtB,WAAA;EACC,kBCl2ekB;EDm2elB,QAAA;ADmn6DF;AACA;ECln6DE,SAAA;ADon6DF;AACA;ECnn6DG,yBCp1e0B;EFy84E3B,WAAW;ACnn6DX;ADqn6DF;EACE,yBAAyB;ECpn6DxB,cAAA;ADsn6DH;AACA;EACE,cAAc;ECpn6Db,6BAAA;ADsn6DH;AACA;ECpn6DG,kBAAA;ADsn6DH;AACA;ECnn6DE,MAAA;ADqn6DF;AACA;EACE,wBAAwB;ACln6D1B;ADon6DA;ECln6DC,sBAAmB;EACnB,qBAAkB;ADon6DnB;AACA;ECln6DC,qBAAA;ADon6DD;AACA;ECln6DC,mBAAA;EACC,qBAAoB;EDon6DpB,WAAW;AACb;ACln6DA;;;EAIE,cAAA;ADmn6DF;AACA;EACE,cAAc;AChn6Df;ADkn6DD;EChn6DE,yBAAU;EDkn6DV,WAAW;AACb;AC9m6DE;EACC,WAAO;ADgn6DV;AACA;EACE,cAAc;AC7m6DhB;AD+m6DA;EC7m6DI,qBAAqB;AD+m6DzB;;AAEA;EC9m6DA,kBAAA;EDgn6DE,wBAAwB;EACxB,WAAW;EC/m6DT,+BAAoB;ADin6DxB;;AAEA;EChn6DA,qBAAU;EACV,oBAAQ;EACJ,mBAAkB;ADkn6DtB;;AAEA;EChn6DC,cAAc;ADkn6Df;AACA;ECjn6DC,oBAAA;ADmn6DD;;AAEA;EChn6DE,yBAAoB;EDon6DpB,+BAA+B;ACjn6DhC;;ADon6DD;ECjn6DE,YAAS;EACT,WAAA;ADmn6DF;;AAEA;ECjn6DE,YAAA;EACA,WAAU;ADmn6DZ;;AC/m6DE;;EAEC,qBAAkB;EDkn6DnB,oBAAoB;AC9m6DpB;;ADin6DF;;;EC3m6DE,oBAAW;EACX,mBAAY;AD+m6Dd;;AAEA,SC/m6DG;ADgn6DH;EC7m6DC,kBAAa;EACZ,qBAAW;EACX,WAAQ;ED+m6DR,YAAY;EC9m6DZ,sBAAA;EACC,6BAAe;ADgn6DlB;AC7m6DC;;EAEC,WAAQ;ED+m6DR,YAAY;EC9m6DZ,qBAAA;EDin6DA,iBAAiB;AC7m6DlB;AD+m6DD;EC5m6DE,aAAA;EAID,mBAAY;EACX,uBAAW;EACX,+BAAY;ED+m6DZ,iBAAiB;EC9m6DjB,gBAAA;ADgn6DF;AACA;;EC5m6DE,kBAAW;AD+m6Db;AACA;;EC7m6DG,gBAAe;ADgn6DlB;AC7m6DC;EACC,WAAW;EACX,YAAY;AD+m6Dd;AC9m6DE;EACC,kBAAkB;ADgn6DrB;AC7m6DC;EACC,WAAO;EACP,YAAQ;AD+m6DV;AC9m6DE;EACC,eAAW;ADgn6Dd;AC5m6DE;EACC,WAAW;EACX,YAAW;AD8m6Dd;AC3m6DG;EACC,kBAAkB;AD6m6DtB;ACzm6DG;EACC,WAAW;ED2m6Db,YAAY;ACvm6DX;ADym6DH;EACE,iBAAiB;ACrm6DhB;ADum6DH;EACE,WAAW;ECnm6DV,YAAA;ADqm6DH;AACA;ECjm6DG,kBAAA;ADmm6DH;AACA;EC/l6DG,WAAA;EACC,YAAW;ADim6Df;AC7l6DG;EACC,eAAe;AD+l6DnB;AC1l6DE;EACC,WAAU;ED4l6DX,YAAY;AC3l6DX;AD6l6DH;EACE,kBAAkB;ACxl6DlB;AD0l6DF;ECxl6DG,aCrkfoB;EF+p5ErB,cAAc;ACtl6Dd;ADwl6DF;ECtl6DG,iBC3kfoB;AFmq5EvB;ACpl6DE;EACC,iBAAgB;EAChB,oBCjlfoB;AFuq5EvB;ACll6DE;EACC,kBAAkB;ADol6DrB;AACA;EChl6DE,iBAAA;ADkl6DF;AACA;EACE,kBAAkB;AC9k6DlB;ADgl6DF;EC9k6DG,eCnmfoB;AFmr5EvB;AC5k6DE;EACC,kBAAkB;AD8k6DrB;AACA;EC1k6DE,kBAAA;AD4k6DF;AACA;EACE,kBAAkB;ACxk6DlB;AD0k6DF;ECxk6DG,eCrnfoB;AF+r5EvB;ACtk6DE;EACC,mBAAkB;ADwk6DrB;AACA;ECpk6DE,WAAA;ADsk6DF;AACA;EACE,oCAAoC;EClk6DpC,WAAA;ADok6DF;AACA;EACE,oCAAoC;EChk6DpC,WAAA;ADkk6DF;AACA;EACE,oCAAoC;EC9j6DpC,WAAA;ADgk6DF;AACA;EACE,oCAAoC;EC5j6DpC,WAAA;AD8j6DF;AACA;EACE,oCAAoC;EC1j6DpC,WAAA;AD4j6DF;AACA;EACE,oCAAoC;ECxj6DpC,WAAA;AD0j6DF;AACA;EACE,oCAAoC;ECtj6DpC,WAAA;ADwj6DF;AACA;EACE,oCAAoC;ECpj6DpC,WAAA;ADsj6DF;AACA;EACE,oCAAoC;EClj6DpC,WAAA;ADoj6DF;AACA;EACE,oCAAoC;EChj6DpC,WAAA;ADkj6DF;AACA;EACE,oCAAoC;EC9i6DpC,WAAA;ADgj6DF;AACA;EACE,oCAAoC;EC5i6DpC,WAAA;AD8i6DF;AACA;EACE,oCAAoC;EC1i6DpC,WAAA;AD4i6DF;AACA;EACE,oCAAoC;ECxi6DpC,WAAA;AD0i6DF;AACA;EACE,oCAAoC;ECti6DpC,WAAA;ADwi6DF;AACA;EACE,oCAAoC;ECpi6DpC,WAAA;ADsi6DF;AACA;EACE,oCAAoC;ECli6DpC,WAAA;ADoi6DF;AACA;EACE,oCAAoC;EChi6DpC,WAAA;ADki6DF;AACA;EACE,oCAAoC;EC9h6DpC,cAAA;ADgi6DF;AACA;EACE,oCAAoC;EC5h6DpC,WAAA;AD8h6DF;AACA;EACE,oCAAoC;EC1h6DpC,WAAA;AD4h6DF;AACA;EACE,oCAAoC;ECxh6DpC,WAAA;AD0h6DF;AACA;EACE,oCAAoC;ECth6DpC,WAAA;ADwh6DF;AACA;EACE,oCAAoC;ECph6DpC,WAAA;ADsh6DF;AACA;EACE,oCAAoC;EClh6DpC,cAAA;ADoh6DF;AACA;EACE,oCAAoC;EChh6DpC,WAAA;ADkh6DF;AACA;EACE,oCAAoC;EC9g6DpC,WAAA;ADgh6DF;AACA;EACE,oCAAoC;EC5g6DpC,cAAA;AD8g6DF;AACA;EACE,oCAAoC;EC1g6DpC,cAAA;AD4g6DF;AACA;EACE,oCAAoC;ECxg6DpC,cAAA;AD0g6DF;AACA;EACE,oCAAoC;ECtg6DpC,cAAA;ADwg6DF;AACA;EACE,oCAAoC;ECpg6DpC,cAAA;ADsg6DF;AACA;EACE,oCAAoC;EClg6DpC,cAAA;ADog6DF;AACA;EACE,oCAAoC;EChg6DpC,cAAA;ADkg6DF;AACA;EACE,oCAAoC;EC9/5DpC,cAAA;ADgg6DF;AACA;EACE,oCAAoC;EC5/5DpC,cAAA;AD8/5DF;AACA;EACE,oCAAoC;EC1/5DpC,cAAA;AD4/5DF;AACA;EACE,oCAAoC;ECx/5DpC,cAAA;AD0/5DF;AACA;EACE,oCAAoC;ECt/5DpC,cAAA;ADw/5DF;AACA;EACE,oCAAoC;ECp/5DpC,cAAA;ADs/5DF;AACA;EACE,oCAAoC;ECl/5DpC,cAAA;ADo/5DF;AACA;EACE,oCAAoC;ECh/5DpC,cAAA;ADk/5DF;AACA;EACE,oCAAoC;EC9+5DpC,cAAA;ADg/5DF;AACA;EACE,oCAAoC;EACpC,cAAc;AC7+5DhB;AD++5DA;EC7+5DC,oCAA2B;EAC3B,cAAS;AD++5DV;AC9+5DC;EACC,oCAAe;EACf,cAAQ;ADg/5DV;AC/+5DE;EDi/5DA,oCCh/5De;EACd,cAAO;ADi/5DV;AACA;EC7+5DE,oCAAA;EACC,cAAc;AD++5DjB;AC9+5DG;EACC,oCAAS;EDg/5DX,cAAc;AC3+5Dd;AD6+5DF;EC3+5DG,oCAAe;ED6+5DhB,cAAc;AC5+5Db;AD8+5DH;EACE,oCAAoC;EC3+5DpC,cAAA;AD6+5DF;AACA;ECz+5DE,oCAAQ;EACP,cAAW;AD2+5Dd;AACA;EC1+5DG,oCAAA;EACC,cAAW;AD4+5Df;ACz+5DE;EACC,oCAAuB;ED2+5DxB,cAAc;AAChB;;ACv+5DA;EAGC,oBAAa;AD0+5Dd;AACA;ECx+5DC,eAAa;ED0+5DZ,gBAAgB;AAClB;ACz+5DA;;EAEC,sBCp6foC;EDq6fpC,gBAAe;AD2+5DhB;AACA;ECz+5DC,sBAAoB;AD2+5DrB;AACA;ECz+5DC,UAAA;AD2+5DD;AACA;ECz+5DC,cAAA;ED2+5DC,eAAe;AC1+5DhB;AD4+5DD;EC1+5DE,iBAAgB;AD4+5DlB;AACA;EACE,mBAAmB;AACrB;ACv+5DG;EACC,WAAU;EACV,YAAY;ADy+5DhB;AACA;ECr+5DG,gBAAA;ADu+5DH;AACA;ECp+5DE,uBAAA;ADs+5DF;;AAEA,aAAa;ACp+5DX;EDw+5DA,aAAa;EC/95DX,mBAAS;ADm+5Db;;AAEA;ECh+5DG,cAAa;EDk+5Dd,qBAAqB;EC/95DpB,eAAA;EACC,gBAAc;EDm+5DhB,aAAa;ECx95DX,mBAAA;EACC,uBCv+f4B;EDw+f5B,+BCx+f4B;AFo85EjC;ACz95DK;EACC,cAAA;ED295DJ,gBAAgB;ECp95Dd,yBAAA;EACC,qBAAa;ADs95DlB;;AAEA;ECh95DG,mBAAe;EACf,qBAAc;EDk95Df,WAAW;AACb;AC985DA;EACA,cAAO;ADg95DP;AACA;EC985DC,8BAAsB;EACtB,iCAAc;ADg95Df;AACA;EC985DC,+BAAsB;EACtB,kCAAqB;ADg95DtB;AACA;EACE,mBAAmB;EC/85DpB,SAAA;ADi95DD;AACA;EC/85DE,oBAAkB;EAClB,qBAAO;ADi95DT;AACA;EC/85DE,oBAAkB;ADi95DpB;ACh95DE;;EDm95DA,oBAAoB;ACh95DpB;ADk95DF;ECh95DG,mBAAW;EDk95DZ,qBAAqB;ACh95DrB;ADk95DF;ECh95DG,yBAAY;ADk95Df;ACh95DE;EACC,yBAAW;ADk95Dd;AACA;ECh95DE,oBAAA;EACC,gBAAU;EACV,eAAW;ADk95Dd;;AC/85DE,QAAA;ADk95DF;ECh95DG,gBAAW;EACX,qBAAW;EDk95DZ,sBAAsB;ECh95DtB,cAAA;EACC,eAAG;EDk95DJ,qBCj95Da;EDk95Db,sBCj95Da;EDk95Db,qBAAqB;ECh95DpB,kBAAG;EDk95DJ,0BCj95DuB;ADk95DzB;AACA;EACE,WAAW;EC/85DX,YAAA;EACC,kBAAG;EDi95DJ,sBCh95Da;EDi95Db,kBCh95Da;EDi95Db,UAAU;EC/85DT,kBAAG;ADi95DN;AACA;EACE,qBAAqB;AACvB;AC/85DE;EACC,UAAU;EDi95DX,WAAW;ACh95DV;ADk95DH;ECh95DI,WAAM;EACN,YAAO;ADk95DX;AACA;ECh95DI,WAAQ;EACR,YAAA;ADk95DJ;AACA;ECh95DI,UAAS;EDk95DX,WAAW;EC985DZ,YAAM;ADg95DP;AACA;EACE,UAAU;EC/85DV,WAAA;EACC,YAAQ;ADi95DX;AAWA;EACE;IC985DC,qBAAA;IACC,YAAU;EDg95DZ;EC985DC;IACC,qBAAiB;IDg95DjB,UAAU;EC385Db;AD685DD;AACA;EACE,kBAAkB;AC585DlB;AD885DF;EACE,kBAAkB;EC385DnB,MAAA;EACC,OAAA;EACA,WCppgBqB;EFim6ErB,YAAY;EC585DZ,iBAAA;EACC,kBC1mgBc;ED6mgBhB,2CAAY;EACX,WAAU;AD685DZ;AACA;EC585DE,aAAA;EACC,mBEjwgBE;AH+s6EL;AC385DC;EACC,aCrngBe;EDsngBf,mBClqgBqB;EF+m6ErB,oBAAoB;AC585DpB;AD885DF;EACE,aAAa;EC385Dd,cAAA;EACC,oBC5ngB0B;AFyk6E5B;AACA;EC585DE,cAAA;EACC,qBC/ngByB;EF6k6E1B,eAAe;AC385DhB;AD685DD;EC385DE,kBChrgBqB;AF6n6EvB;AC585DE;EACC,kBCtogBc;AFol6EjB;AC385DC;EACC,mBC1ogB0B;ED2ogB1B,WCvrgBqB;AFoo6EvB;AC585DE;EACC,qBC7ogByB;AF2l6E5B;AC385DC;EACC,mBCjpgB0B;EDkpgB1B,WC9rgBqB;AF2o6EvB;AC585DE;EACC,qBCppgByB;AFkm6E5B;AC385DC;EACC,mBCxpgB0B;EDypgB1B,WCrsgBqB;AFkp6EvB;AC585DE;EACC,qBC3pgByB;AFym6E5B;AC385DC;EACC,mBEpzgBW;EFqzgBX,WC5sgBqB;AFyp6EvB;AC585DE;EACC,qBEvzgBU;AHqw6Eb;AC385DC;EACC,mBE1zgBa;EF2zgBb,WCntgBqB;AFgq6EvB;AC585DE;EACC,qBE7zgBY;AH2w6Ef;AC385DC;EACC,mBEh0gBa;EFi0gBb,WC1tgBqB;AFuq6EvB;AC585DE;EACC,qBEn0gBY;AHix6Ef;AC385DC;EACC,mBEt0gBa;EFu0gBb,WCjugBqB;AF8q6EvB;AC585DE;EACC,qBEz0gBY;AHux6Ef;AC385DC;EACC,mBE50gBW;EF60gBX,WCxugBqB;AFqr6EvB;AC585DE;EACC,qBE/0gBU;AH6x6Eb;AC385DC;EACC,mBClsgB0B;EDmsgB1B,WC/ugBqB;AF4r6EvB;AC585DE;EACC,qBCrsgByB;AFmp6E5B;AC385DC;EACC,mBCzsgB0B;ED0sgB1B,WCtvgBqB;AFms6EvB;AC585DE;EACC,qBC5sgByB;AF0p6E5B;AC385DC;EACC,mBE71gBW;EF81gBX,WC7vgBqB;AF0s6EvB;AC585DE;EACC,qBEh2gBU;AH8y6Eb;AC385DC;EACC,mBEn2gBW;EFo2gBX,WCpwgBqB;AFit6EvB;AC585DE;EACC,qBEt2gBU;AHoz6Eb;AC385DC;EACC,mBEz2gBU;EF02gBV,WCvwgBkB;AFot6EpB;AC585DE;EACC,qBE52gBS;AH0z6EZ;AC385DC;EACC,mBE92gBa;EF+2gBb,WClxgBqB;AF+t6EvB;AC585DE;EACC,qBEj3gBY;AH+z6Ef;AC385DC;EACC,mBEp3gBc;EFq3gBd,WCzxgBqB;AFsu6EvB;AC585DE;EACC,qBEv3gBa;AHq06EhB;AC385DC;EACC,mBEx3gBY;EFy3gBZ,WChygBqB;AF6u6EvB;AC585DE;EACC,qBE33gBW;AHy06Ed;AC385DC;EACC,mBEj4gBY;EFk4gBZ,WCvygBqB;AFov6EvB;AC585DE;EACC,qBEp4gBW;AHk16Ed;AC385DC;EACC,mBEv4gBW;EFw4gBX,WC9ygBqB;AF2v6EvB;AC585DE;EACC,qBE14gBU;AHw16Eb;AC385DC;EACC,mBE54gBW;EF64gBX,cCrzgBqB;AFkw6EvB;AC585DE;EACC,qBE/4gBU;AH616Eb;AC385DC;EACC,mBCpygB2B;EDqygB3B,WC5zgBqB;AFyw6EvB;AC585DE;EACC,qBCvygB0B;AFqv6E7B;AC385DC;EACC,mBCzygBiC;ED0ygBjC,WC/zgBkB;AF4w6EpB;AC585DE;EACC,qBC5ygBgC;AF0v6EnC;AC385DC;EACC,mBCr0gB6B;EDs0gB7B,WC10gBqB;AFux6EvB;AC585DE;EACC,qBCx0gB4B;AFsx6E/B;AC385DC;EACC,mBAAW;EACX,WAAO;AD685DT;AC585DE;EACC,qBCvygByB;AFqv6E5B;AACA;EC585DE,mBAAA;EACC,WAAA;AD885DH;AACA;EC585DE,qBAAA;AD885DF;AACA;EACE,mBAAmB;EC585DnB,WAAA;AD885DF;AACA;EACE,qBAAqB;AC585DrB;AD885DF;EC585DG,mBE1pgBuC;EHwm6ExC,WAAW;AC585DX;AD885DF;EC585DG,qBEt7gB+B;AHo46ElC;AC585DE;EACC,mBC/zgBc;EDg0gBd,cEvpgBqC;AHqm6ExC;AC585DE;EACC,qBCn0gByB;AFix6E5B;AACA;EC585DE,mBAAA;EACC,WAAA;AD885DH;AACA;EC585DE,qBAAA;AD885DF;AACA;EACE,uBAAuB;EC585DvB,iBAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EACE,qBAAqB;EC385DtB,cAAA;AD685DD;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EC385DC,qBAAkB;EACjB,cEnxgBa;AHgu6Ef;AACA;EC585DE,qBAAA;EACC,cEtxgBY;AHou6Ef;AC385DC;EACC,qBEj9gBiC;EFk9gBjC,cEvjhBU;AHog7EZ;AC585DE;EACC,qBEp9gBgC;EHk66EjC,cAAc;AC385Df;AD685DD;EC385DE,qBE3hhBoC;EHw+6EpC,cAAc;AC585Dd;AD885DF;EACE,qBAAqB;EC385DtB,cAAA;AD685DD;AACA;EACE,qBAAqB;EC585DrB,cAAA;AD885DF;AACA;EC385DC,qBAAiB;EAChB,cE1jhBY;AHug7Ed;AACA;EC585DE,qBAAA;EACC,cE7jhBW;AH2g7Ed;AC385DC;EACC,mBE9xgBuC;EF+xgBvC,cE1xgBsC;AHuu6ExC;AC585DE;EACC,qBEjygBsC;AH+u6EzC;AC385DC;EACC,mBE56gBuC;EF66gBvC,cEv6gBsC;AHo36ExC;AC585DE;EACC,qBE/6gBsC;AH636EzC;AC385DC;EACC,mBEhygByC;EFiygBzC,cE3xgBwC;AHwu6E1C;AC585DE;EACC,qBEnygBwC;AHiv6E3C;AC385DC;EACC,mBE9jhBmC;EF+jhBnC,cE7mhBW;AH0j7Eb;AC585DE;EACC,qBEjkhBkC;AH+g7ErC;AC385DC;EACC,mBEzjhBuC;EF0jhBvC,cEnnhBa;AHgk7Ef;AC585DE;EACC,qBE5jhBsC;AH0g7EzC;AC385DC;EACC,mBEpjhBuC;EFqjhBvC,cEznhBa;AHsk7Ef;AC585DE;EACC,qBEvjhBsC;AHqg7EzC;AC385DC;EACC,mBE/ihBuC;EFgjhBvC,cE/nhBa;AH4k7Ef;AC585DE;EACC,qBEljhBsC;AHgg7EzC;AC385DC;EACC,mBE1ihBmC;EF2ihBnC,cErohBW;AHkl7Eb;AC585DE;EACC,qBE7ihBkC;AH2/6ErC;AC385DC;EACC,mBE13gByC;EF23gBzC,cC3/gB0B;AFw86E5B;AC585DE;EACC,qBE73gBwC;AH206E3C;AC385DC;EACC,mBEphhBmC;EFqhhBnC,cClghB0B;AF+86E5B;AC585DE;EACC,qBEvhhBkC;AHq+6ErC;AC385DC;EACC,mBE/ghBmC;EFghhBnC,cEtphBW;AHmm7Eb;AC585DE;EACC,qBElhhBkC;AHg+6ErC;AC385DC;EACC,mBE1ghBmC;EF2ghBnC,cE5phBW;AHym7Eb;AC585DE;EACC,qBE7ghBkC;AH296ErC;AC385DC;EACC,mBErghBiC;EFsghBjC,cElqhBU;AH+m7EZ;AC585DE;EACC,qBExghBgC;AHs96EnC;AC385DC;EACC,mBEp/gBuC;EFq/gBvC,cEvqhBa;AHon7Ef;AC585DE;EACC,qBEv/gBsC;AHq86EzC;AC385DC;EACC,mBE/+gByC;EFg/gBzC,cE7qhBc;AH0n7EhB;AC585DE;EACC,qBEl/gBwC;AHg86E3C;AC385DC;EACC,mBEl9gBqC;EFm9gBrC,cEjrhBY;AH8n7Ed;AC585DE;EACC,qBEr9gBoC;AHm66EvC;AC385DC;EACC,mBEj/gBqC;EFk/gBrC,cE1rhBY;AHuo7Ed;AC585DE;EACC,qBEp/gBoC;AHk86EvC;AC385DC;EACC,mBE5+gBmC;EF6+gBnC,cEhshBW;AH6o7Eb;AC585DE;EACC,qBE/+gBkC;AH676ErC;AC385DC;EACC,mBCjlhB+B;EDklhB/B,cErshBW;AHkp7Eb;AC585DE;EACC,qBCplhB8B;AFki7EjC;AC385DC;EACC,mBE34gB6C;EF44gB7C,cC7lhB2B;AF0i7E7B;AC585DE;EACC,qBE94gB4C;AH416E/C;AC385DC;EACC,mBC/lhB+B;EDgmhB/B,cCpmhB2B;AFij7E7B;AC585DE;EACC,qBClmhB8B;AFgj7EjC;AC385DC;EACC,mBCrmhBmC;EDsmhBnC,cC9nhB6B;AF2k7E/B;AC585DE;EACC,qBCxmhBkC;AFsj7ErC;AC385DC;EACC,mBAAc;ED685Dd,cAAc;AAChB;AC185DC;EGzthBO,qBAAsB;AJsq7E9B;AACA;EACE,mBAAmB;EC785DnB,cAAA;AD+85DF;AACA;EInq7EQ,qBAAkB;AJqq7E1B;AACA;EE9r7EG,mBAAY;EFgs7Eb,cAAc;AC/85Dd;ADi95DF;EACE,qBAAqB;AC785DrB;AD+85DF;EC785DG,mBC3phBoB;EA7FpB,cAAY;AFws7Ef;AC385DE;EACC,qBCrnhByB;AFkk7E5B;AACA;EACE,mBAAmB;ECz85DnB,cAAA;AD285DF;AACA;EEht7EG,qBAAY;AFkt7Ef;ACv85DE;EACC,mBCnohByB;EDoohBzB,cChrhBoB;AFyn7EvB;AACA;ECr85DE,qBAAA;ADu85DF;AACA;EE1t7EG,oBAAY;AF4t7Ef;;AAEA;EAGE,0BAA0B;ACj85D1B;ADm85DF;EC375DG,2BC/phByB;EDgqhBzB,+DC5shBoB;AF6o7EvB;AACA;EC775DE,gEAAgB;AD+75DlB;AACA;EE9u7EG,mBAAY;EFgv7Eb,WAAW;EC375DX,iEAAgB;AD675DlB;AACA;EEnv7EG,mBAAY;EFqv7Eb,WAAW;ECz75DX,iEAAgB;AD275DlB;AACA;EExv7EG,mBAAY;EF0v7Eb,WAAW;ECv75DX,iEAAgB;ADy75DlB;AACA;EE7v7EG,mBAAY;EF+v7Eb,WAAW;ECr75DX,gEAAgB;ADu75DlB;AACA;ECn75DE,mBAAA;EC/0hBC,WAAU;EFqw7EX,gEAAgE;ACj75DhE;ADm75DF;EACE,mBAAmB;EC/65DnB,WAAA;ECz1hBC,gEAA6D;AF2w7EhE;AC765DE;EC91hBC,mBAAY;EF8w7Eb,WAAW;EC365DX,8DAAgB;AD665DlB;AACA;ECz65DE,mBAAA;ECx2hBC,WAAU;EFox7EX,8DAA8D;ACv65D9D;ADy65DF;EACE,mBAAmB;ECr65DnB,WAAA;ECl3hBC,gEAA6D;AF0x7EhE;ACn65DE;ECv3hBC,mBAAY;EF6x7Eb,WAAW;ECj65DX,gEAAgB;ADm65DlB;AACA;EC/55DE,mBAAA;ECj4hBC,WAAU;EFmy7EX,kEAAkE;AC755DlE;AD+55DF;EACE,mBAAmB;EC355DnB,WAAA;EACC,kECtxhBgC;AFmr7EnC;AACA;EACE,iEAAiE;ACz55DjE;AD255DF;ECz55DG,iECvzhBoB;AFkt7EvB;AACA;ECv55DE,iEAAgB;ADy55DlB;AACA;EACE,gEAAgE;AAClE;ACr55DC;EACC,gEAAkB;ADu55DpB;AACA;EACE,iEAAiE;ACp55DlE;ADs55DD;ECp55DE,iEAAQ;ADs55DV;AACA;EACE,gEAAgE;ACn55DjE;ADq55DD;ECn55DE,gEAAkB;ADq55DpB;AACA;EACE,+DAA+D;ACl55DjE;AACA;EACC,iEC7zhBoC;AFit7ErC;ACn55DC;EACC,gEAA8B;ADq55DhC;AACA;ECn55DC,iEAAa;ADq55Dd;AACA;EACE,mBAAmB;ECn55DpB,cAAA;EACC,iDCvzhB0B;AF4s7E5B;AACA;ECp55DE,mBAAA;EACC,WCt2hBoB;EF4v7ErB,+DAA+D;ACn55DhE;ADq55DD;EACE,uBAAuB;ECn55DxB,gBAAA;ADq55DD;;ACl55DC;EACC,mBCp0hB0B;EDq0hB1B,mBErshBgB;AH0l7ElB;;AAEA;ECn55DE,kBE7rhBa;EHkl7Eb,SAAS;ECn55DV,QAAA;ADq55DD;;AAEA;ECn55DC,kBAAA;EACC,kBCh1hB0B;EDi1hB1B,SAAA;ADq55DF;;AAEA,aExu7EiB;AFyu7EjB;EACE,qBAAqB;ACn55DtB;ADq55DD;ECn55DE,8BE7phB6C;EHkj7E7C,+BAA+B;ACn55DhC;ADq55DD;ECn55DE,kCC92hB+B;EFmw7E/B,iCAAiC;ACn55DlC;ADq55DD;ECn55DE,yBCz4hB6B;EF8x7E7B,qBAAqB;ACn55DtB;ADq55DD;EACE,WAAW;ACp55DX;ADs55DF;ECp55DG,cCv2hBc;AF6v7EjB;ACp55DE;EACC,yBC12hByB;AFgw7E5B;AACA;ECp55DE,cAAA;EACC,yBC92hByB;AFow7E5B;AACA;ECp55DE,cAAA;EACC,yBCl3hByB;AFww7E5B;AACA;ECp55DE,cAAA;EACC,yBCt3hByB;AF4w7E5B;AACA;ECp55DE,cAAA;EACC,yBC/4hB0B;AFqy7E7B;AACA;EACE,cAAc;EC745Df,yBAAA;AD+45DD;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;ECl55Df,yBAAA;ADo55DD;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;ACp55DG;EACC,yBCh5hBwB;EDi5hBxB,qBCj5hBwB;AFuy7E5B;ACh55DG;EACC,yBCx5hBwB;EDy5hBxB,qBCz5hBwB;AF2y7E5B;AC545DG;EACC,yBCh6hBwB;EDi6hBxB,qBCj6hBwB;AF+y7E5B;ACx45DG;EACC,yBCx6hBwB;EDy6hBxB,qBCz6hBwB;AFmz7E5B;ACp45DG;EACC,yBCh7hBwB;EDi7hBxB,qBCj7hBwB;AFuz7E5B;ACh45DG;EACC,yBC78hByB;ED88hBzB,qBC98hByB;AFg17E7B;;AC535DA;;;;;;EAQE,iCAAiB;AD635DnB;AACA;;;;;;ECp35DC,+BAAgB;AD235DjB;;AAEA;ECz35DI,yBAAY;EACf,qBAAe;AD235DhB;AACA;EC135DA,yBAAoB;EACnB,qBAAQ;AD435DT;AACA;EC335DA,yBAAmB;EAClB,qBAAqB;AD635DtB;AACA;EC335DC,yBAAqB;ED635DpB,qBAAqB;AACvB;AC335DC;EACC,yBAAY;ED635DZ,qBAAqB;AC335DtB;AD635DD;EC335DE,yBAAe;EACf,qBAAe;AD635DjB;;AAEA,aE/47EoB;AFg57EpB;EC535DG,cAAQ;ED835DT,cAAc;AC535Dd;AD835DF;EC535DG,iBAAc;ED835Df,cAAc;EC535Dd,eAAA;AD835DF;;AC535DG,cAAA;AD+35DH;;EC535DI,gBAAgB;EAChB,mBAAiB;ED+35DnB,eAAe;EACf,aAAa;EC135Df,YAAA;EACA,gBAAU;AD435DV;;AC135DC;EACC,SAAA;AD635DF;;AAEA;EACE,qBAAqB;EC335DtB,iBAAA;EACC,mBAAU;ED635DV,qBAAqB;AC335DtB;;AD835DD;EC335DC,YAAA;AD635DD;AACA;EC335DC,mBAAA;EACC,eAAW;ED635DX,sBAAsB;AC335DvB;AD635DD;EACE,cAAc;EC335Df,gBAAA;EACC,yBCvhiB0B;AFo57E5B;AC535DE;EACC,gBAAU;EACV,uBAAa;AD835DhB;AACA;EC535DG,WAAQ;AD835DX;AACA;EC535DG,kBAAkB;EAClB,gBAAY;EACZ,0BAAoB;EACpB,kBAAS;AD835DZ;;AAEA,cC735DG;AD835DH;EC535DG,gBAAe;AD835DlB;AACA;EC735DG,oBAAA;AD+35DH;AACA;EC735DI,oBAAQ;AD+35DZ;AACA;EC735DI,WAAU;AD+35Dd;AACA;EC735DI,WAAU;AD+35Dd;AACA;EC735DI,YAAA;AD+35DJ;AACA;EIvi8EQ,YAAA;AJyi8ER;AACA;EACE,YAAY;AC/35Db;ADi45DD;EACE,yBAAyB;ACh45DzB;ADk45DF;ECh45DG,kBAAiB;EDk45DlB,YAAY;EACZ,WAAW;EC/35Db,mBAAgB;EACf,YAAA;EACA,oBAAmB;EACnB,uBAAgB;EAChB,kBAAc;EDi45Db,YAAY;EC535DX,aAAS;EAGT,mBAAmB;EACnB,uBAAsB;EACtB,+BAAmB;ADg45DtB;AC/35DG;EACC,WAAS;EACT,kBAAe;EACf,QAAM;EACN,SAAQ;EACR,aAAa;EDi45Df,UAAU;EC/35DT,QAAA;EACC,YAAM;EACN,sBAAkB;EAClB,4CAAe;EDi45DjB,qDAAqD;EACrD,qBAAqB;ECz35DnB,yBAAa;AD+35DjB;AACA;EC735DC,4BAAkB;AD+35DnB;AACA;EC735DC,4BAA+B;EAC/B,kBAAS;AD+35DV;;AAEA;EC735DC,0BAAsB;EACtB,mBAAmB;EACnB,gBAAe;EACf,oBAAA;AD+35DD;;AAEA;EC735DC,aAAS;EAER,mBAAgB;ADk45DlB;AACA;EACE,qBAAqB;ECh45DtB,mBAAA;EGtviBO,cAAA;EAIA,kBAAmB;EAInB,gBAAkB;AJmn8E1B;AACA;EACE,cAAc;ECr45Dd,kBAAA;EACC,eAAS;ADu45DZ;;ACl45DA,YAAA;AACA;EACC,YAAY;EDq45DX,WAAW;ECp45DZ,aAAA;EACC,kBAAc;EDs45Dd,SAAS;ECr45DT,kBAAA;EACC,gBAAe;EDu45DhB,eAAe;EACf,yBAAyB;ECl45DvB,aAAY;EAGf,mBAAgB;EAChB,uBCjsiBsB;EDksiBtB,+BAAkB;EG/wiBX,qBAAsB;EAItB,gEAAyB;EH6wiBhC,sCAAQ;EGjxiBD,UAAA;AJ2p8ER;AACA;EIhp8EQ,gBAAiB;EAIjB,sBAAc;EHmwiBpB,oBAAS;AD645DX;AACA;ECt45DA,2BAAiB;AAEhB;AD245DD;EACE,gBAAgB;AAClB;;AAEA,eC145Da;AD245Db;ECz45DI,eAAM;AD245DV;AACA;ECz45DC,sBAAW;AD245DZ;AACA;EACE,gBAAgB;AAClB;;ACz45DA;EACE,sBCrsiBkB;EDssiBlB,gBAAW;EACX,yBAAkB;ED445DlB,qBAAqB;EACrB,gBAAgB;EC145DlB,gBAAe;EACb,kBAAiB;ED845DjB,iDAAiD;AC345DjD;AD645DF;EAKE,4BAA4B;EAC5B,UAAU;EC145DZ,qFAAa;AD445Db;AACA;EC145DE,UAAA;AD445DF;;AC145DE,gBAAA;AD645DF;EACE,UAAU;AACZ;;AAEA;EC145DE,qBAAa;ED445Db,kBAAkB;EAClB,MAAM;EC145DR,OAAA;EACE,QAAO;EACP,YAAY;ED445DZ,sBAAsB;EACtB,uBAAuB;AC145DzB;;AD645DA,YC345DU;AD445DV;EACE,yBAAyB;EC145D3B,WAAY;EACV,kBAAW;AD445Db;;AAEA;EACE,iBAAiB;EC145DnB,iBAAA;EACE,mBAAe;AD445DjB;AC145DI;EACE,eAAe;AD445DrB;;ACt45DE;EACE,mBAAc;ADy45DlB;;AAEA;ECr45DE,WAAA;EACE,mBAAe;EDu45DjB,oBAAoB;EACpB,gBAAgB;ACp45DlB;ADs45DA;ECp45DE,eAAQ;ADs45DV;;AAEA;ECp45DA,YAAA;EACE,aAAW;ADs45Db;;ACn45DA;EACE,YAAU;EDs45DV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;ACp45Dd;;ADu45DA;ECr45DE,WAAA;EACE,YAAS;EDu45DX,eAAe;ACt45Db;;ADy45DJ;ECt45DI,oBAAA;ADw45DJ;AACA;EACE,eAAe;ACp45DjB;;ADu45DA;ECp45DI,oBAAA;EACE,oBAAe;ADs45DrB;;ACj45DA;EACI,oBAAc;ADo45DlB;;ACl45DC;EACC,cAAa;EDq45Db,wBAAwB;EACxB,qBAAqB;ACn45DvB;;ADs45DA;EACE,WAAW;ACn45DX;;ADs45DF;ECn45DE,UAAA;ADq45DF;;ACh45DE;EACC,UAAS;ADm45DZ;;AAEA;EACE,WAAW;ACj45DX;ADm45DF;EACE,oBAAoB;ACh45DrB;ADk45DD;EACE,yBAAyB;AAC3B;AC/35DA;EACA,gBAAA;ADi45DA;;AAEA;EC/35DC,kBAAW;ADi45DZ;AACA;EC/35DE,eAAA;ADi45DF;;AC935DE;EACC,cAAQ;EDi45DT,mBAAmB;AC/35DnB;ADi45DF;EC/35DG,gBAAa;ADi45DhB;;AAEA,oBCh45DmB;ADi45DnB;EC/35DG,mBAAU;ADi45Db;AC/35DE;EACC,WCl3iBc;AFmv8EjB;AACA;EC/35DG,WAAO;ADi45DV;AACA;EACE,iBAAiB;AC/35DjB;ADi45DF;EACE,cAAc;ACh45Db;ADk45DH;ECh45DI,mBAAiB;ADk45DrB;AACA;ECh45DI,gBAAU;ADk45Dd;;AAEA,YCj45DY;ADk45DZ;ECh45DI,YAAW;EDk45Db,8CAA8C;ECj45D5C,sBAAA;EACC,mBAAW;EDm45Dd,uCAAuC;AC535DrC;AD835DJ;EACE,aAAa;ACz35Db;AD235DF;ECz35DG,SAAM;AD235DT;AACA;ECz35DG,cC56iB4B;ED66iB5B,uCAAuB;EACvB,iBAAA;EACA,gBAAA;EACA,gBAAa;EACb,uBAAW;EACX,UAAQ;AD235DX;AACA;ECz35DG,cAAU;EACV,uCAAS;ED235DV,oBAAoB;EC135DnB,eAAA;EACC,oBAAgB;EAChB,UAAS;AD435Db;AC135DG;EACC,mBAAS;AD435Db;ACv35DE;EACC,aAAQ;EACL,sBAAU;EDy35Dd,gBAAgB;ECv35DhB,SAAA;EACC,iBAAa;EACV,gCAAS;EDy35Db,WAAW;ECx35DV,YAAA;EGzhjBK,oBAAsB;EAItB,iBAAmB;AJi58E3B;AACA;EIt48EQ,2BAAoB;AJw48E5B;AC335DE;EACC,qBAAS;AD635DZ;AACA;EC535DG,iBAAA;EGhijBK,+DAA4B;EAI5B,oBAAmB;EAInB,aAAgB;EAIhB,cAAiB;EAIjB,uBAAc;EJm58EpB,kCAAkC;EC/35DlC,kCAAA;EACC,oBAAS;EACN,WAAS;EDi45Db,YAAY;ECh45DX,YAAA;EGvijBK,UAAA;EAIA,WAAA;EAIA,UAAA;AJo68ER;AACA;EACE,gBAAgB;ECn45DhB,mBAAA;ADq45DF;AACA;EACE,UAAU;ACn45DV;ADq45DF;ECn45DG,QAAQ;EACR,UAAQ;ADq45DX;AACA;ECn45DG,aAAM;EACN,SAAO;ADq45DV;AACA;EIp78EQ,yBAAkB;AJ078E1B;AACA;ECv45DG,SAAA;EDy45DD,YAAY;ACt45Db;ADw45DD;ECl45DE,yBAAA;ADw45DF;AACA;ECt45DE,SAAA;EACA,SAAA;ADw45DF;ACt45DC;ED445DC,wBAAwB;ACt45DvB;ADw45DH;;ECh45DK,aAAA;ADm45DL;AACA;EC935DG,WAAA;EACC,kBAAa;EACb,QCphjBa;EFo58Ef,SAAS;EC735DT,cAAA;EACC,MAAA;ED+35DD,OAAO;EC535DR,sBAAA;EACC,sCAAG;ED835DH,+CC735DW;ED835DX,qBC735DoB;EDk45DpB,yBAAyB;EACzB,6CAA6C;AC335D9C;AD635DD;EAKE,yBC535DW;EAMX,sBAAG;AD435DL;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WC335DC;AD435DH;AACA;ECz35DC,WAAA;AD235DD;AACA;EACE,qBC135DY;AD235Dd;AACA;EACE,aC135DW;ED235DX,WC135DU;AD235DZ;AACA;ECx35DC,qDAAa;AD035Dd;AA+BA;EACE;IACE,UAAU;IACV,2BAA2B;ECp35D9B;EACC;IACC,UAAU;IACV,wBAAW;EDs35DZ;AACF;AACA;ECh35DC,wBAAA;ADq35DD;AA+BA;EACE;IACE,UAAU;IACV,4BAA4B;EC/25D/B;EACC;IACC,UAAU;IACV,wBAAW;EDi35DZ;AACF;AACA;EC325DC,0BAAA;ADg35DD;AA+BA;EACE;IACE,UAAU;IACV,4BAA4B;EC125D/B;EACC;IACC,UAAU;IACV,wBAAW;ED425DZ;AACF;AACA;ECt25DC,2BAAA;AD225DD;AA+BA;EACE;ICj25DE,UAAA;IAGC,2BCjujBuB;EFkk9E1B;ECx15DG;IAEC,UC5ujBW;IFqk9Eb,wBAAwB;ECh15DvB;ADk15DL;AACA;EC7z5DK,0BAAA;ADk05DL;;ACvz5DK;EAEC;IDyz5DF,aAAa;EChz5DZ;ADkz5DL;AACA,SAAS;ACzy5DJ;EACC,sBE3wjBmC;EHsj9EvC,uBAAuB;ECly5DpB,qBAAA;EACC,cCtzjBsB;EF0l9E1B,eAAe;EC3x5DZ,oBAAA;AD6x5DL;AACA;ECpx5DK,eAAA;ADsx5DL;AACA;EC9w5DE,aAAA;ADgx5DF;AACA;EACE,aAAa;AC5w5Db;AD8w5DF;EC5w5DG,WAAQ;ED8w5DT,YAAY;AACd;AC1w5DA;EACA,aAAU;AD4w5DV;AACA;EACE,aAAa;AC3w5Df;AD6w5DA;EACE,aAAa;AACf;AC5w5DA;EACA,aAAM;AD8w5DN;AACA;EC5w5DC,aAAA;AD8w5DD;AC7w5DC;EACC,aAAS;AD+w5DX;AACA;EC7w5DE,aAAA;AD+w5DF;AACA;EC7w5DE,aAAA;AD+w5DF;AACA;EC7w5DE,aAAS;AD+w5DX;AACA;EC7w5DE,aAAa;AD+w5Df;AACA;EACE,aAAa;AC7w5Dd;AD+w5DD;EACE,wBAAwB;EC7w5DzB,yBAAM;AD+w5DP;AACA;EC7w5DE,sBAAW;EACX,uBAAO;AD+w5DT;;AAEA,WC9w5DS;AD+w5DT;EC9w5DE,aAAA;ADgx5DF;;AC3w5DE;EACC,WAAA;AD8w5DH;;AAEA,QAAQ;AC1w5DJ;EACC,qBEnxjBsC;EFoxjBtC,kBEpxjBa;EHgi9EhB,sBAAsB;ACvw5DrB;ADyw5DH;EAGE,aAAa;EClw5DZ,mBAAQ;EACR,uBC78jB4B;EFmt9E7B,+BAA+B;EClw5D7B,qBAAA;EACC,kBC77jBiB;ED87jBjB,wBC97jBiB;EFks9EpB,mBAAmB;EC/v5DlB,gBAAA;EACC,oBC79jBmB;ED89jBnB,cC19jBgB;AF2t9EpB;AACA;EC5v5DE,oBAAA;AD8v5DF;AACA;EC5v5DG,kBC37jByB;EFyr9E1B,YAAY;EC1v5DV,WAAA;EACC,OAAA;ED4v5DH,MAAM;ECvv5DL,UAAA;EACC,eCl/jBmB;AF2u9EvB;AACA;EACE,oBAAoB;ACpv5DpB;ADsv5DF;ECpv5DG,yBAA+B;EAC/B,yBCx/jB4B;EF8u9E7B,cAAc;AClv5DZ;ADov5DJ;EACE,qBAAqB;EC/u5DpB,yBAAA;ADiv5DH;AACA;EC/u5DI,WAAA;EDiv5DF,qBAAqB;EC3u5DpB,yBAAA;AD6u5DH;AACA;EC3u5DI,yBAAoB;EACpB,yBAAa;ED6u5Df,cAAc;AC3u5Db;AD6u5DH;EC3u5DI,qBAAU;EACV,yBAAS;AD6u5Db;ACvu5DG;EACC,WAAM;EACN,qBAAA;EACA,yBAAyB;ADyu5D7B;AACA;EIp19EQ,uBAAmB;EAYnB,yBAAc;EJ209EpB,cAAc;ACzu5Db;AD2u5DH;EIz19EQ,qBAAmB;AJ219E3B;AACA;ECxu5DI,WAAA;EACC,qBAAc;ED0u5DjB,yBAAyB;ACxu5DvB;AD0u5DJ;EACE,uBAAuB;ECpu5DvB,yBAAA;EACC,cAAa;ADsu5DhB;AACA;EClu5DE,qBAAM;ADou5DR;AACA;ECju5DC,WAAA;EACC,qBAAkB;EDmu5DlB,yBAAyB;AClu5DzB;ADou5DF;EACE,eAAe;EClu5Df,cAAA;EACC,oBAAc;EACd,aAAA;ADou5DH;AACA;;EClu5DI,WAAO;EACP,UAAA;ADqu5DJ;AChu5DE;EACC,4DAAmB;EDku5DpB,mCAAmC;ECju5DlC,kCAAQ;EACP,gBAAY;EAGZ,0BAAkB;ADmu5DtB;AACA;EAGE,0BAA0B;ACju5DzB;ADmu5DH;EACE,eAAe;AC9t5Df;ADgu5DF;EC9t5DG,mBAAc;ADgu5DjB;AC5t5DI;EACC,mBAAkB;ED8t5DrB,yBAAyB;ACvt5DtB;ADyt5DL;EACE,oBAAoB;AClt5DlB;ADot5DJ;EACE,mBAAmB;AACrB;AC/s5DA;EACC,oBAAW;ADit5DZ;AACA;EACE,gCAAgC;EC/s5DjC,oCAAS;EACR,yBAAqB;ADit5DvB;AACA;EACE,yBAAyB;EC/s5D3B,oBAAmB;AAElB;ADgt5DD;EACE,oBAAoB;AC9s5DnB;ADgt5DH;EACE,YAAY;EC7s5DV,WAAA;EACC,eAAS;EG/tkBN,kBAAoB;EAIpB,OAAA;AJ469ER;AACA;EC3s5DI,kBAAA;AD6s5DJ;AACA;EC1s5DK,qBAAA;AD4s5DL;AACA;EACE,oBAAoB;ECrs5DtB,eAAW;AACX;ADus5DA;ECrs5DC,mBAAiB;ADus5DlB;AACA;ECrs5DC,kBAAU;ADus5DX;AACA;ECrs5DC,qBAAS;ADus5DV;;AAEA;ECrs5DC,YAAM;EACN,aAAY;ADus5Db;;AAEA;EI979EQ,qBAAiB;EAIjB,sBAAc;AJ679EtB;;AAEA,kBC3s5DW;AD4s5DX;EC1s5DE,eAAA;AD4s5DF;AACA;EC1s5DE,cAAS;AD4s5DX;AACA;ECzs5DE,UAAA;EAGC,4BAAS;AD2s5DZ;AACA;ECzs5DG,cAAY;AD2s5Df;AACA;ECzs5DG,UAAA;AD2s5DH;;ACxs5DE,UAAA;AD2s5DF;ECzs5DG,aAAQ;EACR,uBAAM;EACN,mBAAS;EACT,kBAAW;EACX,UAAU;EACV,mBAAY;EACZ,WAAU;EACV,sBAAe;EACf,qBAAa;EACb,kBAAc;ED2s5Df,gBAAgB;ECxs5DjB,MAAA;EACC,kBAAS;ED8s5DT,2BAA2B;AC1s5D1B;AD4s5DH;ECvs5DC,aAAA;ED4s5DC,mBAAmB;ECzs5DnB,kBAAA;EACC,UAAA;AD2s5DH;AACA;EC1s5DG,6BAAA;EACC,MAAA;ED4s5DF,SAAS;ECvs5DV,WAAA;EACC,kBAAS;EG9zkBH,8BAAsB;EAItB,iCAAmB;EAInB,gCAAkB;EAIlB,gDAAuB;EAIvB,WAAc;AJ4/9EtB;AACA;EC5s5DE,6BAAA;EACC,0BAAe;ED8s5DhB,MAAM;EC1s5DP,SAAA;EACC,WAAU;EACV,kBAAQ;EGx0kBF,YAAA;EAIA,8BHq0kBiB;EGj0kBjB,iCHi0kBiB;EG7zkBjB,+BH6zkBiB;EGzzkBjB,iDHyzkBiB;ADgt5DzB;AC/s5DE;EACC,UAAA;ADit5DH;AACA;ECht5DG,0BAAA;EACC,6BAAY;ADkt5DhB;AC9s5DC;EACC,aAAW;ADgt5Db;AACA;EIpi+EQ,WAAA;EAIA,UAAA;AJmi+ER;AACA;EIxh+EQ,yBHs0kBiB;EDot5DvB,4BAA4B;ACnt5D5B;ADqt5DF;ECnt5DG,aAAA;ADqt5DH;ACpt5DG;EACC,SAAQ;EAOV,gCAAwB;EACxB,WAAA;ADot5DF;AACA;EIhj+EQ,gBH41kBa;ADst5DrB;AACA;EACE,WAAW;ECvt5DX,SAAA;ED6t5DA,eAAe;ACtt5DhB;ADwt5DD;ECtt5DE,0BAAS;EACT,6BAAyB;ADwt5D3B;AACA;EIxk+EQ,aAAA;AJ0k+ER;AACA;EI/j+EQ,YAAe;EAIf,UAAY;EJ8j+ElB,SAAS;ECxt5DP,eAAY;AD8t5DhB;AC1t5DC;EACC,yBAAe;ED4t5Df,4BAA4B;ACzt5D5B;AD2t5DF;ECzt5DG,aAAY;AD2t5Df;ACxt5DC;EACC,OAAA;EACA,SAAS;EACT,yBAAwB;ED0t5DxB,4BAA4B;ECnt5D1B,eEr6kBE;AH8n+EN;ACrt5DC;EACC,gBCzxkBe;AFg/9EjB;ACrt5DG;EAEC,aAAY;ADst5DhB;AClt5DC;EACC,QAAA;EDot5DA,UAAU;EClt5DT,0BAAA;EAEC,6BCtykBwB;EFy/9E1B,SAAS;EC1s5DP,eC/ykBa;AF+/9EjB;AC5s5DC;EACC,gBCpzkBe;AFkg+EjB;AC5s5DG;EAEC,aAAY;AD6s5DhB;ACzs5DC;EACC,gBC7zkBe;AFwg+EjB;ACzs5DG;EAEC,mBCj0kBa;EF2g+Ef,oBAAoB;ACts5DrB;ADws5DD;EACE,gBAAgB;ECts5Df,kBAAA;EAEC,yBC10kBwB;AFih+E5B;ACns5DC;EACC,mBC/0kB0B;AFoh+E5B;ACns5DG;EAEC,qBCn1kBwB;AFuh+E5B;AChs5DC;EACC,mBCx1kB0B;AF0h+E5B;AChs5DG;EAEC,qBC51kBwB;AF6h+E5B;AC7r5DC;EACC,mBCj2kB0B;AFgi+E5B;AC7r5DG;EAEC,qBCr2kBwB;AFmi+E5B;AC1r5DC;EACC,mBE1/kBU;AHsr+EZ;AC1r5DG;EAEC,qBE9/kBQ;AHyr+EZ;ACvr5DC;EACC,mBExglBW;AHis+Eb;ACvr5DG;EAEC,qBE5glBS;AHos+Eb;ACpr5DC;EACC,mBEhhlBa;AHss+Ef;ACpr5DG;EAEC,qBEphlBW;AHys+Ef;ACjr5DC;EACC,mBExhlBa;AH2s+Ef;ACjr5DG;EAEC,qBE5hlBW;AH8s+Ef;AC9q5DC;EACC,mBEhilBa;AHgt+Ef;AC9q5DG;EAEC,qBEpilBW;AHmt+Ef;AC3q5DC;EACC,mBCv5kB0B;AFok+E5B;AC3q5DG;EAEC,qBC35kBwB;AFuk+E5B;ACxq5DC;EACC,mBE7ilBW;AHut+Eb;ACxq5DG;EAEC,qBEjjlBS;AH0t+Eb;ACrq5DC;EACC,mBErjlBW;AH4t+Eb;ACrq5DG;EAEC,qBEzjlBS;AH+t+Eb;AClq5DC;EACC,mBC19kB6B;AF8n+E/B;AACA;EClq5DG,qBAAA;ADoq5DH;AACA;EC/p5DC,mBAAA;ADiq5DD;AACA;EC/p5DG,qBAAA;ADiq5DH;AACA;EC5p5DC,mBAAA;AD8p5DD;AACA;EC5p5DG,qBAAA;AD8p5DH;AACA;ECzp5DC,mBAAA;AD2p5DD;AACA;ECzp5DG,qBAAA;AD2p5DH;AACA;ECtp5DC,mBAAA;ADwp5DD;AACA;ECtp5DG,qBAAA;ADwp5DH;AACA;ECnp5DC,mBAAA;ADqp5DD;AACA;ECnp5DG,qBAAA;ADqp5DH;AACA;EChp5DC,mBAAA;ADkp5DD;AACA;EChp5DG,qBAAA;ADkp5DH;AACA;EC7o5DC,cAAA;EACC,mBCvglB2B;AFsp+E7B;AC7o5DG;EAEC,qBC3glByB;AFyp+E7B;AC1o5DC;EACC,mBC9glBiC;AF0p+EnC;AACA;EC1o5DG,qBAAA;AD4o5DH;AACA;ECvo5DC,mBAAA;ADyo5DD;AACA;ECvo5DG,qBAAA;ADyo5DH;AACA;EACE,mBAAmB;ACpo5DrB;ADso5DA;ECpo5DC,qBAAiB;ADso5DlB;AACA;ECpo5DC,mBAAU;ADso5DX;AACA;ECpo5DC,qBAAqB;ADso5DtB;AACA;ECpo5DC,mBAAS;ADso5DV;AACA;ECpo5DC,qBAAkB;ADso5DnB;ACro5DC;EACC,mBAAS;ADuo5DX;AACA;ECro5DE,qBAAgB;ADuo5DlB;AACA;ECro5DE,mBAAS;ADuo5DX;AACA;ECro5DC,qBAAQ;ADuo5DT;AACA;ECro5DE,mBAAc;EACd,cAAa;ADuo5Df;AACA;ECro5DE,qBAAW;ADuo5Db;AACA;ECro5DE,mBAAO;ADuo5DT;ACro5DC;EACC,qBAAS;ADuo5DX;;AAEA;ECro5DE,aAAS;EDuo5DT,uBAAuB;ECro5DxB,mBAAA;EACC,kBAAS;EGprlBH,UAAA;EAIA,mBAAmB;EAInB,WAAA;EAIA,qBAAiB;EAIjB,mBAAc;EHsqlBpB,gBAAU;ED2o5DV,SAAS;ECzo5DV,YAAA;EGxrlBO,WAAA;EAIA,kBHqrlBa;AD4o5DrB;AACA;EC5o5DE,aAAK;EG1rlBC,mBAAsB;EAItB,kBAAmB;EAInB,UAAA;EAIA,kBAAiB;AJm0+EzB;AACA;ECjp5DC,6BAAA;EACC,8BExtlBW;EH22+EX,gCAAgC;EClp5DhC,+BAAA;EACC,kDE1tlBU;EH82+EX,aAAa;ECjp5Dd,WAAA;EACC,kBC7klBe;EFgu+Ef,OAAO;EClp5DP,QAAA;ADop5DF;AACA;ECjp5DC,UAAA;ADmp5DD;AACA;EClp5DE,WAAA;EAEC,UAAA;ADmp5DH;AChp5DC;EACC,SAAA;EAMD,6BAAA;EACC,WAAU;ADip5DZ;AChp5DE;EDsp5DA,eAAe;EC/o5Df,MAAA;ADip5DF;AACA;ECzo5DG,6BClnlByB;AFiw+E5B;AC5o5DC;EACC,mBCtnlB0B;AFow+E5B;AC7o5DE;EAEC,qBCznlByB;AFuw+E5B;AC3o5DC;EACC,mBC7nlB0B;AF0w+E5B;AC5o5DE;EAEC,qBCholByB;AF6w+E5B;AC1o5DC;EACC,mBCpolB0B;AFgx+E5B;AC3o5DE;EAEC,qBCvolByB;AFmx+E5B;ACzo5DC;EACC,mBE3xlBU;AHs6+EZ;AC1o5DE;EAEC,qBE9xlBS;AHy6+EZ;ACxo5DC;EACC,mBEvylBW;AHi7+Eb;ACzo5DE;EAEC,qBE1ylBU;AHo7+Eb;ACvo5DC;EACC,mBE7ylBa;AHs7+Ef;ACxo5DE;EAEC,qBEhzlBY;AHy7+Ef;ACto5DC;EACC,mBEnzlBa;AH27+Ef;ACvo5DE;EAEC,qBEtzlBY;AH87+Ef;ACro5DC;EACC,mBEzzlBa;AHg8+Ef;ACto5DE;EAEC,qBE5zlBY;AHm8+Ef;ACpo5DC;EACC,mBC9qlB0B;AFoz+E5B;ACro5DE;EAEC,qBCjrlByB;AFuz+E5B;ACno5DC;EACC,mBEl0lBW;AHu8+Eb;ACpo5DE;EAEC,qBEr0lBU;AH08+Eb;AClo5DC;EACC,mBEx0lBW;AH48+Eb;ACno5DE;EAEC,qBE30lBU;AH+8+Eb;ACjo5DC;EACC,mBE90lBU;AHi9+EZ;AACA;EClo5DE,qBAAA;ADoo5DF;AACA;ECho5DC,mBAAA;ADko5DD;AACA;ECjo5DE,qBAAA;ADmo5DF;AACA;EC/n5DC,mBAAA;ADio5DD;AACA;ECho5DE,qBAAA;ADko5DF;AACA;EC9n5DC,mBAAA;ADgo5DD;AACA;EC/n5DE,qBAAA;ADio5DF;AACA;EC7n5DC,mBAAA;AD+n5DD;AACA;EC9n5DE,qBAAA;ADgo5DF;AACA;EC5n5DC,mBAAA;AD8n5DD;AACA;EC7n5DE,qBAAA;AD+n5DF;AACA;EC3n5DC,mBAAA;AD6n5DD;AACA;EC5n5DE,qBAAA;AD8n5DF;AACA;EC1n5DC,mBAAA;EACC,cC1wlBe;AFs4+EjB;AC3n5DE;EAEC,qBC7wlB0B;AFy4+E7B;ACzn5DC;EACC,mBC/wlBiC;AF04+EnC;AACA;EC1n5DE,qBAAA;AD4n5DF;AACA;ECxn5DC,mBAAA;AD0n5DD;AACA;ECzn5DE,qBAAA;AD2n5DF;AACA;EACE,mBAAmB;ACtn5DrB;AACA;EACC,qBAAW;ADwn5DZ;AACA;ECtn5DC,mBAAkB;ADwn5DnB;AACA;EACE,qBAAqB;ACvn5DtB;ADyn5DD;ECvn5DE,mBAAM;ADyn5DR;AACA;ECvn5DE,qBAAW;ADyn5Db;AACA;ECvn5DC,mBAAA;ADyn5DD;AACA;ECvn5DE,qBAAmB;ADyn5DrB;AACA;ECvn5DE,mBAAiB;ADyn5DnB;AACA;ECvn5DE,qBAAW;ADyn5Db;AACA;ECvn5DE,mBAAkB;EACf,cAAU;ADyn5Df;ACvn5DC;EACC,qBAAW;ADyn5Db;AACA;EACE,mBAAmB;ACvn5DpB;ADyn5DD;ECvn5DE,qBAAgB;ADyn5DlB;;ACtn5DC,iBAAA;ADyn5DD;ECvn5DE,WAAQ;EACR,gBAAU;EDyn5DV,kBAAkB;ECvn5DnB,kBAAA;EACC,qBAAW;EACX,sBAAgB;ADyn5DlB;AACA;ECvn5DC,kBAAA;EACC,OAAO;EACP,MAAM;EACN,QAAA;EDyn5DA,YAAY;ECvn5Db,WAAA;ADyn5DD;AACA;ECvn5DG,aAAW;EAGX,mBAAW;ED0n5DZ,uBAAuB;ECxn5DvB,+BAAA;EACC,qBAAW;ED0n5DZ,YAAY;ECxn5DZ,WAAA;EACC,WAAO;ED0n5DR,kBAAkB;ECxn5DlB,UAAA;AD0n5DF;AACA;ECvn5DC,WAAA;EACC,gBAAU;EDyn5DV,kBAAkB;ACxn5DlB;AD0n5DF;ECxn5DG,WAAS;EACN,gBAAU;EACb,kBAAU;AD0n5Db;AACA;ECxn5DG,WAAU;EACV,gBAAW;ED0n5DZ,kBAAkB;ACzn5DjB;AD2n5DH;ECzn5DK,WAAU;EACV,gBAAA;EACA,kBAAO;AD2n5DZ;AACA;EACE,aAAa;ECrn5Db,gBAAA;EACC,eAAU;ADun5Db;AACA;ECnn5DA,YAAW;AACX;ADqn5DA;EACE,YAAY;ACpn5Db;ADsn5DD;ECpn5DE,YAAY;ADsn5Dd;AACA;EACE,YAAY;ACrn5DZ;ADun5DF;ECrn5DG,YAAU;ADun5Db;ACrn5DE;EACC,cAAW;ADun5Dd;AACA;ECrn5DE,kBAAA;ADun5DF;AACA;EACE,kBAAkB;ECrn5DlB,SAAA;EACC,UAAO;EACP,UAAS;EDun5DV,gBAAgB;ECrn5DhB,cAAA;EACC,cAAQ;EACR,uBAAQ;ADun5DX;AACA;EI1n/EQ,oBAAmB;EAInB,kBAAkB;EAIlB,6BAAiB;EAIjB,OAAA;EJmn/EN,WAAW;ACzn5DX;;AD4n5DF;ECzn5DG,kBAAU;AD2n5Db;;AAEA,UIlo/EQ;AJmo/ER;EI3n/EQ,gBAAc;AJ6n/EtB;AC5n5DC;EACC,eCr8lBqB;EFmk/ErB,YAAY;EC7n5DZ,aAAA;EACC,gBAAc;AD+n5DjB;AACA;EC5n5DA,SAAW;EAEV,WAAA;AD6n5DD;AACA;EC3n5DE,YAAW;EACX,WAAA;AD6n5DF;AACA;EACE,SAAS;EC5n5DT,UAAA;AD8n5DF;AACA;EC3n5DC,YAAA;EACC,UAAS;AD6n5DX;AACA;EC3n5DE,SAAA;ED6n5DA,SAAS;EACT,WAAW;ECtn5DT,2BAAsB;AD4n5D1B;AACA;EC3n5DC,YAAA;EACC,SCh9lBe;EDi9lBf,WAAA;EAKA,2BCj8lB0B;AF8j/E5B;AACA;EC3n5DE,WAAU;AD6n5DZ;AC5n5DE;EACC,cCt8lByB;AFok/E5B;;AAEA,UAAU;AACV;ECtn5DI,mBAAiB;EAElB,6BAAA;EACC,YAAA;AD0n5DJ;ACxn5DG;EACC,YAAU;AD0n5Dd;AACA;ECvn5DI,aAAS;EAET,8BAAW;AD0n5Df;;AAEA,mBAAmB;ACzn5Df;EACC,cAAA;ED2n5DH,6BAA6B;EAC7B,sBAAsB;ECtn5DxB,qBAAmB;AAGjB;ADsn5DF;EACE,cAAc;ECpn5Dd,6BAAA;EACC,sBAAe;EACf,qBAAS;ADsn5DZ;AACA;ECpn5DG,cAAQ;EACR,yBAAU;EACV,qBChimBoB;EDiimBpB,2BAAmB;ADsn5DtB;AACA;EACE,cAAc;ECrn5Db,yBAAA;EACC,qBAAe;ADun5DnB;;AChn5DA;EAEC,iBAAc;ADmn5Df;AACA;ECjn5DC,wDCjjmBsB;AFoq/EvB;AACA;ECjn5DC,kBAAO;EDmn5DN,UAAU;EACV,OAAO;EChn5DP,MAAA;EACC,SAAA;EDkn5DD,YAAY;EACZ,WAAW;EC/m5Db,UAAW;EACX,eAAW;ADin5DX;AACA;EC/m5DC,0DAAe;ADin5DhB;;AAEA,kBChn5DU;ADin5DV;EACE,qBAAqB;AACvB;AC/m5DC;EACC,eAAQ;EACR,SAAA;EACA,gBAAgB;EDin5DhB,YAAY;EC/m5Db,QAAA;EACE,UAAQ;EACR,gBAAe;EACf,mBAAe;EACf,8BAAgB;EAChB,SAAQ;ADin5DX;AACA;EC9m5DA,gBAAA;AAKI;;AD6m5DJ,eC3m5Dc;AD4m5Dd;EC1m5DK,eAAa;EACb,SAAA;EACA,aAAA;EACA,gBAAa;EACb,8CAAuB;EACvB,QAAA;EACA,OAAA;AD4m5DL;;AAEA;ECzm5DI,wBAAiB;AD2m5DrB;;AAEA,UC3m5Da;AD4m5Db;ECvm5DM,gBAAW;ED2m5Df,0BAA0B;ECvm5DzB,oBAAA;EACC,wBAAgB;EDym5DlB,UAAU;ACxm5DR;;AD2m5DJ;ECxm5DK,0BAAoB;EACpB,qBAAa;EACb,gBAAA;AD0m5DL;AACA;ECxm5DK,yBAAuB;EACvB,qBAAA;EACA,eAAe;EACf,gBAAS;ED0m5DZ,YAAY;ACzm5DT;;AD4m5DL,uBE3u/E+B;AF4u/E/B;EC1m5DM,+BAAA;EAGC,aAAS;EAIV,mBAAkB;EAClB,uBAAoB;EACpB,+BAAa;EACb,qBAAmB;AD2m5DzB;AACA;ECzm5DM,SAAA;EACA,kBAAA;AD2m5DN;AC1m5DM;EACC,YAAY;ED4m5DjB,QAAQ;AC3m5DH;AD6m5DP;EC3m5DQ,WAAW;AD6m5DnB;ACxm5DI;EACC,iBAAS;AD0m5Dd;AACA;ECxm5DK,iBAAgB;EAGhB,aAAU;EAGV,mBAAe;EACf,uBAAiB;EACjB,+BAAY;EACZ,qBAAW;ED0m5Dd,kBAAkB;AACpB;ACrm5DA;EAMK,UAAA;EDkm5DH,cCjm5De;ADkm5DjB;AACA;EACE,WCjm5DI;EDkm5DJ,mBAAmB;EC7l5DlB,UAAA;AD+l5DH;AACA;EACE,kBAAkB;EC1l5DpB,aAAA;ED+l5DE,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;AKp5/EnC;AAEC;EACC,oBAAe;ALq5/EjB;AACA;EKn5/EE,YAAA;EACA,WAAA;ALq5/EF;AKj5/EK;EACC,kBAAkB;ELm5/EtB,UAAU;EKh5/EN,YAAA;EACC,uBAAe;ALk5/EtB;AKj5/EO;EACC,kBH8FuB;EG7FvB,OAAO;EACP,MAAA;EACA,eAAa;EACb,iBAAiB;EACjB,YAAA;EACA,WAAW;ALm5/EnB;;AAEA;EKj5/EQ;ILm5/EJ,gBAAgB;IAGhB,uBAAuB;EKj5/EpB;EACC;IACA,aAAY;EACZ;ALm5/ER;AACA,6BKl5/EqB;ALm5/ErB,uBKl5/EyB;ALm5/EzB,6BKl5/EiC;ALm5/EjC;;;oEAGoE;AKj5/E7D,UAAA;ALm5/EP;EKj5/EQ,gCAAkB;EAClB,YAAA;EACA,8BAAoB;ELm5/E1B,sCAAsC;EKj5/E/B,4BAAA;ALm5/ET;AACA;EK/4/EW,kBAAA;EACC,UAAS;ALi5/ErB;AACA;EK/4/EY,gBAAA;ALi5/EZ;AACA;EK/4/EY,cAAW;EAEV,aAAY;EAGZ,mBAAkB;EAClB,8BH8DgB;EFo1/E3B,sCAAsC;EKr4/EtC,4BAAA;EACC,gCAAoB;ALu4/EvB;AACA;EACE,gBAAgB;AKp4/Eb;ALs4/EL;EACE,6BAA6B;EKn4/EzB,aAAA;ELu4/EJ,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EKv4/E1B,qBAAoB;ELy4/EzB,cAAc;EKx4/ET,mBAAA;AL04/EP;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EK74/EhB,oBAAa;AL+4/ErB;AKz4/EO;EL24/EL,kBAAkB;AACpB;AACA;EK34/EQ,aAAY;EAEZ,mBAAA;ELg5/EN,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EKx4/EV,cAAA;AL04/EV;AACA;EAGE,aAAa;AACf;AACA;EK74/EU,aAAA;AL+4/EV;AACA;;;;;;EKt4/EG,oBAAA;AL64/EH;AACA;;;;;;EKv4/EK,aAAY;AL84/EjB;AACA;;;;;;EKv4/EK,YAAW;EL84/Ed,oBAAoB;AK14/EpB;AL44/EF;;;;;;EKr4/EG,aAAa;AL44/EhB;AK34/EG;;;;;;EAQC,wBAAA;AL24/EJ;AACA;;;;;;EIrggFQ,eAAc;AJ4ggFtB;AACA;EKz4/EE,YAAA;AL24/EF;AACA;EACE,oBAAoB;AKx4/EtB;AL04/EA;EACE,6BIpigF4B;EJqigF5B,aIjigFM;EJkigFN,uBIthgF0B;EJuhgF1B,+BAA+B;EAC/B,qBAAqB;EKx4/EvB,cAAA;EAKK,mBAAA;ALs4/EL;AACA;EKh4/EU,oBAAA;ALk4/EV;AACA;;EAIE,aKt4/EkB;ELy4/ElB,mBAAmB;AACrB;AACA;;EAIE,mBAAmB;AACrB;AACA;EACE,mBKh4/EgB;ALi4/ElB;AACA;EACE,WK53/EG;AL63/EL;;AAEA;EAKE,4BAA4B;EAC5B,gBKp3/EkB;ALq3/EpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IK92/EE,qBAAW;ELk3/Eb;AACF;AACA;EACE;IACE,YAAY;EACd;EM9ngFF;;;;;;IAQG,0BAAoB;EN8ngFrB;EM3ngFD;;IAIC,aAAS;EACT;EACA;;IAIE,mBAAmB;EACnB;EACA;IACA,iBAAc;EN6ngFhB;EM3ngFC;IACC,MAAA;EN6ngFF;AM5ngFE;AN8ngFJ;EACE;;IM3ngFG,+BAAiB;EN8ngFpB;EM5ngFE;;IAEC,0BJwGgC;EFshgFnC;EM3ngFC;IACC,eAAW;IACX,MAAO;IACP,OAAQ;IACR,WAAA;IACA,YAAc;EACd;EACA;IACA,6BAAyB;EN6ngF3B;AM5ngFE;AN8ngFJ;;;oEM3ngFK;AN+ngFL,SM9ngFY;AN+ngFZ;EACE,yBAAyB;AM1ngFzB;AN4ngFF;EM1ngFG,kBAAe;EN4ngFhB,OAAO;EACP,QAAQ;EMvngFR,SAAA;EACC,6BAAoB;ENyngFrB,gBAAgB;AMtngFjB;ANwngFD;EMtngFE,YAAM;EACN,mBAAO;EACP,uBAAS;EACT,+BJqCqB;EIpCrB,eAAW;ANwngFb;AMvngFE;EACC,kBJ6DiB;AF4jgFpB;AACA;EMvngFE,cAAA;ANyngFF;AACA;EACE,kBAAkB;AMxngFjB;AN0ngFH;EMxngFI,cAAa;EN0ngFf,cAAc;AMxngFb;AN0ngFH;EMxngFI,kBAAc;EAEf,aAAA;EN4ngFD,mBAAmB;EMxngFlB,yBAAA;EACC,iCAAwB;AN0ngF5B;AACA;EMxngFI,oBAAgB;EN0ngFlB,cAAc;AMxngFb;AN0ngFH;EMxngFI,YJYgB;EIXhB,WAAA;AN0ngFJ;AACA;EMzngFI,mBAAA;EACC,gBJQ0B;AFmngF/B;;AAEA;EACE,qBAAqB;AMzngFnB;AN2ngFJ;EACE,kBAAkB;EMzngFhB,OAAA;EACC,QAAA;EN2ngFH,SAAS;EMzngFP,gBAAA;EACC,6BAAgB;AN2ngFrB;AACA;EMxngFG,mBAAA;EACC,gBAAS;AN0ngFb;AACA;EMxngFI,iBAAgB;EAChB,oBAAmB;AN0ngFvB;AACA;EACE,oBAAoB;EMzngFlB,mBAAA;AN2ngFJ;AACA;EACE,cAAc;EACd,qBAAqB;AMnngFrB;ANqngFF;EACE,mBAAmB;EACnB,UAAU;AMlngFZ;ANongFA;EACE,yBMjngFiB;ENkngFjB,mBAAmB;EM7mgFjB,iBAAA;EN+mgFF,gBM9mgFa;AN+mgFf;AACA;EACE,cM7mgFc;EN8mgFd,cM7mgFU;EN8mgFV,qBM7mgFmB;EN8mgFnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AMxmgFA;EAII,cAAA;ANumgFJ;AACA;EMrmgFM,qBAAA;ANumgFN;AACA;EMtmgFO,iBAAA;ENwmgFL,cMvmgFM;ANwmgFR;AACA;EAEE,aMnmgFG;ENsmgFH,mBMnmgFoB;ENomgFpB,yBMnmgF0B;ENomgF1B,iCMnmgFwB;ANomgF1B;AACA;EM9lgFG,oBAAA;ENgmgFD,cM/lgFE;ANgmgFJ;;AAEA;EACE,qBM5lgFG;AN6lgFL;;AAEA;EM5lgFK;IACC,yBAAa;EN8lgFjB;EACA;IMxlgFF,WAAA;EAGG;ENwlgFD;IMhlgFI,cAAA;IACC,eAAc;ENmlgFnB;EMllgFK;IACC,oBAAe;ENolgFrB;EACA;IM5kgFF,oBAAA;EAGG;AN4kgFH;AACA;EACE;IO10gFF,YAAA;EP40gFE;EACA;IACE,uBAAuB;EO10gF3B;EAEC;IP20gFG,gBAAgB;EOz0gFlB;EACA;IP20gFE,kBAAkB;IOz0gFrB,sBAAA;EACC;EACA;IP20gFE,uBAAuB;IOz0gF1B,+BAAc;IACb,qBAAS;EACT;;EP40gFA;IOz0gFD,uBAAc;EACb;EP20gFA;IOz0gFC,2BAAA;IACC,mCL4F2B;IF+ugF3B,yBAAyB;IOx0gF3B,kBAAA;EACC;EACA;IP00gFC,cAAc;EOv0gFf;APy0gFH;AACA;EACE;IOr0gFC,qBAAA;EACC;EPu0gFF;IOr0gFG,uBAAA;ELnCD;EF22gFF;IOl0gFI,gBAAA;EACC;APo0gFP;AOh0gFI;EL1CA;IF62gFA,qBAAqB;EO5zgFxB;AP8zgFD;AACA;;;oEAGoE;AACpE,SAAS;AOzzgFT;;EAEC,YLqFgB;EFsugFf,UAAU;AO1zgFX;AP4zgFD;EACE,kBAAkB;EAClB,qBAAqB;AOzzgFtB;AP2zgFD;EOvzgFI,oBAAc;AP2zgFlB;AO1zgFI;EACC,mBAAY;AP4zgFjB;AOzzgFG;EACC,qBAAe;AP2zgFnB;AACA;EO1zgFI,kBAAA;EACC,WAAS;AP4zgFd;AACA;EO1zgFK,kBAAgB;EAChB,WAAW;AP4zgFhB;AACA;EO1zgFK,WAAI;AP4zgFT;AACA;EIn3gFQ,qCAAwB;AJq3gFhC;AACA;EI93gFQ,WAAA;AJg4gFR;AACA;EACE,+BAA+B;AO5zgF/B;AP8zgFF;EO5zgFG,gBAAS;AP8zgFZ;AACA;EO5zgFG,kBAAgB;AP8zgFnB;;AAEA,MO7zgFG;AP8zgFH;EO7zgFG,cAAA;AP+zgFH;AACA;EO7zgFI,cAAa;AP+zgFjB;;AOzzgFI;EACC,kBAAkB;AP4zgFvB;AACA;EO3zgFK,iCAAA;AP6zgFL;AACA;EO3zgFM,aAAS;AP6zgFf;AOrzgFG;EACC,gCAAoB;EACpB,kBAAY;APuzgFhB;AACA;EOtzgFI,gBAAA;EACC,+DAAoC;EPwzgFvC,eAAe;EOtzgFX,oBAAA;ELtIF,iBAAO;EF+7gFT,kBAAkB;EOrzgFf,WAAA;EL1ID,oBAAO;EKoJR,uBAAA;EAKA,yBAAA;APizgFH;AACA;EO1ygFK,aAAM;EAGJ,mBAAa;EP8ygFlB,uBAAuB;EO3ygFpB,+BAAA;AP6ygFL;AACA;EOrygFK,qBAAA;EACC,kBAAY;EACZ,cAAc;EPuygFlB,kBAAkB;AO/xgFjB;APiygFH;EIl8gFQ,kBAAoB;EAIpB,cAAA;AJi8gFR;AACA;EOlygFI,eAAA;EACC,oBAAa;EPoygFhB,cAAc;AO/xgFf;APiygFD;EO/xgFE,qBAAgB;EPiygFhB,mBAAmB;EOhygFnB,oBAAA;APkygFF;AACA;EOhygFG,oCAAiB;APkygFpB;AOhygFI;EACC,+BAAgB;APkygFrB;AACA;EOhygFK,+BAAoB;APkygFzB;AACA;EIr9gFQ,6BAAyB;AJu9gFjC;AACA;EI58gFQ,gBAAc;AJ88gFtB;AACA;EI/8gFQ,oBAAc;AJi9gFtB;AOrygFK;EH5LG,oCAA4B;EAI5B,yBAAmB;AJi+gF3B;AACA;EIt9gFQ,cAAc;AJw9gFtB;AOpygFI;EACC,cAAO;APsygFZ;AOhygFI;EACC,mBAAkB;EAClB,sBAAY;APkygFjB;AO5xgFI;EACC,oCAAqB;EAGrB,4BAAW;AP8xgFhB;AACA;EO5xgFK,gCAAO;AP8xgFZ;AACA;EO3xgFK,iCAAS;AP8xgFd;AOvxgFE;EL9PE,2BAA6B;EFwhhF/B,mCAAmC;EOxxgFlC,kBAAA;AP0xgFH;AACA;EOxxgFG,gBAAA;ELnQC,+DAA6B;EF8hhF/B,eAAe;EOxxgFd,oBAAA;EACC,iBLrHwB;EK2HxB,uBAAA;EAKF,yBAAA;APuxgFF;AACA;EOhxgFM,0BLpLiB;AF08gFvB;AOnxgFI;EACC,gBLxLkB;AF68gFvB;AOpxgFK;ELnSD,mBAAY;EF0jhFd,kCAAkC;AOpxgF/B;APsxgFL;EACE,sBAAsB;AO9wgFnB;APgxgFL;EACE,WAAW;EO1wgFV,kBAAA;EACC,WL7MmB;EFy9gFrB,OAAO;EOvwgFP,SAAA;ELxTE,SAAO;EFkkhFT,WAAW;EOxwgFV,SAAA;AP0wgFH;AACA;EOxwgFG,YAAA;AP0wgFH;AACA;EOxwgFG,+BAAS;AP0wgFZ;AACA;EOxwgFG,+BAAQ;AP0wgFX;AACA;EOvwgFI,cAAA;APywgFJ;AACA;EOrwgFE,+BAAA;APuwgFF;AACA;EOlwgFK,+BAAA;APowgFL;AACA;EO7vgFI,WAAA;AP+vgFJ;AACA;EO9vgFK,WAAA;APgwgFL;AACA;EO7vgFI,WAAA;AP+vgFJ;AACA;EO9vgFK,WAAA;APgwgFL;AACA;EO9vgFK,oCAAA;APgwgFL;AACA;EOzvgFE,+BAAA;AP2vgFF;AACA;EACE,+BAA+B;AOzvgF/B;AP2vgFF;EOzvgFG,WAAW;AP2vgFd;AACA;EOxvgFA,cAAU;AP0vgFV;AACA;EOvvgFE,4BAAA;APyvgFF;AACA;EOzvgFG,4BAAwB;AP2vgF3B;AOzvgFE;EP2vgFA,cAAc;AAChB;AACA;EACE,4BAA4B;AOxvgF5B;AP0vgFF;EOxvgFG,4BAAsB;AP0vgFzB;AOvvgFC;EACC,cAAc;APyvgFhB;AOvvgFC;EACC,4BAAe;APyvgFjB;AOxvgFE;EACC,WAAA;AP0vgFH;AOzvgFG;EACC,WAAO;AP2vgFX;AOrvgFG;EACC,cLlTa;AFyihFjB;AACA;EOpvgFE,kCAAA;APsvgFF;AACA;EOnvgFC,4BAAW;APqvgFZ;AACA;EOnvgFG,qBAAA;EACC,eL9Ta;AFmjhFjB;AACA;EOlvgFE,uBAAA;EACC,mBAAc;APovgFjB;;AAEA;EACE,gCAAgC;AOlvgFhC;APovgFF;;;EOjvgFI,yBAAsB;APqvgF1B;AACA;;EAEE,6BAA6B;EOpvgF3B,wDAAS;APsvgFb;AACA;;EOhvgFA,sBAAa;APmvgFb;AACA;EACE,wDAAwD;AOlvgF1D;APovgFA;EOlvgFC,gBAAY;APovgFb;AACA;EOnvgFC,gBAAA;APqvgFD;AACA;EOnvgFG,uBAAA;APqvgFH;AACA;EACE,gBAAgB;EOjvgFf,wDAAU;APmvgFb;AACA;EACE,wDAAwD;AOhvgFxD;APkvgFF;EOhvgFG,sCAAe;APkvgFlB;AACA;EOhvgFG,gBAAW;EPkvgFZ,oEAAoE;AOjvgFnE;APmvgFH;EOjvgFI,oEAA8B;APmvgFlC;AACA;EO5ugFI,gBAAA;AP8ugFJ;AACA;EACE,gBAAgB;AO1ugFd;AP4ugFJ;EO1ugFK,uBAAA;EP4ugFH,cAAc;EOrugFb,aAAA;EACC,eAAc;APuugFlB;AOlugFE;EACC,uBAAe;APougFlB;;AAEA;EOnugFI,gBLzXgB;AF8lhFpB;;AAEA;EO5tgFI,aAAA;EACC,mBAAW;AP+tgFhB;AACA;EOztgFI,kBAAA;AP2tgFJ;AACA;EACE,8BAA8B;EOttgFhC,iCAAiB;APwtgFjB;AACA;EOttgFC,+BAAkB;EAClB,kCAAyB;APwtgF1B;AACA;EACE,oCAAoC;EACpC,gBAAgB;EOttgFlB,kBAAe;EAGb,uBAAA;EACC,YAAY;APstgFf;AOptgFE;EACC,sBAAe;EACf,8BAAS;EACT,gCAAgB;APstgFnB;AACA;EOptgFG,4BAAU;EACV,+BLpcoB;AF0phFvB;AACA;EACE,6BAA6B;EOrtgF5B,gCAAA;APutgFH;AACA;EOltgFE,gBAAA;APotgFF;AACA;EOltgFG,eAAY;APotgFf;AACA;EOltgFG,uBAAgB;EPotgFjB,mBAAmB;AOhtgFnB;APktgFF;EOhtgFG,kDAAyB;APktgF5B;AACA;EACE,uBAAuB;EOhtgFvB,YAAA;APktgFF;AACA;EOhtgFG,qCAAiB;APktgFpB;;AAEA;EOjtgFG,yBAAA;EACC,YAAA;EPmtgFF,kBAAkB;EOltgFhB,yBAAA;EACC,gBAAgB;EPotgFnB,cAAc;AOltgFZ;;APqtgFJ,cOhtgFc;APitgFd;EO/sgFK,mBAAiB;APitgFtB;AACA;EO/sgFK,eAAe;EACf,SAAA;EPitgFH,gBAAgB;EO1tgFb,YAAA;ELhlBD,QAAO;EF6yhFT,UAAU;EOntgFP,gBAAA;EACC,8BLzcsB;EK0ctB,SAAA;APqtgFN;AACA;EO/sgFA,eAAA;APitgFA;AACA;EACE,gBAAgB;EO9sgFhB,SAAA;EPgtgFA,gBO/sgFa;EPgtgFb,2BAA2B;EAC3B,UAAU;EO1sgFT,gBAAA;AP4sgFH;AACA;EACE,iBAAiB;EACjB,yBAAyB;EQz0hF3B,gBAAA;ER20hFE,cAAc;AAChB;AACA;EQz0hFA,cAAA;EAEC,kBAAA;EJ6BO,iBAAA;EAIA,sBAAmB;EAYnB,qBAAc;AJgyhFtB;AQ10hFC;EACC,qBAAoB;AR40hFtB;AACA;EQ10hFE,gBAAW;AR40hFb;AACA;EQ10hFE,cAAS;EACT,mBAAY;EACZ,cAAc;EACd,iBAAY;EACZ,gBAAc;EJeR,mBAAoB;EAIpB,uBAAmB;EAYnB,kCAAoB;AJgzhF5B;AQ50hFE;EACC,4BAAc;AR80hFjB;AACA;EQ50hFE,cAAA;EACC,qBAAc;AR80hFjB;;AQ30hFI;EACC;IACA,eAAW;EACX;EACA;IR80hFD,aAAa;EQ10hFX;AR40hFN;AACA;EQ10hFO,mBAAS;EACT,mBAAa;AR40hFpB;;AAEA;;;qEQx0hF0B;AR40hF1B,0BAA0B;AQ30hFnB;ECRK,yBAXG;ATm2hFf;AQ70hFO;EAGC,aAAY;EACZ,iBAAc;ER+0hFpB,eAAe;EQ90hFT,MAAA;EACC,SAAS;ERg1hFhB,YAAY;EQ50hFN,cAAA;EACC,aAAU;EACV,+BAAW;EAGX,yBAAM;AR80hFf;AACA;EIh3hFQ,cAAA;EAIA,cAAiB;AJ+2hFzB;AACA;EIp2hFQ,eAAc;EAhBd,kBAAoB;AJu3hF5B;AACA;EACE,oBAAoB;EQj1hFb,mBAAA;EJxCD,cAAA;EAIA,gBAAmB;AJy3hF3B;AACA;EI92hFQ,kBAAc;EAhBd,aAAA;EAYA,mBAAiB;EAIjB,mBAAc;EJu3hFpB,eAAe;EQn1hFV,mBAAA;ARq1hFP;AACA;EAGE,gCAAgC;AQ90hF1B;ARg1hFR;EQv0hFQ,aAAO;ER20hFb,qBAAqB;AQx0hFjB;AR00hFN;EQx0hFO,iBAAiB;AR00hFxB;AQz0hFO;EACC,kBAAW;EACX,WAAU;EACV,WAAQ;EACR,gBAAU;EACV,mEAAU;EACV,oBAAM;EACN,iBAAS;EAUV,uBAAS;EJ3FR,yBAAmB;AJo6hF3B;AACA;EQ7zhFQ,0BAAS;ARm0hFjB;AQ7zhFG;EAMA,0BAAoB;AR8zhFvB;AACA;EQ5zhFG,yBAAc;AR8zhFjB;AACA;EQ5zhFG,aAAA;AR8zhFH;AACA;EACE,aAAa;AQ7zhFZ;AR+zhFH;EACE,yBAAyB;AQ7zhFxB;AR+zhFH;EQ7zhFI,kBAAS;EACT,iBAAa;AR+zhFjB;AACA;EQ7zhFI,WAAW;EACX,UAAA;ER+zhFF,yBAAyB;EQ5zhFrB,kBAAA;EACC,UAAA;ER8zhFL,MAAM;EQtzhFN,SAAA;EACC,YAAW;ARwzhFd;AQtzhFE;EACC,mBAAM;ERwzhFP,iCAAiC;EQtzhFjC,kBAAA;EAKA,0BAAA;ARszhFF;AACA;EQpzhFE,QAAA;ARszhFF;AACA;EQpzhFG,+BAAQ;ARszhFX;AACA;EQpzhFG,YAAS;ARszhFZ;AACA;EIl9hFQ,sBAAc;EI+JnB,aAAY;EACZ,cAAW;EACX,YAAY;EAKZ,mBNzGoB;EF+5hFrB,gBAAgB;AQjzhFX;ARmzhFP;EACE,cAAc;AQjzhFP;ARmzhFT;EQ1yhFS,aN9Fe;EF44hFtB,cAAc;EQpyhFd,mBAAA;EACC,YNjIiB;EFu6hFlB,8BAA8B;AQjyhFzB;ARmyhFP;EACE,mBAAmB;AQjyhFZ;ARmyhFT;EACE,cAAc;AQ5xhFR;AR8xhFR;EACE,OAAO;AACT;AQrxhFA;EAGG,YAAA;ARqxhFH;AACA;EACE,OAAO;AQjxhFT;ARmxhFA;EACE,eQjxhFW;ERkxhFX,OAAO;EQhxhFP,QAAA;ERkxhFA,SQjxhFC;ERkxhFD,MAAM;EQ/whFL,aAAA;ERmxhFD,0BQhxhFU;ERixhFV,iCQhxhFc;ERixhFd,UQhxhFS;ERixhFT,YIrhiFM;EJshiFN,WIlhiFM;EJmhiFN,mBI/giFwB;AJghiF1B;AACA;EACE,gBQpxhFe;ARqxhFjB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBQrxhFa;ARsxhFf;AACA;EQpxhFM,mBAAA;ARsxhFN;AACA;EQlxhFQ,WAAA;ARoxhFR;AACA;EQlxhFQ,+BAAA;ARoxhFR;AACA;EQlxhFU,mBAAA;ARoxhFV;;AAEA;EACE;IIniiFM,UAAY;EJqiiFlB;AACF;AACA;EACE;IQpxhFM,UAAA;ERsxhFN;EACA;IQrxhFO,kBAAA;ERuxhFP;EACA;IACE,OAAO;IQnxhFF,SAAA;IACC,QAAA;IRqxhFN,YAAY;IQjxhFP,WAAA;IAKC,wBAAqB;IACrB,gCAA+B;IRmxhFrC,eAAe;IQ/whFV,aAAA;ERixhFP;EACA;IQ/whFS,4BAAA;ERixhFT;EACA;IQhxhFU,UAAA;IACC,kBAAiB;IJjUtB,gBAAA;EJoliFN;EACA;IIzkiFM,8BAAuB;EJ2kiF7B;EACA;IQnxhFS,aAAA;ERqxhFT;EACA;IQnxhFU,gBAAK;ERqxhFf;EACA;IQ5whFW,wBAAmB;ERkxhF9B;EACA;IQ7whFO,kBAAA;ER+whFP;EACA;IQ3whFQ,SAAS;ER6whFjB;EACA;ISpmiFU,gBAPG;ILAP,oBI+VqB;ER+whF3B;EACA;IInmiFM,eImVqB;ERkxhF3B;EACA;IQjxhFQ,uBAAqB;INzV5B,gBAAY;IM2VL,kBAAS;IACT,UAAU;IRmxhFhB,qBAAqB;IQ9whFf,yBAAA;ERgxhFR;EACA;II1niFM,eAAA;EJ4niFN;EACA;IIjniFM,sBIkWsB;ERixhF5B;EACA;IQlwhFM,iBAAA;IRwwhFJ,yBAAyB;EAC3B;EU1qiFF;IV4qiFI,iBAAiB;IACjB,UAAU;IACV,MAAM;IU1qiFV,kBAAA;EAEC;EN6BO;IAIA,oBAAmB;EAYnB;EJioiFN;IU3qiFD,qBAAA;IACC,WAAS;EACT;EACA;IACA,cAAW;IACX,8BAAe;IACf,YAAM;IAGN,kGAAc;INiCR,wCAAoB;IMiI1B,qBAAA;IVkhiFE,gEAAgE;IU/qiFlE,SAAA;IACC,eAAc;EACd;EViriFD;IU/qiFA,UAAA;IACC,UAAQ;IAKN,kCAAmB;EACnB;EACA;IViriFD,gBAAgB;EU7qiFd;EACC;IACA,mBAAoB;EACpB;AV+qiFP;AACA;;;qEU3qiFyB;AV+qiFzB,wBU9qiFqB;AV+qiFrB;ESvriFI,yBAXW;ATssiFf;AACA;EU9qiFQ,aAAS;EACT,iBAAS;EACT,eAAY;EACZ,MAAA;EVkriFN,SAAS;EUjriFH,YAAA;EACC,cAAU;EVmriFjB,aAAa;EU/qiFP,+BAAA;EAGC,yBAAW;EACX,mBAAgB;EAChB,uBAAM;AViriFf;AACA;EIntiFQ,cAAA;EAIA,cAAiB;AJktiFzB;AACA;EIvsiFQ,eAAc;EAhBd,kBAAoB;AJ0tiF5B;AACA;EACE,oBAAoB;EUpriFb,mBAAA;ENxCD,cAAA;EAIA,gBAAmB;AJ4tiF3B;AACA;EIjtiFQ,kBAAc;EAhBd,aAAA;EAYA,mBAAiB;EAIjB,mBAAc;EJ0tiFpB,eAAe;EUtriFV,mBAAA;AVwriFP;AACA;EUlriFO,kCAAA;ERxFH,yBAAY;EQ0FR,qBAAO;AVoriFf;AACA;EU/qiFO,gCAAiB;AVmriFxB;AUlriFO;EAGC,aAAQ;EACR,qBAAkB;AVoriF1B;AACA;EUlriFQ,iBAAS;AVoriFjB;AACA;EU7qiFM,kBAAA;EACC,WAAW;EACX,WAAS;EACT,gBAAQ;ENtFP,mEAA4B;EAI5B,oBAAmB;EAYnB,iBAAc;EMiFf,uBAAA;EAOJ,yBAAA;AVwqiFH;AACA;EUjqiFG,0BAAa;AVuqiFhB;AACA;EAKE,0BAA0B;AUtqiFzB;AVwqiFH;EACE,yBAAyB;AUtqiFxB;AVwqiFH;EUtqiFI,mCAAoB;EACpB,yBAAa;EACb,qBAAc;AVwqiFlB;AACA;EUtqiFI,kBAAiB;EVwqiFnB,iBAAiB;AUrqiFb;AVuqiFN;EACE,WAAW;EUhqiFX,UAAA;EACC,yBAAc;EACd,kBAAgB;EVkqiFjB,UAAU;EU9piFV,MAAA;EACC,SAAS;EVgqiFV,YAAY;AU5piFZ;AV8piFF;EACE,mBAAmB;EU5piFnB,iCAAA;EACC,kBAAM;EAGN,0BAAY;AV8piFf;AU1piFE;EACC,QAAO;AV4piFV;AU1piFE;EACC,+BAAe;AV4piFlB;AACA;EU1piFG,YAAS;AV4piFZ;AACA;EIt0iFQ,yBAAsB;EF7B1B,aAAY;EQ2Mb,cAAU;EACV,YAAY;EVgqiFb,mBAAmB;EU1piFnB,gBAAA;AV4piFF;AACA;EUvpiFO,cAAA;AVypiFP;AACA;EAGE,aAAa;EUlpiFP,cAAA;EACC,mBR9F4B;EFkviFnC,YAAY;EU1oiFZ,8BAAA;AV4oiFF;AACA;EUvoiFO,mBAAA;AVyoiFP;AACA;EUvoiFS,cAAA;ERnPL,qBAAO;AF63iFX;AUloiFQ;EACC,aR1He;AF8viFxB;AACA;EU3niFA,cAAA;AV6niFA;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO;AACT;AACA;EACE,eAAe;EUvniFd,OAAA;EVyniFD,QUxniFO;EVyniFP,SAAS;EUvniFR,MAAA;EVyniFD,aUxniFa;EV2niFb,0BUxniFiB;EVyniFjB,iCAAiC;EUtniF7B,UAAA;EVwniFJ,YUvniFc;EVwniFd,WAAW;EUrniFN,mBAAA;AVuniFP;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WIh5iFM;AJi5iFR;AACA;EACE,+BIv4iF0B;AJw4iF5B;AACA;EACE,mBU7miFe;AV8miFjB;;AAEA;EACE;IU5miFK,kBAAa;EV8miFlB;EU3miFK;IACC,WAAS;EV6miFf;EU1miFM;IACC,OAAA;EV4miFP;EU1miFM;IACC,iBAAW;EV4miFlB;EUzmiFK;IACC,UAAS;EV2miFf;EACA;IUxmiFI,WAAA;EV0miFJ;EACA;IUnmiFO,aAAA;EVqmiFP;EACA;IU7liFC,aAAA;EV+liFD;EACA;IU7liFE,kBAAQ;IACR,cAAY;EV+liFd;EACA;IW79iFF,cAAA;EX+9iFE;EACA;IACE,aAAa;EW79iFjB;EAEC;IACC,aAAa;EP4BP;EAIA;IAYA,aAAc;EJq7iFpB;EW99iFD;IAME,yBAAoB;EACpB;EACA;IACA,YAAU;EACV;EACA;IAGA,aAAc;EACd;EACA;IPSK,cAAA;EAIA;EAYA;IOsCL,mBAAoB;EXo6iFrB;EWh+iFC;IACC,WAAU;EACV;EXk+iFF;IW/9iFE,aAAc;EACd;EXk+iFF;IW/9iFI,cAAA;EACC;EACA;IACA,eAAS;EACT;EACA;IACA,UAAA;IACA,SAAW;IACX,QAAQ;IACR,kBAAc;EACd;AXi+iFP;AWh+iFO;;;oEAGa;AXk+iFpB,6BWj+iF6B;AXk+iF7B;EWj+iFQ,iBAAA;EAMD,yBAAA;AXg+iFP;AACA;EW19iFO,UAAA;AX49iFP;AACA;EWp9iFG,aAAA;EACC,iBAAS;EACT,eAAS;EACT,OAAO;EACP,MAAA;EACA,SAAQ;EACR,WAAA;EACA,cAAc;EACd,aAAa;EXw9iFf,+BAA+B;EAG/B,yBAAyB;EWr9iFxB,mBAAA;AXu9iFH;AACA;EACE,cAAc;EWp9iFd,cAAA;AXs9iFF;AACA;EWp9iFG,eAAa;EACb,kBAAiB;AXs9iFpB;AACA;EWp9iFG,kBAAS;EAGT,aAAa;EAGb,mBAAc;EPzET,mBAAsB;EAItB,eAAiB;EAIjB,mBAAkB;AJ0hjF1B;AACA;EInhjFQ,aAAc;EJuhjFpB,qBAAqB;AW39iFpB;AX69iFH;EW39iFI,iBAAc;AX69iFlB;AW39iFG;EACC,yBAAc;AX69iFlB;AACA;EW39iFK,mCAAA;EACC,yBAAoB;EACpB,qBAAmB;AX69iFzB;AACA;EACE,sBAAsB;EWv9iFhB,aAAS;EACT,YAAS;EAGT,mBAAgB;AX29iFxB;AACA;EWz9iFQ,SAAO;AX29iFf;AACA;EW19iFQ,cAAA;EFlGJ,qBAXW;AT0kjFf;AACA;EW19iFS,aAAS;EACT,iBAAS;EACT,eAAY;EACZ,MAAA;EX89iFP,SAAS;EW79iFF,UAAA;EACC,YAAU;EX+9iFlB,cAAc;EW39iFP,aAAA;EACC,gBAAU;EACV,+BAAW;EAKX,2BAAiB;EPnHnB,yBAAkB;AJmljF1B;AACA;EI5ljFQ,cAAA;EAIA,cAAA;AJ2ljFR;AACA;EWh+iFU,eAAA;EPhIF,kBAAoB;AJmmjF5B;AACA;EIxljFQ,oBAAiB;EAIjB,mBAAc;EJuljFpB,cAAc;EWj+iFP,gBAAA;AXm+iFT;AACA;EIlmjFQ,kBAAkB;EJsmjFxB,aAAa;EAGb,mBAAmB;EW99iFb,mBAAA;EACC,eAAO;EXg+iFd,mBAAmB;AW79iFd;AX+9iFP;EW59iFQ,gCAAA;AXg+iFR;AACA;EW59iFS,aAAU;EACV,qBAAM;AXg+iFf;AACA;EACE,iBAAiB;AWz9iFZ;AX29iFP;EWz9iFQ,kBAAS;EACT,WAAQ;EP5KR,WAAA;EAIA,gBAAiB;EAYjB,mEAAoB;EJ0njF1B,oBAAoB;EW39iFb,iBAAA;EXi+iFP,uBAAuB;EAGvB,yBAAyB;AWj9iFxB;AXm9iFH;EW78iFI,0BAAgB;AXm9iFpB;AACA;EW98iFM,0BAAc;AXo9iFpB;AWj9iFG;EACC,yBAAa;AXm9iFjB;AW78iFG;EPxNK,yBAAsB;AJwqjF9B;AACA;EI7pjFQ,kBAAiB;EAIjB,iBAAc;AJ4pjFtB;AW78iFG;EACC,WAAU;EX+8iFZ,UAAU;EW18iFJ,yBAAA;EACC,kBTrJsB;EFimjF7B,UAAU;EW18iFF,MAAA;ETjQN,SAAO;EF8sjFT,YAAY;AWr8iFL;AXu8iFT;EACE,mBAAmB;EW/7iFlB,iCAAA;EACC,kBT7KmB;ESmLd,0BT/KsB;AF6mjF/B;AW57iFU;ET3RN,QAAO;AF0tjFX;AWv7iFS;EACC,+BTlK2B;AF2ljFrC;AW76iFG;EACC,YTvMgB;AFsnjFpB;AW16iFQ;EACC,iBTjNc;EAtGnB,aAAO;EFsujFT,cAAc;EWr6iFP,gBAAA;EACC,YThMc;ESyMpB,mBR5TU;AH6tjFd;AW55iFQ;EACC,cT3Oc;AFyojFvB;AW55iFU;ETnVN,aAAO;AFkvjFX;AWv5iFS;EAcP,uBAAA;AXg5iFF;AACA;EW94iFE,gBAAA;AXg5iFF;AACA;EW74iFG,cAAA;AX+4iFH;AACA;EW74iFG,4BAAA;AX+4iFH;AACA;EW14iFI,mBAAA;AX44iFJ;AACA;EW14iFI,gBAAA;AX44iFJ;AACA;EWz4iFG,cAAA;AX24iFH;AACA;EACE,4BW14iFU;AX24iFZ;AACA;EACE,mBW14iFe;AX24iFjB;AACA;EACE,mBW14iFa;AX24iFf;AACA;EY/xjFA,WAAA;AZiyjFA;AACA;EACE,+BAA+B;AY/xjFjC;AAEC;ER6BO,mBAAoB;AJowjF5B;AACA;EACE,mBAAmB;AYhyjFpB;AZkyjFD;EYhyjFE,WAAS;AZkyjFX;AACA;EYhyjFE,+BAAe;AZkyjFjB;AACA;EYhyjFE,mBAAY;AZkyjFd;;AAEA;EIlxjFQ;IAIA,cAAiB;EAYjB;EJswjFN;IYlyjFA,OAAA;EACC;EACA;IZoyjFC,WAAW;EYlyjFb;EACC;IACA,OAAQ;EZoyjFT;EYlyjFE;IACC,OAAS;EACT;EACA;IACA,UAAW;EZoyjFd;EYhyjFI;IACC,eAAS;IACT,OAAS;IACT,QAAS;IACT,SAAS;IACT,MAAA;IACA,aAAc;IACd,iCAAmB;IACnB,YAAQ;IACR,WAAO;EACP;AZkyjFP;AYjyjFO;;;qEHnB+B;ATyzjFtC,sBAAsB;AYnyjFf;EAGC,yBAAY;AZqyjFpB;AACA;EAGE,aAAa;EYlyjFP,iBAAA;EACC,eAAU;EACV,MAAK;EACL,SAAS;EACT,YAAS;EACT,cAAM;EACN,aAAA;EACA,+BAAiB;ER3BlB,yBAAkB;AJk0jF1B;AACA;EI30jFQ,cAAA;EAIA,cAAA;AJ00jFR;AACA;EYvyjFS,eAAA;ERxCD,kBAAoB;AJk1jF5B;AACA;EIv0jFQ,oBAAiB;EAIjB,mBAAc;EJs0jFpB,cAAc;EYxyjFR,gBAAA;AZ0yjFR;AACA;EIj1jFQ,kBAAkB;EJq1jFxB,aAAa;EAGb,mBAAmB;EYtyjFb,mBAAA;EACC,eAAa;EZwyjFpB,mBAAmB;AYpyjFb;AZsyjFR;EY7xjFQ,gCAAyB;AZiyjFjC;AY9xjFM;EZkyjFJ,aAAa;EY/xjFR,qBAAA;AZiyjFP;AACA;EY/xjFQ,iBAAQ;AZiyjFhB;AACA;EY/xjFQ,kBAAM;EACN,WAAS;EACT,WAAO;EZiyjFb,gBAAgB;EY1xjFZ,mEAAA;EACC,oBAAmB;EACnB,iBAAS;EZgyjFd,uBAAuB;EAGvB,yBAAyB;AYvxjFpB;AZyxjFP;EY9wjFE,0BAAA;AZoxjFF;AACA;EY9wjFG,0BAAyB;AZoxjF5B;AACA;EYlxjFG,yBAAgB;AZoxjFnB;AYnxjFG;EACC,aAAa;AZqxjFjB;AYnxjFG;EACC,aAAS;AZqxjFb;AACA;EYnxjFI,yBAAc;AZqxjFlB;AACA;EYnxjFI,kBAAiB;EZqxjFnB,iBAAiB;AYlxjFb;AZoxjFN;EACE,WAAW;EY5wjFX,UAAA;EACC,yBAAc;EZ8wjFf,kBAAkB;EY5wjFlB,UAAA;EACC,MAAK;EZ8wjFN,SAAS;EY5wjFT,YAAA;AZ8wjFF;AACA;EY1wjFE,mBAAA;EACC,iCAAO;EZ4wjFR,kBAAkB;EYxwjFjB,0BAAO;AZ4wjFV;AACA;EY1wjFG,QAAM;AZ4wjFT;AACA;EIn7jFQ,+BAAyB;AJq7jFjC;AACA;EY5wjFG,YAAU;AZ8wjFb;AACA;EY5wjFG,sBAAmB;EAIpB,aAAa;EZ6wjFb,cAAc;EYzwjFb,YAAA;EAMK,mBAAA;EACC,gBV/GsB;AFu3jF/B;AYtwjFU;EV3NN,cAAO;AFo+jFX;AYjwjFS;EAWN,aAAA;EACC,cVrIgB;EFg4jFlB,mBAAmB;EYtvjFb,YAAA;EACC,8BV/Ic;AFu4jFvB;AYtvjFU;EVvPN,mBAAO;AFg/jFX;;;AAGA;EACE,cAAc;AYzujFhB;AZ2ujFA;EACE,OYxujFE;AZyujFJ;AACA;EYrujFA,YAAA;AZuujFA;AACA;EACE,OYpujFO;AZqujFT;AACA;EACE,eIn+jFM;EJo+jFN,OIh+jFM;EJi+jFN,QI79jFM;EJ89jFN,SI19jFM;EJ29jFN,MYxujFE;EZyujFF,aAAa;EAGb,0BAA0B;EYxujFxB,iCAAA;EZ0ujFF,UYzujFU;EZ0ujFV,YYzujFa;EZ0ujFb,WYzujFG;EZ0ujFH,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BI5/jFyB;AJ6/jF3B;AACA;EACE,mBIn/jFoB;AJo/jFtB;AACA;EACE,mBYxujFgB;AZyujFlB;AACA;EACE,WYzujFgB;AZ0ujFlB;AACA;EACE,+BY1ujFwB;AZ2ujF1B;AACA;EYvujFS,mBAAA;AZyujFT;;AAEA;EACE;IYvujFQ,UAAA;EZyujFR;AACF;AACA;EACE;IACE,8BAA8B;IYrujFvB,WAAA;IACC,gBAAS;IRjTb,wBAAmB;IAInB,SAAA;EJ0hkFN;EACA;IACE,4BAA4B;EYzujFrB;EZ2ujFT;IYzujFU,UAAS;IACT,kBAAK;IACL,gBAAU;EZ2ujFpB;EYzujFW;IACC,8BAAoB;EZ2ujFhC;EYtujFU;IACC,aAAK;EZwujFhB;EACA;IYnujFO,gBAAA;EZqujFP;EACA;IIpjkFM,wBQqVqB;EZqujF3B;EACA;II/ikFM,kBQyUqB;EZwujF3B;EACA;IYvujFQ,SAAA;EZyujFR;EACA;IYvujFQ,gBAAe;IZyujFrB,oBAAoB;EYpujFd;EZsujFR;IYlujFS,uBAAU;IRnWb,gBAAA;IAIA,kBQgWsB;IR5VtB,UAAA;IAIA,qBQwVsB;IRpVtB,yBQoVsB;EZwujF5B;EYttjFO;IACC,eV1SO;EFkgkFf;EY1sjFO;IACC,sBVrTqB;EFigkF7B;EACA;IatnkFF,iBAAA;IAOC,yBAAW;EACV;EACA;IACA,iBAAS;IACT,UAAS;IACT,MAAA;IACA,kBAAM;EACN;EACA;IACA,oBAAS;EACT;EACA;IACA,qBX6FqB;IE7Ef,WAAA;EAIA;EAYA;IJylkFJ,cAAc;IavnkFhB,8BAAA;IACC,YAAQ;IAGR,kGAAoB;IAKpB,wCAA8B;IAE9B,qBAAe;IbynkFd,gEAAgE;IaxnkFjE,SAAA;IACC,eAAc;EACd;EACA;Ib0nkFA,UAAU;IaxnkFX,UAAA;IAKC,kCAAyB;EACzB;EACA;Ib0nkFA,gBAAgB;EavnkFhB;EACC;IACA,mBAAe;EACf;AbynkFL;AatnkFG;;;oEb0nkFiE;AavnkFhE,SAAA;AbynkFJ;EACE,eAAe;EAGf,aAAa;EatnkFZ,iBAAA;EACC,MAAA;EbwnkFF,aAAa;EarnkFb,YAAA;EACC,SAAQ;EACR,aAAM;EbunkFP,YAAY;EatnkFX,gBAAA;EAEC,yBAAA;AbynkFJ;AACA;EavnkFK,wBAAS;EACT,gCAAe;EAKjB,aAAQ;EbynkFT,mBAAmB;EarnkFnB,8BAAA;EACC,sCAAW;EACX,4BAAc;AbunkFjB;AarnkFE;EACC,eAAY;EACZ,cAAa;EbunkFd,gBAAgB;AarnkFhB;AbunkFF;EACE,iBAAiB;EAGjB,aAAa;EAGb,mBAAmB;Aa9mkFlB;AbgnkFH;EACE,kBAAkB;Ea5mkFjB,yBAAA;EACC,gBAAc;Ab8mkFlB;Aa1mkFG;ETrFK,mBAAoB;EAIpB,gBAAiB;AJ+rkFzB;AACA;Ea3mkFI,WAAA;Ab6mkFJ;AACA;EazmkFI,WAAA;Ab2mkFJ;AACA;EatmkFC,gBAAA;AbwmkFD;AACA;EatmkFE,cAAW;EACX,cXvBkB;AF+nkFpB;AACA;EatmkFE,qCAAM;AbwmkFR;AACA;EACE,kBAAkB;EatmkFpB,WAAA;EAII,SAAA;EbqmkFF,eapmkFgB;AbqmkFlB;AACA;EACE,wBalmkFkB;EbmmkFlB,gBAAgB;Ea/lkFd,6BAAA;AbimkFJ;AACA;EACE,YIhtkFkB;EJitkFlB,+BAA+B;AACjC;AACA;EACE,aAAa;Ea9lkFV,8BAAA;AbgmkFL;AACA;EACE,SAAS;Ac1wkFX;Ad4wkFA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EAGE,yBAAyB;AAC3B;Ac1wkFA;EACA,WAAc;Ad4wkFd;AACA;Ec1wkFC,YAAO;Ad4wkFR;AACA;EIjvkFQ,kBAAc;EJmvkFpB,YAAY;Ec7wkFb,WAAA;EACC,mBAAS;EACT,aAAS;EACT,aAAa;EACb,MAAM;EACN,OAAA;Ad+wkFF;;AAEA;EIxwkFQ;IAYA,cAAc;EJ+vkFpB;EchxkFA;IACC,eAAc;EACd;EACA;IAGA,yBAAa;EACb;EACA;IACA,OAAQ;EACR;EACA;IACA,QAAO;EACP;AdkxkFH;AcjxkFG;;;;;;;;;;;;;;;;;oEAgBsB;AdoxkFzB,UcnxkFY;AdoxkFZ;EclxkFK,kBAAiB;EACjB,gBAAgB;EAChB,0BAAmB;EAElB,4BAAiB;AdqxkFvB;AACA;EcjxkFM,aAAK;EdqxkFT,YAAY;EclxkFV,kBAAA;EACC,gBAAa;EdoxkFhB,OAAO;EAGP,yBAAyB;AcjxkFxB;AdmxkFH;EcjxkFI,+BAAO;EACP,gBAAY;EACZ,kBAAc;EAEd,aAAA;EACC,iBAAc;EdoxkFjB,YAAY;EclxkFV,UAAA;EACC,OAAA;EdoxkFH,aAAa;EcjxkFR,YAAA;EACC,cAAO;AdmxkFf;Ac9wkFI;EAEC,aAAA;EAGC,mBAAc;EdixkFlB,8BAA8B;EchxkF1B,sCAAA;EACC,4BAAe;EdkxkFpB,YAAY;EchxkFR,kBAAA;EACC,gCAAqB;EACrB,gBAAc;EVjFb,cAAA;AJo2kFR;AACA;EchxkFO,aAAa;EAGb,mBAAa;AdoxkFpB;AACA;EcnxkFO,iBAAA;EACC,gBAAS;EACT,gBAAa;AdqxkFrB;AACA;EcnxkFQ,MAAA;AdqxkFR;AcnxkFO;EACC,oBAAoB;AdqxkF5B;AACA;EcnxkFQ,eAAY;AdqxkFpB;AcpxkFQ;EAEC,SAAO;EdsxkFd,YAAY;EcrxkFL,cAAA;EduxkFP,gBAAgB;AAClB;AACA;EcpxkFU,sBAAe;AdsxkFzB;AACA;EcpxkFS,sBAAA;AdsxkFT;AACA;EcpxkFU,eAAe;AdsxkFzB;AcnxkFQ;EACC,iBAAgB;AdqxkFzB;AACA;EcnxkFS,UAAS;EACT,YAAS;EACT,qBAAiB;AdqxkF1B;AACA;EcnxkFS,gBAAe;AdqxkFxB;AACA;EcnxkFS,qBAAqB;EACrB,qBAAY;EAEX,qBAAkB;EAGnB,mBAAA;EAGA,aAAA;EACC,eAAS;AdsxkFnB;AACA;EcpxkFU,kBAAS;EVhJX,kBAAoB;EJy6kF1B,aAAa;AcpxkFR;AdsxkFP;EcjxkFW,aAAS;EACT,YAAW;AdqxkFtB;AcnxkFU;EdqxkFR,YAAY;EACZ,SAAO;AACT;AACA;;;EIr6kFQ,gBAAc;EJy6kFpB,uBAAuB;EchxkFf,mBAAA;AdkxkFV;AACA;Ec9wkFQ,cAAA;EACC,gBAAgB;EdgxkFvB,qBAAqB;Ac7wkFZ;Ad+wkFX;EACE,iBAAiB;EcvwkFd,kBAAA;EAEC,aAAA;EACC,iBZtFa;EFg2kFlB,8BAA8B;EcrwkF3B,sCAAA;EACC,4BAAc;EAMlB,qBAAA;EACC,aAAS;AdowkFZ;AACA;EclwkFG,kBAAW;EACX,cAAW;AdowkFd;AACA;EclwkFG,kBAAU;AdowkFb;AcnwkFG;EACC,UAAS;EACT,kBAAS;EACT,kBAAa;EACb,SAAA;EAGA,gCAA8B;AdqwkFlC;AACA;EcnwkFI,yBAAW;AdqwkFf;AACA;EcnwkFI,UAAA;EdqwkFF,mBAAmB;AcpwkFjB;AdswkFJ;;;EclwkFI,UAAA;EACC,kBAAiB;EdwwkFpB,gCAAgC;AcrwkF7B;AduwkFL;EcrwkFM,cAAS;AduwkFf;AACA;EcrwkFM,yBAAyB;AduwkF/B;AACA;EcrwkFM,cAAa;AduwkFnB;AcpwkFM;EACC,gBAAe;AdswkFtB;AACA;EcpwkFO,mBAAe;AdswkFtB;AcpwkFM;EACC,eAAW;EdswkFhB,gBAAgB;AcpwkFZ;AdswkFN;EclwkFO,aAAW;EdswkFhB,YAAY;EclwkFV,iBAAA;EACC,YAAS;EACT,gBAAS;EACT,WAAS;AdowkFd;AcnwkFK;EAKF,aAAA;EV9PK,mBAAc;EUgQlB,8BAAW;EACX,sCAAO;EACP,4BAAY;EACZ,YAAU;EdqwkFZ,kBAAkB;EcpwkFhB,gBAAA;EACC,gCAAS;AdswkFd;AACA;EACE,aAAa;EcnwkFV,qBAAA;AdqwkFL;AACA;EclwkFO,mBAAS;AdswkFhB;AACA;EcpwkFO,kBAAgB;EAEhB,aAAA;EAGC,mBAAS;EACT,kBAAiB;AduwkFzB;ActwkFQ;EACC,eZxNsB;EFg+kF7B,gBAAgB;EctwkFV,cAAA;EACC,0BAAa;AdwwkFtB;AACA;EctwkFS,mBAAkB;AdwwkF3B;AACA;EcrwkFO,gBAAA;EACC,uBAAkB;EduwkFxB,mBAAmB;EcrwkFd,gBAAA;AduwkFP;AACA;EcnwkFQ,aAAa;AduwkFrB;AACA;EACE,mBAAmB;ActwkFb;AdwwkFR;EclwkFS,yBAAS;EAIZ,SAAA;EACC,YAAS;EACT,cAAS;AdowkFhB;AACA;EclwkFO,UAAS;EdowkFd,cAAc;EclwkFR,qBAAA;AdowkFR;AACA;EcnwkFS,oBAAA;AdqwkFT;AACA;EclwkFU,aAAA;EAGC,mBAAgB;AdswkF3B;AACA;EcpwkFW,qBAAgB;EdswkFzB,sBAAsB;EcpwkFd,qBAAA;EACC,kBAAU;AdswkFrB;AACA;EcnwkFS,cAAA;AdqwkFT;AACA;EcnwkFU,cAAO;EACP,yBAAM;EACN,kBAAY;EACZ,kBAAW;EACX,WZ5Ra;AFiilFvB;AACA;EcnwkFU,kBAAS;AdqwkFnB;AACA;EcnwkFU,iBAAiB;EACjB,UAAA;EAGA,aAAA;EACA,UAAA;EdqwkFR,kCAAkC;AclwkF1B;AdowkFV;EACE,aAAa;AchwkFL;AdkwkFV;EACE,UAAU;Ac9vkFJ;AdgwkFR;EcxvkFS,aAAS;EACT,eAAA;Ad6vkFT;AACA;EACE,eAAe;AcxvkFR;Ad0vkFT;EclvkFM,mBAAc;AdsvkFpB;AcnvkFQ;EACC,cAAW;EdqvkFlB,gBAAgB;EclvkFT,gBAAA;EACC,uBAAsB;EdovkF9B,mBAAmB;Ec9ukFhB,gBAAA;AdgvkFL;AACA;Ec/ukFM,mBAAA;EACC,kBAAa;AdivkFpB;AACA;Ec/ukFO,kBAAa;EACb,UAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAwB;EACxB,sBAAqB;EAEpB,aAAA;EAEA,mBAAA;EACC,uBZjUmB;EFojlF1B,+BAA+B;EclvkFxB,qBAAA;AdovkFT;AACA;EclvkFS,UAAA;AdovkFT;AACA;EchvkFS,aAAA;AdkvkFT;AACA;Ec/ukFQ,aAAA;AdivkFR;AACA;EACE,UAAU;Ac5ukFP;Ad8ukFL;EACE,sBAAsB;Ec7ukFlB,gBAAA;Ad+ukFN;AACA;EACE,iCAAiC;Ac3ukF/B;Ad6ukFJ;Ec3ukFK,sBAAkB;Ad6ukFvB;AACA;Ec3ukFK,mBAAiB;Ad6ukFtB;AACA;Ec5ukFK,yBAAA;Ad8ukFL;AACA;Ec5ukFM,sBAAW;Ad8ukFjB;AACA;Ec5ukFM,cAAQ;EAGT,aAAA;EACC,yBZjY6B;EYkY7B,iCAAW;EACX,uBAAW;EAEX,sBAAkB;EdgvkFtB,qBAAqB;Ac5ukFlB;Ad8ukFL;Ec3ukFM,2BAAU;Ad8ukFhB;AACA;EACE,mBAAmB;Ac3ukFjB;Ad6ukFJ;Ec3ukFK,WAAS;Ad6ukFd;AACA;Ec3ukFK,WAAA;Ad6ukFL;AACA;Ec3ukFK,0BAAO;Ad6ukFZ;AACA;Ec1ukFG,cAAA;EACC,kBAAS;Ad4ukFb;AACA;Ec1ukFI,uBAAmB;Ad4ukFvB;AACA;Ec1ukFI,qBAAS;EACT,oBZ9bmB;AF0qlFvB;AACA;Ec1ukFI,kBAAiB;EV9gBb,kBAAoB;EAIpB,gBAAiB;EAYjB,mBAAc;EJ6ulFpB,kBAAkB;Ec7ukFhB,0BAAA;Ad+ukFJ;AACA;Ec7ukFI,mBAAA;EACC,WAAU;Ed+ukFb,WAAW;Ec9ukFR,UAAA;EACC,kBAAgB;EdgvkFpB,QAAQ;Ec5ukFP,WAAA;Ad8ukFH;AACA;Ec5ukFI,mBAAa;EACb,WAAO;EACP,WAAW;EACX,SAAS;EACT,kBAAW;EACX,QAAQ;EACR,WAAU;Ad8ukFd;AACA;EI9wlFQ,qBAAmB;EAYnB,gBAAc;EJqwlFpB,UAAU;Ec/ukFR,kBAAA;EACC,kBAAe;AdivkFpB;Ac/ukFI;EAGC,aZ3de;EY8df,mBAAe;EdivkFlB,uBAAuB;EchvkFpB,2BAAA;EAmBC,iBAAc;AdgukFpB;AclvkFM;EAGC,aAAS;EAGT,mBAAgB;EAChB,wBAAmB;EdovkFxB,gBAAgB;EcnvkFX,6BAAA;EACC,gBAAS;EACT,kBAAS;EduvkFf,yBAAyB;AcpvkFnB;AdsvkFR;EACE,cAAc;Ac/ukFZ;AdivkFJ;EACE,WAAW;AchvkFR;AdkvkFL;EACE,iBAAiB;AclvkFb;AdovkFN;EACE,kBAAkB;EcjvkFd,SAAA;EACC,aAAa;EdmvkFlB,YAAY;Ec/ukFV,cAAA;EACC,SAAQ;EACR,YAAY;EdivkFf,YAAY;EchvkFT,gBAAA;EACC,8BAAc;EVllBZ,yBAAmB;AJu0lF3B;AACA;EACE,gBAAgB;AcnvkFZ;AdqvkFN;EACE,kBAAkB;EcnvkFd,gBAAA;EACC,cAAA;AdqvkFP;AACA;EACE,eAAe;AcpvkFV;AdsvkFP;EACE,sBAAsB;AcpvkFf;AdsvkFT;EACE,cAAc;EchvkFR,aAAS;EAGT,mBAAgB;AdovkFxB;AACA;EchvkFU,aAAY;EACZ,mBAAW;AdovkFrB;AACA;EcjvkFQ,mBAAA;AdmvkFR;AACA;EcjvkFS,eAAe;AdmvkFxB;AACA;EACE,sBAAsB;AcjvkFhB;AdmvkFR;EcjvkFS,cAAU;AdmvkFnB;Ac/ukFM;EACC,qBAAiB;AdivkFxB;Ac9ukFS;EACC,gBZjhBkB;EFiwlF1B,eAAe;Ac9ukFR;AdgvkFT;EACE,cAAc;EcnukFb,qBAAA;EAGA,qBAAA;EACC,qBAAO;AdqukFX;AcnukFG;EACC,gBAAa;AdqukFjB;AchukFE;EAEC,mBAAA;AdmukFH;AACA;EclukFI,kBAAA;AdoukFJ;AACA;EclukFK,kBAAU;AdoukFf;AclukFI;EAGC,aAAY;EdsukFf,mBAAmB;EcjukFlB,YAAA;AdmukFH;AACA;EcjukFI,YAAW;EAEX,SAAO;AdmukFX;AcjukFG;EACC,cAAY;EACZ,gBAAY;EACZ,uBAAuB;EdmukFzB,mBAAmB;EclukFjB,gBAAA;AdoukFJ;AACA;EclukFK,kBAAkB;EdoukFrB,mBAAmB;AcjukFlB;AdmukFH;EcjukFI,yBAAM;AdmukFV;AACA;EcjukFI,cAAY;AdmukFhB;AACA;EclukFI,cAAA;AdoukFJ;AACA;Ec/tkFC,mBAAA;AdiukFD;AACA;EchukFE,QAAA;AdkukFF;AACA;EchukFG,mBAAa;AdkukFhB;AACA;EchukFG,+BAAmB;AdkukFtB;AACA;EchukFG,uBAAe;AdkukFlB;AACA;EcjukFG,kBAAA;EACC,WZlpBgB;EYmpBhB,mBAAe;AdmukFnB;AACA;EAGE,aAAa;EACb,cAAc;Ec9tkFhB,kBAAK;AdgukFL;AACA;Ec9tkFI,aAAA;EACA,mBAAW;EACX,iBAAiB;EdgukFnB,uBAAuB;EACvB,iBAAiB;Ac/tkFnB;AdiukFA;Ec/tkFI,aAAA;EACA,iBAAA;EACE,uBAAW;AdiukFjB;AACA;EACE,WAAW;EchukFb,YAAO;EACH,kBAAU;AdkukFd;AACA;EchukFK,eAAW;EACX,MAAA;EdkukFH,SAAS;EACT,OAAO;EcjukFT,gBAAA;EACM,gBAAG;AdmukFT;AACA;EcnukFK,gBAAI;AdqukFT;AACA;EcrukFI,eAAK;AduukFT;AACA;EcrukFM,aAAG;EACJ,mBAAI;Ed2ukFP,8Bc3ukFmB;Ed4ukFnB,sCAAsC;Ec3ukFpC,4BAAK;Ed6ukFP,sBc7ukFmB;Ad8ukFrB;AACA;Ec7ukFA,cAAA;EAII,gBAAA;Ad4ukFJ;;AAEA;EczukFK,aAAA;Ad2ukFL;;AAEA;EACE,UcxukFQ;EdyukFR,oCAAoC;EcpukFlC,6BAAA;EdsukFF,4BcrukFW;EdsukFX,qBAAqB;AACvB;;AAEA;EcpukFI,UAAA;EdsukFF,oCcrukFqB;EdsukFrB,6BAA6B;EAC7B,4BAA4B;EclukF7B,qBAAW;AdoukFZ;;AAEA;EACE,UcpukFQ;EdqukFR,oCAAoC;EACpC,6BAA6B;EclukF/B,4BAA2B;EAC1B,qBAAA;AdoukFD;AAaA;Ec5tkFI;IACC,UAAA;Ed8tkFH;EACA;Ic1tkFD,UAAA;EACA;Ed4tkFC;Ic1tkFA,UAAU;Ed4tkFV;AACF;AACA;EACE;Ic1tkFF,aAAA;IAGG,YAAA;Ed0tkFD;EACA;IACE,WAAW;EcttkFf;EAGG;IACC,YAAU;EdstkFZ;EcptkFC;IACC,QAAM;EdstkFR;EACA;IcptkFE,mBAAW;EdstkFb;EcrtkFE;IACC,mBAAiB;EdutkFpB;;EAEA;IcttkFG,iBAAA;EdwtkFH;EACA;IACE,sBAAsB;EcttkFrB;AdwtkFL;AACA;EcrtkFI;IACC,aAAU;EdutkFb;AACF;AACA;EACE;IACE,MAAM;Ic/skFN,2CAAA;EditkFF;EACA;Ic/skFE,eAAA;EditkFF;EACA;Ic1skFG,eAAA;Ed4skFH;EACA;IACE,eAAe;EctskFnB;;EdyskFE,qBctskFe;EduskFf;IACE,SAAS;IcnskFP,kBAAA;IACC,WAAA;IACA,UAAS;EdqskFd;AACF;AACA;EACE;IACE,aAAa;EczrkFX;Ad2rkFN;AACA;EACE;IACE,WAAW;EczrkFT;Ed2rkFJ;IACE,YAAY;IcprkFd,eAAA;IV/7BM,MAAA;IAIA,WAAA;EJmnmFN;EACA;IIxmmFM,2BAAoB;IJ0mmFxB,mCAAmC;IczrkFpC,yBAAA;Ed2rkFD;EACA;IczrkFC,cAAA;IVp8BK,cAAA;EJgomFN;EACA;IIrnmFM,iBAAiB;EJunmFvB;EACA;Ic9rkFE,WAAA;EdgskFF;EACA;IACE,WAAW;Ic3rkFf,YAAc;EACd;EACC;IACC,WAAW;Ed6rkFX;EACA;Ic3rkFD,QAAI;Ed6rkFH;EACA;IACE,aAAa;Ec3rkFhB;Ad6rkFD;AACA;EACE;IACE,cAAc;Ic3rkFlB,eAAQ;EACP;EACA;Id8rkFG,iBAAiB;Ec5rkFpB;EACC;IACA,aAAA;IACA,cAAW;EACX;EACA;IACA,aAAc;IACd,cAAU;IACV,cAAS;Ed8rkFT;Ec7rkFA;IACC,8BAAsB;Ed+rkFvB;Ec7rkFA;IdmskFE,2BAA2B;Ec7rkF7B;EACC;Id+rkFC,gBAAgB;EAClB;Ec5rkFF;IAKC,wBAAY;EACZ;EACA;IACA,gBAAa;EACb;Ad8rkFD;AACA,aAAa;Ac7rkFZ;EACC;IACA,0BAAoB;IACpB,yBAAoB;EACpB;EACA;IACA,2BAAsB;IACtB,yBAAmB;EACnB;EACA;IACA,0BAA4B;IAC5B,yBAAc;EACd;Ad+rkFF;AACA;Ec7rkFG,mBAAA;EACC,aAAA;EACA,YAAA;Ad+rkFJ;AACA;Ec9rkFI,2DAAY;EACX,yBAAiB;EACjB,WAAS;EACT,kBAAS;EACT,oBAAa;EACb,sBAAmB;EACnB,UAAA;EACA,qBAAmB;AdgskFxB;AACA;Ec7rkFK,sBAAA;Ad+rkFL;AACA;Ec7rkFM,sBAAe;Ad+rkFrB;Ac7rkFK;EACC,sBAAmB;Ad+rkFzB;AACA;EACE,eAAe;AczrkFd;;Ad4rkFH;EczrkFI,eAAY;EACZ,MAAA;Ed2rkFF,SAAS;EcvrkFV,QAAA;EACC,aAAU;EACV,YAAM;EdyrkFN,yCAAyC;EcxrkFzC,cAAA;EACC,gBAAQ;Ed0rkFT,iBAAiB;AczrkFhB;Ad2rkFH;EACE,mBAAmB;EcxrkFhB,aAAW;EAEX,mBAAA;EACC,8BAAe;Ed6rkFnB,sCAAsC;Ec3rkFnC,4BAAA;EACC,cAAS;EACT,uBAAoB;EVtkClB,YAAA;AJowmFR;AACA;Ec3rkFM,mBAAmB;Ad+rkFzB;AACA;Ec7rkFM,kBAAa;EAEb,aAAA;EAGC,mBAAS;EACT,kBAAS;AdgskFhB;AACA;Ec9rkFM,eAAA;EACC,WAAS;EACT,0BAAoB;AdgskF3B;AACA;EACE,mBAAmB;Ec/rkFd,WAAA;EACC,0BAAY;AdiskFpB;AACA;EchskFQ,UAAA;EdkskFN,WAAW;EACX,YAAY;Ec/rkFL,uBAAgB;AdiskFzB;AACA;EACE,cAAc;Ec/rkFR,cAAA;AdiskFR;AACA;Ec/rkFS,0BAAqB;AdiskF9B;Ac9rkFO;EACC,iBAAgB;AdgskFxB;AACA;Ec9rkFQ,UAAS;EACT,YAAS;EACT,qBAAiB;AdgskFzB;AACA;Ec9rkFQ,gBAAe;AdgskFvB;AACA;Ec9rkFQ,qBAAqB;EACrB,qBAAY;EAEX,qBAAkB;EAGnB,mBAAA;EAGA,aAAA;EACC,eAAS;AdiskFlB;AACA;Ec/rkFS,kBAAS;EVroCV,kBAAoB;EJy0mF1B,aAAa;Ac/rkFT;AdiskFN;Ec5rkFU,aAAS;EACT,YAAW;AdgskFrB;Ac9rkFS;EdgskFP,YAAY;EACZ,SAAO;AACT;AACA;;;EIr0mFQ,gBAAc;EJy0mFpB,uBAAuB;Ec3rkFhB,mBAAA;Ad6rkFT;AACA;EczrkFO,cAAA;EACC,gBAAgB;Ed2rkFtB,qBAAqB;AcxrkFb;Ad0rkFV;EACE,iBAAiB;EclrkFf,kBAAA;EAEC,aAAA;EACC,iBZ3kCc;EFgwmFlB,8BAA8B;EchrkF9B,sCAAA;EACC,4BAAS;EdorkFV,qBAAqB;Ec/qkFpB,aAAA;AdirkFH;AACA;EchrkFI,kBAAA;EACC,cAAS;AdkrkFd;AACA;EchrkFK,kBAAiB;AdkrkFtB;AACA;EACE,UAAU;EcjrkFP,kBAAA;EACC,kBAAS;EACT,SAAA;EdqrkFJ,gCAAgC;AclrkF5B;AdorkFN;EACE,yBAAyB;AclrkFrB;AdorkFN;EclrkFO,UAAA;EACA,mBAAiB;AdorkFxB;AACA;;;EchrkFO,UAAS;EACT,kBAAS;EAGT,gCAAY;AdorkFnB;AACA;EE76mFI,cAAY;AF+6mFhB;AACA;EclrkFO,yBAAoB;AdorkF3B;AACA;EclrkFO,cAAc;AdorkFrB;AACA;EclrkFO,gBAAA;AdorkFP;AACA;EcjrkFO,mBAAA;AdmrkFP;AACA;Ec/qkFK,UAAA;EACC,cAAY;EdirkFhB,kBAAkB;Ac/qkFf;AdirkFL;Ec/qkFM,oBAAS;AdirkFf;AACA;Ec7qkFM,aAAY;EAGZ,mBAAO;AdirkFb;AACA;Ec9qkFM,qBAAA;EACC,sBAAS;EdgrkFd,qBAAqB;Ec5qkFnB,kBAAA;Ad8qkFJ;AACA;Ec5qkFK,cAAa;Ad8qkFlB;AACA;EACE,cAAc;Ec3qkFT,yBAAA;EACC,kBAAiB;EACjB,kBAAgB;EAChB,WAAW;Ad6qkFnB;Ac5qkFQ;EACC,kBAAkB;Ed8qkFzB,UAAU;Ec5qkFJ,OAAA;EACC,MAAK;EACL,YAAW;EACX,WAAU;EACV,WAAA;EACA,iCAAmB;EACnB,sBAAgB;EAGhB,aAAU;EAKb,mBAAA;EACC,uBAAa;Ed4qkFlB,+BAA+B;EctqkF3B,qBAAA;AdwqkFN;AACA;EcvqkFO,UAAA;AdyqkFP;AACA;EACE,kBAAkB;AcpqkFb;AdsqkFP;EACE,iBAAiB;EchqkFhB,UAAA;EAIG,aAAA;EACC,UAAU;EdiqkFf,kCAAkC;Ec9pkF7B,kBAAA;EACC,MAAA;EdgqkFN,QAAQ;Ec1pkFP,UAAA;Ad4pkFH;AACA;Ec3pkFI,UAAA;Ad6pkFJ;AACA;EczpkFK,aAAA;EAEA,eAAe;Ad6pkFpB;AACA;EczpkFK,mBAAa;Ad6pkFlB;Ac5pkFK;EACC,kBAAkB;Ad8pkFxB;AACA;Ec7pkFM,cAAA;EACC,gBZnuCU;EFk4mFf,gBAAgB;Ec9pkFX,uBAAA;EACC,mBZjxCe;EFi7mFrB,gBAAgB;Ac9pkFX;AdgqkFP;EACE,mBAAmB;Ec5pkFd,kBAAA;Ad8pkFP;AACA;EcxpkFG,aAAA;Ad0pkFH;AACA;EczpkFI,UAAA;Ad2pkFJ;AACA;EACE,sBAAsB;EcppkFjB,aAAA;AdspkFP;AACA;Ec/okFE,iCAAA;AdipkFF;AACA;Ec/okFG,sBAAe;AdipkFlB;AACA;Ec/okFG,mBAAgB;AdipkFnB;AchpkFG;EACC,yBZjyC+B;AFm7mFnC;AACA;EchpkFI,sBAAU;AdkpkFd;AACA;EchpkFI,cAAW;EAGX,aZ1yCkB;EY2yClB,yBAAW;EACX,iCAAW;EACX,uBAAS;EAET,sBAAQ;EAGT,qBAAA;AdkpkFH;AACA;Ec/okFI,2BAAkB;AdkpkFtB;AACA;Ec9okFC,mBAAO;AdgpkFR;AACA;Ec9okFE,WAAU;AdgpkFZ;AACA;EIjjnFQ,WAAA;AJmjnFR;AACA;EchpkFE,0BAAoB;AdkpkFtB;AACA;EchpkFE,mBAAgB;AdkpkFlB;AACA;EchpkFE,qBAAA;EACA,oBAAe;AdkpkFjB;AcjpkFE;EACC,aAAQ;AdmpkFX;AcjpkFE;EACC,kBAAW;EdmpkFZ,kBAAkB;EAClB,gBAAgB;EchpkFlB,mBAAA;EdkpkFE,kBcjpkFe;EAChB,0BAAe;AdkpkFhB;AACA;EchpkFC,mBAAY;EdkpkFX,WAAW;EACX,WAAW;EcjpkFb,UAAA;EACC,kBAAe;EACZ,QAAO;EACP,WAAQ;AdmpkFZ;AACA;EcjpkFI,mBAAc;EACjB,WAAU;EACV,WAAQ;EACR,SAAQ;EACR,kBAAU;EdmpkFT,QAAQ;EclpkFT,WAAA;AdopkFD;AACA;EACE,qBAAqB;EclpkFvB,gBAAA;EACC,UAAA;EdopkFC,kBcnpkFU;EdopkFV,kBAAkB;AACpB;AclpkFA;EACA,gBAAkB;EACjB,6BAAc;EACd,gBAAY;EACZ,kBAAU;EAGV,yBAAoB;EAGpB,aAAQ;EAER,mBAAA;EACC,8BZ/4C6B;EYg5C7B,sCAA8B;EdqpkF9B,4BAA4B;AcppkF5B;AdspkFF;EcppkFG,cAAS;AdspkFZ;AACA;EcppkFG,YAAA;AdspkFH;;AAEA;;EAEE,eAAe;EcnpkFd,WAAA;EACC,YAAA;EACA,YAAA;AdqpkFJ;;AcnpkFI;EACC,eAAS;EACT,WAAS;EACT,aAAS;EACT,gBAAa;EACb,YAAA;EACA,qBAAgB;EAChB,yCAAmB;EACnB,aAAY;EdspkFf,aAAa;EcnpkFV,WAAA;AdqpkFL;AACA;EcnpkFM,mBZn7CiB;AFwknFvB;;AclpkFK;EACC;IdqpkFF,WAAW;Ec/okFd;AdipkFD;AACA,gBchpkFY;AdipkFZ;EchpkFE,eAAA;EACC,aAAY;EdkpkFb,WAAW;EchpkFX,aAAA;EACC,YAAQ;EdkpkFT,qBAAqB;EcjpkFpB,gBAAA;EACC,yCAAgB;EdmpkFlB,cAAc;EclpkFZ,gBAAA;AdopkFJ;AACA;EchpkFE,mBAAA;EACC,8BAAS;AdkpkFZ;AACA;Ec7okFI,aAAa;EAEZ,mBAAS;EACT,8BAAoB;EACpB,sCAAa;EACb,4BAAyB;AdkpkF9B;AACA;Ec/okFM,mBAAS;AdmpkFf;AACA;EcjpkFM,kBAAiB;EAEhB,aZ79Ca;EYi+Cd,mBAAkB;EdmpkFtB,kBAAkB;Ac/okFjB;AdipkFH;;Ec7okFM,eAAA;EACC,WAAU;EdgpkFf,0BAA0B;Ac7okFrB;Ad+okFP;EACE,mBAAmB;AczokFlB;Ad2okFH;EACE,2BAA2B;Ec1okFzB,kBAAA;Ad4okFJ;AACA;Ec1okFK,oBAAoB;Ad4okFzB;AACA;Ec1okFK,gCAAyB;Ad4okF9B;AACA;Ec1okFK,iBAAgB;Ad4okFrB;AACA;Ec1okFK,sBAAqB;Ad4okF1B;Ac3okFK;EACC,UAAA;EACA,cAAc;Ed6okFlB,kBAAkB;Ac5okFd;Ad8okFN;EACE,oBAAoB;Ac7okFf;Ad+okFP;Ec3okFQ,aZhhDe;EYqhDf,mBAAA;Ad6okFR;AcnokFO;EACC,qBAAY;EdqokFlB,sBAAsB;Ec9nkFtB,qBAAA;EACC,kBAAkB;AdgokFrB;AACA;Ec9nkFG,cAAU;AdgokFb;AACA;EACE,kBAAkB;Ac/nkFjB;AdiokFH;Ec/nkFI,sBAAW;AdiokFf;AACA;Ec/nkFI,mBAAkB;AdiokFtB;AACA;EACE,yBAAyB;Ac/nkFxB;AdiokFH;Ec/nkFI,sBAAW;AdiokFf;AACA;Ec/nkFI,cAAU;EdmokFZ,aAAa;Ec/nkFZ,yBAAA;EACC,iCAAqB;EACrB,uBZlkDmB;EYokDnB,sBAAkB;EAKrB,qBAAA;Ad+nkFD;AACA;Ec7nkFG,2BAAW;AdgokFd;Ac/nkFG;EACC,mBAAW;AdiokFf;Ac9nkFE;EACC,WAAU;AdgokFb;AACA;Ec9nkFE,WAAA;AdgokFF;AACA;Ec9nkFG,0BAAoB;AdgokFvB;AACA;Ec9nkFG,aAAA;AdgokFH;AACA;Ec9nkFG,kBAAiB;EACjB,kBAAgB;EAChB,gBAAa;EACb,mBAAiB;EACjB,kBAAiB;EdgokFlB,0BAA0B;Ac9nkFzB;AdgokFH;Ec9nkFI,mBAAmB;EdgokFrB,WAAW;EACX,WAAW;Ec5nkFb,UAAA;EACC,kBAAkB;Ed8nkFjB,Qc7nkFK;Ed8nkFL,Wc7nkFS;Ad8nkFX;AACA;EACE,mBc7nkFW;Ed8nkFX,Wc7nkFS;Ed8nkFT,WAAW;Ec7nkFX,SAAA;Ed+nkFA,kBc9nkFU;Ed+nkFV,QAAQ;Ec7nkFR,WAAA;Ad+nkFF;AACA;EACE,qBc9nkFa;Ed+nkFb,gBAAgB;Ec9nkFf,UAAA;EdgokFD,kBc/nkFe;EdgokFf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;Ac3nkFA;EACA,6BAAkB;Ad6nkFlB;AACA;EIh1nFQ,YAAA;AJk1nFR;AACA;EACE,kBAAkB;Ec9nkFnB,sBAAA;AdgokFD;AACA;Ec9nkFE,mBAAS;EACT,sBAAa;EAGb,aAAY;EACZ,uBAAc;EACd,+BAAM;EACN,qBAAW;EAGX,mBZtpDqB;EYupDrB,kBAAc;EVpuDR,kBAAoB;AJq2nF5B;AACA;EACE,WAAW;EcjokFX,mBAAA;AdmokFF;;AAEA;EcjokFE;IACC,WAAQ;IdmokFP,iBAAiB;IclokFjB,gBAAA;IACA,SAAW;IACX,QAAA;IdookFA,MAAM;EcnokFN;EACC;IACA,4BAAmB;EACnB;EACA;IACA,cAAS;IACT,cAAa;IACb,YAAA;EACA;EACA;IdqokFD,aAAa;EclokFZ;EZxxDD;IY0xDE,aZpoDsB;EFwwnF1B;AchokFC;AdkokFH,WcjokFY;AdkokFZ;EchokFI,kBAAS;EACT,0BAAY;EdookFd,4BAA4B;AcjokF1B;AdmokFJ;EACE,kBAAkB;EAGlB,aAAa;EcnokFT,iBAAA;EACC,OAAA;EACA,YAAW;EACX,cAAY;EACZ,MAAA;EdqokFL,YAAY;EcpokFP,UAAA;EACC,YAAW;EdsokFjB,gBAAgB;EclokFX,+BAAA;EAGC,yBAAW;AdookFnB;AACA;EclokFQ,cAAM;EACN,cAAa;AdookFrB;AACA;EclokFO,eAAA;AdookFP;AACA;EACE,kBAAkB;EcnokFZ,mBAAA;AdqokFR;AACA;Ec3nkFM,oBAAA;EACC,mBZ3sDsB;EY4sDtB,kBAAkB;EAGlB,aAAY;EAQf,mBAAA;AdwnkFJ;AACA;EACE,mCAAmC;EcpnkFnC,cAAA;AdsnkFF;AACA;EACE,gBAAgB;EcnnkFjB,yBAAA;EACC,SAAS;EACT,YAAS;EACT,gBAAa;EACb,WAAU;AdqnkFZ;AACA;EcnnkFE,UAAQ;AdqnkFV;AACA;EI/7nFQ,UAAA;AJi8nFR;AACA;EcrnkFG,eAAA;EACC,WAAS;EACT,YAAS;EACT,UAAS;AdunkFb;AACA;EcrnkFI,uBAAmB;AdunkFvB;AACA;EcrnkFI,WAAA;EACA,YAAW;EACX,WAAS;EACT,kBAAe;EACf,OAAA;EACA,MAAA;EdunkFF,kBAAkB;EctnkFhB,WAAA;AdwnkFJ;AACA;EctnkFI,uBAAa;EACb,cAAA;AdwnkFJ;AACA;EctnkFI,mBAAO;AdwnkFX;ActnkFM;EACC,cAAQ;EACR,kBAAW;AdwnkFlB;AACA;EctnkFO,kBAAa;EACb,gBAAA;AdwnkFP;AACA;EACE,kBAAkB;EcvnkFb,qBAAA;AdynkFP;AACA;EcvnkFQ,YAAW;EdynkFjB,6BAA6B;ActnkFzB;AdwnkFN;EAGE,aAAa;EcrnkFV,gBAAA;EAMC,mBAAiB;EdknkFrB,kBAAkB;EcvnkFd,YAAA;EACC,OAAA;Ed2nkFL,yBAAyB;AcrnkFtB;AdunkFL;Ec/mkFK,aAAa;EAKb,mBAAQ;EdinkFX,8BAA8B;Ec9mkF7B,sCAAA;EACC,4BAAkB;EAClB,YAAW;EACX,kBAAgB;EAChB,gBAAS;EACT,gBZ10D2B;EF07nF7B,kBAAkB;Ac9mkFjB;AdgnkFH;Ec5mkFG,aAAA;EdknkFD,mBAAmB;Ec/mkFjB,SAAA;AdinkFJ;AACA;EACE,QAAQ;EchnkFJ,WAAA;EAKH,aAAA;EAGA,mBAAA;AdgnkFH;AACA;;Ec7mkFI,YAAW;EdgnkFb,uBAAuB;Ac/mkFrB;AdinkFJ;EACE,qBAAqB;EchnkFlB,yBAAA;EACC,kBAAS;AdknkFf;AACA;EchnkFM,uBAAmB;AdknkFzB;AACA;EchnkFM,iBAAiB;EACjB,gBAAY;EACZ,gBAAW;AdknkFjB;AACA;EchnkFM,yBZr3DiB;AFu+nFvB;AACA;Ec9mkFG,oBAAA;AdgnkFH;AACA;Ec9mkFG,yBAAA;AdgnkFH;AACA;Ec9mkFG,kBAAA;EACC,gBAAQ;EdgnkFV,yBAAyB;Ec9mkFxB,iBAAA;EACC,cAAA;AdgnkFJ;Ac9mkFG;;EdinkFD,mBAAmB;Ac9mkFlB;AdgnkFH;Ec9mkFI,sBAAa;EdgnkFf,uBAAuB;Ac9mkFtB;AdgnkFH;EACE,sBAAsB;Ec9mkFnB,uBAAA;AdgnkFL;AACA;Ec5mkFG,yBAAA;Ad8mkFH;AACA;EACE,uBAAuB;Ac7mkFrB;Ad+mkFJ;EACE,gBAAgB;Ac9mkFb;AdgnkFL;Ec9mkFM,uBAAa;AdgnkFnB;Ac7mkFI;EACC,eAAS;Ad+mkFd;AACA;Ec3mkFK,aAAa;EAEZ,mBAAa;EdgnkFjB,uBAAuB;Ec9mkFpB,YAAA;EACC,WAAU;EACV,mBAAe;EACf,kBAAa;EdgnkFjB,WAAW;Ec9mkFR,kBAAA;AdgnkFL;AACA;Ec/mkFM,qBAAA;AdinkFN;AACA;Ec3mkFE,cAAA;Ad6mkFF;AACA;EczmkFE,SAAA;Ad2mkFF;AACA;EczmkFE,yBAAA;Ad2mkFF;AACA;EACE,UAAU;ActmkFV;AdwmkFF;EACE,yBAAyB;EcpmkFzB,cAAA;AdsmkFF;AACA;EcpmkFG,gBAAa;AdsmkFhB;AACA;EACE,yBAAyB;AcpmkFzB;AdsmkFF;EcpmkFG,wBAAoB;EACpB,qBAAa;AdsmkFhB;AcrmkFG;EACC,wBAAkB;AdumkFtB;AACA;EcrmkFI,qBAAa;EdumkFf,cAAc;AcrmkFb;AdumkFH;EclmkFE,aAAA;EAEC,mBAAA;AdumkFH;AACA;EcrmkFI,oBAAa;AdumkFjB;AACA;EcvmkFI,gBAAA;EACC,uBAAoB;EACpB,mBAAS;AdymkFd;AACA;EcvmkFK,gBAAU;AdymkFf;AACA;EACE,uBAAuB;AcxmkFpB;Ad0mkFL;EACE,qBAAqB;AACvB;AcnmkFA;EAEE,YAAA;AdomkFF;AACA;EclmkFE,eAAA;AdomkFF;;AAEA;EcnmkFG,aAAA;AdqmkFH;AACA;EAGE,aAAa;EcjmkFZ,YAAA;EdmmkFD,iBclmkFY;AdmmkFd;AACA;EAGE,aI7roFM;AJ8roFR;AACA;EACE,kBIproFuB;EJqroFvB,gBIjroFoB;EJkroFpB,cAAc;EcrmkFb,aAAA;AdumkFH;AACA;EcrmkFG,kBAAA;EdumkFD,QIvsoFM;AJwsoFR;AACA;EACE,eI9roFqB;AJ+roFvB;AACA;EAGE,aAAa;EACb,uBAAuB;ActmkFzB;AACA;EV3mEQ,aAAA;EAIA,cAAA;EAYA,kBAAc;EJwsoFpB,QAAQ;EczmkFT,qBAAA;Ad2mkFD;AACA;EczmkFE,mBAAS;Ad2mkFX;;AAEA;EczmkFE;IACA,YAAc;EACd;EACA;IACA,cAAS;IACT,eAAY;EACZ;EACA;IV7nEM,aAAA;EAIA;EAYA;IJ2toFJ,OAAO;Ec5mkFT;EACC;IACA,WAAU;Id8mkFT,mBAAmB;Ic5mkFrB,mBAAA;EACC;Ed8mkFD;IczmkFE,2BAAkB;EAClB;Ed+mkFF;Ic9mkFG,gBAAA;EACA;EACA;IAKA,wBAAyB;EACzB;EACA;IdgnkFD,gBAAgB;Ec/mkFf;AdinkFL;AACA,WchnkFe;AdinkFf;Ec/mkFM,kBAAc;EACd,0BAAiB;EAEhB,4BAAqB;AdknkF5B;Ac7mkFK;EZ9rED,kBAAY;EYqsEd,aAAA;EACC,iBAAY;EACZ,OAAA;Ed4mkFD,YAAY;EczmkFb,cAAA;EACC,MAAA;EACA,YAAS;EACT,UAAS;EACT,YAAU;EACV,gBAAc;EACd,+BAAiB;EVnrEX,yBAAsB;AJiyoF9B;AACA;EACE,cAAc;Ec5mkFd,cAAA;Ad8mkFF;AACA;Ec5mkFG,eAAS;Ad8mkFZ;AACA;Ec5mkFG,YAAS;Ad8mkFZ;AACA;Ec5mkFG,kBAAS;EACT,mBAAM;Ad8mkFT;AACA;Ec5mkFG,sBAAY;Ed8mkFb,mBAAmB;Ec7mkFlB,kBAAA;EAGC,aAAa;EAGb,mBAAmB;Ad+mkFvB;AACA;Ec3mkFI,aAAS;EACT,qBAAc;EACd,iBZroEmB;AFovoFvB;AACA;Ec9mkFI,qBAAA;AdgnkFJ;AACA;Ec9mkFK,mCAAa;EACb,cAAA;AdgnkFL;AACA;EACE,YAAY;Ec/mkFT,6BAAA;AdinkFL;AACA;Ec7mkFK,aAAA;EACC,gBAAK;EdinkFT,mBAAmB;Ec9mkFjB,kBAAA;EACC,YAAY;EdgnkFf,OAAO;EAGP,yBAAyB;Ac7mkFxB;Ad+mkFH;EACE,+BAA+B;Ec7mkF9B,gBAAA;EACC,kBAAa;EAGb,aAAY;EACZ,iBAAgB;Ed+mkFlB,YAAY;Ec9mkFV,UAAA;EACC,OAAM;EdgnkFT,YAAY;Ec/mkFT,cAAA;EACC,aAAS;AdinkFf;AACA;Ec9mkFO,aAAS;EVvvER,mBAAmB;EAYnB,8BAAoB;EU8uErB,sCAAoB;EACpB,4BAAoB;EACpB,YAAS;EACT,kBAAc;EdonkFnB,gCAAgC;EcnnkF3B,gBAAA;EACC,cAAS;AdqnkFjB;AACA;EcjnkFQ,aAAU;EAGV,mBAAmB;AdqnkF3B;AcpnkFQ;EACC,iBAAW;EdsnkFlB,gBAAgB;EcnnkFX,gBAAA;AdqnkFP;AACA;EcnnkFQ,MAAA;AdqnkFR;AACA;EcpnkFQ,mBAAA;AdsnkFR;AACA;EACE,eAAe;AcrnkFR;AdunkFT;EcrnkFU,sBAAoB;AdunkF9B;AACA;EcrnkFU,cAAc;EAEd,SAAA;EdunkFR,YAAY;EctnkFJ,gBAAA;AdwnkFV;AACA;EctnkFW,iBAAa;AdwnkFxB;AACA;EctnkFW,UAAA;EACA,YAAW;EdwnkFpB,qBAAqB;AcvnkFZ;AdynkFX;EcvnkFY,qBAAoB;EACpB,qBAAa;EAGb,qBZ1sEiB;EY4sEhB,aAAO;Ed0nkFlB,eAAe;AcznkFJ;Ad2nkFb;EcznkFc,kBZ1rEc;EFqzoF1B,kBAAkB;EAGlB,aAAa;EcznkFF,iBAAA;Ed6nkFX,mBAAmB;Ac1nkFP;Ad4nkFd;Ec1nkFe,mBAAO;Ad4nkFtB;AcvnkFW;Ed2nkFT,aAAa;EcrnkFN,YAAA;AdunkFT;AACA;EcrnkFU,YAAU;EACV,SAAA;AdunkFV;AACA;EcnnkFU,aAAa;EAGd,mBAAA;EACC,qBAAe;AdunkFzB;AACA;EcnnkFU,aAAU;EAGV,mBAAkB;EAClB,iBAAU;AdunkFpB;AcnnkFO;EAMK,aAAA;EACC,oBAAS;EdknkFpB,UAAU;Ec1mkFJ,cAAA;Ad4mkFR;AACA;EcvmkFK,eAAA;AdymkFL;AACA;EcxmkFM,aAAA;EACC,eZlxEa;AF43oFpB;AcpmkFE;EACC,UAAS;AdsmkFZ;AACA;EcpmkFG,aAAa;EACb,eAAW;AdsmkFd;AACA;EcpmkFG,UAAQ;EACR,oBAAU;AdsmkFb;AcrmkFG;EACC,kBAAS;EACT,oBAAoB;AdumkFxB;AACA;;EcpmkFI,cAAa;EACb,gBAAe;EACf,uBAAuB;EACvB,mBAAe;EACf,0BAAW;AdumkFf;AACA;EcrmkFI,qBAAc;EACd,gBAAS;AdumkFb;ActmkFI;EACC,gBAAa;EdwmkFhB,mBAAmB;EctmkFjB,gBAAA;AdwmkFJ;AACA;EACE,gBAAgB;EctmkFd,oBAAA;EACC,qBAAmB;EACnB,4BAAsB;EACtB,mBAAmB;AdwmkFxB;AcvmkFK;EACC,yBAAiB;AdymkFvB;AACA;EcvmkFM,UAAS;AdymkFf;AACA;EcvmkFM,yBAAmB;AdymkFzB;AACA;EctmkFM,gBAAA;AdwmkFN;AACA;EctmkFO,mBZj2EwB;AFy8oF/B;AACA;EctmkFM,kBAAA;EAKF,aAAA;EACC,YAAS;EACT,gBAAS;EACT,iBAAa;EdsmkFhB,YAAY;EcrmkFT,WAAA;AdumkFL;AACA;EcpmkFO,aAAa;EVl8EZ,mBAAoB;EAIpB,8BAAyB;EAYzB,sCAAoB;EUy7ExB,4BAAgB;EAChB,YAAW;EACX,eAAO;EdumkFT,gBAAgB;EctmkFd,gCAAA;EACC,kBAAe;AdwmkFpB;ActmkFI;EACC,cAAS;AdwmkFd;AACA;EctmkFK,aAAA;EACA,qBAAgB;AdwmkFrB;AACA;EcpmkFK,mBAAe;AdwmkFpB;AcvmkFK;EACC,kBAAS;EAGT,aAAA;Ed2mkFJ,mBAAmB;EcxmkFf,kBAAA;Ad0mkFN;AACA;EcrmkFK,eAAA;EACC,gBAAa;EdumkFjB,cAAc;EctmkFV,0BAAA;AdwmkFN;AACA;EcvmkFO,mBAAA;AdymkFP;AACA;EAGE,aAAa;AcxmkFP;Ad0mkFR;EcxmkFS,mBAAS;EACT,qBAAa;Ad0mkFtB;AACA;EcxmkFS,cAAa;Ad0mkFtB;AACA;EcvmkFS,yBAAA;EACC,gBAAA;EAEA,SAAA;Ad2mkFV;Ac1mkFU;EACC,gBAAa;Ad4mkFxB;AACA;EctmkFY,aAAA;Ed4mkFV,mBAAmB;EcrmkFZ,8BAAA;EACC,sCAAoB;EACpB,4BAAoB;EACpB,sBAAa;AdumkFvB;AACA;EcpmkFU,aAAA;Ed0mkFR,mBAAmB;ActmkFX;AdwmkFV;EctmkFW,gBAAS;AdwmkFpB;AACA;EctmkFW,cAAU;AdwmkFrB;AACA;EcvmkFW,yBAAA;AdymkFX;AACA;EcxmkFY,gBAAA;EACC,eZz6Ee;EY06Ef,WZ16EI;EFohpFf,kBAAkB;ActmkFR;AdwmkFZ;EcrmkFa,aAAA;Ed2mkFX,mBAAmB;EcpmkFX,8BAAA;EACC,sCAAY;EdsmkFrB,4BAA4B;AcnmkFrB;AdqmkFT;EcjmkFU,mBAAY;AdqmkFtB;AACA;EcnmkFa,kBAAA;EAKC,aAAa;AdmmkF3B;Ac5lkFY;EACC,cAAQ;Ed8lkFnB,gBAAgB;AcxlkFJ;Ad0lkFd;Ec5kkFa,aAAQ;EASd,mBAAS;Ad0kkFhB;AACA;EcxkkFO,kBAAe;EACf,qBAAc;Ad0kkFrB;AczkkFO;Ed6kkFL,aAAa;Ec1kkFP,qBAAA;EACC,kBAAc;EACd,UAAS;Ad4kkFlB;AACA;Ec1kkFS,eAAU;Ad4kkFnB;AACA;Ec3kkFS,aAAA;EACC,eAAA;Ad6kkFV;AACA;EACE,aAAa;Ec5kkFL,eAAA;Ad8kkFV;AACA;Ec5kkFU,UAAA;EACC,oBAAoB;Ad8kkF/B;Ac5kkFU;EACC,aAAW;Ad8kkFtB;Ac3kkFS;EACC,kBAAiB;EACjB,MAAA;EACA,WAAO;EACP,YAAM;EACN,OAAM;EACN,0CAAW;EACX,2CZ7jFa;AF0opFvB;AACA;Ec3kkFU,aAAS;Ad6kkFnB;AACA;Ec3kkFU,qBAAmB;Ad6kkF7B;AACA;Ec3kkFU,cAAA;Ad6kkFV;AACA;EACE,qBAAqB;Ac1kkFb;Ad4kkFV;EctkkFW,aAAY;EAMjB,eAAA;AdskkFN;AACA;EcrkkFO,oBAAA;EACC,oBAAkB;AdukkF1B;AACA;EcrkkFO,eAAA;EACC,qBAAa;EACb,sBAAkB;EdukkFxB,qBAAqB;EctkkFf,kBAAA;EACC,mBAAe;AdwkkFxB;AcvkkFS;EAGA,mBAAA;AdykkFT;AACA;EcxkkFU,kBAAA;Ad0kkFV;AACA;EcxkkFW,oBAAmB;Ad0kkF9B;AcxkkFU;EACC,kBZzmFoB;AFmrpF/B;Ac9jkFE;EACC,kBAAY;EdgkkFb,UAAU;Ec9jkFV,OAAA;EACC,MAAA;EdgkkFD,YAAY;Ec7jkFb,WAAA;EACC,WAAU;EACV,iCAAS;EACT,sBAAW;EAGX,aAAY;EAGZ,mBAAa;EACb,uBAAe;Ed+jkFf,+BAA+B;Ec9jkF/B,qBAAA;AdgkkFF;AACA;Ec9jkFG,UZ9oFc;AF8spFjB;Ac9jkFI;EACC,aAAa;AdgkkFlB;Ac7jkFG;EACC,qBZrpFmB;AFotpFvB;AACA;Ec9jkFI,kBAAA;EAEC,UZzpFY;AFwtpFjB;AACA;Ec3jkFE,aAAA;EACC,kBAAY;Ad6jkFf;AACA;EACE,qBAAqB;Ac5jkFpB;Ad8jkFH;EACE,gBAAgB;Ac3jkFhB;Ad6jkFF;Ec3jkFG,qBAAgB;Ad6jkFnB;Ac5jkFG;EACC,eAAY;Ed8jkFd,iBAAiB;Ec3jkFjB,mBAAA;Ad6jkFF;AACA;Ec3jkFM,cAAS;Ad6jkFf;AACA;Ec3jkFG,YAAM;Ad6jkFT;AACA;Ec1jkFK,eAAA;Ad4jkFL;AACA;Ec1jkFK,eAAA;EACC,SAAS;Ed4jkFb,WAAW;EcvjkFT,YAAA;EACC,gBAAQ;EdyjkFX,yCAAyC;EcrjkFzC,cAAA;EACC,gBAAS;EACT,aAAS;EACT,gCAAa;AdujkFhB;AACA;EcrjkFG,wBAAmB;EACnB,mBAAiB;EACjB,WAAA;AdujkFH;AACA;EACE,aAAa;AACf;AcnjkFC;EACC,WAAU;EACV,WAAQ;AdqjkFV;AACA;EcnjkFE,WAAQ;EACR,UAAS;AdqjkFX;AACA;EcnjkFE,aAAU;EdqjkFV,cAAc;EACd,cAAc;AcljkFf;AdojkFD;EACE,aAAa;AACf;AcljkFA;EAEE,YAAA;EdmjkFA,gBcljkFY;AdmjkFd;AACA;EACE,acljkFY;AdmjkFd;AACA;EchjkFG,0BAAA;EdkjkFD,2BcjjkFS;EdkjkFT,SAAS;EchjkFR,QAAA;EdkjkFD,OcjjkFM;EdkjkFN,McjjkFE;EdkjkFF,YcjjkFE;AdkjkFJ;AACA;EACE,aIt3pFM;AJu3pFR;AACA;EACE,eI72pFqB;AJ82pFvB;AACA;EcpjkFG,4BAAA;AdsjkFH;AACA;EAGE,aI73pFM;EJg4pFN,mBIp3pFoB;EJq3pFpB,8BAA8B;EczjkF5B,sCAAA;Ed2jkFF,4Bc1jkFmB;Ed2jkFnB,oBAAoB;AACtB;;AAEA;EACE,kBcrjkFY;EdsjkFZ,YAAY;EcpjkFX,WAAA;EdsjkFD,mBcrjkFa;EdsjkFb,YcrjkFW;EdsjkFX,acrjkFO;EdsjkFP,McrjkFE;EdsjkFF,OAAO;EcrjkFL,WAAA;AdujkFJ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IctjkFG,YAAA;EdwjkFH;EACA;IctjkFG,cAAA;IACC,eAAS;EdwjkFb;EcjjkFE;IACC,OAAK;EdmjkFR;EcjjkFE;IACC,WAAO;IdmjkFR,mBAAmB;Ic/ikFrB,mBAAA;EdijkFA;EACA;Ic3ikFG,2BAAQ;EdijkFX;Ec9ikFC;IACC,gBAAU;EdgjkFZ;EACA;IcvikFF,wBAAa;EACb;EACC;IACA,gBAAO;EVj5FA;AJ+7pFR;AACA;EACE;Ic9ikFD,WAAA;EACC;EACA;IACA,YAAS;IACT,eAAa;IACb,MAAA;IACA,WAAO;EACP;EACA;IACA,2BAAM;IACN,mCAAW;IACX,yBAAS;EACT;EACA;IACA,cAAc;IVj6FR,cAAA;EAIA;EAYA;IJo8pFJ,iBAAiB;EcjjkFnB;EACC;IACA,wBAAc;EdmjkFf;EcjjkFA;IACC,WAAQ;EdmjkFT;EcljkFC;IACC,QAAQ;EdojkFV;EcljkFC;IACC,WAAa;IACb,YAAc;IdojkFd,QAAQ;IcnjkFP,gBAAA;EdqjkFH;EcnjkFG;IACA,uCAAmB;EACnB;EACA;IACA,WAAS;IACT,YAAa;IACb,OAAA;IACA,MAAA;IACA,gBAAa;EdqjkFhB;AcpjkFG;AdsjkFL,YAAY;AACZ;EcrjkFM,kBAAS;EACT,0BAAa;EdyjkFjB,4BAA4B;ActjkFxB;AdwjkFN;EcvjkFO,kBAAS;EZ99FZ,aAAY;EYq+FV,iBZ/0FsB;EFq4pF1B,OAAO;EcjjkFP,YAAA;EACC,cAAY;EACZ,MAAA;EdmjkFD,YAAY;EchjkFb,UAAA;EACC,YAAS;EACT,gBAAS;EACT,+BAAa;EAGb,yBAAiB;AdkjkFnB;AACA;EI3gqFQ,cAAA;EAIA,cAAA;AJ0gqFR;AACA;EcnjkFE,eAAA;AdqjkFF;AACA;EcnjkFG,YAAS;AdqjkFZ;AACA;EcnjkFG,kBZr5FoB;EYs5FpB,mBAAiB;AdqjkFpB;AACA;;EAEE,oBAAoB;EcpjkFnB,mBAAA;EACC,kBAAS;EAGT,aAAA;EAGA,mBAAiB;AdsjkFrB;AACA;;EcjjkFI,aAAa;EACb,iBAAS;EdsjkFX,qBAAqB;AcrjkFnB;AdujkFJ;;EcpjkFK,qBAAa;AdujkFlB;AACA;EcrjkFK,mCAAmB;EACnB,cAAa;AdujkFlB;ActjkFK;EACC,YAAS;EACT,6BAAoB;AdwjkF1B;AACA;EAGE,aAAa;EcvjkFT,gBAAA;EACC,mBAAS;EACT,kBAAS;EACT,YAAS;EACT,OAAA;EAGA,yBAAmB;AdyjkF1B;AACA;EcxjkFO,kBAAA;EAEC,aAAA;EACC,YZx5FQ;EYy5FR,gBZz5FmB;EFo9pF1B,iBAAiB;EcvjkFX,YAAA;EACC,WZ95FQ;EY+5FR,WZ/5FQ;AFw9pFjB;AcxjkFS;Ed4jkFP,aAAa;EAGb,mBAAmB;EcnjkFjB,8BAAA;EACC,sCAAyB;EACzB,4BAAsB;EACtB,YAAW;EdqjkFd,kBAAkB;EcpjkFf,gBAAA;EACC,gCAAiB;EACjB,kBAAS;AdsjkFf;AACA;EcljkFM,aAAa;EAIb,mBAAA;EACC,mBAAe;AdqjkFtB;AACA;EcjjkFM,aAAA;EACC,iBAAW;EdqjkFhB,gBAAgB;EcjjkFd,gBAAA;AdmjkFJ;AACA;EchjkFK,aAAA;EdsjkFH,mBAAmB;EcnjkFf,oBAAA;EACC,kBAAc;AdqjkFrB;AcjjkFM;EACC,eAAa;AdmjkFpB;AACA;EcljkFO,aAAA;EACC,eAAc;AdojkFtB;Ac7ikFG;EACC,aAAU;EACV,eAAW;Ad+ikFf;AACA;Ec7ikFI,UAAS;EACT,oBAAa;Ad+ikFjB;Ac9ikFI;EACC,MAAA;AdgjkFL;AACA;EAGE,mBAAmB;Ac/ikFhB;AdijkFL;Ec/ikFM,kBAAS;EAGT,aAAA;EAGA,mBAAA;EACA,kBAAe;AdijkFrB;AACA;Ec/ikFK,eAAA;EACC,gBAAS;EACT,cAAY;EACZ,0BAAgB;AdijkFtB;AACA;Ec/ikFM,mBAAkB;AdijkFxB;AACA;EAGE,aAAa;AcjjkFV;AdmjkFL;EcjjkFM,mBAAY;EACZ,qBAAmB;AdmjkFzB;AACA;EcjjkFM,cAAS;AdmjkFf;AACA;EcljkFM,mBAAA;EACC,qBAAe;AdojkFtB;AACA;EcnjkFO,cAAA;AdqjkFP;AACA;EcnjkFO,gBAAA;EdsjkFL,SAAO;EAGP,aAAa;AcnjkFR;AdqjkFP;EcjjkFQ,aAAY;EdqjkFlB,iBAAiB;EchjkFf,WAAA;AdkjkFJ;AACA;Ec7ikFQ,aAAa;EAEZ,mBAAe;EdkjkFtB,8BAA8B;EchjkFtB,sCAAA;EACC,4BAAiB;EACjB,gBAAS;AdkjkFpB;AACA;Ec5ikFW,aAAA;EACC,gBAAa;Ed+ikFvB,gBAAgB;Ec7ikFP,kBAAA;EACC,mBAAgB;Ed+ikF1B,uBAAuB;Ec5ikFZ,2BAAgB;AdgjkF7B;AACA;Ec7ikFa,aAAa;EAQf,uBAAA;EACC,kBAAiB;Ed2ikF3B,WAAW;AczikFF;Ad2ikFX;EACE,gBAAgB;EczikFL,iBAAA;Ad2ikFb;AACA;EczikFc,cAAW;Ad2ikFzB;AACA;EczikFc,eAAS;Ad2ikFvB;AACA;EczikFc,iBAAgB;Ad2ikF9B;AACA;Ec1ikFc,cAAA;Ad4ikFd;AACA;EACE,eAAe;Ac1ikFH;Ad4ikFd;Ec1ikFe,mBAAe;EACf,sBAAmB;Ad4ikFlC;AACA;EczikFa,uBAAA;Ad2ikFb;AACA;EczikFc,gBAAa;Ad2ikF3B;AchikFI;EACC,kBZ/nGe;EYioGd,aAAU;AdmikFhB;AACA;EcjikFM,kBAAa;AdmikFnB;AACA;EcjikFM,gBAAe;AdmikFrB;Ac/hkFG;EACC,cAAU;EACV,gBAAS;EACT,uBAAa;EACb,mBAAY;EACZ,cAAc;EACd,gBAAS;EACT,mBAAW;AdiikFf;AACA;Ec/hkFI,kBAAa;AdiikFjB;AACA;EI3xqFQ,gBAAiB;AJ6xqFzB;AACA;EclikFI,cAAA;EACC,gBAAe;EdoikFlB,mBAAmB;Ec9hkFnB,qBAAA;EAGA,aAAA;EAMC,mBAAA;Ad6hkFH;AACA;EACE,oBAAoB;EczhkFtB,cAAU;Ad2hkFV;AACA;EczhkFC,gBAAU;EACV,uBAAc;EACd,mBZnrGgC;EF8sqF/B,gBAAgB;Ac1hkFjB;Ad4hkFD;EACE,gBAAgB;Ec3hkFhB,uBAAA;EACC,mBAAS;Ad6hkFZ;AACA;Ec3hkFG,mBAAmB;Ad6hkFtB;AACA;Ec3hkFG,cAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAU;EACV,uBAAkB;Ed6hkFnB,qBAAqB;Ec1hkFtB,uBAAA;Ad4hkFD;AACA;Ec3hkFE,kBAAA;EACC,SAAA;Ed6hkFD,aAAa;Ec1hkFd,YAAA;EACC,cAAY;EACZ,SAAQ;EACR,YAAW;Ed4hkFX,YAAY;EACZ,gBAAgB;Ec1hkFlB,8BAAgB;EACf,2CAAiB;EAGjB,yBAAc;Ad4hkFf;AACA;Ec3hkFC,gBAAA;Ad6hkFD;AACA;Ec3hkFE,YAAA;Ad6hkFF;AACA;Ec5hkFE,eAAA;Ad8hkFF;AACA;Ec5hkFG,QAAO;Ad8hkFV;;AAEA;Ec5hkFG,iBAAiB;EACjB,YAAA;EAEA,cAAU;Ed8hkFX,mBAAmB;Ac7hkFlB;Ad+hkFH;Ec7hkFI,iBAAe;Ad+hkFnB;Ac7hkFG;EdiikFD,aAAa;EAGb,mBAAmB;Ec5hkFnB,8BAAA;EACC,sCAAe;Ed8hkFhB,4BAA4B;Ec3hkF7B,WAAA;EACC,mBAAc;Ad6hkFhB;AACA;Ec3hkFC,YAAA;Ad6hkFD;AACA;Ec5hkFE,oBAAA;Ad8hkFF;AACA;Ec3hkFC,aAAA;EACC,SAAA;EACA,uBAAuB;Ad6hkFzB;;AAEA;Ec5hkFE,iBAAA;EACC,YAAW;Ed+hkFZ,cAAc;Ec7hkFb,uBAAA;Ad+hkFH;AACA;EACE,iBAAiB;EczhkFjB,gBAAA;EACC,gCAAS;EVz3GJ,sBAAsB;AJq5qF9B;AACA;EcthkFI,aAAS;EAKX,mBAAa;EdwhkFb,8BAA8B;EcrhkF9B,sCAAK;EACJ,4BAAoB;EACpB,WAAS;AduhkFZ;AACA;EcrhkFE,cAAA;EduhkFA,gBAAgB;AAClB;AACA;EcrhkFG,cAAa;EACb,aAAA;AduhkFH;AACA;EcrhkFG,kBAAU;AduhkFb;ActhkFG;EdwhkFD,gBAAgB;AAClB;AACA;EcvhkFI,gCAAa;EdyhkFf,UAAU;AcxhkFR;Ad0hkFJ;EczhkFK,YAAY;Ad2hkFjB;AcvhkFE;EACC,oBAAiB;AdyhkFpB;AcvhkFE;EACC,uBAAkB;EdyhkFnB,+BAA+B;EAC/B,qBAAqB;EcrhkFtB,iBAAA;AduhkFD;AACA;EcrhkFG,uBAAA;EACC,SAAA;AduhkFJ;AcphkFI;EACC,SZ/1Ge;AFq3qFpB;;AcnhkFI;EACC,UZn2Ge;EYs2GhB,6BAAA;AdshkFJ;AACA;EcrhkFK,UAAA;AduhkFL;AACA;EcphkFM,cAAA;AdshkFN;AACA;EAGE,aAAa;Ac/gkFZ;AdihkFH;;EAIE,aAAa;EAGb,mBAAmB;EACnB,mBAAmB;Ac5gkFpB;Ad8gkFD;;EcvgkFG,aAAS;Ad4gkFZ;AACA;;EczgkFG,oBAAgB;Ad4gkFnB;AACA;Ec1gkFG,kBAAA;Ad4gkFH;AACA;Ec1gkFG,mBAAe;Ad4gkFlB;;AAEA;Ec1gkFG,uBAAiB;Ad4gkFpB;AACA;Ec1gkFI,kBAAA;Ad4gkFJ;AACA;Ec1gkFK,cZ54GwB;EY64GxB,gBAAU;Ad4gkFf;AACA;Ec3gkFK,cAAA;EACC,gBAAY;Ad6gkFlB;AczgkFG;EACC,kBAAS;Ad2gkFb;AACA;EACE,oBAAoB;Ac1gkFlB;Ad4gkFJ;Ec1gkFK,kBAAS;Ad4gkFd;AACA;Ec1gkFK,UAAA;Ad4gkFL;AACA;Ec3gkFK,qBAAA;Ad6gkFL;AACA;Ec3gkFM,mBAAc;Ad6gkFpB;Ac5gkFM;EACC,mBZ/4GqB;AF65qF5B;;AczgkFM;EACC,aZr5GqB;AFi6qF5B;;Ac1gkFO;Ed+gkFL,aAAa;EAGb,mBAAmB;EczgkFhB,8BAAA;EACC,sCAAc;Ed2gkFlB,4BAA4B;EctgkF5B,gBAAA;EACC,gCAAe;EACf,YAAY;EdwgkFb,gBAAgB;EcrgkFb,gCAAA;EACC,kBAAiB;EdugkFrB,qBAAqB;AcpgkFjB;AdsgkFN;EcpgkFO,oBZz9GwB;EF+9qF7B,kBAAkB;Ec9/jFd,aAAA;EAeC,kBAAc;Edk/jFnB,0BAA0B;AchgkFrB;AdkgkFP;EACE,aAAa;Ac9/jFN;AdggkFT;Ec5/jFS,aAAA;AdggkFT;AACA;EAGE,aAAa;Ecn/jFL,mBAAS;Adu/jFnB;AACA;Ecr/jFU,YAAA;EACA,WAAW;EACX,eAAe;Adu/jFzB;Act/jFU;EACC,aAAY;EACZ,eZpgHoB;AF4/qF/B;Act/jFU;EACC,aAAa;EACb,eAAc;Adw/jFzB;Acn/jFS;EACC,UZ3/GO;EY4/GP,oBAAiB;Adq/jF3B;Acn/jFS;EACC,qBAAe;Adq/jFzB;AACA;Ecl/jFQ,cAAA;Ado/jFR;AACA;Ec9+jFM,gBAAA;EACC,qBAAgB;Adg/jFvB;AACA;Ec/+jFO,kBAAA;Adi/jFP;AACA;EInmrFQ,gBAAA;EAIA,cAAA;AJkmrFR;AACA;EACE,sBAAsB;Acl/jFhB;Ado/jFR;EACE,kBAAkB;Acl/jFZ;Ado/jFR;Ecl/jFS,gBAAgB;EAChB,cAAa;Ado/jFtB;Acn/jFS;EACC,mBAAiB;Adq/jF3B;Acn/jFW;EACC,kBAAkB;Adq/jF9B;Acj/jFS;EAGC,aAAa;EAGb,mBAAmB;EACnB,mBAAY;Adm/jFtB;Acj/jFW;EACC,gBAAY;EACZ,cAAW;Adm/jFvB;AACA;Ecj/jFW,oBAAA;EACC,cAAS;Adm/jFrB;AACA;Ecj/jFY,cAAA;EACA,kBAAgB;Adm/jF5B;AACA;Ech/jFU,gBAAA;EACC,cZ5kHoB;AF8jrF/B;AACA;Ech/jFW,oBAAmB;Adk/jF9B;AACA;EACE,gBAAgB;Ech/jFR,eAAA;Adk/jFV;AACA;EACE,cAAc;Ec9+jFR,qBAAA;EAIG,qBAAA;EACC,qBZtjHgB;AFqirF5B;Ac7+jFW;EACA,gBZjmHoB;AFglrF/B;Acl+jFE;EAGC,mBAAY;Ado+jFf;AACA;Ecl+jFG,kBAAa;Ado+jFhB;AACA;EACE,kBAAkB;Acn+jFjB;Adq+jFH;Ech+jFO,aAAY;Eds+jFjB,mBAAmB;Ec79jFrB,YAAA;Ad+9jFA;AACA;EACE,YAAY;EAEZ,Sc79jFC;Ad89jFH;AACA;EAGE,aAAa;EAGb,mBc59jFgB;Ad69jFlB;AACA;Ec19jFE,cAAA;Ed49jFA,gBIrsrFM;EJssrFN,uBIlsrFyB;EJmsrFzB,mBI/rrFwB;EJgsrFxB,gBI5rrFuB;EJ6rrFvB,gBIzrrFoB;AJ0rrFtB;AACA;EACE,kBch+jFkB;Edi+jFlB,mBAAmB;AACrB;AACA;EACE,yBI5srFyB;AJ6srF3B;AACA;EACE,cInsrFoB;AJosrFtB;AACA;EACE,ccr+jFY;Ads+jFd;AACA;Ecj+jFA,kBAAA;EAGG,MAAA;Edi+jFD,Ych+jFO;Edi+jFP,QAAQ;EACR,UAAU;Ec99jFX,8BAAY;Edg+jFX,Sc/9jFA;Edg+jFA,gBc/9jFS;Adg+jFX;AACA;Ec79jFG,eAAA;Ad+9jFH;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;Ic19jFF,YAAA;EAEC;EACC;IACA,cAAU;Id29jFR,eAAe;Ec19jFjB;EACC;Id49jFC,OAAO;Ec19jFT;EACC;IACA,WAAY;IACZ,mBZnqHyB;IYoqHzB,mBAAgB;EAChB;EACA;IAKA,2BAAM;EACN;EACA;Id49jFC,gBAAgB;Ecz9jFjB;EACC;IAMD,wBAAS;EVhzHJ;EAIA;IAYA,gBAAc;EJ6vrFpB;Acz9jFC;Ad29jFH;EACE;Ict9jFA,MAAA;EACC;;EAID;IACC,kBAAkB;IAClB,SAAM;EACN;;EAEA;;IAEA,eAAW;Eds9jFZ;;Ecj9jFF;IACA,aAAiB;EAChB;Ado9jFD;AACA,iBAAiB;Acn9jFhB;EACC,sBAAkB;EAClB,kBAAS;Adq9jFX;AACA;Ecn9jFE,kBAAiB;Adq9jFnB;AACA;Ecn9jFE,cAAc;EACd,YAAM;EACN,mBAAW;EACX,wBAAS;EACT,YAAY;EACZ,QAAA;EACA,4DAAqC;EV71H/B,kBAAoB;EAIpB,cAAA;EAYA,QAAA;EJqyrFN,OAAO;Ect9jFP,oBAAA;EACC,WAAM;Adw9jFT;AACA;Ect9jFE,WAAA;Adw9jFF;AACA;Ecv9jFG,kBAAA;EACC,QAAQ;Edy9jFV,UAAU;Ecr9jFR,oCAAmB;Ady9jFvB;Acx9jFK;EACA,UAAA;Ad09jFL;AACA;Ecx9jFK,oBAAoB;Ad09jFzB;AACA;Ecx9jFK,kBAAiB;EACjB,MAAA;EACA,YAAW;Ed09jFd,gBAAgB;Ecz9jFb,UAAA;EACC,YAAS;EACT,WAAS;Ad29jFf;;AAEA,Wc19jFe;Ad29jFf;Ec19jFM,kBAAA;EACC,0BAAqB;Ad49jF5B;Acv9jFK;EZ95HD,kBAAY;EYq6HZ,aAAA;EACC,iBAAc;Eds9jFjB,OAAO;Ecl9jFP,YAAA;EACC,cAAY;EACZ,MAAA;Edo9jFD,YAAY;Ecj9jFb,UAAA;EACC,YAAS;EACT,gBAAS;EACT,+BAAa;EAGb,yBAAiB;Adm9jFnB;AACA;EI52rFQ,cAAA;EAIA,cAAA;AJ22rFR;AACA;Ecp9jFE,eAAA;Ads9jFF;AACA;Ecp9jFG,YAAS;Ads9jFZ;AACA;Ecp9jFG,kBAAa;EACb,mBAAiB;Ads9jFpB;AACA;Ecp9jFG,oBAAW;EACX,mBAAkB;EAClB,kBZ31HoB;EFmzrFrB,aAAa;Ecn9jFX,mBAAS;Adu9jFb;AACA;EAGE,aAAa;Ect9jFX,qBAAA;EACC,iBAAiB;Adw9jFtB;AACA;EACE,qBAAqB;Act9jFnB;Adw9jFJ;EACE,mCAAmC;Ecr9jFlC,cAAA;Adu9jFH;AACA;Ecr9jFI,qBAAmB;Adu9jFvB;Act9jFI;EACC,YAAS;EACT,6BAAoB;Adw9jFzB;AACA;Ecp9jFK,aAAa;EACb,gBAAa;Edw9jFhB,kBAAkB;Ecr9jFf,YAAA;EACC,OAAA;EAGA,yBAAe;Adu9jFrB;Acr9jFK;EAKF,aAAA;EAGC,mBAAa;Edq9jFf,8BAA8B;Ecp9jF5B,sCAAA;EACC,4BAAmB;EACnB,YAAS;Eds9jFZ,kBAAkB;Ecr9jFf,gBAAA;EACC,gCAAc;Edu9jFlB,kBAAkB;Acl9jFlB;Ado9jFF;Ech9jFG,aAAa;EAGb,mBAAiB;Ado9jFpB;AACA;EACE,iBAAiB;Ecn9jFhB,gBAAA;EV5+HK,gBAAA;AJk8rFR;AACA;Ecr9jFI,MAAA;Adu9jFJ;AACA;Ecp9jFK,mBAAe;Adw9jFpB;Acv9jFK;EACC,kBAAY;EAEX,aAAa;Ed49jFlB,mBAAmB;Ecz9jFd,kBAAA;Ad29jFP;AACA;Ec19jFQ,eAAA;EACC,gBAAe;EACf,cAAc;Ed49jFrB,0BAA0B;Acz9jFrB;Ad29jFP;EACE,mBAAmB;Acr9jFf;Adu9jFN;Ecr9jFO,aAAY;Ady9jFnB;AACA;Ecv9jFO,mBAAmB;EACnB,qBAAgB;Ady9jFvB;AACA;Ect9jFO,cAAA;Adw9jFP;AACA;EACE,kBAAkB;Ecv9jFX,aAAY;Ed29jFnB,YAAY;Ecv9jFR,gBAAA;Edy9jFJ,iBAAiB;Ecx9jFZ,YAAA;EACA,WAAA;Ad09jFP;Acz9jFO;Ed69jFL,yBAAyB;Ec39jFnB,gBAAA;EACC,SAAA;Ad89jFT;Ac39jFO;Ed69jFL,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;Ec/9jFf,gBAAA;Edi+jFN,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;Ecn+jFV,cAAA;Adq+jFP;AACA;Ecp+jFQ,sBAAW;Ads+jFnB;AACA;;;;EAIE,gBAAgB;EAEhB,aAAa;Ecp+jFN,mBAAA;Adw+jFT;AACA;;Ect+jFU,kBAAc;Ady+jFxB;AACA;;EAEE,eAAe;AACjB;AACA;;Ecr+jFW,yBAAW;Edw+jFpB,iCAAiC;Acl+jF7B;Ado+jFN;;Ecj+jFO,iBAAa;Ado+jFpB;AACA;;Ecl+jFO,cAAA;Adq+jFP;AACA;;;;;;Ec79jFS,WZ59HQ;AFg8rFjB;AACA;;;;;;Ecv9jFS,gBAAU;Ad89jFnB;AACA;;Ec39jFS,cAAS;Ed89jFhB,WAAW;Ec59jFL,iBAAA;Ad89jFR;AACA;;Ec39jFS,cAAS;Ad89jFlB;AACA;;Ec39jFS,aAAA;Ad89jFT;AACA;;Ec39jFQ,UAAA;Ed89jFN,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;;Ec39jFS,eAAe;Ed89jFtB,oBAAoB;Ec59jFd,qBAAA;EACC,WAAS;Ad89jFlB;AACA;Ec39jFU,aAAA;EACA,oBAAW;EACX,eZjiImB;AFggsF7B;AACA;Ec39jFS,eAAA;Ad69jFT;AACA;Ecz9jFO,aAAA;EACC,eAAS;Ad29jFjB;AACA;Ecz9jFQ,aAAY;EACZ,eAAS;Ad29jFjB;AACA;Ec19jFQ,UAAA;EACC,oBAAc;Ad49jFvB;Ac39jFS;EACC,kBZhiIkB;EYiiIlB,UZjiIO;EF8/rFf,SAAS;Ec19jFH,eAAA;EACC,UAAS;Ad49jFlB;Ac39jFS;EACC,cZviIkB;EYwiIlB,gBZxiIkB;EFqgsF1B,mBAAmB;Ec19jFV,aAAO;Ed89jFhB,uBAAuB;EAGvB,mBAAmB;Acn9jFZ;Adq9jFT;;;;EAIE,gBAAgB;Ec58jFd,uBAAA;EACC,mBAAiB;EACjB,qBAAe;Ad88jFpB;AACA;EACE,UAAU;Ec78jFP,uBAAA;Ad+8jFL;AACA;EACE,wBAAwB;Ec78jFrB,uBAAA;EACC,WAAW;EACX,cAAa;EACb,eZ1nIyB;AFyksF/B;Ac78jFK;EACC,UAAA;Ad+8jFN;Ac78jFK;EAGA,aAAA;EACC,qBAAgB;EAChB,UAAU;EACV,eAAS;Ad+8jFf;AACA;Ec78jFM,eAAS;Ad+8jFf;Ac98jFM;EACC,aAAW;EACX,eAAS;Adg9jFhB;Ac/8jFO;EACC,UAAS;Adi9jFjB;AACA;Ec/8jFQ,aAAW;EACX,eZzmIoB;AF0jsF5B;AACA;Ec/8jFQ,UAAS;EACT,oBAAoB;Adi9jF5B;AACA;Ec/8jFQ,UAAA;Adi9jFR;AACA;Ec98jFM,UAAA;Adg9jFN;AACA;Ec98jFQ,qBAAA;Adg9jFR;AACA;Ech9jFS,kBAAA;EACC,gBZjqIqB;EFmnsF7B,cAAc;Ec/8jFP,+BAAA;Adi9jFT;AACA;Ech9jFU,kBAAA;EACC,cAAW;Adk9jFtB;AACA;Ech9jFU,kBAAA;EACC,gBZ3qIoB;EF6nsF7B,cAAc;Ac78jFT;Ad+8jFP;EACE,eAAe;Ac98jFT;Adg9jFR;EACE,cAAc;Ach9jFP;Adk9jFT;Ech9jFU,gBAAS;EACT,gBAAS;EACT,SAAS;EACT,gBAAA;EACA,gBAAgB;EAChB,iBAAa;Adk9jFvB;Acj9jFU;EACC,YAAS;EACT,gBAAS;Adm9jFpB;AACA;Ecj9jFW,mBAAmB;Edm9jF5B,gBAAgB;Ec/8jFT,cAAA;EACC,WAAA;Edi9jFR,cAAc;Ec18jFZ,gBAAA;EACC,kBAAW;EAIR,aAAQ;Ed28jFd,8BAA8B;Ecx8jF1B,sCAAA;EACC,4BAAe;Ad08jFtB;Acv8jFK;EACC,gBAAQ;Ady8jFd;Acv8jFK;EACC,sBAAiB;Ady8jFvB;Acx8jFM;EACC,cAAU;Ad08jFjB;AACA;Ecx8jFO,qBAAmB;Ad08jF1B;AACA;Ecx8jFO,gBAAc;EACd,kBAAkB;Ad08jFzB;Acz8jFO;EACC,cAAW;Ad28jFnB;AACA;Ecz8jFQ,eAAU;Ad28jFlB;AACA;EACE,mBAAmB;Ac18jFb;Ad48jFR;Ec18jFS,cAAa;EAGb,aAAU;EAGV,mBAAO;Ad48jFhB;Ac18jFQ;EAEC,aAAA;EACC,mBAAa;Ed68jFrB,mBAAmB;Ac18jFb;Ad48jFR;EACE,qBAAqB;Ac38jFd;Ad68jFT;EACE,YAAY;Ac18jFN;Ad48jFR;Ec18jFS,uBAAa;Ad48jFtB;AACA;Ec18jFS,gCAAkB;Ad48jF3B;AACA;Ec18jFS,kBAAU;Ad48jFnB;AACA;Ec18jFQ,kBAAA;Ad48jFR;AACA;EACE,UAAU;Ec38jFH,qBAAA;EACC,kBAAiB;Ed68jFzB,mBAAmB;Ec18jFb,WAAA;EACC,gBZ9uIQ;EY+uIR,cZ3xIc;EFuusFrB,kBAAkB;Ac38jFX;Ad68jFT;EACE,WAAW;Ec18jFL,kCAAA;EACC,mBAAa;EACb,kBAAgB;EAChB,YAAA;EACA,aAAa;Ad48jFtB;Acv8jFK;EACC,WAAQ;Edy8jFZ,4BAA4B;Ecx8jFxB,kCAAA;EACC,qCAAe;Ed08jFpB,kBAAkB;Ecz8jFb,MAAA;EACC,SAAA;Ed28jFN,OAAO;Ac18jFD;Ad48jFR;EACE,gCAAgC;Acz8jFzB;Ad28jFT;EACE,aAAa;Acv8jFJ;Ady8jFX;Ecv8jFY,gCAAkB;Ady8jF9B;Ac57jFG;EACC,aAAW;Ad87jFf;AACA;EACE,WAAW;Ec77jFT,+BAAA;EACC,kCAAgB;Ed+7jFnB,qCAAqC;Ecz7jFrC,kBAAA;EACC,MAAM;Ed27jFP,SAAS;Ecz7jFT,UAAA;EACC,WAAA;Ad27jFH;AACA;Ecv7jFC,mBAAA;EACC,WAAQ;Ady7jFV;AACA;Ecv7jFA,0BAA2B;Ady7jF3B;AACA;EACE,mBcv7jFgB;Edw7jFhB,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;Ecj7jFd,gBAAA;Edm7jFA,uBcl7jFY;Edm7jFZ,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,ecj7jFc;Adk7jFhB;AACA;Ec/6jFE,mBAAA;Adi7jFF;AACA;EACE,gBIr3sFsB;AJs3sFxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;Ecp7jFjB,kBAAA;Ads7jFH;AACA;EACE,YI/3sFM;EJg4sFN,gBI53sFuB;EJ63sFvB,gCIz3sF0B;AJ03sF5B;AACA;EACE,gBc17jFY;Ad27jFd;AACA;Ecr7jFA,YAAA;AACA;Adu7jFA;Ecr7jFC,eAAO;Adu7jFR;;AAEA;Ect7jFE,aAAS;Adw7jFX;;AAEA;Ect7jFE;IACA,cAAY;IACZ,eAAc;EACd;EACA;;;;IAIA,aAAc;EV3+IR;EAIA;IAYA,YAAc;EJs5sFpB;Ecz7jFA;IACC,OAAM;EACN;Ed27jFD;Icz7jFA,WAAA;IACC,mBAAc;Id27jFb,mBAAmB;Ec17jFpB;EACC;Idg8jFA,2BAA2B;Ec37jF1B;EACA;IACA,gBAAS;EACT;EACA;IAKA,wBAAmB;Ed67jFtB;Ec57jFG;IACC,gBAAS;EACT;Ad87jFN;AACA,ec77jFkB;Ad87jFlB;EACE,kBAAkB;Ec77jFd,0BAAA;Ad+7jFN;AACA;Ec17jFK,kBAAA;Ed87jFH,aAAa;Ecv7jFb,iBAAA;EACC,OAAO;Edy7jFR,YAAY;Ecv7jFZ,cAAA;EACC,MAAM;EACN,YAAY;Edy7jFb,UAAU;Ect7jFX,YAAA;EACC,gBAAS;EACT,+BAAoB;EAGpB,yBAAmB;Adw7jFrB;AACA;Ect7jFE,cAAM;EVtiJA,cAAA;AJ+9sFR;AACA;EACE,eAAe;Acz7jFf;Ad27jFF;Ecz7jFG,YAAS;Ad27jFZ;AACA;Ecz7jFG,kBAAW;EACX,mBZj+IoB;AF45sFvB;AACA;Ecz7jFG,oBAAU;Ed27jFX,mBAAmB;Ec17jFlB,kBAAA;EAGC,aAAa;EAGb,mBAAmB;Ad47jFvB;AACA;Ecx7jFI,aAAS;EACT,qBZj/ImB;EYk/InB,iBAAc;Ad47jFlB;AACA;Ec37jFI,qBAAA;Ad67jFJ;AACA;Ec37jFK,mCAAa;EACb,cAAA;Ad67jFL;AACA;EACE,eAAe;Ac57jFZ;Ad87jFL;Ec57jFM,YAAW;EACX,6BAAe;Ad87jFrB;Ac57jFK;EAID,aAAA;EACC,gBAAS;EACT,mBAAS;EACT,kBAAa;Ed67jFhB,YAAY;Ec57jFT,OAAA;Edg8jFH,yBAAyB;Ac77jFrB;Ad+7jFN;EACE,kBAAkB;EIphtFZ,aAAA;EAYA,YAAc;EUglJlB,gBAAgB;EAChB,iBAAW;EACX,YAAO;Ed87jFT,WAAW;Ac77jFT;Ad+7jFJ;Ec37jFO,aAAO;EAGR,mBAAA;EACC,8BAAoB;EACpB,sCAAoB;EACpB,4BAAa;EACb,YAAW;Ed+7jFhB,kBAAkB;Ec97jFb,gBAAA;EACC,gCAAY;EACZ,kBAAW;Adg8jFnB;AACA;Ec77jFS,aZ5/IQ;EYigJR,mBZjgJmB;AFg8sF5B;AACA;Ec97jFS,iBAAA;EACC,gBAAS;EACT,gBAAO;Adg8jFjB;Acz7jFQ;EACC,MAAK;Ad27jFd;AACA;Ecv7jFS,aAAa;Ad27jFtB;Act7jFO;EACC,mBAAmB;EACnB,qBAAgB;Adw7jFxB;AACA;EACE,cAAc;Act7jFP;Adw7jFT;EAGE,yBAAyB;Ecr7jFjB,gBAAA;Edw7jFR,SAAO;Ac/6jFH;Adi7jFN;Ec/6jFO,gBAAS;Adi7jFhB;AACA;Ec/6jFO,kBAAiB;EACjB,gCAAoB;Adi7jF3B;AACA;EAGE,aAAa;Ecj7jFP,oBAAA;Adm7jFR;AACA;EACE,YAAY;Ec/6jFN,WAAA;EACC,eZ7jJmB;AF8+sF5B;AACA;Ech7jFS,aAAA;EACC,eAAS;Adk7jFnB;AACA;Ec56jFO,aAAA;EACC,eAAc;Ad86jFtB;Ac76jFQ;EACC,UAAU;EACV,oBAAoB;Ad+6jF7B;AACA;Ec76jFS,cAAA;EACA,gBAAgB;EAChB,gBAAa;EACb,gBAAe;Ed+6jFtB,uBAAuB;Ec96jFhB,mBAAA;Adg7jFT;AACA;EI5ntFQ,mBAAoB;EAIpB,eAAiB;AJ6ntFzB;AACA;EAGE,2BAA2B;Ach7jFlB;Adk7jFX;Ech7jFY,cAAY;Adk7jFxB;AACA;Ec16jFQ,aAAA;EACC,oBAAS;Ed86jFhB,iBAAiB;Ec36jFV,oBAAA;EACC,UAAS;Ad66jFnB;Ac36jFS;EACC,eX/+IQ;AH45sFlB;Ac56jFU;EACC,aZjnJM;EF+htFf,eAAe;Acz6jFV;Ad26jFP;EItptFQ,aAAA;EAYA,eAAc;AJ6otFtB;AACA;Ec36jFS,UAAA;EACC,oBAAe;Ad66jFzB;Ac56jFU;EACC,eAAa;Ad86jFxB;Ac56jFU;EACC,iBAAW;EAEV,aZ1qJQ;EY6qJR,mBAAe;EACf,uBAAmB;Ad+6jF/B;Ac16jFQ;EACC,mBAAS;Ad46jFlB;Ac16jFQ;EACC,cX/gJS;EWihJR,gCAAS;Ad66jFnB;Acz6jFW;EACC,YAAW;Ad26jFvB;Acx6jFY;EACC,cZ1pJe;EFoktF1B,gBAAgB;Ec/5jFf,gBAAA;EACC,uBAAkB;EAClB,mBAAS;Adi6jFb;AACA;Ec/5jFI,UAAA;Adi6jFJ;AACA;Ec/5jFI,UAAQ;Adi6jFZ;AACA;Ec/5jFI,mBAAY;Adi6jFhB;AACA;EI3rtFQ,cAAc;AJ6rtFtB;Acl6jFI;EAGA,gCAAA;EACC,eZ9tJ0B;AFkotF/B;AACA;Ecl6jFK,gBAAgB;Ado6jFrB;AACA;Ecl6jFK,cAAa;Ado6jFlB;Acl6jFI;EACC,YAAY;Ado6jFjB;Acn6jFK;EAIC,cAAa;Edk6jFjB,gBAAgB;Ecr6jFZ,gBAAA;EACC,uBZ1uJwB;EFiptF7B,mBAAmB;Acp6jFf;Ads6jFN;EACE,UAAU;Acr6jFL;Adu6jFP;Ecr6jFQ,mBAAkB;Adu6jF1B;Acr6jFO;EACC,UZpvJY;AF2ptFpB;Acl6jFI;EACC,cAAc;Ado6jFnB;Acn6jFK;EAIC,cAAa;Adk6jFnB;Acr6jFM;EACC,kBZ7vJwB;EFoqtF7B,SAAS;Ecp6jFL,aAAA;EACC,YAAA;Eds6jFL,cAAc;Ec75jFb,SAAA;EACC,YAAO;Ed+5jFT,YAAY;Ec15jFZ,gBAAA;EACC,8BAAY;Ed45jFb,2CAA2C;EAG3C,yBAAyB;AAC3B;Acv5jFC;EACC,gBAAa;Ady5jFf;AACA;Ecv5jFA,cAAA;EACC,kBAAA;Edy5jFC,gBcx5jFK;Edy5jFL,gBAAgB;EAChB,gBAAgB;Ecv5jFlB,uBAA0B;EAExB,mBAAA;Adw5jFF;AACA;Ect5jFE,eAAA;Adw5jFF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBct5jFqB;Adu5jFvB;AACA;Ecp5jFE,gBAAA;Eds5jFA,kBI7xtFM;AJ8xtFR;AACA;EACE,cIpxtFqB;AJqxtFvB;AACA;Ecz5jFG,eAAA;Ad25jFH;AACA;Ecz5jFG,sBAAA;Ad25jFH;AACA;EACE,cIjytFM;AJkytFR;AACA;EACE,qBAAqB;AACvB;AACA;EACE,QAAQ;AACV;Ac15jFA;EACA,YAAA;Ad45jFA;AACA;EACE,eAAe;Ac35jFhB;;Ad85jFD;Ec35jFE,aAAS;Ad65jFX;;AAEA;Ec35jFE;IACA,MAAA;EACA;Ad65jFF;AACA;Ec35jFE;IACA,YZ11Je;EY21Jf;EVx6JM;IAIA,cAAiB;IAYjB,eAAc;EJwztFpB;Ec95jFA;IACC,OAAM;EACN;Edg6jFD;Ic95jFA,WAAA;IACC,mBAAc;Idg6jFb,mBAAmB;Ec/5jFpB;EACC;Idq6jFA,2BAA2B;Ech6jF1B;EACA;IACA,gBAAS;EACT;EACA;IAKA,wBAAmB;Edk6jFtB;Ecj6jFG;IACC,gBAAS;EACT;Adm6jFN;AACA,ccl6jFkB;Adm6jFlB;EACE,kBAAkB;Ecl6jFd,0BAAA;Ado6jFN;AACA;Ec/5jFK,kBAAA;Edm6jFH,aAAa;Ec55jFb,iBAAA;EACC,OAAM;EACN,YAAY;Ed85jFb,cAAc;Ec35jFf,MAAA;EACC,YAAS;EACT,UAAS;EACT,YAAS;EACT,gBAAgB;EAChB,+BAAmB;EAGnB,yBAAM;Ad65jFR;AACA;EI92tFQ,cAAc;EJg3tFpB,cAAc;Ac95jFd;Adg6jFF;Ec95jFG,eAAS;Adg6jFZ;AACA;Ec95jFG,YAAW;Adg6jFd;AACA;Ec95jFG,kBAAY;EACZ,mBAAU;Adg6jFb;Ac/5jFG;EACC,oBAAoB;EACpB,mBAAS;EACT,kBAAa;EAGb,aAAa;EAGb,mBAAe;Adi6jFnB;AACA;Ec75jFI,aAAS;Edi6jFX,qBAAqB;Ech6jFnB,iBAAA;Adk6jFJ;AACA;Ech6jFK,qBAAa;Adk6jFlB;AACA;Ech6jFK,mCAAmB;Edk6jFtB,cAAc;Acj6jFX;Adm6jFL;Ecj6jFM,YAAW;EACX,6BAAe;Adm6jFrB;Acj6jFK;EAID,aAAA;EACC,gBAAS;EACT,mBAAS;EACT,kBAAa;Edk6jFhB,YAAY;Ecj6jFT,OAAA;Edq6jFH,yBAAyB;Acl6jFrB;Ado6jFN;EACE,kBAAkB;EIn7tFZ,aAAA;EAYA,YAAc;EU0gKlB,gBAAgB;EAChB,iBAAW;EACX,YAAO;Edm6jFT,WAAW;Acl6jFT;Ado6jFJ;Ech6jFO,aAAS;EAET,mBAAA;EACC,8BAAkB;EAClB,sCAAU;EACV,4BAAS;EACT,YAAQ;EACR,kBAAS;EVxiKT,gBAAA;EAIA,gCAAyB;EAYzB,kBAAc;AJg8tFtB;Acr6jFO;EAGC,aAAa;EAGb,mBAAS;Adu6jFjB;AACA;EACE,iBAAiB;Ect6jFX,gBAAA;EACC,gBAAc;Adw6jFvB;Acv6jFS;EACC,MZ97JO;AFu2tFjB;AACA;EAGE,aAAa;Acv6jFN;Ady6jFT;Ecv6jFU,mBZt8JkB;EF+2tF1B,qBAAqB;Acx6jFZ;Ad06jFX;Ecx6jFW,cAAO;Ad06jFlB;Acp6jFQ;EAGA,yBAAA;EACC,gBAAS;EAGX,SAAA;Adq6jFP;AACA;Ecn6jFQ,gBAAA;Adq6jFR;Acn6jFS;EACC,kBAAe;EACf,cAAa;Adq6jFvB;AACA;Ecn6jFU,kBAAU;EACV,UAAO;EACP,SAAS;EACT,eAAW;EACX,UAAM;EAGN,yBAAoB;Adq6jF9B;AACA;Ecj6jFU,aAAa;EACb,kBAAgB;EAChB,WZ1hKa;EF+7tFrB,SAAS;Ec75jFN,UAAA;EACC,cAAQ;Ad+5jFd;Ac55jFQ;EACC,eAAS;Ad85jFlB;Acp5jFE;EACC,aAAY;Eds5jFb,eAAe;Acp5jFf;Ads5jFF;EACE,UAAU;AACZ;Acl5jFC;EACC,aAAa;EACb,eAAY;Ado5jFd;AACA;EACE,UAAU;Ecl5jFX,oBAAA;Ado5jFD;AACA;Ecl5jFE,UAAA;Ado5jFF;AACA;Ecl5jFC,UAAA;Ado5jFD;AACA;Ecl5jFE,iBAAU;EACV,sBAAQ;EACR,2BAAM;Ado5jFR;AACA;Ecl5jFE,gBAAU;EACV,sBAAa;EACb,kBAAS;EACT,kBAAe;EACf,WAAU;Edo5jFV,YAAY;Ecn5jFZ,iBAAA;EACC,YAAS;EACT,WAAS;EACT,kBAAa;EACb,qCAAyB;EAGzB,aAAA;EAGA,mBAAgB;EAChB,uBAAiB;EACjB,WAAO;Adq5jFV;AACA;EACE,gBAAgB;Acp5jFf;Ads5jFH;Ecp5jFI,UZhmKgB;AFs/tFpB;AACA;Ecp5jFI,YAAA;Ads5jFJ;AACA;Ecp5jFG,eAAA;Ads5jFH;;Acn5jFG;EACC,kCAAoB;EACpB,gFAAoB;EACpB,kCAAa;Eds5jFf,oDAAoD;Acr5jFlD;Adu5jFJ;Ecr5jFK,+BAAqB;Edu5jFxB,gFAAkE;Ect5jF/D,kCAAA;EACC,oDAAc;Adw5jFpB;Acj5jFI;EACC,YAAA;Edm5jFH,gBAAgB;Ecl5jFb,kBAAA;EACC,QAAO;Edo5jFX,MAAM;Ecn5jFF,YAAA;EACC,cAAW;EACX,UAAA;Edq5jFL,cAAc;Ecn5jFV,UAAA;EACC,gBZjoKwB;EFshuF7B,uFAAyE;Ac94jF1E;Adg5jFD;Ec54jFE,aAAY;EAGZ,mBAAY;EACZ,8BAAW;Edg5jFX,sCAAsC;Ec74jFtC,4BAAA;EACC,gBAAY;Ed+4jFb,kBAAkB;Ec54jFnB,YAAA;EACC,gCAAsB;Ed84jFtB,kBAAkB;Ac34jFlB;Ad64jFF;EACE,gBAAgB;Ec34jFhB,cAAA;EACC,gBAAgB;Ed64jFjB,gBAAgB;EAChB,uBAAuB;Ecz4jFxB,mBAAA;Ad24jFD;AACA;EACE,kBAAkB;Acz4jFpB;Ad24jFA;Ect4jFE,aAAA;Ad04jFF;AACA;EACE,mBAAmB;Ecv4jFlB,qBAAA;Ady4jFH;AACA;Ecv4jFG,cAAA;Ady4jFH;AACA;EACE,sBcx4jFqB;Ady4jFvB;AACA;EACE,qBIppuF4B;AJqpuF9B;AACA;EACE,gBI3ouFuB;EJ4ouFvB,kBIxouFoB;AJyouFtB;AACA;EACE,cc54jFW;Ad64jFb;AACA;EACE,sBI9puF4B;AJ+puF9B;AACA;EACE,uFIrpuF6B;AJspuF/B;AACA;Ech5jFI,YAAA;Edk5jFF,Wcj5jFY;Adk5jFd;AACA;Ec74jFE,YAAA;Ad+4jFF;AACA;Ec74jFE,sBAAA;Ad+4jFF;AACA;Ec74jFE,sBAAA;Ad+4jFF;AACA;Ec74jFE,sBAAA;Ad+4jFF;;AAEA;EACE,ac74jFa;Ad84jFf;;Acx4jFA;EACA;IACC,YAAS;EACT;Ed24jFC;Ic14jFD,cAAA;IACC,eAAU;EACV;EACA;IACA,OAAS;EACT;EACA;IACA,WAAY;IACZ,mBAAc;IACd,mBAAM;EACN;EACA;IVzzKM,2BAAmB;EAYnB;EJ+ruFN;Ic74jFA,gBAAA;EACC;EACA;IAIA,wBAAA;EACC;Edg5jFF;Ic94jFC,gBAAA;EACC;;Edi5jFF;Ic/4jFE,2BAAA;Edi5jFF;Ec/4jFG;IACA,2BAAmB;EACnB;EACA;IACA,aAAS;EACT;EACA;IACA,QAAA;EACA;Edi5jFH;Ich5jFG,WAAA;Edk5jFH;AACF;AACA,Ocl5jFM;Adm5jFN;Ecj5jFM,kBAAiB;EACjB,0BAAqB;Adm5jF3B;Acl5jFM;Edo5jFJ,kBAAkB;Ec94jFf,aAAA;EZl4KD,iBAAY;EYo4KV,OZ9uKW;EFgouFf,YAAY;Ec74jFZ,cAAA;EACC,MAAM;EACN,YAAY;Ed+4jFb,UAAU;Ec54jFX,YAAA;EACC,gBAAS;EACT,+BAAoB;EAGpB,yBAAmB;Ad84jFrB;AACA;Ec54jFE,cAAM;EVz3KA,cAAA;AJwwuFR;AACA;EACE,eAAe;Ac/4jFf;Adi5jFF;Ec/4jFG,YAAS;Adi5jFZ;AACA;Ec/4jFG,kBAAW;EACX,mBZpzKoB;AFqsuFvB;AACA;;Ec94jFG,oBAAM;Edi5jFP,mBAAmB;Ech5jFlB,kBAAA;EAGC,aAAa;EAGb,mBAAmB;Adk5jFvB;AACA;;Ec74jFI,aZr0Ka;EYs0Kb,iBAAc;EACd,qBAAiB;Adk5jFrB;Acj5jFI;;EAEC,qBAAoB;Adm5jFzB;AACA;Ecj5jFK,mCAAsB;EACtB,cAAa;Adm5jFlB;AACA;Ecl5jFK,YAAA;EACC,6BAAoB;Ado5jF1B;AACA;Ech5jFM,aAAa;Edo5jFjB,gBAAgB;Ecn5jFZ,mBAAA;EACC,kBAAS;EACT,YAAS;EACT,OAAO;EAGP,yBAAmB;Adq5jF1B;AACA;EACE,kBAAkB;EAGlB,aAAa;Ecr5jFP,YAAA;EACC,gBZvzKmB;EYwzKnB,iBZxzKmB;EF+suF1B,YAAY;Ecn5jFN,WAAA;EACC,0BZ7zKmB;AFktuF5B;AACA;Ecl5jFU,aAAO;EAOX,mBAAK;Edk5jFT,8BAA8B;Ec/4jF5B,sCAAA;EACC,4BAAyB;EACzB,YAAA;EACA,kBAAa;Edi5jFhB,gBAAgB;Ech5jFb,gCAAA;EACC,kBAAiB;Adk5jFvB;AACA;Ec94jFM,aAAA;Edo5jFJ,mBAAmB;Ec/4jFf,mBAAA;Adi5jFN;AACA;EAGE,aAAa;Ec/4jFT,iBAAA;EACC,gBAAW;Edi5jFhB,gBAAgB;Ac74jFd;Ad+4jFJ;EAGE,aAAa;Ec54jFT,mBAAmB;EACnB,oBAAS;Edg5jFb,kBAAkB;Ac/4jFd;Adi5jFN;Ech5jFO,eAAc;Adk5jFrB;Ac74jFG;EACC,aAAU;EACV,eAAW;Ad+4jFf;AACA;Ec74jFI,aAAS;EACT,eAAa;Ad+4jFjB;AACA;EI93uFQ,UAAA;EAYA,oBAAc;AJq3uFtB;Ach5jFI;EACC,MAAA;Adk5jFL;Acj5jFK;EAGC,mBAAa;Adm5jFnB;AACA;Ecj5jFM,kBAAa;EAGb,aAAa;EAEZ,mBAAS;EACT,kBAAS;Ado5jFhB;AACA;Ecl5jFO,eAAc;EACd,gBAAa;Edo5jFlB,cAAc;Ecl5jFR,0BAAA;Ado5jFR;AACA;Ecl5jFQ,mBAAA;Ado5jFR;AACA;EAGE,aAAa;Ac/4jFV;Adi5jFL;;Ec94jFM,mBAAa;EACb,qBAAW;Adi5jFjB;Ach5jFM;;EAEC,cAAS;Adk5jFhB;AACA;Ech5jFO,gBAAY;EAEZ,SAAA;Edo5jFL,aAAa;Ecj5jFR,eAAA;EAGC,yBAAkB;Adm5jF1B;AACA;Ecj5jFQ,gBAAQ;Adm5jFhB;AACA;EAGE,aAAa;EAGb,mBAAmB;Ec94jFX,8BAAA;EACC,sCAAoB;EACpB,4BAAoB;Adg5jF/B;AACA;Ec54jFW,aAAY;EAEZ,mBAAA;Adi5jFX;AACA;Ech5jFY,aAAA;Adk5jFZ;AACA;EACE,UAAU;Ec94jFA,uBAAA;EACC,eZ/8Ke;EYg9Kf,kBZh9Ke;AFg2uF5B;Ac/4jFa;Edm5jFX,aAAa;Ec54jFL,YAAA;Ad84jFV;AACA;Ec54jFU,iBAAA;EACC,kBAAS;EACT,UAAS;EACT,iBAAa;Ed84jFtB,kBAAkB;Ec34jFX,gBAAA;EACC,8BAAuB;Ed64jF/B,+BAA+B;Ec34jFtB,UAAA;Ad64jFX;AACA;Ecv4jFa,qBAAA;EACC,iCAAmB;Edy4jF/B,kBAAkB;Ec/3jFZ,gBAAA;EACC,kBAAiB;Edi4jFxB,QAAQ;Ech4jFD,UAAA;EACC,kBZz/KkB;EF23uF1B,2BAA2B;Ecj4jFnB,cAAA;Adm4jFV;AACA;Ecj4jFU,0BAAA;Adm4jFV;AACA;Ec/3jFW,aZvhLM;EY0hLN,mBZrgLiB;EFw4uF1B,oBAAoB;Ecj4jFZ,qBAAA;Adm4jFV;AACA;Ec13jFG,eAAA;Ad43jFH;AACA;Ec13jFI,aAAa;EACb,eAAY;Ad43jFhB;AACA;Ec13jFI,aAAW;EACX,eAAY;Ad43jFhB;AACA;EI/gvFQ,UAAA;EAIA,oBAAmB;AJ8gvF3B;AACA;Ec73jFI,cAAA;Ad+3jFJ;AACA;Ec33jFK,aAAA;Ad+3jFL;AACA;Ec73jFK,wBAAuB;Ad+3jF5B;AACA;Ec73jFK,oBAAe;Ad+3jFpB;AACA;Ec73jFK,mBAAc;Ad+3jFnB;AACA;Ec73jFM,iBAAA;Ad+3jFN;AACA;Ec73jFO,aZtkLsB;AFq8uF7B;AACA;EACE,UAAU;Ac93jFL;Adg4jFP;EACE,eAAe;Ac53jFZ;Ad83jFL;Ec53jFM,aAAS;EACT,eAAa;Ad83jFnB;Ac73jFM;EACC,aAAS;Ad+3jFhB;AACA;Ec73jFO,eAAA;Ad+3jFP;AACA;Ec73jFO,kBAAY;EACZ,SAAS;Ed+3jFd,aAAa;Ec93jFR,YAAA;EACC,cAAO;Edg4jFb,SAAS;Ec/3jFH,YAAA;EACC,YZzkLQ;EY0kLR,gBZ1kLmB;EF28uF1B,8BAA8B;Ec33jFvB,yBZhlLmB;AF+8uF5B;Ac93jFS;Edk4jFP,aAAa;EAGb,mBAAmB;Ec53jFd,8BAAA;EACC,sCAAc;Ed83jFpB,4BAA4B;Ecz3jF1B,kBAAA;EACC,gCAAe;Ed23jFlB,YAAY;Ecx3jFP,gBAAA;EACC,gCAAiB;Ed03jFvB,kBAAkB;Acv3jFZ;Ady3jFR;Ecv3jFS,oBZlpLsB;EF2gvF7B,kBAAkB;Ecj3jFZ,aAAA;EAeC,kBAAc;Edq2jFrB,0BAA0B;Acn3jFnB;Adq3jFT;EACE,aAAa;Acj3jFJ;Adm3jFX;Ec/2jFW,aAAA;Adm3jFX;AACA;EAGE,aAAa;Ect2jFH,mBAAS;EACT,oBAAa;EACb,kBAAiB;Ad02jF7B;AACA;Ecx2jFY,eAAe;Ad02jF3B;Acz2jFY;EACC,aAAY;EACZ,eZ7rLkB;AFwivF/B;Acz2jFY;EACC,aAAa;EACb,eAAc;Ad22jF3B;Act2jFW;EACC,UZprLK;EYqrLL,oBAAiB;Adw2jF7B;Act2jFW;EACC,qBAAe;Adw2jF3B;AACA;Ecr2jFU,cAAA;Adu2jFV;AACA;Ecj2jFQ,gBAAA;Adm2jFR;AACA;EACE,kBAAkB;Acl2jFX;Ado2jFT;Ecl2jFU,gBAAc;EV5yLhB,cAAA;AJipvFR;AACA;Ecp2jFU,sBAAoB;Ads2jF9B;Acr2jFU;EACC,kBAAe;Adu2jF1B;Acr2jFU;EACC,gBAAA;EACA,cAAc;Adu2jFzB;AACA;Ect2jFW,mBAAA;Adw2jFX;AACA;Ecv2jFY,kBAAA;Ady2jFZ;AACA;Ecp2jFY,aAAS;EAGT,mBAAgB;EAChB,mBAAmB;Adw2jF/B;AACA;Ect2jFa,gBAAA;EACC,cAAY;Adw2jF1B;AACA;EACE,oBAAoB;Ect2jFT,cAAA;Adw2jFb;AACA;Ect2jFc,cAAa;EACb,kBAAiB;Adw2jF/B;AACA;EACE,gBAAgB;Ecr2jFN,cAAA;Adu2jFZ;AACA;Ecr2jFa,oBAAe;Adu2jF5B;AACA;Ecr2jFa,eAAW;Edu2jFtB,gBAAgB;Acr2jFN;Adu2jFZ;Ecr2jFa,cAAU;Edu2jFrB,qBAAqB;EAGrB,qBAAqB;Ecl2jFV,qBAAA;Ado2jFb;AACA;Ecl2jFa,gBAAA;Ado2jFb;AACA;EAGE,mBAAmB;Acn1jFnB;Adq1jFF;EACE,kBAAkB;Ach1jFjB;Adk1jFH;EACE,kBAAkB;Ach1jFjB;Adk1jFH;Ecz0jFK,aAAS;EAIN,mBAAa;Ed40jFnB,YAAY;Acv0jFN;Ady0jFR;EACE,YAAY;Ec5zjFZ,SAAA;Ad+zjFF;AACA;EAGE,aAAa;Ec5zjFX,mBAAS;Adg0jFb;AACA;Ec9zjFI,cAAc;EACd,gBAAa;EACb,uBAAe;Edg0jFjB,mBAAmB;Ec/zjFjB,gBAAA;EACC,gBAAS;Adi0jFd;AACA;Ec/zjFK,kBAAY;Edi0jFf,mBAAmB;Ach0jFhB;Adk0jFL;EACE,yBAAyB;Acj0jFrB;Adm0jFN;Ecj0jFO,cZn0LU;AFsovFjB;Ac/zjFM;EACC,cZx0LqB;AFyovF5B;AACA;Ech0jFO,YAAA;Adk0jFP;AACA;EACE,eAAe;Ac7zjFb;Ad+zjFJ;Ec7zjFK,mBAAgB;Ad+zjFrB;Ac7zjFI;EACC,QAAO;Ad+zjFZ;AACA;Ec3zjFE,UAAA;Ad6zjFF;AACA;EACE,+BAA+B;AcxzjF/B;Ad0zjFF;EACE,cAAc;AAChB;;AAEA;EcpzjFE,aAAA;EdwzjFA,gBcvzjFe;AdwzjFjB;AACA;EAGE,aAAa;EAGb,mBctzjFgB;EduzjFhB,gBctzjFe;AduzjFjB;AACA;EAGE,aInyvFM;EJoyvFN,oBIhyvFuB;AJiyvFzB;AACA;EczzjFG,eAAA;Ad2zjFH;AACA;EczzjFG,aAAA;Ed2zjFD,eInzvFM;AJozvFR;AACA;EACE,aI1yvFM;EJ2yvFN,eIvyvFoB;AJwyvFtB;AACA;EACE,Uc/zjFU;Edg0jFV,oBAAoB;AACtB;Ac3zjFA;EAGG,eAAA;Ed2zjFD,gBc1zjFgB;Ad2zjFlB;AACA;EACE,yBc1zjFc;Ed2zjFd,cAAc;AAChB;AcvzjFA;EAII,mBAAA;AdszjFJ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;Ic/yjFF,YAAA;EACC;EdizjFC;IACE,cAAc;IchzjFhB,eAAA;EdkzjFA;EACA;IACE,OAAO;EACT;Ec9yjFF;IACA,WAAc;IACb,mBAAiB;IACjB,mBAAO;EdgzjFN;Ec/yjFD;IAKC,2BAAiB;EACjB;EACA;IACA,gBAAc;EACd;EACA;IVvjMM,wBAAsB;EAItB;EAYA;IJ+1vFJ,gBAAgB;EclzjFlB;AdozjFF;AACA;EACE;IclzjFA,eAAA;EACC;EdozjFD;IcnzjFC,2CAAA;EACC;AdqzjFJ;AcnzjFG;EACC;IACA,MAAA;IACA,WZh9La;IYi9Lb,YAAa;EdqzjFf;EcnzjFC;IACC,QAAA;EACA;AdqzjFJ;AcpzjFK;EACA;IACA,gBAAS;EACT;EACA;IACA,eAAS;IACT,8BAAa;EACb;AdszjFL;AACA,WcrzjFK;AdszjFL;EcpzjFM,kBAAA;EACC,0BAAgB;AdszjFvB;AACA;EcpzjFO,kBAAiB;EVtlMhB,aAAgB;EAIhB,iBUmlMkB;EV/kMlB,OAAA;EAhBA,YAAA;EAIA,cAAA;EAYA,MAAA;EFzCJ,YAAO;EFs7vFT,UAAU;EczzjFL,YAAA;EVpmMC,gBAAA;EAIA,+BUimMmB;EVrlMnB,yBUqlMmB;Ad+zjF3B;Ac3zjFK;EACC,cAAS;EACT,cAAS;Ad6zjFf;AACA;Ec3zjFM,eAAW;Ad6zjFjB;Ac5zjFM;EACC,YAAS;Ad8zjFhB;AczzjFI;EACC,oBAAmB;Ed2zjFtB,mBAAmB;EcxzjFhB,cAAA;EZtpMD,gBAAY;AFi9vFhB;AACA;EcpzjFG,kBAAA;EACC,mBAAc;AdszjFlB;AcnzjFE;EACC,oBAAY;EACZ,mBAAY;EdqzjFb,kBAAkB;EchzjFlB,aAAS;EAGT,mBAAc;AdozjFhB;AACA;EclzjFE,gBAAM;EVlpMA,+DAA4B;EAI5B,oBAAmB;EAYnB,iBAAc;EUuoMnB,qCAAoB;EAGpB,yBZ7kMoB;EY8kMpB,4BAAiB;AduzjFpB;AACA;EclzjFI,wCAAa;AdwzjFjB;AACA;EcpzjFI,aAAA;EACA,qBAAe;EACf,iBAAW;AdwzjFf;AACA;EctzjFI,qBAAc;AdwzjFlB;AACA;EcvzjFI,oBAAA;AdyzjFJ;AACA;EcvzjFK,mCAAa;EACb,cAAA;AdyzjFL;AACA;EACE,qBAAqB;AcxzjFlB;Ad0zjFL;EcxzjFM,YAAW;EACX,6BAAe;Ad0zjFrB;AcxzjFK;EAID,aAAA;EACC,gBAAS;EACT,uBAAoB;EACpB,kBAAa;EdyzjFhB,YAAY;EcxzjFT,OAAA;Ed4zjFH,yBAAyB;AczzjFrB;Ad2zjFN;EACE,kBAAkB;EI5/vFZ,aAAA;EAYA,YAAc;EU4rMlB,gBAAgB;EAChB,iBAAW;EACX,YAAO;Ed0zjFT,WAAW;AczzjFT;Ad2zjFJ;EAGE,aAAa;EcxzjFT,mBAAY;EACZ,8BAAyB;EACzB,sCAAsB;EACtB,4BAAmB;Ed4zjFvB,YAAY;EczzjFR,kBAAA;EACC,gBAAa;Ed2zjFlB,gCAAgC;Ec1zjF3B,kBAAA;Ad4zjFP;AACA;EctzjFM,aAAA;EAEC,mBAAgB;Ad2zjFvB;Ac1zjFO;EACC,iBAAa;Ed4zjFnB,gBAAgB;EczzjFZ,gBAAA;Ad2zjFN;AACA;EczzjFO,MAAK;Ad2zjFZ;Ac1zjFO;EACC,aAAa;Ad8zjFrB;Ac3zjFM;EACC,mBAAa;EACb,qBAAW;Ad6zjFlB;AACA;Ec3zjFM,cAAA;Ad6zjFN;AACA;EAGE,yBAAyB;Ec3zjFnB,gBAAA;EAEC,SAAA;Ad6zjFT;AACA;EACE,gBAAgB;AczzjFZ;Ad2zjFN;;EcxzjFO,gBAAS;Ed4zjFd,aAAa;EAGb,mBAAmB;AcxzjFd;Ad0zjFP;EACE,kBAAkB;ActzjFb;AdwzjFP;EctzjFQ,eAAS;AdwzjFjB;AcvzjFQ;EACC,yBAAc;EdyzjFrB,iCAAiC;AcpzjF5B;AdszjFP;EcpzjFQ,iBAAa;AdszjFrB;AclzjFS;EACC,cAAY;AdozjFtB;AACA;;;EAGE,WAAW;Ac7yjFP;Ad+yjFN;;;Ec3yjFM,gBAAA;Ad+yjFN;AACA;Ec7yjFO,cAAa;EACb,WAAW;Ed+yjFhB,iBAAiB;Ac9yjFZ;AdgzjFP;Ec9yjFQ,cAAW;AdgzjFnB;AACA;Ec/yjFQ,aAAA;AdizjFR;AACA;EACE,UAAU;Ec7yjFJ,uBAAA;EACC,eZ3sMmB;EY4sMnB,kBZ5sMmB;AF2/vF5B;Ac9yjFS;EACC,eAAS;EACT,oBAAmB;EdgzjF3B,qBAAqB;EcryjFrB,WAAA;AduyjFF;AACA;EcryjFE,SAAA;AduyjFF;AACA;EACE,wBAAwB;AclyjFzB;AdoyjFD;EACE,kBAAkB;EAClB,UAAU;AclyjFZ;AdoyjFA;EACE,kCAAkC;AACpC;AACA;EACE,qBAAqB;Ec1xjFvB,sBAAA;Ad4xjFA;AACA;EACE,iBAAiB;EczxjFjB,sBAAA;Ed2xjFA,2Bc1xjFe;Ed2xjFf,gBc1xjFe;Ed2xjFf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EcxxjFjB,gCAAA;Ad0xjFH;AACA;EcrxjFE,aAAA;EdyxjFA,oBI3pwF0B;AJ4pwF5B;AACA;EACE,YIlpwFM;EJmpwFN,WI/owFkB;EJgpwFlB,eAAe;AACjB;AACA;EACE,aAAa;Ec5xjFZ,eAAA;Ad8xjFH;AACA;EACE,aI/pwFM;EJgqwFN,eI5pwFqB;AJ6pwFvB;AACA;EcjyjFI,UAAA;EdmyjFF,oBclyjFmB;AdmyjFrB;AACA;Ec7xjFA,YAAW;AACX;Ad+xjFA;Ec7xjFC,eAAO;Ad+xjFR;;AAEA;Ec9xjFE,aAAS;AdgyjFX;;AAEA;Ec9xjFE;;IAEA,aAAc;EACd;AdgyjFF;AACA;Ec9xjFE;IACA,YZr1Me;EYs1Mf;EVn6MM;IAIA,cAAiB;IAYjB,eAAc;EJsrwFpB;EcjyjFA;IACC,OAAM;EACN;EdmyjFD;IcjyjFA,eAAA;IACC,uBAAc;IdmyjFb,uBAAuB;EclyjFxB;EACC;IAKA,2BZxzMwB;EYyzMxB;EdoyjFF;IclyjFC,gBAAA;EACC;EACA;IAIC,wBAAkB;EAClB;EACA;IACA,gBAAa;EACb;AdqyjFL;AACA,UcpyjFK;AdqyjFL;EcpyjFK,kBAAA;EACC,0BAAoB;AdsyjF1B;AACA;EcpyjFM,kBAAc;EAEd,aAAA;EACC,iBAAS;EduyjFd,OAAO;EclyjFJ,YAAA;EZ1+MD,cAAY;EY4+MV,MAAK;EdoyjFT,YAAY;Ec/xjFZ,UAAA;EACC,YAAY;EACZ,gBAAY;EdiyjFb,+BAA+B;Ec5xjF/B,yBAAoB;AdgyjFtB;AACA;Ec9xjFE,cAAc;EACd,cAAS;AdgyjFX;AACA;EIhwwFQ,eAAA;AJkwwFR;AACA;EACE,YAAY;AcjyjFZ;AdmyjFF;EcjyjFG,oBAAoB;EACpB,mBAAa;EACb,cAAA;EACA,gBAAgB;AdmyjFnB;AACA;EcjyjFG,kBAAA;EACA,mBAAe;AdmyjFlB;AACA;EcjyjFG,oBZl6MoB;EYm6MpB,mBAAc;EACd,kBAAiB;EAEhB,aAAS;EAGT,mBAAmB;AdoyjFvB;AACA;EcjyjFK,aAAW;EACX,qBAAgB;EAChB,iBAAe;AdqyjFpB;AcnyjFI;EACC,qBAAK;AdqyjFV;AclyjFG;EACC,mCAAyB;EACzB,cAAc;AdoyjFlB;AACA;EcnyjFI,YAAA;EACC,6BAAiB;AdqyjFtB;AACA;EcjyjFK,aAAA;EACA,gBAAa;EACb,uBAAiB;EdqyjFpB,kBAAkB;EclyjFf,YAAA;EACC,OAAA;EAGA,yBAAe;AdoyjFrB;AclyjFK;EAKF,aAAA;EAGC,mBAAa;EdkyjFf,8BAA8B;EcjyjF5B,sCAAA;EACC,4BAAmB;EACnB,YAAS;EdmyjFZ,kBAAkB;EclyjFf,gBAAA;EACC,gCAAc;EdoyjFlB,kBAAkB;Ac/xjFlB;AdiyjFF;Ec7xjFG,aAAa;EAGb,mBAAiB;AdiyjFpB;AACA;EACE,iBAAiB;EchyjFhB,gBAAA;EVnjNK,gBAAA;AJs1wFR;AACA;EclyjFI,MAAA;AdoyjFJ;AACA;EcjyjFK,mBAAe;AdqyjFpB;AcpyjFK;EdsyjFH,kBAAkB;EclyjFd,aAAY;EAGZ,mBAAmB;EdsyjFvB,kBAAkB;AcnyjFd;AdqyjFN;EACE,eAAe;EcpyjFV,gBAAA;EACC,cAAa;EdsyjFnB,0BAA0B;AclyjFvB;AdoyjFL;EclyjFM,mBAAA;AdoyjFN;AcnyjFM;EAEC,aAAA;AdsyjFP;AACA;EcnyjFM,mBAAA;EdqyjFJ,qBAAqB;AACvB;AACA;EACE,cAAc;AcpyjFT;AdsyjFP;EACE,kBAAkB;EcnyjFd,aAAA;EACC,YAAW;EACX,gBAAW;EACX,iBAAiB;EduyjFtB,YAAY;EcryjFR,WAAA;AduyjFN;AACA;EAGE,yBAAyB;EcryjFnB,gBAAA;EAEC,SAAA;AduyjFT;AACA;EACE,gBAAgB;AcnyjFZ;AdqyjFN;;EclyjFO,gBAAS;EdsyjFd,aAAa;Ec/xjFR,mBAAS;AdmyjFhB;AACA;EACE,kBAAkB;AclyjFb;AdoyjFP;EACE,eAAe;AcnyjFT;AdqyjFR;EcnyjFS,yBZvgNmB;EF4ywF1B,iCAAiC;AcjyjF3B;AdmyjFR;EcjyjFS,iBZ7gNmB;AFgzwF5B;AclyjFS;EACC,cAAS;AdoyjFnB;AACA;;;Ec5xjFM,WAAO;AdgyjFb;Ac5xjFS;;;EdgyjFP,gBAAgB;Ac9xjFR;AdgyjFV;Ec/xjFW,cAAA;EACA,WAAA;EdiyjFT,iBAAiB;Ac/xjFT;AdiyjFV;EchyjFW,cAAA;AdkyjFX;AACA;Ec5xjFM,aAAA;Ad8xjFN;AACA;EACE,UAAU;Ec7xjFN,uBAAA;Ed+xjFJ,eAAe;EACf,kBAAkB;AACpB;AACA;Ec/xjFO,eAAc;EdiyjFnB,oBAAoB;EchyjFf,qBAAA;EdkyjFL,WAAW;AACb;AACA;EAGE,aAAa;EctyjFP,oBAAO;AdwyjFf;AcryjFM;EduyjFJ,eAAe;AACjB;AACA;EcnyjFG,aAAA;EACC,eAAU;AdqyjFd;AACA;EcnyjFI,aAAY;EACZ,eAAc;AdqyjFlB;AACA;EcnyjFI,UAAQ;EACR,oBZhnNmB;AFq5wFvB;AACA;;EIn9wFQ,yBAAoB;AJs9wF5B;ActyjFI;;EdyyjFF,yBAAyB;AchyjFvB;AdkyjFJ;;Ec/xjFI,+BAAA;EACC,kCAAO;AdkyjFZ;Ac5xjFE;;Ed+xjFA,gCAAgC;Ec5xjFhC,mCAAA;Ad8xjFF;AACA;;EczxjFC,gBAAA;Ad4xjFD;AACA;;;;EAIE,yBAAyB;EACzB,mBcvxjFiB;AdwxjFnB;AACA;;;;;;;EAOE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;Ac1wjFpB;Ad4wjFA;EACE,kBcxwjFQ;EdywjFR,SAAS;EcpwjFJ,aAAA;EdswjFL,YcrwjFgB;EdswjFhB,ccrwjFM;EdswjFN,SAAS;EcrwjFH,YAAA;EduwjFN,YctwjFgB;EduwjFhB,gBAAgB;Ec/vjFhB,8BAAA;EAGA,yBAAA;AdiwjFF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,Qc/vjFE;AdgwjFJ;AACA;Ec7vjFE,YAAA;Ad+vjFF;AACA;EACE,eIjixFsB;AJkixFxB;;AAEA;EclwjFG,aAAA;AdowjFH;;AAEA;EACE;;IIzixFM,aAAgB;EJ4ixFtB;AACF;AACA;EcvwjFI;IACC,2CAAgB;EdywjFnB;EACA;IcnwjFF,eAAgB;EAChB;EACC;IACA,eAAO;EdqwjFN;AcpwjFD;AdswjFD;EcpwjFE;IACA,MAAO;EACP;EACA;IACA,gBAAO;IACP,iCAAY;EACZ;EACA;IACA,gBAAW;EACX;EACA;IACA,YZ3vNe;EY4vNf;EVz0NM;IAIA,cAAiB;IAYjB,eAAc;EJkkxFpB;EcvwjFA;IACC,OAAM;EACN;EdywjFD;IcvwjFA,eAAA;IACC,uBAAc;IdywjFb,uBAAuB;EcxwjFxB;EACC;IAKA,2BZ9tNwB;EY+tNxB;Ed0wjFF;IcxwjFC,gBAAA;EACC;EACA;IAIC,wBAAkB;EAClB;EACA;IACA,gBAAa;EACb;Ad2wjFL;AACA,ec1wjFkB;Ad2wjFlB;Ec1wjFK,kBAAA;EACC,0BAAoB;Ad4wjF1B;AACA;Ec1wjFM,kBAAc;EAEd,aAAA;EACC,iBAAS;Ed6wjFd,OAAO;EcxwjFJ,YAAA;EZh5ND,cAAY;EYk5NV,MAAK;Ed0wjFT,YAAY;EcrwjFZ,UAAA;EACC,YAAY;EACZ,gBAAY;EduwjFb,+BAA+B;EclwjF/B,yBAAoB;AdswjFtB;AACA;EcpwjFE,cAAc;EACd,cAAS;AdswjFX;AACA;EI5oxFQ,eAAA;AJ8oxFR;AACA;EACE,YAAY;AcvwjFZ;AdywjFF;EcvwjFG,oBAAoB;EACpB,mBAAS;EACT,cAAa;EACb,gBAAW;AdywjFd;AACA;EcvwjFG,kBAAY;EACZ,mBAAU;AdywjFb;AcxwjFG;EACC,oBAAoB;EACpB,mBAAS;EACT,kBAAa;EAGb,aAAa;EAGb,mBAAe;Ad0wjFnB;AACA;EctwjFI,aAAS;Ed0wjFX,qBAAqB;EczwjFnB,iBAAA;Ad2wjFJ;AACA;EczwjFK,qBAAa;Ad2wjFlB;AACA;EczwjFK,mCAAmB;Ed2wjFtB,cAAc;Ac1wjFX;Ad4wjFL;Ec1wjFM,YAAW;EACX,6BAAe;Ad4wjFrB;Ac1wjFK;EAID,aAAA;EACC,gBAAS;EACT,uBAAoB;EACpB,kBAAa;Ed2wjFhB,YAAY;Ec1wjFT,OAAA;Ed8wjFH,yBAAyB;Ac3wjFrB;Ad6wjFN;EACE,kBAAkB;EInsxFZ,aAAA;EAYA,YAAc;EUi7NlB,gBAAgB;EAChB,iBAAW;EACX,YAAO;Ed4wjFT,WAAW;Ac3wjFT;Ad6wjFJ;Ec1wjFM,aZt3Nc;EYy3Nd,mBAAmB;EACnB,8BAAe;Ed8wjFnB,sCAAsC;Ec5wjFnC,4BAAA;EACC,YAAU;EACV,kBAAc;Ed8wjFlB,gBAAgB;EczwjFV,gCAAA;EACC,kBAAiB;Ad2wjF1B;AcvwjFU;EAGC,aAAa;EAGb,mBAAmB;AdywjF9B;AACA;EcxwjFW,iBAAA;EACC,gBAAe;EACf,gBZl5NmB;AF4pxF/B;AcxwjFW;EACC,MAAA;Ad0wjFZ;AACA;EcnwjFW,aAAU;AduwjFrB;AcrwjFU;EACC,mBAAe;EACf,qBZz4N0B;AFgpxFrC;AcpwjFS;EACC,cAAW;AdswjFrB;Ac/vjFQ;EAIC,yBAAA;EACC,gBAAe;EdiwjFvB,SAAO;Ac3vjFD;Ad6vjFR;EACE,gBAAgB;Ac3vjFV;Ad6vjFR;Ec3vjFS,cZp6N4B;EFiqxFnC,gBAAgB;EczvjFV,uBAAA;EACC,mBAAY;EACZ,gBAAW;Ad2vjFpB;ActvjFK;EACC,mBAAgB;EdwvjFpB,sBAAsB;AcpvjFjB;AdsvjFP;EACE,kBAAkB;Ac7ujFlB;Ad+ujFF;Ec3ujFG,aAAY;EAKd,mBAAA;EACC,qBAAa;Ad6ujFf;AACA;Ec3ujFA,gBAAA;EAEE,cAAA;Ad4ujFF;AACA;Ec1ujFE,oBAAA;Ed4ujFA,cc3ujFY;Ad4ujFd;AACA;EczujFG,cAAA;Ed2ujFD,kBc1ujFS;Ad2ujFX;AACA;EACE,gBc1ujFO;Ed2ujFP,cc1ujFc;Ad2ujFhB;AACA;EcxujFE,oBAAA;Ad0ujFF;AACA;EACE,kBI3yxFwB;AJ4yxF1B;AACA;EACE,gBAAgB;Ec7ujFf,cAAA;Ad+ujFH;AACA;Ec7ujFG,kBAAA;Ad+ujFH;AACA;EACE,gBIrzxFsB;EJszxFtB,cIlzxFqB;AJmzxFvB;AACA;EclvjFI,qBAAA;EdovjFF,oBcnvjFmB;AdovjFrB;AACA;Ec9ujFA,iBAAmB;AACnB;AdgvjFA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,ac9ujFQ;Ad+ujFV;;AAEA,mEAAmE;;;AAGnE;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;EACE,kCAAkC;AACpC;AACA,2CAA2C;AAC3C,+DAA+D;AAC/D;EACE;AACF,eAAe;AACf,uBAAuB;AACvB,mBAAmB;EACjB;AACF;EACE,sBAAsB;GACrB,kBAAkB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;AACA;EACE;AACF,eAAe;AACf,uBAAuB;AACvB,mBAAmB;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,aAAa;EACb;IACE,eAAe;IACf,oDAAoD;IACpD,6BAA6B;IAC7B,oBAAoB;IACpB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,oDAAoD;IACpD,6BAA6B;IAC7B,oBAAoB;IACpB,oCAAoC;IACpC,iBAAiB;EACnB;EACA;AACF;EACE;AACF,eAAe;AACf;AACA;AACA;EACE,YAAY;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,2CAA2C;;AAE3C;EACE;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,OAAO;EACT;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IAKE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IAKE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;AACF;AACA,kBAAkB;AAClB;EACE;;;;;;;;;;;IAWE,2BAA2B;EAC7B;EACA;;;;;;;;;;;IAWE,0BAA0B;EAC5B;AACF;;;AAGA,2CAA2C;AAC3C;EACE,aAAa;EACb,gBAAgB;AAClB;AACA,iDAAiD;AACjD,wEAAwE;AACxE;EACE,YAAY;EACZ,sBAAsB;EACtB;AACF;AACA;EACE,gBAAgB;AAClB;AACA,wEAAwE;AACxE,gFAAgF;AAChF;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;AACA,wEAAwE;AACxE;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;EAC7B;AACF;AACA;EACE,gBAAgB;EAChB","sourcesContent":["@charset \"UTF-8\";\n/*------------------------------------------------------------------\n[Master Stylesheet]\nProject:\tJampack\n++++ Imports ++++\n++++ Reset ++++\n++++ Basic ++++\n\n\t++CSS Basic++\n\t++Media Object++\n\t++Gap++\n\t++Position++\n\t++Padding++\n\t++Margin++\n\t++Background Colors++\n\t++Text Colors++\n\t++Border++\n\t++Colors++\n\t++Shadow++\n\t++Font Size++\t\n\t++Font Weight++\n\t++Text Case++\n\t++Letter Spacing++\n\t++Line Height++\n\t++Width++\n\t++Width In Percentage++\n\t++Max Width++\n\t++Min Width++\n\t++Height++\n\t++Height In Percentage++\n\t++Max Height++\n\t++Min Height++\n\t++Hr++\n\t++opacity++\n\t++Div Sizes++\n\t++Z-Index++\n\t++Loader++\n\t++Scrollbar++\n\t++Separator++\n\t++Typography++\n\t++Buttons++\n\t++Wrapper++\n\t++Gutter++\n\t++Hk Section++\n\t++Card++\n\t++Placehoder++\n\t++Placehoder++\n\t++Breadcrumb++\n\t++Page Header++\n\t++Page Body++\n\t++Form++\n\t++Checkbox++\n\t++Form Switch++\n\t++Form Range++\n\t++Form validation++\n    ++Inut group++\n    ++Inut search++\n    ++Spinner++\n    ++Input Spinner++\n\t++Select2++\n\t++Tinymce++\n\t++File Upload++\n\t++Form-Wizard++\n\t++Popover++\n\t++Collapse++\n\t++Accordion++\n\t++Table++\n\t++Data Table++\n\t++Advance Table++\n\t++Apex Chart++\n\t++charts++\n\t++Nestable++\n\t++Treeview++\t\n\t++Modals++\n\t++Close++\n\t++Sweet-alert++\n\t++Notification++\n\t++Toast++\n\t++Bootstrap Notify++\n\t++Tooltop++\n\t++Images++  \n\t++Icons++\n    ++Carousel++\n\t++Twitter slider++\n\t++Color Pickr++\n\t++Range Slider++\n\t++Daterangepicker++\n\t++Profile++\n\t++Activity++\n\t++Wizards++\n\t++Pricing Table++\n\t++Dropdown++\n\t++Avatar++\n\t++Pagination++\n\t++Badge++\n\t++List Group++\n\t++Google Map++\n\t++Vecotor Map++\n\t++Progressbar++\n\t++Togglable++\n\t++Advance List++\n\t++Light Gallery++\n\t++Cropperjs++\n\t++Bootstrap TimeOut++\n\t++Hopscotch++\n\t++Rating++\n\t++Tinyemce++\n\t++Chips++\n\t++Playlist widget++\n\t++Ribbons++\n\t++Advance Badges++\n\t++Callout++\n\t++Toolbar++\n\t++Filter Component++\n\t++Content sidebar++\n\t++Fixed Footer++\n\t++Dragula++\n\t++Fixed Footer++\n\t++Authantication Pages++\n\t++Fixed Footer++\n\n++++ Componets Import ++++\t\n-------------------------------------------------------------------*/\n/****************************/\n/** Imports **/\n/****************************/\n@import url(https://fonts.googleapis.com/icon?family=DM+Sans:400,500,700&display=swap||Material+Icons);\n@import url(../../vendors/bootstrap/dist/css/bootstrap.min.css);\n@import url(font-awesome.min.css);\n@import url(dripicons.css);\n@import url(cryptofont.min.css);\n@import url(themify-icons.css);\n@import url(animate.css);\n@import url(flag-icon.min.css);\n@import url(twemoji.min.css);\n@import url(material-design-iconic-font.min.css);\n@import url(remixicon.css);\n@import url(material-icons.css);\n@import url(line-awesome.min.css);\n@import url(bootstrap-icons.css);\n@import url(flaticon.css);\n@import url(prism.css);\n@import url(../../vendors/simplebar/dist/simplebar.min.css);\n@import url(../../vendors/owl.carousel/dist/assets/owl.carousel.min.css);\n@import url(../../vendors/owl.carousel/dist/assets/owl.theme.default.min.css);\n@import url(\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css\");\n/*__________________________________________________________________;\n[Mixin]\nProject:\tJampack\n___________________________________________________________________*/\n/*Shadow*/\n/*Table Variants*/\n/*__________________________________________________________________;\n[Variables]\nProject:\tJampack\n___________________________________________________________________*/\n:root {\n  --bs-body-font-family: 'DM Sans', sans-serif;\n  --bs-text-opacity:1;\n  --bs-bg-opacity: 1;\n}\ninput::-ms-reveal,\ninput::-ms-clear {\ndisplay: none;\n}\n\n/****************************/\n/** Reset **/\n/****************************/\nhtml, body, div, span, applet, object, iframe, p, pre, a, abbr, acronym, address, big, cite, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, fieldset, form, label, legend, caption, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\nem, cite {\n  font-style: italic;\n}\n\nstrong {\n  font-weight: bold;\n}\n\nbody {\n  color: #6f6f6f;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: transparent;\n  height: 100%;\n  \n}\n/****************************/\n/** hide scrolbar **/\n::-webkit-scrollbar {display:none;}\n/****************************/\n\n.main-font, .jq-toast-wrap .jq-toast-single, .jq-toast-wrap .jq-toast-single .jq-toast-heading, .infowindow-wrap .infowindow-header, .infowindow-wrap .infowindow-body {\n  font-family: var(--bs-body-font-family);\n}\n\na:hover, a:active {\n  outline: 0;\n}\n\nul {\n  list-style: none;\n}\nul.list-ul {\n  list-style: disc;\n}\nul.list-ul ul {\n  list-style-type: circle;\n}\nul.list-icon {\n  list-style: none;\n  padding-left: 0;\n}\nul.list-icon > li {\n  padding-left: 1.875rem;\n  counter-increment: li;\n}\nul.list-icon > li i,\nul.list-icon > li .feather-icon,\nul.list-icon > li .svg-icon {\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  text-align: center;\n  margin-left: -1.25rem;\n  position: relative;\n  left: -10px;\n  padding: 1px;\n  top: -1px;\n}\nul.list-icon > li i {\n  font-size: 21px;\n  top: 5px;\n}\nul.hk-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0 -.68rem;\n  padding-left: 0;\n}\nul.hk-list li {\n  padding: .68rem;\n}\nul.hk-list.hk-list-sm {\n  margin: 0 -.4rem;\n}\nul.hk-list.hk-list-sm li {\n  padding: .4rem;\n}\n\na {\n  text-decoration: none;\n  color: #0a2f4c;\n  -webkit-transition: color 0.2s ease;\n  -moz-transition: color 0.2s ease;\n  transition: color 0.2s ease;\n}\na:hover {\n  text-decoration: none;\n  color: #3d9ca5;\n}\na:focus {\n  text-decoration: none;\n  outline: none;\n  color: #3d9ca5;\n}\na.link-info {\n  color: #18DDEF !important;\n}\na.link-info:hover, a.link-info:focus {\n  color: #4fe5f3 !important;\n}\na.link-success {\n  color: #00D67F !important;\n}\na.link-success:hover, a.link-success:focus {\n  color: #3de09e !important;\n}\na.link-warning {\n  color: #FFC400 !important;\n}\na.link-warning:hover, a.link-warning:focus {\n  color: #ffd23d !important;\n}\na.link-danger {\n  color: #FF0000 !important;\n}\na.link-danger:hover, a.link-danger:focus {\n  color: #ff3d3d !important;\n}\na.link-primary {\n  color: #0a2f4c !important;\n}\na.link-primary:hover, a.link-primary:focus {\n  color: #3d9ca5 !important;\n}\na.link-muted {\n  color: #6f6f6f !important;\n}\na.link-muted:hover, a.link-muted:focus {\n  color: #b5b5b5 !important;\n}\na.link-secondary {\n  color: #6f6f6f !important;\n}\na.link-secondary:hover, a.link-secondary:focus {\n  color: #929292 !important;\n}\na.link-dark {\n  color: #262a2e !important;\n}\na.link-dark:hover, a.link-dark:focus {\n  color: #2a2f34 !important;\n}\na.link-light {\n  color: #9e9e9e !important;\n}\na.link-light:hover, a.link-light:focus {\n  color: #b5b5b5 !important;\n}\na.link-white {\n  color: #fff !important;\n}\na.link-white:hover, a.link-white:focus {\n  color: rgba(255, 255, 255, 0.8);\n}\na.link-disabled {\n  color: #b5b5b5 !important;\n  pointer-events: none;\n  user-select: none;\n}\na.link-disabled:hover, a.link-disabled:focus {\n  color: #b5b5b5 !important;\n}\na.link-high-em {\n  font-weight: 500;\n}\na.link-medium-em {\n  font-size: .875rem;\n}\na.link-low-em {\n  font-size: .75rem;\n}\n\nh1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\n  color: #262a2e;\n}\n\n.heading-wth-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n}\n.heading-wth-icon .head-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.heading-wth-icon .head-icon i {\n  line-height: 0;\n}\n\n.h1.heading-wth-icon .head-icon, h1.heading-wth-icon .head-icon {\n  margin-right: 1.125rem;\n}\n\n@media (max-width: 1199px) {\n  .h1.heading-wth-icon .head-icon, h1.heading-wth-icon .head-icon {\n    margin-right: 1.125rem;\n  }\n}\n.h2.heading-wth-icon .head-icon, h2.heading-wth-icon .head-icon {\n  margin-right: 1rem;\n}\n\n@media (max-width: 1199px) {\n  .h2.heading-wth-icon .head-icon, h2.heading-wth-icon .head-icon {\n    margin-right: 1.125rem;\n  }\n}\n.h3.heading-wth-icon .head-icon, h3.heading-wth-icon .head-icon {\n  margin-right: .875rem;\n}\n\n@media (max-width: 1199px) {\n  .h3.heading-wth-icon .head-icon, h3.heading-wth-icon .head-icon {\n    margin-right: 1.125rem;\n  }\n}\n.h4.heading-wth-icon .head-icon, h4.heading-wth-icon .head-icon {\n  margin-right: .75rem;\n}\n\n.h5.heading-wth-icon .head-icon, h5.heading-wth-icon .head-icon {\n  margin-right: .625rem;\n}\n\n.h6.heading-wth-icon .head-icon, h6.heading-wth-icon .head-icon {\n  margin-right: .5rem;\n}\n\n.force-UTF-8 {\n  content: \"¡\";\n}\n\ndt {\n  font-weight: 600;\n}\n\n::-webkit-file-upload-button {\n  cursor: pointer;\n}\n\n/****************************/\n/** Basic **/\n/****************************/\n/*CSS Basic*/\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll;\n}\n\n.white-space-wrap {\n  white-space: initial;\n}\n\n.white-space-nowrap {\n  white-space: nowrap;\n}\n\n.word-break,\na.link-url {\n  word-break: break-all;\n}\n\n.multine-ellipsis {\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n}\n\n.seprator-block {\n  margin-bottom: 5rem;\n}\n\n.no-transition {\n  -webkit-transition: 0s;\n  -moz-transition: 0s;\n  transition: 0s;\n}\n\n.transform-none {\n  transform: none !important;\n}\n\n.name {\n  color: #262a2e !important;\n  font-weight: 500;\n}\n\n.twa-2x {\n  background-size: 1.3em 1.3em;\n  height: 1.3em;\n  width: 1.3em;\n}\n\n.flex-basis-0 {\n  flex-basis: 0 !important;\n}\n\n.flex-1 {\n  -ms-flex: 1 !important;\n  flex: 1 !important;\n}\n\ntd.text-truncate, th.text-truncate {\n  max-width: 1px;\n}\n\n[contenteditable=\"true\"] {\n  outline: none;\n}\n\n.icon-flip-y {\n  -webkit-transform: rotateY(180deg);\n  -moz-transform: rotateY(180deg);\n  -ms-transform: rotateY(180deg);\n  -o-transform: rotateY(180deg);\n  transform: rotateY(180deg);\n}\n\n.icon-flip-x {\n  -webkit-transform: rotateX(180deg);\n  -moz-transform: rotateX(180deg);\n  -ms-transform: rotateX(180deg);\n  -o-transform: rotateX(180deg);\n  transform: rotateX(180deg);\n}\n\n/*Media Object*/\n.media {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.media-head {\n  display: flex;\n}\n\n.media-body {\n  -ms-flex: 1;\n  flex: 1;\n}\n\n/*Gap*/\n.gap-5 {\n  gap: 2rem !important;\n}\n\n.gap-6 {\n  gap: 2.5rem !important;\n}\n\n.gap-7 {\n  gap: 3rem !important;\n}\n\n/*Position*/\n.position-top-start,\n.position-top-end,\n.position-bottom-start,\n.position-bottom-end,\n.position-start-center,\n.position-end-center,\n.position-top-center,\n.position-bottom-center,\n.position-top-start-overflow,\n.position-top-end-overflow,\n.position-bottom-start-overflow,\n.position-bottom-end-overflow,\n.position-start-center-overflow,\n.position-end-center-overflow,\n.position-top-center-overflow,\n.position-bottom-center-overflow {\n  position: absolute !important;\n  z-index: 2;\n}\n\n.position-top-start {\n  top: 0 !important;\n  left: 0 !important;\n}\n\n.position-top-end {\n  top: 0 !important;\n  right: 0 !important;\n}\n\n.position-bottom-start {\n  bottom: 0 !important;\n  left: 0 !important;\n  top: auto !important;\n}\n\n.position-bottom-end {\n  bottom: 0 !important;\n  right: 0 !important;\n  top: auto !important;\n}\n\n.position-top-center {\n  top: 0 !important;\n  right: 50% !important;\n  -webkit-transform: translateX(50%) !important;\n  -moz-transform: translateX(50%) !important;\n  -ms-transform: translateX(50%) !important;\n  -o-transform: translateX(50%) !important;\n  transform: translateX(50%) !important;\n}\n\n.position-bottom-center {\n  bottom: 0 !important;\n  right: 50% !important;\n  -webkit-transform: translateX(50%) !important;\n  -moz-transform: translateX(50%) !important;\n  -ms-transform: translateX(50%) !important;\n  -o-transform: translateX(50%) !important;\n  transform: translateX(50%) !important;\n}\n\n.position-start-center {\n  left: 0 !important;\n  top: 50% !important;\n  -webkit-transform: translateY(-50%) !important;\n  -moz-transform: translateY(-50%) !important;\n  -ms-transform: translateY(-50%) !important;\n  -o-transform: translateY(-50%) !important;\n  transform: translateY(-50%) !important;\n}\n\n.position-end-center {\n  right: 0 !important;\n  top: 50% !important;\n  -webkit-transform: translateY(-50%) !important;\n  -moz-transform: translateY(-50%) !important;\n  -ms-transform: translateY(-50%) !important;\n  -o-transform: translateY(-50%) !important;\n  transform: translateY(-50%) !important;\n}\n\n.position-center {\n  left: 50% !important;\n  top: 50% !important;\n  -webkit-transform: translate(-50%, -50%) !important;\n  -moz-transform: translate(-50%, -50%) !important;\n  -ms-transform: translate(-50%, -50%) !important;\n  -o-transform: translate(-50%, -50%) !important;\n  transform: translate(-50%, -50%) !important;\n}\n\n.position-top-start-overflow {\n  top: 0 !important;\n  left: 0 !important;\n  -webkit-transform: translate(-50%, -50%) !important;\n  -moz-transform: translate(-50%, -50%) !important;\n  -ms-transform: translate(-50%, -50%) !important;\n  -o-transform: translate(-50%, -50%) !important;\n  transform: translate(-50%, -50%) !important;\n}\n\n.position-top-end-overflow {\n  top: 0 !important;\n  right: 0 !important;\n  -webkit-transform: translate(50%, -50%) !important;\n  -moz-transform: translate(50%, -50%) !important;\n  -ms-transform: translate(50%, -50%) !important;\n  -o-transform: translate(50%, -50%) !important;\n  transform: translate(50%, -50%) !important;\n}\n\n.position-bottom-start-overflow {\n  bottom: 0 !important;\n  left: 0 !important;\n  top: auto !important;\n  -webkit-transform: translate(-50%, 50%) !important;\n  -moz-transform: translate(-50%, 50%) !important;\n  -ms-transform: translate(-50%, 50%) !important;\n  -o-transform: translate(-50%, 50%) !important;\n  transform: translate(-50%, 50%) !important;\n}\n\n.position-bottom-end-overflow {\n  bottom: 0 !important;\n  right: 0 !important;\n  top: auto !important;\n  -webkit-transform: translate(50%, 50%) !important;\n  -moz-transform: translate(50%, 50%) !important;\n  -ms-transform: translate(50%, 50%) !important;\n  -o-transform: translate(50%, 50%) !important;\n  transform: translate(50%, 50%) !important;\n}\n\n.position-top-center-overflow {\n  top: 0 !important;\n  right: 50% !important;\n  -webkit-transform: translate(50%, -50%) !important;\n  -moz-transform: translate(50%, -50%) !important;\n  -ms-transform: translate(50%, -50%) !important;\n  -o-transform: translate(50%, -50%) !important;\n  transform: translate(50%, -50%) !important;\n}\n\n.position-bottom-center-overflow {\n  bottom: 0 !important;\n  right: 50% !important;\n  -webkit-transform: translate(50%, 50%) !important;\n  -moz-transform: translate(50%, 50%) !important;\n  -ms-transform: translate(50%, 50%) !important;\n  -o-transform: translate(50%, 50%) !important;\n  transform: translate(50%, 50%) !important;\n}\n\n.position-start-center-overflow {\n  left: 0 !important;\n  top: 50% !important;\n  -webkit-transform: translate(-50%, -50%) !important;\n  -moz-transform: translate(-50%, -50%) !important;\n  -ms-transform: translate(-50%, -50%) !important;\n  -o-transform: translate(-50%, -50%) !important;\n  transform: translate(-50%, -50%) !important;\n}\n\n.position-end-center-overflow {\n  right: 0 !important;\n  top: 50% !important;\n  -webkit-transform: translate(50%, -50%) !important;\n  -moz-transform: translate(50%, -50%) !important;\n  -ms-transform: translate(50%, -50%) !important;\n  -o-transform: translate(50%, -50%) !important;\n  transform: translate(50%, -50%) !important;\n}\n\n.position-top-start-overflow-1,\n.position-top-end-overflow-1,\n.position-bottom-start-overflow-1,\n.position-bottom-end-overflow-1 {\n  position: absolute !important;\n  z-index: 2;\n}\n\n.position-top-start-overflow-1 {\n  top: 12% !important;\n  left: 16% !important;\n  -webkit-transform: translate(-50%, -50%) !important;\n  -moz-transform: translate(-50%, -50%) !important;\n  -ms-transform: translate(-50%, -50%) !important;\n  -o-transform: translate(-50%, -50%) !important;\n  transform: translate(-50%, -50%) !important;\n}\n\n.position-top-end-overflow-1 {\n  top: 12% !important;\n  right: 16% !important;\n  -webkit-transform: translate(50%, -50%) !important;\n  -moz-transform: translate(50%, -50%) !important;\n  -ms-transform: translate(50%, -50%) !important;\n  -o-transform: translate(50%, -50%) !important;\n  transform: translate(50%, -50%) !important;\n}\n\n.position-bottom-start-overflow-1 {\n  bottom: 12% !important;\n  left: 16% !important;\n  top: auto !important;\n  -webkit-transform: translate(-50%, 50%) !important;\n  -moz-transform: translate(-50%, 50%) !important;\n  -ms-transform: translate(-50%, 50%) !important;\n  -o-transform: translate(-50%, 50%) !important;\n  transform: translate(-50%, 50%) !important;\n}\n\n.position-bottom-end-overflow-1 {\n  bottom: 12% !important;\n  right: 16% !important;\n  top: auto !important;\n  -webkit-transform: translate(50%, 50%) !important;\n  -moz-transform: translate(50%, 50%) !important;\n  -ms-transform: translate(50%, 50%) !important;\n  -o-transform: translate(50%, 50%) !important;\n  transform: translate(50%, 50%) !important;\n}\n\n/*Padding*/\n.p-0 {\n  padding: 0rem !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 2rem !important;\n}\n\n.p-6 {\n  padding: 2.5rem !important;\n}\n\n.p-7 {\n  padding: 3rem !important;\n}\n\n.p-8 {\n  padding: 3.5rem !important;\n}\n\n.p-9 {\n  padding: 4rem !important;\n}\n\n.p-10 {\n  padding: 4.5rem !important;\n}\n\n.p-11 {\n  padding: 5rem !important;\n}\n\n.p-12 {\n  padding: 5.5rem !important;\n}\n\n.p-13 {\n  padding: 6rem !important;\n}\n\n.p-14 {\n  padding: 6.5rem !important;\n}\n\n.p-15 {\n  padding: 7rem !important;\n}\n\n.p-16 {\n  padding: 7.5rem !important;\n}\n\n.p-17 {\n  padding: 8rem !important;\n}\n\n.p-18 {\n  padding: 8.5rem !important;\n}\n\n.p-19 {\n  padding: 9rem !important;\n}\n\n.p-20 {\n  padding: 9.5rem !important;\n}\n\n.p-21 {\n  padding: 10rem !important;\n}\n\n.p-22 {\n  padding: 10.5rem !important;\n}\n\n.p-23 {\n  padding: 11rem !important;\n}\n\n.p-24 {\n  padding: 11.5rem !important;\n}\n\n.p-25 {\n  padding: 12rem !important;\n}\n\n.p-26 {\n  padding: 12.5rem !important;\n}\n\n.p-27 {\n  padding: 13rem !important;\n}\n\n.p-28 {\n  padding: 13.5rem !important;\n}\n\n.p-29 {\n  padding: 14rem !important;\n}\n\n.p-30 {\n  padding: 14.5rem !important;\n}\n\n.p-31 {\n  padding: 15rem !important;\n}\n\n.p-32 {\n  padding: 15.5rem !important;\n}\n\n.p-33 {\n  padding: 16rem !important;\n}\n\n.p-34 {\n  padding: 16.5rem !important;\n}\n\n.p-35 {\n  padding: 17rem !important;\n}\n\n.p-36 {\n  padding: 17.5rem !important;\n}\n\n.p-37 {\n  padding: 18rem !important;\n}\n\n.p-38 {\n  padding: 18.5rem !important;\n}\n\n.p-39 {\n  padding: 19rem !important;\n}\n\n.p-40 {\n  padding: 19.5rem !important;\n}\n\n.p-41 {\n  padding: 20rem !important;\n}\n\n.p-42 {\n  padding: 20.5rem !important;\n}\n\n.p-43 {\n  padding: 21rem !important;\n}\n\n.p-44 {\n  padding: 21.5rem !important;\n}\n\n.p-45 {\n  padding: 22rem !important;\n}\n\n.p-46 {\n  padding: 22.5rem !important;\n}\n\n.p-47 {\n  padding: 23rem !important;\n}\n\n.p-48 {\n  padding: 23.5rem !important;\n}\n\n.p-49 {\n  padding: 24rem !important;\n}\n\n.p-50 {\n  padding: 24.5rem !important;\n}\n\n.p-51 {\n  padding: 25rem !important;\n}\n\n.p-52 {\n  padding: 25.5rem !important;\n}\n\n.p-53 {\n  padding: 26rem !important;\n}\n\n.p-54 {\n  padding: 26.5rem !important;\n}\n\n.p-55 {\n  padding: 27rem !important;\n}\n\n.p-56 {\n  padding: 27.5rem !important;\n}\n\n.p-57 {\n  padding: 28rem !important;\n}\n\n.p-58 {\n  padding: 28.5rem !important;\n}\n\n.p-59 {\n  padding: 29rem !important;\n}\n\n.p-60 {\n  padding: 29.5rem !important;\n}\n\n.p-61 {\n  padding: 30rem !important;\n}\n\n.p-62 {\n  padding: 30.5rem !important;\n}\n\n.p-63 {\n  padding: 31rem !important;\n}\n\n.p-64 {\n  padding: 31.5rem !important;\n}\n\n.p-65 {\n  padding: 32rem !important;\n}\n\n.p-66 {\n  padding: 32.5rem !important;\n}\n\n.p-67 {\n  padding: 33rem !important;\n}\n\n.p-68 {\n  padding: 33.5rem !important;\n}\n\n.p-69 {\n  padding: 34rem !important;\n}\n\n.p-70 {\n  padding: 34.5rem !important;\n}\n\n.p-71 {\n  padding: 35rem !important;\n}\n\n.p-72 {\n  padding: 35.5rem !important;\n}\n\n.p-73 {\n  padding: 36rem !important;\n}\n\n.p-74 {\n  padding: 36.5rem !important;\n}\n\n.p-75 {\n  padding: 37rem !important;\n}\n\n.p-76 {\n  padding: 37.5rem !important;\n}\n\n.p-77 {\n  padding: 38rem !important;\n}\n\n.p-78 {\n  padding: 38.5rem !important;\n}\n\n.p-79 {\n  padding: 39rem !important;\n}\n\n.p-80 {\n  padding: 39.5rem !important;\n}\n\n.p-81 {\n  padding: 40rem !important;\n}\n\n.p-82 {\n  padding: 40.5rem !important;\n}\n\n.p-83 {\n  padding: 41rem !important;\n}\n\n.p-84 {\n  padding: 41.5rem !important;\n}\n\n.p-85 {\n  padding: 42rem !important;\n}\n\n.p-86 {\n  padding: 42.5rem !important;\n}\n\n.p-87 {\n  padding: 43rem !important;\n}\n\n.p-88 {\n  padding: 43.5rem !important;\n}\n\n.p-89 {\n  padding: 44rem !important;\n}\n\n.p-90 {\n  padding: 44.5rem !important;\n}\n\n.p-91 {\n  padding: 45rem !important;\n}\n\n.p-92 {\n  padding: 45.5rem !important;\n}\n\n.p-93 {\n  padding: 46rem !important;\n}\n\n.p-94 {\n  padding: 46.5rem !important;\n}\n\n.p-95 {\n  padding: 47rem !important;\n}\n\n.p-96 {\n  padding: 47.5rem !important;\n}\n\n.p-97 {\n  padding: 48rem !important;\n}\n\n.p-98 {\n  padding: 48.5rem !important;\n}\n\n.p-99 {\n  padding: 49rem !important;\n}\n\n.p-100 {\n  padding: 49.5rem !important;\n}\n\n.p-101 {\n  padding: 50rem !important;\n}\n\n.p-102 {\n  padding: 50.5rem !important;\n}\n\n.p-103 {\n  padding: 51rem !important;\n}\n\n.p-104 {\n  padding: 51.5rem !important;\n}\n\n.p-105 {\n  padding: 52rem !important;\n}\n\n.p-106 {\n  padding: 52.5rem !important;\n}\n\n.p-107 {\n  padding: 53rem !important;\n}\n\n.p-108 {\n  padding: 53.5rem !important;\n}\n\n.p-109 {\n  padding: 54rem !important;\n}\n\n.p-110 {\n  padding: 54.5rem !important;\n}\n\n.p-111 {\n  padding: 55rem !important;\n}\n\n.p-112 {\n  padding: 55.5rem !important;\n}\n\n.p-113 {\n  padding: 56rem !important;\n}\n\n.p-114 {\n  padding: 56.5rem !important;\n}\n\n.p-115 {\n  padding: 57rem !important;\n}\n\n.p-116 {\n  padding: 57.5rem !important;\n}\n\n.p-117 {\n  padding: 58rem !important;\n}\n\n.p-118 {\n  padding: 58.5rem !important;\n}\n\n.p-119 {\n  padding: 59rem !important;\n}\n\n.p-120 {\n  padding: 59.5rem !important;\n}\n\n.p-121 {\n  padding: 60rem !important;\n}\n\n.p-122 {\n  padding: 60.5rem !important;\n}\n\n.p-123 {\n  padding: 61rem !important;\n}\n\n.p-124 {\n  padding: 61.5rem !important;\n}\n\n.p-125 {\n  padding: 62rem !important;\n}\n\n.p-126 {\n  padding: 62.5rem !important;\n}\n\n.p-127 {\n  padding: 63rem !important;\n}\n\n.p-128 {\n  padding: 63.5rem !important;\n}\n\n.p-129 {\n  padding: 64rem !important;\n}\n\n.p-130 {\n  padding: 64.5rem !important;\n}\n\n.p-131 {\n  padding: 65rem !important;\n}\n\n.p-132 {\n  padding: 65.5rem !important;\n}\n\n.p-133 {\n  padding: 66rem !important;\n}\n\n.p-134 {\n  padding: 66.5rem !important;\n}\n\n.p-135 {\n  padding: 67rem !important;\n}\n\n.p-136 {\n  padding: 67.5rem !important;\n}\n\n.p-137 {\n  padding: 68rem !important;\n}\n\n.p-138 {\n  padding: 68.5rem !important;\n}\n\n.p-139 {\n  padding: 69rem !important;\n}\n\n.p-140 {\n  padding: 69.5rem !important;\n}\n\n.p-141 {\n  padding: 70rem !important;\n}\n\n.p-142 {\n  padding: 70.5rem !important;\n}\n\n.p-143 {\n  padding: 71rem !important;\n}\n\n.p-144 {\n  padding: 71.5rem !important;\n}\n\n.p-145 {\n  padding: 72rem !important;\n}\n\n.p-146 {\n  padding: 72.5rem !important;\n}\n\n.p-147 {\n  padding: 73rem !important;\n}\n\n.p-148 {\n  padding: 73.5rem !important;\n}\n\n.p-149 {\n  padding: 74rem !important;\n}\n\n.p-150 {\n  padding: 74.5rem !important;\n}\n\n.p-151 {\n  padding: 75rem !important;\n}\n\n.p-152 {\n  padding: 75.5rem !important;\n}\n\n.p-153 {\n  padding: 76rem !important;\n}\n\n.p-154 {\n  padding: 76.5rem !important;\n}\n\n.p-155 {\n  padding: 77rem !important;\n}\n\n.p-156 {\n  padding: 77.5rem !important;\n}\n\n.p-157 {\n  padding: 78rem !important;\n}\n\n.p-158 {\n  padding: 78.5rem !important;\n}\n\n.p-159 {\n  padding: 79rem !important;\n}\n\n.p-160 {\n  padding: 79.5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0rem !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 2rem !important;\n}\n\n.pt-6 {\n  padding-top: 2.5rem !important;\n}\n\n.pt-7 {\n  padding-top: 3rem !important;\n}\n\n.pt-8 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-9 {\n  padding-top: 4rem !important;\n}\n\n.pt-10 {\n  padding-top: 4.5rem !important;\n}\n\n.pt-11 {\n  padding-top: 5rem !important;\n}\n\n.pt-12 {\n  padding-top: 5.5rem !important;\n}\n\n.pt-13 {\n  padding-top: 6rem !important;\n}\n\n.pt-14 {\n  padding-top: 6.5rem !important;\n}\n\n.pt-15 {\n  padding-top: 7rem !important;\n}\n\n.pt-16 {\n  padding-top: 7.5rem !important;\n}\n\n.pt-17 {\n  padding-top: 8rem !important;\n}\n\n.pt-18 {\n  padding-top: 8.5rem !important;\n}\n\n.pt-19 {\n  padding-top: 9rem !important;\n}\n\n.pt-20 {\n  padding-top: 9.5rem !important;\n}\n\n.pt-21 {\n  padding-top: 10rem !important;\n}\n\n.pt-22 {\n  padding-top: 10.5rem !important;\n}\n\n.pt-23 {\n  padding-top: 11rem !important;\n}\n\n.pt-24 {\n  padding-top: 11.5rem !important;\n}\n\n.pt-25 {\n  padding-top: 12rem !important;\n}\n\n.pt-26 {\n  padding-top: 12.5rem !important;\n}\n\n.pt-27 {\n  padding-top: 13rem !important;\n}\n\n.pt-28 {\n  padding-top: 13.5rem !important;\n}\n\n.pt-29 {\n  padding-top: 14rem !important;\n}\n\n.pt-30 {\n  padding-top: 14.5rem !important;\n}\n\n.pt-31 {\n  padding-top: 15rem !important;\n}\n\n.pt-32 {\n  padding-top: 15.5rem !important;\n}\n\n.pt-33 {\n  padding-top: 16rem !important;\n}\n\n.pt-34 {\n  padding-top: 16.5rem !important;\n}\n\n.pt-35 {\n  padding-top: 17rem !important;\n}\n\n.pt-36 {\n  padding-top: 17.5rem !important;\n}\n\n.pt-37 {\n  padding-top: 18rem !important;\n}\n\n.pt-38 {\n  padding-top: 18.5rem !important;\n}\n\n.pt-39 {\n  padding-top: 19rem !important;\n}\n\n.pt-40 {\n  padding-top: 19.5rem !important;\n}\n\n.pt-41 {\n  padding-top: 20rem !important;\n}\n\n.pt-42 {\n  padding-top: 20.5rem !important;\n}\n\n.pt-43 {\n  padding-top: 21rem !important;\n}\n\n.pt-44 {\n  padding-top: 21.5rem !important;\n}\n\n.pt-45 {\n  padding-top: 22rem !important;\n}\n\n.pt-46 {\n  padding-top: 22.5rem !important;\n}\n\n.pt-47 {\n  padding-top: 23rem !important;\n}\n\n.pt-48 {\n  padding-top: 23.5rem !important;\n}\n\n.pt-49 {\n  padding-top: 24rem !important;\n}\n\n.pt-50 {\n  padding-top: 24.5rem !important;\n}\n\n.pt-51 {\n  padding-top: 25rem !important;\n}\n\n.pt-52 {\n  padding-top: 25.5rem !important;\n}\n\n.pt-53 {\n  padding-top: 26rem !important;\n}\n\n.pt-54 {\n  padding-top: 26.5rem !important;\n}\n\n.pt-55 {\n  padding-top: 27rem !important;\n}\n\n.pt-56 {\n  padding-top: 27.5rem !important;\n}\n\n.pt-57 {\n  padding-top: 28rem !important;\n}\n\n.pt-58 {\n  padding-top: 28.5rem !important;\n}\n\n.pt-59 {\n  padding-top: 29rem !important;\n}\n\n.pt-60 {\n  padding-top: 29.5rem !important;\n}\n\n.pt-61 {\n  padding-top: 30rem !important;\n}\n\n.pt-62 {\n  padding-top: 30.5rem !important;\n}\n\n.pt-63 {\n  padding-top: 31rem !important;\n}\n\n.pt-64 {\n  padding-top: 31.5rem !important;\n}\n\n.pt-65 {\n  padding-top: 32rem !important;\n}\n\n.pt-66 {\n  padding-top: 32.5rem !important;\n}\n\n.pt-67 {\n  padding-top: 33rem !important;\n}\n\n.pt-68 {\n  padding-top: 33.5rem !important;\n}\n\n.pt-69 {\n  padding-top: 34rem !important;\n}\n\n.pt-70 {\n  padding-top: 34.5rem !important;\n}\n\n.pt-71 {\n  padding-top: 35rem !important;\n}\n\n.pt-72 {\n  padding-top: 35.5rem !important;\n}\n\n.pt-73 {\n  padding-top: 36rem !important;\n}\n\n.pt-74 {\n  padding-top: 36.5rem !important;\n}\n\n.pt-75 {\n  padding-top: 37rem !important;\n}\n\n.pt-76 {\n  padding-top: 37.5rem !important;\n}\n\n.pt-77 {\n  padding-top: 38rem !important;\n}\n\n.pt-78 {\n  padding-top: 38.5rem !important;\n}\n\n.pt-79 {\n  padding-top: 39rem !important;\n}\n\n.pt-80 {\n  padding-top: 39.5rem !important;\n}\n\n.pt-81 {\n  padding-top: 40rem !important;\n}\n\n.pt-82 {\n  padding-top: 40.5rem !important;\n}\n\n.pt-83 {\n  padding-top: 41rem !important;\n}\n\n.pt-84 {\n  padding-top: 41.5rem !important;\n}\n\n.pt-85 {\n  padding-top: 42rem !important;\n}\n\n.pt-86 {\n  padding-top: 42.5rem !important;\n}\n\n.pt-87 {\n  padding-top: 43rem !important;\n}\n\n.pt-88 {\n  padding-top: 43.5rem !important;\n}\n\n.pt-89 {\n  padding-top: 44rem !important;\n}\n\n.pt-90 {\n  padding-top: 44.5rem !important;\n}\n\n.pt-91 {\n  padding-top: 45rem !important;\n}\n\n.pt-92 {\n  padding-top: 45.5rem !important;\n}\n\n.pt-93 {\n  padding-top: 46rem !important;\n}\n\n.pt-94 {\n  padding-top: 46.5rem !important;\n}\n\n.pt-95 {\n  padding-top: 47rem !important;\n}\n\n.pt-96 {\n  padding-top: 47.5rem !important;\n}\n\n.pt-97 {\n  padding-top: 48rem !important;\n}\n\n.pt-98 {\n  padding-top: 48.5rem !important;\n}\n\n.pt-99 {\n  padding-top: 49rem !important;\n}\n\n.pt-100 {\n  padding-top: 49.5rem !important;\n}\n\n.pt-101 {\n  padding-top: 50rem !important;\n}\n\n.pt-102 {\n  padding-top: 50.5rem !important;\n}\n\n.pt-103 {\n  padding-top: 51rem !important;\n}\n\n.pt-104 {\n  padding-top: 51.5rem !important;\n}\n\n.pt-105 {\n  padding-top: 52rem !important;\n}\n\n.pt-106 {\n  padding-top: 52.5rem !important;\n}\n\n.pt-107 {\n  padding-top: 53rem !important;\n}\n\n.pt-108 {\n  padding-top: 53.5rem !important;\n}\n\n.pt-109 {\n  padding-top: 54rem !important;\n}\n\n.pt-110 {\n  padding-top: 54.5rem !important;\n}\n\n.pt-111 {\n  padding-top: 55rem !important;\n}\n\n.pt-112 {\n  padding-top: 55.5rem !important;\n}\n\n.pt-113 {\n  padding-top: 56rem !important;\n}\n\n.pt-114 {\n  padding-top: 56.5rem !important;\n}\n\n.pt-115 {\n  padding-top: 57rem !important;\n}\n\n.pt-116 {\n  padding-top: 57.5rem !important;\n}\n\n.pt-117 {\n  padding-top: 58rem !important;\n}\n\n.pt-118 {\n  padding-top: 58.5rem !important;\n}\n\n.pt-119 {\n  padding-top: 59rem !important;\n}\n\n.pt-120 {\n  padding-top: 59.5rem !important;\n}\n\n.pt-121 {\n  padding-top: 60rem !important;\n}\n\n.pt-122 {\n  padding-top: 60.5rem !important;\n}\n\n.pt-123 {\n  padding-top: 61rem !important;\n}\n\n.pt-124 {\n  padding-top: 61.5rem !important;\n}\n\n.pt-125 {\n  padding-top: 62rem !important;\n}\n\n.pt-126 {\n  padding-top: 62.5rem !important;\n}\n\n.pt-127 {\n  padding-top: 63rem !important;\n}\n\n.pt-128 {\n  padding-top: 63.5rem !important;\n}\n\n.pt-129 {\n  padding-top: 64rem !important;\n}\n\n.pt-130 {\n  padding-top: 64.5rem !important;\n}\n\n.pt-131 {\n  padding-top: 65rem !important;\n}\n\n.pt-132 {\n  padding-top: 65.5rem !important;\n}\n\n.pt-133 {\n  padding-top: 66rem !important;\n}\n\n.pt-134 {\n  padding-top: 66.5rem !important;\n}\n\n.pt-135 {\n  padding-top: 67rem !important;\n}\n\n.pt-136 {\n  padding-top: 67.5rem !important;\n}\n\n.pt-137 {\n  padding-top: 68rem !important;\n}\n\n.pt-138 {\n  padding-top: 68.5rem !important;\n}\n\n.pt-139 {\n  padding-top: 69rem !important;\n}\n\n.pt-140 {\n  padding-top: 69.5rem !important;\n}\n\n.pt-141 {\n  padding-top: 70rem !important;\n}\n\n.pt-142 {\n  padding-top: 70.5rem !important;\n}\n\n.pt-143 {\n  padding-top: 71rem !important;\n}\n\n.pt-144 {\n  padding-top: 71.5rem !important;\n}\n\n.pt-145 {\n  padding-top: 72rem !important;\n}\n\n.pt-146 {\n  padding-top: 72.5rem !important;\n}\n\n.pt-147 {\n  padding-top: 73rem !important;\n}\n\n.pt-148 {\n  padding-top: 73.5rem !important;\n}\n\n.pt-149 {\n  padding-top: 74rem !important;\n}\n\n.pt-150 {\n  padding-top: 74.5rem !important;\n}\n\n.pt-151 {\n  padding-top: 75rem !important;\n}\n\n.pt-152 {\n  padding-top: 75.5rem !important;\n}\n\n.pt-153 {\n  padding-top: 76rem !important;\n}\n\n.pt-154 {\n  padding-top: 76.5rem !important;\n}\n\n.pt-155 {\n  padding-top: 77rem !important;\n}\n\n.pt-156 {\n  padding-top: 77.5rem !important;\n}\n\n.pt-157 {\n  padding-top: 78rem !important;\n}\n\n.pt-158 {\n  padding-top: 78.5rem !important;\n}\n\n.pt-159 {\n  padding-top: 79rem !important;\n}\n\n.pt-160 {\n  padding-top: 79.5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0rem !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 2rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-10 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pb-11 {\n  padding-bottom: 5rem !important;\n}\n\n.pb-12 {\n  padding-bottom: 5.5rem !important;\n}\n\n.pb-13 {\n  padding-bottom: 6rem !important;\n}\n\n.pb-14 {\n  padding-bottom: 6.5rem !important;\n}\n\n.pb-15 {\n  padding-bottom: 7rem !important;\n}\n\n.pb-16 {\n  padding-bottom: 7.5rem !important;\n}\n\n.pb-17 {\n  padding-bottom: 8rem !important;\n}\n\n.pb-18 {\n  padding-bottom: 8.5rem !important;\n}\n\n.pb-19 {\n  padding-bottom: 9rem !important;\n}\n\n.pb-20 {\n  padding-bottom: 9.5rem !important;\n}\n\n.pb-21 {\n  padding-bottom: 10rem !important;\n}\n\n.pb-22 {\n  padding-bottom: 10.5rem !important;\n}\n\n.pb-23 {\n  padding-bottom: 11rem !important;\n}\n\n.pb-24 {\n  padding-bottom: 11.5rem !important;\n}\n\n.pb-25 {\n  padding-bottom: 12rem !important;\n}\n\n.pb-26 {\n  padding-bottom: 12.5rem !important;\n}\n\n.pb-27 {\n  padding-bottom: 13rem !important;\n}\n\n.pb-28 {\n  padding-bottom: 13.5rem !important;\n}\n\n.pb-29 {\n  padding-bottom: 14rem !important;\n}\n\n.pb-30 {\n  padding-bottom: 14.5rem !important;\n}\n\n.pb-31 {\n  padding-bottom: 15rem !important;\n}\n\n.pb-32 {\n  padding-bottom: 15.5rem !important;\n}\n\n.pb-33 {\n  padding-bottom: 16rem !important;\n}\n\n.pb-34 {\n  padding-bottom: 16.5rem !important;\n}\n\n.pb-35 {\n  padding-bottom: 17rem !important;\n}\n\n.pb-36 {\n  padding-bottom: 17.5rem !important;\n}\n\n.pb-37 {\n  padding-bottom: 18rem !important;\n}\n\n.pb-38 {\n  padding-bottom: 18.5rem !important;\n}\n\n.pb-39 {\n  padding-bottom: 19rem !important;\n}\n\n.pb-40 {\n  padding-bottom: 19.5rem !important;\n}\n\n.pb-41 {\n  padding-bottom: 20rem !important;\n}\n\n.pb-42 {\n  padding-bottom: 20.5rem !important;\n}\n\n.pb-43 {\n  padding-bottom: 21rem !important;\n}\n\n.pb-44 {\n  padding-bottom: 21.5rem !important;\n}\n\n.pb-45 {\n  padding-bottom: 22rem !important;\n}\n\n.pb-46 {\n  padding-bottom: 22.5rem !important;\n}\n\n.pb-47 {\n  padding-bottom: 23rem !important;\n}\n\n.pb-48 {\n  padding-bottom: 23.5rem !important;\n}\n\n.pb-49 {\n  padding-bottom: 24rem !important;\n}\n\n.pb-50 {\n  padding-bottom: 24.5rem !important;\n}\n\n.pb-51 {\n  padding-bottom: 25rem !important;\n}\n\n.pb-52 {\n  padding-bottom: 25.5rem !important;\n}\n\n.pb-53 {\n  padding-bottom: 26rem !important;\n}\n\n.pb-54 {\n  padding-bottom: 26.5rem !important;\n}\n\n.pb-55 {\n  padding-bottom: 27rem !important;\n}\n\n.pb-56 {\n  padding-bottom: 27.5rem !important;\n}\n\n.pb-57 {\n  padding-bottom: 28rem !important;\n}\n\n.pb-58 {\n  padding-bottom: 28.5rem !important;\n}\n\n.pb-59 {\n  padding-bottom: 29rem !important;\n}\n\n.pb-60 {\n  padding-bottom: 29.5rem !important;\n}\n\n.pb-61 {\n  padding-bottom: 30rem !important;\n}\n\n.pb-62 {\n  padding-bottom: 30.5rem !important;\n}\n\n.pb-63 {\n  padding-bottom: 31rem !important;\n}\n\n.pb-64 {\n  padding-bottom: 31.5rem !important;\n}\n\n.pb-65 {\n  padding-bottom: 32rem !important;\n}\n\n.pb-66 {\n  padding-bottom: 32.5rem !important;\n}\n\n.pb-67 {\n  padding-bottom: 33rem !important;\n}\n\n.pb-68 {\n  padding-bottom: 33.5rem !important;\n}\n\n.pb-69 {\n  padding-bottom: 34rem !important;\n}\n\n.pb-70 {\n  padding-bottom: 34.5rem !important;\n}\n\n.pb-71 {\n  padding-bottom: 35rem !important;\n}\n\n.pb-72 {\n  padding-bottom: 35.5rem !important;\n}\n\n.pb-73 {\n  padding-bottom: 36rem !important;\n}\n\n.pb-74 {\n  padding-bottom: 36.5rem !important;\n}\n\n.pb-75 {\n  padding-bottom: 37rem !important;\n}\n\n.pb-76 {\n  padding-bottom: 37.5rem !important;\n}\n\n.pb-77 {\n  padding-bottom: 38rem !important;\n}\n\n.pb-78 {\n  padding-bottom: 38.5rem !important;\n}\n\n.pb-79 {\n  padding-bottom: 39rem !important;\n}\n\n.pb-80 {\n  padding-bottom: 39.5rem !important;\n}\n\n.pb-81 {\n  padding-bottom: 40rem !important;\n}\n\n.pb-82 {\n  padding-bottom: 40.5rem !important;\n}\n\n.pb-83 {\n  padding-bottom: 41rem !important;\n}\n\n.pb-84 {\n  padding-bottom: 41.5rem !important;\n}\n\n.pb-85 {\n  padding-bottom: 42rem !important;\n}\n\n.pb-86 {\n  padding-bottom: 42.5rem !important;\n}\n\n.pb-87 {\n  padding-bottom: 43rem !important;\n}\n\n.pb-88 {\n  padding-bottom: 43.5rem !important;\n}\n\n.pb-89 {\n  padding-bottom: 44rem !important;\n}\n\n.pb-90 {\n  padding-bottom: 44.5rem !important;\n}\n\n.pb-91 {\n  padding-bottom: 45rem !important;\n}\n\n.pb-92 {\n  padding-bottom: 45.5rem !important;\n}\n\n.pb-93 {\n  padding-bottom: 46rem !important;\n}\n\n.pb-94 {\n  padding-bottom: 46.5rem !important;\n}\n\n.pb-95 {\n  padding-bottom: 47rem !important;\n}\n\n.pb-96 {\n  padding-bottom: 47.5rem !important;\n}\n\n.pb-97 {\n  padding-bottom: 48rem !important;\n}\n\n.pb-98 {\n  padding-bottom: 48.5rem !important;\n}\n\n.pb-99 {\n  padding-bottom: 49rem !important;\n}\n\n.pb-100 {\n  padding-bottom: 49.5rem !important;\n}\n\n.pb-101 {\n  padding-bottom: 50rem !important;\n}\n\n.pb-102 {\n  padding-bottom: 50.5rem !important;\n}\n\n.pb-103 {\n  padding-bottom: 51rem !important;\n}\n\n.pb-104 {\n  padding-bottom: 51.5rem !important;\n}\n\n.pb-105 {\n  padding-bottom: 52rem !important;\n}\n\n.pb-106 {\n  padding-bottom: 52.5rem !important;\n}\n\n.pb-107 {\n  padding-bottom: 53rem !important;\n}\n\n.pb-108 {\n  padding-bottom: 53.5rem !important;\n}\n\n.pb-109 {\n  padding-bottom: 54rem !important;\n}\n\n.pb-110 {\n  padding-bottom: 54.5rem !important;\n}\n\n.pb-111 {\n  padding-bottom: 55rem !important;\n}\n\n.pb-112 {\n  padding-bottom: 55.5rem !important;\n}\n\n.pb-113 {\n  padding-bottom: 56rem !important;\n}\n\n.pb-114 {\n  padding-bottom: 56.5rem !important;\n}\n\n.pb-115 {\n  padding-bottom: 57rem !important;\n}\n\n.pb-116 {\n  padding-bottom: 57.5rem !important;\n}\n\n.pb-117 {\n  padding-bottom: 58rem !important;\n}\n\n.pb-118 {\n  padding-bottom: 58.5rem !important;\n}\n\n.pb-119 {\n  padding-bottom: 59rem !important;\n}\n\n.pb-120 {\n  padding-bottom: 59.5rem !important;\n}\n\n.pb-121 {\n  padding-bottom: 60rem !important;\n}\n\n.pb-122 {\n  padding-bottom: 60.5rem !important;\n}\n\n.pb-123 {\n  padding-bottom: 61rem !important;\n}\n\n.pb-124 {\n  padding-bottom: 61.5rem !important;\n}\n\n.pb-125 {\n  padding-bottom: 62rem !important;\n}\n\n.pb-126 {\n  padding-bottom: 62.5rem !important;\n}\n\n.pb-127 {\n  padding-bottom: 63rem !important;\n}\n\n.pb-128 {\n  padding-bottom: 63.5rem !important;\n}\n\n.pb-129 {\n  padding-bottom: 64rem !important;\n}\n\n.pb-130 {\n  padding-bottom: 64.5rem !important;\n}\n\n.pb-131 {\n  padding-bottom: 65rem !important;\n}\n\n.pb-132 {\n  padding-bottom: 65.5rem !important;\n}\n\n.pb-133 {\n  padding-bottom: 66rem !important;\n}\n\n.pb-134 {\n  padding-bottom: 66.5rem !important;\n}\n\n.pb-135 {\n  padding-bottom: 67rem !important;\n}\n\n.pb-136 {\n  padding-bottom: 67.5rem !important;\n}\n\n.pb-137 {\n  padding-bottom: 68rem !important;\n}\n\n.pb-138 {\n  padding-bottom: 68.5rem !important;\n}\n\n.pb-139 {\n  padding-bottom: 69rem !important;\n}\n\n.pb-140 {\n  padding-bottom: 69.5rem !important;\n}\n\n.pb-141 {\n  padding-bottom: 70rem !important;\n}\n\n.pb-142 {\n  padding-bottom: 70.5rem !important;\n}\n\n.pb-143 {\n  padding-bottom: 71rem !important;\n}\n\n.pb-144 {\n  padding-bottom: 71.5rem !important;\n}\n\n.pb-145 {\n  padding-bottom: 72rem !important;\n}\n\n.pb-146 {\n  padding-bottom: 72.5rem !important;\n}\n\n.pb-147 {\n  padding-bottom: 73rem !important;\n}\n\n.pb-148 {\n  padding-bottom: 73.5rem !important;\n}\n\n.pb-149 {\n  padding-bottom: 74rem !important;\n}\n\n.pb-150 {\n  padding-bottom: 74.5rem !important;\n}\n\n.pb-151 {\n  padding-bottom: 75rem !important;\n}\n\n.pb-152 {\n  padding-bottom: 75.5rem !important;\n}\n\n.pb-153 {\n  padding-bottom: 76rem !important;\n}\n\n.pb-154 {\n  padding-bottom: 76.5rem !important;\n}\n\n.pb-155 {\n  padding-bottom: 77rem !important;\n}\n\n.pb-156 {\n  padding-bottom: 77.5rem !important;\n}\n\n.pb-157 {\n  padding-bottom: 78rem !important;\n}\n\n.pb-158 {\n  padding-bottom: 78.5rem !important;\n}\n\n.pb-159 {\n  padding-bottom: 79rem !important;\n}\n\n.pb-160 {\n  padding-bottom: 79.5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0rem !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 2rem !important;\n}\n\n.ps-6 {\n  padding-left: 2.5rem !important;\n}\n\n.ps-7 {\n  padding-left: 3rem !important;\n}\n\n.ps-8 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-9 {\n  padding-left: 4rem !important;\n}\n\n.ps-10 {\n  padding-left: 4.5rem !important;\n}\n\n.ps-11 {\n  padding-left: 5rem !important;\n}\n\n.ps-12 {\n  padding-left: 5.5rem !important;\n}\n\n.ps-13 {\n  padding-left: 6rem !important;\n}\n\n.ps-14 {\n  padding-left: 6.5rem !important;\n}\n\n.ps-15 {\n  padding-left: 7rem !important;\n}\n\n.ps-16 {\n  padding-left: 7.5rem !important;\n}\n\n.ps-17 {\n  padding-left: 8rem !important;\n}\n\n.ps-18 {\n  padding-left: 8.5rem !important;\n}\n\n.ps-19 {\n  padding-left: 9rem !important;\n}\n\n.ps-20 {\n  padding-left: 9.5rem !important;\n}\n\n.ps-21 {\n  padding-left: 10rem !important;\n}\n\n.ps-22 {\n  padding-left: 10.5rem !important;\n}\n\n.ps-23 {\n  padding-left: 11rem !important;\n}\n\n.ps-24 {\n  padding-left: 11.5rem !important;\n}\n\n.ps-25 {\n  padding-left: 12rem !important;\n}\n\n.ps-26 {\n  padding-left: 12.5rem !important;\n}\n\n.ps-27 {\n  padding-left: 13rem !important;\n}\n\n.ps-28 {\n  padding-left: 13.5rem !important;\n}\n\n.ps-29 {\n  padding-left: 14rem !important;\n}\n\n.ps-30 {\n  padding-left: 14.5rem !important;\n}\n\n.ps-31 {\n  padding-left: 15rem !important;\n}\n\n.ps-32 {\n  padding-left: 15.5rem !important;\n}\n\n.ps-33 {\n  padding-left: 16rem !important;\n}\n\n.ps-34 {\n  padding-left: 16.5rem !important;\n}\n\n.ps-35 {\n  padding-left: 17rem !important;\n}\n\n.ps-36 {\n  padding-left: 17.5rem !important;\n}\n\n.ps-37 {\n  padding-left: 18rem !important;\n}\n\n.ps-38 {\n  padding-left: 18.5rem !important;\n}\n\n.ps-39 {\n  padding-left: 19rem !important;\n}\n\n.ps-40 {\n  padding-left: 19.5rem !important;\n}\n\n.ps-41 {\n  padding-left: 20rem !important;\n}\n\n.ps-42 {\n  padding-left: 20.5rem !important;\n}\n\n.ps-43 {\n  padding-left: 21rem !important;\n}\n\n.ps-44 {\n  padding-left: 21.5rem !important;\n}\n\n.ps-45 {\n  padding-left: 22rem !important;\n}\n\n.ps-46 {\n  padding-left: 22.5rem !important;\n}\n\n.ps-47 {\n  padding-left: 23rem !important;\n}\n\n.ps-48 {\n  padding-left: 23.5rem !important;\n}\n\n.ps-49 {\n  padding-left: 24rem !important;\n}\n\n.ps-50 {\n  padding-left: 24.5rem !important;\n}\n\n.ps-51 {\n  padding-left: 25rem !important;\n}\n\n.ps-52 {\n  padding-left: 25.5rem !important;\n}\n\n.ps-53 {\n  padding-left: 26rem !important;\n}\n\n.ps-54 {\n  padding-left: 26.5rem !important;\n}\n\n.ps-55 {\n  padding-left: 27rem !important;\n}\n\n.ps-56 {\n  padding-left: 27.5rem !important;\n}\n\n.ps-57 {\n  padding-left: 28rem !important;\n}\n\n.ps-58 {\n  padding-left: 28.5rem !important;\n}\n\n.ps-59 {\n  padding-left: 29rem !important;\n}\n\n.ps-60 {\n  padding-left: 29.5rem !important;\n}\n\n.ps-61 {\n  padding-left: 30rem !important;\n}\n\n.ps-62 {\n  padding-left: 30.5rem !important;\n}\n\n.ps-63 {\n  padding-left: 31rem !important;\n}\n\n.ps-64 {\n  padding-left: 31.5rem !important;\n}\n\n.ps-65 {\n  padding-left: 32rem !important;\n}\n\n.ps-66 {\n  padding-left: 32.5rem !important;\n}\n\n.ps-67 {\n  padding-left: 33rem !important;\n}\n\n.ps-68 {\n  padding-left: 33.5rem !important;\n}\n\n.ps-69 {\n  padding-left: 34rem !important;\n}\n\n.ps-70 {\n  padding-left: 34.5rem !important;\n}\n\n.ps-71 {\n  padding-left: 35rem !important;\n}\n\n.ps-72 {\n  padding-left: 35.5rem !important;\n}\n\n.ps-73 {\n  padding-left: 36rem !important;\n}\n\n.ps-74 {\n  padding-left: 36.5rem !important;\n}\n\n.ps-75 {\n  padding-left: 37rem !important;\n}\n\n.ps-76 {\n  padding-left: 37.5rem !important;\n}\n\n.ps-77 {\n  padding-left: 38rem !important;\n}\n\n.ps-78 {\n  padding-left: 38.5rem !important;\n}\n\n.ps-79 {\n  padding-left: 39rem !important;\n}\n\n.ps-80 {\n  padding-left: 39.5rem !important;\n}\n\n.ps-81 {\n  padding-left: 40rem !important;\n}\n\n.ps-82 {\n  padding-left: 40.5rem !important;\n}\n\n.ps-83 {\n  padding-left: 41rem !important;\n}\n\n.ps-84 {\n  padding-left: 41.5rem !important;\n}\n\n.ps-85 {\n  padding-left: 42rem !important;\n}\n\n.ps-86 {\n  padding-left: 42.5rem !important;\n}\n\n.ps-87 {\n  padding-left: 43rem !important;\n}\n\n.ps-88 {\n  padding-left: 43.5rem !important;\n}\n\n.ps-89 {\n  padding-left: 44rem !important;\n}\n\n.ps-90 {\n  padding-left: 44.5rem !important;\n}\n\n.ps-91 {\n  padding-left: 45rem !important;\n}\n\n.ps-92 {\n  padding-left: 45.5rem !important;\n}\n\n.ps-93 {\n  padding-left: 46rem !important;\n}\n\n.ps-94 {\n  padding-left: 46.5rem !important;\n}\n\n.ps-95 {\n  padding-left: 47rem !important;\n}\n\n.ps-96 {\n  padding-left: 47.5rem !important;\n}\n\n.ps-97 {\n  padding-left: 48rem !important;\n}\n\n.ps-98 {\n  padding-left: 48.5rem !important;\n}\n\n.ps-99 {\n  padding-left: 49rem !important;\n}\n\n.ps-100 {\n  padding-left: 49.5rem !important;\n}\n\n.ps-101 {\n  padding-left: 50rem !important;\n}\n\n.ps-102 {\n  padding-left: 50.5rem !important;\n}\n\n.ps-103 {\n  padding-left: 51rem !important;\n}\n\n.ps-104 {\n  padding-left: 51.5rem !important;\n}\n\n.ps-105 {\n  padding-left: 52rem !important;\n}\n\n.ps-106 {\n  padding-left: 52.5rem !important;\n}\n\n.ps-107 {\n  padding-left: 53rem !important;\n}\n\n.ps-108 {\n  padding-left: 53.5rem !important;\n}\n\n.ps-109 {\n  padding-left: 54rem !important;\n}\n\n.ps-110 {\n  padding-left: 54.5rem !important;\n}\n\n.ps-111 {\n  padding-left: 55rem !important;\n}\n\n.ps-112 {\n  padding-left: 55.5rem !important;\n}\n\n.ps-113 {\n  padding-left: 56rem !important;\n}\n\n.ps-114 {\n  padding-left: 56.5rem !important;\n}\n\n.ps-115 {\n  padding-left: 57rem !important;\n}\n\n.ps-116 {\n  padding-left: 57.5rem !important;\n}\n\n.ps-117 {\n  padding-left: 58rem !important;\n}\n\n.ps-118 {\n  padding-left: 58.5rem !important;\n}\n\n.ps-119 {\n  padding-left: 59rem !important;\n}\n\n.ps-120 {\n  padding-left: 59.5rem !important;\n}\n\n.ps-121 {\n  padding-left: 60rem !important;\n}\n\n.ps-122 {\n  padding-left: 60.5rem !important;\n}\n\n.ps-123 {\n  padding-left: 61rem !important;\n}\n\n.ps-124 {\n  padding-left: 61.5rem !important;\n}\n\n.ps-125 {\n  padding-left: 62rem !important;\n}\n\n.ps-126 {\n  padding-left: 62.5rem !important;\n}\n\n.ps-127 {\n  padding-left: 63rem !important;\n}\n\n.ps-128 {\n  padding-left: 63.5rem !important;\n}\n\n.ps-129 {\n  padding-left: 64rem !important;\n}\n\n.ps-130 {\n  padding-left: 64.5rem !important;\n}\n\n.ps-131 {\n  padding-left: 65rem !important;\n}\n\n.ps-132 {\n  padding-left: 65.5rem !important;\n}\n\n.ps-133 {\n  padding-left: 66rem !important;\n}\n\n.ps-134 {\n  padding-left: 66.5rem !important;\n}\n\n.ps-135 {\n  padding-left: 67rem !important;\n}\n\n.ps-136 {\n  padding-left: 67.5rem !important;\n}\n\n.ps-137 {\n  padding-left: 68rem !important;\n}\n\n.ps-138 {\n  padding-left: 68.5rem !important;\n}\n\n.ps-139 {\n  padding-left: 69rem !important;\n}\n\n.ps-140 {\n  padding-left: 69.5rem !important;\n}\n\n.ps-141 {\n  padding-left: 70rem !important;\n}\n\n.ps-142 {\n  padding-left: 70.5rem !important;\n}\n\n.ps-143 {\n  padding-left: 71rem !important;\n}\n\n.ps-144 {\n  padding-left: 71.5rem !important;\n}\n\n.ps-145 {\n  padding-left: 72rem !important;\n}\n\n.ps-146 {\n  padding-left: 72.5rem !important;\n}\n\n.ps-147 {\n  padding-left: 73rem !important;\n}\n\n.ps-148 {\n  padding-left: 73.5rem !important;\n}\n\n.ps-149 {\n  padding-left: 74rem !important;\n}\n\n.ps-150 {\n  padding-left: 74.5rem !important;\n}\n\n.ps-151 {\n  padding-left: 75rem !important;\n}\n\n.ps-152 {\n  padding-left: 75.5rem !important;\n}\n\n.ps-153 {\n  padding-left: 76rem !important;\n}\n\n.ps-154 {\n  padding-left: 76.5rem !important;\n}\n\n.ps-155 {\n  padding-left: 77rem !important;\n}\n\n.ps-156 {\n  padding-left: 77.5rem !important;\n}\n\n.ps-157 {\n  padding-left: 78rem !important;\n}\n\n.ps-158 {\n  padding-left: 78.5rem !important;\n}\n\n.ps-159 {\n  padding-left: 79rem !important;\n}\n\n.ps-160 {\n  padding-left: 79.5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0rem !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 2rem !important;\n}\n\n.pe-6 {\n  padding-right: 2.5rem !important;\n}\n\n.pe-7 {\n  padding-right: 3rem !important;\n}\n\n.pe-8 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-9 {\n  padding-right: 4rem !important;\n}\n\n.pe-10 {\n  padding-right: 4.5rem !important;\n}\n\n.pe-11 {\n  padding-right: 5rem !important;\n}\n\n.pe-12 {\n  padding-right: 5.5rem !important;\n}\n\n.pe-13 {\n  padding-right: 6rem !important;\n}\n\n.pe-14 {\n  padding-right: 6.5rem !important;\n}\n\n.pe-15 {\n  padding-right: 7rem !important;\n}\n\n.pe-16 {\n  padding-right: 7.5rem !important;\n}\n\n.pe-17 {\n  padding-right: 8rem !important;\n}\n\n.pe-18 {\n  padding-right: 8.5rem !important;\n}\n\n.pe-19 {\n  padding-right: 9rem !important;\n}\n\n.pe-20 {\n  padding-right: 9.5rem !important;\n}\n\n.pe-21 {\n  padding-right: 10rem !important;\n}\n\n.pe-22 {\n  padding-right: 10.5rem !important;\n}\n\n.pe-23 {\n  padding-right: 11rem !important;\n}\n\n.pe-24 {\n  padding-right: 11.5rem !important;\n}\n\n.pe-25 {\n  padding-right: 12rem !important;\n}\n\n.pe-26 {\n  padding-right: 12.5rem !important;\n}\n\n.pe-27 {\n  padding-right: 13rem !important;\n}\n\n.pe-28 {\n  padding-right: 13.5rem !important;\n}\n\n.pe-29 {\n  padding-right: 14rem !important;\n}\n\n.pe-30 {\n  padding-right: 14.5rem !important;\n}\n\n.pe-31 {\n  padding-right: 15rem !important;\n}\n\n.pe-32 {\n  padding-right: 15.5rem !important;\n}\n\n.pe-33 {\n  padding-right: 16rem !important;\n}\n\n.pe-34 {\n  padding-right: 16.5rem !important;\n}\n\n.pe-35 {\n  padding-right: 17rem !important;\n}\n\n.pe-36 {\n  padding-right: 17.5rem !important;\n}\n\n.pe-37 {\n  padding-right: 18rem !important;\n}\n\n.pe-38 {\n  padding-right: 18.5rem !important;\n}\n\n.pe-39 {\n  padding-right: 19rem !important;\n}\n\n.pe-40 {\n  padding-right: 19.5rem !important;\n}\n\n.pe-41 {\n  padding-right: 20rem !important;\n}\n\n.pe-42 {\n  padding-right: 20.5rem !important;\n}\n\n.pe-43 {\n  padding-right: 21rem !important;\n}\n\n.pe-44 {\n  padding-right: 21.5rem !important;\n}\n\n.pe-45 {\n  padding-right: 22rem !important;\n}\n\n.pe-46 {\n  padding-right: 22.5rem !important;\n}\n\n.pe-47 {\n  padding-right: 23rem !important;\n}\n\n.pe-48 {\n  padding-right: 23.5rem !important;\n}\n\n.pe-49 {\n  padding-right: 24rem !important;\n}\n\n.pe-50 {\n  padding-right: 24.5rem !important;\n}\n\n.pe-51 {\n  padding-right: 25rem !important;\n}\n\n.pe-52 {\n  padding-right: 25.5rem !important;\n}\n\n.pe-53 {\n  padding-right: 26rem !important;\n}\n\n.pe-54 {\n  padding-right: 26.5rem !important;\n}\n\n.pe-55 {\n  padding-right: 27rem !important;\n}\n\n.pe-56 {\n  padding-right: 27.5rem !important;\n}\n\n.pe-57 {\n  padding-right: 28rem !important;\n}\n\n.pe-58 {\n  padding-right: 28.5rem !important;\n}\n\n.pe-59 {\n  padding-right: 29rem !important;\n}\n\n.pe-60 {\n  padding-right: 29.5rem !important;\n}\n\n.pe-61 {\n  padding-right: 30rem !important;\n}\n\n.pe-62 {\n  padding-right: 30.5rem !important;\n}\n\n.pe-63 {\n  padding-right: 31rem !important;\n}\n\n.pe-64 {\n  padding-right: 31.5rem !important;\n}\n\n.pe-65 {\n  padding-right: 32rem !important;\n}\n\n.pe-66 {\n  padding-right: 32.5rem !important;\n}\n\n.pe-67 {\n  padding-right: 33rem !important;\n}\n\n.pe-68 {\n  padding-right: 33.5rem !important;\n}\n\n.pe-69 {\n  padding-right: 34rem !important;\n}\n\n.pe-70 {\n  padding-right: 34.5rem !important;\n}\n\n.pe-71 {\n  padding-right: 35rem !important;\n}\n\n.pe-72 {\n  padding-right: 35.5rem !important;\n}\n\n.pe-73 {\n  padding-right: 36rem !important;\n}\n\n.pe-74 {\n  padding-right: 36.5rem !important;\n}\n\n.pe-75 {\n  padding-right: 37rem !important;\n}\n\n.pe-76 {\n  padding-right: 37.5rem !important;\n}\n\n.pe-77 {\n  padding-right: 38rem !important;\n}\n\n.pe-78 {\n  padding-right: 38.5rem !important;\n}\n\n.pe-79 {\n  padding-right: 39rem !important;\n}\n\n.pe-80 {\n  padding-right: 39.5rem !important;\n}\n\n.pe-81 {\n  padding-right: 40rem !important;\n}\n\n.pe-82 {\n  padding-right: 40.5rem !important;\n}\n\n.pe-83 {\n  padding-right: 41rem !important;\n}\n\n.pe-84 {\n  padding-right: 41.5rem !important;\n}\n\n.pe-85 {\n  padding-right: 42rem !important;\n}\n\n.pe-86 {\n  padding-right: 42.5rem !important;\n}\n\n.pe-87 {\n  padding-right: 43rem !important;\n}\n\n.pe-88 {\n  padding-right: 43.5rem !important;\n}\n\n.pe-89 {\n  padding-right: 44rem !important;\n}\n\n.pe-90 {\n  padding-right: 44.5rem !important;\n}\n\n.pe-91 {\n  padding-right: 45rem !important;\n}\n\n.pe-92 {\n  padding-right: 45.5rem !important;\n}\n\n.pe-93 {\n  padding-right: 46rem !important;\n}\n\n.pe-94 {\n  padding-right: 46.5rem !important;\n}\n\n.pe-95 {\n  padding-right: 47rem !important;\n}\n\n.pe-96 {\n  padding-right: 47.5rem !important;\n}\n\n.pe-97 {\n  padding-right: 48rem !important;\n}\n\n.pe-98 {\n  padding-right: 48.5rem !important;\n}\n\n.pe-99 {\n  padding-right: 49rem !important;\n}\n\n.pe-100 {\n  padding-right: 49.5rem !important;\n}\n\n.pe-101 {\n  padding-right: 50rem !important;\n}\n\n.pe-102 {\n  padding-right: 50.5rem !important;\n}\n\n.pe-103 {\n  padding-right: 51rem !important;\n}\n\n.pe-104 {\n  padding-right: 51.5rem !important;\n}\n\n.pe-105 {\n  padding-right: 52rem !important;\n}\n\n.pe-106 {\n  padding-right: 52.5rem !important;\n}\n\n.pe-107 {\n  padding-right: 53rem !important;\n}\n\n.pe-108 {\n  padding-right: 53.5rem !important;\n}\n\n.pe-109 {\n  padding-right: 54rem !important;\n}\n\n.pe-110 {\n  padding-right: 54.5rem !important;\n}\n\n.pe-111 {\n  padding-right: 55rem !important;\n}\n\n.pe-112 {\n  padding-right: 55.5rem !important;\n}\n\n.pe-113 {\n  padding-right: 56rem !important;\n}\n\n.pe-114 {\n  padding-right: 56.5rem !important;\n}\n\n.pe-115 {\n  padding-right: 57rem !important;\n}\n\n.pe-116 {\n  padding-right: 57.5rem !important;\n}\n\n.pe-117 {\n  padding-right: 58rem !important;\n}\n\n.pe-118 {\n  padding-right: 58.5rem !important;\n}\n\n.pe-119 {\n  padding-right: 59rem !important;\n}\n\n.pe-120 {\n  padding-right: 59.5rem !important;\n}\n\n.pe-121 {\n  padding-right: 60rem !important;\n}\n\n.pe-122 {\n  padding-right: 60.5rem !important;\n}\n\n.pe-123 {\n  padding-right: 61rem !important;\n}\n\n.pe-124 {\n  padding-right: 61.5rem !important;\n}\n\n.pe-125 {\n  padding-right: 62rem !important;\n}\n\n.pe-126 {\n  padding-right: 62.5rem !important;\n}\n\n.pe-127 {\n  padding-right: 63rem !important;\n}\n\n.pe-128 {\n  padding-right: 63.5rem !important;\n}\n\n.pe-129 {\n  padding-right: 64rem !important;\n}\n\n.pe-130 {\n  padding-right: 64.5rem !important;\n}\n\n.pe-131 {\n  padding-right: 65rem !important;\n}\n\n.pe-132 {\n  padding-right: 65.5rem !important;\n}\n\n.pe-133 {\n  padding-right: 66rem !important;\n}\n\n.pe-134 {\n  padding-right: 66.5rem !important;\n}\n\n.pe-135 {\n  padding-right: 67rem !important;\n}\n\n.pe-136 {\n  padding-right: 67.5rem !important;\n}\n\n.pe-137 {\n  padding-right: 68rem !important;\n}\n\n.pe-138 {\n  padding-right: 68.5rem !important;\n}\n\n.pe-139 {\n  padding-right: 69rem !important;\n}\n\n.pe-140 {\n  padding-right: 69.5rem !important;\n}\n\n.pe-141 {\n  padding-right: 70rem !important;\n}\n\n.pe-142 {\n  padding-right: 70.5rem !important;\n}\n\n.pe-143 {\n  padding-right: 71rem !important;\n}\n\n.pe-144 {\n  padding-right: 71.5rem !important;\n}\n\n.pe-145 {\n  padding-right: 72rem !important;\n}\n\n.pe-146 {\n  padding-right: 72.5rem !important;\n}\n\n.pe-147 {\n  padding-right: 73rem !important;\n}\n\n.pe-148 {\n  padding-right: 73.5rem !important;\n}\n\n.pe-149 {\n  padding-right: 74rem !important;\n}\n\n.pe-150 {\n  padding-right: 74.5rem !important;\n}\n\n.pe-151 {\n  padding-right: 75rem !important;\n}\n\n.pe-152 {\n  padding-right: 75.5rem !important;\n}\n\n.pe-153 {\n  padding-right: 76rem !important;\n}\n\n.pe-154 {\n  padding-right: 76.5rem !important;\n}\n\n.pe-155 {\n  padding-right: 77rem !important;\n}\n\n.pe-156 {\n  padding-right: 77.5rem !important;\n}\n\n.pe-157 {\n  padding-right: 78rem !important;\n}\n\n.pe-158 {\n  padding-right: 78.5rem !important;\n}\n\n.pe-159 {\n  padding-right: 79rem !important;\n}\n\n.pe-160 {\n  padding-right: 79.5rem !important;\n}\n\n.px-0 {\n  padding-left: 0rem !important;\n  padding-right: 0rem !important;\n}\n\n.px-1 {\n  padding-left: 0.25rem !important;\n  padding-right: 0.25rem !important;\n}\n\n.px-2 {\n  padding-left: 0.5rem !important;\n  padding-right: 0.5rem !important;\n}\n\n.px-3 {\n  padding-left: 1rem !important;\n  padding-right: 1rem !important;\n}\n\n.px-4 {\n  padding-left: 1.5rem !important;\n  padding-right: 1.5rem !important;\n}\n\n.px-5 {\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n\n.px-6 {\n  padding-left: 2.5rem !important;\n  padding-right: 2.5rem !important;\n}\n\n.px-7 {\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n}\n\n.px-8 {\n  padding-left: 3.5rem !important;\n  padding-right: 3.5rem !important;\n}\n\n.px-9 {\n  padding-left: 4rem !important;\n  padding-right: 4rem !important;\n}\n\n.px-10 {\n  padding-left: 4.5rem !important;\n  padding-right: 4.5rem !important;\n}\n\n.px-11 {\n  padding-left: 5rem !important;\n  padding-right: 5rem !important;\n}\n\n.px-12 {\n  padding-left: 5.5rem !important;\n  padding-right: 5.5rem !important;\n}\n\n.px-13 {\n  padding-left: 6rem !important;\n  padding-right: 6rem !important;\n}\n\n.px-14 {\n  padding-left: 6.5rem !important;\n  padding-right: 6.5rem !important;\n}\n\n.px-15 {\n  padding-left: 7rem !important;\n  padding-right: 7rem !important;\n}\n\n.px-16 {\n  padding-left: 7.5rem !important;\n  padding-right: 7.5rem !important;\n}\n\n.px-17 {\n  padding-left: 8rem !important;\n  padding-right: 8rem !important;\n}\n\n.px-18 {\n  padding-left: 8.5rem !important;\n  padding-right: 8.5rem !important;\n}\n\n.px-19 {\n  padding-left: 9rem !important;\n  padding-right: 9rem !important;\n}\n\n.px-20 {\n  padding-left: 9.5rem !important;\n  padding-right: 9.5rem !important;\n}\n\n.px-21 {\n  padding-left: 10rem !important;\n  padding-right: 10rem !important;\n}\n\n.px-22 {\n  padding-left: 10.5rem !important;\n  padding-right: 10.5rem !important;\n}\n\n.px-23 {\n  padding-left: 11rem !important;\n  padding-right: 11rem !important;\n}\n\n.px-24 {\n  padding-left: 11.5rem !important;\n  padding-right: 11.5rem !important;\n}\n\n.px-25 {\n  padding-left: 12rem !important;\n  padding-right: 12rem !important;\n}\n\n.px-26 {\n  padding-left: 12.5rem !important;\n  padding-right: 12.5rem !important;\n}\n\n.px-27 {\n  padding-left: 13rem !important;\n  padding-right: 13rem !important;\n}\n\n.px-28 {\n  padding-left: 13.5rem !important;\n  padding-right: 13.5rem !important;\n}\n\n.px-29 {\n  padding-left: 14rem !important;\n  padding-right: 14rem !important;\n}\n\n.px-30 {\n  padding-left: 14.5rem !important;\n  padding-right: 14.5rem !important;\n}\n\n.px-31 {\n  padding-left: 15rem !important;\n  padding-right: 15rem !important;\n}\n\n.px-32 {\n  padding-left: 15.5rem !important;\n  padding-right: 15.5rem !important;\n}\n\n.px-33 {\n  padding-left: 16rem !important;\n  padding-right: 16rem !important;\n}\n\n.px-34 {\n  padding-left: 16.5rem !important;\n  padding-right: 16.5rem !important;\n}\n\n.px-35 {\n  padding-left: 17rem !important;\n  padding-right: 17rem !important;\n}\n\n.px-36 {\n  padding-left: 17.5rem !important;\n  padding-right: 17.5rem !important;\n}\n\n.px-37 {\n  padding-left: 18rem !important;\n  padding-right: 18rem !important;\n}\n\n.px-38 {\n  padding-left: 18.5rem !important;\n  padding-right: 18.5rem !important;\n}\n\n.px-39 {\n  padding-left: 19rem !important;\n  padding-right: 19rem !important;\n}\n\n.px-40 {\n  padding-left: 19.5rem !important;\n  padding-right: 19.5rem !important;\n}\n\n.px-41 {\n  padding-left: 20rem !important;\n  padding-right: 20rem !important;\n}\n\n.px-42 {\n  padding-left: 20.5rem !important;\n  padding-right: 20.5rem !important;\n}\n\n.px-43 {\n  padding-left: 21rem !important;\n  padding-right: 21rem !important;\n}\n\n.px-44 {\n  padding-left: 21.5rem !important;\n  padding-right: 21.5rem !important;\n}\n\n.px-45 {\n  padding-left: 22rem !important;\n  padding-right: 22rem !important;\n}\n\n.px-46 {\n  padding-left: 22.5rem !important;\n  padding-right: 22.5rem !important;\n}\n\n.px-47 {\n  padding-left: 23rem !important;\n  padding-right: 23rem !important;\n}\n\n.px-48 {\n  padding-left: 23.5rem !important;\n  padding-right: 23.5rem !important;\n}\n\n.px-49 {\n  padding-left: 24rem !important;\n  padding-right: 24rem !important;\n}\n\n.px-50 {\n  padding-left: 24.5rem !important;\n  padding-right: 24.5rem !important;\n}\n\n.px-51 {\n  padding-left: 25rem !important;\n  padding-right: 25rem !important;\n}\n\n.px-52 {\n  padding-left: 25.5rem !important;\n  padding-right: 25.5rem !important;\n}\n\n.px-53 {\n  padding-left: 26rem !important;\n  padding-right: 26rem !important;\n}\n\n.px-54 {\n  padding-left: 26.5rem !important;\n  padding-right: 26.5rem !important;\n}\n\n.px-55 {\n  padding-left: 27rem !important;\n  padding-right: 27rem !important;\n}\n\n.px-56 {\n  padding-left: 27.5rem !important;\n  padding-right: 27.5rem !important;\n}\n\n.px-57 {\n  padding-left: 28rem !important;\n  padding-right: 28rem !important;\n}\n\n.px-58 {\n  padding-left: 28.5rem !important;\n  padding-right: 28.5rem !important;\n}\n\n.px-59 {\n  padding-left: 29rem !important;\n  padding-right: 29rem !important;\n}\n\n.px-60 {\n  padding-left: 29.5rem !important;\n  padding-right: 29.5rem !important;\n}\n\n.px-61 {\n  padding-left: 30rem !important;\n  padding-right: 30rem !important;\n}\n\n.px-62 {\n  padding-left: 30.5rem !important;\n  padding-right: 30.5rem !important;\n}\n\n.px-63 {\n  padding-left: 31rem !important;\n  padding-right: 31rem !important;\n}\n\n.px-64 {\n  padding-left: 31.5rem !important;\n  padding-right: 31.5rem !important;\n}\n\n.px-65 {\n  padding-left: 32rem !important;\n  padding-right: 32rem !important;\n}\n\n.px-66 {\n  padding-left: 32.5rem !important;\n  padding-right: 32.5rem !important;\n}\n\n.px-67 {\n  padding-left: 33rem !important;\n  padding-right: 33rem !important;\n}\n\n.px-68 {\n  padding-left: 33.5rem !important;\n  padding-right: 33.5rem !important;\n}\n\n.px-69 {\n  padding-left: 34rem !important;\n  padding-right: 34rem !important;\n}\n\n.px-70 {\n  padding-left: 34.5rem !important;\n  padding-right: 34.5rem !important;\n}\n\n.px-71 {\n  padding-left: 35rem !important;\n  padding-right: 35rem !important;\n}\n\n.px-72 {\n  padding-left: 35.5rem !important;\n  padding-right: 35.5rem !important;\n}\n\n.px-73 {\n  padding-left: 36rem !important;\n  padding-right: 36rem !important;\n}\n\n.px-74 {\n  padding-left: 36.5rem !important;\n  padding-right: 36.5rem !important;\n}\n\n.px-75 {\n  padding-left: 37rem !important;\n  padding-right: 37rem !important;\n}\n\n.px-76 {\n  padding-left: 37.5rem !important;\n  padding-right: 37.5rem !important;\n}\n\n.px-77 {\n  padding-left: 38rem !important;\n  padding-right: 38rem !important;\n}\n\n.px-78 {\n  padding-left: 38.5rem !important;\n  padding-right: 38.5rem !important;\n}\n\n.px-79 {\n  padding-left: 39rem !important;\n  padding-right: 39rem !important;\n}\n\n.px-80 {\n  padding-left: 39.5rem !important;\n  padding-right: 39.5rem !important;\n}\n\n.px-81 {\n  padding-left: 40rem !important;\n  padding-right: 40rem !important;\n}\n\n.px-82 {\n  padding-left: 40.5rem !important;\n  padding-right: 40.5rem !important;\n}\n\n.px-83 {\n  padding-left: 41rem !important;\n  padding-right: 41rem !important;\n}\n\n.px-84 {\n  padding-left: 41.5rem !important;\n  padding-right: 41.5rem !important;\n}\n\n.px-85 {\n  padding-left: 42rem !important;\n  padding-right: 42rem !important;\n}\n\n.px-86 {\n  padding-left: 42.5rem !important;\n  padding-right: 42.5rem !important;\n}\n\n.px-87 {\n  padding-left: 43rem !important;\n  padding-right: 43rem !important;\n}\n\n.px-88 {\n  padding-left: 43.5rem !important;\n  padding-right: 43.5rem !important;\n}\n\n.px-89 {\n  padding-left: 44rem !important;\n  padding-right: 44rem !important;\n}\n\n.px-90 {\n  padding-left: 44.5rem !important;\n  padding-right: 44.5rem !important;\n}\n\n.px-91 {\n  padding-left: 45rem !important;\n  padding-right: 45rem !important;\n}\n\n.px-92 {\n  padding-left: 45.5rem !important;\n  padding-right: 45.5rem !important;\n}\n\n.px-93 {\n  padding-left: 46rem !important;\n  padding-right: 46rem !important;\n}\n\n.px-94 {\n  padding-left: 46.5rem !important;\n  padding-right: 46.5rem !important;\n}\n\n.px-95 {\n  padding-left: 47rem !important;\n  padding-right: 47rem !important;\n}\n\n.px-96 {\n  padding-left: 47.5rem !important;\n  padding-right: 47.5rem !important;\n}\n\n.px-97 {\n  padding-left: 48rem !important;\n  padding-right: 48rem !important;\n}\n\n.px-98 {\n  padding-left: 48.5rem !important;\n  padding-right: 48.5rem !important;\n}\n\n.px-99 {\n  padding-left: 49rem !important;\n  padding-right: 49rem !important;\n}\n\n.px-100 {\n  padding-left: 49.5rem !important;\n  padding-right: 49.5rem !important;\n}\n\n.px-101 {\n  padding-left: 50rem !important;\n  padding-right: 50rem !important;\n}\n\n.px-102 {\n  padding-left: 50.5rem !important;\n  padding-right: 50.5rem !important;\n}\n\n.px-103 {\n  padding-left: 51rem !important;\n  padding-right: 51rem !important;\n}\n\n.px-104 {\n  padding-left: 51.5rem !important;\n  padding-right: 51.5rem !important;\n}\n\n.px-105 {\n  padding-left: 52rem !important;\n  padding-right: 52rem !important;\n}\n\n.px-106 {\n  padding-left: 52.5rem !important;\n  padding-right: 52.5rem !important;\n}\n\n.px-107 {\n  padding-left: 53rem !important;\n  padding-right: 53rem !important;\n}\n\n.px-108 {\n  padding-left: 53.5rem !important;\n  padding-right: 53.5rem !important;\n}\n\n.px-109 {\n  padding-left: 54rem !important;\n  padding-right: 54rem !important;\n}\n\n.px-110 {\n  padding-left: 54.5rem !important;\n  padding-right: 54.5rem !important;\n}\n\n.px-111 {\n  padding-left: 55rem !important;\n  padding-right: 55rem !important;\n}\n\n.px-112 {\n  padding-left: 55.5rem !important;\n  padding-right: 55.5rem !important;\n}\n\n.px-113 {\n  padding-left: 56rem !important;\n  padding-right: 56rem !important;\n}\n\n.px-114 {\n  padding-left: 56.5rem !important;\n  padding-right: 56.5rem !important;\n}\n\n.px-115 {\n  padding-left: 57rem !important;\n  padding-right: 57rem !important;\n}\n\n.px-116 {\n  padding-left: 57.5rem !important;\n  padding-right: 57.5rem !important;\n}\n\n.px-117 {\n  padding-left: 58rem !important;\n  padding-right: 58rem !important;\n}\n\n.px-118 {\n  padding-left: 58.5rem !important;\n  padding-right: 58.5rem !important;\n}\n\n.px-119 {\n  padding-left: 59rem !important;\n  padding-right: 59rem !important;\n}\n\n.px-120 {\n  padding-left: 59.5rem !important;\n  padding-right: 59.5rem !important;\n}\n\n.px-121 {\n  padding-left: 60rem !important;\n  padding-right: 60rem !important;\n}\n\n.px-122 {\n  padding-left: 60.5rem !important;\n  padding-right: 60.5rem !important;\n}\n\n.px-123 {\n  padding-left: 61rem !important;\n  padding-right: 61rem !important;\n}\n\n.px-124 {\n  padding-left: 61.5rem !important;\n  padding-right: 61.5rem !important;\n}\n\n.px-125 {\n  padding-left: 62rem !important;\n  padding-right: 62rem !important;\n}\n\n.px-126 {\n  padding-left: 62.5rem !important;\n  padding-right: 62.5rem !important;\n}\n\n.px-127 {\n  padding-left: 63rem !important;\n  padding-right: 63rem !important;\n}\n\n.px-128 {\n  padding-left: 63.5rem !important;\n  padding-right: 63.5rem !important;\n}\n\n.px-129 {\n  padding-left: 64rem !important;\n  padding-right: 64rem !important;\n}\n\n.px-130 {\n  padding-left: 64.5rem !important;\n  padding-right: 64.5rem !important;\n}\n\n.px-131 {\n  padding-left: 65rem !important;\n  padding-right: 65rem !important;\n}\n\n.px-132 {\n  padding-left: 65.5rem !important;\n  padding-right: 65.5rem !important;\n}\n\n.px-133 {\n  padding-left: 66rem !important;\n  padding-right: 66rem !important;\n}\n\n.px-134 {\n  padding-left: 66.5rem !important;\n  padding-right: 66.5rem !important;\n}\n\n.px-135 {\n  padding-left: 67rem !important;\n  padding-right: 67rem !important;\n}\n\n.px-136 {\n  padding-left: 67.5rem !important;\n  padding-right: 67.5rem !important;\n}\n\n.px-137 {\n  padding-left: 68rem !important;\n  padding-right: 68rem !important;\n}\n\n.px-138 {\n  padding-left: 68.5rem !important;\n  padding-right: 68.5rem !important;\n}\n\n.px-139 {\n  padding-left: 69rem !important;\n  padding-right: 69rem !important;\n}\n\n.px-140 {\n  padding-left: 69.5rem !important;\n  padding-right: 69.5rem !important;\n}\n\n.px-141 {\n  padding-left: 70rem !important;\n  padding-right: 70rem !important;\n}\n\n.px-142 {\n  padding-left: 70.5rem !important;\n  padding-right: 70.5rem !important;\n}\n\n.px-143 {\n  padding-left: 71rem !important;\n  padding-right: 71rem !important;\n}\n\n.px-144 {\n  padding-left: 71.5rem !important;\n  padding-right: 71.5rem !important;\n}\n\n.px-145 {\n  padding-left: 72rem !important;\n  padding-right: 72rem !important;\n}\n\n.px-146 {\n  padding-left: 72.5rem !important;\n  padding-right: 72.5rem !important;\n}\n\n.px-147 {\n  padding-left: 73rem !important;\n  padding-right: 73rem !important;\n}\n\n.px-148 {\n  padding-left: 73.5rem !important;\n  padding-right: 73.5rem !important;\n}\n\n.px-149 {\n  padding-left: 74rem !important;\n  padding-right: 74rem !important;\n}\n\n.px-150 {\n  padding-left: 74.5rem !important;\n  padding-right: 74.5rem !important;\n}\n\n.px-151 {\n  padding-left: 75rem !important;\n  padding-right: 75rem !important;\n}\n\n.px-152 {\n  padding-left: 75.5rem !important;\n  padding-right: 75.5rem !important;\n}\n\n.px-153 {\n  padding-left: 76rem !important;\n  padding-right: 76rem !important;\n}\n\n.px-154 {\n  padding-left: 76.5rem !important;\n  padding-right: 76.5rem !important;\n}\n\n.px-155 {\n  padding-left: 77rem !important;\n  padding-right: 77rem !important;\n}\n\n.px-156 {\n  padding-left: 77.5rem !important;\n  padding-right: 77.5rem !important;\n}\n\n.px-157 {\n  padding-left: 78rem !important;\n  padding-right: 78rem !important;\n}\n\n.px-158 {\n  padding-left: 78.5rem !important;\n  padding-right: 78.5rem !important;\n}\n\n.px-159 {\n  padding-left: 79rem !important;\n  padding-right: 79rem !important;\n}\n\n.px-160 {\n  padding-left: 79.5rem !important;\n  padding-right: 79.5rem !important;\n}\n\n.py-0 {\n  padding-top: 0rem !important;\n  padding-bottom: 0rem !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.py-6 {\n  padding-top: 2.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n.py-7 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-8 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-9 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-10 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.py-11 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.py-12 {\n  padding-top: 5.5rem !important;\n  padding-bottom: 5.5rem !important;\n}\n\n.py-13 {\n  padding-top: 6rem !important;\n  padding-bottom: 6rem !important;\n}\n\n.py-14 {\n  padding-top: 6.5rem !important;\n  padding-bottom: 6.5rem !important;\n}\n\n.py-15 {\n  padding-top: 7rem !important;\n  padding-bottom: 7rem !important;\n}\n\n.py-16 {\n  padding-top: 7.5rem !important;\n  padding-bottom: 7.5rem !important;\n}\n\n.py-17 {\n  padding-top: 8rem !important;\n  padding-bottom: 8rem !important;\n}\n\n.py-18 {\n  padding-top: 8.5rem !important;\n  padding-bottom: 8.5rem !important;\n}\n\n.py-19 {\n  padding-top: 9rem !important;\n  padding-bottom: 9rem !important;\n}\n\n.py-20 {\n  padding-top: 9.5rem !important;\n  padding-bottom: 9.5rem !important;\n}\n\n.py-21 {\n  padding-top: 10rem !important;\n  padding-bottom: 10rem !important;\n}\n\n.py-22 {\n  padding-top: 10.5rem !important;\n  padding-bottom: 10.5rem !important;\n}\n\n.py-23 {\n  padding-top: 11rem !important;\n  padding-bottom: 11rem !important;\n}\n\n.py-24 {\n  padding-top: 11.5rem !important;\n  padding-bottom: 11.5rem !important;\n}\n\n.py-25 {\n  padding-top: 12rem !important;\n  padding-bottom: 12rem !important;\n}\n\n.py-26 {\n  padding-top: 12.5rem !important;\n  padding-bottom: 12.5rem !important;\n}\n\n.py-27 {\n  padding-top: 13rem !important;\n  padding-bottom: 13rem !important;\n}\n\n.py-28 {\n  padding-top: 13.5rem !important;\n  padding-bottom: 13.5rem !important;\n}\n\n.py-29 {\n  padding-top: 14rem !important;\n  padding-bottom: 14rem !important;\n}\n\n.py-30 {\n  padding-top: 14.5rem !important;\n  padding-bottom: 14.5rem !important;\n}\n\n.py-31 {\n  padding-top: 15rem !important;\n  padding-bottom: 15rem !important;\n}\n\n.py-32 {\n  padding-top: 15.5rem !important;\n  padding-bottom: 15.5rem !important;\n}\n\n.py-33 {\n  padding-top: 16rem !important;\n  padding-bottom: 16rem !important;\n}\n\n.py-34 {\n  padding-top: 16.5rem !important;\n  padding-bottom: 16.5rem !important;\n}\n\n.py-35 {\n  padding-top: 17rem !important;\n  padding-bottom: 17rem !important;\n}\n\n.py-36 {\n  padding-top: 17.5rem !important;\n  padding-bottom: 17.5rem !important;\n}\n\n.py-37 {\n  padding-top: 18rem !important;\n  padding-bottom: 18rem !important;\n}\n\n.py-38 {\n  padding-top: 18.5rem !important;\n  padding-bottom: 18.5rem !important;\n}\n\n.py-39 {\n  padding-top: 19rem !important;\n  padding-bottom: 19rem !important;\n}\n\n.py-40 {\n  padding-top: 19.5rem !important;\n  padding-bottom: 19.5rem !important;\n}\n\n.py-41 {\n  padding-top: 20rem !important;\n  padding-bottom: 20rem !important;\n}\n\n.py-42 {\n  padding-top: 20.5rem !important;\n  padding-bottom: 20.5rem !important;\n}\n\n.py-43 {\n  padding-top: 21rem !important;\n  padding-bottom: 21rem !important;\n}\n\n.py-44 {\n  padding-top: 21.5rem !important;\n  padding-bottom: 21.5rem !important;\n}\n\n.py-45 {\n  padding-top: 22rem !important;\n  padding-bottom: 22rem !important;\n}\n\n.py-46 {\n  padding-top: 22.5rem !important;\n  padding-bottom: 22.5rem !important;\n}\n\n.py-47 {\n  padding-top: 23rem !important;\n  padding-bottom: 23rem !important;\n}\n\n.py-48 {\n  padding-top: 23.5rem !important;\n  padding-bottom: 23.5rem !important;\n}\n\n.py-49 {\n  padding-top: 24rem !important;\n  padding-bottom: 24rem !important;\n}\n\n.py-50 {\n  padding-top: 24.5rem !important;\n  padding-bottom: 24.5rem !important;\n}\n\n.py-51 {\n  padding-top: 25rem !important;\n  padding-bottom: 25rem !important;\n}\n\n.py-52 {\n  padding-top: 25.5rem !important;\n  padding-bottom: 25.5rem !important;\n}\n\n.py-53 {\n  padding-top: 26rem !important;\n  padding-bottom: 26rem !important;\n}\n\n.py-54 {\n  padding-top: 26.5rem !important;\n  padding-bottom: 26.5rem !important;\n}\n\n.py-55 {\n  padding-top: 27rem !important;\n  padding-bottom: 27rem !important;\n}\n\n.py-56 {\n  padding-top: 27.5rem !important;\n  padding-bottom: 27.5rem !important;\n}\n\n.py-57 {\n  padding-top: 28rem !important;\n  padding-bottom: 28rem !important;\n}\n\n.py-58 {\n  padding-top: 28.5rem !important;\n  padding-bottom: 28.5rem !important;\n}\n\n.py-59 {\n  padding-top: 29rem !important;\n  padding-bottom: 29rem !important;\n}\n\n.py-60 {\n  padding-top: 29.5rem !important;\n  padding-bottom: 29.5rem !important;\n}\n\n.py-61 {\n  padding-top: 30rem !important;\n  padding-bottom: 30rem !important;\n}\n\n.py-62 {\n  padding-top: 30.5rem !important;\n  padding-bottom: 30.5rem !important;\n}\n\n.py-63 {\n  padding-top: 31rem !important;\n  padding-bottom: 31rem !important;\n}\n\n.py-64 {\n  padding-top: 31.5rem !important;\n  padding-bottom: 31.5rem !important;\n}\n\n.py-65 {\n  padding-top: 32rem !important;\n  padding-bottom: 32rem !important;\n}\n\n.py-66 {\n  padding-top: 32.5rem !important;\n  padding-bottom: 32.5rem !important;\n}\n\n.py-67 {\n  padding-top: 33rem !important;\n  padding-bottom: 33rem !important;\n}\n\n.py-68 {\n  padding-top: 33.5rem !important;\n  padding-bottom: 33.5rem !important;\n}\n\n.py-69 {\n  padding-top: 34rem !important;\n  padding-bottom: 34rem !important;\n}\n\n.py-70 {\n  padding-top: 34.5rem !important;\n  padding-bottom: 34.5rem !important;\n}\n\n.py-71 {\n  padding-top: 35rem !important;\n  padding-bottom: 35rem !important;\n}\n\n.py-72 {\n  padding-top: 35.5rem !important;\n  padding-bottom: 35.5rem !important;\n}\n\n.py-73 {\n  padding-top: 36rem !important;\n  padding-bottom: 36rem !important;\n}\n\n.py-74 {\n  padding-top: 36.5rem !important;\n  padding-bottom: 36.5rem !important;\n}\n\n.py-75 {\n  padding-top: 37rem !important;\n  padding-bottom: 37rem !important;\n}\n\n.py-76 {\n  padding-top: 37.5rem !important;\n  padding-bottom: 37.5rem !important;\n}\n\n.py-77 {\n  padding-top: 38rem !important;\n  padding-bottom: 38rem !important;\n}\n\n.py-78 {\n  padding-top: 38.5rem !important;\n  padding-bottom: 38.5rem !important;\n}\n\n.py-79 {\n  padding-top: 39rem !important;\n  padding-bottom: 39rem !important;\n}\n\n.py-80 {\n  padding-top: 39.5rem !important;\n  padding-bottom: 39.5rem !important;\n}\n\n.py-81 {\n  padding-top: 40rem !important;\n  padding-bottom: 40rem !important;\n}\n\n.py-82 {\n  padding-top: 40.5rem !important;\n  padding-bottom: 40.5rem !important;\n}\n\n.py-83 {\n  padding-top: 41rem !important;\n  padding-bottom: 41rem !important;\n}\n\n.py-84 {\n  padding-top: 41.5rem !important;\n  padding-bottom: 41.5rem !important;\n}\n\n.py-85 {\n  padding-top: 42rem !important;\n  padding-bottom: 42rem !important;\n}\n\n.py-86 {\n  padding-top: 42.5rem !important;\n  padding-bottom: 42.5rem !important;\n}\n\n.py-87 {\n  padding-top: 43rem !important;\n  padding-bottom: 43rem !important;\n}\n\n.py-88 {\n  padding-top: 43.5rem !important;\n  padding-bottom: 43.5rem !important;\n}\n\n.py-89 {\n  padding-top: 44rem !important;\n  padding-bottom: 44rem !important;\n}\n\n.py-90 {\n  padding-top: 44.5rem !important;\n  padding-bottom: 44.5rem !important;\n}\n\n.py-91 {\n  padding-top: 45rem !important;\n  padding-bottom: 45rem !important;\n}\n\n.py-92 {\n  padding-top: 45.5rem !important;\n  padding-bottom: 45.5rem !important;\n}\n\n.py-93 {\n  padding-top: 46rem !important;\n  padding-bottom: 46rem !important;\n}\n\n.py-94 {\n  padding-top: 46.5rem !important;\n  padding-bottom: 46.5rem !important;\n}\n\n.py-95 {\n  padding-top: 47rem !important;\n  padding-bottom: 47rem !important;\n}\n\n.py-96 {\n  padding-top: 47.5rem !important;\n  padding-bottom: 47.5rem !important;\n}\n\n.py-97 {\n  padding-top: 48rem !important;\n  padding-bottom: 48rem !important;\n}\n\n.py-98 {\n  padding-top: 48.5rem !important;\n  padding-bottom: 48.5rem !important;\n}\n\n.py-99 {\n  padding-top: 49rem !important;\n  padding-bottom: 49rem !important;\n}\n\n.py-100 {\n  padding-top: 49.5rem !important;\n  padding-bottom: 49.5rem !important;\n}\n\n.py-101 {\n  padding-top: 50rem !important;\n  padding-bottom: 50rem !important;\n}\n\n.py-102 {\n  padding-top: 50.5rem !important;\n  padding-bottom: 50.5rem !important;\n}\n\n.py-103 {\n  padding-top: 51rem !important;\n  padding-bottom: 51rem !important;\n}\n\n.py-104 {\n  padding-top: 51.5rem !important;\n  padding-bottom: 51.5rem !important;\n}\n\n.py-105 {\n  padding-top: 52rem !important;\n  padding-bottom: 52rem !important;\n}\n\n.py-106 {\n  padding-top: 52.5rem !important;\n  padding-bottom: 52.5rem !important;\n}\n\n.py-107 {\n  padding-top: 53rem !important;\n  padding-bottom: 53rem !important;\n}\n\n.py-108 {\n  padding-top: 53.5rem !important;\n  padding-bottom: 53.5rem !important;\n}\n\n.py-109 {\n  padding-top: 54rem !important;\n  padding-bottom: 54rem !important;\n}\n\n.py-110 {\n  padding-top: 54.5rem !important;\n  padding-bottom: 54.5rem !important;\n}\n\n.py-111 {\n  padding-top: 55rem !important;\n  padding-bottom: 55rem !important;\n}\n\n.py-112 {\n  padding-top: 55.5rem !important;\n  padding-bottom: 55.5rem !important;\n}\n\n.py-113 {\n  padding-top: 56rem !important;\n  padding-bottom: 56rem !important;\n}\n\n.py-114 {\n  padding-top: 56.5rem !important;\n  padding-bottom: 56.5rem !important;\n}\n\n.py-115 {\n  padding-top: 57rem !important;\n  padding-bottom: 57rem !important;\n}\n\n.py-116 {\n  padding-top: 57.5rem !important;\n  padding-bottom: 57.5rem !important;\n}\n\n.py-117 {\n  padding-top: 58rem !important;\n  padding-bottom: 58rem !important;\n}\n\n.py-118 {\n  padding-top: 58.5rem !important;\n  padding-bottom: 58.5rem !important;\n}\n\n.py-119 {\n  padding-top: 59rem !important;\n  padding-bottom: 59rem !important;\n}\n\n.py-120 {\n  padding-top: 59.5rem !important;\n  padding-bottom: 59.5rem !important;\n}\n\n.py-121 {\n  padding-top: 60rem !important;\n  padding-bottom: 60rem !important;\n}\n\n.py-122 {\n  padding-top: 60.5rem !important;\n  padding-bottom: 60.5rem !important;\n}\n\n.py-123 {\n  padding-top: 61rem !important;\n  padding-bottom: 61rem !important;\n}\n\n.py-124 {\n  padding-top: 61.5rem !important;\n  padding-bottom: 61.5rem !important;\n}\n\n.py-125 {\n  padding-top: 62rem !important;\n  padding-bottom: 62rem !important;\n}\n\n.py-126 {\n  padding-top: 62.5rem !important;\n  padding-bottom: 62.5rem !important;\n}\n\n.py-127 {\n  padding-top: 63rem !important;\n  padding-bottom: 63rem !important;\n}\n\n.py-128 {\n  padding-top: 63.5rem !important;\n  padding-bottom: 63.5rem !important;\n}\n\n.py-129 {\n  padding-top: 64rem !important;\n  padding-bottom: 64rem !important;\n}\n\n.py-130 {\n  padding-top: 64.5rem !important;\n  padding-bottom: 64.5rem !important;\n}\n\n.py-131 {\n  padding-top: 65rem !important;\n  padding-bottom: 65rem !important;\n}\n\n.py-132 {\n  padding-top: 65.5rem !important;\n  padding-bottom: 65.5rem !important;\n}\n\n.py-133 {\n  padding-top: 66rem !important;\n  padding-bottom: 66rem !important;\n}\n\n.py-134 {\n  padding-top: 66.5rem !important;\n  padding-bottom: 66.5rem !important;\n}\n\n.py-135 {\n  padding-top: 67rem !important;\n  padding-bottom: 67rem !important;\n}\n\n.py-136 {\n  padding-top: 67.5rem !important;\n  padding-bottom: 67.5rem !important;\n}\n\n.py-137 {\n  padding-top: 68rem !important;\n  padding-bottom: 68rem !important;\n}\n\n.py-138 {\n  padding-top: 68.5rem !important;\n  padding-bottom: 68.5rem !important;\n}\n\n.py-139 {\n  padding-top: 69rem !important;\n  padding-bottom: 69rem !important;\n}\n\n.py-140 {\n  padding-top: 69.5rem !important;\n  padding-bottom: 69.5rem !important;\n}\n\n.py-141 {\n  padding-top: 70rem !important;\n  padding-bottom: 70rem !important;\n}\n\n.py-142 {\n  padding-top: 70.5rem !important;\n  padding-bottom: 70.5rem !important;\n}\n\n.py-143 {\n  padding-top: 71rem !important;\n  padding-bottom: 71rem !important;\n}\n\n.py-144 {\n  padding-top: 71.5rem !important;\n  padding-bottom: 71.5rem !important;\n}\n\n.py-145 {\n  padding-top: 72rem !important;\n  padding-bottom: 72rem !important;\n}\n\n.py-146 {\n  padding-top: 72.5rem !important;\n  padding-bottom: 72.5rem !important;\n}\n\n.py-147 {\n  padding-top: 73rem !important;\n  padding-bottom: 73rem !important;\n}\n\n.py-148 {\n  padding-top: 73.5rem !important;\n  padding-bottom: 73.5rem !important;\n}\n\n.py-149 {\n  padding-top: 74rem !important;\n  padding-bottom: 74rem !important;\n}\n\n.py-150 {\n  padding-top: 74.5rem !important;\n  padding-bottom: 74.5rem !important;\n}\n\n.py-151 {\n  padding-top: 75rem !important;\n  padding-bottom: 75rem !important;\n}\n\n.py-152 {\n  padding-top: 75.5rem !important;\n  padding-bottom: 75.5rem !important;\n}\n\n.py-153 {\n  padding-top: 76rem !important;\n  padding-bottom: 76rem !important;\n}\n\n.py-154 {\n  padding-top: 76.5rem !important;\n  padding-bottom: 76.5rem !important;\n}\n\n.py-155 {\n  padding-top: 77rem !important;\n  padding-bottom: 77rem !important;\n}\n\n.py-156 {\n  padding-top: 77.5rem !important;\n  padding-bottom: 77.5rem !important;\n}\n\n.py-157 {\n  padding-top: 78rem !important;\n  padding-bottom: 78rem !important;\n}\n\n.py-158 {\n  padding-top: 78.5rem !important;\n  padding-bottom: 78.5rem !important;\n}\n\n.py-159 {\n  padding-top: 79rem !important;\n  padding-bottom: 79rem !important;\n}\n\n.py-160 {\n  padding-top: 79.5rem !important;\n  padding-bottom: 79.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .p-sm-0 {\n    padding: 0rem !important;\n  }\n\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-sm-5 {\n    padding: 2rem !important;\n  }\n\n  .p-sm-6 {\n    padding: 2.5rem !important;\n  }\n\n  .p-sm-7 {\n    padding: 3rem !important;\n  }\n\n  .p-sm-8 {\n    padding: 3.5rem !important;\n  }\n\n  .p-sm-9 {\n    padding: 4rem !important;\n  }\n\n  .p-sm-10 {\n    padding: 4.5rem !important;\n  }\n\n  .p-sm-11 {\n    padding: 5rem !important;\n  }\n\n  .p-sm-12 {\n    padding: 5.5rem !important;\n  }\n\n  .p-sm-13 {\n    padding: 6rem !important;\n  }\n\n  .p-sm-14 {\n    padding: 6.5rem !important;\n  }\n\n  .p-sm-15 {\n    padding: 7rem !important;\n  }\n\n  .p-sm-16 {\n    padding: 7.5rem !important;\n  }\n\n  .p-sm-17 {\n    padding: 8rem !important;\n  }\n\n  .p-sm-18 {\n    padding: 8.5rem !important;\n  }\n\n  .p-sm-19 {\n    padding: 9rem !important;\n  }\n\n  .p-sm-20 {\n    padding: 9.5rem !important;\n  }\n\n  .p-sm-21 {\n    padding: 10rem !important;\n  }\n\n  .p-sm-22 {\n    padding: 10.5rem !important;\n  }\n\n  .p-sm-23 {\n    padding: 11rem !important;\n  }\n\n  .p-sm-24 {\n    padding: 11.5rem !important;\n  }\n\n  .p-sm-25 {\n    padding: 12rem !important;\n  }\n\n  .p-sm-26 {\n    padding: 12.5rem !important;\n  }\n\n  .p-sm-27 {\n    padding: 13rem !important;\n  }\n\n  .p-sm-28 {\n    padding: 13.5rem !important;\n  }\n\n  .p-sm-29 {\n    padding: 14rem !important;\n  }\n\n  .p-sm-30 {\n    padding: 14.5rem !important;\n  }\n\n  .p-sm-31 {\n    padding: 15rem !important;\n  }\n\n  .p-sm-32 {\n    padding: 15.5rem !important;\n  }\n\n  .p-sm-33 {\n    padding: 16rem !important;\n  }\n\n  .p-sm-34 {\n    padding: 16.5rem !important;\n  }\n\n  .p-sm-35 {\n    padding: 17rem !important;\n  }\n\n  .p-sm-36 {\n    padding: 17.5rem !important;\n  }\n\n  .p-sm-37 {\n    padding: 18rem !important;\n  }\n\n  .p-sm-38 {\n    padding: 18.5rem !important;\n  }\n\n  .p-sm-39 {\n    padding: 19rem !important;\n  }\n\n  .p-sm-40 {\n    padding: 19.5rem !important;\n  }\n\n  .p-sm-41 {\n    padding: 20rem !important;\n  }\n\n  .p-sm-42 {\n    padding: 20.5rem !important;\n  }\n\n  .p-sm-43 {\n    padding: 21rem !important;\n  }\n\n  .p-sm-44 {\n    padding: 21.5rem !important;\n  }\n\n  .p-sm-45 {\n    padding: 22rem !important;\n  }\n\n  .p-sm-46 {\n    padding: 22.5rem !important;\n  }\n\n  .p-sm-47 {\n    padding: 23rem !important;\n  }\n\n  .p-sm-48 {\n    padding: 23.5rem !important;\n  }\n\n  .p-sm-49 {\n    padding: 24rem !important;\n  }\n\n  .p-sm-50 {\n    padding: 24.5rem !important;\n  }\n\n  .p-sm-51 {\n    padding: 25rem !important;\n  }\n\n  .p-sm-52 {\n    padding: 25.5rem !important;\n  }\n\n  .p-sm-53 {\n    padding: 26rem !important;\n  }\n\n  .p-sm-54 {\n    padding: 26.5rem !important;\n  }\n\n  .p-sm-55 {\n    padding: 27rem !important;\n  }\n\n  .p-sm-56 {\n    padding: 27.5rem !important;\n  }\n\n  .p-sm-57 {\n    padding: 28rem !important;\n  }\n\n  .p-sm-58 {\n    padding: 28.5rem !important;\n  }\n\n  .p-sm-59 {\n    padding: 29rem !important;\n  }\n\n  .p-sm-60 {\n    padding: 29.5rem !important;\n  }\n\n  .p-sm-61 {\n    padding: 30rem !important;\n  }\n\n  .p-sm-62 {\n    padding: 30.5rem !important;\n  }\n\n  .p-sm-63 {\n    padding: 31rem !important;\n  }\n\n  .p-sm-64 {\n    padding: 31.5rem !important;\n  }\n\n  .p-sm-65 {\n    padding: 32rem !important;\n  }\n\n  .p-sm-66 {\n    padding: 32.5rem !important;\n  }\n\n  .p-sm-67 {\n    padding: 33rem !important;\n  }\n\n  .p-sm-68 {\n    padding: 33.5rem !important;\n  }\n\n  .p-sm-69 {\n    padding: 34rem !important;\n  }\n\n  .p-sm-70 {\n    padding: 34.5rem !important;\n  }\n\n  .p-sm-71 {\n    padding: 35rem !important;\n  }\n\n  .p-sm-72 {\n    padding: 35.5rem !important;\n  }\n\n  .p-sm-73 {\n    padding: 36rem !important;\n  }\n\n  .p-sm-74 {\n    padding: 36.5rem !important;\n  }\n\n  .p-sm-75 {\n    padding: 37rem !important;\n  }\n\n  .p-sm-76 {\n    padding: 37.5rem !important;\n  }\n\n  .p-sm-77 {\n    padding: 38rem !important;\n  }\n\n  .p-sm-78 {\n    padding: 38.5rem !important;\n  }\n\n  .p-sm-79 {\n    padding: 39rem !important;\n  }\n\n  .p-sm-80 {\n    padding: 39.5rem !important;\n  }\n\n  .p-sm-81 {\n    padding: 40rem !important;\n  }\n\n  .p-sm-82 {\n    padding: 40.5rem !important;\n  }\n\n  .p-sm-83 {\n    padding: 41rem !important;\n  }\n\n  .p-sm-84 {\n    padding: 41.5rem !important;\n  }\n\n  .p-sm-85 {\n    padding: 42rem !important;\n  }\n\n  .p-sm-86 {\n    padding: 42.5rem !important;\n  }\n\n  .p-sm-87 {\n    padding: 43rem !important;\n  }\n\n  .p-sm-88 {\n    padding: 43.5rem !important;\n  }\n\n  .p-sm-89 {\n    padding: 44rem !important;\n  }\n\n  .p-sm-90 {\n    padding: 44.5rem !important;\n  }\n\n  .p-sm-91 {\n    padding: 45rem !important;\n  }\n\n  .p-sm-92 {\n    padding: 45.5rem !important;\n  }\n\n  .p-sm-93 {\n    padding: 46rem !important;\n  }\n\n  .p-sm-94 {\n    padding: 46.5rem !important;\n  }\n\n  .p-sm-95 {\n    padding: 47rem !important;\n  }\n\n  .p-sm-96 {\n    padding: 47.5rem !important;\n  }\n\n  .p-sm-97 {\n    padding: 48rem !important;\n  }\n\n  .p-sm-98 {\n    padding: 48.5rem !important;\n  }\n\n  .p-sm-99 {\n    padding: 49rem !important;\n  }\n\n  .p-sm-100 {\n    padding: 49.5rem !important;\n  }\n\n  .p-sm-101 {\n    padding: 50rem !important;\n  }\n\n  .p-sm-102 {\n    padding: 50.5rem !important;\n  }\n\n  .p-sm-103 {\n    padding: 51rem !important;\n  }\n\n  .p-sm-104 {\n    padding: 51.5rem !important;\n  }\n\n  .p-sm-105 {\n    padding: 52rem !important;\n  }\n\n  .p-sm-106 {\n    padding: 52.5rem !important;\n  }\n\n  .p-sm-107 {\n    padding: 53rem !important;\n  }\n\n  .p-sm-108 {\n    padding: 53.5rem !important;\n  }\n\n  .p-sm-109 {\n    padding: 54rem !important;\n  }\n\n  .p-sm-110 {\n    padding: 54.5rem !important;\n  }\n\n  .p-sm-111 {\n    padding: 55rem !important;\n  }\n\n  .p-sm-112 {\n    padding: 55.5rem !important;\n  }\n\n  .p-sm-113 {\n    padding: 56rem !important;\n  }\n\n  .p-sm-114 {\n    padding: 56.5rem !important;\n  }\n\n  .p-sm-115 {\n    padding: 57rem !important;\n  }\n\n  .p-sm-116 {\n    padding: 57.5rem !important;\n  }\n\n  .p-sm-117 {\n    padding: 58rem !important;\n  }\n\n  .p-sm-118 {\n    padding: 58.5rem !important;\n  }\n\n  .p-sm-119 {\n    padding: 59rem !important;\n  }\n\n  .p-sm-120 {\n    padding: 59.5rem !important;\n  }\n\n  .p-sm-121 {\n    padding: 60rem !important;\n  }\n\n  .p-sm-122 {\n    padding: 60.5rem !important;\n  }\n\n  .p-sm-123 {\n    padding: 61rem !important;\n  }\n\n  .p-sm-124 {\n    padding: 61.5rem !important;\n  }\n\n  .p-sm-125 {\n    padding: 62rem !important;\n  }\n\n  .p-sm-126 {\n    padding: 62.5rem !important;\n  }\n\n  .p-sm-127 {\n    padding: 63rem !important;\n  }\n\n  .p-sm-128 {\n    padding: 63.5rem !important;\n  }\n\n  .p-sm-129 {\n    padding: 64rem !important;\n  }\n\n  .p-sm-130 {\n    padding: 64.5rem !important;\n  }\n\n  .p-sm-131 {\n    padding: 65rem !important;\n  }\n\n  .p-sm-132 {\n    padding: 65.5rem !important;\n  }\n\n  .p-sm-133 {\n    padding: 66rem !important;\n  }\n\n  .p-sm-134 {\n    padding: 66.5rem !important;\n  }\n\n  .p-sm-135 {\n    padding: 67rem !important;\n  }\n\n  .p-sm-136 {\n    padding: 67.5rem !important;\n  }\n\n  .p-sm-137 {\n    padding: 68rem !important;\n  }\n\n  .p-sm-138 {\n    padding: 68.5rem !important;\n  }\n\n  .p-sm-139 {\n    padding: 69rem !important;\n  }\n\n  .p-sm-140 {\n    padding: 69.5rem !important;\n  }\n\n  .p-sm-141 {\n    padding: 70rem !important;\n  }\n\n  .p-sm-142 {\n    padding: 70.5rem !important;\n  }\n\n  .p-sm-143 {\n    padding: 71rem !important;\n  }\n\n  .p-sm-144 {\n    padding: 71.5rem !important;\n  }\n\n  .p-sm-145 {\n    padding: 72rem !important;\n  }\n\n  .p-sm-146 {\n    padding: 72.5rem !important;\n  }\n\n  .p-sm-147 {\n    padding: 73rem !important;\n  }\n\n  .p-sm-148 {\n    padding: 73.5rem !important;\n  }\n\n  .p-sm-149 {\n    padding: 74rem !important;\n  }\n\n  .p-sm-150 {\n    padding: 74.5rem !important;\n  }\n\n  .p-sm-151 {\n    padding: 75rem !important;\n  }\n\n  .p-sm-152 {\n    padding: 75.5rem !important;\n  }\n\n  .p-sm-153 {\n    padding: 76rem !important;\n  }\n\n  .p-sm-154 {\n    padding: 76.5rem !important;\n  }\n\n  .p-sm-155 {\n    padding: 77rem !important;\n  }\n\n  .p-sm-156 {\n    padding: 77.5rem !important;\n  }\n\n  .p-sm-157 {\n    padding: 78rem !important;\n  }\n\n  .p-sm-158 {\n    padding: 78.5rem !important;\n  }\n\n  .p-sm-159 {\n    padding: 79rem !important;\n  }\n\n  .p-sm-160 {\n    padding: 79.5rem !important;\n  }\n\n  .pt-sm-0 {\n    padding-top: 0rem !important;\n  }\n\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-sm-5 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-sm-6 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-sm-7 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-sm-8 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-sm-9 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-sm-10 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-sm-11 {\n    padding-top: 5rem !important;\n  }\n\n  .pt-sm-12 {\n    padding-top: 5.5rem !important;\n  }\n\n  .pt-sm-13 {\n    padding-top: 6rem !important;\n  }\n\n  .pt-sm-14 {\n    padding-top: 6.5rem !important;\n  }\n\n  .pt-sm-15 {\n    padding-top: 7rem !important;\n  }\n\n  .pt-sm-16 {\n    padding-top: 7.5rem !important;\n  }\n\n  .pt-sm-17 {\n    padding-top: 8rem !important;\n  }\n\n  .pt-sm-18 {\n    padding-top: 8.5rem !important;\n  }\n\n  .pt-sm-19 {\n    padding-top: 9rem !important;\n  }\n\n  .pt-sm-20 {\n    padding-top: 9.5rem !important;\n  }\n\n  .pt-sm-21 {\n    padding-top: 10rem !important;\n  }\n\n  .pt-sm-22 {\n    padding-top: 10.5rem !important;\n  }\n\n  .pt-sm-23 {\n    padding-top: 11rem !important;\n  }\n\n  .pt-sm-24 {\n    padding-top: 11.5rem !important;\n  }\n\n  .pt-sm-25 {\n    padding-top: 12rem !important;\n  }\n\n  .pt-sm-26 {\n    padding-top: 12.5rem !important;\n  }\n\n  .pt-sm-27 {\n    padding-top: 13rem !important;\n  }\n\n  .pt-sm-28 {\n    padding-top: 13.5rem !important;\n  }\n\n  .pt-sm-29 {\n    padding-top: 14rem !important;\n  }\n\n  .pt-sm-30 {\n    padding-top: 14.5rem !important;\n  }\n\n  .pt-sm-31 {\n    padding-top: 15rem !important;\n  }\n\n  .pt-sm-32 {\n    padding-top: 15.5rem !important;\n  }\n\n  .pt-sm-33 {\n    padding-top: 16rem !important;\n  }\n\n  .pt-sm-34 {\n    padding-top: 16.5rem !important;\n  }\n\n  .pt-sm-35 {\n    padding-top: 17rem !important;\n  }\n\n  .pt-sm-36 {\n    padding-top: 17.5rem !important;\n  }\n\n  .pt-sm-37 {\n    padding-top: 18rem !important;\n  }\n\n  .pt-sm-38 {\n    padding-top: 18.5rem !important;\n  }\n\n  .pt-sm-39 {\n    padding-top: 19rem !important;\n  }\n\n  .pt-sm-40 {\n    padding-top: 19.5rem !important;\n  }\n\n  .pt-sm-41 {\n    padding-top: 20rem !important;\n  }\n\n  .pt-sm-42 {\n    padding-top: 20.5rem !important;\n  }\n\n  .pt-sm-43 {\n    padding-top: 21rem !important;\n  }\n\n  .pt-sm-44 {\n    padding-top: 21.5rem !important;\n  }\n\n  .pt-sm-45 {\n    padding-top: 22rem !important;\n  }\n\n  .pt-sm-46 {\n    padding-top: 22.5rem !important;\n  }\n\n  .pt-sm-47 {\n    padding-top: 23rem !important;\n  }\n\n  .pt-sm-48 {\n    padding-top: 23.5rem !important;\n  }\n\n  .pt-sm-49 {\n    padding-top: 24rem !important;\n  }\n\n  .pt-sm-50 {\n    padding-top: 24.5rem !important;\n  }\n\n  .pt-sm-51 {\n    padding-top: 25rem !important;\n  }\n\n  .pt-sm-52 {\n    padding-top: 25.5rem !important;\n  }\n\n  .pt-sm-53 {\n    padding-top: 26rem !important;\n  }\n\n  .pt-sm-54 {\n    padding-top: 26.5rem !important;\n  }\n\n  .pt-sm-55 {\n    padding-top: 27rem !important;\n  }\n\n  .pt-sm-56 {\n    padding-top: 27.5rem !important;\n  }\n\n  .pt-sm-57 {\n    padding-top: 28rem !important;\n  }\n\n  .pt-sm-58 {\n    padding-top: 28.5rem !important;\n  }\n\n  .pt-sm-59 {\n    padding-top: 29rem !important;\n  }\n\n  .pt-sm-60 {\n    padding-top: 29.5rem !important;\n  }\n\n  .pt-sm-61 {\n    padding-top: 30rem !important;\n  }\n\n  .pt-sm-62 {\n    padding-top: 30.5rem !important;\n  }\n\n  .pt-sm-63 {\n    padding-top: 31rem !important;\n  }\n\n  .pt-sm-64 {\n    padding-top: 31.5rem !important;\n  }\n\n  .pt-sm-65 {\n    padding-top: 32rem !important;\n  }\n\n  .pt-sm-66 {\n    padding-top: 32.5rem !important;\n  }\n\n  .pt-sm-67 {\n    padding-top: 33rem !important;\n  }\n\n  .pt-sm-68 {\n    padding-top: 33.5rem !important;\n  }\n\n  .pt-sm-69 {\n    padding-top: 34rem !important;\n  }\n\n  .pt-sm-70 {\n    padding-top: 34.5rem !important;\n  }\n\n  .pt-sm-71 {\n    padding-top: 35rem !important;\n  }\n\n  .pt-sm-72 {\n    padding-top: 35.5rem !important;\n  }\n\n  .pt-sm-73 {\n    padding-top: 36rem !important;\n  }\n\n  .pt-sm-74 {\n    padding-top: 36.5rem !important;\n  }\n\n  .pt-sm-75 {\n    padding-top: 37rem !important;\n  }\n\n  .pt-sm-76 {\n    padding-top: 37.5rem !important;\n  }\n\n  .pt-sm-77 {\n    padding-top: 38rem !important;\n  }\n\n  .pt-sm-78 {\n    padding-top: 38.5rem !important;\n  }\n\n  .pt-sm-79 {\n    padding-top: 39rem !important;\n  }\n\n  .pt-sm-80 {\n    padding-top: 39.5rem !important;\n  }\n\n  .pt-sm-81 {\n    padding-top: 40rem !important;\n  }\n\n  .pt-sm-82 {\n    padding-top: 40.5rem !important;\n  }\n\n  .pt-sm-83 {\n    padding-top: 41rem !important;\n  }\n\n  .pt-sm-84 {\n    padding-top: 41.5rem !important;\n  }\n\n  .pt-sm-85 {\n    padding-top: 42rem !important;\n  }\n\n  .pt-sm-86 {\n    padding-top: 42.5rem !important;\n  }\n\n  .pt-sm-87 {\n    padding-top: 43rem !important;\n  }\n\n  .pt-sm-88 {\n    padding-top: 43.5rem !important;\n  }\n\n  .pt-sm-89 {\n    padding-top: 44rem !important;\n  }\n\n  .pt-sm-90 {\n    padding-top: 44.5rem !important;\n  }\n\n  .pt-sm-91 {\n    padding-top: 45rem !important;\n  }\n\n  .pt-sm-92 {\n    padding-top: 45.5rem !important;\n  }\n\n  .pt-sm-93 {\n    padding-top: 46rem !important;\n  }\n\n  .pt-sm-94 {\n    padding-top: 46.5rem !important;\n  }\n\n  .pt-sm-95 {\n    padding-top: 47rem !important;\n  }\n\n  .pt-sm-96 {\n    padding-top: 47.5rem !important;\n  }\n\n  .pt-sm-97 {\n    padding-top: 48rem !important;\n  }\n\n  .pt-sm-98 {\n    padding-top: 48.5rem !important;\n  }\n\n  .pt-sm-99 {\n    padding-top: 49rem !important;\n  }\n\n  .pt-sm-100 {\n    padding-top: 49.5rem !important;\n  }\n\n  .pt-sm-101 {\n    padding-top: 50rem !important;\n  }\n\n  .pt-sm-102 {\n    padding-top: 50.5rem !important;\n  }\n\n  .pt-sm-103 {\n    padding-top: 51rem !important;\n  }\n\n  .pt-sm-104 {\n    padding-top: 51.5rem !important;\n  }\n\n  .pt-sm-105 {\n    padding-top: 52rem !important;\n  }\n\n  .pt-sm-106 {\n    padding-top: 52.5rem !important;\n  }\n\n  .pt-sm-107 {\n    padding-top: 53rem !important;\n  }\n\n  .pt-sm-108 {\n    padding-top: 53.5rem !important;\n  }\n\n  .pt-sm-109 {\n    padding-top: 54rem !important;\n  }\n\n  .pt-sm-110 {\n    padding-top: 54.5rem !important;\n  }\n\n  .pt-sm-111 {\n    padding-top: 55rem !important;\n  }\n\n  .pt-sm-112 {\n    padding-top: 55.5rem !important;\n  }\n\n  .pt-sm-113 {\n    padding-top: 56rem !important;\n  }\n\n  .pt-sm-114 {\n    padding-top: 56.5rem !important;\n  }\n\n  .pt-sm-115 {\n    padding-top: 57rem !important;\n  }\n\n  .pt-sm-116 {\n    padding-top: 57.5rem !important;\n  }\n\n  .pt-sm-117 {\n    padding-top: 58rem !important;\n  }\n\n  .pt-sm-118 {\n    padding-top: 58.5rem !important;\n  }\n\n  .pt-sm-119 {\n    padding-top: 59rem !important;\n  }\n\n  .pt-sm-120 {\n    padding-top: 59.5rem !important;\n  }\n\n  .pt-sm-121 {\n    padding-top: 60rem !important;\n  }\n\n  .pt-sm-122 {\n    padding-top: 60.5rem !important;\n  }\n\n  .pt-sm-123 {\n    padding-top: 61rem !important;\n  }\n\n  .pt-sm-124 {\n    padding-top: 61.5rem !important;\n  }\n\n  .pt-sm-125 {\n    padding-top: 62rem !important;\n  }\n\n  .pt-sm-126 {\n    padding-top: 62.5rem !important;\n  }\n\n  .pt-sm-127 {\n    padding-top: 63rem !important;\n  }\n\n  .pt-sm-128 {\n    padding-top: 63.5rem !important;\n  }\n\n  .pt-sm-129 {\n    padding-top: 64rem !important;\n  }\n\n  .pt-sm-130 {\n    padding-top: 64.5rem !important;\n  }\n\n  .pt-sm-131 {\n    padding-top: 65rem !important;\n  }\n\n  .pt-sm-132 {\n    padding-top: 65.5rem !important;\n  }\n\n  .pt-sm-133 {\n    padding-top: 66rem !important;\n  }\n\n  .pt-sm-134 {\n    padding-top: 66.5rem !important;\n  }\n\n  .pt-sm-135 {\n    padding-top: 67rem !important;\n  }\n\n  .pt-sm-136 {\n    padding-top: 67.5rem !important;\n  }\n\n  .pt-sm-137 {\n    padding-top: 68rem !important;\n  }\n\n  .pt-sm-138 {\n    padding-top: 68.5rem !important;\n  }\n\n  .pt-sm-139 {\n    padding-top: 69rem !important;\n  }\n\n  .pt-sm-140 {\n    padding-top: 69.5rem !important;\n  }\n\n  .pt-sm-141 {\n    padding-top: 70rem !important;\n  }\n\n  .pt-sm-142 {\n    padding-top: 70.5rem !important;\n  }\n\n  .pt-sm-143 {\n    padding-top: 71rem !important;\n  }\n\n  .pt-sm-144 {\n    padding-top: 71.5rem !important;\n  }\n\n  .pt-sm-145 {\n    padding-top: 72rem !important;\n  }\n\n  .pt-sm-146 {\n    padding-top: 72.5rem !important;\n  }\n\n  .pt-sm-147 {\n    padding-top: 73rem !important;\n  }\n\n  .pt-sm-148 {\n    padding-top: 73.5rem !important;\n  }\n\n  .pt-sm-149 {\n    padding-top: 74rem !important;\n  }\n\n  .pt-sm-150 {\n    padding-top: 74.5rem !important;\n  }\n\n  .pt-sm-151 {\n    padding-top: 75rem !important;\n  }\n\n  .pt-sm-152 {\n    padding-top: 75.5rem !important;\n  }\n\n  .pt-sm-153 {\n    padding-top: 76rem !important;\n  }\n\n  .pt-sm-154 {\n    padding-top: 76.5rem !important;\n  }\n\n  .pt-sm-155 {\n    padding-top: 77rem !important;\n  }\n\n  .pt-sm-156 {\n    padding-top: 77.5rem !important;\n  }\n\n  .pt-sm-157 {\n    padding-top: 78rem !important;\n  }\n\n  .pt-sm-158 {\n    padding-top: 78.5rem !important;\n  }\n\n  .pt-sm-159 {\n    padding-top: 79rem !important;\n  }\n\n  .pt-sm-160 {\n    padding-top: 79.5rem !important;\n  }\n\n  .pb-sm-0 {\n    padding-bottom: 0rem !important;\n  }\n\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-sm-5 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-sm-6 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-sm-7 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-sm-8 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-sm-9 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-sm-10 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-sm-11 {\n    padding-bottom: 5rem !important;\n  }\n\n  .pb-sm-12 {\n    padding-bottom: 5.5rem !important;\n  }\n\n  .pb-sm-13 {\n    padding-bottom: 6rem !important;\n  }\n\n  .pb-sm-14 {\n    padding-bottom: 6.5rem !important;\n  }\n\n  .pb-sm-15 {\n    padding-bottom: 7rem !important;\n  }\n\n  .pb-sm-16 {\n    padding-bottom: 7.5rem !important;\n  }\n\n  .pb-sm-17 {\n    padding-bottom: 8rem !important;\n  }\n\n  .pb-sm-18 {\n    padding-bottom: 8.5rem !important;\n  }\n\n  .pb-sm-19 {\n    padding-bottom: 9rem !important;\n  }\n\n  .pb-sm-20 {\n    padding-bottom: 9.5rem !important;\n  }\n\n  .pb-sm-21 {\n    padding-bottom: 10rem !important;\n  }\n\n  .pb-sm-22 {\n    padding-bottom: 10.5rem !important;\n  }\n\n  .pb-sm-23 {\n    padding-bottom: 11rem !important;\n  }\n\n  .pb-sm-24 {\n    padding-bottom: 11.5rem !important;\n  }\n\n  .pb-sm-25 {\n    padding-bottom: 12rem !important;\n  }\n\n  .pb-sm-26 {\n    padding-bottom: 12.5rem !important;\n  }\n\n  .pb-sm-27 {\n    padding-bottom: 13rem !important;\n  }\n\n  .pb-sm-28 {\n    padding-bottom: 13.5rem !important;\n  }\n\n  .pb-sm-29 {\n    padding-bottom: 14rem !important;\n  }\n\n  .pb-sm-30 {\n    padding-bottom: 14.5rem !important;\n  }\n\n  .pb-sm-31 {\n    padding-bottom: 15rem !important;\n  }\n\n  .pb-sm-32 {\n    padding-bottom: 15.5rem !important;\n  }\n\n  .pb-sm-33 {\n    padding-bottom: 16rem !important;\n  }\n\n  .pb-sm-34 {\n    padding-bottom: 16.5rem !important;\n  }\n\n  .pb-sm-35 {\n    padding-bottom: 17rem !important;\n  }\n\n  .pb-sm-36 {\n    padding-bottom: 17.5rem !important;\n  }\n\n  .pb-sm-37 {\n    padding-bottom: 18rem !important;\n  }\n\n  .pb-sm-38 {\n    padding-bottom: 18.5rem !important;\n  }\n\n  .pb-sm-39 {\n    padding-bottom: 19rem !important;\n  }\n\n  .pb-sm-40 {\n    padding-bottom: 19.5rem !important;\n  }\n\n  .pb-sm-41 {\n    padding-bottom: 20rem !important;\n  }\n\n  .pb-sm-42 {\n    padding-bottom: 20.5rem !important;\n  }\n\n  .pb-sm-43 {\n    padding-bottom: 21rem !important;\n  }\n\n  .pb-sm-44 {\n    padding-bottom: 21.5rem !important;\n  }\n\n  .pb-sm-45 {\n    padding-bottom: 22rem !important;\n  }\n\n  .pb-sm-46 {\n    padding-bottom: 22.5rem !important;\n  }\n\n  .pb-sm-47 {\n    padding-bottom: 23rem !important;\n  }\n\n  .pb-sm-48 {\n    padding-bottom: 23.5rem !important;\n  }\n\n  .pb-sm-49 {\n    padding-bottom: 24rem !important;\n  }\n\n  .pb-sm-50 {\n    padding-bottom: 24.5rem !important;\n  }\n\n  .pb-sm-51 {\n    padding-bottom: 25rem !important;\n  }\n\n  .pb-sm-52 {\n    padding-bottom: 25.5rem !important;\n  }\n\n  .pb-sm-53 {\n    padding-bottom: 26rem !important;\n  }\n\n  .pb-sm-54 {\n    padding-bottom: 26.5rem !important;\n  }\n\n  .pb-sm-55 {\n    padding-bottom: 27rem !important;\n  }\n\n  .pb-sm-56 {\n    padding-bottom: 27.5rem !important;\n  }\n\n  .pb-sm-57 {\n    padding-bottom: 28rem !important;\n  }\n\n  .pb-sm-58 {\n    padding-bottom: 28.5rem !important;\n  }\n\n  .pb-sm-59 {\n    padding-bottom: 29rem !important;\n  }\n\n  .pb-sm-60 {\n    padding-bottom: 29.5rem !important;\n  }\n\n  .pb-sm-61 {\n    padding-bottom: 30rem !important;\n  }\n\n  .pb-sm-62 {\n    padding-bottom: 30.5rem !important;\n  }\n\n  .pb-sm-63 {\n    padding-bottom: 31rem !important;\n  }\n\n  .pb-sm-64 {\n    padding-bottom: 31.5rem !important;\n  }\n\n  .pb-sm-65 {\n    padding-bottom: 32rem !important;\n  }\n\n  .pb-sm-66 {\n    padding-bottom: 32.5rem !important;\n  }\n\n  .pb-sm-67 {\n    padding-bottom: 33rem !important;\n  }\n\n  .pb-sm-68 {\n    padding-bottom: 33.5rem !important;\n  }\n\n  .pb-sm-69 {\n    padding-bottom: 34rem !important;\n  }\n\n  .pb-sm-70 {\n    padding-bottom: 34.5rem !important;\n  }\n\n  .pb-sm-71 {\n    padding-bottom: 35rem !important;\n  }\n\n  .pb-sm-72 {\n    padding-bottom: 35.5rem !important;\n  }\n\n  .pb-sm-73 {\n    padding-bottom: 36rem !important;\n  }\n\n  .pb-sm-74 {\n    padding-bottom: 36.5rem !important;\n  }\n\n  .pb-sm-75 {\n    padding-bottom: 37rem !important;\n  }\n\n  .pb-sm-76 {\n    padding-bottom: 37.5rem !important;\n  }\n\n  .pb-sm-77 {\n    padding-bottom: 38rem !important;\n  }\n\n  .pb-sm-78 {\n    padding-bottom: 38.5rem !important;\n  }\n\n  .pb-sm-79 {\n    padding-bottom: 39rem !important;\n  }\n\n  .pb-sm-80 {\n    padding-bottom: 39.5rem !important;\n  }\n\n  .pb-sm-81 {\n    padding-bottom: 40rem !important;\n  }\n\n  .pb-sm-82 {\n    padding-bottom: 40.5rem !important;\n  }\n\n  .pb-sm-83 {\n    padding-bottom: 41rem !important;\n  }\n\n  .pb-sm-84 {\n    padding-bottom: 41.5rem !important;\n  }\n\n  .pb-sm-85 {\n    padding-bottom: 42rem !important;\n  }\n\n  .pb-sm-86 {\n    padding-bottom: 42.5rem !important;\n  }\n\n  .pb-sm-87 {\n    padding-bottom: 43rem !important;\n  }\n\n  .pb-sm-88 {\n    padding-bottom: 43.5rem !important;\n  }\n\n  .pb-sm-89 {\n    padding-bottom: 44rem !important;\n  }\n\n  .pb-sm-90 {\n    padding-bottom: 44.5rem !important;\n  }\n\n  .pb-sm-91 {\n    padding-bottom: 45rem !important;\n  }\n\n  .pb-sm-92 {\n    padding-bottom: 45.5rem !important;\n  }\n\n  .pb-sm-93 {\n    padding-bottom: 46rem !important;\n  }\n\n  .pb-sm-94 {\n    padding-bottom: 46.5rem !important;\n  }\n\n  .pb-sm-95 {\n    padding-bottom: 47rem !important;\n  }\n\n  .pb-sm-96 {\n    padding-bottom: 47.5rem !important;\n  }\n\n  .pb-sm-97 {\n    padding-bottom: 48rem !important;\n  }\n\n  .pb-sm-98 {\n    padding-bottom: 48.5rem !important;\n  }\n\n  .pb-sm-99 {\n    padding-bottom: 49rem !important;\n  }\n\n  .pb-sm-100 {\n    padding-bottom: 49.5rem !important;\n  }\n\n  .pb-sm-101 {\n    padding-bottom: 50rem !important;\n  }\n\n  .pb-sm-102 {\n    padding-bottom: 50.5rem !important;\n  }\n\n  .pb-sm-103 {\n    padding-bottom: 51rem !important;\n  }\n\n  .pb-sm-104 {\n    padding-bottom: 51.5rem !important;\n  }\n\n  .pb-sm-105 {\n    padding-bottom: 52rem !important;\n  }\n\n  .pb-sm-106 {\n    padding-bottom: 52.5rem !important;\n  }\n\n  .pb-sm-107 {\n    padding-bottom: 53rem !important;\n  }\n\n  .pb-sm-108 {\n    padding-bottom: 53.5rem !important;\n  }\n\n  .pb-sm-109 {\n    padding-bottom: 54rem !important;\n  }\n\n  .pb-sm-110 {\n    padding-bottom: 54.5rem !important;\n  }\n\n  .pb-sm-111 {\n    padding-bottom: 55rem !important;\n  }\n\n  .pb-sm-112 {\n    padding-bottom: 55.5rem !important;\n  }\n\n  .pb-sm-113 {\n    padding-bottom: 56rem !important;\n  }\n\n  .pb-sm-114 {\n    padding-bottom: 56.5rem !important;\n  }\n\n  .pb-sm-115 {\n    padding-bottom: 57rem !important;\n  }\n\n  .pb-sm-116 {\n    padding-bottom: 57.5rem !important;\n  }\n\n  .pb-sm-117 {\n    padding-bottom: 58rem !important;\n  }\n\n  .pb-sm-118 {\n    padding-bottom: 58.5rem !important;\n  }\n\n  .pb-sm-119 {\n    padding-bottom: 59rem !important;\n  }\n\n  .pb-sm-120 {\n    padding-bottom: 59.5rem !important;\n  }\n\n  .pb-sm-121 {\n    padding-bottom: 60rem !important;\n  }\n\n  .pb-sm-122 {\n    padding-bottom: 60.5rem !important;\n  }\n\n  .pb-sm-123 {\n    padding-bottom: 61rem !important;\n  }\n\n  .pb-sm-124 {\n    padding-bottom: 61.5rem !important;\n  }\n\n  .pb-sm-125 {\n    padding-bottom: 62rem !important;\n  }\n\n  .pb-sm-126 {\n    padding-bottom: 62.5rem !important;\n  }\n\n  .pb-sm-127 {\n    padding-bottom: 63rem !important;\n  }\n\n  .pb-sm-128 {\n    padding-bottom: 63.5rem !important;\n  }\n\n  .pb-sm-129 {\n    padding-bottom: 64rem !important;\n  }\n\n  .pb-sm-130 {\n    padding-bottom: 64.5rem !important;\n  }\n\n  .pb-sm-131 {\n    padding-bottom: 65rem !important;\n  }\n\n  .pb-sm-132 {\n    padding-bottom: 65.5rem !important;\n  }\n\n  .pb-sm-133 {\n    padding-bottom: 66rem !important;\n  }\n\n  .pb-sm-134 {\n    padding-bottom: 66.5rem !important;\n  }\n\n  .pb-sm-135 {\n    padding-bottom: 67rem !important;\n  }\n\n  .pb-sm-136 {\n    padding-bottom: 67.5rem !important;\n  }\n\n  .pb-sm-137 {\n    padding-bottom: 68rem !important;\n  }\n\n  .pb-sm-138 {\n    padding-bottom: 68.5rem !important;\n  }\n\n  .pb-sm-139 {\n    padding-bottom: 69rem !important;\n  }\n\n  .pb-sm-140 {\n    padding-bottom: 69.5rem !important;\n  }\n\n  .pb-sm-141 {\n    padding-bottom: 70rem !important;\n  }\n\n  .pb-sm-142 {\n    padding-bottom: 70.5rem !important;\n  }\n\n  .pb-sm-143 {\n    padding-bottom: 71rem !important;\n  }\n\n  .pb-sm-144 {\n    padding-bottom: 71.5rem !important;\n  }\n\n  .pb-sm-145 {\n    padding-bottom: 72rem !important;\n  }\n\n  .pb-sm-146 {\n    padding-bottom: 72.5rem !important;\n  }\n\n  .pb-sm-147 {\n    padding-bottom: 73rem !important;\n  }\n\n  .pb-sm-148 {\n    padding-bottom: 73.5rem !important;\n  }\n\n  .pb-sm-149 {\n    padding-bottom: 74rem !important;\n  }\n\n  .pb-sm-150 {\n    padding-bottom: 74.5rem !important;\n  }\n\n  .pb-sm-151 {\n    padding-bottom: 75rem !important;\n  }\n\n  .pb-sm-152 {\n    padding-bottom: 75.5rem !important;\n  }\n\n  .pb-sm-153 {\n    padding-bottom: 76rem !important;\n  }\n\n  .pb-sm-154 {\n    padding-bottom: 76.5rem !important;\n  }\n\n  .pb-sm-155 {\n    padding-bottom: 77rem !important;\n  }\n\n  .pb-sm-156 {\n    padding-bottom: 77.5rem !important;\n  }\n\n  .pb-sm-157 {\n    padding-bottom: 78rem !important;\n  }\n\n  .pb-sm-158 {\n    padding-bottom: 78.5rem !important;\n  }\n\n  .pb-sm-159 {\n    padding-bottom: 79rem !important;\n  }\n\n  .pb-sm-160 {\n    padding-bottom: 79.5rem !important;\n  }\n\n  .ps-sm-0 {\n    padding-left: 0rem !important;\n  }\n\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-sm-5 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-sm-6 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-sm-7 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-sm-8 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-sm-9 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-sm-10 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-sm-11 {\n    padding-left: 5rem !important;\n  }\n\n  .ps-sm-12 {\n    padding-left: 5.5rem !important;\n  }\n\n  .ps-sm-13 {\n    padding-left: 6rem !important;\n  }\n\n  .ps-sm-14 {\n    padding-left: 6.5rem !important;\n  }\n\n  .ps-sm-15 {\n    padding-left: 7rem !important;\n  }\n\n  .ps-sm-16 {\n    padding-left: 7.5rem !important;\n  }\n\n  .ps-sm-17 {\n    padding-left: 8rem !important;\n  }\n\n  .ps-sm-18 {\n    padding-left: 8.5rem !important;\n  }\n\n  .ps-sm-19 {\n    padding-left: 9rem !important;\n  }\n\n  .ps-sm-20 {\n    padding-left: 9.5rem !important;\n  }\n\n  .ps-sm-21 {\n    padding-left: 10rem !important;\n  }\n\n  .ps-sm-22 {\n    padding-left: 10.5rem !important;\n  }\n\n  .ps-sm-23 {\n    padding-left: 11rem !important;\n  }\n\n  .ps-sm-24 {\n    padding-left: 11.5rem !important;\n  }\n\n  .ps-sm-25 {\n    padding-left: 12rem !important;\n  }\n\n  .ps-sm-26 {\n    padding-left: 12.5rem !important;\n  }\n\n  .ps-sm-27 {\n    padding-left: 13rem !important;\n  }\n\n  .ps-sm-28 {\n    padding-left: 13.5rem !important;\n  }\n\n  .ps-sm-29 {\n    padding-left: 14rem !important;\n  }\n\n  .ps-sm-30 {\n    padding-left: 14.5rem !important;\n  }\n\n  .ps-sm-31 {\n    padding-left: 15rem !important;\n  }\n\n  .ps-sm-32 {\n    padding-left: 15.5rem !important;\n  }\n\n  .ps-sm-33 {\n    padding-left: 16rem !important;\n  }\n\n  .ps-sm-34 {\n    padding-left: 16.5rem !important;\n  }\n\n  .ps-sm-35 {\n    padding-left: 17rem !important;\n  }\n\n  .ps-sm-36 {\n    padding-left: 17.5rem !important;\n  }\n\n  .ps-sm-37 {\n    padding-left: 18rem !important;\n  }\n\n  .ps-sm-38 {\n    padding-left: 18.5rem !important;\n  }\n\n  .ps-sm-39 {\n    padding-left: 19rem !important;\n  }\n\n  .ps-sm-40 {\n    padding-left: 19.5rem !important;\n  }\n\n  .ps-sm-41 {\n    padding-left: 20rem !important;\n  }\n\n  .ps-sm-42 {\n    padding-left: 20.5rem !important;\n  }\n\n  .ps-sm-43 {\n    padding-left: 21rem !important;\n  }\n\n  .ps-sm-44 {\n    padding-left: 21.5rem !important;\n  }\n\n  .ps-sm-45 {\n    padding-left: 22rem !important;\n  }\n\n  .ps-sm-46 {\n    padding-left: 22.5rem !important;\n  }\n\n  .ps-sm-47 {\n    padding-left: 23rem !important;\n  }\n\n  .ps-sm-48 {\n    padding-left: 23.5rem !important;\n  }\n\n  .ps-sm-49 {\n    padding-left: 24rem !important;\n  }\n\n  .ps-sm-50 {\n    padding-left: 24.5rem !important;\n  }\n\n  .ps-sm-51 {\n    padding-left: 25rem !important;\n  }\n\n  .ps-sm-52 {\n    padding-left: 25.5rem !important;\n  }\n\n  .ps-sm-53 {\n    padding-left: 26rem !important;\n  }\n\n  .ps-sm-54 {\n    padding-left: 26.5rem !important;\n  }\n\n  .ps-sm-55 {\n    padding-left: 27rem !important;\n  }\n\n  .ps-sm-56 {\n    padding-left: 27.5rem !important;\n  }\n\n  .ps-sm-57 {\n    padding-left: 28rem !important;\n  }\n\n  .ps-sm-58 {\n    padding-left: 28.5rem !important;\n  }\n\n  .ps-sm-59 {\n    padding-left: 29rem !important;\n  }\n\n  .ps-sm-60 {\n    padding-left: 29.5rem !important;\n  }\n\n  .ps-sm-61 {\n    padding-left: 30rem !important;\n  }\n\n  .ps-sm-62 {\n    padding-left: 30.5rem !important;\n  }\n\n  .ps-sm-63 {\n    padding-left: 31rem !important;\n  }\n\n  .ps-sm-64 {\n    padding-left: 31.5rem !important;\n  }\n\n  .ps-sm-65 {\n    padding-left: 32rem !important;\n  }\n\n  .ps-sm-66 {\n    padding-left: 32.5rem !important;\n  }\n\n  .ps-sm-67 {\n    padding-left: 33rem !important;\n  }\n\n  .ps-sm-68 {\n    padding-left: 33.5rem !important;\n  }\n\n  .ps-sm-69 {\n    padding-left: 34rem !important;\n  }\n\n  .ps-sm-70 {\n    padding-left: 34.5rem !important;\n  }\n\n  .ps-sm-71 {\n    padding-left: 35rem !important;\n  }\n\n  .ps-sm-72 {\n    padding-left: 35.5rem !important;\n  }\n\n  .ps-sm-73 {\n    padding-left: 36rem !important;\n  }\n\n  .ps-sm-74 {\n    padding-left: 36.5rem !important;\n  }\n\n  .ps-sm-75 {\n    padding-left: 37rem !important;\n  }\n\n  .ps-sm-76 {\n    padding-left: 37.5rem !important;\n  }\n\n  .ps-sm-77 {\n    padding-left: 38rem !important;\n  }\n\n  .ps-sm-78 {\n    padding-left: 38.5rem !important;\n  }\n\n  .ps-sm-79 {\n    padding-left: 39rem !important;\n  }\n\n  .ps-sm-80 {\n    padding-left: 39.5rem !important;\n  }\n\n  .ps-sm-81 {\n    padding-left: 40rem !important;\n  }\n\n  .ps-sm-82 {\n    padding-left: 40.5rem !important;\n  }\n\n  .ps-sm-83 {\n    padding-left: 41rem !important;\n  }\n\n  .ps-sm-84 {\n    padding-left: 41.5rem !important;\n  }\n\n  .ps-sm-85 {\n    padding-left: 42rem !important;\n  }\n\n  .ps-sm-86 {\n    padding-left: 42.5rem !important;\n  }\n\n  .ps-sm-87 {\n    padding-left: 43rem !important;\n  }\n\n  .ps-sm-88 {\n    padding-left: 43.5rem !important;\n  }\n\n  .ps-sm-89 {\n    padding-left: 44rem !important;\n  }\n\n  .ps-sm-90 {\n    padding-left: 44.5rem !important;\n  }\n\n  .ps-sm-91 {\n    padding-left: 45rem !important;\n  }\n\n  .ps-sm-92 {\n    padding-left: 45.5rem !important;\n  }\n\n  .ps-sm-93 {\n    padding-left: 46rem !important;\n  }\n\n  .ps-sm-94 {\n    padding-left: 46.5rem !important;\n  }\n\n  .ps-sm-95 {\n    padding-left: 47rem !important;\n  }\n\n  .ps-sm-96 {\n    padding-left: 47.5rem !important;\n  }\n\n  .ps-sm-97 {\n    padding-left: 48rem !important;\n  }\n\n  .ps-sm-98 {\n    padding-left: 48.5rem !important;\n  }\n\n  .ps-sm-99 {\n    padding-left: 49rem !important;\n  }\n\n  .ps-sm-100 {\n    padding-left: 49.5rem !important;\n  }\n\n  .ps-sm-101 {\n    padding-left: 50rem !important;\n  }\n\n  .ps-sm-102 {\n    padding-left: 50.5rem !important;\n  }\n\n  .ps-sm-103 {\n    padding-left: 51rem !important;\n  }\n\n  .ps-sm-104 {\n    padding-left: 51.5rem !important;\n  }\n\n  .ps-sm-105 {\n    padding-left: 52rem !important;\n  }\n\n  .ps-sm-106 {\n    padding-left: 52.5rem !important;\n  }\n\n  .ps-sm-107 {\n    padding-left: 53rem !important;\n  }\n\n  .ps-sm-108 {\n    padding-left: 53.5rem !important;\n  }\n\n  .ps-sm-109 {\n    padding-left: 54rem !important;\n  }\n\n  .ps-sm-110 {\n    padding-left: 54.5rem !important;\n  }\n\n  .ps-sm-111 {\n    padding-left: 55rem !important;\n  }\n\n  .ps-sm-112 {\n    padding-left: 55.5rem !important;\n  }\n\n  .ps-sm-113 {\n    padding-left: 56rem !important;\n  }\n\n  .ps-sm-114 {\n    padding-left: 56.5rem !important;\n  }\n\n  .ps-sm-115 {\n    padding-left: 57rem !important;\n  }\n\n  .ps-sm-116 {\n    padding-left: 57.5rem !important;\n  }\n\n  .ps-sm-117 {\n    padding-left: 58rem !important;\n  }\n\n  .ps-sm-118 {\n    padding-left: 58.5rem !important;\n  }\n\n  .ps-sm-119 {\n    padding-left: 59rem !important;\n  }\n\n  .ps-sm-120 {\n    padding-left: 59.5rem !important;\n  }\n\n  .ps-sm-121 {\n    padding-left: 60rem !important;\n  }\n\n  .ps-sm-122 {\n    padding-left: 60.5rem !important;\n  }\n\n  .ps-sm-123 {\n    padding-left: 61rem !important;\n  }\n\n  .ps-sm-124 {\n    padding-left: 61.5rem !important;\n  }\n\n  .ps-sm-125 {\n    padding-left: 62rem !important;\n  }\n\n  .ps-sm-126 {\n    padding-left: 62.5rem !important;\n  }\n\n  .ps-sm-127 {\n    padding-left: 63rem !important;\n  }\n\n  .ps-sm-128 {\n    padding-left: 63.5rem !important;\n  }\n\n  .ps-sm-129 {\n    padding-left: 64rem !important;\n  }\n\n  .ps-sm-130 {\n    padding-left: 64.5rem !important;\n  }\n\n  .ps-sm-131 {\n    padding-left: 65rem !important;\n  }\n\n  .ps-sm-132 {\n    padding-left: 65.5rem !important;\n  }\n\n  .ps-sm-133 {\n    padding-left: 66rem !important;\n  }\n\n  .ps-sm-134 {\n    padding-left: 66.5rem !important;\n  }\n\n  .ps-sm-135 {\n    padding-left: 67rem !important;\n  }\n\n  .ps-sm-136 {\n    padding-left: 67.5rem !important;\n  }\n\n  .ps-sm-137 {\n    padding-left: 68rem !important;\n  }\n\n  .ps-sm-138 {\n    padding-left: 68.5rem !important;\n  }\n\n  .ps-sm-139 {\n    padding-left: 69rem !important;\n  }\n\n  .ps-sm-140 {\n    padding-left: 69.5rem !important;\n  }\n\n  .ps-sm-141 {\n    padding-left: 70rem !important;\n  }\n\n  .ps-sm-142 {\n    padding-left: 70.5rem !important;\n  }\n\n  .ps-sm-143 {\n    padding-left: 71rem !important;\n  }\n\n  .ps-sm-144 {\n    padding-left: 71.5rem !important;\n  }\n\n  .ps-sm-145 {\n    padding-left: 72rem !important;\n  }\n\n  .ps-sm-146 {\n    padding-left: 72.5rem !important;\n  }\n\n  .ps-sm-147 {\n    padding-left: 73rem !important;\n  }\n\n  .ps-sm-148 {\n    padding-left: 73.5rem !important;\n  }\n\n  .ps-sm-149 {\n    padding-left: 74rem !important;\n  }\n\n  .ps-sm-150 {\n    padding-left: 74.5rem !important;\n  }\n\n  .ps-sm-151 {\n    padding-left: 75rem !important;\n  }\n\n  .ps-sm-152 {\n    padding-left: 75.5rem !important;\n  }\n\n  .ps-sm-153 {\n    padding-left: 76rem !important;\n  }\n\n  .ps-sm-154 {\n    padding-left: 76.5rem !important;\n  }\n\n  .ps-sm-155 {\n    padding-left: 77rem !important;\n  }\n\n  .ps-sm-156 {\n    padding-left: 77.5rem !important;\n  }\n\n  .ps-sm-157 {\n    padding-left: 78rem !important;\n  }\n\n  .ps-sm-158 {\n    padding-left: 78.5rem !important;\n  }\n\n  .ps-sm-159 {\n    padding-left: 79rem !important;\n  }\n\n  .ps-sm-160 {\n    padding-left: 79.5rem !important;\n  }\n\n  .pe-sm-0 {\n    padding-right: 0rem !important;\n  }\n\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-sm-5 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-sm-6 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-sm-7 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-sm-8 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-sm-9 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-sm-10 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-sm-11 {\n    padding-right: 5rem !important;\n  }\n\n  .pe-sm-12 {\n    padding-right: 5.5rem !important;\n  }\n\n  .pe-sm-13 {\n    padding-right: 6rem !important;\n  }\n\n  .pe-sm-14 {\n    padding-right: 6.5rem !important;\n  }\n\n  .pe-sm-15 {\n    padding-right: 7rem !important;\n  }\n\n  .pe-sm-16 {\n    padding-right: 7.5rem !important;\n  }\n\n  .pe-sm-17 {\n    padding-right: 8rem !important;\n  }\n\n  .pe-sm-18 {\n    padding-right: 8.5rem !important;\n  }\n\n  .pe-sm-19 {\n    padding-right: 9rem !important;\n  }\n\n  .pe-sm-20 {\n    padding-right: 9.5rem !important;\n  }\n\n  .pe-sm-21 {\n    padding-right: 10rem !important;\n  }\n\n  .pe-sm-22 {\n    padding-right: 10.5rem !important;\n  }\n\n  .pe-sm-23 {\n    padding-right: 11rem !important;\n  }\n\n  .pe-sm-24 {\n    padding-right: 11.5rem !important;\n  }\n\n  .pe-sm-25 {\n    padding-right: 12rem !important;\n  }\n\n  .pe-sm-26 {\n    padding-right: 12.5rem !important;\n  }\n\n  .pe-sm-27 {\n    padding-right: 13rem !important;\n  }\n\n  .pe-sm-28 {\n    padding-right: 13.5rem !important;\n  }\n\n  .pe-sm-29 {\n    padding-right: 14rem !important;\n  }\n\n  .pe-sm-30 {\n    padding-right: 14.5rem !important;\n  }\n\n  .pe-sm-31 {\n    padding-right: 15rem !important;\n  }\n\n  .pe-sm-32 {\n    padding-right: 15.5rem !important;\n  }\n\n  .pe-sm-33 {\n    padding-right: 16rem !important;\n  }\n\n  .pe-sm-34 {\n    padding-right: 16.5rem !important;\n  }\n\n  .pe-sm-35 {\n    padding-right: 17rem !important;\n  }\n\n  .pe-sm-36 {\n    padding-right: 17.5rem !important;\n  }\n\n  .pe-sm-37 {\n    padding-right: 18rem !important;\n  }\n\n  .pe-sm-38 {\n    padding-right: 18.5rem !important;\n  }\n\n  .pe-sm-39 {\n    padding-right: 19rem !important;\n  }\n\n  .pe-sm-40 {\n    padding-right: 19.5rem !important;\n  }\n\n  .pe-sm-41 {\n    padding-right: 20rem !important;\n  }\n\n  .pe-sm-42 {\n    padding-right: 20.5rem !important;\n  }\n\n  .pe-sm-43 {\n    padding-right: 21rem !important;\n  }\n\n  .pe-sm-44 {\n    padding-right: 21.5rem !important;\n  }\n\n  .pe-sm-45 {\n    padding-right: 22rem !important;\n  }\n\n  .pe-sm-46 {\n    padding-right: 22.5rem !important;\n  }\n\n  .pe-sm-47 {\n    padding-right: 23rem !important;\n  }\n\n  .pe-sm-48 {\n    padding-right: 23.5rem !important;\n  }\n\n  .pe-sm-49 {\n    padding-right: 24rem !important;\n  }\n\n  .pe-sm-50 {\n    padding-right: 24.5rem !important;\n  }\n\n  .pe-sm-51 {\n    padding-right: 25rem !important;\n  }\n\n  .pe-sm-52 {\n    padding-right: 25.5rem !important;\n  }\n\n  .pe-sm-53 {\n    padding-right: 26rem !important;\n  }\n\n  .pe-sm-54 {\n    padding-right: 26.5rem !important;\n  }\n\n  .pe-sm-55 {\n    padding-right: 27rem !important;\n  }\n\n  .pe-sm-56 {\n    padding-right: 27.5rem !important;\n  }\n\n  .pe-sm-57 {\n    padding-right: 28rem !important;\n  }\n\n  .pe-sm-58 {\n    padding-right: 28.5rem !important;\n  }\n\n  .pe-sm-59 {\n    padding-right: 29rem !important;\n  }\n\n  .pe-sm-60 {\n    padding-right: 29.5rem !important;\n  }\n\n  .pe-sm-61 {\n    padding-right: 30rem !important;\n  }\n\n  .pe-sm-62 {\n    padding-right: 30.5rem !important;\n  }\n\n  .pe-sm-63 {\n    padding-right: 31rem !important;\n  }\n\n  .pe-sm-64 {\n    padding-right: 31.5rem !important;\n  }\n\n  .pe-sm-65 {\n    padding-right: 32rem !important;\n  }\n\n  .pe-sm-66 {\n    padding-right: 32.5rem !important;\n  }\n\n  .pe-sm-67 {\n    padding-right: 33rem !important;\n  }\n\n  .pe-sm-68 {\n    padding-right: 33.5rem !important;\n  }\n\n  .pe-sm-69 {\n    padding-right: 34rem !important;\n  }\n\n  .pe-sm-70 {\n    padding-right: 34.5rem !important;\n  }\n\n  .pe-sm-71 {\n    padding-right: 35rem !important;\n  }\n\n  .pe-sm-72 {\n    padding-right: 35.5rem !important;\n  }\n\n  .pe-sm-73 {\n    padding-right: 36rem !important;\n  }\n\n  .pe-sm-74 {\n    padding-right: 36.5rem !important;\n  }\n\n  .pe-sm-75 {\n    padding-right: 37rem !important;\n  }\n\n  .pe-sm-76 {\n    padding-right: 37.5rem !important;\n  }\n\n  .pe-sm-77 {\n    padding-right: 38rem !important;\n  }\n\n  .pe-sm-78 {\n    padding-right: 38.5rem !important;\n  }\n\n  .pe-sm-79 {\n    padding-right: 39rem !important;\n  }\n\n  .pe-sm-80 {\n    padding-right: 39.5rem !important;\n  }\n\n  .pe-sm-81 {\n    padding-right: 40rem !important;\n  }\n\n  .pe-sm-82 {\n    padding-right: 40.5rem !important;\n  }\n\n  .pe-sm-83 {\n    padding-right: 41rem !important;\n  }\n\n  .pe-sm-84 {\n    padding-right: 41.5rem !important;\n  }\n\n  .pe-sm-85 {\n    padding-right: 42rem !important;\n  }\n\n  .pe-sm-86 {\n    padding-right: 42.5rem !important;\n  }\n\n  .pe-sm-87 {\n    padding-right: 43rem !important;\n  }\n\n  .pe-sm-88 {\n    padding-right: 43.5rem !important;\n  }\n\n  .pe-sm-89 {\n    padding-right: 44rem !important;\n  }\n\n  .pe-sm-90 {\n    padding-right: 44.5rem !important;\n  }\n\n  .pe-sm-91 {\n    padding-right: 45rem !important;\n  }\n\n  .pe-sm-92 {\n    padding-right: 45.5rem !important;\n  }\n\n  .pe-sm-93 {\n    padding-right: 46rem !important;\n  }\n\n  .pe-sm-94 {\n    padding-right: 46.5rem !important;\n  }\n\n  .pe-sm-95 {\n    padding-right: 47rem !important;\n  }\n\n  .pe-sm-96 {\n    padding-right: 47.5rem !important;\n  }\n\n  .pe-sm-97 {\n    padding-right: 48rem !important;\n  }\n\n  .pe-sm-98 {\n    padding-right: 48.5rem !important;\n  }\n\n  .pe-sm-99 {\n    padding-right: 49rem !important;\n  }\n\n  .pe-sm-100 {\n    padding-right: 49.5rem !important;\n  }\n\n  .pe-sm-101 {\n    padding-right: 50rem !important;\n  }\n\n  .pe-sm-102 {\n    padding-right: 50.5rem !important;\n  }\n\n  .pe-sm-103 {\n    padding-right: 51rem !important;\n  }\n\n  .pe-sm-104 {\n    padding-right: 51.5rem !important;\n  }\n\n  .pe-sm-105 {\n    padding-right: 52rem !important;\n  }\n\n  .pe-sm-106 {\n    padding-right: 52.5rem !important;\n  }\n\n  .pe-sm-107 {\n    padding-right: 53rem !important;\n  }\n\n  .pe-sm-108 {\n    padding-right: 53.5rem !important;\n  }\n\n  .pe-sm-109 {\n    padding-right: 54rem !important;\n  }\n\n  .pe-sm-110 {\n    padding-right: 54.5rem !important;\n  }\n\n  .pe-sm-111 {\n    padding-right: 55rem !important;\n  }\n\n  .pe-sm-112 {\n    padding-right: 55.5rem !important;\n  }\n\n  .pe-sm-113 {\n    padding-right: 56rem !important;\n  }\n\n  .pe-sm-114 {\n    padding-right: 56.5rem !important;\n  }\n\n  .pe-sm-115 {\n    padding-right: 57rem !important;\n  }\n\n  .pe-sm-116 {\n    padding-right: 57.5rem !important;\n  }\n\n  .pe-sm-117 {\n    padding-right: 58rem !important;\n  }\n\n  .pe-sm-118 {\n    padding-right: 58.5rem !important;\n  }\n\n  .pe-sm-119 {\n    padding-right: 59rem !important;\n  }\n\n  .pe-sm-120 {\n    padding-right: 59.5rem !important;\n  }\n\n  .pe-sm-121 {\n    padding-right: 60rem !important;\n  }\n\n  .pe-sm-122 {\n    padding-right: 60.5rem !important;\n  }\n\n  .pe-sm-123 {\n    padding-right: 61rem !important;\n  }\n\n  .pe-sm-124 {\n    padding-right: 61.5rem !important;\n  }\n\n  .pe-sm-125 {\n    padding-right: 62rem !important;\n  }\n\n  .pe-sm-126 {\n    padding-right: 62.5rem !important;\n  }\n\n  .pe-sm-127 {\n    padding-right: 63rem !important;\n  }\n\n  .pe-sm-128 {\n    padding-right: 63.5rem !important;\n  }\n\n  .pe-sm-129 {\n    padding-right: 64rem !important;\n  }\n\n  .pe-sm-130 {\n    padding-right: 64.5rem !important;\n  }\n\n  .pe-sm-131 {\n    padding-right: 65rem !important;\n  }\n\n  .pe-sm-132 {\n    padding-right: 65.5rem !important;\n  }\n\n  .pe-sm-133 {\n    padding-right: 66rem !important;\n  }\n\n  .pe-sm-134 {\n    padding-right: 66.5rem !important;\n  }\n\n  .pe-sm-135 {\n    padding-right: 67rem !important;\n  }\n\n  .pe-sm-136 {\n    padding-right: 67.5rem !important;\n  }\n\n  .pe-sm-137 {\n    padding-right: 68rem !important;\n  }\n\n  .pe-sm-138 {\n    padding-right: 68.5rem !important;\n  }\n\n  .pe-sm-139 {\n    padding-right: 69rem !important;\n  }\n\n  .pe-sm-140 {\n    padding-right: 69.5rem !important;\n  }\n\n  .pe-sm-141 {\n    padding-right: 70rem !important;\n  }\n\n  .pe-sm-142 {\n    padding-right: 70.5rem !important;\n  }\n\n  .pe-sm-143 {\n    padding-right: 71rem !important;\n  }\n\n  .pe-sm-144 {\n    padding-right: 71.5rem !important;\n  }\n\n  .pe-sm-145 {\n    padding-right: 72rem !important;\n  }\n\n  .pe-sm-146 {\n    padding-right: 72.5rem !important;\n  }\n\n  .pe-sm-147 {\n    padding-right: 73rem !important;\n  }\n\n  .pe-sm-148 {\n    padding-right: 73.5rem !important;\n  }\n\n  .pe-sm-149 {\n    padding-right: 74rem !important;\n  }\n\n  .pe-sm-150 {\n    padding-right: 74.5rem !important;\n  }\n\n  .pe-sm-151 {\n    padding-right: 75rem !important;\n  }\n\n  .pe-sm-152 {\n    padding-right: 75.5rem !important;\n  }\n\n  .pe-sm-153 {\n    padding-right: 76rem !important;\n  }\n\n  .pe-sm-154 {\n    padding-right: 76.5rem !important;\n  }\n\n  .pe-sm-155 {\n    padding-right: 77rem !important;\n  }\n\n  .pe-sm-156 {\n    padding-right: 77.5rem !important;\n  }\n\n  .pe-sm-157 {\n    padding-right: 78rem !important;\n  }\n\n  .pe-sm-158 {\n    padding-right: 78.5rem !important;\n  }\n\n  .pe-sm-159 {\n    padding-right: 79rem !important;\n  }\n\n  .pe-sm-160 {\n    padding-right: 79.5rem !important;\n  }\n\n  .px-sm-0 {\n    padding-left: 0rem !important;\n    padding-right: 0rem !important;\n  }\n\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .px-sm-3 {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .px-sm-5 {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n\n  .px-sm-6 {\n    padding-left: 2.5rem !important;\n    padding-right: 2.5rem !important;\n  }\n\n  .px-sm-7 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n  }\n\n  .px-sm-8 {\n    padding-left: 3.5rem !important;\n    padding-right: 3.5rem !important;\n  }\n\n  .px-sm-9 {\n    padding-left: 4rem !important;\n    padding-right: 4rem !important;\n  }\n\n  .px-sm-10 {\n    padding-left: 4.5rem !important;\n    padding-right: 4.5rem !important;\n  }\n\n  .px-sm-11 {\n    padding-left: 5rem !important;\n    padding-right: 5rem !important;\n  }\n\n  .px-sm-12 {\n    padding-left: 5.5rem !important;\n    padding-right: 5.5rem !important;\n  }\n\n  .px-sm-13 {\n    padding-left: 6rem !important;\n    padding-right: 6rem !important;\n  }\n\n  .px-sm-14 {\n    padding-left: 6.5rem !important;\n    padding-right: 6.5rem !important;\n  }\n\n  .px-sm-15 {\n    padding-left: 7rem !important;\n    padding-right: 7rem !important;\n  }\n\n  .px-sm-16 {\n    padding-left: 7.5rem !important;\n    padding-right: 7.5rem !important;\n  }\n\n  .px-sm-17 {\n    padding-left: 8rem !important;\n    padding-right: 8rem !important;\n  }\n\n  .px-sm-18 {\n    padding-left: 8.5rem !important;\n    padding-right: 8.5rem !important;\n  }\n\n  .px-sm-19 {\n    padding-left: 9rem !important;\n    padding-right: 9rem !important;\n  }\n\n  .px-sm-20 {\n    padding-left: 9.5rem !important;\n    padding-right: 9.5rem !important;\n  }\n\n  .px-sm-21 {\n    padding-left: 10rem !important;\n    padding-right: 10rem !important;\n  }\n\n  .px-sm-22 {\n    padding-left: 10.5rem !important;\n    padding-right: 10.5rem !important;\n  }\n\n  .px-sm-23 {\n    padding-left: 11rem !important;\n    padding-right: 11rem !important;\n  }\n\n  .px-sm-24 {\n    padding-left: 11.5rem !important;\n    padding-right: 11.5rem !important;\n  }\n\n  .px-sm-25 {\n    padding-left: 12rem !important;\n    padding-right: 12rem !important;\n  }\n\n  .px-sm-26 {\n    padding-left: 12.5rem !important;\n    padding-right: 12.5rem !important;\n  }\n\n  .px-sm-27 {\n    padding-left: 13rem !important;\n    padding-right: 13rem !important;\n  }\n\n  .px-sm-28 {\n    padding-left: 13.5rem !important;\n    padding-right: 13.5rem !important;\n  }\n\n  .px-sm-29 {\n    padding-left: 14rem !important;\n    padding-right: 14rem !important;\n  }\n\n  .px-sm-30 {\n    padding-left: 14.5rem !important;\n    padding-right: 14.5rem !important;\n  }\n\n  .px-sm-31 {\n    padding-left: 15rem !important;\n    padding-right: 15rem !important;\n  }\n\n  .px-sm-32 {\n    padding-left: 15.5rem !important;\n    padding-right: 15.5rem !important;\n  }\n\n  .px-sm-33 {\n    padding-left: 16rem !important;\n    padding-right: 16rem !important;\n  }\n\n  .px-sm-34 {\n    padding-left: 16.5rem !important;\n    padding-right: 16.5rem !important;\n  }\n\n  .px-sm-35 {\n    padding-left: 17rem !important;\n    padding-right: 17rem !important;\n  }\n\n  .px-sm-36 {\n    padding-left: 17.5rem !important;\n    padding-right: 17.5rem !important;\n  }\n\n  .px-sm-37 {\n    padding-left: 18rem !important;\n    padding-right: 18rem !important;\n  }\n\n  .px-sm-38 {\n    padding-left: 18.5rem !important;\n    padding-right: 18.5rem !important;\n  }\n\n  .px-sm-39 {\n    padding-left: 19rem !important;\n    padding-right: 19rem !important;\n  }\n\n  .px-sm-40 {\n    padding-left: 19.5rem !important;\n    padding-right: 19.5rem !important;\n  }\n\n  .px-sm-41 {\n    padding-left: 20rem !important;\n    padding-right: 20rem !important;\n  }\n\n  .px-sm-42 {\n    padding-left: 20.5rem !important;\n    padding-right: 20.5rem !important;\n  }\n\n  .px-sm-43 {\n    padding-left: 21rem !important;\n    padding-right: 21rem !important;\n  }\n\n  .px-sm-44 {\n    padding-left: 21.5rem !important;\n    padding-right: 21.5rem !important;\n  }\n\n  .px-sm-45 {\n    padding-left: 22rem !important;\n    padding-right: 22rem !important;\n  }\n\n  .px-sm-46 {\n    padding-left: 22.5rem !important;\n    padding-right: 22.5rem !important;\n  }\n\n  .px-sm-47 {\n    padding-left: 23rem !important;\n    padding-right: 23rem !important;\n  }\n\n  .px-sm-48 {\n    padding-left: 23.5rem !important;\n    padding-right: 23.5rem !important;\n  }\n\n  .px-sm-49 {\n    padding-left: 24rem !important;\n    padding-right: 24rem !important;\n  }\n\n  .px-sm-50 {\n    padding-left: 24.5rem !important;\n    padding-right: 24.5rem !important;\n  }\n\n  .px-sm-51 {\n    padding-left: 25rem !important;\n    padding-right: 25rem !important;\n  }\n\n  .px-sm-52 {\n    padding-left: 25.5rem !important;\n    padding-right: 25.5rem !important;\n  }\n\n  .px-sm-53 {\n    padding-left: 26rem !important;\n    padding-right: 26rem !important;\n  }\n\n  .px-sm-54 {\n    padding-left: 26.5rem !important;\n    padding-right: 26.5rem !important;\n  }\n\n  .px-sm-55 {\n    padding-left: 27rem !important;\n    padding-right: 27rem !important;\n  }\n\n  .px-sm-56 {\n    padding-left: 27.5rem !important;\n    padding-right: 27.5rem !important;\n  }\n\n  .px-sm-57 {\n    padding-left: 28rem !important;\n    padding-right: 28rem !important;\n  }\n\n  .px-sm-58 {\n    padding-left: 28.5rem !important;\n    padding-right: 28.5rem !important;\n  }\n\n  .px-sm-59 {\n    padding-left: 29rem !important;\n    padding-right: 29rem !important;\n  }\n\n  .px-sm-60 {\n    padding-left: 29.5rem !important;\n    padding-right: 29.5rem !important;\n  }\n\n  .px-sm-61 {\n    padding-left: 30rem !important;\n    padding-right: 30rem !important;\n  }\n\n  .px-sm-62 {\n    padding-left: 30.5rem !important;\n    padding-right: 30.5rem !important;\n  }\n\n  .px-sm-63 {\n    padding-left: 31rem !important;\n    padding-right: 31rem !important;\n  }\n\n  .px-sm-64 {\n    padding-left: 31.5rem !important;\n    padding-right: 31.5rem !important;\n  }\n\n  .px-sm-65 {\n    padding-left: 32rem !important;\n    padding-right: 32rem !important;\n  }\n\n  .px-sm-66 {\n    padding-left: 32.5rem !important;\n    padding-right: 32.5rem !important;\n  }\n\n  .px-sm-67 {\n    padding-left: 33rem !important;\n    padding-right: 33rem !important;\n  }\n\n  .px-sm-68 {\n    padding-left: 33.5rem !important;\n    padding-right: 33.5rem !important;\n  }\n\n  .px-sm-69 {\n    padding-left: 34rem !important;\n    padding-right: 34rem !important;\n  }\n\n  .px-sm-70 {\n    padding-left: 34.5rem !important;\n    padding-right: 34.5rem !important;\n  }\n\n  .px-sm-71 {\n    padding-left: 35rem !important;\n    padding-right: 35rem !important;\n  }\n\n  .px-sm-72 {\n    padding-left: 35.5rem !important;\n    padding-right: 35.5rem !important;\n  }\n\n  .px-sm-73 {\n    padding-left: 36rem !important;\n    padding-right: 36rem !important;\n  }\n\n  .px-sm-74 {\n    padding-left: 36.5rem !important;\n    padding-right: 36.5rem !important;\n  }\n\n  .px-sm-75 {\n    padding-left: 37rem !important;\n    padding-right: 37rem !important;\n  }\n\n  .px-sm-76 {\n    padding-left: 37.5rem !important;\n    padding-right: 37.5rem !important;\n  }\n\n  .px-sm-77 {\n    padding-left: 38rem !important;\n    padding-right: 38rem !important;\n  }\n\n  .px-sm-78 {\n    padding-left: 38.5rem !important;\n    padding-right: 38.5rem !important;\n  }\n\n  .px-sm-79 {\n    padding-left: 39rem !important;\n    padding-right: 39rem !important;\n  }\n\n  .px-sm-80 {\n    padding-left: 39.5rem !important;\n    padding-right: 39.5rem !important;\n  }\n\n  .px-sm-81 {\n    padding-left: 40rem !important;\n    padding-right: 40rem !important;\n  }\n\n  .px-sm-82 {\n    padding-left: 40.5rem !important;\n    padding-right: 40.5rem !important;\n  }\n\n  .px-sm-83 {\n    padding-left: 41rem !important;\n    padding-right: 41rem !important;\n  }\n\n  .px-sm-84 {\n    padding-left: 41.5rem !important;\n    padding-right: 41.5rem !important;\n  }\n\n  .px-sm-85 {\n    padding-left: 42rem !important;\n    padding-right: 42rem !important;\n  }\n\n  .px-sm-86 {\n    padding-left: 42.5rem !important;\n    padding-right: 42.5rem !important;\n  }\n\n  .px-sm-87 {\n    padding-left: 43rem !important;\n    padding-right: 43rem !important;\n  }\n\n  .px-sm-88 {\n    padding-left: 43.5rem !important;\n    padding-right: 43.5rem !important;\n  }\n\n  .px-sm-89 {\n    padding-left: 44rem !important;\n    padding-right: 44rem !important;\n  }\n\n  .px-sm-90 {\n    padding-left: 44.5rem !important;\n    padding-right: 44.5rem !important;\n  }\n\n  .px-sm-91 {\n    padding-left: 45rem !important;\n    padding-right: 45rem !important;\n  }\n\n  .px-sm-92 {\n    padding-left: 45.5rem !important;\n    padding-right: 45.5rem !important;\n  }\n\n  .px-sm-93 {\n    padding-left: 46rem !important;\n    padding-right: 46rem !important;\n  }\n\n  .px-sm-94 {\n    padding-left: 46.5rem !important;\n    padding-right: 46.5rem !important;\n  }\n\n  .px-sm-95 {\n    padding-left: 47rem !important;\n    padding-right: 47rem !important;\n  }\n\n  .px-sm-96 {\n    padding-left: 47.5rem !important;\n    padding-right: 47.5rem !important;\n  }\n\n  .px-sm-97 {\n    padding-left: 48rem !important;\n    padding-right: 48rem !important;\n  }\n\n  .px-sm-98 {\n    padding-left: 48.5rem !important;\n    padding-right: 48.5rem !important;\n  }\n\n  .px-sm-99 {\n    padding-left: 49rem !important;\n    padding-right: 49rem !important;\n  }\n\n  .px-sm-100 {\n    padding-left: 49.5rem !important;\n    padding-right: 49.5rem !important;\n  }\n\n  .px-sm-101 {\n    padding-left: 50rem !important;\n    padding-right: 50rem !important;\n  }\n\n  .px-sm-102 {\n    padding-left: 50.5rem !important;\n    padding-right: 50.5rem !important;\n  }\n\n  .px-sm-103 {\n    padding-left: 51rem !important;\n    padding-right: 51rem !important;\n  }\n\n  .px-sm-104 {\n    padding-left: 51.5rem !important;\n    padding-right: 51.5rem !important;\n  }\n\n  .px-sm-105 {\n    padding-left: 52rem !important;\n    padding-right: 52rem !important;\n  }\n\n  .px-sm-106 {\n    padding-left: 52.5rem !important;\n    padding-right: 52.5rem !important;\n  }\n\n  .px-sm-107 {\n    padding-left: 53rem !important;\n    padding-right: 53rem !important;\n  }\n\n  .px-sm-108 {\n    padding-left: 53.5rem !important;\n    padding-right: 53.5rem !important;\n  }\n\n  .px-sm-109 {\n    padding-left: 54rem !important;\n    padding-right: 54rem !important;\n  }\n\n  .px-sm-110 {\n    padding-left: 54.5rem !important;\n    padding-right: 54.5rem !important;\n  }\n\n  .px-sm-111 {\n    padding-left: 55rem !important;\n    padding-right: 55rem !important;\n  }\n\n  .px-sm-112 {\n    padding-left: 55.5rem !important;\n    padding-right: 55.5rem !important;\n  }\n\n  .px-sm-113 {\n    padding-left: 56rem !important;\n    padding-right: 56rem !important;\n  }\n\n  .px-sm-114 {\n    padding-left: 56.5rem !important;\n    padding-right: 56.5rem !important;\n  }\n\n  .px-sm-115 {\n    padding-left: 57rem !important;\n    padding-right: 57rem !important;\n  }\n\n  .px-sm-116 {\n    padding-left: 57.5rem !important;\n    padding-right: 57.5rem !important;\n  }\n\n  .px-sm-117 {\n    padding-left: 58rem !important;\n    padding-right: 58rem !important;\n  }\n\n  .px-sm-118 {\n    padding-left: 58.5rem !important;\n    padding-right: 58.5rem !important;\n  }\n\n  .px-sm-119 {\n    padding-left: 59rem !important;\n    padding-right: 59rem !important;\n  }\n\n  .px-sm-120 {\n    padding-left: 59.5rem !important;\n    padding-right: 59.5rem !important;\n  }\n\n  .px-sm-121 {\n    padding-left: 60rem !important;\n    padding-right: 60rem !important;\n  }\n\n  .px-sm-122 {\n    padding-left: 60.5rem !important;\n    padding-right: 60.5rem !important;\n  }\n\n  .px-sm-123 {\n    padding-left: 61rem !important;\n    padding-right: 61rem !important;\n  }\n\n  .px-sm-124 {\n    padding-left: 61.5rem !important;\n    padding-right: 61.5rem !important;\n  }\n\n  .px-sm-125 {\n    padding-left: 62rem !important;\n    padding-right: 62rem !important;\n  }\n\n  .px-sm-126 {\n    padding-left: 62.5rem !important;\n    padding-right: 62.5rem !important;\n  }\n\n  .px-sm-127 {\n    padding-left: 63rem !important;\n    padding-right: 63rem !important;\n  }\n\n  .px-sm-128 {\n    padding-left: 63.5rem !important;\n    padding-right: 63.5rem !important;\n  }\n\n  .px-sm-129 {\n    padding-left: 64rem !important;\n    padding-right: 64rem !important;\n  }\n\n  .px-sm-130 {\n    padding-left: 64.5rem !important;\n    padding-right: 64.5rem !important;\n  }\n\n  .px-sm-131 {\n    padding-left: 65rem !important;\n    padding-right: 65rem !important;\n  }\n\n  .px-sm-132 {\n    padding-left: 65.5rem !important;\n    padding-right: 65.5rem !important;\n  }\n\n  .px-sm-133 {\n    padding-left: 66rem !important;\n    padding-right: 66rem !important;\n  }\n\n  .px-sm-134 {\n    padding-left: 66.5rem !important;\n    padding-right: 66.5rem !important;\n  }\n\n  .px-sm-135 {\n    padding-left: 67rem !important;\n    padding-right: 67rem !important;\n  }\n\n  .px-sm-136 {\n    padding-left: 67.5rem !important;\n    padding-right: 67.5rem !important;\n  }\n\n  .px-sm-137 {\n    padding-left: 68rem !important;\n    padding-right: 68rem !important;\n  }\n\n  .px-sm-138 {\n    padding-left: 68.5rem !important;\n    padding-right: 68.5rem !important;\n  }\n\n  .px-sm-139 {\n    padding-left: 69rem !important;\n    padding-right: 69rem !important;\n  }\n\n  .px-sm-140 {\n    padding-left: 69.5rem !important;\n    padding-right: 69.5rem !important;\n  }\n\n  .px-sm-141 {\n    padding-left: 70rem !important;\n    padding-right: 70rem !important;\n  }\n\n  .px-sm-142 {\n    padding-left: 70.5rem !important;\n    padding-right: 70.5rem !important;\n  }\n\n  .px-sm-143 {\n    padding-left: 71rem !important;\n    padding-right: 71rem !important;\n  }\n\n  .px-sm-144 {\n    padding-left: 71.5rem !important;\n    padding-right: 71.5rem !important;\n  }\n\n  .px-sm-145 {\n    padding-left: 72rem !important;\n    padding-right: 72rem !important;\n  }\n\n  .px-sm-146 {\n    padding-left: 72.5rem !important;\n    padding-right: 72.5rem !important;\n  }\n\n  .px-sm-147 {\n    padding-left: 73rem !important;\n    padding-right: 73rem !important;\n  }\n\n  .px-sm-148 {\n    padding-left: 73.5rem !important;\n    padding-right: 73.5rem !important;\n  }\n\n  .px-sm-149 {\n    padding-left: 74rem !important;\n    padding-right: 74rem !important;\n  }\n\n  .px-sm-150 {\n    padding-left: 74.5rem !important;\n    padding-right: 74.5rem !important;\n  }\n\n  .px-sm-151 {\n    padding-left: 75rem !important;\n    padding-right: 75rem !important;\n  }\n\n  .px-sm-152 {\n    padding-left: 75.5rem !important;\n    padding-right: 75.5rem !important;\n  }\n\n  .px-sm-153 {\n    padding-left: 76rem !important;\n    padding-right: 76rem !important;\n  }\n\n  .px-sm-154 {\n    padding-left: 76.5rem !important;\n    padding-right: 76.5rem !important;\n  }\n\n  .px-sm-155 {\n    padding-left: 77rem !important;\n    padding-right: 77rem !important;\n  }\n\n  .px-sm-156 {\n    padding-left: 77.5rem !important;\n    padding-right: 77.5rem !important;\n  }\n\n  .px-sm-157 {\n    padding-left: 78rem !important;\n    padding-right: 78rem !important;\n  }\n\n  .px-sm-158 {\n    padding-left: 78.5rem !important;\n    padding-right: 78.5rem !important;\n  }\n\n  .px-sm-159 {\n    padding-left: 79rem !important;\n    padding-right: 79rem !important;\n  }\n\n  .px-sm-160 {\n    padding-left: 79.5rem !important;\n    padding-right: 79.5rem !important;\n  }\n\n  .py-sm-0 {\n    padding-top: 0rem !important;\n    padding-bottom: 0rem !important;\n  }\n\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-sm-5 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-sm-6 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-sm-7 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-sm-8 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-sm-9 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-sm-10 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-sm-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .py-sm-12 {\n    padding-top: 5.5rem !important;\n    padding-bottom: 5.5rem !important;\n  }\n\n  .py-sm-13 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n\n  .py-sm-14 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n\n  .py-sm-15 {\n    padding-top: 7rem !important;\n    padding-bottom: 7rem !important;\n  }\n\n  .py-sm-16 {\n    padding-top: 7.5rem !important;\n    padding-bottom: 7.5rem !important;\n  }\n\n  .py-sm-17 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n\n  .py-sm-18 {\n    padding-top: 8.5rem !important;\n    padding-bottom: 8.5rem !important;\n  }\n\n  .py-sm-19 {\n    padding-top: 9rem !important;\n    padding-bottom: 9rem !important;\n  }\n\n  .py-sm-20 {\n    padding-top: 9.5rem !important;\n    padding-bottom: 9.5rem !important;\n  }\n\n  .py-sm-21 {\n    padding-top: 10rem !important;\n    padding-bottom: 10rem !important;\n  }\n\n  .py-sm-22 {\n    padding-top: 10.5rem !important;\n    padding-bottom: 10.5rem !important;\n  }\n\n  .py-sm-23 {\n    padding-top: 11rem !important;\n    padding-bottom: 11rem !important;\n  }\n\n  .py-sm-24 {\n    padding-top: 11.5rem !important;\n    padding-bottom: 11.5rem !important;\n  }\n\n  .py-sm-25 {\n    padding-top: 12rem !important;\n    padding-bottom: 12rem !important;\n  }\n\n  .py-sm-26 {\n    padding-top: 12.5rem !important;\n    padding-bottom: 12.5rem !important;\n  }\n\n  .py-sm-27 {\n    padding-top: 13rem !important;\n    padding-bottom: 13rem !important;\n  }\n\n  .py-sm-28 {\n    padding-top: 13.5rem !important;\n    padding-bottom: 13.5rem !important;\n  }\n\n  .py-sm-29 {\n    padding-top: 14rem !important;\n    padding-bottom: 14rem !important;\n  }\n\n  .py-sm-30 {\n    padding-top: 14.5rem !important;\n    padding-bottom: 14.5rem !important;\n  }\n\n  .py-sm-31 {\n    padding-top: 15rem !important;\n    padding-bottom: 15rem !important;\n  }\n\n  .py-sm-32 {\n    padding-top: 15.5rem !important;\n    padding-bottom: 15.5rem !important;\n  }\n\n  .py-sm-33 {\n    padding-top: 16rem !important;\n    padding-bottom: 16rem !important;\n  }\n\n  .py-sm-34 {\n    padding-top: 16.5rem !important;\n    padding-bottom: 16.5rem !important;\n  }\n\n  .py-sm-35 {\n    padding-top: 17rem !important;\n    padding-bottom: 17rem !important;\n  }\n\n  .py-sm-36 {\n    padding-top: 17.5rem !important;\n    padding-bottom: 17.5rem !important;\n  }\n\n  .py-sm-37 {\n    padding-top: 18rem !important;\n    padding-bottom: 18rem !important;\n  }\n\n  .py-sm-38 {\n    padding-top: 18.5rem !important;\n    padding-bottom: 18.5rem !important;\n  }\n\n  .py-sm-39 {\n    padding-top: 19rem !important;\n    padding-bottom: 19rem !important;\n  }\n\n  .py-sm-40 {\n    padding-top: 19.5rem !important;\n    padding-bottom: 19.5rem !important;\n  }\n\n  .py-sm-41 {\n    padding-top: 20rem !important;\n    padding-bottom: 20rem !important;\n  }\n\n  .py-sm-42 {\n    padding-top: 20.5rem !important;\n    padding-bottom: 20.5rem !important;\n  }\n\n  .py-sm-43 {\n    padding-top: 21rem !important;\n    padding-bottom: 21rem !important;\n  }\n\n  .py-sm-44 {\n    padding-top: 21.5rem !important;\n    padding-bottom: 21.5rem !important;\n  }\n\n  .py-sm-45 {\n    padding-top: 22rem !important;\n    padding-bottom: 22rem !important;\n  }\n\n  .py-sm-46 {\n    padding-top: 22.5rem !important;\n    padding-bottom: 22.5rem !important;\n  }\n\n  .py-sm-47 {\n    padding-top: 23rem !important;\n    padding-bottom: 23rem !important;\n  }\n\n  .py-sm-48 {\n    padding-top: 23.5rem !important;\n    padding-bottom: 23.5rem !important;\n  }\n\n  .py-sm-49 {\n    padding-top: 24rem !important;\n    padding-bottom: 24rem !important;\n  }\n\n  .py-sm-50 {\n    padding-top: 24.5rem !important;\n    padding-bottom: 24.5rem !important;\n  }\n\n  .py-sm-51 {\n    padding-top: 25rem !important;\n    padding-bottom: 25rem !important;\n  }\n\n  .py-sm-52 {\n    padding-top: 25.5rem !important;\n    padding-bottom: 25.5rem !important;\n  }\n\n  .py-sm-53 {\n    padding-top: 26rem !important;\n    padding-bottom: 26rem !important;\n  }\n\n  .py-sm-54 {\n    padding-top: 26.5rem !important;\n    padding-bottom: 26.5rem !important;\n  }\n\n  .py-sm-55 {\n    padding-top: 27rem !important;\n    padding-bottom: 27rem !important;\n  }\n\n  .py-sm-56 {\n    padding-top: 27.5rem !important;\n    padding-bottom: 27.5rem !important;\n  }\n\n  .py-sm-57 {\n    padding-top: 28rem !important;\n    padding-bottom: 28rem !important;\n  }\n\n  .py-sm-58 {\n    padding-top: 28.5rem !important;\n    padding-bottom: 28.5rem !important;\n  }\n\n  .py-sm-59 {\n    padding-top: 29rem !important;\n    padding-bottom: 29rem !important;\n  }\n\n  .py-sm-60 {\n    padding-top: 29.5rem !important;\n    padding-bottom: 29.5rem !important;\n  }\n\n  .py-sm-61 {\n    padding-top: 30rem !important;\n    padding-bottom: 30rem !important;\n  }\n\n  .py-sm-62 {\n    padding-top: 30.5rem !important;\n    padding-bottom: 30.5rem !important;\n  }\n\n  .py-sm-63 {\n    padding-top: 31rem !important;\n    padding-bottom: 31rem !important;\n  }\n\n  .py-sm-64 {\n    padding-top: 31.5rem !important;\n    padding-bottom: 31.5rem !important;\n  }\n\n  .py-sm-65 {\n    padding-top: 32rem !important;\n    padding-bottom: 32rem !important;\n  }\n\n  .py-sm-66 {\n    padding-top: 32.5rem !important;\n    padding-bottom: 32.5rem !important;\n  }\n\n  .py-sm-67 {\n    padding-top: 33rem !important;\n    padding-bottom: 33rem !important;\n  }\n\n  .py-sm-68 {\n    padding-top: 33.5rem !important;\n    padding-bottom: 33.5rem !important;\n  }\n\n  .py-sm-69 {\n    padding-top: 34rem !important;\n    padding-bottom: 34rem !important;\n  }\n\n  .py-sm-70 {\n    padding-top: 34.5rem !important;\n    padding-bottom: 34.5rem !important;\n  }\n\n  .py-sm-71 {\n    padding-top: 35rem !important;\n    padding-bottom: 35rem !important;\n  }\n\n  .py-sm-72 {\n    padding-top: 35.5rem !important;\n    padding-bottom: 35.5rem !important;\n  }\n\n  .py-sm-73 {\n    padding-top: 36rem !important;\n    padding-bottom: 36rem !important;\n  }\n\n  .py-sm-74 {\n    padding-top: 36.5rem !important;\n    padding-bottom: 36.5rem !important;\n  }\n\n  .py-sm-75 {\n    padding-top: 37rem !important;\n    padding-bottom: 37rem !important;\n  }\n\n  .py-sm-76 {\n    padding-top: 37.5rem !important;\n    padding-bottom: 37.5rem !important;\n  }\n\n  .py-sm-77 {\n    padding-top: 38rem !important;\n    padding-bottom: 38rem !important;\n  }\n\n  .py-sm-78 {\n    padding-top: 38.5rem !important;\n    padding-bottom: 38.5rem !important;\n  }\n\n  .py-sm-79 {\n    padding-top: 39rem !important;\n    padding-bottom: 39rem !important;\n  }\n\n  .py-sm-80 {\n    padding-top: 39.5rem !important;\n    padding-bottom: 39.5rem !important;\n  }\n\n  .py-sm-81 {\n    padding-top: 40rem !important;\n    padding-bottom: 40rem !important;\n  }\n\n  .py-sm-82 {\n    padding-top: 40.5rem !important;\n    padding-bottom: 40.5rem !important;\n  }\n\n  .py-sm-83 {\n    padding-top: 41rem !important;\n    padding-bottom: 41rem !important;\n  }\n\n  .py-sm-84 {\n    padding-top: 41.5rem !important;\n    padding-bottom: 41.5rem !important;\n  }\n\n  .py-sm-85 {\n    padding-top: 42rem !important;\n    padding-bottom: 42rem !important;\n  }\n\n  .py-sm-86 {\n    padding-top: 42.5rem !important;\n    padding-bottom: 42.5rem !important;\n  }\n\n  .py-sm-87 {\n    padding-top: 43rem !important;\n    padding-bottom: 43rem !important;\n  }\n\n  .py-sm-88 {\n    padding-top: 43.5rem !important;\n    padding-bottom: 43.5rem !important;\n  }\n\n  .py-sm-89 {\n    padding-top: 44rem !important;\n    padding-bottom: 44rem !important;\n  }\n\n  .py-sm-90 {\n    padding-top: 44.5rem !important;\n    padding-bottom: 44.5rem !important;\n  }\n\n  .py-sm-91 {\n    padding-top: 45rem !important;\n    padding-bottom: 45rem !important;\n  }\n\n  .py-sm-92 {\n    padding-top: 45.5rem !important;\n    padding-bottom: 45.5rem !important;\n  }\n\n  .py-sm-93 {\n    padding-top: 46rem !important;\n    padding-bottom: 46rem !important;\n  }\n\n  .py-sm-94 {\n    padding-top: 46.5rem !important;\n    padding-bottom: 46.5rem !important;\n  }\n\n  .py-sm-95 {\n    padding-top: 47rem !important;\n    padding-bottom: 47rem !important;\n  }\n\n  .py-sm-96 {\n    padding-top: 47.5rem !important;\n    padding-bottom: 47.5rem !important;\n  }\n\n  .py-sm-97 {\n    padding-top: 48rem !important;\n    padding-bottom: 48rem !important;\n  }\n\n  .py-sm-98 {\n    padding-top: 48.5rem !important;\n    padding-bottom: 48.5rem !important;\n  }\n\n  .py-sm-99 {\n    padding-top: 49rem !important;\n    padding-bottom: 49rem !important;\n  }\n\n  .py-sm-100 {\n    padding-top: 49.5rem !important;\n    padding-bottom: 49.5rem !important;\n  }\n\n  .py-sm-101 {\n    padding-top: 50rem !important;\n    padding-bottom: 50rem !important;\n  }\n\n  .py-sm-102 {\n    padding-top: 50.5rem !important;\n    padding-bottom: 50.5rem !important;\n  }\n\n  .py-sm-103 {\n    padding-top: 51rem !important;\n    padding-bottom: 51rem !important;\n  }\n\n  .py-sm-104 {\n    padding-top: 51.5rem !important;\n    padding-bottom: 51.5rem !important;\n  }\n\n  .py-sm-105 {\n    padding-top: 52rem !important;\n    padding-bottom: 52rem !important;\n  }\n\n  .py-sm-106 {\n    padding-top: 52.5rem !important;\n    padding-bottom: 52.5rem !important;\n  }\n\n  .py-sm-107 {\n    padding-top: 53rem !important;\n    padding-bottom: 53rem !important;\n  }\n\n  .py-sm-108 {\n    padding-top: 53.5rem !important;\n    padding-bottom: 53.5rem !important;\n  }\n\n  .py-sm-109 {\n    padding-top: 54rem !important;\n    padding-bottom: 54rem !important;\n  }\n\n  .py-sm-110 {\n    padding-top: 54.5rem !important;\n    padding-bottom: 54.5rem !important;\n  }\n\n  .py-sm-111 {\n    padding-top: 55rem !important;\n    padding-bottom: 55rem !important;\n  }\n\n  .py-sm-112 {\n    padding-top: 55.5rem !important;\n    padding-bottom: 55.5rem !important;\n  }\n\n  .py-sm-113 {\n    padding-top: 56rem !important;\n    padding-bottom: 56rem !important;\n  }\n\n  .py-sm-114 {\n    padding-top: 56.5rem !important;\n    padding-bottom: 56.5rem !important;\n  }\n\n  .py-sm-115 {\n    padding-top: 57rem !important;\n    padding-bottom: 57rem !important;\n  }\n\n  .py-sm-116 {\n    padding-top: 57.5rem !important;\n    padding-bottom: 57.5rem !important;\n  }\n\n  .py-sm-117 {\n    padding-top: 58rem !important;\n    padding-bottom: 58rem !important;\n  }\n\n  .py-sm-118 {\n    padding-top: 58.5rem !important;\n    padding-bottom: 58.5rem !important;\n  }\n\n  .py-sm-119 {\n    padding-top: 59rem !important;\n    padding-bottom: 59rem !important;\n  }\n\n  .py-sm-120 {\n    padding-top: 59.5rem !important;\n    padding-bottom: 59.5rem !important;\n  }\n\n  .py-sm-121 {\n    padding-top: 60rem !important;\n    padding-bottom: 60rem !important;\n  }\n\n  .py-sm-122 {\n    padding-top: 60.5rem !important;\n    padding-bottom: 60.5rem !important;\n  }\n\n  .py-sm-123 {\n    padding-top: 61rem !important;\n    padding-bottom: 61rem !important;\n  }\n\n  .py-sm-124 {\n    padding-top: 61.5rem !important;\n    padding-bottom: 61.5rem !important;\n  }\n\n  .py-sm-125 {\n    padding-top: 62rem !important;\n    padding-bottom: 62rem !important;\n  }\n\n  .py-sm-126 {\n    padding-top: 62.5rem !important;\n    padding-bottom: 62.5rem !important;\n  }\n\n  .py-sm-127 {\n    padding-top: 63rem !important;\n    padding-bottom: 63rem !important;\n  }\n\n  .py-sm-128 {\n    padding-top: 63.5rem !important;\n    padding-bottom: 63.5rem !important;\n  }\n\n  .py-sm-129 {\n    padding-top: 64rem !important;\n    padding-bottom: 64rem !important;\n  }\n\n  .py-sm-130 {\n    padding-top: 64.5rem !important;\n    padding-bottom: 64.5rem !important;\n  }\n\n  .py-sm-131 {\n    padding-top: 65rem !important;\n    padding-bottom: 65rem !important;\n  }\n\n  .py-sm-132 {\n    padding-top: 65.5rem !important;\n    padding-bottom: 65.5rem !important;\n  }\n\n  .py-sm-133 {\n    padding-top: 66rem !important;\n    padding-bottom: 66rem !important;\n  }\n\n  .py-sm-134 {\n    padding-top: 66.5rem !important;\n    padding-bottom: 66.5rem !important;\n  }\n\n  .py-sm-135 {\n    padding-top: 67rem !important;\n    padding-bottom: 67rem !important;\n  }\n\n  .py-sm-136 {\n    padding-top: 67.5rem !important;\n    padding-bottom: 67.5rem !important;\n  }\n\n  .py-sm-137 {\n    padding-top: 68rem !important;\n    padding-bottom: 68rem !important;\n  }\n\n  .py-sm-138 {\n    padding-top: 68.5rem !important;\n    padding-bottom: 68.5rem !important;\n  }\n\n  .py-sm-139 {\n    padding-top: 69rem !important;\n    padding-bottom: 69rem !important;\n  }\n\n  .py-sm-140 {\n    padding-top: 69.5rem !important;\n    padding-bottom: 69.5rem !important;\n  }\n\n  .py-sm-141 {\n    padding-top: 70rem !important;\n    padding-bottom: 70rem !important;\n  }\n\n  .py-sm-142 {\n    padding-top: 70.5rem !important;\n    padding-bottom: 70.5rem !important;\n  }\n\n  .py-sm-143 {\n    padding-top: 71rem !important;\n    padding-bottom: 71rem !important;\n  }\n\n  .py-sm-144 {\n    padding-top: 71.5rem !important;\n    padding-bottom: 71.5rem !important;\n  }\n\n  .py-sm-145 {\n    padding-top: 72rem !important;\n    padding-bottom: 72rem !important;\n  }\n\n  .py-sm-146 {\n    padding-top: 72.5rem !important;\n    padding-bottom: 72.5rem !important;\n  }\n\n  .py-sm-147 {\n    padding-top: 73rem !important;\n    padding-bottom: 73rem !important;\n  }\n\n  .py-sm-148 {\n    padding-top: 73.5rem !important;\n    padding-bottom: 73.5rem !important;\n  }\n\n  .py-sm-149 {\n    padding-top: 74rem !important;\n    padding-bottom: 74rem !important;\n  }\n\n  .py-sm-150 {\n    padding-top: 74.5rem !important;\n    padding-bottom: 74.5rem !important;\n  }\n\n  .py-sm-151 {\n    padding-top: 75rem !important;\n    padding-bottom: 75rem !important;\n  }\n\n  .py-sm-152 {\n    padding-top: 75.5rem !important;\n    padding-bottom: 75.5rem !important;\n  }\n\n  .py-sm-153 {\n    padding-top: 76rem !important;\n    padding-bottom: 76rem !important;\n  }\n\n  .py-sm-154 {\n    padding-top: 76.5rem !important;\n    padding-bottom: 76.5rem !important;\n  }\n\n  .py-sm-155 {\n    padding-top: 77rem !important;\n    padding-bottom: 77rem !important;\n  }\n\n  .py-sm-156 {\n    padding-top: 77.5rem !important;\n    padding-bottom: 77.5rem !important;\n  }\n\n  .py-sm-157 {\n    padding-top: 78rem !important;\n    padding-bottom: 78rem !important;\n  }\n\n  .py-sm-158 {\n    padding-top: 78.5rem !important;\n    padding-bottom: 78.5rem !important;\n  }\n\n  .py-sm-159 {\n    padding-top: 79rem !important;\n    padding-bottom: 79rem !important;\n  }\n\n  .py-sm-160 {\n    padding-top: 79.5rem !important;\n    padding-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .p-md-0 {\n    padding: 0rem !important;\n  }\n\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-md-5 {\n    padding: 2rem !important;\n  }\n\n  .p-md-6 {\n    padding: 2.5rem !important;\n  }\n\n  .p-md-7 {\n    padding: 3rem !important;\n  }\n\n  .p-md-8 {\n    padding: 3.5rem !important;\n  }\n\n  .p-md-9 {\n    padding: 4rem !important;\n  }\n\n  .p-md-10 {\n    padding: 4.5rem !important;\n  }\n\n  .p-md-11 {\n    padding: 5rem !important;\n  }\n\n  .p-md-12 {\n    padding: 5.5rem !important;\n  }\n\n  .p-md-13 {\n    padding: 6rem !important;\n  }\n\n  .p-md-14 {\n    padding: 6.5rem !important;\n  }\n\n  .p-md-15 {\n    padding: 7rem !important;\n  }\n\n  .p-md-16 {\n    padding: 7.5rem !important;\n  }\n\n  .p-md-17 {\n    padding: 8rem !important;\n  }\n\n  .p-md-18 {\n    padding: 8.5rem !important;\n  }\n\n  .p-md-19 {\n    padding: 9rem !important;\n  }\n\n  .p-md-20 {\n    padding: 9.5rem !important;\n  }\n\n  .p-md-21 {\n    padding: 10rem !important;\n  }\n\n  .p-md-22 {\n    padding: 10.5rem !important;\n  }\n\n  .p-md-23 {\n    padding: 11rem !important;\n  }\n\n  .p-md-24 {\n    padding: 11.5rem !important;\n  }\n\n  .p-md-25 {\n    padding: 12rem !important;\n  }\n\n  .p-md-26 {\n    padding: 12.5rem !important;\n  }\n\n  .p-md-27 {\n    padding: 13rem !important;\n  }\n\n  .p-md-28 {\n    padding: 13.5rem !important;\n  }\n\n  .p-md-29 {\n    padding: 14rem !important;\n  }\n\n  .p-md-30 {\n    padding: 14.5rem !important;\n  }\n\n  .p-md-31 {\n    padding: 15rem !important;\n  }\n\n  .p-md-32 {\n    padding: 15.5rem !important;\n  }\n\n  .p-md-33 {\n    padding: 16rem !important;\n  }\n\n  .p-md-34 {\n    padding: 16.5rem !important;\n  }\n\n  .p-md-35 {\n    padding: 17rem !important;\n  }\n\n  .p-md-36 {\n    padding: 17.5rem !important;\n  }\n\n  .p-md-37 {\n    padding: 18rem !important;\n  }\n\n  .p-md-38 {\n    padding: 18.5rem !important;\n  }\n\n  .p-md-39 {\n    padding: 19rem !important;\n  }\n\n  .p-md-40 {\n    padding: 19.5rem !important;\n  }\n\n  .p-md-41 {\n    padding: 20rem !important;\n  }\n\n  .p-md-42 {\n    padding: 20.5rem !important;\n  }\n\n  .p-md-43 {\n    padding: 21rem !important;\n  }\n\n  .p-md-44 {\n    padding: 21.5rem !important;\n  }\n\n  .p-md-45 {\n    padding: 22rem !important;\n  }\n\n  .p-md-46 {\n    padding: 22.5rem !important;\n  }\n\n  .p-md-47 {\n    padding: 23rem !important;\n  }\n\n  .p-md-48 {\n    padding: 23.5rem !important;\n  }\n\n  .p-md-49 {\n    padding: 24rem !important;\n  }\n\n  .p-md-50 {\n    padding: 24.5rem !important;\n  }\n\n  .p-md-51 {\n    padding: 25rem !important;\n  }\n\n  .p-md-52 {\n    padding: 25.5rem !important;\n  }\n\n  .p-md-53 {\n    padding: 26rem !important;\n  }\n\n  .p-md-54 {\n    padding: 26.5rem !important;\n  }\n\n  .p-md-55 {\n    padding: 27rem !important;\n  }\n\n  .p-md-56 {\n    padding: 27.5rem !important;\n  }\n\n  .p-md-57 {\n    padding: 28rem !important;\n  }\n\n  .p-md-58 {\n    padding: 28.5rem !important;\n  }\n\n  .p-md-59 {\n    padding: 29rem !important;\n  }\n\n  .p-md-60 {\n    padding: 29.5rem !important;\n  }\n\n  .p-md-61 {\n    padding: 30rem !important;\n  }\n\n  .p-md-62 {\n    padding: 30.5rem !important;\n  }\n\n  .p-md-63 {\n    padding: 31rem !important;\n  }\n\n  .p-md-64 {\n    padding: 31.5rem !important;\n  }\n\n  .p-md-65 {\n    padding: 32rem !important;\n  }\n\n  .p-md-66 {\n    padding: 32.5rem !important;\n  }\n\n  .p-md-67 {\n    padding: 33rem !important;\n  }\n\n  .p-md-68 {\n    padding: 33.5rem !important;\n  }\n\n  .p-md-69 {\n    padding: 34rem !important;\n  }\n\n  .p-md-70 {\n    padding: 34.5rem !important;\n  }\n\n  .p-md-71 {\n    padding: 35rem !important;\n  }\n\n  .p-md-72 {\n    padding: 35.5rem !important;\n  }\n\n  .p-md-73 {\n    padding: 36rem !important;\n  }\n\n  .p-md-74 {\n    padding: 36.5rem !important;\n  }\n\n  .p-md-75 {\n    padding: 37rem !important;\n  }\n\n  .p-md-76 {\n    padding: 37.5rem !important;\n  }\n\n  .p-md-77 {\n    padding: 38rem !important;\n  }\n\n  .p-md-78 {\n    padding: 38.5rem !important;\n  }\n\n  .p-md-79 {\n    padding: 39rem !important;\n  }\n\n  .p-md-80 {\n    padding: 39.5rem !important;\n  }\n\n  .p-md-81 {\n    padding: 40rem !important;\n  }\n\n  .p-md-82 {\n    padding: 40.5rem !important;\n  }\n\n  .p-md-83 {\n    padding: 41rem !important;\n  }\n\n  .p-md-84 {\n    padding: 41.5rem !important;\n  }\n\n  .p-md-85 {\n    padding: 42rem !important;\n  }\n\n  .p-md-86 {\n    padding: 42.5rem !important;\n  }\n\n  .p-md-87 {\n    padding: 43rem !important;\n  }\n\n  .p-md-88 {\n    padding: 43.5rem !important;\n  }\n\n  .p-md-89 {\n    padding: 44rem !important;\n  }\n\n  .p-md-90 {\n    padding: 44.5rem !important;\n  }\n\n  .p-md-91 {\n    padding: 45rem !important;\n  }\n\n  .p-md-92 {\n    padding: 45.5rem !important;\n  }\n\n  .p-md-93 {\n    padding: 46rem !important;\n  }\n\n  .p-md-94 {\n    padding: 46.5rem !important;\n  }\n\n  .p-md-95 {\n    padding: 47rem !important;\n  }\n\n  .p-md-96 {\n    padding: 47.5rem !important;\n  }\n\n  .p-md-97 {\n    padding: 48rem !important;\n  }\n\n  .p-md-98 {\n    padding: 48.5rem !important;\n  }\n\n  .p-md-99 {\n    padding: 49rem !important;\n  }\n\n  .p-md-100 {\n    padding: 49.5rem !important;\n  }\n\n  .p-md-101 {\n    padding: 50rem !important;\n  }\n\n  .p-md-102 {\n    padding: 50.5rem !important;\n  }\n\n  .p-md-103 {\n    padding: 51rem !important;\n  }\n\n  .p-md-104 {\n    padding: 51.5rem !important;\n  }\n\n  .p-md-105 {\n    padding: 52rem !important;\n  }\n\n  .p-md-106 {\n    padding: 52.5rem !important;\n  }\n\n  .p-md-107 {\n    padding: 53rem !important;\n  }\n\n  .p-md-108 {\n    padding: 53.5rem !important;\n  }\n\n  .p-md-109 {\n    padding: 54rem !important;\n  }\n\n  .p-md-110 {\n    padding: 54.5rem !important;\n  }\n\n  .p-md-111 {\n    padding: 55rem !important;\n  }\n\n  .p-md-112 {\n    padding: 55.5rem !important;\n  }\n\n  .p-md-113 {\n    padding: 56rem !important;\n  }\n\n  .p-md-114 {\n    padding: 56.5rem !important;\n  }\n\n  .p-md-115 {\n    padding: 57rem !important;\n  }\n\n  .p-md-116 {\n    padding: 57.5rem !important;\n  }\n\n  .p-md-117 {\n    padding: 58rem !important;\n  }\n\n  .p-md-118 {\n    padding: 58.5rem !important;\n  }\n\n  .p-md-119 {\n    padding: 59rem !important;\n  }\n\n  .p-md-120 {\n    padding: 59.5rem !important;\n  }\n\n  .p-md-121 {\n    padding: 60rem !important;\n  }\n\n  .p-md-122 {\n    padding: 60.5rem !important;\n  }\n\n  .p-md-123 {\n    padding: 61rem !important;\n  }\n\n  .p-md-124 {\n    padding: 61.5rem !important;\n  }\n\n  .p-md-125 {\n    padding: 62rem !important;\n  }\n\n  .p-md-126 {\n    padding: 62.5rem !important;\n  }\n\n  .p-md-127 {\n    padding: 63rem !important;\n  }\n\n  .p-md-128 {\n    padding: 63.5rem !important;\n  }\n\n  .p-md-129 {\n    padding: 64rem !important;\n  }\n\n  .p-md-130 {\n    padding: 64.5rem !important;\n  }\n\n  .p-md-131 {\n    padding: 65rem !important;\n  }\n\n  .p-md-132 {\n    padding: 65.5rem !important;\n  }\n\n  .p-md-133 {\n    padding: 66rem !important;\n  }\n\n  .p-md-134 {\n    padding: 66.5rem !important;\n  }\n\n  .p-md-135 {\n    padding: 67rem !important;\n  }\n\n  .p-md-136 {\n    padding: 67.5rem !important;\n  }\n\n  .p-md-137 {\n    padding: 68rem !important;\n  }\n\n  .p-md-138 {\n    padding: 68.5rem !important;\n  }\n\n  .p-md-139 {\n    padding: 69rem !important;\n  }\n\n  .p-md-140 {\n    padding: 69.5rem !important;\n  }\n\n  .p-md-141 {\n    padding: 70rem !important;\n  }\n\n  .p-md-142 {\n    padding: 70.5rem !important;\n  }\n\n  .p-md-143 {\n    padding: 71rem !important;\n  }\n\n  .p-md-144 {\n    padding: 71.5rem !important;\n  }\n\n  .p-md-145 {\n    padding: 72rem !important;\n  }\n\n  .p-md-146 {\n    padding: 72.5rem !important;\n  }\n\n  .p-md-147 {\n    padding: 73rem !important;\n  }\n\n  .p-md-148 {\n    padding: 73.5rem !important;\n  }\n\n  .p-md-149 {\n    padding: 74rem !important;\n  }\n\n  .p-md-150 {\n    padding: 74.5rem !important;\n  }\n\n  .p-md-151 {\n    padding: 75rem !important;\n  }\n\n  .p-md-152 {\n    padding: 75.5rem !important;\n  }\n\n  .p-md-153 {\n    padding: 76rem !important;\n  }\n\n  .p-md-154 {\n    padding: 76.5rem !important;\n  }\n\n  .p-md-155 {\n    padding: 77rem !important;\n  }\n\n  .p-md-156 {\n    padding: 77.5rem !important;\n  }\n\n  .p-md-157 {\n    padding: 78rem !important;\n  }\n\n  .p-md-158 {\n    padding: 78.5rem !important;\n  }\n\n  .p-md-159 {\n    padding: 79rem !important;\n  }\n\n  .p-md-160 {\n    padding: 79.5rem !important;\n  }\n\n  .pt-md-0 {\n    padding-top: 0rem !important;\n  }\n\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-md-5 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-md-6 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-md-7 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-md-8 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-md-9 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-md-10 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-md-11 {\n    padding-top: 5rem !important;\n  }\n\n  .pt-md-12 {\n    padding-top: 5.5rem !important;\n  }\n\n  .pt-md-13 {\n    padding-top: 6rem !important;\n  }\n\n  .pt-md-14 {\n    padding-top: 6.5rem !important;\n  }\n\n  .pt-md-15 {\n    padding-top: 7rem !important;\n  }\n\n  .pt-md-16 {\n    padding-top: 7.5rem !important;\n  }\n\n  .pt-md-17 {\n    padding-top: 8rem !important;\n  }\n\n  .pt-md-18 {\n    padding-top: 8.5rem !important;\n  }\n\n  .pt-md-19 {\n    padding-top: 9rem !important;\n  }\n\n  .pt-md-20 {\n    padding-top: 9.5rem !important;\n  }\n\n  .pt-md-21 {\n    padding-top: 10rem !important;\n  }\n\n  .pt-md-22 {\n    padding-top: 10.5rem !important;\n  }\n\n  .pt-md-23 {\n    padding-top: 11rem !important;\n  }\n\n  .pt-md-24 {\n    padding-top: 11.5rem !important;\n  }\n\n  .pt-md-25 {\n    padding-top: 12rem !important;\n  }\n\n  .pt-md-26 {\n    padding-top: 12.5rem !important;\n  }\n\n  .pt-md-27 {\n    padding-top: 13rem !important;\n  }\n\n  .pt-md-28 {\n    padding-top: 13.5rem !important;\n  }\n\n  .pt-md-29 {\n    padding-top: 14rem !important;\n  }\n\n  .pt-md-30 {\n    padding-top: 14.5rem !important;\n  }\n\n  .pt-md-31 {\n    padding-top: 15rem !important;\n  }\n\n  .pt-md-32 {\n    padding-top: 15.5rem !important;\n  }\n\n  .pt-md-33 {\n    padding-top: 16rem !important;\n  }\n\n  .pt-md-34 {\n    padding-top: 16.5rem !important;\n  }\n\n  .pt-md-35 {\n    padding-top: 17rem !important;\n  }\n\n  .pt-md-36 {\n    padding-top: 17.5rem !important;\n  }\n\n  .pt-md-37 {\n    padding-top: 18rem !important;\n  }\n\n  .pt-md-38 {\n    padding-top: 18.5rem !important;\n  }\n\n  .pt-md-39 {\n    padding-top: 19rem !important;\n  }\n\n  .pt-md-40 {\n    padding-top: 19.5rem !important;\n  }\n\n  .pt-md-41 {\n    padding-top: 20rem !important;\n  }\n\n  .pt-md-42 {\n    padding-top: 20.5rem !important;\n  }\n\n  .pt-md-43 {\n    padding-top: 21rem !important;\n  }\n\n  .pt-md-44 {\n    padding-top: 21.5rem !important;\n  }\n\n  .pt-md-45 {\n    padding-top: 22rem !important;\n  }\n\n  .pt-md-46 {\n    padding-top: 22.5rem !important;\n  }\n\n  .pt-md-47 {\n    padding-top: 23rem !important;\n  }\n\n  .pt-md-48 {\n    padding-top: 23.5rem !important;\n  }\n\n  .pt-md-49 {\n    padding-top: 24rem !important;\n  }\n\n  .pt-md-50 {\n    padding-top: 24.5rem !important;\n  }\n\n  .pt-md-51 {\n    padding-top: 25rem !important;\n  }\n\n  .pt-md-52 {\n    padding-top: 25.5rem !important;\n  }\n\n  .pt-md-53 {\n    padding-top: 26rem !important;\n  }\n\n  .pt-md-54 {\n    padding-top: 26.5rem !important;\n  }\n\n  .pt-md-55 {\n    padding-top: 27rem !important;\n  }\n\n  .pt-md-56 {\n    padding-top: 27.5rem !important;\n  }\n\n  .pt-md-57 {\n    padding-top: 28rem !important;\n  }\n\n  .pt-md-58 {\n    padding-top: 28.5rem !important;\n  }\n\n  .pt-md-59 {\n    padding-top: 29rem !important;\n  }\n\n  .pt-md-60 {\n    padding-top: 29.5rem !important;\n  }\n\n  .pt-md-61 {\n    padding-top: 30rem !important;\n  }\n\n  .pt-md-62 {\n    padding-top: 30.5rem !important;\n  }\n\n  .pt-md-63 {\n    padding-top: 31rem !important;\n  }\n\n  .pt-md-64 {\n    padding-top: 31.5rem !important;\n  }\n\n  .pt-md-65 {\n    padding-top: 32rem !important;\n  }\n\n  .pt-md-66 {\n    padding-top: 32.5rem !important;\n  }\n\n  .pt-md-67 {\n    padding-top: 33rem !important;\n  }\n\n  .pt-md-68 {\n    padding-top: 33.5rem !important;\n  }\n\n  .pt-md-69 {\n    padding-top: 34rem !important;\n  }\n\n  .pt-md-70 {\n    padding-top: 34.5rem !important;\n  }\n\n  .pt-md-71 {\n    padding-top: 35rem !important;\n  }\n\n  .pt-md-72 {\n    padding-top: 35.5rem !important;\n  }\n\n  .pt-md-73 {\n    padding-top: 36rem !important;\n  }\n\n  .pt-md-74 {\n    padding-top: 36.5rem !important;\n  }\n\n  .pt-md-75 {\n    padding-top: 37rem !important;\n  }\n\n  .pt-md-76 {\n    padding-top: 37.5rem !important;\n  }\n\n  .pt-md-77 {\n    padding-top: 38rem !important;\n  }\n\n  .pt-md-78 {\n    padding-top: 38.5rem !important;\n  }\n\n  .pt-md-79 {\n    padding-top: 39rem !important;\n  }\n\n  .pt-md-80 {\n    padding-top: 39.5rem !important;\n  }\n\n  .pt-md-81 {\n    padding-top: 40rem !important;\n  }\n\n  .pt-md-82 {\n    padding-top: 40.5rem !important;\n  }\n\n  .pt-md-83 {\n    padding-top: 41rem !important;\n  }\n\n  .pt-md-84 {\n    padding-top: 41.5rem !important;\n  }\n\n  .pt-md-85 {\n    padding-top: 42rem !important;\n  }\n\n  .pt-md-86 {\n    padding-top: 42.5rem !important;\n  }\n\n  .pt-md-87 {\n    padding-top: 43rem !important;\n  }\n\n  .pt-md-88 {\n    padding-top: 43.5rem !important;\n  }\n\n  .pt-md-89 {\n    padding-top: 44rem !important;\n  }\n\n  .pt-md-90 {\n    padding-top: 44.5rem !important;\n  }\n\n  .pt-md-91 {\n    padding-top: 45rem !important;\n  }\n\n  .pt-md-92 {\n    padding-top: 45.5rem !important;\n  }\n\n  .pt-md-93 {\n    padding-top: 46rem !important;\n  }\n\n  .pt-md-94 {\n    padding-top: 46.5rem !important;\n  }\n\n  .pt-md-95 {\n    padding-top: 47rem !important;\n  }\n\n  .pt-md-96 {\n    padding-top: 47.5rem !important;\n  }\n\n  .pt-md-97 {\n    padding-top: 48rem !important;\n  }\n\n  .pt-md-98 {\n    padding-top: 48.5rem !important;\n  }\n\n  .pt-md-99 {\n    padding-top: 49rem !important;\n  }\n\n  .pt-md-100 {\n    padding-top: 49.5rem !important;\n  }\n\n  .pt-md-101 {\n    padding-top: 50rem !important;\n  }\n\n  .pt-md-102 {\n    padding-top: 50.5rem !important;\n  }\n\n  .pt-md-103 {\n    padding-top: 51rem !important;\n  }\n\n  .pt-md-104 {\n    padding-top: 51.5rem !important;\n  }\n\n  .pt-md-105 {\n    padding-top: 52rem !important;\n  }\n\n  .pt-md-106 {\n    padding-top: 52.5rem !important;\n  }\n\n  .pt-md-107 {\n    padding-top: 53rem !important;\n  }\n\n  .pt-md-108 {\n    padding-top: 53.5rem !important;\n  }\n\n  .pt-md-109 {\n    padding-top: 54rem !important;\n  }\n\n  .pt-md-110 {\n    padding-top: 54.5rem !important;\n  }\n\n  .pt-md-111 {\n    padding-top: 55rem !important;\n  }\n\n  .pt-md-112 {\n    padding-top: 55.5rem !important;\n  }\n\n  .pt-md-113 {\n    padding-top: 56rem !important;\n  }\n\n  .pt-md-114 {\n    padding-top: 56.5rem !important;\n  }\n\n  .pt-md-115 {\n    padding-top: 57rem !important;\n  }\n\n  .pt-md-116 {\n    padding-top: 57.5rem !important;\n  }\n\n  .pt-md-117 {\n    padding-top: 58rem !important;\n  }\n\n  .pt-md-118 {\n    padding-top: 58.5rem !important;\n  }\n\n  .pt-md-119 {\n    padding-top: 59rem !important;\n  }\n\n  .pt-md-120 {\n    padding-top: 59.5rem !important;\n  }\n\n  .pt-md-121 {\n    padding-top: 60rem !important;\n  }\n\n  .pt-md-122 {\n    padding-top: 60.5rem !important;\n  }\n\n  .pt-md-123 {\n    padding-top: 61rem !important;\n  }\n\n  .pt-md-124 {\n    padding-top: 61.5rem !important;\n  }\n\n  .pt-md-125 {\n    padding-top: 62rem !important;\n  }\n\n  .pt-md-126 {\n    padding-top: 62.5rem !important;\n  }\n\n  .pt-md-127 {\n    padding-top: 63rem !important;\n  }\n\n  .pt-md-128 {\n    padding-top: 63.5rem !important;\n  }\n\n  .pt-md-129 {\n    padding-top: 64rem !important;\n  }\n\n  .pt-md-130 {\n    padding-top: 64.5rem !important;\n  }\n\n  .pt-md-131 {\n    padding-top: 65rem !important;\n  }\n\n  .pt-md-132 {\n    padding-top: 65.5rem !important;\n  }\n\n  .pt-md-133 {\n    padding-top: 66rem !important;\n  }\n\n  .pt-md-134 {\n    padding-top: 66.5rem !important;\n  }\n\n  .pt-md-135 {\n    padding-top: 67rem !important;\n  }\n\n  .pt-md-136 {\n    padding-top: 67.5rem !important;\n  }\n\n  .pt-md-137 {\n    padding-top: 68rem !important;\n  }\n\n  .pt-md-138 {\n    padding-top: 68.5rem !important;\n  }\n\n  .pt-md-139 {\n    padding-top: 69rem !important;\n  }\n\n  .pt-md-140 {\n    padding-top: 69.5rem !important;\n  }\n\n  .pt-md-141 {\n    padding-top: 70rem !important;\n  }\n\n  .pt-md-142 {\n    padding-top: 70.5rem !important;\n  }\n\n  .pt-md-143 {\n    padding-top: 71rem !important;\n  }\n\n  .pt-md-144 {\n    padding-top: 71.5rem !important;\n  }\n\n  .pt-md-145 {\n    padding-top: 72rem !important;\n  }\n\n  .pt-md-146 {\n    padding-top: 72.5rem !important;\n  }\n\n  .pt-md-147 {\n    padding-top: 73rem !important;\n  }\n\n  .pt-md-148 {\n    padding-top: 73.5rem !important;\n  }\n\n  .pt-md-149 {\n    padding-top: 74rem !important;\n  }\n\n  .pt-md-150 {\n    padding-top: 74.5rem !important;\n  }\n\n  .pt-md-151 {\n    padding-top: 75rem !important;\n  }\n\n  .pt-md-152 {\n    padding-top: 75.5rem !important;\n  }\n\n  .pt-md-153 {\n    padding-top: 76rem !important;\n  }\n\n  .pt-md-154 {\n    padding-top: 76.5rem !important;\n  }\n\n  .pt-md-155 {\n    padding-top: 77rem !important;\n  }\n\n  .pt-md-156 {\n    padding-top: 77.5rem !important;\n  }\n\n  .pt-md-157 {\n    padding-top: 78rem !important;\n  }\n\n  .pt-md-158 {\n    padding-top: 78.5rem !important;\n  }\n\n  .pt-md-159 {\n    padding-top: 79rem !important;\n  }\n\n  .pt-md-160 {\n    padding-top: 79.5rem !important;\n  }\n\n  .pb-md-0 {\n    padding-bottom: 0rem !important;\n  }\n\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-md-5 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-md-6 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-md-7 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-md-8 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-md-9 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-md-10 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-md-11 {\n    padding-bottom: 5rem !important;\n  }\n\n  .pb-md-12 {\n    padding-bottom: 5.5rem !important;\n  }\n\n  .pb-md-13 {\n    padding-bottom: 6rem !important;\n  }\n\n  .pb-md-14 {\n    padding-bottom: 6.5rem !important;\n  }\n\n  .pb-md-15 {\n    padding-bottom: 7rem !important;\n  }\n\n  .pb-md-16 {\n    padding-bottom: 7.5rem !important;\n  }\n\n  .pb-md-17 {\n    padding-bottom: 8rem !important;\n  }\n\n  .pb-md-18 {\n    padding-bottom: 8.5rem !important;\n  }\n\n  .pb-md-19 {\n    padding-bottom: 9rem !important;\n  }\n\n  .pb-md-20 {\n    padding-bottom: 9.5rem !important;\n  }\n\n  .pb-md-21 {\n    padding-bottom: 10rem !important;\n  }\n\n  .pb-md-22 {\n    padding-bottom: 10.5rem !important;\n  }\n\n  .pb-md-23 {\n    padding-bottom: 11rem !important;\n  }\n\n  .pb-md-24 {\n    padding-bottom: 11.5rem !important;\n  }\n\n  .pb-md-25 {\n    padding-bottom: 12rem !important;\n  }\n\n  .pb-md-26 {\n    padding-bottom: 12.5rem !important;\n  }\n\n  .pb-md-27 {\n    padding-bottom: 13rem !important;\n  }\n\n  .pb-md-28 {\n    padding-bottom: 13.5rem !important;\n  }\n\n  .pb-md-29 {\n    padding-bottom: 14rem !important;\n  }\n\n  .pb-md-30 {\n    padding-bottom: 14.5rem !important;\n  }\n\n  .pb-md-31 {\n    padding-bottom: 15rem !important;\n  }\n\n  .pb-md-32 {\n    padding-bottom: 15.5rem !important;\n  }\n\n  .pb-md-33 {\n    padding-bottom: 16rem !important;\n  }\n\n  .pb-md-34 {\n    padding-bottom: 16.5rem !important;\n  }\n\n  .pb-md-35 {\n    padding-bottom: 17rem !important;\n  }\n\n  .pb-md-36 {\n    padding-bottom: 17.5rem !important;\n  }\n\n  .pb-md-37 {\n    padding-bottom: 18rem !important;\n  }\n\n  .pb-md-38 {\n    padding-bottom: 18.5rem !important;\n  }\n\n  .pb-md-39 {\n    padding-bottom: 19rem !important;\n  }\n\n  .pb-md-40 {\n    padding-bottom: 19.5rem !important;\n  }\n\n  .pb-md-41 {\n    padding-bottom: 20rem !important;\n  }\n\n  .pb-md-42 {\n    padding-bottom: 20.5rem !important;\n  }\n\n  .pb-md-43 {\n    padding-bottom: 21rem !important;\n  }\n\n  .pb-md-44 {\n    padding-bottom: 21.5rem !important;\n  }\n\n  .pb-md-45 {\n    padding-bottom: 22rem !important;\n  }\n\n  .pb-md-46 {\n    padding-bottom: 22.5rem !important;\n  }\n\n  .pb-md-47 {\n    padding-bottom: 23rem !important;\n  }\n\n  .pb-md-48 {\n    padding-bottom: 23.5rem !important;\n  }\n\n  .pb-md-49 {\n    padding-bottom: 24rem !important;\n  }\n\n  .pb-md-50 {\n    padding-bottom: 24.5rem !important;\n  }\n\n  .pb-md-51 {\n    padding-bottom: 25rem !important;\n  }\n\n  .pb-md-52 {\n    padding-bottom: 25.5rem !important;\n  }\n\n  .pb-md-53 {\n    padding-bottom: 26rem !important;\n  }\n\n  .pb-md-54 {\n    padding-bottom: 26.5rem !important;\n  }\n\n  .pb-md-55 {\n    padding-bottom: 27rem !important;\n  }\n\n  .pb-md-56 {\n    padding-bottom: 27.5rem !important;\n  }\n\n  .pb-md-57 {\n    padding-bottom: 28rem !important;\n  }\n\n  .pb-md-58 {\n    padding-bottom: 28.5rem !important;\n  }\n\n  .pb-md-59 {\n    padding-bottom: 29rem !important;\n  }\n\n  .pb-md-60 {\n    padding-bottom: 29.5rem !important;\n  }\n\n  .pb-md-61 {\n    padding-bottom: 30rem !important;\n  }\n\n  .pb-md-62 {\n    padding-bottom: 30.5rem !important;\n  }\n\n  .pb-md-63 {\n    padding-bottom: 31rem !important;\n  }\n\n  .pb-md-64 {\n    padding-bottom: 31.5rem !important;\n  }\n\n  .pb-md-65 {\n    padding-bottom: 32rem !important;\n  }\n\n  .pb-md-66 {\n    padding-bottom: 32.5rem !important;\n  }\n\n  .pb-md-67 {\n    padding-bottom: 33rem !important;\n  }\n\n  .pb-md-68 {\n    padding-bottom: 33.5rem !important;\n  }\n\n  .pb-md-69 {\n    padding-bottom: 34rem !important;\n  }\n\n  .pb-md-70 {\n    padding-bottom: 34.5rem !important;\n  }\n\n  .pb-md-71 {\n    padding-bottom: 35rem !important;\n  }\n\n  .pb-md-72 {\n    padding-bottom: 35.5rem !important;\n  }\n\n  .pb-md-73 {\n    padding-bottom: 36rem !important;\n  }\n\n  .pb-md-74 {\n    padding-bottom: 36.5rem !important;\n  }\n\n  .pb-md-75 {\n    padding-bottom: 37rem !important;\n  }\n\n  .pb-md-76 {\n    padding-bottom: 37.5rem !important;\n  }\n\n  .pb-md-77 {\n    padding-bottom: 38rem !important;\n  }\n\n  .pb-md-78 {\n    padding-bottom: 38.5rem !important;\n  }\n\n  .pb-md-79 {\n    padding-bottom: 39rem !important;\n  }\n\n  .pb-md-80 {\n    padding-bottom: 39.5rem !important;\n  }\n\n  .pb-md-81 {\n    padding-bottom: 40rem !important;\n  }\n\n  .pb-md-82 {\n    padding-bottom: 40.5rem !important;\n  }\n\n  .pb-md-83 {\n    padding-bottom: 41rem !important;\n  }\n\n  .pb-md-84 {\n    padding-bottom: 41.5rem !important;\n  }\n\n  .pb-md-85 {\n    padding-bottom: 42rem !important;\n  }\n\n  .pb-md-86 {\n    padding-bottom: 42.5rem !important;\n  }\n\n  .pb-md-87 {\n    padding-bottom: 43rem !important;\n  }\n\n  .pb-md-88 {\n    padding-bottom: 43.5rem !important;\n  }\n\n  .pb-md-89 {\n    padding-bottom: 44rem !important;\n  }\n\n  .pb-md-90 {\n    padding-bottom: 44.5rem !important;\n  }\n\n  .pb-md-91 {\n    padding-bottom: 45rem !important;\n  }\n\n  .pb-md-92 {\n    padding-bottom: 45.5rem !important;\n  }\n\n  .pb-md-93 {\n    padding-bottom: 46rem !important;\n  }\n\n  .pb-md-94 {\n    padding-bottom: 46.5rem !important;\n  }\n\n  .pb-md-95 {\n    padding-bottom: 47rem !important;\n  }\n\n  .pb-md-96 {\n    padding-bottom: 47.5rem !important;\n  }\n\n  .pb-md-97 {\n    padding-bottom: 48rem !important;\n  }\n\n  .pb-md-98 {\n    padding-bottom: 48.5rem !important;\n  }\n\n  .pb-md-99 {\n    padding-bottom: 49rem !important;\n  }\n\n  .pb-md-100 {\n    padding-bottom: 49.5rem !important;\n  }\n\n  .pb-md-101 {\n    padding-bottom: 50rem !important;\n  }\n\n  .pb-md-102 {\n    padding-bottom: 50.5rem !important;\n  }\n\n  .pb-md-103 {\n    padding-bottom: 51rem !important;\n  }\n\n  .pb-md-104 {\n    padding-bottom: 51.5rem !important;\n  }\n\n  .pb-md-105 {\n    padding-bottom: 52rem !important;\n  }\n\n  .pb-md-106 {\n    padding-bottom: 52.5rem !important;\n  }\n\n  .pb-md-107 {\n    padding-bottom: 53rem !important;\n  }\n\n  .pb-md-108 {\n    padding-bottom: 53.5rem !important;\n  }\n\n  .pb-md-109 {\n    padding-bottom: 54rem !important;\n  }\n\n  .pb-md-110 {\n    padding-bottom: 54.5rem !important;\n  }\n\n  .pb-md-111 {\n    padding-bottom: 55rem !important;\n  }\n\n  .pb-md-112 {\n    padding-bottom: 55.5rem !important;\n  }\n\n  .pb-md-113 {\n    padding-bottom: 56rem !important;\n  }\n\n  .pb-md-114 {\n    padding-bottom: 56.5rem !important;\n  }\n\n  .pb-md-115 {\n    padding-bottom: 57rem !important;\n  }\n\n  .pb-md-116 {\n    padding-bottom: 57.5rem !important;\n  }\n\n  .pb-md-117 {\n    padding-bottom: 58rem !important;\n  }\n\n  .pb-md-118 {\n    padding-bottom: 58.5rem !important;\n  }\n\n  .pb-md-119 {\n    padding-bottom: 59rem !important;\n  }\n\n  .pb-md-120 {\n    padding-bottom: 59.5rem !important;\n  }\n\n  .pb-md-121 {\n    padding-bottom: 60rem !important;\n  }\n\n  .pb-md-122 {\n    padding-bottom: 60.5rem !important;\n  }\n\n  .pb-md-123 {\n    padding-bottom: 61rem !important;\n  }\n\n  .pb-md-124 {\n    padding-bottom: 61.5rem !important;\n  }\n\n  .pb-md-125 {\n    padding-bottom: 62rem !important;\n  }\n\n  .pb-md-126 {\n    padding-bottom: 62.5rem !important;\n  }\n\n  .pb-md-127 {\n    padding-bottom: 63rem !important;\n  }\n\n  .pb-md-128 {\n    padding-bottom: 63.5rem !important;\n  }\n\n  .pb-md-129 {\n    padding-bottom: 64rem !important;\n  }\n\n  .pb-md-130 {\n    padding-bottom: 64.5rem !important;\n  }\n\n  .pb-md-131 {\n    padding-bottom: 65rem !important;\n  }\n\n  .pb-md-132 {\n    padding-bottom: 65.5rem !important;\n  }\n\n  .pb-md-133 {\n    padding-bottom: 66rem !important;\n  }\n\n  .pb-md-134 {\n    padding-bottom: 66.5rem !important;\n  }\n\n  .pb-md-135 {\n    padding-bottom: 67rem !important;\n  }\n\n  .pb-md-136 {\n    padding-bottom: 67.5rem !important;\n  }\n\n  .pb-md-137 {\n    padding-bottom: 68rem !important;\n  }\n\n  .pb-md-138 {\n    padding-bottom: 68.5rem !important;\n  }\n\n  .pb-md-139 {\n    padding-bottom: 69rem !important;\n  }\n\n  .pb-md-140 {\n    padding-bottom: 69.5rem !important;\n  }\n\n  .pb-md-141 {\n    padding-bottom: 70rem !important;\n  }\n\n  .pb-md-142 {\n    padding-bottom: 70.5rem !important;\n  }\n\n  .pb-md-143 {\n    padding-bottom: 71rem !important;\n  }\n\n  .pb-md-144 {\n    padding-bottom: 71.5rem !important;\n  }\n\n  .pb-md-145 {\n    padding-bottom: 72rem !important;\n  }\n\n  .pb-md-146 {\n    padding-bottom: 72.5rem !important;\n  }\n\n  .pb-md-147 {\n    padding-bottom: 73rem !important;\n  }\n\n  .pb-md-148 {\n    padding-bottom: 73.5rem !important;\n  }\n\n  .pb-md-149 {\n    padding-bottom: 74rem !important;\n  }\n\n  .pb-md-150 {\n    padding-bottom: 74.5rem !important;\n  }\n\n  .pb-md-151 {\n    padding-bottom: 75rem !important;\n  }\n\n  .pb-md-152 {\n    padding-bottom: 75.5rem !important;\n  }\n\n  .pb-md-153 {\n    padding-bottom: 76rem !important;\n  }\n\n  .pb-md-154 {\n    padding-bottom: 76.5rem !important;\n  }\n\n  .pb-md-155 {\n    padding-bottom: 77rem !important;\n  }\n\n  .pb-md-156 {\n    padding-bottom: 77.5rem !important;\n  }\n\n  .pb-md-157 {\n    padding-bottom: 78rem !important;\n  }\n\n  .pb-md-158 {\n    padding-bottom: 78.5rem !important;\n  }\n\n  .pb-md-159 {\n    padding-bottom: 79rem !important;\n  }\n\n  .pb-md-160 {\n    padding-bottom: 79.5rem !important;\n  }\n\n  .ps-md-0 {\n    padding-left: 0rem !important;\n  }\n\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-md-5 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-md-6 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-md-7 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-md-8 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-md-9 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-md-10 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-md-11 {\n    padding-left: 5rem !important;\n  }\n\n  .ps-md-12 {\n    padding-left: 5.5rem !important;\n  }\n\n  .ps-md-13 {\n    padding-left: 6rem !important;\n  }\n\n  .ps-md-14 {\n    padding-left: 6.5rem !important;\n  }\n\n  .ps-md-15 {\n    padding-left: 7rem !important;\n  }\n\n  .ps-md-16 {\n    padding-left: 7.5rem !important;\n  }\n\n  .ps-md-17 {\n    padding-left: 8rem !important;\n  }\n\n  .ps-md-18 {\n    padding-left: 8.5rem !important;\n  }\n\n  .ps-md-19 {\n    padding-left: 9rem !important;\n  }\n\n  .ps-md-20 {\n    padding-left: 9.5rem !important;\n  }\n\n  .ps-md-21 {\n    padding-left: 10rem !important;\n  }\n\n  .ps-md-22 {\n    padding-left: 10.5rem !important;\n  }\n\n  .ps-md-23 {\n    padding-left: 11rem !important;\n  }\n\n  .ps-md-24 {\n    padding-left: 11.5rem !important;\n  }\n\n  .ps-md-25 {\n    padding-left: 12rem !important;\n  }\n\n  .ps-md-26 {\n    padding-left: 12.5rem !important;\n  }\n\n  .ps-md-27 {\n    padding-left: 13rem !important;\n  }\n\n  .ps-md-28 {\n    padding-left: 13.5rem !important;\n  }\n\n  .ps-md-29 {\n    padding-left: 14rem !important;\n  }\n\n  .ps-md-30 {\n    padding-left: 14.5rem !important;\n  }\n\n  .ps-md-31 {\n    padding-left: 15rem !important;\n  }\n\n  .ps-md-32 {\n    padding-left: 15.5rem !important;\n  }\n\n  .ps-md-33 {\n    padding-left: 16rem !important;\n  }\n\n  .ps-md-34 {\n    padding-left: 16.5rem !important;\n  }\n\n  .ps-md-35 {\n    padding-left: 17rem !important;\n  }\n\n  .ps-md-36 {\n    padding-left: 17.5rem !important;\n  }\n\n  .ps-md-37 {\n    padding-left: 18rem !important;\n  }\n\n  .ps-md-38 {\n    padding-left: 18.5rem !important;\n  }\n\n  .ps-md-39 {\n    padding-left: 19rem !important;\n  }\n\n  .ps-md-40 {\n    padding-left: 19.5rem !important;\n  }\n\n  .ps-md-41 {\n    padding-left: 20rem !important;\n  }\n\n  .ps-md-42 {\n    padding-left: 20.5rem !important;\n  }\n\n  .ps-md-43 {\n    padding-left: 21rem !important;\n  }\n\n  .ps-md-44 {\n    padding-left: 21.5rem !important;\n  }\n\n  .ps-md-45 {\n    padding-left: 22rem !important;\n  }\n\n  .ps-md-46 {\n    padding-left: 22.5rem !important;\n  }\n\n  .ps-md-47 {\n    padding-left: 23rem !important;\n  }\n\n  .ps-md-48 {\n    padding-left: 23.5rem !important;\n  }\n\n  .ps-md-49 {\n    padding-left: 24rem !important;\n  }\n\n  .ps-md-50 {\n    padding-left: 24.5rem !important;\n  }\n\n  .ps-md-51 {\n    padding-left: 25rem !important;\n  }\n\n  .ps-md-52 {\n    padding-left: 25.5rem !important;\n  }\n\n  .ps-md-53 {\n    padding-left: 26rem !important;\n  }\n\n  .ps-md-54 {\n    padding-left: 26.5rem !important;\n  }\n\n  .ps-md-55 {\n    padding-left: 27rem !important;\n  }\n\n  .ps-md-56 {\n    padding-left: 27.5rem !important;\n  }\n\n  .ps-md-57 {\n    padding-left: 28rem !important;\n  }\n\n  .ps-md-58 {\n    padding-left: 28.5rem !important;\n  }\n\n  .ps-md-59 {\n    padding-left: 29rem !important;\n  }\n\n  .ps-md-60 {\n    padding-left: 29.5rem !important;\n  }\n\n  .ps-md-61 {\n    padding-left: 30rem !important;\n  }\n\n  .ps-md-62 {\n    padding-left: 30.5rem !important;\n  }\n\n  .ps-md-63 {\n    padding-left: 31rem !important;\n  }\n\n  .ps-md-64 {\n    padding-left: 31.5rem !important;\n  }\n\n  .ps-md-65 {\n    padding-left: 32rem !important;\n  }\n\n  .ps-md-66 {\n    padding-left: 32.5rem !important;\n  }\n\n  .ps-md-67 {\n    padding-left: 33rem !important;\n  }\n\n  .ps-md-68 {\n    padding-left: 33.5rem !important;\n  }\n\n  .ps-md-69 {\n    padding-left: 34rem !important;\n  }\n\n  .ps-md-70 {\n    padding-left: 34.5rem !important;\n  }\n\n  .ps-md-71 {\n    padding-left: 35rem !important;\n  }\n\n  .ps-md-72 {\n    padding-left: 35.5rem !important;\n  }\n\n  .ps-md-73 {\n    padding-left: 36rem !important;\n  }\n\n  .ps-md-74 {\n    padding-left: 36.5rem !important;\n  }\n\n  .ps-md-75 {\n    padding-left: 37rem !important;\n  }\n\n  .ps-md-76 {\n    padding-left: 37.5rem !important;\n  }\n\n  .ps-md-77 {\n    padding-left: 38rem !important;\n  }\n\n  .ps-md-78 {\n    padding-left: 38.5rem !important;\n  }\n\n  .ps-md-79 {\n    padding-left: 39rem !important;\n  }\n\n  .ps-md-80 {\n    padding-left: 39.5rem !important;\n  }\n\n  .ps-md-81 {\n    padding-left: 40rem !important;\n  }\n\n  .ps-md-82 {\n    padding-left: 40.5rem !important;\n  }\n\n  .ps-md-83 {\n    padding-left: 41rem !important;\n  }\n\n  .ps-md-84 {\n    padding-left: 41.5rem !important;\n  }\n\n  .ps-md-85 {\n    padding-left: 42rem !important;\n  }\n\n  .ps-md-86 {\n    padding-left: 42.5rem !important;\n  }\n\n  .ps-md-87 {\n    padding-left: 43rem !important;\n  }\n\n  .ps-md-88 {\n    padding-left: 43.5rem !important;\n  }\n\n  .ps-md-89 {\n    padding-left: 44rem !important;\n  }\n\n  .ps-md-90 {\n    padding-left: 44.5rem !important;\n  }\n\n  .ps-md-91 {\n    padding-left: 45rem !important;\n  }\n\n  .ps-md-92 {\n    padding-left: 45.5rem !important;\n  }\n\n  .ps-md-93 {\n    padding-left: 46rem !important;\n  }\n\n  .ps-md-94 {\n    padding-left: 46.5rem !important;\n  }\n\n  .ps-md-95 {\n    padding-left: 47rem !important;\n  }\n\n  .ps-md-96 {\n    padding-left: 47.5rem !important;\n  }\n\n  .ps-md-97 {\n    padding-left: 48rem !important;\n  }\n\n  .ps-md-98 {\n    padding-left: 48.5rem !important;\n  }\n\n  .ps-md-99 {\n    padding-left: 49rem !important;\n  }\n\n  .ps-md-100 {\n    padding-left: 49.5rem !important;\n  }\n\n  .ps-md-101 {\n    padding-left: 50rem !important;\n  }\n\n  .ps-md-102 {\n    padding-left: 50.5rem !important;\n  }\n\n  .ps-md-103 {\n    padding-left: 51rem !important;\n  }\n\n  .ps-md-104 {\n    padding-left: 51.5rem !important;\n  }\n\n  .ps-md-105 {\n    padding-left: 52rem !important;\n  }\n\n  .ps-md-106 {\n    padding-left: 52.5rem !important;\n  }\n\n  .ps-md-107 {\n    padding-left: 53rem !important;\n  }\n\n  .ps-md-108 {\n    padding-left: 53.5rem !important;\n  }\n\n  .ps-md-109 {\n    padding-left: 54rem !important;\n  }\n\n  .ps-md-110 {\n    padding-left: 54.5rem !important;\n  }\n\n  .ps-md-111 {\n    padding-left: 55rem !important;\n  }\n\n  .ps-md-112 {\n    padding-left: 55.5rem !important;\n  }\n\n  .ps-md-113 {\n    padding-left: 56rem !important;\n  }\n\n  .ps-md-114 {\n    padding-left: 56.5rem !important;\n  }\n\n  .ps-md-115 {\n    padding-left: 57rem !important;\n  }\n\n  .ps-md-116 {\n    padding-left: 57.5rem !important;\n  }\n\n  .ps-md-117 {\n    padding-left: 58rem !important;\n  }\n\n  .ps-md-118 {\n    padding-left: 58.5rem !important;\n  }\n\n  .ps-md-119 {\n    padding-left: 59rem !important;\n  }\n\n  .ps-md-120 {\n    padding-left: 59.5rem !important;\n  }\n\n  .ps-md-121 {\n    padding-left: 60rem !important;\n  }\n\n  .ps-md-122 {\n    padding-left: 60.5rem !important;\n  }\n\n  .ps-md-123 {\n    padding-left: 61rem !important;\n  }\n\n  .ps-md-124 {\n    padding-left: 61.5rem !important;\n  }\n\n  .ps-md-125 {\n    padding-left: 62rem !important;\n  }\n\n  .ps-md-126 {\n    padding-left: 62.5rem !important;\n  }\n\n  .ps-md-127 {\n    padding-left: 63rem !important;\n  }\n\n  .ps-md-128 {\n    padding-left: 63.5rem !important;\n  }\n\n  .ps-md-129 {\n    padding-left: 64rem !important;\n  }\n\n  .ps-md-130 {\n    padding-left: 64.5rem !important;\n  }\n\n  .ps-md-131 {\n    padding-left: 65rem !important;\n  }\n\n  .ps-md-132 {\n    padding-left: 65.5rem !important;\n  }\n\n  .ps-md-133 {\n    padding-left: 66rem !important;\n  }\n\n  .ps-md-134 {\n    padding-left: 66.5rem !important;\n  }\n\n  .ps-md-135 {\n    padding-left: 67rem !important;\n  }\n\n  .ps-md-136 {\n    padding-left: 67.5rem !important;\n  }\n\n  .ps-md-137 {\n    padding-left: 68rem !important;\n  }\n\n  .ps-md-138 {\n    padding-left: 68.5rem !important;\n  }\n\n  .ps-md-139 {\n    padding-left: 69rem !important;\n  }\n\n  .ps-md-140 {\n    padding-left: 69.5rem !important;\n  }\n\n  .ps-md-141 {\n    padding-left: 70rem !important;\n  }\n\n  .ps-md-142 {\n    padding-left: 70.5rem !important;\n  }\n\n  .ps-md-143 {\n    padding-left: 71rem !important;\n  }\n\n  .ps-md-144 {\n    padding-left: 71.5rem !important;\n  }\n\n  .ps-md-145 {\n    padding-left: 72rem !important;\n  }\n\n  .ps-md-146 {\n    padding-left: 72.5rem !important;\n  }\n\n  .ps-md-147 {\n    padding-left: 73rem !important;\n  }\n\n  .ps-md-148 {\n    padding-left: 73.5rem !important;\n  }\n\n  .ps-md-149 {\n    padding-left: 74rem !important;\n  }\n\n  .ps-md-150 {\n    padding-left: 74.5rem !important;\n  }\n\n  .ps-md-151 {\n    padding-left: 75rem !important;\n  }\n\n  .ps-md-152 {\n    padding-left: 75.5rem !important;\n  }\n\n  .ps-md-153 {\n    padding-left: 76rem !important;\n  }\n\n  .ps-md-154 {\n    padding-left: 76.5rem !important;\n  }\n\n  .ps-md-155 {\n    padding-left: 77rem !important;\n  }\n\n  .ps-md-156 {\n    padding-left: 77.5rem !important;\n  }\n\n  .ps-md-157 {\n    padding-left: 78rem !important;\n  }\n\n  .ps-md-158 {\n    padding-left: 78.5rem !important;\n  }\n\n  .ps-md-159 {\n    padding-left: 79rem !important;\n  }\n\n  .ps-md-160 {\n    padding-left: 79.5rem !important;\n  }\n\n  .pe-md-0 {\n    padding-right: 0rem !important;\n  }\n\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-md-5 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-md-6 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-md-7 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-md-8 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-md-9 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-md-10 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-md-11 {\n    padding-right: 5rem !important;\n  }\n\n  .pe-md-12 {\n    padding-right: 5.5rem !important;\n  }\n\n  .pe-md-13 {\n    padding-right: 6rem !important;\n  }\n\n  .pe-md-14 {\n    padding-right: 6.5rem !important;\n  }\n\n  .pe-md-15 {\n    padding-right: 7rem !important;\n  }\n\n  .pe-md-16 {\n    padding-right: 7.5rem !important;\n  }\n\n  .pe-md-17 {\n    padding-right: 8rem !important;\n  }\n\n  .pe-md-18 {\n    padding-right: 8.5rem !important;\n  }\n\n  .pe-md-19 {\n    padding-right: 9rem !important;\n  }\n\n  .pe-md-20 {\n    padding-right: 9.5rem !important;\n  }\n\n  .pe-md-21 {\n    padding-right: 10rem !important;\n  }\n\n  .pe-md-22 {\n    padding-right: 10.5rem !important;\n  }\n\n  .pe-md-23 {\n    padding-right: 11rem !important;\n  }\n\n  .pe-md-24 {\n    padding-right: 11.5rem !important;\n  }\n\n  .pe-md-25 {\n    padding-right: 12rem !important;\n  }\n\n  .pe-md-26 {\n    padding-right: 12.5rem !important;\n  }\n\n  .pe-md-27 {\n    padding-right: 13rem !important;\n  }\n\n  .pe-md-28 {\n    padding-right: 13.5rem !important;\n  }\n\n  .pe-md-29 {\n    padding-right: 14rem !important;\n  }\n\n  .pe-md-30 {\n    padding-right: 14.5rem !important;\n  }\n\n  .pe-md-31 {\n    padding-right: 15rem !important;\n  }\n\n  .pe-md-32 {\n    padding-right: 15.5rem !important;\n  }\n\n  .pe-md-33 {\n    padding-right: 16rem !important;\n  }\n\n  .pe-md-34 {\n    padding-right: 16.5rem !important;\n  }\n\n  .pe-md-35 {\n    padding-right: 17rem !important;\n  }\n\n  .pe-md-36 {\n    padding-right: 17.5rem !important;\n  }\n\n  .pe-md-37 {\n    padding-right: 18rem !important;\n  }\n\n  .pe-md-38 {\n    padding-right: 18.5rem !important;\n  }\n\n  .pe-md-39 {\n    padding-right: 19rem !important;\n  }\n\n  .pe-md-40 {\n    padding-right: 19.5rem !important;\n  }\n\n  .pe-md-41 {\n    padding-right: 20rem !important;\n  }\n\n  .pe-md-42 {\n    padding-right: 20.5rem !important;\n  }\n\n  .pe-md-43 {\n    padding-right: 21rem !important;\n  }\n\n  .pe-md-44 {\n    padding-right: 21.5rem !important;\n  }\n\n  .pe-md-45 {\n    padding-right: 22rem !important;\n  }\n\n  .pe-md-46 {\n    padding-right: 22.5rem !important;\n  }\n\n  .pe-md-47 {\n    padding-right: 23rem !important;\n  }\n\n  .pe-md-48 {\n    padding-right: 23.5rem !important;\n  }\n\n  .pe-md-49 {\n    padding-right: 24rem !important;\n  }\n\n  .pe-md-50 {\n    padding-right: 24.5rem !important;\n  }\n\n  .pe-md-51 {\n    padding-right: 25rem !important;\n  }\n\n  .pe-md-52 {\n    padding-right: 25.5rem !important;\n  }\n\n  .pe-md-53 {\n    padding-right: 26rem !important;\n  }\n\n  .pe-md-54 {\n    padding-right: 26.5rem !important;\n  }\n\n  .pe-md-55 {\n    padding-right: 27rem !important;\n  }\n\n  .pe-md-56 {\n    padding-right: 27.5rem !important;\n  }\n\n  .pe-md-57 {\n    padding-right: 28rem !important;\n  }\n\n  .pe-md-58 {\n    padding-right: 28.5rem !important;\n  }\n\n  .pe-md-59 {\n    padding-right: 29rem !important;\n  }\n\n  .pe-md-60 {\n    padding-right: 29.5rem !important;\n  }\n\n  .pe-md-61 {\n    padding-right: 30rem !important;\n  }\n\n  .pe-md-62 {\n    padding-right: 30.5rem !important;\n  }\n\n  .pe-md-63 {\n    padding-right: 31rem !important;\n  }\n\n  .pe-md-64 {\n    padding-right: 31.5rem !important;\n  }\n\n  .pe-md-65 {\n    padding-right: 32rem !important;\n  }\n\n  .pe-md-66 {\n    padding-right: 32.5rem !important;\n  }\n\n  .pe-md-67 {\n    padding-right: 33rem !important;\n  }\n\n  .pe-md-68 {\n    padding-right: 33.5rem !important;\n  }\n\n  .pe-md-69 {\n    padding-right: 34rem !important;\n  }\n\n  .pe-md-70 {\n    padding-right: 34.5rem !important;\n  }\n\n  .pe-md-71 {\n    padding-right: 35rem !important;\n  }\n\n  .pe-md-72 {\n    padding-right: 35.5rem !important;\n  }\n\n  .pe-md-73 {\n    padding-right: 36rem !important;\n  }\n\n  .pe-md-74 {\n    padding-right: 36.5rem !important;\n  }\n\n  .pe-md-75 {\n    padding-right: 37rem !important;\n  }\n\n  .pe-md-76 {\n    padding-right: 37.5rem !important;\n  }\n\n  .pe-md-77 {\n    padding-right: 38rem !important;\n  }\n\n  .pe-md-78 {\n    padding-right: 38.5rem !important;\n  }\n\n  .pe-md-79 {\n    padding-right: 39rem !important;\n  }\n\n  .pe-md-80 {\n    padding-right: 39.5rem !important;\n  }\n\n  .pe-md-81 {\n    padding-right: 40rem !important;\n  }\n\n  .pe-md-82 {\n    padding-right: 40.5rem !important;\n  }\n\n  .pe-md-83 {\n    padding-right: 41rem !important;\n  }\n\n  .pe-md-84 {\n    padding-right: 41.5rem !important;\n  }\n\n  .pe-md-85 {\n    padding-right: 42rem !important;\n  }\n\n  .pe-md-86 {\n    padding-right: 42.5rem !important;\n  }\n\n  .pe-md-87 {\n    padding-right: 43rem !important;\n  }\n\n  .pe-md-88 {\n    padding-right: 43.5rem !important;\n  }\n\n  .pe-md-89 {\n    padding-right: 44rem !important;\n  }\n\n  .pe-md-90 {\n    padding-right: 44.5rem !important;\n  }\n\n  .pe-md-91 {\n    padding-right: 45rem !important;\n  }\n\n  .pe-md-92 {\n    padding-right: 45.5rem !important;\n  }\n\n  .pe-md-93 {\n    padding-right: 46rem !important;\n  }\n\n  .pe-md-94 {\n    padding-right: 46.5rem !important;\n  }\n\n  .pe-md-95 {\n    padding-right: 47rem !important;\n  }\n\n  .pe-md-96 {\n    padding-right: 47.5rem !important;\n  }\n\n  .pe-md-97 {\n    padding-right: 48rem !important;\n  }\n\n  .pe-md-98 {\n    padding-right: 48.5rem !important;\n  }\n\n  .pe-md-99 {\n    padding-right: 49rem !important;\n  }\n\n  .pe-md-100 {\n    padding-right: 49.5rem !important;\n  }\n\n  .pe-md-101 {\n    padding-right: 50rem !important;\n  }\n\n  .pe-md-102 {\n    padding-right: 50.5rem !important;\n  }\n\n  .pe-md-103 {\n    padding-right: 51rem !important;\n  }\n\n  .pe-md-104 {\n    padding-right: 51.5rem !important;\n  }\n\n  .pe-md-105 {\n    padding-right: 52rem !important;\n  }\n\n  .pe-md-106 {\n    padding-right: 52.5rem !important;\n  }\n\n  .pe-md-107 {\n    padding-right: 53rem !important;\n  }\n\n  .pe-md-108 {\n    padding-right: 53.5rem !important;\n  }\n\n  .pe-md-109 {\n    padding-right: 54rem !important;\n  }\n\n  .pe-md-110 {\n    padding-right: 54.5rem !important;\n  }\n\n  .pe-md-111 {\n    padding-right: 55rem !important;\n  }\n\n  .pe-md-112 {\n    padding-right: 55.5rem !important;\n  }\n\n  .pe-md-113 {\n    padding-right: 56rem !important;\n  }\n\n  .pe-md-114 {\n    padding-right: 56.5rem !important;\n  }\n\n  .pe-md-115 {\n    padding-right: 57rem !important;\n  }\n\n  .pe-md-116 {\n    padding-right: 57.5rem !important;\n  }\n\n  .pe-md-117 {\n    padding-right: 58rem !important;\n  }\n\n  .pe-md-118 {\n    padding-right: 58.5rem !important;\n  }\n\n  .pe-md-119 {\n    padding-right: 59rem !important;\n  }\n\n  .pe-md-120 {\n    padding-right: 59.5rem !important;\n  }\n\n  .pe-md-121 {\n    padding-right: 60rem !important;\n  }\n\n  .pe-md-122 {\n    padding-right: 60.5rem !important;\n  }\n\n  .pe-md-123 {\n    padding-right: 61rem !important;\n  }\n\n  .pe-md-124 {\n    padding-right: 61.5rem !important;\n  }\n\n  .pe-md-125 {\n    padding-right: 62rem !important;\n  }\n\n  .pe-md-126 {\n    padding-right: 62.5rem !important;\n  }\n\n  .pe-md-127 {\n    padding-right: 63rem !important;\n  }\n\n  .pe-md-128 {\n    padding-right: 63.5rem !important;\n  }\n\n  .pe-md-129 {\n    padding-right: 64rem !important;\n  }\n\n  .pe-md-130 {\n    padding-right: 64.5rem !important;\n  }\n\n  .pe-md-131 {\n    padding-right: 65rem !important;\n  }\n\n  .pe-md-132 {\n    padding-right: 65.5rem !important;\n  }\n\n  .pe-md-133 {\n    padding-right: 66rem !important;\n  }\n\n  .pe-md-134 {\n    padding-right: 66.5rem !important;\n  }\n\n  .pe-md-135 {\n    padding-right: 67rem !important;\n  }\n\n  .pe-md-136 {\n    padding-right: 67.5rem !important;\n  }\n\n  .pe-md-137 {\n    padding-right: 68rem !important;\n  }\n\n  .pe-md-138 {\n    padding-right: 68.5rem !important;\n  }\n\n  .pe-md-139 {\n    padding-right: 69rem !important;\n  }\n\n  .pe-md-140 {\n    padding-right: 69.5rem !important;\n  }\n\n  .pe-md-141 {\n    padding-right: 70rem !important;\n  }\n\n  .pe-md-142 {\n    padding-right: 70.5rem !important;\n  }\n\n  .pe-md-143 {\n    padding-right: 71rem !important;\n  }\n\n  .pe-md-144 {\n    padding-right: 71.5rem !important;\n  }\n\n  .pe-md-145 {\n    padding-right: 72rem !important;\n  }\n\n  .pe-md-146 {\n    padding-right: 72.5rem !important;\n  }\n\n  .pe-md-147 {\n    padding-right: 73rem !important;\n  }\n\n  .pe-md-148 {\n    padding-right: 73.5rem !important;\n  }\n\n  .pe-md-149 {\n    padding-right: 74rem !important;\n  }\n\n  .pe-md-150 {\n    padding-right: 74.5rem !important;\n  }\n\n  .pe-md-151 {\n    padding-right: 75rem !important;\n  }\n\n  .pe-md-152 {\n    padding-right: 75.5rem !important;\n  }\n\n  .pe-md-153 {\n    padding-right: 76rem !important;\n  }\n\n  .pe-md-154 {\n    padding-right: 76.5rem !important;\n  }\n\n  .pe-md-155 {\n    padding-right: 77rem !important;\n  }\n\n  .pe-md-156 {\n    padding-right: 77.5rem !important;\n  }\n\n  .pe-md-157 {\n    padding-right: 78rem !important;\n  }\n\n  .pe-md-158 {\n    padding-right: 78.5rem !important;\n  }\n\n  .pe-md-159 {\n    padding-right: 79rem !important;\n  }\n\n  .pe-md-160 {\n    padding-right: 79.5rem !important;\n  }\n\n  .px-md-0 {\n    padding-left: 0rem !important;\n    padding-right: 0rem !important;\n  }\n\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .px-md-3 {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .px-md-5 {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n\n  .px-md-6 {\n    padding-left: 2.5rem !important;\n    padding-right: 2.5rem !important;\n  }\n\n  .px-md-7 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n  }\n\n  .px-md-8 {\n    padding-left: 3.5rem !important;\n    padding-right: 3.5rem !important;\n  }\n\n  .px-md-9 {\n    padding-left: 4rem !important;\n    padding-right: 4rem !important;\n  }\n\n  .px-md-10 {\n    padding-left: 4.5rem !important;\n    padding-right: 4.5rem !important;\n  }\n\n  .px-md-11 {\n    padding-left: 5rem !important;\n    padding-right: 5rem !important;\n  }\n\n  .px-md-12 {\n    padding-left: 5.5rem !important;\n    padding-right: 5.5rem !important;\n  }\n\n  .px-md-13 {\n    padding-left: 6rem !important;\n    padding-right: 6rem !important;\n  }\n\n  .px-md-14 {\n    padding-left: 6.5rem !important;\n    padding-right: 6.5rem !important;\n  }\n\n  .px-md-15 {\n    padding-left: 7rem !important;\n    padding-right: 7rem !important;\n  }\n\n  .px-md-16 {\n    padding-left: 7.5rem !important;\n    padding-right: 7.5rem !important;\n  }\n\n  .px-md-17 {\n    padding-left: 8rem !important;\n    padding-right: 8rem !important;\n  }\n\n  .px-md-18 {\n    padding-left: 8.5rem !important;\n    padding-right: 8.5rem !important;\n  }\n\n  .px-md-19 {\n    padding-left: 9rem !important;\n    padding-right: 9rem !important;\n  }\n\n  .px-md-20 {\n    padding-left: 9.5rem !important;\n    padding-right: 9.5rem !important;\n  }\n\n  .px-md-21 {\n    padding-left: 10rem !important;\n    padding-right: 10rem !important;\n  }\n\n  .px-md-22 {\n    padding-left: 10.5rem !important;\n    padding-right: 10.5rem !important;\n  }\n\n  .px-md-23 {\n    padding-left: 11rem !important;\n    padding-right: 11rem !important;\n  }\n\n  .px-md-24 {\n    padding-left: 11.5rem !important;\n    padding-right: 11.5rem !important;\n  }\n\n  .px-md-25 {\n    padding-left: 12rem !important;\n    padding-right: 12rem !important;\n  }\n\n  .px-md-26 {\n    padding-left: 12.5rem !important;\n    padding-right: 12.5rem !important;\n  }\n\n  .px-md-27 {\n    padding-left: 13rem !important;\n    padding-right: 13rem !important;\n  }\n\n  .px-md-28 {\n    padding-left: 13.5rem !important;\n    padding-right: 13.5rem !important;\n  }\n\n  .px-md-29 {\n    padding-left: 14rem !important;\n    padding-right: 14rem !important;\n  }\n\n  .px-md-30 {\n    padding-left: 14.5rem !important;\n    padding-right: 14.5rem !important;\n  }\n\n  .px-md-31 {\n    padding-left: 15rem !important;\n    padding-right: 15rem !important;\n  }\n\n  .px-md-32 {\n    padding-left: 15.5rem !important;\n    padding-right: 15.5rem !important;\n  }\n\n  .px-md-33 {\n    padding-left: 16rem !important;\n    padding-right: 16rem !important;\n  }\n\n  .px-md-34 {\n    padding-left: 16.5rem !important;\n    padding-right: 16.5rem !important;\n  }\n\n  .px-md-35 {\n    padding-left: 17rem !important;\n    padding-right: 17rem !important;\n  }\n\n  .px-md-36 {\n    padding-left: 17.5rem !important;\n    padding-right: 17.5rem !important;\n  }\n\n  .px-md-37 {\n    padding-left: 18rem !important;\n    padding-right: 18rem !important;\n  }\n\n  .px-md-38 {\n    padding-left: 18.5rem !important;\n    padding-right: 18.5rem !important;\n  }\n\n  .px-md-39 {\n    padding-left: 19rem !important;\n    padding-right: 19rem !important;\n  }\n\n  .px-md-40 {\n    padding-left: 19.5rem !important;\n    padding-right: 19.5rem !important;\n  }\n\n  .px-md-41 {\n    padding-left: 20rem !important;\n    padding-right: 20rem !important;\n  }\n\n  .px-md-42 {\n    padding-left: 20.5rem !important;\n    padding-right: 20.5rem !important;\n  }\n\n  .px-md-43 {\n    padding-left: 21rem !important;\n    padding-right: 21rem !important;\n  }\n\n  .px-md-44 {\n    padding-left: 21.5rem !important;\n    padding-right: 21.5rem !important;\n  }\n\n  .px-md-45 {\n    padding-left: 22rem !important;\n    padding-right: 22rem !important;\n  }\n\n  .px-md-46 {\n    padding-left: 22.5rem !important;\n    padding-right: 22.5rem !important;\n  }\n\n  .px-md-47 {\n    padding-left: 23rem !important;\n    padding-right: 23rem !important;\n  }\n\n  .px-md-48 {\n    padding-left: 23.5rem !important;\n    padding-right: 23.5rem !important;\n  }\n\n  .px-md-49 {\n    padding-left: 24rem !important;\n    padding-right: 24rem !important;\n  }\n\n  .px-md-50 {\n    padding-left: 24.5rem !important;\n    padding-right: 24.5rem !important;\n  }\n\n  .px-md-51 {\n    padding-left: 25rem !important;\n    padding-right: 25rem !important;\n  }\n\n  .px-md-52 {\n    padding-left: 25.5rem !important;\n    padding-right: 25.5rem !important;\n  }\n\n  .px-md-53 {\n    padding-left: 26rem !important;\n    padding-right: 26rem !important;\n  }\n\n  .px-md-54 {\n    padding-left: 26.5rem !important;\n    padding-right: 26.5rem !important;\n  }\n\n  .px-md-55 {\n    padding-left: 27rem !important;\n    padding-right: 27rem !important;\n  }\n\n  .px-md-56 {\n    padding-left: 27.5rem !important;\n    padding-right: 27.5rem !important;\n  }\n\n  .px-md-57 {\n    padding-left: 28rem !important;\n    padding-right: 28rem !important;\n  }\n\n  .px-md-58 {\n    padding-left: 28.5rem !important;\n    padding-right: 28.5rem !important;\n  }\n\n  .px-md-59 {\n    padding-left: 29rem !important;\n    padding-right: 29rem !important;\n  }\n\n  .px-md-60 {\n    padding-left: 29.5rem !important;\n    padding-right: 29.5rem !important;\n  }\n\n  .px-md-61 {\n    padding-left: 30rem !important;\n    padding-right: 30rem !important;\n  }\n\n  .px-md-62 {\n    padding-left: 30.5rem !important;\n    padding-right: 30.5rem !important;\n  }\n\n  .px-md-63 {\n    padding-left: 31rem !important;\n    padding-right: 31rem !important;\n  }\n\n  .px-md-64 {\n    padding-left: 31.5rem !important;\n    padding-right: 31.5rem !important;\n  }\n\n  .px-md-65 {\n    padding-left: 32rem !important;\n    padding-right: 32rem !important;\n  }\n\n  .px-md-66 {\n    padding-left: 32.5rem !important;\n    padding-right: 32.5rem !important;\n  }\n\n  .px-md-67 {\n    padding-left: 33rem !important;\n    padding-right: 33rem !important;\n  }\n\n  .px-md-68 {\n    padding-left: 33.5rem !important;\n    padding-right: 33.5rem !important;\n  }\n\n  .px-md-69 {\n    padding-left: 34rem !important;\n    padding-right: 34rem !important;\n  }\n\n  .px-md-70 {\n    padding-left: 34.5rem !important;\n    padding-right: 34.5rem !important;\n  }\n\n  .px-md-71 {\n    padding-left: 35rem !important;\n    padding-right: 35rem !important;\n  }\n\n  .px-md-72 {\n    padding-left: 35.5rem !important;\n    padding-right: 35.5rem !important;\n  }\n\n  .px-md-73 {\n    padding-left: 36rem !important;\n    padding-right: 36rem !important;\n  }\n\n  .px-md-74 {\n    padding-left: 36.5rem !important;\n    padding-right: 36.5rem !important;\n  }\n\n  .px-md-75 {\n    padding-left: 37rem !important;\n    padding-right: 37rem !important;\n  }\n\n  .px-md-76 {\n    padding-left: 37.5rem !important;\n    padding-right: 37.5rem !important;\n  }\n\n  .px-md-77 {\n    padding-left: 38rem !important;\n    padding-right: 38rem !important;\n  }\n\n  .px-md-78 {\n    padding-left: 38.5rem !important;\n    padding-right: 38.5rem !important;\n  }\n\n  .px-md-79 {\n    padding-left: 39rem !important;\n    padding-right: 39rem !important;\n  }\n\n  .px-md-80 {\n    padding-left: 39.5rem !important;\n    padding-right: 39.5rem !important;\n  }\n\n  .px-md-81 {\n    padding-left: 40rem !important;\n    padding-right: 40rem !important;\n  }\n\n  .px-md-82 {\n    padding-left: 40.5rem !important;\n    padding-right: 40.5rem !important;\n  }\n\n  .px-md-83 {\n    padding-left: 41rem !important;\n    padding-right: 41rem !important;\n  }\n\n  .px-md-84 {\n    padding-left: 41.5rem !important;\n    padding-right: 41.5rem !important;\n  }\n\n  .px-md-85 {\n    padding-left: 42rem !important;\n    padding-right: 42rem !important;\n  }\n\n  .px-md-86 {\n    padding-left: 42.5rem !important;\n    padding-right: 42.5rem !important;\n  }\n\n  .px-md-87 {\n    padding-left: 43rem !important;\n    padding-right: 43rem !important;\n  }\n\n  .px-md-88 {\n    padding-left: 43.5rem !important;\n    padding-right: 43.5rem !important;\n  }\n\n  .px-md-89 {\n    padding-left: 44rem !important;\n    padding-right: 44rem !important;\n  }\n\n  .px-md-90 {\n    padding-left: 44.5rem !important;\n    padding-right: 44.5rem !important;\n  }\n\n  .px-md-91 {\n    padding-left: 45rem !important;\n    padding-right: 45rem !important;\n  }\n\n  .px-md-92 {\n    padding-left: 45.5rem !important;\n    padding-right: 45.5rem !important;\n  }\n\n  .px-md-93 {\n    padding-left: 46rem !important;\n    padding-right: 46rem !important;\n  }\n\n  .px-md-94 {\n    padding-left: 46.5rem !important;\n    padding-right: 46.5rem !important;\n  }\n\n  .px-md-95 {\n    padding-left: 47rem !important;\n    padding-right: 47rem !important;\n  }\n\n  .px-md-96 {\n    padding-left: 47.5rem !important;\n    padding-right: 47.5rem !important;\n  }\n\n  .px-md-97 {\n    padding-left: 48rem !important;\n    padding-right: 48rem !important;\n  }\n\n  .px-md-98 {\n    padding-left: 48.5rem !important;\n    padding-right: 48.5rem !important;\n  }\n\n  .px-md-99 {\n    padding-left: 49rem !important;\n    padding-right: 49rem !important;\n  }\n\n  .px-md-100 {\n    padding-left: 49.5rem !important;\n    padding-right: 49.5rem !important;\n  }\n\n  .px-md-101 {\n    padding-left: 50rem !important;\n    padding-right: 50rem !important;\n  }\n\n  .px-md-102 {\n    padding-left: 50.5rem !important;\n    padding-right: 50.5rem !important;\n  }\n\n  .px-md-103 {\n    padding-left: 51rem !important;\n    padding-right: 51rem !important;\n  }\n\n  .px-md-104 {\n    padding-left: 51.5rem !important;\n    padding-right: 51.5rem !important;\n  }\n\n  .px-md-105 {\n    padding-left: 52rem !important;\n    padding-right: 52rem !important;\n  }\n\n  .px-md-106 {\n    padding-left: 52.5rem !important;\n    padding-right: 52.5rem !important;\n  }\n\n  .px-md-107 {\n    padding-left: 53rem !important;\n    padding-right: 53rem !important;\n  }\n\n  .px-md-108 {\n    padding-left: 53.5rem !important;\n    padding-right: 53.5rem !important;\n  }\n\n  .px-md-109 {\n    padding-left: 54rem !important;\n    padding-right: 54rem !important;\n  }\n\n  .px-md-110 {\n    padding-left: 54.5rem !important;\n    padding-right: 54.5rem !important;\n  }\n\n  .px-md-111 {\n    padding-left: 55rem !important;\n    padding-right: 55rem !important;\n  }\n\n  .px-md-112 {\n    padding-left: 55.5rem !important;\n    padding-right: 55.5rem !important;\n  }\n\n  .px-md-113 {\n    padding-left: 56rem !important;\n    padding-right: 56rem !important;\n  }\n\n  .px-md-114 {\n    padding-left: 56.5rem !important;\n    padding-right: 56.5rem !important;\n  }\n\n  .px-md-115 {\n    padding-left: 57rem !important;\n    padding-right: 57rem !important;\n  }\n\n  .px-md-116 {\n    padding-left: 57.5rem !important;\n    padding-right: 57.5rem !important;\n  }\n\n  .px-md-117 {\n    padding-left: 58rem !important;\n    padding-right: 58rem !important;\n  }\n\n  .px-md-118 {\n    padding-left: 58.5rem !important;\n    padding-right: 58.5rem !important;\n  }\n\n  .px-md-119 {\n    padding-left: 59rem !important;\n    padding-right: 59rem !important;\n  }\n\n  .px-md-120 {\n    padding-left: 59.5rem !important;\n    padding-right: 59.5rem !important;\n  }\n\n  .px-md-121 {\n    padding-left: 60rem !important;\n    padding-right: 60rem !important;\n  }\n\n  .px-md-122 {\n    padding-left: 60.5rem !important;\n    padding-right: 60.5rem !important;\n  }\n\n  .px-md-123 {\n    padding-left: 61rem !important;\n    padding-right: 61rem !important;\n  }\n\n  .px-md-124 {\n    padding-left: 61.5rem !important;\n    padding-right: 61.5rem !important;\n  }\n\n  .px-md-125 {\n    padding-left: 62rem !important;\n    padding-right: 62rem !important;\n  }\n\n  .px-md-126 {\n    padding-left: 62.5rem !important;\n    padding-right: 62.5rem !important;\n  }\n\n  .px-md-127 {\n    padding-left: 63rem !important;\n    padding-right: 63rem !important;\n  }\n\n  .px-md-128 {\n    padding-left: 63.5rem !important;\n    padding-right: 63.5rem !important;\n  }\n\n  .px-md-129 {\n    padding-left: 64rem !important;\n    padding-right: 64rem !important;\n  }\n\n  .px-md-130 {\n    padding-left: 64.5rem !important;\n    padding-right: 64.5rem !important;\n  }\n\n  .px-md-131 {\n    padding-left: 65rem !important;\n    padding-right: 65rem !important;\n  }\n\n  .px-md-132 {\n    padding-left: 65.5rem !important;\n    padding-right: 65.5rem !important;\n  }\n\n  .px-md-133 {\n    padding-left: 66rem !important;\n    padding-right: 66rem !important;\n  }\n\n  .px-md-134 {\n    padding-left: 66.5rem !important;\n    padding-right: 66.5rem !important;\n  }\n\n  .px-md-135 {\n    padding-left: 67rem !important;\n    padding-right: 67rem !important;\n  }\n\n  .px-md-136 {\n    padding-left: 67.5rem !important;\n    padding-right: 67.5rem !important;\n  }\n\n  .px-md-137 {\n    padding-left: 68rem !important;\n    padding-right: 68rem !important;\n  }\n\n  .px-md-138 {\n    padding-left: 68.5rem !important;\n    padding-right: 68.5rem !important;\n  }\n\n  .px-md-139 {\n    padding-left: 69rem !important;\n    padding-right: 69rem !important;\n  }\n\n  .px-md-140 {\n    padding-left: 69.5rem !important;\n    padding-right: 69.5rem !important;\n  }\n\n  .px-md-141 {\n    padding-left: 70rem !important;\n    padding-right: 70rem !important;\n  }\n\n  .px-md-142 {\n    padding-left: 70.5rem !important;\n    padding-right: 70.5rem !important;\n  }\n\n  .px-md-143 {\n    padding-left: 71rem !important;\n    padding-right: 71rem !important;\n  }\n\n  .px-md-144 {\n    padding-left: 71.5rem !important;\n    padding-right: 71.5rem !important;\n  }\n\n  .px-md-145 {\n    padding-left: 72rem !important;\n    padding-right: 72rem !important;\n  }\n\n  .px-md-146 {\n    padding-left: 72.5rem !important;\n    padding-right: 72.5rem !important;\n  }\n\n  .px-md-147 {\n    padding-left: 73rem !important;\n    padding-right: 73rem !important;\n  }\n\n  .px-md-148 {\n    padding-left: 73.5rem !important;\n    padding-right: 73.5rem !important;\n  }\n\n  .px-md-149 {\n    padding-left: 74rem !important;\n    padding-right: 74rem !important;\n  }\n\n  .px-md-150 {\n    padding-left: 74.5rem !important;\n    padding-right: 74.5rem !important;\n  }\n\n  .px-md-151 {\n    padding-left: 75rem !important;\n    padding-right: 75rem !important;\n  }\n\n  .px-md-152 {\n    padding-left: 75.5rem !important;\n    padding-right: 75.5rem !important;\n  }\n\n  .px-md-153 {\n    padding-left: 76rem !important;\n    padding-right: 76rem !important;\n  }\n\n  .px-md-154 {\n    padding-left: 76.5rem !important;\n    padding-right: 76.5rem !important;\n  }\n\n  .px-md-155 {\n    padding-left: 77rem !important;\n    padding-right: 77rem !important;\n  }\n\n  .px-md-156 {\n    padding-left: 77.5rem !important;\n    padding-right: 77.5rem !important;\n  }\n\n  .px-md-157 {\n    padding-left: 78rem !important;\n    padding-right: 78rem !important;\n  }\n\n  .px-md-158 {\n    padding-left: 78.5rem !important;\n    padding-right: 78.5rem !important;\n  }\n\n  .px-md-159 {\n    padding-left: 79rem !important;\n    padding-right: 79rem !important;\n  }\n\n  .px-md-160 {\n    padding-left: 79.5rem !important;\n    padding-right: 79.5rem !important;\n  }\n\n  .py-md-0 {\n    padding-top: 0rem !important;\n    padding-bottom: 0rem !important;\n  }\n\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-md-5 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-md-6 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-md-7 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-md-8 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-md-9 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-md-10 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-md-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .py-md-12 {\n    padding-top: 5.5rem !important;\n    padding-bottom: 5.5rem !important;\n  }\n\n  .py-md-13 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n\n  .py-md-14 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n\n  .py-md-15 {\n    padding-top: 7rem !important;\n    padding-bottom: 7rem !important;\n  }\n\n  .py-md-16 {\n    padding-top: 7.5rem !important;\n    padding-bottom: 7.5rem !important;\n  }\n\n  .py-md-17 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n\n  .py-md-18 {\n    padding-top: 8.5rem !important;\n    padding-bottom: 8.5rem !important;\n  }\n\n  .py-md-19 {\n    padding-top: 9rem !important;\n    padding-bottom: 9rem !important;\n  }\n\n  .py-md-20 {\n    padding-top: 9.5rem !important;\n    padding-bottom: 9.5rem !important;\n  }\n\n  .py-md-21 {\n    padding-top: 10rem !important;\n    padding-bottom: 10rem !important;\n  }\n\n  .py-md-22 {\n    padding-top: 10.5rem !important;\n    padding-bottom: 10.5rem !important;\n  }\n\n  .py-md-23 {\n    padding-top: 11rem !important;\n    padding-bottom: 11rem !important;\n  }\n\n  .py-md-24 {\n    padding-top: 11.5rem !important;\n    padding-bottom: 11.5rem !important;\n  }\n\n  .py-md-25 {\n    padding-top: 12rem !important;\n    padding-bottom: 12rem !important;\n  }\n\n  .py-md-26 {\n    padding-top: 12.5rem !important;\n    padding-bottom: 12.5rem !important;\n  }\n\n  .py-md-27 {\n    padding-top: 13rem !important;\n    padding-bottom: 13rem !important;\n  }\n\n  .py-md-28 {\n    padding-top: 13.5rem !important;\n    padding-bottom: 13.5rem !important;\n  }\n\n  .py-md-29 {\n    padding-top: 14rem !important;\n    padding-bottom: 14rem !important;\n  }\n\n  .py-md-30 {\n    padding-top: 14.5rem !important;\n    padding-bottom: 14.5rem !important;\n  }\n\n  .py-md-31 {\n    padding-top: 15rem !important;\n    padding-bottom: 15rem !important;\n  }\n\n  .py-md-32 {\n    padding-top: 15.5rem !important;\n    padding-bottom: 15.5rem !important;\n  }\n\n  .py-md-33 {\n    padding-top: 16rem !important;\n    padding-bottom: 16rem !important;\n  }\n\n  .py-md-34 {\n    padding-top: 16.5rem !important;\n    padding-bottom: 16.5rem !important;\n  }\n\n  .py-md-35 {\n    padding-top: 17rem !important;\n    padding-bottom: 17rem !important;\n  }\n\n  .py-md-36 {\n    padding-top: 17.5rem !important;\n    padding-bottom: 17.5rem !important;\n  }\n\n  .py-md-37 {\n    padding-top: 18rem !important;\n    padding-bottom: 18rem !important;\n  }\n\n  .py-md-38 {\n    padding-top: 18.5rem !important;\n    padding-bottom: 18.5rem !important;\n  }\n\n  .py-md-39 {\n    padding-top: 19rem !important;\n    padding-bottom: 19rem !important;\n  }\n\n  .py-md-40 {\n    padding-top: 19.5rem !important;\n    padding-bottom: 19.5rem !important;\n  }\n\n  .py-md-41 {\n    padding-top: 20rem !important;\n    padding-bottom: 20rem !important;\n  }\n\n  .py-md-42 {\n    padding-top: 20.5rem !important;\n    padding-bottom: 20.5rem !important;\n  }\n\n  .py-md-43 {\n    padding-top: 21rem !important;\n    padding-bottom: 21rem !important;\n  }\n\n  .py-md-44 {\n    padding-top: 21.5rem !important;\n    padding-bottom: 21.5rem !important;\n  }\n\n  .py-md-45 {\n    padding-top: 22rem !important;\n    padding-bottom: 22rem !important;\n  }\n\n  .py-md-46 {\n    padding-top: 22.5rem !important;\n    padding-bottom: 22.5rem !important;\n  }\n\n  .py-md-47 {\n    padding-top: 23rem !important;\n    padding-bottom: 23rem !important;\n  }\n\n  .py-md-48 {\n    padding-top: 23.5rem !important;\n    padding-bottom: 23.5rem !important;\n  }\n\n  .py-md-49 {\n    padding-top: 24rem !important;\n    padding-bottom: 24rem !important;\n  }\n\n  .py-md-50 {\n    padding-top: 24.5rem !important;\n    padding-bottom: 24.5rem !important;\n  }\n\n  .py-md-51 {\n    padding-top: 25rem !important;\n    padding-bottom: 25rem !important;\n  }\n\n  .py-md-52 {\n    padding-top: 25.5rem !important;\n    padding-bottom: 25.5rem !important;\n  }\n\n  .py-md-53 {\n    padding-top: 26rem !important;\n    padding-bottom: 26rem !important;\n  }\n\n  .py-md-54 {\n    padding-top: 26.5rem !important;\n    padding-bottom: 26.5rem !important;\n  }\n\n  .py-md-55 {\n    padding-top: 27rem !important;\n    padding-bottom: 27rem !important;\n  }\n\n  .py-md-56 {\n    padding-top: 27.5rem !important;\n    padding-bottom: 27.5rem !important;\n  }\n\n  .py-md-57 {\n    padding-top: 28rem !important;\n    padding-bottom: 28rem !important;\n  }\n\n  .py-md-58 {\n    padding-top: 28.5rem !important;\n    padding-bottom: 28.5rem !important;\n  }\n\n  .py-md-59 {\n    padding-top: 29rem !important;\n    padding-bottom: 29rem !important;\n  }\n\n  .py-md-60 {\n    padding-top: 29.5rem !important;\n    padding-bottom: 29.5rem !important;\n  }\n\n  .py-md-61 {\n    padding-top: 30rem !important;\n    padding-bottom: 30rem !important;\n  }\n\n  .py-md-62 {\n    padding-top: 30.5rem !important;\n    padding-bottom: 30.5rem !important;\n  }\n\n  .py-md-63 {\n    padding-top: 31rem !important;\n    padding-bottom: 31rem !important;\n  }\n\n  .py-md-64 {\n    padding-top: 31.5rem !important;\n    padding-bottom: 31.5rem !important;\n  }\n\n  .py-md-65 {\n    padding-top: 32rem !important;\n    padding-bottom: 32rem !important;\n  }\n\n  .py-md-66 {\n    padding-top: 32.5rem !important;\n    padding-bottom: 32.5rem !important;\n  }\n\n  .py-md-67 {\n    padding-top: 33rem !important;\n    padding-bottom: 33rem !important;\n  }\n\n  .py-md-68 {\n    padding-top: 33.5rem !important;\n    padding-bottom: 33.5rem !important;\n  }\n\n  .py-md-69 {\n    padding-top: 34rem !important;\n    padding-bottom: 34rem !important;\n  }\n\n  .py-md-70 {\n    padding-top: 34.5rem !important;\n    padding-bottom: 34.5rem !important;\n  }\n\n  .py-md-71 {\n    padding-top: 35rem !important;\n    padding-bottom: 35rem !important;\n  }\n\n  .py-md-72 {\n    padding-top: 35.5rem !important;\n    padding-bottom: 35.5rem !important;\n  }\n\n  .py-md-73 {\n    padding-top: 36rem !important;\n    padding-bottom: 36rem !important;\n  }\n\n  .py-md-74 {\n    padding-top: 36.5rem !important;\n    padding-bottom: 36.5rem !important;\n  }\n\n  .py-md-75 {\n    padding-top: 37rem !important;\n    padding-bottom: 37rem !important;\n  }\n\n  .py-md-76 {\n    padding-top: 37.5rem !important;\n    padding-bottom: 37.5rem !important;\n  }\n\n  .py-md-77 {\n    padding-top: 38rem !important;\n    padding-bottom: 38rem !important;\n  }\n\n  .py-md-78 {\n    padding-top: 38.5rem !important;\n    padding-bottom: 38.5rem !important;\n  }\n\n  .py-md-79 {\n    padding-top: 39rem !important;\n    padding-bottom: 39rem !important;\n  }\n\n  .py-md-80 {\n    padding-top: 39.5rem !important;\n    padding-bottom: 39.5rem !important;\n  }\n\n  .py-md-81 {\n    padding-top: 40rem !important;\n    padding-bottom: 40rem !important;\n  }\n\n  .py-md-82 {\n    padding-top: 40.5rem !important;\n    padding-bottom: 40.5rem !important;\n  }\n\n  .py-md-83 {\n    padding-top: 41rem !important;\n    padding-bottom: 41rem !important;\n  }\n\n  .py-md-84 {\n    padding-top: 41.5rem !important;\n    padding-bottom: 41.5rem !important;\n  }\n\n  .py-md-85 {\n    padding-top: 42rem !important;\n    padding-bottom: 42rem !important;\n  }\n\n  .py-md-86 {\n    padding-top: 42.5rem !important;\n    padding-bottom: 42.5rem !important;\n  }\n\n  .py-md-87 {\n    padding-top: 43rem !important;\n    padding-bottom: 43rem !important;\n  }\n\n  .py-md-88 {\n    padding-top: 43.5rem !important;\n    padding-bottom: 43.5rem !important;\n  }\n\n  .py-md-89 {\n    padding-top: 44rem !important;\n    padding-bottom: 44rem !important;\n  }\n\n  .py-md-90 {\n    padding-top: 44.5rem !important;\n    padding-bottom: 44.5rem !important;\n  }\n\n  .py-md-91 {\n    padding-top: 45rem !important;\n    padding-bottom: 45rem !important;\n  }\n\n  .py-md-92 {\n    padding-top: 45.5rem !important;\n    padding-bottom: 45.5rem !important;\n  }\n\n  .py-md-93 {\n    padding-top: 46rem !important;\n    padding-bottom: 46rem !important;\n  }\n\n  .py-md-94 {\n    padding-top: 46.5rem !important;\n    padding-bottom: 46.5rem !important;\n  }\n\n  .py-md-95 {\n    padding-top: 47rem !important;\n    padding-bottom: 47rem !important;\n  }\n\n  .py-md-96 {\n    padding-top: 47.5rem !important;\n    padding-bottom: 47.5rem !important;\n  }\n\n  .py-md-97 {\n    padding-top: 48rem !important;\n    padding-bottom: 48rem !important;\n  }\n\n  .py-md-98 {\n    padding-top: 48.5rem !important;\n    padding-bottom: 48.5rem !important;\n  }\n\n  .py-md-99 {\n    padding-top: 49rem !important;\n    padding-bottom: 49rem !important;\n  }\n\n  .py-md-100 {\n    padding-top: 49.5rem !important;\n    padding-bottom: 49.5rem !important;\n  }\n\n  .py-md-101 {\n    padding-top: 50rem !important;\n    padding-bottom: 50rem !important;\n  }\n\n  .py-md-102 {\n    padding-top: 50.5rem !important;\n    padding-bottom: 50.5rem !important;\n  }\n\n  .py-md-103 {\n    padding-top: 51rem !important;\n    padding-bottom: 51rem !important;\n  }\n\n  .py-md-104 {\n    padding-top: 51.5rem !important;\n    padding-bottom: 51.5rem !important;\n  }\n\n  .py-md-105 {\n    padding-top: 52rem !important;\n    padding-bottom: 52rem !important;\n  }\n\n  .py-md-106 {\n    padding-top: 52.5rem !important;\n    padding-bottom: 52.5rem !important;\n  }\n\n  .py-md-107 {\n    padding-top: 53rem !important;\n    padding-bottom: 53rem !important;\n  }\n\n  .py-md-108 {\n    padding-top: 53.5rem !important;\n    padding-bottom: 53.5rem !important;\n  }\n\n  .py-md-109 {\n    padding-top: 54rem !important;\n    padding-bottom: 54rem !important;\n  }\n\n  .py-md-110 {\n    padding-top: 54.5rem !important;\n    padding-bottom: 54.5rem !important;\n  }\n\n  .py-md-111 {\n    padding-top: 55rem !important;\n    padding-bottom: 55rem !important;\n  }\n\n  .py-md-112 {\n    padding-top: 55.5rem !important;\n    padding-bottom: 55.5rem !important;\n  }\n\n  .py-md-113 {\n    padding-top: 56rem !important;\n    padding-bottom: 56rem !important;\n  }\n\n  .py-md-114 {\n    padding-top: 56.5rem !important;\n    padding-bottom: 56.5rem !important;\n  }\n\n  .py-md-115 {\n    padding-top: 57rem !important;\n    padding-bottom: 57rem !important;\n  }\n\n  .py-md-116 {\n    padding-top: 57.5rem !important;\n    padding-bottom: 57.5rem !important;\n  }\n\n  .py-md-117 {\n    padding-top: 58rem !important;\n    padding-bottom: 58rem !important;\n  }\n\n  .py-md-118 {\n    padding-top: 58.5rem !important;\n    padding-bottom: 58.5rem !important;\n  }\n\n  .py-md-119 {\n    padding-top: 59rem !important;\n    padding-bottom: 59rem !important;\n  }\n\n  .py-md-120 {\n    padding-top: 59.5rem !important;\n    padding-bottom: 59.5rem !important;\n  }\n\n  .py-md-121 {\n    padding-top: 60rem !important;\n    padding-bottom: 60rem !important;\n  }\n\n  .py-md-122 {\n    padding-top: 60.5rem !important;\n    padding-bottom: 60.5rem !important;\n  }\n\n  .py-md-123 {\n    padding-top: 61rem !important;\n    padding-bottom: 61rem !important;\n  }\n\n  .py-md-124 {\n    padding-top: 61.5rem !important;\n    padding-bottom: 61.5rem !important;\n  }\n\n  .py-md-125 {\n    padding-top: 62rem !important;\n    padding-bottom: 62rem !important;\n  }\n\n  .py-md-126 {\n    padding-top: 62.5rem !important;\n    padding-bottom: 62.5rem !important;\n  }\n\n  .py-md-127 {\n    padding-top: 63rem !important;\n    padding-bottom: 63rem !important;\n  }\n\n  .py-md-128 {\n    padding-top: 63.5rem !important;\n    padding-bottom: 63.5rem !important;\n  }\n\n  .py-md-129 {\n    padding-top: 64rem !important;\n    padding-bottom: 64rem !important;\n  }\n\n  .py-md-130 {\n    padding-top: 64.5rem !important;\n    padding-bottom: 64.5rem !important;\n  }\n\n  .py-md-131 {\n    padding-top: 65rem !important;\n    padding-bottom: 65rem !important;\n  }\n\n  .py-md-132 {\n    padding-top: 65.5rem !important;\n    padding-bottom: 65.5rem !important;\n  }\n\n  .py-md-133 {\n    padding-top: 66rem !important;\n    padding-bottom: 66rem !important;\n  }\n\n  .py-md-134 {\n    padding-top: 66.5rem !important;\n    padding-bottom: 66.5rem !important;\n  }\n\n  .py-md-135 {\n    padding-top: 67rem !important;\n    padding-bottom: 67rem !important;\n  }\n\n  .py-md-136 {\n    padding-top: 67.5rem !important;\n    padding-bottom: 67.5rem !important;\n  }\n\n  .py-md-137 {\n    padding-top: 68rem !important;\n    padding-bottom: 68rem !important;\n  }\n\n  .py-md-138 {\n    padding-top: 68.5rem !important;\n    padding-bottom: 68.5rem !important;\n  }\n\n  .py-md-139 {\n    padding-top: 69rem !important;\n    padding-bottom: 69rem !important;\n  }\n\n  .py-md-140 {\n    padding-top: 69.5rem !important;\n    padding-bottom: 69.5rem !important;\n  }\n\n  .py-md-141 {\n    padding-top: 70rem !important;\n    padding-bottom: 70rem !important;\n  }\n\n  .py-md-142 {\n    padding-top: 70.5rem !important;\n    padding-bottom: 70.5rem !important;\n  }\n\n  .py-md-143 {\n    padding-top: 71rem !important;\n    padding-bottom: 71rem !important;\n  }\n\n  .py-md-144 {\n    padding-top: 71.5rem !important;\n    padding-bottom: 71.5rem !important;\n  }\n\n  .py-md-145 {\n    padding-top: 72rem !important;\n    padding-bottom: 72rem !important;\n  }\n\n  .py-md-146 {\n    padding-top: 72.5rem !important;\n    padding-bottom: 72.5rem !important;\n  }\n\n  .py-md-147 {\n    padding-top: 73rem !important;\n    padding-bottom: 73rem !important;\n  }\n\n  .py-md-148 {\n    padding-top: 73.5rem !important;\n    padding-bottom: 73.5rem !important;\n  }\n\n  .py-md-149 {\n    padding-top: 74rem !important;\n    padding-bottom: 74rem !important;\n  }\n\n  .py-md-150 {\n    padding-top: 74.5rem !important;\n    padding-bottom: 74.5rem !important;\n  }\n\n  .py-md-151 {\n    padding-top: 75rem !important;\n    padding-bottom: 75rem !important;\n  }\n\n  .py-md-152 {\n    padding-top: 75.5rem !important;\n    padding-bottom: 75.5rem !important;\n  }\n\n  .py-md-153 {\n    padding-top: 76rem !important;\n    padding-bottom: 76rem !important;\n  }\n\n  .py-md-154 {\n    padding-top: 76.5rem !important;\n    padding-bottom: 76.5rem !important;\n  }\n\n  .py-md-155 {\n    padding-top: 77rem !important;\n    padding-bottom: 77rem !important;\n  }\n\n  .py-md-156 {\n    padding-top: 77.5rem !important;\n    padding-bottom: 77.5rem !important;\n  }\n\n  .py-md-157 {\n    padding-top: 78rem !important;\n    padding-bottom: 78rem !important;\n  }\n\n  .py-md-158 {\n    padding-top: 78.5rem !important;\n    padding-bottom: 78.5rem !important;\n  }\n\n  .py-md-159 {\n    padding-top: 79rem !important;\n    padding-bottom: 79rem !important;\n  }\n\n  .py-md-160 {\n    padding-top: 79.5rem !important;\n    padding-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .p-lg-0 {\n    padding: 0rem !important;\n  }\n\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-lg-5 {\n    padding: 2rem !important;\n  }\n\n  .p-lg-6 {\n    padding: 2.5rem !important;\n  }\n\n  .p-lg-7 {\n    padding: 3rem !important;\n  }\n\n  .p-lg-8 {\n    padding: 3.5rem !important;\n  }\n\n  .p-lg-9 {\n    padding: 4rem !important;\n  }\n\n  .p-lg-10 {\n    padding: 4.5rem !important;\n  }\n\n  .p-lg-11 {\n    padding: 5rem !important;\n  }\n\n  .p-lg-12 {\n    padding: 5.5rem !important;\n  }\n\n  .p-lg-13 {\n    padding: 6rem !important;\n  }\n\n  .p-lg-14 {\n    padding: 6.5rem !important;\n  }\n\n  .p-lg-15 {\n    padding: 7rem !important;\n  }\n\n  .p-lg-16 {\n    padding: 7.5rem !important;\n  }\n\n  .p-lg-17 {\n    padding: 8rem !important;\n  }\n\n  .p-lg-18 {\n    padding: 8.5rem !important;\n  }\n\n  .p-lg-19 {\n    padding: 9rem !important;\n  }\n\n  .p-lg-20 {\n    padding: 9.5rem !important;\n  }\n\n  .p-lg-21 {\n    padding: 10rem !important;\n  }\n\n  .p-lg-22 {\n    padding: 10.5rem !important;\n  }\n\n  .p-lg-23 {\n    padding: 11rem !important;\n  }\n\n  .p-lg-24 {\n    padding: 11.5rem !important;\n  }\n\n  .p-lg-25 {\n    padding: 12rem !important;\n  }\n\n  .p-lg-26 {\n    padding: 12.5rem !important;\n  }\n\n  .p-lg-27 {\n    padding: 13rem !important;\n  }\n\n  .p-lg-28 {\n    padding: 13.5rem !important;\n  }\n\n  .p-lg-29 {\n    padding: 14rem !important;\n  }\n\n  .p-lg-30 {\n    padding: 14.5rem !important;\n  }\n\n  .p-lg-31 {\n    padding: 15rem !important;\n  }\n\n  .p-lg-32 {\n    padding: 15.5rem !important;\n  }\n\n  .p-lg-33 {\n    padding: 16rem !important;\n  }\n\n  .p-lg-34 {\n    padding: 16.5rem !important;\n  }\n\n  .p-lg-35 {\n    padding: 17rem !important;\n  }\n\n  .p-lg-36 {\n    padding: 17.5rem !important;\n  }\n\n  .p-lg-37 {\n    padding: 18rem !important;\n  }\n\n  .p-lg-38 {\n    padding: 18.5rem !important;\n  }\n\n  .p-lg-39 {\n    padding: 19rem !important;\n  }\n\n  .p-lg-40 {\n    padding: 19.5rem !important;\n  }\n\n  .p-lg-41 {\n    padding: 20rem !important;\n  }\n\n  .p-lg-42 {\n    padding: 20.5rem !important;\n  }\n\n  .p-lg-43 {\n    padding: 21rem !important;\n  }\n\n  .p-lg-44 {\n    padding: 21.5rem !important;\n  }\n\n  .p-lg-45 {\n    padding: 22rem !important;\n  }\n\n  .p-lg-46 {\n    padding: 22.5rem !important;\n  }\n\n  .p-lg-47 {\n    padding: 23rem !important;\n  }\n\n  .p-lg-48 {\n    padding: 23.5rem !important;\n  }\n\n  .p-lg-49 {\n    padding: 24rem !important;\n  }\n\n  .p-lg-50 {\n    padding: 24.5rem !important;\n  }\n\n  .p-lg-51 {\n    padding: 25rem !important;\n  }\n\n  .p-lg-52 {\n    padding: 25.5rem !important;\n  }\n\n  .p-lg-53 {\n    padding: 26rem !important;\n  }\n\n  .p-lg-54 {\n    padding: 26.5rem !important;\n  }\n\n  .p-lg-55 {\n    padding: 27rem !important;\n  }\n\n  .p-lg-56 {\n    padding: 27.5rem !important;\n  }\n\n  .p-lg-57 {\n    padding: 28rem !important;\n  }\n\n  .p-lg-58 {\n    padding: 28.5rem !important;\n  }\n\n  .p-lg-59 {\n    padding: 29rem !important;\n  }\n\n  .p-lg-60 {\n    padding: 29.5rem !important;\n  }\n\n  .p-lg-61 {\n    padding: 30rem !important;\n  }\n\n  .p-lg-62 {\n    padding: 30.5rem !important;\n  }\n\n  .p-lg-63 {\n    padding: 31rem !important;\n  }\n\n  .p-lg-64 {\n    padding: 31.5rem !important;\n  }\n\n  .p-lg-65 {\n    padding: 32rem !important;\n  }\n\n  .p-lg-66 {\n    padding: 32.5rem !important;\n  }\n\n  .p-lg-67 {\n    padding: 33rem !important;\n  }\n\n  .p-lg-68 {\n    padding: 33.5rem !important;\n  }\n\n  .p-lg-69 {\n    padding: 34rem !important;\n  }\n\n  .p-lg-70 {\n    padding: 34.5rem !important;\n  }\n\n  .p-lg-71 {\n    padding: 35rem !important;\n  }\n\n  .p-lg-72 {\n    padding: 35.5rem !important;\n  }\n\n  .p-lg-73 {\n    padding: 36rem !important;\n  }\n\n  .p-lg-74 {\n    padding: 36.5rem !important;\n  }\n\n  .p-lg-75 {\n    padding: 37rem !important;\n  }\n\n  .p-lg-76 {\n    padding: 37.5rem !important;\n  }\n\n  .p-lg-77 {\n    padding: 38rem !important;\n  }\n\n  .p-lg-78 {\n    padding: 38.5rem !important;\n  }\n\n  .p-lg-79 {\n    padding: 39rem !important;\n  }\n\n  .p-lg-80 {\n    padding: 39.5rem !important;\n  }\n\n  .p-lg-81 {\n    padding: 40rem !important;\n  }\n\n  .p-lg-82 {\n    padding: 40.5rem !important;\n  }\n\n  .p-lg-83 {\n    padding: 41rem !important;\n  }\n\n  .p-lg-84 {\n    padding: 41.5rem !important;\n  }\n\n  .p-lg-85 {\n    padding: 42rem !important;\n  }\n\n  .p-lg-86 {\n    padding: 42.5rem !important;\n  }\n\n  .p-lg-87 {\n    padding: 43rem !important;\n  }\n\n  .p-lg-88 {\n    padding: 43.5rem !important;\n  }\n\n  .p-lg-89 {\n    padding: 44rem !important;\n  }\n\n  .p-lg-90 {\n    padding: 44.5rem !important;\n  }\n\n  .p-lg-91 {\n    padding: 45rem !important;\n  }\n\n  .p-lg-92 {\n    padding: 45.5rem !important;\n  }\n\n  .p-lg-93 {\n    padding: 46rem !important;\n  }\n\n  .p-lg-94 {\n    padding: 46.5rem !important;\n  }\n\n  .p-lg-95 {\n    padding: 47rem !important;\n  }\n\n  .p-lg-96 {\n    padding: 47.5rem !important;\n  }\n\n  .p-lg-97 {\n    padding: 48rem !important;\n  }\n\n  .p-lg-98 {\n    padding: 48.5rem !important;\n  }\n\n  .p-lg-99 {\n    padding: 49rem !important;\n  }\n\n  .p-lg-100 {\n    padding: 49.5rem !important;\n  }\n\n  .p-lg-101 {\n    padding: 50rem !important;\n  }\n\n  .p-lg-102 {\n    padding: 50.5rem !important;\n  }\n\n  .p-lg-103 {\n    padding: 51rem !important;\n  }\n\n  .p-lg-104 {\n    padding: 51.5rem !important;\n  }\n\n  .p-lg-105 {\n    padding: 52rem !important;\n  }\n\n  .p-lg-106 {\n    padding: 52.5rem !important;\n  }\n\n  .p-lg-107 {\n    padding: 53rem !important;\n  }\n\n  .p-lg-108 {\n    padding: 53.5rem !important;\n  }\n\n  .p-lg-109 {\n    padding: 54rem !important;\n  }\n\n  .p-lg-110 {\n    padding: 54.5rem !important;\n  }\n\n  .p-lg-111 {\n    padding: 55rem !important;\n  }\n\n  .p-lg-112 {\n    padding: 55.5rem !important;\n  }\n\n  .p-lg-113 {\n    padding: 56rem !important;\n  }\n\n  .p-lg-114 {\n    padding: 56.5rem !important;\n  }\n\n  .p-lg-115 {\n    padding: 57rem !important;\n  }\n\n  .p-lg-116 {\n    padding: 57.5rem !important;\n  }\n\n  .p-lg-117 {\n    padding: 58rem !important;\n  }\n\n  .p-lg-118 {\n    padding: 58.5rem !important;\n  }\n\n  .p-lg-119 {\n    padding: 59rem !important;\n  }\n\n  .p-lg-120 {\n    padding: 59.5rem !important;\n  }\n\n  .p-lg-121 {\n    padding: 60rem !important;\n  }\n\n  .p-lg-122 {\n    padding: 60.5rem !important;\n  }\n\n  .p-lg-123 {\n    padding: 61rem !important;\n  }\n\n  .p-lg-124 {\n    padding: 61.5rem !important;\n  }\n\n  .p-lg-125 {\n    padding: 62rem !important;\n  }\n\n  .p-lg-126 {\n    padding: 62.5rem !important;\n  }\n\n  .p-lg-127 {\n    padding: 63rem !important;\n  }\n\n  .p-lg-128 {\n    padding: 63.5rem !important;\n  }\n\n  .p-lg-129 {\n    padding: 64rem !important;\n  }\n\n  .p-lg-130 {\n    padding: 64.5rem !important;\n  }\n\n  .p-lg-131 {\n    padding: 65rem !important;\n  }\n\n  .p-lg-132 {\n    padding: 65.5rem !important;\n  }\n\n  .p-lg-133 {\n    padding: 66rem !important;\n  }\n\n  .p-lg-134 {\n    padding: 66.5rem !important;\n  }\n\n  .p-lg-135 {\n    padding: 67rem !important;\n  }\n\n  .p-lg-136 {\n    padding: 67.5rem !important;\n  }\n\n  .p-lg-137 {\n    padding: 68rem !important;\n  }\n\n  .p-lg-138 {\n    padding: 68.5rem !important;\n  }\n\n  .p-lg-139 {\n    padding: 69rem !important;\n  }\n\n  .p-lg-140 {\n    padding: 69.5rem !important;\n  }\n\n  .p-lg-141 {\n    padding: 70rem !important;\n  }\n\n  .p-lg-142 {\n    padding: 70.5rem !important;\n  }\n\n  .p-lg-143 {\n    padding: 71rem !important;\n  }\n\n  .p-lg-144 {\n    padding: 71.5rem !important;\n  }\n\n  .p-lg-145 {\n    padding: 72rem !important;\n  }\n\n  .p-lg-146 {\n    padding: 72.5rem !important;\n  }\n\n  .p-lg-147 {\n    padding: 73rem !important;\n  }\n\n  .p-lg-148 {\n    padding: 73.5rem !important;\n  }\n\n  .p-lg-149 {\n    padding: 74rem !important;\n  }\n\n  .p-lg-150 {\n    padding: 74.5rem !important;\n  }\n\n  .p-lg-151 {\n    padding: 75rem !important;\n  }\n\n  .p-lg-152 {\n    padding: 75.5rem !important;\n  }\n\n  .p-lg-153 {\n    padding: 76rem !important;\n  }\n\n  .p-lg-154 {\n    padding: 76.5rem !important;\n  }\n\n  .p-lg-155 {\n    padding: 77rem !important;\n  }\n\n  .p-lg-156 {\n    padding: 77.5rem !important;\n  }\n\n  .p-lg-157 {\n    padding: 78rem !important;\n  }\n\n  .p-lg-158 {\n    padding: 78.5rem !important;\n  }\n\n  .p-lg-159 {\n    padding: 79rem !important;\n  }\n\n  .p-lg-160 {\n    padding: 79.5rem !important;\n  }\n\n  .pt-lg-0 {\n    padding-top: 0rem !important;\n  }\n\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-lg-5 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-lg-6 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-lg-7 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-lg-8 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-lg-9 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-lg-10 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-lg-11 {\n    padding-top: 5rem !important;\n  }\n\n  .pt-lg-12 {\n    padding-top: 5.5rem !important;\n  }\n\n  .pt-lg-13 {\n    padding-top: 6rem !important;\n  }\n\n  .pt-lg-14 {\n    padding-top: 6.5rem !important;\n  }\n\n  .pt-lg-15 {\n    padding-top: 7rem !important;\n  }\n\n  .pt-lg-16 {\n    padding-top: 7.5rem !important;\n  }\n\n  .pt-lg-17 {\n    padding-top: 8rem !important;\n  }\n\n  .pt-lg-18 {\n    padding-top: 8.5rem !important;\n  }\n\n  .pt-lg-19 {\n    padding-top: 9rem !important;\n  }\n\n  .pt-lg-20 {\n    padding-top: 9.5rem !important;\n  }\n\n  .pt-lg-21 {\n    padding-top: 10rem !important;\n  }\n\n  .pt-lg-22 {\n    padding-top: 10.5rem !important;\n  }\n\n  .pt-lg-23 {\n    padding-top: 11rem !important;\n  }\n\n  .pt-lg-24 {\n    padding-top: 11.5rem !important;\n  }\n\n  .pt-lg-25 {\n    padding-top: 12rem !important;\n  }\n\n  .pt-lg-26 {\n    padding-top: 12.5rem !important;\n  }\n\n  .pt-lg-27 {\n    padding-top: 13rem !important;\n  }\n\n  .pt-lg-28 {\n    padding-top: 13.5rem !important;\n  }\n\n  .pt-lg-29 {\n    padding-top: 14rem !important;\n  }\n\n  .pt-lg-30 {\n    padding-top: 14.5rem !important;\n  }\n\n  .pt-lg-31 {\n    padding-top: 15rem !important;\n  }\n\n  .pt-lg-32 {\n    padding-top: 15.5rem !important;\n  }\n\n  .pt-lg-33 {\n    padding-top: 16rem !important;\n  }\n\n  .pt-lg-34 {\n    padding-top: 16.5rem !important;\n  }\n\n  .pt-lg-35 {\n    padding-top: 17rem !important;\n  }\n\n  .pt-lg-36 {\n    padding-top: 17.5rem !important;\n  }\n\n  .pt-lg-37 {\n    padding-top: 18rem !important;\n  }\n\n  .pt-lg-38 {\n    padding-top: 18.5rem !important;\n  }\n\n  .pt-lg-39 {\n    padding-top: 19rem !important;\n  }\n\n  .pt-lg-40 {\n    padding-top: 19.5rem !important;\n  }\n\n  .pt-lg-41 {\n    padding-top: 20rem !important;\n  }\n\n  .pt-lg-42 {\n    padding-top: 20.5rem !important;\n  }\n\n  .pt-lg-43 {\n    padding-top: 21rem !important;\n  }\n\n  .pt-lg-44 {\n    padding-top: 21.5rem !important;\n  }\n\n  .pt-lg-45 {\n    padding-top: 22rem !important;\n  }\n\n  .pt-lg-46 {\n    padding-top: 22.5rem !important;\n  }\n\n  .pt-lg-47 {\n    padding-top: 23rem !important;\n  }\n\n  .pt-lg-48 {\n    padding-top: 23.5rem !important;\n  }\n\n  .pt-lg-49 {\n    padding-top: 24rem !important;\n  }\n\n  .pt-lg-50 {\n    padding-top: 24.5rem !important;\n  }\n\n  .pt-lg-51 {\n    padding-top: 25rem !important;\n  }\n\n  .pt-lg-52 {\n    padding-top: 25.5rem !important;\n  }\n\n  .pt-lg-53 {\n    padding-top: 26rem !important;\n  }\n\n  .pt-lg-54 {\n    padding-top: 26.5rem !important;\n  }\n\n  .pt-lg-55 {\n    padding-top: 27rem !important;\n  }\n\n  .pt-lg-56 {\n    padding-top: 27.5rem !important;\n  }\n\n  .pt-lg-57 {\n    padding-top: 28rem !important;\n  }\n\n  .pt-lg-58 {\n    padding-top: 28.5rem !important;\n  }\n\n  .pt-lg-59 {\n    padding-top: 29rem !important;\n  }\n\n  .pt-lg-60 {\n    padding-top: 29.5rem !important;\n  }\n\n  .pt-lg-61 {\n    padding-top: 30rem !important;\n  }\n\n  .pt-lg-62 {\n    padding-top: 30.5rem !important;\n  }\n\n  .pt-lg-63 {\n    padding-top: 31rem !important;\n  }\n\n  .pt-lg-64 {\n    padding-top: 31.5rem !important;\n  }\n\n  .pt-lg-65 {\n    padding-top: 32rem !important;\n  }\n\n  .pt-lg-66 {\n    padding-top: 32.5rem !important;\n  }\n\n  .pt-lg-67 {\n    padding-top: 33rem !important;\n  }\n\n  .pt-lg-68 {\n    padding-top: 33.5rem !important;\n  }\n\n  .pt-lg-69 {\n    padding-top: 34rem !important;\n  }\n\n  .pt-lg-70 {\n    padding-top: 34.5rem !important;\n  }\n\n  .pt-lg-71 {\n    padding-top: 35rem !important;\n  }\n\n  .pt-lg-72 {\n    padding-top: 35.5rem !important;\n  }\n\n  .pt-lg-73 {\n    padding-top: 36rem !important;\n  }\n\n  .pt-lg-74 {\n    padding-top: 36.5rem !important;\n  }\n\n  .pt-lg-75 {\n    padding-top: 37rem !important;\n  }\n\n  .pt-lg-76 {\n    padding-top: 37.5rem !important;\n  }\n\n  .pt-lg-77 {\n    padding-top: 38rem !important;\n  }\n\n  .pt-lg-78 {\n    padding-top: 38.5rem !important;\n  }\n\n  .pt-lg-79 {\n    padding-top: 39rem !important;\n  }\n\n  .pt-lg-80 {\n    padding-top: 39.5rem !important;\n  }\n\n  .pt-lg-81 {\n    padding-top: 40rem !important;\n  }\n\n  .pt-lg-82 {\n    padding-top: 40.5rem !important;\n  }\n\n  .pt-lg-83 {\n    padding-top: 41rem !important;\n  }\n\n  .pt-lg-84 {\n    padding-top: 41.5rem !important;\n  }\n\n  .pt-lg-85 {\n    padding-top: 42rem !important;\n  }\n\n  .pt-lg-86 {\n    padding-top: 42.5rem !important;\n  }\n\n  .pt-lg-87 {\n    padding-top: 43rem !important;\n  }\n\n  .pt-lg-88 {\n    padding-top: 43.5rem !important;\n  }\n\n  .pt-lg-89 {\n    padding-top: 44rem !important;\n  }\n\n  .pt-lg-90 {\n    padding-top: 44.5rem !important;\n  }\n\n  .pt-lg-91 {\n    padding-top: 45rem !important;\n  }\n\n  .pt-lg-92 {\n    padding-top: 45.5rem !important;\n  }\n\n  .pt-lg-93 {\n    padding-top: 46rem !important;\n  }\n\n  .pt-lg-94 {\n    padding-top: 46.5rem !important;\n  }\n\n  .pt-lg-95 {\n    padding-top: 47rem !important;\n  }\n\n  .pt-lg-96 {\n    padding-top: 47.5rem !important;\n  }\n\n  .pt-lg-97 {\n    padding-top: 48rem !important;\n  }\n\n  .pt-lg-98 {\n    padding-top: 48.5rem !important;\n  }\n\n  .pt-lg-99 {\n    padding-top: 49rem !important;\n  }\n\n  .pt-lg-100 {\n    padding-top: 49.5rem !important;\n  }\n\n  .pt-lg-101 {\n    padding-top: 50rem !important;\n  }\n\n  .pt-lg-102 {\n    padding-top: 50.5rem !important;\n  }\n\n  .pt-lg-103 {\n    padding-top: 51rem !important;\n  }\n\n  .pt-lg-104 {\n    padding-top: 51.5rem !important;\n  }\n\n  .pt-lg-105 {\n    padding-top: 52rem !important;\n  }\n\n  .pt-lg-106 {\n    padding-top: 52.5rem !important;\n  }\n\n  .pt-lg-107 {\n    padding-top: 53rem !important;\n  }\n\n  .pt-lg-108 {\n    padding-top: 53.5rem !important;\n  }\n\n  .pt-lg-109 {\n    padding-top: 54rem !important;\n  }\n\n  .pt-lg-110 {\n    padding-top: 54.5rem !important;\n  }\n\n  .pt-lg-111 {\n    padding-top: 55rem !important;\n  }\n\n  .pt-lg-112 {\n    padding-top: 55.5rem !important;\n  }\n\n  .pt-lg-113 {\n    padding-top: 56rem !important;\n  }\n\n  .pt-lg-114 {\n    padding-top: 56.5rem !important;\n  }\n\n  .pt-lg-115 {\n    padding-top: 57rem !important;\n  }\n\n  .pt-lg-116 {\n    padding-top: 57.5rem !important;\n  }\n\n  .pt-lg-117 {\n    padding-top: 58rem !important;\n  }\n\n  .pt-lg-118 {\n    padding-top: 58.5rem !important;\n  }\n\n  .pt-lg-119 {\n    padding-top: 59rem !important;\n  }\n\n  .pt-lg-120 {\n    padding-top: 59.5rem !important;\n  }\n\n  .pt-lg-121 {\n    padding-top: 60rem !important;\n  }\n\n  .pt-lg-122 {\n    padding-top: 60.5rem !important;\n  }\n\n  .pt-lg-123 {\n    padding-top: 61rem !important;\n  }\n\n  .pt-lg-124 {\n    padding-top: 61.5rem !important;\n  }\n\n  .pt-lg-125 {\n    padding-top: 62rem !important;\n  }\n\n  .pt-lg-126 {\n    padding-top: 62.5rem !important;\n  }\n\n  .pt-lg-127 {\n    padding-top: 63rem !important;\n  }\n\n  .pt-lg-128 {\n    padding-top: 63.5rem !important;\n  }\n\n  .pt-lg-129 {\n    padding-top: 64rem !important;\n  }\n\n  .pt-lg-130 {\n    padding-top: 64.5rem !important;\n  }\n\n  .pt-lg-131 {\n    padding-top: 65rem !important;\n  }\n\n  .pt-lg-132 {\n    padding-top: 65.5rem !important;\n  }\n\n  .pt-lg-133 {\n    padding-top: 66rem !important;\n  }\n\n  .pt-lg-134 {\n    padding-top: 66.5rem !important;\n  }\n\n  .pt-lg-135 {\n    padding-top: 67rem !important;\n  }\n\n  .pt-lg-136 {\n    padding-top: 67.5rem !important;\n  }\n\n  .pt-lg-137 {\n    padding-top: 68rem !important;\n  }\n\n  .pt-lg-138 {\n    padding-top: 68.5rem !important;\n  }\n\n  .pt-lg-139 {\n    padding-top: 69rem !important;\n  }\n\n  .pt-lg-140 {\n    padding-top: 69.5rem !important;\n  }\n\n  .pt-lg-141 {\n    padding-top: 70rem !important;\n  }\n\n  .pt-lg-142 {\n    padding-top: 70.5rem !important;\n  }\n\n  .pt-lg-143 {\n    padding-top: 71rem !important;\n  }\n\n  .pt-lg-144 {\n    padding-top: 71.5rem !important;\n  }\n\n  .pt-lg-145 {\n    padding-top: 72rem !important;\n  }\n\n  .pt-lg-146 {\n    padding-top: 72.5rem !important;\n  }\n\n  .pt-lg-147 {\n    padding-top: 73rem !important;\n  }\n\n  .pt-lg-148 {\n    padding-top: 73.5rem !important;\n  }\n\n  .pt-lg-149 {\n    padding-top: 74rem !important;\n  }\n\n  .pt-lg-150 {\n    padding-top: 74.5rem !important;\n  }\n\n  .pt-lg-151 {\n    padding-top: 75rem !important;\n  }\n\n  .pt-lg-152 {\n    padding-top: 75.5rem !important;\n  }\n\n  .pt-lg-153 {\n    padding-top: 76rem !important;\n  }\n\n  .pt-lg-154 {\n    padding-top: 76.5rem !important;\n  }\n\n  .pt-lg-155 {\n    padding-top: 77rem !important;\n  }\n\n  .pt-lg-156 {\n    padding-top: 77.5rem !important;\n  }\n\n  .pt-lg-157 {\n    padding-top: 78rem !important;\n  }\n\n  .pt-lg-158 {\n    padding-top: 78.5rem !important;\n  }\n\n  .pt-lg-159 {\n    padding-top: 79rem !important;\n  }\n\n  .pt-lg-160 {\n    padding-top: 79.5rem !important;\n  }\n\n  .pb-lg-0 {\n    padding-bottom: 0rem !important;\n  }\n\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-lg-5 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-lg-6 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-lg-7 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-lg-8 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-lg-9 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-lg-10 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-lg-11 {\n    padding-bottom: 5rem !important;\n  }\n\n  .pb-lg-12 {\n    padding-bottom: 5.5rem !important;\n  }\n\n  .pb-lg-13 {\n    padding-bottom: 6rem !important;\n  }\n\n  .pb-lg-14 {\n    padding-bottom: 6.5rem !important;\n  }\n\n  .pb-lg-15 {\n    padding-bottom: 7rem !important;\n  }\n\n  .pb-lg-16 {\n    padding-bottom: 7.5rem !important;\n  }\n\n  .pb-lg-17 {\n    padding-bottom: 8rem !important;\n  }\n\n  .pb-lg-18 {\n    padding-bottom: 8.5rem !important;\n  }\n\n  .pb-lg-19 {\n    padding-bottom: 9rem !important;\n  }\n\n  .pb-lg-20 {\n    padding-bottom: 9.5rem !important;\n  }\n\n  .pb-lg-21 {\n    padding-bottom: 10rem !important;\n  }\n\n  .pb-lg-22 {\n    padding-bottom: 10.5rem !important;\n  }\n\n  .pb-lg-23 {\n    padding-bottom: 11rem !important;\n  }\n\n  .pb-lg-24 {\n    padding-bottom: 11.5rem !important;\n  }\n\n  .pb-lg-25 {\n    padding-bottom: 12rem !important;\n  }\n\n  .pb-lg-26 {\n    padding-bottom: 12.5rem !important;\n  }\n\n  .pb-lg-27 {\n    padding-bottom: 13rem !important;\n  }\n\n  .pb-lg-28 {\n    padding-bottom: 13.5rem !important;\n  }\n\n  .pb-lg-29 {\n    padding-bottom: 14rem !important;\n  }\n\n  .pb-lg-30 {\n    padding-bottom: 14.5rem !important;\n  }\n\n  .pb-lg-31 {\n    padding-bottom: 15rem !important;\n  }\n\n  .pb-lg-32 {\n    padding-bottom: 15.5rem !important;\n  }\n\n  .pb-lg-33 {\n    padding-bottom: 16rem !important;\n  }\n\n  .pb-lg-34 {\n    padding-bottom: 16.5rem !important;\n  }\n\n  .pb-lg-35 {\n    padding-bottom: 17rem !important;\n  }\n\n  .pb-lg-36 {\n    padding-bottom: 17.5rem !important;\n  }\n\n  .pb-lg-37 {\n    padding-bottom: 18rem !important;\n  }\n\n  .pb-lg-38 {\n    padding-bottom: 18.5rem !important;\n  }\n\n  .pb-lg-39 {\n    padding-bottom: 19rem !important;\n  }\n\n  .pb-lg-40 {\n    padding-bottom: 19.5rem !important;\n  }\n\n  .pb-lg-41 {\n    padding-bottom: 20rem !important;\n  }\n\n  .pb-lg-42 {\n    padding-bottom: 20.5rem !important;\n  }\n\n  .pb-lg-43 {\n    padding-bottom: 21rem !important;\n  }\n\n  .pb-lg-44 {\n    padding-bottom: 21.5rem !important;\n  }\n\n  .pb-lg-45 {\n    padding-bottom: 22rem !important;\n  }\n\n  .pb-lg-46 {\n    padding-bottom: 22.5rem !important;\n  }\n\n  .pb-lg-47 {\n    padding-bottom: 23rem !important;\n  }\n\n  .pb-lg-48 {\n    padding-bottom: 23.5rem !important;\n  }\n\n  .pb-lg-49 {\n    padding-bottom: 24rem !important;\n  }\n\n  .pb-lg-50 {\n    padding-bottom: 24.5rem !important;\n  }\n\n  .pb-lg-51 {\n    padding-bottom: 25rem !important;\n  }\n\n  .pb-lg-52 {\n    padding-bottom: 25.5rem !important;\n  }\n\n  .pb-lg-53 {\n    padding-bottom: 26rem !important;\n  }\n\n  .pb-lg-54 {\n    padding-bottom: 26.5rem !important;\n  }\n\n  .pb-lg-55 {\n    padding-bottom: 27rem !important;\n  }\n\n  .pb-lg-56 {\n    padding-bottom: 27.5rem !important;\n  }\n\n  .pb-lg-57 {\n    padding-bottom: 28rem !important;\n  }\n\n  .pb-lg-58 {\n    padding-bottom: 28.5rem !important;\n  }\n\n  .pb-lg-59 {\n    padding-bottom: 29rem !important;\n  }\n\n  .pb-lg-60 {\n    padding-bottom: 29.5rem !important;\n  }\n\n  .pb-lg-61 {\n    padding-bottom: 30rem !important;\n  }\n\n  .pb-lg-62 {\n    padding-bottom: 30.5rem !important;\n  }\n\n  .pb-lg-63 {\n    padding-bottom: 31rem !important;\n  }\n\n  .pb-lg-64 {\n    padding-bottom: 31.5rem !important;\n  }\n\n  .pb-lg-65 {\n    padding-bottom: 32rem !important;\n  }\n\n  .pb-lg-66 {\n    padding-bottom: 32.5rem !important;\n  }\n\n  .pb-lg-67 {\n    padding-bottom: 33rem !important;\n  }\n\n  .pb-lg-68 {\n    padding-bottom: 33.5rem !important;\n  }\n\n  .pb-lg-69 {\n    padding-bottom: 34rem !important;\n  }\n\n  .pb-lg-70 {\n    padding-bottom: 34.5rem !important;\n  }\n\n  .pb-lg-71 {\n    padding-bottom: 35rem !important;\n  }\n\n  .pb-lg-72 {\n    padding-bottom: 35.5rem !important;\n  }\n\n  .pb-lg-73 {\n    padding-bottom: 36rem !important;\n  }\n\n  .pb-lg-74 {\n    padding-bottom: 36.5rem !important;\n  }\n\n  .pb-lg-75 {\n    padding-bottom: 37rem !important;\n  }\n\n  .pb-lg-76 {\n    padding-bottom: 37.5rem !important;\n  }\n\n  .pb-lg-77 {\n    padding-bottom: 38rem !important;\n  }\n\n  .pb-lg-78 {\n    padding-bottom: 38.5rem !important;\n  }\n\n  .pb-lg-79 {\n    padding-bottom: 39rem !important;\n  }\n\n  .pb-lg-80 {\n    padding-bottom: 39.5rem !important;\n  }\n\n  .pb-lg-81 {\n    padding-bottom: 40rem !important;\n  }\n\n  .pb-lg-82 {\n    padding-bottom: 40.5rem !important;\n  }\n\n  .pb-lg-83 {\n    padding-bottom: 41rem !important;\n  }\n\n  .pb-lg-84 {\n    padding-bottom: 41.5rem !important;\n  }\n\n  .pb-lg-85 {\n    padding-bottom: 42rem !important;\n  }\n\n  .pb-lg-86 {\n    padding-bottom: 42.5rem !important;\n  }\n\n  .pb-lg-87 {\n    padding-bottom: 43rem !important;\n  }\n\n  .pb-lg-88 {\n    padding-bottom: 43.5rem !important;\n  }\n\n  .pb-lg-89 {\n    padding-bottom: 44rem !important;\n  }\n\n  .pb-lg-90 {\n    padding-bottom: 44.5rem !important;\n  }\n\n  .pb-lg-91 {\n    padding-bottom: 45rem !important;\n  }\n\n  .pb-lg-92 {\n    padding-bottom: 45.5rem !important;\n  }\n\n  .pb-lg-93 {\n    padding-bottom: 46rem !important;\n  }\n\n  .pb-lg-94 {\n    padding-bottom: 46.5rem !important;\n  }\n\n  .pb-lg-95 {\n    padding-bottom: 47rem !important;\n  }\n\n  .pb-lg-96 {\n    padding-bottom: 47.5rem !important;\n  }\n\n  .pb-lg-97 {\n    padding-bottom: 48rem !important;\n  }\n\n  .pb-lg-98 {\n    padding-bottom: 48.5rem !important;\n  }\n\n  .pb-lg-99 {\n    padding-bottom: 49rem !important;\n  }\n\n  .pb-lg-100 {\n    padding-bottom: 49.5rem !important;\n  }\n\n  .pb-lg-101 {\n    padding-bottom: 50rem !important;\n  }\n\n  .pb-lg-102 {\n    padding-bottom: 50.5rem !important;\n  }\n\n  .pb-lg-103 {\n    padding-bottom: 51rem !important;\n  }\n\n  .pb-lg-104 {\n    padding-bottom: 51.5rem !important;\n  }\n\n  .pb-lg-105 {\n    padding-bottom: 52rem !important;\n  }\n\n  .pb-lg-106 {\n    padding-bottom: 52.5rem !important;\n  }\n\n  .pb-lg-107 {\n    padding-bottom: 53rem !important;\n  }\n\n  .pb-lg-108 {\n    padding-bottom: 53.5rem !important;\n  }\n\n  .pb-lg-109 {\n    padding-bottom: 54rem !important;\n  }\n\n  .pb-lg-110 {\n    padding-bottom: 54.5rem !important;\n  }\n\n  .pb-lg-111 {\n    padding-bottom: 55rem !important;\n  }\n\n  .pb-lg-112 {\n    padding-bottom: 55.5rem !important;\n  }\n\n  .pb-lg-113 {\n    padding-bottom: 56rem !important;\n  }\n\n  .pb-lg-114 {\n    padding-bottom: 56.5rem !important;\n  }\n\n  .pb-lg-115 {\n    padding-bottom: 57rem !important;\n  }\n\n  .pb-lg-116 {\n    padding-bottom: 57.5rem !important;\n  }\n\n  .pb-lg-117 {\n    padding-bottom: 58rem !important;\n  }\n\n  .pb-lg-118 {\n    padding-bottom: 58.5rem !important;\n  }\n\n  .pb-lg-119 {\n    padding-bottom: 59rem !important;\n  }\n\n  .pb-lg-120 {\n    padding-bottom: 59.5rem !important;\n  }\n\n  .pb-lg-121 {\n    padding-bottom: 60rem !important;\n  }\n\n  .pb-lg-122 {\n    padding-bottom: 60.5rem !important;\n  }\n\n  .pb-lg-123 {\n    padding-bottom: 61rem !important;\n  }\n\n  .pb-lg-124 {\n    padding-bottom: 61.5rem !important;\n  }\n\n  .pb-lg-125 {\n    padding-bottom: 62rem !important;\n  }\n\n  .pb-lg-126 {\n    padding-bottom: 62.5rem !important;\n  }\n\n  .pb-lg-127 {\n    padding-bottom: 63rem !important;\n  }\n\n  .pb-lg-128 {\n    padding-bottom: 63.5rem !important;\n  }\n\n  .pb-lg-129 {\n    padding-bottom: 64rem !important;\n  }\n\n  .pb-lg-130 {\n    padding-bottom: 64.5rem !important;\n  }\n\n  .pb-lg-131 {\n    padding-bottom: 65rem !important;\n  }\n\n  .pb-lg-132 {\n    padding-bottom: 65.5rem !important;\n  }\n\n  .pb-lg-133 {\n    padding-bottom: 66rem !important;\n  }\n\n  .pb-lg-134 {\n    padding-bottom: 66.5rem !important;\n  }\n\n  .pb-lg-135 {\n    padding-bottom: 67rem !important;\n  }\n\n  .pb-lg-136 {\n    padding-bottom: 67.5rem !important;\n  }\n\n  .pb-lg-137 {\n    padding-bottom: 68rem !important;\n  }\n\n  .pb-lg-138 {\n    padding-bottom: 68.5rem !important;\n  }\n\n  .pb-lg-139 {\n    padding-bottom: 69rem !important;\n  }\n\n  .pb-lg-140 {\n    padding-bottom: 69.5rem !important;\n  }\n\n  .pb-lg-141 {\n    padding-bottom: 70rem !important;\n  }\n\n  .pb-lg-142 {\n    padding-bottom: 70.5rem !important;\n  }\n\n  .pb-lg-143 {\n    padding-bottom: 71rem !important;\n  }\n\n  .pb-lg-144 {\n    padding-bottom: 71.5rem !important;\n  }\n\n  .pb-lg-145 {\n    padding-bottom: 72rem !important;\n  }\n\n  .pb-lg-146 {\n    padding-bottom: 72.5rem !important;\n  }\n\n  .pb-lg-147 {\n    padding-bottom: 73rem !important;\n  }\n\n  .pb-lg-148 {\n    padding-bottom: 73.5rem !important;\n  }\n\n  .pb-lg-149 {\n    padding-bottom: 74rem !important;\n  }\n\n  .pb-lg-150 {\n    padding-bottom: 74.5rem !important;\n  }\n\n  .pb-lg-151 {\n    padding-bottom: 75rem !important;\n  }\n\n  .pb-lg-152 {\n    padding-bottom: 75.5rem !important;\n  }\n\n  .pb-lg-153 {\n    padding-bottom: 76rem !important;\n  }\n\n  .pb-lg-154 {\n    padding-bottom: 76.5rem !important;\n  }\n\n  .pb-lg-155 {\n    padding-bottom: 77rem !important;\n  }\n\n  .pb-lg-156 {\n    padding-bottom: 77.5rem !important;\n  }\n\n  .pb-lg-157 {\n    padding-bottom: 78rem !important;\n  }\n\n  .pb-lg-158 {\n    padding-bottom: 78.5rem !important;\n  }\n\n  .pb-lg-159 {\n    padding-bottom: 79rem !important;\n  }\n\n  .pb-lg-160 {\n    padding-bottom: 79.5rem !important;\n  }\n\n  .ps-lg-0 {\n    padding-left: 0rem !important;\n  }\n\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-lg-5 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-lg-6 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-lg-7 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-lg-8 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-lg-9 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-lg-10 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-lg-11 {\n    padding-left: 5rem !important;\n  }\n\n  .ps-lg-12 {\n    padding-left: 5.5rem !important;\n  }\n\n  .ps-lg-13 {\n    padding-left: 6rem !important;\n  }\n\n  .ps-lg-14 {\n    padding-left: 6.5rem !important;\n  }\n\n  .ps-lg-15 {\n    padding-left: 7rem !important;\n  }\n\n  .ps-lg-16 {\n    padding-left: 7.5rem !important;\n  }\n\n  .ps-lg-17 {\n    padding-left: 8rem !important;\n  }\n\n  .ps-lg-18 {\n    padding-left: 8.5rem !important;\n  }\n\n  .ps-lg-19 {\n    padding-left: 9rem !important;\n  }\n\n  .ps-lg-20 {\n    padding-left: 9.5rem !important;\n  }\n\n  .ps-lg-21 {\n    padding-left: 10rem !important;\n  }\n\n  .ps-lg-22 {\n    padding-left: 10.5rem !important;\n  }\n\n  .ps-lg-23 {\n    padding-left: 11rem !important;\n  }\n\n  .ps-lg-24 {\n    padding-left: 11.5rem !important;\n  }\n\n  .ps-lg-25 {\n    padding-left: 12rem !important;\n  }\n\n  .ps-lg-26 {\n    padding-left: 12.5rem !important;\n  }\n\n  .ps-lg-27 {\n    padding-left: 13rem !important;\n  }\n\n  .ps-lg-28 {\n    padding-left: 13.5rem !important;\n  }\n\n  .ps-lg-29 {\n    padding-left: 14rem !important;\n  }\n\n  .ps-lg-30 {\n    padding-left: 14.5rem !important;\n  }\n\n  .ps-lg-31 {\n    padding-left: 15rem !important;\n  }\n\n  .ps-lg-32 {\n    padding-left: 15.5rem !important;\n  }\n\n  .ps-lg-33 {\n    padding-left: 16rem !important;\n  }\n\n  .ps-lg-34 {\n    padding-left: 16.5rem !important;\n  }\n\n  .ps-lg-35 {\n    padding-left: 17rem !important;\n  }\n\n  .ps-lg-36 {\n    padding-left: 17.5rem !important;\n  }\n\n  .ps-lg-37 {\n    padding-left: 18rem !important;\n  }\n\n  .ps-lg-38 {\n    padding-left: 18.5rem !important;\n  }\n\n  .ps-lg-39 {\n    padding-left: 19rem !important;\n  }\n\n  .ps-lg-40 {\n    padding-left: 19.5rem !important;\n  }\n\n  .ps-lg-41 {\n    padding-left: 20rem !important;\n  }\n\n  .ps-lg-42 {\n    padding-left: 20.5rem !important;\n  }\n\n  .ps-lg-43 {\n    padding-left: 21rem !important;\n  }\n\n  .ps-lg-44 {\n    padding-left: 21.5rem !important;\n  }\n\n  .ps-lg-45 {\n    padding-left: 22rem !important;\n  }\n\n  .ps-lg-46 {\n    padding-left: 22.5rem !important;\n  }\n\n  .ps-lg-47 {\n    padding-left: 23rem !important;\n  }\n\n  .ps-lg-48 {\n    padding-left: 23.5rem !important;\n  }\n\n  .ps-lg-49 {\n    padding-left: 24rem !important;\n  }\n\n  .ps-lg-50 {\n    padding-left: 24.5rem !important;\n  }\n\n  .ps-lg-51 {\n    padding-left: 25rem !important;\n  }\n\n  .ps-lg-52 {\n    padding-left: 25.5rem !important;\n  }\n\n  .ps-lg-53 {\n    padding-left: 26rem !important;\n  }\n\n  .ps-lg-54 {\n    padding-left: 26.5rem !important;\n  }\n\n  .ps-lg-55 {\n    padding-left: 27rem !important;\n  }\n\n  .ps-lg-56 {\n    padding-left: 27.5rem !important;\n  }\n\n  .ps-lg-57 {\n    padding-left: 28rem !important;\n  }\n\n  .ps-lg-58 {\n    padding-left: 28.5rem !important;\n  }\n\n  .ps-lg-59 {\n    padding-left: 29rem !important;\n  }\n\n  .ps-lg-60 {\n    padding-left: 29.5rem !important;\n  }\n\n  .ps-lg-61 {\n    padding-left: 30rem !important;\n  }\n\n  .ps-lg-62 {\n    padding-left: 30.5rem !important;\n  }\n\n  .ps-lg-63 {\n    padding-left: 31rem !important;\n  }\n\n  .ps-lg-64 {\n    padding-left: 31.5rem !important;\n  }\n\n  .ps-lg-65 {\n    padding-left: 32rem !important;\n  }\n\n  .ps-lg-66 {\n    padding-left: 32.5rem !important;\n  }\n\n  .ps-lg-67 {\n    padding-left: 33rem !important;\n  }\n\n  .ps-lg-68 {\n    padding-left: 33.5rem !important;\n  }\n\n  .ps-lg-69 {\n    padding-left: 34rem !important;\n  }\n\n  .ps-lg-70 {\n    padding-left: 34.5rem !important;\n  }\n\n  .ps-lg-71 {\n    padding-left: 35rem !important;\n  }\n\n  .ps-lg-72 {\n    padding-left: 35.5rem !important;\n  }\n\n  .ps-lg-73 {\n    padding-left: 36rem !important;\n  }\n\n  .ps-lg-74 {\n    padding-left: 36.5rem !important;\n  }\n\n  .ps-lg-75 {\n    padding-left: 37rem !important;\n  }\n\n  .ps-lg-76 {\n    padding-left: 37.5rem !important;\n  }\n\n  .ps-lg-77 {\n    padding-left: 38rem !important;\n  }\n\n  .ps-lg-78 {\n    padding-left: 38.5rem !important;\n  }\n\n  .ps-lg-79 {\n    padding-left: 39rem !important;\n  }\n\n  .ps-lg-80 {\n    padding-left: 39.5rem !important;\n  }\n\n  .ps-lg-81 {\n    padding-left: 40rem !important;\n  }\n\n  .ps-lg-82 {\n    padding-left: 40.5rem !important;\n  }\n\n  .ps-lg-83 {\n    padding-left: 41rem !important;\n  }\n\n  .ps-lg-84 {\n    padding-left: 41.5rem !important;\n  }\n\n  .ps-lg-85 {\n    padding-left: 42rem !important;\n  }\n\n  .ps-lg-86 {\n    padding-left: 42.5rem !important;\n  }\n\n  .ps-lg-87 {\n    padding-left: 43rem !important;\n  }\n\n  .ps-lg-88 {\n    padding-left: 43.5rem !important;\n  }\n\n  .ps-lg-89 {\n    padding-left: 44rem !important;\n  }\n\n  .ps-lg-90 {\n    padding-left: 44.5rem !important;\n  }\n\n  .ps-lg-91 {\n    padding-left: 45rem !important;\n  }\n\n  .ps-lg-92 {\n    padding-left: 45.5rem !important;\n  }\n\n  .ps-lg-93 {\n    padding-left: 46rem !important;\n  }\n\n  .ps-lg-94 {\n    padding-left: 46.5rem !important;\n  }\n\n  .ps-lg-95 {\n    padding-left: 47rem !important;\n  }\n\n  .ps-lg-96 {\n    padding-left: 47.5rem !important;\n  }\n\n  .ps-lg-97 {\n    padding-left: 48rem !important;\n  }\n\n  .ps-lg-98 {\n    padding-left: 48.5rem !important;\n  }\n\n  .ps-lg-99 {\n    padding-left: 49rem !important;\n  }\n\n  .ps-lg-100 {\n    padding-left: 49.5rem !important;\n  }\n\n  .ps-lg-101 {\n    padding-left: 50rem !important;\n  }\n\n  .ps-lg-102 {\n    padding-left: 50.5rem !important;\n  }\n\n  .ps-lg-103 {\n    padding-left: 51rem !important;\n  }\n\n  .ps-lg-104 {\n    padding-left: 51.5rem !important;\n  }\n\n  .ps-lg-105 {\n    padding-left: 52rem !important;\n  }\n\n  .ps-lg-106 {\n    padding-left: 52.5rem !important;\n  }\n\n  .ps-lg-107 {\n    padding-left: 53rem !important;\n  }\n\n  .ps-lg-108 {\n    padding-left: 53.5rem !important;\n  }\n\n  .ps-lg-109 {\n    padding-left: 54rem !important;\n  }\n\n  .ps-lg-110 {\n    padding-left: 54.5rem !important;\n  }\n\n  .ps-lg-111 {\n    padding-left: 55rem !important;\n  }\n\n  .ps-lg-112 {\n    padding-left: 55.5rem !important;\n  }\n\n  .ps-lg-113 {\n    padding-left: 56rem !important;\n  }\n\n  .ps-lg-114 {\n    padding-left: 56.5rem !important;\n  }\n\n  .ps-lg-115 {\n    padding-left: 57rem !important;\n  }\n\n  .ps-lg-116 {\n    padding-left: 57.5rem !important;\n  }\n\n  .ps-lg-117 {\n    padding-left: 58rem !important;\n  }\n\n  .ps-lg-118 {\n    padding-left: 58.5rem !important;\n  }\n\n  .ps-lg-119 {\n    padding-left: 59rem !important;\n  }\n\n  .ps-lg-120 {\n    padding-left: 59.5rem !important;\n  }\n\n  .ps-lg-121 {\n    padding-left: 60rem !important;\n  }\n\n  .ps-lg-122 {\n    padding-left: 60.5rem !important;\n  }\n\n  .ps-lg-123 {\n    padding-left: 61rem !important;\n  }\n\n  .ps-lg-124 {\n    padding-left: 61.5rem !important;\n  }\n\n  .ps-lg-125 {\n    padding-left: 62rem !important;\n  }\n\n  .ps-lg-126 {\n    padding-left: 62.5rem !important;\n  }\n\n  .ps-lg-127 {\n    padding-left: 63rem !important;\n  }\n\n  .ps-lg-128 {\n    padding-left: 63.5rem !important;\n  }\n\n  .ps-lg-129 {\n    padding-left: 64rem !important;\n  }\n\n  .ps-lg-130 {\n    padding-left: 64.5rem !important;\n  }\n\n  .ps-lg-131 {\n    padding-left: 65rem !important;\n  }\n\n  .ps-lg-132 {\n    padding-left: 65.5rem !important;\n  }\n\n  .ps-lg-133 {\n    padding-left: 66rem !important;\n  }\n\n  .ps-lg-134 {\n    padding-left: 66.5rem !important;\n  }\n\n  .ps-lg-135 {\n    padding-left: 67rem !important;\n  }\n\n  .ps-lg-136 {\n    padding-left: 67.5rem !important;\n  }\n\n  .ps-lg-137 {\n    padding-left: 68rem !important;\n  }\n\n  .ps-lg-138 {\n    padding-left: 68.5rem !important;\n  }\n\n  .ps-lg-139 {\n    padding-left: 69rem !important;\n  }\n\n  .ps-lg-140 {\n    padding-left: 69.5rem !important;\n  }\n\n  .ps-lg-141 {\n    padding-left: 70rem !important;\n  }\n\n  .ps-lg-142 {\n    padding-left: 70.5rem !important;\n  }\n\n  .ps-lg-143 {\n    padding-left: 71rem !important;\n  }\n\n  .ps-lg-144 {\n    padding-left: 71.5rem !important;\n  }\n\n  .ps-lg-145 {\n    padding-left: 72rem !important;\n  }\n\n  .ps-lg-146 {\n    padding-left: 72.5rem !important;\n  }\n\n  .ps-lg-147 {\n    padding-left: 73rem !important;\n  }\n\n  .ps-lg-148 {\n    padding-left: 73.5rem !important;\n  }\n\n  .ps-lg-149 {\n    padding-left: 74rem !important;\n  }\n\n  .ps-lg-150 {\n    padding-left: 74.5rem !important;\n  }\n\n  .ps-lg-151 {\n    padding-left: 75rem !important;\n  }\n\n  .ps-lg-152 {\n    padding-left: 75.5rem !important;\n  }\n\n  .ps-lg-153 {\n    padding-left: 76rem !important;\n  }\n\n  .ps-lg-154 {\n    padding-left: 76.5rem !important;\n  }\n\n  .ps-lg-155 {\n    padding-left: 77rem !important;\n  }\n\n  .ps-lg-156 {\n    padding-left: 77.5rem !important;\n  }\n\n  .ps-lg-157 {\n    padding-left: 78rem !important;\n  }\n\n  .ps-lg-158 {\n    padding-left: 78.5rem !important;\n  }\n\n  .ps-lg-159 {\n    padding-left: 79rem !important;\n  }\n\n  .ps-lg-160 {\n    padding-left: 79.5rem !important;\n  }\n\n  .pe-lg-0 {\n    padding-right: 0rem !important;\n  }\n\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-lg-5 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-lg-6 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-lg-7 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-lg-8 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-lg-9 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-lg-10 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-lg-11 {\n    padding-right: 5rem !important;\n  }\n\n  .pe-lg-12 {\n    padding-right: 5.5rem !important;\n  }\n\n  .pe-lg-13 {\n    padding-right: 6rem !important;\n  }\n\n  .pe-lg-14 {\n    padding-right: 6.5rem !important;\n  }\n\n  .pe-lg-15 {\n    padding-right: 7rem !important;\n  }\n\n  .pe-lg-16 {\n    padding-right: 7.5rem !important;\n  }\n\n  .pe-lg-17 {\n    padding-right: 8rem !important;\n  }\n\n  .pe-lg-18 {\n    padding-right: 8.5rem !important;\n  }\n\n  .pe-lg-19 {\n    padding-right: 9rem !important;\n  }\n\n  .pe-lg-20 {\n    padding-right: 9.5rem !important;\n  }\n\n  .pe-lg-21 {\n    padding-right: 10rem !important;\n  }\n\n  .pe-lg-22 {\n    padding-right: 10.5rem !important;\n  }\n\n  .pe-lg-23 {\n    padding-right: 11rem !important;\n  }\n\n  .pe-lg-24 {\n    padding-right: 11.5rem !important;\n  }\n\n  .pe-lg-25 {\n    padding-right: 12rem !important;\n  }\n\n  .pe-lg-26 {\n    padding-right: 12.5rem !important;\n  }\n\n  .pe-lg-27 {\n    padding-right: 13rem !important;\n  }\n\n  .pe-lg-28 {\n    padding-right: 13.5rem !important;\n  }\n\n  .pe-lg-29 {\n    padding-right: 14rem !important;\n  }\n\n  .pe-lg-30 {\n    padding-right: 14.5rem !important;\n  }\n\n  .pe-lg-31 {\n    padding-right: 15rem !important;\n  }\n\n  .pe-lg-32 {\n    padding-right: 15.5rem !important;\n  }\n\n  .pe-lg-33 {\n    padding-right: 16rem !important;\n  }\n\n  .pe-lg-34 {\n    padding-right: 16.5rem !important;\n  }\n\n  .pe-lg-35 {\n    padding-right: 17rem !important;\n  }\n\n  .pe-lg-36 {\n    padding-right: 17.5rem !important;\n  }\n\n  .pe-lg-37 {\n    padding-right: 18rem !important;\n  }\n\n  .pe-lg-38 {\n    padding-right: 18.5rem !important;\n  }\n\n  .pe-lg-39 {\n    padding-right: 19rem !important;\n  }\n\n  .pe-lg-40 {\n    padding-right: 19.5rem !important;\n  }\n\n  .pe-lg-41 {\n    padding-right: 20rem !important;\n  }\n\n  .pe-lg-42 {\n    padding-right: 20.5rem !important;\n  }\n\n  .pe-lg-43 {\n    padding-right: 21rem !important;\n  }\n\n  .pe-lg-44 {\n    padding-right: 21.5rem !important;\n  }\n\n  .pe-lg-45 {\n    padding-right: 22rem !important;\n  }\n\n  .pe-lg-46 {\n    padding-right: 22.5rem !important;\n  }\n\n  .pe-lg-47 {\n    padding-right: 23rem !important;\n  }\n\n  .pe-lg-48 {\n    padding-right: 23.5rem !important;\n  }\n\n  .pe-lg-49 {\n    padding-right: 24rem !important;\n  }\n\n  .pe-lg-50 {\n    padding-right: 24.5rem !important;\n  }\n\n  .pe-lg-51 {\n    padding-right: 25rem !important;\n  }\n\n  .pe-lg-52 {\n    padding-right: 25.5rem !important;\n  }\n\n  .pe-lg-53 {\n    padding-right: 26rem !important;\n  }\n\n  .pe-lg-54 {\n    padding-right: 26.5rem !important;\n  }\n\n  .pe-lg-55 {\n    padding-right: 27rem !important;\n  }\n\n  .pe-lg-56 {\n    padding-right: 27.5rem !important;\n  }\n\n  .pe-lg-57 {\n    padding-right: 28rem !important;\n  }\n\n  .pe-lg-58 {\n    padding-right: 28.5rem !important;\n  }\n\n  .pe-lg-59 {\n    padding-right: 29rem !important;\n  }\n\n  .pe-lg-60 {\n    padding-right: 29.5rem !important;\n  }\n\n  .pe-lg-61 {\n    padding-right: 30rem !important;\n  }\n\n  .pe-lg-62 {\n    padding-right: 30.5rem !important;\n  }\n\n  .pe-lg-63 {\n    padding-right: 31rem !important;\n  }\n\n  .pe-lg-64 {\n    padding-right: 31.5rem !important;\n  }\n\n  .pe-lg-65 {\n    padding-right: 32rem !important;\n  }\n\n  .pe-lg-66 {\n    padding-right: 32.5rem !important;\n  }\n\n  .pe-lg-67 {\n    padding-right: 33rem !important;\n  }\n\n  .pe-lg-68 {\n    padding-right: 33.5rem !important;\n  }\n\n  .pe-lg-69 {\n    padding-right: 34rem !important;\n  }\n\n  .pe-lg-70 {\n    padding-right: 34.5rem !important;\n  }\n\n  .pe-lg-71 {\n    padding-right: 35rem !important;\n  }\n\n  .pe-lg-72 {\n    padding-right: 35.5rem !important;\n  }\n\n  .pe-lg-73 {\n    padding-right: 36rem !important;\n  }\n\n  .pe-lg-74 {\n    padding-right: 36.5rem !important;\n  }\n\n  .pe-lg-75 {\n    padding-right: 37rem !important;\n  }\n\n  .pe-lg-76 {\n    padding-right: 37.5rem !important;\n  }\n\n  .pe-lg-77 {\n    padding-right: 38rem !important;\n  }\n\n  .pe-lg-78 {\n    padding-right: 38.5rem !important;\n  }\n\n  .pe-lg-79 {\n    padding-right: 39rem !important;\n  }\n\n  .pe-lg-80 {\n    padding-right: 39.5rem !important;\n  }\n\n  .pe-lg-81 {\n    padding-right: 40rem !important;\n  }\n\n  .pe-lg-82 {\n    padding-right: 40.5rem !important;\n  }\n\n  .pe-lg-83 {\n    padding-right: 41rem !important;\n  }\n\n  .pe-lg-84 {\n    padding-right: 41.5rem !important;\n  }\n\n  .pe-lg-85 {\n    padding-right: 42rem !important;\n  }\n\n  .pe-lg-86 {\n    padding-right: 42.5rem !important;\n  }\n\n  .pe-lg-87 {\n    padding-right: 43rem !important;\n  }\n\n  .pe-lg-88 {\n    padding-right: 43.5rem !important;\n  }\n\n  .pe-lg-89 {\n    padding-right: 44rem !important;\n  }\n\n  .pe-lg-90 {\n    padding-right: 44.5rem !important;\n  }\n\n  .pe-lg-91 {\n    padding-right: 45rem !important;\n  }\n\n  .pe-lg-92 {\n    padding-right: 45.5rem !important;\n  }\n\n  .pe-lg-93 {\n    padding-right: 46rem !important;\n  }\n\n  .pe-lg-94 {\n    padding-right: 46.5rem !important;\n  }\n\n  .pe-lg-95 {\n    padding-right: 47rem !important;\n  }\n\n  .pe-lg-96 {\n    padding-right: 47.5rem !important;\n  }\n\n  .pe-lg-97 {\n    padding-right: 48rem !important;\n  }\n\n  .pe-lg-98 {\n    padding-right: 48.5rem !important;\n  }\n\n  .pe-lg-99 {\n    padding-right: 49rem !important;\n  }\n\n  .pe-lg-100 {\n    padding-right: 49.5rem !important;\n  }\n\n  .pe-lg-101 {\n    padding-right: 50rem !important;\n  }\n\n  .pe-lg-102 {\n    padding-right: 50.5rem !important;\n  }\n\n  .pe-lg-103 {\n    padding-right: 51rem !important;\n  }\n\n  .pe-lg-104 {\n    padding-right: 51.5rem !important;\n  }\n\n  .pe-lg-105 {\n    padding-right: 52rem !important;\n  }\n\n  .pe-lg-106 {\n    padding-right: 52.5rem !important;\n  }\n\n  .pe-lg-107 {\n    padding-right: 53rem !important;\n  }\n\n  .pe-lg-108 {\n    padding-right: 53.5rem !important;\n  }\n\n  .pe-lg-109 {\n    padding-right: 54rem !important;\n  }\n\n  .pe-lg-110 {\n    padding-right: 54.5rem !important;\n  }\n\n  .pe-lg-111 {\n    padding-right: 55rem !important;\n  }\n\n  .pe-lg-112 {\n    padding-right: 55.5rem !important;\n  }\n\n  .pe-lg-113 {\n    padding-right: 56rem !important;\n  }\n\n  .pe-lg-114 {\n    padding-right: 56.5rem !important;\n  }\n\n  .pe-lg-115 {\n    padding-right: 57rem !important;\n  }\n\n  .pe-lg-116 {\n    padding-right: 57.5rem !important;\n  }\n\n  .pe-lg-117 {\n    padding-right: 58rem !important;\n  }\n\n  .pe-lg-118 {\n    padding-right: 58.5rem !important;\n  }\n\n  .pe-lg-119 {\n    padding-right: 59rem !important;\n  }\n\n  .pe-lg-120 {\n    padding-right: 59.5rem !important;\n  }\n\n  .pe-lg-121 {\n    padding-right: 60rem !important;\n  }\n\n  .pe-lg-122 {\n    padding-right: 60.5rem !important;\n  }\n\n  .pe-lg-123 {\n    padding-right: 61rem !important;\n  }\n\n  .pe-lg-124 {\n    padding-right: 61.5rem !important;\n  }\n\n  .pe-lg-125 {\n    padding-right: 62rem !important;\n  }\n\n  .pe-lg-126 {\n    padding-right: 62.5rem !important;\n  }\n\n  .pe-lg-127 {\n    padding-right: 63rem !important;\n  }\n\n  .pe-lg-128 {\n    padding-right: 63.5rem !important;\n  }\n\n  .pe-lg-129 {\n    padding-right: 64rem !important;\n  }\n\n  .pe-lg-130 {\n    padding-right: 64.5rem !important;\n  }\n\n  .pe-lg-131 {\n    padding-right: 65rem !important;\n  }\n\n  .pe-lg-132 {\n    padding-right: 65.5rem !important;\n  }\n\n  .pe-lg-133 {\n    padding-right: 66rem !important;\n  }\n\n  .pe-lg-134 {\n    padding-right: 66.5rem !important;\n  }\n\n  .pe-lg-135 {\n    padding-right: 67rem !important;\n  }\n\n  .pe-lg-136 {\n    padding-right: 67.5rem !important;\n  }\n\n  .pe-lg-137 {\n    padding-right: 68rem !important;\n  }\n\n  .pe-lg-138 {\n    padding-right: 68.5rem !important;\n  }\n\n  .pe-lg-139 {\n    padding-right: 69rem !important;\n  }\n\n  .pe-lg-140 {\n    padding-right: 69.5rem !important;\n  }\n\n  .pe-lg-141 {\n    padding-right: 70rem !important;\n  }\n\n  .pe-lg-142 {\n    padding-right: 70.5rem !important;\n  }\n\n  .pe-lg-143 {\n    padding-right: 71rem !important;\n  }\n\n  .pe-lg-144 {\n    padding-right: 71.5rem !important;\n  }\n\n  .pe-lg-145 {\n    padding-right: 72rem !important;\n  }\n\n  .pe-lg-146 {\n    padding-right: 72.5rem !important;\n  }\n\n  .pe-lg-147 {\n    padding-right: 73rem !important;\n  }\n\n  .pe-lg-148 {\n    padding-right: 73.5rem !important;\n  }\n\n  .pe-lg-149 {\n    padding-right: 74rem !important;\n  }\n\n  .pe-lg-150 {\n    padding-right: 74.5rem !important;\n  }\n\n  .pe-lg-151 {\n    padding-right: 75rem !important;\n  }\n\n  .pe-lg-152 {\n    padding-right: 75.5rem !important;\n  }\n\n  .pe-lg-153 {\n    padding-right: 76rem !important;\n  }\n\n  .pe-lg-154 {\n    padding-right: 76.5rem !important;\n  }\n\n  .pe-lg-155 {\n    padding-right: 77rem !important;\n  }\n\n  .pe-lg-156 {\n    padding-right: 77.5rem !important;\n  }\n\n  .pe-lg-157 {\n    padding-right: 78rem !important;\n  }\n\n  .pe-lg-158 {\n    padding-right: 78.5rem !important;\n  }\n\n  .pe-lg-159 {\n    padding-right: 79rem !important;\n  }\n\n  .pe-lg-160 {\n    padding-right: 79.5rem !important;\n  }\n\n  .px-lg-0 {\n    padding-left: 0rem !important;\n    padding-right: 0rem !important;\n  }\n\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .px-lg-3 {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .px-lg-5 {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n\n  .px-lg-6 {\n    padding-left: 2.5rem !important;\n    padding-right: 2.5rem !important;\n  }\n\n  .px-lg-7 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n  }\n\n  .px-lg-8 {\n    padding-left: 3.5rem !important;\n    padding-right: 3.5rem !important;\n  }\n\n  .px-lg-9 {\n    padding-left: 4rem !important;\n    padding-right: 4rem !important;\n  }\n\n  .px-lg-10 {\n    padding-left: 4.5rem !important;\n    padding-right: 4.5rem !important;\n  }\n\n  .px-lg-11 {\n    padding-left: 5rem !important;\n    padding-right: 5rem !important;\n  }\n\n  .px-lg-12 {\n    padding-left: 5.5rem !important;\n    padding-right: 5.5rem !important;\n  }\n\n  .px-lg-13 {\n    padding-left: 6rem !important;\n    padding-right: 6rem !important;\n  }\n\n  .px-lg-14 {\n    padding-left: 6.5rem !important;\n    padding-right: 6.5rem !important;\n  }\n\n  .px-lg-15 {\n    padding-left: 7rem !important;\n    padding-right: 7rem !important;\n  }\n\n  .px-lg-16 {\n    padding-left: 7.5rem !important;\n    padding-right: 7.5rem !important;\n  }\n\n  .px-lg-17 {\n    padding-left: 8rem !important;\n    padding-right: 8rem !important;\n  }\n\n  .px-lg-18 {\n    padding-left: 8.5rem !important;\n    padding-right: 8.5rem !important;\n  }\n\n  .px-lg-19 {\n    padding-left: 9rem !important;\n    padding-right: 9rem !important;\n  }\n\n  .px-lg-20 {\n    padding-left: 9.5rem !important;\n    padding-right: 9.5rem !important;\n  }\n\n  .px-lg-21 {\n    padding-left: 10rem !important;\n    padding-right: 10rem !important;\n  }\n\n  .px-lg-22 {\n    padding-left: 10.5rem !important;\n    padding-right: 10.5rem !important;\n  }\n\n  .px-lg-23 {\n    padding-left: 11rem !important;\n    padding-right: 11rem !important;\n  }\n\n  .px-lg-24 {\n    padding-left: 11.5rem !important;\n    padding-right: 11.5rem !important;\n  }\n\n  .px-lg-25 {\n    padding-left: 12rem !important;\n    padding-right: 12rem !important;\n  }\n\n  .px-lg-26 {\n    padding-left: 12.5rem !important;\n    padding-right: 12.5rem !important;\n  }\n\n  .px-lg-27 {\n    padding-left: 13rem !important;\n    padding-right: 13rem !important;\n  }\n\n  .px-lg-28 {\n    padding-left: 13.5rem !important;\n    padding-right: 13.5rem !important;\n  }\n\n  .px-lg-29 {\n    padding-left: 14rem !important;\n    padding-right: 14rem !important;\n  }\n\n  .px-lg-30 {\n    padding-left: 14.5rem !important;\n    padding-right: 14.5rem !important;\n  }\n\n  .px-lg-31 {\n    padding-left: 15rem !important;\n    padding-right: 15rem !important;\n  }\n\n  .px-lg-32 {\n    padding-left: 15.5rem !important;\n    padding-right: 15.5rem !important;\n  }\n\n  .px-lg-33 {\n    padding-left: 16rem !important;\n    padding-right: 16rem !important;\n  }\n\n  .px-lg-34 {\n    padding-left: 16.5rem !important;\n    padding-right: 16.5rem !important;\n  }\n\n  .px-lg-35 {\n    padding-left: 17rem !important;\n    padding-right: 17rem !important;\n  }\n\n  .px-lg-36 {\n    padding-left: 17.5rem !important;\n    padding-right: 17.5rem !important;\n  }\n\n  .px-lg-37 {\n    padding-left: 18rem !important;\n    padding-right: 18rem !important;\n  }\n\n  .px-lg-38 {\n    padding-left: 18.5rem !important;\n    padding-right: 18.5rem !important;\n  }\n\n  .px-lg-39 {\n    padding-left: 19rem !important;\n    padding-right: 19rem !important;\n  }\n\n  .px-lg-40 {\n    padding-left: 19.5rem !important;\n    padding-right: 19.5rem !important;\n  }\n\n  .px-lg-41 {\n    padding-left: 20rem !important;\n    padding-right: 20rem !important;\n  }\n\n  .px-lg-42 {\n    padding-left: 20.5rem !important;\n    padding-right: 20.5rem !important;\n  }\n\n  .px-lg-43 {\n    padding-left: 21rem !important;\n    padding-right: 21rem !important;\n  }\n\n  .px-lg-44 {\n    padding-left: 21.5rem !important;\n    padding-right: 21.5rem !important;\n  }\n\n  .px-lg-45 {\n    padding-left: 22rem !important;\n    padding-right: 22rem !important;\n  }\n\n  .px-lg-46 {\n    padding-left: 22.5rem !important;\n    padding-right: 22.5rem !important;\n  }\n\n  .px-lg-47 {\n    padding-left: 23rem !important;\n    padding-right: 23rem !important;\n  }\n\n  .px-lg-48 {\n    padding-left: 23.5rem !important;\n    padding-right: 23.5rem !important;\n  }\n\n  .px-lg-49 {\n    padding-left: 24rem !important;\n    padding-right: 24rem !important;\n  }\n\n  .px-lg-50 {\n    padding-left: 24.5rem !important;\n    padding-right: 24.5rem !important;\n  }\n\n  .px-lg-51 {\n    padding-left: 25rem !important;\n    padding-right: 25rem !important;\n  }\n\n  .px-lg-52 {\n    padding-left: 25.5rem !important;\n    padding-right: 25.5rem !important;\n  }\n\n  .px-lg-53 {\n    padding-left: 26rem !important;\n    padding-right: 26rem !important;\n  }\n\n  .px-lg-54 {\n    padding-left: 26.5rem !important;\n    padding-right: 26.5rem !important;\n  }\n\n  .px-lg-55 {\n    padding-left: 27rem !important;\n    padding-right: 27rem !important;\n  }\n\n  .px-lg-56 {\n    padding-left: 27.5rem !important;\n    padding-right: 27.5rem !important;\n  }\n\n  .px-lg-57 {\n    padding-left: 28rem !important;\n    padding-right: 28rem !important;\n  }\n\n  .px-lg-58 {\n    padding-left: 28.5rem !important;\n    padding-right: 28.5rem !important;\n  }\n\n  .px-lg-59 {\n    padding-left: 29rem !important;\n    padding-right: 29rem !important;\n  }\n\n  .px-lg-60 {\n    padding-left: 29.5rem !important;\n    padding-right: 29.5rem !important;\n  }\n\n  .px-lg-61 {\n    padding-left: 30rem !important;\n    padding-right: 30rem !important;\n  }\n\n  .px-lg-62 {\n    padding-left: 30.5rem !important;\n    padding-right: 30.5rem !important;\n  }\n\n  .px-lg-63 {\n    padding-left: 31rem !important;\n    padding-right: 31rem !important;\n  }\n\n  .px-lg-64 {\n    padding-left: 31.5rem !important;\n    padding-right: 31.5rem !important;\n  }\n\n  .px-lg-65 {\n    padding-left: 32rem !important;\n    padding-right: 32rem !important;\n  }\n\n  .px-lg-66 {\n    padding-left: 32.5rem !important;\n    padding-right: 32.5rem !important;\n  }\n\n  .px-lg-67 {\n    padding-left: 33rem !important;\n    padding-right: 33rem !important;\n  }\n\n  .px-lg-68 {\n    padding-left: 33.5rem !important;\n    padding-right: 33.5rem !important;\n  }\n\n  .px-lg-69 {\n    padding-left: 34rem !important;\n    padding-right: 34rem !important;\n  }\n\n  .px-lg-70 {\n    padding-left: 34.5rem !important;\n    padding-right: 34.5rem !important;\n  }\n\n  .px-lg-71 {\n    padding-left: 35rem !important;\n    padding-right: 35rem !important;\n  }\n\n  .px-lg-72 {\n    padding-left: 35.5rem !important;\n    padding-right: 35.5rem !important;\n  }\n\n  .px-lg-73 {\n    padding-left: 36rem !important;\n    padding-right: 36rem !important;\n  }\n\n  .px-lg-74 {\n    padding-left: 36.5rem !important;\n    padding-right: 36.5rem !important;\n  }\n\n  .px-lg-75 {\n    padding-left: 37rem !important;\n    padding-right: 37rem !important;\n  }\n\n  .px-lg-76 {\n    padding-left: 37.5rem !important;\n    padding-right: 37.5rem !important;\n  }\n\n  .px-lg-77 {\n    padding-left: 38rem !important;\n    padding-right: 38rem !important;\n  }\n\n  .px-lg-78 {\n    padding-left: 38.5rem !important;\n    padding-right: 38.5rem !important;\n  }\n\n  .px-lg-79 {\n    padding-left: 39rem !important;\n    padding-right: 39rem !important;\n  }\n\n  .px-lg-80 {\n    padding-left: 39.5rem !important;\n    padding-right: 39.5rem !important;\n  }\n\n  .px-lg-81 {\n    padding-left: 40rem !important;\n    padding-right: 40rem !important;\n  }\n\n  .px-lg-82 {\n    padding-left: 40.5rem !important;\n    padding-right: 40.5rem !important;\n  }\n\n  .px-lg-83 {\n    padding-left: 41rem !important;\n    padding-right: 41rem !important;\n  }\n\n  .px-lg-84 {\n    padding-left: 41.5rem !important;\n    padding-right: 41.5rem !important;\n  }\n\n  .px-lg-85 {\n    padding-left: 42rem !important;\n    padding-right: 42rem !important;\n  }\n\n  .px-lg-86 {\n    padding-left: 42.5rem !important;\n    padding-right: 42.5rem !important;\n  }\n\n  .px-lg-87 {\n    padding-left: 43rem !important;\n    padding-right: 43rem !important;\n  }\n\n  .px-lg-88 {\n    padding-left: 43.5rem !important;\n    padding-right: 43.5rem !important;\n  }\n\n  .px-lg-89 {\n    padding-left: 44rem !important;\n    padding-right: 44rem !important;\n  }\n\n  .px-lg-90 {\n    padding-left: 44.5rem !important;\n    padding-right: 44.5rem !important;\n  }\n\n  .px-lg-91 {\n    padding-left: 45rem !important;\n    padding-right: 45rem !important;\n  }\n\n  .px-lg-92 {\n    padding-left: 45.5rem !important;\n    padding-right: 45.5rem !important;\n  }\n\n  .px-lg-93 {\n    padding-left: 46rem !important;\n    padding-right: 46rem !important;\n  }\n\n  .px-lg-94 {\n    padding-left: 46.5rem !important;\n    padding-right: 46.5rem !important;\n  }\n\n  .px-lg-95 {\n    padding-left: 47rem !important;\n    padding-right: 47rem !important;\n  }\n\n  .px-lg-96 {\n    padding-left: 47.5rem !important;\n    padding-right: 47.5rem !important;\n  }\n\n  .px-lg-97 {\n    padding-left: 48rem !important;\n    padding-right: 48rem !important;\n  }\n\n  .px-lg-98 {\n    padding-left: 48.5rem !important;\n    padding-right: 48.5rem !important;\n  }\n\n  .px-lg-99 {\n    padding-left: 49rem !important;\n    padding-right: 49rem !important;\n  }\n\n  .px-lg-100 {\n    padding-left: 49.5rem !important;\n    padding-right: 49.5rem !important;\n  }\n\n  .px-lg-101 {\n    padding-left: 50rem !important;\n    padding-right: 50rem !important;\n  }\n\n  .px-lg-102 {\n    padding-left: 50.5rem !important;\n    padding-right: 50.5rem !important;\n  }\n\n  .px-lg-103 {\n    padding-left: 51rem !important;\n    padding-right: 51rem !important;\n  }\n\n  .px-lg-104 {\n    padding-left: 51.5rem !important;\n    padding-right: 51.5rem !important;\n  }\n\n  .px-lg-105 {\n    padding-left: 52rem !important;\n    padding-right: 52rem !important;\n  }\n\n  .px-lg-106 {\n    padding-left: 52.5rem !important;\n    padding-right: 52.5rem !important;\n  }\n\n  .px-lg-107 {\n    padding-left: 53rem !important;\n    padding-right: 53rem !important;\n  }\n\n  .px-lg-108 {\n    padding-left: 53.5rem !important;\n    padding-right: 53.5rem !important;\n  }\n\n  .px-lg-109 {\n    padding-left: 54rem !important;\n    padding-right: 54rem !important;\n  }\n\n  .px-lg-110 {\n    padding-left: 54.5rem !important;\n    padding-right: 54.5rem !important;\n  }\n\n  .px-lg-111 {\n    padding-left: 55rem !important;\n    padding-right: 55rem !important;\n  }\n\n  .px-lg-112 {\n    padding-left: 55.5rem !important;\n    padding-right: 55.5rem !important;\n  }\n\n  .px-lg-113 {\n    padding-left: 56rem !important;\n    padding-right: 56rem !important;\n  }\n\n  .px-lg-114 {\n    padding-left: 56.5rem !important;\n    padding-right: 56.5rem !important;\n  }\n\n  .px-lg-115 {\n    padding-left: 57rem !important;\n    padding-right: 57rem !important;\n  }\n\n  .px-lg-116 {\n    padding-left: 57.5rem !important;\n    padding-right: 57.5rem !important;\n  }\n\n  .px-lg-117 {\n    padding-left: 58rem !important;\n    padding-right: 58rem !important;\n  }\n\n  .px-lg-118 {\n    padding-left: 58.5rem !important;\n    padding-right: 58.5rem !important;\n  }\n\n  .px-lg-119 {\n    padding-left: 59rem !important;\n    padding-right: 59rem !important;\n  }\n\n  .px-lg-120 {\n    padding-left: 59.5rem !important;\n    padding-right: 59.5rem !important;\n  }\n\n  .px-lg-121 {\n    padding-left: 60rem !important;\n    padding-right: 60rem !important;\n  }\n\n  .px-lg-122 {\n    padding-left: 60.5rem !important;\n    padding-right: 60.5rem !important;\n  }\n\n  .px-lg-123 {\n    padding-left: 61rem !important;\n    padding-right: 61rem !important;\n  }\n\n  .px-lg-124 {\n    padding-left: 61.5rem !important;\n    padding-right: 61.5rem !important;\n  }\n\n  .px-lg-125 {\n    padding-left: 62rem !important;\n    padding-right: 62rem !important;\n  }\n\n  .px-lg-126 {\n    padding-left: 62.5rem !important;\n    padding-right: 62.5rem !important;\n  }\n\n  .px-lg-127 {\n    padding-left: 63rem !important;\n    padding-right: 63rem !important;\n  }\n\n  .px-lg-128 {\n    padding-left: 63.5rem !important;\n    padding-right: 63.5rem !important;\n  }\n\n  .px-lg-129 {\n    padding-left: 64rem !important;\n    padding-right: 64rem !important;\n  }\n\n  .px-lg-130 {\n    padding-left: 64.5rem !important;\n    padding-right: 64.5rem !important;\n  }\n\n  .px-lg-131 {\n    padding-left: 65rem !important;\n    padding-right: 65rem !important;\n  }\n\n  .px-lg-132 {\n    padding-left: 65.5rem !important;\n    padding-right: 65.5rem !important;\n  }\n\n  .px-lg-133 {\n    padding-left: 66rem !important;\n    padding-right: 66rem !important;\n  }\n\n  .px-lg-134 {\n    padding-left: 66.5rem !important;\n    padding-right: 66.5rem !important;\n  }\n\n  .px-lg-135 {\n    padding-left: 67rem !important;\n    padding-right: 67rem !important;\n  }\n\n  .px-lg-136 {\n    padding-left: 67.5rem !important;\n    padding-right: 67.5rem !important;\n  }\n\n  .px-lg-137 {\n    padding-left: 68rem !important;\n    padding-right: 68rem !important;\n  }\n\n  .px-lg-138 {\n    padding-left: 68.5rem !important;\n    padding-right: 68.5rem !important;\n  }\n\n  .px-lg-139 {\n    padding-left: 69rem !important;\n    padding-right: 69rem !important;\n  }\n\n  .px-lg-140 {\n    padding-left: 69.5rem !important;\n    padding-right: 69.5rem !important;\n  }\n\n  .px-lg-141 {\n    padding-left: 70rem !important;\n    padding-right: 70rem !important;\n  }\n\n  .px-lg-142 {\n    padding-left: 70.5rem !important;\n    padding-right: 70.5rem !important;\n  }\n\n  .px-lg-143 {\n    padding-left: 71rem !important;\n    padding-right: 71rem !important;\n  }\n\n  .px-lg-144 {\n    padding-left: 71.5rem !important;\n    padding-right: 71.5rem !important;\n  }\n\n  .px-lg-145 {\n    padding-left: 72rem !important;\n    padding-right: 72rem !important;\n  }\n\n  .px-lg-146 {\n    padding-left: 72.5rem !important;\n    padding-right: 72.5rem !important;\n  }\n\n  .px-lg-147 {\n    padding-left: 73rem !important;\n    padding-right: 73rem !important;\n  }\n\n  .px-lg-148 {\n    padding-left: 73.5rem !important;\n    padding-right: 73.5rem !important;\n  }\n\n  .px-lg-149 {\n    padding-left: 74rem !important;\n    padding-right: 74rem !important;\n  }\n\n  .px-lg-150 {\n    padding-left: 74.5rem !important;\n    padding-right: 74.5rem !important;\n  }\n\n  .px-lg-151 {\n    padding-left: 75rem !important;\n    padding-right: 75rem !important;\n  }\n\n  .px-lg-152 {\n    padding-left: 75.5rem !important;\n    padding-right: 75.5rem !important;\n  }\n\n  .px-lg-153 {\n    padding-left: 76rem !important;\n    padding-right: 76rem !important;\n  }\n\n  .px-lg-154 {\n    padding-left: 76.5rem !important;\n    padding-right: 76.5rem !important;\n  }\n\n  .px-lg-155 {\n    padding-left: 77rem !important;\n    padding-right: 77rem !important;\n  }\n\n  .px-lg-156 {\n    padding-left: 77.5rem !important;\n    padding-right: 77.5rem !important;\n  }\n\n  .px-lg-157 {\n    padding-left: 78rem !important;\n    padding-right: 78rem !important;\n  }\n\n  .px-lg-158 {\n    padding-left: 78.5rem !important;\n    padding-right: 78.5rem !important;\n  }\n\n  .px-lg-159 {\n    padding-left: 79rem !important;\n    padding-right: 79rem !important;\n  }\n\n  .px-lg-160 {\n    padding-left: 79.5rem !important;\n    padding-right: 79.5rem !important;\n  }\n\n  .py-lg-0 {\n    padding-top: 0rem !important;\n    padding-bottom: 0rem !important;\n  }\n\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-lg-5 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-lg-6 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-lg-7 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-lg-8 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-lg-9 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-lg-10 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-lg-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .py-lg-12 {\n    padding-top: 5.5rem !important;\n    padding-bottom: 5.5rem !important;\n  }\n\n  .py-lg-13 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n\n  .py-lg-14 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n\n  .py-lg-15 {\n    padding-top: 7rem !important;\n    padding-bottom: 7rem !important;\n  }\n\n  .py-lg-16 {\n    padding-top: 7.5rem !important;\n    padding-bottom: 7.5rem !important;\n  }\n\n  .py-lg-17 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n\n  .py-lg-18 {\n    padding-top: 8.5rem !important;\n    padding-bottom: 8.5rem !important;\n  }\n\n  .py-lg-19 {\n    padding-top: 9rem !important;\n    padding-bottom: 9rem !important;\n  }\n\n  .py-lg-20 {\n    padding-top: 9.5rem !important;\n    padding-bottom: 9.5rem !important;\n  }\n\n  .py-lg-21 {\n    padding-top: 10rem !important;\n    padding-bottom: 10rem !important;\n  }\n\n  .py-lg-22 {\n    padding-top: 10.5rem !important;\n    padding-bottom: 10.5rem !important;\n  }\n\n  .py-lg-23 {\n    padding-top: 11rem !important;\n    padding-bottom: 11rem !important;\n  }\n\n  .py-lg-24 {\n    padding-top: 11.5rem !important;\n    padding-bottom: 11.5rem !important;\n  }\n\n  .py-lg-25 {\n    padding-top: 12rem !important;\n    padding-bottom: 12rem !important;\n  }\n\n  .py-lg-26 {\n    padding-top: 12.5rem !important;\n    padding-bottom: 12.5rem !important;\n  }\n\n  .py-lg-27 {\n    padding-top: 13rem !important;\n    padding-bottom: 13rem !important;\n  }\n\n  .py-lg-28 {\n    padding-top: 13.5rem !important;\n    padding-bottom: 13.5rem !important;\n  }\n\n  .py-lg-29 {\n    padding-top: 14rem !important;\n    padding-bottom: 14rem !important;\n  }\n\n  .py-lg-30 {\n    padding-top: 14.5rem !important;\n    padding-bottom: 14.5rem !important;\n  }\n\n  .py-lg-31 {\n    padding-top: 15rem !important;\n    padding-bottom: 15rem !important;\n  }\n\n  .py-lg-32 {\n    padding-top: 15.5rem !important;\n    padding-bottom: 15.5rem !important;\n  }\n\n  .py-lg-33 {\n    padding-top: 16rem !important;\n    padding-bottom: 16rem !important;\n  }\n\n  .py-lg-34 {\n    padding-top: 16.5rem !important;\n    padding-bottom: 16.5rem !important;\n  }\n\n  .py-lg-35 {\n    padding-top: 17rem !important;\n    padding-bottom: 17rem !important;\n  }\n\n  .py-lg-36 {\n    padding-top: 17.5rem !important;\n    padding-bottom: 17.5rem !important;\n  }\n\n  .py-lg-37 {\n    padding-top: 18rem !important;\n    padding-bottom: 18rem !important;\n  }\n\n  .py-lg-38 {\n    padding-top: 18.5rem !important;\n    padding-bottom: 18.5rem !important;\n  }\n\n  .py-lg-39 {\n    padding-top: 19rem !important;\n    padding-bottom: 19rem !important;\n  }\n\n  .py-lg-40 {\n    padding-top: 19.5rem !important;\n    padding-bottom: 19.5rem !important;\n  }\n\n  .py-lg-41 {\n    padding-top: 20rem !important;\n    padding-bottom: 20rem !important;\n  }\n\n  .py-lg-42 {\n    padding-top: 20.5rem !important;\n    padding-bottom: 20.5rem !important;\n  }\n\n  .py-lg-43 {\n    padding-top: 21rem !important;\n    padding-bottom: 21rem !important;\n  }\n\n  .py-lg-44 {\n    padding-top: 21.5rem !important;\n    padding-bottom: 21.5rem !important;\n  }\n\n  .py-lg-45 {\n    padding-top: 22rem !important;\n    padding-bottom: 22rem !important;\n  }\n\n  .py-lg-46 {\n    padding-top: 22.5rem !important;\n    padding-bottom: 22.5rem !important;\n  }\n\n  .py-lg-47 {\n    padding-top: 23rem !important;\n    padding-bottom: 23rem !important;\n  }\n\n  .py-lg-48 {\n    padding-top: 23.5rem !important;\n    padding-bottom: 23.5rem !important;\n  }\n\n  .py-lg-49 {\n    padding-top: 24rem !important;\n    padding-bottom: 24rem !important;\n  }\n\n  .py-lg-50 {\n    padding-top: 24.5rem !important;\n    padding-bottom: 24.5rem !important;\n  }\n\n  .py-lg-51 {\n    padding-top: 25rem !important;\n    padding-bottom: 25rem !important;\n  }\n\n  .py-lg-52 {\n    padding-top: 25.5rem !important;\n    padding-bottom: 25.5rem !important;\n  }\n\n  .py-lg-53 {\n    padding-top: 26rem !important;\n    padding-bottom: 26rem !important;\n  }\n\n  .py-lg-54 {\n    padding-top: 26.5rem !important;\n    padding-bottom: 26.5rem !important;\n  }\n\n  .py-lg-55 {\n    padding-top: 27rem !important;\n    padding-bottom: 27rem !important;\n  }\n\n  .py-lg-56 {\n    padding-top: 27.5rem !important;\n    padding-bottom: 27.5rem !important;\n  }\n\n  .py-lg-57 {\n    padding-top: 28rem !important;\n    padding-bottom: 28rem !important;\n  }\n\n  .py-lg-58 {\n    padding-top: 28.5rem !important;\n    padding-bottom: 28.5rem !important;\n  }\n\n  .py-lg-59 {\n    padding-top: 29rem !important;\n    padding-bottom: 29rem !important;\n  }\n\n  .py-lg-60 {\n    padding-top: 29.5rem !important;\n    padding-bottom: 29.5rem !important;\n  }\n\n  .py-lg-61 {\n    padding-top: 30rem !important;\n    padding-bottom: 30rem !important;\n  }\n\n  .py-lg-62 {\n    padding-top: 30.5rem !important;\n    padding-bottom: 30.5rem !important;\n  }\n\n  .py-lg-63 {\n    padding-top: 31rem !important;\n    padding-bottom: 31rem !important;\n  }\n\n  .py-lg-64 {\n    padding-top: 31.5rem !important;\n    padding-bottom: 31.5rem !important;\n  }\n\n  .py-lg-65 {\n    padding-top: 32rem !important;\n    padding-bottom: 32rem !important;\n  }\n\n  .py-lg-66 {\n    padding-top: 32.5rem !important;\n    padding-bottom: 32.5rem !important;\n  }\n\n  .py-lg-67 {\n    padding-top: 33rem !important;\n    padding-bottom: 33rem !important;\n  }\n\n  .py-lg-68 {\n    padding-top: 33.5rem !important;\n    padding-bottom: 33.5rem !important;\n  }\n\n  .py-lg-69 {\n    padding-top: 34rem !important;\n    padding-bottom: 34rem !important;\n  }\n\n  .py-lg-70 {\n    padding-top: 34.5rem !important;\n    padding-bottom: 34.5rem !important;\n  }\n\n  .py-lg-71 {\n    padding-top: 35rem !important;\n    padding-bottom: 35rem !important;\n  }\n\n  .py-lg-72 {\n    padding-top: 35.5rem !important;\n    padding-bottom: 35.5rem !important;\n  }\n\n  .py-lg-73 {\n    padding-top: 36rem !important;\n    padding-bottom: 36rem !important;\n  }\n\n  .py-lg-74 {\n    padding-top: 36.5rem !important;\n    padding-bottom: 36.5rem !important;\n  }\n\n  .py-lg-75 {\n    padding-top: 37rem !important;\n    padding-bottom: 37rem !important;\n  }\n\n  .py-lg-76 {\n    padding-top: 37.5rem !important;\n    padding-bottom: 37.5rem !important;\n  }\n\n  .py-lg-77 {\n    padding-top: 38rem !important;\n    padding-bottom: 38rem !important;\n  }\n\n  .py-lg-78 {\n    padding-top: 38.5rem !important;\n    padding-bottom: 38.5rem !important;\n  }\n\n  .py-lg-79 {\n    padding-top: 39rem !important;\n    padding-bottom: 39rem !important;\n  }\n\n  .py-lg-80 {\n    padding-top: 39.5rem !important;\n    padding-bottom: 39.5rem !important;\n  }\n\n  .py-lg-81 {\n    padding-top: 40rem !important;\n    padding-bottom: 40rem !important;\n  }\n\n  .py-lg-82 {\n    padding-top: 40.5rem !important;\n    padding-bottom: 40.5rem !important;\n  }\n\n  .py-lg-83 {\n    padding-top: 41rem !important;\n    padding-bottom: 41rem !important;\n  }\n\n  .py-lg-84 {\n    padding-top: 41.5rem !important;\n    padding-bottom: 41.5rem !important;\n  }\n\n  .py-lg-85 {\n    padding-top: 42rem !important;\n    padding-bottom: 42rem !important;\n  }\n\n  .py-lg-86 {\n    padding-top: 42.5rem !important;\n    padding-bottom: 42.5rem !important;\n  }\n\n  .py-lg-87 {\n    padding-top: 43rem !important;\n    padding-bottom: 43rem !important;\n  }\n\n  .py-lg-88 {\n    padding-top: 43.5rem !important;\n    padding-bottom: 43.5rem !important;\n  }\n\n  .py-lg-89 {\n    padding-top: 44rem !important;\n    padding-bottom: 44rem !important;\n  }\n\n  .py-lg-90 {\n    padding-top: 44.5rem !important;\n    padding-bottom: 44.5rem !important;\n  }\n\n  .py-lg-91 {\n    padding-top: 45rem !important;\n    padding-bottom: 45rem !important;\n  }\n\n  .py-lg-92 {\n    padding-top: 45.5rem !important;\n    padding-bottom: 45.5rem !important;\n  }\n\n  .py-lg-93 {\n    padding-top: 46rem !important;\n    padding-bottom: 46rem !important;\n  }\n\n  .py-lg-94 {\n    padding-top: 46.5rem !important;\n    padding-bottom: 46.5rem !important;\n  }\n\n  .py-lg-95 {\n    padding-top: 47rem !important;\n    padding-bottom: 47rem !important;\n  }\n\n  .py-lg-96 {\n    padding-top: 47.5rem !important;\n    padding-bottom: 47.5rem !important;\n  }\n\n  .py-lg-97 {\n    padding-top: 48rem !important;\n    padding-bottom: 48rem !important;\n  }\n\n  .py-lg-98 {\n    padding-top: 48.5rem !important;\n    padding-bottom: 48.5rem !important;\n  }\n\n  .py-lg-99 {\n    padding-top: 49rem !important;\n    padding-bottom: 49rem !important;\n  }\n\n  .py-lg-100 {\n    padding-top: 49.5rem !important;\n    padding-bottom: 49.5rem !important;\n  }\n\n  .py-lg-101 {\n    padding-top: 50rem !important;\n    padding-bottom: 50rem !important;\n  }\n\n  .py-lg-102 {\n    padding-top: 50.5rem !important;\n    padding-bottom: 50.5rem !important;\n  }\n\n  .py-lg-103 {\n    padding-top: 51rem !important;\n    padding-bottom: 51rem !important;\n  }\n\n  .py-lg-104 {\n    padding-top: 51.5rem !important;\n    padding-bottom: 51.5rem !important;\n  }\n\n  .py-lg-105 {\n    padding-top: 52rem !important;\n    padding-bottom: 52rem !important;\n  }\n\n  .py-lg-106 {\n    padding-top: 52.5rem !important;\n    padding-bottom: 52.5rem !important;\n  }\n\n  .py-lg-107 {\n    padding-top: 53rem !important;\n    padding-bottom: 53rem !important;\n  }\n\n  .py-lg-108 {\n    padding-top: 53.5rem !important;\n    padding-bottom: 53.5rem !important;\n  }\n\n  .py-lg-109 {\n    padding-top: 54rem !important;\n    padding-bottom: 54rem !important;\n  }\n\n  .py-lg-110 {\n    padding-top: 54.5rem !important;\n    padding-bottom: 54.5rem !important;\n  }\n\n  .py-lg-111 {\n    padding-top: 55rem !important;\n    padding-bottom: 55rem !important;\n  }\n\n  .py-lg-112 {\n    padding-top: 55.5rem !important;\n    padding-bottom: 55.5rem !important;\n  }\n\n  .py-lg-113 {\n    padding-top: 56rem !important;\n    padding-bottom: 56rem !important;\n  }\n\n  .py-lg-114 {\n    padding-top: 56.5rem !important;\n    padding-bottom: 56.5rem !important;\n  }\n\n  .py-lg-115 {\n    padding-top: 57rem !important;\n    padding-bottom: 57rem !important;\n  }\n\n  .py-lg-116 {\n    padding-top: 57.5rem !important;\n    padding-bottom: 57.5rem !important;\n  }\n\n  .py-lg-117 {\n    padding-top: 58rem !important;\n    padding-bottom: 58rem !important;\n  }\n\n  .py-lg-118 {\n    padding-top: 58.5rem !important;\n    padding-bottom: 58.5rem !important;\n  }\n\n  .py-lg-119 {\n    padding-top: 59rem !important;\n    padding-bottom: 59rem !important;\n  }\n\n  .py-lg-120 {\n    padding-top: 59.5rem !important;\n    padding-bottom: 59.5rem !important;\n  }\n\n  .py-lg-121 {\n    padding-top: 60rem !important;\n    padding-bottom: 60rem !important;\n  }\n\n  .py-lg-122 {\n    padding-top: 60.5rem !important;\n    padding-bottom: 60.5rem !important;\n  }\n\n  .py-lg-123 {\n    padding-top: 61rem !important;\n    padding-bottom: 61rem !important;\n  }\n\n  .py-lg-124 {\n    padding-top: 61.5rem !important;\n    padding-bottom: 61.5rem !important;\n  }\n\n  .py-lg-125 {\n    padding-top: 62rem !important;\n    padding-bottom: 62rem !important;\n  }\n\n  .py-lg-126 {\n    padding-top: 62.5rem !important;\n    padding-bottom: 62.5rem !important;\n  }\n\n  .py-lg-127 {\n    padding-top: 63rem !important;\n    padding-bottom: 63rem !important;\n  }\n\n  .py-lg-128 {\n    padding-top: 63.5rem !important;\n    padding-bottom: 63.5rem !important;\n  }\n\n  .py-lg-129 {\n    padding-top: 64rem !important;\n    padding-bottom: 64rem !important;\n  }\n\n  .py-lg-130 {\n    padding-top: 64.5rem !important;\n    padding-bottom: 64.5rem !important;\n  }\n\n  .py-lg-131 {\n    padding-top: 65rem !important;\n    padding-bottom: 65rem !important;\n  }\n\n  .py-lg-132 {\n    padding-top: 65.5rem !important;\n    padding-bottom: 65.5rem !important;\n  }\n\n  .py-lg-133 {\n    padding-top: 66rem !important;\n    padding-bottom: 66rem !important;\n  }\n\n  .py-lg-134 {\n    padding-top: 66.5rem !important;\n    padding-bottom: 66.5rem !important;\n  }\n\n  .py-lg-135 {\n    padding-top: 67rem !important;\n    padding-bottom: 67rem !important;\n  }\n\n  .py-lg-136 {\n    padding-top: 67.5rem !important;\n    padding-bottom: 67.5rem !important;\n  }\n\n  .py-lg-137 {\n    padding-top: 68rem !important;\n    padding-bottom: 68rem !important;\n  }\n\n  .py-lg-138 {\n    padding-top: 68.5rem !important;\n    padding-bottom: 68.5rem !important;\n  }\n\n  .py-lg-139 {\n    padding-top: 69rem !important;\n    padding-bottom: 69rem !important;\n  }\n\n  .py-lg-140 {\n    padding-top: 69.5rem !important;\n    padding-bottom: 69.5rem !important;\n  }\n\n  .py-lg-141 {\n    padding-top: 70rem !important;\n    padding-bottom: 70rem !important;\n  }\n\n  .py-lg-142 {\n    padding-top: 70.5rem !important;\n    padding-bottom: 70.5rem !important;\n  }\n\n  .py-lg-143 {\n    padding-top: 71rem !important;\n    padding-bottom: 71rem !important;\n  }\n\n  .py-lg-144 {\n    padding-top: 71.5rem !important;\n    padding-bottom: 71.5rem !important;\n  }\n\n  .py-lg-145 {\n    padding-top: 72rem !important;\n    padding-bottom: 72rem !important;\n  }\n\n  .py-lg-146 {\n    padding-top: 72.5rem !important;\n    padding-bottom: 72.5rem !important;\n  }\n\n  .py-lg-147 {\n    padding-top: 73rem !important;\n    padding-bottom: 73rem !important;\n  }\n\n  .py-lg-148 {\n    padding-top: 73.5rem !important;\n    padding-bottom: 73.5rem !important;\n  }\n\n  .py-lg-149 {\n    padding-top: 74rem !important;\n    padding-bottom: 74rem !important;\n  }\n\n  .py-lg-150 {\n    padding-top: 74.5rem !important;\n    padding-bottom: 74.5rem !important;\n  }\n\n  .py-lg-151 {\n    padding-top: 75rem !important;\n    padding-bottom: 75rem !important;\n  }\n\n  .py-lg-152 {\n    padding-top: 75.5rem !important;\n    padding-bottom: 75.5rem !important;\n  }\n\n  .py-lg-153 {\n    padding-top: 76rem !important;\n    padding-bottom: 76rem !important;\n  }\n\n  .py-lg-154 {\n    padding-top: 76.5rem !important;\n    padding-bottom: 76.5rem !important;\n  }\n\n  .py-lg-155 {\n    padding-top: 77rem !important;\n    padding-bottom: 77rem !important;\n  }\n\n  .py-lg-156 {\n    padding-top: 77.5rem !important;\n    padding-bottom: 77.5rem !important;\n  }\n\n  .py-lg-157 {\n    padding-top: 78rem !important;\n    padding-bottom: 78rem !important;\n  }\n\n  .py-lg-158 {\n    padding-top: 78.5rem !important;\n    padding-bottom: 78.5rem !important;\n  }\n\n  .py-lg-159 {\n    padding-top: 79rem !important;\n    padding-bottom: 79rem !important;\n  }\n\n  .py-lg-160 {\n    padding-top: 79.5rem !important;\n    padding-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .p-xl-0 {\n    padding: 0rem !important;\n  }\n\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xl-5 {\n    padding: 2rem !important;\n  }\n\n  .p-xl-6 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xl-7 {\n    padding: 3rem !important;\n  }\n\n  .p-xl-8 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xl-9 {\n    padding: 4rem !important;\n  }\n\n  .p-xl-10 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xl-11 {\n    padding: 5rem !important;\n  }\n\n  .p-xl-12 {\n    padding: 5.5rem !important;\n  }\n\n  .p-xl-13 {\n    padding: 6rem !important;\n  }\n\n  .p-xl-14 {\n    padding: 6.5rem !important;\n  }\n\n  .p-xl-15 {\n    padding: 7rem !important;\n  }\n\n  .p-xl-16 {\n    padding: 7.5rem !important;\n  }\n\n  .p-xl-17 {\n    padding: 8rem !important;\n  }\n\n  .p-xl-18 {\n    padding: 8.5rem !important;\n  }\n\n  .p-xl-19 {\n    padding: 9rem !important;\n  }\n\n  .p-xl-20 {\n    padding: 9.5rem !important;\n  }\n\n  .p-xl-21 {\n    padding: 10rem !important;\n  }\n\n  .p-xl-22 {\n    padding: 10.5rem !important;\n  }\n\n  .p-xl-23 {\n    padding: 11rem !important;\n  }\n\n  .p-xl-24 {\n    padding: 11.5rem !important;\n  }\n\n  .p-xl-25 {\n    padding: 12rem !important;\n  }\n\n  .p-xl-26 {\n    padding: 12.5rem !important;\n  }\n\n  .p-xl-27 {\n    padding: 13rem !important;\n  }\n\n  .p-xl-28 {\n    padding: 13.5rem !important;\n  }\n\n  .p-xl-29 {\n    padding: 14rem !important;\n  }\n\n  .p-xl-30 {\n    padding: 14.5rem !important;\n  }\n\n  .p-xl-31 {\n    padding: 15rem !important;\n  }\n\n  .p-xl-32 {\n    padding: 15.5rem !important;\n  }\n\n  .p-xl-33 {\n    padding: 16rem !important;\n  }\n\n  .p-xl-34 {\n    padding: 16.5rem !important;\n  }\n\n  .p-xl-35 {\n    padding: 17rem !important;\n  }\n\n  .p-xl-36 {\n    padding: 17.5rem !important;\n  }\n\n  .p-xl-37 {\n    padding: 18rem !important;\n  }\n\n  .p-xl-38 {\n    padding: 18.5rem !important;\n  }\n\n  .p-xl-39 {\n    padding: 19rem !important;\n  }\n\n  .p-xl-40 {\n    padding: 19.5rem !important;\n  }\n\n  .p-xl-41 {\n    padding: 20rem !important;\n  }\n\n  .p-xl-42 {\n    padding: 20.5rem !important;\n  }\n\n  .p-xl-43 {\n    padding: 21rem !important;\n  }\n\n  .p-xl-44 {\n    padding: 21.5rem !important;\n  }\n\n  .p-xl-45 {\n    padding: 22rem !important;\n  }\n\n  .p-xl-46 {\n    padding: 22.5rem !important;\n  }\n\n  .p-xl-47 {\n    padding: 23rem !important;\n  }\n\n  .p-xl-48 {\n    padding: 23.5rem !important;\n  }\n\n  .p-xl-49 {\n    padding: 24rem !important;\n  }\n\n  .p-xl-50 {\n    padding: 24.5rem !important;\n  }\n\n  .p-xl-51 {\n    padding: 25rem !important;\n  }\n\n  .p-xl-52 {\n    padding: 25.5rem !important;\n  }\n\n  .p-xl-53 {\n    padding: 26rem !important;\n  }\n\n  .p-xl-54 {\n    padding: 26.5rem !important;\n  }\n\n  .p-xl-55 {\n    padding: 27rem !important;\n  }\n\n  .p-xl-56 {\n    padding: 27.5rem !important;\n  }\n\n  .p-xl-57 {\n    padding: 28rem !important;\n  }\n\n  .p-xl-58 {\n    padding: 28.5rem !important;\n  }\n\n  .p-xl-59 {\n    padding: 29rem !important;\n  }\n\n  .p-xl-60 {\n    padding: 29.5rem !important;\n  }\n\n  .p-xl-61 {\n    padding: 30rem !important;\n  }\n\n  .p-xl-62 {\n    padding: 30.5rem !important;\n  }\n\n  .p-xl-63 {\n    padding: 31rem !important;\n  }\n\n  .p-xl-64 {\n    padding: 31.5rem !important;\n  }\n\n  .p-xl-65 {\n    padding: 32rem !important;\n  }\n\n  .p-xl-66 {\n    padding: 32.5rem !important;\n  }\n\n  .p-xl-67 {\n    padding: 33rem !important;\n  }\n\n  .p-xl-68 {\n    padding: 33.5rem !important;\n  }\n\n  .p-xl-69 {\n    padding: 34rem !important;\n  }\n\n  .p-xl-70 {\n    padding: 34.5rem !important;\n  }\n\n  .p-xl-71 {\n    padding: 35rem !important;\n  }\n\n  .p-xl-72 {\n    padding: 35.5rem !important;\n  }\n\n  .p-xl-73 {\n    padding: 36rem !important;\n  }\n\n  .p-xl-74 {\n    padding: 36.5rem !important;\n  }\n\n  .p-xl-75 {\n    padding: 37rem !important;\n  }\n\n  .p-xl-76 {\n    padding: 37.5rem !important;\n  }\n\n  .p-xl-77 {\n    padding: 38rem !important;\n  }\n\n  .p-xl-78 {\n    padding: 38.5rem !important;\n  }\n\n  .p-xl-79 {\n    padding: 39rem !important;\n  }\n\n  .p-xl-80 {\n    padding: 39.5rem !important;\n  }\n\n  .p-xl-81 {\n    padding: 40rem !important;\n  }\n\n  .p-xl-82 {\n    padding: 40.5rem !important;\n  }\n\n  .p-xl-83 {\n    padding: 41rem !important;\n  }\n\n  .p-xl-84 {\n    padding: 41.5rem !important;\n  }\n\n  .p-xl-85 {\n    padding: 42rem !important;\n  }\n\n  .p-xl-86 {\n    padding: 42.5rem !important;\n  }\n\n  .p-xl-87 {\n    padding: 43rem !important;\n  }\n\n  .p-xl-88 {\n    padding: 43.5rem !important;\n  }\n\n  .p-xl-89 {\n    padding: 44rem !important;\n  }\n\n  .p-xl-90 {\n    padding: 44.5rem !important;\n  }\n\n  .p-xl-91 {\n    padding: 45rem !important;\n  }\n\n  .p-xl-92 {\n    padding: 45.5rem !important;\n  }\n\n  .p-xl-93 {\n    padding: 46rem !important;\n  }\n\n  .p-xl-94 {\n    padding: 46.5rem !important;\n  }\n\n  .p-xl-95 {\n    padding: 47rem !important;\n  }\n\n  .p-xl-96 {\n    padding: 47.5rem !important;\n  }\n\n  .p-xl-97 {\n    padding: 48rem !important;\n  }\n\n  .p-xl-98 {\n    padding: 48.5rem !important;\n  }\n\n  .p-xl-99 {\n    padding: 49rem !important;\n  }\n\n  .p-xl-100 {\n    padding: 49.5rem !important;\n  }\n\n  .p-xl-101 {\n    padding: 50rem !important;\n  }\n\n  .p-xl-102 {\n    padding: 50.5rem !important;\n  }\n\n  .p-xl-103 {\n    padding: 51rem !important;\n  }\n\n  .p-xl-104 {\n    padding: 51.5rem !important;\n  }\n\n  .p-xl-105 {\n    padding: 52rem !important;\n  }\n\n  .p-xl-106 {\n    padding: 52.5rem !important;\n  }\n\n  .p-xl-107 {\n    padding: 53rem !important;\n  }\n\n  .p-xl-108 {\n    padding: 53.5rem !important;\n  }\n\n  .p-xl-109 {\n    padding: 54rem !important;\n  }\n\n  .p-xl-110 {\n    padding: 54.5rem !important;\n  }\n\n  .p-xl-111 {\n    padding: 55rem !important;\n  }\n\n  .p-xl-112 {\n    padding: 55.5rem !important;\n  }\n\n  .p-xl-113 {\n    padding: 56rem !important;\n  }\n\n  .p-xl-114 {\n    padding: 56.5rem !important;\n  }\n\n  .p-xl-115 {\n    padding: 57rem !important;\n  }\n\n  .p-xl-116 {\n    padding: 57.5rem !important;\n  }\n\n  .p-xl-117 {\n    padding: 58rem !important;\n  }\n\n  .p-xl-118 {\n    padding: 58.5rem !important;\n  }\n\n  .p-xl-119 {\n    padding: 59rem !important;\n  }\n\n  .p-xl-120 {\n    padding: 59.5rem !important;\n  }\n\n  .p-xl-121 {\n    padding: 60rem !important;\n  }\n\n  .p-xl-122 {\n    padding: 60.5rem !important;\n  }\n\n  .p-xl-123 {\n    padding: 61rem !important;\n  }\n\n  .p-xl-124 {\n    padding: 61.5rem !important;\n  }\n\n  .p-xl-125 {\n    padding: 62rem !important;\n  }\n\n  .p-xl-126 {\n    padding: 62.5rem !important;\n  }\n\n  .p-xl-127 {\n    padding: 63rem !important;\n  }\n\n  .p-xl-128 {\n    padding: 63.5rem !important;\n  }\n\n  .p-xl-129 {\n    padding: 64rem !important;\n  }\n\n  .p-xl-130 {\n    padding: 64.5rem !important;\n  }\n\n  .p-xl-131 {\n    padding: 65rem !important;\n  }\n\n  .p-xl-132 {\n    padding: 65.5rem !important;\n  }\n\n  .p-xl-133 {\n    padding: 66rem !important;\n  }\n\n  .p-xl-134 {\n    padding: 66.5rem !important;\n  }\n\n  .p-xl-135 {\n    padding: 67rem !important;\n  }\n\n  .p-xl-136 {\n    padding: 67.5rem !important;\n  }\n\n  .p-xl-137 {\n    padding: 68rem !important;\n  }\n\n  .p-xl-138 {\n    padding: 68.5rem !important;\n  }\n\n  .p-xl-139 {\n    padding: 69rem !important;\n  }\n\n  .p-xl-140 {\n    padding: 69.5rem !important;\n  }\n\n  .p-xl-141 {\n    padding: 70rem !important;\n  }\n\n  .p-xl-142 {\n    padding: 70.5rem !important;\n  }\n\n  .p-xl-143 {\n    padding: 71rem !important;\n  }\n\n  .p-xl-144 {\n    padding: 71.5rem !important;\n  }\n\n  .p-xl-145 {\n    padding: 72rem !important;\n  }\n\n  .p-xl-146 {\n    padding: 72.5rem !important;\n  }\n\n  .p-xl-147 {\n    padding: 73rem !important;\n  }\n\n  .p-xl-148 {\n    padding: 73.5rem !important;\n  }\n\n  .p-xl-149 {\n    padding: 74rem !important;\n  }\n\n  .p-xl-150 {\n    padding: 74.5rem !important;\n  }\n\n  .p-xl-151 {\n    padding: 75rem !important;\n  }\n\n  .p-xl-152 {\n    padding: 75.5rem !important;\n  }\n\n  .p-xl-153 {\n    padding: 76rem !important;\n  }\n\n  .p-xl-154 {\n    padding: 76.5rem !important;\n  }\n\n  .p-xl-155 {\n    padding: 77rem !important;\n  }\n\n  .p-xl-156 {\n    padding: 77.5rem !important;\n  }\n\n  .p-xl-157 {\n    padding: 78rem !important;\n  }\n\n  .p-xl-158 {\n    padding: 78.5rem !important;\n  }\n\n  .p-xl-159 {\n    padding: 79rem !important;\n  }\n\n  .p-xl-160 {\n    padding: 79.5rem !important;\n  }\n\n  .pt-xl-0 {\n    padding-top: 0rem !important;\n  }\n\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xl-5 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xl-6 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xl-7 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xl-8 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xl-9 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xl-10 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xl-11 {\n    padding-top: 5rem !important;\n  }\n\n  .pt-xl-12 {\n    padding-top: 5.5rem !important;\n  }\n\n  .pt-xl-13 {\n    padding-top: 6rem !important;\n  }\n\n  .pt-xl-14 {\n    padding-top: 6.5rem !important;\n  }\n\n  .pt-xl-15 {\n    padding-top: 7rem !important;\n  }\n\n  .pt-xl-16 {\n    padding-top: 7.5rem !important;\n  }\n\n  .pt-xl-17 {\n    padding-top: 8rem !important;\n  }\n\n  .pt-xl-18 {\n    padding-top: 8.5rem !important;\n  }\n\n  .pt-xl-19 {\n    padding-top: 9rem !important;\n  }\n\n  .pt-xl-20 {\n    padding-top: 9.5rem !important;\n  }\n\n  .pt-xl-21 {\n    padding-top: 10rem !important;\n  }\n\n  .pt-xl-22 {\n    padding-top: 10.5rem !important;\n  }\n\n  .pt-xl-23 {\n    padding-top: 11rem !important;\n  }\n\n  .pt-xl-24 {\n    padding-top: 11.5rem !important;\n  }\n\n  .pt-xl-25 {\n    padding-top: 12rem !important;\n  }\n\n  .pt-xl-26 {\n    padding-top: 12.5rem !important;\n  }\n\n  .pt-xl-27 {\n    padding-top: 13rem !important;\n  }\n\n  .pt-xl-28 {\n    padding-top: 13.5rem !important;\n  }\n\n  .pt-xl-29 {\n    padding-top: 14rem !important;\n  }\n\n  .pt-xl-30 {\n    padding-top: 14.5rem !important;\n  }\n\n  .pt-xl-31 {\n    padding-top: 15rem !important;\n  }\n\n  .pt-xl-32 {\n    padding-top: 15.5rem !important;\n  }\n\n  .pt-xl-33 {\n    padding-top: 16rem !important;\n  }\n\n  .pt-xl-34 {\n    padding-top: 16.5rem !important;\n  }\n\n  .pt-xl-35 {\n    padding-top: 17rem !important;\n  }\n\n  .pt-xl-36 {\n    padding-top: 17.5rem !important;\n  }\n\n  .pt-xl-37 {\n    padding-top: 18rem !important;\n  }\n\n  .pt-xl-38 {\n    padding-top: 18.5rem !important;\n  }\n\n  .pt-xl-39 {\n    padding-top: 19rem !important;\n  }\n\n  .pt-xl-40 {\n    padding-top: 19.5rem !important;\n  }\n\n  .pt-xl-41 {\n    padding-top: 20rem !important;\n  }\n\n  .pt-xl-42 {\n    padding-top: 20.5rem !important;\n  }\n\n  .pt-xl-43 {\n    padding-top: 21rem !important;\n  }\n\n  .pt-xl-44 {\n    padding-top: 21.5rem !important;\n  }\n\n  .pt-xl-45 {\n    padding-top: 22rem !important;\n  }\n\n  .pt-xl-46 {\n    padding-top: 22.5rem !important;\n  }\n\n  .pt-xl-47 {\n    padding-top: 23rem !important;\n  }\n\n  .pt-xl-48 {\n    padding-top: 23.5rem !important;\n  }\n\n  .pt-xl-49 {\n    padding-top: 24rem !important;\n  }\n\n  .pt-xl-50 {\n    padding-top: 24.5rem !important;\n  }\n\n  .pt-xl-51 {\n    padding-top: 25rem !important;\n  }\n\n  .pt-xl-52 {\n    padding-top: 25.5rem !important;\n  }\n\n  .pt-xl-53 {\n    padding-top: 26rem !important;\n  }\n\n  .pt-xl-54 {\n    padding-top: 26.5rem !important;\n  }\n\n  .pt-xl-55 {\n    padding-top: 27rem !important;\n  }\n\n  .pt-xl-56 {\n    padding-top: 27.5rem !important;\n  }\n\n  .pt-xl-57 {\n    padding-top: 28rem !important;\n  }\n\n  .pt-xl-58 {\n    padding-top: 28.5rem !important;\n  }\n\n  .pt-xl-59 {\n    padding-top: 29rem !important;\n  }\n\n  .pt-xl-60 {\n    padding-top: 29.5rem !important;\n  }\n\n  .pt-xl-61 {\n    padding-top: 30rem !important;\n  }\n\n  .pt-xl-62 {\n    padding-top: 30.5rem !important;\n  }\n\n  .pt-xl-63 {\n    padding-top: 31rem !important;\n  }\n\n  .pt-xl-64 {\n    padding-top: 31.5rem !important;\n  }\n\n  .pt-xl-65 {\n    padding-top: 32rem !important;\n  }\n\n  .pt-xl-66 {\n    padding-top: 32.5rem !important;\n  }\n\n  .pt-xl-67 {\n    padding-top: 33rem !important;\n  }\n\n  .pt-xl-68 {\n    padding-top: 33.5rem !important;\n  }\n\n  .pt-xl-69 {\n    padding-top: 34rem !important;\n  }\n\n  .pt-xl-70 {\n    padding-top: 34.5rem !important;\n  }\n\n  .pt-xl-71 {\n    padding-top: 35rem !important;\n  }\n\n  .pt-xl-72 {\n    padding-top: 35.5rem !important;\n  }\n\n  .pt-xl-73 {\n    padding-top: 36rem !important;\n  }\n\n  .pt-xl-74 {\n    padding-top: 36.5rem !important;\n  }\n\n  .pt-xl-75 {\n    padding-top: 37rem !important;\n  }\n\n  .pt-xl-76 {\n    padding-top: 37.5rem !important;\n  }\n\n  .pt-xl-77 {\n    padding-top: 38rem !important;\n  }\n\n  .pt-xl-78 {\n    padding-top: 38.5rem !important;\n  }\n\n  .pt-xl-79 {\n    padding-top: 39rem !important;\n  }\n\n  .pt-xl-80 {\n    padding-top: 39.5rem !important;\n  }\n\n  .pt-xl-81 {\n    padding-top: 40rem !important;\n  }\n\n  .pt-xl-82 {\n    padding-top: 40.5rem !important;\n  }\n\n  .pt-xl-83 {\n    padding-top: 41rem !important;\n  }\n\n  .pt-xl-84 {\n    padding-top: 41.5rem !important;\n  }\n\n  .pt-xl-85 {\n    padding-top: 42rem !important;\n  }\n\n  .pt-xl-86 {\n    padding-top: 42.5rem !important;\n  }\n\n  .pt-xl-87 {\n    padding-top: 43rem !important;\n  }\n\n  .pt-xl-88 {\n    padding-top: 43.5rem !important;\n  }\n\n  .pt-xl-89 {\n    padding-top: 44rem !important;\n  }\n\n  .pt-xl-90 {\n    padding-top: 44.5rem !important;\n  }\n\n  .pt-xl-91 {\n    padding-top: 45rem !important;\n  }\n\n  .pt-xl-92 {\n    padding-top: 45.5rem !important;\n  }\n\n  .pt-xl-93 {\n    padding-top: 46rem !important;\n  }\n\n  .pt-xl-94 {\n    padding-top: 46.5rem !important;\n  }\n\n  .pt-xl-95 {\n    padding-top: 47rem !important;\n  }\n\n  .pt-xl-96 {\n    padding-top: 47.5rem !important;\n  }\n\n  .pt-xl-97 {\n    padding-top: 48rem !important;\n  }\n\n  .pt-xl-98 {\n    padding-top: 48.5rem !important;\n  }\n\n  .pt-xl-99 {\n    padding-top: 49rem !important;\n  }\n\n  .pt-xl-100 {\n    padding-top: 49.5rem !important;\n  }\n\n  .pt-xl-101 {\n    padding-top: 50rem !important;\n  }\n\n  .pt-xl-102 {\n    padding-top: 50.5rem !important;\n  }\n\n  .pt-xl-103 {\n    padding-top: 51rem !important;\n  }\n\n  .pt-xl-104 {\n    padding-top: 51.5rem !important;\n  }\n\n  .pt-xl-105 {\n    padding-top: 52rem !important;\n  }\n\n  .pt-xl-106 {\n    padding-top: 52.5rem !important;\n  }\n\n  .pt-xl-107 {\n    padding-top: 53rem !important;\n  }\n\n  .pt-xl-108 {\n    padding-top: 53.5rem !important;\n  }\n\n  .pt-xl-109 {\n    padding-top: 54rem !important;\n  }\n\n  .pt-xl-110 {\n    padding-top: 54.5rem !important;\n  }\n\n  .pt-xl-111 {\n    padding-top: 55rem !important;\n  }\n\n  .pt-xl-112 {\n    padding-top: 55.5rem !important;\n  }\n\n  .pt-xl-113 {\n    padding-top: 56rem !important;\n  }\n\n  .pt-xl-114 {\n    padding-top: 56.5rem !important;\n  }\n\n  .pt-xl-115 {\n    padding-top: 57rem !important;\n  }\n\n  .pt-xl-116 {\n    padding-top: 57.5rem !important;\n  }\n\n  .pt-xl-117 {\n    padding-top: 58rem !important;\n  }\n\n  .pt-xl-118 {\n    padding-top: 58.5rem !important;\n  }\n\n  .pt-xl-119 {\n    padding-top: 59rem !important;\n  }\n\n  .pt-xl-120 {\n    padding-top: 59.5rem !important;\n  }\n\n  .pt-xl-121 {\n    padding-top: 60rem !important;\n  }\n\n  .pt-xl-122 {\n    padding-top: 60.5rem !important;\n  }\n\n  .pt-xl-123 {\n    padding-top: 61rem !important;\n  }\n\n  .pt-xl-124 {\n    padding-top: 61.5rem !important;\n  }\n\n  .pt-xl-125 {\n    padding-top: 62rem !important;\n  }\n\n  .pt-xl-126 {\n    padding-top: 62.5rem !important;\n  }\n\n  .pt-xl-127 {\n    padding-top: 63rem !important;\n  }\n\n  .pt-xl-128 {\n    padding-top: 63.5rem !important;\n  }\n\n  .pt-xl-129 {\n    padding-top: 64rem !important;\n  }\n\n  .pt-xl-130 {\n    padding-top: 64.5rem !important;\n  }\n\n  .pt-xl-131 {\n    padding-top: 65rem !important;\n  }\n\n  .pt-xl-132 {\n    padding-top: 65.5rem !important;\n  }\n\n  .pt-xl-133 {\n    padding-top: 66rem !important;\n  }\n\n  .pt-xl-134 {\n    padding-top: 66.5rem !important;\n  }\n\n  .pt-xl-135 {\n    padding-top: 67rem !important;\n  }\n\n  .pt-xl-136 {\n    padding-top: 67.5rem !important;\n  }\n\n  .pt-xl-137 {\n    padding-top: 68rem !important;\n  }\n\n  .pt-xl-138 {\n    padding-top: 68.5rem !important;\n  }\n\n  .pt-xl-139 {\n    padding-top: 69rem !important;\n  }\n\n  .pt-xl-140 {\n    padding-top: 69.5rem !important;\n  }\n\n  .pt-xl-141 {\n    padding-top: 70rem !important;\n  }\n\n  .pt-xl-142 {\n    padding-top: 70.5rem !important;\n  }\n\n  .pt-xl-143 {\n    padding-top: 71rem !important;\n  }\n\n  .pt-xl-144 {\n    padding-top: 71.5rem !important;\n  }\n\n  .pt-xl-145 {\n    padding-top: 72rem !important;\n  }\n\n  .pt-xl-146 {\n    padding-top: 72.5rem !important;\n  }\n\n  .pt-xl-147 {\n    padding-top: 73rem !important;\n  }\n\n  .pt-xl-148 {\n    padding-top: 73.5rem !important;\n  }\n\n  .pt-xl-149 {\n    padding-top: 74rem !important;\n  }\n\n  .pt-xl-150 {\n    padding-top: 74.5rem !important;\n  }\n\n  .pt-xl-151 {\n    padding-top: 75rem !important;\n  }\n\n  .pt-xl-152 {\n    padding-top: 75.5rem !important;\n  }\n\n  .pt-xl-153 {\n    padding-top: 76rem !important;\n  }\n\n  .pt-xl-154 {\n    padding-top: 76.5rem !important;\n  }\n\n  .pt-xl-155 {\n    padding-top: 77rem !important;\n  }\n\n  .pt-xl-156 {\n    padding-top: 77.5rem !important;\n  }\n\n  .pt-xl-157 {\n    padding-top: 78rem !important;\n  }\n\n  .pt-xl-158 {\n    padding-top: 78.5rem !important;\n  }\n\n  .pt-xl-159 {\n    padding-top: 79rem !important;\n  }\n\n  .pt-xl-160 {\n    padding-top: 79.5rem !important;\n  }\n\n  .pb-xl-0 {\n    padding-bottom: 0rem !important;\n  }\n\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xl-5 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xl-6 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xl-7 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xl-8 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xl-9 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xl-10 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xl-11 {\n    padding-bottom: 5rem !important;\n  }\n\n  .pb-xl-12 {\n    padding-bottom: 5.5rem !important;\n  }\n\n  .pb-xl-13 {\n    padding-bottom: 6rem !important;\n  }\n\n  .pb-xl-14 {\n    padding-bottom: 6.5rem !important;\n  }\n\n  .pb-xl-15 {\n    padding-bottom: 7rem !important;\n  }\n\n  .pb-xl-16 {\n    padding-bottom: 7.5rem !important;\n  }\n\n  .pb-xl-17 {\n    padding-bottom: 8rem !important;\n  }\n\n  .pb-xl-18 {\n    padding-bottom: 8.5rem !important;\n  }\n\n  .pb-xl-19 {\n    padding-bottom: 9rem !important;\n  }\n\n  .pb-xl-20 {\n    padding-bottom: 9.5rem !important;\n  }\n\n  .pb-xl-21 {\n    padding-bottom: 10rem !important;\n  }\n\n  .pb-xl-22 {\n    padding-bottom: 10.5rem !important;\n  }\n\n  .pb-xl-23 {\n    padding-bottom: 11rem !important;\n  }\n\n  .pb-xl-24 {\n    padding-bottom: 11.5rem !important;\n  }\n\n  .pb-xl-25 {\n    padding-bottom: 12rem !important;\n  }\n\n  .pb-xl-26 {\n    padding-bottom: 12.5rem !important;\n  }\n\n  .pb-xl-27 {\n    padding-bottom: 13rem !important;\n  }\n\n  .pb-xl-28 {\n    padding-bottom: 13.5rem !important;\n  }\n\n  .pb-xl-29 {\n    padding-bottom: 14rem !important;\n  }\n\n  .pb-xl-30 {\n    padding-bottom: 14.5rem !important;\n  }\n\n  .pb-xl-31 {\n    padding-bottom: 15rem !important;\n  }\n\n  .pb-xl-32 {\n    padding-bottom: 15.5rem !important;\n  }\n\n  .pb-xl-33 {\n    padding-bottom: 16rem !important;\n  }\n\n  .pb-xl-34 {\n    padding-bottom: 16.5rem !important;\n  }\n\n  .pb-xl-35 {\n    padding-bottom: 17rem !important;\n  }\n\n  .pb-xl-36 {\n    padding-bottom: 17.5rem !important;\n  }\n\n  .pb-xl-37 {\n    padding-bottom: 18rem !important;\n  }\n\n  .pb-xl-38 {\n    padding-bottom: 18.5rem !important;\n  }\n\n  .pb-xl-39 {\n    padding-bottom: 19rem !important;\n  }\n\n  .pb-xl-40 {\n    padding-bottom: 19.5rem !important;\n  }\n\n  .pb-xl-41 {\n    padding-bottom: 20rem !important;\n  }\n\n  .pb-xl-42 {\n    padding-bottom: 20.5rem !important;\n  }\n\n  .pb-xl-43 {\n    padding-bottom: 21rem !important;\n  }\n\n  .pb-xl-44 {\n    padding-bottom: 21.5rem !important;\n  }\n\n  .pb-xl-45 {\n    padding-bottom: 22rem !important;\n  }\n\n  .pb-xl-46 {\n    padding-bottom: 22.5rem !important;\n  }\n\n  .pb-xl-47 {\n    padding-bottom: 23rem !important;\n  }\n\n  .pb-xl-48 {\n    padding-bottom: 23.5rem !important;\n  }\n\n  .pb-xl-49 {\n    padding-bottom: 24rem !important;\n  }\n\n  .pb-xl-50 {\n    padding-bottom: 24.5rem !important;\n  }\n\n  .pb-xl-51 {\n    padding-bottom: 25rem !important;\n  }\n\n  .pb-xl-52 {\n    padding-bottom: 25.5rem !important;\n  }\n\n  .pb-xl-53 {\n    padding-bottom: 26rem !important;\n  }\n\n  .pb-xl-54 {\n    padding-bottom: 26.5rem !important;\n  }\n\n  .pb-xl-55 {\n    padding-bottom: 27rem !important;\n  }\n\n  .pb-xl-56 {\n    padding-bottom: 27.5rem !important;\n  }\n\n  .pb-xl-57 {\n    padding-bottom: 28rem !important;\n  }\n\n  .pb-xl-58 {\n    padding-bottom: 28.5rem !important;\n  }\n\n  .pb-xl-59 {\n    padding-bottom: 29rem !important;\n  }\n\n  .pb-xl-60 {\n    padding-bottom: 29.5rem !important;\n  }\n\n  .pb-xl-61 {\n    padding-bottom: 30rem !important;\n  }\n\n  .pb-xl-62 {\n    padding-bottom: 30.5rem !important;\n  }\n\n  .pb-xl-63 {\n    padding-bottom: 31rem !important;\n  }\n\n  .pb-xl-64 {\n    padding-bottom: 31.5rem !important;\n  }\n\n  .pb-xl-65 {\n    padding-bottom: 32rem !important;\n  }\n\n  .pb-xl-66 {\n    padding-bottom: 32.5rem !important;\n  }\n\n  .pb-xl-67 {\n    padding-bottom: 33rem !important;\n  }\n\n  .pb-xl-68 {\n    padding-bottom: 33.5rem !important;\n  }\n\n  .pb-xl-69 {\n    padding-bottom: 34rem !important;\n  }\n\n  .pb-xl-70 {\n    padding-bottom: 34.5rem !important;\n  }\n\n  .pb-xl-71 {\n    padding-bottom: 35rem !important;\n  }\n\n  .pb-xl-72 {\n    padding-bottom: 35.5rem !important;\n  }\n\n  .pb-xl-73 {\n    padding-bottom: 36rem !important;\n  }\n\n  .pb-xl-74 {\n    padding-bottom: 36.5rem !important;\n  }\n\n  .pb-xl-75 {\n    padding-bottom: 37rem !important;\n  }\n\n  .pb-xl-76 {\n    padding-bottom: 37.5rem !important;\n  }\n\n  .pb-xl-77 {\n    padding-bottom: 38rem !important;\n  }\n\n  .pb-xl-78 {\n    padding-bottom: 38.5rem !important;\n  }\n\n  .pb-xl-79 {\n    padding-bottom: 39rem !important;\n  }\n\n  .pb-xl-80 {\n    padding-bottom: 39.5rem !important;\n  }\n\n  .pb-xl-81 {\n    padding-bottom: 40rem !important;\n  }\n\n  .pb-xl-82 {\n    padding-bottom: 40.5rem !important;\n  }\n\n  .pb-xl-83 {\n    padding-bottom: 41rem !important;\n  }\n\n  .pb-xl-84 {\n    padding-bottom: 41.5rem !important;\n  }\n\n  .pb-xl-85 {\n    padding-bottom: 42rem !important;\n  }\n\n  .pb-xl-86 {\n    padding-bottom: 42.5rem !important;\n  }\n\n  .pb-xl-87 {\n    padding-bottom: 43rem !important;\n  }\n\n  .pb-xl-88 {\n    padding-bottom: 43.5rem !important;\n  }\n\n  .pb-xl-89 {\n    padding-bottom: 44rem !important;\n  }\n\n  .pb-xl-90 {\n    padding-bottom: 44.5rem !important;\n  }\n\n  .pb-xl-91 {\n    padding-bottom: 45rem !important;\n  }\n\n  .pb-xl-92 {\n    padding-bottom: 45.5rem !important;\n  }\n\n  .pb-xl-93 {\n    padding-bottom: 46rem !important;\n  }\n\n  .pb-xl-94 {\n    padding-bottom: 46.5rem !important;\n  }\n\n  .pb-xl-95 {\n    padding-bottom: 47rem !important;\n  }\n\n  .pb-xl-96 {\n    padding-bottom: 47.5rem !important;\n  }\n\n  .pb-xl-97 {\n    padding-bottom: 48rem !important;\n  }\n\n  .pb-xl-98 {\n    padding-bottom: 48.5rem !important;\n  }\n\n  .pb-xl-99 {\n    padding-bottom: 49rem !important;\n  }\n\n  .pb-xl-100 {\n    padding-bottom: 49.5rem !important;\n  }\n\n  .pb-xl-101 {\n    padding-bottom: 50rem !important;\n  }\n\n  .pb-xl-102 {\n    padding-bottom: 50.5rem !important;\n  }\n\n  .pb-xl-103 {\n    padding-bottom: 51rem !important;\n  }\n\n  .pb-xl-104 {\n    padding-bottom: 51.5rem !important;\n  }\n\n  .pb-xl-105 {\n    padding-bottom: 52rem !important;\n  }\n\n  .pb-xl-106 {\n    padding-bottom: 52.5rem !important;\n  }\n\n  .pb-xl-107 {\n    padding-bottom: 53rem !important;\n  }\n\n  .pb-xl-108 {\n    padding-bottom: 53.5rem !important;\n  }\n\n  .pb-xl-109 {\n    padding-bottom: 54rem !important;\n  }\n\n  .pb-xl-110 {\n    padding-bottom: 54.5rem !important;\n  }\n\n  .pb-xl-111 {\n    padding-bottom: 55rem !important;\n  }\n\n  .pb-xl-112 {\n    padding-bottom: 55.5rem !important;\n  }\n\n  .pb-xl-113 {\n    padding-bottom: 56rem !important;\n  }\n\n  .pb-xl-114 {\n    padding-bottom: 56.5rem !important;\n  }\n\n  .pb-xl-115 {\n    padding-bottom: 57rem !important;\n  }\n\n  .pb-xl-116 {\n    padding-bottom: 57.5rem !important;\n  }\n\n  .pb-xl-117 {\n    padding-bottom: 58rem !important;\n  }\n\n  .pb-xl-118 {\n    padding-bottom: 58.5rem !important;\n  }\n\n  .pb-xl-119 {\n    padding-bottom: 59rem !important;\n  }\n\n  .pb-xl-120 {\n    padding-bottom: 59.5rem !important;\n  }\n\n  .pb-xl-121 {\n    padding-bottom: 60rem !important;\n  }\n\n  .pb-xl-122 {\n    padding-bottom: 60.5rem !important;\n  }\n\n  .pb-xl-123 {\n    padding-bottom: 61rem !important;\n  }\n\n  .pb-xl-124 {\n    padding-bottom: 61.5rem !important;\n  }\n\n  .pb-xl-125 {\n    padding-bottom: 62rem !important;\n  }\n\n  .pb-xl-126 {\n    padding-bottom: 62.5rem !important;\n  }\n\n  .pb-xl-127 {\n    padding-bottom: 63rem !important;\n  }\n\n  .pb-xl-128 {\n    padding-bottom: 63.5rem !important;\n  }\n\n  .pb-xl-129 {\n    padding-bottom: 64rem !important;\n  }\n\n  .pb-xl-130 {\n    padding-bottom: 64.5rem !important;\n  }\n\n  .pb-xl-131 {\n    padding-bottom: 65rem !important;\n  }\n\n  .pb-xl-132 {\n    padding-bottom: 65.5rem !important;\n  }\n\n  .pb-xl-133 {\n    padding-bottom: 66rem !important;\n  }\n\n  .pb-xl-134 {\n    padding-bottom: 66.5rem !important;\n  }\n\n  .pb-xl-135 {\n    padding-bottom: 67rem !important;\n  }\n\n  .pb-xl-136 {\n    padding-bottom: 67.5rem !important;\n  }\n\n  .pb-xl-137 {\n    padding-bottom: 68rem !important;\n  }\n\n  .pb-xl-138 {\n    padding-bottom: 68.5rem !important;\n  }\n\n  .pb-xl-139 {\n    padding-bottom: 69rem !important;\n  }\n\n  .pb-xl-140 {\n    padding-bottom: 69.5rem !important;\n  }\n\n  .pb-xl-141 {\n    padding-bottom: 70rem !important;\n  }\n\n  .pb-xl-142 {\n    padding-bottom: 70.5rem !important;\n  }\n\n  .pb-xl-143 {\n    padding-bottom: 71rem !important;\n  }\n\n  .pb-xl-144 {\n    padding-bottom: 71.5rem !important;\n  }\n\n  .pb-xl-145 {\n    padding-bottom: 72rem !important;\n  }\n\n  .pb-xl-146 {\n    padding-bottom: 72.5rem !important;\n  }\n\n  .pb-xl-147 {\n    padding-bottom: 73rem !important;\n  }\n\n  .pb-xl-148 {\n    padding-bottom: 73.5rem !important;\n  }\n\n  .pb-xl-149 {\n    padding-bottom: 74rem !important;\n  }\n\n  .pb-xl-150 {\n    padding-bottom: 74.5rem !important;\n  }\n\n  .pb-xl-151 {\n    padding-bottom: 75rem !important;\n  }\n\n  .pb-xl-152 {\n    padding-bottom: 75.5rem !important;\n  }\n\n  .pb-xl-153 {\n    padding-bottom: 76rem !important;\n  }\n\n  .pb-xl-154 {\n    padding-bottom: 76.5rem !important;\n  }\n\n  .pb-xl-155 {\n    padding-bottom: 77rem !important;\n  }\n\n  .pb-xl-156 {\n    padding-bottom: 77.5rem !important;\n  }\n\n  .pb-xl-157 {\n    padding-bottom: 78rem !important;\n  }\n\n  .pb-xl-158 {\n    padding-bottom: 78.5rem !important;\n  }\n\n  .pb-xl-159 {\n    padding-bottom: 79rem !important;\n  }\n\n  .pb-xl-160 {\n    padding-bottom: 79.5rem !important;\n  }\n\n  .ps-xl-0 {\n    padding-left: 0rem !important;\n  }\n\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xl-5 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xl-6 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xl-7 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xl-8 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xl-9 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xl-10 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xl-11 {\n    padding-left: 5rem !important;\n  }\n\n  .ps-xl-12 {\n    padding-left: 5.5rem !important;\n  }\n\n  .ps-xl-13 {\n    padding-left: 6rem !important;\n  }\n\n  .ps-xl-14 {\n    padding-left: 6.5rem !important;\n  }\n\n  .ps-xl-15 {\n    padding-left: 7rem !important;\n  }\n\n  .ps-xl-16 {\n    padding-left: 7.5rem !important;\n  }\n\n  .ps-xl-17 {\n    padding-left: 8rem !important;\n  }\n\n  .ps-xl-18 {\n    padding-left: 8.5rem !important;\n  }\n\n  .ps-xl-19 {\n    padding-left: 9rem !important;\n  }\n\n  .ps-xl-20 {\n    padding-left: 9.5rem !important;\n  }\n\n  .ps-xl-21 {\n    padding-left: 10rem !important;\n  }\n\n  .ps-xl-22 {\n    padding-left: 10.5rem !important;\n  }\n\n  .ps-xl-23 {\n    padding-left: 11rem !important;\n  }\n\n  .ps-xl-24 {\n    padding-left: 11.5rem !important;\n  }\n\n  .ps-xl-25 {\n    padding-left: 12rem !important;\n  }\n\n  .ps-xl-26 {\n    padding-left: 12.5rem !important;\n  }\n\n  .ps-xl-27 {\n    padding-left: 13rem !important;\n  }\n\n  .ps-xl-28 {\n    padding-left: 13.5rem !important;\n  }\n\n  .ps-xl-29 {\n    padding-left: 14rem !important;\n  }\n\n  .ps-xl-30 {\n    padding-left: 14.5rem !important;\n  }\n\n  .ps-xl-31 {\n    padding-left: 15rem !important;\n  }\n\n  .ps-xl-32 {\n    padding-left: 15.5rem !important;\n  }\n\n  .ps-xl-33 {\n    padding-left: 16rem !important;\n  }\n\n  .ps-xl-34 {\n    padding-left: 16.5rem !important;\n  }\n\n  .ps-xl-35 {\n    padding-left: 17rem !important;\n  }\n\n  .ps-xl-36 {\n    padding-left: 17.5rem !important;\n  }\n\n  .ps-xl-37 {\n    padding-left: 18rem !important;\n  }\n\n  .ps-xl-38 {\n    padding-left: 18.5rem !important;\n  }\n\n  .ps-xl-39 {\n    padding-left: 19rem !important;\n  }\n\n  .ps-xl-40 {\n    padding-left: 19.5rem !important;\n  }\n\n  .ps-xl-41 {\n    padding-left: 20rem !important;\n  }\n\n  .ps-xl-42 {\n    padding-left: 20.5rem !important;\n  }\n\n  .ps-xl-43 {\n    padding-left: 21rem !important;\n  }\n\n  .ps-xl-44 {\n    padding-left: 21.5rem !important;\n  }\n\n  .ps-xl-45 {\n    padding-left: 22rem !important;\n  }\n\n  .ps-xl-46 {\n    padding-left: 22.5rem !important;\n  }\n\n  .ps-xl-47 {\n    padding-left: 23rem !important;\n  }\n\n  .ps-xl-48 {\n    padding-left: 23.5rem !important;\n  }\n\n  .ps-xl-49 {\n    padding-left: 24rem !important;\n  }\n\n  .ps-xl-50 {\n    padding-left: 24.5rem !important;\n  }\n\n  .ps-xl-51 {\n    padding-left: 25rem !important;\n  }\n\n  .ps-xl-52 {\n    padding-left: 25.5rem !important;\n  }\n\n  .ps-xl-53 {\n    padding-left: 26rem !important;\n  }\n\n  .ps-xl-54 {\n    padding-left: 26.5rem !important;\n  }\n\n  .ps-xl-55 {\n    padding-left: 27rem !important;\n  }\n\n  .ps-xl-56 {\n    padding-left: 27.5rem !important;\n  }\n\n  .ps-xl-57 {\n    padding-left: 28rem !important;\n  }\n\n  .ps-xl-58 {\n    padding-left: 28.5rem !important;\n  }\n\n  .ps-xl-59 {\n    padding-left: 29rem !important;\n  }\n\n  .ps-xl-60 {\n    padding-left: 29.5rem !important;\n  }\n\n  .ps-xl-61 {\n    padding-left: 30rem !important;\n  }\n\n  .ps-xl-62 {\n    padding-left: 30.5rem !important;\n  }\n\n  .ps-xl-63 {\n    padding-left: 31rem !important;\n  }\n\n  .ps-xl-64 {\n    padding-left: 31.5rem !important;\n  }\n\n  .ps-xl-65 {\n    padding-left: 32rem !important;\n  }\n\n  .ps-xl-66 {\n    padding-left: 32.5rem !important;\n  }\n\n  .ps-xl-67 {\n    padding-left: 33rem !important;\n  }\n\n  .ps-xl-68 {\n    padding-left: 33.5rem !important;\n  }\n\n  .ps-xl-69 {\n    padding-left: 34rem !important;\n  }\n\n  .ps-xl-70 {\n    padding-left: 34.5rem !important;\n  }\n\n  .ps-xl-71 {\n    padding-left: 35rem !important;\n  }\n\n  .ps-xl-72 {\n    padding-left: 35.5rem !important;\n  }\n\n  .ps-xl-73 {\n    padding-left: 36rem !important;\n  }\n\n  .ps-xl-74 {\n    padding-left: 36.5rem !important;\n  }\n\n  .ps-xl-75 {\n    padding-left: 37rem !important;\n  }\n\n  .ps-xl-76 {\n    padding-left: 37.5rem !important;\n  }\n\n  .ps-xl-77 {\n    padding-left: 38rem !important;\n  }\n\n  .ps-xl-78 {\n    padding-left: 38.5rem !important;\n  }\n\n  .ps-xl-79 {\n    padding-left: 39rem !important;\n  }\n\n  .ps-xl-80 {\n    padding-left: 39.5rem !important;\n  }\n\n  .ps-xl-81 {\n    padding-left: 40rem !important;\n  }\n\n  .ps-xl-82 {\n    padding-left: 40.5rem !important;\n  }\n\n  .ps-xl-83 {\n    padding-left: 41rem !important;\n  }\n\n  .ps-xl-84 {\n    padding-left: 41.5rem !important;\n  }\n\n  .ps-xl-85 {\n    padding-left: 42rem !important;\n  }\n\n  .ps-xl-86 {\n    padding-left: 42.5rem !important;\n  }\n\n  .ps-xl-87 {\n    padding-left: 43rem !important;\n  }\n\n  .ps-xl-88 {\n    padding-left: 43.5rem !important;\n  }\n\n  .ps-xl-89 {\n    padding-left: 44rem !important;\n  }\n\n  .ps-xl-90 {\n    padding-left: 44.5rem !important;\n  }\n\n  .ps-xl-91 {\n    padding-left: 45rem !important;\n  }\n\n  .ps-xl-92 {\n    padding-left: 45.5rem !important;\n  }\n\n  .ps-xl-93 {\n    padding-left: 46rem !important;\n  }\n\n  .ps-xl-94 {\n    padding-left: 46.5rem !important;\n  }\n\n  .ps-xl-95 {\n    padding-left: 47rem !important;\n  }\n\n  .ps-xl-96 {\n    padding-left: 47.5rem !important;\n  }\n\n  .ps-xl-97 {\n    padding-left: 48rem !important;\n  }\n\n  .ps-xl-98 {\n    padding-left: 48.5rem !important;\n  }\n\n  .ps-xl-99 {\n    padding-left: 49rem !important;\n  }\n\n  .ps-xl-100 {\n    padding-left: 49.5rem !important;\n  }\n\n  .ps-xl-101 {\n    padding-left: 50rem !important;\n  }\n\n  .ps-xl-102 {\n    padding-left: 50.5rem !important;\n  }\n\n  .ps-xl-103 {\n    padding-left: 51rem !important;\n  }\n\n  .ps-xl-104 {\n    padding-left: 51.5rem !important;\n  }\n\n  .ps-xl-105 {\n    padding-left: 52rem !important;\n  }\n\n  .ps-xl-106 {\n    padding-left: 52.5rem !important;\n  }\n\n  .ps-xl-107 {\n    padding-left: 53rem !important;\n  }\n\n  .ps-xl-108 {\n    padding-left: 53.5rem !important;\n  }\n\n  .ps-xl-109 {\n    padding-left: 54rem !important;\n  }\n\n  .ps-xl-110 {\n    padding-left: 54.5rem !important;\n  }\n\n  .ps-xl-111 {\n    padding-left: 55rem !important;\n  }\n\n  .ps-xl-112 {\n    padding-left: 55.5rem !important;\n  }\n\n  .ps-xl-113 {\n    padding-left: 56rem !important;\n  }\n\n  .ps-xl-114 {\n    padding-left: 56.5rem !important;\n  }\n\n  .ps-xl-115 {\n    padding-left: 57rem !important;\n  }\n\n  .ps-xl-116 {\n    padding-left: 57.5rem !important;\n  }\n\n  .ps-xl-117 {\n    padding-left: 58rem !important;\n  }\n\n  .ps-xl-118 {\n    padding-left: 58.5rem !important;\n  }\n\n  .ps-xl-119 {\n    padding-left: 59rem !important;\n  }\n\n  .ps-xl-120 {\n    padding-left: 59.5rem !important;\n  }\n\n  .ps-xl-121 {\n    padding-left: 60rem !important;\n  }\n\n  .ps-xl-122 {\n    padding-left: 60.5rem !important;\n  }\n\n  .ps-xl-123 {\n    padding-left: 61rem !important;\n  }\n\n  .ps-xl-124 {\n    padding-left: 61.5rem !important;\n  }\n\n  .ps-xl-125 {\n    padding-left: 62rem !important;\n  }\n\n  .ps-xl-126 {\n    padding-left: 62.5rem !important;\n  }\n\n  .ps-xl-127 {\n    padding-left: 63rem !important;\n  }\n\n  .ps-xl-128 {\n    padding-left: 63.5rem !important;\n  }\n\n  .ps-xl-129 {\n    padding-left: 64rem !important;\n  }\n\n  .ps-xl-130 {\n    padding-left: 64.5rem !important;\n  }\n\n  .ps-xl-131 {\n    padding-left: 65rem !important;\n  }\n\n  .ps-xl-132 {\n    padding-left: 65.5rem !important;\n  }\n\n  .ps-xl-133 {\n    padding-left: 66rem !important;\n  }\n\n  .ps-xl-134 {\n    padding-left: 66.5rem !important;\n  }\n\n  .ps-xl-135 {\n    padding-left: 67rem !important;\n  }\n\n  .ps-xl-136 {\n    padding-left: 67.5rem !important;\n  }\n\n  .ps-xl-137 {\n    padding-left: 68rem !important;\n  }\n\n  .ps-xl-138 {\n    padding-left: 68.5rem !important;\n  }\n\n  .ps-xl-139 {\n    padding-left: 69rem !important;\n  }\n\n  .ps-xl-140 {\n    padding-left: 69.5rem !important;\n  }\n\n  .ps-xl-141 {\n    padding-left: 70rem !important;\n  }\n\n  .ps-xl-142 {\n    padding-left: 70.5rem !important;\n  }\n\n  .ps-xl-143 {\n    padding-left: 71rem !important;\n  }\n\n  .ps-xl-144 {\n    padding-left: 71.5rem !important;\n  }\n\n  .ps-xl-145 {\n    padding-left: 72rem !important;\n  }\n\n  .ps-xl-146 {\n    padding-left: 72.5rem !important;\n  }\n\n  .ps-xl-147 {\n    padding-left: 73rem !important;\n  }\n\n  .ps-xl-148 {\n    padding-left: 73.5rem !important;\n  }\n\n  .ps-xl-149 {\n    padding-left: 74rem !important;\n  }\n\n  .ps-xl-150 {\n    padding-left: 74.5rem !important;\n  }\n\n  .ps-xl-151 {\n    padding-left: 75rem !important;\n  }\n\n  .ps-xl-152 {\n    padding-left: 75.5rem !important;\n  }\n\n  .ps-xl-153 {\n    padding-left: 76rem !important;\n  }\n\n  .ps-xl-154 {\n    padding-left: 76.5rem !important;\n  }\n\n  .ps-xl-155 {\n    padding-left: 77rem !important;\n  }\n\n  .ps-xl-156 {\n    padding-left: 77.5rem !important;\n  }\n\n  .ps-xl-157 {\n    padding-left: 78rem !important;\n  }\n\n  .ps-xl-158 {\n    padding-left: 78.5rem !important;\n  }\n\n  .ps-xl-159 {\n    padding-left: 79rem !important;\n  }\n\n  .ps-xl-160 {\n    padding-left: 79.5rem !important;\n  }\n\n  .pe-xl-0 {\n    padding-right: 0rem !important;\n  }\n\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xl-5 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xl-6 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xl-7 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xl-8 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xl-9 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xl-10 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xl-11 {\n    padding-right: 5rem !important;\n  }\n\n  .pe-xl-12 {\n    padding-right: 5.5rem !important;\n  }\n\n  .pe-xl-13 {\n    padding-right: 6rem !important;\n  }\n\n  .pe-xl-14 {\n    padding-right: 6.5rem !important;\n  }\n\n  .pe-xl-15 {\n    padding-right: 7rem !important;\n  }\n\n  .pe-xl-16 {\n    padding-right: 7.5rem !important;\n  }\n\n  .pe-xl-17 {\n    padding-right: 8rem !important;\n  }\n\n  .pe-xl-18 {\n    padding-right: 8.5rem !important;\n  }\n\n  .pe-xl-19 {\n    padding-right: 9rem !important;\n  }\n\n  .pe-xl-20 {\n    padding-right: 9.5rem !important;\n  }\n\n  .pe-xl-21 {\n    padding-right: 10rem !important;\n  }\n\n  .pe-xl-22 {\n    padding-right: 10.5rem !important;\n  }\n\n  .pe-xl-23 {\n    padding-right: 11rem !important;\n  }\n\n  .pe-xl-24 {\n    padding-right: 11.5rem !important;\n  }\n\n  .pe-xl-25 {\n    padding-right: 12rem !important;\n  }\n\n  .pe-xl-26 {\n    padding-right: 12.5rem !important;\n  }\n\n  .pe-xl-27 {\n    padding-right: 13rem !important;\n  }\n\n  .pe-xl-28 {\n    padding-right: 13.5rem !important;\n  }\n\n  .pe-xl-29 {\n    padding-right: 14rem !important;\n  }\n\n  .pe-xl-30 {\n    padding-right: 14.5rem !important;\n  }\n\n  .pe-xl-31 {\n    padding-right: 15rem !important;\n  }\n\n  .pe-xl-32 {\n    padding-right: 15.5rem !important;\n  }\n\n  .pe-xl-33 {\n    padding-right: 16rem !important;\n  }\n\n  .pe-xl-34 {\n    padding-right: 16.5rem !important;\n  }\n\n  .pe-xl-35 {\n    padding-right: 17rem !important;\n  }\n\n  .pe-xl-36 {\n    padding-right: 17.5rem !important;\n  }\n\n  .pe-xl-37 {\n    padding-right: 18rem !important;\n  }\n\n  .pe-xl-38 {\n    padding-right: 18.5rem !important;\n  }\n\n  .pe-xl-39 {\n    padding-right: 19rem !important;\n  }\n\n  .pe-xl-40 {\n    padding-right: 19.5rem !important;\n  }\n\n  .pe-xl-41 {\n    padding-right: 20rem !important;\n  }\n\n  .pe-xl-42 {\n    padding-right: 20.5rem !important;\n  }\n\n  .pe-xl-43 {\n    padding-right: 21rem !important;\n  }\n\n  .pe-xl-44 {\n    padding-right: 21.5rem !important;\n  }\n\n  .pe-xl-45 {\n    padding-right: 22rem !important;\n  }\n\n  .pe-xl-46 {\n    padding-right: 22.5rem !important;\n  }\n\n  .pe-xl-47 {\n    padding-right: 23rem !important;\n  }\n\n  .pe-xl-48 {\n    padding-right: 23.5rem !important;\n  }\n\n  .pe-xl-49 {\n    padding-right: 24rem !important;\n  }\n\n  .pe-xl-50 {\n    padding-right: 24.5rem !important;\n  }\n\n  .pe-xl-51 {\n    padding-right: 25rem !important;\n  }\n\n  .pe-xl-52 {\n    padding-right: 25.5rem !important;\n  }\n\n  .pe-xl-53 {\n    padding-right: 26rem !important;\n  }\n\n  .pe-xl-54 {\n    padding-right: 26.5rem !important;\n  }\n\n  .pe-xl-55 {\n    padding-right: 27rem !important;\n  }\n\n  .pe-xl-56 {\n    padding-right: 27.5rem !important;\n  }\n\n  .pe-xl-57 {\n    padding-right: 28rem !important;\n  }\n\n  .pe-xl-58 {\n    padding-right: 28.5rem !important;\n  }\n\n  .pe-xl-59 {\n    padding-right: 29rem !important;\n  }\n\n  .pe-xl-60 {\n    padding-right: 29.5rem !important;\n  }\n\n  .pe-xl-61 {\n    padding-right: 30rem !important;\n  }\n\n  .pe-xl-62 {\n    padding-right: 30.5rem !important;\n  }\n\n  .pe-xl-63 {\n    padding-right: 31rem !important;\n  }\n\n  .pe-xl-64 {\n    padding-right: 31.5rem !important;\n  }\n\n  .pe-xl-65 {\n    padding-right: 32rem !important;\n  }\n\n  .pe-xl-66 {\n    padding-right: 32.5rem !important;\n  }\n\n  .pe-xl-67 {\n    padding-right: 33rem !important;\n  }\n\n  .pe-xl-68 {\n    padding-right: 33.5rem !important;\n  }\n\n  .pe-xl-69 {\n    padding-right: 34rem !important;\n  }\n\n  .pe-xl-70 {\n    padding-right: 34.5rem !important;\n  }\n\n  .pe-xl-71 {\n    padding-right: 35rem !important;\n  }\n\n  .pe-xl-72 {\n    padding-right: 35.5rem !important;\n  }\n\n  .pe-xl-73 {\n    padding-right: 36rem !important;\n  }\n\n  .pe-xl-74 {\n    padding-right: 36.5rem !important;\n  }\n\n  .pe-xl-75 {\n    padding-right: 37rem !important;\n  }\n\n  .pe-xl-76 {\n    padding-right: 37.5rem !important;\n  }\n\n  .pe-xl-77 {\n    padding-right: 38rem !important;\n  }\n\n  .pe-xl-78 {\n    padding-right: 38.5rem !important;\n  }\n\n  .pe-xl-79 {\n    padding-right: 39rem !important;\n  }\n\n  .pe-xl-80 {\n    padding-right: 39.5rem !important;\n  }\n\n  .pe-xl-81 {\n    padding-right: 40rem !important;\n  }\n\n  .pe-xl-82 {\n    padding-right: 40.5rem !important;\n  }\n\n  .pe-xl-83 {\n    padding-right: 41rem !important;\n  }\n\n  .pe-xl-84 {\n    padding-right: 41.5rem !important;\n  }\n\n  .pe-xl-85 {\n    padding-right: 42rem !important;\n  }\n\n  .pe-xl-86 {\n    padding-right: 42.5rem !important;\n  }\n\n  .pe-xl-87 {\n    padding-right: 43rem !important;\n  }\n\n  .pe-xl-88 {\n    padding-right: 43.5rem !important;\n  }\n\n  .pe-xl-89 {\n    padding-right: 44rem !important;\n  }\n\n  .pe-xl-90 {\n    padding-right: 44.5rem !important;\n  }\n\n  .pe-xl-91 {\n    padding-right: 45rem !important;\n  }\n\n  .pe-xl-92 {\n    padding-right: 45.5rem !important;\n  }\n\n  .pe-xl-93 {\n    padding-right: 46rem !important;\n  }\n\n  .pe-xl-94 {\n    padding-right: 46.5rem !important;\n  }\n\n  .pe-xl-95 {\n    padding-right: 47rem !important;\n  }\n\n  .pe-xl-96 {\n    padding-right: 47.5rem !important;\n  }\n\n  .pe-xl-97 {\n    padding-right: 48rem !important;\n  }\n\n  .pe-xl-98 {\n    padding-right: 48.5rem !important;\n  }\n\n  .pe-xl-99 {\n    padding-right: 49rem !important;\n  }\n\n  .pe-xl-100 {\n    padding-right: 49.5rem !important;\n  }\n\n  .pe-xl-101 {\n    padding-right: 50rem !important;\n  }\n\n  .pe-xl-102 {\n    padding-right: 50.5rem !important;\n  }\n\n  .pe-xl-103 {\n    padding-right: 51rem !important;\n  }\n\n  .pe-xl-104 {\n    padding-right: 51.5rem !important;\n  }\n\n  .pe-xl-105 {\n    padding-right: 52rem !important;\n  }\n\n  .pe-xl-106 {\n    padding-right: 52.5rem !important;\n  }\n\n  .pe-xl-107 {\n    padding-right: 53rem !important;\n  }\n\n  .pe-xl-108 {\n    padding-right: 53.5rem !important;\n  }\n\n  .pe-xl-109 {\n    padding-right: 54rem !important;\n  }\n\n  .pe-xl-110 {\n    padding-right: 54.5rem !important;\n  }\n\n  .pe-xl-111 {\n    padding-right: 55rem !important;\n  }\n\n  .pe-xl-112 {\n    padding-right: 55.5rem !important;\n  }\n\n  .pe-xl-113 {\n    padding-right: 56rem !important;\n  }\n\n  .pe-xl-114 {\n    padding-right: 56.5rem !important;\n  }\n\n  .pe-xl-115 {\n    padding-right: 57rem !important;\n  }\n\n  .pe-xl-116 {\n    padding-right: 57.5rem !important;\n  }\n\n  .pe-xl-117 {\n    padding-right: 58rem !important;\n  }\n\n  .pe-xl-118 {\n    padding-right: 58.5rem !important;\n  }\n\n  .pe-xl-119 {\n    padding-right: 59rem !important;\n  }\n\n  .pe-xl-120 {\n    padding-right: 59.5rem !important;\n  }\n\n  .pe-xl-121 {\n    padding-right: 60rem !important;\n  }\n\n  .pe-xl-122 {\n    padding-right: 60.5rem !important;\n  }\n\n  .pe-xl-123 {\n    padding-right: 61rem !important;\n  }\n\n  .pe-xl-124 {\n    padding-right: 61.5rem !important;\n  }\n\n  .pe-xl-125 {\n    padding-right: 62rem !important;\n  }\n\n  .pe-xl-126 {\n    padding-right: 62.5rem !important;\n  }\n\n  .pe-xl-127 {\n    padding-right: 63rem !important;\n  }\n\n  .pe-xl-128 {\n    padding-right: 63.5rem !important;\n  }\n\n  .pe-xl-129 {\n    padding-right: 64rem !important;\n  }\n\n  .pe-xl-130 {\n    padding-right: 64.5rem !important;\n  }\n\n  .pe-xl-131 {\n    padding-right: 65rem !important;\n  }\n\n  .pe-xl-132 {\n    padding-right: 65.5rem !important;\n  }\n\n  .pe-xl-133 {\n    padding-right: 66rem !important;\n  }\n\n  .pe-xl-134 {\n    padding-right: 66.5rem !important;\n  }\n\n  .pe-xl-135 {\n    padding-right: 67rem !important;\n  }\n\n  .pe-xl-136 {\n    padding-right: 67.5rem !important;\n  }\n\n  .pe-xl-137 {\n    padding-right: 68rem !important;\n  }\n\n  .pe-xl-138 {\n    padding-right: 68.5rem !important;\n  }\n\n  .pe-xl-139 {\n    padding-right: 69rem !important;\n  }\n\n  .pe-xl-140 {\n    padding-right: 69.5rem !important;\n  }\n\n  .pe-xl-141 {\n    padding-right: 70rem !important;\n  }\n\n  .pe-xl-142 {\n    padding-right: 70.5rem !important;\n  }\n\n  .pe-xl-143 {\n    padding-right: 71rem !important;\n  }\n\n  .pe-xl-144 {\n    padding-right: 71.5rem !important;\n  }\n\n  .pe-xl-145 {\n    padding-right: 72rem !important;\n  }\n\n  .pe-xl-146 {\n    padding-right: 72.5rem !important;\n  }\n\n  .pe-xl-147 {\n    padding-right: 73rem !important;\n  }\n\n  .pe-xl-148 {\n    padding-right: 73.5rem !important;\n  }\n\n  .pe-xl-149 {\n    padding-right: 74rem !important;\n  }\n\n  .pe-xl-150 {\n    padding-right: 74.5rem !important;\n  }\n\n  .pe-xl-151 {\n    padding-right: 75rem !important;\n  }\n\n  .pe-xl-152 {\n    padding-right: 75.5rem !important;\n  }\n\n  .pe-xl-153 {\n    padding-right: 76rem !important;\n  }\n\n  .pe-xl-154 {\n    padding-right: 76.5rem !important;\n  }\n\n  .pe-xl-155 {\n    padding-right: 77rem !important;\n  }\n\n  .pe-xl-156 {\n    padding-right: 77.5rem !important;\n  }\n\n  .pe-xl-157 {\n    padding-right: 78rem !important;\n  }\n\n  .pe-xl-158 {\n    padding-right: 78.5rem !important;\n  }\n\n  .pe-xl-159 {\n    padding-right: 79rem !important;\n  }\n\n  .pe-xl-160 {\n    padding-right: 79.5rem !important;\n  }\n\n  .px-xl-0 {\n    padding-left: 0rem !important;\n    padding-right: 0rem !important;\n  }\n\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .px-xl-3 {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .px-xl-5 {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n\n  .px-xl-6 {\n    padding-left: 2.5rem !important;\n    padding-right: 2.5rem !important;\n  }\n\n  .px-xl-7 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n  }\n\n  .px-xl-8 {\n    padding-left: 3.5rem !important;\n    padding-right: 3.5rem !important;\n  }\n\n  .px-xl-9 {\n    padding-left: 4rem !important;\n    padding-right: 4rem !important;\n  }\n\n  .px-xl-10 {\n    padding-left: 4.5rem !important;\n    padding-right: 4.5rem !important;\n  }\n\n  .px-xl-11 {\n    padding-left: 5rem !important;\n    padding-right: 5rem !important;\n  }\n\n  .px-xl-12 {\n    padding-left: 5.5rem !important;\n    padding-right: 5.5rem !important;\n  }\n\n  .px-xl-13 {\n    padding-left: 6rem !important;\n    padding-right: 6rem !important;\n  }\n\n  .px-xl-14 {\n    padding-left: 6.5rem !important;\n    padding-right: 6.5rem !important;\n  }\n\n  .px-xl-15 {\n    padding-left: 7rem !important;\n    padding-right: 7rem !important;\n  }\n\n  .px-xl-16 {\n    padding-left: 7.5rem !important;\n    padding-right: 7.5rem !important;\n  }\n\n  .px-xl-17 {\n    padding-left: 8rem !important;\n    padding-right: 8rem !important;\n  }\n\n  .px-xl-18 {\n    padding-left: 8.5rem !important;\n    padding-right: 8.5rem !important;\n  }\n\n  .px-xl-19 {\n    padding-left: 9rem !important;\n    padding-right: 9rem !important;\n  }\n\n  .px-xl-20 {\n    padding-left: 9.5rem !important;\n    padding-right: 9.5rem !important;\n  }\n\n  .px-xl-21 {\n    padding-left: 10rem !important;\n    padding-right: 10rem !important;\n  }\n\n  .px-xl-22 {\n    padding-left: 10.5rem !important;\n    padding-right: 10.5rem !important;\n  }\n\n  .px-xl-23 {\n    padding-left: 11rem !important;\n    padding-right: 11rem !important;\n  }\n\n  .px-xl-24 {\n    padding-left: 11.5rem !important;\n    padding-right: 11.5rem !important;\n  }\n\n  .px-xl-25 {\n    padding-left: 12rem !important;\n    padding-right: 12rem !important;\n  }\n\n  .px-xl-26 {\n    padding-left: 12.5rem !important;\n    padding-right: 12.5rem !important;\n  }\n\n  .px-xl-27 {\n    padding-left: 13rem !important;\n    padding-right: 13rem !important;\n  }\n\n  .px-xl-28 {\n    padding-left: 13.5rem !important;\n    padding-right: 13.5rem !important;\n  }\n\n  .px-xl-29 {\n    padding-left: 14rem !important;\n    padding-right: 14rem !important;\n  }\n\n  .px-xl-30 {\n    padding-left: 14.5rem !important;\n    padding-right: 14.5rem !important;\n  }\n\n  .px-xl-31 {\n    padding-left: 15rem !important;\n    padding-right: 15rem !important;\n  }\n\n  .px-xl-32 {\n    padding-left: 15.5rem !important;\n    padding-right: 15.5rem !important;\n  }\n\n  .px-xl-33 {\n    padding-left: 16rem !important;\n    padding-right: 16rem !important;\n  }\n\n  .px-xl-34 {\n    padding-left: 16.5rem !important;\n    padding-right: 16.5rem !important;\n  }\n\n  .px-xl-35 {\n    padding-left: 17rem !important;\n    padding-right: 17rem !important;\n  }\n\n  .px-xl-36 {\n    padding-left: 17.5rem !important;\n    padding-right: 17.5rem !important;\n  }\n\n  .px-xl-37 {\n    padding-left: 18rem !important;\n    padding-right: 18rem !important;\n  }\n\n  .px-xl-38 {\n    padding-left: 18.5rem !important;\n    padding-right: 18.5rem !important;\n  }\n\n  .px-xl-39 {\n    padding-left: 19rem !important;\n    padding-right: 19rem !important;\n  }\n\n  .px-xl-40 {\n    padding-left: 19.5rem !important;\n    padding-right: 19.5rem !important;\n  }\n\n  .px-xl-41 {\n    padding-left: 20rem !important;\n    padding-right: 20rem !important;\n  }\n\n  .px-xl-42 {\n    padding-left: 20.5rem !important;\n    padding-right: 20.5rem !important;\n  }\n\n  .px-xl-43 {\n    padding-left: 21rem !important;\n    padding-right: 21rem !important;\n  }\n\n  .px-xl-44 {\n    padding-left: 21.5rem !important;\n    padding-right: 21.5rem !important;\n  }\n\n  .px-xl-45 {\n    padding-left: 22rem !important;\n    padding-right: 22rem !important;\n  }\n\n  .px-xl-46 {\n    padding-left: 22.5rem !important;\n    padding-right: 22.5rem !important;\n  }\n\n  .px-xl-47 {\n    padding-left: 23rem !important;\n    padding-right: 23rem !important;\n  }\n\n  .px-xl-48 {\n    padding-left: 23.5rem !important;\n    padding-right: 23.5rem !important;\n  }\n\n  .px-xl-49 {\n    padding-left: 24rem !important;\n    padding-right: 24rem !important;\n  }\n\n  .px-xl-50 {\n    padding-left: 24.5rem !important;\n    padding-right: 24.5rem !important;\n  }\n\n  .px-xl-51 {\n    padding-left: 25rem !important;\n    padding-right: 25rem !important;\n  }\n\n  .px-xl-52 {\n    padding-left: 25.5rem !important;\n    padding-right: 25.5rem !important;\n  }\n\n  .px-xl-53 {\n    padding-left: 26rem !important;\n    padding-right: 26rem !important;\n  }\n\n  .px-xl-54 {\n    padding-left: 26.5rem !important;\n    padding-right: 26.5rem !important;\n  }\n\n  .px-xl-55 {\n    padding-left: 27rem !important;\n    padding-right: 27rem !important;\n  }\n\n  .px-xl-56 {\n    padding-left: 27.5rem !important;\n    padding-right: 27.5rem !important;\n  }\n\n  .px-xl-57 {\n    padding-left: 28rem !important;\n    padding-right: 28rem !important;\n  }\n\n  .px-xl-58 {\n    padding-left: 28.5rem !important;\n    padding-right: 28.5rem !important;\n  }\n\n  .px-xl-59 {\n    padding-left: 29rem !important;\n    padding-right: 29rem !important;\n  }\n\n  .px-xl-60 {\n    padding-left: 29.5rem !important;\n    padding-right: 29.5rem !important;\n  }\n\n  .px-xl-61 {\n    padding-left: 30rem !important;\n    padding-right: 30rem !important;\n  }\n\n  .px-xl-62 {\n    padding-left: 30.5rem !important;\n    padding-right: 30.5rem !important;\n  }\n\n  .px-xl-63 {\n    padding-left: 31rem !important;\n    padding-right: 31rem !important;\n  }\n\n  .px-xl-64 {\n    padding-left: 31.5rem !important;\n    padding-right: 31.5rem !important;\n  }\n\n  .px-xl-65 {\n    padding-left: 32rem !important;\n    padding-right: 32rem !important;\n  }\n\n  .px-xl-66 {\n    padding-left: 32.5rem !important;\n    padding-right: 32.5rem !important;\n  }\n\n  .px-xl-67 {\n    padding-left: 33rem !important;\n    padding-right: 33rem !important;\n  }\n\n  .px-xl-68 {\n    padding-left: 33.5rem !important;\n    padding-right: 33.5rem !important;\n  }\n\n  .px-xl-69 {\n    padding-left: 34rem !important;\n    padding-right: 34rem !important;\n  }\n\n  .px-xl-70 {\n    padding-left: 34.5rem !important;\n    padding-right: 34.5rem !important;\n  }\n\n  .px-xl-71 {\n    padding-left: 35rem !important;\n    padding-right: 35rem !important;\n  }\n\n  .px-xl-72 {\n    padding-left: 35.5rem !important;\n    padding-right: 35.5rem !important;\n  }\n\n  .px-xl-73 {\n    padding-left: 36rem !important;\n    padding-right: 36rem !important;\n  }\n\n  .px-xl-74 {\n    padding-left: 36.5rem !important;\n    padding-right: 36.5rem !important;\n  }\n\n  .px-xl-75 {\n    padding-left: 37rem !important;\n    padding-right: 37rem !important;\n  }\n\n  .px-xl-76 {\n    padding-left: 37.5rem !important;\n    padding-right: 37.5rem !important;\n  }\n\n  .px-xl-77 {\n    padding-left: 38rem !important;\n    padding-right: 38rem !important;\n  }\n\n  .px-xl-78 {\n    padding-left: 38.5rem !important;\n    padding-right: 38.5rem !important;\n  }\n\n  .px-xl-79 {\n    padding-left: 39rem !important;\n    padding-right: 39rem !important;\n  }\n\n  .px-xl-80 {\n    padding-left: 39.5rem !important;\n    padding-right: 39.5rem !important;\n  }\n\n  .px-xl-81 {\n    padding-left: 40rem !important;\n    padding-right: 40rem !important;\n  }\n\n  .px-xl-82 {\n    padding-left: 40.5rem !important;\n    padding-right: 40.5rem !important;\n  }\n\n  .px-xl-83 {\n    padding-left: 41rem !important;\n    padding-right: 41rem !important;\n  }\n\n  .px-xl-84 {\n    padding-left: 41.5rem !important;\n    padding-right: 41.5rem !important;\n  }\n\n  .px-xl-85 {\n    padding-left: 42rem !important;\n    padding-right: 42rem !important;\n  }\n\n  .px-xl-86 {\n    padding-left: 42.5rem !important;\n    padding-right: 42.5rem !important;\n  }\n\n  .px-xl-87 {\n    padding-left: 43rem !important;\n    padding-right: 43rem !important;\n  }\n\n  .px-xl-88 {\n    padding-left: 43.5rem !important;\n    padding-right: 43.5rem !important;\n  }\n\n  .px-xl-89 {\n    padding-left: 44rem !important;\n    padding-right: 44rem !important;\n  }\n\n  .px-xl-90 {\n    padding-left: 44.5rem !important;\n    padding-right: 44.5rem !important;\n  }\n\n  .px-xl-91 {\n    padding-left: 45rem !important;\n    padding-right: 45rem !important;\n  }\n\n  .px-xl-92 {\n    padding-left: 45.5rem !important;\n    padding-right: 45.5rem !important;\n  }\n\n  .px-xl-93 {\n    padding-left: 46rem !important;\n    padding-right: 46rem !important;\n  }\n\n  .px-xl-94 {\n    padding-left: 46.5rem !important;\n    padding-right: 46.5rem !important;\n  }\n\n  .px-xl-95 {\n    padding-left: 47rem !important;\n    padding-right: 47rem !important;\n  }\n\n  .px-xl-96 {\n    padding-left: 47.5rem !important;\n    padding-right: 47.5rem !important;\n  }\n\n  .px-xl-97 {\n    padding-left: 48rem !important;\n    padding-right: 48rem !important;\n  }\n\n  .px-xl-98 {\n    padding-left: 48.5rem !important;\n    padding-right: 48.5rem !important;\n  }\n\n  .px-xl-99 {\n    padding-left: 49rem !important;\n    padding-right: 49rem !important;\n  }\n\n  .px-xl-100 {\n    padding-left: 49.5rem !important;\n    padding-right: 49.5rem !important;\n  }\n\n  .px-xl-101 {\n    padding-left: 50rem !important;\n    padding-right: 50rem !important;\n  }\n\n  .px-xl-102 {\n    padding-left: 50.5rem !important;\n    padding-right: 50.5rem !important;\n  }\n\n  .px-xl-103 {\n    padding-left: 51rem !important;\n    padding-right: 51rem !important;\n  }\n\n  .px-xl-104 {\n    padding-left: 51.5rem !important;\n    padding-right: 51.5rem !important;\n  }\n\n  .px-xl-105 {\n    padding-left: 52rem !important;\n    padding-right: 52rem !important;\n  }\n\n  .px-xl-106 {\n    padding-left: 52.5rem !important;\n    padding-right: 52.5rem !important;\n  }\n\n  .px-xl-107 {\n    padding-left: 53rem !important;\n    padding-right: 53rem !important;\n  }\n\n  .px-xl-108 {\n    padding-left: 53.5rem !important;\n    padding-right: 53.5rem !important;\n  }\n\n  .px-xl-109 {\n    padding-left: 54rem !important;\n    padding-right: 54rem !important;\n  }\n\n  .px-xl-110 {\n    padding-left: 54.5rem !important;\n    padding-right: 54.5rem !important;\n  }\n\n  .px-xl-111 {\n    padding-left: 55rem !important;\n    padding-right: 55rem !important;\n  }\n\n  .px-xl-112 {\n    padding-left: 55.5rem !important;\n    padding-right: 55.5rem !important;\n  }\n\n  .px-xl-113 {\n    padding-left: 56rem !important;\n    padding-right: 56rem !important;\n  }\n\n  .px-xl-114 {\n    padding-left: 56.5rem !important;\n    padding-right: 56.5rem !important;\n  }\n\n  .px-xl-115 {\n    padding-left: 57rem !important;\n    padding-right: 57rem !important;\n  }\n\n  .px-xl-116 {\n    padding-left: 57.5rem !important;\n    padding-right: 57.5rem !important;\n  }\n\n  .px-xl-117 {\n    padding-left: 58rem !important;\n    padding-right: 58rem !important;\n  }\n\n  .px-xl-118 {\n    padding-left: 58.5rem !important;\n    padding-right: 58.5rem !important;\n  }\n\n  .px-xl-119 {\n    padding-left: 59rem !important;\n    padding-right: 59rem !important;\n  }\n\n  .px-xl-120 {\n    padding-left: 59.5rem !important;\n    padding-right: 59.5rem !important;\n  }\n\n  .px-xl-121 {\n    padding-left: 60rem !important;\n    padding-right: 60rem !important;\n  }\n\n  .px-xl-122 {\n    padding-left: 60.5rem !important;\n    padding-right: 60.5rem !important;\n  }\n\n  .px-xl-123 {\n    padding-left: 61rem !important;\n    padding-right: 61rem !important;\n  }\n\n  .px-xl-124 {\n    padding-left: 61.5rem !important;\n    padding-right: 61.5rem !important;\n  }\n\n  .px-xl-125 {\n    padding-left: 62rem !important;\n    padding-right: 62rem !important;\n  }\n\n  .px-xl-126 {\n    padding-left: 62.5rem !important;\n    padding-right: 62.5rem !important;\n  }\n\n  .px-xl-127 {\n    padding-left: 63rem !important;\n    padding-right: 63rem !important;\n  }\n\n  .px-xl-128 {\n    padding-left: 63.5rem !important;\n    padding-right: 63.5rem !important;\n  }\n\n  .px-xl-129 {\n    padding-left: 64rem !important;\n    padding-right: 64rem !important;\n  }\n\n  .px-xl-130 {\n    padding-left: 64.5rem !important;\n    padding-right: 64.5rem !important;\n  }\n\n  .px-xl-131 {\n    padding-left: 65rem !important;\n    padding-right: 65rem !important;\n  }\n\n  .px-xl-132 {\n    padding-left: 65.5rem !important;\n    padding-right: 65.5rem !important;\n  }\n\n  .px-xl-133 {\n    padding-left: 66rem !important;\n    padding-right: 66rem !important;\n  }\n\n  .px-xl-134 {\n    padding-left: 66.5rem !important;\n    padding-right: 66.5rem !important;\n  }\n\n  .px-xl-135 {\n    padding-left: 67rem !important;\n    padding-right: 67rem !important;\n  }\n\n  .px-xl-136 {\n    padding-left: 67.5rem !important;\n    padding-right: 67.5rem !important;\n  }\n\n  .px-xl-137 {\n    padding-left: 68rem !important;\n    padding-right: 68rem !important;\n  }\n\n  .px-xl-138 {\n    padding-left: 68.5rem !important;\n    padding-right: 68.5rem !important;\n  }\n\n  .px-xl-139 {\n    padding-left: 69rem !important;\n    padding-right: 69rem !important;\n  }\n\n  .px-xl-140 {\n    padding-left: 69.5rem !important;\n    padding-right: 69.5rem !important;\n  }\n\n  .px-xl-141 {\n    padding-left: 70rem !important;\n    padding-right: 70rem !important;\n  }\n\n  .px-xl-142 {\n    padding-left: 70.5rem !important;\n    padding-right: 70.5rem !important;\n  }\n\n  .px-xl-143 {\n    padding-left: 71rem !important;\n    padding-right: 71rem !important;\n  }\n\n  .px-xl-144 {\n    padding-left: 71.5rem !important;\n    padding-right: 71.5rem !important;\n  }\n\n  .px-xl-145 {\n    padding-left: 72rem !important;\n    padding-right: 72rem !important;\n  }\n\n  .px-xl-146 {\n    padding-left: 72.5rem !important;\n    padding-right: 72.5rem !important;\n  }\n\n  .px-xl-147 {\n    padding-left: 73rem !important;\n    padding-right: 73rem !important;\n  }\n\n  .px-xl-148 {\n    padding-left: 73.5rem !important;\n    padding-right: 73.5rem !important;\n  }\n\n  .px-xl-149 {\n    padding-left: 74rem !important;\n    padding-right: 74rem !important;\n  }\n\n  .px-xl-150 {\n    padding-left: 74.5rem !important;\n    padding-right: 74.5rem !important;\n  }\n\n  .px-xl-151 {\n    padding-left: 75rem !important;\n    padding-right: 75rem !important;\n  }\n\n  .px-xl-152 {\n    padding-left: 75.5rem !important;\n    padding-right: 75.5rem !important;\n  }\n\n  .px-xl-153 {\n    padding-left: 76rem !important;\n    padding-right: 76rem !important;\n  }\n\n  .px-xl-154 {\n    padding-left: 76.5rem !important;\n    padding-right: 76.5rem !important;\n  }\n\n  .px-xl-155 {\n    padding-left: 77rem !important;\n    padding-right: 77rem !important;\n  }\n\n  .px-xl-156 {\n    padding-left: 77.5rem !important;\n    padding-right: 77.5rem !important;\n  }\n\n  .px-xl-157 {\n    padding-left: 78rem !important;\n    padding-right: 78rem !important;\n  }\n\n  .px-xl-158 {\n    padding-left: 78.5rem !important;\n    padding-right: 78.5rem !important;\n  }\n\n  .px-xl-159 {\n    padding-left: 79rem !important;\n    padding-right: 79rem !important;\n  }\n\n  .px-xl-160 {\n    padding-left: 79.5rem !important;\n    padding-right: 79.5rem !important;\n  }\n\n  .py-xl-0 {\n    padding-top: 0rem !important;\n    padding-bottom: 0rem !important;\n  }\n\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xl-5 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xl-6 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xl-7 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xl-8 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xl-9 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xl-10 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xl-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .py-xl-12 {\n    padding-top: 5.5rem !important;\n    padding-bottom: 5.5rem !important;\n  }\n\n  .py-xl-13 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n\n  .py-xl-14 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n\n  .py-xl-15 {\n    padding-top: 7rem !important;\n    padding-bottom: 7rem !important;\n  }\n\n  .py-xl-16 {\n    padding-top: 7.5rem !important;\n    padding-bottom: 7.5rem !important;\n  }\n\n  .py-xl-17 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n\n  .py-xl-18 {\n    padding-top: 8.5rem !important;\n    padding-bottom: 8.5rem !important;\n  }\n\n  .py-xl-19 {\n    padding-top: 9rem !important;\n    padding-bottom: 9rem !important;\n  }\n\n  .py-xl-20 {\n    padding-top: 9.5rem !important;\n    padding-bottom: 9.5rem !important;\n  }\n\n  .py-xl-21 {\n    padding-top: 10rem !important;\n    padding-bottom: 10rem !important;\n  }\n\n  .py-xl-22 {\n    padding-top: 10.5rem !important;\n    padding-bottom: 10.5rem !important;\n  }\n\n  .py-xl-23 {\n    padding-top: 11rem !important;\n    padding-bottom: 11rem !important;\n  }\n\n  .py-xl-24 {\n    padding-top: 11.5rem !important;\n    padding-bottom: 11.5rem !important;\n  }\n\n  .py-xl-25 {\n    padding-top: 12rem !important;\n    padding-bottom: 12rem !important;\n  }\n\n  .py-xl-26 {\n    padding-top: 12.5rem !important;\n    padding-bottom: 12.5rem !important;\n  }\n\n  .py-xl-27 {\n    padding-top: 13rem !important;\n    padding-bottom: 13rem !important;\n  }\n\n  .py-xl-28 {\n    padding-top: 13.5rem !important;\n    padding-bottom: 13.5rem !important;\n  }\n\n  .py-xl-29 {\n    padding-top: 14rem !important;\n    padding-bottom: 14rem !important;\n  }\n\n  .py-xl-30 {\n    padding-top: 14.5rem !important;\n    padding-bottom: 14.5rem !important;\n  }\n\n  .py-xl-31 {\n    padding-top: 15rem !important;\n    padding-bottom: 15rem !important;\n  }\n\n  .py-xl-32 {\n    padding-top: 15.5rem !important;\n    padding-bottom: 15.5rem !important;\n  }\n\n  .py-xl-33 {\n    padding-top: 16rem !important;\n    padding-bottom: 16rem !important;\n  }\n\n  .py-xl-34 {\n    padding-top: 16.5rem !important;\n    padding-bottom: 16.5rem !important;\n  }\n\n  .py-xl-35 {\n    padding-top: 17rem !important;\n    padding-bottom: 17rem !important;\n  }\n\n  .py-xl-36 {\n    padding-top: 17.5rem !important;\n    padding-bottom: 17.5rem !important;\n  }\n\n  .py-xl-37 {\n    padding-top: 18rem !important;\n    padding-bottom: 18rem !important;\n  }\n\n  .py-xl-38 {\n    padding-top: 18.5rem !important;\n    padding-bottom: 18.5rem !important;\n  }\n\n  .py-xl-39 {\n    padding-top: 19rem !important;\n    padding-bottom: 19rem !important;\n  }\n\n  .py-xl-40 {\n    padding-top: 19.5rem !important;\n    padding-bottom: 19.5rem !important;\n  }\n\n  .py-xl-41 {\n    padding-top: 20rem !important;\n    padding-bottom: 20rem !important;\n  }\n\n  .py-xl-42 {\n    padding-top: 20.5rem !important;\n    padding-bottom: 20.5rem !important;\n  }\n\n  .py-xl-43 {\n    padding-top: 21rem !important;\n    padding-bottom: 21rem !important;\n  }\n\n  .py-xl-44 {\n    padding-top: 21.5rem !important;\n    padding-bottom: 21.5rem !important;\n  }\n\n  .py-xl-45 {\n    padding-top: 22rem !important;\n    padding-bottom: 22rem !important;\n  }\n\n  .py-xl-46 {\n    padding-top: 22.5rem !important;\n    padding-bottom: 22.5rem !important;\n  }\n\n  .py-xl-47 {\n    padding-top: 23rem !important;\n    padding-bottom: 23rem !important;\n  }\n\n  .py-xl-48 {\n    padding-top: 23.5rem !important;\n    padding-bottom: 23.5rem !important;\n  }\n\n  .py-xl-49 {\n    padding-top: 24rem !important;\n    padding-bottom: 24rem !important;\n  }\n\n  .py-xl-50 {\n    padding-top: 24.5rem !important;\n    padding-bottom: 24.5rem !important;\n  }\n\n  .py-xl-51 {\n    padding-top: 25rem !important;\n    padding-bottom: 25rem !important;\n  }\n\n  .py-xl-52 {\n    padding-top: 25.5rem !important;\n    padding-bottom: 25.5rem !important;\n  }\n\n  .py-xl-53 {\n    padding-top: 26rem !important;\n    padding-bottom: 26rem !important;\n  }\n\n  .py-xl-54 {\n    padding-top: 26.5rem !important;\n    padding-bottom: 26.5rem !important;\n  }\n\n  .py-xl-55 {\n    padding-top: 27rem !important;\n    padding-bottom: 27rem !important;\n  }\n\n  .py-xl-56 {\n    padding-top: 27.5rem !important;\n    padding-bottom: 27.5rem !important;\n  }\n\n  .py-xl-57 {\n    padding-top: 28rem !important;\n    padding-bottom: 28rem !important;\n  }\n\n  .py-xl-58 {\n    padding-top: 28.5rem !important;\n    padding-bottom: 28.5rem !important;\n  }\n\n  .py-xl-59 {\n    padding-top: 29rem !important;\n    padding-bottom: 29rem !important;\n  }\n\n  .py-xl-60 {\n    padding-top: 29.5rem !important;\n    padding-bottom: 29.5rem !important;\n  }\n\n  .py-xl-61 {\n    padding-top: 30rem !important;\n    padding-bottom: 30rem !important;\n  }\n\n  .py-xl-62 {\n    padding-top: 30.5rem !important;\n    padding-bottom: 30.5rem !important;\n  }\n\n  .py-xl-63 {\n    padding-top: 31rem !important;\n    padding-bottom: 31rem !important;\n  }\n\n  .py-xl-64 {\n    padding-top: 31.5rem !important;\n    padding-bottom: 31.5rem !important;\n  }\n\n  .py-xl-65 {\n    padding-top: 32rem !important;\n    padding-bottom: 32rem !important;\n  }\n\n  .py-xl-66 {\n    padding-top: 32.5rem !important;\n    padding-bottom: 32.5rem !important;\n  }\n\n  .py-xl-67 {\n    padding-top: 33rem !important;\n    padding-bottom: 33rem !important;\n  }\n\n  .py-xl-68 {\n    padding-top: 33.5rem !important;\n    padding-bottom: 33.5rem !important;\n  }\n\n  .py-xl-69 {\n    padding-top: 34rem !important;\n    padding-bottom: 34rem !important;\n  }\n\n  .py-xl-70 {\n    padding-top: 34.5rem !important;\n    padding-bottom: 34.5rem !important;\n  }\n\n  .py-xl-71 {\n    padding-top: 35rem !important;\n    padding-bottom: 35rem !important;\n  }\n\n  .py-xl-72 {\n    padding-top: 35.5rem !important;\n    padding-bottom: 35.5rem !important;\n  }\n\n  .py-xl-73 {\n    padding-top: 36rem !important;\n    padding-bottom: 36rem !important;\n  }\n\n  .py-xl-74 {\n    padding-top: 36.5rem !important;\n    padding-bottom: 36.5rem !important;\n  }\n\n  .py-xl-75 {\n    padding-top: 37rem !important;\n    padding-bottom: 37rem !important;\n  }\n\n  .py-xl-76 {\n    padding-top: 37.5rem !important;\n    padding-bottom: 37.5rem !important;\n  }\n\n  .py-xl-77 {\n    padding-top: 38rem !important;\n    padding-bottom: 38rem !important;\n  }\n\n  .py-xl-78 {\n    padding-top: 38.5rem !important;\n    padding-bottom: 38.5rem !important;\n  }\n\n  .py-xl-79 {\n    padding-top: 39rem !important;\n    padding-bottom: 39rem !important;\n  }\n\n  .py-xl-80 {\n    padding-top: 39.5rem !important;\n    padding-bottom: 39.5rem !important;\n  }\n\n  .py-xl-81 {\n    padding-top: 40rem !important;\n    padding-bottom: 40rem !important;\n  }\n\n  .py-xl-82 {\n    padding-top: 40.5rem !important;\n    padding-bottom: 40.5rem !important;\n  }\n\n  .py-xl-83 {\n    padding-top: 41rem !important;\n    padding-bottom: 41rem !important;\n  }\n\n  .py-xl-84 {\n    padding-top: 41.5rem !important;\n    padding-bottom: 41.5rem !important;\n  }\n\n  .py-xl-85 {\n    padding-top: 42rem !important;\n    padding-bottom: 42rem !important;\n  }\n\n  .py-xl-86 {\n    padding-top: 42.5rem !important;\n    padding-bottom: 42.5rem !important;\n  }\n\n  .py-xl-87 {\n    padding-top: 43rem !important;\n    padding-bottom: 43rem !important;\n  }\n\n  .py-xl-88 {\n    padding-top: 43.5rem !important;\n    padding-bottom: 43.5rem !important;\n  }\n\n  .py-xl-89 {\n    padding-top: 44rem !important;\n    padding-bottom: 44rem !important;\n  }\n\n  .py-xl-90 {\n    padding-top: 44.5rem !important;\n    padding-bottom: 44.5rem !important;\n  }\n\n  .py-xl-91 {\n    padding-top: 45rem !important;\n    padding-bottom: 45rem !important;\n  }\n\n  .py-xl-92 {\n    padding-top: 45.5rem !important;\n    padding-bottom: 45.5rem !important;\n  }\n\n  .py-xl-93 {\n    padding-top: 46rem !important;\n    padding-bottom: 46rem !important;\n  }\n\n  .py-xl-94 {\n    padding-top: 46.5rem !important;\n    padding-bottom: 46.5rem !important;\n  }\n\n  .py-xl-95 {\n    padding-top: 47rem !important;\n    padding-bottom: 47rem !important;\n  }\n\n  .py-xl-96 {\n    padding-top: 47.5rem !important;\n    padding-bottom: 47.5rem !important;\n  }\n\n  .py-xl-97 {\n    padding-top: 48rem !important;\n    padding-bottom: 48rem !important;\n  }\n\n  .py-xl-98 {\n    padding-top: 48.5rem !important;\n    padding-bottom: 48.5rem !important;\n  }\n\n  .py-xl-99 {\n    padding-top: 49rem !important;\n    padding-bottom: 49rem !important;\n  }\n\n  .py-xl-100 {\n    padding-top: 49.5rem !important;\n    padding-bottom: 49.5rem !important;\n  }\n\n  .py-xl-101 {\n    padding-top: 50rem !important;\n    padding-bottom: 50rem !important;\n  }\n\n  .py-xl-102 {\n    padding-top: 50.5rem !important;\n    padding-bottom: 50.5rem !important;\n  }\n\n  .py-xl-103 {\n    padding-top: 51rem !important;\n    padding-bottom: 51rem !important;\n  }\n\n  .py-xl-104 {\n    padding-top: 51.5rem !important;\n    padding-bottom: 51.5rem !important;\n  }\n\n  .py-xl-105 {\n    padding-top: 52rem !important;\n    padding-bottom: 52rem !important;\n  }\n\n  .py-xl-106 {\n    padding-top: 52.5rem !important;\n    padding-bottom: 52.5rem !important;\n  }\n\n  .py-xl-107 {\n    padding-top: 53rem !important;\n    padding-bottom: 53rem !important;\n  }\n\n  .py-xl-108 {\n    padding-top: 53.5rem !important;\n    padding-bottom: 53.5rem !important;\n  }\n\n  .py-xl-109 {\n    padding-top: 54rem !important;\n    padding-bottom: 54rem !important;\n  }\n\n  .py-xl-110 {\n    padding-top: 54.5rem !important;\n    padding-bottom: 54.5rem !important;\n  }\n\n  .py-xl-111 {\n    padding-top: 55rem !important;\n    padding-bottom: 55rem !important;\n  }\n\n  .py-xl-112 {\n    padding-top: 55.5rem !important;\n    padding-bottom: 55.5rem !important;\n  }\n\n  .py-xl-113 {\n    padding-top: 56rem !important;\n    padding-bottom: 56rem !important;\n  }\n\n  .py-xl-114 {\n    padding-top: 56.5rem !important;\n    padding-bottom: 56.5rem !important;\n  }\n\n  .py-xl-115 {\n    padding-top: 57rem !important;\n    padding-bottom: 57rem !important;\n  }\n\n  .py-xl-116 {\n    padding-top: 57.5rem !important;\n    padding-bottom: 57.5rem !important;\n  }\n\n  .py-xl-117 {\n    padding-top: 58rem !important;\n    padding-bottom: 58rem !important;\n  }\n\n  .py-xl-118 {\n    padding-top: 58.5rem !important;\n    padding-bottom: 58.5rem !important;\n  }\n\n  .py-xl-119 {\n    padding-top: 59rem !important;\n    padding-bottom: 59rem !important;\n  }\n\n  .py-xl-120 {\n    padding-top: 59.5rem !important;\n    padding-bottom: 59.5rem !important;\n  }\n\n  .py-xl-121 {\n    padding-top: 60rem !important;\n    padding-bottom: 60rem !important;\n  }\n\n  .py-xl-122 {\n    padding-top: 60.5rem !important;\n    padding-bottom: 60.5rem !important;\n  }\n\n  .py-xl-123 {\n    padding-top: 61rem !important;\n    padding-bottom: 61rem !important;\n  }\n\n  .py-xl-124 {\n    padding-top: 61.5rem !important;\n    padding-bottom: 61.5rem !important;\n  }\n\n  .py-xl-125 {\n    padding-top: 62rem !important;\n    padding-bottom: 62rem !important;\n  }\n\n  .py-xl-126 {\n    padding-top: 62.5rem !important;\n    padding-bottom: 62.5rem !important;\n  }\n\n  .py-xl-127 {\n    padding-top: 63rem !important;\n    padding-bottom: 63rem !important;\n  }\n\n  .py-xl-128 {\n    padding-top: 63.5rem !important;\n    padding-bottom: 63.5rem !important;\n  }\n\n  .py-xl-129 {\n    padding-top: 64rem !important;\n    padding-bottom: 64rem !important;\n  }\n\n  .py-xl-130 {\n    padding-top: 64.5rem !important;\n    padding-bottom: 64.5rem !important;\n  }\n\n  .py-xl-131 {\n    padding-top: 65rem !important;\n    padding-bottom: 65rem !important;\n  }\n\n  .py-xl-132 {\n    padding-top: 65.5rem !important;\n    padding-bottom: 65.5rem !important;\n  }\n\n  .py-xl-133 {\n    padding-top: 66rem !important;\n    padding-bottom: 66rem !important;\n  }\n\n  .py-xl-134 {\n    padding-top: 66.5rem !important;\n    padding-bottom: 66.5rem !important;\n  }\n\n  .py-xl-135 {\n    padding-top: 67rem !important;\n    padding-bottom: 67rem !important;\n  }\n\n  .py-xl-136 {\n    padding-top: 67.5rem !important;\n    padding-bottom: 67.5rem !important;\n  }\n\n  .py-xl-137 {\n    padding-top: 68rem !important;\n    padding-bottom: 68rem !important;\n  }\n\n  .py-xl-138 {\n    padding-top: 68.5rem !important;\n    padding-bottom: 68.5rem !important;\n  }\n\n  .py-xl-139 {\n    padding-top: 69rem !important;\n    padding-bottom: 69rem !important;\n  }\n\n  .py-xl-140 {\n    padding-top: 69.5rem !important;\n    padding-bottom: 69.5rem !important;\n  }\n\n  .py-xl-141 {\n    padding-top: 70rem !important;\n    padding-bottom: 70rem !important;\n  }\n\n  .py-xl-142 {\n    padding-top: 70.5rem !important;\n    padding-bottom: 70.5rem !important;\n  }\n\n  .py-xl-143 {\n    padding-top: 71rem !important;\n    padding-bottom: 71rem !important;\n  }\n\n  .py-xl-144 {\n    padding-top: 71.5rem !important;\n    padding-bottom: 71.5rem !important;\n  }\n\n  .py-xl-145 {\n    padding-top: 72rem !important;\n    padding-bottom: 72rem !important;\n  }\n\n  .py-xl-146 {\n    padding-top: 72.5rem !important;\n    padding-bottom: 72.5rem !important;\n  }\n\n  .py-xl-147 {\n    padding-top: 73rem !important;\n    padding-bottom: 73rem !important;\n  }\n\n  .py-xl-148 {\n    padding-top: 73.5rem !important;\n    padding-bottom: 73.5rem !important;\n  }\n\n  .py-xl-149 {\n    padding-top: 74rem !important;\n    padding-bottom: 74rem !important;\n  }\n\n  .py-xl-150 {\n    padding-top: 74.5rem !important;\n    padding-bottom: 74.5rem !important;\n  }\n\n  .py-xl-151 {\n    padding-top: 75rem !important;\n    padding-bottom: 75rem !important;\n  }\n\n  .py-xl-152 {\n    padding-top: 75.5rem !important;\n    padding-bottom: 75.5rem !important;\n  }\n\n  .py-xl-153 {\n    padding-top: 76rem !important;\n    padding-bottom: 76rem !important;\n  }\n\n  .py-xl-154 {\n    padding-top: 76.5rem !important;\n    padding-bottom: 76.5rem !important;\n  }\n\n  .py-xl-155 {\n    padding-top: 77rem !important;\n    padding-bottom: 77rem !important;\n  }\n\n  .py-xl-156 {\n    padding-top: 77.5rem !important;\n    padding-bottom: 77.5rem !important;\n  }\n\n  .py-xl-157 {\n    padding-top: 78rem !important;\n    padding-bottom: 78rem !important;\n  }\n\n  .py-xl-158 {\n    padding-top: 78.5rem !important;\n    padding-bottom: 78.5rem !important;\n  }\n\n  .py-xl-159 {\n    padding-top: 79rem !important;\n    padding-bottom: 79rem !important;\n  }\n\n  .py-xl-160 {\n    padding-top: 79.5rem !important;\n    padding-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .p-xxl-0 {\n    padding: 0rem !important;\n  }\n\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xxl-5 {\n    padding: 2rem !important;\n  }\n\n  .p-xxl-6 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xxl-7 {\n    padding: 3rem !important;\n  }\n\n  .p-xxl-8 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xxl-9 {\n    padding: 4rem !important;\n  }\n\n  .p-xxl-10 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xxl-11 {\n    padding: 5rem !important;\n  }\n\n  .p-xxl-12 {\n    padding: 5.5rem !important;\n  }\n\n  .p-xxl-13 {\n    padding: 6rem !important;\n  }\n\n  .p-xxl-14 {\n    padding: 6.5rem !important;\n  }\n\n  .p-xxl-15 {\n    padding: 7rem !important;\n  }\n\n  .p-xxl-16 {\n    padding: 7.5rem !important;\n  }\n\n  .p-xxl-17 {\n    padding: 8rem !important;\n  }\n\n  .p-xxl-18 {\n    padding: 8.5rem !important;\n  }\n\n  .p-xxl-19 {\n    padding: 9rem !important;\n  }\n\n  .p-xxl-20 {\n    padding: 9.5rem !important;\n  }\n\n  .p-xxl-21 {\n    padding: 10rem !important;\n  }\n\n  .p-xxl-22 {\n    padding: 10.5rem !important;\n  }\n\n  .p-xxl-23 {\n    padding: 11rem !important;\n  }\n\n  .p-xxl-24 {\n    padding: 11.5rem !important;\n  }\n\n  .p-xxl-25 {\n    padding: 12rem !important;\n  }\n\n  .p-xxl-26 {\n    padding: 12.5rem !important;\n  }\n\n  .p-xxl-27 {\n    padding: 13rem !important;\n  }\n\n  .p-xxl-28 {\n    padding: 13.5rem !important;\n  }\n\n  .p-xxl-29 {\n    padding: 14rem !important;\n  }\n\n  .p-xxl-30 {\n    padding: 14.5rem !important;\n  }\n\n  .p-xxl-31 {\n    padding: 15rem !important;\n  }\n\n  .p-xxl-32 {\n    padding: 15.5rem !important;\n  }\n\n  .p-xxl-33 {\n    padding: 16rem !important;\n  }\n\n  .p-xxl-34 {\n    padding: 16.5rem !important;\n  }\n\n  .p-xxl-35 {\n    padding: 17rem !important;\n  }\n\n  .p-xxl-36 {\n    padding: 17.5rem !important;\n  }\n\n  .p-xxl-37 {\n    padding: 18rem !important;\n  }\n\n  .p-xxl-38 {\n    padding: 18.5rem !important;\n  }\n\n  .p-xxl-39 {\n    padding: 19rem !important;\n  }\n\n  .p-xxl-40 {\n    padding: 19.5rem !important;\n  }\n\n  .p-xxl-41 {\n    padding: 20rem !important;\n  }\n\n  .p-xxl-42 {\n    padding: 20.5rem !important;\n  }\n\n  .p-xxl-43 {\n    padding: 21rem !important;\n  }\n\n  .p-xxl-44 {\n    padding: 21.5rem !important;\n  }\n\n  .p-xxl-45 {\n    padding: 22rem !important;\n  }\n\n  .p-xxl-46 {\n    padding: 22.5rem !important;\n  }\n\n  .p-xxl-47 {\n    padding: 23rem !important;\n  }\n\n  .p-xxl-48 {\n    padding: 23.5rem !important;\n  }\n\n  .p-xxl-49 {\n    padding: 24rem !important;\n  }\n\n  .p-xxl-50 {\n    padding: 24.5rem !important;\n  }\n\n  .p-xxl-51 {\n    padding: 25rem !important;\n  }\n\n  .p-xxl-52 {\n    padding: 25.5rem !important;\n  }\n\n  .p-xxl-53 {\n    padding: 26rem !important;\n  }\n\n  .p-xxl-54 {\n    padding: 26.5rem !important;\n  }\n\n  .p-xxl-55 {\n    padding: 27rem !important;\n  }\n\n  .p-xxl-56 {\n    padding: 27.5rem !important;\n  }\n\n  .p-xxl-57 {\n    padding: 28rem !important;\n  }\n\n  .p-xxl-58 {\n    padding: 28.5rem !important;\n  }\n\n  .p-xxl-59 {\n    padding: 29rem !important;\n  }\n\n  .p-xxl-60 {\n    padding: 29.5rem !important;\n  }\n\n  .p-xxl-61 {\n    padding: 30rem !important;\n  }\n\n  .p-xxl-62 {\n    padding: 30.5rem !important;\n  }\n\n  .p-xxl-63 {\n    padding: 31rem !important;\n  }\n\n  .p-xxl-64 {\n    padding: 31.5rem !important;\n  }\n\n  .p-xxl-65 {\n    padding: 32rem !important;\n  }\n\n  .p-xxl-66 {\n    padding: 32.5rem !important;\n  }\n\n  .p-xxl-67 {\n    padding: 33rem !important;\n  }\n\n  .p-xxl-68 {\n    padding: 33.5rem !important;\n  }\n\n  .p-xxl-69 {\n    padding: 34rem !important;\n  }\n\n  .p-xxl-70 {\n    padding: 34.5rem !important;\n  }\n\n  .p-xxl-71 {\n    padding: 35rem !important;\n  }\n\n  .p-xxl-72 {\n    padding: 35.5rem !important;\n  }\n\n  .p-xxl-73 {\n    padding: 36rem !important;\n  }\n\n  .p-xxl-74 {\n    padding: 36.5rem !important;\n  }\n\n  .p-xxl-75 {\n    padding: 37rem !important;\n  }\n\n  .p-xxl-76 {\n    padding: 37.5rem !important;\n  }\n\n  .p-xxl-77 {\n    padding: 38rem !important;\n  }\n\n  .p-xxl-78 {\n    padding: 38.5rem !important;\n  }\n\n  .p-xxl-79 {\n    padding: 39rem !important;\n  }\n\n  .p-xxl-80 {\n    padding: 39.5rem !important;\n  }\n\n  .p-xxl-81 {\n    padding: 40rem !important;\n  }\n\n  .p-xxl-82 {\n    padding: 40.5rem !important;\n  }\n\n  .p-xxl-83 {\n    padding: 41rem !important;\n  }\n\n  .p-xxl-84 {\n    padding: 41.5rem !important;\n  }\n\n  .p-xxl-85 {\n    padding: 42rem !important;\n  }\n\n  .p-xxl-86 {\n    padding: 42.5rem !important;\n  }\n\n  .p-xxl-87 {\n    padding: 43rem !important;\n  }\n\n  .p-xxl-88 {\n    padding: 43.5rem !important;\n  }\n\n  .p-xxl-89 {\n    padding: 44rem !important;\n  }\n\n  .p-xxl-90 {\n    padding: 44.5rem !important;\n  }\n\n  .p-xxl-91 {\n    padding: 45rem !important;\n  }\n\n  .p-xxl-92 {\n    padding: 45.5rem !important;\n  }\n\n  .p-xxl-93 {\n    padding: 46rem !important;\n  }\n\n  .p-xxl-94 {\n    padding: 46.5rem !important;\n  }\n\n  .p-xxl-95 {\n    padding: 47rem !important;\n  }\n\n  .p-xxl-96 {\n    padding: 47.5rem !important;\n  }\n\n  .p-xxl-97 {\n    padding: 48rem !important;\n  }\n\n  .p-xxl-98 {\n    padding: 48.5rem !important;\n  }\n\n  .p-xxl-99 {\n    padding: 49rem !important;\n  }\n\n  .p-xxl-100 {\n    padding: 49.5rem !important;\n  }\n\n  .p-xxl-101 {\n    padding: 50rem !important;\n  }\n\n  .p-xxl-102 {\n    padding: 50.5rem !important;\n  }\n\n  .p-xxl-103 {\n    padding: 51rem !important;\n  }\n\n  .p-xxl-104 {\n    padding: 51.5rem !important;\n  }\n\n  .p-xxl-105 {\n    padding: 52rem !important;\n  }\n\n  .p-xxl-106 {\n    padding: 52.5rem !important;\n  }\n\n  .p-xxl-107 {\n    padding: 53rem !important;\n  }\n\n  .p-xxl-108 {\n    padding: 53.5rem !important;\n  }\n\n  .p-xxl-109 {\n    padding: 54rem !important;\n  }\n\n  .p-xxl-110 {\n    padding: 54.5rem !important;\n  }\n\n  .p-xxl-111 {\n    padding: 55rem !important;\n  }\n\n  .p-xxl-112 {\n    padding: 55.5rem !important;\n  }\n\n  .p-xxl-113 {\n    padding: 56rem !important;\n  }\n\n  .p-xxl-114 {\n    padding: 56.5rem !important;\n  }\n\n  .p-xxl-115 {\n    padding: 57rem !important;\n  }\n\n  .p-xxl-116 {\n    padding: 57.5rem !important;\n  }\n\n  .p-xxl-117 {\n    padding: 58rem !important;\n  }\n\n  .p-xxl-118 {\n    padding: 58.5rem !important;\n  }\n\n  .p-xxl-119 {\n    padding: 59rem !important;\n  }\n\n  .p-xxl-120 {\n    padding: 59.5rem !important;\n  }\n\n  .p-xxl-121 {\n    padding: 60rem !important;\n  }\n\n  .p-xxl-122 {\n    padding: 60.5rem !important;\n  }\n\n  .p-xxl-123 {\n    padding: 61rem !important;\n  }\n\n  .p-xxl-124 {\n    padding: 61.5rem !important;\n  }\n\n  .p-xxl-125 {\n    padding: 62rem !important;\n  }\n\n  .p-xxl-126 {\n    padding: 62.5rem !important;\n  }\n\n  .p-xxl-127 {\n    padding: 63rem !important;\n  }\n\n  .p-xxl-128 {\n    padding: 63.5rem !important;\n  }\n\n  .p-xxl-129 {\n    padding: 64rem !important;\n  }\n\n  .p-xxl-130 {\n    padding: 64.5rem !important;\n  }\n\n  .p-xxl-131 {\n    padding: 65rem !important;\n  }\n\n  .p-xxl-132 {\n    padding: 65.5rem !important;\n  }\n\n  .p-xxl-133 {\n    padding: 66rem !important;\n  }\n\n  .p-xxl-134 {\n    padding: 66.5rem !important;\n  }\n\n  .p-xxl-135 {\n    padding: 67rem !important;\n  }\n\n  .p-xxl-136 {\n    padding: 67.5rem !important;\n  }\n\n  .p-xxl-137 {\n    padding: 68rem !important;\n  }\n\n  .p-xxl-138 {\n    padding: 68.5rem !important;\n  }\n\n  .p-xxl-139 {\n    padding: 69rem !important;\n  }\n\n  .p-xxl-140 {\n    padding: 69.5rem !important;\n  }\n\n  .p-xxl-141 {\n    padding: 70rem !important;\n  }\n\n  .p-xxl-142 {\n    padding: 70.5rem !important;\n  }\n\n  .p-xxl-143 {\n    padding: 71rem !important;\n  }\n\n  .p-xxl-144 {\n    padding: 71.5rem !important;\n  }\n\n  .p-xxl-145 {\n    padding: 72rem !important;\n  }\n\n  .p-xxl-146 {\n    padding: 72.5rem !important;\n  }\n\n  .p-xxl-147 {\n    padding: 73rem !important;\n  }\n\n  .p-xxl-148 {\n    padding: 73.5rem !important;\n  }\n\n  .p-xxl-149 {\n    padding: 74rem !important;\n  }\n\n  .p-xxl-150 {\n    padding: 74.5rem !important;\n  }\n\n  .p-xxl-151 {\n    padding: 75rem !important;\n  }\n\n  .p-xxl-152 {\n    padding: 75.5rem !important;\n  }\n\n  .p-xxl-153 {\n    padding: 76rem !important;\n  }\n\n  .p-xxl-154 {\n    padding: 76.5rem !important;\n  }\n\n  .p-xxl-155 {\n    padding: 77rem !important;\n  }\n\n  .p-xxl-156 {\n    padding: 77.5rem !important;\n  }\n\n  .p-xxl-157 {\n    padding: 78rem !important;\n  }\n\n  .p-xxl-158 {\n    padding: 78.5rem !important;\n  }\n\n  .p-xxl-159 {\n    padding: 79rem !important;\n  }\n\n  .p-xxl-160 {\n    padding: 79.5rem !important;\n  }\n\n  .pt-xxl-0 {\n    padding-top: 0rem !important;\n  }\n\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xxl-5 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xxl-6 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xxl-7 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xxl-8 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xxl-9 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xxl-10 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xxl-11 {\n    padding-top: 5rem !important;\n  }\n\n  .pt-xxl-12 {\n    padding-top: 5.5rem !important;\n  }\n\n  .pt-xxl-13 {\n    padding-top: 6rem !important;\n  }\n\n  .pt-xxl-14 {\n    padding-top: 6.5rem !important;\n  }\n\n  .pt-xxl-15 {\n    padding-top: 7rem !important;\n  }\n\n  .pt-xxl-16 {\n    padding-top: 7.5rem !important;\n  }\n\n  .pt-xxl-17 {\n    padding-top: 8rem !important;\n  }\n\n  .pt-xxl-18 {\n    padding-top: 8.5rem !important;\n  }\n\n  .pt-xxl-19 {\n    padding-top: 9rem !important;\n  }\n\n  .pt-xxl-20 {\n    padding-top: 9.5rem !important;\n  }\n\n  .pt-xxl-21 {\n    padding-top: 10rem !important;\n  }\n\n  .pt-xxl-22 {\n    padding-top: 10.5rem !important;\n  }\n\n  .pt-xxl-23 {\n    padding-top: 11rem !important;\n  }\n\n  .pt-xxl-24 {\n    padding-top: 11.5rem !important;\n  }\n\n  .pt-xxl-25 {\n    padding-top: 12rem !important;\n  }\n\n  .pt-xxl-26 {\n    padding-top: 12.5rem !important;\n  }\n\n  .pt-xxl-27 {\n    padding-top: 13rem !important;\n  }\n\n  .pt-xxl-28 {\n    padding-top: 13.5rem !important;\n  }\n\n  .pt-xxl-29 {\n    padding-top: 14rem !important;\n  }\n\n  .pt-xxl-30 {\n    padding-top: 14.5rem !important;\n  }\n\n  .pt-xxl-31 {\n    padding-top: 15rem !important;\n  }\n\n  .pt-xxl-32 {\n    padding-top: 15.5rem !important;\n  }\n\n  .pt-xxl-33 {\n    padding-top: 16rem !important;\n  }\n\n  .pt-xxl-34 {\n    padding-top: 16.5rem !important;\n  }\n\n  .pt-xxl-35 {\n    padding-top: 17rem !important;\n  }\n\n  .pt-xxl-36 {\n    padding-top: 17.5rem !important;\n  }\n\n  .pt-xxl-37 {\n    padding-top: 18rem !important;\n  }\n\n  .pt-xxl-38 {\n    padding-top: 18.5rem !important;\n  }\n\n  .pt-xxl-39 {\n    padding-top: 19rem !important;\n  }\n\n  .pt-xxl-40 {\n    padding-top: 19.5rem !important;\n  }\n\n  .pt-xxl-41 {\n    padding-top: 20rem !important;\n  }\n\n  .pt-xxl-42 {\n    padding-top: 20.5rem !important;\n  }\n\n  .pt-xxl-43 {\n    padding-top: 21rem !important;\n  }\n\n  .pt-xxl-44 {\n    padding-top: 21.5rem !important;\n  }\n\n  .pt-xxl-45 {\n    padding-top: 22rem !important;\n  }\n\n  .pt-xxl-46 {\n    padding-top: 22.5rem !important;\n  }\n\n  .pt-xxl-47 {\n    padding-top: 23rem !important;\n  }\n\n  .pt-xxl-48 {\n    padding-top: 23.5rem !important;\n  }\n\n  .pt-xxl-49 {\n    padding-top: 24rem !important;\n  }\n\n  .pt-xxl-50 {\n    padding-top: 24.5rem !important;\n  }\n\n  .pt-xxl-51 {\n    padding-top: 25rem !important;\n  }\n\n  .pt-xxl-52 {\n    padding-top: 25.5rem !important;\n  }\n\n  .pt-xxl-53 {\n    padding-top: 26rem !important;\n  }\n\n  .pt-xxl-54 {\n    padding-top: 26.5rem !important;\n  }\n\n  .pt-xxl-55 {\n    padding-top: 27rem !important;\n  }\n\n  .pt-xxl-56 {\n    padding-top: 27.5rem !important;\n  }\n\n  .pt-xxl-57 {\n    padding-top: 28rem !important;\n  }\n\n  .pt-xxl-58 {\n    padding-top: 28.5rem !important;\n  }\n\n  .pt-xxl-59 {\n    padding-top: 29rem !important;\n  }\n\n  .pt-xxl-60 {\n    padding-top: 29.5rem !important;\n  }\n\n  .pt-xxl-61 {\n    padding-top: 30rem !important;\n  }\n\n  .pt-xxl-62 {\n    padding-top: 30.5rem !important;\n  }\n\n  .pt-xxl-63 {\n    padding-top: 31rem !important;\n  }\n\n  .pt-xxl-64 {\n    padding-top: 31.5rem !important;\n  }\n\n  .pt-xxl-65 {\n    padding-top: 32rem !important;\n  }\n\n  .pt-xxl-66 {\n    padding-top: 32.5rem !important;\n  }\n\n  .pt-xxl-67 {\n    padding-top: 33rem !important;\n  }\n\n  .pt-xxl-68 {\n    padding-top: 33.5rem !important;\n  }\n\n  .pt-xxl-69 {\n    padding-top: 34rem !important;\n  }\n\n  .pt-xxl-70 {\n    padding-top: 34.5rem !important;\n  }\n\n  .pt-xxl-71 {\n    padding-top: 35rem !important;\n  }\n\n  .pt-xxl-72 {\n    padding-top: 35.5rem !important;\n  }\n\n  .pt-xxl-73 {\n    padding-top: 36rem !important;\n  }\n\n  .pt-xxl-74 {\n    padding-top: 36.5rem !important;\n  }\n\n  .pt-xxl-75 {\n    padding-top: 37rem !important;\n  }\n\n  .pt-xxl-76 {\n    padding-top: 37.5rem !important;\n  }\n\n  .pt-xxl-77 {\n    padding-top: 38rem !important;\n  }\n\n  .pt-xxl-78 {\n    padding-top: 38.5rem !important;\n  }\n\n  .pt-xxl-79 {\n    padding-top: 39rem !important;\n  }\n\n  .pt-xxl-80 {\n    padding-top: 39.5rem !important;\n  }\n\n  .pt-xxl-81 {\n    padding-top: 40rem !important;\n  }\n\n  .pt-xxl-82 {\n    padding-top: 40.5rem !important;\n  }\n\n  .pt-xxl-83 {\n    padding-top: 41rem !important;\n  }\n\n  .pt-xxl-84 {\n    padding-top: 41.5rem !important;\n  }\n\n  .pt-xxl-85 {\n    padding-top: 42rem !important;\n  }\n\n  .pt-xxl-86 {\n    padding-top: 42.5rem !important;\n  }\n\n  .pt-xxl-87 {\n    padding-top: 43rem !important;\n  }\n\n  .pt-xxl-88 {\n    padding-top: 43.5rem !important;\n  }\n\n  .pt-xxl-89 {\n    padding-top: 44rem !important;\n  }\n\n  .pt-xxl-90 {\n    padding-top: 44.5rem !important;\n  }\n\n  .pt-xxl-91 {\n    padding-top: 45rem !important;\n  }\n\n  .pt-xxl-92 {\n    padding-top: 45.5rem !important;\n  }\n\n  .pt-xxl-93 {\n    padding-top: 46rem !important;\n  }\n\n  .pt-xxl-94 {\n    padding-top: 46.5rem !important;\n  }\n\n  .pt-xxl-95 {\n    padding-top: 47rem !important;\n  }\n\n  .pt-xxl-96 {\n    padding-top: 47.5rem !important;\n  }\n\n  .pt-xxl-97 {\n    padding-top: 48rem !important;\n  }\n\n  .pt-xxl-98 {\n    padding-top: 48.5rem !important;\n  }\n\n  .pt-xxl-99 {\n    padding-top: 49rem !important;\n  }\n\n  .pt-xxl-100 {\n    padding-top: 49.5rem !important;\n  }\n\n  .pt-xxl-101 {\n    padding-top: 50rem !important;\n  }\n\n  .pt-xxl-102 {\n    padding-top: 50.5rem !important;\n  }\n\n  .pt-xxl-103 {\n    padding-top: 51rem !important;\n  }\n\n  .pt-xxl-104 {\n    padding-top: 51.5rem !important;\n  }\n\n  .pt-xxl-105 {\n    padding-top: 52rem !important;\n  }\n\n  .pt-xxl-106 {\n    padding-top: 52.5rem !important;\n  }\n\n  .pt-xxl-107 {\n    padding-top: 53rem !important;\n  }\n\n  .pt-xxl-108 {\n    padding-top: 53.5rem !important;\n  }\n\n  .pt-xxl-109 {\n    padding-top: 54rem !important;\n  }\n\n  .pt-xxl-110 {\n    padding-top: 54.5rem !important;\n  }\n\n  .pt-xxl-111 {\n    padding-top: 55rem !important;\n  }\n\n  .pt-xxl-112 {\n    padding-top: 55.5rem !important;\n  }\n\n  .pt-xxl-113 {\n    padding-top: 56rem !important;\n  }\n\n  .pt-xxl-114 {\n    padding-top: 56.5rem !important;\n  }\n\n  .pt-xxl-115 {\n    padding-top: 57rem !important;\n  }\n\n  .pt-xxl-116 {\n    padding-top: 57.5rem !important;\n  }\n\n  .pt-xxl-117 {\n    padding-top: 58rem !important;\n  }\n\n  .pt-xxl-118 {\n    padding-top: 58.5rem !important;\n  }\n\n  .pt-xxl-119 {\n    padding-top: 59rem !important;\n  }\n\n  .pt-xxl-120 {\n    padding-top: 59.5rem !important;\n  }\n\n  .pt-xxl-121 {\n    padding-top: 60rem !important;\n  }\n\n  .pt-xxl-122 {\n    padding-top: 60.5rem !important;\n  }\n\n  .pt-xxl-123 {\n    padding-top: 61rem !important;\n  }\n\n  .pt-xxl-124 {\n    padding-top: 61.5rem !important;\n  }\n\n  .pt-xxl-125 {\n    padding-top: 62rem !important;\n  }\n\n  .pt-xxl-126 {\n    padding-top: 62.5rem !important;\n  }\n\n  .pt-xxl-127 {\n    padding-top: 63rem !important;\n  }\n\n  .pt-xxl-128 {\n    padding-top: 63.5rem !important;\n  }\n\n  .pt-xxl-129 {\n    padding-top: 64rem !important;\n  }\n\n  .pt-xxl-130 {\n    padding-top: 64.5rem !important;\n  }\n\n  .pt-xxl-131 {\n    padding-top: 65rem !important;\n  }\n\n  .pt-xxl-132 {\n    padding-top: 65.5rem !important;\n  }\n\n  .pt-xxl-133 {\n    padding-top: 66rem !important;\n  }\n\n  .pt-xxl-134 {\n    padding-top: 66.5rem !important;\n  }\n\n  .pt-xxl-135 {\n    padding-top: 67rem !important;\n  }\n\n  .pt-xxl-136 {\n    padding-top: 67.5rem !important;\n  }\n\n  .pt-xxl-137 {\n    padding-top: 68rem !important;\n  }\n\n  .pt-xxl-138 {\n    padding-top: 68.5rem !important;\n  }\n\n  .pt-xxl-139 {\n    padding-top: 69rem !important;\n  }\n\n  .pt-xxl-140 {\n    padding-top: 69.5rem !important;\n  }\n\n  .pt-xxl-141 {\n    padding-top: 70rem !important;\n  }\n\n  .pt-xxl-142 {\n    padding-top: 70.5rem !important;\n  }\n\n  .pt-xxl-143 {\n    padding-top: 71rem !important;\n  }\n\n  .pt-xxl-144 {\n    padding-top: 71.5rem !important;\n  }\n\n  .pt-xxl-145 {\n    padding-top: 72rem !important;\n  }\n\n  .pt-xxl-146 {\n    padding-top: 72.5rem !important;\n  }\n\n  .pt-xxl-147 {\n    padding-top: 73rem !important;\n  }\n\n  .pt-xxl-148 {\n    padding-top: 73.5rem !important;\n  }\n\n  .pt-xxl-149 {\n    padding-top: 74rem !important;\n  }\n\n  .pt-xxl-150 {\n    padding-top: 74.5rem !important;\n  }\n\n  .pt-xxl-151 {\n    padding-top: 75rem !important;\n  }\n\n  .pt-xxl-152 {\n    padding-top: 75.5rem !important;\n  }\n\n  .pt-xxl-153 {\n    padding-top: 76rem !important;\n  }\n\n  .pt-xxl-154 {\n    padding-top: 76.5rem !important;\n  }\n\n  .pt-xxl-155 {\n    padding-top: 77rem !important;\n  }\n\n  .pt-xxl-156 {\n    padding-top: 77.5rem !important;\n  }\n\n  .pt-xxl-157 {\n    padding-top: 78rem !important;\n  }\n\n  .pt-xxl-158 {\n    padding-top: 78.5rem !important;\n  }\n\n  .pt-xxl-159 {\n    padding-top: 79rem !important;\n  }\n\n  .pt-xxl-160 {\n    padding-top: 79.5rem !important;\n  }\n\n  .pb-xxl-0 {\n    padding-bottom: 0rem !important;\n  }\n\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xxl-5 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xxl-6 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xxl-7 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xxl-8 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xxl-9 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xxl-10 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xxl-11 {\n    padding-bottom: 5rem !important;\n  }\n\n  .pb-xxl-12 {\n    padding-bottom: 5.5rem !important;\n  }\n\n  .pb-xxl-13 {\n    padding-bottom: 6rem !important;\n  }\n\n  .pb-xxl-14 {\n    padding-bottom: 6.5rem !important;\n  }\n\n  .pb-xxl-15 {\n    padding-bottom: 7rem !important;\n  }\n\n  .pb-xxl-16 {\n    padding-bottom: 7.5rem !important;\n  }\n\n  .pb-xxl-17 {\n    padding-bottom: 8rem !important;\n  }\n\n  .pb-xxl-18 {\n    padding-bottom: 8.5rem !important;\n  }\n\n  .pb-xxl-19 {\n    padding-bottom: 9rem !important;\n  }\n\n  .pb-xxl-20 {\n    padding-bottom: 9.5rem !important;\n  }\n\n  .pb-xxl-21 {\n    padding-bottom: 10rem !important;\n  }\n\n  .pb-xxl-22 {\n    padding-bottom: 10.5rem !important;\n  }\n\n  .pb-xxl-23 {\n    padding-bottom: 11rem !important;\n  }\n\n  .pb-xxl-24 {\n    padding-bottom: 11.5rem !important;\n  }\n\n  .pb-xxl-25 {\n    padding-bottom: 12rem !important;\n  }\n\n  .pb-xxl-26 {\n    padding-bottom: 12.5rem !important;\n  }\n\n  .pb-xxl-27 {\n    padding-bottom: 13rem !important;\n  }\n\n  .pb-xxl-28 {\n    padding-bottom: 13.5rem !important;\n  }\n\n  .pb-xxl-29 {\n    padding-bottom: 14rem !important;\n  }\n\n  .pb-xxl-30 {\n    padding-bottom: 14.5rem !important;\n  }\n\n  .pb-xxl-31 {\n    padding-bottom: 15rem !important;\n  }\n\n  .pb-xxl-32 {\n    padding-bottom: 15.5rem !important;\n  }\n\n  .pb-xxl-33 {\n    padding-bottom: 16rem !important;\n  }\n\n  .pb-xxl-34 {\n    padding-bottom: 16.5rem !important;\n  }\n\n  .pb-xxl-35 {\n    padding-bottom: 17rem !important;\n  }\n\n  .pb-xxl-36 {\n    padding-bottom: 17.5rem !important;\n  }\n\n  .pb-xxl-37 {\n    padding-bottom: 18rem !important;\n  }\n\n  .pb-xxl-38 {\n    padding-bottom: 18.5rem !important;\n  }\n\n  .pb-xxl-39 {\n    padding-bottom: 19rem !important;\n  }\n\n  .pb-xxl-40 {\n    padding-bottom: 19.5rem !important;\n  }\n\n  .pb-xxl-41 {\n    padding-bottom: 20rem !important;\n  }\n\n  .pb-xxl-42 {\n    padding-bottom: 20.5rem !important;\n  }\n\n  .pb-xxl-43 {\n    padding-bottom: 21rem !important;\n  }\n\n  .pb-xxl-44 {\n    padding-bottom: 21.5rem !important;\n  }\n\n  .pb-xxl-45 {\n    padding-bottom: 22rem !important;\n  }\n\n  .pb-xxl-46 {\n    padding-bottom: 22.5rem !important;\n  }\n\n  .pb-xxl-47 {\n    padding-bottom: 23rem !important;\n  }\n\n  .pb-xxl-48 {\n    padding-bottom: 23.5rem !important;\n  }\n\n  .pb-xxl-49 {\n    padding-bottom: 24rem !important;\n  }\n\n  .pb-xxl-50 {\n    padding-bottom: 24.5rem !important;\n  }\n\n  .pb-xxl-51 {\n    padding-bottom: 25rem !important;\n  }\n\n  .pb-xxl-52 {\n    padding-bottom: 25.5rem !important;\n  }\n\n  .pb-xxl-53 {\n    padding-bottom: 26rem !important;\n  }\n\n  .pb-xxl-54 {\n    padding-bottom: 26.5rem !important;\n  }\n\n  .pb-xxl-55 {\n    padding-bottom: 27rem !important;\n  }\n\n  .pb-xxl-56 {\n    padding-bottom: 27.5rem !important;\n  }\n\n  .pb-xxl-57 {\n    padding-bottom: 28rem !important;\n  }\n\n  .pb-xxl-58 {\n    padding-bottom: 28.5rem !important;\n  }\n\n  .pb-xxl-59 {\n    padding-bottom: 29rem !important;\n  }\n\n  .pb-xxl-60 {\n    padding-bottom: 29.5rem !important;\n  }\n\n  .pb-xxl-61 {\n    padding-bottom: 30rem !important;\n  }\n\n  .pb-xxl-62 {\n    padding-bottom: 30.5rem !important;\n  }\n\n  .pb-xxl-63 {\n    padding-bottom: 31rem !important;\n  }\n\n  .pb-xxl-64 {\n    padding-bottom: 31.5rem !important;\n  }\n\n  .pb-xxl-65 {\n    padding-bottom: 32rem !important;\n  }\n\n  .pb-xxl-66 {\n    padding-bottom: 32.5rem !important;\n  }\n\n  .pb-xxl-67 {\n    padding-bottom: 33rem !important;\n  }\n\n  .pb-xxl-68 {\n    padding-bottom: 33.5rem !important;\n  }\n\n  .pb-xxl-69 {\n    padding-bottom: 34rem !important;\n  }\n\n  .pb-xxl-70 {\n    padding-bottom: 34.5rem !important;\n  }\n\n  .pb-xxl-71 {\n    padding-bottom: 35rem !important;\n  }\n\n  .pb-xxl-72 {\n    padding-bottom: 35.5rem !important;\n  }\n\n  .pb-xxl-73 {\n    padding-bottom: 36rem !important;\n  }\n\n  .pb-xxl-74 {\n    padding-bottom: 36.5rem !important;\n  }\n\n  .pb-xxl-75 {\n    padding-bottom: 37rem !important;\n  }\n\n  .pb-xxl-76 {\n    padding-bottom: 37.5rem !important;\n  }\n\n  .pb-xxl-77 {\n    padding-bottom: 38rem !important;\n  }\n\n  .pb-xxl-78 {\n    padding-bottom: 38.5rem !important;\n  }\n\n  .pb-xxl-79 {\n    padding-bottom: 39rem !important;\n  }\n\n  .pb-xxl-80 {\n    padding-bottom: 39.5rem !important;\n  }\n\n  .pb-xxl-81 {\n    padding-bottom: 40rem !important;\n  }\n\n  .pb-xxl-82 {\n    padding-bottom: 40.5rem !important;\n  }\n\n  .pb-xxl-83 {\n    padding-bottom: 41rem !important;\n  }\n\n  .pb-xxl-84 {\n    padding-bottom: 41.5rem !important;\n  }\n\n  .pb-xxl-85 {\n    padding-bottom: 42rem !important;\n  }\n\n  .pb-xxl-86 {\n    padding-bottom: 42.5rem !important;\n  }\n\n  .pb-xxl-87 {\n    padding-bottom: 43rem !important;\n  }\n\n  .pb-xxl-88 {\n    padding-bottom: 43.5rem !important;\n  }\n\n  .pb-xxl-89 {\n    padding-bottom: 44rem !important;\n  }\n\n  .pb-xxl-90 {\n    padding-bottom: 44.5rem !important;\n  }\n\n  .pb-xxl-91 {\n    padding-bottom: 45rem !important;\n  }\n\n  .pb-xxl-92 {\n    padding-bottom: 45.5rem !important;\n  }\n\n  .pb-xxl-93 {\n    padding-bottom: 46rem !important;\n  }\n\n  .pb-xxl-94 {\n    padding-bottom: 46.5rem !important;\n  }\n\n  .pb-xxl-95 {\n    padding-bottom: 47rem !important;\n  }\n\n  .pb-xxl-96 {\n    padding-bottom: 47.5rem !important;\n  }\n\n  .pb-xxl-97 {\n    padding-bottom: 48rem !important;\n  }\n\n  .pb-xxl-98 {\n    padding-bottom: 48.5rem !important;\n  }\n\n  .pb-xxl-99 {\n    padding-bottom: 49rem !important;\n  }\n\n  .pb-xxl-100 {\n    padding-bottom: 49.5rem !important;\n  }\n\n  .pb-xxl-101 {\n    padding-bottom: 50rem !important;\n  }\n\n  .pb-xxl-102 {\n    padding-bottom: 50.5rem !important;\n  }\n\n  .pb-xxl-103 {\n    padding-bottom: 51rem !important;\n  }\n\n  .pb-xxl-104 {\n    padding-bottom: 51.5rem !important;\n  }\n\n  .pb-xxl-105 {\n    padding-bottom: 52rem !important;\n  }\n\n  .pb-xxl-106 {\n    padding-bottom: 52.5rem !important;\n  }\n\n  .pb-xxl-107 {\n    padding-bottom: 53rem !important;\n  }\n\n  .pb-xxl-108 {\n    padding-bottom: 53.5rem !important;\n  }\n\n  .pb-xxl-109 {\n    padding-bottom: 54rem !important;\n  }\n\n  .pb-xxl-110 {\n    padding-bottom: 54.5rem !important;\n  }\n\n  .pb-xxl-111 {\n    padding-bottom: 55rem !important;\n  }\n\n  .pb-xxl-112 {\n    padding-bottom: 55.5rem !important;\n  }\n\n  .pb-xxl-113 {\n    padding-bottom: 56rem !important;\n  }\n\n  .pb-xxl-114 {\n    padding-bottom: 56.5rem !important;\n  }\n\n  .pb-xxl-115 {\n    padding-bottom: 57rem !important;\n  }\n\n  .pb-xxl-116 {\n    padding-bottom: 57.5rem !important;\n  }\n\n  .pb-xxl-117 {\n    padding-bottom: 58rem !important;\n  }\n\n  .pb-xxl-118 {\n    padding-bottom: 58.5rem !important;\n  }\n\n  .pb-xxl-119 {\n    padding-bottom: 59rem !important;\n  }\n\n  .pb-xxl-120 {\n    padding-bottom: 59.5rem !important;\n  }\n\n  .pb-xxl-121 {\n    padding-bottom: 60rem !important;\n  }\n\n  .pb-xxl-122 {\n    padding-bottom: 60.5rem !important;\n  }\n\n  .pb-xxl-123 {\n    padding-bottom: 61rem !important;\n  }\n\n  .pb-xxl-124 {\n    padding-bottom: 61.5rem !important;\n  }\n\n  .pb-xxl-125 {\n    padding-bottom: 62rem !important;\n  }\n\n  .pb-xxl-126 {\n    padding-bottom: 62.5rem !important;\n  }\n\n  .pb-xxl-127 {\n    padding-bottom: 63rem !important;\n  }\n\n  .pb-xxl-128 {\n    padding-bottom: 63.5rem !important;\n  }\n\n  .pb-xxl-129 {\n    padding-bottom: 64rem !important;\n  }\n\n  .pb-xxl-130 {\n    padding-bottom: 64.5rem !important;\n  }\n\n  .pb-xxl-131 {\n    padding-bottom: 65rem !important;\n  }\n\n  .pb-xxl-132 {\n    padding-bottom: 65.5rem !important;\n  }\n\n  .pb-xxl-133 {\n    padding-bottom: 66rem !important;\n  }\n\n  .pb-xxl-134 {\n    padding-bottom: 66.5rem !important;\n  }\n\n  .pb-xxl-135 {\n    padding-bottom: 67rem !important;\n  }\n\n  .pb-xxl-136 {\n    padding-bottom: 67.5rem !important;\n  }\n\n  .pb-xxl-137 {\n    padding-bottom: 68rem !important;\n  }\n\n  .pb-xxl-138 {\n    padding-bottom: 68.5rem !important;\n  }\n\n  .pb-xxl-139 {\n    padding-bottom: 69rem !important;\n  }\n\n  .pb-xxl-140 {\n    padding-bottom: 69.5rem !important;\n  }\n\n  .pb-xxl-141 {\n    padding-bottom: 70rem !important;\n  }\n\n  .pb-xxl-142 {\n    padding-bottom: 70.5rem !important;\n  }\n\n  .pb-xxl-143 {\n    padding-bottom: 71rem !important;\n  }\n\n  .pb-xxl-144 {\n    padding-bottom: 71.5rem !important;\n  }\n\n  .pb-xxl-145 {\n    padding-bottom: 72rem !important;\n  }\n\n  .pb-xxl-146 {\n    padding-bottom: 72.5rem !important;\n  }\n\n  .pb-xxl-147 {\n    padding-bottom: 73rem !important;\n  }\n\n  .pb-xxl-148 {\n    padding-bottom: 73.5rem !important;\n  }\n\n  .pb-xxl-149 {\n    padding-bottom: 74rem !important;\n  }\n\n  .pb-xxl-150 {\n    padding-bottom: 74.5rem !important;\n  }\n\n  .pb-xxl-151 {\n    padding-bottom: 75rem !important;\n  }\n\n  .pb-xxl-152 {\n    padding-bottom: 75.5rem !important;\n  }\n\n  .pb-xxl-153 {\n    padding-bottom: 76rem !important;\n  }\n\n  .pb-xxl-154 {\n    padding-bottom: 76.5rem !important;\n  }\n\n  .pb-xxl-155 {\n    padding-bottom: 77rem !important;\n  }\n\n  .pb-xxl-156 {\n    padding-bottom: 77.5rem !important;\n  }\n\n  .pb-xxl-157 {\n    padding-bottom: 78rem !important;\n  }\n\n  .pb-xxl-158 {\n    padding-bottom: 78.5rem !important;\n  }\n\n  .pb-xxl-159 {\n    padding-bottom: 79rem !important;\n  }\n\n  .pb-xxl-160 {\n    padding-bottom: 79.5rem !important;\n  }\n\n  .ps-xxl-0 {\n    padding-left: 0rem !important;\n  }\n\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xxl-5 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xxl-6 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xxl-7 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xxl-8 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xxl-9 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xxl-10 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xxl-11 {\n    padding-left: 5rem !important;\n  }\n\n  .ps-xxl-12 {\n    padding-left: 5.5rem !important;\n  }\n\n  .ps-xxl-13 {\n    padding-left: 6rem !important;\n  }\n\n  .ps-xxl-14 {\n    padding-left: 6.5rem !important;\n  }\n\n  .ps-xxl-15 {\n    padding-left: 7rem !important;\n  }\n\n  .ps-xxl-16 {\n    padding-left: 7.5rem !important;\n  }\n\n  .ps-xxl-17 {\n    padding-left: 8rem !important;\n  }\n\n  .ps-xxl-18 {\n    padding-left: 8.5rem !important;\n  }\n\n  .ps-xxl-19 {\n    padding-left: 9rem !important;\n  }\n\n  .ps-xxl-20 {\n    padding-left: 9.5rem !important;\n  }\n\n  .ps-xxl-21 {\n    padding-left: 10rem !important;\n  }\n\n  .ps-xxl-22 {\n    padding-left: 10.5rem !important;\n  }\n\n  .ps-xxl-23 {\n    padding-left: 11rem !important;\n  }\n\n  .ps-xxl-24 {\n    padding-left: 11.5rem !important;\n  }\n\n  .ps-xxl-25 {\n    padding-left: 12rem !important;\n  }\n\n  .ps-xxl-26 {\n    padding-left: 12.5rem !important;\n  }\n\n  .ps-xxl-27 {\n    padding-left: 13rem !important;\n  }\n\n  .ps-xxl-28 {\n    padding-left: 13.5rem !important;\n  }\n\n  .ps-xxl-29 {\n    padding-left: 14rem !important;\n  }\n\n  .ps-xxl-30 {\n    padding-left: 14.5rem !important;\n  }\n\n  .ps-xxl-31 {\n    padding-left: 15rem !important;\n  }\n\n  .ps-xxl-32 {\n    padding-left: 15.5rem !important;\n  }\n\n  .ps-xxl-33 {\n    padding-left: 16rem !important;\n  }\n\n  .ps-xxl-34 {\n    padding-left: 16.5rem !important;\n  }\n\n  .ps-xxl-35 {\n    padding-left: 17rem !important;\n  }\n\n  .ps-xxl-36 {\n    padding-left: 17.5rem !important;\n  }\n\n  .ps-xxl-37 {\n    padding-left: 18rem !important;\n  }\n\n  .ps-xxl-38 {\n    padding-left: 18.5rem !important;\n  }\n\n  .ps-xxl-39 {\n    padding-left: 19rem !important;\n  }\n\n  .ps-xxl-40 {\n    padding-left: 19.5rem !important;\n  }\n\n  .ps-xxl-41 {\n    padding-left: 20rem !important;\n  }\n\n  .ps-xxl-42 {\n    padding-left: 20.5rem !important;\n  }\n\n  .ps-xxl-43 {\n    padding-left: 21rem !important;\n  }\n\n  .ps-xxl-44 {\n    padding-left: 21.5rem !important;\n  }\n\n  .ps-xxl-45 {\n    padding-left: 22rem !important;\n  }\n\n  .ps-xxl-46 {\n    padding-left: 22.5rem !important;\n  }\n\n  .ps-xxl-47 {\n    padding-left: 23rem !important;\n  }\n\n  .ps-xxl-48 {\n    padding-left: 23.5rem !important;\n  }\n\n  .ps-xxl-49 {\n    padding-left: 24rem !important;\n  }\n\n  .ps-xxl-50 {\n    padding-left: 24.5rem !important;\n  }\n\n  .ps-xxl-51 {\n    padding-left: 25rem !important;\n  }\n\n  .ps-xxl-52 {\n    padding-left: 25.5rem !important;\n  }\n\n  .ps-xxl-53 {\n    padding-left: 26rem !important;\n  }\n\n  .ps-xxl-54 {\n    padding-left: 26.5rem !important;\n  }\n\n  .ps-xxl-55 {\n    padding-left: 27rem !important;\n  }\n\n  .ps-xxl-56 {\n    padding-left: 27.5rem !important;\n  }\n\n  .ps-xxl-57 {\n    padding-left: 28rem !important;\n  }\n\n  .ps-xxl-58 {\n    padding-left: 28.5rem !important;\n  }\n\n  .ps-xxl-59 {\n    padding-left: 29rem !important;\n  }\n\n  .ps-xxl-60 {\n    padding-left: 29.5rem !important;\n  }\n\n  .ps-xxl-61 {\n    padding-left: 30rem !important;\n  }\n\n  .ps-xxl-62 {\n    padding-left: 30.5rem !important;\n  }\n\n  .ps-xxl-63 {\n    padding-left: 31rem !important;\n  }\n\n  .ps-xxl-64 {\n    padding-left: 31.5rem !important;\n  }\n\n  .ps-xxl-65 {\n    padding-left: 32rem !important;\n  }\n\n  .ps-xxl-66 {\n    padding-left: 32.5rem !important;\n  }\n\n  .ps-xxl-67 {\n    padding-left: 33rem !important;\n  }\n\n  .ps-xxl-68 {\n    padding-left: 33.5rem !important;\n  }\n\n  .ps-xxl-69 {\n    padding-left: 34rem !important;\n  }\n\n  .ps-xxl-70 {\n    padding-left: 34.5rem !important;\n  }\n\n  .ps-xxl-71 {\n    padding-left: 35rem !important;\n  }\n\n  .ps-xxl-72 {\n    padding-left: 35.5rem !important;\n  }\n\n  .ps-xxl-73 {\n    padding-left: 36rem !important;\n  }\n\n  .ps-xxl-74 {\n    padding-left: 36.5rem !important;\n  }\n\n  .ps-xxl-75 {\n    padding-left: 37rem !important;\n  }\n\n  .ps-xxl-76 {\n    padding-left: 37.5rem !important;\n  }\n\n  .ps-xxl-77 {\n    padding-left: 38rem !important;\n  }\n\n  .ps-xxl-78 {\n    padding-left: 38.5rem !important;\n  }\n\n  .ps-xxl-79 {\n    padding-left: 39rem !important;\n  }\n\n  .ps-xxl-80 {\n    padding-left: 39.5rem !important;\n  }\n\n  .ps-xxl-81 {\n    padding-left: 40rem !important;\n  }\n\n  .ps-xxl-82 {\n    padding-left: 40.5rem !important;\n  }\n\n  .ps-xxl-83 {\n    padding-left: 41rem !important;\n  }\n\n  .ps-xxl-84 {\n    padding-left: 41.5rem !important;\n  }\n\n  .ps-xxl-85 {\n    padding-left: 42rem !important;\n  }\n\n  .ps-xxl-86 {\n    padding-left: 42.5rem !important;\n  }\n\n  .ps-xxl-87 {\n    padding-left: 43rem !important;\n  }\n\n  .ps-xxl-88 {\n    padding-left: 43.5rem !important;\n  }\n\n  .ps-xxl-89 {\n    padding-left: 44rem !important;\n  }\n\n  .ps-xxl-90 {\n    padding-left: 44.5rem !important;\n  }\n\n  .ps-xxl-91 {\n    padding-left: 45rem !important;\n  }\n\n  .ps-xxl-92 {\n    padding-left: 45.5rem !important;\n  }\n\n  .ps-xxl-93 {\n    padding-left: 46rem !important;\n  }\n\n  .ps-xxl-94 {\n    padding-left: 46.5rem !important;\n  }\n\n  .ps-xxl-95 {\n    padding-left: 47rem !important;\n  }\n\n  .ps-xxl-96 {\n    padding-left: 47.5rem !important;\n  }\n\n  .ps-xxl-97 {\n    padding-left: 48rem !important;\n  }\n\n  .ps-xxl-98 {\n    padding-left: 48.5rem !important;\n  }\n\n  .ps-xxl-99 {\n    padding-left: 49rem !important;\n  }\n\n  .ps-xxl-100 {\n    padding-left: 49.5rem !important;\n  }\n\n  .ps-xxl-101 {\n    padding-left: 50rem !important;\n  }\n\n  .ps-xxl-102 {\n    padding-left: 50.5rem !important;\n  }\n\n  .ps-xxl-103 {\n    padding-left: 51rem !important;\n  }\n\n  .ps-xxl-104 {\n    padding-left: 51.5rem !important;\n  }\n\n  .ps-xxl-105 {\n    padding-left: 52rem !important;\n  }\n\n  .ps-xxl-106 {\n    padding-left: 52.5rem !important;\n  }\n\n  .ps-xxl-107 {\n    padding-left: 53rem !important;\n  }\n\n  .ps-xxl-108 {\n    padding-left: 53.5rem !important;\n  }\n\n  .ps-xxl-109 {\n    padding-left: 54rem !important;\n  }\n\n  .ps-xxl-110 {\n    padding-left: 54.5rem !important;\n  }\n\n  .ps-xxl-111 {\n    padding-left: 55rem !important;\n  }\n\n  .ps-xxl-112 {\n    padding-left: 55.5rem !important;\n  }\n\n  .ps-xxl-113 {\n    padding-left: 56rem !important;\n  }\n\n  .ps-xxl-114 {\n    padding-left: 56.5rem !important;\n  }\n\n  .ps-xxl-115 {\n    padding-left: 57rem !important;\n  }\n\n  .ps-xxl-116 {\n    padding-left: 57.5rem !important;\n  }\n\n  .ps-xxl-117 {\n    padding-left: 58rem !important;\n  }\n\n  .ps-xxl-118 {\n    padding-left: 58.5rem !important;\n  }\n\n  .ps-xxl-119 {\n    padding-left: 59rem !important;\n  }\n\n  .ps-xxl-120 {\n    padding-left: 59.5rem !important;\n  }\n\n  .ps-xxl-121 {\n    padding-left: 60rem !important;\n  }\n\n  .ps-xxl-122 {\n    padding-left: 60.5rem !important;\n  }\n\n  .ps-xxl-123 {\n    padding-left: 61rem !important;\n  }\n\n  .ps-xxl-124 {\n    padding-left: 61.5rem !important;\n  }\n\n  .ps-xxl-125 {\n    padding-left: 62rem !important;\n  }\n\n  .ps-xxl-126 {\n    padding-left: 62.5rem !important;\n  }\n\n  .ps-xxl-127 {\n    padding-left: 63rem !important;\n  }\n\n  .ps-xxl-128 {\n    padding-left: 63.5rem !important;\n  }\n\n  .ps-xxl-129 {\n    padding-left: 64rem !important;\n  }\n\n  .ps-xxl-130 {\n    padding-left: 64.5rem !important;\n  }\n\n  .ps-xxl-131 {\n    padding-left: 65rem !important;\n  }\n\n  .ps-xxl-132 {\n    padding-left: 65.5rem !important;\n  }\n\n  .ps-xxl-133 {\n    padding-left: 66rem !important;\n  }\n\n  .ps-xxl-134 {\n    padding-left: 66.5rem !important;\n  }\n\n  .ps-xxl-135 {\n    padding-left: 67rem !important;\n  }\n\n  .ps-xxl-136 {\n    padding-left: 67.5rem !important;\n  }\n\n  .ps-xxl-137 {\n    padding-left: 68rem !important;\n  }\n\n  .ps-xxl-138 {\n    padding-left: 68.5rem !important;\n  }\n\n  .ps-xxl-139 {\n    padding-left: 69rem !important;\n  }\n\n  .ps-xxl-140 {\n    padding-left: 69.5rem !important;\n  }\n\n  .ps-xxl-141 {\n    padding-left: 70rem !important;\n  }\n\n  .ps-xxl-142 {\n    padding-left: 70.5rem !important;\n  }\n\n  .ps-xxl-143 {\n    padding-left: 71rem !important;\n  }\n\n  .ps-xxl-144 {\n    padding-left: 71.5rem !important;\n  }\n\n  .ps-xxl-145 {\n    padding-left: 72rem !important;\n  }\n\n  .ps-xxl-146 {\n    padding-left: 72.5rem !important;\n  }\n\n  .ps-xxl-147 {\n    padding-left: 73rem !important;\n  }\n\n  .ps-xxl-148 {\n    padding-left: 73.5rem !important;\n  }\n\n  .ps-xxl-149 {\n    padding-left: 74rem !important;\n  }\n\n  .ps-xxl-150 {\n    padding-left: 74.5rem !important;\n  }\n\n  .ps-xxl-151 {\n    padding-left: 75rem !important;\n  }\n\n  .ps-xxl-152 {\n    padding-left: 75.5rem !important;\n  }\n\n  .ps-xxl-153 {\n    padding-left: 76rem !important;\n  }\n\n  .ps-xxl-154 {\n    padding-left: 76.5rem !important;\n  }\n\n  .ps-xxl-155 {\n    padding-left: 77rem !important;\n  }\n\n  .ps-xxl-156 {\n    padding-left: 77.5rem !important;\n  }\n\n  .ps-xxl-157 {\n    padding-left: 78rem !important;\n  }\n\n  .ps-xxl-158 {\n    padding-left: 78.5rem !important;\n  }\n\n  .ps-xxl-159 {\n    padding-left: 79rem !important;\n  }\n\n  .ps-xxl-160 {\n    padding-left: 79.5rem !important;\n  }\n\n  .pe-xxl-0 {\n    padding-right: 0rem !important;\n  }\n\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xxl-5 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xxl-6 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xxl-7 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xxl-8 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xxl-9 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xxl-10 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xxl-11 {\n    padding-right: 5rem !important;\n  }\n\n  .pe-xxl-12 {\n    padding-right: 5.5rem !important;\n  }\n\n  .pe-xxl-13 {\n    padding-right: 6rem !important;\n  }\n\n  .pe-xxl-14 {\n    padding-right: 6.5rem !important;\n  }\n\n  .pe-xxl-15 {\n    padding-right: 7rem !important;\n  }\n\n  .pe-xxl-16 {\n    padding-right: 7.5rem !important;\n  }\n\n  .pe-xxl-17 {\n    padding-right: 8rem !important;\n  }\n\n  .pe-xxl-18 {\n    padding-right: 8.5rem !important;\n  }\n\n  .pe-xxl-19 {\n    padding-right: 9rem !important;\n  }\n\n  .pe-xxl-20 {\n    padding-right: 9.5rem !important;\n  }\n\n  .pe-xxl-21 {\n    padding-right: 10rem !important;\n  }\n\n  .pe-xxl-22 {\n    padding-right: 10.5rem !important;\n  }\n\n  .pe-xxl-23 {\n    padding-right: 11rem !important;\n  }\n\n  .pe-xxl-24 {\n    padding-right: 11.5rem !important;\n  }\n\n  .pe-xxl-25 {\n    padding-right: 12rem !important;\n  }\n\n  .pe-xxl-26 {\n    padding-right: 12.5rem !important;\n  }\n\n  .pe-xxl-27 {\n    padding-right: 13rem !important;\n  }\n\n  .pe-xxl-28 {\n    padding-right: 13.5rem !important;\n  }\n\n  .pe-xxl-29 {\n    padding-right: 14rem !important;\n  }\n\n  .pe-xxl-30 {\n    padding-right: 14.5rem !important;\n  }\n\n  .pe-xxl-31 {\n    padding-right: 15rem !important;\n  }\n\n  .pe-xxl-32 {\n    padding-right: 15.5rem !important;\n  }\n\n  .pe-xxl-33 {\n    padding-right: 16rem !important;\n  }\n\n  .pe-xxl-34 {\n    padding-right: 16.5rem !important;\n  }\n\n  .pe-xxl-35 {\n    padding-right: 17rem !important;\n  }\n\n  .pe-xxl-36 {\n    padding-right: 17.5rem !important;\n  }\n\n  .pe-xxl-37 {\n    padding-right: 18rem !important;\n  }\n\n  .pe-xxl-38 {\n    padding-right: 18.5rem !important;\n  }\n\n  .pe-xxl-39 {\n    padding-right: 19rem !important;\n  }\n\n  .pe-xxl-40 {\n    padding-right: 19.5rem !important;\n  }\n\n  .pe-xxl-41 {\n    padding-right: 20rem !important;\n  }\n\n  .pe-xxl-42 {\n    padding-right: 20.5rem !important;\n  }\n\n  .pe-xxl-43 {\n    padding-right: 21rem !important;\n  }\n\n  .pe-xxl-44 {\n    padding-right: 21.5rem !important;\n  }\n\n  .pe-xxl-45 {\n    padding-right: 22rem !important;\n  }\n\n  .pe-xxl-46 {\n    padding-right: 22.5rem !important;\n  }\n\n  .pe-xxl-47 {\n    padding-right: 23rem !important;\n  }\n\n  .pe-xxl-48 {\n    padding-right: 23.5rem !important;\n  }\n\n  .pe-xxl-49 {\n    padding-right: 24rem !important;\n  }\n\n  .pe-xxl-50 {\n    padding-right: 24.5rem !important;\n  }\n\n  .pe-xxl-51 {\n    padding-right: 25rem !important;\n  }\n\n  .pe-xxl-52 {\n    padding-right: 25.5rem !important;\n  }\n\n  .pe-xxl-53 {\n    padding-right: 26rem !important;\n  }\n\n  .pe-xxl-54 {\n    padding-right: 26.5rem !important;\n  }\n\n  .pe-xxl-55 {\n    padding-right: 27rem !important;\n  }\n\n  .pe-xxl-56 {\n    padding-right: 27.5rem !important;\n  }\n\n  .pe-xxl-57 {\n    padding-right: 28rem !important;\n  }\n\n  .pe-xxl-58 {\n    padding-right: 28.5rem !important;\n  }\n\n  .pe-xxl-59 {\n    padding-right: 29rem !important;\n  }\n\n  .pe-xxl-60 {\n    padding-right: 29.5rem !important;\n  }\n\n  .pe-xxl-61 {\n    padding-right: 30rem !important;\n  }\n\n  .pe-xxl-62 {\n    padding-right: 30.5rem !important;\n  }\n\n  .pe-xxl-63 {\n    padding-right: 31rem !important;\n  }\n\n  .pe-xxl-64 {\n    padding-right: 31.5rem !important;\n  }\n\n  .pe-xxl-65 {\n    padding-right: 32rem !important;\n  }\n\n  .pe-xxl-66 {\n    padding-right: 32.5rem !important;\n  }\n\n  .pe-xxl-67 {\n    padding-right: 33rem !important;\n  }\n\n  .pe-xxl-68 {\n    padding-right: 33.5rem !important;\n  }\n\n  .pe-xxl-69 {\n    padding-right: 34rem !important;\n  }\n\n  .pe-xxl-70 {\n    padding-right: 34.5rem !important;\n  }\n\n  .pe-xxl-71 {\n    padding-right: 35rem !important;\n  }\n\n  .pe-xxl-72 {\n    padding-right: 35.5rem !important;\n  }\n\n  .pe-xxl-73 {\n    padding-right: 36rem !important;\n  }\n\n  .pe-xxl-74 {\n    padding-right: 36.5rem !important;\n  }\n\n  .pe-xxl-75 {\n    padding-right: 37rem !important;\n  }\n\n  .pe-xxl-76 {\n    padding-right: 37.5rem !important;\n  }\n\n  .pe-xxl-77 {\n    padding-right: 38rem !important;\n  }\n\n  .pe-xxl-78 {\n    padding-right: 38.5rem !important;\n  }\n\n  .pe-xxl-79 {\n    padding-right: 39rem !important;\n  }\n\n  .pe-xxl-80 {\n    padding-right: 39.5rem !important;\n  }\n\n  .pe-xxl-81 {\n    padding-right: 40rem !important;\n  }\n\n  .pe-xxl-82 {\n    padding-right: 40.5rem !important;\n  }\n\n  .pe-xxl-83 {\n    padding-right: 41rem !important;\n  }\n\n  .pe-xxl-84 {\n    padding-right: 41.5rem !important;\n  }\n\n  .pe-xxl-85 {\n    padding-right: 42rem !important;\n  }\n\n  .pe-xxl-86 {\n    padding-right: 42.5rem !important;\n  }\n\n  .pe-xxl-87 {\n    padding-right: 43rem !important;\n  }\n\n  .pe-xxl-88 {\n    padding-right: 43.5rem !important;\n  }\n\n  .pe-xxl-89 {\n    padding-right: 44rem !important;\n  }\n\n  .pe-xxl-90 {\n    padding-right: 44.5rem !important;\n  }\n\n  .pe-xxl-91 {\n    padding-right: 45rem !important;\n  }\n\n  .pe-xxl-92 {\n    padding-right: 45.5rem !important;\n  }\n\n  .pe-xxl-93 {\n    padding-right: 46rem !important;\n  }\n\n  .pe-xxl-94 {\n    padding-right: 46.5rem !important;\n  }\n\n  .pe-xxl-95 {\n    padding-right: 47rem !important;\n  }\n\n  .pe-xxl-96 {\n    padding-right: 47.5rem !important;\n  }\n\n  .pe-xxl-97 {\n    padding-right: 48rem !important;\n  }\n\n  .pe-xxl-98 {\n    padding-right: 48.5rem !important;\n  }\n\n  .pe-xxl-99 {\n    padding-right: 49rem !important;\n  }\n\n  .pe-xxl-100 {\n    padding-right: 49.5rem !important;\n  }\n\n  .pe-xxl-101 {\n    padding-right: 50rem !important;\n  }\n\n  .pe-xxl-102 {\n    padding-right: 50.5rem !important;\n  }\n\n  .pe-xxl-103 {\n    padding-right: 51rem !important;\n  }\n\n  .pe-xxl-104 {\n    padding-right: 51.5rem !important;\n  }\n\n  .pe-xxl-105 {\n    padding-right: 52rem !important;\n  }\n\n  .pe-xxl-106 {\n    padding-right: 52.5rem !important;\n  }\n\n  .pe-xxl-107 {\n    padding-right: 53rem !important;\n  }\n\n  .pe-xxl-108 {\n    padding-right: 53.5rem !important;\n  }\n\n  .pe-xxl-109 {\n    padding-right: 54rem !important;\n  }\n\n  .pe-xxl-110 {\n    padding-right: 54.5rem !important;\n  }\n\n  .pe-xxl-111 {\n    padding-right: 55rem !important;\n  }\n\n  .pe-xxl-112 {\n    padding-right: 55.5rem !important;\n  }\n\n  .pe-xxl-113 {\n    padding-right: 56rem !important;\n  }\n\n  .pe-xxl-114 {\n    padding-right: 56.5rem !important;\n  }\n\n  .pe-xxl-115 {\n    padding-right: 57rem !important;\n  }\n\n  .pe-xxl-116 {\n    padding-right: 57.5rem !important;\n  }\n\n  .pe-xxl-117 {\n    padding-right: 58rem !important;\n  }\n\n  .pe-xxl-118 {\n    padding-right: 58.5rem !important;\n  }\n\n  .pe-xxl-119 {\n    padding-right: 59rem !important;\n  }\n\n  .pe-xxl-120 {\n    padding-right: 59.5rem !important;\n  }\n\n  .pe-xxl-121 {\n    padding-right: 60rem !important;\n  }\n\n  .pe-xxl-122 {\n    padding-right: 60.5rem !important;\n  }\n\n  .pe-xxl-123 {\n    padding-right: 61rem !important;\n  }\n\n  .pe-xxl-124 {\n    padding-right: 61.5rem !important;\n  }\n\n  .pe-xxl-125 {\n    padding-right: 62rem !important;\n  }\n\n  .pe-xxl-126 {\n    padding-right: 62.5rem !important;\n  }\n\n  .pe-xxl-127 {\n    padding-right: 63rem !important;\n  }\n\n  .pe-xxl-128 {\n    padding-right: 63.5rem !important;\n  }\n\n  .pe-xxl-129 {\n    padding-right: 64rem !important;\n  }\n\n  .pe-xxl-130 {\n    padding-right: 64.5rem !important;\n  }\n\n  .pe-xxl-131 {\n    padding-right: 65rem !important;\n  }\n\n  .pe-xxl-132 {\n    padding-right: 65.5rem !important;\n  }\n\n  .pe-xxl-133 {\n    padding-right: 66rem !important;\n  }\n\n  .pe-xxl-134 {\n    padding-right: 66.5rem !important;\n  }\n\n  .pe-xxl-135 {\n    padding-right: 67rem !important;\n  }\n\n  .pe-xxl-136 {\n    padding-right: 67.5rem !important;\n  }\n\n  .pe-xxl-137 {\n    padding-right: 68rem !important;\n  }\n\n  .pe-xxl-138 {\n    padding-right: 68.5rem !important;\n  }\n\n  .pe-xxl-139 {\n    padding-right: 69rem !important;\n  }\n\n  .pe-xxl-140 {\n    padding-right: 69.5rem !important;\n  }\n\n  .pe-xxl-141 {\n    padding-right: 70rem !important;\n  }\n\n  .pe-xxl-142 {\n    padding-right: 70.5rem !important;\n  }\n\n  .pe-xxl-143 {\n    padding-right: 71rem !important;\n  }\n\n  .pe-xxl-144 {\n    padding-right: 71.5rem !important;\n  }\n\n  .pe-xxl-145 {\n    padding-right: 72rem !important;\n  }\n\n  .pe-xxl-146 {\n    padding-right: 72.5rem !important;\n  }\n\n  .pe-xxl-147 {\n    padding-right: 73rem !important;\n  }\n\n  .pe-xxl-148 {\n    padding-right: 73.5rem !important;\n  }\n\n  .pe-xxl-149 {\n    padding-right: 74rem !important;\n  }\n\n  .pe-xxl-150 {\n    padding-right: 74.5rem !important;\n  }\n\n  .pe-xxl-151 {\n    padding-right: 75rem !important;\n  }\n\n  .pe-xxl-152 {\n    padding-right: 75.5rem !important;\n  }\n\n  .pe-xxl-153 {\n    padding-right: 76rem !important;\n  }\n\n  .pe-xxl-154 {\n    padding-right: 76.5rem !important;\n  }\n\n  .pe-xxl-155 {\n    padding-right: 77rem !important;\n  }\n\n  .pe-xxl-156 {\n    padding-right: 77.5rem !important;\n  }\n\n  .pe-xxl-157 {\n    padding-right: 78rem !important;\n  }\n\n  .pe-xxl-158 {\n    padding-right: 78.5rem !important;\n  }\n\n  .pe-xxl-159 {\n    padding-right: 79rem !important;\n  }\n\n  .pe-xxl-160 {\n    padding-right: 79.5rem !important;\n  }\n\n  .px-xxl-0 {\n    padding-left: 0rem !important;\n    padding-right: 0rem !important;\n  }\n\n  .px-xxl-1 {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .px-xxl-2 {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .px-xxl-3 {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .px-xxl-4 {\n    padding-left: 1.5rem !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .px-xxl-5 {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n\n  .px-xxl-6 {\n    padding-left: 2.5rem !important;\n    padding-right: 2.5rem !important;\n  }\n\n  .px-xxl-7 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n  }\n\n  .px-xxl-8 {\n    padding-left: 3.5rem !important;\n    padding-right: 3.5rem !important;\n  }\n\n  .px-xxl-9 {\n    padding-left: 4rem !important;\n    padding-right: 4rem !important;\n  }\n\n  .px-xxl-10 {\n    padding-left: 4.5rem !important;\n    padding-right: 4.5rem !important;\n  }\n\n  .px-xxl-11 {\n    padding-left: 5rem !important;\n    padding-right: 5rem !important;\n  }\n\n  .px-xxl-12 {\n    padding-left: 5.5rem !important;\n    padding-right: 5.5rem !important;\n  }\n\n  .px-xxl-13 {\n    padding-left: 6rem !important;\n    padding-right: 6rem !important;\n  }\n\n  .px-xxl-14 {\n    padding-left: 6.5rem !important;\n    padding-right: 6.5rem !important;\n  }\n\n  .px-xxl-15 {\n    padding-left: 7rem !important;\n    padding-right: 7rem !important;\n  }\n\n  .px-xxl-16 {\n    padding-left: 7.5rem !important;\n    padding-right: 7.5rem !important;\n  }\n\n  .px-xxl-17 {\n    padding-left: 8rem !important;\n    padding-right: 8rem !important;\n  }\n\n  .px-xxl-18 {\n    padding-left: 8.5rem !important;\n    padding-right: 8.5rem !important;\n  }\n\n  .px-xxl-19 {\n    padding-left: 9rem !important;\n    padding-right: 9rem !important;\n  }\n\n  .px-xxl-20 {\n    padding-left: 9.5rem !important;\n    padding-right: 9.5rem !important;\n  }\n\n  .px-xxl-21 {\n    padding-left: 10rem !important;\n    padding-right: 10rem !important;\n  }\n\n  .px-xxl-22 {\n    padding-left: 10.5rem !important;\n    padding-right: 10.5rem !important;\n  }\n\n  .px-xxl-23 {\n    padding-left: 11rem !important;\n    padding-right: 11rem !important;\n  }\n\n  .px-xxl-24 {\n    padding-left: 11.5rem !important;\n    padding-right: 11.5rem !important;\n  }\n\n  .px-xxl-25 {\n    padding-left: 12rem !important;\n    padding-right: 12rem !important;\n  }\n\n  .px-xxl-26 {\n    padding-left: 12.5rem !important;\n    padding-right: 12.5rem !important;\n  }\n\n  .px-xxl-27 {\n    padding-left: 13rem !important;\n    padding-right: 13rem !important;\n  }\n\n  .px-xxl-28 {\n    padding-left: 13.5rem !important;\n    padding-right: 13.5rem !important;\n  }\n\n  .px-xxl-29 {\n    padding-left: 14rem !important;\n    padding-right: 14rem !important;\n  }\n\n  .px-xxl-30 {\n    padding-left: 14.5rem !important;\n    padding-right: 14.5rem !important;\n  }\n\n  .px-xxl-31 {\n    padding-left: 15rem !important;\n    padding-right: 15rem !important;\n  }\n\n  .px-xxl-32 {\n    padding-left: 15.5rem !important;\n    padding-right: 15.5rem !important;\n  }\n\n  .px-xxl-33 {\n    padding-left: 16rem !important;\n    padding-right: 16rem !important;\n  }\n\n  .px-xxl-34 {\n    padding-left: 16.5rem !important;\n    padding-right: 16.5rem !important;\n  }\n\n  .px-xxl-35 {\n    padding-left: 17rem !important;\n    padding-right: 17rem !important;\n  }\n\n  .px-xxl-36 {\n    padding-left: 17.5rem !important;\n    padding-right: 17.5rem !important;\n  }\n\n  .px-xxl-37 {\n    padding-left: 18rem !important;\n    padding-right: 18rem !important;\n  }\n\n  .px-xxl-38 {\n    padding-left: 18.5rem !important;\n    padding-right: 18.5rem !important;\n  }\n\n  .px-xxl-39 {\n    padding-left: 19rem !important;\n    padding-right: 19rem !important;\n  }\n\n  .px-xxl-40 {\n    padding-left: 19.5rem !important;\n    padding-right: 19.5rem !important;\n  }\n\n  .px-xxl-41 {\n    padding-left: 20rem !important;\n    padding-right: 20rem !important;\n  }\n\n  .px-xxl-42 {\n    padding-left: 20.5rem !important;\n    padding-right: 20.5rem !important;\n  }\n\n  .px-xxl-43 {\n    padding-left: 21rem !important;\n    padding-right: 21rem !important;\n  }\n\n  .px-xxl-44 {\n    padding-left: 21.5rem !important;\n    padding-right: 21.5rem !important;\n  }\n\n  .px-xxl-45 {\n    padding-left: 22rem !important;\n    padding-right: 22rem !important;\n  }\n\n  .px-xxl-46 {\n    padding-left: 22.5rem !important;\n    padding-right: 22.5rem !important;\n  }\n\n  .px-xxl-47 {\n    padding-left: 23rem !important;\n    padding-right: 23rem !important;\n  }\n\n  .px-xxl-48 {\n    padding-left: 23.5rem !important;\n    padding-right: 23.5rem !important;\n  }\n\n  .px-xxl-49 {\n    padding-left: 24rem !important;\n    padding-right: 24rem !important;\n  }\n\n  .px-xxl-50 {\n    padding-left: 24.5rem !important;\n    padding-right: 24.5rem !important;\n  }\n\n  .px-xxl-51 {\n    padding-left: 25rem !important;\n    padding-right: 25rem !important;\n  }\n\n  .px-xxl-52 {\n    padding-left: 25.5rem !important;\n    padding-right: 25.5rem !important;\n  }\n\n  .px-xxl-53 {\n    padding-left: 26rem !important;\n    padding-right: 26rem !important;\n  }\n\n  .px-xxl-54 {\n    padding-left: 26.5rem !important;\n    padding-right: 26.5rem !important;\n  }\n\n  .px-xxl-55 {\n    padding-left: 27rem !important;\n    padding-right: 27rem !important;\n  }\n\n  .px-xxl-56 {\n    padding-left: 27.5rem !important;\n    padding-right: 27.5rem !important;\n  }\n\n  .px-xxl-57 {\n    padding-left: 28rem !important;\n    padding-right: 28rem !important;\n  }\n\n  .px-xxl-58 {\n    padding-left: 28.5rem !important;\n    padding-right: 28.5rem !important;\n  }\n\n  .px-xxl-59 {\n    padding-left: 29rem !important;\n    padding-right: 29rem !important;\n  }\n\n  .px-xxl-60 {\n    padding-left: 29.5rem !important;\n    padding-right: 29.5rem !important;\n  }\n\n  .px-xxl-61 {\n    padding-left: 30rem !important;\n    padding-right: 30rem !important;\n  }\n\n  .px-xxl-62 {\n    padding-left: 30.5rem !important;\n    padding-right: 30.5rem !important;\n  }\n\n  .px-xxl-63 {\n    padding-left: 31rem !important;\n    padding-right: 31rem !important;\n  }\n\n  .px-xxl-64 {\n    padding-left: 31.5rem !important;\n    padding-right: 31.5rem !important;\n  }\n\n  .px-xxl-65 {\n    padding-left: 32rem !important;\n    padding-right: 32rem !important;\n  }\n\n  .px-xxl-66 {\n    padding-left: 32.5rem !important;\n    padding-right: 32.5rem !important;\n  }\n\n  .px-xxl-67 {\n    padding-left: 33rem !important;\n    padding-right: 33rem !important;\n  }\n\n  .px-xxl-68 {\n    padding-left: 33.5rem !important;\n    padding-right: 33.5rem !important;\n  }\n\n  .px-xxl-69 {\n    padding-left: 34rem !important;\n    padding-right: 34rem !important;\n  }\n\n  .px-xxl-70 {\n    padding-left: 34.5rem !important;\n    padding-right: 34.5rem !important;\n  }\n\n  .px-xxl-71 {\n    padding-left: 35rem !important;\n    padding-right: 35rem !important;\n  }\n\n  .px-xxl-72 {\n    padding-left: 35.5rem !important;\n    padding-right: 35.5rem !important;\n  }\n\n  .px-xxl-73 {\n    padding-left: 36rem !important;\n    padding-right: 36rem !important;\n  }\n\n  .px-xxl-74 {\n    padding-left: 36.5rem !important;\n    padding-right: 36.5rem !important;\n  }\n\n  .px-xxl-75 {\n    padding-left: 37rem !important;\n    padding-right: 37rem !important;\n  }\n\n  .px-xxl-76 {\n    padding-left: 37.5rem !important;\n    padding-right: 37.5rem !important;\n  }\n\n  .px-xxl-77 {\n    padding-left: 38rem !important;\n    padding-right: 38rem !important;\n  }\n\n  .px-xxl-78 {\n    padding-left: 38.5rem !important;\n    padding-right: 38.5rem !important;\n  }\n\n  .px-xxl-79 {\n    padding-left: 39rem !important;\n    padding-right: 39rem !important;\n  }\n\n  .px-xxl-80 {\n    padding-left: 39.5rem !important;\n    padding-right: 39.5rem !important;\n  }\n\n  .px-xxl-81 {\n    padding-left: 40rem !important;\n    padding-right: 40rem !important;\n  }\n\n  .px-xxl-82 {\n    padding-left: 40.5rem !important;\n    padding-right: 40.5rem !important;\n  }\n\n  .px-xxl-83 {\n    padding-left: 41rem !important;\n    padding-right: 41rem !important;\n  }\n\n  .px-xxl-84 {\n    padding-left: 41.5rem !important;\n    padding-right: 41.5rem !important;\n  }\n\n  .px-xxl-85 {\n    padding-left: 42rem !important;\n    padding-right: 42rem !important;\n  }\n\n  .px-xxl-86 {\n    padding-left: 42.5rem !important;\n    padding-right: 42.5rem !important;\n  }\n\n  .px-xxl-87 {\n    padding-left: 43rem !important;\n    padding-right: 43rem !important;\n  }\n\n  .px-xxl-88 {\n    padding-left: 43.5rem !important;\n    padding-right: 43.5rem !important;\n  }\n\n  .px-xxl-89 {\n    padding-left: 44rem !important;\n    padding-right: 44rem !important;\n  }\n\n  .px-xxl-90 {\n    padding-left: 44.5rem !important;\n    padding-right: 44.5rem !important;\n  }\n\n  .px-xxl-91 {\n    padding-left: 45rem !important;\n    padding-right: 45rem !important;\n  }\n\n  .px-xxl-92 {\n    padding-left: 45.5rem !important;\n    padding-right: 45.5rem !important;\n  }\n\n  .px-xxl-93 {\n    padding-left: 46rem !important;\n    padding-right: 46rem !important;\n  }\n\n  .px-xxl-94 {\n    padding-left: 46.5rem !important;\n    padding-right: 46.5rem !important;\n  }\n\n  .px-xxl-95 {\n    padding-left: 47rem !important;\n    padding-right: 47rem !important;\n  }\n\n  .px-xxl-96 {\n    padding-left: 47.5rem !important;\n    padding-right: 47.5rem !important;\n  }\n\n  .px-xxl-97 {\n    padding-left: 48rem !important;\n    padding-right: 48rem !important;\n  }\n\n  .px-xxl-98 {\n    padding-left: 48.5rem !important;\n    padding-right: 48.5rem !important;\n  }\n\n  .px-xxl-99 {\n    padding-left: 49rem !important;\n    padding-right: 49rem !important;\n  }\n\n  .px-xxl-100 {\n    padding-left: 49.5rem !important;\n    padding-right: 49.5rem !important;\n  }\n\n  .px-xxl-101 {\n    padding-left: 50rem !important;\n    padding-right: 50rem !important;\n  }\n\n  .px-xxl-102 {\n    padding-left: 50.5rem !important;\n    padding-right: 50.5rem !important;\n  }\n\n  .px-xxl-103 {\n    padding-left: 51rem !important;\n    padding-right: 51rem !important;\n  }\n\n  .px-xxl-104 {\n    padding-left: 51.5rem !important;\n    padding-right: 51.5rem !important;\n  }\n\n  .px-xxl-105 {\n    padding-left: 52rem !important;\n    padding-right: 52rem !important;\n  }\n\n  .px-xxl-106 {\n    padding-left: 52.5rem !important;\n    padding-right: 52.5rem !important;\n  }\n\n  .px-xxl-107 {\n    padding-left: 53rem !important;\n    padding-right: 53rem !important;\n  }\n\n  .px-xxl-108 {\n    padding-left: 53.5rem !important;\n    padding-right: 53.5rem !important;\n  }\n\n  .px-xxl-109 {\n    padding-left: 54rem !important;\n    padding-right: 54rem !important;\n  }\n\n  .px-xxl-110 {\n    padding-left: 54.5rem !important;\n    padding-right: 54.5rem !important;\n  }\n\n  .px-xxl-111 {\n    padding-left: 55rem !important;\n    padding-right: 55rem !important;\n  }\n\n  .px-xxl-112 {\n    padding-left: 55.5rem !important;\n    padding-right: 55.5rem !important;\n  }\n\n  .px-xxl-113 {\n    padding-left: 56rem !important;\n    padding-right: 56rem !important;\n  }\n\n  .px-xxl-114 {\n    padding-left: 56.5rem !important;\n    padding-right: 56.5rem !important;\n  }\n\n  .px-xxl-115 {\n    padding-left: 57rem !important;\n    padding-right: 57rem !important;\n  }\n\n  .px-xxl-116 {\n    padding-left: 57.5rem !important;\n    padding-right: 57.5rem !important;\n  }\n\n  .px-xxl-117 {\n    padding-left: 58rem !important;\n    padding-right: 58rem !important;\n  }\n\n  .px-xxl-118 {\n    padding-left: 58.5rem !important;\n    padding-right: 58.5rem !important;\n  }\n\n  .px-xxl-119 {\n    padding-left: 59rem !important;\n    padding-right: 59rem !important;\n  }\n\n  .px-xxl-120 {\n    padding-left: 59.5rem !important;\n    padding-right: 59.5rem !important;\n  }\n\n  .px-xxl-121 {\n    padding-left: 60rem !important;\n    padding-right: 60rem !important;\n  }\n\n  .px-xxl-122 {\n    padding-left: 60.5rem !important;\n    padding-right: 60.5rem !important;\n  }\n\n  .px-xxl-123 {\n    padding-left: 61rem !important;\n    padding-right: 61rem !important;\n  }\n\n  .px-xxl-124 {\n    padding-left: 61.5rem !important;\n    padding-right: 61.5rem !important;\n  }\n\n  .px-xxl-125 {\n    padding-left: 62rem !important;\n    padding-right: 62rem !important;\n  }\n\n  .px-xxl-126 {\n    padding-left: 62.5rem !important;\n    padding-right: 62.5rem !important;\n  }\n\n  .px-xxl-127 {\n    padding-left: 63rem !important;\n    padding-right: 63rem !important;\n  }\n\n  .px-xxl-128 {\n    padding-left: 63.5rem !important;\n    padding-right: 63.5rem !important;\n  }\n\n  .px-xxl-129 {\n    padding-left: 64rem !important;\n    padding-right: 64rem !important;\n  }\n\n  .px-xxl-130 {\n    padding-left: 64.5rem !important;\n    padding-right: 64.5rem !important;\n  }\n\n  .px-xxl-131 {\n    padding-left: 65rem !important;\n    padding-right: 65rem !important;\n  }\n\n  .px-xxl-132 {\n    padding-left: 65.5rem !important;\n    padding-right: 65.5rem !important;\n  }\n\n  .px-xxl-133 {\n    padding-left: 66rem !important;\n    padding-right: 66rem !important;\n  }\n\n  .px-xxl-134 {\n    padding-left: 66.5rem !important;\n    padding-right: 66.5rem !important;\n  }\n\n  .px-xxl-135 {\n    padding-left: 67rem !important;\n    padding-right: 67rem !important;\n  }\n\n  .px-xxl-136 {\n    padding-left: 67.5rem !important;\n    padding-right: 67.5rem !important;\n  }\n\n  .px-xxl-137 {\n    padding-left: 68rem !important;\n    padding-right: 68rem !important;\n  }\n\n  .px-xxl-138 {\n    padding-left: 68.5rem !important;\n    padding-right: 68.5rem !important;\n  }\n\n  .px-xxl-139 {\n    padding-left: 69rem !important;\n    padding-right: 69rem !important;\n  }\n\n  .px-xxl-140 {\n    padding-left: 69.5rem !important;\n    padding-right: 69.5rem !important;\n  }\n\n  .px-xxl-141 {\n    padding-left: 70rem !important;\n    padding-right: 70rem !important;\n  }\n\n  .px-xxl-142 {\n    padding-left: 70.5rem !important;\n    padding-right: 70.5rem !important;\n  }\n\n  .px-xxl-143 {\n    padding-left: 71rem !important;\n    padding-right: 71rem !important;\n  }\n\n  .px-xxl-144 {\n    padding-left: 71.5rem !important;\n    padding-right: 71.5rem !important;\n  }\n\n  .px-xxl-145 {\n    padding-left: 72rem !important;\n    padding-right: 72rem !important;\n  }\n\n  .px-xxl-146 {\n    padding-left: 72.5rem !important;\n    padding-right: 72.5rem !important;\n  }\n\n  .px-xxl-147 {\n    padding-left: 73rem !important;\n    padding-right: 73rem !important;\n  }\n\n  .px-xxl-148 {\n    padding-left: 73.5rem !important;\n    padding-right: 73.5rem !important;\n  }\n\n  .px-xxl-149 {\n    padding-left: 74rem !important;\n    padding-right: 74rem !important;\n  }\n\n  .px-xxl-150 {\n    padding-left: 74.5rem !important;\n    padding-right: 74.5rem !important;\n  }\n\n  .px-xxl-151 {\n    padding-left: 75rem !important;\n    padding-right: 75rem !important;\n  }\n\n  .px-xxl-152 {\n    padding-left: 75.5rem !important;\n    padding-right: 75.5rem !important;\n  }\n\n  .px-xxl-153 {\n    padding-left: 76rem !important;\n    padding-right: 76rem !important;\n  }\n\n  .px-xxl-154 {\n    padding-left: 76.5rem !important;\n    padding-right: 76.5rem !important;\n  }\n\n  .px-xxl-155 {\n    padding-left: 77rem !important;\n    padding-right: 77rem !important;\n  }\n\n  .px-xxl-156 {\n    padding-left: 77.5rem !important;\n    padding-right: 77.5rem !important;\n  }\n\n  .px-xxl-157 {\n    padding-left: 78rem !important;\n    padding-right: 78rem !important;\n  }\n\n  .px-xxl-158 {\n    padding-left: 78.5rem !important;\n    padding-right: 78.5rem !important;\n  }\n\n  .px-xxl-159 {\n    padding-left: 79rem !important;\n    padding-right: 79rem !important;\n  }\n\n  .px-xxl-160 {\n    padding-left: 79.5rem !important;\n    padding-right: 79.5rem !important;\n  }\n\n  .py-xxl-0 {\n    padding-top: 0rem !important;\n    padding-bottom: 0rem !important;\n  }\n\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xxl-5 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xxl-6 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xxl-7 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xxl-8 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xxl-9 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xxl-10 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xxl-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .py-xxl-12 {\n    padding-top: 5.5rem !important;\n    padding-bottom: 5.5rem !important;\n  }\n\n  .py-xxl-13 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n\n  .py-xxl-14 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n\n  .py-xxl-15 {\n    padding-top: 7rem !important;\n    padding-bottom: 7rem !important;\n  }\n\n  .py-xxl-16 {\n    padding-top: 7.5rem !important;\n    padding-bottom: 7.5rem !important;\n  }\n\n  .py-xxl-17 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n\n  .py-xxl-18 {\n    padding-top: 8.5rem !important;\n    padding-bottom: 8.5rem !important;\n  }\n\n  .py-xxl-19 {\n    padding-top: 9rem !important;\n    padding-bottom: 9rem !important;\n  }\n\n  .py-xxl-20 {\n    padding-top: 9.5rem !important;\n    padding-bottom: 9.5rem !important;\n  }\n\n  .py-xxl-21 {\n    padding-top: 10rem !important;\n    padding-bottom: 10rem !important;\n  }\n\n  .py-xxl-22 {\n    padding-top: 10.5rem !important;\n    padding-bottom: 10.5rem !important;\n  }\n\n  .py-xxl-23 {\n    padding-top: 11rem !important;\n    padding-bottom: 11rem !important;\n  }\n\n  .py-xxl-24 {\n    padding-top: 11.5rem !important;\n    padding-bottom: 11.5rem !important;\n  }\n\n  .py-xxl-25 {\n    padding-top: 12rem !important;\n    padding-bottom: 12rem !important;\n  }\n\n  .py-xxl-26 {\n    padding-top: 12.5rem !important;\n    padding-bottom: 12.5rem !important;\n  }\n\n  .py-xxl-27 {\n    padding-top: 13rem !important;\n    padding-bottom: 13rem !important;\n  }\n\n  .py-xxl-28 {\n    padding-top: 13.5rem !important;\n    padding-bottom: 13.5rem !important;\n  }\n\n  .py-xxl-29 {\n    padding-top: 14rem !important;\n    padding-bottom: 14rem !important;\n  }\n\n  .py-xxl-30 {\n    padding-top: 14.5rem !important;\n    padding-bottom: 14.5rem !important;\n  }\n\n  .py-xxl-31 {\n    padding-top: 15rem !important;\n    padding-bottom: 15rem !important;\n  }\n\n  .py-xxl-32 {\n    padding-top: 15.5rem !important;\n    padding-bottom: 15.5rem !important;\n  }\n\n  .py-xxl-33 {\n    padding-top: 16rem !important;\n    padding-bottom: 16rem !important;\n  }\n\n  .py-xxl-34 {\n    padding-top: 16.5rem !important;\n    padding-bottom: 16.5rem !important;\n  }\n\n  .py-xxl-35 {\n    padding-top: 17rem !important;\n    padding-bottom: 17rem !important;\n  }\n\n  .py-xxl-36 {\n    padding-top: 17.5rem !important;\n    padding-bottom: 17.5rem !important;\n  }\n\n  .py-xxl-37 {\n    padding-top: 18rem !important;\n    padding-bottom: 18rem !important;\n  }\n\n  .py-xxl-38 {\n    padding-top: 18.5rem !important;\n    padding-bottom: 18.5rem !important;\n  }\n\n  .py-xxl-39 {\n    padding-top: 19rem !important;\n    padding-bottom: 19rem !important;\n  }\n\n  .py-xxl-40 {\n    padding-top: 19.5rem !important;\n    padding-bottom: 19.5rem !important;\n  }\n\n  .py-xxl-41 {\n    padding-top: 20rem !important;\n    padding-bottom: 20rem !important;\n  }\n\n  .py-xxl-42 {\n    padding-top: 20.5rem !important;\n    padding-bottom: 20.5rem !important;\n  }\n\n  .py-xxl-43 {\n    padding-top: 21rem !important;\n    padding-bottom: 21rem !important;\n  }\n\n  .py-xxl-44 {\n    padding-top: 21.5rem !important;\n    padding-bottom: 21.5rem !important;\n  }\n\n  .py-xxl-45 {\n    padding-top: 22rem !important;\n    padding-bottom: 22rem !important;\n  }\n\n  .py-xxl-46 {\n    padding-top: 22.5rem !important;\n    padding-bottom: 22.5rem !important;\n  }\n\n  .py-xxl-47 {\n    padding-top: 23rem !important;\n    padding-bottom: 23rem !important;\n  }\n\n  .py-xxl-48 {\n    padding-top: 23.5rem !important;\n    padding-bottom: 23.5rem !important;\n  }\n\n  .py-xxl-49 {\n    padding-top: 24rem !important;\n    padding-bottom: 24rem !important;\n  }\n\n  .py-xxl-50 {\n    padding-top: 24.5rem !important;\n    padding-bottom: 24.5rem !important;\n  }\n\n  .py-xxl-51 {\n    padding-top: 25rem !important;\n    padding-bottom: 25rem !important;\n  }\n\n  .py-xxl-52 {\n    padding-top: 25.5rem !important;\n    padding-bottom: 25.5rem !important;\n  }\n\n  .py-xxl-53 {\n    padding-top: 26rem !important;\n    padding-bottom: 26rem !important;\n  }\n\n  .py-xxl-54 {\n    padding-top: 26.5rem !important;\n    padding-bottom: 26.5rem !important;\n  }\n\n  .py-xxl-55 {\n    padding-top: 27rem !important;\n    padding-bottom: 27rem !important;\n  }\n\n  .py-xxl-56 {\n    padding-top: 27.5rem !important;\n    padding-bottom: 27.5rem !important;\n  }\n\n  .py-xxl-57 {\n    padding-top: 28rem !important;\n    padding-bottom: 28rem !important;\n  }\n\n  .py-xxl-58 {\n    padding-top: 28.5rem !important;\n    padding-bottom: 28.5rem !important;\n  }\n\n  .py-xxl-59 {\n    padding-top: 29rem !important;\n    padding-bottom: 29rem !important;\n  }\n\n  .py-xxl-60 {\n    padding-top: 29.5rem !important;\n    padding-bottom: 29.5rem !important;\n  }\n\n  .py-xxl-61 {\n    padding-top: 30rem !important;\n    padding-bottom: 30rem !important;\n  }\n\n  .py-xxl-62 {\n    padding-top: 30.5rem !important;\n    padding-bottom: 30.5rem !important;\n  }\n\n  .py-xxl-63 {\n    padding-top: 31rem !important;\n    padding-bottom: 31rem !important;\n  }\n\n  .py-xxl-64 {\n    padding-top: 31.5rem !important;\n    padding-bottom: 31.5rem !important;\n  }\n\n  .py-xxl-65 {\n    padding-top: 32rem !important;\n    padding-bottom: 32rem !important;\n  }\n\n  .py-xxl-66 {\n    padding-top: 32.5rem !important;\n    padding-bottom: 32.5rem !important;\n  }\n\n  .py-xxl-67 {\n    padding-top: 33rem !important;\n    padding-bottom: 33rem !important;\n  }\n\n  .py-xxl-68 {\n    padding-top: 33.5rem !important;\n    padding-bottom: 33.5rem !important;\n  }\n\n  .py-xxl-69 {\n    padding-top: 34rem !important;\n    padding-bottom: 34rem !important;\n  }\n\n  .py-xxl-70 {\n    padding-top: 34.5rem !important;\n    padding-bottom: 34.5rem !important;\n  }\n\n  .py-xxl-71 {\n    padding-top: 35rem !important;\n    padding-bottom: 35rem !important;\n  }\n\n  .py-xxl-72 {\n    padding-top: 35.5rem !important;\n    padding-bottom: 35.5rem !important;\n  }\n\n  .py-xxl-73 {\n    padding-top: 36rem !important;\n    padding-bottom: 36rem !important;\n  }\n\n  .py-xxl-74 {\n    padding-top: 36.5rem !important;\n    padding-bottom: 36.5rem !important;\n  }\n\n  .py-xxl-75 {\n    padding-top: 37rem !important;\n    padding-bottom: 37rem !important;\n  }\n\n  .py-xxl-76 {\n    padding-top: 37.5rem !important;\n    padding-bottom: 37.5rem !important;\n  }\n\n  .py-xxl-77 {\n    padding-top: 38rem !important;\n    padding-bottom: 38rem !important;\n  }\n\n  .py-xxl-78 {\n    padding-top: 38.5rem !important;\n    padding-bottom: 38.5rem !important;\n  }\n\n  .py-xxl-79 {\n    padding-top: 39rem !important;\n    padding-bottom: 39rem !important;\n  }\n\n  .py-xxl-80 {\n    padding-top: 39.5rem !important;\n    padding-bottom: 39.5rem !important;\n  }\n\n  .py-xxl-81 {\n    padding-top: 40rem !important;\n    padding-bottom: 40rem !important;\n  }\n\n  .py-xxl-82 {\n    padding-top: 40.5rem !important;\n    padding-bottom: 40.5rem !important;\n  }\n\n  .py-xxl-83 {\n    padding-top: 41rem !important;\n    padding-bottom: 41rem !important;\n  }\n\n  .py-xxl-84 {\n    padding-top: 41.5rem !important;\n    padding-bottom: 41.5rem !important;\n  }\n\n  .py-xxl-85 {\n    padding-top: 42rem !important;\n    padding-bottom: 42rem !important;\n  }\n\n  .py-xxl-86 {\n    padding-top: 42.5rem !important;\n    padding-bottom: 42.5rem !important;\n  }\n\n  .py-xxl-87 {\n    padding-top: 43rem !important;\n    padding-bottom: 43rem !important;\n  }\n\n  .py-xxl-88 {\n    padding-top: 43.5rem !important;\n    padding-bottom: 43.5rem !important;\n  }\n\n  .py-xxl-89 {\n    padding-top: 44rem !important;\n    padding-bottom: 44rem !important;\n  }\n\n  .py-xxl-90 {\n    padding-top: 44.5rem !important;\n    padding-bottom: 44.5rem !important;\n  }\n\n  .py-xxl-91 {\n    padding-top: 45rem !important;\n    padding-bottom: 45rem !important;\n  }\n\n  .py-xxl-92 {\n    padding-top: 45.5rem !important;\n    padding-bottom: 45.5rem !important;\n  }\n\n  .py-xxl-93 {\n    padding-top: 46rem !important;\n    padding-bottom: 46rem !important;\n  }\n\n  .py-xxl-94 {\n    padding-top: 46.5rem !important;\n    padding-bottom: 46.5rem !important;\n  }\n\n  .py-xxl-95 {\n    padding-top: 47rem !important;\n    padding-bottom: 47rem !important;\n  }\n\n  .py-xxl-96 {\n    padding-top: 47.5rem !important;\n    padding-bottom: 47.5rem !important;\n  }\n\n  .py-xxl-97 {\n    padding-top: 48rem !important;\n    padding-bottom: 48rem !important;\n  }\n\n  .py-xxl-98 {\n    padding-top: 48.5rem !important;\n    padding-bottom: 48.5rem !important;\n  }\n\n  .py-xxl-99 {\n    padding-top: 49rem !important;\n    padding-bottom: 49rem !important;\n  }\n\n  .py-xxl-100 {\n    padding-top: 49.5rem !important;\n    padding-bottom: 49.5rem !important;\n  }\n\n  .py-xxl-101 {\n    padding-top: 50rem !important;\n    padding-bottom: 50rem !important;\n  }\n\n  .py-xxl-102 {\n    padding-top: 50.5rem !important;\n    padding-bottom: 50.5rem !important;\n  }\n\n  .py-xxl-103 {\n    padding-top: 51rem !important;\n    padding-bottom: 51rem !important;\n  }\n\n  .py-xxl-104 {\n    padding-top: 51.5rem !important;\n    padding-bottom: 51.5rem !important;\n  }\n\n  .py-xxl-105 {\n    padding-top: 52rem !important;\n    padding-bottom: 52rem !important;\n  }\n\n  .py-xxl-106 {\n    padding-top: 52.5rem !important;\n    padding-bottom: 52.5rem !important;\n  }\n\n  .py-xxl-107 {\n    padding-top: 53rem !important;\n    padding-bottom: 53rem !important;\n  }\n\n  .py-xxl-108 {\n    padding-top: 53.5rem !important;\n    padding-bottom: 53.5rem !important;\n  }\n\n  .py-xxl-109 {\n    padding-top: 54rem !important;\n    padding-bottom: 54rem !important;\n  }\n\n  .py-xxl-110 {\n    padding-top: 54.5rem !important;\n    padding-bottom: 54.5rem !important;\n  }\n\n  .py-xxl-111 {\n    padding-top: 55rem !important;\n    padding-bottom: 55rem !important;\n  }\n\n  .py-xxl-112 {\n    padding-top: 55.5rem !important;\n    padding-bottom: 55.5rem !important;\n  }\n\n  .py-xxl-113 {\n    padding-top: 56rem !important;\n    padding-bottom: 56rem !important;\n  }\n\n  .py-xxl-114 {\n    padding-top: 56.5rem !important;\n    padding-bottom: 56.5rem !important;\n  }\n\n  .py-xxl-115 {\n    padding-top: 57rem !important;\n    padding-bottom: 57rem !important;\n  }\n\n  .py-xxl-116 {\n    padding-top: 57.5rem !important;\n    padding-bottom: 57.5rem !important;\n  }\n\n  .py-xxl-117 {\n    padding-top: 58rem !important;\n    padding-bottom: 58rem !important;\n  }\n\n  .py-xxl-118 {\n    padding-top: 58.5rem !important;\n    padding-bottom: 58.5rem !important;\n  }\n\n  .py-xxl-119 {\n    padding-top: 59rem !important;\n    padding-bottom: 59rem !important;\n  }\n\n  .py-xxl-120 {\n    padding-top: 59.5rem !important;\n    padding-bottom: 59.5rem !important;\n  }\n\n  .py-xxl-121 {\n    padding-top: 60rem !important;\n    padding-bottom: 60rem !important;\n  }\n\n  .py-xxl-122 {\n    padding-top: 60.5rem !important;\n    padding-bottom: 60.5rem !important;\n  }\n\n  .py-xxl-123 {\n    padding-top: 61rem !important;\n    padding-bottom: 61rem !important;\n  }\n\n  .py-xxl-124 {\n    padding-top: 61.5rem !important;\n    padding-bottom: 61.5rem !important;\n  }\n\n  .py-xxl-125 {\n    padding-top: 62rem !important;\n    padding-bottom: 62rem !important;\n  }\n\n  .py-xxl-126 {\n    padding-top: 62.5rem !important;\n    padding-bottom: 62.5rem !important;\n  }\n\n  .py-xxl-127 {\n    padding-top: 63rem !important;\n    padding-bottom: 63rem !important;\n  }\n\n  .py-xxl-128 {\n    padding-top: 63.5rem !important;\n    padding-bottom: 63.5rem !important;\n  }\n\n  .py-xxl-129 {\n    padding-top: 64rem !important;\n    padding-bottom: 64rem !important;\n  }\n\n  .py-xxl-130 {\n    padding-top: 64.5rem !important;\n    padding-bottom: 64.5rem !important;\n  }\n\n  .py-xxl-131 {\n    padding-top: 65rem !important;\n    padding-bottom: 65rem !important;\n  }\n\n  .py-xxl-132 {\n    padding-top: 65.5rem !important;\n    padding-bottom: 65.5rem !important;\n  }\n\n  .py-xxl-133 {\n    padding-top: 66rem !important;\n    padding-bottom: 66rem !important;\n  }\n\n  .py-xxl-134 {\n    padding-top: 66.5rem !important;\n    padding-bottom: 66.5rem !important;\n  }\n\n  .py-xxl-135 {\n    padding-top: 67rem !important;\n    padding-bottom: 67rem !important;\n  }\n\n  .py-xxl-136 {\n    padding-top: 67.5rem !important;\n    padding-bottom: 67.5rem !important;\n  }\n\n  .py-xxl-137 {\n    padding-top: 68rem !important;\n    padding-bottom: 68rem !important;\n  }\n\n  .py-xxl-138 {\n    padding-top: 68.5rem !important;\n    padding-bottom: 68.5rem !important;\n  }\n\n  .py-xxl-139 {\n    padding-top: 69rem !important;\n    padding-bottom: 69rem !important;\n  }\n\n  .py-xxl-140 {\n    padding-top: 69.5rem !important;\n    padding-bottom: 69.5rem !important;\n  }\n\n  .py-xxl-141 {\n    padding-top: 70rem !important;\n    padding-bottom: 70rem !important;\n  }\n\n  .py-xxl-142 {\n    padding-top: 70.5rem !important;\n    padding-bottom: 70.5rem !important;\n  }\n\n  .py-xxl-143 {\n    padding-top: 71rem !important;\n    padding-bottom: 71rem !important;\n  }\n\n  .py-xxl-144 {\n    padding-top: 71.5rem !important;\n    padding-bottom: 71.5rem !important;\n  }\n\n  .py-xxl-145 {\n    padding-top: 72rem !important;\n    padding-bottom: 72rem !important;\n  }\n\n  .py-xxl-146 {\n    padding-top: 72.5rem !important;\n    padding-bottom: 72.5rem !important;\n  }\n\n  .py-xxl-147 {\n    padding-top: 73rem !important;\n    padding-bottom: 73rem !important;\n  }\n\n  .py-xxl-148 {\n    padding-top: 73.5rem !important;\n    padding-bottom: 73.5rem !important;\n  }\n\n  .py-xxl-149 {\n    padding-top: 74rem !important;\n    padding-bottom: 74rem !important;\n  }\n\n  .py-xxl-150 {\n    padding-top: 74.5rem !important;\n    padding-bottom: 74.5rem !important;\n  }\n\n  .py-xxl-151 {\n    padding-top: 75rem !important;\n    padding-bottom: 75rem !important;\n  }\n\n  .py-xxl-152 {\n    padding-top: 75.5rem !important;\n    padding-bottom: 75.5rem !important;\n  }\n\n  .py-xxl-153 {\n    padding-top: 76rem !important;\n    padding-bottom: 76rem !important;\n  }\n\n  .py-xxl-154 {\n    padding-top: 76.5rem !important;\n    padding-bottom: 76.5rem !important;\n  }\n\n  .py-xxl-155 {\n    padding-top: 77rem !important;\n    padding-bottom: 77rem !important;\n  }\n\n  .py-xxl-156 {\n    padding-top: 77.5rem !important;\n    padding-bottom: 77.5rem !important;\n  }\n\n  .py-xxl-157 {\n    padding-top: 78rem !important;\n    padding-bottom: 78rem !important;\n  }\n\n  .py-xxl-158 {\n    padding-top: 78.5rem !important;\n    padding-bottom: 78.5rem !important;\n  }\n\n  .py-xxl-159 {\n    padding-top: 79rem !important;\n    padding-bottom: 79rem !important;\n  }\n\n  .py-xxl-160 {\n    padding-top: 79.5rem !important;\n    padding-bottom: 79.5rem !important;\n  }\n}\n/*Margin*/\n.m-0 {\n  margin: 0rem !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 2rem !important;\n}\n\n.m-6 {\n  margin: 2.5rem !important;\n}\n\n.m-7 {\n  margin: 3rem !important;\n}\n\n.m-8 {\n  margin: 3.5rem !important;\n}\n\n.m-9 {\n  margin: 4rem !important;\n}\n\n.m-10 {\n  margin: 4.5rem !important;\n}\n\n.m-11 {\n  margin: 5rem !important;\n}\n\n.m-12 {\n  margin: 5.5rem !important;\n}\n\n.m-13 {\n  margin: 6rem !important;\n}\n\n.m-14 {\n  margin: 6.5rem !important;\n}\n\n.m-15 {\n  margin: 7rem !important;\n}\n\n.m-16 {\n  margin: 7.5rem !important;\n}\n\n.m-17 {\n  margin: 8rem !important;\n}\n\n.m-18 {\n  margin: 8.5rem !important;\n}\n\n.m-19 {\n  margin: 9rem !important;\n}\n\n.m-20 {\n  margin: 9.5rem !important;\n}\n\n.m-21 {\n  margin: 10rem !important;\n}\n\n.m-22 {\n  margin: 10.5rem !important;\n}\n\n.m-23 {\n  margin: 11rem !important;\n}\n\n.m-24 {\n  margin: 11.5rem !important;\n}\n\n.m-25 {\n  margin: 12rem !important;\n}\n\n.m-26 {\n  margin: 12.5rem !important;\n}\n\n.m-27 {\n  margin: 13rem !important;\n}\n\n.m-28 {\n  margin: 13.5rem !important;\n}\n\n.m-29 {\n  margin: 14rem !important;\n}\n\n.m-30 {\n  margin: 14.5rem !important;\n}\n\n.m-31 {\n  margin: 15rem !important;\n}\n\n.m-32 {\n  margin: 15.5rem !important;\n}\n\n.m-33 {\n  margin: 16rem !important;\n}\n\n.m-34 {\n  margin: 16.5rem !important;\n}\n\n.m-35 {\n  margin: 17rem !important;\n}\n\n.m-36 {\n  margin: 17.5rem !important;\n}\n\n.m-37 {\n  margin: 18rem !important;\n}\n\n.m-38 {\n  margin: 18.5rem !important;\n}\n\n.m-39 {\n  margin: 19rem !important;\n}\n\n.m-40 {\n  margin: 19.5rem !important;\n}\n\n.m-41 {\n  margin: 20rem !important;\n}\n\n.m-42 {\n  margin: 20.5rem !important;\n}\n\n.m-43 {\n  margin: 21rem !important;\n}\n\n.m-44 {\n  margin: 21.5rem !important;\n}\n\n.m-45 {\n  margin: 22rem !important;\n}\n\n.m-46 {\n  margin: 22.5rem !important;\n}\n\n.m-47 {\n  margin: 23rem !important;\n}\n\n.m-48 {\n  margin: 23.5rem !important;\n}\n\n.m-49 {\n  margin: 24rem !important;\n}\n\n.m-50 {\n  margin: 24.5rem !important;\n}\n\n.m-51 {\n  margin: 25rem !important;\n}\n\n.m-52 {\n  margin: 25.5rem !important;\n}\n\n.m-53 {\n  margin: 26rem !important;\n}\n\n.m-54 {\n  margin: 26.5rem !important;\n}\n\n.m-55 {\n  margin: 27rem !important;\n}\n\n.m-56 {\n  margin: 27.5rem !important;\n}\n\n.m-57 {\n  margin: 28rem !important;\n}\n\n.m-58 {\n  margin: 28.5rem !important;\n}\n\n.m-59 {\n  margin: 29rem !important;\n}\n\n.m-60 {\n  margin: 29.5rem !important;\n}\n\n.m-61 {\n  margin: 30rem !important;\n}\n\n.m-62 {\n  margin: 30.5rem !important;\n}\n\n.m-63 {\n  margin: 31rem !important;\n}\n\n.m-64 {\n  margin: 31.5rem !important;\n}\n\n.m-65 {\n  margin: 32rem !important;\n}\n\n.m-66 {\n  margin: 32.5rem !important;\n}\n\n.m-67 {\n  margin: 33rem !important;\n}\n\n.m-68 {\n  margin: 33.5rem !important;\n}\n\n.m-69 {\n  margin: 34rem !important;\n}\n\n.m-70 {\n  margin: 34.5rem !important;\n}\n\n.m-71 {\n  margin: 35rem !important;\n}\n\n.m-72 {\n  margin: 35.5rem !important;\n}\n\n.m-73 {\n  margin: 36rem !important;\n}\n\n.m-74 {\n  margin: 36.5rem !important;\n}\n\n.m-75 {\n  margin: 37rem !important;\n}\n\n.m-76 {\n  margin: 37.5rem !important;\n}\n\n.m-77 {\n  margin: 38rem !important;\n}\n\n.m-78 {\n  margin: 38.5rem !important;\n}\n\n.m-79 {\n  margin: 39rem !important;\n}\n\n.m-80 {\n  margin: 39.5rem !important;\n}\n\n.m-81 {\n  margin: 40rem !important;\n}\n\n.m-82 {\n  margin: 40.5rem !important;\n}\n\n.m-83 {\n  margin: 41rem !important;\n}\n\n.m-84 {\n  margin: 41.5rem !important;\n}\n\n.m-85 {\n  margin: 42rem !important;\n}\n\n.m-86 {\n  margin: 42.5rem !important;\n}\n\n.m-87 {\n  margin: 43rem !important;\n}\n\n.m-88 {\n  margin: 43.5rem !important;\n}\n\n.m-89 {\n  margin: 44rem !important;\n}\n\n.m-90 {\n  margin: 44.5rem !important;\n}\n\n.m-91 {\n  margin: 45rem !important;\n}\n\n.m-92 {\n  margin: 45.5rem !important;\n}\n\n.m-93 {\n  margin: 46rem !important;\n}\n\n.m-94 {\n  margin: 46.5rem !important;\n}\n\n.m-95 {\n  margin: 47rem !important;\n}\n\n.m-96 {\n  margin: 47.5rem !important;\n}\n\n.m-97 {\n  margin: 48rem !important;\n}\n\n.m-98 {\n  margin: 48.5rem !important;\n}\n\n.m-99 {\n  margin: 49rem !important;\n}\n\n.m-100 {\n  margin: 49.5rem !important;\n}\n\n.m-101 {\n  margin: 50rem !important;\n}\n\n.m-102 {\n  margin: 50.5rem !important;\n}\n\n.m-103 {\n  margin: 51rem !important;\n}\n\n.m-104 {\n  margin: 51.5rem !important;\n}\n\n.m-105 {\n  margin: 52rem !important;\n}\n\n.m-106 {\n  margin: 52.5rem !important;\n}\n\n.m-107 {\n  margin: 53rem !important;\n}\n\n.m-108 {\n  margin: 53.5rem !important;\n}\n\n.m-109 {\n  margin: 54rem !important;\n}\n\n.m-110 {\n  margin: 54.5rem !important;\n}\n\n.m-111 {\n  margin: 55rem !important;\n}\n\n.m-112 {\n  margin: 55.5rem !important;\n}\n\n.m-113 {\n  margin: 56rem !important;\n}\n\n.m-114 {\n  margin: 56.5rem !important;\n}\n\n.m-115 {\n  margin: 57rem !important;\n}\n\n.m-116 {\n  margin: 57.5rem !important;\n}\n\n.m-117 {\n  margin: 58rem !important;\n}\n\n.m-118 {\n  margin: 58.5rem !important;\n}\n\n.m-119 {\n  margin: 59rem !important;\n}\n\n.m-120 {\n  margin: 59.5rem !important;\n}\n\n.m-121 {\n  margin: 60rem !important;\n}\n\n.m-122 {\n  margin: 60.5rem !important;\n}\n\n.m-123 {\n  margin: 61rem !important;\n}\n\n.m-124 {\n  margin: 61.5rem !important;\n}\n\n.m-125 {\n  margin: 62rem !important;\n}\n\n.m-126 {\n  margin: 62.5rem !important;\n}\n\n.m-127 {\n  margin: 63rem !important;\n}\n\n.m-128 {\n  margin: 63.5rem !important;\n}\n\n.m-129 {\n  margin: 64rem !important;\n}\n\n.m-130 {\n  margin: 64.5rem !important;\n}\n\n.m-131 {\n  margin: 65rem !important;\n}\n\n.m-132 {\n  margin: 65.5rem !important;\n}\n\n.m-133 {\n  margin: 66rem !important;\n}\n\n.m-134 {\n  margin: 66.5rem !important;\n}\n\n.m-135 {\n  margin: 67rem !important;\n}\n\n.m-136 {\n  margin: 67.5rem !important;\n}\n\n.m-137 {\n  margin: 68rem !important;\n}\n\n.m-138 {\n  margin: 68.5rem !important;\n}\n\n.m-139 {\n  margin: 69rem !important;\n}\n\n.m-140 {\n  margin: 69.5rem !important;\n}\n\n.m-141 {\n  margin: 70rem !important;\n}\n\n.m-142 {\n  margin: 70.5rem !important;\n}\n\n.m-143 {\n  margin: 71rem !important;\n}\n\n.m-144 {\n  margin: 71.5rem !important;\n}\n\n.m-145 {\n  margin: 72rem !important;\n}\n\n.m-146 {\n  margin: 72.5rem !important;\n}\n\n.m-147 {\n  margin: 73rem !important;\n}\n\n.m-148 {\n  margin: 73.5rem !important;\n}\n\n.m-149 {\n  margin: 74rem !important;\n}\n\n.m-150 {\n  margin: 74.5rem !important;\n}\n\n.m-151 {\n  margin: 75rem !important;\n}\n\n.m-152 {\n  margin: 75.5rem !important;\n}\n\n.m-153 {\n  margin: 76rem !important;\n}\n\n.m-154 {\n  margin: 76.5rem !important;\n}\n\n.m-155 {\n  margin: 77rem !important;\n}\n\n.m-156 {\n  margin: 77.5rem !important;\n}\n\n.m-157 {\n  margin: 78rem !important;\n}\n\n.m-158 {\n  margin: 78.5rem !important;\n}\n\n.m-159 {\n  margin: 79rem !important;\n}\n\n.m-160 {\n  margin: 79.5rem !important;\n}\n\n.mt-0 {\n  margin-top: 0rem !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 2rem !important;\n}\n\n.mt-6 {\n  margin-top: 2.5rem !important;\n}\n\n.mt-7 {\n  margin-top: 3rem !important;\n}\n\n.mt-8 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-9 {\n  margin-top: 4rem !important;\n}\n\n.mt-10 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-11 {\n  margin-top: 5rem !important;\n}\n\n.mt-12 {\n  margin-top: 5.5rem !important;\n}\n\n.mt-13 {\n  margin-top: 6rem !important;\n}\n\n.mt-14 {\n  margin-top: 6.5rem !important;\n}\n\n.mt-15 {\n  margin-top: 7rem !important;\n}\n\n.mt-16 {\n  margin-top: 7.5rem !important;\n}\n\n.mt-17 {\n  margin-top: 8rem !important;\n}\n\n.mt-18 {\n  margin-top: 8.5rem !important;\n}\n\n.mt-19 {\n  margin-top: 9rem !important;\n}\n\n.mt-20 {\n  margin-top: 9.5rem !important;\n}\n\n.mt-21 {\n  margin-top: 10rem !important;\n}\n\n.mt-22 {\n  margin-top: 10.5rem !important;\n}\n\n.mt-23 {\n  margin-top: 11rem !important;\n}\n\n.mt-24 {\n  margin-top: 11.5rem !important;\n}\n\n.mt-25 {\n  margin-top: 12rem !important;\n}\n\n.mt-26 {\n  margin-top: 12.5rem !important;\n}\n\n.mt-27 {\n  margin-top: 13rem !important;\n}\n\n.mt-28 {\n  margin-top: 13.5rem !important;\n}\n\n.mt-29 {\n  margin-top: 14rem !important;\n}\n\n.mt-30 {\n  margin-top: 14.5rem !important;\n}\n\n.mt-31 {\n  margin-top: 15rem !important;\n}\n\n.mt-32 {\n  margin-top: 15.5rem !important;\n}\n\n.mt-33 {\n  margin-top: 16rem !important;\n}\n\n.mt-34 {\n  margin-top: 16.5rem !important;\n}\n\n.mt-35 {\n  margin-top: 17rem !important;\n}\n\n.mt-36 {\n  margin-top: 17.5rem !important;\n}\n\n.mt-37 {\n  margin-top: 18rem !important;\n}\n\n.mt-38 {\n  margin-top: 18.5rem !important;\n}\n\n.mt-39 {\n  margin-top: 19rem !important;\n}\n\n.mt-40 {\n  margin-top: 19.5rem !important;\n}\n\n.mt-41 {\n  margin-top: 20rem !important;\n}\n\n.mt-42 {\n  margin-top: 20.5rem !important;\n}\n\n.mt-43 {\n  margin-top: 21rem !important;\n}\n\n.mt-44 {\n  margin-top: 21.5rem !important;\n}\n\n.mt-45 {\n  margin-top: 22rem !important;\n}\n\n.mt-46 {\n  margin-top: 22.5rem !important;\n}\n\n.mt-47 {\n  margin-top: 23rem !important;\n}\n\n.mt-48 {\n  margin-top: 23.5rem !important;\n}\n\n.mt-49 {\n  margin-top: 24rem !important;\n}\n\n.mt-50 {\n  margin-top: 24.5rem !important;\n}\n\n.mt-51 {\n  margin-top: 25rem !important;\n}\n\n.mt-52 {\n  margin-top: 25.5rem !important;\n}\n\n.mt-53 {\n  margin-top: 26rem !important;\n}\n\n.mt-54 {\n  margin-top: 26.5rem !important;\n}\n\n.mt-55 {\n  margin-top: 27rem !important;\n}\n\n.mt-56 {\n  margin-top: 27.5rem !important;\n}\n\n.mt-57 {\n  margin-top: 28rem !important;\n}\n\n.mt-58 {\n  margin-top: 28.5rem !important;\n}\n\n.mt-59 {\n  margin-top: 29rem !important;\n}\n\n.mt-60 {\n  margin-top: 29.5rem !important;\n}\n\n.mt-61 {\n  margin-top: 30rem !important;\n}\n\n.mt-62 {\n  margin-top: 30.5rem !important;\n}\n\n.mt-63 {\n  margin-top: 31rem !important;\n}\n\n.mt-64 {\n  margin-top: 31.5rem !important;\n}\n\n.mt-65 {\n  margin-top: 32rem !important;\n}\n\n.mt-66 {\n  margin-top: 32.5rem !important;\n}\n\n.mt-67 {\n  margin-top: 33rem !important;\n}\n\n.mt-68 {\n  margin-top: 33.5rem !important;\n}\n\n.mt-69 {\n  margin-top: 34rem !important;\n}\n\n.mt-70 {\n  margin-top: 34.5rem !important;\n}\n\n.mt-71 {\n  margin-top: 35rem !important;\n}\n\n.mt-72 {\n  margin-top: 35.5rem !important;\n}\n\n.mt-73 {\n  margin-top: 36rem !important;\n}\n\n.mt-74 {\n  margin-top: 36.5rem !important;\n}\n\n.mt-75 {\n  margin-top: 37rem !important;\n}\n\n.mt-76 {\n  margin-top: 37.5rem !important;\n}\n\n.mt-77 {\n  margin-top: 38rem !important;\n}\n\n.mt-78 {\n  margin-top: 38.5rem !important;\n}\n\n.mt-79 {\n  margin-top: 39rem !important;\n}\n\n.mt-80 {\n  margin-top: 39.5rem !important;\n}\n\n.mt-81 {\n  margin-top: 40rem !important;\n}\n\n.mt-82 {\n  margin-top: 40.5rem !important;\n}\n\n.mt-83 {\n  margin-top: 41rem !important;\n}\n\n.mt-84 {\n  margin-top: 41.5rem !important;\n}\n\n.mt-85 {\n  margin-top: 42rem !important;\n}\n\n.mt-86 {\n  margin-top: 42.5rem !important;\n}\n\n.mt-87 {\n  margin-top: 43rem !important;\n}\n\n.mt-88 {\n  margin-top: 43.5rem !important;\n}\n\n.mt-89 {\n  margin-top: 44rem !important;\n}\n\n.mt-90 {\n  margin-top: 44.5rem !important;\n}\n\n.mt-91 {\n  margin-top: 45rem !important;\n}\n\n.mt-92 {\n  margin-top: 45.5rem !important;\n}\n\n.mt-93 {\n  margin-top: 46rem !important;\n}\n\n.mt-94 {\n  margin-top: 46.5rem !important;\n}\n\n.mt-95 {\n  margin-top: 47rem !important;\n}\n\n.mt-96 {\n  margin-top: 47.5rem !important;\n}\n\n.mt-97 {\n  margin-top: 48rem !important;\n}\n\n.mt-98 {\n  margin-top: 48.5rem !important;\n}\n\n.mt-99 {\n  margin-top: 49rem !important;\n}\n\n.mt-100 {\n  margin-top: 49.5rem !important;\n}\n\n.mt-101 {\n  margin-top: 50rem !important;\n}\n\n.mt-102 {\n  margin-top: 50.5rem !important;\n}\n\n.mt-103 {\n  margin-top: 51rem !important;\n}\n\n.mt-104 {\n  margin-top: 51.5rem !important;\n}\n\n.mt-105 {\n  margin-top: 52rem !important;\n}\n\n.mt-106 {\n  margin-top: 52.5rem !important;\n}\n\n.mt-107 {\n  margin-top: 53rem !important;\n}\n\n.mt-108 {\n  margin-top: 53.5rem !important;\n}\n\n.mt-109 {\n  margin-top: 54rem !important;\n}\n\n.mt-110 {\n  margin-top: 54.5rem !important;\n}\n\n.mt-111 {\n  margin-top: 55rem !important;\n}\n\n.mt-112 {\n  margin-top: 55.5rem !important;\n}\n\n.mt-113 {\n  margin-top: 56rem !important;\n}\n\n.mt-114 {\n  margin-top: 56.5rem !important;\n}\n\n.mt-115 {\n  margin-top: 57rem !important;\n}\n\n.mt-116 {\n  margin-top: 57.5rem !important;\n}\n\n.mt-117 {\n  margin-top: 58rem !important;\n}\n\n.mt-118 {\n  margin-top: 58.5rem !important;\n}\n\n.mt-119 {\n  margin-top: 59rem !important;\n}\n\n.mt-120 {\n  margin-top: 59.5rem !important;\n}\n\n.mt-121 {\n  margin-top: 60rem !important;\n}\n\n.mt-122 {\n  margin-top: 60.5rem !important;\n}\n\n.mt-123 {\n  margin-top: 61rem !important;\n}\n\n.mt-124 {\n  margin-top: 61.5rem !important;\n}\n\n.mt-125 {\n  margin-top: 62rem !important;\n}\n\n.mt-126 {\n  margin-top: 62.5rem !important;\n}\n\n.mt-127 {\n  margin-top: 63rem !important;\n}\n\n.mt-128 {\n  margin-top: 63.5rem !important;\n}\n\n.mt-129 {\n  margin-top: 64rem !important;\n}\n\n.mt-130 {\n  margin-top: 64.5rem !important;\n}\n\n.mt-131 {\n  margin-top: 65rem !important;\n}\n\n.mt-132 {\n  margin-top: 65.5rem !important;\n}\n\n.mt-133 {\n  margin-top: 66rem !important;\n}\n\n.mt-134 {\n  margin-top: 66.5rem !important;\n}\n\n.mt-135 {\n  margin-top: 67rem !important;\n}\n\n.mt-136 {\n  margin-top: 67.5rem !important;\n}\n\n.mt-137 {\n  margin-top: 68rem !important;\n}\n\n.mt-138 {\n  margin-top: 68.5rem !important;\n}\n\n.mt-139 {\n  margin-top: 69rem !important;\n}\n\n.mt-140 {\n  margin-top: 69.5rem !important;\n}\n\n.mt-141 {\n  margin-top: 70rem !important;\n}\n\n.mt-142 {\n  margin-top: 70.5rem !important;\n}\n\n.mt-143 {\n  margin-top: 71rem !important;\n}\n\n.mt-144 {\n  margin-top: 71.5rem !important;\n}\n\n.mt-145 {\n  margin-top: 72rem !important;\n}\n\n.mt-146 {\n  margin-top: 72.5rem !important;\n}\n\n.mt-147 {\n  margin-top: 73rem !important;\n}\n\n.mt-148 {\n  margin-top: 73.5rem !important;\n}\n\n.mt-149 {\n  margin-top: 74rem !important;\n}\n\n.mt-150 {\n  margin-top: 74.5rem !important;\n}\n\n.mt-151 {\n  margin-top: 75rem !important;\n}\n\n.mt-152 {\n  margin-top: 75.5rem !important;\n}\n\n.mt-153 {\n  margin-top: 76rem !important;\n}\n\n.mt-154 {\n  margin-top: 76.5rem !important;\n}\n\n.mt-155 {\n  margin-top: 77rem !important;\n}\n\n.mt-156 {\n  margin-top: 77.5rem !important;\n}\n\n.mt-157 {\n  margin-top: 78rem !important;\n}\n\n.mt-158 {\n  margin-top: 78.5rem !important;\n}\n\n.mt-159 {\n  margin-top: 79rem !important;\n}\n\n.mt-160 {\n  margin-top: 79.5rem !important;\n}\n\n.mb-0 {\n  margin-bottom: 0rem !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-6 {\n  margin-bottom: 2.5rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-10 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-11 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-12 {\n  margin-bottom: 5.5rem !important;\n}\n\n.mb-13 {\n  margin-bottom: 6rem !important;\n}\n\n.mb-14 {\n  margin-bottom: 6.5rem !important;\n}\n\n.mb-15 {\n  margin-bottom: 7rem !important;\n}\n\n.mb-16 {\n  margin-bottom: 7.5rem !important;\n}\n\n.mb-17 {\n  margin-bottom: 8rem !important;\n}\n\n.mb-18 {\n  margin-bottom: 8.5rem !important;\n}\n\n.mb-19 {\n  margin-bottom: 9rem !important;\n}\n\n.mb-20 {\n  margin-bottom: 9.5rem !important;\n}\n\n.mb-21 {\n  margin-bottom: 10rem !important;\n}\n\n.mb-22 {\n  margin-bottom: 10.5rem !important;\n}\n\n.mb-23 {\n  margin-bottom: 11rem !important;\n}\n\n.mb-24 {\n  margin-bottom: 11.5rem !important;\n}\n\n.mb-25 {\n  margin-bottom: 12rem !important;\n}\n\n.mb-26 {\n  margin-bottom: 12.5rem !important;\n}\n\n.mb-27 {\n  margin-bottom: 13rem !important;\n}\n\n.mb-28 {\n  margin-bottom: 13.5rem !important;\n}\n\n.mb-29 {\n  margin-bottom: 14rem !important;\n}\n\n.mb-30 {\n  margin-bottom: 14.5rem !important;\n}\n\n.mb-31 {\n  margin-bottom: 15rem !important;\n}\n\n.mb-32 {\n  margin-bottom: 15.5rem !important;\n}\n\n.mb-33 {\n  margin-bottom: 16rem !important;\n}\n\n.mb-34 {\n  margin-bottom: 16.5rem !important;\n}\n\n.mb-35 {\n  margin-bottom: 17rem !important;\n}\n\n.mb-36 {\n  margin-bottom: 17.5rem !important;\n}\n\n.mb-37 {\n  margin-bottom: 18rem !important;\n}\n\n.mb-38 {\n  margin-bottom: 18.5rem !important;\n}\n\n.mb-39 {\n  margin-bottom: 19rem !important;\n}\n\n.mb-40 {\n  margin-bottom: 19.5rem !important;\n}\n\n.mb-41 {\n  margin-bottom: 20rem !important;\n}\n\n.mb-42 {\n  margin-bottom: 20.5rem !important;\n}\n\n.mb-43 {\n  margin-bottom: 21rem !important;\n}\n\n.mb-44 {\n  margin-bottom: 21.5rem !important;\n}\n\n.mb-45 {\n  margin-bottom: 22rem !important;\n}\n\n.mb-46 {\n  margin-bottom: 22.5rem !important;\n}\n\n.mb-47 {\n  margin-bottom: 23rem !important;\n}\n\n.mb-48 {\n  margin-bottom: 23.5rem !important;\n}\n\n.mb-49 {\n  margin-bottom: 24rem !important;\n}\n\n.mb-50 {\n  margin-bottom: 24.5rem !important;\n}\n\n.mb-51 {\n  margin-bottom: 25rem !important;\n}\n\n.mb-52 {\n  margin-bottom: 25.5rem !important;\n}\n\n.mb-53 {\n  margin-bottom: 26rem !important;\n}\n\n.mb-54 {\n  margin-bottom: 26.5rem !important;\n}\n\n.mb-55 {\n  margin-bottom: 27rem !important;\n}\n\n.mb-56 {\n  margin-bottom: 27.5rem !important;\n}\n\n.mb-57 {\n  margin-bottom: 28rem !important;\n}\n\n.mb-58 {\n  margin-bottom: 28.5rem !important;\n}\n\n.mb-59 {\n  margin-bottom: 29rem !important;\n}\n\n.mb-60 {\n  margin-bottom: 29.5rem !important;\n}\n\n.mb-61 {\n  margin-bottom: 30rem !important;\n}\n\n.mb-62 {\n  margin-bottom: 30.5rem !important;\n}\n\n.mb-63 {\n  margin-bottom: 31rem !important;\n}\n\n.mb-64 {\n  margin-bottom: 31.5rem !important;\n}\n\n.mb-65 {\n  margin-bottom: 32rem !important;\n}\n\n.mb-66 {\n  margin-bottom: 32.5rem !important;\n}\n\n.mb-67 {\n  margin-bottom: 33rem !important;\n}\n\n.mb-68 {\n  margin-bottom: 33.5rem !important;\n}\n\n.mb-69 {\n  margin-bottom: 34rem !important;\n}\n\n.mb-70 {\n  margin-bottom: 34.5rem !important;\n}\n\n.mb-71 {\n  margin-bottom: 35rem !important;\n}\n\n.mb-72 {\n  margin-bottom: 35.5rem !important;\n}\n\n.mb-73 {\n  margin-bottom: 36rem !important;\n}\n\n.mb-74 {\n  margin-bottom: 36.5rem !important;\n}\n\n.mb-75 {\n  margin-bottom: 37rem !important;\n}\n\n.mb-76 {\n  margin-bottom: 37.5rem !important;\n}\n\n.mb-77 {\n  margin-bottom: 38rem !important;\n}\n\n.mb-78 {\n  margin-bottom: 38.5rem !important;\n}\n\n.mb-79 {\n  margin-bottom: 39rem !important;\n}\n\n.mb-80 {\n  margin-bottom: 39.5rem !important;\n}\n\n.mb-81 {\n  margin-bottom: 40rem !important;\n}\n\n.mb-82 {\n  margin-bottom: 40.5rem !important;\n}\n\n.mb-83 {\n  margin-bottom: 41rem !important;\n}\n\n.mb-84 {\n  margin-bottom: 41.5rem !important;\n}\n\n.mb-85 {\n  margin-bottom: 42rem !important;\n}\n\n.mb-86 {\n  margin-bottom: 42.5rem !important;\n}\n\n.mb-87 {\n  margin-bottom: 43rem !important;\n}\n\n.mb-88 {\n  margin-bottom: 43.5rem !important;\n}\n\n.mb-89 {\n  margin-bottom: 44rem !important;\n}\n\n.mb-90 {\n  margin-bottom: 44.5rem !important;\n}\n\n.mb-91 {\n  margin-bottom: 45rem !important;\n}\n\n.mb-92 {\n  margin-bottom: 45.5rem !important;\n}\n\n.mb-93 {\n  margin-bottom: 46rem !important;\n}\n\n.mb-94 {\n  margin-bottom: 46.5rem !important;\n}\n\n.mb-95 {\n  margin-bottom: 47rem !important;\n}\n\n.mb-96 {\n  margin-bottom: 47.5rem !important;\n}\n\n.mb-97 {\n  margin-bottom: 48rem !important;\n}\n\n.mb-98 {\n  margin-bottom: 48.5rem !important;\n}\n\n.mb-99 {\n  margin-bottom: 49rem !important;\n}\n\n.mb-100 {\n  margin-bottom: 49.5rem !important;\n}\n\n.mb-101 {\n  margin-bottom: 50rem !important;\n}\n\n.mb-102 {\n  margin-bottom: 50.5rem !important;\n}\n\n.mb-103 {\n  margin-bottom: 51rem !important;\n}\n\n.mb-104 {\n  margin-bottom: 51.5rem !important;\n}\n\n.mb-105 {\n  margin-bottom: 52rem !important;\n}\n\n.mb-106 {\n  margin-bottom: 52.5rem !important;\n}\n\n.mb-107 {\n  margin-bottom: 53rem !important;\n}\n\n.mb-108 {\n  margin-bottom: 53.5rem !important;\n}\n\n.mb-109 {\n  margin-bottom: 54rem !important;\n}\n\n.mb-110 {\n  margin-bottom: 54.5rem !important;\n}\n\n.mb-111 {\n  margin-bottom: 55rem !important;\n}\n\n.mb-112 {\n  margin-bottom: 55.5rem !important;\n}\n\n.mb-113 {\n  margin-bottom: 56rem !important;\n}\n\n.mb-114 {\n  margin-bottom: 56.5rem !important;\n}\n\n.mb-115 {\n  margin-bottom: 57rem !important;\n}\n\n.mb-116 {\n  margin-bottom: 57.5rem !important;\n}\n\n.mb-117 {\n  margin-bottom: 58rem !important;\n}\n\n.mb-118 {\n  margin-bottom: 58.5rem !important;\n}\n\n.mb-119 {\n  margin-bottom: 59rem !important;\n}\n\n.mb-120 {\n  margin-bottom: 59.5rem !important;\n}\n\n.mb-121 {\n  margin-bottom: 60rem !important;\n}\n\n.mb-122 {\n  margin-bottom: 60.5rem !important;\n}\n\n.mb-123 {\n  margin-bottom: 61rem !important;\n}\n\n.mb-124 {\n  margin-bottom: 61.5rem !important;\n}\n\n.mb-125 {\n  margin-bottom: 62rem !important;\n}\n\n.mb-126 {\n  margin-bottom: 62.5rem !important;\n}\n\n.mb-127 {\n  margin-bottom: 63rem !important;\n}\n\n.mb-128 {\n  margin-bottom: 63.5rem !important;\n}\n\n.mb-129 {\n  margin-bottom: 64rem !important;\n}\n\n.mb-130 {\n  margin-bottom: 64.5rem !important;\n}\n\n.mb-131 {\n  margin-bottom: 65rem !important;\n}\n\n.mb-132 {\n  margin-bottom: 65.5rem !important;\n}\n\n.mb-133 {\n  margin-bottom: 66rem !important;\n}\n\n.mb-134 {\n  margin-bottom: 66.5rem !important;\n}\n\n.mb-135 {\n  margin-bottom: 67rem !important;\n}\n\n.mb-136 {\n  margin-bottom: 67.5rem !important;\n}\n\n.mb-137 {\n  margin-bottom: 68rem !important;\n}\n\n.mb-138 {\n  margin-bottom: 68.5rem !important;\n}\n\n.mb-139 {\n  margin-bottom: 69rem !important;\n}\n\n.mb-140 {\n  margin-bottom: 69.5rem !important;\n}\n\n.mb-141 {\n  margin-bottom: 70rem !important;\n}\n\n.mb-142 {\n  margin-bottom: 70.5rem !important;\n}\n\n.mb-143 {\n  margin-bottom: 71rem !important;\n}\n\n.mb-144 {\n  margin-bottom: 71.5rem !important;\n}\n\n.mb-145 {\n  margin-bottom: 72rem !important;\n}\n\n.mb-146 {\n  margin-bottom: 72.5rem !important;\n}\n\n.mb-147 {\n  margin-bottom: 73rem !important;\n}\n\n.mb-148 {\n  margin-bottom: 73.5rem !important;\n}\n\n.mb-149 {\n  margin-bottom: 74rem !important;\n}\n\n.mb-150 {\n  margin-bottom: 74.5rem !important;\n}\n\n.mb-151 {\n  margin-bottom: 75rem !important;\n}\n\n.mb-152 {\n  margin-bottom: 75.5rem !important;\n}\n\n.mb-153 {\n  margin-bottom: 76rem !important;\n}\n\n.mb-154 {\n  margin-bottom: 76.5rem !important;\n}\n\n.mb-155 {\n  margin-bottom: 77rem !important;\n}\n\n.mb-156 {\n  margin-bottom: 77.5rem !important;\n}\n\n.mb-157 {\n  margin-bottom: 78rem !important;\n}\n\n.mb-158 {\n  margin-bottom: 78.5rem !important;\n}\n\n.mb-159 {\n  margin-bottom: 79rem !important;\n}\n\n.mb-160 {\n  margin-bottom: 79.5rem !important;\n}\n\n.ms-0 {\n  margin-left: 0rem !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 2rem !important;\n}\n\n.ms-6 {\n  margin-left: 2.5rem !important;\n}\n\n.ms-7 {\n  margin-left: 3rem !important;\n}\n\n.ms-8 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-9 {\n  margin-left: 4rem !important;\n}\n\n.ms-10 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-11 {\n  margin-left: 5rem !important;\n}\n\n.ms-12 {\n  margin-left: 5.5rem !important;\n}\n\n.ms-13 {\n  margin-left: 6rem !important;\n}\n\n.ms-14 {\n  margin-left: 6.5rem !important;\n}\n\n.ms-15 {\n  margin-left: 7rem !important;\n}\n\n.ms-16 {\n  margin-left: 7.5rem !important;\n}\n\n.ms-17 {\n  margin-left: 8rem !important;\n}\n\n.ms-18 {\n  margin-left: 8.5rem !important;\n}\n\n.ms-19 {\n  margin-left: 9rem !important;\n}\n\n.ms-20 {\n  margin-left: 9.5rem !important;\n}\n\n.ms-21 {\n  margin-left: 10rem !important;\n}\n\n.ms-22 {\n  margin-left: 10.5rem !important;\n}\n\n.ms-23 {\n  margin-left: 11rem !important;\n}\n\n.ms-24 {\n  margin-left: 11.5rem !important;\n}\n\n.ms-25 {\n  margin-left: 12rem !important;\n}\n\n.ms-26 {\n  margin-left: 12.5rem !important;\n}\n\n.ms-27 {\n  margin-left: 13rem !important;\n}\n\n.ms-28 {\n  margin-left: 13.5rem !important;\n}\n\n.ms-29 {\n  margin-left: 14rem !important;\n}\n\n.ms-30 {\n  margin-left: 14.5rem !important;\n}\n\n.ms-31 {\n  margin-left: 15rem !important;\n}\n\n.ms-32 {\n  margin-left: 15.5rem !important;\n}\n\n.ms-33 {\n  margin-left: 16rem !important;\n}\n\n.ms-34 {\n  margin-left: 16.5rem !important;\n}\n\n.ms-35 {\n  margin-left: 17rem !important;\n}\n\n.ms-36 {\n  margin-left: 17.5rem !important;\n}\n\n.ms-37 {\n  margin-left: 18rem !important;\n}\n\n.ms-38 {\n  margin-left: 18.5rem !important;\n}\n\n.ms-39 {\n  margin-left: 19rem !important;\n}\n\n.ms-40 {\n  margin-left: 19.5rem !important;\n}\n\n.ms-41 {\n  margin-left: 20rem !important;\n}\n\n.ms-42 {\n  margin-left: 20.5rem !important;\n}\n\n.ms-43 {\n  margin-left: 21rem !important;\n}\n\n.ms-44 {\n  margin-left: 21.5rem !important;\n}\n\n.ms-45 {\n  margin-left: 22rem !important;\n}\n\n.ms-46 {\n  margin-left: 22.5rem !important;\n}\n\n.ms-47 {\n  margin-left: 23rem !important;\n}\n\n.ms-48 {\n  margin-left: 23.5rem !important;\n}\n\n.ms-49 {\n  margin-left: 24rem !important;\n}\n\n.ms-50 {\n  margin-left: 24.5rem !important;\n}\n\n.ms-51 {\n  margin-left: 25rem !important;\n}\n\n.ms-52 {\n  margin-left: 25.5rem !important;\n}\n\n.ms-53 {\n  margin-left: 26rem !important;\n}\n\n.ms-54 {\n  margin-left: 26.5rem !important;\n}\n\n.ms-55 {\n  margin-left: 27rem !important;\n}\n\n.ms-56 {\n  margin-left: 27.5rem !important;\n}\n\n.ms-57 {\n  margin-left: 28rem !important;\n}\n\n.ms-58 {\n  margin-left: 28.5rem !important;\n}\n\n.ms-59 {\n  margin-left: 29rem !important;\n}\n\n.ms-60 {\n  margin-left: 29.5rem !important;\n}\n\n.ms-61 {\n  margin-left: 30rem !important;\n}\n\n.ms-62 {\n  margin-left: 30.5rem !important;\n}\n\n.ms-63 {\n  margin-left: 31rem !important;\n}\n\n.ms-64 {\n  margin-left: 31.5rem !important;\n}\n\n.ms-65 {\n  margin-left: 32rem !important;\n}\n\n.ms-66 {\n  margin-left: 32.5rem !important;\n}\n\n.ms-67 {\n  margin-left: 33rem !important;\n}\n\n.ms-68 {\n  margin-left: 33.5rem !important;\n}\n\n.ms-69 {\n  margin-left: 34rem !important;\n}\n\n.ms-70 {\n  margin-left: 34.5rem !important;\n}\n\n.ms-71 {\n  margin-left: 35rem !important;\n}\n\n.ms-72 {\n  margin-left: 35.5rem !important;\n}\n\n.ms-73 {\n  margin-left: 36rem !important;\n}\n\n.ms-74 {\n  margin-left: 36.5rem !important;\n}\n\n.ms-75 {\n  margin-left: 37rem !important;\n}\n\n.ms-76 {\n  margin-left: 37.5rem !important;\n}\n\n.ms-77 {\n  margin-left: 38rem !important;\n}\n\n.ms-78 {\n  margin-left: 38.5rem !important;\n}\n\n.ms-79 {\n  margin-left: 39rem !important;\n}\n\n.ms-80 {\n  margin-left: 39.5rem !important;\n}\n\n.ms-81 {\n  margin-left: 40rem !important;\n}\n\n.ms-82 {\n  margin-left: 40.5rem !important;\n}\n\n.ms-83 {\n  margin-left: 41rem !important;\n}\n\n.ms-84 {\n  margin-left: 41.5rem !important;\n}\n\n.ms-85 {\n  margin-left: 42rem !important;\n}\n\n.ms-86 {\n  margin-left: 42.5rem !important;\n}\n\n.ms-87 {\n  margin-left: 43rem !important;\n}\n\n.ms-88 {\n  margin-left: 43.5rem !important;\n}\n\n.ms-89 {\n  margin-left: 44rem !important;\n}\n\n.ms-90 {\n  margin-left: 44.5rem !important;\n}\n\n.ms-91 {\n  margin-left: 45rem !important;\n}\n\n.ms-92 {\n  margin-left: 45.5rem !important;\n}\n\n.ms-93 {\n  margin-left: 46rem !important;\n}\n\n.ms-94 {\n  margin-left: 46.5rem !important;\n}\n\n.ms-95 {\n  margin-left: 47rem !important;\n}\n\n.ms-96 {\n  margin-left: 47.5rem !important;\n}\n\n.ms-97 {\n  margin-left: 48rem !important;\n}\n\n.ms-98 {\n  margin-left: 48.5rem !important;\n}\n\n.ms-99 {\n  margin-left: 49rem !important;\n}\n\n.ms-100 {\n  margin-left: 49.5rem !important;\n}\n\n.ms-101 {\n  margin-left: 50rem !important;\n}\n\n.ms-102 {\n  margin-left: 50.5rem !important;\n}\n\n.ms-103 {\n  margin-left: 51rem !important;\n}\n\n.ms-104 {\n  margin-left: 51.5rem !important;\n}\n\n.ms-105 {\n  margin-left: 52rem !important;\n}\n\n.ms-106 {\n  margin-left: 52.5rem !important;\n}\n\n.ms-107 {\n  margin-left: 53rem !important;\n}\n\n.ms-108 {\n  margin-left: 53.5rem !important;\n}\n\n.ms-109 {\n  margin-left: 54rem !important;\n}\n\n.ms-110 {\n  margin-left: 54.5rem !important;\n}\n\n.ms-111 {\n  margin-left: 55rem !important;\n}\n\n.ms-112 {\n  margin-left: 55.5rem !important;\n}\n\n.ms-113 {\n  margin-left: 56rem !important;\n}\n\n.ms-114 {\n  margin-left: 56.5rem !important;\n}\n\n.ms-115 {\n  margin-left: 57rem !important;\n}\n\n.ms-116 {\n  margin-left: 57.5rem !important;\n}\n\n.ms-117 {\n  margin-left: 58rem !important;\n}\n\n.ms-118 {\n  margin-left: 58.5rem !important;\n}\n\n.ms-119 {\n  margin-left: 59rem !important;\n}\n\n.ms-120 {\n  margin-left: 59.5rem !important;\n}\n\n.ms-121 {\n  margin-left: 60rem !important;\n}\n\n.ms-122 {\n  margin-left: 60.5rem !important;\n}\n\n.ms-123 {\n  margin-left: 61rem !important;\n}\n\n.ms-124 {\n  margin-left: 61.5rem !important;\n}\n\n.ms-125 {\n  margin-left: 62rem !important;\n}\n\n.ms-126 {\n  margin-left: 62.5rem !important;\n}\n\n.ms-127 {\n  margin-left: 63rem !important;\n}\n\n.ms-128 {\n  margin-left: 63.5rem !important;\n}\n\n.ms-129 {\n  margin-left: 64rem !important;\n}\n\n.ms-130 {\n  margin-left: 64.5rem !important;\n}\n\n.ms-131 {\n  margin-left: 65rem !important;\n}\n\n.ms-132 {\n  margin-left: 65.5rem !important;\n}\n\n.ms-133 {\n  margin-left: 66rem !important;\n}\n\n.ms-134 {\n  margin-left: 66.5rem !important;\n}\n\n.ms-135 {\n  margin-left: 67rem !important;\n}\n\n.ms-136 {\n  margin-left: 67.5rem !important;\n}\n\n.ms-137 {\n  margin-left: 68rem !important;\n}\n\n.ms-138 {\n  margin-left: 68.5rem !important;\n}\n\n.ms-139 {\n  margin-left: 69rem !important;\n}\n\n.ms-140 {\n  margin-left: 69.5rem !important;\n}\n\n.ms-141 {\n  margin-left: 70rem !important;\n}\n\n.ms-142 {\n  margin-left: 70.5rem !important;\n}\n\n.ms-143 {\n  margin-left: 71rem !important;\n}\n\n.ms-144 {\n  margin-left: 71.5rem !important;\n}\n\n.ms-145 {\n  margin-left: 72rem !important;\n}\n\n.ms-146 {\n  margin-left: 72.5rem !important;\n}\n\n.ms-147 {\n  margin-left: 73rem !important;\n}\n\n.ms-148 {\n  margin-left: 73.5rem !important;\n}\n\n.ms-149 {\n  margin-left: 74rem !important;\n}\n\n.ms-150 {\n  margin-left: 74.5rem !important;\n}\n\n.ms-151 {\n  margin-left: 75rem !important;\n}\n\n.ms-152 {\n  margin-left: 75.5rem !important;\n}\n\n.ms-153 {\n  margin-left: 76rem !important;\n}\n\n.ms-154 {\n  margin-left: 76.5rem !important;\n}\n\n.ms-155 {\n  margin-left: 77rem !important;\n}\n\n.ms-156 {\n  margin-left: 77.5rem !important;\n}\n\n.ms-157 {\n  margin-left: 78rem !important;\n}\n\n.ms-158 {\n  margin-left: 78.5rem !important;\n}\n\n.ms-159 {\n  margin-left: 79rem !important;\n}\n\n.ms-160 {\n  margin-left: 79.5rem !important;\n}\n\n.me-0 {\n  margin-right: 0rem !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 2rem !important;\n}\n\n.me-6 {\n  margin-right: 2.5rem !important;\n}\n\n.me-7 {\n  margin-right: 3rem !important;\n}\n\n.me-8 {\n  margin-right: 3.5rem !important;\n}\n\n.me-9 {\n  margin-right: 4rem !important;\n}\n\n.me-10 {\n  margin-right: 4.5rem !important;\n}\n\n.me-11 {\n  margin-right: 5rem !important;\n}\n\n.me-12 {\n  margin-right: 5.5rem !important;\n}\n\n.me-13 {\n  margin-right: 6rem !important;\n}\n\n.me-14 {\n  margin-right: 6.5rem !important;\n}\n\n.me-15 {\n  margin-right: 7rem !important;\n}\n\n.me-16 {\n  margin-right: 7.5rem !important;\n}\n\n.me-17 {\n  margin-right: 8rem !important;\n}\n\n.me-18 {\n  margin-right: 8.5rem !important;\n}\n\n.me-19 {\n  margin-right: 9rem !important;\n}\n\n.me-20 {\n  margin-right: 9.5rem !important;\n}\n\n.me-21 {\n  margin-right: 10rem !important;\n}\n\n.me-22 {\n  margin-right: 10.5rem !important;\n}\n\n.me-23 {\n  margin-right: 11rem !important;\n}\n\n.me-24 {\n  margin-right: 11.5rem !important;\n}\n\n.me-25 {\n  margin-right: 12rem !important;\n}\n\n.me-26 {\n  margin-right: 12.5rem !important;\n}\n\n.me-27 {\n  margin-right: 13rem !important;\n}\n\n.me-28 {\n  margin-right: 13.5rem !important;\n}\n\n.me-29 {\n  margin-right: 14rem !important;\n}\n\n.me-30 {\n  margin-right: 14.5rem !important;\n}\n\n.me-31 {\n  margin-right: 15rem !important;\n}\n\n.me-32 {\n  margin-right: 15.5rem !important;\n}\n\n.me-33 {\n  margin-right: 16rem !important;\n}\n\n.me-34 {\n  margin-right: 16.5rem !important;\n}\n\n.me-35 {\n  margin-right: 17rem !important;\n}\n\n.me-36 {\n  margin-right: 17.5rem !important;\n}\n\n.me-37 {\n  margin-right: 18rem !important;\n}\n\n.me-38 {\n  margin-right: 18.5rem !important;\n}\n\n.me-39 {\n  margin-right: 19rem !important;\n}\n\n.me-40 {\n  margin-right: 19.5rem !important;\n}\n\n.me-41 {\n  margin-right: 20rem !important;\n}\n\n.me-42 {\n  margin-right: 20.5rem !important;\n}\n\n.me-43 {\n  margin-right: 21rem !important;\n}\n\n.me-44 {\n  margin-right: 21.5rem !important;\n}\n\n.me-45 {\n  margin-right: 22rem !important;\n}\n\n.me-46 {\n  margin-right: 22.5rem !important;\n}\n\n.me-47 {\n  margin-right: 23rem !important;\n}\n\n.me-48 {\n  margin-right: 23.5rem !important;\n}\n\n.me-49 {\n  margin-right: 24rem !important;\n}\n\n.me-50 {\n  margin-right: 24.5rem !important;\n}\n\n.me-51 {\n  margin-right: 25rem !important;\n}\n\n.me-52 {\n  margin-right: 25.5rem !important;\n}\n\n.me-53 {\n  margin-right: 26rem !important;\n}\n\n.me-54 {\n  margin-right: 26.5rem !important;\n}\n\n.me-55 {\n  margin-right: 27rem !important;\n}\n\n.me-56 {\n  margin-right: 27.5rem !important;\n}\n\n.me-57 {\n  margin-right: 28rem !important;\n}\n\n.me-58 {\n  margin-right: 28.5rem !important;\n}\n\n.me-59 {\n  margin-right: 29rem !important;\n}\n\n.me-60 {\n  margin-right: 29.5rem !important;\n}\n\n.me-61 {\n  margin-right: 30rem !important;\n}\n\n.me-62 {\n  margin-right: 30.5rem !important;\n}\n\n.me-63 {\n  margin-right: 31rem !important;\n}\n\n.me-64 {\n  margin-right: 31.5rem !important;\n}\n\n.me-65 {\n  margin-right: 32rem !important;\n}\n\n.me-66 {\n  margin-right: 32.5rem !important;\n}\n\n.me-67 {\n  margin-right: 33rem !important;\n}\n\n.me-68 {\n  margin-right: 33.5rem !important;\n}\n\n.me-69 {\n  margin-right: 34rem !important;\n}\n\n.me-70 {\n  margin-right: 34.5rem !important;\n}\n\n.me-71 {\n  margin-right: 35rem !important;\n}\n\n.me-72 {\n  margin-right: 35.5rem !important;\n}\n\n.me-73 {\n  margin-right: 36rem !important;\n}\n\n.me-74 {\n  margin-right: 36.5rem !important;\n}\n\n.me-75 {\n  margin-right: 37rem !important;\n}\n\n.me-76 {\n  margin-right: 37.5rem !important;\n}\n\n.me-77 {\n  margin-right: 38rem !important;\n}\n\n.me-78 {\n  margin-right: 38.5rem !important;\n}\n\n.me-79 {\n  margin-right: 39rem !important;\n}\n\n.me-80 {\n  margin-right: 39.5rem !important;\n}\n\n.me-81 {\n  margin-right: 40rem !important;\n}\n\n.me-82 {\n  margin-right: 40.5rem !important;\n}\n\n.me-83 {\n  margin-right: 41rem !important;\n}\n\n.me-84 {\n  margin-right: 41.5rem !important;\n}\n\n.me-85 {\n  margin-right: 42rem !important;\n}\n\n.me-86 {\n  margin-right: 42.5rem !important;\n}\n\n.me-87 {\n  margin-right: 43rem !important;\n}\n\n.me-88 {\n  margin-right: 43.5rem !important;\n}\n\n.me-89 {\n  margin-right: 44rem !important;\n}\n\n.me-90 {\n  margin-right: 44.5rem !important;\n}\n\n.me-91 {\n  margin-right: 45rem !important;\n}\n\n.me-92 {\n  margin-right: 45.5rem !important;\n}\n\n.me-93 {\n  margin-right: 46rem !important;\n}\n\n.me-94 {\n  margin-right: 46.5rem !important;\n}\n\n.me-95 {\n  margin-right: 47rem !important;\n}\n\n.me-96 {\n  margin-right: 47.5rem !important;\n}\n\n.me-97 {\n  margin-right: 48rem !important;\n}\n\n.me-98 {\n  margin-right: 48.5rem !important;\n}\n\n.me-99 {\n  margin-right: 49rem !important;\n}\n\n.me-100 {\n  margin-right: 49.5rem !important;\n}\n\n.me-101 {\n  margin-right: 50rem !important;\n}\n\n.me-102 {\n  margin-right: 50.5rem !important;\n}\n\n.me-103 {\n  margin-right: 51rem !important;\n}\n\n.me-104 {\n  margin-right: 51.5rem !important;\n}\n\n.me-105 {\n  margin-right: 52rem !important;\n}\n\n.me-106 {\n  margin-right: 52.5rem !important;\n}\n\n.me-107 {\n  margin-right: 53rem !important;\n}\n\n.me-108 {\n  margin-right: 53.5rem !important;\n}\n\n.me-109 {\n  margin-right: 54rem !important;\n}\n\n.me-110 {\n  margin-right: 54.5rem !important;\n}\n\n.me-111 {\n  margin-right: 55rem !important;\n}\n\n.me-112 {\n  margin-right: 55.5rem !important;\n}\n\n.me-113 {\n  margin-right: 56rem !important;\n}\n\n.me-114 {\n  margin-right: 56.5rem !important;\n}\n\n.me-115 {\n  margin-right: 57rem !important;\n}\n\n.me-116 {\n  margin-right: 57.5rem !important;\n}\n\n.me-117 {\n  margin-right: 58rem !important;\n}\n\n.me-118 {\n  margin-right: 58.5rem !important;\n}\n\n.me-119 {\n  margin-right: 59rem !important;\n}\n\n.me-120 {\n  margin-right: 59.5rem !important;\n}\n\n.me-121 {\n  margin-right: 60rem !important;\n}\n\n.me-122 {\n  margin-right: 60.5rem !important;\n}\n\n.me-123 {\n  margin-right: 61rem !important;\n}\n\n.me-124 {\n  margin-right: 61.5rem !important;\n}\n\n.me-125 {\n  margin-right: 62rem !important;\n}\n\n.me-126 {\n  margin-right: 62.5rem !important;\n}\n\n.me-127 {\n  margin-right: 63rem !important;\n}\n\n.me-128 {\n  margin-right: 63.5rem !important;\n}\n\n.me-129 {\n  margin-right: 64rem !important;\n}\n\n.me-130 {\n  margin-right: 64.5rem !important;\n}\n\n.me-131 {\n  margin-right: 65rem !important;\n}\n\n.me-132 {\n  margin-right: 65.5rem !important;\n}\n\n.me-133 {\n  margin-right: 66rem !important;\n}\n\n.me-134 {\n  margin-right: 66.5rem !important;\n}\n\n.me-135 {\n  margin-right: 67rem !important;\n}\n\n.me-136 {\n  margin-right: 67.5rem !important;\n}\n\n.me-137 {\n  margin-right: 68rem !important;\n}\n\n.me-138 {\n  margin-right: 68.5rem !important;\n}\n\n.me-139 {\n  margin-right: 69rem !important;\n}\n\n.me-140 {\n  margin-right: 69.5rem !important;\n}\n\n.me-141 {\n  margin-right: 70rem !important;\n}\n\n.me-142 {\n  margin-right: 70.5rem !important;\n}\n\n.me-143 {\n  margin-right: 71rem !important;\n}\n\n.me-144 {\n  margin-right: 71.5rem !important;\n}\n\n.me-145 {\n  margin-right: 72rem !important;\n}\n\n.me-146 {\n  margin-right: 72.5rem !important;\n}\n\n.me-147 {\n  margin-right: 73rem !important;\n}\n\n.me-148 {\n  margin-right: 73.5rem !important;\n}\n\n.me-149 {\n  margin-right: 74rem !important;\n}\n\n.me-150 {\n  margin-right: 74.5rem !important;\n}\n\n.me-151 {\n  margin-right: 75rem !important;\n}\n\n.me-152 {\n  margin-right: 75.5rem !important;\n}\n\n.me-153 {\n  margin-right: 76rem !important;\n}\n\n.me-154 {\n  margin-right: 76.5rem !important;\n}\n\n.me-155 {\n  margin-right: 77rem !important;\n}\n\n.me-156 {\n  margin-right: 77.5rem !important;\n}\n\n.me-157 {\n  margin-right: 78rem !important;\n}\n\n.me-158 {\n  margin-right: 78.5rem !important;\n}\n\n.me-159 {\n  margin-right: 79rem !important;\n}\n\n.me-160 {\n  margin-right: 79.5rem !important;\n}\n\n.mx-0 {\n  margin-left: 0rem !important;\n  margin-right: 0rem !important;\n}\n\n.mx-1 {\n  margin-left: 0.25rem !important;\n  margin-right: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-left: 0.5rem !important;\n  margin-right: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-left: 1rem !important;\n  margin-right: 1rem !important;\n}\n\n.mx-4 {\n  margin-left: 1.5rem !important;\n  margin-right: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-left: 2rem !important;\n  margin-right: 2rem !important;\n}\n\n.mx-6 {\n  margin-left: 2.5rem !important;\n  margin-right: 2.5rem !important;\n}\n\n.mx-7 {\n  margin-left: 3rem !important;\n  margin-right: 3rem !important;\n}\n\n.mx-8 {\n  margin-left: 3.5rem !important;\n  margin-right: 3.5rem !important;\n}\n\n.mx-9 {\n  margin-left: 4rem !important;\n  margin-right: 4rem !important;\n}\n\n.mx-10 {\n  margin-left: 4.5rem !important;\n  margin-right: 4.5rem !important;\n}\n\n.mx-11 {\n  margin-left: 5rem !important;\n  margin-right: 5rem !important;\n}\n\n.mx-12 {\n  margin-left: 5.5rem !important;\n  margin-right: 5.5rem !important;\n}\n\n.mx-13 {\n  margin-left: 6rem !important;\n  margin-right: 6rem !important;\n}\n\n.mx-14 {\n  margin-left: 6.5rem !important;\n  margin-right: 6.5rem !important;\n}\n\n.mx-15 {\n  margin-left: 7rem !important;\n  margin-right: 7rem !important;\n}\n\n.mx-16 {\n  margin-left: 7.5rem !important;\n  margin-right: 7.5rem !important;\n}\n\n.mx-17 {\n  margin-left: 8rem !important;\n  margin-right: 8rem !important;\n}\n\n.mx-18 {\n  margin-left: 8.5rem !important;\n  margin-right: 8.5rem !important;\n}\n\n.mx-19 {\n  margin-left: 9rem !important;\n  margin-right: 9rem !important;\n}\n\n.mx-20 {\n  margin-left: 9.5rem !important;\n  margin-right: 9.5rem !important;\n}\n\n.mx-21 {\n  margin-left: 10rem !important;\n  margin-right: 10rem !important;\n}\n\n.mx-22 {\n  margin-left: 10.5rem !important;\n  margin-right: 10.5rem !important;\n}\n\n.mx-23 {\n  margin-left: 11rem !important;\n  margin-right: 11rem !important;\n}\n\n.mx-24 {\n  margin-left: 11.5rem !important;\n  margin-right: 11.5rem !important;\n}\n\n.mx-25 {\n  margin-left: 12rem !important;\n  margin-right: 12rem !important;\n}\n\n.mx-26 {\n  margin-left: 12.5rem !important;\n  margin-right: 12.5rem !important;\n}\n\n.mx-27 {\n  margin-left: 13rem !important;\n  margin-right: 13rem !important;\n}\n\n.mx-28 {\n  margin-left: 13.5rem !important;\n  margin-right: 13.5rem !important;\n}\n\n.mx-29 {\n  margin-left: 14rem !important;\n  margin-right: 14rem !important;\n}\n\n.mx-30 {\n  margin-left: 14.5rem !important;\n  margin-right: 14.5rem !important;\n}\n\n.mx-31 {\n  margin-left: 15rem !important;\n  margin-right: 15rem !important;\n}\n\n.mx-32 {\n  margin-left: 15.5rem !important;\n  margin-right: 15.5rem !important;\n}\n\n.mx-33 {\n  margin-left: 16rem !important;\n  margin-right: 16rem !important;\n}\n\n.mx-34 {\n  margin-left: 16.5rem !important;\n  margin-right: 16.5rem !important;\n}\n\n.mx-35 {\n  margin-left: 17rem !important;\n  margin-right: 17rem !important;\n}\n\n.mx-36 {\n  margin-left: 17.5rem !important;\n  margin-right: 17.5rem !important;\n}\n\n.mx-37 {\n  margin-left: 18rem !important;\n  margin-right: 18rem !important;\n}\n\n.mx-38 {\n  margin-left: 18.5rem !important;\n  margin-right: 18.5rem !important;\n}\n\n.mx-39 {\n  margin-left: 19rem !important;\n  margin-right: 19rem !important;\n}\n\n.mx-40 {\n  margin-left: 19.5rem !important;\n  margin-right: 19.5rem !important;\n}\n\n.mx-41 {\n  margin-left: 20rem !important;\n  margin-right: 20rem !important;\n}\n\n.mx-42 {\n  margin-left: 20.5rem !important;\n  margin-right: 20.5rem !important;\n}\n\n.mx-43 {\n  margin-left: 21rem !important;\n  margin-right: 21rem !important;\n}\n\n.mx-44 {\n  margin-left: 21.5rem !important;\n  margin-right: 21.5rem !important;\n}\n\n.mx-45 {\n  margin-left: 22rem !important;\n  margin-right: 22rem !important;\n}\n\n.mx-46 {\n  margin-left: 22.5rem !important;\n  margin-right: 22.5rem !important;\n}\n\n.mx-47 {\n  margin-left: 23rem !important;\n  margin-right: 23rem !important;\n}\n\n.mx-48 {\n  margin-left: 23.5rem !important;\n  margin-right: 23.5rem !important;\n}\n\n.mx-49 {\n  margin-left: 24rem !important;\n  margin-right: 24rem !important;\n}\n\n.mx-50 {\n  margin-left: 24.5rem !important;\n  margin-right: 24.5rem !important;\n}\n\n.mx-51 {\n  margin-left: 25rem !important;\n  margin-right: 25rem !important;\n}\n\n.mx-52 {\n  margin-left: 25.5rem !important;\n  margin-right: 25.5rem !important;\n}\n\n.mx-53 {\n  margin-left: 26rem !important;\n  margin-right: 26rem !important;\n}\n\n.mx-54 {\n  margin-left: 26.5rem !important;\n  margin-right: 26.5rem !important;\n}\n\n.mx-55 {\n  margin-left: 27rem !important;\n  margin-right: 27rem !important;\n}\n\n.mx-56 {\n  margin-left: 27.5rem !important;\n  margin-right: 27.5rem !important;\n}\n\n.mx-57 {\n  margin-left: 28rem !important;\n  margin-right: 28rem !important;\n}\n\n.mx-58 {\n  margin-left: 28.5rem !important;\n  margin-right: 28.5rem !important;\n}\n\n.mx-59 {\n  margin-left: 29rem !important;\n  margin-right: 29rem !important;\n}\n\n.mx-60 {\n  margin-left: 29.5rem !important;\n  margin-right: 29.5rem !important;\n}\n\n.mx-61 {\n  margin-left: 30rem !important;\n  margin-right: 30rem !important;\n}\n\n.mx-62 {\n  margin-left: 30.5rem !important;\n  margin-right: 30.5rem !important;\n}\n\n.mx-63 {\n  margin-left: 31rem !important;\n  margin-right: 31rem !important;\n}\n\n.mx-64 {\n  margin-left: 31.5rem !important;\n  margin-right: 31.5rem !important;\n}\n\n.mx-65 {\n  margin-left: 32rem !important;\n  margin-right: 32rem !important;\n}\n\n.mx-66 {\n  margin-left: 32.5rem !important;\n  margin-right: 32.5rem !important;\n}\n\n.mx-67 {\n  margin-left: 33rem !important;\n  margin-right: 33rem !important;\n}\n\n.mx-68 {\n  margin-left: 33.5rem !important;\n  margin-right: 33.5rem !important;\n}\n\n.mx-69 {\n  margin-left: 34rem !important;\n  margin-right: 34rem !important;\n}\n\n.mx-70 {\n  margin-left: 34.5rem !important;\n  margin-right: 34.5rem !important;\n}\n\n.mx-71 {\n  margin-left: 35rem !important;\n  margin-right: 35rem !important;\n}\n\n.mx-72 {\n  margin-left: 35.5rem !important;\n  margin-right: 35.5rem !important;\n}\n\n.mx-73 {\n  margin-left: 36rem !important;\n  margin-right: 36rem !important;\n}\n\n.mx-74 {\n  margin-left: 36.5rem !important;\n  margin-right: 36.5rem !important;\n}\n\n.mx-75 {\n  margin-left: 37rem !important;\n  margin-right: 37rem !important;\n}\n\n.mx-76 {\n  margin-left: 37.5rem !important;\n  margin-right: 37.5rem !important;\n}\n\n.mx-77 {\n  margin-left: 38rem !important;\n  margin-right: 38rem !important;\n}\n\n.mx-78 {\n  margin-left: 38.5rem !important;\n  margin-right: 38.5rem !important;\n}\n\n.mx-79 {\n  margin-left: 39rem !important;\n  margin-right: 39rem !important;\n}\n\n.mx-80 {\n  margin-left: 39.5rem !important;\n  margin-right: 39.5rem !important;\n}\n\n.mx-81 {\n  margin-left: 40rem !important;\n  margin-right: 40rem !important;\n}\n\n.mx-82 {\n  margin-left: 40.5rem !important;\n  margin-right: 40.5rem !important;\n}\n\n.mx-83 {\n  margin-left: 41rem !important;\n  margin-right: 41rem !important;\n}\n\n.mx-84 {\n  margin-left: 41.5rem !important;\n  margin-right: 41.5rem !important;\n}\n\n.mx-85 {\n  margin-left: 42rem !important;\n  margin-right: 42rem !important;\n}\n\n.mx-86 {\n  margin-left: 42.5rem !important;\n  margin-right: 42.5rem !important;\n}\n\n.mx-87 {\n  margin-left: 43rem !important;\n  margin-right: 43rem !important;\n}\n\n.mx-88 {\n  margin-left: 43.5rem !important;\n  margin-right: 43.5rem !important;\n}\n\n.mx-89 {\n  margin-left: 44rem !important;\n  margin-right: 44rem !important;\n}\n\n.mx-90 {\n  margin-left: 44.5rem !important;\n  margin-right: 44.5rem !important;\n}\n\n.mx-91 {\n  margin-left: 45rem !important;\n  margin-right: 45rem !important;\n}\n\n.mx-92 {\n  margin-left: 45.5rem !important;\n  margin-right: 45.5rem !important;\n}\n\n.mx-93 {\n  margin-left: 46rem !important;\n  margin-right: 46rem !important;\n}\n\n.mx-94 {\n  margin-left: 46.5rem !important;\n  margin-right: 46.5rem !important;\n}\n\n.mx-95 {\n  margin-left: 47rem !important;\n  margin-right: 47rem !important;\n}\n\n.mx-96 {\n  margin-left: 47.5rem !important;\n  margin-right: 47.5rem !important;\n}\n\n.mx-97 {\n  margin-left: 48rem !important;\n  margin-right: 48rem !important;\n}\n\n.mx-98 {\n  margin-left: 48.5rem !important;\n  margin-right: 48.5rem !important;\n}\n\n.mx-99 {\n  margin-left: 49rem !important;\n  margin-right: 49rem !important;\n}\n\n.mx-100 {\n  margin-left: 49.5rem !important;\n  margin-right: 49.5rem !important;\n}\n\n.mx-101 {\n  margin-left: 50rem !important;\n  margin-right: 50rem !important;\n}\n\n.mx-102 {\n  margin-left: 50.5rem !important;\n  margin-right: 50.5rem !important;\n}\n\n.mx-103 {\n  margin-left: 51rem !important;\n  margin-right: 51rem !important;\n}\n\n.mx-104 {\n  margin-left: 51.5rem !important;\n  margin-right: 51.5rem !important;\n}\n\n.mx-105 {\n  margin-left: 52rem !important;\n  margin-right: 52rem !important;\n}\n\n.mx-106 {\n  margin-left: 52.5rem !important;\n  margin-right: 52.5rem !important;\n}\n\n.mx-107 {\n  margin-left: 53rem !important;\n  margin-right: 53rem !important;\n}\n\n.mx-108 {\n  margin-left: 53.5rem !important;\n  margin-right: 53.5rem !important;\n}\n\n.mx-109 {\n  margin-left: 54rem !important;\n  margin-right: 54rem !important;\n}\n\n.mx-110 {\n  margin-left: 54.5rem !important;\n  margin-right: 54.5rem !important;\n}\n\n.mx-111 {\n  margin-left: 55rem !important;\n  margin-right: 55rem !important;\n}\n\n.mx-112 {\n  margin-left: 55.5rem !important;\n  margin-right: 55.5rem !important;\n}\n\n.mx-113 {\n  margin-left: 56rem !important;\n  margin-right: 56rem !important;\n}\n\n.mx-114 {\n  margin-left: 56.5rem !important;\n  margin-right: 56.5rem !important;\n}\n\n.mx-115 {\n  margin-left: 57rem !important;\n  margin-right: 57rem !important;\n}\n\n.mx-116 {\n  margin-left: 57.5rem !important;\n  margin-right: 57.5rem !important;\n}\n\n.mx-117 {\n  margin-left: 58rem !important;\n  margin-right: 58rem !important;\n}\n\n.mx-118 {\n  margin-left: 58.5rem !important;\n  margin-right: 58.5rem !important;\n}\n\n.mx-119 {\n  margin-left: 59rem !important;\n  margin-right: 59rem !important;\n}\n\n.mx-120 {\n  margin-left: 59.5rem !important;\n  margin-right: 59.5rem !important;\n}\n\n.mx-121 {\n  margin-left: 60rem !important;\n  margin-right: 60rem !important;\n}\n\n.mx-122 {\n  margin-left: 60.5rem !important;\n  margin-right: 60.5rem !important;\n}\n\n.mx-123 {\n  margin-left: 61rem !important;\n  margin-right: 61rem !important;\n}\n\n.mx-124 {\n  margin-left: 61.5rem !important;\n  margin-right: 61.5rem !important;\n}\n\n.mx-125 {\n  margin-left: 62rem !important;\n  margin-right: 62rem !important;\n}\n\n.mx-126 {\n  margin-left: 62.5rem !important;\n  margin-right: 62.5rem !important;\n}\n\n.mx-127 {\n  margin-left: 63rem !important;\n  margin-right: 63rem !important;\n}\n\n.mx-128 {\n  margin-left: 63.5rem !important;\n  margin-right: 63.5rem !important;\n}\n\n.mx-129 {\n  margin-left: 64rem !important;\n  margin-right: 64rem !important;\n}\n\n.mx-130 {\n  margin-left: 64.5rem !important;\n  margin-right: 64.5rem !important;\n}\n\n.mx-131 {\n  margin-left: 65rem !important;\n  margin-right: 65rem !important;\n}\n\n.mx-132 {\n  margin-left: 65.5rem !important;\n  margin-right: 65.5rem !important;\n}\n\n.mx-133 {\n  margin-left: 66rem !important;\n  margin-right: 66rem !important;\n}\n\n.mx-134 {\n  margin-left: 66.5rem !important;\n  margin-right: 66.5rem !important;\n}\n\n.mx-135 {\n  margin-left: 67rem !important;\n  margin-right: 67rem !important;\n}\n\n.mx-136 {\n  margin-left: 67.5rem !important;\n  margin-right: 67.5rem !important;\n}\n\n.mx-137 {\n  margin-left: 68rem !important;\n  margin-right: 68rem !important;\n}\n\n.mx-138 {\n  margin-left: 68.5rem !important;\n  margin-right: 68.5rem !important;\n}\n\n.mx-139 {\n  margin-left: 69rem !important;\n  margin-right: 69rem !important;\n}\n\n.mx-140 {\n  margin-left: 69.5rem !important;\n  margin-right: 69.5rem !important;\n}\n\n.mx-141 {\n  margin-left: 70rem !important;\n  margin-right: 70rem !important;\n}\n\n.mx-142 {\n  margin-left: 70.5rem !important;\n  margin-right: 70.5rem !important;\n}\n\n.mx-143 {\n  margin-left: 71rem !important;\n  margin-right: 71rem !important;\n}\n\n.mx-144 {\n  margin-left: 71.5rem !important;\n  margin-right: 71.5rem !important;\n}\n\n.mx-145 {\n  margin-left: 72rem !important;\n  margin-right: 72rem !important;\n}\n\n.mx-146 {\n  margin-left: 72.5rem !important;\n  margin-right: 72.5rem !important;\n}\n\n.mx-147 {\n  margin-left: 73rem !important;\n  margin-right: 73rem !important;\n}\n\n.mx-148 {\n  margin-left: 73.5rem !important;\n  margin-right: 73.5rem !important;\n}\n\n.mx-149 {\n  margin-left: 74rem !important;\n  margin-right: 74rem !important;\n}\n\n.mx-150 {\n  margin-left: 74.5rem !important;\n  margin-right: 74.5rem !important;\n}\n\n.mx-151 {\n  margin-left: 75rem !important;\n  margin-right: 75rem !important;\n}\n\n.mx-152 {\n  margin-left: 75.5rem !important;\n  margin-right: 75.5rem !important;\n}\n\n.mx-153 {\n  margin-left: 76rem !important;\n  margin-right: 76rem !important;\n}\n\n.mx-154 {\n  margin-left: 76.5rem !important;\n  margin-right: 76.5rem !important;\n}\n\n.mx-155 {\n  margin-left: 77rem !important;\n  margin-right: 77rem !important;\n}\n\n.mx-156 {\n  margin-left: 77.5rem !important;\n  margin-right: 77.5rem !important;\n}\n\n.mx-157 {\n  margin-left: 78rem !important;\n  margin-right: 78rem !important;\n}\n\n.mx-158 {\n  margin-left: 78.5rem !important;\n  margin-right: 78.5rem !important;\n}\n\n.mx-159 {\n  margin-left: 79rem !important;\n  margin-right: 79rem !important;\n}\n\n.mx-160 {\n  margin-left: 79.5rem !important;\n  margin-right: 79.5rem !important;\n}\n\n.my-0 {\n  margin-top: 0rem !important;\n  margin-bottom: 0rem !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n\n.my-6 {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.my-7 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-8 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-9 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-10 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-11 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-12 {\n  margin-top: 5.5rem !important;\n  margin-bottom: 5.5rem !important;\n}\n\n.my-13 {\n  margin-top: 6rem !important;\n  margin-bottom: 6rem !important;\n}\n\n.my-14 {\n  margin-top: 6.5rem !important;\n  margin-bottom: 6.5rem !important;\n}\n\n.my-15 {\n  margin-top: 7rem !important;\n  margin-bottom: 7rem !important;\n}\n\n.my-16 {\n  margin-top: 7.5rem !important;\n  margin-bottom: 7.5rem !important;\n}\n\n.my-17 {\n  margin-top: 8rem !important;\n  margin-bottom: 8rem !important;\n}\n\n.my-18 {\n  margin-top: 8.5rem !important;\n  margin-bottom: 8.5rem !important;\n}\n\n.my-19 {\n  margin-top: 9rem !important;\n  margin-bottom: 9rem !important;\n}\n\n.my-20 {\n  margin-top: 9.5rem !important;\n  margin-bottom: 9.5rem !important;\n}\n\n.my-21 {\n  margin-top: 10rem !important;\n  margin-bottom: 10rem !important;\n}\n\n.my-22 {\n  margin-top: 10.5rem !important;\n  margin-bottom: 10.5rem !important;\n}\n\n.my-23 {\n  margin-top: 11rem !important;\n  margin-bottom: 11rem !important;\n}\n\n.my-24 {\n  margin-top: 11.5rem !important;\n  margin-bottom: 11.5rem !important;\n}\n\n.my-25 {\n  margin-top: 12rem !important;\n  margin-bottom: 12rem !important;\n}\n\n.my-26 {\n  margin-top: 12.5rem !important;\n  margin-bottom: 12.5rem !important;\n}\n\n.my-27 {\n  margin-top: 13rem !important;\n  margin-bottom: 13rem !important;\n}\n\n.my-28 {\n  margin-top: 13.5rem !important;\n  margin-bottom: 13.5rem !important;\n}\n\n.my-29 {\n  margin-top: 14rem !important;\n  margin-bottom: 14rem !important;\n}\n\n.my-30 {\n  margin-top: 14.5rem !important;\n  margin-bottom: 14.5rem !important;\n}\n\n.my-31 {\n  margin-top: 15rem !important;\n  margin-bottom: 15rem !important;\n}\n\n.my-32 {\n  margin-top: 15.5rem !important;\n  margin-bottom: 15.5rem !important;\n}\n\n.my-33 {\n  margin-top: 16rem !important;\n  margin-bottom: 16rem !important;\n}\n\n.my-34 {\n  margin-top: 16.5rem !important;\n  margin-bottom: 16.5rem !important;\n}\n\n.my-35 {\n  margin-top: 17rem !important;\n  margin-bottom: 17rem !important;\n}\n\n.my-36 {\n  margin-top: 17.5rem !important;\n  margin-bottom: 17.5rem !important;\n}\n\n.my-37 {\n  margin-top: 18rem !important;\n  margin-bottom: 18rem !important;\n}\n\n.my-38 {\n  margin-top: 18.5rem !important;\n  margin-bottom: 18.5rem !important;\n}\n\n.my-39 {\n  margin-top: 19rem !important;\n  margin-bottom: 19rem !important;\n}\n\n.my-40 {\n  margin-top: 19.5rem !important;\n  margin-bottom: 19.5rem !important;\n}\n\n.my-41 {\n  margin-top: 20rem !important;\n  margin-bottom: 20rem !important;\n}\n\n.my-42 {\n  margin-top: 20.5rem !important;\n  margin-bottom: 20.5rem !important;\n}\n\n.my-43 {\n  margin-top: 21rem !important;\n  margin-bottom: 21rem !important;\n}\n\n.my-44 {\n  margin-top: 21.5rem !important;\n  margin-bottom: 21.5rem !important;\n}\n\n.my-45 {\n  margin-top: 22rem !important;\n  margin-bottom: 22rem !important;\n}\n\n.my-46 {\n  margin-top: 22.5rem !important;\n  margin-bottom: 22.5rem !important;\n}\n\n.my-47 {\n  margin-top: 23rem !important;\n  margin-bottom: 23rem !important;\n}\n\n.my-48 {\n  margin-top: 23.5rem !important;\n  margin-bottom: 23.5rem !important;\n}\n\n.my-49 {\n  margin-top: 24rem !important;\n  margin-bottom: 24rem !important;\n}\n\n.my-50 {\n  margin-top: 24.5rem !important;\n  margin-bottom: 24.5rem !important;\n}\n\n.my-51 {\n  margin-top: 25rem !important;\n  margin-bottom: 25rem !important;\n}\n\n.my-52 {\n  margin-top: 25.5rem !important;\n  margin-bottom: 25.5rem !important;\n}\n\n.my-53 {\n  margin-top: 26rem !important;\n  margin-bottom: 26rem !important;\n}\n\n.my-54 {\n  margin-top: 26.5rem !important;\n  margin-bottom: 26.5rem !important;\n}\n\n.my-55 {\n  margin-top: 27rem !important;\n  margin-bottom: 27rem !important;\n}\n\n.my-56 {\n  margin-top: 27.5rem !important;\n  margin-bottom: 27.5rem !important;\n}\n\n.my-57 {\n  margin-top: 28rem !important;\n  margin-bottom: 28rem !important;\n}\n\n.my-58 {\n  margin-top: 28.5rem !important;\n  margin-bottom: 28.5rem !important;\n}\n\n.my-59 {\n  margin-top: 29rem !important;\n  margin-bottom: 29rem !important;\n}\n\n.my-60 {\n  margin-top: 29.5rem !important;\n  margin-bottom: 29.5rem !important;\n}\n\n.my-61 {\n  margin-top: 30rem !important;\n  margin-bottom: 30rem !important;\n}\n\n.my-62 {\n  margin-top: 30.5rem !important;\n  margin-bottom: 30.5rem !important;\n}\n\n.my-63 {\n  margin-top: 31rem !important;\n  margin-bottom: 31rem !important;\n}\n\n.my-64 {\n  margin-top: 31.5rem !important;\n  margin-bottom: 31.5rem !important;\n}\n\n.my-65 {\n  margin-top: 32rem !important;\n  margin-bottom: 32rem !important;\n}\n\n.my-66 {\n  margin-top: 32.5rem !important;\n  margin-bottom: 32.5rem !important;\n}\n\n.my-67 {\n  margin-top: 33rem !important;\n  margin-bottom: 33rem !important;\n}\n\n.my-68 {\n  margin-top: 33.5rem !important;\n  margin-bottom: 33.5rem !important;\n}\n\n.my-69 {\n  margin-top: 34rem !important;\n  margin-bottom: 34rem !important;\n}\n\n.my-70 {\n  margin-top: 34.5rem !important;\n  margin-bottom: 34.5rem !important;\n}\n\n.my-71 {\n  margin-top: 35rem !important;\n  margin-bottom: 35rem !important;\n}\n\n.my-72 {\n  margin-top: 35.5rem !important;\n  margin-bottom: 35.5rem !important;\n}\n\n.my-73 {\n  margin-top: 36rem !important;\n  margin-bottom: 36rem !important;\n}\n\n.my-74 {\n  margin-top: 36.5rem !important;\n  margin-bottom: 36.5rem !important;\n}\n\n.my-75 {\n  margin-top: 37rem !important;\n  margin-bottom: 37rem !important;\n}\n\n.my-76 {\n  margin-top: 37.5rem !important;\n  margin-bottom: 37.5rem !important;\n}\n\n.my-77 {\n  margin-top: 38rem !important;\n  margin-bottom: 38rem !important;\n}\n\n.my-78 {\n  margin-top: 38.5rem !important;\n  margin-bottom: 38.5rem !important;\n}\n\n.my-79 {\n  margin-top: 39rem !important;\n  margin-bottom: 39rem !important;\n}\n\n.my-80 {\n  margin-top: 39.5rem !important;\n  margin-bottom: 39.5rem !important;\n}\n\n.my-81 {\n  margin-top: 40rem !important;\n  margin-bottom: 40rem !important;\n}\n\n.my-82 {\n  margin-top: 40.5rem !important;\n  margin-bottom: 40.5rem !important;\n}\n\n.my-83 {\n  margin-top: 41rem !important;\n  margin-bottom: 41rem !important;\n}\n\n.my-84 {\n  margin-top: 41.5rem !important;\n  margin-bottom: 41.5rem !important;\n}\n\n.my-85 {\n  margin-top: 42rem !important;\n  margin-bottom: 42rem !important;\n}\n\n.my-86 {\n  margin-top: 42.5rem !important;\n  margin-bottom: 42.5rem !important;\n}\n\n.my-87 {\n  margin-top: 43rem !important;\n  margin-bottom: 43rem !important;\n}\n\n.my-88 {\n  margin-top: 43.5rem !important;\n  margin-bottom: 43.5rem !important;\n}\n\n.my-89 {\n  margin-top: 44rem !important;\n  margin-bottom: 44rem !important;\n}\n\n.my-90 {\n  margin-top: 44.5rem !important;\n  margin-bottom: 44.5rem !important;\n}\n\n.my-91 {\n  margin-top: 45rem !important;\n  margin-bottom: 45rem !important;\n}\n\n.my-92 {\n  margin-top: 45.5rem !important;\n  margin-bottom: 45.5rem !important;\n}\n\n.my-93 {\n  margin-top: 46rem !important;\n  margin-bottom: 46rem !important;\n}\n\n.my-94 {\n  margin-top: 46.5rem !important;\n  margin-bottom: 46.5rem !important;\n}\n\n.my-95 {\n  margin-top: 47rem !important;\n  margin-bottom: 47rem !important;\n}\n\n.my-96 {\n  margin-top: 47.5rem !important;\n  margin-bottom: 47.5rem !important;\n}\n\n.my-97 {\n  margin-top: 48rem !important;\n  margin-bottom: 48rem !important;\n}\n\n.my-98 {\n  margin-top: 48.5rem !important;\n  margin-bottom: 48.5rem !important;\n}\n\n.my-99 {\n  margin-top: 49rem !important;\n  margin-bottom: 49rem !important;\n}\n\n.my-100 {\n  margin-top: 49.5rem !important;\n  margin-bottom: 49.5rem !important;\n}\n\n.my-101 {\n  margin-top: 50rem !important;\n  margin-bottom: 50rem !important;\n}\n\n.my-102 {\n  margin-top: 50.5rem !important;\n  margin-bottom: 50.5rem !important;\n}\n\n.my-103 {\n  margin-top: 51rem !important;\n  margin-bottom: 51rem !important;\n}\n\n.my-104 {\n  margin-top: 51.5rem !important;\n  margin-bottom: 51.5rem !important;\n}\n\n.my-105 {\n  margin-top: 52rem !important;\n  margin-bottom: 52rem !important;\n}\n\n.my-106 {\n  margin-top: 52.5rem !important;\n  margin-bottom: 52.5rem !important;\n}\n\n.my-107 {\n  margin-top: 53rem !important;\n  margin-bottom: 53rem !important;\n}\n\n.my-108 {\n  margin-top: 53.5rem !important;\n  margin-bottom: 53.5rem !important;\n}\n\n.my-109 {\n  margin-top: 54rem !important;\n  margin-bottom: 54rem !important;\n}\n\n.my-110 {\n  margin-top: 54.5rem !important;\n  margin-bottom: 54.5rem !important;\n}\n\n.my-111 {\n  margin-top: 55rem !important;\n  margin-bottom: 55rem !important;\n}\n\n.my-112 {\n  margin-top: 55.5rem !important;\n  margin-bottom: 55.5rem !important;\n}\n\n.my-113 {\n  margin-top: 56rem !important;\n  margin-bottom: 56rem !important;\n}\n\n.my-114 {\n  margin-top: 56.5rem !important;\n  margin-bottom: 56.5rem !important;\n}\n\n.my-115 {\n  margin-top: 57rem !important;\n  margin-bottom: 57rem !important;\n}\n\n.my-116 {\n  margin-top: 57.5rem !important;\n  margin-bottom: 57.5rem !important;\n}\n\n.my-117 {\n  margin-top: 58rem !important;\n  margin-bottom: 58rem !important;\n}\n\n.my-118 {\n  margin-top: 58.5rem !important;\n  margin-bottom: 58.5rem !important;\n}\n\n.my-119 {\n  margin-top: 59rem !important;\n  margin-bottom: 59rem !important;\n}\n\n.my-120 {\n  margin-top: 59.5rem !important;\n  margin-bottom: 59.5rem !important;\n}\n\n.my-121 {\n  margin-top: 60rem !important;\n  margin-bottom: 60rem !important;\n}\n\n.my-122 {\n  margin-top: 60.5rem !important;\n  margin-bottom: 60.5rem !important;\n}\n\n.my-123 {\n  margin-top: 61rem !important;\n  margin-bottom: 61rem !important;\n}\n\n.my-124 {\n  margin-top: 61.5rem !important;\n  margin-bottom: 61.5rem !important;\n}\n\n.my-125 {\n  margin-top: 62rem !important;\n  margin-bottom: 62rem !important;\n}\n\n.my-126 {\n  margin-top: 62.5rem !important;\n  margin-bottom: 62.5rem !important;\n}\n\n.my-127 {\n  margin-top: 63rem !important;\n  margin-bottom: 63rem !important;\n}\n\n.my-128 {\n  margin-top: 63.5rem !important;\n  margin-bottom: 63.5rem !important;\n}\n\n.my-129 {\n  margin-top: 64rem !important;\n  margin-bottom: 64rem !important;\n}\n\n.my-130 {\n  margin-top: 64.5rem !important;\n  margin-bottom: 64.5rem !important;\n}\n\n.my-131 {\n  margin-top: 65rem !important;\n  margin-bottom: 65rem !important;\n}\n\n.my-132 {\n  margin-top: 65.5rem !important;\n  margin-bottom: 65.5rem !important;\n}\n\n.my-133 {\n  margin-top: 66rem !important;\n  margin-bottom: 66rem !important;\n}\n\n.my-134 {\n  margin-top: 66.5rem !important;\n  margin-bottom: 66.5rem !important;\n}\n\n.my-135 {\n  margin-top: 67rem !important;\n  margin-bottom: 67rem !important;\n}\n\n.my-136 {\n  margin-top: 67.5rem !important;\n  margin-bottom: 67.5rem !important;\n}\n\n.my-137 {\n  margin-top: 68rem !important;\n  margin-bottom: 68rem !important;\n}\n\n.my-138 {\n  margin-top: 68.5rem !important;\n  margin-bottom: 68.5rem !important;\n}\n\n.my-139 {\n  margin-top: 69rem !important;\n  margin-bottom: 69rem !important;\n}\n\n.my-140 {\n  margin-top: 69.5rem !important;\n  margin-bottom: 69.5rem !important;\n}\n\n.my-141 {\n  margin-top: 70rem !important;\n  margin-bottom: 70rem !important;\n}\n\n.my-142 {\n  margin-top: 70.5rem !important;\n  margin-bottom: 70.5rem !important;\n}\n\n.my-143 {\n  margin-top: 71rem !important;\n  margin-bottom: 71rem !important;\n}\n\n.my-144 {\n  margin-top: 71.5rem !important;\n  margin-bottom: 71.5rem !important;\n}\n\n.my-145 {\n  margin-top: 72rem !important;\n  margin-bottom: 72rem !important;\n}\n\n.my-146 {\n  margin-top: 72.5rem !important;\n  margin-bottom: 72.5rem !important;\n}\n\n.my-147 {\n  margin-top: 73rem !important;\n  margin-bottom: 73rem !important;\n}\n\n.my-148 {\n  margin-top: 73.5rem !important;\n  margin-bottom: 73.5rem !important;\n}\n\n.my-149 {\n  margin-top: 74rem !important;\n  margin-bottom: 74rem !important;\n}\n\n.my-150 {\n  margin-top: 74.5rem !important;\n  margin-bottom: 74.5rem !important;\n}\n\n.my-151 {\n  margin-top: 75rem !important;\n  margin-bottom: 75rem !important;\n}\n\n.my-152 {\n  margin-top: 75.5rem !important;\n  margin-bottom: 75.5rem !important;\n}\n\n.my-153 {\n  margin-top: 76rem !important;\n  margin-bottom: 76rem !important;\n}\n\n.my-154 {\n  margin-top: 76.5rem !important;\n  margin-bottom: 76.5rem !important;\n}\n\n.my-155 {\n  margin-top: 77rem !important;\n  margin-bottom: 77rem !important;\n}\n\n.my-156 {\n  margin-top: 77.5rem !important;\n  margin-bottom: 77.5rem !important;\n}\n\n.my-157 {\n  margin-top: 78rem !important;\n  margin-bottom: 78rem !important;\n}\n\n.my-158 {\n  margin-top: 78.5rem !important;\n  margin-bottom: 78.5rem !important;\n}\n\n.my-159 {\n  margin-top: 79rem !important;\n  margin-bottom: 79rem !important;\n}\n\n.my-160 {\n  margin-top: 79.5rem !important;\n  margin-bottom: 79.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0rem !important;\n  }\n\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-sm-5 {\n    margin: 2rem !important;\n  }\n\n  .m-sm-6 {\n    margin: 2.5rem !important;\n  }\n\n  .m-sm-7 {\n    margin: 3rem !important;\n  }\n\n  .m-sm-8 {\n    margin: 3.5rem !important;\n  }\n\n  .m-sm-9 {\n    margin: 4rem !important;\n  }\n\n  .m-sm-10 {\n    margin: 4.5rem !important;\n  }\n\n  .m-sm-11 {\n    margin: 5rem !important;\n  }\n\n  .m-sm-12 {\n    margin: 5.5rem !important;\n  }\n\n  .m-sm-13 {\n    margin: 6rem !important;\n  }\n\n  .m-sm-14 {\n    margin: 6.5rem !important;\n  }\n\n  .m-sm-15 {\n    margin: 7rem !important;\n  }\n\n  .m-sm-16 {\n    margin: 7.5rem !important;\n  }\n\n  .m-sm-17 {\n    margin: 8rem !important;\n  }\n\n  .m-sm-18 {\n    margin: 8.5rem !important;\n  }\n\n  .m-sm-19 {\n    margin: 9rem !important;\n  }\n\n  .m-sm-20 {\n    margin: 9.5rem !important;\n  }\n\n  .m-sm-21 {\n    margin: 10rem !important;\n  }\n\n  .m-sm-22 {\n    margin: 10.5rem !important;\n  }\n\n  .m-sm-23 {\n    margin: 11rem !important;\n  }\n\n  .m-sm-24 {\n    margin: 11.5rem !important;\n  }\n\n  .m-sm-25 {\n    margin: 12rem !important;\n  }\n\n  .m-sm-26 {\n    margin: 12.5rem !important;\n  }\n\n  .m-sm-27 {\n    margin: 13rem !important;\n  }\n\n  .m-sm-28 {\n    margin: 13.5rem !important;\n  }\n\n  .m-sm-29 {\n    margin: 14rem !important;\n  }\n\n  .m-sm-30 {\n    margin: 14.5rem !important;\n  }\n\n  .m-sm-31 {\n    margin: 15rem !important;\n  }\n\n  .m-sm-32 {\n    margin: 15.5rem !important;\n  }\n\n  .m-sm-33 {\n    margin: 16rem !important;\n  }\n\n  .m-sm-34 {\n    margin: 16.5rem !important;\n  }\n\n  .m-sm-35 {\n    margin: 17rem !important;\n  }\n\n  .m-sm-36 {\n    margin: 17.5rem !important;\n  }\n\n  .m-sm-37 {\n    margin: 18rem !important;\n  }\n\n  .m-sm-38 {\n    margin: 18.5rem !important;\n  }\n\n  .m-sm-39 {\n    margin: 19rem !important;\n  }\n\n  .m-sm-40 {\n    margin: 19.5rem !important;\n  }\n\n  .m-sm-41 {\n    margin: 20rem !important;\n  }\n\n  .m-sm-42 {\n    margin: 20.5rem !important;\n  }\n\n  .m-sm-43 {\n    margin: 21rem !important;\n  }\n\n  .m-sm-44 {\n    margin: 21.5rem !important;\n  }\n\n  .m-sm-45 {\n    margin: 22rem !important;\n  }\n\n  .m-sm-46 {\n    margin: 22.5rem !important;\n  }\n\n  .m-sm-47 {\n    margin: 23rem !important;\n  }\n\n  .m-sm-48 {\n    margin: 23.5rem !important;\n  }\n\n  .m-sm-49 {\n    margin: 24rem !important;\n  }\n\n  .m-sm-50 {\n    margin: 24.5rem !important;\n  }\n\n  .m-sm-51 {\n    margin: 25rem !important;\n  }\n\n  .m-sm-52 {\n    margin: 25.5rem !important;\n  }\n\n  .m-sm-53 {\n    margin: 26rem !important;\n  }\n\n  .m-sm-54 {\n    margin: 26.5rem !important;\n  }\n\n  .m-sm-55 {\n    margin: 27rem !important;\n  }\n\n  .m-sm-56 {\n    margin: 27.5rem !important;\n  }\n\n  .m-sm-57 {\n    margin: 28rem !important;\n  }\n\n  .m-sm-58 {\n    margin: 28.5rem !important;\n  }\n\n  .m-sm-59 {\n    margin: 29rem !important;\n  }\n\n  .m-sm-60 {\n    margin: 29.5rem !important;\n  }\n\n  .m-sm-61 {\n    margin: 30rem !important;\n  }\n\n  .m-sm-62 {\n    margin: 30.5rem !important;\n  }\n\n  .m-sm-63 {\n    margin: 31rem !important;\n  }\n\n  .m-sm-64 {\n    margin: 31.5rem !important;\n  }\n\n  .m-sm-65 {\n    margin: 32rem !important;\n  }\n\n  .m-sm-66 {\n    margin: 32.5rem !important;\n  }\n\n  .m-sm-67 {\n    margin: 33rem !important;\n  }\n\n  .m-sm-68 {\n    margin: 33.5rem !important;\n  }\n\n  .m-sm-69 {\n    margin: 34rem !important;\n  }\n\n  .m-sm-70 {\n    margin: 34.5rem !important;\n  }\n\n  .m-sm-71 {\n    margin: 35rem !important;\n  }\n\n  .m-sm-72 {\n    margin: 35.5rem !important;\n  }\n\n  .m-sm-73 {\n    margin: 36rem !important;\n  }\n\n  .m-sm-74 {\n    margin: 36.5rem !important;\n  }\n\n  .m-sm-75 {\n    margin: 37rem !important;\n  }\n\n  .m-sm-76 {\n    margin: 37.5rem !important;\n  }\n\n  .m-sm-77 {\n    margin: 38rem !important;\n  }\n\n  .m-sm-78 {\n    margin: 38.5rem !important;\n  }\n\n  .m-sm-79 {\n    margin: 39rem !important;\n  }\n\n  .m-sm-80 {\n    margin: 39.5rem !important;\n  }\n\n  .m-sm-81 {\n    margin: 40rem !important;\n  }\n\n  .m-sm-82 {\n    margin: 40.5rem !important;\n  }\n\n  .m-sm-83 {\n    margin: 41rem !important;\n  }\n\n  .m-sm-84 {\n    margin: 41.5rem !important;\n  }\n\n  .m-sm-85 {\n    margin: 42rem !important;\n  }\n\n  .m-sm-86 {\n    margin: 42.5rem !important;\n  }\n\n  .m-sm-87 {\n    margin: 43rem !important;\n  }\n\n  .m-sm-88 {\n    margin: 43.5rem !important;\n  }\n\n  .m-sm-89 {\n    margin: 44rem !important;\n  }\n\n  .m-sm-90 {\n    margin: 44.5rem !important;\n  }\n\n  .m-sm-91 {\n    margin: 45rem !important;\n  }\n\n  .m-sm-92 {\n    margin: 45.5rem !important;\n  }\n\n  .m-sm-93 {\n    margin: 46rem !important;\n  }\n\n  .m-sm-94 {\n    margin: 46.5rem !important;\n  }\n\n  .m-sm-95 {\n    margin: 47rem !important;\n  }\n\n  .m-sm-96 {\n    margin: 47.5rem !important;\n  }\n\n  .m-sm-97 {\n    margin: 48rem !important;\n  }\n\n  .m-sm-98 {\n    margin: 48.5rem !important;\n  }\n\n  .m-sm-99 {\n    margin: 49rem !important;\n  }\n\n  .m-sm-100 {\n    margin: 49.5rem !important;\n  }\n\n  .m-sm-101 {\n    margin: 50rem !important;\n  }\n\n  .m-sm-102 {\n    margin: 50.5rem !important;\n  }\n\n  .m-sm-103 {\n    margin: 51rem !important;\n  }\n\n  .m-sm-104 {\n    margin: 51.5rem !important;\n  }\n\n  .m-sm-105 {\n    margin: 52rem !important;\n  }\n\n  .m-sm-106 {\n    margin: 52.5rem !important;\n  }\n\n  .m-sm-107 {\n    margin: 53rem !important;\n  }\n\n  .m-sm-108 {\n    margin: 53.5rem !important;\n  }\n\n  .m-sm-109 {\n    margin: 54rem !important;\n  }\n\n  .m-sm-110 {\n    margin: 54.5rem !important;\n  }\n\n  .m-sm-111 {\n    margin: 55rem !important;\n  }\n\n  .m-sm-112 {\n    margin: 55.5rem !important;\n  }\n\n  .m-sm-113 {\n    margin: 56rem !important;\n  }\n\n  .m-sm-114 {\n    margin: 56.5rem !important;\n  }\n\n  .m-sm-115 {\n    margin: 57rem !important;\n  }\n\n  .m-sm-116 {\n    margin: 57.5rem !important;\n  }\n\n  .m-sm-117 {\n    margin: 58rem !important;\n  }\n\n  .m-sm-118 {\n    margin: 58.5rem !important;\n  }\n\n  .m-sm-119 {\n    margin: 59rem !important;\n  }\n\n  .m-sm-120 {\n    margin: 59.5rem !important;\n  }\n\n  .m-sm-121 {\n    margin: 60rem !important;\n  }\n\n  .m-sm-122 {\n    margin: 60.5rem !important;\n  }\n\n  .m-sm-123 {\n    margin: 61rem !important;\n  }\n\n  .m-sm-124 {\n    margin: 61.5rem !important;\n  }\n\n  .m-sm-125 {\n    margin: 62rem !important;\n  }\n\n  .m-sm-126 {\n    margin: 62.5rem !important;\n  }\n\n  .m-sm-127 {\n    margin: 63rem !important;\n  }\n\n  .m-sm-128 {\n    margin: 63.5rem !important;\n  }\n\n  .m-sm-129 {\n    margin: 64rem !important;\n  }\n\n  .m-sm-130 {\n    margin: 64.5rem !important;\n  }\n\n  .m-sm-131 {\n    margin: 65rem !important;\n  }\n\n  .m-sm-132 {\n    margin: 65.5rem !important;\n  }\n\n  .m-sm-133 {\n    margin: 66rem !important;\n  }\n\n  .m-sm-134 {\n    margin: 66.5rem !important;\n  }\n\n  .m-sm-135 {\n    margin: 67rem !important;\n  }\n\n  .m-sm-136 {\n    margin: 67.5rem !important;\n  }\n\n  .m-sm-137 {\n    margin: 68rem !important;\n  }\n\n  .m-sm-138 {\n    margin: 68.5rem !important;\n  }\n\n  .m-sm-139 {\n    margin: 69rem !important;\n  }\n\n  .m-sm-140 {\n    margin: 69.5rem !important;\n  }\n\n  .m-sm-141 {\n    margin: 70rem !important;\n  }\n\n  .m-sm-142 {\n    margin: 70.5rem !important;\n  }\n\n  .m-sm-143 {\n    margin: 71rem !important;\n  }\n\n  .m-sm-144 {\n    margin: 71.5rem !important;\n  }\n\n  .m-sm-145 {\n    margin: 72rem !important;\n  }\n\n  .m-sm-146 {\n    margin: 72.5rem !important;\n  }\n\n  .m-sm-147 {\n    margin: 73rem !important;\n  }\n\n  .m-sm-148 {\n    margin: 73.5rem !important;\n  }\n\n  .m-sm-149 {\n    margin: 74rem !important;\n  }\n\n  .m-sm-150 {\n    margin: 74.5rem !important;\n  }\n\n  .m-sm-151 {\n    margin: 75rem !important;\n  }\n\n  .m-sm-152 {\n    margin: 75.5rem !important;\n  }\n\n  .m-sm-153 {\n    margin: 76rem !important;\n  }\n\n  .m-sm-154 {\n    margin: 76.5rem !important;\n  }\n\n  .m-sm-155 {\n    margin: 77rem !important;\n  }\n\n  .m-sm-156 {\n    margin: 77.5rem !important;\n  }\n\n  .m-sm-157 {\n    margin: 78rem !important;\n  }\n\n  .m-sm-158 {\n    margin: 78.5rem !important;\n  }\n\n  .m-sm-159 {\n    margin: 79rem !important;\n  }\n\n  .m-sm-160 {\n    margin: 79.5rem !important;\n  }\n\n  .mt-sm-0 {\n    margin-top: 0rem !important;\n  }\n\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-sm-5 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-sm-6 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-sm-7 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-sm-8 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-sm-9 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-sm-10 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-sm-11 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-sm-12 {\n    margin-top: 5.5rem !important;\n  }\n\n  .mt-sm-13 {\n    margin-top: 6rem !important;\n  }\n\n  .mt-sm-14 {\n    margin-top: 6.5rem !important;\n  }\n\n  .mt-sm-15 {\n    margin-top: 7rem !important;\n  }\n\n  .mt-sm-16 {\n    margin-top: 7.5rem !important;\n  }\n\n  .mt-sm-17 {\n    margin-top: 8rem !important;\n  }\n\n  .mt-sm-18 {\n    margin-top: 8.5rem !important;\n  }\n\n  .mt-sm-19 {\n    margin-top: 9rem !important;\n  }\n\n  .mt-sm-20 {\n    margin-top: 9.5rem !important;\n  }\n\n  .mt-sm-21 {\n    margin-top: 10rem !important;\n  }\n\n  .mt-sm-22 {\n    margin-top: 10.5rem !important;\n  }\n\n  .mt-sm-23 {\n    margin-top: 11rem !important;\n  }\n\n  .mt-sm-24 {\n    margin-top: 11.5rem !important;\n  }\n\n  .mt-sm-25 {\n    margin-top: 12rem !important;\n  }\n\n  .mt-sm-26 {\n    margin-top: 12.5rem !important;\n  }\n\n  .mt-sm-27 {\n    margin-top: 13rem !important;\n  }\n\n  .mt-sm-28 {\n    margin-top: 13.5rem !important;\n  }\n\n  .mt-sm-29 {\n    margin-top: 14rem !important;\n  }\n\n  .mt-sm-30 {\n    margin-top: 14.5rem !important;\n  }\n\n  .mt-sm-31 {\n    margin-top: 15rem !important;\n  }\n\n  .mt-sm-32 {\n    margin-top: 15.5rem !important;\n  }\n\n  .mt-sm-33 {\n    margin-top: 16rem !important;\n  }\n\n  .mt-sm-34 {\n    margin-top: 16.5rem !important;\n  }\n\n  .mt-sm-35 {\n    margin-top: 17rem !important;\n  }\n\n  .mt-sm-36 {\n    margin-top: 17.5rem !important;\n  }\n\n  .mt-sm-37 {\n    margin-top: 18rem !important;\n  }\n\n  .mt-sm-38 {\n    margin-top: 18.5rem !important;\n  }\n\n  .mt-sm-39 {\n    margin-top: 19rem !important;\n  }\n\n  .mt-sm-40 {\n    margin-top: 19.5rem !important;\n  }\n\n  .mt-sm-41 {\n    margin-top: 20rem !important;\n  }\n\n  .mt-sm-42 {\n    margin-top: 20.5rem !important;\n  }\n\n  .mt-sm-43 {\n    margin-top: 21rem !important;\n  }\n\n  .mt-sm-44 {\n    margin-top: 21.5rem !important;\n  }\n\n  .mt-sm-45 {\n    margin-top: 22rem !important;\n  }\n\n  .mt-sm-46 {\n    margin-top: 22.5rem !important;\n  }\n\n  .mt-sm-47 {\n    margin-top: 23rem !important;\n  }\n\n  .mt-sm-48 {\n    margin-top: 23.5rem !important;\n  }\n\n  .mt-sm-49 {\n    margin-top: 24rem !important;\n  }\n\n  .mt-sm-50 {\n    margin-top: 24.5rem !important;\n  }\n\n  .mt-sm-51 {\n    margin-top: 25rem !important;\n  }\n\n  .mt-sm-52 {\n    margin-top: 25.5rem !important;\n  }\n\n  .mt-sm-53 {\n    margin-top: 26rem !important;\n  }\n\n  .mt-sm-54 {\n    margin-top: 26.5rem !important;\n  }\n\n  .mt-sm-55 {\n    margin-top: 27rem !important;\n  }\n\n  .mt-sm-56 {\n    margin-top: 27.5rem !important;\n  }\n\n  .mt-sm-57 {\n    margin-top: 28rem !important;\n  }\n\n  .mt-sm-58 {\n    margin-top: 28.5rem !important;\n  }\n\n  .mt-sm-59 {\n    margin-top: 29rem !important;\n  }\n\n  .mt-sm-60 {\n    margin-top: 29.5rem !important;\n  }\n\n  .mt-sm-61 {\n    margin-top: 30rem !important;\n  }\n\n  .mt-sm-62 {\n    margin-top: 30.5rem !important;\n  }\n\n  .mt-sm-63 {\n    margin-top: 31rem !important;\n  }\n\n  .mt-sm-64 {\n    margin-top: 31.5rem !important;\n  }\n\n  .mt-sm-65 {\n    margin-top: 32rem !important;\n  }\n\n  .mt-sm-66 {\n    margin-top: 32.5rem !important;\n  }\n\n  .mt-sm-67 {\n    margin-top: 33rem !important;\n  }\n\n  .mt-sm-68 {\n    margin-top: 33.5rem !important;\n  }\n\n  .mt-sm-69 {\n    margin-top: 34rem !important;\n  }\n\n  .mt-sm-70 {\n    margin-top: 34.5rem !important;\n  }\n\n  .mt-sm-71 {\n    margin-top: 35rem !important;\n  }\n\n  .mt-sm-72 {\n    margin-top: 35.5rem !important;\n  }\n\n  .mt-sm-73 {\n    margin-top: 36rem !important;\n  }\n\n  .mt-sm-74 {\n    margin-top: 36.5rem !important;\n  }\n\n  .mt-sm-75 {\n    margin-top: 37rem !important;\n  }\n\n  .mt-sm-76 {\n    margin-top: 37.5rem !important;\n  }\n\n  .mt-sm-77 {\n    margin-top: 38rem !important;\n  }\n\n  .mt-sm-78 {\n    margin-top: 38.5rem !important;\n  }\n\n  .mt-sm-79 {\n    margin-top: 39rem !important;\n  }\n\n  .mt-sm-80 {\n    margin-top: 39.5rem !important;\n  }\n\n  .mt-sm-81 {\n    margin-top: 40rem !important;\n  }\n\n  .mt-sm-82 {\n    margin-top: 40.5rem !important;\n  }\n\n  .mt-sm-83 {\n    margin-top: 41rem !important;\n  }\n\n  .mt-sm-84 {\n    margin-top: 41.5rem !important;\n  }\n\n  .mt-sm-85 {\n    margin-top: 42rem !important;\n  }\n\n  .mt-sm-86 {\n    margin-top: 42.5rem !important;\n  }\n\n  .mt-sm-87 {\n    margin-top: 43rem !important;\n  }\n\n  .mt-sm-88 {\n    margin-top: 43.5rem !important;\n  }\n\n  .mt-sm-89 {\n    margin-top: 44rem !important;\n  }\n\n  .mt-sm-90 {\n    margin-top: 44.5rem !important;\n  }\n\n  .mt-sm-91 {\n    margin-top: 45rem !important;\n  }\n\n  .mt-sm-92 {\n    margin-top: 45.5rem !important;\n  }\n\n  .mt-sm-93 {\n    margin-top: 46rem !important;\n  }\n\n  .mt-sm-94 {\n    margin-top: 46.5rem !important;\n  }\n\n  .mt-sm-95 {\n    margin-top: 47rem !important;\n  }\n\n  .mt-sm-96 {\n    margin-top: 47.5rem !important;\n  }\n\n  .mt-sm-97 {\n    margin-top: 48rem !important;\n  }\n\n  .mt-sm-98 {\n    margin-top: 48.5rem !important;\n  }\n\n  .mt-sm-99 {\n    margin-top: 49rem !important;\n  }\n\n  .mt-sm-100 {\n    margin-top: 49.5rem !important;\n  }\n\n  .mt-sm-101 {\n    margin-top: 50rem !important;\n  }\n\n  .mt-sm-102 {\n    margin-top: 50.5rem !important;\n  }\n\n  .mt-sm-103 {\n    margin-top: 51rem !important;\n  }\n\n  .mt-sm-104 {\n    margin-top: 51.5rem !important;\n  }\n\n  .mt-sm-105 {\n    margin-top: 52rem !important;\n  }\n\n  .mt-sm-106 {\n    margin-top: 52.5rem !important;\n  }\n\n  .mt-sm-107 {\n    margin-top: 53rem !important;\n  }\n\n  .mt-sm-108 {\n    margin-top: 53.5rem !important;\n  }\n\n  .mt-sm-109 {\n    margin-top: 54rem !important;\n  }\n\n  .mt-sm-110 {\n    margin-top: 54.5rem !important;\n  }\n\n  .mt-sm-111 {\n    margin-top: 55rem !important;\n  }\n\n  .mt-sm-112 {\n    margin-top: 55.5rem !important;\n  }\n\n  .mt-sm-113 {\n    margin-top: 56rem !important;\n  }\n\n  .mt-sm-114 {\n    margin-top: 56.5rem !important;\n  }\n\n  .mt-sm-115 {\n    margin-top: 57rem !important;\n  }\n\n  .mt-sm-116 {\n    margin-top: 57.5rem !important;\n  }\n\n  .mt-sm-117 {\n    margin-top: 58rem !important;\n  }\n\n  .mt-sm-118 {\n    margin-top: 58.5rem !important;\n  }\n\n  .mt-sm-119 {\n    margin-top: 59rem !important;\n  }\n\n  .mt-sm-120 {\n    margin-top: 59.5rem !important;\n  }\n\n  .mt-sm-121 {\n    margin-top: 60rem !important;\n  }\n\n  .mt-sm-122 {\n    margin-top: 60.5rem !important;\n  }\n\n  .mt-sm-123 {\n    margin-top: 61rem !important;\n  }\n\n  .mt-sm-124 {\n    margin-top: 61.5rem !important;\n  }\n\n  .mt-sm-125 {\n    margin-top: 62rem !important;\n  }\n\n  .mt-sm-126 {\n    margin-top: 62.5rem !important;\n  }\n\n  .mt-sm-127 {\n    margin-top: 63rem !important;\n  }\n\n  .mt-sm-128 {\n    margin-top: 63.5rem !important;\n  }\n\n  .mt-sm-129 {\n    margin-top: 64rem !important;\n  }\n\n  .mt-sm-130 {\n    margin-top: 64.5rem !important;\n  }\n\n  .mt-sm-131 {\n    margin-top: 65rem !important;\n  }\n\n  .mt-sm-132 {\n    margin-top: 65.5rem !important;\n  }\n\n  .mt-sm-133 {\n    margin-top: 66rem !important;\n  }\n\n  .mt-sm-134 {\n    margin-top: 66.5rem !important;\n  }\n\n  .mt-sm-135 {\n    margin-top: 67rem !important;\n  }\n\n  .mt-sm-136 {\n    margin-top: 67.5rem !important;\n  }\n\n  .mt-sm-137 {\n    margin-top: 68rem !important;\n  }\n\n  .mt-sm-138 {\n    margin-top: 68.5rem !important;\n  }\n\n  .mt-sm-139 {\n    margin-top: 69rem !important;\n  }\n\n  .mt-sm-140 {\n    margin-top: 69.5rem !important;\n  }\n\n  .mt-sm-141 {\n    margin-top: 70rem !important;\n  }\n\n  .mt-sm-142 {\n    margin-top: 70.5rem !important;\n  }\n\n  .mt-sm-143 {\n    margin-top: 71rem !important;\n  }\n\n  .mt-sm-144 {\n    margin-top: 71.5rem !important;\n  }\n\n  .mt-sm-145 {\n    margin-top: 72rem !important;\n  }\n\n  .mt-sm-146 {\n    margin-top: 72.5rem !important;\n  }\n\n  .mt-sm-147 {\n    margin-top: 73rem !important;\n  }\n\n  .mt-sm-148 {\n    margin-top: 73.5rem !important;\n  }\n\n  .mt-sm-149 {\n    margin-top: 74rem !important;\n  }\n\n  .mt-sm-150 {\n    margin-top: 74.5rem !important;\n  }\n\n  .mt-sm-151 {\n    margin-top: 75rem !important;\n  }\n\n  .mt-sm-152 {\n    margin-top: 75.5rem !important;\n  }\n\n  .mt-sm-153 {\n    margin-top: 76rem !important;\n  }\n\n  .mt-sm-154 {\n    margin-top: 76.5rem !important;\n  }\n\n  .mt-sm-155 {\n    margin-top: 77rem !important;\n  }\n\n  .mt-sm-156 {\n    margin-top: 77.5rem !important;\n  }\n\n  .mt-sm-157 {\n    margin-top: 78rem !important;\n  }\n\n  .mt-sm-158 {\n    margin-top: 78.5rem !important;\n  }\n\n  .mt-sm-159 {\n    margin-top: 79rem !important;\n  }\n\n  .mt-sm-160 {\n    margin-top: 79.5rem !important;\n  }\n\n  .mb-sm-0 {\n    margin-bottom: 0rem !important;\n  }\n\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-sm-5 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-sm-6 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-sm-7 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-sm-8 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-sm-9 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-sm-10 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-sm-11 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-sm-12 {\n    margin-bottom: 5.5rem !important;\n  }\n\n  .mb-sm-13 {\n    margin-bottom: 6rem !important;\n  }\n\n  .mb-sm-14 {\n    margin-bottom: 6.5rem !important;\n  }\n\n  .mb-sm-15 {\n    margin-bottom: 7rem !important;\n  }\n\n  .mb-sm-16 {\n    margin-bottom: 7.5rem !important;\n  }\n\n  .mb-sm-17 {\n    margin-bottom: 8rem !important;\n  }\n\n  .mb-sm-18 {\n    margin-bottom: 8.5rem !important;\n  }\n\n  .mb-sm-19 {\n    margin-bottom: 9rem !important;\n  }\n\n  .mb-sm-20 {\n    margin-bottom: 9.5rem !important;\n  }\n\n  .mb-sm-21 {\n    margin-bottom: 10rem !important;\n  }\n\n  .mb-sm-22 {\n    margin-bottom: 10.5rem !important;\n  }\n\n  .mb-sm-23 {\n    margin-bottom: 11rem !important;\n  }\n\n  .mb-sm-24 {\n    margin-bottom: 11.5rem !important;\n  }\n\n  .mb-sm-25 {\n    margin-bottom: 12rem !important;\n  }\n\n  .mb-sm-26 {\n    margin-bottom: 12.5rem !important;\n  }\n\n  .mb-sm-27 {\n    margin-bottom: 13rem !important;\n  }\n\n  .mb-sm-28 {\n    margin-bottom: 13.5rem !important;\n  }\n\n  .mb-sm-29 {\n    margin-bottom: 14rem !important;\n  }\n\n  .mb-sm-30 {\n    margin-bottom: 14.5rem !important;\n  }\n\n  .mb-sm-31 {\n    margin-bottom: 15rem !important;\n  }\n\n  .mb-sm-32 {\n    margin-bottom: 15.5rem !important;\n  }\n\n  .mb-sm-33 {\n    margin-bottom: 16rem !important;\n  }\n\n  .mb-sm-34 {\n    margin-bottom: 16.5rem !important;\n  }\n\n  .mb-sm-35 {\n    margin-bottom: 17rem !important;\n  }\n\n  .mb-sm-36 {\n    margin-bottom: 17.5rem !important;\n  }\n\n  .mb-sm-37 {\n    margin-bottom: 18rem !important;\n  }\n\n  .mb-sm-38 {\n    margin-bottom: 18.5rem !important;\n  }\n\n  .mb-sm-39 {\n    margin-bottom: 19rem !important;\n  }\n\n  .mb-sm-40 {\n    margin-bottom: 19.5rem !important;\n  }\n\n  .mb-sm-41 {\n    margin-bottom: 20rem !important;\n  }\n\n  .mb-sm-42 {\n    margin-bottom: 20.5rem !important;\n  }\n\n  .mb-sm-43 {\n    margin-bottom: 21rem !important;\n  }\n\n  .mb-sm-44 {\n    margin-bottom: 21.5rem !important;\n  }\n\n  .mb-sm-45 {\n    margin-bottom: 22rem !important;\n  }\n\n  .mb-sm-46 {\n    margin-bottom: 22.5rem !important;\n  }\n\n  .mb-sm-47 {\n    margin-bottom: 23rem !important;\n  }\n\n  .mb-sm-48 {\n    margin-bottom: 23.5rem !important;\n  }\n\n  .mb-sm-49 {\n    margin-bottom: 24rem !important;\n  }\n\n  .mb-sm-50 {\n    margin-bottom: 24.5rem !important;\n  }\n\n  .mb-sm-51 {\n    margin-bottom: 25rem !important;\n  }\n\n  .mb-sm-52 {\n    margin-bottom: 25.5rem !important;\n  }\n\n  .mb-sm-53 {\n    margin-bottom: 26rem !important;\n  }\n\n  .mb-sm-54 {\n    margin-bottom: 26.5rem !important;\n  }\n\n  .mb-sm-55 {\n    margin-bottom: 27rem !important;\n  }\n\n  .mb-sm-56 {\n    margin-bottom: 27.5rem !important;\n  }\n\n  .mb-sm-57 {\n    margin-bottom: 28rem !important;\n  }\n\n  .mb-sm-58 {\n    margin-bottom: 28.5rem !important;\n  }\n\n  .mb-sm-59 {\n    margin-bottom: 29rem !important;\n  }\n\n  .mb-sm-60 {\n    margin-bottom: 29.5rem !important;\n  }\n\n  .mb-sm-61 {\n    margin-bottom: 30rem !important;\n  }\n\n  .mb-sm-62 {\n    margin-bottom: 30.5rem !important;\n  }\n\n  .mb-sm-63 {\n    margin-bottom: 31rem !important;\n  }\n\n  .mb-sm-64 {\n    margin-bottom: 31.5rem !important;\n  }\n\n  .mb-sm-65 {\n    margin-bottom: 32rem !important;\n  }\n\n  .mb-sm-66 {\n    margin-bottom: 32.5rem !important;\n  }\n\n  .mb-sm-67 {\n    margin-bottom: 33rem !important;\n  }\n\n  .mb-sm-68 {\n    margin-bottom: 33.5rem !important;\n  }\n\n  .mb-sm-69 {\n    margin-bottom: 34rem !important;\n  }\n\n  .mb-sm-70 {\n    margin-bottom: 34.5rem !important;\n  }\n\n  .mb-sm-71 {\n    margin-bottom: 35rem !important;\n  }\n\n  .mb-sm-72 {\n    margin-bottom: 35.5rem !important;\n  }\n\n  .mb-sm-73 {\n    margin-bottom: 36rem !important;\n  }\n\n  .mb-sm-74 {\n    margin-bottom: 36.5rem !important;\n  }\n\n  .mb-sm-75 {\n    margin-bottom: 37rem !important;\n  }\n\n  .mb-sm-76 {\n    margin-bottom: 37.5rem !important;\n  }\n\n  .mb-sm-77 {\n    margin-bottom: 38rem !important;\n  }\n\n  .mb-sm-78 {\n    margin-bottom: 38.5rem !important;\n  }\n\n  .mb-sm-79 {\n    margin-bottom: 39rem !important;\n  }\n\n  .mb-sm-80 {\n    margin-bottom: 39.5rem !important;\n  }\n\n  .mb-sm-81 {\n    margin-bottom: 40rem !important;\n  }\n\n  .mb-sm-82 {\n    margin-bottom: 40.5rem !important;\n  }\n\n  .mb-sm-83 {\n    margin-bottom: 41rem !important;\n  }\n\n  .mb-sm-84 {\n    margin-bottom: 41.5rem !important;\n  }\n\n  .mb-sm-85 {\n    margin-bottom: 42rem !important;\n  }\n\n  .mb-sm-86 {\n    margin-bottom: 42.5rem !important;\n  }\n\n  .mb-sm-87 {\n    margin-bottom: 43rem !important;\n  }\n\n  .mb-sm-88 {\n    margin-bottom: 43.5rem !important;\n  }\n\n  .mb-sm-89 {\n    margin-bottom: 44rem !important;\n  }\n\n  .mb-sm-90 {\n    margin-bottom: 44.5rem !important;\n  }\n\n  .mb-sm-91 {\n    margin-bottom: 45rem !important;\n  }\n\n  .mb-sm-92 {\n    margin-bottom: 45.5rem !important;\n  }\n\n  .mb-sm-93 {\n    margin-bottom: 46rem !important;\n  }\n\n  .mb-sm-94 {\n    margin-bottom: 46.5rem !important;\n  }\n\n  .mb-sm-95 {\n    margin-bottom: 47rem !important;\n  }\n\n  .mb-sm-96 {\n    margin-bottom: 47.5rem !important;\n  }\n\n  .mb-sm-97 {\n    margin-bottom: 48rem !important;\n  }\n\n  .mb-sm-98 {\n    margin-bottom: 48.5rem !important;\n  }\n\n  .mb-sm-99 {\n    margin-bottom: 49rem !important;\n  }\n\n  .mb-sm-100 {\n    margin-bottom: 49.5rem !important;\n  }\n\n  .mb-sm-101 {\n    margin-bottom: 50rem !important;\n  }\n\n  .mb-sm-102 {\n    margin-bottom: 50.5rem !important;\n  }\n\n  .mb-sm-103 {\n    margin-bottom: 51rem !important;\n  }\n\n  .mb-sm-104 {\n    margin-bottom: 51.5rem !important;\n  }\n\n  .mb-sm-105 {\n    margin-bottom: 52rem !important;\n  }\n\n  .mb-sm-106 {\n    margin-bottom: 52.5rem !important;\n  }\n\n  .mb-sm-107 {\n    margin-bottom: 53rem !important;\n  }\n\n  .mb-sm-108 {\n    margin-bottom: 53.5rem !important;\n  }\n\n  .mb-sm-109 {\n    margin-bottom: 54rem !important;\n  }\n\n  .mb-sm-110 {\n    margin-bottom: 54.5rem !important;\n  }\n\n  .mb-sm-111 {\n    margin-bottom: 55rem !important;\n  }\n\n  .mb-sm-112 {\n    margin-bottom: 55.5rem !important;\n  }\n\n  .mb-sm-113 {\n    margin-bottom: 56rem !important;\n  }\n\n  .mb-sm-114 {\n    margin-bottom: 56.5rem !important;\n  }\n\n  .mb-sm-115 {\n    margin-bottom: 57rem !important;\n  }\n\n  .mb-sm-116 {\n    margin-bottom: 57.5rem !important;\n  }\n\n  .mb-sm-117 {\n    margin-bottom: 58rem !important;\n  }\n\n  .mb-sm-118 {\n    margin-bottom: 58.5rem !important;\n  }\n\n  .mb-sm-119 {\n    margin-bottom: 59rem !important;\n  }\n\n  .mb-sm-120 {\n    margin-bottom: 59.5rem !important;\n  }\n\n  .mb-sm-121 {\n    margin-bottom: 60rem !important;\n  }\n\n  .mb-sm-122 {\n    margin-bottom: 60.5rem !important;\n  }\n\n  .mb-sm-123 {\n    margin-bottom: 61rem !important;\n  }\n\n  .mb-sm-124 {\n    margin-bottom: 61.5rem !important;\n  }\n\n  .mb-sm-125 {\n    margin-bottom: 62rem !important;\n  }\n\n  .mb-sm-126 {\n    margin-bottom: 62.5rem !important;\n  }\n\n  .mb-sm-127 {\n    margin-bottom: 63rem !important;\n  }\n\n  .mb-sm-128 {\n    margin-bottom: 63.5rem !important;\n  }\n\n  .mb-sm-129 {\n    margin-bottom: 64rem !important;\n  }\n\n  .mb-sm-130 {\n    margin-bottom: 64.5rem !important;\n  }\n\n  .mb-sm-131 {\n    margin-bottom: 65rem !important;\n  }\n\n  .mb-sm-132 {\n    margin-bottom: 65.5rem !important;\n  }\n\n  .mb-sm-133 {\n    margin-bottom: 66rem !important;\n  }\n\n  .mb-sm-134 {\n    margin-bottom: 66.5rem !important;\n  }\n\n  .mb-sm-135 {\n    margin-bottom: 67rem !important;\n  }\n\n  .mb-sm-136 {\n    margin-bottom: 67.5rem !important;\n  }\n\n  .mb-sm-137 {\n    margin-bottom: 68rem !important;\n  }\n\n  .mb-sm-138 {\n    margin-bottom: 68.5rem !important;\n  }\n\n  .mb-sm-139 {\n    margin-bottom: 69rem !important;\n  }\n\n  .mb-sm-140 {\n    margin-bottom: 69.5rem !important;\n  }\n\n  .mb-sm-141 {\n    margin-bottom: 70rem !important;\n  }\n\n  .mb-sm-142 {\n    margin-bottom: 70.5rem !important;\n  }\n\n  .mb-sm-143 {\n    margin-bottom: 71rem !important;\n  }\n\n  .mb-sm-144 {\n    margin-bottom: 71.5rem !important;\n  }\n\n  .mb-sm-145 {\n    margin-bottom: 72rem !important;\n  }\n\n  .mb-sm-146 {\n    margin-bottom: 72.5rem !important;\n  }\n\n  .mb-sm-147 {\n    margin-bottom: 73rem !important;\n  }\n\n  .mb-sm-148 {\n    margin-bottom: 73.5rem !important;\n  }\n\n  .mb-sm-149 {\n    margin-bottom: 74rem !important;\n  }\n\n  .mb-sm-150 {\n    margin-bottom: 74.5rem !important;\n  }\n\n  .mb-sm-151 {\n    margin-bottom: 75rem !important;\n  }\n\n  .mb-sm-152 {\n    margin-bottom: 75.5rem !important;\n  }\n\n  .mb-sm-153 {\n    margin-bottom: 76rem !important;\n  }\n\n  .mb-sm-154 {\n    margin-bottom: 76.5rem !important;\n  }\n\n  .mb-sm-155 {\n    margin-bottom: 77rem !important;\n  }\n\n  .mb-sm-156 {\n    margin-bottom: 77.5rem !important;\n  }\n\n  .mb-sm-157 {\n    margin-bottom: 78rem !important;\n  }\n\n  .mb-sm-158 {\n    margin-bottom: 78.5rem !important;\n  }\n\n  .mb-sm-159 {\n    margin-bottom: 79rem !important;\n  }\n\n  .mb-sm-160 {\n    margin-bottom: 79.5rem !important;\n  }\n\n  .ms-sm-0 {\n    margin-left: 0rem !important;\n  }\n\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-sm-5 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-sm-6 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-sm-7 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-sm-8 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-sm-9 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-sm-10 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-sm-11 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-sm-12 {\n    margin-left: 5.5rem !important;\n  }\n\n  .ms-sm-13 {\n    margin-left: 6rem !important;\n  }\n\n  .ms-sm-14 {\n    margin-left: 6.5rem !important;\n  }\n\n  .ms-sm-15 {\n    margin-left: 7rem !important;\n  }\n\n  .ms-sm-16 {\n    margin-left: 7.5rem !important;\n  }\n\n  .ms-sm-17 {\n    margin-left: 8rem !important;\n  }\n\n  .ms-sm-18 {\n    margin-left: 8.5rem !important;\n  }\n\n  .ms-sm-19 {\n    margin-left: 9rem !important;\n  }\n\n  .ms-sm-20 {\n    margin-left: 9.5rem !important;\n  }\n\n  .ms-sm-21 {\n    margin-left: 10rem !important;\n  }\n\n  .ms-sm-22 {\n    margin-left: 10.5rem !important;\n  }\n\n  .ms-sm-23 {\n    margin-left: 11rem !important;\n  }\n\n  .ms-sm-24 {\n    margin-left: 11.5rem !important;\n  }\n\n  .ms-sm-25 {\n    margin-left: 12rem !important;\n  }\n\n  .ms-sm-26 {\n    margin-left: 12.5rem !important;\n  }\n\n  .ms-sm-27 {\n    margin-left: 13rem !important;\n  }\n\n  .ms-sm-28 {\n    margin-left: 13.5rem !important;\n  }\n\n  .ms-sm-29 {\n    margin-left: 14rem !important;\n  }\n\n  .ms-sm-30 {\n    margin-left: 14.5rem !important;\n  }\n\n  .ms-sm-31 {\n    margin-left: 15rem !important;\n  }\n\n  .ms-sm-32 {\n    margin-left: 15.5rem !important;\n  }\n\n  .ms-sm-33 {\n    margin-left: 16rem !important;\n  }\n\n  .ms-sm-34 {\n    margin-left: 16.5rem !important;\n  }\n\n  .ms-sm-35 {\n    margin-left: 17rem !important;\n  }\n\n  .ms-sm-36 {\n    margin-left: 17.5rem !important;\n  }\n\n  .ms-sm-37 {\n    margin-left: 18rem !important;\n  }\n\n  .ms-sm-38 {\n    margin-left: 18.5rem !important;\n  }\n\n  .ms-sm-39 {\n    margin-left: 19rem !important;\n  }\n\n  .ms-sm-40 {\n    margin-left: 19.5rem !important;\n  }\n\n  .ms-sm-41 {\n    margin-left: 20rem !important;\n  }\n\n  .ms-sm-42 {\n    margin-left: 20.5rem !important;\n  }\n\n  .ms-sm-43 {\n    margin-left: 21rem !important;\n  }\n\n  .ms-sm-44 {\n    margin-left: 21.5rem !important;\n  }\n\n  .ms-sm-45 {\n    margin-left: 22rem !important;\n  }\n\n  .ms-sm-46 {\n    margin-left: 22.5rem !important;\n  }\n\n  .ms-sm-47 {\n    margin-left: 23rem !important;\n  }\n\n  .ms-sm-48 {\n    margin-left: 23.5rem !important;\n  }\n\n  .ms-sm-49 {\n    margin-left: 24rem !important;\n  }\n\n  .ms-sm-50 {\n    margin-left: 24.5rem !important;\n  }\n\n  .ms-sm-51 {\n    margin-left: 25rem !important;\n  }\n\n  .ms-sm-52 {\n    margin-left: 25.5rem !important;\n  }\n\n  .ms-sm-53 {\n    margin-left: 26rem !important;\n  }\n\n  .ms-sm-54 {\n    margin-left: 26.5rem !important;\n  }\n\n  .ms-sm-55 {\n    margin-left: 27rem !important;\n  }\n\n  .ms-sm-56 {\n    margin-left: 27.5rem !important;\n  }\n\n  .ms-sm-57 {\n    margin-left: 28rem !important;\n  }\n\n  .ms-sm-58 {\n    margin-left: 28.5rem !important;\n  }\n\n  .ms-sm-59 {\n    margin-left: 29rem !important;\n  }\n\n  .ms-sm-60 {\n    margin-left: 29.5rem !important;\n  }\n\n  .ms-sm-61 {\n    margin-left: 30rem !important;\n  }\n\n  .ms-sm-62 {\n    margin-left: 30.5rem !important;\n  }\n\n  .ms-sm-63 {\n    margin-left: 31rem !important;\n  }\n\n  .ms-sm-64 {\n    margin-left: 31.5rem !important;\n  }\n\n  .ms-sm-65 {\n    margin-left: 32rem !important;\n  }\n\n  .ms-sm-66 {\n    margin-left: 32.5rem !important;\n  }\n\n  .ms-sm-67 {\n    margin-left: 33rem !important;\n  }\n\n  .ms-sm-68 {\n    margin-left: 33.5rem !important;\n  }\n\n  .ms-sm-69 {\n    margin-left: 34rem !important;\n  }\n\n  .ms-sm-70 {\n    margin-left: 34.5rem !important;\n  }\n\n  .ms-sm-71 {\n    margin-left: 35rem !important;\n  }\n\n  .ms-sm-72 {\n    margin-left: 35.5rem !important;\n  }\n\n  .ms-sm-73 {\n    margin-left: 36rem !important;\n  }\n\n  .ms-sm-74 {\n    margin-left: 36.5rem !important;\n  }\n\n  .ms-sm-75 {\n    margin-left: 37rem !important;\n  }\n\n  .ms-sm-76 {\n    margin-left: 37.5rem !important;\n  }\n\n  .ms-sm-77 {\n    margin-left: 38rem !important;\n  }\n\n  .ms-sm-78 {\n    margin-left: 38.5rem !important;\n  }\n\n  .ms-sm-79 {\n    margin-left: 39rem !important;\n  }\n\n  .ms-sm-80 {\n    margin-left: 39.5rem !important;\n  }\n\n  .ms-sm-81 {\n    margin-left: 40rem !important;\n  }\n\n  .ms-sm-82 {\n    margin-left: 40.5rem !important;\n  }\n\n  .ms-sm-83 {\n    margin-left: 41rem !important;\n  }\n\n  .ms-sm-84 {\n    margin-left: 41.5rem !important;\n  }\n\n  .ms-sm-85 {\n    margin-left: 42rem !important;\n  }\n\n  .ms-sm-86 {\n    margin-left: 42.5rem !important;\n  }\n\n  .ms-sm-87 {\n    margin-left: 43rem !important;\n  }\n\n  .ms-sm-88 {\n    margin-left: 43.5rem !important;\n  }\n\n  .ms-sm-89 {\n    margin-left: 44rem !important;\n  }\n\n  .ms-sm-90 {\n    margin-left: 44.5rem !important;\n  }\n\n  .ms-sm-91 {\n    margin-left: 45rem !important;\n  }\n\n  .ms-sm-92 {\n    margin-left: 45.5rem !important;\n  }\n\n  .ms-sm-93 {\n    margin-left: 46rem !important;\n  }\n\n  .ms-sm-94 {\n    margin-left: 46.5rem !important;\n  }\n\n  .ms-sm-95 {\n    margin-left: 47rem !important;\n  }\n\n  .ms-sm-96 {\n    margin-left: 47.5rem !important;\n  }\n\n  .ms-sm-97 {\n    margin-left: 48rem !important;\n  }\n\n  .ms-sm-98 {\n    margin-left: 48.5rem !important;\n  }\n\n  .ms-sm-99 {\n    margin-left: 49rem !important;\n  }\n\n  .ms-sm-100 {\n    margin-left: 49.5rem !important;\n  }\n\n  .ms-sm-101 {\n    margin-left: 50rem !important;\n  }\n\n  .ms-sm-102 {\n    margin-left: 50.5rem !important;\n  }\n\n  .ms-sm-103 {\n    margin-left: 51rem !important;\n  }\n\n  .ms-sm-104 {\n    margin-left: 51.5rem !important;\n  }\n\n  .ms-sm-105 {\n    margin-left: 52rem !important;\n  }\n\n  .ms-sm-106 {\n    margin-left: 52.5rem !important;\n  }\n\n  .ms-sm-107 {\n    margin-left: 53rem !important;\n  }\n\n  .ms-sm-108 {\n    margin-left: 53.5rem !important;\n  }\n\n  .ms-sm-109 {\n    margin-left: 54rem !important;\n  }\n\n  .ms-sm-110 {\n    margin-left: 54.5rem !important;\n  }\n\n  .ms-sm-111 {\n    margin-left: 55rem !important;\n  }\n\n  .ms-sm-112 {\n    margin-left: 55.5rem !important;\n  }\n\n  .ms-sm-113 {\n    margin-left: 56rem !important;\n  }\n\n  .ms-sm-114 {\n    margin-left: 56.5rem !important;\n  }\n\n  .ms-sm-115 {\n    margin-left: 57rem !important;\n  }\n\n  .ms-sm-116 {\n    margin-left: 57.5rem !important;\n  }\n\n  .ms-sm-117 {\n    margin-left: 58rem !important;\n  }\n\n  .ms-sm-118 {\n    margin-left: 58.5rem !important;\n  }\n\n  .ms-sm-119 {\n    margin-left: 59rem !important;\n  }\n\n  .ms-sm-120 {\n    margin-left: 59.5rem !important;\n  }\n\n  .ms-sm-121 {\n    margin-left: 60rem !important;\n  }\n\n  .ms-sm-122 {\n    margin-left: 60.5rem !important;\n  }\n\n  .ms-sm-123 {\n    margin-left: 61rem !important;\n  }\n\n  .ms-sm-124 {\n    margin-left: 61.5rem !important;\n  }\n\n  .ms-sm-125 {\n    margin-left: 62rem !important;\n  }\n\n  .ms-sm-126 {\n    margin-left: 62.5rem !important;\n  }\n\n  .ms-sm-127 {\n    margin-left: 63rem !important;\n  }\n\n  .ms-sm-128 {\n    margin-left: 63.5rem !important;\n  }\n\n  .ms-sm-129 {\n    margin-left: 64rem !important;\n  }\n\n  .ms-sm-130 {\n    margin-left: 64.5rem !important;\n  }\n\n  .ms-sm-131 {\n    margin-left: 65rem !important;\n  }\n\n  .ms-sm-132 {\n    margin-left: 65.5rem !important;\n  }\n\n  .ms-sm-133 {\n    margin-left: 66rem !important;\n  }\n\n  .ms-sm-134 {\n    margin-left: 66.5rem !important;\n  }\n\n  .ms-sm-135 {\n    margin-left: 67rem !important;\n  }\n\n  .ms-sm-136 {\n    margin-left: 67.5rem !important;\n  }\n\n  .ms-sm-137 {\n    margin-left: 68rem !important;\n  }\n\n  .ms-sm-138 {\n    margin-left: 68.5rem !important;\n  }\n\n  .ms-sm-139 {\n    margin-left: 69rem !important;\n  }\n\n  .ms-sm-140 {\n    margin-left: 69.5rem !important;\n  }\n\n  .ms-sm-141 {\n    margin-left: 70rem !important;\n  }\n\n  .ms-sm-142 {\n    margin-left: 70.5rem !important;\n  }\n\n  .ms-sm-143 {\n    margin-left: 71rem !important;\n  }\n\n  .ms-sm-144 {\n    margin-left: 71.5rem !important;\n  }\n\n  .ms-sm-145 {\n    margin-left: 72rem !important;\n  }\n\n  .ms-sm-146 {\n    margin-left: 72.5rem !important;\n  }\n\n  .ms-sm-147 {\n    margin-left: 73rem !important;\n  }\n\n  .ms-sm-148 {\n    margin-left: 73.5rem !important;\n  }\n\n  .ms-sm-149 {\n    margin-left: 74rem !important;\n  }\n\n  .ms-sm-150 {\n    margin-left: 74.5rem !important;\n  }\n\n  .ms-sm-151 {\n    margin-left: 75rem !important;\n  }\n\n  .ms-sm-152 {\n    margin-left: 75.5rem !important;\n  }\n\n  .ms-sm-153 {\n    margin-left: 76rem !important;\n  }\n\n  .ms-sm-154 {\n    margin-left: 76.5rem !important;\n  }\n\n  .ms-sm-155 {\n    margin-left: 77rem !important;\n  }\n\n  .ms-sm-156 {\n    margin-left: 77.5rem !important;\n  }\n\n  .ms-sm-157 {\n    margin-left: 78rem !important;\n  }\n\n  .ms-sm-158 {\n    margin-left: 78.5rem !important;\n  }\n\n  .ms-sm-159 {\n    margin-left: 79rem !important;\n  }\n\n  .ms-sm-160 {\n    margin-left: 79.5rem !important;\n  }\n\n  .me-sm-0 {\n    margin-right: 0rem !important;\n  }\n\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-sm-5 {\n    margin-right: 2rem !important;\n  }\n\n  .me-sm-6 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-sm-7 {\n    margin-right: 3rem !important;\n  }\n\n  .me-sm-8 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-sm-9 {\n    margin-right: 4rem !important;\n  }\n\n  .me-sm-10 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-sm-11 {\n    margin-right: 5rem !important;\n  }\n\n  .me-sm-12 {\n    margin-right: 5.5rem !important;\n  }\n\n  .me-sm-13 {\n    margin-right: 6rem !important;\n  }\n\n  .me-sm-14 {\n    margin-right: 6.5rem !important;\n  }\n\n  .me-sm-15 {\n    margin-right: 7rem !important;\n  }\n\n  .me-sm-16 {\n    margin-right: 7.5rem !important;\n  }\n\n  .me-sm-17 {\n    margin-right: 8rem !important;\n  }\n\n  .me-sm-18 {\n    margin-right: 8.5rem !important;\n  }\n\n  .me-sm-19 {\n    margin-right: 9rem !important;\n  }\n\n  .me-sm-20 {\n    margin-right: 9.5rem !important;\n  }\n\n  .me-sm-21 {\n    margin-right: 10rem !important;\n  }\n\n  .me-sm-22 {\n    margin-right: 10.5rem !important;\n  }\n\n  .me-sm-23 {\n    margin-right: 11rem !important;\n  }\n\n  .me-sm-24 {\n    margin-right: 11.5rem !important;\n  }\n\n  .me-sm-25 {\n    margin-right: 12rem !important;\n  }\n\n  .me-sm-26 {\n    margin-right: 12.5rem !important;\n  }\n\n  .me-sm-27 {\n    margin-right: 13rem !important;\n  }\n\n  .me-sm-28 {\n    margin-right: 13.5rem !important;\n  }\n\n  .me-sm-29 {\n    margin-right: 14rem !important;\n  }\n\n  .me-sm-30 {\n    margin-right: 14.5rem !important;\n  }\n\n  .me-sm-31 {\n    margin-right: 15rem !important;\n  }\n\n  .me-sm-32 {\n    margin-right: 15.5rem !important;\n  }\n\n  .me-sm-33 {\n    margin-right: 16rem !important;\n  }\n\n  .me-sm-34 {\n    margin-right: 16.5rem !important;\n  }\n\n  .me-sm-35 {\n    margin-right: 17rem !important;\n  }\n\n  .me-sm-36 {\n    margin-right: 17.5rem !important;\n  }\n\n  .me-sm-37 {\n    margin-right: 18rem !important;\n  }\n\n  .me-sm-38 {\n    margin-right: 18.5rem !important;\n  }\n\n  .me-sm-39 {\n    margin-right: 19rem !important;\n  }\n\n  .me-sm-40 {\n    margin-right: 19.5rem !important;\n  }\n\n  .me-sm-41 {\n    margin-right: 20rem !important;\n  }\n\n  .me-sm-42 {\n    margin-right: 20.5rem !important;\n  }\n\n  .me-sm-43 {\n    margin-right: 21rem !important;\n  }\n\n  .me-sm-44 {\n    margin-right: 21.5rem !important;\n  }\n\n  .me-sm-45 {\n    margin-right: 22rem !important;\n  }\n\n  .me-sm-46 {\n    margin-right: 22.5rem !important;\n  }\n\n  .me-sm-47 {\n    margin-right: 23rem !important;\n  }\n\n  .me-sm-48 {\n    margin-right: 23.5rem !important;\n  }\n\n  .me-sm-49 {\n    margin-right: 24rem !important;\n  }\n\n  .me-sm-50 {\n    margin-right: 24.5rem !important;\n  }\n\n  .me-sm-51 {\n    margin-right: 25rem !important;\n  }\n\n  .me-sm-52 {\n    margin-right: 25.5rem !important;\n  }\n\n  .me-sm-53 {\n    margin-right: 26rem !important;\n  }\n\n  .me-sm-54 {\n    margin-right: 26.5rem !important;\n  }\n\n  .me-sm-55 {\n    margin-right: 27rem !important;\n  }\n\n  .me-sm-56 {\n    margin-right: 27.5rem !important;\n  }\n\n  .me-sm-57 {\n    margin-right: 28rem !important;\n  }\n\n  .me-sm-58 {\n    margin-right: 28.5rem !important;\n  }\n\n  .me-sm-59 {\n    margin-right: 29rem !important;\n  }\n\n  .me-sm-60 {\n    margin-right: 29.5rem !important;\n  }\n\n  .me-sm-61 {\n    margin-right: 30rem !important;\n  }\n\n  .me-sm-62 {\n    margin-right: 30.5rem !important;\n  }\n\n  .me-sm-63 {\n    margin-right: 31rem !important;\n  }\n\n  .me-sm-64 {\n    margin-right: 31.5rem !important;\n  }\n\n  .me-sm-65 {\n    margin-right: 32rem !important;\n  }\n\n  .me-sm-66 {\n    margin-right: 32.5rem !important;\n  }\n\n  .me-sm-67 {\n    margin-right: 33rem !important;\n  }\n\n  .me-sm-68 {\n    margin-right: 33.5rem !important;\n  }\n\n  .me-sm-69 {\n    margin-right: 34rem !important;\n  }\n\n  .me-sm-70 {\n    margin-right: 34.5rem !important;\n  }\n\n  .me-sm-71 {\n    margin-right: 35rem !important;\n  }\n\n  .me-sm-72 {\n    margin-right: 35.5rem !important;\n  }\n\n  .me-sm-73 {\n    margin-right: 36rem !important;\n  }\n\n  .me-sm-74 {\n    margin-right: 36.5rem !important;\n  }\n\n  .me-sm-75 {\n    margin-right: 37rem !important;\n  }\n\n  .me-sm-76 {\n    margin-right: 37.5rem !important;\n  }\n\n  .me-sm-77 {\n    margin-right: 38rem !important;\n  }\n\n  .me-sm-78 {\n    margin-right: 38.5rem !important;\n  }\n\n  .me-sm-79 {\n    margin-right: 39rem !important;\n  }\n\n  .me-sm-80 {\n    margin-right: 39.5rem !important;\n  }\n\n  .me-sm-81 {\n    margin-right: 40rem !important;\n  }\n\n  .me-sm-82 {\n    margin-right: 40.5rem !important;\n  }\n\n  .me-sm-83 {\n    margin-right: 41rem !important;\n  }\n\n  .me-sm-84 {\n    margin-right: 41.5rem !important;\n  }\n\n  .me-sm-85 {\n    margin-right: 42rem !important;\n  }\n\n  .me-sm-86 {\n    margin-right: 42.5rem !important;\n  }\n\n  .me-sm-87 {\n    margin-right: 43rem !important;\n  }\n\n  .me-sm-88 {\n    margin-right: 43.5rem !important;\n  }\n\n  .me-sm-89 {\n    margin-right: 44rem !important;\n  }\n\n  .me-sm-90 {\n    margin-right: 44.5rem !important;\n  }\n\n  .me-sm-91 {\n    margin-right: 45rem !important;\n  }\n\n  .me-sm-92 {\n    margin-right: 45.5rem !important;\n  }\n\n  .me-sm-93 {\n    margin-right: 46rem !important;\n  }\n\n  .me-sm-94 {\n    margin-right: 46.5rem !important;\n  }\n\n  .me-sm-95 {\n    margin-right: 47rem !important;\n  }\n\n  .me-sm-96 {\n    margin-right: 47.5rem !important;\n  }\n\n  .me-sm-97 {\n    margin-right: 48rem !important;\n  }\n\n  .me-sm-98 {\n    margin-right: 48.5rem !important;\n  }\n\n  .me-sm-99 {\n    margin-right: 49rem !important;\n  }\n\n  .me-sm-100 {\n    margin-right: 49.5rem !important;\n  }\n\n  .me-sm-101 {\n    margin-right: 50rem !important;\n  }\n\n  .me-sm-102 {\n    margin-right: 50.5rem !important;\n  }\n\n  .me-sm-103 {\n    margin-right: 51rem !important;\n  }\n\n  .me-sm-104 {\n    margin-right: 51.5rem !important;\n  }\n\n  .me-sm-105 {\n    margin-right: 52rem !important;\n  }\n\n  .me-sm-106 {\n    margin-right: 52.5rem !important;\n  }\n\n  .me-sm-107 {\n    margin-right: 53rem !important;\n  }\n\n  .me-sm-108 {\n    margin-right: 53.5rem !important;\n  }\n\n  .me-sm-109 {\n    margin-right: 54rem !important;\n  }\n\n  .me-sm-110 {\n    margin-right: 54.5rem !important;\n  }\n\n  .me-sm-111 {\n    margin-right: 55rem !important;\n  }\n\n  .me-sm-112 {\n    margin-right: 55.5rem !important;\n  }\n\n  .me-sm-113 {\n    margin-right: 56rem !important;\n  }\n\n  .me-sm-114 {\n    margin-right: 56.5rem !important;\n  }\n\n  .me-sm-115 {\n    margin-right: 57rem !important;\n  }\n\n  .me-sm-116 {\n    margin-right: 57.5rem !important;\n  }\n\n  .me-sm-117 {\n    margin-right: 58rem !important;\n  }\n\n  .me-sm-118 {\n    margin-right: 58.5rem !important;\n  }\n\n  .me-sm-119 {\n    margin-right: 59rem !important;\n  }\n\n  .me-sm-120 {\n    margin-right: 59.5rem !important;\n  }\n\n  .me-sm-121 {\n    margin-right: 60rem !important;\n  }\n\n  .me-sm-122 {\n    margin-right: 60.5rem !important;\n  }\n\n  .me-sm-123 {\n    margin-right: 61rem !important;\n  }\n\n  .me-sm-124 {\n    margin-right: 61.5rem !important;\n  }\n\n  .me-sm-125 {\n    margin-right: 62rem !important;\n  }\n\n  .me-sm-126 {\n    margin-right: 62.5rem !important;\n  }\n\n  .me-sm-127 {\n    margin-right: 63rem !important;\n  }\n\n  .me-sm-128 {\n    margin-right: 63.5rem !important;\n  }\n\n  .me-sm-129 {\n    margin-right: 64rem !important;\n  }\n\n  .me-sm-130 {\n    margin-right: 64.5rem !important;\n  }\n\n  .me-sm-131 {\n    margin-right: 65rem !important;\n  }\n\n  .me-sm-132 {\n    margin-right: 65.5rem !important;\n  }\n\n  .me-sm-133 {\n    margin-right: 66rem !important;\n  }\n\n  .me-sm-134 {\n    margin-right: 66.5rem !important;\n  }\n\n  .me-sm-135 {\n    margin-right: 67rem !important;\n  }\n\n  .me-sm-136 {\n    margin-right: 67.5rem !important;\n  }\n\n  .me-sm-137 {\n    margin-right: 68rem !important;\n  }\n\n  .me-sm-138 {\n    margin-right: 68.5rem !important;\n  }\n\n  .me-sm-139 {\n    margin-right: 69rem !important;\n  }\n\n  .me-sm-140 {\n    margin-right: 69.5rem !important;\n  }\n\n  .me-sm-141 {\n    margin-right: 70rem !important;\n  }\n\n  .me-sm-142 {\n    margin-right: 70.5rem !important;\n  }\n\n  .me-sm-143 {\n    margin-right: 71rem !important;\n  }\n\n  .me-sm-144 {\n    margin-right: 71.5rem !important;\n  }\n\n  .me-sm-145 {\n    margin-right: 72rem !important;\n  }\n\n  .me-sm-146 {\n    margin-right: 72.5rem !important;\n  }\n\n  .me-sm-147 {\n    margin-right: 73rem !important;\n  }\n\n  .me-sm-148 {\n    margin-right: 73.5rem !important;\n  }\n\n  .me-sm-149 {\n    margin-right: 74rem !important;\n  }\n\n  .me-sm-150 {\n    margin-right: 74.5rem !important;\n  }\n\n  .me-sm-151 {\n    margin-right: 75rem !important;\n  }\n\n  .me-sm-152 {\n    margin-right: 75.5rem !important;\n  }\n\n  .me-sm-153 {\n    margin-right: 76rem !important;\n  }\n\n  .me-sm-154 {\n    margin-right: 76.5rem !important;\n  }\n\n  .me-sm-155 {\n    margin-right: 77rem !important;\n  }\n\n  .me-sm-156 {\n    margin-right: 77.5rem !important;\n  }\n\n  .me-sm-157 {\n    margin-right: 78rem !important;\n  }\n\n  .me-sm-158 {\n    margin-right: 78.5rem !important;\n  }\n\n  .me-sm-159 {\n    margin-right: 79rem !important;\n  }\n\n  .me-sm-160 {\n    margin-right: 79.5rem !important;\n  }\n\n  .mx-sm-0 {\n    margin-left: 0rem !important;\n    margin-right: 0rem !important;\n  }\n\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n    margin-right: 1rem !important;\n  }\n\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .mx-sm-5 {\n    margin-left: 2rem !important;\n    margin-right: 2rem !important;\n  }\n\n  .mx-sm-6 {\n    margin-left: 2.5rem !important;\n    margin-right: 2.5rem !important;\n  }\n\n  .mx-sm-7 {\n    margin-left: 3rem !important;\n    margin-right: 3rem !important;\n  }\n\n  .mx-sm-8 {\n    margin-left: 3.5rem !important;\n    margin-right: 3.5rem !important;\n  }\n\n  .mx-sm-9 {\n    margin-left: 4rem !important;\n    margin-right: 4rem !important;\n  }\n\n  .mx-sm-10 {\n    margin-left: 4.5rem !important;\n    margin-right: 4.5rem !important;\n  }\n\n  .mx-sm-11 {\n    margin-left: 5rem !important;\n    margin-right: 5rem !important;\n  }\n\n  .mx-sm-12 {\n    margin-left: 5.5rem !important;\n    margin-right: 5.5rem !important;\n  }\n\n  .mx-sm-13 {\n    margin-left: 6rem !important;\n    margin-right: 6rem !important;\n  }\n\n  .mx-sm-14 {\n    margin-left: 6.5rem !important;\n    margin-right: 6.5rem !important;\n  }\n\n  .mx-sm-15 {\n    margin-left: 7rem !important;\n    margin-right: 7rem !important;\n  }\n\n  .mx-sm-16 {\n    margin-left: 7.5rem !important;\n    margin-right: 7.5rem !important;\n  }\n\n  .mx-sm-17 {\n    margin-left: 8rem !important;\n    margin-right: 8rem !important;\n  }\n\n  .mx-sm-18 {\n    margin-left: 8.5rem !important;\n    margin-right: 8.5rem !important;\n  }\n\n  .mx-sm-19 {\n    margin-left: 9rem !important;\n    margin-right: 9rem !important;\n  }\n\n  .mx-sm-20 {\n    margin-left: 9.5rem !important;\n    margin-right: 9.5rem !important;\n  }\n\n  .mx-sm-21 {\n    margin-left: 10rem !important;\n    margin-right: 10rem !important;\n  }\n\n  .mx-sm-22 {\n    margin-left: 10.5rem !important;\n    margin-right: 10.5rem !important;\n  }\n\n  .mx-sm-23 {\n    margin-left: 11rem !important;\n    margin-right: 11rem !important;\n  }\n\n  .mx-sm-24 {\n    margin-left: 11.5rem !important;\n    margin-right: 11.5rem !important;\n  }\n\n  .mx-sm-25 {\n    margin-left: 12rem !important;\n    margin-right: 12rem !important;\n  }\n\n  .mx-sm-26 {\n    margin-left: 12.5rem !important;\n    margin-right: 12.5rem !important;\n  }\n\n  .mx-sm-27 {\n    margin-left: 13rem !important;\n    margin-right: 13rem !important;\n  }\n\n  .mx-sm-28 {\n    margin-left: 13.5rem !important;\n    margin-right: 13.5rem !important;\n  }\n\n  .mx-sm-29 {\n    margin-left: 14rem !important;\n    margin-right: 14rem !important;\n  }\n\n  .mx-sm-30 {\n    margin-left: 14.5rem !important;\n    margin-right: 14.5rem !important;\n  }\n\n  .mx-sm-31 {\n    margin-left: 15rem !important;\n    margin-right: 15rem !important;\n  }\n\n  .mx-sm-32 {\n    margin-left: 15.5rem !important;\n    margin-right: 15.5rem !important;\n  }\n\n  .mx-sm-33 {\n    margin-left: 16rem !important;\n    margin-right: 16rem !important;\n  }\n\n  .mx-sm-34 {\n    margin-left: 16.5rem !important;\n    margin-right: 16.5rem !important;\n  }\n\n  .mx-sm-35 {\n    margin-left: 17rem !important;\n    margin-right: 17rem !important;\n  }\n\n  .mx-sm-36 {\n    margin-left: 17.5rem !important;\n    margin-right: 17.5rem !important;\n  }\n\n  .mx-sm-37 {\n    margin-left: 18rem !important;\n    margin-right: 18rem !important;\n  }\n\n  .mx-sm-38 {\n    margin-left: 18.5rem !important;\n    margin-right: 18.5rem !important;\n  }\n\n  .mx-sm-39 {\n    margin-left: 19rem !important;\n    margin-right: 19rem !important;\n  }\n\n  .mx-sm-40 {\n    margin-left: 19.5rem !important;\n    margin-right: 19.5rem !important;\n  }\n\n  .mx-sm-41 {\n    margin-left: 20rem !important;\n    margin-right: 20rem !important;\n  }\n\n  .mx-sm-42 {\n    margin-left: 20.5rem !important;\n    margin-right: 20.5rem !important;\n  }\n\n  .mx-sm-43 {\n    margin-left: 21rem !important;\n    margin-right: 21rem !important;\n  }\n\n  .mx-sm-44 {\n    margin-left: 21.5rem !important;\n    margin-right: 21.5rem !important;\n  }\n\n  .mx-sm-45 {\n    margin-left: 22rem !important;\n    margin-right: 22rem !important;\n  }\n\n  .mx-sm-46 {\n    margin-left: 22.5rem !important;\n    margin-right: 22.5rem !important;\n  }\n\n  .mx-sm-47 {\n    margin-left: 23rem !important;\n    margin-right: 23rem !important;\n  }\n\n  .mx-sm-48 {\n    margin-left: 23.5rem !important;\n    margin-right: 23.5rem !important;\n  }\n\n  .mx-sm-49 {\n    margin-left: 24rem !important;\n    margin-right: 24rem !important;\n  }\n\n  .mx-sm-50 {\n    margin-left: 24.5rem !important;\n    margin-right: 24.5rem !important;\n  }\n\n  .mx-sm-51 {\n    margin-left: 25rem !important;\n    margin-right: 25rem !important;\n  }\n\n  .mx-sm-52 {\n    margin-left: 25.5rem !important;\n    margin-right: 25.5rem !important;\n  }\n\n  .mx-sm-53 {\n    margin-left: 26rem !important;\n    margin-right: 26rem !important;\n  }\n\n  .mx-sm-54 {\n    margin-left: 26.5rem !important;\n    margin-right: 26.5rem !important;\n  }\n\n  .mx-sm-55 {\n    margin-left: 27rem !important;\n    margin-right: 27rem !important;\n  }\n\n  .mx-sm-56 {\n    margin-left: 27.5rem !important;\n    margin-right: 27.5rem !important;\n  }\n\n  .mx-sm-57 {\n    margin-left: 28rem !important;\n    margin-right: 28rem !important;\n  }\n\n  .mx-sm-58 {\n    margin-left: 28.5rem !important;\n    margin-right: 28.5rem !important;\n  }\n\n  .mx-sm-59 {\n    margin-left: 29rem !important;\n    margin-right: 29rem !important;\n  }\n\n  .mx-sm-60 {\n    margin-left: 29.5rem !important;\n    margin-right: 29.5rem !important;\n  }\n\n  .mx-sm-61 {\n    margin-left: 30rem !important;\n    margin-right: 30rem !important;\n  }\n\n  .mx-sm-62 {\n    margin-left: 30.5rem !important;\n    margin-right: 30.5rem !important;\n  }\n\n  .mx-sm-63 {\n    margin-left: 31rem !important;\n    margin-right: 31rem !important;\n  }\n\n  .mx-sm-64 {\n    margin-left: 31.5rem !important;\n    margin-right: 31.5rem !important;\n  }\n\n  .mx-sm-65 {\n    margin-left: 32rem !important;\n    margin-right: 32rem !important;\n  }\n\n  .mx-sm-66 {\n    margin-left: 32.5rem !important;\n    margin-right: 32.5rem !important;\n  }\n\n  .mx-sm-67 {\n    margin-left: 33rem !important;\n    margin-right: 33rem !important;\n  }\n\n  .mx-sm-68 {\n    margin-left: 33.5rem !important;\n    margin-right: 33.5rem !important;\n  }\n\n  .mx-sm-69 {\n    margin-left: 34rem !important;\n    margin-right: 34rem !important;\n  }\n\n  .mx-sm-70 {\n    margin-left: 34.5rem !important;\n    margin-right: 34.5rem !important;\n  }\n\n  .mx-sm-71 {\n    margin-left: 35rem !important;\n    margin-right: 35rem !important;\n  }\n\n  .mx-sm-72 {\n    margin-left: 35.5rem !important;\n    margin-right: 35.5rem !important;\n  }\n\n  .mx-sm-73 {\n    margin-left: 36rem !important;\n    margin-right: 36rem !important;\n  }\n\n  .mx-sm-74 {\n    margin-left: 36.5rem !important;\n    margin-right: 36.5rem !important;\n  }\n\n  .mx-sm-75 {\n    margin-left: 37rem !important;\n    margin-right: 37rem !important;\n  }\n\n  .mx-sm-76 {\n    margin-left: 37.5rem !important;\n    margin-right: 37.5rem !important;\n  }\n\n  .mx-sm-77 {\n    margin-left: 38rem !important;\n    margin-right: 38rem !important;\n  }\n\n  .mx-sm-78 {\n    margin-left: 38.5rem !important;\n    margin-right: 38.5rem !important;\n  }\n\n  .mx-sm-79 {\n    margin-left: 39rem !important;\n    margin-right: 39rem !important;\n  }\n\n  .mx-sm-80 {\n    margin-left: 39.5rem !important;\n    margin-right: 39.5rem !important;\n  }\n\n  .mx-sm-81 {\n    margin-left: 40rem !important;\n    margin-right: 40rem !important;\n  }\n\n  .mx-sm-82 {\n    margin-left: 40.5rem !important;\n    margin-right: 40.5rem !important;\n  }\n\n  .mx-sm-83 {\n    margin-left: 41rem !important;\n    margin-right: 41rem !important;\n  }\n\n  .mx-sm-84 {\n    margin-left: 41.5rem !important;\n    margin-right: 41.5rem !important;\n  }\n\n  .mx-sm-85 {\n    margin-left: 42rem !important;\n    margin-right: 42rem !important;\n  }\n\n  .mx-sm-86 {\n    margin-left: 42.5rem !important;\n    margin-right: 42.5rem !important;\n  }\n\n  .mx-sm-87 {\n    margin-left: 43rem !important;\n    margin-right: 43rem !important;\n  }\n\n  .mx-sm-88 {\n    margin-left: 43.5rem !important;\n    margin-right: 43.5rem !important;\n  }\n\n  .mx-sm-89 {\n    margin-left: 44rem !important;\n    margin-right: 44rem !important;\n  }\n\n  .mx-sm-90 {\n    margin-left: 44.5rem !important;\n    margin-right: 44.5rem !important;\n  }\n\n  .mx-sm-91 {\n    margin-left: 45rem !important;\n    margin-right: 45rem !important;\n  }\n\n  .mx-sm-92 {\n    margin-left: 45.5rem !important;\n    margin-right: 45.5rem !important;\n  }\n\n  .mx-sm-93 {\n    margin-left: 46rem !important;\n    margin-right: 46rem !important;\n  }\n\n  .mx-sm-94 {\n    margin-left: 46.5rem !important;\n    margin-right: 46.5rem !important;\n  }\n\n  .mx-sm-95 {\n    margin-left: 47rem !important;\n    margin-right: 47rem !important;\n  }\n\n  .mx-sm-96 {\n    margin-left: 47.5rem !important;\n    margin-right: 47.5rem !important;\n  }\n\n  .mx-sm-97 {\n    margin-left: 48rem !important;\n    margin-right: 48rem !important;\n  }\n\n  .mx-sm-98 {\n    margin-left: 48.5rem !important;\n    margin-right: 48.5rem !important;\n  }\n\n  .mx-sm-99 {\n    margin-left: 49rem !important;\n    margin-right: 49rem !important;\n  }\n\n  .mx-sm-100 {\n    margin-left: 49.5rem !important;\n    margin-right: 49.5rem !important;\n  }\n\n  .mx-sm-101 {\n    margin-left: 50rem !important;\n    margin-right: 50rem !important;\n  }\n\n  .mx-sm-102 {\n    margin-left: 50.5rem !important;\n    margin-right: 50.5rem !important;\n  }\n\n  .mx-sm-103 {\n    margin-left: 51rem !important;\n    margin-right: 51rem !important;\n  }\n\n  .mx-sm-104 {\n    margin-left: 51.5rem !important;\n    margin-right: 51.5rem !important;\n  }\n\n  .mx-sm-105 {\n    margin-left: 52rem !important;\n    margin-right: 52rem !important;\n  }\n\n  .mx-sm-106 {\n    margin-left: 52.5rem !important;\n    margin-right: 52.5rem !important;\n  }\n\n  .mx-sm-107 {\n    margin-left: 53rem !important;\n    margin-right: 53rem !important;\n  }\n\n  .mx-sm-108 {\n    margin-left: 53.5rem !important;\n    margin-right: 53.5rem !important;\n  }\n\n  .mx-sm-109 {\n    margin-left: 54rem !important;\n    margin-right: 54rem !important;\n  }\n\n  .mx-sm-110 {\n    margin-left: 54.5rem !important;\n    margin-right: 54.5rem !important;\n  }\n\n  .mx-sm-111 {\n    margin-left: 55rem !important;\n    margin-right: 55rem !important;\n  }\n\n  .mx-sm-112 {\n    margin-left: 55.5rem !important;\n    margin-right: 55.5rem !important;\n  }\n\n  .mx-sm-113 {\n    margin-left: 56rem !important;\n    margin-right: 56rem !important;\n  }\n\n  .mx-sm-114 {\n    margin-left: 56.5rem !important;\n    margin-right: 56.5rem !important;\n  }\n\n  .mx-sm-115 {\n    margin-left: 57rem !important;\n    margin-right: 57rem !important;\n  }\n\n  .mx-sm-116 {\n    margin-left: 57.5rem !important;\n    margin-right: 57.5rem !important;\n  }\n\n  .mx-sm-117 {\n    margin-left: 58rem !important;\n    margin-right: 58rem !important;\n  }\n\n  .mx-sm-118 {\n    margin-left: 58.5rem !important;\n    margin-right: 58.5rem !important;\n  }\n\n  .mx-sm-119 {\n    margin-left: 59rem !important;\n    margin-right: 59rem !important;\n  }\n\n  .mx-sm-120 {\n    margin-left: 59.5rem !important;\n    margin-right: 59.5rem !important;\n  }\n\n  .mx-sm-121 {\n    margin-left: 60rem !important;\n    margin-right: 60rem !important;\n  }\n\n  .mx-sm-122 {\n    margin-left: 60.5rem !important;\n    margin-right: 60.5rem !important;\n  }\n\n  .mx-sm-123 {\n    margin-left: 61rem !important;\n    margin-right: 61rem !important;\n  }\n\n  .mx-sm-124 {\n    margin-left: 61.5rem !important;\n    margin-right: 61.5rem !important;\n  }\n\n  .mx-sm-125 {\n    margin-left: 62rem !important;\n    margin-right: 62rem !important;\n  }\n\n  .mx-sm-126 {\n    margin-left: 62.5rem !important;\n    margin-right: 62.5rem !important;\n  }\n\n  .mx-sm-127 {\n    margin-left: 63rem !important;\n    margin-right: 63rem !important;\n  }\n\n  .mx-sm-128 {\n    margin-left: 63.5rem !important;\n    margin-right: 63.5rem !important;\n  }\n\n  .mx-sm-129 {\n    margin-left: 64rem !important;\n    margin-right: 64rem !important;\n  }\n\n  .mx-sm-130 {\n    margin-left: 64.5rem !important;\n    margin-right: 64.5rem !important;\n  }\n\n  .mx-sm-131 {\n    margin-left: 65rem !important;\n    margin-right: 65rem !important;\n  }\n\n  .mx-sm-132 {\n    margin-left: 65.5rem !important;\n    margin-right: 65.5rem !important;\n  }\n\n  .mx-sm-133 {\n    margin-left: 66rem !important;\n    margin-right: 66rem !important;\n  }\n\n  .mx-sm-134 {\n    margin-left: 66.5rem !important;\n    margin-right: 66.5rem !important;\n  }\n\n  .mx-sm-135 {\n    margin-left: 67rem !important;\n    margin-right: 67rem !important;\n  }\n\n  .mx-sm-136 {\n    margin-left: 67.5rem !important;\n    margin-right: 67.5rem !important;\n  }\n\n  .mx-sm-137 {\n    margin-left: 68rem !important;\n    margin-right: 68rem !important;\n  }\n\n  .mx-sm-138 {\n    margin-left: 68.5rem !important;\n    margin-right: 68.5rem !important;\n  }\n\n  .mx-sm-139 {\n    margin-left: 69rem !important;\n    margin-right: 69rem !important;\n  }\n\n  .mx-sm-140 {\n    margin-left: 69.5rem !important;\n    margin-right: 69.5rem !important;\n  }\n\n  .mx-sm-141 {\n    margin-left: 70rem !important;\n    margin-right: 70rem !important;\n  }\n\n  .mx-sm-142 {\n    margin-left: 70.5rem !important;\n    margin-right: 70.5rem !important;\n  }\n\n  .mx-sm-143 {\n    margin-left: 71rem !important;\n    margin-right: 71rem !important;\n  }\n\n  .mx-sm-144 {\n    margin-left: 71.5rem !important;\n    margin-right: 71.5rem !important;\n  }\n\n  .mx-sm-145 {\n    margin-left: 72rem !important;\n    margin-right: 72rem !important;\n  }\n\n  .mx-sm-146 {\n    margin-left: 72.5rem !important;\n    margin-right: 72.5rem !important;\n  }\n\n  .mx-sm-147 {\n    margin-left: 73rem !important;\n    margin-right: 73rem !important;\n  }\n\n  .mx-sm-148 {\n    margin-left: 73.5rem !important;\n    margin-right: 73.5rem !important;\n  }\n\n  .mx-sm-149 {\n    margin-left: 74rem !important;\n    margin-right: 74rem !important;\n  }\n\n  .mx-sm-150 {\n    margin-left: 74.5rem !important;\n    margin-right: 74.5rem !important;\n  }\n\n  .mx-sm-151 {\n    margin-left: 75rem !important;\n    margin-right: 75rem !important;\n  }\n\n  .mx-sm-152 {\n    margin-left: 75.5rem !important;\n    margin-right: 75.5rem !important;\n  }\n\n  .mx-sm-153 {\n    margin-left: 76rem !important;\n    margin-right: 76rem !important;\n  }\n\n  .mx-sm-154 {\n    margin-left: 76.5rem !important;\n    margin-right: 76.5rem !important;\n  }\n\n  .mx-sm-155 {\n    margin-left: 77rem !important;\n    margin-right: 77rem !important;\n  }\n\n  .mx-sm-156 {\n    margin-left: 77.5rem !important;\n    margin-right: 77.5rem !important;\n  }\n\n  .mx-sm-157 {\n    margin-left: 78rem !important;\n    margin-right: 78rem !important;\n  }\n\n  .mx-sm-158 {\n    margin-left: 78.5rem !important;\n    margin-right: 78.5rem !important;\n  }\n\n  .mx-sm-159 {\n    margin-left: 79rem !important;\n    margin-right: 79rem !important;\n  }\n\n  .mx-sm-160 {\n    margin-left: 79.5rem !important;\n    margin-right: 79.5rem !important;\n  }\n\n  .my-sm-0 {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem !important;\n  }\n\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-sm-5 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-sm-6 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-sm-7 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-sm-8 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-sm-9 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-sm-10 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-sm-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-sm-12 {\n    margin-top: 5.5rem !important;\n    margin-bottom: 5.5rem !important;\n  }\n\n  .my-sm-13 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n\n  .my-sm-14 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n\n  .my-sm-15 {\n    margin-top: 7rem !important;\n    margin-bottom: 7rem !important;\n  }\n\n  .my-sm-16 {\n    margin-top: 7.5rem !important;\n    margin-bottom: 7.5rem !important;\n  }\n\n  .my-sm-17 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n\n  .my-sm-18 {\n    margin-top: 8.5rem !important;\n    margin-bottom: 8.5rem !important;\n  }\n\n  .my-sm-19 {\n    margin-top: 9rem !important;\n    margin-bottom: 9rem !important;\n  }\n\n  .my-sm-20 {\n    margin-top: 9.5rem !important;\n    margin-bottom: 9.5rem !important;\n  }\n\n  .my-sm-21 {\n    margin-top: 10rem !important;\n    margin-bottom: 10rem !important;\n  }\n\n  .my-sm-22 {\n    margin-top: 10.5rem !important;\n    margin-bottom: 10.5rem !important;\n  }\n\n  .my-sm-23 {\n    margin-top: 11rem !important;\n    margin-bottom: 11rem !important;\n  }\n\n  .my-sm-24 {\n    margin-top: 11.5rem !important;\n    margin-bottom: 11.5rem !important;\n  }\n\n  .my-sm-25 {\n    margin-top: 12rem !important;\n    margin-bottom: 12rem !important;\n  }\n\n  .my-sm-26 {\n    margin-top: 12.5rem !important;\n    margin-bottom: 12.5rem !important;\n  }\n\n  .my-sm-27 {\n    margin-top: 13rem !important;\n    margin-bottom: 13rem !important;\n  }\n\n  .my-sm-28 {\n    margin-top: 13.5rem !important;\n    margin-bottom: 13.5rem !important;\n  }\n\n  .my-sm-29 {\n    margin-top: 14rem !important;\n    margin-bottom: 14rem !important;\n  }\n\n  .my-sm-30 {\n    margin-top: 14.5rem !important;\n    margin-bottom: 14.5rem !important;\n  }\n\n  .my-sm-31 {\n    margin-top: 15rem !important;\n    margin-bottom: 15rem !important;\n  }\n\n  .my-sm-32 {\n    margin-top: 15.5rem !important;\n    margin-bottom: 15.5rem !important;\n  }\n\n  .my-sm-33 {\n    margin-top: 16rem !important;\n    margin-bottom: 16rem !important;\n  }\n\n  .my-sm-34 {\n    margin-top: 16.5rem !important;\n    margin-bottom: 16.5rem !important;\n  }\n\n  .my-sm-35 {\n    margin-top: 17rem !important;\n    margin-bottom: 17rem !important;\n  }\n\n  .my-sm-36 {\n    margin-top: 17.5rem !important;\n    margin-bottom: 17.5rem !important;\n  }\n\n  .my-sm-37 {\n    margin-top: 18rem !important;\n    margin-bottom: 18rem !important;\n  }\n\n  .my-sm-38 {\n    margin-top: 18.5rem !important;\n    margin-bottom: 18.5rem !important;\n  }\n\n  .my-sm-39 {\n    margin-top: 19rem !important;\n    margin-bottom: 19rem !important;\n  }\n\n  .my-sm-40 {\n    margin-top: 19.5rem !important;\n    margin-bottom: 19.5rem !important;\n  }\n\n  .my-sm-41 {\n    margin-top: 20rem !important;\n    margin-bottom: 20rem !important;\n  }\n\n  .my-sm-42 {\n    margin-top: 20.5rem !important;\n    margin-bottom: 20.5rem !important;\n  }\n\n  .my-sm-43 {\n    margin-top: 21rem !important;\n    margin-bottom: 21rem !important;\n  }\n\n  .my-sm-44 {\n    margin-top: 21.5rem !important;\n    margin-bottom: 21.5rem !important;\n  }\n\n  .my-sm-45 {\n    margin-top: 22rem !important;\n    margin-bottom: 22rem !important;\n  }\n\n  .my-sm-46 {\n    margin-top: 22.5rem !important;\n    margin-bottom: 22.5rem !important;\n  }\n\n  .my-sm-47 {\n    margin-top: 23rem !important;\n    margin-bottom: 23rem !important;\n  }\n\n  .my-sm-48 {\n    margin-top: 23.5rem !important;\n    margin-bottom: 23.5rem !important;\n  }\n\n  .my-sm-49 {\n    margin-top: 24rem !important;\n    margin-bottom: 24rem !important;\n  }\n\n  .my-sm-50 {\n    margin-top: 24.5rem !important;\n    margin-bottom: 24.5rem !important;\n  }\n\n  .my-sm-51 {\n    margin-top: 25rem !important;\n    margin-bottom: 25rem !important;\n  }\n\n  .my-sm-52 {\n    margin-top: 25.5rem !important;\n    margin-bottom: 25.5rem !important;\n  }\n\n  .my-sm-53 {\n    margin-top: 26rem !important;\n    margin-bottom: 26rem !important;\n  }\n\n  .my-sm-54 {\n    margin-top: 26.5rem !important;\n    margin-bottom: 26.5rem !important;\n  }\n\n  .my-sm-55 {\n    margin-top: 27rem !important;\n    margin-bottom: 27rem !important;\n  }\n\n  .my-sm-56 {\n    margin-top: 27.5rem !important;\n    margin-bottom: 27.5rem !important;\n  }\n\n  .my-sm-57 {\n    margin-top: 28rem !important;\n    margin-bottom: 28rem !important;\n  }\n\n  .my-sm-58 {\n    margin-top: 28.5rem !important;\n    margin-bottom: 28.5rem !important;\n  }\n\n  .my-sm-59 {\n    margin-top: 29rem !important;\n    margin-bottom: 29rem !important;\n  }\n\n  .my-sm-60 {\n    margin-top: 29.5rem !important;\n    margin-bottom: 29.5rem !important;\n  }\n\n  .my-sm-61 {\n    margin-top: 30rem !important;\n    margin-bottom: 30rem !important;\n  }\n\n  .my-sm-62 {\n    margin-top: 30.5rem !important;\n    margin-bottom: 30.5rem !important;\n  }\n\n  .my-sm-63 {\n    margin-top: 31rem !important;\n    margin-bottom: 31rem !important;\n  }\n\n  .my-sm-64 {\n    margin-top: 31.5rem !important;\n    margin-bottom: 31.5rem !important;\n  }\n\n  .my-sm-65 {\n    margin-top: 32rem !important;\n    margin-bottom: 32rem !important;\n  }\n\n  .my-sm-66 {\n    margin-top: 32.5rem !important;\n    margin-bottom: 32.5rem !important;\n  }\n\n  .my-sm-67 {\n    margin-top: 33rem !important;\n    margin-bottom: 33rem !important;\n  }\n\n  .my-sm-68 {\n    margin-top: 33.5rem !important;\n    margin-bottom: 33.5rem !important;\n  }\n\n  .my-sm-69 {\n    margin-top: 34rem !important;\n    margin-bottom: 34rem !important;\n  }\n\n  .my-sm-70 {\n    margin-top: 34.5rem !important;\n    margin-bottom: 34.5rem !important;\n  }\n\n  .my-sm-71 {\n    margin-top: 35rem !important;\n    margin-bottom: 35rem !important;\n  }\n\n  .my-sm-72 {\n    margin-top: 35.5rem !important;\n    margin-bottom: 35.5rem !important;\n  }\n\n  .my-sm-73 {\n    margin-top: 36rem !important;\n    margin-bottom: 36rem !important;\n  }\n\n  .my-sm-74 {\n    margin-top: 36.5rem !important;\n    margin-bottom: 36.5rem !important;\n  }\n\n  .my-sm-75 {\n    margin-top: 37rem !important;\n    margin-bottom: 37rem !important;\n  }\n\n  .my-sm-76 {\n    margin-top: 37.5rem !important;\n    margin-bottom: 37.5rem !important;\n  }\n\n  .my-sm-77 {\n    margin-top: 38rem !important;\n    margin-bottom: 38rem !important;\n  }\n\n  .my-sm-78 {\n    margin-top: 38.5rem !important;\n    margin-bottom: 38.5rem !important;\n  }\n\n  .my-sm-79 {\n    margin-top: 39rem !important;\n    margin-bottom: 39rem !important;\n  }\n\n  .my-sm-80 {\n    margin-top: 39.5rem !important;\n    margin-bottom: 39.5rem !important;\n  }\n\n  .my-sm-81 {\n    margin-top: 40rem !important;\n    margin-bottom: 40rem !important;\n  }\n\n  .my-sm-82 {\n    margin-top: 40.5rem !important;\n    margin-bottom: 40.5rem !important;\n  }\n\n  .my-sm-83 {\n    margin-top: 41rem !important;\n    margin-bottom: 41rem !important;\n  }\n\n  .my-sm-84 {\n    margin-top: 41.5rem !important;\n    margin-bottom: 41.5rem !important;\n  }\n\n  .my-sm-85 {\n    margin-top: 42rem !important;\n    margin-bottom: 42rem !important;\n  }\n\n  .my-sm-86 {\n    margin-top: 42.5rem !important;\n    margin-bottom: 42.5rem !important;\n  }\n\n  .my-sm-87 {\n    margin-top: 43rem !important;\n    margin-bottom: 43rem !important;\n  }\n\n  .my-sm-88 {\n    margin-top: 43.5rem !important;\n    margin-bottom: 43.5rem !important;\n  }\n\n  .my-sm-89 {\n    margin-top: 44rem !important;\n    margin-bottom: 44rem !important;\n  }\n\n  .my-sm-90 {\n    margin-top: 44.5rem !important;\n    margin-bottom: 44.5rem !important;\n  }\n\n  .my-sm-91 {\n    margin-top: 45rem !important;\n    margin-bottom: 45rem !important;\n  }\n\n  .my-sm-92 {\n    margin-top: 45.5rem !important;\n    margin-bottom: 45.5rem !important;\n  }\n\n  .my-sm-93 {\n    margin-top: 46rem !important;\n    margin-bottom: 46rem !important;\n  }\n\n  .my-sm-94 {\n    margin-top: 46.5rem !important;\n    margin-bottom: 46.5rem !important;\n  }\n\n  .my-sm-95 {\n    margin-top: 47rem !important;\n    margin-bottom: 47rem !important;\n  }\n\n  .my-sm-96 {\n    margin-top: 47.5rem !important;\n    margin-bottom: 47.5rem !important;\n  }\n\n  .my-sm-97 {\n    margin-top: 48rem !important;\n    margin-bottom: 48rem !important;\n  }\n\n  .my-sm-98 {\n    margin-top: 48.5rem !important;\n    margin-bottom: 48.5rem !important;\n  }\n\n  .my-sm-99 {\n    margin-top: 49rem !important;\n    margin-bottom: 49rem !important;\n  }\n\n  .my-sm-100 {\n    margin-top: 49.5rem !important;\n    margin-bottom: 49.5rem !important;\n  }\n\n  .my-sm-101 {\n    margin-top: 50rem !important;\n    margin-bottom: 50rem !important;\n  }\n\n  .my-sm-102 {\n    margin-top: 50.5rem !important;\n    margin-bottom: 50.5rem !important;\n  }\n\n  .my-sm-103 {\n    margin-top: 51rem !important;\n    margin-bottom: 51rem !important;\n  }\n\n  .my-sm-104 {\n    margin-top: 51.5rem !important;\n    margin-bottom: 51.5rem !important;\n  }\n\n  .my-sm-105 {\n    margin-top: 52rem !important;\n    margin-bottom: 52rem !important;\n  }\n\n  .my-sm-106 {\n    margin-top: 52.5rem !important;\n    margin-bottom: 52.5rem !important;\n  }\n\n  .my-sm-107 {\n    margin-top: 53rem !important;\n    margin-bottom: 53rem !important;\n  }\n\n  .my-sm-108 {\n    margin-top: 53.5rem !important;\n    margin-bottom: 53.5rem !important;\n  }\n\n  .my-sm-109 {\n    margin-top: 54rem !important;\n    margin-bottom: 54rem !important;\n  }\n\n  .my-sm-110 {\n    margin-top: 54.5rem !important;\n    margin-bottom: 54.5rem !important;\n  }\n\n  .my-sm-111 {\n    margin-top: 55rem !important;\n    margin-bottom: 55rem !important;\n  }\n\n  .my-sm-112 {\n    margin-top: 55.5rem !important;\n    margin-bottom: 55.5rem !important;\n  }\n\n  .my-sm-113 {\n    margin-top: 56rem !important;\n    margin-bottom: 56rem !important;\n  }\n\n  .my-sm-114 {\n    margin-top: 56.5rem !important;\n    margin-bottom: 56.5rem !important;\n  }\n\n  .my-sm-115 {\n    margin-top: 57rem !important;\n    margin-bottom: 57rem !important;\n  }\n\n  .my-sm-116 {\n    margin-top: 57.5rem !important;\n    margin-bottom: 57.5rem !important;\n  }\n\n  .my-sm-117 {\n    margin-top: 58rem !important;\n    margin-bottom: 58rem !important;\n  }\n\n  .my-sm-118 {\n    margin-top: 58.5rem !important;\n    margin-bottom: 58.5rem !important;\n  }\n\n  .my-sm-119 {\n    margin-top: 59rem !important;\n    margin-bottom: 59rem !important;\n  }\n\n  .my-sm-120 {\n    margin-top: 59.5rem !important;\n    margin-bottom: 59.5rem !important;\n  }\n\n  .my-sm-121 {\n    margin-top: 60rem !important;\n    margin-bottom: 60rem !important;\n  }\n\n  .my-sm-122 {\n    margin-top: 60.5rem !important;\n    margin-bottom: 60.5rem !important;\n  }\n\n  .my-sm-123 {\n    margin-top: 61rem !important;\n    margin-bottom: 61rem !important;\n  }\n\n  .my-sm-124 {\n    margin-top: 61.5rem !important;\n    margin-bottom: 61.5rem !important;\n  }\n\n  .my-sm-125 {\n    margin-top: 62rem !important;\n    margin-bottom: 62rem !important;\n  }\n\n  .my-sm-126 {\n    margin-top: 62.5rem !important;\n    margin-bottom: 62.5rem !important;\n  }\n\n  .my-sm-127 {\n    margin-top: 63rem !important;\n    margin-bottom: 63rem !important;\n  }\n\n  .my-sm-128 {\n    margin-top: 63.5rem !important;\n    margin-bottom: 63.5rem !important;\n  }\n\n  .my-sm-129 {\n    margin-top: 64rem !important;\n    margin-bottom: 64rem !important;\n  }\n\n  .my-sm-130 {\n    margin-top: 64.5rem !important;\n    margin-bottom: 64.5rem !important;\n  }\n\n  .my-sm-131 {\n    margin-top: 65rem !important;\n    margin-bottom: 65rem !important;\n  }\n\n  .my-sm-132 {\n    margin-top: 65.5rem !important;\n    margin-bottom: 65.5rem !important;\n  }\n\n  .my-sm-133 {\n    margin-top: 66rem !important;\n    margin-bottom: 66rem !important;\n  }\n\n  .my-sm-134 {\n    margin-top: 66.5rem !important;\n    margin-bottom: 66.5rem !important;\n  }\n\n  .my-sm-135 {\n    margin-top: 67rem !important;\n    margin-bottom: 67rem !important;\n  }\n\n  .my-sm-136 {\n    margin-top: 67.5rem !important;\n    margin-bottom: 67.5rem !important;\n  }\n\n  .my-sm-137 {\n    margin-top: 68rem !important;\n    margin-bottom: 68rem !important;\n  }\n\n  .my-sm-138 {\n    margin-top: 68.5rem !important;\n    margin-bottom: 68.5rem !important;\n  }\n\n  .my-sm-139 {\n    margin-top: 69rem !important;\n    margin-bottom: 69rem !important;\n  }\n\n  .my-sm-140 {\n    margin-top: 69.5rem !important;\n    margin-bottom: 69.5rem !important;\n  }\n\n  .my-sm-141 {\n    margin-top: 70rem !important;\n    margin-bottom: 70rem !important;\n  }\n\n  .my-sm-142 {\n    margin-top: 70.5rem !important;\n    margin-bottom: 70.5rem !important;\n  }\n\n  .my-sm-143 {\n    margin-top: 71rem !important;\n    margin-bottom: 71rem !important;\n  }\n\n  .my-sm-144 {\n    margin-top: 71.5rem !important;\n    margin-bottom: 71.5rem !important;\n  }\n\n  .my-sm-145 {\n    margin-top: 72rem !important;\n    margin-bottom: 72rem !important;\n  }\n\n  .my-sm-146 {\n    margin-top: 72.5rem !important;\n    margin-bottom: 72.5rem !important;\n  }\n\n  .my-sm-147 {\n    margin-top: 73rem !important;\n    margin-bottom: 73rem !important;\n  }\n\n  .my-sm-148 {\n    margin-top: 73.5rem !important;\n    margin-bottom: 73.5rem !important;\n  }\n\n  .my-sm-149 {\n    margin-top: 74rem !important;\n    margin-bottom: 74rem !important;\n  }\n\n  .my-sm-150 {\n    margin-top: 74.5rem !important;\n    margin-bottom: 74.5rem !important;\n  }\n\n  .my-sm-151 {\n    margin-top: 75rem !important;\n    margin-bottom: 75rem !important;\n  }\n\n  .my-sm-152 {\n    margin-top: 75.5rem !important;\n    margin-bottom: 75.5rem !important;\n  }\n\n  .my-sm-153 {\n    margin-top: 76rem !important;\n    margin-bottom: 76rem !important;\n  }\n\n  .my-sm-154 {\n    margin-top: 76.5rem !important;\n    margin-bottom: 76.5rem !important;\n  }\n\n  .my-sm-155 {\n    margin-top: 77rem !important;\n    margin-bottom: 77rem !important;\n  }\n\n  .my-sm-156 {\n    margin-top: 77.5rem !important;\n    margin-bottom: 77.5rem !important;\n  }\n\n  .my-sm-157 {\n    margin-top: 78rem !important;\n    margin-bottom: 78rem !important;\n  }\n\n  .my-sm-158 {\n    margin-top: 78.5rem !important;\n    margin-bottom: 78.5rem !important;\n  }\n\n  .my-sm-159 {\n    margin-top: 79rem !important;\n    margin-bottom: 79rem !important;\n  }\n\n  .my-sm-160 {\n    margin-top: 79.5rem !important;\n    margin-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0rem !important;\n  }\n\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-md-5 {\n    margin: 2rem !important;\n  }\n\n  .m-md-6 {\n    margin: 2.5rem !important;\n  }\n\n  .m-md-7 {\n    margin: 3rem !important;\n  }\n\n  .m-md-8 {\n    margin: 3.5rem !important;\n  }\n\n  .m-md-9 {\n    margin: 4rem !important;\n  }\n\n  .m-md-10 {\n    margin: 4.5rem !important;\n  }\n\n  .m-md-11 {\n    margin: 5rem !important;\n  }\n\n  .m-md-12 {\n    margin: 5.5rem !important;\n  }\n\n  .m-md-13 {\n    margin: 6rem !important;\n  }\n\n  .m-md-14 {\n    margin: 6.5rem !important;\n  }\n\n  .m-md-15 {\n    margin: 7rem !important;\n  }\n\n  .m-md-16 {\n    margin: 7.5rem !important;\n  }\n\n  .m-md-17 {\n    margin: 8rem !important;\n  }\n\n  .m-md-18 {\n    margin: 8.5rem !important;\n  }\n\n  .m-md-19 {\n    margin: 9rem !important;\n  }\n\n  .m-md-20 {\n    margin: 9.5rem !important;\n  }\n\n  .m-md-21 {\n    margin: 10rem !important;\n  }\n\n  .m-md-22 {\n    margin: 10.5rem !important;\n  }\n\n  .m-md-23 {\n    margin: 11rem !important;\n  }\n\n  .m-md-24 {\n    margin: 11.5rem !important;\n  }\n\n  .m-md-25 {\n    margin: 12rem !important;\n  }\n\n  .m-md-26 {\n    margin: 12.5rem !important;\n  }\n\n  .m-md-27 {\n    margin: 13rem !important;\n  }\n\n  .m-md-28 {\n    margin: 13.5rem !important;\n  }\n\n  .m-md-29 {\n    margin: 14rem !important;\n  }\n\n  .m-md-30 {\n    margin: 14.5rem !important;\n  }\n\n  .m-md-31 {\n    margin: 15rem !important;\n  }\n\n  .m-md-32 {\n    margin: 15.5rem !important;\n  }\n\n  .m-md-33 {\n    margin: 16rem !important;\n  }\n\n  .m-md-34 {\n    margin: 16.5rem !important;\n  }\n\n  .m-md-35 {\n    margin: 17rem !important;\n  }\n\n  .m-md-36 {\n    margin: 17.5rem !important;\n  }\n\n  .m-md-37 {\n    margin: 18rem !important;\n  }\n\n  .m-md-38 {\n    margin: 18.5rem !important;\n  }\n\n  .m-md-39 {\n    margin: 19rem !important;\n  }\n\n  .m-md-40 {\n    margin: 19.5rem !important;\n  }\n\n  .m-md-41 {\n    margin: 20rem !important;\n  }\n\n  .m-md-42 {\n    margin: 20.5rem !important;\n  }\n\n  .m-md-43 {\n    margin: 21rem !important;\n  }\n\n  .m-md-44 {\n    margin: 21.5rem !important;\n  }\n\n  .m-md-45 {\n    margin: 22rem !important;\n  }\n\n  .m-md-46 {\n    margin: 22.5rem !important;\n  }\n\n  .m-md-47 {\n    margin: 23rem !important;\n  }\n\n  .m-md-48 {\n    margin: 23.5rem !important;\n  }\n\n  .m-md-49 {\n    margin: 24rem !important;\n  }\n\n  .m-md-50 {\n    margin: 24.5rem !important;\n  }\n\n  .m-md-51 {\n    margin: 25rem !important;\n  }\n\n  .m-md-52 {\n    margin: 25.5rem !important;\n  }\n\n  .m-md-53 {\n    margin: 26rem !important;\n  }\n\n  .m-md-54 {\n    margin: 26.5rem !important;\n  }\n\n  .m-md-55 {\n    margin: 27rem !important;\n  }\n\n  .m-md-56 {\n    margin: 27.5rem !important;\n  }\n\n  .m-md-57 {\n    margin: 28rem !important;\n  }\n\n  .m-md-58 {\n    margin: 28.5rem !important;\n  }\n\n  .m-md-59 {\n    margin: 29rem !important;\n  }\n\n  .m-md-60 {\n    margin: 29.5rem !important;\n  }\n\n  .m-md-61 {\n    margin: 30rem !important;\n  }\n\n  .m-md-62 {\n    margin: 30.5rem !important;\n  }\n\n  .m-md-63 {\n    margin: 31rem !important;\n  }\n\n  .m-md-64 {\n    margin: 31.5rem !important;\n  }\n\n  .m-md-65 {\n    margin: 32rem !important;\n  }\n\n  .m-md-66 {\n    margin: 32.5rem !important;\n  }\n\n  .m-md-67 {\n    margin: 33rem !important;\n  }\n\n  .m-md-68 {\n    margin: 33.5rem !important;\n  }\n\n  .m-md-69 {\n    margin: 34rem !important;\n  }\n\n  .m-md-70 {\n    margin: 34.5rem !important;\n  }\n\n  .m-md-71 {\n    margin: 35rem !important;\n  }\n\n  .m-md-72 {\n    margin: 35.5rem !important;\n  }\n\n  .m-md-73 {\n    margin: 36rem !important;\n  }\n\n  .m-md-74 {\n    margin: 36.5rem !important;\n  }\n\n  .m-md-75 {\n    margin: 37rem !important;\n  }\n\n  .m-md-76 {\n    margin: 37.5rem !important;\n  }\n\n  .m-md-77 {\n    margin: 38rem !important;\n  }\n\n  .m-md-78 {\n    margin: 38.5rem !important;\n  }\n\n  .m-md-79 {\n    margin: 39rem !important;\n  }\n\n  .m-md-80 {\n    margin: 39.5rem !important;\n  }\n\n  .m-md-81 {\n    margin: 40rem !important;\n  }\n\n  .m-md-82 {\n    margin: 40.5rem !important;\n  }\n\n  .m-md-83 {\n    margin: 41rem !important;\n  }\n\n  .m-md-84 {\n    margin: 41.5rem !important;\n  }\n\n  .m-md-85 {\n    margin: 42rem !important;\n  }\n\n  .m-md-86 {\n    margin: 42.5rem !important;\n  }\n\n  .m-md-87 {\n    margin: 43rem !important;\n  }\n\n  .m-md-88 {\n    margin: 43.5rem !important;\n  }\n\n  .m-md-89 {\n    margin: 44rem !important;\n  }\n\n  .m-md-90 {\n    margin: 44.5rem !important;\n  }\n\n  .m-md-91 {\n    margin: 45rem !important;\n  }\n\n  .m-md-92 {\n    margin: 45.5rem !important;\n  }\n\n  .m-md-93 {\n    margin: 46rem !important;\n  }\n\n  .m-md-94 {\n    margin: 46.5rem !important;\n  }\n\n  .m-md-95 {\n    margin: 47rem !important;\n  }\n\n  .m-md-96 {\n    margin: 47.5rem !important;\n  }\n\n  .m-md-97 {\n    margin: 48rem !important;\n  }\n\n  .m-md-98 {\n    margin: 48.5rem !important;\n  }\n\n  .m-md-99 {\n    margin: 49rem !important;\n  }\n\n  .m-md-100 {\n    margin: 49.5rem !important;\n  }\n\n  .m-md-101 {\n    margin: 50rem !important;\n  }\n\n  .m-md-102 {\n    margin: 50.5rem !important;\n  }\n\n  .m-md-103 {\n    margin: 51rem !important;\n  }\n\n  .m-md-104 {\n    margin: 51.5rem !important;\n  }\n\n  .m-md-105 {\n    margin: 52rem !important;\n  }\n\n  .m-md-106 {\n    margin: 52.5rem !important;\n  }\n\n  .m-md-107 {\n    margin: 53rem !important;\n  }\n\n  .m-md-108 {\n    margin: 53.5rem !important;\n  }\n\n  .m-md-109 {\n    margin: 54rem !important;\n  }\n\n  .m-md-110 {\n    margin: 54.5rem !important;\n  }\n\n  .m-md-111 {\n    margin: 55rem !important;\n  }\n\n  .m-md-112 {\n    margin: 55.5rem !important;\n  }\n\n  .m-md-113 {\n    margin: 56rem !important;\n  }\n\n  .m-md-114 {\n    margin: 56.5rem !important;\n  }\n\n  .m-md-115 {\n    margin: 57rem !important;\n  }\n\n  .m-md-116 {\n    margin: 57.5rem !important;\n  }\n\n  .m-md-117 {\n    margin: 58rem !important;\n  }\n\n  .m-md-118 {\n    margin: 58.5rem !important;\n  }\n\n  .m-md-119 {\n    margin: 59rem !important;\n  }\n\n  .m-md-120 {\n    margin: 59.5rem !important;\n  }\n\n  .m-md-121 {\n    margin: 60rem !important;\n  }\n\n  .m-md-122 {\n    margin: 60.5rem !important;\n  }\n\n  .m-md-123 {\n    margin: 61rem !important;\n  }\n\n  .m-md-124 {\n    margin: 61.5rem !important;\n  }\n\n  .m-md-125 {\n    margin: 62rem !important;\n  }\n\n  .m-md-126 {\n    margin: 62.5rem !important;\n  }\n\n  .m-md-127 {\n    margin: 63rem !important;\n  }\n\n  .m-md-128 {\n    margin: 63.5rem !important;\n  }\n\n  .m-md-129 {\n    margin: 64rem !important;\n  }\n\n  .m-md-130 {\n    margin: 64.5rem !important;\n  }\n\n  .m-md-131 {\n    margin: 65rem !important;\n  }\n\n  .m-md-132 {\n    margin: 65.5rem !important;\n  }\n\n  .m-md-133 {\n    margin: 66rem !important;\n  }\n\n  .m-md-134 {\n    margin: 66.5rem !important;\n  }\n\n  .m-md-135 {\n    margin: 67rem !important;\n  }\n\n  .m-md-136 {\n    margin: 67.5rem !important;\n  }\n\n  .m-md-137 {\n    margin: 68rem !important;\n  }\n\n  .m-md-138 {\n    margin: 68.5rem !important;\n  }\n\n  .m-md-139 {\n    margin: 69rem !important;\n  }\n\n  .m-md-140 {\n    margin: 69.5rem !important;\n  }\n\n  .m-md-141 {\n    margin: 70rem !important;\n  }\n\n  .m-md-142 {\n    margin: 70.5rem !important;\n  }\n\n  .m-md-143 {\n    margin: 71rem !important;\n  }\n\n  .m-md-144 {\n    margin: 71.5rem !important;\n  }\n\n  .m-md-145 {\n    margin: 72rem !important;\n  }\n\n  .m-md-146 {\n    margin: 72.5rem !important;\n  }\n\n  .m-md-147 {\n    margin: 73rem !important;\n  }\n\n  .m-md-148 {\n    margin: 73.5rem !important;\n  }\n\n  .m-md-149 {\n    margin: 74rem !important;\n  }\n\n  .m-md-150 {\n    margin: 74.5rem !important;\n  }\n\n  .m-md-151 {\n    margin: 75rem !important;\n  }\n\n  .m-md-152 {\n    margin: 75.5rem !important;\n  }\n\n  .m-md-153 {\n    margin: 76rem !important;\n  }\n\n  .m-md-154 {\n    margin: 76.5rem !important;\n  }\n\n  .m-md-155 {\n    margin: 77rem !important;\n  }\n\n  .m-md-156 {\n    margin: 77.5rem !important;\n  }\n\n  .m-md-157 {\n    margin: 78rem !important;\n  }\n\n  .m-md-158 {\n    margin: 78.5rem !important;\n  }\n\n  .m-md-159 {\n    margin: 79rem !important;\n  }\n\n  .m-md-160 {\n    margin: 79.5rem !important;\n  }\n\n  .mt-md-0 {\n    margin-top: 0rem !important;\n  }\n\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-md-5 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-md-6 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-md-7 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-md-8 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-md-9 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-md-10 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-md-11 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-md-12 {\n    margin-top: 5.5rem !important;\n  }\n\n  .mt-md-13 {\n    margin-top: 6rem !important;\n  }\n\n  .mt-md-14 {\n    margin-top: 6.5rem !important;\n  }\n\n  .mt-md-15 {\n    margin-top: 7rem !important;\n  }\n\n  .mt-md-16 {\n    margin-top: 7.5rem !important;\n  }\n\n  .mt-md-17 {\n    margin-top: 8rem !important;\n  }\n\n  .mt-md-18 {\n    margin-top: 8.5rem !important;\n  }\n\n  .mt-md-19 {\n    margin-top: 9rem !important;\n  }\n\n  .mt-md-20 {\n    margin-top: 9.5rem !important;\n  }\n\n  .mt-md-21 {\n    margin-top: 10rem !important;\n  }\n\n  .mt-md-22 {\n    margin-top: 10.5rem !important;\n  }\n\n  .mt-md-23 {\n    margin-top: 11rem !important;\n  }\n\n  .mt-md-24 {\n    margin-top: 11.5rem !important;\n  }\n\n  .mt-md-25 {\n    margin-top: 12rem !important;\n  }\n\n  .mt-md-26 {\n    margin-top: 12.5rem !important;\n  }\n\n  .mt-md-27 {\n    margin-top: 13rem !important;\n  }\n\n  .mt-md-28 {\n    margin-top: 13.5rem !important;\n  }\n\n  .mt-md-29 {\n    margin-top: 14rem !important;\n  }\n\n  .mt-md-30 {\n    margin-top: 14.5rem !important;\n  }\n\n  .mt-md-31 {\n    margin-top: 15rem !important;\n  }\n\n  .mt-md-32 {\n    margin-top: 15.5rem !important;\n  }\n\n  .mt-md-33 {\n    margin-top: 16rem !important;\n  }\n\n  .mt-md-34 {\n    margin-top: 16.5rem !important;\n  }\n\n  .mt-md-35 {\n    margin-top: 17rem !important;\n  }\n\n  .mt-md-36 {\n    margin-top: 17.5rem !important;\n  }\n\n  .mt-md-37 {\n    margin-top: 18rem !important;\n  }\n\n  .mt-md-38 {\n    margin-top: 18.5rem !important;\n  }\n\n  .mt-md-39 {\n    margin-top: 19rem !important;\n  }\n\n  .mt-md-40 {\n    margin-top: 19.5rem !important;\n  }\n\n  .mt-md-41 {\n    margin-top: 20rem !important;\n  }\n\n  .mt-md-42 {\n    margin-top: 20.5rem !important;\n  }\n\n  .mt-md-43 {\n    margin-top: 21rem !important;\n  }\n\n  .mt-md-44 {\n    margin-top: 21.5rem !important;\n  }\n\n  .mt-md-45 {\n    margin-top: 22rem !important;\n  }\n\n  .mt-md-46 {\n    margin-top: 22.5rem !important;\n  }\n\n  .mt-md-47 {\n    margin-top: 23rem !important;\n  }\n\n  .mt-md-48 {\n    margin-top: 23.5rem !important;\n  }\n\n  .mt-md-49 {\n    margin-top: 24rem !important;\n  }\n\n  .mt-md-50 {\n    margin-top: 24.5rem !important;\n  }\n\n  .mt-md-51 {\n    margin-top: 25rem !important;\n  }\n\n  .mt-md-52 {\n    margin-top: 25.5rem !important;\n  }\n\n  .mt-md-53 {\n    margin-top: 26rem !important;\n  }\n\n  .mt-md-54 {\n    margin-top: 26.5rem !important;\n  }\n\n  .mt-md-55 {\n    margin-top: 27rem !important;\n  }\n\n  .mt-md-56 {\n    margin-top: 27.5rem !important;\n  }\n\n  .mt-md-57 {\n    margin-top: 28rem !important;\n  }\n\n  .mt-md-58 {\n    margin-top: 28.5rem !important;\n  }\n\n  .mt-md-59 {\n    margin-top: 29rem !important;\n  }\n\n  .mt-md-60 {\n    margin-top: 29.5rem !important;\n  }\n\n  .mt-md-61 {\n    margin-top: 30rem !important;\n  }\n\n  .mt-md-62 {\n    margin-top: 30.5rem !important;\n  }\n\n  .mt-md-63 {\n    margin-top: 31rem !important;\n  }\n\n  .mt-md-64 {\n    margin-top: 31.5rem !important;\n  }\n\n  .mt-md-65 {\n    margin-top: 32rem !important;\n  }\n\n  .mt-md-66 {\n    margin-top: 32.5rem !important;\n  }\n\n  .mt-md-67 {\n    margin-top: 33rem !important;\n  }\n\n  .mt-md-68 {\n    margin-top: 33.5rem !important;\n  }\n\n  .mt-md-69 {\n    margin-top: 34rem !important;\n  }\n\n  .mt-md-70 {\n    margin-top: 34.5rem !important;\n  }\n\n  .mt-md-71 {\n    margin-top: 35rem !important;\n  }\n\n  .mt-md-72 {\n    margin-top: 35.5rem !important;\n  }\n\n  .mt-md-73 {\n    margin-top: 36rem !important;\n  }\n\n  .mt-md-74 {\n    margin-top: 36.5rem !important;\n  }\n\n  .mt-md-75 {\n    margin-top: 37rem !important;\n  }\n\n  .mt-md-76 {\n    margin-top: 37.5rem !important;\n  }\n\n  .mt-md-77 {\n    margin-top: 38rem !important;\n  }\n\n  .mt-md-78 {\n    margin-top: 38.5rem !important;\n  }\n\n  .mt-md-79 {\n    margin-top: 39rem !important;\n  }\n\n  .mt-md-80 {\n    margin-top: 39.5rem !important;\n  }\n\n  .mt-md-81 {\n    margin-top: 40rem !important;\n  }\n\n  .mt-md-82 {\n    margin-top: 40.5rem !important;\n  }\n\n  .mt-md-83 {\n    margin-top: 41rem !important;\n  }\n\n  .mt-md-84 {\n    margin-top: 41.5rem !important;\n  }\n\n  .mt-md-85 {\n    margin-top: 42rem !important;\n  }\n\n  .mt-md-86 {\n    margin-top: 42.5rem !important;\n  }\n\n  .mt-md-87 {\n    margin-top: 43rem !important;\n  }\n\n  .mt-md-88 {\n    margin-top: 43.5rem !important;\n  }\n\n  .mt-md-89 {\n    margin-top: 44rem !important;\n  }\n\n  .mt-md-90 {\n    margin-top: 44.5rem !important;\n  }\n\n  .mt-md-91 {\n    margin-top: 45rem !important;\n  }\n\n  .mt-md-92 {\n    margin-top: 45.5rem !important;\n  }\n\n  .mt-md-93 {\n    margin-top: 46rem !important;\n  }\n\n  .mt-md-94 {\n    margin-top: 46.5rem !important;\n  }\n\n  .mt-md-95 {\n    margin-top: 47rem !important;\n  }\n\n  .mt-md-96 {\n    margin-top: 47.5rem !important;\n  }\n\n  .mt-md-97 {\n    margin-top: 48rem !important;\n  }\n\n  .mt-md-98 {\n    margin-top: 48.5rem !important;\n  }\n\n  .mt-md-99 {\n    margin-top: 49rem !important;\n  }\n\n  .mt-md-100 {\n    margin-top: 49.5rem !important;\n  }\n\n  .mt-md-101 {\n    margin-top: 50rem !important;\n  }\n\n  .mt-md-102 {\n    margin-top: 50.5rem !important;\n  }\n\n  .mt-md-103 {\n    margin-top: 51rem !important;\n  }\n\n  .mt-md-104 {\n    margin-top: 51.5rem !important;\n  }\n\n  .mt-md-105 {\n    margin-top: 52rem !important;\n  }\n\n  .mt-md-106 {\n    margin-top: 52.5rem !important;\n  }\n\n  .mt-md-107 {\n    margin-top: 53rem !important;\n  }\n\n  .mt-md-108 {\n    margin-top: 53.5rem !important;\n  }\n\n  .mt-md-109 {\n    margin-top: 54rem !important;\n  }\n\n  .mt-md-110 {\n    margin-top: 54.5rem !important;\n  }\n\n  .mt-md-111 {\n    margin-top: 55rem !important;\n  }\n\n  .mt-md-112 {\n    margin-top: 55.5rem !important;\n  }\n\n  .mt-md-113 {\n    margin-top: 56rem !important;\n  }\n\n  .mt-md-114 {\n    margin-top: 56.5rem !important;\n  }\n\n  .mt-md-115 {\n    margin-top: 57rem !important;\n  }\n\n  .mt-md-116 {\n    margin-top: 57.5rem !important;\n  }\n\n  .mt-md-117 {\n    margin-top: 58rem !important;\n  }\n\n  .mt-md-118 {\n    margin-top: 58.5rem !important;\n  }\n\n  .mt-md-119 {\n    margin-top: 59rem !important;\n  }\n\n  .mt-md-120 {\n    margin-top: 59.5rem !important;\n  }\n\n  .mt-md-121 {\n    margin-top: 60rem !important;\n  }\n\n  .mt-md-122 {\n    margin-top: 60.5rem !important;\n  }\n\n  .mt-md-123 {\n    margin-top: 61rem !important;\n  }\n\n  .mt-md-124 {\n    margin-top: 61.5rem !important;\n  }\n\n  .mt-md-125 {\n    margin-top: 62rem !important;\n  }\n\n  .mt-md-126 {\n    margin-top: 62.5rem !important;\n  }\n\n  .mt-md-127 {\n    margin-top: 63rem !important;\n  }\n\n  .mt-md-128 {\n    margin-top: 63.5rem !important;\n  }\n\n  .mt-md-129 {\n    margin-top: 64rem !important;\n  }\n\n  .mt-md-130 {\n    margin-top: 64.5rem !important;\n  }\n\n  .mt-md-131 {\n    margin-top: 65rem !important;\n  }\n\n  .mt-md-132 {\n    margin-top: 65.5rem !important;\n  }\n\n  .mt-md-133 {\n    margin-top: 66rem !important;\n  }\n\n  .mt-md-134 {\n    margin-top: 66.5rem !important;\n  }\n\n  .mt-md-135 {\n    margin-top: 67rem !important;\n  }\n\n  .mt-md-136 {\n    margin-top: 67.5rem !important;\n  }\n\n  .mt-md-137 {\n    margin-top: 68rem !important;\n  }\n\n  .mt-md-138 {\n    margin-top: 68.5rem !important;\n  }\n\n  .mt-md-139 {\n    margin-top: 69rem !important;\n  }\n\n  .mt-md-140 {\n    margin-top: 69.5rem !important;\n  }\n\n  .mt-md-141 {\n    margin-top: 70rem !important;\n  }\n\n  .mt-md-142 {\n    margin-top: 70.5rem !important;\n  }\n\n  .mt-md-143 {\n    margin-top: 71rem !important;\n  }\n\n  .mt-md-144 {\n    margin-top: 71.5rem !important;\n  }\n\n  .mt-md-145 {\n    margin-top: 72rem !important;\n  }\n\n  .mt-md-146 {\n    margin-top: 72.5rem !important;\n  }\n\n  .mt-md-147 {\n    margin-top: 73rem !important;\n  }\n\n  .mt-md-148 {\n    margin-top: 73.5rem !important;\n  }\n\n  .mt-md-149 {\n    margin-top: 74rem !important;\n  }\n\n  .mt-md-150 {\n    margin-top: 74.5rem !important;\n  }\n\n  .mt-md-151 {\n    margin-top: 75rem !important;\n  }\n\n  .mt-md-152 {\n    margin-top: 75.5rem !important;\n  }\n\n  .mt-md-153 {\n    margin-top: 76rem !important;\n  }\n\n  .mt-md-154 {\n    margin-top: 76.5rem !important;\n  }\n\n  .mt-md-155 {\n    margin-top: 77rem !important;\n  }\n\n  .mt-md-156 {\n    margin-top: 77.5rem !important;\n  }\n\n  .mt-md-157 {\n    margin-top: 78rem !important;\n  }\n\n  .mt-md-158 {\n    margin-top: 78.5rem !important;\n  }\n\n  .mt-md-159 {\n    margin-top: 79rem !important;\n  }\n\n  .mt-md-160 {\n    margin-top: 79.5rem !important;\n  }\n\n  .mb-md-0 {\n    margin-bottom: 0rem !important;\n  }\n\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-md-5 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-md-6 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-md-7 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-md-8 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-md-9 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-md-10 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-md-11 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-md-12 {\n    margin-bottom: 5.5rem !important;\n  }\n\n  .mb-md-13 {\n    margin-bottom: 6rem !important;\n  }\n\n  .mb-md-14 {\n    margin-bottom: 6.5rem !important;\n  }\n\n  .mb-md-15 {\n    margin-bottom: 7rem !important;\n  }\n\n  .mb-md-16 {\n    margin-bottom: 7.5rem !important;\n  }\n\n  .mb-md-17 {\n    margin-bottom: 8rem !important;\n  }\n\n  .mb-md-18 {\n    margin-bottom: 8.5rem !important;\n  }\n\n  .mb-md-19 {\n    margin-bottom: 9rem !important;\n  }\n\n  .mb-md-20 {\n    margin-bottom: 9.5rem !important;\n  }\n\n  .mb-md-21 {\n    margin-bottom: 10rem !important;\n  }\n\n  .mb-md-22 {\n    margin-bottom: 10.5rem !important;\n  }\n\n  .mb-md-23 {\n    margin-bottom: 11rem !important;\n  }\n\n  .mb-md-24 {\n    margin-bottom: 11.5rem !important;\n  }\n\n  .mb-md-25 {\n    margin-bottom: 12rem !important;\n  }\n\n  .mb-md-26 {\n    margin-bottom: 12.5rem !important;\n  }\n\n  .mb-md-27 {\n    margin-bottom: 13rem !important;\n  }\n\n  .mb-md-28 {\n    margin-bottom: 13.5rem !important;\n  }\n\n  .mb-md-29 {\n    margin-bottom: 14rem !important;\n  }\n\n  .mb-md-30 {\n    margin-bottom: 14.5rem !important;\n  }\n\n  .mb-md-31 {\n    margin-bottom: 15rem !important;\n  }\n\n  .mb-md-32 {\n    margin-bottom: 15.5rem !important;\n  }\n\n  .mb-md-33 {\n    margin-bottom: 16rem !important;\n  }\n\n  .mb-md-34 {\n    margin-bottom: 16.5rem !important;\n  }\n\n  .mb-md-35 {\n    margin-bottom: 17rem !important;\n  }\n\n  .mb-md-36 {\n    margin-bottom: 17.5rem !important;\n  }\n\n  .mb-md-37 {\n    margin-bottom: 18rem !important;\n  }\n\n  .mb-md-38 {\n    margin-bottom: 18.5rem !important;\n  }\n\n  .mb-md-39 {\n    margin-bottom: 19rem !important;\n  }\n\n  .mb-md-40 {\n    margin-bottom: 19.5rem !important;\n  }\n\n  .mb-md-41 {\n    margin-bottom: 20rem !important;\n  }\n\n  .mb-md-42 {\n    margin-bottom: 20.5rem !important;\n  }\n\n  .mb-md-43 {\n    margin-bottom: 21rem !important;\n  }\n\n  .mb-md-44 {\n    margin-bottom: 21.5rem !important;\n  }\n\n  .mb-md-45 {\n    margin-bottom: 22rem !important;\n  }\n\n  .mb-md-46 {\n    margin-bottom: 22.5rem !important;\n  }\n\n  .mb-md-47 {\n    margin-bottom: 23rem !important;\n  }\n\n  .mb-md-48 {\n    margin-bottom: 23.5rem !important;\n  }\n\n  .mb-md-49 {\n    margin-bottom: 24rem !important;\n  }\n\n  .mb-md-50 {\n    margin-bottom: 24.5rem !important;\n  }\n\n  .mb-md-51 {\n    margin-bottom: 25rem !important;\n  }\n\n  .mb-md-52 {\n    margin-bottom: 25.5rem !important;\n  }\n\n  .mb-md-53 {\n    margin-bottom: 26rem !important;\n  }\n\n  .mb-md-54 {\n    margin-bottom: 26.5rem !important;\n  }\n\n  .mb-md-55 {\n    margin-bottom: 27rem !important;\n  }\n\n  .mb-md-56 {\n    margin-bottom: 27.5rem !important;\n  }\n\n  .mb-md-57 {\n    margin-bottom: 28rem !important;\n  }\n\n  .mb-md-58 {\n    margin-bottom: 28.5rem !important;\n  }\n\n  .mb-md-59 {\n    margin-bottom: 29rem !important;\n  }\n\n  .mb-md-60 {\n    margin-bottom: 29.5rem !important;\n  }\n\n  .mb-md-61 {\n    margin-bottom: 30rem !important;\n  }\n\n  .mb-md-62 {\n    margin-bottom: 30.5rem !important;\n  }\n\n  .mb-md-63 {\n    margin-bottom: 31rem !important;\n  }\n\n  .mb-md-64 {\n    margin-bottom: 31.5rem !important;\n  }\n\n  .mb-md-65 {\n    margin-bottom: 32rem !important;\n  }\n\n  .mb-md-66 {\n    margin-bottom: 32.5rem !important;\n  }\n\n  .mb-md-67 {\n    margin-bottom: 33rem !important;\n  }\n\n  .mb-md-68 {\n    margin-bottom: 33.5rem !important;\n  }\n\n  .mb-md-69 {\n    margin-bottom: 34rem !important;\n  }\n\n  .mb-md-70 {\n    margin-bottom: 34.5rem !important;\n  }\n\n  .mb-md-71 {\n    margin-bottom: 35rem !important;\n  }\n\n  .mb-md-72 {\n    margin-bottom: 35.5rem !important;\n  }\n\n  .mb-md-73 {\n    margin-bottom: 36rem !important;\n  }\n\n  .mb-md-74 {\n    margin-bottom: 36.5rem !important;\n  }\n\n  .mb-md-75 {\n    margin-bottom: 37rem !important;\n  }\n\n  .mb-md-76 {\n    margin-bottom: 37.5rem !important;\n  }\n\n  .mb-md-77 {\n    margin-bottom: 38rem !important;\n  }\n\n  .mb-md-78 {\n    margin-bottom: 38.5rem !important;\n  }\n\n  .mb-md-79 {\n    margin-bottom: 39rem !important;\n  }\n\n  .mb-md-80 {\n    margin-bottom: 39.5rem !important;\n  }\n\n  .mb-md-81 {\n    margin-bottom: 40rem !important;\n  }\n\n  .mb-md-82 {\n    margin-bottom: 40.5rem !important;\n  }\n\n  .mb-md-83 {\n    margin-bottom: 41rem !important;\n  }\n\n  .mb-md-84 {\n    margin-bottom: 41.5rem !important;\n  }\n\n  .mb-md-85 {\n    margin-bottom: 42rem !important;\n  }\n\n  .mb-md-86 {\n    margin-bottom: 42.5rem !important;\n  }\n\n  .mb-md-87 {\n    margin-bottom: 43rem !important;\n  }\n\n  .mb-md-88 {\n    margin-bottom: 43.5rem !important;\n  }\n\n  .mb-md-89 {\n    margin-bottom: 44rem !important;\n  }\n\n  .mb-md-90 {\n    margin-bottom: 44.5rem !important;\n  }\n\n  .mb-md-91 {\n    margin-bottom: 45rem !important;\n  }\n\n  .mb-md-92 {\n    margin-bottom: 45.5rem !important;\n  }\n\n  .mb-md-93 {\n    margin-bottom: 46rem !important;\n  }\n\n  .mb-md-94 {\n    margin-bottom: 46.5rem !important;\n  }\n\n  .mb-md-95 {\n    margin-bottom: 47rem !important;\n  }\n\n  .mb-md-96 {\n    margin-bottom: 47.5rem !important;\n  }\n\n  .mb-md-97 {\n    margin-bottom: 48rem !important;\n  }\n\n  .mb-md-98 {\n    margin-bottom: 48.5rem !important;\n  }\n\n  .mb-md-99 {\n    margin-bottom: 49rem !important;\n  }\n\n  .mb-md-100 {\n    margin-bottom: 49.5rem !important;\n  }\n\n  .mb-md-101 {\n    margin-bottom: 50rem !important;\n  }\n\n  .mb-md-102 {\n    margin-bottom: 50.5rem !important;\n  }\n\n  .mb-md-103 {\n    margin-bottom: 51rem !important;\n  }\n\n  .mb-md-104 {\n    margin-bottom: 51.5rem !important;\n  }\n\n  .mb-md-105 {\n    margin-bottom: 52rem !important;\n  }\n\n  .mb-md-106 {\n    margin-bottom: 52.5rem !important;\n  }\n\n  .mb-md-107 {\n    margin-bottom: 53rem !important;\n  }\n\n  .mb-md-108 {\n    margin-bottom: 53.5rem !important;\n  }\n\n  .mb-md-109 {\n    margin-bottom: 54rem !important;\n  }\n\n  .mb-md-110 {\n    margin-bottom: 54.5rem !important;\n  }\n\n  .mb-md-111 {\n    margin-bottom: 55rem !important;\n  }\n\n  .mb-md-112 {\n    margin-bottom: 55.5rem !important;\n  }\n\n  .mb-md-113 {\n    margin-bottom: 56rem !important;\n  }\n\n  .mb-md-114 {\n    margin-bottom: 56.5rem !important;\n  }\n\n  .mb-md-115 {\n    margin-bottom: 57rem !important;\n  }\n\n  .mb-md-116 {\n    margin-bottom: 57.5rem !important;\n  }\n\n  .mb-md-117 {\n    margin-bottom: 58rem !important;\n  }\n\n  .mb-md-118 {\n    margin-bottom: 58.5rem !important;\n  }\n\n  .mb-md-119 {\n    margin-bottom: 59rem !important;\n  }\n\n  .mb-md-120 {\n    margin-bottom: 59.5rem !important;\n  }\n\n  .mb-md-121 {\n    margin-bottom: 60rem !important;\n  }\n\n  .mb-md-122 {\n    margin-bottom: 60.5rem !important;\n  }\n\n  .mb-md-123 {\n    margin-bottom: 61rem !important;\n  }\n\n  .mb-md-124 {\n    margin-bottom: 61.5rem !important;\n  }\n\n  .mb-md-125 {\n    margin-bottom: 62rem !important;\n  }\n\n  .mb-md-126 {\n    margin-bottom: 62.5rem !important;\n  }\n\n  .mb-md-127 {\n    margin-bottom: 63rem !important;\n  }\n\n  .mb-md-128 {\n    margin-bottom: 63.5rem !important;\n  }\n\n  .mb-md-129 {\n    margin-bottom: 64rem !important;\n  }\n\n  .mb-md-130 {\n    margin-bottom: 64.5rem !important;\n  }\n\n  .mb-md-131 {\n    margin-bottom: 65rem !important;\n  }\n\n  .mb-md-132 {\n    margin-bottom: 65.5rem !important;\n  }\n\n  .mb-md-133 {\n    margin-bottom: 66rem !important;\n  }\n\n  .mb-md-134 {\n    margin-bottom: 66.5rem !important;\n  }\n\n  .mb-md-135 {\n    margin-bottom: 67rem !important;\n  }\n\n  .mb-md-136 {\n    margin-bottom: 67.5rem !important;\n  }\n\n  .mb-md-137 {\n    margin-bottom: 68rem !important;\n  }\n\n  .mb-md-138 {\n    margin-bottom: 68.5rem !important;\n  }\n\n  .mb-md-139 {\n    margin-bottom: 69rem !important;\n  }\n\n  .mb-md-140 {\n    margin-bottom: 69.5rem !important;\n  }\n\n  .mb-md-141 {\n    margin-bottom: 70rem !important;\n  }\n\n  .mb-md-142 {\n    margin-bottom: 70.5rem !important;\n  }\n\n  .mb-md-143 {\n    margin-bottom: 71rem !important;\n  }\n\n  .mb-md-144 {\n    margin-bottom: 71.5rem !important;\n  }\n\n  .mb-md-145 {\n    margin-bottom: 72rem !important;\n  }\n\n  .mb-md-146 {\n    margin-bottom: 72.5rem !important;\n  }\n\n  .mb-md-147 {\n    margin-bottom: 73rem !important;\n  }\n\n  .mb-md-148 {\n    margin-bottom: 73.5rem !important;\n  }\n\n  .mb-md-149 {\n    margin-bottom: 74rem !important;\n  }\n\n  .mb-md-150 {\n    margin-bottom: 74.5rem !important;\n  }\n\n  .mb-md-151 {\n    margin-bottom: 75rem !important;\n  }\n\n  .mb-md-152 {\n    margin-bottom: 75.5rem !important;\n  }\n\n  .mb-md-153 {\n    margin-bottom: 76rem !important;\n  }\n\n  .mb-md-154 {\n    margin-bottom: 76.5rem !important;\n  }\n\n  .mb-md-155 {\n    margin-bottom: 77rem !important;\n  }\n\n  .mb-md-156 {\n    margin-bottom: 77.5rem !important;\n  }\n\n  .mb-md-157 {\n    margin-bottom: 78rem !important;\n  }\n\n  .mb-md-158 {\n    margin-bottom: 78.5rem !important;\n  }\n\n  .mb-md-159 {\n    margin-bottom: 79rem !important;\n  }\n\n  .mb-md-160 {\n    margin-bottom: 79.5rem !important;\n  }\n\n  .ms-md-0 {\n    margin-left: 0rem !important;\n  }\n\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-md-5 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-md-6 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-md-7 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-md-8 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-md-9 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-md-10 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-md-11 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-md-12 {\n    margin-left: 5.5rem !important;\n  }\n\n  .ms-md-13 {\n    margin-left: 6rem !important;\n  }\n\n  .ms-md-14 {\n    margin-left: 6.5rem !important;\n  }\n\n  .ms-md-15 {\n    margin-left: 7rem !important;\n  }\n\n  .ms-md-16 {\n    margin-left: 7.5rem !important;\n  }\n\n  .ms-md-17 {\n    margin-left: 8rem !important;\n  }\n\n  .ms-md-18 {\n    margin-left: 8.5rem !important;\n  }\n\n  .ms-md-19 {\n    margin-left: 9rem !important;\n  }\n\n  .ms-md-20 {\n    margin-left: 9.5rem !important;\n  }\n\n  .ms-md-21 {\n    margin-left: 10rem !important;\n  }\n\n  .ms-md-22 {\n    margin-left: 10.5rem !important;\n  }\n\n  .ms-md-23 {\n    margin-left: 11rem !important;\n  }\n\n  .ms-md-24 {\n    margin-left: 11.5rem !important;\n  }\n\n  .ms-md-25 {\n    margin-left: 12rem !important;\n  }\n\n  .ms-md-26 {\n    margin-left: 12.5rem !important;\n  }\n\n  .ms-md-27 {\n    margin-left: 13rem !important;\n  }\n\n  .ms-md-28 {\n    margin-left: 13.5rem !important;\n  }\n\n  .ms-md-29 {\n    margin-left: 14rem !important;\n  }\n\n  .ms-md-30 {\n    margin-left: 14.5rem !important;\n  }\n\n  .ms-md-31 {\n    margin-left: 15rem !important;\n  }\n\n  .ms-md-32 {\n    margin-left: 15.5rem !important;\n  }\n\n  .ms-md-33 {\n    margin-left: 16rem !important;\n  }\n\n  .ms-md-34 {\n    margin-left: 16.5rem !important;\n  }\n\n  .ms-md-35 {\n    margin-left: 17rem !important;\n  }\n\n  .ms-md-36 {\n    margin-left: 17.5rem !important;\n  }\n\n  .ms-md-37 {\n    margin-left: 18rem !important;\n  }\n\n  .ms-md-38 {\n    margin-left: 18.5rem !important;\n  }\n\n  .ms-md-39 {\n    margin-left: 19rem !important;\n  }\n\n  .ms-md-40 {\n    margin-left: 19.5rem !important;\n  }\n\n  .ms-md-41 {\n    margin-left: 20rem !important;\n  }\n\n  .ms-md-42 {\n    margin-left: 20.5rem !important;\n  }\n\n  .ms-md-43 {\n    margin-left: 21rem !important;\n  }\n\n  .ms-md-44 {\n    margin-left: 21.5rem !important;\n  }\n\n  .ms-md-45 {\n    margin-left: 22rem !important;\n  }\n\n  .ms-md-46 {\n    margin-left: 22.5rem !important;\n  }\n\n  .ms-md-47 {\n    margin-left: 23rem !important;\n  }\n\n  .ms-md-48 {\n    margin-left: 23.5rem !important;\n  }\n\n  .ms-md-49 {\n    margin-left: 24rem !important;\n  }\n\n  .ms-md-50 {\n    margin-left: 24.5rem !important;\n  }\n\n  .ms-md-51 {\n    margin-left: 25rem !important;\n  }\n\n  .ms-md-52 {\n    margin-left: 25.5rem !important;\n  }\n\n  .ms-md-53 {\n    margin-left: 26rem !important;\n  }\n\n  .ms-md-54 {\n    margin-left: 26.5rem !important;\n  }\n\n  .ms-md-55 {\n    margin-left: 27rem !important;\n  }\n\n  .ms-md-56 {\n    margin-left: 27.5rem !important;\n  }\n\n  .ms-md-57 {\n    margin-left: 28rem !important;\n  }\n\n  .ms-md-58 {\n    margin-left: 28.5rem !important;\n  }\n\n  .ms-md-59 {\n    margin-left: 29rem !important;\n  }\n\n  .ms-md-60 {\n    margin-left: 29.5rem !important;\n  }\n\n  .ms-md-61 {\n    margin-left: 30rem !important;\n  }\n\n  .ms-md-62 {\n    margin-left: 30.5rem !important;\n  }\n\n  .ms-md-63 {\n    margin-left: 31rem !important;\n  }\n\n  .ms-md-64 {\n    margin-left: 31.5rem !important;\n  }\n\n  .ms-md-65 {\n    margin-left: 32rem !important;\n  }\n\n  .ms-md-66 {\n    margin-left: 32.5rem !important;\n  }\n\n  .ms-md-67 {\n    margin-left: 33rem !important;\n  }\n\n  .ms-md-68 {\n    margin-left: 33.5rem !important;\n  }\n\n  .ms-md-69 {\n    margin-left: 34rem !important;\n  }\n\n  .ms-md-70 {\n    margin-left: 34.5rem !important;\n  }\n\n  .ms-md-71 {\n    margin-left: 35rem !important;\n  }\n\n  .ms-md-72 {\n    margin-left: 35.5rem !important;\n  }\n\n  .ms-md-73 {\n    margin-left: 36rem !important;\n  }\n\n  .ms-md-74 {\n    margin-left: 36.5rem !important;\n  }\n\n  .ms-md-75 {\n    margin-left: 37rem !important;\n  }\n\n  .ms-md-76 {\n    margin-left: 37.5rem !important;\n  }\n\n  .ms-md-77 {\n    margin-left: 38rem !important;\n  }\n\n  .ms-md-78 {\n    margin-left: 38.5rem !important;\n  }\n\n  .ms-md-79 {\n    margin-left: 39rem !important;\n  }\n\n  .ms-md-80 {\n    margin-left: 39.5rem !important;\n  }\n\n  .ms-md-81 {\n    margin-left: 40rem !important;\n  }\n\n  .ms-md-82 {\n    margin-left: 40.5rem !important;\n  }\n\n  .ms-md-83 {\n    margin-left: 41rem !important;\n  }\n\n  .ms-md-84 {\n    margin-left: 41.5rem !important;\n  }\n\n  .ms-md-85 {\n    margin-left: 42rem !important;\n  }\n\n  .ms-md-86 {\n    margin-left: 42.5rem !important;\n  }\n\n  .ms-md-87 {\n    margin-left: 43rem !important;\n  }\n\n  .ms-md-88 {\n    margin-left: 43.5rem !important;\n  }\n\n  .ms-md-89 {\n    margin-left: 44rem !important;\n  }\n\n  .ms-md-90 {\n    margin-left: 44.5rem !important;\n  }\n\n  .ms-md-91 {\n    margin-left: 45rem !important;\n  }\n\n  .ms-md-92 {\n    margin-left: 45.5rem !important;\n  }\n\n  .ms-md-93 {\n    margin-left: 46rem !important;\n  }\n\n  .ms-md-94 {\n    margin-left: 46.5rem !important;\n  }\n\n  .ms-md-95 {\n    margin-left: 47rem !important;\n  }\n\n  .ms-md-96 {\n    margin-left: 47.5rem !important;\n  }\n\n  .ms-md-97 {\n    margin-left: 48rem !important;\n  }\n\n  .ms-md-98 {\n    margin-left: 48.5rem !important;\n  }\n\n  .ms-md-99 {\n    margin-left: 49rem !important;\n  }\n\n  .ms-md-100 {\n    margin-left: 49.5rem !important;\n  }\n\n  .ms-md-101 {\n    margin-left: 50rem !important;\n  }\n\n  .ms-md-102 {\n    margin-left: 50.5rem !important;\n  }\n\n  .ms-md-103 {\n    margin-left: 51rem !important;\n  }\n\n  .ms-md-104 {\n    margin-left: 51.5rem !important;\n  }\n\n  .ms-md-105 {\n    margin-left: 52rem !important;\n  }\n\n  .ms-md-106 {\n    margin-left: 52.5rem !important;\n  }\n\n  .ms-md-107 {\n    margin-left: 53rem !important;\n  }\n\n  .ms-md-108 {\n    margin-left: 53.5rem !important;\n  }\n\n  .ms-md-109 {\n    margin-left: 54rem !important;\n  }\n\n  .ms-md-110 {\n    margin-left: 54.5rem !important;\n  }\n\n  .ms-md-111 {\n    margin-left: 55rem !important;\n  }\n\n  .ms-md-112 {\n    margin-left: 55.5rem !important;\n  }\n\n  .ms-md-113 {\n    margin-left: 56rem !important;\n  }\n\n  .ms-md-114 {\n    margin-left: 56.5rem !important;\n  }\n\n  .ms-md-115 {\n    margin-left: 57rem !important;\n  }\n\n  .ms-md-116 {\n    margin-left: 57.5rem !important;\n  }\n\n  .ms-md-117 {\n    margin-left: 58rem !important;\n  }\n\n  .ms-md-118 {\n    margin-left: 58.5rem !important;\n  }\n\n  .ms-md-119 {\n    margin-left: 59rem !important;\n  }\n\n  .ms-md-120 {\n    margin-left: 59.5rem !important;\n  }\n\n  .ms-md-121 {\n    margin-left: 60rem !important;\n  }\n\n  .ms-md-122 {\n    margin-left: 60.5rem !important;\n  }\n\n  .ms-md-123 {\n    margin-left: 61rem !important;\n  }\n\n  .ms-md-124 {\n    margin-left: 61.5rem !important;\n  }\n\n  .ms-md-125 {\n    margin-left: 62rem !important;\n  }\n\n  .ms-md-126 {\n    margin-left: 62.5rem !important;\n  }\n\n  .ms-md-127 {\n    margin-left: 63rem !important;\n  }\n\n  .ms-md-128 {\n    margin-left: 63.5rem !important;\n  }\n\n  .ms-md-129 {\n    margin-left: 64rem !important;\n  }\n\n  .ms-md-130 {\n    margin-left: 64.5rem !important;\n  }\n\n  .ms-md-131 {\n    margin-left: 65rem !important;\n  }\n\n  .ms-md-132 {\n    margin-left: 65.5rem !important;\n  }\n\n  .ms-md-133 {\n    margin-left: 66rem !important;\n  }\n\n  .ms-md-134 {\n    margin-left: 66.5rem !important;\n  }\n\n  .ms-md-135 {\n    margin-left: 67rem !important;\n  }\n\n  .ms-md-136 {\n    margin-left: 67.5rem !important;\n  }\n\n  .ms-md-137 {\n    margin-left: 68rem !important;\n  }\n\n  .ms-md-138 {\n    margin-left: 68.5rem !important;\n  }\n\n  .ms-md-139 {\n    margin-left: 69rem !important;\n  }\n\n  .ms-md-140 {\n    margin-left: 69.5rem !important;\n  }\n\n  .ms-md-141 {\n    margin-left: 70rem !important;\n  }\n\n  .ms-md-142 {\n    margin-left: 70.5rem !important;\n  }\n\n  .ms-md-143 {\n    margin-left: 71rem !important;\n  }\n\n  .ms-md-144 {\n    margin-left: 71.5rem !important;\n  }\n\n  .ms-md-145 {\n    margin-left: 72rem !important;\n  }\n\n  .ms-md-146 {\n    margin-left: 72.5rem !important;\n  }\n\n  .ms-md-147 {\n    margin-left: 73rem !important;\n  }\n\n  .ms-md-148 {\n    margin-left: 73.5rem !important;\n  }\n\n  .ms-md-149 {\n    margin-left: 74rem !important;\n  }\n\n  .ms-md-150 {\n    margin-left: 74.5rem !important;\n  }\n\n  .ms-md-151 {\n    margin-left: 75rem !important;\n  }\n\n  .ms-md-152 {\n    margin-left: 75.5rem !important;\n  }\n\n  .ms-md-153 {\n    margin-left: 76rem !important;\n  }\n\n  .ms-md-154 {\n    margin-left: 76.5rem !important;\n  }\n\n  .ms-md-155 {\n    margin-left: 77rem !important;\n  }\n\n  .ms-md-156 {\n    margin-left: 77.5rem !important;\n  }\n\n  .ms-md-157 {\n    margin-left: 78rem !important;\n  }\n\n  .ms-md-158 {\n    margin-left: 78.5rem !important;\n  }\n\n  .ms-md-159 {\n    margin-left: 79rem !important;\n  }\n\n  .ms-md-160 {\n    margin-left: 79.5rem !important;\n  }\n\n  .me-md-0 {\n    margin-right: 0rem !important;\n  }\n\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-md-5 {\n    margin-right: 2rem !important;\n  }\n\n  .me-md-6 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-md-7 {\n    margin-right: 3rem !important;\n  }\n\n  .me-md-8 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-md-9 {\n    margin-right: 4rem !important;\n  }\n\n  .me-md-10 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-md-11 {\n    margin-right: 5rem !important;\n  }\n\n  .me-md-12 {\n    margin-right: 5.5rem !important;\n  }\n\n  .me-md-13 {\n    margin-right: 6rem !important;\n  }\n\n  .me-md-14 {\n    margin-right: 6.5rem !important;\n  }\n\n  .me-md-15 {\n    margin-right: 7rem !important;\n  }\n\n  .me-md-16 {\n    margin-right: 7.5rem !important;\n  }\n\n  .me-md-17 {\n    margin-right: 8rem !important;\n  }\n\n  .me-md-18 {\n    margin-right: 8.5rem !important;\n  }\n\n  .me-md-19 {\n    margin-right: 9rem !important;\n  }\n\n  .me-md-20 {\n    margin-right: 9.5rem !important;\n  }\n\n  .me-md-21 {\n    margin-right: 10rem !important;\n  }\n\n  .me-md-22 {\n    margin-right: 10.5rem !important;\n  }\n\n  .me-md-23 {\n    margin-right: 11rem !important;\n  }\n\n  .me-md-24 {\n    margin-right: 11.5rem !important;\n  }\n\n  .me-md-25 {\n    margin-right: 12rem !important;\n  }\n\n  .me-md-26 {\n    margin-right: 12.5rem !important;\n  }\n\n  .me-md-27 {\n    margin-right: 13rem !important;\n  }\n\n  .me-md-28 {\n    margin-right: 13.5rem !important;\n  }\n\n  .me-md-29 {\n    margin-right: 14rem !important;\n  }\n\n  .me-md-30 {\n    margin-right: 14.5rem !important;\n  }\n\n  .me-md-31 {\n    margin-right: 15rem !important;\n  }\n\n  .me-md-32 {\n    margin-right: 15.5rem !important;\n  }\n\n  .me-md-33 {\n    margin-right: 16rem !important;\n  }\n\n  .me-md-34 {\n    margin-right: 16.5rem !important;\n  }\n\n  .me-md-35 {\n    margin-right: 17rem !important;\n  }\n\n  .me-md-36 {\n    margin-right: 17.5rem !important;\n  }\n\n  .me-md-37 {\n    margin-right: 18rem !important;\n  }\n\n  .me-md-38 {\n    margin-right: 18.5rem !important;\n  }\n\n  .me-md-39 {\n    margin-right: 19rem !important;\n  }\n\n  .me-md-40 {\n    margin-right: 19.5rem !important;\n  }\n\n  .me-md-41 {\n    margin-right: 20rem !important;\n  }\n\n  .me-md-42 {\n    margin-right: 20.5rem !important;\n  }\n\n  .me-md-43 {\n    margin-right: 21rem !important;\n  }\n\n  .me-md-44 {\n    margin-right: 21.5rem !important;\n  }\n\n  .me-md-45 {\n    margin-right: 22rem !important;\n  }\n\n  .me-md-46 {\n    margin-right: 22.5rem !important;\n  }\n\n  .me-md-47 {\n    margin-right: 23rem !important;\n  }\n\n  .me-md-48 {\n    margin-right: 23.5rem !important;\n  }\n\n  .me-md-49 {\n    margin-right: 24rem !important;\n  }\n\n  .me-md-50 {\n    margin-right: 24.5rem !important;\n  }\n\n  .me-md-51 {\n    margin-right: 25rem !important;\n  }\n\n  .me-md-52 {\n    margin-right: 25.5rem !important;\n  }\n\n  .me-md-53 {\n    margin-right: 26rem !important;\n  }\n\n  .me-md-54 {\n    margin-right: 26.5rem !important;\n  }\n\n  .me-md-55 {\n    margin-right: 27rem !important;\n  }\n\n  .me-md-56 {\n    margin-right: 27.5rem !important;\n  }\n\n  .me-md-57 {\n    margin-right: 28rem !important;\n  }\n\n  .me-md-58 {\n    margin-right: 28.5rem !important;\n  }\n\n  .me-md-59 {\n    margin-right: 29rem !important;\n  }\n\n  .me-md-60 {\n    margin-right: 29.5rem !important;\n  }\n\n  .me-md-61 {\n    margin-right: 30rem !important;\n  }\n\n  .me-md-62 {\n    margin-right: 30.5rem !important;\n  }\n\n  .me-md-63 {\n    margin-right: 31rem !important;\n  }\n\n  .me-md-64 {\n    margin-right: 31.5rem !important;\n  }\n\n  .me-md-65 {\n    margin-right: 32rem !important;\n  }\n\n  .me-md-66 {\n    margin-right: 32.5rem !important;\n  }\n\n  .me-md-67 {\n    margin-right: 33rem !important;\n  }\n\n  .me-md-68 {\n    margin-right: 33.5rem !important;\n  }\n\n  .me-md-69 {\n    margin-right: 34rem !important;\n  }\n\n  .me-md-70 {\n    margin-right: 34.5rem !important;\n  }\n\n  .me-md-71 {\n    margin-right: 35rem !important;\n  }\n\n  .me-md-72 {\n    margin-right: 35.5rem !important;\n  }\n\n  .me-md-73 {\n    margin-right: 36rem !important;\n  }\n\n  .me-md-74 {\n    margin-right: 36.5rem !important;\n  }\n\n  .me-md-75 {\n    margin-right: 37rem !important;\n  }\n\n  .me-md-76 {\n    margin-right: 37.5rem !important;\n  }\n\n  .me-md-77 {\n    margin-right: 38rem !important;\n  }\n\n  .me-md-78 {\n    margin-right: 38.5rem !important;\n  }\n\n  .me-md-79 {\n    margin-right: 39rem !important;\n  }\n\n  .me-md-80 {\n    margin-right: 39.5rem !important;\n  }\n\n  .me-md-81 {\n    margin-right: 40rem !important;\n  }\n\n  .me-md-82 {\n    margin-right: 40.5rem !important;\n  }\n\n  .me-md-83 {\n    margin-right: 41rem !important;\n  }\n\n  .me-md-84 {\n    margin-right: 41.5rem !important;\n  }\n\n  .me-md-85 {\n    margin-right: 42rem !important;\n  }\n\n  .me-md-86 {\n    margin-right: 42.5rem !important;\n  }\n\n  .me-md-87 {\n    margin-right: 43rem !important;\n  }\n\n  .me-md-88 {\n    margin-right: 43.5rem !important;\n  }\n\n  .me-md-89 {\n    margin-right: 44rem !important;\n  }\n\n  .me-md-90 {\n    margin-right: 44.5rem !important;\n  }\n\n  .me-md-91 {\n    margin-right: 45rem !important;\n  }\n\n  .me-md-92 {\n    margin-right: 45.5rem !important;\n  }\n\n  .me-md-93 {\n    margin-right: 46rem !important;\n  }\n\n  .me-md-94 {\n    margin-right: 46.5rem !important;\n  }\n\n  .me-md-95 {\n    margin-right: 47rem !important;\n  }\n\n  .me-md-96 {\n    margin-right: 47.5rem !important;\n  }\n\n  .me-md-97 {\n    margin-right: 48rem !important;\n  }\n\n  .me-md-98 {\n    margin-right: 48.5rem !important;\n  }\n\n  .me-md-99 {\n    margin-right: 49rem !important;\n  }\n\n  .me-md-100 {\n    margin-right: 49.5rem !important;\n  }\n\n  .me-md-101 {\n    margin-right: 50rem !important;\n  }\n\n  .me-md-102 {\n    margin-right: 50.5rem !important;\n  }\n\n  .me-md-103 {\n    margin-right: 51rem !important;\n  }\n\n  .me-md-104 {\n    margin-right: 51.5rem !important;\n  }\n\n  .me-md-105 {\n    margin-right: 52rem !important;\n  }\n\n  .me-md-106 {\n    margin-right: 52.5rem !important;\n  }\n\n  .me-md-107 {\n    margin-right: 53rem !important;\n  }\n\n  .me-md-108 {\n    margin-right: 53.5rem !important;\n  }\n\n  .me-md-109 {\n    margin-right: 54rem !important;\n  }\n\n  .me-md-110 {\n    margin-right: 54.5rem !important;\n  }\n\n  .me-md-111 {\n    margin-right: 55rem !important;\n  }\n\n  .me-md-112 {\n    margin-right: 55.5rem !important;\n  }\n\n  .me-md-113 {\n    margin-right: 56rem !important;\n  }\n\n  .me-md-114 {\n    margin-right: 56.5rem !important;\n  }\n\n  .me-md-115 {\n    margin-right: 57rem !important;\n  }\n\n  .me-md-116 {\n    margin-right: 57.5rem !important;\n  }\n\n  .me-md-117 {\n    margin-right: 58rem !important;\n  }\n\n  .me-md-118 {\n    margin-right: 58.5rem !important;\n  }\n\n  .me-md-119 {\n    margin-right: 59rem !important;\n  }\n\n  .me-md-120 {\n    margin-right: 59.5rem !important;\n  }\n\n  .me-md-121 {\n    margin-right: 60rem !important;\n  }\n\n  .me-md-122 {\n    margin-right: 60.5rem !important;\n  }\n\n  .me-md-123 {\n    margin-right: 61rem !important;\n  }\n\n  .me-md-124 {\n    margin-right: 61.5rem !important;\n  }\n\n  .me-md-125 {\n    margin-right: 62rem !important;\n  }\n\n  .me-md-126 {\n    margin-right: 62.5rem !important;\n  }\n\n  .me-md-127 {\n    margin-right: 63rem !important;\n  }\n\n  .me-md-128 {\n    margin-right: 63.5rem !important;\n  }\n\n  .me-md-129 {\n    margin-right: 64rem !important;\n  }\n\n  .me-md-130 {\n    margin-right: 64.5rem !important;\n  }\n\n  .me-md-131 {\n    margin-right: 65rem !important;\n  }\n\n  .me-md-132 {\n    margin-right: 65.5rem !important;\n  }\n\n  .me-md-133 {\n    margin-right: 66rem !important;\n  }\n\n  .me-md-134 {\n    margin-right: 66.5rem !important;\n  }\n\n  .me-md-135 {\n    margin-right: 67rem !important;\n  }\n\n  .me-md-136 {\n    margin-right: 67.5rem !important;\n  }\n\n  .me-md-137 {\n    margin-right: 68rem !important;\n  }\n\n  .me-md-138 {\n    margin-right: 68.5rem !important;\n  }\n\n  .me-md-139 {\n    margin-right: 69rem !important;\n  }\n\n  .me-md-140 {\n    margin-right: 69.5rem !important;\n  }\n\n  .me-md-141 {\n    margin-right: 70rem !important;\n  }\n\n  .me-md-142 {\n    margin-right: 70.5rem !important;\n  }\n\n  .me-md-143 {\n    margin-right: 71rem !important;\n  }\n\n  .me-md-144 {\n    margin-right: 71.5rem !important;\n  }\n\n  .me-md-145 {\n    margin-right: 72rem !important;\n  }\n\n  .me-md-146 {\n    margin-right: 72.5rem !important;\n  }\n\n  .me-md-147 {\n    margin-right: 73rem !important;\n  }\n\n  .me-md-148 {\n    margin-right: 73.5rem !important;\n  }\n\n  .me-md-149 {\n    margin-right: 74rem !important;\n  }\n\n  .me-md-150 {\n    margin-right: 74.5rem !important;\n  }\n\n  .me-md-151 {\n    margin-right: 75rem !important;\n  }\n\n  .me-md-152 {\n    margin-right: 75.5rem !important;\n  }\n\n  .me-md-153 {\n    margin-right: 76rem !important;\n  }\n\n  .me-md-154 {\n    margin-right: 76.5rem !important;\n  }\n\n  .me-md-155 {\n    margin-right: 77rem !important;\n  }\n\n  .me-md-156 {\n    margin-right: 77.5rem !important;\n  }\n\n  .me-md-157 {\n    margin-right: 78rem !important;\n  }\n\n  .me-md-158 {\n    margin-right: 78.5rem !important;\n  }\n\n  .me-md-159 {\n    margin-right: 79rem !important;\n  }\n\n  .me-md-160 {\n    margin-right: 79.5rem !important;\n  }\n\n  .mx-md-0 {\n    margin-left: 0rem !important;\n    margin-right: 0rem !important;\n  }\n\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .mx-md-3 {\n    margin-left: 1rem !important;\n    margin-right: 1rem !important;\n  }\n\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .mx-md-5 {\n    margin-left: 2rem !important;\n    margin-right: 2rem !important;\n  }\n\n  .mx-md-6 {\n    margin-left: 2.5rem !important;\n    margin-right: 2.5rem !important;\n  }\n\n  .mx-md-7 {\n    margin-left: 3rem !important;\n    margin-right: 3rem !important;\n  }\n\n  .mx-md-8 {\n    margin-left: 3.5rem !important;\n    margin-right: 3.5rem !important;\n  }\n\n  .mx-md-9 {\n    margin-left: 4rem !important;\n    margin-right: 4rem !important;\n  }\n\n  .mx-md-10 {\n    margin-left: 4.5rem !important;\n    margin-right: 4.5rem !important;\n  }\n\n  .mx-md-11 {\n    margin-left: 5rem !important;\n    margin-right: 5rem !important;\n  }\n\n  .mx-md-12 {\n    margin-left: 5.5rem !important;\n    margin-right: 5.5rem !important;\n  }\n\n  .mx-md-13 {\n    margin-left: 6rem !important;\n    margin-right: 6rem !important;\n  }\n\n  .mx-md-14 {\n    margin-left: 6.5rem !important;\n    margin-right: 6.5rem !important;\n  }\n\n  .mx-md-15 {\n    margin-left: 7rem !important;\n    margin-right: 7rem !important;\n  }\n\n  .mx-md-16 {\n    margin-left: 7.5rem !important;\n    margin-right: 7.5rem !important;\n  }\n\n  .mx-md-17 {\n    margin-left: 8rem !important;\n    margin-right: 8rem !important;\n  }\n\n  .mx-md-18 {\n    margin-left: 8.5rem !important;\n    margin-right: 8.5rem !important;\n  }\n\n  .mx-md-19 {\n    margin-left: 9rem !important;\n    margin-right: 9rem !important;\n  }\n\n  .mx-md-20 {\n    margin-left: 9.5rem !important;\n    margin-right: 9.5rem !important;\n  }\n\n  .mx-md-21 {\n    margin-left: 10rem !important;\n    margin-right: 10rem !important;\n  }\n\n  .mx-md-22 {\n    margin-left: 10.5rem !important;\n    margin-right: 10.5rem !important;\n  }\n\n  .mx-md-23 {\n    margin-left: 11rem !important;\n    margin-right: 11rem !important;\n  }\n\n  .mx-md-24 {\n    margin-left: 11.5rem !important;\n    margin-right: 11.5rem !important;\n  }\n\n  .mx-md-25 {\n    margin-left: 12rem !important;\n    margin-right: 12rem !important;\n  }\n\n  .mx-md-26 {\n    margin-left: 12.5rem !important;\n    margin-right: 12.5rem !important;\n  }\n\n  .mx-md-27 {\n    margin-left: 13rem !important;\n    margin-right: 13rem !important;\n  }\n\n  .mx-md-28 {\n    margin-left: 13.5rem !important;\n    margin-right: 13.5rem !important;\n  }\n\n  .mx-md-29 {\n    margin-left: 14rem !important;\n    margin-right: 14rem !important;\n  }\n\n  .mx-md-30 {\n    margin-left: 14.5rem !important;\n    margin-right: 14.5rem !important;\n  }\n\n  .mx-md-31 {\n    margin-left: 15rem !important;\n    margin-right: 15rem !important;\n  }\n\n  .mx-md-32 {\n    margin-left: 15.5rem !important;\n    margin-right: 15.5rem !important;\n  }\n\n  .mx-md-33 {\n    margin-left: 16rem !important;\n    margin-right: 16rem !important;\n  }\n\n  .mx-md-34 {\n    margin-left: 16.5rem !important;\n    margin-right: 16.5rem !important;\n  }\n\n  .mx-md-35 {\n    margin-left: 17rem !important;\n    margin-right: 17rem !important;\n  }\n\n  .mx-md-36 {\n    margin-left: 17.5rem !important;\n    margin-right: 17.5rem !important;\n  }\n\n  .mx-md-37 {\n    margin-left: 18rem !important;\n    margin-right: 18rem !important;\n  }\n\n  .mx-md-38 {\n    margin-left: 18.5rem !important;\n    margin-right: 18.5rem !important;\n  }\n\n  .mx-md-39 {\n    margin-left: 19rem !important;\n    margin-right: 19rem !important;\n  }\n\n  .mx-md-40 {\n    margin-left: 19.5rem !important;\n    margin-right: 19.5rem !important;\n  }\n\n  .mx-md-41 {\n    margin-left: 20rem !important;\n    margin-right: 20rem !important;\n  }\n\n  .mx-md-42 {\n    margin-left: 20.5rem !important;\n    margin-right: 20.5rem !important;\n  }\n\n  .mx-md-43 {\n    margin-left: 21rem !important;\n    margin-right: 21rem !important;\n  }\n\n  .mx-md-44 {\n    margin-left: 21.5rem !important;\n    margin-right: 21.5rem !important;\n  }\n\n  .mx-md-45 {\n    margin-left: 22rem !important;\n    margin-right: 22rem !important;\n  }\n\n  .mx-md-46 {\n    margin-left: 22.5rem !important;\n    margin-right: 22.5rem !important;\n  }\n\n  .mx-md-47 {\n    margin-left: 23rem !important;\n    margin-right: 23rem !important;\n  }\n\n  .mx-md-48 {\n    margin-left: 23.5rem !important;\n    margin-right: 23.5rem !important;\n  }\n\n  .mx-md-49 {\n    margin-left: 24rem !important;\n    margin-right: 24rem !important;\n  }\n\n  .mx-md-50 {\n    margin-left: 24.5rem !important;\n    margin-right: 24.5rem !important;\n  }\n\n  .mx-md-51 {\n    margin-left: 25rem !important;\n    margin-right: 25rem !important;\n  }\n\n  .mx-md-52 {\n    margin-left: 25.5rem !important;\n    margin-right: 25.5rem !important;\n  }\n\n  .mx-md-53 {\n    margin-left: 26rem !important;\n    margin-right: 26rem !important;\n  }\n\n  .mx-md-54 {\n    margin-left: 26.5rem !important;\n    margin-right: 26.5rem !important;\n  }\n\n  .mx-md-55 {\n    margin-left: 27rem !important;\n    margin-right: 27rem !important;\n  }\n\n  .mx-md-56 {\n    margin-left: 27.5rem !important;\n    margin-right: 27.5rem !important;\n  }\n\n  .mx-md-57 {\n    margin-left: 28rem !important;\n    margin-right: 28rem !important;\n  }\n\n  .mx-md-58 {\n    margin-left: 28.5rem !important;\n    margin-right: 28.5rem !important;\n  }\n\n  .mx-md-59 {\n    margin-left: 29rem !important;\n    margin-right: 29rem !important;\n  }\n\n  .mx-md-60 {\n    margin-left: 29.5rem !important;\n    margin-right: 29.5rem !important;\n  }\n\n  .mx-md-61 {\n    margin-left: 30rem !important;\n    margin-right: 30rem !important;\n  }\n\n  .mx-md-62 {\n    margin-left: 30.5rem !important;\n    margin-right: 30.5rem !important;\n  }\n\n  .mx-md-63 {\n    margin-left: 31rem !important;\n    margin-right: 31rem !important;\n  }\n\n  .mx-md-64 {\n    margin-left: 31.5rem !important;\n    margin-right: 31.5rem !important;\n  }\n\n  .mx-md-65 {\n    margin-left: 32rem !important;\n    margin-right: 32rem !important;\n  }\n\n  .mx-md-66 {\n    margin-left: 32.5rem !important;\n    margin-right: 32.5rem !important;\n  }\n\n  .mx-md-67 {\n    margin-left: 33rem !important;\n    margin-right: 33rem !important;\n  }\n\n  .mx-md-68 {\n    margin-left: 33.5rem !important;\n    margin-right: 33.5rem !important;\n  }\n\n  .mx-md-69 {\n    margin-left: 34rem !important;\n    margin-right: 34rem !important;\n  }\n\n  .mx-md-70 {\n    margin-left: 34.5rem !important;\n    margin-right: 34.5rem !important;\n  }\n\n  .mx-md-71 {\n    margin-left: 35rem !important;\n    margin-right: 35rem !important;\n  }\n\n  .mx-md-72 {\n    margin-left: 35.5rem !important;\n    margin-right: 35.5rem !important;\n  }\n\n  .mx-md-73 {\n    margin-left: 36rem !important;\n    margin-right: 36rem !important;\n  }\n\n  .mx-md-74 {\n    margin-left: 36.5rem !important;\n    margin-right: 36.5rem !important;\n  }\n\n  .mx-md-75 {\n    margin-left: 37rem !important;\n    margin-right: 37rem !important;\n  }\n\n  .mx-md-76 {\n    margin-left: 37.5rem !important;\n    margin-right: 37.5rem !important;\n  }\n\n  .mx-md-77 {\n    margin-left: 38rem !important;\n    margin-right: 38rem !important;\n  }\n\n  .mx-md-78 {\n    margin-left: 38.5rem !important;\n    margin-right: 38.5rem !important;\n  }\n\n  .mx-md-79 {\n    margin-left: 39rem !important;\n    margin-right: 39rem !important;\n  }\n\n  .mx-md-80 {\n    margin-left: 39.5rem !important;\n    margin-right: 39.5rem !important;\n  }\n\n  .mx-md-81 {\n    margin-left: 40rem !important;\n    margin-right: 40rem !important;\n  }\n\n  .mx-md-82 {\n    margin-left: 40.5rem !important;\n    margin-right: 40.5rem !important;\n  }\n\n  .mx-md-83 {\n    margin-left: 41rem !important;\n    margin-right: 41rem !important;\n  }\n\n  .mx-md-84 {\n    margin-left: 41.5rem !important;\n    margin-right: 41.5rem !important;\n  }\n\n  .mx-md-85 {\n    margin-left: 42rem !important;\n    margin-right: 42rem !important;\n  }\n\n  .mx-md-86 {\n    margin-left: 42.5rem !important;\n    margin-right: 42.5rem !important;\n  }\n\n  .mx-md-87 {\n    margin-left: 43rem !important;\n    margin-right: 43rem !important;\n  }\n\n  .mx-md-88 {\n    margin-left: 43.5rem !important;\n    margin-right: 43.5rem !important;\n  }\n\n  .mx-md-89 {\n    margin-left: 44rem !important;\n    margin-right: 44rem !important;\n  }\n\n  .mx-md-90 {\n    margin-left: 44.5rem !important;\n    margin-right: 44.5rem !important;\n  }\n\n  .mx-md-91 {\n    margin-left: 45rem !important;\n    margin-right: 45rem !important;\n  }\n\n  .mx-md-92 {\n    margin-left: 45.5rem !important;\n    margin-right: 45.5rem !important;\n  }\n\n  .mx-md-93 {\n    margin-left: 46rem !important;\n    margin-right: 46rem !important;\n  }\n\n  .mx-md-94 {\n    margin-left: 46.5rem !important;\n    margin-right: 46.5rem !important;\n  }\n\n  .mx-md-95 {\n    margin-left: 47rem !important;\n    margin-right: 47rem !important;\n  }\n\n  .mx-md-96 {\n    margin-left: 47.5rem !important;\n    margin-right: 47.5rem !important;\n  }\n\n  .mx-md-97 {\n    margin-left: 48rem !important;\n    margin-right: 48rem !important;\n  }\n\n  .mx-md-98 {\n    margin-left: 48.5rem !important;\n    margin-right: 48.5rem !important;\n  }\n\n  .mx-md-99 {\n    margin-left: 49rem !important;\n    margin-right: 49rem !important;\n  }\n\n  .mx-md-100 {\n    margin-left: 49.5rem !important;\n    margin-right: 49.5rem !important;\n  }\n\n  .mx-md-101 {\n    margin-left: 50rem !important;\n    margin-right: 50rem !important;\n  }\n\n  .mx-md-102 {\n    margin-left: 50.5rem !important;\n    margin-right: 50.5rem !important;\n  }\n\n  .mx-md-103 {\n    margin-left: 51rem !important;\n    margin-right: 51rem !important;\n  }\n\n  .mx-md-104 {\n    margin-left: 51.5rem !important;\n    margin-right: 51.5rem !important;\n  }\n\n  .mx-md-105 {\n    margin-left: 52rem !important;\n    margin-right: 52rem !important;\n  }\n\n  .mx-md-106 {\n    margin-left: 52.5rem !important;\n    margin-right: 52.5rem !important;\n  }\n\n  .mx-md-107 {\n    margin-left: 53rem !important;\n    margin-right: 53rem !important;\n  }\n\n  .mx-md-108 {\n    margin-left: 53.5rem !important;\n    margin-right: 53.5rem !important;\n  }\n\n  .mx-md-109 {\n    margin-left: 54rem !important;\n    margin-right: 54rem !important;\n  }\n\n  .mx-md-110 {\n    margin-left: 54.5rem !important;\n    margin-right: 54.5rem !important;\n  }\n\n  .mx-md-111 {\n    margin-left: 55rem !important;\n    margin-right: 55rem !important;\n  }\n\n  .mx-md-112 {\n    margin-left: 55.5rem !important;\n    margin-right: 55.5rem !important;\n  }\n\n  .mx-md-113 {\n    margin-left: 56rem !important;\n    margin-right: 56rem !important;\n  }\n\n  .mx-md-114 {\n    margin-left: 56.5rem !important;\n    margin-right: 56.5rem !important;\n  }\n\n  .mx-md-115 {\n    margin-left: 57rem !important;\n    margin-right: 57rem !important;\n  }\n\n  .mx-md-116 {\n    margin-left: 57.5rem !important;\n    margin-right: 57.5rem !important;\n  }\n\n  .mx-md-117 {\n    margin-left: 58rem !important;\n    margin-right: 58rem !important;\n  }\n\n  .mx-md-118 {\n    margin-left: 58.5rem !important;\n    margin-right: 58.5rem !important;\n  }\n\n  .mx-md-119 {\n    margin-left: 59rem !important;\n    margin-right: 59rem !important;\n  }\n\n  .mx-md-120 {\n    margin-left: 59.5rem !important;\n    margin-right: 59.5rem !important;\n  }\n\n  .mx-md-121 {\n    margin-left: 60rem !important;\n    margin-right: 60rem !important;\n  }\n\n  .mx-md-122 {\n    margin-left: 60.5rem !important;\n    margin-right: 60.5rem !important;\n  }\n\n  .mx-md-123 {\n    margin-left: 61rem !important;\n    margin-right: 61rem !important;\n  }\n\n  .mx-md-124 {\n    margin-left: 61.5rem !important;\n    margin-right: 61.5rem !important;\n  }\n\n  .mx-md-125 {\n    margin-left: 62rem !important;\n    margin-right: 62rem !important;\n  }\n\n  .mx-md-126 {\n    margin-left: 62.5rem !important;\n    margin-right: 62.5rem !important;\n  }\n\n  .mx-md-127 {\n    margin-left: 63rem !important;\n    margin-right: 63rem !important;\n  }\n\n  .mx-md-128 {\n    margin-left: 63.5rem !important;\n    margin-right: 63.5rem !important;\n  }\n\n  .mx-md-129 {\n    margin-left: 64rem !important;\n    margin-right: 64rem !important;\n  }\n\n  .mx-md-130 {\n    margin-left: 64.5rem !important;\n    margin-right: 64.5rem !important;\n  }\n\n  .mx-md-131 {\n    margin-left: 65rem !important;\n    margin-right: 65rem !important;\n  }\n\n  .mx-md-132 {\n    margin-left: 65.5rem !important;\n    margin-right: 65.5rem !important;\n  }\n\n  .mx-md-133 {\n    margin-left: 66rem !important;\n    margin-right: 66rem !important;\n  }\n\n  .mx-md-134 {\n    margin-left: 66.5rem !important;\n    margin-right: 66.5rem !important;\n  }\n\n  .mx-md-135 {\n    margin-left: 67rem !important;\n    margin-right: 67rem !important;\n  }\n\n  .mx-md-136 {\n    margin-left: 67.5rem !important;\n    margin-right: 67.5rem !important;\n  }\n\n  .mx-md-137 {\n    margin-left: 68rem !important;\n    margin-right: 68rem !important;\n  }\n\n  .mx-md-138 {\n    margin-left: 68.5rem !important;\n    margin-right: 68.5rem !important;\n  }\n\n  .mx-md-139 {\n    margin-left: 69rem !important;\n    margin-right: 69rem !important;\n  }\n\n  .mx-md-140 {\n    margin-left: 69.5rem !important;\n    margin-right: 69.5rem !important;\n  }\n\n  .mx-md-141 {\n    margin-left: 70rem !important;\n    margin-right: 70rem !important;\n  }\n\n  .mx-md-142 {\n    margin-left: 70.5rem !important;\n    margin-right: 70.5rem !important;\n  }\n\n  .mx-md-143 {\n    margin-left: 71rem !important;\n    margin-right: 71rem !important;\n  }\n\n  .mx-md-144 {\n    margin-left: 71.5rem !important;\n    margin-right: 71.5rem !important;\n  }\n\n  .mx-md-145 {\n    margin-left: 72rem !important;\n    margin-right: 72rem !important;\n  }\n\n  .mx-md-146 {\n    margin-left: 72.5rem !important;\n    margin-right: 72.5rem !important;\n  }\n\n  .mx-md-147 {\n    margin-left: 73rem !important;\n    margin-right: 73rem !important;\n  }\n\n  .mx-md-148 {\n    margin-left: 73.5rem !important;\n    margin-right: 73.5rem !important;\n  }\n\n  .mx-md-149 {\n    margin-left: 74rem !important;\n    margin-right: 74rem !important;\n  }\n\n  .mx-md-150 {\n    margin-left: 74.5rem !important;\n    margin-right: 74.5rem !important;\n  }\n\n  .mx-md-151 {\n    margin-left: 75rem !important;\n    margin-right: 75rem !important;\n  }\n\n  .mx-md-152 {\n    margin-left: 75.5rem !important;\n    margin-right: 75.5rem !important;\n  }\n\n  .mx-md-153 {\n    margin-left: 76rem !important;\n    margin-right: 76rem !important;\n  }\n\n  .mx-md-154 {\n    margin-left: 76.5rem !important;\n    margin-right: 76.5rem !important;\n  }\n\n  .mx-md-155 {\n    margin-left: 77rem !important;\n    margin-right: 77rem !important;\n  }\n\n  .mx-md-156 {\n    margin-left: 77.5rem !important;\n    margin-right: 77.5rem !important;\n  }\n\n  .mx-md-157 {\n    margin-left: 78rem !important;\n    margin-right: 78rem !important;\n  }\n\n  .mx-md-158 {\n    margin-left: 78.5rem !important;\n    margin-right: 78.5rem !important;\n  }\n\n  .mx-md-159 {\n    margin-left: 79rem !important;\n    margin-right: 79rem !important;\n  }\n\n  .mx-md-160 {\n    margin-left: 79.5rem !important;\n    margin-right: 79.5rem !important;\n  }\n\n  .my-md-0 {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem !important;\n  }\n\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-md-5 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-md-6 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-md-7 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-md-8 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-md-9 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-md-10 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-md-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-md-12 {\n    margin-top: 5.5rem !important;\n    margin-bottom: 5.5rem !important;\n  }\n\n  .my-md-13 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n\n  .my-md-14 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n\n  .my-md-15 {\n    margin-top: 7rem !important;\n    margin-bottom: 7rem !important;\n  }\n\n  .my-md-16 {\n    margin-top: 7.5rem !important;\n    margin-bottom: 7.5rem !important;\n  }\n\n  .my-md-17 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n\n  .my-md-18 {\n    margin-top: 8.5rem !important;\n    margin-bottom: 8.5rem !important;\n  }\n\n  .my-md-19 {\n    margin-top: 9rem !important;\n    margin-bottom: 9rem !important;\n  }\n\n  .my-md-20 {\n    margin-top: 9.5rem !important;\n    margin-bottom: 9.5rem !important;\n  }\n\n  .my-md-21 {\n    margin-top: 10rem !important;\n    margin-bottom: 10rem !important;\n  }\n\n  .my-md-22 {\n    margin-top: 10.5rem !important;\n    margin-bottom: 10.5rem !important;\n  }\n\n  .my-md-23 {\n    margin-top: 11rem !important;\n    margin-bottom: 11rem !important;\n  }\n\n  .my-md-24 {\n    margin-top: 11.5rem !important;\n    margin-bottom: 11.5rem !important;\n  }\n\n  .my-md-25 {\n    margin-top: 12rem !important;\n    margin-bottom: 12rem !important;\n  }\n\n  .my-md-26 {\n    margin-top: 12.5rem !important;\n    margin-bottom: 12.5rem !important;\n  }\n\n  .my-md-27 {\n    margin-top: 13rem !important;\n    margin-bottom: 13rem !important;\n  }\n\n  .my-md-28 {\n    margin-top: 13.5rem !important;\n    margin-bottom: 13.5rem !important;\n  }\n\n  .my-md-29 {\n    margin-top: 14rem !important;\n    margin-bottom: 14rem !important;\n  }\n\n  .my-md-30 {\n    margin-top: 14.5rem !important;\n    margin-bottom: 14.5rem !important;\n  }\n\n  .my-md-31 {\n    margin-top: 15rem !important;\n    margin-bottom: 15rem !important;\n  }\n\n  .my-md-32 {\n    margin-top: 15.5rem !important;\n    margin-bottom: 15.5rem !important;\n  }\n\n  .my-md-33 {\n    margin-top: 16rem !important;\n    margin-bottom: 16rem !important;\n  }\n\n  .my-md-34 {\n    margin-top: 16.5rem !important;\n    margin-bottom: 16.5rem !important;\n  }\n\n  .my-md-35 {\n    margin-top: 17rem !important;\n    margin-bottom: 17rem !important;\n  }\n\n  .my-md-36 {\n    margin-top: 17.5rem !important;\n    margin-bottom: 17.5rem !important;\n  }\n\n  .my-md-37 {\n    margin-top: 18rem !important;\n    margin-bottom: 18rem !important;\n  }\n\n  .my-md-38 {\n    margin-top: 18.5rem !important;\n    margin-bottom: 18.5rem !important;\n  }\n\n  .my-md-39 {\n    margin-top: 19rem !important;\n    margin-bottom: 19rem !important;\n  }\n\n  .my-md-40 {\n    margin-top: 19.5rem !important;\n    margin-bottom: 19.5rem !important;\n  }\n\n  .my-md-41 {\n    margin-top: 20rem !important;\n    margin-bottom: 20rem !important;\n  }\n\n  .my-md-42 {\n    margin-top: 20.5rem !important;\n    margin-bottom: 20.5rem !important;\n  }\n\n  .my-md-43 {\n    margin-top: 21rem !important;\n    margin-bottom: 21rem !important;\n  }\n\n  .my-md-44 {\n    margin-top: 21.5rem !important;\n    margin-bottom: 21.5rem !important;\n  }\n\n  .my-md-45 {\n    margin-top: 22rem !important;\n    margin-bottom: 22rem !important;\n  }\n\n  .my-md-46 {\n    margin-top: 22.5rem !important;\n    margin-bottom: 22.5rem !important;\n  }\n\n  .my-md-47 {\n    margin-top: 23rem !important;\n    margin-bottom: 23rem !important;\n  }\n\n  .my-md-48 {\n    margin-top: 23.5rem !important;\n    margin-bottom: 23.5rem !important;\n  }\n\n  .my-md-49 {\n    margin-top: 24rem !important;\n    margin-bottom: 24rem !important;\n  }\n\n  .my-md-50 {\n    margin-top: 24.5rem !important;\n    margin-bottom: 24.5rem !important;\n  }\n\n  .my-md-51 {\n    margin-top: 25rem !important;\n    margin-bottom: 25rem !important;\n  }\n\n  .my-md-52 {\n    margin-top: 25.5rem !important;\n    margin-bottom: 25.5rem !important;\n  }\n\n  .my-md-53 {\n    margin-top: 26rem !important;\n    margin-bottom: 26rem !important;\n  }\n\n  .my-md-54 {\n    margin-top: 26.5rem !important;\n    margin-bottom: 26.5rem !important;\n  }\n\n  .my-md-55 {\n    margin-top: 27rem !important;\n    margin-bottom: 27rem !important;\n  }\n\n  .my-md-56 {\n    margin-top: 27.5rem !important;\n    margin-bottom: 27.5rem !important;\n  }\n\n  .my-md-57 {\n    margin-top: 28rem !important;\n    margin-bottom: 28rem !important;\n  }\n\n  .my-md-58 {\n    margin-top: 28.5rem !important;\n    margin-bottom: 28.5rem !important;\n  }\n\n  .my-md-59 {\n    margin-top: 29rem !important;\n    margin-bottom: 29rem !important;\n  }\n\n  .my-md-60 {\n    margin-top: 29.5rem !important;\n    margin-bottom: 29.5rem !important;\n  }\n\n  .my-md-61 {\n    margin-top: 30rem !important;\n    margin-bottom: 30rem !important;\n  }\n\n  .my-md-62 {\n    margin-top: 30.5rem !important;\n    margin-bottom: 30.5rem !important;\n  }\n\n  .my-md-63 {\n    margin-top: 31rem !important;\n    margin-bottom: 31rem !important;\n  }\n\n  .my-md-64 {\n    margin-top: 31.5rem !important;\n    margin-bottom: 31.5rem !important;\n  }\n\n  .my-md-65 {\n    margin-top: 32rem !important;\n    margin-bottom: 32rem !important;\n  }\n\n  .my-md-66 {\n    margin-top: 32.5rem !important;\n    margin-bottom: 32.5rem !important;\n  }\n\n  .my-md-67 {\n    margin-top: 33rem !important;\n    margin-bottom: 33rem !important;\n  }\n\n  .my-md-68 {\n    margin-top: 33.5rem !important;\n    margin-bottom: 33.5rem !important;\n  }\n\n  .my-md-69 {\n    margin-top: 34rem !important;\n    margin-bottom: 34rem !important;\n  }\n\n  .my-md-70 {\n    margin-top: 34.5rem !important;\n    margin-bottom: 34.5rem !important;\n  }\n\n  .my-md-71 {\n    margin-top: 35rem !important;\n    margin-bottom: 35rem !important;\n  }\n\n  .my-md-72 {\n    margin-top: 35.5rem !important;\n    margin-bottom: 35.5rem !important;\n  }\n\n  .my-md-73 {\n    margin-top: 36rem !important;\n    margin-bottom: 36rem !important;\n  }\n\n  .my-md-74 {\n    margin-top: 36.5rem !important;\n    margin-bottom: 36.5rem !important;\n  }\n\n  .my-md-75 {\n    margin-top: 37rem !important;\n    margin-bottom: 37rem !important;\n  }\n\n  .my-md-76 {\n    margin-top: 37.5rem !important;\n    margin-bottom: 37.5rem !important;\n  }\n\n  .my-md-77 {\n    margin-top: 38rem !important;\n    margin-bottom: 38rem !important;\n  }\n\n  .my-md-78 {\n    margin-top: 38.5rem !important;\n    margin-bottom: 38.5rem !important;\n  }\n\n  .my-md-79 {\n    margin-top: 39rem !important;\n    margin-bottom: 39rem !important;\n  }\n\n  .my-md-80 {\n    margin-top: 39.5rem !important;\n    margin-bottom: 39.5rem !important;\n  }\n\n  .my-md-81 {\n    margin-top: 40rem !important;\n    margin-bottom: 40rem !important;\n  }\n\n  .my-md-82 {\n    margin-top: 40.5rem !important;\n    margin-bottom: 40.5rem !important;\n  }\n\n  .my-md-83 {\n    margin-top: 41rem !important;\n    margin-bottom: 41rem !important;\n  }\n\n  .my-md-84 {\n    margin-top: 41.5rem !important;\n    margin-bottom: 41.5rem !important;\n  }\n\n  .my-md-85 {\n    margin-top: 42rem !important;\n    margin-bottom: 42rem !important;\n  }\n\n  .my-md-86 {\n    margin-top: 42.5rem !important;\n    margin-bottom: 42.5rem !important;\n  }\n\n  .my-md-87 {\n    margin-top: 43rem !important;\n    margin-bottom: 43rem !important;\n  }\n\n  .my-md-88 {\n    margin-top: 43.5rem !important;\n    margin-bottom: 43.5rem !important;\n  }\n\n  .my-md-89 {\n    margin-top: 44rem !important;\n    margin-bottom: 44rem !important;\n  }\n\n  .my-md-90 {\n    margin-top: 44.5rem !important;\n    margin-bottom: 44.5rem !important;\n  }\n\n  .my-md-91 {\n    margin-top: 45rem !important;\n    margin-bottom: 45rem !important;\n  }\n\n  .my-md-92 {\n    margin-top: 45.5rem !important;\n    margin-bottom: 45.5rem !important;\n  }\n\n  .my-md-93 {\n    margin-top: 46rem !important;\n    margin-bottom: 46rem !important;\n  }\n\n  .my-md-94 {\n    margin-top: 46.5rem !important;\n    margin-bottom: 46.5rem !important;\n  }\n\n  .my-md-95 {\n    margin-top: 47rem !important;\n    margin-bottom: 47rem !important;\n  }\n\n  .my-md-96 {\n    margin-top: 47.5rem !important;\n    margin-bottom: 47.5rem !important;\n  }\n\n  .my-md-97 {\n    margin-top: 48rem !important;\n    margin-bottom: 48rem !important;\n  }\n\n  .my-md-98 {\n    margin-top: 48.5rem !important;\n    margin-bottom: 48.5rem !important;\n  }\n\n  .my-md-99 {\n    margin-top: 49rem !important;\n    margin-bottom: 49rem !important;\n  }\n\n  .my-md-100 {\n    margin-top: 49.5rem !important;\n    margin-bottom: 49.5rem !important;\n  }\n\n  .my-md-101 {\n    margin-top: 50rem !important;\n    margin-bottom: 50rem !important;\n  }\n\n  .my-md-102 {\n    margin-top: 50.5rem !important;\n    margin-bottom: 50.5rem !important;\n  }\n\n  .my-md-103 {\n    margin-top: 51rem !important;\n    margin-bottom: 51rem !important;\n  }\n\n  .my-md-104 {\n    margin-top: 51.5rem !important;\n    margin-bottom: 51.5rem !important;\n  }\n\n  .my-md-105 {\n    margin-top: 52rem !important;\n    margin-bottom: 52rem !important;\n  }\n\n  .my-md-106 {\n    margin-top: 52.5rem !important;\n    margin-bottom: 52.5rem !important;\n  }\n\n  .my-md-107 {\n    margin-top: 53rem !important;\n    margin-bottom: 53rem !important;\n  }\n\n  .my-md-108 {\n    margin-top: 53.5rem !important;\n    margin-bottom: 53.5rem !important;\n  }\n\n  .my-md-109 {\n    margin-top: 54rem !important;\n    margin-bottom: 54rem !important;\n  }\n\n  .my-md-110 {\n    margin-top: 54.5rem !important;\n    margin-bottom: 54.5rem !important;\n  }\n\n  .my-md-111 {\n    margin-top: 55rem !important;\n    margin-bottom: 55rem !important;\n  }\n\n  .my-md-112 {\n    margin-top: 55.5rem !important;\n    margin-bottom: 55.5rem !important;\n  }\n\n  .my-md-113 {\n    margin-top: 56rem !important;\n    margin-bottom: 56rem !important;\n  }\n\n  .my-md-114 {\n    margin-top: 56.5rem !important;\n    margin-bottom: 56.5rem !important;\n  }\n\n  .my-md-115 {\n    margin-top: 57rem !important;\n    margin-bottom: 57rem !important;\n  }\n\n  .my-md-116 {\n    margin-top: 57.5rem !important;\n    margin-bottom: 57.5rem !important;\n  }\n\n  .my-md-117 {\n    margin-top: 58rem !important;\n    margin-bottom: 58rem !important;\n  }\n\n  .my-md-118 {\n    margin-top: 58.5rem !important;\n    margin-bottom: 58.5rem !important;\n  }\n\n  .my-md-119 {\n    margin-top: 59rem !important;\n    margin-bottom: 59rem !important;\n  }\n\n  .my-md-120 {\n    margin-top: 59.5rem !important;\n    margin-bottom: 59.5rem !important;\n  }\n\n  .my-md-121 {\n    margin-top: 60rem !important;\n    margin-bottom: 60rem !important;\n  }\n\n  .my-md-122 {\n    margin-top: 60.5rem !important;\n    margin-bottom: 60.5rem !important;\n  }\n\n  .my-md-123 {\n    margin-top: 61rem !important;\n    margin-bottom: 61rem !important;\n  }\n\n  .my-md-124 {\n    margin-top: 61.5rem !important;\n    margin-bottom: 61.5rem !important;\n  }\n\n  .my-md-125 {\n    margin-top: 62rem !important;\n    margin-bottom: 62rem !important;\n  }\n\n  .my-md-126 {\n    margin-top: 62.5rem !important;\n    margin-bottom: 62.5rem !important;\n  }\n\n  .my-md-127 {\n    margin-top: 63rem !important;\n    margin-bottom: 63rem !important;\n  }\n\n  .my-md-128 {\n    margin-top: 63.5rem !important;\n    margin-bottom: 63.5rem !important;\n  }\n\n  .my-md-129 {\n    margin-top: 64rem !important;\n    margin-bottom: 64rem !important;\n  }\n\n  .my-md-130 {\n    margin-top: 64.5rem !important;\n    margin-bottom: 64.5rem !important;\n  }\n\n  .my-md-131 {\n    margin-top: 65rem !important;\n    margin-bottom: 65rem !important;\n  }\n\n  .my-md-132 {\n    margin-top: 65.5rem !important;\n    margin-bottom: 65.5rem !important;\n  }\n\n  .my-md-133 {\n    margin-top: 66rem !important;\n    margin-bottom: 66rem !important;\n  }\n\n  .my-md-134 {\n    margin-top: 66.5rem !important;\n    margin-bottom: 66.5rem !important;\n  }\n\n  .my-md-135 {\n    margin-top: 67rem !important;\n    margin-bottom: 67rem !important;\n  }\n\n  .my-md-136 {\n    margin-top: 67.5rem !important;\n    margin-bottom: 67.5rem !important;\n  }\n\n  .my-md-137 {\n    margin-top: 68rem !important;\n    margin-bottom: 68rem !important;\n  }\n\n  .my-md-138 {\n    margin-top: 68.5rem !important;\n    margin-bottom: 68.5rem !important;\n  }\n\n  .my-md-139 {\n    margin-top: 69rem !important;\n    margin-bottom: 69rem !important;\n  }\n\n  .my-md-140 {\n    margin-top: 69.5rem !important;\n    margin-bottom: 69.5rem !important;\n  }\n\n  .my-md-141 {\n    margin-top: 70rem !important;\n    margin-bottom: 70rem !important;\n  }\n\n  .my-md-142 {\n    margin-top: 70.5rem !important;\n    margin-bottom: 70.5rem !important;\n  }\n\n  .my-md-143 {\n    margin-top: 71rem !important;\n    margin-bottom: 71rem !important;\n  }\n\n  .my-md-144 {\n    margin-top: 71.5rem !important;\n    margin-bottom: 71.5rem !important;\n  }\n\n  .my-md-145 {\n    margin-top: 72rem !important;\n    margin-bottom: 72rem !important;\n  }\n\n  .my-md-146 {\n    margin-top: 72.5rem !important;\n    margin-bottom: 72.5rem !important;\n  }\n\n  .my-md-147 {\n    margin-top: 73rem !important;\n    margin-bottom: 73rem !important;\n  }\n\n  .my-md-148 {\n    margin-top: 73.5rem !important;\n    margin-bottom: 73.5rem !important;\n  }\n\n  .my-md-149 {\n    margin-top: 74rem !important;\n    margin-bottom: 74rem !important;\n  }\n\n  .my-md-150 {\n    margin-top: 74.5rem !important;\n    margin-bottom: 74.5rem !important;\n  }\n\n  .my-md-151 {\n    margin-top: 75rem !important;\n    margin-bottom: 75rem !important;\n  }\n\n  .my-md-152 {\n    margin-top: 75.5rem !important;\n    margin-bottom: 75.5rem !important;\n  }\n\n  .my-md-153 {\n    margin-top: 76rem !important;\n    margin-bottom: 76rem !important;\n  }\n\n  .my-md-154 {\n    margin-top: 76.5rem !important;\n    margin-bottom: 76.5rem !important;\n  }\n\n  .my-md-155 {\n    margin-top: 77rem !important;\n    margin-bottom: 77rem !important;\n  }\n\n  .my-md-156 {\n    margin-top: 77.5rem !important;\n    margin-bottom: 77.5rem !important;\n  }\n\n  .my-md-157 {\n    margin-top: 78rem !important;\n    margin-bottom: 78rem !important;\n  }\n\n  .my-md-158 {\n    margin-top: 78.5rem !important;\n    margin-bottom: 78.5rem !important;\n  }\n\n  .my-md-159 {\n    margin-top: 79rem !important;\n    margin-bottom: 79rem !important;\n  }\n\n  .my-md-160 {\n    margin-top: 79.5rem !important;\n    margin-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0rem !important;\n  }\n\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-lg-5 {\n    margin: 2rem !important;\n  }\n\n  .m-lg-6 {\n    margin: 2.5rem !important;\n  }\n\n  .m-lg-7 {\n    margin: 3rem !important;\n  }\n\n  .m-lg-8 {\n    margin: 3.5rem !important;\n  }\n\n  .m-lg-9 {\n    margin: 4rem !important;\n  }\n\n  .m-lg-10 {\n    margin: 4.5rem !important;\n  }\n\n  .m-lg-11 {\n    margin: 5rem !important;\n  }\n\n  .m-lg-12 {\n    margin: 5.5rem !important;\n  }\n\n  .m-lg-13 {\n    margin: 6rem !important;\n  }\n\n  .m-lg-14 {\n    margin: 6.5rem !important;\n  }\n\n  .m-lg-15 {\n    margin: 7rem !important;\n  }\n\n  .m-lg-16 {\n    margin: 7.5rem !important;\n  }\n\n  .m-lg-17 {\n    margin: 8rem !important;\n  }\n\n  .m-lg-18 {\n    margin: 8.5rem !important;\n  }\n\n  .m-lg-19 {\n    margin: 9rem !important;\n  }\n\n  .m-lg-20 {\n    margin: 9.5rem !important;\n  }\n\n  .m-lg-21 {\n    margin: 10rem !important;\n  }\n\n  .m-lg-22 {\n    margin: 10.5rem !important;\n  }\n\n  .m-lg-23 {\n    margin: 11rem !important;\n  }\n\n  .m-lg-24 {\n    margin: 11.5rem !important;\n  }\n\n  .m-lg-25 {\n    margin: 12rem !important;\n  }\n\n  .m-lg-26 {\n    margin: 12.5rem !important;\n  }\n\n  .m-lg-27 {\n    margin: 13rem !important;\n  }\n\n  .m-lg-28 {\n    margin: 13.5rem !important;\n  }\n\n  .m-lg-29 {\n    margin: 14rem !important;\n  }\n\n  .m-lg-30 {\n    margin: 14.5rem !important;\n  }\n\n  .m-lg-31 {\n    margin: 15rem !important;\n  }\n\n  .m-lg-32 {\n    margin: 15.5rem !important;\n  }\n\n  .m-lg-33 {\n    margin: 16rem !important;\n  }\n\n  .m-lg-34 {\n    margin: 16.5rem !important;\n  }\n\n  .m-lg-35 {\n    margin: 17rem !important;\n  }\n\n  .m-lg-36 {\n    margin: 17.5rem !important;\n  }\n\n  .m-lg-37 {\n    margin: 18rem !important;\n  }\n\n  .m-lg-38 {\n    margin: 18.5rem !important;\n  }\n\n  .m-lg-39 {\n    margin: 19rem !important;\n  }\n\n  .m-lg-40 {\n    margin: 19.5rem !important;\n  }\n\n  .m-lg-41 {\n    margin: 20rem !important;\n  }\n\n  .m-lg-42 {\n    margin: 20.5rem !important;\n  }\n\n  .m-lg-43 {\n    margin: 21rem !important;\n  }\n\n  .m-lg-44 {\n    margin: 21.5rem !important;\n  }\n\n  .m-lg-45 {\n    margin: 22rem !important;\n  }\n\n  .m-lg-46 {\n    margin: 22.5rem !important;\n  }\n\n  .m-lg-47 {\n    margin: 23rem !important;\n  }\n\n  .m-lg-48 {\n    margin: 23.5rem !important;\n  }\n\n  .m-lg-49 {\n    margin: 24rem !important;\n  }\n\n  .m-lg-50 {\n    margin: 24.5rem !important;\n  }\n\n  .m-lg-51 {\n    margin: 25rem !important;\n  }\n\n  .m-lg-52 {\n    margin: 25.5rem !important;\n  }\n\n  .m-lg-53 {\n    margin: 26rem !important;\n  }\n\n  .m-lg-54 {\n    margin: 26.5rem !important;\n  }\n\n  .m-lg-55 {\n    margin: 27rem !important;\n  }\n\n  .m-lg-56 {\n    margin: 27.5rem !important;\n  }\n\n  .m-lg-57 {\n    margin: 28rem !important;\n  }\n\n  .m-lg-58 {\n    margin: 28.5rem !important;\n  }\n\n  .m-lg-59 {\n    margin: 29rem !important;\n  }\n\n  .m-lg-60 {\n    margin: 29.5rem !important;\n  }\n\n  .m-lg-61 {\n    margin: 30rem !important;\n  }\n\n  .m-lg-62 {\n    margin: 30.5rem !important;\n  }\n\n  .m-lg-63 {\n    margin: 31rem !important;\n  }\n\n  .m-lg-64 {\n    margin: 31.5rem !important;\n  }\n\n  .m-lg-65 {\n    margin: 32rem !important;\n  }\n\n  .m-lg-66 {\n    margin: 32.5rem !important;\n  }\n\n  .m-lg-67 {\n    margin: 33rem !important;\n  }\n\n  .m-lg-68 {\n    margin: 33.5rem !important;\n  }\n\n  .m-lg-69 {\n    margin: 34rem !important;\n  }\n\n  .m-lg-70 {\n    margin: 34.5rem !important;\n  }\n\n  .m-lg-71 {\n    margin: 35rem !important;\n  }\n\n  .m-lg-72 {\n    margin: 35.5rem !important;\n  }\n\n  .m-lg-73 {\n    margin: 36rem !important;\n  }\n\n  .m-lg-74 {\n    margin: 36.5rem !important;\n  }\n\n  .m-lg-75 {\n    margin: 37rem !important;\n  }\n\n  .m-lg-76 {\n    margin: 37.5rem !important;\n  }\n\n  .m-lg-77 {\n    margin: 38rem !important;\n  }\n\n  .m-lg-78 {\n    margin: 38.5rem !important;\n  }\n\n  .m-lg-79 {\n    margin: 39rem !important;\n  }\n\n  .m-lg-80 {\n    margin: 39.5rem !important;\n  }\n\n  .m-lg-81 {\n    margin: 40rem !important;\n  }\n\n  .m-lg-82 {\n    margin: 40.5rem !important;\n  }\n\n  .m-lg-83 {\n    margin: 41rem !important;\n  }\n\n  .m-lg-84 {\n    margin: 41.5rem !important;\n  }\n\n  .m-lg-85 {\n    margin: 42rem !important;\n  }\n\n  .m-lg-86 {\n    margin: 42.5rem !important;\n  }\n\n  .m-lg-87 {\n    margin: 43rem !important;\n  }\n\n  .m-lg-88 {\n    margin: 43.5rem !important;\n  }\n\n  .m-lg-89 {\n    margin: 44rem !important;\n  }\n\n  .m-lg-90 {\n    margin: 44.5rem !important;\n  }\n\n  .m-lg-91 {\n    margin: 45rem !important;\n  }\n\n  .m-lg-92 {\n    margin: 45.5rem !important;\n  }\n\n  .m-lg-93 {\n    margin: 46rem !important;\n  }\n\n  .m-lg-94 {\n    margin: 46.5rem !important;\n  }\n\n  .m-lg-95 {\n    margin: 47rem !important;\n  }\n\n  .m-lg-96 {\n    margin: 47.5rem !important;\n  }\n\n  .m-lg-97 {\n    margin: 48rem !important;\n  }\n\n  .m-lg-98 {\n    margin: 48.5rem !important;\n  }\n\n  .m-lg-99 {\n    margin: 49rem !important;\n  }\n\n  .m-lg-100 {\n    margin: 49.5rem !important;\n  }\n\n  .m-lg-101 {\n    margin: 50rem !important;\n  }\n\n  .m-lg-102 {\n    margin: 50.5rem !important;\n  }\n\n  .m-lg-103 {\n    margin: 51rem !important;\n  }\n\n  .m-lg-104 {\n    margin: 51.5rem !important;\n  }\n\n  .m-lg-105 {\n    margin: 52rem !important;\n  }\n\n  .m-lg-106 {\n    margin: 52.5rem !important;\n  }\n\n  .m-lg-107 {\n    margin: 53rem !important;\n  }\n\n  .m-lg-108 {\n    margin: 53.5rem !important;\n  }\n\n  .m-lg-109 {\n    margin: 54rem !important;\n  }\n\n  .m-lg-110 {\n    margin: 54.5rem !important;\n  }\n\n  .m-lg-111 {\n    margin: 55rem !important;\n  }\n\n  .m-lg-112 {\n    margin: 55.5rem !important;\n  }\n\n  .m-lg-113 {\n    margin: 56rem !important;\n  }\n\n  .m-lg-114 {\n    margin: 56.5rem !important;\n  }\n\n  .m-lg-115 {\n    margin: 57rem !important;\n  }\n\n  .m-lg-116 {\n    margin: 57.5rem !important;\n  }\n\n  .m-lg-117 {\n    margin: 58rem !important;\n  }\n\n  .m-lg-118 {\n    margin: 58.5rem !important;\n  }\n\n  .m-lg-119 {\n    margin: 59rem !important;\n  }\n\n  .m-lg-120 {\n    margin: 59.5rem !important;\n  }\n\n  .m-lg-121 {\n    margin: 60rem !important;\n  }\n\n  .m-lg-122 {\n    margin: 60.5rem !important;\n  }\n\n  .m-lg-123 {\n    margin: 61rem !important;\n  }\n\n  .m-lg-124 {\n    margin: 61.5rem !important;\n  }\n\n  .m-lg-125 {\n    margin: 62rem !important;\n  }\n\n  .m-lg-126 {\n    margin: 62.5rem !important;\n  }\n\n  .m-lg-127 {\n    margin: 63rem !important;\n  }\n\n  .m-lg-128 {\n    margin: 63.5rem !important;\n  }\n\n  .m-lg-129 {\n    margin: 64rem !important;\n  }\n\n  .m-lg-130 {\n    margin: 64.5rem !important;\n  }\n\n  .m-lg-131 {\n    margin: 65rem !important;\n  }\n\n  .m-lg-132 {\n    margin: 65.5rem !important;\n  }\n\n  .m-lg-133 {\n    margin: 66rem !important;\n  }\n\n  .m-lg-134 {\n    margin: 66.5rem !important;\n  }\n\n  .m-lg-135 {\n    margin: 67rem !important;\n  }\n\n  .m-lg-136 {\n    margin: 67.5rem !important;\n  }\n\n  .m-lg-137 {\n    margin: 68rem !important;\n  }\n\n  .m-lg-138 {\n    margin: 68.5rem !important;\n  }\n\n  .m-lg-139 {\n    margin: 69rem !important;\n  }\n\n  .m-lg-140 {\n    margin: 69.5rem !important;\n  }\n\n  .m-lg-141 {\n    margin: 70rem !important;\n  }\n\n  .m-lg-142 {\n    margin: 70.5rem !important;\n  }\n\n  .m-lg-143 {\n    margin: 71rem !important;\n  }\n\n  .m-lg-144 {\n    margin: 71.5rem !important;\n  }\n\n  .m-lg-145 {\n    margin: 72rem !important;\n  }\n\n  .m-lg-146 {\n    margin: 72.5rem !important;\n  }\n\n  .m-lg-147 {\n    margin: 73rem !important;\n  }\n\n  .m-lg-148 {\n    margin: 73.5rem !important;\n  }\n\n  .m-lg-149 {\n    margin: 74rem !important;\n  }\n\n  .m-lg-150 {\n    margin: 74.5rem !important;\n  }\n\n  .m-lg-151 {\n    margin: 75rem !important;\n  }\n\n  .m-lg-152 {\n    margin: 75.5rem !important;\n  }\n\n  .m-lg-153 {\n    margin: 76rem !important;\n  }\n\n  .m-lg-154 {\n    margin: 76.5rem !important;\n  }\n\n  .m-lg-155 {\n    margin: 77rem !important;\n  }\n\n  .m-lg-156 {\n    margin: 77.5rem !important;\n  }\n\n  .m-lg-157 {\n    margin: 78rem !important;\n  }\n\n  .m-lg-158 {\n    margin: 78.5rem !important;\n  }\n\n  .m-lg-159 {\n    margin: 79rem !important;\n  }\n\n  .m-lg-160 {\n    margin: 79.5rem !important;\n  }\n\n  .mt-lg-0 {\n    margin-top: 0rem !important;\n  }\n\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-lg-5 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-lg-6 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-lg-7 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-lg-8 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-lg-9 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-lg-10 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-lg-11 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-lg-12 {\n    margin-top: 5.5rem !important;\n  }\n\n  .mt-lg-13 {\n    margin-top: 6rem !important;\n  }\n\n  .mt-lg-14 {\n    margin-top: 6.5rem !important;\n  }\n\n  .mt-lg-15 {\n    margin-top: 7rem !important;\n  }\n\n  .mt-lg-16 {\n    margin-top: 7.5rem !important;\n  }\n\n  .mt-lg-17 {\n    margin-top: 8rem !important;\n  }\n\n  .mt-lg-18 {\n    margin-top: 8.5rem !important;\n  }\n\n  .mt-lg-19 {\n    margin-top: 9rem !important;\n  }\n\n  .mt-lg-20 {\n    margin-top: 9.5rem !important;\n  }\n\n  .mt-lg-21 {\n    margin-top: 10rem !important;\n  }\n\n  .mt-lg-22 {\n    margin-top: 10.5rem !important;\n  }\n\n  .mt-lg-23 {\n    margin-top: 11rem !important;\n  }\n\n  .mt-lg-24 {\n    margin-top: 11.5rem !important;\n  }\n\n  .mt-lg-25 {\n    margin-top: 12rem !important;\n  }\n\n  .mt-lg-26 {\n    margin-top: 12.5rem !important;\n  }\n\n  .mt-lg-27 {\n    margin-top: 13rem !important;\n  }\n\n  .mt-lg-28 {\n    margin-top: 13.5rem !important;\n  }\n\n  .mt-lg-29 {\n    margin-top: 14rem !important;\n  }\n\n  .mt-lg-30 {\n    margin-top: 14.5rem !important;\n  }\n\n  .mt-lg-31 {\n    margin-top: 15rem !important;\n  }\n\n  .mt-lg-32 {\n    margin-top: 15.5rem !important;\n  }\n\n  .mt-lg-33 {\n    margin-top: 16rem !important;\n  }\n\n  .mt-lg-34 {\n    margin-top: 16.5rem !important;\n  }\n\n  .mt-lg-35 {\n    margin-top: 17rem !important;\n  }\n\n  .mt-lg-36 {\n    margin-top: 17.5rem !important;\n  }\n\n  .mt-lg-37 {\n    margin-top: 18rem !important;\n  }\n\n  .mt-lg-38 {\n    margin-top: 18.5rem !important;\n  }\n\n  .mt-lg-39 {\n    margin-top: 19rem !important;\n  }\n\n  .mt-lg-40 {\n    margin-top: 19.5rem !important;\n  }\n\n  .mt-lg-41 {\n    margin-top: 20rem !important;\n  }\n\n  .mt-lg-42 {\n    margin-top: 20.5rem !important;\n  }\n\n  .mt-lg-43 {\n    margin-top: 21rem !important;\n  }\n\n  .mt-lg-44 {\n    margin-top: 21.5rem !important;\n  }\n\n  .mt-lg-45 {\n    margin-top: 22rem !important;\n  }\n\n  .mt-lg-46 {\n    margin-top: 22.5rem !important;\n  }\n\n  .mt-lg-47 {\n    margin-top: 23rem !important;\n  }\n\n  .mt-lg-48 {\n    margin-top: 23.5rem !important;\n  }\n\n  .mt-lg-49 {\n    margin-top: 24rem !important;\n  }\n\n  .mt-lg-50 {\n    margin-top: 24.5rem !important;\n  }\n\n  .mt-lg-51 {\n    margin-top: 25rem !important;\n  }\n\n  .mt-lg-52 {\n    margin-top: 25.5rem !important;\n  }\n\n  .mt-lg-53 {\n    margin-top: 26rem !important;\n  }\n\n  .mt-lg-54 {\n    margin-top: 26.5rem !important;\n  }\n\n  .mt-lg-55 {\n    margin-top: 27rem !important;\n  }\n\n  .mt-lg-56 {\n    margin-top: 27.5rem !important;\n  }\n\n  .mt-lg-57 {\n    margin-top: 28rem !important;\n  }\n\n  .mt-lg-58 {\n    margin-top: 28.5rem !important;\n  }\n\n  .mt-lg-59 {\n    margin-top: 29rem !important;\n  }\n\n  .mt-lg-60 {\n    margin-top: 29.5rem !important;\n  }\n\n  .mt-lg-61 {\n    margin-top: 30rem !important;\n  }\n\n  .mt-lg-62 {\n    margin-top: 30.5rem !important;\n  }\n\n  .mt-lg-63 {\n    margin-top: 31rem !important;\n  }\n\n  .mt-lg-64 {\n    margin-top: 31.5rem !important;\n  }\n\n  .mt-lg-65 {\n    margin-top: 32rem !important;\n  }\n\n  .mt-lg-66 {\n    margin-top: 32.5rem !important;\n  }\n\n  .mt-lg-67 {\n    margin-top: 33rem !important;\n  }\n\n  .mt-lg-68 {\n    margin-top: 33.5rem !important;\n  }\n\n  .mt-lg-69 {\n    margin-top: 34rem !important;\n  }\n\n  .mt-lg-70 {\n    margin-top: 34.5rem !important;\n  }\n\n  .mt-lg-71 {\n    margin-top: 35rem !important;\n  }\n\n  .mt-lg-72 {\n    margin-top: 35.5rem !important;\n  }\n\n  .mt-lg-73 {\n    margin-top: 36rem !important;\n  }\n\n  .mt-lg-74 {\n    margin-top: 36.5rem !important;\n  }\n\n  .mt-lg-75 {\n    margin-top: 37rem !important;\n  }\n\n  .mt-lg-76 {\n    margin-top: 37.5rem !important;\n  }\n\n  .mt-lg-77 {\n    margin-top: 38rem !important;\n  }\n\n  .mt-lg-78 {\n    margin-top: 38.5rem !important;\n  }\n\n  .mt-lg-79 {\n    margin-top: 39rem !important;\n  }\n\n  .mt-lg-80 {\n    margin-top: 39.5rem !important;\n  }\n\n  .mt-lg-81 {\n    margin-top: 40rem !important;\n  }\n\n  .mt-lg-82 {\n    margin-top: 40.5rem !important;\n  }\n\n  .mt-lg-83 {\n    margin-top: 41rem !important;\n  }\n\n  .mt-lg-84 {\n    margin-top: 41.5rem !important;\n  }\n\n  .mt-lg-85 {\n    margin-top: 42rem !important;\n  }\n\n  .mt-lg-86 {\n    margin-top: 42.5rem !important;\n  }\n\n  .mt-lg-87 {\n    margin-top: 43rem !important;\n  }\n\n  .mt-lg-88 {\n    margin-top: 43.5rem !important;\n  }\n\n  .mt-lg-89 {\n    margin-top: 44rem !important;\n  }\n\n  .mt-lg-90 {\n    margin-top: 44.5rem !important;\n  }\n\n  .mt-lg-91 {\n    margin-top: 45rem !important;\n  }\n\n  .mt-lg-92 {\n    margin-top: 45.5rem !important;\n  }\n\n  .mt-lg-93 {\n    margin-top: 46rem !important;\n  }\n\n  .mt-lg-94 {\n    margin-top: 46.5rem !important;\n  }\n\n  .mt-lg-95 {\n    margin-top: 47rem !important;\n  }\n\n  .mt-lg-96 {\n    margin-top: 47.5rem !important;\n  }\n\n  .mt-lg-97 {\n    margin-top: 48rem !important;\n  }\n\n  .mt-lg-98 {\n    margin-top: 48.5rem !important;\n  }\n\n  .mt-lg-99 {\n    margin-top: 49rem !important;\n  }\n\n  .mt-lg-100 {\n    margin-top: 49.5rem !important;\n  }\n\n  .mt-lg-101 {\n    margin-top: 50rem !important;\n  }\n\n  .mt-lg-102 {\n    margin-top: 50.5rem !important;\n  }\n\n  .mt-lg-103 {\n    margin-top: 51rem !important;\n  }\n\n  .mt-lg-104 {\n    margin-top: 51.5rem !important;\n  }\n\n  .mt-lg-105 {\n    margin-top: 52rem !important;\n  }\n\n  .mt-lg-106 {\n    margin-top: 52.5rem !important;\n  }\n\n  .mt-lg-107 {\n    margin-top: 53rem !important;\n  }\n\n  .mt-lg-108 {\n    margin-top: 53.5rem !important;\n  }\n\n  .mt-lg-109 {\n    margin-top: 54rem !important;\n  }\n\n  .mt-lg-110 {\n    margin-top: 54.5rem !important;\n  }\n\n  .mt-lg-111 {\n    margin-top: 55rem !important;\n  }\n\n  .mt-lg-112 {\n    margin-top: 55.5rem !important;\n  }\n\n  .mt-lg-113 {\n    margin-top: 56rem !important;\n  }\n\n  .mt-lg-114 {\n    margin-top: 56.5rem !important;\n  }\n\n  .mt-lg-115 {\n    margin-top: 57rem !important;\n  }\n\n  .mt-lg-116 {\n    margin-top: 57.5rem !important;\n  }\n\n  .mt-lg-117 {\n    margin-top: 58rem !important;\n  }\n\n  .mt-lg-118 {\n    margin-top: 58.5rem !important;\n  }\n\n  .mt-lg-119 {\n    margin-top: 59rem !important;\n  }\n\n  .mt-lg-120 {\n    margin-top: 59.5rem !important;\n  }\n\n  .mt-lg-121 {\n    margin-top: 60rem !important;\n  }\n\n  .mt-lg-122 {\n    margin-top: 60.5rem !important;\n  }\n\n  .mt-lg-123 {\n    margin-top: 61rem !important;\n  }\n\n  .mt-lg-124 {\n    margin-top: 61.5rem !important;\n  }\n\n  .mt-lg-125 {\n    margin-top: 62rem !important;\n  }\n\n  .mt-lg-126 {\n    margin-top: 62.5rem !important;\n  }\n\n  .mt-lg-127 {\n    margin-top: 63rem !important;\n  }\n\n  .mt-lg-128 {\n    margin-top: 63.5rem !important;\n  }\n\n  .mt-lg-129 {\n    margin-top: 64rem !important;\n  }\n\n  .mt-lg-130 {\n    margin-top: 64.5rem !important;\n  }\n\n  .mt-lg-131 {\n    margin-top: 65rem !important;\n  }\n\n  .mt-lg-132 {\n    margin-top: 65.5rem !important;\n  }\n\n  .mt-lg-133 {\n    margin-top: 66rem !important;\n  }\n\n  .mt-lg-134 {\n    margin-top: 66.5rem !important;\n  }\n\n  .mt-lg-135 {\n    margin-top: 67rem !important;\n  }\n\n  .mt-lg-136 {\n    margin-top: 67.5rem !important;\n  }\n\n  .mt-lg-137 {\n    margin-top: 68rem !important;\n  }\n\n  .mt-lg-138 {\n    margin-top: 68.5rem !important;\n  }\n\n  .mt-lg-139 {\n    margin-top: 69rem !important;\n  }\n\n  .mt-lg-140 {\n    margin-top: 69.5rem !important;\n  }\n\n  .mt-lg-141 {\n    margin-top: 70rem !important;\n  }\n\n  .mt-lg-142 {\n    margin-top: 70.5rem !important;\n  }\n\n  .mt-lg-143 {\n    margin-top: 71rem !important;\n  }\n\n  .mt-lg-144 {\n    margin-top: 71.5rem !important;\n  }\n\n  .mt-lg-145 {\n    margin-top: 72rem !important;\n  }\n\n  .mt-lg-146 {\n    margin-top: 72.5rem !important;\n  }\n\n  .mt-lg-147 {\n    margin-top: 73rem !important;\n  }\n\n  .mt-lg-148 {\n    margin-top: 73.5rem !important;\n  }\n\n  .mt-lg-149 {\n    margin-top: 74rem !important;\n  }\n\n  .mt-lg-150 {\n    margin-top: 74.5rem !important;\n  }\n\n  .mt-lg-151 {\n    margin-top: 75rem !important;\n  }\n\n  .mt-lg-152 {\n    margin-top: 75.5rem !important;\n  }\n\n  .mt-lg-153 {\n    margin-top: 76rem !important;\n  }\n\n  .mt-lg-154 {\n    margin-top: 76.5rem !important;\n  }\n\n  .mt-lg-155 {\n    margin-top: 77rem !important;\n  }\n\n  .mt-lg-156 {\n    margin-top: 77.5rem !important;\n  }\n\n  .mt-lg-157 {\n    margin-top: 78rem !important;\n  }\n\n  .mt-lg-158 {\n    margin-top: 78.5rem !important;\n  }\n\n  .mt-lg-159 {\n    margin-top: 79rem !important;\n  }\n\n  .mt-lg-160 {\n    margin-top: 79.5rem !important;\n  }\n\n  .mb-lg-0 {\n    margin-bottom: 0rem !important;\n  }\n\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-lg-5 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-lg-6 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-lg-7 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-lg-8 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-lg-9 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-lg-10 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-lg-11 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-lg-12 {\n    margin-bottom: 5.5rem !important;\n  }\n\n  .mb-lg-13 {\n    margin-bottom: 6rem !important;\n  }\n\n  .mb-lg-14 {\n    margin-bottom: 6.5rem !important;\n  }\n\n  .mb-lg-15 {\n    margin-bottom: 7rem !important;\n  }\n\n  .mb-lg-16 {\n    margin-bottom: 7.5rem !important;\n  }\n\n  .mb-lg-17 {\n    margin-bottom: 8rem !important;\n  }\n\n  .mb-lg-18 {\n    margin-bottom: 8.5rem !important;\n  }\n\n  .mb-lg-19 {\n    margin-bottom: 9rem !important;\n  }\n\n  .mb-lg-20 {\n    margin-bottom: 9.5rem !important;\n  }\n\n  .mb-lg-21 {\n    margin-bottom: 10rem !important;\n  }\n\n  .mb-lg-22 {\n    margin-bottom: 10.5rem !important;\n  }\n\n  .mb-lg-23 {\n    margin-bottom: 11rem !important;\n  }\n\n  .mb-lg-24 {\n    margin-bottom: 11.5rem !important;\n  }\n\n  .mb-lg-25 {\n    margin-bottom: 12rem !important;\n  }\n\n  .mb-lg-26 {\n    margin-bottom: 12.5rem !important;\n  }\n\n  .mb-lg-27 {\n    margin-bottom: 13rem !important;\n  }\n\n  .mb-lg-28 {\n    margin-bottom: 13.5rem !important;\n  }\n\n  .mb-lg-29 {\n    margin-bottom: 14rem !important;\n  }\n\n  .mb-lg-30 {\n    margin-bottom: 14.5rem !important;\n  }\n\n  .mb-lg-31 {\n    margin-bottom: 15rem !important;\n  }\n\n  .mb-lg-32 {\n    margin-bottom: 15.5rem !important;\n  }\n\n  .mb-lg-33 {\n    margin-bottom: 16rem !important;\n  }\n\n  .mb-lg-34 {\n    margin-bottom: 16.5rem !important;\n  }\n\n  .mb-lg-35 {\n    margin-bottom: 17rem !important;\n  }\n\n  .mb-lg-36 {\n    margin-bottom: 17.5rem !important;\n  }\n\n  .mb-lg-37 {\n    margin-bottom: 18rem !important;\n  }\n\n  .mb-lg-38 {\n    margin-bottom: 18.5rem !important;\n  }\n\n  .mb-lg-39 {\n    margin-bottom: 19rem !important;\n  }\n\n  .mb-lg-40 {\n    margin-bottom: 19.5rem !important;\n  }\n\n  .mb-lg-41 {\n    margin-bottom: 20rem !important;\n  }\n\n  .mb-lg-42 {\n    margin-bottom: 20.5rem !important;\n  }\n\n  .mb-lg-43 {\n    margin-bottom: 21rem !important;\n  }\n\n  .mb-lg-44 {\n    margin-bottom: 21.5rem !important;\n  }\n\n  .mb-lg-45 {\n    margin-bottom: 22rem !important;\n  }\n\n  .mb-lg-46 {\n    margin-bottom: 22.5rem !important;\n  }\n\n  .mb-lg-47 {\n    margin-bottom: 23rem !important;\n  }\n\n  .mb-lg-48 {\n    margin-bottom: 23.5rem !important;\n  }\n\n  .mb-lg-49 {\n    margin-bottom: 24rem !important;\n  }\n\n  .mb-lg-50 {\n    margin-bottom: 24.5rem !important;\n  }\n\n  .mb-lg-51 {\n    margin-bottom: 25rem !important;\n  }\n\n  .mb-lg-52 {\n    margin-bottom: 25.5rem !important;\n  }\n\n  .mb-lg-53 {\n    margin-bottom: 26rem !important;\n  }\n\n  .mb-lg-54 {\n    margin-bottom: 26.5rem !important;\n  }\n\n  .mb-lg-55 {\n    margin-bottom: 27rem !important;\n  }\n\n  .mb-lg-56 {\n    margin-bottom: 27.5rem !important;\n  }\n\n  .mb-lg-57 {\n    margin-bottom: 28rem !important;\n  }\n\n  .mb-lg-58 {\n    margin-bottom: 28.5rem !important;\n  }\n\n  .mb-lg-59 {\n    margin-bottom: 29rem !important;\n  }\n\n  .mb-lg-60 {\n    margin-bottom: 29.5rem !important;\n  }\n\n  .mb-lg-61 {\n    margin-bottom: 30rem !important;\n  }\n\n  .mb-lg-62 {\n    margin-bottom: 30.5rem !important;\n  }\n\n  .mb-lg-63 {\n    margin-bottom: 31rem !important;\n  }\n\n  .mb-lg-64 {\n    margin-bottom: 31.5rem !important;\n  }\n\n  .mb-lg-65 {\n    margin-bottom: 32rem !important;\n  }\n\n  .mb-lg-66 {\n    margin-bottom: 32.5rem !important;\n  }\n\n  .mb-lg-67 {\n    margin-bottom: 33rem !important;\n  }\n\n  .mb-lg-68 {\n    margin-bottom: 33.5rem !important;\n  }\n\n  .mb-lg-69 {\n    margin-bottom: 34rem !important;\n  }\n\n  .mb-lg-70 {\n    margin-bottom: 34.5rem !important;\n  }\n\n  .mb-lg-71 {\n    margin-bottom: 35rem !important;\n  }\n\n  .mb-lg-72 {\n    margin-bottom: 35.5rem !important;\n  }\n\n  .mb-lg-73 {\n    margin-bottom: 36rem !important;\n  }\n\n  .mb-lg-74 {\n    margin-bottom: 36.5rem !important;\n  }\n\n  .mb-lg-75 {\n    margin-bottom: 37rem !important;\n  }\n\n  .mb-lg-76 {\n    margin-bottom: 37.5rem !important;\n  }\n\n  .mb-lg-77 {\n    margin-bottom: 38rem !important;\n  }\n\n  .mb-lg-78 {\n    margin-bottom: 38.5rem !important;\n  }\n\n  .mb-lg-79 {\n    margin-bottom: 39rem !important;\n  }\n\n  .mb-lg-80 {\n    margin-bottom: 39.5rem !important;\n  }\n\n  .mb-lg-81 {\n    margin-bottom: 40rem !important;\n  }\n\n  .mb-lg-82 {\n    margin-bottom: 40.5rem !important;\n  }\n\n  .mb-lg-83 {\n    margin-bottom: 41rem !important;\n  }\n\n  .mb-lg-84 {\n    margin-bottom: 41.5rem !important;\n  }\n\n  .mb-lg-85 {\n    margin-bottom: 42rem !important;\n  }\n\n  .mb-lg-86 {\n    margin-bottom: 42.5rem !important;\n  }\n\n  .mb-lg-87 {\n    margin-bottom: 43rem !important;\n  }\n\n  .mb-lg-88 {\n    margin-bottom: 43.5rem !important;\n  }\n\n  .mb-lg-89 {\n    margin-bottom: 44rem !important;\n  }\n\n  .mb-lg-90 {\n    margin-bottom: 44.5rem !important;\n  }\n\n  .mb-lg-91 {\n    margin-bottom: 45rem !important;\n  }\n\n  .mb-lg-92 {\n    margin-bottom: 45.5rem !important;\n  }\n\n  .mb-lg-93 {\n    margin-bottom: 46rem !important;\n  }\n\n  .mb-lg-94 {\n    margin-bottom: 46.5rem !important;\n  }\n\n  .mb-lg-95 {\n    margin-bottom: 47rem !important;\n  }\n\n  .mb-lg-96 {\n    margin-bottom: 47.5rem !important;\n  }\n\n  .mb-lg-97 {\n    margin-bottom: 48rem !important;\n  }\n\n  .mb-lg-98 {\n    margin-bottom: 48.5rem !important;\n  }\n\n  .mb-lg-99 {\n    margin-bottom: 49rem !important;\n  }\n\n  .mb-lg-100 {\n    margin-bottom: 49.5rem !important;\n  }\n\n  .mb-lg-101 {\n    margin-bottom: 50rem !important;\n  }\n\n  .mb-lg-102 {\n    margin-bottom: 50.5rem !important;\n  }\n\n  .mb-lg-103 {\n    margin-bottom: 51rem !important;\n  }\n\n  .mb-lg-104 {\n    margin-bottom: 51.5rem !important;\n  }\n\n  .mb-lg-105 {\n    margin-bottom: 52rem !important;\n  }\n\n  .mb-lg-106 {\n    margin-bottom: 52.5rem !important;\n  }\n\n  .mb-lg-107 {\n    margin-bottom: 53rem !important;\n  }\n\n  .mb-lg-108 {\n    margin-bottom: 53.5rem !important;\n  }\n\n  .mb-lg-109 {\n    margin-bottom: 54rem !important;\n  }\n\n  .mb-lg-110 {\n    margin-bottom: 54.5rem !important;\n  }\n\n  .mb-lg-111 {\n    margin-bottom: 55rem !important;\n  }\n\n  .mb-lg-112 {\n    margin-bottom: 55.5rem !important;\n  }\n\n  .mb-lg-113 {\n    margin-bottom: 56rem !important;\n  }\n\n  .mb-lg-114 {\n    margin-bottom: 56.5rem !important;\n  }\n\n  .mb-lg-115 {\n    margin-bottom: 57rem !important;\n  }\n\n  .mb-lg-116 {\n    margin-bottom: 57.5rem !important;\n  }\n\n  .mb-lg-117 {\n    margin-bottom: 58rem !important;\n  }\n\n  .mb-lg-118 {\n    margin-bottom: 58.5rem !important;\n  }\n\n  .mb-lg-119 {\n    margin-bottom: 59rem !important;\n  }\n\n  .mb-lg-120 {\n    margin-bottom: 59.5rem !important;\n  }\n\n  .mb-lg-121 {\n    margin-bottom: 60rem !important;\n  }\n\n  .mb-lg-122 {\n    margin-bottom: 60.5rem !important;\n  }\n\n  .mb-lg-123 {\n    margin-bottom: 61rem !important;\n  }\n\n  .mb-lg-124 {\n    margin-bottom: 61.5rem !important;\n  }\n\n  .mb-lg-125 {\n    margin-bottom: 62rem !important;\n  }\n\n  .mb-lg-126 {\n    margin-bottom: 62.5rem !important;\n  }\n\n  .mb-lg-127 {\n    margin-bottom: 63rem !important;\n  }\n\n  .mb-lg-128 {\n    margin-bottom: 63.5rem !important;\n  }\n\n  .mb-lg-129 {\n    margin-bottom: 64rem !important;\n  }\n\n  .mb-lg-130 {\n    margin-bottom: 64.5rem !important;\n  }\n\n  .mb-lg-131 {\n    margin-bottom: 65rem !important;\n  }\n\n  .mb-lg-132 {\n    margin-bottom: 65.5rem !important;\n  }\n\n  .mb-lg-133 {\n    margin-bottom: 66rem !important;\n  }\n\n  .mb-lg-134 {\n    margin-bottom: 66.5rem !important;\n  }\n\n  .mb-lg-135 {\n    margin-bottom: 67rem !important;\n  }\n\n  .mb-lg-136 {\n    margin-bottom: 67.5rem !important;\n  }\n\n  .mb-lg-137 {\n    margin-bottom: 68rem !important;\n  }\n\n  .mb-lg-138 {\n    margin-bottom: 68.5rem !important;\n  }\n\n  .mb-lg-139 {\n    margin-bottom: 69rem !important;\n  }\n\n  .mb-lg-140 {\n    margin-bottom: 69.5rem !important;\n  }\n\n  .mb-lg-141 {\n    margin-bottom: 70rem !important;\n  }\n\n  .mb-lg-142 {\n    margin-bottom: 70.5rem !important;\n  }\n\n  .mb-lg-143 {\n    margin-bottom: 71rem !important;\n  }\n\n  .mb-lg-144 {\n    margin-bottom: 71.5rem !important;\n  }\n\n  .mb-lg-145 {\n    margin-bottom: 72rem !important;\n  }\n\n  .mb-lg-146 {\n    margin-bottom: 72.5rem !important;\n  }\n\n  .mb-lg-147 {\n    margin-bottom: 73rem !important;\n  }\n\n  .mb-lg-148 {\n    margin-bottom: 73.5rem !important;\n  }\n\n  .mb-lg-149 {\n    margin-bottom: 74rem !important;\n  }\n\n  .mb-lg-150 {\n    margin-bottom: 74.5rem !important;\n  }\n\n  .mb-lg-151 {\n    margin-bottom: 75rem !important;\n  }\n\n  .mb-lg-152 {\n    margin-bottom: 75.5rem !important;\n  }\n\n  .mb-lg-153 {\n    margin-bottom: 76rem !important;\n  }\n\n  .mb-lg-154 {\n    margin-bottom: 76.5rem !important;\n  }\n\n  .mb-lg-155 {\n    margin-bottom: 77rem !important;\n  }\n\n  .mb-lg-156 {\n    margin-bottom: 77.5rem !important;\n  }\n\n  .mb-lg-157 {\n    margin-bottom: 78rem !important;\n  }\n\n  .mb-lg-158 {\n    margin-bottom: 78.5rem !important;\n  }\n\n  .mb-lg-159 {\n    margin-bottom: 79rem !important;\n  }\n\n  .mb-lg-160 {\n    margin-bottom: 79.5rem !important;\n  }\n\n  .ms-lg-0 {\n    margin-left: 0rem !important;\n  }\n\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-lg-5 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-lg-6 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-lg-7 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-lg-8 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-lg-9 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-lg-10 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-lg-11 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-lg-12 {\n    margin-left: 5.5rem !important;\n  }\n\n  .ms-lg-13 {\n    margin-left: 6rem !important;\n  }\n\n  .ms-lg-14 {\n    margin-left: 6.5rem !important;\n  }\n\n  .ms-lg-15 {\n    margin-left: 7rem !important;\n  }\n\n  .ms-lg-16 {\n    margin-left: 7.5rem !important;\n  }\n\n  .ms-lg-17 {\n    margin-left: 8rem !important;\n  }\n\n  .ms-lg-18 {\n    margin-left: 8.5rem !important;\n  }\n\n  .ms-lg-19 {\n    margin-left: 9rem !important;\n  }\n\n  .ms-lg-20 {\n    margin-left: 9.5rem !important;\n  }\n\n  .ms-lg-21 {\n    margin-left: 10rem !important;\n  }\n\n  .ms-lg-22 {\n    margin-left: 10.5rem !important;\n  }\n\n  .ms-lg-23 {\n    margin-left: 11rem !important;\n  }\n\n  .ms-lg-24 {\n    margin-left: 11.5rem !important;\n  }\n\n  .ms-lg-25 {\n    margin-left: 12rem !important;\n  }\n\n  .ms-lg-26 {\n    margin-left: 12.5rem !important;\n  }\n\n  .ms-lg-27 {\n    margin-left: 13rem !important;\n  }\n\n  .ms-lg-28 {\n    margin-left: 13.5rem !important;\n  }\n\n  .ms-lg-29 {\n    margin-left: 14rem !important;\n  }\n\n  .ms-lg-30 {\n    margin-left: 14.5rem !important;\n  }\n\n  .ms-lg-31 {\n    margin-left: 15rem !important;\n  }\n\n  .ms-lg-32 {\n    margin-left: 15.5rem !important;\n  }\n\n  .ms-lg-33 {\n    margin-left: 16rem !important;\n  }\n\n  .ms-lg-34 {\n    margin-left: 16.5rem !important;\n  }\n\n  .ms-lg-35 {\n    margin-left: 17rem !important;\n  }\n\n  .ms-lg-36 {\n    margin-left: 17.5rem !important;\n  }\n\n  .ms-lg-37 {\n    margin-left: 18rem !important;\n  }\n\n  .ms-lg-38 {\n    margin-left: 18.5rem !important;\n  }\n\n  .ms-lg-39 {\n    margin-left: 19rem !important;\n  }\n\n  .ms-lg-40 {\n    margin-left: 19.5rem !important;\n  }\n\n  .ms-lg-41 {\n    margin-left: 20rem !important;\n  }\n\n  .ms-lg-42 {\n    margin-left: 20.5rem !important;\n  }\n\n  .ms-lg-43 {\n    margin-left: 21rem !important;\n  }\n\n  .ms-lg-44 {\n    margin-left: 21.5rem !important;\n  }\n\n  .ms-lg-45 {\n    margin-left: 22rem !important;\n  }\n\n  .ms-lg-46 {\n    margin-left: 22.5rem !important;\n  }\n\n  .ms-lg-47 {\n    margin-left: 23rem !important;\n  }\n\n  .ms-lg-48 {\n    margin-left: 23.5rem !important;\n  }\n\n  .ms-lg-49 {\n    margin-left: 24rem !important;\n  }\n\n  .ms-lg-50 {\n    margin-left: 24.5rem !important;\n  }\n\n  .ms-lg-51 {\n    margin-left: 25rem !important;\n  }\n\n  .ms-lg-52 {\n    margin-left: 25.5rem !important;\n  }\n\n  .ms-lg-53 {\n    margin-left: 26rem !important;\n  }\n\n  .ms-lg-54 {\n    margin-left: 26.5rem !important;\n  }\n\n  .ms-lg-55 {\n    margin-left: 27rem !important;\n  }\n\n  .ms-lg-56 {\n    margin-left: 27.5rem !important;\n  }\n\n  .ms-lg-57 {\n    margin-left: 28rem !important;\n  }\n\n  .ms-lg-58 {\n    margin-left: 28.5rem !important;\n  }\n\n  .ms-lg-59 {\n    margin-left: 29rem !important;\n  }\n\n  .ms-lg-60 {\n    margin-left: 29.5rem !important;\n  }\n\n  .ms-lg-61 {\n    margin-left: 30rem !important;\n  }\n\n  .ms-lg-62 {\n    margin-left: 30.5rem !important;\n  }\n\n  .ms-lg-63 {\n    margin-left: 31rem !important;\n  }\n\n  .ms-lg-64 {\n    margin-left: 31.5rem !important;\n  }\n\n  .ms-lg-65 {\n    margin-left: 32rem !important;\n  }\n\n  .ms-lg-66 {\n    margin-left: 32.5rem !important;\n  }\n\n  .ms-lg-67 {\n    margin-left: 33rem !important;\n  }\n\n  .ms-lg-68 {\n    margin-left: 33.5rem !important;\n  }\n\n  .ms-lg-69 {\n    margin-left: 34rem !important;\n  }\n\n  .ms-lg-70 {\n    margin-left: 34.5rem !important;\n  }\n\n  .ms-lg-71 {\n    margin-left: 35rem !important;\n  }\n\n  .ms-lg-72 {\n    margin-left: 35.5rem !important;\n  }\n\n  .ms-lg-73 {\n    margin-left: 36rem !important;\n  }\n\n  .ms-lg-74 {\n    margin-left: 36.5rem !important;\n  }\n\n  .ms-lg-75 {\n    margin-left: 37rem !important;\n  }\n\n  .ms-lg-76 {\n    margin-left: 37.5rem !important;\n  }\n\n  .ms-lg-77 {\n    margin-left: 38rem !important;\n  }\n\n  .ms-lg-78 {\n    margin-left: 38.5rem !important;\n  }\n\n  .ms-lg-79 {\n    margin-left: 39rem !important;\n  }\n\n  .ms-lg-80 {\n    margin-left: 39.5rem !important;\n  }\n\n  .ms-lg-81 {\n    margin-left: 40rem !important;\n  }\n\n  .ms-lg-82 {\n    margin-left: 40.5rem !important;\n  }\n\n  .ms-lg-83 {\n    margin-left: 41rem !important;\n  }\n\n  .ms-lg-84 {\n    margin-left: 41.5rem !important;\n  }\n\n  .ms-lg-85 {\n    margin-left: 42rem !important;\n  }\n\n  .ms-lg-86 {\n    margin-left: 42.5rem !important;\n  }\n\n  .ms-lg-87 {\n    margin-left: 43rem !important;\n  }\n\n  .ms-lg-88 {\n    margin-left: 43.5rem !important;\n  }\n\n  .ms-lg-89 {\n    margin-left: 44rem !important;\n  }\n\n  .ms-lg-90 {\n    margin-left: 44.5rem !important;\n  }\n\n  .ms-lg-91 {\n    margin-left: 45rem !important;\n  }\n\n  .ms-lg-92 {\n    margin-left: 45.5rem !important;\n  }\n\n  .ms-lg-93 {\n    margin-left: 46rem !important;\n  }\n\n  .ms-lg-94 {\n    margin-left: 46.5rem !important;\n  }\n\n  .ms-lg-95 {\n    margin-left: 47rem !important;\n  }\n\n  .ms-lg-96 {\n    margin-left: 47.5rem !important;\n  }\n\n  .ms-lg-97 {\n    margin-left: 48rem !important;\n  }\n\n  .ms-lg-98 {\n    margin-left: 48.5rem !important;\n  }\n\n  .ms-lg-99 {\n    margin-left: 49rem !important;\n  }\n\n  .ms-lg-100 {\n    margin-left: 49.5rem !important;\n  }\n\n  .ms-lg-101 {\n    margin-left: 50rem !important;\n  }\n\n  .ms-lg-102 {\n    margin-left: 50.5rem !important;\n  }\n\n  .ms-lg-103 {\n    margin-left: 51rem !important;\n  }\n\n  .ms-lg-104 {\n    margin-left: 51.5rem !important;\n  }\n\n  .ms-lg-105 {\n    margin-left: 52rem !important;\n  }\n\n  .ms-lg-106 {\n    margin-left: 52.5rem !important;\n  }\n\n  .ms-lg-107 {\n    margin-left: 53rem !important;\n  }\n\n  .ms-lg-108 {\n    margin-left: 53.5rem !important;\n  }\n\n  .ms-lg-109 {\n    margin-left: 54rem !important;\n  }\n\n  .ms-lg-110 {\n    margin-left: 54.5rem !important;\n  }\n\n  .ms-lg-111 {\n    margin-left: 55rem !important;\n  }\n\n  .ms-lg-112 {\n    margin-left: 55.5rem !important;\n  }\n\n  .ms-lg-113 {\n    margin-left: 56rem !important;\n  }\n\n  .ms-lg-114 {\n    margin-left: 56.5rem !important;\n  }\n\n  .ms-lg-115 {\n    margin-left: 57rem !important;\n  }\n\n  .ms-lg-116 {\n    margin-left: 57.5rem !important;\n  }\n\n  .ms-lg-117 {\n    margin-left: 58rem !important;\n  }\n\n  .ms-lg-118 {\n    margin-left: 58.5rem !important;\n  }\n\n  .ms-lg-119 {\n    margin-left: 59rem !important;\n  }\n\n  .ms-lg-120 {\n    margin-left: 59.5rem !important;\n  }\n\n  .ms-lg-121 {\n    margin-left: 60rem !important;\n  }\n\n  .ms-lg-122 {\n    margin-left: 60.5rem !important;\n  }\n\n  .ms-lg-123 {\n    margin-left: 61rem !important;\n  }\n\n  .ms-lg-124 {\n    margin-left: 61.5rem !important;\n  }\n\n  .ms-lg-125 {\n    margin-left: 62rem !important;\n  }\n\n  .ms-lg-126 {\n    margin-left: 62.5rem !important;\n  }\n\n  .ms-lg-127 {\n    margin-left: 63rem !important;\n  }\n\n  .ms-lg-128 {\n    margin-left: 63.5rem !important;\n  }\n\n  .ms-lg-129 {\n    margin-left: 64rem !important;\n  }\n\n  .ms-lg-130 {\n    margin-left: 64.5rem !important;\n  }\n\n  .ms-lg-131 {\n    margin-left: 65rem !important;\n  }\n\n  .ms-lg-132 {\n    margin-left: 65.5rem !important;\n  }\n\n  .ms-lg-133 {\n    margin-left: 66rem !important;\n  }\n\n  .ms-lg-134 {\n    margin-left: 66.5rem !important;\n  }\n\n  .ms-lg-135 {\n    margin-left: 67rem !important;\n  }\n\n  .ms-lg-136 {\n    margin-left: 67.5rem !important;\n  }\n\n  .ms-lg-137 {\n    margin-left: 68rem !important;\n  }\n\n  .ms-lg-138 {\n    margin-left: 68.5rem !important;\n  }\n\n  .ms-lg-139 {\n    margin-left: 69rem !important;\n  }\n\n  .ms-lg-140 {\n    margin-left: 69.5rem !important;\n  }\n\n  .ms-lg-141 {\n    margin-left: 70rem !important;\n  }\n\n  .ms-lg-142 {\n    margin-left: 70.5rem !important;\n  }\n\n  .ms-lg-143 {\n    margin-left: 71rem !important;\n  }\n\n  .ms-lg-144 {\n    margin-left: 71.5rem !important;\n  }\n\n  .ms-lg-145 {\n    margin-left: 72rem !important;\n  }\n\n  .ms-lg-146 {\n    margin-left: 72.5rem !important;\n  }\n\n  .ms-lg-147 {\n    margin-left: 73rem !important;\n  }\n\n  .ms-lg-148 {\n    margin-left: 73.5rem !important;\n  }\n\n  .ms-lg-149 {\n    margin-left: 74rem !important;\n  }\n\n  .ms-lg-150 {\n    margin-left: 74.5rem !important;\n  }\n\n  .ms-lg-151 {\n    margin-left: 75rem !important;\n  }\n\n  .ms-lg-152 {\n    margin-left: 75.5rem !important;\n  }\n\n  .ms-lg-153 {\n    margin-left: 76rem !important;\n  }\n\n  .ms-lg-154 {\n    margin-left: 76.5rem !important;\n  }\n\n  .ms-lg-155 {\n    margin-left: 77rem !important;\n  }\n\n  .ms-lg-156 {\n    margin-left: 77.5rem !important;\n  }\n\n  .ms-lg-157 {\n    margin-left: 78rem !important;\n  }\n\n  .ms-lg-158 {\n    margin-left: 78.5rem !important;\n  }\n\n  .ms-lg-159 {\n    margin-left: 79rem !important;\n  }\n\n  .ms-lg-160 {\n    margin-left: 79.5rem !important;\n  }\n\n  .me-lg-0 {\n    margin-right: 0rem !important;\n  }\n\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-lg-5 {\n    margin-right: 2rem !important;\n  }\n\n  .me-lg-6 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-lg-7 {\n    margin-right: 3rem !important;\n  }\n\n  .me-lg-8 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-lg-9 {\n    margin-right: 4rem !important;\n  }\n\n  .me-lg-10 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-lg-11 {\n    margin-right: 5rem !important;\n  }\n\n  .me-lg-12 {\n    margin-right: 5.5rem !important;\n  }\n\n  .me-lg-13 {\n    margin-right: 6rem !important;\n  }\n\n  .me-lg-14 {\n    margin-right: 6.5rem !important;\n  }\n\n  .me-lg-15 {\n    margin-right: 7rem !important;\n  }\n\n  .me-lg-16 {\n    margin-right: 7.5rem !important;\n  }\n\n  .me-lg-17 {\n    margin-right: 8rem !important;\n  }\n\n  .me-lg-18 {\n    margin-right: 8.5rem !important;\n  }\n\n  .me-lg-19 {\n    margin-right: 9rem !important;\n  }\n\n  .me-lg-20 {\n    margin-right: 9.5rem !important;\n  }\n\n  .me-lg-21 {\n    margin-right: 10rem !important;\n  }\n\n  .me-lg-22 {\n    margin-right: 10.5rem !important;\n  }\n\n  .me-lg-23 {\n    margin-right: 11rem !important;\n  }\n\n  .me-lg-24 {\n    margin-right: 11.5rem !important;\n  }\n\n  .me-lg-25 {\n    margin-right: 12rem !important;\n  }\n\n  .me-lg-26 {\n    margin-right: 12.5rem !important;\n  }\n\n  .me-lg-27 {\n    margin-right: 13rem !important;\n  }\n\n  .me-lg-28 {\n    margin-right: 13.5rem !important;\n  }\n\n  .me-lg-29 {\n    margin-right: 14rem !important;\n  }\n\n  .me-lg-30 {\n    margin-right: 14.5rem !important;\n  }\n\n  .me-lg-31 {\n    margin-right: 15rem !important;\n  }\n\n  .me-lg-32 {\n    margin-right: 15.5rem !important;\n  }\n\n  .me-lg-33 {\n    margin-right: 16rem !important;\n  }\n\n  .me-lg-34 {\n    margin-right: 16.5rem !important;\n  }\n\n  .me-lg-35 {\n    margin-right: 17rem !important;\n  }\n\n  .me-lg-36 {\n    margin-right: 17.5rem !important;\n  }\n\n  .me-lg-37 {\n    margin-right: 18rem !important;\n  }\n\n  .me-lg-38 {\n    margin-right: 18.5rem !important;\n  }\n\n  .me-lg-39 {\n    margin-right: 19rem !important;\n  }\n\n  .me-lg-40 {\n    margin-right: 19.5rem !important;\n  }\n\n  .me-lg-41 {\n    margin-right: 20rem !important;\n  }\n\n  .me-lg-42 {\n    margin-right: 20.5rem !important;\n  }\n\n  .me-lg-43 {\n    margin-right: 21rem !important;\n  }\n\n  .me-lg-44 {\n    margin-right: 21.5rem !important;\n  }\n\n  .me-lg-45 {\n    margin-right: 22rem !important;\n  }\n\n  .me-lg-46 {\n    margin-right: 22.5rem !important;\n  }\n\n  .me-lg-47 {\n    margin-right: 23rem !important;\n  }\n\n  .me-lg-48 {\n    margin-right: 23.5rem !important;\n  }\n\n  .me-lg-49 {\n    margin-right: 24rem !important;\n  }\n\n  .me-lg-50 {\n    margin-right: 24.5rem !important;\n  }\n\n  .me-lg-51 {\n    margin-right: 25rem !important;\n  }\n\n  .me-lg-52 {\n    margin-right: 25.5rem !important;\n  }\n\n  .me-lg-53 {\n    margin-right: 26rem !important;\n  }\n\n  .me-lg-54 {\n    margin-right: 26.5rem !important;\n  }\n\n  .me-lg-55 {\n    margin-right: 27rem !important;\n  }\n\n  .me-lg-56 {\n    margin-right: 27.5rem !important;\n  }\n\n  .me-lg-57 {\n    margin-right: 28rem !important;\n  }\n\n  .me-lg-58 {\n    margin-right: 28.5rem !important;\n  }\n\n  .me-lg-59 {\n    margin-right: 29rem !important;\n  }\n\n  .me-lg-60 {\n    margin-right: 29.5rem !important;\n  }\n\n  .me-lg-61 {\n    margin-right: 30rem !important;\n  }\n\n  .me-lg-62 {\n    margin-right: 30.5rem !important;\n  }\n\n  .me-lg-63 {\n    margin-right: 31rem !important;\n  }\n\n  .me-lg-64 {\n    margin-right: 31.5rem !important;\n  }\n\n  .me-lg-65 {\n    margin-right: 32rem !important;\n  }\n\n  .me-lg-66 {\n    margin-right: 32.5rem !important;\n  }\n\n  .me-lg-67 {\n    margin-right: 33rem !important;\n  }\n\n  .me-lg-68 {\n    margin-right: 33.5rem !important;\n  }\n\n  .me-lg-69 {\n    margin-right: 34rem !important;\n  }\n\n  .me-lg-70 {\n    margin-right: 34.5rem !important;\n  }\n\n  .me-lg-71 {\n    margin-right: 35rem !important;\n  }\n\n  .me-lg-72 {\n    margin-right: 35.5rem !important;\n  }\n\n  .me-lg-73 {\n    margin-right: 36rem !important;\n  }\n\n  .me-lg-74 {\n    margin-right: 36.5rem !important;\n  }\n\n  .me-lg-75 {\n    margin-right: 37rem !important;\n  }\n\n  .me-lg-76 {\n    margin-right: 37.5rem !important;\n  }\n\n  .me-lg-77 {\n    margin-right: 38rem !important;\n  }\n\n  .me-lg-78 {\n    margin-right: 38.5rem !important;\n  }\n\n  .me-lg-79 {\n    margin-right: 39rem !important;\n  }\n\n  .me-lg-80 {\n    margin-right: 39.5rem !important;\n  }\n\n  .me-lg-81 {\n    margin-right: 40rem !important;\n  }\n\n  .me-lg-82 {\n    margin-right: 40.5rem !important;\n  }\n\n  .me-lg-83 {\n    margin-right: 41rem !important;\n  }\n\n  .me-lg-84 {\n    margin-right: 41.5rem !important;\n  }\n\n  .me-lg-85 {\n    margin-right: 42rem !important;\n  }\n\n  .me-lg-86 {\n    margin-right: 42.5rem !important;\n  }\n\n  .me-lg-87 {\n    margin-right: 43rem !important;\n  }\n\n  .me-lg-88 {\n    margin-right: 43.5rem !important;\n  }\n\n  .me-lg-89 {\n    margin-right: 44rem !important;\n  }\n\n  .me-lg-90 {\n    margin-right: 44.5rem !important;\n  }\n\n  .me-lg-91 {\n    margin-right: 45rem !important;\n  }\n\n  .me-lg-92 {\n    margin-right: 45.5rem !important;\n  }\n\n  .me-lg-93 {\n    margin-right: 46rem !important;\n  }\n\n  .me-lg-94 {\n    margin-right: 46.5rem !important;\n  }\n\n  .me-lg-95 {\n    margin-right: 47rem !important;\n  }\n\n  .me-lg-96 {\n    margin-right: 47.5rem !important;\n  }\n\n  .me-lg-97 {\n    margin-right: 48rem !important;\n  }\n\n  .me-lg-98 {\n    margin-right: 48.5rem !important;\n  }\n\n  .me-lg-99 {\n    margin-right: 49rem !important;\n  }\n\n  .me-lg-100 {\n    margin-right: 49.5rem !important;\n  }\n\n  .me-lg-101 {\n    margin-right: 50rem !important;\n  }\n\n  .me-lg-102 {\n    margin-right: 50.5rem !important;\n  }\n\n  .me-lg-103 {\n    margin-right: 51rem !important;\n  }\n\n  .me-lg-104 {\n    margin-right: 51.5rem !important;\n  }\n\n  .me-lg-105 {\n    margin-right: 52rem !important;\n  }\n\n  .me-lg-106 {\n    margin-right: 52.5rem !important;\n  }\n\n  .me-lg-107 {\n    margin-right: 53rem !important;\n  }\n\n  .me-lg-108 {\n    margin-right: 53.5rem !important;\n  }\n\n  .me-lg-109 {\n    margin-right: 54rem !important;\n  }\n\n  .me-lg-110 {\n    margin-right: 54.5rem !important;\n  }\n\n  .me-lg-111 {\n    margin-right: 55rem !important;\n  }\n\n  .me-lg-112 {\n    margin-right: 55.5rem !important;\n  }\n\n  .me-lg-113 {\n    margin-right: 56rem !important;\n  }\n\n  .me-lg-114 {\n    margin-right: 56.5rem !important;\n  }\n\n  .me-lg-115 {\n    margin-right: 57rem !important;\n  }\n\n  .me-lg-116 {\n    margin-right: 57.5rem !important;\n  }\n\n  .me-lg-117 {\n    margin-right: 58rem !important;\n  }\n\n  .me-lg-118 {\n    margin-right: 58.5rem !important;\n  }\n\n  .me-lg-119 {\n    margin-right: 59rem !important;\n  }\n\n  .me-lg-120 {\n    margin-right: 59.5rem !important;\n  }\n\n  .me-lg-121 {\n    margin-right: 60rem !important;\n  }\n\n  .me-lg-122 {\n    margin-right: 60.5rem !important;\n  }\n\n  .me-lg-123 {\n    margin-right: 61rem !important;\n  }\n\n  .me-lg-124 {\n    margin-right: 61.5rem !important;\n  }\n\n  .me-lg-125 {\n    margin-right: 62rem !important;\n  }\n\n  .me-lg-126 {\n    margin-right: 62.5rem !important;\n  }\n\n  .me-lg-127 {\n    margin-right: 63rem !important;\n  }\n\n  .me-lg-128 {\n    margin-right: 63.5rem !important;\n  }\n\n  .me-lg-129 {\n    margin-right: 64rem !important;\n  }\n\n  .me-lg-130 {\n    margin-right: 64.5rem !important;\n  }\n\n  .me-lg-131 {\n    margin-right: 65rem !important;\n  }\n\n  .me-lg-132 {\n    margin-right: 65.5rem !important;\n  }\n\n  .me-lg-133 {\n    margin-right: 66rem !important;\n  }\n\n  .me-lg-134 {\n    margin-right: 66.5rem !important;\n  }\n\n  .me-lg-135 {\n    margin-right: 67rem !important;\n  }\n\n  .me-lg-136 {\n    margin-right: 67.5rem !important;\n  }\n\n  .me-lg-137 {\n    margin-right: 68rem !important;\n  }\n\n  .me-lg-138 {\n    margin-right: 68.5rem !important;\n  }\n\n  .me-lg-139 {\n    margin-right: 69rem !important;\n  }\n\n  .me-lg-140 {\n    margin-right: 69.5rem !important;\n  }\n\n  .me-lg-141 {\n    margin-right: 70rem !important;\n  }\n\n  .me-lg-142 {\n    margin-right: 70.5rem !important;\n  }\n\n  .me-lg-143 {\n    margin-right: 71rem !important;\n  }\n\n  .me-lg-144 {\n    margin-right: 71.5rem !important;\n  }\n\n  .me-lg-145 {\n    margin-right: 72rem !important;\n  }\n\n  .me-lg-146 {\n    margin-right: 72.5rem !important;\n  }\n\n  .me-lg-147 {\n    margin-right: 73rem !important;\n  }\n\n  .me-lg-148 {\n    margin-right: 73.5rem !important;\n  }\n\n  .me-lg-149 {\n    margin-right: 74rem !important;\n  }\n\n  .me-lg-150 {\n    margin-right: 74.5rem !important;\n  }\n\n  .me-lg-151 {\n    margin-right: 75rem !important;\n  }\n\n  .me-lg-152 {\n    margin-right: 75.5rem !important;\n  }\n\n  .me-lg-153 {\n    margin-right: 76rem !important;\n  }\n\n  .me-lg-154 {\n    margin-right: 76.5rem !important;\n  }\n\n  .me-lg-155 {\n    margin-right: 77rem !important;\n  }\n\n  .me-lg-156 {\n    margin-right: 77.5rem !important;\n  }\n\n  .me-lg-157 {\n    margin-right: 78rem !important;\n  }\n\n  .me-lg-158 {\n    margin-right: 78.5rem !important;\n  }\n\n  .me-lg-159 {\n    margin-right: 79rem !important;\n  }\n\n  .me-lg-160 {\n    margin-right: 79.5rem !important;\n  }\n\n  .mx-lg-0 {\n    margin-left: 0rem !important;\n    margin-right: 0rem !important;\n  }\n\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n    margin-right: 1rem !important;\n  }\n\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .mx-lg-5 {\n    margin-left: 2rem !important;\n    margin-right: 2rem !important;\n  }\n\n  .mx-lg-6 {\n    margin-left: 2.5rem !important;\n    margin-right: 2.5rem !important;\n  }\n\n  .mx-lg-7 {\n    margin-left: 3rem !important;\n    margin-right: 3rem !important;\n  }\n\n  .mx-lg-8 {\n    margin-left: 3.5rem !important;\n    margin-right: 3.5rem !important;\n  }\n\n  .mx-lg-9 {\n    margin-left: 4rem !important;\n    margin-right: 4rem !important;\n  }\n\n  .mx-lg-10 {\n    margin-left: 4.5rem !important;\n    margin-right: 4.5rem !important;\n  }\n\n  .mx-lg-11 {\n    margin-left: 5rem !important;\n    margin-right: 5rem !important;\n  }\n\n  .mx-lg-12 {\n    margin-left: 5.5rem !important;\n    margin-right: 5.5rem !important;\n  }\n\n  .mx-lg-13 {\n    margin-left: 6rem !important;\n    margin-right: 6rem !important;\n  }\n\n  .mx-lg-14 {\n    margin-left: 6.5rem !important;\n    margin-right: 6.5rem !important;\n  }\n\n  .mx-lg-15 {\n    margin-left: 7rem !important;\n    margin-right: 7rem !important;\n  }\n\n  .mx-lg-16 {\n    margin-left: 7.5rem !important;\n    margin-right: 7.5rem !important;\n  }\n\n  .mx-lg-17 {\n    margin-left: 8rem !important;\n    margin-right: 8rem !important;\n  }\n\n  .mx-lg-18 {\n    margin-left: 8.5rem !important;\n    margin-right: 8.5rem !important;\n  }\n\n  .mx-lg-19 {\n    margin-left: 9rem !important;\n    margin-right: 9rem !important;\n  }\n\n  .mx-lg-20 {\n    margin-left: 9.5rem !important;\n    margin-right: 9.5rem !important;\n  }\n\n  .mx-lg-21 {\n    margin-left: 10rem !important;\n    margin-right: 10rem !important;\n  }\n\n  .mx-lg-22 {\n    margin-left: 10.5rem !important;\n    margin-right: 10.5rem !important;\n  }\n\n  .mx-lg-23 {\n    margin-left: 11rem !important;\n    margin-right: 11rem !important;\n  }\n\n  .mx-lg-24 {\n    margin-left: 11.5rem !important;\n    margin-right: 11.5rem !important;\n  }\n\n  .mx-lg-25 {\n    margin-left: 12rem !important;\n    margin-right: 12rem !important;\n  }\n\n  .mx-lg-26 {\n    margin-left: 12.5rem !important;\n    margin-right: 12.5rem !important;\n  }\n\n  .mx-lg-27 {\n    margin-left: 13rem !important;\n    margin-right: 13rem !important;\n  }\n\n  .mx-lg-28 {\n    margin-left: 13.5rem !important;\n    margin-right: 13.5rem !important;\n  }\n\n  .mx-lg-29 {\n    margin-left: 14rem !important;\n    margin-right: 14rem !important;\n  }\n\n  .mx-lg-30 {\n    margin-left: 14.5rem !important;\n    margin-right: 14.5rem !important;\n  }\n\n  .mx-lg-31 {\n    margin-left: 15rem !important;\n    margin-right: 15rem !important;\n  }\n\n  .mx-lg-32 {\n    margin-left: 15.5rem !important;\n    margin-right: 15.5rem !important;\n  }\n\n  .mx-lg-33 {\n    margin-left: 16rem !important;\n    margin-right: 16rem !important;\n  }\n\n  .mx-lg-34 {\n    margin-left: 16.5rem !important;\n    margin-right: 16.5rem !important;\n  }\n\n  .mx-lg-35 {\n    margin-left: 17rem !important;\n    margin-right: 17rem !important;\n  }\n\n  .mx-lg-36 {\n    margin-left: 17.5rem !important;\n    margin-right: 17.5rem !important;\n  }\n\n  .mx-lg-37 {\n    margin-left: 18rem !important;\n    margin-right: 18rem !important;\n  }\n\n  .mx-lg-38 {\n    margin-left: 18.5rem !important;\n    margin-right: 18.5rem !important;\n  }\n\n  .mx-lg-39 {\n    margin-left: 19rem !important;\n    margin-right: 19rem !important;\n  }\n\n  .mx-lg-40 {\n    margin-left: 19.5rem !important;\n    margin-right: 19.5rem !important;\n  }\n\n  .mx-lg-41 {\n    margin-left: 20rem !important;\n    margin-right: 20rem !important;\n  }\n\n  .mx-lg-42 {\n    margin-left: 20.5rem !important;\n    margin-right: 20.5rem !important;\n  }\n\n  .mx-lg-43 {\n    margin-left: 21rem !important;\n    margin-right: 21rem !important;\n  }\n\n  .mx-lg-44 {\n    margin-left: 21.5rem !important;\n    margin-right: 21.5rem !important;\n  }\n\n  .mx-lg-45 {\n    margin-left: 22rem !important;\n    margin-right: 22rem !important;\n  }\n\n  .mx-lg-46 {\n    margin-left: 22.5rem !important;\n    margin-right: 22.5rem !important;\n  }\n\n  .mx-lg-47 {\n    margin-left: 23rem !important;\n    margin-right: 23rem !important;\n  }\n\n  .mx-lg-48 {\n    margin-left: 23.5rem !important;\n    margin-right: 23.5rem !important;\n  }\n\n  .mx-lg-49 {\n    margin-left: 24rem !important;\n    margin-right: 24rem !important;\n  }\n\n  .mx-lg-50 {\n    margin-left: 24.5rem !important;\n    margin-right: 24.5rem !important;\n  }\n\n  .mx-lg-51 {\n    margin-left: 25rem !important;\n    margin-right: 25rem !important;\n  }\n\n  .mx-lg-52 {\n    margin-left: 25.5rem !important;\n    margin-right: 25.5rem !important;\n  }\n\n  .mx-lg-53 {\n    margin-left: 26rem !important;\n    margin-right: 26rem !important;\n  }\n\n  .mx-lg-54 {\n    margin-left: 26.5rem !important;\n    margin-right: 26.5rem !important;\n  }\n\n  .mx-lg-55 {\n    margin-left: 27rem !important;\n    margin-right: 27rem !important;\n  }\n\n  .mx-lg-56 {\n    margin-left: 27.5rem !important;\n    margin-right: 27.5rem !important;\n  }\n\n  .mx-lg-57 {\n    margin-left: 28rem !important;\n    margin-right: 28rem !important;\n  }\n\n  .mx-lg-58 {\n    margin-left: 28.5rem !important;\n    margin-right: 28.5rem !important;\n  }\n\n  .mx-lg-59 {\n    margin-left: 29rem !important;\n    margin-right: 29rem !important;\n  }\n\n  .mx-lg-60 {\n    margin-left: 29.5rem !important;\n    margin-right: 29.5rem !important;\n  }\n\n  .mx-lg-61 {\n    margin-left: 30rem !important;\n    margin-right: 30rem !important;\n  }\n\n  .mx-lg-62 {\n    margin-left: 30.5rem !important;\n    margin-right: 30.5rem !important;\n  }\n\n  .mx-lg-63 {\n    margin-left: 31rem !important;\n    margin-right: 31rem !important;\n  }\n\n  .mx-lg-64 {\n    margin-left: 31.5rem !important;\n    margin-right: 31.5rem !important;\n  }\n\n  .mx-lg-65 {\n    margin-left: 32rem !important;\n    margin-right: 32rem !important;\n  }\n\n  .mx-lg-66 {\n    margin-left: 32.5rem !important;\n    margin-right: 32.5rem !important;\n  }\n\n  .mx-lg-67 {\n    margin-left: 33rem !important;\n    margin-right: 33rem !important;\n  }\n\n  .mx-lg-68 {\n    margin-left: 33.5rem !important;\n    margin-right: 33.5rem !important;\n  }\n\n  .mx-lg-69 {\n    margin-left: 34rem !important;\n    margin-right: 34rem !important;\n  }\n\n  .mx-lg-70 {\n    margin-left: 34.5rem !important;\n    margin-right: 34.5rem !important;\n  }\n\n  .mx-lg-71 {\n    margin-left: 35rem !important;\n    margin-right: 35rem !important;\n  }\n\n  .mx-lg-72 {\n    margin-left: 35.5rem !important;\n    margin-right: 35.5rem !important;\n  }\n\n  .mx-lg-73 {\n    margin-left: 36rem !important;\n    margin-right: 36rem !important;\n  }\n\n  .mx-lg-74 {\n    margin-left: 36.5rem !important;\n    margin-right: 36.5rem !important;\n  }\n\n  .mx-lg-75 {\n    margin-left: 37rem !important;\n    margin-right: 37rem !important;\n  }\n\n  .mx-lg-76 {\n    margin-left: 37.5rem !important;\n    margin-right: 37.5rem !important;\n  }\n\n  .mx-lg-77 {\n    margin-left: 38rem !important;\n    margin-right: 38rem !important;\n  }\n\n  .mx-lg-78 {\n    margin-left: 38.5rem !important;\n    margin-right: 38.5rem !important;\n  }\n\n  .mx-lg-79 {\n    margin-left: 39rem !important;\n    margin-right: 39rem !important;\n  }\n\n  .mx-lg-80 {\n    margin-left: 39.5rem !important;\n    margin-right: 39.5rem !important;\n  }\n\n  .mx-lg-81 {\n    margin-left: 40rem !important;\n    margin-right: 40rem !important;\n  }\n\n  .mx-lg-82 {\n    margin-left: 40.5rem !important;\n    margin-right: 40.5rem !important;\n  }\n\n  .mx-lg-83 {\n    margin-left: 41rem !important;\n    margin-right: 41rem !important;\n  }\n\n  .mx-lg-84 {\n    margin-left: 41.5rem !important;\n    margin-right: 41.5rem !important;\n  }\n\n  .mx-lg-85 {\n    margin-left: 42rem !important;\n    margin-right: 42rem !important;\n  }\n\n  .mx-lg-86 {\n    margin-left: 42.5rem !important;\n    margin-right: 42.5rem !important;\n  }\n\n  .mx-lg-87 {\n    margin-left: 43rem !important;\n    margin-right: 43rem !important;\n  }\n\n  .mx-lg-88 {\n    margin-left: 43.5rem !important;\n    margin-right: 43.5rem !important;\n  }\n\n  .mx-lg-89 {\n    margin-left: 44rem !important;\n    margin-right: 44rem !important;\n  }\n\n  .mx-lg-90 {\n    margin-left: 44.5rem !important;\n    margin-right: 44.5rem !important;\n  }\n\n  .mx-lg-91 {\n    margin-left: 45rem !important;\n    margin-right: 45rem !important;\n  }\n\n  .mx-lg-92 {\n    margin-left: 45.5rem !important;\n    margin-right: 45.5rem !important;\n  }\n\n  .mx-lg-93 {\n    margin-left: 46rem !important;\n    margin-right: 46rem !important;\n  }\n\n  .mx-lg-94 {\n    margin-left: 46.5rem !important;\n    margin-right: 46.5rem !important;\n  }\n\n  .mx-lg-95 {\n    margin-left: 47rem !important;\n    margin-right: 47rem !important;\n  }\n\n  .mx-lg-96 {\n    margin-left: 47.5rem !important;\n    margin-right: 47.5rem !important;\n  }\n\n  .mx-lg-97 {\n    margin-left: 48rem !important;\n    margin-right: 48rem !important;\n  }\n\n  .mx-lg-98 {\n    margin-left: 48.5rem !important;\n    margin-right: 48.5rem !important;\n  }\n\n  .mx-lg-99 {\n    margin-left: 49rem !important;\n    margin-right: 49rem !important;\n  }\n\n  .mx-lg-100 {\n    margin-left: 49.5rem !important;\n    margin-right: 49.5rem !important;\n  }\n\n  .mx-lg-101 {\n    margin-left: 50rem !important;\n    margin-right: 50rem !important;\n  }\n\n  .mx-lg-102 {\n    margin-left: 50.5rem !important;\n    margin-right: 50.5rem !important;\n  }\n\n  .mx-lg-103 {\n    margin-left: 51rem !important;\n    margin-right: 51rem !important;\n  }\n\n  .mx-lg-104 {\n    margin-left: 51.5rem !important;\n    margin-right: 51.5rem !important;\n  }\n\n  .mx-lg-105 {\n    margin-left: 52rem !important;\n    margin-right: 52rem !important;\n  }\n\n  .mx-lg-106 {\n    margin-left: 52.5rem !important;\n    margin-right: 52.5rem !important;\n  }\n\n  .mx-lg-107 {\n    margin-left: 53rem !important;\n    margin-right: 53rem !important;\n  }\n\n  .mx-lg-108 {\n    margin-left: 53.5rem !important;\n    margin-right: 53.5rem !important;\n  }\n\n  .mx-lg-109 {\n    margin-left: 54rem !important;\n    margin-right: 54rem !important;\n  }\n\n  .mx-lg-110 {\n    margin-left: 54.5rem !important;\n    margin-right: 54.5rem !important;\n  }\n\n  .mx-lg-111 {\n    margin-left: 55rem !important;\n    margin-right: 55rem !important;\n  }\n\n  .mx-lg-112 {\n    margin-left: 55.5rem !important;\n    margin-right: 55.5rem !important;\n  }\n\n  .mx-lg-113 {\n    margin-left: 56rem !important;\n    margin-right: 56rem !important;\n  }\n\n  .mx-lg-114 {\n    margin-left: 56.5rem !important;\n    margin-right: 56.5rem !important;\n  }\n\n  .mx-lg-115 {\n    margin-left: 57rem !important;\n    margin-right: 57rem !important;\n  }\n\n  .mx-lg-116 {\n    margin-left: 57.5rem !important;\n    margin-right: 57.5rem !important;\n  }\n\n  .mx-lg-117 {\n    margin-left: 58rem !important;\n    margin-right: 58rem !important;\n  }\n\n  .mx-lg-118 {\n    margin-left: 58.5rem !important;\n    margin-right: 58.5rem !important;\n  }\n\n  .mx-lg-119 {\n    margin-left: 59rem !important;\n    margin-right: 59rem !important;\n  }\n\n  .mx-lg-120 {\n    margin-left: 59.5rem !important;\n    margin-right: 59.5rem !important;\n  }\n\n  .mx-lg-121 {\n    margin-left: 60rem !important;\n    margin-right: 60rem !important;\n  }\n\n  .mx-lg-122 {\n    margin-left: 60.5rem !important;\n    margin-right: 60.5rem !important;\n  }\n\n  .mx-lg-123 {\n    margin-left: 61rem !important;\n    margin-right: 61rem !important;\n  }\n\n  .mx-lg-124 {\n    margin-left: 61.5rem !important;\n    margin-right: 61.5rem !important;\n  }\n\n  .mx-lg-125 {\n    margin-left: 62rem !important;\n    margin-right: 62rem !important;\n  }\n\n  .mx-lg-126 {\n    margin-left: 62.5rem !important;\n    margin-right: 62.5rem !important;\n  }\n\n  .mx-lg-127 {\n    margin-left: 63rem !important;\n    margin-right: 63rem !important;\n  }\n\n  .mx-lg-128 {\n    margin-left: 63.5rem !important;\n    margin-right: 63.5rem !important;\n  }\n\n  .mx-lg-129 {\n    margin-left: 64rem !important;\n    margin-right: 64rem !important;\n  }\n\n  .mx-lg-130 {\n    margin-left: 64.5rem !important;\n    margin-right: 64.5rem !important;\n  }\n\n  .mx-lg-131 {\n    margin-left: 65rem !important;\n    margin-right: 65rem !important;\n  }\n\n  .mx-lg-132 {\n    margin-left: 65.5rem !important;\n    margin-right: 65.5rem !important;\n  }\n\n  .mx-lg-133 {\n    margin-left: 66rem !important;\n    margin-right: 66rem !important;\n  }\n\n  .mx-lg-134 {\n    margin-left: 66.5rem !important;\n    margin-right: 66.5rem !important;\n  }\n\n  .mx-lg-135 {\n    margin-left: 67rem !important;\n    margin-right: 67rem !important;\n  }\n\n  .mx-lg-136 {\n    margin-left: 67.5rem !important;\n    margin-right: 67.5rem !important;\n  }\n\n  .mx-lg-137 {\n    margin-left: 68rem !important;\n    margin-right: 68rem !important;\n  }\n\n  .mx-lg-138 {\n    margin-left: 68.5rem !important;\n    margin-right: 68.5rem !important;\n  }\n\n  .mx-lg-139 {\n    margin-left: 69rem !important;\n    margin-right: 69rem !important;\n  }\n\n  .mx-lg-140 {\n    margin-left: 69.5rem !important;\n    margin-right: 69.5rem !important;\n  }\n\n  .mx-lg-141 {\n    margin-left: 70rem !important;\n    margin-right: 70rem !important;\n  }\n\n  .mx-lg-142 {\n    margin-left: 70.5rem !important;\n    margin-right: 70.5rem !important;\n  }\n\n  .mx-lg-143 {\n    margin-left: 71rem !important;\n    margin-right: 71rem !important;\n  }\n\n  .mx-lg-144 {\n    margin-left: 71.5rem !important;\n    margin-right: 71.5rem !important;\n  }\n\n  .mx-lg-145 {\n    margin-left: 72rem !important;\n    margin-right: 72rem !important;\n  }\n\n  .mx-lg-146 {\n    margin-left: 72.5rem !important;\n    margin-right: 72.5rem !important;\n  }\n\n  .mx-lg-147 {\n    margin-left: 73rem !important;\n    margin-right: 73rem !important;\n  }\n\n  .mx-lg-148 {\n    margin-left: 73.5rem !important;\n    margin-right: 73.5rem !important;\n  }\n\n  .mx-lg-149 {\n    margin-left: 74rem !important;\n    margin-right: 74rem !important;\n  }\n\n  .mx-lg-150 {\n    margin-left: 74.5rem !important;\n    margin-right: 74.5rem !important;\n  }\n\n  .mx-lg-151 {\n    margin-left: 75rem !important;\n    margin-right: 75rem !important;\n  }\n\n  .mx-lg-152 {\n    margin-left: 75.5rem !important;\n    margin-right: 75.5rem !important;\n  }\n\n  .mx-lg-153 {\n    margin-left: 76rem !important;\n    margin-right: 76rem !important;\n  }\n\n  .mx-lg-154 {\n    margin-left: 76.5rem !important;\n    margin-right: 76.5rem !important;\n  }\n\n  .mx-lg-155 {\n    margin-left: 77rem !important;\n    margin-right: 77rem !important;\n  }\n\n  .mx-lg-156 {\n    margin-left: 77.5rem !important;\n    margin-right: 77.5rem !important;\n  }\n\n  .mx-lg-157 {\n    margin-left: 78rem !important;\n    margin-right: 78rem !important;\n  }\n\n  .mx-lg-158 {\n    margin-left: 78.5rem !important;\n    margin-right: 78.5rem !important;\n  }\n\n  .mx-lg-159 {\n    margin-left: 79rem !important;\n    margin-right: 79rem !important;\n  }\n\n  .mx-lg-160 {\n    margin-left: 79.5rem !important;\n    margin-right: 79.5rem !important;\n  }\n\n  .my-lg-0 {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem !important;\n  }\n\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-lg-5 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-lg-6 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-lg-7 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-lg-8 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-lg-9 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-lg-10 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-lg-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-lg-12 {\n    margin-top: 5.5rem !important;\n    margin-bottom: 5.5rem !important;\n  }\n\n  .my-lg-13 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n\n  .my-lg-14 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n\n  .my-lg-15 {\n    margin-top: 7rem !important;\n    margin-bottom: 7rem !important;\n  }\n\n  .my-lg-16 {\n    margin-top: 7.5rem !important;\n    margin-bottom: 7.5rem !important;\n  }\n\n  .my-lg-17 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n\n  .my-lg-18 {\n    margin-top: 8.5rem !important;\n    margin-bottom: 8.5rem !important;\n  }\n\n  .my-lg-19 {\n    margin-top: 9rem !important;\n    margin-bottom: 9rem !important;\n  }\n\n  .my-lg-20 {\n    margin-top: 9.5rem !important;\n    margin-bottom: 9.5rem !important;\n  }\n\n  .my-lg-21 {\n    margin-top: 10rem !important;\n    margin-bottom: 10rem !important;\n  }\n\n  .my-lg-22 {\n    margin-top: 10.5rem !important;\n    margin-bottom: 10.5rem !important;\n  }\n\n  .my-lg-23 {\n    margin-top: 11rem !important;\n    margin-bottom: 11rem !important;\n  }\n\n  .my-lg-24 {\n    margin-top: 11.5rem !important;\n    margin-bottom: 11.5rem !important;\n  }\n\n  .my-lg-25 {\n    margin-top: 12rem !important;\n    margin-bottom: 12rem !important;\n  }\n\n  .my-lg-26 {\n    margin-top: 12.5rem !important;\n    margin-bottom: 12.5rem !important;\n  }\n\n  .my-lg-27 {\n    margin-top: 13rem !important;\n    margin-bottom: 13rem !important;\n  }\n\n  .my-lg-28 {\n    margin-top: 13.5rem !important;\n    margin-bottom: 13.5rem !important;\n  }\n\n  .my-lg-29 {\n    margin-top: 14rem !important;\n    margin-bottom: 14rem !important;\n  }\n\n  .my-lg-30 {\n    margin-top: 14.5rem !important;\n    margin-bottom: 14.5rem !important;\n  }\n\n  .my-lg-31 {\n    margin-top: 15rem !important;\n    margin-bottom: 15rem !important;\n  }\n\n  .my-lg-32 {\n    margin-top: 15.5rem !important;\n    margin-bottom: 15.5rem !important;\n  }\n\n  .my-lg-33 {\n    margin-top: 16rem !important;\n    margin-bottom: 16rem !important;\n  }\n\n  .my-lg-34 {\n    margin-top: 16.5rem !important;\n    margin-bottom: 16.5rem !important;\n  }\n\n  .my-lg-35 {\n    margin-top: 17rem !important;\n    margin-bottom: 17rem !important;\n  }\n\n  .my-lg-36 {\n    margin-top: 17.5rem !important;\n    margin-bottom: 17.5rem !important;\n  }\n\n  .my-lg-37 {\n    margin-top: 18rem !important;\n    margin-bottom: 18rem !important;\n  }\n\n  .my-lg-38 {\n    margin-top: 18.5rem !important;\n    margin-bottom: 18.5rem !important;\n  }\n\n  .my-lg-39 {\n    margin-top: 19rem !important;\n    margin-bottom: 19rem !important;\n  }\n\n  .my-lg-40 {\n    margin-top: 19.5rem !important;\n    margin-bottom: 19.5rem !important;\n  }\n\n  .my-lg-41 {\n    margin-top: 20rem !important;\n    margin-bottom: 20rem !important;\n  }\n\n  .my-lg-42 {\n    margin-top: 20.5rem !important;\n    margin-bottom: 20.5rem !important;\n  }\n\n  .my-lg-43 {\n    margin-top: 21rem !important;\n    margin-bottom: 21rem !important;\n  }\n\n  .my-lg-44 {\n    margin-top: 21.5rem !important;\n    margin-bottom: 21.5rem !important;\n  }\n\n  .my-lg-45 {\n    margin-top: 22rem !important;\n    margin-bottom: 22rem !important;\n  }\n\n  .my-lg-46 {\n    margin-top: 22.5rem !important;\n    margin-bottom: 22.5rem !important;\n  }\n\n  .my-lg-47 {\n    margin-top: 23rem !important;\n    margin-bottom: 23rem !important;\n  }\n\n  .my-lg-48 {\n    margin-top: 23.5rem !important;\n    margin-bottom: 23.5rem !important;\n  }\n\n  .my-lg-49 {\n    margin-top: 24rem !important;\n    margin-bottom: 24rem !important;\n  }\n\n  .my-lg-50 {\n    margin-top: 24.5rem !important;\n    margin-bottom: 24.5rem !important;\n  }\n\n  .my-lg-51 {\n    margin-top: 25rem !important;\n    margin-bottom: 25rem !important;\n  }\n\n  .my-lg-52 {\n    margin-top: 25.5rem !important;\n    margin-bottom: 25.5rem !important;\n  }\n\n  .my-lg-53 {\n    margin-top: 26rem !important;\n    margin-bottom: 26rem !important;\n  }\n\n  .my-lg-54 {\n    margin-top: 26.5rem !important;\n    margin-bottom: 26.5rem !important;\n  }\n\n  .my-lg-55 {\n    margin-top: 27rem !important;\n    margin-bottom: 27rem !important;\n  }\n\n  .my-lg-56 {\n    margin-top: 27.5rem !important;\n    margin-bottom: 27.5rem !important;\n  }\n\n  .my-lg-57 {\n    margin-top: 28rem !important;\n    margin-bottom: 28rem !important;\n  }\n\n  .my-lg-58 {\n    margin-top: 28.5rem !important;\n    margin-bottom: 28.5rem !important;\n  }\n\n  .my-lg-59 {\n    margin-top: 29rem !important;\n    margin-bottom: 29rem !important;\n  }\n\n  .my-lg-60 {\n    margin-top: 29.5rem !important;\n    margin-bottom: 29.5rem !important;\n  }\n\n  .my-lg-61 {\n    margin-top: 30rem !important;\n    margin-bottom: 30rem !important;\n  }\n\n  .my-lg-62 {\n    margin-top: 30.5rem !important;\n    margin-bottom: 30.5rem !important;\n  }\n\n  .my-lg-63 {\n    margin-top: 31rem !important;\n    margin-bottom: 31rem !important;\n  }\n\n  .my-lg-64 {\n    margin-top: 31.5rem !important;\n    margin-bottom: 31.5rem !important;\n  }\n\n  .my-lg-65 {\n    margin-top: 32rem !important;\n    margin-bottom: 32rem !important;\n  }\n\n  .my-lg-66 {\n    margin-top: 32.5rem !important;\n    margin-bottom: 32.5rem !important;\n  }\n\n  .my-lg-67 {\n    margin-top: 33rem !important;\n    margin-bottom: 33rem !important;\n  }\n\n  .my-lg-68 {\n    margin-top: 33.5rem !important;\n    margin-bottom: 33.5rem !important;\n  }\n\n  .my-lg-69 {\n    margin-top: 34rem !important;\n    margin-bottom: 34rem !important;\n  }\n\n  .my-lg-70 {\n    margin-top: 34.5rem !important;\n    margin-bottom: 34.5rem !important;\n  }\n\n  .my-lg-71 {\n    margin-top: 35rem !important;\n    margin-bottom: 35rem !important;\n  }\n\n  .my-lg-72 {\n    margin-top: 35.5rem !important;\n    margin-bottom: 35.5rem !important;\n  }\n\n  .my-lg-73 {\n    margin-top: 36rem !important;\n    margin-bottom: 36rem !important;\n  }\n\n  .my-lg-74 {\n    margin-top: 36.5rem !important;\n    margin-bottom: 36.5rem !important;\n  }\n\n  .my-lg-75 {\n    margin-top: 37rem !important;\n    margin-bottom: 37rem !important;\n  }\n\n  .my-lg-76 {\n    margin-top: 37.5rem !important;\n    margin-bottom: 37.5rem !important;\n  }\n\n  .my-lg-77 {\n    margin-top: 38rem !important;\n    margin-bottom: 38rem !important;\n  }\n\n  .my-lg-78 {\n    margin-top: 38.5rem !important;\n    margin-bottom: 38.5rem !important;\n  }\n\n  .my-lg-79 {\n    margin-top: 39rem !important;\n    margin-bottom: 39rem !important;\n  }\n\n  .my-lg-80 {\n    margin-top: 39.5rem !important;\n    margin-bottom: 39.5rem !important;\n  }\n\n  .my-lg-81 {\n    margin-top: 40rem !important;\n    margin-bottom: 40rem !important;\n  }\n\n  .my-lg-82 {\n    margin-top: 40.5rem !important;\n    margin-bottom: 40.5rem !important;\n  }\n\n  .my-lg-83 {\n    margin-top: 41rem !important;\n    margin-bottom: 41rem !important;\n  }\n\n  .my-lg-84 {\n    margin-top: 41.5rem !important;\n    margin-bottom: 41.5rem !important;\n  }\n\n  .my-lg-85 {\n    margin-top: 42rem !important;\n    margin-bottom: 42rem !important;\n  }\n\n  .my-lg-86 {\n    margin-top: 42.5rem !important;\n    margin-bottom: 42.5rem !important;\n  }\n\n  .my-lg-87 {\n    margin-top: 43rem !important;\n    margin-bottom: 43rem !important;\n  }\n\n  .my-lg-88 {\n    margin-top: 43.5rem !important;\n    margin-bottom: 43.5rem !important;\n  }\n\n  .my-lg-89 {\n    margin-top: 44rem !important;\n    margin-bottom: 44rem !important;\n  }\n\n  .my-lg-90 {\n    margin-top: 44.5rem !important;\n    margin-bottom: 44.5rem !important;\n  }\n\n  .my-lg-91 {\n    margin-top: 45rem !important;\n    margin-bottom: 45rem !important;\n  }\n\n  .my-lg-92 {\n    margin-top: 45.5rem !important;\n    margin-bottom: 45.5rem !important;\n  }\n\n  .my-lg-93 {\n    margin-top: 46rem !important;\n    margin-bottom: 46rem !important;\n  }\n\n  .my-lg-94 {\n    margin-top: 46.5rem !important;\n    margin-bottom: 46.5rem !important;\n  }\n\n  .my-lg-95 {\n    margin-top: 47rem !important;\n    margin-bottom: 47rem !important;\n  }\n\n  .my-lg-96 {\n    margin-top: 47.5rem !important;\n    margin-bottom: 47.5rem !important;\n  }\n\n  .my-lg-97 {\n    margin-top: 48rem !important;\n    margin-bottom: 48rem !important;\n  }\n\n  .my-lg-98 {\n    margin-top: 48.5rem !important;\n    margin-bottom: 48.5rem !important;\n  }\n\n  .my-lg-99 {\n    margin-top: 49rem !important;\n    margin-bottom: 49rem !important;\n  }\n\n  .my-lg-100 {\n    margin-top: 49.5rem !important;\n    margin-bottom: 49.5rem !important;\n  }\n\n  .my-lg-101 {\n    margin-top: 50rem !important;\n    margin-bottom: 50rem !important;\n  }\n\n  .my-lg-102 {\n    margin-top: 50.5rem !important;\n    margin-bottom: 50.5rem !important;\n  }\n\n  .my-lg-103 {\n    margin-top: 51rem !important;\n    margin-bottom: 51rem !important;\n  }\n\n  .my-lg-104 {\n    margin-top: 51.5rem !important;\n    margin-bottom: 51.5rem !important;\n  }\n\n  .my-lg-105 {\n    margin-top: 52rem !important;\n    margin-bottom: 52rem !important;\n  }\n\n  .my-lg-106 {\n    margin-top: 52.5rem !important;\n    margin-bottom: 52.5rem !important;\n  }\n\n  .my-lg-107 {\n    margin-top: 53rem !important;\n    margin-bottom: 53rem !important;\n  }\n\n  .my-lg-108 {\n    margin-top: 53.5rem !important;\n    margin-bottom: 53.5rem !important;\n  }\n\n  .my-lg-109 {\n    margin-top: 54rem !important;\n    margin-bottom: 54rem !important;\n  }\n\n  .my-lg-110 {\n    margin-top: 54.5rem !important;\n    margin-bottom: 54.5rem !important;\n  }\n\n  .my-lg-111 {\n    margin-top: 55rem !important;\n    margin-bottom: 55rem !important;\n  }\n\n  .my-lg-112 {\n    margin-top: 55.5rem !important;\n    margin-bottom: 55.5rem !important;\n  }\n\n  .my-lg-113 {\n    margin-top: 56rem !important;\n    margin-bottom: 56rem !important;\n  }\n\n  .my-lg-114 {\n    margin-top: 56.5rem !important;\n    margin-bottom: 56.5rem !important;\n  }\n\n  .my-lg-115 {\n    margin-top: 57rem !important;\n    margin-bottom: 57rem !important;\n  }\n\n  .my-lg-116 {\n    margin-top: 57.5rem !important;\n    margin-bottom: 57.5rem !important;\n  }\n\n  .my-lg-117 {\n    margin-top: 58rem !important;\n    margin-bottom: 58rem !important;\n  }\n\n  .my-lg-118 {\n    margin-top: 58.5rem !important;\n    margin-bottom: 58.5rem !important;\n  }\n\n  .my-lg-119 {\n    margin-top: 59rem !important;\n    margin-bottom: 59rem !important;\n  }\n\n  .my-lg-120 {\n    margin-top: 59.5rem !important;\n    margin-bottom: 59.5rem !important;\n  }\n\n  .my-lg-121 {\n    margin-top: 60rem !important;\n    margin-bottom: 60rem !important;\n  }\n\n  .my-lg-122 {\n    margin-top: 60.5rem !important;\n    margin-bottom: 60.5rem !important;\n  }\n\n  .my-lg-123 {\n    margin-top: 61rem !important;\n    margin-bottom: 61rem !important;\n  }\n\n  .my-lg-124 {\n    margin-top: 61.5rem !important;\n    margin-bottom: 61.5rem !important;\n  }\n\n  .my-lg-125 {\n    margin-top: 62rem !important;\n    margin-bottom: 62rem !important;\n  }\n\n  .my-lg-126 {\n    margin-top: 62.5rem !important;\n    margin-bottom: 62.5rem !important;\n  }\n\n  .my-lg-127 {\n    margin-top: 63rem !important;\n    margin-bottom: 63rem !important;\n  }\n\n  .my-lg-128 {\n    margin-top: 63.5rem !important;\n    margin-bottom: 63.5rem !important;\n  }\n\n  .my-lg-129 {\n    margin-top: 64rem !important;\n    margin-bottom: 64rem !important;\n  }\n\n  .my-lg-130 {\n    margin-top: 64.5rem !important;\n    margin-bottom: 64.5rem !important;\n  }\n\n  .my-lg-131 {\n    margin-top: 65rem !important;\n    margin-bottom: 65rem !important;\n  }\n\n  .my-lg-132 {\n    margin-top: 65.5rem !important;\n    margin-bottom: 65.5rem !important;\n  }\n\n  .my-lg-133 {\n    margin-top: 66rem !important;\n    margin-bottom: 66rem !important;\n  }\n\n  .my-lg-134 {\n    margin-top: 66.5rem !important;\n    margin-bottom: 66.5rem !important;\n  }\n\n  .my-lg-135 {\n    margin-top: 67rem !important;\n    margin-bottom: 67rem !important;\n  }\n\n  .my-lg-136 {\n    margin-top: 67.5rem !important;\n    margin-bottom: 67.5rem !important;\n  }\n\n  .my-lg-137 {\n    margin-top: 68rem !important;\n    margin-bottom: 68rem !important;\n  }\n\n  .my-lg-138 {\n    margin-top: 68.5rem !important;\n    margin-bottom: 68.5rem !important;\n  }\n\n  .my-lg-139 {\n    margin-top: 69rem !important;\n    margin-bottom: 69rem !important;\n  }\n\n  .my-lg-140 {\n    margin-top: 69.5rem !important;\n    margin-bottom: 69.5rem !important;\n  }\n\n  .my-lg-141 {\n    margin-top: 70rem !important;\n    margin-bottom: 70rem !important;\n  }\n\n  .my-lg-142 {\n    margin-top: 70.5rem !important;\n    margin-bottom: 70.5rem !important;\n  }\n\n  .my-lg-143 {\n    margin-top: 71rem !important;\n    margin-bottom: 71rem !important;\n  }\n\n  .my-lg-144 {\n    margin-top: 71.5rem !important;\n    margin-bottom: 71.5rem !important;\n  }\n\n  .my-lg-145 {\n    margin-top: 72rem !important;\n    margin-bottom: 72rem !important;\n  }\n\n  .my-lg-146 {\n    margin-top: 72.5rem !important;\n    margin-bottom: 72.5rem !important;\n  }\n\n  .my-lg-147 {\n    margin-top: 73rem !important;\n    margin-bottom: 73rem !important;\n  }\n\n  .my-lg-148 {\n    margin-top: 73.5rem !important;\n    margin-bottom: 73.5rem !important;\n  }\n\n  .my-lg-149 {\n    margin-top: 74rem !important;\n    margin-bottom: 74rem !important;\n  }\n\n  .my-lg-150 {\n    margin-top: 74.5rem !important;\n    margin-bottom: 74.5rem !important;\n  }\n\n  .my-lg-151 {\n    margin-top: 75rem !important;\n    margin-bottom: 75rem !important;\n  }\n\n  .my-lg-152 {\n    margin-top: 75.5rem !important;\n    margin-bottom: 75.5rem !important;\n  }\n\n  .my-lg-153 {\n    margin-top: 76rem !important;\n    margin-bottom: 76rem !important;\n  }\n\n  .my-lg-154 {\n    margin-top: 76.5rem !important;\n    margin-bottom: 76.5rem !important;\n  }\n\n  .my-lg-155 {\n    margin-top: 77rem !important;\n    margin-bottom: 77rem !important;\n  }\n\n  .my-lg-156 {\n    margin-top: 77.5rem !important;\n    margin-bottom: 77.5rem !important;\n  }\n\n  .my-lg-157 {\n    margin-top: 78rem !important;\n    margin-bottom: 78rem !important;\n  }\n\n  .my-lg-158 {\n    margin-top: 78.5rem !important;\n    margin-bottom: 78.5rem !important;\n  }\n\n  .my-lg-159 {\n    margin-top: 79rem !important;\n    margin-bottom: 79rem !important;\n  }\n\n  .my-lg-160 {\n    margin-top: 79.5rem !important;\n    margin-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0rem !important;\n  }\n\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xl-5 {\n    margin: 2rem !important;\n  }\n\n  .m-xl-6 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xl-7 {\n    margin: 3rem !important;\n  }\n\n  .m-xl-8 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xl-9 {\n    margin: 4rem !important;\n  }\n\n  .m-xl-10 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xl-11 {\n    margin: 5rem !important;\n  }\n\n  .m-xl-12 {\n    margin: 5.5rem !important;\n  }\n\n  .m-xl-13 {\n    margin: 6rem !important;\n  }\n\n  .m-xl-14 {\n    margin: 6.5rem !important;\n  }\n\n  .m-xl-15 {\n    margin: 7rem !important;\n  }\n\n  .m-xl-16 {\n    margin: 7.5rem !important;\n  }\n\n  .m-xl-17 {\n    margin: 8rem !important;\n  }\n\n  .m-xl-18 {\n    margin: 8.5rem !important;\n  }\n\n  .m-xl-19 {\n    margin: 9rem !important;\n  }\n\n  .m-xl-20 {\n    margin: 9.5rem !important;\n  }\n\n  .m-xl-21 {\n    margin: 10rem !important;\n  }\n\n  .m-xl-22 {\n    margin: 10.5rem !important;\n  }\n\n  .m-xl-23 {\n    margin: 11rem !important;\n  }\n\n  .m-xl-24 {\n    margin: 11.5rem !important;\n  }\n\n  .m-xl-25 {\n    margin: 12rem !important;\n  }\n\n  .m-xl-26 {\n    margin: 12.5rem !important;\n  }\n\n  .m-xl-27 {\n    margin: 13rem !important;\n  }\n\n  .m-xl-28 {\n    margin: 13.5rem !important;\n  }\n\n  .m-xl-29 {\n    margin: 14rem !important;\n  }\n\n  .m-xl-30 {\n    margin: 14.5rem !important;\n  }\n\n  .m-xl-31 {\n    margin: 15rem !important;\n  }\n\n  .m-xl-32 {\n    margin: 15.5rem !important;\n  }\n\n  .m-xl-33 {\n    margin: 16rem !important;\n  }\n\n  .m-xl-34 {\n    margin: 16.5rem !important;\n  }\n\n  .m-xl-35 {\n    margin: 17rem !important;\n  }\n\n  .m-xl-36 {\n    margin: 17.5rem !important;\n  }\n\n  .m-xl-37 {\n    margin: 18rem !important;\n  }\n\n  .m-xl-38 {\n    margin: 18.5rem !important;\n  }\n\n  .m-xl-39 {\n    margin: 19rem !important;\n  }\n\n  .m-xl-40 {\n    margin: 19.5rem !important;\n  }\n\n  .m-xl-41 {\n    margin: 20rem !important;\n  }\n\n  .m-xl-42 {\n    margin: 20.5rem !important;\n  }\n\n  .m-xl-43 {\n    margin: 21rem !important;\n  }\n\n  .m-xl-44 {\n    margin: 21.5rem !important;\n  }\n\n  .m-xl-45 {\n    margin: 22rem !important;\n  }\n\n  .m-xl-46 {\n    margin: 22.5rem !important;\n  }\n\n  .m-xl-47 {\n    margin: 23rem !important;\n  }\n\n  .m-xl-48 {\n    margin: 23.5rem !important;\n  }\n\n  .m-xl-49 {\n    margin: 24rem !important;\n  }\n\n  .m-xl-50 {\n    margin: 24.5rem !important;\n  }\n\n  .m-xl-51 {\n    margin: 25rem !important;\n  }\n\n  .m-xl-52 {\n    margin: 25.5rem !important;\n  }\n\n  .m-xl-53 {\n    margin: 26rem !important;\n  }\n\n  .m-xl-54 {\n    margin: 26.5rem !important;\n  }\n\n  .m-xl-55 {\n    margin: 27rem !important;\n  }\n\n  .m-xl-56 {\n    margin: 27.5rem !important;\n  }\n\n  .m-xl-57 {\n    margin: 28rem !important;\n  }\n\n  .m-xl-58 {\n    margin: 28.5rem !important;\n  }\n\n  .m-xl-59 {\n    margin: 29rem !important;\n  }\n\n  .m-xl-60 {\n    margin: 29.5rem !important;\n  }\n\n  .m-xl-61 {\n    margin: 30rem !important;\n  }\n\n  .m-xl-62 {\n    margin: 30.5rem !important;\n  }\n\n  .m-xl-63 {\n    margin: 31rem !important;\n  }\n\n  .m-xl-64 {\n    margin: 31.5rem !important;\n  }\n\n  .m-xl-65 {\n    margin: 32rem !important;\n  }\n\n  .m-xl-66 {\n    margin: 32.5rem !important;\n  }\n\n  .m-xl-67 {\n    margin: 33rem !important;\n  }\n\n  .m-xl-68 {\n    margin: 33.5rem !important;\n  }\n\n  .m-xl-69 {\n    margin: 34rem !important;\n  }\n\n  .m-xl-70 {\n    margin: 34.5rem !important;\n  }\n\n  .m-xl-71 {\n    margin: 35rem !important;\n  }\n\n  .m-xl-72 {\n    margin: 35.5rem !important;\n  }\n\n  .m-xl-73 {\n    margin: 36rem !important;\n  }\n\n  .m-xl-74 {\n    margin: 36.5rem !important;\n  }\n\n  .m-xl-75 {\n    margin: 37rem !important;\n  }\n\n  .m-xl-76 {\n    margin: 37.5rem !important;\n  }\n\n  .m-xl-77 {\n    margin: 38rem !important;\n  }\n\n  .m-xl-78 {\n    margin: 38.5rem !important;\n  }\n\n  .m-xl-79 {\n    margin: 39rem !important;\n  }\n\n  .m-xl-80 {\n    margin: 39.5rem !important;\n  }\n\n  .m-xl-81 {\n    margin: 40rem !important;\n  }\n\n  .m-xl-82 {\n    margin: 40.5rem !important;\n  }\n\n  .m-xl-83 {\n    margin: 41rem !important;\n  }\n\n  .m-xl-84 {\n    margin: 41.5rem !important;\n  }\n\n  .m-xl-85 {\n    margin: 42rem !important;\n  }\n\n  .m-xl-86 {\n    margin: 42.5rem !important;\n  }\n\n  .m-xl-87 {\n    margin: 43rem !important;\n  }\n\n  .m-xl-88 {\n    margin: 43.5rem !important;\n  }\n\n  .m-xl-89 {\n    margin: 44rem !important;\n  }\n\n  .m-xl-90 {\n    margin: 44.5rem !important;\n  }\n\n  .m-xl-91 {\n    margin: 45rem !important;\n  }\n\n  .m-xl-92 {\n    margin: 45.5rem !important;\n  }\n\n  .m-xl-93 {\n    margin: 46rem !important;\n  }\n\n  .m-xl-94 {\n    margin: 46.5rem !important;\n  }\n\n  .m-xl-95 {\n    margin: 47rem !important;\n  }\n\n  .m-xl-96 {\n    margin: 47.5rem !important;\n  }\n\n  .m-xl-97 {\n    margin: 48rem !important;\n  }\n\n  .m-xl-98 {\n    margin: 48.5rem !important;\n  }\n\n  .m-xl-99 {\n    margin: 49rem !important;\n  }\n\n  .m-xl-100 {\n    margin: 49.5rem !important;\n  }\n\n  .m-xl-101 {\n    margin: 50rem !important;\n  }\n\n  .m-xl-102 {\n    margin: 50.5rem !important;\n  }\n\n  .m-xl-103 {\n    margin: 51rem !important;\n  }\n\n  .m-xl-104 {\n    margin: 51.5rem !important;\n  }\n\n  .m-xl-105 {\n    margin: 52rem !important;\n  }\n\n  .m-xl-106 {\n    margin: 52.5rem !important;\n  }\n\n  .m-xl-107 {\n    margin: 53rem !important;\n  }\n\n  .m-xl-108 {\n    margin: 53.5rem !important;\n  }\n\n  .m-xl-109 {\n    margin: 54rem !important;\n  }\n\n  .m-xl-110 {\n    margin: 54.5rem !important;\n  }\n\n  .m-xl-111 {\n    margin: 55rem !important;\n  }\n\n  .m-xl-112 {\n    margin: 55.5rem !important;\n  }\n\n  .m-xl-113 {\n    margin: 56rem !important;\n  }\n\n  .m-xl-114 {\n    margin: 56.5rem !important;\n  }\n\n  .m-xl-115 {\n    margin: 57rem !important;\n  }\n\n  .m-xl-116 {\n    margin: 57.5rem !important;\n  }\n\n  .m-xl-117 {\n    margin: 58rem !important;\n  }\n\n  .m-xl-118 {\n    margin: 58.5rem !important;\n  }\n\n  .m-xl-119 {\n    margin: 59rem !important;\n  }\n\n  .m-xl-120 {\n    margin: 59.5rem !important;\n  }\n\n  .m-xl-121 {\n    margin: 60rem !important;\n  }\n\n  .m-xl-122 {\n    margin: 60.5rem !important;\n  }\n\n  .m-xl-123 {\n    margin: 61rem !important;\n  }\n\n  .m-xl-124 {\n    margin: 61.5rem !important;\n  }\n\n  .m-xl-125 {\n    margin: 62rem !important;\n  }\n\n  .m-xl-126 {\n    margin: 62.5rem !important;\n  }\n\n  .m-xl-127 {\n    margin: 63rem !important;\n  }\n\n  .m-xl-128 {\n    margin: 63.5rem !important;\n  }\n\n  .m-xl-129 {\n    margin: 64rem !important;\n  }\n\n  .m-xl-130 {\n    margin: 64.5rem !important;\n  }\n\n  .m-xl-131 {\n    margin: 65rem !important;\n  }\n\n  .m-xl-132 {\n    margin: 65.5rem !important;\n  }\n\n  .m-xl-133 {\n    margin: 66rem !important;\n  }\n\n  .m-xl-134 {\n    margin: 66.5rem !important;\n  }\n\n  .m-xl-135 {\n    margin: 67rem !important;\n  }\n\n  .m-xl-136 {\n    margin: 67.5rem !important;\n  }\n\n  .m-xl-137 {\n    margin: 68rem !important;\n  }\n\n  .m-xl-138 {\n    margin: 68.5rem !important;\n  }\n\n  .m-xl-139 {\n    margin: 69rem !important;\n  }\n\n  .m-xl-140 {\n    margin: 69.5rem !important;\n  }\n\n  .m-xl-141 {\n    margin: 70rem !important;\n  }\n\n  .m-xl-142 {\n    margin: 70.5rem !important;\n  }\n\n  .m-xl-143 {\n    margin: 71rem !important;\n  }\n\n  .m-xl-144 {\n    margin: 71.5rem !important;\n  }\n\n  .m-xl-145 {\n    margin: 72rem !important;\n  }\n\n  .m-xl-146 {\n    margin: 72.5rem !important;\n  }\n\n  .m-xl-147 {\n    margin: 73rem !important;\n  }\n\n  .m-xl-148 {\n    margin: 73.5rem !important;\n  }\n\n  .m-xl-149 {\n    margin: 74rem !important;\n  }\n\n  .m-xl-150 {\n    margin: 74.5rem !important;\n  }\n\n  .m-xl-151 {\n    margin: 75rem !important;\n  }\n\n  .m-xl-152 {\n    margin: 75.5rem !important;\n  }\n\n  .m-xl-153 {\n    margin: 76rem !important;\n  }\n\n  .m-xl-154 {\n    margin: 76.5rem !important;\n  }\n\n  .m-xl-155 {\n    margin: 77rem !important;\n  }\n\n  .m-xl-156 {\n    margin: 77.5rem !important;\n  }\n\n  .m-xl-157 {\n    margin: 78rem !important;\n  }\n\n  .m-xl-158 {\n    margin: 78.5rem !important;\n  }\n\n  .m-xl-159 {\n    margin: 79rem !important;\n  }\n\n  .m-xl-160 {\n    margin: 79.5rem !important;\n  }\n\n  .mt-xl-0 {\n    margin-top: 0rem !important;\n  }\n\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xl-5 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xl-6 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xl-7 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xl-8 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xl-9 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xl-10 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xl-11 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xl-12 {\n    margin-top: 5.5rem !important;\n  }\n\n  .mt-xl-13 {\n    margin-top: 6rem !important;\n  }\n\n  .mt-xl-14 {\n    margin-top: 6.5rem !important;\n  }\n\n  .mt-xl-15 {\n    margin-top: 7rem !important;\n  }\n\n  .mt-xl-16 {\n    margin-top: 7.5rem !important;\n  }\n\n  .mt-xl-17 {\n    margin-top: 8rem !important;\n  }\n\n  .mt-xl-18 {\n    margin-top: 8.5rem !important;\n  }\n\n  .mt-xl-19 {\n    margin-top: 9rem !important;\n  }\n\n  .mt-xl-20 {\n    margin-top: 9.5rem !important;\n  }\n\n  .mt-xl-21 {\n    margin-top: 10rem !important;\n  }\n\n  .mt-xl-22 {\n    margin-top: 10.5rem !important;\n  }\n\n  .mt-xl-23 {\n    margin-top: 11rem !important;\n  }\n\n  .mt-xl-24 {\n    margin-top: 11.5rem !important;\n  }\n\n  .mt-xl-25 {\n    margin-top: 12rem !important;\n  }\n\n  .mt-xl-26 {\n    margin-top: 12.5rem !important;\n  }\n\n  .mt-xl-27 {\n    margin-top: 13rem !important;\n  }\n\n  .mt-xl-28 {\n    margin-top: 13.5rem !important;\n  }\n\n  .mt-xl-29 {\n    margin-top: 14rem !important;\n  }\n\n  .mt-xl-30 {\n    margin-top: 14.5rem !important;\n  }\n\n  .mt-xl-31 {\n    margin-top: 15rem !important;\n  }\n\n  .mt-xl-32 {\n    margin-top: 15.5rem !important;\n  }\n\n  .mt-xl-33 {\n    margin-top: 16rem !important;\n  }\n\n  .mt-xl-34 {\n    margin-top: 16.5rem !important;\n  }\n\n  .mt-xl-35 {\n    margin-top: 17rem !important;\n  }\n\n  .mt-xl-36 {\n    margin-top: 17.5rem !important;\n  }\n\n  .mt-xl-37 {\n    margin-top: 18rem !important;\n  }\n\n  .mt-xl-38 {\n    margin-top: 18.5rem !important;\n  }\n\n  .mt-xl-39 {\n    margin-top: 19rem !important;\n  }\n\n  .mt-xl-40 {\n    margin-top: 19.5rem !important;\n  }\n\n  .mt-xl-41 {\n    margin-top: 20rem !important;\n  }\n\n  .mt-xl-42 {\n    margin-top: 20.5rem !important;\n  }\n\n  .mt-xl-43 {\n    margin-top: 21rem !important;\n  }\n\n  .mt-xl-44 {\n    margin-top: 21.5rem !important;\n  }\n\n  .mt-xl-45 {\n    margin-top: 22rem !important;\n  }\n\n  .mt-xl-46 {\n    margin-top: 22.5rem !important;\n  }\n\n  .mt-xl-47 {\n    margin-top: 23rem !important;\n  }\n\n  .mt-xl-48 {\n    margin-top: 23.5rem !important;\n  }\n\n  .mt-xl-49 {\n    margin-top: 24rem !important;\n  }\n\n  .mt-xl-50 {\n    margin-top: 24.5rem !important;\n  }\n\n  .mt-xl-51 {\n    margin-top: 25rem !important;\n  }\n\n  .mt-xl-52 {\n    margin-top: 25.5rem !important;\n  }\n\n  .mt-xl-53 {\n    margin-top: 26rem !important;\n  }\n\n  .mt-xl-54 {\n    margin-top: 26.5rem !important;\n  }\n\n  .mt-xl-55 {\n    margin-top: 27rem !important;\n  }\n\n  .mt-xl-56 {\n    margin-top: 27.5rem !important;\n  }\n\n  .mt-xl-57 {\n    margin-top: 28rem !important;\n  }\n\n  .mt-xl-58 {\n    margin-top: 28.5rem !important;\n  }\n\n  .mt-xl-59 {\n    margin-top: 29rem !important;\n  }\n\n  .mt-xl-60 {\n    margin-top: 29.5rem !important;\n  }\n\n  .mt-xl-61 {\n    margin-top: 30rem !important;\n  }\n\n  .mt-xl-62 {\n    margin-top: 30.5rem !important;\n  }\n\n  .mt-xl-63 {\n    margin-top: 31rem !important;\n  }\n\n  .mt-xl-64 {\n    margin-top: 31.5rem !important;\n  }\n\n  .mt-xl-65 {\n    margin-top: 32rem !important;\n  }\n\n  .mt-xl-66 {\n    margin-top: 32.5rem !important;\n  }\n\n  .mt-xl-67 {\n    margin-top: 33rem !important;\n  }\n\n  .mt-xl-68 {\n    margin-top: 33.5rem !important;\n  }\n\n  .mt-xl-69 {\n    margin-top: 34rem !important;\n  }\n\n  .mt-xl-70 {\n    margin-top: 34.5rem !important;\n  }\n\n  .mt-xl-71 {\n    margin-top: 35rem !important;\n  }\n\n  .mt-xl-72 {\n    margin-top: 35.5rem !important;\n  }\n\n  .mt-xl-73 {\n    margin-top: 36rem !important;\n  }\n\n  .mt-xl-74 {\n    margin-top: 36.5rem !important;\n  }\n\n  .mt-xl-75 {\n    margin-top: 37rem !important;\n  }\n\n  .mt-xl-76 {\n    margin-top: 37.5rem !important;\n  }\n\n  .mt-xl-77 {\n    margin-top: 38rem !important;\n  }\n\n  .mt-xl-78 {\n    margin-top: 38.5rem !important;\n  }\n\n  .mt-xl-79 {\n    margin-top: 39rem !important;\n  }\n\n  .mt-xl-80 {\n    margin-top: 39.5rem !important;\n  }\n\n  .mt-xl-81 {\n    margin-top: 40rem !important;\n  }\n\n  .mt-xl-82 {\n    margin-top: 40.5rem !important;\n  }\n\n  .mt-xl-83 {\n    margin-top: 41rem !important;\n  }\n\n  .mt-xl-84 {\n    margin-top: 41.5rem !important;\n  }\n\n  .mt-xl-85 {\n    margin-top: 42rem !important;\n  }\n\n  .mt-xl-86 {\n    margin-top: 42.5rem !important;\n  }\n\n  .mt-xl-87 {\n    margin-top: 43rem !important;\n  }\n\n  .mt-xl-88 {\n    margin-top: 43.5rem !important;\n  }\n\n  .mt-xl-89 {\n    margin-top: 44rem !important;\n  }\n\n  .mt-xl-90 {\n    margin-top: 44.5rem !important;\n  }\n\n  .mt-xl-91 {\n    margin-top: 45rem !important;\n  }\n\n  .mt-xl-92 {\n    margin-top: 45.5rem !important;\n  }\n\n  .mt-xl-93 {\n    margin-top: 46rem !important;\n  }\n\n  .mt-xl-94 {\n    margin-top: 46.5rem !important;\n  }\n\n  .mt-xl-95 {\n    margin-top: 47rem !important;\n  }\n\n  .mt-xl-96 {\n    margin-top: 47.5rem !important;\n  }\n\n  .mt-xl-97 {\n    margin-top: 48rem !important;\n  }\n\n  .mt-xl-98 {\n    margin-top: 48.5rem !important;\n  }\n\n  .mt-xl-99 {\n    margin-top: 49rem !important;\n  }\n\n  .mt-xl-100 {\n    margin-top: 49.5rem !important;\n  }\n\n  .mt-xl-101 {\n    margin-top: 50rem !important;\n  }\n\n  .mt-xl-102 {\n    margin-top: 50.5rem !important;\n  }\n\n  .mt-xl-103 {\n    margin-top: 51rem !important;\n  }\n\n  .mt-xl-104 {\n    margin-top: 51.5rem !important;\n  }\n\n  .mt-xl-105 {\n    margin-top: 52rem !important;\n  }\n\n  .mt-xl-106 {\n    margin-top: 52.5rem !important;\n  }\n\n  .mt-xl-107 {\n    margin-top: 53rem !important;\n  }\n\n  .mt-xl-108 {\n    margin-top: 53.5rem !important;\n  }\n\n  .mt-xl-109 {\n    margin-top: 54rem !important;\n  }\n\n  .mt-xl-110 {\n    margin-top: 54.5rem !important;\n  }\n\n  .mt-xl-111 {\n    margin-top: 55rem !important;\n  }\n\n  .mt-xl-112 {\n    margin-top: 55.5rem !important;\n  }\n\n  .mt-xl-113 {\n    margin-top: 56rem !important;\n  }\n\n  .mt-xl-114 {\n    margin-top: 56.5rem !important;\n  }\n\n  .mt-xl-115 {\n    margin-top: 57rem !important;\n  }\n\n  .mt-xl-116 {\n    margin-top: 57.5rem !important;\n  }\n\n  .mt-xl-117 {\n    margin-top: 58rem !important;\n  }\n\n  .mt-xl-118 {\n    margin-top: 58.5rem !important;\n  }\n\n  .mt-xl-119 {\n    margin-top: 59rem !important;\n  }\n\n  .mt-xl-120 {\n    margin-top: 59.5rem !important;\n  }\n\n  .mt-xl-121 {\n    margin-top: 60rem !important;\n  }\n\n  .mt-xl-122 {\n    margin-top: 60.5rem !important;\n  }\n\n  .mt-xl-123 {\n    margin-top: 61rem !important;\n  }\n\n  .mt-xl-124 {\n    margin-top: 61.5rem !important;\n  }\n\n  .mt-xl-125 {\n    margin-top: 62rem !important;\n  }\n\n  .mt-xl-126 {\n    margin-top: 62.5rem !important;\n  }\n\n  .mt-xl-127 {\n    margin-top: 63rem !important;\n  }\n\n  .mt-xl-128 {\n    margin-top: 63.5rem !important;\n  }\n\n  .mt-xl-129 {\n    margin-top: 64rem !important;\n  }\n\n  .mt-xl-130 {\n    margin-top: 64.5rem !important;\n  }\n\n  .mt-xl-131 {\n    margin-top: 65rem !important;\n  }\n\n  .mt-xl-132 {\n    margin-top: 65.5rem !important;\n  }\n\n  .mt-xl-133 {\n    margin-top: 66rem !important;\n  }\n\n  .mt-xl-134 {\n    margin-top: 66.5rem !important;\n  }\n\n  .mt-xl-135 {\n    margin-top: 67rem !important;\n  }\n\n  .mt-xl-136 {\n    margin-top: 67.5rem !important;\n  }\n\n  .mt-xl-137 {\n    margin-top: 68rem !important;\n  }\n\n  .mt-xl-138 {\n    margin-top: 68.5rem !important;\n  }\n\n  .mt-xl-139 {\n    margin-top: 69rem !important;\n  }\n\n  .mt-xl-140 {\n    margin-top: 69.5rem !important;\n  }\n\n  .mt-xl-141 {\n    margin-top: 70rem !important;\n  }\n\n  .mt-xl-142 {\n    margin-top: 70.5rem !important;\n  }\n\n  .mt-xl-143 {\n    margin-top: 71rem !important;\n  }\n\n  .mt-xl-144 {\n    margin-top: 71.5rem !important;\n  }\n\n  .mt-xl-145 {\n    margin-top: 72rem !important;\n  }\n\n  .mt-xl-146 {\n    margin-top: 72.5rem !important;\n  }\n\n  .mt-xl-147 {\n    margin-top: 73rem !important;\n  }\n\n  .mt-xl-148 {\n    margin-top: 73.5rem !important;\n  }\n\n  .mt-xl-149 {\n    margin-top: 74rem !important;\n  }\n\n  .mt-xl-150 {\n    margin-top: 74.5rem !important;\n  }\n\n  .mt-xl-151 {\n    margin-top: 75rem !important;\n  }\n\n  .mt-xl-152 {\n    margin-top: 75.5rem !important;\n  }\n\n  .mt-xl-153 {\n    margin-top: 76rem !important;\n  }\n\n  .mt-xl-154 {\n    margin-top: 76.5rem !important;\n  }\n\n  .mt-xl-155 {\n    margin-top: 77rem !important;\n  }\n\n  .mt-xl-156 {\n    margin-top: 77.5rem !important;\n  }\n\n  .mt-xl-157 {\n    margin-top: 78rem !important;\n  }\n\n  .mt-xl-158 {\n    margin-top: 78.5rem !important;\n  }\n\n  .mt-xl-159 {\n    margin-top: 79rem !important;\n  }\n\n  .mt-xl-160 {\n    margin-top: 79.5rem !important;\n  }\n\n  .mb-xl-0 {\n    margin-bottom: 0rem !important;\n  }\n\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xl-5 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xl-6 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xl-7 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xl-8 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xl-9 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xl-10 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xl-11 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xl-12 {\n    margin-bottom: 5.5rem !important;\n  }\n\n  .mb-xl-13 {\n    margin-bottom: 6rem !important;\n  }\n\n  .mb-xl-14 {\n    margin-bottom: 6.5rem !important;\n  }\n\n  .mb-xl-15 {\n    margin-bottom: 7rem !important;\n  }\n\n  .mb-xl-16 {\n    margin-bottom: 7.5rem !important;\n  }\n\n  .mb-xl-17 {\n    margin-bottom: 8rem !important;\n  }\n\n  .mb-xl-18 {\n    margin-bottom: 8.5rem !important;\n  }\n\n  .mb-xl-19 {\n    margin-bottom: 9rem !important;\n  }\n\n  .mb-xl-20 {\n    margin-bottom: 9.5rem !important;\n  }\n\n  .mb-xl-21 {\n    margin-bottom: 10rem !important;\n  }\n\n  .mb-xl-22 {\n    margin-bottom: 10.5rem !important;\n  }\n\n  .mb-xl-23 {\n    margin-bottom: 11rem !important;\n  }\n\n  .mb-xl-24 {\n    margin-bottom: 11.5rem !important;\n  }\n\n  .mb-xl-25 {\n    margin-bottom: 12rem !important;\n  }\n\n  .mb-xl-26 {\n    margin-bottom: 12.5rem !important;\n  }\n\n  .mb-xl-27 {\n    margin-bottom: 13rem !important;\n  }\n\n  .mb-xl-28 {\n    margin-bottom: 13.5rem !important;\n  }\n\n  .mb-xl-29 {\n    margin-bottom: 14rem !important;\n  }\n\n  .mb-xl-30 {\n    margin-bottom: 14.5rem !important;\n  }\n\n  .mb-xl-31 {\n    margin-bottom: 15rem !important;\n  }\n\n  .mb-xl-32 {\n    margin-bottom: 15.5rem !important;\n  }\n\n  .mb-xl-33 {\n    margin-bottom: 16rem !important;\n  }\n\n  .mb-xl-34 {\n    margin-bottom: 16.5rem !important;\n  }\n\n  .mb-xl-35 {\n    margin-bottom: 17rem !important;\n  }\n\n  .mb-xl-36 {\n    margin-bottom: 17.5rem !important;\n  }\n\n  .mb-xl-37 {\n    margin-bottom: 18rem !important;\n  }\n\n  .mb-xl-38 {\n    margin-bottom: 18.5rem !important;\n  }\n\n  .mb-xl-39 {\n    margin-bottom: 19rem !important;\n  }\n\n  .mb-xl-40 {\n    margin-bottom: 19.5rem !important;\n  }\n\n  .mb-xl-41 {\n    margin-bottom: 20rem !important;\n  }\n\n  .mb-xl-42 {\n    margin-bottom: 20.5rem !important;\n  }\n\n  .mb-xl-43 {\n    margin-bottom: 21rem !important;\n  }\n\n  .mb-xl-44 {\n    margin-bottom: 21.5rem !important;\n  }\n\n  .mb-xl-45 {\n    margin-bottom: 22rem !important;\n  }\n\n  .mb-xl-46 {\n    margin-bottom: 22.5rem !important;\n  }\n\n  .mb-xl-47 {\n    margin-bottom: 23rem !important;\n  }\n\n  .mb-xl-48 {\n    margin-bottom: 23.5rem !important;\n  }\n\n  .mb-xl-49 {\n    margin-bottom: 24rem !important;\n  }\n\n  .mb-xl-50 {\n    margin-bottom: 24.5rem !important;\n  }\n\n  .mb-xl-51 {\n    margin-bottom: 25rem !important;\n  }\n\n  .mb-xl-52 {\n    margin-bottom: 25.5rem !important;\n  }\n\n  .mb-xl-53 {\n    margin-bottom: 26rem !important;\n  }\n\n  .mb-xl-54 {\n    margin-bottom: 26.5rem !important;\n  }\n\n  .mb-xl-55 {\n    margin-bottom: 27rem !important;\n  }\n\n  .mb-xl-56 {\n    margin-bottom: 27.5rem !important;\n  }\n\n  .mb-xl-57 {\n    margin-bottom: 28rem !important;\n  }\n\n  .mb-xl-58 {\n    margin-bottom: 28.5rem !important;\n  }\n\n  .mb-xl-59 {\n    margin-bottom: 29rem !important;\n  }\n\n  .mb-xl-60 {\n    margin-bottom: 29.5rem !important;\n  }\n\n  .mb-xl-61 {\n    margin-bottom: 30rem !important;\n  }\n\n  .mb-xl-62 {\n    margin-bottom: 30.5rem !important;\n  }\n\n  .mb-xl-63 {\n    margin-bottom: 31rem !important;\n  }\n\n  .mb-xl-64 {\n    margin-bottom: 31.5rem !important;\n  }\n\n  .mb-xl-65 {\n    margin-bottom: 32rem !important;\n  }\n\n  .mb-xl-66 {\n    margin-bottom: 32.5rem !important;\n  }\n\n  .mb-xl-67 {\n    margin-bottom: 33rem !important;\n  }\n\n  .mb-xl-68 {\n    margin-bottom: 33.5rem !important;\n  }\n\n  .mb-xl-69 {\n    margin-bottom: 34rem !important;\n  }\n\n  .mb-xl-70 {\n    margin-bottom: 34.5rem !important;\n  }\n\n  .mb-xl-71 {\n    margin-bottom: 35rem !important;\n  }\n\n  .mb-xl-72 {\n    margin-bottom: 35.5rem !important;\n  }\n\n  .mb-xl-73 {\n    margin-bottom: 36rem !important;\n  }\n\n  .mb-xl-74 {\n    margin-bottom: 36.5rem !important;\n  }\n\n  .mb-xl-75 {\n    margin-bottom: 37rem !important;\n  }\n\n  .mb-xl-76 {\n    margin-bottom: 37.5rem !important;\n  }\n\n  .mb-xl-77 {\n    margin-bottom: 38rem !important;\n  }\n\n  .mb-xl-78 {\n    margin-bottom: 38.5rem !important;\n  }\n\n  .mb-xl-79 {\n    margin-bottom: 39rem !important;\n  }\n\n  .mb-xl-80 {\n    margin-bottom: 39.5rem !important;\n  }\n\n  .mb-xl-81 {\n    margin-bottom: 40rem !important;\n  }\n\n  .mb-xl-82 {\n    margin-bottom: 40.5rem !important;\n  }\n\n  .mb-xl-83 {\n    margin-bottom: 41rem !important;\n  }\n\n  .mb-xl-84 {\n    margin-bottom: 41.5rem !important;\n  }\n\n  .mb-xl-85 {\n    margin-bottom: 42rem !important;\n  }\n\n  .mb-xl-86 {\n    margin-bottom: 42.5rem !important;\n  }\n\n  .mb-xl-87 {\n    margin-bottom: 43rem !important;\n  }\n\n  .mb-xl-88 {\n    margin-bottom: 43.5rem !important;\n  }\n\n  .mb-xl-89 {\n    margin-bottom: 44rem !important;\n  }\n\n  .mb-xl-90 {\n    margin-bottom: 44.5rem !important;\n  }\n\n  .mb-xl-91 {\n    margin-bottom: 45rem !important;\n  }\n\n  .mb-xl-92 {\n    margin-bottom: 45.5rem !important;\n  }\n\n  .mb-xl-93 {\n    margin-bottom: 46rem !important;\n  }\n\n  .mb-xl-94 {\n    margin-bottom: 46.5rem !important;\n  }\n\n  .mb-xl-95 {\n    margin-bottom: 47rem !important;\n  }\n\n  .mb-xl-96 {\n    margin-bottom: 47.5rem !important;\n  }\n\n  .mb-xl-97 {\n    margin-bottom: 48rem !important;\n  }\n\n  .mb-xl-98 {\n    margin-bottom: 48.5rem !important;\n  }\n\n  .mb-xl-99 {\n    margin-bottom: 49rem !important;\n  }\n\n  .mb-xl-100 {\n    margin-bottom: 49.5rem !important;\n  }\n\n  .mb-xl-101 {\n    margin-bottom: 50rem !important;\n  }\n\n  .mb-xl-102 {\n    margin-bottom: 50.5rem !important;\n  }\n\n  .mb-xl-103 {\n    margin-bottom: 51rem !important;\n  }\n\n  .mb-xl-104 {\n    margin-bottom: 51.5rem !important;\n  }\n\n  .mb-xl-105 {\n    margin-bottom: 52rem !important;\n  }\n\n  .mb-xl-106 {\n    margin-bottom: 52.5rem !important;\n  }\n\n  .mb-xl-107 {\n    margin-bottom: 53rem !important;\n  }\n\n  .mb-xl-108 {\n    margin-bottom: 53.5rem !important;\n  }\n\n  .mb-xl-109 {\n    margin-bottom: 54rem !important;\n  }\n\n  .mb-xl-110 {\n    margin-bottom: 54.5rem !important;\n  }\n\n  .mb-xl-111 {\n    margin-bottom: 55rem !important;\n  }\n\n  .mb-xl-112 {\n    margin-bottom: 55.5rem !important;\n  }\n\n  .mb-xl-113 {\n    margin-bottom: 56rem !important;\n  }\n\n  .mb-xl-114 {\n    margin-bottom: 56.5rem !important;\n  }\n\n  .mb-xl-115 {\n    margin-bottom: 57rem !important;\n  }\n\n  .mb-xl-116 {\n    margin-bottom: 57.5rem !important;\n  }\n\n  .mb-xl-117 {\n    margin-bottom: 58rem !important;\n  }\n\n  .mb-xl-118 {\n    margin-bottom: 58.5rem !important;\n  }\n\n  .mb-xl-119 {\n    margin-bottom: 59rem !important;\n  }\n\n  .mb-xl-120 {\n    margin-bottom: 59.5rem !important;\n  }\n\n  .mb-xl-121 {\n    margin-bottom: 60rem !important;\n  }\n\n  .mb-xl-122 {\n    margin-bottom: 60.5rem !important;\n  }\n\n  .mb-xl-123 {\n    margin-bottom: 61rem !important;\n  }\n\n  .mb-xl-124 {\n    margin-bottom: 61.5rem !important;\n  }\n\n  .mb-xl-125 {\n    margin-bottom: 62rem !important;\n  }\n\n  .mb-xl-126 {\n    margin-bottom: 62.5rem !important;\n  }\n\n  .mb-xl-127 {\n    margin-bottom: 63rem !important;\n  }\n\n  .mb-xl-128 {\n    margin-bottom: 63.5rem !important;\n  }\n\n  .mb-xl-129 {\n    margin-bottom: 64rem !important;\n  }\n\n  .mb-xl-130 {\n    margin-bottom: 64.5rem !important;\n  }\n\n  .mb-xl-131 {\n    margin-bottom: 65rem !important;\n  }\n\n  .mb-xl-132 {\n    margin-bottom: 65.5rem !important;\n  }\n\n  .mb-xl-133 {\n    margin-bottom: 66rem !important;\n  }\n\n  .mb-xl-134 {\n    margin-bottom: 66.5rem !important;\n  }\n\n  .mb-xl-135 {\n    margin-bottom: 67rem !important;\n  }\n\n  .mb-xl-136 {\n    margin-bottom: 67.5rem !important;\n  }\n\n  .mb-xl-137 {\n    margin-bottom: 68rem !important;\n  }\n\n  .mb-xl-138 {\n    margin-bottom: 68.5rem !important;\n  }\n\n  .mb-xl-139 {\n    margin-bottom: 69rem !important;\n  }\n\n  .mb-xl-140 {\n    margin-bottom: 69.5rem !important;\n  }\n\n  .mb-xl-141 {\n    margin-bottom: 70rem !important;\n  }\n\n  .mb-xl-142 {\n    margin-bottom: 70.5rem !important;\n  }\n\n  .mb-xl-143 {\n    margin-bottom: 71rem !important;\n  }\n\n  .mb-xl-144 {\n    margin-bottom: 71.5rem !important;\n  }\n\n  .mb-xl-145 {\n    margin-bottom: 72rem !important;\n  }\n\n  .mb-xl-146 {\n    margin-bottom: 72.5rem !important;\n  }\n\n  .mb-xl-147 {\n    margin-bottom: 73rem !important;\n  }\n\n  .mb-xl-148 {\n    margin-bottom: 73.5rem !important;\n  }\n\n  .mb-xl-149 {\n    margin-bottom: 74rem !important;\n  }\n\n  .mb-xl-150 {\n    margin-bottom: 74.5rem !important;\n  }\n\n  .mb-xl-151 {\n    margin-bottom: 75rem !important;\n  }\n\n  .mb-xl-152 {\n    margin-bottom: 75.5rem !important;\n  }\n\n  .mb-xl-153 {\n    margin-bottom: 76rem !important;\n  }\n\n  .mb-xl-154 {\n    margin-bottom: 76.5rem !important;\n  }\n\n  .mb-xl-155 {\n    margin-bottom: 77rem !important;\n  }\n\n  .mb-xl-156 {\n    margin-bottom: 77.5rem !important;\n  }\n\n  .mb-xl-157 {\n    margin-bottom: 78rem !important;\n  }\n\n  .mb-xl-158 {\n    margin-bottom: 78.5rem !important;\n  }\n\n  .mb-xl-159 {\n    margin-bottom: 79rem !important;\n  }\n\n  .mb-xl-160 {\n    margin-bottom: 79.5rem !important;\n  }\n\n  .ms-xl-0 {\n    margin-left: 0rem !important;\n  }\n\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xl-5 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xl-6 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xl-7 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xl-8 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xl-9 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xl-10 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xl-11 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xl-12 {\n    margin-left: 5.5rem !important;\n  }\n\n  .ms-xl-13 {\n    margin-left: 6rem !important;\n  }\n\n  .ms-xl-14 {\n    margin-left: 6.5rem !important;\n  }\n\n  .ms-xl-15 {\n    margin-left: 7rem !important;\n  }\n\n  .ms-xl-16 {\n    margin-left: 7.5rem !important;\n  }\n\n  .ms-xl-17 {\n    margin-left: 8rem !important;\n  }\n\n  .ms-xl-18 {\n    margin-left: 8.5rem !important;\n  }\n\n  .ms-xl-19 {\n    margin-left: 9rem !important;\n  }\n\n  .ms-xl-20 {\n    margin-left: 9.5rem !important;\n  }\n\n  .ms-xl-21 {\n    margin-left: 10rem !important;\n  }\n\n  .ms-xl-22 {\n    margin-left: 10.5rem !important;\n  }\n\n  .ms-xl-23 {\n    margin-left: 11rem !important;\n  }\n\n  .ms-xl-24 {\n    margin-left: 11.5rem !important;\n  }\n\n  .ms-xl-25 {\n    margin-left: 12rem !important;\n  }\n\n  .ms-xl-26 {\n    margin-left: 12.5rem !important;\n  }\n\n  .ms-xl-27 {\n    margin-left: 13rem !important;\n  }\n\n  .ms-xl-28 {\n    margin-left: 13.5rem !important;\n  }\n\n  .ms-xl-29 {\n    margin-left: 14rem !important;\n  }\n\n  .ms-xl-30 {\n    margin-left: 14.5rem !important;\n  }\n\n  .ms-xl-31 {\n    margin-left: 15rem !important;\n  }\n\n  .ms-xl-32 {\n    margin-left: 15.5rem !important;\n  }\n\n  .ms-xl-33 {\n    margin-left: 16rem !important;\n  }\n\n  .ms-xl-34 {\n    margin-left: 16.5rem !important;\n  }\n\n  .ms-xl-35 {\n    margin-left: 17rem !important;\n  }\n\n  .ms-xl-36 {\n    margin-left: 17.5rem !important;\n  }\n\n  .ms-xl-37 {\n    margin-left: 18rem !important;\n  }\n\n  .ms-xl-38 {\n    margin-left: 18.5rem !important;\n  }\n\n  .ms-xl-39 {\n    margin-left: 19rem !important;\n  }\n\n  .ms-xl-40 {\n    margin-left: 19.5rem !important;\n  }\n\n  .ms-xl-41 {\n    margin-left: 20rem !important;\n  }\n\n  .ms-xl-42 {\n    margin-left: 20.5rem !important;\n  }\n\n  .ms-xl-43 {\n    margin-left: 21rem !important;\n  }\n\n  .ms-xl-44 {\n    margin-left: 21.5rem !important;\n  }\n\n  .ms-xl-45 {\n    margin-left: 22rem !important;\n  }\n\n  .ms-xl-46 {\n    margin-left: 22.5rem !important;\n  }\n\n  .ms-xl-47 {\n    margin-left: 23rem !important;\n  }\n\n  .ms-xl-48 {\n    margin-left: 23.5rem !important;\n  }\n\n  .ms-xl-49 {\n    margin-left: 24rem !important;\n  }\n\n  .ms-xl-50 {\n    margin-left: 24.5rem !important;\n  }\n\n  .ms-xl-51 {\n    margin-left: 25rem !important;\n  }\n\n  .ms-xl-52 {\n    margin-left: 25.5rem !important;\n  }\n\n  .ms-xl-53 {\n    margin-left: 26rem !important;\n  }\n\n  .ms-xl-54 {\n    margin-left: 26.5rem !important;\n  }\n\n  .ms-xl-55 {\n    margin-left: 27rem !important;\n  }\n\n  .ms-xl-56 {\n    margin-left: 27.5rem !important;\n  }\n\n  .ms-xl-57 {\n    margin-left: 28rem !important;\n  }\n\n  .ms-xl-58 {\n    margin-left: 28.5rem !important;\n  }\n\n  .ms-xl-59 {\n    margin-left: 29rem !important;\n  }\n\n  .ms-xl-60 {\n    margin-left: 29.5rem !important;\n  }\n\n  .ms-xl-61 {\n    margin-left: 30rem !important;\n  }\n\n  .ms-xl-62 {\n    margin-left: 30.5rem !important;\n  }\n\n  .ms-xl-63 {\n    margin-left: 31rem !important;\n  }\n\n  .ms-xl-64 {\n    margin-left: 31.5rem !important;\n  }\n\n  .ms-xl-65 {\n    margin-left: 32rem !important;\n  }\n\n  .ms-xl-66 {\n    margin-left: 32.5rem !important;\n  }\n\n  .ms-xl-67 {\n    margin-left: 33rem !important;\n  }\n\n  .ms-xl-68 {\n    margin-left: 33.5rem !important;\n  }\n\n  .ms-xl-69 {\n    margin-left: 34rem !important;\n  }\n\n  .ms-xl-70 {\n    margin-left: 34.5rem !important;\n  }\n\n  .ms-xl-71 {\n    margin-left: 35rem !important;\n  }\n\n  .ms-xl-72 {\n    margin-left: 35.5rem !important;\n  }\n\n  .ms-xl-73 {\n    margin-left: 36rem !important;\n  }\n\n  .ms-xl-74 {\n    margin-left: 36.5rem !important;\n  }\n\n  .ms-xl-75 {\n    margin-left: 37rem !important;\n  }\n\n  .ms-xl-76 {\n    margin-left: 37.5rem !important;\n  }\n\n  .ms-xl-77 {\n    margin-left: 38rem !important;\n  }\n\n  .ms-xl-78 {\n    margin-left: 38.5rem !important;\n  }\n\n  .ms-xl-79 {\n    margin-left: 39rem !important;\n  }\n\n  .ms-xl-80 {\n    margin-left: 39.5rem !important;\n  }\n\n  .ms-xl-81 {\n    margin-left: 40rem !important;\n  }\n\n  .ms-xl-82 {\n    margin-left: 40.5rem !important;\n  }\n\n  .ms-xl-83 {\n    margin-left: 41rem !important;\n  }\n\n  .ms-xl-84 {\n    margin-left: 41.5rem !important;\n  }\n\n  .ms-xl-85 {\n    margin-left: 42rem !important;\n  }\n\n  .ms-xl-86 {\n    margin-left: 42.5rem !important;\n  }\n\n  .ms-xl-87 {\n    margin-left: 43rem !important;\n  }\n\n  .ms-xl-88 {\n    margin-left: 43.5rem !important;\n  }\n\n  .ms-xl-89 {\n    margin-left: 44rem !important;\n  }\n\n  .ms-xl-90 {\n    margin-left: 44.5rem !important;\n  }\n\n  .ms-xl-91 {\n    margin-left: 45rem !important;\n  }\n\n  .ms-xl-92 {\n    margin-left: 45.5rem !important;\n  }\n\n  .ms-xl-93 {\n    margin-left: 46rem !important;\n  }\n\n  .ms-xl-94 {\n    margin-left: 46.5rem !important;\n  }\n\n  .ms-xl-95 {\n    margin-left: 47rem !important;\n  }\n\n  .ms-xl-96 {\n    margin-left: 47.5rem !important;\n  }\n\n  .ms-xl-97 {\n    margin-left: 48rem !important;\n  }\n\n  .ms-xl-98 {\n    margin-left: 48.5rem !important;\n  }\n\n  .ms-xl-99 {\n    margin-left: 49rem !important;\n  }\n\n  .ms-xl-100 {\n    margin-left: 49.5rem !important;\n  }\n\n  .ms-xl-101 {\n    margin-left: 50rem !important;\n  }\n\n  .ms-xl-102 {\n    margin-left: 50.5rem !important;\n  }\n\n  .ms-xl-103 {\n    margin-left: 51rem !important;\n  }\n\n  .ms-xl-104 {\n    margin-left: 51.5rem !important;\n  }\n\n  .ms-xl-105 {\n    margin-left: 52rem !important;\n  }\n\n  .ms-xl-106 {\n    margin-left: 52.5rem !important;\n  }\n\n  .ms-xl-107 {\n    margin-left: 53rem !important;\n  }\n\n  .ms-xl-108 {\n    margin-left: 53.5rem !important;\n  }\n\n  .ms-xl-109 {\n    margin-left: 54rem !important;\n  }\n\n  .ms-xl-110 {\n    margin-left: 54.5rem !important;\n  }\n\n  .ms-xl-111 {\n    margin-left: 55rem !important;\n  }\n\n  .ms-xl-112 {\n    margin-left: 55.5rem !important;\n  }\n\n  .ms-xl-113 {\n    margin-left: 56rem !important;\n  }\n\n  .ms-xl-114 {\n    margin-left: 56.5rem !important;\n  }\n\n  .ms-xl-115 {\n    margin-left: 57rem !important;\n  }\n\n  .ms-xl-116 {\n    margin-left: 57.5rem !important;\n  }\n\n  .ms-xl-117 {\n    margin-left: 58rem !important;\n  }\n\n  .ms-xl-118 {\n    margin-left: 58.5rem !important;\n  }\n\n  .ms-xl-119 {\n    margin-left: 59rem !important;\n  }\n\n  .ms-xl-120 {\n    margin-left: 59.5rem !important;\n  }\n\n  .ms-xl-121 {\n    margin-left: 60rem !important;\n  }\n\n  .ms-xl-122 {\n    margin-left: 60.5rem !important;\n  }\n\n  .ms-xl-123 {\n    margin-left: 61rem !important;\n  }\n\n  .ms-xl-124 {\n    margin-left: 61.5rem !important;\n  }\n\n  .ms-xl-125 {\n    margin-left: 62rem !important;\n  }\n\n  .ms-xl-126 {\n    margin-left: 62.5rem !important;\n  }\n\n  .ms-xl-127 {\n    margin-left: 63rem !important;\n  }\n\n  .ms-xl-128 {\n    margin-left: 63.5rem !important;\n  }\n\n  .ms-xl-129 {\n    margin-left: 64rem !important;\n  }\n\n  .ms-xl-130 {\n    margin-left: 64.5rem !important;\n  }\n\n  .ms-xl-131 {\n    margin-left: 65rem !important;\n  }\n\n  .ms-xl-132 {\n    margin-left: 65.5rem !important;\n  }\n\n  .ms-xl-133 {\n    margin-left: 66rem !important;\n  }\n\n  .ms-xl-134 {\n    margin-left: 66.5rem !important;\n  }\n\n  .ms-xl-135 {\n    margin-left: 67rem !important;\n  }\n\n  .ms-xl-136 {\n    margin-left: 67.5rem !important;\n  }\n\n  .ms-xl-137 {\n    margin-left: 68rem !important;\n  }\n\n  .ms-xl-138 {\n    margin-left: 68.5rem !important;\n  }\n\n  .ms-xl-139 {\n    margin-left: 69rem !important;\n  }\n\n  .ms-xl-140 {\n    margin-left: 69.5rem !important;\n  }\n\n  .ms-xl-141 {\n    margin-left: 70rem !important;\n  }\n\n  .ms-xl-142 {\n    margin-left: 70.5rem !important;\n  }\n\n  .ms-xl-143 {\n    margin-left: 71rem !important;\n  }\n\n  .ms-xl-144 {\n    margin-left: 71.5rem !important;\n  }\n\n  .ms-xl-145 {\n    margin-left: 72rem !important;\n  }\n\n  .ms-xl-146 {\n    margin-left: 72.5rem !important;\n  }\n\n  .ms-xl-147 {\n    margin-left: 73rem !important;\n  }\n\n  .ms-xl-148 {\n    margin-left: 73.5rem !important;\n  }\n\n  .ms-xl-149 {\n    margin-left: 74rem !important;\n  }\n\n  .ms-xl-150 {\n    margin-left: 74.5rem !important;\n  }\n\n  .ms-xl-151 {\n    margin-left: 75rem !important;\n  }\n\n  .ms-xl-152 {\n    margin-left: 75.5rem !important;\n  }\n\n  .ms-xl-153 {\n    margin-left: 76rem !important;\n  }\n\n  .ms-xl-154 {\n    margin-left: 76.5rem !important;\n  }\n\n  .ms-xl-155 {\n    margin-left: 77rem !important;\n  }\n\n  .ms-xl-156 {\n    margin-left: 77.5rem !important;\n  }\n\n  .ms-xl-157 {\n    margin-left: 78rem !important;\n  }\n\n  .ms-xl-158 {\n    margin-left: 78.5rem !important;\n  }\n\n  .ms-xl-159 {\n    margin-left: 79rem !important;\n  }\n\n  .ms-xl-160 {\n    margin-left: 79.5rem !important;\n  }\n\n  .me-xl-0 {\n    margin-right: 0rem !important;\n  }\n\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xl-5 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xl-6 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xl-7 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xl-8 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xl-9 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xl-10 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xl-11 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xl-12 {\n    margin-right: 5.5rem !important;\n  }\n\n  .me-xl-13 {\n    margin-right: 6rem !important;\n  }\n\n  .me-xl-14 {\n    margin-right: 6.5rem !important;\n  }\n\n  .me-xl-15 {\n    margin-right: 7rem !important;\n  }\n\n  .me-xl-16 {\n    margin-right: 7.5rem !important;\n  }\n\n  .me-xl-17 {\n    margin-right: 8rem !important;\n  }\n\n  .me-xl-18 {\n    margin-right: 8.5rem !important;\n  }\n\n  .me-xl-19 {\n    margin-right: 9rem !important;\n  }\n\n  .me-xl-20 {\n    margin-right: 9.5rem !important;\n  }\n\n  .me-xl-21 {\n    margin-right: 10rem !important;\n  }\n\n  .me-xl-22 {\n    margin-right: 10.5rem !important;\n  }\n\n  .me-xl-23 {\n    margin-right: 11rem !important;\n  }\n\n  .me-xl-24 {\n    margin-right: 11.5rem !important;\n  }\n\n  .me-xl-25 {\n    margin-right: 12rem !important;\n  }\n\n  .me-xl-26 {\n    margin-right: 12.5rem !important;\n  }\n\n  .me-xl-27 {\n    margin-right: 13rem !important;\n  }\n\n  .me-xl-28 {\n    margin-right: 13.5rem !important;\n  }\n\n  .me-xl-29 {\n    margin-right: 14rem !important;\n  }\n\n  .me-xl-30 {\n    margin-right: 14.5rem !important;\n  }\n\n  .me-xl-31 {\n    margin-right: 15rem !important;\n  }\n\n  .me-xl-32 {\n    margin-right: 15.5rem !important;\n  }\n\n  .me-xl-33 {\n    margin-right: 16rem !important;\n  }\n\n  .me-xl-34 {\n    margin-right: 16.5rem !important;\n  }\n\n  .me-xl-35 {\n    margin-right: 17rem !important;\n  }\n\n  .me-xl-36 {\n    margin-right: 17.5rem !important;\n  }\n\n  .me-xl-37 {\n    margin-right: 18rem !important;\n  }\n\n  .me-xl-38 {\n    margin-right: 18.5rem !important;\n  }\n\n  .me-xl-39 {\n    margin-right: 19rem !important;\n  }\n\n  .me-xl-40 {\n    margin-right: 19.5rem !important;\n  }\n\n  .me-xl-41 {\n    margin-right: 20rem !important;\n  }\n\n  .me-xl-42 {\n    margin-right: 20.5rem !important;\n  }\n\n  .me-xl-43 {\n    margin-right: 21rem !important;\n  }\n\n  .me-xl-44 {\n    margin-right: 21.5rem !important;\n  }\n\n  .me-xl-45 {\n    margin-right: 22rem !important;\n  }\n\n  .me-xl-46 {\n    margin-right: 22.5rem !important;\n  }\n\n  .me-xl-47 {\n    margin-right: 23rem !important;\n  }\n\n  .me-xl-48 {\n    margin-right: 23.5rem !important;\n  }\n\n  .me-xl-49 {\n    margin-right: 24rem !important;\n  }\n\n  .me-xl-50 {\n    margin-right: 24.5rem !important;\n  }\n\n  .me-xl-51 {\n    margin-right: 25rem !important;\n  }\n\n  .me-xl-52 {\n    margin-right: 25.5rem !important;\n  }\n\n  .me-xl-53 {\n    margin-right: 26rem !important;\n  }\n\n  .me-xl-54 {\n    margin-right: 26.5rem !important;\n  }\n\n  .me-xl-55 {\n    margin-right: 27rem !important;\n  }\n\n  .me-xl-56 {\n    margin-right: 27.5rem !important;\n  }\n\n  .me-xl-57 {\n    margin-right: 28rem !important;\n  }\n\n  .me-xl-58 {\n    margin-right: 28.5rem !important;\n  }\n\n  .me-xl-59 {\n    margin-right: 29rem !important;\n  }\n\n  .me-xl-60 {\n    margin-right: 29.5rem !important;\n  }\n\n  .me-xl-61 {\n    margin-right: 30rem !important;\n  }\n\n  .me-xl-62 {\n    margin-right: 30.5rem !important;\n  }\n\n  .me-xl-63 {\n    margin-right: 31rem !important;\n  }\n\n  .me-xl-64 {\n    margin-right: 31.5rem !important;\n  }\n\n  .me-xl-65 {\n    margin-right: 32rem !important;\n  }\n\n  .me-xl-66 {\n    margin-right: 32.5rem !important;\n  }\n\n  .me-xl-67 {\n    margin-right: 33rem !important;\n  }\n\n  .me-xl-68 {\n    margin-right: 33.5rem !important;\n  }\n\n  .me-xl-69 {\n    margin-right: 34rem !important;\n  }\n\n  .me-xl-70 {\n    margin-right: 34.5rem !important;\n  }\n\n  .me-xl-71 {\n    margin-right: 35rem !important;\n  }\n\n  .me-xl-72 {\n    margin-right: 35.5rem !important;\n  }\n\n  .me-xl-73 {\n    margin-right: 36rem !important;\n  }\n\n  .me-xl-74 {\n    margin-right: 36.5rem !important;\n  }\n\n  .me-xl-75 {\n    margin-right: 37rem !important;\n  }\n\n  .me-xl-76 {\n    margin-right: 37.5rem !important;\n  }\n\n  .me-xl-77 {\n    margin-right: 38rem !important;\n  }\n\n  .me-xl-78 {\n    margin-right: 38.5rem !important;\n  }\n\n  .me-xl-79 {\n    margin-right: 39rem !important;\n  }\n\n  .me-xl-80 {\n    margin-right: 39.5rem !important;\n  }\n\n  .me-xl-81 {\n    margin-right: 40rem !important;\n  }\n\n  .me-xl-82 {\n    margin-right: 40.5rem !important;\n  }\n\n  .me-xl-83 {\n    margin-right: 41rem !important;\n  }\n\n  .me-xl-84 {\n    margin-right: 41.5rem !important;\n  }\n\n  .me-xl-85 {\n    margin-right: 42rem !important;\n  }\n\n  .me-xl-86 {\n    margin-right: 42.5rem !important;\n  }\n\n  .me-xl-87 {\n    margin-right: 43rem !important;\n  }\n\n  .me-xl-88 {\n    margin-right: 43.5rem !important;\n  }\n\n  .me-xl-89 {\n    margin-right: 44rem !important;\n  }\n\n  .me-xl-90 {\n    margin-right: 44.5rem !important;\n  }\n\n  .me-xl-91 {\n    margin-right: 45rem !important;\n  }\n\n  .me-xl-92 {\n    margin-right: 45.5rem !important;\n  }\n\n  .me-xl-93 {\n    margin-right: 46rem !important;\n  }\n\n  .me-xl-94 {\n    margin-right: 46.5rem !important;\n  }\n\n  .me-xl-95 {\n    margin-right: 47rem !important;\n  }\n\n  .me-xl-96 {\n    margin-right: 47.5rem !important;\n  }\n\n  .me-xl-97 {\n    margin-right: 48rem !important;\n  }\n\n  .me-xl-98 {\n    margin-right: 48.5rem !important;\n  }\n\n  .me-xl-99 {\n    margin-right: 49rem !important;\n  }\n\n  .me-xl-100 {\n    margin-right: 49.5rem !important;\n  }\n\n  .me-xl-101 {\n    margin-right: 50rem !important;\n  }\n\n  .me-xl-102 {\n    margin-right: 50.5rem !important;\n  }\n\n  .me-xl-103 {\n    margin-right: 51rem !important;\n  }\n\n  .me-xl-104 {\n    margin-right: 51.5rem !important;\n  }\n\n  .me-xl-105 {\n    margin-right: 52rem !important;\n  }\n\n  .me-xl-106 {\n    margin-right: 52.5rem !important;\n  }\n\n  .me-xl-107 {\n    margin-right: 53rem !important;\n  }\n\n  .me-xl-108 {\n    margin-right: 53.5rem !important;\n  }\n\n  .me-xl-109 {\n    margin-right: 54rem !important;\n  }\n\n  .me-xl-110 {\n    margin-right: 54.5rem !important;\n  }\n\n  .me-xl-111 {\n    margin-right: 55rem !important;\n  }\n\n  .me-xl-112 {\n    margin-right: 55.5rem !important;\n  }\n\n  .me-xl-113 {\n    margin-right: 56rem !important;\n  }\n\n  .me-xl-114 {\n    margin-right: 56.5rem !important;\n  }\n\n  .me-xl-115 {\n    margin-right: 57rem !important;\n  }\n\n  .me-xl-116 {\n    margin-right: 57.5rem !important;\n  }\n\n  .me-xl-117 {\n    margin-right: 58rem !important;\n  }\n\n  .me-xl-118 {\n    margin-right: 58.5rem !important;\n  }\n\n  .me-xl-119 {\n    margin-right: 59rem !important;\n  }\n\n  .me-xl-120 {\n    margin-right: 59.5rem !important;\n  }\n\n  .me-xl-121 {\n    margin-right: 60rem !important;\n  }\n\n  .me-xl-122 {\n    margin-right: 60.5rem !important;\n  }\n\n  .me-xl-123 {\n    margin-right: 61rem !important;\n  }\n\n  .me-xl-124 {\n    margin-right: 61.5rem !important;\n  }\n\n  .me-xl-125 {\n    margin-right: 62rem !important;\n  }\n\n  .me-xl-126 {\n    margin-right: 62.5rem !important;\n  }\n\n  .me-xl-127 {\n    margin-right: 63rem !important;\n  }\n\n  .me-xl-128 {\n    margin-right: 63.5rem !important;\n  }\n\n  .me-xl-129 {\n    margin-right: 64rem !important;\n  }\n\n  .me-xl-130 {\n    margin-right: 64.5rem !important;\n  }\n\n  .me-xl-131 {\n    margin-right: 65rem !important;\n  }\n\n  .me-xl-132 {\n    margin-right: 65.5rem !important;\n  }\n\n  .me-xl-133 {\n    margin-right: 66rem !important;\n  }\n\n  .me-xl-134 {\n    margin-right: 66.5rem !important;\n  }\n\n  .me-xl-135 {\n    margin-right: 67rem !important;\n  }\n\n  .me-xl-136 {\n    margin-right: 67.5rem !important;\n  }\n\n  .me-xl-137 {\n    margin-right: 68rem !important;\n  }\n\n  .me-xl-138 {\n    margin-right: 68.5rem !important;\n  }\n\n  .me-xl-139 {\n    margin-right: 69rem !important;\n  }\n\n  .me-xl-140 {\n    margin-right: 69.5rem !important;\n  }\n\n  .me-xl-141 {\n    margin-right: 70rem !important;\n  }\n\n  .me-xl-142 {\n    margin-right: 70.5rem !important;\n  }\n\n  .me-xl-143 {\n    margin-right: 71rem !important;\n  }\n\n  .me-xl-144 {\n    margin-right: 71.5rem !important;\n  }\n\n  .me-xl-145 {\n    margin-right: 72rem !important;\n  }\n\n  .me-xl-146 {\n    margin-right: 72.5rem !important;\n  }\n\n  .me-xl-147 {\n    margin-right: 73rem !important;\n  }\n\n  .me-xl-148 {\n    margin-right: 73.5rem !important;\n  }\n\n  .me-xl-149 {\n    margin-right: 74rem !important;\n  }\n\n  .me-xl-150 {\n    margin-right: 74.5rem !important;\n  }\n\n  .me-xl-151 {\n    margin-right: 75rem !important;\n  }\n\n  .me-xl-152 {\n    margin-right: 75.5rem !important;\n  }\n\n  .me-xl-153 {\n    margin-right: 76rem !important;\n  }\n\n  .me-xl-154 {\n    margin-right: 76.5rem !important;\n  }\n\n  .me-xl-155 {\n    margin-right: 77rem !important;\n  }\n\n  .me-xl-156 {\n    margin-right: 77.5rem !important;\n  }\n\n  .me-xl-157 {\n    margin-right: 78rem !important;\n  }\n\n  .me-xl-158 {\n    margin-right: 78.5rem !important;\n  }\n\n  .me-xl-159 {\n    margin-right: 79rem !important;\n  }\n\n  .me-xl-160 {\n    margin-right: 79.5rem !important;\n  }\n\n  .mx-xl-0 {\n    margin-left: 0rem !important;\n    margin-right: 0rem !important;\n  }\n\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n    margin-right: 1rem !important;\n  }\n\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .mx-xl-5 {\n    margin-left: 2rem !important;\n    margin-right: 2rem !important;\n  }\n\n  .mx-xl-6 {\n    margin-left: 2.5rem !important;\n    margin-right: 2.5rem !important;\n  }\n\n  .mx-xl-7 {\n    margin-left: 3rem !important;\n    margin-right: 3rem !important;\n  }\n\n  .mx-xl-8 {\n    margin-left: 3.5rem !important;\n    margin-right: 3.5rem !important;\n  }\n\n  .mx-xl-9 {\n    margin-left: 4rem !important;\n    margin-right: 4rem !important;\n  }\n\n  .mx-xl-10 {\n    margin-left: 4.5rem !important;\n    margin-right: 4.5rem !important;\n  }\n\n  .mx-xl-11 {\n    margin-left: 5rem !important;\n    margin-right: 5rem !important;\n  }\n\n  .mx-xl-12 {\n    margin-left: 5.5rem !important;\n    margin-right: 5.5rem !important;\n  }\n\n  .mx-xl-13 {\n    margin-left: 6rem !important;\n    margin-right: 6rem !important;\n  }\n\n  .mx-xl-14 {\n    margin-left: 6.5rem !important;\n    margin-right: 6.5rem !important;\n  }\n\n  .mx-xl-15 {\n    margin-left: 7rem !important;\n    margin-right: 7rem !important;\n  }\n\n  .mx-xl-16 {\n    margin-left: 7.5rem !important;\n    margin-right: 7.5rem !important;\n  }\n\n  .mx-xl-17 {\n    margin-left: 8rem !important;\n    margin-right: 8rem !important;\n  }\n\n  .mx-xl-18 {\n    margin-left: 8.5rem !important;\n    margin-right: 8.5rem !important;\n  }\n\n  .mx-xl-19 {\n    margin-left: 9rem !important;\n    margin-right: 9rem !important;\n  }\n\n  .mx-xl-20 {\n    margin-left: 9.5rem !important;\n    margin-right: 9.5rem !important;\n  }\n\n  .mx-xl-21 {\n    margin-left: 10rem !important;\n    margin-right: 10rem !important;\n  }\n\n  .mx-xl-22 {\n    margin-left: 10.5rem !important;\n    margin-right: 10.5rem !important;\n  }\n\n  .mx-xl-23 {\n    margin-left: 11rem !important;\n    margin-right: 11rem !important;\n  }\n\n  .mx-xl-24 {\n    margin-left: 11.5rem !important;\n    margin-right: 11.5rem !important;\n  }\n\n  .mx-xl-25 {\n    margin-left: 12rem !important;\n    margin-right: 12rem !important;\n  }\n\n  .mx-xl-26 {\n    margin-left: 12.5rem !important;\n    margin-right: 12.5rem !important;\n  }\n\n  .mx-xl-27 {\n    margin-left: 13rem !important;\n    margin-right: 13rem !important;\n  }\n\n  .mx-xl-28 {\n    margin-left: 13.5rem !important;\n    margin-right: 13.5rem !important;\n  }\n\n  .mx-xl-29 {\n    margin-left: 14rem !important;\n    margin-right: 14rem !important;\n  }\n\n  .mx-xl-30 {\n    margin-left: 14.5rem !important;\n    margin-right: 14.5rem !important;\n  }\n\n  .mx-xl-31 {\n    margin-left: 15rem !important;\n    margin-right: 15rem !important;\n  }\n\n  .mx-xl-32 {\n    margin-left: 15.5rem !important;\n    margin-right: 15.5rem !important;\n  }\n\n  .mx-xl-33 {\n    margin-left: 16rem !important;\n    margin-right: 16rem !important;\n  }\n\n  .mx-xl-34 {\n    margin-left: 16.5rem !important;\n    margin-right: 16.5rem !important;\n  }\n\n  .mx-xl-35 {\n    margin-left: 17rem !important;\n    margin-right: 17rem !important;\n  }\n\n  .mx-xl-36 {\n    margin-left: 17.5rem !important;\n    margin-right: 17.5rem !important;\n  }\n\n  .mx-xl-37 {\n    margin-left: 18rem !important;\n    margin-right: 18rem !important;\n  }\n\n  .mx-xl-38 {\n    margin-left: 18.5rem !important;\n    margin-right: 18.5rem !important;\n  }\n\n  .mx-xl-39 {\n    margin-left: 19rem !important;\n    margin-right: 19rem !important;\n  }\n\n  .mx-xl-40 {\n    margin-left: 19.5rem !important;\n    margin-right: 19.5rem !important;\n  }\n\n  .mx-xl-41 {\n    margin-left: 20rem !important;\n    margin-right: 20rem !important;\n  }\n\n  .mx-xl-42 {\n    margin-left: 20.5rem !important;\n    margin-right: 20.5rem !important;\n  }\n\n  .mx-xl-43 {\n    margin-left: 21rem !important;\n    margin-right: 21rem !important;\n  }\n\n  .mx-xl-44 {\n    margin-left: 21.5rem !important;\n    margin-right: 21.5rem !important;\n  }\n\n  .mx-xl-45 {\n    margin-left: 22rem !important;\n    margin-right: 22rem !important;\n  }\n\n  .mx-xl-46 {\n    margin-left: 22.5rem !important;\n    margin-right: 22.5rem !important;\n  }\n\n  .mx-xl-47 {\n    margin-left: 23rem !important;\n    margin-right: 23rem !important;\n  }\n\n  .mx-xl-48 {\n    margin-left: 23.5rem !important;\n    margin-right: 23.5rem !important;\n  }\n\n  .mx-xl-49 {\n    margin-left: 24rem !important;\n    margin-right: 24rem !important;\n  }\n\n  .mx-xl-50 {\n    margin-left: 24.5rem !important;\n    margin-right: 24.5rem !important;\n  }\n\n  .mx-xl-51 {\n    margin-left: 25rem !important;\n    margin-right: 25rem !important;\n  }\n\n  .mx-xl-52 {\n    margin-left: 25.5rem !important;\n    margin-right: 25.5rem !important;\n  }\n\n  .mx-xl-53 {\n    margin-left: 26rem !important;\n    margin-right: 26rem !important;\n  }\n\n  .mx-xl-54 {\n    margin-left: 26.5rem !important;\n    margin-right: 26.5rem !important;\n  }\n\n  .mx-xl-55 {\n    margin-left: 27rem !important;\n    margin-right: 27rem !important;\n  }\n\n  .mx-xl-56 {\n    margin-left: 27.5rem !important;\n    margin-right: 27.5rem !important;\n  }\n\n  .mx-xl-57 {\n    margin-left: 28rem !important;\n    margin-right: 28rem !important;\n  }\n\n  .mx-xl-58 {\n    margin-left: 28.5rem !important;\n    margin-right: 28.5rem !important;\n  }\n\n  .mx-xl-59 {\n    margin-left: 29rem !important;\n    margin-right: 29rem !important;\n  }\n\n  .mx-xl-60 {\n    margin-left: 29.5rem !important;\n    margin-right: 29.5rem !important;\n  }\n\n  .mx-xl-61 {\n    margin-left: 30rem !important;\n    margin-right: 30rem !important;\n  }\n\n  .mx-xl-62 {\n    margin-left: 30.5rem !important;\n    margin-right: 30.5rem !important;\n  }\n\n  .mx-xl-63 {\n    margin-left: 31rem !important;\n    margin-right: 31rem !important;\n  }\n\n  .mx-xl-64 {\n    margin-left: 31.5rem !important;\n    margin-right: 31.5rem !important;\n  }\n\n  .mx-xl-65 {\n    margin-left: 32rem !important;\n    margin-right: 32rem !important;\n  }\n\n  .mx-xl-66 {\n    margin-left: 32.5rem !important;\n    margin-right: 32.5rem !important;\n  }\n\n  .mx-xl-67 {\n    margin-left: 33rem !important;\n    margin-right: 33rem !important;\n  }\n\n  .mx-xl-68 {\n    margin-left: 33.5rem !important;\n    margin-right: 33.5rem !important;\n  }\n\n  .mx-xl-69 {\n    margin-left: 34rem !important;\n    margin-right: 34rem !important;\n  }\n\n  .mx-xl-70 {\n    margin-left: 34.5rem !important;\n    margin-right: 34.5rem !important;\n  }\n\n  .mx-xl-71 {\n    margin-left: 35rem !important;\n    margin-right: 35rem !important;\n  }\n\n  .mx-xl-72 {\n    margin-left: 35.5rem !important;\n    margin-right: 35.5rem !important;\n  }\n\n  .mx-xl-73 {\n    margin-left: 36rem !important;\n    margin-right: 36rem !important;\n  }\n\n  .mx-xl-74 {\n    margin-left: 36.5rem !important;\n    margin-right: 36.5rem !important;\n  }\n\n  .mx-xl-75 {\n    margin-left: 37rem !important;\n    margin-right: 37rem !important;\n  }\n\n  .mx-xl-76 {\n    margin-left: 37.5rem !important;\n    margin-right: 37.5rem !important;\n  }\n\n  .mx-xl-77 {\n    margin-left: 38rem !important;\n    margin-right: 38rem !important;\n  }\n\n  .mx-xl-78 {\n    margin-left: 38.5rem !important;\n    margin-right: 38.5rem !important;\n  }\n\n  .mx-xl-79 {\n    margin-left: 39rem !important;\n    margin-right: 39rem !important;\n  }\n\n  .mx-xl-80 {\n    margin-left: 39.5rem !important;\n    margin-right: 39.5rem !important;\n  }\n\n  .mx-xl-81 {\n    margin-left: 40rem !important;\n    margin-right: 40rem !important;\n  }\n\n  .mx-xl-82 {\n    margin-left: 40.5rem !important;\n    margin-right: 40.5rem !important;\n  }\n\n  .mx-xl-83 {\n    margin-left: 41rem !important;\n    margin-right: 41rem !important;\n  }\n\n  .mx-xl-84 {\n    margin-left: 41.5rem !important;\n    margin-right: 41.5rem !important;\n  }\n\n  .mx-xl-85 {\n    margin-left: 42rem !important;\n    margin-right: 42rem !important;\n  }\n\n  .mx-xl-86 {\n    margin-left: 42.5rem !important;\n    margin-right: 42.5rem !important;\n  }\n\n  .mx-xl-87 {\n    margin-left: 43rem !important;\n    margin-right: 43rem !important;\n  }\n\n  .mx-xl-88 {\n    margin-left: 43.5rem !important;\n    margin-right: 43.5rem !important;\n  }\n\n  .mx-xl-89 {\n    margin-left: 44rem !important;\n    margin-right: 44rem !important;\n  }\n\n  .mx-xl-90 {\n    margin-left: 44.5rem !important;\n    margin-right: 44.5rem !important;\n  }\n\n  .mx-xl-91 {\n    margin-left: 45rem !important;\n    margin-right: 45rem !important;\n  }\n\n  .mx-xl-92 {\n    margin-left: 45.5rem !important;\n    margin-right: 45.5rem !important;\n  }\n\n  .mx-xl-93 {\n    margin-left: 46rem !important;\n    margin-right: 46rem !important;\n  }\n\n  .mx-xl-94 {\n    margin-left: 46.5rem !important;\n    margin-right: 46.5rem !important;\n  }\n\n  .mx-xl-95 {\n    margin-left: 47rem !important;\n    margin-right: 47rem !important;\n  }\n\n  .mx-xl-96 {\n    margin-left: 47.5rem !important;\n    margin-right: 47.5rem !important;\n  }\n\n  .mx-xl-97 {\n    margin-left: 48rem !important;\n    margin-right: 48rem !important;\n  }\n\n  .mx-xl-98 {\n    margin-left: 48.5rem !important;\n    margin-right: 48.5rem !important;\n  }\n\n  .mx-xl-99 {\n    margin-left: 49rem !important;\n    margin-right: 49rem !important;\n  }\n\n  .mx-xl-100 {\n    margin-left: 49.5rem !important;\n    margin-right: 49.5rem !important;\n  }\n\n  .mx-xl-101 {\n    margin-left: 50rem !important;\n    margin-right: 50rem !important;\n  }\n\n  .mx-xl-102 {\n    margin-left: 50.5rem !important;\n    margin-right: 50.5rem !important;\n  }\n\n  .mx-xl-103 {\n    margin-left: 51rem !important;\n    margin-right: 51rem !important;\n  }\n\n  .mx-xl-104 {\n    margin-left: 51.5rem !important;\n    margin-right: 51.5rem !important;\n  }\n\n  .mx-xl-105 {\n    margin-left: 52rem !important;\n    margin-right: 52rem !important;\n  }\n\n  .mx-xl-106 {\n    margin-left: 52.5rem !important;\n    margin-right: 52.5rem !important;\n  }\n\n  .mx-xl-107 {\n    margin-left: 53rem !important;\n    margin-right: 53rem !important;\n  }\n\n  .mx-xl-108 {\n    margin-left: 53.5rem !important;\n    margin-right: 53.5rem !important;\n  }\n\n  .mx-xl-109 {\n    margin-left: 54rem !important;\n    margin-right: 54rem !important;\n  }\n\n  .mx-xl-110 {\n    margin-left: 54.5rem !important;\n    margin-right: 54.5rem !important;\n  }\n\n  .mx-xl-111 {\n    margin-left: 55rem !important;\n    margin-right: 55rem !important;\n  }\n\n  .mx-xl-112 {\n    margin-left: 55.5rem !important;\n    margin-right: 55.5rem !important;\n  }\n\n  .mx-xl-113 {\n    margin-left: 56rem !important;\n    margin-right: 56rem !important;\n  }\n\n  .mx-xl-114 {\n    margin-left: 56.5rem !important;\n    margin-right: 56.5rem !important;\n  }\n\n  .mx-xl-115 {\n    margin-left: 57rem !important;\n    margin-right: 57rem !important;\n  }\n\n  .mx-xl-116 {\n    margin-left: 57.5rem !important;\n    margin-right: 57.5rem !important;\n  }\n\n  .mx-xl-117 {\n    margin-left: 58rem !important;\n    margin-right: 58rem !important;\n  }\n\n  .mx-xl-118 {\n    margin-left: 58.5rem !important;\n    margin-right: 58.5rem !important;\n  }\n\n  .mx-xl-119 {\n    margin-left: 59rem !important;\n    margin-right: 59rem !important;\n  }\n\n  .mx-xl-120 {\n    margin-left: 59.5rem !important;\n    margin-right: 59.5rem !important;\n  }\n\n  .mx-xl-121 {\n    margin-left: 60rem !important;\n    margin-right: 60rem !important;\n  }\n\n  .mx-xl-122 {\n    margin-left: 60.5rem !important;\n    margin-right: 60.5rem !important;\n  }\n\n  .mx-xl-123 {\n    margin-left: 61rem !important;\n    margin-right: 61rem !important;\n  }\n\n  .mx-xl-124 {\n    margin-left: 61.5rem !important;\n    margin-right: 61.5rem !important;\n  }\n\n  .mx-xl-125 {\n    margin-left: 62rem !important;\n    margin-right: 62rem !important;\n  }\n\n  .mx-xl-126 {\n    margin-left: 62.5rem !important;\n    margin-right: 62.5rem !important;\n  }\n\n  .mx-xl-127 {\n    margin-left: 63rem !important;\n    margin-right: 63rem !important;\n  }\n\n  .mx-xl-128 {\n    margin-left: 63.5rem !important;\n    margin-right: 63.5rem !important;\n  }\n\n  .mx-xl-129 {\n    margin-left: 64rem !important;\n    margin-right: 64rem !important;\n  }\n\n  .mx-xl-130 {\n    margin-left: 64.5rem !important;\n    margin-right: 64.5rem !important;\n  }\n\n  .mx-xl-131 {\n    margin-left: 65rem !important;\n    margin-right: 65rem !important;\n  }\n\n  .mx-xl-132 {\n    margin-left: 65.5rem !important;\n    margin-right: 65.5rem !important;\n  }\n\n  .mx-xl-133 {\n    margin-left: 66rem !important;\n    margin-right: 66rem !important;\n  }\n\n  .mx-xl-134 {\n    margin-left: 66.5rem !important;\n    margin-right: 66.5rem !important;\n  }\n\n  .mx-xl-135 {\n    margin-left: 67rem !important;\n    margin-right: 67rem !important;\n  }\n\n  .mx-xl-136 {\n    margin-left: 67.5rem !important;\n    margin-right: 67.5rem !important;\n  }\n\n  .mx-xl-137 {\n    margin-left: 68rem !important;\n    margin-right: 68rem !important;\n  }\n\n  .mx-xl-138 {\n    margin-left: 68.5rem !important;\n    margin-right: 68.5rem !important;\n  }\n\n  .mx-xl-139 {\n    margin-left: 69rem !important;\n    margin-right: 69rem !important;\n  }\n\n  .mx-xl-140 {\n    margin-left: 69.5rem !important;\n    margin-right: 69.5rem !important;\n  }\n\n  .mx-xl-141 {\n    margin-left: 70rem !important;\n    margin-right: 70rem !important;\n  }\n\n  .mx-xl-142 {\n    margin-left: 70.5rem !important;\n    margin-right: 70.5rem !important;\n  }\n\n  .mx-xl-143 {\n    margin-left: 71rem !important;\n    margin-right: 71rem !important;\n  }\n\n  .mx-xl-144 {\n    margin-left: 71.5rem !important;\n    margin-right: 71.5rem !important;\n  }\n\n  .mx-xl-145 {\n    margin-left: 72rem !important;\n    margin-right: 72rem !important;\n  }\n\n  .mx-xl-146 {\n    margin-left: 72.5rem !important;\n    margin-right: 72.5rem !important;\n  }\n\n  .mx-xl-147 {\n    margin-left: 73rem !important;\n    margin-right: 73rem !important;\n  }\n\n  .mx-xl-148 {\n    margin-left: 73.5rem !important;\n    margin-right: 73.5rem !important;\n  }\n\n  .mx-xl-149 {\n    margin-left: 74rem !important;\n    margin-right: 74rem !important;\n  }\n\n  .mx-xl-150 {\n    margin-left: 74.5rem !important;\n    margin-right: 74.5rem !important;\n  }\n\n  .mx-xl-151 {\n    margin-left: 75rem !important;\n    margin-right: 75rem !important;\n  }\n\n  .mx-xl-152 {\n    margin-left: 75.5rem !important;\n    margin-right: 75.5rem !important;\n  }\n\n  .mx-xl-153 {\n    margin-left: 76rem !important;\n    margin-right: 76rem !important;\n  }\n\n  .mx-xl-154 {\n    margin-left: 76.5rem !important;\n    margin-right: 76.5rem !important;\n  }\n\n  .mx-xl-155 {\n    margin-left: 77rem !important;\n    margin-right: 77rem !important;\n  }\n\n  .mx-xl-156 {\n    margin-left: 77.5rem !important;\n    margin-right: 77.5rem !important;\n  }\n\n  .mx-xl-157 {\n    margin-left: 78rem !important;\n    margin-right: 78rem !important;\n  }\n\n  .mx-xl-158 {\n    margin-left: 78.5rem !important;\n    margin-right: 78.5rem !important;\n  }\n\n  .mx-xl-159 {\n    margin-left: 79rem !important;\n    margin-right: 79rem !important;\n  }\n\n  .mx-xl-160 {\n    margin-left: 79.5rem !important;\n    margin-right: 79.5rem !important;\n  }\n\n  .my-xl-0 {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem !important;\n  }\n\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xl-5 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xl-6 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xl-7 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xl-8 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xl-9 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xl-10 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xl-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xl-12 {\n    margin-top: 5.5rem !important;\n    margin-bottom: 5.5rem !important;\n  }\n\n  .my-xl-13 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n\n  .my-xl-14 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n\n  .my-xl-15 {\n    margin-top: 7rem !important;\n    margin-bottom: 7rem !important;\n  }\n\n  .my-xl-16 {\n    margin-top: 7.5rem !important;\n    margin-bottom: 7.5rem !important;\n  }\n\n  .my-xl-17 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n\n  .my-xl-18 {\n    margin-top: 8.5rem !important;\n    margin-bottom: 8.5rem !important;\n  }\n\n  .my-xl-19 {\n    margin-top: 9rem !important;\n    margin-bottom: 9rem !important;\n  }\n\n  .my-xl-20 {\n    margin-top: 9.5rem !important;\n    margin-bottom: 9.5rem !important;\n  }\n\n  .my-xl-21 {\n    margin-top: 10rem !important;\n    margin-bottom: 10rem !important;\n  }\n\n  .my-xl-22 {\n    margin-top: 10.5rem !important;\n    margin-bottom: 10.5rem !important;\n  }\n\n  .my-xl-23 {\n    margin-top: 11rem !important;\n    margin-bottom: 11rem !important;\n  }\n\n  .my-xl-24 {\n    margin-top: 11.5rem !important;\n    margin-bottom: 11.5rem !important;\n  }\n\n  .my-xl-25 {\n    margin-top: 12rem !important;\n    margin-bottom: 12rem !important;\n  }\n\n  .my-xl-26 {\n    margin-top: 12.5rem !important;\n    margin-bottom: 12.5rem !important;\n  }\n\n  .my-xl-27 {\n    margin-top: 13rem !important;\n    margin-bottom: 13rem !important;\n  }\n\n  .my-xl-28 {\n    margin-top: 13.5rem !important;\n    margin-bottom: 13.5rem !important;\n  }\n\n  .my-xl-29 {\n    margin-top: 14rem !important;\n    margin-bottom: 14rem !important;\n  }\n\n  .my-xl-30 {\n    margin-top: 14.5rem !important;\n    margin-bottom: 14.5rem !important;\n  }\n\n  .my-xl-31 {\n    margin-top: 15rem !important;\n    margin-bottom: 15rem !important;\n  }\n\n  .my-xl-32 {\n    margin-top: 15.5rem !important;\n    margin-bottom: 15.5rem !important;\n  }\n\n  .my-xl-33 {\n    margin-top: 16rem !important;\n    margin-bottom: 16rem !important;\n  }\n\n  .my-xl-34 {\n    margin-top: 16.5rem !important;\n    margin-bottom: 16.5rem !important;\n  }\n\n  .my-xl-35 {\n    margin-top: 17rem !important;\n    margin-bottom: 17rem !important;\n  }\n\n  .my-xl-36 {\n    margin-top: 17.5rem !important;\n    margin-bottom: 17.5rem !important;\n  }\n\n  .my-xl-37 {\n    margin-top: 18rem !important;\n    margin-bottom: 18rem !important;\n  }\n\n  .my-xl-38 {\n    margin-top: 18.5rem !important;\n    margin-bottom: 18.5rem !important;\n  }\n\n  .my-xl-39 {\n    margin-top: 19rem !important;\n    margin-bottom: 19rem !important;\n  }\n\n  .my-xl-40 {\n    margin-top: 19.5rem !important;\n    margin-bottom: 19.5rem !important;\n  }\n\n  .my-xl-41 {\n    margin-top: 20rem !important;\n    margin-bottom: 20rem !important;\n  }\n\n  .my-xl-42 {\n    margin-top: 20.5rem !important;\n    margin-bottom: 20.5rem !important;\n  }\n\n  .my-xl-43 {\n    margin-top: 21rem !important;\n    margin-bottom: 21rem !important;\n  }\n\n  .my-xl-44 {\n    margin-top: 21.5rem !important;\n    margin-bottom: 21.5rem !important;\n  }\n\n  .my-xl-45 {\n    margin-top: 22rem !important;\n    margin-bottom: 22rem !important;\n  }\n\n  .my-xl-46 {\n    margin-top: 22.5rem !important;\n    margin-bottom: 22.5rem !important;\n  }\n\n  .my-xl-47 {\n    margin-top: 23rem !important;\n    margin-bottom: 23rem !important;\n  }\n\n  .my-xl-48 {\n    margin-top: 23.5rem !important;\n    margin-bottom: 23.5rem !important;\n  }\n\n  .my-xl-49 {\n    margin-top: 24rem !important;\n    margin-bottom: 24rem !important;\n  }\n\n  .my-xl-50 {\n    margin-top: 24.5rem !important;\n    margin-bottom: 24.5rem !important;\n  }\n\n  .my-xl-51 {\n    margin-top: 25rem !important;\n    margin-bottom: 25rem !important;\n  }\n\n  .my-xl-52 {\n    margin-top: 25.5rem !important;\n    margin-bottom: 25.5rem !important;\n  }\n\n  .my-xl-53 {\n    margin-top: 26rem !important;\n    margin-bottom: 26rem !important;\n  }\n\n  .my-xl-54 {\n    margin-top: 26.5rem !important;\n    margin-bottom: 26.5rem !important;\n  }\n\n  .my-xl-55 {\n    margin-top: 27rem !important;\n    margin-bottom: 27rem !important;\n  }\n\n  .my-xl-56 {\n    margin-top: 27.5rem !important;\n    margin-bottom: 27.5rem !important;\n  }\n\n  .my-xl-57 {\n    margin-top: 28rem !important;\n    margin-bottom: 28rem !important;\n  }\n\n  .my-xl-58 {\n    margin-top: 28.5rem !important;\n    margin-bottom: 28.5rem !important;\n  }\n\n  .my-xl-59 {\n    margin-top: 29rem !important;\n    margin-bottom: 29rem !important;\n  }\n\n  .my-xl-60 {\n    margin-top: 29.5rem !important;\n    margin-bottom: 29.5rem !important;\n  }\n\n  .my-xl-61 {\n    margin-top: 30rem !important;\n    margin-bottom: 30rem !important;\n  }\n\n  .my-xl-62 {\n    margin-top: 30.5rem !important;\n    margin-bottom: 30.5rem !important;\n  }\n\n  .my-xl-63 {\n    margin-top: 31rem !important;\n    margin-bottom: 31rem !important;\n  }\n\n  .my-xl-64 {\n    margin-top: 31.5rem !important;\n    margin-bottom: 31.5rem !important;\n  }\n\n  .my-xl-65 {\n    margin-top: 32rem !important;\n    margin-bottom: 32rem !important;\n  }\n\n  .my-xl-66 {\n    margin-top: 32.5rem !important;\n    margin-bottom: 32.5rem !important;\n  }\n\n  .my-xl-67 {\n    margin-top: 33rem !important;\n    margin-bottom: 33rem !important;\n  }\n\n  .my-xl-68 {\n    margin-top: 33.5rem !important;\n    margin-bottom: 33.5rem !important;\n  }\n\n  .my-xl-69 {\n    margin-top: 34rem !important;\n    margin-bottom: 34rem !important;\n  }\n\n  .my-xl-70 {\n    margin-top: 34.5rem !important;\n    margin-bottom: 34.5rem !important;\n  }\n\n  .my-xl-71 {\n    margin-top: 35rem !important;\n    margin-bottom: 35rem !important;\n  }\n\n  .my-xl-72 {\n    margin-top: 35.5rem !important;\n    margin-bottom: 35.5rem !important;\n  }\n\n  .my-xl-73 {\n    margin-top: 36rem !important;\n    margin-bottom: 36rem !important;\n  }\n\n  .my-xl-74 {\n    margin-top: 36.5rem !important;\n    margin-bottom: 36.5rem !important;\n  }\n\n  .my-xl-75 {\n    margin-top: 37rem !important;\n    margin-bottom: 37rem !important;\n  }\n\n  .my-xl-76 {\n    margin-top: 37.5rem !important;\n    margin-bottom: 37.5rem !important;\n  }\n\n  .my-xl-77 {\n    margin-top: 38rem !important;\n    margin-bottom: 38rem !important;\n  }\n\n  .my-xl-78 {\n    margin-top: 38.5rem !important;\n    margin-bottom: 38.5rem !important;\n  }\n\n  .my-xl-79 {\n    margin-top: 39rem !important;\n    margin-bottom: 39rem !important;\n  }\n\n  .my-xl-80 {\n    margin-top: 39.5rem !important;\n    margin-bottom: 39.5rem !important;\n  }\n\n  .my-xl-81 {\n    margin-top: 40rem !important;\n    margin-bottom: 40rem !important;\n  }\n\n  .my-xl-82 {\n    margin-top: 40.5rem !important;\n    margin-bottom: 40.5rem !important;\n  }\n\n  .my-xl-83 {\n    margin-top: 41rem !important;\n    margin-bottom: 41rem !important;\n  }\n\n  .my-xl-84 {\n    margin-top: 41.5rem !important;\n    margin-bottom: 41.5rem !important;\n  }\n\n  .my-xl-85 {\n    margin-top: 42rem !important;\n    margin-bottom: 42rem !important;\n  }\n\n  .my-xl-86 {\n    margin-top: 42.5rem !important;\n    margin-bottom: 42.5rem !important;\n  }\n\n  .my-xl-87 {\n    margin-top: 43rem !important;\n    margin-bottom: 43rem !important;\n  }\n\n  .my-xl-88 {\n    margin-top: 43.5rem !important;\n    margin-bottom: 43.5rem !important;\n  }\n\n  .my-xl-89 {\n    margin-top: 44rem !important;\n    margin-bottom: 44rem !important;\n  }\n\n  .my-xl-90 {\n    margin-top: 44.5rem !important;\n    margin-bottom: 44.5rem !important;\n  }\n\n  .my-xl-91 {\n    margin-top: 45rem !important;\n    margin-bottom: 45rem !important;\n  }\n\n  .my-xl-92 {\n    margin-top: 45.5rem !important;\n    margin-bottom: 45.5rem !important;\n  }\n\n  .my-xl-93 {\n    margin-top: 46rem !important;\n    margin-bottom: 46rem !important;\n  }\n\n  .my-xl-94 {\n    margin-top: 46.5rem !important;\n    margin-bottom: 46.5rem !important;\n  }\n\n  .my-xl-95 {\n    margin-top: 47rem !important;\n    margin-bottom: 47rem !important;\n  }\n\n  .my-xl-96 {\n    margin-top: 47.5rem !important;\n    margin-bottom: 47.5rem !important;\n  }\n\n  .my-xl-97 {\n    margin-top: 48rem !important;\n    margin-bottom: 48rem !important;\n  }\n\n  .my-xl-98 {\n    margin-top: 48.5rem !important;\n    margin-bottom: 48.5rem !important;\n  }\n\n  .my-xl-99 {\n    margin-top: 49rem !important;\n    margin-bottom: 49rem !important;\n  }\n\n  .my-xl-100 {\n    margin-top: 49.5rem !important;\n    margin-bottom: 49.5rem !important;\n  }\n\n  .my-xl-101 {\n    margin-top: 50rem !important;\n    margin-bottom: 50rem !important;\n  }\n\n  .my-xl-102 {\n    margin-top: 50.5rem !important;\n    margin-bottom: 50.5rem !important;\n  }\n\n  .my-xl-103 {\n    margin-top: 51rem !important;\n    margin-bottom: 51rem !important;\n  }\n\n  .my-xl-104 {\n    margin-top: 51.5rem !important;\n    margin-bottom: 51.5rem !important;\n  }\n\n  .my-xl-105 {\n    margin-top: 52rem !important;\n    margin-bottom: 52rem !important;\n  }\n\n  .my-xl-106 {\n    margin-top: 52.5rem !important;\n    margin-bottom: 52.5rem !important;\n  }\n\n  .my-xl-107 {\n    margin-top: 53rem !important;\n    margin-bottom: 53rem !important;\n  }\n\n  .my-xl-108 {\n    margin-top: 53.5rem !important;\n    margin-bottom: 53.5rem !important;\n  }\n\n  .my-xl-109 {\n    margin-top: 54rem !important;\n    margin-bottom: 54rem !important;\n  }\n\n  .my-xl-110 {\n    margin-top: 54.5rem !important;\n    margin-bottom: 54.5rem !important;\n  }\n\n  .my-xl-111 {\n    margin-top: 55rem !important;\n    margin-bottom: 55rem !important;\n  }\n\n  .my-xl-112 {\n    margin-top: 55.5rem !important;\n    margin-bottom: 55.5rem !important;\n  }\n\n  .my-xl-113 {\n    margin-top: 56rem !important;\n    margin-bottom: 56rem !important;\n  }\n\n  .my-xl-114 {\n    margin-top: 56.5rem !important;\n    margin-bottom: 56.5rem !important;\n  }\n\n  .my-xl-115 {\n    margin-top: 57rem !important;\n    margin-bottom: 57rem !important;\n  }\n\n  .my-xl-116 {\n    margin-top: 57.5rem !important;\n    margin-bottom: 57.5rem !important;\n  }\n\n  .my-xl-117 {\n    margin-top: 58rem !important;\n    margin-bottom: 58rem !important;\n  }\n\n  .my-xl-118 {\n    margin-top: 58.5rem !important;\n    margin-bottom: 58.5rem !important;\n  }\n\n  .my-xl-119 {\n    margin-top: 59rem !important;\n    margin-bottom: 59rem !important;\n  }\n\n  .my-xl-120 {\n    margin-top: 59.5rem !important;\n    margin-bottom: 59.5rem !important;\n  }\n\n  .my-xl-121 {\n    margin-top: 60rem !important;\n    margin-bottom: 60rem !important;\n  }\n\n  .my-xl-122 {\n    margin-top: 60.5rem !important;\n    margin-bottom: 60.5rem !important;\n  }\n\n  .my-xl-123 {\n    margin-top: 61rem !important;\n    margin-bottom: 61rem !important;\n  }\n\n  .my-xl-124 {\n    margin-top: 61.5rem !important;\n    margin-bottom: 61.5rem !important;\n  }\n\n  .my-xl-125 {\n    margin-top: 62rem !important;\n    margin-bottom: 62rem !important;\n  }\n\n  .my-xl-126 {\n    margin-top: 62.5rem !important;\n    margin-bottom: 62.5rem !important;\n  }\n\n  .my-xl-127 {\n    margin-top: 63rem !important;\n    margin-bottom: 63rem !important;\n  }\n\n  .my-xl-128 {\n    margin-top: 63.5rem !important;\n    margin-bottom: 63.5rem !important;\n  }\n\n  .my-xl-129 {\n    margin-top: 64rem !important;\n    margin-bottom: 64rem !important;\n  }\n\n  .my-xl-130 {\n    margin-top: 64.5rem !important;\n    margin-bottom: 64.5rem !important;\n  }\n\n  .my-xl-131 {\n    margin-top: 65rem !important;\n    margin-bottom: 65rem !important;\n  }\n\n  .my-xl-132 {\n    margin-top: 65.5rem !important;\n    margin-bottom: 65.5rem !important;\n  }\n\n  .my-xl-133 {\n    margin-top: 66rem !important;\n    margin-bottom: 66rem !important;\n  }\n\n  .my-xl-134 {\n    margin-top: 66.5rem !important;\n    margin-bottom: 66.5rem !important;\n  }\n\n  .my-xl-135 {\n    margin-top: 67rem !important;\n    margin-bottom: 67rem !important;\n  }\n\n  .my-xl-136 {\n    margin-top: 67.5rem !important;\n    margin-bottom: 67.5rem !important;\n  }\n\n  .my-xl-137 {\n    margin-top: 68rem !important;\n    margin-bottom: 68rem !important;\n  }\n\n  .my-xl-138 {\n    margin-top: 68.5rem !important;\n    margin-bottom: 68.5rem !important;\n  }\n\n  .my-xl-139 {\n    margin-top: 69rem !important;\n    margin-bottom: 69rem !important;\n  }\n\n  .my-xl-140 {\n    margin-top: 69.5rem !important;\n    margin-bottom: 69.5rem !important;\n  }\n\n  .my-xl-141 {\n    margin-top: 70rem !important;\n    margin-bottom: 70rem !important;\n  }\n\n  .my-xl-142 {\n    margin-top: 70.5rem !important;\n    margin-bottom: 70.5rem !important;\n  }\n\n  .my-xl-143 {\n    margin-top: 71rem !important;\n    margin-bottom: 71rem !important;\n  }\n\n  .my-xl-144 {\n    margin-top: 71.5rem !important;\n    margin-bottom: 71.5rem !important;\n  }\n\n  .my-xl-145 {\n    margin-top: 72rem !important;\n    margin-bottom: 72rem !important;\n  }\n\n  .my-xl-146 {\n    margin-top: 72.5rem !important;\n    margin-bottom: 72.5rem !important;\n  }\n\n  .my-xl-147 {\n    margin-top: 73rem !important;\n    margin-bottom: 73rem !important;\n  }\n\n  .my-xl-148 {\n    margin-top: 73.5rem !important;\n    margin-bottom: 73.5rem !important;\n  }\n\n  .my-xl-149 {\n    margin-top: 74rem !important;\n    margin-bottom: 74rem !important;\n  }\n\n  .my-xl-150 {\n    margin-top: 74.5rem !important;\n    margin-bottom: 74.5rem !important;\n  }\n\n  .my-xl-151 {\n    margin-top: 75rem !important;\n    margin-bottom: 75rem !important;\n  }\n\n  .my-xl-152 {\n    margin-top: 75.5rem !important;\n    margin-bottom: 75.5rem !important;\n  }\n\n  .my-xl-153 {\n    margin-top: 76rem !important;\n    margin-bottom: 76rem !important;\n  }\n\n  .my-xl-154 {\n    margin-top: 76.5rem !important;\n    margin-bottom: 76.5rem !important;\n  }\n\n  .my-xl-155 {\n    margin-top: 77rem !important;\n    margin-bottom: 77rem !important;\n  }\n\n  .my-xl-156 {\n    margin-top: 77.5rem !important;\n    margin-bottom: 77.5rem !important;\n  }\n\n  .my-xl-157 {\n    margin-top: 78rem !important;\n    margin-bottom: 78rem !important;\n  }\n\n  .my-xl-158 {\n    margin-top: 78.5rem !important;\n    margin-bottom: 78.5rem !important;\n  }\n\n  .my-xl-159 {\n    margin-top: 79rem !important;\n    margin-bottom: 79rem !important;\n  }\n\n  .my-xl-160 {\n    margin-top: 79.5rem !important;\n    margin-bottom: 79.5rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .m-xxl-0 {\n    margin: 0rem !important;\n  }\n\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xxl-5 {\n    margin: 2rem !important;\n  }\n\n  .m-xxl-6 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xxl-7 {\n    margin: 3rem !important;\n  }\n\n  .m-xxl-8 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xxl-9 {\n    margin: 4rem !important;\n  }\n\n  .m-xxl-10 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xxl-11 {\n    margin: 5rem !important;\n  }\n\n  .m-xxl-12 {\n    margin: 5.5rem !important;\n  }\n\n  .m-xxl-13 {\n    margin: 6rem !important;\n  }\n\n  .m-xxl-14 {\n    margin: 6.5rem !important;\n  }\n\n  .m-xxl-15 {\n    margin: 7rem !important;\n  }\n\n  .m-xxl-16 {\n    margin: 7.5rem !important;\n  }\n\n  .m-xxl-17 {\n    margin: 8rem !important;\n  }\n\n  .m-xxl-18 {\n    margin: 8.5rem !important;\n  }\n\n  .m-xxl-19 {\n    margin: 9rem !important;\n  }\n\n  .m-xxl-20 {\n    margin: 9.5rem !important;\n  }\n\n  .m-xxl-21 {\n    margin: 10rem !important;\n  }\n\n  .m-xxl-22 {\n    margin: 10.5rem !important;\n  }\n\n  .m-xxl-23 {\n    margin: 11rem !important;\n  }\n\n  .m-xxl-24 {\n    margin: 11.5rem !important;\n  }\n\n  .m-xxl-25 {\n    margin: 12rem !important;\n  }\n\n  .m-xxl-26 {\n    margin: 12.5rem !important;\n  }\n\n  .m-xxl-27 {\n    margin: 13rem !important;\n  }\n\n  .m-xxl-28 {\n    margin: 13.5rem !important;\n  }\n\n  .m-xxl-29 {\n    margin: 14rem !important;\n  }\n\n  .m-xxl-30 {\n    margin: 14.5rem !important;\n  }\n\n  .m-xxl-31 {\n    margin: 15rem !important;\n  }\n\n  .m-xxl-32 {\n    margin: 15.5rem !important;\n  }\n\n  .m-xxl-33 {\n    margin: 16rem !important;\n  }\n\n  .m-xxl-34 {\n    margin: 16.5rem !important;\n  }\n\n  .m-xxl-35 {\n    margin: 17rem !important;\n  }\n\n  .m-xxl-36 {\n    margin: 17.5rem !important;\n  }\n\n  .m-xxl-37 {\n    margin: 18rem !important;\n  }\n\n  .m-xxl-38 {\n    margin: 18.5rem !important;\n  }\n\n  .m-xxl-39 {\n    margin: 19rem !important;\n  }\n\n  .m-xxl-40 {\n    margin: 19.5rem !important;\n  }\n\n  .m-xxl-41 {\n    margin: 20rem !important;\n  }\n\n  .m-xxl-42 {\n    margin: 20.5rem !important;\n  }\n\n  .m-xxl-43 {\n    margin: 21rem !important;\n  }\n\n  .m-xxl-44 {\n    margin: 21.5rem !important;\n  }\n\n  .m-xxl-45 {\n    margin: 22rem !important;\n  }\n\n  .m-xxl-46 {\n    margin: 22.5rem !important;\n  }\n\n  .m-xxl-47 {\n    margin: 23rem !important;\n  }\n\n  .m-xxl-48 {\n    margin: 23.5rem !important;\n  }\n\n  .m-xxl-49 {\n    margin: 24rem !important;\n  }\n\n  .m-xxl-50 {\n    margin: 24.5rem !important;\n  }\n\n  .m-xxl-51 {\n    margin: 25rem !important;\n  }\n\n  .m-xxl-52 {\n    margin: 25.5rem !important;\n  }\n\n  .m-xxl-53 {\n    margin: 26rem !important;\n  }\n\n  .m-xxl-54 {\n    margin: 26.5rem !important;\n  }\n\n  .m-xxl-55 {\n    margin: 27rem !important;\n  }\n\n  .m-xxl-56 {\n    margin: 27.5rem !important;\n  }\n\n  .m-xxl-57 {\n    margin: 28rem !important;\n  }\n\n  .m-xxl-58 {\n    margin: 28.5rem !important;\n  }\n\n  .m-xxl-59 {\n    margin: 29rem !important;\n  }\n\n  .m-xxl-60 {\n    margin: 29.5rem !important;\n  }\n\n  .m-xxl-61 {\n    margin: 30rem !important;\n  }\n\n  .m-xxl-62 {\n    margin: 30.5rem !important;\n  }\n\n  .m-xxl-63 {\n    margin: 31rem !important;\n  }\n\n  .m-xxl-64 {\n    margin: 31.5rem !important;\n  }\n\n  .m-xxl-65 {\n    margin: 32rem !important;\n  }\n\n  .m-xxl-66 {\n    margin: 32.5rem !important;\n  }\n\n  .m-xxl-67 {\n    margin: 33rem !important;\n  }\n\n  .m-xxl-68 {\n    margin: 33.5rem !important;\n  }\n\n  .m-xxl-69 {\n    margin: 34rem !important;\n  }\n\n  .m-xxl-70 {\n    margin: 34.5rem !important;\n  }\n\n  .m-xxl-71 {\n    margin: 35rem !important;\n  }\n\n  .m-xxl-72 {\n    margin: 35.5rem !important;\n  }\n\n  .m-xxl-73 {\n    margin: 36rem !important;\n  }\n\n  .m-xxl-74 {\n    margin: 36.5rem !important;\n  }\n\n  .m-xxl-75 {\n    margin: 37rem !important;\n  }\n\n  .m-xxl-76 {\n    margin: 37.5rem !important;\n  }\n\n  .m-xxl-77 {\n    margin: 38rem !important;\n  }\n\n  .m-xxl-78 {\n    margin: 38.5rem !important;\n  }\n\n  .m-xxl-79 {\n    margin: 39rem !important;\n  }\n\n  .m-xxl-80 {\n    margin: 39.5rem !important;\n  }\n\n  .m-xxl-81 {\n    margin: 40rem !important;\n  }\n\n  .m-xxl-82 {\n    margin: 40.5rem !important;\n  }\n\n  .m-xxl-83 {\n    margin: 41rem !important;\n  }\n\n  .m-xxl-84 {\n    margin: 41.5rem !important;\n  }\n\n  .m-xxl-85 {\n    margin: 42rem !important;\n  }\n\n  .m-xxl-86 {\n    margin: 42.5rem !important;\n  }\n\n  .m-xxl-87 {\n    margin: 43rem !important;\n  }\n\n  .m-xxl-88 {\n    margin: 43.5rem !important;\n  }\n\n  .m-xxl-89 {\n    margin: 44rem !important;\n  }\n\n  .m-xxl-90 {\n    margin: 44.5rem !important;\n  }\n\n  .m-xxl-91 {\n    margin: 45rem !important;\n  }\n\n  .m-xxl-92 {\n    margin: 45.5rem !important;\n  }\n\n  .m-xxl-93 {\n    margin: 46rem !important;\n  }\n\n  .m-xxl-94 {\n    margin: 46.5rem !important;\n  }\n\n  .m-xxl-95 {\n    margin: 47rem !important;\n  }\n\n  .m-xxl-96 {\n    margin: 47.5rem !important;\n  }\n\n  .m-xxl-97 {\n    margin: 48rem !important;\n  }\n\n  .m-xxl-98 {\n    margin: 48.5rem !important;\n  }\n\n  .m-xxl-99 {\n    margin: 49rem !important;\n  }\n\n  .m-xxl-100 {\n    margin: 49.5rem !important;\n  }\n\n  .m-xxl-101 {\n    margin: 50rem !important;\n  }\n\n  .m-xxl-102 {\n    margin: 50.5rem !important;\n  }\n\n  .m-xxl-103 {\n    margin: 51rem !important;\n  }\n\n  .m-xxl-104 {\n    margin: 51.5rem !important;\n  }\n\n  .m-xxl-105 {\n    margin: 52rem !important;\n  }\n\n  .m-xxl-106 {\n    margin: 52.5rem !important;\n  }\n\n  .m-xxl-107 {\n    margin: 53rem !important;\n  }\n\n  .m-xxl-108 {\n    margin: 53.5rem !important;\n  }\n\n  .m-xxl-109 {\n    margin: 54rem !important;\n  }\n\n  .m-xxl-110 {\n    margin: 54.5rem !important;\n  }\n\n  .m-xxl-111 {\n    margin: 55rem !important;\n  }\n\n  .m-xxl-112 {\n    margin: 55.5rem !important;\n  }\n\n  .m-xxl-113 {\n    margin: 56rem !important;\n  }\n\n  .m-xxl-114 {\n    margin: 56.5rem !important;\n  }\n\n  .m-xxl-115 {\n    margin: 57rem !important;\n  }\n\n  .m-xxl-116 {\n    margin: 57.5rem !important;\n  }\n\n  .m-xxl-117 {\n    margin: 58rem !important;\n  }\n\n  .m-xxl-118 {\n    margin: 58.5rem !important;\n  }\n\n  .m-xxl-119 {\n    margin: 59rem !important;\n  }\n\n  .m-xxl-120 {\n    margin: 59.5rem !important;\n  }\n\n  .m-xxl-121 {\n    margin: 60rem !important;\n  }\n\n  .m-xxl-122 {\n    margin: 60.5rem !important;\n  }\n\n  .m-xxl-123 {\n    margin: 61rem !important;\n  }\n\n  .m-xxl-124 {\n    margin: 61.5rem !important;\n  }\n\n  .m-xxl-125 {\n    margin: 62rem !important;\n  }\n\n  .m-xxl-126 {\n    margin: 62.5rem !important;\n  }\n\n  .m-xxl-127 {\n    margin: 63rem !important;\n  }\n\n  .m-xxl-128 {\n    margin: 63.5rem !important;\n  }\n\n  .m-xxl-129 {\n    margin: 64rem !important;\n  }\n\n  .m-xxl-130 {\n    margin: 64.5rem !important;\n  }\n\n  .m-xxl-131 {\n    margin: 65rem !important;\n  }\n\n  .m-xxl-132 {\n    margin: 65.5rem !important;\n  }\n\n  .m-xxl-133 {\n    margin: 66rem !important;\n  }\n\n  .m-xxl-134 {\n    margin: 66.5rem !important;\n  }\n\n  .m-xxl-135 {\n    margin: 67rem !important;\n  }\n\n  .m-xxl-136 {\n    margin: 67.5rem !important;\n  }\n\n  .m-xxl-137 {\n    margin: 68rem !important;\n  }\n\n  .m-xxl-138 {\n    margin: 68.5rem !important;\n  }\n\n  .m-xxl-139 {\n    margin: 69rem !important;\n  }\n\n  .m-xxl-140 {\n    margin: 69.5rem !important;\n  }\n\n  .m-xxl-141 {\n    margin: 70rem !important;\n  }\n\n  .m-xxl-142 {\n    margin: 70.5rem !important;\n  }\n\n  .m-xxl-143 {\n    margin: 71rem !important;\n  }\n\n  .m-xxl-144 {\n    margin: 71.5rem !important;\n  }\n\n  .m-xxl-145 {\n    margin: 72rem !important;\n  }\n\n  .m-xxl-146 {\n    margin: 72.5rem !important;\n  }\n\n  .m-xxl-147 {\n    margin: 73rem !important;\n  }\n\n  .m-xxl-148 {\n    margin: 73.5rem !important;\n  }\n\n  .m-xxl-149 {\n    margin: 74rem !important;\n  }\n\n  .m-xxl-150 {\n    margin: 74.5rem !important;\n  }\n\n  .m-xxl-151 {\n    margin: 75rem !important;\n  }\n\n  .m-xxl-152 {\n    margin: 75.5rem !important;\n  }\n\n  .m-xxl-153 {\n    margin: 76rem !important;\n  }\n\n  .m-xxl-154 {\n    margin: 76.5rem !important;\n  }\n\n  .m-xxl-155 {\n    margin: 77rem !important;\n  }\n\n  .m-xxl-156 {\n    margin: 77.5rem !important;\n  }\n\n  .m-xxl-157 {\n    margin: 78rem !important;\n  }\n\n  .m-xxl-158 {\n    margin: 78.5rem !important;\n  }\n\n  .m-xxl-159 {\n    margin: 79rem !important;\n  }\n\n  .m-xxl-160 {\n    margin: 79.5rem !important;\n  }\n\n  .mt-xxl-0 {\n    margin-top: 0rem !important;\n  }\n\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xxl-5 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xxl-6 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xxl-7 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xxl-8 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xxl-9 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xxl-10 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xxl-11 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xxl-12 {\n    margin-top: 5.5rem !important;\n  }\n\n  .mt-xxl-13 {\n    margin-top: 6rem !important;\n  }\n\n  .mt-xxl-14 {\n    margin-top: 6.5rem !important;\n  }\n\n  .mt-xxl-15 {\n    margin-top: 7rem !important;\n  }\n\n  .mt-xxl-16 {\n    margin-top: 7.5rem !important;\n  }\n\n  .mt-xxl-17 {\n    margin-top: 8rem !important;\n  }\n\n  .mt-xxl-18 {\n    margin-top: 8.5rem !important;\n  }\n\n  .mt-xxl-19 {\n    margin-top: 9rem !important;\n  }\n\n  .mt-xxl-20 {\n    margin-top: 9.5rem !important;\n  }\n\n  .mt-xxl-21 {\n    margin-top: 10rem !important;\n  }\n\n  .mt-xxl-22 {\n    margin-top: 10.5rem !important;\n  }\n\n  .mt-xxl-23 {\n    margin-top: 11rem !important;\n  }\n\n  .mt-xxl-24 {\n    margin-top: 11.5rem !important;\n  }\n\n  .mt-xxl-25 {\n    margin-top: 12rem !important;\n  }\n\n  .mt-xxl-26 {\n    margin-top: 12.5rem !important;\n  }\n\n  .mt-xxl-27 {\n    margin-top: 13rem !important;\n  }\n\n  .mt-xxl-28 {\n    margin-top: 13.5rem !important;\n  }\n\n  .mt-xxl-29 {\n    margin-top: 14rem !important;\n  }\n\n  .mt-xxl-30 {\n    margin-top: 14.5rem !important;\n  }\n\n  .mt-xxl-31 {\n    margin-top: 15rem !important;\n  }\n\n  .mt-xxl-32 {\n    margin-top: 15.5rem !important;\n  }\n\n  .mt-xxl-33 {\n    margin-top: 16rem !important;\n  }\n\n  .mt-xxl-34 {\n    margin-top: 16.5rem !important;\n  }\n\n  .mt-xxl-35 {\n    margin-top: 17rem !important;\n  }\n\n  .mt-xxl-36 {\n    margin-top: 17.5rem !important;\n  }\n\n  .mt-xxl-37 {\n    margin-top: 18rem !important;\n  }\n\n  .mt-xxl-38 {\n    margin-top: 18.5rem !important;\n  }\n\n  .mt-xxl-39 {\n    margin-top: 19rem !important;\n  }\n\n  .mt-xxl-40 {\n    margin-top: 19.5rem !important;\n  }\n\n  .mt-xxl-41 {\n    margin-top: 20rem !important;\n  }\n\n  .mt-xxl-42 {\n    margin-top: 20.5rem !important;\n  }\n\n  .mt-xxl-43 {\n    margin-top: 21rem !important;\n  }\n\n  .mt-xxl-44 {\n    margin-top: 21.5rem !important;\n  }\n\n  .mt-xxl-45 {\n    margin-top: 22rem !important;\n  }\n\n  .mt-xxl-46 {\n    margin-top: 22.5rem !important;\n  }\n\n  .mt-xxl-47 {\n    margin-top: 23rem !important;\n  }\n\n  .mt-xxl-48 {\n    margin-top: 23.5rem !important;\n  }\n\n  .mt-xxl-49 {\n    margin-top: 24rem !important;\n  }\n\n  .mt-xxl-50 {\n    margin-top: 24.5rem !important;\n  }\n\n  .mt-xxl-51 {\n    margin-top: 25rem !important;\n  }\n\n  .mt-xxl-52 {\n    margin-top: 25.5rem !important;\n  }\n\n  .mt-xxl-53 {\n    margin-top: 26rem !important;\n  }\n\n  .mt-xxl-54 {\n    margin-top: 26.5rem !important;\n  }\n\n  .mt-xxl-55 {\n    margin-top: 27rem !important;\n  }\n\n  .mt-xxl-56 {\n    margin-top: 27.5rem !important;\n  }\n\n  .mt-xxl-57 {\n    margin-top: 28rem !important;\n  }\n\n  .mt-xxl-58 {\n    margin-top: 28.5rem !important;\n  }\n\n  .mt-xxl-59 {\n    margin-top: 29rem !important;\n  }\n\n  .mt-xxl-60 {\n    margin-top: 29.5rem !important;\n  }\n\n  .mt-xxl-61 {\n    margin-top: 30rem !important;\n  }\n\n  .mt-xxl-62 {\n    margin-top: 30.5rem !important;\n  }\n\n  .mt-xxl-63 {\n    margin-top: 31rem !important;\n  }\n\n  .mt-xxl-64 {\n    margin-top: 31.5rem !important;\n  }\n\n  .mt-xxl-65 {\n    margin-top: 32rem !important;\n  }\n\n  .mt-xxl-66 {\n    margin-top: 32.5rem !important;\n  }\n\n  .mt-xxl-67 {\n    margin-top: 33rem !important;\n  }\n\n  .mt-xxl-68 {\n    margin-top: 33.5rem !important;\n  }\n\n  .mt-xxl-69 {\n    margin-top: 34rem !important;\n  }\n\n  .mt-xxl-70 {\n    margin-top: 34.5rem !important;\n  }\n\n  .mt-xxl-71 {\n    margin-top: 35rem !important;\n  }\n\n  .mt-xxl-72 {\n    margin-top: 35.5rem !important;\n  }\n\n  .mt-xxl-73 {\n    margin-top: 36rem !important;\n  }\n\n  .mt-xxl-74 {\n    margin-top: 36.5rem !important;\n  }\n\n  .mt-xxl-75 {\n    margin-top: 37rem !important;\n  }\n\n  .mt-xxl-76 {\n    margin-top: 37.5rem !important;\n  }\n\n  .mt-xxl-77 {\n    margin-top: 38rem !important;\n  }\n\n  .mt-xxl-78 {\n    margin-top: 38.5rem !important;\n  }\n\n  .mt-xxl-79 {\n    margin-top: 39rem !important;\n  }\n\n  .mt-xxl-80 {\n    margin-top: 39.5rem !important;\n  }\n\n  .mt-xxl-81 {\n    margin-top: 40rem !important;\n  }\n\n  .mt-xxl-82 {\n    margin-top: 40.5rem !important;\n  }\n\n  .mt-xxl-83 {\n    margin-top: 41rem !important;\n  }\n\n  .mt-xxl-84 {\n    margin-top: 41.5rem !important;\n  }\n\n  .mt-xxl-85 {\n    margin-top: 42rem !important;\n  }\n\n  .mt-xxl-86 {\n    margin-top: 42.5rem !important;\n  }\n\n  .mt-xxl-87 {\n    margin-top: 43rem !important;\n  }\n\n  .mt-xxl-88 {\n    margin-top: 43.5rem !important;\n  }\n\n  .mt-xxl-89 {\n    margin-top: 44rem !important;\n  }\n\n  .mt-xxl-90 {\n    margin-top: 44.5rem !important;\n  }\n\n  .mt-xxl-91 {\n    margin-top: 45rem !important;\n  }\n\n  .mt-xxl-92 {\n    margin-top: 45.5rem !important;\n  }\n\n  .mt-xxl-93 {\n    margin-top: 46rem !important;\n  }\n\n  .mt-xxl-94 {\n    margin-top: 46.5rem !important;\n  }\n\n  .mt-xxl-95 {\n    margin-top: 47rem !important;\n  }\n\n  .mt-xxl-96 {\n    margin-top: 47.5rem !important;\n  }\n\n  .mt-xxl-97 {\n    margin-top: 48rem !important;\n  }\n\n  .mt-xxl-98 {\n    margin-top: 48.5rem !important;\n  }\n\n  .mt-xxl-99 {\n    margin-top: 49rem !important;\n  }\n\n  .mt-xxl-100 {\n    margin-top: 49.5rem !important;\n  }\n\n  .mt-xxl-101 {\n    margin-top: 50rem !important;\n  }\n\n  .mt-xxl-102 {\n    margin-top: 50.5rem !important;\n  }\n\n  .mt-xxl-103 {\n    margin-top: 51rem !important;\n  }\n\n  .mt-xxl-104 {\n    margin-top: 51.5rem !important;\n  }\n\n  .mt-xxl-105 {\n    margin-top: 52rem !important;\n  }\n\n  .mt-xxl-106 {\n    margin-top: 52.5rem !important;\n  }\n\n  .mt-xxl-107 {\n    margin-top: 53rem !important;\n  }\n\n  .mt-xxl-108 {\n    margin-top: 53.5rem !important;\n  }\n\n  .mt-xxl-109 {\n    margin-top: 54rem !important;\n  }\n\n  .mt-xxl-110 {\n    margin-top: 54.5rem !important;\n  }\n\n  .mt-xxl-111 {\n    margin-top: 55rem !important;\n  }\n\n  .mt-xxl-112 {\n    margin-top: 55.5rem !important;\n  }\n\n  .mt-xxl-113 {\n    margin-top: 56rem !important;\n  }\n\n  .mt-xxl-114 {\n    margin-top: 56.5rem !important;\n  }\n\n  .mt-xxl-115 {\n    margin-top: 57rem !important;\n  }\n\n  .mt-xxl-116 {\n    margin-top: 57.5rem !important;\n  }\n\n  .mt-xxl-117 {\n    margin-top: 58rem !important;\n  }\n\n  .mt-xxl-118 {\n    margin-top: 58.5rem !important;\n  }\n\n  .mt-xxl-119 {\n    margin-top: 59rem !important;\n  }\n\n  .mt-xxl-120 {\n    margin-top: 59.5rem !important;\n  }\n\n  .mt-xxl-121 {\n    margin-top: 60rem !important;\n  }\n\n  .mt-xxl-122 {\n    margin-top: 60.5rem !important;\n  }\n\n  .mt-xxl-123 {\n    margin-top: 61rem !important;\n  }\n\n  .mt-xxl-124 {\n    margin-top: 61.5rem !important;\n  }\n\n  .mt-xxl-125 {\n    margin-top: 62rem !important;\n  }\n\n  .mt-xxl-126 {\n    margin-top: 62.5rem !important;\n  }\n\n  .mt-xxl-127 {\n    margin-top: 63rem !important;\n  }\n\n  .mt-xxl-128 {\n    margin-top: 63.5rem !important;\n  }\n\n  .mt-xxl-129 {\n    margin-top: 64rem !important;\n  }\n\n  .mt-xxl-130 {\n    margin-top: 64.5rem !important;\n  }\n\n  .mt-xxl-131 {\n    margin-top: 65rem !important;\n  }\n\n  .mt-xxl-132 {\n    margin-top: 65.5rem !important;\n  }\n\n  .mt-xxl-133 {\n    margin-top: 66rem !important;\n  }\n\n  .mt-xxl-134 {\n    margin-top: 66.5rem !important;\n  }\n\n  .mt-xxl-135 {\n    margin-top: 67rem !important;\n  }\n\n  .mt-xxl-136 {\n    margin-top: 67.5rem !important;\n  }\n\n  .mt-xxl-137 {\n    margin-top: 68rem !important;\n  }\n\n  .mt-xxl-138 {\n    margin-top: 68.5rem !important;\n  }\n\n  .mt-xxl-139 {\n    margin-top: 69rem !important;\n  }\n\n  .mt-xxl-140 {\n    margin-top: 69.5rem !important;\n  }\n\n  .mt-xxl-141 {\n    margin-top: 70rem !important;\n  }\n\n  .mt-xxl-142 {\n    margin-top: 70.5rem !important;\n  }\n\n  .mt-xxl-143 {\n    margin-top: 71rem !important;\n  }\n\n  .mt-xxl-144 {\n    margin-top: 71.5rem !important;\n  }\n\n  .mt-xxl-145 {\n    margin-top: 72rem !important;\n  }\n\n  .mt-xxl-146 {\n    margin-top: 72.5rem !important;\n  }\n\n  .mt-xxl-147 {\n    margin-top: 73rem !important;\n  }\n\n  .mt-xxl-148 {\n    margin-top: 73.5rem !important;\n  }\n\n  .mt-xxl-149 {\n    margin-top: 74rem !important;\n  }\n\n  .mt-xxl-150 {\n    margin-top: 74.5rem !important;\n  }\n\n  .mt-xxl-151 {\n    margin-top: 75rem !important;\n  }\n\n  .mt-xxl-152 {\n    margin-top: 75.5rem !important;\n  }\n\n  .mt-xxl-153 {\n    margin-top: 76rem !important;\n  }\n\n  .mt-xxl-154 {\n    margin-top: 76.5rem !important;\n  }\n\n  .mt-xxl-155 {\n    margin-top: 77rem !important;\n  }\n\n  .mt-xxl-156 {\n    margin-top: 77.5rem !important;\n  }\n\n  .mt-xxl-157 {\n    margin-top: 78rem !important;\n  }\n\n  .mt-xxl-158 {\n    margin-top: 78.5rem !important;\n  }\n\n  .mt-xxl-159 {\n    margin-top: 79rem !important;\n  }\n\n  .mt-xxl-160 {\n    margin-top: 79.5rem !important;\n  }\n\n  .mb-xxl-0 {\n    margin-bottom: 0rem !important;\n  }\n\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xxl-5 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xxl-6 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xxl-7 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xxl-8 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xxl-9 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xxl-10 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xxl-11 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xxl-12 {\n    margin-bottom: 5.5rem !important;\n  }\n\n  .mb-xxl-13 {\n    margin-bottom: 6rem !important;\n  }\n\n  .mb-xxl-14 {\n    margin-bottom: 6.5rem !important;\n  }\n\n  .mb-xxl-15 {\n    margin-bottom: 7rem !important;\n  }\n\n  .mb-xxl-16 {\n    margin-bottom: 7.5rem !important;\n  }\n\n  .mb-xxl-17 {\n    margin-bottom: 8rem !important;\n  }\n\n  .mb-xxl-18 {\n    margin-bottom: 8.5rem !important;\n  }\n\n  .mb-xxl-19 {\n    margin-bottom: 9rem !important;\n  }\n\n  .mb-xxl-20 {\n    margin-bottom: 9.5rem !important;\n  }\n\n  .mb-xxl-21 {\n    margin-bottom: 10rem !important;\n  }\n\n  .mb-xxl-22 {\n    margin-bottom: 10.5rem !important;\n  }\n\n  .mb-xxl-23 {\n    margin-bottom: 11rem !important;\n  }\n\n  .mb-xxl-24 {\n    margin-bottom: 11.5rem !important;\n  }\n\n  .mb-xxl-25 {\n    margin-bottom: 12rem !important;\n  }\n\n  .mb-xxl-26 {\n    margin-bottom: 12.5rem !important;\n  }\n\n  .mb-xxl-27 {\n    margin-bottom: 13rem !important;\n  }\n\n  .mb-xxl-28 {\n    margin-bottom: 13.5rem !important;\n  }\n\n  .mb-xxl-29 {\n    margin-bottom: 14rem !important;\n  }\n\n  .mb-xxl-30 {\n    margin-bottom: 14.5rem !important;\n  }\n\n  .mb-xxl-31 {\n    margin-bottom: 15rem !important;\n  }\n\n  .mb-xxl-32 {\n    margin-bottom: 15.5rem !important;\n  }\n\n  .mb-xxl-33 {\n    margin-bottom: 16rem !important;\n  }\n\n  .mb-xxl-34 {\n    margin-bottom: 16.5rem !important;\n  }\n\n  .mb-xxl-35 {\n    margin-bottom: 17rem !important;\n  }\n\n  .mb-xxl-36 {\n    margin-bottom: 17.5rem !important;\n  }\n\n  .mb-xxl-37 {\n    margin-bottom: 18rem !important;\n  }\n\n  .mb-xxl-38 {\n    margin-bottom: 18.5rem !important;\n  }\n\n  .mb-xxl-39 {\n    margin-bottom: 19rem !important;\n  }\n\n  .mb-xxl-40 {\n    margin-bottom: 19.5rem !important;\n  }\n\n  .mb-xxl-41 {\n    margin-bottom: 20rem !important;\n  }\n\n  .mb-xxl-42 {\n    margin-bottom: 20.5rem !important;\n  }\n\n  .mb-xxl-43 {\n    margin-bottom: 21rem !important;\n  }\n\n  .mb-xxl-44 {\n    margin-bottom: 21.5rem !important;\n  }\n\n  .mb-xxl-45 {\n    margin-bottom: 22rem !important;\n  }\n\n  .mb-xxl-46 {\n    margin-bottom: 22.5rem !important;\n  }\n\n  .mb-xxl-47 {\n    margin-bottom: 23rem !important;\n  }\n\n  .mb-xxl-48 {\n    margin-bottom: 23.5rem !important;\n  }\n\n  .mb-xxl-49 {\n    margin-bottom: 24rem !important;\n  }\n\n  .mb-xxl-50 {\n    margin-bottom: 24.5rem !important;\n  }\n\n  .mb-xxl-51 {\n    margin-bottom: 25rem !important;\n  }\n\n  .mb-xxl-52 {\n    margin-bottom: 25.5rem !important;\n  }\n\n  .mb-xxl-53 {\n    margin-bottom: 26rem !important;\n  }\n\n  .mb-xxl-54 {\n    margin-bottom: 26.5rem !important;\n  }\n\n  .mb-xxl-55 {\n    margin-bottom: 27rem !important;\n  }\n\n  .mb-xxl-56 {\n    margin-bottom: 27.5rem !important;\n  }\n\n  .mb-xxl-57 {\n    margin-bottom: 28rem !important;\n  }\n\n  .mb-xxl-58 {\n    margin-bottom: 28.5rem !important;\n  }\n\n  .mb-xxl-59 {\n    margin-bottom: 29rem !important;\n  }\n\n  .mb-xxl-60 {\n    margin-bottom: 29.5rem !important;\n  }\n\n  .mb-xxl-61 {\n    margin-bottom: 30rem !important;\n  }\n\n  .mb-xxl-62 {\n    margin-bottom: 30.5rem !important;\n  }\n\n  .mb-xxl-63 {\n    margin-bottom: 31rem !important;\n  }\n\n  .mb-xxl-64 {\n    margin-bottom: 31.5rem !important;\n  }\n\n  .mb-xxl-65 {\n    margin-bottom: 32rem !important;\n  }\n\n  .mb-xxl-66 {\n    margin-bottom: 32.5rem !important;\n  }\n\n  .mb-xxl-67 {\n    margin-bottom: 33rem !important;\n  }\n\n  .mb-xxl-68 {\n    margin-bottom: 33.5rem !important;\n  }\n\n  .mb-xxl-69 {\n    margin-bottom: 34rem !important;\n  }\n\n  .mb-xxl-70 {\n    margin-bottom: 34.5rem !important;\n  }\n\n  .mb-xxl-71 {\n    margin-bottom: 35rem !important;\n  }\n\n  .mb-xxl-72 {\n    margin-bottom: 35.5rem !important;\n  }\n\n  .mb-xxl-73 {\n    margin-bottom: 36rem !important;\n  }\n\n  .mb-xxl-74 {\n    margin-bottom: 36.5rem !important;\n  }\n\n  .mb-xxl-75 {\n    margin-bottom: 37rem !important;\n  }\n\n  .mb-xxl-76 {\n    margin-bottom: 37.5rem !important;\n  }\n\n  .mb-xxl-77 {\n    margin-bottom: 38rem !important;\n  }\n\n  .mb-xxl-78 {\n    margin-bottom: 38.5rem !important;\n  }\n\n  .mb-xxl-79 {\n    margin-bottom: 39rem !important;\n  }\n\n  .mb-xxl-80 {\n    margin-bottom: 39.5rem !important;\n  }\n\n  .mb-xxl-81 {\n    margin-bottom: 40rem !important;\n  }\n\n  .mb-xxl-82 {\n    margin-bottom: 40.5rem !important;\n  }\n\n  .mb-xxl-83 {\n    margin-bottom: 41rem !important;\n  }\n\n  .mb-xxl-84 {\n    margin-bottom: 41.5rem !important;\n  }\n\n  .mb-xxl-85 {\n    margin-bottom: 42rem !important;\n  }\n\n  .mb-xxl-86 {\n    margin-bottom: 42.5rem !important;\n  }\n\n  .mb-xxl-87 {\n    margin-bottom: 43rem !important;\n  }\n\n  .mb-xxl-88 {\n    margin-bottom: 43.5rem !important;\n  }\n\n  .mb-xxl-89 {\n    margin-bottom: 44rem !important;\n  }\n\n  .mb-xxl-90 {\n    margin-bottom: 44.5rem !important;\n  }\n\n  .mb-xxl-91 {\n    margin-bottom: 45rem !important;\n  }\n\n  .mb-xxl-92 {\n    margin-bottom: 45.5rem !important;\n  }\n\n  .mb-xxl-93 {\n    margin-bottom: 46rem !important;\n  }\n\n  .mb-xxl-94 {\n    margin-bottom: 46.5rem !important;\n  }\n\n  .mb-xxl-95 {\n    margin-bottom: 47rem !important;\n  }\n\n  .mb-xxl-96 {\n    margin-bottom: 47.5rem !important;\n  }\n\n  .mb-xxl-97 {\n    margin-bottom: 48rem !important;\n  }\n\n  .mb-xxl-98 {\n    margin-bottom: 48.5rem !important;\n  }\n\n  .mb-xxl-99 {\n    margin-bottom: 49rem !important;\n  }\n\n  .mb-xxl-100 {\n    margin-bottom: 49.5rem !important;\n  }\n\n  .mb-xxl-101 {\n    margin-bottom: 50rem !important;\n  }\n\n  .mb-xxl-102 {\n    margin-bottom: 50.5rem !important;\n  }\n\n  .mb-xxl-103 {\n    margin-bottom: 51rem !important;\n  }\n\n  .mb-xxl-104 {\n    margin-bottom: 51.5rem !important;\n  }\n\n  .mb-xxl-105 {\n    margin-bottom: 52rem !important;\n  }\n\n  .mb-xxl-106 {\n    margin-bottom: 52.5rem !important;\n  }\n\n  .mb-xxl-107 {\n    margin-bottom: 53rem !important;\n  }\n\n  .mb-xxl-108 {\n    margin-bottom: 53.5rem !important;\n  }\n\n  .mb-xxl-109 {\n    margin-bottom: 54rem !important;\n  }\n\n  .mb-xxl-110 {\n    margin-bottom: 54.5rem !important;\n  }\n\n  .mb-xxl-111 {\n    margin-bottom: 55rem !important;\n  }\n\n  .mb-xxl-112 {\n    margin-bottom: 55.5rem !important;\n  }\n\n  .mb-xxl-113 {\n    margin-bottom: 56rem !important;\n  }\n\n  .mb-xxl-114 {\n    margin-bottom: 56.5rem !important;\n  }\n\n  .mb-xxl-115 {\n    margin-bottom: 57rem !important;\n  }\n\n  .mb-xxl-116 {\n    margin-bottom: 57.5rem !important;\n  }\n\n  .mb-xxl-117 {\n    margin-bottom: 58rem !important;\n  }\n\n  .mb-xxl-118 {\n    margin-bottom: 58.5rem !important;\n  }\n\n  .mb-xxl-119 {\n    margin-bottom: 59rem !important;\n  }\n\n  .mb-xxl-120 {\n    margin-bottom: 59.5rem !important;\n  }\n\n  .mb-xxl-121 {\n    margin-bottom: 60rem !important;\n  }\n\n  .mb-xxl-122 {\n    margin-bottom: 60.5rem !important;\n  }\n\n  .mb-xxl-123 {\n    margin-bottom: 61rem !important;\n  }\n\n  .mb-xxl-124 {\n    margin-bottom: 61.5rem !important;\n  }\n\n  .mb-xxl-125 {\n    margin-bottom: 62rem !important;\n  }\n\n  .mb-xxl-126 {\n    margin-bottom: 62.5rem !important;\n  }\n\n  .mb-xxl-127 {\n    margin-bottom: 63rem !important;\n  }\n\n  .mb-xxl-128 {\n    margin-bottom: 63.5rem !important;\n  }\n\n  .mb-xxl-129 {\n    margin-bottom: 64rem !important;\n  }\n\n  .mb-xxl-130 {\n    margin-bottom: 64.5rem !important;\n  }\n\n  .mb-xxl-131 {\n    margin-bottom: 65rem !important;\n  }\n\n  .mb-xxl-132 {\n    margin-bottom: 65.5rem !important;\n  }\n\n  .mb-xxl-133 {\n    margin-bottom: 66rem !important;\n  }\n\n  .mb-xxl-134 {\n    margin-bottom: 66.5rem !important;\n  }\n\n  .mb-xxl-135 {\n    margin-bottom: 67rem !important;\n  }\n\n  .mb-xxl-136 {\n    margin-bottom: 67.5rem !important;\n  }\n\n  .mb-xxl-137 {\n    margin-bottom: 68rem !important;\n  }\n\n  .mb-xxl-138 {\n    margin-bottom: 68.5rem !important;\n  }\n\n  .mb-xxl-139 {\n    margin-bottom: 69rem !important;\n  }\n\n  .mb-xxl-140 {\n    margin-bottom: 69.5rem !important;\n  }\n\n  .mb-xxl-141 {\n    margin-bottom: 70rem !important;\n  }\n\n  .mb-xxl-142 {\n    margin-bottom: 70.5rem !important;\n  }\n\n  .mb-xxl-143 {\n    margin-bottom: 71rem !important;\n  }\n\n  .mb-xxl-144 {\n    margin-bottom: 71.5rem !important;\n  }\n\n  .mb-xxl-145 {\n    margin-bottom: 72rem !important;\n  }\n\n  .mb-xxl-146 {\n    margin-bottom: 72.5rem !important;\n  }\n\n  .mb-xxl-147 {\n    margin-bottom: 73rem !important;\n  }\n\n  .mb-xxl-148 {\n    margin-bottom: 73.5rem !important;\n  }\n\n  .mb-xxl-149 {\n    margin-bottom: 74rem !important;\n  }\n\n  .mb-xxl-150 {\n    margin-bottom: 74.5rem !important;\n  }\n\n  .mb-xxl-151 {\n    margin-bottom: 75rem !important;\n  }\n\n  .mb-xxl-152 {\n    margin-bottom: 75.5rem !important;\n  }\n\n  .mb-xxl-153 {\n    margin-bottom: 76rem !important;\n  }\n\n  .mb-xxl-154 {\n    margin-bottom: 76.5rem !important;\n  }\n\n  .mb-xxl-155 {\n    margin-bottom: 77rem !important;\n  }\n\n  .mb-xxl-156 {\n    margin-bottom: 77.5rem !important;\n  }\n\n  .mb-xxl-157 {\n    margin-bottom: 78rem !important;\n  }\n\n  .mb-xxl-158 {\n    margin-bottom: 78.5rem !important;\n  }\n\n  .mb-xxl-159 {\n    margin-bottom: 79rem !important;\n  }\n\n  .mb-xxl-160 {\n    margin-bottom: 79.5rem !important;\n  }\n\n  .ms-xxl-0 {\n    margin-left: 0rem !important;\n  }\n\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xxl-5 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xxl-6 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xxl-7 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xxl-8 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xxl-9 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xxl-10 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xxl-11 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xxl-12 {\n    margin-left: 5.5rem !important;\n  }\n\n  .ms-xxl-13 {\n    margin-left: 6rem !important;\n  }\n\n  .ms-xxl-14 {\n    margin-left: 6.5rem !important;\n  }\n\n  .ms-xxl-15 {\n    margin-left: 7rem !important;\n  }\n\n  .ms-xxl-16 {\n    margin-left: 7.5rem !important;\n  }\n\n  .ms-xxl-17 {\n    margin-left: 8rem !important;\n  }\n\n  .ms-xxl-18 {\n    margin-left: 8.5rem !important;\n  }\n\n  .ms-xxl-19 {\n    margin-left: 9rem !important;\n  }\n\n  .ms-xxl-20 {\n    margin-left: 9.5rem !important;\n  }\n\n  .ms-xxl-21 {\n    margin-left: 10rem !important;\n  }\n\n  .ms-xxl-22 {\n    margin-left: 10.5rem !important;\n  }\n\n  .ms-xxl-23 {\n    margin-left: 11rem !important;\n  }\n\n  .ms-xxl-24 {\n    margin-left: 11.5rem !important;\n  }\n\n  .ms-xxl-25 {\n    margin-left: 12rem !important;\n  }\n\n  .ms-xxl-26 {\n    margin-left: 12.5rem !important;\n  }\n\n  .ms-xxl-27 {\n    margin-left: 13rem !important;\n  }\n\n  .ms-xxl-28 {\n    margin-left: 13.5rem !important;\n  }\n\n  .ms-xxl-29 {\n    margin-left: 14rem !important;\n  }\n\n  .ms-xxl-30 {\n    margin-left: 14.5rem !important;\n  }\n\n  .ms-xxl-31 {\n    margin-left: 15rem !important;\n  }\n\n  .ms-xxl-32 {\n    margin-left: 15.5rem !important;\n  }\n\n  .ms-xxl-33 {\n    margin-left: 16rem !important;\n  }\n\n  .ms-xxl-34 {\n    margin-left: 16.5rem !important;\n  }\n\n  .ms-xxl-35 {\n    margin-left: 17rem !important;\n  }\n\n  .ms-xxl-36 {\n    margin-left: 17.5rem !important;\n  }\n\n  .ms-xxl-37 {\n    margin-left: 18rem !important;\n  }\n\n  .ms-xxl-38 {\n    margin-left: 18.5rem !important;\n  }\n\n  .ms-xxl-39 {\n    margin-left: 19rem !important;\n  }\n\n  .ms-xxl-40 {\n    margin-left: 19.5rem !important;\n  }\n\n  .ms-xxl-41 {\n    margin-left: 20rem !important;\n  }\n\n  .ms-xxl-42 {\n    margin-left: 20.5rem !important;\n  }\n\n  .ms-xxl-43 {\n    margin-left: 21rem !important;\n  }\n\n  .ms-xxl-44 {\n    margin-left: 21.5rem !important;\n  }\n\n  .ms-xxl-45 {\n    margin-left: 22rem !important;\n  }\n\n  .ms-xxl-46 {\n    margin-left: 22.5rem !important;\n  }\n\n  .ms-xxl-47 {\n    margin-left: 23rem !important;\n  }\n\n  .ms-xxl-48 {\n    margin-left: 23.5rem !important;\n  }\n\n  .ms-xxl-49 {\n    margin-left: 24rem !important;\n  }\n\n  .ms-xxl-50 {\n    margin-left: 24.5rem !important;\n  }\n\n  .ms-xxl-51 {\n    margin-left: 25rem !important;\n  }\n\n  .ms-xxl-52 {\n    margin-left: 25.5rem !important;\n  }\n\n  .ms-xxl-53 {\n    margin-left: 26rem !important;\n  }\n\n  .ms-xxl-54 {\n    margin-left: 26.5rem !important;\n  }\n\n  .ms-xxl-55 {\n    margin-left: 27rem !important;\n  }\n\n  .ms-xxl-56 {\n    margin-left: 27.5rem !important;\n  }\n\n  .ms-xxl-57 {\n    margin-left: 28rem !important;\n  }\n\n  .ms-xxl-58 {\n    margin-left: 28.5rem !important;\n  }\n\n  .ms-xxl-59 {\n    margin-left: 29rem !important;\n  }\n\n  .ms-xxl-60 {\n    margin-left: 29.5rem !important;\n  }\n\n  .ms-xxl-61 {\n    margin-left: 30rem !important;\n  }\n\n  .ms-xxl-62 {\n    margin-left: 30.5rem !important;\n  }\n\n  .ms-xxl-63 {\n    margin-left: 31rem !important;\n  }\n\n  .ms-xxl-64 {\n    margin-left: 31.5rem !important;\n  }\n\n  .ms-xxl-65 {\n    margin-left: 32rem !important;\n  }\n\n  .ms-xxl-66 {\n    margin-left: 32.5rem !important;\n  }\n\n  .ms-xxl-67 {\n    margin-left: 33rem !important;\n  }\n\n  .ms-xxl-68 {\n    margin-left: 33.5rem !important;\n  }\n\n  .ms-xxl-69 {\n    margin-left: 34rem !important;\n  }\n\n  .ms-xxl-70 {\n    margin-left: 34.5rem !important;\n  }\n\n  .ms-xxl-71 {\n    margin-left: 35rem !important;\n  }\n\n  .ms-xxl-72 {\n    margin-left: 35.5rem !important;\n  }\n\n  .ms-xxl-73 {\n    margin-left: 36rem !important;\n  }\n\n  .ms-xxl-74 {\n    margin-left: 36.5rem !important;\n  }\n\n  .ms-xxl-75 {\n    margin-left: 37rem !important;\n  }\n\n  .ms-xxl-76 {\n    margin-left: 37.5rem !important;\n  }\n\n  .ms-xxl-77 {\n    margin-left: 38rem !important;\n  }\n\n  .ms-xxl-78 {\n    margin-left: 38.5rem !important;\n  }\n\n  .ms-xxl-79 {\n    margin-left: 39rem !important;\n  }\n\n  .ms-xxl-80 {\n    margin-left: 39.5rem !important;\n  }\n\n  .ms-xxl-81 {\n    margin-left: 40rem !important;\n  }\n\n  .ms-xxl-82 {\n    margin-left: 40.5rem !important;\n  }\n\n  .ms-xxl-83 {\n    margin-left: 41rem !important;\n  }\n\n  .ms-xxl-84 {\n    margin-left: 41.5rem !important;\n  }\n\n  .ms-xxl-85 {\n    margin-left: 42rem !important;\n  }\n\n  .ms-xxl-86 {\n    margin-left: 42.5rem !important;\n  }\n\n  .ms-xxl-87 {\n    margin-left: 43rem !important;\n  }\n\n  .ms-xxl-88 {\n    margin-left: 43.5rem !important;\n  }\n\n  .ms-xxl-89 {\n    margin-left: 44rem !important;\n  }\n\n  .ms-xxl-90 {\n    margin-left: 44.5rem !important;\n  }\n\n  .ms-xxl-91 {\n    margin-left: 45rem !important;\n  }\n\n  .ms-xxl-92 {\n    margin-left: 45.5rem !important;\n  }\n\n  .ms-xxl-93 {\n    margin-left: 46rem !important;\n  }\n\n  .ms-xxl-94 {\n    margin-left: 46.5rem !important;\n  }\n\n  .ms-xxl-95 {\n    margin-left: 47rem !important;\n  }\n\n  .ms-xxl-96 {\n    margin-left: 47.5rem !important;\n  }\n\n  .ms-xxl-97 {\n    margin-left: 48rem !important;\n  }\n\n  .ms-xxl-98 {\n    margin-left: 48.5rem !important;\n  }\n\n  .ms-xxl-99 {\n    margin-left: 49rem !important;\n  }\n\n  .ms-xxl-100 {\n    margin-left: 49.5rem !important;\n  }\n\n  .ms-xxl-101 {\n    margin-left: 50rem !important;\n  }\n\n  .ms-xxl-102 {\n    margin-left: 50.5rem !important;\n  }\n\n  .ms-xxl-103 {\n    margin-left: 51rem !important;\n  }\n\n  .ms-xxl-104 {\n    margin-left: 51.5rem !important;\n  }\n\n  .ms-xxl-105 {\n    margin-left: 52rem !important;\n  }\n\n  .ms-xxl-106 {\n    margin-left: 52.5rem !important;\n  }\n\n  .ms-xxl-107 {\n    margin-left: 53rem !important;\n  }\n\n  .ms-xxl-108 {\n    margin-left: 53.5rem !important;\n  }\n\n  .ms-xxl-109 {\n    margin-left: 54rem !important;\n  }\n\n  .ms-xxl-110 {\n    margin-left: 54.5rem !important;\n  }\n\n  .ms-xxl-111 {\n    margin-left: 55rem !important;\n  }\n\n  .ms-xxl-112 {\n    margin-left: 55.5rem !important;\n  }\n\n  .ms-xxl-113 {\n    margin-left: 56rem !important;\n  }\n\n  .ms-xxl-114 {\n    margin-left: 56.5rem !important;\n  }\n\n  .ms-xxl-115 {\n    margin-left: 57rem !important;\n  }\n\n  .ms-xxl-116 {\n    margin-left: 57.5rem !important;\n  }\n\n  .ms-xxl-117 {\n    margin-left: 58rem !important;\n  }\n\n  .ms-xxl-118 {\n    margin-left: 58.5rem !important;\n  }\n\n  .ms-xxl-119 {\n    margin-left: 59rem !important;\n  }\n\n  .ms-xxl-120 {\n    margin-left: 59.5rem !important;\n  }\n\n  .ms-xxl-121 {\n    margin-left: 60rem !important;\n  }\n\n  .ms-xxl-122 {\n    margin-left: 60.5rem !important;\n  }\n\n  .ms-xxl-123 {\n    margin-left: 61rem !important;\n  }\n\n  .ms-xxl-124 {\n    margin-left: 61.5rem !important;\n  }\n\n  .ms-xxl-125 {\n    margin-left: 62rem !important;\n  }\n\n  .ms-xxl-126 {\n    margin-left: 62.5rem !important;\n  }\n\n  .ms-xxl-127 {\n    margin-left: 63rem !important;\n  }\n\n  .ms-xxl-128 {\n    margin-left: 63.5rem !important;\n  }\n\n  .ms-xxl-129 {\n    margin-left: 64rem !important;\n  }\n\n  .ms-xxl-130 {\n    margin-left: 64.5rem !important;\n  }\n\n  .ms-xxl-131 {\n    margin-left: 65rem !important;\n  }\n\n  .ms-xxl-132 {\n    margin-left: 65.5rem !important;\n  }\n\n  .ms-xxl-133 {\n    margin-left: 66rem !important;\n  }\n\n  .ms-xxl-134 {\n    margin-left: 66.5rem !important;\n  }\n\n  .ms-xxl-135 {\n    margin-left: 67rem !important;\n  }\n\n  .ms-xxl-136 {\n    margin-left: 67.5rem !important;\n  }\n\n  .ms-xxl-137 {\n    margin-left: 68rem !important;\n  }\n\n  .ms-xxl-138 {\n    margin-left: 68.5rem !important;\n  }\n\n  .ms-xxl-139 {\n    margin-left: 69rem !important;\n  }\n\n  .ms-xxl-140 {\n    margin-left: 69.5rem !important;\n  }\n\n  .ms-xxl-141 {\n    margin-left: 70rem !important;\n  }\n\n  .ms-xxl-142 {\n    margin-left: 70.5rem !important;\n  }\n\n  .ms-xxl-143 {\n    margin-left: 71rem !important;\n  }\n\n  .ms-xxl-144 {\n    margin-left: 71.5rem !important;\n  }\n\n  .ms-xxl-145 {\n    margin-left: 72rem !important;\n  }\n\n  .ms-xxl-146 {\n    margin-left: 72.5rem !important;\n  }\n\n  .ms-xxl-147 {\n    margin-left: 73rem !important;\n  }\n\n  .ms-xxl-148 {\n    margin-left: 73.5rem !important;\n  }\n\n  .ms-xxl-149 {\n    margin-left: 74rem !important;\n  }\n\n  .ms-xxl-150 {\n    margin-left: 74.5rem !important;\n  }\n\n  .ms-xxl-151 {\n    margin-left: 75rem !important;\n  }\n\n  .ms-xxl-152 {\n    margin-left: 75.5rem !important;\n  }\n\n  .ms-xxl-153 {\n    margin-left: 76rem !important;\n  }\n\n  .ms-xxl-154 {\n    margin-left: 76.5rem !important;\n  }\n\n  .ms-xxl-155 {\n    margin-left: 77rem !important;\n  }\n\n  .ms-xxl-156 {\n    margin-left: 77.5rem !important;\n  }\n\n  .ms-xxl-157 {\n    margin-left: 78rem !important;\n  }\n\n  .ms-xxl-158 {\n    margin-left: 78.5rem !important;\n  }\n\n  .ms-xxl-159 {\n    margin-left: 79rem !important;\n  }\n\n  .ms-xxl-160 {\n    margin-left: 79.5rem !important;\n  }\n\n  .me-xxl-0 {\n    margin-right: 0rem !important;\n  }\n\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xxl-5 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xxl-6 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xxl-7 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xxl-8 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xxl-9 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xxl-10 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xxl-11 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xxl-12 {\n    margin-right: 5.5rem !important;\n  }\n\n  .me-xxl-13 {\n    margin-right: 6rem !important;\n  }\n\n  .me-xxl-14 {\n    margin-right: 6.5rem !important;\n  }\n\n  .me-xxl-15 {\n    margin-right: 7rem !important;\n  }\n\n  .me-xxl-16 {\n    margin-right: 7.5rem !important;\n  }\n\n  .me-xxl-17 {\n    margin-right: 8rem !important;\n  }\n\n  .me-xxl-18 {\n    margin-right: 8.5rem !important;\n  }\n\n  .me-xxl-19 {\n    margin-right: 9rem !important;\n  }\n\n  .me-xxl-20 {\n    margin-right: 9.5rem !important;\n  }\n\n  .me-xxl-21 {\n    margin-right: 10rem !important;\n  }\n\n  .me-xxl-22 {\n    margin-right: 10.5rem !important;\n  }\n\n  .me-xxl-23 {\n    margin-right: 11rem !important;\n  }\n\n  .me-xxl-24 {\n    margin-right: 11.5rem !important;\n  }\n\n  .me-xxl-25 {\n    margin-right: 12rem !important;\n  }\n\n  .me-xxl-26 {\n    margin-right: 12.5rem !important;\n  }\n\n  .me-xxl-27 {\n    margin-right: 13rem !important;\n  }\n\n  .me-xxl-28 {\n    margin-right: 13.5rem !important;\n  }\n\n  .me-xxl-29 {\n    margin-right: 14rem !important;\n  }\n\n  .me-xxl-30 {\n    margin-right: 14.5rem !important;\n  }\n\n  .me-xxl-31 {\n    margin-right: 15rem !important;\n  }\n\n  .me-xxl-32 {\n    margin-right: 15.5rem !important;\n  }\n\n  .me-xxl-33 {\n    margin-right: 16rem !important;\n  }\n\n  .me-xxl-34 {\n    margin-right: 16.5rem !important;\n  }\n\n  .me-xxl-35 {\n    margin-right: 17rem !important;\n  }\n\n  .me-xxl-36 {\n    margin-right: 17.5rem !important;\n  }\n\n  .me-xxl-37 {\n    margin-right: 18rem !important;\n  }\n\n  .me-xxl-38 {\n    margin-right: 18.5rem !important;\n  }\n\n  .me-xxl-39 {\n    margin-right: 19rem !important;\n  }\n\n  .me-xxl-40 {\n    margin-right: 19.5rem !important;\n  }\n\n  .me-xxl-41 {\n    margin-right: 20rem !important;\n  }\n\n  .me-xxl-42 {\n    margin-right: 20.5rem !important;\n  }\n\n  .me-xxl-43 {\n    margin-right: 21rem !important;\n  }\n\n  .me-xxl-44 {\n    margin-right: 21.5rem !important;\n  }\n\n  .me-xxl-45 {\n    margin-right: 22rem !important;\n  }\n\n  .me-xxl-46 {\n    margin-right: 22.5rem !important;\n  }\n\n  .me-xxl-47 {\n    margin-right: 23rem !important;\n  }\n\n  .me-xxl-48 {\n    margin-right: 23.5rem !important;\n  }\n\n  .me-xxl-49 {\n    margin-right: 24rem !important;\n  }\n\n  .me-xxl-50 {\n    margin-right: 24.5rem !important;\n  }\n\n  .me-xxl-51 {\n    margin-right: 25rem !important;\n  }\n\n  .me-xxl-52 {\n    margin-right: 25.5rem !important;\n  }\n\n  .me-xxl-53 {\n    margin-right: 26rem !important;\n  }\n\n  .me-xxl-54 {\n    margin-right: 26.5rem !important;\n  }\n\n  .me-xxl-55 {\n    margin-right: 27rem !important;\n  }\n\n  .me-xxl-56 {\n    margin-right: 27.5rem !important;\n  }\n\n  .me-xxl-57 {\n    margin-right: 28rem !important;\n  }\n\n  .me-xxl-58 {\n    margin-right: 28.5rem !important;\n  }\n\n  .me-xxl-59 {\n    margin-right: 29rem !important;\n  }\n\n  .me-xxl-60 {\n    margin-right: 29.5rem !important;\n  }\n\n  .me-xxl-61 {\n    margin-right: 30rem !important;\n  }\n\n  .me-xxl-62 {\n    margin-right: 30.5rem !important;\n  }\n\n  .me-xxl-63 {\n    margin-right: 31rem !important;\n  }\n\n  .me-xxl-64 {\n    margin-right: 31.5rem !important;\n  }\n\n  .me-xxl-65 {\n    margin-right: 32rem !important;\n  }\n\n  .me-xxl-66 {\n    margin-right: 32.5rem !important;\n  }\n\n  .me-xxl-67 {\n    margin-right: 33rem !important;\n  }\n\n  .me-xxl-68 {\n    margin-right: 33.5rem !important;\n  }\n\n  .me-xxl-69 {\n    margin-right: 34rem !important;\n  }\n\n  .me-xxl-70 {\n    margin-right: 34.5rem !important;\n  }\n\n  .me-xxl-71 {\n    margin-right: 35rem !important;\n  }\n\n  .me-xxl-72 {\n    margin-right: 35.5rem !important;\n  }\n\n  .me-xxl-73 {\n    margin-right: 36rem !important;\n  }\n\n  .me-xxl-74 {\n    margin-right: 36.5rem !important;\n  }\n\n  .me-xxl-75 {\n    margin-right: 37rem !important;\n  }\n\n  .me-xxl-76 {\n    margin-right: 37.5rem !important;\n  }\n\n  .me-xxl-77 {\n    margin-right: 38rem !important;\n  }\n\n  .me-xxl-78 {\n    margin-right: 38.5rem !important;\n  }\n\n  .me-xxl-79 {\n    margin-right: 39rem !important;\n  }\n\n  .me-xxl-80 {\n    margin-right: 39.5rem !important;\n  }\n\n  .me-xxl-81 {\n    margin-right: 40rem !important;\n  }\n\n  .me-xxl-82 {\n    margin-right: 40.5rem !important;\n  }\n\n  .me-xxl-83 {\n    margin-right: 41rem !important;\n  }\n\n  .me-xxl-84 {\n    margin-right: 41.5rem !important;\n  }\n\n  .me-xxl-85 {\n    margin-right: 42rem !important;\n  }\n\n  .me-xxl-86 {\n    margin-right: 42.5rem !important;\n  }\n\n  .me-xxl-87 {\n    margin-right: 43rem !important;\n  }\n\n  .me-xxl-88 {\n    margin-right: 43.5rem !important;\n  }\n\n  .me-xxl-89 {\n    margin-right: 44rem !important;\n  }\n\n  .me-xxl-90 {\n    margin-right: 44.5rem !important;\n  }\n\n  .me-xxl-91 {\n    margin-right: 45rem !important;\n  }\n\n  .me-xxl-92 {\n    margin-right: 45.5rem !important;\n  }\n\n  .me-xxl-93 {\n    margin-right: 46rem !important;\n  }\n\n  .me-xxl-94 {\n    margin-right: 46.5rem !important;\n  }\n\n  .me-xxl-95 {\n    margin-right: 47rem !important;\n  }\n\n  .me-xxl-96 {\n    margin-right: 47.5rem !important;\n  }\n\n  .me-xxl-97 {\n    margin-right: 48rem !important;\n  }\n\n  .me-xxl-98 {\n    margin-right: 48.5rem !important;\n  }\n\n  .me-xxl-99 {\n    margin-right: 49rem !important;\n  }\n\n  .me-xxl-100 {\n    margin-right: 49.5rem !important;\n  }\n\n  .me-xxl-101 {\n    margin-right: 50rem !important;\n  }\n\n  .me-xxl-102 {\n    margin-right: 50.5rem !important;\n  }\n\n  .me-xxl-103 {\n    margin-right: 51rem !important;\n  }\n\n  .me-xxl-104 {\n    margin-right: 51.5rem !important;\n  }\n\n  .me-xxl-105 {\n    margin-right: 52rem !important;\n  }\n\n  .me-xxl-106 {\n    margin-right: 52.5rem !important;\n  }\n\n  .me-xxl-107 {\n    margin-right: 53rem !important;\n  }\n\n  .me-xxl-108 {\n    margin-right: 53.5rem !important;\n  }\n\n  .me-xxl-109 {\n    margin-right: 54rem !important;\n  }\n\n  .me-xxl-110 {\n    margin-right: 54.5rem !important;\n  }\n\n  .me-xxl-111 {\n    margin-right: 55rem !important;\n  }\n\n  .me-xxl-112 {\n    margin-right: 55.5rem !important;\n  }\n\n  .me-xxl-113 {\n    margin-right: 56rem !important;\n  }\n\n  .me-xxl-114 {\n    margin-right: 56.5rem !important;\n  }\n\n  .me-xxl-115 {\n    margin-right: 57rem !important;\n  }\n\n  .me-xxl-116 {\n    margin-right: 57.5rem !important;\n  }\n\n  .me-xxl-117 {\n    margin-right: 58rem !important;\n  }\n\n  .me-xxl-118 {\n    margin-right: 58.5rem !important;\n  }\n\n  .me-xxl-119 {\n    margin-right: 59rem !important;\n  }\n\n  .me-xxl-120 {\n    margin-right: 59.5rem !important;\n  }\n\n  .me-xxl-121 {\n    margin-right: 60rem !important;\n  }\n\n  .me-xxl-122 {\n    margin-right: 60.5rem !important;\n  }\n\n  .me-xxl-123 {\n    margin-right: 61rem !important;\n  }\n\n  .me-xxl-124 {\n    margin-right: 61.5rem !important;\n  }\n\n  .me-xxl-125 {\n    margin-right: 62rem !important;\n  }\n\n  .me-xxl-126 {\n    margin-right: 62.5rem !important;\n  }\n\n  .me-xxl-127 {\n    margin-right: 63rem !important;\n  }\n\n  .me-xxl-128 {\n    margin-right: 63.5rem !important;\n  }\n\n  .me-xxl-129 {\n    margin-right: 64rem !important;\n  }\n\n  .me-xxl-130 {\n    margin-right: 64.5rem !important;\n  }\n\n  .me-xxl-131 {\n    margin-right: 65rem !important;\n  }\n\n  .me-xxl-132 {\n    margin-right: 65.5rem !important;\n  }\n\n  .me-xxl-133 {\n    margin-right: 66rem !important;\n  }\n\n  .me-xxl-134 {\n    margin-right: 66.5rem !important;\n  }\n\n  .me-xxl-135 {\n    margin-right: 67rem !important;\n  }\n\n  .me-xxl-136 {\n    margin-right: 67.5rem !important;\n  }\n\n  .me-xxl-137 {\n    margin-right: 68rem !important;\n  }\n\n  .me-xxl-138 {\n    margin-right: 68.5rem !important;\n  }\n\n  .me-xxl-139 {\n    margin-right: 69rem !important;\n  }\n\n  .me-xxl-140 {\n    margin-right: 69.5rem !important;\n  }\n\n  .me-xxl-141 {\n    margin-right: 70rem !important;\n  }\n\n  .me-xxl-142 {\n    margin-right: 70.5rem !important;\n  }\n\n  .me-xxl-143 {\n    margin-right: 71rem !important;\n  }\n\n  .me-xxl-144 {\n    margin-right: 71.5rem !important;\n  }\n\n  .me-xxl-145 {\n    margin-right: 72rem !important;\n  }\n\n  .me-xxl-146 {\n    margin-right: 72.5rem !important;\n  }\n\n  .me-xxl-147 {\n    margin-right: 73rem !important;\n  }\n\n  .me-xxl-148 {\n    margin-right: 73.5rem !important;\n  }\n\n  .me-xxl-149 {\n    margin-right: 74rem !important;\n  }\n\n  .me-xxl-150 {\n    margin-right: 74.5rem !important;\n  }\n\n  .me-xxl-151 {\n    margin-right: 75rem !important;\n  }\n\n  .me-xxl-152 {\n    margin-right: 75.5rem !important;\n  }\n\n  .me-xxl-153 {\n    margin-right: 76rem !important;\n  }\n\n  .me-xxl-154 {\n    margin-right: 76.5rem !important;\n  }\n\n  .me-xxl-155 {\n    margin-right: 77rem !important;\n  }\n\n  .me-xxl-156 {\n    margin-right: 77.5rem !important;\n  }\n\n  .me-xxl-157 {\n    margin-right: 78rem !important;\n  }\n\n  .me-xxl-158 {\n    margin-right: 78.5rem !important;\n  }\n\n  .me-xxl-159 {\n    margin-right: 79rem !important;\n  }\n\n  .me-xxl-160 {\n    margin-right: 79.5rem !important;\n  }\n\n  .mx-xxl-0 {\n    margin-left: 0rem !important;\n    margin-right: 0rem !important;\n  }\n\n  .mx-xxl-1 {\n    margin-left: 0.25rem !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .mx-xxl-2 {\n    margin-left: 0.5rem !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .mx-xxl-3 {\n    margin-left: 1rem !important;\n    margin-right: 1rem !important;\n  }\n\n  .mx-xxl-4 {\n    margin-left: 1.5rem !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .mx-xxl-5 {\n    margin-left: 2rem !important;\n    margin-right: 2rem !important;\n  }\n\n  .mx-xxl-6 {\n    margin-left: 2.5rem !important;\n    margin-right: 2.5rem !important;\n  }\n\n  .mx-xxl-7 {\n    margin-left: 3rem !important;\n    margin-right: 3rem !important;\n  }\n\n  .mx-xxl-8 {\n    margin-left: 3.5rem !important;\n    margin-right: 3.5rem !important;\n  }\n\n  .mx-xxl-9 {\n    margin-left: 4rem !important;\n    margin-right: 4rem !important;\n  }\n\n  .mx-xxl-10 {\n    margin-left: 4.5rem !important;\n    margin-right: 4.5rem !important;\n  }\n\n  .mx-xxl-11 {\n    margin-left: 5rem !important;\n    margin-right: 5rem !important;\n  }\n\n  .mx-xxl-12 {\n    margin-left: 5.5rem !important;\n    margin-right: 5.5rem !important;\n  }\n\n  .mx-xxl-13 {\n    margin-left: 6rem !important;\n    margin-right: 6rem !important;\n  }\n\n  .mx-xxl-14 {\n    margin-left: 6.5rem !important;\n    margin-right: 6.5rem !important;\n  }\n\n  .mx-xxl-15 {\n    margin-left: 7rem !important;\n    margin-right: 7rem !important;\n  }\n\n  .mx-xxl-16 {\n    margin-left: 7.5rem !important;\n    margin-right: 7.5rem !important;\n  }\n\n  .mx-xxl-17 {\n    margin-left: 8rem !important;\n    margin-right: 8rem !important;\n  }\n\n  .mx-xxl-18 {\n    margin-left: 8.5rem !important;\n    margin-right: 8.5rem !important;\n  }\n\n  .mx-xxl-19 {\n    margin-left: 9rem !important;\n    margin-right: 9rem !important;\n  }\n\n  .mx-xxl-20 {\n    margin-left: 9.5rem !important;\n    margin-right: 9.5rem !important;\n  }\n\n  .mx-xxl-21 {\n    margin-left: 10rem !important;\n    margin-right: 10rem !important;\n  }\n\n  .mx-xxl-22 {\n    margin-left: 10.5rem !important;\n    margin-right: 10.5rem !important;\n  }\n\n  .mx-xxl-23 {\n    margin-left: 11rem !important;\n    margin-right: 11rem !important;\n  }\n\n  .mx-xxl-24 {\n    margin-left: 11.5rem !important;\n    margin-right: 11.5rem !important;\n  }\n\n  .mx-xxl-25 {\n    margin-left: 12rem !important;\n    margin-right: 12rem !important;\n  }\n\n  .mx-xxl-26 {\n    margin-left: 12.5rem !important;\n    margin-right: 12.5rem !important;\n  }\n\n  .mx-xxl-27 {\n    margin-left: 13rem !important;\n    margin-right: 13rem !important;\n  }\n\n  .mx-xxl-28 {\n    margin-left: 13.5rem !important;\n    margin-right: 13.5rem !important;\n  }\n\n  .mx-xxl-29 {\n    margin-left: 14rem !important;\n    margin-right: 14rem !important;\n  }\n\n  .mx-xxl-30 {\n    margin-left: 14.5rem !important;\n    margin-right: 14.5rem !important;\n  }\n\n  .mx-xxl-31 {\n    margin-left: 15rem !important;\n    margin-right: 15rem !important;\n  }\n\n  .mx-xxl-32 {\n    margin-left: 15.5rem !important;\n    margin-right: 15.5rem !important;\n  }\n\n  .mx-xxl-33 {\n    margin-left: 16rem !important;\n    margin-right: 16rem !important;\n  }\n\n  .mx-xxl-34 {\n    margin-left: 16.5rem !important;\n    margin-right: 16.5rem !important;\n  }\n\n  .mx-xxl-35 {\n    margin-left: 17rem !important;\n    margin-right: 17rem !important;\n  }\n\n  .mx-xxl-36 {\n    margin-left: 17.5rem !important;\n    margin-right: 17.5rem !important;\n  }\n\n  .mx-xxl-37 {\n    margin-left: 18rem !important;\n    margin-right: 18rem !important;\n  }\n\n  .mx-xxl-38 {\n    margin-left: 18.5rem !important;\n    margin-right: 18.5rem !important;\n  }\n\n  .mx-xxl-39 {\n    margin-left: 19rem !important;\n    margin-right: 19rem !important;\n  }\n\n  .mx-xxl-40 {\n    margin-left: 19.5rem !important;\n    margin-right: 19.5rem !important;\n  }\n\n  .mx-xxl-41 {\n    margin-left: 20rem !important;\n    margin-right: 20rem !important;\n  }\n\n  .mx-xxl-42 {\n    margin-left: 20.5rem !important;\n    margin-right: 20.5rem !important;\n  }\n\n  .mx-xxl-43 {\n    margin-left: 21rem !important;\n    margin-right: 21rem !important;\n  }\n\n  .mx-xxl-44 {\n    margin-left: 21.5rem !important;\n    margin-right: 21.5rem !important;\n  }\n\n  .mx-xxl-45 {\n    margin-left: 22rem !important;\n    margin-right: 22rem !important;\n  }\n\n  .mx-xxl-46 {\n    margin-left: 22.5rem !important;\n    margin-right: 22.5rem !important;\n  }\n\n  .mx-xxl-47 {\n    margin-left: 23rem !important;\n    margin-right: 23rem !important;\n  }\n\n  .mx-xxl-48 {\n    margin-left: 23.5rem !important;\n    margin-right: 23.5rem !important;\n  }\n\n  .mx-xxl-49 {\n    margin-left: 24rem !important;\n    margin-right: 24rem !important;\n  }\n\n  .mx-xxl-50 {\n    margin-left: 24.5rem !important;\n    margin-right: 24.5rem !important;\n  }\n\n  .mx-xxl-51 {\n    margin-left: 25rem !important;\n    margin-right: 25rem !important;\n  }\n\n  .mx-xxl-52 {\n    margin-left: 25.5rem !important;\n    margin-right: 25.5rem !important;\n  }\n\n  .mx-xxl-53 {\n    margin-left: 26rem !important;\n    margin-right: 26rem !important;\n  }\n\n  .mx-xxl-54 {\n    margin-left: 26.5rem !important;\n    margin-right: 26.5rem !important;\n  }\n\n  .mx-xxl-55 {\n    margin-left: 27rem !important;\n    margin-right: 27rem !important;\n  }\n\n  .mx-xxl-56 {\n    margin-left: 27.5rem !important;\n    margin-right: 27.5rem !important;\n  }\n\n  .mx-xxl-57 {\n    margin-left: 28rem !important;\n    margin-right: 28rem !important;\n  }\n\n  .mx-xxl-58 {\n    margin-left: 28.5rem !important;\n    margin-right: 28.5rem !important;\n  }\n\n  .mx-xxl-59 {\n    margin-left: 29rem !important;\n    margin-right: 29rem !important;\n  }\n\n  .mx-xxl-60 {\n    margin-left: 29.5rem !important;\n    margin-right: 29.5rem !important;\n  }\n\n  .mx-xxl-61 {\n    margin-left: 30rem !important;\n    margin-right: 30rem !important;\n  }\n\n  .mx-xxl-62 {\n    margin-left: 30.5rem !important;\n    margin-right: 30.5rem !important;\n  }\n\n  .mx-xxl-63 {\n    margin-left: 31rem !important;\n    margin-right: 31rem !important;\n  }\n\n  .mx-xxl-64 {\n    margin-left: 31.5rem !important;\n    margin-right: 31.5rem !important;\n  }\n\n  .mx-xxl-65 {\n    margin-left: 32rem !important;\n    margin-right: 32rem !important;\n  }\n\n  .mx-xxl-66 {\n    margin-left: 32.5rem !important;\n    margin-right: 32.5rem !important;\n  }\n\n  .mx-xxl-67 {\n    margin-left: 33rem !important;\n    margin-right: 33rem !important;\n  }\n\n  .mx-xxl-68 {\n    margin-left: 33.5rem !important;\n    margin-right: 33.5rem !important;\n  }\n\n  .mx-xxl-69 {\n    margin-left: 34rem !important;\n    margin-right: 34rem !important;\n  }\n\n  .mx-xxl-70 {\n    margin-left: 34.5rem !important;\n    margin-right: 34.5rem !important;\n  }\n\n  .mx-xxl-71 {\n    margin-left: 35rem !important;\n    margin-right: 35rem !important;\n  }\n\n  .mx-xxl-72 {\n    margin-left: 35.5rem !important;\n    margin-right: 35.5rem !important;\n  }\n\n  .mx-xxl-73 {\n    margin-left: 36rem !important;\n    margin-right: 36rem !important;\n  }\n\n  .mx-xxl-74 {\n    margin-left: 36.5rem !important;\n    margin-right: 36.5rem !important;\n  }\n\n  .mx-xxl-75 {\n    margin-left: 37rem !important;\n    margin-right: 37rem !important;\n  }\n\n  .mx-xxl-76 {\n    margin-left: 37.5rem !important;\n    margin-right: 37.5rem !important;\n  }\n\n  .mx-xxl-77 {\n    margin-left: 38rem !important;\n    margin-right: 38rem !important;\n  }\n\n  .mx-xxl-78 {\n    margin-left: 38.5rem !important;\n    margin-right: 38.5rem !important;\n  }\n\n  .mx-xxl-79 {\n    margin-left: 39rem !important;\n    margin-right: 39rem !important;\n  }\n\n  .mx-xxl-80 {\n    margin-left: 39.5rem !important;\n    margin-right: 39.5rem !important;\n  }\n\n  .mx-xxl-81 {\n    margin-left: 40rem !important;\n    margin-right: 40rem !important;\n  }\n\n  .mx-xxl-82 {\n    margin-left: 40.5rem !important;\n    margin-right: 40.5rem !important;\n  }\n\n  .mx-xxl-83 {\n    margin-left: 41rem !important;\n    margin-right: 41rem !important;\n  }\n\n  .mx-xxl-84 {\n    margin-left: 41.5rem !important;\n    margin-right: 41.5rem !important;\n  }\n\n  .mx-xxl-85 {\n    margin-left: 42rem !important;\n    margin-right: 42rem !important;\n  }\n\n  .mx-xxl-86 {\n    margin-left: 42.5rem !important;\n    margin-right: 42.5rem !important;\n  }\n\n  .mx-xxl-87 {\n    margin-left: 43rem !important;\n    margin-right: 43rem !important;\n  }\n\n  .mx-xxl-88 {\n    margin-left: 43.5rem !important;\n    margin-right: 43.5rem !important;\n  }\n\n  .mx-xxl-89 {\n    margin-left: 44rem !important;\n    margin-right: 44rem !important;\n  }\n\n  .mx-xxl-90 {\n    margin-left: 44.5rem !important;\n    margin-right: 44.5rem !important;\n  }\n\n  .mx-xxl-91 {\n    margin-left: 45rem !important;\n    margin-right: 45rem !important;\n  }\n\n  .mx-xxl-92 {\n    margin-left: 45.5rem !important;\n    margin-right: 45.5rem !important;\n  }\n\n  .mx-xxl-93 {\n    margin-left: 46rem !important;\n    margin-right: 46rem !important;\n  }\n\n  .mx-xxl-94 {\n    margin-left: 46.5rem !important;\n    margin-right: 46.5rem !important;\n  }\n\n  .mx-xxl-95 {\n    margin-left: 47rem !important;\n    margin-right: 47rem !important;\n  }\n\n  .mx-xxl-96 {\n    margin-left: 47.5rem !important;\n    margin-right: 47.5rem !important;\n  }\n\n  .mx-xxl-97 {\n    margin-left: 48rem !important;\n    margin-right: 48rem !important;\n  }\n\n  .mx-xxl-98 {\n    margin-left: 48.5rem !important;\n    margin-right: 48.5rem !important;\n  }\n\n  .mx-xxl-99 {\n    margin-left: 49rem !important;\n    margin-right: 49rem !important;\n  }\n\n  .mx-xxl-100 {\n    margin-left: 49.5rem !important;\n    margin-right: 49.5rem !important;\n  }\n\n  .mx-xxl-101 {\n    margin-left: 50rem !important;\n    margin-right: 50rem !important;\n  }\n\n  .mx-xxl-102 {\n    margin-left: 50.5rem !important;\n    margin-right: 50.5rem !important;\n  }\n\n  .mx-xxl-103 {\n    margin-left: 51rem !important;\n    margin-right: 51rem !important;\n  }\n\n  .mx-xxl-104 {\n    margin-left: 51.5rem !important;\n    margin-right: 51.5rem !important;\n  }\n\n  .mx-xxl-105 {\n    margin-left: 52rem !important;\n    margin-right: 52rem !important;\n  }\n\n  .mx-xxl-106 {\n    margin-left: 52.5rem !important;\n    margin-right: 52.5rem !important;\n  }\n\n  .mx-xxl-107 {\n    margin-left: 53rem !important;\n    margin-right: 53rem !important;\n  }\n\n  .mx-xxl-108 {\n    margin-left: 53.5rem !important;\n    margin-right: 53.5rem !important;\n  }\n\n  .mx-xxl-109 {\n    margin-left: 54rem !important;\n    margin-right: 54rem !important;\n  }\n\n  .mx-xxl-110 {\n    margin-left: 54.5rem !important;\n    margin-right: 54.5rem !important;\n  }\n\n  .mx-xxl-111 {\n    margin-left: 55rem !important;\n    margin-right: 55rem !important;\n  }\n\n  .mx-xxl-112 {\n    margin-left: 55.5rem !important;\n    margin-right: 55.5rem !important;\n  }\n\n  .mx-xxl-113 {\n    margin-left: 56rem !important;\n    margin-right: 56rem !important;\n  }\n\n  .mx-xxl-114 {\n    margin-left: 56.5rem !important;\n    margin-right: 56.5rem !important;\n  }\n\n  .mx-xxl-115 {\n    margin-left: 57rem !important;\n    margin-right: 57rem !important;\n  }\n\n  .mx-xxl-116 {\n    margin-left: 57.5rem !important;\n    margin-right: 57.5rem !important;\n  }\n\n  .mx-xxl-117 {\n    margin-left: 58rem !important;\n    margin-right: 58rem !important;\n  }\n\n  .mx-xxl-118 {\n    margin-left: 58.5rem !important;\n    margin-right: 58.5rem !important;\n  }\n\n  .mx-xxl-119 {\n    margin-left: 59rem !important;\n    margin-right: 59rem !important;\n  }\n\n  .mx-xxl-120 {\n    margin-left: 59.5rem !important;\n    margin-right: 59.5rem !important;\n  }\n\n  .mx-xxl-121 {\n    margin-left: 60rem !important;\n    margin-right: 60rem !important;\n  }\n\n  .mx-xxl-122 {\n    margin-left: 60.5rem !important;\n    margin-right: 60.5rem !important;\n  }\n\n  .mx-xxl-123 {\n    margin-left: 61rem !important;\n    margin-right: 61rem !important;\n  }\n\n  .mx-xxl-124 {\n    margin-left: 61.5rem !important;\n    margin-right: 61.5rem !important;\n  }\n\n  .mx-xxl-125 {\n    margin-left: 62rem !important;\n    margin-right: 62rem !important;\n  }\n\n  .mx-xxl-126 {\n    margin-left: 62.5rem !important;\n    margin-right: 62.5rem !important;\n  }\n\n  .mx-xxl-127 {\n    margin-left: 63rem !important;\n    margin-right: 63rem !important;\n  }\n\n  .mx-xxl-128 {\n    margin-left: 63.5rem !important;\n    margin-right: 63.5rem !important;\n  }\n\n  .mx-xxl-129 {\n    margin-left: 64rem !important;\n    margin-right: 64rem !important;\n  }\n\n  .mx-xxl-130 {\n    margin-left: 64.5rem !important;\n    margin-right: 64.5rem !important;\n  }\n\n  .mx-xxl-131 {\n    margin-left: 65rem !important;\n    margin-right: 65rem !important;\n  }\n\n  .mx-xxl-132 {\n    margin-left: 65.5rem !important;\n    margin-right: 65.5rem !important;\n  }\n\n  .mx-xxl-133 {\n    margin-left: 66rem !important;\n    margin-right: 66rem !important;\n  }\n\n  .mx-xxl-134 {\n    margin-left: 66.5rem !important;\n    margin-right: 66.5rem !important;\n  }\n\n  .mx-xxl-135 {\n    margin-left: 67rem !important;\n    margin-right: 67rem !important;\n  }\n\n  .mx-xxl-136 {\n    margin-left: 67.5rem !important;\n    margin-right: 67.5rem !important;\n  }\n\n  .mx-xxl-137 {\n    margin-left: 68rem !important;\n    margin-right: 68rem !important;\n  }\n\n  .mx-xxl-138 {\n    margin-left: 68.5rem !important;\n    margin-right: 68.5rem !important;\n  }\n\n  .mx-xxl-139 {\n    margin-left: 69rem !important;\n    margin-right: 69rem !important;\n  }\n\n  .mx-xxl-140 {\n    margin-left: 69.5rem !important;\n    margin-right: 69.5rem !important;\n  }\n\n  .mx-xxl-141 {\n    margin-left: 70rem !important;\n    margin-right: 70rem !important;\n  }\n\n  .mx-xxl-142 {\n    margin-left: 70.5rem !important;\n    margin-right: 70.5rem !important;\n  }\n\n  .mx-xxl-143 {\n    margin-left: 71rem !important;\n    margin-right: 71rem !important;\n  }\n\n  .mx-xxl-144 {\n    margin-left: 71.5rem !important;\n    margin-right: 71.5rem !important;\n  }\n\n  .mx-xxl-145 {\n    margin-left: 72rem !important;\n    margin-right: 72rem !important;\n  }\n\n  .mx-xxl-146 {\n    margin-left: 72.5rem !important;\n    margin-right: 72.5rem !important;\n  }\n\n  .mx-xxl-147 {\n    margin-left: 73rem !important;\n    margin-right: 73rem !important;\n  }\n\n  .mx-xxl-148 {\n    margin-left: 73.5rem !important;\n    margin-right: 73.5rem !important;\n  }\n\n  .mx-xxl-149 {\n    margin-left: 74rem !important;\n    margin-right: 74rem !important;\n  }\n\n  .mx-xxl-150 {\n    margin-left: 74.5rem !important;\n    margin-right: 74.5rem !important;\n  }\n\n  .mx-xxl-151 {\n    margin-left: 75rem !important;\n    margin-right: 75rem !important;\n  }\n\n  .mx-xxl-152 {\n    margin-left: 75.5rem !important;\n    margin-right: 75.5rem !important;\n  }\n\n  .mx-xxl-153 {\n    margin-left: 76rem !important;\n    margin-right: 76rem !important;\n  }\n\n  .mx-xxl-154 {\n    margin-left: 76.5rem !important;\n    margin-right: 76.5rem !important;\n  }\n\n  .mx-xxl-155 {\n    margin-left: 77rem !important;\n    margin-right: 77rem !important;\n  }\n\n  .mx-xxl-156 {\n    margin-left: 77.5rem !important;\n    margin-right: 77.5rem !important;\n  }\n\n  .mx-xxl-157 {\n    margin-left: 78rem !important;\n    margin-right: 78rem !important;\n  }\n\n  .mx-xxl-158 {\n    margin-left: 78.5rem !important;\n    margin-right: 78.5rem !important;\n  }\n\n  .mx-xxl-159 {\n    margin-left: 79rem !important;\n    margin-right: 79rem !important;\n  }\n\n  .mx-xxl-160 {\n    margin-left: 79.5rem !important;\n    margin-right: 79.5rem !important;\n  }\n\n  .my-xxl-0 {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem !important;\n  }\n\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xxl-5 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xxl-6 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xxl-7 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xxl-8 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xxl-9 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xxl-10 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xxl-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xxl-12 {\n    margin-top: 5.5rem !important;\n    margin-bottom: 5.5rem !important;\n  }\n\n  .my-xxl-13 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n\n  .my-xxl-14 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n\n  .my-xxl-15 {\n    margin-top: 7rem !important;\n    margin-bottom: 7rem !important;\n  }\n\n  .my-xxl-16 {\n    margin-top: 7.5rem !important;\n    margin-bottom: 7.5rem !important;\n  }\n\n  .my-xxl-17 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n\n  .my-xxl-18 {\n    margin-top: 8.5rem !important;\n    margin-bottom: 8.5rem !important;\n  }\n\n  .my-xxl-19 {\n    margin-top: 9rem !important;\n    margin-bottom: 9rem !important;\n  }\n\n  .my-xxl-20 {\n    margin-top: 9.5rem !important;\n    margin-bottom: 9.5rem !important;\n  }\n\n  .my-xxl-21 {\n    margin-top: 10rem !important;\n    margin-bottom: 10rem !important;\n  }\n\n  .my-xxl-22 {\n    margin-top: 10.5rem !important;\n    margin-bottom: 10.5rem !important;\n  }\n\n  .my-xxl-23 {\n    margin-top: 11rem !important;\n    margin-bottom: 11rem !important;\n  }\n\n  .my-xxl-24 {\n    margin-top: 11.5rem !important;\n    margin-bottom: 11.5rem !important;\n  }\n\n  .my-xxl-25 {\n    margin-top: 12rem !important;\n    margin-bottom: 12rem !important;\n  }\n\n  .my-xxl-26 {\n    margin-top: 12.5rem !important;\n    margin-bottom: 12.5rem !important;\n  }\n\n  .my-xxl-27 {\n    margin-top: 13rem !important;\n    margin-bottom: 13rem !important;\n  }\n\n  .my-xxl-28 {\n    margin-top: 13.5rem !important;\n    margin-bottom: 13.5rem !important;\n  }\n\n  .my-xxl-29 {\n    margin-top: 14rem !important;\n    margin-bottom: 14rem !important;\n  }\n\n  .my-xxl-30 {\n    margin-top: 14.5rem !important;\n    margin-bottom: 14.5rem !important;\n  }\n\n  .my-xxl-31 {\n    margin-top: 15rem !important;\n    margin-bottom: 15rem !important;\n  }\n\n  .my-xxl-32 {\n    margin-top: 15.5rem !important;\n    margin-bottom: 15.5rem !important;\n  }\n\n  .my-xxl-33 {\n    margin-top: 16rem !important;\n    margin-bottom: 16rem !important;\n  }\n\n  .my-xxl-34 {\n    margin-top: 16.5rem !important;\n    margin-bottom: 16.5rem !important;\n  }\n\n  .my-xxl-35 {\n    margin-top: 17rem !important;\n    margin-bottom: 17rem !important;\n  }\n\n  .my-xxl-36 {\n    margin-top: 17.5rem !important;\n    margin-bottom: 17.5rem !important;\n  }\n\n  .my-xxl-37 {\n    margin-top: 18rem !important;\n    margin-bottom: 18rem !important;\n  }\n\n  .my-xxl-38 {\n    margin-top: 18.5rem !important;\n    margin-bottom: 18.5rem !important;\n  }\n\n  .my-xxl-39 {\n    margin-top: 19rem !important;\n    margin-bottom: 19rem !important;\n  }\n\n  .my-xxl-40 {\n    margin-top: 19.5rem !important;\n    margin-bottom: 19.5rem !important;\n  }\n\n  .my-xxl-41 {\n    margin-top: 20rem !important;\n    margin-bottom: 20rem !important;\n  }\n\n  .my-xxl-42 {\n    margin-top: 20.5rem !important;\n    margin-bottom: 20.5rem !important;\n  }\n\n  .my-xxl-43 {\n    margin-top: 21rem !important;\n    margin-bottom: 21rem !important;\n  }\n\n  .my-xxl-44 {\n    margin-top: 21.5rem !important;\n    margin-bottom: 21.5rem !important;\n  }\n\n  .my-xxl-45 {\n    margin-top: 22rem !important;\n    margin-bottom: 22rem !important;\n  }\n\n  .my-xxl-46 {\n    margin-top: 22.5rem !important;\n    margin-bottom: 22.5rem !important;\n  }\n\n  .my-xxl-47 {\n    margin-top: 23rem !important;\n    margin-bottom: 23rem !important;\n  }\n\n  .my-xxl-48 {\n    margin-top: 23.5rem !important;\n    margin-bottom: 23.5rem !important;\n  }\n\n  .my-xxl-49 {\n    margin-top: 24rem !important;\n    margin-bottom: 24rem !important;\n  }\n\n  .my-xxl-50 {\n    margin-top: 24.5rem !important;\n    margin-bottom: 24.5rem !important;\n  }\n\n  .my-xxl-51 {\n    margin-top: 25rem !important;\n    margin-bottom: 25rem !important;\n  }\n\n  .my-xxl-52 {\n    margin-top: 25.5rem !important;\n    margin-bottom: 25.5rem !important;\n  }\n\n  .my-xxl-53 {\n    margin-top: 26rem !important;\n    margin-bottom: 26rem !important;\n  }\n\n  .my-xxl-54 {\n    margin-top: 26.5rem !important;\n    margin-bottom: 26.5rem !important;\n  }\n\n  .my-xxl-55 {\n    margin-top: 27rem !important;\n    margin-bottom: 27rem !important;\n  }\n\n  .my-xxl-56 {\n    margin-top: 27.5rem !important;\n    margin-bottom: 27.5rem !important;\n  }\n\n  .my-xxl-57 {\n    margin-top: 28rem !important;\n    margin-bottom: 28rem !important;\n  }\n\n  .my-xxl-58 {\n    margin-top: 28.5rem !important;\n    margin-bottom: 28.5rem !important;\n  }\n\n  .my-xxl-59 {\n    margin-top: 29rem !important;\n    margin-bottom: 29rem !important;\n  }\n\n  .my-xxl-60 {\n    margin-top: 29.5rem !important;\n    margin-bottom: 29.5rem !important;\n  }\n\n  .my-xxl-61 {\n    margin-top: 30rem !important;\n    margin-bottom: 30rem !important;\n  }\n\n  .my-xxl-62 {\n    margin-top: 30.5rem !important;\n    margin-bottom: 30.5rem !important;\n  }\n\n  .my-xxl-63 {\n    margin-top: 31rem !important;\n    margin-bottom: 31rem !important;\n  }\n\n  .my-xxl-64 {\n    margin-top: 31.5rem !important;\n    margin-bottom: 31.5rem !important;\n  }\n\n  .my-xxl-65 {\n    margin-top: 32rem !important;\n    margin-bottom: 32rem !important;\n  }\n\n  .my-xxl-66 {\n    margin-top: 32.5rem !important;\n    margin-bottom: 32.5rem !important;\n  }\n\n  .my-xxl-67 {\n    margin-top: 33rem !important;\n    margin-bottom: 33rem !important;\n  }\n\n  .my-xxl-68 {\n    margin-top: 33.5rem !important;\n    margin-bottom: 33.5rem !important;\n  }\n\n  .my-xxl-69 {\n    margin-top: 34rem !important;\n    margin-bottom: 34rem !important;\n  }\n\n  .my-xxl-70 {\n    margin-top: 34.5rem !important;\n    margin-bottom: 34.5rem !important;\n  }\n\n  .my-xxl-71 {\n    margin-top: 35rem !important;\n    margin-bottom: 35rem !important;\n  }\n\n  .my-xxl-72 {\n    margin-top: 35.5rem !important;\n    margin-bottom: 35.5rem !important;\n  }\n\n  .my-xxl-73 {\n    margin-top: 36rem !important;\n    margin-bottom: 36rem !important;\n  }\n\n  .my-xxl-74 {\n    margin-top: 36.5rem !important;\n    margin-bottom: 36.5rem !important;\n  }\n\n  .my-xxl-75 {\n    margin-top: 37rem !important;\n    margin-bottom: 37rem !important;\n  }\n\n  .my-xxl-76 {\n    margin-top: 37.5rem !important;\n    margin-bottom: 37.5rem !important;\n  }\n\n  .my-xxl-77 {\n    margin-top: 38rem !important;\n    margin-bottom: 38rem !important;\n  }\n\n  .my-xxl-78 {\n    margin-top: 38.5rem !important;\n    margin-bottom: 38.5rem !important;\n  }\n\n  .my-xxl-79 {\n    margin-top: 39rem !important;\n    margin-bottom: 39rem !important;\n  }\n\n  .my-xxl-80 {\n    margin-top: 39.5rem !important;\n    margin-bottom: 39.5rem !important;\n  }\n\n  .my-xxl-81 {\n    margin-top: 40rem !important;\n    margin-bottom: 40rem !important;\n  }\n\n  .my-xxl-82 {\n    margin-top: 40.5rem !important;\n    margin-bottom: 40.5rem !important;\n  }\n\n  .my-xxl-83 {\n    margin-top: 41rem !important;\n    margin-bottom: 41rem !important;\n  }\n\n  .my-xxl-84 {\n    margin-top: 41.5rem !important;\n    margin-bottom: 41.5rem !important;\n  }\n\n  .my-xxl-85 {\n    margin-top: 42rem !important;\n    margin-bottom: 42rem !important;\n  }\n\n  .my-xxl-86 {\n    margin-top: 42.5rem !important;\n    margin-bottom: 42.5rem !important;\n  }\n\n  .my-xxl-87 {\n    margin-top: 43rem !important;\n    margin-bottom: 43rem !important;\n  }\n\n  .my-xxl-88 {\n    margin-top: 43.5rem !important;\n    margin-bottom: 43.5rem !important;\n  }\n\n  .my-xxl-89 {\n    margin-top: 44rem !important;\n    margin-bottom: 44rem !important;\n  }\n\n  .my-xxl-90 {\n    margin-top: 44.5rem !important;\n    margin-bottom: 44.5rem !important;\n  }\n\n  .my-xxl-91 {\n    margin-top: 45rem !important;\n    margin-bottom: 45rem !important;\n  }\n\n  .my-xxl-92 {\n    margin-top: 45.5rem !important;\n    margin-bottom: 45.5rem !important;\n  }\n\n  .my-xxl-93 {\n    margin-top: 46rem !important;\n    margin-bottom: 46rem !important;\n  }\n\n  .my-xxl-94 {\n    margin-top: 46.5rem !important;\n    margin-bottom: 46.5rem !important;\n  }\n\n  .my-xxl-95 {\n    margin-top: 47rem !important;\n    margin-bottom: 47rem !important;\n  }\n\n  .my-xxl-96 {\n    margin-top: 47.5rem !important;\n    margin-bottom: 47.5rem !important;\n  }\n\n  .my-xxl-97 {\n    margin-top: 48rem !important;\n    margin-bottom: 48rem !important;\n  }\n\n  .my-xxl-98 {\n    margin-top: 48.5rem !important;\n    margin-bottom: 48.5rem !important;\n  }\n\n  .my-xxl-99 {\n    margin-top: 49rem !important;\n    margin-bottom: 49rem !important;\n  }\n\n  .my-xxl-100 {\n    margin-top: 49.5rem !important;\n    margin-bottom: 49.5rem !important;\n  }\n\n  .my-xxl-101 {\n    margin-top: 50rem !important;\n    margin-bottom: 50rem !important;\n  }\n\n  .my-xxl-102 {\n    margin-top: 50.5rem !important;\n    margin-bottom: 50.5rem !important;\n  }\n\n  .my-xxl-103 {\n    margin-top: 51rem !important;\n    margin-bottom: 51rem !important;\n  }\n\n  .my-xxl-104 {\n    margin-top: 51.5rem !important;\n    margin-bottom: 51.5rem !important;\n  }\n\n  .my-xxl-105 {\n    margin-top: 52rem !important;\n    margin-bottom: 52rem !important;\n  }\n\n  .my-xxl-106 {\n    margin-top: 52.5rem !important;\n    margin-bottom: 52.5rem !important;\n  }\n\n  .my-xxl-107 {\n    margin-top: 53rem !important;\n    margin-bottom: 53rem !important;\n  }\n\n  .my-xxl-108 {\n    margin-top: 53.5rem !important;\n    margin-bottom: 53.5rem !important;\n  }\n\n  .my-xxl-109 {\n    margin-top: 54rem !important;\n    margin-bottom: 54rem !important;\n  }\n\n  .my-xxl-110 {\n    margin-top: 54.5rem !important;\n    margin-bottom: 54.5rem !important;\n  }\n\n  .my-xxl-111 {\n    margin-top: 55rem !important;\n    margin-bottom: 55rem !important;\n  }\n\n  .my-xxl-112 {\n    margin-top: 55.5rem !important;\n    margin-bottom: 55.5rem !important;\n  }\n\n  .my-xxl-113 {\n    margin-top: 56rem !important;\n    margin-bottom: 56rem !important;\n  }\n\n  .my-xxl-114 {\n    margin-top: 56.5rem !important;\n    margin-bottom: 56.5rem !important;\n  }\n\n  .my-xxl-115 {\n    margin-top: 57rem !important;\n    margin-bottom: 57rem !important;\n  }\n\n  .my-xxl-116 {\n    margin-top: 57.5rem !important;\n    margin-bottom: 57.5rem !important;\n  }\n\n  .my-xxl-117 {\n    margin-top: 58rem !important;\n    margin-bottom: 58rem !important;\n  }\n\n  .my-xxl-118 {\n    margin-top: 58.5rem !important;\n    margin-bottom: 58.5rem !important;\n  }\n\n  .my-xxl-119 {\n    margin-top: 59rem !important;\n    margin-bottom: 59rem !important;\n  }\n\n  .my-xxl-120 {\n    margin-top: 59.5rem !important;\n    margin-bottom: 59.5rem !important;\n  }\n\n  .my-xxl-121 {\n    margin-top: 60rem !important;\n    margin-bottom: 60rem !important;\n  }\n\n  .my-xxl-122 {\n    margin-top: 60.5rem !important;\n    margin-bottom: 60.5rem !important;\n  }\n\n  .my-xxl-123 {\n    margin-top: 61rem !important;\n    margin-bottom: 61rem !important;\n  }\n\n  .my-xxl-124 {\n    margin-top: 61.5rem !important;\n    margin-bottom: 61.5rem !important;\n  }\n\n  .my-xxl-125 {\n    margin-top: 62rem !important;\n    margin-bottom: 62rem !important;\n  }\n\n  .my-xxl-126 {\n    margin-top: 62.5rem !important;\n    margin-bottom: 62.5rem !important;\n  }\n\n  .my-xxl-127 {\n    margin-top: 63rem !important;\n    margin-bottom: 63rem !important;\n  }\n\n  .my-xxl-128 {\n    margin-top: 63.5rem !important;\n    margin-bottom: 63.5rem !important;\n  }\n\n  .my-xxl-129 {\n    margin-top: 64rem !important;\n    margin-bottom: 64rem !important;\n  }\n\n  .my-xxl-130 {\n    margin-top: 64.5rem !important;\n    margin-bottom: 64.5rem !important;\n  }\n\n  .my-xxl-131 {\n    margin-top: 65rem !important;\n    margin-bottom: 65rem !important;\n  }\n\n  .my-xxl-132 {\n    margin-top: 65.5rem !important;\n    margin-bottom: 65.5rem !important;\n  }\n\n  .my-xxl-133 {\n    margin-top: 66rem !important;\n    margin-bottom: 66rem !important;\n  }\n\n  .my-xxl-134 {\n    margin-top: 66.5rem !important;\n    margin-bottom: 66.5rem !important;\n  }\n\n  .my-xxl-135 {\n    margin-top: 67rem !important;\n    margin-bottom: 67rem !important;\n  }\n\n  .my-xxl-136 {\n    margin-top: 67.5rem !important;\n    margin-bottom: 67.5rem !important;\n  }\n\n  .my-xxl-137 {\n    margin-top: 68rem !important;\n    margin-bottom: 68rem !important;\n  }\n\n  .my-xxl-138 {\n    margin-top: 68.5rem !important;\n    margin-bottom: 68.5rem !important;\n  }\n\n  .my-xxl-139 {\n    margin-top: 69rem !important;\n    margin-bottom: 69rem !important;\n  }\n\n  .my-xxl-140 {\n    margin-top: 69.5rem !important;\n    margin-bottom: 69.5rem !important;\n  }\n\n  .my-xxl-141 {\n    margin-top: 70rem !important;\n    margin-bottom: 70rem !important;\n  }\n\n  .my-xxl-142 {\n    margin-top: 70.5rem !important;\n    margin-bottom: 70.5rem !important;\n  }\n\n  .my-xxl-143 {\n    margin-top: 71rem !important;\n    margin-bottom: 71rem !important;\n  }\n\n  .my-xxl-144 {\n    margin-top: 71.5rem !important;\n    margin-bottom: 71.5rem !important;\n  }\n\n  .my-xxl-145 {\n    margin-top: 72rem !important;\n    margin-bottom: 72rem !important;\n  }\n\n  .my-xxl-146 {\n    margin-top: 72.5rem !important;\n    margin-bottom: 72.5rem !important;\n  }\n\n  .my-xxl-147 {\n    margin-top: 73rem !important;\n    margin-bottom: 73rem !important;\n  }\n\n  .my-xxl-148 {\n    margin-top: 73.5rem !important;\n    margin-bottom: 73.5rem !important;\n  }\n\n  .my-xxl-149 {\n    margin-top: 74rem !important;\n    margin-bottom: 74rem !important;\n  }\n\n  .my-xxl-150 {\n    margin-top: 74.5rem !important;\n    margin-bottom: 74.5rem !important;\n  }\n\n  .my-xxl-151 {\n    margin-top: 75rem !important;\n    margin-bottom: 75rem !important;\n  }\n\n  .my-xxl-152 {\n    margin-top: 75.5rem !important;\n    margin-bottom: 75.5rem !important;\n  }\n\n  .my-xxl-153 {\n    margin-top: 76rem !important;\n    margin-bottom: 76rem !important;\n  }\n\n  .my-xxl-154 {\n    margin-top: 76.5rem !important;\n    margin-bottom: 76.5rem !important;\n  }\n\n  .my-xxl-155 {\n    margin-top: 77rem !important;\n    margin-bottom: 77rem !important;\n  }\n\n  .my-xxl-156 {\n    margin-top: 77.5rem !important;\n    margin-bottom: 77.5rem !important;\n  }\n\n  .my-xxl-157 {\n    margin-top: 78rem !important;\n    margin-bottom: 78rem !important;\n  }\n\n  .my-xxl-158 {\n    margin-top: 78.5rem !important;\n    margin-bottom: 78.5rem !important;\n  }\n\n  .my-xxl-159 {\n    margin-top: 79rem !important;\n    margin-bottom: 79rem !important;\n  }\n\n  .my-xxl-160 {\n    margin-top: 79.5rem !important;\n    margin-bottom: 79.5rem !important;\n  }\n}\n/*Background Colors*/\n.bg-sky-light-5 {\n  background-color: rgba(235, 249, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-light-4 {\n  background-color: rgba(199, 238, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-light-3 {\n  background-color: rgba(153, 223, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-light-2 {\n  background-color: rgba(107, 209, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-light-1 {\n  background-color: rgba(61, 195, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky {\n  background-color: rgba(0, 176, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-dark-5 {\n  background-color: rgba(0, 88, 128, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-dark-4 {\n  background-color: rgba(0, 106, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-dark-3 {\n  background-color: rgba(0, 123, 179, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-dark-2 {\n  background-color: rgba(0, 141, 204, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sky-dark-1 {\n  background-color: rgba(0, 158, 230, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-light-5 {\n  background-color: rgba(235, 252, 245, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-light-4 {\n  background-color: rgba(199, 246, 227, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-light-3 {\n  background-color: rgba(153, 239, 204, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-light-2 {\n  background-color: rgba(107, 231, 181, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-light-1 {\n  background-color: rgba(61, 224, 158, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green {\n  background-color: rgba(0, 214, 127, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-dark-5 {\n  background-color: rgba(0, 107, 64, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-dark-4 {\n  background-color: rgba(0, 128, 76, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-dark-3 {\n  background-color: rgba(0, 150, 89, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-dark-2 {\n  background-color: rgba(0, 171, 102, var(--bs-bg-opacity)) !important;\n}\n\n.bg-green-dark-1 {\n  background-color: rgba(0, 193, 114, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-light-5 {\n  background-color: rgba(235, 252, 245, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-light-4 {\n  background-color: rgba(199, 246, 227, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-light-3 {\n  background-color: rgba(153, 239, 204, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-light-2 {\n  background-color: rgba(107, 231, 181, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-light-1 {\n  background-color: rgba(61, 224, 158, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  background-color: rgba(0, 214, 127, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-dark-5 {\n  background-color: rgba(0, 107, 64, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-dark-4 {\n  background-color: rgba(0, 128, 76, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-dark-3 {\n  background-color: rgba(0, 150, 89, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-dark-2 {\n  background-color: rgba(0, 171, 102, var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-dark-1 {\n  background-color: rgba(0, 193, 114, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-light-5 {\n  background-color: rgba(255, 250, 235, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-light-4 {\n  background-color: rgba(255, 242, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-light-3 {\n  background-color: rgba(255, 231, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-light-2 {\n  background-color: rgba(255, 221, 107, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-light-1 {\n  background-color: rgba(255, 210, 61, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow {\n  background-color: rgba(255, 196, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-dark-5 {\n  background-color: rgba(128, 98, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-dark-4 {\n  background-color: rgba(153, 118, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-dark-3 {\n  background-color: rgba(179, 137, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-dark-2 {\n  background-color: rgba(204, 157, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow-dark-1 {\n  background-color: rgba(230, 176, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-light-5 {\n  background-color: rgba(255, 250, 235, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-light-4 {\n  background-color: rgba(255, 242, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-light-3 {\n  background-color: rgba(255, 231, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-light-2 {\n  background-color: rgba(255, 221, 107, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-light-1 {\n  background-color: rgba(255, 210, 61, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  background-color: rgba(255, 196, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-dark-5 {\n  background-color: rgba(128, 98, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-dark-4 {\n  background-color: rgba(153, 118, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-dark-3 {\n  background-color: rgba(179, 137, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-dark-2 {\n  background-color: rgba(204, 157, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning-dark-1 {\n  background-color: rgba(230, 176, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-light-5 {\n  background-color: rgba(255, 235, 235, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-light-4 {\n  background-color: rgba(255, 199, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-light-3 {\n  background-color: rgba(255, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-light-2 {\n  background-color: rgba(255, 107, 107, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-light-1 {\n  background-color: rgba(255, 61, 61, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red {\n  background-color: rgba(255, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-dark-5 {\n  background-color: rgba(128, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-dark-4 {\n  background-color: rgba(153, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-dark-3 {\n  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-dark-2 {\n  background-color: rgba(204, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-red-dark-1 {\n  background-color: rgba(230, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-light-5 {\n  background-color: rgba(255, 235, 235, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-light-4 {\n  background-color: rgba(255, 199, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-light-3 {\n  background-color: rgba(255, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-light-2 {\n  background-color: rgba(255, 107, 107, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-light-1 {\n  background-color: rgba(255, 61, 61, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  background-color: rgba(255, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-dark-5 {\n  background-color: rgba(128, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-dark-4 {\n  background-color: rgba(153, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-dark-3 {\n  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-dark-2 {\n  background-color: rgba(204, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-dark-1 {\n  background-color: rgba(230, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-light-5 {\n  background-color: rgba(238, 246, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-light-4 {\n  background-color: rgba(208, 230, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-light-3 {\n  background-color: rgba(169, 209, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-light-2 {\n  background-color: rgba(131, 189, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-light-1 {\n  background-color: rgba(92, 168, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue {\n  background-color: rgba(41, 141, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-dark-5 {\n  background-color: rgba(21, 71, 128, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-dark-4 {\n  background-color: rgba(25, 85, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-dark-3 {\n  background-color: rgba(29, 99, 179, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-dark-2 {\n  background-color: rgba(33, 113, 204, var(--bs-bg-opacity)) !important;\n}\n\n.bg-blue-dark-1 {\n  background-color: rgba(37, 127, 230, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-light-5 {\n  background-color: rgba(8, 54, 77, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-light-4 {\n  background-color: rgba(199, 226, 229, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-light-3 {\n  background-color: rgba(153, 203, 207, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-light-2 {\n  background-color: rgba(107, 180, 186, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-light-1 {\n  background-color: rgba(61, 156, 165, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary {\n  background-color: rgba(0, 125, 136, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-dark-5 {\n  background-color: rgba(0, 63, 68, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-dark-4 {\n  background-color: rgba(0, 75, 82, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-dark-3 {\n  background-color: rgba(0, 88, 95, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-dark-2 {\n  background-color: rgba(0, 100, 109, var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-dark-1 {\n  background-color: rgba(0, 113, 122, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-light-5 {\n  background-color: rgba(237, 252, 254, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-light-4 {\n  background-color: rgba(204, 248, 251, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-light-3 {\n  background-color: rgba(163, 241, 249, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-light-2 {\n  background-color: rgba(121, 235, 246, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-light-1 {\n  background-color: rgba(79, 229, 243, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan {\n  background-color: rgba(24, 221, 239, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-dark-5 {\n  background-color: rgba(12, 111, 120, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-dark-4 {\n  background-color: rgba(14, 133, 143, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-dark-3 {\n  background-color: rgba(17, 155, 167, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-dark-2 {\n  background-color: rgba(19, 177, 191, var(--bs-bg-opacity)) !important;\n}\n\n.bg-cyan-dark-1 {\n  background-color: rgba(22, 199, 215, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-light-5 {\n  background-color: rgba(237, 252, 254, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-light-4 {\n  background-color: rgba(204, 248, 251, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-light-3 {\n  background-color: rgba(163, 241, 249, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-light-2 {\n  background-color: rgba(121, 235, 246, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-light-1 {\n  background-color: rgba(79, 229, 243, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  background-color: rgba(24, 221, 239, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-dark-5 {\n  background-color: rgba(12, 111, 120, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-dark-4 {\n  background-color: rgba(14, 133, 143, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-dark-3 {\n  background-color: rgba(17, 155, 167, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-dark-2 {\n  background-color: rgba(19, 177, 191, var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-dark-1 {\n  background-color: rgba(22, 199, 215, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-light-5 {\n  background-color: rgba(247, 247, 247, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-light-4 {\n  background-color: rgba(234, 234, 234, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-light-3 {\n  background-color: rgba(216, 216, 216, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-light-2 {\n  background-color: rgba(199, 199, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-light-1 {\n  background-color: rgba(181, 181, 181, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey {\n  background-color: rgba(158, 158, 158, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-dark-1 {\n  background-color: rgba(142, 142, 142, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-dark-2 {\n  background-color: rgba(126, 126, 126, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-dark-3 {\n  background-color: rgba(111, 111, 111, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-dark-4 {\n  background-color: rgba(95, 95, 95, var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-dark-5 {\n  background-color: rgba(79, 79, 79, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-light-5 {\n  background-color: rgba(243, 243, 243, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-light-4 {\n  background-color: rgba(223, 223, 223, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-light-3 {\n  background-color: rgba(197, 197, 197, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-light-2 {\n  background-color: rgba(171, 171, 171, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-light-1 {\n  background-color: rgba(146, 146, 146, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  background-color: rgba(111, 111, 111, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-dark-1 {\n  background-color: rgba(100, 100, 100, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-dark-2 {\n  background-color: rgba(89, 89, 89, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-dark-3 {\n  background-color: rgba(78, 78, 78, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-dark-4 {\n  background-color: rgba(67, 67, 67, var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary-dark-5 {\n  background-color: rgba(56, 56, 56, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-light-5 {\n  background-color: rgba(253, 238, 246, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-light-4 {\n  background-color: rgba(250, 208, 231, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-light-3 {\n  background-color: rgba(246, 169, 211, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-light-2 {\n  background-color: rgba(242, 131, 191, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-light-1 {\n  background-color: rgba(238, 92, 171, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink {\n  background-color: rgba(233, 41, 144, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-dark-5 {\n  background-color: rgba(117, 21, 72, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-dark-4 {\n  background-color: rgba(140, 25, 86, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-dark-3 {\n  background-color: rgba(163, 29, 101, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-dark-2 {\n  background-color: rgba(186, 33, 115, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink-dark-1 {\n  background-color: rgba(210, 37, 130, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-light-5 {\n  background-color: rgba(250, 238, 254, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-light-4 {\n  background-color: rgba(241, 209, 252, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-light-3 {\n  background-color: rgba(230, 172, 250, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-light-2 {\n  background-color: rgba(218, 134, 248, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-light-1 {\n  background-color: rgba(207, 97, 246, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple {\n  background-color: rgba(192, 47, 243, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-dark-5 {\n  background-color: rgba(96, 24, 122, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-dark-4 {\n  background-color: rgba(115, 28, 146, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-dark-3 {\n  background-color: rgba(134, 33, 170, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-dark-2 {\n  background-color: rgba(154, 38, 194, var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-dark-1 {\n  background-color: rgba(173, 42, 219, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-light-5 {\n  background-color: rgba(244, 238, 254, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-light-4 {\n  background-color: rgba(224, 208, 253, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-light-3 {\n  background-color: rgba(199, 169, 252, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-light-2 {\n  background-color: rgba(174, 131, 251, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-light-1 {\n  background-color: rgba(149, 92, 250, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet {\n  background-color: rgba(116, 41, 248, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-dark-5 {\n  background-color: rgba(58, 21, 124, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-dark-4 {\n  background-color: rgba(70, 25, 149, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-dark-3 {\n  background-color: rgba(81, 29, 174, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-dark-2 {\n  background-color: rgba(93, 33, 198, var(--bs-bg-opacity)) !important;\n}\n\n.bg-violet-dark-1 {\n  background-color: rgba(104, 37, 223, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-light-5 {\n  background-color: rgba(235, 243, 254, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-light-4 {\n  background-color: rgba(199, 222, 253, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-light-3 {\n  background-color: rgba(153, 195, 252, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-light-2 {\n  background-color: rgba(107, 168, 250, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-light-1 {\n  background-color: rgba(61, 141, 249, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo {\n  background-color: rgba(0, 105, 247, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-dark-5 {\n  background-color: rgba(0, 53, 124, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-dark-4 {\n  background-color: rgba(0, 63, 148, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-dark-3 {\n  background-color: rgba(0, 74, 173, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-dark-2 {\n  background-color: rgba(0, 84, 198, var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo-dark-1 {\n  background-color: rgba(0, 95, 222, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-light-5 {\n  background-color: rgba(235, 245, 245, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-light-4 {\n  background-color: rgba(199, 226, 229, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-light-3 {\n  background-color: rgba(153, 203, 207, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-light-2 {\n  background-color: rgba(107, 180, 186, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-light-1 {\n  background-color: rgba(61, 156, 165, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal {\n  background-color: rgba(0, 125, 136, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-dark-5 {\n  background-color: rgba(0, 63, 68, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-dark-4 {\n  background-color: rgba(0, 75, 82, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-dark-3 {\n  background-color: rgba(0, 88, 95, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-dark-2 {\n  background-color: rgba(0, 100, 109, var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal-dark-1 {\n  background-color: rgba(0, 113, 122, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-light-5 {\n  background-color: rgba(245, 253, 238, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-light-4 {\n  background-color: rgba(227, 249, 209, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-light-3 {\n  background-color: rgba(205, 243, 172, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-light-2 {\n  background-color: rgba(182, 238, 135, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-light-1 {\n  background-color: rgba(159, 233, 98, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon {\n  background-color: rgba(129, 226, 48, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-dark-5 {\n  background-color: rgba(65, 113, 24, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-dark-4 {\n  background-color: rgba(77, 136, 29, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-dark-3 {\n  background-color: rgba(90, 158, 34, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-dark-2 {\n  background-color: rgba(103, 181, 38, var(--bs-bg-opacity)) !important;\n}\n\n.bg-neon-dark-1 {\n  background-color: rgba(116, 203, 43, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-light-5 {\n  background-color: rgba(250, 253, 239, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-light-4 {\n  background-color: rgba(242, 250, 211, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-light-3 {\n  background-color: rgba(231, 246, 176, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-light-2 {\n  background-color: rgba(220, 242, 140, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-light-1 {\n  background-color: rgba(209, 238, 105, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime {\n  background-color: rgba(194, 233, 57, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-dark-5 {\n  background-color: rgba(97, 117, 29, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-dark-4 {\n  background-color: rgba(116, 140, 34, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-dark-3 {\n  background-color: rgba(136, 163, 40, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-dark-2 {\n  background-color: rgba(155, 186, 46, var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime-dark-1 {\n  background-color: rgba(175, 210, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-light-5 {\n  background-color: rgba(255, 253, 235, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-light-4 {\n  background-color: rgba(255, 250, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-light-3 {\n  background-color: rgba(255, 247, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-light-2 {\n  background-color: rgba(255, 243, 107, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-light-1 {\n  background-color: rgba(255, 239, 61, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun {\n  background-color: rgba(255, 234, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-dark-5 {\n  background-color: rgba(128, 117, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-dark-4 {\n  background-color: rgba(153, 140, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-dark-3 {\n  background-color: rgba(179, 164, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-dark-2 {\n  background-color: rgba(204, 187, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-sun-dark-1 {\n  background-color: rgba(230, 211, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-light-5 {\n  background-color: rgba(255, 246, 235, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-light-4 {\n  background-color: rgba(255, 231, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-light-3 {\n  background-color: rgba(255, 211, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-light-2 {\n  background-color: rgba(255, 191, 107, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-light-1 {\n  background-color: rgba(255, 171, 61, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange {\n  background-color: rgba(255, 145, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-dark-5 {\n  background-color: rgba(128, 73, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-dark-4 {\n  background-color: rgba(153, 87, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-dark-3 {\n  background-color: rgba(179, 102, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-dark-2 {\n  background-color: rgba(204, 116, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-orange-dark-1 {\n  background-color: rgba(230, 131, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-light-5 {\n  background-color: rgba(255, 242, 235, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-light-4 {\n  background-color: rgba(255, 218, 199, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-light-3 {\n  background-color: rgba(255, 188, 153, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-light-2 {\n  background-color: rgba(255, 158, 107, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-light-1 {\n  background-color: rgba(255, 127, 61, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin {\n  background-color: rgba(255, 87, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-dark-5 {\n  background-color: rgba(128, 44, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-dark-4 {\n  background-color: rgba(153, 52, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-dark-3 {\n  background-color: rgba(179, 61, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-dark-2 {\n  background-color: rgba(204, 70, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-pumpkin-dark-1 {\n  background-color: rgba(230, 78, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-light-5 {\n  background-color: rgba(247, 241, 236, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-light-4 {\n  background-color: rgba(232, 216, 204, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-light-3 {\n  background-color: rgba(213, 184, 161, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-light-2 {\n  background-color: rgba(194, 152, 119, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-light-1 {\n  background-color: rgba(174, 120, 77, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown {\n  background-color: rgba(149, 77, 21, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-dark-5 {\n  background-color: rgba(75, 39, 11, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-dark-4 {\n  background-color: rgba(89, 46, 13, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-dark-3 {\n  background-color: rgba(104, 54, 15, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-dark-2 {\n  background-color: rgba(119, 62, 17, var(--bs-bg-opacity)) !important;\n}\n\n.bg-brown-dark-1 {\n  background-color: rgba(134, 69, 19, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-light-5 {\n  background-color: rgba(250, 247, 240, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-light-4 {\n  background-color: rgba(242, 232, 215, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-light-3 {\n  background-color: rgba(231, 213, 182, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-light-2 {\n  background-color: rgba(220, 195, 149, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-light-1 {\n  background-color: rgba(209, 176, 117, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold {\n  background-color: rgba(195, 151, 73, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-dark-5 {\n  background-color: rgba(98, 76, 37, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-dark-4 {\n  background-color: rgba(117, 91, 44, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-dark-3 {\n  background-color: rgba(137, 106, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-dark-2 {\n  background-color: rgba(156, 121, 58, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gold-dark-1 {\n  background-color: rgba(176, 136, 66, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-light-5 {\n  background-color: rgba(242, 245, 246, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-light-4 {\n  background-color: rgba(220, 226, 229, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-light-3 {\n  background-color: rgba(191, 203, 208, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-light-2 {\n  background-color: rgba(162, 180, 187, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-light-1 {\n  background-color: rgba(133, 156, 166, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke {\n  background-color: rgba(94, 125, 138, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-dark-5 {\n  background-color: rgba(47, 63, 69, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-dark-4 {\n  background-color: rgba(56, 75, 83, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-dark-3 {\n  background-color: rgba(66, 88, 97, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-dark-2 {\n  background-color: rgba(75, 100, 110, var(--bs-bg-opacity)) !important;\n}\n\n.bg-smoke-dark-1 {\n  background-color: rgba(85, 113, 124, var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  background-color: rgba(247, 247, 247, var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark-10 {\n  background-color: rgba(47, 52, 58, var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark-20 {\n  background-color: rgba(42, 47, 52, var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark,\n.bg-dark-40 {\n  background-color: rgba(38, 42, 46, var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark-60 {\n  background-color: rgba(33, 36, 41, var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark-80 {\n  background-color: rgba(28, 31, 35, var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark-100 {\n  background-color: rgba(24, 26, 29, var(--bs-bg-opacity)) !important;\n}\n\n.bg-twitter {\n  background-color: #00acee !important;\n}\n\n.bg-facebook {\n  background-color: #1778F2 !important;\n}\n\n.bg-gradient-primary {\n  background: #0a2f4c;\n  background: linear-gradient(45deg, #0a2f4c, #955cfa) !important;\n}\n\n.bg-gradient-info {\n  background: #18DDEF;\n  background: linear-gradient(45deg, #18DDEF, #0a2f4c) !important;\n}\n\n.bg-gradient-success {\n  background: #00D67F;\n  background: linear-gradient(45deg, #00D67F, #81E230) !important;\n}\n\n.bg-gradient-warning {\n  background: #FFC400;\n  background: linear-gradient(45deg, #FFC400, #FFEA00) !important;\n}\n\n.bg-gradient-danger {\n  background: #ff3d3d;\n  background: linear-gradient(45deg, #ff3d3d, #E92990) !important;\n}\n\n.bg-gradient-secondary {\n  background: #6f6f6f;\n  background: linear-gradient(45deg, #6f6f6f, #d8d8d8) !important;\n}\n\n.bg-gradient-light {\n  background: #b5b5b5;\n  background: linear-gradient(45deg, #b5b5b5, #f7f7f7) !important;\n}\n\n.bg-gradient-dark {\n  background: #262a2e;\n  background: linear-gradient(45deg, #262a2e, #6f6f6f) !important;\n}\n\n.bg-gradient-pony {\n  background: #f6a9d3;\n  background: linear-gradient(45deg, #f6a9d3, #4fe5f3) !important;\n}\n\n.bg-gradient-space {\n  background: #cf61f6;\n  background: linear-gradient(45deg, #cf61f6, #ffdd6b) !important;\n}\n\n.bg-gradient-streaks {\n  background: #7429F8;\n  background: linear-gradient(45deg, #7429F8, #0a2f4c) !important;\n}\n\n.bg-gradient-bunting {\n  background: #5ca8ff;\n  background: linear-gradient(45deg, #5ca8ff, #d5b8a1) !important;\n}\n\n.bg-gradient-paradise {\n  background: #00357c;\n  background: linear-gradient(45deg, #00357c, #7429F8) !important;\n}\n\n.bg-gradient-heaven {\n  background: #81E230;\n  background: linear-gradient(45deg, #81E230, #00B0FF) !important;\n}\n\n.bg-gradient-honey {\n  background: #C2E939;\n  background: linear-gradient(45deg, #C2E939, #FF9100) !important;\n}\n\n.bg-gradient-warbler {\n  background: #FFEA00;\n  background: linear-gradient(45deg, #FFEA00, #9e9e9e) !important;\n}\n\n.bg-gradient-dusk {\n  background: #ff7f3d;\n  background: linear-gradient(45deg, #ff7f3d, #955cfa) !important;\n}\n\n.bg-gradient-citrine {\n  background: #ba2173;\n  background: linear-gradient(45deg, #ba2173, #68360f) !important;\n}\n\n.bg-gradient-royston {\n  background: #6be7b5;\n  background: linear-gradient(45deg, #6be7b5, #c29877) !important;\n}\n\n.bg-gradient-ashes {\n  background: #2f3f45;\n  background: linear-gradient(45deg, #2f3f45, #4b646e) !important;\n}\n\n.bg-gradient-metal {\n  background: #C39749;\n  background: linear-gradient(45deg, #C39749, #9e9e9e) !important;\n}\n\n.bg-gradient-sunset {\n  background: #ff7f3d;\n  background: linear-gradient(45deg, #ff7f3d, #ffab3d) !important;\n}\n\n.overlay-wrap {\n  position: relative;\n}\n.overlay-wrap .bg-overlay {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n}\n\n/*Text Colors*/\n.text-sky {\n  color: rgba(0, 176, 255, var(--bs-text-opacity)) !important;\n}\n\n.text-cyan {\n  color: rgba(24, 221, 239, var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  color: rgba(24, 221, 239, var(--bs-text-opacity)) !important;\n}\n\n.text-green {\n  color: rgba(0, 214, 127, var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  color: rgba(0, 214, 127, var(--bs-text-opacity)) !important;\n}\n\n.text-yellow {\n  color: rgba(255, 196, 0, var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  color: rgba(255, 196, 0, var(--bs-text-opacity)) !important;\n}\n\n.text-red {\n  color: rgba(255, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  color: rgba(255, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.text-blue {\n  color: rgba(41, 141, 255, var(--bs-text-opacity)) !important;\n}\n\n.text-primary {\n  color: rgba(0, 125, 136, var(--bs-text-opacity)) !important;\n}\n\n.text-pink {\n  color: rgba(233, 41, 144, var(--bs-text-opacity)) !important;\n}\n\n.text-purple {\n  color: rgba(192, 47, 243, var(--bs-text-opacity)) !important;\n}\n\n.text-violet {\n  color: rgba(116, 41, 248, var(--bs-text-opacity)) !important;\n}\n\n.text-indigo {\n  color: rgba(0, 105, 247, var(--bs-text-opacity)) !important;\n}\n\n.text-teal {\n  color: rgba(0, 125, 136, var(--bs-text-opacity)) !important;\n}\n\n.text-neon {\n  color: rgba(129, 226, 48, var(--bs-text-opacity)) !important;\n}\n\n.text-lime {\n  color: rgba(194, 233, 57, var(--bs-text-opacity)) !important;\n}\n\n.text-sun {\n  color: rgba(255, 234, 0, var(--bs-text-opacity)) !important;\n}\n\n.text-orange {\n  color: rgba(255, 145, 0, var(--bs-text-opacity)) !important;\n}\n\n.text-pumpkin {\n  color: rgba(255, 87, 0, var(--bs-text-opacity)) !important;\n}\n\n.text-brown {\n  color: rgba(149, 77, 21, var(--bs-text-opacity)) !important;\n}\n\n.text-gold {\n  color: rgba(195, 151, 73, var(--bs-text-opacity)) !important;\n}\n\n.text-smoke {\n  color: rgba(94, 125, 138, var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  color: rgba(111, 111, 111, var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  color: rgba(111, 111, 111, var(--bs-text-opacity)) !important;\n}\n\n.text-grey {\n  color: rgba(158, 158, 158, var(--bs-text-opacity)) !important;\n}\n\n.text-dark-10 {\n  color: rgba(47, 52, 58, var(--bs-text-opacity)) !important;\n}\n\n.text-dark-20 {\n  color: rgba(42, 47, 52, var(--bs-text-opacity)) !important;\n}\n\n.text-dark,\n.text-dark-40 {\n  color: rgba(38, 42, 46, var(--bs-text-opacity)) !important;\n}\n\n.text-dark-60 {\n  color: rgba(33, 36, 41, var(--bs-text-opacity)) !important;\n}\n\n.text-dark-80 {\n  color: rgba(28, 31, 35, var(--bs-text-opacity)) !important;\n}\n\n.text-dark-100 {\n  color: rgba(24, 26, 29, var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  color: rgba(126, 126, 126, var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  color: rgba(111, 111, 111, var(--bs-text-opacity)) !important;\n}\n\n.text-disabled {\n  color: rgba(181, 181, 181, var(--bs-text-opacity)) !important;\n}\n\n.text-high-em {\n  color: #262a2e;\n  font-weight: 500;\n}\n\n.text-medium-em {\n  color: #262a2e;\n  font-size: .875rem;\n}\n\n.text-low-em {\n  font-size: .75rem;\n}\n\n/*Border*/\n.border-dashed {\n  border-style: dashed !important;\n}\n\n.border-dotted {\n  border-style: dotted !important;\n}\n\n.circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill-start {\n  border-top-left-radius: 50rem !important;\n  border-bottom-left-radius: 50rem !important;\n}\n\n.rounded-pill-end {\n  border-top-right-radius: 50rem !important;\n  border-bottom-right-radius: 50rem !important;\n}\n\n.rounded-top-start {\n  border-top-left-radius: 0.25rem !important;\n}\n\n.rounded-top-end {\n  border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom-start {\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-bottom-end {\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-start-0 {\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-top-end-0 {\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-start-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-bottom-start-0 {\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-end-0 {\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-0 {\n  border-radius: 0rem !important;\n}\n\n.rounded-1 {\n  border-radius: 0.125rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.375rem !important;\n}\n\n.rounded-4 {\n  border-radius: 0.5rem !important;\n}\n\n.rounded-5 {\n  border-radius: 0.625rem !important;\n}\n\n.rounded-6 {\n  border-radius: 0.75rem !important;\n}\n\n.rounded-7 {\n  border-radius: 0.875rem !important;\n}\n\n.rounded-8 {\n  border-radius: 1rem !important;\n}\n\n.rounded-9 {\n  border-radius: 1.125rem !important;\n}\n\n.rounded-10 {\n  border-radius: 1.25rem !important;\n}\n\n.rounded-11 {\n  border-radius: 1.375rem !important;\n}\n\n.rounded-12 {\n  border-radius: 1.5rem !important;\n}\n\n.rounded-13 {\n  border-radius: 1.625rem !important;\n}\n\n.rounded-14 {\n  border-radius: 1.75rem !important;\n}\n\n.rounded-15 {\n  border-radius: 1.875rem !important;\n}\n\n.rounded-16 {\n  border-radius: 2rem !important;\n}\n\n.rounded-17 {\n  border-radius: 2.125rem !important;\n}\n\n.rounded-18 {\n  border-radius: 2.25rem !important;\n}\n\n.rounded-19 {\n  border-radius: 2.375rem !important;\n}\n\n.rounded-20 {\n  border-radius: 2.5rem !important;\n}\n\n.rounded-21 {\n  border-radius: 2.75rem !important;\n}\n\n.rounded-22 {\n  border-radius: 3rem !important;\n}\n\n.rounded-23 {\n  border-radius: 3.25rem !important;\n}\n\n.rounded-24 {\n  border-radius: 3.5rem !important;\n}\n\n.rounded-25 {\n  border-radius: 3.75rem !important;\n}\n\n.rounded-26 {\n  border-radius: 4rem !important;\n}\n\n.rounded-27 {\n  border-radius: 4.25rem !important;\n}\n\n.rounded-28 {\n  border-radius: 4.5rem !important;\n}\n\n.rounded-29 {\n  border-radius: 4.75rem !important;\n}\n\n.rounded-30 {\n  border-radius: 5rem !important;\n}\n\n.rounded-31 {\n  border-radius: 5.25rem !important;\n}\n\n.rounded-32 {\n  border-radius: 5.5rem !important;\n}\n\n.rounded-33 {\n  border-radius: 5.75rem !important;\n}\n\n.rounded-34 {\n  border-radius: 6rem !important;\n}\n\n.border-sky {\n  border-color: #00B0FF !important;\n}\n\n.border-cyan {\n  border-color: #18DDEF !important;\n}\n\n.border-info {\n  border-color: #18DDEF !important;\n}\n\n.border-red {\n  border-color: #FF0000 !important;\n}\n\n.border-danger {\n  border-color: #FF0000 !important;\n}\n\n.border-green {\n  border-color: #00D67F !important;\n}\n\n.border-success {\n  border-color: #00D67F !important;\n}\n\n.border-yellow {\n  border-color: #FFC400 !important;\n}\n\n.border-warning {\n  border-color: #FFC400 !important;\n}\n\n.border-pink {\n  border-color: #E92990 !important;\n}\n\n.border-purple {\n  border-color: #C02FF3 !important;\n}\n\n.border-violet {\n  border-color: #7429F8 !important;\n}\n\n.border-indigo {\n  border-color: #0069F7 !important;\n}\n\n.border-blue {\n  border-color: #298DFF !important;\n}\n\n.border-primary {\n  border-color: #0a2f4c !important;\n}\n\n.border-teal {\n  border-color: #0a2f4c !important;\n}\n\n.border-neon {\n  border-color: #81E230 !important;\n}\n\n.border-lime {\n  border-color: #C2E939 !important;\n}\n\n.border-sun {\n  border-color: #FFEA00 !important;\n}\n\n.border-orange {\n  border-color: #FF9100 !important;\n}\n\n.border-pumpkin {\n  border-color: #FF5700 !important;\n}\n\n.border-brown {\n  border-color: #954D15 !important;\n}\n\n.border-gold {\n  border-color: #C39749 !important;\n}\n\n.border-smoke {\n  border-color: #5e7d8a !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.border-light {\n  border-color: #d8d8d8 !important;\n}\n\n.border-dark-10 {\n  border-color: #2F343A !important;\n}\n\n.border-dark-20 {\n  border-color: #2a2f34 !important;\n}\n\n.border-dark,\n.border-dark-40 {\n  border-color: #262a2e !important;\n}\n\n.border-dark-60 {\n  border-color: #212429 !important;\n}\n\n.border-dark-80 {\n  border-color: #1c1f23 !important;\n}\n\n.border-dark-100 {\n  border-color: #181a1d !important;\n}\n\n.border-grey {\n  border-color: #9e9e9e !important;\n}\n\n.border-secondary {\n  border-color: #6f6f6f !important;\n}\n\n.subtractive-example > .d-inline-block {\n  border: 1px solid #9e9e9e;\n}\n\n/*Colors*/\n.color-palette-wrap .color-wrap {\n  padding: 1rem;\n}\n\n/*Shadow*/\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover-sm {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover-lg {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-xl {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover-xl {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-sm-sky {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sm-sky.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sm-sky.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sm-sky.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sm-sky.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-hover-sm-sky {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-sky:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sm-sky:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sm-sky:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sm-sky:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sm-sky:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-sky {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sky.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sky.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sky.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-sky.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-hover-sky {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sky:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sky:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sky:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sky:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-sky:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-lg-sky {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-lg-sky.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-lg-sky.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-lg-sky.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-lg-sky.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-hover-lg-sky {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-sky:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-lg-sky:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-lg-sky:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-lg-sky:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-lg-sky:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-xl-sky {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-xl-sky.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-xl-sky.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-xl-sky.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-xl-sky.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-hover-xl-sky {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-sky:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-xl-sky:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-xl-sky:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-xl-sky:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n.shadow-hover-xl-sky:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 176, 255, 0.1) !important;\n}\n\n.shadow-sm-cyan {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-cyan.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-cyan.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-cyan.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-cyan.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-sm-cyan {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-cyan:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-cyan:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-cyan:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-cyan:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-cyan:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-cyan {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-cyan.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-cyan.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-cyan.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-cyan.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-cyan {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-cyan:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-cyan:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-cyan:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-cyan:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-cyan:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-lg-cyan {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-cyan.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-cyan.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-cyan.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-cyan.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-lg-cyan {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-cyan:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-cyan:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-cyan:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-cyan:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-cyan:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-xl-cyan {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-cyan.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-cyan.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-cyan.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-cyan.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-xl-cyan {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-cyan:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-cyan:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-cyan:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-cyan:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-cyan:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-sm-info {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-info.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-info.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-info.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-sm-info.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-sm-info {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-info:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-info:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-info:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-info:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-sm-info:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-info {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-info.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-info.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-info.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-info.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-info {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-info:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-info:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-info:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-info:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-info:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-lg-info {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-info.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-info.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-info.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-lg-info.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-lg-info {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-info:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-info:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-info:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-info:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-lg-info:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-xl-info {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-info.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-info.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-info.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-xl-info.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-hover-xl-info {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-info:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-info:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-info:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-info:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n.shadow-hover-xl-info:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(24, 221, 239, 0.1) !important;\n}\n\n.shadow-sm-green {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-green.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-green.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-green.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-green.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-sm-green {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-green:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-green:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-green:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-green:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-green:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-green {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-green.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-green.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-green.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-green.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-green {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-green:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-green:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-green:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-green:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-green:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-lg-green {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-green.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-green.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-green.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-green.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-lg-green {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-green:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-green:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-green:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-green:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-green:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-xl-green {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-green.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-green.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-green.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-green.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-xl-green {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-green:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-green:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-green:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-green:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-green:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-sm-success {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-success.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-success.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-success.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-sm-success.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-sm-success {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-success:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-success:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-success:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-success:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-sm-success:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-success {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-success.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-success.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-success.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-success.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-success {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-success:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-success:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-success:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-success:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-success:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-lg-success {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-success.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-success.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-success.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-lg-success.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-lg-success {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-success:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-success:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-success:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-success:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-lg-success:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-xl-success {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-success.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-success.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-success.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-xl-success.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-hover-xl-success {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-success:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-success:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-success:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-success:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n.shadow-hover-xl-success:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 214, 127, 0.1) !important;\n}\n\n.shadow-sm-yellow {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-yellow.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-yellow.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-yellow.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-yellow.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-sm-yellow {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-yellow:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-yellow:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-yellow:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-yellow:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-yellow:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-yellow {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-yellow.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-yellow.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-yellow.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-yellow.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-yellow {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-yellow:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-yellow:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-yellow:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-yellow:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-yellow:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-lg-yellow {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-yellow.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-yellow.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-yellow.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-yellow.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-lg-yellow {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-yellow:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-yellow:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-yellow:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-yellow:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-yellow:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-xl-yellow {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-yellow.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-yellow.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-yellow.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-yellow.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-xl-yellow {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-yellow:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-yellow:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-yellow:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-yellow:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-yellow:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-sm-warning {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-warning.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-warning.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-warning.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-sm-warning.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-sm-warning {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-warning:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-warning:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-warning:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-warning:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-sm-warning:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-warning {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-warning.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-warning.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-warning.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-warning.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-warning {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-warning:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-warning:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-warning:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-warning:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-warning:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-lg-warning {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-warning.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-warning.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-warning.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-lg-warning.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-lg-warning {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-warning:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-warning:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-warning:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-warning:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-lg-warning:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-xl-warning {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-warning.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-warning.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-warning.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-xl-warning.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-hover-xl-warning {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-warning:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-warning:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-warning:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-warning:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n.shadow-hover-xl-warning:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 196, 0, 0.1) !important;\n}\n\n.shadow-sm-red {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-red.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-red.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-red.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-red.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-sm-red {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-red:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-red:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-red:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-red:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-red:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-red {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-red.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-red.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-red.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-red.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-red {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-red:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-red:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-red:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-red:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-red:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-lg-red {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-red.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-red.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-red.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-red.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-lg-red {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-red:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-red:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-red:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-red:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-red:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-xl-red {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-red.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-red.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-red.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-red.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-xl-red {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-red:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-red:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-red:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-red:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-red:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-sm-danger {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-danger.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-danger.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-danger.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-sm-danger.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-sm-danger {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-danger:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-danger:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-danger:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-danger:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-sm-danger:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-danger {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-danger.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-danger.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-danger.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-danger.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-danger {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-danger:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-danger:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-danger:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-danger:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-danger:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-lg-danger {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-danger.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-danger.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-danger.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-lg-danger.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-lg-danger {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-danger:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-danger:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-danger:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-danger:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-lg-danger:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-xl-danger {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-danger.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-danger.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-danger.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-xl-danger.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-hover-xl-danger {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-danger:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-danger:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-danger:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-danger:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n.shadow-hover-xl-danger:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 0, 0, 0.1) !important;\n}\n\n.shadow-sm-blue {\n  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-sm-blue.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-sm-blue.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-sm-blue.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-sm-blue.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-hover-sm-blue {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-blue:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-sm-blue:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-sm-blue:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-sm-blue:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-sm-blue:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-blue {\n  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-blue.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-blue.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-blue.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-blue.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-hover-blue {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-blue:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-blue:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-blue:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-blue:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-blue:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-lg-blue {\n  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-lg-blue.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-lg-blue.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-lg-blue.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-lg-blue.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-hover-lg-blue {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-blue:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-lg-blue:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-lg-blue:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-lg-blue:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-lg-blue:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-xl-blue {\n  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-xl-blue.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-xl-blue.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-xl-blue.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-xl-blue.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-hover-xl-blue {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-blue:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-xl-blue:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-xl-blue:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-xl-blue:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n.shadow-hover-xl-blue:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(41, 141, 255, 0.1) !important;\n}\n\n.shadow-sm-primary {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-primary.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-primary.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-primary.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-primary.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-sm-primary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-primary:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-primary:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-primary:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-primary:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-primary:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-primary {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-primary.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-primary.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-primary.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-primary.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-primary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-primary:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-primary:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-primary:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-primary:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-primary:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-lg-primary {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-primary.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-primary.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-primary.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-primary.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-lg-primary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-primary:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-primary:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-primary:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-primary:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-primary:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-xl-primary {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-primary.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-primary.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-primary.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-primary.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-xl-primary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-primary:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-primary:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-primary:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-primary:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-primary:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-sm-pink {\n  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-sm-pink.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-sm-pink.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-sm-pink.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-sm-pink.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-hover-sm-pink {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-pink:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-sm-pink:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-sm-pink:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-sm-pink:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-sm-pink:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-pink {\n  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-pink.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-pink.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-pink.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-pink.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-hover-pink {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-pink:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-pink:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-pink:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-pink:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-pink:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-lg-pink {\n  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-lg-pink.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-lg-pink.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-lg-pink.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-lg-pink.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-hover-lg-pink {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-pink:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-lg-pink:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-lg-pink:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-lg-pink:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-lg-pink:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-xl-pink {\n  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-xl-pink.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-xl-pink.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-xl-pink.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-xl-pink.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-hover-xl-pink {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-pink:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-xl-pink:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-xl-pink:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-xl-pink:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n.shadow-hover-xl-pink:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(233, 41, 144, 0.1) !important;\n}\n\n.shadow-sm-purple {\n  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-sm-purple.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-sm-purple.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-sm-purple.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-sm-purple.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-hover-sm-purple {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-purple:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-sm-purple:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-sm-purple:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-sm-purple:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-sm-purple:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-purple {\n  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-purple.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-purple.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-purple.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-purple.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-hover-purple {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-purple:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-purple:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-purple:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-purple:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-purple:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-lg-purple {\n  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-lg-purple.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-lg-purple.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-lg-purple.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-lg-purple.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-hover-lg-purple {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-purple:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-lg-purple:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-lg-purple:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-lg-purple:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-lg-purple:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-xl-purple {\n  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-xl-purple.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-xl-purple.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-xl-purple.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-xl-purple.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-hover-xl-purple {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-purple:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-xl-purple:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-xl-purple:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-xl-purple:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n.shadow-hover-xl-purple:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(192, 47, 243, 0.1) !important;\n}\n\n.shadow-sm-violet {\n  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-sm-violet.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-sm-violet.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-sm-violet.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-sm-violet.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-hover-sm-violet {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-violet:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-sm-violet:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-sm-violet:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-sm-violet:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-sm-violet:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-violet {\n  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-violet.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-violet.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-violet.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-violet.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-hover-violet {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-violet:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-violet:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-violet:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-violet:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-violet:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-lg-violet {\n  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-lg-violet.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-lg-violet.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-lg-violet.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-lg-violet.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-hover-lg-violet {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-violet:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-lg-violet:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-lg-violet:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-lg-violet:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-lg-violet:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-xl-violet {\n  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-xl-violet.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-xl-violet.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-xl-violet.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-xl-violet.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-hover-xl-violet {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-violet:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-xl-violet:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-xl-violet:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-xl-violet:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n.shadow-hover-xl-violet:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(116, 41, 248, 0.1) !important;\n}\n\n.shadow-sm-indigo {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-sm-indigo.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-sm-indigo.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-sm-indigo.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-sm-indigo.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-hover-sm-indigo {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-indigo:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-sm-indigo:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-sm-indigo:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-sm-indigo:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-sm-indigo:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-indigo {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-indigo.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-indigo.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-indigo.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-indigo.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-hover-indigo {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-indigo:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-indigo:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-indigo:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-indigo:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-indigo:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-lg-indigo {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-lg-indigo.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-lg-indigo.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-lg-indigo.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-lg-indigo.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-hover-lg-indigo {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-indigo:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-lg-indigo:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-lg-indigo:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-lg-indigo:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-lg-indigo:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-xl-indigo {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-xl-indigo.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-xl-indigo.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-xl-indigo.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-xl-indigo.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-hover-xl-indigo {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-indigo:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-xl-indigo:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-xl-indigo:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-xl-indigo:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n.shadow-hover-xl-indigo:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 105, 247, 0.1) !important;\n}\n\n.shadow-sm-teal {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-teal.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-teal.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-teal.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-sm-teal.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-sm-teal {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-teal:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-teal:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-teal:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-teal:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-sm-teal:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-teal {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-teal.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-teal.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-teal.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-teal.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-teal {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-teal:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-teal:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-teal:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-teal:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-teal:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-lg-teal {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-teal.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-teal.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-teal.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-lg-teal.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-lg-teal {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-teal:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-teal:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-teal:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-teal:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-lg-teal:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-xl-teal {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-teal.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-teal.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-teal.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-xl-teal.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-hover-xl-teal {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-teal:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-teal:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-teal:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-teal:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n.shadow-hover-xl-teal:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(0, 125, 136, 0.1) !important;\n}\n\n.shadow-sm-neon {\n  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-sm-neon.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-sm-neon.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-sm-neon.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-sm-neon.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-hover-sm-neon {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-neon:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-sm-neon:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-sm-neon:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-sm-neon:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-sm-neon:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-neon {\n  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-neon.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-neon.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-neon.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-neon.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-hover-neon {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-neon:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-neon:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-neon:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-neon:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-neon:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-lg-neon {\n  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-lg-neon.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-lg-neon.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-lg-neon.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-lg-neon.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-hover-lg-neon {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-neon:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-lg-neon:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-lg-neon:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-lg-neon:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-lg-neon:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-xl-neon {\n  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-xl-neon.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-xl-neon.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-xl-neon.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-xl-neon.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-hover-xl-neon {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-neon:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-xl-neon:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-xl-neon:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-xl-neon:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n.shadow-hover-xl-neon:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(129, 226, 48, 0.1) !important;\n}\n\n.shadow-sm-lime {\n  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-sm-lime.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-sm-lime.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-sm-lime.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-sm-lime.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-hover-sm-lime {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-lime:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-sm-lime:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-sm-lime:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-sm-lime:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-sm-lime:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-lime {\n  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lime.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lime.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lime.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lime.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-hover-lime {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lime:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lime:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lime:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lime:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lime:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-lg-lime {\n  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lg-lime.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lg-lime.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lg-lime.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-lg-lime.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-hover-lg-lime {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-lime:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lg-lime:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lg-lime:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lg-lime:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-lg-lime:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-xl-lime {\n  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-xl-lime.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-xl-lime.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-xl-lime.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-xl-lime.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-hover-xl-lime {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-lime:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-xl-lime:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-xl-lime:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-xl-lime:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n.shadow-hover-xl-lime:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(194, 233, 57, 0.1) !important;\n}\n\n.shadow-sm-sun {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sm-sun.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sm-sun.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sm-sun.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sm-sun.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-hover-sm-sun {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-sun:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sm-sun:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sm-sun:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sm-sun:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sm-sun:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-sun {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sun.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sun.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sun.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-sun.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-hover-sun {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sun:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sun:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sun:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sun:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-sun:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-lg-sun {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-lg-sun.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-lg-sun.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-lg-sun.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-lg-sun.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-hover-lg-sun {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-sun:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-lg-sun:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-lg-sun:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-lg-sun:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-lg-sun:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-xl-sun {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-xl-sun.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-xl-sun.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-xl-sun.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-xl-sun.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-hover-xl-sun {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-sun:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-xl-sun:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-xl-sun:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-xl-sun:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n.shadow-hover-xl-sun:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 234, 0, 0.1) !important;\n}\n\n.shadow-sm-orange {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-sm-orange.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-sm-orange.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-sm-orange.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-sm-orange.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-hover-sm-orange {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-orange:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-sm-orange:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-sm-orange:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-sm-orange:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-sm-orange:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-orange {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-orange.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-orange.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-orange.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-orange.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-hover-orange {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-orange:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-orange:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-orange:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-orange:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-orange:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-lg-orange {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-lg-orange.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-lg-orange.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-lg-orange.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-lg-orange.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-hover-lg-orange {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-orange:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-lg-orange:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-lg-orange:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-lg-orange:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-lg-orange:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-xl-orange {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-xl-orange.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-xl-orange.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-xl-orange.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-xl-orange.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-hover-xl-orange {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-orange:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-xl-orange:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-xl-orange:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-xl-orange:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n.shadow-hover-xl-orange:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 145, 0, 0.1) !important;\n}\n\n.shadow-sm-pumpkin {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-sm-pumpkin.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-sm-pumpkin.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-sm-pumpkin.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-sm-pumpkin.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-hover-sm-pumpkin {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-pumpkin:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-sm-pumpkin:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-sm-pumpkin:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-sm-pumpkin:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-sm-pumpkin:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-pumpkin {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-pumpkin.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-pumpkin.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-pumpkin.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-pumpkin.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-hover-pumpkin {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-pumpkin:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-pumpkin:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-pumpkin:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-pumpkin:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-pumpkin:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-lg-pumpkin {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-lg-pumpkin.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-lg-pumpkin.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-lg-pumpkin.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-lg-pumpkin.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-hover-lg-pumpkin {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-pumpkin:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-lg-pumpkin:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-lg-pumpkin:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-lg-pumpkin:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-lg-pumpkin:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-xl-pumpkin {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-xl-pumpkin.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-xl-pumpkin.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-xl-pumpkin.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-xl-pumpkin.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-hover-xl-pumpkin {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-pumpkin:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-xl-pumpkin:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-xl-pumpkin:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-xl-pumpkin:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n.shadow-hover-xl-pumpkin:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 87, 0, 0.1) !important;\n}\n\n.shadow-sm-brown {\n  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-sm-brown.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-sm-brown.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-sm-brown.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-sm-brown.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-hover-sm-brown {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-brown:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-sm-brown:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-sm-brown:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-sm-brown:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-sm-brown:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-brown {\n  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-brown.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-brown.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-brown.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-brown.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-hover-brown {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-brown:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-brown:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-brown:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-brown:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-brown:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-lg-brown {\n  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-lg-brown.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-lg-brown.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-lg-brown.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-lg-brown.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-hover-lg-brown {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-brown:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-lg-brown:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-lg-brown:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-lg-brown:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-lg-brown:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-xl-brown {\n  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-xl-brown.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-xl-brown.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-xl-brown.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-xl-brown.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-hover-xl-brown {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-brown:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-xl-brown:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-xl-brown:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-xl-brown:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n.shadow-hover-xl-brown:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(149, 77, 21, 0.1) !important;\n}\n\n.shadow-sm-gold {\n  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-sm-gold.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-sm-gold.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-sm-gold.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-sm-gold.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-hover-sm-gold {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-gold:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-sm-gold:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-sm-gold:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-sm-gold:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-sm-gold:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-gold {\n  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-gold.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-gold.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-gold.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-gold.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-hover-gold {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-gold:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-gold:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-gold:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-gold:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-gold:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-lg-gold {\n  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-lg-gold.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-lg-gold.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-lg-gold.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-lg-gold.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-hover-lg-gold {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-gold:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-lg-gold:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-lg-gold:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-lg-gold:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-lg-gold:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-xl-gold {\n  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-xl-gold.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-xl-gold.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-xl-gold.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-xl-gold.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-hover-xl-gold {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-gold:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-xl-gold:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-xl-gold:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-xl-gold:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n.shadow-hover-xl-gold:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(195, 151, 73, 0.1) !important;\n}\n\n.shadow-sm-smoke {\n  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-sm-smoke.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-sm-smoke.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-sm-smoke.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-sm-smoke.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-hover-sm-smoke {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-smoke:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-sm-smoke:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-sm-smoke:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-sm-smoke:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-sm-smoke:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-smoke {\n  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-smoke.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-smoke.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-smoke.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-smoke.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-hover-smoke {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-smoke:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-smoke:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-smoke:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-smoke:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-smoke:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-lg-smoke {\n  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-lg-smoke.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-lg-smoke.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-lg-smoke.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-lg-smoke.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-hover-lg-smoke {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-smoke:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-lg-smoke:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-lg-smoke:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-lg-smoke:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-lg-smoke:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-xl-smoke {\n  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-xl-smoke.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-xl-smoke.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-xl-smoke.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-xl-smoke.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-hover-xl-smoke {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-smoke:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-xl-smoke:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-xl-smoke:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-xl-smoke:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n.shadow-hover-xl-smoke:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(94, 125, 138, 0.1) !important;\n}\n\n.shadow-sm-grey {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-grey.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-grey.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-grey.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-grey.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-sm-grey {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-grey:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-grey:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-grey:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-grey:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-grey:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-grey {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-grey.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-grey.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-grey.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-grey.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-grey {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-grey:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-grey:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-grey:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-grey:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-grey:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-lg-grey {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-grey.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-grey.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-grey.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-grey.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-lg-grey {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-grey:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-grey:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-grey:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-grey:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-grey:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-xl-grey {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-grey.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-grey.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-grey.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-grey.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-xl-grey {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-grey:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-grey:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-grey:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-grey:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-grey:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-sm-secondary {\n  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-sm-secondary.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-sm-secondary.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-sm-secondary.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-sm-secondary.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-hover-sm-secondary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-secondary:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-sm-secondary:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-sm-secondary:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-sm-secondary:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-sm-secondary:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-secondary {\n  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-secondary.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-secondary.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-secondary.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-secondary.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-hover-secondary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-secondary:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-secondary:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-secondary:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-secondary:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-secondary:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-lg-secondary {\n  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-lg-secondary.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-lg-secondary.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-lg-secondary.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-lg-secondary.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-hover-lg-secondary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-secondary:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-lg-secondary:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-lg-secondary:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-lg-secondary:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-lg-secondary:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-xl-secondary {\n  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-xl-secondary.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-xl-secondary.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-xl-secondary.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-xl-secondary.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-hover-xl-secondary {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-secondary:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-xl-secondary:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-xl-secondary:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-xl-secondary:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n.shadow-hover-xl-secondary:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(111, 111, 111, 0.1) !important;\n}\n\n.shadow-sm-light {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-light.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-light.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-light.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-sm-light.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-sm-light {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-light:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-light:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-light:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-light:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-sm-light:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-light {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-light.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-light.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-light.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-light.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-light {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-light:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-light:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-light:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-light:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-light:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-lg-light {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-light.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-light.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-light.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-lg-light.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-lg-light {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-light:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-light:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-light:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-light:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-lg-light:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-xl-light {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-light.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-light.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-light.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-xl-light.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-hover-xl-light {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-light:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-light:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-light:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-light:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n.shadow-hover-xl-light:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(158, 158, 158, 0.1) !important;\n}\n\n.shadow-sm-dark {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm-dark.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm-dark.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm-dark.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-sm-dark.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover-sm-dark {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-dark:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm-dark:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm-dark:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm-dark:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-sm-dark:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-dark {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-dark.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-dark.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-dark.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-dark.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover-dark {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-dark:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-dark:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-dark:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-dark:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-dark:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-lg-dark {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg-dark.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg-dark.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg-dark.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-lg-dark.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover-lg-dark {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-dark:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg-dark:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg-dark:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg-dark:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-lg-dark:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-xl-dark {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl-dark.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl-dark.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl-dark.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-xl-dark.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-hover-xl-dark {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-dark:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl-dark:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl-dark:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl-dark:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n.shadow-hover-xl-dark:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(47, 52, 58, 0.1) !important;\n}\n\n.shadow-sm-white {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-sm-white.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-sm-white.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-sm-white.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-sm-white.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n\n.shadow-hover-sm-white {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-sm-white:hover {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-sm-white:hover.shadow-top {\n  box-shadow: 0 -0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-sm-white:hover.shadow-bottom {\n  box-shadow: 0 0.125rem 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-sm-white:hover.shadow-left {\n  box-shadow: -0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-sm-white:hover.shadow-right {\n  box-shadow: 0.125rem 0 0.125rem rgba(255, 255, 255, 0.1) !important;\n}\n\n.shadow-white {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-white.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-white.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-white.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-white.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n\n.shadow-hover-white {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-white:hover {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-white:hover.shadow-top {\n  box-shadow: 0 -0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-white:hover.shadow-bottom {\n  box-shadow: 0 0.25rem 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-white:hover.shadow-left {\n  box-shadow: -0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-white:hover.shadow-right {\n  box-shadow: 0.25rem 0 0.3125rem rgba(255, 255, 255, 0.1) !important;\n}\n\n.shadow-lg-white {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-lg-white.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-lg-white.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-lg-white.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-lg-white.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n\n.shadow-hover-lg-white {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-lg-white:hover {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-lg-white:hover.shadow-top {\n  box-shadow: 0 -0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-lg-white:hover.shadow-bottom {\n  box-shadow: 0 0.375rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-lg-white:hover.shadow-left {\n  box-shadow: -0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-lg-white:hover.shadow-right {\n  box-shadow: 0.375rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n\n.shadow-xl-white {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-xl-white.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-xl-white.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-xl-white.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-xl-white.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n\n.shadow-hover-xl-white {\n  -webkit-transition: box-shadow 0.3s ease;\n  -moz-transition: box-shadow 0.3s ease;\n  transition: box-shadow 0.3s ease;\n}\n.shadow-hover-xl-white:hover {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-xl-white:hover.shadow-top {\n  box-shadow: 0 -0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-xl-white:hover.shadow-bottom {\n  box-shadow: 0 0.5rem 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-xl-white:hover.shadow-left {\n  box-shadow: -0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n.shadow-hover-xl-white:hover.shadow-right {\n  box-shadow: 0.5rem 0 0.625rem rgba(255, 255, 255, 0.1) !important;\n}\n\n/*Font Size*/\n.fs-7 {\n  font-size: 0.875rem !important;\n}\n\n.fs-8 {\n  font-size: 0.75rem !important;\n}\n\n.font-1 {\n  font-size: 0.5rem !important;\n}\n\n.font-2 {\n  font-size: 0.75rem !important;\n}\n\n.font-3 {\n  font-size: 1rem !important;\n}\n\n.font-4 {\n  font-size: 1.25rem !important;\n}\n\n.font-5 {\n  font-size: 1.5rem !important;\n}\n\n.font-6 {\n  font-size: 1.75rem !important;\n}\n\n.font-7 {\n  font-size: 2rem !important;\n}\n\n.font-8 {\n  font-size: 2.25rem !important;\n}\n\n.font-9 {\n  font-size: 2.5rem !important;\n}\n\n.font-10 {\n  font-size: 2.75rem !important;\n}\n\n/*Font Weight*/\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n/*Text Case*/\n.text-nonecase {\n  text-transform: none !important;\n}\n\n/*Letter Spacing*/\n.ls-0 {\n  letter-spacing: 0px !important;\n}\n\n.ls-1 {\n  letter-spacing: 0.25px !important;\n}\n\n.ls-2 {\n  letter-spacing: 0.5px !important;\n}\n\n.ls-3 {\n  letter-spacing: 0.75px !important;\n}\n\n.ls-4 {\n  letter-spacing: 1px !important;\n}\n\n.ls-n-1 {\n  letter-spacing: -0.25px !important;\n}\n\n.ls-n-2 {\n  letter-spacing: -0.5px !important;\n}\n\n.ls-n-3 {\n  letter-spacing: -0.75px !important;\n}\n\n.ls-n-4 {\n  letter-spacing: -1px !important;\n}\n\n/*Line Height*/\n.lh-0 {\n  line-height: 0 !important;\n}\n\n/*Width*/\n.w-0 {\n  width: 0 !important;\n}\n\n.w-25p {\n  width: 25px !important;\n}\n\n.w-30p {\n  width: 30px !important;\n}\n\n.w-35p {\n  width: 35px !important;\n}\n\n.w-40p {\n  width: 40px !important;\n}\n\n.w-45p {\n  width: 45px !important;\n}\n\n.w-50p {\n  width: 50px !important;\n}\n\n.w-55p {\n  width: 55px !important;\n}\n\n.w-60p {\n  width: 60px !important;\n}\n\n.w-65p {\n  width: 65px !important;\n}\n\n.w-70p {\n  width: 70px !important;\n}\n\n.w-75p {\n  width: 75px !important;\n}\n\n.w-80p {\n  width: 80px !important;\n}\n\n.w-85p {\n  width: 85px !important;\n}\n\n.w-90p {\n  width: 90px !important;\n}\n\n.w-95p {\n  width: 95px !important;\n}\n\n.w-100p {\n  width: 100px !important;\n}\n\n.w-105p {\n  width: 105px !important;\n}\n\n.w-110p {\n  width: 110px !important;\n}\n\n.w-115p {\n  width: 115px !important;\n}\n\n.w-120p {\n  width: 120px !important;\n}\n\n.w-125p {\n  width: 125px !important;\n}\n\n.w-130p {\n  width: 130px !important;\n}\n\n.w-135p {\n  width: 135px !important;\n}\n\n.w-140p {\n  width: 140px !important;\n}\n\n.w-145p {\n  width: 145px !important;\n}\n\n.w-150p {\n  width: 150px !important;\n}\n\n.w-155p {\n  width: 155px !important;\n}\n\n.w-160p {\n  width: 160px !important;\n}\n\n.w-165p {\n  width: 165px !important;\n}\n\n.w-170p {\n  width: 170px !important;\n}\n\n.w-175p {\n  width: 175px !important;\n}\n\n.w-180p {\n  width: 180px !important;\n}\n\n.w-185p {\n  width: 185px !important;\n}\n\n.w-190p {\n  width: 190px !important;\n}\n\n.w-195p {\n  width: 195px !important;\n}\n\n.w-200p {\n  width: 200px !important;\n}\n\n.w-205p {\n  width: 205px !important;\n}\n\n.w-210p {\n  width: 210px !important;\n}\n\n.w-215p {\n  width: 215px !important;\n}\n\n.w-220p {\n  width: 220px !important;\n}\n\n.w-225p {\n  width: 225px !important;\n}\n\n.w-230p {\n  width: 230px !important;\n}\n\n.w-235p {\n  width: 235px !important;\n}\n\n.w-240p {\n  width: 240px !important;\n}\n\n.w-245p {\n  width: 245px !important;\n}\n\n.w-250p {\n  width: 250px !important;\n}\n\n.w-255p {\n  width: 255px !important;\n}\n\n.w-260p {\n  width: 260px !important;\n}\n\n.w-265p {\n  width: 265px !important;\n}\n\n.w-270p {\n  width: 270px !important;\n}\n\n.w-275p {\n  width: 275px !important;\n}\n\n.w-280p {\n  width: 280px !important;\n}\n\n.w-285p {\n  width: 285px !important;\n}\n\n.w-290p {\n  width: 290px !important;\n}\n\n.w-295p {\n  width: 295px !important;\n}\n\n.w-300p {\n  width: 300px !important;\n}\n\n.w-305p {\n  width: 305px !important;\n}\n\n.w-310p {\n  width: 310px !important;\n}\n\n.w-315p {\n  width: 315px !important;\n}\n\n.w-320p {\n  width: 320px !important;\n}\n\n.w-325p {\n  width: 325px !important;\n}\n\n.w-330p {\n  width: 330px !important;\n}\n\n.w-335p {\n  width: 335px !important;\n}\n\n.w-340p {\n  width: 340px !important;\n}\n\n.w-345p {\n  width: 345px !important;\n}\n\n.w-350p {\n  width: 350px !important;\n}\n\n.w-355p {\n  width: 355px !important;\n}\n\n.w-360p {\n  width: 360px !important;\n}\n\n.w-365p {\n  width: 365px !important;\n}\n\n.w-370p {\n  width: 370px !important;\n}\n\n.w-375p {\n  width: 375px !important;\n}\n\n.w-380p {\n  width: 380px !important;\n}\n\n.w-385p {\n  width: 385px !important;\n}\n\n.w-390p {\n  width: 390px !important;\n}\n\n.w-395p {\n  width: 395px !important;\n}\n\n.w-400p {\n  width: 400px !important;\n}\n\n.w-405p {\n  width: 405px !important;\n}\n\n.w-410p {\n  width: 410px !important;\n}\n\n.w-415p {\n  width: 415px !important;\n}\n\n.w-420p {\n  width: 420px !important;\n}\n\n.w-425p {\n  width: 425px !important;\n}\n\n.w-430p {\n  width: 430px !important;\n}\n\n.w-435p {\n  width: 435px !important;\n}\n\n.w-440p {\n  width: 440px !important;\n}\n\n.w-445p {\n  width: 445px !important;\n}\n\n.w-450p {\n  width: 450px !important;\n}\n\n.w-455p {\n  width: 455px !important;\n}\n\n.w-460p {\n  width: 460px !important;\n}\n\n.w-465p {\n  width: 465px !important;\n}\n\n.w-470p {\n  width: 470px !important;\n}\n\n.w-475p {\n  width: 475px !important;\n}\n\n.w-480p {\n  width: 480px !important;\n}\n\n.w-485p {\n  width: 485px !important;\n}\n\n.w-490p {\n  width: 490px !important;\n}\n\n.w-495p {\n  width: 495px !important;\n}\n\n.w-500p {\n  width: 500px !important;\n}\n\n.w-505p {\n  width: 505px !important;\n}\n\n.w-510p {\n  width: 510px !important;\n}\n\n.w-515p {\n  width: 515px !important;\n}\n\n.w-520p {\n  width: 520px !important;\n}\n\n.w-525p {\n  width: 525px !important;\n}\n\n.w-530p {\n  width: 530px !important;\n}\n\n.w-535p {\n  width: 535px !important;\n}\n\n.w-540p {\n  width: 540px !important;\n}\n\n.w-545p {\n  width: 545px !important;\n}\n\n.w-550p {\n  width: 550px !important;\n}\n\n.w-555p {\n  width: 555px !important;\n}\n\n.w-560p {\n  width: 560px !important;\n}\n\n.w-565p {\n  width: 565px !important;\n}\n\n.w-570p {\n  width: 570px !important;\n}\n\n.w-575p {\n  width: 575px !important;\n}\n\n.w-580p {\n  width: 580px !important;\n}\n\n.w-585p {\n  width: 585px !important;\n}\n\n.w-590p {\n  width: 590px !important;\n}\n\n.w-595p {\n  width: 595px !important;\n}\n\n.w-600p {\n  width: 600px !important;\n}\n\n.w-605p {\n  width: 605px !important;\n}\n\n.w-610p {\n  width: 610px !important;\n}\n\n.w-615p {\n  width: 615px !important;\n}\n\n.w-620p {\n  width: 620px !important;\n}\n\n.w-625p {\n  width: 625px !important;\n}\n\n.w-630p {\n  width: 630px !important;\n}\n\n.w-635p {\n  width: 635px !important;\n}\n\n.w-640p {\n  width: 640px !important;\n}\n\n.w-645p {\n  width: 645px !important;\n}\n\n.w-650p {\n  width: 650px !important;\n}\n\n.w-655p {\n  width: 655px !important;\n}\n\n.w-660p {\n  width: 660px !important;\n}\n\n.w-665p {\n  width: 665px !important;\n}\n\n.w-670p {\n  width: 670px !important;\n}\n\n.w-675p {\n  width: 675px !important;\n}\n\n.w-680p {\n  width: 680px !important;\n}\n\n.w-685p {\n  width: 685px !important;\n}\n\n.w-690p {\n  width: 690px !important;\n}\n\n.w-695p {\n  width: 695px !important;\n}\n\n.w-700p {\n  width: 700px !important;\n}\n\n.w-705p {\n  width: 705px !important;\n}\n\n.w-710p {\n  width: 710px !important;\n}\n\n.w-715p {\n  width: 715px !important;\n}\n\n.w-720p {\n  width: 720px !important;\n}\n\n.w-725p {\n  width: 725px !important;\n}\n\n.w-730p {\n  width: 730px !important;\n}\n\n.w-735p {\n  width: 735px !important;\n}\n\n.w-740p {\n  width: 740px !important;\n}\n\n.w-745p {\n  width: 745px !important;\n}\n\n.w-750p {\n  width: 750px !important;\n}\n\n.w-755p {\n  width: 755px !important;\n}\n\n.w-760p {\n  width: 760px !important;\n}\n\n.w-765p {\n  width: 765px !important;\n}\n\n.w-770p {\n  width: 770px !important;\n}\n\n.w-775p {\n  width: 775px !important;\n}\n\n.w-780p {\n  width: 780px !important;\n}\n\n.w-785p {\n  width: 785px !important;\n}\n\n.w-790p {\n  width: 790px !important;\n}\n\n.w-795p {\n  width: 795px !important;\n}\n\n.w-800p {\n  width: 800px !important;\n}\n\n@media (min-width: 576px) {\n  .w-sm-25p {\n    width: 25px !important;\n  }\n\n  .w-sm-30p {\n    width: 30px !important;\n  }\n\n  .w-sm-35p {\n    width: 35px !important;\n  }\n\n  .w-sm-40p {\n    width: 40px !important;\n  }\n\n  .w-sm-45p {\n    width: 45px !important;\n  }\n\n  .w-sm-50p {\n    width: 50px !important;\n  }\n\n  .w-sm-55p {\n    width: 55px !important;\n  }\n\n  .w-sm-60p {\n    width: 60px !important;\n  }\n\n  .w-sm-65p {\n    width: 65px !important;\n  }\n\n  .w-sm-70p {\n    width: 70px !important;\n  }\n\n  .w-sm-75p {\n    width: 75px !important;\n  }\n\n  .w-sm-80p {\n    width: 80px !important;\n  }\n\n  .w-sm-85p {\n    width: 85px !important;\n  }\n\n  .w-sm-90p {\n    width: 90px !important;\n  }\n\n  .w-sm-95p {\n    width: 95px !important;\n  }\n\n  .w-sm-100p {\n    width: 100px !important;\n  }\n\n  .w-sm-105p {\n    width: 105px !important;\n  }\n\n  .w-sm-110p {\n    width: 110px !important;\n  }\n\n  .w-sm-115p {\n    width: 115px !important;\n  }\n\n  .w-sm-120p {\n    width: 120px !important;\n  }\n\n  .w-sm-125p {\n    width: 125px !important;\n  }\n\n  .w-sm-130p {\n    width: 130px !important;\n  }\n\n  .w-sm-135p {\n    width: 135px !important;\n  }\n\n  .w-sm-140p {\n    width: 140px !important;\n  }\n\n  .w-sm-145p {\n    width: 145px !important;\n  }\n\n  .w-sm-150p {\n    width: 150px !important;\n  }\n\n  .w-sm-155p {\n    width: 155px !important;\n  }\n\n  .w-sm-160p {\n    width: 160px !important;\n  }\n\n  .w-sm-165p {\n    width: 165px !important;\n  }\n\n  .w-sm-170p {\n    width: 170px !important;\n  }\n\n  .w-sm-175p {\n    width: 175px !important;\n  }\n\n  .w-sm-180p {\n    width: 180px !important;\n  }\n\n  .w-sm-185p {\n    width: 185px !important;\n  }\n\n  .w-sm-190p {\n    width: 190px !important;\n  }\n\n  .w-sm-195p {\n    width: 195px !important;\n  }\n\n  .w-sm-200p {\n    width: 200px !important;\n  }\n\n  .w-sm-205p {\n    width: 205px !important;\n  }\n\n  .w-sm-210p {\n    width: 210px !important;\n  }\n\n  .w-sm-215p {\n    width: 215px !important;\n  }\n\n  .w-sm-220p {\n    width: 220px !important;\n  }\n\n  .w-sm-225p {\n    width: 225px !important;\n  }\n\n  .w-sm-230p {\n    width: 230px !important;\n  }\n\n  .w-sm-235p {\n    width: 235px !important;\n  }\n\n  .w-sm-240p {\n    width: 240px !important;\n  }\n\n  .w-sm-245p {\n    width: 245px !important;\n  }\n\n  .w-sm-250p {\n    width: 250px !important;\n  }\n\n  .w-sm-255p {\n    width: 255px !important;\n  }\n\n  .w-sm-260p {\n    width: 260px !important;\n  }\n\n  .w-sm-265p {\n    width: 265px !important;\n  }\n\n  .w-sm-270p {\n    width: 270px !important;\n  }\n\n  .w-sm-275p {\n    width: 275px !important;\n  }\n\n  .w-sm-280p {\n    width: 280px !important;\n  }\n\n  .w-sm-285p {\n    width: 285px !important;\n  }\n\n  .w-sm-290p {\n    width: 290px !important;\n  }\n\n  .w-sm-295p {\n    width: 295px !important;\n  }\n\n  .w-sm-300p {\n    width: 300px !important;\n  }\n\n  .w-sm-305p {\n    width: 305px !important;\n  }\n\n  .w-sm-310p {\n    width: 310px !important;\n  }\n\n  .w-sm-315p {\n    width: 315px !important;\n  }\n\n  .w-sm-320p {\n    width: 320px !important;\n  }\n\n  .w-sm-325p {\n    width: 325px !important;\n  }\n\n  .w-sm-330p {\n    width: 330px !important;\n  }\n\n  .w-sm-335p {\n    width: 335px !important;\n  }\n\n  .w-sm-340p {\n    width: 340px !important;\n  }\n\n  .w-sm-345p {\n    width: 345px !important;\n  }\n\n  .w-sm-350p {\n    width: 350px !important;\n  }\n\n  .w-sm-355p {\n    width: 355px !important;\n  }\n\n  .w-sm-360p {\n    width: 360px !important;\n  }\n\n  .w-sm-365p {\n    width: 365px !important;\n  }\n\n  .w-sm-370p {\n    width: 370px !important;\n  }\n\n  .w-sm-375p {\n    width: 375px !important;\n  }\n\n  .w-sm-380p {\n    width: 380px !important;\n  }\n\n  .w-sm-385p {\n    width: 385px !important;\n  }\n\n  .w-sm-390p {\n    width: 390px !important;\n  }\n\n  .w-sm-395p {\n    width: 395px !important;\n  }\n\n  .w-sm-400p {\n    width: 400px !important;\n  }\n\n  .w-sm-405p {\n    width: 405px !important;\n  }\n\n  .w-sm-410p {\n    width: 410px !important;\n  }\n\n  .w-sm-415p {\n    width: 415px !important;\n  }\n\n  .w-sm-420p {\n    width: 420px !important;\n  }\n\n  .w-sm-425p {\n    width: 425px !important;\n  }\n\n  .w-sm-430p {\n    width: 430px !important;\n  }\n\n  .w-sm-435p {\n    width: 435px !important;\n  }\n\n  .w-sm-440p {\n    width: 440px !important;\n  }\n\n  .w-sm-445p {\n    width: 445px !important;\n  }\n\n  .w-sm-450p {\n    width: 450px !important;\n  }\n\n  .w-sm-455p {\n    width: 455px !important;\n  }\n\n  .w-sm-460p {\n    width: 460px !important;\n  }\n\n  .w-sm-465p {\n    width: 465px !important;\n  }\n\n  .w-sm-470p {\n    width: 470px !important;\n  }\n\n  .w-sm-475p {\n    width: 475px !important;\n  }\n\n  .w-sm-480p {\n    width: 480px !important;\n  }\n\n  .w-sm-485p {\n    width: 485px !important;\n  }\n\n  .w-sm-490p {\n    width: 490px !important;\n  }\n\n  .w-sm-495p {\n    width: 495px !important;\n  }\n\n  .w-sm-500p {\n    width: 500px !important;\n  }\n\n  .w-sm-505p {\n    width: 505px !important;\n  }\n\n  .w-sm-510p {\n    width: 510px !important;\n  }\n\n  .w-sm-515p {\n    width: 515px !important;\n  }\n\n  .w-sm-520p {\n    width: 520px !important;\n  }\n\n  .w-sm-525p {\n    width: 525px !important;\n  }\n\n  .w-sm-530p {\n    width: 530px !important;\n  }\n\n  .w-sm-535p {\n    width: 535px !important;\n  }\n\n  .w-sm-540p {\n    width: 540px !important;\n  }\n\n  .w-sm-545p {\n    width: 545px !important;\n  }\n\n  .w-sm-550p {\n    width: 550px !important;\n  }\n\n  .w-sm-555p {\n    width: 555px !important;\n  }\n\n  .w-sm-560p {\n    width: 560px !important;\n  }\n\n  .w-sm-565p {\n    width: 565px !important;\n  }\n\n  .w-sm-570p {\n    width: 570px !important;\n  }\n\n  .w-sm-575p {\n    width: 575px !important;\n  }\n\n  .w-sm-580p {\n    width: 580px !important;\n  }\n\n  .w-sm-585p {\n    width: 585px !important;\n  }\n\n  .w-sm-590p {\n    width: 590px !important;\n  }\n\n  .w-sm-595p {\n    width: 595px !important;\n  }\n\n  .w-sm-600p {\n    width: 600px !important;\n  }\n\n  .w-sm-605p {\n    width: 605px !important;\n  }\n\n  .w-sm-610p {\n    width: 610px !important;\n  }\n\n  .w-sm-615p {\n    width: 615px !important;\n  }\n\n  .w-sm-620p {\n    width: 620px !important;\n  }\n\n  .w-sm-625p {\n    width: 625px !important;\n  }\n\n  .w-sm-630p {\n    width: 630px !important;\n  }\n\n  .w-sm-635p {\n    width: 635px !important;\n  }\n\n  .w-sm-640p {\n    width: 640px !important;\n  }\n\n  .w-sm-645p {\n    width: 645px !important;\n  }\n\n  .w-sm-650p {\n    width: 650px !important;\n  }\n\n  .w-sm-655p {\n    width: 655px !important;\n  }\n\n  .w-sm-660p {\n    width: 660px !important;\n  }\n\n  .w-sm-665p {\n    width: 665px !important;\n  }\n\n  .w-sm-670p {\n    width: 670px !important;\n  }\n\n  .w-sm-675p {\n    width: 675px !important;\n  }\n\n  .w-sm-680p {\n    width: 680px !important;\n  }\n\n  .w-sm-685p {\n    width: 685px !important;\n  }\n\n  .w-sm-690p {\n    width: 690px !important;\n  }\n\n  .w-sm-695p {\n    width: 695px !important;\n  }\n\n  .w-sm-700p {\n    width: 700px !important;\n  }\n\n  .w-sm-705p {\n    width: 705px !important;\n  }\n\n  .w-sm-710p {\n    width: 710px !important;\n  }\n\n  .w-sm-715p {\n    width: 715px !important;\n  }\n\n  .w-sm-720p {\n    width: 720px !important;\n  }\n\n  .w-sm-725p {\n    width: 725px !important;\n  }\n\n  .w-sm-730p {\n    width: 730px !important;\n  }\n\n  .w-sm-735p {\n    width: 735px !important;\n  }\n\n  .w-sm-740p {\n    width: 740px !important;\n  }\n\n  .w-sm-745p {\n    width: 745px !important;\n  }\n\n  .w-sm-750p {\n    width: 750px !important;\n  }\n\n  .w-sm-755p {\n    width: 755px !important;\n  }\n\n  .w-sm-760p {\n    width: 760px !important;\n  }\n\n  .w-sm-765p {\n    width: 765px !important;\n  }\n\n  .w-sm-770p {\n    width: 770px !important;\n  }\n\n  .w-sm-775p {\n    width: 775px !important;\n  }\n\n  .w-sm-780p {\n    width: 780px !important;\n  }\n\n  .w-sm-785p {\n    width: 785px !important;\n  }\n\n  .w-sm-790p {\n    width: 790px !important;\n  }\n\n  .w-sm-795p {\n    width: 795px !important;\n  }\n\n  .w-sm-800p {\n    width: 800px !important;\n  }\n}\n@media (min-width: 768px) {\n  .w-md-25p {\n    width: 25px !important;\n  }\n\n  .w-md-30p {\n    width: 30px !important;\n  }\n\n  .w-md-35p {\n    width: 35px !important;\n  }\n\n  .w-md-40p {\n    width: 40px !important;\n  }\n\n  .w-md-45p {\n    width: 45px !important;\n  }\n\n  .w-md-50p {\n    width: 50px !important;\n  }\n\n  .w-md-55p {\n    width: 55px !important;\n  }\n\n  .w-md-60p {\n    width: 60px !important;\n  }\n\n  .w-md-65p {\n    width: 65px !important;\n  }\n\n  .w-md-70p {\n    width: 70px !important;\n  }\n\n  .w-md-75p {\n    width: 75px !important;\n  }\n\n  .w-md-80p {\n    width: 80px !important;\n  }\n\n  .w-md-85p {\n    width: 85px !important;\n  }\n\n  .w-md-90p {\n    width: 90px !important;\n  }\n\n  .w-md-95p {\n    width: 95px !important;\n  }\n\n  .w-md-100p {\n    width: 100px !important;\n  }\n\n  .w-md-105p {\n    width: 105px !important;\n  }\n\n  .w-md-110p {\n    width: 110px !important;\n  }\n\n  .w-md-115p {\n    width: 115px !important;\n  }\n\n  .w-md-120p {\n    width: 120px !important;\n  }\n\n  .w-md-125p {\n    width: 125px !important;\n  }\n\n  .w-md-130p {\n    width: 130px !important;\n  }\n\n  .w-md-135p {\n    width: 135px !important;\n  }\n\n  .w-md-140p {\n    width: 140px !important;\n  }\n\n  .w-md-145p {\n    width: 145px !important;\n  }\n\n  .w-md-150p {\n    width: 150px !important;\n  }\n\n  .w-md-155p {\n    width: 155px !important;\n  }\n\n  .w-md-160p {\n    width: 160px !important;\n  }\n\n  .w-md-165p {\n    width: 165px !important;\n  }\n\n  .w-md-170p {\n    width: 170px !important;\n  }\n\n  .w-md-175p {\n    width: 175px !important;\n  }\n\n  .w-md-180p {\n    width: 180px !important;\n  }\n\n  .w-md-185p {\n    width: 185px !important;\n  }\n\n  .w-md-190p {\n    width: 190px !important;\n  }\n\n  .w-md-195p {\n    width: 195px !important;\n  }\n\n  .w-md-200p {\n    width: 200px !important;\n  }\n\n  .w-md-205p {\n    width: 205px !important;\n  }\n\n  .w-md-210p {\n    width: 210px !important;\n  }\n\n  .w-md-215p {\n    width: 215px !important;\n  }\n\n  .w-md-220p {\n    width: 220px !important;\n  }\n\n  .w-md-225p {\n    width: 225px !important;\n  }\n\n  .w-md-230p {\n    width: 230px !important;\n  }\n\n  .w-md-235p {\n    width: 235px !important;\n  }\n\n  .w-md-240p {\n    width: 240px !important;\n  }\n\n  .w-md-245p {\n    width: 245px !important;\n  }\n\n  .w-md-250p {\n    width: 250px !important;\n  }\n\n  .w-md-255p {\n    width: 255px !important;\n  }\n\n  .w-md-260p {\n    width: 260px !important;\n  }\n\n  .w-md-265p {\n    width: 265px !important;\n  }\n\n  .w-md-270p {\n    width: 270px !important;\n  }\n\n  .w-md-275p {\n    width: 275px !important;\n  }\n\n  .w-md-280p {\n    width: 280px !important;\n  }\n\n  .w-md-285p {\n    width: 285px !important;\n  }\n\n  .w-md-290p {\n    width: 290px !important;\n  }\n\n  .w-md-295p {\n    width: 295px !important;\n  }\n\n  .w-md-300p {\n    width: 300px !important;\n  }\n\n  .w-md-305p {\n    width: 305px !important;\n  }\n\n  .w-md-310p {\n    width: 310px !important;\n  }\n\n  .w-md-315p {\n    width: 315px !important;\n  }\n\n  .w-md-320p {\n    width: 320px !important;\n  }\n\n  .w-md-325p {\n    width: 325px !important;\n  }\n\n  .w-md-330p {\n    width: 330px !important;\n  }\n\n  .w-md-335p {\n    width: 335px !important;\n  }\n\n  .w-md-340p {\n    width: 340px !important;\n  }\n\n  .w-md-345p {\n    width: 345px !important;\n  }\n\n  .w-md-350p {\n    width: 350px !important;\n  }\n\n  .w-md-355p {\n    width: 355px !important;\n  }\n\n  .w-md-360p {\n    width: 360px !important;\n  }\n\n  .w-md-365p {\n    width: 365px !important;\n  }\n\n  .w-md-370p {\n    width: 370px !important;\n  }\n\n  .w-md-375p {\n    width: 375px !important;\n  }\n\n  .w-md-380p {\n    width: 380px !important;\n  }\n\n  .w-md-385p {\n    width: 385px !important;\n  }\n\n  .w-md-390p {\n    width: 390px !important;\n  }\n\n  .w-md-395p {\n    width: 395px !important;\n  }\n\n  .w-md-400p {\n    width: 400px !important;\n  }\n\n  .w-md-405p {\n    width: 405px !important;\n  }\n\n  .w-md-410p {\n    width: 410px !important;\n  }\n\n  .w-md-415p {\n    width: 415px !important;\n  }\n\n  .w-md-420p {\n    width: 420px !important;\n  }\n\n  .w-md-425p {\n    width: 425px !important;\n  }\n\n  .w-md-430p {\n    width: 430px !important;\n  }\n\n  .w-md-435p {\n    width: 435px !important;\n  }\n\n  .w-md-440p {\n    width: 440px !important;\n  }\n\n  .w-md-445p {\n    width: 445px !important;\n  }\n\n  .w-md-450p {\n    width: 450px !important;\n  }\n\n  .w-md-455p {\n    width: 455px !important;\n  }\n\n  .w-md-460p {\n    width: 460px !important;\n  }\n\n  .w-md-465p {\n    width: 465px !important;\n  }\n\n  .w-md-470p {\n    width: 470px !important;\n  }\n\n  .w-md-475p {\n    width: 475px !important;\n  }\n\n  .w-md-480p {\n    width: 480px !important;\n  }\n\n  .w-md-485p {\n    width: 485px !important;\n  }\n\n  .w-md-490p {\n    width: 490px !important;\n  }\n\n  .w-md-495p {\n    width: 495px !important;\n  }\n\n  .w-md-500p {\n    width: 500px !important;\n  }\n\n  .w-md-505p {\n    width: 505px !important;\n  }\n\n  .w-md-510p {\n    width: 510px !important;\n  }\n\n  .w-md-515p {\n    width: 515px !important;\n  }\n\n  .w-md-520p {\n    width: 520px !important;\n  }\n\n  .w-md-525p {\n    width: 525px !important;\n  }\n\n  .w-md-530p {\n    width: 530px !important;\n  }\n\n  .w-md-535p {\n    width: 535px !important;\n  }\n\n  .w-md-540p {\n    width: 540px !important;\n  }\n\n  .w-md-545p {\n    width: 545px !important;\n  }\n\n  .w-md-550p {\n    width: 550px !important;\n  }\n\n  .w-md-555p {\n    width: 555px !important;\n  }\n\n  .w-md-560p {\n    width: 560px !important;\n  }\n\n  .w-md-565p {\n    width: 565px !important;\n  }\n\n  .w-md-570p {\n    width: 570px !important;\n  }\n\n  .w-md-575p {\n    width: 575px !important;\n  }\n\n  .w-md-580p {\n    width: 580px !important;\n  }\n\n  .w-md-585p {\n    width: 585px !important;\n  }\n\n  .w-md-590p {\n    width: 590px !important;\n  }\n\n  .w-md-595p {\n    width: 595px !important;\n  }\n\n  .w-md-600p {\n    width: 600px !important;\n  }\n\n  .w-md-605p {\n    width: 605px !important;\n  }\n\n  .w-md-610p {\n    width: 610px !important;\n  }\n\n  .w-md-615p {\n    width: 615px !important;\n  }\n\n  .w-md-620p {\n    width: 620px !important;\n  }\n\n  .w-md-625p {\n    width: 625px !important;\n  }\n\n  .w-md-630p {\n    width: 630px !important;\n  }\n\n  .w-md-635p {\n    width: 635px !important;\n  }\n\n  .w-md-640p {\n    width: 640px !important;\n  }\n\n  .w-md-645p {\n    width: 645px !important;\n  }\n\n  .w-md-650p {\n    width: 650px !important;\n  }\n\n  .w-md-655p {\n    width: 655px !important;\n  }\n\n  .w-md-660p {\n    width: 660px !important;\n  }\n\n  .w-md-665p {\n    width: 665px !important;\n  }\n\n  .w-md-670p {\n    width: 670px !important;\n  }\n\n  .w-md-675p {\n    width: 675px !important;\n  }\n\n  .w-md-680p {\n    width: 680px !important;\n  }\n\n  .w-md-685p {\n    width: 685px !important;\n  }\n\n  .w-md-690p {\n    width: 690px !important;\n  }\n\n  .w-md-695p {\n    width: 695px !important;\n  }\n\n  .w-md-700p {\n    width: 700px !important;\n  }\n\n  .w-md-705p {\n    width: 705px !important;\n  }\n\n  .w-md-710p {\n    width: 710px !important;\n  }\n\n  .w-md-715p {\n    width: 715px !important;\n  }\n\n  .w-md-720p {\n    width: 720px !important;\n  }\n\n  .w-md-725p {\n    width: 725px !important;\n  }\n\n  .w-md-730p {\n    width: 730px !important;\n  }\n\n  .w-md-735p {\n    width: 735px !important;\n  }\n\n  .w-md-740p {\n    width: 740px !important;\n  }\n\n  .w-md-745p {\n    width: 745px !important;\n  }\n\n  .w-md-750p {\n    width: 750px !important;\n  }\n\n  .w-md-755p {\n    width: 755px !important;\n  }\n\n  .w-md-760p {\n    width: 760px !important;\n  }\n\n  .w-md-765p {\n    width: 765px !important;\n  }\n\n  .w-md-770p {\n    width: 770px !important;\n  }\n\n  .w-md-775p {\n    width: 775px !important;\n  }\n\n  .w-md-780p {\n    width: 780px !important;\n  }\n\n  .w-md-785p {\n    width: 785px !important;\n  }\n\n  .w-md-790p {\n    width: 790px !important;\n  }\n\n  .w-md-795p {\n    width: 795px !important;\n  }\n\n  .w-md-800p {\n    width: 800px !important;\n  }\n}\n@media (min-width: 992px) {\n  .w-lg-25p {\n    width: 25px !important;\n  }\n\n  .w-lg-30p {\n    width: 30px !important;\n  }\n\n  .w-lg-35p {\n    width: 35px !important;\n  }\n\n  .w-lg-40p {\n    width: 40px !important;\n  }\n\n  .w-lg-45p {\n    width: 45px !important;\n  }\n\n  .w-lg-50p {\n    width: 50px !important;\n  }\n\n  .w-lg-55p {\n    width: 55px !important;\n  }\n\n  .w-lg-60p {\n    width: 60px !important;\n  }\n\n  .w-lg-65p {\n    width: 65px !important;\n  }\n\n  .w-lg-70p {\n    width: 70px !important;\n  }\n\n  .w-lg-75p {\n    width: 75px !important;\n  }\n\n  .w-lg-80p {\n    width: 80px !important;\n  }\n\n  .w-lg-85p {\n    width: 85px !important;\n  }\n\n  .w-lg-90p {\n    width: 90px !important;\n  }\n\n  .w-lg-95p {\n    width: 95px !important;\n  }\n\n  .w-lg-100p {\n    width: 100px !important;\n  }\n\n  .w-lg-105p {\n    width: 105px !important;\n  }\n\n  .w-lg-110p {\n    width: 110px !important;\n  }\n\n  .w-lg-115p {\n    width: 115px !important;\n  }\n\n  .w-lg-120p {\n    width: 120px !important;\n  }\n\n  .w-lg-125p {\n    width: 125px !important;\n  }\n\n  .w-lg-130p {\n    width: 130px !important;\n  }\n\n  .w-lg-135p {\n    width: 135px !important;\n  }\n\n  .w-lg-140p {\n    width: 140px !important;\n  }\n\n  .w-lg-145p {\n    width: 145px !important;\n  }\n\n  .w-lg-150p {\n    width: 150px !important;\n  }\n\n  .w-lg-155p {\n    width: 155px !important;\n  }\n\n  .w-lg-160p {\n    width: 160px !important;\n  }\n\n  .w-lg-165p {\n    width: 165px !important;\n  }\n\n  .w-lg-170p {\n    width: 170px !important;\n  }\n\n  .w-lg-175p {\n    width: 175px !important;\n  }\n\n  .w-lg-180p {\n    width: 180px !important;\n  }\n\n  .w-lg-185p {\n    width: 185px !important;\n  }\n\n  .w-lg-190p {\n    width: 190px !important;\n  }\n\n  .w-lg-195p {\n    width: 195px !important;\n  }\n\n  .w-lg-200p {\n    width: 200px !important;\n  }\n\n  .w-lg-205p {\n    width: 205px !important;\n  }\n\n  .w-lg-210p {\n    width: 210px !important;\n  }\n\n  .w-lg-215p {\n    width: 215px !important;\n  }\n\n  .w-lg-220p {\n    width: 220px !important;\n  }\n\n  .w-lg-225p {\n    width: 225px !important;\n  }\n\n  .w-lg-230p {\n    width: 230px !important;\n  }\n\n  .w-lg-235p {\n    width: 235px !important;\n  }\n\n  .w-lg-240p {\n    width: 240px !important;\n  }\n\n  .w-lg-245p {\n    width: 245px !important;\n  }\n\n  .w-lg-250p {\n    width: 250px !important;\n  }\n\n  .w-lg-255p {\n    width: 255px !important;\n  }\n\n  .w-lg-260p {\n    width: 260px !important;\n  }\n\n  .w-lg-265p {\n    width: 265px !important;\n  }\n\n  .w-lg-270p {\n    width: 270px !important;\n  }\n\n  .w-lg-275p {\n    width: 275px !important;\n  }\n\n  .w-lg-280p {\n    width: 280px !important;\n  }\n\n  .w-lg-285p {\n    width: 285px !important;\n  }\n\n  .w-lg-290p {\n    width: 290px !important;\n  }\n\n  .w-lg-295p {\n    width: 295px !important;\n  }\n\n  .w-lg-300p {\n    width: 300px !important;\n  }\n\n  .w-lg-305p {\n    width: 305px !important;\n  }\n\n  .w-lg-310p {\n    width: 310px !important;\n  }\n\n  .w-lg-315p {\n    width: 315px !important;\n  }\n\n  .w-lg-320p {\n    width: 320px !important;\n  }\n\n  .w-lg-325p {\n    width: 325px !important;\n  }\n\n  .w-lg-330p {\n    width: 330px !important;\n  }\n\n  .w-lg-335p {\n    width: 335px !important;\n  }\n\n  .w-lg-340p {\n    width: 340px !important;\n  }\n\n  .w-lg-345p {\n    width: 345px !important;\n  }\n\n  .w-lg-350p {\n    width: 350px !important;\n  }\n\n  .w-lg-355p {\n    width: 355px !important;\n  }\n\n  .w-lg-360p {\n    width: 360px !important;\n  }\n\n  .w-lg-365p {\n    width: 365px !important;\n  }\n\n  .w-lg-370p {\n    width: 370px !important;\n  }\n\n  .w-lg-375p {\n    width: 375px !important;\n  }\n\n  .w-lg-380p {\n    width: 380px !important;\n  }\n\n  .w-lg-385p {\n    width: 385px !important;\n  }\n\n  .w-lg-390p {\n    width: 390px !important;\n  }\n\n  .w-lg-395p {\n    width: 395px !important;\n  }\n\n  .w-lg-400p {\n    width: 400px !important;\n  }\n\n  .w-lg-405p {\n    width: 405px !important;\n  }\n\n  .w-lg-410p {\n    width: 410px !important;\n  }\n\n  .w-lg-415p {\n    width: 415px !important;\n  }\n\n  .w-lg-420p {\n    width: 420px !important;\n  }\n\n  .w-lg-425p {\n    width: 425px !important;\n  }\n\n  .w-lg-430p {\n    width: 430px !important;\n  }\n\n  .w-lg-435p {\n    width: 435px !important;\n  }\n\n  .w-lg-440p {\n    width: 440px !important;\n  }\n\n  .w-lg-445p {\n    width: 445px !important;\n  }\n\n  .w-lg-450p {\n    width: 450px !important;\n  }\n\n  .w-lg-455p {\n    width: 455px !important;\n  }\n\n  .w-lg-460p {\n    width: 460px !important;\n  }\n\n  .w-lg-465p {\n    width: 465px !important;\n  }\n\n  .w-lg-470p {\n    width: 470px !important;\n  }\n\n  .w-lg-475p {\n    width: 475px !important;\n  }\n\n  .w-lg-480p {\n    width: 480px !important;\n  }\n\n  .w-lg-485p {\n    width: 485px !important;\n  }\n\n  .w-lg-490p {\n    width: 490px !important;\n  }\n\n  .w-lg-495p {\n    width: 495px !important;\n  }\n\n  .w-lg-500p {\n    width: 500px !important;\n  }\n\n  .w-lg-505p {\n    width: 505px !important;\n  }\n\n  .w-lg-510p {\n    width: 510px !important;\n  }\n\n  .w-lg-515p {\n    width: 515px !important;\n  }\n\n  .w-lg-520p {\n    width: 520px !important;\n  }\n\n  .w-lg-525p {\n    width: 525px !important;\n  }\n\n  .w-lg-530p {\n    width: 530px !important;\n  }\n\n  .w-lg-535p {\n    width: 535px !important;\n  }\n\n  .w-lg-540p {\n    width: 540px !important;\n  }\n\n  .w-lg-545p {\n    width: 545px !important;\n  }\n\n  .w-lg-550p {\n    width: 550px !important;\n  }\n\n  .w-lg-555p {\n    width: 555px !important;\n  }\n\n  .w-lg-560p {\n    width: 560px !important;\n  }\n\n  .w-lg-565p {\n    width: 565px !important;\n  }\n\n  .w-lg-570p {\n    width: 570px !important;\n  }\n\n  .w-lg-575p {\n    width: 575px !important;\n  }\n\n  .w-lg-580p {\n    width: 580px !important;\n  }\n\n  .w-lg-585p {\n    width: 585px !important;\n  }\n\n  .w-lg-590p {\n    width: 590px !important;\n  }\n\n  .w-lg-595p {\n    width: 595px !important;\n  }\n\n  .w-lg-600p {\n    width: 600px !important;\n  }\n\n  .w-lg-605p {\n    width: 605px !important;\n  }\n\n  .w-lg-610p {\n    width: 610px !important;\n  }\n\n  .w-lg-615p {\n    width: 615px !important;\n  }\n\n  .w-lg-620p {\n    width: 620px !important;\n  }\n\n  .w-lg-625p {\n    width: 625px !important;\n  }\n\n  .w-lg-630p {\n    width: 630px !important;\n  }\n\n  .w-lg-635p {\n    width: 635px !important;\n  }\n\n  .w-lg-640p {\n    width: 640px !important;\n  }\n\n  .w-lg-645p {\n    width: 645px !important;\n  }\n\n  .w-lg-650p {\n    width: 650px !important;\n  }\n\n  .w-lg-655p {\n    width: 655px !important;\n  }\n\n  .w-lg-660p {\n    width: 660px !important;\n  }\n\n  .w-lg-665p {\n    width: 665px !important;\n  }\n\n  .w-lg-670p {\n    width: 670px !important;\n  }\n\n  .w-lg-675p {\n    width: 675px !important;\n  }\n\n  .w-lg-680p {\n    width: 680px !important;\n  }\n\n  .w-lg-685p {\n    width: 685px !important;\n  }\n\n  .w-lg-690p {\n    width: 690px !important;\n  }\n\n  .w-lg-695p {\n    width: 695px !important;\n  }\n\n  .w-lg-700p {\n    width: 700px !important;\n  }\n\n  .w-lg-705p {\n    width: 705px !important;\n  }\n\n  .w-lg-710p {\n    width: 710px !important;\n  }\n\n  .w-lg-715p {\n    width: 715px !important;\n  }\n\n  .w-lg-720p {\n    width: 720px !important;\n  }\n\n  .w-lg-725p {\n    width: 725px !important;\n  }\n\n  .w-lg-730p {\n    width: 730px !important;\n  }\n\n  .w-lg-735p {\n    width: 735px !important;\n  }\n\n  .w-lg-740p {\n    width: 740px !important;\n  }\n\n  .w-lg-745p {\n    width: 745px !important;\n  }\n\n  .w-lg-750p {\n    width: 750px !important;\n  }\n\n  .w-lg-755p {\n    width: 755px !important;\n  }\n\n  .w-lg-760p {\n    width: 760px !important;\n  }\n\n  .w-lg-765p {\n    width: 765px !important;\n  }\n\n  .w-lg-770p {\n    width: 770px !important;\n  }\n\n  .w-lg-775p {\n    width: 775px !important;\n  }\n\n  .w-lg-780p {\n    width: 780px !important;\n  }\n\n  .w-lg-785p {\n    width: 785px !important;\n  }\n\n  .w-lg-790p {\n    width: 790px !important;\n  }\n\n  .w-lg-795p {\n    width: 795px !important;\n  }\n\n  .w-lg-800p {\n    width: 800px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .w-xl-25p {\n    width: 25px !important;\n  }\n\n  .w-xl-30p {\n    width: 30px !important;\n  }\n\n  .w-xl-35p {\n    width: 35px !important;\n  }\n\n  .w-xl-40p {\n    width: 40px !important;\n  }\n\n  .w-xl-45p {\n    width: 45px !important;\n  }\n\n  .w-xl-50p {\n    width: 50px !important;\n  }\n\n  .w-xl-55p {\n    width: 55px !important;\n  }\n\n  .w-xl-60p {\n    width: 60px !important;\n  }\n\n  .w-xl-65p {\n    width: 65px !important;\n  }\n\n  .w-xl-70p {\n    width: 70px !important;\n  }\n\n  .w-xl-75p {\n    width: 75px !important;\n  }\n\n  .w-xl-80p {\n    width: 80px !important;\n  }\n\n  .w-xl-85p {\n    width: 85px !important;\n  }\n\n  .w-xl-90p {\n    width: 90px !important;\n  }\n\n  .w-xl-95p {\n    width: 95px !important;\n  }\n\n  .w-xl-100p {\n    width: 100px !important;\n  }\n\n  .w-xl-105p {\n    width: 105px !important;\n  }\n\n  .w-xl-110p {\n    width: 110px !important;\n  }\n\n  .w-xl-115p {\n    width: 115px !important;\n  }\n\n  .w-xl-120p {\n    width: 120px !important;\n  }\n\n  .w-xl-125p {\n    width: 125px !important;\n  }\n\n  .w-xl-130p {\n    width: 130px !important;\n  }\n\n  .w-xl-135p {\n    width: 135px !important;\n  }\n\n  .w-xl-140p {\n    width: 140px !important;\n  }\n\n  .w-xl-145p {\n    width: 145px !important;\n  }\n\n  .w-xl-150p {\n    width: 150px !important;\n  }\n\n  .w-xl-155p {\n    width: 155px !important;\n  }\n\n  .w-xl-160p {\n    width: 160px !important;\n  }\n\n  .w-xl-165p {\n    width: 165px !important;\n  }\n\n  .w-xl-170p {\n    width: 170px !important;\n  }\n\n  .w-xl-175p {\n    width: 175px !important;\n  }\n\n  .w-xl-180p {\n    width: 180px !important;\n  }\n\n  .w-xl-185p {\n    width: 185px !important;\n  }\n\n  .w-xl-190p {\n    width: 190px !important;\n  }\n\n  .w-xl-195p {\n    width: 195px !important;\n  }\n\n  .w-xl-200p {\n    width: 200px !important;\n  }\n\n  .w-xl-205p {\n    width: 205px !important;\n  }\n\n  .w-xl-210p {\n    width: 210px !important;\n  }\n\n  .w-xl-215p {\n    width: 215px !important;\n  }\n\n  .w-xl-220p {\n    width: 220px !important;\n  }\n\n  .w-xl-225p {\n    width: 225px !important;\n  }\n\n  .w-xl-230p {\n    width: 230px !important;\n  }\n\n  .w-xl-235p {\n    width: 235px !important;\n  }\n\n  .w-xl-240p {\n    width: 240px !important;\n  }\n\n  .w-xl-245p {\n    width: 245px !important;\n  }\n\n  .w-xl-250p {\n    width: 250px !important;\n  }\n\n  .w-xl-255p {\n    width: 255px !important;\n  }\n\n  .w-xl-260p {\n    width: 260px !important;\n  }\n\n  .w-xl-265p {\n    width: 265px !important;\n  }\n\n  .w-xl-270p {\n    width: 270px !important;\n  }\n\n  .w-xl-275p {\n    width: 275px !important;\n  }\n\n  .w-xl-280p {\n    width: 280px !important;\n  }\n\n  .w-xl-285p {\n    width: 285px !important;\n  }\n\n  .w-xl-290p {\n    width: 290px !important;\n  }\n\n  .w-xl-295p {\n    width: 295px !important;\n  }\n\n  .w-xl-300p {\n    width: 300px !important;\n  }\n\n  .w-xl-305p {\n    width: 305px !important;\n  }\n\n  .w-xl-310p {\n    width: 310px !important;\n  }\n\n  .w-xl-315p {\n    width: 315px !important;\n  }\n\n  .w-xl-320p {\n    width: 320px !important;\n  }\n\n  .w-xl-325p {\n    width: 325px !important;\n  }\n\n  .w-xl-330p {\n    width: 330px !important;\n  }\n\n  .w-xl-335p {\n    width: 335px !important;\n  }\n\n  .w-xl-340p {\n    width: 340px !important;\n  }\n\n  .w-xl-345p {\n    width: 345px !important;\n  }\n\n  .w-xl-350p {\n    width: 350px !important;\n  }\n\n  .w-xl-355p {\n    width: 355px !important;\n  }\n\n  .w-xl-360p {\n    width: 360px !important;\n  }\n\n  .w-xl-365p {\n    width: 365px !important;\n  }\n\n  .w-xl-370p {\n    width: 370px !important;\n  }\n\n  .w-xl-375p {\n    width: 375px !important;\n  }\n\n  .w-xl-380p {\n    width: 380px !important;\n  }\n\n  .w-xl-385p {\n    width: 385px !important;\n  }\n\n  .w-xl-390p {\n    width: 390px !important;\n  }\n\n  .w-xl-395p {\n    width: 395px !important;\n  }\n\n  .w-xl-400p {\n    width: 400px !important;\n  }\n\n  .w-xl-405p {\n    width: 405px !important;\n  }\n\n  .w-xl-410p {\n    width: 410px !important;\n  }\n\n  .w-xl-415p {\n    width: 415px !important;\n  }\n\n  .w-xl-420p {\n    width: 420px !important;\n  }\n\n  .w-xl-425p {\n    width: 425px !important;\n  }\n\n  .w-xl-430p {\n    width: 430px !important;\n  }\n\n  .w-xl-435p {\n    width: 435px !important;\n  }\n\n  .w-xl-440p {\n    width: 440px !important;\n  }\n\n  .w-xl-445p {\n    width: 445px !important;\n  }\n\n  .w-xl-450p {\n    width: 450px !important;\n  }\n\n  .w-xl-455p {\n    width: 455px !important;\n  }\n\n  .w-xl-460p {\n    width: 460px !important;\n  }\n\n  .w-xl-465p {\n    width: 465px !important;\n  }\n\n  .w-xl-470p {\n    width: 470px !important;\n  }\n\n  .w-xl-475p {\n    width: 475px !important;\n  }\n\n  .w-xl-480p {\n    width: 480px !important;\n  }\n\n  .w-xl-485p {\n    width: 485px !important;\n  }\n\n  .w-xl-490p {\n    width: 490px !important;\n  }\n\n  .w-xl-495p {\n    width: 495px !important;\n  }\n\n  .w-xl-500p {\n    width: 500px !important;\n  }\n\n  .w-xl-505p {\n    width: 505px !important;\n  }\n\n  .w-xl-510p {\n    width: 510px !important;\n  }\n\n  .w-xl-515p {\n    width: 515px !important;\n  }\n\n  .w-xl-520p {\n    width: 520px !important;\n  }\n\n  .w-xl-525p {\n    width: 525px !important;\n  }\n\n  .w-xl-530p {\n    width: 530px !important;\n  }\n\n  .w-xl-535p {\n    width: 535px !important;\n  }\n\n  .w-xl-540p {\n    width: 540px !important;\n  }\n\n  .w-xl-545p {\n    width: 545px !important;\n  }\n\n  .w-xl-550p {\n    width: 550px !important;\n  }\n\n  .w-xl-555p {\n    width: 555px !important;\n  }\n\n  .w-xl-560p {\n    width: 560px !important;\n  }\n\n  .w-xl-565p {\n    width: 565px !important;\n  }\n\n  .w-xl-570p {\n    width: 570px !important;\n  }\n\n  .w-xl-575p {\n    width: 575px !important;\n  }\n\n  .w-xl-580p {\n    width: 580px !important;\n  }\n\n  .w-xl-585p {\n    width: 585px !important;\n  }\n\n  .w-xl-590p {\n    width: 590px !important;\n  }\n\n  .w-xl-595p {\n    width: 595px !important;\n  }\n\n  .w-xl-600p {\n    width: 600px !important;\n  }\n\n  .w-xl-605p {\n    width: 605px !important;\n  }\n\n  .w-xl-610p {\n    width: 610px !important;\n  }\n\n  .w-xl-615p {\n    width: 615px !important;\n  }\n\n  .w-xl-620p {\n    width: 620px !important;\n  }\n\n  .w-xl-625p {\n    width: 625px !important;\n  }\n\n  .w-xl-630p {\n    width: 630px !important;\n  }\n\n  .w-xl-635p {\n    width: 635px !important;\n  }\n\n  .w-xl-640p {\n    width: 640px !important;\n  }\n\n  .w-xl-645p {\n    width: 645px !important;\n  }\n\n  .w-xl-650p {\n    width: 650px !important;\n  }\n\n  .w-xl-655p {\n    width: 655px !important;\n  }\n\n  .w-xl-660p {\n    width: 660px !important;\n  }\n\n  .w-xl-665p {\n    width: 665px !important;\n  }\n\n  .w-xl-670p {\n    width: 670px !important;\n  }\n\n  .w-xl-675p {\n    width: 675px !important;\n  }\n\n  .w-xl-680p {\n    width: 680px !important;\n  }\n\n  .w-xl-685p {\n    width: 685px !important;\n  }\n\n  .w-xl-690p {\n    width: 690px !important;\n  }\n\n  .w-xl-695p {\n    width: 695px !important;\n  }\n\n  .w-xl-700p {\n    width: 700px !important;\n  }\n\n  .w-xl-705p {\n    width: 705px !important;\n  }\n\n  .w-xl-710p {\n    width: 710px !important;\n  }\n\n  .w-xl-715p {\n    width: 715px !important;\n  }\n\n  .w-xl-720p {\n    width: 720px !important;\n  }\n\n  .w-xl-725p {\n    width: 725px !important;\n  }\n\n  .w-xl-730p {\n    width: 730px !important;\n  }\n\n  .w-xl-735p {\n    width: 735px !important;\n  }\n\n  .w-xl-740p {\n    width: 740px !important;\n  }\n\n  .w-xl-745p {\n    width: 745px !important;\n  }\n\n  .w-xl-750p {\n    width: 750px !important;\n  }\n\n  .w-xl-755p {\n    width: 755px !important;\n  }\n\n  .w-xl-760p {\n    width: 760px !important;\n  }\n\n  .w-xl-765p {\n    width: 765px !important;\n  }\n\n  .w-xl-770p {\n    width: 770px !important;\n  }\n\n  .w-xl-775p {\n    width: 775px !important;\n  }\n\n  .w-xl-780p {\n    width: 780px !important;\n  }\n\n  .w-xl-785p {\n    width: 785px !important;\n  }\n\n  .w-xl-790p {\n    width: 790px !important;\n  }\n\n  .w-xl-795p {\n    width: 795px !important;\n  }\n\n  .w-xl-800p {\n    width: 800px !important;\n  }\n}\n@media (min-width: 1400px) {\n  .w-xxl-25p {\n    width: 25px !important;\n  }\n\n  .w-xxl-30p {\n    width: 30px !important;\n  }\n\n  .w-xxl-35p {\n    width: 35px !important;\n  }\n\n  .w-xxl-40p {\n    width: 40px !important;\n  }\n\n  .w-xxl-45p {\n    width: 45px !important;\n  }\n\n  .w-xxl-50p {\n    width: 50px !important;\n  }\n\n  .w-xxl-55p {\n    width: 55px !important;\n  }\n\n  .w-xxl-60p {\n    width: 60px !important;\n  }\n\n  .w-xxl-65p {\n    width: 65px !important;\n  }\n\n  .w-xxl-70p {\n    width: 70px !important;\n  }\n\n  .w-xxl-75p {\n    width: 75px !important;\n  }\n\n  .w-xxl-80p {\n    width: 80px !important;\n  }\n\n  .w-xxl-85p {\n    width: 85px !important;\n  }\n\n  .w-xxl-90p {\n    width: 90px !important;\n  }\n\n  .w-xxl-95p {\n    width: 95px !important;\n  }\n\n  .w-xxl-100p {\n    width: 100px !important;\n  }\n\n  .w-xxl-105p {\n    width: 105px !important;\n  }\n\n  .w-xxl-110p {\n    width: 110px !important;\n  }\n\n  .w-xxl-115p {\n    width: 115px !important;\n  }\n\n  .w-xxl-120p {\n    width: 120px !important;\n  }\n\n  .w-xxl-125p {\n    width: 125px !important;\n  }\n\n  .w-xxl-130p {\n    width: 130px !important;\n  }\n\n  .w-xxl-135p {\n    width: 135px !important;\n  }\n\n  .w-xxl-140p {\n    width: 140px !important;\n  }\n\n  .w-xxl-145p {\n    width: 145px !important;\n  }\n\n  .w-xxl-150p {\n    width: 150px !important;\n  }\n\n  .w-xxl-155p {\n    width: 155px !important;\n  }\n\n  .w-xxl-160p {\n    width: 160px !important;\n  }\n\n  .w-xxl-165p {\n    width: 165px !important;\n  }\n\n  .w-xxl-170p {\n    width: 170px !important;\n  }\n\n  .w-xxl-175p {\n    width: 175px !important;\n  }\n\n  .w-xxl-180p {\n    width: 180px !important;\n  }\n\n  .w-xxl-185p {\n    width: 185px !important;\n  }\n\n  .w-xxl-190p {\n    width: 190px !important;\n  }\n\n  .w-xxl-195p {\n    width: 195px !important;\n  }\n\n  .w-xxl-200p {\n    width: 200px !important;\n  }\n\n  .w-xxl-205p {\n    width: 205px !important;\n  }\n\n  .w-xxl-210p {\n    width: 210px !important;\n  }\n\n  .w-xxl-215p {\n    width: 215px !important;\n  }\n\n  .w-xxl-220p {\n    width: 220px !important;\n  }\n\n  .w-xxl-225p {\n    width: 225px !important;\n  }\n\n  .w-xxl-230p {\n    width: 230px !important;\n  }\n\n  .w-xxl-235p {\n    width: 235px !important;\n  }\n\n  .w-xxl-240p {\n    width: 240px !important;\n  }\n\n  .w-xxl-245p {\n    width: 245px !important;\n  }\n\n  .w-xxl-250p {\n    width: 250px !important;\n  }\n\n  .w-xxl-255p {\n    width: 255px !important;\n  }\n\n  .w-xxl-260p {\n    width: 260px !important;\n  }\n\n  .w-xxl-265p {\n    width: 265px !important;\n  }\n\n  .w-xxl-270p {\n    width: 270px !important;\n  }\n\n  .w-xxl-275p {\n    width: 275px !important;\n  }\n\n  .w-xxl-280p {\n    width: 280px !important;\n  }\n\n  .w-xxl-285p {\n    width: 285px !important;\n  }\n\n  .w-xxl-290p {\n    width: 290px !important;\n  }\n\n  .w-xxl-295p {\n    width: 295px !important;\n  }\n\n  .w-xxl-300p {\n    width: 300px !important;\n  }\n\n  .w-xxl-305p {\n    width: 305px !important;\n  }\n\n  .w-xxl-310p {\n    width: 310px !important;\n  }\n\n  .w-xxl-315p {\n    width: 315px !important;\n  }\n\n  .w-xxl-320p {\n    width: 320px !important;\n  }\n\n  .w-xxl-325p {\n    width: 325px !important;\n  }\n\n  .w-xxl-330p {\n    width: 330px !important;\n  }\n\n  .w-xxl-335p {\n    width: 335px !important;\n  }\n\n  .w-xxl-340p {\n    width: 340px !important;\n  }\n\n  .w-xxl-345p {\n    width: 345px !important;\n  }\n\n  .w-xxl-350p {\n    width: 350px !important;\n  }\n\n  .w-xxl-355p {\n    width: 355px !important;\n  }\n\n  .w-xxl-360p {\n    width: 360px !important;\n  }\n\n  .w-xxl-365p {\n    width: 365px !important;\n  }\n\n  .w-xxl-370p {\n    width: 370px !important;\n  }\n\n  .w-xxl-375p {\n    width: 375px !important;\n  }\n\n  .w-xxl-380p {\n    width: 380px !important;\n  }\n\n  .w-xxl-385p {\n    width: 385px !important;\n  }\n\n  .w-xxl-390p {\n    width: 390px !important;\n  }\n\n  .w-xxl-395p {\n    width: 395px !important;\n  }\n\n  .w-xxl-400p {\n    width: 400px !important;\n  }\n\n  .w-xxl-405p {\n    width: 405px !important;\n  }\n\n  .w-xxl-410p {\n    width: 410px !important;\n  }\n\n  .w-xxl-415p {\n    width: 415px !important;\n  }\n\n  .w-xxl-420p {\n    width: 420px !important;\n  }\n\n  .w-xxl-425p {\n    width: 425px !important;\n  }\n\n  .w-xxl-430p {\n    width: 430px !important;\n  }\n\n  .w-xxl-435p {\n    width: 435px !important;\n  }\n\n  .w-xxl-440p {\n    width: 440px !important;\n  }\n\n  .w-xxl-445p {\n    width: 445px !important;\n  }\n\n  .w-xxl-450p {\n    width: 450px !important;\n  }\n\n  .w-xxl-455p {\n    width: 455px !important;\n  }\n\n  .w-xxl-460p {\n    width: 460px !important;\n  }\n\n  .w-xxl-465p {\n    width: 465px !important;\n  }\n\n  .w-xxl-470p {\n    width: 470px !important;\n  }\n\n  .w-xxl-475p {\n    width: 475px !important;\n  }\n\n  .w-xxl-480p {\n    width: 480px !important;\n  }\n\n  .w-xxl-485p {\n    width: 485px !important;\n  }\n\n  .w-xxl-490p {\n    width: 490px !important;\n  }\n\n  .w-xxl-495p {\n    width: 495px !important;\n  }\n\n  .w-xxl-500p {\n    width: 500px !important;\n  }\n\n  .w-xxl-505p {\n    width: 505px !important;\n  }\n\n  .w-xxl-510p {\n    width: 510px !important;\n  }\n\n  .w-xxl-515p {\n    width: 515px !important;\n  }\n\n  .w-xxl-520p {\n    width: 520px !important;\n  }\n\n  .w-xxl-525p {\n    width: 525px !important;\n  }\n\n  .w-xxl-530p {\n    width: 530px !important;\n  }\n\n  .w-xxl-535p {\n    width: 535px !important;\n  }\n\n  .w-xxl-540p {\n    width: 540px !important;\n  }\n\n  .w-xxl-545p {\n    width: 545px !important;\n  }\n\n  .w-xxl-550p {\n    width: 550px !important;\n  }\n\n  .w-xxl-555p {\n    width: 555px !important;\n  }\n\n  .w-xxl-560p {\n    width: 560px !important;\n  }\n\n  .w-xxl-565p {\n    width: 565px !important;\n  }\n\n  .w-xxl-570p {\n    width: 570px !important;\n  }\n\n  .w-xxl-575p {\n    width: 575px !important;\n  }\n\n  .w-xxl-580p {\n    width: 580px !important;\n  }\n\n  .w-xxl-585p {\n    width: 585px !important;\n  }\n\n  .w-xxl-590p {\n    width: 590px !important;\n  }\n\n  .w-xxl-595p {\n    width: 595px !important;\n  }\n\n  .w-xxl-600p {\n    width: 600px !important;\n  }\n\n  .w-xxl-605p {\n    width: 605px !important;\n  }\n\n  .w-xxl-610p {\n    width: 610px !important;\n  }\n\n  .w-xxl-615p {\n    width: 615px !important;\n  }\n\n  .w-xxl-620p {\n    width: 620px !important;\n  }\n\n  .w-xxl-625p {\n    width: 625px !important;\n  }\n\n  .w-xxl-630p {\n    width: 630px !important;\n  }\n\n  .w-xxl-635p {\n    width: 635px !important;\n  }\n\n  .w-xxl-640p {\n    width: 640px !important;\n  }\n\n  .w-xxl-645p {\n    width: 645px !important;\n  }\n\n  .w-xxl-650p {\n    width: 650px !important;\n  }\n\n  .w-xxl-655p {\n    width: 655px !important;\n  }\n\n  .w-xxl-660p {\n    width: 660px !important;\n  }\n\n  .w-xxl-665p {\n    width: 665px !important;\n  }\n\n  .w-xxl-670p {\n    width: 670px !important;\n  }\n\n  .w-xxl-675p {\n    width: 675px !important;\n  }\n\n  .w-xxl-680p {\n    width: 680px !important;\n  }\n\n  .w-xxl-685p {\n    width: 685px !important;\n  }\n\n  .w-xxl-690p {\n    width: 690px !important;\n  }\n\n  .w-xxl-695p {\n    width: 695px !important;\n  }\n\n  .w-xxl-700p {\n    width: 700px !important;\n  }\n\n  .w-xxl-705p {\n    width: 705px !important;\n  }\n\n  .w-xxl-710p {\n    width: 710px !important;\n  }\n\n  .w-xxl-715p {\n    width: 715px !important;\n  }\n\n  .w-xxl-720p {\n    width: 720px !important;\n  }\n\n  .w-xxl-725p {\n    width: 725px !important;\n  }\n\n  .w-xxl-730p {\n    width: 730px !important;\n  }\n\n  .w-xxl-735p {\n    width: 735px !important;\n  }\n\n  .w-xxl-740p {\n    width: 740px !important;\n  }\n\n  .w-xxl-745p {\n    width: 745px !important;\n  }\n\n  .w-xxl-750p {\n    width: 750px !important;\n  }\n\n  .w-xxl-755p {\n    width: 755px !important;\n  }\n\n  .w-xxl-760p {\n    width: 760px !important;\n  }\n\n  .w-xxl-765p {\n    width: 765px !important;\n  }\n\n  .w-xxl-770p {\n    width: 770px !important;\n  }\n\n  .w-xxl-775p {\n    width: 775px !important;\n  }\n\n  .w-xxl-780p {\n    width: 780px !important;\n  }\n\n  .w-xxl-785p {\n    width: 785px !important;\n  }\n\n  .w-xxl-790p {\n    width: 790px !important;\n  }\n\n  .w-xxl-795p {\n    width: 795px !important;\n  }\n\n  .w-xxl-800p {\n    width: 800px !important;\n  }\n}\n/*Width In Percentage*/\n.w-5 {\n  width: 5% !important;\n}\n\n.w-10 {\n  width: 10% !important;\n}\n\n.w-15 {\n  width: 15% !important;\n}\n\n.w-20 {\n  width: 20% !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-30 {\n  width: 30% !important;\n}\n\n.w-35 {\n  width: 35% !important;\n}\n\n.w-40 {\n  width: 40% !important;\n}\n\n.w-45 {\n  width: 45% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-55 {\n  width: 55% !important;\n}\n\n.w-60 {\n  width: 60% !important;\n}\n\n.w-65 {\n  width: 65% !important;\n}\n\n.w-70 {\n  width: 70% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-80 {\n  width: 80% !important;\n}\n\n.w-85 {\n  width: 85% !important;\n}\n\n.w-90 {\n  width: 90% !important;\n}\n\n.w-95 {\n  width: 95% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n@media (min-width: 576px) {\n  .w-sm-5 {\n    width: 5% !important;\n  }\n\n  .w-sm-10 {\n    width: 10% !important;\n  }\n\n  .w-sm-15 {\n    width: 15% !important;\n  }\n\n  .w-sm-20 {\n    width: 20% !important;\n  }\n\n  .w-sm-25 {\n    width: 25% !important;\n  }\n\n  .w-sm-30 {\n    width: 30% !important;\n  }\n\n  .w-sm-35 {\n    width: 35% !important;\n  }\n\n  .w-sm-40 {\n    width: 40% !important;\n  }\n\n  .w-sm-45 {\n    width: 45% !important;\n  }\n\n  .w-sm-50 {\n    width: 50% !important;\n  }\n\n  .w-sm-55 {\n    width: 55% !important;\n  }\n\n  .w-sm-60 {\n    width: 60% !important;\n  }\n\n  .w-sm-65 {\n    width: 65% !important;\n  }\n\n  .w-sm-70 {\n    width: 70% !important;\n  }\n\n  .w-sm-75 {\n    width: 75% !important;\n  }\n\n  .w-sm-80 {\n    width: 80% !important;\n  }\n\n  .w-sm-85 {\n    width: 85% !important;\n  }\n\n  .w-sm-90 {\n    width: 90% !important;\n  }\n\n  .w-sm-95 {\n    width: 95% !important;\n  }\n\n  .w-sm-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 768px) {\n  .w-md-5 {\n    width: 5% !important;\n  }\n\n  .w-md-10 {\n    width: 10% !important;\n  }\n\n  .w-md-15 {\n    width: 15% !important;\n  }\n\n  .w-md-20 {\n    width: 20% !important;\n  }\n\n  .w-md-25 {\n    width: 25% !important;\n  }\n\n  .w-md-30 {\n    width: 30% !important;\n  }\n\n  .w-md-35 {\n    width: 35% !important;\n  }\n\n  .w-md-40 {\n    width: 40% !important;\n  }\n\n  .w-md-45 {\n    width: 45% !important;\n  }\n\n  .w-md-50 {\n    width: 50% !important;\n  }\n\n  .w-md-55 {\n    width: 55% !important;\n  }\n\n  .w-md-60 {\n    width: 60% !important;\n  }\n\n  .w-md-65 {\n    width: 65% !important;\n  }\n\n  .w-md-70 {\n    width: 70% !important;\n  }\n\n  .w-md-75 {\n    width: 75% !important;\n  }\n\n  .w-md-80 {\n    width: 80% !important;\n  }\n\n  .w-md-85 {\n    width: 85% !important;\n  }\n\n  .w-md-90 {\n    width: 90% !important;\n  }\n\n  .w-md-95 {\n    width: 95% !important;\n  }\n\n  .w-md-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 992px) {\n  .w-lg-5 {\n    width: 5% !important;\n  }\n\n  .w-lg-10 {\n    width: 10% !important;\n  }\n\n  .w-lg-15 {\n    width: 15% !important;\n  }\n\n  .w-lg-20 {\n    width: 20% !important;\n  }\n\n  .w-lg-25 {\n    width: 25% !important;\n  }\n\n  .w-lg-30 {\n    width: 30% !important;\n  }\n\n  .w-lg-35 {\n    width: 35% !important;\n  }\n\n  .w-lg-40 {\n    width: 40% !important;\n  }\n\n  .w-lg-45 {\n    width: 45% !important;\n  }\n\n  .w-lg-50 {\n    width: 50% !important;\n  }\n\n  .w-lg-55 {\n    width: 55% !important;\n  }\n\n  .w-lg-60 {\n    width: 60% !important;\n  }\n\n  .w-lg-65 {\n    width: 65% !important;\n  }\n\n  .w-lg-70 {\n    width: 70% !important;\n  }\n\n  .w-lg-75 {\n    width: 75% !important;\n  }\n\n  .w-lg-80 {\n    width: 80% !important;\n  }\n\n  .w-lg-85 {\n    width: 85% !important;\n  }\n\n  .w-lg-90 {\n    width: 90% !important;\n  }\n\n  .w-lg-95 {\n    width: 95% !important;\n  }\n\n  .w-lg-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 1200px) {\n  .w-xl-5 {\n    width: 5% !important;\n  }\n\n  .w-xl-10 {\n    width: 10% !important;\n  }\n\n  .w-xl-15 {\n    width: 15% !important;\n  }\n\n  .w-xl-20 {\n    width: 20% !important;\n  }\n\n  .w-xl-25 {\n    width: 25% !important;\n  }\n\n  .w-xl-30 {\n    width: 30% !important;\n  }\n\n  .w-xl-35 {\n    width: 35% !important;\n  }\n\n  .w-xl-40 {\n    width: 40% !important;\n  }\n\n  .w-xl-45 {\n    width: 45% !important;\n  }\n\n  .w-xl-50 {\n    width: 50% !important;\n  }\n\n  .w-xl-55 {\n    width: 55% !important;\n  }\n\n  .w-xl-60 {\n    width: 60% !important;\n  }\n\n  .w-xl-65 {\n    width: 65% !important;\n  }\n\n  .w-xl-70 {\n    width: 70% !important;\n  }\n\n  .w-xl-75 {\n    width: 75% !important;\n  }\n\n  .w-xl-80 {\n    width: 80% !important;\n  }\n\n  .w-xl-85 {\n    width: 85% !important;\n  }\n\n  .w-xl-90 {\n    width: 90% !important;\n  }\n\n  .w-xl-95 {\n    width: 95% !important;\n  }\n\n  .w-xl-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 1400px) {\n  .w-xxl-5 {\n    width: 5% !important;\n  }\n\n  .w-xxl-10 {\n    width: 10% !important;\n  }\n\n  .w-xxl-15 {\n    width: 15% !important;\n  }\n\n  .w-xxl-20 {\n    width: 20% !important;\n  }\n\n  .w-xxl-25 {\n    width: 25% !important;\n  }\n\n  .w-xxl-30 {\n    width: 30% !important;\n  }\n\n  .w-xxl-35 {\n    width: 35% !important;\n  }\n\n  .w-xxl-40 {\n    width: 40% !important;\n  }\n\n  .w-xxl-45 {\n    width: 45% !important;\n  }\n\n  .w-xxl-50 {\n    width: 50% !important;\n  }\n\n  .w-xxl-55 {\n    width: 55% !important;\n  }\n\n  .w-xxl-60 {\n    width: 60% !important;\n  }\n\n  .w-xxl-65 {\n    width: 65% !important;\n  }\n\n  .w-xxl-70 {\n    width: 70% !important;\n  }\n\n  .w-xxl-75 {\n    width: 75% !important;\n  }\n\n  .w-xxl-80 {\n    width: 80% !important;\n  }\n\n  .w-xxl-85 {\n    width: 85% !important;\n  }\n\n  .w-xxl-90 {\n    width: 90% !important;\n  }\n\n  .w-xxl-95 {\n    width: 95% !important;\n  }\n\n  .w-xxl-100 {\n    width: 100% !important;\n  }\n}\n/*Max Width*/\n.mw-25p {\n  max-width: 25px !important;\n}\n\n.mw-50p {\n  max-width: 50px !important;\n}\n\n.mw-75p {\n  max-width: 75px !important;\n}\n\n.mw-100p {\n  max-width: 100px !important;\n}\n\n.mw-125p {\n  max-width: 125px !important;\n}\n\n.mw-150p {\n  max-width: 150px !important;\n}\n\n.mw-175p {\n  max-width: 175px !important;\n}\n\n.mw-200p {\n  max-width: 200px !important;\n}\n\n.mw-225p {\n  max-width: 225px !important;\n}\n\n.mw-250p {\n  max-width: 250px !important;\n}\n\n.mw-275p {\n  max-width: 275px !important;\n}\n\n.mw-300p {\n  max-width: 300px !important;\n}\n\n.mw-325p {\n  max-width: 325px !important;\n}\n\n.mw-350p {\n  max-width: 350px !important;\n}\n\n.mw-375p {\n  max-width: 375px !important;\n}\n\n.mw-400p {\n  max-width: 400px !important;\n}\n\n.mw-425p {\n  max-width: 425px !important;\n}\n\n.mw-450p {\n  max-width: 450px !important;\n}\n\n.mw-475p {\n  max-width: 475px !important;\n}\n\n.mw-500p {\n  max-width: 500px !important;\n}\n\n.mw-525p {\n  max-width: 525px !important;\n}\n\n.mw-550p {\n  max-width: 550px !important;\n}\n\n.mw-575p {\n  max-width: 575px !important;\n}\n\n.mw-600p {\n  max-width: 600px !important;\n}\n\n.mw-625p {\n  max-width: 625px !important;\n}\n\n.mw-650p {\n  max-width: 650px !important;\n}\n\n.mw-675p {\n  max-width: 675px !important;\n}\n\n.mw-700p {\n  max-width: 700px !important;\n}\n\n.mw-725p {\n  max-width: 725px !important;\n}\n\n.mw-750p {\n  max-width: 750px !important;\n}\n\n.mw-775p {\n  max-width: 775px !important;\n}\n\n.mw-800p {\n  max-width: 800px !important;\n}\n\n/*Min Width*/\n.mnw-0 {\n  min-width: 0 !important;\n}\n\n.mnw-25p {\n  min-width: 25px !important;\n}\n\n.mnw-50p {\n  min-width: 50px !important;\n}\n\n.mnw-75p {\n  min-width: 75px !important;\n}\n\n.mnw-100p {\n  min-width: 100px !important;\n}\n\n.mnw-125p {\n  min-width: 125px !important;\n}\n\n.mnw-150p {\n  min-width: 150px !important;\n}\n\n.mnw-175p {\n  min-width: 175px !important;\n}\n\n.mnw-200p {\n  min-width: 200px !important;\n}\n\n.mnw-225p {\n  min-width: 225px !important;\n}\n\n.mnw-250p {\n  min-width: 250px !important;\n}\n\n.mnw-275p {\n  min-width: 275px !important;\n}\n\n.mnw-300p {\n  min-width: 300px !important;\n}\n\n.mnw-325p {\n  min-width: 325px !important;\n}\n\n.mnw-350p {\n  min-width: 350px !important;\n}\n\n.mnw-375p {\n  min-width: 375px !important;\n}\n\n.mnw-400p {\n  min-width: 400px !important;\n}\n\n.mnw-425p {\n  min-width: 425px !important;\n}\n\n.mnw-450p {\n  min-width: 450px !important;\n}\n\n.mnw-475p {\n  min-width: 475px !important;\n}\n\n.mnw-500p {\n  min-width: 500px !important;\n}\n\n.mnw-525p {\n  min-width: 525px !important;\n}\n\n.mnw-550p {\n  min-width: 550px !important;\n}\n\n.mnw-575p {\n  min-width: 575px !important;\n}\n\n.mnw-600p {\n  min-width: 600px !important;\n}\n\n.mnw-625p {\n  min-width: 625px !important;\n}\n\n.mnw-650p {\n  min-width: 650px !important;\n}\n\n.mnw-675p {\n  min-width: 675px !important;\n}\n\n.mnw-700p {\n  min-width: 700px !important;\n}\n\n.mnw-725p {\n  min-width: 725px !important;\n}\n\n.mnw-750p {\n  min-width: 750px !important;\n}\n\n.mnw-775p {\n  min-width: 775px !important;\n}\n\n.mnw-800p {\n  min-width: 800px !important;\n}\n\n/*Height*/\n.h-0 {\n  height: 0 !important;\n}\n\n.h-25p {\n  height: 25px !important;\n}\n\n.h-30p {\n  height: 30px !important;\n}\n\n.h-35p {\n  height: 35px !important;\n}\n\n.h-40p {\n  height: 40px !important;\n}\n\n.h-45p {\n  height: 45px !important;\n}\n\n.h-50p {\n  height: 50px !important;\n}\n\n.h-55p {\n  height: 55px !important;\n}\n\n.h-60p {\n  height: 60px !important;\n}\n\n.h-65p {\n  height: 65px !important;\n}\n\n.h-70p {\n  height: 70px !important;\n}\n\n.h-75p {\n  height: 75px !important;\n}\n\n.h-80p {\n  height: 80px !important;\n}\n\n.h-85p {\n  height: 85px !important;\n}\n\n.h-90p {\n  height: 90px !important;\n}\n\n.h-95p {\n  height: 95px !important;\n}\n\n.h-100p {\n  height: 100px !important;\n}\n\n.h-105p {\n  height: 105px !important;\n}\n\n.h-110p {\n  height: 110px !important;\n}\n\n.h-115p {\n  height: 115px !important;\n}\n\n.h-120p {\n  height: 120px !important;\n}\n\n.h-125p {\n  height: 125px !important;\n}\n\n.h-130p {\n  height: 130px !important;\n}\n\n.h-135p {\n  height: 135px !important;\n}\n\n.h-140p {\n  height: 140px !important;\n}\n\n.h-145p {\n  height: 145px !important;\n}\n\n.h-150p {\n  height: 150px !important;\n}\n\n.h-155p {\n  height: 155px !important;\n}\n\n.h-160p {\n  height: 160px !important;\n}\n\n.h-165p {\n  height: 165px !important;\n}\n\n.h-170p {\n  height: 170px !important;\n}\n\n.h-175p {\n  height: 175px !important;\n}\n\n.h-180p {\n  height: 180px !important;\n}\n\n.h-185p {\n  height: 185px !important;\n}\n\n.h-190p {\n  height: 190px !important;\n}\n\n.h-195p {\n  height: 195px !important;\n}\n\n.h-200p {\n  height: 200px !important;\n}\n\n.h-205p {\n  height: 205px !important;\n}\n\n.h-210p {\n  height: 210px !important;\n}\n\n.h-215p {\n  height: 215px !important;\n}\n\n.h-220p {\n  height: 220px !important;\n}\n\n.h-225p {\n  height: 225px !important;\n}\n\n.h-230p {\n  height: 230px !important;\n}\n\n.h-235p {\n  height: 235px !important;\n}\n\n.h-240p {\n  height: 240px !important;\n}\n\n.h-245p {\n  height: 245px !important;\n}\n\n.h-250p {\n  height: 250px !important;\n}\n\n.h-255p {\n  height: 255px !important;\n}\n\n.h-260p {\n  height: 260px !important;\n}\n\n.h-265p {\n  height: 265px !important;\n}\n\n.h-270p {\n  height: 270px !important;\n}\n\n.h-275p {\n  height: 275px !important;\n}\n\n.h-280p {\n  height: 280px !important;\n}\n\n.h-285p {\n  height: 285px !important;\n}\n\n.h-290p {\n  height: 290px !important;\n}\n\n.h-295p {\n  height: 295px !important;\n}\n\n.h-300p {\n  height: 300px !important;\n}\n\n.h-305p {\n  height: 305px !important;\n}\n\n.h-310p {\n  height: 310px !important;\n}\n\n.h-315p {\n  height: 315px !important;\n}\n\n.h-320p {\n  height: 320px !important;\n}\n\n.h-325p {\n  height: 325px !important;\n}\n\n.h-330p {\n  height: 330px !important;\n}\n\n.h-335p {\n  height: 335px !important;\n}\n\n.h-340p {\n  height: 340px !important;\n}\n\n.h-345p {\n  height: 345px !important;\n}\n\n.h-350p {\n  height: 350px !important;\n}\n\n.h-355p {\n  height: 355px !important;\n}\n\n.h-360p {\n  height: 360px !important;\n}\n\n.h-365p {\n  height: 365px !important;\n}\n\n.h-370p {\n  height: 370px !important;\n}\n\n.h-375p {\n  height: 375px !important;\n}\n\n.h-380p {\n  height: 380px !important;\n}\n\n.h-385p {\n  height: 385px !important;\n}\n\n.h-390p {\n  height: 390px !important;\n}\n\n.h-395p {\n  height: 395px !important;\n}\n\n.h-400p {\n  height: 400px !important;\n}\n\n.h-405p {\n  height: 405px !important;\n}\n\n.h-410p {\n  height: 410px !important;\n}\n\n.h-415p {\n  height: 415px !important;\n}\n\n.h-420p {\n  height: 420px !important;\n}\n\n.h-425p {\n  height: 425px !important;\n}\n\n.h-430p {\n  height: 430px !important;\n}\n\n.h-435p {\n  height: 435px !important;\n}\n\n.h-440p {\n  height: 440px !important;\n}\n\n.h-445p {\n  height: 445px !important;\n}\n\n.h-450p {\n  height: 450px !important;\n}\n\n.h-455p {\n  height: 455px !important;\n}\n\n.h-460p {\n  height: 460px !important;\n}\n\n.h-465p {\n  height: 465px !important;\n}\n\n.h-470p {\n  height: 470px !important;\n}\n\n.h-475p {\n  height: 475px !important;\n}\n\n.h-480p {\n  height: 480px !important;\n}\n\n.h-485p {\n  height: 485px !important;\n}\n\n.h-490p {\n  height: 490px !important;\n}\n\n.h-495p {\n  height: 495px !important;\n}\n\n.h-500p {\n  height: 500px !important;\n}\n\n.h-505p {\n  height: 505px !important;\n}\n\n.h-510p {\n  height: 510px !important;\n}\n\n.h-515p {\n  height: 515px !important;\n}\n\n.h-520p {\n  height: 520px !important;\n}\n\n.h-525p {\n  height: 525px !important;\n}\n\n.h-530p {\n  height: 530px !important;\n}\n\n.h-535p {\n  height: 535px !important;\n}\n\n.h-540p {\n  height: 540px !important;\n}\n\n.h-545p {\n  height: 545px !important;\n}\n\n.h-550p {\n  height: 550px !important;\n}\n\n.h-555p {\n  height: 555px !important;\n}\n\n.h-560p {\n  height: 560px !important;\n}\n\n.h-565p {\n  height: 565px !important;\n}\n\n.h-570p {\n  height: 570px !important;\n}\n\n.h-575p {\n  height: 575px !important;\n}\n\n.h-580p {\n  height: 580px !important;\n}\n\n.h-585p {\n  height: 585px !important;\n}\n\n.h-590p {\n  height: 590px !important;\n}\n\n.h-595p {\n  height: 595px !important;\n}\n\n.h-600p {\n  height: 600px !important;\n}\n\n.h-605p {\n  height: 605px !important;\n}\n\n.h-610p {\n  height: 610px !important;\n}\n\n.h-615p {\n  height: 615px !important;\n}\n\n.h-620p {\n  height: 620px !important;\n}\n\n.h-625p {\n  height: 625px !important;\n}\n\n.h-630p {\n  height: 630px !important;\n}\n\n.h-635p {\n  height: 635px !important;\n}\n\n.h-640p {\n  height: 640px !important;\n}\n\n.h-645p {\n  height: 645px !important;\n}\n\n.h-650p {\n  height: 650px !important;\n}\n\n.h-655p {\n  height: 655px !important;\n}\n\n.h-660p {\n  height: 660px !important;\n}\n\n.h-665p {\n  height: 665px !important;\n}\n\n.h-670p {\n  height: 670px !important;\n}\n\n.h-675p {\n  height: 675px !important;\n}\n\n.h-680p {\n  height: 680px !important;\n}\n\n.h-685p {\n  height: 685px !important;\n}\n\n.h-690p {\n  height: 690px !important;\n}\n\n.h-695p {\n  height: 695px !important;\n}\n\n.h-700p {\n  height: 700px !important;\n}\n\n.h-705p {\n  height: 705px !important;\n}\n\n.h-710p {\n  height: 710px !important;\n}\n\n.h-715p {\n  height: 715px !important;\n}\n\n.h-720p {\n  height: 720px !important;\n}\n\n.h-725p {\n  height: 725px !important;\n}\n\n.h-730p {\n  height: 730px !important;\n}\n\n.h-735p {\n  height: 735px !important;\n}\n\n.h-740p {\n  height: 740px !important;\n}\n\n.h-745p {\n  height: 745px !important;\n}\n\n.h-750p {\n  height: 750px !important;\n}\n\n.h-755p {\n  height: 755px !important;\n}\n\n.h-760p {\n  height: 760px !important;\n}\n\n.h-765p {\n  height: 765px !important;\n}\n\n.h-770p {\n  height: 770px !important;\n}\n\n.h-775p {\n  height: 775px !important;\n}\n\n.h-780p {\n  height: 780px !important;\n}\n\n.h-785p {\n  height: 785px !important;\n}\n\n.h-790p {\n  height: 790px !important;\n}\n\n.h-795p {\n  height: 795px !important;\n}\n\n.h-800p {\n  height: 800px !important;\n}\n\n/*Height In Percentage*/\n.h-25 {\n  height: 25% !important;\n}\n\n.h-30 {\n  height: 30% !important;\n}\n\n.h-35 {\n  height: 35% !important;\n}\n\n.h-40 {\n  height: 40% !important;\n}\n\n.h-45 {\n  height: 45% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-55 {\n  height: 55% !important;\n}\n\n.h-60 {\n  height: 60% !important;\n}\n\n.h-65 {\n  height: 65% !important;\n}\n\n.h-70 {\n  height: 70% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-80 {\n  height: 80% !important;\n}\n\n.h-85 {\n  height: 85% !important;\n}\n\n.h-90 {\n  height: 90% !important;\n}\n\n.h-95 {\n  height: 95% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n/*Max Height*/\n.mh-100p {\n  max-height: 100px !important;\n}\n\n.mh-125p {\n  max-height: 125px !important;\n}\n\n.mh-150p {\n  max-height: 150px !important;\n}\n\n.mh-175p {\n  max-height: 175px !important;\n}\n\n.mh-200p {\n  max-height: 200px !important;\n}\n\n.mh-225p {\n  max-height: 225px !important;\n}\n\n.mh-250p {\n  max-height: 250px !important;\n}\n\n.mh-275p {\n  max-height: 275px !important;\n}\n\n.mh-300p {\n  max-height: 300px !important;\n}\n\n.mh-325p {\n  max-height: 325px !important;\n}\n\n.mh-350p {\n  max-height: 350px !important;\n}\n\n.mh-375p {\n  max-height: 375px !important;\n}\n\n.mh-400p {\n  max-height: 400px !important;\n}\n\n.mh-425p {\n  max-height: 425px !important;\n}\n\n.mh-450p {\n  max-height: 450px !important;\n}\n\n.mh-475p {\n  max-height: 475px !important;\n}\n\n.mh-500p {\n  max-height: 500px !important;\n}\n\n.mh-525p {\n  max-height: 525px !important;\n}\n\n.mh-550p {\n  max-height: 550px !important;\n}\n\n.mh-575p {\n  max-height: 575px !important;\n}\n\n.mh-600p {\n  max-height: 600px !important;\n}\n\n.mh-625p {\n  max-height: 625px !important;\n}\n\n.mh-650p {\n  max-height: 650px !important;\n}\n\n.mh-675p {\n  max-height: 675px !important;\n}\n\n.mh-700p {\n  max-height: 700px !important;\n}\n\n.mh-725p {\n  max-height: 725px !important;\n}\n\n.mh-750p {\n  max-height: 750px !important;\n}\n\n.mh-775p {\n  max-height: 775px !important;\n}\n\n.mh-800p {\n  max-height: 800px !important;\n}\n\n/*Min Height*/\n.mnh-0 {\n  min-height: 0 !important;\n}\n\n.mnh-100p {\n  min-height: 100px !important;\n}\n\n.mnh-125p {\n  min-height: 125px !important;\n}\n\n.mnh-150p {\n  min-height: 150px !important;\n}\n\n.mnh-175p {\n  min-height: 175px !important;\n}\n\n.mnh-200p {\n  min-height: 200px !important;\n}\n\n.mnh-225p {\n  min-height: 225px !important;\n}\n\n.mnh-250p {\n  min-height: 250px !important;\n}\n\n.mnh-275p {\n  min-height: 275px !important;\n}\n\n.mnh-300p {\n  min-height: 300px !important;\n}\n\n.mnh-325p {\n  min-height: 325px !important;\n}\n\n.mnh-350p {\n  min-height: 350px !important;\n}\n\n.mnh-375p {\n  min-height: 375px !important;\n}\n\n.mnh-400p {\n  min-height: 400px !important;\n}\n\n.mnh-425p {\n  min-height: 425px !important;\n}\n\n.mnh-450p {\n  min-height: 450px !important;\n}\n\n.mnh-475p {\n  min-height: 475px !important;\n}\n\n.mnh-500p {\n  min-height: 500px !important;\n}\n\n.mnh-525p {\n  min-height: 525px !important;\n}\n\n.mnh-550p {\n  min-height: 550px !important;\n}\n\n.mnh-575p {\n  min-height: 575px !important;\n}\n\n.mnh-600p {\n  min-height: 600px !important;\n}\n\n.mnh-625p {\n  min-height: 625px !important;\n}\n\n.mnh-650p {\n  min-height: 650px !important;\n}\n\n.mnh-675p {\n  min-height: 675px !important;\n}\n\n.mnh-700p {\n  min-height: 700px !important;\n}\n\n.mnh-725p {\n  min-height: 725px !important;\n}\n\n.mnh-750p {\n  min-height: 750px !important;\n}\n\n.mnh-775p {\n  min-height: 775px !important;\n}\n\n.mnh-800p {\n  min-height: 800px !important;\n}\n\n.mnh-100vh {\n  min-height: 100vh !important;\n}\n\n/*Hr*/\nhr {\n  background: #eaeaea;\n}\nhr.hr-2 {\n  height: 2px !important;\n}\nhr.hr-3 {\n  height: 3px !important;\n}\n\n/*opacity*/\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-30 {\n  opacity: 0.3 !important;\n}\n\n.opacity-35 {\n  opacity: 0.35 !important;\n}\n\n.opacity-40 {\n  opacity: 0.4 !important;\n}\n\n.opacity-45 {\n  opacity: 0.45 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-55 {\n  opacity: 0.55 !important;\n}\n\n.opacity-60 {\n  opacity: 0.6 !important;\n}\n\n.opacity-65 {\n  opacity: 0.65 !important;\n}\n\n.opacity-70 {\n  opacity: 0.7 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-80 {\n  opacity: 0.8 !important;\n}\n\n.opacity-85 {\n  opacity: 0.85 !important;\n}\n\n.opacity-90 {\n  opacity: 0.9 !important;\n}\n\n.opacity-95 {\n  opacity: 0.95 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.bg-opacity-85 {\n  --bs-bg-opacity: 0.85;\n}\n\n/*Div Sizes*/\n.d-1 {\n  height: 0.5rem !important;\n  width: 0.5rem !important;\n}\n\n.d-2 {\n  height: 0.75rem !important;\n  width: 0.75rem !important;\n}\n\n.d-3 {\n  height: 1rem !important;\n  width: 1rem !important;\n}\n\n.d-4 {\n  height: 1.25rem !important;\n  width: 1.25rem !important;\n}\n\n.d-5 {\n  height: 1.5rem !important;\n  width: 1.5rem !important;\n}\n\n.d-6 {\n  height: 1.75rem !important;\n  width: 1.75rem !important;\n}\n\n.d-7 {\n  height: 2rem !important;\n  width: 2rem !important;\n}\n\n.d-8 {\n  height: 2.5rem !important;\n  width: 2.5rem !important;\n}\n\n.d-9 {\n  height: 3rem !important;\n  width: 3rem !important;\n}\n\n.d-10 {\n  height: 3.5rem !important;\n  width: 3.5rem !important;\n}\n\n.d-11 {\n  height: 4rem !important;\n  width: 4rem !important;\n}\n\n.d-12 {\n  height: 4.5rem !important;\n  width: 4.5rem !important;\n}\n\n.d-13 {\n  height: 5rem !important;\n  width: 5rem !important;\n}\n\n.d-14 {\n  height: 5.5rem !important;\n  width: 5.5rem !important;\n}\n\n.d-15 {\n  height: 6rem !important;\n  width: 6rem !important;\n}\n\n.d-16 {\n  height: 7rem !important;\n  width: 7rem !important;\n}\n\n.d-17 {\n  height: 8rem !important;\n  width: 8rem !important;\n}\n\n.d-18 {\n  height: 9rem !important;\n  width: 9rem !important;\n}\n\n.d-19 {\n  height: 10rem !important;\n  width: 10rem !important;\n}\n\n.d-20 {\n  height: 11rem !important;\n  width: 11rem !important;\n}\n\n/*Z-Index*/\n.z-index-1 {\n  z-index: 1 !important;\n}\n\n.z-index-2 {\n  z-index: 2 !important;\n}\n\n.z-index-3 {\n  z-index: 3 !important;\n}\n\n.z-index-4 {\n  z-index: 4 !important;\n}\n\n.z-index-5 {\n  z-index: 5 !important;\n}\n\n.z-index-6 {\n  z-index: 6 !important;\n}\n\n.z-index-7 {\n  z-index: 7 !important;\n}\n\n.z-index-8 {\n  z-index: 8 !important;\n}\n\n.z-index-9 {\n  z-index: 9 !important;\n}\n\n.z-index-10 {\n  z-index: 10 !important;\n}\n\n/*Loader*/\n.preloader-it {\n  background: #fff;\n  position: fixed;\n  z-index: 10001;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.loader-pendulums {\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n  display: block;\n  margin: 0 auto;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 4rem;\n  width: 1em;\n  height: 1em;\n  border-radius: 50%;\n  border: 0.1em solid #d8d8d8;\n}\n.loader-pendulums:before, .loader-pendulums:after {\n  content: '';\n  width: 1em;\n  height: 1em;\n  left: -.1em;\n  top: -.1em;\n  padding: .1em;\n  display: block;\n  border-radius: 50%;\n  position: absolute;\n  -webkit-transform-origin: center center;\n  transform-origin: center center;\n  border: .1em solid;\n  border-color: #9e9e9e transparent transparent transparent;\n  -webkit-animation: pendulum infinite 2s cubic-bezier(0.3, 1.65, 0.7, -0.65);\n  animation: pendulum infinite 2s cubic-bezier(0.3, 1.65, 0.7, -0.65);\n}\n.loader-pendulums:before {\n  border-color: #262a2e transparent transparent transparent;\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n  -webkit-animation-name: pendulum2;\n  animation-name: pendulum2;\n}\n\n@-webkit-keyframes pendulum {\n  from {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(359deg);\n    -moz-transform: rotate(359deg);\n    -ms-transform: rotate(359deg);\n    -o-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes pendulum {\n  from {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(359deg);\n    -moz-transform: rotate(359deg);\n    -ms-transform: rotate(359deg);\n    -o-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@-webkit-keyframes pendulum2 {\n  from {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  to {\n    -webkit-transform: rotate(520deg);\n    -moz-transform: rotate(520deg);\n    -ms-transform: rotate(520deg);\n    -o-transform: rotate(520deg);\n    transform: rotate(520deg);\n  }\n}\n@keyframes pendulum2 {\n  from {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  to {\n    -webkit-transform: rotate(520deg);\n    -moz-transform: rotate(520deg);\n    -ms-transform: rotate(520deg);\n    -o-transform: rotate(520deg);\n    transform: rotate(520deg);\n  }\n}\n/*Scrollbar*/\n.slimScrollBar {\n  right: 0 !important;\n}\n\n.nicescroll-rails.nicescroll-rails-vr {\n  z-index: 999 !important;\n}\n\n.simplebar-placeholder {\n  width: auto !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-scroll-content::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n.simplebar-scrollbar:before {\n  background: #d6d9da;\n}\n.simplebar-scrollbar.simplebar-visible:before {\n  opacity: .8;\n}\n\n.simplebar-content:after,\n.simplebar-content:before {\n  clear: both;\n}\n\n.nicescroll-bar {\n  height: 100%;\n  width: 100%;\n}\n\n.ps__thumb-y,\n.ps__thumb-x {\n  border-radius: 0;\n  background: #d6d9da;\n}\n\n.ps__thumb-x,\n.ps__rail-x {\n  height: 6px;\n}\n\n.ps__thumb-y,\n.ps__rail-y {\n  width: 6px;\n}\n\n.ps__rail-x,\n.ps__rail-y {\n  background: transparent;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n  border-radius: 0;\n  height: 6px;\n  background: #d6d9da;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n  border-radius: 0;\n  width: 6px;\n  background: #d6d9da;\n}\n\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n  background-color: transparent;\n  opacity: 1;\n}\n\n.ps:hover >\n.ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 1;\n}\n\n/*Separator*/\n.separator {\n  padding: 1px 0;\n  margin: 1.25rem 0;\n}\n.separator:after {\n  content: \"\";\n  display: block;\n  width: 100%;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.separator-full {\n  padding: 1px 0;\n  margin: 1.25rem 0;\n}\n.separator-full:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 1px;\n  width: 100%;\n  left: 0;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.v-separator-full {\n  margin: 0 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.v-separator-full:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  display: block;\n  height: 100%;\n  border-right: 1px solid #eaeaea;\n}\n\n.v-separator {\n  margin: 0 1rem;\n}\n.v-separator:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  height: calc(100% - 30px);\n  border-right: 1px solid #d8d8d8;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.separator-light:after {\n  border-color: #f7f7f7;\n}\n\n/*Typography*/\np.p-xl {\n  font-size: 1.25rem;\n}\np.p-lg {\n  font-size: 1.125rem;\n}\np.p-sm {\n  font-size: 0.875rem;\n}\np.p-xs {\n  font-size: 0.75rem;\n}\n\n.title,\n.title-lg,\n.title-sm,\n.title-xs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  margin-bottom: .5rem;\n}\n.title .title-icon,\n.title-lg .title-icon,\n.title-sm .title-icon,\n.title-xs .title-icon {\n  margin-right: .5rem;\n  display: inline-flex;\n}\n.title .title-icon i,\n.title-lg .title-icon i,\n.title-sm .title-icon i,\n.title-xs .title-icon i {\n  line-height: 0;\n}\n.title.title-wth-divider,\n.title-lg.title-wth-divider,\n.title-sm.title-wth-divider,\n.title-xs.title-wth-divider {\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.title.title-wth-divider > span,\n.title-lg.title-wth-divider > span,\n.title-sm.title-wth-divider > span,\n.title-xs.title-wth-divider > span {\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.title.title-wth-divider::before,\n.title-lg.title-wth-divider::before,\n.title-sm.title-wth-divider::before,\n.title-xs.title-wth-divider::before {\n  content: \"\";\n  display: block;\n  height: 1px;\n  width: 0;\n  background: #d8d8d8;\n}\n.title.title-wth-divider::after,\n.title-lg.title-wth-divider::after,\n.title-sm.title-wth-divider::after,\n.title-xs.title-wth-divider::after {\n  content: \"\";\n  display: block;\n  height: 1px;\n  width: 100%;\n  margin-left: .625rem;\n  background: #d8d8d8;\n}\n.title.title-wth-divider.divider-right::before,\n.title-lg.title-wth-divider.divider-right::before,\n.title-sm.title-wth-divider.divider-right::before,\n.title-xs.title-wth-divider.divider-right::before {\n  width: 100%;\n  margin-right: .625rem;\n}\n.title.title-wth-divider.divider-right::after,\n.title-lg.title-wth-divider.divider-right::after,\n.title-sm.title-wth-divider.divider-right::after,\n.title-xs.title-wth-divider.divider-right::after {\n  width: 0;\n  margin: 0;\n}\n.title.title-wth-divider.divider-center::before,\n.title-lg.title-wth-divider.divider-center::before,\n.title-sm.title-wth-divider.divider-center::before,\n.title-xs.title-wth-divider.divider-center::before {\n  width: 100%;\n  margin-right: .625rem;\n}\n.title.title-wth-divider.divider-center::after,\n.title-lg.title-wth-divider.divider-center::after,\n.title-sm.title-wth-divider.divider-center::after,\n.title-xs.title-wth-divider.divider-center::after {\n  width: 100%;\n  margin-left: .625rem;\n}\n\n.title {\n  font-size: 1rem;\n  color: #262a2e;\n  font-weight: 500;\n}\n.title .title-icon {\n  font-size: 1.5rem;\n}\n\n.title-lg {\n  font-size: 1.125rem;\n  color: #262a2e;\n  font-weight: 500;\n}\n.title-lg .title-icon {\n  font-size: 1.75rem;\n}\n\n.title-sm {\n  font-size: 0.875rem;\n  color: #262a2e;\n  font-weight: 500;\n}\n.title-sm .title-icon {\n  font-size: 1.25rem;\n}\n\n.title-xs {\n  font-size: 0.75rem;\n  color: #262a2e;\n  font-weight: 500;\n}\n.title-xs .title-icon {\n  font-size: 1rem;\n}\n\n.small, small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\n.hidden-element {\n  display: none !important;\n}\n\ncode {\n  margin: 0 .25rem;\n  color: #0a2f4c;\n}\n\n.strikethrough s, .strikethrough del {\n  position: relative;\n  text-decoration: none;\n}\n.strikethrough s:after, .strikethrough del:after {\n  content: \"\";\n  height: 12px;\n  background: #0a2f4c;\n  mix-blend-mode: multiply;\n  opacity: .3;\n  width: 100%;\n  position: absolute;\n  margin-left: 0;\n  top: 5px;\n  left: 0;\n  pointer-events: none;\n}\n.strikethrough del:after {\n  background: #FF0000;\n}\n\n.mark, mark {\n  padding: 0;\n  background: none;\n  color: #262a2e;\n  position: relative;\n}\n.mark:after, mark:after {\n  content: \"\";\n  height: 12px;\n  background: #FF9100;\n  mix-blend-mode: multiply;\n  opacity: .3;\n  width: 100%;\n  position: absolute;\n  margin-left: 0;\n  top: 5px;\n  left: 0;\n  pointer-events: none;\n}\n\n.display-1,\n.display-2,\n.display-3,\n.display-4,\n.display-5,\n.display-6 {\n  color: #262a2e;\n}\n\n.hk-dragger {\n  font-size: 2rem;\n  cursor: grab;\n  color: #9e9e9e;\n  margin-right: .625rem;\n}\n\n/*Buttons*/\n.btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button {\n  /* text-transform: capitalize; */\n  outline: none;\n  font-size: 1rem;\n  padding: .375rem  1rem;\n  border-width: 1px;\n  border-radius: 0.375rem;\n  /*Buttons with Icon*/\n  /*HK Custom Buttons*/\n  /*Buttons Icon*/\n  /*Buttons Options*/\n\n}\n.btn:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:focus, .btn:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:active, .btn:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:hover {\n  box-shadow: none;\n}\n.btn > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n.btn > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.btn > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child) {\n  margin-right: .75rem;\n}\n.btn > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child) {\n  margin-left: .75rem;\n}\n.btn.btn-lg > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child) {\n  margin-right: 1.25rem;\n}\n.btn.btn-lg > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child) {\n  margin-left: 1.25rem;\n}\n.btn.btn-sm > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child) {\n  margin-right: 0.75rem;\n}\n.btn.btn-sm > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child) {\n  margin-left: 0.75rem;\n}\n.btn.btn-xs > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child) {\n  margin-right: 0.5rem;\n}\n.btn.btn-xs > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child) {\n  margin-left: 0.5rem;\n}\n.btn.btn-custom, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button {\n  position: relative;\n}\n.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n  position: static;\n}\n.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon {\n  background: rgba(0, 0, 0, 0.08) none repeat scroll 0 0;\n  position: absolute;\n  border-radius: 0.5rem;\n  top: -1px;\n  bottom: -1px;\n  width: 40px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:last-child) {\n  left: -1px;\n  margin: 0;\n}\n.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon:not(:first-child) {\n  right: -1px;\n  left: auto;\n}\n.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child) {\n  padding-right: 2.25rem;\n}\n.btn.btn-custom > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child) {\n  padding-left: 2.25rem;\n}\n.btn.btn-custom.btn-lg > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon {\n  width: 46px;\n  border-radius: 0.5rem;\n}\n.btn.btn-custom.btn-lg > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child) {\n  padding-right: 2.625rem;\n}\n.btn.btn-custom.btn-lg > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-lg.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child) {\n  padding-left: 2.625rem;\n}\n.btn.btn-custom.btn-sm > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon {\n  width: 33px;\n  border-radius: .2rem;\n}\n.btn.btn-custom.btn-sm > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child) {\n  padding-right: 2rem;\n}\n.btn.btn-custom.btn-sm > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child) {\n  padding-left: 2rem;\n}\n.btn.btn-custom.btn-xs > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon {\n  width: 26px;\n  border-radius: .2rem;\n}\n.btn.btn-custom.btn-xs > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:last-child) {\n  padding-right: 1.5rem;\n}\n.btn.btn-custom.btn-xs > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-xs.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) > span:not(.icon):not(:first-child) {\n  padding-left: 1.5rem;\n}\n.btn.btn-custom.btn-square > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-custom.btn-square.hopscotch-nav-button > span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) .icon {\n  border-radius: 0;\n}\n.btn.btn-icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.hopscotch-nav-button {\n  height: 38px;\n  width: 38px;\n  padding: 0;\n}\n.btn.btn-icon[class*=\"btn-flush-\"], div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button {\n  position: relative;\n  border: none;\n  background: transparent !important;\n}\n.btn.btn-icon[class*=\"btn-flush-\"]::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 0;\n  width: 0;\n  background: #298DFF;\n  border-radius: 0.5rem;\n  -webkit-transition: all 200ms;\n  -moz-transition: all 200ms;\n  transition: all 200ms;\n}\n.btn.btn-icon[class*=\"btn-flush-\"]:not(:disabled):not(.disabled).active::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:not(:disabled):not(.disabled).active::before, .btn.btn-icon[class*=\"btn-flush-\"]:not(:disabled):not(.disabled):active::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:not(:disabled):not(.disabled):active::before, .btn.btn-icon[class*=\"btn-flush-\"]:hover::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:hover::before, .btn.btn-icon[class*=\"btn-flush-\"]:focus::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:focus::before {\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n.btn.btn-icon[class*=\"btn-flush-\"]:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"]:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"]:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"]:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].hopscotch-nav-button:focus .icon {\n  color: #fff;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-rounded::before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-rounded.hopscotch-nav-button::before {\n  border-radius: 50%;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.hopscotch-nav-button:before {\n  background: #18DDEF;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:before {\n  background: #edfcfe;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #18DDEF;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-info:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-info.hopscotch-nav-button:disabled {\n  color: rgba(24, 221, 239, 0.8);\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.hopscotch-nav-button:before {\n  background: #00D67F;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:before {\n  background: #ebfcf5;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #00D67F;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-success:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-success.hopscotch-nav-button:disabled {\n  color: rgba(0, 214, 127, 0.8);\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.hopscotch-nav-button:before {\n  background: #FFC400;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:before {\n  background: #fffaeb;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #FFC400;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-warning:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-warning.hopscotch-nav-button:disabled {\n  color: rgba(255, 196, 0, 0.8);\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.hopscotch-nav-button:before {\n  background: #FF0000;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:before {\n  background: #ffebeb;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #FF0000;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-danger:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-danger.hopscotch-nav-button:disabled {\n  color: rgba(255, 0, 0, 0.8);\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.hopscotch-nav-button:before {\n  background: #6f6f6f;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:before {\n  background: #f3f3f3;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #6f6f6f;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-secondary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-secondary.hopscotch-nav-button:disabled {\n  color: rgba(158, 158, 158, 0.8);\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.hopscotch-nav-button:before {\n  background: #0a2f4c;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:before {\n  background: #ebf5f5;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #0a2f4c;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-primary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-primary.hopscotch-nav-button:disabled {\n  color: rgba(41, 141, 255, 0.8);\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.hopscotch-nav-button:before {\n  background: #262a2e;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:before {\n  background: #f7f7f7;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #262a2e;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.hopscotch-nav-button:disabled {\n  color: rgba(38, 42, 46, 0.8);\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.hopscotch-nav-button:before {\n  background: #6f6f6f;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:before {\n  background: #f7f7f7;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:hover .icon, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #6f6f6f;\n}\n.btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.disabled.hopscotch-nav-button, .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-light:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-light.hopscotch-nav-button:disabled {\n  color: rgba(111, 111, 111, 0.8);\n}\n.btn.btn-icon.btn-lg, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-lg.hopscotch-nav-button {\n  height: 45px;\n  width: 45px;\n}\n.btn.btn-icon.btn-lg .btn-icon-wrap, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-lg.hopscotch-nav-button .btn-icon-wrap {\n  font-size: 1.125rem;\n}\n.btn.btn-icon.btn-sm, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.hopscotch-nav-button {\n  height: 31px;\n  width: 31px;\n}\n.btn.btn-icon.btn-sm .btn-icon-wrap, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.hopscotch-nav-button .btn-icon-wrap {\n  font-size: 0.875rem;\n}\n.btn.btn-icon.btn-xs, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-xs.hopscotch-nav-button {\n  height: 28px;\n  width: 28px;\n  padding-left: 0;\n  padding-right: 0;\n}\n.btn.btn-icon.btn-xs .btn-icon-wrap, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon.btn-xs.hopscotch-nav-button .btn-icon-wrap {\n  font-size: 0.875rem;\n}\n.btn.btn-rounded, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-rounded.hopscotch-nav-button {\n  border-radius: 50rem !important;\n}\n.btn.btn-rounded .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-rounded.hopscotch-nav-button .icon {\n  border-radius: 50% !important;\n}\n.btn.btn-square, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-square.hopscotch-nav-button {\n  border-radius: 0 !important;\n}\n.btn.btn-uppercase, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-uppercase.hopscotch-nav-button {\n  text-transform: uppercase !important;\n  font-weight: 600;\n}\n.btn.btn-floating, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-floating.hopscotch-nav-button {\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14) !important;\n  z-index: 1001;\n}\n.btn.btn-animated, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button {\n  -webkit-transition: all 0.15s ease;\n  -moz-transition: all 0.15s ease;\n  transition: all 0.15s ease;\n}\n.btn.btn-animated:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button:hover, .btn.btn-animated:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button:focus {\n  -webkit-transform: translateY(-3px);\n  -moz-transform: translateY(-3px);\n  -ms-transform: translateY(-3px);\n  -o-transform: translateY(-3px);\n  transform: translateY(-3px);\n}\n.btn .custom-caret, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button .custom-caret {\n  display: inline-block !important;\n  margin-left: 5px;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=button].btn-block,\ninput[type=reset].btn-block,\ninput[type=submit].btn-block {\n  width: 100%;\n}\n\n.btn-icon-dropdown {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n/*Button Colors*/\n.btn-info {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-info:hover, .btn-info:focus {\n  color: #fff;\n  background-color: #16c7d7;\n  border-color: #16c7d7;\n}\n.btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #16c7d7;\n  border-color: #16c7d7;\n}\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #a3f1f9;\n  border-color: #a3f1f9;\n}\n.btn-info.btn-animated:focus, .btn-info.btn-animated:active, .btn-info.btn-animated:hover, .btn-info.btn-animated:not(:disabled):not(.disabled).active, .btn-info.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-green {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-green:hover, .btn-green:focus {\n  color: #fff;\n  background-color: #00c172;\n  border-color: #00c172;\n}\n.btn-green:not(:disabled):not(.disabled).active, .btn-green:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #00c172;\n  border-color: #00c172;\n}\n.btn-green.disabled, .btn-green:disabled {\n  color: #fff;\n  background-color: #99efcc;\n  border-color: #99efcc;\n}\n.btn-green.btn-animated:focus, .btn-green.btn-animated:active, .btn-green.btn-animated:hover, .btn-green.btn-animated:not(:disabled):not(.disabled).active, .btn-green.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-success:hover, .btn-success:focus {\n  color: #fff;\n  background-color: #00c172;\n  border-color: #00c172;\n}\n.btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #00c172;\n  border-color: #00c172;\n}\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #99efcc;\n  border-color: #99efcc;\n}\n.btn-success.btn-animated:focus, .btn-success.btn-animated:active, .btn-success.btn-animated:hover, .btn-success.btn-animated:not(:disabled):not(.disabled).active, .btn-success.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-warning {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-warning:hover, .btn-warning:focus {\n  color: #fff;\n  background-color: #e6b000;\n  border-color: #e6b000;\n}\n.btn-warning:not(:disabled):not(.disabled).active, .btn-warning:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #e6b000;\n  border-color: #e6b000;\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #fff;\n  background-color: #ffe799;\n  border-color: #ffe799;\n}\n.btn-warning.btn-animated:focus, .btn-warning.btn-animated:active, .btn-warning.btn-animated:hover, .btn-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-warning.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-danger:hover, .btn-danger:focus {\n  color: #fff;\n  background-color: #e60000;\n  border-color: #e60000;\n}\n.btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #e60000;\n  border-color: #e60000;\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #ff9999;\n  border-color: #ff9999;\n}\n.btn-danger.btn-animated:focus, .btn-danger.btn-animated:active, .btn-danger.btn-animated:hover, .btn-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-danger.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-grey {\n  color: #fff;\n  background-color: #9e9e9e;\n  border-color: #9e9e9e;\n}\n.btn-grey:hover, .btn-grey:focus {\n  color: #fff;\n  background-color: #8e8e8e;\n  border-color: #8e8e8e;\n}\n.btn-grey:not(:disabled):not(.disabled).active, .btn-grey:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #8e8e8e;\n  border-color: #8e8e8e;\n}\n.btn-grey.disabled, .btn-grey:disabled {\n  color: #fff;\n  background-color: #d8d8d8;\n  border-color: #d8d8d8;\n}\n.btn-grey.btn-animated:focus, .btn-grey.btn-animated:active, .btn-grey.btn-animated:hover, .btn-grey.btn-animated:not(:disabled):not(.disabled).active, .btn-grey.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #9e9e9e;\n  border-color: #9e9e9e;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-secondary:hover, .btn-secondary:focus {\n  color: #fff;\n  background-color: #646464;\n  border-color: #646464;\n}\n.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #646464;\n  border-color: #646464;\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #fff;\n  background-color: #c5c5c5;\n  border-color: #c5c5c5;\n}\n.btn-secondary.btn-animated:focus, .btn-secondary.btn-animated:active, .btn-secondary.btn-animated:hover, .btn-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-secondary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-primary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next {\n  color: #fff;\n  background-color: #08364d;\n  border-color: #08364d;\n}\n.btn-primary:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:hover, .btn-primary:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:focus {\n  color: #fff;\n  background-color: #0c4f71;\n  border-color: #0c4f71;\n}\n.btn-primary:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #0c4f71;\n  border-color: #0c4f71;\n}\n.btn-primary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.next, .btn-primary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:disabled {\n  color: #fff;\n  background-color: #99cbcf;\n  border-color: #99cbcf;\n}\n.btn-primary.btn-animated:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:focus, .btn-primary.btn-animated:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:active, .btn-primary.btn-animated:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:hover, .btn-primary.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-primary.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #08364d;\n  border-color: #08364d;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-dark:hover, .btn-dark:focus {\n  color: #fff;\n  background-color: #212429;\n  border-color: #212429;\n}\n.btn-dark:not(:disabled):not(.disabled).active, .btn-dark:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #212429;\n  border-color: #212429;\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #9e9e9e;\n  border-color: #9e9e9e;\n}\n.btn-dark.btn-animated:focus, .btn-dark.btn-animated:active, .btn-dark.btn-animated:hover, .btn-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-dark.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-default,\n.btn-light {\n  color: #262a2e;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n.btn-default:hover, .btn-default:focus,\n.btn-light:hover,\n.btn-light:focus {\n  color: #6f6f6f;\n  background-color: #d8d8d8;\n  border-color: #d8d8d8;\n}\n.btn-default:not(:disabled):not(.disabled).active, .btn-default:not(:disabled):not(.disabled):active,\n.btn-light:not(:disabled):not(.disabled).active,\n.btn-light:not(:disabled):not(.disabled):active {\n  color: #262a2e;\n  background-color: #d8d8d8;\n  border-color: #d8d8d8;\n}\n.btn-default.disabled, .btn-default:disabled,\n.btn-light.disabled,\n.btn-light:disabled {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n.btn-default.btn-animated:focus, .btn-default.btn-animated:active, .btn-default.btn-animated:hover, .btn-default.btn-animated:not(:disabled):not(.disabled).active, .btn-default.btn-animated:not(:disabled):not(.disabled):active,\n.btn-light.btn-animated:focus,\n.btn-light.btn-animated:active,\n.btn-light.btn-animated:hover,\n.btn-light.btn-animated:not(:disabled):not(.disabled).active,\n.btn-light.btn-animated:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-white, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next {\n  color: #262a2e;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-white:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:hover, .btn-white:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:focus {\n  color: #5f5f5f;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-white:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-white:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled):active {\n  color: #5f5f5f;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-white.disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.next, .btn-white:disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:disabled {\n  color: #5f5f5f;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-white.btn-animated:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:focus, .btn-white.btn-animated:active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:active, .btn-white.btn-animated:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:hover, .btn-white.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-white.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active {\n  color: #5f5f5f;\n  background-color: #fff;\n  border-color: #fff;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-link {\n  color: #0a2f4c;\n  text-decoration: none !important;\n}\n.btn-link:hover, .btn-link:focus {\n  color: #0a2f4c;\n}\n\n.btn:not(:disabled):not(.disabled).active:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:not(:disabled):not(.disabled).active:focus,\n.btn:not(:disabled):not(.disabled):active:focus,\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:not(:disabled):not(.disabled):active:focus,\n.show > .btn.dropdown-toggle:focus,\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button:focus {\n  box-shadow: none;\n}\n\n.btn-group-vertical > .btn:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button:hover,\n.btn-group > .btn:hover,\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group > .hopscotch-nav-button:hover {\n  z-index: 0;\n}\n\n.show > .btn-primary.dropdown-toggle, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button.next {\n  color: #fff;\n  background-color: #00717a;\n  border-color: #00717a;\n}\n.show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #646464;\n  border-color: #646464;\n}\n.show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #16c7d7;\n  border-color: #16c7d7;\n}\n.show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: #00c172;\n  border-color: #00c172;\n}\n.show > .btn-warning.dropdown-toggle {\n  color: #fff;\n  background-color: #e6b000;\n  border-color: #e6b000;\n}\n.show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #e60000;\n  border-color: #e60000;\n}\n.show > .btn-light.dropdown-toggle {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n.show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #00717a;\n  border-color: #00717a;\n}\n.show > .btn-outline-secondary.dropdown-toggle, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button.prev {\n  color: #fff;\n  background-color: #646464;\n  border-color: #646464;\n}\n.show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #16c7d7;\n  border-color: #16c7d7;\n}\n.show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #00c172;\n  border-color: #00c172;\n}\n.show > .btn-outline-warning.dropdown-toggle {\n  color: #fff;\n  background-color: #e6b000;\n  border-color: #e6b000;\n}\n.show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #e60000;\n  border-color: #e60000;\n}\n.show > .btn-outline-light.dropdown-toggle, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .show > .dropdown-toggle.btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .show > .dropdown-toggle.hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .show > .dropdown-toggle.hopscotch-nav-button.next {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n.show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #2a2f34;\n  border-color: #2a2f34;\n}\n\n.dropdown > .btn-wth-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/*Buttons Soft*/\n.btn-soft-info {\n  color: #18DDEF;\n  background-color: #edfcfe;\n  border-color: #edfcfe;\n}\n.btn-soft-info:hover, .btn-soft-info:focus {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-soft-info:not(:disabled):not(.disabled).active, .btn-soft-info:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-soft-info.disabled, .btn-soft-info:disabled {\n  color: #18DDEF;\n  background-color: #a3f1f9;\n  border-color: #a3f1f9;\n}\n.btn-soft-info.btn-animated:focus, .btn-soft-info.btn-animated:active, .btn-soft-info.btn-animated:hover, .btn-soft-info.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-info.btn-animated:not(:disabled):not(.disabled):active {\n  color: #18DDEF;\n  background-color: #edfcfe;\n  border-color: #edfcfe;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-soft-success {\n  color: #00D67F;\n  background-color: #ebfcf5;\n  border-color: #ebfcf5;\n}\n.btn-soft-success:hover, .btn-soft-success:focus {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-soft-success:not(:disabled):not(.disabled).active, .btn-soft-success:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-soft-success.disabled, .btn-soft-success:disabled {\n  color: #00D67F;\n  background-color: #99efcc;\n  border-color: #99efcc;\n}\n.btn-soft-success.btn-animated:focus, .btn-soft-success.btn-animated:active, .btn-soft-success.btn-animated:hover, .btn-soft-success.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-success.btn-animated:not(:disabled):not(.disabled):active {\n  color: #00D67F;\n  background-color: #ebfcf5;\n  border-color: #ebfcf5;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-soft-warning {\n  color: #FFC400;\n  background-color: #fffaeb;\n  border-color: #fffaeb;\n}\n.btn-soft-warning:hover, .btn-soft-warning:focus {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-soft-warning:not(:disabled):not(.disabled).active, .btn-soft-warning:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-soft-warning.disabled, .btn-soft-warning:disabled {\n  color: #FFC400;\n  background-color: #ffe799;\n  border-color: #ffe799;\n}\n.btn-soft-warning.btn-animated:focus, .btn-soft-warning.btn-animated:active, .btn-soft-warning.btn-animated:hover, .btn-soft-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-warning.btn-animated:not(:disabled):not(.disabled):active {\n  color: #FFC400;\n  background-color: #fffaeb;\n  border-color: #fffaeb;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-soft-danger {\n  color: #FF0000;\n  background-color: #ffebeb;\n  border-color: #ffebeb;\n}\n.btn-soft-danger:hover, .btn-soft-danger:focus {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-soft-danger:not(:disabled):not(.disabled).active, .btn-soft-danger:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-soft-danger.disabled, .btn-soft-danger:disabled {\n  color: #FF0000;\n  background-color: #ff9999;\n  border-color: #ff9999;\n}\n.btn-soft-danger.btn-animated:focus, .btn-soft-danger.btn-animated:active, .btn-soft-danger.btn-animated:hover, .btn-soft-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-danger.btn-animated:not(:disabled):not(.disabled):active {\n  color: #FF0000;\n  background-color: #ffebeb;\n  border-color: #ffebeb;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-soft-secondary {\n  color: #262a2e;\n  background-color: #f3f3f3;\n  border-color: #f3f3f3;\n}\n.btn-soft-secondary:hover, .btn-soft-secondary:focus {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-soft-secondary:not(:disabled):not(.disabled).active, .btn-soft-secondary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-soft-secondary.disabled, .btn-soft-secondary:disabled {\n  color: #6f6f6f;\n  background-color: #c5c5c5;\n  border-color: #c5c5c5;\n}\n.btn-soft-secondary.btn-animated:focus, .btn-soft-secondary.btn-animated:active, .btn-soft-secondary.btn-animated:hover, .btn-soft-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-secondary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: #f3f3f3;\n  border-color: #f3f3f3;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-soft-primary {\n  color: #0a2f4c;\n  background-color: #ebf5f5;\n  border-color: #ebf5f5;\n}\n.btn-soft-primary:hover, .btn-soft-primary:focus {\n  color: #fff;\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.btn-soft-primary:not(:disabled):not(.disabled).active, .btn-soft-primary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.btn-soft-primary.disabled, .btn-soft-primary:disabled {\n  color: #0a2f4c;\n  background-color: #99cbcf;\n  border-color: #99cbcf;\n}\n.btn-soft-primary.btn-animated:focus, .btn-soft-primary.btn-animated:active, .btn-soft-primary.btn-animated:hover, .btn-soft-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-primary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #0a2f4c;\n  background-color: #ebf5f5;\n  border-color: #ebf5f5;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-soft-light {\n  color: #6f6f6f;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n}\n.btn-soft-light:hover, .btn-soft-light:focus {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-soft-light:not(:disabled):not(.disabled).active, .btn-soft-light:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-soft-light.disabled, .btn-soft-light:disabled {\n  color: #6f6f6f;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n}\n.btn-soft-light.btn-animated:focus, .btn-soft-light.btn-animated:active, .btn-soft-light.btn-animated:hover, .btn-soft-light.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-light.btn-animated:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-soft-dark {\n  color: #262a2e;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n}\n.btn-soft-dark:hover, .btn-soft-dark:focus {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-soft-dark:not(:disabled):not(.disabled).active, .btn-soft-dark:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-soft-dark.disabled, .btn-soft-dark:disabled {\n  color: #fff;\n  background-color: #9e9e9e;\n  border-color: #9e9e9e;\n}\n.btn-soft-dark.btn-animated:focus, .btn-soft-dark.btn-animated:active, .btn-soft-dark.btn-animated:hover, .btn-soft-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-soft-dark.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n/*Buttons Flush*/\n.btn-flush-info {\n  color: #18DDEF;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-info:hover, .btn-flush-info:focus {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-flush-info:not(:disabled):not(.disabled).active, .btn-flush-info:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-flush-info.disabled, .btn-flush-info:disabled {\n  color: #18DDEF;\n  background-color: #a3f1f9;\n  border-color: #a3f1f9;\n}\n.btn-flush-info.flush-outline-hover:hover, .btn-flush-info.flush-outline-hover:focus, .btn-flush-info.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-info.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #18DDEF;\n  background-color: transparent;\n  border-color: #18DDEF;\n}\n.btn-flush-info.flush-soft-hover:hover, .btn-flush-info.flush-soft-hover:focus, .btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-info.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #18DDEF;\n  background-color: #edfcfe;\n  border-color: #edfcfe;\n}\n.btn-flush-info.btn-animated:focus, .btn-flush-info.btn-animated:active, .btn-flush-info.btn-animated:hover, .btn-flush-info.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-info.btn-animated:not(:disabled):not(.disabled):active {\n  color: #18DDEF;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-flush-success {\n  color: #00D67F;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-success:hover, .btn-flush-success:focus {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-flush-success:not(:disabled):not(.disabled).active, .btn-flush-success:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-flush-success.disabled, .btn-flush-success:disabled {\n  color: #00D67F;\n  background-color: #99efcc;\n  border-color: #99efcc;\n}\n.btn-flush-success.flush-outline-hover:hover, .btn-flush-success.flush-outline-hover:focus, .btn-flush-success.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-success.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #00D67F;\n  background-color: transparent;\n  border-color: #00D67F;\n}\n.btn-flush-success.flush-soft-hover:hover, .btn-flush-success.flush-soft-hover:focus, .btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-success.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #00D67F;\n  background-color: #ebfcf5;\n  border-color: #ebfcf5;\n}\n.btn-flush-success.btn-animated:focus, .btn-flush-success.btn-animated:active, .btn-flush-success.btn-animated:hover, .btn-flush-success.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-success.btn-animated:not(:disabled):not(.disabled):active {\n  color: #00D67F;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-flush-warning {\n  color: #FFC400;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-warning:hover, .btn-flush-warning:focus {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-flush-warning:not(:disabled):not(.disabled).active, .btn-flush-warning:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-flush-warning.disabled, .btn-flush-warning:disabled {\n  color: #FFC400;\n  background-color: #ffe799;\n  border-color: #ffe799;\n}\n.btn-flush-warning.flush-outline-hover:hover, .btn-flush-warning.flush-outline-hover:focus, .btn-flush-warning.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-warning.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #FFC400;\n  background-color: transparent;\n  border-color: #FFC400;\n}\n.btn-flush-warning.flush-soft-hover:hover, .btn-flush-warning.flush-soft-hover:focus, .btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-warning.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #FFC400;\n  background-color: #fffaeb;\n  border-color: #fffaeb;\n}\n.btn-flush-warning.btn-animated:focus, .btn-flush-warning.btn-animated:active, .btn-flush-warning.btn-animated:hover, .btn-flush-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-warning.btn-animated:not(:disabled):not(.disabled):active {\n  color: #FFC400;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-flush-danger {\n  color: #FF0000;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-danger:hover, .btn-flush-danger:focus {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-flush-danger:not(:disabled):not(.disabled).active, .btn-flush-danger:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-flush-danger.disabled, .btn-flush-danger:disabled {\n  color: #FF0000;\n  background-color: #ff9999;\n  border-color: #ff9999;\n}\n.btn-flush-danger.flush-outline-hover:hover, .btn-flush-danger.flush-outline-hover:focus, .btn-flush-danger.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-danger.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #FF0000;\n  background-color: transparent;\n  border-color: #FF0000;\n}\n.btn-flush-danger.flush-soft-hover:hover, .btn-flush-danger.flush-soft-hover:focus, .btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-danger.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #FF0000;\n  background-color: #ffebeb;\n  border-color: #ffebeb;\n}\n.btn-flush-danger.btn-animated:focus, .btn-flush-danger.btn-animated:active, .btn-flush-danger.btn-animated:hover, .btn-flush-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-danger.btn-animated:not(:disabled):not(.disabled):active {\n  color: #FF0000;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-flush-secondary {\n  color: #6f6f6f;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-secondary:hover, .btn-flush-secondary:focus {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-flush-secondary:not(:disabled):not(.disabled).active, .btn-flush-secondary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-flush-secondary.disabled, .btn-flush-secondary:disabled {\n  color: #6f6f6f;\n  background-color: #c5c5c5;\n  border-color: #c5c5c5;\n}\n.btn-flush-secondary.flush-outline-hover:hover, .btn-flush-secondary.flush-outline-hover:focus, .btn-flush-secondary.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-secondary.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: transparent;\n  border-color: #6f6f6f;\n}\n.btn-flush-secondary.flush-soft-hover:hover, .btn-flush-secondary.flush-soft-hover:focus, .btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-secondary.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: #f3f3f3;\n  border-color: #f3f3f3;\n}\n.btn-flush-secondary.btn-animated:focus, .btn-flush-secondary.btn-animated:active, .btn-flush-secondary.btn-animated:hover, .btn-flush-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-secondary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-flush-primary {\n  color: #0a2f4c;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-primary:hover, .btn-flush-primary:focus {\n  color: #fff;\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.btn-flush-primary:not(:disabled):not(.disabled).active, .btn-flush-primary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.btn-flush-primary.disabled, .btn-flush-primary:disabled {\n  color: #0a2f4c;\n  background-color: #99cbcf;\n  border-color: #99cbcf;\n}\n.btn-flush-primary.flush-outline-hover:hover, .btn-flush-primary.flush-outline-hover:focus, .btn-flush-primary.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-primary.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #0a2f4c;\n  background-color: transparent;\n  border-color: #0a2f4c;\n}\n.btn-flush-primary.flush-soft-hover:hover, .btn-flush-primary.flush-soft-hover:focus, .btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-primary.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #0a2f4c;\n  background-color: #ebf5f5;\n  border-color: #ebf5f5;\n}\n.btn-flush-primary.btn-animated:focus, .btn-flush-primary.btn-animated:active, .btn-flush-primary.btn-animated:hover, .btn-flush-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-primary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #0a2f4c;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-flush-dark {\n  color: #262a2e;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-dark:hover, .btn-flush-dark:focus {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-flush-dark:not(:disabled):not(.disabled).active, .btn-flush-dark:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-flush-dark.disabled, .btn-flush-dark:disabled {\n  color: #fff;\n  background-color: #9e9e9e;\n  border-color: #9e9e9e;\n}\n.btn-flush-dark.flush-outline-hover:hover, .btn-flush-dark.flush-outline-hover:focus, .btn-flush-dark.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-dark.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #262a2e;\n  background-color: transparent;\n  border-color: #262a2e;\n}\n.btn-flush-dark.flush-soft-hover:hover, .btn-flush-dark.flush-soft-hover:focus, .btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #262a2e;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n}\n.btn-flush-dark.btn-animated:focus, .btn-flush-dark.btn-animated:active, .btn-flush-dark.btn-animated:hover, .btn-flush-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-dark.btn-animated:not(:disabled):not(.disabled):active {\n  color: #262a2e;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-flush-light {\n  color: #6f6f6f;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-flush-light:hover, .btn-flush-light:focus {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-flush-light:not(:disabled):not(.disabled).active, .btn-flush-light:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-flush-light.disabled, .btn-flush-light:disabled {\n  color: #6f6f6f;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n}\n.btn-flush-light.flush-outline-hover:hover, .btn-flush-light.flush-outline-hover:focus, .btn-flush-light.flush-outline-hover:not(:disabled):not(.disabled).active, .btn-flush-light.flush-outline-hover:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: transparent;\n  background-image: none;\n  border-color: #eaeaea;\n}\n.btn-flush-light.flush-soft-hover:hover, .btn-flush-light.flush-soft-hover:focus, .btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled).active, .btn-flush-light.flush-soft-hover:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: #f7f7f7;\n  border-color: #f7f7f7;\n}\n.btn-flush-light.btn-animated:focus, .btn-flush-light.btn-animated:active, .btn-flush-light.btn-animated:hover, .btn-flush-light.btn-animated:not(:disabled):not(.disabled).active, .btn-flush-light.btn-animated:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n/*Buttons Gradien*/\n.btn-gradient-primary {\n  color: #fff;\n  border: none;\n  background: #0a2f4c;\n  background: linear-gradient(45deg, #0a2f4c, #955cfa) !important;\n}\n.btn-gradient-primary:hover, .btn-gradient-primary:focus {\n  color: #fff;\n  background: #00717a;\n  background: linear-gradient(45deg, #00717a, #7429F8) !important;\n}\n.btn-gradient-primary:not(:disabled):not(.disabled).active, .btn-gradient-primary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background: #00717a;\n  background: linear-gradient(45deg, #00717a, #7429F8) !important;\n}\n.btn-gradient-primary.disabled, .btn-gradient-primary:disabled {\n  color: #fff;\n  background: #99cbcf;\n  background: linear-gradient(45deg, #99cbcf, #c7a9fc) !important;\n}\n.btn-gradient-primary.btn-animated:focus, .btn-gradient-primary.btn-animated:active, .btn-gradient-primary.btn-animated:hover, .btn-gradient-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-primary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border: none;\n  background: #0a2f4c;\n  background: linear-gradient(45deg, #0a2f4c, #955cfa) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-gradient-info {\n  color: #fff;\n  border: none;\n  background: #18DDEF;\n  background: linear-gradient(45deg, #18DDEF, #0a2f4c) !important;\n}\n.btn-gradient-info:hover, .btn-gradient-info:focus {\n  color: #fff;\n  background: #16c7d7;\n  background: linear-gradient(45deg, #16c7d7, #00717a) !important;\n}\n.btn-gradient-info:not(:disabled):not(.disabled).active, .btn-gradient-info:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background: #16c7d7;\n  background: linear-gradient(45deg, #16c7d7, #00717a) !important;\n}\n.btn-gradient-info.disabled, .btn-gradient-info:disabled {\n  color: #fff;\n  background: #a3f1f9;\n  background: linear-gradient(45deg, #a3f1f9, #99cbcf) !important;\n}\n.btn-gradient-info.btn-animated:focus, .btn-gradient-info.btn-animated:active, .btn-gradient-info.btn-animated:hover, .btn-gradient-info.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-info.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border: none;\n  background: #18DDEF;\n  background: linear-gradient(45deg, #18DDEF, #0a2f4c) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-gradient-success {\n  color: #fff;\n  border: none;\n  background: #00D67F;\n  background: linear-gradient(45deg, #00D67F, #81E230) !important;\n}\n.btn-gradient-success:hover, .btn-gradient-success:focus {\n  color: #fff;\n  background: #00c172;\n  background: linear-gradient(45deg, #00c172, #74cb2b) !important;\n}\n.btn-gradient-success:not(:disabled):not(.disabled).active, .btn-gradient-success:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background: #00c172;\n  background: linear-gradient(45deg, #00c172, #74cb2b) !important;\n}\n.btn-gradient-success.disabled, .btn-gradient-success:disabled {\n  color: #fff;\n  background: #99efcc;\n  background: linear-gradient(45deg, #99efcc, #cdf3ac) !important;\n}\n.btn-gradient-success.btn-animated:focus, .btn-gradient-success.btn-animated:active, .btn-gradient-success.btn-animated:hover, .btn-gradient-success.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-success.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border: none;\n  background: #00D67F;\n  background: linear-gradient(45deg, #00D67F, #81E230) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-gradient-warning {\n  color: #fff;\n  border: none;\n  background: #FFC400;\n  background: linear-gradient(45deg, #FFC400, #FFEA00) !important;\n}\n.btn-gradient-warning:hover, .btn-gradient-warning:focus {\n  color: #fff;\n  background: #e6b000;\n  background: linear-gradient(45deg, #e6b000, #e6d300) !important;\n}\n.btn-gradient-warning:not(:disabled):not(.disabled).active, .btn-gradient-warning:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background: #e6b000;\n  background: linear-gradient(45deg, #e6b000, #e6d300) !important;\n}\n.btn-gradient-warning.disabled, .btn-gradient-warning:disabled {\n  color: #fff;\n  background: #ffe799;\n  background: linear-gradient(45deg, #ffe799, #fff799) !important;\n}\n.btn-gradient-warning.btn-animated:focus, .btn-gradient-warning.btn-animated:active, .btn-gradient-warning.btn-animated:hover, .btn-gradient-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-warning.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border: none;\n  background: #FFC400;\n  background: linear-gradient(45deg, #FFC400, #FFEA00) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-gradient-danger {\n  color: #fff;\n  border: none;\n  background: #ff3d3d;\n  background: linear-gradient(45deg, #ff3d3d, #E92990) !important;\n}\n.btn-gradient-danger:hover, .btn-gradient-danger:focus {\n  color: #fff;\n  background: #FF0000;\n  background: linear-gradient(45deg, #FF0000, #d22582) !important;\n}\n.btn-gradient-danger:not(:disabled):not(.disabled).active, .btn-gradient-danger:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background: #FF0000;\n  background: linear-gradient(45deg, #FF0000, #d22582) !important;\n}\n.btn-gradient-danger.disabled, .btn-gradient-danger:disabled {\n  color: #fff;\n  background: #ff9999;\n  background: linear-gradient(45deg, #ff9999, #f6a9d3) !important;\n}\n.btn-gradient-danger.btn-animated:focus, .btn-gradient-danger.btn-animated:active, .btn-gradient-danger.btn-animated:hover, .btn-gradient-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-danger.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border: none;\n  background: #ff3d3d;\n  background: linear-gradient(45deg, #ff3d3d, #E92990) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-gradient-secondary {\n  color: #fff;\n  border: none;\n  background: #6f6f6f;\n  background: linear-gradient(45deg, #6f6f6f, #d8d8d8) !important;\n}\n.btn-gradient-secondary:hover, .btn-gradient-secondary:focus {\n  color: #fff;\n  background: #646464;\n  background: linear-gradient(45deg, #646464, #c7c7c7) !important;\n}\n.btn-gradient-secondary:not(:disabled):not(.disabled).active, .btn-gradient-secondary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background: #646464;\n  background: linear-gradient(45deg, #646464, #c7c7c7) !important;\n}\n.btn-gradient-secondary.disabled, .btn-gradient-secondary:disabled {\n  color: #fff;\n  background: #c5c5c5;\n  background: linear-gradient(45deg, #c5c5c5, #d8d8d8) !important;\n}\n.btn-gradient-secondary.btn-animated:focus, .btn-gradient-secondary.btn-animated:active, .btn-gradient-secondary.btn-animated:hover, .btn-gradient-secondary.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-secondary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border: none;\n  background: #6f6f6f;\n  background: linear-gradient(45deg, #6f6f6f, #d8d8d8) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-gradient-light {\n  color: #262a2e;\n  border: none;\n  background: #b5b5b5;\n  background: linear-gradient(45deg, #b5b5b5, #f7f7f7) !important;\n}\n.btn-gradient-light:hover, .btn-gradient-light:focus {\n  color: #262a2e;\n  background: #d8d8d8;\n  background: linear-gradient(45deg, #d8d8d8, #eaeaea) !important;\n}\n.btn-gradient-light:not(:disabled):not(.disabled).active, .btn-gradient-light:not(:disabled):not(.disabled):active {\n  color: #262a2e;\n  background: #d8d8d8;\n  background: linear-gradient(45deg, #d8d8d8, #eaeaea) !important;\n}\n.btn-gradient-light.disabled, .btn-gradient-light:disabled {\n  color: #262a2e;\n  background: #f7f7f7;\n  background: linear-gradient(45deg, #f7f7f7, #d8d8d8) !important;\n}\n.btn-gradient-light.btn-animated:focus, .btn-gradient-light.btn-animated:active, .btn-gradient-light.btn-animated:hover, .btn-gradient-light.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-light.btn-animated:not(:disabled):not(.disabled):active {\n  color: #262a2e;\n  border: none;\n  background: #b5b5b5;\n  background: linear-gradient(45deg, #b5b5b5, #f7f7f7) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-gradient-dark {\n  color: #fff;\n  border: none;\n  background: #262a2e;\n  background: linear-gradient(45deg, #262a2e, #6f6f6f) !important;\n}\n.btn-gradient-dark:hover, .btn-gradient-dark:focus {\n  color: #fff;\n  background: #212429;\n  background: linear-gradient(45deg, #212429, #4f4f4f) !important;\n}\n.btn-gradient-dark:not(:disabled):not(.disabled).active, .btn-gradient-dark:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background: #212429;\n  background: linear-gradient(45deg, #212429, #4f4f4f) !important;\n}\n.btn-gradient-dark.disabled, .btn-gradient-dark:disabled {\n  color: #fff;\n  background: #2F343A;\n  background: linear-gradient(45deg, #2F343A, #d8d8d8) !important;\n}\n.btn-gradient-dark.btn-animated:focus, .btn-gradient-dark.btn-animated:active, .btn-gradient-dark.btn-animated:hover, .btn-gradient-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-gradient-dark.btn-animated:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border: none;\n  background: #262a2e;\n  background: linear-gradient(45deg, #262a2e, #6f6f6f) !important;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n/*Buttons Outline*/\n.btn-outline-info {\n  color: #18DDEF;\n  background-color: transparent;\n  background-image: none;\n  border-color: #18DDEF;\n}\n.btn-outline-info:hover, .btn-outline-info:focus {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-outline-info:not(:disabled):not(.disabled).active, .btn-outline-info:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #fff;\n  background-color: #a3f1f9;\n  border-color: #a3f1f9;\n}\n.btn-outline-info.btn-animated:focus, .btn-outline-info.btn-animated:active, .btn-outline-info.btn-animated:hover, .btn-outline-info.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-info.btn-animated:not(:disabled):not(.disabled):active {\n  color: #18DDEF;\n  background-color: transparent;\n  background-image: none;\n  border-color: #18DDEF;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-success {\n  color: #00D67F;\n  background-color: transparent;\n  background-image: none;\n  border-color: #00D67F;\n}\n.btn-outline-success:hover, .btn-outline-success:focus {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-outline-success:not(:disabled):not(.disabled).active, .btn-outline-success:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #fff;\n  background-color: #99efcc;\n  border-color: #99efcc;\n}\n.btn-outline-success.btn-animated:focus, .btn-outline-success.btn-animated:active, .btn-outline-success.btn-animated:hover, .btn-outline-success.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-success.btn-animated:not(:disabled):not(.disabled):active {\n  color: #00D67F;\n  background-color: transparent;\n  background-image: none;\n  border-color: #00D67F;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-warning {\n  color: #FFC400;\n  background-color: transparent;\n  background-image: none;\n  border-color: #FFC400;\n}\n.btn-outline-warning:hover, .btn-outline-warning:focus {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-outline-warning:not(:disabled):not(.disabled).active, .btn-outline-warning:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #fff;\n  background-color: #ffe799;\n  border-color: #ffe799;\n}\n.btn-outline-warning.btn-animated:focus, .btn-outline-warning.btn-animated:active, .btn-outline-warning.btn-animated:hover, .btn-outline-warning.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-warning.btn-animated:not(:disabled):not(.disabled):active {\n  color: #FFC400;\n  background-color: transparent;\n  background-image: none;\n  border-color: #FFC400;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-danger {\n  color: #FF0000;\n  background-color: transparent;\n  background-image: none;\n  border-color: #FF0000;\n}\n.btn-outline-danger:hover, .btn-outline-danger:focus {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #fff;\n  background-color: #ff9999;\n  border-color: #ff9999;\n}\n.btn-outline-danger.btn-animated:focus, .btn-outline-danger.btn-animated:active, .btn-outline-danger.btn-animated:hover, .btn-outline-danger.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-danger.btn-animated:not(:disabled):not(.disabled):active {\n  color: #FF0000;\n  background-color: transparent;\n  background-image: none;\n  border-color: #FF0000;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-secondary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {\n  color: #6f6f6f;\n  background-color: transparent;\n  background-image: none;\n  border-color: #6f6f6f;\n}\n.btn-outline-secondary:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:hover, .btn-outline-secondary:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:focus {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-secondary:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-outline-secondary.disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.prev, .btn-outline-secondary:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:disabled {\n  color: #fff;\n  background-color: #c5c5c5;\n  border-color: #c5c5c5;\n}\n.btn-outline-secondary.btn-animated:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:focus, .btn-outline-secondary.btn-animated:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:active, .btn-outline-secondary.btn-animated:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:hover, .btn-outline-secondary.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-secondary.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: transparent;\n  background-image: none;\n  border-color: #6f6f6f;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-primary {\n  color: #08364d;\n  background-color: transparent;\n  background-image: none;\n  border-color: #08364d;\n}\n.btn-outline-primary:hover, .btn-outline-primary:focus {\n  color: #fff;\n  background-color: #08364d;\n  border-color: #08364d;\n}\n.btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #08364d;\n  border-color: #08364d;\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #fff;\n  background-color: #99cbcf;\n  border-color: #99cbcf;\n}\n.btn-outline-primary.btn-animated:focus, .btn-outline-primary.btn-animated:active, .btn-outline-primary.btn-animated:hover, .btn-outline-primary.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-primary.btn-animated:not(:disabled):not(.disabled):active {\n  color: #08364d;\n  background-color: transparent;\n  background-image: none;\n  border-color: #0a2f4c;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-dark {\n  color: #262a2e;\n  background-color: transparent;\n  background-image: none;\n  border-color: #262a2e;\n}\n.btn-outline-dark:hover, .btn-outline-dark:focus {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-outline-dark:not(:disabled):not(.disabled).active, .btn-outline-dark:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #fff;\n  background-color: #9e9e9e;\n  border-color: #9e9e9e;\n}\n.btn-outline-dark.btn-animated:focus, .btn-outline-dark.btn-animated:active, .btn-outline-dark.btn-animated:hover, .btn-outline-dark.btn-animated:not(:disabled):not(.disabled).active, .btn-outline-dark.btn-animated:not(:disabled):not(.disabled):active {\n  color: #262a2e;\n  background-color: transparent;\n  background-image: none;\n  border-color: #262a2e;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-light, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next {\n  color: #6f6f6f;\n  background-color: transparent;\n  background-image: none;\n  border-color: #eaeaea;\n}\n.btn-outline-light:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:hover, .btn-outline-light:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:focus {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n.btn-outline-light:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-outline-light:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n.btn-outline-light.disabled, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .disabled.btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .disabled.hopscotch-nav-button.next, .btn-outline-light:disabled, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-primary:disabled, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:disabled {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n.btn-outline-light.btn-animated:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:focus, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:focus, .btn-outline-light.btn-animated:active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:active, .btn-outline-light.btn-animated:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:hover, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:hover, .btn-outline-light.btn-animated:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:not(:disabled):not(.disabled).active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled).active, .btn-outline-light.btn-animated:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.btn-primary:not(:disabled):not(.disabled):active, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-animated.hopscotch-nav-button.next:not(:disabled):not(.disabled):active {\n  color: #6f6f6f;\n  background-color: transparent;\n  background-image: none;\n  border-color: #eaeaea;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n.btn-outline-white, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {\n  color: #fff;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fff;\n}\n.btn-outline-white:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:hover, .btn-outline-white:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:focus {\n  color: #fff;\n  background-color: transparent;\n  border-color: #fff;\n}\n.btn-outline-white:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-white:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: transparent;\n  border-color: #fff;\n}\n.btn-outline-white.disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .disabled.hopscotch-nav-button.prev, .btn-outline-white:disabled, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev:disabled {\n  color: #fff;\n  background-color: transparent;\n  border-color: #fff;\n}\n.btn-outline-white.btn-animated:focus, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:focus, .btn-outline-white.btn-animated:active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:active, .btn-outline-white.btn-animated:hover, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:hover, .btn-outline-white.btn-animated:not(:disabled):not(.disabled).active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled).active, .btn-outline-white.btn-animated:not(:disabled):not(.disabled):active, div.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .btn-animated.hopscotch-nav-button.prev:not(:disabled):not(.disabled):active {\n  color: #fff;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fff;\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;\n}\n\n/*Buttons Check*/\n.btn-check:active + .btn-info, .btn-check:checked + .btn-info {\n  color: #fff;\n  background-color: #16c7d7;\n  border-color: #16c7d7;\n}\n.btn-check:active + .btn-success, .btn-check:checked + .btn-success {\n  color: #fff;\n  background-color: #00c172;\n  border-color: #00c172;\n}\n.btn-check:active + .btn-warning, .btn-check:checked + .btn-warning {\n  color: #fff;\n  background-color: #e6b000;\n  border-color: #e6b000;\n}\n.btn-check:active + .btn-danger, .btn-check:checked + .btn-danger {\n  color: #fff;\n  background-color: #e60000;\n  border-color: #e60000;\n}\n.btn-check:active + .btn-secondary, .btn-check:checked + .btn-secondary {\n  color: #fff;\n  background-color: #646464;\n  border-color: #646464;\n}\n.btn-check:active + .btn-primary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:active + .hopscotch-nav-button.next, .btn-check:checked + .btn-primary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:checked + .hopscotch-nav-button.next {\n  color: #fff;\n  background-color: #00717a;\n  border-color: #00717a;\n}\n.btn-check:active + .btn-dark, .btn-check:checked + .btn-dark {\n  color: #fff;\n  background-color: #212429;\n  border-color: #212429;\n}\n.btn-check:active + .btn-light, .btn-check:checked + .btn-light {\n  color: #262a2e;\n  background-color: #d8d8d8;\n  border-color: #d8d8d8;\n}\n.btn-check:active + .btn-outline-info, .btn-check:checked + .btn-outline-info {\n  color: #fff;\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.btn-check:active + .btn-outline-success, .btn-check:checked + .btn-outline-success {\n  color: #fff;\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.btn-check:active + .btn-outline-warning, .btn-check:checked + .btn-outline-warning {\n  color: #fff;\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.btn-check:active + .btn-outline-danger, .btn-check:checked + .btn-outline-danger {\n  color: #fff;\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-check:active + .btn-outline-secondary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:active + .hopscotch-nav-button.prev, .btn-check:checked + .btn-outline-secondary, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:checked + .hopscotch-nav-button.prev {\n  color: #fff;\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n.btn-check:active + .btn-outline-primary, .btn-check:checked + .btn-outline-primary {\n  color: #fff;\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.btn-check:active + .btn-outline-dark, .btn-check:checked + .btn-outline-dark {\n  color: #fff;\n  background-color: #262a2e;\n  border-color: #262a2e;\n}\n.btn-check:active + .btn-outline-light, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:active + .btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:active + .hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:active + .hopscotch-nav-button.next, .btn-check:checked + .btn-outline-light, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:checked + .btn-primary, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-check:checked + .hopscotch-nav-button.next, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn-check:checked + .hopscotch-nav-button.next {\n  color: #6f6f6f;\n  background-color: #eaeaea;\n  border-color: #eaeaea;\n}\n\n/*Buttons Group*/\n.btn-group .btn + .btn, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .hopscotch-nav-button + .btn, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .btn + .hopscotch-nav-button, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .hopscotch-nav-button + .hopscotch-nav-button, .btn-group .btn + .btn-group, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .btn-group, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .hopscotch-nav-button + .btn-group, .btn-group .btn-group + .btn, .btn-group div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group .btn-group + .hopscotch-nav-button, .btn-group .btn-group + .btn-group {\n  margin-left: -1px;\n}\n\n.btn-group-vertical > .btn + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .btn + .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button + .hopscotch-nav-button, .btn-group-vertical > .btn + .btn-group, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .hopscotch-nav-button + .btn-group, .btn-group-vertical > .btn-group + .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-vertical > .btn-group + .hopscotch-nav-button, .btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n\n.btn-group-lg > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-lg > .hopscotch-nav-button,\n.btn-lg {\n  font-size: 1.125rem;\n  padding: 0.5rem 1.3rem;\n  border-radius: 0.375rem;\n}\n\n.btn-group-sm > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-sm > .hopscotch-nav-button,\n.btn-sm,\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button {\n  font-size: 0.875rem;\n  padding: .25rem .8rem;\n  border-radius: 0.375rem;\n}\n\n.btn-group-xs > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-xs > .hopscotch-nav-button,\n.btn-xs {\n  font-size: .75rem;\n  padding: .25rem .6rem;\n}\n\n/*Button Social*/\n.btn-social {\n  color: #fff;\n  -webkit-transition: all 0.15s ease;\n  -moz-transition: all 0.15s ease;\n  transition: all 0.15s ease;\n}\n.btn-social:focus, .btn-social:active, .btn-social:hover {\n  color: #fff;\n  -webkit-transform: translateY(-3px);\n  -moz-transform: translateY(-3px);\n  -ms-transform: translateY(-3px);\n  -o-transform: translateY(-3px);\n  transform: translateY(-3px);\n}\n.btn-social.btn-social-facebook {\n  background-color: #1778F2;\n  border-color: #1778F2;\n}\n.btn-social.btn-social-facebook:focus, .btn-social.btn-social-facebook:active, .btn-social.btn-social-facebook:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(23, 120, 242, 0.6) !important;\n}\n.btn-social.btn-social-twitter {\n  background-color: #00acee;\n  border-color: #00acee;\n}\n.btn-social.btn-social-twitter:focus, .btn-social.btn-social-twitter:active, .btn-social.btn-social-twitter:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 172, 238, 0.6) !important;\n}\n.btn-social.btn-social-gplus {\n  background-color: #db4a39;\n  border-color: #db4a39;\n}\n.btn-social.btn-social-gplus:focus, .btn-social.btn-social-gplus:active, .btn-social.btn-social-gplus:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(219, 74, 57, 0.6) !important;\n}\n.btn-social.btn-social-linkedin {\n  background-color: #0077B5;\n  border-color: #0077B5;\n}\n.btn-social.btn-social-linkedin:focus, .btn-social.btn-social-linkedin:active, .btn-social.btn-social-linkedin:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 119, 181, 0.6) !important;\n}\n.btn-social.btn-social-instagram {\n  border-color: transparent;\n  background: #f0100f;\n  background: linear-gradient(45deg, #f0100f, #b900b3) !important;\n}\n.btn-social.btn-social-instagram:focus, .btn-social.btn-social-instagram:active, .btn-social.btn-social-instagram:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(240, 16, 15, 0.6) !important;\n  background: #f0100f;\n  background: linear-gradient(45deg, #f0100f, #b900b3) !important;\n}\n.btn-social.btn-social-pinterest {\n  background-color: #E60023;\n  border-color: #E60023;\n}\n.btn-social.btn-social-pinterest:focus, .btn-social.btn-social-pinterest:active, .btn-social.btn-social-pinterest:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(230, 0, 35, 0.6) !important;\n}\n.btn-social.btn-social-dribbble {\n  background-color: #ea4c89;\n  border-color: #ea4c89;\n}\n.btn-social.btn-social-dribbble:focus, .btn-social.btn-social-dribbble:active, .btn-social.btn-social-dribbble:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(234, 76, 137, 0.6) !important;\n}\n.btn-social.btn-social-youtube {\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.btn-social.btn-social-youtube:focus, .btn-social.btn-social-youtube:active, .btn-social.btn-social-youtube:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(255, 0, 0, 0.6) !important;\n}\n.btn-social.btn-social-dropbox {\n  background-color: #0061ff;\n  border-color: #0061ff;\n}\n.btn-social.btn-social-dropbox:focus, .btn-social.btn-social-dropbox:active, .btn-social.btn-social-dropbox:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 97, 255, 0.6) !important;\n}\n.btn-social.btn-social-github {\n  background-color: #24292e;\n  border-color: #24292e;\n}\n.btn-social.btn-social-github:focus, .btn-social.btn-social-github:active, .btn-social.btn-social-github:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(36, 41, 46, 0.6) !important;\n}\n.btn-social.btn-social-skype {\n  background-color: #00aff0;\n  border-color: #00aff0;\n}\n.btn-social.btn-social-skype:focus, .btn-social.btn-social-skype:active, .btn-social.btn-social-skype:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 175, 240, 0.6) !important;\n}\n.btn-social.btn-social-tumblr {\n  background-color: #000000;\n  border-color: #000000;\n}\n.btn-social.btn-social-tumblr:focus, .btn-social.btn-social-tumblr:active, .btn-social.btn-social-tumblr:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 0, 0, 0.6) !important;\n}\n.btn-social.btn-social-flickr {\n  background-color: #0063dc;\n  border-color: #0063dc;\n}\n.btn-social.btn-social-flickr:focus, .btn-social.btn-social-flickr:active, .btn-social.btn-social-flickr:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(0, 99, 220, 0.6) !important;\n}\n.btn-social.btn-social-behance {\n  background-color: #1769ff;\n  border-color: #1769ff;\n}\n.btn-social.btn-social-behance:focus, .btn-social.btn-social-behance:active, .btn-social.btn-social-behance:hover {\n  box-shadow: 0 1.25rem 1.875rem -0.625rem rgba(23, 105, 255, 0.6) !important;\n}\n\n/*Wrapper*/\n.hk-wrapper {\n  position: relative;\n}\n\n.hk-pg-wrapper {\n  padding: 65px 0 60px;\n  position: relative;\n  min-height: 100vh;\n}\n\n/*Gutter*/\n.g-5, .gx-5 {\n  --bs-gutter-x: 2rem;\n}\n\n.g-5, .gy-5 {\n  --bs-gutter-y: 2rem;\n}\n\n.g-6, .gx-6 {\n  --bs-gutter-x: 2.5rem;\n}\n\n.g-6, .gy-6 {\n  --bs-gutter-y: 2.5rem;\n}\n\n.g-7, .gx-7 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-7, .gy-7 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .g-sm-5, .gx-sm-5 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-sm-5, .gy-sm-5 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-sm-6, .gx-sm-6 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-sm-6, .gy-sm-6 {\n    --bs-gutter-y: 2.5rem;\n  }\n\n  .g-sm-7, .gx-sm-7 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-sm-7, .gy-sm-7 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .g-md-5, .gx-md-5 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-md-5, .gy-md-5 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-md-6, .gx-md-6 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-md-6, .gy-md-6 {\n    --bs-gutter-y: 2.5rem;\n  }\n\n  .g-md-7, .gx-md-7 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-md-7, .gy-md-7 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .g-lg-5, .gx-lg-5 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-lg-5, .gy-lg-5 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-lg-6, .gx-lg-6 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-lg-6, .gy-lg-6 {\n    --bs-gutter-y: 2.5rem;\n  }\n\n  .g-lg-7, .gx-lg-7 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-lg-7, .gy-lg-7 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .g-xl-5, .gx-xl-5 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-xl-5, .gy-xl-5 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-xl-6, .gx-xl-6 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-xl-6, .gy-xl-6 {\n    --bs-gutter-y: 2.5rem;\n  }\n\n  .g-xl-7, .gx-xl-7 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-xl-7, .gy-xl-7 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .g-xxl-5, .gx-xxl-5 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-xxl-5, .gy-xxl-5 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-xxl-6, .gx-xxl-6 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-xxl-6, .gy-xxl-6 {\n    --bs-gutter-y: 2.5rem;\n  }\n\n  .g-xxl-7, .gx-xxl-7 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-xxl-7, .gy-xxl-7 {\n    --bs-gutter-y: 3rem;\n  }\n}\n/*Hk Section*/\n.hk-section {\n  margin-bottom: 3.125rem;\n}\n.hk-section .hk-sec-title {\n  margin-bottom: 1.25rem;\n}\n\n/*Card*/\n.card {\n  border-color: #eaeaea;\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);\n  margin-bottom: .875rem;\n  border-radius: 0.5rem;\n}\n.card .card-header {\n  background: transparent;\n  border-color: #eaeaea;\n  padding: 0.75rem 1.25rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.card .card-header > h1, .card .card-header > h2, .card .card-header > h3, .card .card-header > h4, .card .card-header > h5, .card .card-header > h6, .card .card-header > .h1, .card .card-header > .h2, .card .card-header > .h3, .card .card-header > .h4, .card .card-header > .h5, .card .card-header > .h6 {\n  margin-bottom: 0;\n}\n.card .card-header.card-header-bold {\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.card .card-header.card-header-wth-bg {\n  background: #f7f7f7;\n  border-color: transparent;\n}\n.card .card-header.card-header-wth-bg.card-header-action .card-action-wrap {\n  color: #fff;\n}\n.card .card-header.card-header-action .card-action-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.card .card-header.card-header-action .card-action-wrap > a.collapsed {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.card .card-header.card-header-action.card-header-wth-text {\n  align-items: flex-start;\n  -webkit-box-align: flex-start;\n  -ms-flex-align: flex-start;\n  border-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;\n}\n.card .card-header.card-header-wth-bg-inv {\n  color: #fff;\n  background: #0a2f4c;\n  border-color: transparent;\n}\n.card .card-header.card-header-wth-bg-inv h1, .card .card-header.card-header-wth-bg-inv h2, .card .card-header.card-header-wth-bg-inv h3, .card .card-header.card-header-wth-bg-inv h4, .card .card-header.card-header-wth-bg-inv h5, .card .card-header.card-header-wth-bg-inv h6, .card .card-header.card-header-wth-bg-inv .h1, .card .card-header.card-header-wth-bg-inv .h2, .card .card-header.card-header-wth-bg-inv .h3, .card .card-header.card-header-wth-bg-inv .h4, .card .card-header.card-header-wth-bg-inv .h5, .card .card-header.card-header-wth-bg-inv .h6 {\n  color: #fff;\n}\n.card .card-header:first-child {\n  border-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;\n}\n.card .card-header .nav-tabs.card-header-tabs {\n  border-bottom: 0;\n}\n.card.sticky-card-header .card-header {\n  top: 64px;\n  position: -webkit-sticky;\n  position: sticky;\n  z-index: 100;\n}\n.card .card-text {\n  margin-bottom: 1rem;\n}\n.card .card-text:last-child {\n  margin-bottom: 0;\n}\n.card .card-title {\n  font-size: 1rem;\n  color: #262a2e;\n  font-weight: 500;\n}\n.card .card-subtitle {\n  font-size: 0.875rem;\n}\n.card .card-body {\n  padding: 1.25rem;\n  min-height: 1px;\n}\n.card .card-body > .card-action-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: absolute;\n  right: 14px;\n  top: 8px;\n}\n.card .card-body > .card-action-wrap .btn, .card .card-body > .card-action-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .card .card-body > .card-action-wrap .hopscotch-nav-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-shrink: 0;\n}\n.card .card-body > .card-close {\n  position: absolute;\n  right: 14px;\n  top: 10px;\n  cursor: pointer;\n}\n.card .card-body > .card-close a {\n  color: #262a2e;\n  -webkit-transition: 0.2s ease;\n  -moz-transition: 0.2s ease;\n  transition: 0.2s ease;\n  margin-left: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  opacity: .6;\n  font-size: 1.125rem;\n}\n.card .card-body > .card-close a:hover {\n  opacity: 1;\n}\n.card.close-over .btn-close {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n}\n.card.card-selected {\n  position: relative;\n  border-color: #0a2f4c;\n}\n.card.card-selected:after {\n  height: 22px;\n  width: 22px;\n  background: #0a2f4c;\n  color: #fff;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  cursor: pointer;\n  font: normal normal normal 16px/1 'Material-Design-Iconic-Font';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f26b\";\n  top: -10px;\n  right: -10px;\n  line-height: 0;\n  position: absolute;\n}\n.card .card-footer {\n  background: transparent;\n  border-color: #eaeaea;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.75rem 1.25rem;\n}\n.card .card-footer:last-child {\n  border-radius: 0 0 calc(0.5rem - 1px) calc(0.5rem - 1px);\n}\n.card .card-img-bg {\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.card.card-refresh {\n  position: relative;\n}\n.card.card-refresh .refresh-container {\n  background: rgba(255, 255, 255, 0.9);\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  display: none;\n  z-index: 5;\n  cursor: wait;\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n.card.card-refresh .refresh-container .loader-pendulums {\n  font-size: 2rem;\n}\n.card.fullscreen {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: 0;\n  position: fixed;\n  overflow-y: auto;\n  z-index: 1040;\n  border-radius: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.card.card-lg .card-header,\n.card.card-lg .card-footer {\n  padding: 1rem 1.5rem;\n}\n.card.card-lg .card-body {\n  padding: 1.5rem;\n}\n.card.card-sm .card-header,\n.card.card-sm .card-footer {\n  padding: .625rem 1rem;\n}\n.card.card-sm .card-body {\n  padding: 1rem;\n}\n.card.card-shadow {\n  border: none;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\n}\n.card.card-flush {\n  border: none;\n  box-shadow: none;\n}\n.card.card-border {\n  border: 1px solid #eaeaea;\n  box-shadow: none;\n}\n.card.card-simple .card-header,\n.card.card-simple .card-footer {\n  border: none;\n}\n.card.card-wth-line {\n  padding-top: .25rem;\n  border-top: 0;\n}\n.card.card-wth-line .card-line {\n  position: absolute;\n  top: 0;\n  height: 30px;\n  width: 100%;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n.card.card-wth-line .card-body {\n  position: relative;\n  z-index: 1;\n  background: #fff;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n.card.card-wth-progress .progress {\n  background: transparent;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n.card.card-wth-tabs > .card-header {\n  padding-bottom: .5rem;\n}\n\n.card-img, .card-img-top {\n  border-top-left-radius: calc(0.5rem - 1px);\n  border-top-right-radius: calc(0.5rem - 1px);\n}\n\n.card-img, .card-img-bottom {\n  border-bottom-right-radius: calc(0.5rem - 1px);\n  border-bottom-left-radius: calc(0.5rem - 1px);\n}\n\n.card-group > .card {\n  margin-bottom: .875rem;\n}\n\n.hk-wrapper.hk-menu-toggle .card.fullscreen {\n  left: 0;\n}\n\n@media (max-width: 1199px) {\n  .card.fullscreen {\n    left: 0;\n  }\n\n  .hk-wrapper.hk-menu-toggle .card.fullscreen {\n    left: 269px;\n    right: -269px;\n  }\n}\n@media (max-width: 576px) {\n  .card.card-lg .card-header,\n  .card.card-lg .card-footer {\n    padding: .75rem 1.25rem;\n  }\n  .card.card-lg .card-body {\n    padding: 1.25rem;\n  }\n}\n/*Placehoder*/\n.placeholder {\n  border-radius: 0.25rem;\n}\n\n/*Breadcrumb*/\n.breadcrumb .breadcrumb-item {\n  font-size: 0.875rem;\n}\n.breadcrumb .breadcrumb-item > a {\n  color: #2F343A;\n}\n.breadcrumb .breadcrumb-item > a:hover, .breadcrumb .breadcrumb-item > a:focus {\n  color: #0a2f4c;\n}\n.breadcrumb .breadcrumb-item.active {\n  color: #6f6f6f;\n}\n.breadcrumb.breadcrumb-sm .breadcrumb-item {\n  font-size: 0.75rem;\n}\n.breadcrumb.breadcrumb-dark .breadcrumb-item > a {\n  color: rgba(255, 255, 255, 0.85);\n}\n.breadcrumb.breadcrumb-dark .breadcrumb-item > a:hover, .breadcrumb.breadcrumb-dark .breadcrumb-item > a:focus {\n  color: white;\n}\n.breadcrumb.breadcrumb-dark .breadcrumb-item.active {\n  color: rgba(255, 255, 255, 0.7);\n}\n.breadcrumb.breadcrumb-dark .breadcrumb-item + .breadcrumb-item:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n.breadcrumb.breadcrumb-full-width {\n  border-radius: 0;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: .3rem;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: flex;\n}\n.breadcrumb-item + .breadcrumb-item:before {\n  font-family: \"dripicons-v2\" !important;\n  content: \"V\";\n  padding-right: .3rem;\n  position: relative;\n  top: 1px;\n  font-size: 0.625rem;\n  color: rgba(181, 181, 181, 0.8);\n}\n\n/*Page Header*/\n.hk-pg-header {\n  padding: 1.25rem 0;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n}\n.hk-pg-header .pg-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin-bottom: .3rem;\n}\n.hk-pg-header .pg-title-sm {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: .25rem;\n}\n.hk-pg-header .pg-title-xs {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin-bottom: .25rem;\n}\n.hk-pg-header .breadcrumb {\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n  margin-bottom: 0.5rem;\n}\n.hk-pg-header .pg-subtitle {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-bottom: .3rem;\n}\n.hk-pg-header .pg-stats-group {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-pg-header .pg-stats-group .stats-symbol {\n  display: -ms-flexbox;\n  display: flex;\n  padding-right: .25rem;\n}\n.hk-pg-header .pg-stats-group .stats-symbol .feather-icon svg, .hk-pg-header .pg-stats-group .stats-symbol .svg-icon svg {\n  height: 13px;\n  width: 13px;\n}\n.hk-pg-header .pg-stats-group .stats-title {\n  font-size: 0.875rem;\n}\n.hk-pg-header .pg-stats-group .stats-dot-sep {\n  padding: 0 .625rem;\n  color: #d8d8d8;\n}\n.hk-pg-header .pg-stats-group .stats-line-sep {\n  padding: 0 .625rem;\n  color: #d8d8d8;\n}\n.hk-pg-header .pg-header-action-wrap {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-pg-header.pg-header-wth-tab {\n  padding-bottom: 0;\n}\n.hk-pg-header.pg-header-wth-tab .nav-tabs {\n  margin-top: 1.875rem;\n  border-bottom: none;\n}\n.hk-pg-header.pg-header-wth-img {\n  position: relative;\n  background-image: url(../img/cropper.png);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.hk-pg-header.pg-header-wth-img:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #262a2e;\n  opacity: .6;\n}\n.hk-pg-header.pg-header-wth-img > div, .hk-pg-header.pg-header-wth-img > .nav-tabs {\n  position: relative;\n  z-index: 2;\n}\n.hk-pg-header.pg-header-wth-bg {\n  background: #f7f7f7;\n  border-bottom: none;\n}\n.hk-pg-header.pg-header-wth-bg .nav-tabs .nav-item .nav-link,\n.hk-pg-header.pg-header-wth-bg .nav-tabs .nav-item .nav-link.active {\n  border: none;\n}\n.hk-pg-header.pg-header-wth-bg .nav-tabs .nav-item.show .nav-link {\n  border: none;\n}\n.hk-pg-header.pg-header-dark .pg-title,\n.hk-pg-header.pg-header-dark .pg-title-sm,\n.hk-pg-header.pg-header-dark .pg-title-xs {\n  color: #fff;\n}\n.hk-pg-header.pg-header-dark .pg-subtitle, .hk-pg-header.pg-header-dark p {\n  color: rgba(255, 255, 255, 0.8);\n}\n.hk-pg-header.pg-header-dark .pg-stats-group .stats-symbol,\n.hk-pg-header.pg-header-dark .pg-stats-group .stats-title {\n  color: rgba(255, 255, 255, 0.8);\n}\n.hk-pg-header.pg-header-dark .pg-stats-group .stats-line-sep,\n.hk-pg-header.pg-header-dark .pg-stats-group .stats-dot-sep {\n  color: rgba(255, 255, 255, 0.3);\n}\n.hk-pg-header.pg-header-dark .hk-vertical-separator-full:after {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n@media (max-width: 767px) {\n  .hk-pg-header .pg-title {\n    font-size: 1.625rem;\n  }\n}\n/*Page Body*/\n.hk-pg-body {\n  padding: 2rem 0;\n}\n\n/*Form*/\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-control, .form-select, .wizard > .content > .body input, .dd-handle {\n  color: #262a2e;\n  border-color: #d8d8d8;\n  border-radius: 0.375rem;\n}\n.form-control.square-input, .square-input.form-select, .wizard > .content > .body input.square-input, .square-input.dd-handle {\n  border-radius: 0;\n}\n.form-control:focus, .form-select:focus, .wizard > .content > .body input:focus, .dd-handle:focus {\n  border-color: #0a2f4c;\n  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.16);\n}\n.form-control:disabled, .form-select:disabled, .wizard > .content > .body input:disabled, .dd-handle:disabled {\n  color: #b5b5b5;\n  background-color: #f7f7f7;\n  cursor: not-allowed;\n}\n.form-control[readonly], [readonly].form-select, .wizard > .content > .body input[readonly], [readonly].dd-handle {\n  border-color: #c7c7c7;\n  box-shadow: none;\n  color: #6f6f6f;\n  background-color: #f7f7f7;\n}\n.form-control:hover:not(:disabled):not([readonly]), .form-select:hover:not(:disabled):not([readonly]), .wizard > .content > .body input:hover:not(:disabled):not([readonly]), .dd-handle:hover:not(:disabled):not([readonly]) {\n  border-color: #0a2f4c;\n  z-index: 4;\n}\n.form-control.rounded-input, .rounded-input.form-select, .wizard > .content > .body input.rounded-input, .rounded-input.dd-handle {\n  border-radius: 50rem !important;\n}\n.form-control::placeholder, .form-select::placeholder, .wizard > .content > .body input::placeholder, .dd-handle::placeholder {\n  color: #9e9e9e;\n}\n.form-control::-webkit-input-placeholder, .form-select::-webkit-input-placeholder, .wizard > .content > .body input::-webkit-input-placeholder, .dd-handle::-webkit-input-placeholder {\n  color: #9e9e9e;\n}\n.form-control:-moz-placeholder, .form-select:-moz-placeholder, .wizard > .content > .body input:-moz-placeholder, .dd-handle:-moz-placeholder {\n  color: #9e9e9e;\n}\n.form-control:-ms-input-placeholder, .form-select:-ms-input-placeholder, .wizard > .content > .body input:-ms-input-placeholder, .dd-handle:-ms-input-placeholder {\n  color: #9e9e9e;\n}\n.form-control.form-control-line, .form-control-line.form-select, .wizard > .content > .body input.form-control-line, .form-control-line.dd-handle {\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n  padding-left: 0;\n  background: transparent !important;\n}\n.form-control.form-control-line:focus, .form-control-line.form-select:focus, .wizard > .content > .body input.form-control-line:focus, .form-control-line.dd-handle:focus {\n  box-shadow: none;\n}\n.form-control::file-selector-button, .form-select::file-selector-button, .wizard > .content > .body input::file-selector-button, .dd-handle::file-selector-button, .form-control::-webkit-file-upload-button, .form-select::-webkit-file-upload-button, .wizard > .content > .body input::-webkit-file-upload-button, .dd-handle::-webkit-file-upload-button {\n  background: #fff !important;\n  color: #262a2e;\n}\n\ntextarea.form-control, textarea.form-select, textarea.dd-handle {\n  height: auto;\n}\n\n.form-select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n.form-select:hover:not(:disabled) {\n  border-color: #0a2f4c;\n  z-index: 4;\n}\n\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  height: auto;\n}\n\n.input-group-lg > .form-select,\n.form-select-lg {\n  padding-right: 1.75rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n\n.input-group-sm > .form-select,\n.form-select-sm {\n  padding-right: 1.75rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n\n.form-control-lg,\n.form-select-lg {\n  font-size: 1.125rem;\n}\n\n/*Checkbox*/\n.form-check-input[type=checkbox] {\n  border-radius: 0.125em;\n}\n.form-check-input:checked {\n  background-color: #08364d;\n  border-color: #08364d;\n}\n.form-check-input:focus {\n  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.16);\n}\n.form-check-input:disabled ~ .form-check-label {\n  color: #5e7d8a;\n}\n\n.form-switch .form-check-input[type=checkbox] {\n  border-radius: 2em;\n}\n\n.form-check-lg {\n  min-height: 2rem;\n  padding-left: 2em;\n}\n.form-check-lg .form-check-input {\n  height: 1.25rem;\n  width: 1.25rem;\n  margin-left: -2em;\n  margin-top: 0.3rem;\n}\n.form-check-lg .form-check-label {\n  font-size: 1.025rem;\n  margin-top: .2rem;\n}\n\n.form-check-sm .form-check-input {\n  height: 0.875rem;\n  width: 0.875rem;\n  margin-top: 0.275em;\n}\n.form-check-sm .form-check-label {\n  font-size: .875rem;\n}\n\n.checkbox-circle.form-check-input {\n  border-radius: 50%;\n}\n\n/*Form Switch*/\n.form-switch.form-switch-lg {\n  padding-left: 3.5rem;\n}\n.form-switch.form-switch-lg .form-check-input {\n  height: 1.3em;\n  width: 2.8em;\n  margin-left: -3.5em;\n}\n.form-switch.form-switch-lg .form-check-label {\n  font-size: 1.025rem;\n  margin-top: 0.1rem;\n}\n.form-switch.form-switch-xl {\n  padding-left: 4.5rem;\n}\n.form-switch.form-switch-xl .form-check-input {\n  height: 1.8em;\n  width: 3.5em;\n  margin-left: -4.5em;\n}\n.form-switch.form-switch-xl .form-check-label {\n  font-size: 1.2rem;\n  margin-top: 0.2rem;\n}\n\n/*Form Range*/\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);\n}\n.form-range::-webkit-slider-thumb {\n  background-color: #0a2f4c;\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #99cbcf;\n}\n\n/*Form validation*/\n.form-control.is-valid, .is-valid.form-select, .wizard > .content > .body input.is-valid, .is-valid.dd-handle {\n  border-color: #00D67F;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.form-control.is-valid:hover, .is-valid.form-select:hover, .wizard > .content > .body input.is-valid:hover, .is-valid.dd-handle:hover {\n  border-color: #00D67F !important;\n}\n.form-control.is-valid:focus, .is-valid.form-select:focus, .wizard > .content > .body input.is-valid:focus, .is-valid.dd-handle:focus {\n  border-color: #00D67F;\n  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);\n}\n.form-control.is-invalid, .is-invalid.form-select, .wizard > .content > .body input.is-invalid, .is-invalid.dd-handle {\n  border-color: #FF0000 !important;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.form-control.is-invalid:focus, .is-invalid.form-select:focus, .wizard > .content > .body input.is-invalid:focus, .is-invalid.dd-handle:focus {\n  border-color: #FF0000;\n  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);\n}\n\n.form-select.is-valid {\n  border-color: #00D67F;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.form-select.is-valid:hover {\n  border-color: #00D67F !important;\n}\n.form-select.is-valid:focus {\n  border-color: #00D67F;\n  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);\n}\n.form-select.is-invalid {\n  border-color: #FF0000;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.form-select.is-invalid:hover {\n  border-color: #FF0000 !important;\n}\n.form-select.is-invalid:focus {\n  border-color: #FF0000;\n  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);\n}\n\n.form-check-input.is-valid {\n  border-color: #00D67F;\n}\n.form-check-input.is-valid:checked {\n  background-color: #00D67F;\n}\n.form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);\n}\n.form-check-input.is-valid ~ .form-check-label {\n  color: #00D67F;\n}\n.form-check-input.is-invalid {\n  border-color: #FF0000;\n}\n.form-check-input.is-invalid:checked {\n  background-color: #FF0000;\n}\n.form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);\n}\n.form-check-input.is-invalid ~ .form-check-label {\n  color: #FF0000;\n}\n\n.was-validated .form-select:valid {\n  border-color: #00D67F;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.was-validated .form-select:valid:hover {\n  border-color: #00D67F !important;\n}\n.was-validated .form-select:valid:focus {\n  border-color: #00D67F;\n  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);\n}\n.was-validated .form-select:invalid {\n  border-color: #FF0000;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.was-validated .form-select:invalid:hover {\n  border-color: #FF0000 !important;\n}\n.was-validated .form-select:invalid:focus {\n  border-color: #FF0000;\n  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);\n}\n.was-validated .form-control:valid, .was-validated .form-select:valid, .was-validated .wizard > .content > .body input:valid, .wizard > .content > .body .was-validated input:valid, .was-validated .dd-handle:valid {\n  border-color: #00D67F;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.was-validated .form-control:valid:hover, .was-validated .form-select:valid:hover, .was-validated .wizard > .content > .body input:valid:hover, .wizard > .content > .body .was-validated input:valid:hover, .was-validated .dd-handle:valid:hover {\n  border-color: #00D67F !important;\n}\n.was-validated .form-control:valid:focus, .was-validated .form-select:valid:focus, .was-validated .wizard > .content > .body input:valid:focus, .wizard > .content > .body .was-validated input:valid:focus, .was-validated .dd-handle:valid:focus {\n  border-color: #00D67F;\n  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);\n}\n.was-validated .form-control:invalid, .was-validated .form-select:invalid, .was-validated .wizard > .content > .body input:invalid, .wizard > .content > .body .was-validated input:invalid, .was-validated .dd-handle:invalid {\n  border-color: #FF0000;\n  background-image: none;\n  padding-right: inherit;\n  z-index: 4;\n}\n.was-validated .form-control:invalid:hover, .was-validated .form-select:invalid:hover, .was-validated .wizard > .content > .body input:invalid:hover, .wizard > .content > .body .was-validated input:invalid:hover, .was-validated .dd-handle:invalid:hover {\n  border-color: #FF0000 !important;\n}\n.was-validated .form-control:invalid:focus, .was-validated .form-select:invalid:focus, .was-validated .wizard > .content > .body input:invalid:focus, .wizard > .content > .body .was-validated input:invalid:focus, .was-validated .dd-handle:invalid:focus {\n  border-color: #FF0000;\n  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);\n}\n.was-validated .form-check-input:valid {\n  border-color: #00D67F;\n}\n.was-validated .form-check-input:valid:checked {\n  background-color: #00D67F;\n}\n.was-validated .form-check-input:valid:focus {\n  box-shadow: 0 0 0 0.125rem rgba(0, 214, 127, 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label {\n  color: #00D67F;\n}\n.was-validated .form-check-input:invalid {\n  border-color: #FF0000;\n}\n.was-validated .form-check-input:invalid:checked {\n  background-color: #FF0000;\n}\n.was-validated .form-check-input:invalid:focus {\n  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label {\n  color: #FF0000;\n}\n\n.valid-feedback {\n  color: #00D67F;\n}\n\n.invalid-feedback {\n  color: #FF0000;\n}\n\n.valid-tooltip {\n  background: #00D67F;\n}\n\n.invalid-tooltip {\n  background: #FF0000;\n}\n\n/*Input group*/\n.input-affix-wrapper {\n  display: flex;\n  position: relative;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.input-affix-wrapper .input-prefix,\n.input-affix-wrapper .input-suffix {\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  position: absolute;\n  z-index: 5;\n  padding: 0.375rem 0rem;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  min-width: 1.8rem;\n}\n.input-affix-wrapper .input-prefix {\n  left: 0;\n}\n.input-affix-wrapper .input-suffix {\n  right: 0;\n}\n.input-affix-wrapper .form-control:not(:first-child), .input-affix-wrapper .form-select:not(:first-child), .input-affix-wrapper .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper input:not(:first-child), .input-affix-wrapper .dd-handle:not(:first-child),\n.input-affix-wrapper .form-select:not(:first-child) {\n  padding-left: 2.5rem;\n}\n.input-affix-wrapper .form-control:not(:last-child), .input-affix-wrapper .form-select:not(:last-child), .input-affix-wrapper .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper input:not(:last-child), .input-affix-wrapper .dd-handle:not(:last-child),\n.input-affix-wrapper .form-select:not(:last-child) {\n  /*padding-right: 2.5rem;*/\n}\n.input-affix-wrapper.input-affix-wrapper-sm .input-prefix,\n.input-affix-wrapper.input-affix-wrapper-sm .input-suffix {\n  font-size: 0.875rem;\n  padding: 0.25rem 0.5rem;\n  min-width: 1.5rem;\n}\n.input-affix-wrapper.input-affix-wrapper-sm .form-control, .input-affix-wrapper.input-affix-wrapper-sm .form-select, .input-affix-wrapper.input-affix-wrapper-sm .wizard > .content > .body input, .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-sm input, .input-affix-wrapper.input-affix-wrapper-sm .dd-handle,\n.input-affix-wrapper.input-affix-wrapper-sm .form-select {\n  padding: .25rem .5rem;\n  font-size: .875rem;\n}\n.input-affix-wrapper.input-affix-wrapper-sm .form-control:not(:first-child), .input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:first-child), .input-affix-wrapper.input-affix-wrapper-sm .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-sm input:not(:first-child), .input-affix-wrapper.input-affix-wrapper-sm .dd-handle:not(:first-child),\n.input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:first-child) {\n  padding-left: 2rem;\n}\n.input-affix-wrapper.input-affix-wrapper-sm .form-control:not(:last-child), .input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:last-child), .input-affix-wrapper.input-affix-wrapper-sm .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-sm input:not(:last-child), .input-affix-wrapper.input-affix-wrapper-sm .dd-handle:not(:last-child),\n.input-affix-wrapper.input-affix-wrapper-sm .form-select:not(:last-child) {\n  padding-right: 2rem;\n}\n.input-affix-wrapper.input-affix-wrapper-lg .input-prefix,\n.input-affix-wrapper.input-affix-wrapper-lg .input-suffix {\n  font-size: 1.25rem;\n  padding: 0.5rem 1rem;\n  min-width: 2rem;\n}\n.input-affix-wrapper.input-affix-wrapper-lg .form-control, .input-affix-wrapper.input-affix-wrapper-lg .form-select, .input-affix-wrapper.input-affix-wrapper-lg .wizard > .content > .body input, .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-lg input, .input-affix-wrapper.input-affix-wrapper-lg .dd-handle,\n.input-affix-wrapper.input-affix-wrapper-lg .form-select {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n}\n.input-affix-wrapper.input-affix-wrapper-lg .form-control:not(:first-child), .input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:first-child), .input-affix-wrapper.input-affix-wrapper-lg .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-lg input:not(:first-child), .input-affix-wrapper.input-affix-wrapper-lg .dd-handle:not(:first-child),\n.input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:first-child) {\n  padding-left: 3rem;\n}\n.input-affix-wrapper.input-affix-wrapper-lg .form-control:not(:last-child), .input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:last-child), .input-affix-wrapper.input-affix-wrapper-lg .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.input-affix-wrapper-lg input:not(:last-child), .input-affix-wrapper.input-affix-wrapper-lg .dd-handle:not(:last-child),\n.input-affix-wrapper.input-affix-wrapper-lg .form-select:not(:last-child) {\n  padding-right: 3rem;\n}\n.input-affix-wrapper.affix-border .input-prefix,\n.input-affix-wrapper.affix-border .input-suffix {\n  border: 1px solid #d8d8d8;\n  border-radius: 0.375rem;\n  padding: 0;\n}\n.input-affix-wrapper.affix-border .input-suffix {\n  margin-right: 0.5rem;\n}\n.input-affix-wrapper.affix-border .input-prefix {\n  margin-left: 0.5rem;\n}\n.input-affix-wrapper.affix-wth-text .form-control:not(:first-child), .input-affix-wrapper.affix-wth-text .form-select:not(:first-child), .input-affix-wrapper.affix-wth-text .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text input:not(:first-child), .input-affix-wrapper.affix-wth-text .dd-handle:not(:first-child),\n.input-affix-wrapper.affix-wth-text .form-select:not(:first-child) {\n  padding-left: 3.5rem;\n}\n.input-affix-wrapper.affix-wth-text .form-control:not(:last-child), .input-affix-wrapper.affix-wth-text .form-select:not(:last-child), .input-affix-wrapper.affix-wth-text .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text input:not(:last-child), .input-affix-wrapper.affix-wth-text .dd-handle:not(:last-child),\n.input-affix-wrapper.affix-wth-text .form-select:not(:last-child) {\n  padding-right: 3.5rem;\n}\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-control:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm input:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .dd-handle:not(:first-child),\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:first-child) {\n  padding-left: 3rem;\n}\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-control:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm input:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .dd-handle:not(:last-child),\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-sm .form-select:not(:last-child) {\n  padding-right: 3rem;\n}\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-control:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg input:not(:first-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .dd-handle:not(:first-child),\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:first-child) {\n  padding-left: 4.5rem;\n}\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-control:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg input:not(:last-child), .input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .dd-handle:not(:last-child),\n.input-affix-wrapper.affix-wth-text.input-affix-wrapper-lg .form-select:not(:last-child) {\n  padding-right: 4.5rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.wizard > .content > .body .input-group-lg > input,\n.input-group-lg > .dd-handle,\n.input-group-sm > .form-select,\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.wizard > .content > .body .input-group-sm > input,\n.input-group-sm > .dd-handle {\n  border-radius: 0.375rem;\n}\n\n.input-group > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-group > .hopscotch-nav-button, .input-group > .form-control, .input-group > .form-select, .wizard > .content > .body .input-group > input, .input-group > .dd-handle, .input-group > .form-select, .input-group > .input-group-text,\n.input-group-sm > .btn,\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-group-sm > .hopscotch-nav-button, .input-group-sm > .form-control, .input-group-sm > .form-select, .wizard > .content > .body .input-group-sm > input, .input-group-sm > .dd-handle, .input-group-sm > .form-select, .input-group-sm > .input-group-text,\n.input-group-lg > .btn,\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-group-lg > .hopscotch-nav-button, .input-group-lg > .form-control, .input-group-lg > .form-select, .wizard > .content > .body .input-group-lg > input, .input-group-lg > .dd-handle, .input-group-lg > .form-select, .input-group-lg > .input-group-text {\n  border-radius: 0.375rem;\n}\n\n.input-group-text {\n  border-color: #d8d8d8;\n  background-color: #fff;\n  border-width: 1px;\n  border-radius: 0.375rem;\n  color: #6f6f6f;\n  overflow: hidden;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  min-width: 45px;\n}\n\n.input-group-lg .input-group-text {\n  min-width: 55px;\n}\n\n.input-group-sm .input-group-text {\n  min-width: 40px;\n}\n\n.input-group.input-group-wth-icon {\n  position: relative;\n  align-items: center;\n}\n.input-group.input-group-wth-icon .input-group-text {\n  position: absolute;\n  height: calc(100% - 2px);\n  z-index: 5;\n  border: 0;\n  background: transparent;\n  pointer-events: none;\n}\n.input-group.input-group-wth-icon .input-group-text:not(:last-child) {\n  left: 0;\n}\n.input-group.input-group-wth-icon .input-group-text:not(:first-child) {\n  right: 0;\n}\n.input-group.input-group-wth-icon .form-control, .input-group.input-group-wth-icon .form-select, .input-group.input-group-wth-icon .wizard > .content > .body input, .wizard > .content > .body .input-group.input-group-wth-icon input, .input-group.input-group-wth-icon .dd-handle {\n  border-radius: 0.5rem !important;\n}\n.input-group.input-group-wth-icon .form-control:not(:first-child), .input-group.input-group-wth-icon .form-select:not(:first-child), .input-group.input-group-wth-icon .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-group.input-group-wth-icon input:not(:first-child), .input-group.input-group-wth-icon .dd-handle:not(:first-child) {\n  padding-left: 2.6rem;\n}\n.input-group.input-group-wth-icon .form-control:not(:last-child), .input-group.input-group-wth-icon .form-select:not(:last-child), .input-group.input-group-wth-icon .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-group.input-group-wth-icon input:not(:last-child), .input-group.input-group-wth-icon .dd-handle:not(:last-child) {\n  padding-right: 2.6rem;\n}\n.input-group.input-group-sm.input-group-wth-icon .form-control:not(:first-child), .input-group.input-group-sm.input-group-wth-icon .form-select:not(:first-child), .input-group.input-group-sm.input-group-wth-icon .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-group.input-group-sm.input-group-wth-icon input:not(:first-child), .input-group.input-group-sm.input-group-wth-icon .dd-handle:not(:first-child) {\n  padding-left: 2.3rem;\n}\n.input-group.input-group-sm.input-group-wth-icon .form-control:not(:last-child), .input-group.input-group-sm.input-group-wth-icon .form-select:not(:last-child), .input-group.input-group-sm.input-group-wth-icon .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-group.input-group-sm.input-group-wth-icon input:not(:last-child), .input-group.input-group-sm.input-group-wth-icon .dd-handle:not(:last-child) {\n  padding-right: 2.3rem;\n}\n.input-group.input-group-lg.input-group-wth-icon .form-control:not(:first-child), .input-group.input-group-lg.input-group-wth-icon .form-select:not(:first-child), .input-group.input-group-lg.input-group-wth-icon .wizard > .content > .body input:not(:first-child), .wizard > .content > .body .input-group.input-group-lg.input-group-wth-icon input:not(:first-child), .input-group.input-group-lg.input-group-wth-icon .dd-handle:not(:first-child) {\n  padding-left: 3.1rem;\n}\n.input-group.input-group-lg.input-group-wth-icon .form-control:not(:last-child), .input-group.input-group-lg.input-group-wth-icon .form-select:not(:last-child), .input-group.input-group-lg.input-group-wth-icon .wizard > .content > .body input:not(:last-child), .wizard > .content > .body .input-group.input-group-lg.input-group-wth-icon input:not(:last-child), .input-group.input-group-lg.input-group-wth-icon .dd-handle:not(:last-child) {\n  padding-right: 3.1rem;\n}\n.input-group .form-select.is-valid, .input-group .form-select.is-invalid,\n.input-group .form-control.is-valid,\n.input-group .is-valid.form-select,\n.input-group .wizard > .content > .body input.is-valid,\n.wizard > .content > .body .input-group input.is-valid,\n.input-group .is-valid.dd-handle,\n.input-group .form-control.is-invalid,\n.input-group .is-invalid.form-select,\n.input-group .wizard > .content > .body input.is-invalid,\n.wizard > .content > .body .input-group input.is-invalid,\n.input-group .is-invalid.dd-handle {\n  z-index: 4;\n}\n.input-group > .input-affix-wrapper {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 1%;\n}\n.input-group > .input-affix-wrapper:not(:first-child) .form-control, .input-group > .input-affix-wrapper:not(:first-child) .form-select, .input-group > .input-affix-wrapper:not(:first-child) .wizard > .content > .body input, .wizard > .content > .body .input-group > .input-affix-wrapper:not(:first-child) input, .input-group > .input-affix-wrapper:not(:first-child) .dd-handle,\n.input-group > .input-affix-wrapper:not(:first-child) .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .input-affix-wrapper:not(:last-child) .form-control, .input-group > .input-affix-wrapper:not(:last-child) .form-select, .input-group > .input-affix-wrapper:not(:last-child) .wizard > .content > .body input, .wizard > .content > .body .input-group > .input-affix-wrapper:not(:last-child) input, .input-group > .input-affix-wrapper:not(:last-child) .dd-handle,\n.input-group > .input-affix-wrapper:not(:last-child) .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\nlabel {\n  color: #262a2e;\n}\n\n.custom-file-label {\n  color: #262a2e;\n  border: 1px solid #d8d8d8;\n  height: calc(2.25rem + 2px);\n}\n.custom-file-label:after {\n  border-left: 0;\n  background: #f7f7f7;\n}\n\n.form-label-group {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  margin-bottom: .5rem;\n}\n.form-label-group label {\n  margin-bottom: 0;\n}\n\n/*Input Search*/\n.input-search .btn-input-clear {\n  cursor: pointer;\n  line-height: 0;\n}\n.input-search .btn-input-clear,\n.input-search .input-loader {\n  display: none;\n}\n.input-search.loading .btn-input-clear {\n  display: none !important;\n}\n.input-search.loading .input-loader {\n  display: block;\n}\n\n/*Spinner*/\n.spinner-border {\n  border-width: 0.125em;\n}\n\n.spinner-border-sm {\n  border-width: 0.1em;\n}\n\n/*Input Spinner*/\n.input-spinner-wrap .btn, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .hopscotch-nav-button {\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  border-color: #d8d8d8 !important;\n  background: #fff !important;\n  color: #9e9e9e !important;\n}\n.input-spinner-wrap .btn strong, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button strong, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .hopscotch-nav-button strong {\n  display: none;\n}\n.input-spinner-wrap .btn:after, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .hopscotch-nav-button:after {\n  font: normal normal normal 20px/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n}\n.input-spinner-wrap .btn.btn-decrement:after, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-decrement.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .btn-decrement.hopscotch-nav-button:after {\n  content: '\\f273';\n}\n.input-spinner-wrap .btn.btn-increment:after, .input-spinner-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-increment.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .btn-increment.hopscotch-nav-button:after {\n  content: '\\f278';\n}\n.input-spinner-wrap .input-group.input-group-sm .btn.btn-outline-light:after, .input-spinner-wrap .input-group.input-group-sm div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-outline-light.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-sm .btn-outline-light.hopscotch-nav-button:after, .input-spinner-wrap .input-group.input-group-sm div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.btn-primary:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-sm .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-sm .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-sm div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-sm .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-sm .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-sm .btn.btn-primary:after {\n  font-size: 1rem;\n}\n.input-spinner-wrap .input-group.input-group-lg .btn.btn-outline-light:after, .input-spinner-wrap .input-group.input-group-lg div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-outline-light.hopscotch-nav-button:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-lg .btn-outline-light.hopscotch-nav-button:after, .input-spinner-wrap .input-group.input-group-lg div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.btn-primary:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-lg .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.btn-primary:after, .input-spinner-wrap .input-group.input-group-lg .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.next:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-lg div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .hopscotch-nav-button.next:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-lg .hopscotch-nav-button.next:after, .input-spinner-wrap .input-group.input-group-lg .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn.btn-primary:after, .calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .input-spinner-wrap .input-group.input-group-lg .btn.btn-primary:after {\n  font-size: 1.5rem;\n}\n\n/*Select2*/\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.select2-dropdown {\n  border-color: #d8d8d8;\n}\n\n.select2-container {\n  width: 100% !important;\n}\n.select2-container.select2-container--default.select2-container--disabled {\n  cursor: not-allowed;\n}\n.select2-container.select2-container--default.select2-container--disabled .select2-selection--single {\n  background-color: #f7f7f7;\n  pointer-events: none;\n}\n\n.select2-container--default .select2-selection--single,\n.select2-container--default .select2-selection--multiple {\n  display: block;\n  width: 100%;\n  height: calc(2.25rem + 2px);\n  padding: .375rem 1rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #262a2e;\n  background-color: #fff;\n  border: 1px solid #d8d8d8;\n  border-radius: 0.5rem;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n.select2-container--default .select2-selection--single:hover,\n.select2-container--default .select2-selection--multiple:hover {\n  border-color: #0a2f4c;\n}\n.select2-container--default .select2-selection--single:focus,\n.select2-container--default .select2-selection--multiple:focus {\n  border-color: #0a2f4c;\n  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow,\n.select2-container--default .select2-selection--multiple .select2-selection__arrow {\n  height: calc(2.25rem + 2px);\n  top: 0;\n  right: 6px;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b,\n.select2-container--default .select2-selection--multiple .select2-selection__arrow b {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px 12px;\n  height: 100%;\n  width: 20px;\n  display: block;\n  border: none;\n  margin: auto;\n  position: static;\n}\n.select2-container--default .select2-selection--single .select2-selection__rendered,\n.select2-container--default .select2-selection--multiple .select2-selection__rendered {\n  color: #262a2e;\n  line-height: inherit;\n  padding-left: 0;\n  padding-right: 0;\n}\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  border-color: #d8d8d8;\n}\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border: solid #0a2f4c 1px;\n  box-shadow: 0 0 0 0.125rem rgba(0, 125, 136, 0.25);\n}\n.select2-container--default.select2-container--open .select2-selection--single {\n  border-color: #0a2f4c;\n}\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {\n  border-top-right-radius: 0.5rem;\n  border-top-left-radius: 0.5rem;\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #0a2f4c;\n}\n.select2-container--default .select2-results__option[aria-selected=\"true\"] {\n  background-color: #f7f7f7;\n  color: #262a2e;\n}\n.select2-container--default .select2-selection--multiple {\n  height: auto;\n  min-height: calc(2.25rem + 2px);\n  padding: 0;\n}\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  background-color: #f7f7f7;\n  border: none;\n  font-size: 75%;\n  border-radius: .25rem;\n  color: #262a2e;\n  margin-right: .375rem;\n  margin-top: .375rem;\n  padding: .25rem .5rem;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.select2-container--default .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove {\n  color: #262a2e;\n  font-weight: 600;\n  margin-left: .375rem;\n  float: right;\n  font-size: 0.875rem;\n  opacity: 0.5;\n  padding-top: 1px;\n  height: 0;\n  position: relative;\n  top: -2px;\n}\n.select2-container--default .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:hover {\n  opacity: 1;\n}\n.select2-container--default .select2-selection--multiple .select2-selection__rendered {\n  padding: 0 1rem;\n}\n\n.select2-container--default .select2-results__group,\n.select2-results__option {\n  padding: .375rem 1rem;\n}\n\n/*Tinymce*/\n.mce-container, .mce-container *, .mce-widget, .mce-widget *, .mce-reset {\n  color: #8e8e8e !important;\n}\n\n.mce-text {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\n}\n\n.mce-menu-item .mce-caret {\n  border-left-color: #8e8e8e !important;\n}\n\ndiv.mce-menu .mce-menu-item-sep, .mce-menu-item-sep:hover {\n  border-bottom-color: #d8d8d8 !important;\n}\n\n.mce-menu {\n  border-bottom-color: #d8d8d8 !important;\n}\n\n.tinymce-wrap .mce-tinymce {\n  box-shadow: none;\n}\n.tinymce-wrap .mce-toolbar .mce-btn-group {\n  padding: .25rem 0;\n}\n.tinymce-wrap .mce-btn-group .mce-btn {\n  margin-left: .25rem;\n  margin-right: .25rem;\n}\n.tinymce-wrap .mce-btn-group:not(:first-child) {\n  border-left: none;\n  padding-left: 0;\n  margin-left: 0;\n}\n.tinymce-wrap .mce-container, .tinymce-wrap .mce-container *, .tinymce-wrap .mce-widget, .tinymce-wrap .mce-widget *, .tinymce-wrap .mce-reset {\n  font-family: inherit;\n  color: #8e8e8e;\n}\n.tinymce-wrap .mce-panel {\n  border-color: #d8d8d8;\n  border-radius: .25rem;\n}\n.tinymce-wrap .mce-top-part::before {\n  box-shadow: none;\n}\n.tinymce-wrap .mce-btn:hover, .tinymce-wrap .mce-btn.mce-disabled:hover button,\n.tinymce-wrap .mce-menubar .mce-menubtn:hover, .tinymce-wrap .mce-menubar .mce-menubtn:focus {\n  border-color: transparent;\n  border-radius: .25rem;\n  background: #f7f7f7;\n  color: #262a2e;\n}\n.tinymce-wrap .mce-btn.mce-active:hover, .tinymce-wrap .mce-btn.mce-active:focus, .tinymce-wrap .mce-btn.mce-active:active {\n  background: #f7f7f7;\n  border-color: transparent;\n}\n.tinymce-wrap .mce-btn.mce-active,\n.tinymce-wrap .mce-btn:active {\n  background: #f7f7f7;\n  border-color: transparent;\n}\n.tinymce-wrap .mce-btn.mce-active button i,\n.tinymce-wrap .mce-btn:active button i {\n  color: #0a2f4c !important;\n}\n.tinymce-wrap .mce-btn.mce-active button, .tinymce-wrap .mce-btn.mce-active:hover button, .tinymce-wrap .mce-btn.mce-active i, .tinymce-wrap .mce-btn.mce-active:hover i {\n  color: #0a2f4c;\n}\n.tinymce-wrap .mce-btn.mce-active .mce-caret, .tinymce-wrap .mce-btn.mce-active:hover .mce-caret {\n  border-top-color: #8e8e8e;\n}\n\n.mce-ico {\n  font-family: 'tinymce',Arial !important;\n  color: #5f5f5f !important;\n}\n\n.mce-menu-item.mce-active.mce-menu-item-normal {\n  background: #f7f7f7 !important;\n}\n\n.mce-tooltip {\n  opacity: 1 !important;\n  filter: alpha(opacity=100) !important;\n}\n\n.mce-tooltip-inner {\n  font-size: 0.75rem !important;\n  background-color: #262a2e !important;\n  padding: 0.25rem 0.5rem !important;\n  border-radius: 0.5rem;\n  color: #fff !important;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\n}\n\n.mce-tooltip-arrow {\n  border-bottom-color: #262a2e !important;\n}\n\n.mce-menu-item:hover, .mce-menu-item:focus {\n  background: #f7f7f7 !important;\n}\n\n/*File Upload*/\n.btn-file {\n  overflow: hidden;\n  position: relative;\n  vertical-align: middle;\n  display: inline-block;\n}\n.btn-file input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  font-size: 1.5rem;\n  height: 100%;\n  width: 100%;\n  direction: ltr;\n  cursor: pointer;\n}\n\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n  display: none;\n}\n\n.fileinput.input-group > .input-group-append:last-child > .btn.btn-file:not(:last-child):not(.dropdown-toggle), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.input-group > .input-group-append:last-child > .btn-file.hopscotch-nav-button:not(:last-child):not(.dropdown-toggle), .fileinput.input-group > .input-group-append:not(:last-child) > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.input-group > .input-group-append:not(:last-child) > .btn-file.hopscotch-nav-button, .fileinput.input-group > .input-group-prepend > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.input-group > .input-group-prepend > .btn-file.hopscotch-nav-button {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n.fileinput.fileinput-exists.input-group > .input-group-append:last-child > .btn.btn-file:not(:last-child):not(.dropdown-toggle), div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.fileinput-exists.input-group > .input-group-append:last-child > .btn-file.hopscotch-nav-button:not(:last-child):not(.dropdown-toggle), .fileinput.fileinput-exists.input-group > .input-group-append:not(:last-child) > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.fileinput-exists.input-group > .input-group-append:not(:last-child) > .btn-file.hopscotch-nav-button, .fileinput.fileinput-exists.input-group > .input-group-prepend > .btn.btn-file, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .fileinput.fileinput-exists.input-group > .input-group-prepend > .btn-file.hopscotch-nav-button {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.dropzone {\n  border: 1px dashed #d8d8d8;\n  color: #262a2e;\n  border-radius: 0.25rem;\n}\n.dropzone .dz-message {\n  margin: 3em 0;\n  font-weight: 500;\n  color: #262a2e;\n}\n.dropzone .dz-preview .dz-details {\n  color: #262a2e;\n}\n.dropzone .dz-preview .dz-filename span {\n  background-color: transparent;\n}\n.dropzone .dz-preview .dz-image {\n  border-radius: 0.25rem;\n}\n.dropzone .dz-preview.dz-file-preview .dz-image {\n  border-radius: 0.25rem;\n}\n\n.dropify-wrapper {\n  border: 1px dashed #d8d8d8;\n  border-radius: 0.25rem;\n  font-family: inherit;\n  color: #262a2e;\n  font-size: 1rem;\n  padding: 1rem;\n}\n.dropify-wrapper .dropify-message p .main-text {\n  display: block;\n  color: #262a2e;\n  font-weight: 500;\n}\n.dropify-wrapper .dropify-message p .sub-text {\n  font-size: 0.875rem;\n  display: block;\n  color: #6f6f6f;\n}\n.dropify-wrapper .dropify-message span.file-icon {\n  font-size: 2rem;\n  color: #fff;\n  height: 3rem;\n  width: 3rem;\n  display: block;\n  margin: auto;\n  color: #9e9e9e;\n  position: relative;\n}\n.dropify-wrapper .dropify-message span.file-icon:before {\n  content: \"\\F603\";\n  display: inline-block;\n  font-family: bootstrap-icons !important;\n  font-style: normal;\n  font-weight: normal !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -0.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  top: 50%;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.dropify-wrapper .dropify-preview .dropify-infos {\n  background: rgba(47, 52, 58, 0.85);\n}\n.dropify-wrapper .dropify-preview .dropify-infos .dropify-infos-inner p {\n  font-weight: 500;\n}\n.dropify-wrapper .dropify-preview .dropify-infos .dropify-infos-inner p.dropify-infos-message {\n  margin-top: 0px;\n  padding-top: 0px;\n  opacity: 1;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #9e9e9e;\n  font-size: 0.875rem;\n}\n.dropify-wrapper .dropify-preview .dropify-infos .dropify-infos-inner p.dropify-infos-message:before {\n  display: none;\n}\n.dropify-wrapper .dropify-clear {\n  border: none;\n  font-size: 0.75rem;\n  padding: .125rem .375rem;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  top: 8px;\n  right: 8px;\n}\n.dropify-wrapper .dropify-clear:hover {\n  border-radius: 1rem;\n}\n.dropify-wrapper:hover {\n  background-image: none;\n}\n\n.dropify-square .dropify-wrapper,\n.dropify-circle .dropify-wrapper {\n  height: 7.5rem;\n  width: 7.5rem;\n  overflow: visible;\n}\n.dropify-square .dropify-wrapper .dropify-message,\n.dropify-circle .dropify-wrapper .dropify-message {\n  font-size: 0.875rem;\n}\n.dropify-square .dropify-wrapper .dropify-message span.file-icon,\n.dropify-circle .dropify-wrapper .dropify-message span.file-icon {\n  font-size: 1.25rem;\n  height: 1.25rem;\n  width: 1.25rem;\n}\n.dropify-square .dropify-wrapper .dropify-message p,\n.dropify-circle .dropify-wrapper .dropify-message p {\n  font-size: 0.875rem;\n}\n.dropify-square .dropify-wrapper .dropify-preview,\n.dropify-circle .dropify-wrapper .dropify-preview {\n  border-radius: 50%;\n  padding: 0;\n}\n.dropify-square .dropify-wrapper:hover .dropify-clear, .dropify-square .dropify-wrapper:hover .dropify-preview .dropify-infos,\n.dropify-circle .dropify-wrapper:hover .dropify-clear,\n.dropify-circle .dropify-wrapper:hover .dropify-preview .dropify-infos {\n  opacity: 0;\n}\n\n.dropify-circle .dropify-wrapper {\n  border-radius: 50%;\n}\n\n/*Form-Wizard*/\n.wizard > .steps li > a {\n  border: 1px solid #d8d8d8;\n  border-radius: 0 !important;\n  background: #fff !important;\n  font-weight: 500;\n  position: relative;\n}\n.wizard > .steps li > a:after {\n  content: \"\\eb74\";\n  font-family: 'remixicon';\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  height: 1rem;\n  width: 1rem;\n  background: #d8d8d8;\n  border-radius: 50%;\n  right: 0.5rem;\n  top: 0.5rem;\n  color: #fff;\n  font-size: 0.875rem;\n  -webkit-transition: all 0.1s ease;\n  -moz-transition: all 0.1s ease;\n  transition: all 0.1s ease;\n}\n.wizard > .steps li > a:before {\n  content: \"\";\n  position: absolute;\n  background: transparent;\n  height: 3px;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  -webkit-transition: all 0.1s ease;\n  -moz-transition: all 0.1s ease;\n  transition: all 0.1s ease;\n}\n.wizard > .steps .current a, .wizard > .steps .current a:hover, .wizard > .steps .current a:active {\n  color: #262a2e;\n}\n.wizard > .steps .current a:before, .wizard > .steps .current a:hover:before, .wizard > .steps .current a:active:before {\n  background: #0a2f4c;\n}\n.wizard > .steps .current.error a, .wizard > .steps .current.error a:hover, .wizard > .steps .current.error a:active {\n  color: #FF0000;\n}\n.wizard > .steps .current.error a:before, .wizard > .steps .current.error a:hover:before, .wizard > .steps .current.error a:active:before {\n  background: #FF0000;\n}\n.wizard > .steps .done a, .wizard > .steps .done a:hover, .wizard > .steps .done a:active {\n  color: #262a2e;\n  overflow: hidden;\n}\n.wizard > .steps .done a:after, .wizard > .steps .done a:hover:after, .wizard > .steps .done a:active:after {\n  background: #00D67F;\n}\n.wizard > .steps .done a:before, .wizard > .steps .done a:hover:before, .wizard > .steps .done a:active:before {\n  background: transparent;\n}\n.wizard > .content {\n  background: #fff;\n  border-radius: 0;\n  min-height: 100px;\n  margin: 0;\n  border: none;\n  padding-bottom: .625rem;\n}\n.wizard > .content > .body {\n  width: 100%;\n  height: auto;\n  padding: 1.875rem;\n  position: static;\n}\n.wizard > .content > .body label.error {\n  color: #FF0000;\n}\n.wizard > .content > .body input.error {\n  background: #fff;\n  border-color: #FF0000 !important;\n  color: #262a2e;\n}\n.wizard > .content > .body input.error:focus {\n  box-shadow: 0 0 0 0.125rem rgba(255, 0, 0, 0.25);\n}\n.wizard > .actions {\n  background: #fff;\n  padding: .625rem 1.875rem;\n}\n.wizard > .actions a, .wizard > .actions a:hover, .wizard > .actions a:active {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  background: #0a2f4c;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 1px solid #0a2f4c;\n  text-transform: capitalize;\n  outline: none;\n  font-size: 1rem;\n  padding: 0.375rem 1rem;\n  border-radius: 0.5rem;\n}\n.wizard > .actions .disabled a, .wizard > .actions .disabled a:hover, .wizard > .actions .disabled a:active {\n  color: #fff;\n  background-color: #99cbcf;\n  border-color: #99cbcf;\n}\n\n@media (max-width: 991px) {\n  .wizard .steps ul > li {\n    width: 100%;\n  }\n}\n/*Popover*/\n.popover {\n  border: none;\n  border-radius: 0.5rem;\n  font-family: var(--bs-body-font-family);\n  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.1);\n}\n\n.popover-header {\n  color: #262a2e;\n  background-color: #fff;\n  padding: 0.65rem .75rem;\n  border-radius: 0.5rem 0.5rem 0 0;\n  border-color: #d8d8d8;\n}\n\n.popover-body {\n  padding: .65rem .75rem;\n  color: #6f6f6f;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n}\n\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::before, .bs-popover-top > .arrow::before {\n  border-top-color: transparent;\n}\n\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before, .bs-popover-bottom > .arrow::before {\n  border-bottom-color: transparent;\n}\n\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::before, .bs-popover-left > .arrow::before {\n  border-left-color: transparent;\n}\n\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::before, .bs-popover-right > .arrow::before {\n  border-right-color: transparent;\n}\n\n/*Collapse*/\n.collapse-simple > .card {\n  margin-bottom: 0;\n  box-shadow: none;\n  border: 0;\n  border-bottom: 1px solid #eaeaea;\n  border-radius: 0;\n  padding: 0.5rem 0;\n}\n.collapse-simple > .card:last-child {\n  border-bottom: 0;\n}\n.collapse-simple > .card > .card-header {\n  padding: 0;\n  border: 0;\n}\n.collapse-simple > .card > .card-header > * {\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: .5rem 0;\n  display: block;\n  width: 100%;\n  color: #0a2f4c;\n  text-align: left;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background: transparent;\n  border: none;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n.collapse-simple > .card > .card-header > *::before {\n  content: '\\f2f9';\n  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n  font-size: 1.25rem;\n  text-rendering: auto;\n  position: absolute;\n  top: 8px;\n  right: 0;\n  color: rgba(38, 42, 46, 0.3);\n}\n.collapse-simple > .card > .card-header > *.collapsed:before {\n  content: '\\f2fc';\n}\n.collapse-simple > .card > div > .card-body {\n  padding: .5rem 0;\n}\n\n/*Accordion*/\n.accordion .accordion-button {\n  color: #262a2e;\n  font-weight: 500;\n  padding: .75rem 1.25rem;\n}\n.accordion .accordion-button:not(.collapsed) {\n  background: #0a2f4c;\n  color: #fff;\n  box-shadow: none;\n  border-bottom: 1px solid #d8d8d8;\n}\n.accordion .accordion-button:not(.collapsed)::after {\n  background: none;\n  color: rgba(255, 255, 255, 0.3);\n}\n.accordion .accordion-button:focus {\n  box-shadow: none;\n}\n.accordion .accordion-button::after {\n  width: auto;\n  height: auto;\n  background: none;\n  content: '\\f2f9';\n  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n  font-size: 1.25rem;\n  text-rendering: auto;\n  position: absolute;\n  top: 12px;\n  right: 20px;\n  color: rgba(38, 42, 46, 0.3);\n}\n.accordion .accordion-item:first-of-type {\n  border-top-left-radius: calc(0.5rem - 1px);\n  border-top-right-radius: calc(0.5rem - 1px);\n}\n.accordion .accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: calc(0.5rem - 1px);\n  border-top-right-radius: calc(0.5rem - 1px);\n}\n.accordion .accordion-item:last-of-type {\n  border-bottom-left-radius: calc(0.5rem - 1px);\n  border-bottom-right-radius: calc(0.5rem - 1px);\n}\n.accordion .accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: calc(0.5rem - 1px);\n  border-bottom-left-radius: calc(0.5rem - 1px);\n}\n.accordion.accordion-flush .accordion-item:first-of-type {\n  border-radius: 0;\n}\n.accordion.accordion-flush .accordion-item:first-of-type .accordion-button {\n  border-radius: 0;\n}\n.accordion.accordion-flush .accordion-item:last-of-type {\n  border-radius: 0;\n}\n.accordion.accordion-flush .accordion-item:last-of-type .accordion-button.collapsed {\n  border-radius: 0;\n}\n.accordion.accordion-card > .accordion-item {\n  margin-bottom: 1.875rem;\n  border-bottom: 1px;\n  border: 1px solid #d8d8d8;\n  border-radius: calc(0.5rem - 1px);\n  overflow: hidden;\n}\n.accordion.accordion-card.accordion-card-shadow > .accordion-item {\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);\n}\n.accordion.accordion-card.accordion-card-bold > .accordion-item .accordion-body {\n  background: #0a2f4c;\n  color: #fff;\n}\n.accordion.accordion-soft .accordion-button:not(.collapsed) {\n  background: #ebf5f5;\n  color: #0a2f4c;\n}\n.accordion.accordion-soft .accordion-button:not(.collapsed):after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.accordion.accordion-soft.accordion-card.accordion-card-bold > .accordion-item .accordion-body {\n  background: #ebf5f5;\n  color: #0a2f4c;\n}\n.accordion.accordion-soft.accordion-soft-content .accordion-button:not(.collapsed) {\n  background: transparent;\n}\n.accordion.accordion-soft.accordion-soft-content > .accordion-item .accordion-body {\n  background: #ebf5f5;\n  color: #262a2e;\n}\n.accordion.accordion-simple .accordion-button:not(.collapsed) {\n  background: transparent;\n  color: #0a2f4c;\n}\n.accordion.accordion-simple .accordion-button:not(.collapsed)::after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.accordion.accordion-simple.accordion-card.accordion-card-bold .accordion-button {\n  border-color: transparent;\n}\n.accordion.accordion-simple.accordion-card.accordion-card-bold .accordion-item .accordion-body {\n  background: transparent;\n  color: inherit;\n}\n.accordion.accordion-icon .accordion-button .acon-icon {\n  min-width: 30px;\n  display: inline-block;\n  margin-right: .625rem;\n  font-size: 1.5rem;\n}\n\n/*Table*/\n.table {\n  --bs-table-striped-color: #262a2e;\n  --bs-table-active-color: #262a2e;\n  --bs-table-hover-color: #262a2e;\n  --bs-table-hover-bg: #f7f7f7;\n  color: #6f6f6f;\n  border-color: #eaeaea;\n}\n.table thead th,\n.table tfoot th {\n  vertical-align: middle;\n  font-weight: 500;\n  color: #262a2e;\n  font-size: 0.875rem;\n  /* text-transform: capitalize; */\n}\n.table thead th .form-check,\n.table tfoot th .form-check {\n  font-size: 1rem;\n}\n.table td, .table th {\n  vertical-align: middle;\n  padding: .75rem .4rem;\n}\n.table td a.table-link-text:hover, .table th a.table-link-text:hover {\n  text-decoration: underline;\n}\n.table.table-fixed {\n  table-layout: fixed;\n}\n.table.table-lg td, .table.table-lg th {\n  padding: 1rem 1.5rem;\n}\n.table:not(.table-borderless) > :not(:first-child) {\n  border-top: 0;\n}\n.table.table-sm td, .table.table-sm th {\n  padding: .625rem 1rem;\n}\n.table.nowrap th, .table.nowrap td {\n  white-space: nowrap;\n}\n.table .tb-truncate {\n  max-width: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.table .tb-truncate > * {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.table .thead-primary th,\n.table .thead-success th,\n.table .thead-info th,\n.table .thead-warning th,\n.table .thead-danger th,\n.table .thead-secondary th,\n.table .thead-dark th {\n  color: #fff;\n}\n.table .thead-success th {\n  background-color: #00D67F;\n}\n.table .thead-info th {\n  background-color: #18DDEF;\n}\n.table .thead-warning th {\n  background-color: #FFC400;\n}\n.table .thead-danger th {\n  background-color: #FF0000;\n}\n.table .thead-secondary th {\n  background-color: #6f6f6f;\n}\n.table .thead-primary th {\n  background-color: #0a2f4c;\n}\n.table .thead-light th {\n  background-color: #f7f7f7;\n}\n.table .thead-dark th {\n  background-color: #262a2e;\n}\n.table.table-dark thead th, .table.table-dark tfoot th {\n  color: #fff;\n}\n.table.table-fc-fixed thead th:first-child {\n  position: sticky;\n  left: 0;\n  z-index: 2;\n  background: #fff;\n}\n.table.table-fc-fixed tbody th, .table.table-fc-fixed tbody tr td:first-child {\n  position: sticky;\n  left: 0;\n  z-index: 2;\n  background: #fff;\n}\n.table.table-lc-fixed thead th:last-child {\n  position: sticky;\n  right: 0;\n  z-index: 2;\n  background: #fff;\n}\n.table.table-lc-fixed tbody tr td:last-child {\n  position: sticky;\n  right: 0;\n  z-index: 2;\n  background: #fff;\n}\n.table table thead th:first-child {\n  position: sticky;\n  left: 0;\n  z-index: 2;\n}\n\n.table-row-gap td {\n  border: 0 !important;\n}\n\ntable.sticky-table-header thead tr th {\n  position: sticky;\n  top: 64px;\n  z-index: 99;\n}\n\n.table-action-hover .table-action {\n  opacity: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #fff;\n  right: 1.25rem;\n  transition: all 0.1s;\n}\n.table-action-hover .table-action::before {\n  width: 120px;\n  content: \"\";\n  height: 100%;\n  margin-left: -120px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);\n}\n.table-action-hover tr:hover .table-action {\n  opacity: 1;\n}\n.table-action-hover.table-hover .table-action {\n  background-color: var(--bs-table-hover-bg);\n}\n.table-action-hover.table-hover .table-action::before {\n  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, var(--bs-table-hover-bg) 100%);\n}\n\n.table-primary {\n  --bs-table-bg: #e6f2f3;\n  --bs-table-striped-bg: #b3d8db;\n  --bs-table-striped-color: color-contrast(#b3d8db);\n  --bs-table-active-bg: #d9eced;\n  --bs-table-active-color: color-contrast(#d9eced);\n  --bs-table-hover-bg: #cce5e7;\n  --bs-table-hover-color: color-contrast(#cce5e7);\n  color: #0a2f4c;\n  border-color: #80bec4;\n}\n\n.table-secondary {\n  --bs-table-bg: #f1f1f1;\n  --bs-table-striped-bg: #d4d4d4;\n  --bs-table-striped-color: color-contrast(#d4d4d4);\n  --bs-table-active-bg: #e9e9e9;\n  --bs-table-active-color: color-contrast(#e9e9e9);\n  --bs-table-hover-bg: #e2e2e2;\n  --bs-table-hover-color: color-contrast(#e2e2e2);\n  color: #6f6f6f;\n  border-color: #b7b7b7;\n}\n\n.table-success {\n  --bs-table-bg: #e6fbf2;\n  --bs-table-striped-bg: #b3f3d9;\n  --bs-table-striped-color: color-contrast(#b3f3d9);\n  --bs-table-active-bg: #d9f9ec;\n  --bs-table-active-color: color-contrast(#d9f9ec);\n  --bs-table-hover-bg: #ccf7e5;\n  --bs-table-hover-color: color-contrast(#ccf7e5);\n  color: #00D67F;\n  border-color: #80ebbf;\n}\n\n.table-info {\n  --bs-table-bg: #e8fcfd;\n  --bs-table-striped-bg: #baf5fa;\n  --bs-table-striped-color: color-contrast(#baf5fa);\n  --bs-table-active-bg: #dcfafd;\n  --bs-table-active-color: color-contrast(#dcfafd);\n  --bs-table-hover-bg: #d1f8fc;\n  --bs-table-hover-color: color-contrast(#d1f8fc);\n  color: #18DDEF;\n  border-color: #8ceef7;\n}\n\n.table-warning {\n  --bs-table-bg: #fff9e6;\n  --bs-table-striped-bg: #ffedb3;\n  --bs-table-striped-color: color-contrast(#ffedb3);\n  --bs-table-active-bg: #fff6d9;\n  --bs-table-active-color: color-contrast(#fff6d9);\n  --bs-table-hover-bg: #fff3cc;\n  --bs-table-hover-color: color-contrast(#fff3cc);\n  color: #FFC400;\n  border-color: #ffe280;\n}\n\n.table-danger {\n  --bs-table-bg: #ffe6e6;\n  --bs-table-striped-bg: #ffb3b3;\n  --bs-table-striped-color: color-contrast(#ffb3b3);\n  --bs-table-active-bg: #ffd9d9;\n  --bs-table-active-color: color-contrast(#ffd9d9);\n  --bs-table-hover-bg: #ffcccc;\n  --bs-table-hover-color: color-contrast(#ffcccc);\n  color: #FF0000;\n  border-color: #ff8080;\n}\n\n.table-light {\n  --bs-table-bg: #f7f7f7;\n  --bs-table-striped-bg: #eaeaea;\n  --bs-table-striped-color: color-contrast(#eaeaea);\n  --bs-table-active-bg: #e9e9e9;\n  --bs-table-active-color: color-contrast(#e9e9e9);\n  --bs-table-hover-bg: #d8d8d8;\n  --bs-table-hover-color: color-contrast(#d8d8d8);\n  color: #6f6f6f;\n  border-color: #d8d8d8;\n}\n\n.table-dark {\n  --bs-table-bg: #262a2e;\n  --bs-table-striped-bg: #2a2f34;\n  --bs-table-striped-color: color-contrast(#2a2f34);\n  --bs-table-active-bg: #3c3f43;\n  --bs-table-active-color: color-contrast(#3c3f43);\n  --bs-table-hover-bg: #2a2f34;\n  --bs-table-hover-color: color-contrast(#2a2f34);\n  color: #fff;\n  border-color: #2a2f34;\n}\n\n@media (max-width: 1200px) {\n  .table-responsive .table > tbody > tr > td,\n  .table-responsive .table > tbody > tr > th,\n  .table-responsive .table > tfoot > tr > td,\n  .table-responsive .table > tfoot > tr > th,\n  .table-responsive .table > thead > tr > td,\n  .table-responsive .table > thead > tr > th {\n    white-space: nowrap;\n  }\n}\n/*Data Table*/\ntable.dataTable thead td, table.dataTable thead th {\n  position: relative;\n  background-image: none !important;\n}\ntable.dataTable thead td.sorting_asc, table.dataTable thead td.sorting_desc, table.dataTable thead th.sorting_asc, table.dataTable thead th.sorting_desc {\n  color: #0a2f4c;\n  background-image: none !important;\n}\ntable.dataTable thead td.sorting::before, \ntable.dataTable thead td.sorting_asc::before, \ntable.dataTable thead td.sorting_desc::before, \ntable.dataTable thead td.sorting::after, \ntable.dataTable thead td.sorting_asc::after, \ntable.dataTable thead td.sorting_desc::after, \ntable.dataTable thead th.sorting::before, \ntable.dataTable thead th.sorting_asc::before,\ntable.dataTable thead th.sorting_desc::before, \ntable.dataTable thead th.sorting::after, \ntable.dataTable thead th.sorting_asc::after,\ntable.dataTable thead th.sorting_desc::after\n {\n  display: inline-block;\n  font-family: remixicon;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 0.875rem;\n  text-transform: none;\n  text-rendering: auto;\n  line-height: 1;\n  position: absolute;\n  z-index: 10;\n  right: 7px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\ntable.dataTable thead span.sorting::before, \ntable.dataTable thead span.sorting::after,\ntable.dataTable thead span.sorting_asc::after,\ntable.dataTable thead span.sorting_desc::after,\ntable.dataTable thead span.sorting_asc::before,\ntable.dataTable thead span.sorting_desc::before\n{\n\tbottom:0px!important;\n} \n\n\ntable.dataTable thead td.sorting::before, table.dataTable thead td.sorting_asc::before, table.dataTable thead td.sorting_desc::before, table.dataTable thead td.sorting::after, table.dataTable thead td.sorting_asc::after, table.dataTable thead td.sorting_desc::after, table.dataTable thead th.sorting::before, table.dataTable thead th.sorting_asc::before, table.dataTable thead th.sorting_desc::before, table.dataTable thead th.sorting::after, table.dataTable thead th.sorting_asc::after, table.dataTable thead th.sorting_desc::after {\n  content: \"\";\n  bottom: auto;\n  opacity: 1;\n}\ntable.dataTable thead td.sorting::before, table.dataTable thead th.sorting::before, table.dataTable thead span.sorting::before{\n  content: \"\\ea72\";\n}\ntable.dataTable thead td.sorting.sorting_asc::before, table.dataTable thead th.sorting.sorting_asc::before, table.dataTable thead span.sorting::before {\n  content: \"\\f0f9\";\n}\ntable.dataTable thead td.sorting.sorting_desc::after, table.dataTable thead th.sorting.sorting_desc::after, table.dataTable thead span.sorting::before {\n  content: \"\\f0fa\";\n}\ntable.dataTable thead td.sorting.sorting_desc::before, table.dataTable thead th.sorting.sorting_desc::before, table.dataTable thead span.sorting::before {\n  content: \"\";\n}\ntable.dataTable tbody tr.selected td {\n  background-color: #ebf5f5;\n  color: #262a2e;\n}\ntable.dataTable tbody tr.group, table.dataTable tbody tr.group:hover {\n  color: #0a2f4c !important;\n  font-weight: 600;\n  text-transform: uppercase;\n}\ntable.dt-rowReorder-float {\n  outline-offset: 0;\n  outline-color: #0a2f4c;\n}\n\ndiv.dataTables_wrapper .dataTables_length select {\n  margin-right: .625rem;\n}\ndiv.dataTables_wrapper div.dataTables_filter input {\n  margin-left: 0 !important;\n  width: 100% !important;\n}\ndiv.dataTables_wrapper .dataTables_scrollBody {\n  border-left: 0 !important;\n}\ndiv.dataTables_wrapper .dataTables_scrollBody thead th {\n  overflow: hidden;\n}\ndiv.dataTables_wrapper .dataTables_scrollBody table {\n  margin-bottom: 1rem !important;\n}\ndiv.dataTables_wrapper div.dataTables_info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding-top: 0;\n}\n\n/*Advance Table*/\n.table-advance th, .table-advance td {\n  border: none;\n}\n.table-advance tbody tr {\n  -webkit-transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  -moz-transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 0.5rem;\n}\n.table-advance tbody tr th, .table-advance tbody tr td {\n  border: none;\n  position: relative;\n}\n.table-advance tbody tr th:after, .table-advance tbody tr td:after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-top: 1px solid #d8d8d8;\n  border-bottom: 1px solid #d8d8d8;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n}\n.table-advance tbody tr th:first-child:after, .table-advance tbody tr td:first-child:after {\n  border-left: 1px solid #d8d8d8;\n  border-radius: 0.5rem 0 0 0.5rem;\n}\n.table-advance tbody tr th:last-child:after, .table-advance tbody tr td:last-child:after {\n  border-right: 1px solid #d8d8d8;\n  border-radius: 0 0.5rem 0.5rem 0;\n}\n.table-advance tbody tr.table-row-gap {\n  box-shadow: none;\n  pointer-events: none;\n}\n.table-advance tbody tr.table-row-gap th, .table-advance tbody tr.table-row-gap td {\n  padding: .5rem;\n}\n.table-advance tbody tr.table-row-gap th:after, .table-advance tbody tr.table-row-gap td:after {\n  display: none;\n}\n.table-advance.table-striped tbody tr:nth-of-type(odd) {\n  background-color: transparent;\n}\n\n/*Apex Chart*/\n.apexcharts-legend .apexcharts-legend-marker {\n  margin-right: .625rem;\n}\n\n.apexcharts-toolbar {\n  max-width: inherit !important;\n}\n.apexcharts-toolbar .apexcharts-zoom-icon,\n.apexcharts-toolbar .apexcharts-zoomin-icon,\n.apexcharts-toolbar .apexcharts-zoomout-icon,\n.apexcharts-toolbar .apexcharts-reset-icon,\n.apexcharts-toolbar .apexcharts-pan-icon,\n.apexcharts-toolbar .apexcharts-selection-icon,\n.apexcharts-toolbar .apexcharts-menu-icon,\n.apexcharts-toolbar .apexcharts-toolbar-custom-icon {\n  height: auto;\n  width: auto;\n  color: #262a2e;\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -ms-transform: scale(1);\n  -o-transform: scale(1);\n  transform: scale(1);\n  margin-left: 1rem;\n  margin-right: 0;\n}\n.apexcharts-toolbar svg {\n  fill: none !important;\n  height: 18px;\n  width: 18px;\n}\n.apexcharts-toolbar .apexcharts-menu {\n  min-width: 10rem;\n  padding: .5rem 0;\n  margin: .125rem 0 0;\n}\n.apexcharts-toolbar .apexcharts-menu .apexcharts-menu-item {\n  padding: .25rem 1.5rem;\n  text-align: left;\n  color: #262a2e;\n  font-size: 1rem;\n}\n.apexcharts-toolbar .apexcharts-menu .apexcharts-menu-item:hover {\n  background-color: #f7f7f7;\n}\n\n.apexcharts-canvas .apexcharts-xaxistooltip,\n.apexcharts-canvas .apexcharts-yaxistooltip {\n  font-size: 0.75rem;\n  background: #262a2e;\n  color: #fff;\n  border-radius: 0.5rem;\n  max-width: 200px;\n  padding: .25rem .5rem;\n  text-align: center;\n}\n.apexcharts-canvas .apexcharts-xaxistooltip:before, .apexcharts-canvas .apexcharts-xaxistooltip:after,\n.apexcharts-canvas .apexcharts-yaxistooltip:before,\n.apexcharts-canvas .apexcharts-yaxistooltip:after {\n  display: none;\n}\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {\n  border-radius: 0.5rem;\n  max-width: 200px;\n  text-align: center;\n  font-size: 0.75rem;\n}\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light {\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  color: #6f6f6f;\n  border: none;\n  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.1);\n}\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  color: #fff;\n  background-color: #0a2f4c;\n  border-bottom: none;\n  padding: 0.65rem .75rem;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-series-group {\n  padding-left: .75rem;\n  padding-right: .75rem;\n}\n\n#chart_year,\n#chart_quarter {\n  width: 96%;\n  max-width: 48%;\n  box-shadow: none;\n  padding-left: 0;\n  padding-top: 1.25rem;\n  background: #fff;\n}\n\n#chart_year {\n  float: left;\n  position: relative;\n  -webkit-transition: 1s ease transform;\n  -moz-transition: 1s ease transform;\n  transition: 1s ease transform;\n  z-index: 3;\n}\n\n#chart_year.chart_quarter-activated {\n  transform: translateX(0);\n  -webkit-transition: 1s ease transform;\n  -moz-transition: 1s ease transform;\n  transition: 1s ease transform;\n}\n\n#chart_quarter {\n  float: left;\n  position: relative;\n  z-index: -2;\n  -webkit-transition: 1s ease transform;\n  -moz-transition: 1s ease transform;\n  transition: 1s ease transform;\n}\n\n#chart_quarter.active {\n  -webkit-transition: 1.1s ease-in-out transform;\n  -moz-transition: 1.1s ease-in-out transform;\n  transition: 1.1s ease-in-out transform;\n  -webkit-transform: translateX(0);\n  -moz-transform: translateX(0);\n  -ms-transform: translateX(0);\n  -o-transform: translateX(0);\n  transform: translateX(0);\n  z-index: 1;\n}\n\n.apexcharts-datalabel-value {\n  fill: #262a2e !important;\n}\n\n@media screen and (min-width: 480px) {\n  #chart_year {\n    -webkit-transform: translateX(50%);\n    -moz-transform: translateX(50%);\n    -ms-transform: translateX(50%);\n    -o-transform: translateX(50%);\n    transform: translateX(50%);\n  }\n\n  #chart_quarter {\n    -webkit-transform: translateX(-50%);\n    -moz-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    -o-transform: translateX(-50%);\n    transform: translateX(-50%);\n  }\n}\n/*charts*/\n.hk-charts-pg .hk-container-mwlg .card .card-footer {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  min-height: 139px;\n}\n.hk-charts-pg .hk-container-mwlg .card:hover .card-footer {\n  background: #f7f7f7;\n}\n\n/*Nestable*/\n.dd-handle {\n  font-weight: 500;\n  margin: 0 0 .375rem;\n  padding: .5rem 1rem;\n  background: #fff;\n  color: #262a2e;\n  height: 37px;\n  border-width: 1px;\n  border-color: #d8d8d8;\n}\n.dd-handle:hover, .dd-handle:focus, .dd-handle:active {\n  color: #262a2e;\n  background: #f7f7f7;\n}\n\n.dd-item > button {\n  margin: 0;\n  height: 37px;\n  font-size: 1.5rem;\n  width: 42px;\n  color: #9e9e9e;\n  outline: none;\n}\n.dd-item > button.dd-expand:before, .dd-item > button.dd-collapse:before {\n  font-family: 'Line Awesome Free';\n  font-weight: 900;\n  line-height: 1;\n}\n.dd-item > button.dd-expand::before {\n  content: \"\\f067\";\n}\n.dd-item > button.dd-collapse::before {\n  content: \"\\f068\";\n}\n.dd-item > button:hover, .dd-item > button:focus, .dd-item > button:active {\n  outline: none;\n}\n\n.dd-placeholder {\n  background: transparent;\n  border-color: #d8d8d8;\n}\n\n.dd3-content {\n  display: block;\n  width: 100%;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  margin: 0 0 .375rem;\n  font-size: 0.875rem;\n  padding: .5rem 1rem .5rem 4rem;\n  background: #fff;\n  color: #262a2e;\n  border: 1px solid #d8d8d8;\n}\n.dd3-content:hover, .dd3-content:focus, .dd3-content:active {\n  color: #262a2e;\n  background: #f7f7f7;\n}\n\n.dd-dragel > .dd3-item > .dd3-content {\n  margin: 0;\n}\n\n.dd3-item > button {\n  margin-left: 2.625rem;\n}\n\n.dd3-handle {\n  position: absolute;\n  margin: 0;\n  left: 0;\n  top: 0;\n  cursor: grab;\n  color: #9e9e9e;\n  width: 42px;\n  text-indent: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  padding: 1.125rem;\n  border-color: #d8d8d8;\n  border-radius: 0.5rem 0 0 0.5rem;\n}\n.dd3-handle:before {\n  font-family: 'Line Awesome Free';\n  font-weight: 900;\n  color: #9e9e9e;\n  content: \"\\f2a1\";\n  font-size: 1.625rem;\n  color: #d8d8d8;\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 8px;\n  width: 100%;\n  text-align: center;\n  text-indent: 0;\n}\n\n/*Treeview*/\n.jstree-default .jstree-clicked,\n.jstree-default .jstree-hovered {\n  background: none;\n  box-shadow: none;\n  color: #298DFF;\n}\n\n/*Modals*/\n.modal-content,\n.modal-header,\n.modal-footer {\n  border-color: #d8d8d8;\n}\n\n.modal-content {\n  border-radius: 0.5rem;\n  overflow: hidden;\n  border: none;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  border-top-left-radius: calc(0.5rem - 1px);\n  border-top-right-radius: calc(0.5rem - 1px);\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.modal-header.header-wth-bg {\n  background: #f7f7f7;\n  border-bottom: 0;\n}\n.modal-header.header-wth-bg-inv {\n  background: #0a2f4c;\n  border-bottom: 0;\n}\n.modal-header.header-wth-bg-inv .modal-title {\n  color: #fff;\n}\n\n.modal-body > .btn-close {\n  position: absolute;\n  right: 1.5rem;\n  top: 1.25rem;\n}\n.modal-body > .btn-close ~ :is(h1, h2, h3, h4, h5, h6) {\n  padding-right: 1.5rem;\n  margin-top: 0.5rem;\n}\n\n.modal-footer {\n  border-bottom-right-radius: calc(0.5rem- 1px);\n  border-bottom-left-radius: calc(0.5rem - 1px);\n}\n\n.modal-backdrop {\n  background-color: #262a2e;\n}\n\nbody.modal-open {\n  padding-right: 0 !important;\n}\nbody.modal-open .hk-navbar {\n  padding-right: 1rem !important;\n}\n\n/*Close*/\n.btn-close {\n  color: #262a2e;\n  opacity: .6;\n  outline: none;\n  height: auto;\n  width: auto;\n  text-shadow: none;\n  font: normal normal normal 0/1 'Material-Design-Iconic-Font';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.btn-close:before {\n  content: \"\\f136\";\n  font-size: 1rem;\n}\n.btn-close:focus {\n  box-shadow: none;\n}\n.btn-close:not(:disabled):not(.disabled):not(.btn-close-white):focus, .btn-close:not(:disabled):not(.disabled):not(.btn-close-white):hover {\n  color: #6f6f6f;\n  opacity: 1;\n}\n.btn-close span {\n  display: none;\n}\n\n.close-over .btn-close {\n  height: 22px;\n  width: 22px;\n  background: #6f6f6f;\n  color: #fff !important;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  cursor: pointer;\n  position: absolute;\n  right: -11px;\n  top: -11px;\n  opacity: 1;\n}\n.close-over .btn-close:before {\n  content: \"\\f136\";\n  font-size: 1rem;\n  line-height: 0;\n}\n.close-over .btn-close:hover {\n  background: #262a2e;\n}\n\n/*Sweet-alert*/\n.swal2-container .swal2-content {\n  color: #6f6f6f;\n}\n.swal2-container .swal2-title {\n  color: #262a2e;\n}\n.swal2-container .swal2-popup {\n  border-radius: 0.5rem;\n}\n.swal2-container .swal2-popup .swal2-validation-message {\n  background: transparent;\n  align-items: start;\n  border: none;\n  color: #FF0000;\n}\n.swal2-container .swal2-popup .swal2-validation-message:before {\n  content: \"\\ED77\";\n  font-family: remixicon !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: transparent;\n  color: #FF0000;\n  min-width: auto;\n}\n.swal2-container .swal2-popup .swal2-image {\n  border-radius: 2rem;\n}\n.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step {\n  background: #00D67F;\n}\n.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {\n  background: #298DFF;\n}\n.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {\n  background: #d8d8d8;\n}\n.swal2-container .swal2-popup .swal2-progress-steps .swal2-progress-step-line {\n  height: .2rem;\n  background: #298DFF;\n}\n.swal2-container .swal2-popup .swal2-close {\n  outline: none;\n}\n.swal2-container .swal2-title {\n  font-size: 1.1rem;\n}\n.swal2-container .swal2-title span {\n  display: -ms-flexbox;\n  display: flex;\n}\n.swal2-container.swal2-has-header .swal2-popup .swal2-header {\n  padding-right: 1rem;\n  padding-left: 1rem;\n  padding-bottom: 1rem;\n  margin-left: -1rem;\n  margin-right: -1rem;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid #d8d8d8;\n}\n.swal2-container.swal2-has-footer .swal2-popup.swal2-modal {\n  padding-bottom: 0;\n}\n.swal2-container.swal2-has-footer .swal2-popup.swal2-modal .swal2-footer {\n  margin-left: -1rem;\n  margin-right: -1rem;\n  border-top: 1px solid #d8d8d8;\n}\n.swal2-container.swal2-has-bg .swal2-popup .swal2-content {\n  background: #f7f7f7;\n  margin-left: -1rem;\n  margin-right: -1rem;\n  margin-top: -1rem;\n  padding-bottom: 2rem;\n  padding-top: 2rem;\n}\n.swal2-container.swal2-has-bg .swal2-popup .swal2-actions .btn, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .hopscotch-nav-button {\n  flex: 1;\n  border: 0;\n  padding: 0;\n}\n.swal2-container.swal2-has-bg .swal2-popup .swal2-actions .btn:hover, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:hover, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .hopscotch-nav-button:hover, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .btn:focus, .swal2-container.swal2-has-bg .swal2-popup .swal2-actions div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .swal2-container.swal2-has-bg .swal2-popup .swal2-actions .hopscotch-nav-button:focus {\n  background: transparent;\n  color: #9e9e9e;\n}\n\n.swal2-shown {\n  padding-right: 0 !important;\n}\n\n/*Notification*/\n.alert {\n  color: #262a2e;\n  border-radius: 0.5rem;\n  padding: 0.75rem 1rem;\n}\n.alert .alert-link {\n  font-weight: normal;\n  color: inherit;\n  text-decoration: underline;\n}\n.alert.alert-dismissible .btn-close {\n  padding: 0.9rem 1rem;\n  color: inherit;\n}\n.alert.alert-dismissible .btn-close:before {\n  position: relative;\n  top: -2px;\n}\n.alert.alert-dismissible .btn-close:hover {\n  opacity: 1;\n  color: inherit;\n}\n.alert.alert-primary {\n  color: #0a2f4c;\n  background: #ebf5f5;\n  border-color: rgba(199, 226, 229, 0.3);\n}\n.alert.alert-success {\n  color: #00D67F;\n  background: #ebfcf5;\n  border-color: rgba(199, 246, 227, 0.3);\n}\n.alert.alert-info {\n  color: #16c7d7;\n  background: #edfcfe;\n  border-color: rgba(204, 248, 251, 0.3);\n}\n.alert.alert-danger {\n  color: #FF0000;\n  background: #ffebeb;\n  border-color: rgba(255, 199, 199, 0.3);\n}\n.alert.alert-warning {\n  color: #cc9d00;\n  background: #fffaeb;\n  border-color: rgba(255, 242, 199, 0.3);\n}\n.alert.alert-secondary {\n  color: #6f6f6f;\n  background: #f3f3f3;\n  border-color: rgba(223, 223, 223, 0.3);\n}\n.alert.alert-light {\n  color: #5f5f5f;\n  background: #f7f7f7;\n  border-color: #eaeaea;\n}\n.alert.alert-dark {\n  color: #fff;\n  background: #262a2e;\n  border-color: #262a2e;\n}\n.alert.alert-dark.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-dark.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  text-decoration: none;\n  opacity: 1;\n}\n.alert.alert-inv {\n  color: #fff;\n}\n.alert.alert-inv.alert-inv-primary {\n  background: #0a2f4c;\n  color: #ebf5f5;\n}\n.alert.alert-inv.alert-inv-primary.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-primary.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  text-decoration: none;\n  opacity: 1;\n}\n.alert.alert-inv.alert-inv-info {\n  background: #18DDEF;\n  color: #edfcfe;\n}\n.alert.alert-inv.alert-inv-info.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-info.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  text-decoration: none;\n  opacity: 1;\n}\n.alert.alert-inv.alert-inv-success {\n  background: #00D67F;\n  color: #ebfcf5;\n}\n.alert.alert-inv.alert-inv-success.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-success.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  text-decoration: none;\n  opacity: 1;\n}\n.alert.alert-inv.alert-inv-warning {\n  background: #FFC400;\n  color: #fffaeb;\n}\n.alert.alert-inv.alert-inv-warning.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-warning.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  text-decoration: none;\n  opacity: 1;\n}\n.alert.alert-inv.alert-inv-danger {\n  background: #FF0000;\n  color: #ffebeb;\n}\n.alert.alert-inv.alert-inv-danger.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-danger.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  text-decoration: none;\n  opacity: 1;\n}\n.alert.alert-inv.alert-inv-secondary {\n  background: #6f6f6f;\n  color: #f3f3f3;\n}\n.alert.alert-inv.alert-inv-secondary.alert-dismissible .btn-close:not(:disabled):not(.disabled):focus, .alert.alert-inv.alert-inv-secondary.alert-dismissible .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  text-decoration: none;\n  opacity: 1;\n}\n.alert.alert-border-primary {\n  border-color: #0a2f4c;\n  color: #0a2f4c;\n}\n.alert.alert-border-info {\n  border-color: #18DDEF;\n  color: #18DDEF;\n}\n.alert.alert-border-success {\n  border-color: #00D67F;\n  color: #00D67F;\n}\n.alert.alert-border-warning {\n  border-color: #FFC400;\n  color: #FFC400;\n}\n.alert.alert-border-danger {\n  border-color: #FF0000;\n  color: #FF0000;\n}\n.alert.alert-border-secondary {\n  border-color: #6f6f6f;\n  color: #6f6f6f;\n}\n.alert.alert-wth-icon {\n  padding-left: 3.375rem;\n  position: relative;\n}\n.alert.alert-wth-icon .alert-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1.5rem;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  height: 100%;\n  width: 54px;\n  left: 0;\n  top: 0;\n  position: absolute;\n}\n.alert.alert-square {\n  border-radius: 0;\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n\n.jq-toast-wrap {\n  width: 300px;\n}\n.jq-toast-wrap .jq-toast-single {\n  color: #262a2e;\n  border-radius: 0.5rem;\n  margin: 0;\n  border: none;\n  background: #fff;\n  font-size: 0.875rem;\n  line-height: 1.3;\n}\n.jq-toast-wrap .jq-toast-single .jq-toast-loader {\n  border-radius: 2px 2px 0 0;\n  height: 2px;\n}\n.jq-toast-wrap .jq-toast-single a {\n  color: inherit;\n  text-decoration: underline;\n  font-weight: inherit;\n  border-bottom: none;\n  padding-bottom: 0;\n  font-size: inherit;\n}\n.jq-toast-wrap .jq-toast-single .close-jq-toast-single {\n  font-size: 1.5rem;\n  top: 0;\n}\n.jq-toast-wrap .jq-toast-single .jq-toast-heading {\n  font-size: 1rem !important;\n  color: inherit;\n  font-weight: 500;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-primary {\n  background: #ebf5f5;\n  color: #0a2f4c;\n  border: 1px solid;\n  border-color: rgba(199, 226, 229, 0.3);\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-secondary {\n  background: #f3f3f3;\n  color: #6f6f6f;\n  border: 1px solid;\n  border-color: rgba(223, 223, 223, 0.3);\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-info {\n  background: #edfcfe;\n  color: #18DDEF;\n  border: 1px solid;\n  border-color: rgba(204, 248, 251, 0.3);\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-success {\n  background: #ebfcf5;\n  color: #00D67F;\n  border: 1px solid;\n  border-color: rgba(199, 246, 227, 0.3);\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-warning {\n  background: #fffaeb;\n  color: #FFC400;\n  border: 1px solid;\n  border-color: rgba(255, 242, 199, 0.3);\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-danger {\n  background: #ffebeb;\n  color: #FF0000;\n  border: 1px solid;\n  border-color: rgba(255, 199, 199, 0.3);\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-light {\n  background: #f7f7f7;\n  color: #5f5f5f;\n  border: 1px solid;\n  border-color: #d8d8d8;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-dark {\n  background: #262a2e;\n  color: #fff;\n  border: 1px solid;\n  border-color: #2a2f34;\n}\n.jq-toast-wrap .jq-toast-single.jq-has-icon {\n  padding: .75rem 1.5rem .875rem 2.75rem;\n}\n.jq-toast-wrap .jq-toast-single.jq-has-icon .jq-toast-icon {\n  position: absolute;\n  font-size: 1rem;\n  left: 11px;\n  top: 14px;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-inv {\n  color: #fff;\n  border: none;\n  background: #262a2e;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-primary {\n  background: #0a2f4c;\n  color: #ebf5f5;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-danger {\n  background: #FF0000;\n  color: #ffebeb;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-warning {\n  background: #FFC400;\n  color: #fffaeb;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-info {\n  background: #18DDEF;\n  color: #edfcfe;\n}\n.jq-toast-wrap .jq-toast-single.jq-toast-inv.jq-toast-inv-success {\n  background: #00D67F;\n  color: #ebfcf5;\n}\n\n.bottom-center-fullwidth .jq-toast-wrap {\n  left: 0 !important;\n  right: 0 !important;\n  width: 100% !important;\n  bottom: 0 !important;\n}\n.bottom-center-fullwidth .jq-toast-wrap .jq-toast-single {\n  border-radius: 0;\n}\n\n.top-center-fullwidth .jq-toast-wrap {\n  left: 0 !important;\n  right: 0 !important;\n  width: 100% !important;\n  top: 2px !important;\n}\n.top-center-fullwidth .jq-toast-wrap .jq-toast-single {\n  border-radius: 0;\n}\n\n@media (max-width: 576px) {\n  .jq-toast-wrap.top-right, .jq-toast-wrap.top-left, .jq-toast-wrap.bottom-right, .jq-toast-wrap.bottom-left {\n    left: 0;\n    right: 0;\n    width: 100%;\n  }\n}\n/*Toast*/\n.toast {\n  border: none;\n  border-radius: 0.5rem;\n}\n\n/*Bootstrap Notify*/\nspan[data-notify=\"icon\"] {\n  position: relative;\n  top: 3px;\n  line-height: 0;\n  font-size: 1rem;\n}\n\n/*Tooltop*/\n.tooltip {\n  font-size: 0.75rem;\n  font-family: var(--bs-body-font-family);\n}\n.tooltip .tooltip-inner {\n  background: #262a2e;\n  border-radius: 0.5rem;\n}\n.tooltip.show {\n  opacity: 1;\n}\n.tooltip .tooltip-arrow {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n  .tooltip {\n    display: none !important;\n  }\n}\n/*Images*/\n.img-thumbnail {\n  border-color: #d8d8d8;\n  border-radius: 0;\n}\n\n.img-background {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n/*Icons*/\n.font-icons-wrap li {\n  text-align: center;\n  vertical-align: middle;\n  padding: 1.875rem .625rem 1.875rem .625rem;\n  height: 100px;\n  width: 100px;\n  margin: .625rem;\n  min-height: 60px;\n  border: solid 1px #eee;\n  border-radius: 0.5rem;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  cursor: pointer;\n}\n.font-icons-wrap li a {\n  color: #262a2e;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  font-size: 1.25rem;\n}\n.font-icons-wrap li a > i {\n  font-size: 1.625rem;\n  line-height: 20px;\n}\n.font-icons-wrap li a span {\n  display: inline-block;\n  position: absolute;\n  background-color: #298DFF;\n  color: #fff;\n  padding: .25rem .5rem;\n  font-size: 0.75rem;\n  white-space: nowrap;\n  top: 45px;\n  left: 50%;\n  min-width: 98px;\n  display: none;\n  border-radius: .25rem;\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.font-icons-wrap li:hover {\n  background: #262a2e;\n}\n.font-icons-wrap li:hover a {\n  color: #fff;\n}\n.font-icons-wrap li:hover a span {\n  display: block;\n}\n\n.feather {\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n\n.svg-icon {\n  line-height: 0 !important;\n}\n\n.feather-icon {\n  line-height: 0 !important;\n}\n.feather-icon.fe-x > svg {\n  height: 16px;\n  width: 16px;\n}\n.feather-icon.fe-2x > svg {\n  height: 32px;\n  width: 32px;\n}\n\n.feather-icon > svg,\n.svg-icon > svg {\n  height: 1em;\n  width: 1em;\n}\n\n.flag-icon {\n  height: 20px;\n  width: 20px;\n}\n\n/*Carousel*/\n.carousel-control-prev,\n.carousel-control-next {\n  opacity: 1;\n}\n.carousel-control-prev:hover .carousel-control-next-icon,\n.carousel-control-prev:hover .carousel-control-prev-icon,\n.carousel-control-next:hover .carousel-control-next-icon,\n.carousel-control-next:hover .carousel-control-prev-icon {\n  border-color: white;\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n  height: 50px;\n  width: 50px;\n  border: 2px solid;\n  border-color: rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  background: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  font-size: 1.25rem;\n}\n.carousel-control-next-icon:before,\n.carousel-control-prev-icon:before {\n  display: inline-block;\n  font: normal normal normal 22px/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  padding-left: .25rem;\n  speak: none;\n  text-transform: none;\n  text-rendering: auto;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.carousel-control-next-icon:before {\n  content: \"\\f2fb\";\n}\n\n.carousel-control-prev-icon:before {\n  content: \"\\f2fa\";\n}\n\n.custom-carousel-nav .carousel-text-nav {\n  position: static;\n  color: #262a2e;\n}\n.custom-carousel-nav .carousel-text-nav:hover, .custom-carousel-nav .carousel-text-nav:focus {\n  color: #262a2e;\n}\n.custom-carousel-nav .carousel-indicators {\n  position: static;\n}\n\n.carousel-indicators {\n  bottom: 20px;\n}\n.carousel-indicators li[data-bs-target] {\n  width: 6px;\n  height: 6px;\n  margin-right: .25rem;\n  margin-left: .25rem;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  background: transparent;\n}\n.carousel-indicators li[data-bs-target].active {\n  background: #b5b5b5;\n}\n.carousel-indicators.dark-indicators li {\n  border-color: #262a2e;\n}\n.carousel-indicators.dark-indicators li.active {\n  background: #2f343a;\n}\n.carousel-indicators.theme-indicators li {\n  border-color: #0a2f4c;\n}\n.carousel-indicators.theme-indicators li.active {\n  background: #007d88;\n}\n\n.carousel-caption {\n  bottom: 30px;\n}\n\n.owl-carousel .item-video {\n  height: auto;\n}\n.owl-carousel .owl-video-tn {\n  background-size: cover;\n}\n.owl-carousel .owl-dots .owl-dot span {\n  width: 8px;\n  height: 8px;\n  margin: 0 .25rem;\n  background: transparent;\n  border: 1px solid #262a2e;\n}\n.owl-carousel .owl-dots .owl-dot:focus {\n  outline: none;\n}\n.owl-carousel .owl-dots .owl-dot:hover span {\n  background: #262a2e;\n}\n.owl-carousel .owl-dots .owl-dot.active span {\n  background: #262a2e;\n}\n.owl-carousel.light-owl-dots .owl-dots .owl-dot span {\n  border: 1px solid #fff;\n}\n.owl-carousel.light-owl-dots .owl-dots .owl-dot:focus {\n  outline: none;\n}\n.owl-carousel.light-owl-dots .owl-dots .owl-dot:hover span {\n  background: #fff;\n}\n.owl-carousel.light-owl-dots .owl-dots .owl-dot.active span {\n  background: #fff;\n}\n.owl-carousel.theme-owl-dots .owl-dots .owl-dot span {\n  border: 1px solid #0a2f4c;\n}\n.owl-carousel.theme-owl-dots .owl-dots .owl-dot:focus {\n  outline: none;\n}\n.owl-carousel.theme-owl-dots .owl-dots .owl-dot:hover span {\n  background: #0a2f4c;\n}\n.owl-carousel.theme-owl-dots .owl-dots .owl-dot.active span {\n  background: #0a2f4c;\n}\n.owl-carousel .owl-video-play-icon {\n  background: rgba(255, 255, 255, 0.8);\n  left: 20px;\n  bottom: 20px;\n  margin: 0;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  top: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  color: #298DFF;\n}\n.owl-carousel .owl-video-play-icon:before {\n  display: inline-block;\n  font: normal normal normal 22px/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  padding-left: .25rem;\n  speak: none;\n  text-transform: none;\n  text-rendering: auto;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f3aa\";\n}\n.owl-carousel .owl-video-play-icon:hover {\n  -webkit-transform: scale(1.1, 1.1);\n  -moz-transform: scale(1.1, 1.1);\n  -ms-transform: scale(1.1, 1.1);\n  -o-transform: scale(1.1, 1.1);\n  transform: scale(1.1, 1.1);\n}\n.owl-carousel.dots-on-item .owl-dots {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 15px;\n}\n\n@media (max-width: 991px) {\n  .carousel-control-next-icon, .carousel-control-prev-icon {\n    height: 30px;\n    width: 30px;\n    font-size: 1rem;\n  }\n}\n/*Twitter slider*/\n.twitter-slider-wrap i.fa-twitter {\n  font-size: 1.875rem;\n  color: #fff;\n}\n.twitter-slider-wrap .owl-carousel {\n  text-align: center;\n}\n.twitter-slider-wrap .owl-carousel .user, .twitter-slider-wrap .owl-carousel .interact {\n  display: none;\n}\n.twitter-slider-wrap .owl-carousel .tweet {\n  font-size: 1rem;\n  color: #fff;\n  margin-bottom: 1.875rem;\n}\n.twitter-slider-wrap .owl-carousel .tweet > a {\n  color: #fff;\n}\n.twitter-slider-wrap .owl-carousel .timePosted > a {\n  font-size: 0.75rem;\n  color: #fff;\n}\n\n.product-detail-slider .owl-carousel {\n  border-radius: 0.5rem;\n  overflow: hidden;\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n}\n.product-detail-slider .thumb-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  margin-top: 1rem;\n}\n.product-detail-slider .thumb-wrap > a {\n  display: block;\n  background-size: cover;\n  background-position: center;\n  box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n  height: 50px;\n  width: 100px;\n  border-radius: 0.5rem;\n  margin: 0 .625rem;\n  background-color: #d8d8d8;\n  border: 1px solid transparent;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.product-detail-slider .thumb-wrap > a.active-thumb {\n  border: 1px solid #298DFF;\n}\n\n/*Color Pickr*/\n.form-control-color {\n  padding: .375rem;\n}\n\n.colorpicker-input-addon {\n  padding: 0;\n}\n.colorpicker-input-addon i {\n  height: 100%;\n  width: 100%;\n}\n\n.pickr .pcr-app {\n  z-index: 1035;\n}\n.pickr .pcr-app .pcr-interaction input {\n  padding: .3em .5em;\n  letter-spacing: inherit;\n  border-radius: .25rem;\n  background: #f7f7f7;\n  color: #b5b5b5;\n}\n.pickr .pcr-app .pcr-interaction .pcr-save {\n  background: #298DFF;\n  color: #fff;\n}\n.pickr .pcr-app .pcr-interaction .pcr-clear {\n  background: #FF0000;\n  color: #fff;\n}\n.pickr .pcr-app .pcr-interaction .pcr-type.active {\n  background: #eef6ff;\n  color: #298DFF;\n}\n.pickr .pcr-app .pcr-interaction .pcr-result {\n  color: #262a2e;\n  border: 1px solid #d8d8d8;\n  background: #fff;\n  border-radius: 0.5rem;\n}\n.pickr .pcr-app .pcr-interaction .pcr-result:focus {\n  box-shadow: none;\n  border-color: #298DFF;\n}\n.pickr .pcr-button {\n  width: 100%;\n  border-radius: 0;\n}\n\n@media (max-width: 414px) {\n  .pcr-app {\n    max-width: 310px;\n  }\n}\n/*Range Slider*/\n.irs-line {\n  height: 7px;\n  background: #f7f7f7;\n  border: none;\n}\n\n.irs-bar {\n  height: 7px;\n  border: none;\n  background: #0a2f4c;\n}\n\n.irs-slider {\n  top: 24px;\n  width: 25px;\n  height: 25px;\n  border: none;\n  background: #0a2f4c;\n  border-radius: 50%;\n}\n.irs-slider.state_hover, .irs-slider:hover {\n  background: #0a2f4c;\n}\n\n.irs-bar-edge {\n  height: 7px;\n  top: 33px;\n  width: 14px;\n  border: none;\n  background: #0a2f4c;\n}\n\n.irs-from, .irs-to, .irs-single {\n  font-size: 0.75rem;\n  font-weight: 500;\n  background: #262a2e;\n  line-height: 1.5;\n  padding: .0625rem .5rem;\n  border-radius: 0.5rem;\n}\n\n.irs-min, .irs-max {\n  color: inherit;\n  font-size: 0.75rem;\n  background: none;\n  line-height: 1.5;\n  border-radius: .25rem;\n  -moz-border-radius: .25rem;\n  font-weight: 500;\n}\n\n.irs.irs-sm .irs-line {\n  height: 3px;\n}\n.irs.irs-sm .irs-bar {\n  height: 3px;\n}\n.irs.irs-sm .irs-slider {\n  top: 25px;\n  width: 18px;\n  height: 18px;\n}\n.irs.irs-sm .irs-bar-edge {\n  height: 3px;\n}\n\n/*Daterangepicker*/\n.daterangepicker {\n  font-family: inherit;\n  border-color: #d8d8d8;\n}\n.daterangepicker:before, .daterangepicker:after {\n  display: none;\n}\n.daterangepicker .drp-buttons .btn, .daterangepicker .drp-buttons div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .daterangepicker .drp-buttons .hopscotch-nav-button {\n  margin-left: .5rem;\n  padding: .25rem .5rem;\n  font-size: .875rem;\n  font-weight: 400;\n}\n.daterangepicker td.active, .daterangepicker td.active:hover {\n  background-color: #0a2f4c;\n}\n.daterangepicker td.active.available:hover, .daterangepicker td.active:hover.available:hover {\n  background-color: #0a2f4c;\n}\n.daterangepicker td.in-range {\n  background-color: #ebf5f5;\n  color: #262a2e;\n}\n.daterangepicker td.in-range.active, .daterangepicker td.in-range.active:hover {\n  background-color: #0a2f4c;\n}\n.daterangepicker td.available:hover {\n  background-color: #f7f7f7;\n}\n.daterangepicker th.available:hover {\n  background-color: transparent;\n}\n.daterangepicker .calendar-table th, .daterangepicker .calendar-table td {\n  min-width: 33px;\n  width: 33px;\n  height: 33px;\n  font-size: 0.875rem;\n  position: relative;\n  border: none;\n}\n.daterangepicker .calendar-table th.active, .daterangepicker .calendar-table th.active:hover, .daterangepicker .calendar-table td.active, .daterangepicker .calendar-table td.active:hover {\n  color: #fff;\n}\n.daterangepicker .calendar-table th.active.available:hover, .daterangepicker .calendar-table th.active:hover.available:hover, .daterangepicker .calendar-table td.active.available:hover, .daterangepicker .calendar-table td.active:hover.available:hover {\n  color: #fff;\n}\n.daterangepicker .calendar-table th.next span, .daterangepicker .calendar-table th.prev span {\n  border-color: #b5b5b5;\n}\n.daterangepicker .calendar-table th:hover.next span, .daterangepicker .calendar-table th:hover.prev span {\n  border-color: #262a2e;\n}\n.daterangepicker th.month {\n  width: auto;\n  font-size: 0.875rem;\n  color: #262a2e;\n  letter-spacing: .5px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.daterangepicker .drp-selected {\n  font-size: 0.875rem;\n  padding-right: .25rem;\n  color: #262a2e;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n.daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {\n  color: #d8d8d8;\n}\n.daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {\n  background: #fff;\n  width: 60px;\n  margin: .625rem auto;\n  border: 1px solid #d8d8d8;\n  padding: .25rem;\n  border-radius: .25rem;\n  font-size: 0.875rem;\n  color: #262a2e;\n}\n.daterangepicker select.monthselect, .daterangepicker select.yearselect {\n  background: #fff;\n  border: 1px solid #d8d8d8;\n  padding: .25rem;\n  border-radius: .25rem;\n  font-size: 0.875rem;\n  color: #262a2e;\n}\n.daterangepicker .ranges li {\n  font-size: 0.875rem;\n  padding: .625rem .75rem;\n}\n.daterangepicker .ranges li:hover {\n  background-color: #f7f7f7;\n}\n.daterangepicker .ranges li.active {\n  background-color: #0a2f4c;\n}\n.daterangepicker.show-ranges .drp-calendar.left {\n  border-color: #d8d8d8;\n}\n.daterangepicker .drp-calendar.single .calendar-time {\n  padding-right: 8px;\n}\n\n@media (max-width: 767px) {\n  .daterangepicker {\n    width: 281px;\n  }\n  .daterangepicker.show-ranges .drp-calendar.left {\n    border: none;\n  }\n  .daterangepicker .drp-buttons {\n    text-align: left;\n  }\n  .daterangepicker .drp-buttons .btn, .daterangepicker .drp-buttons div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .daterangepicker .drp-buttons .hopscotch-nav-button {\n    margin-left: 0;\n    margin-right: .5rem;\n  }\n  .daterangepicker .drp-buttons .drp-selected {\n    display: block;\n    margin-bottom: .625rem;\n  }\n  .daterangepicker.ltr .ranges {\n    width: 100%;\n  }\n  .daterangepicker.ltr .ranges ul {\n    width: 100%;\n  }\n  .daterangepicker.ltr .drp-calendar {\n    width: 100%;\n  }\n  .daterangepicker.ltr .drp-calendar.left .calendar-table {\n    padding-right: 0;\n  }\n}\n/*Profile*/\n.profile-wrap .profile-intro {\n  position: relative;\n  z-index: 1;\n  margin-top: -6rem;\n}\n.profile-wrap .profile-img-wrap {\n  height: 10rem;\n  position: relative;\n}\n.profile-wrap .profile-img-wrap > img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n.profile-wrap header.profile-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  background: #fff;\n  border-bottom: 1px solid #d8d8d8;\n  position: relative;\n}\n.profile-wrap header.profile-header .profile-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.profile-wrap header.profile-header .profile-options-wrap > a {\n  margin-left: .5rem;\n  display: inline-block;\n}\n.profile-wrap header.profile-header .profile-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.profile-wrap .comment-block .media .media-head {\n  margin-right: 1rem;\n}\n.profile-wrap .comment-block .media .media-body > div:first-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: .25rem;\n}\n.profile-wrap .comment-block .media .media-body > div:first-child .cm-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.profile-wrap .comment-block .media .media-body > div:first-child .badge {\n  margin-left: .625rem;\n  flex-shrink: 0;\n}\n.profile-wrap .comment-block .media .media-body .comment-action-wrap span, .profile-wrap .comment-block .media .media-body .comment-action-wrap a {\n  color: #6f6f6f;\n  font-size: 0.75rem;\n}\n.profile-wrap .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {\n  margin: 0 .25rem;\n  color: #d8d8d8;\n}\n.profile-wrap .comment-block .media .media-body > .media {\n  margin-top: 1.875rem;\n}\n.profile-wrap .comment-block .media .media-head {\n  margin-right: 1rem;\n}\n.profile-wrap .comment-block .media .media-body > div:first-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: .25rem;\n}\n.profile-wrap .comment-block .media .media-body > div:first-child .cm-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.profile-wrap .comment-block .media .media-body > div:first-child .badge {\n  margin-left: .625rem;\n  flex-shrink: 0;\n}\n.profile-wrap .comment-block .media .media-body .comment-action-wrap span, .profile-wrap .comment-block .media .media-body .comment-action-wrap a {\n  color: #6f6f6f;\n  font-size: 0.75rem;\n}\n.profile-wrap .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {\n  margin: 0 .25rem;\n  color: #d8d8d8;\n}\n.profile-wrap .comment-block .media .media-body > .media {\n  margin-top: 1.875rem;\n}\n.profile-wrap .card.card-profile-feed .btn-pg-link {\n  position: absolute;\n  bottom: 25px;\n  left: 25px;\n}\n.profile-wrap .card.card-profile-feed .feed-img-layout .row {\n  margin-right: -0.25rem;\n  margin-left: -0.25rem;\n}\n.profile-wrap .card.card-profile-feed .feed-img-layout .row > [class*=\"col-\"] {\n  padding-right: .25rem;\n  padding-left: .25rem;\n}\n.profile-wrap .card.card-profile-feed .feed-img-layout .feed-img {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 100%;\n}\n.profile-wrap .card.card-profile-feed .btn-video-link {\n  background: rgba(47, 52, 58, 0.5);\n  height: 45px;\n  width: 45px;\n  position: absolute;\n  border-radius: 50%;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  color: #fff;\n}\n.profile-wrap .card.card-profile-feed .btn-video-link:before {\n  display: inline-block;\n  font: normal normal normal 1.5rem/1 'Material-Design-Iconic-Font';\n  padding-left: .25rem;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  text-rendering: auto;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f3aa\";\n}\n.profile-wrap .card.card-profile-feed .card-footer > div a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #9e9e9e;\n  font-size: .875rem;\n}\n.profile-wrap .card.card-profile-feed .card-footer > div a > i {\n  line-height: 1;\n  margin-right: .5rem;\n}\n.profile-wrap .card.card-profile-feed .card-footer > div:last-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.profile-wrap .card.card-profile-feed .card-footer > div:last-child a {\n  margin-right: .625rem;\n}\n.profile-wrap .card.card-profile-feed .card-footer > div:last-child a:last-child {\n  margin-right: 0;\n}\n\n.edit-profile-wrap .nav-profile .nav-header {\n  font-size: .75rem;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #9e9e9e;\n}\n.edit-profile-wrap .nav-profile .nav {\n  margin: 1rem 0;\n  font-size: .875rem;\n  flex-wrap: nowrap;\n  border: 0;\n}\n.edit-profile-wrap .nav-profile .nav .nav-item {\n  margin-bottom: .25rem;\n}\n.edit-profile-wrap .nav-profile .nav .nav-item:last-child {\n  margin-bottom: 0;\n}\n.edit-profile-wrap .nav-profile .nav .nav-item a.nav-link {\n  color: #262a2e;\n  border: 0;\n  padding: 0;\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.edit-profile-wrap .nav-profile .nav .nav-item a.nav-link:hover, .edit-profile-wrap .nav-profile .nav .nav-item a.nav-link:focus {\n  color: rgba(38, 42, 46, 0.8);\n}\n.edit-profile-wrap .nav-profile .nav .nav-item a.nav-link .active {\n  color: #0a2f4c;\n}\n\n/*Activity*/\n.activity-list .list-group-item {\n  padding: 0;\n  border: none;\n}\n.activity-list .list-group-item .media {\n  position: relative;\n  align-items: inherit;\n}\n.activity-list .list-group-item .media .media-head {\n  position: relative;\n  margin-right: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  min-width: 48px;\n  align-items: center;\n}\n.activity-list .list-group-item .media .media-head > .avatar {\n  flex-shrink: 0;\n}\n.activity-list .list-group-item .media .media-body {\n  padding-bottom: 1.5rem;\n}\n.activity-list .list-group-item .media .media-body .last-activity-time {\n  font-size: 0.75rem;\n  margin-top: .25rem;\n}\n.activity-list .list-group-item.toggle-activity .media .media-body {\n  padding-bottom: 0;\n  display: flex;\n  align-items: center;\n}\n.activity-list .list-group-item:last-child .media .media-head:after {\n  display: none;\n}\n.activity-list.activity-wth-line .list-group-item .media .media-head:after {\n  content: \"\";\n  background: #d8d8d8;\n  width: 2.5px;\n  height: 100%;\n  border-radius: 50rem;\n  margin: .5rem auto;\n  min-height: 25px;\n}\n\n.activity-list-h {\n  flex-direction: row;\n}\n.activity-list-h .list-group-item {\n  padding: 0;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 6.25rem;\n  align-items: center;\n}\n.activity-list-h .list-group-item .media {\n  flex-flow: column;\n  align-items: center;\n  flex: 1;\n}\n.activity-list-h .list-group-item .media .media-body {\n  width: 400px;\n  padding: 0 .625rem;\n  display: flex;\n}\n.activity-list-h .list-group-item .media .media-body .last-activity-time {\n  font-size: 0.75rem;\n  margin-top: .25rem;\n}\n.activity-list-h .list-group-item .media .media-body .card {\n  width: 100%;\n}\n.activity-list-h .list-group-item .media .media-head {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  min-height: 48px;\n  align-items: center;\n  position: absolute;\n  bottom: 45px;\n}\n.activity-list-h .list-group-item .media .media-head:after, .activity-list-h .list-group-item .media .media-head:before {\n  content: \"\";\n  height: 2.5px;\n  background: #d8d8d8;\n  width: 100%;\n  position: absolute;\n  margin: .5rem auto;\n  right: 0;\n  width: 50%;\n  top: 0;\n  bottom: 0;\n  margin: auto 0;\n}\n.activity-list-h .list-group-item .media .media-head:before {\n  left: 0;\n}\n.activity-list-h .list-group-item .media .media-head .avatar {\n  z-index: 1;\n  outline: 7px solid #fff;\n}\n.activity-list-h .list-group-item:first-child .media .media-head:before {\n  display: none;\n}\n.activity-list-h .list-group-item:last-child .media .media-head:after {\n  display: none;\n}\n.activity-list-h .list-group-item .activity-time {\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: .5rem 0;\n  color: #0a2f4c;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n}\n\n.user-activity .media {\n  position: relative;\n  padding-bottom: 1.25rem;\n  margin-left: 1.25rem;\n}\n.user-activity .media .media-head {\n  position: absolute;\n  left: -20px;\n}\n.user-activity .media:after {\n  content: \"\";\n  position: absolute;\n  width: 1px;\n  height: calc(100% - 77px);\n  background: #d8d8d8;\n  top: 60px;\n}\n.user-activity .media .media-body {\n  padding-bottom: 1.875rem;\n  margin-left: 2.5rem;\n  min-width: 0;\n}\n.user-activity .media:last-child .media-body {\n  border-bottom: none;\n}\n.user-activity.user-activity-sm .media {\n  padding-bottom: .625rem;\n  margin-left: 1rem;\n}\n.user-activity.user-activity-sm .media .media-head {\n  left: -16px;\n}\n.user-activity.user-activity-sm .media .media-body {\n  padding-bottom: .625rem;\n  margin-left: 1.875rem;\n}\n\n@media (max-width: 576px) {\n  .user-activity .media .media-body {\n    margin-left: 2.125rem;\n  }\n}\n/*Wizards*/\n.hk-wizard {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-size: 0.875rem;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  font-feature-settings: \"tnum\";\n  display: flex;\n  width: 100%;\n  font-size: 0;\n  text-align: initial;\n}\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] {\n  cursor: pointer;\n}\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-title .hk-wizard-icon,\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-subtitle .hk-wizard-icon,\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-description .hk-wizard-icon,\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button] .hk-wizard-item-icon .hk-wizard-icon {\n  -webkit-transition: color 0.3s;\n  -moz-transition: color 0.3s;\n  transition: color 0.3s;\n}\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-title,\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-subtitle,\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-description {\n  color: #0a2f4c;\n}\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active):not(.hk-wizard-item-process) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-icon {\n  border-color: #0a2f4c;\n}\n.hk-wizard .hk-wizard-item:not(.hk-wizard-item-active):not(.hk-wizard-item-process) > .hk-wizard-item-container[role=button]:hover .hk-wizard-item-icon .hk-wizard-icon {\n  color: #0a2f4c;\n}\n.hk-wizard:not(.hk-wizard-vertical) .hk-wizard-item-custom .hk-wizard-item-icon {\n  width: auto;\n  background: 0 0;\n}\n\n.hk-wizard-item {\n  position: relative;\n  display: inline-block;\n  flex: 1;\n  overflow: hidden;\n  vertical-align: top;\n}\n.hk-wizard-item:last-child {\n  flex: none;\n}\n.hk-wizard-item:last-child > .hk-wizard-item-container > .hk-wizard-item-tail {\n  display: none;\n}\n.hk-wizard-item:last-child > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {\n  display: none;\n}\n\n.hk-wizard-item-container {\n  outline: none;\n}\n\n.hk-wizard-item-icon {\n  display: inline-block;\n  vertical-align: top;\n  width: 32px;\n  height: 32px;\n  margin: 0 .5rem 0 0;\n  font-size: 1rem;\n  line-height: 32px;\n  text-align: center;\n  border: 1px solid #c7c7c7;\n  border-radius: 2rem;\n  transition: background-color .3s, border-color .3s;\n}\n.hk-wizard-item-icon .hk-wizard-icon {\n  position: relative;\n  top: -.5px;\n  color: #0a2f4c;\n}\n\n.hk-wizard-item-content {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.hk-wizard-item-tail {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  width: 100%;\n  padding: 0 .625rem;\n}\n.hk-wizard-item-tail:after {\n  display: inline-block;\n  width: 100%;\n  height: 1px;\n  background: #d8d8d8;\n  border-radius: 1px;\n  -webkit-transition: background 0.3s;\n  -moz-transition: background 0.3s;\n  transition: background 0.3s;\n  content: \"\";\n}\n\n.hk-wizard-item-title {\n  position: relative;\n  display: inline-block;\n  padding-right: 1rem;\n  font-size: 1rem;\n  line-height: 32px;\n  color: #262a2e;\n}\n.hk-wizard-item-title:after {\n  position: absolute;\n  top: 16px;\n  left: 100%;\n  display: block;\n  width: 9999px;\n  height: 1px;\n  background: #d8d8d8;\n  content: \"\";\n}\n\n.hk-wizard-item-subtitle {\n  display: inline;\n  margin-left: .5rem;\n  font-weight: 400;\n  font-size: 0.875rem;\n}\n\n.hk-wizard-item-description {\n  font-size: 0.875rem;\n}\n\n.hk-wizard-item-wait > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {\n  color: #6f6f6f;\n}\n.hk-wizard-item-wait .hk-wizard-item-icon {\n  background-color: #fff;\n  border-color: #c7c7c7;\n}\n.hk-wizard-item-wait .hk-wizard-item-icon > .hk-wizard-icon {\n  color: #c7c7c7;\n}\n.hk-wizard-item-wait .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {\n  background: #c7c7c7;\n}\n.hk-wizard-item-wait > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {\n  background-color: #d8d8d8;\n}\n.hk-wizard-item-wait > .hk-wizard-item-container > .hk-wizard-item-tail:after {\n  background-color: #d8d8d8;\n}\n\n.hk-wizard-item-process .hk-wizard-item-icon {\n  background-color: #fff;\n  border-color: #0a2f4c;\n}\n.hk-wizard-item-process .hk-wizard-item-icon > .hk-wizard-icon {\n  color: #0a2f4c;\n}\n.hk-wizard-item-process .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {\n  background: #0a2f4c;\n}\n.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {\n  color: #262a2e;\n}\n.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {\n  background-color: #d8d8d8;\n}\n.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-description {\n  color: #262a2e;\n}\n.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-tail:after {\n  background-color: #d8d8d8;\n}\n.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-icon {\n  background: #0a2f4c;\n}\n.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-icon .hk-wizard-icon {\n  color: #fff;\n}\n.hk-wizard-item-process > .hk-wizard-item-container > .hk-wizard-item-title {\n  font-weight: 500;\n}\n\n.hk-wizard-item-finish .hk-wizard-item-icon {\n  background-color: #fff;\n  border-color: #0a2f4c;\n}\n.hk-wizard-item-finish .hk-wizard-item-icon > .hk-wizard-icon {\n  color: #0a2f4c;\n}\n.hk-wizard-item-finish .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {\n  background: #0a2f4c;\n}\n.hk-wizard-item-finish > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {\n  color: #262a2e;\n}\n.hk-wizard-item-finish > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {\n  background-color: #0a2f4c;\n}\n.hk-wizard-item-finish > .hk-wizard-item-container > .hk-wizard-item-tail:after {\n  background-color: #0a2f4c;\n}\n\n.hk-wizard-item-error .hk-wizard-item-icon {\n  background-color: #fff;\n  border-color: #FF0000;\n}\n.hk-wizard-item-error .hk-wizard-item-icon > .hk-wizard-icon {\n  color: #FF0000;\n}\n.hk-wizard-item-error .hk-wizard-item-icon > .hk-wizard-icon .hk-wizard-icon-dot {\n  background: #FF0000;\n}\n.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title {\n  color: #FF0000;\n}\n.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {\n  background-color: #d8d8d8;\n}\n.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-description {\n  color: #FF0000;\n}\n.hk-wizard-item-error > .hk-wizard-item-container > .hk-wizard-item-tail:after {\n  background-color: #d8d8d8;\n}\n\n.hk-wizard-item.hk-wizard-next-error .hk-wizard-item-title:after {\n  background: #FF0000;\n}\n\n.hk-wizard-item-disabled {\n  cursor: not-allowed;\n}\n\n.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item {\n  padding-left: 1rem;\n  white-space: nowrap;\n}\n.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item:first-child {\n  padding-left: 0;\n}\n.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item:last-child .hk-wizard-item-title {\n  padding-right: 0;\n}\n.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item-tail {\n  display: none;\n}\n.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item-description {\n  max-width: 140px;\n  white-space: normal;\n}\n\n.hk-wizard-item-custom > .hk-wizard-item-container > .hk-wizard-item-icon {\n  height: auto;\n  background: 0 0;\n  border: 0;\n}\n.hk-wizard-item-custom > .hk-wizard-item-container > .hk-wizard-item-icon > .hk-wizard-icon {\n  top: 0;\n  left: .5px;\n  width: 32px;\n  height: 32px;\n  font-size: 1.5rem;\n  line-height: 32px;\n}\n\n.hk-wizard-item-custom.hk-wizard-item-process .hk-wizard-item-icon > .hk-wizard-icon {\n  color: #0a2f4c;\n}\n\n.hk-wizard-sm.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item {\n  padding-left: .75rem;\n}\n.hk-wizard-sm.hk-wizard-horizontal:not(.hk-wizard-label-vertical) .hk-wizard-item:first-child {\n  padding-left: 0;\n}\n\n.hk-wizard-sm .hk-wizard-item-icon {\n  width: 24px;\n  height: 24px;\n  margin: 0 .5rem 0 0;\n  font-size: 0.75rem;\n  line-height: 24px;\n  text-align: center;\n  border-radius: 1.5rem;\n}\n.hk-wizard-sm .hk-wizard-item-title {\n  padding-right: .75rem;\n  font-size: 0.875rem;\n  line-height: 24px;\n}\n.hk-wizard-sm .hk-wizard-item-title:after {\n  top: 12px;\n}\n.hk-wizard-sm .hk-wizard-item-description {\n  font-size: 0.875rem;\n}\n.hk-wizard-sm .hk-wizard-item-tail {\n  top: 8px;\n}\n.hk-wizard-sm .hk-wizard-item-custom .hk-wizard-item-icon {\n  width: inherit;\n  height: inherit;\n  line-height: inherit;\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n}\n.hk-wizard-sm .hk-wizard-item-custom .hk-wizard-item-icon > .hk-wizard-icon {\n  font-size: 1.5rem;\n  line-height: 24px;\n  transform: none;\n}\n\n.hk-wizard-vertical {\n  display: flex;\n  flex-direction: column;\n}\n.hk-wizard-vertical > .hk-wizard-item {\n  display: block;\n  flex: 1 0 auto;\n  padding-left: 0;\n  overflow: visible;\n}\n.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-icon {\n  float: left;\n  margin-right: 1rem;\n}\n.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-content {\n  display: block;\n  min-height: 48px;\n  overflow: hidden;\n}\n.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-title {\n  line-height: 32px;\n}\n.hk-wizard-vertical > .hk-wizard-item .hk-wizard-item-description {\n  padding-bottom: .75rem;\n}\n.hk-wizard-vertical > .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-tail {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  width: 1px;\n  height: 100%;\n  padding: 2.375rem 0 .375rem;\n}\n.hk-wizard-vertical > .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-tail:after {\n  width: 1px;\n  height: 100%;\n}\n.hk-wizard-vertical > .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-content > .hk-wizard-item-title:after {\n  display: none;\n}\n.hk-wizard-vertical > .hk-wizard-item:not(:last-child) > .hk-wizard-item-container > .hk-wizard-item-tail {\n  display: block;\n}\n\n.hk-wizard-vertical.hk-wizard-sm .hk-wizard-item-container .hk-wizard-item-tail {\n  position: absolute;\n  top: 0;\n  left: 12px;\n  padding: 1.875rem 0 .375rem;\n}\n.hk-wizard-vertical.hk-wizard-sm .hk-wizard-item-container .hk-wizard-item-title {\n  line-height: 24px;\n}\n\n.hk-wizard-label-vertical .hk-wizard-item {\n  overflow: visible;\n}\n.hk-wizard-label-vertical .hk-wizard-item-tail {\n  margin-left: 3.625rem;\n  padding: .25rem 1.5rem;\n}\n.hk-wizard-label-vertical .hk-wizard-item-content {\n  display: block;\n  width: 116px;\n  margin-top: .5rem;\n  text-align: center;\n}\n.hk-wizard-label-vertical .hk-wizard-item-icon {\n  display: inline-block;\n  margin-left: 2.625rem;\n}\n.hk-wizard-label-vertical .hk-wizard-item-title {\n  padding-right: 0;\n  padding-left: 0;\n}\n.hk-wizard-label-vertical .hk-wizard-item-title:after {\n  display: none;\n}\n.hk-wizard-label-vertical .hk-wizard-item-subtitle {\n  display: block;\n  margin-bottom: 4px;\n  margin-left: 0;\n  line-height: 1.5715;\n}\n\n.hk-wizard-label-vertical.hk-wizard-sm:not(.hk-wizard-dot) .hk-wizard-item-icon {\n  margin-left: 2.875rem;\n}\n\n.hk-wizard-dot .hk-wizard-item-title {\n  line-height: 1.5715;\n}\n.hk-wizard-dot .hk-wizard-item-tail {\n  top: 2px;\n  width: 100%;\n  margin: 0 0 0 4.375rem;\n  padding: 0;\n}\n.hk-wizard-dot .hk-wizard-item-tail:after {\n  width: calc(100% - 20px);\n  height: 3px;\n  margin-left: .75rem;\n}\n.hk-wizard-dot .hk-wizard-item:first-child .hk-wizard-icon-dot {\n  left: 2px;\n}\n.hk-wizard-dot .hk-wizard-item-icon {\n  width: 8px;\n  height: 8px;\n  margin-left: 4.25rem;\n  padding-right: 0;\n  line-height: 8px;\n  background: 0 0;\n  border: 0;\n}\n.hk-wizard-dot .hk-wizard-item-icon .hk-wizard-icon-dot {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 6.25rem;\n  transition: all .3s;\n}\n.hk-wizard-dot .hk-wizard-item-icon .hk-wizard-icon-dot:after {\n  position: absolute;\n  top: -12px;\n  left: -26px;\n  width: 60px;\n  height: 32px;\n  content: \"\";\n}\n.hk-wizard-dot .hk-wizard-item-content {\n  width: 140px;\n}\n.hk-wizard-dot .hk-wizard-item-process .hk-wizard-item-icon {\n  position: relative;\n  top: -1px;\n  width: 10px;\n  height: 10px;\n  line-height: 10px;\n  background: 0 0;\n}\n.hk-wizard-dot .hk-wizard-item-process .hk-wizard-icon:first-child .hk-wizard-icon-dot {\n  left: 0;\n}\n\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-title {\n  line-height: 1.5715;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-tail {\n  top: 2px;\n  width: 100%;\n  margin: 0 0 0 4.375rem;\n  padding: 0;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-tail:after {\n  width: calc(100% - 20px);\n  height: 3px;\n  margin-left: .75rem;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item:first-child .hk-wizard-icon-dot {\n  left: 2px;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-icon {\n  width: 8px;\n  height: 8px;\n  margin-left: 4.25rem;\n  padding-right: 0;\n  line-height: 8px;\n  background: 0 0;\n  border: 0;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-icon .hk-wizard-icon-dot {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 6.25rem;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-icon .hk-wizard-icon-dot:after {\n  position: absolute;\n  top: -12px;\n  left: -26px;\n  width: 60px;\n  height: 32px;\n  content: \"\";\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-content {\n  width: 140px;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-process .hk-wizard-item-icon {\n  position: relative;\n  top: -1px;\n  width: 10px;\n  height: 10px;\n  line-height: 10px;\n  background: 0 0;\n}\n.hk-wizard-dot.hk-wizard-sm .hk-wizard-item-process .hk-wizard-icon:first-child .hk-wizard-icon-dot {\n  left: 0;\n}\n\n.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item-icon {\n  margin-top: .75rem;\n  margin-left: 0;\n  background: 0 0;\n}\n.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item > .hk-wizard-item-container > .hk-wizard-item-tail {\n  top: 6.5px;\n  left: -9px;\n  margin: 0;\n  padding: 1.375rem 0 .25rem;\n}\n.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item:first-child .hk-wizard-icon-dot {\n  left: 0;\n}\n.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item-content {\n  width: inherit;\n}\n.hk-wizard-vertical.hk-wizard-dot .hk-wizard-item-process .hk-wizard-item-container .hk-wizard-item-icon .hk-wizard-icon-dot {\n  top: -1px;\n  left: -1px;\n}\n\n/*Pricing Table*/\n.hk-pricing-table-1 .table th {\n  font-size: 1rem;\n  white-space: inherit !important;\n}\n.hk-pricing-table-1 .table thead tr th h5 {\n  padding: .75rem 1.25rem;\n  margin: 0 -1.25rem;\n  border-bottom: 1px solid #d8d8d8;\n}\n.hk-pricing-table-1 .table thead tr th.pricing-highlighted h5 {\n  background: #0a2f4c;\n  color: #fff;\n}\n.hk-pricing-table-1 .table tbody .monthly-price {\n  text-align: center;\n}\n.hk-pricing-table-1 .table tbody .monthly-price .money {\n  display: inline-block;\n  vertical-align: top;\n  padding-top: 1rem;\n}\n.hk-pricing-table-1 .table tbody .monthly-price .price sup {\n  display: inline-block;\n  vertical-align: top;\n  padding-top: 1.5rem;\n  font-size: 1.125rem;\n}\n.hk-pricing-table-1 .table tbody .monthly-price .price .price-number {\n  font-size: 3.3rem;\n  font-weight: 500;\n}\n.hk-pricing-table-1 .table tbody .monthly-price .duration {\n  position: relative;\n  top: 10px;\n}\n\n.hk-pricing-table-2 .table-responsive {\n  padding-top: 3.125rem;\n}\n.hk-pricing-table-2 .table th {\n  font-size: 1rem;\n  white-space: inherit !important;\n}\n.hk-pricing-table-2 .table .pricing-highlighted {\n  background: rgba(0, 125, 136, 0.15);\n}\n.hk-pricing-table-2 .table thead tr th {\n  position: relative;\n}\n.hk-pricing-table-2 .table thead tr th.pricing-highlighted h5 {\n  padding: .75rem 1.25rem;\n  top: -47px;\n  position: absolute;\n  border-bottom: 1px solid #d8d8d8;\n  background: #0a2f4c;\n  color: #fff;\n  left: -1px;\n  right: -1px;\n}\n.hk-pricing-table-2 .table tbody .monthly-price {\n  text-align: center;\n}\n.hk-pricing-table-2 .table tbody .monthly-price .money {\n  display: inline-block;\n  vertical-align: top;\n  padding-top: 1rem;\n}\n.hk-pricing-table-2 .table tbody .monthly-price .price sup {\n  display: inline-block;\n  vertical-align: top;\n  padding-top: 1.5rem;\n  font-size: 1.125rem;\n}\n.hk-pricing-table-2 .table tbody .monthly-price .price .price-number {\n  font-size: 3.3rem;\n  font-weight: 500;\n}\n.hk-pricing-table-2 .table tbody .monthly-price .duration {\n  position: relative;\n  top: 10px;\n}\n\n.hk-pricing-table-3 {\n  text-align: center;\n}\n.hk-pricing-table-3 .table-responsive {\n  padding-top: 3.125rem;\n}\n.hk-pricing-table-3 .table th {\n  font-size: 1rem;\n  white-space: inherit !important;\n}\n.hk-pricing-table-3 .table th .icon-wrap {\n  margin-top: 1.5rem;\n  font-size: 2.5rem;\n}\n.hk-pricing-table-3 .table tbody .monthly-price .money {\n  display: inline-block;\n  vertical-align: top;\n  padding-top: 1rem;\n}\n.hk-pricing-table-3 .table tbody .monthly-price .price sup {\n  display: inline-block;\n  vertical-align: top;\n  padding-top: 1.5rem;\n  font-size: 1.125rem;\n}\n.hk-pricing-table-3 .table tbody .monthly-price .price .price-number {\n  font-size: 2.6rem;\n  font-weight: 500;\n}\n.hk-pricing-table-3 .table tbody .monthly-price .duration {\n  display: inline-block;\n  vertical-align: top;\n  padding-top: 1.125rem;\n}\n\n/*Dropdown*/\n.dropdown-toggle.no-caret:after {\n  display: none;\n}\n.dropdown-toggle:after {\n  content: '\\f2f9';\n  font: normal normal normal 1rem/1 'Material-Design-Iconic-Font';\n  border: none !important;\n  vertical-align: 0 !important;\n  margin-left: .4em;\n}\n.dropdown-toggle.dropdown-toggle-split:after, .dropdown-toggle.dropdown-toggle-split:before {\n  margin: 0 !important;\n}\n\n.dropup .dropdown-toggle::after {\n  content: '\\f2fc';\n  margin-left: .4em;\n}\n\n.dropstart .dropdown-toggle::before {\n  content: '\\f2fa';\n  vertical-align: 0 !important;\n  font: normal normal normal 1rem/1 'Material-Design-Iconic-Font';\n  border: none !important;\n  margin-right: .4em;\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n\n.dropend .dropdown-toggle::after {\n  content: '\\f2fb';\n  vertical-align: 0;\n  margin-left: .4em;\n}\n\n.btn.btn-lg.dropdown-toggle:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.dropdown-toggle.hopscotch-nav-button:after, .btn.btn-lg.dropdown-toggle:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-lg.dropdown-toggle.hopscotch-nav-button:before, .btn.btn-sm.dropdown-toggle:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .dropdown-toggle.hopscotch-nav-button:after, .btn.btn-sm.dropdown-toggle:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .dropdown-toggle.hopscotch-nav-button:before, .btn.btn-xs.dropdown-toggle:after, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.dropdown-toggle.hopscotch-nav-button:after, .btn.btn-xs.dropdown-toggle:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-xs.dropdown-toggle.hopscotch-nav-button:before {\n  font-size: inherit;\n}\n\n.dropdown-menu, .apexcharts-toolbar .apexcharts-menu {\n  color: #6f6f6f;\n  border: none;\n  border-radius: 0.5rem;\n  padding: .5rem;\n  box-shadow: 0px 6px 16px rgba(47, 52, 58, 0.1);\n}\n.dropdown-menu .dropdown-item-text, .apexcharts-toolbar .apexcharts-menu .dropdown-item-text {\n  color: #6f6f6f;\n  padding: .5rem .75rem;\n}\n.dropdown-menu .dropdown-header, .apexcharts-toolbar .apexcharts-menu .dropdown-header {\n  color: #9e9e9e;\n  padding: .5rem .75rem;\n  font-weight: 500;\n}\n.dropdown-menu .dropdown-header.dropdown-header-bold, .apexcharts-toolbar .apexcharts-menu .dropdown-header.dropdown-header-bold {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.dropdown-menu .dropdown-header.header-wth-bg, .apexcharts-toolbar .apexcharts-menu .dropdown-header.header-wth-bg {\n  background: #262a2e;\n  color: #fff;\n  margin-top: -.5rem;\n  margin-left: -.5rem;\n  margin-right: -.5rem;\n  margin-bottom: .5rem;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n  padding-top: .8rem;\n  padding-bottom: .8rem;\n}\n.dropdown-menu.dropdown-bordered, .apexcharts-toolbar .dropdown-bordered.apexcharts-menu {\n  border: 1px solid #d8d8d8;\n  box-shadow: none;\n}\n.dropdown-menu.dropdown-menu-icon-text .dropdown-item .dropdown-item-text, .apexcharts-toolbar .dropdown-menu-icon-text.apexcharts-menu .dropdown-item .dropdown-item-text {\n  padding: 0;\n}\n.dropdown-menu.dropdown-menu-avatar .dropdown-item, .apexcharts-toolbar .dropdown-menu-avatar.apexcharts-menu .dropdown-item {\n  padding-top: .3rem;\n  padding-bottom: .3rem;\n}\n.dropdown-menu.dropdown-menu-avatar .dropdown-item .dropdown-item-text, .apexcharts-toolbar .dropdown-menu-avatar.apexcharts-menu .dropdown-item .dropdown-item-text {\n  padding: 0;\n}\n.dropdown-menu.dropdown-menu-avatar .dropdown-item .avatar, .apexcharts-toolbar .dropdown-menu-avatar.apexcharts-menu .dropdown-item .avatar {\n  margin-right: 1rem;\n}\n.dropdown-menu .dropdown-item, .apexcharts-toolbar .apexcharts-menu .dropdown-item {\n  color: #262a2e;\n  cursor: pointer;\n  border-radius: .25rem;\n  padding: .25rem .75rem;\n}\n.dropdown-menu .dropdown-item .dropdown-icon, .apexcharts-toolbar .apexcharts-menu .dropdown-item .dropdown-icon {\n  font-size: 1.125rem;\n  margin-right: .625rem;\n  width: 21px;\n  position: relative;\n  top: 2px;\n}\n.dropdown-menu .dropdown-item .dropdown-icon.feather-icon, .apexcharts-toolbar .apexcharts-menu .dropdown-item .dropdown-icon.feather-icon, .dropdown-menu .dropdown-item .dropdown-icon .svg-icon, .apexcharts-toolbar .apexcharts-menu .dropdown-item .dropdown-icon .svg-icon {\n  top: -2px;\n}\n.dropdown-menu .dropdown-item.active, .apexcharts-toolbar .apexcharts-menu .dropdown-item.active, .dropdown-menu .dropdown-item:active, .apexcharts-toolbar .apexcharts-menu .dropdown-item:active {\n  background-color: #0a2f4c;\n  color: #fff;\n}\n.dropdown-menu .dropdown-item:focus:not(.active):not(.disabled), .apexcharts-toolbar .apexcharts-menu .dropdown-item:focus:not(.active):not(.disabled), .dropdown-menu .dropdown-item:hover:not(.active):not(.disabled), .apexcharts-toolbar .apexcharts-menu .dropdown-item:hover:not(.active):not(.disabled) {\n  background-color: #f7f7f7;\n  color: #262a2e;\n}\n.dropdown-menu .dropdown-item:disabled, .apexcharts-toolbar .apexcharts-menu .dropdown-item:disabled, .dropdown-menu .dropdown-item.disabled, .apexcharts-toolbar .apexcharts-menu .dropdown-item.disabled {\n  color: #b5b5b5;\n  background-color: transparent;\n}\n.dropdown-menu .sub-dropdown-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu {\n  position: relative;\n}\n.dropdown-menu .sub-dropdown-menu .dropdown-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .apexcharts-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .apexcharts-menu {\n  top: 0;\n}\n.dropdown-menu .sub-dropdown-menu .dropdown-menu:before, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu:before, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .apexcharts-menu:before, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .apexcharts-menu:before, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .apexcharts-menu:before, .dropdown-menu .sub-dropdown-menu .dropdown-menu:after, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu:after, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .apexcharts-menu:after, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .apexcharts-menu:after, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .apexcharts-menu:after {\n  display: none !important;\n}\n.dropdown-menu .sub-dropdown-menu .dropdown-menu.open-left-side, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu.open-left-side, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .open-left-side.apexcharts-menu, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .open-left-side.apexcharts-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .open-left-side.apexcharts-menu {\n  right: 100% !important;\n  left: auto !important;\n}\n.dropdown-menu .sub-dropdown-menu .dropdown-menu.open-right-side, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .dropdown-menu.open-right-side, .dropdown-menu .sub-dropdown-menu .apexcharts-toolbar .open-right-side.apexcharts-menu, .apexcharts-toolbar .dropdown-menu .sub-dropdown-menu .open-right-side.apexcharts-menu, .apexcharts-toolbar .apexcharts-menu .sub-dropdown-menu .open-right-side.apexcharts-menu {\n  left: 100% !important;\n}\n.dropdown-menu.dropdown-menu-dark, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu {\n  background: #262a2e;\n  border-color: #262a2e;\n  color: #fff;\n}\n.dropdown-menu.dropdown-menu-dark .dropdown-header, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-header,\n.dropdown-menu.dropdown-menu-dark .dropdown-item-text,\n.apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item-text {\n  color: #6f6f6f;\n}\n.dropdown-menu.dropdown-menu-dark .dropdown-item, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item {\n  color: #eaeaea;\n}\n.dropdown-menu.dropdown-menu-dark .dropdown-item:focus:not(.active):not(.disabled), .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:focus:not(.active):not(.disabled), .dropdown-menu.dropdown-menu-dark .dropdown-item:hover:not(.active):not(.disabled), .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:hover:not(.active):not(.disabled) {\n  background-color: #4f4f4f;\n  color: #fff;\n}\n.dropdown-menu.dropdown-menu-dark .dropdown-item.active, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item.active, .dropdown-menu.dropdown-menu-dark .dropdown-item:active, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:active {\n  color: #fff;\n}\n.dropdown-menu.dropdown-menu-dark .dropdown-item:disabled, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item:disabled, .dropdown-menu.dropdown-menu-dark .dropdown-item.disabled, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-item.disabled {\n  color: #5f5f5f;\n}\n.dropdown-menu.dropdown-menu-dark .dropdown-divider, .apexcharts-toolbar .dropdown-menu-dark.apexcharts-menu .dropdown-divider {\n  border-color: #262a2e;\n}\n\n.dropdown-menu-active {\n  position: absolute; \n  inset: 0px auto auto 0px; \n  margin: 0px; \n  transform: translate(0px, 33px);\n}\n\n.dropdown-divider {\n  border-color: #eaeaea;\n  margin-right: -.5rem;\n  margin-left: -.5rem;\n}\n\n.show-on-hover:hover > .dropdown-menu, .apexcharts-toolbar .show-on-hover:hover > .apexcharts-menu {\n  display: block;\n}\n.show-on-hover > .dropdown-toggle:active {\n  pointer-events: none;\n}\n\n.dropdown-menu.animated, .apexcharts-toolbar .animated.apexcharts-menu {\n  -webkit-animation-duration: 0.55s;\n  animation-duration: 0.55s;\n  -webkit-animation-timing-function: ease;\n  animation-timing-function: ease;\n}\n\n.custom-caret svg {\n  height: 19px;\n  width: 19px;\n}\n\n.btn-sm .custom-caret svg, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button .custom-caret svg {\n  height: 17px;\n  width: 17px;\n}\n\n.btn-group-lg > .btn + .dropdown-toggle-split, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-lg > .hopscotch-nav-button + .dropdown-toggle-split,\n.btn-lg + .dropdown-toggle-split {\n  padding-right: 1.3rem;\n  padding-left: 1.3rem;\n}\n\n.btn-group-sm > .btn + .dropdown-toggle-split, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-group-sm > .hopscotch-nav-button + .dropdown-toggle-split,\n.btn-sm + .dropdown-toggle-split,\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button + .dropdown-toggle-split {\n  padding-right: .8rem;\n  padding-left: .8rem;\n}\n\n/*Avatar*/\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 4rem;\n  height: 4rem;\n  vertical-align: middle;\n  background-color: transparent;\n}\n.avatar .avatar-img,\n.avatar .initial-wrap {\n  width: 100%;\n  height: 100%;\n  border-radius: 0.5rem;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.avatar > .initial-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n.avatar.avatar-rounded .avatar-img,\n.avatar.avatar-rounded .initial-wrap {\n  border-radius: 50%;\n}\n.avatar.avatar-square .avatar-img,\n.avatar.avatar-square .initial-wrap {\n  border-radius: 0;\n}\n.avatar.avatar-xxxl {\n  width: 9rem;\n  height: 9rem;\n}\n.avatar.avatar-xxxl > .initial-wrap {\n  font-size: 2.25rem;\n}\n.avatar.avatar-xxl {\n  width: 8rem;\n  height: 8rem;\n}\n.avatar.avatar-xxl > .initial-wrap {\n  font-size: 2rem;\n}\n.avatar.avatar-xl {\n  width: 7rem;\n  height: 7rem;\n}\n.avatar.avatar-xl > .initial-wrap {\n  font-size: 1.75rem;\n}\n.avatar.avatar-lg {\n  width: 6rem;\n  height: 6rem;\n}\n.avatar.avatar-lg > .initial-wrap {\n  font-size: 1.5rem;\n}\n.avatar.avatar-md {\n  width: 5rem;\n  height: 5rem;\n}\n.avatar.avatar-md > .initial-wrap {\n  font-size: 1.25rem;\n}\n.avatar.avatar-sm {\n  width: 3rem;\n  height: 3rem;\n}\n.avatar.avatar-sm > .initial-wrap {\n  font-size: 1rem;\n}\n.avatar.avatar-xs {\n  width: 2rem;\n  height: 2rem;\n}\n.avatar.avatar-xs > .initial-wrap {\n  font-size: 0.75rem;\n}\n.avatar.avatar-xxs {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.avatar.avatar-xxs > .initial-wrap {\n  font-size: 0.6rem;\n}\n.avatar.avatar-icon > .initial-wrap {\n  font-size: 1.5rem;\n  font-weight: inherit;\n}\n.avatar.avatar-icon.avatar-xxxl > .initial-wrap {\n  font-size: 2.75rem;\n}\n.avatar.avatar-icon.avatar-xxl > .initial-wrap {\n  font-size: 2.5rem;\n}\n.avatar.avatar-icon.avatar-xl > .initial-wrap {\n  font-size: 2.25rem;\n}\n.avatar.avatar-icon.avatar-lg > .initial-wrap {\n  font-size: 2rem;\n}\n.avatar.avatar-icon.avatar-md > .initial-wrap {\n  font-size: 1.75rem;\n}\n.avatar.avatar-icon.avatar-sm > .initial-wrap {\n  font-size: 1.25rem;\n}\n.avatar.avatar-icon.avatar-xs > .initial-wrap {\n  font-size: 1.25rem;\n}\n.avatar.avatar-icon.avatar-xxs > .initial-wrap {\n  font-size: 1rem;\n}\n.avatar.avatar-logo > .initial-wrap {\n  background: #f7f7f7;\n}\n.avatar.avatar-logo > .initial-wrap > img {\n  height: 50%;\n}\n.avatar.avatar-cyan > .initial-wrap {\n  background-color: #18DDEF !important;\n  color: #fff;\n}\n.avatar.avatar-info > .initial-wrap {\n  background-color: #18DDEF !important;\n  color: #fff;\n}\n.avatar.avatar-sky > .initial-wrap {\n  background-color: #00B0FF !important;\n  color: #fff;\n}\n.avatar.avatar-green > .initial-wrap {\n  background-color: #00D67F !important;\n  color: #fff;\n}\n.avatar.avatar-success > .initial-wrap {\n  background-color: #00D67F !important;\n  color: #fff;\n}\n.avatar.avatar-red > .initial-wrap {\n  background-color: #FF0000 !important;\n  color: #fff;\n}\n.avatar.avatar-danger > .initial-wrap {\n  background-color: #FF0000 !important;\n  color: #fff;\n}\n.avatar.avatar-yellow > .initial-wrap {\n  background-color: #FFC400 !important;\n  color: #fff;\n}\n.avatar.avatar-warning > .initial-wrap {\n  background-color: #FFC400 !important;\n  color: #fff;\n}\n.avatar.avatar-pink > .initial-wrap {\n  background-color: #E92990 !important;\n  color: #fff;\n}\n.avatar.avatar-purple > .initial-wrap {\n  background-color: #C02FF3 !important;\n  color: #fff;\n}\n.avatar.avatar-violet > .initial-wrap {\n  background-color: #7429F8 !important;\n  color: #fff;\n}\n.avatar.avatar-indigo > .initial-wrap {\n  background-color: #0069F7 !important;\n  color: #fff;\n}\n.avatar.avatar-blue > .initial-wrap {\n  background-color: #298DFF !important;\n  color: #fff;\n}\n.avatar.avatar-primary > .initial-wrap {\n  background-color: #0a2f4c !important;\n  color: #fff;\n}\n.avatar.avatar-teal > .initial-wrap {\n  background-color: #0a2f4c !important;\n  color: #fff;\n}\n.avatar.avatar-neon > .initial-wrap {\n  background-color: #81E230 !important;\n  color: #fff;\n}\n.avatar.avatar-lime > .initial-wrap {\n  background-color: #C2E939 !important;\n  color: #fff;\n}\n.avatar.avatar-sun > .initial-wrap {\n  background-color: #FFEA00 !important;\n  color: #262a2e;\n}\n.avatar.avatar-orange > .initial-wrap {\n  background-color: #FF9100 !important;\n  color: #fff;\n}\n.avatar.avatar-pumpkin > .initial-wrap {\n  background-color: #FF5700 !important;\n  color: #fff;\n}\n.avatar.avatar-brown > .initial-wrap {\n  background-color: #954D15 !important;\n  color: #fff;\n}\n.avatar.avatar-gold > .initial-wrap {\n  background-color: #C39749 !important;\n  color: #fff;\n}\n.avatar.avatar-dark > .initial-wrap {\n  background-color: #262a2e !important;\n  color: #fff;\n}\n.avatar.avatar-light > .initial-wrap {\n  background-color: #eaeaea !important;\n  color: #262a2e;\n}\n.avatar.avatar-grey > .initial-wrap {\n  background-color: #9e9e9e !important;\n  color: #fff;\n}\n.avatar.avatar-secondary > .initial-wrap {\n  background-color: #6f6f6f !important;\n  color: #fff;\n}\n.avatar.avatar-soft-cyan > .initial-wrap {\n  background-color: #edfcfe !important;\n  color: #18DDEF;\n}\n.avatar.avatar-soft-info > .initial-wrap {\n  background-color: #edfcfe !important;\n  color: #18DDEF;\n}\n.avatar.avatar-soft-sky > .initial-wrap {\n  background-color: #ebf9ff !important;\n  color: #00B0FF;\n}\n.avatar.avatar-soft-green > .initial-wrap {\n  background-color: #ebfcf5 !important;\n  color: #00D67F;\n}\n.avatar.avatar-soft-success > .initial-wrap {\n  background-color: #ebfcf5 !important;\n  color: #00D67F;\n}\n.avatar.avatar-soft-red > .initial-wrap {\n  background-color: #ffebeb !important;\n  color: #FF0000;\n}\n.avatar.avatar-soft-danger > .initial-wrap {\n  background-color: #ffebeb !important;\n  color: #FF0000;\n}\n.avatar.avatar-soft-yellow > .initial-wrap {\n  background-color: #fffaeb !important;\n  color: #FFC400;\n}\n.avatar.avatar-soft-warning > .initial-wrap {\n  background-color: #fffaeb !important;\n  color: #FFC400;\n}\n.avatar.avatar-soft-pink > .initial-wrap {\n  background-color: #fdeef6 !important;\n  color: #E92990;\n}\n.avatar.avatar-soft-purple > .initial-wrap {\n  background-color: #faeefe !important;\n  color: #C02FF3;\n}\n.avatar.avatar-soft-violet > .initial-wrap {\n  background-color: #f4eefe !important;\n  color: #7429F8;\n}\n.avatar.avatar-soft-indigo > .initial-wrap {\n  background-color: #ebf3fe !important;\n  color: #0069F7;\n}\n.avatar.avatar-soft-blue > .initial-wrap {\n  background-color: #eef6ff !important;\n  color: #298DFF;\n}\n.avatar.avatar-soft-primary > .initial-wrap {\n  background-color: #ebf5f5 !important;\n  color: #0a2f4c;\n}\n.avatar.avatar-soft-teal > .initial-wrap {\n  background-color: #ebf5f5 !important;\n  color: #0a2f4c;\n}\n.avatar.avatar-soft-neon > .initial-wrap {\n  background-color: #f5fdee !important;\n  color: #81E230;\n}\n.avatar.avatar-soft-lime > .initial-wrap {\n  background-color: #fafdef !important;\n  color: #C2E939;\n}\n.avatar.avatar-soft-sun > .initial-wrap {\n  background-color: #fffdeb !important;\n  color: #FFEA00;\n}\n.avatar.avatar-soft-orange > .initial-wrap {\n  background-color: #fff6eb !important;\n  color: #FF9100;\n}\n.avatar.avatar-soft-pumpkin > .initial-wrap {\n  background-color: #fff2eb !important;\n  color: #FF5700;\n}\n.avatar.avatar-soft-brown > .initial-wrap {\n  background-color: #f7f1ec !important;\n  color: #954D15;\n}\n.avatar.avatar-soft-gold > .initial-wrap {\n  background-color: #faf7f0 !important;\n  color: #C39749;\n}\n.avatar.avatar-soft-dark > .initial-wrap {\n  background-color: #d8d8d8 !important;\n  color: #262a2e;\n}\n.avatar.avatar-soft-light > .initial-wrap {\n  background-color: #f7f7f7 !important;\n  color: #6f6f6f;\n}\n.avatar.avatar-soft-grey > .initial-wrap {\n  background-color: #f7f7f7 !important;\n  color: #9e9e9e;\n}\n.avatar.avatar-soft-secondary > .initial-wrap {\n  background-color: #f3f3f3 !important;\n  color: #6f6f6f;\n}\n\n.avatar-group {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.avatar-group .avatar {\n  width: 2.625rem;\n  height: 2.625rem;\n}\n.avatar-group .avatar .avatar-img,\n.avatar-group .avatar > .initial-wrap {\n  border: 2px solid #fff;\n  font-size: .9rem;\n}\n.avatar-group.avatar-group-overlapped .avatar {\n  margin-right: -.875rem;\n}\n.avatar-group.avatar-group-overlapped .avatar:hover {\n  z-index: 1;\n}\n.avatar-group.avatar-group-lg .avatar {\n  width: 3.25rem;\n  height: 3.25rem;\n}\n.avatar-group.avatar-group-lg .avatar > .initial-wrap {\n  font-size: .95rem;\n}\n.avatar-group.avatar-group-lg.avatar-group-overlapped .avatar {\n  margin-right: -1rem;\n}\n.avatar-group.avatar-group-sm .avatar {\n  width: 2rem;\n  height: 2rem;\n}\n.avatar-group.avatar-group-sm .avatar > .initial-wrap {\n  font-size: .6rem;\n}\n.avatar-group.avatar-group-sm.avatar-group-overlapped .avatar {\n  margin-right: -0.625rem;\n}\n\n/*Pagination*/\n.pagination-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.page-link {\n  color: #262a2e;\n  border-color: #d8d8d8;\n  min-width: 40px;\n  min-height: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n.page-link:focus, .page-link:hover {\n  color: #262a2e;\n  box-shadow: none;\n  background-color: #eaeaea;\n  border-color: #d8d8d8;\n}\n\n.pagination .page-item.active .page-link {\n  background: #0a2f4c;\n  border-color: #0a2f4c;\n  color: #fff;\n}\n.pagination .page-item.disabled .page-link {\n  color: #b5b5b5;\n}\n.pagination .page-item:first-child .page-link {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n.pagination .page-item:last-child .page-link {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n.pagination.custom-pagination .page-item + .page-item {\n  padding-left: .5rem;\n  margin: 0;\n}\n.pagination.custom-pagination .page-link {\n  padding: .5rem .8rem;\n  border-radius: 0.5rem;\n}\n.pagination.custom-pagination.pagination-rounded .page-link {\n  border-radius: 50rem;\n}\n.pagination.custom-pagination.pagination-rounded .page-item:first-child .page-link,\n.pagination.custom-pagination.pagination-rounded .page-item:last-child .page-link {\n  border-radius: 50rem;\n}\n.pagination.custom-pagination.pagination-filled .page-item:not(.active) .page-link {\n  background: #f7f7f7;\n  border-color: #f7f7f7;\n}\n.pagination.custom-pagination.pagination-filled .page-item:not(.active):hover .page-link {\n  background-color: #eaeaea;\n}\n.pagination.custom-pagination.pagination-simple .page-item:not(.active) .page-link {\n  border-color: transparent;\n}\n.pagination.pagination-sm .page-link {\n  padding: .3rem .6rem;\n  min-height: 30px;\n  min-width: 30px;\n}\n\n/*Badge*/\n.badge {\n  font-weight: 500;\n  border-radius: 0.5rem;\n  padding: .5rem .625rem;\n  font-size: 70%;\n  min-width: 25px;\n  letter-spacing: 0.3px;\n  vertical-align: middle;\n  display: inline-block;\n  text-align: center;\n  text-transform: capitalize;\n}\n.badge.badge-indicator {\n  width: 10px;\n  height: 10px;\n  min-width: initial;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  padding: 0;\n  position: relative;\n}\n.badge.badge-indicator:empty {\n  display: inline-block;\n}\n.badge.badge-indicator.badge-indicator-sm {\n  width: 7px;\n  height: 7px;\n}\n.badge.badge-indicator.badge-indicator-lg {\n  width: 12px;\n  height: 12px;\n}\n.badge.badge-indicator.badge-indicator-xl {\n  width: 16px;\n  height: 16px;\n}\n.badge.badge-indicator.badge-indicator-nobdr {\n  width: 8px;\n  height: 8px;\n  border: none;\n}\n.badge.badge-indicator.badge-indicator-nobdr-sm {\n  width: 5px;\n  height: 5px;\n  border: none;\n}\n@-webkit-keyframes ripple {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  to {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n@keyframes ripple {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  to {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n.badge.badge-indicator.badge-indicator-processing {\n  position: relative;\n}\n.badge.badge-indicator.badge-indicator-processing::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid;\n  border-radius: 50%;\n  -webkit-animation: ripple 1.2s infinite ease-in-out;\n  animation: ripple 1.2s infinite ease-in-out;\n  content: \"\";\n}\n.badge > span {\n  display: flex;\n  align-items: center;\n}\n.badge > span .icon {\n  display: flex;\n  font-size: 0.875rem;\n  margin-right: .25rem;\n}\n.badge > span .badge-dot {\n  display: flex;\n  font-size: 8px;\n  margin-right: .25rem;\n}\n.badge.badge-sm {\n  font-size: 60%;\n  padding: .25rem .5rem;\n  min-width: 19px;\n}\n.badge.badge-sm > span .badge-dot {\n  font-size: .375rem;\n}\n.badge.badge-sm > span .icon {\n  font-size: 0.75rem;\n}\n.badge.badge-cyan {\n  background: #18DDEF;\n  color: #fff;\n}\n.badge.badge-cyan.badge-indicator-processing:after {\n  border-color: #18DDEF;\n}\n.badge.badge-info {\n  background: #18DDEF;\n  color: #fff;\n}\n.badge.badge-info.badge-indicator-processing:after {\n  border-color: #18DDEF;\n}\n.badge.badge-sky {\n  background: #00B0FF;\n  color: #fff;\n}\n.badge.badge-sky.badge-indicator-processing:after {\n  border-color: #00B0FF;\n}\n.badge.badge-green {\n  background: #00D67F;\n  color: #fff;\n}\n.badge.badge-green.badge-indicator-processing:after {\n  border-color: #00D67F;\n}\n.badge.badge-success {\n  background: #00D67F;\n  color: #fff;\n}\n.badge.badge-success.badge-indicator-processing:after {\n  border-color: #00D67F;\n}\n.badge.badge-red {\n  background: #FF0000;\n  color: #fff;\n}\n.badge.badge-red.badge-indicator-processing:after {\n  border-color: #FF0000;\n}\n.badge.badge-danger {\n  background: #FF0000;\n  color: #fff;\n}\n.badge.badge-danger.badge-indicator-processing:after {\n  border-color: #FF0000;\n}\n.badge.badge-yellow {\n  background: #FFC400;\n  color: #fff;\n}\n.badge.badge-yellow.badge-indicator-processing:after {\n  border-color: #FFC400;\n}\n.badge.badge-warning {\n  background: #FFC400;\n  color: #fff;\n}\n.badge.badge-warning.badge-indicator-processing:after {\n  border-color: #FFC400;\n}\n.badge.badge-pink {\n  background: #E92990;\n  color: #fff;\n}\n.badge.badge-pink.badge-indicator-processing:after {\n  border-color: #E92990;\n}\n.badge.badge-purple {\n  background: #C02FF3;\n  color: #fff;\n}\n.badge.badge-purple.badge-indicator-processing:after {\n  border-color: #C02FF3;\n}\n.badge.badge-violet {\n  background: #7429F8;\n  color: #fff;\n}\n.badge.badge-violet.badge-indicator-processing:after {\n  border-color: #7429F8;\n}\n.badge.badge-indigo {\n  background: #0069F7;\n  color: #fff;\n}\n.badge.badge-indigo.badge-indicator-processing:after {\n  border-color: #0069F7;\n}\n.badge.badge-blue {\n  background: #298DFF;\n  color: #fff;\n}\n.badge.badge-blue.badge-indicator-processing:after {\n  border-color: #298DFF;\n}\n.badge.badge-primary {\n  background: #4eafcb;\n  color: #fff;\n}\n.badge.badge-primary.badge-indicator-processing:after {\n  border-color: #4eafcb;\n}\n.badge.badge-teal {\n  background: #4eafcb;\n  color: #fff;\n}\n.badge.badge-teal.badge-indicator-processing:after {\n  border-color: #4eafcb;\n}\n.badge.badge-neon {\n  background: #81E230;\n  color: #fff;\n}\n.badge.badge-neon.badge-indicator-processing:after {\n  border-color: #81E230;\n}\n.badge.badge-lime {\n  background: #C2E939;\n  color: #fff;\n}\n.badge.badge-lime.badge-indicator-processing:after {\n  border-color: #C2E939;\n}\n.badge.badge-sun {\n  background: #FFEA00;\n  color: #262a2e;\n}\n.badge.badge-sun.badge-indicator-processing:after {\n  border-color: #FFEA00;\n}\n.badge.badge-orange {\n  background: #FF9100;\n  color: #fff;\n}\n.badge.badge-orange.badge-indicator-processing:after {\n  border-color: #FF9100;\n}\n.badge.badge-pumpkin {\n  background: #FF5700;\n  color: #fff;\n}\n.badge.badge-pumpkin.badge-indicator-processing:after {\n  border-color: #FF5700;\n}\n.badge.badge-smoke {\n  background: #5e7d8a;\n  color: #fff;\n}\n.badge.badge-smoke.badge-indicator-processing:after {\n  border-color: #5e7d8a;\n}\n.badge.badge-brown {\n  background: #954D15;\n  color: #fff;\n}\n.badge.badge-brown.badge-indicator-processing:after {\n  border-color: #954D15;\n}\n.badge.badge-gold {\n  background: #C39749;\n  color: #fff;\n}\n.badge.badge-gold.badge-indicator-processing:after {\n  border-color: #C39749;\n}\n.badge.badge-grey {\n  background: #9e9e9e;\n  color: #fff;\n}\n.badge.badge-grey.badge-indicator-processing:after {\n  border-color: #9e9e9e;\n}\n.badge.badge-secondary {\n  background: #6f6f6f;\n  color: #fff;\n}\n.badge.badge-secondary.badge-indicator-processing:after {\n  border-color: #6f6f6f;\n}\n.badge.badge-light {\n  background: #eaeaea;\n  color: #262a2e;\n}\n.badge.badge-light.badge-indicator-processing:after {\n  border-color: #eaeaea;\n}\n.badge.badge-dark {\n  background: #262a2e;\n  color: #fff;\n}\n.badge.badge-dark.badge-indicator-processing:after {\n  border-color: #262a2e;\n}\n.badge.badge-outline {\n  background: transparent;\n  border: 1px solid;\n}\n.badge.badge-outline.badge-cyan {\n  border-color: #18DDEF;\n  color: #18DDEF;\n}\n.badge.badge-outline.badge-info {\n  border-color: #18DDEF;\n  color: #18DDEF;\n}\n.badge.badge-outline.badge-sky {\n  border-color: #00B0FF;\n  color: #00B0FF;\n}\n.badge.badge-outline.badge-green {\n  border-color: #00D67F;\n  color: #00ab66;\n}\n.badge.badge-outline.badge-success {\n  border-color: #00D67F;\n  color: #00ab66;\n}\n.badge.badge-outline.badge-red {\n  border-color: #FF0000;\n  color: #e60000;\n}\n.badge.badge-outline.badge-danger {\n  border-color: #FF0000;\n  color: #e60000;\n}\n.badge.badge-outline.badge-yellow {\n  border-color: #FFC400;\n  color: #cc9d00;\n}\n.badge.badge-outline.badge-warning {\n  border-color: #FFC400;\n  color: #cc9d00;\n}\n.badge.badge-outline.badge-grey {\n  border-color: #9e9e9e;\n  color: #9e9e9e;\n}\n.badge.badge-outline.badge-secondary {\n  border-color: #6f6f6f;\n  color: #6f6f6f;\n}\n.badge.badge-outline.badge-light {\n  border-color: #eaeaea;\n  color: #262a2e;\n}\n.badge.badge-outline.badge-dark {\n  border-color: #262a2e;\n  color: #262a2e;\n}\n.badge.badge-outline.badge-pink {\n  border-color: #E92990;\n  color: #E92990;\n}\n.badge.badge-outline.badge-purple {\n  border-color: #C02FF3;\n  color: #C02FF3;\n}\n.badge.badge-outline.badge-violet {\n  border-color: #7429F8;\n  color: #7429F8;\n}\n.badge.badge-outline.badge-indigo {\n  border-color: #0069F7;\n  color: #0069F7;\n}\n.badge.badge-outline.badge-blue {\n  border-color: #298DFF;\n  color: #298DFF;\n}\n.badge.badge-outline.badge-primary {\n  border-color: #0a2f4c;\n  color: #0a2f4c;\n}\n.badge.badge-outline.badge-teal {\n  border-color: #0a2f4c;\n  color: #0a2f4c;\n}\n.badge.badge-outline.badge-neon {\n  border-color: #81E230;\n  color: #81E230;\n}\n.badge.badge-outline.badge-lime {\n  border-color: #C2E939;\n  color: #C2E939;\n}\n.badge.badge-outline.badge-sun {\n  border-color: #FFEA00;\n  color: #FFEA00;\n}\n.badge.badge-outline.badge-orange {\n  border-color: #FF9100;\n  color: #FF9100;\n}\n.badge.badge-outline.badge-pumpkin {\n  border-color: #FF5700;\n  color: #FF5700;\n}\n.badge.badge-outline.badge-smoke {\n  border-color: #5e7d8a;\n  color: #5e7d8a;\n}\n.badge.badge-outline.badge-brown {\n  border-color: #954D15;\n  color: #954D15;\n}\n.badge.badge-outline.badge-gold {\n  border-color: #C39749;\n  color: #C39749;\n}\n.badge.badge-soft-cyan {\n  background: #edfcfe;\n  color: #18DDEF;\n}\n.badge.badge-soft-cyan.badge-indicator-processing:after {\n  border-color: #edfcfe;\n}\n.badge.badge-soft-info {\n  background: #edfcfe;\n  color: #18DDEF;\n}\n.badge.badge-soft-info.badge-indicator-processing:after {\n  border-color: #edfcfe;\n}\n.badge.badge-soft-sky {\n  background: #ebf9ff;\n  color: #00B0FF;\n}\n.badge.badge-soft-sky.badge-indicator-processing:after {\n  border-color: #ebf9ff;\n}\n.badge.badge-soft-green {\n  background: #ebfcf5;\n  color: #00ab66;\n}\n.badge.badge-soft-green.badge-indicator-processing:after {\n  border-color: #ebfcf5;\n}\n.badge.badge-soft-success {\n  background: #ebfcf5;\n  color: #00ab66;\n}\n.badge.badge-soft-success.badge-indicator-processing:after {\n  border-color: #ebfcf5;\n}\n.badge.badge-soft-red {\n  background: #ffebeb;\n  color: #e60000;\n}\n.badge.badge-soft-red.badge-indicator-processing:after {\n  border-color: #ffebeb;\n}\n.badge.badge-soft-danger {\n  background: #ffebeb;\n  color: #e60000;\n}\n.badge.badge-soft-danger.badge-indicator-processing:after {\n  border-color: #ffebeb;\n}\n.badge.badge-soft-yellow {\n  background: #fffaeb;\n  color: #cc9d00;\n}\n.badge.badge-soft-yellow.badge-indicator-processing:after {\n  border-color: #fffaeb;\n}\n.badge.badge-soft-warning {\n  background: #fffaeb;\n  color: #cc9d00;\n}\n.badge.badge-soft-warning.badge-indicator-processing:after {\n  border-color: #fffaeb;\n}\n.badge.badge-soft-pink {\n  background: #fdeef6;\n  color: #E92990;\n}\n.badge.badge-soft-pink.badge-indicator-processing:after {\n  border-color: #fdeef6;\n}\n.badge.badge-soft-purple {\n  background: #faeefe;\n  color: #C02FF3;\n}\n.badge.badge-soft-purple.badge-indicator-processing:after {\n  border-color: #faeefe;\n}\n.badge.badge-soft-violet {\n  background: #f4eefe;\n  color: #7429F8;\n}\n.badge.badge-soft-violet.badge-indicator-processing:after {\n  border-color: #f4eefe;\n}\n.badge.badge-soft-indigo {\n  background: #ebf3fe;\n  color: #0069F7;\n}\n.badge.badge-soft-indigo.badge-indicator-processing:after {\n  border-color: #ebf3fe;\n}\n.badge.badge-soft-blue {\n  background: #eef6ff;\n  color: #298DFF;\n}\n.badge.badge-soft-blue.badge-indicator-processing:after {\n  border-color: #eef6ff;\n}\n.badge.badge-soft-primary {\n  background: #ebf5f5;\n  color: #0a2f4c;\n}\n.badge.badge-soft-primary.badge-indicator-processing:after {\n  border-color: #ebf5f5;\n}\n.badge.badge-soft-teal {\n  background: #ebf5f5;\n  color: #0a2f4c;\n}\n.badge.badge-soft-teal.badge-indicator-processing:after {\n  border-color: #ebf5f5;\n}\n.badge.badge-soft-neon {\n  background: #f5fdee;\n  color: #81E230;\n}\n.badge.badge-soft-neon.badge-indicator-processing:after {\n  border-color: #f5fdee;\n}\n.badge.badge-soft-lime {\n  background: #fafdef;\n  color: #C2E939;\n}\n.badge.badge-soft-lime.badge-indicator-processing:after {\n  border-color: #fafdef;\n}\n.badge.badge-soft-sun {\n  background: #fffdeb;\n  color: #FFEA00;\n}\n.badge.badge-soft-sun.badge-indicator-processing:after {\n  border-color: #fffdeb;\n}\n.badge.badge-soft-orange {\n  background: #fff6eb;\n  color: #FF9100;\n}\n.badge.badge-soft-orange.badge-indicator-processing:after {\n  border-color: #fff6eb;\n}\n.badge.badge-soft-pumpkin {\n  background: #fff2eb;\n  color: #FF5700;\n}\n.badge.badge-soft-pumpkin.badge-indicator-processing:after {\n  border-color: #fff2eb;\n}\n.badge.badge-soft-smoke {\n  background: #f2f5f6;\n  color: #5e7d8a;\n}\n.badge.badge-soft-smoke.badge-indicator-processing:after {\n  border-color: #f2f5f6;\n}\n.badge.badge-soft-brown {\n  background: #f7f1ec;\n  color: #954D15;\n}\n.badge.badge-soft-brown.badge-indicator-processing:after {\n  border-color: #f7f1ec;\n}\n.badge.badge-soft-gold {\n  background: #faf7f0;\n  color: #C39749;\n}\n.badge.badge-soft-gold.badge-indicator-processing:after {\n  border-color: #faf7f0;\n}\n.badge.badge-soft-grey {\n  background: #f7f7f7;\n  color: #9e9e9e;\n}\n.badge.badge-soft-grey.badge-indicator-processing:after {\n  border-color: #f7f7f7;\n}\n.badge.badge-soft-secondary {\n  background: #f3f3f3;\n  color: #6f6f6f;\n}\n.badge.badge-soft-secondary.badge-indicator-processing:after {\n  border-color: #f3f3f3;\n}\n.badge.badge-soft-light {\n  background: #f7f7f7;\n  color: #6f6f6f;\n}\n.badge.badge-soft-light.badge-indicator-processing:after {\n  border-color: #f7f7f7;\n}\n.badge.badge-soft-dark {\n  background: #d8d8d8;\n  color: #262a2e;\n}\n.badge.badge-soft-dark.badge-indicator-processing:after {\n  border-color: #d8d8d8;\n}\n.badge.badge-pill {\n  border-radius: 50rem;\n}\n\na.badge {\n  -webkit-transition: all 0.15s ease;\n  -moz-transition: all 0.15s ease;\n  transition: all 0.15s ease;\n}\na.badge:hover, a.badge:focus {\n  -webkit-transform: translateY(-3px);\n  -moz-transform: translateY(-3px);\n  -ms-transform: translateY(-3px);\n  -o-transform: translateY(-3px);\n  transform: translateY(-3px);\n  box-shadow: 0 0.1875rem 0.5rem rgba(47, 52, 58, 0.3) !important;\n}\na.badge-sky:hover, a.badge-sky:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(0, 176, 255, 0.3) !important;\n}\na.badge-cyan:hover, a.badge-cyan:focus {\n  background: #18DDEF;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(24, 221, 239, 0.3) !important;\n}\na.badge-info:hover, a.badge-info:focus {\n  background: #18DDEF;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(24, 221, 239, 0.3) !important;\n}\na.badge-blue:hover, a.badge-blue:focus {\n  background: #298DFF;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(41, 141, 255, 0.3) !important;\n}\na.badge-primary:hover, a.badge-primary:focus {\n  background: #0a2f4c;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(0, 125, 136, 0.3) !important;\n}\na.badge-green:hover, a.badge-green:focus {\n  background: #00D67F;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(0, 214, 127, 0.3) !important;\n}\na.badge-success:hover, a.badge-success:focus {\n  background: #00D67F;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(0, 214, 127, 0.3) !important;\n}\na.badge-red:hover, a.badge-red:focus {\n  background: #FF0000;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(255, 0, 0, 0.3) !important;\n}\na.badge-danger:hover, a.badge-danger:focus {\n  background: #FF0000;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(255, 0, 0, 0.3) !important;\n}\na.badge-yellow:hover, a.badge-yellow:focus {\n  background: #FFC400;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(255, 196, 0, 0.3) !important;\n}\na.badge-warning:hover, a.badge-warning:focus {\n  background: #FFC400;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(255, 196, 0, 0.3) !important;\n}\na.badge-grey:hover, a.badge-grey:focus {\n  background: #9e9e9e;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(158, 158, 158, 0.3) !important;\n}\na.badge-secondary:hover, a.badge-secondary:focus {\n  background: #6f6f6f;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(111, 111, 111, 0.3) !important;\n}\na.badge-pink:hover, a.badge-pink:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(233, 41, 144, 0.3) !important;\n}\na.badge-purple:hover, a.badge-purple:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(192, 47, 243, 0.3) !important;\n}\na.badge-violet:hover, a.badge-violet:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(116, 41, 248, 0.3) !important;\n}\na.badge-indigo:hover, a.badge-indigo:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(0, 105, 247, 0.3) !important;\n}\na.badge-teal:hover, a.badge-teal:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(0, 125, 136, 0.3) !important;\n}\na.badge-neon:hover, a.badge-neon:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(129, 226, 48, 0.3) !important;\n}\na.badge-lime:hover, a.badge-lime:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(194, 233, 57, 0.3) !important;\n}\na.badge-sun:hover, a.badge-sun:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(255, 234, 0, 0.3) !important;\n}\na.badge-orange:hover, a.badge-orange:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(255, 145, 0, 0.3) !important;\n}\na.badge-pumpkin:hover, a.badge-pumpkin:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(255, 87, 0, 0.3) !important;\n}\na.badge-smoke:hover, a.badge-smoke:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(94, 125, 138, 0.3) !important;\n}\na.badge-brown:hover, a.badge-brown:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(149, 77, 21, 0.3) !important;\n}\na.badge-gold:hover, a.badge-gold:focus {\n  box-shadow: 0 0.1875rem 0.5rem rgba(195, 151, 73, 0.3) !important;\n}\na.badge-light:hover, a.badge-light:focus {\n  background: #eaeaea;\n  color: #262a2e;\n  box-shadow: 0 0.1875rem 0.5rem #d8d8d8 !important;\n}\na.badge-dark:hover, a.badge-dark:focus {\n  background: #262a2e;\n  color: #fff;\n  box-shadow: 0 0.1875rem 0.5rem rgba(38, 42, 46, 0.3) !important;\n}\na.badge-outline:hover, a.badge-outline:focus {\n  background: transparent;\n  box-shadow: none;\n}\n\n.badge-status .badge-label {\n  margin-left: .25rem;\n  font-size: 0.875rem;\n}\n\n.badge-on-text .badge {\n  position: relative;\n  top: -5px;\n  right: 0;\n}\n\n.badge-on-text-end .badge {\n  margin-left: .5rem;\n  position: relative;\n  top: -1px;\n}\n\n/*List Group*/\n.list-group-item {\n  border-color: #d8d8d8;\n}\n.list-group-item:first-child {\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n.list-group-item.active {\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.list-group-item.active h1, .list-group-item.active h2, .list-group-item.active h3, .list-group-item.active h4, .list-group-item.active h5, .list-group-item.active h6 {\n  color: #fff;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #b5b5b5;\n}\n.list-group-item.list-group-item-action:not(.active):focus, .list-group-item.list-group-item-action:not(.active):hover {\n  background-color: #f7f7f7;\n}\n.list-group-item.list-group-item-primary:not(.active) {\n  color: #0a2f4c;\n  background-color: #ebf5f5;\n}\n.list-group-item.list-group-item-info:not(.active) {\n  color: #18DDEF;\n  background-color: #edfcfe;\n}\n.list-group-item.list-group-item-success:not(.active) {\n  color: #00D67F;\n  background-color: #ebfcf5;\n}\n.list-group-item.list-group-item-warning:not(.active) {\n  color: #FFC400;\n  background-color: #fffaeb;\n}\n.list-group-item.list-group-item-danger:not(.active) {\n  color: #FF0000;\n  background-color: #ffebeb;\n}\n.list-group-item.list-group-item-secondary:not(.active) {\n  color: #6f6f6f;\n  background-color: #f3f3f3;\n}\n.list-group-item.list-group-item-light:not(.active) {\n  color: #5f5f5f;\n  background-color: #f7f7f7;\n}\n.list-group-item.list-group-item-dark:not(.active) {\n  color: #fff;\n  background-color: #262a2e;\n}\n.list-group-item.list-group-inv {\n  color: #fff;\n}\n.list-group-item.list-group-inv.list-group-inv-primary:not(.active) {\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.list-group-item.list-group-inv.list-group-inv-info:not(.active) {\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.list-group-item.list-group-inv.list-group-inv-success:not(.active) {\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.list-group-item.list-group-inv.list-group-inv-warning:not(.active) {\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.list-group-item.list-group-inv.list-group-inv-danger:not(.active) {\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.list-group-item.list-group-inv.list-group-inv-secondary:not(.active) {\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n\n.list-group-horizontal-xxl > .list-group-item:first-child,\n.list-group-horizontal-xl > .list-group-item:first-child,\n.list-group-horizontal-lg > .list-group-item:first-child,\n.list-group-horizontal-md > .list-group-item:first-child,\n.list-group-horizontal-sm > .list-group-item:first-child,\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.5rem;\n}\n.list-group-horizontal-xxl > .list-group-item:last-child,\n.list-group-horizontal-xl > .list-group-item:last-child,\n.list-group-horizontal-lg > .list-group-item:last-child,\n.list-group-horizontal-md > .list-group-item:last-child,\n.list-group-horizontal-sm > .list-group-item:last-child,\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.5rem;\n}\n\n.list-group.active-info .list-group-item.active {\n  background-color: #18DDEF;\n  border-color: #18DDEF;\n}\n.list-group.active-success .list-group-item.active {\n  background-color: #00D67F;\n  border-color: #00D67F;\n}\n.list-group.active-warning .list-group-item.active {\n  background-color: #FFC400;\n  border-color: #FFC400;\n}\n.list-group.active-danger .list-group-item.active {\n  background-color: #FF0000;\n  border-color: #FF0000;\n}\n.list-group.active-primary .list-group-item.active {\n  background-color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n.list-group.active-secondary .list-group-item.active {\n  background-color: #6f6f6f;\n  border-color: #6f6f6f;\n}\n\n/*Google Map*/\n.infowindow-wrap .infowindow-header {\n  color: #262a2e;\n  padding: 0 5px;\n}\n.infowindow-wrap .infowindow-body {\n  padding: 0 .25rem;\n  color: #6f6f6f;\n  font-size: 1rem;\n}\n\n/*Vecotor Map*/\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  line-height: 9px;\n  background: #262a2e;\n  padding: .25rem;\n  width: .75rem;\n  height: 13px;\n  border-radius: 0;\n}\n\n.jvectormap-zoomout {\n  top: 31px;\n}\n\n.jvectormap-goback {\n  padding: .15rem .4rem;\n  font-size: .75rem;\n  background: #0a2f4c;\n  border-radius: 0.2rem;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  height: 23px;\n}\n.jvectormap-legend-cnt-h .jvectormap-legend {\n  background: #262a2e;\n  padding: .25rem;\n  border-radius: .125rem;\n}\n.jvectormap-legend-cnt-h .jvectormap-legend.jvectormap-legend-icons {\n  color: #262a2e;\n  background: #fff;\n  border: #c7c7c7 1px solid;\n}\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-title {\n  font-weight: 500;\n  margin-bottom: 0.625rem;\n}\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n  width: 55px;\n}\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick .jvectormap-legend-tick-text {\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  margin-top: .25rem;\n}\n\n/*Progressbar*/\n.progress {\n  border-radius: 0;\n}\n.progress.progress-bar-rounded {\n  border-radius: 50rem;\n}\n.progress.progress-bar-rounded .progress-bar {\n  border-radius: 50rem;\n}\n.progress.progress-bar-xs {\n  height: 5px;\n}\n.progress.progress-bar-sm {\n  height: 9px;\n}\n.progress.progress-bar-md {\n  height: 13px;\n}\n.progress.progress-bar-lg {\n  height: 18px;\n}\n.progress.progress-bar-xl {\n  height: 20px;\n}\n.progress .progress-bar {\n  background-color: #0a2f4c;\n}\n.progress .progress-bar .progress-tooltip {\n  position: absolute;\n  right: -20px;\n  width: 50px;\n  background: #262a2e;\n  bottom: 25px;\n  border-radius: .3rem;\n  padding: .25rem .625rem;\n  font-size: 0.75rem;\n  height: 30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n.progress .progress-bar .progress-tooltip:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  bottom: -10px;\n  left: -5px;\n  right: 0;\n  margin: auto;\n  box-sizing: border-box;\n  border: 0.6em solid rgba(240, 210, 210, 0.1);\n  border-color: transparent transparent #262a2e #262a2e;\n  transform-origin: 0 0;\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.progress.progress-width-animated {\n  overflow: visible !important;\n}\n.progress.progress-width-animated .progress-bar {\n  overflow: visible !important;\n  position: relative;\n}\n\n.progress-label {\n  text-transform: capitalize;\n  font-size: 0.875rem;\n  font-weight: 400;\n  margin-bottom: .5rem;\n}\n\n.progress-wrap.lb-side-left .progress-lb-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.progress-wrap.lb-side-left .progress-lb-wrap .progress-label {\n  display: inline-block;\n  padding-right: 1rem;\n  flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  margin-bottom: 0;\n}\n.progress-wrap.lb-side-left .progress-lb-wrap .progress {\n  flex: 1 1 100%;\n  -ms-flex: 1 1 100%;\n  max-width: 100%;\n}\n\n/*Togglable*/\n.hk-sidebar-togglable {\n  height: 25px;\n  width: 25px;\n  left: -12.5px;\n  border-radius: 50%;\n  top: 52px;\n  position: absolute;\n  background: #fff;\n  cursor: pointer;\n  border: 1px solid #d8d8d8;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  box-shadow: 0 0.125rem 0.125rem rgba(47, 52, 58, 0.1) !important;\n  -webkit-transition: -webkit-transform 0.3s ease-in-out;\n  -moz-transition: -moz-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  z-index: 2;\n}\n.hk-sidebar-togglable:after {\n  content: \"\\ea62\";\n  font-family: remixicon;\n  text-rendering: auto;\n}\n.hk-sidebar-togglable.active {\n  -webkit-transform: translateX(32px);\n  -moz-transform: translateX(32px);\n  -ms-transform: translateX(32px);\n  -o-transform: translateX(32px);\n  transform: translateX(32px);\n}\n.hk-sidebar-togglable.active:after {\n  content: \"\\ea6c\";\n}\n\n/*Advance List*/\n.advance-list {\n  padding-left: 0;\n}\n.advance-list > li {\n  margin-bottom: 1.25rem;\n}\n.advance-list > li:last-child {\n  margin-bottom: 0;\n}\n\n.advance-list-item {\n  padding: .5rem 1.25rem;\n  min-height: 50px;\n  border: 1px solid #d8d8d8;\n  border-radius: 0.5rem;\n  list-style: none;\n  background: #fff;\n  position: relative;\n  -webkit-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  -moz-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.advance-list-item:hover {\n  -webkit-transform: scale(1.02, 1.02);\n  -moz-transform: scale(1.02, 1.02);\n  -ms-transform: scale(1.02, 1.02);\n  -o-transform: scale(1.02, 1.02);\n  transform: scale(1.02, 1.02);\n  z-index: 1;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n.advance-list-item.drp-open {\n  z-index: 4;\n}\n\n/*Light Gallery*/\n.lg-outer .lg-img-wrap {\n  padding: 0;\n}\n\n.lg-outer .lg-video .lg-object {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: auto !important;\n  height: 100% !important;\n}\n\n/*Cropperjs*/\n.img-container, .img-preview {\n  background-color: #f7f7f7;\n  width: 100%;\n  text-align: center;\n}\n\n.img-container {\n  min-height: 200px;\n  max-height: 469px;\n  margin-bottom: 1rem;\n}\n.img-container > img {\n  max-width: 100%;\n}\n\n.docs-preview {\n  margin-right: -1rem;\n}\n\n.img-preview {\n  float: left;\n  margin-right: .5rem;\n  margin-bottom: .5rem;\n  overflow: hidden;\n}\n.img-preview > img {\n  max-width: 100%;\n}\n\n.preview-lg {\n  width: 255px;\n  height: 143px;\n}\n\n.preview-md {\n  width: 128px;\n  height: 72px;\n}\n\n.preview-sm {\n  width: 72px;\n  height: 41px;\n}\n\n.preview-xs {\n  width: 40px;\n  height: 24px;\n  margin-right: 0;\n}\n\n.docs-data > .input-group {\n  margin-bottom: .5rem;\n}\n.docs-data > .input-group > label {\n  min-width: 80px;\n}\n\n.docs-buttons > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-buttons > .hopscotch-nav-button, .docs-buttons > .btn-group, .docs-buttons > .form-control, .docs-buttons > .form-select, .wizard > .content > .body .docs-buttons > input, .docs-buttons > .dd-handle {\n  margin-right: .25rem;\n  margin-bottom: .5rem;\n}\n\n.docs-toggles > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-toggles > .hopscotch-nav-button, .docs-toggles > .btn-group, .docs-toggles > .dropdown {\n  margin-bottom: .5rem;\n}\n\n.docs-tooltip {\n  display: block;\n  margin: -0.5rem -0.75rem;\n  padding: .5rem .75rem;\n}\n\n.docs-aspect-ratios, .docs-view-modes {\n  width: 100%;\n}\n\n.docs-aspect-ratios > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-aspect-ratios > .hopscotch-nav-button {\n  width: 20%;\n}\n\n.docs-view-modes > .btn, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .docs-view-modes > .hopscotch-nav-button {\n  width: 25%;\n}\n\n.docs-options .dropdown-menu, .docs-options .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .docs-options .apexcharts-menu {\n  width: 100%;\n}\n.docs-options .dropdown-menu > li, .docs-options .apexcharts-toolbar .apexcharts-menu > li, .apexcharts-toolbar .docs-options .apexcharts-menu > li {\n  padding: .25rem 1rem;\n}\n.docs-options .dropdown-menu > li:hover, .docs-options .apexcharts-toolbar .apexcharts-menu > li:hover, .apexcharts-toolbar .docs-options .apexcharts-menu > li:hover {\n  background-color: #f7f7f7;\n}\n.docs-options .dropdown-menu > li > label, .docs-options .apexcharts-toolbar .apexcharts-menu > li > label, .apexcharts-toolbar .docs-options .apexcharts-menu > li > label {\n  margin-bottom: 0;\n}\n\n.docs-cropped .modal-body {\n  text-align: center;\n}\n.docs-cropped .modal-body > img, .docs-cropped .modal-body > canvas {\n  max-width: 100%;\n}\n\n.common-credits > li {\n  display: block;\n  margin-bottom: 1rem;\n}\n.common-credits > li:last-child {\n  margin-bottom: 0;\n}\n\n/*Bootstrap TimeOut*/\n#session-timeout-dialog .modal-header {\n  background: #FF0000;\n}\n#session-timeout-dialog .modal-header .modal-title {\n  color: #fff;\n}\n#session-timeout-dialog .modal-header button.btn-close {\n  color: #fff;\n}\n#session-timeout-dialog .modal-body p.mb-10 {\n  font-size: 1.1rem;\n}\n#session-timeout-dialog .modal-body .countdown-holder {\n  color: #FF0000;\n}\n#session-timeout-dialog .modal-body .progress {\n  margin-top: 1.25rem;\n}\n#session-timeout-dialog .modal-footer {\n  border-top: none;\n}\n\n/*Hopscotch*/\ndiv.hopscotch-bubble {\n  border: none;\n  box-shadow: 0px 4px 16px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  font-family: var(--bs-body-font-family);\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-number {\n  display: none;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-content {\n  margin: 0;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container h3 {\n  color: #262a2e;\n  font-family: var(--bs-body-font-family);\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.2;\n  margin: -1px 16px 4px 0;\n  padding: 0;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-content {\n  color: #6f6f6f;\n  font-family: var(--bs-body-font-family);\n  line-height: inherit;\n  margin: .5rem 0;\n  font-weight: inherit;\n  padding: 0;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions {\n  margin: 1.25rem 0 0;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button {\n  outline: none;\n  background-image: none;\n  font-weight: 400;\n  margin: 0;\n  overflow: visible;\n  text-decoration: none !important;\n  width: auto;\n  height: auto;\n  line-height: inherit;\n  text-shadow: none;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:focus, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:active, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:hover {\n  box-shadow: none !important;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {\n  margin-right: .625rem;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-close {\n  text-shadow: none;\n  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  outline: none;\n  color: #262a2e;\n  background: transparent;\n  webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-indent: inherit;\n  width: auto;\n  height: auto;\n  font-size: 0;\n  z-index: 1;\n  opacity: .6;\n  right: 3px;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-close:before {\n  content: \"\\f136\";\n  font-size: 1.125rem;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-container .hopscotch-bubble-close:hover {\n  opacity: 1;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.up {\n  top: 2px;\n  left: 32px;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.down {\n  bottom: -32px;\n  left: 4px;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.down:after {\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.right {\n  top: 30px;\n  right: -32px;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.right:after {\n  -webkit-transform: rotate(225deg);\n  -moz-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  -o-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.left {\n  top: 10px;\n  left: 2px;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container.left:after {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container .hopscotch-bubble-arrow-border,\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container .hopscotch-bubble-arrow {\n  display: none;\n}\ndiv.hopscotch-bubble .hopscotch-bubble-arrow-container:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  margin-left: 0;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n  border: 0.6em solid rgba(0, 0, 0, 0.1);\n  border-color: transparent transparent #fff #fff;\n  transform-origin: 0 0;\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n  box-shadow: -2px 2px 16px rgba(0, 0, 0, 0.05);\n}\ndiv.hopscotch-bubble.animated {\n  -webkit-animation-fill-mode: both;\n  -moz-animation-fill-mode: both;\n  -ms-animation-fill-mode: both;\n  -o-animation-fill-mode: both;\n  animation-fill-mode: both;\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  -ms-animation-duration: 1s;\n  -o-animation-duration: 1s;\n  animation-duration: 1s;\n}\ndiv.hopscotch-bubble.tour-hopscotch-dark {\n  background: #00585f;\n}\ndiv.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container h3 {\n  color: #fff;\n}\ndiv.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-content {\n  color: #fff;\n}\ndiv.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button.prev {\n  margin-right: .625rem;\n}\ndiv.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-container .hopscotch-bubble-close {\n  outline: none;\n  color: #fff;\n}\ndiv.hopscotch-bubble.tour-hopscotch-dark .hopscotch-bubble-arrow-container::after {\n  border-color: transparent transparent #00585f #00585f;\n}\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@-moz-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -moz-transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    -moz-transform: translateY(0);\n  }\n}\n@-o-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -o-transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    -o-transform: translateY(0);\n  }\n}\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\ndiv.hopscotch-bubble.fade-in-up {\n  -webkit-animation-name: fadeInUp;\n  -moz-animation-name: fadeInUp;\n  -o-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n}\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@-moz-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -moz-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    -moz-transform: translateY(0);\n  }\n}\n@-o-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -ms-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    -ms-transform: translateY(0);\n  }\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\ndiv.hopscotch-bubble.fade-in-down {\n  -webkit-animation-name: fadeInDown;\n  -moz-animation-name: fadeInDown;\n  -o-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n@-webkit-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    -moz-transform: translateX(0);\n  }\n}\n@-o-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -o-transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    -o-transform: translateX(0);\n  }\n}\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\ndiv.hopscotch-bubble.fade-in-right {\n  -webkit-animation-name: fadeInRight;\n  -moz-animation-name: fadeInRight;\n  -o-animation-name: fadeInRight;\n  animation-name: fadeInRight;\n}\n@-webkit-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    -moz-transform: translateX(0);\n  }\n}\n@-o-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -o-transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    -o-transform: translateX(0);\n  }\n}\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\ndiv.hopscotch-bubble.fade-in-left {\n  -webkit-animation-name: fadeInLeft;\n  -moz-animation-name: fadeInLeft;\n  -o-animation-name: fadeInLeft;\n  animation-name: fadeInLeft;\n}\n\n@media (max-width: 1199px) {\n  div.hopscotch-bubble {\n    display: none;\n  }\n}\n/*Rating*/\n.rating .jq-star {\n  width: 1rem !important;\n  height: 1rem !important;\n  display: inline-block;\n  line-height: 0;\n  cursor: pointer;\n  margin-right: .25rem;\n}\n.rating .jq-star:last-child {\n  margin-right: 0;\n}\n.rating .jq-star polygon[class^=\"svg-empty\"] {\n  fill: #eaeaea;\n}\n.rating .jq-star polygon[class^=\"svg-hovered\"], .rating .jq-star polygon[class^=\"svg-rated\"], .rating .jq-star polygon[class^=\"svg-active\"] {\n  fill: #0a2f4c;\n}\n.rating .jq-star .jq-star-svg {\n  width: 100%;\n  height: 100%;\n}\n.rating.rating-yellow .jq-star polygon[class^=\"svg-hovered\"], .rating.rating-yellow .jq-star polygon[class^=\"svg-rated\"], .rating.rating-yellow .jq-star polygon[class^=\"svg-active\"] {\n  fill: #FFC400;\n}\n.rating.rating-progressive[data-rating=\"1\"] .jq-star polygon[class^=\"svg-rated\"], .rating.rating-progressive[data-rating=\"1\"] .jq-star polygon[class^=\"svg-active\"] {\n  fill: #FF0000;\n}\n.rating.rating-progressive[data-rating=\"2\"] .jq-star polygon[class^=\"svg-rated\"], .rating.rating-progressive[data-rating=\"2\"] .jq-star polygon[class^=\"svg-active\"] {\n  fill: #ffd23d;\n}\n.rating.rating-progressive[data-rating=\"3\"] .jq-star polygon[class^=\"svg-rated\"], .rating.rating-progressive[data-rating=\"3\"] .jq-star polygon[class^=\"svg-active\"] {\n  fill: #FFC400;\n}\n.rating.rating-progressive[data-rating=\"4\"] .jq-star polygon[class^=\"svg-rated\"], .rating.rating-progressive[data-rating=\"4\"] .jq-star polygon[class^=\"svg-active\"] {\n  fill: #3de09e;\n}\n.rating.rating-progressive[data-rating=\"5\"] .jq-star polygon[class^=\"svg-rated\"], .rating.rating-progressive[data-rating=\"5\"] .jq-star polygon[class^=\"svg-active\"] {\n  fill: #00D67F;\n}\n.rating.rating-progressive.rating-level-1 .jq-star polygon[class^=\"svg-hovered\"] {\n  fill: #FF0000;\n}\n.rating.rating-progressive.rating-level-2 .jq-star polygon[class^=\"svg-hovered\"] {\n  fill: #ffd23d;\n}\n.rating.rating-progressive.rating-level-3 .jq-star polygon[class^=\"svg-hovered\"] {\n  fill: #FFC400;\n}\n.rating.rating-progressive.rating-level-4 .jq-star polygon[class^=\"svg-hovered\"] {\n  fill: #3de09e;\n}\n.rating.rating-progressive.rating-level-5 .jq-star polygon[class^=\"svg-hovered\"] {\n  fill: #00D67F;\n}\n.rating.rating-lg .jq-star {\n  width: 1.5rem !important;\n  height: 1.5rem !important;\n}\n.rating.rating-xl .jq-star {\n  width: 2rem !important;\n  height: 2rem !important;\n}\n\n/*Tinyemce*/\n.editable {\n  outline: none;\n}\n\n.tox.tox-tinymce {\n  z-index: 11;\n}\n\n/*Chips*/\n.chip {\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n}\n.chip > span {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  position: relative;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: .5rem;\n  color: #262a2e;\n}\n.chip .chip-text {\n  pointer-events: none;\n}\n.chip input {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n.chip input + span {\n  pointer-events: none;\n}\n.chip.chip-primary > span {\n  background-color: #ebf5f5;\n  border: 1px solid #ebf5f5;\n  color: #0a2f4c;\n}\n.chip.chip-primary:hover input + span {\n  border-color: #c7e2e5;\n  background-color: #c7e2e5;\n}\n.chip.chip-primary input:checked + span {\n  color: #fff;\n  border-color: #0a2f4c;\n  background-color: #0a2f4c;\n}\n.chip.chip-secondary > span {\n  background-color: #f7f7f7;\n  border: 1px solid #f7f7f7;\n  color: #262a2e;\n}\n.chip.chip-secondary:hover input + span {\n  border-color: #eaeaea;\n  background-color: #eaeaea;\n}\n.chip.chip-secondary input:checked + span {\n  color: #fff;\n  border-color: #262a2e;\n  background-color: #262a2e;\n}\n.chip.chip-outline-primary > span {\n  background: transparent;\n  border: 1px solid #99cbcf;\n  color: #0a2f4c;\n}\n.chip.chip-outline-primary:hover input + span {\n  border-color: #0a2f4c;\n}\n.chip.chip-outline-primary input:checked + span {\n  color: #fff;\n  border-color: #0a2f4c;\n  background-color: #0a2f4c;\n}\n.chip.chip-outline-secondary > span {\n  background: transparent;\n  border: 1px solid #b5b5b5;\n  color: #262a2e;\n}\n.chip.chip-outline-secondary:hover input + span {\n  border-color: #262a2e;\n}\n.chip.chip-outline-secondary input:checked + span {\n  color: #fff;\n  border-color: #262a2e;\n  background-color: #262a2e;\n}\n.chip.chip-wth-icon > span i, .chip.chip-wth-icon > span .feather-icon, .chip.chip-wth-icon > span .svg-icon {\n  font-size: 1rem;\n  line-height: 1;\n  margin-right: 0.5rem;\n  display: flex;\n}\n.chip.chip-wth-icon > span .feather-icon > svg,\n.chip.chip-wth-icon > span .svg-icon > svg {\n  height: 1em;\n  width: 1em;\n}\n.chip.chip-ticked > span:before {\n  font: normal normal normal 0/1 'Material-Design-Iconic-Font';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f26b\";\n  -webkit-transition: all 0.15s ease;\n  -moz-transition: all 0.15s ease;\n  transition: all 0.15s ease;\n}\n.chip.chip-ticked > span .chip-text {\n  -webkit-transition: all 0.15s ease;\n  -moz-transition: all 0.15s ease;\n  transition: all 0.15s ease;\n}\n.chip.chip-ticked input:checked + span:before {\n  font-size: 1rem;\n}\n.chip.chip-ticked input:checked + span .chip-text {\n  margin-left: 0.5rem;\n}\n.chip.chip-dismissable .btn-close {\n  margin-left: 0.5rem;\n  color: inherit !important;\n}\n.chip.chip-pill > span {\n  border-radius: 50rem;\n}\n.chip.chip-disabled {\n  cursor: not-allowed;\n}\n.chip.chip-disabled input {\n  pointer-events: none;\n}\n.chip.chip-disabled > span {\n  border-color: #f7f7f7 !important;\n  background-color: #f7f7f7 !important;\n  color: #b5b5b5 !important;\n}\n.chip.chip-disabled > span .btn-close {\n  color: #b5b5b5 !important;\n  pointer-events: none;\n}\n.chip.user-chip > span {\n  border-radius: 50rem;\n}\n.chip.user-chip > span .avatar {\n  height: 100%;\n  width: auto;\n  padding: 0.2rem;\n  position: absolute;\n  left: 0;\n}\n.chip.user-chip > span .avatar img {\n  border-radius: 50%;\n}\n.chip.user-chip > span .chip-text {\n  margin-left: 1.375rem;\n}\n.chip.chip-lg > span {\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n}\n.chip.chip-lg.chip-wth-icon > span i, .chip.chip-lg.chip-wth-icon > span svg {\n  font-size: 1.125rem;\n}\n.chip.chip-lg.chip-ticked input:checked + span:before {\n  font-size: 1.25rem;\n}\n.chip.chip-lg.user-chip > span .chip-text {\n  margin-left: 1.875rem;\n}\n\n.tag-input {\n  border: none;\n  outline: none;\n}\n\n.tags-container .hk-chip {\n  margin-right: .625rem;\n  margin-bottom: .625rem;\n}\n\n/*Playlist widget*/\n.hk-playlist-wrap .media {\n  cursor: pointer;\n}\n.hk-playlist-wrap .media .media-body .song-name {\n  color: #262a2e;\n}\n.hk-playlist-wrap .media .media-body .palyer-action-wrap .volume-ctrl {\n  opacity: 0;\n  -webkit-transition: 0.15 ease-in-out;\n  -moz-transition: 0.15 ease-in-out;\n  transition: 0.15 ease-in-out;\n}\n.hk-playlist-wrap .media.active .media-body .song-name {\n  color: #0a2f4c;\n}\n.hk-playlist-wrap .media.active .media-body .palyer-action-wrap .volume-ctrl {\n  opacity: 1;\n}\n\n/*Ribbons*/\n.hk-ribbon-type-1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 20px;\n  background: #0a2f4c;\n  color: #fff;\n  padding: .25rem .75rem;\n  border-radius: 0.5rem;\n  font-size: 0.75rem;\n  min-height: 26px;\n  top: 0;\n  text-align: center;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.hk-ribbon-type-1 > span {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n}\n.hk-ribbon-type-1.ribbon-wth-flag:before {\n  background-color: transparent;\n  top: 0;\n  bottom: 0;\n  content: \"\";\n  position: absolute;\n  border-top: 13px solid #0a2f4c;\n  border-bottom: 13px solid #0a2f4c;\n  border-right: 13px solid #0a2f4c;\n  border-left: 0.6rem solid transparent !important;\n  left: -14px;\n}\n.hk-ribbon-type-1.ribbon-wth-flag:after {\n  background-color: transparent;\n  border: 13px solid #0a2f4c;\n  top: 0;\n  bottom: 0;\n  content: \"\";\n  position: absolute;\n  right: -14px;\n  border-top: 13px solid #0a2f4c;\n  border-bottom: 13px solid #0a2f4c;\n  border-left: 13px solid #0a2f4c;\n  border-right: 0.6rem solid transparent !important;\n}\n.hk-ribbon-type-1.overhead-start {\n  left: 14px;\n}\n.hk-ribbon-type-1.overhead-start.ribbon-wth-flag {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.hk-ribbon-type-1.overhead-start.ribbon-wth-flag:before {\n  display: none;\n}\n.hk-ribbon-type-1.overhead-end {\n  right: 14px;\n  left: auto;\n}\n.hk-ribbon-type-1.overhead-end.ribbon-wth-flag {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.hk-ribbon-type-1.overhead-end.ribbon-wth-flag:after {\n  display: none;\n}\n.hk-ribbon-type-1.overhead-center {\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  right: auto;\n}\n.hk-ribbon-type-1.overhead-center.ribbon-wth-flag {\n  border-radius: 0;\n}\n.hk-ribbon-type-1.start-over {\n  left: -14px;\n  top: 14px;\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n.hk-ribbon-type-1.start-over.ribbon-wth-flag {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.hk-ribbon-type-1.start-over.ribbon-wth-flag:before {\n  display: none;\n}\n.hk-ribbon-type-1.end-over {\n  right: -14px;\n  left: auto;\n  top: 14px;\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n.hk-ribbon-type-1.end-over.ribbon-wth-flag {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.hk-ribbon-type-1.end-over.ribbon-wth-flag:after {\n  display: none;\n}\n.hk-ribbon-type-1.start-touch {\n  left: 0;\n  top: 14px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n.hk-ribbon-type-1.start-touch.ribbon-wth-flag {\n  border-radius: 0;\n}\n.hk-ribbon-type-1.start-touch.ribbon-wth-flag:before {\n  display: none;\n}\n.hk-ribbon-type-1.end-touch {\n  right: 0;\n  left: auto;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  top: 14px;\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n.hk-ribbon-type-1.end-touch.ribbon-wth-flag {\n  border-radius: 0;\n}\n.hk-ribbon-type-1.end-touch.ribbon-wth-flag:after {\n  display: none;\n}\n.hk-ribbon-type-1.ribbon-square {\n  border-radius: 0;\n}\n.hk-ribbon-type-1.ribbon-wth-icon > span > * {\n  font-size: 1.125rem;\n  margin-right: .25rem;\n}\n.hk-ribbon-type-1.hk-ribbon-uppercase {\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n}\n.hk-ribbon-type-1.hk-ribbon-blue {\n  background: #298DFF;\n}\n.hk-ribbon-type-1.hk-ribbon-blue.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-blue.ribbon-wth-flag:after {\n  border-color: #298DFF;\n}\n.hk-ribbon-type-1.hk-ribbon-primary {\n  background: #0a2f4c;\n}\n.hk-ribbon-type-1.hk-ribbon-primary.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-primary.ribbon-wth-flag:after {\n  border-color: #0a2f4c;\n}\n.hk-ribbon-type-1.hk-ribbon-info {\n  background: #18DDEF;\n}\n.hk-ribbon-type-1.hk-ribbon-info.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-info.ribbon-wth-flag:after {\n  border-color: #18DDEF;\n}\n.hk-ribbon-type-1.hk-ribbon-cyan {\n  background: #18DDEF;\n}\n.hk-ribbon-type-1.hk-ribbon-cyan.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-cyan.ribbon-wth-flag:after {\n  border-color: #18DDEF;\n}\n.hk-ribbon-type-1.hk-ribbon-green {\n  background: #00D67F;\n}\n.hk-ribbon-type-1.hk-ribbon-green.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-green.ribbon-wth-flag:after {\n  border-color: #00D67F;\n}\n.hk-ribbon-type-1.hk-ribbon-success {\n  background: #00D67F;\n}\n.hk-ribbon-type-1.hk-ribbon-success.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-success.ribbon-wth-flag:after {\n  border-color: #00D67F;\n}\n.hk-ribbon-type-1.hk-ribbon-red {\n  background: #FF0000;\n}\n.hk-ribbon-type-1.hk-ribbon-red.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-red.ribbon-wth-flag:after {\n  border-color: #FF0000;\n}\n.hk-ribbon-type-1.hk-ribbon-danger {\n  background: #FF0000;\n}\n.hk-ribbon-type-1.hk-ribbon-danger.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-danger.ribbon-wth-flag:after {\n  border-color: #FF0000;\n}\n.hk-ribbon-type-1.hk-ribbon-yellow {\n  background: #FFC400;\n}\n.hk-ribbon-type-1.hk-ribbon-yellow.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-yellow.ribbon-wth-flag:after {\n  border-color: #FFC400;\n}\n.hk-ribbon-type-1.hk-ribbon-warning {\n  background: #FFC400;\n}\n.hk-ribbon-type-1.hk-ribbon-warning.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-warning.ribbon-wth-flag:after {\n  border-color: #FFC400;\n}\n.hk-ribbon-type-1.hk-ribbon-sky {\n  background: #00B0FF;\n}\n.hk-ribbon-type-1.hk-ribbon-sky.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-sky.ribbon-wth-flag:after {\n  border-color: #00B0FF;\n}\n.hk-ribbon-type-1.hk-ribbon-pink {\n  background: #E92990;\n}\n.hk-ribbon-type-1.hk-ribbon-pink.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-pink.ribbon-wth-flag:after {\n  border-color: #E92990;\n}\n.hk-ribbon-type-1.hk-ribbon-purple {\n  background: #C02FF3;\n}\n.hk-ribbon-type-1.hk-ribbon-purple.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-purple.ribbon-wth-flag:after {\n  border-color: #C02FF3;\n}\n.hk-ribbon-type-1.hk-ribbon-violet {\n  background: #7429F8;\n}\n.hk-ribbon-type-1.hk-ribbon-violet.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-violet.ribbon-wth-flag:after {\n  border-color: #7429F8;\n}\n.hk-ribbon-type-1.hk-ribbon-indigo {\n  background: #0069F7;\n}\n.hk-ribbon-type-1.hk-ribbon-indigo.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-indigo.ribbon-wth-flag:after {\n  border-color: #0069F7;\n}\n.hk-ribbon-type-1.hk-ribbon-teal {\n  background: #0a2f4c;\n}\n.hk-ribbon-type-1.hk-ribbon-teal.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-teal.ribbon-wth-flag:after {\n  border-color: #0a2f4c;\n}\n.hk-ribbon-type-1.hk-ribbon-neon {\n  background: #81E230;\n}\n.hk-ribbon-type-1.hk-ribbon-neon.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-neon.ribbon-wth-flag:after {\n  border-color: #81E230;\n}\n.hk-ribbon-type-1.hk-ribbon-lime {\n  background: #C2E939;\n}\n.hk-ribbon-type-1.hk-ribbon-lime.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-lime.ribbon-wth-flag:after {\n  border-color: #C2E939;\n}\n.hk-ribbon-type-1.hk-ribbon-sun {\n  color: #262a2e;\n  background: #FFEA00;\n}\n.hk-ribbon-type-1.hk-ribbon-sun.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-sun.ribbon-wth-flag:after {\n  border-color: #FFEA00;\n}\n.hk-ribbon-type-1.hk-ribbon-orange {\n  background: #FF9100;\n}\n.hk-ribbon-type-1.hk-ribbon-orange.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-orange.ribbon-wth-flag:after {\n  border-color: #FF9100;\n}\n.hk-ribbon-type-1.hk-ribbon-pumpkin {\n  background: #FF5700;\n}\n.hk-ribbon-type-1.hk-ribbon-pumpkin.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-pumpkin.ribbon-wth-flag:after {\n  border-color: #FF5700;\n}\n.hk-ribbon-type-1.hk-ribbon-brown {\n  background: #954D15;\n}\n.hk-ribbon-type-1.hk-ribbon-brown.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-brown.ribbon-wth-flag:after {\n  border-color: #954D15;\n}\n.hk-ribbon-type-1.hk-ribbon-gold {\n  background: #C39749;\n}\n.hk-ribbon-type-1.hk-ribbon-gold.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-gold.ribbon-wth-flag:after {\n  border-color: #C39749;\n}\n.hk-ribbon-type-1.hk-ribbon-smoke {\n  background: #5e7d8a;\n}\n.hk-ribbon-type-1.hk-ribbon-smoke.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-smoke.ribbon-wth-flag:after {\n  border-color: #5e7d8a;\n}\n.hk-ribbon-type-1.hk-ribbon-grey {\n  background: #9e9e9e;\n}\n.hk-ribbon-type-1.hk-ribbon-grey.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-grey.ribbon-wth-flag:after {\n  border-color: #9e9e9e;\n}\n.hk-ribbon-type-1.hk-ribbon-secondary {\n  background: #6f6f6f;\n}\n.hk-ribbon-type-1.hk-ribbon-secondary.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-secondary.ribbon-wth-flag:after {\n  border-color: #6f6f6f;\n}\n.hk-ribbon-type-1.hk-ribbon-light {\n  background: #eaeaea;\n  color: #262a2e;\n}\n.hk-ribbon-type-1.hk-ribbon-light.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-light.ribbon-wth-flag:after {\n  border-color: #eaeaea;\n}\n.hk-ribbon-type-1.hk-ribbon-dark {\n  background: #262a2e;\n}\n.hk-ribbon-type-1.hk-ribbon-dark.ribbon-wth-flag:before, .hk-ribbon-type-1.hk-ribbon-dark.ribbon-wth-flag:after {\n  border-color: #262a2e;\n}\n\n.hk-ribbon-type-2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 20px;\n  background: #0a2f4c;\n  color: #fff;\n  padding: .25rem .5rem;\n  font-size: 1.125rem;\n  font-weight: 500;\n  top: -8px;\n  height: 39px;\n  width: 34px;\n  text-align: center;\n}\n.hk-ribbon-type-2 > span {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  font-size: 1.25rem;\n}\n.hk-ribbon-type-2:after {\n  background-color: transparent;\n  border-top: 17px solid #0a2f4c;\n  border-right: 17px solid #0a2f4c;\n  border-left: 17px solid #0a2f4c;\n  border-bottom: 0.6rem solid transparent !important;\n  bottom: -10px;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.hk-ribbon-type-2.overhead-start {\n  left: 20px;\n}\n.hk-ribbon-type-2.overhead-end {\n  right: 20px;\n  left: auto;\n}\n.hk-ribbon-type-2.overhead-center {\n  left: 50%;\n  -webkit-transform: translate(-50%, 0);\n  -moz-transform: translate(-50%, 0);\n  -ms-transform: translate(-50%, 0);\n  -o-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  right: auto;\n}\n.hk-ribbon-type-2.top-touch {\n  -webkit-transform: none;\n  -moz-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n  top: 0;\n}\n.hk-ribbon-type-2.top-touch.overhead-center {\n  -webkit-transform: translate(-50%, 0);\n  -moz-transform: translate(-50%, 0);\n  -ms-transform: translate(-50%, 0);\n  -o-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n}\n.hk-ribbon-type-2.hk-ribbon-blue {\n  background: #298DFF;\n}\n.hk-ribbon-type-2.hk-ribbon-blue:after {\n  border-color: #298DFF;\n}\n.hk-ribbon-type-2.hk-ribbon-primary {\n  background: #0a2f4c;\n}\n.hk-ribbon-type-2.hk-ribbon-primary:after {\n  border-color: #0a2f4c;\n}\n.hk-ribbon-type-2.hk-ribbon-cyan {\n  background: #18DDEF;\n}\n.hk-ribbon-type-2.hk-ribbon-cyan:before, .hk-ribbon-type-2.hk-ribbon-cyan:after {\n  border-color: #18DDEF;\n}\n.hk-ribbon-type-2.hk-ribbon-info {\n  background: #18DDEF;\n}\n.hk-ribbon-type-2.hk-ribbon-info:before, .hk-ribbon-type-2.hk-ribbon-info:after {\n  border-color: #18DDEF;\n}\n.hk-ribbon-type-2.hk-ribbon-green {\n  background: #00D67F;\n}\n.hk-ribbon-type-2.hk-ribbon-green:before, .hk-ribbon-type-2.hk-ribbon-green:after {\n  border-color: #00D67F;\n}\n.hk-ribbon-type-2.hk-ribbon-success {\n  background: #00D67F;\n}\n.hk-ribbon-type-2.hk-ribbon-success:before, .hk-ribbon-type-2.hk-ribbon-success:after {\n  border-color: #00D67F;\n}\n.hk-ribbon-type-2.hk-ribbon-red {\n  background: #FF0000;\n}\n.hk-ribbon-type-2.hk-ribbon-red:before, .hk-ribbon-type-2.hk-ribbon-red:after {\n  border-color: #FF0000;\n}\n.hk-ribbon-type-2.hk-ribbon-danger {\n  background: #FF0000;\n}\n.hk-ribbon-type-2.hk-ribbon-danger:before, .hk-ribbon-type-2.hk-ribbon-danger:after {\n  border-color: #FF0000;\n}\n.hk-ribbon-type-2.hk-ribbon-yellow {\n  background: #FFC400;\n}\n.hk-ribbon-type-2.hk-ribbon-yellow:before, .hk-ribbon-type-2.hk-ribbon-yellow:after {\n  border-color: #FFC400;\n}\n.hk-ribbon-type-2.hk-ribbon-warning {\n  background: #FFC400;\n}\n.hk-ribbon-type-2.hk-ribbon-warning:before, .hk-ribbon-type-2.hk-ribbon-warning:after {\n  border-color: #FFC400;\n}\n.hk-ribbon-type-2.hk-ribbon-sky {\n  background: #00B0FF;\n}\n.hk-ribbon-type-2.hk-ribbon-sky:before, .hk-ribbon-type-2.hk-ribbon-sky:after {\n  border-color: #00B0FF;\n}\n.hk-ribbon-type-2.hk-ribbon-pink {\n  background: #E92990;\n}\n.hk-ribbon-type-2.hk-ribbon-pink:before, .hk-ribbon-type-2.hk-ribbon-pink:after {\n  border-color: #E92990;\n}\n.hk-ribbon-type-2.hk-ribbon-purple {\n  background: #C02FF3;\n}\n.hk-ribbon-type-2.hk-ribbon-purple:before, .hk-ribbon-type-2.hk-ribbon-purple:after {\n  border-color: #C02FF3;\n}\n.hk-ribbon-type-2.hk-ribbon-violet {\n  background: #7429F8;\n}\n.hk-ribbon-type-2.hk-ribbon-violet:before, .hk-ribbon-type-2.hk-ribbon-violet:after {\n  border-color: #7429F8;\n}\n.hk-ribbon-type-2.hk-ribbon-indigo {\n  background: #0069F7;\n}\n.hk-ribbon-type-2.hk-ribbon-indigo:before, .hk-ribbon-type-2.hk-ribbon-indigo:after {\n  border-color: #0069F7;\n}\n.hk-ribbon-type-2.hk-ribbon-teal {\n  background: #0a2f4c;\n}\n.hk-ribbon-type-2.hk-ribbon-teal:before, .hk-ribbon-type-2.hk-ribbon-teal:after {\n  border-color: #0a2f4c;\n}\n.hk-ribbon-type-2.hk-ribbon-neon {\n  background: #81E230;\n}\n.hk-ribbon-type-2.hk-ribbon-neon:before, .hk-ribbon-type-2.hk-ribbon-neon:after {\n  border-color: #81E230;\n}\n.hk-ribbon-type-2.hk-ribbon-lime {\n  background: #C2E939;\n}\n.hk-ribbon-type-2.hk-ribbon-lime:before, .hk-ribbon-type-2.hk-ribbon-lime:after {\n  border-color: #C2E939;\n}\n.hk-ribbon-type-2.hk-ribbon-sun {\n  background: #FFEA00;\n  color: #262a2e;\n}\n.hk-ribbon-type-2.hk-ribbon-sun:before, .hk-ribbon-type-2.hk-ribbon-sun:after {\n  border-color: #FFEA00;\n}\n.hk-ribbon-type-2.hk-ribbon-orange {\n  background: #FF9100;\n}\n.hk-ribbon-type-2.hk-ribbon-orange:before, .hk-ribbon-type-2.hk-ribbon-orange:after {\n  border-color: #FF9100;\n}\n.hk-ribbon-type-2.hk-ribbon-pumpkin {\n  background: #FF5700;\n}\n.hk-ribbon-type-2.hk-ribbon-pumpkin:before, .hk-ribbon-type-2.hk-ribbon-pumpkin:after {\n  border-color: #FF5700;\n}\n.hk-ribbon-type-2.hk-ribbon-brown {\n  background: #954D15;\n}\n.hk-ribbon-type-2.hk-ribbon-brown:before, .hk-ribbon-type-2.hk-ribbon-brown:after {\n  border-color: #954D15;\n}\n.hk-ribbon-type-2.hk-ribbon-gold {\n  background: #C39749;\n}\n.hk-ribbon-type-2.hk-ribbon-gold:before, .hk-ribbon-type-2.hk-ribbon-gold:after {\n  border-color: #C39749;\n}\n.hk-ribbon-type-2.hk-ribbon-smoke {\n  background: #5e7d8a;\n}\n.hk-ribbon-type-2.hk-ribbon-smoke:before, .hk-ribbon-type-2.hk-ribbon-smoke:after {\n  border-color: #5e7d8a;\n}\n.hk-ribbon-type-2.hk-ribbon-grey {\n  background: #9e9e9e;\n}\n.hk-ribbon-type-2.hk-ribbon-grey:before, .hk-ribbon-type-2.hk-ribbon-grey:after {\n  border-color: #9e9e9e;\n}\n.hk-ribbon-type-2.hk-ribbon-secondary {\n  background: #6f6f6f;\n}\n.hk-ribbon-type-2.hk-ribbon-secondary:before, .hk-ribbon-type-2.hk-ribbon-secondary:after {\n  border-color: #6f6f6f;\n}\n.hk-ribbon-type-2.hk-ribbon-light {\n  background: #eaeaea;\n  color: #262a2e;\n}\n.hk-ribbon-type-2.hk-ribbon-light:before, .hk-ribbon-type-2.hk-ribbon-light:after {\n  border-color: #eaeaea;\n}\n.hk-ribbon-type-2.hk-ribbon-dark {\n  background: #262a2e;\n}\n.hk-ribbon-type-2.hk-ribbon-dark:before, .hk-ribbon-type-2.hk-ribbon-dark:after {\n  border-color: #262a2e;\n}\n\n/*Advance Badges*/\n.badge-icon {\n  width: 4rem;\n  height: 4.313rem;\n  font-size: 2.25rem;\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.badge-icon > svg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n}\n.badge-icon .badge-icon-wrap {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  height: 100%;\n  width: 100%;\n  color: #fff;\n  position: relative;\n  z-index: 1;\n}\n.badge-icon.badge-icon-lg {\n  width: 6rem;\n  height: 6.031rem;\n  font-size: 3.25rem;\n}\n.badge-icon.badge-icon-md {\n  width: 5rem;\n  height: 5.031rem;\n  font-size: 2.75rem;\n}\n.badge-icon.badge-icon-sm {\n  width: 3rem;\n  height: 3.313rem;\n  font-size: 1.75rem;\n}\n.badge-icon.badge-icon-xs {\n  width: 2rem;\n  height: 2.313rem;\n  font-size: 1.25rem;\n}\n.badge-icon.badge-icon-xxs {\n  width: 1.5rem;\n  height: 1.813rem;\n  font-size: 1rem;\n}\n.badge-icon.badge-circle {\n  height: 4rem;\n}\n.badge-icon.badge-circle.badge-icon-lg {\n  height: 6rem;\n}\n.badge-icon.badge-circle.badge-icon-md {\n  height: 5rem;\n}\n.badge-icon.badge-circle.badge-icon-sm {\n  height: 3rem;\n}\n.badge-icon.badge-circle.badge-icon-xs {\n  height: 2rem;\n}\n.badge-icon.badge-circle.badge-icon-xxs {\n  height: 1.5rem;\n}\n.badge-icon.badge-level {\n  position: relative;\n}\n.badge-icon.badge-level > span {\n  position: absolute;\n  bottom: 0;\n  right: 16%;\n  z-index: 1;\n  font-weight: 600;\n  color: inherit;\n  font-size: 40%;\n  background: transparent;\n}\n.badge-icon.badge-level > span:before {\n  content: attr(title);\n  position: absolute;\n  -webkit-text-stroke: 4px #fff;\n  left: 0;\n  z-index: -1;\n}\n\n.avatar.custom-badge-on-avatar .badge-icon {\n  font-size: inherit;\n}\n\n/*Callout*/\n.callout {\n  margin-bottom: 0;\n}\n.callout.callout-floating {\n  position: fixed;\n  width: 300px;\n  z-index: 1055;\n  margin-bottom: 0;\n}\n.callout.callout-floating.top-end {\n  top: 25px;\n  right: 25px;\n}\n.callout.callout-floating.bottom-end {\n  bottom: 25px;\n  right: 25px;\n}\n.callout.callout-floating.top-start {\n  top: 25px;\n  left: 25px;\n}\n.callout.callout-floating.bottom-start {\n  bottom: 25px;\n  left: 25px;\n}\n.callout.callout-floating.top-center {\n  top: 25px;\n  left: 50%;\n  width: auto;\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.callout.callout-floating.bottom-center {\n  bottom: 25px;\n  left: 50%;\n  width: auto;\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n.callout.callout-dark {\n  color: #fff;\n}\n.callout.callout-dark h1, .callout.callout-dark h2, .callout.callout-dark h3, .callout.callout-dark h4, .callout.callout-dark h5, .callout.callout-dark h6, .callout.callout-dark p {\n  color: inherit;\n}\n\n/*Toolbar*/\n.hk-toolbar .nav {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n  height: 100%;\n}\n.hk-toolbar .nav .nav-item {\n  height: 100%;\n}\n.hk-toolbar.toolbar-asymmetric {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n/*Filter Component*/\n.btn-filter {\n  color: #6f6f6f;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f7f7f7;\n}\n.btn-filter:hover, .btn-filter:focus {\n  color: #6f6f6f;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f7f7f7;\n}\n.btn-filter.active {\n  color: #0a2f4c;\n  background-color: #ebf5f5;\n  border-color: #0a2f4c;\n  box-shadow: none !important;\n}\n.btn-filter.active:hover, .btn-filter.active:focus {\n  color: #0a2f4c;\n  background-color: #ebf5f5;\n  border-color: #0a2f4c;\n}\n\n.filter-block-wrap .filter-block.card .card-img {\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.filter-block-wrap .filter-block.card .card-img-overlay {\n  background-color: rgba(38, 42, 46, var(--bs-bg-opacity));\n}\n.filter-block-wrap .filter-block.card input {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n.filter-block-wrap .filter-block.card input:checked ~ .card-img-overlay {\n  background-color: rgba(41, 141, 255, var(--bs-bg-opacity));\n}\n\n/*Content sidebar*/\n[data-content-sidebar=\"active\"].hk-wrapper .hk-pg-wrapper {\n  margin-right: 17.5rem;\n}\n[data-content-sidebar=\"active\"].hk-wrapper .hk-content-sidebar {\n  position: fixed;\n  top: 64px;\n  overflow-y: auto;\n  width: 280px;\n  right: 0;\n  z-index: 2;\n  background: #fff;\n  padding-top: 1.5rem;\n  border-left: 1px solid #d8d8d8;\n  bottom: 0;\n}\n[data-content-sidebar=\"active\"].hk-wrapper .hk-content-sidebar .sidebar-content-wrap {\n  padding: 1.25rem;\n}\n\n/*Fixed Footer*/\n.hk-fixed-footer {\n  position: fixed;\n  bottom: 0;\n  z-index: 1032;\n  background: #fff;\n  box-shadow: 1px 1px 3px 5px rgba(0, 0, 0, 0.1);\n  right: 0;\n  left: 0;\n}\n\n.hk-wrapper.fixed-footer-active .hk-pg-wrapper {\n  padding-bottom: 8.125rem;\n}\n\n/*Dragula*/\n.gu-mirror {\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: grabbing;\n  position: fixed !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  opacity: 1;\n}\n\n.dragula-demo .dragula-block {\n  border: 1px dotted #b5b5b5;\n  border-radius: .25rem;\n  padding: .625rem;\n}\n.dragula-demo .dragula-block > div {\n  border: 1px solid #d8d8d8;\n  border-radius: .25rem;\n  margin: .625rem;\n  padding: .625rem;\n  cursor: move;\n}\n\n/*Authantication Pages*/\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .hk-pg-body .auth-content {\n  min-height: calc(100vh - 249px);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .v-separator {\n  margin: 0;\n  position: relative;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .v-separator:after {\n  height: 100%;\n  right: 0;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .v-separator.separator-sm:after {\n  height: 70%;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split {\n  min-height: 100vh;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content {\n  min-height: 100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  position: relative;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content mark {\n  z-index: 1;\n  color: #262a2e;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content mark:after {\n  z-index: -1;\n  background: #00D67F;\n  opacity: 1;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link {\n  font-size: 0.75rem;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .feather-icon, .hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .svg-icon {\n  margin-right: .25rem;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .feather-icon svg, .hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .auth-content .extr-link .svg-icon svg {\n  height: 14px;\n  width: 14px;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .credit-text {\n  position: absolute;\n  left: 30px;\n  bottom: 30px;\n  mix-blend-mode: inherit;\n}\n.hk-wrapper.hk-pg-auth .hk-pg-wrapper .auth-split .bg-img {\n  position: absolute;\n  left: 0;\n  top: 0;\n  max-width: 100%;\n  object-fit: cover;\n  height: 100%;\n  z-index: -1;\n}\n\n@media (max-width: 767px) {\n  .hk-wrapper.hk-pg-auth .hk-pg-wrapper .hk-pg-body .container-xxl .auth-content {\n    min-height: auto;\n    -webkit-box-align: flex-start;\n    -ms-flex-align: flex-start;\n    align-items: flex-start;\n  }\n  .hk-wrapper.hk-pg-auth .v-separator:after {\n    display: none;\n  }\n}\n/****************************/\n/** Componets Import **/\n/****************************/\n/*------------------------------------------------------------------\n[Header]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/*Top Nav*/\n.hk-wrapper .hk-navbar {\n  border-bottom: 1px solid #eaeaea;\n  height: 65px;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown .dropdown-menu, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown .apexcharts-menu {\n  position: absolute;\n  right:10px;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu {\n  width: 21.875rem;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-header, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-header, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-header {\n  color: #262a2e;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  border-bottom: 1px solid #f7f7f7;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-body, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-body, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-body {\n  height: 23.75rem;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-footer, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-footer, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-footer {\n  border-top: 1px solid #f7f7f7;\n  padding: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  color: #0a2f4c;\n  font-size: 0.875rem;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item {\n  white-space: inherit;\n  padding-top: .75rem;\n  padding-bottom: .75rem;\n  border-radius: .5rem;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-head, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-head, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-head {\n  margin-right: 1rem;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-body > div .notifications-info, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-top: .25rem;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-body > div .notifications-info > .badge, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info > .badge, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info > .badge {\n  margin-right: .625rem;\n}\n.hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .dropdown-menu .dropdown-item .media .media-body > div .notifications-info .notifications-time, .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-toolbar .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info .notifications-time, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-nav .nav-item .dropdown.dropdown-notifications .apexcharts-menu .dropdown-item .media .media-body > div .notifications-info .notifications-time {\n  font-size: 0.75rem;\n  color: #6f6f6f;\n}\n.hk-wrapper .hk-navbar .navbar-search {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input > span.btn-input-clear, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle > span.btn-input-clear {\n  display: none;\n}\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-suffix, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-suffix,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-prefix,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-prefix,\n.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-prefix,\n.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-prefix,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-prefix {\n  pointer-events: none;\n}\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-suffix > span.spinner-border, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-suffix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control + .input-prefix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select + .input-prefix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input + .input-prefix > span.spinner-border,\n.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input + .input-prefix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle + .input-prefix > span.spinner-border {\n  display: none;\n}\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-suffix, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-suffix, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-suffix,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-prefix,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-prefix,\n.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-prefix,\n.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-prefix,\n.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-prefix {\n  border: none;\n  pointer-events: auto;\n}\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border), .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-suffix > span:not(.btn-input-clear):not(.spinner-border),\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),\n.hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),\n.hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),\n.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border),\n.hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-prefix > span:not(.btn-input-clear):not(.spinner-border) {\n  display: none;\n}\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-suffix > span.btn-input-clear, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-suffix > span.btn-input-clear,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-prefix > span.btn-input-clear,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-prefix > span.btn-input-clear,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-prefix > span.btn-input-clear,\n.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-prefix > span.btn-input-clear,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-prefix > span.btn-input-clear {\n  display: none !important;\n}\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-suffix > span.spinner-border, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-suffix > span.spinner-border, .hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-suffix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-control:focus + .input-prefix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.form-select:focus + .input-prefix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading .wizard > .content > .body input:focus + .input-prefix > span.spinner-border,\n.wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search.loading input:focus + .input-prefix > span.spinner-border,\n.hk-wrapper .hk-navbar .navbar-search .input-search.loading input.dd-handle:focus + .input-prefix > span.spinner-border {\n  display: inline;\n}\n.hk-wrapper .hk-navbar .navbar-search .dropdown-menu, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu {\n  width: 18rem;\n}\n.hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-body, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-body, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-body {\n  max-height: 19.75rem;\n}\n.hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-footer, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-footer, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-footer {\n  border-top: 1px solid #f7f7f7;\n  padding: 1rem;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  color: #0a2f4c;\n  font-size: 0.875rem;\n}\n.hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-item, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-item, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-item {\n  white-space: inherit;\n}\n.hk-wrapper .hk-navbar .nav-start-wrap,\n.hk-wrapper .hk-navbar .nav-end-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-wrapper .hk-navbar .nav-start-wrap > .navbar-nav,\n.hk-wrapper .hk-navbar .nav-end-wrap > .navbar-nav {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-wrapper .hk-navbar .navbar-brand .brand-img:last-child {\n  margin-left: 0.5rem;\n}\n.login-brand-image{\n  width:200px;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .hk-navbar {\n  -webkit-transform: translateY(-100%);\n  -moz-transform: translateY(-100%);\n  -ms-transform: translateY(-100%);\n  -o-transform: translateY(-100%);\n  transform: translateY(-100%);\n  overflow: hidden;\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] .hk-pg-wrapper {\n  padding-top: 0;\n}\n\n@media (min-width: 992px) {\n  .hk-wrapper .hk-navbar {\n    -webkit-transition: 0.2s ease;\n    -moz-transition: 0.2s ease;\n    transition: 0.2s ease;\n  }\n}\n@media (min-width: 1200px) {\n  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-control, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle {\n    width: 18rem;\n  }\n  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-suffix > span.btn-input-clear, .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-suffix > span.btn-input-clear, .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-suffix > span.btn-input-clear,\n  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-control:focus + .input-prefix > span.btn-input-clear,\n  .hk-wrapper .hk-navbar .navbar-search .input-search input.form-select:focus + .input-prefix > span.btn-input-clear,\n  .hk-wrapper .hk-navbar .navbar-search .input-search .wizard > .content > .body input:focus + .input-prefix > span.btn-input-clear,\n  .wizard > .content > .body .hk-wrapper .hk-navbar .navbar-search .input-search input:focus + .input-prefix > span.btn-input-clear,\n  .hk-wrapper .hk-navbar .navbar-search .input-search input.dd-handle:focus + .input-prefix > span.btn-input-clear {\n    display: inline !important;\n  }\n  .hk-wrapper .hk-navbar .nav-start-wrap,\n  .hk-wrapper .hk-navbar .nav-end-wrap {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .hk-wrapper .hk-navbar .nav-start-wrap > .navbar-nav,\n  .hk-wrapper .hk-navbar .nav-end-wrap > .navbar-nav {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n  .hk-wrapper[data-navbar-style=\"collapsed\"][data-layout=\"horizontal\"] .hk-pg-wrapper {\n    padding-top: 65px;\n  }\n  .hk-wrapper[data-navbar-style=\"collapsed\"][data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu {\n    top: 0;\n  }\n}\n@media (max-width: 1199px) {\n  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-suffix,\n  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-prefix {\n    pointer-events: auto !important;\n  }\n  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-suffix > span.btn-input-clear,\n  .hk-wrapper .hk-navbar .navbar-search .mobile-search .input-search .input-prefix > span.btn-input-clear {\n    display: inline !important;\n  }\n  .hk-wrapper .hk-navbar .navbar-search .dropdown-menu, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  .hk-wrapper .hk-navbar .navbar-search .dropdown-menu .dropdown-body, .hk-wrapper .hk-navbar .navbar-search .apexcharts-toolbar .apexcharts-menu .dropdown-body, .apexcharts-toolbar .hk-wrapper .hk-navbar .navbar-search .apexcharts-menu .dropdown-body {\n    max-height: calc(100% - 55px);\n  }\n}\n/*------------------------------------------------------------------\n[Footer]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/*Footer*/\n[data-footer=\"simple\"].hk-wrapper .hk-pg-wrapper, .footer-simple-example.hk-wrapper .hk-pg-wrapper {\n  /*padding-bottom: 120px;*/\n}\n[data-footer=\"simple\"] .hk-footer, .footer-simple-example .hk-footer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-top: 1px solid #eaeaea;\n  background: #fff;\n}\n[data-footer=\"simple\"] .hk-footer .footer > .row, .footer-simple-example .hk-footer .footer > .row {\n  height: 60px;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  padding: 22px 0;\n}\n[data-footer=\"simple\"] .hk-footer .footer .footer-text, .footer-simple-example .hk-footer .footer .footer-text {\n  font-size: 0.75rem;\n}\n[data-footer=\"simple\"] .hk-footer .footer .footer-text a, .footer-simple-example .hk-footer .footer .footer-text a {\n  color: #08364d;\n}\n[data-footer=\"simple\"] .hk-footer .footer .footer-text .copy-text, .footer-simple-example .hk-footer .footer .footer-text .copy-text {\n  padding-right: 5px;\n}\n[data-footer=\"simple\"] .hk-footer .footer .footer-text .footer-link-sep, .footer-simple-example .hk-footer .footer .footer-text .footer-link-sep {\n  padding: 0 5px;\n  color: #d8d8d8;\n}\n[data-footer=\"simple\"] .hk-footer .footer .footer-extr-link, .footer-simple-example .hk-footer .footer .footer-extr-link {\n  font-size: 0.75rem;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n}\n[data-footer=\"simple\"] .hk-footer .footer .footer-extr-link .feather-icon, .footer-simple-example .hk-footer .footer .footer-extr-link .feather-icon {\n  margin-right: .25rem;\n  color: #08364d;\n}\n[data-footer=\"simple\"] .hk-footer .footer .footer-extr-link .feather-icon svg, .footer-simple-example .hk-footer .footer .footer-extr-link .feather-icon svg {\n  height: 14px;\n  width: 14px;\n}\n[data-footer=\"simple\"] .hk-footer.footer-wth-bg, .footer-simple-example .hk-footer.footer-wth-bg {\n  background: #f7f7f7;\n  border-top: none;\n}\n\n[data-footer=\"complex\"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {\n  padding-bottom: 400px;\n}\n[data-footer=\"complex\"] .hk-footer, .footer-complex-example .hk-footer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  border-top: 1px solid #d8d8d8;\n}\n[data-footer=\"complex\"] .hk-footer.footer-wth-bg, .footer-complex-example .hk-footer.footer-wth-bg {\n  background: #f7f7f7;\n  border-top: none;\n}\n[data-footer=\"complex\"] .hk-footer .footer, .footer-complex-example .hk-footer .footer {\n  padding-top: 40px;\n  padding-bottom: 30px;\n}\n[data-footer=\"complex\"] .hk-footer .footer > .row:last-child, .footer-complex-example .hk-footer .footer > .row:last-child {\n  margin-top: 3.375rem;\n  align-items: center;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-brand, .footer-complex-example .hk-footer .footer .footer-brand {\n  display: block;\n  margin-bottom: .25rem;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-info-text, .footer-complex-example .hk-footer .footer .footer-info-text {\n  font-size: 0.875rem;\n  width: 85%;\n}\n[data-footer=\"complex\"] .hk-footer .footer .quick-links-head, .footer-complex-example .hk-footer .footer .quick-links-head {\n  text-transform: uppercase;\n  margin-bottom: 1rem;\n  font-size: .85rem;\n  font-weight: 600;\n}\n[data-footer=\"complex\"] .hk-footer .footer .quick-links, .footer-complex-example .hk-footer .footer .quick-links {\n  display: block;\n  color: #262a2e;\n  margin-bottom: .25rem;\n  font-size: 0.875rem;\n}\n[data-footer=\"complex\"] .hk-footer .footer .quick-links:hover, .footer-complex-example .hk-footer .footer .quick-links:hover {\n  color: #262a2e;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-text, .footer-complex-example .hk-footer .footer .footer-text {\n  font-size: 0.75rem;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-text a, .footer-complex-example .hk-footer .footer .footer-text a {\n  color: #0a2f4c;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-text .copy-text, .footer-complex-example .hk-footer .footer .footer-text .copy-text {\n  padding-right: .25rem;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-text .footer-link-sep, .footer-complex-example .hk-footer .footer .footer-text .footer-link-sep {\n  padding: 0 .25rem;\n  color: #d8d8d8;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n}\n[data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap .btn, [data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions [data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .btn, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button {\n  margin-left: .625rem;\n  flex-shrink: 0;\n}\n\n.footer-complex-example.hk-wrapper .hk-pg-wrapper {\n  padding-bottom: 120px;\n}\n\n@media (max-width: 1400px) {\n  [data-footer=\"complex\"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {\n    padding-bottom: 31.875rem;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer .footer-info-text, .footer-complex-example .hk-footer .footer .footer-info-text {\n    width: 100%;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer > .row > .col-xl-6, .footer-complex-example .hk-footer .footer > .row > .col-xl-6 {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer > .row > .col-xl-6:last-child, .footer-complex-example .hk-footer .footer > .row > .col-xl-6:last-child {\n    margin-top: 2.125rem;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer > .row:last-child, .footer-complex-example .hk-footer .footer > .row:last-child {\n    margin-top: 2.125rem;\n  }\n}\n@media (max-width: 1199px) {\n  [data-footer=\"simple\"] .hk-footer .footer > .row, .footer-simple-example .hk-footer .footer > .row {\n    height: auto;\n  }\n  [data-footer=\"simple\"] .hk-footer .footer > .row > .col-xl-6 .col-xl-4, .footer-simple-example .hk-footer .footer > .row > .col-xl-6 .col-xl-4 {\n    margin-bottom: 1.875rem;\n  }\n  [data-footer=\"simple\"] .hk-footer .footer > .row > .col-xl-6 .col-xl-4:last-child, .footer-simple-example .hk-footer .footer > .row > .col-xl-6 .col-xl-4:last-child {\n    margin-bottom: 0;\n  }\n  [data-footer=\"simple\"] .hk-footer .footer .footer-text, .footer-simple-example .hk-footer .footer .footer-text {\n    text-align: center;\n    margin-bottom: .625rem;\n  }\n  [data-footer=\"simple\"] .hk-footer .footer .footer-extr-link, .footer-simple-example .hk-footer .footer .footer-extr-link {\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n  }\n\n  [data-footer=\"complex\"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {\n    padding-bottom: 34.5rem;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap {\n    justify-content: flex-start;\n    -webkit-justify-content: flex-start;\n    -ms-flex-pack: flex-start;\n    margin-top: 1.5rem;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap .btn:first-child, [data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:first-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions [data-footer=\"complex\"] .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button:first-child, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .btn:first-child, .footer-complex-example .hk-footer .footer .footer-social-btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:first-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .footer-complex-example .hk-footer .footer .footer-social-btn-wrap .hopscotch-nav-button:first-child {\n    margin-left: 0;\n  }\n}\n@media (max-width: 767px) {\n  [data-footer=\"complex\"].hk-wrapper .hk-pg-wrapper, .footer-complex-example.hk-wrapper .hk-pg-wrapper {\n    padding-bottom: 63rem;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer > .row > .col-xl-6 .col-md-4, .footer-complex-example .hk-footer .footer > .row > .col-xl-6 .col-md-4 {\n    margin-bottom: 1.875rem;\n  }\n  [data-footer=\"complex\"] .hk-footer .footer > .row > .col-xl-6 .col-md-4:last-child, .footer-complex-example .hk-footer .footer > .row > .col-xl-6 .col-md-4:last-child {\n    margin-bottom: 0;\n  }\n}\n@media (max-width: 666px) {\n  [data-footer=\"simple\"].hk-wrapper .hk-pg-wrapper, .footer-simple-example.hk-wrapper .hk-pg-wrapper {\n    padding-bottom: 10rem;\n  }\n}\n/*------------------------------------------------------------------\n[Nav]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/*Navbar*/\n.navbar .navbar-toggler-menu,\n.navbar .navbar-toggler {\n  border: none;\n  padding: 0;\n}\n.navbar .navbar-toggler-menu {\n  align-self: center;\n  margin-right: .625rem;\n}\n.navbar .navbar-brand {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.navbar.navbar-dark {\n  background: #262a2e;\n}\n.navbar.navbar-dark .badge.badge-indicator {\n  border-color: #262a2e;\n}\n.navbar.navbar-dark .form-control, .navbar.navbar-dark .form-select, .navbar.navbar-dark .wizard > .content > .body input, .wizard > .content > .body .navbar.navbar-dark input, .navbar.navbar-dark .dd-handle {\n  border-color: #fff;\n  color: #fff;\n}\n.navbar.navbar-dark .input-affix-wrapper.affix-border .input-prefix, .navbar.navbar-dark .input-affix-wrapper.affix-border .input-suffix {\n  border-color: #fff;\n  color: #fff;\n}\n.navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.hopscotch-nav-button {\n  color: #fff;\n}\n.navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:before, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:before, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:before {\n  background: rgba(255, 255, 255, 0.05);\n}\n.navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled).active .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled).active .icon, .navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:not(:disabled):not(.disabled):active .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:not(:disabled):not(.disabled):active .icon, .navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:hover .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:hover .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:hover .icon, .navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover:focus .icon, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:focus .icon, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.flush-soft-hover.hopscotch-nav-button:focus .icon {\n  color: #fff;\n}\n.navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark.disabled, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.disabled.hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.disabled.hopscotch-nav-button, .navbar.navbar-dark .btn.btn-icon[class*=\"btn-flush-\"].btn-flush-dark:disabled, .navbar.navbar-dark div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.hopscotch-nav-button:disabled, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .navbar.navbar-dark .btn-icon[class*=\"btn-flush-\"].btn-flush-dark.hopscotch-nav-button:disabled {\n  color: rgba(255, 255, 255, 0.8);\n}\n.navbar.navbar-light {\n  background: #fff;\n}\n.navbar.navbar-light .badge.badge-indicator {\n  border-color: #fff;\n}\n\n/*Nav*/\n.nav-link {\n  color: #0a2f4c;\n}\n.nav-link:hover, .nav-link:focus {\n  color: #3d9ca5;\n}\n\n.nav .nav-item {\n  position: relative;\n}\n.nav .nav-item .nav-link.no-arrow {\n  padding-right: 0.75rem !important;\n}\n.nav .nav-item .nav-link.no-arrow:after {\n  display: none;\n}\n.nav .nav-item .nav-link.link-with-arrow {\n  padding-right: 1.8rem !important;\n  position: relative;\n}\n.nav .nav-item .nav-link.link-with-arrow:after {\n  content: '\\f2f9';\n  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n  font-size: 1rem;\n  text-rendering: auto;\n  margin-left: auto;\n  position: absolute;\n  right: 1rem;\n  top: calc(50% - 8px);\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.nav.nav-icon > .nav-item .nav-link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n.nav.nav-icon > .nav-item .nav-link > .nav-icon-wrap {\n  margin-right: .875rem;\n  font-size: 1.25rem;\n  line-height: 0;\n  position: relative;\n}\n.nav.nav-icon.nav-icon-top > .nav-item > .nav-link {\n  text-align: center;\n  display: block;\n}\n.nav.nav-icon.nav-icon-top > .nav-item > .nav-link > .nav-icon-wrap {\n  margin-right: 0;\n  margin-bottom: .5rem;\n  display: block;\n}\n.nav.nav-pills > .nav-item > .nav-link {\n  border-radius: 0.5rem;\n  margin-left: .25rem;\n  margin-right: .25rem;\n}\n.nav.nav-pills > .nav-item > .nav-link.active {\n  background-color: #0a2f4c !important;\n}\n.nav.nav-pills > .nav-item > .nav-link.active.link-with-arrow:after {\n  color: rgba(255, 255, 255, 0.6);\n}\n.nav.nav-pills > .nav-item > .nav-link.active:after {\n  color: rgba(255, 255, 255, 0.6);\n}\n.nav.nav-pills .show > .nav-link {\n  background-color: transparent;\n}\n.nav.nav-pills.nav-pills-square > .nav-item > .nav-link {\n  border-radius: 0;\n}\n.nav.nav-pills.nav-pills-rounded > .nav-item > .nav-link {\n  border-radius: 50rem;\n}\n.nav.nav-pills.nav-pills-soft > .nav-item > .nav-link.active {\n  background-color: #ebf5f5 !important;\n  color: #0a2f4c !important;\n}\n.nav.nav-pills.nav-pills-soft > .nav-item > .nav-link.active.link-with-arrow:after {\n  color: inherit;\n}\n.nav.nav-pills.nav-pills-soft > .nav-item > .nav-link.active:after {\n  color: inherit;\n}\n.nav.nav-pills.nav-icon.nav-icon-top > .nav-item > .nav-link {\n  padding-top: .95rem;\n  padding-bottom: .95rem;\n}\n.nav.nav-line > .nav-item > .nav-link {\n  border-bottom: 1px solid transparent;\n  -webkit-transition: 0.2s ease-in-out;\n  -moz-transition: 0.2s ease-in-out;\n  transition: 0.2s ease-in-out;\n}\n.nav.nav-line > .nav-item > .nav-link.active {\n  border-color: #0a2f4c !important;\n}\n.nav.nav-vertical {\n  -ms-flex-direction: column !important;\n  flex-direction: column !important;\n}\n.nav.nav-vertical .nav-item .nav-link {\n  justify-content: flex-start;\n  -webkit-justify-content: flex-start;\n  position: relative;\n}\n.nav.nav-vertical .nav-item .nav-link[data-toggle=\"collapse\"]::after {\n  content: '\\f2f9';\n  font: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n  font-size: 1rem;\n  text-rendering: auto;\n  margin-left: auto;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.nav.nav-vertical .nav-item .nav-link[data-toggle=\"collapse\"][aria-expanded=\"true\"]::after {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  -o-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n.nav.nav-vertical.nav-pills > .nav-item > .nav-link {\n  margin: .25rem 0;\n}\n.nav.nav-vertical.nav-line > .nav-item > .nav-link {\n  border-bottom: none;\n  border-left: 1px solid transparent;\n}\n.nav.nav-vertical.nav-separator > .nav-item > .nav-link {\n  padding: .75rem 1.5rem;\n}\n.nav.nav-vertical.nav-separator > .nav-item::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: auto;\n  bottom: 0;\n  height: 1px;\n  margin: 0;\n}\n.nav.nav-dark .nav-link {\n  color: white;\n}\n.nav.nav-dark .nav-link:hover, .nav.nav-dark .nav-link:focus {\n  color: rgba(255, 255, 255, 0.8);\n}\n.nav.nav-dark .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.3);\n}\n.nav.nav-dark .nav-link.active {\n  color: #0a2f4c;\n}\n.nav.nav-dark .nav-link:after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.nav.nav-dark .nav-link.link-with-arrow:after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.nav.nav-dark .nav-item.show .nav-link {\n  color: #fff;\n}\n.nav.nav-dark.nav-pills > .nav-item > .nav-link.active {\n  color: #fff;\n}\n.nav.nav-dark.nav-pills > .nav-item > .nav-link.active:hover, .nav.nav-dark.nav-pills > .nav-item > .nav-link.active:focus {\n  color: #fff;\n}\n.nav.nav-dark.nav-pills > .nav-item > .nav-link {\n  color: #fff;\n}\n.nav.nav-dark.nav-pills > .nav-item > .nav-link:hover, .nav.nav-dark.nav-pills > .nav-item > .nav-link:focus {\n  background: rgba(255, 255, 255, 0.1);\n}\n.nav.nav-dark.nav-pills > .nav-item > .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.3);\n}\n.nav.nav-dark.nav-vertical .nav-item .nav-link[data-toggle=\"collapse\"]::after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.nav.nav-dark.nav-line .nav-item.show .nav-link {\n  color: #fff;\n}\n.nav.nav-light .nav-link {\n  color: #262a2e;\n}\n.nav.nav-light .nav-link:hover, .nav.nav-light .nav-link:focus {\n  color: rgba(38, 42, 46, 0.8);\n}\n.nav.nav-light .nav-link.disabled {\n  color: rgba(38, 42, 46, 0.3);\n}\n.nav.nav-light .nav-link.active {\n  color: #0a2f4c;\n}\n.nav.nav-light .nav-link:after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.nav.nav-light .nav-link.link-with-arrow:after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.nav.nav-light .nav-item.show .nav-link {\n  color: #262a2e;\n}\n.nav.nav-light.nav-vertical .nav-item .nav-link[data-toggle=\"collapse\"]::after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.nav.nav-light.nav-pills > .nav-item > .nav-link.active {\n  color: #fff;\n}\n.nav.nav-light.nav-pills > .nav-item > .nav-link.active:hover, .nav.nav-light.nav-pills > .nav-item > .nav-link.active:focus {\n  color: #fff;\n}\n.nav.nav-light.nav-pills > .nav-item > .nav-link {\n  color: #262a2e;\n}\n.nav.nav-light.nav-pills > .nav-item > .nav-link:hover, .nav.nav-light.nav-pills > .nav-item > .nav-link:focus {\n  background: rgba(38, 42, 46, 0.08);\n}\n.nav.nav-light.nav-pills > .nav-item > .nav-link.disabled {\n  color: rgba(38, 42, 46, 0.3);\n}\n.nav.nav-sm > .nav-item .nav-link > .nav-icon-wrap {\n  margin-right: .875rem;\n  font-size: 1rem;\n}\n.nav.nav-sm .nav-link {\n  padding: .25rem 0.75rem;\n  font-size: 0.875rem;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #d8d8d8;\n}\n.nav-tabs .nav-item.show .nav-link:hover, .nav-tabs .nav-item.show .nav-link:focus,\n.nav-tabs > .nav-item > .nav-link:hover,\n.nav-tabs > .nav-item > .nav-link:focus {\n  border-color: transparent;\n}\n.nav-tabs .nav-item.show .nav-link.active,\n.nav-tabs > .nav-item > .nav-link.active {\n  background-color: transparent;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;\n}\n.nav-tabs.nav-sm .nav-item.show .nav-link,\n.nav-tabs.nav-sm > .nav-item > .nav-link {\n  padding: .4rem 0.75rem;\n}\n.nav-tabs .nav-item.show .nav-link {\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;\n}\n.nav-tabs.nav-pills {\n  border-bottom: 0;\n}\n.nav-tabs.nav-pills > .nav-item {\n  margin-bottom: 0;\n}\n.nav-tabs.nav-pills > .nav-item > .nav-link {\n  border: none !important;\n}\n.nav-tabs.nav-light > .nav-item > .nav-link.active {\n  background: #fff;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;\n}\n.nav-tabs.nav-light .nav-item.show .nav-link {\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #fff;\n}\n.nav-tabs.nav-dark {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.nav-tabs.nav-dark > .nav-item > .nav-link.active {\n  background: #fff;\n  border-color: rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1) #fff;\n}\n.nav-tabs.nav-dark .nav-item.show .nav-link {\n  border-color: rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1) #fff;\n}\n.nav-tabs.nav-line {\n  border-bottom: 0;\n}\n.nav-tabs.nav-line > .nav-item {\n  margin-bottom: 0;\n}\n.nav-tabs.nav-line > .nav-item > .nav-link {\n  background: transparent;\n  border-left: 0;\n  border-top: 0;\n  border-right: 0;\n}\n.nav-tabs.nav-line > .nav-item > .nav-link.active {\n  background: transparent;\n}\n\n.tab-content {\n  margin-top: 1rem;\n}\n\n.nav-segmented-tabs {\n  display: -ms-flexbox;\n  display: flex;\n  border-bottom: none;\n}\n.nav-segmented-tabs > .nav-item {\n  margin-right: -1px;\n}\n.nav-segmented-tabs > .nav-item:first-child .nav-link {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n.nav-segmented-tabs > .nav-item:last-child .nav-link {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n.nav-segmented-tabs > .nav-item > .nav-link {\n  border: 1px solid #d8d8d8 !important;\n  border-radius: 0;\n  text-align: center;\n  background: transparent;\n  height: 100%;\n}\n.nav-segmented-tabs > .nav-item > .nav-link.active {\n  color: #fff !important;\n  background: #0a2f4c !important;\n  border-color: #0a2f4c !important;\n}\n.nav-segmented-tabs.segmented-tabs-rounded > .nav-item:first-child .nav-link {\n  border-top-left-radius: 50px;\n  border-bottom-left-radius: 50px;\n}\n.nav-segmented-tabs.segmented-tabs-rounded > .nav-item:last-child .nav-link {\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n.nav-segmented-tabs.segmented-tabs-square > .nav-item > .nav-link {\n  border-radius: 0;\n}\n.nav-segmented-tabs.segmented-tabs-filled > .nav-item {\n  margin-right: 0;\n}\n.nav-segmented-tabs.segmented-tabs-filled > .nav-item .nav-link {\n  border: none !important;\n  background: #f7f7f7;\n}\n.nav-segmented-tabs.nav-dark > .nav-item > .nav-link {\n  border-color: rgba(255, 255, 255, 0.15) !important;\n}\n.nav-segmented-tabs.nav-dark > .nav-item.show > .nav-link {\n  background: transparent;\n  color: white;\n}\n.nav-segmented-tabs.nav-dark.segmented-tabs-filled > .nav-item .nav-link {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.nav-header-bold {\n  padding: 1.5rem 0 .5rem 0;\n  width: 240px;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #0a2f4c;\n}\n\n/*Section Nav*/\n.hk-wrapper[data-aside=\"fixed\"] .hk-pg-wrapper {\n  margin-right: 180px;\n}\n.hk-wrapper[data-aside=\"fixed\"] .hk-aside {\n  position: fixed;\n  top: 65px;\n  overflow-y: auto;\n  width: 180px;\n  right: 0;\n  z-index: 1;\n  background: #fff;\n  border-left: 1px solid #d8d8d8;\n  bottom: 0;\n}\n.hk-wrapper[data-aside=\"fixed\"] .hk-aside .nicescroll-bar {\n  padding: 1.5rem;\n}\n.hk-wrapper[data-aside=\"sticky\"] .hk-aside {\n  position: sticky;\n  top: 70px;\n  overflow-y: auto;\n  height: calc(100vh - 250px);\n  z-index: 1;\n  margin-top: 3rem;\n}\n.hk-wrapper .nav-toc .nav-header {\n  font-size: .75rem;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #9e9e9e;\n}\n.hk-wrapper .nav-toc .nav {\n  margin: 1rem 0;\n  font-size: .875rem;\n  flex-wrap: nowrap;\n  border-left: 1px solid;\n  border-color: #d8d8d8;\n}\n.hk-wrapper .nav-toc .nav .nav-item {\n  margin-bottom: .25rem;\n}\n.hk-wrapper .nav-toc .nav .nav-item:last-child {\n  margin-bottom: 0;\n}\n.hk-wrapper .nav-toc .nav .nav-item a.nav-link {\n  color: #262a2e;\n  padding: 0 0 0 1rem;\n  display: block;\n  margin-left: -1px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  border-left: 1px solid transparent;\n}\n.hk-wrapper .nav-toc .nav .nav-item a.nav-link:hover, .hk-wrapper .nav-toc .nav .nav-item a.nav-link:focus {\n  color: rgba(38, 42, 46, 0.8);\n}\n.hk-wrapper .nav-toc .nav .nav-item a.nav-link.active {\n  color: #0a2f4c;\n  border-color: #0a2f4c;\n}\n\n@media (max-width: 767px) {\n  .hk-wrapper[data-aside=\"fixed\"] .hk-pg-wrapper {\n    margin-right: 0;\n  }\n  .hk-wrapper[data-aside=\"fixed\"] .hk-aside {\n    display: none;\n  }\n}\n.toc-wrapper .nav.nav-vertical .nav-item .nav-link {\n  font-size: 0.875rem;\n  padding: 0.125rem 0;\n}\n\n/*------------------------------------------------------------------\n[Horizontal Menu]\nProject:\tJampack\n--------------------------------------------------------------------*/\n/**Horizontal Navigation**/\n.hk-wrapper[data-layout=\"horizontal\"] .hk-pg-wrapper {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 270px;\n  margin-left: 0;\n  z-index: 1032;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu > .nicescroll-bar {\n  overflow: auto;\n  flex: 1 1 auto;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap {\n  padding: 1.5rem;\n  position: relative;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .nav-header {\n  padding: 0 0 .5rem 0;\n  font-size: 0.875rem;\n  color: #0a2f4c;\n  font-weight: 500;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: .5rem 1rem;\n  margin: 0 -1rem;\n  white-space: nowrap;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {\n  -webkit-transition: -webkit-transform 0.25s ease;\n  -moz-transition: -moz-transform 0.25s ease;\n  transition: transform 0.25s ease;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {\n  font-size: 1.5rem;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  position: absolute;\n  right: 1rem;\n  z-index: -1;\n  content: '\\f2f9';\n  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  margin-left: auto;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  -o-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {\n  -webkit-transform: translateX(5px);\n  -moz-transform: translateX(5px);\n  -ms-transform: translateX(5px);\n  -o-transform: translateX(5px);\n  transform: translateX(5px);\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item > .nav-link[data-bs-toggle=\"collapse\"]::after {\n  display: none;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item .nav-children .nav-item .nav-link .nav-icon-wrap {\n  display: none;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {\n  position: relative;\n  padding: 0.5rem 0;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  content: \"\";\n  width: 1px;\n  height: calc(100% - 20px);\n  position: absolute;\n  left: 10px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {\n  font-size: 0.875rem;\n  padding: 0.15rem 0 0.15rem 1.4rem;\n  margin: 0 0 0 1rem;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  right: 0;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {\n  padding: 0.15rem 0 0.15rem 2rem;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-header {\n  padding: 0.5rem 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex: 0 0 auto;\n  height: 65px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  overflow: hidden;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-header .navbar-toggle {\n  flex-shrink: 0;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-header > span {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  flex-grow: 1;\n  justify-content: space-between;\n}\n.hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {\n  margin-left: 0.5rem;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-pg-wrapper {\n  margin-left: 0;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-navbar {\n  left: 0;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu {\n  left: -270px;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"collapsed\"] .hk-menu {\n  left: 0;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"collapsed\"] .hk-menu-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 1031;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n  background: rgba(38, 42, 46, 0.5);\n  opacity: 1;\n  height: auto;\n  width: auto;\n  visibility: visible;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"light\"] .hk-menu {\n  background: #fff;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"light\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #262a2e;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"light\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"light\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"dark\"] .hk-menu {\n  background: #262a2e;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"dark\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #fff;\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"dark\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.hk-wrapper[data-layout=\"horizontal\"][data-menu=\"dark\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n\n@media (max-width: 1199px) {\n  .hk-wrapper[data-layout=\"horizontal\"] .hk-menu .menu-content-wrap > .menu-group {\n    padding: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .hk-wrapper[data-layout=\"horizontal\"].hk-section-nav-active .hk-section-nav {\n    top: 130px;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"] .hk-pg-wrapper {\n    padding-top: 130px;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu {\n    left: 0;\n    top: 65px;\n    right: 0;\n    bottom: auto;\n    width: 100%;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    border-bottom: 1px solid #eaeaea;\n    border-right: 0;\n    z-index: 1029;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu > .nicescroll-bar {\n    overflow: visible !important;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap {\n    padding: 0;\n    position: relative;\n    min-height: auto;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group > .navbar-nav.flex-column {\n    flex-direction: row !important;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n    display: none;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link {\n    min-height: 65px;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link:hover > * {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item {\n    position: relative;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n    margin: 0;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n    position: static;\n    margin-left: 0.75rem;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:first-child > .nav-link {\n    padding-left: 0;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {\n    height: auto !important;\n    min-width: 10rem;\n    position: absolute;\n    z-index: 1;\n    border-radius: .25rem;\n    border: 1px solid #eaeaea;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children {\n    padding: 1rem 0;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link {\n    padding: .25rem 1.5rem;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n    margin-left: auto;\n    -webkit-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    -o-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children {\n    padding: 0.5rem 0;\n    left: 100%;\n    top: 0;\n    position: absolute;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children .nav-item .nav-link {\n    padding: .25rem 1rem;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item.edge ul.nav-children {\n    left: auto !important;\n    right: 100%;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse, .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse.show, .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapsing {\n    display: block;\n    clip: rect(1px, 1px, 1px, 1px);\n    opacity: 0.1;\n    -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);\n    -moz-transition: -moz-transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);\n    transition: transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);\n    -webkit-transform: translateY(-10px) scaleY(0.5);\n    -moz-transform: translateY(-10px) scaleY(0.5);\n    -ms-transform: translateY(-10px) scaleY(0.5);\n    -o-transform: translateY(-10px) scaleY(0.5);\n    transform: translateY(-10px) scaleY(0.5);\n    -webkit-transform-origin: top;\n    transform-origin: top;\n    box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n    top: 100%;\n    position: fixed;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse, .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse.show, .hk-wrapper[data-layout=\"horizontal\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapsing {\n    clip: auto;\n    opacity: 1;\n    -webkit-transform: translateY(0) scaleY(1);\n    -moz-transform: translateY(0) scaleY(1);\n    -ms-transform: translateY(0) scaleY(1);\n    -o-transform: translateY(0) scaleY(1);\n    transform: translateY(0) scaleY(1);\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-menu=\"light\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {\n    background: #fff;\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-menu=\"dark\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {\n    background: #262a2e;\n  }\n}\n/*------------------------------------------------------------------\n[Classic Menu]\nProject:\tJampack\n--------------------------------------------------------------------*/\n/**Vertical Navigation**/\n.hk-wrapper[data-layout=\"vertical\"] .hk-pg-wrapper {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 270px;\n  margin-left: 0;\n  z-index: 1032;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  /*Sidebar fixednav*/\n  /*Horizontal Scrollbar*/\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu > .nicescroll-bar {\n  overflow: auto;\n  flex: 1 1 auto;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap {\n  padding: 1.5rem;\n  position: relative;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .nav-header {\n  padding: 0 0 .5rem 0;\n  font-size: 0.875rem;\n  color: #9e9e9e;\n  font-weight: 500;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: .5rem 1rem;\n  margin: 0 -1rem;\n  white-space: nowrap;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link.active{\n  background: rgba(0, 76, 136, 0.15);\n  color: #0a2f4c !important;\n  border-radius: 0.5rem;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {\n  -webkit-transition: -webkit-transform 0.25s ease;\n  -moz-transition: -moz-transform 0.25s ease;\n  transition: transform 0.25s ease;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {\n  font-size: 1.5rem;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  position: absolute;\n  right: 1rem;\n  z-index: -1;\n  content: '\\f2f9';\n  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  margin-left: auto;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  -o-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {\n  -webkit-transform: translateX(5px);\n  -moz-transform: translateX(5px);\n  -ms-transform: translateX(5px);\n  -o-transform: translateX(5px);\n  transform: translateX(5px);\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link.active {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c !important;\n  border-radius: 0.5rem;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {\n  position: relative;\n  padding: 0.5rem 0;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  content: \"\";\n  width: 1px;\n  height: calc(100% - 20px);\n  position: absolute;\n  left: 10px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {\n  font-size: 0.875rem;\n  padding: 0.15rem 0 0.15rem 1.4rem;\n  margin: 0 0 0 1rem;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  right: 0;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {\n  padding: 0.15rem 0 0.15rem 2rem;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-header {\n  padding: 0.5rem 1.1875rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex: 0 0 auto;\n  height: 65px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  overflow: hidden;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-header .navbar-toggle {\n  flex-shrink: 0;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-header > span {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  flex-grow: 1;\n  justify-content: space-between;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {\n  margin-left: 0.5rem;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .bottom-nav {\n  flex: 0 0 auto;\n  padding-bottom: .5rem;\n}\n.hk-wrapper[data-layout=\"vertical\"] .hk-menu .simplebar-track.simplebar-horizontal {\n  display: none;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"default\"] .hk-pg-wrapper {\n  margin-left: 0;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"default\"] .hk-navbar {\n  left: 0;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"default\"] .hk-menu {\n  left: -270px;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu {\n  left: 0;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 1031;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n  background: rgba(38, 42, 46, 0.5);\n  opacity: 1;\n  height: auto;\n  width: auto;\n  visibility: visible;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"light\"] .hk-menu {\n  background: #fff;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"light\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #262a2e;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"light\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"light\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"dark\"] .hk-menu {\n  background: #262a2e;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"dark\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #fff;\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"dark\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.hk-wrapper[data-layout=\"vertical\"][data-menu=\"dark\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n\n@media (min-width: 1200px) {\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"default\"] .hk-pg-wrapper {\n    margin-left: 270px;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"default\"] .hk-navbar {\n    left: 270px;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"default\"] .hk-menu {\n    left: 0;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-pg-wrapper {\n    margin-left: 72px;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-navbar {\n    left: 72px;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu {\n    width: 72px;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .menu-content-wrap > .callout {\n    display: none;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .menu-content-wrap .menu-group .nav-header {\n    display: none;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link > *:not(.nav-icon-wrap) {\n    visibility: hidden;\n    flex-shrink: 0;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link[data-bs-toggle=\"collapse\"]::after {\n    right: -1.5rem;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .menu-content-wrap .menu-group .collapse.show {\n    display: none;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .menu-content-wrap .menu-gap {\n    display: none;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {\n    display: none;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu .navbar-toggle {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover {\n    width: 270px;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover .menu-content-wrap > .callout {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover .menu-content-wrap .menu-group .nav-header {\n    display: block;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link > *:not(.nav-icon-wrap) {\n    visibility: visible;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link[data-bs-toggle=\"collapse\"]::after {\n    right: 1rem;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover .menu-content-wrap .menu-group .collapse.show {\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover .menu-content-wrap .menu-gap {\n    display: block;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"][data-hover=\"active\"] .hk-menu:hover .menu-header > span .navbar-brand .brand-img:last-child {\n    display: inline;\n  }\n  .hk-wrapper[data-layout=\"vertical\"][data-layout-style=\"collapsed\"] .hk-menu-backdrop {\n    opacity: 0;\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n}\n/*------------------------------------------------------------------\n[Icon Menu]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/**Vertical Icon Navigation**/\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-pg-wrapper {\n  margin-left: 72px;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-navbar {\n  left: 72px;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 72px;\n  margin-left: 0;\n  z-index: 1032;\n  border-right: 1px solid #d8d8d8;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  /*Sidebar fixednav*/\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu > .nicescroll-bar {\n  overflow: auto;\n  flex: 1 1 auto;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-content-wrap {\n  padding: 1.5rem;\n  position: relative;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item .nav-link {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: .5rem 1rem;\n  margin: 0 -1rem;\n  white-space: nowrap;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {\n  font-size: 1.5rem;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-content-wrap .navbar-nav .nav-item.active > .nav-link {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-content-wrap .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c !important;\n  border-radius: 0.5rem;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-header {\n  padding: 0.5rem 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 65px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .menu-header .navbar-brand {\n  margin: 0;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu .bottom-nav {\n  flex: 0 0 auto;\n  padding-bottom: .5rem;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 72px;\n  width: 270px;\n  margin-left: 0;\n  z-index: 1031;\n  overflow: hidden;\n  border-right: 1px solid #d8d8d8;\n  -webkit-transform: translate(-100%);\n  -moz-transform: translate(-100%);\n  -ms-transform: translate(-100%);\n  -o-transform: translate(-100%);\n  transform: translate(-100%);\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu > .nicescroll-bar {\n  overflow: auto;\n  flex: 1 1 auto;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap {\n  padding: 1.5rem;\n  position: relative;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-header {\n  padding: 0 0 .5rem 0;\n  font-size: 0.875rem;\n  color: #0a2f4c;\n  font-weight: 500;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: .5rem 1rem;\n  margin: 0 -1rem;\n  white-space: nowrap;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {\n  -webkit-transition: -webkit-transform 0.25s ease;\n  -moz-transition: -moz-transform 0.25s ease;\n  transition: transform 0.25s ease;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {\n  font-size: 1.5rem;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  position: absolute;\n  right: 1rem;\n  z-index: -1;\n  content: '\\f2f9';\n  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  margin-left: auto;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"][aria-default=\"true\"]::after {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  -o-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {\n  -webkit-transform: translateX(5px);\n  -moz-transform: translateX(5px);\n  -ms-transform: translateX(5px);\n  -o-transform: translateX(5px);\n  transform: translateX(5px);\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {\n  position: relative;\n  padding: 0.5rem 0;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  content: \"\";\n  width: 1px;\n  height: calc(100% - 20px);\n  position: absolute;\n  left: 10px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {\n  font-size: 0.875rem;\n  padding: 0.15rem 0 0.15rem 1.4rem;\n  margin: 0 0 0 1rem;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  right: 0;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {\n  padding: 0.15rem 0 0.15rem 2rem;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-header {\n  padding: 0 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex: 0 0 auto;\n  min-height: 65px;\n  width: 269px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .menu-header .navbar-toggle {\n  flex-shrink: 0;\n}\n.hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu .subnav-list {\n  display: none;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-submenu=\"active\"] .hk-menu .sub-menu {\n  -webkit-transform: translate(0);\n  -moz-transform: translate(0);\n  -ms-transform: translate(0);\n  -o-transform: translate(0);\n  transform: translate(0);\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .main-menu {\n  background: #fff;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #262a2e;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .sub-menu {\n  background: #fff;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #262a2e;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"light\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .main-menu {\n  background: #262a2e;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #fff;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .main-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .sub-menu {\n  background: #2F343A;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #fff;\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.hk-wrapper[data-layout=\"twocolumn\"][data-menu=\"dark\"] .hk-menu .sub-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n\n@media (max-width: 1199px) {\n  .hk-wrapper[data-layout=\"twocolumn\"] .hk-pg-wrapper {\n    margin-left: 0;\n  }\n  .hk-wrapper[data-layout=\"twocolumn\"] .hk-navbar {\n    left: 0;\n  }\n  .hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .main-menu {\n    left: -72px;\n  }\n  .hk-wrapper[data-layout=\"twocolumn\"] .hk-menu .sub-menu {\n    left: 0;\n  }\n  .hk-wrapper[data-layout=\"twocolumn\"][data-layout-style=\"offcanvas\"] .hk-menu .main-menu {\n    left: 0;\n  }\n  .hk-wrapper[data-layout=\"twocolumn\"][data-layout-style=\"offcanvas\"] .hk-menu .sub-menu {\n    left: 72px;\n  }\n  .hk-wrapper[data-layout=\"twocolumn\"][data-layout-style=\"offcanvas\"] .hk-menu-backdrop {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 1030;\n    background: rgba(38, 42, 46, 0.5);\n    height: auto;\n    width: auto;\n  }\n}\n/*------------------------------------------------------------------\n[Navbar Menu]\nProject:\tJampack\n--------------------------------------------------------------------*/\n/**Navbar Navigation**/\n.hk-wrapper[data-layout=\"navbar\"] .hk-pg-wrapper {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 270px;\n  margin-left: 0;\n  z-index: 1032;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu > .nicescroll-bar {\n  overflow: auto;\n  flex: 1 1 auto;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap {\n  padding: 1.5rem;\n  position: relative;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .nav-header {\n  padding: 0 0 .5rem 0;\n  font-size: 0.875rem;\n  color: #0a2f4c;\n  font-weight: 500;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: .5rem 1rem;\n  margin: 0 -1rem;\n  white-space: nowrap;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link > * {\n  -webkit-transition: -webkit-transform 0.25s ease;\n  -moz-transition: -moz-transform 0.25s ease;\n  transition: transform 0.25s ease;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link .nav-icon-wrap > *:not(.badge) {\n  font-size: 1.5rem;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  position: absolute;\n  right: 1rem;\n  z-index: -1;\n  content: '\\f2f9';\n  font: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  margin-left: auto;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  -o-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link:hover > * {\n  -webkit-transform: translateX(5px);\n  -moz-transform: translateX(5px);\n  -ms-transform: translateX(5px);\n  -o-transform: translateX(5px);\n  transform: translateX(5px);\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.active > .nav-link {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item > .nav-link[data-bs-toggle=\"collapse\"]::after {\n  display: none;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item.more-nav-item .nav-children .nav-item .nav-link .nav-icon-wrap {\n  display: none;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item.active > .nav-link {\n  color: #0a2f4c !important;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul {\n  position: relative;\n  padding: 0.5rem 0;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  content: \"\";\n  width: 1px;\n  height: calc(100% - 20px);\n  position: absolute;\n  left: 10px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link {\n  font-size: 0.875rem;\n  padding: 0.15rem 0 0.15rem 1.4rem;\n  margin: 0 0 0 1rem;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  right: 0;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-group .nav-children .nav-children .nav-item .nav-link {\n  padding: 0.15rem 0 0.15rem 2rem;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-header {\n  padding: 0.5rem 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex: 0 0 auto;\n  height: 65px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  overflow: hidden;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-header .navbar-toggle {\n  flex-shrink: 0;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-header > span {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  flex-grow: 1;\n  justify-content: space-between;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-menu .menu-header > span .navbar-brand .brand-img:last-child {\n  margin-left: 0.5rem;\n}\n\n\n.hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-pg-wrapper {\n  margin-left: 0;\n}\n.hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-navbar {\n  left: 0;\n}\n.hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu {\n  left: -270px;\n}\n.hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"collapsed\"] .hk-menu {\n  left: 0;\n}\n.hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"collapsed\"] .hk-menu-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 1031;\n  -webkit-transition: all 0.25s ease;\n  -moz-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n  background: rgba(38, 42, 46, 0.5);\n  opacity: 1;\n  height: auto;\n  width: auto;\n  visibility: visible;\n}\n.hk-wrapper[data-layout=\"navbar\"] .simplebar-track.simplebar-horizontal {\n  display: none;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-light .hk-menu {\n  background: #fff;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #262a2e;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(38, 42, 46, 0.3);\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-dark .hk-menu {\n  background: #262a2e;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n  color: #fff;\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n  color: rgba(255, 255, 255, 0.3);\n}\n.hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n  background: #d8d8d8;\n}\n\n@media (max-width: 1199px) {\n  .hk-wrapper[data-layout=\"navbar\"] .hk-menu .container.menu-group {\n    padding: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu {\n    background: inherit !important;\n    width: 100%;\n    position: static;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    border: 0;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu > .nicescroll-bar {\n    overflow: visible !important;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap {\n    padding: 0;\n    position: relative;\n    min-height: auto;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group > .navbar-nav.flex-column {\n    flex-direction: row !important;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > ul:after {\n    display: none;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link {\n    min-height: 65px;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav > .nav-item > .nav-link:hover > * {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item {\n    position: relative;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link {\n    margin: 0;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n    position: static;\n    margin-left: 0.75rem;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {\n    height: auto !important;\n    min-width: 10rem;\n    position: absolute;\n    z-index: 1;\n    border-radius: .25rem;\n    border: 1px solid #eaeaea;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children {\n    padding: 1rem 0;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link {\n    padding: .25rem 1.5rem;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item .nav-link[data-bs-toggle=\"collapse\"]::after {\n    margin-left: auto;\n    -webkit-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    -o-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children {\n    padding: 0.5rem 0;\n    left: 100%;\n    top: 0;\n    position: absolute;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item ul.nav-children .nav-item .nav-link {\n    padding: .25rem 1rem;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.nav-children .nav-item.edge ul.nav-children {\n    left: auto !important;\n    right: 100%;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse, .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapse.show, .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item > ul.collapsing {\n    display: block;\n    clip: rect(1px, 1px, 1px, 1px);\n    opacity: 0.1;\n    -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);\n    -moz-transition: -moz-transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);\n    transition: transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1);\n    -webkit-transform: translateY(-10px) scaleY(0.5);\n    -moz-transform: translateY(-10px) scaleY(0.5);\n    -ms-transform: translateY(-10px) scaleY(0.5);\n    -o-transform: translateY(-10px) scaleY(0.5);\n    transform: translateY(-10px) scaleY(0.5);\n    -webkit-transform-origin: top;\n    transform-origin: top;\n    box-shadow: 0 0.25rem 0.3125rem rgba(47, 52, 58, 0.1) !important;\n    top: 100%;\n    position: fixed;\n  }\n  .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse, .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapse.show, .hk-wrapper[data-layout=\"navbar\"][data-layout-style=\"default\"] .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item:hover > ul.collapsing {\n    clip: auto;\n    opacity: 1;\n    -webkit-transform: translateY(0) scaleY(1);\n    -moz-transform: translateY(0) scaleY(1);\n    -ms-transform: translateY(0) scaleY(1);\n    -o-transform: translateY(0) scaleY(1);\n    transform: translateY(0) scaleY(1);\n  }\n  .hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-light .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {\n    background: #fff;\n  }\n  .hk-wrapper[data-layout=\"navbar\"] .hk-navbar.navbar.navbar-dark .hk-menu .menu-content-wrap .menu-group .navbar-nav .nav-item ul.nav-children {\n    background: #262a2e;\n  }\n}\n/*------------------------------------------------------------------\n[Drawer]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/*Drawer*/\n.hk-wrapper .hk-drawer {\n  position: fixed;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  top: 0;\n  right: -320px;\n  width: 320px;\n  bottom: 0;\n  z-index: 1050;\n  border: none;\n  background: #fff;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper .hk-drawer .drawer-header {\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #d8d8d8;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.hk-wrapper .hk-drawer .drawer-header .drawer-text {\n  font-size: 1rem;\n  color: #2F343A;\n  font-weight: 500;\n}\n.hk-wrapper .hk-drawer .drawer-header .drawer-header-action {\n  margin-left: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-wrapper .hk-drawer .drawer-header.header-bold .drawer-text {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.hk-wrapper .hk-drawer .drawer-header.header-wth-bg {\n  background: #0a2f4c;\n  border-bottom: 0;\n}\n.hk-wrapper .hk-drawer .drawer-header.header-wth-bg .drawer-text {\n  color: #fff;\n}\n.hk-wrapper .hk-drawer .drawer-header.header-wth-bg .drawer-close {\n  color: #fff;\n}\n.hk-wrapper .hk-drawer .drawer-header.header-flush {\n  border-bottom: 0;\n}\n.hk-wrapper .hk-drawer .drawer-body {\n  overflow: auto;\n  flex: 1 1 auto;\n}\n.hk-wrapper .hk-drawer .drawer-body .drawer-content-wrap {\n  Padding: 1.25rem 1.25rem 7rem 1.25rem;\n}\n.hk-wrapper .hk-drawer .drawer-body .drawer-content-wrap .drawer-close {\n  position: absolute;\n  right: 14px;\n  top: 10px;\n  cursor: pointer;\n}\n.hk-wrapper .hk-drawer .drawer-footer {\n  padding: 0.75rem 1.25rem;\n  background: #fff;\n  border-top: 1px solid #d8d8d8;\n}\n.hk-wrapper .hk-drawer.drawer-left {\n  left: -320px;\n  border-right: 1px solid #d8d8d8;\n}\n.hk-wrapper .hk-drawer.drawer-right {\n  right: -320px;\n  border-left: 1px solid #d8d8d8;\n}\n.hk-wrapper .hk-drawer.drawer-small {\n  top: 65px;\n}\n.hk-wrapper .hk-drawer.drawer-toggle.hk-drawer.drawer-left {\n  left: 0;\n}\n.hk-wrapper .hk-drawer.drawer-toggle.hk-drawer.drawer-right {\n  right: 0;\n}\n.hk-wrapper.hk-drawer-push.hk-drawer-pushleft .hk-pg-wrapper {\n  margin-left: 20rem;\n}\n.hk-wrapper.hk-drawer-push.hk-drawer-pushright .hk-pg-wrapper {\n  margin-right: 20rem;\n}\n.hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push .hk-navbar {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushleft .hk-navbar {\n  left: 320px;\n}\n.hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushright .hk-navbar {\n  right: 320px;\n}\n.hk-wrapper .hk-drawer-backdrop {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background: #262a2e;\n  opacity: 0.25;\n  z-index: 1033;\n  top: 0;\n  left: 0;\n}\n\n@media (max-width: 1199px) {\n  .hk-wrapper.hk-drawer-push.hk-drawer-pushleft .hk-pg-wrapper {\n    margin-left: 0;\n  }\n  .hk-wrapper.hk-drawer-push.hk-drawer-pushright .hk-pg-wrapper {\n    margin-right: 0;\n  }\n  .hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push .hk-navbar {\n    -webkit-transition: all 0.2s ease;\n    -moz-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n  }\n  .hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushleft .hk-navbar {\n    left: 0;\n  }\n  .hk-wrapper.hk-drawer-push.hk-drawer-wth-nav-push.hk-drawer-pushright .hk-navbar {\n    right: 0;\n  }\n}\n/*------------------------------------------------------------------\n[Master Stylesheet]\nProject:\tJampack\n++++ ChatApp ++++\n++++ Chat Popup ++++\n++++ Chatbot Popup ++++\n++++ Calendar ++++\n++++ Email UI ++++\n++++ Taskboard ++++\n++++ Checklist List ++++\n++++ Contact ++++\n++++ File Manager ++++\n++++ Gallery App ++++\n++++ Todo ++++\n++++ Blog App ++++\n++++ invoice ++++\n++++ Integrations ++++\n-------------------------------------------------------------------*/\n/*ChatApp*/\n.chatapp-wrap {\n  position: relative;\n  overflow: hidden;\n  height: calc(100vh - 65px);\n  -webkit-transition: height 0.2s ease;\n  -moz-transition: height 0.2s ease;\n  transition: height 0.2s ease;\n}\n.chatapp-wrap .chatapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside {\n  border-right: 1px solid #eaeaea;\n  background: #fff;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  height: 100%;\n  z-index: 1;\n  left: 0;\n  margin-top: 0;\n  width: 370px;\n  flex-shrink: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  border-bottom: 1px solid #eaeaea;\n  background: #fff;\n  color: #262a2e;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .chatapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .chatapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .chatapp-title:after {\n  top: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .btn, .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .hopscotch-nav-button {\n  margin-right: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .btn:last-child, .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:last-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .chatapp-wrap .chatapp-content .chatapp-aside header.aside-header .hopscotch-nav-button:last-child {\n  margin-right: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body {\n  -ms-flex: 1;\n  flex: 1;\n  height: 100%;\n  overflow: auto;\n  padding: 1.25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .aside-search {\n  margin-bottom: 1.25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .frequent-contact {\n  margin-bottom: 1.25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .frequent-contact ul li .avatar {\n  cursor: pointer;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list {\n  margin: 0 -0.8rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item {\n  padding: 0;\n  border: none;\n  margin-bottom: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item:last-child {\n  margin-bottom: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media {\n  padding: .75rem .8rem;\n  border-radius: 0.5rem;\n  -webkit-transition: 0.2s ease;\n  -moz-transition: 0.2s ease;\n  transition: 0.2s ease;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-head {\n  position: relative;\n  margin-right: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-width: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child {\n  min-width: 0;\n  flex: 1;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name,\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-last-chat,\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-status {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name {\n  color: #262a2e;\n  font-weight: 500;\n  margin-bottom: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child {\n  text-align: right;\n  padding-left: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  width: 4.5rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child .last-chat-time {\n  font-size: 0.75rem;\n  color: #0a2f4c;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child .badge {\n  margin-top: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media .media-body > div:last-child .action-drp {\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 15px;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover, .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus {\n  background-color: #f2f2f2;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .action-drp, .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .action-drp {\n  opacity: 1;\n  visibility: visible;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .last-chat-time,\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .badge-pill, .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .last-chat-time,\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .badge-pill {\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media.read-chat .media-body > div:last-child .last-chat-time {\n  color: #6f6f6f;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media.read-chat.active-user {\n  background-color: #f2f2f2;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .list-group-item .media.read-chat.active-user .media-body > div:first-child .user-name {\n  color: #0a2f4c;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .title-wth-divider {\n  padding: 0 .8rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .chat-contacts-list .title-wth-divider:after {\n  background: #f7f7f7;\n}\n.chatapp-wrap .chatapp-content .chatapp-aside .aside-body .channels-list .nav-item .nav-link {\n  padding-left: 0;\n  padding-right: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  flex-flow: column;\n  height: 100%;\n  background: #fff;\n  z-index: 10;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .back-user-list {\n  display: none;\n  margin-right: .625rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #262a2e;\n  text-transform: capitalize;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-status {\n  font-size: 0.875rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-name, .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-body .user-status {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 150px;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .chat-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .chat-options-wrap > a {\n  margin-left: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  -ms-flex: 1;\n  flex: 1;\n  height: 100%;\n  overflow: auto;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body ul.list-unstyled {\n  width: 90%;\n  margin: 0 auto;\n  padding: 2rem 1.25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body {\n  margin-left: 0.75rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box > div {\n  padding: .625rem 1rem;\n  border-radius: 1.25rem;\n  display: inline-block;\n  position: relative;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box > div p:first-child {\n  color: #262a2e;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box > div .chat-time {\n  display: block;\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  margin-top: .25rem;\n  opacity: .5;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box + .msg-box {\n  margin-top: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box .msg-action {\n  margin-left: 1rem;\n  opacity: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0;\n  background: transparent !important;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box .msg-action:after {\n  display: none;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body .msg-box:hover .msg-action {\n  opacity: 1;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div {\n  cursor: pointer;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .file-name {\n  color: #262a2e;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 165px;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .file-size {\n  font-size: 0.875rem;\n  margin-top: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .file-overlay {\n  position: absolute;\n  opacity: 0;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  color: #fff;\n  background: rgba(38, 42, 46, 0.4);\n  border-radius: 1.25rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div:hover .file-overlay {\n  opacity: 1;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div.msg-action:after {\n  display: none;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box + .msg-box {\n  margin-top: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box > div {\n  padding: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box > div img {\n  border-radius: 1.25rem;\n  max-width: 336px;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box:first-child > div, .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-imgs .msg-box:last-child > div {\n  border-radius: 1.25rem !important;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.received {\n  margin-bottom: 1.25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.received .media-body .msg-box > div {\n  background: #f2f2f2;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.received .media-body .msg-box:first-child > div {\n  border-top-left-radius: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent {\n  margin-bottom: 1.25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body {\n  margin-left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box {\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box > div {\n  background: #0a2f4c;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box > div p {\n  color: #fff;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box > div .chat-time {\n  color: #fff;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box:first-child > div {\n  border-top-right-radius: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.sent .media-body .msg-box .msg-action {\n  margin-left: 0;\n  margin-right: 1rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.media-attachment {\n  margin-bottom: 1.125rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media.media-attachment .media-body > .msg-box {\n  margin-bottom: .25rem;\n  margin-right: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep {\n  position: relative;\n  text-align: center;\n  overflow: hidden;\n  font-size: 0.875rem;\n  margin: 1.875rem 0;\n  text-transform: capitalize;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep:before {\n  background: #eaeaea;\n  content: \"\";\n  height: 1px;\n  right: 50%;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep:after {\n  background: #eaeaea;\n  content: \"\";\n  height: 1px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .day-sep span {\n  display: inline-block;\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  padding: 0 .625rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .start-conversation {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 195px);\n  flex-flow: column;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 0.75rem 1.25rem;\n  background: #fff;\n  border-top: 1px solid #eaeaea;\n  margin-top: -1px;\n  position: relative;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .feather-icon, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .svg-icon {\n  display: block;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group {\n  width: 100%;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .form-control, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .form-select, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .wizard > .content > .body input, .wizard > .content > .body .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group input, .chatapp-wrap .chatapp-content .chatapp-single-chat footer.chat-footer .input-group .dd-handle {\n  margin: 0 0.75rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info {\n  position: absolute;\n  top: 65px;\n  right: -370px;\n  width: 370px;\n  margin-left: 0;\n  bottom: 0;\n  z-index: 100;\n  border: none;\n  background: #fff;\n  border-left: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .nicescroll-bar {\n  padding: 1.25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-name {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #262a2e;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info {\n  padding-left: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li {\n  margin-bottom: .625rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a {\n  color: #262a2e;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a .cp-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .5rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a .cp-icon-wrap .feather-icon, .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-info li a .cp-icon-wrap .svg-icon {\n  font-size: 1.125rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action {\n  padding-left: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action li {\n  margin-bottom: .625rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action li a {\n  color: #262a2e;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-action li:last-child {\n  margin-bottom: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files {\n  margin: 0 -.8rem;\n  padding-left: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li {\n  padding: .8rem;\n  border-radius: 0.5rem;\n  -webkit-transition: 0.2s ease;\n  -moz-transition: 0.2s ease;\n  transition: 0.2s ease;\n  margin-bottom: .25rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:last-child {\n  margin-bottom: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-head {\n  margin-right: 1rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-head .avatar.avatar-sm .avatar-icon {\n  font-size: 1.75rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  min-width: 0;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body > div:first-child {\n  min-width: 0;\n  -ms-flex: 1;\n  flex: 1;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body .file-name {\n  color: #262a2e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li .media .media-body .file-size {\n  margin-top: .25rem;\n  font-size: 0.875rem;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:hover {\n  background-color: #f2f2f2;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:hover .media .media-body .file-name {\n  color: #0a2f4c;\n}\n.chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .cp-files li:hover .media .media-body a.cp-file-action {\n  color: #262a2e;\n}\n.chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-body {\n  margin-right: 370px;\n}\n.chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-info {\n  right: 0;\n}\n.chatapp-wrap.chatapp-info-active .chatapp-single-chat footer.chat-footer {\n  margin-right: 370px;\n}\n.chatapp-wrap .chatapp-call-window .modal-content {\n  min-height: calc(100vh - 100px);\n}\n.chatapp-wrap .chatapp-call-window .modal-content .modal-header {\n  Padding: 0.3rem 1.25rem;\n}\n.chatapp-wrap .chatapp-call-window .modal-content .modal-header .modal-title {\n  text-align: center;\n  width: 100%;\n  font-size: 0.875rem;\n}\n.chatapp-wrap .chatapp-call-window .modal-content .modal-header > .modal-action {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  right: 1.25rem;\n  position: absolute;\n}\n.chatapp-wrap .chatapp-call-window .modal-content .modal-body {\n  display: flex;\n  align-items: center;\n  flex-flow: column;\n  justify-content: center;\n  padding: 3.125rem;\n}\n.chatapp-wrap .chatapp-call-window .modal-content .modal-footer {\n  border-top: 0;\n  min-height: 160px;\n  justify-content: center;\n}\n.chatapp-wrap .chatapp-call-window .modal-content .modal-footer .chatapp-caller-img {\n  right: 30px;\n  bottom: 30px;\n  position: absolute;\n}\n.chatapp-wrap .chatapp-call-window .modal-content.fullscreen {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto;\n  border-radius: 0;\n}\n.chatapp-wrap .chatapp-call-window .modal-content.fullscreen .modal-header {\n  border-radius: 0;\n}\n.chatapp-wrap .invite-user-list {\n  padding: 0 1rem;\n}\n.chatapp-wrap .invite-user-list > li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  margin-bottom: .625rem;\n}\n.chatapp-wrap .invite-user-list > li .user-name {\n  color: #262a2e;\n  font-weight: 500;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .chatapp-wrap {\n  height: 100vh;\n}\n\n.one {\n  opacity: 0;\n  -webkit-animation: dot 1.3s infinite;\n  -webkit-animation-delay: 0.0s;\n  animation: dot 1.3s infinite;\n  animation-delay: 0.0s;\n}\n\n.two {\n  opacity: 0;\n  -webkit-animation: dot 1.3s infinite;\n  -webkit-animation-delay: 0.2s;\n  animation: dot 1.3s infinite;\n  animation-delay: 0.2s;\n}\n\n.three {\n  opacity: 0;\n  -webkit-animation: dot 1.3s infinite;\n  -webkit-animation-delay: 0.3s;\n  animation: dot 1.3s infinite;\n  animation-delay: 0.3s;\n}\n\n@-webkit-keyframes dot {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes dot {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@media (max-width: 1599px) {\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info {\n    right: -320px;\n    width: 320px;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body ul.list-unstyled {\n    width: 100%;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-aside {\n    width: 320px;\n  }\n  .chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-info {\n    right: 0;\n  }\n  .chatapp-wrap.chatapp-info-active .chatapp-single-chat .chat-body {\n    margin-right: 20rem;\n  }\n  .chatapp-wrap.chatapp-info-active .chatapp-single-chat footer.chat-footer {\n    margin-right: 20rem;\n  }\n\n  ul.hk-list {\n    margin: 0 -.28rem;\n  }\n  ul.hk-list li {\n    padding: .68rem .28rem;\n  }\n}\n@media (min-width: 1200px) {\n  button.btn-close.info-close {\n    display: none;\n  }\n}\n@media (max-width: 1199px) {\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info {\n    top: 0;\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body {\n    margin-right: 0;\n  }\n  .chatapp-wrap.chatapp-info-active .chatapp-content .chatapp-single-chat .chat-body {\n    margin-right: 0;\n  }\n  .chatapp-wrap.chatapp-info-active .chatapp-content .chatapp-single-chat footer {\n    margin-right: 0;\n  }\n\n  /*Common for all App*/\n  button.btn-close.info-close {\n    top: 20px;\n    position: absolute;\n    right: 20px;\n    z-index: 1;\n  }\n}\n@media (min-width: 992px) {\n  .chatapp-wrap .chatapp-content .chatapp-aside .hk-sidebar-togglable {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .chatapp-wrap .chatapp-content .chatapp-aside {\n    width: 100%;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat {\n    right: -100%;\n    position: fixed;\n    top: 0;\n    width: 100%;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header {\n    justify-content: flex-start;\n    -webkit-justify-content: flex-start;\n    -ms-flex-pack: flex-start;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .back-user-list {\n    display: block;\n    flex-shrink: 0;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .chat-options-wrap {\n    margin-left: auto;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body ul.list-unstyled {\n    width: 100%;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-info .avatar.avatar-xxl {\n    width: 6rem;\n    height: 6rem;\n  }\n  .chatapp-wrap.chatapp-slide .chatapp-content .chatapp-aside {\n    left: -100%;\n  }\n  .chatapp-wrap.chatapp-slide .chatapp-content .chatapp-single-chat {\n    right: 0;\n  }\n  .chatapp-wrap .chatapp-call-window .modal-content .modal-footer .chatapp-caller-img {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .chatapp-wrap .chatapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-aside .aside-body .frequent-contact ul {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat header.chat-header .media .media-head .avatar.avatar-sm {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .avatar.avatar-xs {\n    width: 1.5rem;\n    height: 1.5rem;\n    flex-shrink: 0;\n  }\n  .chatapp-wrap .chatapp-content .chatapp-single-chat .chat-body .media .media-body.msg-docs .msg-box > div .media .file-name {\n    max-width: calc(100vw - 300px);\n  }\n  .chatapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .chatapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .chatapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .chatapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n/*Chat Popup*/\n@keyframes mercuryTypingAnimation {\n  0% {\n    transform: translateY(0px);\n    background-color: #99cbcf;\n  }\n  28% {\n    transform: translateY(-7px);\n    background-color: #6bb4ba;\n  }\n  44% {\n    transform: translateY(0px);\n    background-color: #3d9ca5;\n  }\n}\n.typing {\n  align-items: center;\n  display: flex;\n  height: 17px;\n}\n.typing .dot {\n  animation: mercuryTypingAnimation 1.8s infinite ease-in-out;\n  background-color: #99cbcf;\n  height: 5px;\n  border-radius: 50%;\n  margin-right: .25rem;\n  vertical-align: middle;\n  width: 5px;\n  display: inline-block;\n}\n.typing .dot:nth-child(1) {\n  animation-delay: 200ms;\n}\n.typing .dot:nth-child(2) {\n  animation-delay: 300ms;\n}\n.typing .dot:nth-child(3) {\n  animation-delay: 400ms;\n}\n.typing .dot:last-child {\n  margin-right: 0;\n}\n\n.hk-chat-popup {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  display: none;\n  width: 380px;\n  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);\n  z-index: 10000;\n  background: #fff;\n  flex-flow: column;\n}\n.hk-chat-popup header {\n  background: #262a2e;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  flex-shrink: 0;\n  Padding: 0.5rem 1.25rem;\n  height: 64px;\n}\n.hk-chat-popup header .media-wrap .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-chat-popup header .media-wrap .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.hk-chat-popup header .media-wrap .media .media-body .user-name {\n  font-size: 1rem;\n  color: #fff;\n  text-transform: capitalize;\n}\n.hk-chat-popup header .media-wrap .media .media-body .user-status {\n  font-size: 0.875rem;\n  color: #fff;\n  text-transform: capitalize;\n}\n.hk-chat-popup header .input-group .contact-search {\n  padding: 0;\n  color: #fff;\n  border: none;\n  background: transparent;\n}\n.hk-chat-popup .chat-popup-body {\n  overflow: auto;\n  flex: 1 1 auto;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap {\n  padding: 0 1.25rem 1.25rem;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list {\n  margin: 0 -0.8rem;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item {\n  padding: 0;\n  border: none;\n  margin-bottom: .25rem;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item:last-child {\n  margin-bottom: 0;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media {\n  padding: .75rem .8rem;\n  border-radius: 0.5rem;\n  -webkit-transition: 0.2s ease;\n  -moz-transition: 0.2s ease;\n  transition: 0.2s ease;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-head {\n  position: relative;\n  margin-right: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-width: 0;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child {\n  min-width: 0;\n  flex: 1;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name,\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-last-chat,\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-status {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:first-child .user-name {\n  color: #262a2e;\n  font-weight: 500;\n  margin-bottom: .25rem;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child {\n  text-align: right;\n  padding-left: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  width: 4.5rem;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child .last-chat-time {\n  font-size: 0.75rem;\n  color: #0a2f4c;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child .badge {\n  margin-top: .25rem;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media .media-body > div:last-child .action-drp {\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 15px;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover, .hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus {\n  background-color: #f2f2f2;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .action-drp, .hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .action-drp {\n  opacity: 1;\n  visibility: visible;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .last-chat-time,\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:hover .media-body > div:last-child .badge-pill, .hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .last-chat-time,\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media:focus .media-body > div:last-child .badge-pill {\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media.read-chat .media-body > div:last-child .last-chat-time {\n  color: #6f6f6f;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media.read-chat.active-user {\n  background-color: #f2f2f2;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .list-group-item .media.read-chat.active-user .media-body > div:first-child .user-name {\n  color: #0a2f4c;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .title-wth-divider {\n  padding: 0 .8rem;\n}\n.hk-chat-popup .chat-popup-body .contact-list-wrap .chat-contacts-list .title-wth-divider:after {\n  background: #f7f7f7;\n}\n.hk-chat-popup .chat-popup-body ul.list-unstyled {\n  width: 95%;\n  margin: 0 auto;\n  padding: 1.25rem 0;\n}\n.hk-chat-popup .chat-popup-body .media .media-body {\n  margin-left: 0.75rem;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div {\n  padding: .625rem 1rem;\n  border-radius: 1.25rem;\n  display: inline-block;\n  position: relative;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div p:first-child {\n  color: #262a2e;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div .chat-time {\n  display: block;\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  margin-top: .25rem;\n  opacity: .5;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div .file-overlay {\n  position: absolute;\n  opacity: 0;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  color: #fff;\n  background: rgba(38, 42, 46, 0.4);\n  border-radius: 1.25rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box > div:hover .file-overlay {\n  opacity: 1;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box + .msg-box {\n  margin-top: .25rem;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box .msg-action {\n  margin-left: 1rem;\n  opacity: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0;\n  background: transparent !important;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n}\n.hk-chat-popup .chat-popup-body .media .media-body .msg-box:hover .msg-action {\n  opacity: 1;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-docs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media .avatar.avatar-sm .avatar-icon {\n  font-size: 1.75rem;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media .file-name {\n  color: #262a2e;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 165px;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box > div .media .file-size {\n  font-size: 0.875rem;\n  margin-top: .25rem;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-docs .msg-box + .msg-box {\n  margin-top: 0;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box > div {\n  padding: 0;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box > div img {\n  border-radius: 1.25rem;\n  height: 150px;\n}\n.hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box:first-child > div, .hk-chat-popup .chat-popup-body .media .media-body.msg-imgs .msg-box:last-child > div {\n  border-radius: 1.25rem !important;\n}\n.hk-chat-popup .chat-popup-body .media.received {\n  margin-bottom: 1.25rem;\n}\n.hk-chat-popup .chat-popup-body .media.received .media-body .msg-box > div {\n  background: #f2f2f2;\n}\n.hk-chat-popup .chat-popup-body .media.received .media-body .msg-box:first-child > div {\n  border-top-left-radius: 0;\n}\n.hk-chat-popup .chat-popup-body .media.sent {\n  margin-bottom: 1.25rem;\n}\n.hk-chat-popup .chat-popup-body .media.sent .media-body {\n  margin-left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n}\n.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box {\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n}\n.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box > div {\n  background: #0a2f4c;\n}\n.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box > div p {\n  color: #fff;\n}\n.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box > div .chat-time {\n  color: #fff;\n}\n.hk-chat-popup .chat-popup-body .media.sent .media-body .msg-box:first-child > div {\n  border-top-right-radius: 0;\n}\n.hk-chat-popup .chat-popup-body .media.media-attachment {\n  margin-bottom: 17px;\n}\n.hk-chat-popup .chat-popup-body .media.media-attachment .media-body > .msg-box {\n  margin-bottom: .25rem;\n  margin-right: .25rem;\n}\n.hk-chat-popup .chat-popup-body .media.typing-wrap .media-body .msg-box > div:after {\n  display: none;\n}\n.hk-chat-popup .chat-popup-body .day-sep {\n  position: relative;\n  text-align: center;\n  overflow: hidden;\n  font-size: 0.875rem;\n  margin: 1.875rem 0;\n  text-transform: capitalize;\n}\n.hk-chat-popup .chat-popup-body .day-sep:before {\n  background: #eaeaea;\n  content: \"\";\n  height: 1px;\n  right: 50%;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.hk-chat-popup .chat-popup-body .day-sep:after {\n  background: #eaeaea;\n  content: \"\";\n  height: 1px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.hk-chat-popup .chat-popup-body .day-sep span {\n  display: inline-block;\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  padding: 0 .625rem;\n}\n.hk-chat-popup footer {\n  background: #fff;\n  border-top: 1px solid #eaeaea;\n  margin-top: -1px;\n  position: relative;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.hk-chat-popup footer .feather-icon, .hk-chat-popup footer .svg-icon {\n  display: block;\n}\n.hk-chat-popup footer .form-control, .hk-chat-popup footer .form-select, .hk-chat-popup footer .wizard > .content > .body input, .wizard > .content > .body .hk-chat-popup footer input, .hk-chat-popup footer .dd-handle {\n  height: 57px;\n}\n\n.btn-popup-open,\n.btn-popup-close {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 111;\n}\n\n.chat-popover {\n  position: fixed;\n  right: 20px;\n  bottom: 100px;\n  background: #fff;\n  width: 270px;\n  border-radius: 0.5rem;\n  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n  display: none;\n  z-index: 99;\n}\n.chat-popover p {\n  font-size: 0.875rem;\n}\n\n@media (max-width: 800px) {\n  .hk-chat-popup {\n    width: 100%;\n  }\n}\n/*Chatbot Popup*/\n.hk-chatbot-popup {\n  position: fixed;\n  bottom: 100px;\n  right: 30px;\n  display: none;\n  width: 380px;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);\n  z-index: 10000;\n  background: #fff;\n}\n.hk-chatbot-popup header {\n  background: #262a2e;\n  Padding: 0.5rem 1.25rem 5.5rem;\n}\n.hk-chatbot-popup header .chatbot-head-top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.hk-chatbot-popup header .media-wrap .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-chatbot-popup header .media-wrap .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.hk-chatbot-popup header .media-wrap .media .media-body .user-name,\n.hk-chatbot-popup header .media-wrap .media .media-body .user-status {\n  font-size: 1rem;\n  color: #fff;\n  text-transform: capitalize;\n}\n.hk-chatbot-popup header .media-wrap .media .media-body .user-status {\n  font-size: 0.875rem;\n}\n.hk-chatbot-popup .chatbot-popup-body {\n  height: calc(100vh - 440px);\n  position: relative;\n}\n.hk-chatbot-popup .chatbot-popup-body .nicescroll-bar {\n  margin-top: -5.25rem;\n}\n.hk-chatbot-popup .chatbot-popup-body .init-content-wrap {\n  padding: 1.25rem 1.25rem 1.25rem;\n}\n.hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap {\n  text-align: right;\n}\n.hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap .btn, .hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hk-chatbot-popup .chatbot-popup-body .init-content-wrap .btn-wrap .hopscotch-nav-button {\n  margin-bottom: .625rem;\n}\n.hk-chatbot-popup .chatbot-popup-body ul.list-unstyled {\n  width: 95%;\n  margin: 0 auto;\n  padding: 1.25rem 0;\n}\n.hk-chatbot-popup .chatbot-popup-body .media .media-body {\n  margin-left: 0.75rem;\n}\n.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box > div {\n  padding: .625rem 1rem;\n  border-radius: 1.25rem;\n  display: inline-block;\n  position: relative;\n}\n.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box > div p:first-child {\n  color: #262a2e;\n}\n.hk-chatbot-popup .chatbot-popup-body .media .media-body .msg-box + .msg-box {\n  margin-top: .25rem;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.received {\n  margin-bottom: 1.25rem;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.received .media-body .msg-box > div {\n  background: #f2f2f2;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.received .media-body .msg-box:first-child > div {\n  border-top-left-radius: 0;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.sent {\n  margin-bottom: 1.25rem;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body {\n  margin-left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box {\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box > div {\n  background: #0a2f4c;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box > div p {\n  color: #fff;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box > div .chat-time {\n  color: #fff;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.sent .media-body .msg-box:first-child > div {\n  border-top-right-radius: 0;\n}\n.hk-chatbot-popup .chatbot-popup-body .media.typing-wrap .media-body .msg-box > div:after {\n  display: none;\n}\n.hk-chatbot-popup .chatbot-popup-body .day-sep {\n  position: relative;\n  text-align: center;\n  overflow: hidden;\n  font-size: 0.875rem;\n  margin: 1.875rem 0;\n  text-transform: capitalize;\n}\n.hk-chatbot-popup .chatbot-popup-body .day-sep:before {\n  background: #eaeaea;\n  content: \"\";\n  height: 1px;\n  right: 50%;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.hk-chatbot-popup .chatbot-popup-body .day-sep:after {\n  background: #eaeaea;\n  content: \"\";\n  height: 1px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.hk-chatbot-popup .chatbot-popup-body .day-sep span {\n  display: inline-block;\n  background: #fff;\n  z-index: 1;\n  position: relative;\n  padding: 0 .625rem;\n}\n.hk-chatbot-popup footer {\n  background: #fff;\n}\n.hk-chatbot-popup footer .input-group {\n  border-top: 1px solid #eaeaea;\n}\n.hk-chatbot-popup footer .input-group .form-control, .hk-chatbot-popup footer .input-group .form-select, .hk-chatbot-popup footer .input-group .wizard > .content > .body input, .wizard > .content > .body .hk-chatbot-popup footer .input-group input, .hk-chatbot-popup footer .input-group .dd-handle {\n  height: 57px;\n}\n.hk-chatbot-popup footer .chatbot-intro-text {\n  text-align: center;\n  padding: .5rem 1.25rem;\n}\n.hk-chatbot-popup footer .footer-copy-text {\n  background: #f7f7f7;\n  padding: .5rem 1.25rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n  font-size: 0.75rem;\n}\n.hk-chatbot-popup footer .footer-copy-text .brand-link img {\n  width: 75px;\n  margin-left: .25rem;\n}\n\n@media (max-width: 767px) {\n  .hk-chatbot-popup {\n    width: 100%;\n    flex-flow: column;\n    border-radius: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n  }\n  .hk-chatbot-popup header {\n    Padding: 0.5rem 1.25rem 1rem;\n  }\n  .hk-chatbot-popup .chatbot-popup-body {\n    overflow: auto;\n    flex: 1 1 auto;\n    height: auto;\n  }\n  .hk-chatbot-popup .chatbot-popup-body .nicescroll-bar {\n    margin-top: 0;\n  }\n  .hk-chatbot-popup footer .chatbot-intro-text {\n    display: none;\n  }\n}\n/*Calendar*/\n.calendarapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n  -webkit-transition: height 0.2s ease;\n  -moz-transition: height 0.2s ease;\n  transition: height 0.2s ease;\n}\n.calendarapp-wrap .calendarapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.calendarapp-wrap .calendarapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker {\n  position: static;\n  display: block !important;\n  margin: 0;\n  border: none;\n  overflow: hidden;\n  width: auto;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar {\n  padding: 0;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table {\n  padding: 0;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table th, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td {\n  min-width: 30px;\n  width: 30px;\n  height: 30px;\n  z-index: 1;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table th.active, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table th:hover, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td.active, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:hover {\n  background: transparent;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:after {\n  content: \"\";\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 50%;\n  z-index: -1;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td.active, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:hover {\n  background: transparent;\n  color: #0a2f4c;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td.active:after, .calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .daterangepicker .drp-calendar .calendar-table td:hover:after {\n  background: #c7e2e5;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .upcoming-event-wrap .nav .nav-item .event-time {\n  color: #6f6f6f;\n  font-size: 0.75rem;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .upcoming-event-wrap .nav .nav-item .event-name {\n  margin-top: .25rem;\n  font-weight: 500;\n}\n.calendarapp-wrap .calendarapp-sidebar .menu-content-wrap .categories-wrap .form-check {\n  padding-top: .5rem;\n  padding-bottom: .5rem;\n}\n.calendarapp-wrap .calendarapp-sidebar .calendarapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.calendarapp-wrap .calendarapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 270px;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  margin-bottom: 0;\n  background: #fff;\n  position: relative;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  flex: 1;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group {\n  order: 2;\n  float: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group .fc-prev-button,\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group .fc-next-button {\n  border: none;\n  background: transparent;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .fc-today-button {\n  border-radius: 0.5rem;\n  margin-left: 0 !important;\n  margin-right: 1rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2) {\n  justify-content: center;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2) h2 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) {\n  justify-content: flex-end;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-toolbar > * > :not(:first-child) {\n  margin-left: 0.25rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-col-header td, .calendarapp-wrap .calendarapp-content .fc .fc-col-header th {\n  border: 1px solid #eaeaea;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-col-header-cell-cushion {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  padding: .25rem 0;\n  color: #262a2e;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-axis-cushion,\n.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-slot-label-cushion {\n  font-size: 0.875rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body {\n  width: 100% !important;\n  height: 100% !important;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body .fc-scrollgrid-sync-table {\n  width: 100% !important;\n  height: 100% !important;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body .fc-scrollgrid-sync-table td, .calendarapp-wrap .calendarapp-content .fc .fc-daygrid-body .fc-scrollgrid-sync-table th {\n  border: 1px solid #eaeaea;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day-top {\n  justify-content: center;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day-number {\n  padding: .625rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day.fc-day-today {\n  background: transparent;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top {\n  padding: .25rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top .fc-daygrid-day-number {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  height: 35px;\n  width: 35px;\n  background: #0a2f4c;\n  border-radius: 50%;\n  color: #fff;\n  position: relative;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-list-event-dot {\n  border-color: #0a2f4c;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-slot {\n  border-left: 0;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-divider {\n  border: 0;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-v-event {\n  background-color: #0a2f4c;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-timegrid-divider {\n  padding: 0;\n}\n.calendarapp-wrap .calendarapp-content .fc .table-bordered {\n  border: 1px solid #eaeaea;\n  border-left: 0;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-view-harness .fc-daygrid {\n  background: #fff;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-view-harness .fc-daygrid .table-bordered .fc-day-other {\n  background-color: #f7f7f7;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event {\n  padding: .125rem .375rem;\n  border-radius: 0.5rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event.has-avatar {\n  padding: .375rem .625rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event.has-avatar .avatar {\n  margin-right: .625rem;\n  flex-shrink: 0;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main i {\n  margin-right: .25rem;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main .fc-event-main-frame {\n  overflow: hidden;\n}\n.calendarapp-wrap .calendarapp-content .fc .fc-daygrid-event .fc-event-main .fc-event-main-frame .fc-event-title {\n  text-overflow: ellipsis;\n}\n.calendarapp-wrap .calendarapp-content .fc-daygrid-event-dot {\n  border-color: #0a2f4c;\n}\n.calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-sidebar {\n  left: -270px;\n}\n.calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-content {\n  padding-left: 0;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .calendarapp-wrap {\n  height: 100vh;\n}\n.hk-wrapper .calendar-drawer > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  flex-flow: column;\n}\n.hk-wrapper .calendar-drawer .event-head {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.hk-wrapper .calendar-drawer .event-head .event-name {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #262a2e;\n  outline: none;\n}\n.hk-wrapper .calendar-drawer .event-head .badge-indicator {\n  position: relative;\n  top: 7px;\n}\n.hk-wrapper .calendar-drawer .event-detail {\n  padding-left: 0;\n}\n.hk-wrapper .calendar-drawer .event-detail li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 1.125rem;\n}\n.hk-wrapper .calendar-drawer .event-detail li .ev-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  color: #262a2e;\n  position: relative;\n  top: 1px;\n  margin-right: .625rem;\n}\n.hk-wrapper .calendar-drawer .event-detail li .ev-icon-wrap .feather-icon, .hk-wrapper .calendar-drawer .event-detail li .ev-icon-wrap .svg-icon {\n  font-size: 1.125rem;\n}\n\n@media (max-width: 1199px) {\n  .calendarapp-wrap .calendarapp-sidebar {\n    left: -270px;\n  }\n  .calendarapp-wrap .calendarapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .calendarapp-wrap .calendarapp-content .fc-toolbar-chunk:nth-child(3) > .btn-group {\n    display: none;\n  }\n  .calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-sidebar {\n    left: 0;\n  }\n  .calendarapp-wrap.calendarapp-sidebar-toggle .calendarapp-content {\n    left: 270px;\n    padding-left: 270px;\n    margin-left: -270px;\n  }\n  .calendarapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .calendarapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .calendarapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .calendarapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n/*Email UI*/\n.emailapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n  -webkit-transition: height 0.2s ease;\n  -moz-transition: height 0.2s ease;\n  transition: height 0.2s ease;\n}\n.emailapp-wrap .emailapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.emailapp-wrap .emailapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.emailapp-wrap .emailapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .375rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n  font-size: 1.5rem;\n}\n.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.emailapp-wrap .emailapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.emailapp-wrap .emailapp-sidebar .emailapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.emailapp-wrap .emailapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 270px;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside {\n  border-right: 1px solid #eaeaea;\n  background: #fff;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  height: 100%;\n  z-index: 1;\n  left: 0;\n  width: 370px;\n  flex-shrink: 0;\n  margin-top: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  border-bottom: 1px solid #eaeaea;\n  background: #fff;\n  color: #262a2e;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .emailapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .emailapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .emailapp-title:after {\n  top: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .btn, .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .hopscotch-nav-button {\n  margin-right: .5rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .btn:last-child, .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .hopscotch-nav-button:last-child, div.hopscotch-bubble .hopscotch-bubble-container .hopscotch-actions .emailapp-wrap .emailapp-content .emailapp-aside header.aside-header .hopscotch-nav-button:last-child {\n  margin-right: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-search {\n  margin-bottom: 1.25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body {\n  overflow: auto;\n  -ms-flex: 1;\n  flex: 1;\n  height: 100%;\n  padding: 1.25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list {\n  margin: 0 -0.8rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item {\n  padding: 0;\n  border: none;\n  margin-bottom: .25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media {\n  padding: .75rem .8rem;\n  border-radius: 0.5rem;\n  -webkit-transition: 0.2s ease;\n  -moz-transition: 0.2s ease;\n  transition: 0.2s ease;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-head {\n  position: relative;\n  margin-right: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-head .badge-indicator {\n  margin-top: .875rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-width: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div {\n  min-width: 0;\n  flex: 1;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: .25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-left: auto;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: .625rem;\n  opacity: 0;\n  color: #6f6f6f;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star .svg-icon > svg {\n  cursor: pointer;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked {\n  opacity: 1;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div > div:first-child div:last-child .email-time {\n  font-size: 0.75rem;\n  margin-left: .625rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-head,\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-subject {\n  color: #262a2e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-subject {\n  margin-bottom: .25rem;\n  font-weight: 500;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-head {\n  font-weight: 500;\n  margin-right: .5rem;\n  max-width: 150px;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media .media-body > div .email-text {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  font-size: 0.875rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:hover, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:focus {\n  background-color: #f2f2f2;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:hover .media-body > div > div:first-child div:last-child .email-star, .emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media:focus .media-body > div > div:first-child div:last-child .email-star {\n  opacity: 1;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .list-group-item .media.read-email.active-user {\n  background-color: #f2f2f2;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .hk-section-head-border {\n  padding: 0 .8rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-aside .aside-body .email-list .hk-section-head-border:after {\n  background: #f7f7f7;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .feather-icon, .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .svg-icon {\n  display: block;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .back-user-list {\n  display: none;\n  margin-right: .625rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media .media-body .user-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #262a2e;\n  text-transform: capitalize;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .media .media-body .user-status {\n  font-size: 0.875rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-subject {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  margin-bottom: 1.25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-subject > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-subject > div h4 {\n  margin-bottom: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item {\n  overflow: auto;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header {\n  border-color: transparent;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div {\n  padding: 1.25rem;\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .media .media-head {\n  margin-right: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .media .media-body > div:first-child {\n  color: #262a2e;\n  font-weight: 500;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-time {\n  font-size: 0.75rem;\n  margin-right: 1.25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .625rem;\n  position: relative;\n  z-index: 1;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star .svg-icon > svg {\n  cursor: pointer;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked > .feather-icon > svg, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked > .feather-icon > svg:hover, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action .email-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head .email-head-action > a {\n  display: none;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle=\"collapse\"] {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  border-top-left-radius: calc(0.5rem - 1px);\n  border-top-right-radius: calc(0.5rem - 1px);\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle=\"collapse\"] ~ .media .media-body > div:last-child {\n  display: none;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] ~ .email-head-action > a {\n  display: inline-block;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div .email-head [data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] ~ .media .media-body > div:last-child {\n  display: block;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .accordion-header > div[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] .email-head .email-head-action > a {\n  display: inline-block;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box {\n  margin-bottom: .5rem;\n  margin-right: .25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div {\n  cursor: pointer;\n  padding: .625rem 1rem;\n  border-radius: 1.25rem;\n  display: inline-block;\n  position: relative;\n  background: #f2f2f2;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media .avatar.avatar-sm .avatar-icon {\n  font-size: 1.75rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media .media-body {\n  margin-left: 1.25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .media .file-size {\n  margin-top: .25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div .file-overlay {\n  position: absolute;\n  opacity: 0;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  color: #fff;\n  background: rgba(38, 42, 46, 0.4);\n  border-radius: 1.25rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div:hover .file-overlay {\n  opacity: 1;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .email-attachment-wrap .attachment-box > div.msg-action:after {\n  display: none;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown {\n  display: inline-block;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown > .dropdown-toggle {\n  position: relative;\n  z-index: 1;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu {\n  padding: 1rem;\n  font-size: .875rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div {\n  margin-bottom: .25rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div:last-child, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div:last-child, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div:last-child {\n  margin-bottom: 0;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div > span, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div > span, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div > span {\n  display: inline-block;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div > span:first-child, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div > span:first-child, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div > span:first-child {\n  min-width: 50px;\n  text-align: right;\n  margin-right: .5rem;\n}\n.emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .dropdown-menu > div > span:last-child, .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-toolbar .apexcharts-menu > div > span:last-child, .apexcharts-toolbar .emailapp-wrap .emailapp-content .emailapp-single-email .email-body .single-email-thread .accordion-item .mail-desc-dropdown .apexcharts-menu > div > span:last-child {\n  color: #262a2e;\n}\n.emailapp-wrap.emailapp-sidebar-toggle .emailapp-sidebar {\n  left: -270px;\n}\n.emailapp-wrap.emailapp-sidebar-toggle .emailapp-content {\n  padding-left: 0;\n}\n.emailapp-wrap .compose-email-popup {\n  position: fixed;\n  bottom: 0;\n  right: 20px;\n  width: 700px;\n  overflow-y: auto;\n  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);\n  z-index: 10000;\n  background: #fff;\n  display: none;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n.emailapp-wrap .compose-email-popup header {\n  Padding: 0.75rem 1.25rem;\n  background: #262a2e;\n  color: #fff;\n}\n.emailapp-wrap .compose-email-popup header #max_compose_popup .icon > span:last-child {\n  display: none;\n}\n.emailapp-wrap .compose-email-popup header .btn-close {\n  color: #fff;\n  opacity: .6;\n}\n.emailapp-wrap .compose-email-popup header .btn-close:not(:disabled):not(.disabled):focus, .emailapp-wrap .compose-email-popup header .btn-close:not(:disabled):not(.disabled):hover {\n  color: #fff;\n  opacity: 1;\n}\n.emailapp-wrap .compose-email-popup form {\n  padding: 1rem;\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.emailapp-wrap .compose-email-popup form textarea {\n  height: 230px;\n}\n.emailapp-wrap .compose-email-popup.minimize-email-popup {\n  width: 300px;\n  min-height: auto;\n}\n.emailapp-wrap .compose-email-popup.minimize-email-popup form, .emailapp-wrap .compose-email-popup.minimize-email-popup .compose-email-footer {\n  display: none;\n}\n.emailapp-wrap .compose-email-popup.maximize-email-popup {\n  width: calc(100vw - 700px);\n  height: calc(100vh - 200px);\n  bottom: 0;\n  right: 0;\n  left: 0;\n  top: 0;\n  margin: auto;\n}\n.emailapp-wrap .compose-email-popup.maximize-email-popup header #max_compose_popup .icon > span:first-child {\n  display: none;\n}\n.emailapp-wrap .compose-email-popup.maximize-email-popup header #max_compose_popup .icon > span:last-child {\n  display: inline;\n}\n.emailapp-wrap .compose-email-popup.maximize-email-popup form textarea.form-control, .emailapp-wrap .compose-email-popup.maximize-email-popup form textarea.form-select, .emailapp-wrap .compose-email-popup.maximize-email-popup form textarea.dd-handle {\n  height: calc( 100vh - 500px);\n}\n.emailapp-wrap .compose-email-popup .compose-email-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  padding: 0 1rem 1rem;\n}\n\n.hk-wrapper.hk__email__backdrop::after {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background: #262a2e;\n  opacity: 0.5;\n  z-index: 1033;\n  top: 0;\n  left: 0;\n  content: \"\";\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .emailapp-wrap {\n  height: 100vh;\n}\n\n@media (max-width: 1199px) {\n  .emailapp-wrap .emailapp-sidebar {\n    left: -270px;\n  }\n  .emailapp-wrap .emailapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .emailapp-wrap.emailapp-sidebar-toggle .emailapp-sidebar {\n    left: 0;\n  }\n  .emailapp-wrap.emailapp-sidebar-toggle .emailapp-content {\n    left: 270px;\n    padding-left: 270px;\n    margin-left: -270px;\n  }\n  .emailapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .emailapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .emailapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .emailapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n@media (max-width: 991px) {\n  .emailapp-wrap .emailapp-content .emailapp-aside {\n    width: 100%;\n  }\n  .emailapp-wrap .emailapp-content .emailapp-single-email {\n    right: -100%;\n    position: fixed;\n    top: 0;\n    width: 100%;\n  }\n  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header {\n    justify-content: flex-start;\n    -webkit-justify-content: flex-start;\n    -ms-flex-pack: flex-start;\n  }\n  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .back-user-list {\n    display: block;\n    flex-shrink: 0;\n  }\n  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .email-options-wrap + .email-options-wrap {\n    margin-left: auto;\n  }\n  .emailapp-wrap .emailapp-content .emailapp-single-email header.email-header .hk-navbar-togglable {\n    display: none !important;\n  }\n  .emailapp-wrap.emailapp-slide .emailapp-content .emailapp-aside {\n    left: -100%;\n  }\n  .emailapp-wrap.emailapp-slide .emailapp-content .emailapp-single-email {\n    right: 0;\n  }\n  .emailapp-wrap .compose-email-popup {\n    width: 100%;\n    height: 100%;\n    right: 0;\n    border-radius: 0;\n  }\n  .emailapp-wrap .compose-email-popup form textarea.form-control, .emailapp-wrap .compose-email-popup form textarea.form-select, .emailapp-wrap .compose-email-popup form textarea.dd-handle {\n    height: calc( 100vh - 300px) !important;\n  }\n  .emailapp-wrap .compose-email-popup.maximize-email-popup {\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    border-radius: 0;\n  }\n}\n/*Taskboard*/\n.taskboardapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n  -webkit-transition: height 0.2s ease;\n  -moz-transition: height 0.2s ease;\n  transition: height 0.2s ease;\n}\n.taskboardapp-wrap .taskboardapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.taskboardapp-wrap .taskboardapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link,\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap,\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1.5rem;\n  margin-right: .875rem;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text,\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.taskboardapp-wrap .taskboardapp-sidebar .taskboardapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.taskboardapp-wrap .taskboardapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 270px;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  width: 100%;\n  z-index: 10;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  white-space: nowrap;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-left: .625rem;\n  font-size: 1.25rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star > .feather-icon > svg, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star .svg-icon > svg {\n  cursor: pointer;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star > .feather-icon > svg:hover, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked > .feather-icon > svg, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked > .feather-icon > svg:hover, .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title h1 .task-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboardapp-title:after {\n  top: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media .media-body .user-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #262a2e;\n  text-transform: capitalize;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .media .media-body .user-status {\n  font-size: 0.875rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > .d-flex.ms-auto > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap header.taskboard-header .taskboard-options-wrap > .d-flex.ms-auto > a:first-child {\n  margin-left: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body {\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  width: 100%;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .taskbar-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  padding: 1.25rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-scroll {\n  display: -ms-flexbox;\n  display: flex;\n  overflow-x: auto;\n  max-height: 100%;\n  overflow-y: hidden;\n  margin-top: 2.25rem;\n  padding-bottom: 1.25rem;\n  -webkit-transition: width 0.2s ease;\n  -moz-transition: width 0.2s ease;\n  transition: width 0.2s ease;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  padding: 0 1.25rem;\n  float: left;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .tasklist {\n  max-height: 100%;\n  margin: 0 .875rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .tasklist:first-child {\n  margin-left: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .tasklist:last-child {\n  margin-right: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .spipeline-list {\n  margin: 0 .875rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .spipeline-list:first-child {\n  margin-left: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body > div .tasklist-wrap .spipeline-list:last-child {\n  margin-right: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap {\n  margin-top: 3.75rem;\n  margin-bottom: 3.75rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] {\n  margin-bottom: 1.875rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card {\n  margin-bottom: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card .media .media-head {\n  margin-right: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.board-card .media .media-head {\n  margin-right: 1rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.board-card .media .media-body {\n  overflow: hidden;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.board-card .media .media-body span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #262a2e;\n  font-weight: 500;\n  font-size: 1.125rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.team-card .media .media-head {\n  margin-right: 1rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.team-card .media .media-body {\n  overflow: hidden;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.team-card .media .media-body > div:first-child {\n  color: #262a2e;\n  font-weight: 500;\n  font-size: 1.125rem;\n  margin-bottom: .25rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.team-card .media .media-body > div:first-child .badge {\n  margin-left: .625rem;\n  flex-shrink: 0;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.team-card .media .media-body > div:first-child span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 200px;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body .board-team-wrap .tab-pane .row > [class*=\"col-\"] .card.team-card .media .media-body > div:last-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body.taskboard-body-alt {\n  background: #f7f7f7;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-body.taskboard-body-alt > div .tasklist-scroll {\n  overflow: auto;\n  max-height: inherit;\n  height: 100%;\n  margin-top: 0;\n  padding-bottom: 1.25rem;\n  padding-top: 1.875rem;\n  margin-bottom: 5.125rem;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-info {\n  position: absolute;\n  top: 65px;\n  right: -370px;\n  width: 370px;\n  margin-left: 0;\n  bottom: 0;\n  z-index: 100;\n  border: none;\n  background: #fff;\n  border-left: 1px solid #eaeaea;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-info .nicescroll-bar {\n  padding: 1.25rem;\n}\n.taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-sidebar {\n  left: -270px;\n}\n.taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-content {\n  padding-left: 0;\n}\n.taskboardapp-wrap.taskboardapp-info-active .taskboardapp-detail-wrap .taskboard-info {\n  right: 0;\n}\n\n.tasklist {\n  min-height: 100px;\n  width: 350px;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  background: #f7f7f7;\n}\n.tasklist > .card-header {\n  flex-flow: column;\n}\n.tasklist > .card-header > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n.tasklist .tasklist-handle {\n  cursor: grab;\n}\n.tasklist .tasklist-handle h6 {\n  pointer-events: none;\n}\n.tasklist.add-new-task {\n  min-height: 0;\n  border: 0;\n  background: transparent;\n}\n\n.spipeline-list {\n  min-height: 100px;\n  width: 350px;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  background: transparent;\n}\n.spipeline-list > .card-header {\n  flex-flow: column;\n  background: #fff;\n  border-radius: 0.5rem !important;\n  margin-bottom: .875rem;\n}\n.spipeline-list > .card-header > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  width: 100%;\n}\n.spipeline-list > .card-header > div .overall-estimation {\n  color: #262a2e;\n  font-weight: 500;\n}\n.spipeline-list > .card-header > div .spipeline-dot-sep {\n  color: #d8d8d8;\n  margin: 0 5px;\n}\n.spipeline-list > .card-header > div .lead-count {\n  font-size: 0.75rem;\n}\n.spipeline-list > .card-header .btn-block {\n  margin-top: 1rem;\n}\n.spipeline-list > .card-body {\n  border-radius: 0.5rem !important;\n  padding: 0;\n}\n.spipeline-list .spipeline-handle {\n  cursor: grab;\n}\n.spipeline-list .spipeline-handle h6 {\n  pointer-events: none;\n}\n.spipeline-list.create-new-list {\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  min-height: 139px;\n}\n.spipeline-list.create-new-list > .card-header {\n  background: transparent;\n  margin: 0;\n}\n.spipeline-list.create-new-list > .card-header .btn-block {\n  margin: 0;\n}\n\n.tasklist-card .card-header .card-action-wrap {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease;\n  -moz-transition: opacity 0.2s ease;\n  transition: opacity 0.2s ease;\n}\n.tasklist-card:hover .card-header .card-action-wrap {\n  opacity: 1;\n}\n.tasklist-card .card-body {\n  padding-top: 0;\n}\n.tasklist-card .card-footer > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.tasklist-card .card-footer .task-counter,\n.tasklist-card .card-footer .task-discuss {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 0.875rem;\n}\n.tasklist-card .card-footer .task-counter > span,\n.tasklist-card .card-footer .task-discuss > span {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.tasklist-card .card-footer .task-counter > span:first-child,\n.tasklist-card .card-footer .task-discuss > span:first-child {\n  margin-right: .25rem;\n}\n.tasklist-card .card-footer .task-discuss {\n  margin-left: .5rem;\n}\n.tasklist-card .card-footer .task-deadline {\n  font-size: 0.875rem;\n}\n\n.spipeline-card .card-body {\n  padding: .75rem 1.25rem;\n}\n.spipeline-card .card-body > .media .media-head {\n  margin-right: 1rem;\n}\n.spipeline-card .card-body > .media .media-body .brand-name {\n  color: #262a2e;\n  font-weight: 600;\n}\n.spipeline-card .card-body > .media .media-body .price-estimation {\n  color: #262a2e;\n  font-weight: 500;\n}\n.spipeline-card .card-body > .media .media-body .media {\n  margin-top: .25rem;\n}\n.spipeline-card .card-body > .media .media-body .media .media-head {\n  margin-right: .25rem;\n}\n.spipeline-card .card-body > .media .media-body .media .media-body p {\n  font-size: 0.75rem;\n}\n.spipeline-card .card-body .spipeline-dropdown .position-relative {\n  top: -10px;\n}\n.spipeline-card .card-body .spipeline-dropdown .dropdown-item {\n  padding: .5rem .75rem;\n}\n.spipeline-card.lost-deal {\n  background: #ffebeb;\n}\n.spipeline-card.won-deal {\n  background: #ebfcf5;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .taskboardapp-wrap {\n  height: 100vh;\n}\n\n.task-detail-modal .modal-body header.task-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  padding: 1.25rem;\n  border-radius: 0.5rem 0.5rem 0 0;\n  height: 65px;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n  margin-right: 12.5rem;\n}\n.task-detail-modal .modal-body header.task-header .apexcharts-datalabels-group text {\n  font-family: inherit;\n  font-size: 0.75rem;\n  fill: #6f6f6f;\n  position: absolute;\n  transform: translateY(5px);\n}\n.task-detail-modal .modal-body header.task-header .apexcharts-datalabels-group text:last-child {\n  display: none;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star > .feather-icon > svg, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star .svg-icon > svg {\n  height: 21px;\n  width: 21px;\n  cursor: pointer;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star > .feather-icon > svg:hover, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg:hover, .task-detail-modal .modal-body header.task-header .task-options-wrap .task-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap > a {\n  display: inline-block;\n}\n.task-detail-modal .modal-body header.task-header .task-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.task-detail-modal .modal-body .task-detail-body {\n  padding: 1.25rem;\n  margin-right: 12.5rem;\n}\n.task-detail-modal .modal-body .task-detail-body form .media .media-head {\n  margin-right: 1rem;\n}\n.task-detail-modal .modal-body .task-detail-body form .media .media-body .as-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media {\n  margin-bottom: 1.25rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media .media-head {\n  margin-right: 1rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:first-child {\n  font-weight: 500;\n  color: #262a2e;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:last-child {\n  font-size: 0.875rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-head {\n  margin-right: 1rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .cm-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .badge {\n  margin-left: .625rem;\n  flex-shrink: 0;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap span, .task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap a {\n  color: #6f6f6f;\n  font-size: 0.75rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {\n  margin: 0 .25rem;\n  color: #d8d8d8;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > .media {\n  margin-top: 1.875rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files {\n  margin: 0 -.8rem;\n  padding-left: 0;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li {\n  padding: .8rem;\n  border-radius: 0.5rem;\n  -webkit-transition: 0.2s ease;\n  -moz-transition: 0.2s ease;\n  transition: 0.2s ease;\n  margin-bottom: .25rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:last-child {\n  margin-bottom: 0;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-head {\n  margin-right: 1rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-head .avatar.avatar-sm .avatar-icon {\n  font-size: 1.75rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  min-width: 0;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:first-child {\n  min-width: 0;\n  -ms-flex: 1;\n  flex: 1;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:last-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-name {\n  color: #262a2e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n  max-width: 200px;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-size {\n  margin-top: .25rem;\n  font-size: 0.875rem;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover {\n  background-color: #f2f2f2;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body .file-name {\n  color: #0a2f4c;\n}\n.task-detail-modal .modal-body .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body a.cp-file-action {\n  color: #262a2e;\n}\n.task-detail-modal .modal-body .task-action-wrap {\n  position: absolute;\n  top: 0;\n  width: 200px;\n  right: 0;\n  z-index: 1;\n  border-left: 1px solid #eaeaea;\n  bottom: 0;\n  background: #fff;\n}\n.task-detail-modal .modal-body .task-action-wrap .nicescroll-bar {\n  padding: 1.5rem;\n}\n.task-detail-modal .modal-body .task-action-wrap .nicescroll-bar .nav-vertical > .nav-item > .nav-link {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n@media (max-width: 1399px) {\n  .taskboardapp-wrap .taskboardapp-sidebar {\n    left: -270px;\n  }\n  .taskboardapp-wrap .taskboardapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-sidebar {\n    left: 0;\n  }\n  .taskboardapp-wrap.taskboardapp-sidebar-toggle .taskboardapp-content {\n    left: 270px;\n    padding-left: 270px;\n    margin-left: -270px;\n  }\n  .taskboardapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .taskboardapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .taskboardapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .taskboardapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n@media (max-width: 1199px) {\n  .taskboardapp-wrap .taskboardapp-content .taskboardapp-detail-wrap .taskboard-info {\n    top: 0;\n  }\n\n  .info-close {\n    position: relative;\n    top: -4px;\n  }\n\n  .task-detail-modal .modal-body header.task-header,\n  .task-detail-modal .modal-body .task-detail-body {\n    margin-right: 0;\n  }\n\n  .task-action-wrap {\n    display: none;\n  }\n}\n/*Checklist List*/\n.hk-checklist .form-check {\n  margin-bottom: .625rem;\n  position: relative;\n}\n.hk-checklist .form-check .form-check-label {\n  position: relative;\n}\n.hk-checklist .form-check .done-strikethrough {\n  display: block;\n  height: 12px;\n  background: #FF0000;\n  mix-blend-mode: multiply;\n  opacity: .08;\n  width: 0;\n  transition: width .35s ease-in-out, opacity .25s ease-in-out;\n  position: absolute;\n  margin-left: 0;\n  top: 35%;\n  left: 0;\n  pointer-events: none;\n  content: \"\";\n}\n.hk-checklist .form-check.form-check input:checked + label .done-strikethrough {\n  width: 100%;\n}\n.hk-checklist .form-check .delete-checklist {\n  position: absolute;\n  right: 0;\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in-out;\n  -moz-transition: opacity 0.2s ease-in-out;\n  transition: opacity 0.2s ease-in-out;\n}\n.hk-checklist .form-check:hover .delete-checklist {\n  opacity: 1;\n}\n.hk-checklist .add-new-checklist .feather-icon {\n  margin-right: .25rem;\n}\n.hk-checklist .form-control.checklist-input, .hk-checklist .checklist-input.form-select, .hk-checklist .wizard > .content > .body input.checklist-input, .wizard > .content > .body .hk-checklist input.checklist-input, .hk-checklist .checklist-input.dd-handle {\n  position: absolute;\n  top: 0;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  height: auto;\n  width: auto;\n}\n\n/*Contact */\n.contactapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n}\n.contactapp-wrap .contactapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contactapp-wrap .contactapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n  font-size: 1.5rem;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.contactapp-wrap .contactapp-sidebar .menu-content-wrap .tag-cloud .badge {\n  margin-bottom: .25rem;\n}\n.contactapp-wrap .contactapp-sidebar .contactapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.contactapp-wrap .contactapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contactapp-wrap .contactapp-content header.contact-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.contactapp-wrap .contactapp-content header.contact-header .contactapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.contactapp-wrap .contactapp-content header.contact-header .contactapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.contactapp-wrap .contactapp-content header.contact-header .contactapp-title:after {\n  top: 0;\n}\n.contactapp-wrap .contactapp-content header.contact-header .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.contactapp-wrap .contactapp-content header.contact-header .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.contactapp-wrap .contactapp-content header.contact-header .media .media-body .user-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #262a2e;\n  text-transform: capitalize;\n}\n.contactapp-wrap .contactapp-content header.contact-header .media .media-body .user-status {\n  font-size: 0.875rem;\n}\n.contactapp-wrap .contactapp-content header.contact-header .contact-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.contactapp-wrap .contactapp-content header.contact-header .contact-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.contactapp-wrap .contactapp-content header.contact-header .contact-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap {\n  padding: 1rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form {\n  border-radius: 0.5rem;\n  padding: 1.25rem;\n  background: #f7f7f7;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form .dropify-square {\n  position: absolute;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form .dropify-square .dropify-wrapper {\n  height: 5.75rem;\n  width: 5.75rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .quick-access-form-wrap .quick-access-form .col-md-12 {\n  padding-left: 7.125rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-left,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-left,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right {\n  min-height: 45px;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-left > div,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-left > div {\n  margin-right: 1rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-left > div:last-child,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-left > div:last-child {\n  margin-right: 0;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right {\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right > div,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right > div {\n  margin-left: 1rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right > div:first-child,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right > div:first-child {\n  margin-left: 0;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_filter,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_filter,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info {\n  float: none;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_filter label,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length label,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info label,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_filter label,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length label,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info label {\n  margin-bottom: 0;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info {\n  padding-top: 0;\n  width: 95px;\n  text-align: right;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_paginate,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_paginate {\n  padding-top: 0;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child),\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {\n  display: none;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link {\n  padding: 0;\n  background: transparent;\n  min-width: auto;\n  font-size: 1.25rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length select,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length select {\n  margin-right: 0;\n  margin-left: .625rem;\n  display: inline-block;\n  width: auto;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: .625rem;\n  font-size: 1rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star .svg-icon > svg {\n  cursor: pointer;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .form-check.form-check-lg {\n  position: absolute;\n  left: 14px;\n  top: 17px;\n  cursor: pointer;\n  opacity: 0;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-name {\n  color: #262a2e;\n  font-weight: 500;\n  margin-top: .625rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-name,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-email,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-contact,\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .user-desg {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-bottom: .25rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .card-footer {\n  padding: 0;\n  justify-content: center;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card .card-footer > .d-flex {\n  padding: 0.75rem 1.25rem;\n  justify-content: center;\n  width: 100%;\n  color: #6f6f6f;\n  font-size: 1rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card.contact-card:hover .form-check.form-check-lg {\n  opacity: 1;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .625rem;\n  opacity: 0;\n  font-size: 1rem;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star .svg-icon > svg {\n  cursor: pointer;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked {\n  opacity: 1;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked > .feather-icon > svg, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked > .feather-icon > svg:hover, .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card .contact-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .card:hover .contact-star {\n  opacity: 1;\n}\n.contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view.select-multiple .card.contact-card .form-check.form-check-lg {\n  opacity: 1;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar {\n  padding: 0 !important;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info {\n  position: relative;\n  padding: 1.25rem;\n  flex-shrink: 0;\n  border-right: 1px solid #eaeaea;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .action-btn {\n  position: absolute;\n  right: 1.25rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .cp-name {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #262a2e;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .cp-info {\n  padding-left: 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .dropify-circle .dropify-wrapper {\n  margin: 0 auto;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card {\n  margin-bottom: 0;\n  box-shadow: none;\n  border: 0;\n  border-radius: 0;\n  border-radius: 0;\n  padding: 0.5rem 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-header {\n  border: none;\n  padding: .5rem 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-header > a {\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: block;\n  width: 100%;\n  color: #0a2f4c;\n  text-align: left;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body {\n  padding: .5rem 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li {\n  margin-bottom: .625rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li a {\n  color: #262a2e;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li > span {\n  display: inline-block;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li > span:first-child {\n  min-width: 100px;\n  margin-right: 1rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-info li > span:last-child {\n  color: #262a2e;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action {\n  padding-left: 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li {\n  margin-bottom: 10px;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li a {\n  color: #262a2e;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li a .cp-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .5rem;\n  font-size: 1.125rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-info .card .card-body .cp-action li:last-child {\n  margin-bottom: .25rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info {\n  flex-grow: 1;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .nav-tabs .nav-item .nav-link {\n  padding: .75rem 1.25rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .nav-tabs.nav-line {\n  border-bottom: 1px solid #eaeaea;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .tab-content {\n  padding: 0 1.25rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap {\n  padding: 0 1.25rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus {\n  padding: 0;\n  list-style-type: none;\n  font-family: arial;\n  font-size: 0.875rem;\n  clear: both;\n  line-height: 1em;\n  margin: 0 -1px;\n  text-align: center;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li {\n  float: left;\n  padding: 1rem 1.875rem 1rem 2.5rem;\n  background: #d8d8d8;\n  position: relative;\n  width: 19.5%;\n  margin: 0 1px;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:before {\n  content: '';\n  border-left: 20px solid #fff;\n  border-top: 20px solid transparent;\n  border-bottom: 20px solid transparent;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:first-child {\n  border-radius: 0.5rem 0 0 0.5rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:first-child:before {\n  display: none;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:last-child {\n  border-radius: 0 0.5rem 0.5rem 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:last-child:after {\n  display: none;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li:after {\n  content: '';\n  border-left: 20px solid #d8d8d8;\n  border-top: 20px solid transparent;\n  border-bottom: 20px solid transparent;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 100%;\n  z-index: 20;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.active {\n  background: #FF9100;\n  color: #fff;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.active:after {\n  border-left-color: #FF9100;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.completed {\n  background: #0a2f4c;\n  color: #fff;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li.completed:after {\n  border-left-color: #0a2f4c;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .pipeline-status-wrap .pipeline-stutus li > span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap {\n  padding: 0 1.25rem 1.25rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread {\n  padding-left: 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li {\n  margin-bottom: 1rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li:last-child {\n  margin-bottom: 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li .media .media-head {\n  margin-right: 1rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-body .nicescroll-bar .contact-more-info .activity-wrap .activity-thread li .media .media-body > div .activity-time {\n  font-size: 0.75rem;\n  margin-top: .25rem;\n}\n.contactapp-wrap .contactapp-content .contact-detail-modal header.contact-header {\n  height: auto;\n  padding: 1.25rem;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n.contactapp-wrap .contactapp-content .contact-detail-modal header.contact-header ul.hk-list.hk-list-sm li {\n  padding: 0 .4rem;\n}\n.contactapp-wrap.contactapp-sidebar-toggle .contactapp-sidebar {\n  left: -270px;\n}\n.contactapp-wrap.contactapp-sidebar-toggle .contactapp-content {\n  padding-left: 0;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .contactapp-wrap {\n  height: 100vh;\n}\n\n@media (max-width: 1740px) {\n  .contactapp-wrap .contactapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_info,\n  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-list-view .contact-toolbar-right .dataTables_length,\n  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_info,\n  .contactapp-wrap .contactapp-content .contactapp-detail-wrap .contact-body .nicescroll-bar .contact-card-view .contact-toolbar-right .dataTables_length {\n    display: none;\n  }\n  .contactapp-wrap .contactapp-sidebar {\n    left: -270px;\n  }\n  .contactapp-wrap.contactapp-sidebar-toggle .contactapp-sidebar {\n    left: 0;\n  }\n  .contactapp-wrap.contactapp-sidebar-toggle .contactapp-content {\n    left: 270px;\n    padding-left: 270px;\n    margin-left: -270px;\n  }\n  .contactapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .contactapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .contactapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .contactapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n/*File Manager*/\n.fmapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n}\n.fmapp-wrap .fmapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.fmapp-wrap .fmapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.fmapp-wrap .fmapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n  font-size: 1.5rem;\n}\n.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.fmapp-wrap .fmapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.fmapp-wrap .fmapp-sidebar .fmapp-storage {\n  padding: 1.5rem;\n}\n.fmapp-wrap .fmapp-sidebar .fmapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.fmapp-wrap .fmapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 270px;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fmapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fmapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fmapp-title:after {\n  top: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fm-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fm-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap header.fm-header .fm-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .nav-line {\n  margin: 0 -1.25rem;\n  border-bottom: 1px solid #eaeaea;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: .625rem;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star .svg-icon > svg {\n  height: 16px;\n  width: 16px;\n  cursor: pointer;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .file-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .media .media-body .file-name {\n  color: #262a2e;\n  font-weight: 500;\n  max-width: 190px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .fmapp-info-trigger.media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: pointer;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .fmapp-info-trigger.media .media-body .file-name {\n  -webkit-transition: color 0.2s ease;\n  -moz-transition: color 0.2s ease;\n  transition: color 0.2s ease;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-list-view .fmapp-info-trigger.media:hover .media-body .file-name {\n  color: #0a2f4c;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .25rem;\n  margin-top: .4rem;\n  margin-left: .625rem;\n  opacity: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star .svg-icon > svg {\n  cursor: pointer;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked > .feather-icon > svg, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked > .feather-icon > svg:hover, .fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .file-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card {\n  cursor: pointer;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-body {\n  min-height: 150px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-body i {\n  font-size: 2.375rem;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-footer {\n  display: block;\n  -webkit-transition: background 0.2s ease;\n  -moz-transition: background 0.2s ease;\n  transition: background 0.2s ease;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-footer > .d-flex > div {\n  min-width: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .card-footer > .d-flex > div .file-name {\n  color: #262a2e;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card .file-star.marked {\n  opacity: 1;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card:hover .file-star {\n  opacity: 1;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card:hover .card-footer {\n  background: #ebf5f5;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-card:hover .card-footer .file-name {\n  color: #0a2f4c;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card {\n  -webkit-transition: background 0.2s ease;\n  -moz-transition: background 0.2s ease;\n  transition: background 0.2s ease;\n  cursor: pointer;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media {\n  overflow: hidden;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media .avatar {\n  flex-shrink: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media .media-body {\n  min-width: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .card-body .media .media-body .file-name {\n  color: #262a2e;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card .file-star.marked {\n  opacity: 1;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover {\n  background: #ebf5f5;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover .file-star {\n  opacity: 1;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover .card-body .media .avatar {\n  flex-shrink: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .fm-body .nicescroll-bar .file-card-view .card.file-compact-card:hover .card-body .media .media-body .file-name {\n  color: #0a2f4c;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info {\n  position: absolute;\n  top: 65px;\n  right: -370px;\n  width: 370px;\n  margin-left: 0;\n  bottom: 0;\n  z-index: 100;\n  border: none;\n  background: #fff;\n  border-left: 1px solid #eaeaea;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .nicescroll-bar {\n  padding: 1.25rem;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .file-name {\n  color: #262a2e;\n  font-size: 1.25rem;\n  font-weight: 500;\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info {\n  padding-left: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li {\n  margin-bottom: .625rem;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li a {\n  color: #262a2e;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li > span {\n  display: inline-block;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li > span:first-child {\n  min-width: 100px;\n  margin-right: 1rem;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-info li > span:last-child {\n  color: #262a2e;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action {\n  padding-left: 0;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action li {\n  margin-bottom: .625rem;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action li a {\n  color: #262a2e;\n}\n.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info .fm-action li:last-child {\n  margin-bottom: .25rem;\n}\n.fmapp-wrap.fmapp-info-active .fmapp-detail-wrap .file-info {\n  right: 0;\n}\n.fmapp-wrap.fmapp-sidebar-toggle .fmapp-sidebar {\n  left: -270px;\n}\n.fmapp-wrap.fmapp-sidebar-toggle .fmapp-content {\n  padding-left: 0;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .fmapp-wrap {\n  height: 100vh;\n}\n\n@media (max-width: 1199px) {\n  .fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info {\n    top: 0;\n  }\n}\n@media (max-width: 767px) {\n  .fmapp-wrap .fmapp-sidebar {\n    left: -270px;\n  }\n  .fmapp-wrap .fmapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .fmapp-wrap.fmapp-sidebar-toggle .fmapp-sidebar {\n    left: 0;\n  }\n  .fmapp-wrap.fmapp-sidebar-toggle .fmapp-content {\n    left: 270px;\n    padding-left: 270px;\n    margin-left: -270px;\n  }\n  .fmapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .fmapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .fmapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .fmapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n/*Gallery App*/\n.galleryapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n}\n.galleryapp-wrap .galleryapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.galleryapp-wrap .galleryapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n  font-size: 1.5rem;\n}\n.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.galleryapp-wrap .galleryapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.galleryapp-wrap .galleryapp-sidebar .galleryapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.galleryapp-wrap .galleryapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 270px;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .galleryapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .galleryapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .galleryapp-title:after {\n  top: 0;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .gallery-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .gallery-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap header.gallery-header .gallery-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a {\n  position: relative;\n  display: block;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .form-check {\n  position: absolute;\n  left: 14px;\n  top: 17px;\n  cursor: pointer;\n  opacity: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  right: 14px;\n  top: 20px;\n  opacity: 0;\n  color: #6f6f6f;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star > .feather-icon > svg, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star .svg-icon > svg {\n  cursor: pointer;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star > .feather-icon > svg:hover, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked {\n  opacity: 1;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked > .feather-icon > svg, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked > .feather-icon > svg:hover, .galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a:hover .form-check {\n  opacity: 1;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a:hover .gallery-star {\n  opacity: 1;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-img {\n  min-height: 230px;\n  background-size: cover;\n  background-position: center;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body .nicescroll-bar .hk-gallery a .gallery-img.gallery-video:after {\n  content: \"\\efb6\";\n  font-family: remixicon;\n  font-style: normal;\n  position: absolute;\n  right: 14px;\n  bottom: 14px;\n  font-size: 1.5rem;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.45);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body.select-multiple .nicescroll-bar {\n  padding: 1.25rem;\n}\n.galleryapp-wrap .galleryapp-content .galleryapp-detail-wrap .gallery-body.select-multiple .nicescroll-bar .hk-gallery a .form-check {\n  opacity: 1;\n}\n.galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-sidebar {\n  left: -270px;\n}\n.galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-content {\n  padding-left: 0;\n}\n\n.lg-outer.galleryapp-info-active .lg-img-wrap {\n  padding-right: 26.25rem !important;\n  background: url(\"../img/loading.gif\") no-repeat scroll transparent;\n  background-position: center center;\n  background-position: calc((100% - 300px) / 2) center;\n}\n.lg-outer.galleryapp-info-active .lg-video-cont {\n  padding-right: 20rem !important;\n  background: url(\"../img/loading.gif\") no-repeat scroll transparent;\n  background-position: center center;\n  background-position: calc((100% - 300px) / 2) center;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html {\n  height: 100%;\n  overflow-y: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 420px;\n  z-index: 99999;\n  left: auto;\n  color: inherit;\n  padding: 0;\n  text-align: left;\n  background: #fff url(\"../img/loading.gif\") no-repeat scroll center center;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  padding: 1.25rem;\n  margin: 0 -1.25rem;\n  height: 65px;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .file-name {\n  font-weight: 500;\n  color: #262a2e;\n  max-width: 190px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .file-type {\n  font-size: 0.75rem;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .gallery-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .gallery-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html header.gallery-header .gallery-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li {\n  margin-bottom: .625rem;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li > span {\n  display: inline-block;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li > span:first-child {\n  min-width: 100px;\n  margin-right: 1rem;\n}\n.lg-outer.galleryapp-info-active .lg-sub-html .gallery-detail-body .file-info li > span:last-child {\n  color: #262a2e;\n}\n.lg-outer.galleryapp-info-active .galleryapp-info-active.fb_iframe_widget {\n  background-image: none;\n}\n.lg-outer.galleryapp-info-active .galleryapp-info-active.fb_iframe_widget.fb_iframe_widget_loader {\n  background: #fff url(\"../img/loading.gif\") no-repeat scroll center center;\n}\n.lg-outer.galleryapp-info-active .lg-toolbar {\n  right: 420px;\n  width: auto;\n}\n.lg-outer.galleryapp-info-active .lg-actions .lg-next {\n  right: 440px;\n}\n.lg-outer.galleryapp-info-active .lg-item {\n  background-image: none;\n}\n.lg-outer.galleryapp-info-active .lg-item.lg-complete .lg-img-wrap {\n  background-image: none;\n}\n.lg-outer.galleryapp-info-active .lg-item.lg-complete .lg-video-cont {\n  background-image: none;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .galleryapp-wrap {\n  height: 100vh;\n}\n\n@media (max-width: 767px) {\n  .galleryapp-wrap .galleryapp-sidebar {\n    left: -270px;\n  }\n  .galleryapp-wrap .galleryapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-sidebar {\n    left: 0;\n  }\n  .galleryapp-wrap.galleryapp-sidebar-toggle .galleryapp-content {\n    left: 270px;\n    padding-left: 270px;\n    margin-left: -270px;\n  }\n  .galleryapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .galleryapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .galleryapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .galleryapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n\n  .lg-outer.galleryapp-info-active .lg-img-wrap {\n    padding-right: 0 !important;\n  }\n  .lg-outer.galleryapp-info-active .lg-video-cont {\n    padding-right: 0 !important;\n  }\n  .lg-outer.galleryapp-info-active .lg-sub-html {\n    display: none;\n  }\n  .lg-outer.galleryapp-info-active .lg-toolbar {\n    right: 0;\n  }\n  .lg-outer.galleryapp-info-active .lg-actions .lg-next {\n    right: 20px;\n  }\n}\n/*Todo*/\n.todoapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n}\n.todoapp-wrap .todoapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.todoapp-wrap .todoapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link,\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap,\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1.5rem;\n  margin-right: .875rem;\n}\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text,\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > div .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.todoapp-wrap .todoapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.todoapp-wrap .todoapp-sidebar .todoapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.todoapp-wrap .todoapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 270px;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n  width: calc(100vw - 270px);\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  white-space: nowrap;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-left: .625rem;\n  font-size: 1.25rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star .svg-icon > svg {\n  cursor: pointer;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title h1 .task-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todoapp-title:after {\n  top: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media .media-body .user-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #262a2e;\n  text-transform: capitalize;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .media .media-body .user-status {\n  font-size: 0.875rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > .d-flex.ms-auto > a,\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > .d-flex.ms-auto > a:first-child,\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap header.todo-header .todo-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body {\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar > div .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {\n  display: none;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .todo-toolbar > div .pagination.custom-pagination .page-link {\n  padding: 0;\n  background: transparent;\n  min-width: auto;\n  font-size: 1.25rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .gutter.gutter-horizontal {\n  cursor: ew-resize;\n  position: relative;\n  width: 7px;\n  cursor: ew-resize;\n  text-align: center;\n  background: #fff;\n  border-left: 1px solid #eaeaea;\n  border-right: 1px solid #eaeaea;\n  z-index: 5;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .gutter.gutter-horizontal:after {\n  display: inline-block;\n  font-family: remixicon !important;\n  font-style: normal;\n  content: \"\\ef26\";\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  font-size: 1.25rem;\n  transform: translateY(-50%);\n  color: #0a2f4c;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap {\n  width: calc(100vw - 270px);\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-left: .625rem;\n  margin-right: .625rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star .svg-icon > svg {\n  cursor: pointer;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task .todo-text {\n  color: #262a2e;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table .gt-single-task > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable {\n  margin-top: 0 !important;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable th:first-child, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable td:first-child {\n  border-left-width: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable thead tr:first-child th, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .table-wrap table.gt-todo-table.table-bordered.dataTable thead tr:first-child td {\n  border-top-width: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container {\n  overflow: initial;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt {\n  fill: #0a2f4c;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .grid-row:nth-child(even) {\n  fill: #fff;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .row-line, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .tick {\n  stroke: #d8d8d8;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .bar {\n  fill: #8e8e8e;\n  stroke: #6f6f6f;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .bar-progress {\n  fill: #0a2f4c;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .todo-body .nicescroll-bar .split-wrap .split .gantt-wrap .gantt-container .gantt .grid-header {\n  stroke-width: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info {\n  position: absolute;\n  top: 65px;\n  right: -550px;\n  width: 550px;\n  margin-left: 0;\n  bottom: 0;\n  z-index: 100;\n  border: none;\n  background: #fff;\n  border-left: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  padding: 0 1.25rem;\n  border-radius: 0.5rem 0.5rem 0 0;\n  height: 65px;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .apexcharts-datalabels-group text {\n  font-family: inherit;\n  font-size: 0.75rem;\n  fill: #6f6f6f;\n  position: absolute;\n  transform: translateY(5px);\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .apexcharts-datalabels-group text:last-child {\n  display: none;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-left: .625rem;\n  font-size: 1.25rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star .svg-icon > svg {\n  cursor: pointer;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked > .feather-icon > svg:hover, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap .task-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap > a {\n  display: inline-block;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info header.task-header .task-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body {\n  padding: 1.25rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body form .media .media-head {\n  margin-right: 1rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body form .media .media-body .as-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media {\n  margin-bottom: 1.25rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media .media-head {\n  margin-right: 1rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:first-child {\n  font-weight: 500;\n  color: #262a2e;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .note-block .media .media-body div:last-child {\n  font-size: 0.875rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-head {\n  margin-right: 1rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .cm-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > div:first-child .badge {\n  margin-left: .625rem;\n  flex-shrink: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap span, .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap a {\n  color: #6f6f6f;\n  font-size: 0.75rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {\n  margin: 0 .25rem;\n  color: #d8d8d8;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .comment-block .media .media-body > .media {\n  margin-top: 1.875rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files {\n  padding-left: 0;\n  margin: 0 -.8rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li {\n  padding: .8rem;\n  border-radius: 0.5rem;\n  -webkit-transition: 0.2s ease;\n  -moz-transition: 0.2s ease;\n  transition: 0.2s ease;\n  margin-bottom: .25rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:last-child {\n  margin-bottom: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .avatar.avatar-sm {\n  margin-right: 1rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .avatar.avatar-sm .avatar-icon {\n  font-size: 1.75rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  min-width: 0;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:first-child {\n  min-width: 0;\n  -ms-flex: 1;\n  flex: 1;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body > div:last-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-name {\n  color: #262a2e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n  max-width: 200px;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li .media .media-body .file-size {\n  margin-top: .25rem;\n  font-size: 0.875rem;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover {\n  background-color: #f2f2f2;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body .file-name {\n  color: #0a2f4c;\n}\n.todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info .task-detail-body .tab-content .tab-pane .file-block .sh-files li:hover .media .media-body a.cp-file-action {\n  color: #262a2e;\n}\n.todoapp-wrap.todoapp-sidebar-toggle .todoapp-sidebar {\n  left: -270px;\n}\n.todoapp-wrap.todoapp-sidebar-toggle .todoapp-content {\n  padding-left: 0;\n}\n.todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .todo-body {\n  margin-right: 550px;\n}\n.todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .task-info {\n  right: 0;\n}\n.todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar {\n  padding: 0;\n}\n.todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar table.dataTable.cell-border thead th {\n  border-right: 1px solid #eaeaea;\n}\n.todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar table.dataTable.cell-border tbody tr th:first-child, .todoapp-wrap.ganttapp-wrap .todoapp-content .todoapp-detail-wrap .nicescroll-bar table.dataTable.cell-border tbody tr td:first-child {\n  border-left: 0;\n}\n\n.advance-list-item.single-task-list .form-check {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0;\n}\n.advance-list-item.single-task-list .form-check + div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-weight: 500;\n}\n.advance-list-item.single-task-list .form-check + div .todo-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: .625rem;\n}\n.advance-list-item.single-task-list .form-check + div .todo-star > .feather-icon > svg, .advance-list-item.single-task-list .form-check + div .todo-star .svg-icon > svg {\n  cursor: pointer;\n}\n.advance-list-item.single-task-list .form-check + div .todo-star > .feather-icon > svg:hover, .advance-list-item.single-task-list .form-check + div .todo-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.advance-list-item.single-task-list .form-check + div .todo-star.marked > .feather-icon > svg, .advance-list-item.single-task-list .form-check + div .todo-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.advance-list-item.single-task-list .form-check + div .todo-star.marked > .feather-icon > svg:hover, .advance-list-item.single-task-list .form-check + div .todo-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.advance-list-item.single-task-list .form-check + div .todo-text {\n  cursor: pointer;\n  max-width: 300px;\n}\n.advance-list-item.single-task-list .form-check + div .badge-indicator {\n  margin: 0 .75rem  0 .5rem;\n  flex-shrink: 0;\n}\n.advance-list-item.single-task-list.selected {\n  background: #ebf5f5;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .todoapp-wrap {\n  height: 100vh;\n}\n\n@media (max-width: 1740px) {\n  .todoapp-wrap .todoapp-sidebar {\n    left: -270px;\n  }\n  .todoapp-wrap .todoapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .todoapp-wrap.todoapp-sidebar-toggle .todoapp-sidebar {\n    left: 0;\n  }\n  .todoapp-wrap.todoapp-sidebar-toggle .todoapp-content {\n    left: 270px;\n    padding-left: 270px;\n    margin-left: -270px;\n  }\n  .todoapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .todoapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .todoapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .todoapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n@media (max-width: 1500px) {\n  .todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .todo-body {\n    margin-right: 0;\n  }\n  .todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .task-info {\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n  }\n}\n@media (max-width: 1199px) {\n  .todoapp-wrap .todoapp-content .todoapp-detail-wrap .task-info {\n    top: 0;\n    width: 100%;\n    right: -100%;\n  }\n  .todoapp-wrap.todoapp-info-active .todoapp-detail-wrap .task-info {\n    right: 0;\n  }\n}\n@media (max-width: 767px) {\n  .advance-list-item.single-task-list {\n    min-height: auto;\n  }\n  .advance-list-item.single-task-list .form-check + div .todo-text {\n    cursor: pointer;\n    max-width: calc(100vw - 250px);\n  }\n}\n/*Blog App*/\n.blogapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n}\n.blogapp-wrap .blogapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.blogapp-wrap .blogapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .nav-header {\n  padding: 0 0 .5rem 0;\n  font-size: 0.875rem;\n  color: #0a2f4c;\n  font-weight: 500;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link[data-toggle=\"collapse\"]::after {\n  content: '\\f2f9';\n  font: normal normal normal 18px/1 'Material-Design-Iconic-Font';\n  text-rendering: auto;\n  margin-left: auto;\n  -webkit-transform: translateX(0) rotate(0deg);\n  -moz-transform: translateX(0) rotate(0deg);\n  -ms-transform: translateX(0) rotate(0deg);\n  -o-transform: translateX(0) rotate(0deg);\n  transform: translateX(0) rotate(0deg);\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n  color: rgba(38, 42, 46, 0.3);\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link[data-toggle=\"collapse\"][aria-expanded=\"true\"]::after {\n  -webkit-transform: translateX(0) rotate(-180deg);\n  -moz-transform: translateX(0) rotate(-180deg);\n  -ms-transform: translateX(0) rotate(-180deg);\n  -o-transform: translateX(0) rotate(-180deg);\n  transform: translateX(0) rotate(-180deg);\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n  font-size: 1.5rem;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item .secondary-nav .nav-item .nav-link {\n  padding-left: 3.3rem;\n}\n.blogapp-wrap .blogapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.blogapp-wrap .blogapp-sidebar .tag-cloud .badge {\n  margin-bottom: .25rem;\n}\n.blogapp-wrap .blogapp-sidebar .blogapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.blogapp-wrap .blogapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 16.875rem;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blogapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blogapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blogapp-title:after {\n  top: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blog-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blog-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap header.blog-header .blog-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-left,\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right {\n  min-height: 45px;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-left > div {\n  margin-right: 1rem;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-left > div:last-child {\n  margin-right: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right {\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right > div {\n  margin-left: 1rem;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right > div:first-child {\n  margin-left: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_filter,\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length,\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info {\n  float: none;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_filter label,\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length label,\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info label {\n  margin-bottom: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info {\n  padding-top: 0;\n  width: 95px;\n  text-align: right;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_paginate {\n  padding-top: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {\n  display: none;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link {\n  padding: 0;\n  background: transparent;\n  min-width: auto;\n  font-size: 1.25rem;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length select {\n  margin-right: 0;\n  margin-left: .625rem;\n  display: inline-block;\n  width: auto;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .tox-tinymce {\n  border: 0;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .tox-tinymce .tox-statusbar__text-container {\n  display: none !important;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .nav-tabs > .nav-item > .nav-link {\n  position: relative;\n  z-index: 1;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .nav-tabs > .nav-item > .nav-link.active {\n  border-color: #eaeaea #eaeaea #fff;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .advance-option-post .nav-tabs {\n  margin-left: -1.25rem;\n  margin-right: -1.25rem;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .edit-post-form .advance-option-post .uploaded-img-prev a .card {\n  min-height: 100px;\n  background-size: cover;\n  background-position: center;\n  margin-bottom: 0;\n  margin-top: 1rem;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .nav-line {\n  margin: 0 -1.25rem;\n  border-bottom: 1px solid #eaeaea;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: .625rem;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star > .feather-icon > svg, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star .svg-icon > svg {\n  height: 16px;\n  width: 16px;\n  cursor: pointer;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star > .feather-icon > svg:hover, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked > .feather-icon > svg, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked > .feather-icon > svg:hover, .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .post-list .post-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.blogapp-wrap.blogapp-sidebar-toggle .blogapp-sidebar {\n  left: -270px;\n}\n.blogapp-wrap.blogapp-sidebar-toggle .blogapp-content {\n  padding-left: 0;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .blogapp-wrap {\n  height: 100vh;\n}\n\n@media (max-width: 1740px) {\n  .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_info,\n  .blogapp-wrap .blogapp-content .blogapp-detail-wrap .blog-body .nicescroll-bar .blog-toolbar-right .dataTables_length {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .blogapp-wrap .blogapp-sidebar {\n    left: -270px;\n  }\n  .blogapp-wrap .blogapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .blogapp-wrap.blogapp-sidebar-toggle .blogapp-sidebar {\n    left: 0;\n  }\n  .blogapp-wrap.blogapp-sidebar-toggle .blogapp-content {\n    left: 16.875rem;\n    padding-left: 16.875rem;\n    margin-left: -16.875rem;\n  }\n  .blogapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .blogapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .blogapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .blogapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n/*invoice*/\n.invoiceapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n}\n.invoiceapp-wrap .invoiceapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.invoiceapp-wrap .invoiceapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .nav-header {\n  padding: 0 0 .5rem 0;\n  font-size: 0.875rem;\n  color: #0a2f4c;\n  font-weight: 500;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n  font-size: 1.5rem;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.invoiceapp-wrap .invoiceapp-sidebar .invoiceapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.invoiceapp-wrap .invoiceapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 16.875rem;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoiceapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoiceapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoiceapp-title:after {\n  top: 0;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .media .media-head {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .media .media-body .user-name {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #262a2e;\n  text-transform: capitalize;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .media .media-body .user-status {\n  font-size: 0.875rem;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoice-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoice-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.invoiceapp-wrap .invoiceapp-content header.invoice-header .invoice-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-left,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right {\n  min-height: 45px;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-left > div {\n  margin-right: 1rem;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-left > div:last-child {\n  margin-right: 0;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right {\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right > div {\n  margin-left: 1rem;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right > div:first-child {\n  margin-left: 0;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_filter,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info {\n  float: none;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_filter label,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length label,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info label {\n  margin-bottom: 0;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info {\n  padding-top: 0;\n  width: 95px;\n  text-align: right;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_paginate {\n  padding-top: 0;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_paginate .pagination.custom-pagination .paginate_button:not(:first-child):not(:last-child) {\n  display: none;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_paginate .pagination.custom-pagination .page-link {\n  padding: 0;\n  background: transparent;\n  min-width: auto;\n  font-size: 1.25rem;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length select {\n  margin-right: 0;\n  margin-left: .625rem;\n  display: inline-block;\n  width: auto;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: .625rem;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star > .feather-icon > svg, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star .svg-icon > svg {\n  cursor: pointer;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star > .feather-icon > svg:hover, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star .svg-icon > svg:hover {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked > .feather-icon > svg, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked .svg-icon > svg {\n  fill: #FFC400;\n  stroke: #FFC400;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked > .feather-icon > svg:hover, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-list-view .invoice-star.marked .svg-icon > svg:hover {\n  fill: none;\n  stroke: currentColor;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap {\n  border: 1px solid #eaeaea;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table thead tr th,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table thead tr th {\n  border-color: transparent;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table thead tr th:first-child,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table thead tr th:first-child {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table thead tr th:last-child,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table thead tr th:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table {\n  min-width: 450px;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table {\n  border-collapse: separate;\n  border-spacing: 0px;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table td, .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .invoice-table th,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table td,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .subtotal-table th,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table td,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table th,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table td,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .subtotal-table th {\n  border: 1px solid #eaeaea;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .template-invoice-wrap .form-group,\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .form-group {\n  position: relative;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {\n  position: absolute;\n  top: 65px;\n  right: -370px;\n  width: 370px;\n  margin-left: 0;\n  bottom: 0;\n  z-index: 100;\n  border: none;\n  background: #fff;\n  border-left: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings .nicescroll-bar {\n  padding: 1.25rem;\n}\n.invoiceapp-wrap.invoiceapp-setting-active .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {\n  margin-right: 370px;\n}\n.invoiceapp-wrap.invoiceapp-setting-active .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {\n  right: 0;\n}\n.invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-sidebar {\n  left: -270px;\n}\n.invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-content {\n  padding-left: 0;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .invoiceapp-wrap {\n  height: 100vh;\n}\n\n@media (max-width: 1740px) {\n  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_info,\n  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .invoice-toolbar-right .dataTables_length {\n    display: none;\n  }\n}\n@media (max-width: 1600px) {\n  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n  }\n  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {\n    margin-right: 0;\n  }\n  .invoiceapp-wrap.invoiceapp-setting-active .invoiceapp-content .invoiceapp-detail-wrap .invoice-body {\n    margin-right: 0;\n  }\n}\n@media (max-width: 1199px) {\n  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-settings {\n    top: 0;\n  }\n  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table-wrap {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .invoiceapp-wrap .invoiceapp-content .invoiceapp-detail-wrap .invoice-body .nicescroll-bar .create-invoice-wrap .invoice-table-wrap .invoice-table {\n    min-width: 900px;\n  }\n  .invoiceapp-wrap .invoiceapp-sidebar {\n    left: -270px;\n  }\n  .invoiceapp-wrap .invoiceapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-sidebar {\n    left: 0;\n  }\n  .invoiceapp-wrap.invoiceapp-sidebar-toggle .invoiceapp-content {\n    left: 16.875rem;\n    padding-left: 16.875rem;\n    margin-left: -16.875rem;\n  }\n  .invoiceapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .invoiceapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .invoiceapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .invoiceapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n/*Integrations*/\n.integrationsapp-wrap {\n  position: relative;\n  height: calc(100vh - 65px);\n}\n.integrationsapp-wrap .integrationsapp-sidebar {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-flow: column;\n  left: 0;\n  width: 270px;\n  margin-left: 0;\n  top: 0;\n  height: 100%;\n  z-index: 1;\n  border: none;\n  background: #fff;\n  border-right: 1px solid #eaeaea;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.integrationsapp-wrap .integrationsapp-sidebar > div.nicescroll-bar {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap {\n  padding: 1.5rem;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-gap {\n  height: 25px;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .nav-header {\n  padding: 0 0 .5rem 0;\n  font-size: 0.875rem;\n  color: #0a2f4c;\n  font-weight: 500;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link {\n  border-radius: .5rem;\n  padding: .5rem 1rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: .875rem;\n  font-size: 1.5rem;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item > .nav-link .nav-icon-wrap .nav-link-text {\n  display: inline-block;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .menu-content-wrap .menu-group > .navbar-nav > .nav-item.active > .nav-link {\n  background: rgba(0, 125, 136, 0.15);\n  color: #0a2f4c;\n}\n.integrationsapp-wrap .integrationsapp-sidebar .integrationsapp-fixednav {\n  height: 61px;\n  border-top: 1px solid #eaeaea;\n}\n.integrationsapp-wrap .integrationsapp-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  padding-left: 16.875rem;\n  position: relative;\n  height: 100%;\n  left: 0;\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-grow: 1;\n  background: #fff;\n  flex-flow: column;\n  height: 100%;\n  z-index: 10;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  height: 65px;\n  padding: 0 1.25rem;\n  background: #fff;\n  border-bottom: 1px solid #eaeaea;\n  position: relative;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrationsapp-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrationsapp-title h1 {\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrationsapp-title:after {\n  top: 0;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrations-options-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrations-options-wrap > a {\n  margin-left: .25rem;\n  display: inline-block;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap header.integrations-header .integrations-options-wrap > a:first-child {\n  margin-left: 0;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body {\n  -webkit-transition: all 0.2s ease;\n  -moz-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  -ms-flex: 1;\n  flex: 1;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar {\n  padding: 1.25rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .app-name {\n  color: #262a2e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .app-cat {\n  font-size: 0.875rem;\n  margin-bottom: .625rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-head {\n  margin-right: 1rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > div:first-child {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: .25rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > div:first-child .cm-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > div:first-child .badge {\n  margin-left: .625rem;\n  flex-shrink: 0;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body .comment-action-wrap span, .integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body .comment-action-wrap a {\n  color: #6f6f6f;\n  font-size: 0.75rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body .comment-action-wrap .comment-dot-sep {\n  margin: 0 .25rem;\n  color: #d8d8d8;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .comment-block .media .media-body > .media {\n  margin-top: 1.875rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .media .media-head {\n  margin-right: 1rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .media .media-body .cr-name {\n  font-weight: 500;\n  color: #262a2e;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review-action-wrap span, .integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review-action-wrap a {\n  font-size: 0.75rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review-action-wrap .review-dot-sep {\n  margin: 0 .25rem;\n  color: #d8d8d8;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .tab-content .review-block .review .review {\n  margin-left: 3.125rem;\n  margin-top: 1.875rem;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .card-int {\n  min-height: 250px;\n}\n.integrationsapp-wrap .integrationsapp-content .integrationsapp-detail-wrap .integrations-body .nicescroll-bar .content-aside .tag-cloud .badge {\n  margin-bottom: .25rem;\n}\n.integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-sidebar {\n  left: -270px;\n}\n.integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-content {\n  padding-left: 0;\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] .integrationsapp-wrap {\n  height: 100vh;\n}\n\n/*------------------------ custom --------------------------------*/\n\n\n.swal2-styled.swal2-confirm {\n  background-color: #08364d;\n}\n.hk-pg-wrapper-custom{\n  height: 100vh;\n  padding-bottom:60px;\n}\n.text-white-color{\n  color:#fff!important;\n}\n.text-white-color h2{\n  color:#fff!important;\n}\n\n/*-------------------Multiselect Dropdown---------------------*/\n.chips{\n  background-color: green !important;\n}\n/*----------------------------------------*/\n/*-------------------Multiselect Dropdown---------------------*/\n@media (max-width: 660px) {\n  .setDiscount_section{\nflex-wrap: wrap;\njustify-content: center;\nalign-items: center;\n  }\n.showDiscounts_section{\n  justify-content:center;\n   align-items:center;\n}\n.discount-header_section{\n  margin-bottom: 30px;\n}\n}\n@media (max-width: 480px) {\n  .colomns_wrapper{\nflex-wrap: wrap;\njustify-content: center;\nalign-items: center;\n  }\n  .discount-header_section{\n    margin-bottom: 50px;\n  }\n}\n.new_box-content{\n  width: 100%;\n  padding: 20px;\n  p{\n    font-size: 18px;\n    background: linear-gradient(to left, #000 , #11749e);\n    -webkit-background-clip: text;\n    background-clip:text;\n    -webkit-text-fill-color: transparent;\n    font-weight: bold;\n  }\n  h3{\n    font-size: 17px;\n    background: linear-gradient(to left, #000 , #11749e);\n    -webkit-background-clip: text;\n    background-clip:text;\n    -webkit-text-fill-color: transparent;\n    font-weight: bold;\n  }\n  }\n@media (max-width: 360px) {\n  .new_box-content{\nfont-size: 15px;\n}\n}\n.colomns_wrapper{\n  display:flex;\n  gap:30px\n}\n.discount-section_box,.new_discount-box{\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 1rem;\n  max-width: 300px;\n  box-shadow: 0 0 1rem #08364d;\n  overflow: hidden;\n  display: flex;\n  padding: 0;\n  margin-bottom: 20px;\n  cursor: pointer;\n}\n.section_box-content, .new_box-content{\n  position: absolute;\n  color: #000;\n}\n/*----------------------------------------*/\n\n@media (max-width: 991px) {\n  .integrationsapp-wrap .integrationsapp-sidebar {\n    left: -270px;\n  }\n  .integrationsapp-wrap .integrationsapp-content {\n    margin-left: 0;\n    padding-left: 0;\n  }\n  .integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-sidebar {\n    left: 0;\n  }\n  .integrationsapp-wrap.integrationsapp-sidebar-toggle .integrationsapp-content {\n    left: 16.875rem;\n    padding-left: 16.875rem;\n    margin-left: -16.875rem;\n  }\n  .integrationsapp-wrap .hk-sidebar-togglable {\n    -webkit-transform: translateX(32px);\n    -moz-transform: translateX(32px);\n    -ms-transform: translateX(32px);\n    -o-transform: translateX(32px);\n    transform: translateX(32px);\n  }\n  .integrationsapp-wrap .hk-sidebar-togglable:after {\n    content: \"\\ea6c\";\n  }\n  .integrationsapp-wrap .hk-sidebar-togglable.active {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .integrationsapp-wrap .hk-sidebar-togglable.active:after {\n    content: \"\\ea62\";\n  }\n}\n/*Horizontal Menu*/\n@media (min-width: 1200px) {\n  .hk-wrapper[data-layout=\"horizontal\"] .chatapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .calendarapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .emailapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .taskboardapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .contactapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .fmapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .galleryapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .todoapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .blogapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .invoiceapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"] .integrationsapp-wrap {\n    height: calc(100vh - 130px);\n  }\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .chatapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .calendarapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .emailapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .taskboardapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .contactapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .fmapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .galleryapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .todoapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .blogapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .invoiceapp-wrap,\n  .hk-wrapper[data-layout=\"horizontal\"][data-navbar-style=\"collapsed\"] .integrationsapp-wrap {\n    height: calc(100vh - 65px);\n  }\n}\n\n\n/* Change react multiselect dropdown size */\n.optionContainer {\n  height: 10rem;\n  overflow: hidden;\n}\n/*______________________________________________*/\n/*--------------------Table Column Header------------------------------*/\n.columnHeader{\n  display:flex;\n  justify-content:center;\n  align-items:center\n}\ntd{\n  overflow: hidden;\n}\n/*---------------------------------------------------------------------*/\n/*-------------------------Payment Progress Bar--------------------------------*/\n.progress-bar-container{\n  width: 180px;\n}\n.progress-bar{\n  width: 100%;\n  height: 1.5rem;\n  border-radius: 10px;\n  background-color: #e6e6e6;\n  position: relative; \n  p{\n    z-index: 100;\n    color: #000;\n    font-weight: 500;\n  }\n}\n.progress-bar-fill{\n  height: 100%;\n  border-radius: 10px;\n  background-color: #2ecc71;\n  transition: width 0.5s ease-out;\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: flex;\n  justify-content: center; \n  align-items: center;\n \n}\n/*---------------------------------------------------------------------*/\n@media print {\n  body{\n    counter-reset: page;\n  }\n  #pageNumber::before{\n    counter-increment: page;\n    content: 'Էջ:' counter(page);\n    display: flex;\n    flex-direction: row-reverse;\n  }\n}\n.form-control.custom-datepicker{\n  min-width: 250px;\n  }","@charset \"UTF-8\"; \n/*------------------------------------------------------------------\n[Master Stylesheet]\nProject:\tJampack\n++++ Imports ++++\n++++ Reset ++++\n++++ Basic ++++\n\n\t++CSS Basic++\n\t++Media Object++\n\t++Gap++\n\t++Position++\n\t++Padding++\n\t++Margin++\n\t++Background Colors++\n\t++Text Colors++\n\t++Border++\n\t++Colors++\n\t++Shadow++\n\t++Font Size++\t\n\t++Font Weight++\n\t++Text Case++\n\t++Letter Spacing++\n\t++Line Height++\n\t++Width++\n\t++Width In Percentage++\n\t++Max Width++\n\t++Min Width++\n\t++Height++\n\t++Height In Percentage++\n\t++Max Height++\n\t++Min Height++\n\t++Hr++\n\t++opacity++\n\t++Div Sizes++\n\t++Z-Index++\n\t++Loader++\n\t++Scrollbar++\n\t++Separator++\n\t++Typography++\n\t++Buttons++\n\t++Wrapper++\n\t++Gutter++\n\t++Hk Section++\n\t++Card++\n\t++Placehoder++\n\t++Placehoder++\n\t++Breadcrumb++\n\t++Page Header++\n\t++Page Body++\n\t++Form++\n\t++Checkbox++\n\t++Form Switch++\n\t++Form Range++\n\t++Form validation++\n    ++Inut group++\n    ++Inut search++\n    ++Spinner++\n    ++Input Spinner++\n\t++Select2++\n\t++Tinymce++\n\t++File Upload++\n\t++Form-Wizard++\n\t++Popover++\n\t++Collapse++\n\t++Accordion++\n\t++Table++\n\t++Data Table++\n\t++Advance Table++\n\t++Apex Chart++\n\t++charts++\n\t++Nestable++\n\t++Treeview++\t\n\t++Modals++\n\t++Close++\n\t++Sweet-alert++\n\t++Notification++\n\t++Toast++\n\t++Bootstrap Notify++\n\t++Tooltop++\n\t++Images++  \n\t++Icons++\n    ++Carousel++\n\t++Twitter slider++\n\t++Color Pickr++\n\t++Range Slider++\n\t++Daterangepicker++\n\t++Profile++\n\t++Activity++\n\t++Wizards++\n\t++Pricing Table++\n\t++Dropdown++\n\t++Avatar++\n\t++Pagination++\n\t++Badge++\n\t++List Group++\n\t++Google Map++\n\t++Vecotor Map++\n\t++Progressbar++\n\t++Togglable++\n\t++Advance List++\n\t++Light Gallery++\n\t++Cropperjs++\n\t++Bootstrap TimeOut++\n\t++Hopscotch++\n\t++Rating++\n\t++Tinyemce++\n\t++Chips++\n\t++Playlist widget++\n\t++Ribbons++\n\t++Advance Badges++\n\t++Callout++\n\t++Toolbar++\n\t++Filter Component++\n\t++Content sidebar++\n\t++Fixed Footer++\n\t++Dragula++\n\t++Fixed Footer++\n\t++Authantication Pages++\n\t++Fixed Footer++\n\n++++ Componets Import ++++\t\n-------------------------------------------------------------------*/\n\n/****************************/\n/** Imports **/\n/****************************/\n@import url(https://fonts.googleapis.com/icon?family=DM+Sans:400,500,700&display=swap||Material+Icons);\n@import \"../../vendors/bootstrap/dist/css/bootstrap.min.css\";\n@import \"font-awesome.min.css\";\t\n@import \"dripicons.css\";\t\n@import \"cryptofont.min.css\";\t\n@import \"themify-icons.css\";\t\n@import \"animate.css\";\t\n@import \"flag-icon.min.css\";\t\n@import \"twemoji.min.css\";\t\n@import \"material-design-iconic-font.min.css\";\t\n@import \"remixicon.css\";\n@import \"material-icons.css\";\n@import \"line-awesome.min.css\";\n@import \"bootstrap-icons.css\";\n@import \"flaticon.css\";\n@import \"prism.css\";\n@import \"../../vendors/simplebar/dist/simplebar.min.css\";\t\n@import \"../../vendors/owl.carousel/dist/assets/owl.carousel.min.css\";\t\n@import \"../../vendors/owl.carousel/dist/assets/owl.theme.default.min.css\";\t\n@import \"../../vendors/bourbon/app/assets/stylesheets/_bourbon.scss\";\t\n@import \"mixins.scss\";\t\n@import \"variables.scss\";\t\n/****************************/\n/** Reset **/\n/****************************/\nhtml, body, div, span, applet, object, iframe, p, pre, a, abbr, acronym,address, big, cite, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, fieldset, form, label, legend, caption, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n}\nem,cite {\n\tfont-style: italic;\n}\t\n\nstrong{\n\tfont-weight:bold;\n}\n \nbody {\n\tcolor: $grey_dark_3;\n\tfont-family: var(--bs-body-font-family);\n\tfont-size: var(--bs-body-font-size);\n\t-webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: transparent;\n\toverflow-x:hidden;\n}\n\n.main-font {\n\tfont-family: var(--bs-body-font-family);\n}\na:hover,a:active {\n    outline: 0;\n}\n\nul {\n    list-style: none;\n\t&.list-ul {\n\t\tlist-style: disc;\n\t\tul{\n\t\t\tlist-style-type: circle;\n\t\t}\n\t}\n\t&.list-icon {\n\t\tlist-style: none;\n\t\tpadding-left: 0;\n\t\t> li {\n\t\t\tpadding-left: 1.875rem;\n\t\t\tcounter-increment: li;\n\t\t\ti,\n\t\t\t.feather-icon,\n\t\t\t.svg-icon {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\theight: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t\ttext-align: center;\n\t\t\t\tmargin-left: -1.25rem;\n\t\t\t\tposition: relative;\n\t\t\t\tleft: -10px;\n\t\t\t\tpadding: 1px;\n\t\t\t\ttop: -1px;\n\t\t\t\t\n\t\t\t}\n\t\t\ti {\n\t\t\t\tfont-size:21px;\n\t\t\t\ttop:5px;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-list {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-ms-flex-wrap: wrap;\n\t\tflex-wrap: wrap;\n\t\tmargin: 0 -.68rem;\n\t\tpadding-left: 0;\n\t\tli {\n\t\t\tpadding: .68rem;\n\t\t}\n\t\t&.hk-list-sm {\n\t\t\t margin: 0 -.4rem;\n\t\t\tli {\n\t\t\t\tpadding: .4rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\na {\n   text-decoration: none;\n   color:$primary;\n   @include transition(color .2s ease);\n\t&:hover {\n\t\ttext-decoration: none;\n\t\t color:$primary_light_1;\n\t}\n\t&:focus {\n\t\ttext-decoration: none;\n\t\toutline: none;\n\t\tcolor:$primary_light_1;\n\t}\n\t&.link-info {\n\t\tcolor: $info !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $info_light_1 !important;\n\t\t}\n\t}\n\t&.link-success {\n\t\tcolor: $success !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $success_light_1 !important;\n\t\t}\n\t}\n\t&.link-warning {\n\t\tcolor: $warning !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $warning_light_1 !important;\n\t\t}\n\t}\n\t&.link-danger {\n\t\tcolor: $danger !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $danger_light_1 !important;\n\t\t}\n\t}\n\t&.link-primary {\n\t\tcolor: $primary !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $primary_light_1 !important;\n\t\t}\n\t}\n\t&.link-muted {\n\t\tcolor: $grey_dark_3 !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $grey_light_1 !important;\n\t\t}\n\t}\n\t&.link-secondary {\n\t\tcolor:$secondary !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $secondary_light_1 !important;\n\t\t}\n\t}\n\t&.link-dark {\n\t\tcolor:$black_2 !important;\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: $black_1 !important;\n\t\t}\n\t}\n\t&.link-light {\n\t\tcolor:$grey !important;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $grey_light_1 !important;\n\t\t}\n\t}\n\t&.link-white {\n\t\tcolor:$white !important;\n\t\t&:hover,&:focus {\n\t\t\t@include color-opacity($white,.8);\n\t\t}\n\t}\n\t&.link-disabled {\n\t\tcolor:$grey_light_1 !important;\n\t\tpointer-events: none;\n\t\tuser-select: none;\n\t\t&:hover,&:focus {\n\t\t\tcolor: $grey_light_1 !important;\n\t\t}\n\t}\n\t&.link-high-em {\n\t\tfont-weight: 500;\n\t}\n\t&.link-medium-em {\n\t\tfont-size: .875rem;\n\t}\n\t&.link-low-em {\n\t\tfont-size: .75rem;\n\t}\n}\nh1,h2,h3,h4,h5,h6,.h1, .h2, .h3, .h4, .h5, .h6 {\n\tcolor:$black_2;\n}\n.heading-wth-icon {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay:flex;\n\talign-items: center;\n\t.head-icon {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\ti{\n\t\t\tline-height: 0;\n\t\t}\n\t}\n}\n.h1, h1 {\n\t&.heading-wth-icon {\n\t\t.head-icon {\n\t\t\tmargin-right:1.125rem;\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t.h1, h1 {\n\t\t&.heading-wth-icon {\n\t\t\t.head-icon {\n\t\t\t\tmargin-right:1.125rem;\n\t\t\t}\n\t\t}\n\t}\n}\n.h2, h2 {\n\t&.heading-wth-icon {\n\t\t.head-icon {\n\t\t\tmargin-right:1rem;\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t.h2, h2 {\n\t\t&.heading-wth-icon {\n\t\t\t.head-icon {\n\t\t\t\tmargin-right:1.125rem;\n\t\t\t}\n\t\t}\n\t}\n}\n.h3, h3 {\n\t&.heading-wth-icon {\n\t\t.head-icon {\n\t\t\tmargin-right:.875rem;\n\t\t}\n\t}\n}\t\n@media (max-width: 1199px) {\n\t.h3, h3 {\n\t\t&.heading-wth-icon {\n\t\t\t.head-icon {\n\t\t\t\tmargin-right:1.125rem;\n\t\t\t}\n\t\t}\n\t}\n}\n.h4, h4 {\n    &.heading-wth-icon {\n\t\t.head-icon {\n\t\t\tmargin-right:.75rem;\n\t\t}\n\t}\n}\n\n.h5, h5 {\n\t&.heading-wth-icon {\n\t\t.head-icon {\n\t\t\tmargin-right:.625rem;\n\t\t}\n\t}\n}\n\n.h6, h6 {\n\t&.heading-wth-icon {\n\t\t.head-icon {\n\t\t\tmargin-right:.5rem;\n\t\t}\n\t}\n}\n.force-UTF-8{\n    content: \"¡\";\n}\ndt {\n    font-weight: 600;\n}\n::-webkit-file-upload-button { cursor:pointer; }\n/****************************/\n/** Basic **/\n/****************************/\n\n/*CSS Basic*/\n.overflow-y-scroll {\n\toverflow-y:scroll;\n}\n.overflow-x-scroll {\n\toverflow-x:scroll;\n}\n.white-space-wrap{\n\twhite-space: initial;\n}\n.white-space-nowrap{\n\twhite-space: nowrap;\n}\n.word-break,\na.link-url {\n\tword-break:break-all;\n}\n.multine-ellipsis {\n\t-webkit-box-orient: vertical;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 4;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: normal;\n}\n.seprator-block {\n    margin-bottom: 5rem;\n}\n.no-transition {\n\t@include transition(0s);\n}\n.transform-none {\n\ttransform: none!important;\n}\n.name {\n\tcolor:$black_2!important;\n\tfont-weight:500;\n}\n.twa-2x {\n    background-size: 1.3em 1.3em;\n    height: 1.3em;\n    width: 1.3em;\n}\n.flex-basis-0 {\n\tflex-basis:0!important;\n}\n.flex-1 {\n\t-ms-flex: 1!important;\n\tflex: 1!important;\n}\ntd,th {\n\t&.text-truncate {\n\t\tmax-width:1px;\n\t}\n}\n[contenteditable=\"true\"] {\n    outline: none;\n}\n.icon-flip-y {\n\t@include transform(rotateY(180deg));\n}\n.icon-flip-x {\n\t@include transform(rotateX(180deg));\n}\n/*Media Object*/\n.media {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: start;\n    align-items: flex-start;\n}\n.media-head {\n    display: flex;\n}\n.media-body {\n    -ms-flex: 1;\n    flex: 1;\n}\n/*Gap*/\n$num: 5;\n$num1: 0;\n@while $num < 8 {\n    .gap-#{$num} {\n        gap: $num1 +2rem !important;\n    }\n    $num1: $num1 +0.5;\n    $num: $num +1;\n}\n/*Position*/\n.position-top-start,\n.position-top-end,\n.position-bottom-start,\n.position-bottom-end,\n.position-start-center,\n.position-end-center,\n.position-top-center,\n.position-bottom-center,\n.position-top-start-overflow,\n.position-top-end-overflow,\n.position-bottom-start-overflow,\n.position-bottom-end-overflow,\n.position-start-center-overflow,\n.position-end-center-overflow,\n.position-top-center-overflow,\n.position-bottom-center-overflow {\n\tposition:absolute!important;\n\tz-index:2;\n}\n.position-top-start {\n\ttop: 0!important;\n\tleft: 0!important;\n}\n.position-top-end {\n\ttop: 0!important;\n\tright: 0!important;\n}\n.position-bottom-start {\n\tbottom: 0!important;\n\tleft: 0!important;\n\ttop:auto!important;\n}\n.position-bottom-end {\n\tbottom: 0!important;\n\tright: 0!important;\n\ttop:auto!important;\n}\n.position-top-center {\n\ttop: 0!important;\n\tright: 50%!important;\n\t@include transform(translateX(50%)!important);\n}\t\n.position-bottom-center {\n\tbottom: 0!important;\n\tright: 50%!important;\n\t@include transform(translateX(50%)!important);\n}\n.position-start-center {\n\tleft: 0!important;\n\ttop: 50%!important;\n\t@include transform(translateY(-50%)!important);\n}\n.position-end-center {\n\tright: 0!important;\n\ttop: 50%!important;\n\t@include transform(translateY(-50%)!important);\n}\n.position-center {\n\tleft: 50%!important;\n\ttop: 50%!important;\n\t@include transform(translate(-50%, -50%)!important);\n}\n.position-top-start-overflow {\n\ttop: 0!important;\n\tleft: 0!important;\n\t@include transform(translate(-50%, -50%)!important);\n}\n.position-top-end-overflow {\n\ttop: 0!important;\n\tright: 0!important;\n\t@include transform(translate(50%, -50%)!important);\n}\n.position-bottom-start-overflow {\n\tbottom: 0!important;\n\tleft: 0!important;\n\ttop:auto!important;\n\t@include transform(translate(-50%, 50%)!important);\n}\n.position-bottom-end-overflow {\n\tbottom: 0!important;\n\tright: 0!important;\n\ttop:auto!important;\n\t@include transform(translate(50%, 50%)!important);\n}\n.position-top-center-overflow {\n\ttop: 0!important;\n\tright: 50%!important;\n\t@include transform(translate(50%, -50%)!important);\n}\t\n.position-bottom-center-overflow {\n\tbottom: 0!important;\n\tright: 50%!important;\n\t@include transform(translate(50%, 50%)!important);\n}\n.position-start-center-overflow {\n\tleft: 0!important;\n\ttop: 50%!important;\n\t@include transform(translate(-50%, -50%)!important);\n}\n.position-end-center-overflow {\n\tright: 0!important;\n\ttop: 50%!important;\n\t@include transform(translate(50%, -50%)!important);\n}\n.position-top-start-overflow-1,\n.position-top-end-overflow-1,\n.position-bottom-start-overflow-1,\n.position-bottom-end-overflow-1 {\n\tposition:absolute!important;\n\tz-index:2;\n}\n.position-top-start-overflow-1 {\n\ttop: 12%!important;\n\tleft:16%!important;\n\t@include transform(translate(-50%, -50%)!important);\n}\n.position-top-end-overflow-1 {\n\ttop: 12%!important;\n\tright:16%!important;\n\t@include transform(translate(50%, -50%)!important);\n}\n.position-bottom-start-overflow-1 {\n\tbottom: 12%!important;\n\tleft:16%!important;\n\ttop:auto!important;\n\t@include transform(translate(-50%, 50%)!important);\n}\t\n.position-bottom-end-overflow-1 {\n\tbottom: 12%!important;\n\tright:16%!important;\n\ttop:auto!important;\n\t@include transform(translate(50%, 50%)!important);\n}\n/*Padding*/\n$num: 0;\n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n    .p-#{$num} {\n        padding: $num1 +0.5rem !important;\n    }\n    $num: $num +1;\n    $num1: $num1 + 0.5rem;\n}\n\n$num: 0;\n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n    .pt-#{$num} {\n        padding-top: $num1 +0.5rem !important;\n    }\n    $num: $num +1;\n    $num1: $num1 + 0.5rem;\n}\n\n$num: 0;\n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n    .pb-#{$num} {\n        padding-bottom: $num1 +0.5rem !important;\n    }\n    $num: $num +1;\n    $num1: $num1 + 0.5rem;\n}\n\n$num: 0;\n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n    .ps-#{$num} {\n        padding-left: $num1 +0.5rem !important;\n    }\n    $num: $num +1;\n    $num1: $num1 + 0.5rem;\n}\n\n$num: 0;\n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n    .pe-#{$num} {\n        padding-right: $num1 +0.5rem !important;\n    }\n    $num: $num +1;\n    $num1: $num1 + 0.5rem;\n}\n\n$num: 0;\n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n    .px-#{$num} {\n        padding-left: $num1 +0.5rem !important;\n        padding-right: $num1 +0.5rem !important;\n    }\n    $num: $num +1;\n    $num1: $num1 + 0.5rem;\n}\n\n$num: 0;\n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n    .py-#{$num} {\n        padding-top: $num1 +0.5rem !important;\n        padding-bottom: $num1 +0.5rem !important;\n    }\n    $num: $num +1;\n    $num1: $num1 + 0.5rem;\n}\n@media (min-width: 576px) { \n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.p-sm-#{$num} {\n\t\t\tpadding: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pt-sm-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pb-sm-#{$num} {\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ps-sm-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pe-sm-#{$num} {\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.px-sm-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.py-sm-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 768px) { \n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.p-md-#{$num} {\n\t\t\tpadding: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pt-md-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0;\n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pb-md-#{$num} {\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ps-md-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pe-md-#{$num} {\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.px-md-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.py-md-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 992px) { \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.p-lg-#{$num} {\n\t\t\tpadding: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pt-lg-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pb-lg-#{$num} {\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ps-lg-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pe-lg-#{$num} {\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.px-lg-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.py-lg-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 1200px) { \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.p-xl-#{$num} {\n\t\t\tpadding: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pt-xl-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pb-xl-#{$num} {\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ps-xl-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pe-xl-#{$num} {\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.px-xl-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.py-xl-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 1400px) { \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.p-xxl-#{$num} {\n\t\t\tpadding: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pt-xxl-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pb-xxl-#{$num} {\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ps-xxl-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.pe-xxl-#{$num} {\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.px-xxl-#{$num} {\n\t\t\tpadding-left: $num1 +0.5rem !important;\n\t\t\tpadding-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.py-xxl-#{$num} {\n\t\t\tpadding-top: $num1 +0.5rem !important;\n\t\t\tpadding-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n\n/*Margin*/\n$num: 0; \n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n\t.m-#{$num} {\n\t\tmargin: $num1 +0.5rem !important;\n\t}\n\t$num: $num +1;\n\t$num1: $num1 + 0.5rem;\n}\n\n$num: 0; \n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n\t.mt-#{$num} {\n\t\tmargin-top: $num1 +0.5rem !important;\n\t}\n\t$num: $num +1;\n\t$num1: $num1 + 0.5rem;\n}\n\n$num: 0; \n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n\t.mb-#{$num} {\n\t\tmargin-bottom: $num1 +0.5rem !important;\n\t}\n\t$num: $num +1;\n\t$num1: $num1 + 0.5rem;\n}\n\n$num: 0; \n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n\t.ms-#{$num} {\n\t\tmargin-left: $num1 +0.5rem !important;\n\t}\n\t$num: $num +1;\n\t$num1: $num1 + 0.5rem;\n}\n\n$num: 0; \n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n\t.me-#{$num} {\n\t\tmargin-right: $num1 +0.5rem !important;\n\t}\n\t$num: $num +1;\n\t$num1: $num1 + 0.5rem;\n}\n\n$num: 0; \n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n\t.mx-#{$num} {\n\t\tmargin-left: $num1 +0.5rem !important;\n\t\tmargin-right: $num1 +0.5rem !important;\n\t}\n\t$num: $num +1;\n\t$num1: $num1 + 0.5rem;\n}\n\n$num: 0; \n$num1: 1.5;\n@while $num < 161 {\n\t@if $num == 0 {\n\t\t$num1 : -0.5;\n\t}\n\t@if $num == 1 {\n\t\t$num1 : -0.25;\n\t}\n\t@if $num == 2 {\n\t\t$num1 : 0;\n\t}\n\t.my-#{$num} {\n\t\tmargin-top: $num1 +0.5rem !important;\n\t\tmargin-bottom: $num1 +0.5rem !important;\n\t}\n\t$num: $num +1;\n\t$num1: $num1 + 0.5rem;\n}\n@media (min-width: 576px) { \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.m-sm-#{$num} {\n\t\t\tmargin: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mt-sm-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mb-sm-#{$num} {\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ms-sm-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.me-sm-#{$num} {\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mx-sm-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.my-sm-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 768px) { \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.m-md-#{$num} {\n\t\t\tmargin: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mt-md-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mb-md-#{$num} {\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ms-md-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.me-md-#{$num} {\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mx-md-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.my-md-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 992px) { \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.m-lg-#{$num} {\n\t\t\tmargin: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mt-lg-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mb-lg-#{$num} {\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ms-lg-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.me-lg-#{$num} {\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mx-lg-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.my-lg-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 1200px) {  \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.m-xl-#{$num} {\n\t\t\tmargin: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mt-xl-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mb-xl-#{$num} {\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ms-xl-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.me-xl-#{$num} {\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mx-xl-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.my-xl-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n@media (min-width: 1400px) {  \n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.m-xxl-#{$num} {\n\t\t\tmargin: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mt-xxl-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mb-xxl-#{$num} {\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.ms-xxl-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.me-xxl-#{$num} {\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.mx-xxl-#{$num} {\n\t\t\tmargin-left: $num1 +0.5rem !important;\n\t\t\tmargin-right: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n\n\t$num: 0; \n\t$num1: 1.5;\n\t@while $num < 161 {\n\t\t@if $num == 0 {\n\t\t\t$num1 : -0.5;\n\t\t}\n\t\t@if $num == 1 {\n\t\t\t$num1 : -0.25;\n\t\t}\n\t\t@if $num == 2 {\n\t\t\t$num1 : 0;\n\t\t}\n\t\t.my-xxl-#{$num} {\n\t\t\tmargin-top: $num1 +0.5rem !important;\n\t\t\tmargin-bottom: $num1 +0.5rem !important;\n\t\t}\n\t\t$num: $num +1;\n\t\t$num1: $num1 + 0.5rem;\n\t}\n}\n\n/*Background Colors*/\n.bg-sky-light-5 {\n\tbackground-color:rgba($sky_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-light-4 {\n\tbackground-color:rgba($sky_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-light-3 {\n\tbackground-color:rgba($sky_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-light-2 {\n\tbackground-color:rgba($sky_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-light-1 {\n\tbackground-color:rgba($sky_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-sky {\n\tbackground-color:rgba($sky,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-dark-5 {\n\tbackground-color:rgba($sky_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-dark-4 {\n\tbackground-color:rgba($sky_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-dark-3 {\n\tbackground-color:rgba($sky_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-dark-2 {\n\tbackground-color:rgba($sky_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-sky-dark-1 {\n\tbackground-color:rgba($sky_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-green-light-5 {\n\tbackground-color:rgba($green_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-green-light-4 {\n\tbackground-color:rgba($green_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-green-light-3 {\n\tbackground-color:rgba($green_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-green-light-2 {\n\tbackground-color:rgba($green_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-green-light-1 {\n\tbackground-color:rgba($green_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-green{\n\tbackground-color:rgba($green,var(--bs-bg-opacity)) !important;\n}\n.bg-green-dark-5 {\n\tbackground-color:rgba($green_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-green-dark-4 {\n\tbackground-color:rgba($green_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-green-dark-3 {\n\tbackground-color:rgba($green_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-green-dark-2 {\n\tbackground-color:rgba($green_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-green-dark-1 {\n\tbackground-color:rgba($green_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-success-light-5 {\n\tbackground-color:rgba($success_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-success-light-4 {\n\tbackground-color:rgba($success_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-success-light-3 {\n\tbackground-color:rgba($success_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-success-light-2 {\n\tbackground-color:rgba($success_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-success-light-1 {\n\tbackground-color:rgba($success_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-success{\n\tbackground-color:rgba($success,var(--bs-bg-opacity)) !important;\n}\n.bg-success-dark-5 {\n\tbackground-color:rgba($success_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-success-dark-4 {\n\tbackground-color:rgba($success_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-success-dark-3 {\n\tbackground-color:rgba($success_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-success-dark-2 {\n\tbackground-color:rgba($success_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-success-dark-1 {\n\tbackground-color:rgba($success_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-light-5 {\n\tbackground-color:rgba($yellow_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-light-4 {\n\tbackground-color:rgba($yellow_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-light-3 {\n\tbackground-color:rgba($yellow_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-light-2 {\n\tbackground-color:rgba($yellow_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-light-1 {\n\tbackground-color:rgba($yellow_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow {\n\tbackground-color:rgba($yellow,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-dark-5 {\n\tbackground-color:rgba($yellow_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-dark-4 {\n\tbackground-color:rgba($yellow_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-dark-3 {\n\tbackground-color:rgba($yellow_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-dark-2 {\n\tbackground-color:rgba($yellow_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-yellow-dark-1 {\n\tbackground-color:rgba($yellow_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-light-5 {\n\tbackground-color:rgba($warning_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-light-4 {\n\tbackground-color:rgba($warning_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-light-3 {\n\tbackground-color:rgba($warning_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-light-2 {\n\tbackground-color:rgba($warning_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-light-1 {\n\tbackground-color:rgba($warning_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-warning {\n\tbackground-color:rgba($warning,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-dark-5 {\n\tbackground-color:rgba($warning_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-dark-4 {\n\tbackground-color:rgba($warning_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-dark-3 {\n\tbackground-color:rgba($warning_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-dark-2 {\n\tbackground-color:rgba($warning_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-warning-dark-1 {\n\tbackground-color:rgba($warning_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-red-light-5 {\n\tbackground-color:rgba($red_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-red-light-4 {\n\tbackground-color:rgba($red_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-red-light-3 {\n\tbackground-color:rgba($red_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-red-light-2 {\n\tbackground-color:rgba($red_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-red-light-1 {\n\tbackground-color:rgba($red_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-red {\n\tbackground-color:rgba($red,var(--bs-bg-opacity)) !important;\n}\n.bg-red-dark-5 {\n\tbackground-color:rgba($red_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-red-dark-4 {\n\tbackground-color:rgba($red_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-red-dark-3 {\n\tbackground-color:rgba($red_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-red-dark-2 {\n\tbackground-color:rgba($red_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-red-dark-1 {\n\tbackground-color:rgba($red_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-light-5 {\n\tbackground-color:rgba($danger_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-light-4 {\n\tbackground-color:rgba($danger_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-light-3 {\n\tbackground-color:rgba($danger_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-light-2 {\n\tbackground-color:rgba($danger_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-light-1 {\n\tbackground-color:rgba($danger_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-danger {\n\tbackground-color:rgba($danger,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-dark-5 {\n\tbackground-color:rgba($danger_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-dark-4 {\n\tbackground-color:rgba($danger_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-dark-3 {\n\tbackground-color:rgba($danger_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-dark-2 {\n\tbackground-color:rgba($danger_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-danger-dark-1 {\n\tbackground-color:rgba($danger_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-light-5 {\n\tbackground-color:rgba($blue_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-light-4 {\n\tbackground-color:rgba($blue_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-light-3 {\n\tbackground-color:rgba($blue_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-light-2 {\n\tbackground-color:rgba($blue_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-light-1 {\n\tbackground-color:rgba($blue_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-blue {\n\tbackground-color:rgba($blue,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-dark-5 {\n\tbackground-color:rgba($blue_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-dark-4 {\n\tbackground-color:rgba($blue_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-dark-3 {\n\tbackground-color:rgba($blue_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-dark-2 {\n\tbackground-color:rgba($blue_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-blue-dark-1 {\n\tbackground-color:rgba($blue_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-light-5 {\n\tbackground-color:rgba($primary_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-light-4 {\n\tbackground-color:rgba($primary_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-light-3 {\n\tbackground-color:rgba($primary_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-light-2 {\n\tbackground-color:rgba($primary_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-light-1 {\n\tbackground-color:rgba($primary_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-primary {\n\tbackground-color:rgba($primary,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-dark-5 {\n\tbackground-color:rgba($primary_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-dark-4 {\n\tbackground-color:rgba($primary_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-dark-3 {\n\tbackground-color:rgba($primary_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-dark-2 {\n\tbackground-color:rgba($primary_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-primary-dark-1 {\n\tbackground-color:rgba($primary_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-light-5 {\n\tbackground-color:rgba($cyan_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-light-4 {\n\tbackground-color:rgba($cyan_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-light-3 {\n\tbackground-color:rgba($cyan_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-light-2 {\n\tbackground-color:rgba($cyan_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-light-1 {\n\tbackground-color:rgba($cyan_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan {\n\tbackground-color:rgba($cyan,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-dark-5 {\n\tbackground-color:rgba($cyan_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-dark-4 {\n\tbackground-color:rgba($cyan_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-dark-3 {\n\tbackground-color:rgba($cyan_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-dark-2 {\n\tbackground-color:rgba($cyan_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-cyan-dark-1 {\n\tbackground-color:rgba($cyan_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-info-light-5 {\n\tbackground-color:rgba($info_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-info-light-4 {\n\tbackground-color:rgba($info_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-info-light-3 {\n\tbackground-color:rgba($info_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-info-light-2 {\n\tbackground-color:rgba($info_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-info-light-1 {\n\tbackground-color:rgba($info_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-info {\n\tbackground-color:rgba($info,var(--bs-bg-opacity)) !important;\n}\n.bg-info-dark-5 {\n\tbackground-color:rgba($info_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-info-dark-4 {\n\tbackground-color:rgba($info_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-info-dark-3 {\n\tbackground-color:rgba($info_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-info-dark-2 {\n\tbackground-color:rgba($info_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-info-dark-1 {\n\tbackground-color:rgba($info_dark_1,var(--bs-bg-opacity)) !important;\n}\n\n.bg-grey-light-5 {\n\tbackground-color:rgba($grey_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-light-4 {\n\tbackground-color:rgba($grey_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-light-3 {\n\tbackground-color:rgba($grey_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-light-2 {\n\tbackground-color:rgba($grey_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-light-1 {\n\tbackground-color:rgba($grey_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-grey {\n\tbackground-color:rgba($grey,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-dark-1 {\n\tbackground-color:rgba($grey_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-dark-2 {\n\tbackground-color:rgba($grey_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-dark-3 {\n\tbackground-color:rgba($grey_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-dark-4 {\n\tbackground-color:rgba($grey_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-grey-dark-5 {\n\tbackground-color:rgba($grey_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-light-5 {\n\tbackground-color:rgba($secondary_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-light-4 {\n\tbackground-color:rgba($secondary_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-light-3 {\n\tbackground-color:rgba($secondary_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-light-2 {\n\tbackground-color:rgba($secondary_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-light-1 {\n\tbackground-color:rgba($secondary_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary {\n\tbackground-color:rgba($secondary,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-dark-1 {\n\tbackground-color:rgba($secondary_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-dark-2 {\n\tbackground-color:rgba($secondary_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-dark-3 {\n\tbackground-color:rgba($secondary_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-dark-4 {\n\tbackground-color:rgba($secondary_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-secondary-dark-5 {\n\tbackground-color:rgba($secondary_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-light-5 {\n\tbackground-color:rgba($pink_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-light-4 {\n\tbackground-color:rgba($pink_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-light-3 {\n\tbackground-color:rgba($pink_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-light-2 {\n\tbackground-color:rgba($pink_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-light-1 {\n\tbackground-color:rgba($pink_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-pink {\n\tbackground-color:rgba($pink,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-dark-5 {\n\tbackground-color:rgba($pink_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-dark-4 {\n\tbackground-color:rgba($pink_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-dark-3 {\n\tbackground-color:rgba($pink_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-dark-2 {\n\tbackground-color:rgba($pink_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-pink-dark-1 {\n\tbackground-color:rgba($pink_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-light-5 {\n\tbackground-color:rgba($purple_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-light-4 {\n\tbackground-color:rgba($purple_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-light-3 {\n\tbackground-color:rgba($purple_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-light-2 {\n\tbackground-color:rgba($purple_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-light-1 {\n\tbackground-color:rgba($purple_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-purple {\n\tbackground-color:rgba($purple,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-dark-5 {\n\tbackground-color:rgba($purple_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-dark-4 {\n\tbackground-color:rgba($purple_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-dark-3 {\n\tbackground-color:rgba($purple_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-dark-2 {\n\tbackground-color:rgba($purple_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-purple-dark-1 {\n\tbackground-color:rgba($purple_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-light-5 {\n\tbackground-color:rgba($violet_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-light-4 {\n\tbackground-color:rgba($violet_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-light-3 {\n\tbackground-color:rgba($violet_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-light-2 {\n\tbackground-color:rgba($violet_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-light-1 {\n\tbackground-color:rgba($violet_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-violet {\n\tbackground-color:rgba($violet,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-dark-5 {\n\tbackground-color:rgba($violet_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-dark-4 {\n\tbackground-color:rgba($violet_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-dark-3 {\n\tbackground-color:rgba($violet_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-dark-2 {\n\tbackground-color:rgba($violet_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-violet-dark-1 {\n\tbackground-color:rgba($violet_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-light-5 {\n\tbackground-color:rgba($indigo_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-light-4 {\n\tbackground-color:rgba($indigo_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-light-3 {\n\tbackground-color:rgba($indigo_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-light-2 {\n\tbackground-color:rgba($indigo_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-light-1 {\n\tbackground-color:rgba($indigo_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo {\n\tbackground-color:rgba($indigo,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-dark-5 {\n\tbackground-color:rgba($indigo_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-dark-4 {\n\tbackground-color:rgba($indigo_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-dark-3 {\n\tbackground-color:rgba($indigo_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-dark-2 {\n\tbackground-color:rgba($indigo_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-indigo-dark-1 {\n\tbackground-color:rgba($indigo_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-light-5 {\n\tbackground-color:rgba($teal_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-light-4 {\n\tbackground-color:rgba($teal_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-light-3 {\n\tbackground-color:rgba($teal_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-light-2 {\n\tbackground-color:rgba($teal_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-light-1 {\n\tbackground-color:rgba($teal_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-teal {\n\tbackground-color:rgba($teal,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-dark-5 {\n\tbackground-color:rgba($teal_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-dark-4 {\n\tbackground-color:rgba($teal_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-dark-3 {\n\tbackground-color:rgba($teal_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-dark-2 {\n\tbackground-color:rgba($teal_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-teal-dark-1 {\n\tbackground-color:rgba($teal_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-light-5 {\n\tbackground-color:rgba($neon_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-light-4 {\n\tbackground-color:rgba($neon_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-light-3 {\n\tbackground-color:rgba($neon_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-light-2 {\n\tbackground-color:rgba($neon_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-light-1 {\n\tbackground-color:rgba($neon_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-neon {\n\tbackground-color:rgba($neon,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-dark-5 {\n\tbackground-color:rgba($neon_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-dark-4 {\n\tbackground-color:rgba($neon_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-dark-3 {\n\tbackground-color:rgba($neon_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-dark-2 {\n\tbackground-color:rgba($neon_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-neon-dark-1 {\n\tbackground-color:rgba($neon_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-light-5 {\n\tbackground-color:rgba($lime_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-light-4 {\n\tbackground-color:rgba($lime_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-light-3 {\n\tbackground-color:rgba($lime_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-light-2 {\n\tbackground-color:rgba($lime_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-light-1 {\n\tbackground-color:rgba($lime_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-lime {\n\tbackground-color:rgba($lime,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-dark-5 {\n\tbackground-color:rgba($lime_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-dark-4 {\n\tbackground-color:rgba($lime_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-dark-3 {\n\tbackground-color:rgba($lime_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-dark-2 {\n\tbackground-color:rgba($lime_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-lime-dark-1 {\n\tbackground-color:rgba($lime_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-light-5 {\n\tbackground-color:rgba($sun_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-light-4 {\n\tbackground-color:rgba($sun_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-light-3 {\n\tbackground-color:rgba($sun_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-light-2 {\n\tbackground-color:rgba($sun_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-light-1 {\n\tbackground-color:rgba($sun_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-sun {\n\tbackground-color:rgba($sun,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-dark-5 {\n\tbackground-color:rgba($sun_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-dark-4 {\n\tbackground-color:rgba($sun_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-dark-3 {\n\tbackground-color:rgba($sun_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-dark-2 {\n\tbackground-color:rgba($sun_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-sun-dark-1 {\n\tbackground-color:rgba($sun_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-light-5 {\n\tbackground-color:rgba($orange_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-light-4 {\n\tbackground-color:rgba($orange_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-light-3 {\n\tbackground-color:rgba($orange_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-light-2 {\n\tbackground-color:rgba($orange_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-light-1 {\n\tbackground-color:rgba($orange_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-orange {\n\tbackground-color:rgba($orange,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-dark-5 {\n\tbackground-color:rgba($orange_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-dark-4 {\n\tbackground-color:rgba($orange_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-dark-3 {\n\tbackground-color:rgba($orange_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-dark-2 {\n\tbackground-color:rgba($orange_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-orange-dark-1 {\n\tbackground-color:rgba($orange_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-light-5 {\n\tbackground-color:rgba($pumpkin_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-light-4 {\n\tbackground-color:rgba($pumpkin_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-light-3 {\n\tbackground-color:rgba($pumpkin_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-light-2 {\n\tbackground-color:rgba($pumpkin_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-light-1 {\n\tbackground-color:rgba($pumpkin_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin {\n\tbackground-color:rgba($pumpkin,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-dark-5 {\n\tbackground-color:rgba($pumpkin_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-dark-4 {\n\tbackground-color:rgba($pumpkin_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-dark-3 {\n\tbackground-color:rgba($pumpkin_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-dark-2 {\n\tbackground-color:rgba($pumpkin_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-pumpkin-dark-1 {\n\tbackground-color:rgba($pumpkin_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-light-5 {\n\tbackground-color:rgba($brown_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-light-4 {\n\tbackground-color:rgba($brown_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-light-3 {\n\tbackground-color:rgba($brown_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-light-2 {\n\tbackground-color:rgba($brown_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-light-1 {\n\tbackground-color:rgba($brown_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-brown {\n\tbackground-color:rgba($brown,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-dark-5 {\n\tbackground-color:rgba($brown_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-dark-4 {\n\tbackground-color:rgba($brown_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-dark-3 {\n\tbackground-color:rgba($brown_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-dark-2 {\n\tbackground-color:rgba($brown_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-brown-dark-1 {\n\tbackground-color:rgba($brown_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-light-5 {\n\tbackground-color:rgba($gold_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-light-4 {\n\tbackground-color:rgba($gold_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-light-3 {\n\tbackground-color:rgba($gold_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-light-2 {\n\tbackground-color:rgba($gold_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-light-1 {\n\tbackground-color:rgba($gold_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-gold {\n\tbackground-color:rgba($gold,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-dark-5 {\n\tbackground-color:rgba($gold_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-dark-4 {\n\tbackground-color:rgba($gold_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-dark-3 {\n\tbackground-color:rgba($gold_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-dark-2 {\n\tbackground-color:rgba($gold_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-gold-dark-1 {\n\tbackground-color:rgba($gold_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-light-5 {\n\tbackground-color:rgba($smoke_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-light-4 {\n\tbackground-color:rgba($smoke_light_4,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-light-3 {\n\tbackground-color:rgba($smoke_light_3,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-light-2 {\n\tbackground-color:rgba($smoke_light_2,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-light-1 {\n\tbackground-color:rgba($smoke_light_1,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke {\n\tbackground-color:rgba($smoke,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-dark-5 {\n\tbackground-color:rgba($smoke_dark_5,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-dark-4 {\n\tbackground-color:rgba($smoke_dark_4,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-dark-3 {\n\tbackground-color:rgba($smoke_dark_3,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-dark-2 {\n\tbackground-color:rgba($smoke_dark_2,var(--bs-bg-opacity)) !important;\n}\n.bg-smoke-dark-1 {\n\tbackground-color:rgba($smoke_dark_1,var(--bs-bg-opacity)) !important;\n}\n.bg-white {\n\tbackground-color:rgba($white,var(--bs-bg-opacity)) !important;\n}\n.bg-light {\n\tbackground-color:rgba( $grey_light_5,var(--bs-bg-opacity)) !important;\n}\n.bg-dark-10 {\n\tbackground-color:rgba($black,var(--bs-bg-opacity)) !important;\n}\n.bg-dark-20 {\n\tbackground-color:rgba($black_1,var(--bs-bg-opacity)) !important;\n}\n.bg-dark,\n.bg-dark-40 {\n\tbackground-color:rgba($black_2,var(--bs-bg-opacity)) !important;\n}\n.bg-dark-60 {\n\tbackground-color:rgba($black_3,var(--bs-bg-opacity)) !important;\n}\n.bg-dark-80 {\n\tbackground-color:rgba($black_4,var(--bs-bg-opacity)) !important;\n}\n.bg-dark-100 {\n\tbackground-color:rgba($black_5,var(--bs-bg-opacity)) !important;\n}\n.bg-twitter {\n\tbackground-color:$twitter !important;\n}\n.bg-facebook {\n\tbackground-color:$facebook !important;\n}\n.bg-gradient-primary {\n\t@include bg-linear-gradient(45deg,$primary,$violet_light_1);\n}\n.bg-gradient-info {\n\t@include bg-linear-gradient(45deg,$info,$teal);\n}\n.bg-gradient-success {\n\t@include bg-linear-gradient(45deg,$success,$neon);\n}\n.bg-gradient-warning {\n\t@include bg-linear-gradient(45deg,$warning,$sun);\n}\n.bg-gradient-danger {\n\t@include bg-linear-gradient(45deg,$danger_light_1,$pink);\n}\n.bg-gradient-secondary {\n\t@include bg-linear-gradient(45deg,$secondary,$grey_light_3);\n}\n.bg-gradient-light {\n\t@include bg-linear-gradient(45deg,$grey_light_1,$grey_light_5);\n}\n.bg-gradient-dark {\n\t@include bg-linear-gradient(45deg,$black_2,$grey_dark_3);\n}\n.bg-gradient-pony {\n\t@include bg-linear-gradient(45deg,$pink_light_3,$cyan_light_1);\n}\n.bg-gradient-space {\n\t@include bg-linear-gradient(45deg,$purple_light_1,$yellow_light_2);\n}\n.bg-gradient-streaks {\n\t@include bg-linear-gradient(45deg,$violet,$teal);\n}\n.bg-gradient-bunting {\n\t@include bg-linear-gradient(45deg,$blue_light_1,$brown_light_3);\n}\n.bg-gradient-paradise {\n\t@include bg-linear-gradient(45deg,$indigo_dark_5,$violet);\n}\n.bg-gradient-heaven {\n\t@include bg-linear-gradient(45deg,$neon,$sky);\n}\n.bg-gradient-honey {\n\t@include bg-linear-gradient(45deg,$lime,$orange);\n}\n.bg-gradient-warbler {\n\t@include bg-linear-gradient(45deg,$sun,$grey);\n}\n.bg-gradient-dusk {\n\t@include bg-linear-gradient(45deg,$pumpkin_light_1,$violet_light_1);\n}\n.bg-gradient-citrine {\n\t@include bg-linear-gradient(45deg,$pink_dark_2,$brown_dark_3);\n}\n.bg-gradient-royston {\n\t@include bg-linear-gradient(45deg,$green_light_2,$brown_light_2);\n}\n.bg-gradient-ashes\t {\n\t@include bg-linear-gradient(45deg,$smoke_dark_5,$smoke_dark_2);\n}\n.bg-gradient-metal {\n\t@include bg-linear-gradient(45deg,$gold,$grey);\n}\n.bg-gradient-sunset {\n\t@include bg-linear-gradient(45deg,$pumpkin_light_1,$orange_light_1);\n}\n.overlay-wrap {\n\tposition:relative;\n\t.bg-overlay {\n\t\tposition:absolute;\n\t\tleft:0;\n\t\ttop:0;\n\t\theight:100%;\n\t\twidth:100%;\n\t\tz-index:1;\n\t}\n}\n/*Text Colors*/\n.text-sky {\n\tcolor:rgba($sky ,var(--bs-text-opacity)) !important;\n}\n.text-cyan {\n\tcolor:rgba($cyan ,var(--bs-text-opacity)) !important;\n}\n.text-info {\n\tcolor:rgba($info ,var(--bs-text-opacity)) !important;\n}\n.text-green {\n\tcolor:rgba($green ,var(--bs-text-opacity)) !important;\n}\n.text-success {\n\tcolor:rgba($success ,var(--bs-text-opacity)) !important;\n}\n.text-yellow {\n\tcolor:rgba($yellow ,var(--bs-text-opacity)) !important;\n}\n.text-warning {\n\tcolor:rgba($warning ,var(--bs-text-opacity)) !important;\n}\n.text-red {\n\tcolor:rgba($red ,var(--bs-text-opacity)) !important;\n}\n.text-danger {\n\tcolor:rgba($danger ,var(--bs-text-opacity)) !important;\n}\n.text-blue {\n\tcolor:rgba($blue ,var(--bs-text-opacity)) !important;\n}\n.text-primary {\n\tcolor:rgba($primary ,var(--bs-text-opacity)) !important;\n}\n.text-pink {\n\tcolor:rgba($pink ,var(--bs-text-opacity)) !important;\n}\n.text-purple {\n\tcolor:rgba($purple ,var(--bs-text-opacity)) !important;\n}\n.text-violet {\n\tcolor:rgba($violet ,var(--bs-text-opacity)) !important;\n}\n.text-indigo {\n\tcolor:rgba($indigo ,var(--bs-text-opacity)) !important;\n}\n.text-teal {\n\tcolor:rgba($teal ,var(--bs-text-opacity)) !important;\n}\n.text-neon {\n\tcolor:rgba($neon ,var(--bs-text-opacity)) !important;\n}\n.text-lime {\n\tcolor:rgba($lime ,var(--bs-text-opacity)) !important;\n}\n.text-sun {\n\tcolor:rgba($sun ,var(--bs-text-opacity)) !important;\n}\n.text-orange {\n\tcolor:rgba($orange ,var(--bs-text-opacity)) !important;\n}\n.text-pumpkin {\n\tcolor:rgba($pumpkin ,var(--bs-text-opacity)) !important;\n}\n.text-brown {\n\tcolor:rgba($brown ,var(--bs-text-opacity)) !important;\n}\n.text-gold {\n\tcolor:rgba($gold ,var(--bs-text-opacity)) !important;\n}\n.text-smoke {\n\tcolor:rgba($smoke ,var(--bs-text-opacity)) !important;\n}\n.text-muted {\n\tcolor:rgba($grey_dark_3 ,var(--bs-text-opacity)) !important;\n}\n.text-secondary {\n\tcolor:rgba($secondary ,var(--bs-text-opacity)) !important;\n}\n.text-grey {\n\tcolor:rgba($grey ,var(--bs-text-opacity)) !important;\n}\n.text-dark-10 {\n\tcolor:rgba($black ,var(--bs-text-opacity)) !important;\n}\n.text-dark-20 {\n\tcolor:rgba($black_1 ,var(--bs-text-opacity)) !important;\n}\n.text-dark,\n.text-dark-40 {\n\tcolor:rgba($black_2 ,var(--bs-text-opacity)) !important;\n}\n.text-dark-60 {\n\tcolor:rgba($black_3 ,var(--bs-text-opacity)) !important;\n}\n.text-dark-80 {\n\tcolor:rgba($black_4 ,var(--bs-text-opacity)) !important;\n}\n.text-dark-100 {\n\tcolor:rgba($black_5 ,var(--bs-text-opacity)) !important;\n}\n.text-light {\n\tcolor:rgba($grey_dark_2 ,var(--bs-text-opacity)) !important;\n}\n.text-white {\n\tcolor:rgba($white ,var(--bs-text-opacity)) !important;\n}\n.text-body {\n\tcolor:rgba($grey_dark_3,var(--bs-text-opacity)) !important;\n}\n.text-disabled {\n\tcolor:rgba($grey_light_1 ,var(--bs-text-opacity)) !important;\n}\n.text-high-em {\n\tcolor: $black_2;\n\tfont-weight: 500;\n}\n.text-medium-em {\n\tcolor: $black_2;\n\tfont-size: .875rem;\n}\n.text-low-em {\n\tfont-size: .75rem;\n}\n/*Border*/\n.border-dashed {\n\tborder-style:dashed!important;\n}\n.border-dotted {\n\tborder-style:dotted!important;\n}\n.circle {\n    border-radius: 50%!important;\n}\n.rounded-pill-start {\n border-top-left-radius:50rem!important;\n border-bottom-left-radius:50rem!important;\n}\n.rounded-pill-end {\n border-top-right-radius:50rem!important;\n border-bottom-right-radius:50rem!important;\n}\n.rounded-top-start {\n    border-top-left-radius: .25rem!important;\n}\n.rounded-top-end {\n    border-top-right-radius: .25rem!important;\n}\n.rounded-bottom-start {\n    border-bottom-left-radius: .25rem!important;\n}\n.rounded-bottom-end {\n    border-bottom-right-radius: .25rem!important;\n}\n.rounded-top-0 {\n    border-top-left-radius: 0!important;\n    border-top-right-radius: 0!important;\n}\n.rounded-top-start-0 {\n    border-top-left-radius: 0!important;\n}\n.rounded-top-end-0 {\n    border-top-right-radius: 0!important;\n}\n.rounded-start-0 {\n    border-top-left-radius: 0!important;\n    border-bottom-left-radius: 0!important;\n}\n.rounded-end-0 {\n    border-top-right-radius: 0!important;\n    border-bottom-right-radius: 0!important;\n}\n.rounded-bottom-0 {\n    border-bottom-left-radius: 0!important;\n    border-bottom-right-radius: 0!important;\n}\n.rounded-bottom-start-0 {\n    border-bottom-left-radius: 0!important;\n}\n.rounded-bottom-end-0 {\n    border-bottom-right-radius: 0!important;\n}\n$num: 0;\n$num1: 0;\n@while $num1 < 21 {\n    .rounded-#{$num1} {\n        border-radius: $num +0rem!important;\n    }\n\t$num: $num +0.125;\n\t$num1: $num1 +1;\n}\n$num: 2.5;\n$num1: 21;\n@while $num1 < 35 {\n    .rounded-#{$num1} {\n        border-radius: $num +0.25rem!important;\n    }\n\t$num: $num +0.25;\n\t$num1: $num1 +1;\n}\n\n\n.border-sky {\n\tborder-color:$sky !important;\n}\n.border-cyan {\n\tborder-color:$cyan !important;\n}\n.border-info {\n\tborder-color:$info !important;\n}\n.border-red  {\n\tborder-color:$red !important;\n}\n.border-danger  {\n\tborder-color:$danger !important;\n}\n.border-green {\n\tborder-color:$green !important;\n}\n.border-success {\n\tborder-color:$success !important;\n}\n.border-yellow {\n\tborder-color:$yellow !important;\n}\n.border-warning {\n\tborder-color:$warning !important;\n}\n.border-pink {\n\tborder-color:$pink !important;\n}\n.border-purple {\n\tborder-color:$purple !important;\n}\n.border-violet {\n\tborder-color:$violet !important;\n}\n.border-indigo {\n\tborder-color:$indigo !important;\n}\n.border-blue {\n\tborder-color:$blue !important;\n}\n.border-primary {\n\tborder-color:$primary !important;\n}\n.border-teal {\n\tborder-color:$teal !important;\n}\n.border-neon {\n\tborder-color:$neon !important;\n}\n.border-lime {\n\tborder-color:$lime !important;\n}\n.border-sun {\n\tborder-color:$sun !important;\n}\n.border-orange {\n\tborder-color:$orange !important;\n}\n.border-pumpkin {\n\tborder-color:$pumpkin !important;\n}\n.border-brown {\n\tborder-color:$brown !important;\n}\n.border-gold {\n\tborder-color:$gold !important;\n}\n.border-smoke {\n\tborder-color:$smoke !important;\n}\n.border-white {\n\tborder-color:$white !important;\n}\n.border-light {\n\tborder-color:$grey_light_3 !important;\n}\n.border-dark-10 {\n\tborder-color:$black !important;\n}\n.border-dark-20 {\n\tborder-color:$black_1 !important;\n}\n.border-dark,\n.border-dark-40 {\n\tborder-color:$black_2 !important;\n}\n.border-dark-60 {\n\tborder-color:$black_3 !important;\n}\n.border-dark-80 {\n\tborder-color:$black_4 !important;\n}\n.border-dark-100 {\n\tborder-color:$black_5 !important;\n}\n.border-grey {\n\tborder-color:$grey !important;\n}\n.border-secondary {\n\tborder-color:$secondary !important;\n}\n.subtractive-example > .d-inline-block {\n\tborder:1px solid $grey;\n}\n/*Colors*/\n.color-palette-wrap {\n\t.color-wrap {\n\t\tpadding:1rem;\n\t}\n}\n/*Shadow*/\n.shadow-none {\n\tbox-shadow:none!important;\n}\n.shadow-sm {\n\t@include boxshadow-sm($black);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($black);\n\t}\n}\n.shadow-hover-sm {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($black);\n\t\t}\n\t}\t\n}\n.shadow {\n\t@include boxshadow($black);\n\t&.shadow-top {\n\t\t@include boxshadow-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($black);\n\t}\n}\n.shadow-hover {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($black);\n\t\t}\n\t}\t\n}\n.shadow-lg {\n\t@include boxshadow-lg($black);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($black);\n\t}\n}\n.shadow-hover-lg {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($black);\n\t\t}\n\t}\t\n}\n.shadow-xl {\n\t@include boxshadow-xl($black);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($black);\n\t}\n}\n.shadow-hover-xl {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($black);\n\t\t}\n\t}\t\n}\n.shadow-sm-sky {\n\t@include boxshadow-sm($sky);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($sky);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($sky);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($sky);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($sky);\n\t}\n}\n.shadow-hover-sm-sky {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($sky);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($sky);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($sky);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($sky);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($sky);\n\t\t}\n\t}\t\n}\n.shadow-sky {\n\t@include boxshadow($sky);\n\t&.shadow-top {\n\t\t@include boxshadow-top($sky);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($sky);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($sky);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($sky);\n\t}\n}\n.shadow-hover-sky {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($sky);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($sky);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($sky);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($sky);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($sky);\n\t\t}\n\t}\t\n}\n.shadow-lg-sky {\n\t@include boxshadow-lg($sky);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($sky);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($sky);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($sky);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($sky);\n\t}\n}\n.shadow-hover-lg-sky {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($sky);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($sky);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($sky);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($sky);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($sky);\n\t\t}\n\t}\t\n}\n.shadow-xl-sky {\n\t@include boxshadow-xl($sky);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($sky);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($sky);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($sky);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($sky);\n\t}\n}\n.shadow-hover-xl-sky {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($sky);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($sky);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($sky);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($sky);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($sky);\n\t\t}\n\t}\t\n}\n.shadow-sm-cyan {\n\t@include boxshadow-sm($cyan);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($cyan);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($cyan);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($cyan);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($cyan);\n\t}\n}\n.shadow-hover-sm-cyan {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($cyan);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($cyan);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($cyan);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($cyan);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($cyan);\n\t\t}\n\t}\t\n}\n.shadow-cyan {\n\t@include boxshadow($cyan);\n\t&.shadow-top {\n\t\t@include boxshadow-top($cyan);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($cyan);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($cyan);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($cyan);\n\t}\n}\n.shadow-hover-cyan {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($cyan);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($cyan);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($cyan);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($cyan);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($cyan);\n\t\t}\n\t}\t\n}\n.shadow-lg-cyan {\n\t@include boxshadow-lg($cyan);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($cyan);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($cyan);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($cyan);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($cyan);\n\t}\n}\n.shadow-hover-lg-cyan {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($cyan);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($cyan);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($cyan);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($cyan);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($cyan);\n\t\t}\n\t}\t\n}\n.shadow-xl-cyan {\n\t@include boxshadow-xl($cyan);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($cyan);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($cyan);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($cyan);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($cyan);\n\t}\n}\n.shadow-hover-xl-cyan {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($cyan);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($cyan);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($cyan);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($cyan);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($cyan);\n\t\t}\n\t}\t\n}\n.shadow-sm-info {\n\t@include boxshadow-sm($info);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($info);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($info);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($info);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($info);\n\t}\n}\n.shadow-hover-sm-info {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($info);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($info);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($info);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($info);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($info);\n\t\t}\n\t}\t\n}\n.shadow-info {\n\t@include boxshadow($info);\n\t&.shadow-top {\n\t\t@include boxshadow-top($info);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($info);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($info);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($info);\n\t}\n}\n.shadow-hover-info {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($info);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($info);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($info);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($info);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($info);\n\t\t}\n\t}\t\n}\n.shadow-lg-info {\n\t@include boxshadow-lg($info);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($info);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($info);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($info);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($info);\n\t}\n}\n.shadow-hover-lg-info {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($info);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($info);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($info);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($info);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($info);\n\t\t}\n\t}\t\n}\n.shadow-xl-info {\n\t@include boxshadow-xl($info);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($info);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($info);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($info);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($info);\n\t}\n}\n.shadow-hover-xl-info {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($info);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($info);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($info);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($info);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($info);\n\t\t}\n\t}\t\n}\n.shadow-sm-green {\n\t@include boxshadow-sm($green);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($green);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($green);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($green);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($green);\n\t}\n}\n.shadow-hover-sm-green {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($green);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($green);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($green);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($green);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($green);\n\t\t}\n\t}\t\n}\n.shadow-green {\n\t@include boxshadow($green);\n\t&.shadow-top {\n\t\t@include boxshadow-top($green);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($green);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($green);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($green);\n\t}\n}\n.shadow-hover-green {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($green);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($green);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($green);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($green);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($green);\n\t\t}\n\t}\t\n}\n.shadow-lg-green {\n\t@include boxshadow-lg($green);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($green);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($green);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($green);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($green);\n\t}\n}\n.shadow-hover-lg-green {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($green);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($green);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($green);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($green);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($green);\n\t\t}\n\t}\t\n}\n.shadow-xl-green {\n\t@include boxshadow-xl($green);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($green);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($green);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($green);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($green);\n\t}\n}\n.shadow-hover-xl-green {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($green);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($green);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($green);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($green);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($green);\n\t\t}\n\t}\t\n}\n.shadow-sm-success {\n\t@include boxshadow-sm($success);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($success);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($success);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($success);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($success);\n\t}\n}\n.shadow-hover-sm-success {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($success);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($success);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($success);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($success);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($success);\n\t\t}\n\t}\t\n}\n.shadow-success {\n\t@include boxshadow($success);\n\t&.shadow-top {\n\t\t@include boxshadow-top($success);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($success);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($success);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($success);\n\t}\n}\n.shadow-hover-success {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($success);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($success);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($success);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($success);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($success);\n\t\t}\n\t}\t\n}\n.shadow-lg-success {\n\t@include boxshadow-lg($success);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($success);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($success);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($success);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($success);\n\t}\n}\n.shadow-hover-lg-success {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($success);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($success);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($success);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($success);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($success);\n\t\t}\n\t}\t\n}\n.shadow-xl-success {\n\t@include boxshadow-xl($success);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($success);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($success);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($success);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($success);\n\t}\n}\n.shadow-hover-xl-success {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($success);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($success);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($success);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($success);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($success);\n\t\t}\n\t}\t\n}\n.shadow-sm-yellow {\n\t@include boxshadow-sm($yellow);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($yellow);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($yellow);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($yellow);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($yellow);\n\t}\n}\n.shadow-hover-sm-yellow {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($yellow);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($yellow);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($yellow);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($yellow);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($yellow);\n\t\t}\n\t}\t\n}\n.shadow-yellow {\n\t@include boxshadow($yellow);\n\t&.shadow-top {\n\t\t@include boxshadow-top($yellow);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($yellow);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($yellow);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($yellow);\n\t}\n}\n.shadow-hover-yellow {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($yellow);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($yellow);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($yellow);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($yellow);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($yellow);\n\t\t}\n\t}\t\n}\n.shadow-lg-yellow {\n\t@include boxshadow-lg($yellow);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($yellow);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($yellow);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($yellow);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($yellow);\n\t}\n}\n.shadow-hover-lg-yellow {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($yellow);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($yellow);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($yellow);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($yellow);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($yellow);\n\t\t}\n\t}\t\n}\n.shadow-xl-yellow {\n\t@include boxshadow-xl($yellow);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($yellow);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($yellow);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($yellow);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($yellow);\n\t}\n}\n.shadow-hover-xl-yellow {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($yellow);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($yellow);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($yellow);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($yellow);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($yellow);\n\t\t}\n\t}\t\n}\n.shadow-sm-warning {\n\t@include boxshadow-sm($warning);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($warning);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($warning);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($warning);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($warning);\n\t}\n}\n.shadow-hover-sm-warning {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($warning);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($warning);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($warning);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($warning);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($warning);\n\t\t}\n\t}\t\n}\n.shadow-warning {\n\t@include boxshadow($warning);\n\t&.shadow-top {\n\t\t@include boxshadow-top($warning);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($warning);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($warning);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($warning);\n\t}\n}\n.shadow-hover-warning {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($warning);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($warning);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($warning);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($warning);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($warning);\n\t\t}\n\t}\t\n}\n.shadow-lg-warning {\n\t@include boxshadow-lg($warning);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($warning);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($warning);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($warning);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($warning);\n\t}\n}\n.shadow-hover-lg-warning {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($warning);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($warning);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($warning);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($warning);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($warning);\n\t\t}\n\t}\t\n}\n.shadow-xl-warning {\n\t@include boxshadow-xl($warning);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($warning);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($warning);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($warning);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($warning);\n\t}\n}\n.shadow-hover-xl-warning {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($warning);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($warning);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($warning);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($warning);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($warning);\n\t\t}\n\t}\t\n}\n.shadow-sm-red {\n\t@include boxshadow-sm($red);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($red);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($red);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($red);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($red);\n\t}\n}\n.shadow-hover-sm-red {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($red);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($red);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($red);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($red);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($red);\n\t\t}\n\t}\t\n}\n.shadow-red {\n\t@include boxshadow($red);\n\t&.shadow-top {\n\t\t@include boxshadow-top($red);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($red);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($red);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($red);\n\t}\n}\n.shadow-hover-red {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($red);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($red);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($red);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($red);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($red);\n\t\t}\n\t}\t\n}\n.shadow-lg-red {\n\t@include boxshadow-lg($red);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($red);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($red);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($red);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($red);\n\t}\n}\n.shadow-hover-lg-red {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($red);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($red);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($red);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($red);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($red);\n\t\t}\n\t}\t\n}\n.shadow-xl-red {\n\t@include boxshadow-xl($red);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($red);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($red);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($red);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($red);\n\t}\n}\n.shadow-hover-xl-red {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($red);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($red);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($red);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($red);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($red);\n\t\t}\n\t}\t\n}\n.shadow-sm-danger {\n\t@include boxshadow-sm($danger);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($danger);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($danger);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($danger);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($danger);\n\t}\n}\n.shadow-hover-sm-danger {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($danger);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($danger);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($danger);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($danger);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($danger);\n\t\t}\n\t}\t\n}\n.shadow-danger {\n\t@include boxshadow($danger);\n\t&.shadow-top {\n\t\t@include boxshadow-top($danger);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($danger);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($danger);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($danger);\n\t}\n}\n.shadow-hover-danger {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($danger);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($danger);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($danger);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($danger);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($danger);\n\t\t}\n\t}\t\n}\n.shadow-lg-danger {\n\t@include boxshadow-lg($danger);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($danger);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($danger);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($danger);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($danger);\n\t}\n}\n.shadow-hover-lg-danger {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($danger);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($danger);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($danger);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($danger);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($danger);\n\t\t}\n\t}\t\n}\n.shadow-xl-danger {\n\t@include boxshadow-xl($danger);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($danger);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($danger);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($danger);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($danger);\n\t}\n}\n.shadow-hover-xl-danger {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($danger);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($danger);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($danger);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($danger);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($danger);\n\t\t}\n\t}\t\n}\n.shadow-sm-blue {\n\t@include boxshadow-sm($blue);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($blue);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($blue);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($blue);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($blue);\n\t}\n}\n.shadow-hover-sm-blue {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($blue);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($blue);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($blue);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($blue);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($blue);\n\t\t}\n\t}\t\n}\n.shadow-blue {\n\t@include boxshadow($blue);\n\t&.shadow-top {\n\t\t@include boxshadow-top($blue);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($blue);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($blue);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($blue);\n\t}\n}\n.shadow-hover-blue {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($blue);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($blue);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($blue);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($blue);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($blue);\n\t\t}\n\t}\t\n}\n.shadow-lg-blue {\n\t@include boxshadow-lg($blue);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($blue);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($blue);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($blue);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($blue);\n\t}\n}\n.shadow-hover-lg-blue {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($blue);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($blue);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($blue);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($blue);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($blue);\n\t\t}\n\t}\t\n}\n.shadow-xl-blue {\n\t@include boxshadow-xl($blue);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($blue);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($blue);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($blue);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($blue);\n\t}\n}\n.shadow-hover-xl-blue {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($blue);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($blue);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($blue);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($blue);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($blue);\n\t\t}\n\t}\t\n}\n.shadow-sm-primary {\n\t@include boxshadow-sm($primary);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($primary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($primary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($primary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($primary);\n\t}\n}\n.shadow-hover-sm-primary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($primary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($primary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($primary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($primary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($primary);\n\t\t}\n\t}\t\n}\n.shadow-primary {\n\t@include boxshadow($primary);\n\t&.shadow-top {\n\t\t@include boxshadow-top($primary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($primary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($primary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($primary);\n\t}\n}\n.shadow-hover-primary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($primary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($primary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($primary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($primary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($primary);\n\t\t}\n\t}\t\n}\n.shadow-lg-primary {\n\t@include boxshadow-lg($primary);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($primary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($primary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($primary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($primary);\n\t}\n}\n.shadow-hover-lg-primary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($primary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($primary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($primary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($primary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($primary);\n\t\t}\n\t}\t\n}\n.shadow-xl-primary {\n\t@include boxshadow-xl($primary);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($primary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($primary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($primary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($primary);\n\t}\n}\n.shadow-hover-xl-primary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($primary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($primary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($primary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($primary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($primary);\n\t\t}\n\t}\t\n}\n.shadow-sm-pink {\n\t@include boxshadow-sm($pink);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($pink);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($pink);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($pink);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($pink);\n\t}\n}\n.shadow-hover-sm-pink {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($pink);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($pink);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($pink);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($pink);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($pink);\n\t\t}\n\t}\t\n}\n.shadow-pink {\n\t@include boxshadow($pink);\n\t&.shadow-top {\n\t\t@include boxshadow-top($pink);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($pink);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($pink);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($pink);\n\t}\n}\n.shadow-hover-pink {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($pink);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($pink);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($pink);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($pink);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($pink);\n\t\t}\n\t}\t\n}\n.shadow-lg-pink {\n\t@include boxshadow-lg($pink);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($pink);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($pink);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($pink);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($pink);\n\t}\n}\n.shadow-hover-lg-pink {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($pink);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($pink);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($pink);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($pink);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($pink);\n\t\t}\n\t}\t\n}\n.shadow-xl-pink {\n\t@include boxshadow-xl($pink);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($pink);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($pink);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($pink);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($pink);\n\t}\n}\n.shadow-hover-xl-pink {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($pink);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($pink);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($pink);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($pink);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($pink);\n\t\t}\n\t}\t\n}\n.shadow-sm-purple {\n\t@include boxshadow-sm($purple);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($purple);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($purple);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($purple);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($purple);\n\t}\n}\n.shadow-hover-sm-purple {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($purple);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($purple);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($purple);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($purple);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($purple);\n\t\t}\n\t}\t\n}\n.shadow-purple {\n\t@include boxshadow($purple);\n\t&.shadow-top {\n\t\t@include boxshadow-top($purple);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($purple);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($purple);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($purple);\n\t}\n}\n.shadow-hover-purple {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($purple);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($purple);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($purple);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($purple);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($purple);\n\t\t}\n\t}\t\n}\n.shadow-lg-purple {\n\t@include boxshadow-lg($purple);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($purple);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($purple);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($purple);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($purple);\n\t}\n}\n.shadow-hover-lg-purple {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($purple);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($purple);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($purple);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($purple);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($purple);\n\t\t}\n\t}\t\n}\n.shadow-xl-purple {\n\t@include boxshadow-xl($purple);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($purple);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($purple);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($purple);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($purple);\n\t}\n}\n.shadow-hover-xl-purple {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($purple);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($purple);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($purple);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($purple);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($purple);\n\t\t}\n\t}\t\n}\n.shadow-sm-violet {\n\t@include boxshadow-sm($violet);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($violet);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($violet);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($violet);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($violet);\n\t}\n}\n.shadow-hover-sm-violet {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($violet);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($violet);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($violet);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($violet);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($violet);\n\t\t}\n\t}\t\n}\n.shadow-violet {\n\t@include boxshadow($violet);\n\t&.shadow-top {\n\t\t@include boxshadow-top($violet);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($violet);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($violet);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($violet);\n\t}\n}\n.shadow-hover-violet {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($violet);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($violet);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($violet);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($violet);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($violet);\n\t\t}\n\t}\t\n}\n.shadow-lg-violet {\n\t@include boxshadow-lg($violet);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($violet);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($violet);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($violet);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($violet);\n\t}\n}\n.shadow-hover-lg-violet {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($violet);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($violet);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($violet);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($violet);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($violet);\n\t\t}\n\t}\t\n}\n.shadow-xl-violet {\n\t@include boxshadow-xl($violet);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($violet);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($violet);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($violet);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($violet);\n\t}\n}\n.shadow-hover-xl-violet {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($violet);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($violet);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($violet);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($violet);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($violet);\n\t\t}\n\t}\t\n}\n.shadow-sm-indigo {\n\t@include boxshadow-sm($indigo);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($indigo);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($indigo);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($indigo);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($indigo);\n\t}\n}\n.shadow-hover-sm-indigo {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($indigo);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($indigo);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($indigo);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($indigo);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($indigo);\n\t\t}\n\t}\t\n}\n.shadow-indigo {\n\t@include boxshadow($indigo);\n\t&.shadow-top {\n\t\t@include boxshadow-top($indigo);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($indigo);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($indigo);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($indigo);\n\t}\n}\n.shadow-hover-indigo {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($indigo);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($indigo);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($indigo);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($indigo);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($indigo);\n\t\t}\n\t}\t\n}\n.shadow-lg-indigo {\n\t@include boxshadow-lg($indigo);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($indigo);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($indigo);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($indigo);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($indigo);\n\t}\n}\n.shadow-hover-lg-indigo {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($indigo);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($indigo);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($indigo);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($indigo);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($indigo);\n\t\t}\n\t}\t\n}\n.shadow-xl-indigo {\n\t@include boxshadow-xl($indigo);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($indigo);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($indigo);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($indigo);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($indigo);\n\t}\n}\n.shadow-hover-xl-indigo {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($indigo);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($indigo);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($indigo);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($indigo);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($indigo);\n\t\t}\n\t}\t\n}\n.shadow-sm-teal {\n\t@include boxshadow-sm($teal);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($teal);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($teal);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($teal);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($teal);\n\t}\n}\n.shadow-hover-sm-teal {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($teal);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($teal);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($teal);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($teal);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($teal);\n\t\t}\n\t}\t\n}\n.shadow-teal {\n\t@include boxshadow($teal);\n\t&.shadow-top {\n\t\t@include boxshadow-top($teal);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($teal);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($teal);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($teal);\n\t}\n}\n.shadow-hover-teal {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($teal);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($teal);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($teal);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($teal);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($teal);\n\t\t}\n\t}\t\n}\n.shadow-lg-teal {\n\t@include boxshadow-lg($teal);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($teal);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($teal);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($teal);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($teal);\n\t}\n}\n.shadow-hover-lg-teal {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($teal);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($teal);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($teal);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($teal);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($teal);\n\t\t}\n\t}\t\n}\n.shadow-xl-teal {\n\t@include boxshadow-xl($teal);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($teal);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($teal);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($teal);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($teal);\n\t}\n}\n.shadow-hover-xl-teal {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($teal);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($teal);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($teal);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($teal);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($teal);\n\t\t}\n\t}\t\n}\n.shadow-sm-neon {\n\t@include boxshadow-sm($neon);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($neon);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($neon);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($neon);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($neon);\n\t}\n}\n.shadow-hover-sm-neon {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($neon);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($neon);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($neon);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($neon);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($neon);\n\t\t}\n\t}\t\n}\n.shadow-neon {\n\t@include boxshadow($neon);\n\t&.shadow-top {\n\t\t@include boxshadow-top($neon);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($neon);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($neon);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($neon);\n\t}\n}\n.shadow-hover-neon {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($neon);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($neon);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($neon);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($neon);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($neon);\n\t\t}\n\t}\t\n}\n.shadow-lg-neon {\n\t@include boxshadow-lg($neon);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($neon);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($neon);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($neon);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($neon);\n\t}\n}\n.shadow-hover-lg-neon {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($neon);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($neon);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($neon);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($neon);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($neon);\n\t\t}\n\t}\t\n}\n.shadow-xl-neon {\n\t@include boxshadow-xl($neon);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($neon);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($neon);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($neon);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($neon);\n\t}\n}\n.shadow-hover-xl-neon {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($neon);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($neon);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($neon);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($neon);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($neon);\n\t\t}\n\t}\t\n}\n.shadow-sm-lime {\n\t@include boxshadow-sm($lime);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($lime);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($lime);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($lime);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($lime);\n\t}\n}\n.shadow-hover-sm-lime {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($lime);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($lime);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($lime);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($lime);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($lime);\n\t\t}\n\t}\t\n}\n.shadow-lime {\n\t@include boxshadow($lime);\n\t&.shadow-top {\n\t\t@include boxshadow-top($lime);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($lime);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($lime);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($lime);\n\t}\n}\n.shadow-hover-lime {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($lime);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($lime);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($lime);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($lime);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($lime);\n\t\t}\n\t}\t\n}\n.shadow-lg-lime {\n\t@include boxshadow-lg($lime);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($lime);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($lime);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($lime);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($lime);\n\t}\n}\n.shadow-hover-lg-lime {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($lime);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($lime);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($lime);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($lime);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($lime);\n\t\t}\n\t}\t\n}\n.shadow-xl-lime {\n\t@include boxshadow-xl($lime);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($lime);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($lime);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($lime);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($lime);\n\t}\n}\n.shadow-hover-xl-lime {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($lime);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($lime);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($lime);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($lime);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($lime);\n\t\t}\n\t}\t\n}\n.shadow-sm-sun {\n\t@include boxshadow-sm($sun);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($sun);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($sun);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($sun);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($sun);\n\t}\n}\n.shadow-hover-sm-sun {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($sun);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($sun);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($sun);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($sun);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($sun);\n\t\t}\n\t}\t\n}\n.shadow-sun {\n\t@include boxshadow($sun);\n\t&.shadow-top {\n\t\t@include boxshadow-top($sun);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($sun);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($sun);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($sun);\n\t}\n}\n.shadow-hover-sun {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($sun);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($sun);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($sun);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($sun);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($sun);\n\t\t}\n\t}\t\n}\n.shadow-lg-sun {\n\t@include boxshadow-lg($sun);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($sun);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($sun);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($sun);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($sun);\n\t}\n}\n.shadow-hover-lg-sun {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($sun);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($sun);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($sun);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($sun);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($sun);\n\t\t}\n\t}\t\n}\n.shadow-xl-sun {\n\t@include boxshadow-xl($sun);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($sun);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($sun);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($sun);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($sun);\n\t}\n}\n.shadow-hover-xl-sun {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($sun);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($sun);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($sun);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($sun);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($sun);\n\t\t}\n\t}\t\n}\n.shadow-sm-orange {\n\t@include boxshadow-sm($orange);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($orange);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($orange);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($orange);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($orange);\n\t}\n}\n.shadow-hover-sm-orange {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($orange);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($orange);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($orange);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($orange);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($orange);\n\t\t}\n\t}\t\n}\n.shadow-orange {\n\t@include boxshadow($orange);\n\t&.shadow-top {\n\t\t@include boxshadow-top($orange);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($orange);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($orange);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($orange);\n\t}\n}\n.shadow-hover-orange {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($orange);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($orange);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($orange);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($orange);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($orange);\n\t\t}\n\t}\t\n}\n.shadow-lg-orange {\n\t@include boxshadow-lg($orange);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($orange);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($orange);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($orange);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($orange);\n\t}\n}\n.shadow-hover-lg-orange {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($orange);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($orange);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($orange);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($orange);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($orange);\n\t\t}\n\t}\t\n}\n.shadow-xl-orange {\n\t@include boxshadow-xl($orange);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($orange);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($orange);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($orange);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($orange);\n\t}\n}\n.shadow-hover-xl-orange {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($orange);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($orange);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($orange);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($orange);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($orange);\n\t\t}\n\t}\t\n}\n.shadow-sm-pumpkin {\n\t@include boxshadow-sm($pumpkin);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($pumpkin);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($pumpkin);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($pumpkin);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($pumpkin);\n\t}\n}\n.shadow-hover-sm-pumpkin {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($pumpkin);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($pumpkin);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($pumpkin);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($pumpkin);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($pumpkin);\n\t\t}\n\t}\t\n}\n.shadow-pumpkin {\n\t@include boxshadow($pumpkin);\n\t&.shadow-top {\n\t\t@include boxshadow-top($pumpkin);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($pumpkin);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($pumpkin);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($pumpkin);\n\t}\n}\n.shadow-hover-pumpkin {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($pumpkin);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($pumpkin);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($pumpkin);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($pumpkin);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($pumpkin);\n\t\t}\n\t}\t\n}\n.shadow-lg-pumpkin {\n\t@include boxshadow-lg($pumpkin);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($pumpkin);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($pumpkin);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($pumpkin);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($pumpkin);\n\t}\n}\n.shadow-hover-lg-pumpkin {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($pumpkin);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($pumpkin);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($pumpkin);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($pumpkin);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($pumpkin);\n\t\t}\n\t}\t\n}\n.shadow-xl-pumpkin {\n\t@include boxshadow-xl($pumpkin);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($pumpkin);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($pumpkin);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($pumpkin);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($pumpkin);\n\t}\n}\n.shadow-hover-xl-pumpkin {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($pumpkin);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($pumpkin);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($pumpkin);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($pumpkin);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($pumpkin);\n\t\t}\n\t}\t\n}\n.shadow-sm-brown {\n\t@include boxshadow-sm($brown);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($brown);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($brown);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($brown);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($brown);\n\t}\n}\n.shadow-hover-sm-brown {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($brown);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($brown);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($brown);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($brown);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($brown);\n\t\t}\n\t}\t\n}\n.shadow-brown {\n\t@include boxshadow($brown);\n\t&.shadow-top {\n\t\t@include boxshadow-top($brown);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($brown);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($brown);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($brown);\n\t}\n}\n.shadow-hover-brown {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($brown);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($brown);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($brown);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($brown);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($brown);\n\t\t}\n\t}\t\n}\n.shadow-lg-brown {\n\t@include boxshadow-lg($brown);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($brown);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($brown);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($brown);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($brown);\n\t}\n}\n.shadow-hover-lg-brown {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($brown);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($brown);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($brown);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($brown);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($brown);\n\t\t}\n\t}\t\n}\n.shadow-xl-brown {\n\t@include boxshadow-xl($brown);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($brown);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($brown);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($brown);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($brown);\n\t}\n}\n.shadow-hover-xl-brown {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($brown);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($brown);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($brown);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($brown);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($brown);\n\t\t}\n\t}\t\n}\n.shadow-sm-gold {\n\t@include boxshadow-sm($gold);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($gold);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($gold);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($gold);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($gold);\n\t}\n}\n.shadow-hover-sm-gold {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($gold);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($gold);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($gold);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($gold);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($gold);\n\t\t}\n\t}\t\n}\n.shadow-gold {\n\t@include boxshadow($gold);\n\t&.shadow-top {\n\t\t@include boxshadow-top($gold);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($gold);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($gold);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($gold);\n\t}\n}\n.shadow-hover-gold {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($gold);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($gold);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($gold);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($gold);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($gold);\n\t\t}\n\t}\t\n}\n.shadow-lg-gold {\n\t@include boxshadow-lg($gold);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($gold);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($gold);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($gold);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($gold);\n\t}\n}\n.shadow-hover-lg-gold {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($gold);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($gold);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($gold);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($gold);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($gold);\n\t\t}\n\t}\t\n}\n.shadow-xl-gold {\n\t@include boxshadow-xl($gold);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($gold);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($gold);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($gold);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($gold);\n\t}\n}\n.shadow-hover-xl-gold {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($gold);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($gold);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($gold);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($gold);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($gold);\n\t\t}\n\t}\t\n}\n.shadow-sm-smoke {\n\t@include boxshadow-sm($smoke);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($smoke);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($smoke);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($smoke);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($smoke);\n\t}\n}\n.shadow-hover-sm-smoke {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($smoke);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($smoke);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($smoke);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($smoke);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($smoke);\n\t\t}\n\t}\t\n}\n.shadow-smoke {\n\t@include boxshadow($smoke);\n\t&.shadow-top {\n\t\t@include boxshadow-top($smoke);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($smoke);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($smoke);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($smoke);\n\t}\n}\n.shadow-hover-smoke {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($smoke);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($smoke);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($smoke);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($smoke);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($smoke);\n\t\t}\n\t}\t\n}\n.shadow-lg-smoke {\n\t@include boxshadow-lg($smoke);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($smoke);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($smoke);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($smoke);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($smoke);\n\t}\n}\n.shadow-hover-lg-smoke {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($smoke);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($smoke);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($smoke);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($smoke);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($smoke);\n\t\t}\n\t}\t\n}\n.shadow-xl-smoke {\n\t@include boxshadow-xl($smoke);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($smoke);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($smoke);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($smoke);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($smoke);\n\t}\n}\n.shadow-hover-xl-smoke {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($smoke);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($smoke);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($smoke);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($smoke);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($smoke);\n\t\t}\n\t}\t\n}\n.shadow-sm-grey {\n\t@include boxshadow-sm($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($grey);\n\t}\n}\n.shadow-hover-sm-grey {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-grey {\n\t@include boxshadow($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($grey);\n\t}\n}\n.shadow-hover-grey {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-lg-grey {\n\t@include boxshadow-lg($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($grey);\n\t}\n}\n.shadow-hover-lg-grey {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-xl-grey {\n\t@include boxshadow-xl($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($grey);\n\t}\n}\n.shadow-hover-xl-grey {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-sm-secondary {\n\t@include boxshadow-sm($secondary);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($secondary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($secondary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($secondary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($secondary);\n\t}\n}\n.shadow-hover-sm-secondary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($secondary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($secondary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($secondary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($secondary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($secondary);\n\t\t}\n\t}\t\n}\n.shadow-secondary {\n\t@include boxshadow($secondary);\n\t&.shadow-top {\n\t\t@include boxshadow-top($secondary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($secondary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($secondary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($secondary);\n\t}\n}\n.shadow-hover-secondary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($secondary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($secondary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($secondary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($secondary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($secondary);\n\t\t}\n\t}\t\n}\n.shadow-lg-secondary {\n\t@include boxshadow-lg($secondary);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($secondary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($secondary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($secondary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($secondary);\n\t}\n}\n.shadow-hover-lg-secondary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($secondary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($secondary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($secondary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($secondary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($secondary);\n\t\t}\n\t}\t\n}\n.shadow-xl-secondary {\n\t@include boxshadow-xl($secondary);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($secondary);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($secondary);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($secondary);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($secondary);\n\t}\n}\n.shadow-hover-xl-secondary {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($secondary);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($secondary);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($secondary);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($secondary);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($secondary);\n\t\t}\n\t}\t\n}\n.shadow-sm-light {\n\t@include boxshadow-sm($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($grey);\n\t}\n}\n.shadow-hover-sm-light {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-light {\n\t@include boxshadow($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($grey);\n\t}\n}\n.shadow-hover-light {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-lg-light {\n\t@include boxshadow-lg($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($grey);\n\t}\n}\n.shadow-hover-lg-light {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-xl-light {\n\t@include boxshadow-xl($grey);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($grey);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($grey);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($grey);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($grey);\n\t}\n}\n.shadow-hover-xl-light {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($grey);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($grey);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($grey);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($grey);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($grey);\n\t\t}\n\t}\t\n}\n.shadow-sm-dark {\n\t@include boxshadow-sm($black);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($black);\n\t}\n}\n.shadow-hover-sm-dark {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($black);\n\t\t}\n\t}\t\n}\n.shadow-dark {\n\t@include boxshadow($black);\n\t&.shadow-top {\n\t\t@include boxshadow-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($black);\n\t}\n}\n.shadow-hover-dark {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($black);\n\t\t}\n\t}\t\n}\n.shadow-lg-dark {\n\t@include boxshadow-lg($black);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($black);\n\t}\n}\n.shadow-hover-lg-dark {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($black);\n\t\t}\n\t}\t\n}\n.shadow-xl-dark {\n\t@include boxshadow-xl($black);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($black);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($black);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($black);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($black);\n\t}\n}\n.shadow-hover-xl-dark {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($black);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($black);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($black);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($black);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($black);\n\t\t}\n\t}\t\n}\n.shadow-sm-white {\n\t@include boxshadow-sm($white);\n\t&.shadow-top {\n\t\t@include boxshadow-sm-top($white);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-sm-bottom($white);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-sm-left($white);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-sm-right($white);\n\t}\n}\n.shadow-hover-sm-white {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-sm($white);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-sm-top($white);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-sm-bottom($white);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-sm-left($white);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-sm-right($white);\n\t\t}\n\t}\t\n}\n.shadow-white {\n\t@include boxshadow($white);\n\t&.shadow-top {\n\t\t@include boxshadow-top($white);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-bottom($white);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-left($white);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-right($white);\n\t}\n}\n.shadow-hover-white {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow($white);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-top($white);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-bottom($white);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-left($white);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-right($white);\n\t\t}\n\t}\t\n}\n.shadow-lg-white {\n\t@include boxshadow-lg($white);\n\t&.shadow-top {\n\t\t@include boxshadow-lg-top($white);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-lg-bottom($white);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-lg-left($white);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-lg-right($white);\n\t}\n}\n.shadow-hover-lg-white {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-lg($white);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-lg-top($white);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-lg-bottom($white);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-lg-left($white);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-lg-right($white);\n\t\t}\n\t}\t\n}\n.shadow-xl-white {\n\t@include boxshadow-xl($white);\n\t&.shadow-top {\n\t\t@include boxshadow-xl-top($white);\n\t}\n\t&.shadow-bottom {\n\t\t@include boxshadow-xl-bottom($white);\n\t}\n\t&.shadow-left {\n\t\t@include boxshadow-xl-left($white);\n\t}\n\t&.shadow-right {\n\t\t@include boxshadow-xl-right($white);\n\t}\n}\n.shadow-hover-xl-white {\n\t@include transition(box-shadow .3s ease);\n\t&:hover {\n\t\t@include boxshadow-xl($white);\n\t\t&.shadow-top {\n\t\t\t@include boxshadow-xl-top($white);\n\t\t}\n\t\t&.shadow-bottom {\n\t\t\t@include boxshadow-xl-bottom($white);\n\t\t}\n\t\t&.shadow-left {\n\t\t\t@include boxshadow-xl-left($white);\n\t\t}\n\t\t&.shadow-right {\n\t\t\t@include boxshadow-xl-right($white);\n\t\t}\n\t}\t\n}\n/*Font Size*/\n.fs-7 {\n\tfont-size:0.875rem!important;\n}\n.fs-8 {\n\tfont-size:0.75rem!important;\n}\n$num: 1;\n$num1: 0.5;\n@while $num < 11 {\n    .font-#{$num} {\n        font-size: $num1 + 0rem!important;\n    }\n\t$num: $num +1;\n\t$num1: $num1 +0.25;\n}\n/*Font Weight*/\n.fw-semibold {\n\tfont-weight:600!important;\n}\n.fw-medium {\n\tfont-weight:500!important;\n}\n/*Text Case*/\n.text-nonecase {\n\ttext-transform:none !important;\n}\n/*Letter Spacing*/\n$num: 0;\n$num1: 0;\n@while $num < 5 {\n    .ls-#{$num} {\n        letter-spacing: $num1 +0px!important;\n    }\n\t$num: $num +1;\n\t$num1: $num1 +0.25;\n}\n\n$num: 1;\n$num1: 0;\n@while $num < 5 {\n    .ls-n-#{$num} {\n        letter-spacing: -($num1 +0.25px)!important;\n    }\n\t$num: $num + 1;\n\t$num1: $num1 + 0.25;\n}\n\n/*Line Height*/\n.lh-0 {\n\tline-height:0!important;\n}\n/*Width*/\n.w-0 {\n\twidth:0!important;\n}\n$num: 25;\n@while $num < 801 {\n    .w-#{$num}p {\n        width: $num +0px!important;\n    }\n\t$num: $num +5;\n}\n@media (min-width: 576px) { \n\t$num: 25;\n\t@while $num < 801 {\n\t\t.w-sm-#{$num}p {\n\t\t\twidth: $num +0px!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 768px) { \n\t$num: 25;\n\t@while $num < 801 {\t\n\t\t.w-md-#{$num}p {\n\t\t\twidth: $num +0px!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 992px) { \n\t$num: 25;\n\t@while $num < 801 {\t\n\t\t.w-lg-#{$num}p {\n\t\t\twidth: $num +0px!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 1200px) { \n\t$num: 25;\n\t@while $num < 801 {\t\n\t\t.w-xl-#{$num}p {\n\t\t\twidth: $num +0px!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 1400px) { \n\t$num: 25;\n\t@while $num < 801 {\t\n\t\t.w-xxl-#{$num}p {\n\t\t\twidth: $num +0px!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n/*Width In Percentage*/\n$num: 5;\n@while $num < 101 {\t\n\t.w-#{$num} {\n        width: $num +0%!important;\n    }\n    $num: $num +5;\n}\n@media (min-width: 576px) { \n\t$num: 5;\n\t@while $num < 101 {\t\n\t\t.w-sm-#{$num} {\n\t\t\twidth: $num +0%!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 768px) { \n\t$num: 5;\n\t@while $num < 101 {\t\n\t\t.w-md-#{$num} {\n\t\t\twidth: $num +0%!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 992px) { \n\t$num: 5;\n\t@while $num < 101 {\t\n\t\t.w-lg-#{$num} {\n\t\t\twidth: $num +0%!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 1200px) { \n\t$num: 5;\n\t@while $num < 101 {\t\n\t\t.w-xl-#{$num} {\n\t\t\twidth: $num +0%!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n@media (min-width: 1400px) { \n\t$num: 5;\n\t@while $num < 101 {\t\n\t\t.w-xxl-#{$num} {\n\t\t\twidth: $num +0%!important;\n\t\t}\n\t\t$num: $num +5;\n\t}\n}\n/*Max Width*/\n$num: 25;\n@while $num < 801 {\n    .mw-#{$num}p {\n        max-width: $num +0px!important;\n    }\n\t$num: $num +25;\n}\n\n/*Min Width*/\n.mnw-0 {\n\tmin-width:0!important;\n}\n$num: 25;\n@while $num < 801 {\n    .mnw-#{$num}p {\n        min-width: $num +0px!important;\n    }\n\t$num: $num +25;\n}\n\n/*Height*/\n.h-0 {\n\theight:0!important;\n}\n$num: 25;\n@while $num < 801 {\n    .h-#{$num}p {\n        height: $num +0px !important;\n    }\n    $num: $num +5;\n}\n/*Height In Percentage*/\n$num: 25;\n@while $num < 101 {\n    .h-#{$num} {\n        height: $num +0% !important;\n    }\n    $num: $num +5;\n}\n\n/*Max Height*/\n$num: 100;\n@while $num < 801 {\n    .mh-#{$num}p {\n        max-height: $num +0px !important;\n    }\n    $num: $num +25;\n}\n\n/*Min Height*/\n$num: 100;\n.mnh-0 {\n\tmin-height:0 !important;\n}\n@while $num < 801 {\n    .mnh-#{$num}p {\n        min-height: $num +0px !important;\n    }\n    $num: $num +25;\n}\n.mnh-100vh {\n\tmin-height:100vh !important;\n}\n/*Hr*/\nhr {\n\tbackground: $grey_light_4;\n\t&.hr-2 {\n\t\theight: 2px!important;\n\t}\n\t&.hr-3 {\n\t\theight: 3px!important;\n\t}\n}\n\n/*opacity*/\n$num0: 10;\n$num1: 0.1;\n@while $num0 < 101 {\n    .opacity-#{$num0} {\n        opacity: $num1 +0 !important;\n    }\n    $num0: $num0 +5;\n    $num1: $num1 +0.05;\n}\n.bg-opacity-85 {\n    --bs-bg-opacity: 0.85;\n}\n/*Div Sizes*/\n$num: 1;\n$num1: 0.25;\n@while $num < 7 {\n    .d-#{$num} {\n        height: $num1 +0.25rem !important;\n        width: $num1 +0.25rem !important;\n    }\n    $num1: $num1 +0.25rem;\n    $num: $num +1;\n}\n$num: 7;\n$num1: 1.5;\n@while $num < 16 {\n    .d-#{$num} {\n        height: $num1 +0.5rem !important;\n        width: $num1 +0.5rem !important;\n    }\n    $num1: $num1 +0.5rem;\n    $num: $num +1;\n}\n$num: 16;\n$num1: 6;\n@while $num < 21 {\n    .d-#{$num} {\n        height: $num1 +1rem !important;\n        width: $num1 +1rem !important;\n    }\n    $num1: $num1 +1rem;\n    $num: $num +1;\n}\n/*Z-Index*/\n$num: 1;\n@while $num < 11 {\n    .z-index-#{$num} {\n        z-index: $num +0 !important;\n    }\n    $num: $num + 1;\n}\n/*Loader*/\n.preloader-it {\n\tbackground: $white;\n\tposition: fixed;\n\tz-index: 10001;\n\theight: 100%;\n\twidth: 100%;\n\toverflow:hidden;\n}\n.loader-pendulums {\n\tposition: relative;\n\ttop: 50%;\n\t@include transform (translateY(-50%));\n\tdisplay: block;\n\tmargin: 0 auto;\n\ttext-rendering: optimizeLegibility;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tfont-size: 4rem;\n\twidth: 1em;\n\theight: 1em;\n\tborder-radius: 50%;\n\tborder: 0.1em solid $grey_light_3;\n\t&:before,&:after {\n\t\tcontent: '';\n\t\twidth: 1em;\n\t\theight: 1em;\n\t\tleft: -.1em;\n\t\ttop: -.1em;\n\t\tpadding: .1em;\n\t\tdisplay: block;\n\t\tborder-radius: 50%;\n\t\tposition: absolute;\n\t\t-webkit-transform-origin: center center;\n\t\ttransform-origin: center center;\n\t\tborder: .1em solid;\n\t\tborder-color: $grey transparent transparent transparent;\n\t\t-webkit-animation: pendulum infinite 2s cubic-bezier(0.3, 1.65, 0.7, -0.65);\n\t\tanimation: pendulum infinite 2s cubic-bezier(0.3, 1.65, 0.7, -0.65);\n\t}\n\t&:before {\n\t\tborder-color: $black_2 transparent transparent transparent;\n\t\t-webkit-animation-delay: -1s;\n\t\tanimation-delay: -1s;\n\t\t-webkit-animation-name: pendulum2;\n\t\tanimation-name: pendulum2;\n\t}\n}\n\n@-webkit-keyframes pendulum {\n\tfrom {\n\t\t@include transform(rotate(0deg));\n\t}\n\tto {\n\t\t@include transform(rotate(359deg));\n\t}\n}\n\n@keyframes pendulum {\n\tfrom {\n\t\t@include transform(rotate(0deg));\n\t}\n\tto {\n\t\t@include transform(rotate(359deg));\n\t}\n}\n@-webkit-keyframes pendulum2 {\n\tfrom {\n\t\t@include transform(rotate(180deg));\n\t}\n\tto {\n\t\t@include transform(rotate(520deg));\n\t}\n}\n@keyframes pendulum2 {\n\tfrom {\n\t\t@include transform(rotate(180deg));\n\t}\n\tto {\n\t\t@include transform(rotate(520deg));\n\t}\n}\n/*Scrollbar*/\n.slimScrollBar {\n\tright:0!important;\n}\n.nicescroll-rails.nicescroll-rails-vr {\n    z-index: 999 !important;\n}\n.simplebar-placeholder { \n\twidth: auto!important; \n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-scroll-content::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n\twidth: 0;\n\theight: 0;\n\tdisplay: none;\n}\n\n.simplebar-scrollbar {\n\t&:before {\n\t\tbackground:#d6d9da;\n\t}\n\t&.simplebar-visible:before {\n\t\topacity:.8;\n\t}\n}\n.simplebar-content:after, \n.simplebar-content:before {\n   clear: both;\n}\n.nicescroll-bar {\n\theight: 100%;\n\twidth: 100%;\n}\n.ps__thumb-y,\n.ps__thumb-x {\n\tborder-radius:0;\n\tbackground:#d6d9da;\n}\t\n\n.ps__thumb-x,\n.ps__rail-x {\n\theight: 6px;\n}\t\n.ps__thumb-y,\n.ps__rail-y {\n\twidth: 6px;\n}\n\n.ps__rail-x,\n.ps__rail-y {\n\tbackground:transparent;\n}\n.ps__rail-x:hover > .ps__thumb-x, \n.ps__rail-x:focus > .ps__thumb-x, \n.ps__rail-x.ps--clicking .ps__thumb-x {\n\tborder-radius:0;\n\theight: 6px;\n\tbackground:#d6d9da;\n}\n.ps__rail-y:hover > .ps__thumb-y, \n.ps__rail-y:focus > .ps__thumb-y, \n.ps__rail-y.ps--clicking .ps__thumb-y {\n\tborder-radius:0;\n\twidth: 6px;\n\tbackground:#d6d9da;\n}\n.ps {\n\t.ps__rail-x:hover,\n\t.ps__rail-y:hover, \n\t.ps__rail-x:focus, \n\t.ps__rail-y:focus, \n\t.ps__rail-x.ps--clicking, \n\t.ps__rail-y.ps--clicking {\n\t\tbackground-color: transparent;\n\t\topacity: 1;\n\t\t\n\t}\n}\n.ps:hover > \n.ps__rail-x, \n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x, \n.ps--focus > .ps__rail-y, \n.ps--scrolling-x > .ps__rail-x, \n.ps--scrolling-y > .ps__rail-y {\n\topacity:1;\n}\n/*Separator*/\n.separator{\n\tpadding:1px 0;\n\tmargin:1.25rem 0;\n\t&:after {\n\t\tcontent:\"\";\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tborder-bottom: 1px solid $grey_light_4;\n\t}\n}\n.separator-full{\n\tpadding:1px 0;\n\tmargin:1.25rem 0;\n\t\t&:after {\n\t\tcontent:\"\";\n\t\tdisplay: block;\n\t\tposition:absolute;\n\t\theight: 1px;\n\t\twidth: 100%;\n\t\tleft:0;\n\t\tborder-bottom: 1px solid $grey_light_4;\n\t}\n}\n.v-separator-full {\n\tmargin:0 1rem;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t&:after {\n\t\tcontent:\"\";\n\t\tposition: absolute;\n\t\ttop:0;\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tborder-right: 1px solid $grey_light_4;\n\t}\n}\n.v-separator {\n\tmargin:0 1rem;\n\t&:after {\n\t\tcontent:\"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\theight: calc(100% - 30px);\n\t\tborder-right: 1px solid $grey_light_3;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tmargin: auto;\n\t}\n}\n.separator-light {\n\t&:after {\n\t\tborder-color: $grey_light_5;\n\t}\n}\n\n/*Typography*/\np {\n\t&.p-xl {\n\t\tfont-size:1.25rem;\n\t}\n\t&.p-lg {\n\t\tfont-size:1.125rem;\n\t}\n\t&.p-sm {\n\t\tfont-size:0.875rem;\n\t}\n\t&.p-xs {\n\t\tfont-size:0.75rem;\n\t}\n}\n.title,\n.title-lg,\n.title-sm,\n.title-xs {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: .5rem;\n\t.title-icon {\n\t\tmargin-right: .5rem;\n\t\tdisplay: inline-flex;\n\t\ti{\n\t\t\tline-height: 0;\n\t\t}\n\t}\n\t&.title-wth-divider {\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\t>span {\n\t\t\tdisplay: flex;\n\t\t\twhite-space: nowrap;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t}\n\t\t&::before {\n\t\t\tcontent:\"\";\n\t\t\tdisplay: block;\n\t\t\theight: 1px;\n\t\t\twidth: 0;\n\t\t\tbackground: $grey_light_3;\n\t\t}\n\t\t&::after {\n\t\t\tcontent:\"\";\n\t\t\tdisplay: block;\n\t\t\theight: 1px;\n\t\t\twidth: 100%;\n\t\t\tmargin-left:.625rem;\n\t\t\tbackground: $grey_light_3;\n\t\t}\n\t\t&.divider-right {\n\t\t\t&::before {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-right:.625rem;\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\twidth: 0;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t\t&.divider-center {\n\t\t\t&::before {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-right:.625rem;\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-left:.625rem;\n\t\t\t}\n\t\t}\n\t}\n}\n.title {\n\tfont-size:1rem;\n\tcolor:$black_2;\n\tfont-weight:500;\n\t.title-icon {\n\t\tfont-size:1.5rem;\n\t}\n}\n.title-lg {\n\tfont-size:1.125rem;\n\tcolor:$black_2;\n\tfont-weight:500;\n\t.title-icon {\n\t\tfont-size:1.75rem;\n\t}\n}\n.title-sm  {\n\tfont-size:0.875rem;\n\tcolor:$black_2;\n\tfont-weight:500;\n\t.title-icon {\n\t\tfont-size:1.25rem;\n\t}\n}\n\n.title-xs  {\n\tfont-size:0.75rem;\n\tcolor:$black_2;\n\tfont-weight:500;\n\t.title-icon {\n\t\tfont-size:1rem;\n\t}\n}\n.small, small {\n    font-size: 80%;\n    font-weight: 400;\n}\n.hidden-element {\n\tdisplay:none!important;\n}\ncode {\n\tmargin:0 .25rem;\t\n\tcolor: $primary;\n}\n.strikethrough {\n\ts,del {\n\t\tposition:relative;\n\t\ttext-decoration:none;\n\t\t&:after {\n\t\t\tcontent:\"\";\n\t\t\theight: 12px;\n\t\t\tbackground: $primary;\n\t\t\tmix-blend-mode: multiply;\n\t\t\topacity: .3;\n\t\t\twidth: 100%;\n\t\t\tposition: absolute;\n\t\t\tmargin-left: 0;\n\t\t\ttop: 5px;\n\t\t\tleft:0;\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\tdel:after {\n\t\tbackground:$red;\n\t}\n}\n.mark, mark {\n\tpadding:0;\t\n\tbackground: none;\t\n\tcolor: $black_2;\t\n\tposition: relative;\n\t&:after {\n\t\tcontent:\"\";\n\t\theight: 12px;\n\t\tbackground: $orange;\n\t\tmix-blend-mode: multiply;\n\t\topacity: .3;\n\t\twidth: 100%;\n\t\tposition: absolute;\n\t\tmargin-left: 0;\n\t\ttop: 5px;\n\t\tleft:0;\n\t\tpointer-events: none;\n\t}\n}\n.display-1,\n.display-2,\n.display-3,\n.display-4,\n.display-5,\n.display-6 {\n\tcolor:$black_2;\n}\n\n.hk-dragger {\n\tfont-size:2rem;\n\tcursor:grab;\n\tcolor:$grey;\n\tmargin-right:.625rem;\n}\n/*Buttons*/\n.btn {\n\ttext-transform:capitalize;\n\toutline:none;\n\tfont-size: 1rem;\n\tpadding: .375rem  1rem;\n\tborder-width:1px;\n\tborder-radius: 0.375rem;\n\t&:focus,&:active,&:hover {\n\t\tbox-shadow:none;\n\t}\n\t/*Buttons with Icon*/\n\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\t.icon {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-right:.75rem;\n\t\t\t}\n\t\t\t&:not(:first-child) {\n\t\t\t\tmargin-left:.75rem;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-lg {\n\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\t.icon {\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\tmargin-right:1.25rem;\n\t\t\t\t}\n\t\t\t\t&:not(:first-child) {\n\t\t\t\t\tmargin-left:1.25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-sm {\n\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\t.icon {\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\tmargin-right:0.75rem;\n\t\t\t\t}\n\t\t\t\t&:not(:first-child) {\n\t\t\t\t\tmargin-left:0.75rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-xs {\n\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\t.icon {\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\tmargin-right:0.5rem;\n\t\t\t\t}\n\t\t\t\t&:not(:first-child) {\n\t\t\t\t\tmargin-left:0.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t/*HK Custom Buttons*/\n\t&.btn-custom {\n\t\tposition:relative;\n\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\tposition:static;\n\t\t\t.icon {\n\t\t\t\tbackground: rgba(0, 0, 0, 0.08) none repeat scroll 0 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tborder-radius:0.5rem;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom:-1px;\n\t\t\t\twidth:40px;\n\t\t\t\tdisplay: -webkit-inline-box;\n\t\t\t\tdisplay: -ms-inline-flexbox;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t&:not(:last-child) { \n\t\t\t\t\tleft:-1px;\n\t\t\t\t\tmargin:0;\n\t\t\t\t}\n\t\t\t\t&:not(:first-child) {\n\t\t\t\t\tright: -1px;\n\t\t\t\t\tleft: auto;\n\t\t\t\t}\n\t\t\t}\n\t\t\t>span:not(.icon):not(:last-child) {\n\t\t\t\tpadding-right:2.25rem;\n\t\t\t}\n\t\t\t>span:not(.icon):not(:first-child) {\n\t\t\t\tpadding-left:2.25rem;\n\t\t\t}\n\t\t}\n\t\t&.btn-lg {\n\t\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\t\t.icon {\n\t\t\t\t\twidth:46px;\n\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t}\n\t\t\t\t>span:not(.icon):not(:last-child) {\n\t\t\t\t\tpadding-right:2.625rem;\n\t\t\t\t}\n\t\t\t\t>span:not(.icon):not(:first-child) {\n\t\t\t\t\tpadding-left:2.625rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.btn-sm {\n\t\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\t\t.icon {\n\t\t\t\t\twidth:33px;\n\t\t\t\t\tborder-radius:.2rem;\n\t\t\t\t}\n\t\t\t\t>span:not(.icon):not(:last-child) {\n\t\t\t\t\tpadding-right:2rem;\n\t\t\t\t}\n\t\t\t\t>span:not(.icon):not(:first-child) {\n\t\t\t\t\tpadding-left:2rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.btn-xs {\n\t\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\t\t.icon {\n\t\t\t\t\twidth:26px;\n\t\t\t\t\tborder-radius:.2rem;\n\t\t\t\t}\n\t\t\t\t>span:not(.icon):not(:last-child) {\n\t\t\t\t\tpadding-right:1.5rem;\n\t\t\t\t}\n\t\t\t\t>span:not(.icon):not(:first-child) {\n\t\t\t\t\tpadding-left:1.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.btn-square {\n\t\t\t> span:not(.badge):not(.sr-only):not(span[class^=\"spinner\"]) {\n\t\t\t\t.icon {\n\t\t\t\t\tborder-radius: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t/*Buttons Icon*/\n\t&.btn-icon {\n\t\theight:38px;\n\t\twidth:38px;\n\t\tpadding:0;\n\t\t&[class*=\"btn-flush-\"] {\n\t\t\t\tposition:relative;\n\t\t\t\tborder:none;\n\t\t\t\tbackground:transparent!important;\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\theight: 0;\n\t\t\t\t\twidth: 0;\n\t\t\t\t\tbackground:$blue;\n\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t@include transition(all 200ms);\n\t\t\t\t}\n\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t&::before {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t\tleft:0;\n\t\t\t\t\t\theight:100%;\n\t\t\t\t\t\twidth:100%;\n\t\t\t\t\t}\n\t\t\t\t\t.icon {\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.btn-rounded {\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tborder-radius:50%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t&.btn-flush-info {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$info;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$info_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$info;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($info);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.btn-flush-success {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$success;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$success_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$success;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($success);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.btn-flush-warning {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$warning;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$warning_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$warning;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($warning);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.btn-flush-danger {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$danger;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$danger_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$danger;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($danger);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.btn-flush-secondary {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$secondary;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$secondary_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$secondary;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($grey);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.btn-flush-primary {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$primary_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($blue);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.btn-flush-dark {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$black_2;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($black_2);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.btn-flush-light {\n\t\t\t\t&:before {\n\t\t\t\t\tbackground:$grey_dark_3;\n\t\t\t\t}\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($grey_dark_3);\n\t\t\t\t}\n\t\t\t}\n\n\n\t\t}\n\t\t&.btn-lg {\n\t\t\theight:45px;\n\t\t\twidth:45px;\n\t\t\t.btn-icon-wrap {\n\t\t\t\tfont-size: 1.125rem;\n\t\t\t}\n\t\t}\n\t\t&.btn-sm {\n\t\t\theight:31px;\n\t\t\twidth:31px;\n\t\t\t.btn-icon-wrap {\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t}\n\t\t}\n\t\t&.btn-xs {\n\t\t\theight: 28px;\n\t\t\twidth: 28px;\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t\t.btn-icon-wrap {\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*Buttons Options*/\n\t&.btn-rounded {\n\t  border-radius: 50rem!important;\n\t\t.icon { \n\t\t\tborder-radius: 50%!important;\n\t\t}\n\t}\n\t&.btn-square {\n\t\tborder-radius: 0!important;\n\t}\n\t&.btn-uppercase {\n\t\ttext-transform: uppercase!important;\n\t\tfont-weight:600;\n\t}\n\t&.btn-floating {\n\t\tbox-shadow:0 6px 20px rgba(0,0,0,.14)!important;\n\t\tz-index:1001;\n\t}\n\t&.btn-animated {\n\t\t@include transition(all .15s ease);\n\t\t&:hover,&:focus {\n\t\t\t@include transform(translateY(-3px));\n\t\t}\n\t}\n\t.custom-caret {\n\t\tdisplay: inline-block!important;\n\t\tmargin-left: 5px;\n\t}\n}\n.btn-block {\n\tdisplay: block;\n\twidth: 100%\n}\n.btn-block+.btn-block {\n\tmargin-top: .5rem\n}\n\ninput[type=button].btn-block,\ninput[type=reset].btn-block,\ninput[type=submit].btn-block {\n\twidth: 100%\n}\n.btn-icon-dropdown {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n\n/*Button Colors*/\n.btn-info {\n\tcolor:$white;\n\tbackground-color: $info;\n\tborder-color: $info;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $info_dark_1;\n\t\tborder-color: $info_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $info_dark_1;\n\t\tborder-color: $info_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $info_light_3;\n\t\tborder-color: $info_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $info;\n\t\t\tborder-color: $info;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-green {\n\tcolor:$white;\n\tbackground-color: $green;\n\tborder-color: $green;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $green_dark_1;\n\t\tborder-color: $green_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $green_dark_1;\n\t\tborder-color: $green_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $green_light_3;\n\t\tborder-color: $green_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $green;\n\t\t\tborder-color: $green;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-success {\n\tcolor:$white;\n\tbackground-color: $success;\n\tborder-color: $success;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $success_dark_1;\n\t\tborder-color: $success_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $success_dark_1;\n\t\tborder-color: $success_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $success_light_3;\n\t\tborder-color: $success_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $success;\n\t\t\tborder-color: $success;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-warning {\n\tcolor:$white;\n\tbackground-color: $warning;\n\tborder-color: $warning;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $warning_dark_1;\n\t\tborder-color: $warning_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $warning_dark_1;\n\t\tborder-color: $warning_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $warning_light_3;\n\t\tborder-color: $warning_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $warning;\n\t\t\tborder-color: $warning;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-danger {\n\tcolor:$white;\n\tbackground-color: $danger;\n\tborder-color: $danger;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $danger_dark_1;\n\t\tborder-color: $danger_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $danger_dark_1;\n\t\tborder-color: $danger_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $danger_light_3;\n\t\tborder-color: $danger_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $danger;\n\t\t\tborder-color: $danger;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-grey {\n\tcolor:$white;\n\tbackground-color: $grey;\n\tborder-color: $grey;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $grey_dark_1;\n\t\tborder-color: $grey_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $grey_dark_1;\n\t\tborder-color: $grey_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $grey_light_3;\n\t\tborder-color: $grey_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $grey;\n\t\t\tborder-color: $grey;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-secondary {\n\tcolor:$white;\n\tbackground-color: $secondary;\n\tborder-color: $secondary;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary_dark_1;\n\t\tborder-color: $secondary_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary_dark_1;\n\t\tborder-color: $secondary_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary_light_3;\n\t\tborder-color: $secondary_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $secondary;\n\t\t\tborder-color: $secondary;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-primary {\n\tcolor:$white;\n\tbackground-color: $primary;\n\tborder-color: $primary;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $primary_dark_1;\n\t\tborder-color: $primary_dark_1;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $primary_dark_1;\n\t\tborder-color: $primary_dark_1;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $primary_light_3;\n\t\tborder-color: $primary_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $primary;\n\t\t\tborder-color: $primary;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-dark {\n\tcolor:$white;\n\tbackground-color: $black_2;\n\tborder-color: $black_2;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $black_3;\n\t\tborder-color: $black_3;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $black_3;\n\t\tborder-color: $black_3;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $grey;\n\t\tborder-color: $grey;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $black_2;\n\t\t\tborder-color: $black_2;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-default,\n.btn-light {\n\tcolor:$black_2;\n\tbackground-color: $grey_light_4;\n\tborder-color: $grey_light_4;\n\t&:hover,&:focus {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_3;\n\t\tborder-color: $grey_light_3;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$black_2;\n\t\tbackground-color: $grey_light_3;\n\t\tborder-color: $grey_light_3;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_4;\n\t\tborder-color: $grey_light_4;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$grey_dark_3;\n\t\t\tbackground-color: $grey_light_4;\n\t\t\tborder-color: $grey_light_4;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-white {\n\tcolor:$black_2;\n\tbackground-color: $white;\n\tborder-color: $white;\n\t&:hover,&:focus {\n\t\tcolor:$grey_dark_4;\n\t\tbackground-color: $white;\n\t\tborder-color: $white;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$grey_dark_4;\n\t\tbackground-color: $white;\n\t\tborder-color: $white;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$grey_dark_4;\n\t\tbackground-color: $white;\n\t\tborder-color: $white;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$grey_dark_4;\n\t\t\tbackground-color: $white;\n\t\t\tborder-color: $white;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-link {\n\tcolor:$primary;\n\ttext-decoration:none!important;\n\t&:hover,&:focus {\n\t\tcolor:$primary;\n\t}\n}\n.btn:not(:disabled):not(.disabled).active:focus, \n.btn:not(:disabled):not(.disabled):active:focus, \n.show > .btn.dropdown-toggle:focus {\n\tbox-shadow: none;\n}\n.btn-group-vertical > .btn:hover,\n.btn-group > .btn:hover {\n    z-index: 0;\n}\n.show > {\n\t.btn-primary.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $primary_dark_1;\n\t\tborder-color: $primary_dark_1;\n\t}\n\t.btn-secondary.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary_dark_1;\n\t\tborder-color: $secondary_dark_1;\n\t}\n\t.btn-info.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $info_dark_1;\n\t\tborder-color: $info_dark_1;\n\t}\n\t.btn-success.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $success_dark_1;\n\t\tborder-color: $success_dark_1;\n\t}\n\t.btn-warning.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $warning_dark_1;\n\t\tborder-color: $warning_dark_1;\n\t}\n\t.btn-danger.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $danger_dark_1;\n\t\tborder-color: $danger_dark_1;\n\t}\n\t.btn-light.dropdown-toggle {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_4;\n\t\tborder-color: $grey_light_4;\n\t}\n\t.btn-dark.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $black_2;\n\t\tborder-color: $black_2;\n\t}\n\t.btn-outline-primary.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $primary_dark_1;\n\t\tborder-color: $primary_dark_1;\n\t}\n\t.btn-outline-secondary.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary_dark_1;\n\t\tborder-color: $secondary_dark_1;\n\t}\n\t.btn-outline-info.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $info_dark_1;\n\t\tborder-color: $info_dark_1;\n\t}\n\t.btn-outline-success.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $success_dark_1;\n\t\tborder-color: $success_dark_1;\n\t}\n\t.btn-outline-warning.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $warning_dark_1;\n\t\tborder-color: $warning_dark_1;\n\t}\n\t.btn-outline-danger.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $danger_dark_1;\n\t\tborder-color: $danger_dark_1;\n\t}\n\t.btn-outline-light.dropdown-toggle {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_4;\n\t\tborder-color: $grey_light_4;\n\t}\n\t.btn-outline-dark.dropdown-toggle {\n\t\tcolor:$white;\n\t\tbackground-color: $black_1;\n\t\tborder-color: $black_1;\n\t}\n}\n.dropdown {\n\t>.btn-wth-icon {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay:flex;\n\t}\n}\n/*Buttons Soft*/\n.btn-soft-info {\n\tcolor:$info;\n\tbackground-color:$info_light_5;\n\tborder-color:$info_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $info;\n\t\tborder-color: $info;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $info;\n\t\tborder-color: $info;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$info;\n\t\tbackground-color:$info_light_3;\n\t\tborder-color:$info_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$info;\n\t\t\tbackground-color: $info_light_5;\n\t\t\tborder-color: $info_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-soft-success {\n\tcolor:$success;\n\tbackground-color:$success_light_5;\n\tborder-color:$success_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $success;\n\t\tborder-color: $success;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $success;\n\t\tborder-color: $success;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$success;\n\t\tbackground-color:$success_light_3;\n\t\tborder-color:$success_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$success;\n\t\t\tbackground-color: $success_light_5;\n\t\t\tborder-color: $success_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-soft-warning {\n\tcolor:$warning;\n\tbackground-color:$warning_light_5;\n\tborder-color:$warning_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $warning;\n\t\tborder-color: $warning;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $warning;\n\t\tborder-color: $warning;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$warning;\n\t\tbackground-color:$warning_light_3;\n\t\tborder-color:$warning_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$warning;\n\t\t\tbackground-color:$warning_light_5;\n\t\t\tborder-color:$warning_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-soft-danger {\n\tcolor:$danger;\n\tbackground-color:$danger_light_5;\n\tborder-color:$danger_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $danger;\n\t\tborder-color: $danger;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $danger;\n\t\tborder-color: $danger;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$danger;\n\t\tbackground-color:$danger_light_3;\n\t\tborder-color:$danger_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$danger;\n\t\t\tbackground-color:$danger_light_5;\n\t\t\tborder-color:$danger_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-soft-secondary {\n\tcolor:$black_2;\n\tbackground-color:$secondary_light_5;\n\tborder-color:$secondary_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary;\n\t\tborder-color: $secondary;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary;\n\t\tborder-color: $secondary;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$secondary;\n\t\tbackground-color:$secondary_light_3;\n\t\tborder-color:$secondary_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$secondary;\n\t\t\tbackground-color:$secondary_light_5;\n\t\t\tborder-color:$secondary_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-soft-primary {\n\tcolor:$primary;\n\tbackground-color:$primary_light_5;\n\tborder-color:$primary_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$primary;\n\t\tbackground-color:$primary_light_3;\n\t\tborder-color:$primary_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$primary;\n\t\t\tbackground-color:$primary_light_5;\n\t\t\tborder-color:$primary_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-soft-light {\n\tcolor:$grey_dark_3;\n\tbackground-color:$grey_light_5;\n\tborder-color:$grey_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $grey_dark_3;\n\t\tborder-color: $grey_dark_3;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $grey_dark_3;\n\t\tborder-color: $grey_dark_3;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color:$grey_light_5;\n\t\tborder-color:$grey_light_5;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$grey_dark_3;\n\t\t\tbackground-color:$grey_light_5;\n\t\t\tborder-color:$grey_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-soft-dark {\n\tcolor:$black_2;\n\tbackground-color: $grey_light_5;\n\tborder-color: $grey_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $black_2;\n\t\tborder-color: $black_2;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $black_2;\n\t\tborder-color: $black_2;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $grey;\n\t\tborder-color: $grey;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $grey_light_5;\n\t\t\tborder-color: $grey_light_5;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n\n/*Buttons Flush*/\n.btn-flush-info {\n\tcolor:$info;\n\tbackground-color:transparent;\n\tborder-color:transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $info;\n\t\tborder-color: $info;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $info;\n\t\tborder-color: $info;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$info;\n\t\tbackground-color:$info_light_3;\n\t\tborder-color:$info_light_3;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$info;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$info;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$info;\n\t\t\tbackground-color:$info_light_5;\n\t\t\tborder-color:$info_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$info;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-flush-success {\n\tcolor:$success;\n\tbackground-color:transparent;\n\tborder-color:transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $success;\n\t\tborder-color: $success;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $success;\n\t\tborder-color: $success;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$success;\n\t\tbackground-color:$success_light_3;\n\t\tborder-color:$success_light_3;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$success;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$success;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$success;\n\t\t\tbackground-color:$success_light_5;\n\t\t\tborder-color:$success_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$success;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-flush-warning {\n\tcolor:$warning;\n\tbackground-color:transparent;\n\tborder-color:transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $warning;\n\t\tborder-color: $warning;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $warning;\n\t\tborder-color: $warning;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$warning;\n\t\tbackground-color:$warning_light_3;\n\t\tborder-color:$warning_light_3;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$warning;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$warning;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$warning;\n\t\t\tbackground-color:$warning_light_5;\n\t\t\tborder-color:$warning_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$warning;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-flush-danger {\n\tcolor:$danger;\n\tbackground-color:transparent;\n\tborder-color:transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $danger;\n\t\tborder-color: $danger;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $danger;\n\t\tborder-color: $danger;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$danger;\n\t\tbackground-color:$danger_light_3;\n\t\tborder-color:$danger_light_3;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$danger;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$danger;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$danger;\n\t\t\tbackground-color:$danger_light_5;\n\t\t\tborder-color:$danger_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$danger;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-flush-secondary {\n\tcolor:$secondary;\n\tbackground-color:transparent;\n\tborder-color:transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary;\n\t\tborder-color: $secondary;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary;\n\t\tborder-color: $secondary;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$secondary;\n\t\tbackground-color:$secondary_light_3;\n\t\tborder-color:$secondary_light_3;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$secondary;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$secondary;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$secondary;\n\t\t\tbackground-color:$secondary_light_5;\n\t\t\tborder-color:$secondary_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$secondary;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-flush-primary {\n\tcolor:$primary;\n\tbackground-color:transparent;\n\tborder-color:transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$primary;\n\t\tbackground-color:$primary_light_3;\n\t\tborder-color:$primary_light_3;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$primary;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$primary;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$primary;\n\t\t\tbackground-color:$primary_light_5;\n\t\t\tborder-color:$primary_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$primary;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-flush-dark {\n\tcolor:$black_2;\n\tbackground-color: transparent;\n\tborder-color: transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $black_2;\n\t\tborder-color: $black_2;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $black_2;\n\t\tborder-color: $black_2;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $grey;\n\t\tborder-color: $grey;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$black_2;\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$black_2;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$black_2;\n\t\t\tbackground-color: $grey_light_5;\n\t\t\tborder-color: $grey_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$black_2;\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-flush-light {\n\tcolor:$grey_dark_3;\n\tbackground-color: transparent;\n\tborder-color: transparent;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $grey_dark_3;\n\t\tborder-color: $grey_dark_3;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $grey_dark_3;\n\t\tborder-color: $grey_dark_3;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_5;\n\t\tborder-color: $grey_light_5;\n\t}\n\t&.flush-outline-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$grey_dark_3;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $grey_light_4;\n\t\t}\n\t}\n\t&.flush-soft-hover {\n\t\t&:hover,&:focus,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$grey_dark_3;\n\t\t\tbackground-color:$grey_light_5;\n\t\t\tborder-color:$grey_light_5;\n\t\t}\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$grey_dark_3;\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n/*Buttons Gradien*/\n.btn-gradient-primary {\n\tcolor:$white;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$primary,$violet_light_1);\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$primary_dark_1,$violet);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$primary_dark_1,$violet);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$primary_light_3,$violet_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$primary,$violet_light_1);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-gradient-info {\n\tcolor:$white;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$info,$teal);\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$info_dark_1,$teal_dark_1);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$info_dark_1,$teal_dark_1);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$info_light_3,$teal_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$info,$teal);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-gradient-success {\n\tcolor:$white;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$success,$neon);\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$success_dark_1,$neon_dark_1);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$success_dark_1,$neon_dark_1);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$success_light_3,$neon_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$success,$neon);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-gradient-warning {\n\tcolor:$white;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$warning,$sun);\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$warning_dark_1,$sun_dark_1);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$warning_dark_1,$sun_dark_1);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$warning_light_3,$sun_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$warning,$sun);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-gradient-danger {\n\tcolor:$white;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$danger_light_1,$pink);\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$danger,$pink_dark_1);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$danger,$pink_dark_1);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$danger_light_3,$pink_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$danger_light_1,$pink);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-gradient-secondary {\n\tcolor:$white;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$secondary,$grey_light_3);\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$secondary_dark_1,$grey_light_2);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$secondary_dark_1,$grey_light_2);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$secondary_light_3,$grey_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$secondary,$grey_light_3);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-gradient-light {\n\tcolor:$black_2;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$grey_light_1,$grey_light_5);\n\t&:hover,&:focus {\n\t\tcolor:$black_2;\n\t\t@include bg-linear-gradient(45deg,$grey_light_3,$grey_light_4);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$black_2;\n\t\t@include bg-linear-gradient(45deg,$grey_light_3,$grey_light_4);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$black_2;\n\t\t@include bg-linear-gradient(45deg,$grey_light_5,$grey_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$black_2;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$grey_light_1,$grey_light_5);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-gradient-dark {\n\tcolor:$white;\n\tborder:none;\n\t@include bg-linear-gradient(45deg,$black_2,$grey_dark_3);\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$black_3,$grey_dark_5);\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$black_3,$grey_dark_5);\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\t@include bg-linear-gradient(45deg,$black,$grey_light_3);\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,\n\t\t&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\t@include bg-linear-gradient(45deg,$black_2,$grey_dark_3);\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n\n/*Buttons Outline*/\n.btn-outline-info {\n\tcolor:$info;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $info;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $info;\n\t\tborder-color: $info;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $info;\n\t\tborder-color: $info;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $info_light_3;\n\t\tborder-color: $info_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$info;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $info;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-success {\n\tcolor:$success;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $success;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $success;\n\t\tborder-color: $success;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $success;\n\t\tborder-color: $success;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $success_light_3;\n\t\tborder-color: $success_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$success;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $success;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-warning {\n\tcolor:$warning;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $warning;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $warning;\n\t\tborder-color: $warning;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $warning;\n\t\tborder-color: $warning;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $warning_light_3;\n\t\tborder-color: $warning_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$warning;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $warning;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-danger {\n\tcolor:$danger;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $danger;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $danger;\n\t\tborder-color: $danger;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $danger;\n\t\tborder-color: $danger;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $danger_light_3;\n\t\tborder-color: $danger_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$danger;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $danger;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-secondary {\n\tcolor:$secondary;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $secondary;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary;\n\t\tborder-color: $secondary;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary;\n\t\tborder-color: $secondary;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $secondary_light_3;\n\t\tborder-color: $secondary_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$secondary;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $secondary;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-primary {\n\tcolor:$primary;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $primary;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $primary_light_3;\n\t\tborder-color: $primary_light_3;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$primary;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $primary;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-dark {\n\tcolor:$black_2;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $black_2;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: $black_2;\n\t\tborder-color: $black_2;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: $black_2;\n\t\tborder-color: $black_2;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: $grey;\n\t\tborder-color: $grey;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$black_2;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $black_2;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-light {\n\tcolor:$grey_dark_3;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $grey_light_4;\n\t&:hover,&:focus {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_4;\n\t\tborder-color: $grey_light_4;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_4;\n\t\tborder-color: $grey_light_4;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: $grey_light_4;\n\t\tborder-color: $grey_light_4;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$grey_dark_3;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $grey_light_4;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n.btn-outline-white {\n\tcolor:$white;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $white;\n\t&:hover,&:focus {\n\t\tcolor:$white;\n\t\tbackground-color: transparent;\n\t\tborder-color: $white;\n\t}\n\t&:not(:disabled):not(.disabled).active,\n\t&:not(:disabled):not(.disabled):active {\n\t\tcolor:$white;\n\t\tbackground-color: transparent;\n\t\tborder-color: $white;\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$white;\n\t\tbackground-color: transparent;\n\t\tborder-color: $white;\n\t}\n\t&.btn-animated {\n\t\t&:focus,&:active,&:hover,&:not(:disabled):not(.disabled).active,&:not(:disabled):not(.disabled):active {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: transparent;\n\t\t\tbackground-image: none;\n\t\t\tborder-color: $white;\n\t\t\tbox-shadow:0 6px 10px rgba(0,0,0,0.1)!important;\n\t\t}\n\t}\n}\n/*Buttons Check*/\n.btn-check {\n\t&:active,&:checked {\n\t\t& +.btn-info {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $info_dark_1;\n\t\t\tborder-color: $info_dark_1;\n\t\t}\n\t\t& +.btn-success {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $success_dark_1;\n\t\t\tborder-color: $success_dark_1;\n\t\t}\n\t\t& +.btn-warning {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $warning_dark_1;\n\t\t\tborder-color: $warning_dark_1;\n\t\t}\n\t\t& +.btn-danger {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $danger_dark_1;\n\t\t\tborder-color: $danger_dark_1;\n\t\t}\n\t\t& +.btn-secondary {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $secondary_dark_1;\n\t\t\tborder-color: $secondary_dark_1;\n\t\t}\n\t\t& +.btn-primary {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $primary_dark_1;\n\t\t\tborder-color: $primary_dark_1;\n\t\t}\n\t\t& +.btn-dark {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $black_3;\n\t\t\tborder-color: $black_3;\n\t\t}\n\t\t& +.btn-light {\n\t\t\tcolor:$black_2;\n\t\t\tbackground-color: $grey_light_3;\n\t\t\tborder-color: $grey_light_3;\n\t\t}\n\t\t& +.btn-outline-info {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $info;\n\t\t\tborder-color: $info;\n\t\t}\n\t\t& +.btn-outline-success {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $success;\n\t\t\tborder-color: $success;\n\t\t}\n\t\t& +.btn-outline-warning {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $warning;\n\t\t\tborder-color: $warning;\n\t\t}\n\t\t& +.btn-outline-danger {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $danger;\n\t\t\tborder-color: $danger;\n\t\t}\n\t\t& +.btn-outline-secondary {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $secondary;\n\t\t\tborder-color: $secondary;\n\t\t}\n\t\t& +.btn-outline-primary {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $primary;\n\t\t\tborder-color: $primary;\n\t\t}\n\t\t& +.btn-outline-dark {\n\t\t\tcolor:$white;\n\t\t\tbackground-color: $black_2;\n\t\t\tborder-color: $black_2;\n\t\t}\n\t\t& +.btn-outline-light {\n\t\t\tcolor:$grey_dark_3;\n\t\t\tbackground-color: $grey_light_4;\n\t\t\tborder-color: $grey_light_4;\n\t\t}\n\t}\n}\n/*Buttons Group*/\n.btn-group .btn + .btn, .btn-group .btn + .btn-group, .btn-group .btn-group + .btn, .btn-group .btn-group + .btn-group {\n    margin-left: -1px;\n}\n.btn-group-vertical > .btn + .btn, .btn-group-vertical > .btn + .btn-group, .btn-group-vertical > .btn-group + .btn, .btn-group-vertical > .btn-group + .btn-group {\n    margin-top: -1px;\n\t margin-left: 0;\n}\t\n.btn-group-lg > .btn, \n.btn-lg {\n\tfont-size: 1.125rem;\n\tpadding: 0.5rem 1.3rem;\n\tborder-radius: 0.375rem;\n}\n.btn-group-sm > .btn, \n.btn-sm {\n\tfont-size: 0.875rem;\n\tpadding: .25rem .8rem;\n\tborder-radius: 0.375rem;\n}\n.btn-group-xs > .btn, \n.btn-xs {\n\tfont-size: .75rem;\n\tpadding: .25rem .6rem;\n}\n/*Button Social*/\n.btn-social {\n\tcolor:$white;\n\t@include transition(all .15s ease);\n\t&:focus,&:active,&:hover {\n\t\tcolor:$white;\n\t\t@include transform(translateY(-3px));\n\t}\n\t&.btn-social-facebook {\n\t\tbackground-color: $facebook;\n\t\tborder-color: $facebook;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($facebook);\n\t\t}\n\t}\n\t&.btn-social-twitter {\n\t\tbackground-color: $twitter;\n\t\tborder-color: $twitter;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($twitter);\n\t\t}\n\t}\n\t&.btn-social-gplus {\n\t\tbackground-color: $googleplus;\n\t\tborder-color: $googleplus;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($googleplus);\n\t\t}\n\t}\n\t&.btn-social-linkedin {\n\t\tbackground-color:$linkedin;\n\t\tborder-color:$linkedin;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($linkedin);\n\t\t}\n\t}\n\t&.btn-social-instagram {\n\t\tborder-color: transparent;\n\t\t@include bg-linear-gradient(45deg,#f0100f,#b900b3);\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($instagram);\n\t\t\t@include bg-linear-gradient(45deg,#f0100f,#b900b3);\n\t\t}\n\t}\n\t&.btn-social-pinterest {\n\t\tbackground-color: $pinterest;\n\t\tborder-color: $pinterest;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($pinterest);\n\t\t}\n\t}\n\t&.btn-social-dribbble {\n\t\tbackground-color: $dribbble;\n\t\tborder-color: $dribbble;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($dribbble);\n\t\t}\n\t}\n\t&.btn-social-youtube {\n\t\tbackground-color: $youtube;\n\t\tborder-color: $youtube;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($youtube);\n\t\t}\n\t}\n\t&.btn-social-dropbox {\n\t\tbackground-color: $dropbox;\n\t\tborder-color: $dropbox;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($dropbox);\n\t\t}\n\t}\n\t&.btn-social-github {\n\t\tbackground-color: $github;\n\t\tborder-color: $github;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($github);\n\t\t}\n\t}\n\t&.btn-social-skype {\n\t\tbackground-color: $skype;\n\t\tborder-color:  $skype;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($skype);\n\t\t}\n\t}\n\t&.btn-social-tumblr {\n\t\tbackground-color: $tumblr;\n\t\tborder-color: $tumblr;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($tumblr);\n\t\t}\n\t}\n\t&.btn-social-flickr {\n\t\tbackground-color: $flickr;\n\t\tborder-color:$flickr;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($flickr);\n\t\t}\n\t}\n\t&.btn-social-behance {\n\t\tbackground-color: $behance;\n\t\tborder-color: $behance;\n\t\t&:focus,&:active,&:hover {\n\t\t\t@include boxshadow-custom-btn-2($behance);\n\t\t}\n\t}\n}\n\n/*Wrapper*/\n.hk-wrapper  {\n\tposition:relative;\n}\n\n.hk-pg-wrapper {\n\tpadding:65px 0 60px;\n\tposition:relative;\n\tmin-height: 100vh;\n}\n\n/*Gutter*/\n$num: 5;\n$num1: 1.5;\n@while $num < 8 {\n    .g-#{$num},.gx-#{$num} {\n        --bs-gutter-x : #{$num1 +0.5}rem;\n    }\n\t.g-#{$num},.gy-#{$num} {\n        --bs-gutter-y : #{$num1 +0.5}rem;\n    }\n    $num:$num +1;\n    $num1:$num1 + 0.5;\n}\n@media (min-width: 576px) {\n\t$num: 5;\n\t$num1: 1.5;\n\t@while $num < 8 {\n\t\t.g-sm-#{$num},.gx-sm-#{$num} {\n\t\t\t--bs-gutter-x: #{$num1 +0.5}rem;\n\t\t}\n\t\t.g-sm-#{$num},.gy-sm-#{$num} {\n\t\t\t--bs-gutter-y: #{$num1 +0.5}rem;\n\t\t}\n\t\t$num:$num +1;\n\t\t$num1:$num1 + 0.5;\n\t}\n}\n@media (min-width: 768px) {\n\t$num: 5;\n\t$num1: 1.5;\n\t@while $num < 8 {\n\t\t.g-md-#{$num},.gx-md-#{$num} {\n\t\t\t--bs-gutter-x: #{$num1 +0.5}rem;\n\t\t}\n\t\t.g-md-#{$num},.gy-md-#{$num} {\n\t\t\t--bs-gutter-y: #{$num1 +0.5}rem;\n\t\t}\n\t\t$num:$num +1;\n\t\t$num1:$num1 + 0.5;\n\t}\n}\n@media (min-width: 992px) {\n\t$num: 5;\n\t$num1: 1.5;\n\t@while $num < 8 {\n\t\t.g-lg-#{$num},.gx-lg-#{$num} {\n\t\t\t--bs-gutter-x: #{$num1 +0.5}rem;\n\t\t}\n\t\t.g-lg-#{$num},.gy-lg-#{$num} {\n\t\t\t--bs-gutter-y: #{$num1 +0.5}rem;\n\t\t}\n\t\t$num:$num +1;\n\t\t$num1:$num1 + 0.5;\n\t}\n}\n@media (min-width: 1200px) {\n\t$num: 5;\n\t$num1: 1.5;\n\t@while $num < 8 {\n\t\t.g-xl-#{$num},.gx-xl-#{$num} {\n\t\t\t--bs-gutter-x: #{$num1 +0.5}rem;\n\t\t}\n\t\t.g-xl-#{$num},.gy-xl-#{$num} {\n\t\t\t--bs-gutter-y: #{$num1 +0.5}rem;\n\t\t}\n\t\t$num:$num +1;\n\t\t$num1:$num1 + 0.5;\n\t}\n}\n@media (min-width: 1400px) {\n\t$num: 5;\n\t$num1: 1.5;\n\t@while $num < 8 {\n\t\t.g-xxl-#{$num},.gx-xxl-#{$num} {\n\t\t\t--bs-gutter-x: #{$num1 +0.5}rem;\n\t\t}\n\t\t.g-xxl-#{$num},.gy-xxl-#{$num} {\n\t\t\t--bs-gutter-y: #{$num1 +0.5}rem;\n\t\t}\n\t\t$num:$num +1;\n\t\t$num1:$num1 + 0.5;\n\t}\n}\n/*Hk Section*/\n.hk-section {\n\tmargin-bottom:3.125rem;\n\t.hk-sec-title {\n\t\tmargin-bottom: 1.25rem;\n\t}\n}\n/*Card*/\n.card {\n\tborder-color:$grey_light_4;\n\tbox-shadow:0 2px 2px rgba(0, 0, 0, 0.1);\n\tmargin-bottom:.875rem;\n\tborder-radius:0.5rem;\n\t.card-header {\n\t\tbackground:transparent;\n\t\tborder-color:$grey_light_4;\n\t\tpadding:0.75rem 1.25rem;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t\t>h1,>h2,>h3,>h4,>h5,>h6,>.h1,>.h2,>.h3,>.h4,>.h5,>.h6 {\n\t\t\tmargin-bottom:0;\n\t\t}\n\t\t&.card-header-bold {\n\t\t\tfont-size:0.875rem;\n\t\t\ttext-transform:uppercase;\n\t\t\tfont-weight:600;\n\t\t}\n\t\t&.card-header-wth-bg {\n\t\t\tbackground:$grey_light_5;\n\t\t\tborder-color:transparent;\n\t\t\t&.card-header-action {\n\t\t\t\t.card-action-wrap {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.card-header-action {\n\t\t\t.card-action-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\t> a.collapsed {\n\t\t\t\t\t@include transform(rotate(180deg));\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.card-header-wth-text {\n\t\t\t\talign-items:flex-start;\n\t\t\t\t-webkit-box-align: flex-start;\n\t\t\t\t-ms-flex-align: flex-start;\n\t\t\t\tborder-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;\n\t\t\t}\n\t\t}\n\t\t&.card-header-wth-bg-inv {\n\t\t\tcolor:$white;\n\t\t\tbackground:$primary;\n\t\t\tborder-color:transparent;\n\t\t\th1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6 {\n\t\t\t\tcolor:$white;;\n\t\t\t}\n\t\t}\n\t\t\n\t\t&:first-child {\n\t\t\tborder-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;\n\t\t}\n\t\t.nav-tabs.card-header-tabs {\n\t\t\tborder-bottom:0;\n\t\t}\n\t}\n\t&.sticky-card-header {\n\t\t.card-header {\n\t\t\ttop:64px;\n\t\t\tposition: -webkit-sticky;\n\t\t\tposition: sticky;\n\t\t\tz-index: 100;\n\t\t}\n\t}\n\t.card-text {\n\t\tmargin-bottom:1rem;\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\t.card-title {\n\t\tfont-size: 1rem;\n\t\tcolor:$black_2;\n\t\tfont-weight: 500;\n\t}\n\t.card-subtitle {\n\t\tfont-size: 0.875rem;\n\t}\n\t.card-body {\n\t\tpadding:1.25rem;\n\t\tmin-height: 1px;\n\t\t>.card-action-wrap {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tposition: absolute;\n\t\t\tright: 14px;\n\t\t\ttop: 8px;\n\t\t\t.btn {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-shrink:0;\n\t\t\t}\n\t\t}\n\t\t> .card-close {\n\t\t\tposition: absolute;\n\t\t\tright: 14px;\n\t\t\ttop: 10px;\n\t\t\tcursor: pointer;\n\t\t\ta {\n\t\t\t\tcolor:$black_2;\n\t\t\t\t@include transition(.2s ease);\n\t\t\t\tmargin-left:1rem;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\topacity:.6;\n\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t&:hover {\n\t\t\t\t\topacity:1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.close-over {\n\t\t.btn-close {\n\t\t\tposition:absolute;\n\t\t\ttop:-10px;\n\t\t\tright:-10px;\n\t\t}\n\t}\n\t&.card-selected {\n\t\tposition:relative;\n\t\tborder-color:$primary;\n\t\t&:after {\n\t\t\theight: 22px;\n\t\t\twidth: 22px;\n\t\t\tbackground: $primary;\n\t\t\tcolor: $white;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tcursor: pointer;\n\t\t\tfont: normal normal normal 16px/1 'Material-Design-Iconic-Font';\n\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\tcontent: \"\\f26b\";\n\t\t\ttop:-10px;\n\t\t\tright:-10px;\n\t\t\tline-height: 0;\n\t\t\tposition:absolute;\n\t\t}\n\t}\n\t.card-footer {\n\t\tbackground:transparent;\n\t\tborder-color:$grey_light_4;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tpadding:0.75rem 1.25rem;\n\t\t&:last-child {\n\t\t\tborder-radius: 0 0 calc(0.5rem - 1px) calc(0.5rem - 1px);\n\t\t}\n\t}\n\t.card-img-bg {\n\t\toverflow: hidden;\n\t\tbackground-size:cover;\n\t\tbackground-position:center;\n\t\tbackground-repeat:no-repeat;\n\t}\n\t&.card-refresh {\n\t\tposition:relative;\n\t\t.refresh-container {\t\n\t\t\t@include background-opacity($white,.9);\n\t\t\theight: 100%;\n\t\t\tleft: 0;\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\twidth: 100%;\n\t\t\tdisplay:none;\n\t\t\tz-index: 5;\n\t\t\tcursor:wait;\n\t\t\tborder-radius:0.5rem;\n\t\t\toverflow:hidden;\n\t\t\t.loader-pendulums {\n\t\t\t\tfont-size:2rem;\n\t\t\t}\n\t\t}\n\t}\n\t&.fullscreen {\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tmargin: 0;\n\t\tposition: fixed;\n\t\toverflow-y: auto;\n\t\tz-index: 1040;\n\t\tborder-radius: 0;\n\t\t@include transition(all .2s ease);\n\t}\n\t&.card-lg {\n\t\t.card-header,\n\t\t.card-footer {\n\t\t\tpadding:1rem 1.5rem;\n\t\t}\n\t\t.card-body {\n\t\t\tpadding:1.5rem;\n\t\t}\n\t}\n\t&.card-sm {\n\t\t.card-header,\n\t\t.card-footer {\n\t\t\tpadding:.625rem 1rem;\n\t\t}\n\t\t.card-body {\n\t\t\tpadding:1rem;\n\t\t}\n\t}\n\t&.card-shadow {\n\t\tborder:none;\n\t\tbox-shadow:0 6px 16px rgba(0,0,0,0.1);\n\t}\n\t&.card-flush {\n\t\tborder:none;\n\t\tbox-shadow:none;\n\t}\n\t&.card-border {\n\t\tborder:1px solid $grey_light_4;\n\t\tbox-shadow:none;\n\t}\n\t&.card-simple {\n\t\t.card-header,\n\t\t.card-footer {\n\t\t\tborder:none;\n\t\t}\n\t}\n\t&.card-wth-line {\n\t\tpadding-top: .25rem;\n\t\tborder-top:0;\n\t\t.card-line {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\theight: 30px;\n\t\t\twidth: 100%;\n\t\t\tborder-top-left-radius: 0.5rem;\n\t\t\tborder-top-right-radius: 0.5rem;\n\t\t}\n\t\t.card-body {\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\t\t\tbackground: $white;\n\t\t\tborder-top-left-radius: 0.5rem;\n\t\t\tborder-top-right-radius: 0.5rem;\n\t\t}\n\t}\n\t&.card-wth-progress {\n\t\t.progress {\n\t\t\tbackground:transparent;\n\t\t\tborder-top-left-radius: 0.5rem;\n\t\t\tborder-top-right-radius: 0.5rem;\n\t\t}\n\t}\n\t&.card-wth-tabs {\n\t\t>.card-header {\n\t\t\tpadding-bottom: .5rem;\n\t\t}\n\t}\n}\n.card-img, .card-img-top {\n    border-top-left-radius: calc(0.5rem - 1px);\n    border-top-right-radius: calc(0.5rem - 1px);\n}\n.card-img, .card-img-bottom {\n    border-bottom-right-radius: calc(0.5rem - 1px);\n    border-bottom-left-radius: calc(0.5rem - 1px);\n}\n.card-group > .card {\n\tmargin-bottom:.875rem;\n}\n.hk-wrapper.hk-menu-toggle {\n\t.card.fullscreen {\n\t\tleft:0;\n\t}\n}\n@media (max-width: 1199px){\n.card.fullscreen {\n\tleft: 0;\n}\t\t\n.hk-wrapper.hk-menu-toggle {\n\t.card.fullscreen {\n\t\tleft:269px;\n\t\tright:-269px;\n\t}\n}\n}\n@media (max-width: 576px) { \n\t.card.card-lg {\n\t\t.card-header,\n\t\t.card-footer {\n\t\t\tpadding: .75rem 1.25rem;\n\t\t}\n\t\t.card-body {\n\t\t\tpadding: 1.25rem;\n\t\t}\n\t}\n}\n/*Placehoder*/\n.placeholder {\n\tborder-radius: 0.25rem;\n}\n/*Breadcrumb*/\n.breadcrumb {\n\t.breadcrumb-item {\n\t\tfont-size:0.875rem;\n\t\t> a {\n\t\t\tcolor:$black;\n\t\t\t&:hover,&:focus {\n\t\t\t\tcolor:$primary;\n\t\t\t}\n\t\t}\n\t\t&.active {\n\t\t\tcolor: $grey_dark_3;\n\t\t}\n\t}\n\t&.breadcrumb-sm {\n\t\t.breadcrumb-item {\n\t\t\tfont-size:0.75rem;\n\t\t}\n\t}\n\t&.breadcrumb-dark {\n\t\t.breadcrumb-item {\n\t\t\t> a {\n\t\t\t\t@include color-opacity($white,.85);\n\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t@include color-opacity($white,1);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include color-opacity($white,.7);\n\t\t\t}\n\t\t}\n\t\t.breadcrumb-item + .breadcrumb-item {\n\t\t\t&:before { \n\t\t\t\t@include color-opacity($white,.3);\n\t\t\t}\n\t\t}\n\t}\n\t&.breadcrumb-full-width {\n\t\tborder-radius:0;\n\t}\n}\n.breadcrumb-item + .breadcrumb-item {\n\tpadding-left: .3rem; \n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tdisplay: flex;\n\t&:before {\n\t\tfont-family: \"dripicons-v2\" !important;\n\t\tcontent: \"V\";\n\t\tpadding-right: .3rem;  \n\t\tposition: relative;\n\t\ttop: 1px;\n\t\tfont-size: 0.625rem;\n\t\t@include color-opacity($grey_light_1,.8);\n\t}\n}\n\n/*Page Header*/\n.hk-pg-header {\n\tpadding:1.25rem 0;\n\tbackground:$white;\n\tborder-bottom: 1px solid $grey_light_4;\n\t.pg-title {\n\t\tfont-size:1.75rem;\n\t\tfont-weight: 700;\n\t\tmargin-bottom:.3rem;\n\t}\n\t.pg-title-sm {\n\t\tfont-size:1.5rem;\n\t\tfont-weight: 700;\n\t\tmargin-bottom:.25rem;\n\t}\n\t.pg-title-xs {\n\t\tfont-size:1.25rem;\n\t\tfont-weight: 700;\n\t\tmargin-bottom:.25rem;\n\t}\n\t.breadcrumb {\n\t\tpadding-top:0;\n\t\tpadding-left:0;\n\t\tpadding-right:0;\n\t\tmargin-bottom: 0.5rem;\n\t}\n\t.pg-subtitle {\n\t\tfont-size: 0.75rem;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 600;\n\t\tmargin-bottom:.3rem;\n\t}\n\t.pg-stats-group {\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items:center;\n\t\t.stats-symbol {\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tpadding-right:.25rem;\n\t\t\t.feather-icon svg,.svg-icon svg {\n\t\t\t\theight:13px;\n\t\t\t\twidth:13px;\n\t\t\t}\n\t\t}\n\t\t.stats-title {\n\t\t\tfont-size:0.875rem;\n\t\t}\n\t\t.stats-dot-sep {\n\t\t\tpadding:0 .625rem;\n\t\t\tcolor:$grey_light_3;\n\t\t}\n\t\t.stats-line-sep {\n\t\t\tpadding:0 .625rem;\n\t\t\tcolor:$grey_light_3;\n\t\t}\n\t}\n\t.pg-header-action-wrap {\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items:center;\n\t}\n\t&.pg-header-wth-tab {\n\t\tpadding-bottom:0;\n\t\t.nav-tabs {\n\t\t\tmargin-top:1.875rem;\n\t\t\tborder-bottom: none;\n\t\t}\n\t}\n\t&.pg-header-wth-img {\n\t\tposition:relative;\n\t\tbackground-image:url(../img/cropper.jpg);\n\t\tbackground-size:cover;\n\t\tbackground-position:center;\n\t\tbackground-repeat:no-repeat;\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\ttop: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tbackground: $black_2;\n\t\t\topacity: .6;\n\t\t}\n\t\t>div,>.nav-tabs {\n\t\t\tposition:relative;\n\t\t\tz-index:2;\n\t\t}\n\t}\n\t&.pg-header-wth-bg {\n\t\tbackground:$grey_light_5;\n\t\tborder-bottom:none;\n\t\t.nav-tabs {\n\t\t\t.nav-item {\n\t\t\t\t.nav-link,\n\t\t\t\t.nav-link.active {\n\t\t\t\t\tborder:none;\n\t\t\t\t}\n\t\t\t\t&.show {\n\t\t\t\t\t.nav-link {\n\t\t\t\t\t\tborder:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.pg-header-dark {\n\t\t.pg-title,\n\t\t.pg-title-sm,\n\t\t.pg-title-xs {\n\t\t\tcolor:$white;\n\t\t}\n\t\t.pg-subtitle,p {\n\t\t\t@include color-opacity($white,.8);\n\t\t}\n\t\t.pg-stats-group {\n\t\t\t.stats-symbol,\n\t\t\t.stats-title {\n\t\t\t\t@include color-opacity($white,.8);\n\t\t\t}\n\t\t\t.stats-line-sep,\n\t\t\t.stats-dot-sep {\n\t\t\t\t@include color-opacity($white,.3);\n\t\t\t}\n\t\t}\n\t\t.hk-vertical-separator-full:after {\n\t\t\t@include background-opacity($white,.2);\n\t\t}\n\t}\n}\n\n@media (max-width: 767px) {\n\t.hk-pg-header {\n\t\t.pg-title {\n\t\t\tfont-size:1.625rem;\n\t\t}\n\t}\t\n}\t\n/*Page Body*/\n.hk-pg-body {\n\tpadding:2rem 0;\n}\n/*Form*/\n.form-group {\n\tmargin-bottom: 1rem;\n}\n.form-control {\n\tcolor: $black_2;\n\tborder-color:$grey_light_3;\n\tborder-radius:0.375rem;\n\t&.square-input {\n\t\tborder-radius:0;\n\t}\n\t&:focus {\n\t\tborder-color: $primary;\n\t\tbox-shadow: 0 0 0 0.125rem rgba($primary, 0.16);\n\t}\n\t&:disabled {\n\t\tcolor:$grey_light_1;\n\t\tbackground-color:$grey_light_5;\n\t\tcursor: not-allowed;\n\t}\n\t&[readonly] {\n\t\tborder-color:$grey_light_2;\n\t\tbox-shadow: none;\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color:$grey_light_5;\n\t}\n\t&:hover:not(:disabled):not([readonly]) {\n\t\tborder-color: $primary;\n\t\tz-index: 4;\n\t}\n\t&.rounded-input {\n\t\tborder-radius:50rem!important;\n\t}\n\t&::placeholder {\n\t\tcolor:$grey;\t\n\t}\n\t&::-webkit-input-placeholder {\n\t\tcolor:$grey;\n\t}\n\t&:-moz-placeholder {\n\t\tcolor:$grey;\n\t}\n\t&:-ms-input-placeholder {\n\t\tcolor:$grey;\n\t}\n\t&.form-control-line {\n\t\tborder-top:0;\n\t\tborder-left:0;\n\t\tborder-right:0;\n\t\tborder-radius:0;\n\t\tpadding-left:0;\n\t\tbackground:transparent!important;\n\t\t&:focus {\n\t\t\tbox-shadow:none;\n\t\t}\n\t}\n\t&::file-selector-button,\n\t&::-webkit-file-upload-button {\n\t\tbackground:$white!important;\n\t\tcolor:$black_2;\n\t}\n}\ntextarea.form-control {\n\theight: auto;\n}\n.form-select {\n\t@extend .form-control;\n\tbackground-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")!important;\n\t&:hover:not(:disabled) {\n\t\tborder-color: $primary;\n\t\tz-index: 4;\n\t}\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n\theight: auto;\n}\n.input-group-lg > .form-select,\n.form-select-lg {\n\tpadding-right:1.75rem;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")!important;\n\t\n}\n.input-group-sm > .form-select,\n.form-select-sm {\n\tpadding-right:1.75rem;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")!important;\n}\n.form-control-lg,\n.form-select-lg {\n    font-size: 1.125rem;\n}\n/*Checkbox*/\n.form-check-input {\n\t&[type=checkbox] {\n\t\tborder-radius: 0.125em;\n\t}\n\t&:checked {\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t}\n\t&:focus {\n\t\tbox-shadow: 0 0 0 0.125rem rgba($primary, 0.16);\n\t}\n\t&:disabled{\n\t\t~ .form-check-label {\n\t\t\tcolor: $smoke;\n\t\t}\n\t} \n}\n.form-switch {\n\t.form-check-input {\n\t\t&[type=checkbox] {\n\t\t\tborder-radius: 2em;\n\t\t}\n\t}\t\n}\n.form-check-lg {\n\tmin-height: 2rem;\n\tpadding-left: 2em;\n\t.form-check-input {\n\t\theight: 1.25rem;\n\t\twidth: 1.25rem;\n\t\tmargin-left: -2em;\n\t\tmargin-top: 0.3rem;\n\t}\n\t.form-check-label {\n\t\tfont-size: 1.025rem;\n\t\tmargin-top: .2rem;\n\t}\n}\n.form-check-sm {\n\t.form-check-input {\n\t\theight: 0.875rem;\n\t\twidth: 0.875rem;\n\t\tmargin-top: 0.275em;\n\t}\n\t.form-check-label {\n\t\tfont-size: .875rem;\n\t}\n}\n.checkbox-circle {\n\t&.form-check-input {\n\t\tborder-radius:50%;\n\t}\n}\n/*Form Switch*/\n.form-switch {\n\t&.form-switch-lg {\n\t\tpadding-left: 3.5rem;\n\t\t.form-check-input {\n\t\t\theight: 1.3em;\n\t\t\twidth: 2.8em;\n\t\t\tmargin-left: -3.5em;\n\t\t}\n\t\t.form-check-label {\n\t\t\tfont-size: 1.025rem;\n\t\t\tmargin-top: 0.1rem;\n\t\t}\n\t}\n\t&.form-switch-xl {\n\t\tpadding-left: 4.5rem;\n\t\t.form-check-input {\n\t\t\theight: 1.8em;\n\t\t\twidth: 3.5em;\n\t\t\tmargin-left: -4.5em;\n\t\t}\n\t\t.form-check-label {\n\t\t\tfont-size: 1.2rem;\n\t\t\tmargin-top: 0.2rem;\n\t\t}\n\t}\n}\n/*Form Range*/\n.form-range {\n\t&:focus {\n\t\t&::-webkit-slider-thumb {\n\t\t\tbox-shadow: 0 0 0 0.125rem  rgba($primary, 0.25);\n\t\t}\n\t\t&::-moz-range-thumb {\n\t\t\tbox-shadow: 0 0 0 0.125rem  rgba($primary, 0.25);\n\t\t}\n\t}\n\t&::-webkit-slider-thumb {\n\t\tbackground-color: $primary;\n\t\t&:active {\n\t\t\tbackground-color: $primary_light_3;\n\t\t}\n\t}\n\t\n}\n\n/*Form validation*/\n.form-control {\n\t&.is-valid {\n\t\tborder-color: $success;\n\t\tbackground-image: none;\n\t\tpadding-right: inherit; \n\t\tz-index: 4;\n\t\t&:hover {\n\t\t\tborder-color: $success!important;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $success;\n\t\t\tbox-shadow: 0 0 0 0.125rem rgba($success, 0.25);\n\t\t}\n\t}\n\t&.is-invalid {\n\t\tborder-color: $danger!important;\n\t\tbackground-image: none;\n\t\tpadding-right: inherit;\n\t\tz-index: 4;\n\t\t&:focus {\n\t\t\tborder-color: $danger;\n\t\t\tbox-shadow: 0 0 0 0.125rem rgba($danger, 0.25);\n\t\t}\n\t}\n}\n.form-select {\n\t&.is-valid {\n\t\tborder-color: $success;\n\t\tbackground-image: none;\n\t\tpadding-right: inherit;\n\t\tz-index: 4;\n\t\t&:hover {\n\t\t\tborder-color: $success!important;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $success;\n\t\t\tbox-shadow: 0 0 0 0.125rem rgba($success, 0.25);\n\t\t}\n\t}\n\t&.is-invalid {\n\t\tborder-color: $danger;\n\t\tbackground-image: none;\n\t\tpadding-right: inherit;\n\t\tz-index: 4;\n\t\t&:hover {\n\t\t\tborder-color: $danger!important;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $danger;\n\t\t\tbox-shadow: 0 0 0 0.125rem rgba($danger, 0.25);\n\t\t}\n\t}\n}\n.form-check-input{\n\t&.is-valid {\n\t\tborder-color: $success;\n\t\t&:checked {\n\t\t\tbackground-color: $success;\n\t\t}\n\t\t&:focus {\n\t\t\tbox-shadow: 0 0 0 0.125rem rgba($success, 0.25);\n\t\t}\n\t\t~ {\n\t\t\t.form-check-label {\n\t\t\t\tcolor: $success;\n\t\t\t}\n\t\t}\n\t}\n\t&.is-invalid {\n\t\tborder-color: $danger;\n\t\t&:checked {\n\t\t\tbackground-color: $danger;\n\t\t}\n\t\t&:focus {\n\t\t\tbox-shadow: 0 0 0 0.125rem rgba($danger, 0.25);\n\t\t}\n\t\t~ {\n\t\t\t.form-check-label {\n\t\t\t\tcolor: $danger;\n\t\t\t}\n\t\t}\n\t}\n}\n.was-validated {\n\t.form-select {\n\t\t&:valid {\n\t\t\tborder-color: $success;\n\t\t\tbackground-image: none;\n\t\t\tpadding-right: inherit;\n\t\t\tz-index: 4;\n\t\t\t&:hover {\n\t\t\t\tborder-color: $success!important;\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tborder-color: $success;\n\t\t\t\tbox-shadow: 0 0 0 0.125rem rgba($success, 0.25);\n\t\t\t}\n\t\t}\n\t\t&:invalid {\n\t\t\tborder-color: $danger;\n\t\t\tbackground-image: none;\n\t\t\tpadding-right: inherit;\n\t\t\tz-index: 4;\n\t\t\t&:hover {\n\t\t\t\tborder-color: $danger!important;\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tborder-color: $danger;\n\t\t\t\tbox-shadow: 0 0 0 0.125rem rgba($danger, 0.25);\n\t\t\t}\n\t\t}\n\t}\n\t.form-control {\n\t\t&:valid {\n\t\t\tborder-color: $success;\n\t\t\tbackground-image: none;\n\t\t\tpadding-right: inherit;\n\t\t\tz-index: 4;\n\t\t\t&:hover {\n\t\t\t\tborder-color: $success!important;\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tborder-color: $success;\n\t\t\t\tbox-shadow: 0 0 0 0.125rem rgba($success, 0.25);\n\t\t\t}\n\t\t}\n\t\t&:invalid {\n\t\t\tborder-color: $danger;\n\t\t\tbackground-image: none;\n\t\t\tpadding-right: inherit;\n\t\t\tz-index: 4;\n\t\t\t&:hover {\n\t\t\t\tborder-color: $danger!important;\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tborder-color: $danger;\n\t\t\t\tbox-shadow: 0 0 0 0.125rem rgba($danger, 0.25);\n\t\t\t}\n\t\t}\n\t}\n\t.form-check-input {\n\t\t&:valid {\n\t\t\tborder-color: $success;\n\t\t\t&:checked {\n\t\t\t\tbackground-color: $success;\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tbox-shadow: 0 0 0 0.125rem rgba($success, 0.25);\n\t\t\t}\n\t\t\t~ {\n\t\t\t\t.form-check-label {\n\t\t\t\t\tcolor: $success;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&:invalid {\n\t\t\tborder-color: $danger;\n\t\t\t&:checked {\n\t\t\t\tbackground-color: $danger;\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tbox-shadow: 0 0 0 0.125rem rgba($danger, 0.25);\n\t\t\t}\n\t\t\t~ {\n\t\t\t\t.form-check-label {\n\t\t\t\t\tcolor: $danger;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.valid-feedback {\n\tcolor: $success;\n}\n.invalid-feedback {\n\tcolor: $danger;\n}\n.valid-tooltip {\n\tbackground:$success;\n}\n.invalid-tooltip {\n\tbackground:$danger;\n}\n/*Input group*/\n.input-affix-wrapper  {\n\tdisplay: flex;\n\tposition: relative;\n\tflex-wrap: wrap;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t\t.input-prefix,\n\t\t.input-suffix {\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tposition: absolute;\n\t\t\tz-index: 5;\n\t\t\tpadding: 0.375rem 0.75rem;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 1rem;\n\t\t\tline-height: 1.5;\n\t\t\tmin-width: 1.8rem;\n\t\t}\n\t.input-prefix {\n\t\tleft:0;\n\t}\n\t.input-suffix {\n\t\tright:0;\n\t}\n\t.form-control,\n\t.form-select {\n\t\t&:not(:first-child){\n\t\t\tpadding-left:2.5rem;\n\t\t}\n\t\t&:not(:last-child){\n\t\t\tpadding-right:2.5rem;\n\t\t}\n\t}\n\t&.input-affix-wrapper-sm {\n\t\t.input-prefix,\n\t\t.input-suffix {\n\t\t\tfont-size:0.875rem;\n\t\t\tpadding: 0.25rem 0.5rem;\n\t\t\tmin-width: 1.5rem;\n\t\t}\n\t\t.form-control,\n\t\t.form-select {\n\t\t\tpadding: .25rem .5rem;\n\t\t\tfont-size: .875rem;\n\t\t\t&:not(:first-child){\n\t\t\t\tpadding-left:2rem;\n\t\t\t}\n\t\t\t&:not(:last-child){\n\t\t\t\tpadding-right:2rem;\n\t\t\t}\n\t\t}\n\t}\n\t&.input-affix-wrapper-lg {\n\t\t.input-prefix,\n\t\t.input-suffix {\n\t\t\tfont-size: 1.25rem;\n\t\t\tpadding: 0.5rem 1rem;\n\t\t\tmin-width: 2rem;\n\t\t}\n\t\t.form-control,\n\t\t.form-select {\n\t\t\tpadding: 0.5rem 1rem;\n\t\t\tfont-size: 1.25rem;\n\t\t\t&:not(:first-child){\n\t\t\t\tpadding-left:3rem;\n\t\t\t}\n\t\t\t&:not(:last-child){\n\t\t\t\tpadding-right:3rem;\n\t\t\t}\n\t\t}\n\t}\n\t&.affix-border {\n\t\t.input-prefix,\n\t\t.input-suffix {\n\t\t\tborder: 1px solid $grey_light_3;\n\t\t\tborder-radius: 0.375rem;\n\t\t\tpadding: 0;\n\t\t}\n\t\t.input-suffix {\n\t\t\tmargin-right: 0.5rem;\n\t\t}\n\t\t.input-prefix {\n\t\t\tmargin-left: 0.5rem;\n\t\t}\n\t}\n\t&.affix-wth-text {\n\t\t.form-control,\n\t\t.form-select {\n\t\t\t&:not(:first-child){\n\t\t\t\tpadding-left:3.5rem;\n\t\t\t}\n\t\t\t&:not(:last-child){\n\t\t\t\tpadding-right:3.5rem;\n\t\t\t}\n\t\t}\n\t\t&.input-affix-wrapper-sm {\n\t\t\t.form-control,\n\t\t\t.form-select {\n\t\t\t\t&:not(:first-child){\n\t\t\t\t\tpadding-left:3rem;\n\t\t\t\t}\n\t\t\t\t&:not(:last-child){\n\t\t\t\t\tpadding-right:3rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.input-affix-wrapper-lg {\n\t\t\t.form-control,\n\t\t\t.form-select {\n\t\t\t\t&:not(:first-child){\n\t\t\t\t\tpadding-left:4.5rem;\n\t\t\t\t}\n\t\t\t\t&:not(:last-child){\n\t\t\t\t\tpadding-right:4.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.input-group-lg>.form-select, \n.input-group-lg>.form-control,\n.input-group-sm>.form-select, \n.input-group-sm>.form-control {\n\tborder-radius:0.375rem;\n}\n.input-group > .btn, .input-group > .form-control, .input-group > .form-select, .input-group > .input-group-text,\n.input-group-sm > .btn, .input-group-sm > .form-control, .input-group-sm > .form-select, .input-group-sm > .input-group-text,\n.input-group-lg > .btn, .input-group-lg > .form-control, .input-group-lg > .form-select, .input-group-lg > .input-group-text {\n\tborder-radius:0.375rem;\n}\n\n.input-group-text { \n\tborder-color:$grey_light_3;\n\tbackground-color: $white;\n\tborder-width: 1px;\n\tborder-radius:0.375rem;\n\tcolor:$grey_dark_3;\n\toverflow:hidden;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tmin-width:45px;\n}\n.input-group-lg .input-group-text {\n\tmin-width:55px;\n}\n.input-group-sm .input-group-text {\n\tmin-width:40px;\n}\n\n.input-group {\n\t&.input-group-wth-icon {\n\t\tposition:relative;\n\t\talign-items: center;\n\t\t.input-group-text {\n\t\t\tposition: absolute;\n\t\t\theight: calc(100% - 2px);\n\t\t\tz-index: 5;\n\t\t\tborder: 0;\n\t\t\tbackground: transparent;\n\t\t\tpointer-events: none;\n\t\t\t&:not(:last-child){\n\t\t\t\tleft:0;\n\t\t\t}\n\t\t\t&:not(:first-child){\n\t\t\t\tright:0;\n\t\t\t}\n\t\t}\n\t\t.form-control {\n\t\t\tborder-radius: 0.5rem!important;\n\t\t\t&:not(:first-child){\n\t\t\t\tpadding-left:2.6rem;\n\t\t\t}\n\t\t\t&:not(:last-child){\n\t\t\t\tpadding-right:2.6rem;\n\t\t\t}\n\t\t}\n\t}\n\t&.input-group-sm {\n\t\t&.input-group-wth-icon {\n\t\t\t.form-control {\n\t\t\t\t&:not(:first-child){\n\t\t\t\t\tpadding-left:2.3rem;\n\t\t\t\t}\n\t\t\t\t&:not(:last-child){\n\t\t\t\t\tpadding-right:2.3rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.input-group-lg {\n\t\t&.input-group-wth-icon {\n\t\t\t.form-control {\n\t\t\t\t&:not(:first-child){\n\t\t\t\t\tpadding-left:3.1rem;\n\t\t\t\t}\n\t\t\t\t&:not(:last-child){\n\t\t\t\t\tpadding-right:3.1rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.form-select,\n\t.form-control {\n\t\t&.is-valid,\n\t\t&.is-invalid {\n\t\t\tz-index: 4;\n\t\t}\n\t}\n\t> .input-affix-wrapper {\n\t\tflex: 1 1 auto;\n\t\tmin-width: 0;\n\t\twidth: 1%;\n\t\t&:not(:first-child) {\n\t\t\t.form-control,\n\t\t\t.form-select {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\t\t}\n\t\t&:not(:last-child) {\n\t\t\t.form-control,\n\t\t\t.form-select {\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\nlabel {\n    color:$black_2;\n}\n.custom-file-label {\n    color: $black_2;\n    border: 1px solid $grey_light_3;\n\theight: calc(2.25rem + 2px);\n\t&:after {\n\t\tborder-left:0;\n\t\tbackground:$grey_light_5;\n\t}\n}\n.form-label-group {\n   \tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items:center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n    margin-bottom: .5rem;\n\tlabel {\n\t\tmargin-bottom:0;\n\t}\n}\n\n/*Input Search*/\n.input-search {\n\t.btn-input-clear {\n\t\tcursor:pointer;\n\t\tline-height: 0;\n\t}\n\t.btn-input-clear,\n\t.input-loader {\n\t\tdisplay: none;\n\t}\n\t&.loading {\n\t\t.btn-input-clear {\n\t\t\tdisplay: none!important;\n\t\t}\n\t\t.input-loader {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n/*Spinner*/\n.spinner-border {\n\tborder-width: 0.125em;\n}\n.spinner-border-sm {\n\tborder-width: 0.1em;\n}\n/*Input Spinner*/\n.input-spinner-wrap {\n\t.btn {\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tborder-color:$grey_light_3!important;\n\t\tbackground:$white!important;\n\t\tcolor:$grey!important;\n\t\tstrong {\n\t\t\tdisplay:none;\n\t\t}\n\t\t&:after {\n\t\t\tfont: normal normal normal 20px/1 'Material-Design-Iconic-Font';\n\t\t\ttext-rendering: auto;\n\t\t}\n\t\t&.btn-decrement {\n\t\t\t&:after {\n\t\t\t\tcontent:'\\f273';\n\t\t\t}\n\t\t}\n\t\t&.btn-increment {\n\t\t\t&:after {\n\t\t\t\tcontent:'\\f278';\n\t\t\t}\n\t\t}\n\t}\n\t.input-group{\n\t\t&.input-group-sm {\n\t\t\t.btn.btn-outline-light {\n\t\t\t\t&:after {\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.input-group-lg {\n\t\t\t.btn.btn-outline-light {\n\t\t\t\t&:after {\n\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Select2*/\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,\n .select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {\n\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n\n}\n.select2-dropdown {\n\tborder-color:$grey_light_3;\n}\n.select2-container {\n\twidth:100%!important;\n\t&.select2-container--default {\n\t\t&.select2-container--disabled {\n\t\t\tcursor:not-allowed;\n\t\t\t.select2-selection--single {\n\t\t\t\tbackground-color:$grey_light_5;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\t\t}\n\t}\n}\n.select2-container--default {\n\t.select2-selection--single,\n\t.select2-selection--multiple {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\theight: calc(2.25rem + 2px);\n\t\tpadding: .375rem 1rem;\n\t\tfont-size: 1rem;\n\t\tline-height: 1.5;\n\t\tcolor: $black_2;\n\t\tbackground-color: $white;\n\t\tborder: 1px solid $grey_light_3;\n\t\tborder-radius:0.5rem;\n\t\ttransition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n\t\t&:hover {\n\t\t\tborder-color:$primary;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color:$primary;\n\t\t\tbox-shadow: 0 0 0 0.125rem rgba($primary, 0.25);\n\t\t}\n\t\t.select2-selection__arrow {\n\t\t\theight: calc(2.25rem + 2px);\n\t\t\ttop: 0;\n\t\t\tright: 6px;\n\t\t\tb {\n\t\t\t\tbackground-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20' fill='none' stroke='rgba(47, 52, 58, 0.3)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")!important;\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-size: 16px 12px;\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 20px;\n\t\t\t\tdisplay: block;\n\t\t\t\tborder: none;\n\t\t\t\tmargin: auto;\n\t\t\t\tposition: static;\n\t\t\t}\n\t\t}\n\t\t.select2-selection__rendered {\n\t\t\tcolor:$black_2;\n\t\t\tline-height: inherit;\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\t.select2-search--dropdown .select2-search__field {\n\t\tborder-color: $grey_light_3;\n\t}\n\t&.select2-container--focus .select2-selection--multiple {\n\t\tborder: solid $primary 1px;\n\t\tbox-shadow: 0 0 0 0.125rem rgba($primary, 0.25);\n\t}\n\t&.select2-container--open {\n\t\t.select2-selection--single {\n\t\t\tborder-color:$primary;\n\t\t}\t\n\t\t&.select2-container--below {\n\t\t\t.select2-selection--single,\n\t\t\t.select2-selection--multiple {\n\t\t\t\tborder-top-right-radius: 0.5rem;\n\t\t\t\tborder-top-left-radius: 0.5rem;\n\t\t\t}\n\t\t\t\n\t\t}\n\t}\n\t.select2-results__option--highlighted[aria-selected] {\n\t\tbackground-color: $primary;\n\t}\n\t.select2-results__option[aria-selected=\"true\"] {\n\t\tbackground-color: $grey_light_5;\n\t\tcolor:$black_2;\n\t}\n\t.select2-selection--multiple {\n\t\t\theight:auto;\n\t\t\tmin-height:calc(2.25rem + 2px);\n\t\t\tpadding:0;\n\t\t.select2-selection__choice {\n\t\t\tbackground-color: $grey_light_5;\n\t\t\tborder: none;\n\t\t\tfont-size:75%;\n\t\t\tborder-radius: .25rem;\n\t\t\tcolor: $black_2;\n\t\t\tmargin-right: .375rem;\n\t\t\tmargin-top: .375rem;\n\t\t\tpadding: .25rem .5rem;\n\t\t\tfont-weight: 500;\n\t\t\ttext-transform: capitalize;\n\t\t\t.select2-selection__choice__remove {\n\t\t\t\tcolor: $black_2;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin-left: .375rem;\n\t\t\t\tfloat: right;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\topacity: 0.5; \n\t\t\t\tpadding-top:1px;\n\t\t\t\theight: 0;\n\t\t\t\tposition: relative;\n\t\t\t\ttop: -2px;\n\t\t\t\t&:hover {\n\t\t\t\t\topacity:1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t\t.select2-selection__rendered {\n\t\t\tpadding: 0 1rem;  \n\t\t}\n\n\t}\n}\n.select2-container--default .select2-results__group,\n.select2-results__option {\n    padding: .375rem 1rem;\n}\t\n\n/*Tinymce*/\n.mce-container, .mce-container *, .mce-widget, .mce-widget *, .mce-reset {\n\tcolor:$grey_dark_1!important;\n}\n.mce-text {\n\tfont-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\"!important;\n}\n.mce-menu-item .mce-caret {\n    border-left-color: $grey_dark_1!important;\n}\ndiv.mce-menu .mce-menu-item-sep, .mce-menu-item-sep:hover {\n\tborder-bottom-color: $grey_light_3!important;\n}\n.mce-menu { \n\tborder-bottom-color: $grey_light_3!important;\n}\n.tinymce-wrap {\n\t.mce-tinymce {\n\t\tbox-shadow: none;\n\t}\n\t.mce-toolbar .mce-btn-group {\n\t\tpadding: .25rem 0;\n\t}\n\t.mce-btn-group {\n\t\t.mce-btn {\n\t\t\tmargin-left: .25rem;\n\t\t\tmargin-right: .25rem;\n\t\t}\n\t\t&:not(:first-child) {\n\t\t\tborder-left: none;\n\t\t\tpadding-left: 0;\n\t\t\tmargin-left: 0;\n\t\t}\t\n\t}\n\t.mce-container, .mce-container *, .mce-widget, .mce-widget *, .mce-reset {\n\t\tfont-family:inherit;\n\t\tcolor:$grey_dark_1;\n\t}\n\t.mce-panel {\n\t\tborder-color:$grey_light_3;\n\t\tborder-radius: .25rem;\n\t}\t\n\t.mce-top-part::before {\n\t\tbox-shadow: none;\n\t}\n\t.mce-btn:hover,.mce-btn.mce-disabled:hover button,\n\t.mce-menubar .mce-menubtn:hover,.mce-menubar .mce-menubtn:focus {\n\t\tborder-color: transparent;\n\t\tborder-radius:.25rem;\n\t\tbackground:$grey_light_5;\n\t\tcolor:$black_2;\n\t}\n\t.mce-btn.mce-active:hover, .mce-btn.mce-active:focus, .mce-btn.mce-active:active {\n\t\tbackground: $grey_light_5;\n\t\tborder-color: transparent;\n\t}\n\t.mce-btn.mce-active, \n\t.mce-btn:active {\n\t\tbackground: $grey_light_5;\n\t\tborder-color: transparent;\n\t\tbutton {\n\t\t\ti {\n\t\t\t\tcolor: $primary!important;\n\t\t\t}\n\t\t}\n\t}\n\t.mce-btn.mce-active button, .mce-btn.mce-active:hover button, .mce-btn.mce-active i, .mce-btn.mce-active:hover i {\n\t\tcolor: $primary;\n\t}\n\t.mce-btn.mce-active .mce-caret, .mce-btn.mce-active:hover .mce-caret {\n\t\tborder-top-color: $grey_dark_1;\n\t}\n}\n.mce-ico {\n\tfont-family: 'tinymce',Arial !important;\n\tcolor:$grey_dark_4!important;\n}\t\n.mce-menu-item.mce-active.mce-menu-item-normal {\n    background: $grey_light_5!important;\n}\n.mce-tooltip {\n\topacity:1!important;\n\tfilter:alpha(opacity=100)!important;\n}\n.mce-tooltip-inner {\n\tfont-size:0.75rem!important;\n\tbackground-color:$black_2!important;\n\tpadding: 0.25rem 0.5rem!important;\n\tborder-radius:0.5rem;\n\tcolor:$white!important;\n\tfont-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\"!important;\n}\n.mce-tooltip-arrow {\n\tborder-bottom-color:$black_2!important;\n}\n.mce-menu-item:hover, .mce-menu-item:focus {\n    background: $grey_light_5!important;\n}\n\n/*File Upload*/\n.btn-file {\n\toverflow: hidden;\n\tposition: relative;\n\tvertical-align: middle;\n\tdisplay:inline-block;\n\tinput {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tmargin: 0;\n\t\topacity: 0;\n\t\tfilter: alpha(opacity=0);\n\t\tfont-size: 1.5rem;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tdirection: ltr;\n\t\tcursor: pointer;\n\t}\n}\n.fileinput-exists .fileinput-new, \n.fileinput-new .fileinput-exists {\n\tdisplay: none;\n}\n.fileinput {\n\t&.input-group > .input-group-append:last-child > .btn.btn-file:not(:last-child):not(.dropdown-toggle), &.input-group > .input-group-append:not(:last-child) > .btn.btn-file, &.input-group > .input-group-prepend > .btn.btn-file {\n\t\tborder-top-right-radius: 0.5rem;\n\t\tborder-bottom-right-radius: 0.5rem;\n\t}\n\t&.fileinput-exists {\n\t\t&.input-group > .input-group-append:last-child > .btn.btn-file:not(:last-child):not(.dropdown-toggle), &.input-group > .input-group-append:not(:last-child) > .btn.btn-file, &.input-group > .input-group-prepend > .btn.btn-file {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n}\t\n.dropzone {\n    border: 1px dashed $grey_light_3; \n\tcolor: $black_2;\n\tborder-radius: 0.25rem;\n\t.dz-message {\n\t\tmargin: 3em 0;\n\t\tfont-weight:500;\n\t\tcolor:$black_2;\n\t}\n\t.dz-preview {\n\t\t.dz-details {\n\t\t\tcolor: $black_2;\n\t\t}\t\n\t\t.dz-filename span {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t\t.dz-image {\n\t\t\tborder-radius: 0.25rem;\n\t\t}\t\n\t\t&.dz-file-preview .dz-image {\n\t\t\tborder-radius:0.25rem;\n\t\t}\n\t}\n}\n.dropify-wrapper {\n\tborder: 1px dashed $grey_light_3; \n\tborder-radius: 0.25rem;\n\tfont-family: inherit;\n\tcolor: $black_2;\n\tfont-size:1rem;\n\tpadding:1rem;\n\t.dropify-message {\n\t\tp {\n\t\t\t.main-text{\n\t\t\t\tdisplay:block;\n\t\t\t\tcolor:$black_2;\n\t\t\t\tfont-weight:500;\n\t\t\t}\n\t\t\t.sub-text{\n\t\t\t\tfont-size:0.875rem;\n\t\t\t\tdisplay:block;\n\t\t\t\tcolor:$grey_dark_3;\n\t\t\t}\n\t\t}\n\t\tspan.file-icon {\n\t\t\tfont-size: 2rem;\n\t\t\tcolor: $white;\n\t\t\theight: 3rem;\n\t\t\twidth: 3rem;\n\t\t\tdisplay: block;\n\t\t\tmargin: auto;\n\t\t\tcolor:$grey;\n\t\t\tposition:relative;\n\t\t\t&:before {\n\t\t\t\tcontent: \"\\F603\";\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tfont-family: bootstrap-icons !important;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: normal !important;\n\t\t\t\tfont-variant: normal;\n\t\t\t\ttext-transform: none;\n\t\t\t\tline-height: 1;\n\t\t\t\tvertical-align: -0.125em;\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\ttop: 50%;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tmargin: auto;\n\t\t\t\t@include transform(translateY(-50%));\n\t\t\t}\n\t\t}\n\t}\n\t.dropify-preview .dropify-infos {\n\t\t@include background-opacity($black,.85);\n\t\t.dropify-infos-inner p {\n\t\t\tfont-weight:500;\n\t\t\t&.dropify-infos-message {\n\t\t\t\tmargin-top: 0px;\n\t\t\t\tpadding-top: 0px;\n\t\t\t\topacity:1;\n\t\t\t\tfont-weight:700;\n\t\t\t\ttext-transform:uppercase;\n\t\t\t\tletter-spacing:0.5px;\n\t\t\t\tcolor:$grey;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t&:before {\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.dropify-clear {\n\t\tborder:none;\n\t\tfont-size: 0.75rem;\n\t\tpadding: .125rem .375rem;\n\t\tfont-weight: 500;\n\t\tletter-spacing: 0.5px;\n\t\ttop: 8px;\n\t\tright: 8px;\n\t\t&:hover {\n\t\t\tborder-radius: 1rem;\n\t\t}\n\t}\n\t&:hover {\n\t\tbackground-image: none;\n\t}\n}\t\n.dropify-square,\n.dropify-circle {\n\t.dropify-wrapper {\n\t\theight: 7.5rem;\n\t\twidth: 7.5rem;\n\t\toverflow:visible;\n\t\t.dropify-message {\n\t\t\tfont-size:0.875rem;\n\t\t\tspan.file-icon {\n\t\t\t\tfont-size: 1.25rem;\n\t\t\t\theight: 1.25rem;\n\t\t\t\twidth: 1.25rem;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size:0.875rem;\n\t\t\t}\n\t\t}\n\t\t.dropify-preview {\n\t\t\tborder-radius:50%;\n\t\t\tpadding: 0;\n\t\t}\n\t\t&:hover {\n\t\t\t.dropify-clear,.dropify-preview .dropify-infos {\n\t\t\t\topacity:0;\n\t\t\t}\n\t\t}\n\t}\n}\n.dropify-circle {\n\t.dropify-wrapper {\n\t\tborder-radius:50%;\n\t}\n}\t\t\n/*Form-Wizard*/\n.wizard {\n\t> .steps {\n\t\tli > a {\n\t\t\tborder:1px solid $grey_light_3;\n\t\t\tborder-radius: 0!important;\n\t\t\tbackground: $white!important;\n\t\t\tfont-weight:500;\n\t\t\tposition:relative;\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\eb74\";\n\t\t\t\tfont-family: 'remixicon';\n\t\t\t\tfont-style: normal;\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\tposition: absolute;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t\theight: 1rem;\n\t\t\t\twidth: 1rem;\n\t\t\t\tbackground: $grey_light_3;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tright: 0.5rem;\n\t\t\t\ttop: 0.5rem;\n\t\t\t\tcolor:$white;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t@include transition(all .1s ease);\n\t\t\t}\n\t\t\t&:before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\tbackground: transparent;\n\t\t\t\theight: 3px;\n\t\t\t\twidth: 100%;\n\t\t\t\tleft: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\t@include transition(all .1s ease);\n\t\t\t}\n\t\t}\n\t\t.current {\n\t\t\ta,a:hover,a:active {\n\t\t\t\tcolor: $black_2;\n\t\t\t\t&:before {\n\t\t\t\t\tbackground: $primary;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\t&.error {\n\t\t\t\ta,a:hover,a:active {\n\t\t\t\t\tcolor: $danger;\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground: $danger;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.done {\n\t\t\ta,a:hover,a:active {\n\t\t\t\tcolor: $black_2;\n\t\t\t\toverflow: hidden;\n\t\t\t\t&:after {\n\t\t\t\t\tbackground: $success;\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t> .content {\n\t\tbackground: $white;\n\t\tborder-radius: 0;\n\t\tmin-height: 100px;\n\t\tmargin: 0;\n\t\tborder: none;\n\t\tpadding-bottom: .625rem;\n\t\t>.body {\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tpadding: 1.875rem;\n\t\t\tposition: static;\n\t\t\tlabel.error {\n\t\t\t\tcolor:$danger;\t\t\n\t\t\t}\n\t\t\tinput {\n\t\t\t\t@extend .form-control;\n\t\t\t\t&.error {\n\t\t\t\t\tbackground: $white;\n\t\t\t\t\tborder-color:$danger!important;\n\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tbox-shadow: 0 0 0 0.125rem rgba($danger, 0.25);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\t\n\t> .actions {\n\t\tbackground:$white;\n\t\tpadding:.625rem 1.875rem;\n\t\ta,a:hover,a:active {\n\t\t\tdisplay: inline-block;\n\t\t\tfont-weight: 400;\n\t\t\ttext-align: center;\n\t\t\twhite-space: nowrap;\n\t\t\tbackground:$primary;\n\t\t\tvertical-align: middle;\n\t\t\t-webkit-user-select: none;\n\t\t\t-moz-user-select: none;\n\t\t\t-ms-user-select: none;\n\t\t\tuser-select: none;\n\t\t\tborder: 1px solid $primary;\n\t\t\ttext-transform:capitalize;\n\t\t\toutline:none;\n\t\t\tfont-size: 1rem;\n\t\t\tpadding: 0.375rem 1rem;\n\t\t\tborder-radius: 0.5rem;\n\t\t}\n\t\t.disabled {\n\t\t\ta,a:hover,a:active {\n\t\t\t\tcolor:$white;\n\t\t\t\tbackground-color: $primary_light_3;\n\t\t\t\tborder-color: $primary_light_3;\n\t\t\t}\n\t\t}\n\t}\n}\t\n@media (max-width: 991px) {\n\t.wizard .steps ul > li {\n\t\twidth: 100%;\n\t}\n}\t\n\n/*Popover*/\n.popover {\n\tborder: none;\n\tborder-radius:0.5rem;\n\tfont-family: var(--bs-body-font-family);\n\tbox-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.1);\n}  \n.popover-header {\n\tcolor: $black_2;\n\tbackground-color: $white;\n\tpadding: 0.65rem .75rem;\n\tborder-radius: 0.5rem 0.5rem 0 0;\n\tborder-color:$grey_light_3;\n}\t\n.popover-body {\n\tpadding: .65rem .75rem;\n\tcolor: $grey_dark_3;\n\tborder-radius:0.5rem;\n\tfont-size: 1rem;\n}   \n\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::before, .bs-popover-top > .arrow::before {\n\tborder-top-color: transparent;\n}\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before, .bs-popover-bottom > .arrow::before {\n\tborder-bottom-color: transparent;\n}\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::before, .bs-popover-left > .arrow::before {\n\tborder-left-color: transparent;\n}\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::before, .bs-popover-right > .arrow::before {\n\tborder-right-color: transparent;\n}\n\n/*Collapse*/\n.collapse-simple {\n\t>.card {\n\t\tmargin-bottom:0;\n\t\tbox-shadow:none;\n\t\tborder:0;\n\t\tborder-bottom:1px solid $grey_light_4;\n\t\tborder-radius:0;\n\t\tpadding:0.5rem 0;\n\t\t&:last-child {\n\t\t\tborder-bottom:0;\n\t\t}\n\t\t>.card-header {\n\t\t\tpadding:0;\n\t\t\tborder:0;\n\t\t\t> * {\n\t\t\t\tfont-size:0.875rem;\n\t\t\t\tfont-weight:500;\n\t\t\t\tpadding:.5rem 0;\n\t\t\t\tdisplay: block;\n\t\t\t\twidth:100%;\n\t\t\t\tcolor:$primary;\n\t\t\t\ttext-align:left;\n\t\t\t\tposition:relative;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder: none;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t@include transition(all 0.2s ease-in-out);\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\tfont: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 8px;\n\t\t\t\t\tright: 0;\n\t\t\t\t\t@include color-opacity($black_2,.3);\n\t\t\t\t}\n\t\t\t} \n\t\t\t>* {\n\t\t\t\t&.collapsed {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: '\\f2fc';\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t>div {\n\t\t\t>.card-body {\n\t\t\t\tpadding:.5rem 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Accordion*/\n.accordion {\n\t.accordion-button {\n\tcolor:$black_2;\n\tfont-weight:500;\n\tpadding:.75rem 1.25rem;\n\t&:not(.collapsed) {\n\t\tbackground:$primary;\n\t\tcolor:$white;\n\t\tbox-shadow: none;\n\t\tborder-bottom: 1px solid $grey_light_3;\n\t\t&::after {\n\t\t\tbackground:none;\n\t\t\t@include color-opacity($white,.3);\n\t\t}\n\t}\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t}\n\t\t&::after {\n\t\t\twidth: auto;\n\t\t\theight: auto;\n\t\t\tbackground:none;\n\t\t\tcontent: '\\f2f9';\n\t\t\tfont: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n\t\t\tfont-size: 1.25rem;\n\t\t\ttext-rendering: auto;\n\t\t\tposition: absolute;\n\t\t\ttop: 12px;\n\t\t\tright: 20px;\n\t\t\t@include color-opacity($black_2,.3);\n\t\t}\n\t\t\n\t}\n\t.accordion-item {\n\t\t&:first-of-type {\n\t\t\tborder-top-left-radius: calc(0.5rem - 1px);\n\t\t\tborder-top-right-radius: calc(0.5rem - 1px);\n\t\t\t.accordion-button {\n\t\t\t\tborder-top-left-radius: calc(0.5rem - 1px);\n\t\t\t\tborder-top-right-radius: calc(0.5rem - 1px);\n\t\t\t}\n\t\t}\n\t\t&:last-of-type {\n\t\t\tborder-bottom-left-radius: calc(0.5rem - 1px);\n\t\t\tborder-bottom-right-radius: calc(0.5rem - 1px);\n\t\t\t.accordion-button.collapsed {\n\t\t\t\tborder-bottom-right-radius: calc(0.5rem - 1px);\n\t\t\t\tborder-bottom-left-radius: calc(0.5rem - 1px);\n\t\t\t}\n\t\t}\n\t}\n\t&.accordion-flush {\n\t\t.accordion-item {\n\t\t\t&:first-of-type {\n\t\t\t\tborder-radius: 0;\n\t\t\t\t.accordion-button {\n\t\t\t\t\tborder-radius: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-of-type {\n\t\t\t\tborder-radius: 0;\n\t\t\t\t.accordion-button.collapsed {\n\t\t\t\t\tborder-radius: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.accordion-card {\n\t\t> .accordion-item {\n\t\t\tmargin-bottom: 1.875rem;\n\t\t\tborder-bottom: 1px;\n\t\t\tborder: 1px solid $grey_light_3;\n\t\t\tborder-radius: calc(0.5rem - 1px);\n\t\t\toverflow: hidden;\n\t\t}\n\t\t&.accordion-card-shadow > .accordion-item {\n\t\t\tbox-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);\n\t\t}\n\t\t&.accordion-card-bold {\n\t\t\t>.accordion-item {\n\t\t\t\t.accordion-body {\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.accordion-soft {\n\t\t.accordion-button { \n\t\t\t&:not(.collapsed) {\n\t\t\t\tbackground:$primary_light_5;\n\t\t\t\tcolor:$primary;\n\t\t\t\t&:after {\n\t\t\t\t\t@include color-opacity($black_2,.3);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.accordion-card {\n\t\t\t&.accordion-card-bold {\n\t\t\t\t>.accordion-item {\n\t\t\t\t\t.accordion-body {\n\t\t\t\t\t\tbackground:$primary_light_5;\n\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.accordion-soft-content {\n\t\t\t.accordion-button { \n\t\t\t\t&:not(.collapsed) {\n\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\n\t\t\t}\n\t\t\t>.accordion-item {\n\t\t\t\t.accordion-body {\n\t\t\t\t\tbackground:$primary_light_5;\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.accordion-simple {\n\t\t.accordion-button {\n\t\t\t&:not(.collapsed) {\n\t\t\t\tbackground:transparent;\n\t\t\t\tcolor:$primary;\n\t\t\t\t&::after {\n\t\t\t\t\t@include color-opacity($black_2,.3);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.accordion-card {\n\t\t\t&.accordion-card-bold {\n\t\t\t\t.accordion-button { \n\t\t\t\t\tborder-color: transparent;\n\t\t\t\t}\n\t\t\t\t.accordion-item  .accordion-body {\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tcolor:inherit;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.accordion-icon {\n\t\t.accordion-button {\n\t\t\t.acon-icon {\n\t\t\t\tmin-width: 30px;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tmargin-right: .625rem;\n\t\t\t\tfont-size: 1.5rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n/*Table*/\n.table {\n  --bs-table-striped-color: #{$black_2};\n  --bs-table-active-color: #{$black_2};\n  --bs-table-hover-color: #{$black_2};\n  --bs-table-hover-bg: #{$grey_light_5};\n\tcolor:$grey_dark_3;\n\tborder-color:$grey_light_4;\n\tthead th,\n\ttfoot th {\n\t\tvertical-align:middle;\n\t\tfont-weight:500;\n\t\tcolor:$black_2;\n\t\tfont-size: 0.875rem;\n\t\ttext-transform: capitalize;\n\t\t.form-check {\n\t\t\tfont-size: 1rem;\n\t\t}\n\t}\n\ttd,th {\n\t\tvertical-align: middle;\n\t\tpadding: .75rem 1.25rem;\n\t\ta.table-link-text {\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\t&.table-fixed {\n\t\ttable-layout:fixed;\n\t}\n\t&.table-lg { \n\t\ttd,th {\n\t\t\tpadding: 1rem 1.5rem;\n\t\t}\n\t}\n\t&:not(.table-borderless){\n\t\t>:not(:first-child) {\n\t\t\tborder-top:0;\n\t\t}\n\t}\n\t&.table-sm { \n\t\ttd,th {\n\t\t\tpadding:.625rem 1rem;\n\t\t}\n\t}\n\t&.nowrap {\n\t\tth, td {\n\t\t\twhite-space: nowrap;\n\t\t}\n\t} \n\t.tb-truncate {\n\t\tmax-width:1px;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\t>* {\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\t\n\t\t}\n\t}\n\t.thead-primary th,\n\t.thead-success th, \n\t.thead-info th, \n\t.thead-warning th, \n\t.thead-danger th, \n\t.thead-secondary th,\n\t.thead-dark th {\n\t\tcolor: $white;\n\t}\n\t.thead-success th {\n\t\tbackground-color: $success;\n\t}\n\t.thead-info th {\n\t\tbackground-color: $info;\n\t}\n\t.thead-warning th {\n\t\tbackground-color: $warning;\n\t}\n\t.thead-danger th {\n\t\tbackground-color: $danger;\n\t}\n\t.thead-secondary th\t{\n\t\tbackground-color: $secondary;\n\t}\n\t.thead-primary th {\n\t\tbackground-color: $primary;\n\t}\n\t.thead-light th {\n\t\tbackground-color: $grey_light_5;\n\t}\n\t.thead-dark th {\n\t\tbackground-color: $black_2;\n\t}\n\t&.table-dark {\n\t\tthead th, tfoot th {\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t&.table-fc-fixed {\n\t\tthead th:first-child {\n\t\t\tposition: sticky;\n\t\t\tleft: 0;\n\t\t\tz-index: 2;\n\t\t\tbackground: $white;\n\t\t}\n\t\ttbody {\n\t\t\tth,tr td:first-child {\n\t\t\t\tposition: sticky;\n\t\t\t\tleft: 0;\n\t\t\t\tz-index: 2;\n\t\t\t\tbackground: $white;\n\t\t\t}\n\t\t}\n\t}\n\t&.table-lc-fixed {\n\t\tthead th:last-child {\n\t\t\tposition: sticky;\n\t\t\tright: 0;\n\t\t\tz-index: 2;\n\t\t\tbackground: $white;\n\t\t}\n\t\ttbody {\n\t\t\ttr td:last-child {\n\t\t\t\tposition: sticky;\n\t\t\t\tright: 0;\n\t\t\t\tz-index: 2;\n\t\t\t\tbackground: $white;\n\t\t\t}\n\t\t}\n\t}\n\ttable thead th:first-child {\n\t\tposition: sticky;\n\t\tleft: 0;\n\t\tz-index: 2;\n\t}\n}\n.table-row-gap {\n\ttd {\n\t\tborder:0!important;\n\t}\n}\ntable.sticky-table-header thead tr th {\n\tposition: sticky;\n\ttop: 64px;\n\tz-index: 99;\n}\n.table-action-hover {\n\t.table-action {\n\t\topacity: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay:flex;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tbackground: $white;\n\t\tright: 1.25rem;\n\t\ttransition: all 0.1s;\n\t\t&::before {\n\t\t\twidth: 120px;\n\t\t\tcontent: \"\";\n\t\t\theight: 100%;\n\t\t\tmargin-left: -120px;\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tbackground-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, $white 100%);\n\t\t}\n\t}\t\n\ttr:hover {\n\t\t.table-action {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t&.table-hover {\n\t\t.table-action {\n\t\t\tbackground-color: var(--bs-table-hover-bg);\n\t\t\t&::before {\n\t\t\t\tbackground-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%,var(--bs-table-hover-bg) 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n\n@each $color, $value in $table-variants {\n\t@include table-variant($color, $value);\n}\n\n@media (max-width: 1200px) {\n\t.table-responsive  .table > tbody > tr > td, \n\t.table-responsive  .table > tbody > tr > th, \n\t.table-responsive  .table > tfoot > tr > td, \n\t.table-responsive  .table > tfoot > tr > th, \n\t.table-responsive  .table > thead > tr > td, \n\t.table-responsive  .table > thead > tr > th {\n\t\twhite-space:nowrap;\n\t}\n}\n/*Data Table*/\ntable {\n\t&.dataTable {\n\t\tthead {\n\t\t\ttd,th {\n\t\t\t\tposition: relative;\n\t\t\t\tbackground-image: none!important;\n\t\t\t\t&.sorting_asc,&.sorting_desc {\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t\tbackground-image: none !important;\n\t\t\t\t}\n\t\t\t\t&.sorting::before,\n\t\t\t\t&.sorting_asc::before,\n\t\t\t\t&.sorting_desc::before,\n\t\t\t\t&.sorting::after,\n\t\t\t\t&.sorting_asc::after,\n\t\t\t\t&.sorting_desc::after {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tfont-family: remixicon;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\ttext-transform: none;\n\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\tline-height: 1;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\tright: 7px;\n\t\t\t\t\ttop:50%;\n\t\t\t\t\t@include transform(translateY(-50%));\n\t\t\t\t}\n\t\t\t\t&.sorting::before,\n\t\t\t\t&.sorting_asc::before,\n\t\t\t\t&.sorting_desc::before,\n\t\t\t\t&.sorting::after,\n\t\t\t\t&.sorting_asc::after,\n\t\t\t\t&.sorting_desc::after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tbottom: auto;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&.sorting::before {\n\t\t\t\t\tcontent: \"\\ea72\";\n\t\t\t\t}\n\t\t\t\t&.sorting {\n\t\t\t\t\t&.sorting_asc::before {\n\t\t\t\t\t\tcontent: \"\\f0f9\";\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\t&.sorting_desc::after {\n\t\t\t\t\t\tcontent: \"\\f0fa\";\n\t\t\t\t\t}\n\t\t\t\t\t&.sorting_desc::before {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttbody {\n\t\t\ttr{\n\t\t\t\t&.selected {\n\t\t\t\t\ttd {\n\t\t\t\t\t\tbackground-color:$primary_light_5;\n\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.group,&.group:hover {\n\t\t\t\t\tcolor: $primary !important;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.dt-rowReorder-float {\n\t\toutline-offset: 0;\n\t\toutline-color: $primary;\n\t}\n}\ndiv.dataTables_wrapper {\n\t.dataTables_length {\n\t\tselect {\n\t\t\tmargin-right: .625rem;\n\t\t}\n\t}\n\tdiv.dataTables_filter input {\n\t\tmargin-left: 0!important;\n\t\twidth: 100%!important ;\n\t}\n\t.dataTables_scrollBody {\n\t\tthead th{\n\t\t\toverflow:hidden;\n\t\t}\n\t\tborder-left: 0!important;\n\t\ttable {\n\t\t\tmargin-bottom: 1rem!important;\n\t\t}\n\t}\n\tdiv.dataTables_info {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 100%;\n\t\tpadding-top: 0;\n\t}\n}\n\n/*Advance Table*/\n.table-advance {\n\tth,td {\n\t\tborder:none;\n\t}\n\ttbody tr {\n\t\t@include transition(all 200ms cubic-bezier(0.4, 0, 0.2, 1));\n\t\tborder-radius:0.5rem;\n\t\tth,td {\n\t\t\tborder:none;\n\t\t\tposition:relative;\n\t\t\t&:after {\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tborder-top: 1px solid $grey_light_3;\n\t\t\t\tborder-bottom: 1px solid $grey_light_3;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 0;\n\t\t\t\tpointer-events:none;\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\t&:after {\n\t\t\t\t\tborder-left: 1px solid $grey_light_3;\n\t\t\t\t\tborder-radius: 0.5rem 0 0 0.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t&:after {\n\t\t\t\t\tborder-right: 1px solid $grey_light_3;\n\t\t\t\t\tborder-radius: 0 0.5rem 0.5rem 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.table-row-gap {\n\t\t\tbox-shadow:none;\n\t\t\tpointer-events:none;\n\t\t\tth,td {\n\t\t\t\tpadding: .5rem;\n\t\t\t\t&:after {\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.table-striped tbody tr:nth-of-type(odd) {\n\t\tbackground-color: transparent;\n\t}\n}\n\n/*Apex Chart*/\n.apexcharts-legend {\n\t.apexcharts-legend-marker {\n\t\tmargin-right:.625rem;\n\t}\n}\n.apexcharts-toolbar {\n\tmax-width: inherit!important;\n\t.apexcharts-zoom-icon, \n\t.apexcharts-zoomin-icon, \n\t.apexcharts-zoomout-icon, \n\t.apexcharts-reset-icon, \n\t.apexcharts-pan-icon, \n\t.apexcharts-selection-icon, \n\t.apexcharts-menu-icon, \n\t.apexcharts-toolbar-custom-icon {\n\t\theight:auto;\n\t\twidth:auto;\n\t\tcolor:$black_2;\n\t\t@include transform(scale(1));\n\t\tmargin-left:1rem;\n\t\tmargin-right:0;\n\t}\n\tsvg {\n\t\tfill:none!important;\n\t\theight: 18px;\n\t\twidth: 18px;\n\t}\n\t.apexcharts-menu {\n\t\t@extend .dropdown-menu;\n\t\tmin-width: 10rem;\n\t\tpadding: .5rem 0;\n\t\tmargin: .125rem 0 0;\n\t\t.apexcharts-menu-item {\n\t\t\tpadding: .25rem 1.5rem;\n\t\t\ttext-align: left;\n\t\t\tcolor:$black_2;\n\t\t\tfont-size:1rem;\n\t\t\t&:hover {\n\t\t\t\tbackground-color:$grey_light_5;\n\t\t\t}\n\t\t}\n\t}\n}\n.apexcharts-canvas {\n\t.apexcharts-xaxistooltip,\n\t.apexcharts-yaxistooltip {\n\t\tfont-size:0.75rem;\n\t\tbackground:$black_2;\n\t\tcolor:$white;\n\t\tborder-radius:0.5rem;\n\t\tmax-width:200px;\n\t\tpadding:.25rem .5rem;\n\t\ttext-align:center;\n\t\t&:before,&:after {\n\t\t\tdisplay:none;\n\t\t}\n\t}\n\t.apexcharts-tooltip.apexcharts-theme-dark {\n\t\tborder-radius:0.5rem;\n\t\tmax-width:200px;\n\t\ttext-align:center;\n\t\tfont-size:0.75rem;\n\t}\n\t.apexcharts-tooltip.apexcharts-theme-light {\n\t\tborder-radius:0.5rem;\n\t\tfont-size: 1rem;\n\t\tcolor: $grey_dark_3;\n\t\tborder:none;\n\t\tbox-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.1);\n\t\t.apexcharts-tooltip-title {\n\t\t\tcolor: $white;\n\t\t\tbackground-color: $primary;\n\t\t\tborder-bottom: none;\n\t\t\tpadding: 0.65rem .75rem;\n\t\t\tborder-radius: 0.5rem 0.5rem 0 0;\n\t\t}\n\t\t.apexcharts-tooltip-series-group {\n\t\t\tpadding-left:.75rem;\n\t\t\tpadding-right:.75rem;\n\t\t}\n\t}\n}\n#chart_year,\n#chart_quarter {\n  width: 96%;\n  max-width: 48%;\n  box-shadow: none;\n  padding-left: 0;\n  padding-top: 1.25rem;\n  background: $white;\n}\n\n#chart_year {\n  float: left;\n  position: relative;\n  @include transition(1s ease transform);\n  z-index: 3;\n}\n\n#chart_year.chart_quarter-activated {\n  transform: translateX(0);\n    @include transition(1s ease transform);\n}\n\n#chart_quarter {\n  float: left;\n  position: relative;\n  z-index: -2;\n  @include transition(1s ease transform);\n}\n\n#chart_quarter.active {\n  @include transition(1.1s ease-in-out transform);\n  @include transform(translateX(0));\n  z-index: 1;\n}\n\n.apexcharts-datalabel-value {\n\tfill:$black_2!important;\n}\n@media screen and (min-width: 480px) {\n  #chart_year {\n\t@include transform(translateX(50%));\n  }\n  #chart_quarter {\n\t@include transform(translateX(-50%));\n  }\n}\n\n/*charts*/\n.hk-charts-pg { \n\t.hk-container-mwlg .card{\n\t\t.card-footer {\n\t\t\t@include transition(all .2s ease);\n\t\t\tmin-height: 139px;\n\t\t}\n\t\t&:hover {\n\t\t\t.card-footer {\n\t\t\t\tbackground:$grey_light_5;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Nestable*/\n.dd-handle {\n\t@extend .form-control;\n\tfont-weight: 500;\n\tmargin: 0 0 .375rem;\n\tpadding: .5rem 1rem;\n\tbackground:$white;\n\tcolor: $black_2;\n\theight: 37px;\n\tborder-width:1px;\n\tborder-color:$grey_light_3;\n\t&:hover,&:focus,&:active {\n\t\tcolor:$black_2;\n\t\tbackground:$grey_light_5;\n\t}\n}\n.dd-item > button {\n\tmargin:0;\n\theight:37px;\n\tfont-size:1.5rem;\n\twidth:42px;\n\tcolor:$grey;\n\toutline:none;\n\t\t&.dd-expand:before,&.dd-collapse:before {\n\t\t\tfont-family: 'Line Awesome Free';\n\t\t\tfont-weight: 900;\n\t\t\tline-height: 1;\n\t\t}\t\n\t\t&.dd-expand::before {\n\t\t\tcontent: \"\\f067\";\n\t\t}\n\t\t&.dd-collapse::before {\n\t\t\tcontent: \"\\f068\";\n\t\t}\n\t\t&:hover,&:focus,&:active {\n\t\t\toutline:none;\n\t\t}\n}\n.dd-placeholder {\n\tbackground:transparent;\n\tborder-color:$grey_light_3;\n\t\n}\n.dd3-content {\n\tdisplay: block;\n\twidth: 100%;\n\tborder-radius:0.5rem;\n\tfont-weight: 500;  \n\tmargin: 0 0 .375rem;    \n\tfont-size: 0.875rem;\n\tpadding: .5rem 1rem .5rem 4rem;\n\tbackground:$white;\n\tcolor: $black_2;\n\tborder:1px solid $grey_light_3;\n\t&:hover,&:focus,&:active {\n\t\tcolor:$black_2;\n\t\tbackground:$grey_light_5;\n\t}\n}\n.dd-dragel > .dd3-item > .dd3-content {\n  margin: 0;\n}\n.dd3-item > button {\n  margin-left: 2.625rem;\n}\n.dd3-handle {\n\tposition: absolute;\n\tmargin: 0;\n\tleft: 0;\n\ttop: 0;\n\tcursor: grab;\n\tcolor:$grey;\n\twidth: 42px;\n\ttext-indent: 100%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tpadding:1.125rem;\n\tborder-color:$grey_light_3;\n\tborder-radius:0.5rem 0 0 0.5rem;\n\t&:before {\n\t\tfont-family: 'Line Awesome Free';\n\t\tfont-weight: 900;\n\t\tcolor:$grey;\n\t\tcontent:\"\\f2a1\";\n\t\tfont-size: 1.625rem;\n\t\tcolor:$grey_light_3;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 8px;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\ttext-indent: 0;\n  }\n}\n/*Treeview*/\n.jstree-default {\n\t.jstree-clicked,\n\t.jstree-hovered {\n\t\tbackground: none;\n\t\tbox-shadow: none;\n\t\tcolor:$blue;\n\t}\n}\n/*Modals*/\n.modal-content,\n.modal-header,\n.modal-footer {\n\tborder-color:$grey_light_3;\n}\t\n.modal-content {\n\tborder-radius:0.5rem;\n\toverflow: hidden;\n\tborder:none;\n\tbox-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);\n}\t\n.modal-header {\n\tborder-top-left-radius: calc(0.5rem - 1px);\n\tborder-top-right-radius: calc(0.5rem - 1px);\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t&.header-wth-bg {\n\t\tbackground:$grey_light_5;\n\t\tborder-bottom: 0;\n\t}\n\t&.header-wth-bg-inv {\n\t\tbackground:$primary;\n\t\tborder-bottom: 0;\n\t\t.modal-title {\n\t\t\tcolor:$white;\n\t\t}\n\t}\n}\n.modal-body { \n\t> .btn-close {\n\t\tposition: absolute;\n\t\tright: 1.5rem;\n\t\ttop: 1.25rem;\n\t\t~ :is(h1, h2, h3, h4, h5, h6) {\n\t\t\tpadding-right: 1.5rem;\n\t\t\tmargin-top: 0.5rem;\n\t\t}\n\t}\n}\n.modal-footer {\n    border-bottom-right-radius: calc(0.5rem- 1px);\n    border-bottom-left-radius: calc(0.5rem - 1px);\n}\n.modal-backdrop {\n\tbackground-color:$black_2;\n}\nbody.modal-open {\n\tpadding-right:0!important;\n\t.hk-navbar {\n\t\tpadding-right:1rem!important;\n\t}\n}\n/*Close*/\n.btn-close {\n\tcolor:$black_2;\n\topacity: .6;\n\toutline:none;\n\theight: auto;\n\twidth: auto;\n\ttext-shadow:none;\n\tfont: normal normal normal 0/1 'Material-Design-Iconic-Font';\n\t-webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\t&:before {\n\t\tcontent: \"\\f136\";\n\t\tfont-size:1rem;\n\t}\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n\t&:not(:disabled):not(.disabled):not(.btn-close-white):focus, &:not(:disabled):not(.disabled):not(.btn-close-white):hover {\n\t\tcolor:$grey_dark_3;\n\t\topacity: 1;\n\t}\n\tspan {\n\t\tdisplay:none;\n\t}\n}\n.close-over {\n\t.btn-close {\n\t\theight: 22px;\n\t\twidth: 22px;\n\t\tbackground: $grey_dark_3;\n\t\tcolor: $white!important;\n\t\tborder-radius: 50%;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\tright: -11px;\n    \ttop: -11px;\n\t\topacity:1;\n\t\t&:before {\n\t\t\tcontent: \"\\f136\";\n\t\t\tfont-size: 1rem;\n\t\t\tline-height: 0;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: $black_2;\n\t\t}\n\t}\n}\n/*Sweet-alert*/\n.swal2-container {\n\t.swal2-content {\n\t\tcolor:$grey_dark_3;\n\t}\n\t.swal2-title {\n\t\tcolor:$black_2;\n\t}\n\t.swal2-popup {\n\t\tborder-radius:0.5rem;\n\t\t.swal2-validation-message {\n\t\t\tbackground:transparent;\n\t\t\talign-items: start;\n\t\t\tborder:none;\n\t\t\tcolor:$red;\n\t\t\t&:before {\n\t\t\t\tcontent: \"\\ED77\";\n\t\t\t\tfont-family: remixicon!important;\n\t\t\t\tfont-style: normal;\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\tbackground:transparent;\n\t\t\t\tcolor:$red;\n\t\t\t\tmin-width:auto;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t\t.swal2-image {\n\t\t\tborder-radius: 2rem;\n\t\t}\n\t\t.swal2-progress-steps {\n\t\t\t.swal2-progress-step {\n\t\t\t\tbackground:$green;\n\t\t\t\t&.swal2-active-progress-step {\n\t\t\t\t\tbackground: $blue;\n\t\t\t\t}\n\t\t\t\t&.swal2-active-progress-step ~ .swal2-progress-step {\n\t\t\t\t\tbackground:$grey_light_3;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.swal2-progress-step-line {\n\t\t\t\theight:.2rem;\n\t\t\t\tbackground:$blue;\n\t\t\t}\n\t\t}\n\t\t.swal2-close {\n\t\t\toutline:none;\n\t\t}\n\t}\n\t.swal2-title {\n\t\tfont-size: 1.1rem;\n\t\tspan {\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay:flex;\n\t\t}\n\t}\n\t&.swal2-has-header {\n\t\t.swal2-popup {\n\t\t\t.swal2-header {\n\t\t\t\tpadding-right: 1rem;\n\t\t\t\tpadding-left: 1rem;\n\t\t\t\tpadding-bottom:1rem;\n\t\t\t\tmargin-left:-1rem;\n\t\t\t\tmargin-right:-1rem;\n\t\t\t\tmargin-bottom:1rem;\n\t\t\t\tborder-bottom: 1px solid $grey_light_3;\n\t\t\t}\n\t\t}\n\t}\n\t&.swal2-has-footer {\n\t\t.swal2-popup.swal2-modal {\n\t\t\tpadding-bottom:0;\n\t\t\t.swal2-footer {\n\t\t\t\tmargin-left:-1rem;\n\t\t\t\tmargin-right:-1rem;\n\t\t\t\tborder-top:1px solid $grey_light_3;\n\t\t\t}\n\t\t}\n\t}\n\t&.swal2-has-bg {\n\t\t.swal2-popup {\n\t\t\t.swal2-content {\n\t\t\t\tbackground:$grey_light_5;\n\t\t\t\tmargin-left:-1rem;\n\t\t\t\tmargin-right:-1rem;\n\t\t\t\tmargin-top:-1rem;\n\t\t\t\tpadding-bottom: 2rem;\n\t\t\t\tpadding-top: 2rem;\n\t\t\t}\n\t\t\t.swal2-actions {\n\t\t\t\t.btn {\n\t\t\t\t\tflex:1;\n\t\t\t\t\tborder:0;\n\t\t\t\t\tpadding:0;\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\tcolor:$grey;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\t\n.swal2-shown {\n\tpadding-right:0!important;\n}\n/*Notification*/\n.alert {\n\tcolor:$black_2;\n\tborder-radius:0.5rem;\n\tpadding:0.75rem 1rem;\n\t.alert-link {\n\t\tfont-weight:normal;\n\t\tcolor: inherit;\n\t\ttext-decoration:underline;\n\t}\n\t&.alert-dismissible .btn-close {\n\t\tpadding: 0.9rem 1rem;\n\t\tcolor:inherit;\n\t\t&:before {\n\t\t\tposition:relative;\n\t\t\ttop:-2px;\n\t\t}\n\t\t&:hover {\n\t\t\topacity:1;\n\t\t\tcolor:inherit;\n\t\t}\n\t}\n\t&.alert-primary {\n\t\tcolor:$primary;\n\t\tbackground:$primary_light_5;\n\t\t@include border-opacity($primary_light_4,0.3);\n\t}\n\t&.alert-success {\n\t\tcolor:$success;\n\t\tbackground:$success_light_5;\n\t\t@include border-opacity($success_light_4,0.3);\n\t}\n\t&.alert-info {\n\t\tcolor:$info_dark_1;\n\t\tbackground:$info_light_5;\n\t\t@include border-opacity($info_light_4,0.3);\n\t}\n\t&.alert-danger {\n\t\tcolor:$danger;\n\t\tbackground:$danger_light_5;\n\t\t@include border-opacity($danger_light_4,0.3);\n\t}\n\t&.alert-warning {\n\t\tcolor:$warning_dark_2;\n\t\tbackground:$warning_light_5;\n\t\t@include border-opacity($warning_light_4,0.3);\n\t}\n\t&.alert-secondary {\n\t\tcolor:$secondary;\n\t\tbackground:$secondary_light_5;\n\t\t@include border-opacity($secondary_light_4,0.3);\n\t}\n\t&.alert-light {\n\t\tcolor:$grey_dark_4;\n\t\tbackground:$grey_light_5;\n\t\t@include border-opacity($grey_light_4,1);\n\t}\n\t&.alert-dark {\n\t\tcolor:$white;\n\t\tbackground:$black_2;\n\t\t&.alert-dismissible {\n\t\t\t.btn-close:not(:disabled):not(.disabled):focus, .btn-close:not(:disabled):not(.disabled):hover {\n\t\t\t\tcolor:$white;\n\t\t\t\ttext-decoration: none;\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t\tborder-color:$black_2;\n\t}\n\t&.alert-inv {\n\tcolor:$white;\n\t\t&.alert-inv-primary {\n\t\t\tbackground:$primary;\n\t\t\tcolor:$primary_light_5;\n\t\t\t&.alert-dismissible {\n\t\t\t\t.btn-close:not(:disabled):not(.disabled):focus, .btn-close:not(:disabled):not(.disabled):hover {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.alert-inv-info {\n\t\t\tbackground:$info;\n\t\t\tcolor:$info_light_5;\n\t\t\t&.alert-dismissible {\n\t\t\t\t.btn-close:not(:disabled):not(.disabled):focus, .btn-close:not(:disabled):not(.disabled):hover {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.alert-inv-success {\n\t\t\tbackground:$success;\n\t\t\tcolor:$success_light_5;\n\t\t\t&.alert-dismissible {\n\t\t\t\t.btn-close:not(:disabled):not(.disabled):focus, .btn-close:not(:disabled):not(.disabled):hover {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.alert-inv-warning {\n\t\t\tbackground:$warning;\n\t\t\tcolor:$warning_light_5;\n\t\t\t&.alert-dismissible {\n\t\t\t\t.btn-close:not(:disabled):not(.disabled):focus, .btn-close:not(:disabled):not(.disabled):hover {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.alert-inv-danger {\n\t\t\tbackground:$danger;\n\t\t\tcolor:$danger_light_5;\n\t\t\t&.alert-dismissible {\n\t\t\t\t.btn-close:not(:disabled):not(.disabled):focus, .btn-close:not(:disabled):not(.disabled):hover {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.alert-inv-secondary {\n\t\t\tbackground:$secondary;\n\t\t\tcolor:$secondary_light_5;\n\t\t\t&.alert-dismissible {\n\t\t\t\t.btn-close:not(:disabled):not(.disabled):focus, .btn-close:not(:disabled):not(.disabled):hover {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.alert-border-primary {\n\t\tborder-color:$primary;\n\t\tcolor:$primary;\n\t}\n\t&.alert-border-info {\n\t\tborder-color:$info;\n\t\tcolor:$info;\n\t}\n\t&.alert-border-success {\n\t\tborder-color:$success;\n\t\tcolor:$success;\n\t}\n\t&.alert-border-warning {\n\t\tborder-color:$warning;\n\t\tcolor:$warning;\n\t}\n\t&.alert-border-danger {\n\t\tborder-color:$danger;\n\t\tcolor:$danger;\n\t}\n\t&.alert-border-secondary {\n\t\tborder-color:$secondary;\n\t\tcolor:$secondary;\n\t}\n\t&.alert-wth-icon {\n\t\tpadding-left:3.375rem;\n\t\tposition:relative;\n\t\t.alert-icon-wrap {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tfont-size: 1.5rem;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\theight:100%;\n\t\t\twidth:54px;\n\t\t\tleft:0;\n\t\t\ttop:0;\n\t\t\tposition:absolute;\n\t\t}\n\t}\n\t&.alert-square {\n\t\tborder-radius:0;\n\t}\n}\n.alert-dismissible {\n\tpadding-right: 3rem;\n}\n.jq-toast-wrap {\n\twidth:300px;\n\t.jq-toast-single {\n\t\tcolor:$black_2;\n\t\tborder-radius:0.5rem;\n\t\tmargin:0;\n\t\tborder:none;\n\t\tbackground:$white;\n\t\t@extend .main-font;\n\t\tfont-size:0.875rem;\n\t\tline-height: 1.3;\n\t\t.jq-toast-loader {\n\t\t\tborder-radius:2px 2px 0 0;\n\t\t\theight: 2px;\n\t\t}\n\t\ta {\n\t\t\tcolor: inherit;\n\t\t\ttext-decoration: underline;\n\t\t\tfont-weight: inherit;\n\t\t\tborder-bottom:none;\n\t\t\tpadding-bottom: 0;\n\t\t\tfont-size: inherit;\n\t\t}\n\t\t.close-jq-toast-single {\n\t\t\tfont-size: 1.5rem;\n\t\t\ttop:0;\n\t\t}\t\n\t\t.jq-toast-heading {\n\t\t\tfont-size:1rem!important;\n\t\t\tcolor:inherit;\n\t\t\tfont-weight:500;\n\t\t\t@extend .main-font;\n\t\t}\t\n\t\t&.jq-toast-primary {\n\t\t\tbackground:$primary_light_5;\n\t\t\tcolor:$primary;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($primary_light_4,0.3);\n\t\t}\n\t\t&.jq-toast-secondary {\n\t\t\tbackground:$secondary_light_5;\n\t\t\tcolor:$secondary;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($secondary_light_4,0.3);\n\t\t}\n\t\t&.jq-toast-info {\n\t\t\tbackground:$info_light_5;\n\t\t\tcolor:$info;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($info_light_4,0.3);\n\t\t}\n\t\t&.jq-toast-success {\n\t\t\tbackground:$success_light_5;\n\t\t\tcolor:$success;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($success_light_4,0.3);\n\t\t}\n\t\t&.jq-toast-warning {\n\t\t\tbackground:$warning_light_5;\n\t\t\tcolor:$warning;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($warning_light_4,0.3);\n\t\t}\n\t\t&.jq-toast-danger {\n\t\t\tbackground:$danger_light_5;\n\t\t\tcolor:$danger;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($danger_light_4,0.3);\n\t\t}\n\t\t&.jq-toast-light {\n\t\t\tbackground:$grey_light_5;\n\t\t\tcolor:$grey_dark_4;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($grey_light_3,1);\n\t\t}\n\t\t&.jq-toast-dark {\n\t\t\tbackground:$black_2;\n\t\t\tcolor:$white;\n\t\t\tborder:1px solid;\n\t\t\t@include border-opacity($black_1,1);\n\t\t}\n\t\t&.jq-has-icon {\n\t\t\tpadding: .75rem 1.5rem .875rem 2.75rem;\n\t\t\t.jq-toast-icon {\n\t\t\t\tposition:absolute;\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tleft: 11px;\n\t\t\t\ttop: 14px;\n\t\t\t}\n\t\t}\n\t\t&.jq-toast-inv {\n\t\t\tcolor:$white;\n\t\t\tborder:none;\n\t\t\tbackground:$black_2;\n\t\t\t&.jq-toast-inv-primary {\n\t\t\t\tbackground:$primary;\n\t\t\t\tcolor:$primary_light_5;\n\t\t\t}\n\t\t\t&.jq-toast-inv-danger {\n\t\t\t\tbackground:$danger;\n\t\t\t\tcolor:$danger_light_5;\n\t\t\t}\n\t\t\t&.jq-toast-inv-warning {\n\t\t\t\tbackground:$warning;\n\t\t\t\tcolor:$warning_light_5;\n\t\t\t}\n\t\t\t&.jq-toast-inv-info {\n\t\t\t\tbackground:$info;\n\t\t\t\tcolor:$info_light_5;\n\t\t\t}\n\t\t\t&.jq-toast-inv-success {\n\t\t\t\tbackground:$success;\n\t\t\t\tcolor:$success_light_5;\n\t\t\t}\n\t\t}\n\t}\n}\t\n.bottom-center-fullwidth { \n\t.jq-toast-wrap{\n\t\tleft:0!important;\n\t\tright:0!important;\n\t\twidth:100%!important;\n\t\tbottom:0!important;\n\t\t.jq-toast-single {\n\t\t\tborder-radius:0;\n\t\t}\n\t}\n}\n.top-center-fullwidth {\n\t.jq-toast-wrap {\n\t\tleft:0!important;\n\t\tright:0!important;\n\t\twidth:100%!important;\n\t\ttop:2px!important;\n\t\t.jq-toast-single {\n\t\t\tborder-radius:0;\n\t\t}\n\t}\n}\n@media (max-width: 576px) {\n\t.jq-toast-wrap{\n\t\t&.top-right,\n\t\t&.top-left,\n\t\t&.bottom-right,\n\t\t&.bottom-left {\n\t\t\tleft:0;\n\t\t\tright:0;\n\t\t\twidth:100%;\n\t\t}\t\n\t}\n}\n/*Toast*/\n.toast {\n\tborder:none;\n\tborder-radius: 0.5rem;\n}\n/*Bootstrap Notify*/\nspan[data-notify=\"icon\"] {\n\tposition:relative;\n\ttop:3px;\n\tline-height:0;\n\tfont-size: 1rem;\n}\n/*Tooltop*/\n.tooltip {\n\tfont-size:0.75rem;\n\tfont-family: var(--bs-body-font-family);\n\t.tooltip-inner {\n\t\tbackground:$black_2;\n\t\tborder-radius:0.5rem;\n\t}\n\t&.show {\n\t\topacity:1;\n\t}\n\t.tooltip-arrow {\n\t\tdisplay:none;\n\t}\n}\n@media (max-width: 1024px) {\n\t.tooltip {\n\t\tdisplay:none!important;\n\t}\n}\n/*Images*/\n.img-thumbnail {\n    border-color: $grey_light_3;\n    border-radius: 0;\n}\n.img-background {\n\tbackground-size:cover;\n\tbackground-repeat:no-repeat;\n\tbackground-position:center;\n}\n/*Icons*/\n.font-icons-wrap {\n\tli {\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\tpadding: 1.875rem .625rem 1.875rem .625rem;\n\t\theight: 100px;\n\t\twidth: 100px;\n\t\tmargin: .625rem;\n\t\tmin-height: 60px;\n\t\tborder: solid 1px #eee;\n\t\tborder-radius:0.5rem;\n\t\tdisplay: -webkit-inline-box;\n\t\tdisplay: -ms-inline-flexbox;\n\t\tdisplay: inline-flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tcursor:pointer;\n\t\ta {\n\t\t\tcolor: $black_2;\n\t\t\tposition: relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tfont-size: 1.25rem;\n\t\t\t> i {\n\t\t\t\tfont-size: 1.625rem;\n\t\t\t\tline-height: 20px;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tposition: absolute;\n\t\t\t\tbackground-color: $blue;\n\t\t\t\tcolor: $white;\n\t\t\t\tpadding: .25rem .5rem;\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\ttop: 45px;\n\t\t\t\tleft: 50%;\n\t\t\t\tmin-width:98px;\n\t\t\t\tdisplay:none;\n\t\t\t\tborder-radius:.25rem;\n\t\t\t\t@include transform(translateX(-50%));\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\tbackground:$black_2;\n\t\t\ta {\n\t\t\t\tcolor:$white;\n\t\t\t\tspan {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.feather {\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n.svg-icon{\n\tline-height: 0 !important;\n}\n.feather-icon{\n\tline-height: 0 !important;\n\t&.fe-x {\n\t\t>svg {\n\t\t\theight:16px;\n\t\t\twidth:16px;\n\t\t}\t\n\t}\n\t&.fe-2x {\n\t\t>svg {\n\t\t\theight:32px;\n\t\t\twidth:32px;\n\t\t}\t\n\t}\n}\n.feather-icon > svg,\n.svg-icon > svg {\n\theight:1em;\n\twidth:1em;\n}\n.flag-icon {\n\theight:20px;\n\twidth:20px;\n}\n\n/*Carousel*/\n.carousel-control-prev,\n.carousel-control-next {\n\topacity:1;\n\t&:hover {\n\t\t.carousel-control-next-icon,\n\t\t.carousel-control-prev-icon\t{\n\t\t\t@include border-opacity($white, 1);\n\t\t}\n\t}\n}\n.carousel-control-next-icon,\n.carousel-control-prev-icon\t{\n\theight: 50px;\n\twidth: 50px;\n\tborder: 2px solid;\n\t@include border-opacity($white, 0.5);\n\tborder-radius: 50%;\n\tbackground:none;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\tfont-size: 1.25rem;\n\t&:before {\n\t\tdisplay: inline-block;\n\t\tfont: normal normal normal 22px/1 'Material-Design-Iconic-Font';\n\t\ttext-rendering: auto;\n\t\tpadding-left:.25rem;\n\t\tspeak: none;\n\t\ttext-transform: none;\n\t\ttext-rendering: auto;\n\t\tline-height: 1;\n\t\t-webkit-font-smoothing: antialiased;\n\t\t-moz-osx-font-smoothing: grayscale;\n\t}\n}\n.carousel-control-next-icon:before {\n\tcontent: \"\\f2fb\";\n}\n.carousel-control-prev-icon:before {\n\tcontent: \"\\f2fa\";\n}\n.custom-carousel-nav {\n\t.carousel-text-nav {\n\t\tposition:static;\n\t\tcolor:$black_2;\n\t\t&:hover,&:focus {\n\t\t\tcolor:$black_2;\n\t\t}\n\t}\n\t.carousel-indicators {\n\t\tposition:static;\n\t}\n}\n\n.carousel-indicators {\n\tbottom:20px;\n\tli[data-bs-target] {\n\t\twidth: 6px;\n\t\theight: 6px;\n\t\tmargin-right: .25rem;\n\t\tmargin-left: .25rem;\n\t\tborder:1px solid $white;\n\t\tborder-radius: 50%;\n\t\tbackground:transparent;\n\t\t&.active {\n\t\t\t@include background-opacity($grey_light_1,1);\n\t\t}\n\t}\n\t&.dark-indicators {\n\t\tli {\n\t\t\tborder-color:$black_2;\n\t\t\t&.active {\n\t\t\t\t@include background-opacity($black,1);\n\t\t\t}\n\t\t}\n\t}\n\t&.theme-indicators {\n\t\tli {\n\t\t\tborder-color:$primary;\n\t\t\t&.active {\n\t\t\t\t@include background-opacity($primary,1);\n\t\t\t}\n\t\t}\n\t}\n}\n.carousel-caption {\n    bottom: 30px;\n}\t\n.owl-carousel {\n\t.item-video {\n\t\theight:auto;\n\t}\n\t.owl-video-tn { \n\t\tbackground-size:cover;\n\t}\n\t.owl-dots .owl-dot {\n\t\tspan {\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tmargin: 0 .25rem;\n\t\t\tbackground:transparent;\n\t\t\tborder:1px solid $black_2;\n\t\t}\t\n\t\t&:focus {\n\t\t\toutline:none;\n\t\t}\n\t\t&:hover {\n\t\t\tspan {\n\t\t\t\tbackground:$black_2;\n\t\t\t}\t\n\t\t}\n\t\t&.active {\n\t\t\tspan {\n\t\t\t\tbackground:$black_2;\n\t\t\t}\n\t\t}\n\t}\n\t&.light-owl-dots {\n\t\t.owl-dots .owl-dot {\n\t\t\tspan {\n\t\t\t\tborder:1px solid $white;\n\t\t\t}\t\n\t\t\t&:focus {\n\t\t\t\toutline:none;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tspan {\n\t\t\t\t\tbackground:$white;\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tspan {\n\t\t\t\t\tbackground:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.theme-owl-dots {\n\t\t.owl-dots .owl-dot {\n\t\t\tspan {\n\t\t\t\tborder:1px solid $primary;\n\t\t\t}\t\n\t\t\t&:focus {\n\t\t\t\toutline:none;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tspan {\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tspan {\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.owl-video-play-icon {\n\t\t@include background-opacity($white,.8);\n\t\tleft: 20px;\n\t\tbottom: 20px;\n\t\tmargin: 0;\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tborder-radius: 50%;\n\t\ttop: auto;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tcolor:$blue;\n\t\t&:before {\n\t\t\tdisplay: inline-block;\n\t\t\tfont: normal normal normal 22px/1 'Material-Design-Iconic-Font';\n\t\t\ttext-rendering: auto;\n\t\t\tpadding-left:.25rem;\n\t\t\tspeak: none;\n\t\t\ttext-transform: none;\n\t\t\ttext-rendering: auto;\n\t\t\tline-height: 1;\n\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\tcontent:\"\\f3aa\";\n\t\t}\n\t\t&:hover {\n\t\t\t@include transform(scale(1.1,1.1));\n\t\t}\n\t}\n\t&.dots-on-item {\n\t\t.owl-dots {\n\t\t\tposition:absolute;\n\t\t\tleft:0;\n\t\t\tright:0;\n\t\t\tbottom:15px;\n\t\t}\n\t}\n}\n@media (max-width: 991px) {\n\t.carousel-control-next-icon, .carousel-control-prev-icon {\n\t\theight: 30px;\n\t\twidth: 30px;\n\t\tfont-size: 1rem;\n\t}\n}\n/*Twitter slider*/\n.twitter-slider-wrap {\n\ti.fa-twitter {\n\t\tfont-size:1.875rem;\n\t\tcolor:$white;\n\t}\n\t.owl-carousel {\n\t\ttext-align:center;\n\t\t.user,.interact {\n\t\t\tdisplay:none;\n\t\t}\n\t\t.tweet {\n\t\t\tfont-size:1rem;\n\t\t\tcolor:$white;\n\t\t\tmargin-bottom:1.875rem;\n\t\t\t> a {\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n\t\t.timePosted {\n\t\t\t> a {\n\t\t\t\tfont-size:0.75rem;\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n.product-detail-slider {\n\t.owl-carousel {\n\t\tborder-radius:0.5rem;\n\t\toverflow:hidden;\n\t\t@include boxshadow($black);\n\t}\n\t.thumb-wrap {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\t\n\t\tmargin-top:1rem;\n\t\t>a {\n\t\t\tdisplay:block;\n\t\t\tbackground-size:cover;\n\t\t\tbackground-position:center;\n\t\t\t@include boxshadow($black);\n\t\t\theight:50px;\n\t\t\twidth:100px;\n\t\t\tborder-radius:0.5rem;\n\t\t\tmargin:0 .625rem;\n\t\t\tbackground-color:$grey_light_3;\n\t\t\tborder:1px solid transparent;\n\t\t\t@include transition(all .2s ease);\n\t\t\t&.active-thumb {\n\t\t\t\tborder: 1px solid $blue;\n\t\t\t}\n\t\t}\n\t}\n}\n/*Color Pickr*/\n.form-control-color {\n    padding: .375rem;\n}\n.colorpicker-input-addon {\n\tpadding:0;\n\ti {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n}\n.pickr {\n\t.pcr-app {\n\t\tz-index: 1035;\n\t\t.pcr-interaction {\n\t\t\tinput {\n\t\t\t\tpadding: .3em .5em;\n\t\t\t\tletter-spacing:inherit;\n\t\t\t\tborder-radius: .25rem;\n\t\t\t\tbackground:$grey_light_5;\n\t\t\t\tcolor:$grey_light_1;\n\t\t\t}\n\t\t\t.pcr-save {\n\t\t\t\tbackground: $blue;\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t\t.pcr-clear {\n\t\t\t\tbackground: $red;\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t\t.pcr-type.active {\n\t\t\t\tbackground: $blue_light_5;\n\t\t\t\tcolor:$blue;\n\t\t\t}\n\t\t\t.pcr-result {\n\t\t\t\tcolor: $black_2;\n\t\t\t\tborder:1px solid $grey_light_3;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t&:focus {\n\t\t\t\t\tbox-shadow:none;\n\t\t\t\t\tborder-color:$blue;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.pcr-button {\n\t\twidth: 100%;\n\t\tborder-radius: 0;\n\t}\t\n}\t\n\n@media (max-width: 414px) {\n\t.pcr-app {\n\t\tmax-width:310px;\n\t}\n}\t\n/*Range Slider*/\n.irs-line {\n    height: 7px;\n    background: $grey_light_5;\n    border: none;\n}\n.irs-bar {\n    height: 7px; \n\tborder:none;\n    background: $primary;\n}\n.irs-slider {\n    top: 24px;\n    width: 25px;\n    height: 25px;\n    border: none;\n    background: $primary;\n\tborder-radius: 50%;\n    &.state_hover,&:hover {\n\t\tbackground: $primary;\n\t}\n}\n\n.irs-bar-edge {\n    height: 7px;\n    top: 33px;\n    width: 14px;\n    border: none;\n\tbackground: $primary;\n}\n.irs-from, .irs-to, .irs-single {\n    font-size: 0.75rem;\n\tfont-weight:500;\n    background: $black_2;\n\tline-height:1.5;\n\tpadding: .0625rem .5rem;\n    border-radius:0.5rem;\n}\n.irs-min, .irs-max {\n    color: inherit;\n    font-size: 0.75rem;\n    background: none;\n    line-height: 1.5;\n    border-radius: .25rem;\n    -moz-border-radius: .25rem;\n    font-weight: 500;\n}\n.irs.irs-sm {\n\t.irs-line {\n\t\theight: 3px;\n\t}\n\t.irs-bar {\n\t\theight: 3px; \n\t}\n\t.irs-slider {\n\t\ttop: 25px;\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n\n\t.irs-bar-edge {\n\t\theight: 3px;\n\t}\n}\n\n/*Daterangepicker*/\n.daterangepicker {\n\tfont-family: inherit;\n\tborder-color:$grey_light_3;\n\t&:before,&:after {\n\t\tdisplay:none;\n\t}\n\t.drp-buttons .btn {\n\t\tmargin-left: .5rem;\n\t\tpadding: .25rem .5rem;\n\t\tfont-size: .875rem;\n\t\tfont-weight:400;\n\t}\n\ttd {\n\t\t&.active,&.active:hover {\n\t\t\tbackground-color: $primary;\n\t\t\t&.available:hover {\n\t\t\t\tbackground-color: $primary;\n\t\t\t}\n\t\t}\n\t\t&.in-range {\n\t\t\tbackground-color: $primary_light_5;\n\t\t\tcolor:$black_2;\n\t\t\t&.active,&.active:hover {\n\t\t\t\tbackground-color: $primary;\n\t\t\t}\n\t\t}\n\t\t&.available:hover {\n\t\t\tbackground-color: $grey_light_5;\n\t\t}\n\t}\n\tth {\n\t\t&.available:hover {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\t.calendar-table {\n\t\tth,td {\n\t\t\tmin-width: 33px;\n\t\t\twidth: 33px;\n\t\t\theight: 33px;\n\t\t\tfont-size:0.875rem;\n\t\t\tposition: relative;\n\t\t\tborder: none;\n\t\t\t&.active,&.active:hover {\n\t\t\t\tcolor:$white;\n\t\t\t\t&.available:hover {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tth {\n\t\t\t&.next span,&.prev span {\n\t\t\t\tborder-color:$grey_light_1;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\t&.next span,&.prev span {\n\t\t\t\t\tborder-color:$black_2;\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t}\n\tth.month {\n\t\twidth: auto;\n\t\tfont-size: 0.875rem;\n\t\tcolor: $black_2;\n\t\tletter-spacing:.5px;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 600;\n\t}\t\n\t.drp-selected {\n\t\tfont-size: 0.875rem;\n\t\tpadding-right: .25rem;\n\t\tcolor: $black_2;\n\t\tfont-weight: 500;\n\t\tletter-spacing: 0.5px;\n\t}\t\n\ttd.off, td.off.in-range,td.off.start-date,td.off.end-date {\n\t\tcolor:$grey_light_3;\n\t}\n\tselect.hourselect, select.minuteselect, select.secondselect,select.ampmselect {\n\t\tbackground:$white;\n\t\twidth: 60px;\n\t\tmargin: .625rem auto;\n\t\tborder: 1px solid $grey_light_3;\n\t\tpadding: .25rem;\n\t\tborder-radius: .25rem;\n\t\tfont-size: 0.875rem;\n\t\tcolor: $black_2;\n\t}\n\tselect.monthselect, select.yearselect {\n\t\tbackground:$white;\n\t\tborder: 1px solid $grey_light_3;\n\t\tpadding: .25rem;\n\t\tborder-radius: .25rem;\n\t\tfont-size: 0.875rem;\n\t\tcolor: $black_2;\n\t}\n\t.ranges li {\n\t\tfont-size: 0.875rem;\n\t\tpadding:.625rem .75rem;\n\t\t&:hover {\n\t\t\tbackground-color: $grey_light_5;\n\t\t}\n\t\t&.active {\n\t\t\tbackground-color:$primary;\n\t\t}\n\t}\n\t&.show-ranges .drp-calendar.left {\n\t\tborder-color:$grey_light_3;\n\t}\n\t.drp-calendar.single {\n\t\t.calendar-time {\n\t\t\tpadding-right: 8px;\n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n \t.daterangepicker {\n\t\twidth: 281px;\n\t\t&.show-ranges {\n\t\t\t.drp-calendar.left {\n\t\t\t\tborder:none;\n\t\t\t}\n\t\t}\n\t\t.drp-buttons {\n\t\t\ttext-align:left;\n\t\t\t.btn {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-right: .5rem;\n\t\t\t}\n\t\t\t.drp-selected {\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-bottom: .625rem;\n\t\t\t}\n\t\t}\n\t\t&.ltr .ranges {\n\t\t\twidth: 100%;\n\t\t\tul {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t\t&.ltr .drp-calendar {\n\t\t\twidth: 100%;\n\t\t\t&.left .calendar-table {\n\t\t\t\tpadding-right: 0;\n\t\t\t}\n\t\t}\n\t}\n} \n\n/*Profile*/\n.profile-wrap {\n\t.profile-intro {\n\t\tposition:relative;\n\t\tz-index:1;\n\t\tmargin-top: -6rem;\n\t}\n\t.profile-img-wrap {\n\t\theight: 10rem;\n\t\tposition: relative;\n\t\t>img {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\theader.profile-header {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t\theight:65px;\n\t\tbackground:$white;\n\t\tborder-bottom:1px solid $grey_light_3;\n\t\tposition:relative;\n\t\t.profile-options-wrap {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t> a {\n\t\t\t\tmargin-left: .5rem;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\t&:first-child {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\n\t}\n\t.comment-block {\n\t\t.media {\n\t\t\t.media-head {\n\t\t\t\tmargin-right:1rem;\n\t\t\t}\n\t\t\t.media-body {\n\t\t\t\t> div {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t.cm-name {\n\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.comment-action-wrap {\n\t\t\t\t\tspan,a {\n\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t}\n\t\t\t\t\t.comment-dot-sep {\n\t\t\t\t\t\tmargin:0 .25rem;\n\t\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t>.media {\n\t\t\t\t\tmargin-top:1.875rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.comment-block {\n\t\t.media {\n\t\t\t.media-head {\n\t\t\t\tmargin-right:1rem;\n\t\t\t}\n\t\t\t.media-body {\n\t\t\t\t> div {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t.cm-name {\n\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.comment-action-wrap {\n\t\t\t\t\tspan,a {\n\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t}\n\t\t\t\t\t.comment-dot-sep {\n\t\t\t\t\t\tmargin:0 .25rem;\n\t\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t>.media {\n\t\t\t\t\tmargin-top:1.875rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.card.card-profile-feed {\n\t\t.btn-pg-link{\n\t\t\tposition:absolute;\n\t\t\tbottom:25px;\n\t\t\tleft:25px;\n\t\t}\n\t\t.feed-img-layout {\n\t\t\t.row {\n\t\t\t\tmargin-right: -0.25rem;\n\t\t\t\tmargin-left: -0.25rem;\n\t\t\t\t> [class*=\"col-\"] {\n\t\t\t\t\tpadding-right: .25rem;\n\t\t\t\t\tpadding-left: .25rem;\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t.feed-img {\n\t\t\t\tbackground-size:cover;\n\t\t\t\tbackground-repeat:no-repeat;\n\t\t\t\tbackground-position:center;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t\t.btn-video-link {\n\t\t\t@include background-opacity($black,.5);\n\t\t\theight: 45px;\n\t\t\twidth: 45px;\n\t\t\tposition:absolute;\n\t\t\tborder-radius: 50%;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tmargin:auto;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\t\n\t\t\tcolor: $white;\n\t\t\t&:before {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tfont: normal normal normal 1.5rem/1 'Material-Design-Iconic-Font';\n\t\t\t\tpadding-left: .25rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tfont-variant: normal;\n\t\t\t\ttext-transform: none;\n\t\t\t\ttext-rendering: auto;\n\t\t\t\tline-height: 1;\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\tcontent: \"\\f3aa\";\n\t\t\t}\n\t\t}\n\t\t.card-footer {\n\t\t\t>div {\n\t\t\t\ta {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor:$grey;\n\t\t\t\t\tfont-size:.875rem;\n\t\t\t\t\t>i {\n\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\tmargin-right:.5rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&:last-child {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\ta {\n\t\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\t\n.edit-profile-wrap {\n\t.nav-profile {\n\t\t.nav-header {\n\t\t\tfont-size: .75rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: $grey;\n\t\t}\n\t\t.nav {\n\t\t\tmargin: 1rem 0;\n\t\t\tfont-size: .875rem;\n\t\t\tflex-wrap: nowrap;\n\t\t\tborder: 0;\n\t\t\t.nav-item {\n\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\ta.nav-link {\n\t\t\t\t\t@include color-opacity($black_2,1);\n\t\t\t\t\tborder: 0;\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t@include color-opacity($black_2,.8);\n\t\t\t\t\t}\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n/*Activity*/\n.activity-list {\n\t.list-group-item {\n\t\tpadding: 0;\n\t\tborder: none;\n\t\t.media {\n\t\t\tposition: relative;\n\t\t\talign-items: inherit;\n\t\t\t.media-head {\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-right: 1rem;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-flow: column;\n\t\t\t\tmin-width: 48px;\n    \t\t\talign-items: center;\n\t\t\t\t> .avatar {\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.media-body {\n\t\t\t\tpadding-bottom: 1.5rem;\n\t\t\t\t.last-activity-time {\n\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.toggle-activity {\n\t\t\t.media .media-body{\n\t\t\t\tpadding-bottom: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t\t&:last-child {\n\t\t\t.media {\n\t\t\t\t.media-head {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.activity-wth-line {\n\t\t.list-group-item {\n\t\t\t.media {\n\t\t\t\t.media-head {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\twidth: 2.5px;\n\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\tborder-radius: 50rem;\n\t\t\t\t\t\tmargin: .5rem auto;\n\t\t\t\t\t\tmin-height: 25px;\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.activity-list-h {\n\tflex-direction: row;\n    .list-group-item {\n\t\tpadding: 0;\n\t\tborder: none;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding-bottom: 6.25rem;\n\t\talign-items: center;\n\t\t.media {\n\t\t\tflex-flow: column;\n\t\t\talign-items: center;\n\t\t\tflex:1;\n\t\t\t.media-body {\n\t\t\t\twidth: 400px;\n\t\t\t\tpadding: 0 .625rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\t.last-activity-time {\n\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t}\n\t\t\t\t.card {\n\t\t\t\t\twidth:100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.media-head {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\tposition:relative;\n\t\t\t\tmin-height: 48px;\n    \t\t\talign-items: center;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: 45px;\n\t\t\t\t&:after,\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\theight: 2.5px;\n\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tmargin: .5rem auto;\n\t\t\t\t\tright: 0;\n\t\t\t\t\twidth: 50%;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tmargin: auto 0;\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tleft:0;\n\t\t\t\t}\n\t\t\t\t.avatar {\n\t\t\t\t\tz-index: 1;\n\t\t\t\t\toutline: 7px solid $white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&:first-child {\n\t\t\t.media {\n\t\t\t\t.media-head {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&:last-child {\n\t\t\t.media {\n\t\t\t\t.media-head {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.activity-time {\n\t\t\ttext-align: center;\n\t\t\tfont-size:0.875rem;\n\t\t\tfont-weight:500;\n\t\t\tpadding:.5rem 0;\n\t\t\tcolor:$primary;\n\t\t\ttext-align:center;\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t}\n\t}\n}\t\n.user-activity {\n  .media {\n\t\tposition: relative;\n\t\tpadding-bottom: 1.25rem;\n\t\tmargin-left:1.25rem;\n\t\t.media-head {\n\t\t\tposition: absolute;\n\t\t\tleft: -20px;\n\t\t}\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: calc(100% - 77px);\n\t\t\tbackground: $grey_light_3;\n\t\t\ttop: 60px;\n\t\t}\n\t\t.media-body {\n\t\t\tpadding-bottom: 1.875rem;\n\t\t\tmargin-left: 2.5rem;\n\t\t\tmin-width:0;\n\t\t}\n\t\t&:last-child {\n\t\t\t.media-body {\n\t\t\t\tborder-bottom:none;\n\t\t\t}\n\t\t}\n\t}\n\t&.user-activity-sm {\n\t\t .media {\n\t\t\tpadding-bottom: .625rem;\n\t\t\tmargin-left:1rem;\n\t\t\t.media-head {\n\t\t\t\tleft: -16px;\n\t\t\t}\n\t\t\t.media-body {\n\t\t\t\tpadding-bottom: .625rem;\n\t\t\t\tmargin-left: 1.875rem;\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 576px) { \n\t.user-activity .media .media-body {\n\t\tmargin-left: 2.125rem;\n\t}\n}\n/*Wizards*/\n.hk-wizard {\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 0.875rem;\n\tfont-variant: tabular-nums;\n\tline-height: 1.5715;\n\tlist-style: none;\n\tfont-feature-settings: \"tnum\";\n\tdisplay: flex;\n\twidth: 100%;\n\tfont-size: 0;\n\ttext-align: initial;\n\t.hk-wizard-item {\n\t\t&:not(.hk-wizard-item-active) {\n\t\t\t>.hk-wizard-item-container[role=button] {\n\t\t\t\tcursor: pointer;\n\t\t\t\t.hk-wizard-item-title,\n\t\t\t\t.hk-wizard-item-subtitle,\n\t\t\t\t.hk-wizard-item-description,\n\t\t\t\t.hk-wizard-item-icon {\n\t\t\t\t\t.hk-wizard-icon {\n\t\t\t\t\t\t@include transition(color .3s);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\t.hk-wizard-item-title,\n\t\t\t\t\t.hk-wizard-item-subtitle,\n\t\t\t\t\t.hk-wizard-item-description {\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:not(.hk-wizard-item-process) {\n\t\t\t\t>.hk-wizard-item-container[role=button] {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t.hk-wizard-item-icon {\n\t\t\t\t\t\t\tborder-color: $primary;\n\t\t\t\t\t\t\t.hk-wizard-icon {\n\t\t\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&:not(.hk-wizard-vertical) {\n\t\t.hk-wizard-item-custom {\n\t\t\t.hk-wizard-item-icon {\n\t\t\t\twidth: auto;\n\t\t\t\tbackground: 0 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-item {\n\tposition: relative;\n\tdisplay: inline-block;\n\tflex: 1;\n\toverflow: hidden;\n\tvertical-align: top;\n\t&:last-child {\n\t\tflex: none;\n\t\t>.hk-wizard-item-container {\n\t\t\t>.hk-wizard-item-tail {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t>.hk-wizard-item-content {\n\t\t\t\t>.hk-wizard-item-title {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-item-container {\n\toutline: none;\n}\n.hk-wizard-item-icon {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twidth: 32px;\n\theight: 32px;\n\tmargin: 0 .5rem 0 0;\n\tfont-size: 1rem;\n\tline-height: 32px;\n\ttext-align: center;\n\tborder: 1px solid $grey_light_2;\n\tborder-radius: 2rem;\n\ttransition: background-color .3s, border-color .3s;\n\t.hk-wizard-icon {\n\t\tposition: relative;\n\t\ttop: -.5px;\n\t\tcolor: $primary;\n\t}\n}\n.hk-wizard-item-content {\n\tdisplay: inline-block;\n\tvertical-align: top;\n}\n.hk-wizard-item-tail {\n\tposition: absolute;\n\ttop: 12px;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 0 .625rem;\n\t&:after {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t\theight: 1px;\n\t\tbackground: $grey_light_3;\n\t\tborder-radius: 1px;\n\t\t@include transition(background .3s);\n\t\tcontent: \"\";\n\t}\n}\n.hk-wizard-item-title {\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding-right: 1rem;\n\tfont-size: 1rem;\n\tline-height: 32px;\n\tcolor:$black_2;\n\t&:after {\n\t\tposition: absolute;\n\t\ttop: 16px;\n\t\tleft: 100%;\n\t\tdisplay: block;\n\t\twidth: 9999px;\n\t\theight: 1px;\n\t\tbackground: $grey_light_3;\n\t\tcontent: \"\";\n\t}\n}\n.hk-wizard-item-subtitle {\n\tdisplay: inline;\n\tmargin-left: .5rem;\n\tfont-weight: 400;\n\tfont-size: 0.875rem;\n}\n.hk-wizard-item-description {\n\tfont-size: 0.875rem;\n}\n.hk-wizard-item-wait {\n\t>.hk-wizard-item-container>.hk-wizard-item-content>.hk-wizard-item-title {\n\t\tcolor: $grey_dark_3;\n\t}\n\t.hk-wizard-item-icon {\n\t\tbackground-color: $white;\n\t\tborder-color: $grey_light_2;\n\t\t>.hk-wizard-icon {\n\t\t\tcolor: $grey_light_2;\n\t\t\t.hk-wizard-icon-dot {\n\t\t\t\tbackground: $grey_light_2;\n\t\t\t}\n\t\t}\n\t}\n\t>.hk-wizard-item-container {\n\t\t>.hk-wizard-item-content {\n\t\t\t>.hk-wizard-item-title {\n\t\t\t\t&:after {\n\t\t\t\t\tbackground-color: $grey_light_3;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t>.hk-wizard-item-tail {\n\t\t\t&:after {\n\t\t\t\tbackground-color: $grey_light_3;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-item-process {\n\t.hk-wizard-item-icon {\n\t\tbackground-color: $white;\n\t\tborder-color: $primary;\n\t\t>.hk-wizard-icon {\n\t\t\tcolor: $primary;\n\t\t\t.hk-wizard-icon-dot {\n\t\t\t\tbackground: $primary;\n\t\t\t}\n\t\t}\n\t}\n\t>.hk-wizard-item-container {\n\t\t>.hk-wizard-item-content {\n\t\t\t>.hk-wizard-item-title {\n\t\t\t\tcolor: $black_2;\n\t\t\t\t&:after {\n\t\t\t\t\tbackground-color: $grey_light_3;\n\t\t\t\t}\n\t\t\t}\n\t\t\t>.hk-wizard-item-description {\n\t\t\t\tcolor: $black_2;\n\t\t\t}\n\t\t}\n\t\t>.hk-wizard-item-tail {\n\t\t\t&:after {\n\t\t\t\tbackground-color: $grey_light_3;\n\t\t\t}\n\t\t}\n\t\t>.hk-wizard-item-icon {\n\t\t\tbackground: $primary;\n\t\t\t.hk-wizard-icon {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t\t>.hk-wizard-item-title {\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n.hk-wizard-item-finish {\n\t.hk-wizard-item-icon {\n\t\tbackground-color: $white;\n\t\tborder-color: $primary;\n\t\t>.hk-wizard-icon {\n\t\t\tcolor: $primary;\n\t\t\t.hk-wizard-icon-dot {\n\t\t\t\tbackground: $primary;\n\t\t\t}\n\t\t}\n\t}\n\t>.hk-wizard-item-container {\n\t\t>.hk-wizard-item-content {\n\t\t\t>.hk-wizard-item-title {\n\t\t\t\tcolor: $black_2;\n\t\t\t\t&:after {\n\t\t\t\t\tbackground-color: $primary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t>.hk-wizard-item-tail {\n\t\t\t&:after {\n\t\t\t\tbackground-color: $primary;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-item-error {\n\t.hk-wizard-item-icon {\n\t\tbackground-color: $white;\n\t\tborder-color:$red;\n\t\t>.hk-wizard-icon {\n\t\t\tcolor:$red;\n\t\t\t.hk-wizard-icon-dot {\n\t\t\t\tbackground: $red;\n\t\t\t}\n\t\t}\n\t}\n\t>.hk-wizard-item-container {\n\t\t>.hk-wizard-item-content {\n\t\t\t>.hk-wizard-item-title {\n\t\t\t\tcolor:$red;\n\t\t\t\t&:after {\n\t\t\t\t\tbackground-color: $grey_light_3;\n\t\t\t\t}\n\t\t\t}\n\t\t\t>.hk-wizard-item-description {\n\t\t\t\tcolor:$red;\n\t\t\t}\n\t\t}\n\t\t>.hk-wizard-item-tail {\n\t\t\t&:after {\n\t\t\t\tbackground-color: $grey_light_3;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-item.hk-wizard-next-error {\n\t.hk-wizard-item-title {\n\t\t&:after {\n\t\t\tbackground: $red;\n\t\t}\n\t}\n}\n.hk-wizard-item-disabled {\n\tcursor: not-allowed;\n}\n.hk-wizard-horizontal {\n\t&:not(.hk-wizard-label-vertical) {\n\t\t.hk-wizard-item {\n\t\t\tpadding-left: 1rem;\n\t\t\twhite-space: nowrap;\n\t\t\t&:first-child {\n\t\t\t\tpadding-left: 0;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t.hk-wizard-item-title {\n\t\t\t\t\tpadding-right: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.hk-wizard-item-tail {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.hk-wizard-item-description {\n\t\t\tmax-width: 140px;\n\t\t\twhite-space: normal;\n\t\t}\n\t}\n}\n.hk-wizard-item-custom {\n\t>.hk-wizard-item-container {\n\t\t>.hk-wizard-item-icon {\n\t\t\theight: auto;\n\t\t\tbackground: 0 0;\n\t\t\tborder: 0;\n\t\t\t>.hk-wizard-icon {\n\t\t\t\ttop: 0;\n\t\t\t\tleft: .5px;\n\t\t\t\twidth: 32px;\n\t\t\t\theight: 32px;\n\t\t\t\tfont-size: 1.5rem;\n\t\t\t\tline-height: 32px;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-item-custom.hk-wizard-item-process {\n\t.hk-wizard-item-icon {\n\t\t>.hk-wizard-icon {\n\t\t\tcolor: $primary;\n\t\t}\n\t}\n}\n.hk-wizard-sm.hk-wizard-horizontal {\n\t&:not(.hk-wizard-label-vertical) {\n\t\t.hk-wizard-item {\n\t\t\tpadding-left: .75rem;\n\t\t\t&:first-child {\n\t\t\t\tpadding-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-sm {\n\t.hk-wizard-item-icon {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin: 0 .5rem 0 0;\n\t\tfont-size: 0.75rem;\n\t\tline-height: 24px;\n\t\ttext-align: center;\n\t\tborder-radius: 1.5rem;\n\t}\n\t.hk-wizard-item-title {\n\t\tpadding-right: .75rem;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 24px;\n\t\t&:after {\n\t\t\ttop: 12px;\n\t\t}\n\t}\n\t.hk-wizard-item-description {\n\t\tfont-size: 0.875rem;\n\t}\n\t.hk-wizard-item-tail {\n\t\ttop: 8px;\n\t}\n\t.hk-wizard-item-custom {\n\t\t.hk-wizard-item-icon {\n\t\t\twidth: inherit;\n\t\t\theight: inherit;\n\t\t\tline-height: inherit;\n\t\t\tbackground: 0 0;\n\t\t\tborder: 0;\n\t\t\tborder-radius: 0;\n\t\t\t>.hk-wizard-icon {\n\t\t\t\tfont-size: 1.5rem;\n\t\t\t\tline-height: 24px;\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-vertical {\n\tdisplay: flex;\n\tflex-direction: column;\n\t>.hk-wizard-item {\n\t\tdisplay: block;\n\t\tflex: 1 0 auto;\n\t\tpadding-left: 0;\n\t\toverflow: visible;\n\t\t.hk-wizard-item-icon {\n\t\t\tfloat: left;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t\t.hk-wizard-item-content {\n\t\t\tdisplay: block;\n\t\t\tmin-height: 48px;\n\t\t\toverflow: hidden;\n\t\t}\n\t\t.hk-wizard-item-title {\n\t\t\tline-height: 32px;\n\t\t}\n\t\t.hk-wizard-item-description {\n\t\t\tpadding-bottom: .75rem;\n\t\t}\n\t\t>.hk-wizard-item-container {\n\t\t\t>.hk-wizard-item-tail {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 16px;\n\t\t\t\twidth: 1px;\n\t\t\t\theight: 100%;\n\t\t\t\tpadding: 2.375rem 0 .375rem;\n\t\t\t\t&:after {\n\t\t\t\t\twidth: 1px;\n\t\t\t\t\theight: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t>.hk-wizard-item-content {\n\t\t\t\t>.hk-wizard-item-title {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&:not(:last-child) {\n\t\t\t>.hk-wizard-item-container {\n\t\t\t\t>.hk-wizard-item-tail {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-vertical.hk-wizard-sm {\n\t.hk-wizard-item-container {\n\t\t.hk-wizard-item-tail {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 12px;\n\t\t\tpadding: 1.875rem 0 .375rem;\n\t\t}\n\t\t.hk-wizard-item-title {\n\t\t\tline-height: 24px;\n\t\t}\n\t}\n}\n.hk-wizard-label-vertical {\n\t.hk-wizard-item {\n\t\toverflow: visible;\n\t}\n\t.hk-wizard-item-tail {\n\t\tmargin-left: 3.625rem;\n\t\tpadding: .25rem 1.5rem;\n\t}\n\t.hk-wizard-item-content {\n\t\tdisplay: block;\n\t\twidth: 116px;\n\t\tmargin-top: .5rem;\n\t\ttext-align: center;\n\t}\n\t.hk-wizard-item-icon {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 2.625rem;\n\t}\n\t.hk-wizard-item-title {\n\t\tpadding-right: 0;\n\t\tpadding-left: 0;\n\t\t&:after {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t.hk-wizard-item-subtitle {\n\t\tdisplay: block;\n\t\tmargin-bottom: 4px;\n\t\tmargin-left: 0;\n\t\tline-height: 1.5715;\n\t}\n}\n.hk-wizard-label-vertical.hk-wizard-sm {\n\t&:not(.hk-wizard-dot) {\n\t\t.hk-wizard-item-icon {\n\t\t\tmargin-left: 2.875rem;\n\t\t}\n\t}\n}\n.hk-wizard-dot {\n\t.hk-wizard-item-title {\n\t\tline-height: 1.5715;\n\t}\n\t.hk-wizard-item-tail {\n\t\ttop: 2px;\n\t\twidth: 100%;\n\t\tmargin: 0 0 0 4.375rem;\n\t\tpadding: 0;\n\t\t&:after {\n\t\t\twidth: calc(100% - 20px);\n\t\t\theight: 3px;\n\t\t\tmargin-left: .75rem;\n\t\t}\n\t}\n\t.hk-wizard-item {\n\t\t&:first-child {\n\t\t\t.hk-wizard-icon-dot {\n\t\t\t\tleft: 2px;\n\t\t\t}\n\t\t}\n\t}\n\t.hk-wizard-item-icon {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tmargin-left: 4.25rem;\n\t\tpadding-right: 0;\n\t\tline-height: 8px;\n\t\tbackground: 0 0;\n\t\tborder: 0;\n\t\t.hk-wizard-icon-dot {\n\t\t\tposition: relative;\n\t\t\tfloat: left;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tborder-radius: 6.25rem;\n\t\t\ttransition: all .3s;\n\t\t\t&:after {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -12px;\n\t\t\t\tleft: -26px;\n\t\t\t\twidth: 60px;\n\t\t\t\theight: 32px;\n\t\t\t\tcontent: \"\";\n\t\t\t}\n\t\t}\n\t}\n\t.hk-wizard-item-content {\n\t\twidth: 140px;\n\t}\n\t.hk-wizard-item-process {\n\t\t.hk-wizard-item-icon {\n\t\t\tposition: relative;\n\t\t\ttop: -1px;\n\t\t\twidth: 10px;\n\t\t\theight: 10px;\n\t\t\tline-height: 10px;\n\t\t\tbackground: 0 0;\n\t\t}\n\t\t.hk-wizard-icon {\n\t\t\t&:first-child {\n\t\t\t\t.hk-wizard-icon-dot {\n\t\t\t\t\tleft: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-dot.hk-wizard-sm {\n\t.hk-wizard-item-title {\n\t\tline-height: 1.5715;\n\t}\n\t.hk-wizard-item-tail {\n\t\ttop: 2px;\n\t\twidth: 100%;\n\t\tmargin: 0 0 0 4.375rem;\n\t\tpadding: 0;\n\t\t&:after {\n\t\t\twidth: calc(100% - 20px);\n\t\t\theight: 3px;\n\t\t\tmargin-left: .75rem;\n\t\t}\n\t}\n\t.hk-wizard-item {\n\t\t&:first-child {\n\t\t\t.hk-wizard-icon-dot {\n\t\t\t\tleft: 2px;\n\t\t\t}\n\t\t}\n\t}\n\t.hk-wizard-item-icon {\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tmargin-left: 4.25rem;\n\t\tpadding-right: 0;\n\t\tline-height: 8px;\n\t\tbackground: 0 0;\n\t\tborder: 0;\n\t\t.hk-wizard-icon-dot {\n\t\t\tposition: relative;\n\t\t\tfloat: left;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tborder-radius: 6.25rem;\n\t\t\t&:after {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -12px;\n\t\t\t\tleft: -26px;\n\t\t\t\twidth: 60px;\n\t\t\t\theight: 32px;\n\t\t\t\tcontent: \"\";\n\t\t\t}\n\t\t}\n\t}\n\t.hk-wizard-item-content {\n\t\twidth: 140px;\n\t}\n\t.hk-wizard-item-process {\n\t\t.hk-wizard-item-icon {\n\t\t\tposition: relative;\n\t\t\ttop: -1px;\n\t\t\twidth: 10px;\n\t\t\theight: 10px;\n\t\t\tline-height: 10px;\n\t\t\tbackground: 0 0;\n\t\t}\n\t\t.hk-wizard-icon {\n\t\t\t&:first-child {\n\t\t\t\t.hk-wizard-icon-dot {\n\t\t\t\t\tleft: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wizard-vertical.hk-wizard-dot {\n\t.hk-wizard-item-icon {\n\t\tmargin-top: .75rem;\n\t\tmargin-left: 0;\n\t\tbackground: 0 0;\n\t}\n\t.hk-wizard-item {\n\t\t>.hk-wizard-item-container {\n\t\t\t>.hk-wizard-item-tail {\n\t\t\t\ttop: 6.5px;\n\t\t\t\tleft: -9px;\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 1.375rem 0 .25rem;\n\t\t\t}\n\t\t}\n\t\t&:first-child {\n\t\t\t.hk-wizard-icon-dot {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t}\n\t}\n\t.hk-wizard-item-content {\n\t\twidth: inherit;\n\t}\n\t.hk-wizard-item-process {\n\t\t.hk-wizard-item-container {\n\t\t\t.hk-wizard-item-icon {\n\t\t\t\t.hk-wizard-icon-dot {\n\t\t\t\t\ttop: -1px;\n\t\t\t\t\tleft: -1px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Pricing Table*/\n.hk-pricing-table-1 {\n\t.table {\n\t\tth{\n\t\t\tfont-size:1rem;\n\t\t\twhite-space:inherit!important;\n\t\t}\n\t\tthead tr th{\n\t\t\th5 {\n\t\t\t\tpadding: .75rem 1.25rem;\n\t\t\t\tmargin:0 -1.25rem;\n\t\t\t\tborder-bottom: 1px solid $grey_light_3;\n\t\t\t}\n\t\t\t&.pricing-highlighted {\n\t\t\t\th5 {\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttbody {\n\t\t\t.monthly-price {\n\t\t\t\ttext-align:center;\n\t\t\t\t.money {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\tpadding-top: 1rem;\n\t\t\t\t}\n\t\t\t\t.price {\n\t\t\t\t\tsup {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tvertical-align: top;\n\t\t\t\t\t\tpadding-top: 1.5rem;\n\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t}\n\t\t\t\t\t.price-number {\n\t\t\t\t\t\tfont-size: 3.3rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.duration {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ttop: 10px;\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-pricing-table-2 {\n\t.table-responsive {\n\t\tpadding-top:3.125rem;\n\t}\n\t.table {\n\t\tth{\n\t\t\tfont-size:1rem;\n\t\t\twhite-space:inherit!important;\n\t\t}\n\t\t.pricing-highlighted {\n\t\t\t@include background-opacity($primary,.15);\n\t\t}\n\t\tthead tr th{\n\t\t\tposition:relative;\n\t\t\t&.pricing-highlighted {\n\t\t\t\th5 {\n\t\t\t\t\tpadding: .75rem 1.25rem;\n\t\t\t\t\ttop:-47px;\n\t\t\t\t\tposition:absolute;\n\t\t\t\t\tborder-bottom: 1px solid $grey_light_3;\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\tleft:-1px;\n\t\t\t\t\tright:-1px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttbody {\n\t\t\t.monthly-price {\n\t\t\t\ttext-align:center;\n\t\t\t\t.money {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\tpadding-top: 1rem;\n\t\t\t\t}\n\t\t\t\t.price {\n\t\t\t\t\tsup {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tvertical-align: top;\n\t\t\t\t\t\tpadding-top: 1.5rem;\n\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t}\n\t\t\t\t\t.price-number {\n\t\t\t\t\t\tfont-size: 3.3rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.duration {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ttop: 10px;\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-pricing-table-3 {\n\ttext-align:center;\n\t.table-responsive {\n\t\tpadding-top:3.125rem;\n\t}\n\t.table {\n\t\tth{\n\t\t\tfont-size:1rem;\n\t\t\twhite-space:inherit!important;\n\t\t\t.icon-wrap {\n\t\t\t\tmargin-top: 1.5rem;\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t}\n\t\t}\n\t\ttbody {\n\t\t\t.monthly-price {\n\t\t\t\t.money {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\tpadding-top: 1rem;\n\t\t\t\t}\n\t\t\t\t.price {\n\t\t\t\t\tsup {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tvertical-align: top;\n\t\t\t\t\t\tpadding-top: 1.5rem;\n\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t}\n\t\t\t\t\t.price-number {\n\t\t\t\t\t\tfont-size: 2.6rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.duration {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\tpadding-top: 1.125rem;\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Dropdown*/\n.dropdown-toggle{\n\t&.no-caret {\n\t\t&:after {\n\t\t\tdisplay:none;\n\t\t}\n\t}\n\t&:after {\n\t\tcontent: '\\f2f9';\n\t\tfont: normal normal normal 1rem/1 'Material-Design-Iconic-Font';\n\t\tborder: none!important;\n\t\tvertical-align: 0 !important;\n\t\tmargin-left: .4em;\n\t}\n\t&.dropdown-toggle-split {\n\t\t&:after,&:before {\n\t\t\tmargin:0!important;\n\t\t}\n\t}\n}\n.dropup .dropdown-toggle::after {\n\tcontent: '\\f2fc';\n\tmargin-left: .4em;\n}\n.dropstart {\n\t.dropdown-toggle::before {\n\t\tcontent: '\\f2fa';\n\t\tvertical-align: 0!important;\n\t\tfont: normal normal normal 1rem/1 'Material-Design-Iconic-Font';\n\t\tborder: none!important;\n\t\tmargin-right: .4em;\n\t}\n\t.dropdown-toggle::after {\n\t\tdisplay: none;\n\t}\n} \n.dropend .dropdown-toggle::after {\n\tcontent: '\\f2fb';\n\tvertical-align: 0;\n\tmargin-left: .4em;\n}\n.btn {\n\t&.btn-lg,&.btn-sm,&.btn-xs {\n\t\t&.dropdown-toggle {\n\t\t\t&:after,&:before {\n\t\t\t\tfont-size: inherit;\n\t\t\t}\n\t\t}\t\n\t}\n}\n.dropdown-menu {\n\tcolor:$grey_dark_3;\n\tborder:none;\n\tborder-radius:0.5rem;\n\tpadding: .5rem;\n\tbox-shadow:0px 6px 16px rgba(47, 52, 58, 0.1);\n\t.dropdown-item-text {\n\t\tcolor:$grey_dark_3;\n\t\tpadding: .5rem .75rem;\n\t}\n\t.dropdown-header {\n\t\tcolor:$grey;\n\t\tpadding: .5rem .75rem;\n\t\tfont-weight:500;\n\t\t&.dropdown-header-bold {\n\t\t\tfont-size: 0.75rem;\n\t\t\ttext-transform:uppercase;\n\t\t\tfont-weight:600;\n\t\t}\n\t\t&.header-wth-bg {\n\t\t\tbackground:$black_2;\n\t\t\tcolor:$white;\n\t\t\tmargin-top: -.5rem;\n\t\t\tmargin-left: -.5rem;\n\t\t\tmargin-right: -.5rem;\n\t\t\tmargin-bottom: .5rem;\n\t\t\tborder-top-left-radius: 0.5rem;\n\t\t\tborder-top-right-radius: 0.5rem;\n\t\t\tpadding-top: .8rem;\n\t\t\tpadding-bottom: .8rem;\n\t\t}\n\t}\n\t&.dropdown-bordered {\n\t\tborder:1px solid $grey_light_3;\n\t\tbox-shadow:none;\n\t}\n\t&.dropdown-menu-icon-text {\n\t\t.dropdown-item {\n\t\t\t.dropdown-item-text {\n\t\t\t\tpadding:0;\n\t\t\t}\n\t\t}\n\t}\n\t&.dropdown-menu-avatar {\n\t\t.dropdown-item {\n\t\t\tpadding-top:.3rem;\n\t\t\tpadding-bottom:.3rem;\n\t\t\t.dropdown-item-text {\n\t\t\t\tpadding:0;\n\t\t\t}\n\t\t\t.avatar {\n\t\t\t\tmargin-right:1rem;\n\t\t\t}\n\t\t}\n\t}\n\t.dropdown-item {\n\t\tcolor:$black_2;\n\t\tcursor:pointer;\n\t\tborder-radius:.25rem;\n\t\tpadding: .25rem .75rem;\n\t\t.dropdown-icon {\n\t\t\tfont-size: 1.125rem;\n\t\t\tmargin-right: .625rem;\n\t\t\twidth: 21px;\n\t\t\tposition: relative;\n\t\t\ttop:2px;\n\t\t\t&.feather-icon, .svg-icon {\n\t\t\t\ttop:-2px;\n\t\t\t}\t\n\t\t}\n\t\t&.active,&:active {\n\t\t\tbackground-color:$primary;\n\t\t\tcolor:$white;\n\t\t} \n\t\t&:focus:not(.active):not(.disabled),&:hover:not(.active):not(.disabled) {\n\t\t\tbackground-color:$grey_light_5;\n\t\t\tcolor:$black_2;\n\t\t}\n\t\t&:disabled,&.disabled {\n\t\t\tcolor:$grey_light_1;\n\t\t\tbackground-color:transparent;\n\t\t}\n\t}\n\t.sub-dropdown-menu {\n\t\tposition:relative;\n\t\t.dropdown-menu {\n\t\t\t&:before ,&:after{\n\t\t\t\tdisplay:none!important;\n\t\t\t}\n\t\t\ttop:0;\n\t\t\t&.open-left-side {\n\t\t\t\tright:100%!important;\n\t\t\t\tleft:auto!important;\n\t\t\t}  \n\t\t\t&.open-right-side {\n\t\t\t\tleft:100%!important;\n\t\t\t}  \n\t\t}\t\n\t}\n\t&.dropdown-menu-dark {\n\t\tbackground:$black_2;\n\t\tborder-color:$black_2;\n\t\tcolor:$white;\n\t\t.dropdown-header,\n\t\t.dropdown-item-text {\n\t\t\tcolor:$grey_dark_3;\n\t\t}\n\t\t.dropdown-item {\n\t\t\tcolor:$grey_light_4;\n\t\t\t&:focus:not(.active):not(.disabled),&:hover:not(.active):not(.disabled) {\n\t\t\t\tbackground-color:$grey_dark_5;\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t\t&.active,&:active {\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t\t&:disabled,&.disabled {\n\t\t\t\tcolor:$grey_dark_4;\n\t\t\t}\n\t\t}\n\t\t.dropdown-divider {\n\t\t\tborder-color: $black_2;\n\t\t}\n\t}\n}\n.dropdown-divider {\n\tborder-color: $grey_light_4;\n\tmargin-right:-.5rem;\n\tmargin-left:-.5rem;\n}\t\n.show-on-hover {\n\t&:hover > .dropdown-menu {\n\t\tdisplay: block;    \n\t}\n\t>.dropdown-toggle:active {\n\t\tpointer-events: none;\n\t}\n}\n.dropdown-menu.animated {\n  -webkit-animation-duration: 0.55s;\n  animation-duration: 0.55s;\n  \n  -webkit-animation-timing-function: ease;\n  animation-timing-function: ease;\n  \n}\n.custom-caret {\n\tsvg {\n\t\theight:19px;\n\t\twidth:19px;\n\t}\n}\n.btn-sm {\n\t.custom-caret {\n\t\tsvg {\n\t\t\theight:17px;\n\t\t\twidth:17px;\n\t\t}\n\t}\n}\n.btn-group-lg > .btn + .dropdown-toggle-split, \n.btn-lg + .dropdown-toggle-split {\n    padding-right: 1.3rem;\n    padding-left: 1.3rem;\n}\n.btn-group-sm > .btn + .dropdown-toggle-split, \n.btn-sm + .dropdown-toggle-split {\n    padding-right: .8rem;\n    padding-left: .8rem;\n}\n/*Avatar*/\n.avatar {\n    position: relative;\n    display: inline-block;\n    width: 4rem;\n    height: 4rem;\n\tvertical-align: middle;\n\tbackground-color: transparent;\n\t.avatar-img,\n\t.initial-wrap {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder-radius:0.5rem;\n\t\t-o-object-fit: cover;\n\t\tobject-fit: cover;\n\t}\n\t>.initial-wrap {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\tfont-size:1.1rem;\n\t\tfont-weight: 600;\n\t}\n\t&.avatar-rounded {\n\t\t.avatar-img,\n\t\t.initial-wrap {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n\t&.avatar-square {\n\t\t.avatar-img,\n\t\t.initial-wrap {\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\t&.avatar-xxxl {\n\t\twidth: 9rem;\n\t\theight: 9rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 2.25rem;\n\t\t}\n\t}\n\t&.avatar-xxl {\n\t\twidth: 8rem;\n\t\theight: 8rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 2rem;\n\t\t}\n\t}\n\t&.avatar-xl {\n\t\twidth: 7rem;\n\t\theight: 7rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 1.75rem;\n\t\t}\n\t}\n\t&.avatar-lg {\n\t\twidth: 6rem;\n\t\theight: 6rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 1.5rem;\n\t\t}\n\t}\n\t&.avatar-md {\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 1.25rem;\n\t\t}\n\t}\n\t&.avatar-sm {\n\t\twidth: 3rem;\n\t\theight: 3rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 1rem;\n\t\t}\n\t}\n\t&.avatar-xs {\n\t\twidth: 2rem;\n\t\theight: 2rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 0.75rem;\n\t\t}\n\t}\n\t&.avatar-xxs {\n\t\twidth: 1.5rem;\n\t\theight: 1.5rem;\n\t\t>.initial-wrap {\n\t\t\tfont-size: 0.6rem;\n\t\t}\n\t}\n\t&.avatar-icon {\n\t\t>.initial-wrap {\n\t\t\tfont-size: 1.5rem;\n\t\t\tfont-weight: inherit;\n\t\t}\n\t\t&.avatar-xxxl {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 2.75rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-xxl {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-xl {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 2.25rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-lg {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 2rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-md {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 1.75rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-sm {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 1.25rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-xs {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 1.25rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-xxs {\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: 1rem;\n\t\t\t}\n\t\t}\n\t}\n\t&.avatar-logo {\n\t\t>.initial-wrap {\n\t\t\tbackground: $grey_light_5;\n\t\t\t> img {\n\t\t\t\theight: 50%;\n\t\t\t}\n\t\t}\n\t}\n\t&.avatar-cyan {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $cyan !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-info {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $info !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-sky {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $sky !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-green {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $green !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-success {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $success !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-red {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $red !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-danger {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $danger !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-yellow {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $yellow !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-warning {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $warning !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-pink {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $pink !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-purple {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $purple !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-violet {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $violet !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-indigo {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $indigo !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-blue {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $blue !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-primary {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $primary !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-teal {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $teal !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-neon {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $neon !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-lime {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $lime !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-sun {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $sun !important;\n\t\t\tcolor: $black_2;\n\t\t}\n\t}\n\t&.avatar-orange {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $orange !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-pumpkin {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $pumpkin !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-brown {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $brown !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-gold {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $gold !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-dark {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $black_2 !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-light {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $grey_light_4 !important;\n\t\t\tcolor: $black_2;\n\t\t}\n\t}\n\t&.avatar-grey {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $grey !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-secondary {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $secondary !important;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t&.avatar-soft-cyan {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $cyan_light_5 !important;\n\t\t\tcolor: $cyan;\n\t\t}\n\t}\n\t&.avatar-soft-info {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $info_light_5 !important;\n\t\t\tcolor: $info;\n\t\t}\n\t}\n\t&.avatar-soft-sky {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $sky_light_5 !important;\n\t\t\tcolor: $sky;\n\t\t}\n\t}\n\t&.avatar-soft-green {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $green_light_5 !important;\n\t\t\tcolor: $green;\n\t\t}\n\t}\n\t&.avatar-soft-success {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $success_light_5 !important;\n\t\t\tcolor: $success;\n\t\t}\n\t}\n\t&.avatar-soft-red {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $red_light_5 !important;\n\t\t\tcolor: $red;\n\t\t}\n\t}\n\t&.avatar-soft-danger {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $danger_light_5 !important;\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n\t&.avatar-soft-yellow {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $yellow_light_5 !important;\n\t\t\tcolor: $yellow;\n\t\t}\n\t}\n\t&.avatar-soft-warning {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $warning_light_5 !important;\n\t\t\tcolor: $warning;\n\t\t}\n\t}\n\t&.avatar-soft-pink {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $pink_light_5 !important;\n\t\t\tcolor: $pink;\n\t\t}\n\t}\n\t&.avatar-soft-purple {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $purple_light_5 !important;\n\t\t\tcolor: $purple;\n\t\t}\n\t}\n\t&.avatar-soft-violet {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $violet_light_5 !important;\n\t\t\tcolor: $violet;\n\t\t}\n\t}\n\t&.avatar-soft-indigo {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $indigo_light_5 !important;\n\t\t\tcolor: $indigo;\n\t\t}\n\t}\n\t&.avatar-soft-blue {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $blue_light_5 !important;\n\t\t\tcolor: $blue;\n\t\t}\n\t}\n\t&.avatar-soft-primary {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $primary_light_5 !important;\n\t\t\tcolor: $primary;\n\t\t}\n\t}\n\t&.avatar-soft-teal {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $teal_light_5 !important;\n\t\t\tcolor: $teal;\n\t\t}\n\t}\n\t&.avatar-soft-neon {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $neon_light_5 !important;\n\t\t\tcolor: $neon;\n\t\t}\n\t}\n\t&.avatar-soft-lime {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $lime_light_5 !important;\n\t\t\tcolor: $lime;\n\t\t}\n\t}\n\t&.avatar-soft-sun {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $sun_light_5 !important;\n\t\t\tcolor: $sun;\n\t\t}\n\t}\n\t&.avatar-soft-orange {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $orange_light_5 !important;\n\t\t\tcolor: $orange;\n\t\t}\n\t}\n\t&.avatar-soft-pumpkin {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $pumpkin_light_5 !important;\n\t\t\tcolor: $pumpkin;\n\t\t}\n\t}\n\t&.avatar-soft-brown {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $brown_light_5 !important;\n\t\t\tcolor: $brown;\n\t\t}\n\t}\n\t&.avatar-soft-gold {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $gold_light_5 !important;\n\t\t\tcolor: $gold;\n\t\t}\n\t}\n\t&.avatar-soft-dark {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $grey_light_3 !important;\n\t\t\tcolor: $black_2;\n\t\t}\n\t}\n\t&.avatar-soft-light {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $grey_light_5 !important;\n\t\t\tcolor: $grey_dark_3;\n\t\t}\n\t}\n\t&.avatar-soft-grey {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $grey_light_5 !important;\n\t\t\tcolor: $grey;\n\t\t}\n\t}\n\t&.avatar-soft-secondary {\n\t\t>.initial-wrap {\n\t\t\tbackground-color: $secondary_light_5 !important;\n\t\t\tcolor: $secondary;\n\t\t}\n\t}\n}\n.avatar-group {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t.avatar { \n\t\twidth: 2.625rem;\n\t\theight: 2.625rem;\n\t\t.avatar-img,\n\t\t>.initial-wrap {\n\t\t\tborder:2px solid $white;\n\t\t\tfont-size: .9rem;\n\t\t}\n\t}\n\t&.avatar-group-overlapped {\n\t\t.avatar {\n\t\t\tmargin-right: -.875rem;\n\t\t\t&:hover{\n\t\t\t\tz-index:1;\n\t\t\t}\n\t\t}\n\t}\t\n\t&.avatar-group-lg {\n\t\t.avatar { \n\t\t\twidth: 3.25rem;\n\t\t\theight: 3.25rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .95rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -1rem;\n\t\t}\t\n\t}\n\t&.avatar-group-sm {\n\t\t.avatar { \n\t\t\twidth: 2rem;\n\t\t\theight: 2rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .6rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -0.625rem;\n\t\t}\t\n\t}\n}\n/*Pagination*/\n.pagination-wrap{\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n.page-link {\n\tcolor:$black_2;\n\tborder-color:$grey_light_3;\n\tmin-width: 40px;\n\tmin-height: 40px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\t&:focus,&:hover {\n\t\tcolor:$black_2;\n\t\tbox-shadow: none;\n\t\tbackground-color: $grey_light_4;\n\t\tborder-color: $grey_light_3;\n\t}\n}\n.pagination {\n\t.page-item {\n\t\t&.active {\n\t\t\t.page-link {\n\t\t\t\tbackground:$primary;\n\t\t\t\tborder-color:$primary;\n\t\t\t\tcolor:$white;\n\t\t\t}\t\n\t\t}\n\t\t&.disabled {\n\t\t\t.page-link {\n\t\t\t\tcolor:$grey_light_1;\n\t\t\t}\n\t\t}\n\t\t&:first-child .page-link {\n\t\t\tborder-top-left-radius: 0.5rem;\n\t\t\tborder-bottom-left-radius: 0.5rem;\n\t\t}\n\t\t&:last-child .page-link {\n\t\t\tborder-top-right-radius: 0.5rem;\n\t\t\tborder-bottom-right-radius: 0.5rem;\n\t\t}\n\t}\n\t&.custom-pagination {\n\t\t.page-item {\n\t\t\t+ .page-item {\n\t\t\t\tpadding-left: .5rem;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t\t.page-link {\n\t\t\tpadding: .5rem .8rem;\n\t\t\tborder-radius:0.5rem;\n\t\t}\n\t\t&.pagination-rounded {\n\t\t\t.page-link {\n\t\t\t\tborder-radius:50rem;\n\t\t\t}\n\t\t\t.page-item:first-child,\n\t\t\t.page-item:last-child {\n\t\t\t\t.page-link {\n\t\t\t\t\tborder-radius:50rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.pagination-filled {\n\t\t\t.page-item:not(.active) {\n\t\t\t\t.page-link {\n\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\tborder-color: $grey_light_5;\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\t.page-link {\n\t\t\t\t\t\tbackground-color: $grey_light_4;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\n\t\t&.pagination-simple {\n\t\t\t.page-item:not(.active) {\n\t\t\t\t.page-link {\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t}\n\t&.pagination-sm {\n\t\t.page-link {\n\t\t\tpadding: .3rem .6rem;\n\t\t\tmin-height:30px;\n\t\t\tmin-width:30px;\n\t\t}\n\t}\n}\n\n/*Badge*/\n.badge {\n\tfont-weight: 500;\n\tborder-radius:0.5rem;\n\tpadding: .5rem .625rem;\n\tfont-size: 70%;\n\tmin-width: 25px;\n\tletter-spacing: 0.3px;\n\tvertical-align: middle;  \n\tdisplay: inline-block;\n\ttext-align: center;\n\ttext-transform: capitalize;\n\t&.badge-indicator {\n\t\twidth: 10px;\n\t\theight:10px;\n\t\tmin-width: initial;\n\t\tborder:2px solid $white;\n\t\tborder-radius: 50%;\n\t\tpadding: 0;\n\t\tposition: relative;\n\t\t&:empty {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t\t&.badge-indicator-sm {\n\t\t\twidth: 7px;\n\t\t\theight: 7px;\n\t\t}\n\t\t&.badge-indicator-lg {\n\t\t\twidth: 12px;\n\t\t\theight: 12px;\n\t\t}\n\t\t&.badge-indicator-xl {\n\t\t\twidth: 16px;\n\t\t\theight: 16px;\n\t\t}\n\t\t&.badge-indicator-nobdr {\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tborder:none;\n\t\t}\n\t\t&.badge-indicator-nobdr-sm {\n\t\t\twidth: 5px;\n\t\t\theight: 5px;\n\t\t\tborder:none;\n\t\t}\n\t\t@-webkit-keyframes ripple {\n\t\t\t0% {\n\t\t\t\ttransform: scale(.8);\n\t\t\t\topacity: .5\n\t\t\t}\n\t\t\tto {\n\t\t\t\ttransform: scale(2.4);\n\t\t\t\topacity: 0\n\t\t\t}\n\t\t}\n\t\t\n\t\t@keyframes ripple {\n\t\t\t0% {\n\t\t\t\ttransform: scale(.8);\n\t\t\t\topacity: .5\n\t\t\t}\n\t\t\tto {\n\t\t\t\ttransform: scale(2.4);\n\t\t\t\topacity: 0\n\t\t\t}\n\t\t}\n\t\t&.badge-indicator-processing {\n\t\t\tposition: relative;\n\t\t\t&::after {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tborder: 1px solid;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\t-webkit-animation: ripple 1.2s infinite ease-in-out;\n\t\t\t\tanimation: ripple 1.2s infinite ease-in-out;\n\t\t\t\tcontent: \"\";\n\t\t\t}\n\t\t}\n\t}\n\t>span {\n\t\tdisplay:flex;\n\t\talign-items:center;\n\t\t.icon {\n\t\t\tdisplay:flex;\n\t\t\tfont-size:0.875rem;\n\t\t\tmargin-right:.25rem;\n\t\t}\n\t\t.badge-dot {\n\t\t\tdisplay:flex;\n\t\t\tfont-size:8px;\n\t\t\tmargin-right:.25rem;\n\t\t}\n\t}\n\t&.badge-sm {\n\t\tfont-size: 60%;\n\t\tpadding: .25rem .5rem;\n\t\tmin-width: 19px;\n\t\t>span {\n\t\t\t.badge-dot {\n\t\t\t\tfont-size:.375rem;\n\t\t\t}\n\t\t\t.icon {\n\t\t\t\tfont-size:0.75rem;\n\t\t\t}\n\t\t}\n\t}\n    \n\t&.badge-cyan {\n\t\tbackground:$cyan;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$cyan;\n\t\t}\n\t}\n\t&.badge-info {\n\t\tbackground:$info;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$info;\n\t\t}\n\t}\n\t&.badge-sky {\n\t\tbackground:$sky;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$sky;\n\t\t}\n\t}\n\t&.badge-green {\n\t\tbackground:$green;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$green;\n\t\t}\n\t}\n\t&.badge-success {\n\t\tbackground:$success;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$success;\n\t\t}\n\t}\n\t&.badge-red {\n\t\tbackground:$red;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$red;\n\t\t}\n\t}\n\t&.badge-danger {\n\t\tbackground:$danger;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$danger;\n\t\t}\n\t}\n\t&.badge-yellow {\n\t\tbackground:$yellow;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$yellow;\n\t\t}\n\t}\n\t&.badge-warning {\n\t\tbackground:$warning;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$warning;\n\t\t}\n\t}\n\t&.badge-pink {\n\t\tbackground:$pink;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$pink;\n\t\t}\n\t}\n\t&.badge-purple {\n\t\tbackground:$purple;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$purple;\n\t\t}\n\t}\n\t&.badge-violet {\n\t\tbackground:$violet;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$violet;\n\t\t}\n\t}\n\t&.badge-indigo {\n\t\tbackground:$indigo;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$indigo;\n\t\t}\n\t}\n\t&.badge-blue {\n\t\tbackground:$blue;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$blue;\n\t\t}\n\t}\n\t&.badge-primary {\n\t\tbackground:$primary;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$primary;\n\t\t}\n\t}\n\t&.badge-teal {\n\t\tbackground:$teal;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$teal;\n\t\t}\n\t}\n\t&.badge-neon {\n\t\tbackground:$neon;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$neon;\n\t\t}\n\t}\n\t&.badge-lime {\n\t\tbackground:$lime;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$lime;\n\t\t}\n\t}\n\t&.badge-sun {\n\t\tbackground:$sun;\n\t\tcolor:$black_2;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$sun;\n\t\t}\n\t}\n\t&.badge-orange {\n\t\tbackground:$orange;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$orange;\n\t\t}\n\t}\n\t&.badge-pumpkin {\n\t\tbackground:$pumpkin;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$pumpkin\n\t\t}\n\t}\n\t&.badge-smoke {\n\t\tbackground:$smoke;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$smoke;\n\t\t}\n\t}\n\t&.badge-brown {\n\t\tbackground:$brown;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$brown;\n\t\t}\n\t}\n\t&.badge-gold {\n\t\tbackground:$gold;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$gold;\n\t\t}\n\t}\n\t&.badge-grey {\n\t\tbackground:$grey;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$grey;\n\t\t}\n\t}\n\t&.badge-secondary {\n\t\tbackground:$secondary;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$secondary;\n\t\t}\n\t}\n\t&.badge-light {\n\t\tbackground:$grey_light_4;\n\t\tcolor:$black_2;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$grey_light_4;\n\t\t}\n\t}\n\t&.badge-dark {\n\t\tbackground:$black_2;\n\t\tcolor:$white;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$black_2;\n\t\t}\n\t}\n\t&.badge-outline {\n\t\tbackground:transparent;\n\t\tborder:1px solid;\n\t\t&.badge-cyan {\n\t\t\tborder-color:$cyan;\n\t\t\tcolor:$cyan;\n\t\t}\n\t\t&.badge-info {\n\t\t\tborder-color:$info;\n\t\t\tcolor:$info;\n\t\t}\n\t\t&.badge-sky {\n\t\t\tborder-color:$sky;\n\t\t\tcolor:$sky;\n\t\t}\n\t\t&.badge-green {\n\t\t\tborder-color:$green;\n\t\t\tcolor:$green_dark_2;\n\t\t}\n\t\t&.badge-success {\n\t\t\tborder-color:$success;\n\t\t\tcolor:$success_dark_2;\n\t\t}\n\t\t&.badge-red {\n\t\t\tborder-color:$red;\n\t\t\tcolor:$red_dark_1;\n\t\t}\n\t\t&.badge-danger {\n\t\t\tborder-color:$danger;\n\t\t\tcolor:$danger_dark_1;\n\t\t}\n\t\t&.badge-yellow {\n\t\t\tborder-color:$yellow;\n\t\t\tcolor:$yellow_dark_2;\n\t\t}\n\t\t&.badge-warning {\n\t\t\tborder-color:$warning;\n\t\t\tcolor:$warning_dark_2;\n\t\t}\n\t\t&.badge-grey {\n\t\t\tborder-color:$grey;\n\t\t\tcolor:$grey;\n\t\t}\n\t\t&.badge-secondary {\n\t\t\tborder-color:$secondary;\n\t\t\tcolor:$secondary;\n\t\t}\n\t\t&.badge-light {\n\t\t\tborder-color:$grey_light_4;\n\t\t\tcolor:$black_2;\n\t\t}\n\t\t&.badge-dark {\n\t\t\tborder-color:$black_2;\n\t\t\tcolor:$black_2;\n\t\t}\n\t\t&.badge-pink {\n\t\t\tborder-color:$pink;\n\t\t\tcolor:$pink;\n\t\t}\n\t\t&.badge-purple {\n\t\t\tborder-color:$purple;\n\t\t\tcolor:$purple;\n\t\t}\n\t\t&.badge-violet {\n\t\t\tborder-color:$violet;\n\t\t\tcolor:$violet;\n\t\t}\n\t\t&.badge-indigo {\n\t\t\tborder-color:$indigo;\n\t\t\tcolor:$indigo;\n\t\t}\n\t\t&.badge-blue {\n\t\t\tborder-color:$blue;\n\t\t\tcolor:$blue;\n\t\t}\n\t\t&.badge-primary {\n\t\t\tborder-color:$primary;\n\t\t\tcolor:$primary;\n\t\t}\n\t\t&.badge-teal {\n\t\t\tborder-color:$teal;\n\t\t\tcolor:$teal;\n\t\t}\n\t\t&.badge-neon {\n\t\t\tborder-color:$neon;\n\t\t\tcolor:$neon;\n\t\t}\n\t\t&.badge-lime {\n\t\t\tborder-color:$lime;\n\t\t\tcolor:$lime;\n\t\t}\n\t\t&.badge-sun {\n\t\t\tborder-color:$sun;\n\t\t\tcolor:$sun;\n\t\t}\n\t\t&.badge-orange {\n\t\t\tborder-color:$orange;\n\t\t\tcolor:$orange;\n\t\t}\n\t\t&.badge-pumpkin {\n\t\t\tborder-color:$pumpkin;\n\t\t\tcolor:$pumpkin;\n\t\t}\n\t\t&.badge-smoke {\n\t\t\tborder-color:$smoke;\n\t\t\tcolor:$smoke;\n\t\t}\n\t\t&.badge-brown {\n\t\t\tborder-color:$brown;\n\t\t\tcolor:$brown;\n\t\t}\n\t\t&.badge-gold {\n\t\t\tborder-color:$gold;\n\t\t\tcolor:$gold;\n\t\t}\n\t}\n\t&.badge-soft-cyan {\n\t\tbackground:$cyan_light_5;\n\t\tcolor:$cyan;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$cyan_light_5;\n\t\t}\n\t}\n\t&.badge-soft-info {\n\t\tbackground:$info_light_5;\n\t\tcolor:$info;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$info_light_5;\n\t\t}\n\t}\n\t&.badge-soft-sky {\n\t\tbackground:$sky_light_5;\n\t\tcolor:$sky;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$sky_light_5;\n\t\t}\n\t}\n\t&.badge-soft-green {\n\t\tbackground:$green_light_5;\n\t\tcolor:$green_dark_2;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$green_light_5;\n\t\t}\n\t}\n\t&.badge-soft-success{\n\t\tbackground:$success_light_5;\n\t\tcolor:$success_dark_2;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$success_light_5;\n\t\t}\n\t}\n\t&.badge-soft-red {\n\t\tbackground:$red_light_5;\n\t\tcolor:$red_dark_1;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$red_light_5;\n\t\t}\n\t}\n\t&.badge-soft-danger {\n\t\tbackground:$danger_light_5;\n\t\tcolor:$danger_dark_1;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$danger_light_5;\n\t\t}\n\t}\n\t&.badge-soft-yellow {\n\t\tbackground:$yellow_light_5;\n\t\tcolor:$yellow_dark_2;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$yellow_light_5;\n\t\t}\n\t}\n\t&.badge-soft-warning {\n\t\tbackground:$warning_light_5;\n\t\tcolor:$warning_dark_2;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$warning_light_5;\n\t\t}\n\t}\n\t&.badge-soft-pink {\n\t\tbackground:$pink_light_5;\n\t\tcolor:$pink;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$pink_light_5;\n\t\t}\n\t}\n\t&.badge-soft-purple {\n\t\tbackground:$purple_light_5;\n\t\tcolor:$purple;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$purple_light_5;\n\t\t}\n\t}\n\t&.badge-soft-violet {\n\t\tbackground:$violet_light_5;\n\t\tcolor:$violet;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$violet_light_5;\n\t\t}\n\t}\n\t&.badge-soft-indigo {\n\t\tbackground:$indigo_light_5;\n\t\tcolor:$indigo;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$indigo_light_5;\n\t\t}\n\t}\n\t&.badge-soft-blue {\n\t\tbackground:$blue_light_5;\n\t\tcolor:$blue;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$blue_light_5;\n\t\t}\n\t}\n\t&.badge-soft-primary {\n\t\tbackground:$primary_light_5;\n\t\tcolor:$primary;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$primary_light_5;\n\t\t}\n\t}\n\t&.badge-soft-teal {\n\t\tbackground:$teal_light_5;\n\t\tcolor:$teal;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$teal_light_5;\n\t\t}\n\t}\n\t&.badge-soft-neon {\n\t\tbackground:$neon_light_5;\n\t\tcolor:$neon;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$neon_light_5;\n\t\t}\n\t}\n\t&.badge-soft-lime {\n\t\tbackground:$lime_light_5;\n\t\tcolor:$lime;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$lime_light_5;\n\t\t}\n\t}\n\t&.badge-soft-sun {\n\t\tbackground:$sun_light_5;\n\t\tcolor:$sun;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$sun_light_5;\n\t\t}\n\t}\n\t&.badge-soft-orange {\n\t\tbackground:$orange_light_5;\n\t\tcolor:$orange;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$orange_light_5;\n\t\t}\n\t}\n\t&.badge-soft-pumpkin {\n\t\tbackground:$pumpkin_light_5;\n\t\tcolor:$pumpkin;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$pumpkin_light_5;\n\t\t}\n\t}\n\t&.badge-soft-smoke {\n\t\tbackground:$smoke_light_5;\n\t\tcolor:$smoke;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$smoke_light_5;\n\t\t}\n\t}\n\t&.badge-soft-brown {\n\t\tbackground:$brown_light_5;\n\t\tcolor:$brown;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$brown_light_5;\n\t\t}\n\t}\n\t&.badge-soft-gold {\n\t\tbackground:$gold_light_5;\n\t\tcolor:$gold;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$gold_light_5;\n\t\t}\n\t}\n\t&.badge-soft-grey {\n\t\tbackground:$grey_light_5;\n\t\tcolor:$grey;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$grey_light_5;\n\t\t}\n\t}\n\t&.badge-soft-secondary {\n\t\tbackground:$secondary_light_5;\n\t\tcolor:$secondary;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$secondary_light_5;\n\t\t}\n\t}\n\t&.badge-soft-light {\n\t\tbackground:$grey_light_5;\n\t\tcolor:$grey_dark_3;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$grey_light_5;\n\t\t}\n\t}\n\t&.badge-soft-dark {\n\t\tbackground: $grey_light_3;\n\t\tcolor:$black_2;\n\t\t&.badge-indicator-processing:after {\n\t\t\tborder-color:$grey_light_3;\n\t\t}\n\t}\n\t&.badge-pill {\n\t\tborder-radius:50rem;\n\t}\n}\na {\n\t&.badge {\n\t\t@include transition(all .15s ease);\n\t\t&:hover,&:focus {\n\t\t\t@include transform(translateY(-3px));\n\t\t\t@include boxshadow-badge-link($black);\n\t\t}\n\t}\n\t&.badge-sky {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($sky);\n\t\t}\n\t}\n\t&.badge-cyan {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$cyan;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($cyan);\n\t\t}\n\t}\n\t&.badge-info {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$info;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($info);\n\t\t}\n\t}\n\t&.badge-blue {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$blue;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($blue);\n\t\t}\n\t}\n\t&.badge-primary {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$primary;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($primary);\n\t\t}\n\t}\n\t&.badge-green {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$green;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($green);\n\t\t}\n\t}\n\t&.badge-success {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$success;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($success);\n\t\t}\n\t}\n\t&.badge-red {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$red;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($red);\n\t\t}\n\t}\n\t&.badge-danger {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$danger;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($danger);\n\t\t}\n\t}\n\t&.badge-yellow {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$yellow;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($yellow);\n\t\t}\n\t}\n\t&.badge-warning {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$warning;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($warning);\n\t\t}\n\t}\n\t&.badge-grey {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$grey;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($grey);\n\t\t}\n\t}\n\t&.badge-secondary {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$secondary;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($secondary);\n\t\t}\n\t}\n\t&.badge-pink {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($pink);\n\t\t}\n\t}\n\t&.badge-purple {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($purple);\n\t\t}\n\t}\n\t&.badge-violet {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($violet);\n\t\t}\n\t}\n\t&.badge-indigo {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($indigo);\n\t\t}\n\t}\n\t&.badge-teal {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($teal);\n\t\t}\n\t}\n\t&.badge-neon {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($neon);\n\t\t}\n\t}\n\t&.badge-lime {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($lime);\n\t\t}\n\t}\n\t&.badge-sun {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($sun);\n\t\t}\n\t}\n\t&.badge-orange {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($orange);\n\t\t}\n\t}\n\t&.badge-pumpkin {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($pumpkin);\n\t\t}\n\t}\n\t&.badge-smoke {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($smoke);\n\t\t}\n\t}\n\t&.badge-brown {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($brown);\n\t\t}\n\t}\n\t&.badge-gold {\n\t\t&:hover,&:focus {\n\t\t\t@include boxshadow-badge-link($gold);\n\t\t}\n\t}\n\t&.badge-light {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$grey_light_4;\n\t\t\tcolor:$black_2;\n\t\t\t@include boxshadow-badge-link($grey_light_3,1);\n\t\t}\n\t}\n\t&.badge-dark {\n\t\t&:hover,&:focus {\n\t\t\tbackground:$black_2;\n\t\t\tcolor:$white;\n\t\t\t@include boxshadow-badge-link($black_2);\n\t\t}\n\t}\n\t&.badge-outline {\n\t\t&:hover,&:focus {\n\t\t\tbackground:transparent;\n\t\t\tbox-shadow: none;\n\t\t}\t\n\t}\t\n}\n.badge-status {\n\t.badge-label {\n\t\tmargin-left:.25rem;\n\t\tfont-size:0.875rem;\n\t}\n}\n.badge-on-text {\n\t.badge {\n\t\tposition: relative;\n\t\ttop:-5px;\n\t\tright: 0;\n\t}\n}\n.badge-on-text-end {\n\t.badge {\n\t\tmargin-left:.5rem;\n\t\tposition: relative;\n\t\ttop: -1px;\n\t}\n}\n\n/*List Group*/\n.list-group-item { \n\tborder-color:$grey_light_3;\n\t&:first-child {\n\t\tborder-top-left-radius: 0.5rem;\n\t\tborder-top-right-radius: 0.5rem;\n\t}\n\t&:last-child {\n\t\tborder-bottom-right-radius: 0.5rem;\n\t\tborder-bottom-left-radius: 0.5rem;\n\t}\n\t&.active {\n\t\tbackground-color: $primary;\n\t\tborder-color: $primary;\n\t\th1,h2,h3,h4,h5,h6 {\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t&.disabled,&:disabled {\n\t\tcolor:$grey_light_1;\n\t}\n\t&.list-group-item-action:not(.active):focus, &.list-group-item-action:not(.active):hover {\n\t\tbackground-color:$grey_light_5;\n\t}\n\t&.list-group-item-primary:not(.active) { \n\t\tcolor:$primary;\n\t\tbackground-color:$primary_light_5;\n\t}\n\t&.list-group-item-info:not(.active) { \n\t\tcolor:$info;\n\t\tbackground-color:$info_light_5;\n\t}\n\t&.list-group-item-success:not(.active) { \n\t\tcolor:$success;\n\t\tbackground-color:$success_light_5;\n\t}\n\t&.list-group-item-warning:not(.active) { \n\t\tcolor:$warning;\n\t\tbackground-color:$warning_light_5;\n\t}\n\t&.list-group-item-danger:not(.active) { \n\t\tcolor:$danger;\n\t\tbackground-color:$danger_light_5;\n\t}\n\t&.list-group-item-secondary:not(.active) { \n\t\tcolor:$secondary;\n\t\tbackground-color:$secondary_light_5;\n\t}\n\t&.list-group-item-light:not(.active) { \n\t\tcolor:$grey_dark_4;\n\t\tbackground-color:$grey_light_5;\n\t}\n\t&.list-group-item-dark:not(.active) { \n\t\tcolor:$white;\n\t\tbackground-color:$black_2;\n\t}\n\t&.list-group-inv {\n\t\tcolor:$white;\n\t\t&.list-group-inv-primary:not(.active) {\n\t\t\tbackground-color:$primary;\n\t\t\tborder-color:$primary;\n\t\t}\n\t\t&.list-group-inv-info:not(.active) {\n\t\t\tbackground-color:$info;\n\t\t\tborder-color:$info;\n\t\t}\n\t\t&.list-group-inv-success:not(.active) {\n\t\t\tbackground-color:$success;\n\t\t\tborder-color:$success;\n\t\t}\n\t\t&.list-group-inv-warning:not(.active) {\n\t\t\tbackground-color:$warning;\n\t\t\tborder-color:$warning;\n\t\t}\n\t\t&.list-group-inv-danger:not(.active) {\n\t\t\tbackground-color:$danger;\n\t\t\tborder-color:$danger;\n\t\t}\n\t\t&.list-group-inv-secondary:not(.active) {\n\t\t\tbackground-color:$secondary;\n\t\t\tborder-color:$secondary;\n\t\t}\n\t}\n}\n.list-group-horizontal-xxl,\n.list-group-horizontal-xl,\n.list-group-horizontal-lg,\n.list-group-horizontal-md,\n.list-group-horizontal-sm,\n.list-group-horizontal {\n\t>.list-group-item:first-child {\n\t\tborder-bottom-left-radius: 0.5rem;\n\t}\n\t>.list-group-item:last-child {\n\t\tborder-top-right-radius: 0.5rem;\n\t}\n}\n.list-group {\n\t&.active-info {\n\t\t.list-group-item {\n\t\t\t&.active {\n\t\t\t\tbackground-color: $info;\n\t\t\t\tborder-color: $info;\n\t\t\t}\n\t\t}\n\t}\n\t&.active-success {\n\t\t.list-group-item {\n\t\t\t&.active {\n\t\t\t\tbackground-color: $success;\n\t\t\t\tborder-color: $success;\n\t\t\t}\n\t\t}\n\t}\n\t&.active-warning {\n\t\t.list-group-item {\n\t\t\t&.active {\n\t\t\t\tbackground-color: $warning;\n\t\t\t\tborder-color: $warning;\n\t\t\t}\n\t\t}\n\t}\n\t&.active-danger {\n\t\t.list-group-item {\n\t\t\t&.active {\n\t\t\t\tbackground-color: $danger;\n\t\t\t\tborder-color: $danger;\n\t\t\t}\n\t\t}\n\t}\n\t&.active-primary {\n\t\t.list-group-item {\n\t\t\t&.active {\n\t\t\t\tbackground-color: $primary;\n\t\t\t\tborder-color: $primary;\n\t\t\t}\n\t\t}\n\t}\n\t&.active-secondary {\n\t\t.list-group-item {\n\t\t\t&.active {\n\t\t\t\tbackground-color: $secondary;\n\t\t\t\tborder-color: $secondary;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Google Map*/\n.infowindow-wrap {\n\t.infowindow-header {\n\t\tcolor: $black_2;\n\t\tpadding: 0 5px;\n\t\t@extend .main-font;\n\t}\n\t.infowindow-body {\n\t\tpadding: 0 .25rem;\n\t\tcolor: $grey_dark_3;\n\t\tfont-size: 1rem;\n\t\t@extend .main-font;\n\t}\n}\n\n/*Vecotor Map*/\n.jvectormap-zoomin, \n.jvectormap-zoomout {\n\tline-height: 9px;\n\tbackground:$black_2;\n\tpadding:.25rem;\n\twidth: .75rem;\n    height: 13px;\n\tborder-radius:0;\n}\n.jvectormap-zoomout { \n\ttop:31px;\n}\n.jvectormap-goback {\n\tpadding: .15rem .4rem;\n\tfont-size: .75rem;\n\tbackground:$primary;\n\tborder-radius: 0.2rem;\n}\n.jvectormap-legend-cnt-h {\n\t.jvectormap-legend-tick-sample {\n\t\theight: 23px;\n\t}\n\t.jvectormap-legend {\n\t\tbackground: $black_2;\n\t\tpadding: .25rem;\n\t\tborder-radius: .125rem;\n\t\t&.jvectormap-legend-icons {\n\t\t\tcolor: $black_2;\n\t\t\tbackground: $white;\n\t\t\tborder: $grey_light_2 1px solid;\n\t\t}\n\t\t.jvectormap-legend-title {\n\t\t\tfont-weight: 500;\n\t\t\tmargin-bottom:.625rem\n\t\t}\n\t\t.jvectormap-legend-tick {\n\t\t\twidth: 55px;\n\t\t\t.jvectormap-legend-tick-text {\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t\tfont-weight: 500;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t\tmargin-top:.25rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Progressbar*/\n.progress { \n\tborder-radius:0;\n\t&.progress-bar-rounded {\n\t\tborder-radius:50rem;\n\t\t.progress-bar {\n\t\t\tborder-radius:50rem;\n\t\t}\n\t}\n\t&.progress-bar-xs {\n\t\theight:5px;\n\t}\n\t&.progress-bar-sm {\n\t\theight:9px;\n\t}\n\t&.progress-bar-md {\n\t\theight:13px;\n\t}\n\t&.progress-bar-lg {\n\t\theight:18px;\n\t}\n\t&.progress-bar-xl {\n\t\theight:20px;\n\t}\n\t.progress-bar {\n\t\tbackground-color:$primary;\n\t\t.progress-tooltip {\n\t\t\tposition: absolute;\n\t\t\tright: 0-20px;\n\t\t\twidth: 50px;\n\t\t\tbackground:$black_2;\n\t\t\tbottom: 25px;\n\t\t\tborder-radius: .3rem;\n\t\t\tpadding: .25rem .625rem;\n\t\t\tfont-size: 0.75rem;\n\t\t\theight: 30px;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t&:after {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\t\t\t\tbottom: -10px;\n\t\t\t\tleft: -5px;\n\t\t\t\tright: 0;\n\t\t\t\tmargin: auto;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tborder: .6em solid rgba(240, 210, 210, 0.1);\n\t\t\t\tborder-color: transparent transparent $black_2 $black_2;\n\t\t\t\ttransform-origin: 0 0;\n\t\t\t\t@include transform(rotate(-45deg));\n\t\t\t}\n\t\t}\n\t}\n\t&.progress-width-animated {\n\t\toverflow:visible!important;\n\t\t.progress-bar {\n\t\t\toverflow:visible!important;\n\t\t\tposition:relative;\n\t\t}\n\t}\n}\n.progress-label {\n\ttext-transform: capitalize;\n\tfont-size: 0.875rem;\n\tfont-weight: 400;\n\tmargin-bottom:.5rem;\n}\n.progress-wrap {\n\t&.lb-side-left {\n\t\t.progress-lb-wrap {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\t.progress-label {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tpadding-right: 1rem;\n\t\t\t\tflex: 0 0 auto;\n\t\t\t\t-ms-flex: 0 0 auto;\n\t\t\t\tmargin-bottom:0;\n\t\t\t}\n\t\t\t.progress {\n\t\t\t\tflex: 1 1 100%;\n\t\t\t\t-ms-flex: 1 1 100%;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\t\n\t}\n} \n/*Togglable*/\n.hk-sidebar-togglable {\n\theight: 25px;\n    width: 25px;\n    left: -12.5px;\n\tborder-radius:50%;\n\ttop:52px;\n\tposition: absolute;\n\tbackground: $white;\n\tcursor:pointer;\n\tborder: 1px solid $grey_light_3;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\t-ms-flex-pack: center;\n\t@include boxshadow-sm($black);\n\t@include transition(transform .3s ease-in-out);\n\tz-index:2;\n\t&:after {\n\t\tcontent: \"\\ea62\";\n\t\tfont-family: remixicon;\n\t\ttext-rendering: auto;\n\t}\n\t&.active {\n\t\t@include transform(translateX(32px));\n\t\t&:after {\n\t\t\tcontent: \"\\ea6c\";\n\t\t}\n\t}\n}\t\n\n/*Advance List*/\n.advance-list {\n\tpadding-left: 0;\n\t> li {\n\t\tmargin-bottom:1.25rem;\n\t\t&:last-child {\n\t\t\tmargin-bottom:0;\n\t\t}\n\t}\n}\n.advance-list-item {\n\tpadding: .5rem 1.25rem;\n    min-height: 50px;\n    border: 1px solid $grey_light_3;\n    border-radius:0.5rem;\n\tlist-style: none;\n\tbackground:$white;\n\tposition: relative;\n\t@include transition(all .3s cubic-bezier(0.4, 0, 0.2, 1));\n\t&:hover {\n\t\t@include transform(scale(1.02,1.02));\n\t\tz-index:1;\n\t\tbox-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\t}\n\t&.drp-open {\n\t\tz-index:4;\n\t}\n}\n\n/*Light Gallery*/\n.lg-outer {\n\t.lg-img-wrap {\n\t\tpadding: 0;\n\t}\n}\n.lg-outer .lg-video .lg-object {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 0;\n\tright:0;\n\tmargin:auto;\n\twidth: auto !important;\n    height: 100% !important;\n}\n/*Cropperjs*/\n.img-container, .img-preview {\n  background-color: $grey_light_5;\n  width: 100%;\n  text-align: center;\n}\n\n.img-container {\n  min-height: 200px;\n  max-height: 469px;\n  margin-bottom: 1rem;\n  > img {\n    max-width: 100%;\n  }\n}\n\n.docs-preview {\n  margin-right: -1rem;\n}\n\n.img-preview {\n  float: left;\n  margin-right: .5rem;\n  margin-bottom: .5rem;\n  overflow: hidden;\n  > img {\n    max-width: 100%;\n  }\n}\n\n.preview-lg {\n  width: 255px;\n  height: 143px;\n}\n\n.preview-md {\n  width: 128px;\n  height: 72px;\n}\n\n.preview-sm {\n  width: 72px;\n  height: 41px;\n}\n\n.preview-xs {\n  width: 40px;\n  height: 24px;\n  margin-right: 0;\n}\n\n.docs-data > .input-group {\n  margin-bottom: .5rem;\n  > {\n    label {\n      min-width: 80px;\n    }\n  }\n}\n\n.docs-buttons > {\n  .btn, .btn-group, .form-control {\n    margin-right: .25rem;\n    margin-bottom: .5rem;\n  }\n}\n\n.docs-toggles > {\n  .btn, .btn-group, .dropdown {\n    margin-bottom: .5rem;\n  }\n}\n\n.docs-tooltip {\n  display: block;\n  margin: -0.5rem -0.75rem;\n  padding: .5rem .75rem;\n}\n\n.docs-aspect-ratios, .docs-view-modes {\n  width: 100%;\n}\n\n.docs-aspect-ratios > .btn {\n  width: 20%;\n}\n\n.docs-view-modes > .btn {\n  width: 25%;\n}\n\n.docs-options .dropdown-menu {\n  width: 100%;\n  > li {\n    padding: .25rem 1rem;\n    &:hover {\n      background-color: #f7f7f7;\n    }\n    > label {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.docs-cropped .modal-body {\n  text-align: center;\n  > {\n    img, canvas {\n      max-width: 100%;\n    }\n  }\n}\n\n.common-credits > li {\n    display: block;\n    margin-bottom: 1rem;\n\t&:last-child {\n\t\tmargin-bottom:0;\n\t}\n}\n/*Bootstrap TimeOut*/\n#session-timeout-dialog {\n\t.modal-header{\n\t\tbackground: $red;\n\t\t.modal-title {\n\t\t\tcolor:$white;\n\t\t}\n\t\tbutton.btn-close {\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.modal-body {\n\t\tp.mb-10 {\n\t\t\tfont-size:1.1rem;\n\t\t}\n\t\t.countdown-holder {\n\t\t\tcolor:$red;\n\t\t}\n\t\t.progress {\n\t\t\tmargin-top:1.25rem;\n\t\t}\n\t}\n\t.modal-footer {\n\t\tborder-top:none;\n\t}\n}\n\n/*Hopscotch*/\ndiv.hopscotch-bubble {\n\tborder:none;\n\tbox-shadow:0px 4px 16px 0 rgba(0, 0, 0, 0.12);\n\tborder-radius:0.25rem;\n\tfont-size: 0.875rem;\n\tfont-family: var(--bs-body-font-family);\n\t.hopscotch-bubble-container {\n\t\t.hopscotch-bubble-number {\n\t\t\tdisplay:none;\n\t\t}\n\t\t.hopscotch-bubble-content {\n\t\t\tmargin:0;\n\t\t}\n\t\th3 {\n\t\t\tcolor: $black_2;\n\t\t\tfont-family: var(--bs-body-font-family);\n\t\t\tfont-size: 1.1rem;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 1.2;\n\t\t\tmargin: -1px 16px 4px 0;\n\t\t\tpadding: 0;\n\t\t}\n\t\t.hopscotch-content {\n\t\t\tcolor: $grey_dark_3;\n\t\t\tfont-family: var(--bs-body-font-family);\n\t\t\tline-height: inherit;\n\t\t\tmargin:.5rem 0;\n\t\t\tfont-weight: inherit;\n\t\t\tpadding:0;\n\t\t}\n\t\t.hopscotch-actions {\n\t\t\tmargin: 1.25rem 0 0;\n\t\t\t.hopscotch-nav-button {\n\t\t\t\toutline:none;\n\t\t\t\tbackground-image:none;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tmargin: 0;\n\t\t\t\toverflow: visible;\n\t\t\t\ttext-decoration: none !important;\n\t\t\t\twidth: auto;\n\t\t\t\theight: auto;\n\t\t\t\tline-height: inherit;\n\t\t\t\ttext-shadow: none;\n\t\t\t\t&:focus,&:active,&:hover {\n\t\t\t\t\tbox-shadow:none!important;\n\t\t\t\t}\n\t\t\t\t@extend .btn;\n\t\t\t\t@extend .btn-sm;\n\t\t\t\t&.next {\n\t\t\t\t\t@extend .btn-primary;\n\t\t\t\t}\n\t\t\t\t&.prev {\n\t\t\t\t\t@extend .btn-outline-secondary;\n\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.hopscotch-bubble-close {\n\t\t\ttext-shadow:none;\n\t\t\tfont: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n\t\t\ttext-rendering: auto;\n\t\t\toutline: none;\n\t\t\tcolor: $black_2;\n\t\t\tbackground: transparent;\n\t\t\twebkit-font-smoothing: antialiased;\n\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\ttext-indent: inherit;\n\t\t\twidth: auto;\n\t\t\theight: auto;\n\t\t\tfont-size:0;\n\t\t\tz-index:1;\n\t\t\topacity:.6;\n\t\t\tright:3px;\n\t\t\t&:before {\n\t\t\t\tcontent: \"\\f136\";\n\t\t\t\tfont-size: 1.125rem;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\topacity:1;\n\t\t\t}\n\t\t}\n\t}\n\t.hopscotch-bubble-arrow-container {\n\t\t&.up {\n\t\t\ttop: 2px;\n    \t\tleft: 32px;\n\t\t}\n\t\t&.down {\n\t\t\tbottom: -32px;\n    \t\tleft: 4px;\n\t\t\t&:after { \n\t\t\t\t@include transform(rotate(-45deg));\n\t\t\t}\n\t\t}\n\t\t&.right {\n\t\t\ttop: 30px;\n  \t\t\tright: -32px;\n\t\t\t&:after { \n\t\t\t\t@include transform(rotate(225deg));\n\t\t\t}\n\t\t}\n\t\t&.left {\n\t\t\ttop: 10px;\n    \t\tleft: 2px;\n\t\t\t&:after { \n\t\t\t\t@include transform(rotate(45deg));\n\t\t\t}\n\t\t}\n\t\t.hopscotch-bubble-arrow-border,\n\t\t.hopscotch-bubble-arrow {\n\t\t\tdisplay:none;\n\t\t}\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tmargin-left: 0;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder: .6em solid rgba(0, 0, 0, 0.1);\n\t\t\tborder-color: transparent transparent $white $white;\n\t\t\ttransform-origin: 0 0;\n\t\t\t@include transform(rotate(135deg));\n\t\t\tbox-shadow: -2px 2px 16px rgba(0, 0, 0, 0.05);\n\t\t}\n\t}\n\t&.animated {\n\t\t-webkit-animation-fill-mode: both;\n\t\t-moz-animation-fill-mode: both;\n\t\t-ms-animation-fill-mode: both;\n\t\t-o-animation-fill-mode: both;\n\t\tanimation-fill-mode: both;\n\t\t-webkit-animation-duration: 1s;\n\t\t-moz-animation-duration: 1s;\n\t\t-ms-animation-duration: 1s;\n\t\t-o-animation-duration: 1s;\n\t\tanimation-duration: 1s\n\t}\n\t&.tour-hopscotch-dark {\n\t\tbackground:$primary_dark_3;\n\t\t.hopscotch-bubble-container {\n\t\t\th3 {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t\t.hopscotch-content {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t\t.hopscotch-actions {\n\t\t\t\t.hopscotch-nav-button {\n\t\t\t\t\t&.next {\n\t\t\t\t\t\t@extend .btn-white;\n\t\t\t\t\t}\n\t\t\t\t\t&.prev {\n\t\t\t\t\t\t@extend .btn-outline-white;\n\t\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.hopscotch-bubble-close {\n\t\t\t\toutline: none;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t\t.hopscotch-bubble-arrow-container::after {\n\t\t\tborder-color: transparent transparent $primary_dark_3 $primary_dark_3;\n\t\t}\n\t}\n\t@-webkit-keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0)\n\t\t}\n\t}\n\n\t@-moz-keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-moz-transform: translateY(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-moz-transform: translateY(0)\n\t\t}\n\t}\n\n\t@-o-keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-o-transform: translateY(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-o-transform: translateY(0)\n\t\t}\n\t}\n\n\t@keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0)\n\t\t}\n\t}\n\n\t&.fade-in-up {\n\t\t-webkit-animation-name: fadeInUp;\n\t\t-moz-animation-name: fadeInUp;\n\t\t-o-animation-name: fadeInUp;\n\t\tanimation-name: fadeInUp\n\t}\n\n\t@-webkit-keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0)\n\t\t}\n\t}\n\n\t@-moz-keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-moz-transform: translateY(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-moz-transform: translateY(0)\n\t\t}\n\t}\n\n\t@-o-keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-ms-transform: translateY(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-ms-transform: translateY(0)\n\t\t}\n\t}\n\n\t@keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0)\n\t\t}\n\t}\n\n\t&.fade-in-down {\n\t\t-webkit-animation-name: fadeInDown;\n\t\t-moz-animation-name: fadeInDown;\n\t\t-o-animation-name: fadeInDown;\n\t\tanimation-name: fadeInDown\n\t}\n\n\t@-webkit-keyframes fadeInRight {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateX(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateX(0)\n\t\t}\n\t}\n\n\t@-moz-keyframes fadeInRight {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-moz-transform: translateX(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-moz-transform: translateX(0)\n\t\t}\n\t}\n\n\t@-o-keyframes fadeInRight {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-o-transform: translateX(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-o-transform: translateX(0)\n\t\t}\n\t}\n\n\t@keyframes fadeInRight {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateX(-20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateX(0)\n\t\t}\n\t}\n\n\t&.fade-in-right {\n\t\t-webkit-animation-name: fadeInRight;\n\t\t-moz-animation-name: fadeInRight;\n\t\t-o-animation-name: fadeInRight;\n\t\tanimation-name: fadeInRight\n\t}\n\n\t@-webkit-keyframes fadeInLeft {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateX(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateX(0)\n\t\t}\n\t}\n\n\t@-moz-keyframes fadeInLeft {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-moz-transform: translateX(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-moz-transform: translateX(0)\n\t\t}\n\t}\n\n\t@-o-keyframes fadeInLeft {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-o-transform: translateX(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-o-transform: translateX(0)\n\t\t}\n\t}\n\n\t@keyframes fadeInLeft {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateX(20px)\n\t\t}\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateX(0)\n\t\t}\n\t}\n\n\t&.fade-in-left {\n\t\t-webkit-animation-name: fadeInLeft;\n\t\t-moz-animation-name: fadeInLeft;\n\t\t-o-animation-name: fadeInLeft;\n\t\tanimation-name: fadeInLeft\n\t}\n}\n@media (max-width: 1199px) {\n\tdiv.hopscotch-bubble {\n\t\tdisplay:none;\n\t}\n}\n/*Rating*/\n.rating {\n\t.jq-star {\n\t\twidth: 1rem!important;\n\t\theight: 1rem!important;\n\t\tdisplay: inline-block;\n\t\tline-height: 0;\n\t\tcursor: pointer;\n\t\tmargin-right: .25rem;\n\t\t&:last-child {\n\t\t\tmargin-right:0;\n\t\t}\n\t\tpolygon {\n\t\t\t&[class^=\"svg-empty\"] {\n\t\t\t\tfill:$grey_light_4;\n\t\t\t}\n\t\t\t&[class^=\"svg-hovered\"],\n\t\t\t&[class^=\"svg-rated\"],\n\t\t\t&[class^=\"svg-active\"] {\n\t\t\t\tfill:$primary;\n\t\t\t}\n\t\t}\n\t\t.jq-star-svg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n\t&.rating-yellow {\n\t\t.jq-star {\n\t\t\tpolygon {\n\t\t\t\t&[class^=\"svg-hovered\"],\n\t\t\t\t&[class^=\"svg-rated\"],\n\t\t\t\t&[class^=\"svg-active\"] {\n\t\t\t\t\tfill:$yellow;\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t}\n\t&.rating-progressive {\n\t\t&[data-rating=\"1\"] {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-rated\"],\n\t\t\t\t\t&[class^=\"svg-active\"] {\n\t\t\t\t\t\tfill:$red;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&[data-rating=\"2\"] {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-rated\"],\n\t\t\t\t\t&[class^=\"svg-active\"] {\n\t\t\t\t\t\tfill:$yellow_light_1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&[data-rating=\"3\"] {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-rated\"],\n\t\t\t\t\t&[class^=\"svg-active\"] {\n\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&[data-rating=\"4\"] {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-rated\"],\n\t\t\t\t\t&[class^=\"svg-active\"] {\n\t\t\t\t\t\tfill:$green_light_1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&[data-rating=\"5\"] {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-rated\"],\n\t\t\t\t\t&[class^=\"svg-active\"] {\n\t\t\t\t\t\tfill:$green;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&.rating-level-1 {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-hovered\"] {\n\t\t\t\t\t\tfill:$red;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&.rating-level-2 {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-hovered\"] {\n\t\t\t\t\t\tfill:$yellow_light_1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&.rating-level-3 {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-hovered\"] {\n\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&.rating-level-4 {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-hovered\"] {\n\t\t\t\t\t\tfill:$green_light_1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t&.rating-level-5 {\n\t\t\t.jq-star {\n\t\t\t\tpolygon {\n\t\t\t\t\t&[class^=\"svg-hovered\"] {\n\t\t\t\t\t\tfill:$green;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t}\n\t&.rating-lg {\n\t\t.jq-star {\n\t\t\twidth: 1.5rem!important;\n\t\t\theight: 1.5rem!important;\n\t\t}\n\t}\n\t&.rating-xl {\n\t\t.jq-star {\n\t\t\twidth: 2rem!important;\n\t\t\theight: 2rem!important;\n\t\t}\n\t}\t\n}\n\n/*Tinyemce*/\n.editable {\n\toutline:none;\n}\n.tox.tox-tinymce {\n\tz-index:11;\n}\n/*Chips*/\n.chip {\n\tdisplay:inline-block;\n\tposition:relative;\n\tvertical-align: middle;\n\t>span {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tposition:relative;\n\t\tpadding: 0.25rem 0.75rem;\n\t\tfont-size:0.875rem;\n\t\tline-height: 1.5;\n\t\tborder-radius:.5rem;\n\t\tcolor:$black_2;\n\t}\n\t.chip-text {\n\t\tpointer-events:none;\n\t}\n\tinput {\n\t\tposition: absolute;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\topacity:0;\n\t\tcursor:pointer;\n\t\t+ span {\n\t\t\tpointer-events:none;\n\t\t}\n\t}\n\t&.chip-primary {\n\t\t>span {\n\t\t\tbackground-color: $primary_light_5;\n\t\t\tborder: 1px solid $primary_light_5;\n\t\t\tcolor:$primary;\n\t\t}\t\n\t\t&:hover {\n\t\t\tinput {\n\t\t\t\t+ span {\n\t\t\t\t\tborder-color:$primary_light_4;\n\t\t\t\t\tbackground-color:$primary_light_4;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tinput {\n\t\t\t&:checked + span {\n\t\t\t\tcolor:$white;\n\t\t\t\tborder-color: $primary;\n\t\t\t\tbackground-color:$primary;\n\t\t\t}\n\t\t}\n\t}\n\t&.chip-secondary {\n\t\t>span {\n\t\t\tbackground-color: $grey_light_5;\n\t\t\tborder: 1px solid $grey_light_5;\n\t\t\tcolor:$black_2;\n\t\t}\n\t\t&:hover {\n\t\t\tinput {\n\t\t\t\t+ span {\n\t\t\t\t\tborder-color:$grey_light_4;\n\t\t\t\t\tbackground-color:$grey_light_4;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tinput {\n\t\t\t&:checked + span {\n\t\t\t\tcolor:$white;\n\t\t\t\tborder-color: $black_2;\n\t\t\t\tbackground-color:$black_2;\n\t\t\t}\n\t\t}\n\t}\n\t&.chip-outline-primary {\n\t\t>span {\n\t\t\tbackground:transparent;\n\t\t\tborder: 1px solid $primary_light_3;\n\t\t\tcolor:$primary;\n\t\t}\n\t\t&:hover {\n\t\t\tinput {\n\t\t\t\t+ span {\n\t\t\t\t\tborder-color:$primary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tinput {\n\t\t\t&:checked + span {\n\t\t\t\tcolor:$white;\n\t\t\t\tborder-color: $primary;\n\t\t\t\tbackground-color:$primary;\n\t\t\t}\n\t\t}\n\t}\n\t&.chip-outline-secondary {\n\t\t>span {\n\t\t\tbackground:transparent;\n\t\t\tborder: 1px solid $grey_light_1;\n\t\t\tcolor:$black_2;\n\t\t}\n\t\t&:hover {\n\t\t\tinput {\n\t\t\t\t+ span {\n\t\t\t\t\tborder-color:$black_2;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tinput {\n\t\t\t&:checked + span {\n\t\t\t\tcolor:$white;\n\t\t\t\tborder-color: $black_2;\n\t\t\t\tbackground-color:$black_2;\n\t\t\t}\n\t\t}\n\t}\n\t&.chip-wth-icon {\n\t\t>span {\n\t\t\ti,.feather-icon,.svg-icon {\n\t\t\t\tfont-size:1rem;\n\t\t\t\tline-height: 1;\n\t\t\t\tmargin-right: 0.5rem;\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t\t.feather-icon > svg,\n\t\t\t.svg-icon > svg {\n\t\t\t\theight:1em;\n\t\t\t\twidth:1em;\n\t\t\t}\n\t\t}\n\t}\n\t&.chip-ticked {\n\t\t>span {\n\t\t\t&:before {\n\t\t\t\tfont: normal normal normal 0/1 'Material-Design-Iconic-Font';\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\tcontent: \"\\f26b\";\n\t\t\t\t@include transition(all .15s ease);\n\t\t\t}\n\t\t\t.chip-text {\n\t\t\t\t@include transition(all .15s ease);\n\t\t\t}\n\t\t}\n\t\tinput {\n\t\t\t&:checked + span {\n\t\t\t\t&:before {\n\t\t\t\t\tfont-size:1rem;\n\t\t\t\t}\n\t\t\t\t.chip-text {\n\t\t\t\t\tmargin-left: 0.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.chip-dismissable {\n\t\t.btn-close {\n\t\t\tmargin-left: 0.5rem;\n\t\t\tcolor:inherit!important;\n\t\t}\n\t}\n\t&.chip-pill {\n\t\t>span {\n\t\t\tborder-radius: 50rem;\n\t\t}\n\t}\n\t&.chip-disabled {\n\t\tcursor:not-allowed;\n\t\tinput {\n\t\t\tpointer-events: none;\n\t\t}\n\t\t>span {\n\t\t\tborder-color: $grey_light_5!important;\n\t\t\tbackground-color: $grey_light_5!important;\n\t\t\tcolor: $grey_light_1!important;\n\t\t\t.btn-close {\n\t\t\t\tcolor: $grey_light_1!important;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\t\t}\n\t}\n\t&.user-chip {\n\t\t>span {\n\t\t\tborder-radius:50rem;\n\t\t\t.avatar {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: auto;\n\t\t\t\tpadding:0.2rem;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\timg {\n\t\t\t\t\tborder-radius:50%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chip-text {\n\t\t\t\tmargin-left: 1.375rem;\n\t\t\t}\n\t\t}\n\t}\t\n\t&.chip-lg {\n\t\t>span {\n\t\t\tpadding: 0.5rem 1rem;\n\t\t\tfont-size:1rem;\n\t\t}\n\t\t&.chip-wth-icon {\n\t\t\t>span {\n\t\t\t\ti,svg {\n\t\t\t\t\tfont-size:1.125rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.chip-ticked {\n\t\t\tinput {\n\t\t\t\t&:checked + span {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tfont-size:1.25rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.user-chip {\n\t\t\t>span {\n\t\t\t\t.chip-text {\n\t\t\t\t\tmargin-left: 1.875rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.tag-input {\n\tborder:none;\n\toutline:none;\n}\n.tags-container {\n\t.hk-chip {\n\t\tmargin-right: .625rem;\n\t\tmargin-bottom: .625rem;\n\t}\n}\n/*Playlist widget*/\n.hk-playlist-wrap {\n\t.media {\n\t\tcursor:pointer;\n\t\t.media-body {\n\t\t\t.song-name {\n\t\t\t\tcolor:$black_2;\n\t\t\t}\n\t\t\t.palyer-action-wrap {\n\t\t\t\t.volume-ctrl {\n\t\t\t\t\topacity:0;\n\t\t\t\t\t@include transition(.15 ease-in-out);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.active {\n\t\t\t.media-body {\n\t\t\t\t.song-name {\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t}\n\t\t\t\t.palyer-action-wrap {\n\t\t\t\t\t.volume-ctrl {\n\t\t\t\t\t\topacity:1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Ribbons*/\n.hk-ribbon-type-1 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: absolute;\n\tleft: 20px;\n\tbackground: $primary;\n\tcolor: $white;\n\tpadding: .25rem .75rem;\n\tborder-radius:0.5rem;\n\tfont-size: 0.75rem;\n\tmin-height:26px;\n\ttop: 0;\n\ttext-align: center;\n\t@include transform(translateY(-50%));\n\t>span {\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay:flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;  \n\t\tposition:relative;\n\t\tz-index:1;\n\t}\n\t&.ribbon-wth-flag {\n\t\t&:before {\n\t\t\tbackground-color: transparent;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tborder-top: 13px solid $primary;\n\t\t\tborder-bottom: 13px solid $primary;\n\t\t\tborder-right: 13px solid $primary;\n\t\t\tborder-left: .6rem solid transparent!important;\n\t\t\tleft: -14px;\n\t\t}\n\t\t&:after {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 13px solid $primary;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tright: -14px;\n\t\t\tborder-top: 13px solid $primary;\n\t\t\tborder-bottom: 13px solid $primary;\n\t\t\tborder-left: 13px solid $primary;\n\t\t\tborder-right: .6rem solid transparent!important;\n\t\t}\n\t}\n\t&.overhead-start {\n\t\tleft:14px;\n\t\t&.ribbon-wth-flag {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t\t&:before {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t}\n\t&.overhead-end {\n\t\tright:14px;\n\t\tleft:auto;\n\t\t&.ribbon-wth-flag {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\t&:after {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t\t\n\t}\n\t&.overhead-center {\n\t\tleft: 50%;\n\t\t@include transform(translate(-50%,-50%));\n\t\tright:auto;\n\t\t&.ribbon-wth-flag {\n\t\t\tborder-radius:0;\n\t\t}\n\t\t\n\t}\n\t&.start-over {\n\t\tleft:-14px;\n\t\ttop:14px;\n\t\t@include transform(none);\n\t\t&.ribbon-wth-flag {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t\t&:before {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t}\n\t&.end-over {\n\t\tright:-14px;\n\t\tleft:auto;\n\t\ttop:14px;\n\t\t@include transform(none);\n\t\t&.ribbon-wth-flag {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\t&:after {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t}\n\t&.start-touch {\n\t\tleft:0;\n\t\ttop:14px;\n\t\tborder-top-left-radius:0;\n\t\tborder-bottom-left-radius:0;\n\t\t@include transform(none);\n\t\t&.ribbon-wth-flag {\n\t\t\tborder-radius:0;\n\t\t\t&:before {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t}\n\t&.end-touch {\n\t\tright:0;\n\t\tleft:auto;\n\t\tborder-top-right-radius:0;\n\t\tborder-bottom-right-radius:0;\n\t\ttop:14px;\n\t\t@include transform(none);\n\t\t&.ribbon-wth-flag {\n\t\t\tborder-radius:0;\n\t\t\t&:after {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t}\n\t&.ribbon-square {\n\t\tborder-radius:0;\n\t}\n\t&.ribbon-wth-icon {\n\t\t> span >* {\n\t\t\tfont-size:1.125rem;\n\t\t\tmargin-right:.25rem;\n\t\t}\n\t}\n\t&.hk-ribbon-uppercase {\n\t\tfont-weight:600;\n\t\tfont-size:0.75rem;\n\t\ttext-transform:uppercase;\n\t}\n\t&.hk-ribbon-blue {\n\t\tbackground:$blue;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$blue;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-primary {\n\t\tbackground:$primary;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$primary;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-info {\n\t\tbackground:$info;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$info;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-cyan {\n\t\tbackground:$cyan;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$cyan;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-green {\n\t\tbackground:$green;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$green;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-success {\n\t\tbackground:$success;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$success;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-red {\n\t\tbackground:$red;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$red;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-danger {\n\t\tbackground:$danger;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$danger;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-yellow {\n\t\tbackground:$yellow;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$yellow;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-warning {\n\t\tbackground:$warning;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$warning;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-sky {\n\t\tbackground:$sky;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$sky;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-pink {\n\t\tbackground:$pink;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$pink;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-purple {\n\t\tbackground:$purple;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$purple;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-violet {\n\t\tbackground:$violet;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$violet;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-indigo {\n\t\tbackground:$indigo;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$indigo;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-teal {\n\t\tbackground:$teal;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$teal;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-neon {\n\t\tbackground:$neon;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$neon;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-lime {\n\t\tbackground:$lime;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$lime;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-sun {\n\t\tcolor:$black_2;\n\t\tbackground:$sun;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$sun;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-orange {\n\t\tbackground:$orange;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$orange;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-pumpkin {\n\t\tbackground:$pumpkin;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$pumpkin;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-brown {\n\t\tbackground:$brown;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$brown;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-gold {\n\t\tbackground:$gold;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$gold;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-smoke {\n\t\tbackground:$smoke;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$smoke;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-grey {\n\t\tbackground:$grey;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$grey;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-secondary {\n\t\tbackground:$secondary;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$secondary;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-light {\n\t\tbackground:$grey_light_4;\n\t\tcolor:$black_2;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$grey_light_4;\n\t\t\t}\n\t\t}\n\t}\n\t&.hk-ribbon-dark {\n\t\tbackground:$black_2;\n\t\t&.ribbon-wth-flag {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tborder-color:$black_2;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-ribbon-type-2 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: absolute;\n\tleft: 20px;\n\tbackground: $primary;\n\tcolor: $white;\n\tpadding: .25rem .5rem;\n\tfont-size: 1.125rem;\n\tfont-weight: 500;\n\ttop: -8px;\n\theight:39px;\n\twidth:34px;\n\ttext-align: center;\n\t>span {\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay:flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;  \n\t\tposition:relative;\n\t\tz-index:1;\n\t\tfont-size:1.25rem;\n\t}\n\t&:after {\n\t\tbackground-color: transparent;\n\t\tborder-top: 17px solid $primary;\n\t\tborder-right: 17px solid $primary;\n\t\tborder-left: 17px solid $primary;\n\t\tborder-bottom:.6rem solid transparent!important;\n\t\tbottom: -10px;\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright:0;\n\t}\n\t&.overhead-start {\n\t\tleft:20px;\n\t}\n\t&.overhead-end {\n\t\tright:20px;\n\t\tleft:auto;\n\t}\n\t&.overhead-center {\n\t\tleft: 50%;\n\t\t@include transform(translate(-50%,0));\n\t\tright:auto;\n\t}\n\t&.top-touch {\n\t\t@include transform(none);\n\t\ttop:0;\n\t\t&.overhead-center {\n\t\t\t@include transform(translate(-50%,0));\n\t\t}\n\t}\n\t&.hk-ribbon-blue {\n\t\tbackground:$blue;\n\t\t&:after {\n\t\t\tborder-color:$blue;\n\t\t}\n\t}\n\t&.hk-ribbon-primary {\n\t\tbackground:$primary;\n\t\t&:after {\n\t\t\tborder-color:$primary;\n\t\t}\n\t}\n\t&.hk-ribbon-cyan {\n\t\tbackground:$cyan;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$cyan;\n\t\t}\n\t}\n\t&.hk-ribbon-info {\n\t\tbackground:$info;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$info;\n\t\t}\n\t}\n\t&.hk-ribbon-green {\n\t\tbackground:$green;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$green;\n\t\t}\n\t}\n\t&.hk-ribbon-success {\n\t\tbackground:$success;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$success;\n\t\t}\n\t}\n\t&.hk-ribbon-red {\n\t\tbackground:$red;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$red;\n\t\t}\n\t}\n\t&.hk-ribbon-danger {\n\t\tbackground:$danger;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$danger;\n\t\t}\n\t}\n\t&.hk-ribbon-yellow {\n\t\tbackground:$yellow;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$yellow;\n\t\t}\n\t}\n\t&.hk-ribbon-warning {\n\t\tbackground:$warning;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$warning;\n\t\t}\n\t}\n\t&.hk-ribbon-sky {\n\t\tbackground:$sky;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$sky;\n\t\t}\n\t}\n\t&.hk-ribbon-pink {\n\t\tbackground:$pink;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$pink;\n\t\t}\n\t}\n\t&.hk-ribbon-purple {\n\t\tbackground:$purple;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$purple;\n\t\t}\n\t}\n\t&.hk-ribbon-violet {\n\t\tbackground:$violet;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$violet;\n\t\t}\n\t}\n\t&.hk-ribbon-indigo {\n\t\tbackground:$indigo;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$indigo;\n\t\t}\n\t}\n\t&.hk-ribbon-teal {\n\t\tbackground:$teal;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$teal;\n\t\t}\n\t}\n\t&.hk-ribbon-neon {\n\t\tbackground:$neon;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$neon;\n\t\t}\n\t}\n\t&.hk-ribbon-lime {\n\t\tbackground:$lime;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$lime;\n\t\t}\n\t}\n\t&.hk-ribbon-sun {\n\t\tbackground:$sun;\n\t\tcolor:$black_2;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$sun;\n\t\t}\n\t}\n\t&.hk-ribbon-orange {\n\t\tbackground:$orange;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$orange;\n\t\t}\n\t}\n\t&.hk-ribbon-pumpkin {\n\t\tbackground:$pumpkin;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$pumpkin;\n\t\t}\n\t}\n\t&.hk-ribbon-brown {\n\t\tbackground:$brown;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$brown;\n\t\t}\n\t}\n\t&.hk-ribbon-gold {\n\t\tbackground:$gold;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$gold;\n\t\t}\n\t}\n\t&.hk-ribbon-smoke {\n\t\tbackground:$smoke;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$smoke;\n\t\t}\n\t}\n\t&.hk-ribbon-grey {\n\t\tbackground:$grey;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$grey;\n\t\t}\n\t}\n\t&.hk-ribbon-secondary {\n\t\tbackground:$secondary;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$secondary;\n\t\t}\n\t}\n\t&.hk-ribbon-light {\n\t\tbackground:$grey_light_4;\n\t\tcolor:$black_2;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$grey_light_4;\n\t\t}\n\t}\n\t&.hk-ribbon-dark {\n\t\tbackground:$black_2;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-color:$black_2;\n\t\t}\n\t}\n}\n\n/*Advance Badges*/\n.badge-icon {\n\twidth: 4rem;\n\theight: 4.313rem;\n\tfont-size: 2.25rem;\n\tposition: relative;\n\tdisplay:inline-block;\n\tvertical-align: middle;\n\t> svg {\n\t\tposition:absolute;\n\t\tleft:0;\n\t\ttop:0;\n\t\tright:0;\n\t\theight:100%;\n\t\twidth:100%;\n\t}\n\t.badge-icon-wrap {\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay:flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;  \n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\theight:100%;\n\t\twidth:100%;\n\t\tcolor:$white;\n\t\tposition: relative;\n    \tz-index: 1;\n\t}\n\t&.badge-icon-lg {\n\t\twidth: 6rem;\n\t\theight: 6.031rem;\n\t\tfont-size:3.25rem;\n\t}\n\t&.badge-icon-md {\n\t\twidth: 5rem;\n\t\theight: 5.031rem;\n\t\tfont-size:2.75rem;\n\t}\n\t&.badge-icon-sm {\n\t\twidth: 3rem;\n\t\theight: 3.313rem;\n\t\tfont-size:1.75rem;\n\t}\n\t&.badge-icon-xs {\n\t\twidth: 2rem;\n\t\theight: 2.313rem;\n\t\tfont-size:1.25rem;\n\t}\n\t&.badge-icon-xxs {\n\t\twidth: 1.5rem;\n\t\theight: 1.813rem;\n\t\tfont-size:1rem;\n\t}\n\t&.badge-circle {\n\t\theight: 4rem;\n\t\t&.badge-icon-lg {\n\t\t\theight:6rem;\n\t\t}\n\t\t&.badge-icon-md {\n\t\t\theight:5rem;\n\t\t}\n\t\t&.badge-icon-sm {\n\t\t\theight:3rem;\n\t\t}\n\t\t&.badge-icon-xs {\n\t\t\theight:2rem;\n\t\t}\n\t\t&.badge-icon-xxs {\n\t\t\theight:1.5rem;\n\t\t}\n\t}\n\t&.badge-level{\n\t\tposition: relative;\n\t\t>span {\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n   \t\t\tright: 16%;\n\t\t\tz-index: 1;\n\t\t\tfont-weight: 600;\n\t\t\tcolor:inherit;\n\t\t\tfont-size:40%;\n\t\t\tbackground:transparent;\n\t\t\t&:before {\n\t\t\t  content: attr(title);\n\t\t\t  position: absolute;\n\t\t\t  -webkit-text-stroke: 4px $white;\n\t\t\t  left: 0;\n\t\t\t  z-index: -1;\n\t\t\t}\n\t\t}\n\t} \n}\n.avatar {\n\t&.custom-badge-on-avatar {\n\t\t.badge-icon {\n\t\t\tfont-size:inherit;\n\t\t}\n\t}\n}\n\n/*Callout*/\n.callout {\n\tmargin-bottom: 0;\n\t&.callout-floating {\n\t\tposition: fixed;\n\t\twidth: 300px;\n\t\tz-index: 1055;\n\t\tmargin-bottom: 0;\n\t\t&.top-end {\n\t\t\ttop:25px;\t\n\t\t\tright:25px;\n\t\t}\n\t\t&.bottom-end {\n\t\t\tbottom:25px;\n\t\t\tright:25px;\n\t\t}\n\t\t&.top-start {\n\t\t\ttop:25px;\t\n\t\t\tleft:25px;\n\t\t}\n\t\t&.bottom-start {\n\t\t\tbottom:25px;\n\t\t\tleft:25px;\n\t\t}\n\t\t&.top-center {\n\t\t\ttop:25px;\t\n\t\t\tleft:50%;\n\t\t\twidth:auto;\n\t\t\t@include transform(translateX(-50%));\n\t\t}\n\t\t&.bottom-center {\n\t\t\tbottom:25px;\t\n\t\t\tleft:50%;\n\t\t\twidth:auto;\n\t\t\t@include transform(translateX(-50%));\n\t\t}\n\t}\n\t&.callout-dark {\n\t\tcolor:$white;\n\t\th1,h2,h3,h4,h5,h6,p{\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n}\n/*Toolbar*/\n.hk-toolbar{\n\t.nav{\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\t-ms-flex-pack: distribute;\n\t\tjustify-content: space-around;\n\t\theight:100%;\t\n\t\t.nav-item {\n\t\t\theight:100%;\n\t\t}\n\t}\n\t&.toolbar-asymmetric {\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-ms-flex-pack: justify;\n\t\tjustify-content: space-between;\n\t}\n}\n\n/*Filter Component*/\n.btn-filter {\n\tcolor:$grey_dark_3;\n\tbackground-color: transparent;\n    background-image: none;\n\tborder-color: $grey_light_5;\n\t&:hover,&:focus {\n\t\tcolor:$grey_dark_3;\n\t\tbackground-color: transparent;\n\t\tbackground-image: none;\n\t\tborder-color: $grey_light_5;\n\t}\n\t&.active {\n\t\tcolor:$primary;\n\t\tbackground-color:$primary_light_5;\n\t\tborder-color:$primary;\n\t\tbox-shadow:none!important;\n\t\t&:hover,&:focus {\n\t\t\tcolor:$primary;\n\t\t\tbackground-color:$primary_light_5;\n\t\t\tborder-color:$primary;\n\t\t}\n\t}\n}\n.filter-block-wrap {\n\t.filter-block {\n\t\t&.card {\n\t\t\t.card-img {\n\t\t\t\t-o-object-fit: cover;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t\t.card-img-overlay {\n\t\t\t\tbackground-color:rgba($black_2,var(--bs-bg-opacity));\n\t\t\t}\n\t\t\tinput {\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 1;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 0;\n\t\t\t\tmargin: 0;\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\topacity: 0;\n\t\t\t\tcursor: pointer;\n\t\t\t\t&:checked ~ .card-img-overlay {\n\t\t\t\t\tbackground-color:rgba($blue,var(--bs-bg-opacity));\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n/*Content sidebar*/\n[data-content-sidebar=\"active\"] {\n\t&.hk-wrapper {\n\t\t.hk-pg-wrapper {\n\t\t\tmargin-right:17.5rem;\n\t\t}\n\t\t.hk-content-sidebar {\t\n\t\t\tposition: fixed;\n\t\t\ttop: 64px;\n\t\t\toverflow-y: auto;\n\t\t\twidth: 280px;\n\t\t\tright: 0;\n\t\t\tz-index: 2;\n\t\t\tbackground: $white;\n\t\t\tpadding-top: 1.5rem;\n\t\t\tborder-left: 1px solid $grey_light_3;\n\t\t\tbottom:0;\t\n\t\t\t.sidebar-content-wrap {\n\t\t\t\tpadding:1.25rem;\n\t\t\t}\n\t\t}\n\n\t}\n}\n\n/*Fixed Footer*/\n.hk-fixed-footer {\n\tposition:fixed;\n\tbottom:0;\n\tz-index:1032;\n\tbackground:$white;\n\tbox-shadow: 1px 1px 3px 5px rgba(0, 0, 0, 0.1);\n\tright: 0;\n\tleft: 0;\n}\n.hk-wrapper {\n\t&.fixed-footer-active {\n\t\t.hk-pg-wrapper {\n\t\t\tpadding-bottom:8.125rem;\n\t\t}\n\t}\n}\n/*Dragula*/\n.gu-mirror {\n\tcursor:-webkit-grabbing; \n\tcursor:-moz-grabbing; \n\tcursor:grabbing;\n\tposition: fixed !important;\n\tmargin: 0 !important;\n\tz-index: 9999 !important;\n\topacity: 1;\n}\n.dragula-demo {\n\t.dragula-block {\n\t\tborder: 1px dotted $grey_light_1;\n\t\tborder-radius: .25rem;\n\t\tpadding: .625rem;\n\t}\n\t.dragula-block > div{\n\t  border: 1px solid $grey_light_3;\n\t  border-radius: .25rem;\n\t  margin: .625rem;\n\t  padding: .625rem;\n\t  cursor: move;\n\t}\n}\n\n/*Authantication Pages*/\n.hk-wrapper {\n\t&.hk-pg-auth {\n\t\t.hk-pg-wrapper {\n\t\t\t.hk-pg-body {\n\t\t\t\t.auth-content {\n\t\t\t\t\tmin-height:calc(100vh - 249px);\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.v-separator {\n\t\t\t\tmargin:0;\n\t\t\t\tposition:relative;\n\t\t\t\t&:after {\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tright: 0;\n\t\t\t\t}\n\t\t\t\t&.separator-sm {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\theight: 70%;\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.auth-split {\n\t\t\t\tmin-height:100vh;\n\t\t\t\t.auth-content {\n\t\t\t\t\tmin-height:100vh;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\tposition:relative;\t\n\t\t\t\t\tmark {\n\t\t\t\t\t\tz-index:1;\n\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tz-index:-1;\n\t\t\t\t\t\t\tbackground: $green;\n\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.extr-link {\n\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t\t\t.feather-icon, .svg-icon {\n\t\t\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t\theight: 14px;\n\t\t\t\t\t\t\t\twidth: 14px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.credit-text {\n\t\t\t\t\tposition:absolute;\n\t\t\t\t\tleft:30px;\n\t\t\t\t\tbottom:30px;\n\t\t\t\t\tmix-blend-mode: inherit;\n\t\t\t\t}\n\t\t\t\t.bg-img {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tz-index: -1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n\t.hk-wrapper {\n\t\t&.hk-pg-auth {\n\t\t\t.hk-pg-wrapper {\n\t\t\t.hk-pg-body {\n\t\t\t\t.container-xxl {\n\t\t\t\t\t.auth-content {\n\t\t\t\t\t\tmin-height:auto;\n\t\t\t\t\t\t-webkit-box-align: flex-start;\n\t\t\t\t\t\t-ms-flex-align: flex-start;\n\t\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\t.v-separator:after {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t}\n}\n/****************************/\n/** Componets Import **/\n/****************************/\n@import \"header.scss\";\t\n@import \"footer.scss\";\t\n@import \"nav.scss\";\t\n@import \"horizontal-menu.scss\";\t\n@import \"vertical-classic-menu.scss\";\t\n@import \"vertical-icon-menu.scss\";\n@import \"navbar-menu.scss\";\n@import \"drawer.scss\";\t\n@import \"apps.scss\";\n","/*__________________________________________________________________;\n[Mixin]\nProject:\tJampack\n___________________________________________________________________*/;\n\n@mixin background-opacity($color, $opacity: 0.6) {\n    background: rgba($color, $opacity);\n}\n\n@mixin color-opacity($color, $opacity: 0.8) {\n    color: rgba($color, $opacity);\n}\n\n@mixin border-opacity($color, $opacity: 0.8) {\n    border-color: rgba($color, $opacity);\n}\n\n/*Shadow*/\n@mixin boxshadow-badge-link($color, $opacity: 0.3) {\n   box-shadow: 0 .1875rem .5rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-custom-btn-2($color, $opacity: 0.6) {\n   box-shadow: 0 1.25rem 1.875rem -0.625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-custom-btn-2-hover($color, $opacity: 0.4) {\n   box-shadow: 0 1.875rem 2.5rem -0.625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-sm($color, $opacity: 0.1) {\n   box-shadow: 0 .125rem .125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-sm-top($color, $opacity: 0.1) {\n   box-shadow: 0 -0.125rem .125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-sm-bottom($color, $opacity: 0.1) {\n   box-shadow: 0 .125rem .125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-sm-left($color, $opacity: 0.1) {\n   box-shadow: -0.125rem 0 .125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-sm-right($color, $opacity: 0.1) {\n   box-shadow: .125rem 0 .125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow($color, $opacity: 0.1) {\n   box-shadow: 0 .25rem .3125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-top($color, $opacity: 0.1) {\n   box-shadow: 0 -0.25rem .3125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-bottom($color, $opacity: 0.1) {\n   box-shadow: 0 .25rem .3125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-left($color, $opacity: 0.1) {\n   box-shadow: -0.25rem 0 .3125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-right($color, $opacity: 0.1) {\n   box-shadow: .25rem 0 .3125rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-lg($color, $opacity: 0.1) {\n   box-shadow: 0 .375rem .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-lg-top($color, $opacity: 0.1) {\n   box-shadow: 0 -0.375rem .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-lg-bottom($color, $opacity: 0.1) {\n   box-shadow: 0 .375rem .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-lg-left($color, $opacity: 0.1) {\n   box-shadow: -0.375rem 0 .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-lg-right($color, $opacity: 0.1) {\n   box-shadow: .375rem 0 .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-xl($color, $opacity: 0.1) {\n   box-shadow: 0 .5rem .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-xl-top($color, $opacity: 0.1) {\n   box-shadow: 0 -0.5rem .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-xl-bottom($color, $opacity: 0.1) {\n   box-shadow: 0 .5rem .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-xl-left($color, $opacity: 0.1) {\n   box-shadow: -0.5rem 0 .625rem rgba($color, $opacity)!important;\n}\n@mixin boxshadow-xl-right($color, $opacity: 0.1) {\n   box-shadow: .5rem 0 .625rem rgba($color, $opacity)!important;\n}\n@mixin clear() {\n\toverflow:hidden;\n\tclear:both;\n\tfloat:none;\n}\n\n@mixin font-size($size) {\n  font-size: $size;\n  font-size: calculateRem($size);\n}\n\n@mixin bg-linear-gradient($direction, $color-stops...) {\n  background: nth(nth($color-stops, 1), 1);\n  background: linear-gradient($direction, $color-stops)!important;\n}\n@mixin bdr-linear-gradient($direction, $color-stops...) {\n  border-color: nth(nth($color-stops, 1), 1);\n  border-color: linear-gradient($direction, $color-stops)!important;\n}\n\n/*Table Variants*/\n@mixin table-variant($state, $background) {\n   @if $state == 'dark' {\n\n      .table-#{$state} {\n         $color: $white;\n         $hover-bg: $black_1;\n         $striped-bg: $black_1;\n         $active-bg: mix($color, $background, percentage(.1));\n         $table-bg: $background;\n         $border-color: $black_1;\n     \n         --bs-table-bg: #{$table-bg};\n         --bs-table-striped-bg: #{$striped-bg};\n         --bs-table-striped-color: #{color-contrast($striped-bg)};\n         --bs-table-active-bg: #{$active-bg};\n         --bs-table-active-color: #{color-contrast($active-bg)};\n         --bs-table-hover-bg: #{$hover-bg};\n         --bs-table-hover-color: #{color-contrast($hover-bg)};\n     \n         color: $color;\n         border-color: $border-color;\n       }\n  \n     } \n     @else if $state == 'light' {\n\n      .table-#{$state} {\n         $color: $grey_dark_3;\n         $hover-bg: $grey_light_3;\n         $striped-bg: $grey_light_4;\n         $active-bg: mix($color, $background, percentage(.1));\n         $table-bg: $grey_light_5;\n         $border-color: $grey_light_3;\n     \n         --bs-table-bg: #{$table-bg};\n         --bs-table-striped-bg: #{$striped-bg};\n         --bs-table-striped-color: #{color-contrast($striped-bg)};\n         --bs-table-active-bg: #{$active-bg};\n         --bs-table-active-color: #{color-contrast($active-bg)};\n         --bs-table-hover-bg: #{$hover-bg};\n         --bs-table-hover-color: #{color-contrast($hover-bg)};\n     \n         color: $color;\n         border-color: $border-color;\n      }\n  \n     } @else {\n      .table-#{$state} {\n         $color: $background;\n         $hover-bg: mix(white, $background, 80%);\n         $striped-bg: mix(white, $background, 70%);\n         $active-bg: mix(white, $background, 85%);\n         $table-bg: mix(white, $background, 90%);\n         $border-color: mix(white, $background, 50%);\n     \n         --bs-table-bg: #{$table-bg};\n         --bs-table-striped-bg: #{$striped-bg};\n         --bs-table-striped-color: #{color-contrast($striped-bg)};\n         --bs-table-active-bg: #{$active-bg};\n         --bs-table-active-color: #{color-contrast($active-bg)};\n         --bs-table-hover-bg: #{$hover-bg};\n         --bs-table-hover-color: #{color-contrast($hover-bg)};\n     \n         color: $color;\n         border-color: $border-color;\n       }\n     }\n}","/*__________________________________________________________________;\n[Variables]\nProject:\tJampack\n___________________________________________________________________*/;\n// Color variables\n$red: #FF0000;    \n$green:#00D67F;\n$pink:#E92990;\n$purple:#C02FF3;\n$violet:#7429F8;\n$indigo:#0069F7;\n$blue:#298DFF;\n$sky:#00B0FF;\n$cyan:#18DDEF;\n$teal:#007D88;\n$neon:#81E230;\n$lime:#C2E939;\n$sun:#FFEA00;\n$yellow:#FFC400;\n$orange:#FF9100;\n$pumpkin:#FF5700;\n$brown:#954D15;\n$gold:#C39749;\n$smoke:#5e7d8a;\n$grey:#9e9e9e;\n$black:#2F343A;\n$white:#fff;\n\n// Red color variables\n$red_light_5: mix(white, $red, 92%);\n$red_light_4: mix(white, $red, 78%);\n$red_light_3: mix(white, $red, 60%);\n$red_light_2: mix(white, $red, 42%);\n$red_light_1: mix(white, $red, 24%);\n$red_dark_1: mix(black, $red, 10%);\n$red_dark_2: mix(black, $red, 20%);\n$red_dark_3: mix(black, $red, 30%);\n$red_dark_4: mix(black, $red, 40%);\n$red_dark_5: mix(black, $red, 50%);\n\n// Green color variables\n$green_light_5: mix(white, $green, 92%);\n$green_light_4: mix(white, $green, 78%);\n$green_light_3: mix(white, $green, 60%);\n$green_light_2: mix(white, $green, 42%);\n$green_light_1: mix(white, $green, 24%);\n$green_dark_1: mix(black, $green, 10%);\n$green_dark_2: mix(black, $green, 20%);\n$green_dark_3: mix(black, $green, 30%);\n$green_dark_4: mix(black, $green, 40%);\n$green_dark_5: mix(black, $green, 50%); \n\n// Pink color variables\n$pink_light_5: mix(white, $pink, 92%);\n$pink_light_4: mix(white, $pink, 78%);\n$pink_light_3: mix(white, $pink, 60%);\n$pink_light_2: mix(white, $pink, 42%);\n$pink_light_1: mix(white, $pink, 24%);\n$pink_dark_1: mix(black, $pink, 10%);\n$pink_dark_2: mix(black, $pink, 20%);\n$pink_dark_3: mix(black, $pink, 30%);\n$pink_dark_4: mix(black, $pink, 40%);\n$pink_dark_5: mix(black, $pink, 50%);\n\n// Purple color variables\n$purple_light_5: mix(white, $purple, 92%);\n$purple_light_4: mix(white, $purple, 78%);\n$purple_light_3: mix(white, $purple, 60%);\n$purple_light_2: mix(white, $purple, 42%);\n$purple_light_1: mix(white, $purple, 24%);\n$purple_dark_1: mix(black, $purple, 10%);\n$purple_dark_2: mix(black, $purple, 20%);\n$purple_dark_3: mix(black, $purple, 30%);\n$purple_dark_4: mix(black, $purple, 40%);\n$purple_dark_5: mix(black, $purple, 50%);\n\n// Violet color variables\n$violet_light_5: mix(white, $violet, 92%);\n$violet_light_4: mix(white, $violet, 78%);\n$violet_light_3: mix(white, $violet, 60%);\n$violet_light_2: mix(white, $violet, 42%);\n$violet_light_1: mix(white, $violet, 24%);\n$violet_dark_1: mix(black, $violet, 10%);\n$violet_dark_2: mix(black, $violet, 20%);\n$violet_dark_3: mix(black, $violet, 30%);\n$violet_dark_4: mix(black, $violet, 40%);\n$violet_dark_5: mix(black, $violet, 50%);\n\n// Indigo color variables\n$indigo_light_5: mix(white, $indigo, 92%);\n$indigo_light_4: mix(white, $indigo, 78%);\n$indigo_light_3: mix(white, $indigo, 60%);\n$indigo_light_2: mix(white, $indigo, 42%);\n$indigo_light_1: mix(white, $indigo, 24%);\n$indigo_dark_1: mix(black, $indigo, 10%);\n$indigo_dark_2: mix(black, $indigo, 20%);\n$indigo_dark_3: mix(black, $indigo, 30%);\n$indigo_dark_4: mix(black, $indigo, 40%);\n$indigo_dark_5: mix(black, $indigo, 50%);\n\n// Blue color variables\n$blue_light_5: mix(white, $blue, 92%);\n$blue_light_4: mix(white, $blue, 78%);\n$blue_light_3: mix(white, $blue, 60%);\n$blue_light_2: mix(white, $blue, 42%);\n$blue_light_1: mix(white, $blue, 24%);\n$blue_dark_1: mix(black, $blue, 10%);\n$blue_dark_2: mix(black, $blue, 20%);\n$blue_dark_3: mix(black, $blue, 30%);\n$blue_dark_4: mix(black, $blue, 40%);\n$blue_dark_5: mix(black, $blue, 50%);\n\n// Sky color variables\n$sky_light_5: mix(white, $sky, 92%);\n$sky_light_4: mix(white, $sky, 78%);\n$sky_light_3: mix(white, $sky, 60%);\n$sky_light_2: mix(white, $sky, 42%);\n$sky_light_1: mix(white, $sky, 24%);\n$sky_dark_1: mix(black, $sky, 10%);\n$sky_dark_2: mix(black, $sky, 20%);\n$sky_dark_3: mix(black, $sky, 30%);\n$sky_dark_4: mix(black, $sky, 40%);\n$sky_dark_5: mix(black, $sky, 50%);\n\n// Cyan color variables\n$cyan_light_5: mix(white, $cyan, 92%);\n$cyan_light_4: mix(white, $cyan, 78%);\n$cyan_light_3: mix(white, $cyan, 60%);\n$cyan_light_2: mix(white, $cyan, 42%);\n$cyan_light_1: mix(white, $cyan, 24%);\n$cyan_dark_1: mix(black, $cyan, 10%);\n$cyan_dark_2: mix(black, $cyan, 20%);\n$cyan_dark_3: mix(black, $cyan, 30%);\n$cyan_dark_4: mix(black, $cyan, 40%);\n$cyan_dark_5: mix(black, $cyan, 50%);\n\n// Teal color variables\n$teal_light_5: mix(white, $teal, 92%);\n$teal_light_4: mix(white, $teal, 78%);\n$teal_light_3: mix(white, $teal, 60%);\n$teal_light_2: mix(white, $teal, 42%);\n$teal_light_1: mix(white, $teal, 24%);\n$teal_dark_1: mix(black, $teal, 10%);\n$teal_dark_2: mix(black, $teal, 20%);\n$teal_dark_3: mix(black, $teal, 30%);\n$teal_dark_4: mix(black, $teal, 40%);\n$teal_dark_5: mix(black, $teal, 50%);\n\n// Neon color variables\n$neon_light_5: mix(white, $neon, 92%);\n$neon_light_4: mix(white, $neon, 78%);\n$neon_light_3: mix(white, $neon, 60%);\n$neon_light_2: mix(white, $neon, 42%);\n$neon_light_1: mix(white, $neon, 24%);\n$neon_dark_1: mix(black, $neon, 10%);\n$neon_dark_2: mix(black, $neon, 20%);\n$neon_dark_3: mix(black, $neon, 30%);\n$neon_dark_4: mix(black, $neon, 40%);\n$neon_dark_5: mix(black, $neon, 50%);\n\n// Lime color variables\n$lime_light_5: mix(white, $lime, 92%);\n$lime_light_4: mix(white, $lime, 78%);\n$lime_light_3: mix(white, $lime, 60%);\n$lime_light_2: mix(white, $lime, 42%);\n$lime_light_1: mix(white, $lime, 24%);\n$lime_dark_1: mix(black, $lime, 10%);\n$lime_dark_2: mix(black, $lime, 20%);\n$lime_dark_3: mix(black, $lime, 30%);\n$lime_dark_4: mix(black, $lime, 40%);\n$lime_dark_5: mix(black, $lime, 50%);\n\n// Sun color variables\n$sun_light_5: mix(white, $sun, 92%);\n$sun_light_4: mix(white, $sun, 78%);\n$sun_light_3: mix(white, $sun, 60%);\n$sun_light_2: mix(white, $sun, 42%);\n$sun_light_1: mix(white, $sun, 24%);\n$sun_dark_1: mix(black, $sun, 10%);\n$sun_dark_2: mix(black, $sun, 20%);\n$sun_dark_3: mix(black, $sun, 30%);\n$sun_dark_4: mix(black, $sun, 40%);\n$sun_dark_5: mix(black, $sun, 50%);\n\n// Yellow color variables\n$yellow_light_5: mix(white, $yellow, 92%);\n$yellow_light_4: mix(white, $yellow, 78%);\n$yellow_light_3: mix(white, $yellow, 60%);\n$yellow_light_2: mix(white, $yellow, 42%);\n$yellow_light_1: mix(white, $yellow, 24%);\n$yellow_dark_1: mix(black, $yellow, 10%);\n$yellow_dark_2: mix(black, $yellow, 20%);\n$yellow_dark_3: mix(black, $yellow, 30%);\n$yellow_dark_4: mix(black, $yellow, 40%);\n$yellow_dark_5: mix(black, $yellow, 50%);\n\n// Orange color variables\n$orange_light_5: mix(white, $orange, 92%);\n$orange_light_4: mix(white, $orange, 78%);\n$orange_light_3: mix(white, $orange, 60%);\n$orange_light_2: mix(white, $orange, 42%);\n$orange_light_1: mix(white, $orange, 24%);\n$orange_dark_1: mix(black, $orange, 10%);\n$orange_dark_2: mix(black, $orange, 20%);\n$orange_dark_3: mix(black, $orange, 30%);\n$orange_dark_4: mix(black, $orange, 40%);\n$orange_dark_5: mix(black, $orange, 50%);\n\n// Pumpkin color variables\n$pumpkin_light_5: mix(white, $pumpkin, 92%);\n$pumpkin_light_4: mix(white, $pumpkin, 78%);\n$pumpkin_light_3: mix(white, $pumpkin, 60%);\n$pumpkin_light_2: mix(white, $pumpkin, 42%);\n$pumpkin_light_1: mix(white, $pumpkin, 24%);\n$pumpkin_dark_1: mix(black, $pumpkin, 10%);\n$pumpkin_dark_2: mix(black, $pumpkin, 20%);\n$pumpkin_dark_3: mix(black, $pumpkin, 30%);\n$pumpkin_dark_4: mix(black, $pumpkin, 40%);\n$pumpkin_dark_5: mix(black, $pumpkin, 50%);\n\n// Brown color variables\n$brown_light_5: mix(white, $brown, 92%);\n$brown_light_4: mix(white, $brown, 78%);\n$brown_light_3: mix(white, $brown, 60%);\n$brown_light_2: mix(white, $brown, 42%);\n$brown_light_1: mix(white, $brown, 24%);\n$brown_dark_1: mix(black, $brown, 10%);\n$brown_dark_2: mix(black, $brown, 20%);\n$brown_dark_3: mix(black, $brown, 30%);\n$brown_dark_4: mix(black, $brown, 40%);\n$brown_dark_5: mix(black, $brown, 50%);\n\n// Gold color variables\n$gold_light_5: mix(white, $gold, 92%);\n$gold_light_4: mix(white, $gold, 78%);\n$gold_light_3: mix(white, $gold, 60%);\n$gold_light_2: mix(white, $gold, 42%);\n$gold_light_1: mix(white, $gold, 24%);\n$gold_dark_1: mix(black, $gold, 10%);\n$gold_dark_2: mix(black, $gold, 20%);\n$gold_dark_3: mix(black, $gold, 30%);\n$gold_dark_4: mix(black, $gold, 40%);\n$gold_dark_5: mix(black, $gold, 50%);\n\n// Smoke color variables\n$smoke_light_5: mix(white, $smoke, 92%);\n$smoke_light_4: mix(white, $smoke, 78%);\n$smoke_light_3: mix(white, $smoke, 60%);\n$smoke_light_2: mix(white, $smoke, 42%);\n$smoke_light_1: mix(white, $smoke, 24%);\n$smoke_dark_1: mix(black, $smoke, 10%);\n$smoke_dark_2: mix(black, $smoke, 20%);\n$smoke_dark_3: mix(black, $smoke, 30%);\n$smoke_dark_4: mix(black, $smoke, 40%);\n$smoke_dark_5: mix(black, $smoke, 50%);\n\n// Grey color variables\n$grey_light_5: mix(white, $grey, 92%);\n$grey_light_4: mix(white, $grey, 78%);\n$grey_light_3: mix(white, $grey, 60%);\n$grey_light_2: mix(white, $grey, 42%);\n$grey_light_1: mix(white, $grey, 24%);\n$grey_dark_1: mix(black, $grey, 10%);\n$grey_dark_2: mix(black, $grey, 20%);\n$grey_dark_3: mix(black, $grey, 30%);\n$grey_dark_4: mix(black, $grey, 40%);\n$grey_dark_5: mix(black, $grey, 50%);\n\n// Dark color variables\n$black_1:mix(black, $black, 10%);\n$black_2:mix(black, $black, 20%);\n$black_3:mix(black, $black, 30%);\n$black_4:mix(black, $black, 40%);\n$black_5:mix(black, $black, 50%);\n\n// Theme color variables\n$primary : $teal;\n$info : $cyan;\n$success : $green;\n$danger : $red;\n$warning : $yellow;\n$secondary : $grey_dark_3;\n\n// Primary color variables \n$primary_light_5: mix(white, $primary, 92%);\n$primary_light_4: mix(white, $primary, 78%);\n$primary_light_3: mix(white, $primary, 60%);\n$primary_light_2: mix(white, $primary, 42%);\n$primary_light_1: mix(white, $primary, 24%);\n$primary_dark_1: mix(black, $primary, 10%);\n$primary_dark_2: mix(black, $primary, 20%);\n$primary_dark_3: mix(black, $primary, 30%);\n$primary_dark_4: mix(black, $primary, 40%);\n$primary_dark_5: mix(black, $primary, 50%);\n\n// Info color variables\n$info_light_5: mix(white, $info, 92%);\n$info_light_4: mix(white, $info, 78%);\n$info_light_3: mix(white, $info, 60%);\n$info_light_2: mix(white, $info, 42%);\n$info_light_1: mix(white, $info, 24%);\n$info_dark_1: mix(black, $info, 10%);\n$info_dark_2: mix(black, $info, 20%);\n$info_dark_3: mix(black, $info, 30%);\n$info_dark_4: mix(black, $info, 40%);\n$info_dark_5: mix(black, $info, 50%);\n\n// Sucess color variables\n$success_light_5: mix(white, $success, 92%);\n$success_light_4: mix(white, $success, 78%);\n$success_light_3: mix(white, $success, 60%);\n$success_light_2: mix(white, $success, 42%);\n$success_light_1: mix(white, $success, 24%);\n$success_dark_1: mix(black, $success, 10%);\n$success_dark_2: mix(black, $success, 20%);\n$success_dark_3: mix(black, $success, 30%);\n$success_dark_4: mix(black, $success, 40%);\n$success_dark_5: mix(black, $success, 50%);\n\n// Danger color variables\n$danger_light_5: mix(white, $danger, 92%);\n$danger_light_4: mix(white, $danger, 78%);\n$danger_light_3: mix(white, $danger, 60%);\n$danger_light_2: mix(white, $danger, 42%);\n$danger_light_1: mix(white, $danger, 24%);\n$danger_dark_1: mix(black, $danger, 10%);\n$danger_dark_2: mix(black, $danger, 20%);\n$danger_dark_3: mix(black, $danger, 30%);\n$danger_dark_4: mix(black, $danger, 40%);\n$danger_dark_5: mix(black, $danger, 50%);\n\n// Warning color variables\n$warning_light_5: mix(white, $warning, 92%);\n$warning_light_4: mix(white, $warning, 78%);\n$warning_light_3: mix(white, $warning, 60%);\n$warning_light_2: mix(white, $warning, 42%);\n$warning_light_1: mix(white, $warning, 24%);\n$warning_dark_1: mix(black, $warning, 10%);\n$warning_dark_2: mix(black, $warning, 20%);\n$warning_dark_3: mix(black, $warning, 30%);\n$warning_dark_4: mix(black, $warning, 40%);\n$warning_dark_5: mix(black, $warning, 50%);\n\n// Secondary color variables \n$secondary_light_5: mix(white, $secondary, 92%);\n$secondary_light_4: mix(white, $secondary, 78%);\n$secondary_light_3: mix(white, $secondary, 60%);\n$secondary_light_2: mix(white, $secondary, 42%);\n$secondary_light_1: mix(white, $secondary, 24%);\n$secondary_dark_1: mix(black, $secondary, 10%);\n$secondary_dark_2: mix(black, $secondary, 20%);\n$secondary_dark_3: mix(black, $secondary, 30%);\n$secondary_dark_4: mix(black, $secondary, 40%);\n$secondary_dark_5: mix(black, $secondary, 50%);\n\n// Social Media color variables\n$facebook:#1778F2;\n$twitter:#00acee;\n$dribbble:#ea4c89;\n$pinterest:#E60023;\n$youtube:#FF0000;\n$googleplus:#db4a39;\n$instagram:#f0100f;\n$behance:#053eff;\n$dropbox:#0061ff;\n$linkedin:#0077B5;\n$skype: #00aff0;\n$tumblr: #000000;\n$flickr: #0063dc;\n$behance: #1769ff;\n$github: #24292e;\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $grey_light_5,\n  \"dark\":       $black_2,\n) !default;\n// scss-docs-end table-loop\n\n:root {\n  --bs-body-font-family: 'DM Sans', sans-serif;\n  --bs-text-opacity:1;\n  --bs-bg-opacity: 1;\n}","","/*------------------------------------------------------------------\n[Header]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/*Top Nav*/\n.hk-wrapper {\n\t.hk-navbar {\n\t\tborder-bottom: 1px solid $grey_light_4;\n\t\theight:65px;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t\t.navbar-nav {\n\t\t\t.nav-item {\n\t\t\t\t.dropdown {\n\t\t\t\t\t.dropdown-menu {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t}\n\t\t\t\t\t&.dropdown-notifications {\n\t\t\t\t\t\t.dropdown-menu {\n\t\t\t\t\t\t\twidth:21.875rem;\n\t\t\t\t\t\t\t.dropdown-header {\n\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\t\t\t\tborder-bottom:1px solid $grey_light_5;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dropdown-body {\n\t\t\t\t\t\t\t\theight:23.75rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dropdown-footer {\n\t\t\t\t\t\t\t\tborder-top:1px solid $grey_light_5;\n\t\t\t\t\t\t\t\tpadding:1rem;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dropdown-item {\n\t\t\t\t\t\t\t\twhite-space:inherit;\n\t\t\t\t\t\t\t\tpadding-top:.75rem;\n\t\t\t\t\t\t\t\tpadding-bottom:.75rem;\n\t\t\t\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\t\t.notifications-info {\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t\t\t\t\t>.badge {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t.notifications-time {\t\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t\t.navbar-search {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t.input-search {\n\t\t\t\tinput.form-control {\n\t\t\t\t\t>span.btn-input-clear {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t+ {\n\t\t\t\t\t\t.input-suffix,\n\t\t\t\t\t\t.input-prefix {\n\t\t\t\t\t\t\tpointer-events: none;\n\t\t\t\t\t\t\t>span.spinner-border {\n\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\t+ {\n\t\t\t\t\t\t\t.input-suffix,\n\t\t\t\t\t\t\t.input-prefix {\n\t\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\t\tpointer-events: auto;\n\t\t\t\t\t\t\t\t>span:not(.btn-input-clear):not(.spinner-border) {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.loading {\n\t\t\t\t\tinput.form-control{\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t+ {\n\t\t\t\t\t\t\t\t.input-suffix,\n\t\t\t\t\t\t\t\t.input-prefix {\n\t\t\t\t\t\t\t\t\t>span {\n\t\t\t\t\t\t\t\t\t\t&.btn-input-clear {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: none!important;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t&.spinner-border {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: inline;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.dropdown-menu {\n\t\t\t\twidth:18rem;\n\t\t\t\t.dropdown-body {\n\t\t\t\t\tmax-height:19.75rem;\n\t\t\t\t}\n\t\t\t\t.dropdown-footer {\n\t\t\t\t\tborder-top:1px solid $grey_light_5;\n\t\t\t\t\tpadding:1rem;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t}\n\t\t\t\t.dropdown-item {\n\t\t\t\t\twhite-space:inherit;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.nav-start-wrap,\n\t\t.nav-end-wrap {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\t>.navbar-nav {\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t\t.navbar-brand {\n\t\t\t.brand-img {\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-left: 0.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&[data-navbar-style=\"collapsed\"] {\n\t\t.hk-navbar {\n\t\t\t@include transform(translateY(-100%));\n\t\t\toverflow: hidden;\n\t\t}\n\t\t.hk-pg-wrapper {\n\t\t\tpadding-top:0;\t\n\t\t}\n\t}\n}\n@media (min-width: 992px) {\n\t.hk-wrapper {\n\t\t.hk-navbar {\n\t\t\t@include transition(0.2s ease);\n\t\t}\n\t}\n}\t\t\n@media (min-width: 1200px) {\n\t.hk-wrapper {\n\t\t.hk-navbar {\n\t\t\t.navbar-search {\n\t\t\t\t.input-search {\n\t\t\t\t\tinput.form-control {\n\t\t\t\t\t\twidth: 18rem;\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t+ {\n\t\t\t\t\t\t\t\t.input-suffix,\n\t\t\t\t\t\t\t\t.input-prefix {\n\t\t\t\t\t\t\t\t\t>span{\n\t\t\t\t\t\t\t\t\t\t&.btn-input-clear {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: inline!important;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.nav-start-wrap,\n\t\t\t.nav-end-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t>.navbar-nav {\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&[data-navbar-style=\"collapsed\"] {\n\t\t\t&[data-layout=\"horizontal\"] {\n\t\t\t\t.hk-pg-wrapper {\n\t\t\t\t\tpadding-top:65px;\t\n\t\t\t\t}\n\t\t\t\t&[data-layout-style=\"default\"] .hk-menu {\n\t\t\t\t\ttop:0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t}\n\t}\t\n}\t\n@media (max-width: 1199px) {\n\t.hk-wrapper {\n\t\t.hk-navbar .navbar-search {\n\t\t\t.mobile-search {\n\t\t\t\t.input-search {\n\t\t\t\t\t.input-suffix,\n\t\t\t\t\t.input-prefix {\n\t\t\t\t\t\tpointer-events: auto!important;\n\t\t\t\t\t\t>span{\n\t\t\t\t\t\t\t&.btn-input-clear {\n\t\t\t\t\t\t\t\tdisplay: inline!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.dropdown-menu {\n\t\t\t\tposition: fixed;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\t.dropdown-body {\n\t\t\t\t\tmax-height: calc(100% - 55px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\t\n}","/*------------------------------------------------------------------\n[Footer]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/*Footer*/\n[data-footer=\"simple\"],.footer-simple-example {\n\t&.hk-wrapper {\n\t\t.hk-pg-wrapper  {\n\t\t\tpadding-bottom:120px;\n\t\t}\n\t}\n\t.hk-footer {\n\t\tposition:absolute;\n\t\tleft:0;\n\t\tright:0;\n\t\tbottom: 0;\n\t\tborder-top:1px solid $grey_light_4;\n\t\tbackground:$white;\n\t\t.footer {\n\t\t\t>.row {\n\t\t\t\theight:60px;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\tpadding:22px 0;\n\t\t\t}\n\t\t\t.footer-text {\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t\ta {\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t}\n\t\t\t\t.copy-text {\n\t\t\t\t\tpadding-right:5px;\n\t\t\t\t}\n\t\t\t\t.footer-link-sep {\n\t\t\t\t\tpadding:0 5px;\n\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.footer-extr-link {\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay:flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t.feather-icon {\n\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t\tsvg {\n\t\t\t\t\t\theight:14px;\n\t\t\t\t\t\twidth:14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.footer-wth-bg {\n\t\t\tbackground:$grey_light_5;\n\t\t\tborder-top:none;\n\t\t}\t\n\t}\t\n}\t\n[data-footer=\"complex\"],.footer-complex-example {\n\t&.hk-wrapper {\n\t\t.hk-pg-wrapper  {\n\t\t\tpadding-bottom:400px;\n\t\t}\n\t}\n\t.hk-footer {\n\t\tposition:absolute;\n\t\tleft:0;\n\t\tright:0;\n\t\tbottom: 0;\n\t\tbackground:$white;\n\t\tborder-top:1px solid $grey_light_3;\n\t\t&.footer-wth-bg {\n\t\t\tbackground:$grey_light_5;\n\t\t\tborder-top:none;\n\t\t}\n\t\t.footer {\n\t\t\tpadding-top:40px;\n\t\t\tpadding-bottom:30px;\n\t\t\t>.row:last-child {\n\t\t\t\tmargin-top:3.375rem;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t\t.footer-brand {\n\t\t\t\tdisplay:block;\n\t\t\t\tmargin-bottom:.25rem;\n\t\t\t}\n\t\t\t.footer-info-text {\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\twidth:85%;\n\t\t\t}\n\t\t\t.quick-links-head {\n\t\t\t\ttext-transform:uppercase;\n\t\t\t\tmargin-bottom:1rem;\n\t\t\t\tfont-size: .85rem;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t\t.quick-links {\n\t\t\t\tdisplay:block;\n\t\t\t\tcolor:$black_2;\n\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.footer-text {\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t\ta {\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t}\n\t\t\t\t.copy-text {\n\t\t\t\t\tpadding-right:.25rem;\n\t\t\t\t}\n\t\t\t\t.footer-link-sep {\n\t\t\t\t\tpadding:0 .25rem;\n\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.footer-social-btn-wrap {\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay:flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t.btn {\n\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\tflex-shrink:0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\t\n\t}\t\n}\n.footer-complex-example {\n\t&.hk-wrapper {\n\t\t.hk-pg-wrapper  {\n\t\t\tpadding-bottom:120px;\n\t\t}\n\t}\n}\n@media (max-width: 1400px) {\n\t[data-footer=\"complex\"],.footer-complex-example {\n\t\t&.hk-wrapper {\n\t\t\t.hk-pg-wrapper  {\n\t\t\t\tpadding-bottom:31.875rem;\n\t\t\t}\n\t\t}\n\t\t.hk-footer {\n\t\t\t.footer {\n\t\t\t\t.footer-info-text {\n\t\t\t\t\twidth:100%;\n\t\t\t\t}\n\t\t\t\t>.row {\n\t\t\t\t\t>.col-xl-6 {\n\t\t\t\t\t\t-ms-flex: 0 0 100%;\n\t\t\t\t\t\tflex: 0 0 100%;\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-top:2.125rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-top: 2.125rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t[data-footer=\"simple\"],.footer-simple-example {\n\t\t.hk-footer {\n\t\t\t.footer {\n\t\t\t\t>.row {\n\t\t\t\t\theight: auto;\n\t\t\t\t\t>.col-xl-6 {\n\t\t\t\t\t\t.col-xl-4 {\n\t\t\t\t\t\t\tmargin-bottom:1.875rem;\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t.footer-text {\n\t\t\t\t\ttext-align:center;\n\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t}\n\t\t\t\t.footer-extr-link {\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t[data-footer=\"complex\"],.footer-complex-example {\n\t\t&.hk-wrapper {\n\t\t\t.hk-pg-wrapper  {\n\t\t\t\tpadding-bottom: 34.5rem;\n\t\t\t}\n\t\t}\n\t\t.hk-footer {\n\t\t\t.footer {\n\t\t\t\t.footer-social-btn-wrap {\n\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t-webkit-justify-content: flex-start;\n\t\t\t\t\t-ms-flex-pack: flex-start;\n\t\t\t\t\tmargin-top:1.5rem;\n\t\t\t\t\t.btn:first-child {\n\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n[data-footer=\"complex\"],.footer-complex-example {\n\t\t&.hk-wrapper {\n\t\t\t.hk-pg-wrapper  {\n\t\t\t\tpadding-bottom:63rem;\n\t\t\t}\n\t\t}\n\t\t.hk-footer {\n\t\t\t.footer {\n\t\t\t\t>.row {\n\t\t\t\t\t>.col-xl-6 {\n\t\t\t\t\t\t.col-md-4 {\n\t\t\t\t\t\t\tmargin-bottom:1.875rem;\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 666px) {\n\t[data-footer=\"simple\"],.footer-simple-example {\n\t\t&.hk-wrapper {\n\t\t\t.hk-pg-wrapper  {\n\t\t\t\tpadding-bottom:10rem;\n\t\t\t}\n\t\t}\n\t}\n}\n","/*------------------------------------------------------------------\n[Nav]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/*Navbar*/\n.navbar {\n\t.navbar-toggler-menu,\n\t.navbar-toggler {\n\t\tborder:none;\n\t\tpadding:0;\n\t}\n\t.navbar-toggler-menu {\n\t\talign-self:center;\n\t\tmargin-right:.625rem;\n\t}\n\t.navbar-brand {\n\t\tdisplay: -webkit-inline-box;\n\t\tdisplay: -ms-inline-flexbox;\n\t\tdisplay: inline-flex;\n\t}\n\t&.navbar-dark {\n\t\tbackground:$black_2;\n\t\t.badge {\n\t\t\t&.badge-indicator {\n\t\t\t\tborder-color:$black_2;\n\t\t\t}\n\t\t}\n\t\t.form-control {\n\t\t\tborder-color: $white;\n\t\t\tcolor: $white;\n\t\t}\n\t\t.input-affix-wrapper.affix-border {\n\t\t\t.input-prefix,.input-suffix {\n\t\t\t\tborder-color: $white;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t\t.btn.btn-icon[class*=\"btn-flush-\"] {\n\t\t\t&.btn-flush-dark {\n\t\t\t\tcolor: $white;\n\t\t\t\t&.flush-soft-hover {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\t@include background-opacity($white,0.05);\n\t\t\t\t\t}\n\t\t\t\t\t&:not(:disabled):not(.disabled).active,\n\t\t\t\t\t&:not(:disabled):not(.disabled):active,\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled,\n\t\t\t\t&:disabled {\n\t\t\t\t\t@include color-opacity($white);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.navbar-light {\n\t\tbackground:$white;\n\t\t.badge {\n\t\t\t&.badge-indicator {\n\t\t\t\tborder-color:$white;\n\t\t\t}\n\t\t}\n\t}\n} \n\n/*Nav*/\n.nav-link {\n\tcolor: $primary;\n\t&:hover,&:focus {\n\t\tcolor: $primary_light_1;\n\t}\n}\n.nav {\n\t.nav-item {\n\t\tposition:relative;\n\t\t.nav-link {\n\t\t\t&.no-arrow {\n\t\t\t\tpadding-right:.75rem!important;\n\t\t\t\t&:after {\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.link-with-arrow {\n\t\t\t\tpadding-right: 1.8rem!important;\n\t\t\t\tposition:relative;\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\tfont: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 1rem;\n\t\t\t\t\ttop:calc(50% - 8px);\n\t\t\t\t\t@include transform(rotate(0deg));\n\t\t\t\t\t@include transition(all 0.4s ease);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\t\n\t&.nav-icon {\n\t\t> .nav-item .nav-link {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items:center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t> .nav-icon-wrap {\n\t\t\t\tmargin-right: .875rem;\n\t\t\t\tfont-size:1.25rem;\n\t\t\t\tline-height:0;\n\t\t\t\tposition:relative;\n\t\t\t}\n\t\t}\n\t\t&.nav-icon-top {\n\t\t\t>.nav-item {\n\t\t\t\t> .nav-link {\n\t\t\t\t\ttext-align: center;\n    \t\t\t\tdisplay: block;\n\t\t\t\t\t> .nav-icon-wrap {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\tmargin-bottom:.5rem;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-pills {\n\t\t>.nav-item {\n\t\t\t>.nav-link {\n\t\t\t\tborder-radius:0.5rem;\n\t\t\t\tmargin-left:.25rem;\n\t\t\t\tmargin-right:.25rem;\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: $primary!important;\n\t\t\t\t\t&.link-with-arrow {\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t@include color-opacity($white,0.6);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\t@include color-opacity($white,0.6);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.show > .nav-link {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t\t&.nav-pills-square {\n\t\t\t>.nav-item >.nav-link {\n\t\t\t\tborder-radius:0;\n\t\t\t}\n\t\t}\n\t\t&.nav-pills-rounded {\n\t\t\t>.nav-item >.nav-link {\n\t\t\t\tborder-radius:50rem;\n\t\t\t}\n\t\t}\n\t\t&.nav-pills-soft {\n\t\t\t>.nav-item >.nav-link {\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: $primary_light_5!important;\n\t\t\t\t\tcolor:$primary!important;\n\t\t\t\t\t&.link-with-arrow {\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tcolor:inherit;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tcolor:inherit;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.nav-icon {\n\t\t\t&.nav-icon-top {\n\t\t\t\t>.nav-item {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\tpadding-top:.95rem;\n\t\t\t\t\t\tpadding-bottom:.95rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-line {\n\t\t>.nav-item {\n\t\t\t>.nav-link {\n\t\t\t\tborder-bottom:1px solid transparent;\n\t\t\t\t@include transition(.2s ease-in-out);\n\t\t\t\t&.active {\n\t\t\t\t\tborder-color:$primary!important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-vertical {\n\t\t-ms-flex-direction: column !important;\n\t\tflex-direction: column !important;\n\t\t.nav-item .nav-link {\n\t\t\tjustify-content: flex-start;\n\t\t\t-webkit-justify-content: flex-start;\n\t\t\tposition:relative;\n\t\t\t&[data-toggle=\"collapse\"] {\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\tfont: normal normal normal 14px/1 'Material-Design-Iconic-Font';\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t@include transform(rotate(0deg));\n\t\t\t\t\t@include transition(all 0.4s ease);\n\t\t\t\t}\n\t\t\t\t&[aria-expanded=\"true\"] {\n\t\t\t\t\t&::after {\n\t\t\t\t\t\t@include transform(rotate(-180deg));\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.nav-pills {\n\t\t\t>.nav-item {\n\t\t\t\t>.nav-link {\n\t\t\t\t\tmargin:.25rem 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.nav-line {\n\t\t\t>.nav-item {\n\t\t\t\t>.nav-link {\n\t\t\t\t\tborder-bottom:none;\n\t\t\t\t\tborder-left:1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\t\n\t\t&.nav-separator {\n\t\t\t> .nav-item {\n\t\t\t\t>.nav-link {\n\t\t\t\t\tpadding:.75rem 1.5rem;\n\t\t\t\t}\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: auto;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\theight: 1px;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\n\t}\n\t&.nav-dark {\n\t\t.nav-link {\n\t\t\t@include color-opacity($white,1);\n\t\t\t&:hover,&:focus {\n\t\t\t\t@include color-opacity($white,.8);\n\t\t\t}\n\t\t\t&.disabled {\n\t\t\t\t@include color-opacity($white,.3);\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tcolor:$primary;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t}\n\t\t\t&.link-with-arrow {\n\t\t\t\t&:after {\n\t\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t\t.nav-item.show .nav-link {\n\t\t\tcolor:$white;\n\t\t}\n\t\t&.nav-pills {\n\t\t\t>.nav-item {\n\t\t\t\t>.nav-link.active {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t>.nav-link {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t@include background-opacity($white,.1);\n\t\t\t\t\t}\n\t\t\t\t\t&.disabled {\n\t\t\t\t\t\t@include color-opacity($white,.3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.nav-vertical {\n\t\t\t.nav-item .nav-link {\n\t\t\t\t&[data-toggle=\"collapse\"] {\n\t\t\t\t\t&::after {\n\t\t\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\t\n\t\t&.nav-line {\n\t\t\t.nav-item.show .nav-link {\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n\t}\t\n\t&.nav-light {\n\t\t.nav-link {\n\t\t\t@include color-opacity($black_2,1);\n\t\t\t&:hover,&:focus {\n\t\t\t\t@include color-opacity($black_2,.8);\n\t\t\t}\n\t\t\t&.disabled {\n\t\t\t\t@include color-opacity($black_2,.3);\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tcolor:$primary;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t}\n\t\t\t&.link-with-arrow {\n\t\t\t\t&:after {\n\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.nav-item.show .nav-link {\n\t\t\tcolor:$black_2;\n\t\t}\n\t\t&.nav-vertical {\n\t\t\t.nav-item .nav-link {\n\t\t\t\t&[data-toggle=\"collapse\"] {\n\t\t\t\t\t&::after {\n\t\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\n\t\t&.nav-pills {\n\t\t\t>.nav-item {\n\t\t\t\t>.nav-link.active {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t>.nav-link {\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t\t@include background-opacity($black_2,.08);\n\t\t\t\t\t}\n\t\t\t\t\t&.disabled {\n\t\t\t\t\t\t@include color-opacity($black_2,.3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-sm {\n\t\t> .nav-item .nav-link > .nav-icon-wrap {\n\t\t\tmargin-right: .875rem;\n\t\t\tfont-size:1rem;\n\t\t}\n\t\t.nav-link {\n\t\t\tpadding: .25rem 0.75rem;\n\t\t\tfont-size: 0.875rem;\n\t\t}\n\t}\n}\n.nav-tabs {\n    border-bottom: 1px solid $grey_light_3;\n\t.nav-item.show .nav-link,\n\t>.nav-item > .nav-link {\n\t\t&:hover,&:focus {\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&.active {\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color: rgba(0,0,0,0.1) rgba(0,0,0,0.1) $white;\n\t\t}\n\t}\n\t&.nav-sm {\n\t\t.nav-item.show .nav-link,\n\t\t>.nav-item > .nav-link {\n\t\t\tpadding: .4rem 0.75rem;\n\t\t}\n\t}\n\t.nav-item.show .nav-link {\n\t\tborder-color: rgba(0,0,0,0.1) rgba(0,0,0,0.1) $white;\n\t}\n\t&.nav-pills {\n\t\tborder-bottom:0;\n\t\t>.nav-item {\n\t\t\tmargin-bottom:0;\n\t\t\t>.nav-link {\n\t\t\t\tborder:none!important;\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-light {\n\t\t>.nav-item > .nav-link { \n\t\t\t&.active {\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-color: rgba(0,0,0,0.1) rgba(0,0,0,0.1) $white;\n\t\t\t}\n\t\t}\n\t\t.nav-item.show .nav-link {\n\t\t\tborder-color: rgba(0,0,0,0.1) rgba(0,0,0,0.1) $white;\n\t\t}\n\t}\n\t&.nav-dark {\n\t\t@include border-opacity($white,0.1);\n\t\t>.nav-item > .nav-link { \n\t\t\t&.active {\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-color: rgba(255,255,255,0.1) rgba(255,255,255,0.1) $white;\n\t\t\t}\n\t\t}\n\t\t.nav-item.show .nav-link {\n\t\t\tborder-color: rgba(255,255,255,0.1) rgba(255,255,255,0.1) $white;\n\t\t}\n\t}\n\t&.nav-line {\n\t\tborder-bottom:0;\n\t\t>.nav-item {\n\t\t\tmargin-bottom:0;\n\t\t\t>.nav-link {\n\t\t\t\tbackground:transparent;\n\t\t\t\tborder-left:0;\n\t\t\t\tborder-top:0;\n\t\t\t\tborder-right:0;\n\t\t\t\t&.active {\n\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.tab-content {\n\tmargin-top:1rem;\n}\n.nav-segmented-tabs {\n\tdisplay: -ms-flexbox;\n\tdisplay:flex;\n\tborder-bottom:none;\n\t>.nav-item {\n\t\tmargin-right:-1px;\n\t\t&:first-child {\n\t\t\t.nav-link {\n\t\t\t\tborder-top-left-radius:0.5rem;\n\t\t\t\tborder-bottom-left-radius:0.5rem;\n\t\t\t}\n\t\t}\n\t\t&:last-child {\n\t\t\t.nav-link {\n\t\t\t\tborder-top-right-radius:0.5rem;\n\t\t\t\tborder-bottom-right-radius:0.5rem;\n\t\t\t}\n\t\t}\n\t\t>.nav-link {\n\t\t\tborder:1px solid $grey_light_3!important;\n\t\t\tborder-radius:0;\n\t\t\ttext-align:center;\n\t\t\tbackground:transparent;\n\t\t\theight:100%;\n\t\t\t&.active {\n\t\t\t\tcolor: $white!important;\n\t\t\t\tbackground: $primary!important;\n\t\t\t\tborder-color: $primary!important;\n\t\t\t}\n\t\t}\n\t}\n\t&.segmented-tabs-rounded {\n\t\t>.nav-item {\n\t\t\t&:first-child {\n\t\t\t\t.nav-link {\n\t\t\t\t\tborder-top-left-radius:50px;\n\t\t\t\t\tborder-bottom-left-radius:50px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t.nav-link {\n\t\t\t\t\tborder-top-right-radius:50px;\n\t\t\t\t\tborder-bottom-right-radius:50px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.segmented-tabs-square {\n\t\t>.nav-item {\n\t\t\t>.nav-link {\n\t\t\t\tborder-radius:0;\n\t\t\t}\n\t\t}\n\t}\n\t&.segmented-tabs-filled {\n\t\t>.nav-item {\n\t\t\tmargin-right: 0;\n\t\t\t.nav-link {\n\t\t\t\tborder:none!important;\n\t\t\t\tbackground:$grey_light_5;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.nav-dark {\n\t\t>.nav-item {\n\t\t\t>.nav-link {\n\t\t\t\tborder-color:rgba(255,255,255,.15)!important;\n\t\t\t}\n\t\t\t&.show {\n\t\t\t\t>.nav-link {\n\t\t\t\t\tbackground:transparent;\n\t\t\t\t\tcolor:white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.segmented-tabs-filled {\n\t\t\t>.nav-item {\n\t\t\t\t.nav-link {\n\t\t\t\t\t@include background-opacity($white,0.05);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.nav-header-bold {\n\tpadding: 1.5rem 0 .5rem 0;\n\twidth: 240px;\n\tfont-size: 0.75rem;\n\ttext-transform: uppercase;\n\tfont-weight: 600;\n\tcolor: $primary;\n} \n\n/*Section Nav*/\n.hk-wrapper{\n\t&[data-aside=\"fixed\"] {\n\t\t.hk-pg-wrapper {\n\t\t\tmargin-right:180px;\n\t\t}\n\t\t.hk-aside {\n\t\t\tposition: fixed;\n\t\t\ttop: 65px;\n\t\t\toverflow-y: auto;\n\t\t\twidth: 180px;\n\t\t\tright: 0;\n\t\t\tz-index: 1;\n\t\t\tbackground: $white;\n\t\t\tborder-left: 1px solid $grey_light_3;\n\t\t\tbottom:0;\t\n\t\t\t.nicescroll-bar {\n\t\t\t\tpadding: 1.5rem;\n\t\t\t}\n\t\t}\n\t}\n\t&[data-aside=\"sticky\"] {\n\t\t.hk-aside {\n\t\t\tposition: sticky;\n\t\t\ttop: 70px;\n\t\t\toverflow-y: auto;\n\t\t\theight: calc(100vh - 250px);\n\t\t\tz-index: 1;\n\t\t\tmargin-top: 3rem;\n\t\t}\n\t}\n\t.nav-toc {\n\t\t.nav-header {\n\t\t\tfont-size: .75rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: $grey;\n\t\t}\n\t\t.nav {\n\t\t\tmargin: 1rem 0;\n\t\t\tfont-size: .875rem;\n\t\t\tflex-wrap: nowrap;\n\t\t\tborder-left: 1px solid;\n\t\t\tborder-color: $grey_light_3;\n\t\t\t.nav-item {\n\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\ta.nav-link {\n\t\t\t\t\t@include color-opacity($black_2,1);\n\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t@include color-opacity($black_2,.8);\n\t\t\t\t\t}\n\t\t\t\t\tpadding: 0 0 0 1rem;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tmargin-left: -1px;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tborder-left: 1px solid transparent;\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\tborder-color: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n\t.hk-wrapper[data-aside=\"fixed\"] {\n\t\t.hk-pg-wrapper {\n\t\t\tmargin-right:0;\n\t\t}\n\t\t.hk-aside {\n\t\t\tdisplay:none;\n\t\t}\n\t}\n}\n.toc-wrapper {\n\t.nav.nav-vertical {\n\t\t.nav-item {\n\t\t\t.nav-link{\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tpadding: 0.125rem 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n","/*------------------------------------------------------------------\n[Horizontal Menu]\nProject:\tJampack\n--------------------------------------------------------------------*/\n/**Horizontal Navigation**/\n.hk-wrapper[data-layout=\"horizontal\"] {\n\t.hk-pg-wrapper {\n\t\t@include transition(all 0.2s ease);\n\t}\n\t.hk-menu {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\tz-index:1032;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t\n\t\t>.nicescroll-bar {\n\t\t\toverflow: auto;\n\t\t\tflex: 1 1 auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\tposition: relative;\n\t\t\t.menu-group {\n\t\t\t\t.nav-header {\n\t\t\t\t\tpadding: 0 0 .5rem 0;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tcolor: $primary;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\t.navbar-nav {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tpadding:.5rem 1rem;\n\t\t\t\t\t\t\tmargin:0 -1rem;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t>*{\n\t\t\t\t\t\t\t\t@include transition(transform .25s ease);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\t\t\t>*:not(.badge) {\n\t\t\t\t\t\t\t\t\tfont-size:1.5rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tright: 1rem;\n\t\t\t\t\t\t\t\t\tz-index: -1;\n\t\t\t\t\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\t\t\t\t\tfont: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n\t\t\t\t\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\t\t\t@include transform(rotate(0deg));\n\t\t\t\t\t\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&[aria-expanded=\"true\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t@include transform(rotate(-180deg));\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t>* {\n\t\t\t\t\t\t\t\t\t@include transform(translateX(5px));\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.more-nav-item {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.nav-children {\n\t\t\t\t\t\t\t\t.nav-item .nav-link .nav-icon-wrap{\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\t\theight: calc(100% - 20px);\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tleft: 10px;\n\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\tmargin:auto;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.nav-children {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 1.4rem;\n\t\t\t\t\t\t\tmargin: 0 0 0 1rem;\n\t\t\t\t\t\t\t@include transition(all .25s ease);\n\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}    \t\n\t\t\t\t\t.nav-children {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 2rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} \n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t}\n\t\t.menu-header {\n\t\t\tpadding: 0.5rem 1.5rem;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex: 0 0 auto;\n\t\t\theight: 65px;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\toverflow: hidden;\n\t\t\t.navbar-toggle {\n\t\t\t\tflex-shrink: 0;\t\n\t\t\t}\n\t\t\t>span {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-shrink: 0;\n    \t\t\talign-items: center;\n\t\t\t\tflex-grow: 1;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t.navbar-brand {\n\t\t\t\t\t.brand-img {\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-left: 0.5rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&[data-layout-style=\"default\"] {\n\t\t.hk-pg-wrapper {\n\t\t\tmargin-left: 0;\n\t\t}\n\t\t.hk-navbar {\n\t\t\tleft:0;\n\t\t}\n\t\t.hk-menu {\n\t\t\tleft: -270px;\n\t\t}\n\t}\n\t&[data-layout-style=\"collapsed\"] {\n\t\t.hk-menu {\n\t\t\tleft: 0;\n\t\t}\n\t\t.hk-menu-backdrop {\n\t\t\tposition: fixed;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\ttop: 0;\n\t\t\tz-index: 1031;\n\t\t\t@include transition(all 0.25s ease);\n\t\t\t@include background-opacity($black_2,.5);\n\t\t\topacity: 1;\n\t\t\theight: auto;\n\t\t\twidth: auto;\n\t\t\tvisibility: visible;\n\t\t}\n\t}\n\t&[data-menu=\"light\"] {\n\t\t.hk-menu {\n\t\t\tbackground:$white;\n\t\t\t.menu-content-wrap {\n\t\t\t\t.menu-group {\n\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&[data-menu=\"dark\"] {\n\t\t.hk-menu {\n\t\t\tbackground:$black_2;\n\t\t\t.menu-content-wrap {\n\t\t\t\t.menu-group {\n\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t.hk-wrapper[data-layout=\"horizontal\"] {\n\t\t.hk-menu {\n\t\t\t.menu-content-wrap > .menu-group {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t}\n}\t\n@media (min-width: 1200px) {\n\t.hk-wrapper[data-layout=\"horizontal\"] {\n\t\t&.hk-section-nav-active .hk-section-nav {\n\t\t\ttop: 130px;\n\t\t}\n\t\t.hk-pg-wrapper {\n\t\t\tpadding-top: 130px;\n\t\t}\n\t\t&[data-layout-style=\"default\"] {\n\t\t\t.hk-menu {\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 65px;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: auto;\n\t\t\t\twidth: 100%;\n\t\t\t\t@include transform(translateY(0));\n\t\t\t\tborder-bottom: 1px solid $grey_light_4;\n\t\t\t\tborder-right: 0;\n\t\t\t\tz-index: 1029;\n\t\t\t\t>.nicescroll-bar {\n\t\t\t\t\toverflow: visible !important;\n\t\t\t\t}\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\tpadding:0;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tmin-height: auto;\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t>.navbar-nav.flex-column {\n\t\t\t\t\t\t\tflex-direction: row!important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul:after {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t\tmin-height: 65px;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t>* {\n\t\t\t\t\t\t\t\t\t\t\t@include transform(translateX(0));\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t} \n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\t\t\tposition: static;\n\t\t\t\t\t\t\t\t\t\tmargin-left: 0.75rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\tul {\n\t\t\t\t\t\t\t\t\t&.nav-children {\n\t\t\t\t\t\t\t\t\t\theight: auto !important;\n\t\t\t\t\t\t\t\t\t\tmin-width:10rem;\n\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\tz-index:1;\n\t\t\t\t\t\t\t\t\t\tborder-radius: .25rem;\n\t\t\t\t\t\t\t\t\t\tborder: 1px solid $grey_light_4;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&.nav-children {\n\t\t\t\t\t\t\t\t\t\tpadding: 1rem 0;\n\t\t\t\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\t\t\t\tpadding: .25rem 1.5rem;\n\t\t\t\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\t\t\t\t\t\t\t@include transform(rotate(-90deg));\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\t\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\t\t\t\t\t\t\t\tleft:100%;\n\t\t\t\t\t\t\t\t\t\t\t\ttop:0;\n\t\t\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: .25rem 1rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t&.edge {\n\t\t\t\t\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\t\t\t\t\tleft:auto!important;\n\t\t\t\t\t\t\t\t\t\t\t\t\tright: 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.collapse,\n\t\t\t\t\t\t\t\t\t&.collapse.show,\n\t\t\t\t\t\t\t\t\t&.collapsing {\n\t\t\t\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\t\t\t\tclip: rect(1px, 1px, 1px, 1px);\n\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t@include transition(transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1));\n\t\t\t\t\t\t\t\t\t\t@include transform(translateY(-10px) scaleY(0.5));\n\t\t\t\t\t\t\t\t\t\t-webkit-transform-origin: top;\n\t\t\t\t\t\t\t\t\t\ttransform-origin: top;\n\t\t\t\t\t\t\t\t\t\t@include boxshadow($black);\n\t\t\t\t\t\t\t\t\t\ttop: 100%;\n\t\t\t\t\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t\t&.collapse,\n\t\t\t\t\t\t\t\t\t\t&.collapse.show,\n\t\t\t\t\t\t\t\t\t\t&.collapsing {\n\t\t\t\t\t\t\t\t\t\t\tclip: auto;\n\t\t\t\t\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\t\t\t\t\t@include transform(translateY(0) scaleY(1));\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&[data-menu=\"light\"] {\n\t\t\t.hk-menu {\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\tbackground: $white;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&[data-menu=\"dark\"] {\n\t\t\t.hk-menu {\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\tbackground: $black_2;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\t\n","","/*------------------------------------------------------------------\n[Classic Menu]\nProject:\tJampack\n--------------------------------------------------------------------*/\n/**Vertical Navigation**/\n.hk-wrapper[data-layout=\"vertical\"] {\n\t.hk-pg-wrapper {\n\t\t@include transition(all 0.2s ease);\n\t}\n\t.hk-menu {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\tz-index:1032;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t\n\t\t>.nicescroll-bar {\n\t\t\toverflow: auto;\n\t\t\tflex: 1 1 auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\tposition: relative;\n\t\t\t.menu-group {\n\t\t\t\t.nav-header {\n\t\t\t\t\tpadding: 0 0 .5rem 0;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tcolor: $grey;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\t.navbar-nav {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tpadding:.5rem 1rem;\n\t\t\t\t\t\t\tmargin:0 -1rem;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t>*{\n\t\t\t\t\t\t\t\t@include transition(transform .25s ease);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\t\t\t>*:not(.badge) {\n\t\t\t\t\t\t\t\t\tfont-size:1.5rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tright: 1rem;\n\t\t\t\t\t\t\t\t\tz-index: -1;\n\t\t\t\t\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\t\t\t\t\tfont: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n\t\t\t\t\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\t\t\t@include transform(rotate(0deg));\n\t\t\t\t\t\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&[aria-expanded=\"true\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t@include transform(rotate(-180deg));\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t>* {\n\t\t\t\t\t\t\t\t\t@include transform(translateX(5px));\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t\tborder-radius: 0.5rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\t\theight: calc(100% - 20px);\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tleft: 10px;\n\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\tmargin:auto;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.nav-children {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 1.4rem;\n\t\t\t\t\t\t\tmargin: 0 0 0 1rem;\n\t\t\t\t\t\t\t@include transition(all .25s ease);\n\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}    \t\n\t\t\t\t\t.nav-children {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 2rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} \n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t}\n\t\t.menu-header {\n\t\t\tpadding: 0.5rem 1.1875rem;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex: 0 0 auto;\n\t\t\theight: 65px;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\toverflow: hidden;\n\t\t\t.navbar-toggle {\n\t\t\t\tflex-shrink: 0;\t\n\t\t\t}\n\t\t\t>span {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-shrink: 0;\n    \t\t\talign-items: center;\n\t\t\t\tflex-grow: 1;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t.navbar-brand {\n\t\t\t\t\t.brand-img {\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-left: 0.5rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t/*Sidebar fixednav*/\n\t\t.bottom-nav {\n\t\t\tflex: 0 0 auto;\n\t\t\tpadding-bottom: .5rem;\t\n\t\t}\n\n\t\t/*Horizontal Scrollbar*/\n\t\t.simplebar-track.simplebar-horizontal {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t&[data-layout-style=\"default\"] {\n\t\t.hk-pg-wrapper {\n\t\t\tmargin-left: 0;\n\t\t}\n\t\t.hk-navbar {\n\t\t\tleft:0;\n\t\t}\n\t\t.hk-menu {\n\t\t\tleft: -270px;\n\t\t}\n\t}\n\t&[data-layout-style=\"collapsed\"] {\n\t\t.hk-menu {\n\t\t\tleft: 0;\n\t\t}\n\t\t.hk-menu-backdrop {\n\t\t\tposition: fixed;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\ttop: 0;\n\t\t\tz-index: 1031;\n\t\t\t@include transition(all 0.25s ease);\n\t\t\t@include background-opacity($black_2,.5);\n\t\t\topacity: 1;\n\t\t\theight: auto;\n\t\t\twidth: auto;\n\t\t\tvisibility: visible;\n\t\t}\n\t}\n\t&[data-menu=\"light\"] {\n\t\t.hk-menu {\n\t\t\tbackground:$white;\n\t\t\t.menu-content-wrap {\n\t\t\t\t.menu-group {\n\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&[data-menu=\"dark\"] {\n\t\t.hk-menu {\n\t\t\tbackground:$black_2;\n\t\t\t.menu-content-wrap {\n\t\t\t\t.menu-group {\n\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\t\n@media (min-width: 1200px) {\n\t.hk-wrapper[data-layout=\"vertical\"] {\n\t\t&[data-layout-style=\"default\"] {\n\t\t\t.hk-pg-wrapper {\n\t\t\t\tmargin-left: 270px;\n\t\t\t}\n\t\t\t.hk-navbar {\n\t\t\t\tleft:270px;\n\t\t\t}\n\t\t\t.hk-menu {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t}\n\t\t&[data-layout-style=\"collapsed\"] {\n\t\t\t.hk-pg-wrapper {\n\t\t\t\tmargin-left: 72px;\n\t\t\t}\n\t\t\t.hk-navbar {\n\t\t\t\tleft:72px;\n\t\t\t}\n\t\t\t.hk-menu {\n\t\t\t\twidth: 72px;\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t>.callout {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.nav-header {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.navbar-nav > .nav-item > .nav-link  {\n\t\t\t\t\t\t\t> *:not(.nav-icon-wrap) {\n\t\t\t\t\t\t\t\tvisibility: hidden;\n\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\tright: -1.5rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.collapse.show {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.menu-gap {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t} \n\t\t\t\t.menu-header {\n\t\t\t\t\t>span {\n\t\t\t\t\t\t.navbar-brand {\n\t\t\t\t\t\t\t.brand-img {\n\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.navbar-toggle {\n\t\t\t\t\t@include transform(rotate(180deg));\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-hover=\"active\"] {\n\t\t\t\t.hk-menu:hover {\n\t\t\t\t\twidth: 270px;\n\t\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t\t>.callout {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t\t.nav-header {\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.navbar-nav > .nav-item > .nav-link  {\n\t\t\t\t\t\t\t\t> *:not(.nav-icon-wrap) {\n\t\t\t\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\t\tright: 1rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.collapse.show {\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} \n\t\t\t\t\t\t.menu-gap {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t}\n\t\t\t\t\t} \n\t\t\t\t\t.menu-header {\n\t\t\t\t\t\t>span {\n\t\t\t\t\t\t\t.navbar-brand {\n\t\t\t\t\t\t\t\t.brand-img {\n\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\tdisplay: inline;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.hk-menu-backdrop {\n\t\t\t\topacity: 0;\n\t\t\t\theight: 0;\n\t\t\t\twidth: 0;\n\t\t\t\tvisibility: hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\t\n","/*------------------------------------------------------------------\n[Icon Menu]\nProject:\tJampack\n-------------------------------------------------------------------*/\n/**Vertical Icon Navigation**/\n.hk-wrapper[data-layout=\"twocolumn\"] {\n\t.hk-pg-wrapper {\n\t\tmargin-left: 72px;\n\t\t@include transition(all 0.2s ease);\n\t}\n\t.hk-navbar {\n\t\tleft:72px;\n\t}\n\t.hk-menu {\n\t\t.main-menu {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-flow: column;\n\t\t\tposition: fixed;\n\t\t\tleft: 0;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\twidth: 72px;\n\t\t\tmargin-left: 0;\n\t\t\tz-index:1032;\n\t\t\tborder-right: 1px solid $grey_light_3;\n\t\t\t@include transition(all 0.2s ease);\n\t\t\t\n\t\t\t>.nicescroll-bar {\n\t\t\t\toverflow: auto;\n\t\t\t\tflex: 1 1 auto;\n\t\t\t}\n\t\t\t.menu-content-wrap {\n\t\t\t\tpadding:1.5rem;\n\t\t\t\tposition: relative;\n\t\t\t\t.navbar-nav {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tpadding:.5rem 1rem;\n\t\t\t\t\t\t\tmargin:0 -1rem;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\t\t\t>*:not(.badge) {\n\t\t\t\t\t\t\t\t\tfont-size:1.5rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t\tborder-radius: 0.5rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.menu-header {\n\t\t\t\tpadding: 0.5rem 1.5rem;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\theight: 65px;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\t.navbar-brand {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t/*Sidebar fixednav*/\n\t\t\t.bottom-nav {\n\t\t\t\tflex: 0 0 auto;\n\t\t\t\tpadding-bottom: .5rem;\t\n\t\t\t}\n\t\t}\n\t\t.sub-menu {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-flow: column;\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 72px;\n\t\t\twidth: 270px;\n\t\t\tmargin-left: 0;\n\t\t\tz-index:1031;\n\t\t\toverflow: hidden;\n\t\t\tborder-right: 1px solid $grey_light_3;\n\t\t\t@include transform(translate(-100%));\n\t\t\t@include transition(all 0.2s ease);\n\t\t\t>.nicescroll-bar {\n\t\t\t\toverflow: auto;\n\t\t\t\tflex: 1 1 auto;\n\t\t\t}\n\t\t\t.menu-content-wrap {\n\t\t\t\tpadding:1.5rem;\n\t\t\t\tposition: relative;\n\t\t\t\t.menu-group {\n\t\t\t\t\t.nav-header {\n\t\t\t\t\t\tpadding: 0 0 .5rem 0;\n\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t}\n\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\tpadding:.5rem 1rem;\n\t\t\t\t\t\t\t\tmargin:0 -1rem;\n\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t>*{\n\t\t\t\t\t\t\t\t\t@include transition(transform .25s ease);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\t\t\t\t>*:not(.badge) {\n\t\t\t\t\t\t\t\t\t\tfont-size:1.5rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\tright: 1rem;\n\t\t\t\t\t\t\t\t\t\tz-index: -1;\n\t\t\t\t\t\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\t\t\t\t\t\tfont: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n\t\t\t\t\t\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\t\t\t\t@include transform(rotate(0deg));\n\t\t\t\t\t\t\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&[aria-default=\"true\"] {\n\t\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t\t@include transform(rotate(-180deg));\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t>* {\n\t\t\t\t\t\t\t\t\t\t@include transform(translateX(5px));\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\t\t\theight: calc(100% - 20px);\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tleft: 10px;\n\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\tmargin:auto;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.nav-children {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 1.4rem;\n\t\t\t\t\t\t\t\tmargin: 0 0 0 1rem;\n\t\t\t\t\t\t\t\t@include transition(all .25s ease);\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}    \t\n\t\t\t\t\t\t.nav-children {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 2rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} \n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.menu-gap {\n\t\t\t\t\theight: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.menu-header {\n\t\t\t\tpadding: 0 1.5rem;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex: 0 0 auto;\n\t\t\t\tmin-height: 65px;\n\t\t\t\twidth: 269px;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\t\t.navbar-toggle {\n\t\t\t\t\t\tflex-shrink: 0;\t\n\t\t\t\t\t}\n\t\t\t}\n\t\t\t.subnav-list {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\t&[data-submenu=\"active\"] {\n\t\t.hk-menu {\n\t\t\t.sub-menu {\n\t\t\t\t@include transform(translate(0));\n\t\t\t}\n\t\t}\n\t}\n\t&[data-menu=\"light\"] {\n\t\t.hk-menu {\n\t\t\t.main-menu {\n\t\t\t\tbackground:$white;\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.sub-menu {\n\t\t\t\tbackground:$white;\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&[data-menu=\"dark\"] {\n\t\t.hk-menu {\n\t\t\t.main-menu {\n\t\t\t\tbackground:$black_2;\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.sub-menu {\n\t\t\t\tbackground:$black;\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\t\n@media (max-width: 1199px) {\n\t.hk-wrapper[data-layout=\"twocolumn\"] {\n\t\t.hk-pg-wrapper {\n\t\t\tmargin-left: 0;\n\t\t}\n\t\t.hk-navbar {\n\t\t\tleft:0;\n\t\t}\n\t\t.hk-menu {\n\t\t\t.main-menu {\n\t\t\t\tleft: -72px;\n\t\t\t}\n\t\t\t.sub-menu {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t}\n\t\t&[data-layout-style=\"offcanvas\"] {\n\t\t\t.hk-menu {\n\t\t\t\t.main-menu {\n\t\t\t\t\tleft: 0;\n\t\t\t\t}\n\t\t\t\t.sub-menu {\n\t\t\t\t\tleft: 72px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.hk-menu-backdrop {\n\t\t\t\tposition: fixed;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\ttop: 0;\n\t\t\t\tz-index: 1030;\n\t\t\t\t@include background-opacity($black_2,.5);\n\t\t\t\theight: auto;\n\t\t\t\twidth: auto;\n\t\t\t}\n\t\t}\n\t}\n}\n","/*------------------------------------------------------------------\n[Navbar Menu]\nProject:\tJampack\n--------------------------------------------------------------------*/\n/**Navbar Navigation**/\n.hk-wrapper[data-layout=\"navbar\"] {\n\t.hk-pg-wrapper {\n\t\t@include transition(all 0.2s ease);\n\t}\n\t.hk-menu {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\tz-index:1032;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t\n\t\t>.nicescroll-bar {\n\t\t\toverflow: auto;\n\t\t\tflex: 1 1 auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\tposition: relative;\n\t\t\t.menu-group {\n\t\t\t\t.nav-header {\n\t\t\t\t\tpadding: 0 0 .5rem 0;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tcolor: $primary;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\t.navbar-nav {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tpadding:.5rem 1rem;\n\t\t\t\t\t\t\tmargin:0 -1rem;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t>*{\n\t\t\t\t\t\t\t\t@include transition(transform .25s ease);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\t\t\t>*:not(.badge) {\n\t\t\t\t\t\t\t\t\tfont-size:1.5rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tright: 1rem;\n\t\t\t\t\t\t\t\t\tz-index: -1;\n\t\t\t\t\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\t\t\t\t\tfont: normal normal normal 1.125rem/1 'Material-Design-Iconic-Font';\n\t\t\t\t\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\t\t\t@include transform(rotate(0deg));\n\t\t\t\t\t\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&[aria-expanded=\"true\"] {\n\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t@include transform(rotate(-180deg));\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t>* {\n\t\t\t\t\t\t\t\t\t@include transform(translateX(5px));\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.more-nav-item {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.nav-children {\n\t\t\t\t\t\t\t\t.nav-item .nav-link .nav-icon-wrap{\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\t\theight: calc(100% - 20px);\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tleft: 10px;\n\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\tmargin:auto;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.nav-children {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 1.4rem;\n\t\t\t\t\t\t\tmargin: 0 0 0 1rem;\n\t\t\t\t\t\t\t@include transition(all .25s ease);\n\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}    \t\n\t\t\t\t\t.nav-children {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tpadding: 0.15rem 0 0.15rem 2rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} \n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t}\n\t\t.menu-header {\n\t\t\tpadding: 0.5rem 1.5rem;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex: 0 0 auto;\n\t\t\theight: 65px;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\toverflow: hidden;\n\t\t\t.navbar-toggle {\n\t\t\t\tflex-shrink: 0;\t\n\t\t\t}\n\t\t\t>span {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-shrink: 0;\n    \t\t\talign-items: center;\n\t\t\t\tflex-grow: 1;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t.navbar-brand {\n\t\t\t\t\t.brand-img {\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-left: 0.5rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&[data-layout-style=\"default\"] {\n\t\t.hk-pg-wrapper {\n\t\t\tmargin-left: 0;\n\t\t}\n\t\t.hk-navbar {\n\t\t\tleft:0;\n\t\t}\n\t\t.hk-menu {\n\t\t\tleft: -270px;\n\t\t}\n\t}\n\t&[data-layout-style=\"collapsed\"] {\n\t\t.hk-menu {\n\t\t\tleft: 0;\n\t\t}\n\t\t.hk-menu-backdrop {\n\t\t\tposition: fixed;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\ttop: 0;\n\t\t\tz-index: 1031;\n\t\t\t@include transition(all 0.25s ease);\n\t\t\t@include background-opacity($black_2,.5);\n\t\t\topacity: 1;\n\t\t\theight: auto;\n\t\t\twidth: auto;\n\t\t\tvisibility: visible;\n\t\t}\n\t}\n\t.simplebar-track.simplebar-horizontal {\n\t\tdisplay: none;\n\t}\n\t.hk-navbar.navbar {\n\t\t&.navbar-light {\n\t\t\t.hk-menu {\n\t\t\t\tbackground:$white;\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.navbar-dark {\n\t\t\t.hk-menu {\n\t\t\t\tbackground:$black_2;\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\t\t\t@include color-opacity($white,0.3);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t.hk-wrapper[data-layout=\"navbar\"] {\n\t\t.hk-menu {\n\t\t\t.container.menu-group {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t}\n}\t\n@media (min-width: 1200px) {\n\t.hk-wrapper[data-layout=\"navbar\"] {\n\t\t&[data-layout-style=\"default\"] {\n\t\t\t.hk-menu {\n\t\t\t\tbackground: inherit!important;\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: static;\n\t\t\t\t@include transform(translateY(0));\n\t\t\t\tborder: 0;\n\t\t\t\t>.nicescroll-bar {\n\t\t\t\t\toverflow: visible !important;\n\t\t\t\t}\n\t\t\t\t.menu-content-wrap {\n\t\t\t\t\tpadding:0;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tmin-height: auto;\n\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t>.navbar-nav.flex-column {\n\t\t\t\t\t\t\tflex-direction: row!important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t> .nav-item {\n\t\t\t\t\t\t\t\t> ul:after {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\t\t\tmin-height: 65px;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t>* {\n\t\t\t\t\t\t\t\t\t\t\t@include transform(translateX(0));\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t} \n\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\t\t\tposition: static;\n\t\t\t\t\t\t\t\t\t\tmargin-left: 0.75rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\tul {\n\t\t\t\t\t\t\t\t\t&.nav-children {\n\t\t\t\t\t\t\t\t\t\theight: auto !important;\n\t\t\t\t\t\t\t\t\t\tmin-width:10rem;\n\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\tz-index:1;\n\t\t\t\t\t\t\t\t\t\tborder-radius: .25rem;\n\t\t\t\t\t\t\t\t\t\tborder: 1px solid $grey_light_4;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t&.nav-children {\n\t\t\t\t\t\t\t\t\t\tpadding: 1rem 0;\n\t\t\t\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\t\t\t\tpadding: .25rem 1.5rem;\n\t\t\t\t\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"]::after {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\t\t\t\t\t\t\t@include transform(rotate(-90deg));\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\t\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\t\t\t\t\t\t\t\tleft:100%;\n\t\t\t\t\t\t\t\t\t\t\t\ttop:0;\n\t\t\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: .25rem 1rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t&.edge {\n\t\t\t\t\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\t\t\t\t\tleft:auto!important;\n\t\t\t\t\t\t\t\t\t\t\t\t\tright: 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.collapse,\n\t\t\t\t\t\t\t\t\t&.collapse.show,\n\t\t\t\t\t\t\t\t\t&.collapsing {\n\t\t\t\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\t\t\t\tclip: rect(1px, 1px, 1px, 1px);\n\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t@include transition(transform 0.1s cubic-bezier(0.2, 0, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 0, 0.2, 1));\n\t\t\t\t\t\t\t\t\t\t@include transform(translateY(-10px) scaleY(0.5));\n\t\t\t\t\t\t\t\t\t\t-webkit-transform-origin: top;\n\t\t\t\t\t\t\t\t\t\ttransform-origin: top;\n\t\t\t\t\t\t\t\t\t\t@include boxshadow($black);\n\t\t\t\t\t\t\t\t\t\ttop: 100%;\n\t\t\t\t\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\t\t\t\t&.collapse,\n\t\t\t\t\t\t\t\t\t\t&.collapse.show,\n\t\t\t\t\t\t\t\t\t\t&.collapsing {\n\t\t\t\t\t\t\t\t\t\t\tclip: auto;\n\t\t\t\t\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\t\t\t\t\t@include transform(translateY(0) scaleY(1));\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.hk-navbar.navbar {\n\t\t\t&.navbar-light {\n\t\t\t\t.hk-menu {\n\t\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\t\tbackground: $white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.navbar-dark {\n\t\t\t\t.hk-menu {\n\t\t\t\t\t.menu-content-wrap {\n\t\t\t\t\t\t.menu-group {\n\t\t\t\t\t\t\t.navbar-nav {\n\t\t\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t\t\tul.nav-children {\n\t\t\t\t\t\t\t\t\t\tbackground: $black_2;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\t\n","/*------------------------------------------------------------------\n[Drawer]\nProject:\tJampack\n-------------------------------------------------------------------*/\n\n/*Drawer*/\n.hk-wrapper {\n\t.hk-drawer {\n\t\tposition: fixed;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\ttop: 0;\n\t\tright: -320px;\n\t\twidth: 320px;\n\t\tbottom: 0;\n\t\tz-index:1050;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\t@include transition(all 0.2s ease);\n\t\t.drawer-header {\n\t\t\tpadding:0.75rem 1.25rem;\n\t\t\tborder-bottom:1px solid $grey_light_3;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\t.drawer-text {\n\t\t\t\tfont-size:1rem;\n\t\t\t\tcolor:$black;\n\t\t\t\tfont-weight:500;\n\t\t\t}\n\t\t\t.drawer-header-action {\n\t\t\t\tmargin-left:auto;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t\t&.header-bold {\n\t\t\t\t.drawer-text {\n\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\ttext-transform:uppercase;\n\t\t\t\t\tfont-weight:600;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.header-wth-bg {\n\t\t\t\tbackground:$primary;\n\t\t\t\tborder-bottom:0;\n\t\t\t\t.drawer-text {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\n\t\t\t\t.drawer-close {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.header-flush {\n\t\t\t\tborder-bottom:0;\n\t\t\t}\n\t\t}\n\t\t.drawer-body {\n\t\t\toverflow: auto;\n\t\t\tflex: 1 1 auto;\n\t\t\t.drawer-content-wrap {\n\t\t\t\tPadding: 1.25rem 1.25rem 7rem 1.25rem;\n\t\t\t\t.drawer-close {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 14px;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.drawer-footer {\n\t\t\tpadding:0.75rem 1.25rem;\n\t\t\tbackground:$white;\n\t\t\tborder-top:1px solid $grey_light_3;\n\t\t}\n\t\t&.drawer-left {\n\t\t\tleft:-320px;\n\t\t\tborder-right: 1px solid $grey_light_3;\n\t\t}\n\t\t&.drawer-right {\n\t\t\tright:-320px;\n\t\t\tborder-left: 1px solid $grey_light_3;\n\t\t}\n\t\t&.drawer-small {\n\t\t\ttop:65px;\n\t\t}\n\t\t&.drawer-toggle {\n\t\t\t&.hk-drawer {\n\t\t\t\t&.drawer-left {\n\t\t\t\t\tleft:0;\n\t\t\t\t}\n\t\t\t\t&.drawer-right {\n\t\t\t\t\tright:0;\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\n\t}\n\t&.hk-drawer-push {\n\t\t&.hk-drawer-pushleft {\n\t\t\t.hk-pg-wrapper {\n\t\t\t\tmargin-left: 20rem;\n\t\t\t}\t\n\t\t}\n\t\t&.hk-drawer-pushright {\n\t\t\t.hk-pg-wrapper {\n\t\t\t\tmargin-right: 20rem;\n\t\t\t}\t\n\t\t}\n\t\t&.hk-drawer-wth-nav-push {\n\t\t\t.hk-navbar {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t}\n\t\t\t&.hk-drawer-pushleft {\n\t\t\t\t.hk-navbar {\n\t\t\t\t\tleft: 320px;\n\t\t\t\t}\t\t\n\t\t\t}\n\t\t\t&.hk-drawer-pushright {\n\t\t\t\t.hk-navbar {\n\t\t\t\t\tright: 320px;\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t}\n\t.hk-drawer-backdrop {\n\t\tposition: absolute;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tbackground: $black_2;\n\t\topacity:0.25;\n\t\tz-index: 1033;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n@media (max-width: 1199px) {\n\t.hk-wrapper {\n\t\t&.hk-drawer-push {\n\t\t\t&.hk-drawer-pushleft {\n\t\t\t\t.hk-pg-wrapper {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.hk-drawer-pushright {\n\t\t\t\t.hk-pg-wrapper {\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.hk-drawer-wth-nav-push {\n\t\t\t\t.hk-navbar {\n\t\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t}\n\t\t\t\t&.hk-drawer-pushleft {\n\t\t\t\t\t.hk-navbar {\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t}\t\t\n\t\t\t\t}\n\t\t\t\t&.hk-drawer-pushright {\n\t\t\t\t\t.hk-navbar {\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\t\n}","\t@charset \"UTF-8\"; \n/*------------------------------------------------------------------\n[Master Stylesheet]\nProject:\tJampack\n++++ ChatApp ++++\n++++ Chat Popup ++++\n++++ Chatbot Popup ++++\n++++ Calendar ++++\n++++ Email UI ++++\n++++ Taskboard ++++\n++++ Checklist List ++++\n++++ Contact ++++\n++++ File Manager ++++\n++++ Gallery App ++++\n++++ Todo ++++\n++++ Blog App ++++\n++++ invoice ++++\n++++ Integrations ++++\n-------------------------------------------------------------------*/\n/*ChatApp*/\t\n.chatapp-wrap {\n\tposition:relative;\n\toverflow:hidden;\n\theight:calc(100vh - 65px);\n\t@include transition(height 0.2s ease);\n\t.chatapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\theight: 100%;\n\t\tposition:relative;\n\t\toverflow: hidden;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.chatapp-aside {\n\t\t\tborder-right: 1px solid $grey_light_4;\n\t\t\tbackground:$white;\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:1;\n\t\t\tleft:0;\n\t\t\tmargin-top:0;\n\t\t\twidth: 370px;\n\t\t\tflex-shrink: 0;\n\t\t\theader.aside-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tbackground:$white;\n\t\t\t\tcolor:$black_2;\n\t\t\t\t.chatapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\th1{\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.btn {\n\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.aside-body {\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\theight: 100%;\n\t\t\t\toverflow: auto;\n\t\t\t\tpadding:1.25rem;\n\t\t\t\t.aside-search {\n\t\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t}\n\t\t\t\t.frequent-contact {\n\t\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t\tul {\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t.avatar {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-contacts-list {\n\t\t\t\t\tmargin:0 -0.8rem;\n\t\t\t\t\t.list-group-item {\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\tborder:none;\n\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\tpadding: .75rem .8rem;\n\t\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t\t@include transition(.2s ease);\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t>div:first-child {\n\t\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\t\t.user-name,\n\t\t\t\t\t\t\t\t\t.user-last-chat,\n\t\t\t\t\t\t\t\t\t.user-status\n\t\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t>div:last-child {\n\t\t\t\t\t\t\t\t\ttext-align:right;\n\t\t\t\t\t\t\t\t\tpadding-left:1rem;\n\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\tflex-flow: column;\n\t\t\t\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\t\t\t\t\t-webkit-box-align: flex-end;\n\t\t\t\t\t\t\t\t\t-ms-flex-align: flex-end;\n\t\t\t\t\t\t\t\t\talign-items: flex-end;\n\t\t\t\t\t\t\t\t\twidth:4.5rem;\n\t\t\t\t\t\t\t\t\t.last-chat-time {\n\t\t\t\t\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.action-drp {\n\t\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t\t\tvisibility:hidden;\n\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\ttop: 15px;\n\t\t\t\t\t\t\t\t\t\t@include transition(all .2s ease-in-out);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t\t.media-body { \n\t\t\t\t\t\t\t\t\t>div:last-child {\n\t\t\t\t\t\t\t\t\t\t.action-drp {\n\t\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t\t\tvisibility:visible;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.last-chat-time,\n\t\t\t\t\t\t\t\t\t\t.badge-pill {\n\t\t\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t\t\t\tvisibility:hidden;\n\t\t\t\t\t\t\t\t\t\t\t@include transition(all .2s ease-in-out);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.read-chat {\n\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t>div:last-child { \n\t\t\t\t\t\t\t\t\t\t.last-chat-time {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.active-user {\n\t\t\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t>div:first-child {\n\t\t\t\t\t\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.title-wth-divider {\n\t\t\t\t\t\tpadding:0 .8rem;\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.channels-list {\n\t\t\t\t\t.nav-item .nav-link {\n\t\t\t\t\t\tpadding-left:0;\n\t\t\t\t\t\tpadding-right:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.chatapp-single-chat {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tbackground:$white;\n\t\t\tz-index:10;\n\t\t\theader.chat-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\t.back-user-list {\n\t\t\t\t\tdisplay:none;\n\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t}\n\t\t\t\t.media {\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.media-head {\n\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t}\n\t\t\t\t\t.media-body {\n\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.user-status {\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.user-name,.user-status {\n\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\tmax-width: 150px;\t\t\t\t\t\t\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t.chat-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left:.25rem;\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chat-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\theight: 100%;\n\t\t\t\toverflow: auto;\n\t\t\t\tul.list-unstyled {\n\t\t\t\t\twidth:90%;\n\t\t\t\t\tmargin:0 auto;\n\t\t\t\t\tpadding:2rem 1.25rem;\n\t\t\t\t}\n\t\t\t\t.media {\n\t\t\t\t\t.media-body {\n\t\t\t\t\t\tmargin-left: 0.75rem;\n\t\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tpadding: .625rem 1rem;\n\t\t\t\t\t\t\t\tborder-radius: 1.25rem;\n\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\t\tp:first-child {\n\t\t\t\t\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.chat-time {\n\t\t\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\t\t\ttext-transform:uppercase;\n\t\t\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t\t\t\t\t\topacity:.5;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t+ .msg-box {\n\t\t\t\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.msg-action {\n\t\t\t\t\t\t\t\tmargin-left:1rem;\n\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\tbackground: transparent!important;\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t.msg-action {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t\t&.msg-docs {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-ms-flex-wrap: wrap;\n\t\t\t\t\t\t\tflex-wrap:wrap;\n\t\t\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\tmax-width: 165px;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.file-size {\n\t\t\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.file-overlay {\n\t\t\t\t\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t\t@include background-opacity($black_2,.4);\n\t\t\t\t\t\t\t\t\t\tborder-radius:1.25rem;\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t.file-overlay {\n\t\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.msg-action {\n\t\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t+ .msg-box {\n\t\t\t\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.msg-imgs {\n\t\t\t\t\t\t\t.msg-box { \n\t\t\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\t\t\tborder-radius:1.25rem;\n\t\t\t\t\t\t\t\t\t\tmax-width: 336px;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:first-child,\n\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\tborder-radius:1.25rem!important;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.received {\n\t\t\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\tbackground:#f2f2f2;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\tborder-top-left-radius:0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t}\n\t\t\t\t\t&.sent {\n\t\t\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t\t\t\t-ms-flex-pack: flex-end;\n\t\t\t\t\t\t\t-ms-flex-direction: column;\n\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\t-webkit-box-align: flex-end;\n\t\t\t\t\t\t\t-ms-flex-align: flex-end;\n\t\t\t\t\t\t\talign-items: flex-end;\t\t\t\t\t\t\n\t\t\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t\t\t-ms-flex-direction: row-reverse;\n\t\t\t\t\t\t\t\tflex-direction: row-reverse;\n\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\tbackground:$primary;\n\t\t\t\t\t\t\t\t\tp {\n\t\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.chat-time {\n\t\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\tborder-top-right-radius:0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.msg-action {\n\t\t\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t}\n\t\t\t\t\t&.media-attachment {\n\t\t\t\t\t\tmargin-bottom:1.125rem;\n\t\t\t\t\t\t.media-body > .msg-box{\n\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.day-sep {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\toverflow:hidden;\n\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\tmargin:1.875rem 0;\n\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground: $grey_light_4;\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\theight: 1px;\n\t\t\t\t\t\tright: 50%;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tbackground: $grey_light_4;\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\theight: 1px;\n\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\tspan {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tbackground:$white;\n\t\t\t\t\t\tz-index: 1;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tpadding: 0 .625rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.start-conversation {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\theight:calc(100vh - 195px);\n\t\t\t\t\tflex-flow: column;\n\t\t\t\t}\n\t\t\t}\n\t\t\tfooter.chat-footer {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tpadding: 0.75rem 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-top:1px solid $grey_light_4;\n\t\t\t\tmargin-top:-1px;\n\t\t\t\tposition:relative;\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t.feather-icon, .svg-icon {\n\t\t\t\t\tdisplay:block;\n\t\t\t\t}\n\t\t\t\t.input-group {\n\t\t\t\t\twidth:100%;\n\t\t\t\t\t.form-control {\n\t\t\t\t\t\tmargin:0 0.75rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chat-info {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 65px;\n\t\t\t\tright: -370px;\n\t\t\t\twidth: 370px;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tz-index:100;\n\t\t\t\tborder: none;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-left: 1px solid $grey_light_4;\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t}\n\t\t\t\t.cp-name {\n\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\tfont-weight:500;\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t}\n\t\t\t\t.cp-info {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tli {\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t.cp-icon-wrap {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tmargin-right:.5rem;\n\t\t\t\t\t\t\t\t.feather-icon, .svg-icon {\n\t\t\t\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.cp-action {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tli {\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.cp-files {\n\t\t\t\t\tmargin: 0 -.8rem;\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tli {\n\t\t\t\t\t\tpadding: .8rem;\n\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t@include transition(0.2s ease);\n\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t.avatar.avatar-sm {\n\t\t\t\t\t\t\t\t\t.avatar-icon {\n\t\t\t\t\t\t\t\t\t\tfont-size: 1.75rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t\t\t-ms-flex: 1;\n\t\t\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.file-size {\n\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\ta.cp-file-action {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.chatapp-info-active {\n\t\t.chatapp-single-chat {\n\t\t\t.chat-body {\n\t\t\t\tmargin-right:370px;\n\t\t\t}\n\t\t\t.chat-info {\n\t\t\t\tright:0;\n\t\t\t}\n\t\t\tfooter.chat-footer {\n\t\t\t\tmargin-right:370px;\n\t\t\t}\n\t\t}\n\t}\n\t.chatapp-call-window {\n\t\t.modal-content {\n\t\t\tmin-height: calc(100vh - 100px);\n\t\t\t.modal-header {\n\t\t\t\tPadding: 0.3rem 1.25rem;\n\t\t\t\t.modal-title {\n\t\t\t\t\ttext-align:center;\n\t\t\t\t\twidth:100%;\n\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t}\n\t\t\t\t>.modal-action {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay:flex;\n\t\t\t\t\tright: 1.25rem;\n\t\t\t\t\tposition:absolute;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.modal-body {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tflex-flow: column;\n\t\t\t\tjustify-content: center;\n\t\t\t\tpadding:3.125rem;\n\t\t\t}\n\t\t\t.modal-footer {\n\t\t\t\tborder-top:0;\n\t\t\t\tmin-height: 160px;\n\t\t\t\tjustify-content: center;\n\t\t\t\t.chatapp-caller-img {\t\n\t\t\t\t\tright:30px;\n\t\t\t\t\tbottom:30px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.fullscreen {\n\t\t\t\tposition: fixed;\n\t\t\t\ttop: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tleft: 0;\n\t\t\t\toverflow-y: auto;\n\t\t\t\tborder-radius:0;\n\t\t\t\t.modal-header {\n\t\t\t\t\tborder-radius:0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.invite-user-list {\n\t\tpadding:0 1rem;\n\t\t>li {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\tmargin-bottom:.625rem;\n\t\t\t.user-name {\n\t\t\t\tcolor:$black_2;\n\t\t\t\tfont-weight:500;\n\t\t\t}\n\t\t}\n\t}\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.chatapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n.one {\n    opacity: 0;\n    -webkit-animation: dot 1.3s infinite;\n    -webkit-animation-delay: 0.0s;\n    animation: dot 1.3s infinite;\n    animation-delay: 0.0s;\n}\n.two {\n    opacity: 0;\n    -webkit-animation: dot 1.3s infinite;\n    -webkit-animation-delay: 0.2s;\n      animation: dot 1.3s infinite;\n      animation-delay: 0.2s;\n}\n.three {\n    opacity: 0;\n    -webkit-animation: dot 1.3s infinite;\n    -webkit-animation-delay: 0.3s;\n     animation: dot 1.3s infinite;\n     animation-delay: 0.3s;\n}\n@-webkit-keyframes dot {\n      0% { opacity: 0; }\n     50% { opacity: 0; }\n    100% { opacity: 1; }\n}\n@keyframes dot {\n      0% { opacity: 0; }\n     50% { opacity: 0; }\n    100% { opacity: 1; }\n}\n@media (max-width: 1599px) {\n\t.chatapp-wrap {\n\t\t.chatapp-content {\n\t\t\t.chatapp-single-chat {\n\t\t\t\t.chat-info {\n\t\t\t\t\tright: -320px;\n\t\t\t\t\twidth: 320px;\n\t\t\t\t}\n\t\t\t\t.chat-body {\n\t\t\t\t\tul.list-unstyled {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chatapp-aside {\n\t\t\t\twidth:320px;\n\t\t\t}\n\t\t}\n\t\t&.chatapp-info-active {\n\t\t\t.chatapp-single-chat {\n\t\t\t\t.chat-info {\n\t\t\t\t\tright: 0;\n\t\t\t\t}\n\t\t\t\t.chat-body {\n\t\t\t\t\tmargin-right: 20rem;\n\t\t\t\t}\n\t\t\t\tfooter.chat-footer {\n\t\t\t\t\tmargin-right:20rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\tul.hk-list {\n\t\tmargin: 0 -.28rem;\n\t\tli {\n\t\t\tpadding: .68rem .28rem;\n\t\t}\n\t}\n}\n@media (min-width: 1200px) {\n\tbutton.btn-close.info-close {\n\t\tdisplay:none;\n\t}\n}\n@media (max-width: 1199px) {\n\t.chatapp-wrap {\n\t\t.chatapp-content .chatapp-single-chat {\n\t\t\t.chat-info {\n\t\t\t\ttop:0;\n\t\t\t\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\t\t\t}\n\t\t\t.chat-body {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t\t\n\t\t&.chatapp-info-active {\n\t\t\t.chatapp-content .chatapp-single-chat {\n\t\t\t\t .chat-body {\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\n\t\t\t\tfooter {\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t/*Common for all App*/\n\tbutton.btn-close.info-close {\n\t\ttop: 20px;\n\t\tposition: absolute;\n\t\tright: 20px;\n\t\tz-index: 1;\n\t}\n}\n@media (min-width: 992px) {\n\t.chatapp-wrap {\n\t\t.chatapp-content .chatapp-aside{ \n\t\t\t.hk-sidebar-togglable {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 991px) {\n\t.chatapp-wrap {\n\t\t.chatapp-content {\n\t\t\t.chatapp-aside {\n\t\t\t\twidth:100%;\n\t\t\t}\n\t\t\t.chatapp-single-chat {\n\t\t\t\tright:-100%;\n\t\t\t\tposition:fixed;\n\t\t\t\ttop:0;\n\t\t\t\twidth: 100%;\n\t\t\t\theader.chat-header {\n\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t-webkit-justify-content: flex-start;\n\t\t\t\t\t-ms-flex-pack: flex-start;\n\t\t\t\t\t.back-user-list {\n\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\tflex-shrink:0;\n\t\t\t\t\t}\n\t\t\t\t\t.chat-options-wrap {\n\t\t\t\t\t\tmargin-left:auto;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-body ul.list-unstyled {\n\t\t\t\t\twidth:100%;\n\t\t\t\t}\n\t\t\t\t.chat-info {\n\t\t\t\t\t.avatar.avatar-xxl {\n\t\t\t\t\t\twidth: 6rem;\n\t\t\t\t\t\theight: 6rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.chatapp-slide {\n\t\t\t.chatapp-content {\n\t\t\t\t.chatapp-aside {\n\t\t\t\t\tleft:-100%;\n\t\t\t\t}\n\t\t\t\t.chatapp-single-chat {\n\t\t\t\t\tright:0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.chatapp-call-window {\n\t\t\t.modal-content {\n\t\t\t\t.modal-footer {\n\t\t\t\t\t.chatapp-caller-img {\n\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n\t.chatapp-wrap {\n\t\t.chatapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t\t.chatapp-aside {\n\t\t\t\t.aside-body {\n\t\t\t\t\t.frequent-contact {\n\t\t\t\t\t\tul {\n\t\t\t\t\t\t\t-ms-flex-wrap: nowrap;\n\t\t\t\t\t\t\tflex-wrap:nowrap;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chatapp-single-chat {\n\t\t\t\theader.chat-header {\n\t\t\t\t\t.media .media-head {\n\t\t\t\t\t\t.avatar.avatar-sm {\n\t\t\t\t\t\t\twidth: 2.5rem;\n\t\t\t\t\t\t\theight: 2.5rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-body {\n\t\t\t\t\t.media .media-body.msg-docs .msg-box > div .media {\n\t\t\t\t\t\t.avatar.avatar-xs {\n\t\t\t\t\t\t\twidth: 1.5rem;\n\t\t\t\t\t\t\theight: 1.5rem;\n\t\t\t\t\t\t\tflex-shrink:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t max-width: calc(100vw - 300px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n/*Chat Popup*/\n@keyframes mercuryTypingAnimation {\n\t0% {\n\t\ttransform: translateY(0px);\n\t\tbackground-color:$primary_light_3;\n\t}\n\t28% {\n\t\ttransform: translateY(-7px);\n\t\tbackground-color:$primary_light_2;\n\t}\n\t44% {\n\t\ttransform: translateY(0px);\n\t\tbackground-color: $primary_light_1;\n\t}\n}\n.typing {\n\talign-items: center;\n\tdisplay: flex;\n\theight: 17px;\n\t.dot {\n\t\tanimation: mercuryTypingAnimation 1.8s infinite ease-in-out;\n\t\tbackground-color: $primary_light_3;\n\t\theight: 5px;\n\t\tborder-radius:50%;\n\t\tmargin-right: .25rem;\n\t\tvertical-align: middle;\n\t\twidth: 5px;\n\t\tdisplay: inline-block;\n\t\t&:nth-child(1) {\n\t\t\tanimation-delay: 200ms;\n\t\t}\n\t\t&:nth-child(2) {\n\t\t\tanimation-delay: 300ms;\n\t\t}\n\t\t&:nth-child(3) {\n\t\t\tanimation-delay: 400ms;\n\t\t}\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n}\n.hk-chat-popup {\n\tposition:fixed;\n\ttop:0;\n\tbottom:0;\n\tright:0;\n\tdisplay:none;\n\twidth:380px;\n\tbox-shadow:0 8px 10px rgba(0,0,0,0.1);\n\tz-index:10000;\n\tbackground:$white;\n\tflex-flow: column;\n\theader {\n\t\tbackground:$black_2;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t\tflex-shrink: 0;\n\t\tPadding: 0.5rem 1.25rem;\n\t\theight:64px;\n\t\t.media-wrap {\n\t\t\t.media {\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\t.media-head {\n\t\t\t\t\tposition:relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t}\n\t\t\t\t.media-body {\n\t\t\t\t\t.user-name {\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t}\n\t\t\t\t\t.user-status {\n\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.input-group {\n\t\t\t.contact-search {\n\t\t\t\tpadding:0;\n\t\t\t\tcolor:$white;\n\t\t\t\tborder: none;\n\t\t\t\tbackground: transparent;\n\t\t\t}\n\t\t}\n\t}\n\t.chat-popup-body {\n\t\toverflow: auto;\n\t\tflex: 1 1 auto;\n\t\t.contact-list-wrap {\n\t\t\tpadding:0 1.25rem 1.25rem;\n\t\t\t.chat-contacts-list {\n\t\t\t\tmargin:0 -0.8rem;\n\t\t\t\t.list-group-item {\n\t\t\t\t\tpadding:0;\n\t\t\t\t\tborder:none;\n\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t}\n\t\t\t\t\t.media {\n\t\t\t\t\t\tpadding: .75rem .8rem;\n\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t@include transition(.2s ease);\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t>div:first-child {\n\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\t.user-name,\n\t\t\t\t\t\t\t\t.user-last-chat,\n\t\t\t\t\t\t\t\t.user-status\n\t\t\t\t\t\t\t\t{\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t>div:last-child {\n\t\t\t\t\t\t\t\ttext-align:right;\n\t\t\t\t\t\t\t\tpadding-left:1rem;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tflex-flow: column;\n\t\t\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\t\t\t\t-webkit-box-align: flex-end;\n\t\t\t\t\t\t\t\t-ms-flex-align: flex-end;\n\t\t\t\t\t\t\t\talign-items: flex-end;\n\t\t\t\t\t\t\t\twidth:4.5rem;\n\t\t\t\t\t\t\t\t.last-chat-time {\n\t\t\t\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.action-drp {\n\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t\tvisibility:hidden;\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\ttop: 15px;\n\t\t\t\t\t\t\t\t\t@include transition(all .2s ease-in-out);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t.media-body { \n\t\t\t\t\t\t\t\t>div:last-child {\n\t\t\t\t\t\t\t\t\t.action-drp {\n\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t\tvisibility:visible;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.last-chat-time,\n\t\t\t\t\t\t\t\t\t.badge-pill {\n\t\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t\t\tvisibility:hidden;\n\t\t\t\t\t\t\t\t\t\t@include transition(all .2s ease-in-out);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.read-chat {\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t>div:last-child { \n\t\t\t\t\t\t\t\t\t.last-chat-time {\n\t\t\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.active-user {\n\t\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t>div:first-child {\n\t\t\t\t\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.title-wth-divider {\n\t\t\t\t\tpadding:0 .8rem;\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tul.list-unstyled {\n\t\t\twidth:95%;\n\t\t\tmargin:0 auto;\n\t\t\tpadding:1.25rem 0;\n\t\t}\n\t\t.media {\n\t\t\t.media-body {\n\t\t\t\tmargin-left: 0.75rem;\n\t\t\t\t.msg-box {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t>div {\n\t\t\t\t\t\tpadding: .625rem 1rem;\n\t\t\t\t\t\tborder-radius: 1.25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\tp:first-child {\n\t\t\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.chat-time {\n\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\ttext-transform:uppercase;\n\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t\t\t\topacity:.5;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.file-overlay {\n\t\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t@include background-opacity($black_2,.4);\n\t\t\t\t\t\t\tborder-radius:1.25rem;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t.file-overlay {\n\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t+ .msg-box {\n\t\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t\t}\n\t\t\t\t\t.msg-action {\n\t\t\t\t\t\tmargin-left:1rem;\n\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tbackground: transparent!important;\n\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t\tright:0;\n\t\t\t\t\t\tz-index:1;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t.msg-action {\n\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t&.msg-docs {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-ms-flex-wrap: wrap;\n\t\t\t\t\tflex-wrap:wrap;\n\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t.avatar.avatar-sm .avatar-icon {\n\t\t\t\t\t\t\t\t\tfont-size: 1.75rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\tmax-width: 165px;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.file-size {\n\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t+ .msg-box {\n\t\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.msg-imgs {\n\t\t\t\t\t.msg-box { \n\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\tborder-radius:1.25rem;\n\t\t\t\t\t\t\t\theight:150px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child,\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tborder-radius:1.25rem!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.received {\n\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t.media-body {\n\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tbackground:#f2f2f2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tborder-top-left-radius:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.sent {\n\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t.media-body {\n\t\t\t\t\tmargin-left:0;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t\t-ms-flex-pack: flex-end;\n\t\t\t\t\t-ms-flex-direction: column;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t-webkit-box-align: flex-end;\n\t\t\t\t\t-ms-flex-align: flex-end;\n\t\t\t\t\talign-items: flex-end;\t\t\t\t\t\t\n\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t-ms-flex-direction: row-reverse;\n\t\t\t\t\t\tflex-direction: row-reverse;\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tbackground:$primary;\n\t\t\t\t\t\t\tp {\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.chat-time {\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tborder-top-right-radius:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.media-attachment {\n\t\t\t\tmargin-bottom:17px;\n\t\t\t\t.media-body > .msg-box{\n\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.typing-wrap {\n\t\t\t\t.media-body {\n\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.day-sep {\n\t\t\tposition: relative;\n\t\t\ttext-align: center;\n\t\t\toverflow:hidden;\n\t\t\tfont-size:0.875rem;\n\t\t\tmargin:1.875rem 0;\n\t\t\ttext-transform: capitalize;\n\t\t\t&:before {\n\t\t\t\tbackground: $grey_light_4;\n\t\t\t\tcontent: \"\";\n\t\t\t\theight: 1px;\n\t\t\t\tright: 50%;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tbackground: $grey_light_4;\n\t\t\t\tcontent: \"\";\n\t\t\t\theight: 1px;\n\t\t\t\tleft: 50%;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tbackground:$white;\n\t\t\t\tz-index: 1;\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: 0 .625rem;\n\t\t\t}\n\t\t}\n\t}\n\tfooter {\n\t\tbackground:$white;\n\t\tborder-top:1px solid $grey_light_4;\n\t\tmargin-top:-1px;\n\t\tposition:relative;\n\t\t@include transition(all 0.2s ease);\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t\t.feather-icon, .svg-icon {\n\t\t\tdisplay:block;\n\t\t}\n\t\t.form-control {\n\t\t\theight:57px;\n\t\t}\n\t}\n}\n.btn-popup-open,\n.btn-popup-close {\n\tposition: fixed;\n\tright: 20px;\n\tbottom: 20px;\n\tz-index: 111;\n}\n.chat-popover {\n\tposition: fixed;\n    right: 20px;\n    bottom: 100px;\n    background: $white;\n    width: 270px;\n    border-radius:0.5rem;\n\tbox-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);\n\tpadding:1rem;\n\tdisplay:none;\n\tz-index:99;\n\tp {\n\t\tfont-size:0.875rem;\n\t}\n}\n@media (max-width: 800px) {\n\t.hk-chat-popup {\n\t\twidth:100%;\n\t}\n}\n/*Chatbot Popup*/\n.hk-chatbot-popup {\n\tposition:fixed;\n\tbottom:100px;\n\tright:30px;\n\tdisplay:none;\n\twidth:380px;\n\tborder-radius:0.5rem;\n\toverflow:hidden;\n\tbox-shadow:0 8px 10px rgba(0,0,0,0.1);\n\tz-index:10000;\n\tbackground:$white;\n\theader {\n\t\tbackground:$black_2;\n\t\tPadding: 0.5rem 1.25rem 5.5rem;\n\t\t.chatbot-head-top {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t}\n\t\t.media-wrap {\n\t\t\t.media {\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\t.media-head {\n\t\t\t\t\tposition:relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t}\n\t\t\t\t.media-body {\n\t\t\t\t\t.user-name,\n\t\t\t\t\t.user-status {\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t}\n\t\t\t\t\t.user-status { \n\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chatbot-popup-body {\n\t\theight: calc(100vh - 440px);\n\t\tposition: relative;\n\t\t.nicescroll-bar {\n\t\t\tmargin-top: -5.25rem;\n\t\t}\n\t\t.init-content-wrap {\n\t\t\tpadding:1.25rem 1.25rem 1.25rem;\n\t\t\t.btn-wrap {\n\t\t\t\ttext-align:right;\n\t\t\t\t.btn {\n\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tul.list-unstyled {\n\t\t\twidth:95%;\n\t\t\tmargin:0 auto;\n\t\t\tpadding:1.25rem 0;\n\t\t}\n\t\t.media {\n\t\t\t.media-body {\n\t\t\t\tmargin-left: 0.75rem;\n\t\t\t\t.msg-box {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t>div {\n\t\t\t\t\t\tpadding: .625rem 1rem;\n\t\t\t\t\t\tborder-radius: 1.25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\tp:first-child {\n\t\t\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t+ .msg-box {\n\t\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.received {\n\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t.media-body {\n\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tbackground:#f2f2f2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tborder-top-left-radius:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.sent {\n\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t.media-body {\n\t\t\t\t\tmargin-left:0;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t\t-ms-flex-pack: flex-end;\n\t\t\t\t\t-ms-flex-direction: column;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t-webkit-box-align: flex-end;\n\t\t\t\t\t-ms-flex-align: flex-end;\n\t\t\t\t\talign-items: flex-end;\t\t\t\t\t\t\n\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t-ms-flex-direction: row-reverse;\n\t\t\t\t\t\tflex-direction: row-reverse;\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tbackground:$primary;\n\t\t\t\t\t\t\tp {\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.chat-time {\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tborder-top-right-radius:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&.typing-wrap {\n\t\t\t\t.media-body {\n\t\t\t\t\t.msg-box {\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.day-sep {\n\t\t\tposition: relative;\n\t\t\ttext-align: center;\n\t\t\toverflow:hidden;\n\t\t\tfont-size:0.875rem;\n\t\t\tmargin:1.875rem 0;\n\t\t\ttext-transform: capitalize;\n\t\t\t&:before {\n\t\t\t\tbackground: $grey_light_4;\n\t\t\t\tcontent: \"\";\n\t\t\t\theight: 1px;\n\t\t\t\tright: 50%;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tbackground: $grey_light_4;\n\t\t\t\tcontent: \"\";\n\t\t\t\theight: 1px;\n\t\t\t\tleft: 50%;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tbackground:$white;\n\t\t\t\tz-index: 1;\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: 0 .625rem;\n\t\t\t}\n\t\t}\n\t}\n\tfooter {\n\t\tbackground:$white;\n\t\t.input-group {\n\t\t\tborder-top:1px solid $grey_light_4;\n\t\t\t.form-control {\n\t\t\t\theight:57px;\n\t\t\t}\n\t\t}\n\t\t.chatbot-intro-text {\n\t\t\ttext-align:center;\n\t\t\tpadding:.5rem 1.25rem;\n\t\t}\n\t\t.footer-copy-text {\n\t\t\tbackground:$grey_light_5;\n\t\t\tpadding:.5rem 1.25rem;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\ttext-align:center;\n\t\t\tfont-size:0.75rem;\n\t\t\t\n\t\t\t.brand-link img {\n\t\t\t\twidth: 75px;\n\t\t\t\tmargin-left: .25rem;\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n\t.hk-chatbot-popup {\n\t\twidth:100%;\n\t\tflex-flow: column;\n\t\tborder-radius: 0;\n\t\tbottom: 0;\n    \tright: 0;\n    \ttop: 0;\n\t\theader {\n\t\t\tPadding: 0.5rem 1.25rem 1rem;\n\t\t}\n\t\t.chatbot-popup-body {\n\t\t\toverflow: auto;\n\t\t\tflex: 1 1 auto;\n\t\t\theight: auto;\n\t\t\t.nicescroll-bar {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\t\tfooter .chatbot-intro-text {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/*Calendar*/\n.calendarapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t@include transition(height 0.2s ease);\n\t.calendarapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t> .nav-link {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.daterangepicker {\n\t\t\t\tposition:static;\n\t\t\t\tdisplay:block!important;\n\t\t\t\tmargin: 0;\n\t\t\t\tborder: none;\n\t\t\t\toverflow: hidden;\n\t\t\t\twidth:auto;\n\t\t\t\t.drp-calendar {\n\t\t\t\t\tpadding:0;\n\t\t\t\t\t.calendar-table {\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\tth,td {\n\t\t\t\t\t\t\tmin-width: 30px;\n\t\t\t\t\t\t\twidth: 30px;\n\t\t\t\t\t\t\theight: 30px;\n\t\t\t\t\t\t\tz-index: 1;\n\t\t\t\t\t\t\t&.active,&:hover {\n\t\t\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\ttd {\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\t\tz-index:-1;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.active,&:hover {\n\t\t\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tbackground: $primary_light_4;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.upcoming-event-wrap {\n\t\t\t\t.nav {\n\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t.event-time {\n\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.event-name {\n\t\t\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t\t.categories-wrap {\n\t\t\t\t.form-check {\n\t\t\t\t\tpadding-top: .5rem;\n\t\t\t\t\tpadding-bottom: .5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.calendarapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.calendarapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 270px;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.fc {\n\t\t\t.fc-toolbar {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tmargin-bottom:0;\n\t\t\t\tbackground:$white;\n\t\t\t\tposition:relative;\n\t\t\t\t.fc-toolbar-chunk {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tflex: 1;\n\t\t\t\t\t&:nth-child(1) {\n\t\t\t\t\t\t.btn-group {\n\t\t\t\t\t\t\torder: 2;\n\t\t\t\t\t\t\tfloat: none;\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t.fc-prev-button,\n\t\t\t\t\t\t\t.fc-next-button {\n\t\t\t\t\t\t\t\tborder:none;\n\t\t\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.fc-today-button {\n\t\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t\tmargin-left:0!important;\n\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:nth-child(2) {\n\t\t\t\t\t\th2 {\n\t\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t}\n\t\t\t\t\t&:nth-child(3) {\n\t\t\t\t\t\t.btn-primary {\n\t\t\t\t\t\t\t@extend .btn-outline-light;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t>*>:not(:first-child) {\n\t\t\t\t\tmargin-left: 0.25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.fc-col-header {\n\t\t\t\ttd,th {\n\t\t\t\t\tborder: 1px solid $grey_light_4;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.fc-col-header-cell-cushion  {\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t\tfont-weight: 600;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tpadding: .25rem 0;\n\t\t\t\tcolor:$black_2;\n\t\t\t}\n\t\t\t.fc-timegrid-axis-cushion,\n\t\t\t.fc-timegrid-slot-label-cushion {\n\t\t\t\tfont-size:0.875rem;\n\t\t\t}\n\t\t\t.fc-daygrid-body {\n\t\t\t\twidth:100%!important;\n\t\t\t\theight:100%!important;\n\t\t\t\t.fc-scrollgrid-sync-table {\n\t\t\t\t\twidth:100%!important;\n\t\t\t\t\theight:100%!important;\n\t\t\t\t\t td,th {\n\t\t\t\t\t\tborder: 1px solid $grey_light_4;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.fc-daygrid-day-top {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t\t.fc-daygrid-day-number {\n\t\t\t\tpadding: .625rem;\n\t\t\t}\n\t\t\t.fc-daygrid-day.fc-day-today {\n\t\t\t\tbackground:transparent;\n\t\t\t\t.fc-daygrid-day-top {\n\t\t\t\t\tpadding:.25rem;\n\t\t\t\t\t.fc-daygrid-day-number {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\theight: 35px;\n\t\t\t\t\t\twidth: 35px;\n\t\t\t\t\t\tbackground: $primary;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.fc-list-event-dot {\n\t\t\t\tborder-color:$primary;\n\t\t\t}\n\t\t\t.fc-timegrid-slot {\n\t\t\t\tborder-left:0;\n\t\t\t}\n\t\t\t.fc-timegrid-divider {\n\t\t\t\tborder:0;\n\t\t\t}\n\t\t\t.fc-v-event {\n\t\t\t\tbackground-color:$primary; \n\t\t\t}\n\t\t\t.fc-timegrid-divider {\n\t\t\t\tpadding:0;\n\t\t\t}\n\t\t\t.table-bordered { \n\t\t\t\tborder: 1px solid $grey_light_4;\n\t\t\t\tborder-left:0;\n\t\t\t}\n\t\t\t.fc-view-harness .fc-daygrid {\n\t\t\t\tbackground:$white;\n\t\t\t\t.table-bordered { \n\t\t\t\t\t.fc-day-other {\n\t\t\t\t\t\tbackground-color: $grey_light_5;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.fc-daygrid-event {\n\t\t\t\tpadding: .125rem .375rem;\n\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t&.has-avatar {\n\t\t\t\t\tpadding: .375rem .625rem;\n\t\t\t\t\t.avatar {\n\t\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t\tflex-shrink:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.fc-event-main {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\ti{\n\t\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t\t}\n\t\t\t\t\tspan {\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t}\n\t\t\t\t\t.fc-event-main-frame {\n\t\t\t\t\t\toverflow:hidden;\n\t\t\t\t\t\t.fc-event-title {\n\t\t\t\t\t\t\t text-overflow: ellipsis;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.fc-daygrid-event-dot {\n\t\t\tborder-color: $primary;\n\t\t}\n\t}\n\t&.calendarapp-sidebar-toggle {\n\t\t.calendarapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.calendarapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n}\n.hk-wrapper {\n\t&[data-navbar-style=\"collapsed\"] {\n\t\t.calendarapp-wrap {\n\t\t\theight: 100vh;\n\t\t}\n\t}\t\n\t.calendar-drawer {\n\t\t>div {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\theight:100%;\n\t\t\tflex-flow: column;\n\t\t}\n\t\t.event-head {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t.event-name {\n\t\t\t\tfont-size: 1.25rem;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: $black_2;\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t\t.badge-indicator {\n\t\t\t\tposition: relative;\n\t\t\t\ttop: 7px;\n\t\t\t}\n\t\t}\n\t\t.event-detail {\n\t\t\tpadding-left: 0;\n\t\t\tli {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t.ev-icon-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ttop: 1px;\n\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t.feather-icon, .svg-icon {\n\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tmargin-bottom:1.125rem;\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t.calendarapp-wrap {\n\t\t.calendarapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.calendarapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t\t.fc-toolbar-chunk:nth-child(3) > .btn-group {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t&.calendarapp-sidebar-toggle {\n\t\t\t.calendarapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.calendarapp-content {\n\t\t\t\tleft:270px;\n\t\t\t\tpadding-left: 270px;\n\t\t\t\tmargin-left: -270px;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Email UI*/\n.emailapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t@include transition(height 0.2s ease);\n\t.emailapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link {\n\t\t\t\t\tborder-radius: .375rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.emailapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.emailapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 270px;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.emailapp-aside {\n\t\t\tborder-right: 1px solid $grey_light_4;\n\t\t\tbackground:$white;\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:1;\n\t\t\tleft:0;\n\t\t\twidth:370px;\n\t\t\tflex-shrink: 0;\n\t\t\tmargin-top:0;\n\t\t\theader.aside-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tbackground:$white;\n\t\t\t\tcolor:$black_2;\n\t\t\t\t.emailapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\th1{\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.btn {\n\t\t\t\t\tmargin-right:.5rem;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.aside-search {\n\t\t\t\tmargin-bottom: 1.25rem;\n\t\t\t}\n\t\t\t.aside-body {\n\t\t\t\toverflow:auto;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\theight: 100%;\n\t\t\t\tpadding: 1.25rem;\n\t\t\t\t.email-list {\n\t\t\t\t\tmargin:0 -0.8rem;\n\t\t\t\t\t.list-group-item {\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\tborder:none;\n\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\tpadding: .75rem .8rem;\n\t\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t\t@include transition(.2s ease);\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tflex-flow:column;\n\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t.badge-indicator {\n\t\t\t\t\t\t\t\t\tmargin-top:.875rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\t\t>div:first-child {\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t\t\t\t\tdiv:last-child {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\tmargin-left:auto;\n\t\t\t\t\t\t\t\t\t\t\t.email-star {\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t\t\t\t\tcolor: $grey_dark_3;\n\t\t\t\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t.email-time {\n\t\t\t\t\t\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.email-head,\n\t\t\t\t\t\t\t\t\t.email-subject {\n\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.email-subject {\n\t\t\t\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.email-head {\n\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\tmargin-right:.5rem;\n\t\t\t\t\t\t\t\t\t\tmax-width: 150px;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.email-text {\n\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover,&:focus {\n\t\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\t>div:first-child {\n\t\t\t\t\t\t\t\t\t\t\tdiv:last-child {\n\t\t\t\t\t\t\t\t\t\t\t\t.email-star {\n\t\t\t\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.read-email {\n\t\t\t\t\t\t\t\t&.active-user {\n\t\t\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.hk-section-head-border {\n\t\t\t\t\t\tpadding:0 .8rem;\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.emailapp-single-email {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\theader.email-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tposition:relative;\n\t\t\t\t.feather-icon, .svg-icon {\n\t\t\t\t\tdisplay:block;\n\t\t\t\t}\n\t\t\t\t.back-user-list {\n\t\t\t\t\tdisplay:none;\n\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t}\n\t\t\t\t.media {\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.media-head {\n\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t}\n\t\t\t\t\t.media-body {\n\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.user-status {\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t.email-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.email-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t}\n\t\t\t\t.single-email-subject {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\tmargin-bottom: 1.25rem;\n\t\t\t\t\t>div {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\th4 {\n\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.single-email-thread {\n\t\t\t\t\t.accordion-item {\n\t\t\t\t\t\toverflow:auto;\n\t\t\t\t\t\t.accordion-header {\n\t\t\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\twidth:100%;\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\t.email-head {\n\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t>div{\n\t\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t} \n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.email-head-action {\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t.email-time {\n\t\t\t\t\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\t\t\t\t\tmargin-right:1.25rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.email-star {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\t\t\t\tz-index: 1;\n\t\t\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t\t\tborder-top-left-radius: calc(0.5rem - 1px);\n    \t\t\t\t\t\t\t\t\tborder-top-right-radius: calc(0.5rem - 1px);\n\t\t\t\t\t\t\t\t\t\t~ .media {\n\t\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t\t>div{\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t} \n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t&[aria-expanded=\"true\"] {\n\t\t\t\t\t\t\t\t\t\t\t~ .email-head-action {\n\t\t\t\t\t\t\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\t\t\t\t~ .media {\n\t\t\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t\t\t>div{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t} \n\t\t\t\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&[data-bs-toggle=\"collapse\"] {\n\t\t\t\t\t\t\t\t\t&[aria-expanded=\"true\"] {\n\t\t\t\t\t\t\t\t\t\t.email-head { \n\t\t\t\t\t\t\t\t\t\t\t.email-head-action {\n\t\t\t\t\t\t\t\t\t\t\t\t>a {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.email-attachment-wrap {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-ms-flex-wrap: wrap;\n\t\t\t\t\t\t\tflex-wrap:wrap;\n\t\t\t\t\t\t\t.attachment-box {\n\t\t\t\t\t\t\t\tmargin-bottom: .5rem;\n\t\t\t\t\t\t\t\tmargin-right: .25rem;\n\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t\tpadding: .625rem 1rem;\n\t\t\t\t\t\t\t\t\tborder-radius: 1.25rem;\n\t\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\t\tbackground: #f2f2f2;\n\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t.avatar.avatar-sm .avatar-icon {\n\t\t\t\t\t\t\t\t\t\t\tfont-size: 1.75rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\tmargin-left: 1.25rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.file-size {\n\t\t\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.file-overlay {\n\t\t\t\t\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t\t@include background-opacity($black_2,.4);\n\t\t\t\t\t\t\t\t\t\tborder-radius:1.25rem;\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t.file-overlay {\n\t\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.msg-action {\n\t\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.mail-desc-dropdown {\n\t\t\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t\t\t\t>.dropdown-toggle {\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\tz-index: 1;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dropdown-menu {\n\t\t\t\t\t\t\t\tpadding: 1rem;\n\t\t\t\t\t\t\t\tfont-size: .875rem;\n\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t>span {\n\t\t\t\t\t\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\tmin-width: 50px;\n\t\t\t\t\t\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t\t\t\t\t\t\tmargin-right: .5rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.emailapp-sidebar-toggle {\n\t\t.emailapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.emailapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n\t.compose-email-popup {\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\tright: 20px;\n\t\twidth: 700px;\n\t\toverflow-y: auto;\n\t\tbox-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);\n\t\tz-index: 10000;\n\t\tbackground: $white;\n\t\tdisplay: none;\n\t\tborder-radius: 0.5rem 0.5rem 0 0;\n\t\theader {\n\t\t\tPadding: 0.75rem 1.25rem;\n\t\t\tbackground:$black_2;\n\t\t\tcolor:$white;\n\t\t\t#max_compose_popup .icon > span {\n\t\t\t\t&:last-child {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\t\n\t\t\t.btn-close {\n\t\t\t\tcolor: $white;\n\t\t\t\topacity: .6;\n\t\t\t\t&:not(:disabled):not(.disabled):focus, \n\t\t\t\t&:not(:disabled):not(.disabled):hover {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tform {\n\t\t\tpadding:1rem;\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t\ttextarea {\n\t\t\t\theight: 230px;\n\t\t\t}\n\t\t}\n\t\t&.minimize-email-popup {\n\t\t\twidth:300px;\n\t\t\tmin-height: auto;\n\t\t\tform,.compose-email-footer {\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t\t&.maximize-email-popup {\n\t\t\twidth: calc(100vw - 700px);\n\t\t\theight: calc(100vh - 200px);\n\t\t    bottom: 0;\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t\ttop: 0;\n\t\t\tmargin: auto;\n\t\t\theader {\n\t\t\t\t#max_compose_popup .icon > span {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tdisplay: inline;\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t\tform {\n\t\t\t\ttextarea.form-control {\n\t\t\t\t\theight: calc( 100vh - 500px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.compose-email-footer {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\tpadding: 0 1rem 1rem;\n\t\t}\n\t}\n}\n.hk-wrapper {\n\t&.hk__email__backdrop::after {\n\t\tposition: absolute;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tbackground: $black_2;\n\t\topacity:0.5;\n\t\tz-index: 1033;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tcontent:\"\";\n\t}\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.emailapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n@media (max-width: 1199px) {\n\t.emailapp-wrap {\n\t\t.emailapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.emailapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.emailapp-sidebar-toggle {\n\t\t\t.emailapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.emailapp-content {\n\t\t\t\tleft:270px;\n\t\t\t\tpadding-left: 270px;\n\t\t\t\tmargin-left: -270px;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 991px) {\n\t.emailapp-wrap {\n\t\t.emailapp-content {\n\t\t\t.emailapp-aside {\n\t\t\t\twidth:100%;\n\t\t\t}\n\t\t\t.emailapp-single-email {\n\t\t\t\tright:-100%;\n\t\t\t\tposition:fixed;\n\t\t\t\ttop:0;\n\t\t\t\twidth: 100%;\n\t\t\t\theader.email-header {\n\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t-webkit-justify-content: flex-start;\n\t\t\t\t\t-ms-flex-pack: flex-start;\n\t\t\t\t\t.back-user-list {\n\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\tflex-shrink:0;\n\t\t\t\t\t}\n\t\t\t\t\t.email-options-wrap + .email-options-wrap {\n\t\t\t\t\t\tmargin-left:auto;\n\t\t\t\t\t}\n\t\t\t\t\t.hk-navbar-togglable {\n\t\t\t\t\t\tdisplay: none!important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.emailapp-slide {\n\t\t\t.emailapp-content {\n\t\t\t\t.emailapp-aside {\n\t\t\t\t\tleft:-100%;\n\t\t\t\t}\n\t\t\t\t.emailapp-single-email {\n\t\t\t\t\tright:0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.compose-email-popup {\n\t\t\twidth:100%;\n\t\t\theight:100%;\n\t\t\tright:0;\n\t\t\tborder-radius:0;\n\t\t\tform {\n\t\t\t\ttextarea.form-control {\n\t\t\t\t\theight: calc( 100vh - 300px)!important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.maximize-email-popup {\n\t\t\t\twidth:100%;\n\t\t\t\theight:100%;\n\t\t\t\tleft:0;\n\t\t\t\ttop:0;\n\t\t\t\tborder-radius:0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Taskboard*/\n.taskboardapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t@include transition(height 0.2s ease);\n\t.taskboardapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link,\n\t\t\t\t > div {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.taskboardapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.taskboardapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 270px;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.taskboardapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t\tz-index:10;\n\t\t\theader.taskboard-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tposition:relative;\n\t\t\t\t.taskboardapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\th1{\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t.task-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.media {\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.media-head {\n\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t}\n\t\t\t\t\t.media-body {\n\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.user-status {\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t.taskboard-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t\t>.d-flex.ms-auto {\n\t\t\t\t\t\t> a {\n\t\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\n\t\t\t.taskboard-body {\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t>div {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-flow: column;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t.taskbar-toolbar {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\t\tpadding: 1.25rem;\n\t\t\t\t\t}\t\n\t\t\t\t\t.tasklist-scroll {\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\toverflow-x: auto;\n\t\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\t\toverflow-y: hidden;\n\t\t\t\t\t\tmargin-top:2.25rem;\n\t\t\t\t\t\tpadding-bottom: 1.25rem;\n\t\t\t\t\t\t@include transition(width 0.2s ease);\n\t\t\t\t\t}\n\t\t\t\t\t.tasklist-wrap {\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t-webkit-box-align: flex-start;\n\t\t\t\t\t\t-ms-flex-align: flex-start;\n\t\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\t\t\tfloat: left;\n\t\t\t\t\t\t.tasklist {\n\t\t\t\t\t\t\tmax-height:100%;\n\t\t\t\t\t\t\tmargin: 0 .875rem;\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.spipeline-list {\n\t\t\t\t\t\t\tmargin: 0 .875rem;\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.board-team-wrap {\n\t\t\t\t\tmargin-top:3.75rem;\n\t\t\t\t\tmargin-bottom:3.75rem;\n\t\t\t\t\t.tab-pane {\n\t\t\t\t\t\t.row {\n\t\t\t\t\t\t\t> [class*=\"col-\"] {\n\t\t\t\t\t\t\t\tmargin-bottom:1.875rem;\n\t\t\t\t\t\t\t\t.card {\n\t\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.board-card {\n\t\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.team-card {\n\t\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t\toverflow:hidden;\n\t\t\t\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tmax-width: 200px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.taskboard-body-alt {\n\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\t> div .tasklist-scroll {\n\t\t\t\t\t\toverflow: auto;\n\t\t\t\t\t\tmax-height: inherit;\n\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t\tpadding-bottom: 1.25rem;\n\t\t\t\t\t\tpadding-top: 1.875rem;\n\t\t\t\t\t\tmargin-bottom: 5.125rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.taskboard-info {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 65px;\n\t\t\t\tright: -370px;\n\t\t\t\twidth: 370px;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tz-index:100;\n\t\t\t\tborder: none;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-left: 1px solid $grey_light_4;\n\t\t\t\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t}\n\t\t\t}\t\t\t\t\n\t\t}\t\n\t}\n\t&.taskboardapp-sidebar-toggle {\n\t\t.taskboardapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.taskboardapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n\t&.taskboardapp-info-active {\n\t\t.taskboardapp-detail-wrap {\n\t\t\t.taskboard-info {\n\t\t\t\tright:0;\n\t\t\t}\n\t\t}\n\t}\n}\n.tasklist {\n\tmin-height: 100px;\n\twidth: 350px;\n\t-ms-flex: 0 0 auto;\n\tflex: 0 0 auto;\n\tbackground:$grey_light_5;\n\t>.card-header {\n\t\tflex-flow:column;\n\t\t>div {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\twidth:100%;\n\t\t\tmargin-bottom:1rem;\n\t\t}\n\t}\n\t.tasklist-handle {\n\t\tcursor:grab;\n\t\th6 {\n\t\t\tpointer-events:none;\n\t\t}\n\t}\n\t&.add-new-task {\n\t\tmin-height:0;\n\t\tborder:0;\n\t\tbackground:transparent;\n\t}\n}\n.spipeline-list {\n\tmin-height: 100px;\n\twidth: 350px;\n\t-ms-flex: 0 0 auto;\n\tflex: 0 0 auto;\n\tbackground:transparent;\n\t>.card-header {\n\t\tflex-flow:column;\n\t\tbackground:$white;\n\t\tborder-radius:0.5rem!important;\n\t\tmargin-bottom: .875rem;\n\t\t>div {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\twidth:100%;\n\t\t\t.overall-estimation {\n\t\t\t\tcolor:$black_2;\n\t\t\t\tfont-weight:500;\n\t\t\t}\n\t\t\t.spipeline-dot-sep {\n\t\t\t\tcolor:$grey_light_3;\n\t\t\t\tmargin:0 5px;\n\t\t\t}\n\t\t\t.lead-count {\n\t\t\t\tfont-size:0.75rem;\n\t\t\t}\n\t\t}\n\t\t.btn-block {\n\t\t\tmargin-top:1rem;\n\t\t}\n\t}\n\t>.card-body {\n\t\tborder-radius:0.5rem!important;\n\t\tpadding: 0;\n\t}\n\t.spipeline-handle {\n\t\tcursor:grab;\n\t\th6 {\n\t\t\tpointer-events:none;\n\t\t}\n\t}\n\t&.create-new-list {\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tmin-height: 139px;\n\t\t>.card-header {\n\t\t\tbackground:transparent;\n\t\t\tmargin:0;\n\t\t\t.btn-block {\n\t\t\t\tmargin:0;\n\t\t\t}\n\t\t}\n\t}\n}\n.tasklist-card {\n\t.card-header {\n\t\t.card-action-wrap {\n\t\t\topacity:0;\n\t\t\t@include transition(opacity 0.2s ease);\n\t\t}\n\t}\n\t&:hover {\n\t\t.card-header {\n\t\t\t.card-action-wrap {\n\t\t\t\topacity:1;\n\t\t\t}\n\t\t}\n\t}\n\t.card-body {\n\t\tpadding-top:0;\n\t}\n\t.card-footer {\n\t\t>div {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t}\n\t\t.task-counter,\n\t\t.task-discuss {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tfont-size:0.875rem;\n\t\t\t>span {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t&:first-child {\n\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.task-discuss {\n\t\t\tmargin-left:.5rem;\n\t\t}\n\t\t.task-deadline {\n\t\t\tfont-size:0.875rem;\n\t\t}\n\t}\n}\n.spipeline-card {\n\t.card-body {\n\t\tpadding: .75rem 1.25rem;\n\t\t>.media {\n\t\t\t.media-head {\n\t\t\t\tmargin-right:1rem;\n\t\t\t}\n\t\t\t.media-body {\n\t\t\t\t.brand-name {\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\tfont-weight:600;\n\t\t\t\t}\n\t\t\t\t.price-estimation {\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\tfont-weight:500;\n\t\t\t\t}\n\t\t\t\t.media {\n\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t.media-head {\n\t\t\t\t\t\tmargin-right:.25rem;\n\t\t\t\t\t}\n\t\t\t\t\t.media-body {\n\t\t\t\t\t\tp {\n\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.spipeline-dropdown {\n\t\t\t.position-relative {\n\t\t\t\ttop: -10px;\n\t\t\t}\n\t\t\t.dropdown-item {\n\t\t\t\tpadding: .5rem .75rem;\n\t\t\t}\n\t\t}\n\t}\n\t&.lost-deal {\n\t\tbackground:$red_light_5;\n\t}\n\t&.won-deal {\n\t\tbackground:$green_light_5;\n\t}\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.taskboardapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n.task-detail-modal {\n\t.modal-body {\n\t\theader.task-header {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\tpadding: 1.25rem;\n\t\t\tborder-radius: 0.5rem 0.5rem 0 0;\n\t\t\theight:65px;\n\t\t\tbackground:$white;\n\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\tposition:relative;\n\t\t\tmargin-right: 12.5rem;\n\t\t\t.apexcharts-datalabels-group {\n\t\t\t\ttext {\n\t\t\t\t\tfont-family: inherit;\n\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\tfill: $grey_dark_3;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttransform: translateY(5px);\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.task-options-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t.task-star {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\theight: 21px;\n\t\t\t\t\t\twidth: 21px;\n\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.marked {\n\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t> a {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t\t.task-detail-body {\n\t\t\tpadding:1.25rem;\n\t\t\tmargin-right: 12.5rem;\n\t\t\tform {\n\t\t\t\t.media {\n\t\t\t\t\t.media-head {\n\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t}\n\t\t\t\t\t.media-body {\n\t\t\t\t\t\t.as-name {\n\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.tab-content {\n\t\t\t\t.tab-pane {\n\t\t\t\t\t.note-block {\n\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\tdiv {\n\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.comment-block {\n\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\tmargin-bottom: 1rem;\n\t\t\t\t\t\t\t\t\t\t.cm-name {\n\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.comment-action-wrap {\n\t\t\t\t\t\t\t\t\tspan,a {\n\t\t\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.comment-dot-sep {\n\t\t\t\t\t\t\t\t\t\tmargin:0 .25rem;\n\t\t\t\t\t\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t>.media {\n\t\t\t\t\t\t\t\t\tmargin-top:1.875rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.file-block {\n\t\t\t\t\t\t.sh-files {\n\t\t\t\t\t\t\tmargin: 0 -.8rem;\n\t\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t\tpadding: .8rem;\n\t\t\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t\t\t@include transition(0.2s ease);\n\t\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t\t.avatar.avatar-sm {\n\t\t\t\t\t\t\t\t\t\t\t.avatar-icon {\n\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 1.75rem;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex: 1;\n\t\t\t\t\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\tmax-width: 200px;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.file-size {\n\t\t\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\ta.cp-file-action {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.task-action-wrap {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\twidth: 200px;\n\t\t\tright: 0;\n\t\t\tz-index: 1;\n\t\t\tborder-left: 1px solid $grey_light_4;\n\t\t\tbottom:0;\t\n\t\t\tbackground:$white;\n\t\t\t.nicescroll-bar {\n\t\t\t\tpadding: 1.5rem;\n\t\t\t\t.nav-vertical {\n\t\t\t\t\t>.nav-item {\n\t\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t\tpadding-left:0;\n\t\t\t\t\t\t\tpadding-right:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1399px) {\n\t.taskboardapp-wrap {\n\t\t.taskboardapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.taskboardapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.taskboardapp-sidebar-toggle {\n\t\t\t.taskboardapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.taskboardapp-content {\n\t\t\t\tleft:270px;\n\t\t\t\tpadding-left: 270px;\n\t\t\t\tmargin-left: -270px;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t.taskboardapp-wrap {\n\t\t.taskboardapp-content .taskboardapp-detail-wrap {\n\t\t\t.taskboard-info {\n\t\t\t\ttop:0;\n\t\t\t}\n\t\t}\n\t}\n\t.info-close {\n\t\tposition: relative;\n\t\ttop: -4px;\n\t}\n\t.task-detail-modal {\n\t\t.modal-body {\n\t\t\theader.task-header,\n\t\t\t.task-detail-body { \n\t\t\t\tmargin-right:0;\n\t\t\t}\n\t\t}\n\t}\n\t.task-action-wrap { \n\t\tdisplay:none;\n\t}\n}\n\n\n/*Checklist List*/\n.hk-checklist {\n\t.form-check {\n\t\tmargin-bottom: .625rem;\n\t\tposition: relative;\n\t\t.form-check-label {\n\t\t\tposition: relative;\n\t\t}\n\t\t.done-strikethrough {\n\t\t\tdisplay:block;\n\t\t\theight: 12px;\n\t\t\tbackground: $red;\n\t\t\tmix-blend-mode: multiply;\n\t\t\topacity: .08;\n\t\t\twidth: 0;\n\t\t\ttransition: width .35s ease-in-out, opacity .25s ease-in-out;\n\t\t\tposition: absolute;\n\t\t\tmargin-left: 0;\n\t\t\ttop: 35%;\n\t\t\tleft:0;\n\t\t\tpointer-events: none;\n\t\t\tcontent:\"\";\n\t\t}\n\t\t&.form-check input:checked + label {\n\t\t\t.done-strikethrough {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t} \n\t\t.delete-checklist {\n\t\t\tposition:absolute;\n\t\t\tright: 0;\n\t\t\topacity:0;\n\t\t\t@include transition(opacity .2s ease-in-out);\n\t\t}\n\t\t&:hover {\n\t\t\t.delete-checklist {\n\t\t\t\topacity:1;\n\t\t\t}\n\t\t}\n\t}\n\t.add-new-checklist {\n\t\t.feather-icon{\n\t\t\tmargin-right:.25rem;\n\t\t}\n\t}\n\t.form-control {\n\t\t&.checklist-input {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tborder: none;\n\t\t\tbox-shadow: none;\n\t\t\tpadding: 0;\n\t\t\theight: auto;\n\t\t\twidth: auto;\n\t\t}\n\t}\n}\n\n/*Contact */\n.contactapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t.contactapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link {\n\t\t\t\t\tborder-radius:.5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.tag-cloud {\n\t\t\t\t.badge {\n\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.contactapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.contactapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 270px;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\theader.contact-header {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\theight:65px;\n\t\t\tpadding: 0 1.25rem;\n\t\t\tbackground:$white;\n\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\tposition:relative;\n\t\t\t.contactapp-title {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\th1{\n\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\ttop:0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.media {\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\t.media-head {\n\t\t\t\t\tposition:relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t}\n\t\t\t\t.media-body {\n\t\t\t\t\t.user-name {\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t}\n\t\t\t\t\t.user-status {\n\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\t\n\t\t\t.contact-options-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t> a {\n\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t\t.contactapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\t.contact-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t.quick-access-form-wrap {\n\t\t\t\t\t\tpadding:1rem;\n\t\t\t\t\t\t.quick-access-form {\n\t\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t\t\tbackground:$grey_light_5;\n\t\t\t\t\t\t\t.dropify-square {\n\t\t\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\t\t\t.dropify-wrapper {\n\t\t\t\t\t\t\t\t\theight: 5.75rem;\n\t\t\t\t\t\t\t\t\twidth: 5.75rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.col-md-12 {\n\t\t\t\t\t\t\t\tpadding-left:7.125rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.contact-list-view,\n\t\t\t\t\t.contact-card-view {\n\t\t\t\t\t\t.contact-toolbar-left,\n\t\t\t\t\t\t.contact-toolbar-right {\n\t\t\t\t\t\t\tmin-height: 45px;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center; \n\t\t\t\t\t\t}\n\t\t\t\t\t\t.contact-toolbar-left {\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.contact-toolbar-right {\n\t\t\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\tmargin-left:1rem;\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dataTables_filter,\n\t\t\t\t\t\t\t.dataTables_length,\n\t\t\t\t\t\t\t.dataTables_info {\n\t\t\t\t\t\t\t\tfloat:none;\n\t\t\t\t\t\t\t\tlabel {\n\t\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dataTables_info {\n\t\t\t\t\t\t\t\tpadding-top:0;\n\t\t\t\t\t\t\t\twidth: 95px;\n\t\t\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dataTables_paginate {\n\t\t\t\t\t\t\t\tpadding-top:0;\n\t\t\t\t\t\t\t\t.pagination.custom-pagination {\n\t\t\t\t\t\t\t\t\t.paginate_button:not(:first-child):not(:last-child) {\n\t\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.page-link {\n\t\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\t\t\t\tmin-width:auto;\n\t\t\t\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.dataTables_length select {\n\t\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\t\tdisplay: inline-block;\n    \t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t.contact-list-view {\n\t\t\t\t\t\t.contact-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\tfont-size: 1rem;;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} \n\t\t\t\t\t}\n\t\t\t\t\t.contact-card-view {\n\t\t\t\t\t\t.card {\n\t\t\t\t\t\t\t&.contact-card {\n\t\t\t\t\t\t\t\t.form-check.form-check-lg {\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tleft: 14px;\n\t\t\t\t\t\t\t\t\ttop: 17px;\n\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\t\tmargin-top: .625rem;\n\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.user-name,\n\t\t\t\t\t\t\t\t.user-email,\n\t\t\t\t\t\t\t\t.user-contact,\n\t\t\t\t\t\t\t\t.user-desg {\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.card-footer {\n\t\t\t\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t\t>.d-flex {\n\t\t\t\t\t\t\t\t\t\tpadding: 0.75rem 1.25rem;\n\t\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t.form-check.form-check-lg {\n\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.contact-star {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t.contact-star {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.select-multiple {\n\t\t\t\t\t\t\t.card {\n\t\t\t\t\t\t\t\t&.contact-card {\n\t\t\t\t\t\t\t\t\t.form-check.form-check-lg {\n\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.contact-detail-body {\n\t\t\t.nicescroll-bar {\n\t\t\t\tpadding: 0!important;\n\t\t\t\t.contact-info {\n\t\t\t\t\tposition:relative;\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\tborder-right: 1px solid $grey_light_4;\n\t\t\t\t\t.action-btn {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tright: 1.25rem;\n\t\t\t\t\t}\n\t\t\t\t\t.cp-name {\n\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tcolor: $black_2;\n\t\t\t\t\t}\n\t\t\t\t\t.cp-info {\n\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t}\n\t\t\t\t\t.dropify-circle .dropify-wrapper {\n\t\t\t\t\t\tmargin:0 auto;\n\t\t\t\t\t}\n\t\t\t\t\t.card {\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\t\t.card-header {\n\t\t\t\t\t\t\tborder:none;\n\t\t\t\t\t\t\tpadding: .5rem 0;\n\t\t\t\t\t\t\t> a {\n\t\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.card-body {\n\t\t\t\t\t\t\tpadding: .5rem 0;\n\t\t\t\t\t\t\t.cp-info {\n\t\t\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t\t\t\t\t\t>span {\n\t\t\t\t\t\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\tmin-width: 100px;\n\t\t\t\t\t\t\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.cp-action {\n\t\t\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t.cp-icon-wrap {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\tmargin-right: .5rem;\n\t\t\t\t\t\t\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\tmargin-bottom:10px;\n\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.contact-more-info {\n\t\t\t\t\tflex-grow:1;\n\t\t\t\t\t.nav-tabs {\n\t\t\t\t\t\t.nav-item {\n\t\t\t\t\t\t\t.nav-link {\n\t\t\t\t\t\t\t\tpadding:.75rem 1.25rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.nav-line {\n\t\t\t\t\t\t\tborder-bottom: 1px solid $grey_light_4;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.tab-content {\n\t\t\t\t\t\tpadding:0 1.25rem;\n\t\t\t\t\t}\n\t\t\t\t\t.pipeline-status-wrap {\n\t\t\t\t\t\tpadding:0 1.25rem;\n\t\t\t\t\t\t.pipeline-stutus {\n\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\tlist-style-type: none;\n\t\t\t\t\t\t\tfont-family: arial;\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t\tclear: both;\n\t\t\t\t\t\t\tline-height: 1em;\n\t\t\t\t\t\t\tmargin: 0 -1px;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t\tfloat: left;\n\t\t\t\t\t\t\t\tpadding: 1rem 1.875rem 1rem 2.5rem;\n\t\t\t\t\t\t\t\tbackground: $grey_light_3;\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\twidth: 19.5%;\n\t\t\t\t\t\t\t\tmargin: 0 1px;\n\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\t\t\tborder-left: 20px solid $white;\n\t\t\t\t\t\t\t\t\tborder-top: 20px solid transparent;\n\t\t\t\t\t\t\t\t\tborder-bottom: 20px solid transparent;\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\tborder-radius: 0.5rem 0 0 0.5rem;\n\t\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\tborder-radius: 0 0.5rem 0.5rem 0;\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\t\t\t\tborder-left: 20px solid $grey_light_3;\n\t\t\t\t\t\t\t\t\tborder-top: 20px solid transparent;\n\t\t\t\t\t\t\t\t\tborder-bottom: 20px solid transparent;\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\tleft: 100%;\n\t\t\t\t\t\t\t\t\tz-index: 20;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t\tbackground: $orange;\n\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tborder-left-color: $orange;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.completed {\n\t\t\t\t\t\t\t\t\tbackground: $primary;\n\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tborder-left-color: $primary;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t>span {\n\t\t\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.activity-wrap {\n\t\t\t\t\t\tpadding:0 1.25rem 1.25rem;\n\t\t\t\t\t\t.activity-thread {\n\t\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t\tmargin-bottom:1rem;\n\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\t\t.activity-time {\n\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-top: .25rem;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.contact-detail-modal {\n\t\t\theader.contact-header {\n\t\t\t\theight:auto;\n\t\t\t\tpadding: 1.25rem;\n\t\t\t\tborder-radius: 0.5rem 0.5rem 0 0;\n\t\t\t\tul.hk-list.hk-list-sm li {\n\t\t\t\t\tpadding: 0 .4rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.contactapp-sidebar-toggle {\n\t\t.contactapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.contactapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.contactapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n@media (max-width: 1740px) {\n\t.contactapp-wrap {\n\t\t.contactapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t\t.contactapp-detail-wrap .contact-body .nicescroll-bar {\n\t\t\t\t.contact-list-view,\n\t\t\t\t.contact-card-view {\n\t\t\t\t\t.contact-toolbar-right {\n\t\t\t\t\t\t.dataTables_info,\n\t\t\t\t\t\t.dataTables_length {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t} \n\t\t}\n\t\t.contactapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t&.contactapp-sidebar-toggle {\n\t\t\t.contactapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.contactapp-content {\n\t\t\t\tleft:270px;\n\t\t\t\tpadding-left: 270px;\n\t\t\t\tmargin-left: -270px;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*File Manager*/\n.fmapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t.fmapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.fmapp-storage {\n\t\t\tpadding:1.5rem;\n\t\t}\n\t\t.fmapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.fmapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 270px;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.fmapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\theader.fm-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tposition:relative;\n\t\t\t\t.fmapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\th1{\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.fm-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.fm-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t.file-list-view {\n\t\t\t\t\t\t.nav-line {\n\t\t\t\t\t\t\tmargin:0 -1.25rem;\n\t\t\t\t\t\t\tborder-bottom: 1px solid $grey_light_4;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.file-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\theight: 16px;\n\t\t\t\t\t\t\t\twidth: 16px;\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\tmax-width:190px;\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.fmapp-info-trigger {\n\t\t\t\t\t\t\t&.media {\n\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t@include transition(color .2s ease);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.file-card-view {\n\t\t\t\t\t\t.file-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tmargin-right: .25rem;\n\t\t\t\t\t\t\tmargin-top: .4rem;\n\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.card {\n\t\t\t\t\t\t\t&.file-card {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t.card-body {\n\t\t\t\t\t\t\t\t\tmin-height:150px;\n\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\tjustify-content:center;\n\t\t\t\t\t\t\t\t\ti {\n\t\t\t\t\t\t\t\t\t\tfont-size: 2.375rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.card-footer {\n\t\t\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\t\t\t@include transition(background .2s ease);\n\t\t\t\t\t\t\t\t\t>.d-flex {\n\t\t\t\t\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\t\t\t\t\tmin-width:0;\n\t\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.file-star.marked {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t.file-star {\n\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.card-footer {\n\t\t\t\t\t\t\t\t\t\tbackground:$primary_light_5;\n\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.file-compact-card {\n\t\t\t\t\t\t\t\t@include transition(background .2s ease);\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t.card-body {\n\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\toverflow:hidden;\n\t\t\t\t\t\t\t\t\t\t.avatar {\n\t\t\t\t\t\t\t\t\t\t\tflex-shrink:0;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\tmin-width:0;\n\t\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.file-star.marked {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tbackground:$primary_light_5;\n\t\t\t\t\t\t\t\t\t.file-star {\n\t\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.card-body {\n\t\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t\t.avatar {\n\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink:0;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.file-info {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 65px;\n\t\t\t\tright: -370px;\n\t\t\t\twidth: 370px;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tz-index:100;\n\t\t\t\tborder: none;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-left: 1px solid $grey_light_4;\n\t\t\t\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t}\n\t\t\t\t.file-name {\n\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\tfont-weight:500;\n\t\t\t\t\tmax-width: 250px;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t}\n\t\t\t\t.fm-info {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tli {\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t\t\t>span {\n\t\t\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tmin-width: 100px;\n\t\t\t\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.fm-action {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tli {\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.fmapp-info-active {\n\t\t.fmapp-detail-wrap {\n\t\t\t.file-info {\n\t\t\t\tright:0;\n\t\t\t}\n\t\t}\n\t}\n\t&.fmapp-sidebar-toggle {\n\t\t.fmapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.fmapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.fmapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n@media (max-width: 1199px) {\n\t.fmapp-wrap .fmapp-content .fmapp-detail-wrap .file-info {\n\t\ttop:0;\n\t}\n}\n@media (max-width: 767px) {\n\t.fmapp-wrap {\n\t\t.fmapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.fmapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.fmapp-sidebar-toggle {\n\t\t\t.fmapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.fmapp-content {\n\t\t\t\tleft:270px;\n\t\t\t\tpadding-left: 270px;\n\t\t\t\tmargin-left: -270px;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Gallery App*/\n.galleryapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t.galleryapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.galleryapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\n\t\t}\n\t}\n\t.galleryapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 270px;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.galleryapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\theader.gallery-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tposition:relative;\n\t\t\t\t.galleryapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\th1{\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.gallery-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.gallery-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t.hk-gallery {\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t\t.form-check {\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tleft: 14px;\n\t\t\t\t\t\t\t\ttop: 17px;\n\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.gallery-star {\n\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tright: 14px;\n\t\t\t\t\t\t\t\ttop: 20px;\n\t\t\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t.form-check {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.gallery-star {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.gallery-img {\n\t\t\t\t\t\t\t\tmin-height: 230px;\n\t\t\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\t\t\tbackground-position: center;\n\t\t\t\t\t\t\t\t&.gallery-video {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tcontent:\"\\efb6\";\n\t\t\t\t\t\t\t\t\t\tfont-family: remixicon;\n\t\t\t\t\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\t\t\t\t\tright:14px;\n\t\t\t\t\t\t\t\t\t\tbottom:14px;\n\t\t\t\t\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t\t\t\t\theight:35px;\n\t\t\t\t\t\t\t\t\t\twidth:35px;\n\t\t\t\t\t\t\t\t\t\tborder-radius:50%;\n\t\t\t\t\t\t\t\t\t\t@include background-opacity($white,.45);\n\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\tjustify-content:center;\n\t\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.select-multiple {\n\t\t\t\t\t.nicescroll-bar {\n\t\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t\t.hk-gallery {\n\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t.form-check {\n\t\t\t\t\t\t\t\t\topacity:1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.galleryapp-sidebar-toggle {\n\t\t.galleryapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.galleryapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n}\n.lg-outer.galleryapp-info-active {\n\t.lg-img-wrap {\n\t\tpadding-right: 26.25rem !important;\n\t\tbackground: url(\"../img/loading.gif\") no-repeat scroll transparent;\n\t\tbackground-position: center center;\n\t\tbackground-position: calc((100% - 300px) / 2) center;\n\t}\n\t.lg-video-cont {\n\t\tpadding-right: 20rem !important;\n\t\tbackground: url(\"../img/loading.gif\") no-repeat scroll transparent;\n\t\tbackground-position: center center;\n\t\tbackground-position: calc((100% - 300px) / 2) center;\n\t}\n\t.lg-sub-html {\n\t\theight: 100%;\n\t\toverflow-y: auto;\n\t\tposition: absolute;\n\t\tright: 0;\n\t\ttop: 0;\n\t\twidth: 420px;\n\t\tz-index: 99999;\n\t\tleft: auto;\n\t\tcolor:inherit;\n\t\tpadding:0;\n\t\ttext-align:left;\n\t\tbackground: $white url(\"../img/loading.gif\") no-repeat scroll center center;\n\t\theader.gallery-header {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\tpadding: 1.25rem;\n\t\t\tmargin:0 -1.25rem;\n\t\t\theight:65px;\n\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\tposition:relative;\n\t\t\t.file-name {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: $black_2;\n\t\t\t\tmax-width: 190px;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\t\t\t.file-type {\n\t\t\t\tfont-size:0.75rem;\n\t\t\t}\n\t\t\t.gallery-options-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t> a {\n\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t\t.gallery-detail-body {\n\t\t\t.file-info {\n\t\t\t\tli {\n\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t\t>span {\n\t\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmin-width: 100px;\n\t\t\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.galleryapp-info-active.fb_iframe_widget {\n\t\tbackground-image: none;\n\t}\n\t.galleryapp-info-active.fb_iframe_widget.fb_iframe_widget_loader {\n\t\tbackground: #fff url(\"../img/loading.gif\") no-repeat scroll center center;\n\t}\n\t.lg-toolbar {\n\t\tright: 420px;\n\t\twidth: auto;\n\t}\n\t.lg-actions {\n\t\t.lg-next {\n\t\t\tright: 440px;\n\t\t}\n\t}\n\t.lg-item {\n\t\tbackground-image: none;\n\t}\n\t.lg-item.lg-complete {\n\t\t.lg-img-wrap {\n\t\t\tbackground-image: none;\n\t\t}\n\t\t.lg-video-cont {\n\t\t\tbackground-image: none;\n\t\t}\n\t}\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.galleryapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n@media (max-width: 767px) {\n\t.galleryapp-wrap {\n\t\t.galleryapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.galleryapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.galleryapp-sidebar-toggle {\n\t\t\t.galleryapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.galleryapp-content {\n\t\t\t\tleft:270px;\n\t\t\t\tpadding-left: 270px;\n\t\t\t\tmargin-left: -270px;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.lg-outer.galleryapp-info-active {\n\t\t.lg-img-wrap {\n\t\t\tpadding-right: 0 !important;\n\t\t}\n\t\t.lg-video-cont {\n\t\t\tpadding-right: 0 !important;\n\t\t}\n\t\t.lg-sub-html {\n\t\t\tdisplay:none;\n\t\t}\n\t\t.lg-toolbar {\n\t\t\tright: 0;\n\t\t}\n\t\t.lg-actions {\n\t\t\t.lg-next {\n\t\t\t\tright: 20px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Todo*/\n.todoapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t.todoapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t> .nav-link,\n\t\t\t\t> div {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.todoapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.todoapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 270px;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.todoapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\twidth:calc(100vw - 270px);\n\t\t\theader.todo-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tposition:relative;\n\t\t\t\t.todoapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\th1{\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t.task-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.media {\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.media-head {\n\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t}\n\t\t\t\t\t.media-body {\n\t\t\t\t\t\t.user-name {\n\t\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.user-status {\n\t\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t.todo-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t>.d-flex.ms-auto > a,\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.todo-body {\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\tmargin-right: 0;\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t.todo-toolbar {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t.pagination.custom-pagination {\n\t\t\t\t\t\t\t\t.paginate_button:not(:first-child):not(:last-child) {\n\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.page-link {\n\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\t\t\tmin-width:auto;\n\t\t\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.split-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\theight:100%;\n\t\t\t\t\t\t.gutter.gutter-horizontal {\n\t\t\t\t\t\t\tcursor: ew-resize;\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\twidth: 7px;\n\t\t\t\t\t\t\tcursor: ew-resize;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\tbackground: $white;\n\t\t\t\t\t\t\tborder-left:1px solid $grey_light_4;\n\t\t\t\t\t\t\tborder-right:1px solid $grey_light_4;\n\t\t\t\t\t\t\tz-index: 5;\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\tfont-family: remixicon!important;\n\t\t\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\t\t\tcontent: \"\\ef26\";\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\t\tleft: -8px;\n\t\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.split {\n\t\t\t\t\t\t\t.table-wrap {\n\t\t\t\t\t\t\t\twidth:calc(100vw - 270px);\n\t\t\t\t\t\t\t\ttable.gt-todo-table {\n\t\t\t\t\t\t\t\t\t.gt-single-task {\n\t\t\t\t\t\t\t\t\t\t.todo-star {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\t\t\t\t\tmargin-right:.625rem;\n\t\t\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.todo-text {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.table-bordered.dataTable {\n\t\t\t\t\t\t\t\t\t\tmargin-top: 0!important;\n\t\t\t\t\t\t\t\t\t\tth,td {\n\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\tborder-left-width: 0;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\tthead {\n\t\t\t\t\t\t\t\t\t\t\ttr {\n\t\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\tth,td {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tborder-top-width: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.gantt-wrap {\n\t\t\t\t\t\t\t\t.gantt-container {\n\t\t\t\t\t\t\t\t\toverflow: initial;\n\t\t\t\t\t\t\t\t\t.gantt {\n\t\t\t\t\t\t\t\t\t\tfill: $primary;\n\t\t\t\t\t\t\t\t\t\t.grid-row:nth-child(even) {\n\t\t\t\t\t\t\t\t\t\t\tfill: $white;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.row-line,.tick {\n\t\t\t\t\t\t\t\t\t\t\tstroke: $grey_light_3;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.bar {\n\t\t\t\t\t\t\t\t\t\t\tfill: $grey_dark_1;\n\t\t\t\t\t\t\t\t\t\t\tstroke: $grey_dark_3;\n\t\t\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\t\t\t.bar-progress {\n\t\t\t\t\t\t\t\t\t\t\tfill: $primary;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.grid-header {\n\t\t\t\t\t\t\t\t\t\t\tstroke-width: 0;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.task-info {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 65px;\n\t\t\t\tright: -550px;\n\t\t\t\twidth: 550px;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tz-index:100;\n\t\t\t\tborder: none;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-left: 1px solid $grey_light_4;\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\theader.task-header {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\t\tborder-radius: 0.5rem 0.5rem 0 0;\n\t\t\t\t\theight:65px;\n\t\t\t\t\tbackground:$white;\n\t\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\t\tposition:relative;\n\t\t\t\t\t.apexcharts-datalabels-group {\n\t\t\t\t\t\ttext {\n\t\t\t\t\t\t\tfont-family: inherit;\n\t\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\t\tfill: $grey_dark_3;\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttransform: translateY(5px);\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.task-options-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t.task-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t> a {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.task-detail-body {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\tform {\n\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t.as-name {\n\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.tab-content {\n\t\t\t\t\t\t.tab-pane {\n\t\t\t\t\t\t\t.note-block {\n\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\tdiv {\n\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\tmargin-bottom:1.25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.comment-block {\n\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: 1rem;\n\t\t\t\t\t\t\t\t\t\t\t\t.cm-name {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.comment-action-wrap {\n\t\t\t\t\t\t\t\t\t\t\tspan,a {\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t.comment-dot-sep {\n\t\t\t\t\t\t\t\t\t\t\t\tmargin:0 .25rem;\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t>.media {\n\t\t\t\t\t\t\t\t\t\t\tmargin-top:1.875rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.file-block {\n\t\t\t\t\t\t\t\t.sh-files {\n\t\t\t\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\t\t\t\tmargin: 0 -.8rem;\n\t\t\t\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t\t\t\tpadding: .8rem;\n\t\t\t\t\t\t\t\t\t\tborder-radius:0.5rem;\n\t\t\t\t\t\t\t\t\t\t@include transition(0.2s ease);\n\t\t\t\t\t\t\t\t\t\tmargin-bottom:.25rem;\n\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\t.avatar.avatar-sm {\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t\t\t\t\t.avatar-icon {\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 1.75rem;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tmin-width: 0;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex: 1;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmax-width: 200px;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t.file-size {\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-top:.25rem;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\t\tbackground-color:#f2f2f2;\n\t\t\t\t\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t\t\t\t\t.file-name {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\ta.cp-file-action {\n\t\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\t\n\t}\n\t&.todoapp-sidebar-toggle {\n\t\t.todoapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.todoapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n\t&.todoapp-info-active {\n\t\t.todoapp-detail-wrap {\n\t\t\t.todo-body {\n\t\t\t\tmargin-right:550px;\n\t\t\t}\n\t\t\t.task-info {\n\t\t\t\tright:0;\n\t\t\t}\n\t\t}\n\t}\n\t&.ganttapp-wrap {\n\t\t.todoapp-content {\n\t\t\t.todoapp-detail-wrap {\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:0;\n\t\t\t\t\ttable.dataTable.cell-border {\n\t\t\t\t\t\tthead {\n\t\t\t\t\t\t\tth {\n\t\t\t\t\t\t\t\tborder-right:1px solid $grey_light_4;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\ttbody tr {\n\t\t\t\t\t\t\tth,td {\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\tborder-left:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t}\n}\n.advance-list-item {\n\t&.single-task-list {\n\t\t.form-check {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tmargin-bottom: 0;\n\t\t\t+ div {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tfont-weight:500;\n\t\t\t\t.todo-star {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.marked {\n\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.todo-text {\n\t\t\t\t\tcursor:pointer;\n\t\t\t\t\tmax-width: 300px;\n\t\t\t\t}\n\t\t\t\t.badge-indicator {\n\t\t\t\t\tmargin:0 .75rem  0 .5rem;\n\t\t\t\t\tflex-shrink:0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.selected {\n\t\t\tbackground:$primary_light_5;\n\t\t}\n\t}\n}\n.hk-wrapper {\n\t&[data-navbar-style=\"collapsed\"] {\n\t\t.todoapp-wrap {\n\t\t\theight: 100vh;\n\t\t}\n\t}\n}\n@media (max-width: 1740px) {\n\t.todoapp-wrap {\n\t\t.todoapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.todoapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.todoapp-sidebar-toggle {\n\t\t\t.todoapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.todoapp-content {\n\t\t\t\tleft:270px;\n\t\t\t\tpadding-left: 270px;\n\t\t\t\tmargin-left: -270px;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1500px) {\n\t.todoapp-wrap {\n\t\t&.todoapp-info-active .todoapp-detail-wrap {\n\t\t\t.todo-body {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t\t.task-info {\n\t\t\t\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\t\t\t}\n\t\t} \n\t}\n}\n@media (max-width: 1199px) {\n\t.todoapp-wrap {\n\t\t.todoapp-content {\n\t\t\t.todoapp-detail-wrap {\n\t\t\t\t.task-info {\n\t\t\t\t\ttop: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tright: -100%;\n\t\t\t\t}\n\t\t\t} \n\t\t}\n\t\t&.todoapp-info-active .todoapp-detail-wrap {\n\t\t\t.task-info {\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t} \n\t}\n}\t\n@media (max-width: 767px) {\n\t.advance-list-item.single-task-list {\n\t\tmin-height: auto;\n\t\t.form-check + div .todo-text {\n\t\t\tcursor: pointer;\n\t\t\tmax-width: calc(100vw - 250px);\n\t\t}\n\t}\n}\n\n/*Blog App*/\n.blogapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t.blogapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.nav-header {\n\t\t\t\tpadding: 0 0 .5rem 0;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: $primary;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t&[data-toggle=\"collapse\"] {\n\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\tcontent: '\\f2f9';\n\t\t\t\t\t\t\tfont: normal normal normal 18px/1 'Material-Design-Iconic-Font';\n\t\t\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\t@include transform(translateX(0) rotate(0deg));\n\t\t\t\t\t\t\t@include transition(all 0.4s ease);\n\t\t\t\t\t\t\t@include color-opacity($black_2,0.3);\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&[aria-expanded=\"true\"] {\n\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t@include transform(translateX(0) rotate(-180deg));\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t\t.secondary-nav .nav-item .nav-link {\n\t\t\t\t\tpadding-left:3.3rem;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.tag-cloud {\n\t\t\t.badge {\n\t\t\t\tmargin-bottom:.25rem;\n\t\t\t}\n\t\t}\n\t\t.blogapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.blogapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 16.875rem;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.blogapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\theader.blog-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tposition:relative;\n\t\t\t\t.blogapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\th1{\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.blog-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.blog-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t.blog-toolbar-left,\n\t\t\t\t\t.blog-toolbar-right {\n\t\t\t\t\t\tmin-height: 45px;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center; \n\t\t\t\t\t}\n\t\t\t\t\t.blog-toolbar-left {\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.blog-toolbar-right {\n\t\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tmargin-left:1rem;\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_filter,\n\t\t\t\t\t\t.dataTables_length,\n\t\t\t\t\t\t.dataTables_info {\n\t\t\t\t\t\t\tfloat:none;\n\t\t\t\t\t\t\tlabel {\n\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_info {\n\t\t\t\t\t\t\tpadding-top:0;\n\t\t\t\t\t\t\twidth: 95px;\n\t\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_paginate {\n\t\t\t\t\t\t\tpadding-top:0;\n\t\t\t\t\t\t\t.pagination.custom-pagination {\n\t\t\t\t\t\t\t\t.paginate_button:not(:first-child):not(:last-child) {\n\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.page-link {\n\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\t\t\tmin-width:auto;\n\t\t\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_length select {\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.edit-post-form {\n\t\t\t\t\t\t.tox-tinymce {\n\t\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\t\t.tox-statusbar__text-container {\n\t\t\t\t\t\t\t\tdisplay: none!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.nav-tabs {\n\t\t\t\t\t\t\t> .nav-item > .nav-link {\n\t\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t\t\tz-index:1;\n\t\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t\tborder-color: $grey_light_4 $grey_light_4 $white;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.advance-option-post {\n\t\t\t\t\t\t\t.nav-tabs {\n\t\t\t\t\t\t\t\tmargin-left:-1.25rem;\n\t\t\t\t\t\t\t\tmargin-right:-1.25rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.uploaded-img-prev {\n\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\t.card {\n\t\t\t\t\t\t\t\t\t\tmin-height: 100px;\n\t\t\t\t\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\t\t\t\t\tbackground-position: center;\n\t\t\t\t\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\t\t\t\t\tmargin-top: 1rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.post-list {\n\t\t\t\t\t\t.nav-line {\n\t\t\t\t\t\t\tmargin:0 -1.25rem;\n\t\t\t\t\t\t\tborder-bottom: 1px solid $grey_light_4;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.post-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\theight: 16px;\n\t\t\t\t\t\t\t\twidth: 16px;\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.blogapp-sidebar-toggle {\n\t\t.blogapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.blogapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n}\n\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.blogapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n@media (max-width: 1740px) {\n\t.blogapp-wrap {\n\t\t.blogapp-content {\n\t\t\t.blogapp-detail-wrap .blog-body .nicescroll-bar {\n\t\t\t\t.blog-toolbar-right {\n\t\t\t\t\t.dataTables_info,\n\t\t\t\t\t.dataTables_length {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t} \n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n\t.blogapp-wrap {\n\t\t.blogapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.blogapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.blogapp-sidebar-toggle {\n\t\t\t.blogapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.blogapp-content {\n\t\t\t\tleft:16.875rem;\n\t\t\t\tpadding-left: 16.875rem;\n\t\t\t\tmargin-left: -16.875rem;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*invoice*/\n.invoiceapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t.invoiceapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.nav-header {\n\t\t\t\tpadding: 0 0 .5rem 0;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: $primary;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.invoiceapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\n\t\t}\n\t}\n\t.invoiceapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 16.875rem;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\theader.invoice-header {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\t-webkit-justify-content: space-between;\n\t\t\t-ms-flex-pack: space-between;\n\t\t\theight:65px;\n\t\t\tpadding: 0 1.25rem;\n\t\t\tbackground:$white;\n\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\tposition:relative;\n\t\t\t.invoiceapp-title {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\th1{\n\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\ttop:0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.media {\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\t.media-head {\n\t\t\t\t\tposition:relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t}\n\t\t\t\t.media-body {\n\t\t\t\t\t.user-name {\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\ttext-transform:capitalize;\n\t\t\t\t\t}\n\t\t\t\t\t.user-status {\n\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\t\n\t\t\t.invoice-options-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t> a {\n\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t\t.invoiceapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\t.invoice-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t.invoice-toolbar-left,\n\t\t\t\t\t.invoice-toolbar-right {\n\t\t\t\t\t\tmin-height: 45px;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay:flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center; \n\t\t\t\t\t}\n\t\t\t\t\t.invoice-toolbar-left {\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.invoice-toolbar-right {\n\t\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\t\t-webkit-justify-content: flex-end;\n\t\t\t\t\t\t>div {\n\t\t\t\t\t\t\tmargin-left:1rem;\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_filter,\n\t\t\t\t\t\t.dataTables_length,\n\t\t\t\t\t\t.dataTables_info {\n\t\t\t\t\t\t\tfloat:none;\n\t\t\t\t\t\t\tlabel {\n\t\t\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_info {\n\t\t\t\t\t\t\tpadding-top:0;\n\t\t\t\t\t\t\twidth: 95px;\n\t\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_paginate {\n\t\t\t\t\t\t\tpadding-top:0;\n\t\t\t\t\t\t\t.pagination.custom-pagination {\n\t\t\t\t\t\t\t\t.paginate_button:not(:first-child):not(:last-child) {\n\t\t\t\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.page-link {\n\t\t\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\t\t\tmin-width:auto;\n\t\t\t\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dataTables_length select {\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.invoice-list-view {\n\t\t\t\t\t\t.invoice-star {\n\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tmargin-left:.625rem;\n\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\tcursor:pointer;\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.marked {\n\t\t\t\t\t\t\t\t> .feather-icon > svg,.svg-icon > svg {\n\t\t\t\t\t\t\t\t\tfill:$yellow;\n\t\t\t\t\t\t\t\t\tstroke:$yellow;\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tfill:none;\n\t\t\t\t\t\t\t\t\t\tstroke:currentColor;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.template-invoice-wrap,\n\t\t\t\t\t.create-invoice-wrap {\n\t\t\t\t\t\tborder:1px solid $grey_light_4;\n\t\t\t\t\t\t.invoice-table {\n\t\t\t\t\t\t\tthead {\n\t\t\t\t\t\t\t\ttr {\n\t\t\t\t\t\t\t\t\tth {\n\t\t\t\t\t\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\tborder-top-left-radius:0.25rem;\n\t\t\t\t\t\t\t\t\t\t\tborder-bottom-left-radius:0.25rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t\t\t\tborder-top-right-radius:0.25rem;\n\t\t\t\t\t\t\t\t\t\t\tborder-bottom-right-radius:0.25rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.subtotal-table {\n\t\t\t\t\t\t\tmin-width: 450px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.invoice-table,\n\t\t\t\t\t\t.subtotal-table {\n\t\t\t\t\t\t\tborder-collapse: separate;\n\t\t\t\t\t\t\tborder-spacing: 0px;\n\t\t\t\t\t\t\ttd,th {\n\t\t\t\t\t\t\t\tborder:1px solid $grey_light_4;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.form-group {\n\t\t\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.invoice-settings {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 65px;\n\t\t\t\tright: -370px;\n\t\t\t\twidth: 370px;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tz-index:100;\n\t\t\t\tborder: none;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-left: 1px solid $grey_light_4;\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.invoiceapp-setting-active {\n\t\t.invoiceapp-content {\n\t\t\t.invoiceapp-detail-wrap {\n\t\t\t\t.invoice-body {\n\t\t\t\t\tmargin-right:370px;\n\t\t\t\t}\n\t\t\t\t.invoice-settings {\n\t\t\t\t\tright:0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.invoiceapp-sidebar-toggle {\n\t\t.invoiceapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.invoiceapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.invoiceapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n@media (max-width: 1740px) {\n\t.invoiceapp-wrap {\n\t\t.invoiceapp-content {\n\t\t\t.invoiceapp-detail-wrap .invoice-body .nicescroll-bar {\n\t\t\t\t.invoice-toolbar-right {\n\t\t\t\t\t.dataTables_info,\n\t\t\t\t\t.dataTables_length {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t} \n\t\t}\n\t}\n}\n@media (max-width: 1600px) {\n\t.invoiceapp-wrap {\n\t\t.invoiceapp-content .invoiceapp-detail-wrap {\n\t\t\t.invoice-settings {\n\t\t\t\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\t\t\t}\n\t\t\t.invoice-body {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t\t&.invoiceapp-setting-active {\n\t\t\t.invoiceapp-content .invoiceapp-detail-wrap {\n\t\t\t\t.invoice-body {\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 1199px) {\n\t.invoiceapp-wrap {\n\t\t.invoiceapp-content {\n\t\t\t.invoiceapp-detail-wrap {\n\t\t\t\t.invoice-settings {\n\t\t\t\t\ttop:0;\n\t\t\t\t}\n\t\t\t\t.invoice-body {\n\t\t\t\t\t.nicescroll-bar {\n\t\t\t\t\t\t.create-invoice-wrap {\n\t\t\t\t\t\t\t.invoice-table-wrap {\n\t\t\t\t\t\t\t\toverflow-x: auto;\n\t\t\t\t\t\t\t\t-webkit-overflow-scrolling: touch;\n\t\t\t\t\t\t\t\t.invoice-table {\n\t\t\t\t\t\t\t\t\tmin-width: 900px;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.invoiceapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.invoiceapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.invoiceapp-sidebar-toggle {\n\t\t\t.invoiceapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.invoiceapp-content {\n\t\t\t\tleft:16.875rem;\n\t\t\t\tpadding-left: 16.875rem;\n\t\t\t\tmargin-left: -16.875rem;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Integrations*/\n.integrationsapp-wrap {\n\tposition:relative;\n\theight:calc(100vh - 65px);\n\t.integrationsapp-sidebar {\n\t\tposition: absolute;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tflex-flow: column;\n\t\tleft: 0;\n\t\twidth: 270px;\n\t\tmargin-left: 0;\n\t\ttop: 0;\n\t\theight:100%;\n\t\tz-index:1;\n\t\tborder: none;\n\t\tbackground:$white;\n\t\tborder-right: 1px solid $grey_light_4;\n\t\t@include transition(all 0.2s ease);\n\t\t>div.nicescroll-bar {\n\t\t\tflex: 1 1 auto;\n\t\t\toverflow: auto;\n\t\t}\n\t\t.menu-content-wrap {\n\t\t\tpadding:1.5rem;\n\t\t\t.menu-gap {\n\t\t\t\theight: 25px;\n\t\t\t}\n\t\t\t.nav-header {\n\t\t\t\tpadding: 0 0 .5rem 0;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: $primary;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t.menu-group > .navbar-nav > .nav-item {\n\t\t\t\tmargin-left: -1rem;\n\t\t\t\tmargin-right: -1rem;\n\t\t\t\t > .nav-link {\n\t\t\t\t\tborder-radius: .5rem;\n\t\t\t\t\tpadding: .5rem 1rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t.nav-icon-wrap {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-right: .875rem;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\t.nav-link-text {\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t>.nav-link {\n\t\t\t\t\t\t@include background-opacity($primary,0.15);\n\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.integrationsapp-fixednav {\n\t\t\theight: 61px;\n\t\t\tborder-top: 1px solid $grey_light_4;\t\n\t\t}\n\t}\n\t.integrationsapp-content {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\t\tpadding-left: 16.875rem;\n\t\tposition:relative;\n\t\theight: 100%;\n\t\tleft:0;\n\t\t@include transition(all 0.2s ease);\n\t\t.integrationsapp-detail-wrap {\n\t\t\tposition:relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow:1;\n\t\t\tbackground:$white;\n\t\t\tflex-flow: column;\n\t\t\theight: 100%;\n\t\t\tz-index:10;\n\t\t\theader.integrations-header {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\theight:65px;\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\tbackground:$white;\n\t\t\t\tborder-bottom:1px solid $grey_light_4;\n\t\t\t\tposition:relative;\n\t\t\t\t.integrationsapp-title {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\th1{\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tmargin-bottom:0;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.integrations-options-wrap {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t> a {\n\t\t\t\t\t\tmargin-left: .25rem;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.integrations-body {\n\t\t\t\t@include transition(all 0.2s ease);\n\t\t\t\toverflow: hidden;\n\t\t\t\t-ms-flex: 1;\n\t\t\t\tflex: 1;\n\t\t\t\t.nicescroll-bar {\n\t\t\t\t\tpadding:1.25rem;\n\t\t\t\t\t.app-name {\n\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t}\n\t\t\t\t\t.app-cat {\n\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t\tmargin-bottom:.625rem;\n\t\t\t\t\t}\n\t\t\t\t\t.tab-content {\n\t\t\t\t\t\t.comment-block {\n\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t> div {\n\t\t\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t\t\t\t\t.cm-name {\n\t\t\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: .625rem;\n\t\t\t\t\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t.comment-action-wrap {\n\t\t\t\t\t\t\t\t\t\tspan,a {\n\t\t\t\t\t\t\t\t\t\t\tcolor:$grey_dark_3;\n\t\t\t\t\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t.comment-dot-sep {\n\t\t\t\t\t\t\t\t\t\t\tmargin:0 .25rem;\n\t\t\t\t\t\t\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t>.media {\n\t\t\t\t\t\t\t\t\t\tmargin-top:1.875rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.review-block {\n\t\t\t\t\t\t\t.media {\n\t\t\t\t\t\t\t\t.media-head {\n\t\t\t\t\t\t\t\t\tmargin-right:1rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.media-body {\n\t\t\t\t\t\t\t\t\t.cr-name {\n\t\t\t\t\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\t\t\t\t\tcolor:$black_2;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.review-action-wrap {\n\t\t\t\t\t\t\t\tspan,a {\n\t\t\t\t\t\t\t\t\tfont-size:0.75rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.review-dot-sep {\n\t\t\t\t\t\t\t\t\tmargin:0 .25rem;\n\t\t\t\t\t\t\t\t\tcolor:$grey_light_3;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.review {\n\t\t\t\t\t\t\t\t.review {\n\t\t\t\t\t\t\t\t\tmargin-left:3.125rem;\n\t\t\t\t\t\t\t\t\tmargin-top:1.875rem;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.card-int {\n\t\t\t\t\t\tmin-height:250px;\n\t\t\t\t\t}\n\t\t\t\t\t.content-aside {\n\t\t\t\t\t\t.tag-cloud {\n\t\t\t\t\t\t\t.badge {\n\t\t\t\t\t\t\t\tmargin-bottom: .25rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.integrationsapp-sidebar-toggle {\n\t\t.integrationsapp-sidebar {\n\t\t\tleft: -270px;\n\t\t}\t\n\t\t.integrationsapp-content {\n\t\t\tpadding-left:0;\n\t\t}\n\t}\n}\n.hk-wrapper[data-navbar-style=\"collapsed\"] {\n\t.integrationsapp-wrap {\n\t\theight: 100vh;\n\t}\n}\n@media (max-width: 991px) {\n\t.integrationsapp-wrap {\n\t\t.integrationsapp-sidebar {\n\t\t\tleft:-270px;\n\t\t}\n\t\t.integrationsapp-content {\n\t\t\tmargin-left: 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&.integrationsapp-sidebar-toggle {\n\t\t\t.integrationsapp-sidebar {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.integrationsapp-content {\n\t\t\t\tleft:16.875rem;\n\t\t\t\tpadding-left: 16.875rem;\n\t\t\t\tmargin-left: -16.875rem;\n\t\t\t}\n\t\t}\n\t\t.hk-sidebar-togglable {\n\t\t\t@include transform(translateX(32px));\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\ea6c\";\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t@include transform(translateX(0));\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\\ea62\";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*Horizontal Menu*/\t\n@media (min-width: 1200px) {\n\t.hk-wrapper[data-layout=\"horizontal\"] {\n\t\t.chatapp-wrap,\n\t\t.calendarapp-wrap,\n\t\t.emailapp-wrap,\n\t\t.taskboardapp-wrap,\n\t\t.contactapp-wrap,\n\t\t.fmapp-wrap,\n\t\t.galleryapp-wrap,\n\t\t.todoapp-wrap,\n\t\t.blogapp-wrap,\n\t\t.invoiceapp-wrap,\n\t\t.integrationsapp-wrap {\n\t\t\theight:calc(100vh - 130px);\n\t\t}\n\t\t&[data-navbar-style=\"collapsed\"] {\n\t\t\t.chatapp-wrap,\n\t\t\t.calendarapp-wrap,\n\t\t\t.emailapp-wrap,\n\t\t\t.taskboardapp-wrap,\n\t\t\t.contactapp-wrap,\n\t\t\t.fmapp-wrap,\n\t\t\t.galleryapp-wrap,\n\t\t\t.todoapp-wrap,\n\t\t\t.blogapp-wrap,\n\t\t\t.invoiceapp-wrap,\n\t\t\t.integrationsapp-wrap {\n\t\t\t\theight:calc(100vh - 65px);\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
